webpackJsonp(["app"],{

/***/ "../node_modules/autosize/dist/autosize.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Autosize 3.0.21
	license: MIT
	http://www.jacklmoore.com/autosize
*/
(function (global, factory) {
	if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, module], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof exports !== 'undefined' && typeof module !== 'undefined') {
		factory(exports, module);
	} else {
		var mod = {
			exports: {}
		};
		factory(mod.exports, mod);
		global.autosize = mod.exports;
	}
})(this, function (exports, module) {
	'use strict';

	var map = typeof Map === "function" ? new Map() : (function () {
		var keys = [];
		var values = [];

		return {
			has: function has(key) {
				return keys.indexOf(key) > -1;
			},
			get: function get(key) {
				return values[keys.indexOf(key)];
			},
			set: function set(key, value) {
				if (keys.indexOf(key) === -1) {
					keys.push(key);
					values.push(value);
				}
			},
			'delete': function _delete(key) {
				var index = keys.indexOf(key);
				if (index > -1) {
					keys.splice(index, 1);
					values.splice(index, 1);
				}
			}
		};
	})();

	var createEvent = function createEvent(name) {
		return new Event(name, { bubbles: true });
	};
	try {
		new Event('test');
	} catch (e) {
		// IE does not support `new Event()`
		createEvent = function (name) {
			var evt = document.createEvent('Event');
			evt.initEvent(name, true, false);
			return evt;
		};
	}

	function assign(ta) {
		if (!ta || !ta.nodeName || ta.nodeName !== 'TEXTAREA' || map.has(ta)) return;

		var heightOffset = null;
		var clientWidth = ta.clientWidth;
		var cachedHeight = null;

		function init() {
			var style = window.getComputedStyle(ta, null);

			if (style.resize === 'vertical') {
				ta.style.resize = 'none';
			} else if (style.resize === 'both') {
				ta.style.resize = 'horizontal';
			}

			if (style.boxSizing === 'content-box') {
				heightOffset = -(parseFloat(style.paddingTop) + parseFloat(style.paddingBottom));
			} else {
				heightOffset = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
			}
			// Fix when a textarea is not on document body and heightOffset is Not a Number
			if (isNaN(heightOffset)) {
				heightOffset = 0;
			}

			update();
		}

		function changeOverflow(value) {
			{
				// Chrome/Safari-specific fix:
				// When the textarea y-overflow is hidden, Chrome/Safari do not reflow the text to account for the space
				// made available by removing the scrollbar. The following forces the necessary text reflow.
				var width = ta.style.width;
				ta.style.width = '0px';
				// Force reflow:
				/* jshint ignore:start */
				ta.offsetWidth;
				/* jshint ignore:end */
				ta.style.width = width;
			}

			ta.style.overflowY = value;
		}

		function getParentOverflows(el) {
			var arr = [];

			while (el && el.parentNode && el.parentNode instanceof Element) {
				if (el.parentNode.scrollTop) {
					arr.push({
						node: el.parentNode,
						scrollTop: el.parentNode.scrollTop
					});
				}
				el = el.parentNode;
			}

			return arr;
		}

		function resize() {
			var originalHeight = ta.style.height;
			var overflows = getParentOverflows(ta);
			var docTop = document.documentElement && document.documentElement.scrollTop; // Needed for Mobile IE (ticket #240)

			ta.style.height = 'auto';

			var endHeight = ta.scrollHeight + heightOffset;

			if (ta.scrollHeight === 0) {
				// If the scrollHeight is 0, then the element probably has display:none or is detached from the DOM.
				ta.style.height = originalHeight;
				return;
			}

			ta.style.height = endHeight + 'px';

			// used to check if an update is actually necessary on window.resize
			clientWidth = ta.clientWidth;

			// prevents scroll-position jumping
			overflows.forEach(function (el) {
				el.node.scrollTop = el.scrollTop;
			});

			if (docTop) {
				document.documentElement.scrollTop = docTop;
			}
		}

		function update() {
			resize();

			var styleHeight = Math.round(parseFloat(ta.style.height));
			var computed = window.getComputedStyle(ta, null);

			// Using offsetHeight as a replacement for computed.height in IE, because IE does not account use of border-box
			var actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(computed.height)) : ta.offsetHeight;

			// The actual height not matching the style height (set via the resize method) indicates that
			// the max-height has been exceeded, in which case the overflow should be allowed.
			if (actualHeight !== styleHeight) {
				if (computed.overflowY === 'hidden') {
					changeOverflow('scroll');
					resize();
					actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(window.getComputedStyle(ta, null).height)) : ta.offsetHeight;
				}
			} else {
				// Normally keep overflow set to hidden, to avoid flash of scrollbar as the textarea expands.
				if (computed.overflowY !== 'hidden') {
					changeOverflow('hidden');
					resize();
					actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(window.getComputedStyle(ta, null).height)) : ta.offsetHeight;
				}
			}

			if (cachedHeight !== actualHeight) {
				cachedHeight = actualHeight;
				var evt = createEvent('autosize:resized');
				try {
					ta.dispatchEvent(evt);
				} catch (err) {
					// Firefox will throw an error on dispatchEvent for a detached element
					// https://bugzilla.mozilla.org/show_bug.cgi?id=889376
				}
			}
		}

		var pageResize = function pageResize() {
			if (ta.clientWidth !== clientWidth) {
				update();
			}
		};

		var destroy = (function (style) {
			window.removeEventListener('resize', pageResize, false);
			ta.removeEventListener('input', update, false);
			ta.removeEventListener('keyup', update, false);
			ta.removeEventListener('autosize:destroy', destroy, false);
			ta.removeEventListener('autosize:update', update, false);

			Object.keys(style).forEach(function (key) {
				ta.style[key] = style[key];
			});

			map['delete'](ta);
		}).bind(ta, {
			height: ta.style.height,
			resize: ta.style.resize,
			overflowY: ta.style.overflowY,
			overflowX: ta.style.overflowX,
			wordWrap: ta.style.wordWrap
		});

		ta.addEventListener('autosize:destroy', destroy, false);

		// IE9 does not fire onpropertychange or oninput for deletions,
		// so binding to onkeyup to catch most of those events.
		// There is no way that I know of to detect something like 'cut' in IE9.
		if ('onpropertychange' in ta && 'oninput' in ta) {
			ta.addEventListener('keyup', update, false);
		}

		window.addEventListener('resize', pageResize, false);
		ta.addEventListener('input', update, false);
		ta.addEventListener('autosize:update', update, false);
		ta.style.overflowX = 'hidden';
		ta.style.wordWrap = 'break-word';

		map.set(ta, {
			destroy: destroy,
			update: update
		});

		init();
	}

	function destroy(ta) {
		var methods = map.get(ta);
		if (methods) {
			methods.destroy();
		}
	}

	function update(ta) {
		var methods = map.get(ta);
		if (methods) {
			methods.update();
		}
	}

	var autosize = null;

	// Do nothing in Node.js environment and IE8 (or lower)
	if (typeof window === 'undefined' || typeof window.getComputedStyle !== 'function') {
		autosize = function (el) {
			return el;
		};
		autosize.destroy = function (el) {
			return el;
		};
		autosize.update = function (el) {
			return el;
		};
	} else {
		autosize = function (el, options) {
			if (el) {
				Array.prototype.forEach.call(el.length ? el : [el], function (x) {
					return assign(x, options);
				});
			}
			return el;
		};
		autosize.destroy = function (el) {
			if (el) {
				Array.prototype.forEach.call(el.length ? el : [el], destroy);
			}
			return el;
		};
		autosize.update = function (el) {
			if (el) {
				Array.prototype.forEach.call(el.length ? el : [el], update);
			}
			return el;
		};
	}

	module.exports = autosize;
});

/***/ }),

/***/ "../node_modules/babel-runtime/core-js/get-iterator.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("../node_modules/core-js/library/fn/get-iterator.js"), __esModule: true };

/***/ }),

/***/ "../node_modules/babel-runtime/core-js/is-iterable.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("../node_modules/core-js/library/fn/is-iterable.js"), __esModule: true };

/***/ }),

/***/ "../node_modules/babel-runtime/core-js/object/get-own-property-names.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("../node_modules/core-js/library/fn/object/get-own-property-names.js"), __esModule: true };

/***/ }),

/***/ "../node_modules/babel-runtime/core-js/object/keys.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("../node_modules/core-js/library/fn/object/keys.js"), __esModule: true };

/***/ }),

/***/ "../node_modules/babel-runtime/helpers/slicedToArray.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__("../node_modules/babel-runtime/core-js/is-iterable.js");

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__("../node_modules/babel-runtime/core-js/get-iterator.js");

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),

/***/ "../node_modules/base-components/build/blocks/Accordion/Head.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = function styles(_ref) {
  var theme = _ref.theme;
  return '\n  align-items: center;\n  background-color: ' + theme.colors.base.background + ';\n  display: flex;\n  height: ' + (0, _decisivUiUtils.px2rem)(45) + ';\n  justify-content: space-between;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      background: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

var Head = (0, _decisivUiUtils.buildStyledComponent)('Accordion__Head', _styledComponents2.default.div, styles, { themePropTypes: themePropTypes });

exports.default = Head;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/Accordion/Title.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _elements = __webpack_require__("../node_modules/base-components/build/elements/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = function styles(_ref) {
  var theme = _ref.theme;
  return '\n  font-weight: ' + theme.fontWeights.normal + ';\n  text-transform: capitalize;\n';
};

var themePropTypes = {
  fontWeights: _propTypes2.default.shape({
    normal: _propTypes2.default.number.isRequired
  }).isRequired
};

var Title = (0, _decisivUiUtils.buildStyledComponent)('Accordion__Title', _elements.H4, styles, { themePropTypes: themePropTypes });

exports.default = Title;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/Accordion/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _Head = __webpack_require__("../node_modules/base-components/build/blocks/Accordion/Head.js");

var _Head2 = _interopRequireDefault(_Head);

var _Title = __webpack_require__("../node_modules/base-components/build/blocks/Accordion/Title.js");

var _Title2 = _interopRequireDefault(_Title);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  disabled: function disabled() {
    return '\n    opacity: 0.5;\n    pointer-events: none;\n    * {\n      pointer-events: none;\n  }';
  }
};

var styles = function styles(_ref) {
  var theme = _ref.theme;
  return '\n  background-color: ' + theme.colors.base.background + ';\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      background: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

var Accordion = (0, _decisivUiUtils.buildStyledComponent)('Accordion', _styledComponents2.default.div, styles, {
  modifierConfig: modifierConfig,
  themePropTypes: themePropTypes
});

Accordion.Head = _Head2.default;
Accordion.Title = _Title2.default;

exports.default = Accordion;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/Avatar/Icon.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _elements = __webpack_require__("../node_modules/base-components/build/elements/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  small: function small() {
    return '\n    font-size: ' + (0, _decisivUiUtils.px2rem)(16) + ';\n  ';
  },

  secondary: function secondary(_ref) {
    var theme = _ref.theme;
    return '\n    color: ' + theme.colors.base.chrome500 + ';\n  ';
  }
};

var styles = function styles(_ref2) {
  var theme = _ref2.theme;
  return '\n  color: ' + theme.colors.base.chrome000 + ';\n  font-size: ' + (0, _decisivUiUtils.px2rem)(32) + ';\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome000: _propTypes2.default.string.isRequired,
      chrome500: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Icon', (0, _styledComponents2.default)(_elements.Icon), styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

/***/ }),

/***/ "../node_modules/base-components/build/blocks/Avatar/Image.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSize = getSize;

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _md = __webpack_require__("../node_modules/md5/md5.js");

var _md2 = _interopRequireDefault(_md);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _isRetina = __webpack_require__("../node_modules/is-retina/index.js");

var _isRetina2 = _interopRequireDefault(_isRetina);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IS_RETINA = (0, _isRetina2.default)();

function getSize(small, retina) {
  var size = small ? 35 : 60;
  return retina ? size * 2 : size;
}

var styles = '\n  border-radius: 50%;\n';

var Image = (0, _decisivUiUtils.buildStyledComponent)('Image', _styledComponents2.default.img.attrs({
  alt: 'user-avatar',
  src: function src(props) {
    return '\n      https://secure.gravatar.com/avatar/' + (0, _md2.default)(props.email) + '?\n      s=' + getSize(props.small, IS_RETINA) + '&\n      d=404\n    ';
  },
  width: '100%'
}), styles);

Image.propTypes = {
  email: _propTypes2.default.string,
  small: _propTypes2.default.bool
};

Image.defaultProps = {
  email: '',
  small: false
};

exports.default = Image;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/Avatar/Initials.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  small: function small() {
    return '\n    font-size: ' + (0, _decisivUiUtils.px2rem)(12) + ';\n  ';
  },

  secondary: function secondary(_ref) {
    var theme = _ref.theme;
    return '\n    color: ' + theme.colors.base.chrome500 + ';\n  ';
  }
};

var styles = function styles(_ref2) {
  var theme = _ref2.theme;
  return '\n  font-size: ' + (0, _decisivUiUtils.px2rem)(26) + ';\n  font-weight: ' + theme.fontWeights.medium + ';\n  text-transform: uppercase;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome500: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired,
  fontWeights: _propTypes2.default.shape({
    medium: _propTypes2.default.number.isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Initials', _styledComponents2.default.span, styles, {
  modifierConfig: modifierConfig, themePropTypes: themePropTypes
});

/***/ }),

/***/ "../node_modules/base-components/build/blocks/Avatar/Status.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = function styles(_ref) {
  var theme = _ref.theme;
  return '\n  position: absolute;\n  width: 24%;\n  height: 24%;\n  right: 0;\n  bottom: 0;\n  border-radius: 50%;\n  border: 1px solid ' + theme.colors.base.background + ';\n  display: none;\n';
};

var modifierConfig = {
  danger: function danger(_ref2) {
    var theme = _ref2.theme;
    return '\n    background-color: ' + theme.colors.status.danger + ';\n    display: block;\n  ';
  },

  info: function info(_ref3) {
    var theme = _ref3.theme;
    return '\n    background-color: ' + theme.colors.status.info + ';\n    display: block;\n  ';
  },

  success: function success(_ref4) {
    var theme = _ref4.theme;
    return '\n    background-color: ' + theme.colors.status.success + ';\n    display: block;\n  ';
  },

  warning: function warning(_ref5) {
    var theme = _ref5.theme;
    return '\n    background-color: ' + theme.colors.status.warning + ';\n    display: block;\n  ';
  }
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      background: _propTypes2.default.string.isRequired
    }).isRequired,
    status: _propTypes2.default.shape({
      danger: _propTypes2.default.string.isRequired,
      info: _propTypes2.default.string.isRequired,
      success: _propTypes2.default.string.isRequired,
      warning: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

var Status = (0, _decisivUiUtils.buildStyledComponent)('Status', _styledComponents2.default.div, styles, {
  modifierConfig: modifierConfig, themePropTypes: themePropTypes
});

Status.modifiers = modifierConfig;

exports.default = Status;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/Avatar/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _Icon = __webpack_require__("../node_modules/base-components/build/blocks/Avatar/Icon.js");

var _Icon2 = _interopRequireDefault(_Icon);

var _Image = __webpack_require__("../node_modules/base-components/build/blocks/Avatar/Image.js");

var _Image2 = _interopRequireDefault(_Image);

var _Initials = __webpack_require__("../node_modules/base-components/build/blocks/Avatar/Initials.js");

var _Initials2 = _interopRequireDefault(_Initials);

var _Status = __webpack_require__("../node_modules/base-components/build/blocks/Avatar/Status.js");

var _Status2 = _interopRequireDefault(_Status);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  small: function small() {
    return '\n    height: ' + (0, _decisivUiUtils.px2rem)(35) + ';\n    min-width: ' + (0, _decisivUiUtils.px2rem)(35) + ';\n    width: ' + (0, _decisivUiUtils.px2rem)(35) + ';\n  ';
  },

  secondary: function secondary(_ref) {
    var theme = _ref.theme;
    return '\n    background-color: ' + theme.colors.base.chrome200 + ';\n  ';
  }
};

var styles = function styles(_ref2) {
  var theme = _ref2.theme;
  return '\n  align-items: center;\n  background-color: ' + theme.colors.status.info + ';\n  border-radius: 50%;\n  color: ' + theme.colors.base.chrome000 + ';\n  display: inline-flex;\n  height: ' + (0, _decisivUiUtils.px2rem)(60) + ';\n  justify-content: center;\n  position: relative;\n  width: ' + (0, _decisivUiUtils.px2rem)(60) + ';\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome000: _propTypes2.default.string.isRequired,
      chrome200: _propTypes2.default.string.isRequired
    }).isRequired,
    status: _propTypes2.default.shape({
      info: _propTypes2.default.string.isRequired
    })
  }).isRequired
};

var Avatar = (0, _decisivUiUtils.buildStyledComponent)('Avatar', _styledComponents2.default.span, styles, {
  modifierConfig: modifierConfig, themePropTypes: themePropTypes
});

Avatar.Icon = _Icon2.default;
Avatar.Image = _Image2.default;
Avatar.Initials = _Initials2.default;
Avatar.Status = _Status2.default;

exports.default = Avatar;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/Badge/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _elements = __webpack_require__("../node_modules/base-components/build/elements/index.js");

var _childrenWithDefaultModifiers = __webpack_require__("../node_modules/base-components/build/utils/childrenWithDefaultModifiers.js");

var _childrenWithDefaultModifiers2 = _interopRequireDefault(_childrenWithDefaultModifiers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  danger: function danger(_ref) {
    var theme = _ref.theme;
    return 'background-color: ' + theme.colors.status.danger + ';';
  },

  info: function info(_ref2) {
    var theme = _ref2.theme;
    return 'background-color: ' + theme.colors.status.info + ';';
  },

  secondary: function secondary(_ref3) {
    var theme = _ref3.theme;
    return 'background-color: ' + theme.colors.base.chrome500 + ';';
  },

  success: function success(_ref4) {
    var theme = _ref4.theme;
    return 'background-color: ' + theme.colors.status.success + ';';
  },

  warning: function warning(_ref5) {
    var theme = _ref5.theme;
    return 'background-color: ' + theme.colors.status.warning + ';';
  }
};

var styles = function styles(_ref6) {
  var theme = _ref6.theme;
  return '\n  align-items: center;\n  background-color: ' + theme.colors.base.chrome200 + ';\n  border-radius: ' + theme.dimensions.borderRadius + ';\n  display: flex;\n  height: ' + (0, _decisivUiUtils.px2rem)(30) + ';\n  justify-content: center;\n  width: ' + (0, _decisivUiUtils.px2rem)(30) + ';\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome200: _propTypes2.default.string.isRequired,
      chrome500: _propTypes2.default.string.isRequired
    }).isRequired,
    status: _propTypes2.default.shape({
      danger: _propTypes2.default.string.isRequired,
      default: _propTypes2.default.string.isRequired,
      info: _propTypes2.default.string.isRequired,
      success: _propTypes2.default.string.isRequired,
      warning: _propTypes2.default.string.isRequired
    }).isRequired
  }),
  dimensions: _propTypes2.default.shape({
    borderRadius: _propTypes2.default.string.isRequired
  }).isRequired
};

var StyledBadge = (0, _decisivUiUtils.buildStyledComponent)('StyledBadge', _styledComponents2.default.div, styles, {
  modifierConfig: modifierConfig,
  themePropTypes: themePropTypes
});

function Badge(props) {
  var modifiersRequiringDefaults = ['danger', 'info', 'secondary', 'success', 'warning'];
  var defaultModifiers = ['chrome000'];
  var children = (0, _childrenWithDefaultModifiers2.default)(props, modifiersRequiringDefaults, defaultModifiers);

  return _react2.default.createElement(
    StyledBadge,
    props,
    children
  );
}

Badge.propTypes = {
  children: _propTypes2.default.node.isRequired
};

Badge.Icon = _elements.Icon;

exports.default = Badge;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/ButtonGroup/Button.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _QuickActionButton = __webpack_require__("../node_modules/base-components/build/blocks/QuickActionButton/index.js");

var _QuickActionButton2 = _interopRequireDefault(_QuickActionButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  active: function active(_ref) {
    var theme = _ref.theme;
    return '\n    background: ' + theme.colors.base.chrome600 + ';\n    border-color: transparent;\n    > span {\n      color: ' + theme.colors.base.chrome000 + ';\n    }\n    + button {\n      border-left: transparent;\n    }\n  ';
  }
};

var styles = function styles(_ref2) {
  var theme = _ref2.theme;
  return '\n  background: ' + theme.colors.base.chrome100 + ';\n  border: 1px solid ' + theme.colors.base.chrome200 + ';\n  border-radius: 0;\n  color: ' + theme.colors.base.chrome500 + ';\n  cursor: pointer;\n  display: flex;\n  font-size: ' + (0, _decisivUiUtils.px2rem)(theme.dimensions.fontSize) + ';\n  height: ' + (0, _decisivUiUtils.px2rem)(25) + ';\n  justify-content: center;\n  padding: 0;\n  width: ' + (0, _decisivUiUtils.px2rem)(35) + ';\n  &:hover {\n    text-decoration: none;\n    > span {\n      color: ' + theme.colors.base.chrome000 + ';\n    }\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome600: _propTypes2.default.string.isRequired,
      chrome000: _propTypes2.default.string.isRequired,
      chrome100: _propTypes2.default.string.isRequired,
      chrome200: _propTypes2.default.string.isRequired,
      chrome500: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired,
  dimensions: _propTypes2.default.shape({
    fontSize: _propTypes2.default.number.isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Button', (0, _styledComponents2.default)(_QuickActionButton2.default), styles, {
  modifierConfig: modifierConfig,
  themePropTypes: themePropTypes
});

/***/ }),

/***/ "../node_modules/base-components/build/blocks/ButtonGroup/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _Button = __webpack_require__("../node_modules/base-components/build/blocks/ButtonGroup/Button.js");

var _Button2 = _interopRequireDefault(_Button);

var _elements = __webpack_require__("../node_modules/base-components/build/elements/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = function styles(_ref) {
  var theme = _ref.theme;
  return '\n  display: flex;\n\n  button:first-child {\n    border-radius: ' + theme.dimensions.borderRadius + ' 0 0 ' + theme.dimensions.borderRadius + ';\n  }\n\n  button:not(:last-child) {\n    border-right: transparent;\n  }\n\n  button:last-child {\n    border-radius: 0 ' + theme.dimensions.borderRadius + ' ' + theme.dimensions.borderRadius + ' 0;\n  }\n';
};

var themePropTypes = {
  dimensions: _propTypes2.default.shape({
    borderRadius: _propTypes2.default.string.isRequired
  }).isRequired
};

var ButtonGroup = (0, _decisivUiUtils.buildStyledComponent)('ButtonGroup', _styledComponents2.default.div, styles, { themePropTypes: themePropTypes });

ButtonGroup.Button = _Button2.default;
ButtonGroup.ButtonIcon = _elements.Icon;

exports.default = ButtonGroup;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/ButtonIconCircle/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _elements = __webpack_require__("../node_modules/base-components/build/elements/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Component: Button Icon Circle
 *
 * Produces a icon button tag styled to be circular.
 */
var modifierConfig = {
  primary: function primary(_ref) {
    var theme = _ref.theme;
    return '\n    background-color: ' + theme.colors.base.chrome100 + ';\n    border-color: transparent;\n  ';
  },

  secondary: function secondary(_ref2) {
    var theme = _ref2.theme;
    return '\n    background-color: ' + theme.colors.base.chrome600 + ';\n    border-color: transparent;\n    span {\n      color: ' + theme.colors.base.chrome000 + ';\n    }\n  ';
  },

  active: function active(_ref3) {
    var theme = _ref3.theme;
    return '\n    background-color: ' + theme.colors.base.linkHover + ';\n    border-color: transparent;\n    span {\n      color: ' + theme.colors.base.chrome000 + ';\n    }\n  ';
  },

  disabled: function disabled() {
    return '\n    opacity: 0.5;\n    pointer-events: none;\n  ';
  }
};

var styles = function styles(_ref4) {
  var theme = _ref4.theme;
  return '\n  background-color: ' + theme.colors.base.chrome100 + ';\n  border-radius: 50%;\n  border: 1px solid ' + theme.colors.base.chrome200 + ';\n  cursor: pointer;\n  height: ' + (0, _decisivUiUtils.px2rem)(35) + ';\n  line-height: normal;\n  outline: none;\n  transition: all 200ms ease;\n  width: ' + (0, _decisivUiUtils.px2rem)(35) + ';\n  &:hover {\n    background-color: ' + theme.colors.base.linkHover + ';\n    border-color: transparent;\n    span {\n      color: ' + theme.colors.base.chrome000 + ';\n    }\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome000: _propTypes2.default.string.isRequired,
      chrome100: _propTypes2.default.string.isRequired,
      chrome600: _propTypes2.default.string.isRequired,
      linkHover: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

var ButtonIconCircle = (0, _decisivUiUtils.buildStyledComponent)('ButtonIconCircle', _styledComponents2.default.button, styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

ButtonIconCircle.Icon = _elements.Icon;

exports.default = ButtonIconCircle;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/ButtonIconRectangle/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _elements = __webpack_require__("../node_modules/base-components/build/elements/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Component: Button Icon Rectangle
 *
 * Produces a icon button tag styled to be rectangular.
 */
var modifierConfig = {
  hoverSuccess: function hoverSuccess(_ref) {
    var theme = _ref.theme;
    return '\n    &:hover {\n      border-color: ' + theme.colors.base.chrome200 + ';\n      span {\n        color: ' + theme.colors.status.success + ';\n      }\n    }\n  ';
  },

  hoverWarning: function hoverWarning(_ref2) {
    var theme = _ref2.theme;
    return '\n    &:hover {\n      border-color: ' + theme.colors.base.chrome200 + ';\n      span {\n        color: ' + theme.colors.status.warning + ';\n      }\n    }\n  ';
  },

  hoverDanger: function hoverDanger(_ref3) {
    var theme = _ref3.theme;
    return '\n    &:hover {\n      border-color: ' + theme.colors.base.chrome200 + ';\n      span {\n        color: ' + theme.colors.status.danger + ';\n      }\n    }\n  ';
  },

  active: function active(_ref4) {
    var theme = _ref4.theme;
    return '\n    border-color: ' + theme.colors.base.chrome200 + ';\n  ';
  },

  disabled: function disabled() {
    return '\n    opacity: 0.5;\n    pointer-events: none;\n  ';
  }
};

/* istanbul ignore next */
var styles = function styles(_ref5) {
  var theme = _ref5.theme;
  return '\n  background-color: ' + theme.colors.base.chrome000 + ';\n  border-radius: ' + theme.dimensions.borderRadius + ';\n  border: 1px solid transparent;\n  cursor: pointer;\n  height: ' + (0, _decisivUiUtils.px2rem)(25) + ';\n  line-height: normal;\n  outline: none;\n  transition: all 200ms ease;\n  width: ' + (0, _decisivUiUtils.px2rem)(35) + ';\n  &:hover {\n    border-color: ' + theme.colors.base.chrome200 + ';\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome000: _propTypes2.default.string.isRequired,
      chrome200: _propTypes2.default.string.isRequired,
      chrome600: _propTypes2.default.string.isRequired
    }).isRequired,
    status: _propTypes2.default.shape({
      success: _propTypes2.default.string.isRequired,
      warning: _propTypes2.default.string.isRequired,
      danger: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired,
  dimensions: _propTypes2.default.shape({
    borderRadius: _propTypes2.default.string.isRequired
  }).isRequired
};

var ButtonIconRectangle = (0, _decisivUiUtils.buildStyledComponent)('ButtonIconRectangle', _styledComponents2.default.button, styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

ButtonIconRectangle.Icon = _elements.Icon;

exports.default = ButtonIconRectangle;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/ButtonMicro/Icon.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _elements = __webpack_require__("../node_modules/base-components/build/elements/index.js");

var styles = '\n  padding-right: ' + (0, _decisivUiUtils.px2rem)(5) + ';\n';

exports.default = (0, _decisivUiUtils.buildStyledComponent)('ButtonMicro__Icon', _elements.Icon, styles);

/***/ }),

/***/ "../node_modules/base-components/build/blocks/ButtonMicro/Text.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _elements = __webpack_require__("../node_modules/base-components/build/elements/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  active: function active(_ref) {
    var theme = _ref.theme;
    return '\n    color: ' + theme.colors.status.info + ';\n  ';
  }
};

var styles = '';

var themePropTypes = {
  colors: _propTypes2.default.shape({
    status: _propTypes2.default.shape({
      info: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('ButtonMicro__Text', _elements.Text, styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

/***/ }),

/***/ "../node_modules/base-components/build/blocks/ButtonMicro/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _Icon = __webpack_require__("../node_modules/base-components/build/blocks/ButtonMicro/Icon.js");

var _Icon2 = _interopRequireDefault(_Icon);

var _Text = __webpack_require__("../node_modules/base-components/build/blocks/ButtonMicro/Text.js");

var _Text2 = _interopRequireDefault(_Text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  disabled: function disabled() {
    return '\n    opacity: 0.5;\n    pointer-events: none;\n  ';
  }
};

var styles = function styles(_ref) {
  var theme = _ref.theme;
  return '\n  align-items: center;\n  background: ' + theme.colors.base.background + ';\n  border-radius: ' + theme.dimensions.borderRadius + ';\n  border: 1px solid ' + theme.colors.base.chrome200 + ';\n  cursor: pointer;\n  display: flex;\n  height: ' + (0, _decisivUiUtils.px2rem)(17) + ';\n  outline: none;\n  padding: 0 ' + (0, _decisivUiUtils.px2rem)(5) + ';\n\n  &:hover {\n    span:not(.fa) {\n      color: ' + theme.colors.status.info + ';\n      text-decoration: underline;\n    }\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      background: _propTypes2.default.string.isRequired,
      chrome200: _propTypes2.default.string.isRequired
    }).isRequired,
    status: _propTypes2.default.shape({
      info: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired,
  dimensions: _propTypes2.default.shape({
    borderRadius: _propTypes2.default.string.isRequired
  }).isRequired
};

var ButtonMicro = (0, _decisivUiUtils.buildStyledComponent)('ButtonMicro', _styledComponents2.default.button, styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

ButtonMicro.Icon = _Icon2.default;
ButtonMicro.Text = _Text2.default;

exports.default = ButtonMicro;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/ButtonSort/Icon.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _elements = __webpack_require__("../node_modules/base-components/build/elements/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Icon(_ref) {
  var arrowUp = _ref.arrowUp,
      rest = _objectWithoutProperties(_ref, ['arrowUp']);

  var name = arrowUp ? 'angle-up' : 'angle-down';
  return _react2.default.createElement(_elements.Icon, _extends({ name: name }, rest));
}

Icon.propTypes = {
  arrowUp: _propTypes2.default.bool
};

Icon.defaultProps = {
  arrowUp: false
};

exports.default = Icon;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/ButtonSort/Label.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _elements = __webpack_require__("../node_modules/base-components/build/elements/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = '\n  &:after {\n    content: ":";\n  }\n';

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Label', (0, _styledComponents2.default)(_elements.Label), styles);

/***/ }),

/***/ "../node_modules/base-components/build/blocks/ButtonSort/Text.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _elements = __webpack_require__("../node_modules/base-components/build/elements/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = function styles(_ref) {
  var theme = _ref.theme;
  return '\n  color: ' + theme.colors.base.link + ';\n  text-transform: capitalize;\n  padding: 0 ' + theme.dimensions.gridPad + ';\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      link: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired,
  dimensions: _propTypes2.default.shape({
    gridPad: _propTypes2.default.string.isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Text', (0, _styledComponents2.default)(_elements.Text), styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "../node_modules/base-components/build/blocks/ButtonSort/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _Icon = __webpack_require__("../node_modules/base-components/build/blocks/ButtonSort/Icon.js");

var _Icon2 = _interopRequireDefault(_Icon);

var _Label = __webpack_require__("../node_modules/base-components/build/blocks/ButtonSort/Label.js");

var _Label2 = _interopRequireDefault(_Label);

var _Text = __webpack_require__("../node_modules/base-components/build/blocks/ButtonSort/Text.js");

var _Text2 = _interopRequireDefault(_Text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  active: function active(_ref) {
    var theme = _ref.theme;
    return '\n    span {\n      color: ' + theme.colors.base.linkHover + ';\n    }\n  ';
  },

  disabled: function disabled(_ref2) {
    var theme = _ref2.theme;
    return '\n    opacity: 0.5;\n    pointer-events: none;\n    span {\n      color: ' + theme.colors.base.text + ';\n    }\n  ';
  }
};

var styles = function styles(_ref3) {
  var theme = _ref3.theme;
  return '\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-weight: ' + theme.fontWeights.light + ';\n  outline: none;\n  white-space: nowrap;\n\n  &:hover {\n    span {\n      color: ' + theme.colors.base.linkHover + ';\n    }\n    .Text {\n      text-decoration: underline;\n    }\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      linkHover: _propTypes2.default.string.isRequired,
      text: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired,
  fontWeights: _propTypes2.default.shape({
    light: _propTypes2.default.number.isRequired
  }).isRequired
};

var ButtonSort = (0, _decisivUiUtils.buildStyledComponent)('ButtonSort', _styledComponents2.default.button, styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

ButtonSort.Label = _Label2.default;
ButtonSort.Text = _Text2.default;
ButtonSort.Icon = _Icon2.default;

exports.default = ButtonSort;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/ButtonToggle/Bar.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = function styles(_ref) {
  var theme = _ref.theme;
  return '\n  align-items: center;\n  background-color: ' + theme.colors.base.chrome200 + ';\n  border-radius: 1px;\n  display: flex;\n  height: ' + (0, _decisivUiUtils.px2rem)(2) + ';\n  margin: 0 ' + (0, _decisivUiUtils.px2rem)(5) + ';\n  position: relative;\n  width: ' + (0, _decisivUiUtils.px2rem)(36) + ';\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome200: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

var Bar = (0, _decisivUiUtils.buildStyledComponent)('Bar', _styledComponents2.default.div, styles, { themePropTypes: themePropTypes });

exports.default = Bar;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/ButtonToggle/Checkbox.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = '\n  opacity: 0;\n  position: absolute;\n  z-index: -1;\n';

var Checkbox = (0, _decisivUiUtils.buildStyledComponent)('Checkbox', _styledComponents2.default.input.attrs({
  tabIndex: '0',
  type: 'checkbox'
}), styles);

exports.default = Checkbox;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/ButtonToggle/Content.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = '\n  align-items: center;\n  display: flex;\n';

var Content = (0, _decisivUiUtils.buildStyledComponent)('Content', _styledComponents2.default.div, styles);

exports.default = Content;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/ButtonToggle/OptionLabel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  /**
   * This needs `!important` as it shouldn't be overridden by hover state color.
   * And it can't be the default style as it should be overridden by inactive modifier.
   */
  active: function active(_ref) {
    var theme = _ref.theme;
    return '\n    color: ' + theme.colors.base.text + ' !important;\n  ';
  },
  inactive: function inactive(_ref2) {
    var theme = _ref2.theme;
    return '\n    color: ' + theme.colors.base.textLight + ';\n  ';
  }
};

var styles = '\n  font-size: ' + (0, _decisivUiUtils.px2rem)(10) + ';\n  text-transform: capitalize;\n  transition: color 200ms ease;\n';

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired,
      textLight: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

var OptionLabel = (0, _decisivUiUtils.buildStyledComponent)('OptionLabel', _styledComponents2.default.label, styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

exports.default = OptionLabel;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/ButtonToggle/Switch.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  on: function on() {
    return '\n    left: ' + (0, _decisivUiUtils.px2rem)(20) + ';\n  ';
  }
};

var styles = function styles(_ref) {
  var theme = _ref.theme;
  return '\n  background-color: ' + theme.colors.base.chrome100 + ';\n  border-radius: 50%;\n  border: ' + (0, _decisivUiUtils.px2rem)(1) + ' solid ' + theme.colors.base.chrome300 + ';\n  height: ' + (0, _decisivUiUtils.px2rem)(16) + ';\n  left: 0;\n  position: absolute;\n  transition: all 200ms cubic-bezier(0.39, 0.575, 0.565, 1);\n  width: ' + (0, _decisivUiUtils.px2rem)(16) + ';\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome100: _propTypes2.default.string.isRequired,
      chrome300: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

var Switch = (0, _decisivUiUtils.buildStyledComponent)('Switch', _styledComponents2.default.div, styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

exports.default = Switch;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/ButtonToggle/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _Bar = __webpack_require__("../node_modules/base-components/build/blocks/ButtonToggle/Bar.js");

var _Bar2 = _interopRequireDefault(_Bar);

var _Checkbox = __webpack_require__("../node_modules/base-components/build/blocks/ButtonToggle/Checkbox.js");

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _Switch = __webpack_require__("../node_modules/base-components/build/blocks/ButtonToggle/Switch.js");

var _Switch2 = _interopRequireDefault(_Switch);

var _Content = __webpack_require__("../node_modules/base-components/build/blocks/ButtonToggle/Content.js");

var _Content2 = _interopRequireDefault(_Content);

var _OptionLabel = __webpack_require__("../node_modules/base-components/build/blocks/ButtonToggle/OptionLabel.js");

var _OptionLabel2 = _interopRequireDefault(_OptionLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  disabled: function disabled(_ref) {
    var theme = _ref.theme;
    return '\n    opacity: 0.5;\n    pointer-events: none;\n    span {\n      color: ' + theme.colors.base.textLight + ';\n    }\n  ';
  }
};

var styles = function styles(_ref2) {
  var theme = _ref2.theme;
  return '\n  cursor: pointer;\n\n\n\n  &:hover > .Content,\n  .Checkbox:focus + .Content {\n\n    label {\n      color: ' + theme.colors.base.linkHover + ';\n    }\n    .Switch {\n      border-color: transparent;\n      background-color: ' + theme.colors.base.linkHover + ';\n    }\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      linkHover: _propTypes2.default.string.isRequired,
      textLight: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

var ButtonToggle = (0, _decisivUiUtils.buildStyledComponent)('ButtonToggle', _styledComponents2.default.div, styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

ButtonToggle.Bar = _Bar2.default;
ButtonToggle.Checkbox = _Checkbox2.default;
ButtonToggle.Switch = _Switch2.default;
ButtonToggle.Content = _Content2.default;
ButtonToggle.OptionLabel = _OptionLabel2.default;

exports.default = ButtonToggle;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/Calendar/Date.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  disabled: function disabled(_ref) {
    var theme = _ref.theme;
    return {
      styles: '\n      cursor: inherit;\n\n      div {\n        color: ' + theme.colors.base.chrome500 + ';\n      }\n\n      &:hover {\n        background-color: ' + theme.colors.base.background + ';\n\n        div {\n          color: ' + theme.colors.base.chrome500 + ';\n        }\n      }\n    '
    };
  },

  inRange: function inRange(_ref2) {
    var theme = _ref2.theme;
    return {
      styles: '\n      background-color: ' + theme.colors.base.chrome100 + ';\n    '
    };
  },

  selected: function selected(_ref3) {
    var theme = _ref3.theme;
    return {
      styles: '\n      background-color: ' + theme.colors.status.info + ';\n      color: ' + theme.colors.base.chrome000 + ';\n\n      &:hover {\n        background-color: ' + theme.colors.status.info + ';\n\n        div {\n          color: ' + theme.colors.base.chrome000 + ';\n        }\n      }\n    '
    };
  }
};

var styles = function styles(_ref4) {
  var theme = _ref4.theme;
  return '\n  background-color: ' + theme.colors.base.background + ';\n  border-radius: 0;\n  border: none;\n  color: ' + theme.colors.base.textLight + ';\n  cursor: pointer;\n  height: ' + (0, _decisivUiUtils.px2rem)(45) + ';\n  padding: 0;\n  width: 100%;\n\n  div {\n    font-size: ' + (0, _decisivUiUtils.px2rem)(12) + ';\n    line-height: ' + (0, _decisivUiUtils.px2rem)(20) + ';\n    min-height: ' + (0, _decisivUiUtils.px2rem)(20) + ';\n    width: 100%;\n  }\n\n  .fa {\n    font-size: ' + (0, _decisivUiUtils.px2rem)(4) + ';\n    margin-top: ' + (0, _decisivUiUtils.px2rem)(12) + ';\n  }\n\n  &:hover {\n    background-color: ' + theme.colors.base.chrome100 + ';\n\n    div {\n      color: ' + theme.colors.base.linkHover + ';\n    }\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      background: _propTypes2.default.string.isRequired,
      chrome000: _propTypes2.default.string.isRequired,
      chrome100: _propTypes2.default.string.isRequired,
      chrome500: _propTypes2.default.string.isRequired,
      linkHover: _propTypes2.default.string.isRequired,
      textLight: _propTypes2.default.string.isRequired
    }).isRequired,
    status: _propTypes2.default.shape({
      info: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Date', _styledComponents2.default.button, styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

/***/ }),

/***/ "../node_modules/base-components/build/blocks/Calendar/DateTable.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = '\n  border-collapse: collapse;\n  border-spacing: 0;\n  table-layout: fixed;\n  width: 100%;\n';

exports.default = (0, _decisivUiUtils.buildStyledComponent)('DateTable', _styledComponents2.default.table, styles);

/***/ }),

/***/ "../node_modules/base-components/build/blocks/Calendar/DateTableCell.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  withBorder: function withBorder(_ref) {
    var theme = _ref.theme;
    return {
      styles: '\n      border: 1px solid ' + theme.colors.base.chrome100 + ';\n    '
    };
  }
};

var styles = '\n  padding: 0;\n';

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome100: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('DateTableCell', _styledComponents2.default.td, styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

/***/ }),

/***/ "../node_modules/base-components/build/blocks/Calendar/DateTableRow.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = '';

exports.default = (0, _decisivUiUtils.buildStyledComponent)('DateTableRow', _styledComponents2.default.tr, styles);

/***/ }),

/***/ "../node_modules/base-components/build/blocks/Calendar/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/base-components/node_modules/styled-components-reactive-grid/dist/index.js");

var _Date = __webpack_require__("../node_modules/base-components/build/blocks/Calendar/Date.js");

var _Date2 = _interopRequireDefault(_Date);

var _DateTable = __webpack_require__("../node_modules/base-components/build/blocks/Calendar/DateTable.js");

var _DateTable2 = _interopRequireDefault(_DateTable);

var _DateTableCell = __webpack_require__("../node_modules/base-components/build/blocks/Calendar/DateTableCell.js");

var _DateTableCell2 = _interopRequireDefault(_DateTableCell);

var _DateTableRow = __webpack_require__("../node_modules/base-components/build/blocks/Calendar/DateTableRow.js");

var _DateTableRow2 = _interopRequireDefault(_DateTableRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = '\n  max-width: ' + (0, _decisivUiUtils.px2rem)(474) + ';\n  min-width: ' + (0, _decisivUiUtils.px2rem)(344) + ';\n';

var Calendar = (0, _decisivUiUtils.buildStyledComponent)('Calendar', (0, _styledComponents2.default)(_styledComponentsReactiveGrid.Container), styles);

Calendar.Date = _Date2.default;
Calendar.DateTable = _DateTable2.default;
Calendar.DateTableCell = _DateTableCell2.default;
Calendar.DateTableRow = _DateTableRow2.default;

exports.default = Calendar;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/Checkbox/Input.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = function styles(_ref) {
  var theme = _ref.theme;
  return '\n  display: none;\n\n  & + label:before {\n    background: ' + theme.colors.base.background + ';\n    border: 1px solid ' + theme.colors.base.chrome400 + ';\n    border-radius: ' + theme.dimensions.borderRadius + ';\n    color: transparent;\n    content: "\f00c";\n    cursor: pointer;\n    display: inline-block;\n    font-family: FontAwesome;\n    font-size: ' + (0, _decisivUiUtils.px2rem)(16) + ';\n    height: ' + (0, _decisivUiUtils.px2rem)(18) + ';\n    line-height: ' + (0, _decisivUiUtils.px2rem)(18) + ';\n    text-align: center;\n    transition: color .2s;\n    width: ' + (0, _decisivUiUtils.px2rem)(18) + ';\n  }\n\n  &:checked + label:before {\n    color: ' + theme.colors.base.linkHover + ';\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      background: _propTypes2.default.string.isRequired,
      chrome400: _propTypes2.default.string.isRequired,
      linkHover: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired,
  dimensions: _propTypes2.default.shape({
    borderRadius: _propTypes2.default.string.isRequired
  }).isRequired
};

var Input = (0, _decisivUiUtils.buildStyledComponent)('Checkbox__Input', _styledComponents2.default.input.attrs({ type: 'checkbox' }), styles, { themePropTypes: themePropTypes });

exports.default = Input;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/Checkbox/Label.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _elements = __webpack_require__("../node_modules/base-components/build/elements/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  withContent: function withContent() {
    return '\n    &:before {\n      margin-right: ' + (0, _decisivUiUtils.px2rem)(5) + ';\n    }\n  ';
  }
};

var styles = function styles(_ref) {
  var theme = _ref.theme;
  return '\n  align-items: center;\n  display: flex;\n\n  &:hover {\n    color: ' + theme.colors.base.linkHover + ';\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      linkHover: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Checkbox__Label', _elements.Label, styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

/***/ }),

/***/ "../node_modules/base-components/build/blocks/Checkbox/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _Input = __webpack_require__("../node_modules/base-components/build/blocks/Checkbox/Input.js");

var _Input2 = _interopRequireDefault(_Input);

var _Label = __webpack_require__("../node_modules/base-components/build/blocks/Checkbox/Label.js");

var _Label2 = _interopRequireDefault(_Label);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  disabled: function disabled() {
    return '\n    opacity: 0.5;\n    pointer-events: none;\n  ';
  }
};

var styles = '\n  display: inline-block;\n';

var Checkbox = (0, _decisivUiUtils.buildStyledComponent)('Checkbox', _styledComponents2.default.div, styles, { modifierConfig: modifierConfig });

Checkbox.Input = _Input2.default;
Checkbox.Label = _Label2.default;

exports.default = Checkbox;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/ContainerSelectable/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/base-components/node_modules/styled-components-reactive-grid/dist/index.js");

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  active: function active(_ref) {
    var theme = _ref.theme;
    return '\n    background-color: ' + theme.colors.base.selectableActive + ';\n    pointer-events: none;\n    span {\n      color: ' + theme.colors.base.linkHover + ';\n    }\n  ';
  },
  disabled: function disabled() {
    return '\n    opacity: 0.5;\n    pointer-events: none;\n  ';
  }
};

var styles = function styles(_ref2) {
  var theme = _ref2.theme;
  return '\n  cursor: pointer;\n  transition: background 200ms ease;\n  &:hover {\n    background-color: ' + theme.colors.base.selectableHover + ';\n    span {\n      color: ' + theme.colors.base.linkHover + ';\n      text-decoration: underline;\n    }\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      linkHover: _propTypes2.default.string.isRequired,
      selectableActive: _propTypes2.default.string.isRequired,
      selectableHover: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

var ContainerSelectable = (0, _decisivUiUtils.buildStyledComponent)('ContainerSelectable', _styledComponentsReactiveGrid.Container, styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

exports.default = ContainerSelectable;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/Dropdown/Action.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/base-components/node_modules/styled-components-reactive-grid/dist/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Action = (0, _decisivUiUtils.buildStyledComponent)('Dropdown__Action', (0, _styledComponents2.default)(_styledComponentsReactiveGrid.Column));

exports.default = Action;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/Dropdown/Arrow.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _arrow = __webpack_require__("../node_modules/base-components/build/utils/arrow.js");

var _constants = __webpack_require__("../node_modules/base-components/build/blocks/Dropdown/constants.js");

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ARROW_BASE = _constants2.default.ARROW_BASE,
    ARROW_HEIGHT = _constants2.default.ARROW_HEIGHT,
    ARROW_OFFSET = _constants2.default.ARROW_OFFSET,
    BOTTOM_ROTATE = _constants2.default.BOTTOM_ROTATE; // this is a copy/paste from lib/blocks/Popover/Arrow.js (with some modifiers removed)
// will refactor once common logic is identified

var modifierConfig = {
  bottom: function bottom(_ref) {
    var theme = _ref.theme;
    return '\n    background: ' + (0, _arrow.setBackground)(theme.colors.base.background) + ';\n    box-shadow: ' + (0, _arrow.setBoxShadow)('bottom', theme.colors.base.shadowLight) + ';\n    left: 0;\n    margin: auto;\n    right: 0;\n    top: -' + (0, _decisivUiUtils.px2rem)(ARROW_HEIGHT) + ';\n    transform: rotate(' + BOTTOM_ROTATE + 'deg) !important;\n  ';
  },

  bottomLeft: function bottomLeft(_ref2) {
    var theme = _ref2.theme;
    return '\n    background: ' + (0, _arrow.setBackground)(theme.colors.base.background) + ';\n    box-shadow: ' + (0, _arrow.setBoxShadow)('bottom', theme.colors.base.shadowLight) + ';\n    right: ' + (0, _decisivUiUtils.px2rem)(ARROW_OFFSET) + ';\n    top: -' + (0, _decisivUiUtils.px2rem)(ARROW_HEIGHT) + ';\n    transform: rotate(' + BOTTOM_ROTATE + 'deg) !important;\n  ';
  },

  bottomRight: function bottomRight(_ref3) {
    var theme = _ref3.theme;
    return '\n    background: ' + (0, _arrow.setBackground)(theme.colors.base.background) + ';\n    box-shadow: ' + (0, _arrow.setBoxShadow)('bottom', theme.colors.base.shadowLight) + ';\n    left: ' + (0, _decisivUiUtils.px2rem)(ARROW_OFFSET) + ';\n    top: -' + (0, _decisivUiUtils.px2rem)(ARROW_HEIGHT) + ';\n    transform: rotate(' + BOTTOM_ROTATE + 'deg) !important;\n  ';
  }
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      background: _propTypes2.default.string.isRequired,
      shadow: _propTypes2.default.string.isRequired,
      shadowLight: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

var styles = '\n  height: ' + (0, _decisivUiUtils.px2rem)(ARROW_BASE) + ';\n  position: absolute;\n  width: ' + (0, _decisivUiUtils.px2rem)(ARROW_BASE) + ';\n';

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Dropdown__Arrow', _styledComponents2.default.div, styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

/***/ }),

/***/ "../node_modules/base-components/build/blocks/Dropdown/Content.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _constants = __webpack_require__("../node_modules/base-components/build/blocks/Dropdown/constants.js");

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ARROW_WIDTH = _constants2.default.ARROW_WIDTH;


var styles = function styles(_ref) {
  var theme = _ref.theme,
      zIndex = _ref.zIndex;
  return '\n  background-color: ' + theme.colors.base.background + ';\n  border-radius: 0;\n  box-shadow: 0 3px 7px 0 ' + theme.colors.base.shadow + ';\n  display: flex;\n  flex-direction: column;\n  position: absolute;\n  z-index: ' + zIndex + ';\n';
};

var modifierConfig = {
  bottom: function bottom() {
    return '\n    top: calc(100% + ' + (0, _decisivUiUtils.px2rem)(ARROW_WIDTH) + ');\n  ';
  },

  bottomLeft: function bottomLeft(_ref2) {
    var theme = _ref2.theme;
    return '\n    top: calc(100% + ' + (0, _decisivUiUtils.px2rem)(ARROW_WIDTH) + ');\n    border-top-left-radius: ' + theme.dimensions.borderRadius + ';\n  ';
  },

  bottomRight: function bottomRight(_ref3) {
    var theme = _ref3.theme;
    return '\n    top: calc(100% + ' + (0, _decisivUiUtils.px2rem)(ARROW_WIDTH) + ');\n    border-top-right-radius: ' + theme.dimensions.borderRadius + ';\n  ';
  },

  fullWidth: function fullWidth() {
    return '\n    min-width: 100%;\n  ';
  }
};

var propTypes = {
  zIndex: _propTypes2.default.number
};

var defaultProps = {
  zIndex: 1
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      background: _propTypes2.default.string.isRequired,
      shadow: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired,
  dimensions: _propTypes2.default.shape({
    borderRadius: _propTypes2.default.string.isRequired
  })
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Dropdown__Content', _styledComponents2.default.div, styles, {
  defaultProps: defaultProps,
  modifierConfig: modifierConfig,
  propTypes: propTypes,
  themePropTypes: themePropTypes
});

/***/ }),

/***/ "../node_modules/base-components/build/blocks/Dropdown/List.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = '\n  flex: 1;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n';

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Dropdown__List', _styledComponents2.default.ul, styles);

/***/ }),

/***/ "../node_modules/base-components/build/blocks/Dropdown/ListItem.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = function styles(_ref) {
  var theme = _ref.theme;
  return '\n  display: flex;\n  padding: ' + (0, _decisivUiUtils.px2rem)(5) + ' ' + (0, _decisivUiUtils.px2rem)(10) + ';\n  &:hover {\n    cursor: pointer;\n\n    a {\n      color: ' + theme.colors.base.linkHover + ';\n      text-decoration: underline;\n    }\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      linkHover: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

// these modifiers are passed down to ContainerSelectable
// and are not on the li element directly
var propTypes = {
  modifiers: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

var defaultProps = {
  modifiers: []
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Dropdown__ListItem', _styledComponents2.default.li, styles, {
  defaultProps: defaultProps,
  propTypes: propTypes,
  themePropTypes: themePropTypes
});

/***/ }),

/***/ "../node_modules/base-components/build/blocks/Dropdown/SectionBody.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/base-components/node_modules/styled-components-reactive-grid/dist/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = '\n  flex-wrap: nowrap;\n  padding: ' + (0, _decisivUiUtils.px2rem)(10) + ';\n';

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Dropdown__SectionBody', (0, _styledComponents2.default)(_styledComponentsReactiveGrid.Row), styles);

/***/ }),

/***/ "../node_modules/base-components/build/blocks/Dropdown/SectionHeader.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/base-components/node_modules/styled-components-reactive-grid/dist/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = '\n  flex-wrap: nowrap;\n  padding: ' + (0, _decisivUiUtils.px2rem)(5) + ' ' + (0, _decisivUiUtils.px2rem)(10) + ';\n';

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Dropdown__SectionHeader', (0, _styledComponents2.default)(_styledComponentsReactiveGrid.Row), styles);

/***/ }),

/***/ "../node_modules/base-components/build/blocks/Dropdown/Target.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  fullWidth: function fullWidth() {
    return '\n    width: 100%;\n  ';
  }
};

var styles = '';

var Target = (0, _decisivUiUtils.buildStyledComponent)('Dropdown__Target', _styledComponents2.default.span, styles, { modifierConfig: modifierConfig });

exports.default = Target;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/Dropdown/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _arrow = __webpack_require__("../node_modules/base-components/build/utils/arrow.js");

// Ideally, this should be 15px,
// but because of browser rendering inconsistencies, I added a little buffer.
var ARROW_BASE = 15.5;

// Browsers have issues with partial pixels and cause the Popover Arrow to render
// _slightly_ off. The 1px offset here is to accommodate for that.
var BROWSER_OFFSET = 1;

exports.default = _extends({
  ARROW_BASE: ARROW_BASE,
  BROWSER_OFFSET: BROWSER_OFFSET
}, (0, _arrow.generateConstants)({ ARROW_BASE: ARROW_BASE, BROWSER_OFFSET: BROWSER_OFFSET }));

/***/ }),

/***/ "../node_modules/base-components/build/blocks/Dropdown/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _elements = __webpack_require__("../node_modules/base-components/build/elements/index.js");

var _Action = __webpack_require__("../node_modules/base-components/build/blocks/Dropdown/Action.js");

var _Action2 = _interopRequireDefault(_Action);

var _Arrow = __webpack_require__("../node_modules/base-components/build/blocks/Dropdown/Arrow.js");

var _Arrow2 = _interopRequireDefault(_Arrow);

var _Content = __webpack_require__("../node_modules/base-components/build/blocks/Dropdown/Content.js");

var _Content2 = _interopRequireDefault(_Content);

var _List = __webpack_require__("../node_modules/base-components/build/blocks/Dropdown/List.js");

var _List2 = _interopRequireDefault(_List);

var _ListItem = __webpack_require__("../node_modules/base-components/build/blocks/Dropdown/ListItem.js");

var _ListItem2 = _interopRequireDefault(_ListItem);

var _SectionBody = __webpack_require__("../node_modules/base-components/build/blocks/Dropdown/SectionBody.js");

var _SectionBody2 = _interopRequireDefault(_SectionBody);

var _SectionHeader = __webpack_require__("../node_modules/base-components/build/blocks/Dropdown/SectionHeader.js");

var _SectionHeader2 = _interopRequireDefault(_SectionHeader);

var _Target = __webpack_require__("../node_modules/base-components/build/blocks/Dropdown/Target.js");

var _Target2 = _interopRequireDefault(_Target);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  bottom: function bottom() {
    return 'justify-content: center;';
  },
  bottomLeft: function bottomLeft() {
    return 'justify-content: flex-end;';
  },
  bottomRight: function bottomRight() {
    return 'justify-content: flex-start;';
  }
};

var styles = '\n  display: flex;\n  position: relative;\n';

var Dropdown = (0, _decisivUiUtils.buildStyledComponent)('Dropdown', _styledComponents2.default.span, styles, {
  modifierConfig: modifierConfig
});

Dropdown.Action = _Action2.default;
Dropdown.Arrow = _Arrow2.default;
Dropdown.Content = _Content2.default;
Dropdown.Divider = _elements.Divider;
Dropdown.List = _List2.default;
Dropdown.ListItem = _ListItem2.default;
Dropdown.SectionBody = _SectionBody2.default;
Dropdown.SectionHeader = _SectionHeader2.default;
Dropdown.Target = _Target2.default;

exports.default = Dropdown;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/IconCircular/IconBackground.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  bgDanger: function bgDanger(_ref) {
    var theme = _ref.theme;
    return '\n    background: ' + theme.colors.status.danger + ';\n  ';
  },
  bgInfo: function bgInfo(_ref2) {
    var theme = _ref2.theme;
    return '\n    background: ' + theme.colors.status.info + ';\n  ';
  },
  bgSuccess: function bgSuccess(_ref3) {
    var theme = _ref3.theme;
    return '\n    background: ' + theme.colors.status.success + ';\n  ';
  },
  bgWarning: function bgWarning(_ref4) {
    var theme = _ref4.theme;
    return '\n    background: ' + theme.colors.status.warning + ';\n  ';
  }
};

var styles = function styles(_ref5) {
  var theme = _ref5.theme;
  return '\n  align-items: center;\n  background: ' + theme.colors.status.default + ';\n  border-radius: ' + (0, _decisivUiUtils.px2rem)(30) + ';\n  display: flex;\n  justify-content: center;\n  height: ' + (0, _decisivUiUtils.px2rem)(60) + ';\n  width: ' + (0, _decisivUiUtils.px2rem)(60) + ';\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    status: _propTypes2.default.shape({
      danger: _propTypes2.default.string.isRequired,
      default: _propTypes2.default.string.isRequired,
      info: _propTypes2.default.string.isRequired,
      success: _propTypes2.default.string.isRequired,
      warning: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('IconBackground', _styledComponents2.default.div, styles, {
  modifierConfig: modifierConfig,
  themePropTypes: themePropTypes
});

/***/ }),

/***/ "../node_modules/base-components/build/blocks/IconCircular/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _elements = __webpack_require__("../node_modules/base-components/build/elements/index.js");

var _modifiers = __webpack_require__("../node_modules/base-components/build/utils/modifiers.js");

var _IconBackground = __webpack_require__("../node_modules/base-components/build/blocks/IconCircular/IconBackground.js");

var _IconBackground2 = _interopRequireDefault(_IconBackground);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function IconCircular(props) {
  var modifiers = props.modifiers,
      rest = _objectWithoutProperties(props, ['modifiers']);

  var bgModifiers = (0, _modifiers.modifiersForComponent)(modifiers, _IconBackground2.default);
  var iconModifiers = ['medium', 'chrome000'].concat(_toConsumableArray((0, _modifiers.modifiersForComponent)(modifiers, _elements.Icon)));

  return _react2.default.createElement(
    _IconBackground2.default,
    { modifiers: bgModifiers },
    _react2.default.createElement(_elements.Icon, _extends({ modifiers: iconModifiers }, rest))
  );
}

IconCircular.defaultProps = {
  modifiers: []
};

IconCircular.propTypes = {
  modifiers: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

exports.default = IconCircular;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/Input/ActionButton.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  hoverInfo: function hoverInfo(_ref) {
    var theme = _ref.theme;
    return '\n    &:hover {\n      color: ' + theme.colors.status.info + ';\n    }\n  ';
  },

  hoverDanger: function hoverDanger(_ref2) {
    var theme = _ref2.theme;
    return '\n    &:hover {\n      color: ' + theme.colors.status.danger + ';\n    }\n  ';
  }
};

var styles = function styles(_ref3) {
  var theme = _ref3.theme;
  return '\n  background: none;\n  border: none;\n  color: ' + theme.colors.base.chrome500 + ';\n  cursor: pointer;\n  height: 100%;\n  padding: 0 ' + theme.dimensions.gridPad + ';\n  width: 100%;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome500: _propTypes2.default.string.isRequired
    }).isRequired,
    status: _propTypes2.default.shape({
      danger: _propTypes2.default.string.isRequired,
      info: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired,
  dimensions: _propTypes2.default.shape({
    gridPad: _propTypes2.default.string.isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Input__ActionButton', _styledComponents2.default.button, styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

/***/ }),

/***/ "../node_modules/base-components/build/blocks/Input/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/base-components/node_modules/styled-components-reactive-grid/dist/index.js");

var _ActionButton = __webpack_require__("../node_modules/base-components/build/blocks/Input/ActionButton.js");

var _ActionButton2 = _interopRequireDefault(_ActionButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  borderWarning: function borderWarning(_ref) {
    var theme = _ref.theme;
    return '\n    border-color: ' + theme.colors.status.warning + ';\n    &:hover {\n      border-color: ' + theme.colors.status.warning + ';\n    }\n  ';
  },

  disabled: function disabled(_ref2) {
    var theme = _ref2.theme;
    return '\n    border: solid 1px ' + theme.colors.base.chrome400 + ';\n    opacity: 0.5;\n    pointer-events: none;\n  ';
  },

  focused: function focused(_ref3) {
    var theme = _ref3.theme;
    return '\n    border-color: ' + theme.colors.base.chrome600 + ';\n    z-index: 1;\n  ';
  }
};

var styles = function styles(_ref4) {
  var theme = _ref4.theme;
  return '\n  background-color: ' + theme.colors.base.background + ';\n  border: solid 1px ' + theme.colors.base.chrome400 + ';\n  height: ' + (0, _decisivUiUtils.px2rem)(45) + ';\n  transition: border-color 200ms ease;\n\n  &:hover {\n    border-color: ' + theme.colors.base.chrome600 + ';\n    z-index: 1;\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      background: _propTypes2.default.string.isRequired,
      chrome400: _propTypes2.default.string.isRequired,
      chrome600: _propTypes2.default.string.isRequired
    }).isRequired,
    status: _propTypes2.default.shape({
      warning: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

var Input = (0, _decisivUiUtils.buildStyledComponent)('Input', _styledComponentsReactiveGrid.Container, styles, {
  modifierConfig: modifierConfig,
  themePropTypes: themePropTypes
});

Input.ActionButton = _ActionButton2.default;

exports.default = Input;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/LeftNav/ExpanderButton.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _elements = __webpack_require__("../node_modules/base-components/build/elements/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function UnstyledButton(_ref) {
  var name = _ref.name,
      rest = _objectWithoutProperties(_ref, ['name']);

  // eslint-disable-next-line no-unused-vars
  var modifiers = rest.modifiers,
      buttonProps = _objectWithoutProperties(rest, ['modifiers']);

  return _react2.default.createElement(
    'button',
    buttonProps,
    _react2.default.createElement(_elements.Icon, { name: name })
  );
}

UnstyledButton.propTypes = {
  modifiers: _propTypes2.default.arrayOf(_propTypes2.default.string),
  name: _propTypes2.default.string.isRequired
};

UnstyledButton.defaultProps = {
  modifiers: []
};

var styles = function styles(_ref2) {
  var theme = _ref2.theme;
  return '\n  align-items: center;\n  background: none;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  height: ' + theme.dimensions.leftNavWidthCollapsed + ';\n  justify-content: center;\n  padding: 0;\n  width: ' + theme.dimensions.leftNavWidthCollapsed + ';\n\n  opacity: 0.5;\n\n  &:hover {\n    background: ' + theme.colors.base.background + ';\n    opacity: 1;\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      background: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired,
  dimensions: _propTypes2.default.shape({
    leftNavWidthCollapsed: _propTypes2.default.string.isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('ExpanderButton', (0, _styledComponents2.default)(UnstyledButton), styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "../node_modules/base-components/build/blocks/LeftNav/Footer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  expanded: function expanded(_ref) {
    var theme = _ref.theme;
    return '\n    border-top: solid 1px ' + theme.colors.base.chrome200 + ';\n  ';
  }
};

var styles = function styles(_ref2) {
  var theme = _ref2.theme;
  return '\n  align-items: center;\n  background-color: ' + theme.colors.base.chrome100 + ';\n  bottom: 0;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: flex-end;\n  left: 0;\n  position: absolute;\n  right: 0;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome100: _propTypes2.default.string.isRequired,
      chrome200: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Footer', _styledComponents2.default.div, styles, {
  modifierConfig: modifierConfig,
  themePropTypes: themePropTypes
});

/***/ }),

/***/ "../node_modules/base-components/build/blocks/LeftNav/MenuBlock.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  expanded: function expanded() {
    return '\n    overflow-x: hidden;\n    overflow-y: auto;\n  ';
  }
};

var styles = function styles() {
  return '\n  -ms-overflow-style: -ms-autohiding-scrollbar;\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: ' + (0, _decisivUiUtils.px2rem)(45) + ';\n';
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('MenuBlock', _styledComponents2.default.div, styles, { modifierConfig: modifierConfig });

/***/ }),

/***/ "../node_modules/base-components/build/blocks/LeftNav/MenuGroupItem.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _decisivUiUtils.buildStyledComponent)('MenuGroupItem', _styledComponents2.default.li);

/***/ }),

/***/ "../node_modules/base-components/build/blocks/LeftNav/MenuGroupsDivider.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modifierConfig = undefined;

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = exports.modifierConfig = {
  expanded: function expanded(_ref) {
    var theme = _ref.theme;
    return '\n    width: calc(' + theme.dimensions.leftNavWidth + ' - ' + theme.dimensions.leftNavWidthCollapsed + ');\n    margin: 0;\n    margin-left: ' + theme.dimensions.leftNavWidthCollapsed + ';\n  ';
  },

  last: function last() {
    return 'display: none;';
  }
};

var styles = function styles(_ref2) {
  var theme = _ref2.theme;
  return '\n  background: ' + theme.colors.base.chrome200 + ';\n  height: 1px;\n  margin: auto;\n  transition: width ' + theme.dimensions.leftNavExpandTime + ';\n  width: ' + (0, _decisivUiUtils.px2rem)(30) + ';\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome200: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired,
  dimensions: _propTypes2.default.shape({
    leftNavExpandTime: _propTypes2.default.string.isRequired,
    leftNavWidth: _propTypes2.default.string.isRequired,
    leftNavWidthCollapsed: _propTypes2.default.string.isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('MenuGroupsDivider', _styledComponents2.default.div, styles, {
  modifierConfig: modifierConfig,
  themePropTypes: themePropTypes
});

/***/ }),

/***/ "../node_modules/base-components/build/blocks/LeftNav/MenuGroupsList.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = function styles() {
  return '\n  list-style: none;\n  margin: 0;\n  padding: 0;\n';
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('MenuGroupsList', _styledComponents2.default.ul, styles);

/***/ }),

/***/ "../node_modules/base-components/build/blocks/LeftNav/MenuItem.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = '\n  pointer-events: none;\n  position: relative;\n';

exports.default = (0, _decisivUiUtils.buildStyledComponent)('MenuItem', _styledComponents2.default.li, styles);

/***/ }),

/***/ "../node_modules/base-components/build/blocks/LeftNav/MenuItemFlyout.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = function styles(_ref) {
  var theme = _ref.theme;
  return '\n  background: ' + theme.colors.base.chrome100 + ';\n  border-radius: ' + theme.dimensions.borderRadius + ';\n  box-shadow: 0 3px 7px ' + theme.colors.base.shadow + ';\n  left: ' + theme.dimensions.leftNavWidthCollapsed + ';\n  position: absolute;\n  top: 0;\n  width: ' + (0, _decisivUiUtils.px2rem)(180) + ';\n  z-index: 100;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome100: _propTypes2.default.string.isRequired,
      shadow: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired,
  dimensions: _propTypes2.default.shape({
    borderRadius: _propTypes2.default.string.isRequired,
    leftNavWidthCollapsed: _propTypes2.default.string.isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('MenuItemFlyout', _styledComponents2.default.div, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "../node_modules/base-components/build/blocks/LeftNav/MenuItemTitle.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modifierConfig = undefined;

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = exports.modifierConfig = {
  active: function active(_ref) {
    var theme = _ref.theme;
    return '\n    background: ' + theme.colors.base.chrome000 + ';\n    border-left: 2px solid ' + theme.colors.brand.primary + ';\n  ';
  },

  ghost: function ghost(_ref2) {
    var theme = _ref2.theme;
    return '\n    border: none;\n    padding: ' + (0, _decisivUiUtils.px2rem)(8) + ';\n\n    &:hover {\n      background: ' + theme.colors.base.chrome100 + ';\n    }\n  ';
  },

  highlight: function highlight(_ref3) {
    var theme = _ref3.theme;
    return '\n    background: ' + theme.colors.base.chrome000 + ';\n  ';
  }
};

var styles = function styles(_ref4) {
  var theme = _ref4.theme;
  return '\n  align-items: center;\n  background: ' + theme.colors.base.chrome100 + ';\n  border-left: 2px solid transparent;\n  box-sizing: border-box;\n  display: flex;\n  height: ' + theme.dimensions.leftNavWidthCollapsed + ';\n  padding: 0;\n  pointer-events: auto;\n\n  &: hover {\n   background: ' + theme.colors.base.chrome000 + ';\n\n    .MenuItemTitleText {\n      text-decoration: underline;\n    }\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome000: _propTypes2.default.string.isRequired,
      chrome100: _propTypes2.default.string.isRequired
    }).isRequired,
    brand: _propTypes2.default.shape({
      primary: _propTypes2.default.shape.isRequired
    }).isRequired
  }).isRequired,
  dimensions: _propTypes2.default.shape({
    leftNavWidthCollapsed: _propTypes2.default.string.isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('MenuItemTitle', _styledComponents2.default.div, styles, {
  modifierConfig: modifierConfig,
  themePropTypes: themePropTypes
});

/***/ }),

/***/ "../node_modules/base-components/build/blocks/LeftNav/MenuItemTitleGhost.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modifierConfig = undefined;

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _elements = __webpack_require__("../node_modules/base-components/build/elements/index.js");

var modifierConfig = exports.modifierConfig = {
  icon: function icon() {
    return '\n    max-width: ' + (0, _decisivUiUtils.px2rem)(16) + ';\n  ';
  }
};

var styles = function styles() {
  return '\n  height: ' + (0, _decisivUiUtils.px2rem)(16) + ';\n  margin: ' + (0, _decisivUiUtils.px2rem)(8) + ';\n';
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('MenuItemTitleGhost', _elements.GhostIndicator, styles, { modifierConfig: modifierConfig });

/***/ }),

/***/ "../node_modules/base-components/build/blocks/LeftNav/MenuItemTitleIcon.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _elements = __webpack_require__("../node_modules/base-components/build/elements/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = function styles(_ref) {
  var theme = _ref.theme;
  return '\n  align-items: center;\n  display: flex;\n  height: ' + theme.dimensions.leftNavWidthCollapsed + ';\n  justify-content: center;\n  width: calc(' + theme.dimensions.leftNavWidthCollapsed + ' - 2px);\n';
};

var themePropTypes = {
  dimensions: _propTypes2.default.shape({
    leftNavWidthCollapsed: _propTypes2.default.string.isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('MenuItemTitleIcon', (0, _styledComponents2.default)(_elements.Icon), styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "../node_modules/base-components/build/blocks/LeftNav/MenuItemTitleLink.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _elements = __webpack_require__("../node_modules/base-components/build/elements/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = function styles(_ref) {
  var theme = _ref.theme;
  return '\n  color: ' + theme.colors.base.textLight + ';\n  display: flex;\n  flex: 1;\n  text-decoration: none;\n';
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('MenuItemTitleLink', (0, _styledComponents2.default)(_elements.NavLink), styles);

/***/ }),

/***/ "../node_modules/base-components/build/blocks/LeftNav/MenuItemTitleText.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modifierConfig = undefined;

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = exports.modifierConfig = {
  highlight: function highlight() {
    return '\n    text-decoration: underline;\n  ';
  },

  flyout: function flyout() {
    return '\n    padding-left: ' + (0, _decisivUiUtils.px2rem)(10) + ';\n  ';
  }
};

var styles = function styles(_ref) {
  var theme = _ref.theme;
  return '\n  align-items: center;\n  color: ' + theme.colors.base.textLight + ';\n  display: flex;\n  font-size: ' + (0, _decisivUiUtils.px2rem)(12) + ';\n  height: ' + theme.dimensions.leftNavWidthCollapsed + ';\n  overflow: hidden;\n  white-space: nowrap;\n\n  &:hover {\n    text-decoration: underline;\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      textLight: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired,
  dimensions: _propTypes2.default.shape({
    leftNavWidthCollapsed: _propTypes2.default.string.isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('MenuItemTitleText', _styledComponents2.default.div, styles, {
  modifierConfig: modifierConfig,
  themePropTypes: themePropTypes
});

/***/ }),

/***/ "../node_modules/base-components/build/blocks/LeftNav/MenuSubItem.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = '\n  height: ' + (0, _decisivUiUtils.px2rem)(30) + ';\n  pointer-events: auto;\n';

exports.default = (0, _decisivUiUtils.buildStyledComponent)('MenuSubItem', _styledComponents2.default.li, styles);

/***/ }),

/***/ "../node_modules/base-components/build/blocks/LeftNav/MenuSubItemLink.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modifierConfig = undefined;

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _elements = __webpack_require__("../node_modules/base-components/build/elements/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = exports.modifierConfig = {
  active: function active(_ref) {
    var theme = _ref.theme;
    return '\n    background: ' + theme.colors.base.chrome000 + ';\n    border-left: 2px solid ' + theme.colors.brand.primary + ';\n  ';
  },

  flyout: function flyout() {
    return '\n    padding-left: ' + (0, _decisivUiUtils.px2rem)(10) + ';\n  ';
  }
};

var styles = function styles(_ref2) {
  var theme = _ref2.theme;
  return '\n  border-left: 2px solid transparent;\n  color: ' + theme.colors.base.textLight + ';\n  display: block;\n  font-size: ' + (0, _decisivUiUtils.px2rem)(10) + ';\n  height: 100%;\n  line-height: ' + (0, _decisivUiUtils.px2rem)(30) + ';\n  padding-left: ' + (0, _decisivUiUtils.px2rem)(48) + ';\n  text-decoration: none;\n\n  &:hover {\n    background: ' + theme.colors.base.chrome000 + ';\n    text-decoration: underline;\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome000: _propTypes2.default.string.isRequired,
      textLight: _propTypes2.default.string.isRequired
    }).isRequired,
    brand: _propTypes2.default.shape({
      primary: _propTypes2.default.shape.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('MenuSubItemLink', (0, _styledComponents2.default)(_elements.NavLink), styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

/***/ }),

/***/ "../node_modules/base-components/build/blocks/LeftNav/MenusList.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = function styles() {
  return '\n  list-style: none;\n  padding: 0;\n';
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('MenusList', _styledComponents2.default.ul, styles);

/***/ }),

/***/ "../node_modules/base-components/build/blocks/LeftNav/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _ExpanderButton = __webpack_require__("../node_modules/base-components/build/blocks/LeftNav/ExpanderButton.js");

var _ExpanderButton2 = _interopRequireDefault(_ExpanderButton);

var _Footer = __webpack_require__("../node_modules/base-components/build/blocks/LeftNav/Footer.js");

var _Footer2 = _interopRequireDefault(_Footer);

var _MenuBlock = __webpack_require__("../node_modules/base-components/build/blocks/LeftNav/MenuBlock.js");

var _MenuBlock2 = _interopRequireDefault(_MenuBlock);

var _MenuGroupItem = __webpack_require__("../node_modules/base-components/build/blocks/LeftNav/MenuGroupItem.js");

var _MenuGroupItem2 = _interopRequireDefault(_MenuGroupItem);

var _MenuGroupsDivider = __webpack_require__("../node_modules/base-components/build/blocks/LeftNav/MenuGroupsDivider.js");

var _MenuGroupsDivider2 = _interopRequireDefault(_MenuGroupsDivider);

var _MenuGroupsList = __webpack_require__("../node_modules/base-components/build/blocks/LeftNav/MenuGroupsList.js");

var _MenuGroupsList2 = _interopRequireDefault(_MenuGroupsList);

var _MenuItem = __webpack_require__("../node_modules/base-components/build/blocks/LeftNav/MenuItem.js");

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _MenuItemFlyout = __webpack_require__("../node_modules/base-components/build/blocks/LeftNav/MenuItemFlyout.js");

var _MenuItemFlyout2 = _interopRequireDefault(_MenuItemFlyout);

var _MenuItemTitle = __webpack_require__("../node_modules/base-components/build/blocks/LeftNav/MenuItemTitle.js");

var _MenuItemTitle2 = _interopRequireDefault(_MenuItemTitle);

var _MenuItemTitleGhost = __webpack_require__("../node_modules/base-components/build/blocks/LeftNav/MenuItemTitleGhost.js");

var _MenuItemTitleGhost2 = _interopRequireDefault(_MenuItemTitleGhost);

var _MenuItemTitleIcon = __webpack_require__("../node_modules/base-components/build/blocks/LeftNav/MenuItemTitleIcon.js");

var _MenuItemTitleIcon2 = _interopRequireDefault(_MenuItemTitleIcon);

var _MenuItemTitleLink = __webpack_require__("../node_modules/base-components/build/blocks/LeftNav/MenuItemTitleLink.js");

var _MenuItemTitleLink2 = _interopRequireDefault(_MenuItemTitleLink);

var _MenuItemTitleText = __webpack_require__("../node_modules/base-components/build/blocks/LeftNav/MenuItemTitleText.js");

var _MenuItemTitleText2 = _interopRequireDefault(_MenuItemTitleText);

var _MenuSubItem = __webpack_require__("../node_modules/base-components/build/blocks/LeftNav/MenuSubItem.js");

var _MenuSubItem2 = _interopRequireDefault(_MenuSubItem);

var _MenuSubItemLink = __webpack_require__("../node_modules/base-components/build/blocks/LeftNav/MenuSubItemLink.js");

var _MenuSubItemLink2 = _interopRequireDefault(_MenuSubItemLink);

var _MenusList = __webpack_require__("../node_modules/base-components/build/blocks/LeftNav/MenusList.js");

var _MenusList2 = _interopRequireDefault(_MenusList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  expanded: function expanded(_ref) {
    var theme = _ref.theme;
    return '\n    width: ' + theme.dimensions.leftNavWidth + ';\n  ';
  }
};

var styles = function styles(_ref2) {
  var theme = _ref2.theme;
  return '\n  background-color: ' + theme.colors.base.chrome100 + ';\n  border-right: 1px solid ' + theme.colors.base.chrome200 + ';\n  box-sizing: border-box;\n  height: 100%;\n  position: relative;\n  transition: width ' + theme.dimensions.leftNavExpandTime + ';\n  width: ' + theme.dimensions.leftNavWidthCollapsed + ';\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome100: _propTypes2.default.string.isRequired,
      chrome200: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired,
  dimensions: _propTypes2.default.shape({
    leftNavExpandTime: _propTypes2.default.string.isRequired,
    leftNavWidth: _propTypes2.default.string.isRequired,
    leftNavWidthCollapsed: _propTypes2.default.string.isRequired
  }).isRequired
};

var LeftNav = (0, _decisivUiUtils.buildStyledComponent)('LeftNav', _styledComponents2.default.nav, styles, {
  modifierConfig: modifierConfig,
  themePropTypes: themePropTypes
});

LeftNav.ExpanderButton = _ExpanderButton2.default;
LeftNav.Footer = _Footer2.default;
LeftNav.MenuBlock = _MenuBlock2.default;
LeftNav.MenuGroupItem = _MenuGroupItem2.default;
LeftNav.MenuGroupsDivider = _MenuGroupsDivider2.default;
LeftNav.MenuGroupsList = _MenuGroupsList2.default;
LeftNav.MenuItem = _MenuItem2.default;
LeftNav.MenuItemFlyout = _MenuItemFlyout2.default;
LeftNav.MenuItemTitle = _MenuItemTitle2.default;
LeftNav.MenuItemTitleGhost = _MenuItemTitleGhost2.default;
LeftNav.MenuItemTitleIcon = _MenuItemTitleIcon2.default;
LeftNav.MenuItemTitleLink = _MenuItemTitleLink2.default;
LeftNav.MenuItemTitleText = _MenuItemTitleText2.default;
LeftNav.MenuSubItem = _MenuSubItem2.default;
LeftNav.MenuSubItemLink = _MenuSubItemLink2.default;
LeftNav.MenusList = _MenusList2.default;

exports.default = LeftNav;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/ListTable/Body.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/base-components/node_modules/styled-components-reactive-grid/dist/index.js");

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// this acts as our <tbody> element
var styles = function styles() {
  return '\n  flex: 1;\n';
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Body', (0, _styledComponents2.default)(_styledComponentsReactiveGrid.Container), styles);

/***/ }),

/***/ "../node_modules/base-components/build/blocks/ListTable/Data.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/base-components/node_modules/styled-components-reactive-grid/dist/index.js");

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  flexRow: function flexRow() {
    return {
      styles: 'flex-direction: row;'
    };
  }
};

var Data = function Data(props) {
  var componentProps = (0, _lodash.omit)(props, ['modifiers']);
  return _react2.default.createElement(_styledComponentsReactiveGrid.Column, _extends({}, componentProps, { modifiers: ['col'] }));
};

// this acts as our <td> element
var styles = function styles(_ref) {
  var flex = _ref.flex,
      minWidth = _ref.minWidth;
  return '\n  align-items: flex-start;\n  display: flex;\n  flex-direction: column;\n  flex: ' + flex + ';\n  font-size: ' + (0, _decisivUiUtils.px2rem)(12) + ';\n  justify-content: flex-start;\n  min-height: ' + (0, _decisivUiUtils.px2rem)(60) + ';\n  min-width: ' + (0, _decisivUiUtils.px2rem)(minWidth) + ';\n';
};

var defaultProps = {
  flex: 1,
  minWidth: 100
};

var propTypes = {
  flex: _propTypes2.default.number.isRequired,
  minWidth: _propTypes2.default.number.isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Data', (0, _styledComponents2.default)(Data), styles, {
  defaultProps: defaultProps,
  modifierConfig: modifierConfig,
  propTypes: propTypes
});

/***/ }),

/***/ "../node_modules/base-components/build/blocks/ListTable/Head.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/base-components/node_modules/styled-components-reactive-grid/dist/index.js");

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// this acts as our <thead> element
var styles = function styles(_ref) {
  var theme = _ref.theme;
  return '\n  background-color: ' + theme.colors.base.background + ';\n  border-bottom: solid 1px ' + theme.colors.base.chrome200 + ';\n  display: flex;\n  flex-wrap: nowrap;\n  flex: 1;\n  min-height: ' + (0, _decisivUiUtils.px2rem)(50) + ';\n  z-index: 1;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      background: _propTypes2.default.string.isRequired,
      chrome200: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Head', (0, _styledComponents2.default)(_styledComponentsReactiveGrid.Row), styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "../node_modules/base-components/build/blocks/ListTable/Header.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/base-components/node_modules/styled-components-reactive-grid/dist/index.js");

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// this acts as our <th> element
var styles = function styles(_ref) {
  var theme = _ref.theme,
      flex = _ref.flex,
      minWidth = _ref.minWidth;
  return '\n  align-items: center;\n  color: ' + theme.colors.base.chrome500 + ';\n  display: flex;\n  flex: ' + flex + ';\n  font-size: ' + (0, _decisivUiUtils.px2rem)(12) + ';\n  font-weight: 400;\n  justify-content: flex-start;\n  min-width: ' + (0, _decisivUiUtils.px2rem)(minWidth) + ';\n';
};

var propTypes = {
  flex: _propTypes2.default.number.isRequired,
  minWidth: _propTypes2.default.number.isRequired
};

var defaultProps = {
  flex: 1,
  minWidth: 100
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome500: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Header', (0, _styledComponents2.default)(_styledComponentsReactiveGrid.Column), styles, {
  defaultProps: defaultProps,
  propTypes: propTypes,
  themePropTypes: themePropTypes
});

/***/ }),

/***/ "../node_modules/base-components/build/blocks/ListTable/Row.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/base-components/node_modules/styled-components-reactive-grid/dist/index.js");

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  lined: function lined(_ref) {
    var theme = _ref.theme;
    return {
      styles: 'border-bottom: solid 1px ' + theme.colors.base.chrome200 + ';'
    };
  },
  selectableHover: function selectableHover(_ref2) {
    var theme = _ref2.theme;
    return {
      styles: '\n      cursor: pointer;\n      &:hover {\n        background-color: ' + theme.colors.base.selectableHover + ';\n        box-shadow: 0 2px 1px 0 ' + theme.colors.base.shadowLight + ';\n      }\n    '
    };
  },
  selected: function selected(_ref3) {
    var theme = _ref3.theme;
    return {
      styles: '\n      background-color: ' + theme.colors.base.selectableActive + ';\n      box-shadow: 0 2px 1px 0 ' + theme.colors.base.shadow + ';\n    '
    };
  }
};

var Row = function Row(props) {
  var componentProps = (0, _lodash.omit)(props, ['modifiers']);
  return _react2.default.createElement(_styledComponentsReactiveGrid.Row, componentProps);
};

// This acts as our <tr> element
var styles = function styles() {
  return '\n  display: flex;\n  flex-wrap: nowrap;\n  flex: 1;\n  transition: all 200ms ease;\n  vertical-align: top;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome200: _propTypes2.default.string.isRequired,
      selectableActive: _propTypes2.default.string.isRequired,
      selectableHover: _propTypes2.default.string.isRequired,
      shadow: _propTypes2.default.string.isRequired,
      shadowLight: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Row', (0, _styledComponents2.default)(Row), styles, {
  modifierConfig: modifierConfig,
  themePropTypes: themePropTypes
});

/***/ }),

/***/ "../node_modules/base-components/build/blocks/ListTable/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/base-components/node_modules/styled-components-reactive-grid/dist/index.js");

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _Body = __webpack_require__("../node_modules/base-components/build/blocks/ListTable/Body.js");

var _Body2 = _interopRequireDefault(_Body);

var _Data = __webpack_require__("../node_modules/base-components/build/blocks/ListTable/Data.js");

var _Data2 = _interopRequireDefault(_Data);

var _Head = __webpack_require__("../node_modules/base-components/build/blocks/ListTable/Head.js");

var _Head2 = _interopRequireDefault(_Head);

var _Header = __webpack_require__("../node_modules/base-components/build/blocks/ListTable/Header.js");

var _Header2 = _interopRequireDefault(_Header);

var _Row = __webpack_require__("../node_modules/base-components/build/blocks/ListTable/Row.js");

var _Row2 = _interopRequireDefault(_Row);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//  Table Structure:
//  Table
//    Table.Head
//      Table.Header
//      Table.Header
//      ...
//    Table.Body
//      Table.Row
//        Table.Data
//        Table.Data
//        ...
//      Table.Row
//        Table.Data
//        Table.Data
//        ...
//      Table.Row
//        Table.Data
//        Table.Data
//        ...
//      ...etc.

// this acts as our <table> element
var styles = function styles() {
  return '\n  display: table;\n';
};

var ListTable = (0, _decisivUiUtils.buildStyledComponent)('ListTable', (0, _styledComponents2.default)(_styledComponentsReactiveGrid.Container), styles);

ListTable.Body = _Body2.default;
ListTable.Data = _Data2.default;
ListTable.Head = _Head2.default;
ListTable.Header = _Header2.default;
ListTable.Row = _Row2.default;

exports.default = ListTable;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/MessageLarge/Footer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/base-components/node_modules/styled-components-reactive-grid/dist/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Footer(props) {
  var modifiers = props.modifiers,
      rest = _objectWithoutProperties(props, ['modifiers']);

  var defaultModifiers = ['center'];
  var footerModifiers = defaultModifiers.concat(modifiers);

  return _react2.default.createElement(_styledComponentsReactiveGrid.Row, _extends({ modifiers: footerModifiers }, rest));
}

Footer.defaultProps = {
  modifiers: []
};

Footer.propTypes = {
  modifiers: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

exports.default = Footer;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/MessageLarge/Header.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/base-components/node_modules/styled-components-reactive-grid/dist/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Header(props) {
  var modifiers = props.modifiers,
      rest = _objectWithoutProperties(props, ['modifiers']);

  var defaultModifiers = ['center', 'padScaleY_3'];
  var headerModifiers = defaultModifiers.concat(modifiers);

  return _react2.default.createElement(_styledComponentsReactiveGrid.Row, _extends({ modifiers: headerModifiers }, rest));
}

Header.defaultProps = {
  modifiers: []
};

Header.propTypes = {
  modifiers: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

exports.default = Header;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/MessageLarge/Icon.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _elements = __webpack_require__("../node_modules/base-components/build/elements/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Icon(props) {
  var modifiers = props.modifiers,
      rest = _objectWithoutProperties(props, ['modifiers']);

  var defaultModifiers = ['large'];
  var iconModifiers = defaultModifiers.concat(modifiers);

  return _react2.default.createElement(_elements.Icon, _extends({ modifiers: iconModifiers }, rest));
}

Icon.defaultProps = {
  modifiers: []
};

Icon.propTypes = {
  modifiers: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

exports.default = Icon;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/MessageLarge/Section.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/base-components/node_modules/styled-components-reactive-grid/dist/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Section(props) {
  var modifiers = props.modifiers,
      rest = _objectWithoutProperties(props, ['modifiers']);

  var defaultModifiers = ['center'];
  var sectionModifiers = defaultModifiers.concat(modifiers);

  return _react2.default.createElement(_styledComponentsReactiveGrid.Row, _extends({ modifiers: sectionModifiers }, rest));
}

Section.defaultProps = {
  modifiers: []
};

Section.propTypes = {
  modifiers: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

exports.default = Section;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/MessageLarge/Title.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _elements = __webpack_require__("../node_modules/base-components/build/elements/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Title(props) {
  var modifiers = props.modifiers,
      rest = _objectWithoutProperties(props, ['modifiers']);

  var defaultModifiers = ['fontWeightMedium'];
  var titleModifiers = defaultModifiers.concat(modifiers);

  return _react2.default.createElement(_elements.H2, _extends({ modifiers: titleModifiers }, rest));
}

Title.defaultProps = {
  modifiers: []
};

Title.propTypes = {
  modifiers: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

exports.default = Title;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/MessageLarge/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/base-components/node_modules/styled-components-reactive-grid/dist/index.js");

var _elements = __webpack_require__("../node_modules/base-components/build/elements/index.js");

var _Header = __webpack_require__("../node_modules/base-components/build/blocks/MessageLarge/Header.js");

var _Header2 = _interopRequireDefault(_Header);

var _Icon = __webpack_require__("../node_modules/base-components/build/blocks/MessageLarge/Icon.js");

var _Icon2 = _interopRequireDefault(_Icon);

var _Section = __webpack_require__("../node_modules/base-components/build/blocks/MessageLarge/Section.js");

var _Section2 = _interopRequireDefault(_Section);

var _Footer = __webpack_require__("../node_modules/base-components/build/blocks/MessageLarge/Footer.js");

var _Footer2 = _interopRequireDefault(_Footer);

var _Title = __webpack_require__("../node_modules/base-components/build/blocks/MessageLarge/Title.js");

var _Title2 = _interopRequireDefault(_Title);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function MessageLarge(props) {
  return _react2.default.createElement(_styledComponentsReactiveGrid.Container, props);
}

MessageLarge.Footer = _Footer2.default;
MessageLarge.Header = _Header2.default;
MessageLarge.Icon = _Icon2.default;
MessageLarge.Section = _Section2.default;
MessageLarge.Text = _elements.P;
MessageLarge.Title = _Title2.default;

exports.default = MessageLarge;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/MessageMedium/Header.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/base-components/node_modules/styled-components-reactive-grid/dist/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Header(props) {
  var modifiers = props.modifiers,
      rest = _objectWithoutProperties(props, ['modifiers']);

  var defaultModifiers = ['center', 'padScaleY_3'];
  var headerModifiers = defaultModifiers.concat(modifiers);

  return _react2.default.createElement(_styledComponentsReactiveGrid.Row, _extends({ modifiers: headerModifiers }, rest));
}

Header.defaultProps = {
  modifiers: []
};

Header.propTypes = {
  modifiers: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

exports.default = Header;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/MessageMedium/Section.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/base-components/node_modules/styled-components-reactive-grid/dist/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Section(props) {
  var modifiers = props.modifiers,
      rest = _objectWithoutProperties(props, ['modifiers']);

  var defaultModifiers = ['center'];
  var sectionModifiers = defaultModifiers.concat(modifiers);

  return _react2.default.createElement(_styledComponentsReactiveGrid.Row, _extends({ modifiers: sectionModifiers }, rest));
}

Section.defaultProps = {
  modifiers: []
};

Section.propTypes = {
  modifiers: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

exports.default = Section;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/MessageMedium/Text.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _elements = __webpack_require__("../node_modules/base-components/build/elements/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Text(props) {
  var modifiers = props.modifiers,
      rest = _objectWithoutProperties(props, ['modifiers']);

  var defaultModifiers = ['textLight'];
  var textModifiers = defaultModifiers.concat(modifiers);

  return _react2.default.createElement(_elements.P, _extends({ modifiers: textModifiers }, rest));
}

Text.defaultProps = {
  modifiers: []
};

Text.propTypes = {
  modifiers: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

exports.default = Text;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/MessageMedium/Title.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _elements = __webpack_require__("../node_modules/base-components/build/elements/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Title(props) {
  var modifiers = props.modifiers,
      rest = _objectWithoutProperties(props, ['modifiers']);

  var defaultModifiers = ['fontWeightRegular'];
  var titleModifiers = defaultModifiers.concat(modifiers);

  return _react2.default.createElement(_elements.H3, _extends({ modifiers: titleModifiers }, rest));
}

Title.defaultProps = {
  modifiers: []
};

Title.propTypes = {
  modifiers: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

exports.default = Title;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/MessageMedium/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/base-components/node_modules/styled-components-reactive-grid/dist/index.js");

var _IconCircular = __webpack_require__("../node_modules/base-components/build/blocks/IconCircular/index.js");

var _IconCircular2 = _interopRequireDefault(_IconCircular);

var _Header = __webpack_require__("../node_modules/base-components/build/blocks/MessageMedium/Header.js");

var _Header2 = _interopRequireDefault(_Header);

var _Section = __webpack_require__("../node_modules/base-components/build/blocks/MessageMedium/Section.js");

var _Section2 = _interopRequireDefault(_Section);

var _Text = __webpack_require__("../node_modules/base-components/build/blocks/MessageMedium/Text.js");

var _Text2 = _interopRequireDefault(_Text);

var _Title = __webpack_require__("../node_modules/base-components/build/blocks/MessageMedium/Title.js");

var _Title2 = _interopRequireDefault(_Title);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = '\n  margin: 0 auto;\n  max-width: ' + (0, _decisivUiUtils.px2rem)(300) + ';\n';

var MessageMedium = (0, _decisivUiUtils.buildStyledComponent)('MessageMedium', _styledComponentsReactiveGrid.Container, styles);

MessageMedium.Header = _Header2.default;
MessageMedium.Icon = _IconCircular2.default;
MessageMedium.Section = _Section2.default;
MessageMedium.Text = _Text2.default;
MessageMedium.Title = _Title2.default;

exports.default = MessageMedium;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/MessageSmall/Icon.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _elements = __webpack_require__("../node_modules/base-components/build/elements/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ICONS = {
  danger: 'exclamation-triangle',
  info: 'info-circle',
  success: 'check',
  warning: 'exclamation-circle'
};

var styles = function styles() {
  return '\n  margin-right: ' + (0, _decisivUiUtils.px2rem)(5) + ';\n';
};

var propTypes = {
  type: _propTypes2.default.oneOf(['danger', 'info', 'success', 'warning']).isRequired
};

var Icon = (0, _decisivUiUtils.buildStyledComponent)('Icon', (0, _styledComponents2.default)(_elements.Icon).attrs({
  name: function name(_ref) {
    var type = _ref.type;
    return ICONS[type];
  },
  modifiers: function modifiers(_ref2) {
    var type = _ref2.type;
    return [type];
  }
}), styles, { propTypes: propTypes });

exports.default = Icon;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/MessageSmall/Text.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _elements = __webpack_require__("../node_modules/base-components/build/elements/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = function styles(_ref) {
  var theme = _ref.theme;
  return '\n  color: ' + theme.colors.base.textLight + ';\n  font-weight: ' + theme.fontWeights.light + ';\n  white-space: nowrap;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      textLight: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired,
  fontWeights: _propTypes2.default.shape({
    light: _propTypes2.default.number.isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Text', _elements.Text, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "../node_modules/base-components/build/blocks/MessageSmall/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _Icon = __webpack_require__("../node_modules/base-components/build/blocks/MessageSmall/Icon.js");

var _Icon2 = _interopRequireDefault(_Icon);

var _Text = __webpack_require__("../node_modules/base-components/build/blocks/MessageSmall/Text.js");

var _Text2 = _interopRequireDefault(_Text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = function styles() {
  return '\n  align-items: center;\n  display: flex;\n';
};

var MessageSmall = (0, _decisivUiUtils.buildStyledComponent)('MessageSmall', _styledComponents2.default.div, styles);

MessageSmall.Icon = _Icon2.default;
MessageSmall.Text = _Text2.default;

exports.default = MessageSmall;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/Popover/Arrow.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _arrow = __webpack_require__("../node_modules/base-components/build/utils/arrow.js");

var _constants = __webpack_require__("../node_modules/base-components/build/blocks/Popover/constants.js");

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ARROW_BASE = _constants2.default.ARROW_BASE,
    ARROW_HEIGHT = _constants2.default.ARROW_HEIGHT,
    ARROW_OFFSET = _constants2.default.ARROW_OFFSET,
    BOTTOM_ROTATE = _constants2.default.BOTTOM_ROTATE,
    LEFT_ROTATE = _constants2.default.LEFT_ROTATE,
    RIGHT_ROTATE = _constants2.default.RIGHT_ROTATE,
    TOP_ROTATE = _constants2.default.TOP_ROTATE;


var modifierConfig = {
  bottom: function bottom(_ref) {
    var theme = _ref.theme;
    return '\n    background: ' + (0, _arrow.setBackground)(theme.colors.base.background) + ';\n    box-shadow: ' + (0, _arrow.setBoxShadow)('bottom', theme.colors.base.shadowLight) + ';\n    left: 0;\n    margin: auto;\n    right: 0;\n    top: -' + (0, _decisivUiUtils.px2rem)(ARROW_HEIGHT) + ';\n    transform: rotate(' + BOTTOM_ROTATE + 'deg) !important;\n  ';
  },

  bottomLeft: function bottomLeft(_ref2) {
    var theme = _ref2.theme;
    return '\n    background: ' + (0, _arrow.setBackground)(theme.colors.base.background) + ';\n    box-shadow: ' + (0, _arrow.setBoxShadow)('bottom', theme.colors.base.shadowLight) + ';\n    right: ' + (0, _decisivUiUtils.px2rem)(ARROW_OFFSET) + ';\n    top: -' + (0, _decisivUiUtils.px2rem)(ARROW_HEIGHT) + ';\n    transform: rotate(' + BOTTOM_ROTATE + 'deg) !important;\n  ';
  },

  bottomRight: function bottomRight(_ref3) {
    var theme = _ref3.theme;
    return '\n    background: ' + (0, _arrow.setBackground)(theme.colors.base.background) + ';\n    box-shadow: ' + (0, _arrow.setBoxShadow)('bottom', theme.colors.base.shadowLight) + ';\n    left: ' + (0, _decisivUiUtils.px2rem)(ARROW_OFFSET) + ';\n    top: -' + (0, _decisivUiUtils.px2rem)(ARROW_HEIGHT) + ';\n    transform: rotate(' + BOTTOM_ROTATE + 'deg) !important;\n  ';
  },

  left: function left(_ref4) {
    var theme = _ref4.theme;
    return '\n    background: ' + (0, _arrow.setBackground)(theme.colors.base.background) + ';\n    bottom: 0;\n    box-shadow: ' + (0, _arrow.setBoxShadow)('left', theme.colors.base.shadow) + ';\n    margin: auto;\n    right: -' + (0, _decisivUiUtils.px2rem)(ARROW_HEIGHT) + ';\n    top: 0;\n    transform: rotate(' + LEFT_ROTATE + 'deg) !important;\n  ';
  },

  leftBottom: function leftBottom(_ref5) {
    var theme = _ref5.theme;
    return '\n    background: ' + (0, _arrow.setBackground)(theme.colors.base.background) + ';\n    box-shadow: ' + (0, _arrow.setBoxShadow)('left', theme.colors.base.shadow) + ';\n    right: -' + (0, _decisivUiUtils.px2rem)(ARROW_HEIGHT) + ';\n    top: ' + (0, _decisivUiUtils.px2rem)(ARROW_OFFSET) + ';\n    transform: rotate(' + LEFT_ROTATE + 'deg) !important;\n  ';
  },

  leftTop: function leftTop(_ref6) {
    var theme = _ref6.theme;
    return '\n    background: ' + (0, _arrow.setBackground)(theme.colors.base.background) + ';\n    bottom: ' + (0, _decisivUiUtils.px2rem)(ARROW_OFFSET) + ';\n    box-shadow: ' + (0, _arrow.setBoxShadow)('left', theme.colors.base.shadow) + ';\n    right: -' + (0, _decisivUiUtils.px2rem)(ARROW_HEIGHT) + ';\n    transform: rotate(' + LEFT_ROTATE + 'deg) !important;\n  ';
  },

  right: function right(_ref7) {
    var theme = _ref7.theme;
    return '\n    background: ' + (0, _arrow.setBackground)(theme.colors.base.background) + ';\n    bottom: 0;\n    box-shadow: ' + (0, _arrow.setBoxShadow)('right', theme.colors.base.shadow) + ';\n    left: -' + (0, _decisivUiUtils.px2rem)(ARROW_HEIGHT) + ';\n    margin: auto;\n    top: 0;\n    transform: rotate(' + RIGHT_ROTATE + 'deg) !important;\n  ';
  },

  rightBottom: function rightBottom(_ref8) {
    var theme = _ref8.theme;
    return '\n    background: ' + (0, _arrow.setBackground)(theme.colors.base.background) + ';\n    box-shadow: ' + (0, _arrow.setBoxShadow)('right', theme.colors.base.shadow) + ';\n    left: -' + (0, _decisivUiUtils.px2rem)(ARROW_HEIGHT) + ';\n    top: ' + (0, _decisivUiUtils.px2rem)(ARROW_OFFSET) + ';\n    transform: rotate(' + RIGHT_ROTATE + 'deg) !important;\n  ';
  },

  rightTop: function rightTop(_ref9) {
    var theme = _ref9.theme;
    return '\n    background: ' + (0, _arrow.setBackground)(theme.colors.base.background) + ';\n    bottom: ' + (0, _decisivUiUtils.px2rem)(ARROW_OFFSET) + ';\n    box-shadow: ' + (0, _arrow.setBoxShadow)('right', theme.colors.base.shadow) + ';\n    left: -' + (0, _decisivUiUtils.px2rem)(ARROW_HEIGHT) + ';\n    transform: rotate(' + RIGHT_ROTATE + 'deg) !important;\n  ';
  },

  top: function top(_ref10) {
    var theme = _ref10.theme;
    return '\n    background: ' + (0, _arrow.setBackground)(theme.colors.base.background) + ';\n    bottom: -' + (0, _decisivUiUtils.px2rem)(ARROW_HEIGHT) + ';\n    box-shadow: ' + (0, _arrow.setBoxShadow)('top', theme.colors.base.shadow) + ';\n    left: 0;\n    margin: auto;\n    right: 0;\n    transform: rotate(' + TOP_ROTATE + 'deg) !important;\n  ';
  },

  topLeft: function topLeft(_ref11) {
    var theme = _ref11.theme;
    return '\n    background: ' + (0, _arrow.setBackground)(theme.colors.base.background) + ';\n    bottom: -' + (0, _decisivUiUtils.px2rem)(ARROW_HEIGHT) + ';\n    box-shadow: ' + (0, _arrow.setBoxShadow)('top', theme.colors.base.shadow) + ';\n    right: ' + (0, _decisivUiUtils.px2rem)(ARROW_OFFSET) + ';\n    transform: rotate(' + TOP_ROTATE + 'deg) !important;\n  ';
  },

  topRight: function topRight(_ref12) {
    var theme = _ref12.theme;
    return '\n    background: ' + (0, _arrow.setBackground)(theme.colors.base.background) + ';\n    bottom: -' + (0, _decisivUiUtils.px2rem)(ARROW_HEIGHT) + ';\n    box-shadow: ' + (0, _arrow.setBoxShadow)('top', theme.colors.base.shadow) + ';\n    left: ' + (0, _decisivUiUtils.px2rem)(ARROW_OFFSET) + ';\n    transform: rotate(' + TOP_ROTATE + 'deg) !important;\n  ';
  }
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      background: _propTypes2.default.string.isRequired,
      shadow: _propTypes2.default.string.isRequired,
      shadowLight: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

var styles = '\n  height: ' + (0, _decisivUiUtils.px2rem)(ARROW_BASE) + ';\n  position: absolute;\n  width: ' + (0, _decisivUiUtils.px2rem)(ARROW_BASE) + ';\n';

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Popover__Arrow', _styledComponents2.default.div, styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

/***/ }),

/***/ "../node_modules/base-components/build/blocks/Popover/Content.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _constants = __webpack_require__("../node_modules/base-components/build/blocks/Popover/constants.js");

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ARROW_WIDTH = _constants2.default.ARROW_WIDTH,
    ARROW_OFFSET = _constants2.default.ARROW_OFFSET;


var modifierConfig = {
  bottom: function bottom() {
    return '\n    top: calc(100% + ' + (0, _decisivUiUtils.px2rem)(ARROW_WIDTH) + ');\n  ';
  },

  bottomLeft: function bottomLeft() {
    return '\n    top: calc(100% + ' + (0, _decisivUiUtils.px2rem)(ARROW_WIDTH) + ');\n  ';
  },

  bottomRight: function bottomRight() {
    return '\n    top: calc(100% + ' + (0, _decisivUiUtils.px2rem)(ARROW_WIDTH) + ');\n  ';
  },

  left: function left() {
    return '\n    right: calc(100% + ' + (0, _decisivUiUtils.px2rem)(ARROW_WIDTH) + ');\n  ';
  },

  leftBottom: function leftBottom() {
    return '\n    right: calc(100% + ' + (0, _decisivUiUtils.px2rem)(ARROW_WIDTH) + ');\n    top: -' + (0, _decisivUiUtils.px2rem)(ARROW_OFFSET) + ';\n  ';
  },

  leftTop: function leftTop() {
    return '\n    bottom: -' + (0, _decisivUiUtils.px2rem)(ARROW_OFFSET) + ';\n    right: calc(100% + ' + (0, _decisivUiUtils.px2rem)(ARROW_WIDTH) + ');\n  ';
  },

  right: function right() {
    return '\n    left: calc(100% + ' + (0, _decisivUiUtils.px2rem)(ARROW_WIDTH) + ');\n  ';
  },

  rightBottom: function rightBottom() {
    return '\n    left: calc(100% + ' + (0, _decisivUiUtils.px2rem)(ARROW_WIDTH) + ');\n    top: -' + (0, _decisivUiUtils.px2rem)(ARROW_OFFSET) + ';\n  ';
  },

  rightTop: function rightTop() {
    return '\n    bottom: -' + (0, _decisivUiUtils.px2rem)(ARROW_OFFSET) + ';\n    left: calc(100% + ' + (0, _decisivUiUtils.px2rem)(ARROW_WIDTH) + ');\n  ';
  },

  top: function top() {
    return '\n    bottom: calc(100% + ' + (0, _decisivUiUtils.px2rem)(ARROW_WIDTH) + ');\n  ';
  },

  topLeft: function topLeft() {
    return '\n    bottom: calc(100% + ' + (0, _decisivUiUtils.px2rem)(ARROW_WIDTH) + ');\n  ';
  },

  topRight: function topRight() {
    return '\n    bottom: calc(100% + ' + (0, _decisivUiUtils.px2rem)(ARROW_WIDTH) + ');\n  ';
  }
};

var styles = function styles(_ref) {
  var theme = _ref.theme,
      zIndex = _ref.zIndex;
  return '\n  background-color: ' + theme.colors.base.background + ';\n  border-radius: ' + theme.dimensions.borderRadius + ';\n  box-shadow: 0 3px 7px 0 ' + theme.colors.base.shadow + ';\n  position: absolute;\n  z-index: ' + zIndex + ';\n';
};

var propTypes = {
  zIndex: _propTypes2.default.number
};

var defaultProps = {
  zIndex: 1
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      background: _propTypes2.default.string.isRequired,
      shadow: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired,
  dimensions: _propTypes2.default.shape({
    borderRadius: _propTypes2.default.string.isRequired
  }).isRequired
};

var Content = (0, _decisivUiUtils.buildStyledComponent)('Popover__Content', _styledComponents2.default.div, styles, {
  defaultProps: defaultProps,
  modifierConfig: modifierConfig,
  propTypes: propTypes,
  themePropTypes: themePropTypes
});

exports.default = Content;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/Popover/Target.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Target = (0, _decisivUiUtils.buildStyledComponent)('Popover__Target', _styledComponents2.default.span);

exports.default = Target;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/Popover/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _arrow = __webpack_require__("../node_modules/base-components/build/utils/arrow.js");

// Ideally, this should be 15px,
// but because of browser rendering inconsistencies, I added a little buffer.
var ARROW_BASE = 15.5;

// Browsers have issues with partial pixels and cause the Popover Arrow to render
// _slightly_ off. The 1px offset here is to accommodate for that.
var BROWSER_OFFSET = 1;

exports.default = _extends({
  ARROW_BASE: ARROW_BASE,
  BROWSER_OFFSET: BROWSER_OFFSET
}, (0, _arrow.generateConstants)({ ARROW_BASE: ARROW_BASE, BROWSER_OFFSET: BROWSER_OFFSET }));

/***/ }),

/***/ "../node_modules/base-components/build/blocks/Popover/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _Arrow = __webpack_require__("../node_modules/base-components/build/blocks/Popover/Arrow.js");

var _Arrow2 = _interopRequireDefault(_Arrow);

var _Content = __webpack_require__("../node_modules/base-components/build/blocks/Popover/Content.js");

var _Content2 = _interopRequireDefault(_Content);

var _Target = __webpack_require__("../node_modules/base-components/build/blocks/Popover/Target.js");

var _Target2 = _interopRequireDefault(_Target);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  bottom: function bottom() {
    return 'justify-content: center;';
  },
  bottomLeft: function bottomLeft() {
    return 'justify-content: flex-end;';
  },
  bottomRight: function bottomRight() {
    return 'justify-content: flex-start;';
  },
  left: function left() {
    return 'align-items: center;';
  },
  right: function right() {
    return 'align-items: center;';
  },
  top: function top() {
    return 'justify-content: center;';
  },
  topLeft: function topLeft() {
    return 'justify-content: flex-end;';
  },
  topRight: function topRight() {
    return 'justify-content: flex-start;';
  }
};

var styles = '\n  display: flex;\n  position: relative;\n';

var Popover = (0, _decisivUiUtils.buildStyledComponent)('Popover', _styledComponents2.default.div, styles, { modifierConfig: modifierConfig });

Popover.Arrow = _Arrow2.default;
Popover.Content = _Content2.default;
Popover.Target = _Target2.default;

exports.default = Popover;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/QuickActionButton/Icon.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _Icon = __webpack_require__("../node_modules/base-components/build/elements/Icon/index.js");

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  left: function left() {
    return '\n    padding-right: ' + (0, _decisivUiUtils.px2rem)(5) + ';\n  ';
  },
  right: function right() {
    return '\n    padding-left: ' + (0, _decisivUiUtils.px2rem)(5) + ';\n  ';
  }
};

var styles = '\n  color: inherit;\n  font-size: ' + (0, _decisivUiUtils.px2rem)(12) + ';\n';

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Icon', _Icon2.default, styles, { modifierConfig: modifierConfig });

/***/ }),

/***/ "../node_modules/base-components/build/blocks/QuickActionButton/Text.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _Text = __webpack_require__("../node_modules/base-components/build/elements/Text/index.js");

var _Text2 = _interopRequireDefault(_Text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = function styles(_ref) {
  var theme = _ref.theme;
  return '\n  color: inherit;\n  font-weight: ' + theme.fontWeights.light + ';\n  text-transform: uppercase;\n';
};

var themePropTypes = {
  fontWeights: _propTypes2.default.shape({
    light: _propTypes2.default.number.isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Text', _Text2.default, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "../node_modules/base-components/build/blocks/QuickActionButton/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Icon = __webpack_require__("../node_modules/base-components/build/blocks/QuickActionButton/Icon.js");

var _Icon2 = _interopRequireDefault(_Icon);

var _Text = __webpack_require__("../node_modules/base-components/build/blocks/QuickActionButton/Text.js");

var _Text2 = _interopRequireDefault(_Text);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  active: function active(_ref) {
    var theme = _ref.theme;
    return {
      styles: '\n      background-color: ' + theme.colors.base.linkHover + ';\n      color: ' + theme.colors.base.chrome000 + ';\n      border-color: transparent;\n    '
    };
  },
  disabled: function disabled(_ref2) {
    var theme = _ref2.theme;
    return {
      styles: '\n      opacity: 0.5;\n      pointer-events: none;\n      color: ' + theme.colors.base.chrome500 + ';\n    '
    };
  },
  hoverSuccess: function hoverSuccess(_ref3) {
    var theme = _ref3.theme;
    return {
      styles: '\n      &:hover {\n        background-color: ' + theme.colors.status.success + ';\n        border-color: transparent;\n      }\n    '
    };
  },
  hoverWarning: function hoverWarning(_ref4) {
    var theme = _ref4.theme;
    return {
      styles: '\n      &:hover {\n        background-color: ' + theme.colors.status.warning + ';\n        border-color: transparent;\n      }\n    '
    };
  },
  hoverDanger: function hoverDanger(_ref5) {
    var theme = _ref5.theme;
    return {
      styles: '\n      &:hover {\n        background-color: ' + theme.colors.status.danger + ';\n        border-color: transparent;\n      }\n    '
    };
  },
  iconOnly: function iconOnly() {
    return {
      styles: '\n      padding: 0;\n      width: ' + (0, _decisivUiUtils.px2rem)(35) + ';\n    '
    };
  },
  secondary: function secondary(_ref6) {
    var theme = _ref6.theme;
    return {
      styles: '\n      background-color: ' + theme.colors.base.chrome600 + ';\n      color: ' + theme.colors.base.chrome000 + ';\n      border-color: transparent;\n    '
    };
  }
};

var styles = function styles(_ref7) {
  var theme = _ref7.theme;
  return '\n  background-color: ' + theme.colors.base.chrome100 + ';\n  color: ' + theme.colors.base.chrome600 + ';\n  border: 1px solid ' + theme.colors.base.chrome200 + ';;\n  border-radius: ' + theme.dimensions.borderRadius + ';\n  cursor: pointer;\n  min-height: ' + (0, _decisivUiUtils.px2rem)(25) + ';\n  padding: 0 ' + (0, _decisivUiUtils.px2rem)(20) + ';\n  outline: none;\n  transition: all 200ms ease;\n  white-space: nowrap;\n\n  &:hover {\n    background-color: ' + theme.colors.base.linkHover + ';\n    border-color: transparent;\n    color: ' + theme.colors.base.chrome000 + ';\n\n    span:not(.ix):not(.fa) {\n      text-decoration: underline;\n    }\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome000: _propTypes2.default.string.isRequired,
      chrome100: _propTypes2.default.string.isRequired,
      chrome200: _propTypes2.default.string.isRequired,
      chrome500: _propTypes2.default.string.isRequired,
      chrome600: _propTypes2.default.string.isRequired,
      linkHover: _propTypes2.default.string.isRequired
    }).isRequired,
    status: _propTypes2.default.shape({
      success: _propTypes2.default.string.isRequired,
      warning: _propTypes2.default.string.isRequired,
      danger: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired,
  dimensions: _propTypes2.default.shape({
    borderRadius: _propTypes2.default.string.isRequired
  }).isRequired
};

var QuickActionButton = (0, _decisivUiUtils.buildStyledComponent)('QuickActionButton', _styledComponents2.default.button, styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

QuickActionButton.Icon = _Icon2.default;
QuickActionButton.Text = _Text2.default;

exports.default = QuickActionButton;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/TabList/Icon.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _Icon = __webpack_require__("../node_modules/base-components/build/elements/Icon/index.js");

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = '\n  display: block;\n  padding: ' + (0, _decisivUiUtils.px2rem)(5) + ' 0;\n  text-align: center;\n';

exports.default = (0, _decisivUiUtils.buildStyledComponent)('TabList.Icon', (0, _styledComponents2.default)(_Icon2.default), styles);

/***/ }),

/***/ "../node_modules/base-components/build/blocks/TabList/Item.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  active: function active(_ref) {
    var theme = _ref.theme;
    return '\n    border-bottom: solid ' + (0, _decisivUiUtils.px2rem)(2) + ' ' + theme.colors.base.chrome600 + ';\n    color: ' + theme.colors.base.text + ';\n    pointer-events: none;\n  ';
  },
  spaceEven: function spaceEven() {
    return '\n    flex: 1;\n    justify-content: center;\n  ';
  }
};

var styles = function styles(_ref2) {
  var theme = _ref2.theme;
  return '\n  border-bottom: solid 2px transparent;\n  display: flex;\n  position: relative;\n  top: ' + (0, _decisivUiUtils.px2rem)(2) + ';\n\n  &:hover {\n    border-bottom: solid ' + (0, _decisivUiUtils.px2rem)(2) + ' ' + theme.colors.base.linkHover + ';\n\n    span.fa {\n      color: ' + theme.colors.base.linkHover + ';\n    }\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome600: _propTypes2.default.string.isRequired,
      linkHover: _propTypes2.default.string.isRequired,
      text: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

var defaultProps = {
  modifiers: []
};

var propTypes = {
  modifiers: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

var Item = (0, _decisivUiUtils.buildStyledComponent)('TabList.Item', _styledComponents2.default.li, styles, {
  defaultProps: defaultProps,
  modifierConfig: modifierConfig,
  propTypes: propTypes,
  themePropTypes: themePropTypes
});

exports.default = Item;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/TabList/ItemButton.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _constants = __webpack_require__("../node_modules/base-components/build/utils/constants.js");

var _em2rem = __webpack_require__("../node_modules/base-components/build/utils/em2rem.js");

var _em2rem2 = _interopRequireDefault(_em2rem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FONT_SIZE = 12;

var styles = function styles(_ref) {
  var theme = _ref.theme;
  return '\n  background: none;\n  border: 2px solid transparent;\n  color: ' + theme.colors.base.textLight + ';\n  cursor: pointer;\n  font-size: ' + (0, _decisivUiUtils.px2rem)(FONT_SIZE) + ';\n  font-weight: ' + theme.fontWeights.light + ';\n  line-height: ' + (0, _em2rem2.default)(FONT_SIZE, _constants.TEXT_LINE_HEIGHT) + ';\n  padding: ' + (0, _decisivUiUtils.px2rem)(5) + ' ' + (0, _decisivUiUtils.px2rem)(20) + ';\n  text-transform: capitalize;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      linkHover: _propTypes2.default.string.isRequired,
      text: _propTypes2.default.string.isRequired,
      textLight: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired,
  fontWeights: _propTypes2.default.shape({
    light: _propTypes2.default.number.isRequired
  }).isRequired
};

var propTypes = {
  'aria-label': _propTypes2.default.string.isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('TabList.ItemButton', _styledComponents2.default.button, styles, {
  propTypes: propTypes,
  themePropTypes: themePropTypes
});

/***/ }),

/***/ "../node_modules/base-components/build/blocks/TabList/ItemLink.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _elements = __webpack_require__("../node_modules/base-components/build/elements/index.js");

var _constants = __webpack_require__("../node_modules/base-components/build/utils/constants.js");

var _em2rem = __webpack_require__("../node_modules/base-components/build/utils/em2rem.js");

var _em2rem2 = _interopRequireDefault(_em2rem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FONT_SIZE = 12;

var styles = function styles(_ref) {
  var theme = _ref.theme;
  return '\n  color: ' + theme.colors.base.textLight + ';\n  display: inline-block;\n  font-size: ' + (0, _decisivUiUtils.px2rem)(FONT_SIZE) + ';\n  font-weight: ' + theme.fontWeights.light + ';\n  line-height: ' + (0, _em2rem2.default)(FONT_SIZE, _constants.TEXT_LINE_HEIGHT) + ';\n  padding: ' + (0, _decisivUiUtils.px2rem)(5) + ' ' + (0, _decisivUiUtils.px2rem)(20) + ';\n  text-decoration: none;\n  text-transform: capitalize;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      linkHover: _propTypes2.default.string.isRequired,
      text: _propTypes2.default.string.isRequired,
      textLight: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired,
  fontWeights: _propTypes2.default.shape({
    light: _propTypes2.default.number.isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('TabList.ItemLink', (0, _styledComponents2.default)(_elements.NavLink), styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "../node_modules/base-components/build/blocks/TabList/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _Icon = __webpack_require__("../node_modules/base-components/build/blocks/TabList/Icon.js");

var _Icon2 = _interopRequireDefault(_Icon);

var _Item = __webpack_require__("../node_modules/base-components/build/blocks/TabList/Item.js");

var _Item2 = _interopRequireDefault(_Item);

var _ItemButton = __webpack_require__("../node_modules/base-components/build/blocks/TabList/ItemButton.js");

var _ItemButton2 = _interopRequireDefault(_ItemButton);

var _ItemLink = __webpack_require__("../node_modules/base-components/build/blocks/TabList/ItemLink.js");

var _ItemLink2 = _interopRequireDefault(_ItemLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = function styles(_ref) {
  var theme = _ref.theme;
  return '\n  border-bottom: solid ' + (0, _decisivUiUtils.px2rem)(2) + ' ' + theme.colors.base.chrome200 + ';\n  display: flex;\n  flex: 1;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome200: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

var TabList = (0, _decisivUiUtils.buildStyledComponent)('TabList', _styledComponents2.default.ul, styles, { themePropTypes: themePropTypes });

TabList.Icon = _Icon2.default;
TabList.Item = _Item2.default;
TabList.ItemButton = _ItemButton2.default;
TabList.ItemLink = _ItemLink2.default;

exports.default = TabList;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/Tag/CloseButton.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = function styles(_ref) {
  var theme = _ref.theme;
  return '\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0 0 0 ' + (0, _decisivUiUtils.px2rem)(5) + ';\n\n  &:hover, &:focus {\n    span.fa {\n      color: ' + theme.colors.status.danger + ';\n    }\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    status: _propTypes2.default.shape({
      danger: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

var propTypes = {
  onClick: _propTypes2.default.func.isRequired
};

var CloseButton = (0, _decisivUiUtils.buildStyledComponent)('CloseButton', _styledComponents2.default.button, styles, {
  themePropTypes: themePropTypes,
  propTypes: propTypes
});

exports.default = CloseButton;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/Tag/CloseButtonIcon.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _elements = __webpack_require__("../node_modules/base-components/build/elements/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CloseButtonIcon() {
  return _react2.default.createElement(_elements.Icon, { modifiers: ['mini'], name: 'close' });
}

exports.default = CloseButtonIcon;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/Tag/Text.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _elements = __webpack_require__("../node_modules/base-components/build/elements/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Text(props) {
  var modifiers = props.modifiers,
      rest = _objectWithoutProperties(props, ['modifiers']);

  var defaultModifiers = ['small', 'capitalize'];
  var textModifiers = defaultModifiers.concat(modifiers);
  return _react2.default.createElement(_elements.Text, _extends({ modifiers: textModifiers }, rest));
}

Text.propTypes = {
  modifiers: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

Text.defaultProps = {
  modifiers: []
};

exports.default = Text;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/Tag/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _CloseButton = __webpack_require__("../node_modules/base-components/build/blocks/Tag/CloseButton.js");

var _CloseButton2 = _interopRequireDefault(_CloseButton);

var _CloseButtonIcon = __webpack_require__("../node_modules/base-components/build/blocks/Tag/CloseButtonIcon.js");

var _CloseButtonIcon2 = _interopRequireDefault(_CloseButtonIcon);

var _Text = __webpack_require__("../node_modules/base-components/build/blocks/Tag/Text.js");

var _Text2 = _interopRequireDefault(_Text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = function styles(_ref) {
  var theme = _ref.theme;
  return '\n  align-items: center;\n  background-color: ' + theme.colors.base.chrome100 + ';\n  border-radius: ' + theme.dimensions.borderRadius + ';\n  border: 1px solid ' + theme.colors.base.chrome300 + ';\n  box-sizing: border-box;\n  cursor: default;\n  display: inline-flex;\n  justify-content: space-between;\n  min-width: ' + (0, _decisivUiUtils.px2rem)(150) + ';\n  padding: 0 ' + (0, _decisivUiUtils.px2rem)(3) + ' 0 ' + (0, _decisivUiUtils.px2rem)(5) + ';\n\n  &:hover {\n    border: 1px solid ' + theme.colors.base.chrome600 + ';\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome100: _propTypes2.default.string.isRequired,
      chrome300: _propTypes2.default.string.isRequired,
      chrome600: _propTypes2.default.string.isRequired,
      chrome700: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired,
  dimensions: _propTypes2.default.shape({
    borderRadius: _propTypes2.default.string.isRequired
  }).isRequired
};

var Tag = (0, _decisivUiUtils.buildStyledComponent)('Tag', _styledComponents2.default.div, styles, {
  themePropTypes: themePropTypes
});

Tag.CloseButton = _CloseButton2.default;
Tag.CloseButtonIcon = _CloseButtonIcon2.default;
Tag.Text = _Text2.default;

exports.default = Tag;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/Tooltip/Arrow.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _arrow = __webpack_require__("../node_modules/base-components/build/utils/arrow.js");

var _constants = __webpack_require__("../node_modules/base-components/build/blocks/Tooltip/constants.js");

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ARROW_BASE = _constants2.default.ARROW_BASE,
    ARROW_HEIGHT = _constants2.default.ARROW_HEIGHT,
    BOTTOM_ROTATE = _constants2.default.BOTTOM_ROTATE,
    LEFT_ROTATE = _constants2.default.LEFT_ROTATE,
    RIGHT_ROTATE = _constants2.default.RIGHT_ROTATE,
    TOP_ROTATE = _constants2.default.TOP_ROTATE;


var modifierConfig = {
  bottom: function bottom(_ref) {
    var theme = _ref.theme;
    return '\n    background: ' + (0, _arrow.setBackground)(theme.colors.base.chrome700) + ';\n    box-shadow: ' + (0, _arrow.setBoxShadow)('bottom', theme.colors.base.shadowLight) + ';\n    left: 0;\n    margin: auto;\n    right: 0;\n    top: -' + (0, _decisivUiUtils.px2rem)(ARROW_HEIGHT) + ';\n    transform: rotate(' + BOTTOM_ROTATE + 'deg) !important;\n  ';
  },

  left: function left(_ref2) {
    var theme = _ref2.theme;
    return '\n    background: ' + (0, _arrow.setBackground)(theme.colors.base.chrome700) + ';\n    bottom: 0;\n    box-shadow: ' + (0, _arrow.setBoxShadow)('left', theme.colors.base.shadow) + ';\n    margin: auto;\n    right: -' + (0, _decisivUiUtils.px2rem)(ARROW_HEIGHT) + ';\n    top: 0;\n    transform: rotate(' + LEFT_ROTATE + 'deg) !important;\n  ';
  },

  right: function right(_ref3) {
    var theme = _ref3.theme;
    return '\n    background: ' + (0, _arrow.setBackground)(theme.colors.base.chrome700) + ';\n    bottom: 0;\n    box-shadow: ' + (0, _arrow.setBoxShadow)('right', theme.colors.base.shadow) + ';\n    left: -' + (0, _decisivUiUtils.px2rem)(ARROW_HEIGHT) + ';\n    margin: auto;\n    top: 0;\n    transform: rotate(' + RIGHT_ROTATE + 'deg) !important;\n  ';
  },

  top: function top(_ref4) {
    var theme = _ref4.theme;
    return '\n    background: ' + (0, _arrow.setBackground)(theme.colors.base.chrome700) + ';\n    bottom: -' + (0, _decisivUiUtils.px2rem)(ARROW_HEIGHT) + ';\n    box-shadow: ' + (0, _arrow.setBoxShadow)('top', theme.colors.base.shadow) + ';\n    left: 0;\n    margin: auto;\n    right: 0;\n    transform: rotate(' + TOP_ROTATE + 'deg) !important;\n  ';
  }
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome700: _propTypes2.default.string.isRequired,
      shadow: _propTypes2.default.string.isRequired,
      shadowLight: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

var styles = '\n  height: ' + (0, _decisivUiUtils.px2rem)(ARROW_BASE) + ';\n  position: absolute;\n  width: ' + (0, _decisivUiUtils.px2rem)(ARROW_BASE) + ';\n';

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Tooltip__Arrow', _styledComponents2.default.div, styles, {
  modifierConfig: modifierConfig,
  themePropTypes: themePropTypes
});

/***/ }),

/***/ "../node_modules/base-components/build/blocks/Tooltip/Content.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _constants = __webpack_require__("../node_modules/base-components/build/blocks/Tooltip/constants.js");

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ARROW_WIDTH = _constants2.default.ARROW_WIDTH;


var modifierConfig = {
  bottom: function bottom() {
    return '\n    top: calc(100% + ' + (0, _decisivUiUtils.px2rem)(ARROW_WIDTH) + ');\n  ';
  },

  left: function left() {
    return '\n    right: calc(100% + ' + (0, _decisivUiUtils.px2rem)(ARROW_WIDTH) + ');\n  ';
  },

  right: function right() {
    return '\n    left: calc(100% + ' + (0, _decisivUiUtils.px2rem)(ARROW_WIDTH) + ');\n  ';
  },

  top: function top() {
    return '\n    bottom: calc(100% + ' + (0, _decisivUiUtils.px2rem)(ARROW_WIDTH) + ');\n  ';
  }
};

var styles = function styles(_ref) {
  var theme = _ref.theme,
      zIndex = _ref.zIndex;
  return '\n  align-items: center;\n  background-color: ' + theme.colors.base.chrome700 + ';\n  border-radius: ' + theme.dimensions.borderRadius + ';\n  box-shadow: 0 3px 7px 0 ' + theme.colors.base.shadow + ';\n  color: ' + theme.colors.base.chrome000 + ';\n  display: flex;\n  font-size: ' + (0, _decisivUiUtils.px2rem)(12) + ';\n  font-weight: ' + theme.fontWeights.light + ';\n  height: ' + (0, _decisivUiUtils.px2rem)(25) + ';\n  padding: 0 20px;\n  position: absolute;\n  white-space: nowrap;\n  z-index: ' + zIndex + ';\n';
};

var propTypes = {
  zIndex: _propTypes2.default.number
};

var defaultProps = {
  zIndex: 1
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome000: _propTypes2.default.string.isRequired,
      chrome700: _propTypes2.default.string.isRequired,
      shadow: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired,
  dimensions: _propTypes2.default.shape({
    borderRadius: _propTypes2.default.string.isRequired
  }).isRequired,
  fontWeights: _propTypes2.default.shape({
    light: _propTypes2.default.number.isRequired
  }).isRequired
};

var Content = (0, _decisivUiUtils.buildStyledComponent)('Tooltip__Content', _styledComponents2.default.div, styles, {
  defaultProps: defaultProps,
  modifierConfig: modifierConfig,
  propTypes: propTypes,
  themePropTypes: themePropTypes
});

exports.default = Content;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/Tooltip/Target.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = '\n  cursor: default;\n';

var Target = (0, _decisivUiUtils.buildStyledComponent)('Tooltip__Target', _styledComponents2.default.span, styles);

exports.default = Target;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/Tooltip/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _arrow = __webpack_require__("../node_modules/base-components/build/utils/arrow.js");

// Ideally, this should be 12px,
// but because of browser rendering inconsistencies, I added a little buffer.
var ARROW_BASE = 12.5;

// Browsers have issues with partial pixels and cause the Popover Arrow to render
// _slightly_ off. The 1px offset here is to accommodate for that.
var BROWSER_OFFSET = 1;

exports.default = _extends({
  ARROW_BASE: ARROW_BASE,
  BROWSER_OFFSET: BROWSER_OFFSET
}, (0, _arrow.generateConstants)({ ARROW_BASE: ARROW_BASE, BROWSER_OFFSET: BROWSER_OFFSET }));

/***/ }),

/***/ "../node_modules/base-components/build/blocks/Tooltip/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _Arrow = __webpack_require__("../node_modules/base-components/build/blocks/Tooltip/Arrow.js");

var _Arrow2 = _interopRequireDefault(_Arrow);

var _Content = __webpack_require__("../node_modules/base-components/build/blocks/Tooltip/Content.js");

var _Content2 = _interopRequireDefault(_Content);

var _Target = __webpack_require__("../node_modules/base-components/build/blocks/Tooltip/Target.js");

var _Target2 = _interopRequireDefault(_Target);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  bottom: function bottom() {
    return 'justify-content: center;';
  },
  left: function left() {
    return 'align-items: center;';
  },
  right: function right() {
    return 'align-items: center;';
  },
  top: function top() {
    return 'justify-content: center;';
  }
};

var styles = '\n  display: flex;\n  position: relative;\n';

var Tooltip = (0, _decisivUiUtils.buildStyledComponent)('Tooltip', _styledComponents2.default.div, styles, { modifierConfig: modifierConfig });

Tooltip.Arrow = _Arrow2.default;
Tooltip.Content = _Content2.default;
Tooltip.Target = _Target2.default;

exports.default = Tooltip;

/***/ }),

/***/ "../node_modules/base-components/build/blocks/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Accordion = __webpack_require__("../node_modules/base-components/build/blocks/Accordion/index.js");

var _Accordion2 = _interopRequireDefault(_Accordion);

var _Avatar = __webpack_require__("../node_modules/base-components/build/blocks/Avatar/index.js");

var _Avatar2 = _interopRequireDefault(_Avatar);

var _Badge = __webpack_require__("../node_modules/base-components/build/blocks/Badge/index.js");

var _Badge2 = _interopRequireDefault(_Badge);

var _ButtonGroup = __webpack_require__("../node_modules/base-components/build/blocks/ButtonGroup/index.js");

var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);

var _ButtonIconCircle = __webpack_require__("../node_modules/base-components/build/blocks/ButtonIconCircle/index.js");

var _ButtonIconCircle2 = _interopRequireDefault(_ButtonIconCircle);

var _ButtonIconRectangle = __webpack_require__("../node_modules/base-components/build/blocks/ButtonIconRectangle/index.js");

var _ButtonIconRectangle2 = _interopRequireDefault(_ButtonIconRectangle);

var _ButtonSort = __webpack_require__("../node_modules/base-components/build/blocks/ButtonSort/index.js");

var _ButtonSort2 = _interopRequireDefault(_ButtonSort);

var _ButtonToggle = __webpack_require__("../node_modules/base-components/build/blocks/ButtonToggle/index.js");

var _ButtonToggle2 = _interopRequireDefault(_ButtonToggle);

var _Checkbox = __webpack_require__("../node_modules/base-components/build/blocks/Checkbox/index.js");

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _ContainerSelectable = __webpack_require__("../node_modules/base-components/build/blocks/ContainerSelectable/index.js");

var _ContainerSelectable2 = _interopRequireDefault(_ContainerSelectable);

var _Input = __webpack_require__("../node_modules/base-components/build/blocks/Input/index.js");

var _Input2 = _interopRequireDefault(_Input);

var _MessageLarge = __webpack_require__("../node_modules/base-components/build/blocks/MessageLarge/index.js");

var _MessageLarge2 = _interopRequireDefault(_MessageLarge);

var _MessageMedium = __webpack_require__("../node_modules/base-components/build/blocks/MessageMedium/index.js");

var _MessageMedium2 = _interopRequireDefault(_MessageMedium);

var _LeftNav = __webpack_require__("../node_modules/base-components/build/blocks/LeftNav/index.js");

var _LeftNav2 = _interopRequireDefault(_LeftNav);

var _ListTable = __webpack_require__("../node_modules/base-components/build/blocks/ListTable/index.js");

var _ListTable2 = _interopRequireDefault(_ListTable);

var _QuickActionButton = __webpack_require__("../node_modules/base-components/build/blocks/QuickActionButton/index.js");

var _QuickActionButton2 = _interopRequireDefault(_QuickActionButton);

var _TabList = __webpack_require__("../node_modules/base-components/build/blocks/TabList/index.js");

var _TabList2 = _interopRequireDefault(_TabList);

var _Tag = __webpack_require__("../node_modules/base-components/build/blocks/Tag/index.js");

var _Tag2 = _interopRequireDefault(_Tag);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// this is the primary export for Blocks
// The primary export for this library is lib/index.js
module.exports = {
  Accordion: _Accordion2.default,
  Avatar: _Avatar2.default,
  Badge: _Badge2.default,
  ButtonGroup: _ButtonGroup2.default,
  ButtonIconCircle: _ButtonIconCircle2.default,
  ButtonIconRectangle: _ButtonIconRectangle2.default,
  ButtonSort: _ButtonSort2.default,
  ButtonToggle: _ButtonToggle2.default,
  Checkbox: _Checkbox2.default,
  ContainerSelectable: _ContainerSelectable2.default,
  Input: _Input2.default,
  MessageLarge: _MessageLarge2.default,
  MessageMedium: _MessageMedium2.default,
  LeftNav: _LeftNav2.default,
  ListTable: _ListTable2.default,
  QuickActionButton: _QuickActionButton2.default,
  TabList: _TabList2.default,
  Tag: _Tag2.default
};

/***/ }),

/***/ "../node_modules/base-components/build/components/Accordion/Body.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSmoothCollapse = __webpack_require__("../node_modules/base-components/node_modules/react-smooth-collapse/js/index.js");

var _reactSmoothCollapse2 = _interopRequireDefault(_reactSmoothCollapse);

var _constants = __webpack_require__("../node_modules/base-components/build/components/Accordion/constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Body(_ref, context) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, ['children']);

  var expanded = context[_constants.ACCORDION_CONTEXT].expanded;


  return _react2.default.createElement(
    _reactSmoothCollapse2.default,
    _extends({ expanded: expanded }, rest),
    children
  );
}

Body.contextTypes = _defineProperty({}, _constants.ACCORDION_CONTEXT, _propTypes2.default.object.isRequired);

Body.propTypes = {
  children: _propTypes2.default.node.isRequired
};

exports.default = Body;

/***/ }),

/***/ "../node_modules/base-components/build/components/Accordion/Head.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _blocks = __webpack_require__("../node_modules/base-components/build/blocks/index.js");

var _constants = __webpack_require__("../node_modules/base-components/build/components/Accordion/constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Head(_ref, context) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, ['children']);

  var _context$ACCORDION_CO = context[_constants.ACCORDION_CONTEXT],
      expanded = _context$ACCORDION_CO.expanded,
      expand = _context$ACCORDION_CO.expand;


  var icon = expanded ? 'chevron-up' : 'chevron-down';
  return _react2.default.createElement(
    _blocks.Accordion.Head,
    rest,
    children,
    _react2.default.createElement(
      _blocks.ButtonIconRectangle,
      { onClick: expand },
      _react2.default.createElement(_blocks.ButtonIconRectangle.Icon, { name: icon })
    )
  );
}

Head.contextTypes = _defineProperty({}, _constants.ACCORDION_CONTEXT, _propTypes2.default.object.isRequired);

Head.propTypes = {
  children: _propTypes2.default.node.isRequired
};

exports.default = Head;

/***/ }),

/***/ "../node_modules/base-components/build/components/Accordion/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// eslint-disable-next-line import/prefer-default-export
var ACCORDION_CONTEXT = exports.ACCORDION_CONTEXT = '__ACCORDION_CONTEXT__';

/***/ }),

/***/ "../node_modules/base-components/build/components/Accordion/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _blocks = __webpack_require__("../node_modules/base-components/build/blocks/index.js");

var _Head = __webpack_require__("../node_modules/base-components/build/components/Accordion/Head.js");

var _Head2 = _interopRequireDefault(_Head);

var _Body = __webpack_require__("../node_modules/base-components/build/components/Accordion/Body.js");

var _Body2 = _interopRequireDefault(_Body);

var _constants = __webpack_require__("../node_modules/base-components/build/components/Accordion/constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function isExpandControlled(props) {
  return props.expanded !== undefined;
}

var Accordion = function (_Component) {
  _inherits(Accordion, _Component);

  function Accordion() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Accordion);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Accordion.__proto__ || Object.getPrototypeOf(Accordion)).call.apply(_ref, [this].concat(args))), _this), _this.state = { expanded: isExpandControlled(_this.props) ? undefined : true }, _this.expand = function () {
      if (isExpandControlled(_this.props)) {
        _this.props.onExpandedChange({
          name: _this.props.name,
          expanded: !_this.props.expanded
        });
      } else {
        _this.setState({ expanded: !_this.state.expanded }, function () {
          return _this.props.onExpandedChange({
            name: _this.props.name,
            expanded: !_this.state.expanded
          });
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Accordion, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return _defineProperty({}, _constants.ACCORDION_CONTEXT, {
        expand: this.expand,
        expanded: isExpandControlled(this.props) ? this.props.expanded : this.state.expanded
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          disabled = _props.disabled;

      return _react2.default.createElement(
        _blocks.Accordion,
        { modifiers: (0, _lodash.compact)([disabled && 'disabled']) },
        children
      );
    }
  }]);

  return Accordion;
}(_react.Component);

Accordion.Head = _Head2.default;
Accordion.Title = _blocks.Accordion.Title;
Accordion.Body = _Body2.default;
Accordion.modifiers = _blocks.Accordion.modifiers;
Accordion.childContextTypes = _defineProperty({}, _constants.ACCORDION_CONTEXT, _propTypes2.default.object.isRequired);
Accordion.propTypes = {
  children: _propTypes2.default.node.isRequired,
  disabled: _propTypes2.default.bool,
  expanded: _propTypes2.default.bool,
  name: _propTypes2.default.string,
  onExpandedChange: _propTypes2.default.func
};
Accordion.defaultProps = {
  disabled: false,
  expanded: undefined,
  name: '',
  onExpandedChange: _lodash.noop
};
exports.default = Accordion;

/***/ }),

/***/ "../node_modules/base-components/build/components/Avatar/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _blocks = __webpack_require__("../node_modules/base-components/build/blocks/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Avatar = function (_Component) {
  _inherits(Avatar, _Component);

  function Avatar(props) {
    _classCallCheck(this, Avatar);

    var _this = _possibleConstructorReturn(this, (Avatar.__proto__ || Object.getPrototypeOf(Avatar)).call(this, props));

    _this.getInitials = function () {
      var name = _this.props.name;

      return name.split(' ').map(function (n) {
        return n[0];
      }).join('');
    };

    _this.handleGravatarFetchFailed = function () {
      _this.setState({ isGravatarAvailable: false });
    };

    _this.renderContent = function (mainModifiers) {
      var _this$props = _this.props,
          email = _this$props.email,
          name = _this$props.name,
          isCompany = _this$props.isCompany;


      switch (true) {
        case _this.state.isGravatarAvailable:
          return _react2.default.createElement(_blocks.Avatar.Image, {
            email: email,
            onError: _this.handleGravatarFetchFailed,
            small: mainModifiers.includes('small')
          });
        case !!name.length:
          return _react2.default.createElement(
            _blocks.Avatar.Initials,
            { modifiers: mainModifiers },
            _this.getInitials()
          );
        default:
          return _react2.default.createElement(_blocks.Avatar.Icon, {
            modifiers: mainModifiers,
            name: isCompany ? 'building' : 'user'
          });
      }
    };

    _this.state = {
      isGravatarAvailable: false
    };
    return _this;
  }

  _createClass(Avatar, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.props.email) {
        this.setState({
          isGravatarAvailable: true
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.email !== nextProps.email) {
        this.setState({
          isGravatarAvailable: true // Try to load/show gravatar when email changes
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var statusModifiers = [];
      var mainModifiers = [];
      this.props.modifiers.forEach(function (modifier) {
        if (Object.keys(_blocks.Avatar.Status.modifiers).includes(modifier)) {
          statusModifiers.push(modifier);
        } else {
          mainModifiers.push(modifier);
        }
      });

      return _react2.default.createElement(
        _blocks.Avatar,
        { modifiers: mainModifiers },
        this.renderContent(mainModifiers),
        _react2.default.createElement(_blocks.Avatar.Status, { modifiers: statusModifiers })
      );
    }
  }]);

  return Avatar;
}(_react.Component);

Avatar.propTypes = {
  email: _propTypes2.default.string,
  modifiers: _propTypes2.default.arrayOf(_propTypes2.default.string),
  name: _propTypes2.default.string,
  isCompany: _propTypes2.default.bool
};
Avatar.defaultProps = {
  email: '',
  modifiers: [],
  name: '',
  isCompany: false
};


Avatar.modifiers = _extends({}, _blocks.Avatar.modifiers, _blocks.Avatar.Status.modifiers);

exports.default = Avatar;

/***/ }),

/***/ "../node_modules/base-components/build/components/ButtonMicro/Icon.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ButtonMicro = __webpack_require__("../node_modules/base-components/build/blocks/ButtonMicro/index.js");

var _ButtonMicro2 = _interopRequireDefault(_ButtonMicro);

var _modifiers = __webpack_require__("../node_modules/base-components/build/utils/modifiers.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Icon(_ref) {
  var modifiers = _ref.modifiers,
      rest = _objectWithoutProperties(_ref, ['modifiers']);

  var iconModifiers = ['mini'].concat(_toConsumableArray((0, _modifiers.modifiersForComponent)(modifiers, _ButtonMicro2.default.Icon)));
  return _react2.default.createElement(_ButtonMicro2.default.Icon, _extends({ modifiers: iconModifiers }, rest));
}

Icon.propTypes = {
  modifiers: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

Icon.defaultProps = {
  modifiers: []
};

exports.default = Icon;

/***/ }),

/***/ "../node_modules/base-components/build/components/ButtonMicro/Text.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _ButtonMicro = __webpack_require__("../node_modules/base-components/build/blocks/ButtonMicro/index.js");

var _ButtonMicro2 = _interopRequireDefault(_ButtonMicro);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Text(_ref) {
  var modifiers = _ref.modifiers,
      rest = _objectWithoutProperties(_ref, ['modifiers']);

  var textModifiers = (0, _lodash.compact)(['capitalize', 'fontWeightLight', 'small', 'textLight', (0, _lodash.includes)(modifiers, 'active') && 'active']);
  return _react2.default.createElement(_ButtonMicro2.default.Text, _extends({ modifiers: textModifiers }, rest));
}

Text.propTypes = {
  modifiers: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

Text.defaultProps = {
  modifiers: []
};

exports.default = Text;

/***/ }),

/***/ "../node_modules/base-components/build/components/ButtonMicro/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _ButtonMicro = __webpack_require__("../node_modules/base-components/build/blocks/ButtonMicro/index.js");

var _ButtonMicro2 = _interopRequireDefault(_ButtonMicro);

var _modifiers = __webpack_require__("../node_modules/base-components/build/utils/modifiers.js");

var _Icon = __webpack_require__("../node_modules/base-components/build/components/ButtonMicro/Icon.js");

var _Icon2 = _interopRequireDefault(_Icon);

var _Text = __webpack_require__("../node_modules/base-components/build/components/ButtonMicro/Text.js");

var _Text2 = _interopRequireDefault(_Text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BC_BUTTON_MICRO_CONTEXT = '__BC_BUTTON_MICRO_CONTEXT__';

function withButtonMicroProps(WrappedComponent) {
  function WithButtonMicroProps(props, context) {
    var propsFromButtonMicro = context[BC_BUTTON_MICRO_CONTEXT];
    return _react2.default.createElement(WrappedComponent, _extends({}, propsFromButtonMicro, props));
  }

  WithButtonMicroProps.contextTypes = _defineProperty({}, BC_BUTTON_MICRO_CONTEXT, _propTypes2.default.shape({
    modifiers: _propTypes2.default.arrayOf(_propTypes2.default.string)
  }).isRequired);

  WithButtonMicroProps.displayName = 'withButtonMicroProps(' + (WrappedComponent.displayName || WrappedComponent.name || '') + ')';

  return WithButtonMicroProps;
}

var ButtonMicro = function (_Component) {
  _inherits(ButtonMicro, _Component);

  function ButtonMicro() {
    _classCallCheck(this, ButtonMicro);

    return _possibleConstructorReturn(this, (ButtonMicro.__proto__ || Object.getPrototypeOf(ButtonMicro)).apply(this, arguments));
  }

  _createClass(ButtonMicro, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return _defineProperty({}, BC_BUTTON_MICRO_CONTEXT, {
        disabled: this.props.disabled,
        modifiers: this.props.modifiers
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var buttonMicroModifiers = (0, _modifiers.modifiersForComponent)(this.props.modifiers, _ButtonMicro2.default);
      return _react2.default.createElement(_ButtonMicro2.default, _extends({}, this.props, { modifiers: buttonMicroModifiers }));
    }
  }]);

  return ButtonMicro;
}(_react.Component);

ButtonMicro.Icon = withButtonMicroProps(_Icon2.default);
ButtonMicro.Text = withButtonMicroProps(_Text2.default);
ButtonMicro.propTypes = {
  children: _propTypes2.default.node.isRequired,
  disabled: _propTypes2.default.bool,
  modifiers: _propTypes2.default.arrayOf(_propTypes2.default.string)
};
ButtonMicro.defaultProps = {
  disabled: false,
  modifiers: []
};
ButtonMicro.childContextTypes = _defineProperty({}, BC_BUTTON_MICRO_CONTEXT, _propTypes2.default.object.isRequired);
exports.default = ButtonMicro;

/***/ }),

/***/ "../node_modules/base-components/build/components/ButtonToggle/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _ButtonToggle = __webpack_require__("../node_modules/base-components/build/blocks/ButtonToggle/index.js");

var _ButtonToggle2 = _interopRequireDefault(_ButtonToggle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OptionLabel = _ButtonToggle2.default.OptionLabel,
    Bar = _ButtonToggle2.default.Bar,
    Switch = _ButtonToggle2.default.Switch,
    Checkbox = _ButtonToggle2.default.Checkbox,
    Content = _ButtonToggle2.default.Content;

var ButtonToggle = function (_Component) {
  _inherits(ButtonToggle, _Component);

  function ButtonToggle() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ButtonToggle);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ButtonToggle.__proto__ || Object.getPrototypeOf(ButtonToggle)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      options: []
    }, _this.cloneOption = function (option, isDefaultOption) {
      return _react2.default.cloneElement(option, {
        modifiers: [isDefaultOption ? 'active' : 'inactive']
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ButtonToggle, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.parseChildren();
    }
  }, {
    key: 'parseChildren',
    value: function parseChildren() {
      var options = [];
      _react2.default.Children.forEach(this.props.children, function (child) {
        if (child.type === OptionLabel) {
          options.push(child);
        }
      });
      this.setState({ options: options });
    }
  }, {
    key: 'renderButtonContent',
    value: function renderButtonContent() {
      if (!this.state.options.length) {
        return null;
      }

      return _react2.default.createElement(
        Content,
        null,
        this.cloneOption(this.state.options[0], !this.props.on),
        _react2.default.createElement(
          Bar,
          null,
          _react2.default.createElement(Switch, { modifiers: (0, _lodash.compact)([this.props.on && 'on']) })
        ),
        this.cloneOption(this.state.options[1], this.props.on)
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          disabled = _props.disabled,
          on = _props.on,
          _onClick = _props.onClick;


      return _react2.default.createElement(
        _ButtonToggle2.default,
        { modifiers: (0, _lodash.compact)([disabled && 'disabled']), onClick: function onClick() {
            return _onClick(on);
          } },
        _react2.default.createElement(Checkbox, { checked: on, disabled: disabled, onChange: function onChange() {
            return _onClick(on);
          } }),
        this.renderButtonContent()
      );
    }
  }]);

  return ButtonToggle;
}(_react.Component);

ButtonToggle.propTypes = {
  children: _propTypes2.default.node.isRequired,
  disabled: _propTypes2.default.bool,
  on: _propTypes2.default.bool,
  onClick: _propTypes2.default.func
};
ButtonToggle.defaultProps = {
  disabled: false,
  on: true,
  onClick: _lodash.noop
};


ButtonToggle.OnLabel = OptionLabel;
ButtonToggle.OffLabel = OptionLabel;

exports.default = ButtonToggle;

/***/ }),

/***/ "../node_modules/base-components/build/components/Checkbox/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _blocks = __webpack_require__("../node_modules/base-components/build/blocks/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Checkbox(_ref) {
  var id = _ref.id,
      checked = _ref.checked,
      disabled = _ref.disabled,
      label = _ref.label,
      rest = _objectWithoutProperties(_ref, ['id', 'checked', 'disabled', 'label']);

  return _react2.default.createElement(
    _blocks.Checkbox,
    { modifiers: (0, _lodash.compact)([disabled && 'disabled']) },
    _react2.default.createElement(_blocks.Checkbox.Input, _extends({ id: id, checked: checked }, rest)),
    _react2.default.createElement(
      _blocks.Checkbox.Label,
      {
        htmlFor: id,
        modifiers: (0, _lodash.compact)([checked && 'text', label && 'withContent'])
      },
      label
    )
  );
}

Checkbox.propTypes = {
  id: _propTypes2.default.string.isRequired,
  checked: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])
};

Checkbox.defaultProps = {
  checked: false,
  disabled: false,
  label: undefined
};

exports.default = Checkbox;

/***/ }),

/***/ "../node_modules/base-components/build/components/DateSelectors/Calendars/Month.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Month = Month;

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactiveContainer = __webpack_require__("../node_modules/reactive-container/dist/index.js");

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/base-components/node_modules/styled-components-reactive-grid/dist/index.js");

var _Calendar = __webpack_require__("../node_modules/base-components/build/blocks/Calendar/index.js");

var _Calendar2 = _interopRequireDefault(_Calendar);

var _QuickActionButton = __webpack_require__("../node_modules/base-components/build/blocks/QuickActionButton/index.js");

var _QuickActionButton2 = _interopRequireDefault(_QuickActionButton);

var _P = __webpack_require__("../node_modules/base-components/build/elements/P/index.js");

var _P2 = _interopRequireDefault(_P);

var _DateGrid = __webpack_require__("../node_modules/base-components/build/components/DateSelectors/DateGrid/index.js");

var _DateGrid2 = _interopRequireDefault(_DateGrid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO: Determine a way to implement translations
var MONTHS = {
  1: 'January',
  2: 'February',
  3: 'March',
  4: 'April',
  5: 'May',
  6: 'June',
  7: 'July',
  8: 'August',
  9: 'September',
  10: 'October',
  11: 'November',
  12: 'December'
};

/**
 * Creates a responsive month display for the Calendar component.
 */
function Month(_ref) {
  var disabledDates = _ref.disabledDates,
      displayMonth = _ref.displayMonth,
      hoveredOverDate = _ref.hoveredOverDate,
      index = _ref.index,
      multiMonth = _ref.multiMonth,
      onClickNext = _ref.onClickNext,
      onClickPrevious = _ref.onClickPrevious,
      onSelectDate = _ref.onSelectDate,
      range = _ref.range,
      selectedDate = _ref.selectedDate,
      selectedDateRange = _ref.selectedDateRange,
      size = _ref.size,
      today = _ref.today,
      updateHoveredOverDate = _ref.updateHoveredOverDate;

  // Evaluates the provided props and determines if the second month should be displayed.
  var hideSecondMonth = index !== 0 && size === 'XS';
  if (hideSecondMonth) {
    return null;
  }

  // Evaluates the provided props to determine which month navigation buttons to display.
  var displayPreviousNav = index === 0;
  var displayNextNav = !!(size === 'XS' || index === 0 && !multiMonth || index !== 0 && size !== 'XS');

  return _react2.default.createElement(
    _styledComponentsReactiveGrid.Column,
    { modifiers: ['col', 'fluid'] },
    _react2.default.createElement(
      _Calendar2.default,
      null,
      _react2.default.createElement(
        _styledComponentsReactiveGrid.Row,
        { modifiers: ['middle'] },
        _react2.default.createElement(
          _styledComponentsReactiveGrid.Column,
          { modifiers: ['col_2'] },
          displayPreviousNav && _react2.default.createElement(
            _QuickActionButton2.default,
            {
              className: 'previous-month-nav',
              modifiers: ['iconOnly'],
              onClick: onClickPrevious
            },
            _react2.default.createElement(_QuickActionButton2.default.Icon, { name: 'angle-left' })
          )
        ),
        _react2.default.createElement(
          _styledComponentsReactiveGrid.Column,
          { modifiers: ['center', 'col', 'padScaleY_4'] },
          _react2.default.createElement(
            _P2.default,
            null,
            MONTHS[displayMonth.month] + ' ' + displayMonth.year
          )
        ),
        _react2.default.createElement(
          _styledComponentsReactiveGrid.Column,
          { modifiers: ['col_2', 'end'] },
          displayNextNav && _react2.default.createElement(
            _QuickActionButton2.default,
            {
              className: 'next-month-nav',
              modifiers: ['iconOnly'],
              onClick: onClickNext
            },
            _react2.default.createElement(_QuickActionButton2.default.Icon, { name: 'angle-right' })
          )
        )
      ),
      _react2.default.createElement(_DateGrid2.default, {
        disabledDates: disabledDates,
        displayMonth: displayMonth,
        hoveredOverDate: hoveredOverDate,
        onSelectDate: onSelectDate,
        range: range,
        selectedDate: selectedDate,
        selectedDateRange: selectedDateRange,
        today: today,
        updateHoveredOverDate: updateHoveredOverDate
      })
    )
  );
}

Month.propTypes = {
  disabledDates: _propTypes2.default.shape({
    after: _propTypes2.default.instanceOf(Date),
    before: _propTypes2.default.instanceOf(Date)
  }),
  displayMonth: _propTypes2.default.shape({
    year: _propTypes2.default.number.isRequired,
    month: _propTypes2.default.number.isRequired,
    daysInMonth: _propTypes2.default.number.isRequired
  }).isRequired,
  hoveredOverDate: _propTypes2.default.instanceOf(Date),
  index: _propTypes2.default.number.isRequired,
  multiMonth: _propTypes2.default.bool,
  onClickNext: _propTypes2.default.func.isRequired,
  onClickPrevious: _propTypes2.default.func.isRequired,
  onSelectDate: _propTypes2.default.func.isRequired,
  range: _propTypes2.default.bool,
  selectedDate: _propTypes2.default.instanceOf(Date),
  selectedDateRange: _propTypes2.default.shape({
    from: _propTypes2.default.instanceOf(Date),
    to: _propTypes2.default.instanceOf(Date)
  }),
  size: _propTypes2.default.oneOf(['XS', 'LG']).isRequired,
  today: _propTypes2.default.shape({
    year: _propTypes2.default.number.isRequired,
    month: _propTypes2.default.number.isRequired,
    date: _propTypes2.default.number.isRequired
  }).isRequired,
  updateHoveredOverDate: _propTypes2.default.func.isRequired
};

Month.defaultProps = {
  disabledDates: {},
  hoveredOverDate: null,
  multiMonth: false,
  range: false,
  selectedDate: null,
  selectedDateRange: {}
};

var MonthWithSize = (0, _reactiveContainer.withSize)(Month);

MonthWithSize.displayName = 'Month';

exports.default = MonthWithSize;

/***/ }),

/***/ "../node_modules/base-components/build/components/DateSelectors/Calendars/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/base-components/node_modules/styled-components-reactive-grid/dist/index.js");

var _Month = __webpack_require__("../node_modules/base-components/build/components/DateSelectors/Calendars/Month.js");

var _Month2 = _interopRequireDefault(_Month);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MIN_CALENDAR_WIDTH = 344;

var BREAKPOINTS = [{ name: 'LG', minWidth: MIN_CALENDAR_WIDTH * 2 }];

/**
 * Evaluates and returns the number of days in the month of the provided JS date. Compensates for
 * leap years.
 * @param  {Date}   jsDate The date to find the days in the month of.
 * @return {Number}        The number of days in the month of the provided date.
 */
function getDaysInMonth(jsDate) {
  // This creates a date that is the last day of the month of the provided date,
  // ... because JavaScript.
  var date = new Date(jsDate.getYear(), jsDate.getMonth() + 1, 0);
  return date.getDate();
}

/**
 * Generates a displayMonth object for ingestion by the DateGrid.
 * @param    {Date|displayMonth} date          Can be either a JavaScript Date object or
 *                                             displayMonth object.
 * @param    {Object}            options       An optional object with options for this function.
 * @property {String}            options.type  Accepted values ['previous', 'next'].
 *                                             Increments or decrements the displayMonth.
 * @return   {Object             A displayMonth object. Fields: ['year', 'month', 'daysInMonth']
 */
function buildDisplayMonth(date) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type;

  // Ensures we are working with the correct JavaScript date object.
  var jsDate = date instanceof Date ? date : new Date(date.year, date.month - 1, 1);

  // Increments or decrements the month being built based on the "type" option.
  switch (type) {
    case 'previous':
      // jsDate objects are mutable. So impure.
      jsDate.setMonth(jsDate.getMonth() - 1);
      break;
    case 'next':
      jsDate.setMonth(jsDate.getMonth() + 1);
      break;
    default:
      break;
  }

  return {
    year: jsDate.getFullYear(),
    month: jsDate.getMonth() + 1,
    daysInMonth: getDaysInMonth(jsDate)
  };
}

/**
 * Builds an array of display months reflecting the months that may currently be displayed.
 * @param  {Array<displayMonth>}  startArr           The initial collection of displayMonths
 * @param  {Boolean}              [multiMonth=false] A flag that indicates additional months should
 *                                                   be added
 * @return {Array<displayMonth} the final collection of displayMonths
 */
function buildDisplayMonthsArr(startArr) {
  var multiMonth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (multiMonth) {
    var latestDisplayMonth = startArr[startArr.length - 1];
    var nextDisplayMonth = buildDisplayMonth(latestDisplayMonth, { type: 'next' });
    var newDisplayMonthsArr = startArr.concat(nextDisplayMonth);
    return buildDisplayMonthsArr(newDisplayMonthsArr);
  }
  return startArr;
}

var Calendars = function (_Component) {
  _inherits(Calendars, _Component);

  function Calendars() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, Calendars);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Calendars.__proto__ || Object.getPrototypeOf(Calendars)).call.apply(_ref2, [this].concat(args))), _this), _this.state = function () {
      var today = new Date();
      var firstDisplayMonth = buildDisplayMonth(today);
      var displayMonthsArr = buildDisplayMonthsArr([firstDisplayMonth], _this.props.multiMonth);

      return {
        displayMonthsArr: displayMonthsArr,
        hoveredOverDate: null,
        today: {
          year: today.getFullYear(),
          month: today.getMonth() + 1,
          date: today.getDate()
        }
      };
    }(), _this.displayPreviousMonth = function () {
      var firstDisplayMonth = buildDisplayMonth(_this.state.displayMonthsArr[0], { type: 'previous' });
      var displayMonthsArr = buildDisplayMonthsArr([firstDisplayMonth], _this.props.multiMonth);
      _this.setState({ displayMonthsArr: displayMonthsArr });
    }, _this.displayNextMonth = function () {
      var firstDisplayMonth = buildDisplayMonth(_this.state.displayMonthsArr[0], { type: 'next' });
      var displayMonthsArr = buildDisplayMonthsArr([firstDisplayMonth], _this.props.multiMonth);
      _this.setState({ displayMonthsArr: displayMonthsArr });
    }, _this.updateHoveredOverDate = function (date) {
      if (_this.props.range && !_this.props.selectedDateRange.to) {
        _this.setState({ hoveredOverDate: date });
      }
    }, _this.buildMonths = function () {
      return _this.state.displayMonthsArr.map(function (displayMonth, index) {
        return _react2.default.createElement(_Month2.default, {
          key: 'monthIndex-' + index,
          disabledDates: _this.props.disabledDates,
          displayMonth: displayMonth,
          hoveredOverDate: _this.state.hoveredOverDate,
          index: index,
          multiMonth: _this.props.multiMonth,
          onClickNext: _this.displayNextMonth,
          onClickPrevious: _this.displayPreviousMonth,
          onSelectDate: _this.props.onSelectDate,
          range: _this.props.range,
          selectedDate: _this.props.selectedDate,
          selectedDateRange: _this.props.selectedDateRange,
          today: _this.state.today,
          updateHoveredOverDate: _this.updateHoveredOverDate
        });
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // Initial state is set to the return value of this IIFE.


  _createClass(Calendars, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // Clear the value of hoveredOverDate when a "to" selection is made
      if (this.props.range && nextProps.selectedDateRange.to && !this.props.selectedDateRange.to) {
        this.setState({ hoveredOverDate: null });
      }
    }

    /**
     * Handles the navigation to earlier months.
     */


    /**
     * Handles the navigation to later months
     */


    /**
     * Handles updating the hoveredOverDate when the user moves the cursor
     * @param  {Date} date the date the cursor is currently hovered over
     */


    /**
     * Maps over the available displayMonths and returns the Months.
     */

  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _styledComponentsReactiveGrid.ReactiveContainer,
        {
          breakpoints: BREAKPOINTS,
          className: 'CalendarsContainer',
          modifiers: ['fluid']
        },
        _react2.default.createElement(
          _styledComponentsReactiveGrid.Row,
          { style: { flexWrap: 'nowrap' } },
          this.buildMonths()
        )
      );
    }
  }]);

  return Calendars;
}(_react.Component);

Calendars.propTypes = {
  disabledDates: _propTypes2.default.shape({
    after: _propTypes2.default.instanceOf(Date),
    before: _propTypes2.default.instanceOf(Date)
  }),
  multiMonth: _propTypes2.default.bool,
  onSelectDate: _propTypes2.default.func.isRequired,
  range: _propTypes2.default.bool,
  selectedDate: _propTypes2.default.instanceOf(Date),
  selectedDateRange: _propTypes2.default.shape({
    from: _propTypes2.default.instanceOf(Date),
    to: _propTypes2.default.instanceOf(Date)
  })
};
Calendars.defaultProps = {
  disabledDates: {},
  multiMonth: false,
  range: false,
  selectedDate: null,
  selectedDateRange: {}
};


Calendars.displayName = 'Calendars';

exports.default = Calendars;

/***/ }),

/***/ "../node_modules/base-components/build/components/DateSelectors/DateGrid/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactFontawesome = __webpack_require__("../node_modules/react-fontawesome/lib/index.js");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/base-components/node_modules/styled-components-reactive-grid/dist/index.js");

var _Calendar = __webpack_require__("../node_modules/base-components/build/blocks/Calendar/index.js");

var _Calendar2 = _interopRequireDefault(_Calendar);

var _P = __webpack_require__("../node_modules/base-components/build/elements/P/index.js");

var _P2 = _interopRequireDefault(_P);

var _utils = __webpack_require__("../node_modules/base-components/build/components/DateSelectors/utils.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// TODO: Determine a way to implement translations
var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

var DateGrid = function (_Component) {
  _inherits(DateGrid, _Component);

  function DateGrid() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DateGrid);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DateGrid.__proto__ || Object.getPrototypeOf(DateGrid)).call.apply(_ref, [this].concat(args))), _this), _this.isDateDisabled = function (disabledDates, dateToTest) {
      return !!((0, _utils.isBeforeDate)(disabledDates.before, dateToTest) || (0, _utils.isAfterDate)(disabledDates.after, dateToTest));
    }, _this.isDateInRange = function (selectedDateRange, hoveredOverDate, dateToTest) {
      return !!(selectedDateRange.from && (selectedDateRange.to && (0, _utils.isBetweenDates)(selectedDateRange.from, selectedDateRange.to, dateToTest) || hoveredOverDate && (0, _utils.isBetweenDates)(hoveredOverDate, selectedDateRange.from, dateToTest)) || !selectedDateRange.to && hoveredOverDate && (0, _utils.isBetweenDates)(selectedDateRange.from, hoveredOverDate, dateToTest));
    }, _this.isDateSelected = function (date) {
      return !!(_this.props.range && ((0, _utils.isSameDate)(date, _this.props.selectedDateRange.from) || (0, _utils.isSameDate)(date, _this.props.selectedDateRange.to)) || !_this.props.range && (0, _utils.isSameDate)(date, _this.props.selectedDate));
    }, _this.handleSelectDate = function (date) {
      if (_this.isDateSelected(date)) {
        _this.props.onSelectDate(null, date);
      } else {
        _this.props.onSelectDate(date, date);
      }
    }, _this.isBuildingToday = function (date) {
      return !!(_this.props.today.year === _this.props.displayMonth.year && _this.props.today.month === _this.props.displayMonth.month && _this.props.today.date === date);
    }, _this.buildDate = function (date, index) {
      var jsDate = new Date(_this.props.displayMonth.year, _this.props.displayMonth.month - 1, date);

      var dateTableCellModifiers = (0, _lodash.compact)([date && 'withBorder']);

      var dateDisabled = _this.isDateDisabled(_this.props.disabledDates, jsDate);
      var dateInRange = _this.props.range && _this.isDateInRange(_this.props.selectedDateRange, _this.props.hoveredOverDate, jsDate);
      var dateSelected = _this.isDateSelected(jsDate);

      var dateModifiers = (0, _lodash.compact)([dateDisabled && 'disabled', dateInRange && 'inRange', dateSelected && 'selected']);

      return _react2.default.createElement(
        _Calendar2.default.DateTableCell,
        {
          key: 'dayIndex-' + index,
          modifiers: dateTableCellModifiers
        },
        date && _react2.default.createElement(
          _Calendar2.default.Date,
          {
            disabled: dateDisabled,
            modifiers: dateModifiers,
            onMouseEnter: function onMouseEnter() {
              return !dateDisabled && _this.props.updateHoveredOverDate(jsDate);
            },
            onMouseLeave: function onMouseLeave() {
              return _this.props.updateHoveredOverDate(null);
            },
            onClick: function onClick() {
              return _this.handleSelectDate(jsDate);
            }
          },
          _react2.default.createElement(
            'div',
            null,
            date
          ),
          _react2.default.createElement(
            'div',
            null,
            _this.isBuildingToday(date) && _react2.default.createElement(_reactFontawesome2.default, { name: 'circle' })
          )
        )
      );
    }, _this.buildWeek = function (week, index) {
      return _react2.default.createElement(
        _Calendar2.default.DateTableRow,
        { key: 'week-' + index },
        week.map(function (date, dateIndex) {
          return _this.buildDate(date, dateIndex);
        })
      );
    }, _this.buildWeeks = function (displayMonth) {
      // This gets the index of the first of the month within the first week. Ex, if the first is a
      // Wednesday, the firstDayIndex will be 4.
      var firstDayIndex = (0, _utils.getFirstDayOfMonthIndex)(displayMonth);

      // This creates an incrementing array the length of the days in the month
      // plus the days in the first week that are not a part of this month.
      var daysInCalendar = [].concat(_toConsumableArray(Array(displayMonth.daysInMonth + firstDayIndex).keys()));

      // Converts array the length of the total days in the calendar into an array of weeks with
      // properly indexed dates.
      return daysInCalendar.reduce(function (acc, index) {
        // Evaluates the index to determine if this should be the start of a new week.
        var buildingNewWeek = index % 7 === 0;

        // Evaluates whether the current index refers to one of the days before this month begins
        var buildingCurrentMonth = firstDayIndex <= index;

        // Creates the correct date for this index, or null
        var dateVal = buildingCurrentMonth ? index - firstDayIndex + 1 : null;

        // If the current index is the first in the week, adds a new array with the correct date at
        // index 0
        if (buildingNewWeek) {
          var newWeek = [dateVal];
          return [].concat(_toConsumableArray(acc), [newWeek]);
        }

        // If the current index is not the first in the week, appends the correct date to the last
        // week array.
        acc[acc.length - 1].push(dateVal);
        return acc;
      }, []);
    }, _this.buildDateTable = function () {
      return _react2.default.createElement(
        _Calendar2.default.DateTable,
        null,
        _react2.default.createElement(
          'tbody',
          null,
          _this.buildWeeks(_this.props.displayMonth).map(function (week, index) {
            return _this.buildWeek(week, index);
          })
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  /**
   * Evaluates whether the provided date falls within a disabled date range (provided via props)
   * @param    {Object}  disabledDates        Contains data concerning the dates to be disabled.
   * @property {Date}    disabledDates.before All dates before this date are disabled.
   * @property {Date}    disabledDates.after  All dates after this date are disabled.
   * @param    {Date}    dateToTest           The date to test
   * @return   {Boolean}
   */


  /**
   * Evaluates whether the provided date is between two selected dates, or between the selected
   * date and the currently hovered over date.
   * @param    {Object}  selectedDateRange        Contains data concerning the dates to be disabled.
   * @property {Date}    selectedDateRange.from   All dates before this date are disabled.
   * @property {Date}    selectedDateRange.to     All dates after this date are disabled.
   * @param    {Date}    hoveredOverDate          The date the cursor is currently over.
   * @param    {Date}    dateToTest               The date to test
   * @return   {Boolean}
   */


  /**
   * Evaluates whether the provided date is one of the currently selected dates.
   * @param  {Date}    date The date to test
   * @return {Boolean}
   */


  /**
   * Handles the click event on a date. Calls `onSelectDate` from props with the args,
   * [newSelectedDate, dateClicked]
   * @param  {Date} date The date that was clicked
   */


  /**
   * Evaluates whether the date currently being built is today. Time doesn't matter.
   * @param  {Date}    date The date to test
   * @return {Boolean}
   */


  /**
   * Builds a single, correctly styled date for display within the calendar grid.
   * @param  {Number}    date  The date number in the month to build. Ex, the first would be 1.
   * @param  {Number}    index The index of the date within the week. Ex, Sunday would be 0.
   * @return {Component} A fully built JSX DateTableCell, ready to render.
   */


  /**
   * Builds a single row for display within the calendar grid.
   * @param  {Array<Number>} week  An array of numbers, representing the dates to display in the
   *                               week.
   * @param  {Number}        index The index of the week within the month.
   * @return {Component} A fully built JSX DateTableRow, ready to render.
   */


  /**
   * Evaluates the provided displayMonth to determine how many weeks the month spans, and what
   * position within those weeks the dates should be in.
   * @param    {Object} displayMonth             a displayMonth Object
   * @property {Number} displayMonth.daysInMonth the total number of days in this month
   * @return {Array<Array>} An array of arrays representing the weeks the month touches populated
   * with the dates in the correct indexes. `null` is present for indexes that do not correspond to
   * dates for this month.
   */


  /**
   * Builds a calendar grid for display.
   * @return {Component} A fully built JSX DateTable, ready to render.
   */


  _createClass(DateGrid, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _styledComponentsReactiveGrid.Container,
        null,
        _react2.default.createElement(
          _styledComponentsReactiveGrid.Row,
          null,
          DAYS.map(function (day) {
            return _react2.default.createElement(
              _styledComponentsReactiveGrid.Column,
              { key: day, modifiers: ['center', 'col', 'padScale_0'] },
              _react2.default.createElement(
                _P2.default,
                { modifiers: ['small'] },
                day
              )
            );
          })
        ),
        _react2.default.createElement(
          _styledComponentsReactiveGrid.Row,
          null,
          this.buildDateTable()
        )
      );
    }
  }]);

  return DateGrid;
}(_react.Component);

DateGrid.propTypes = {
  disabledDates: _propTypes2.default.shape({
    after: _propTypes2.default.instanceOf(Date),
    before: _propTypes2.default.instanceOf(Date)
  }),
  displayMonth: _propTypes2.default.shape({
    year: _propTypes2.default.number.isRequired,
    month: _propTypes2.default.number.isRequired,
    daysInMonth: _propTypes2.default.number.isRequired
  }).isRequired,
  hoveredOverDate: _propTypes2.default.instanceOf(Date),
  onSelectDate: _propTypes2.default.func.isRequired,
  range: _propTypes2.default.bool,
  selectedDate: _propTypes2.default.instanceOf(Date),
  selectedDateRange: _propTypes2.default.shape({
    from: _propTypes2.default.instanceOf(Date),
    to: _propTypes2.default.instanceOf(Date)
  }),
  today: _propTypes2.default.shape({
    year: _propTypes2.default.number.isRequired,
    month: _propTypes2.default.number.isRequired,
    date: _propTypes2.default.number.isRequired
  }).isRequired,
  updateHoveredOverDate: _propTypes2.default.func.isRequired
};
DateGrid.defaultProps = {
  disabledDates: {},
  hoveredOverDate: null,
  range: false,
  selectedDate: null,
  selectedDateRange: {}
};
exports.default = DateGrid;

/***/ }),

/***/ "../node_modules/base-components/build/components/DateSelectors/DateRangeSelector.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.buildDateRange = buildDateRange;

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _Calendars = __webpack_require__("../node_modules/base-components/build/components/DateSelectors/Calendars/index.js");

var _Calendars2 = _interopRequireDefault(_Calendars);

var _utils = __webpack_require__("../node_modules/base-components/build/components/DateSelectors/utils.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Builds a selectedDateRange based on the current date range and the date clicked
 * @param    {Object}    currentDateRange      The current date range.
 * @property {Date|null} currentDateRange.from The from date currently selected
 * @property {Date|null} currentDateRange.to   The to date currently selected
 * @param    {Date|null} newDate               The newDate to set in the range.
 * @param    {Date}      dateClicked           The date that was actually clicked.
 * @return   {Object}    The new date range. Keys ['from', 'to'].
 */
function buildDateRange(currentDateRange, newDate, dateClicked) {
  // Creates an array with the dates. Useful for sorting.
  var currentDatesArr = (0, _lodash.compact)([currentDateRange.from, currentDateRange.to]);

  // Based on the present values, create a new array of dates.
  var newDatesArr = function () {
    if (!newDate) {
      // newDate will be null if the dateClicked is already selected.
      return (0, _lodash.compact)(currentDatesArr.map(function (date) {
        if (!(0, _utils.isSameDate)(date, dateClicked)) {
          return date;
        }
        return undefined;
      }));
    }

    if ((0, _lodash.isEmpty)(currentDatesArr)) {
      // no dates have yet been selected
      return [newDate];
    }

    if ((0, _utils.isBeforeDate)(currentDatesArr[0], newDate)) {
      // newDate should replace the `from` date.
      return [newDate, currentDatesArr[0]];
    }

    if ((0, _utils.isAfterDate)(currentDatesArr[0], newDate)) {
      // newDate should replace the `to` date.
      return [currentDatesArr[0], newDate];
    }

    // Failsafe
    return [];
  }();

  // Create the object based on the sorted dates in the array.
  return (0, _lodash.zipObject)(['from', 'to'], newDatesArr);
}

var DateRangeSelector = function (_Component) {
  _inherits(DateRangeSelector, _Component);

  function DateRangeSelector() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DateRangeSelector);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DateRangeSelector.__proto__ || Object.getPrototypeOf(DateRangeSelector)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      selectedDateRange: _this.props.selectedDateRange || {}
    }, _this.handleSelectDate = function (selectedDate, dateClicked) {
      var selectedDateRange = buildDateRange(_this.state.selectedDateRange, selectedDate, dateClicked);

      _this.setState({ selectedDateRange: selectedDateRange });
      _this.props.onSelectDate(selectedDateRange);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  /**
   * Handle clicking a date in the calendar grid. Calls `this.props.onSelectDate` with the current
   * selected date range.
   * @param  {Date|null} selectedDate The new date to add to the range
   * @param  {Date} dateClicked The actual date that was clicked.
   */


  _createClass(DateRangeSelector, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_Calendars2.default, {
        disabledDates: this.props.disabledDates,
        multiMonth: this.props.multiMonth,
        onSelectDate: this.handleSelectDate,
        range: true,
        selectedDateRange: this.props.selectedDateRange || this.state.selectedDateRange
      });
    }
  }]);

  return DateRangeSelector;
}(_react.Component);

DateRangeSelector.propTypes = {
  disabledDates: _propTypes2.default.shape({
    after: _propTypes2.default.instanceOf(Date),
    before: _propTypes2.default.instanceOf(Date)
  }),
  multiMonth: _propTypes2.default.bool,
  onSelectDate: _propTypes2.default.func.isRequired,
  selectedDateRange: _propTypes2.default.shape({
    from: _propTypes2.default.instanceOf(Date),
    to: _propTypes2.default.instanceOf(Date)
  })
};
DateRangeSelector.defaultProps = {
  disabledDates: {},
  multiMonth: false,
  selectedDateRange: null
};
exports.default = DateRangeSelector;

/***/ }),

/***/ "../node_modules/base-components/build/components/DateSelectors/DateSelector.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _Calendars = __webpack_require__("../node_modules/base-components/build/components/DateSelectors/Calendars/index.js");

var _Calendars2 = _interopRequireDefault(_Calendars);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DateSelector = function (_Component) {
  _inherits(DateSelector, _Component);

  function DateSelector() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DateSelector);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DateSelector.__proto__ || Object.getPrototypeOf(DateSelector)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      selectedDate: _this.props.selectedDate || null
    }, _this.handleSelectDate = function (selectedDate) {
      _this.setState({ selectedDate: selectedDate });
      _this.props.onSelectDate(selectedDate);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  /**
   * Handle clicking a date in the calendar grid. Calls `this.props.onSelectDate` with the current
   * selected date.
   * @param  {Date|null} selectedDate The new date selected.
   */


  _createClass(DateSelector, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_Calendars2.default, {
        disabledDates: this.props.disabledDates,
        multiMonth: this.props.multiMonth,
        onSelectDate: this.handleSelectDate,
        selectedDate: this.props.selectedDate || this.state.selectedDate
      });
    }
  }]);

  return DateSelector;
}(_react.Component);

DateSelector.propTypes = {
  disabledDates: _propTypes2.default.shape({
    after: _propTypes2.default.instanceOf(Date),
    before: _propTypes2.default.instanceOf(Date)
  }),
  multiMonth: _propTypes2.default.bool,
  onSelectDate: _propTypes2.default.func.isRequired,
  selectedDate: _propTypes2.default.instanceOf(Date)
};
DateSelector.defaultProps = {
  disabledDates: {},
  multiMonth: false,
  selectedDate: null
};
exports.default = DateSelector;

/***/ }),

/***/ "../node_modules/base-components/build/components/DateSelectors/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _DateRangeSelector = __webpack_require__("../node_modules/base-components/build/components/DateSelectors/DateRangeSelector.js");

var _DateRangeSelector2 = _interopRequireDefault(_DateRangeSelector);

var _DateSelector = __webpack_require__("../node_modules/base-components/build/components/DateSelectors/DateSelector.js");

var _DateSelector2 = _interopRequireDefault(_DateSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  DateRangeSelector: _DateRangeSelector2.default,
  DateSelector: _DateSelector2.default
};

/***/ }),

/***/ "../node_modules/base-components/build/components/DateSelectors/utils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFirstDayOfMonthIndex = getFirstDayOfMonthIndex;
exports.isSameDate = isSameDate;
exports.isAfterDate = isAfterDate;
exports.isBeforeDate = isBeforeDate;
exports.isBetweenDates = isBetweenDates;
/**
 * Evaluates a displayMonth to determine the index of the first day within the first
 * week of the month.
 * @param    {Object} displayMonth             a displayMonth Object
 * @property {Number} displayMonth.year        the full year of the displayed month
 * @property {Number} displayMonth.month       the month of the displayed month
 *                                             (as it would be written in a normal date)
 * @property {Number} displayMonth.daysInMonth the total number of days in this month
 * @return   {Number}                          the index of the first day within the first week
 *                                             of the month
 */
function getFirstDayOfMonthIndex(displayMonth) {
  var date = new Date(displayMonth.year, displayMonth.month - 1, 1);
  return date.getDay();
}

/**
 * Evaluates two JavaScript Dates for existence and similarity. Time doesn't matter, only dates.
 * @param  {Date}    date1 A JavaScript Date
 * @param  {Date}    date2 A JavaScript Date
 * @return {Boolean}       If both dates exist and have the same year, month, and date.
 */
function isSameDate(date1, date2) {
  return !!(date1 && date2 && date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate());
}

/**
 * Evaluates two JavaScript Dates for existence and order. Time doesn't matter, only dates.
 * @param  {Date}    setDate    The date to use as the base
 * @param  {Date}    dateToTest The date to evaluate
 * @return {Boolean}            If both dates exist and the dateToTest is after the setDate.
 */
function isAfterDate(setDate, dateToTest) {
  return !!(setDate && dateToTest && setDate < dateToTest && !isSameDate(setDate, dateToTest));
}

/**
 * Evaluates two JavaScript Dates for existence and order. Time doesn't matter, only dates.
 * @param  {Date}    setDate    The date to use as the base
 * @param  {Date}    dateToTest The date to evaluate
 * @return {Boolean}            If both dates exist and the dateToTest is before the setDate.
 */
function isBeforeDate(setDate, dateToTest) {
  return !!(setDate && dateToTest && setDate > dateToTest && !isSameDate(setDate, dateToTest));
}

/**
 * Evaluates three JavaScript Dates for existence and order. Time doesn't matter, only dates.
 * @param  {Date}    setDate1   The earlier date to use as the base
 * @param  {Date}    setDate2   The later date to use as the base
 * @param  {Date}    dateToTest The date to evaluate
 * @return {Boolean}            If all dates exist and the dateToTest is between the set dates.
 */
function isBetweenDates(setDate1, setDate2, dateToTest) {
  return !!(setDate1 && setDate2 && dateToTest && isAfterDate(setDate1, dateToTest) && isBeforeDate(setDate2, dateToTest));
}

/***/ }),

/***/ "../node_modules/base-components/build/components/Dropdown/Action.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Dropdown = __webpack_require__("../node_modules/base-components/build/blocks/Dropdown/index.js");

var _Dropdown2 = _interopRequireDefault(_Dropdown);

var _constants = __webpack_require__("../node_modules/base-components/build/components/Dropdown/constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Action(_ref, context) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, ['children']);

  var hideContent = context[_constants.DROPDOWN_CONTEXT].hideContent;


  return _react2.default.createElement(
    _Dropdown2.default.Action,
    _extends({ onClick: hideContent }, rest),
    children
  );
}

Action.contextTypes = _defineProperty({}, _constants.DROPDOWN_CONTEXT, _propTypes2.default.object.isRequired);

Action.propTypes = {
  children: _propTypes2.default.node.isRequired
};

exports.default = Action;

/***/ }),

/***/ "../node_modules/base-components/build/components/Dropdown/Content.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _Dropdown = __webpack_require__("../node_modules/base-components/build/blocks/Dropdown/index.js");

var _Dropdown2 = _interopRequireDefault(_Dropdown);

var _constants = __webpack_require__("../node_modules/base-components/build/components/Dropdown/constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Content(_ref, context) {
  var children = _ref.children,
      modifiers = _ref.modifiers,
      rest = _objectWithoutProperties(_ref, ['children', 'modifiers']);

  var _context$DROPDOWN_CON = context[_constants.DROPDOWN_CONTEXT],
      arrow = _context$DROPDOWN_CON.arrow,
      fullWidth = _context$DROPDOWN_CON.fullWidth,
      position = _context$DROPDOWN_CON.position,
      showContent = _context$DROPDOWN_CON.showContent,
      zIndex = _context$DROPDOWN_CON.zIndex;

  if (!showContent) {
    return null;
  }
  var fw = (0, _lodash.compact)([fullWidth && 'fullWidth']);
  var contentModifiers = fw.concat.apply(fw, [position].concat(_toConsumableArray(modifiers)));

  return _react2.default.createElement(
    _Dropdown2.default.Content,
    _extends({ arrow: arrow, modifiers: contentModifiers, zIndex: zIndex }, rest),
    children,
    arrow && _react2.default.createElement(_Dropdown2.default.Arrow, { modifiers: [position] })
  );
}

Content.displayName = 'Dropdown__Content';

Content.contextTypes = _defineProperty({}, _constants.DROPDOWN_CONTEXT, _propTypes2.default.object.isRequired);

Content.defaultProps = {
  modifiers: []
};

Content.propTypes = {
  children: _propTypes2.default.node.isRequired,
  modifiers: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

exports.default = Content;

/***/ }),

/***/ "../node_modules/base-components/build/components/Dropdown/List.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ContainerSelectable = __webpack_require__("../node_modules/base-components/build/blocks/ContainerSelectable/index.js");

var _ContainerSelectable2 = _interopRequireDefault(_ContainerSelectable);

var _Dropdown = __webpack_require__("../node_modules/base-components/build/blocks/Dropdown/index.js");

var _Dropdown2 = _interopRequireDefault(_Dropdown);

var _constants = __webpack_require__("../node_modules/base-components/build/components/Dropdown/constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function List(_ref, context) {
  var children = _ref.children,
      name = _ref.name,
      rest = _objectWithoutProperties(_ref, ['children', 'name']);

  var _context$DROPDOWN_CON = context[_constants.DROPDOWN_CONTEXT],
      activeItem = _context$DROPDOWN_CON.activeItem,
      handleItemClick = _context$DROPDOWN_CON.handleItemClick,
      selectable = _context$DROPDOWN_CON.selectable;


  function handleClick(e, itemId) {
    if (selectable) {
      handleItemClick(e, itemId);
    }
  }

  var listItems = _react.Children.map(children, function (child, i) {
    // this ternary allows us to not have to add a name prop
    // for a dropdown that only contains a single list
    var identifier = child.props.id || i.toString();
    var itemId = name.length ? name + ':' + identifier : identifier;
    var isActive = activeItem === itemId;
    var defaultModifiers = ['fluid'];
    var modifierProps = child.props.modifiers.concat(isActive ? 'active' : []);
    var listItem = _react2.default.cloneElement(child, {
      onClick: function onClick(e) {
        return handleClick(e, itemId);
      }
    });

    return _react2.default.createElement(
      _ContainerSelectable2.default,
      { modifiers: defaultModifiers.concat(modifierProps) },
      listItem
    );
  });
  return _react2.default.createElement(
    _Dropdown2.default.List,
    _extends({ name: name }, rest),
    listItems
  );
}

List.contextTypes = _defineProperty({}, _constants.DROPDOWN_CONTEXT, _propTypes2.default.object.isRequired);

List.defaultProps = {
  name: ''
};

List.propTypes = {
  name: _propTypes2.default.string,
  children: _propTypes2.default.node.isRequired
};

exports.default = List;

/***/ }),

/***/ "../node_modules/base-components/build/components/Dropdown/Target.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _Dropdown = __webpack_require__("../node_modules/base-components/build/blocks/Dropdown/index.js");

var _Dropdown2 = _interopRequireDefault(_Dropdown);

var _constants = __webpack_require__("../node_modules/base-components/build/components/Dropdown/constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Target(_ref, context) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, ['children']);

  var _context$DROPDOWN_CON = context[_constants.DROPDOWN_CONTEXT],
      fullWidth = _context$DROPDOWN_CON.fullWidth,
      handleToggle = _context$DROPDOWN_CON.handleToggle,
      handleHover = _context$DROPDOWN_CON.handleHover;

  var modifiers = (0, _lodash.compact)([fullWidth && 'fullWidth']);

  return _react2.default.createElement(
    _Dropdown2.default.Target,
    _extends({
      modifiers: modifiers,
      onClick: handleToggle,
      onMouseEnter: handleHover
    }, rest),
    children
  );
}

Target.contextTypes = _defineProperty({}, _constants.DROPDOWN_CONTEXT, _propTypes2.default.object.isRequired);

Target.propTypes = {
  children: _propTypes2.default.node.isRequired
};

exports.default = Target;

/***/ }),

/***/ "../node_modules/base-components/build/components/Dropdown/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// eslint-disable-next-line import/prefer-default-export
var DROPDOWN_CONTEXT = exports.DROPDOWN_CONTEXT = '__DROPDOWN_CONTEXT__';

/***/ }),

/***/ "../node_modules/base-components/build/components/Dropdown/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _Dropdown = __webpack_require__("../node_modules/base-components/build/blocks/Dropdown/index.js");

var _Dropdown2 = _interopRequireDefault(_Dropdown);

var _constants = __webpack_require__("../node_modules/base-components/build/components/Dropdown/constants.js");

var _Action = __webpack_require__("../node_modules/base-components/build/components/Dropdown/Action.js");

var _Action2 = _interopRequireDefault(_Action);

var _Content = __webpack_require__("../node_modules/base-components/build/components/Dropdown/Content.js");

var _Content2 = _interopRequireDefault(_Content);

var _List = __webpack_require__("../node_modules/base-components/build/components/Dropdown/List.js");

var _List2 = _interopRequireDefault(_List);

var _Target = __webpack_require__("../node_modules/base-components/build/components/Dropdown/Target.js");

var _Target2 = _interopRequireDefault(_Target);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Dropdown = function (_Component) {
  _inherits(Dropdown, _Component);

  function Dropdown() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Dropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      activeItem: _this.props.activeItem,
      showContent: _this.props.showContent
    }, _this.setInnerRef = function (node) {
      _this.innerRef = node;
      return _this.innerRef;
    }, _this.handleClickOutside = function (e) {
      if (!_this.innerRef.contains(e.target) && _this.state.showContent) {
        _this.toggleContent({ show: false });
      }
    }, _this.handleHover = function () {
      if (_this.props.showOnHover) {
        _this.toggleContent({ show: true });
      }
    }, _this.toggleContent = function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          show = _ref2.show;

      // this allows us to handle all show / hide logic in a single location
      // you can explicitly tell the content to show / hide, or let it toggle.
      if (show) {
        _this.props.onExpandedChange(show);
        return _this.setState({ showContent: show });
      }

      _this.props.onExpandedChange(!_this.state.showContent);
      return _this.setState({ showContent: !_this.state.showContent });
    }, _this.handleItemClick = function (e, itemId) {
      _this.props.onChange(e, itemId);
      if (_this.props.hideOnChange) {
        _this.toggleContent({ show: false });
        return _this.setState({ activeItem: itemId });
      }
      return _this.setState({ activeItem: itemId });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Dropdown, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var _this2 = this;

      return _defineProperty({}, _constants.DROPDOWN_CONTEXT, {
        activeItem: this.state.activeItem,
        arrow: this.props.arrow,
        fullWidth: this.props.fullWidth,
        handleHover: this.handleHover,
        handleItemClick: this.handleItemClick,
        handleToggle: this.toggleContent,
        hideContent: function hideContent() {
          return _this2.toggleContent({ show: false });
        },
        position: this.props.position,
        selectable: this.props.selectable,
        showContent: this.state.showContent,
        zIndex: this.props.zIndex
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.activeItem !== nextProps.activeItem) {
        this.setState({ activeItem: nextProps.activeItem });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          position = _props.position,
          rest = _objectWithoutProperties(_props, ['children', 'position']);

      return _react2.default.createElement(
        _Dropdown2.default,
        _extends({
          innerRef: this.setInnerRef,
          modifiers: [position]
        }, rest),
        children
      );
    }
  }]);

  return Dropdown;
}(_react.Component);

Dropdown.Action = _Action2.default;
Dropdown.Content = _Content2.default;
Dropdown.Divider = _Dropdown2.default.Divider;
Dropdown.List = _List2.default;
Dropdown.ListItem = _Dropdown2.default.ListItem;
Dropdown.SectionHeader = _Dropdown2.default.SectionHeader;
Dropdown.SectionBody = _Dropdown2.default.SectionBody;
Dropdown.Target = _Target2.default;
Dropdown.modifiers = _Dropdown2.default.modifiers;
Dropdown.childContextTypes = _defineProperty({}, _constants.DROPDOWN_CONTEXT, _propTypes2.default.object.isRequired);
Dropdown.propTypes = {
  activeItem: _propTypes2.default.string,
  arrow: _propTypes2.default.bool,
  children: _propTypes2.default.node.isRequired,
  fullWidth: _propTypes2.default.bool,
  hideOnChange: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  onExpandedChange: _propTypes2.default.func,
  position: _propTypes2.default.oneOf(['bottom', 'bottomLeft', 'bottomRight']),
  selectable: _propTypes2.default.bool,
  showContent: _propTypes2.default.bool,
  showOnHover: _propTypes2.default.bool,
  zIndex: _propTypes2.default.number
};
Dropdown.defaultProps = {
  activeItem: '',
  arrow: false,
  fullWidth: false,
  hideOnChange: false,
  onChange: _lodash.noop,
  onExpandedChange: _lodash.noop,
  position: 'bottom',
  selectable: true,
  showContent: false,
  showOnHover: false,
  zIndex: 1
};
exports.default = Dropdown;

/***/ }),

/***/ "../node_modules/base-components/build/components/InputField/ActionButton.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/base-components/node_modules/styled-components-reactive-grid/dist/index.js");

var _blocks = __webpack_require__("../node_modules/base-components/build/blocks/index.js");

var _elements = __webpack_require__("../node_modules/base-components/build/elements/index.js");

var _modifiers = __webpack_require__("../node_modules/base-components/build/utils/modifiers.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function ActionButton(_ref) {
  var icon = _ref.icon,
      modifiers = _ref.modifiers,
      rest = _objectWithoutProperties(_ref, ['icon', 'modifiers']);

  var columnModifiers = ['padScale_0'].concat(_toConsumableArray((0, _modifiers.modifiersForComponent)(modifiers, _styledComponentsReactiveGrid.Column)));
  var actionButtonModifiers = (0, _modifiers.modifiersForComponent)(modifiers, _blocks.Input.ActionButton);
  var iconModifiers = ['colorInherit', 'mini'].concat(_toConsumableArray((0, _modifiers.modifiersForComponent)(modifiers, _elements.Icon)));

  return _react2.default.createElement(
    _styledComponentsReactiveGrid.Column,
    {
      modifiers: columnModifiers,
      style: {
        position: 'relative',
        bottom: '2px'
      }
    },
    _react2.default.createElement(
      _blocks.Input.ActionButton,
      _extends({ modifiers: actionButtonModifiers }, rest),
      _react2.default.createElement(_elements.Icon, { modifiers: iconModifiers, name: icon })
    )
  );
}

ActionButton.propTypes = {
  icon: _propTypes2.default.string.isRequired,
  modifiers: _propTypes2.default.arrayOf(_propTypes2.default.string),
  onClick: _propTypes2.default.func.isRequired
};

ActionButton.defaultProps = {
  modifiers: []
};

exports.default = ActionButton;

/***/ }),

/***/ "../node_modules/base-components/build/components/InputField/Avatar.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/base-components/node_modules/styled-components-reactive-grid/dist/index.js");

var _Avatar = __webpack_require__("../node_modules/base-components/build/components/Avatar/index.js");

var _Avatar2 = _interopRequireDefault(_Avatar);

var _modifiers = __webpack_require__("../node_modules/base-components/build/utils/modifiers.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Avatar(_ref) {
  var modifiers = _ref.modifiers,
      rest = _objectWithoutProperties(_ref, ['modifiers']);

  var columnModifiers = [].concat(_toConsumableArray((0, _modifiers.modifiersForComponent)(modifiers, _styledComponentsReactiveGrid.Column)));
  var avatarModifiers = ['secondary', 'small'].concat(_toConsumableArray((0, _modifiers.modifiersForComponent)(modifiers, Avatar)));

  return _react2.default.createElement(
    _styledComponentsReactiveGrid.Column,
    {
      modifiers: columnModifiers,
      style: {
        // NOTE: inline styles to tweak grid components is necessary until there
        // modifier configs can be extended or the required styles are able to be
        // added with grid modifiers.
        display: 'flex'
      }
    },
    _react2.default.createElement(_Avatar2.default, _extends({ modifiers: avatarModifiers }, rest))
  );
}

Avatar.propTypes = {
  modifiers: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

Avatar.defaultProps = {
  modifiers: []
};

exports.default = Avatar;

/***/ }),

/***/ "../node_modules/base-components/build/components/InputField/Icon.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/base-components/node_modules/styled-components-reactive-grid/dist/index.js");

var _elements = __webpack_require__("../node_modules/base-components/build/elements/index.js");

var _modifiers = __webpack_require__("../node_modules/base-components/build/utils/modifiers.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Icon(_ref) {
  var modifiers = _ref.modifiers,
      rest = _objectWithoutProperties(_ref, ['modifiers']);

  var columnModifiers = ['padScaleX_3'].concat(_toConsumableArray((0, _modifiers.modifiersForComponent)(modifiers, _styledComponentsReactiveGrid.Column)));
  var iconModifiers = (0, _modifiers.modifiersForComponent)(modifiers, _elements.Icon);

  return _react2.default.createElement(
    _styledComponentsReactiveGrid.Column,
    { modifiers: columnModifiers },
    _react2.default.createElement(_elements.Icon, _extends({ modifiers: iconModifiers }, rest))
  );
}

Icon.propTypes = {
  modifiers: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

Icon.defaultProps = {
  modifiers: []
};

exports.default = Icon;

/***/ }),

/***/ "../node_modules/base-components/build/components/InputField/Label.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/base-components/node_modules/styled-components-reactive-grid/dist/index.js");

var _elements = __webpack_require__("../node_modules/base-components/build/elements/index.js");

var _modifiers = __webpack_require__("../node_modules/base-components/build/utils/modifiers.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Label(_ref) {
  var modifiers = _ref.modifiers,
      rest = _objectWithoutProperties(_ref, ['modifiers']);

  var columnModifiers = ['col', 'padScaleY_0'].concat(_toConsumableArray((0, _modifiers.modifiersForComponent)(modifiers, _styledComponentsReactiveGrid.Column)));
  var labelModifiers = (0, _modifiers.modifiersForComponent)(modifiers, Label);

  return _react2.default.createElement(
    _styledComponentsReactiveGrid.Column,
    { modifiers: columnModifiers },
    _react2.default.createElement(_elements.Label, _extends({ modifiers: labelModifiers }, rest))
  );
}

Label.propTypes = {
  modifiers: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

Label.defaultProps = {
  modifiers: []
};

exports.default = Label;

/***/ }),

/***/ "../node_modules/base-components/build/components/InputField/TextField.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/base-components/node_modules/styled-components-reactive-grid/dist/index.js");

var _elements = __webpack_require__("../node_modules/base-components/build/elements/index.js");

var _modifiers = __webpack_require__("../node_modules/base-components/build/utils/modifiers.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function TextField(_ref) {
  var modifiers = _ref.modifiers,
      rest = _objectWithoutProperties(_ref, ['modifiers']);

  var columnModifiers = ['col', 'padScaleY_0'].concat(_toConsumableArray((0, _modifiers.modifiersForComponent)(modifiers, _styledComponentsReactiveGrid.Column)));
  var textFieldModifiers = (0, _modifiers.modifiersForComponent)(modifiers, _elements.TextField);

  return _react2.default.createElement(
    _styledComponentsReactiveGrid.Column,
    {
      modifiers: columnModifiers,
      style: {
        position: 'relative',
        bottom: '2px'
      }
    },
    _react2.default.createElement(_elements.TextField, _extends({ modifiers: textFieldModifiers }, rest))
  );
}

TextField.propTypes = {
  modifiers: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

TextField.defaultProps = {
  modifiers: []
};

exports.default = TextField;

/***/ }),

/***/ "../node_modules/base-components/build/components/InputField/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/base-components/node_modules/styled-components-reactive-grid/dist/index.js");

var _blocks = __webpack_require__("../node_modules/base-components/build/blocks/index.js");

var _ActionButton = __webpack_require__("../node_modules/base-components/build/components/InputField/ActionButton.js");

var _ActionButton2 = _interopRequireDefault(_ActionButton);

var _Avatar = __webpack_require__("../node_modules/base-components/build/components/InputField/Avatar.js");

var _Avatar2 = _interopRequireDefault(_Avatar);

var _Icon = __webpack_require__("../node_modules/base-components/build/components/InputField/Icon.js");

var _Icon2 = _interopRequireDefault(_Icon);

var _Label = __webpack_require__("../node_modules/base-components/build/components/InputField/Label.js");

var _Label2 = _interopRequireDefault(_Label);

var _TextField = __webpack_require__("../node_modules/base-components/build/components/InputField/TextField.js");

var _TextField2 = _interopRequireDefault(_TextField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BC_INPUT_FIELD_CONTEXT = '__BC_INPUT_FIELD_CONTEXT__';

function withInputFieldProps(WrappedComponent) {
  function WithInputFieldProps(props, context) {
    var propsFromInputField = context[BC_INPUT_FIELD_CONTEXT];
    return _react2.default.createElement(WrappedComponent, _extends({}, propsFromInputField, props));
  }

  WithInputFieldProps.contextTypes = _defineProperty({}, BC_INPUT_FIELD_CONTEXT, _propTypes2.default.shape({
    disabled: _propTypes2.default.bool.isRequired,
    onBlur: _propTypes2.default.func.isRequired,
    onFocus: _propTypes2.default.func.isRequired,
    placeholder: _propTypes2.default.string.isRequired,
    value: _propTypes2.default.string.isRequired
  }).isRequired);

  return WithInputFieldProps;
}

var InputField = function (_Component) {
  _inherits(InputField, _Component);

  function InputField() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, InputField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InputField.__proto__ || Object.getPrototypeOf(InputField)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isFocused: false
    }, _this.handleBlur = function (e) {
      _this.props.onBlur(e);
      _this.setState(function () {
        return { isFocused: false };
      });
    }, _this.handleFocus = function (e) {
      _this.props.onFocus(e);
      _this.setState(function () {
        return { isFocused: true };
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  // Wrap any component needing the input field's props in withInputFieldProps


  _createClass(InputField, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return _defineProperty({}, BC_INPUT_FIELD_CONTEXT, _extends({}, (0, _lodash.omit)(this.props, ['children']), {
        onBlur: this.handleBlur,
        onFocus: this.handleFocus
      }));
    }
  }, {
    key: 'render',
    value: function render() {
      var isFocused = this.state.isFocused;
      var _props = this.props,
          children = _props.children,
          disabled = _props.disabled,
          isValid = _props.isValid;


      var borderFocus = isFocused && 'focused';
      var borderWarning = !isValid && 'borderWarning';
      var disabledInput = disabled && 'disabled';
      var inputModifiers = (0, _lodash.compact)([borderFocus, borderWarning, disabledInput, 'fluid'].concat(_toConsumableArray(this.props.modifiers)));

      return _react2.default.createElement(
        _blocks.Input,
        { modifiers: inputModifiers },
        _react2.default.createElement(
          _styledComponentsReactiveGrid.Row,
          { modifiers: ['height_100', 'middle'] },
          children
        )
      );
    }
  }]);

  return InputField;
}(_react.Component);

InputField.ActionButton = _ActionButton2.default;
InputField.Avatar = _Avatar2.default;
InputField.Icon = _Icon2.default;
InputField.Label = _Label2.default;
InputField.TextField = withInputFieldProps(_TextField2.default);
InputField.propTypes = {
  children: _propTypes2.default.node.isRequired,
  disabled: _propTypes2.default.bool,
  isValid: _propTypes2.default.bool,
  modifiers: _propTypes2.default.arrayOf(_propTypes2.default.string),
  onBlur: _propTypes2.default.func,
  onFocus: _propTypes2.default.func
};
InputField.defaultProps = {
  disabled: false,
  isValid: true,
  modifiers: [],
  onBlur: _lodash.noop,
  onFocus: _lodash.noop,
  placeholder: 'Enter Value...'
};
InputField.childContextTypes = _defineProperty({}, BC_INPUT_FIELD_CONTEXT, _propTypes2.default.object.isRequired);
exports.default = InputField;

/***/ }),

/***/ "../node_modules/base-components/build/components/InputGroup/Column.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/base-components/node_modules/styled-components-reactive-grid/dist/index.js");

var _modifiers = __webpack_require__("../node_modules/base-components/build/utils/modifiers.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var styles = '\n  margin-right: -1px;\n  &:last-child {\n    margin-right: 0;\n  }\n';

var StyledInputGroupColumn = (0, _decisivUiUtils.buildStyledComponent)('InputGroupColumn', (0, _styledComponents2.default)(_styledComponentsReactiveGrid.Column), styles);

function InputGroupColumn(_ref) {
  var modifiers = _ref.modifiers,
      rest = _objectWithoutProperties(_ref, ['modifiers']);

  var inputGroupColumnModifiers = ['padScale_0'].concat(_toConsumableArray((0, _modifiers.modifiersForComponent)(modifiers, _styledComponentsReactiveGrid.Column)));
  return _react2.default.createElement(StyledInputGroupColumn, _extends({ modifiers: inputGroupColumnModifiers }, rest));
}

InputGroupColumn.propTypes = {
  modifiers: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

InputGroupColumn.defaultProps = {
  modifiers: []
};

exports.default = InputGroupColumn;

/***/ }),

/***/ "../node_modules/base-components/build/components/InputGroup/Row.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/base-components/node_modules/styled-components-reactive-grid/dist/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = '\n  margin-bottom: -1px;\n';

exports.default = (0, _decisivUiUtils.buildStyledComponent)('InputGroupRow', (0, _styledComponents2.default)(_styledComponentsReactiveGrid.Row), styles);

/***/ }),

/***/ "../node_modules/base-components/build/components/InputGroup/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/base-components/node_modules/styled-components-reactive-grid/dist/index.js");

var _modifiers = __webpack_require__("../node_modules/base-components/build/utils/modifiers.js");

var _Row = __webpack_require__("../node_modules/base-components/build/components/InputGroup/Row.js");

var _Row2 = _interopRequireDefault(_Row);

var _Column = __webpack_require__("../node_modules/base-components/build/components/InputGroup/Column.js");

var _Column2 = _interopRequireDefault(_Column);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var StyledInputGroup = (0, _decisivUiUtils.buildStyledComponent)('InputGroup', _styledComponentsReactiveGrid.Container);

function InputGroup(_ref) {
  var modifiers = _ref.modifiers,
      rest = _objectWithoutProperties(_ref, ['modifiers']);

  var inputGroupModifiers = ['padScale_0'].concat(_toConsumableArray((0, _modifiers.modifiersForComponent)(modifiers, StyledInputGroup)));
  return _react2.default.createElement(StyledInputGroup, _extends({ modifiers: inputGroupModifiers }, rest));
}

InputGroup.propTypes = {
  modifiers: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

InputGroup.defaultProps = {
  modifiers: []
};

InputGroup.Row = _Row2.default;
InputGroup.Column = _Column2.default;

exports.default = InputGroup;

/***/ }),

/***/ "../node_modules/base-components/build/components/InputText/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _blocks = __webpack_require__("../node_modules/base-components/build/blocks/index.js");

var _elements = __webpack_require__("../node_modules/base-components/build/elements/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InputText = function (_Component) {
  _inherits(InputText, _Component);

  function InputText() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, InputText);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InputText.__proto__ || Object.getPrototypeOf(InputText)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      focus: false
    }, _this.handleBlur = function (e) {
      _this.props.onBlur(e);
      return _this.setState({ focus: false });
    }, _this.handleFocus = function (e) {
      _this.props.onFocus(e);
      return _this.setState({ focus: true });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(InputText, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // eslint-disable-next-line no-console
      console.error('\n      \uD83D\uDEA8 DEPRECATION WARNING: InputText will soon be deprecated. Please use InputField instead.\n    ');
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          disabled = _props.disabled,
          isValid = _props.isValid,
          label = _props.label,
          name = _props.name,
          onChange = _props.onChange,
          placeholder = _props.placeholder,
          value = _props.value;
      var focus = this.state.focus;

      var borderFocus = focus && 'borderChrome600';
      var borderWarning = !isValid && 'borderWarning';
      var disabledInput = disabled && 'disabled';
      var borderModifiers = (0, _lodash.compact)([borderFocus, borderWarning, disabledInput, 'column', 'pad']);

      return _react2.default.createElement(
        _blocks.Input,
        { modifiers: borderModifiers },
        _react2.default.createElement(
          _elements.Label,
          { modifiers: ['gapX'] },
          label
        ),
        _react2.default.createElement(_elements.TextField, {
          isValid: isValid,
          modifiers: ['gapX'],
          name: name,
          onBlur: this.handleBlur,
          onChange: onChange,
          onFocus: this.handleFocus,
          placeholder: placeholder,
          type: 'text',
          value: value,
          disabled: disabled
        })
      );
    }
  }]);

  return InputText;
}(_react.Component);

InputText.propTypes = {
  disabled: _propTypes2.default.bool,
  isValid: _propTypes2.default.bool,
  label: _propTypes2.default.string,
  name: _propTypes2.default.string.isRequired,
  onBlur: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  placeholder: _propTypes2.default.string,
  value: _propTypes2.default.string.isRequired
};

InputText.defaultProps = {
  disabled: false,
  isValid: true,
  label: '',
  onBlur: _lodash.noop,
  onChange: _lodash.noop,
  onFocus: _lodash.noop,
  placeholder: 'Enter Value...'
};

exports.default = InputText;

/***/ }),

/***/ "../node_modules/base-components/build/components/LeftNav/MenuGroupItem.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _blocks = __webpack_require__("../node_modules/base-components/build/blocks/index.js");

var _MenusList = __webpack_require__("../node_modules/base-components/build/components/LeftNav/MenusList.js");

var _MenusList2 = _interopRequireDefault(_MenusList);

var _menuPropTypes = __webpack_require__("../node_modules/base-components/build/components/LeftNav/menuPropTypes.js");

var _menuPropTypes2 = _interopRequireDefault(_menuPropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function MenuGroupItem(_ref) {
  var TextRenderer = _ref.TextRenderer,
      expanded = _ref.expanded,
      expandedMenus = _ref.expandedMenus,
      handleExpandMenuClick = _ref.handleExpandMenuClick,
      last = _ref.last,
      location = _ref.location,
      menuGroup = _ref.menuGroup,
      menuGroupsLoading = _ref.menuGroupsLoading;

  return _react2.default.createElement(
    _blocks.LeftNav.MenuGroupItem,
    null,
    _react2.default.createElement(_MenusList2.default, {
      TextRenderer: TextRenderer,
      expanded: expanded,
      expandedMenus: expandedMenus,
      handleExpandMenuClick: handleExpandMenuClick,
      location: location,
      menuGroup: menuGroup,
      menuGroupsLoading: menuGroupsLoading
    }),
    _react2.default.createElement(_blocks.LeftNav.MenuGroupsDivider, {
      modifiers: (0, _lodash.compact)([expanded && 'expanded', last && 'last'])
    })
  );
}

MenuGroupItem.propTypes = {
  TextRenderer: _propTypes2.default.func.isRequired,
  expanded: _propTypes2.default.bool.isRequired,
  expandedMenus: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  handleExpandMenuClick: _propTypes2.default.func.isRequired,
  last: _propTypes2.default.bool.isRequired,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string.isRequired
  }).isRequired,
  // eslint-disable-next-line react/no-typos
  menuGroup: _menuPropTypes2.default.menuGroup.isRequired,
  menuGroupsLoading: _propTypes2.default.bool.isRequired
};

exports.default = MenuGroupItem;

/***/ }),

/***/ "../node_modules/base-components/build/components/LeftNav/MenuGroupsList.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ghostMenuGroups = undefined;

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _blocks = __webpack_require__("../node_modules/base-components/build/blocks/index.js");

var _MenuGroupItem = __webpack_require__("../node_modules/base-components/build/components/LeftNav/MenuGroupItem.js");

var _MenuGroupItem2 = _interopRequireDefault(_MenuGroupItem);

var _menuPropTypes = __webpack_require__("../node_modules/base-components/build/components/LeftNav/menuPropTypes.js");

var _menuPropTypes2 = _interopRequireDefault(_menuPropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ghostMenuGroups = exports.ghostMenuGroups = function ghostMenuGroups() {
  return [4, 2, 1].reduce(function (acc, val) {
    var currentGhostGroup = Array.from(new Array(val), function (v, idx) {
      return {
        // path is used as a key later on, so a unique value must
        // be provided here.
        path: val + ':' + idx,
        loading: true
      };
    });
    return acc.concat([currentGhostGroup]);
  }, []);
};

function MenuGroupsList(_ref) {
  var TextRenderer = _ref.TextRenderer,
      expanded = _ref.expanded,
      expandedMenus = _ref.expandedMenus,
      handleExpandMenuClick = _ref.handleExpandMenuClick,
      location = _ref.location,
      menuGroups = _ref.menuGroups,
      menuGroupsLoading = _ref.menuGroupsLoading;

  var renderedMenuGroups = menuGroupsLoading ? ghostMenuGroups() : menuGroups;

  return _react2.default.createElement(
    _blocks.LeftNav.MenuGroupsList,
    null,
    renderedMenuGroups.map(function (menuGroup, index) {
      var last = renderedMenuGroups.length - 1 === index;
      return _react2.default.createElement(_MenuGroupItem2.default, {
        key: index,
        TextRenderer: TextRenderer,
        expanded: expanded,
        expandedMenus: expandedMenus,
        handleExpandMenuClick: handleExpandMenuClick,
        last: last,
        location: location,
        menuGroup: menuGroup,
        menuGroupsLoading: menuGroupsLoading
      });
    })
  );
}

MenuGroupsList.propTypes = {
  TextRenderer: _propTypes2.default.func.isRequired,
  expanded: _propTypes2.default.bool.isRequired,
  expandedMenus: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  handleExpandMenuClick: _propTypes2.default.func.isRequired,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string.isRequired
  }).isRequired,
  // eslint-disable-next-line react/no-typos
  menuGroups: _menuPropTypes2.default.menuGroups.isRequired,
  menuGroupsLoading: _propTypes2.default.bool.isRequired
};

exports.default = MenuGroupsList;

/***/ }),

/***/ "../node_modules/base-components/build/components/LeftNav/MenuItem.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuItem = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _blocks = __webpack_require__("../node_modules/base-components/build/blocks/index.js");

var _MenuItemFlyout = __webpack_require__("../node_modules/base-components/build/components/LeftNav/MenuItemFlyout.js");

var _MenuItemFlyout2 = _interopRequireDefault(_MenuItemFlyout);

var _MenuItemTitle = __webpack_require__("../node_modules/base-components/build/components/LeftNav/MenuItemTitle.js");

var _MenuItemTitle2 = _interopRequireDefault(_MenuItemTitle);

var _MenuSubItemsList = __webpack_require__("../node_modules/base-components/build/components/LeftNav/MenuSubItemsList.js");

var _MenuSubItemsList2 = _interopRequireDefault(_MenuSubItemsList);

var _menuPropTypes = __webpack_require__("../node_modules/base-components/build/components/LeftNav/menuPropTypes.js");

var _menuPropTypes2 = _interopRequireDefault(_menuPropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Compares the menu item's active path to the current pathname. Boolean returned
 * indicates if the two match.
 * @param {object} props the component's props (may be next props)
 * @property {object} props.location a location object provided by the withRouter HOC
 * @property {object} props.menuItem a menuItem object provided by the menu groups list
 * @returns {boolean}
 */
function evaluateMenuItemActive(_ref) {
  var _ref$location$pathnam = _ref.location.pathname,
      pathname = _ref$location$pathnam === undefined ? '' : _ref$location$pathnam,
      path = _ref.menuItem.path;

  var primaryPath = pathname.split('/')[1];
  return !!(path && primaryPath && path.match(primaryPath) || path === '/' && !primaryPath);
}

var MenuItem = exports.MenuItem = function (_Component) {
  _inherits(MenuItem, _Component);

  function MenuItem() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, MenuItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = MenuItem.__proto__ || Object.getPrototypeOf(MenuItem)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      // A menu item's active state is based on the current route
      isActive: evaluateMenuItemActive(_this.props),
      // A menu item's highlighted state is based on the user's cursor position
      isHighlighted: false,
      // A menu item's highlighted state is based on the user's cursor position
      // + the left nav expanded state
      isFlyoutOpen: false
    }, _this.handleMouseEnter = function () {
      if (!_this.props.expanded) {
        _this.setState({
          isHighlighted: true,
          isFlyoutOpen: true
        });
      }
    }, _this.handleMouseLeave = function () {
      _this.setState({
        isHighlighted: false,
        isFlyoutOpen: false
      });
    }, _this.handleMouseEnterMenuItemTitle = function () {
      if (_this.props.expanded) {
        _this.setState({ isHighlighted: true });
      }
    }, _this.handleMouseLeaveMenuItemTitle = function () {
      if (_this.props.expanded) {
        _this.setState({ isHighlighted: false });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MenuItem, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var isActive = evaluateMenuItemActive(nextProps);
      this.setState({
        isActive: isActive
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          TextRenderer = _props.TextRenderer,
          expanded = _props.expanded,
          expandedMenus = _props.expandedMenus,
          handleExpandMenuClick = _props.handleExpandMenuClick,
          menuItem = _props.menuItem,
          menuGroupsLoading = _props.menuGroupsLoading,
          location = _props.location;
      var _state = this.state,
          isActive = _state.isActive,
          isHighlighted = _state.isHighlighted,
          isFlyoutOpen = _state.isFlyoutOpen;


      var menuKey = menuItem.icon + ':' + menuItem.activePath;
      var isMenuExpanded = !!(expanded && Array.isArray(expandedMenus) && expandedMenus.includes(menuKey));

      return _react2.default.createElement(
        _blocks.LeftNav.MenuItem,
        {
          onMouseEnter: this.handleMouseEnter,
          onMouseLeave: this.handleMouseLeave
        },
        _react2.default.createElement(_MenuItemTitle2.default, {
          TextRenderer: TextRenderer,
          expanded: expanded,
          handleExpandMenuClick: handleExpandMenuClick,
          isActive: isActive,
          isFlyoutOpen: isFlyoutOpen,
          isHighlighted: isHighlighted,
          isMenuExpanded: isMenuExpanded,
          menuItem: menuItem,
          menuGroupsLoading: menuGroupsLoading,
          menuKey: menuKey,
          onMouseEnter: this.handleMouseEnterMenuItemTitle,
          onMouseLeave: this.handleMouseLeaveMenuItemTitle
        }),
        isFlyoutOpen && !menuGroupsLoading ? _react2.default.createElement(_MenuItemFlyout2.default, {
          TextRenderer: TextRenderer,
          expanded: expanded,
          handleExpandMenuClick: handleExpandMenuClick,
          isActive: isActive,
          isFlyoutOpen: isFlyoutOpen,
          isHighlighted: isHighlighted,
          isMenuExpanded: isMenuExpanded,
          menuItem: menuItem,
          menuGroupsLoading: menuGroupsLoading,
          menuKey: menuKey,
          onMouseEnter: this.handleMouseEnterMenuItemTitle,
          onMouseLeave: this.handleMouseLeaveMenuItemTitle
        }) : _react2.default.createElement(_MenuSubItemsList2.default, {
          TextRenderer: TextRenderer,
          isFlyoutOpen: isFlyoutOpen,
          isMenuExpanded: isMenuExpanded,
          location: location,
          menuSubItems: menuItem.menuSubItems
        })
      );
    }
  }]);

  return MenuItem;
}(_react.Component);

MenuItem.propTypes = {
  TextRenderer: _propTypes2.default.func.isRequired,
  expanded: _propTypes2.default.bool.isRequired,
  expandedMenus: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  handleExpandMenuClick: _propTypes2.default.func.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string.isRequired
  }).isRequired,
  menuItem: _menuPropTypes2.default.menuItem.isRequired,
  menuGroupsLoading: _propTypes2.default.bool.isRequired
};
exports.default = MenuItem;

/***/ }),

/***/ "../node_modules/base-components/build/components/LeftNav/MenuItemFlyout.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuItemFlyout = MenuItemFlyout;

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__("../node_modules/react-router-dom/es/index.js");

var _blocks = __webpack_require__("../node_modules/base-components/build/blocks/index.js");

var _MenuItemTitle = __webpack_require__("../node_modules/base-components/build/components/LeftNav/MenuItemTitle.js");

var _MenuItemTitle2 = _interopRequireDefault(_MenuItemTitle);

var _MenuSubItem = __webpack_require__("../node_modules/base-components/build/components/LeftNav/MenuSubItem.js");

var _MenuSubItem2 = _interopRequireDefault(_MenuSubItem);

var _menuPropTypes = __webpack_require__("../node_modules/base-components/build/components/LeftNav/menuPropTypes.js");

var _menuPropTypes2 = _interopRequireDefault(_menuPropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function MenuItemFlyout(_ref) {
  var TextRenderer = _ref.TextRenderer,
      expanded = _ref.expanded,
      handleExpandMenuClick = _ref.handleExpandMenuClick,
      isActive = _ref.isActive,
      isHighlighted = _ref.isHighlighted,
      isFlyoutOpen = _ref.isFlyoutOpen,
      isMenuExpanded = _ref.isMenuExpanded,
      location = _ref.location,
      menuItem = _ref.menuItem,
      menuGroupsLoading = _ref.menuGroupsLoading,
      menuKey = _ref.menuKey,
      onMouseEnter = _ref.onMouseEnter,
      onMouseLeave = _ref.onMouseLeave;
  var _menuItem$menuSubItem = menuItem.menuSubItems,
      menuSubItems = _menuItem$menuSubItem === undefined ? [] : _menuItem$menuSubItem;


  return _react2.default.createElement(
    _blocks.LeftNav.MenuItemFlyout,
    null,
    _react2.default.createElement(_MenuItemTitle2.default, {
      TextRenderer: TextRenderer,
      expanded: expanded,
      handleExpandMenuClick: handleExpandMenuClick,
      isActive: isActive,
      isHighlighted: isHighlighted,
      isFlyout: true,
      isFlyoutOpen: isFlyoutOpen,
      isMenuExpanded: isMenuExpanded,
      menuItem: menuItem,
      menuGroupsLoading: menuGroupsLoading,
      menuKey: menuKey,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave
    }),
    _react2.default.createElement(
      _blocks.LeftNav.MenusList,
      null,
      menuSubItems.map(function (menuSubItem) {
        return _react2.default.createElement(_MenuSubItem2.default, {
          key: menuSubItem.path,
          isFlyoutOpen: isFlyoutOpen,
          location: location,
          menuSubItem: menuSubItem,
          TextRenderer: TextRenderer
        });
      })
    )
  );
}

MenuItemFlyout.propTypes = {
  TextRenderer: _propTypes2.default.func.isRequired,
  expanded: _propTypes2.default.bool.isRequired,
  handleExpandMenuClick: _propTypes2.default.func.isRequired,
  isActive: _propTypes2.default.bool.isRequired,
  isFlyoutOpen: _propTypes2.default.bool.isRequired,
  isHighlighted: _propTypes2.default.bool.isRequired,
  isMenuExpanded: _propTypes2.default.bool.isRequired,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string.isRequired
  }).isRequired,
  menuGroupsLoading: _propTypes2.default.bool.isRequired,
  // eslint-disable-next-line react/no-typos
  menuItem: _menuPropTypes2.default.menuItem.isRequired,
  menuKey: _propTypes2.default.string.isRequired,
  onMouseEnter: _propTypes2.default.func.isRequired,
  onMouseLeave: _propTypes2.default.func.isRequired
};

var MenuItemFlyoutWithRouter = (0, _reactRouterDom.withRouter)(MenuItemFlyout);
MenuItemFlyoutWithRouter.displayName = 'MenuItemFlyout';

exports.default = MenuItemFlyoutWithRouter;

/***/ }),

/***/ "../node_modules/base-components/build/components/LeftNav/MenuItemTitle.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _blocks = __webpack_require__("../node_modules/base-components/build/blocks/index.js");

var _menuPropTypes = __webpack_require__("../node_modules/base-components/build/components/LeftNav/menuPropTypes.js");

var _menuPropTypes2 = _interopRequireDefault(_menuPropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function MenuItemTitle(_ref) {
  var TextRenderer = _ref.TextRenderer,
      expanded = _ref.expanded,
      handleExpandMenuClick = _ref.handleExpandMenuClick,
      isActive = _ref.isActive,
      isHighlighted = _ref.isHighlighted,
      isFlyout = _ref.isFlyout,
      isMenuExpanded = _ref.isMenuExpanded,
      menuItem = _ref.menuItem,
      menuGroupsLoading = _ref.menuGroupsLoading,
      menuKey = _ref.menuKey,
      onMouseEnter = _ref.onMouseEnter,
      onMouseLeave = _ref.onMouseLeave;

  if (menuGroupsLoading && !isFlyout) {
    // NOTE: Use the BEM classnames as a guide to build the components.
    return _react2.default.createElement(
      _blocks.LeftNav.MenuItemTitle,
      { modifiers: ['ghost'] },
      _react2.default.createElement(_blocks.LeftNav.MenuItemTitleGhost, { modifiers: ['chrome200', 'icon'] }),
      expanded && _react2.default.createElement(_blocks.LeftNav.MenuItemTitleGhost, { modifiers: ['chrome200'] })
    );
  }

  return _react2.default.createElement(
    _blocks.LeftNav.MenuItemTitle,
    {
      modifiers: (0, _lodash.compact)([isHighlighted && !isFlyout && 'highlight', isActive && !isFlyout && 'active'])
    },
    _react2.default.createElement(
      _blocks.LeftNav.MenuItemTitleLink,
      {
        'aria-label': 'Navigate to ' + menuItem.path,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        to: menuItem.path
      },
      !isFlyout && _react2.default.createElement(_blocks.LeftNav.MenuItemTitleIcon, {
        modifiers: (0, _lodash.compact)([!isActive && !isHighlighted && 'disabled']),
        name: menuItem.icon
      }),
      (expanded || isFlyout) && _react2.default.createElement(
        _blocks.LeftNav.MenuItemTitleText,
        {
          modifiers: (0, _lodash.compact)([isHighlighted && !isFlyout && 'highlight', isFlyout && 'flyout'])
        },
        _react2.default.createElement(TextRenderer, { message: menuItem.message })
      )
    ),
    !isFlyout && expanded && menuItem.menuSubItems && _react2.default.createElement(_blocks.LeftNav.ExpanderButton, {
      modifiers: (0, _lodash.compact)([!isHighlighted && 'disabled']),
      name: isMenuExpanded ? 'angle-up' : 'angle-down',
      onClick: function onClick() {
        return handleExpandMenuClick(menuKey);
      }
    })
  );
}

MenuItemTitle.propTypes = {
  TextRenderer: _propTypes2.default.func.isRequired,
  expanded: _propTypes2.default.bool.isRequired,
  handleExpandMenuClick: _propTypes2.default.func.isRequired,
  isActive: _propTypes2.default.bool.isRequired,
  isFlyout: _propTypes2.default.bool,
  isHighlighted: _propTypes2.default.bool.isRequired,
  isMenuExpanded: _propTypes2.default.bool.isRequired,
  // eslint-disable-next-line react/no-typos
  menuItem: _menuPropTypes2.default.menuItem.isRequired,
  menuGroupsLoading: _propTypes2.default.bool.isRequired,
  menuKey: _propTypes2.default.string.isRequired,
  onMouseEnter: _propTypes2.default.func.isRequired,
  onMouseLeave: _propTypes2.default.func.isRequired
};

MenuItemTitle.defaultProps = {
  isFlyout: false
};

exports.default = MenuItemTitle;

/***/ }),

/***/ "../node_modules/base-components/build/components/LeftNav/MenuSubItem.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _blocks = __webpack_require__("../node_modules/base-components/build/blocks/index.js");

var _menuPropTypes = __webpack_require__("../node_modules/base-components/build/components/LeftNav/menuPropTypes.js");

var _menuPropTypes2 = _interopRequireDefault(_menuPropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function evaluateMenuSubItemActive(currentPath, itemPath) {
  return currentPath && currentPath.endsWith(itemPath);
}

function MenuSubItem(_ref) {
  var TextRenderer = _ref.TextRenderer,
      isFlyoutOpen = _ref.isFlyoutOpen,
      location = _ref.location,
      menuSubItem = _ref.menuSubItem;

  var isActive = evaluateMenuSubItemActive(location.pathname, menuSubItem.path);

  return _react2.default.createElement(
    _blocks.LeftNav.MenuSubItem,
    null,
    _react2.default.createElement(
      _blocks.LeftNav.MenuSubItemLink,
      {
        'aria-label': menuSubItem.message,
        to: menuSubItem.path,
        modifiers: (0, _lodash.compact)([isActive && 'active', isFlyoutOpen && 'flyout'])
      },
      _react2.default.createElement(TextRenderer, { message: menuSubItem.message })
    )
  );
}

MenuSubItem.propTypes = {
  TextRenderer: _propTypes2.default.func.isRequired,
  isFlyoutOpen: _propTypes2.default.bool,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string.isRequired
  }).isRequired,
  // eslint-disable-next-line react/no-typos
  menuSubItem: _menuPropTypes2.default.menuSubItem.isRequired
};

MenuSubItem.defaultProps = {
  isFlyoutOpen: false
};

exports.default = MenuSubItem;

/***/ }),

/***/ "../node_modules/base-components/build/components/LeftNav/MenuSubItemsList.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _blocks = __webpack_require__("../node_modules/base-components/build/blocks/index.js");

var _MenuSubItem = __webpack_require__("../node_modules/base-components/build/components/LeftNav/MenuSubItem.js");

var _MenuSubItem2 = _interopRequireDefault(_MenuSubItem);

var _menuPropTypes = __webpack_require__("../node_modules/base-components/build/components/LeftNav/menuPropTypes.js");

var _menuPropTypes2 = _interopRequireDefault(_menuPropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function MenuSubItemsList(_ref) {
  var TextRenderer = _ref.TextRenderer,
      isFlyoutOpen = _ref.isFlyoutOpen,
      isMenuExpanded = _ref.isMenuExpanded,
      location = _ref.location,
      menuSubItems = _ref.menuSubItems;

  // NOTE: Use the BEM classnames as a guide to build the components.
  return _react2.default.createElement(
    _blocks.LeftNav.MenusList,
    null,
    (isMenuExpanded || isFlyoutOpen) && menuSubItems.map(function (menuSubItem) {
      return _react2.default.createElement(_MenuSubItem2.default, {
        key: menuSubItem.path,
        location: location,
        menuSubItem: menuSubItem,
        TextRenderer: TextRenderer
      });
    })
  );
}

MenuSubItemsList.propTypes = {
  TextRenderer: _propTypes2.default.func.isRequired,
  isFlyoutOpen: _propTypes2.default.bool.isRequired,
  isMenuExpanded: _propTypes2.default.bool.isRequired,
  // eslint-disable-next-line react/no-typos
  menuSubItems: _menuPropTypes2.default.menuSubItems,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string.isRequired
  }).isRequired
};

MenuSubItemsList.defaultProps = {
  menuSubItems: []
};

exports.default = MenuSubItemsList;

/***/ }),

/***/ "../node_modules/base-components/build/components/LeftNav/MenusList.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _blocks = __webpack_require__("../node_modules/base-components/build/blocks/index.js");

var _MenuItem = __webpack_require__("../node_modules/base-components/build/components/LeftNav/MenuItem.js");

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _menuPropTypes = __webpack_require__("../node_modules/base-components/build/components/LeftNav/menuPropTypes.js");

var _menuPropTypes2 = _interopRequireDefault(_menuPropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function MenusList(_ref) {
  var TextRenderer = _ref.TextRenderer,
      expanded = _ref.expanded,
      expandedMenus = _ref.expandedMenus,
      handleExpandMenuClick = _ref.handleExpandMenuClick,
      location = _ref.location,
      menuGroup = _ref.menuGroup,
      menuGroupsLoading = _ref.menuGroupsLoading;

  return _react2.default.createElement(
    _blocks.LeftNav.MenusList,
    null,
    menuGroup.map(function (menuItem) {
      return _react2.default.createElement(_MenuItem2.default, {
        key: menuItem.icon + ':' + menuItem.path,
        TextRenderer: TextRenderer,
        expanded: expanded,
        expandedMenus: expandedMenus,
        handleExpandMenuClick: handleExpandMenuClick,
        location: location,
        menuItem: menuItem,
        menuGroupsLoading: menuGroupsLoading
      });
    })
  );
}

MenusList.propTypes = {
  TextRenderer: _propTypes2.default.func.isRequired,
  expanded: _propTypes2.default.bool.isRequired,
  expandedMenus: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  handleExpandMenuClick: _propTypes2.default.func.isRequired,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string.isRequired
  }).isRequired,
  // eslint-disable-next-line react/no-typos
  menuGroup: _menuPropTypes2.default.menuGroup.isRequired,
  menuGroupsLoading: _propTypes2.default.bool.isRequired
};

exports.default = MenusList;

/***/ }),

/***/ "../node_modules/base-components/build/components/LeftNav/WindowQuery.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WindowQuery = function (_Component) {
  _inherits(WindowQuery, _Component);

  function WindowQuery() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, WindowQuery);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WindowQuery.__proto__ || Object.getPrototypeOf(WindowQuery)).call.apply(_ref, [this].concat(args))), _this), _this.resizeEventHandler = function () {
      _this.props.onResize({ windowWidth: window.innerWidth });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(WindowQuery, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.resizeEventListener = (0, _lodash.throttle)(this.resizeEventHandler, this.props.DEBOUNCE_TIME_MS);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.resizeEventListener);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.resizeEventListener);
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return WindowQuery;
}(_react.Component);

WindowQuery.propTypes = {
  DEBOUNCE_TIME_MS: _propTypes2.default.number,
  children: _propTypes2.default.node.isRequired,
  onResize: _propTypes2.default.func
};
WindowQuery.defaultProps = {
  DEBOUNCE_TIME_MS: 250,
  onResize: _lodash.noop
};
exports.default = WindowQuery;

/***/ }),

/***/ "../node_modules/base-components/build/components/LeftNav/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LeftNav = LeftNav;

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _blocks = __webpack_require__("../node_modules/base-components/build/blocks/index.js");

var _MenuGroupsList = __webpack_require__("../node_modules/base-components/build/components/LeftNav/MenuGroupsList.js");

var _MenuGroupsList2 = _interopRequireDefault(_MenuGroupsList);

var _menuPropTypes = __webpack_require__("../node_modules/base-components/build/components/LeftNav/menuPropTypes.js");

var _menuPropTypes2 = _interopRequireDefault(_menuPropTypes);

var _withExpandedLeftNav = __webpack_require__("../node_modules/base-components/build/components/LeftNav/withExpandedLeftNav.js");

var _withExpandedLeftNav2 = _interopRequireDefault(_withExpandedLeftNav);

var _withExpandedMenus = __webpack_require__("../node_modules/base-components/build/components/LeftNav/withExpandedMenus.js");

var _withExpandedMenus2 = _interopRequireDefault(_withExpandedMenus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LeftNav(_ref) {
  var TextRenderer = _ref.TextRenderer,
      expanded = _ref.expanded,
      expandedMenus = _ref.expandedMenus,
      handleExpandLeftNavClick = _ref.handleExpandLeftNavClick,
      handleExpandMenuClick = _ref.handleExpandMenuClick,
      location = _ref.location,
      menuGroups = _ref.menuGroups,
      menuGroupsLoading = _ref.menuGroupsLoading;

  var modifiers = (0, _lodash.compact)([expanded && 'expanded']);

  return _react2.default.createElement(
    _blocks.LeftNav,
    { modifiers: modifiers },
    _react2.default.createElement(
      _blocks.LeftNav.MenuBlock,
      { modifiers: modifiers },
      _react2.default.createElement(_MenuGroupsList2.default, {
        TextRenderer: TextRenderer,
        expanded: expanded,
        expandedMenus: expandedMenus,
        handleExpandMenuClick: handleExpandMenuClick,
        location: location,
        menuGroups: menuGroups,
        menuGroupsLoading: menuGroupsLoading
      })
    ),
    _react2.default.createElement(
      _blocks.LeftNav.Footer,
      { modifiers: modifiers },
      _react2.default.createElement(_blocks.LeftNav.ExpanderButton, {
        modifiers: modifiers,
        name: expanded ? 'angle-double-left' : 'angle-double-right',
        onClick: handleExpandLeftNavClick
      })
    )
  );
}

LeftNav.propTypes = {
  TextRenderer: _propTypes2.default.func.isRequired,
  expanded: _propTypes2.default.bool.isRequired,
  expandedMenus: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  handleExpandLeftNavClick: _propTypes2.default.func.isRequired,
  handleExpandMenuClick: _propTypes2.default.func.isRequired,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string.isRequired
  }).isRequired,
  // eslint-disable-next-line react/no-typos
  menuGroups: _menuPropTypes2.default.menuGroups.isRequired,
  menuGroupsLoading: _propTypes2.default.bool
};

LeftNav.defaultProps = {
  menuGroupsLoading: false
};

var WrappedLeftNav = (0, _withExpandedLeftNav2.default)((0, _withExpandedMenus2.default)(LeftNav));
WrappedLeftNav.displayName = 'LeftNav';

exports.default = WrappedLeftNav;

/***/ }),

/***/ "../node_modules/base-components/build/components/LeftNav/menuPropTypes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * isRequiredIf allows a PropType to be optionally required based on a condition function. This
 * condition function will receive the props and should return a boolean. A truthy value will
 * cause the type to be required. This is a way to say, for example, if the component has
 * loading === false, require the data prop _and_ if loading === true don't require the data prop.
 * @param {function} type the PropType to be validated, ex. PropTypes.string
 * @param {function} condition a function that recieves the props and returns a boolean.
 * @returns {function} the PropType, with `.isRequired` if needed.
 */
function isRequiredIf(type, condition) {
  return function (props) {
    for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }

    var test = condition(props) ? type.isRequired : type;
    return test.apply(undefined, [props].concat(rest));
  };
}

var menuSubItem = _propTypes2.default.shape({
  message: _propTypes2.default.string.isRequired,
  path: _propTypes2.default.string.isRequired
});

var menuSubItems = _propTypes2.default.arrayOf(menuSubItem);

var menuItem = _propTypes2.default.shape({
  icon: isRequiredIf(_propTypes2.default.string, function (props) {
    return !props.loading;
  }),
  loading: _propTypes2.default.bool,
  menuSubItems: isRequiredIf(menuSubItems, function (props) {
    return !!(!props.loading && !props.path);
  }),
  message: isRequiredIf(_propTypes2.default.string, function (props) {
    return !props.loading;
  }),
  path: _propTypes2.default.string
});

var menuGroup = _propTypes2.default.arrayOf(menuItem);

var menuGroups = _propTypes2.default.arrayOf(menuGroup);

exports.default = {
  menuSubItem: menuSubItem,
  menuSubItems: menuSubItems,
  menuItem: menuItem,
  menuGroup: menuGroup,
  menuGroups: menuGroups
};

/***/ }),

/***/ "../node_modules/base-components/build/components/LeftNav/withExpandedLeftNav.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WithExpandedLeftNav = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _withSmallWindowDetected = __webpack_require__("../node_modules/base-components/build/components/LeftNav/withSmallWindowDetected.js");

var _withSmallWindowDetected2 = _interopRequireDefault(_withSmallWindowDetected);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Prefers a user's actual expanded selection, falls back to being based on window size.
 * @param {object} props The component's props
 */
function evaluateExpandedState(_ref) {
  var requestedExpanded = _ref.requestedExpanded,
      smallWindowDetected = _ref.smallWindowDetected;

  // requestedExpanded is undefined if no user preference has been set.
  if (requestedExpanded !== undefined) {
    return requestedExpanded;
  }
  return !smallWindowDetected;
}

/**
 * This component handles converting the multiple inputs of left nav expanded state into a final
 * expanded boolean value.
 *
 * The requestedExpanded prop may be one of three values: true, false, or undefined.
 *   - If true or false, the nav is being controlled externally and that value should be
 *     preferred.
 *   - If undefined, no user preference has been set and the expand state should be set
 *     based on the window size.
 * The smallWindowDetected prop monitors window size and updates when a change is detected.
 *
 * onChangeRequestedExpandedState will be called with an object when the user clicks the expander
 *   button. This object will contain a single key (`expanded`) with one of three values:
 *   true, false, or undefined
 */

var WithExpandedLeftNav = exports.WithExpandedLeftNav = function (_Component) {
  _inherits(WithExpandedLeftNav, _Component);

  function WithExpandedLeftNav() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, WithExpandedLeftNav);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = WithExpandedLeftNav.__proto__ || Object.getPrototypeOf(WithExpandedLeftNav)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      expanded: evaluateExpandedState(_this.props)
    }, _this.handleExpandLeftNavClick = function () {
      var expanded = !_this.state.expanded;
      _this.setState({ expanded: expanded });

      // If the user selects to expand the nav at the large screen, clear the user's
      // preference by setting it to undefined. This allows the nav to collapse
      // again if the screen shrinks. Otherwise, set it to the expanded value.
      if (expanded && !_this.props.smallWindowDetected) {
        _this.props.onChangeRequestedExpandedState({ requestedExpanded: undefined });
      } else {
        _this.props.onChangeRequestedExpandedState({ requestedExpanded: expanded });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(WithExpandedLeftNav, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // The user's preference is handled elsewhere. This only updates the
      // expanded state based on window width.
      if (nextProps.smallWindowDetected !== this.props.smallWindowDetected) {
        var expanded = evaluateExpandedState(nextProps);
        this.setState({ expanded: expanded });
      }
    }

    /**
     * Includes logic for updating the left nav expanded state, and updating the
     * app level component via onChangeRequestedExpandedState.
     */

  }, {
    key: 'render',
    value: function render() {
      // "consume" the props that no longer need to be passed down for proper functionality
      var passThroughProps = (0, _lodash.omit)(this.props, ['onChangeRequestedExpandedState', 'render', 'smallWindowDetected']);

      return this.props.render(_extends({}, passThroughProps, {
        expanded: this.state.expanded,
        handleExpandLeftNavClick: this.handleExpandLeftNavClick
      }));
    }
  }]);

  return WithExpandedLeftNav;
}(_react.Component);

/* istanbul ignore next */


WithExpandedLeftNav.propTypes = {
  onChangeRequestedExpandedState: _propTypes2.default.func,
  render: _propTypes2.default.func.isRequired,
  // Linting tools should do better :,( This prop is being used, and needs validation.
  // eslint-disable-next-line react/no-unused-prop-types
  requestedExpanded: _propTypes2.default.bool,
  smallWindowDetected: _propTypes2.default.bool.isRequired
};
WithExpandedLeftNav.defaultProps = {
  onChangeRequestedExpandedState: _lodash.noop,
  requestedExpanded: undefined
};
var withExpandedLeftNav = function withExpandedLeftNav(WrappedComponent) {
  function RenderPropComponent(props) {
    return _react2.default.createElement(WithExpandedLeftNav, _extends({}, props, {
      render: function render(componentProps) {
        return _react2.default.createElement(WrappedComponent, componentProps);
      }
    }));
  }

  return (0, _withSmallWindowDetected2.default)(RenderPropComponent);
};

exports.default = withExpandedLeftNav;

/***/ }),

/***/ "../node_modules/base-components/build/components/LeftNav/withExpandedMenus.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WithExpandedMenus = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WithExpandedMenus = exports.WithExpandedMenus = function (_Component) {
  _inherits(WithExpandedMenus, _Component);

  function WithExpandedMenus() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, WithExpandedMenus);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WithExpandedMenus.__proto__ || Object.getPrototypeOf(WithExpandedMenus)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      expandedMenus: _this.props.expandedMenus

      /**
       * Includes logic for updating the expanded menus in state, and updating the
       * app level component via onChangeExpandedMenus.
       * @param {string} menuKey a key used to identify a specific menu.
       */
    }, _this.handleExpandMenuClick = function (menuKey) {
      var prevExpandedMenus = _this.state.expandedMenus;
      // adds or removes the menuKey based on it's existence in the current expanded menus array.

      var expandedMenus = prevExpandedMenus.includes(menuKey) ? (0, _lodash.without)(prevExpandedMenus, menuKey) : prevExpandedMenus.concat(menuKey);

      _this.setState({ expandedMenus: expandedMenus });

      // Alerts the app level component to the new expanded menus. Mainly used for
      // persistence to local storage and setting initial state.
      _this.props.onChangeExpandedMenus({ expandedMenus: expandedMenus });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(WithExpandedMenus, [{
    key: 'render',
    value: function render() {
      // "consume" the props that no longer need to be passed down for proper functionality
      var passThroughProps = (0, _lodash.omit)(this.props, ['onChangeExpandedMenus', 'render']);

      return this.props.render(_extends({}, passThroughProps, {
        expandedMenus: this.state.expandedMenus,
        handleExpandMenuClick: this.handleExpandMenuClick
      }));
    }
  }]);

  return WithExpandedMenus;
}(_react.Component);

/* istanbul ignore next */


WithExpandedMenus.propTypes = {
  expandedMenus: _propTypes2.default.arrayOf(_propTypes2.default.string),
  onChangeExpandedMenus: _propTypes2.default.func,
  render: _propTypes2.default.func.isRequired
};
WithExpandedMenus.defaultProps = {
  expandedMenus: [],
  onChangeExpandedMenus: _lodash.noop
};
var withExpandedMenus = function withExpandedMenus(WrappedComponent) {
  return function (props) {
    return _react2.default.createElement(WithExpandedMenus, _extends({}, props, {
      render: function render(componentProps) {
        return _react2.default.createElement(WrappedComponent, componentProps);
      }
    }));
  };
};

exports.default = withExpandedMenus;

/***/ }),

/***/ "../node_modules/base-components/build/components/LeftNav/withSmallWindowDetected.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WithSmallWindowDetected = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _WindowQuery = __webpack_require__("../node_modules/base-components/build/components/LeftNav/WindowQuery.js");

var _WindowQuery2 = _interopRequireDefault(_WindowQuery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WithSmallWindowDetected = exports.WithSmallWindowDetected = function (_Component) {
  _inherits(WithSmallWindowDetected, _Component);

  function WithSmallWindowDetected() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, WithSmallWindowDetected);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WithSmallWindowDetected.__proto__ || Object.getPrototypeOf(WithSmallWindowDetected)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      smallWindowDetected: false
    }, _this.onResizeWindow = function (_ref2) {
      var windowWidth = _ref2.windowWidth;

      _this.updateSmallWindowDetected(windowWidth);
    }, _this.updateSmallWindowDetected = function (windowWidth) {
      var autoCollapseLeftNavPx = _this.props.theme.dimensions.autoCollapseLeftNavPx;


      _this.setState({ smallWindowDetected: windowWidth < autoCollapseLeftNavPx });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(WithSmallWindowDetected, [{
    key: 'componentDidMount',


    /**
     * On initial mount, update smallWindowDetected state based on window size.
     * @return {undefined} This method is expected to trigger a state mutation, not return a value.
     */
    value: function componentDidMount() {
      this.updateSmallWindowDetected(window.innerWidth);
    }

    /**
     * event handler for resizing the window
     * @param  {number} windowWidth  The width of the window after resizing.
     * @return {undefined} This method is expected to mutate state, not return a value.
     */


    /**
     * Sets a new value for this.state.smallWindowDetected based on the current window width
     * @param  {number} windowWidth  The width of the window to be used in determining the
     *                               smallWindowDetected state
     * @return {undefined} This method is expected to mutate state, not return a value.
     */

  }, {
    key: 'render',
    value: function render() {
      var passThroughProps = (0, _lodash.omit)(this.props, ['render', 'theme']);

      return _react2.default.createElement(
        _WindowQuery2.default,
        { onResize: this.onResizeWindow },
        this.props.render(_extends({
          smallWindowDetected: this.state.smallWindowDetected
        }, passThroughProps))
      );
    }
  }]);

  return WithSmallWindowDetected;
}(_react.Component);

/* istanbul ignore next */


WithSmallWindowDetected.propTypes = {
  render: _propTypes2.default.func.isRequired,
  theme: _propTypes2.default.shape({
    dimensions: _propTypes2.default.shape({
      autoCollapseLeftNavPx: _propTypes2.default.number.isRequired
    }).isRequired
  }).isRequired
};
var withSmallWindowDetected = function withSmallWindowDetected(WrappedComponent) {
  function RenderPropComponent(props) {
    return _react2.default.createElement(WithSmallWindowDetected, _extends({}, props, {
      render: function render(componentProps) {
        return _react2.default.createElement(WrappedComponent, componentProps);
      }
    }));
  }

  return (0, _styledComponents.withTheme)(RenderPropComponent);
};

exports.default = withSmallWindowDetected;

/***/ }),

/***/ "../node_modules/base-components/build/components/MessageSmall/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MessageSmall = __webpack_require__("../node_modules/base-components/build/blocks/MessageSmall/index.js");

var _MessageSmall2 = _interopRequireDefault(_MessageSmall);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function MessageSmall(_ref) {
  var children = _ref.children,
      type = _ref.type;

  return _react2.default.createElement(
    _MessageSmall2.default,
    null,
    _react2.default.createElement(_MessageSmall2.default.Icon, { type: type }),
    _react2.default.createElement(
      _MessageSmall2.default.Text,
      null,
      children
    )
  );
}

MessageSmall.propTypes = {
  children: _propTypes2.default.node.isRequired,
  type: _propTypes2.default.oneOf(['danger', 'info', 'success', 'warning']).isRequired
};

exports.default = MessageSmall;

/***/ }),

/***/ "../node_modules/base-components/build/components/Popover/Content.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Popover = __webpack_require__("../node_modules/base-components/build/blocks/Popover/index.js");

var _Popover2 = _interopRequireDefault(_Popover);

var _constants = __webpack_require__("../node_modules/base-components/build/components/Popover/constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Content(_ref, context) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, ['children']);

  var _context$POPOVER_CONT = context[_constants.POPOVER_CONTEXT],
      arrow = _context$POPOVER_CONT.arrow,
      position = _context$POPOVER_CONT.position,
      showPopover = _context$POPOVER_CONT.showPopover,
      zIndex = _context$POPOVER_CONT.zIndex;


  if (!showPopover) {
    return null;
  }

  return _react2.default.createElement(
    _Popover2.default.Content,
    _extends({ modifiers: [position], zIndex: zIndex }, rest),
    children,
    arrow && _react2.default.createElement(_Popover2.default.Arrow, { modifiers: [position] })
  );
}

Content.contextTypes = _defineProperty({}, _constants.POPOVER_CONTEXT, _propTypes2.default.object.isRequired);

Content.propTypes = {
  children: _propTypes2.default.node.isRequired
};

exports.default = Content;

/***/ }),

/***/ "../node_modules/base-components/build/components/Popover/Target.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Popover = __webpack_require__("../node_modules/base-components/build/blocks/Popover/index.js");

var _Popover2 = _interopRequireDefault(_Popover);

var _constants = __webpack_require__("../node_modules/base-components/build/components/Popover/constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function Target(props, context) {
  var _context$POPOVER_CONT = context[_constants.POPOVER_CONTEXT],
      handleToggle = _context$POPOVER_CONT.handleToggle,
      handleHover = _context$POPOVER_CONT.handleHover;


  return _react2.default.createElement(
    _Popover2.default.Target,
    _extends({ onClick: handleToggle, onMouseEnter: handleHover }, props),
    props.children
  );
}

Target.contextTypes = _defineProperty({}, _constants.POPOVER_CONTEXT, _propTypes2.default.object.isRequired);

Target.propTypes = {
  children: _propTypes2.default.node.isRequired
};

exports.default = Target;

/***/ }),

/***/ "../node_modules/base-components/build/components/Popover/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// eslint-disable-next-line import/prefer-default-export
var POPOVER_CONTEXT = exports.POPOVER_CONTEXT = '__POPOVER_CONTEXT__';

/***/ }),

/***/ "../node_modules/base-components/build/components/Popover/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Popover = __webpack_require__("../node_modules/base-components/build/blocks/Popover/index.js");

var _Popover2 = _interopRequireDefault(_Popover);

var _Content = __webpack_require__("../node_modules/base-components/build/components/Popover/Content.js");

var _Content2 = _interopRequireDefault(_Content);

var _Target = __webpack_require__("../node_modules/base-components/build/components/Popover/Target.js");

var _Target2 = _interopRequireDefault(_Target);

var _constants = __webpack_require__("../node_modules/base-components/build/components/Popover/constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Popover = function (_Component) {
  _inherits(Popover, _Component);

  function Popover() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Popover);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Popover.__proto__ || Object.getPrototypeOf(Popover)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      showPopover: _this.props.showPopover
    }, _this.setInnerRef = function (node) {
      _this.innerRef = node;
      return _this.innerRef;
    }, _this.handleClickOutside = function (e) {
      if (!_this.innerRef.contains(e.target)) {
        _this.setState({ showPopover: false });
      }
    }, _this.handleHover = function () {
      if (_this.props.showOnHover) {
        _this.setState({ showPopover: true });
      }
    }, _this.togglePopover = function () {
      _this.setState({ showPopover: !_this.state.showPopover });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Popover, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return _defineProperty({}, _constants.POPOVER_CONTEXT, {
        arrow: this.props.arrow,
        handleHover: this.handleHover,
        handleToggle: this.togglePopover,
        position: this.props.position,
        showPopover: this.state.showPopover,
        zIndex: this.props.zIndex
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: 'filterPopoverModifiers',
    value: function filterPopoverModifiers() {
      var position = this.props.position;

      var popoverModifiers = Object.keys(_Popover2.default.modifiers);
      return popoverModifiers.includes(position) ? [position] : [];
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          rest = _objectWithoutProperties(_props, ['children']);

      return _react2.default.createElement(
        _Popover2.default,
        _extends({ innerRef: this.setInnerRef, modifiers: this.filterPopoverModifiers() }, rest),
        children
      );
    }
  }]);

  return Popover;
}(_react.Component);

Popover.Content = _Content2.default;
Popover.Target = _Target2.default;
Popover.modifiers = _Popover2.default.modifiers;
Popover.childContextTypes = _defineProperty({}, _constants.POPOVER_CONTEXT, _propTypes2.default.object.isRequired);
Popover.propTypes = {
  arrow: _propTypes2.default.bool,
  children: _propTypes2.default.node.isRequired,
  position: _propTypes2.default.oneOf(['bottom', 'bottomLeft', 'bottomRight', 'left', 'leftBottom', 'leftTop', 'right', 'rightBottom', 'rightTop', 'top', 'topLeft', 'topRight']),
  showOnHover: _propTypes2.default.bool,
  showPopover: _propTypes2.default.bool,
  zIndex: _propTypes2.default.number
};
Popover.defaultProps = {
  zIndex: 1,
  arrow: true,
  position: 'top',
  showOnHover: false,
  showPopover: false
};
exports.default = Popover;

/***/ }),

/***/ "../node_modules/base-components/build/components/Tabs/Content.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/base-components/node_modules/styled-components-reactive-grid/dist/index.js");

var _constants = __webpack_require__("../node_modules/base-components/build/components/Tabs/constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var StyledContent = (0, _decisivUiUtils.buildStyledComponent)('Tabs.Content', (0, _styledComponents2.default)(_styledComponentsReactiveGrid.Row));

function Content(_ref, context) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ['children']);

  var activeTab = context[_constants.TOGGLE_TAB_CONTEXT].activeTab;

  var activeContent = _react2.default.Children.map(children, function (child, i) {
    return activeTab === i ? child : null;
  });

  return _react2.default.createElement(
    StyledContent,
    props,
    activeContent
  );
}

Content.contextTypes = _defineProperty({}, _constants.TOGGLE_TAB_CONTEXT, _propTypes2.default.object.isRequired);

Content.propTypes = {
  children: _propTypes2.default.node.isRequired
};

exports.default = Content;

/***/ }),

/***/ "../node_modules/base-components/build/components/Tabs/List.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TabList = __webpack_require__("../node_modules/base-components/build/blocks/TabList/index.js");

var _TabList2 = _interopRequireDefault(_TabList);

var _constants = __webpack_require__("../node_modules/base-components/build/components/Tabs/constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function List(_ref, context) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ['children']);

  var _context$TOGGLE_TAB_C = context[_constants.TOGGLE_TAB_CONTEXT],
      activeTab = _context$TOGGLE_TAB_C.activeTab,
      handleTabClick = _context$TOGGLE_TAB_C.handleTabClick;


  var mappedChildren = _react2.default.Children.map(children, function (child, i) {
    var active = activeTab === i && 'active';
    return _react2.default.cloneElement(child, {
      modifiers: (0, _lodash.compact)(child.props.modifiers.concat(active)),
      onClick: function onClick(e) {
        return handleTabClick(e, i);
      }
    });
  });
  return _react2.default.createElement(
    _TabList2.default,
    props,
    mappedChildren
  );
}

List.propTypes = {
  children: _propTypes2.default.node.isRequired
};

List.contextTypes = _defineProperty({}, _constants.TOGGLE_TAB_CONTEXT, _propTypes2.default.object.isRequired);

exports.default = List;

/***/ }),

/***/ "../node_modules/base-components/build/components/Tabs/Menu.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/base-components/node_modules/styled-components-reactive-grid/dist/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Tabs.Menu', (0, _styledComponents2.default)(_styledComponentsReactiveGrid.Row));

/***/ }),

/***/ "../node_modules/base-components/build/components/Tabs/Wrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/base-components/node_modules/styled-components-reactive-grid/dist/index.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Tabs(_ref) {
  var modifiers = _ref.modifiers,
      rest = _objectWithoutProperties(_ref, ['modifiers']);

  var defaultModifiers = ['fluid'];
  var tabsModifiers = defaultModifiers.concat(modifiers);
  return _react2.default.createElement(_styledComponentsReactiveGrid.Container, _extends({ modifiers: tabsModifiers }, rest));
}

Tabs.defaultProps = {
  modifiers: []
};

Tabs.propTypes = {
  modifiers: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Tabs', (0, _styledComponents2.default)(Tabs));

/***/ }),

/***/ "../node_modules/base-components/build/components/Tabs/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// eslint-disable-next-line import/prefer-default-export
var TOGGLE_TAB_CONTEXT = exports.TOGGLE_TAB_CONTEXT = '__TOGGLE_TAB_CONTEXT__';

/***/ }),

/***/ "../node_modules/base-components/build/components/Tabs/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _TabList = __webpack_require__("../node_modules/base-components/build/blocks/TabList/index.js");

var _TabList2 = _interopRequireDefault(_TabList);

var _Content = __webpack_require__("../node_modules/base-components/build/components/Tabs/Content.js");

var _Content2 = _interopRequireDefault(_Content);

var _List = __webpack_require__("../node_modules/base-components/build/components/Tabs/List.js");

var _List2 = _interopRequireDefault(_List);

var _Menu = __webpack_require__("../node_modules/base-components/build/components/Tabs/Menu.js");

var _Menu2 = _interopRequireDefault(_Menu);

var _Wrapper = __webpack_require__("../node_modules/base-components/build/components/Tabs/Wrapper.js");

var _Wrapper2 = _interopRequireDefault(_Wrapper);

var _constants = __webpack_require__("../node_modules/base-components/build/components/Tabs/constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Tabs = function (_Component) {
  _inherits(Tabs, _Component);

  function Tabs() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Tabs);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      activeTab: _this.props.activeTab
    }, _this.toggleTab = function (e, i) {
      _this.props.onTabChange(e, i);
      _this.setState({ activeTab: i });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Tabs, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return _defineProperty({}, _constants.TOGGLE_TAB_CONTEXT, {
        activeTab: this.state.activeTab,
        handleTabClick: this.toggleTab
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _Wrapper2.default,
        this.props,
        this.props.children
      );
    }
  }]);

  return Tabs;
}(_react.Component);

Tabs.Content = _Content2.default;
Tabs.Menu = _Menu2.default;
Tabs.List = _List2.default;
Tabs.ListItem = _TabList2.default.Item;
Tabs.ListItemIcon = _TabList2.default.Icon;
Tabs.ListItemLink = _TabList2.default.ItemLink;
Tabs.ListItemButton = _TabList2.default.ItemButton;
Tabs.childContextTypes = _defineProperty({}, _constants.TOGGLE_TAB_CONTEXT, _propTypes2.default.object.isRequired);
Tabs.propTypes = {
  activeTab: _propTypes2.default.number,
  children: _propTypes2.default.node.isRequired,
  onTabChange: _propTypes2.default.func
};
Tabs.defaultProps = {
  activeTab: 0,
  onTabChange: _lodash.noop
};
exports.default = Tabs;

/***/ }),

/***/ "../node_modules/base-components/build/components/Tag/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _blocks = __webpack_require__("../node_modules/base-components/build/blocks/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Tag(_ref) {
  var children = _ref.children,
      id = _ref.id,
      onClickClose = _ref.onClickClose;

  return _react2.default.createElement(
    _blocks.Tag,
    null,
    _react2.default.createElement(
      _blocks.Tag.Text,
      null,
      children
    ),
    _react2.default.createElement(
      _blocks.Tag.CloseButton,
      { onClick: function onClick() {
          return onClickClose(id);
        } },
      _react2.default.createElement(_blocks.Tag.CloseButtonIcon, null)
    )
  );
}

Tag.propTypes = {
  children: _propTypes2.default.node.isRequired,
  id: _propTypes2.default.string.isRequired,
  onClickClose: _propTypes2.default.func.isRequired
};

exports.default = Tag;

/***/ }),

/***/ "../node_modules/base-components/build/components/Tooltip/Content.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _Tooltip = __webpack_require__("../node_modules/base-components/build/blocks/Tooltip/index.js");

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _constants = __webpack_require__("../node_modules/base-components/build/components/Tooltip/constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Content(_ref, context) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, ['children']);

  var _context$TOOLTIP_CONT = context[_constants.TOOLTIP_CONTEXT],
      position = _context$TOOLTIP_CONT.position,
      showTooltip = _context$TOOLTIP_CONT.showTooltip,
      zIndex = _context$TOOLTIP_CONT.zIndex;


  if (!showTooltip) {
    return null;
  }

  return _react2.default.createElement(
    _Tooltip2.default.Content,
    _extends({ modifiers: [position], zIndex: zIndex }, rest),
    children,
    _react2.default.createElement(_Tooltip2.default.Arrow, { modifiers: [position] })
  );
}

Content.contextTypes = _defineProperty({}, _constants.TOOLTIP_CONTEXT, _propTypes2.default.object.isRequired);

Content.displayName = 'Tooltip__Content';

Content.propTypes = {
  children: _propTypes2.default.node.isRequired
};

exports.default = Content;

/***/ }),

/***/ "../node_modules/base-components/build/components/Tooltip/Target.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _Tooltip = __webpack_require__("../node_modules/base-components/build/blocks/Tooltip/index.js");

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _constants = __webpack_require__("../node_modules/base-components/build/components/Tooltip/constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function Target(props, context) {
  var _context$TOOLTIP_CONT = context[_constants.TOOLTIP_CONTEXT],
      onMouseEnterTarget = _context$TOOLTIP_CONT.onMouseEnterTarget,
      onMouseLeaveTarget = _context$TOOLTIP_CONT.onMouseLeaveTarget;


  return _react2.default.createElement(_Tooltip2.default.Target, _extends({
    onMouseEnter: onMouseEnterTarget,
    onMouseLeave: onMouseLeaveTarget
  }, props));
}

Target.contextTypes = _defineProperty({}, _constants.TOOLTIP_CONTEXT, _propTypes2.default.object.isRequired);

Target.displayName = 'Tooltip__Target';

Target.propTypes = {
  children: _propTypes2.default.node.isRequired
};

exports.default = Target;

/***/ }),

/***/ "../node_modules/base-components/build/components/Tooltip/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// eslint-disable-next-line import/prefer-default-export
var TOOLTIP_CONTEXT = exports.TOOLTIP_CONTEXT = '__BC_TOOLTIP_CONTEXT__';

/***/ }),

/***/ "../node_modules/base-components/build/components/Tooltip/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _Tooltip = __webpack_require__("../node_modules/base-components/build/blocks/Tooltip/index.js");

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _constants = __webpack_require__("../node_modules/base-components/build/components/Tooltip/constants.js");

var _Content = __webpack_require__("../node_modules/base-components/build/components/Tooltip/Content.js");

var _Content2 = _interopRequireDefault(_Content);

var _Target = __webpack_require__("../node_modules/base-components/build/components/Tooltip/Target.js");

var _Target2 = _interopRequireDefault(_Target);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Tooltip = function (_Component) {
  _inherits(Tooltip, _Component);

  function Tooltip() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Tooltip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      showTooltip: false
    }, _this.onMouseEnterTarget = function () {
      _this.setState({ showTooltip: true });
    }, _this.onMouseLeaveTarget = function () {
      _this.setState({ showTooltip: false });
    }, _this.filteredModifiers = function () {
      var position = _this.props.position;

      var tooltipModifiers = Object.keys(_Tooltip2.default.modifiers);
      return tooltipModifiers.includes(position) ? [position] : [];
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Tooltip, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return _defineProperty({}, _constants.TOOLTIP_CONTEXT, {
        onMouseEnterTarget: this.onMouseEnterTarget,
        onMouseLeaveTarget: this.onMouseLeaveTarget,
        position: this.props.position,
        showTooltip: this.state.showTooltip,
        zIndex: this.props.zIndex
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          rest = _objectWithoutProperties(_props, ['children']);

      return _react2.default.createElement(
        _Tooltip2.default,
        _extends({}, rest, {
          modifiers: this.filteredModifiers()
        }),
        children
      );
    }
  }]);

  return Tooltip;
}(_react.Component);

Tooltip.Content = _Content2.default;
Tooltip.Target = _Target2.default;
Tooltip.modifiers = _Tooltip2.default.modifiers;
Tooltip.childContextTypes = _defineProperty({}, _constants.TOOLTIP_CONTEXT, _propTypes2.default.object.isRequired);
Tooltip.propTypes = {
  children: _propTypes2.default.node.isRequired,
  position: _propTypes2.default.oneOf(['bottom', 'left', 'right', 'top']),
  zIndex: _propTypes2.default.number
};
Tooltip.defaultProps = {
  zIndex: 1,
  position: 'top'
};
exports.default = Tooltip;

/***/ }),

/***/ "../node_modules/base-components/build/components/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Accordion = __webpack_require__("../node_modules/base-components/build/components/Accordion/index.js");

var _Accordion2 = _interopRequireDefault(_Accordion);

var _Avatar = __webpack_require__("../node_modules/base-components/build/components/Avatar/index.js");

var _Avatar2 = _interopRequireDefault(_Avatar);

var _ButtonToggle = __webpack_require__("../node_modules/base-components/build/components/ButtonToggle/index.js");

var _ButtonToggle2 = _interopRequireDefault(_ButtonToggle);

var _ButtonMicro = __webpack_require__("../node_modules/base-components/build/components/ButtonMicro/index.js");

var _ButtonMicro2 = _interopRequireDefault(_ButtonMicro);

var _Checkbox = __webpack_require__("../node_modules/base-components/build/components/Checkbox/index.js");

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _DateSelectors = __webpack_require__("../node_modules/base-components/build/components/DateSelectors/index.js");

var _Dropdown = __webpack_require__("../node_modules/base-components/build/components/Dropdown/index.js");

var _Dropdown2 = _interopRequireDefault(_Dropdown);

var _InputField = __webpack_require__("../node_modules/base-components/build/components/InputField/index.js");

var _InputField2 = _interopRequireDefault(_InputField);

var _InputGroup = __webpack_require__("../node_modules/base-components/build/components/InputGroup/index.js");

var _InputGroup2 = _interopRequireDefault(_InputGroup);

var _InputText = __webpack_require__("../node_modules/base-components/build/components/InputText/index.js");

var _InputText2 = _interopRequireDefault(_InputText);

var _LeftNav = __webpack_require__("../node_modules/base-components/build/components/LeftNav/index.js");

var _LeftNav2 = _interopRequireDefault(_LeftNav);

var _MessageSmall = __webpack_require__("../node_modules/base-components/build/components/MessageSmall/index.js");

var _MessageSmall2 = _interopRequireDefault(_MessageSmall);

var _Popover = __webpack_require__("../node_modules/base-components/build/components/Popover/index.js");

var _Popover2 = _interopRequireDefault(_Popover);

var _Tabs = __webpack_require__("../node_modules/base-components/build/components/Tabs/index.js");

var _Tabs2 = _interopRequireDefault(_Tabs);

var _Tag = __webpack_require__("../node_modules/base-components/build/components/Tag/index.js");

var _Tag2 = _interopRequireDefault(_Tag);

var _Tooltip = __webpack_require__("../node_modules/base-components/build/components/Tooltip/index.js");

var _Tooltip2 = _interopRequireDefault(_Tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// this is the primary export for Components
// The primary export for this library is lib/index.js
module.exports = {
  Accordion: _Accordion2.default,
  Avatar: _Avatar2.default,
  ButtonToggle: _ButtonToggle2.default,
  ButtonMicro: _ButtonMicro2.default,
  Checkbox: _Checkbox2.default,
  DateRangeSelector: _DateSelectors.DateRangeSelector,
  DateSelector: _DateSelectors.DateSelector,
  Dropdown: _Dropdown2.default,
  InputField: _InputField2.default,
  InputGroup: _InputGroup2.default,
  InputText: _InputText2.default,
  LeftNav: _LeftNav2.default,
  MessageSmall: _MessageSmall2.default,
  Popover: _Popover2.default,
  Tabs: _Tabs2.default,
  Tag: _Tag2.default,
  Tooltip: _Tooltip2.default
};

/***/ }),

/***/ "../node_modules/base-components/build/elements/A/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _Link = __webpack_require__("../node_modules/base-components/build/styles/common/Link.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  'aria-label': _propTypes2.default.string.isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('A', _styledComponents2.default.a, _Link.styles, {
  modifierConfig: _Link.modifierConfig,
  propTypes: propTypes,
  themePropTypes: _Link.themePropTypes
});

/***/ }),

/***/ "../node_modules/base-components/build/elements/ButtonLink/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  active: function active(_ref) {
    var theme = _ref.theme;
    return {
      styles: '\n      color: ' + theme.colors.base.linkHover + ';\n      text-decoration: underline;\n    '
    };
  },

  disabled: function disabled() {
    return {
      styles: '\n      opacity: 0.5;\n      pointer-events: none;\n    '
    };
  },

  small: function small() {
    return '\n    font-size: ' + (0, _decisivUiUtils.px2rem)(12) + ';\n  ';
  }
}; /**
    * Component: ButtonLink
    *
    */

var styles = function styles(_ref2) {
  var theme = _ref2.theme;
  return '\n  background: transparent;\n  border: none;\n  color: ' + theme.colors.base.link + ';\n  cursor: pointer;\n  font-size: ' + (0, _decisivUiUtils.px2rem)(10) + ';\n  line-height: ' + (0, _decisivUiUtils.px2rem)(16) + ';\n  outline: none;\n  padding: 0;\n  text-decoration: none;\n  text-transform: capitalize;\n  white-space: nowrap;\n  &:hover {\n    color: ' + theme.colors.base.linkHover + ';\n    text-decoration: underline;\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      link: _propTypes2.default.string.isRequired,
      linkHover: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('ButtonLink', _styledComponents2.default.button, styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

/***/ }),

/***/ "../node_modules/base-components/build/elements/Divider/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  chrome400: function chrome400(_ref) {
    var theme = _ref.theme;
    return {
      styles: 'border-color: ' + theme.colors.base.chrome400 + ';'
    };
  },

  vertical: function vertical() {
    return {
      styles: '\n      border-left-width: 1px;\n      border-left-style: solid;\n      height: 100%;\n    '
    };
  }
};

var styles = function styles(_ref2) {
  var theme = _ref2.theme;
  return '\n  border-bottom: 1px solid;\n  border-color: ' + theme.colors.base.chrome200 + ';\n  position: relative;\n  width: auto;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome200: _propTypes2.default.string.isRequired,
      chrome400: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Divider', _styledComponents2.default.div, styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

/***/ }),

/***/ "../node_modules/base-components/build/elements/GhostIndicator/GhostAnimation.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  0% {\n    background-position: 0% 50%;\n  }\n\n  50% {\n    background-position: 100% 51%;\n  }\n\n  100% {\n    background-position: 0% 50%;\n  }\n'], ['\n  0% {\n    background-position: 0% 50%;\n  }\n\n  50% {\n    background-position: 100% 51%;\n  }\n\n  100% {\n    background-position: 0% 50%;\n  }\n']);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var GhostAnimation = (0, _styledComponents.keyframes)(_templateObject);

exports.default = GhostAnimation;

/***/ }),

/***/ "../node_modules/base-components/build/elements/GhostIndicator/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _GhostAnimation = __webpack_require__("../node_modules/base-components/build/elements/GhostIndicator/GhostAnimation.js");

var _GhostAnimation2 = _interopRequireDefault(_GhostAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {

  chrome200: function chrome200(_ref) {
    var theme = _ref.theme;
    return {
      styles: '\n      background: linear-gradient(90deg, ' + theme.colors.base.chrome200 + ' 0%,\n      ' + theme.colors.base.chrome300 + ' 16.42%,\n      ' + theme.colors.base.chrome200 + ' 100%);\n    '
    };
  },

  expanded: function expanded() {
    return {
      styles: '\n      height: ' + (0, _decisivUiUtils.px2rem)(24) + ';\n      margin: ' + (0, _decisivUiUtils.px2rem)(12) + ' ' + (0, _decisivUiUtils.px2rem)(6) + ';\n    '
    };
  },

  gapBottom: function gapBottom() {
    return {
      styles: 'margin-bottom: ' + (0, _decisivUiUtils.px2rem)(30) + ';'
    };
  },

  gapRight: function gapRight() {
    return {
      styles: 'margin-right: ' + (0, _decisivUiUtils.px2rem)(12) + ';'
    };
  },

  smallWidth: function smallWidth() {
    return {
      styles: '\n      flex: none;\n      width: ' + (0, _decisivUiUtils.px2rem)(20) + ';\n    '
    };
  },

  wide: function wide() {
    return {
      styles: '\n      width: 80%;\n    '
    };
  }
};

/* istanbul ignore next */
var styles = function styles(_ref2) {
  var theme = _ref2.theme;
  return '\n  animation: ' + _GhostAnimation2.default + ' 2s ease infinite;\n  background-size: 600% 600% !important;\n  background: linear-gradient(90deg, ' + theme.colors.base.chrome100 + ' 0%,\n              ' + theme.colors.base.chrome200 + ' 24.85%,\n              ' + theme.colors.base.chrome100 + ' 100%);\n  border-radius: ' + theme.dimensions.borderRadius + ';\n  height: ' + (0, _decisivUiUtils.px2rem)(20) + ';\n  margin: ' + (0, _decisivUiUtils.px2rem)(8) + ' ' + (0, _decisivUiUtils.px2rem)(2) + ';\n  flex: 1;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome100: _propTypes2.default.string.isRequired,
      chrome200: _propTypes2.default.string.isRequired,
      chrome300: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired,
  dimensions: _propTypes2.default.shape({
    borderRadius: _propTypes2.default.string.isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('GhostIndicator', _styledComponents2.default.div, styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

/***/ }),

/***/ "../node_modules/base-components/build/elements/H1/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _modifiers = __webpack_require__("../node_modules/base-components/build/modifiers/index.js");

var _constants = __webpack_require__("../node_modules/base-components/build/utils/constants.js");

var _em2rem = __webpack_require__("../node_modules/base-components/build/utils/em2rem.js");

var _em2rem2 = _interopRequireDefault(_em2rem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = _modifiers.fontWeights;
var DEFAULT_FONT_SIZE = 32;

var styles = function styles(_ref) {
  var theme = _ref.theme;
  return '\n  color: ' + theme.colors.base.text + ';\n  font-size: ' + (0, _decisivUiUtils.px2rem)(DEFAULT_FONT_SIZE) + ';\n  line-height: ' + (0, _em2rem2.default)(DEFAULT_FONT_SIZE, _constants.HEADER_LINE_HEIGHT) + ';\n  margin: 0;\n';
};

var customThemePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

var themePropTypes = _extends({}, _modifiers.fontWeightPropTypes, customThemePropTypes);

exports.default = (0, _decisivUiUtils.buildStyledComponent)('H1', _styledComponents2.default.h1, styles, {
  modifierConfig: modifierConfig,
  themePropTypes: themePropTypes
});

/***/ }),

/***/ "../node_modules/base-components/build/elements/H2/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _modifiers = __webpack_require__("../node_modules/base-components/build/modifiers/index.js");

var _constants = __webpack_require__("../node_modules/base-components/build/utils/constants.js");

var _em2rem = __webpack_require__("../node_modules/base-components/build/utils/em2rem.js");

var _em2rem2 = _interopRequireDefault(_em2rem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = _modifiers.fontWeights;
var DEFAULT_FONT_SIZE = 26;

var styles = function styles(_ref) {
  var theme = _ref.theme;
  return '\n  color: ' + theme.colors.base.text + ';\n  font-size: ' + (0, _decisivUiUtils.px2rem)(DEFAULT_FONT_SIZE) + ';\n  line-height: ' + (0, _em2rem2.default)(DEFAULT_FONT_SIZE, _constants.HEADER_LINE_HEIGHT) + ';\n  margin: 0;\n';
};

var customThemePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

var themePropTypes = _extends({}, _modifiers.fontWeightPropTypes, customThemePropTypes);

exports.default = (0, _decisivUiUtils.buildStyledComponent)('H2', _styledComponents2.default.h2, styles, {
  modifierConfig: modifierConfig,
  themePropTypes: themePropTypes
});

/***/ }),

/***/ "../node_modules/base-components/build/elements/H3/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _modifiers = __webpack_require__("../node_modules/base-components/build/modifiers/index.js");

var _constants = __webpack_require__("../node_modules/base-components/build/utils/constants.js");

var _em2rem = __webpack_require__("../node_modules/base-components/build/utils/em2rem.js");

var _em2rem2 = _interopRequireDefault(_em2rem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_FONT_SIZE = 20;

var styles = function styles(_ref) {
  var theme = _ref.theme;
  return '\n  color: ' + theme.colors.base.text + ';\n  font-size: ' + (0, _decisivUiUtils.px2rem)(DEFAULT_FONT_SIZE) + ';\n  line-height: ' + (0, _em2rem2.default)(DEFAULT_FONT_SIZE, _constants.HEADER_LINE_HEIGHT) + ';\n  margin: 0;\n';
};

var customThemePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

var modifierConfig = _extends({}, _modifiers.fontColors, _modifiers.fontWeights);

var themePropTypes = _extends({}, _modifiers.fontColorPropTypes, _modifiers.fontWeightPropTypes, customThemePropTypes);

exports.default = (0, _decisivUiUtils.buildStyledComponent)('H3', _styledComponents2.default.h3, styles, {
  modifierConfig: modifierConfig,
  themePropTypes: themePropTypes
});

/***/ }),

/***/ "../node_modules/base-components/build/elements/H4/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _modifiers = __webpack_require__("../node_modules/base-components/build/modifiers/index.js");

var _constants = __webpack_require__("../node_modules/base-components/build/utils/constants.js");

var _em2rem = __webpack_require__("../node_modules/base-components/build/utils/em2rem.js");

var _em2rem2 = _interopRequireDefault(_em2rem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_FONT_SIZE = 14;

var styles = function styles(_ref) {
  var theme = _ref.theme;
  return '\n  color: ' + theme.colors.base.text + ';\n  font-size: ' + (0, _decisivUiUtils.px2rem)(DEFAULT_FONT_SIZE) + ';\n  line-height: ' + (0, _em2rem2.default)(DEFAULT_FONT_SIZE, _constants.HEADER_LINE_HEIGHT) + ';\n  margin: 0;\n';
};

var customThemePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

var themePropTypes = _extends({}, _modifiers.fontWeightPropTypes, customThemePropTypes);

exports.default = (0, _decisivUiUtils.buildStyledComponent)('H4', _styledComponents2.default.h4, styles, {
  modifierConfig: _modifiers.fontWeights,
  themePropTypes: themePropTypes
});

/***/ }),

/***/ "../node_modules/base-components/build/elements/Icon/iconix-names.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ['address-book', 'antenna-times', 'antenna', 'archive', 'arrow-bottom-left-corner', 'arrow-bottom-right-corner', 'arrow-collapse', 'arrow-down', 'arrow-expand', 'arrow-left', 'arrow-right', 'arrow-top-left-corner', 'arrow-top-right-corner', 'arrow-up', 'ban', 'bar-chart', 'bars', 'bell', 'briefcase-plus', 'briefcase', 'building-office', 'calculator', 'calendar-check', 'calendar-exclamation', 'calendar-times', 'calendar', 'check-circle', 'check-partial-shield', 'check-shield', 'check', 'chevron-double-left', 'chevron-double-right', 'chevron-down', 'chevron-left', 'chevron-right', 'chevron-up', 'clear-day', 'clear-night', 'clipboard-check', 'clipboard-exclamation', 'clipboard-times', 'clock', 'cloudy', 'cog', 'coment-plus', 'comment', 'copy', 'credit-card', 'directions', 'download', 'ellipsis-h', 'ellipsis-v', 'envelope', 'exclamation-circle', 'exclamation-shield', 'exclamation-triangle', 'external-link', 'eye-slash', 'eye', 'fallback', 'flag', 'fog', 'grid', 'home', 'info-circle', 'keypad', 'line-chart', 'lock-open', 'lock', 'map-pin', 'megaphone-times', 'megaphone', 'microphone-slash', 'microphone', 'minus-circle', 'minus', 'paperclip', 'partly-cloudy-day', 'partly-cloudy-night', 'pause', 'pencil', 'phone-arrow', 'phone-hangup', 'phone', 'pin', 'plus-circle', 'plus', 'print', 'question-circle', 'rain', 'raindrop', 'record', 'refresh', 'reply', 'road', 'search', 'sleet', 'snow', 'snowflake-o', 'star', 'sticky-note', 'stopwatch', 'thermometer-full', 'times-circle', 'times-shield', 'times', 'tools', 'trash', 'truck', 'unpin', 'upload', 'use-times', 'user-arrow-right', 'user-check', 'user-plus', 'user', 'users', 'wind'];

/***/ }),

/***/ "../node_modules/base-components/build/elements/Icon/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactFontawesome = __webpack_require__("../node_modules/react-fontawesome/lib/index.js");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _iconixNames = __webpack_require__("../node_modules/base-components/build/elements/Icon/iconix-names.js");

var _iconixNames2 = _interopRequireDefault(_iconixNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function UnstyledIcon(props) {
  var iconProps = (0, _lodash.omit)(props, ['theme', 'modifiers']);
  if (_iconixNames2.default.includes(props.name)) {
    return _react2.default.createElement(Iconix, iconProps);
  }
  return _react2.default.createElement(_reactFontawesome2.default, iconProps);
}

UnstyledIcon.propTypes = {
  name: _propTypes2.default.string.isRequired
};

function Iconix(_ref) {
  var name = _ref.name,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, ['name', 'className']);

  return _react2.default.createElement('span', _extends({ className: 'ix ix-' + name + ' ' + className }, rest));
}

Iconix.propTypes = {
  className: _propTypes2.default.string.isRequired,
  name: _propTypes2.default.string.isRequired
};

var modifierConfig = {
  chrome000: function chrome000(_ref2) {
    var theme = _ref2.theme;
    return 'color: ' + theme.colors.base.chrome000 + ';';
  },

  colorInherit: function colorInherit() {
    return 'color: inherit;';
  },

  danger: function danger(_ref3) {
    var theme = _ref3.theme;
    return 'color: ' + theme.colors.status.danger + ';';
  },

  disabled: function disabled() {
    return 'opacity: 0.5;';
  },

  info: function info(_ref4) {
    var theme = _ref4.theme;
    return 'color: ' + theme.colors.status.info + ';';
  },

  large: function large() {
    return 'font-size: ' + (0, _decisivUiUtils.px2rem)(64) + ';';
  },

  medium: function medium() {
    return 'font-size: ' + (0, _decisivUiUtils.px2rem)(32) + ';';
  },

  mini: function mini() {
    return 'font-size: ' + (0, _decisivUiUtils.px2rem)(12) + ';';
  },

  success: function success(_ref5) {
    var theme = _ref5.theme;
    return 'color: ' + theme.colors.status.success + ';';
  },

  text: function text(_ref6) {
    var theme = _ref6.theme;
    return 'color: ' + theme.colors.base.text + ';';
  },

  textLight: function textLight(_ref7) {
    var theme = _ref7.theme;
    return 'color: ' + theme.colors.base.textLight + ';';
  },

  warning: function warning(_ref8) {
    var theme = _ref8.theme;
    return 'color: ' + theme.colors.status.warning + ';';
  }
};

var styles = function styles(_ref9) {
  var theme = _ref9.theme;
  return '\n  color: ' + theme.colors.base.chrome600 + ';\n  font-size: ' + (0, _decisivUiUtils.px2rem)(16) + ';\n  &:before {\n    color: inherit;\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome000: _propTypes2.default.string.isRequired,
      text: _propTypes2.default.string.isRequired,
      textLight: _propTypes2.default.string.isRequired
    }).isRequired,
    status: _propTypes2.default.shape({
      danger: _propTypes2.default.string.isRequired,
      default: _propTypes2.default.string.isRequired,
      info: _propTypes2.default.string.isRequired,
      success: _propTypes2.default.string.isRequired,
      warning: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

var Icon = (0, _decisivUiUtils.buildStyledComponent)('Icon', (0, _styledComponents2.default)(UnstyledIcon), styles, {
  modifierConfig: modifierConfig,
  themePropTypes: themePropTypes
});

Icon.propTypes = {
  name: _propTypes2.default.string.isRequired
};

exports.default = Icon;

/***/ }),

/***/ "../node_modules/base-components/build/elements/Label/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _modifiers = __webpack_require__("../node_modules/base-components/build/modifiers/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = function styles(_ref) {
  var theme = _ref.theme;
  return '\n  color: ' + theme.colors.base.textLight + ';\n  font-size: ' + (0, _decisivUiUtils.px2rem)(10) + ';\n  flex: 1;\n  text-transform: capitalize;\n';
};

var customThemePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      textLight: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

var modifierConfig = _extends({}, _modifiers.fontColors, _modifiers.fontStyles, _modifiers.fontWeights, _modifiers.spacing);

var themePropTypes = _extends({}, _modifiers.fontColorPropTypes, _modifiers.fontWeightPropTypes, customThemePropTypes, _modifiers.spacingPropTypes);

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Label', _styledComponents2.default.label, styles, {
  modifierConfig: modifierConfig,
  themePropTypes: themePropTypes
});

/***/ }),

/***/ "../node_modules/base-components/build/elements/Link/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactRouterDom = __webpack_require__("../node_modules/react-router-dom/es/index.js");

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _Link = __webpack_require__("../node_modules/base-components/build/styles/common/Link.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function UnstyledLink(props) {
  var navLinkProps = (0, _lodash.omit)(props, ['modifiers', 'theme']);
  return _react2.default.createElement(_reactRouterDom.Link, navLinkProps);
}

var propTypes = {
  'aria-label': _propTypes2.default.string.isRequired
};

var Link = (0, _decisivUiUtils.buildStyledComponent)('Link', (0, _styledComponents2.default)(UnstyledLink), _Link.styles, {
  modifierConfig: _Link.modifierConfig,
  propTypes: propTypes,
  themePropTypes: _Link.themePropTypes
});

Link.propTypes = {
  'aria-label': _propTypes2.default.string.isRequired
};

exports.default = Link;

/***/ }),

/***/ "../node_modules/base-components/build/elements/NavLink/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactRouterDom = __webpack_require__("../node_modules/react-router-dom/es/index.js");

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function UnstyledNavLink(props) {
  var navLinkProps = (0, _lodash.omit)(props, ['modifiers', 'theme']);
  return _react2.default.createElement(_reactRouterDom.NavLink, navLinkProps);
}

var NavLink = (0, _decisivUiUtils.buildStyledComponent)('NavLink', (0, _styledComponents2.default)(UnstyledNavLink));

NavLink.propTypes = {
  'aria-label': _propTypes2.default.string.isRequired
};

exports.default = NavLink;

/***/ }),

/***/ "../node_modules/base-components/build/elements/P/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _modifiers = __webpack_require__("../node_modules/base-components/build/modifiers/index.js");

var _spacing = __webpack_require__("../node_modules/base-components/build/modifiers/spacing.js");

var _constants = __webpack_require__("../node_modules/base-components/build/utils/constants.js");

var _em2rem = __webpack_require__("../node_modules/base-components/build/utils/em2rem.js");

var _em2rem2 = _interopRequireDefault(_em2rem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_FONT_SIZE = 12;
var SMALL_FONT_SIZE = 10;

var customModifiers = {
  small: function small() {
    return {
      styles: '\n      font-size: ' + (0, _decisivUiUtils.px2rem)(SMALL_FONT_SIZE) + ';\n      line-height: ' + (0, _em2rem2.default)(SMALL_FONT_SIZE, _constants.TEXT_LINE_HEIGHT) + ';\n    '
    };
  },
  textLight: function textLight(_ref) {
    var theme = _ref.theme;
    return {
      styles: '\n      color: ' + theme.colors.base.textLight + ';\n    '
    };
  }
};

var styles = function styles(_ref2) {
  var theme = _ref2.theme;
  return '\n  color: ' + theme.colors.base.text + ';\n  font-size: ' + (0, _decisivUiUtils.px2rem)(DEFAULT_FONT_SIZE) + ';\n  line-height: ' + (0, _em2rem2.default)(DEFAULT_FONT_SIZE, _constants.TEXT_LINE_HEIGHT) + ';\n  margin: 0;\n';
};

var customThemePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

var modifierConfig = _extends({}, _modifiers.fontStyles, _modifiers.fontWeights, _spacing.spacing, customModifiers);

var themePropTypes = _extends({}, _modifiers.fontWeightPropTypes, customThemePropTypes);

exports.default = (0, _decisivUiUtils.buildStyledComponent)('P', _styledComponents2.default.p, styles, {
  modifierConfig: modifierConfig,
  themePropTypes: themePropTypes
});

/***/ }),

/***/ "../node_modules/base-components/build/elements/Text/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _modifiers = __webpack_require__("../node_modules/base-components/build/modifiers/index.js");

var _constants = __webpack_require__("../node_modules/base-components/build/utils/constants.js");

var _em2rem = __webpack_require__("../node_modules/base-components/build/utils/em2rem.js");

var _em2rem2 = _interopRequireDefault(_em2rem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_FONT_SIZE = 12;
var SMALL_FONT_SIZE = 10;

var customModifiers = {
  capitalize: function capitalize() {
    return 'text-transform: capitalize;';
  },
  noWrap: function noWrap() {
    return 'white-space: nowrap;';
  },
  small: function small() {
    return '\n    font-size: ' + (0, _decisivUiUtils.px2rem)(SMALL_FONT_SIZE) + ';\n    line-height: ' + (0, _em2rem2.default)(SMALL_FONT_SIZE, _constants.TEXT_LINE_HEIGHT) + ';\n  ';
  },
  textLight: function textLight(_ref) {
    var theme = _ref.theme;
    return '\n    color: ' + theme.colors.base.textLight + ';\n  ';
  }
};

var styles = function styles(_ref2) {
  var theme = _ref2.theme;
  return '\n  color: ' + theme.colors.base.text + ';\n  display: inline-block;\n  font-size: ' + (0, _decisivUiUtils.px2rem)(DEFAULT_FONT_SIZE) + ';\n  line-height: ' + (0, _em2rem2.default)(DEFAULT_FONT_SIZE, _constants.TEXT_LINE_HEIGHT) + ';\n';
};

var customThemePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired,
      textLight: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

var modifierConfig = _extends({}, _modifiers.fontColors, _modifiers.fontStyles, _modifiers.fontWeights, _modifiers.spacing, customModifiers);

var themePropTypes = _extends({}, _modifiers.fontColorPropTypes, _modifiers.fontWeightPropTypes, customThemePropTypes, _modifiers.spacingPropTypes);

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Text', _styledComponents2.default.span, styles, {
  modifierConfig: modifierConfig,
  themePropTypes: themePropTypes
});

/***/ }),

/***/ "../node_modules/base-components/build/elements/TextField/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _modifiers = __webpack_require__("../node_modules/base-components/build/modifiers/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = function styles(_ref) {
  var theme = _ref.theme;
  return '\n  border: none;\n  color: ' + theme.colors.base.text + ';\n  font-size: ' + (0, _decisivUiUtils.px2rem)(12) + ';\n  line-height: ' + (0, _decisivUiUtils.px2rem)(20) + ';\n  outline: none;\n  padding: 0;\n  width: 100%;\n\n  &::placeholder {\n    color: ' + theme.colors.base.chrome300 + ';\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome300: _propTypes2.default.string.isRequired,
      text: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('TextField', _styledComponents2.default.input, styles, {
  modifierConfig: _modifiers.spacing,
  themePropTypes: themePropTypes
});

/***/ }),

/***/ "../node_modules/base-components/build/elements/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _A = __webpack_require__("../node_modules/base-components/build/elements/A/index.js");

var _A2 = _interopRequireDefault(_A);

var _ButtonLink = __webpack_require__("../node_modules/base-components/build/elements/ButtonLink/index.js");

var _ButtonLink2 = _interopRequireDefault(_ButtonLink);

var _Divider = __webpack_require__("../node_modules/base-components/build/elements/Divider/index.js");

var _Divider2 = _interopRequireDefault(_Divider);

var _GhostIndicator = __webpack_require__("../node_modules/base-components/build/elements/GhostIndicator/index.js");

var _GhostIndicator2 = _interopRequireDefault(_GhostIndicator);

var _H = __webpack_require__("../node_modules/base-components/build/elements/H1/index.js");

var _H2 = _interopRequireDefault(_H);

var _H3 = __webpack_require__("../node_modules/base-components/build/elements/H2/index.js");

var _H4 = _interopRequireDefault(_H3);

var _H5 = __webpack_require__("../node_modules/base-components/build/elements/H3/index.js");

var _H6 = _interopRequireDefault(_H5);

var _H7 = __webpack_require__("../node_modules/base-components/build/elements/H4/index.js");

var _H8 = _interopRequireDefault(_H7);

var _Icon = __webpack_require__("../node_modules/base-components/build/elements/Icon/index.js");

var _Icon2 = _interopRequireDefault(_Icon);

var _Label = __webpack_require__("../node_modules/base-components/build/elements/Label/index.js");

var _Label2 = _interopRequireDefault(_Label);

var _Link = __webpack_require__("../node_modules/base-components/build/elements/Link/index.js");

var _Link2 = _interopRequireDefault(_Link);

var _NavLink = __webpack_require__("../node_modules/base-components/build/elements/NavLink/index.js");

var _NavLink2 = _interopRequireDefault(_NavLink);

var _P = __webpack_require__("../node_modules/base-components/build/elements/P/index.js");

var _P2 = _interopRequireDefault(_P);

var _Text = __webpack_require__("../node_modules/base-components/build/elements/Text/index.js");

var _Text2 = _interopRequireDefault(_Text);

var _TextField = __webpack_require__("../node_modules/base-components/build/elements/TextField/index.js");

var _TextField2 = _interopRequireDefault(_TextField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  A: _A2.default,
  ButtonLink: _ButtonLink2.default,
  Divider: _Divider2.default,
  GhostIndicator: _GhostIndicator2.default,
  H1: _H2.default,
  H2: _H4.default,
  H3: _H6.default,
  H4: _H8.default,
  Icon: _Icon2.default,
  Label: _Label2.default,
  Link: _Link2.default,
  NavLink: _NavLink2.default,
  P: _P2.default,
  Text: _Text2.default,
  TextField: _TextField2.default
}; // this is the primary export for Elements
// The primary export for this library is lib/index.js

/***/ }),

/***/ "../node_modules/base-components/build/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _blocks = __webpack_require__("../node_modules/base-components/build/blocks/index.js");

var _blocks2 = _interopRequireDefault(_blocks);

var _components = __webpack_require__("../node_modules/base-components/build/components/index.js");

var _components2 = _interopRequireDefault(_components);

var _elements = __webpack_require__("../node_modules/base-components/build/elements/index.js");

var _elements2 = _interopRequireDefault(_elements);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _extends({}, _blocks2.default, _components2.default, _elements2.default);

/***/ }),

/***/ "../node_modules/base-components/build/modifiers/fontColors.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fontColorPropTypes = exports.fontColors = undefined;

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fontColors = {
  danger: function danger(_ref) {
    var theme = _ref.theme;
    return 'color: ' + theme.colors.status.danger + ';';
  },
  default: function _default(_ref2) {
    var theme = _ref2.theme;
    return 'color: ' + theme.colors.status.default + ';';
  },
  info: function info(_ref3) {
    var theme = _ref3.theme;
    return 'color: ' + theme.colors.status.info + ';';
  },
  success: function success(_ref4) {
    var theme = _ref4.theme;
    return 'color: ' + theme.colors.status.success + ';';
  },
  text: function text(_ref5) {
    var theme = _ref5.theme;
    return 'color: ' + theme.colors.base.text + ';';
  },
  textLight: function textLight(_ref6) {
    var theme = _ref6.theme;
    return 'color: ' + theme.colors.base.textLight + ';';
  },
  warning: function warning(_ref7) {
    var theme = _ref7.theme;
    return 'color: ' + theme.colors.status.warning + ';';
  }
};

var fontColorPropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired,
      textLight: _propTypes2.default.string.isRequired
    }).isRequired,
    status: _propTypes2.default.shape({
      danger: _propTypes2.default.string.isRequired,
      default: _propTypes2.default.string.isRequired,
      info: _propTypes2.default.string.isRequired,
      success: _propTypes2.default.string.isRequired,
      warning: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.fontColors = fontColors;
exports.fontColorPropTypes = fontColorPropTypes;

/***/ }),

/***/ "../node_modules/base-components/build/modifiers/fontStyles.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var fontStyles = {
  capitalize: function capitalize() {
    return 'text-transform: capitalize;';
  },
  italicize: function italicize() {
    return 'font-style: italic;';
  },
  lowercase: function lowercase() {
    return 'text-transform: lowercase;';
  },
  underline: function underline() {
    return 'text-decoration: underline;';
  },
  uppercase: function uppercase() {
    return 'text-transform: uppercase;';
  }
};

exports.default = fontStyles;

/***/ }),

/***/ "../node_modules/base-components/build/modifiers/fontWeights.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fontWeights = exports.fontWeightPropTypes = undefined;

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fontWeights = {
  fontWeightBold: function fontWeightBold(_ref) {
    var theme = _ref.theme;
    return '\n    font-weight: ' + theme.fontWeights.bold + ';\n  ';
  },

  fontWeightLight: function fontWeightLight(_ref2) {
    var theme = _ref2.theme;
    return '\n    font-weight: ' + theme.fontWeights.light + ';\n  ';
  },

  fontWeightMedium: function fontWeightMedium(_ref3) {
    var theme = _ref3.theme;
    return '\n    font-weight: ' + theme.fontWeights.medium + ';\n  ';
  },

  fontWeightRegular: function fontWeightRegular(_ref4) {
    var theme = _ref4.theme;
    return '\n    font-weight: ' + theme.fontWeights.normal + ';\n  ';
  }
};

var fontWeightPropTypes = {
  fontWeights: _propTypes2.default.shape({
    bold: _propTypes2.default.number.isRequired,
    light: _propTypes2.default.number.isRequired,
    medium: _propTypes2.default.number.isRequired,
    normal: _propTypes2.default.number.isRequired
  }).isRequired
};

exports.fontWeightPropTypes = fontWeightPropTypes;
exports.fontWeights = fontWeights;

/***/ }),

/***/ "../node_modules/base-components/build/modifiers/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spacing = exports.spacingPropTypes = exports.fontWeights = exports.fontWeightPropTypes = exports.fontStyles = exports.fontColorPropTypes = exports.fontColors = undefined;

var _fontColors = __webpack_require__("../node_modules/base-components/build/modifiers/fontColors.js");

Object.defineProperty(exports, 'fontColors', {
  enumerable: true,
  get: function get() {
    return _fontColors.fontColors;
  }
});
Object.defineProperty(exports, 'fontColorPropTypes', {
  enumerable: true,
  get: function get() {
    return _fontColors.fontColorPropTypes;
  }
});

var _fontWeights = __webpack_require__("../node_modules/base-components/build/modifiers/fontWeights.js");

Object.defineProperty(exports, 'fontWeightPropTypes', {
  enumerable: true,
  get: function get() {
    return _fontWeights.fontWeightPropTypes;
  }
});
Object.defineProperty(exports, 'fontWeights', {
  enumerable: true,
  get: function get() {
    return _fontWeights.fontWeights;
  }
});

var _spacing = __webpack_require__("../node_modules/base-components/build/modifiers/spacing.js");

Object.defineProperty(exports, 'spacingPropTypes', {
  enumerable: true,
  get: function get() {
    return _spacing.spacingPropTypes;
  }
});
Object.defineProperty(exports, 'spacing', {
  enumerable: true,
  get: function get() {
    return _spacing.spacing;
  }
});

var _fontStyles2 = __webpack_require__("../node_modules/base-components/build/modifiers/fontStyles.js");

var _fontStyles3 = _interopRequireDefault(_fontStyles2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.fontStyles = _fontStyles3.default;

/***/ }),

/***/ "../node_modules/base-components/build/modifiers/spacing.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spacingPropTypes = exports.spacing = undefined;

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var spacing = {
  // margin
  gap: function gap(_ref) {
    var theme = _ref.theme;
    return '\n    margin: ' + theme.dimensions.gridPad + ';\n  ';
  },

  gapBottom: function gapBottom(_ref2) {
    var theme = _ref2.theme;
    return '\n    margin-bottom: ' + theme.dimensions.gridPad + ';\n  ';
  },

  gapLeft: function gapLeft(_ref3) {
    var theme = _ref3.theme;
    return '\n    margin-left: ' + theme.dimensions.gridPad + ';\n  ';
  },

  gapNone: function gapNone() {
    return 'margin: 0;';
  },

  gapRight: function gapRight(_ref4) {
    var theme = _ref4.theme;
    return '\n    margin-right: ' + theme.dimensions.gridPad + ';\n  ';
  },

  gapTop: function gapTop(_ref5) {
    var theme = _ref5.theme;
    return '\n    margin-top: ' + theme.dimensions.gridPad + ';\n  ';
  },

  gapX: function gapX(_ref6) {
    var theme = _ref6.theme;
    return '\n    margin-left: ' + theme.dimensions.gridPad + ';\n    margin-right: ' + theme.dimensions.gridPad + ';\n  ';
  },

  gapY: function gapY(_ref7) {
    var theme = _ref7.theme;
    return '\n    margin-bottom: ' + theme.dimensions.gridPad + ';\n    margin-top: ' + theme.dimensions.gridPad + ';\n  ';
  },
  // padding
  pad: function pad(_ref8) {
    var theme = _ref8.theme;
    return '\n    padding: ' + theme.dimensions.gridPad + ';\n  ';
  },

  padBottom: function padBottom(_ref9) {
    var theme = _ref9.theme;
    return '\n    padding-bottom: ' + theme.dimensions.gridPad + ';\n  ';
  },

  padLeft: function padLeft(_ref10) {
    var theme = _ref10.theme;
    return '\n    padding-left: ' + theme.dimensions.gridPad + ';\n  ';
  },

  padNone: function padNone() {
    return 'padding: 0;';
  },

  padRight: function padRight(_ref11) {
    var theme = _ref11.theme;
    return '\n    padding-right: ' + theme.dimensions.gridPad + ';\n  ';
  },

  padTop: function padTop(_ref12) {
    var theme = _ref12.theme;
    return '\n    padding-top: ' + theme.dimensions.gridPad + ';\n  ';
  },

  padX: function padX(_ref13) {
    var theme = _ref13.theme;
    return '\n    padding-left: ' + theme.dimensions.gridPad + ';\n    padding-right: ' + theme.dimensions.gridPad + ';\n  ';
  },

  padY: function padY(_ref14) {
    var theme = _ref14.theme;
    return '\n    padding-bottom: ' + theme.dimensions.gridPad + ';\n    padding-top: ' + theme.dimensions.gridPad + ';\n  ';
  }
};

var spacingPropTypes = {
  dimensions: _propTypes2.default.shape({
    gridPad: _propTypes2.default.string.isRequired
  }).isRequired
};

exports.spacing = spacing;
exports.spacingPropTypes = spacingPropTypes;

/***/ }),

/***/ "../node_modules/base-components/build/styles/common/Link.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themePropTypes = exports.styles = exports.modifierConfig = undefined;

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = exports.modifierConfig = {
  colorText: function colorText(_ref) {
    var theme = _ref.theme;
    return {
      styles: 'color: ' + theme.colors.base.text + ';'
    };
  },
  colorTextLight: function colorTextLight(_ref2) {
    var theme = _ref2.theme;
    return {
      styles: 'color: ' + theme.colors.base.textLight + ';'
    };
  }
}; // These are common styles shared by our A and Link Elements.
// Keeping them consolidated will help ensure they stay in sync.
var styles = exports.styles = function styles(_ref3) {
  var theme = _ref3.theme;
  return '\n  color: ' + theme.colors.base.link + ';\n  cursor: pointer;\n  font-size: 12px;\n  text-decoration: none;\n  text-transform: capitalize;\n  white-space: nowrap;\n\n  &:hover {\n    color: ' + theme.colors.base.linkHover + ';\n    text-decoration: underline;\n    .fa {\n      color: ' + theme.colors.base.linkHover + ';\n    }\n  }\n';
};

var themePropTypes = exports.themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      link: _propTypes2.default.string.isRequired,
      linkHover: _propTypes2.default.string.isRequired,
      text: _propTypes2.default.string.isRequired,
      textLight: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

/***/ }),

/***/ "../node_modules/base-components/build/utils/arrow.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateConstants = generateConstants;
exports.setBackground = setBackground;
exports.setBoxShadow = setBoxShadow;
// NOTE: ARROW_BASE is the actual size of the Arrow div
function generateConstants(_ref) {
  var ARROW_BASE = _ref.ARROW_BASE,
      BROWSER_OFFSET = _ref.BROWSER_OFFSET;

  // ARROW_HEIGHT and ARROW_WIDTH are the dimensions for the visible half of the Arrow
  var ARROW_HEIGHT = function ARROW_HEIGHT() {
    return ARROW_BASE / 2 - BROWSER_OFFSET;
  };

  var ARROW_WIDTH = function ARROW_WIDTH() {
    var HEIGHT = ARROW_HEIGHT();
    return Math.sqrt(HEIGHT * HEIGHT * 2);
  };

  // Yay for Pythagorus! c = √(a² + b²)
  var ARROW_HALF_WIDTH = function ARROW_HALF_WIDTH() {
    return ARROW_WIDTH() / 2;
  };

  // ARROW_OFFSET is how far the arrow is from the edge of the Popover
  var ARROW_OFFSET = function ARROW_OFFSET() {
    return ARROW_HALF_WIDTH() + 20;
  };

  return {
    ARROW_HEIGHT: ARROW_HEIGHT(),
    ARROW_WIDTH: ARROW_WIDTH(),
    ARROW_HALF_WIDTH: ARROW_HALF_WIDTH(),
    ARROW_OFFSET: ARROW_OFFSET(),

    // These constants are used to control the rotation of the pointer.
    BOTTOM_ROTATE: 45,
    LEFT_ROTATE: 135,
    RIGHT_ROTATE: -45,
    TOP_ROTATE: -135
  };
}

function setBackground(color) {
  return 'linear-gradient(to bottom right, ' + color + ' 51%, transparent 0%)';
}

var BOX_SHADOWS = {
  bottom: '-2px -2px 2px -2px',
  left: '-3px -3px 6px -3px',
  right: '-3px -3px 6px -3px',
  top: '-2px -2px 4px -2px'
};

function setBoxShadow(direction, color) {
  return BOX_SHADOWS[direction] + ' ' + color;
}

/***/ }),

/***/ "../node_modules/base-components/build/utils/childrenWithDefaultModifiers.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _react = __webpack_require__("../node_modules/react/react.js");

/**
 * Compares the modifiers in the components props to an array of modifier names that should have
 * the default modifiers applied to the children.
 * @param {object} props The component's props
 * @property {array} props.modifiers The modifiers applied to the component.
 * @param {array} modifiersRequiringDefaults These are the modifiers on the top component that
 *                                           require a default set of modifiers applied to the
 *                                           children.
 * @returns {boolean}
 */
function applyDefaultModifiersToChildren(_ref, modifiersRequiringDefaults) {
  var modifiers = _ref.modifiers;

  // `intersection` returns an array with the elements that appear in both arrays.
  return !!(modifiers && !(0, _lodash.isEmpty)((0, _lodash.intersection)(modifiers, modifiersRequiringDefaults)));
}

/**
 * Creates a batch of children with the appropriate default modifiers applied.
 * @param {object} props The component's props
 * @property {array} props.modifiers The modifiers applied to the component.
 * @property {node} props.modifiers The component's children
 * @param {array} modifiersRequiringDefaults These are the modifiers on the top component that
 *                                           require a default set of modifiers applied to the
 *                                           children.
 * @param {array} defaultModifiers These are the modifiers applied to the children if the top
 *                                 component is rendered with any of the modifiersRequiringDefaults
 * @returns {node} The component's _new_ children
 */
function childrenWithDefaultModifiers(props, modifiersRequiringDefaults, defaultModifiers) {
  // return the children as-is if no extra modifiers are required as defaults on the children.
  if (!applyDefaultModifiersToChildren(props, modifiersRequiringDefaults)) {
    return props.children;
  }
  // Prepend the default modifiers to ALL of the children's modifier arrays if the default
  // override is required. This order is critical, as it allows the developer to override
  // the defaults.
  return _react.Children.map(props.children, function (child) {
    var modifiers = (0, _lodash.concat)(defaultModifiers, child.props.modifiers);
    return (0, _react.cloneElement)(child, { modifiers: modifiers });
  });
}

exports.default = childrenWithDefaultModifiers;

/***/ }),

/***/ "../node_modules/base-components/build/utils/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// Line height ratios (in em)
var HEADER_LINE_HEIGHT = exports.HEADER_LINE_HEIGHT = 1.2;
var TEXT_LINE_HEIGHT = exports.TEXT_LINE_HEIGHT = 1.6;

// eslint-disable-next-line import/prefer-default-export
var ROOT = exports.ROOT =  false ? 'http://localhost:8080' : 'https://base-components.preview.decisivapps.com';

/***/ }),

/***/ "../node_modules/base-components/build/utils/em2rem.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

// Design used em units for headers and text line-heights, but all of our units are in rem.
// This is a quick conversion util to help keep all our units in rem.

function em2rem(px, em) {
  return (0, _decisivUiUtils.px2rem)(px * em);
}

exports.default = em2rem;

/***/ }),

/***/ "../node_modules/base-components/build/utils/modifiers.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modifiersForComponent = modifiersForComponent;

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

// This will split up/ apply only the correct modifiers
// to the internally rendered components.
// eslint-disable-next-line import/prefer-default-export
function modifiersForComponent(modifiers, Component) {
  if (Component.modifiers) {
    return (0, _lodash.intersection)(Object.keys(Component.modifiers), modifiers);
  }
  return [];
}

/***/ }),

/***/ "../node_modules/base-components/node_modules/react-smooth-collapse/js/getTransitionTimeMs.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getTransitionTimeMs;
function getTransitionTimeMs(heightTransition) {
  var m = /(\d+(?:\.\d+)?|\.\d+)(m?s)\b/i.exec(heightTransition);
  if (!m) throw new Error('Could not parse time from transition value');
  return Number(m[1]) * (m[2].length === 1 ? 1000 : 1);
}
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9nZXRUcmFuc2l0aW9uVGltZU1zLmpzIl0sIm5hbWVzIjpbImdldFRyYW5zaXRpb25UaW1lTXMiLCJoZWlnaHRUcmFuc2l0aW9uIiwibSIsImV4ZWMiLCJFcnJvciIsIk51bWJlciIsImxlbmd0aCJdLCJtYXBwaW5ncyI6Ijs7Ozs7a0JBRXdCQSxtQjtBQUFULFNBQVNBLG1CQUFULENBQTZCQyxnQkFBN0IsRUFBK0Q7QUFDNUUsTUFBTUMsSUFBSSxnQ0FBZ0NDLElBQWhDLENBQXFDRixnQkFBckMsQ0FBVjtBQUNBLE1BQUksQ0FBQ0MsQ0FBTCxFQUFRLE1BQU0sSUFBSUUsS0FBSixDQUFVLDRDQUFWLENBQU47QUFDUixTQUFPQyxPQUFPSCxFQUFFLENBQUYsQ0FBUCxLQUFnQkEsRUFBRSxDQUFGLEVBQUtJLE1BQUwsS0FBZ0IsQ0FBaEIsR0FBb0IsSUFBcEIsR0FBMkIsQ0FBM0MsQ0FBUDtBQUNEIiwiZmlsZSI6ImdldFRyYW5zaXRpb25UaW1lTXMuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvKiBAZmxvdyAqL1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBnZXRUcmFuc2l0aW9uVGltZU1zKGhlaWdodFRyYW5zaXRpb246IHN0cmluZyk6IG51bWJlciB7XG4gIGNvbnN0IG0gPSAvKFxcZCsoPzpcXC5cXGQrKT98XFwuXFxkKykobT9zKVxcYi9pLmV4ZWMoaGVpZ2h0VHJhbnNpdGlvbik7XG4gIGlmICghbSkgdGhyb3cgbmV3IEVycm9yKCdDb3VsZCBub3QgcGFyc2UgdGltZSBmcm9tIHRyYW5zaXRpb24gdmFsdWUnKTtcbiAgcmV0dXJuIE51bWJlcihtWzFdKSAqIChtWzJdLmxlbmd0aCA9PT0gMSA/IDEwMDAgOiAxKTtcbn1cbiJdfQ==

/***/ }),

/***/ "../node_modules/base-components/node_modules/react-smooth-collapse/js/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__("../node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("../node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("../node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("../node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _kefir = __webpack_require__("../node_modules/kefir/dist/kefir.js");

var _kefir2 = _interopRequireDefault(_kefir);

var _kefirBus = __webpack_require__("../node_modules/kefir-bus/index.js");

var _kefirBus2 = _interopRequireDefault(_kefirBus);

var _getTransitionTimeMs = __webpack_require__("../node_modules/base-components/node_modules/react-smooth-collapse/js/getTransitionTimeMs.js");

var _getTransitionTimeMs2 = _interopRequireDefault(_getTransitionTimeMs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SmoothCollapse = function (_React$Component) {
  (0, _inherits3.default)(SmoothCollapse, _React$Component);

  function SmoothCollapse(props) {
    (0, _classCallCheck3.default)(this, SmoothCollapse);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SmoothCollapse.__proto__ || (0, _getPrototypeOf2.default)(SmoothCollapse)).call(this, props));

    _this._resetter = (0, _kefirBus2.default)();
    _this._mainEl = null;
    _this._innerEl = null;

    _this._mainElSetter = function (el) {
      _this._mainEl = el;
    };

    _this._innerElSetter = function (el) {
      _this._innerEl = el;
    };

    _this.state = {
      hasBeenVisibleBefore: props.expanded || _this._visibleWhenClosed(),
      fullyClosed: !props.expanded,
      height: props.expanded ? 'auto' : props.collapsedHeight
    };
    return _this;
  }

  (0, _createClass3.default)(SmoothCollapse, [{
    key: '_visibleWhenClosed',
    value: function _visibleWhenClosed(props) {
      if (!props) props = this.props;
      return parseFloat(props.collapsedHeight) !== 0;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._resetter.emit(null);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (!this.props.expanded && nextProps.expanded) {
        this._resetter.emit(null);

        // In order to expand, we need to know the height of the children, so we
        // need to setState first so they get rendered before we continue.

        this.setState({
          fullyClosed: false,
          hasBeenVisibleBefore: true
        }, function () {
          var mainEl = _this2._mainEl;
          var innerEl = _this2._innerEl;
          if (!mainEl || !innerEl) throw new Error('Should not happen');

          // Set the collapser to the target height instead of auto so that it
          // animates correctly. Then switch it to 'auto' after the animation so
          // that it flows correctly if the page is resized.
          var targetHeight = innerEl.clientHeight + 'px';
          _this2.setState({
            height: targetHeight
          });

          // Wait until the transitionend event, or until a timer goes off in
          // case the event doesn't fire because the browser doesn't support it
          // or the element is hidden before it happens. The timer is a little
          // longer than the transition is supposed to take to make sure we don't
          // cut the animation early while it's still going if the browser is
          // running it just a little slow.
          _kefir2.default.fromEvents(mainEl, 'transitionend').merge(_kefir2.default.later((0, _getTransitionTimeMs2.default)(nextProps.heightTransition) * 1.1 + 500)).takeUntilBy(_this2._resetter).take(1).onValue(function () {
            _this2.setState({
              height: 'auto'
            }, function () {
              if (_this2.props.onChangeEnd) {
                _this2.props.onChangeEnd();
              }
            });
          });
        });
      } else if (this.props.expanded && !nextProps.expanded) {
        this._resetter.emit(null);

        if (!this._innerEl) throw new Error('Should not happen');
        this.setState({
          height: this._innerEl.clientHeight + 'px'
        }, function () {
          var mainEl = _this2._mainEl;
          if (!mainEl) throw new Error('Should not happen');

          mainEl.clientHeight; // force the page layout
          _this2.setState({
            height: nextProps.collapsedHeight
          });

          // See comment above about previous use of transitionend event.
          _kefir2.default.fromEvents(mainEl, 'transitionend').merge(_kefir2.default.later((0, _getTransitionTimeMs2.default)(nextProps.heightTransition) * 1.1 + 500)).takeUntilBy(_this2._resetter).take(1).onValue(function () {
            _this2.setState({
              fullyClosed: true
            });
            if (_this2.props.onChangeEnd) {
              _this2.props.onChangeEnd();
            }
          });
        });
      } else if (!nextProps.expanded && this.props.collapsedHeight !== nextProps.collapsedHeight) {
        this.setState({
          hasBeenVisibleBefore: this.state.hasBeenVisibleBefore || this._visibleWhenClosed(nextProps),
          height: nextProps.collapsedHeight
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var visibleWhenClosed = this._visibleWhenClosed();
      var allowOverflowWhenOpen = this.props.allowOverflowWhenOpen;
      var _state = this.state,
          height = _state.height,
          fullyClosed = _state.fullyClosed,
          hasBeenVisibleBefore = _state.hasBeenVisibleBefore;

      var innerEl = hasBeenVisibleBefore ? _react2.default.createElement(
        'div',
        { ref: this._innerElSetter, style: {
            overflow: allowOverflowWhenOpen && height === 'auto' ? 'visible' : 'hidden'
          } },
        this.props.children
      ) : null;

      return _react2.default.createElement(
        'div',
        {
          ref: this._mainElSetter,
          className: this.props.className,
          style: {
            height: height,
            overflow: allowOverflowWhenOpen && height === 'auto' ? 'visible' : 'hidden',
            display: fullyClosed && !visibleWhenClosed ? 'none' : null,
            transition: 'height ' + this.props.heightTransition
          }
        },
        innerEl
      );
    }
  }]);
  return SmoothCollapse;
}(_react2.default.Component);

SmoothCollapse.propTypes = {
  expanded: _propTypes2.default.bool.isRequired,
  onChangeEnd: _propTypes2.default.func,
  collapsedHeight: _propTypes2.default.string,
  heightTransition: _propTypes2.default.string,
  className: _propTypes2.default.string,
  allowOverflowWhenOpen: _propTypes2.default.bool
};
SmoothCollapse.defaultProps = {
  collapsedHeight: '0',
  heightTransition: '.25s ease',
  className: '',
  allowOverflowWhenOpen: false
};
exports.default = SmoothCollapse;
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ "../node_modules/base-components/node_modules/styled-components-reactive-grid/dist/Column.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n      justify-content: center;\n      text-align: center;\n    '], ['\n      justify-content: center;\n      text-align: center;\n    ']),
    _templateObject2 = _taggedTemplateLiteral(['\n      flex-basis: 0;\n      flex-grow: 1;\n      max-width: 100%;\n      -ms-flex-positive: 1;\n    '], ['\n      flex-basis: 0;\n      flex-grow: 1;\n      max-width: 100%;\n      -ms-flex-positive: 1;\n    ']),
    _templateObject3 = _taggedTemplateLiteral(['\n      flex-basis: 8.33333333%;\n      max-width: 8.33333333%;\n      -ms-flex-preferred-size: 8.33333333%;\n    '], ['\n      flex-basis: 8.33333333%;\n      max-width: 8.33333333%;\n      -ms-flex-preferred-size: 8.33333333%;\n    ']),
    _templateObject4 = _taggedTemplateLiteral(['\n      flex-basis: 16.66666667%;\n      max-width: 16.66666667%;\n      -ms-flex-preferred-size: 16.66666667%;\n    '], ['\n      flex-basis: 16.66666667%;\n      max-width: 16.66666667%;\n      -ms-flex-preferred-size: 16.66666667%;\n    ']),
    _templateObject5 = _taggedTemplateLiteral(['\n      flex-basis: 25%;\n      max-width: 25%;\n      -ms-flex-preferred-size: 25%;\n    '], ['\n      flex-basis: 25%;\n      max-width: 25%;\n      -ms-flex-preferred-size: 25%;\n    ']),
    _templateObject6 = _taggedTemplateLiteral(['\n      flex-basis: 33.33333333%;\n      max-width: 33.33333333%;\n      -ms-flex-preferred-size: 33.33333333%;\n    '], ['\n      flex-basis: 33.33333333%;\n      max-width: 33.33333333%;\n      -ms-flex-preferred-size: 33.33333333%;\n    ']),
    _templateObject7 = _taggedTemplateLiteral(['\n      flex-basis: 41.66666667%;\n      max-width: 41.66666667%;\n      -ms-flex-preferred-size: 41.66666667%;\n    '], ['\n      flex-basis: 41.66666667%;\n      max-width: 41.66666667%;\n      -ms-flex-preferred-size: 41.66666667%;\n    ']),
    _templateObject8 = _taggedTemplateLiteral(['\n      flex-basis: 50%;\n      max-width: 50%;\n      -ms-flex-preferred-size: 50%;\n    '], ['\n      flex-basis: 50%;\n      max-width: 50%;\n      -ms-flex-preferred-size: 50%;\n    ']),
    _templateObject9 = _taggedTemplateLiteral(['\n      flex-basis: 58.33333333%;\n      max-width: 58.33333333%;\n      -ms-flex-preferred-size: 58.33333333%;\n    '], ['\n      flex-basis: 58.33333333%;\n      max-width: 58.33333333%;\n      -ms-flex-preferred-size: 58.33333333%;\n    ']),
    _templateObject10 = _taggedTemplateLiteral(['\n      flex-basis: 66.66666667%;\n      max-width: 66.66666667%;\n      -ms-flex-preferred-size: 66.66666667%;\n    '], ['\n      flex-basis: 66.66666667%;\n      max-width: 66.66666667%;\n      -ms-flex-preferred-size: 66.66666667%;\n    ']),
    _templateObject11 = _taggedTemplateLiteral(['\n      flex-basis: 75%;\n      max-width: 75%;\n      -ms-flex-preferred-size: 75%;\n    '], ['\n      flex-basis: 75%;\n      max-width: 75%;\n      -ms-flex-preferred-size: 75%;\n    ']),
    _templateObject12 = _taggedTemplateLiteral(['\n      flex-basis: 83.33333333%;\n      max-width: 83.33333333%;\n      -ms-flex-preferred-size: 83.33333333%;\n    '], ['\n      flex-basis: 83.33333333%;\n      max-width: 83.33333333%;\n      -ms-flex-preferred-size: 83.33333333%;\n    ']),
    _templateObject13 = _taggedTemplateLiteral(['\n      flex-basis: 91.66666667%;\n      max-width: 91.66666667%;\n      -ms-flex-preferred-size: 91.66666667%;\n    '], ['\n      flex-basis: 91.66666667%;\n      max-width: 91.66666667%;\n      -ms-flex-preferred-size: 91.66666667%;\n    ']),
    _templateObject14 = _taggedTemplateLiteral(['\n      flex-basis: 100%;\n      max-width: 100%;\n      -ms-flex-preferred-size: 100%;\n    '], ['\n      flex-basis: 100%;\n      max-width: 100%;\n      -ms-flex-preferred-size: 100%;\n    ']),
    _templateObject15 = _taggedTemplateLiteral(['\n      margin-left: 8.33333333%;\n    '], ['\n      margin-left: 8.33333333%;\n    ']),
    _templateObject16 = _taggedTemplateLiteral(['\n      margin-left: 16.66666667%;\n    '], ['\n      margin-left: 16.66666667%;\n    ']),
    _templateObject17 = _taggedTemplateLiteral(['\n      margin-left: 25%;\n    '], ['\n      margin-left: 25%;\n    ']),
    _templateObject18 = _taggedTemplateLiteral(['\n      margin-left: 33.33333333%;\n    '], ['\n      margin-left: 33.33333333%;\n    ']),
    _templateObject19 = _taggedTemplateLiteral(['\n      margin-left: 41.66666667%;\n    '], ['\n      margin-left: 41.66666667%;\n    ']),
    _templateObject20 = _taggedTemplateLiteral(['\n      margin-left: 50%;\n    '], ['\n      margin-left: 50%;\n    ']),
    _templateObject21 = _taggedTemplateLiteral(['\n      margin-left: 58.33333333%;\n    '], ['\n      margin-left: 58.33333333%;\n    ']),
    _templateObject22 = _taggedTemplateLiteral(['\n      margin-left: 66.66666667%;\n    '], ['\n      margin-left: 66.66666667%;\n    ']),
    _templateObject23 = _taggedTemplateLiteral(['\n      margin-left: 75%;\n    '], ['\n      margin-left: 75%;\n    ']),
    _templateObject24 = _taggedTemplateLiteral(['\n      margin-left: 83.33333333%;\n    '], ['\n      margin-left: 83.33333333%;\n    ']),
    _templateObject25 = _taggedTemplateLiteral(['\n      margin-left: 91.66666667%;\n    '], ['\n      margin-left: 91.66666667%;\n    ']),
    _templateObject26 = _taggedTemplateLiteral(['\n      justify-content: flex-end;\n      text-align: end;\n    '], ['\n      justify-content: flex-end;\n      text-align: end;\n    ']),
    _templateObject27 = _taggedTemplateLiteral(['\n      padding-left: 0;\n      padding-right: 0;\n    '], ['\n      padding-left: 0;\n      padding-right: 0;\n    ']),
    _templateObject28 = _taggedTemplateLiteral(['\n      flex-direction: column-reverse;\n    '], ['\n      flex-direction: column-reverse;\n    ']),
    _templateObject29 = _taggedTemplateLiteral(['\n      justify-content: flex-start;\n      text-align: start;\n    '], ['\n      justify-content: flex-start;\n      text-align: start;\n    ']),
    _templateObject30 = _taggedTemplateLiteral(['\n  ', '\n  box-sizing: border-box;\n  flex: 0 0 auto;\n  padding: ', ';\n  position: relative;\n  ', '\n  ', '\n'], ['\n  ', '\n  box-sizing: border-box;\n  flex: 0 0 auto;\n  padding: ', ';\n  position: relative;\n  ', '\n  ', '\n']);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactiveContainer = __webpack_require__("../node_modules/reactive-container/dist/index.js");

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledComponentsModifiers = __webpack_require__("../node_modules/styled-components-modifiers/dist/index.js");

var _styledComponentsThemeValidator = __webpack_require__("../node_modules/styled-components-theme-validator/dist/index.js");

var _modifiers = __webpack_require__("../node_modules/base-components/node_modules/styled-components-reactive-grid/dist/utils/modifiers.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var COMPONENT_NAME = 'Column';

var MODIFIER_CONFIG = _extends({}, _modifiers.dimensionModifiers, _modifiers.displayModifiers, _modifiers.padScaleModifiers, {
  center: function center() {
    return {
      styles: (0, _styledComponents.css)(_templateObject)
    };
  },
  col: function col() {
    return {
      styles: (0, _styledComponents.css)(_templateObject2)
    };
  },
  col_1: function col_1() {
    return {
      styles: (0, _styledComponents.css)(_templateObject3)
    };
  },
  col_2: function col_2() {
    return {
      styles: (0, _styledComponents.css)(_templateObject4)
    };
  },
  col_3: function col_3() {
    return {
      styles: (0, _styledComponents.css)(_templateObject5)
    };
  },
  col_4: function col_4() {
    return {
      styles: (0, _styledComponents.css)(_templateObject6)
    };
  },
  col_5: function col_5() {
    return {
      styles: (0, _styledComponents.css)(_templateObject7)
    };
  },
  col_6: function col_6() {
    return {
      styles: (0, _styledComponents.css)(_templateObject8)
    };
  },
  col_7: function col_7() {
    return {
      styles: (0, _styledComponents.css)(_templateObject9)
    };
  },

  col_8: function col_8() {
    return {
      styles: (0, _styledComponents.css)(_templateObject10)
    };
  },

  col_9: function col_9() {
    return {
      styles: (0, _styledComponents.css)(_templateObject11)
    };
  },
  col_10: function col_10() {
    return {
      styles: (0, _styledComponents.css)(_templateObject12)
    };
  },
  col_11: function col_11() {
    return {
      styles: (0, _styledComponents.css)(_templateObject13)
    };
  },
  col_12: function col_12() {
    return {
      styles: (0, _styledComponents.css)(_templateObject14)
    };
  },
  col_offset_1: function col_offset_1() {
    return {
      styles: (0, _styledComponents.css)(_templateObject15)
    };
  },
  col_offset_2: function col_offset_2() {
    return {
      styles: (0, _styledComponents.css)(_templateObject16)
    };
  },
  col_offset_3: function col_offset_3() {
    return {
      styles: (0, _styledComponents.css)(_templateObject17)
    };
  },
  col_offset_4: function col_offset_4() {
    return {
      styles: (0, _styledComponents.css)(_templateObject18)
    };
  },
  col_offset_5: function col_offset_5() {
    return {
      styles: (0, _styledComponents.css)(_templateObject19)
    };
  },
  col_offset_6: function col_offset_6() {
    return {
      styles: (0, _styledComponents.css)(_templateObject20)
    };
  },
  col_offset_7: function col_offset_7() {
    return {
      styles: (0, _styledComponents.css)(_templateObject21)
    };
  },
  col_offset_8: function col_offset_8() {
    return {
      styles: (0, _styledComponents.css)(_templateObject22)
    };
  },
  col_offset_9: function col_offset_9() {
    return {
      styles: (0, _styledComponents.css)(_templateObject23)
    };
  },
  col_offset_10: function col_offset_10() {
    return {
      styles: (0, _styledComponents.css)(_templateObject24)
    };
  },
  col_offset_11: function col_offset_11() {
    return {
      styles: (0, _styledComponents.css)(_templateObject25)
    };
  },
  end: function end() {
    return {
      styles: (0, _styledComponents.css)(_templateObject26)
    };
  },
  fluid: function fluid() {
    return {
      styles: (0, _styledComponents.css)(_templateObject27)
    };
  },
  reverse: function reverse() {
    return {
      styles: (0, _styledComponents.css)(_templateObject28)
    };
  },
  start: function start() {
    return {
      styles: (0, _styledComponents.css)(_templateObject29)
    };
  }
});

var THEME_PROPTYPES = (0, _styledComponentsThemeValidator.buildThemePropTypes)({
  dimensions: _propTypes2.default.shape({
    gridPad: _propTypes2.default.string.isRequired
  }).isRequired
});

var Column = _styledComponents2.default.div(_templateObject30, (0, _styledComponentsThemeValidator.validateTheme)(COMPONENT_NAME, THEME_PROPTYPES), function (props) {
  return props.theme.dimensions.gridPad;
}, (0, _styledComponentsModifiers.applyStyleModifiers)(MODIFIER_CONFIG), (0, _styledComponentsModifiers.applyResponsiveStyleModifiers)(MODIFIER_CONFIG));

Column.propTypes = {
  className: _propTypes2.default.string,
  modifiers: (0, _styledComponentsModifiers.styleModifierPropTypes)(MODIFIER_CONFIG),
  responsiveModifiers: (0, _styledComponentsModifiers.responsiveStyleModifierPropTypes)(MODIFIER_CONFIG),
  size: _propTypes2.default.string.isRequired
};

Column.defaultProps = {
  className: COMPONENT_NAME
};

var ColumnWithSize = (0, _reactiveContainer.withSize)(Column);

ColumnWithSize.displayName = COMPONENT_NAME;
ColumnWithSize.modifiers = MODIFIER_CONFIG;

exports.default = ColumnWithSize;

/***/ }),

/***/ "../node_modules/base-components/node_modules/styled-components-reactive-grid/dist/Container.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MODIFIER_CONFIG = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n      display: flex;\n      flex-direction: column;\n    '], ['\n      display: flex;\n      flex-direction: column;\n    ']),
    _templateObject2 = _taggedTemplateLiteral(['\n      padding: 0;\n    '], ['\n      padding: 0;\n    ']),
    _templateObject3 = _taggedTemplateLiteral(['\n  ', '\n  box-sizing: border-box;\n  flex: 1;\n  padding: ', ';\n  position: relative;\n  width: 100%;\n  ', ';\n'], ['\n  ', '\n  box-sizing: border-box;\n  flex: 1;\n  padding: ', ';\n  position: relative;\n  width: 100%;\n  ', ';\n']);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledComponentsModifiers = __webpack_require__("../node_modules/styled-components-modifiers/dist/index.js");

var _styledComponentsThemeValidator = __webpack_require__("../node_modules/styled-components-theme-validator/dist/index.js");

var _modifiers = __webpack_require__("../node_modules/base-components/node_modules/styled-components-reactive-grid/dist/utils/modifiers.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var COMPONENT_NAME = 'Container';

var MODIFIER_CONFIG = exports.MODIFIER_CONFIG = _extends({}, _modifiers.dimensionModifiers, _modifiers.displayModifiers, _modifiers.padScaleModifiers, {
  flex_column: function flex_column() {
    return {
      styles: (0, _styledComponents.css)(_templateObject)
    };
  },
  fluid: function fluid() {
    return {
      styles: (0, _styledComponents.css)(_templateObject2)
    };
  }
});

var THEME_PROPTYPES = (0, _styledComponentsThemeValidator.buildThemePropTypes)({
  dimensions: _propTypes2.default.shape({
    gridPad: _propTypes2.default.string.isRequired
  }).isRequired
});

var Container = _styledComponents2.default.div(_templateObject3, (0, _styledComponentsThemeValidator.validateTheme)(COMPONENT_NAME, THEME_PROPTYPES), function (props) {
  return props.theme.dimensions.gridPad;
}, (0, _styledComponentsModifiers.applyStyleModifiers)(MODIFIER_CONFIG));

Container.propTypes = {
  className: _propTypes2.default.string,
  modifiers: (0, _styledComponentsModifiers.styleModifierPropTypes)(MODIFIER_CONFIG)
};

Container.defaultProps = {
  className: COMPONENT_NAME
};

Container.displayName = COMPONENT_NAME;
Container.modifiers = MODIFIER_CONFIG;

exports.default = Container;

/***/ }),

/***/ "../node_modules/base-components/node_modules/styled-components-reactive-grid/dist/ReactiveContainer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactiveContainer = __webpack_require__("../node_modules/reactive-container/dist/index.js");

var _Container = __webpack_require__("../node_modules/base-components/node_modules/styled-components-reactive-grid/dist/Container.js");

var _Container2 = _interopRequireDefault(_Container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReactiveContainer = (0, _reactiveContainer.makeReactiveContainer)()(_Container2.default);

ReactiveContainer.displayName = 'ReactiveContainer';
ReactiveContainer.modifiers = _Container.MODIFIER_CONFIG;

exports.default = ReactiveContainer;

/***/ }),

/***/ "../node_modules/base-components/node_modules/styled-components-reactive-grid/dist/Row.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n      align-items: flex-end;\n    '], ['\n      align-items: flex-end;\n    ']),
    _templateObject2 = _taggedTemplateLiteral(['\n      justify-content: center;\n      text-align: center;\n    '], ['\n      justify-content: center;\n      text-align: center;\n    ']),
    _templateObject3 = _taggedTemplateLiteral(['\n      justify-content: flex-end;\n      text-align: end;\n    '], ['\n      justify-content: flex-end;\n      text-align: end;\n    ']),
    _templateObject4 = _taggedTemplateLiteral(['\n      margin-left: calc(-', ' * 2);\n      margin-right: calc(-', ' * 2);\n    '], ['\n      margin-left: calc(-', ' * 2);\n      margin-right: calc(-', ' * 2);\n    ']),
    _templateObject5 = _taggedTemplateLiteral(['\n      align-items: center;\n    '], ['\n      align-items: center;\n    ']),
    _templateObject6 = _taggedTemplateLiteral(['\n      -webkit-box-direction: reverse;\n      -webkit-box-orient: horizontal;\n      flex-direction: row-reverse;\n    '], ['\n      -webkit-box-direction: reverse;\n      -webkit-box-orient: horizontal;\n      flex-direction: row-reverse;\n    ']),
    _templateObject7 = _taggedTemplateLiteral(['\n      justify-content: flex-start;\n      text-align: start;\n    '], ['\n      justify-content: flex-start;\n      text-align: start;\n    ']),
    _templateObject8 = _taggedTemplateLiteral(['\n      align-items: flex-start;\n    '], ['\n      align-items: flex-start;\n    ']),
    _templateObject9 = _taggedTemplateLiteral(['\n  ', '\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  flex: 0 1 auto;\n  position: relative;\n  ', '\n  ', '\n'], ['\n  ', '\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  flex: 0 1 auto;\n  position: relative;\n  ', '\n  ', '\n']);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactiveContainer = __webpack_require__("../node_modules/reactive-container/dist/index.js");

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledComponentsModifiers = __webpack_require__("../node_modules/styled-components-modifiers/dist/index.js");

var _styledComponentsThemeValidator = __webpack_require__("../node_modules/styled-components-theme-validator/dist/index.js");

var _modifiers = __webpack_require__("../node_modules/base-components/node_modules/styled-components-reactive-grid/dist/utils/modifiers.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var COMPONENT_NAME = 'Row';

var MODIFIER_CONFIG = _extends({}, _modifiers.dimensionModifiers, _modifiers.displayModifiers, _modifiers.padScaleModifiers, {
  bottom: function bottom() {
    return {
      styles: (0, _styledComponents.css)(_templateObject)
    };
  },
  center: function center() {
    return {
      styles: (0, _styledComponents.css)(_templateObject2)
    };
  },
  end: function end() {
    return {
      styles: (0, _styledComponents.css)(_templateObject3)
    };
  },
  fluid: function fluid(_ref) {
    var theme = _ref.theme;
    return {
      styles: (0, _styledComponents.css)(_templateObject4, theme.dimensions.gridPad, theme.dimensions.gridPad)
    };
  },
  middle: function middle() {
    return {
      styles: (0, _styledComponents.css)(_templateObject5)
    };
  },
  reverse: function reverse() {
    return {
      styles: (0, _styledComponents.css)(_templateObject6)
    };
  },
  start: function start() {
    return {
      styles: (0, _styledComponents.css)(_templateObject7)
    };
  },
  top: function top() {
    return {
      styles: (0, _styledComponents.css)(_templateObject8)
    };
  }
});

var THEME_PROPTYPES = (0, _styledComponentsThemeValidator.buildThemePropTypes)({
  dimensions: _propTypes2.default.shape({
    gridPad: _propTypes2.default.string.isRequired
  }).isRequired
});

var Row = _styledComponents2.default.div(_templateObject9, (0, _styledComponentsThemeValidator.validateTheme)(COMPONENT_NAME, THEME_PROPTYPES), (0, _styledComponentsModifiers.applyStyleModifiers)(MODIFIER_CONFIG), (0, _styledComponentsModifiers.applyResponsiveStyleModifiers)(MODIFIER_CONFIG));

Row.propTypes = {
  className: _propTypes2.default.string,
  modifiers: (0, _styledComponentsModifiers.styleModifierPropTypes)(MODIFIER_CONFIG),
  responsiveModifiers: (0, _styledComponentsModifiers.responsiveStyleModifierPropTypes)(MODIFIER_CONFIG),
  size: _propTypes2.default.string.isRequired
};

Row.defaultProps = {
  className: COMPONENT_NAME
};

var RowWithSize = (0, _reactiveContainer.withSize)(Row);

RowWithSize.displayName = COMPONENT_NAME;
RowWithSize.modifiers = MODIFIER_CONFIG;

exports.default = RowWithSize;

/***/ }),

/***/ "../node_modules/base-components/node_modules/styled-components-reactive-grid/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Row = exports.ReactiveContainer = exports.Container = exports.Column = undefined;

var _Column = __webpack_require__("../node_modules/base-components/node_modules/styled-components-reactive-grid/dist/Column.js");

var _Column2 = _interopRequireDefault(_Column);

var _Container = __webpack_require__("../node_modules/base-components/node_modules/styled-components-reactive-grid/dist/Container.js");

var _Container2 = _interopRequireDefault(_Container);

var _ReactiveContainer = __webpack_require__("../node_modules/base-components/node_modules/styled-components-reactive-grid/dist/ReactiveContainer.js");

var _ReactiveContainer2 = _interopRequireDefault(_ReactiveContainer);

var _Row = __webpack_require__("../node_modules/base-components/node_modules/styled-components-reactive-grid/dist/Row.js");

var _Row2 = _interopRequireDefault(_Row);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Column = _Column2.default;
exports.Container = _Container2.default;
exports.ReactiveContainer = _ReactiveContainer2.default;
exports.Row = _Row2.default;

/***/ }),

/***/ "../node_modules/base-components/node_modules/styled-components-reactive-grid/dist/utils/modifiers.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.padScaleModifiers = exports.displayModifiers = exports.dimensionModifiers = undefined;

var _templateObject = _taggedTemplateLiteral(['\n      display: flex;\n    '], ['\n      display: flex;\n    ']),
    _templateObject2 = _taggedTemplateLiteral(['\n      height: 100%;\n    '], ['\n      height: 100%;\n    ']),
    _templateObject3 = _taggedTemplateLiteral(['\n      flex: 1;\n    '], ['\n      flex: 1;\n    ']),
    _templateObject4 = _taggedTemplateLiteral(['\n      display: none;\n    '], ['\n      display: none;\n    ']),
    _templateObject5 = _taggedTemplateLiteral(['\n      padding: 0;\n    '], ['\n      padding: 0;\n    ']),
    _templateObject6 = _taggedTemplateLiteral(['\n      padding: ', ';\n    '], ['\n      padding: ', ';\n    ']),
    _templateObject7 = _taggedTemplateLiteral(['\n      padding: calc(', ' * 2);\n    '], ['\n      padding: calc(', ' * 2);\n    ']),
    _templateObject8 = _taggedTemplateLiteral(['\n      padding: calc(', ' * 3);\n    '], ['\n      padding: calc(', ' * 3);\n    ']),
    _templateObject9 = _taggedTemplateLiteral(['\n      padding: calc(', ' * 4);\n    '], ['\n      padding: calc(', ' * 4);\n    ']),
    _templateObject10 = _taggedTemplateLiteral(['\n      padding: calc(', ' * 5);\n    '], ['\n      padding: calc(', ' * 5);\n    ']),
    _templateObject11 = _taggedTemplateLiteral(['\n      padding-left: 0;\n      padding-right: 0;\n    '], ['\n      padding-left: 0;\n      padding-right: 0;\n    ']),
    _templateObject12 = _taggedTemplateLiteral(['\n      padding-left: ', ';\n      padding-right: ', ';\n    '], ['\n      padding-left: ', ';\n      padding-right: ', ';\n    ']),
    _templateObject13 = _taggedTemplateLiteral(['\n      padding-left: calc(', ' * 2);\n      padding-right: calc(', ' * 2);\n    '], ['\n      padding-left: calc(', ' * 2);\n      padding-right: calc(', ' * 2);\n    ']),
    _templateObject14 = _taggedTemplateLiteral(['\n      padding-left: calc(', ' * 3);\n      padding-right: calc(', ' * 3);\n    '], ['\n      padding-left: calc(', ' * 3);\n      padding-right: calc(', ' * 3);\n    ']),
    _templateObject15 = _taggedTemplateLiteral(['\n      padding-left: calc(', ' * 4);\n      padding-right: calc(', ' * 4);\n    '], ['\n      padding-left: calc(', ' * 4);\n      padding-right: calc(', ' * 4);\n    ']),
    _templateObject16 = _taggedTemplateLiteral(['\n      padding-left: calc(', ' * 5);\n      padding-right: calc(', ' * 5);\n    '], ['\n      padding-left: calc(', ' * 5);\n      padding-right: calc(', ' * 5);\n    ']),
    _templateObject17 = _taggedTemplateLiteral(['\n      padding-top: 0;\n      padding-bottom: 0;\n    '], ['\n      padding-top: 0;\n      padding-bottom: 0;\n    ']),
    _templateObject18 = _taggedTemplateLiteral(['\n      padding-top: ', ';\n      padding-bottom: ', ';\n    '], ['\n      padding-top: ', ';\n      padding-bottom: ', ';\n    ']),
    _templateObject19 = _taggedTemplateLiteral(['\n      padding-top: calc(', ' * 2);\n      padding-bottom: calc(', ' * 2);\n    '], ['\n      padding-top: calc(', ' * 2);\n      padding-bottom: calc(', ' * 2);\n    ']),
    _templateObject20 = _taggedTemplateLiteral(['\n      padding-top: calc(', ' * 3);\n      padding-bottom: calc(', ' * 3);\n    '], ['\n      padding-top: calc(', ' * 3);\n      padding-bottom: calc(', ' * 3);\n    ']),
    _templateObject21 = _taggedTemplateLiteral(['\n      padding-top: calc(', ' * 4);\n      padding-bottom: calc(', ' * 4);\n    '], ['\n      padding-top: calc(', ' * 4);\n      padding-bottom: calc(', ' * 4);\n    ']),
    _templateObject22 = _taggedTemplateLiteral(['\n      padding-top: calc(', ' * 5);\n      padding-bottom: calc(', ' * 5);\n    '], ['\n      padding-top: calc(', ' * 5);\n      padding-bottom: calc(', ' * 5);\n    ']);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var dimensionModifiers = {
  display_flex: function display_flex() {
    return {
      styles: (0, _styledComponents.css)(_templateObject)
    };
  },
  height_100: function height_100() {
    return {
      styles: (0, _styledComponents.css)(_templateObject2)
    };
  },
  flex_1: function flex_1() {
    return {
      styles: (0, _styledComponents.css)(_templateObject3)
    };
  }
};

var displayModifiers = {
  noDisplay: function noDisplay() {
    return {
      styles: (0, _styledComponents.css)(_templateObject4)
    };
  }
};

var padScaleModifiers = {
  padScale_0: function padScale_0() {
    return {
      styles: (0, _styledComponents.css)(_templateObject5)
    };
  },
  padScale_1: function padScale_1(_ref) {
    var theme = _ref.theme;
    return {
      styles: (0, _styledComponents.css)(_templateObject6, theme.dimensions.gridPad)
    };
  },
  padScale_2: function padScale_2(_ref2) {
    var theme = _ref2.theme;
    return {
      styles: (0, _styledComponents.css)(_templateObject7, theme.dimensions.gridPad)
    };
  },
  padScale_3: function padScale_3(_ref3) {
    var theme = _ref3.theme;
    return {
      styles: (0, _styledComponents.css)(_templateObject8, theme.dimensions.gridPad)
    };
  },
  padScale_4: function padScale_4(_ref4) {
    var theme = _ref4.theme;
    return {
      styles: (0, _styledComponents.css)(_templateObject9, theme.dimensions.gridPad)
    };
  },
  padScale_5: function padScale_5(_ref5) {
    var theme = _ref5.theme;
    return {
      styles: (0, _styledComponents.css)(_templateObject10, theme.dimensions.gridPad)
    };
  },
  padScaleX_0: function padScaleX_0() {
    return {
      styles: (0, _styledComponents.css)(_templateObject11)
    };
  },
  padScaleX_1: function padScaleX_1(_ref6) {
    var theme = _ref6.theme;
    return {
      styles: (0, _styledComponents.css)(_templateObject12, theme.dimensions.gridPad, theme.dimensions.gridPad)
    };
  },
  padScaleX_2: function padScaleX_2(_ref7) {
    var theme = _ref7.theme;
    return {
      styles: (0, _styledComponents.css)(_templateObject13, theme.dimensions.gridPad, theme.dimensions.gridPad)
    };
  },
  padScaleX_3: function padScaleX_3(_ref8) {
    var theme = _ref8.theme;
    return {
      styles: (0, _styledComponents.css)(_templateObject14, theme.dimensions.gridPad, theme.dimensions.gridPad)
    };
  },
  padScaleX_4: function padScaleX_4(_ref9) {
    var theme = _ref9.theme;
    return {
      styles: (0, _styledComponents.css)(_templateObject15, theme.dimensions.gridPad, theme.dimensions.gridPad)
    };
  },
  padScaleX_5: function padScaleX_5(_ref10) {
    var theme = _ref10.theme;
    return {
      styles: (0, _styledComponents.css)(_templateObject16, theme.dimensions.gridPad, theme.dimensions.gridPad)
    };
  },
  padScaleY_0: function padScaleY_0() {
    return {
      styles: (0, _styledComponents.css)(_templateObject17)
    };
  },
  padScaleY_1: function padScaleY_1(_ref11) {
    var theme = _ref11.theme;
    return {
      styles: (0, _styledComponents.css)(_templateObject18, theme.dimensions.gridPad, theme.dimensions.gridPad)
    };
  },
  padScaleY_2: function padScaleY_2(_ref12) {
    var theme = _ref12.theme;
    return {
      styles: (0, _styledComponents.css)(_templateObject19, theme.dimensions.gridPad, theme.dimensions.gridPad)
    };
  },
  padScaleY_3: function padScaleY_3(_ref13) {
    var theme = _ref13.theme;
    return {
      styles: (0, _styledComponents.css)(_templateObject20, theme.dimensions.gridPad, theme.dimensions.gridPad)
    };
  },
  padScaleY_4: function padScaleY_4(_ref14) {
    var theme = _ref14.theme;
    return {
      styles: (0, _styledComponents.css)(_templateObject21, theme.dimensions.gridPad, theme.dimensions.gridPad)
    };
  },
  padScaleY_5: function padScaleY_5(_ref15) {
    var theme = _ref15.theme;
    return {
      styles: (0, _styledComponents.css)(_templateObject22, theme.dimensions.gridPad, theme.dimensions.gridPad)
    };
  }
};

exports.dimensionModifiers = dimensionModifiers;
exports.displayModifiers = displayModifiers;
exports.padScaleModifiers = padScaleModifiers;

/***/ }),

/***/ "../node_modules/base64-js/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function placeHoldersCount (b64) {
  var len = b64.length
  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // the number of equal signs (place holders)
  // if there are two placeholders, than the two characters before it
  // represent one byte
  // if there is only one, then the three characters before it represent 2 bytes
  // this is just a cheap hack to not do indexOf twice
  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
}

function byteLength (b64) {
  // base64 is 4/3 + up to two characters of the original data
  return (b64.length * 3 / 4) - placeHoldersCount(b64)
}

function toByteArray (b64) {
  var i, l, tmp, placeHolders, arr
  var len = b64.length
  placeHolders = placeHoldersCount(b64)

  arr = new Arr((len * 3 / 4) - placeHolders)

  // if there are placeholders, only get up to the last complete 4 chars
  l = placeHolders > 0 ? len - 4 : len

  var L = 0

  for (i = 0; i < l; i += 4) {
    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
    arr[L++] = (tmp >> 16) & 0xFF
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  if (placeHolders === 2) {
    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[L++] = tmp & 0xFF
  } else if (placeHolders === 1) {
    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var output = ''
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    output += lookup[tmp >> 2]
    output += lookup[(tmp << 4) & 0x3F]
    output += '=='
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
    output += lookup[tmp >> 10]
    output += lookup[(tmp >> 4) & 0x3F]
    output += lookup[(tmp << 2) & 0x3F]
    output += '='
  }

  parts.push(output)

  return parts.join('')
}


/***/ }),

/***/ "../node_modules/batch-processor/src/batch-processor.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("../node_modules/batch-processor/src/utils.js");

module.exports = function batchProcessorMaker(options) {
    options             = options || {};
    var reporter        = options.reporter;
    var asyncProcess    = utils.getOption(options, "async", true);
    var autoProcess     = utils.getOption(options, "auto", true);

    if(autoProcess && !asyncProcess) {
        reporter && reporter.warn("Invalid options combination. auto=true and async=false is invalid. Setting async=true.");
        asyncProcess = true;
    }

    var batch = Batch();
    var asyncFrameHandler;
    var isProcessing = false;

    function addFunction(level, fn) {
        if(!isProcessing && autoProcess && asyncProcess && batch.size() === 0) {
            // Since this is async, it is guaranteed to be executed after that the fn is added to the batch.
            // This needs to be done before, since we're checking the size of the batch to be 0.
            processBatchAsync();
        }

        batch.add(level, fn);
    }

    function processBatch() {
        // Save the current batch, and create a new batch so that incoming functions are not added into the currently processing batch.
        // Continue processing until the top-level batch is empty (functions may be added to the new batch while processing, and so on).
        isProcessing = true;
        while (batch.size()) {
            var processingBatch = batch;
            batch = Batch();
            processingBatch.process();
        }
        isProcessing = false;
    }

    function forceProcessBatch(localAsyncProcess) {
        if (isProcessing) {
            return;
        }

        if(localAsyncProcess === undefined) {
            localAsyncProcess = asyncProcess;
        }

        if(asyncFrameHandler) {
            cancelFrame(asyncFrameHandler);
            asyncFrameHandler = null;
        }

        if(localAsyncProcess) {
            processBatchAsync();
        } else {
            processBatch();
        }
    }

    function processBatchAsync() {
        asyncFrameHandler = requestFrame(processBatch);
    }

    function clearBatch() {
        batch           = {};
        batchSize       = 0;
        topLevel        = 0;
        bottomLevel     = 0;
    }

    function cancelFrame(listener) {
        // var cancel = window.cancelAnimationFrame || window.mozCancelAnimationFrame || window.webkitCancelAnimationFrame || window.clearTimeout;
        var cancel = clearTimeout;
        return cancel(listener);
    }

    function requestFrame(callback) {
        // var raf = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || function(fn) { return window.setTimeout(fn, 20); };
        var raf = function(fn) { return setTimeout(fn, 0); };
        return raf(callback);
    }

    return {
        add: addFunction,
        force: forceProcessBatch
    };
};

function Batch() {
    var batch       = {};
    var size        = 0;
    var topLevel    = 0;
    var bottomLevel = 0;

    function add(level, fn) {
        if(!fn) {
            fn = level;
            level = 0;
        }

        if(level > topLevel) {
            topLevel = level;
        } else if(level < bottomLevel) {
            bottomLevel = level;
        }

        if(!batch[level]) {
            batch[level] = [];
        }

        batch[level].push(fn);
        size++;
    }

    function process() {
        for(var level = bottomLevel; level <= topLevel; level++) {
            var fns = batch[level];

            for(var i = 0; i < fns.length; i++) {
                var fn = fns[i];
                fn();
            }
        }
    }

    function getSize() {
        return size;
    }

    return {
        add: add,
        process: process,
        size: getSize
    };
}


/***/ }),

/***/ "../node_modules/batch-processor/src/utils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = module.exports = {};

utils.getOption = getOption;

function getOption(options, name, defaultValue) {
    var value = options[name];

    if((value === undefined || value === null) && defaultValue !== undefined) {
        return defaultValue;
    }

    return value;
}


/***/ }),

/***/ "../node_modules/buffer/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__("../node_modules/base64-js/index.js")
var ieee754 = __webpack_require__("../node_modules/ieee754/index.js")
var isArray = __webpack_require__("../node_modules/isarray/index.js")

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "../node_modules/charenc/charenc.js":
/***/ (function(module, exports) {

var charenc = {
  // UTF-8 encoding
  utf8: {
    // Convert a string to a byte array
    stringToBytes: function(str) {
      return charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
    },

    // Convert a byte array to a string
    bytesToString: function(bytes) {
      return decodeURIComponent(escape(charenc.bin.bytesToString(bytes)));
    }
  },

  // Binary encoding
  bin: {
    // Convert a string to a byte array
    stringToBytes: function(str) {
      for (var bytes = [], i = 0; i < str.length; i++)
        bytes.push(str.charCodeAt(i) & 0xFF);
      return bytes;
    },

    // Convert a byte array to a string
    bytesToString: function(bytes) {
      for (var str = [], i = 0; i < bytes.length; i++)
        str.push(String.fromCharCode(bytes[i]));
      return str.join('');
    }
  }
};

module.exports = charenc;


/***/ }),

/***/ "../node_modules/computed-style/dist/computedStyle.commonjs.js":
/***/ (function(module, exports) {

// This code has been refactored for 140 bytes
// You can see the original here: https://github.com/twolfson/computedStyle/blob/04cd1da2e30fa45844f95f5cb1ac898e9b9ef050/lib/computedStyle.js
var computedStyle = function (el, prop, getComputedStyle) {
  getComputedStyle = window.getComputedStyle;

  // In one fell swoop
  return (
    // If we have getComputedStyle
    getComputedStyle ?
      // Query it
      // TODO: From CSS-Query notes, we might need (node, null) for FF
      getComputedStyle(el) :

    // Otherwise, we are in IE and use currentStyle
      el.currentStyle
  )[
    // Switch to camelCase for CSSOM
    // DEV: Grabbed from jQuery
    // https://github.com/jquery/jquery/blob/1.9-stable/src/css.js#L191-L194
    // https://github.com/jquery/jquery/blob/1.9-stable/src/core.js#L593-L597
    prop.replace(/-(\w)/gi, function (word, letter) {
      return letter.toUpperCase();
    })
  ];
};

module.exports = computedStyle;


/***/ }),

/***/ "../node_modules/core-js/library/fn/get-iterator.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/library/modules/web.dom.iterable.js");
__webpack_require__("../node_modules/core-js/library/modules/es6.string.iterator.js");
module.exports = __webpack_require__("../node_modules/core-js/library/modules/core.get-iterator.js");


/***/ }),

/***/ "../node_modules/core-js/library/fn/is-iterable.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/library/modules/web.dom.iterable.js");
__webpack_require__("../node_modules/core-js/library/modules/es6.string.iterator.js");
module.exports = __webpack_require__("../node_modules/core-js/library/modules/core.is-iterable.js");


/***/ }),

/***/ "../node_modules/core-js/library/fn/object/get-own-property-names.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/library/modules/es6.object.get-own-property-names.js");
var $Object = __webpack_require__("../node_modules/core-js/library/modules/_core.js").Object;
module.exports = function getOwnPropertyNames(it) {
  return $Object.getOwnPropertyNames(it);
};


/***/ }),

/***/ "../node_modules/core-js/library/fn/object/keys.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/library/modules/es6.object.keys.js");
module.exports = __webpack_require__("../node_modules/core-js/library/modules/_core.js").Object.keys;


/***/ }),

/***/ "../node_modules/core-js/library/modules/core.get-iterator.js":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("../node_modules/core-js/library/modules/_an-object.js");
var get = __webpack_require__("../node_modules/core-js/library/modules/core.get-iterator-method.js");
module.exports = __webpack_require__("../node_modules/core-js/library/modules/_core.js").getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/core.is-iterable.js":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("../node_modules/core-js/library/modules/_classof.js");
var ITERATOR = __webpack_require__("../node_modules/core-js/library/modules/_wks.js")('iterator');
var Iterators = __webpack_require__("../node_modules/core-js/library/modules/_iterators.js");
module.exports = __webpack_require__("../node_modules/core-js/library/modules/_core.js").isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/es6.object.get-own-property-names.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__("../node_modules/core-js/library/modules/_object-sap.js")('getOwnPropertyNames', function () {
  return __webpack_require__("../node_modules/core-js/library/modules/_object-gopn-ext.js").f;
});


/***/ }),

/***/ "../node_modules/core-js/library/modules/es6.object.keys.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__("../node_modules/core-js/library/modules/_to-object.js");
var $keys = __webpack_require__("../node_modules/core-js/library/modules/_object-keys.js");

__webpack_require__("../node_modules/core-js/library/modules/_object-sap.js")('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),

/***/ "../node_modules/core-util-is/lib/util.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function isArray(arg) {
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return objectToString(arg) === '[object Array]';
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = Buffer.isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/buffer/index.js").Buffer))

/***/ }),

/***/ "../node_modules/crypt/crypt.js":
/***/ (function(module, exports) {

(function() {
  var base64map
      = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',

  crypt = {
    // Bit-wise rotation left
    rotl: function(n, b) {
      return (n << b) | (n >>> (32 - b));
    },

    // Bit-wise rotation right
    rotr: function(n, b) {
      return (n << (32 - b)) | (n >>> b);
    },

    // Swap big-endian to little-endian and vice versa
    endian: function(n) {
      // If number given, swap endian
      if (n.constructor == Number) {
        return crypt.rotl(n, 8) & 0x00FF00FF | crypt.rotl(n, 24) & 0xFF00FF00;
      }

      // Else, assume array and swap all items
      for (var i = 0; i < n.length; i++)
        n[i] = crypt.endian(n[i]);
      return n;
    },

    // Generate an array of any length of random bytes
    randomBytes: function(n) {
      for (var bytes = []; n > 0; n--)
        bytes.push(Math.floor(Math.random() * 256));
      return bytes;
    },

    // Convert a byte array to big-endian 32-bit words
    bytesToWords: function(bytes) {
      for (var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)
        words[b >>> 5] |= bytes[i] << (24 - b % 32);
      return words;
    },

    // Convert big-endian 32-bit words to a byte array
    wordsToBytes: function(words) {
      for (var bytes = [], b = 0; b < words.length * 32; b += 8)
        bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
      return bytes;
    },

    // Convert a byte array to a hex string
    bytesToHex: function(bytes) {
      for (var hex = [], i = 0; i < bytes.length; i++) {
        hex.push((bytes[i] >>> 4).toString(16));
        hex.push((bytes[i] & 0xF).toString(16));
      }
      return hex.join('');
    },

    // Convert a hex string to a byte array
    hexToBytes: function(hex) {
      for (var bytes = [], c = 0; c < hex.length; c += 2)
        bytes.push(parseInt(hex.substr(c, 2), 16));
      return bytes;
    },

    // Convert a byte array to a base-64 string
    bytesToBase64: function(bytes) {
      for (var base64 = [], i = 0; i < bytes.length; i += 3) {
        var triplet = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];
        for (var j = 0; j < 4; j++)
          if (i * 8 + j * 6 <= bytes.length * 8)
            base64.push(base64map.charAt((triplet >>> 6 * (3 - j)) & 0x3F));
          else
            base64.push('=');
      }
      return base64.join('');
    },

    // Convert a base-64 string to a byte array
    base64ToBytes: function(base64) {
      // Remove non-base-64 characters
      base64 = base64.replace(/[^A-Z0-9+\/]/ig, '');

      for (var bytes = [], i = 0, imod4 = 0; i < base64.length;
          imod4 = ++i % 4) {
        if (imod4 == 0) continue;
        bytes.push(((base64map.indexOf(base64.charAt(i - 1))
            & (Math.pow(2, -2 * imod4 + 8) - 1)) << (imod4 * 2))
            | (base64map.indexOf(base64.charAt(i)) >>> (6 - imod4 * 2)));
      }
      return bytes;
    }
  };

  module.exports = crypt;
})();


/***/ }),

/***/ "../node_modules/css-supports/index.js":
/***/ (function(module, exports) {

var _cacheSupports = {};

function parse(propertyName, reg) {
  return propertyName.split(reg).slice(1, -1);
}

function cssSupports(propertyName, value) {
  var style = document.createElement('div').style;

  // 1 argument
  if (typeof value === 'undefined') {
    // The regex will do this '( a:b ) or ( c:d )' => [" a:b ", " c:d "]
    var arrOr = parse(propertyName, /(?:^\(|\)\s*or\s*\(|\)$)/gi);
    if (arrOr) {
      return arrOr.some(function(condition) { return supports.apply(null, condition.split(':')); });
    }
    var arrAnd = parse(propertyName, /(?:^\(|\)\s*and\s*\(|\)$)/gi);
    if (arrAnd) {
      return arrAnd.every(function(condition) { return supports.apply(null, condition.split(':')); });
    }

    style.cssText = propertyName;
  // 2 arguments
  } else {
    style.cssText = propertyName + ':' + value;
  }

  return !!style.length;
}

function supports(propertyName, value) {
  propertyName = typeof propertyName !== 'undefined' &&
    String.prototype.trim.call(propertyName);
  value = typeof value !== 'undefined' &&
    String.prototype.trim.call(value) || undefined;

  if (!propertyName || (arguments.length === 2 && !value)) return false;

  var key = [propertyName, value].toString();
  if (key in _cacheSupports) {
    return _cacheSupports[key];
  }

  return _cacheSupports[key] = cssSupports(propertyName, value);
}

function shim() {
  if (!('CSS' in window)) {
    window.CSS = {};
  }

  if (!('supports' in window.CSS)) {
    window.CSS.supports = supports;
  }
}

module.exports = supports;
module.exports.shim = shim;


/***/ }),

/***/ "../node_modules/decisiv-domain-utils/build/components/FormattedRelative/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormattedRelative = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.selectUnits = selectUnits;

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _react = __webpack_require__("../node_modules/react/react.js");

var _propTypes = __webpack_require__("../node_modules/decisiv-domain-utils/node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = __webpack_require__("../node_modules/recompose/es/Recompose.js");

var _relativeTime = __webpack_require__("../node_modules/decisiv-domain-utils/build/components/FormattedRelative/relativeTime.js");

var _relativeTime2 = _interopRequireDefault(_relativeTime);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Adapted from the FormattedRelative component included with the react-intl library
// The original can be found here:
// https://github.com/yahoo/react-intl/blob/v2.4.0/src/components/relative.js

var SECOND = 1000;
var MINUTE = 1000 * 60;
var HOUR = 1000 * 60 * 60;
var DAY = 1000 * 60 * 60 * 24;

// The maximum timer delay value is a 32-bit signed integer.
// See: https://mdn.io/setTimeout
var MAX_TIMER_DELAY = 2147483647;

function selectUnits(delta) {
  var absDelta = Math.abs(delta);

  if (absDelta < MINUTE) {
    return 'second';
  }

  if (absDelta < HOUR) {
    return 'minute';
  }

  if (absDelta < DAY) {
    return 'hour';
  }

  // The maximum scheduled delay will be measured in days since the maximum
  // timer delay is less than the number of milliseconds in 25 days.
  return 'day';
}

function getUnitDelay(units) {
  /* istanbul ignore next */
  switch (units) {
    case 'second':
      return SECOND;
    case 'minute':
      return MINUTE;
    case 'hour':
      return HOUR;
    case 'day':
      return DAY;
    default:
      return MAX_TIMER_DELAY;
  }
}

function isSameDate(a, b) {
  if (a === b) {
    return true;
  }

  var aTime = new Date(a).getTime();
  var bTime = new Date(b).getTime();

  return Number.isFinite(aTime) && Number.isFinite(bTime) && aTime === bTime;
}

var FormattedRelative = exports.FormattedRelative = function (_Component) {
  _inherits(FormattedRelative, _Component);

  function FormattedRelative() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FormattedRelative);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FormattedRelative.__proto__ || Object.getPrototypeOf(FormattedRelative)).call.apply(_ref, [this].concat(args))), _this), _this.state = { now: new Date() }, _this.scheduleNextUpdate = function (props, state) {
      // Cancel and pending update because we're scheduling a new update.
      clearTimeout(_this.timer);

      var value = props.value,
          updateInterval = props.updateInterval;

      var time = new Date(value).getTime();

      // If the `updateInterval` is falsy, including `0` or we don't have a
      // valid date, then auto updates have been turned off, so we bail and
      // skip scheduling an update.
      if (!updateInterval || !Number.isFinite(time)) {
        return;
      }

      var delta = time - state.now;
      // const unitDelay = getUnitDelay(units || selectUnits(delta));
      var unitDelay = getUnitDelay(selectUnits(delta));
      var unitRemainder = Math.abs(delta % unitDelay);

      // We want the largest possible timer delay which will still display
      // accurate information while reducing unnecessary re-renders. The delay
      // should be until the next "interesting" moment, like a tick from
      // "1 minute ago" to "2 minutes ago" when the delta is 120,000ms.
      var delay = delta < 0 ? Math.max(updateInterval, unitDelay - unitRemainder) : Math.max(updateInterval, unitRemainder);

      _this.timer = setTimeout(function () {
        _this.setState({ now: new Date() });
      }, delay);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FormattedRelative, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.scheduleNextUpdate(this.props, this.state);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref2) {
      var nextValue = _ref2.value;

      // When the `props.value` date changes, `state.now` needs to be updated,
      // and the next update can be rescheduled.
      if (!isSameDate(nextValue, this.props.value)) {
        this.setState({ now: new Date() });
      }
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      this.scheduleNextUpdate(nextProps, nextState);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timer);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          render = _props.render,
          value = _props.value;

      var renderFunc = children || render;
      var timeString = (0, _relativeTime2.default)(value, this.props);

      return renderFunc(timeString);
    }
  }]);

  return FormattedRelative;
}(_react.Component);

FormattedRelative.propTypes = {
  children: _propTypes2.default.func,
  render: _propTypes2.default.func,
  // eslint-disable-next-line react/no-unused-prop-types
  updateInterval: _propTypes2.default.number,
  // eslint-disable-next-line react/forbid-prop-types
  value: _propTypes2.default.any.isRequired
};
FormattedRelative.defaultProps = {
  children: null,
  render: null,
  updateInterval: 1000 * 10
};
exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('FormattedRelative'), (0, _linguiReact.withI18n)())(FormattedRelative);

/***/ }),

/***/ "../node_modules/decisiv-domain-utils/build/components/FormattedRelative/relativeTime.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _minutes, _minutes2, _minutes3;

exports.default = relativeTime;

var _momentTimezone = __webpack_require__("../node_modules/moment-timezone/index.js");

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var relativeTimeConfig = {
  /*
    Each relative-time language dictionary is broken up into two sections: minutes and months.
     The keys within each section define upper bounds, in the given unit, for which the
    value should be be used.
     By "upper bounds", this means that the value would be used for any time difference
    up to, but NOT including, the corresponding number.  E.g. for unit "minutes" and a key
    value of "90", the corresponding value would be used for any relative time difference
    less than 90 minutes. For a difference of 90 or more minutes, the NEXT entry would be
    used.
     Each value is a string template. Each template can contain one (and only one) of
    the following substitutions:
      {seconds}
      {minutes}
      {hours}
      {days}
      {weeks}
      {months}
      {years}
     The substitution string will be replaced by the result of moment#diff, calculated
    for the given unit. For more information:
      https://momentjs.com/docs/#/displaying/difference/
   */
  future: {
    minutes: (_minutes = {
      60: (0, _linguiReact.i18nMark)('Less than an Hour') }, _defineProperty(_minutes, 2 * 60, (0, _linguiReact.i18nMark)('1 Hour')), _defineProperty(_minutes, 24 * 60, (0, _linguiReact.i18nMark)('{hours} Hours')), _defineProperty(_minutes, 2 * 24 * 60, (0, _linguiReact.i18nMark)('More than a Day')), _defineProperty(_minutes, 7 * 24 * 60, (0, _linguiReact.i18nMark)('{days} Days')), _defineProperty(_minutes, 2 * 7 * 24 * 60, (0, _linguiReact.i18nMark)('More than a Week')), _minutes),
    months: {
      1: (0, _linguiReact.i18nMark)('{weeks} Weeks'), // ≥ 2 weeks, < 1 month
      2: (0, _linguiReact.i18nMark)('More than a Month'), // ≥ 1 month, < 2 months
      12: (0, _linguiReact.i18nMark)('{months} Months'), // ≥ 2 months, < 12 months (1 year)
      24: (0, _linguiReact.i18nMark)('More than a Year') // ≥ 1 year, < 24 months (2 years)
    },
    max: (0, _linguiReact.i18nMark)('{years} Years') // ≥ 2 years
  },
  past: {
    minutes: (_minutes2 = {
      1: (0, _linguiReact.i18nMark)('Less than a Minute'),
      2: (0, _linguiReact.i18nMark)('A Minute Ago'),
      60: (0, _linguiReact.i18nMark)('{minutes} Minutes Ago')
    }, _defineProperty(_minutes2, 2 * 60, (0, _linguiReact.i18nMark)('An Hour Ago')), _defineProperty(_minutes2, 24 * 60, (0, _linguiReact.i18nMark)('{hours} Hours Ago')), _defineProperty(_minutes2, 2 * 24 * 60, (0, _linguiReact.i18nMark)('Yesterday')), _defineProperty(_minutes2, 7 * 24 * 60, (0, _linguiReact.i18nMark)('{days} Days Ago')), _defineProperty(_minutes2, 2 * 7 * 24 * 60, (0, _linguiReact.i18nMark)('A Week Ago')), _minutes2),
    months: {
      1: (0, _linguiReact.i18nMark)('{weeks} Weeks Ago'),
      2: (0, _linguiReact.i18nMark)('A Month Ago'),
      12: (0, _linguiReact.i18nMark)('{months} Months Ago'),
      24: (0, _linguiReact.i18nMark)('A Year Ago')
    },
    max: (0, _linguiReact.i18nMark)('{years} Years Ago')
  },
  downtime: {
    minutes: (_minutes3 = {
      60: (0, _linguiReact.i18nMark)('Less than an Hour')
    }, _defineProperty(_minutes3, 2 * 60, (0, _linguiReact.i18nMark)('More than an Hour')), _defineProperty(_minutes3, 24 * 60, (0, _linguiReact.i18nMark)('{hours} Hours')), _defineProperty(_minutes3, 2 * 24 * 60, (0, _linguiReact.i18nMark)('More than a Day')), _defineProperty(_minutes3, 7 * 24 * 60, (0, _linguiReact.i18nMark)('{days} Days')), _defineProperty(_minutes3, 2 * 7 * 24 * 60, (0, _linguiReact.i18nMark)('Over a Week')), _minutes3),
    months: {
      1: (0, _linguiReact.i18nMark)('{weeks} Weeks'),
      2: (0, _linguiReact.i18nMark)('Over a Month'),
      12: (0, _linguiReact.i18nMark)('{months} Months'),
      24: (0, _linguiReact.i18nMark)('Over a Year')
    },
    max: (0, _linguiReact.i18nMark)('Over {years} Years')
  }
};

/**
 * Get the appropriate relative-time map for the given times, style, and the
 * current language.
 * @param {Moment|String|Number|Date|Array} time
 * @param {Moment|String|Number|Date|Array} referenceTime
 * @param {String} style - a specific override format to use
 * @return {*}
 */
function relativeTimeDictionary(time, referenceTime) {
  var style = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

  if (style && relativeTimeConfig[style]) {
    return relativeTimeConfig[style];
  }

  if ((0, _momentTimezone2.default)(time).isAfter(referenceTime)) {
    return relativeTimeConfig.future;
  }

  return relativeTimeConfig.past;
}

/**
 * Return a human-readable rendering of a relative time - the duration between
 * the given `time` and some baseline "reference time".
 *
 * The style can be specified as a string which is used to look up the appropriate
 * variation of relative time strings, e.g. "downtime" or "realtime". These should
 * be keys into the current locale's relative time dictionary.
 *
 * If no `style` is specified, either "future" or "past" is used, depending on whether
 * the time is after (future) or before (past) the reference time.
 *
 * @param {Moment|String|Number|Date|Array} time
 * @param {Moment|String|Number|Date|Array} referenceTime
 * @param {String} style - a specific override format to use
 * @return {String}
 */
function relativeTimeTemplate(time, referenceTime, style) {
  var dictionary = relativeTimeDictionary(time, referenceTime, style);

  var result = void 0;
  var units = ['minutes', 'months'];
  (0, _lodash.forEach)(units, function (unit) {
    // get this unit's section of the dictionary
    var dictionarySection = dictionary[unit];
    if (dictionarySection) {
      // Find out the absolute difference (in ms) between the two times, in this unit
      var diff = Math.abs((0, _momentTimezone2.default)(referenceTime).diff(time, unit));
      // Get a sorted list of the numeric keys in the dictionary.
      // These keys each define an upper limit, i.e. for a key of 100, the value
      // of that entry in the dictionary would be used for any diff less than 100.
      var upperRanges = (0, _lodash.sortBy)(Object.keys(dictionarySection).map(Number));
      // Find which position in the list of ranges this diff would fit.
      var fit = (0, _lodash.sortedLastIndex)(upperRanges, diff);
      if (fit < upperRanges.length) {
        // fit is the index of the translation to use
        var fitInRange = upperRanges[fit];
        result = dictionarySection['' + fitInRange];
        return false; // break out of the forEach, since we have a value now
      }
    }

    return true; // move on to the next unit
  });

  return result || dictionary.max;
}

var SUBSTITUTION_UNITS = ['years', 'months', 'weeks', 'days', 'hours', 'minutes', 'seconds'];
var SUBSTITUTION_REGEXP = '{(' + SUBSTITUTION_UNITS.join('|') + ')}';

function relativeTime(time) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$referenceTime = _ref.referenceTime,
      referenceTime = _ref$referenceTime === undefined ? new Date() : _ref$referenceTime,
      _ref$style = _ref.style,
      style = _ref$style === undefined ? null : _ref$style,
      _ref$i18n = _ref.i18n,
      i18n = _ref$i18n === undefined ? null : _ref$i18n;

  var template = relativeTimeTemplate(time, referenceTime, style);

  var regExp = new RegExp(SUBSTITUTION_REGEXP);
  var matches = regExp.exec(template);

  if (!matches) {
    // no substitutions to be made in the template, so return it verbatim
    return i18n ? i18n._(template) : template;
  }

  var unit = matches[1];
  var referenceMoment = (0, _momentTimezone2.default)(referenceTime);
  var substitution = Math.abs(referenceMoment.diff(time, unit));

  if (i18n) {
    return i18n._(template, { values: _defineProperty({}, unit, substitution) });
  }

  return template.replace(regExp, '' + substitution);
}

/***/ }),

/***/ "../node_modules/decisiv-domain-utils/build/config.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.configEnabled = configEnabled;

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var TRUTHY_VALUES = ['true', 'yes', 't', 'y'];

/**
 * Checks a given environment variable value to determine if it contains
 * a "truthy" configuration value (true, yes, t, or y).
 * @param {String} key - the name of the environment variable
 * @returns {boolean} `true` if the env var is truthy, `false` otherwise.
 */
// eslint-disable-next-line import/prefer-default-export
function configEnabled(key) {
  return (0, _lodash.includes)(TRUTHY_VALUES, (0, _lodash.lowerCase)(Object({"API_BASE_URL":"https://fleet-mobile-api.preview.decisivapps.com/api","BRAND":"default","TENANT":"default","BUGSNAG_API_KEY":"f4c8e3bfb8dfbd3a460e53b1e5e6d244","GOOGLE_MAPS_API_KEY":"AIzaSyCHbt8PyscdyDliLBNekCqKUXWNUeMv2IA","HOTJAR_ENABLED":"true","PENDO_ENABLED":"true","PENDO_API_KEY":"981f8608-6052-42f5-432b-6bd80a96933d","RELEASE_STAGE":"preview","ZENDESK_ENABLED":"true","ZENDESK_DECISIV_KEY":"cbc4e684-7026-4b63-a690-b7470c5d3637","ZENDESK_MICHELIN_KEY":"71b8e91c-cb29-4fd1-a05e-758c67aa58b6","SHOW_GIT_REVISION":"true","APP_VERSION":"1.3.4","GIT_COMMIT":"e2696e6","VLV_PRICING_URL":"https://volvopg.preview.decisivapps.com","DCV_PRICING_URL":"https://dsmppg.preview.decisivapps.com","MICH_PRICING_URL":"https://michelinpg.preview.decisivapps.com","PORTUNUS_URL":"https://portunus.preview.decisivapps.com"})[key]));
}

/***/ }),

/***/ "../node_modules/decisiv-domain-utils/build/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _timeUtils = __webpack_require__("../node_modules/decisiv-domain-utils/build/timeUtils.js");

var timeUtils = _interopRequireWildcard(_timeUtils);

var _processOpenStatus = __webpack_require__("../node_modules/decisiv-domain-utils/build/processOpenStatus.js");

var processOpenStatus = _interopRequireWildcard(_processOpenStatus);

var _config = __webpack_require__("../node_modules/decisiv-domain-utils/build/config.js");

var _FormattedRelative = __webpack_require__("../node_modules/decisiv-domain-utils/build/components/FormattedRelative/index.js");

var _FormattedRelative2 = _interopRequireDefault(_FormattedRelative);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

module.exports = {
  configEnabled: _config.configEnabled,
  FormattedRelative: _FormattedRelative2.default,
  processOpenStatus: processOpenStatus,
  timeUtils: timeUtils
};

/***/ }),

/***/ "../node_modules/decisiv-domain-utils/build/processOpenStatus.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizeTimeString = normalizeTimeString;
exports.processOperatingHours = processOperatingHours;

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _momentTimezone = __webpack_require__("../node_modules/moment-timezone/index.js");

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _timeUtils = __webpack_require__("../node_modules/decisiv-domain-utils/build/timeUtils.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Clean up any random extra whitespace in the given time string (expected to
 * be roughly in a format like " 5:00AM") for the service provider operating
 * hours.
 */
function normalizeTimeString(str) {
  return str.replace(/\s/g, '') // remove all whitespace
  .replace('AM', ' AM').replace('PM', ' PM');
}

/**
 * Determine if the service provider (which is located in the given `timeZone`) is
 * currently open, based on the open/close hours of a given day of the week.
 */
function evalOpenStatus(targetDay, openingTime, closingTime, timeZone) {
  var timeNowAtProvider = (0, _timeUtils.getCurrentTime)(timeZone);
  var targetDayAtProvider = (0, _momentTimezone2.default)(timeNowAtProvider).day(targetDay);

  var dayNameAtProvider = targetDayAtProvider.format('dddd');

  // fail fast if `targetDay` is not the current day of the week at the provider
  if (dayNameAtProvider !== targetDay) return false;

  // create time objects for opening/closing times of the target day in the provider's time-zone:
  var ymd = targetDayAtProvider.format('YYYY-MM-DD');
  var parseFormat = 'YYYY-MM-DD h:mm A';
  var targetDayOpenAt = _momentTimezone2.default.tz(ymd + ' ' + openingTime, parseFormat, timeZone);
  var targetDayCloseAt = _momentTimezone2.default.tz(ymd + ' ' + closingTime, parseFormat, timeZone);

  // If targetDayOpenAt and targetDayCloseAt are same,
  // it is supposed that targetDayCloseAt is one day more.
  if (targetDayOpenAt.isSame(targetDayCloseAt)) targetDayCloseAt.add(1, 'day');
  // determine if the service provider is open right now, due to the current time
  // in the provider's time-zone falling between the open and close times for
  // the day of the week we're currently processing:
  return timeNowAtProvider.isBetween(targetDayOpenAt, targetDayCloseAt);
}

/**
 * This function serves two purposes:
 *   1. Process the incoming array of service provider operating hours to collapse multiple
 *      days having the same open/close hours into single entries.
 *   2. Determine if the service provider is currently open, based on the specified days
 *      and opening/closing hours.
 * It returns an object with two properties:
 *    * `hours`: the list of processed day-ranges with open/close hours
 *    * `isOpen`: a boolean indicating whether the provider is *currently* open
 */
function processOperatingHours(operatingHours, timeZone) {
  // incoming operatingHours will look something like this:
  // [  {:day=>"Monday", :open=>" 5:00AM", :close=>" 5:00PM"},
  //    {:day=>"Tuesday", :open=>" 5:00AM", :close=>" 5:00PM"},
  //    {:day=>"Wednesday", :open=>" 5:00AM", :close=>" 5:00PM"},
  //    {:day=>"Thursday", :open=>" 5:00AM", :close=>" 5:00PM"},
  //    {:day=>"Friday", :open=>" 5:00AM", :close=>" 5:00PM"},
  //    {:day=>"Saturday", :open=>" 5:00AM", :close=>" 3:00PM"},
  //    {:day=>"Sunday", :open=>" 5:00AM", :close=>" 3:00PM"} ]
  //
  // output should be...
  // [  { start: 'Monday', end: 'Friday', open: '5 AM', close: '5 PM' },
  //    { start: 'Saturday', end: 'Sunday', open: '5 AM', close: '3 PM' } ]

  var isOpen = false;

  var processedHours = operatingHours.reduce(function (processed, dayInfo) {
    // get the last processed day, and all the other processed days before that one:
    var lastDay = processed.length ? (0, _lodash.last)(processed) : { start: '', end: '', open: '', close: '' };
    var otherDays = (0, _lodash.initial)(processed);

    // this will be the full English name of the day of the week we're processing now:
    var targetDay = dayInfo.day;

    // clean up the open/close times:
    var open = normalizeTimeString(dayInfo.open);
    var close = normalizeTimeString(dayInfo.close);

    // if we haven't already found that the provider is open on a previous
    // day, check whether they're open on this day:
    isOpen = isOpen || evalOpenStatus(targetDay, open, close, timeZone);

    // compare this day's open/close with the last day's open/close:
    if (open === lastDay.open && close === lastDay.close) {
      // same open/close hours so merge this day into the last day
      return [].concat(_toConsumableArray(otherDays), [{
        start: lastDay.start || targetDay,
        end: targetDay,
        open: open,
        close: close
      }]);
    }
    // create a new day since this one has different hours from the last one
    return [].concat(_toConsumableArray(processed), [{
      start: targetDay,
      end: targetDay,
      open: open,
      close: close
    }]);
  }, []);

  return { hours: processedHours, isOpen: isOpen };
}

/***/ }),

/***/ "../node_modules/decisiv-domain-utils/build/timeUtils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userTimeZone = userTimeZone;
exports.formatDate = formatDate;
exports.getCurrentTime = getCurrentTime;
exports.convertRailsTz = convertRailsTz;

var _momentTimezone = __webpack_require__("../node_modules/moment-timezone/index.js");

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_TIME_FORMAT = 'D MMM YYYY, h:mm A z';
var DEFAULT_TIME_ZONE = 'America/New_York';

/**
 * Attempt to guess the user's timezone.  Falls back to US Eastern Time when
 * a timezone cannot be detected by the browser.
 */
function userTimeZone() {
  return _momentTimezone2.default.tz.guess() || DEFAULT_TIME_ZONE;
}

/**
 * Parse a given date string and then reformat based on the given format string, in
 * the given time zone (or, by default, in the user's time zone).
 */
function formatDate(date) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$format = _ref.format,
      format = _ref$format === undefined ? DEFAULT_TIME_FORMAT : _ref$format,
      _ref$tz = _ref.tz,
      tz = _ref$tz === undefined ? userTimeZone() : _ref$tz;

  return _momentTimezone2.default.tz(date, tz).format(format);
}

/**
 * Wrapper around `moment().tz(timeZone)` which allows for spying/mocking during
 * tests.  Should be used everywhere in the code, instead of `moment().tz`.
 */
function getCurrentTime() {
  var timeZone = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_TIME_ZONE;

  return (0, _momentTimezone2.default)().tz(timeZone);
}

/**
 * Mapping of Rails time-zones to time-zones that JS/moment.js can understand. The
 * keys are Rails TimeZone names; the values are from the tz database.
 *
 * This is copied from Rails ActiveSupport::TimeZone::MAPPING
 * https://github.com/rails/rails/blob/master/activesupport/lib/active_support/values/time_zone.rb
 */
var RAILS_TZ_MAPPINGS = {
  'International Date Line West': 'Pacific/Midway',
  'Midway Island': 'Pacific/Midway',
  'American Samoa': 'Pacific/Pago_Pago',
  Hawaii: 'Pacific/Honolulu',
  Alaska: 'America/Juneau',
  'Pacific Time (US & Canada)': 'America/Los_Angeles',
  Tijuana: 'America/Tijuana',
  'Mountain Time (US & Canada)': 'America/Denver',
  Arizona: 'America/Phoenix',
  Chihuahua: 'America/Chihuahua',
  Mazatlan: 'America/Mazatlan',
  'Central Time (US & Canada)': 'America/Chicago',
  Saskatchewan: 'America/Regina',
  Guadalajara: 'America/Mexico_City',
  'Mexico City': 'America/Mexico_City',
  Monterrey: 'America/Monterrey',
  'Central America': 'America/Guatemala',
  'Eastern Time (US & Canada)': 'America/New_York',
  'Indiana (East)': 'America/Indiana/Indianapolis',
  Bogota: 'America/Bogota',
  Lima: 'America/Lima',
  Quito: 'America/Lima',
  'Atlantic Time (Canada)': 'America/Halifax',
  Caracas: 'America/Caracas',
  'La Paz': 'America/La_Paz',
  Santiago: 'America/Santiago',
  Newfoundland: 'America/St_Johns',
  Brasilia: 'America/Sao_Paulo',
  'Buenos Aires': 'America/Argentina/Buenos_Aires',
  Montevideo: 'America/Montevideo',
  Georgetown: 'America/Guyana',
  'Puerto Rico': 'America/Puerto_Rico',
  Greenland: 'America/Godthab',
  'Mid-Atlantic': 'Atlantic/South_Georgia',
  Azores: 'Atlantic/Azores',
  'Cape Verde Is.': 'Atlantic/Cape_Verde',
  Dublin: 'Europe/Dublin',
  Edinburgh: 'Europe/London',
  Lisbon: 'Europe/Lisbon',
  London: 'Europe/London',
  Casablanca: 'Africa/Casablanca',
  Monrovia: 'Africa/Monrovia',
  UTC: 'Etc/UTC',
  Belgrade: 'Europe/Belgrade',
  Bratislava: 'Europe/Bratislava',
  Budapest: 'Europe/Budapest',
  Ljubljana: 'Europe/Ljubljana',
  Prague: 'Europe/Prague',
  Sarajevo: 'Europe/Sarajevo',
  Skopje: 'Europe/Skopje',
  Warsaw: 'Europe/Warsaw',
  Zagreb: 'Europe/Zagreb',
  Brussels: 'Europe/Brussels',
  Copenhagen: 'Europe/Copenhagen',
  Madrid: 'Europe/Madrid',
  Paris: 'Europe/Paris',
  Amsterdam: 'Europe/Amsterdam',
  Berlin: 'Europe/Berlin',
  Bern: 'Europe/Zurich',
  Zurich: 'Europe/Zurich',
  Rome: 'Europe/Rome',
  Stockholm: 'Europe/Stockholm',
  Vienna: 'Europe/Vienna',
  'West Central Africa': 'Africa/Algiers',
  Bucharest: 'Europe/Bucharest',
  Cairo: 'Africa/Cairo',
  Helsinki: 'Europe/Helsinki',
  Kyiv: 'Europe/Kiev',
  Riga: 'Europe/Riga',
  Sofia: 'Europe/Sofia',
  Tallinn: 'Europe/Tallinn',
  Vilnius: 'Europe/Vilnius',
  Athens: 'Europe/Athens',
  Istanbul: 'Europe/Istanbul',
  Minsk: 'Europe/Minsk',
  Jerusalem: 'Asia/Jerusalem',
  Harare: 'Africa/Harare',
  Pretoria: 'Africa/Johannesburg',
  Kaliningrad: 'Europe/Kaliningrad',
  Moscow: 'Europe/Moscow',
  'St. Petersburg': 'Europe/Moscow',
  Volgograd: 'Europe/Volgograd',
  Samara: 'Europe/Samara',
  Kuwait: 'Asia/Kuwait',
  Riyadh: 'Asia/Riyadh',
  Nairobi: 'Africa/Nairobi',
  Baghdad: 'Asia/Baghdad',
  Tehran: 'Asia/Tehran',
  'Abu Dhabi': 'Asia/Muscat',
  Muscat: 'Asia/Muscat',
  Baku: 'Asia/Baku',
  Tbilisi: 'Asia/Tbilisi',
  Yerevan: 'Asia/Yerevan',
  Kabul: 'Asia/Kabul',
  Ekaterinburg: 'Asia/Yekaterinburg',
  Islamabad: 'Asia/Karachi',
  Karachi: 'Asia/Karachi',
  Tashkent: 'Asia/Tashkent',
  Chennai: 'Asia/Kolkata',
  Kolkata: 'Asia/Kolkata',
  Mumbai: 'Asia/Kolkata',
  'New Delhi': 'Asia/Kolkata',
  Kathmandu: 'Asia/Kathmandu',
  Astana: 'Asia/Dhaka',
  Dhaka: 'Asia/Dhaka',
  'Sri Jayawardenepura': 'Asia/Colombo',
  Almaty: 'Asia/Almaty',
  Novosibirsk: 'Asia/Novosibirsk',
  Rangoon: 'Asia/Rangoon',
  Bangkok: 'Asia/Bangkok',
  Hanoi: 'Asia/Bangkok',
  Jakarta: 'Asia/Jakarta',
  Krasnoyarsk: 'Asia/Krasnoyarsk',
  Beijing: 'Asia/Shanghai',
  Chongqing: 'Asia/Chongqing',
  'Hong Kong': 'Asia/Hong_Kong',
  Urumqi: 'Asia/Urumqi',
  'Kuala Lumpur': 'Asia/Kuala_Lumpur',
  Singapore: 'Asia/Singapore',
  Taipei: 'Asia/Taipei',
  Perth: 'Australia/Perth',
  Irkutsk: 'Asia/Irkutsk',
  Ulaanbaatar: 'Asia/Ulaanbaatar',
  Seoul: 'Asia/Seoul',
  Osaka: 'Asia/Tokyo',
  Sapporo: 'Asia/Tokyo',
  Tokyo: 'Asia/Tokyo',
  Yakutsk: 'Asia/Yakutsk',
  Darwin: 'Australia/Darwin',
  Adelaide: 'Australia/Adelaide',
  Canberra: 'Australia/Melbourne',
  Melbourne: 'Australia/Melbourne',
  Sydney: 'Australia/Sydney',
  Brisbane: 'Australia/Brisbane',
  Hobart: 'Australia/Hobart',
  Vladivostok: 'Asia/Vladivostok',
  Guam: 'Pacific/Guam',
  'Port Moresby': 'Pacific/Port_Moresby',
  Magadan: 'Asia/Magadan',
  Srednekolymsk: 'Asia/Srednekolymsk',
  'Solomon Is.': 'Pacific/Guadalcanal',
  'New Caledonia': 'Pacific/Noumea',
  Fiji: 'Pacific/Fiji',
  Kamchatka: 'Asia/Kamchatka',
  'Marshall Is.': 'Pacific/Majuro',
  Auckland: 'Pacific/Auckland',
  Wellington: 'Pacific/Auckland',
  "Nuku'alofa": 'Pacific/Tongatapu',
  'Tokelau Is.': 'Pacific/Fakaofo',
  'Chatham Is.': 'Pacific/Chatham',
  Samoa: 'Pacific/Apia'
};

/**
 * Given a Rails-style time zone (e.g. 'Pacific Time (US & Canada)'), get the equivalent
 * time-zone name that moment.tz can understand (e.g. 'America/Los_Angeles').
 */
function convertRailsTz(railsTz) {
  return RAILS_TZ_MAPPINGS[railsTz] || railsTz;
}

/***/ }),

/***/ "../node_modules/decisiv-domain-utils/node_modules/prop-types/factoryWithThrowingShims.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__("../node_modules/fbjs/lib/emptyFunction.js");
var invariant = __webpack_require__("../node_modules/fbjs/lib/invariant.js");
var ReactPropTypesSecret = __webpack_require__("../node_modules/decisiv-domain-utils/node_modules/prop-types/lib/ReactPropTypesSecret.js");

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ "../node_modules/decisiv-domain-utils/node_modules/prop-types/index.js":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__("../node_modules/decisiv-domain-utils/node_modules/prop-types/factoryWithThrowingShims.js")();
}


/***/ }),

/***/ "../node_modules/decisiv-domain-utils/node_modules/prop-types/lib/ReactPropTypesSecret.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ "../node_modules/decisiv-ui-utils/build/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _theme = __webpack_require__("../node_modules/decisiv-ui-utils/build/style/theme.js");

var _theme2 = _interopRequireDefault(_theme);

var _modifiers = __webpack_require__("../node_modules/decisiv-ui-utils/build/modifiers/index.js");

var _modifiers2 = _interopRequireDefault(_modifiers);

var _buildStyledComponent = __webpack_require__("../node_modules/decisiv-ui-utils/build/utils/buildStyledComponent.js");

var _buildStyledComponent2 = _interopRequireDefault(_buildStyledComponent);

var _immutableToJS = __webpack_require__("../node_modules/decisiv-ui-utils/build/utils/immutableToJS.js");

var _immutableToJS2 = _interopRequireDefault(_immutableToJS);

var _px2rem = __webpack_require__("../node_modules/decisiv-ui-utils/build/utils/px2rem.js");

var _px2rem2 = _interopRequireDefault(_px2rem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  buildStyledComponent: _buildStyledComponent2.default,
  immutableToJS: _immutableToJS2.default,
  modifierPropTypes: _modifiers.propTypes,
  modifiers: _modifiers2.default,
  px2rem: _px2rem2.default,
  theme: _theme2.default
};

/***/ }),

/***/ "../node_modules/decisiv-ui-utils/build/modifiers/fontColors.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fontColorPropTypes = exports.fontColors = undefined;

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fontColors = {
  danger: function danger(_ref) {
    var theme = _ref.theme;
    return 'color: ' + theme.colors.status.danger + ';';
  },
  default: function _default(_ref2) {
    var theme = _ref2.theme;
    return 'color: ' + theme.colors.status.default + ';';
  },
  info: function info(_ref3) {
    var theme = _ref3.theme;
    return 'color: ' + theme.colors.status.info + ';';
  },
  success: function success(_ref4) {
    var theme = _ref4.theme;
    return 'color: ' + theme.colors.status.success + ';';
  },
  warning: function warning(_ref5) {
    var theme = _ref5.theme;
    return 'color: ' + theme.colors.status.warning + ';';
  }
};

var fontColorPropTypes = {
  colors: _propTypes2.default.shape({
    status: _propTypes2.default.shape({
      danger: _propTypes2.default.string.isRequired,
      default: _propTypes2.default.string.isRequired,
      info: _propTypes2.default.string.isRequired,
      success: _propTypes2.default.string.isRequired,
      warning: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.fontColors = fontColors;
exports.fontColorPropTypes = fontColorPropTypes;

/***/ }),

/***/ "../node_modules/decisiv-ui-utils/build/modifiers/fontStyles.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var fontStyles = {
  capitalize: function capitalize() {
    return 'text-transform: capitalize;';
  },
  italicize: function italicize() {
    return 'font-style: italic;';
  },
  lowercase: function lowercase() {
    return 'text-transform: lowercase;';
  },
  underline: function underline() {
    return 'text-decoration: underline;';
  },
  uppercase: function uppercase() {
    return 'text-transform: uppercase;';
  }
};

exports.default = fontStyles;

/***/ }),

/***/ "../node_modules/decisiv-ui-utils/build/modifiers/fontWeights.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fontWeights = exports.fontWeightPropTypes = undefined;

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fontWeights = {
  fontWeightBold: function fontWeightBold(_ref) {
    var theme = _ref.theme;
    return '\n    font-weight: ' + theme.fontWeights.bold + ';\n  ';
  },

  fontWeightLight: function fontWeightLight(_ref2) {
    var theme = _ref2.theme;
    return '\n    font-weight: ' + theme.fontWeights.light + ';\n  ';
  },

  fontWeightMedium: function fontWeightMedium(_ref3) {
    var theme = _ref3.theme;
    return '\n    font-weight: ' + theme.fontWeights.medium + ';\n  ';
  },

  fontWeightRegular: function fontWeightRegular(_ref4) {
    var theme = _ref4.theme;
    return '\n    font-weight: ' + theme.fontWeights.normal + ';\n  ';
  }
};

var fontWeightPropTypes = {
  fontWeights: _propTypes2.default.shape({
    bold: _propTypes2.default.number.isRequired,
    light: _propTypes2.default.number.isRequired,
    medium: _propTypes2.default.number.isRequired,
    normal: _propTypes2.default.number.isRequired
  }).isRequired
};

exports.fontWeightPropTypes = fontWeightPropTypes;
exports.fontWeights = fontWeights;

/***/ }),

/***/ "../node_modules/decisiv-ui-utils/build/modifiers/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = undefined;

var _fontColors = __webpack_require__("../node_modules/decisiv-ui-utils/build/modifiers/fontColors.js");

var _fontStyles = __webpack_require__("../node_modules/decisiv-ui-utils/build/modifiers/fontStyles.js");

var _fontStyles2 = _interopRequireDefault(_fontStyles);

var _fontWeights = __webpack_require__("../node_modules/decisiv-ui-utils/build/modifiers/fontWeights.js");

var _spacing = __webpack_require__("../node_modules/decisiv-ui-utils/build/modifiers/spacing.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
    ===== Usage =====

    import { modifiers, modifierPropTypes } from 'decisiv-ui-utils';

    const { fontWeights } = modifiers;
    const { fontWeightPropTypes } = modifierPropTypes;

    const modifierConfig = {
      ...fontWeights,
      ...customModifiers,
    };
 */

var propTypes = exports.propTypes = {
  fontColorPropTypes: _fontColors.fontColorPropTypes,
  fontWeightPropTypes: _fontWeights.fontWeightPropTypes,
  spacingPropTypes: _spacing.spacingPropTypes
};

exports.default = {
  fontColors: _fontColors.fontColors,
  fontStyles: _fontStyles2.default,
  fontWeights: _fontWeights.fontWeights,
  spacing: _spacing.spacing
};

/***/ }),

/***/ "../node_modules/decisiv-ui-utils/build/modifiers/spacing.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spacingPropTypes = exports.spacing = undefined;

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var spacing = {
  // margin
  gap: function gap(_ref) {
    var theme = _ref.theme;
    return '\n    margin: ' + theme.dimensions.gridPad + ';\n  ';
  },

  gapBottom: function gapBottom(_ref2) {
    var theme = _ref2.theme;
    return '\n    margin-bottom: ' + theme.dimensions.gridPad + ';\n  ';
  },

  gapLeft: function gapLeft(_ref3) {
    var theme = _ref3.theme;
    return '\n    margin-left: ' + theme.dimensions.gridPad + ';\n  ';
  },

  gapNone: function gapNone() {
    return 'margin: 0;';
  },

  gapRight: function gapRight(_ref4) {
    var theme = _ref4.theme;
    return '\n    margin-right: ' + theme.dimensions.gridPad + ';\n  ';
  },

  gapTop: function gapTop(_ref5) {
    var theme = _ref5.theme;
    return '\n    margin-top: ' + theme.dimensions.gridPad + ';\n  ';
  },

  gapX: function gapX(_ref6) {
    var theme = _ref6.theme;
    return '\n    margin-left: ' + theme.dimensions.gridPad + ';\n    margin-right: ' + theme.dimensions.gridPad + ';\n  ';
  },

  gapY: function gapY(_ref7) {
    var theme = _ref7.theme;
    return '\n    margin-bottom: ' + theme.dimensions.gridPad + ';\n    margin-top: ' + theme.dimensions.gridPad + ';\n  ';
  },
  // padding
  pad: function pad(_ref8) {
    var theme = _ref8.theme;
    return '\n    padding: ' + theme.dimensions.gridPad + ';\n  ';
  },

  padBottom: function padBottom(_ref9) {
    var theme = _ref9.theme;
    return '\n    padding-bottom: ' + theme.dimensions.gridPad + ';\n  ';
  },

  padLeft: function padLeft(_ref10) {
    var theme = _ref10.theme;
    return '\n    padding-left: ' + theme.dimensions.gridPad + ';\n  ';
  },

  padNone: function padNone() {
    return 'padding: 0;';
  },

  padRight: function padRight(_ref11) {
    var theme = _ref11.theme;
    return '\n    padding-right: ' + theme.dimensions.gridPad + ';\n  ';
  },

  padTop: function padTop(_ref12) {
    var theme = _ref12.theme;
    return '\n    padding-top: ' + theme.dimensions.gridPad + ';\n  ';
  },

  padX: function padX(_ref13) {
    var theme = _ref13.theme;
    return '\n    padding-left: ' + theme.dimensions.gridPad + ';\n    padding-right: ' + theme.dimensions.gridPad + ';\n  ';
  },

  padY: function padY(_ref14) {
    var theme = _ref14.theme;
    return '\n    padding-bottom: ' + theme.dimensions.gridPad + ';\n    padding-top: ' + theme.dimensions.gridPad + ';\n  ';
  }
};

var spacingPropTypes = {
  dimensions: _propTypes2.default.shape({
    gridPad: _propTypes2.default.string.isRequired
  }).isRequired
};

exports.spacing = spacing;
exports.spacingPropTypes = spacingPropTypes;

/***/ }),

/***/ "../node_modules/decisiv-ui-utils/build/style/animations/bounceIn.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bounceIn = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  0% {\n    transform: scale(0.8);\n  }\n  80% {\n    transform: scale(1.05);\n  }\n  100% {\n    transform: scale(1);\n  }\n'], ['\n  0% {\n    transform: scale(0.8);\n  }\n  80% {\n    transform: scale(1.05);\n  }\n  100% {\n    transform: scale(1);\n  }\n']);

var _styledComponents = __webpack_require__("../node_modules/decisiv-ui-utils/node_modules/styled-components/dist/styled-components.es.js");

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var bounceIn = exports.bounceIn = (0, _styledComponents.keyframes)(_templateObject);

exports.default = bounceIn;

/***/ }),

/***/ "../node_modules/decisiv-ui-utils/build/style/animations/bounceOut.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  0% {\n    transform: scale(1);\n  }\n  20% {\n    transform: scale(1.05);\n  }\n  100% {\n    transform: scale(0.2);\n  }\n'], ['\n  0% {\n    transform: scale(1);\n  }\n  20% {\n    transform: scale(1.05);\n  }\n  100% {\n    transform: scale(0.2);\n  }\n']);

var _styledComponents = __webpack_require__("../node_modules/decisiv-ui-utils/node_modules/styled-components/dist/styled-components.es.js");

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var bounceOut = (0, _styledComponents.keyframes)(_templateObject);

exports.default = bounceOut;

/***/ }),

/***/ "../node_modules/decisiv-ui-utils/build/style/animations/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bounceIn = __webpack_require__("../node_modules/decisiv-ui-utils/build/style/animations/bounceIn.js");

Object.defineProperty(exports, 'bounceIn', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_bounceIn).default;
  }
});

var _bounceOut = __webpack_require__("../node_modules/decisiv-ui-utils/build/style/animations/bounceOut.js");

Object.defineProperty(exports, 'bounceOut', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_bounceOut).default;
  }
});

var _spin = __webpack_require__("../node_modules/decisiv-ui-utils/build/style/animations/spin.js");

Object.defineProperty(exports, 'spin', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_spin).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "../node_modules/decisiv-ui-utils/build/style/animations/spin.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spin = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n'], ['\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n']);

var _styledComponents = __webpack_require__("../node_modules/decisiv-ui-utils/node_modules/styled-components/dist/styled-components.es.js");

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var spin = exports.spin = (0, _styledComponents.keyframes)(_templateObject);

exports.default = spin;

/***/ }),

/***/ "../node_modules/decisiv-ui-utils/build/style/brandColors.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Definition of the Decisiv brand color palette.
 */
var brandColors = {
  hover: '#0492d2',
  primary: '#0492d2',
  secondary: '#005d7e',
  tertiary: '#f6a623'
};

exports.default = brandColors;

/***/ }),

/***/ "../node_modules/decisiv-ui-utils/build/style/colors.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _polished = __webpack_require__("../node_modules/decisiv-ui-utils/node_modules/polished/dist/polished.es.js");

var _brandColors = __webpack_require__("../node_modules/decisiv-ui-utils/build/style/brandColors.js");

var _brandColors2 = _interopRequireDefault(_brandColors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var colors = {
  base: {
    background: '#ffffff',
    chrome000: '#ffffff',
    chrome100: '#f7f7f7',
    chrome200: '#e6e7e8',
    chrome300: '#cccccc',
    chrome400: '#bbbbbb',
    chrome500: '#999999',
    chrome600: '#666666',
    chrome700: '#333333',
    chrome800: '#111111',
    link: '#0375a8',
    linkHover: '#0492d2',
    linkVisited: '#884893',
    overlay: (0, _polished.rgba)('#333333', 0.85),
    selectableActive: (0, _polished.rgba)('#0492d2', 0.05),
    selectableHover: (0, _polished.rgba)('#cccccc', 0.2),
    shadow: (0, _polished.rgba)('#333333', 0.4),
    shadowLight: (0, _polished.rgba)('#333333', 0.2),
    text: '#111111',
    textLight: '#333333'
  },
  brand: _brandColors2.default,
  status: {
    danger: '#cc1111',
    default: '#999999',
    info: '#3DB9FF',
    success: '#00a651',
    successBackground: (0, _polished.rgba)('#00a651', 0.1),
    warning: '#f2c144'
  }
};

exports.default = colors;

/***/ }),

/***/ "../node_modules/decisiv-ui-utils/build/style/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var BASE_SIZE_PX = exports.BASE_SIZE_PX = 8;
var BASE_FONT_SIZE_PX = exports.BASE_FONT_SIZE_PX = BASE_SIZE_PX * 2;

/***/ }),

/***/ "../node_modules/decisiv-ui-utils/build/style/dimensions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _px2rem = __webpack_require__("../node_modules/decisiv-ui-utils/build/utils/px2rem.js");

var _px2rem2 = _interopRequireDefault(_px2rem);

var _constants = __webpack_require__("../node_modules/decisiv-ui-utils/build/style/constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Application-wide dimension constants
 */

var topNavHeightInPixel = 80;

exports.default = {
  fontSize: _constants.BASE_FONT_SIZE_PX,
  gridPad: (0, _px2rem2.default)(_constants.BASE_SIZE_PX / 2),

  // These dimensions options are deprecated and will be removed from the application.
  autoCollapseLeftNavPx: 1366, // no unit given because need to compare raw pixel value
  borderRadius: '2px',
  cardGridPadding: (0, _px2rem2.default)(4),
  cardMinWidth: 300,
  caseActionBarIconSize: (0, _px2rem2.default)(16),
  fontSizeMedium: (0, _px2rem2.default)(14),
  fontSizeNormal: (0, _px2rem2.default)(12),
  gridGutterSizeHalf: (0, _px2rem2.default)(25),
  leftNavChildItemHeight: (0, _px2rem2.default)(22),
  leftNavExpandTime: '0.3s',
  leftNavItemHeight: (0, _px2rem2.default)(26),
  leftNavWidth: (0, _px2rem2.default)(211),
  leftNavWidthCollapsed: (0, _px2rem2.default)(48),
  popOverArrowOffset: (0, _px2rem2.default)(40),
  popOverArrowSize: (0, _px2rem2.default)(18),
  popOverArrowSizeSmall: (0, _px2rem2.default)(12),
  popOverMinHeight: (0, _px2rem2.default)(25),
  popOverMinWidth: (0, _px2rem2.default)(150),
  spacingNormal: (0, _px2rem2.default)(15),
  statusCircleRadius: 10,
  tabWidth: (0, _px2rem2.default)(200),
  tooltipArrowSize: (0, _px2rem2.default)(6),
  topNavHeight: (0, _px2rem2.default)(topNavHeightInPixel),
  topNavHeightInPixel: topNavHeightInPixel
};

/***/ }),

/***/ "../node_modules/decisiv-ui-utils/build/style/fontWeights.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  light: 300,
  normal: 400,
  medium: 500,
  bold: 700
};

/***/ }),

/***/ "../node_modules/decisiv-ui-utils/build/style/fonts.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  primary: 'Montserrat',
  primaryFallbacks: 'Helvetica, Arial, sans-serif'
};

/***/ }),

/***/ "../node_modules/decisiv-ui-utils/build/style/globalStyles.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _polished = __webpack_require__("../node_modules/decisiv-ui-utils/node_modules/polished/dist/polished.es.js");

/**
 * Builds the global styles for the application.
 *
 * This sets the default font-family for the `<body>` element to use
 * the web-friendly fallback fonts until FontFaceObserver updates the
 * `<body>` tag indicating that the web-fonts have loaded; at that time
 * the font-family changes to include the main web-font.
 */
function buildGlobalStyleString(appTheme) {
  return '\n    ' + (0, _polished.normalize)() + '\n    html {\n      font-size: ' + appTheme.dimensions.fontSize + 'px;\n      height: 100%;\n    }\n    body {\n      height: 100%;\n      font-family: ' + appTheme.fonts.primaryFallback + ';\n      background-color: ' + appTheme.colors.base.background + ';\n      color: ' + appTheme.colors.base.text + ';\n      button,\n      input,\n      optgroup,\n      select,\n      textarea {\n        font-family: ' + appTheme.fonts.primaryFallback + ';\n        outline: none;\n      }\n      &.fontsLoaded {\n        font-family: ' + appTheme.fonts.primary + ';\n        button,\n        input,\n        optgroup,\n        select,\n        textarea {\n          font-family: ' + appTheme.fonts.primary + ';\n        }\n      }\n      ::-moz-placeholder {\n        font-style: italic;\n        color: ' + appTheme.colors.base.chrome500 + ';\n      }\n      :-ms-input-placeholder {\n        font-style: italic;\n        color: ' + appTheme.colors.base.chrome500 + ';\n      }\n      input:-moz-placeholder {\n        font-style: italic;\n        color: ' + appTheme.colors.base.chrome500 + ';\n      }\n      ::-webkit-input-placeholder {\n        font-style: italic;\n        color: ' + appTheme.colors.base.chrome500 + ';\n      }\n      #root {\n        height: 100%;\n        > * {\n          height: 100%;\n        }\n      }\n    }\n  ';
}

exports.default = {
  buildGlobalStyleString: buildGlobalStyleString
};

/***/ }),

/***/ "../node_modules/decisiv-ui-utils/build/style/theme.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _animations = __webpack_require__("../node_modules/decisiv-ui-utils/build/style/animations/index.js");

var animations = _interopRequireWildcard(_animations);

var _colors = __webpack_require__("../node_modules/decisiv-ui-utils/build/style/colors.js");

var _colors2 = _interopRequireDefault(_colors);

var _dimensions = __webpack_require__("../node_modules/decisiv-ui-utils/build/style/dimensions.js");

var _dimensions2 = _interopRequireDefault(_dimensions);

var _fonts = __webpack_require__("../node_modules/decisiv-ui-utils/build/style/fonts.js");

var _fonts2 = _interopRequireDefault(_fonts);

var _fontWeights = __webpack_require__("../node_modules/decisiv-ui-utils/build/style/fontWeights.js");

var _fontWeights2 = _interopRequireDefault(_fontWeights);

var _globalStyles = __webpack_require__("../node_modules/decisiv-ui-utils/build/style/globalStyles.js");

var _globalStyles2 = _interopRequireDefault(_globalStyles);

var _transitions = __webpack_require__("../node_modules/decisiv-ui-utils/build/style/transitions.js");

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
  animations: animations,
  colors: _colors2.default,
  dimensions: _dimensions2.default,
  fonts: _fonts2.default,
  fontWeights: _fontWeights2.default,
  globalStyles: _globalStyles2.default,
  transitions: _transitions2.default
};

/***/ }),

/***/ "../node_modules/decisiv-ui-utils/build/style/transitions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * App-wise transition constants
 */

var transitions = {
  heightExpand: '.15s cubic-bezier(0, 1, 0.5, 1)'
};

exports.default = transitions;

/***/ }),

/***/ "../node_modules/decisiv-ui-utils/build/utils/buildStyledComponent.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withTestTheme = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n    ', '\n    ', '\n    ', '\n    ', '\n  '], ['\n    ', '\n    ', '\n    ', '\n    ', '\n  ']);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _reactiveContainer = __webpack_require__("../node_modules/reactive-container/dist/index.js");

var _styledComponentsModifiers = __webpack_require__("../node_modules/styled-components-modifiers/dist/index.js");

var _styledComponentsThemeValidator = __webpack_require__("../node_modules/styled-components-theme-validator/dist/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/**
 * This utility was borrowed from the source code of styled-components v3, but it works just
 * fine in v2 as well.
 * https://github.com/styled-components/styled-components/blob/master/src/utils/isStyledComponent.js
 * @param {function} target a component to test.
 */
function isStyledComponent(target) {
  return typeof target === 'function' && typeof target.styledComponentId === 'string';
}

/**
 * Applies the theme to styled component as a defaultProp in test env only.
 * @param  {Component} StyledComponent A styled component
 * @return {Component}                 The styled component with the expected defaultProps
 */
var withTestTheme = exports.withTestTheme = function withTestTheme(StyledComponent) {
  /* istanbul ignore else */
  if (false) {
    // eslint-disable-next-line global-require
    var defaultTheme = require('../style/theme.js').default;

    // eslint-disable-next-line no-param-reassign
    StyledComponent.defaultProps = _extends({}, StyledComponent.defaultProps, {
      theme: defaultTheme
    });
  }

  return StyledComponent;
};

/**
 * Builder function for creating a new styled component with all the fancy add-ons and
 * extensions we've developed.
 *
 * * The theme available to the styled component will be validated using the given `themePropTypes`
 * * Style modifiers will be applied based on the given `modifierConfig`
 * * If `responsive` is truthy, responsive style modifiers will also be applied
 * * A `className` will be added based on...
 *   * the specified `className`, or
 *   * the `className` value from `defaultProps`, or
 *   * the `displayName` of the component.
 * * The styled component will be enhanced with `withTestTheme`
 * * If `responsive`, the styled component will also be enhanced via `withSize`
 *
 * @param {string} displayName - The meaningful display name for the rendered component
 * @param {function|StyledComponent} builderFn - A styled-component builder function, e.g. `styled.div`, or a previously built styled component, e.g `Button`.
 * @param {string|function} styles - The template string (or a function that produces one) used
 *   to render the styles for the component. If a function, receives a single `props` argument.
 * @param {Object} options - Additional options for the builder.
 * @param {Object} options.defaultProps - default property values for the component
 * @param {Object} options.modifierConfig - modifier configuration for component variations
 * @param {Object} options.propTypes - specification of the prop types for the component
 * @param {boolean} options.responsive - if true, responsive extensions will be applied
 * @param {Object} options.themePropTypes - for validation of the theme passed to the component
 * @param {string} options.className - used to explicitly set the `className` for the component
 * @returns {Component}
 */
function buildStyledComponent(displayName, builderFn) {
  var styles = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
      _ref$defaultProps = _ref.defaultProps,
      defaultProps = _ref$defaultProps === undefined ? {} : _ref$defaultProps,
      _ref$modifierConfig = _ref.modifierConfig,
      modifierConfig = _ref$modifierConfig === undefined ? {} : _ref$modifierConfig,
      _ref$propTypes = _ref.propTypes,
      propTypes = _ref$propTypes === undefined ? {} : _ref$propTypes,
      _ref$responsive = _ref.responsive,
      responsive = _ref$responsive === undefined ? false : _ref$responsive,
      _ref$themePropTypes = _ref.themePropTypes,
      themePropTypes = _ref$themePropTypes === undefined ? {} : _ref$themePropTypes,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var validationPropTypes = (0, _styledComponentsThemeValidator.buildThemePropTypes)(themePropTypes);

  // If the builderFn is a styled component, the developer is attempting
  // to extend a previously built styled component. These components get
  // some special treatment
  var isBuilderFnStyledComponent = isStyledComponent(builderFn);

  // A previously built styled component should be extended instead of
  // creating a completely new component.
  var finalBuilderFn = isBuilderFnStyledComponent ? builderFn.extend : builderFn;

  // Also, if the devoloper is using a styled component, merge the modifiers
  // from the parent with the modifierConfig specified for this component. This
  // allows the developer to use both without throwing errors.
  var finalModifierConfig = isBuilderFnStyledComponent && _typeof(builderFn.modifiers) === 'object' ? _extends({}, builderFn.modifiers, modifierConfig) : modifierConfig;

  var component = finalBuilderFn(_templateObject, (0, _styledComponentsThemeValidator.validateTheme)(displayName, validationPropTypes), styles, (0, _styledComponentsModifiers.applyStyleModifiers)(finalModifierConfig), responsive && (0, _styledComponentsModifiers.applyResponsiveStyleModifiers)(finalModifierConfig));

  var finalPropTypes = _extends({}, propTypes);

  if (!(0, _lodash.isEmpty)(finalModifierConfig)) {
    finalPropTypes.modifiers = (0, _styledComponentsModifiers.styleModifierPropTypes)(finalModifierConfig);
  }

  if (responsive) {
    finalPropTypes.responsiveModifiers = (0, _styledComponentsModifiers.responsiveStyleModifierPropTypes)(finalModifierConfig);
    finalPropTypes.size = _propTypes2.default.string.isRequired;
  }

  var classNameProp = defaultProps.className,
      otherDefaultProps = _objectWithoutProperties(defaultProps, ['className']);

  component.defaultProps = _extends({
    className: className || classNameProp || displayName
  }, otherDefaultProps);

  component.displayName = displayName;
  component.modifiers = finalModifierConfig;
  component.propTypes = finalPropTypes;

  if (responsive) {
    return withTestTheme((0, _reactiveContainer.withSize)(component));
  }

  return withTestTheme(component);
}

exports.default = buildStyledComponent;

/***/ }),

/***/ "../node_modules/decisiv-ui-utils/build/utils/immutableToJS.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * This HOC is used to convert the immutable objects held in the redux store into plain JS for
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * our React Components. For more information about this, please see this page in the redux docs:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * http://redux.js.org/docs/recipes/UsingImmutableJS.html
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * This HOC was adapted from these docs.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          */

var _immutable = __webpack_require__("../node_modules/immutable/dist/immutable.js");

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var immutableToJS = function immutableToJS(WrappedComponent) {
  return function (wrappedComponentProps) {
    var propsJS = Object.entries(wrappedComponentProps).reduce(function (newProps, _ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];

      return _extends({}, newProps, _defineProperty({}, key, _immutable.Iterable.isIterable(value) ? value.toJS() : value));
    }, {});

    return _react2.default.createElement(WrappedComponent, propsJS);
  };
};

exports.default = immutableToJS;

/***/ }),

/***/ "../node_modules/decisiv-ui-utils/build/utils/px2rem.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _constants = __webpack_require__("../node_modules/decisiv-ui-utils/build/style/constants.js");

var px2rem = (0, _lodash.curry)(function (base, pixels) {
  return pixels / base + 'rem';
});

exports.default = px2rem(_constants.BASE_FONT_SIZE_PX);

/***/ }),

/***/ "../node_modules/decisiv-ui-utils/node_modules/hoist-non-react-statics/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    arguments: true,
    arity: true
};

var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
        var keys = Object.getOwnPropertyNames(sourceComponent);

        /* istanbul ignore else */
        if (isGetOwnPropertySymbolsAvailable) {
            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
                try {
                    targetComponent[keys[i]] = sourceComponent[keys[i]];
                } catch (error) {

                }
            }
        }
    }

    return targetComponent;
};


/***/ }),

/***/ "../node_modules/decisiv-ui-utils/node_modules/polished/dist/polished.es.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "adjustHue", function() { return curriedAdjustHue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "animation", function() { return animation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundImages", function() { return backgroundImages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgrounds", function() { return backgrounds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "borderColor", function() { return borderColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "borderRadius", function() { return borderRadius; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "borderStyle", function() { return borderStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "borderWidth", function() { return borderWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "buttons", function() { return buttons; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clearFix", function() { return clearFix; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "complement", function() { return complement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "darken", function() { return curriedDarken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "desaturate", function() { return curriedDesaturate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "directionalProperty", function() { return directionalProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ellipsis", function() { return ellipsis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "em", function() { return em; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fontFace", function() { return fontFace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLuminance", function() { return getLuminance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "grayscale", function() { return grayscale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "invert", function() { return invert; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hideText", function() { return hideText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hideVisually", function() { return hideVisually; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hiDPI", function() { return hiDPI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hsl", function() { return hsl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hsla", function() { return hsla; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lighten", function() { return curriedLighten; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "margin", function() { return margin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mix", function() { return curriedMix; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "modularScale", function() { return modularScale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "normalize", function() { return normalize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opacify", function() { return curriedOpacify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "padding", function() { return padding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseToHsl", function() { return parseToHsl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseToRgb", function() { return parseToRgb; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "placeholder", function() { return placeholder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "position", function() { return position; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "radialGradient", function() { return radialGradient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "readableColor", function() { return curriedReadableColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rem", function() { return rem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "retinaImage", function() { return retinaImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rgb", function() { return rgb; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rgba", function() { return rgba; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saturate", function() { return curriedSaturate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selection", function() { return selection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setHue", function() { return curriedSetHue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLightness", function() { return curriedSetLightness; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSaturation", function() { return curriedSetSaturation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shade", function() { return curriedShade; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "size", function() { return size; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stripUnit", function() { return stripUnit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "textInputs", function() { return textInputs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "timingFunctions", function() { return timingFunctions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tint", function() { return curriedTint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toColorString", function() { return toColorString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "transitions", function() { return transitions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "transparentize", function() { return curriedTransparentize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "triangle", function() { return triangle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wordWrap", function() { return wordWrap; });
//      

// @private
function capitalizeString(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

//      
var positionMap = ['Top', 'Right', 'Bottom', 'Left'];

function generateProperty(property, position) {
  if (!property) return position.toLowerCase();
  var splitProperty = property.split('-');
  if (splitProperty.length > 1) {
    splitProperty.splice(1, 0, position);
    return splitProperty.reduce(function (acc, val) {
      return '' + acc + capitalizeString(val);
    });
  }
  var joinedProperty = property.replace(/([a-z])([A-Z])/g, '$1' + position + '$2');
  return property === joinedProperty ? '' + property + position : joinedProperty;
}

function generateStyles(property, valuesWithDefaults) {
  var styles = {};
  for (var i = 0; i < valuesWithDefaults.length; i += 1) {
    if (valuesWithDefaults[i] || valuesWithDefaults[i] === 0) {
      styles[generateProperty(property, positionMap[i])] = valuesWithDefaults[i];
    }
  }
  return styles;
}

/**
 * A helper that enables shorthand for direction based properties. It accepts a property (hyphenated or camelCased) and up to four values that map to top, right, bottom, and left, respectively. You can optionally pass an empty string to get only the directional values as properties. You can also optionally pass a null argument for a directional value to ignore it.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...directionalProperty('padding', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${directionalProperty('padding', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */

function directionalProperty(property) {
  for (var _len = arguments.length, values = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  //  prettier-ignore
  var firstValue = values[0],
      _values$ = values[1],
      secondValue = _values$ === undefined ? firstValue : _values$,
      _values$2 = values[2],
      thirdValue = _values$2 === undefined ? firstValue : _values$2,
      _values$3 = values[3],
      fourthValue = _values$3 === undefined ? secondValue : _values$3;

  var valuesWithDefaults = [firstValue, secondValue, thirdValue, fourthValue];
  return generateStyles(property, valuesWithDefaults);
}

//      

function endsWith (string, suffix) {
  return string.substr(-suffix.length) === suffix;
}

//      

/**
 * Strip the unit from a given CSS value, returning just the number. (or the original value if an invalid string was passed)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': stripUnit('100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${stripUnit('100px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100
 * }
 */

function stripUnit(value) {
  var unitlessValue = parseFloat(value);
  if (isNaN(unitlessValue)) return value;
  return unitlessValue;
}

//      

/**
 * Factory function that creates pixel-to-x converters
 * @private
 */
var pxtoFactory = function pxtoFactory(to) {
  return function (pxval) {
    var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '16px';

    var newPxval = pxval;
    var newBase = base;
    if (typeof pxval === 'string') {
      if (!endsWith(pxval, 'px')) {
        throw new Error('Expected a string ending in "px" or a number passed as the first argument to ' + to + '(), got "' + pxval + '" instead.');
      }
      newPxval = stripUnit(pxval);
    }

    if (typeof base === 'string') {
      if (!endsWith(base, 'px')) {
        throw new Error('Expected a string ending in "px" or a number passed as the second argument to ' + to + '(), got "' + base + '" instead.');
      }
      newBase = stripUnit(base);
    }

    if (typeof newPxval === 'string') {
      throw new Error('Passed invalid pixel value ("' + pxval + '") to ' + to + '(), please pass a value like "12px" or 12.');
    }

    if (typeof newBase === 'string') {
      throw new Error('Passed invalid base value ("' + base + '") to ' + to + '(), please pass a value like "12px" or 12.');
    }

    return '' + newPxval / newBase + to;
  };
};

//      
/**
 * Convert pixel value to ems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': em('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${em('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1em'
 * }
 */

var em = /*#__PURE__*/pxtoFactory('em');

//      

var ratioNames = {
  minorSecond: 1.067,
  majorSecond: 1.125,
  minorThird: 1.2,
  majorThird: 1.25,
  perfectFourth: 1.333,
  augFourth: 1.414,
  perfectFifth: 1.5,
  minorSixth: 1.6,
  goldenSection: 1.618,
  majorSixth: 1.667,
  minorSeventh: 1.778,
  majorSeventh: 1.875,
  octave: 2,
  majorTenth: 2.5,
  majorEleventh: 2.667,
  majorTwelfth: 3,
  doubleOctave: 4

  /** */

  /**
   * Establish consistent measurements and spacial relationships throughout your projects by incrementing up or down a defined scale. We provide a list of commonly used scales as pre-defined variables, see below.
   * @example
   * // Styles as object usage
   * const styles = {
   *    // Increment two steps up the default scale
   *   'fontSize': modularScale(2)
   * }
   *
   * // styled-components usage
   * const div = styled.div`
   *    // Increment two steps up the default scale
   *   fontSize: ${modularScale(2)}
   * `
   *
   * // CSS in JS Output
   *
   * element {
   *   'fontSize': '1.77689em'
   * }
   */
};function modularScale(steps) {
  var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1em';
  var ratio = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'perfectFourth';

  if (typeof steps !== 'number') {
    throw new Error('Please provide a number of steps to the modularScale helper.');
  }
  if (typeof ratio === 'string' && !ratioNames[ratio]) {
    throw new Error('Please pass a number or one of the predefined scales to the modularScale helper as the ratio.');
  }

  var realBase = typeof base === 'string' ? stripUnit(base) : base;
  var realRatio = typeof ratio === 'string' ? ratioNames[ratio] : ratio;

  if (typeof realBase === 'string') {
    throw new Error('Invalid value passed as base to modularScale, expected number or em string but got "' + base + '"');
  }

  return realBase * Math.pow(realRatio, steps) + 'em';
}

//      

/**
 * Convert pixel value to rems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': rem('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${rem('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1rem'
 * }
 */

var rem = /*#__PURE__*/pxtoFactory('rem');

//      

/**
 * CSS to contain a float (credit to CSSMojo).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...clearFix(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${clearFix()}
 * `
 *
 * // CSS as JS Output
 *
 * '&::after': {
 *   'clear': 'both',
 *   'content': '""',
 *   'display': 'table'
 * }
 */

function clearFix() {
  var _ref;

  var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '&';

  var pseudoSelector = parent + '::after';
  return _ref = {}, _ref[pseudoSelector] = {
    clear: 'both',
    content: '""',
    display: 'table'
  }, _ref;
}

//      

/**
 * CSS to represent truncated text with an ellipsis.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...ellipsis('250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${ellipsis('250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'display': 'inline-block',
 *   'maxWidth': '250px',
 *   'overflow': 'hidden',
 *   'textOverflow': 'ellipsis',
 *   'whiteSpace': 'nowrap',
 *   'wordWrap': 'normal'
 * }
 */

function ellipsis() {
  var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '100%';

  return {
    display: 'inline-block',
    maxWidth: width,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    wordWrap: 'normal'
  };
}

//      

/** */

function generateFileReferences(fontFilePath, fileFormats) {
  var fileFontReferences = fileFormats.map(function (format) {
    return 'url("' + fontFilePath + '.' + format + '")';
  });
  return fileFontReferences.join(', ');
}

function generateLocalReferences(localFonts) {
  var localFontReferences = localFonts.map(function (font) {
    return 'local("' + font + '")';
  });
  return localFontReferences.join(', ');
}

function generateSources(fontFilePath, localFonts, fileFormats) {
  var fontReferences = [];
  if (localFonts) fontReferences.push(generateLocalReferences(localFonts));
  if (fontFilePath) {
    fontReferences.push(generateFileReferences(fontFilePath, fileFormats));
  }
  return fontReferences.join(', ');
}

/**
 * CSS for a @font-face declaration.
 *
 * @example
 * // Styles as object basic usage
 * const styles = {
 *    ...fontFace({
 *      'fontFamily': 'Sans-Pro'
 *      'fontFilePath': 'path/to/file'
 *    })
 * }
 *
 * // styled-components basic usage
 * injectGlobal`${
 *   fontFace({
 *     'fontFamily': 'Sans-Pro'
 *     'fontFilePath': 'path/to/file'
 *   }
 * )}`
 *
 * // CSS as JS Output
 *
 * '@font-face': {
 *   'fontFamily': 'Sans-Pro',
 *   'src': 'url("path/to/file.eot"), url("path/to/file.woff2"), url("path/to/file.woff"), url("path/to/file.ttf"), url("path/to/file.svg")',
 * }
 */

function fontFace(_ref) {
  var fontFamily = _ref.fontFamily,
      fontFilePath = _ref.fontFilePath,
      fontStretch = _ref.fontStretch,
      fontStyle = _ref.fontStyle,
      fontVariant = _ref.fontVariant,
      fontWeight = _ref.fontWeight,
      _ref$fileFormats = _ref.fileFormats,
      fileFormats = _ref$fileFormats === undefined ? ['eot', 'woff2', 'woff', 'ttf', 'svg'] : _ref$fileFormats,
      localFonts = _ref.localFonts,
      unicodeRange = _ref.unicodeRange;

  // Error Handling
  if (!fontFamily) throw new Error('fontFace expects a name of a font-family.');
  if (!fontFilePath && !localFonts) {
    throw new Error('fontFace expects either the path to the font file(s) or a name of a local copy.');
  }
  if (localFonts && !Array.isArray(localFonts)) {
    throw new Error('fontFace expects localFonts to be an array.');
  }
  if (!Array.isArray(fileFormats)) {
    throw new Error('fontFace expects fileFormats to be an array.');
  }

  var fontFaceDeclaration = {
    '@font-face': {
      fontFamily: fontFamily,
      src: generateSources(fontFilePath, localFonts, fileFormats),
      unicodeRange: unicodeRange,
      fontStretch: fontStretch,
      fontStyle: fontStyle,
      fontVariant: fontVariant,
      fontWeight: fontWeight
    }

    // Removes undefined fields for cleaner css object.
  };return JSON.parse(JSON.stringify(fontFaceDeclaration));
}

//      

/**
 * CSS to hide text to show a background image in a SEO-friendly way.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'backgroundImage': 'url(logo.png)',
 *   ...hideText(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   backgroundImage: url(logo.png);
 *   ${hideText()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'backgroundImage': 'url(logo.png)',
 *   'textIndent': '101%',
 *   'overflow': 'hidden',
 *   'whiteSpace': 'nowrap',
 * }
 */

function hideText() {
  return {
    textIndent: '101%',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  };
}

//      

/**
 * CSS to hide content visually but remain accessible to screen readers.
 * from [HTML5 Boilerplate](https://github.com/h5bp/html5-boilerplate/blob/9a176f57af1cfe8ec70300da4621fb9b07e5fa31/src/css/main.css#L121)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...hideVisually(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hideVisually()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'border': '0',
 *   'clip': 'rect(0 0 0 0)',
 *   'clipPath': 'inset(50%)',
 *   'height': '1px',
 *   'margin': '-1px',
 *   'overflow': 'hidden',
 *   'padding': '0',
 *   'position': 'absolute',
 *   'whiteSpace': 'nowrap',
 *   'width': '1px',
 * }
 */

function hideVisually() {
  return {
    border: '0',
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: '0',
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: '1px'
  };
}

//      

/**
 * Generates a media query to target HiDPI devices.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  [hiDPI(1.5)]: {
 *    width: 200px;
 *  }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hiDPI(1.5)} {
 *     width: 200px;
 *   }
 * `
 *
 * // CSS as JS Output
 *
 * '@media only screen and (-webkit-min-device-pixel-ratio: 1.5),
 *  only screen and (min--moz-device-pixel-ratio: 1.5),
 *  only screen and (-o-min-device-pixel-ratio: 1.5/1),
 *  only screen and (min-resolution: 144dpi),
 *  only screen and (min-resolution: 1.5dppx)': {
 *   'width': '200px',
 * }
 */

function hiDPI() {
  var ratio = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1.3;

  return "\n    @media only screen and (-webkit-min-device-pixel-ratio: " + ratio + "),\n    only screen and (min--moz-device-pixel-ratio: " + ratio + "),\n    only screen and (-o-min-device-pixel-ratio: " + ratio + "/1),\n    only screen and (min-resolution: " + Math.round(ratio * 96) + "dpi),\n    only screen and (min-resolution: " + ratio + "dppx)\n  ";
}

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



























var taggedTemplateLiteralLoose = function (strings, raw) {
  strings.raw = raw;
  return strings;
};

var _opinionatedRules;
var _abbrTitle;
var _unopinionatedRules;

//      
var opinionatedRules = (_opinionatedRules = {
  html: {
    fontFamily: 'sans-serif'
  },

  body: {
    margin: '0'
  }

}, _opinionatedRules['a:active,\n  a:hover'] = {
  outlineWidth: '0'
}, _opinionatedRules['button,\n  input,\n  optgroup,\n  select,\n  textarea'] = {
  fontFamily: 'sans-serif',
  fontSize: '100%',
  lineHeight: '1.15'
}, _opinionatedRules);

var unopinionatedRules = (_unopinionatedRules = {
  html: {
    lineHeight: '1.15',
    textSizeAdjust: '100%'
  }

}, _unopinionatedRules['article,\n  aside,\n  footer,\n  header,\n  nav,\n  section'] = {
  display: 'block'
}, _unopinionatedRules.h1 = {
  fontSize: '2em',
  margin: '0.67em 0'
}, _unopinionatedRules['figcaption,\n  figure,\n  main'] = {
  display: 'block'
}, _unopinionatedRules.figure = {
  margin: '1em 40px'
}, _unopinionatedRules.hr = {
  boxSizing: 'content-box',
  height: '0',
  overflow: 'visible'
}, _unopinionatedRules.pre = {
  fontFamily: 'monospace, monospace',
  fontSize: '1em'
}, _unopinionatedRules.a = {
  'background-color': 'transparent',
  '-webkit-text-decoration-skip': 'objects'
}, _unopinionatedRules['abbr[title]'] = (_abbrTitle = {
  borderBottom: 'none',
  textDecoration: 'underline'
}, _abbrTitle['textDecoration'] = 'underline dotted', _abbrTitle), _unopinionatedRules['b,\n  strong'] = {
  fontWeight: 'inherit'
}, _unopinionatedRules['code,\n  kbd,\n  samp'] = {
  fontFamily: 'monospace, monospace',
  fontSize: '1em'
}, _unopinionatedRules.dfn = {
  fontStyle: 'italic'
}, _unopinionatedRules.mark = {
  backgroundColor: '#ff0',
  color: '#000'
}, _unopinionatedRules.small = {
  fontSize: '80%'
}, _unopinionatedRules['sub,\n  sup'] = {
  fontSize: '75%',
  lineHeight: '0',
  position: 'relative',
  verticalAlign: 'baseline'
}, _unopinionatedRules.sub = {
  bottom: '-0.25em'
}, _unopinionatedRules.sup = {
  top: '-0.5em'
}, _unopinionatedRules['audio,\n  video'] = {
  display: 'inline-block'
}, _unopinionatedRules['audio:not([controls])'] = {
  display: 'none',
  height: '0'
}, _unopinionatedRules.img = {
  borderStyle: 'none'
}, _unopinionatedRules['svg:not(:root)'] = {
  overflow: 'hidden'
}, _unopinionatedRules['button,\n  input,\n  optgroup,\n  select,\n  textarea'] = {
  margin: '0'
}, _unopinionatedRules['button,\n  input'] = {
  overflow: 'visible'
}, _unopinionatedRules['button,\n  select'] = {
  textTransform: 'none'
}, _unopinionatedRules['button,\n  html [type="button"],\n  [type="reset"],\n  [type="submit"]'] = {
  '-webkit-appearance': 'button'
}, _unopinionatedRules['button::-moz-focus-inner,\n  [type="button"]::-moz-focus-inner,\n  [type="reset"]::-moz-focus-inner,\n  [type="submit"]::-moz-focus-inner'] = {
  borderStyle: 'none',
  padding: '0'
}, _unopinionatedRules['button:-moz-focusring,\n  [type="button"]:-moz-focusring,\n  [type="reset"]:-moz-focusring,\n  [type="submit"]:-moz-focusring'] = {
  outline: '1px dotted ButtonText'
}, _unopinionatedRules.fieldset = {
  border: '1px solid #c0c0c0',
  margin: '0 2px',
  padding: '0.35em 0.625em 0.75em'
}, _unopinionatedRules.legend = {
  boxSizing: 'border-box',
  color: 'inherit',
  display: 'table',
  maxWidth: '100%',
  padding: '0',
  whiteSpace: 'normal'
}, _unopinionatedRules.progress = {
  display: 'inline-block',
  verticalAlign: 'baseline'
}, _unopinionatedRules.textarea = {
  overflow: 'auto'
}, _unopinionatedRules['[type="checkbox"],\n  [type="radio"]'] = {
  boxSizing: 'border-box',
  padding: '0'
}, _unopinionatedRules['[type="number"]::-webkit-inner-spin-button,\n  [type="number"]::-webkit-outer-spin-button'] = {
  height: 'auto'
}, _unopinionatedRules['[type="search"]'] = {
  '-webkit-appearance': 'textfield',
  outlineOffset: '-2px'
}, _unopinionatedRules['[type="search"]::-webkit-search-cancel-button,\n  [type="search"]::-webkit-search-decoration'] = {
  '-webkit-appearance': 'none'
}, _unopinionatedRules['::-webkit-file-upload-button'] = {
  '-webkit-appearance': 'button',
  font: 'inherit'
}, _unopinionatedRules['details,\n  menu'] = {
  display: 'block'
}, _unopinionatedRules.summary = {
  display: 'list-item'
}, _unopinionatedRules.canvas = {
  display: 'inline-block'
}, _unopinionatedRules.template = {
  display: 'none'
}, _unopinionatedRules['[hidden]'] = {
  display: 'none'
}, _unopinionatedRules);

function mergeRules(baseRules, additionalRules) {
  var mergedRules = _extends({}, baseRules);
  Object.keys(additionalRules).forEach(function (key) {
    if (mergedRules[key]) {
      mergedRules[key] = _extends({}, mergedRules[key], additionalRules[key]);
    } else {
      mergedRules[key] = _extends({}, additionalRules[key]);
    }
  });
  return mergedRules;
}

/**
 * CSS to normalize abnormalities across browsers (normalize.css v5.0.0 | MIT License | github.com/necolas/normalize.css)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...normalize(),
 * }
 *
 * // styled-components usage
 * injectGlobal`${normalize()}`
 *
 * // CSS as JS Output
 *
 * html {
 *   fontFamily: 'sans-serif',
 *   lineHeight: 1.15,
 *   textSizeAdjust: 100%,
 * } ...
 */
function normalize(excludeOpinionated) {
  if (excludeOpinionated) return unopinionatedRules;
  return mergeRules(unopinionatedRules, opinionatedRules);
}

//      

/**
 * CSS to style the placeholder pseudo-element.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...placeholder({'color': 'blue'})
 * }
 *
 * // styled-components usage
 * const div = styled.input`
 *    ${placeholder({'color': 'blue'})}
 * `
 *
 * // CSS as JS Output
 *
 * 'input': {
 *   '&:-moz-placeholder': {
 *     'color': 'blue',
 *   },
 *   '&:-ms-input-placeholder': {
 *     'color': 'blue',
 *   },
 *   '&::-moz-placeholder': {
 *     'color': 'blue',
 *   },
 *   '&::-webkit-input-placeholder': {
 *     'color': 'blue',
 *   },
 * },
 */

function placeholder(styles) {
  var _ref;

  var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '&';

  return _ref = {}, _ref[parent + '::-webkit-input-placeholder'] = _extends({}, styles), _ref[parent + ':-moz-placeholder'] = _extends({}, styles), _ref[parent + '::-moz-placeholder'] = _extends({}, styles), _ref[parent + ':-ms-input-placeholder'] = _extends({}, styles), _ref;
}

var _templateObject = /*#__PURE__*/ taggedTemplateLiteralLoose(['radial-gradient(', '', '', '', ')'], ['radial-gradient(', '', '', '', ')']);

//      

/** */

function parseFallback(colorStops) {
  return colorStops[0].split(' ')[0];
}

function constructGradientValue(literals) {
  var template = '';
  for (var i = 0; i < literals.length; i += 1) {
    template += literals[i];
    // Adds leading coma if properties preceed color-stops
    if (i === 3 && (arguments.length <= i + 1 ? undefined : arguments[i + 1]) && ((arguments.length <= 1 ? undefined : arguments[1]) || (arguments.length <= 2 ? undefined : arguments[2]) || (arguments.length <= 3 ? undefined : arguments[3]))) {
      template = template.slice(0, -1);
      template += ', ' + (arguments.length <= i + 1 ? undefined : arguments[i + 1]);
      // No trailing space if color-stops is the only param provided
    } else if (i === 3 && (arguments.length <= i + 1 ? undefined : arguments[i + 1]) && !(arguments.length <= 1 ? undefined : arguments[1]) && !(arguments.length <= 2 ? undefined : arguments[2]) && !(arguments.length <= 3 ? undefined : arguments[3])) {
      template += '' + (arguments.length <= i + 1 ? undefined : arguments[i + 1]);
      // Only adds substitution if it is defined
    } else if (arguments.length <= i + 1 ? undefined : arguments[i + 1]) {
      template += (arguments.length <= i + 1 ? undefined : arguments[i + 1]) + ' ';
    }
  }
  return template.trim();
}

/**
 * CSS for declaring a radial gradient, including a fallback background-color. The fallback is either the first color-stop or an explicitly passed fallback color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })}
 *`
 *
 * // CSS as JS Output
 *
 * div: {
 *   'backgroundColor': '#00FFFF',
 *   'backgroundImage': 'radial-gradient(center ellipse farthest-corner at 45px 45px, #00FFFF 0%, rgba(0, 0, 255, 0) 50%, #0000FF 95%)',
 * }
 */

function radialGradient(_ref) {
  var colorStops = _ref.colorStops,
      extent = _ref.extent,
      fallback = _ref.fallback,
      position = _ref.position,
      shape = _ref.shape;

  if (!colorStops || colorStops.length < 2) {
    throw new Error('radialGradient requries at least 2 color-stops to properly render.');
  }
  return {
    backgroundColor: fallback || parseFallback(colorStops),
    backgroundImage: constructGradientValue(_templateObject, position, shape, extent, colorStops.join(', '))
  };
}

//      

/**
 * A helper to generate a retina background image and non-retina
 * background image. The retina background image will output to a HiDPI media query. The mixin uses
 * a _2x.png filename suffix by default.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  ...retinaImage('my-img')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${retinaImage('my-img')}
 * `
 *
 * // CSS as JS Output
 * div {
 *   backgroundImage: 'url(my-img.png)',
 *   '@media only screen and (-webkit-min-device-pixel-ratio: 1.3),
 *    only screen and (min--moz-device-pixel-ratio: 1.3),
 *    only screen and (-o-min-device-pixel-ratio: 1.3/1),
 *    only screen and (min-resolution: 144dpi),
 *    only screen and (min-resolution: 1.5dppx)': {
 *     backgroundImage: 'url(my-img_2x.png)',
 *   }
 * }
 */
function retinaImage(filename, backgroundSize) {
  var extension = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'png';

  var _ref;

  var retinaFilename = arguments[3];
  var retinaSuffix = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '_2x';

  if (!filename) {
    throw new Error('Please supply a filename to retinaImage() as the first argument.');
  }
  // Replace the dot at the beginning of the passed extension if one exists
  var ext = extension.replace(/^\./, '');
  var rFilename = retinaFilename ? retinaFilename + '.' + ext : '' + filename + retinaSuffix + '.' + ext;

  return _ref = {
    backgroundImage: 'url(' + filename + '.' + ext + ')'
  }, _ref[hiDPI()] = {
    backgroundImage: 'url(' + rFilename + ')',
    backgroundSize: backgroundSize
  }, _ref;
}

//      

/**
 * CSS to style the selection pseudo-element.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...selection({
 *     'backgroundColor': 'blue'
 *   }, 'section')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${selection({'backgroundColor': 'blue'}, 'section')}
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'section::-moz-selection': {
 *     'backgroundColor':'blue',
 *   },
 *   'section::selection': {
 *     'backgroundColor': 'blue',
 *   }
 * }
 */

function selection(styles) {
  var _ref;

  var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  return _ref = {}, _ref[parent + '::-moz-selection'] = _extends({}, styles), _ref[parent + '::selection'] = _extends({}, styles), _ref;
}

//      

/* eslint-disable key-spacing */
var functionsMap = {
  easeInBack: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
  easeInCirc: 'cubic-bezier(0.600,  0.040, 0.980, 0.335)',
  easeInCubic: 'cubic-bezier(0.550,  0.055, 0.675, 0.190)',
  easeInExpo: 'cubic-bezier(0.950,  0.050, 0.795, 0.035)',
  easeInQuad: 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
  easeInQuart: 'cubic-bezier(0.895,  0.030, 0.685, 0.220)',
  easeInQuint: 'cubic-bezier(0.755,  0.050, 0.855, 0.060)',
  easeInSine: 'cubic-bezier(0.470,  0.000, 0.745, 0.715)',

  easeOutBack: 'cubic-bezier(0.175,  0.885, 0.320, 1.275)',
  easeOutCubic: 'cubic-bezier(0.215,  0.610, 0.355, 1.000)',
  easeOutCirc: 'cubic-bezier(0.075,  0.820, 0.165, 1.000)',
  easeOutExpo: 'cubic-bezier(0.190,  1.000, 0.220, 1.000)',
  easeOutQuad: 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
  easeOutQuart: 'cubic-bezier(0.165,  0.840, 0.440, 1.000)',
  easeOutQuint: 'cubic-bezier(0.230,  1.000, 0.320, 1.000)',
  easeOutSine: 'cubic-bezier(0.390,  0.575, 0.565, 1.000)',

  easeInOutBack: 'cubic-bezier(0.680, -0.550, 0.265, 1.550)',
  easeInOutCirc: 'cubic-bezier(0.785,  0.135, 0.150, 0.860)',
  easeInOutCubic: 'cubic-bezier(0.645,  0.045, 0.355, 1.000)',
  easeInOutExpo: 'cubic-bezier(1.000,  0.000, 0.000, 1.000)',
  easeInOutQuad: 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
  easeInOutQuart: 'cubic-bezier(0.770,  0.000, 0.175, 1.000)',
  easeInOutQuint: 'cubic-bezier(0.860,  0.000, 0.070, 1.000)',
  easeInOutSine: 'cubic-bezier(0.445,  0.050, 0.550, 0.950)'
  /* eslint-enable key-spacing */

  /** */

  /**
   * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
   *
   * @example
   * // Styles as object usage
   * const styles = {
   *   'transitionTimingFunction': timingFunctions('easeInQuad')
   * }
   *
   * // styled-components usage
   *  const div = styled.div`
   *   transitionTimingFunction: ${timingFunctions('easeInQuad')};
   * `
   *
   * // CSS as JS Output
   *
   * 'div': {
   *   'transitionTimingFunction': 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
   * }
   */

};function timingFunctions(timingFunction) {
  return functionsMap[timingFunction];
}

//      

/** */

var getBorderWidth = function getBorderWidth(pointingDirection, height, width) {
  switch (pointingDirection) {
    case 'top':
      return '0 ' + width / 2 + 'px ' + height + 'px ' + width / 2 + 'px';
    case 'left':
      return height / 2 + 'px ' + width + 'px ' + height / 2 + 'px 0';
    case 'bottom':
      return height + 'px ' + width / 2 + 'px 0 ' + width / 2 + 'px';
    case 'right':
      return height / 2 + 'px 0 ' + height / 2 + 'px ' + width + 'px';

    default:
      throw new Error("Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.");
  }
};

// needed for border-color
var reverseDirection = {
  left: 'Right',
  right: 'Left',
  top: 'Bottom',
  bottom: 'Top'

  /**
   * CSS to represent triangle with any pointing direction with an optional background color. Accepts number or px values for height and width.
   *
   * @example
   * // Styles as object usage
   *
   * const styles = {
   *   ...triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })
   * }
   *
   *
   * // styled-components usage
   * const div = styled.div`
   *   ${triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })}
   *
   *
   * // CSS as JS Output
   *
   * div: {
   *  'borderColor': 'transparent',
   *  'borderLeftColor': 'red !important',
   *  'borderStyle': 'solid',
   *  'borderWidth': '50px 0 50px 100px',
   *  'height': '0',
   *  'width': '0',
   * }
   */

};function triangle(_ref) {
  var _ref2;

  var pointingDirection = _ref.pointingDirection,
      height = _ref.height,
      width = _ref.width,
      foregroundColor = _ref.foregroundColor,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === undefined ? 'transparent' : _ref$backgroundColor;

  var unitlessHeight = parseFloat(height);
  var unitlessWidth = parseFloat(width);
  if (isNaN(unitlessHeight) || isNaN(unitlessWidth)) {
    throw new Error('Passed an invalid value to `height` or `width`. Please provide a pixel based unit');
  }

  return _ref2 = {
    borderColor: backgroundColor,
    width: '0',
    height: '0',
    borderWidth: getBorderWidth(pointingDirection, unitlessHeight, unitlessWidth),
    borderStyle: 'solid'
  }, _ref2['border' + reverseDirection[pointingDirection] + 'Color'] = foregroundColor + ' !important', _ref2;
}

//      

/**
 * Provides an easy way to change the `wordWrap` property.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...wordWrap('break-word')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${wordWrap('break-word')}
 * `
 *
 * // CSS as JS Output
 *
 * const styles = {
 *   overflowWrap: 'break-word',
 *   wordWrap: 'break-word',
 *   wordBreak: 'break-all',
 * }
 */

function wordWrap() {
  var wrap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'break-word';

  var wordBreak = wrap === 'break-word' ? 'break-all' : wrap;
  return {
    overflowWrap: wrap,
    wordWrap: wrap,
    wordBreak: wordBreak
  };
}

//      


function colorToInt(color) {
  return Math.round(color * 255);
}

function convertToInt(red, green, blue) {
  return colorToInt(red) + "," + colorToInt(green) + "," + colorToInt(blue);
}

function hslToRgb(hue, saturation, lightness) {
  var convert = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : convertToInt;

  if (saturation === 0) {
    // achromatic
    return convert(lightness, lightness, lightness);
  }

  // formular from https://en.wikipedia.org/wiki/HSL_and_HSV
  var huePrime = hue % 360 / 60;
  var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
  var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));

  var red = 0;
  var green = 0;
  var blue = 0;

  if (huePrime >= 0 && huePrime < 1) {
    red = chroma;
    green = secondComponent;
  } else if (huePrime >= 1 && huePrime < 2) {
    red = secondComponent;
    green = chroma;
  } else if (huePrime >= 2 && huePrime < 3) {
    green = chroma;
    blue = secondComponent;
  } else if (huePrime >= 3 && huePrime < 4) {
    green = secondComponent;
    blue = chroma;
  } else if (huePrime >= 4 && huePrime < 5) {
    red = secondComponent;
    blue = chroma;
  } else if (huePrime >= 5 && huePrime < 6) {
    red = chroma;
    blue = secondComponent;
  }

  var lightnessModification = lightness - chroma / 2;
  var finalRed = red + lightnessModification;
  var finalGreen = green + lightnessModification;
  var finalBlue = blue + lightnessModification;
  return convert(finalRed, finalGreen, finalBlue);
}

//      
var namedColorMap = {
  aliceblue: 'f0f8ff',
  antiquewhite: 'faebd7',
  aqua: '00ffff',
  aquamarine: '7fffd4',
  azure: 'f0ffff',
  beige: 'f5f5dc',
  bisque: 'ffe4c4',
  black: '000',
  blanchedalmond: 'ffebcd',
  blue: '0000ff',
  blueviolet: '8a2be2',
  brown: 'a52a2a',
  burlywood: 'deb887',
  cadetblue: '5f9ea0',
  chartreuse: '7fff00',
  chocolate: 'd2691e',
  coral: 'ff7f50',
  cornflowerblue: '6495ed',
  cornsilk: 'fff8dc',
  crimson: 'dc143c',
  cyan: '00ffff',
  darkblue: '00008b',
  darkcyan: '008b8b',
  darkgoldenrod: 'b8860b',
  darkgray: 'a9a9a9',
  darkgreen: '006400',
  darkgrey: 'a9a9a9',
  darkkhaki: 'bdb76b',
  darkmagenta: '8b008b',
  darkolivegreen: '556b2f',
  darkorange: 'ff8c00',
  darkorchid: '9932cc',
  darkred: '8b0000',
  darksalmon: 'e9967a',
  darkseagreen: '8fbc8f',
  darkslateblue: '483d8b',
  darkslategray: '2f4f4f',
  darkslategrey: '2f4f4f',
  darkturquoise: '00ced1',
  darkviolet: '9400d3',
  deeppink: 'ff1493',
  deepskyblue: '00bfff',
  dimgray: '696969',
  dimgrey: '696969',
  dodgerblue: '1e90ff',
  firebrick: 'b22222',
  floralwhite: 'fffaf0',
  forestgreen: '228b22',
  fuchsia: 'ff00ff',
  gainsboro: 'dcdcdc',
  ghostwhite: 'f8f8ff',
  gold: 'ffd700',
  goldenrod: 'daa520',
  gray: '808080',
  green: '008000',
  greenyellow: 'adff2f',
  grey: '808080',
  honeydew: 'f0fff0',
  hotpink: 'ff69b4',
  indianred: 'cd5c5c',
  indigo: '4b0082',
  ivory: 'fffff0',
  khaki: 'f0e68c',
  lavender: 'e6e6fa',
  lavenderblush: 'fff0f5',
  lawngreen: '7cfc00',
  lemonchiffon: 'fffacd',
  lightblue: 'add8e6',
  lightcoral: 'f08080',
  lightcyan: 'e0ffff',
  lightgoldenrodyellow: 'fafad2',
  lightgray: 'd3d3d3',
  lightgreen: '90ee90',
  lightgrey: 'd3d3d3',
  lightpink: 'ffb6c1',
  lightsalmon: 'ffa07a',
  lightseagreen: '20b2aa',
  lightskyblue: '87cefa',
  lightslategray: '789',
  lightslategrey: '789',
  lightsteelblue: 'b0c4de',
  lightyellow: 'ffffe0',
  lime: '0f0',
  limegreen: '32cd32',
  linen: 'faf0e6',
  magenta: 'f0f',
  maroon: '800000',
  mediumaquamarine: '66cdaa',
  mediumblue: '0000cd',
  mediumorchid: 'ba55d3',
  mediumpurple: '9370db',
  mediumseagreen: '3cb371',
  mediumslateblue: '7b68ee',
  mediumspringgreen: '00fa9a',
  mediumturquoise: '48d1cc',
  mediumvioletred: 'c71585',
  midnightblue: '191970',
  mintcream: 'f5fffa',
  mistyrose: 'ffe4e1',
  moccasin: 'ffe4b5',
  navajowhite: 'ffdead',
  navy: '000080',
  oldlace: 'fdf5e6',
  olive: '808000',
  olivedrab: '6b8e23',
  orange: 'ffa500',
  orangered: 'ff4500',
  orchid: 'da70d6',
  palegoldenrod: 'eee8aa',
  palegreen: '98fb98',
  paleturquoise: 'afeeee',
  palevioletred: 'db7093',
  papayawhip: 'ffefd5',
  peachpuff: 'ffdab9',
  peru: 'cd853f',
  pink: 'ffc0cb',
  plum: 'dda0dd',
  powderblue: 'b0e0e6',
  purple: '800080',
  rebeccapurple: '639',
  red: 'f00',
  rosybrown: 'bc8f8f',
  royalblue: '4169e1',
  saddlebrown: '8b4513',
  salmon: 'fa8072',
  sandybrown: 'f4a460',
  seagreen: '2e8b57',
  seashell: 'fff5ee',
  sienna: 'a0522d',
  silver: 'c0c0c0',
  skyblue: '87ceeb',
  slateblue: '6a5acd',
  slategray: '708090',
  slategrey: '708090',
  snow: 'fffafa',
  springgreen: '00ff7f',
  steelblue: '4682b4',
  tan: 'd2b48c',
  teal: '008080',
  thistle: 'd8bfd8',
  tomato: 'ff6347',
  turquoise: '40e0d0',
  violet: 'ee82ee',
  wheat: 'f5deb3',
  white: 'fff',
  whitesmoke: 'f5f5f5',
  yellow: 'ff0',
  yellowgreen: '9acd32'

  /**
   * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
   * @private
   */
};function nameToHex(color) {
  if (typeof color !== 'string') return color;
  var normalizedColorName = color.toLowerCase();
  return namedColorMap[normalizedColorName] ? '#' + namedColorMap[normalizedColorName] : color;
}

//      
var hexRegex = /^#[a-fA-F0-9]{6}$/;
var reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var rgbRegex = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;
var rgbaRegex = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/;
var hslRegex = /^hsl\(\s*(\d{1,3})\s*,\s*(\d{1,3})%\s*,\s*(\d{1,3})%\s*\)$/;
var hslaRegex = /^hsla\(\s*(\d{1,3})\s*,\s*(\d{1,3})%\s*,\s*(\d{1,3})%\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/;

/**
 * Returns an RgbColor or RgbaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a RgbColor or RgbaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = 'rgb(255, 0, 0)';
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = 'hsla(210, 10%, 40%, 0.75)';
 */
function parseToRgb(color) {
  if (typeof color !== 'string') {
    throw new Error('Passed an incorrect argument to a color function, please pass a string representation of a color.');
  }
  var normalizedColor = nameToHex(color);
  if (normalizedColor.match(hexRegex)) {
    return {
      red: parseInt('' + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt('' + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt('' + normalizedColor[5] + normalizedColor[6], 16)
    };
  }
  if (normalizedColor.match(reducedHexRegex)) {
    return {
      red: parseInt('' + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt('' + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt('' + normalizedColor[3] + normalizedColor[3], 16)
    };
  }
  var rgbMatched = rgbRegex.exec(normalizedColor);
  if (rgbMatched) {
    return {
      red: parseInt('' + rgbMatched[1], 10),
      green: parseInt('' + rgbMatched[2], 10),
      blue: parseInt('' + rgbMatched[3], 10)
    };
  }
  var rgbaMatched = rgbaRegex.exec(normalizedColor);
  if (rgbaMatched) {
    return {
      red: parseInt('' + rgbaMatched[1], 10),
      green: parseInt('' + rgbaMatched[2], 10),
      blue: parseInt('' + rgbaMatched[3], 10),
      alpha: parseFloat('' + rgbaMatched[4])
    };
  }
  var hslMatched = hslRegex.exec(normalizedColor);
  if (hslMatched) {
    var hue = parseInt('' + hslMatched[1], 10);
    var saturation = parseInt('' + hslMatched[2], 10) / 100;
    var lightness = parseInt('' + hslMatched[3], 10) / 100;
    var rgbColorString = 'rgb(' + hslToRgb(hue, saturation, lightness) + ')';
    var hslRgbMatched = rgbRegex.exec(rgbColorString);
    return {
      red: parseInt('' + hslRgbMatched[1], 10),
      green: parseInt('' + hslRgbMatched[2], 10),
      blue: parseInt('' + hslRgbMatched[3], 10)
    };
  }
  var hslaMatched = hslaRegex.exec(normalizedColor);
  if (hslaMatched) {
    var _hue = parseInt('' + hslaMatched[1], 10);
    var _saturation = parseInt('' + hslaMatched[2], 10) / 100;
    var _lightness = parseInt('' + hslaMatched[3], 10) / 100;
    var _rgbColorString = 'rgb(' + hslToRgb(_hue, _saturation, _lightness) + ')';
    var _hslRgbMatched = rgbRegex.exec(_rgbColorString);
    return {
      red: parseInt('' + _hslRgbMatched[1], 10),
      green: parseInt('' + _hslRgbMatched[2], 10),
      blue: parseInt('' + _hslRgbMatched[3], 10),
      alpha: parseFloat('' + hslaMatched[4])
    };
  }
  throw new Error("Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.");
}

//      


function rgbToHsl(color) {
  // make sure rgb are contained in a set of [0, 255]
  var red = color.red / 255;
  var green = color.green / 255;
  var blue = color.blue / 255;

  var max = Math.max(red, green, blue);
  var min = Math.min(red, green, blue);
  var lightness = (max + min) / 2;

  if (max === min) {
    // achromatic
    if (color.alpha !== undefined) {
      return {
        hue: 0,
        saturation: 0,
        lightness: lightness,
        alpha: color.alpha
      };
    } else {
      return { hue: 0, saturation: 0, lightness: lightness };
    }
  }

  var hue = void 0;
  var delta = max - min;
  var saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);
  switch (max) {
    case red:
      hue = (green - blue) / delta + (green < blue ? 6 : 0);
      break;
    case green:
      hue = (blue - red) / delta + 2;
      break;
    default:
      // blue case
      hue = (red - green) / delta + 4;
      break;
  }

  hue *= 60;
  if (color.alpha !== undefined) {
    return {
      hue: hue,
      saturation: saturation,
      lightness: lightness,
      alpha: color.alpha
    };
  }
  return { hue: hue, saturation: saturation, lightness: lightness };
}

//      

/**
 * Returns an HslColor or HslaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a HslColor or HslaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = 'rgb(255, 0, 0)';
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = 'hsla(210, 10%, 40%, 0.75)';
 */
function parseToHsl(color) {
  // Note: At a later stage we can optimize this function as right now a hsl
  // color would be parsed converted to rgb values and converted back to hsl.
  return rgbToHsl(parseToRgb(color));
}

//      

/**
 * Reduces hex values if possible e.g. #ff8866 to #f86
 * @private
 */
var reduceHexValue = function reduceHexValue(value) {
  if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) {
    return "#" + value[1] + value[3] + value[5];
  }
  return value;
};

//      
function numberToHex(value) {
  var hex = value.toString(16);
  return hex.length === 1 ? "0" + hex : hex;
}

//      

/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgb(255, 205, 100),
 *   background: rgb({ red: 255, green: 205, blue: 100 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgb(255, 205, 100)};
 *   background: ${rgb({ red: 255, green: 205, blue: 100 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffcd64";
 *   background: "#ffcd64";
 * }
 */
function rgb(value, green, blue) {
  if (typeof value === 'number' && typeof green === 'number' && typeof blue === 'number') {
    return reduceHexValue('#' + numberToHex(value) + numberToHex(green) + numberToHex(blue));
  } else if (typeof value === 'object' && green === undefined && blue === undefined) {
    return reduceHexValue('#' + numberToHex(value.red) + numberToHex(value.green) + numberToHex(value.blue));
  }

  throw new Error('Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).');
}

//      

/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * Can also be used to fade a color by passing a hex value or named CSS color along with an alpha value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgba(255, 205, 100, 0.7),
 *   background: rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 }),
 *   background: rgba(255, 205, 100, 1),
 *   background: rgba('#ffffff', 0.4),
 *   background: rgba('black', 0.7),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgba(255, 205, 100, 0.7)};
 *   background: ${rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 })};
 *   background: ${rgba(255, 205, 100, 1)};
 *   background: ${rgba('#ffffff', 0.4)};
 *   background: ${rgba('black', 0.7)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,205,100,0.7)";
 *   background: "rgba(255,205,100,0.7)";
 *   background: "#ffcd64";
 *   background: "rgba(255,255,255,0.4)";
 *   background: "rgba(0,0,0,0.7)";
 * }
 */
function rgba(firstValue, secondValue, thirdValue, fourthValue) {
  if (typeof firstValue === 'string' && typeof secondValue === 'number') {
    var rgbValue = parseToRgb(firstValue);
    return 'rgba(' + rgbValue.red + ',' + rgbValue.green + ',' + rgbValue.blue + ',' + secondValue + ')';
  } else if (typeof firstValue === 'number' && typeof secondValue === 'number' && typeof thirdValue === 'number' && typeof fourthValue === 'number') {
    return fourthValue >= 1 ? rgb(firstValue, secondValue, thirdValue) : 'rgba(' + firstValue + ',' + secondValue + ',' + thirdValue + ',' + fourthValue + ')';
  } else if (typeof firstValue === 'object' && secondValue === undefined && thirdValue === undefined && fourthValue === undefined) {
    return firstValue.alpha >= 1 ? rgb(firstValue.red, firstValue.green, firstValue.blue) : 'rgba(' + firstValue.red + ',' + firstValue.green + ',' + firstValue.blue + ',' + firstValue.alpha + ')';
  }

  throw new Error('Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).');
}

//      
function colorToHex(color) {
  return numberToHex(Math.round(color * 255));
}

function convertToHex(red, green, blue) {
  return reduceHexValue('#' + colorToHex(red) + colorToHex(green) + colorToHex(blue));
}

function hslToHex(hue, saturation, lightness) {
  return hslToRgb(hue, saturation, lightness, convertToHex);
}

//      

/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsl(359, 0.75, 0.4),
 *   background: hsl({ hue: 360, saturation: 0.75, lightness: 0.4 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsl(359, 0.75, 0.4)};
 *   background: ${hsl({ hue: 360, saturation: 0.75, lightness: 0.4 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#b3191c";
 *   background: "#b3191c";
 * }
 */
function hsl(value, saturation, lightness) {
  if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number') {
    return hslToHex(value, saturation, lightness);
  } else if (typeof value === 'object' && saturation === undefined && lightness === undefined) {
    return hslToHex(value.hue, value.saturation, value.lightness);
  }

  throw new Error('Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).');
}

//      

/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsla(359, 0.75, 0.4, 0.7),
 *   background: hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 }),
 *   background: hsla(359, 0.75, 0.4, 1),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsla(359, 0.75, 0.4, 0.7)};
 *   background: ${hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 })};
 *   background: ${hsla(359, 0.75, 0.4, 1)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(179,25,28,0.7)";
 *   background: "rgba(179,25,28,0.7)";
 *   background: "#b3191c";
 * }
 */
function hsla(value, saturation, lightness, alpha) {
  if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number' && typeof alpha === 'number') {
    return alpha >= 1 ? hslToHex(value, saturation, lightness) : 'rgba(' + hslToRgb(value, saturation, lightness) + ',' + alpha + ')';
  } else if (typeof value === 'object' && saturation === undefined && lightness === undefined && alpha === undefined) {
    return value.alpha >= 1 ? hslToHex(value.hue, value.saturation, value.lightness) : 'rgba(' + hslToRgb(value.hue, value.saturation, value.lightness) + ',' + value.alpha + ')';
  }

  throw new Error('Passed invalid arguments to hsla, please pass multiple numbers e.g. hsl(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).');
}

//      
var isRgb = function isRgb(color) {
  return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};

var isRgba = function isRgba(color) {
  return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && typeof color.alpha === 'number';
};

var isHsl = function isHsl(color) {
  return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};

var isHsla = function isHsla(color) {
  return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && typeof color.alpha === 'number';
};

var errMsg = 'Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.';

/**
 * Converts a RgbColor, RgbaColor, HslColor or HslaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `rgb`, `rgba`, `hsl` or `hsla`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: toColorString({ red: 255, green: 205, blue: 100 }),
 *   background: toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
 *   background: toColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
 *   background: toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${toColorString({ red: 255, green: 205, blue: 100 })};
 *   background: ${toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
 *   background: ${toColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
 *   background: ${toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#ffcd64";
 *   background: "rgba(255,205,100,0.72)";
 *   background: "#00f";
 *   background: "rgba(179,25,25,0.72)";
 * }
 */

function toColorString(color) {
  if (typeof color !== 'object') throw new Error(errMsg);
  if (isRgba(color)) return rgba(color);
  if (isRgb(color)) return rgb(color);
  if (isHsla(color)) return hsla(color);
  if (isHsl(color)) return hsl(color);

  throw new Error(errMsg);
}

//      

// Type definitions taken from https://github.com/gcanti/flow-static-land/blob/master/src/Fun.js


// eslint-disable-next-line no-unused-vars


// eslint-disable-next-line no-unused-vars

// eslint-disable-next-line no-redeclare


function curried(f, length, acc) {
  return function fn() {
    // eslint-disable-next-line prefer-rest-params
    var combined = acc.concat(Array.prototype.slice.call(arguments));
    return combined.length >= length ? f.apply(this, combined) : curried(f, length, combined);
  };
}

// eslint-disable-next-line no-redeclare
function curry(f) {
  // eslint-disable-line no-redeclare
  return curried(f, f.length, []);
}

//      

/**
 * Changes the hue of the color. Hue is a number between 0 to 360. The first
 * argument for adjustHue is the amount of degrees the color is rotated along
 * the color wheel.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: adjustHue(180, '#448'),
 *   background: adjustHue(180, 'rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${adjustHue(180, '#448')};
 *   background: ${adjustHue(180, 'rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#888844";
 *   background: "rgba(136,136,68,0.7)";
 * }
 */
function adjustHue(degree, color) {
  var hslColor = parseToHsl(color);
  return toColorString(_extends({}, hslColor, {
    hue: (hslColor.hue + degree) % 360
  }));
}

var curriedAdjustHue = /*#__PURE__*/curry(adjustHue);

//      

/**
 * Returns the complement of the provided color. This is identical to adjustHue(180, <color>).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: complement('#448'),
 *   background: complement('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${complement('#448')};
 *   background: ${complement('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#884";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */
function complement(color) {
  var hslColor = parseToHsl(color);
  return toColorString(_extends({}, hslColor, {
    hue: (hslColor.hue + 180) % 360
  }));
}

//      

function guard(lowerBoundary, upperBoundary, value) {
  return Math.max(lowerBoundary, Math.min(upperBoundary, value));
}

//      

/**
 * Returns a string value for the darkened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: darken(0.2, '#FFCD64'),
 *   background: darken(0.2, 'rgba(255,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${darken(0.2, '#FFCD64')};
 *   background: ${darken(0.2, 'rgba(255,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffbd31";
 *   background: "rgba(255,189,49,0.7)";
 * }
 */
function darken(amount, color) {
  var hslColor = parseToHsl(color);
  return toColorString(_extends({}, hslColor, {
    lightness: guard(0, 1, hslColor.lightness - amount)
  }));
}

var curriedDarken = /*#__PURE__*/curry(darken);

//      

/**
 * Decreases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the desaturate function is the amount by how much the color
 * intensity should be decreased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: desaturate(0.2, '#CCCD64'),
 *   background: desaturate(0.2, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${desaturate(0.2, '#CCCD64')};
 *   background: ${desaturate(0.2, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#b8b979";
 *   background: "rgba(184,185,121,0.7)";
 * }
 */
function desaturate(amount, color) {
  var hslColor = parseToHsl(color);
  return toColorString(_extends({}, hslColor, {
    saturation: guard(0, 1, hslColor.saturation - amount)
  }));
}

var curriedDesaturate = /*#__PURE__*/curry(desaturate);

//      
/**
 * Returns a number (float) representing the luminance of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff',
 *   background: getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)',
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff'};
 *   background: ${getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)'};
 *
 * // CSS in JS Output
 *
 * div {
 *   background: "#CCCD64";
 *   background: "rgba(58, 133, 255, 1)";
 * }
 */
function getLuminance(color) {
  var rgbColor = parseToRgb(color);

  var _Object$keys$map = Object.keys(rgbColor).map(function (key) {
    var channel = rgbColor[key] / 255;
    return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
  }),
      r = _Object$keys$map[0],
      g = _Object$keys$map[1],
      b = _Object$keys$map[2];

  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

//      

/**
 * Converts the color to a grayscale, by reducing its saturation to 0.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: grayscale('#CCCD64'),
 *   background: grayscale('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${grayscale('#CCCD64')};
 *   background: ${grayscale('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#999";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */
function grayscale(color) {
  return toColorString(_extends({}, parseToHsl(color), {
    saturation: 0
  }));
}

//      

/**
 * Inverts the red, green and blue values of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: invert('#CCCD64'),
 *   background: invert('rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${invert('#CCCD64')};
 *   background: ${invert('rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#33329b";
 *   background: "rgba(154,155,50,0.7)";
 * }
 */
function invert(color) {
  // parse color string to rgb
  var value = parseToRgb(color);
  return toColorString(_extends({}, value, {
    red: 255 - value.red,
    green: 255 - value.green,
    blue: 255 - value.blue
  }));
}

//      

/**
 * Returns a string value for the lightened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: lighten(0.2, '#CCCD64'),
 *   background: lighten(0.2, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${lighten(0.2, '#FFCD64')};
 *   background: ${lighten(0.2, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e5e6b1";
 *   background: "rgba(229,230,177,0.7)";
 * }
 */
function lighten(amount, color) {
  var hslColor = parseToHsl(color);
  return toColorString(_extends({}, hslColor, {
    lightness: guard(0, 1, hslColor.lightness + amount)
  }));
}

var curriedLighten = /*#__PURE__*/curry(lighten);

//      

/**
 * Mixes two colors together by calculating the average of each of the RGB components.
 *
 * By default the weight is 0.5 meaning that half of the first color and half the second
 * color should be used. Optionally the weight can be modified by providing a number
 * as the first argument. 0.25 means that a quarter of the first color and three quarters
 * of the second color should be used.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: mix(0.5, '#f00', '#00f')
 *   background: mix(0.25, '#f00', '#00f')
 *   background: mix(0.5, 'rgba(255, 0, 0, 0.5)', '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${mix(0.5, '#f00', '#00f')};
 *   background: ${mix(0.25, '#f00', '#00f')};
 *   background: ${mix(0.5, 'rgba(255, 0, 0, 0.5)', '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#7f007f";
 *   background: "#3f00bf";
 *   background: "rgba(63, 0, 191, 0.75)";
 * }
 */
function mix() {
  var weight = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.5;
  var color = arguments[1];
  var otherColor = arguments[2];

  var parsedColor1 = parseToRgb(color);
  var color1 = _extends({}, parsedColor1, {
    alpha: typeof parsedColor1.alpha === 'number' ? parsedColor1.alpha : 1
  });

  var parsedColor2 = parseToRgb(otherColor);
  var color2 = _extends({}, parsedColor2, {
    alpha: typeof parsedColor2.alpha === 'number' ? parsedColor2.alpha : 1

    // The formular is copied from the original Sass implementation:
    // http://sass-lang.com/documentation/Sass/Script/Functions.html#mix-instance_method
  });var alphaDelta = color1.alpha - color2.alpha;
  var x = weight * 2 - 1;
  var y = x * alphaDelta === -1 ? x : x + alphaDelta;
  var z = 1 + x * alphaDelta;
  var weight1 = (y / z + 1) / 2.0;
  var weight2 = 1 - weight1;

  var mixedColor = {
    red: Math.floor(color1.red * weight1 + color2.red * weight2),
    green: Math.floor(color1.green * weight1 + color2.green * weight2),
    blue: Math.floor(color1.blue * weight1 + color2.blue * weight2),
    alpha: color1.alpha + (color2.alpha - color1.alpha) * (weight / 1.0)
  };

  return rgba(mixedColor);
}

var curriedMix = /*#__PURE__*/curry(mix);

//      
/**
 * Increases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: opacify(0.1, 'rgba(255, 255, 255, 0.9)');
 *   background: opacify(0.2, 'hsla(0, 0%, 100%, 0.5)'),
 *   background: opacify(0.5, 'rgba(255, 0, 0, 0.2)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${opacify(0.1, 'rgba(255, 255, 255, 0.9)')};
 *   background: ${opacify(0.2, 'hsla(0, 0%, 100%, 0.5)')},
 *   background: ${opacify(0.5, 'rgba(255, 0, 0, 0.2)')},
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#fff";
 *   background: "rgba(255,255,255,0.7)";
 *   background: "rgba(255,0,0,0.7)";
 * }
 */
function opacify(amount, color) {
  var parsedColor = parseToRgb(color);
  var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
  var colorWithAlpha = _extends({}, parsedColor, {
    alpha: guard(0, 1, (alpha * 100 + amount * 100) / 100)
  });
  return rgba(colorWithAlpha);
}

var curriedOpacify = /*#__PURE__*/curry(opacify);

//      
/**
 * Selects black or white for best contrast depending on the luminosity of the given color.
 * Follows W3C specs for readability at https://www.w3.org/TR/WCAG20-TECHS/G18.html
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   color: readableColor('#000'),
 *   color: readableColor('papayawhip'),
 *   color: readableColor('rgb(255,0,0)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   color: ${readableColor('#000')};
 *   color: ${readableColor('papayawhip')};
 *   color: ${readableColor('rgb(255,0,0)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   color: "#fff";
 *   color: "#fff";
 *   color: "#000";
 * }
 */

function readableColor(color) {
  return getLuminance(color) > 0.179 ? '#000' : '#fff';
}

var curriedReadableColor = /*#__PURE__*/curry(readableColor);

//      

/**
 * Increases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the saturate function is the amount by how much the color
 * intensity should be increased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: saturate(0.2, '#CCCD64'),
 *   background: saturate(0.2, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${saturate(0.2, '#FFCD64')};
 *   background: ${saturate(0.2, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e0e250";
 *   background: "rgba(224,226,80,0.7)";
 * }
 */
function saturate(amount, color) {
  var hslColor = parseToHsl(color);
  return toColorString(_extends({}, hslColor, {
    saturation: guard(0, 1, hslColor.saturation + amount)
  }));
}

var curriedSaturate = /*#__PURE__*/curry(saturate);

//      

/**
 * Sets the hue of a color to the provided value. The hue range can be
 * from 0 and 359.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setHue(42, '#CCCD64'),
 *   background: setHue(244, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setHue(42, '#CCCD64')};
 *   background: ${setHue(244, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#cdae64";
 *   background: "rgba(107,100,205,0.7)";
 * }
 */
function setHue(hue, color) {
  return toColorString(_extends({}, parseToHsl(color), {
    hue: hue
  }));
}

var curriedSetHue = /*#__PURE__*/curry(setHue);

//      

/**
 * Sets the lightness of a color to the provided value. The lightness range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setLightness(0.2, '#CCCD64'),
 *   background: setLightness(0.75, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setLightness(0.2, '#CCCD64')};
 *   background: ${setLightness(0.75, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#4d4d19";
 *   background: "rgba(223,224,159,0.7)";
 * }
 */
function setLightness(lightness, color) {
  return toColorString(_extends({}, parseToHsl(color), {
    lightness: lightness
  }));
}

var curriedSetLightness = /*#__PURE__*/curry(setLightness);

//      

/**
 * Sets the saturation of a color to the provided value. The lightness range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setSaturation(0.2, '#CCCD64'),
 *   background: setSaturation(0.75, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setSaturation(0.2, '#CCCD64')};
 *   background: ${setSaturation(0.75, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#adad84";
 *   background: "rgba(228,229,76,0.7)";
 * }
 */
function setSaturation(saturation, color) {
  return toColorString(_extends({}, parseToHsl(color), {
    saturation: saturation
  }));
}

var curriedSetSaturation = /*#__PURE__*/curry(setSaturation);

//      

/**
 * Shades a color by mixing it with black. `shade` can produce
 * hue shifts, where as `darken` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: shade(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${shade(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#00003f";
 * }
 */

function shade(percentage, color) {
  if (typeof percentage !== 'number' || percentage > 1 || percentage < -1) {
    throw new Error('Passed an incorrect argument to shade, please pass a percentage less than or equal to 1 and larger than or equal to -1.');
  }
  if (typeof color !== 'string') {
    throw new Error('Passed an incorrect argument to a color function, please pass a string representation of a color.');
  }
  return curriedMix(percentage, color, 'rgb(0, 0, 0)');
}

var curriedShade = /*#__PURE__*/curry(shade);

//      

/**
 * Tints a color by mixing it with white. `tint` can produce
 * hue shifts, where as `lighten` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: tint(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${tint(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#bfbfff";
 * }
 */

function tint(percentage, color) {
  if (typeof percentage !== 'number' || percentage > 1 || percentage < -1) {
    throw new Error('Passed an incorrect argument to tint, please pass a percentage less than or equal to 1 and larger than or equal to -1.');
  }
  if (typeof color !== 'string') {
    throw new Error('Passed an incorrect argument to a color function, please pass a string representation of a color.');
  }
  return curriedMix(percentage, color, 'rgb(255, 255, 255)');
}

var curriedTint = /*#__PURE__*/curry(tint);

//      
/**
 * Decreases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: transparentize(0.1, '#fff');
 *   background: transparentize(0.2, 'hsl(0, 0%, 100%)'),
 *   background: transparentize(0.5, 'rgba(255, 0, 0, 0.8)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${transparentize(0.1, '#fff')};
 *   background: ${transparentize(0.2, 'hsl(0, 0%, 100%)')},
 *   background: ${transparentize(0.5, 'rgba(255, 0, 0, 0.8)')},
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,255,255,0.9)";
 *   background: "rgba(255,255,255,0.8)";
 *   background: "rgba(255,0,0,0.3)";
 * }
 */
function transparentize(amount, color) {
  var parsedColor = parseToRgb(color);
  var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
  var colorWithAlpha = _extends({}, parsedColor, {
    alpha: guard(0, 1, (alpha * 100 - amount * 100) / 100)
  });
  return rgba(colorWithAlpha);
}

var curriedTransparentize = /*#__PURE__*/curry(transparentize);

//      

/** */

/**
 * Shorthand for easily setting the animation property. Allows either multiple arrays with animations
 * or a single animation spread over the arguments.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out, colorchange 2s'
 * }
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation('rotate', '1s', 'ease-in-out')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation('rotate', '1s', 'ease-in-out')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out'
 * }
 */
function animation() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  // Allow single or multiple animations passed
  var multiMode = Array.isArray(args[0]);
  if (!multiMode && args.length > 8) {
    throw new Error('The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation');
  }
  var code = args.map(function (arg) {
    if (multiMode && !Array.isArray(arg) || !multiMode && Array.isArray(arg)) {
      throw new Error("To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')");
    }
    if (Array.isArray(arg) && arg.length > 8) {
      throw new Error('The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation');
    }

    return Array.isArray(arg) ? arg.join(' ') : arg;
  }).join(', ');

  return {
    animation: code
  };
}

//      

/**
 * Shorthand that accepts any number of backgroundImage values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'backgroundImage': 'url("/image/background.jpg"), linear-gradient(red, green)'
 * }
 */

function backgroundImages() {
  for (var _len = arguments.length, properties = Array(_len), _key = 0; _key < _len; _key++) {
    properties[_key] = arguments[_key];
  }

  return {
    backgroundImage: properties.join(', ')
  };
}

//      

/**
 * Shorthand that accepts any number of background values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'background': 'url("/image/background.jpg"), linear-gradient(red, green), center no-repeat'
 * }
 */
function backgrounds() {
  for (var _len = arguments.length, properties = Array(_len), _key = 0; _key < _len; _key++) {
    properties[_key] = arguments[_key];
  }

  return {
    background: properties.join(', ')
  };
}

//      
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderColor('red', 'green', 'blue', 'yellow')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderColor('red', 'green', 'blue', 'yellow')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopColor': 'red',
 *   'borderRightColor': 'green',
 *   'borderBottomColor': 'blue',
 *   'borderLeftColor': 'yellow'
 * }
 */

function borderColor() {
  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(undefined, ['borderColor'].concat(values));
}

//      
/**
 * Shorthand that accepts a value for side and a value for radius and applies the radius value to both corners of the side.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderRadius('top', '5px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderRadius('top', '5px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopRightRadius': '5px',
 *   'borderTopLeftRadius': '5px',
 * }
 */

function borderRadius(side, radius) {
  var uppercaseSide = capitalizeString(side);
  if (!radius && radius !== 0) {
    throw new Error('borderRadius expects a radius value as a string or number as the second argument.');
  }
  if (uppercaseSide === 'Top' || uppercaseSide === 'Bottom') {
    var _ref;

    return _ref = {}, _ref['border' + uppercaseSide + 'RightRadius'] = radius, _ref['border' + uppercaseSide + 'LeftRadius'] = radius, _ref;
  }

  if (uppercaseSide === 'Left' || uppercaseSide === 'Right') {
    var _ref2;

    return _ref2 = {}, _ref2['borderTop' + uppercaseSide + 'Radius'] = radius, _ref2['borderBottom' + uppercaseSide + 'Radius'] = radius, _ref2;
  }

  throw new Error('borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.');
}

//      
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderStyle('solid', 'dashed', 'dotted', 'double')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderStyle('solid', 'dashed', 'dotted', 'double')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopStyle': 'solid',
 *   'borderRightStyle': 'dashed',
 *   'borderBottomStyle': 'dotted',
 *   'borderLeftStyle': 'double'
 * }
 */

function borderStyle() {
  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(undefined, ['borderStyle'].concat(values));
}

//      
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderWidth('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderWidth('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopWidth': '12px',
 *   'borderRightWidth': '24px',
 *   'borderBottomWidth': '36px',
 *   'borderLeftWidth': '48px'
 * }
 */
function borderWidth() {
  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(undefined, ['borderWidth'].concat(values));
}

//      


function generateSelectors(template, state) {
  var stateSuffix = state ? ':' + state : '';
  return template(stateSuffix);
}

/**
 * Function helper that adds an array of states to a template of selectors. Used in textInputs and buttons.
 * @private
 */
function statefulSelectors(states, template, stateMap) {
  if (!template) throw new Error('You must provide a template to this method.');
  if (states.length === 0) return generateSelectors(template, null);
  var selectors = [];
  for (var i = 0; i < states.length; i += 1) {
    if (stateMap && stateMap.indexOf(states[i]) < 0) {
      throw new Error('You passed an unsupported selector state to this method.');
    }
    selectors.push(generateSelectors(template, states[i]));
  }
  selectors = selectors.join(',');
  return selectors;
}

//      
var stateMap = [undefined, null, 'active', 'focus', 'hover'];

function template(state) {
  return 'button' + state + ',\n  input[type="button"]' + state + ',\n  input[type="reset"]' + state + ',\n  input[type="submit"]' + state;
}

/**
 * Populates selectors that target all buttons. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [buttons('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${buttons('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'button:active,
 *  'input[type="button"]:active,
 *  'input[type=\"reset\"]:active,
 *  'input[type=\"submit\"]:active: {
 *   'border': 'none'
 * }
 */

function buttons() {
  for (var _len = arguments.length, states = Array(_len), _key = 0; _key < _len; _key++) {
    states[_key] = arguments[_key];
  }

  return statefulSelectors(states, template, stateMap);
}

//      
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...margin('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${margin('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'marginTop': '12px',
 *   'marginRight': '24px',
 *   'marginBottom': '36px',
 *   'marginLeft': '48px'
 * }
 */

function margin() {
  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(undefined, ['margin'].concat(values));
}

//      
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...padding('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${padding('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */

function padding() {
  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(undefined, ['padding'].concat(values));
}

//      
var positionMap$1 = ['absolute', 'fixed', 'relative', 'static', 'sticky'];

/**
 * Shorthand accepts up to five values, including null to skip a value, and maps them to their respective directions. The first value can optionally be a position keyword.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...position('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 *
 * // Styles as object usage
 * const styles = {
 *   ...position('absolute', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('absolute', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'position': 'absolute',
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 */

function position(positionKeyword) {
  for (var _len = arguments.length, values = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  if (positionMap$1.indexOf(positionKeyword) >= 0) {
    return _extends({
      position: positionKeyword
    }, directionalProperty.apply(undefined, [''].concat(values)));
  } else {
    var firstValue = positionKeyword; // in this case position is actually the first value
    return directionalProperty.apply(undefined, ['', firstValue].concat(values));
  }
}

//      

/**
 * Shorthand to set the height and width properties in a single statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...size('300px', '250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${size('300px', '250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'height': '300px',
 *   'width': '250px',
 * }
 */

function size(height) {
  var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : height;

  return {
    height: height,
    width: width
  };
}

//      
var stateMap$1 = [undefined, null, 'active', 'focus', 'hover'];

function template$1(state) {
  return 'input[type="color"]' + state + ',\n    input[type="date"]' + state + ',\n    input[type="datetime"]' + state + ',\n    input[type="datetime-local"]' + state + ',\n    input[type="email"]' + state + ',\n    input[type="month"]' + state + ',\n    input[type="number"]' + state + ',\n    input[type="password"]' + state + ',\n    input[type="search"]' + state + ',\n    input[type="tel"]' + state + ',\n    input[type="text"]' + state + ',\n    input[type="time"]' + state + ',\n    input[type="url"]' + state + ',\n    input[type="week"]' + state + ',\n    input:not([type])' + state + ',\n    textarea' + state;
}

/**
 * Populates selectors that target all text inputs. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [textInputs('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${textInputs('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'input[type="color"]:active,
 *  input[type="date"]:active,
 *  input[type="datetime"]:active,
 *  input[type="datetime-local"]:active,
 *  input[type="email"]:active,
 *  input[type="month"]:active,
 *  input[type="number"]:active,
 *  input[type="password"]:active,
 *  input[type="search"]:active,
 *  input[type="tel"]:active,
 *  input[type="text"]:active,
 *  input[type="time"]:active,
 *  input[type="url"]:active,
 *  input[type="week"]:active,
 *  input:not([type]):active,
 *  textarea:active': {
 *   'border': 'none'
 * }
 */

function textInputs() {
  for (var _len = arguments.length, states = Array(_len), _key = 0; _key < _len; _key++) {
    states[_key] = arguments[_key];
  }

  return statefulSelectors(states, template$1, stateMap$1);
}

//      

/**
 * Shorthand that accepts any number of transition values as parameters for creating a single transition statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'transition': 'opacity 1.0s ease-in 0s, width 2.0s ease-in 2s'
 * }
 */

function transitions() {
  for (var _len = arguments.length, properties = Array(_len), _key = 0; _key < _len; _key++) {
    properties[_key] = arguments[_key];
  }

  return {
    transition: properties.join(', ')
  };
}

//      
// Helpers
// Mixins
// Color
// Shorthands




/***/ }),

/***/ "../node_modules/decisiv-ui-utils/node_modules/styled-components/dist/styled-components.es.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "css", function() { return css; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "keyframes", function() { return keyframes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "injectGlobal", function() { return injectGlobal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ThemeProvider", function() { return ThemeProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withTheme", function() { return wrapWithTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ServerStyleSheet", function() { return ServerStyleSheet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StyleSheetManager", function() { return StyleSheetManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_plain_object__ = __webpack_require__("../node_modules/is-plain-object/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_plain_object___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_is_plain_object__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylis__ = __webpack_require__("../node_modules/decisiv-ui-utils/node_modules/stylis/stylis.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_stylis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("../node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__("../node_modules/decisiv-ui-utils/node_modules/hoist-non-react-statics/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);






/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate$2(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

var hyphenate_1 = hyphenate$2;

var hyphenate = hyphenate_1;

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

var hyphenateStyleName_1 = hyphenateStyleName;

//      
var objToCss = function objToCss(obj, prevKey) {
  var css = Object.keys(obj).filter(function (key) {
    var chunk = obj[key];
    return chunk !== undefined && chunk !== null && chunk !== false && chunk !== '';
  }).map(function (key) {
    if (__WEBPACK_IMPORTED_MODULE_0_is_plain_object___default()(obj[key])) return objToCss(obj[key], key);
    return hyphenateStyleName_1(key) + ': ' + obj[key] + ';';
  }).join(' ');
  return prevKey ? prevKey + ' {\n  ' + css + '\n}' : css;
};

var flatten = function flatten(chunks, executionContext) {
  return chunks.reduce(function (ruleSet, chunk) {
    /* Remove falsey values */
    if (chunk === undefined || chunk === null || chunk === false || chunk === '') {
      return ruleSet;
    }
    /* Flatten ruleSet */
    if (Array.isArray(chunk)) {
      return [].concat(ruleSet, flatten(chunk, executionContext));
    }

    /* Handle other components */
    if (chunk.hasOwnProperty('styledComponentId')) {
      // $FlowFixMe not sure how to make this pass
      return [].concat(ruleSet, ['.' + chunk.styledComponentId]);
    }

    /* Either execute or defer the function */
    if (typeof chunk === 'function') {
      return executionContext ? ruleSet.concat.apply(ruleSet, flatten([chunk(executionContext)], executionContext)) : ruleSet.concat(chunk);
    }

    /* Handle objects */
    return ruleSet.concat(
    // $FlowFixMe have to add %checks somehow to isPlainObject
    __WEBPACK_IMPORTED_MODULE_0_is_plain_object___default()(chunk) ? objToCss(chunk) : chunk.toString());
  }, []);
};

//      
var stylis = new __WEBPACK_IMPORTED_MODULE_1_stylis___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: true,
  compress: false,
  semicolon: true
});

var stringifyRules = function stringifyRules(rules, selector, prefix) {
  var flatCSS = rules.join('').replace(/^\s*\/\/.*$/gm, ''); // replace JS comments

  var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;

  return stylis(prefix || !selector ? '' : selector, cssStr);
};

//      
var chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
var charsLength = chars.length;

/* Some high number, usually 9-digit base-10. Map it to base-😎 */
var generateAlphabeticName = function generateAlphabeticName(code) {
  var name = '';
  var x = void 0;

  for (x = code; x > charsLength; x = Math.floor(x / charsLength)) {
    name = chars[x % charsLength] + name;
  }

  return chars[x % charsLength] + name;
};

//      


var interleave = (function (strings, interpolations) {
  return interpolations.reduce(function (array, interp, i) {
    return array.concat(interp, strings[i + 1]);
  }, [strings[0]]);
});

//      
var css = (function (strings) {
  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  return flatten(interleave(strings, interpolations));
});

//      
var SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s+(\S+)\s+\*\//gm;

var extractCompsFromCSS = (function (maybeCSS) {
  var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
  var existingComponents = [];
  css.replace(SC_COMPONENT_ID, function (match, componentId, matchIndex) {
    existingComponents.push({ componentId: componentId, matchIndex: matchIndex });
    return match;
  });
  return existingComponents.map(function (_ref, i) {
    var componentId = _ref.componentId,
        matchIndex = _ref.matchIndex;

    var nextComp = existingComponents[i + 1];
    var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
    return { componentId: componentId, cssFromDOM: cssFromDOM };
  });
});

//      
/* eslint-disable camelcase, no-undef */

var getNonce = (function () {
                                     return  true ? __webpack_require__.nc : null;
});

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();







var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

//      
/* eslint-disable no-underscore-dangle */
/*
 * Browser Style Sheet with Rehydration
 *
 * <style data-styled-components="x y z"
 *        data-styled-components-is-local="true">
 *   /· sc-component-id: a ·/
 *   .sc-a { ... }
 *   .x { ... }
 *   /· sc-component-id: b ·/
 *   .sc-b { ... }
 *   .y { ... }
 *   .z { ... }
 * </style>
 *
 * Note: replace · with * in the above snippet.
 * */
var COMPONENTS_PER_TAG = 40;

var BrowserTag = function () {
  function BrowserTag(el, isLocal) {
    var existingSource = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    classCallCheck(this, BrowserTag);

    this.el = el;
    this.isLocal = isLocal;
    this.ready = false;

    var extractedComps = extractCompsFromCSS(existingSource);

    this.size = extractedComps.length;
    this.components = extractedComps.reduce(function (acc, obj) {
      acc[obj.componentId] = obj; // eslint-disable-line no-param-reassign
      return acc;
    }, {});
  }

  BrowserTag.prototype.isFull = function isFull() {
    return this.size >= COMPONENTS_PER_TAG;
  };

  BrowserTag.prototype.addComponent = function addComponent(componentId) {
    if (!this.ready) this.replaceElement();
    if (false) {
      throw new Error('Trying to add Component \'' + componentId + '\' twice!');
    }

    var comp = { componentId: componentId, textNode: document.createTextNode('') };
    this.el.appendChild(comp.textNode);

    this.size += 1;
    this.components[componentId] = comp;
  };

  BrowserTag.prototype.inject = function inject(componentId, css, name) {
    if (!this.ready) this.replaceElement();
    var comp = this.components[componentId];

    if (false) {
      throw new Error('Must add a new component before you can inject css into it');
    }
    if (comp.textNode.data === '') {
      comp.textNode.appendData('\n/* sc-component-id: ' + componentId + ' */\n');
    }

    comp.textNode.appendData(css);
    if (name) {
      var existingNames = this.el.getAttribute(SC_ATTR);
      this.el.setAttribute(SC_ATTR, existingNames ? existingNames + ' ' + name : name);
    }

    var nonce = getNonce();

    if (nonce) {
      this.el.setAttribute('nonce', nonce);
    }
  };

  BrowserTag.prototype.toHTML = function toHTML() {
    return this.el.outerHTML;
  };

  BrowserTag.prototype.toReactElement = function toReactElement() {
    throw new Error("BrowserTag doesn't implement toReactElement!");
  };

  BrowserTag.prototype.clone = function clone() {
    throw new Error('BrowserTag cannot be cloned!');
  };

  /* Because we care about source order, before we can inject anything we need to
   * create a text node for each component and replace the existing CSS. */


  BrowserTag.prototype.replaceElement = function replaceElement() {
    var _this = this;

    this.ready = true;
    // We have nothing to inject. Use the current el.
    if (this.size === 0) return;

    // Build up our replacement style tag
    var newEl = this.el.cloneNode();
    newEl.appendChild(document.createTextNode('\n'));

    Object.keys(this.components).forEach(function (key) {
      var comp = _this.components[key];

      // eslint-disable-next-line no-param-reassign
      comp.textNode = document.createTextNode(comp.cssFromDOM);
      newEl.appendChild(comp.textNode);
    });

    if (!this.el.parentNode) {
      throw new Error("Trying to replace an element that wasn't mounted!");
    }

    // The ol' switcheroo
    this.el.parentNode.replaceChild(newEl, this.el);
    this.el = newEl;
  };

  return BrowserTag;
}();

/* Factory function to separate DOM operations from logical ones*/


var BrowserStyleSheet = {
  create: function create() {
    var tags = [];
    var names = {};

    /* Construct existing state from DOM */
    var nodes = document.querySelectorAll('[' + SC_ATTR + ']');
    var nodesLength = nodes.length;

    for (var i = 0; i < nodesLength; i += 1) {
      var el = nodes[i];

      tags.push(new BrowserTag(el, el.getAttribute(LOCAL_ATTR) === 'true', el.innerHTML));

      var attr = el.getAttribute(SC_ATTR);
      if (attr) {
        attr.trim().split(/\s+/).forEach(function (name) {
          names[name] = true;
        });
      }
    }

    /* Factory for making more tags */
    var tagConstructor = function tagConstructor(isLocal) {
      var el = document.createElement('style');
      el.type = 'text/css';
      el.setAttribute(SC_ATTR, '');
      el.setAttribute(LOCAL_ATTR, isLocal ? 'true' : 'false');
      if (!document.head) throw new Error('Missing document <head>');
      document.head.appendChild(el);
      return new BrowserTag(el, isLocal);
    };

    return new StyleSheet(tagConstructor, tags, names);
  }
};

//      
var SC_ATTR = 'data-styled-components';
var LOCAL_ATTR = 'data-styled-components-is-local';
var CONTEXT_KEY = '__styled-components-stylesheet__';

/* eslint-disable flowtype/object-type-delimiter */

/* eslint-enable flowtype/object-type-delimiter */

var instance = null;
// eslint-disable-next-line no-use-before-define
var clones = [];

var StyleSheet = function () {
  function StyleSheet(tagConstructor) {
    var tags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var names = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, StyleSheet);
    this.hashes = {};
    this.deferredInjections = {};
    this.stylesCacheable = typeof document !== 'undefined';

    this.tagConstructor = tagConstructor;
    this.tags = tags;
    this.names = names;
    this.constructComponentTagMap();
  }

  // helper for `ComponentStyle` to know when it cache static styles.
  // staticly styled-component can not safely cache styles on the server
  // without all `ComponentStyle` instances saving a reference to the
  // the styleSheet instance they last rendered with,
  // or listening to creation / reset events. otherwise you might create
  // a component with one stylesheet and render it another api response
  // with another, losing styles on from your server-side render.


  StyleSheet.prototype.constructComponentTagMap = function constructComponentTagMap() {
    var _this = this;

    this.componentTags = {};

    this.tags.forEach(function (tag) {
      Object.keys(tag.components).forEach(function (componentId) {
        _this.componentTags[componentId] = tag;
      });
    });
  };

  /* Best level of caching—get the name from the hash straight away. */


  StyleSheet.prototype.getName = function getName(hash) {
    return this.hashes[hash.toString()];
  };

  /* Second level of caching—if the name is already in the dom, don't
   * inject anything and record the hash for getName next time. */


  StyleSheet.prototype.alreadyInjected = function alreadyInjected(hash, name) {
    if (!this.names[name]) return false;

    this.hashes[hash.toString()] = name;
    return true;
  };

  /* Third type of caching—don't inject components' componentId twice. */


  StyleSheet.prototype.hasInjectedComponent = function hasInjectedComponent(componentId) {
    return !!this.componentTags[componentId];
  };

  StyleSheet.prototype.deferredInject = function deferredInject(componentId, isLocal, css) {
    if (this === instance) {
      clones.forEach(function (clone) {
        clone.deferredInject(componentId, isLocal, css);
      });
    }

    this.getOrCreateTag(componentId, isLocal);
    this.deferredInjections[componentId] = css;
  };

  StyleSheet.prototype.inject = function inject(componentId, isLocal, css, hash, name) {
    if (this === instance) {
      clones.forEach(function (clone) {
        clone.inject(componentId, isLocal, css);
      });
    }

    var tag = this.getOrCreateTag(componentId, isLocal);

    var deferredInjection = this.deferredInjections[componentId];
    if (deferredInjection) {
      tag.inject(componentId, deferredInjection);
      delete this.deferredInjections[componentId];
    }

    tag.inject(componentId, css, name);

    if (hash && name) {
      this.hashes[hash.toString()] = name;
    }
  };

  StyleSheet.prototype.toHTML = function toHTML() {
    return this.tags.map(function (tag) {
      return tag.toHTML();
    }).join('');
  };

  StyleSheet.prototype.toReactElements = function toReactElements() {
    return this.tags.map(function (tag, i) {
      return tag.toReactElement('sc-' + i);
    });
  };

  StyleSheet.prototype.getOrCreateTag = function getOrCreateTag(componentId, isLocal) {
    var existingTag = this.componentTags[componentId];
    if (existingTag) {
      return existingTag;
    }

    var lastTag = this.tags[this.tags.length - 1];
    var componentTag = !lastTag || lastTag.isFull() || lastTag.isLocal !== isLocal ? this.createNewTag(isLocal) : lastTag;
    this.componentTags[componentId] = componentTag;
    componentTag.addComponent(componentId);
    return componentTag;
  };

  StyleSheet.prototype.createNewTag = function createNewTag(isLocal) {
    var newTag = this.tagConstructor(isLocal);
    this.tags.push(newTag);
    return newTag;
  };

  StyleSheet.reset = function reset(isServer) {
    instance = StyleSheet.create(isServer);
  };

  /* We can make isServer totally implicit once Jest 20 drops and we
   * can change environment on a per-test basis. */


  StyleSheet.create = function create() {
    var isServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : typeof document === 'undefined';

    return (isServer ? ServerStyleSheet : BrowserStyleSheet).create();
  };

  StyleSheet.clone = function clone(oldSheet) {
    var newSheet = new StyleSheet(oldSheet.tagConstructor, oldSheet.tags.map(function (tag) {
      return tag.clone();
    }), _extends({}, oldSheet.names));

    newSheet.hashes = _extends({}, oldSheet.hashes);
    newSheet.deferredInjections = _extends({}, oldSheet.deferredInjections);
    clones.push(newSheet);

    return newSheet;
  };

  createClass(StyleSheet, null, [{
    key: 'instance',
    get: function get$$1() {
      return instance || (instance = StyleSheet.create());
    }
  }]);
  return StyleSheet;
}();

var _StyleSheetManager$ch;

//      
var StyleSheetManager = function (_Component) {
  inherits(StyleSheetManager, _Component);

  function StyleSheetManager() {
    classCallCheck(this, StyleSheetManager);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  StyleSheetManager.prototype.getChildContext = function getChildContext() {
    var _ref;

    return _ref = {}, _ref[CONTEXT_KEY] = this.props.sheet, _ref;
  };

  StyleSheetManager.prototype.render = function render() {
    /* eslint-disable react/prop-types */
    // Flow v0.43.1 will report an error accessing the `children` property,
    // but v0.47.0 will not. It is necessary to use a type cast instead of
    // a "fixme" comment to satisfy both Flow versions.
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(this.props.children);
  };

  return StyleSheetManager;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

StyleSheetManager.childContextTypes = (_StyleSheetManager$ch = {}, _StyleSheetManager$ch[CONTEXT_KEY] = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(StyleSheet), __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(ServerStyleSheet)]).isRequired, _StyleSheetManager$ch);

StyleSheetManager.propTypes = {
  sheet: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(StyleSheet), __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(ServerStyleSheet)]).isRequired
};

//      
/* eslint-disable no-underscore-dangle */
var ServerTag = function () {
  function ServerTag(isLocal) {
    classCallCheck(this, ServerTag);

    this.isLocal = isLocal;
    this.components = {};
    this.size = 0;
    this.names = [];
  }

  ServerTag.prototype.isFull = function isFull() {
    return false;
  };

  ServerTag.prototype.addComponent = function addComponent(componentId) {
    if (false) {
      throw new Error('Trying to add Component \'' + componentId + '\' twice!');
    }
    this.components[componentId] = { componentId: componentId, css: '' };
    this.size += 1;
  };

  ServerTag.prototype.concatenateCSS = function concatenateCSS() {
    var _this = this;

    return Object.keys(this.components).reduce(function (styles, k) {
      return styles + _this.components[k].css;
    }, '');
  };

  ServerTag.prototype.inject = function inject(componentId, css, name) {
    var comp = this.components[componentId];

    if (false) {
      throw new Error('Must add a new component before you can inject css into it');
    }
    if (comp.css === '') comp.css = '/* sc-component-id: ' + componentId + ' */\n';

    comp.css += css.replace(/\n*$/, '\n');

    if (name) this.names.push(name);
  };

  ServerTag.prototype.toHTML = function toHTML() {
    var attrs = ['type="text/css"', SC_ATTR + '="' + this.names.join(' ') + '"', LOCAL_ATTR + '="' + (this.isLocal ? 'true' : 'false') + '"'];

    var nonce = getNonce();

    if (nonce) {
      attrs.push('nonce="' + nonce + '"');
    }

    return '<style ' + attrs.join(' ') + '>' + this.concatenateCSS() + '</style>';
  };

  ServerTag.prototype.toReactElement = function toReactElement(key) {
    var _attrs;

    var attrs = (_attrs = {}, _attrs[SC_ATTR] = this.names.join(' '), _attrs[LOCAL_ATTR] = this.isLocal.toString(), _attrs);

    var nonce = getNonce();

    if (nonce) {
      attrs.nonce = nonce;
    }

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('style', _extends({
      key: key,
      type: 'text/css'
    }, attrs, {
      dangerouslySetInnerHTML: { __html: this.concatenateCSS() }
    }));
  };

  ServerTag.prototype.clone = function clone() {
    var _this2 = this;

    var copy = new ServerTag(this.isLocal);
    copy.names = [].concat(this.names);
    copy.size = this.size;
    copy.components = Object.keys(this.components).reduce(function (acc, key) {
      acc[key] = _extends({}, _this2.components[key]); // eslint-disable-line no-param-reassign
      return acc;
    }, {});

    return copy;
  };

  return ServerTag;
}();

var ServerStyleSheet = function () {
  function ServerStyleSheet() {
    classCallCheck(this, ServerStyleSheet);

    this.instance = StyleSheet.clone(StyleSheet.instance);
  }

  ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
    if (this.closed) {
      throw new Error("Can't collect styles once you've called getStyleTags!");
    }
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      StyleSheetManager,
      { sheet: this.instance },
      children
    );
  };

  ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
    if (!this.closed) {
      clones.splice(clones.indexOf(this.instance), 1);
      this.closed = true;
    }

    return this.instance.toHTML();
  };

  ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
    if (!this.closed) {
      clones.splice(clones.indexOf(this.instance), 1);
      this.closed = true;
    }

    return this.instance.toReactElements();
  };

  ServerStyleSheet.create = function create() {
    return new StyleSheet(function (isLocal) {
      return new ServerTag(isLocal);
    });
  };

  return ServerStyleSheet;
}();

//      

var LIMIT = 200;

var createWarnTooManyClasses = (function (displayName) {
  var generatedClasses = {};
  var warningSeen = false;

  return function (className) {
    if (!warningSeen) {
      generatedClasses[className] = true;
      if (Object.keys(generatedClasses).length >= LIMIT) {
        // Unable to find latestRule in test environment.
        /* eslint-disable no-console, prefer-template */
        console.warn('Over ' + LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs({\n' + '    style: ({ background }) => ({\n' + '      background,\n' + '    }),\n' + '  })`width: 100%;`\n\n' + '  <Component />');
        warningSeen = true;
        generatedClasses = {};
      }
    }
  };
});

//      
/* eslint-disable max-len */
/**
 * Trying to avoid the unknown-prop errors on styled components by filtering by
 * React's attribute whitelist.
 *
 * To regenerate this regex:
 *
 * 1. `npm i -g regexgen` (https://github.com/devongovett/regexgen)
 * 2. Run `regexgen` with the list of space-separated words below as input
 * 3. Surround the emitted regex with this: `/^(GENERATED_REGEX)$/` -- this will ensure a full string match
 *    and no false positives from partials
 **/
/*
children dangerouslySetInnerHTML key ref autoFocus defaultValue valueLink defaultChecked checkedLink innerHTML suppressContentEditableWarning onFocusIn onFocusOut className onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onReset onClick onContextMenu onDoubleClick onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onAnimationStart onAnimationEnd onAnimationIteration onTransitionEnd onCopyCapture onCutCapture onPasteCapture onCompositionEndCapture onCompositionStartCapture onCompositionUpdateCapture onKeyDownCapture onKeyPressCapture onKeyUpCapture onFocusCapture onBlurCapture onChangeCapture onInputCapture onSubmitCapture onResetCapture onClickCapture onContextMenuCapture onDoubleClickCapture onDragCapture onDragEndCapture onDragEnterCapture onDragExitCapture onDragLeaveCapture onDragOverCapture onDragStartCapture onDropCapture onMouseDownCapture onMouseEnterCapture onMouseLeaveCapture onMouseMoveCapture onMouseOutCapture onMouseOverCapture onMouseUpCapture onSelectCapture onTouchCancelCapture onTouchEndCapture onTouchMoveCapture onTouchStartCapture onScrollCapture onWheelCapture onAbortCapture onCanPlayCapture onCanPlayThroughCapture onDurationChangeCapture onEmptiedCapture onEncryptedCapture onEndedCapture onErrorCapture onLoadedDataCapture onLoadedMetadataCapture onLoadStartCapture onPauseCapture onPlayCapture onPlayingCapture onProgressCapture onRateChangeCapture onSeekedCapture onSeekingCapture onStalledCapture onSuspendCapture onTimeUpdateCapture onVolumeChangeCapture onWaitingCapture onLoadCapture onAnimationStartCapture onAnimationEndCapture onAnimationIterationCapture onTransitionEndCapture accept acceptCharset accessKey action allowFullScreen allowTransparency alt as async autoComplete autoPlay capture cellPadding cellSpacing charSet challenge checked cite classID className cols colSpan content contentEditable contextMenu controls coords crossOrigin data dateTime default defer dir disabled download draggable encType form formAction formEncType formMethod formNoValidate formTarget frameBorder headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media mediaGroup method min minLength multiple muted name nonce noValidate open optimum pattern placeholder playsInline poster preload profile radioGroup readOnly referrerPolicy rel required reversed role rows rowSpan sandbox scope scoped scrolling seamless selected shape size sizes span spellCheck src srcDoc srcLang srcSet start step style summary tabIndex target title type useMap value width wmode wrap about datatype inlist prefix property resource typeof vocab autoCapitalize autoCorrect autoSave color itemProp itemScope itemType itemID itemRef results security unselectable accentHeight accumulate additive alignmentBaseline allowReorder alphabetic amplitude arabicForm ascent attributeName attributeType autoReverse azimuth baseFrequency baseProfile baselineShift bbox begin bias by calcMode capHeight clip clipPath clipRule clipPathUnits colorInterpolation colorInterpolationFilters colorProfile colorRendering contentScriptType contentStyleType cursor cx cy d decelerate descent diffuseConstant direction display divisor dominantBaseline dur dx dy edgeMode elevation enableBackground end exponent externalResourcesRequired fill fillOpacity fillRule filter filterRes filterUnits floodColor floodOpacity focusable fontFamily fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontWeight format from fx fy g1 g2 glyphName glyphOrientationHorizontal glyphOrientationVertical glyphRef gradientTransform gradientUnits hanging horizAdvX horizOriginX ideographic imageRendering in in2 intercept k k1 k2 k3 k4 kernelMatrix kernelUnitLength kerning keyPoints keySplines keyTimes lengthAdjust letterSpacing lightingColor limitingConeAngle local markerEnd markerMid markerStart markerHeight markerUnits markerWidth mask maskContentUnits maskUnits mathematical mode numOctaves offset opacity operator order orient orientation origin overflow overlinePosition overlineThickness paintOrder panose1 pathLength patternContentUnits patternTransform patternUnits pointerEvents points pointsAtX pointsAtY pointsAtZ preserveAlpha preserveAspectRatio primitiveUnits r radius refX refY renderingIntent repeatCount repeatDur requiredExtensions requiredFeatures restart result rotate rx ry scale seed shapeRendering slope spacing specularConstant specularExponent speed spreadMethod startOffset stdDeviation stemh stemv stitchTiles stopColor stopOpacity strikethroughPosition strikethroughThickness string stroke strokeDasharray strokeDashoffset strokeLinecap strokeLinejoin strokeMiterlimit strokeOpacity strokeWidth surfaceScale systemLanguage tableValues targetX targetY textAnchor textDecoration textRendering textLength to transform u1 u2 underlinePosition underlineThickness unicode unicodeBidi unicodeRange unitsPerEm vAlphabetic vHanging vIdeographic vMathematical values vectorEffect version vertAdvY vertOriginX vertOriginY viewBox viewTarget visibility widths wordSpacing writingMode x xHeight x1 x2 xChannelSelector xlinkActuate xlinkArcrole xlinkHref xlinkRole xlinkShow xlinkTitle xlinkType xmlBase xmlns xmlnsXlink xmlLang xmlSpace y y1 y2 yChannelSelector z zoomAndPan
*/
/* eslint-enable max-len */

var ATTRIBUTE_REGEX = /^((?:s(?:uppressContentEditableWarn|croll|pac)|(?:shape|image|text)Render|(?:letter|word)Spac|vHang|hang)ing|(?:on(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:Animation|Touch|Load|Drag)Start|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|TimeUpdate|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|MouseDown|P(?:rogress|laying)|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|KeyPress|DragEnd|Key(?:Down|Up)|(?:Wait|Seek)ing|(?:MouseU|Dro)p|Scroll|Paste|Focus|Abort|Drag|Play|Load|Blur)Captur|alignmentBaselin|(?:limitingConeAng|xlink(?:(?:Arcr|R)o|Tit)|s(?:urfaceSca|ty|ca)|unselectab|baseProfi|fontSty|(?:focus|dragg)ab|multip|profi|tit)l|d(?:ominantBaselin|efaultValu)|a(?:uto(?:Capitaliz|Revers|Sav)|dditiv)|(?:(?:formNoValid|xlinkActu|noValid|accumul|rot)a|autoComple|decelera)t|(?:(?:attribute|item)T|datat)yp|(?:attribute|glyph)Nam|playsInlin|(?:formE|e)ncTyp|(?:writing|input|edge)Mod|(?:xlinkTy|itemSco|keyTy|slo)p|(?:amplitu|mo)d|(?:xmlSpa|non)c|fillRul|(?:dateTi|na)m|r(?:esourc|ol)|xmlBas|wmod)e|(?:glyphOrientationHorizont|loc)al|(?:externalResourcesRequir|select|revers|mut)ed|c(?:o(?:lorInterpolationFilter|ntrol|ord)s|o(?:lor(?:Interpolation)?|ntent)|(?:ontentS(?:cript|tyle)Typ|o(?:ntentEditab|lorProfi)l|l(?:assNam|ipRul)|a(?:lcMod|ptur)|it)e|olorRendering|l(?:ipPathUnits|assID)|o(?:ntextMenu|ls)|h(?:eckedLink|a(?:llenge|rSet)|ildren|ecked)|ell(?:Spac|Padd)ing|(?:rossOrigi|olSpa)n|apHeight|lip(?:Path)?|ursor|[xy])|glyphOrientationVertical|d(?:angerouslySetInnerHTML|efaultChecked|ownload|isabled|isplay|[xy])|(?:s(?:trikethroughThickn|eaml)es|(?:und|ov)erlineThicknes|r(?:equiredExtension|adiu)|(?:requiredFeatur|tableValu|stitchTil|numOctav|filterR)e|key(?:(?:Splin|Tim)e|Param)|autoFocu|header|bia)s|(?:(?:st(?:rikethroughPosi|dDevia)|(?:und|ov)erlinePosi|(?:textDecor|elev)a|orienta)tio|(?:strokeLinejo|orig)i|formActio|zoomAndPa|onFocusI|directio|(?:vers|act)io|rowSpa|begi|ico)n|o(?:n(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:Animation|Touch|Load|Drag)Start|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|TimeUpdate|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|MouseDown|P(?:rogress|laying)|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|KeyPress|DragEnd|Key(?:Down|Up)|(?:Wait|Seek)ing|(?:MouseU|Dro)p|Scroll|Paste|Focus|Abort|Drag|Play|Load|Blur)|rient)|p(?:reserveA(?:spectRatio|lpha)|ointsAt[X-Z]|anose1)|(?:patternContent|ma(?:sk(?:Content)?|rker)|primitive|gradient|pattern|filter)Units|(?:gradientT|patternT|t)ransform|(?:(?:allowTranspar|baseFrequ)enc|re(?:ferrerPolic|adOnl)|(?:(?:st(?:roke|op)O|floodO|fillO|o)pac|integr|secur)it|visibilit|fontFamil|accessKe|propert|summar)y|(?:strokeMiterlimi|(?:specularConsta|repeatCou|fontVaria)n|(?:(?:specularE|e)xpon|renderingInt|asc)en|d(?:iffuseConsta|esce)n|(?:fontSizeAdju|lengthAdju|manife)s|baselineShif|vectorEffec|(?:(?:mar(?:ker|gin)|x)H|accentH|fontW)eigh|a(?:utoCorrec|bou)|markerStar|onFocusOu|in(?:tercep|lis)|restar|forma|heigh|lis)t|(?:(?:st(?:rokeDasho|artO)|o)ffs|acceptChars|formTarg|viewTarg|srcS)et|(?:(?:enableBackgrou|markerE)n|s(?:p(?:readMetho|ee)|ee)|formMetho|m(?:arkerMi|etho)|preloa|kin)d|k(?:ernel(?:UnitLength|Matrix)|[1-4])|(?:[xy]ChannelSelect|lightingCol|textAnch|floodCol|stopCol|operat|htmlF)or|(?:allowFullScre|hidd)en|strokeDasharray|systemLanguage|(?:strokeLineca|itemPro|useMa|wra|loo)p|v(?:Mathematical|ert(?:Origin[XY]|AdvY)|alues|ocab)|(?:pointerEve|keyPoi)nts|unicodeRange|(?:(?:allowReord|placehold|frameBord|paintOrd|post|ord)e|repeatDu|d(?:efe|u))r|mathematical|(?:vI|i)deographic|h(?:oriz(?:Origin|Adv)X|ttpEquiv)|u(?:nicodeBidi|[12])|(?:fontStretc|hig)h|(?:(?:mar(?:ker|gin)W|strokeW)id|azimu)th|vAlphabetic|mediaGroup|spellCheck|(?:unitsPerE|optimu|fro)m|r(?:adioGroup|e(?:sults|f[XY]|l)|ows|[xy])|(?:xmlnsXl|valueL)ink|a(?:rabicForm|l(?:phabetic|t)|sync)|pathLength|(?:text|m(?:in|ax))Length|innerHTML|xlinkShow|(?:xlinkHr|glyphR)ef|r(?:e(?:quired|sult|f))?|o(?:verflow|pen)|(?:tabInde|(?:sand|b)bo|viewBo)x|(?:(?:href|xml|src)La|kerni)ng|f(?:o(?:ntSize|rm)|il(?:ter|l))|autoPlay|unicode|p(?:attern|oints)|t(?:arget[XY]|o)|i(?:temRef|n2|s)|divisor|d(?:efault|ata|ir)?|srcDoc|s(?:coped|te(?:m[hv]|p)|pan)|(?:width|size)s|(?:stri|la)ng|prefix|itemID|s(?:t(?:roke|art)|hape|cope|rc)|a(?:ccept|s)|t(?:arget|ype)|typeof|width|value|x(?:mlns)?|label|m(?:edia|a(?:sk|x)|in)|size|href|k(?:ey)?|end|low|x[12]|i[dn]|y[12]|g[12]|by|f[xy]|[yz])$/;

/* From DOMProperty */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
var isCustomAttribute = RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'));

var validAttr = (function (name) {
  return ATTRIBUTE_REGEX.test(name) || isCustomAttribute(name.toLowerCase());
});

//      


function isTag(target) /* : %checks */{
  return typeof target === 'string';
}

//      


function isStyledComponent(target) /* : %checks */{
  return typeof target === 'function' && typeof target.styledComponentId === 'string';
}

//      

/* eslint-disable no-undef */
function getComponentName(target) {
  return target.displayName || target.name || 'Component';
}

//      


var determineTheme = (function (props, fallbackTheme, defaultProps) {
  // Props should take precedence over ThemeProvider, which should take precedence over
  // defaultProps, but React automatically puts defaultProps on props.

  /* eslint-disable react/prop-types */
  var isDefaultTheme = defaultProps && props.theme === defaultProps.theme;
  var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme;
  /* eslint-enable */

  return theme;
});

//      
var escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
var dashesAtEnds = /(^-|-$)/g;

/**
 * TODO: Explore using CSS.escape when it becomes more available
 * in evergreen browsers.
 */
function escape(str) {
  return str
  // Replace all possible CSS selectors
  .replace(escapeRegex, '-')

  // Remove extraneous hyphens at the start and end
  .replace(dashesAtEnds, '');
}

//      
/**
 * Creates a broadcast that can be listened to, i.e. simple event emitter
 *
 * @see https://github.com/ReactTraining/react-broadcast
 */

var createBroadcast = function createBroadcast(initialState) {
  var listeners = {};
  var id = 0;
  var state = initialState;

  function publish(nextState) {
    state = nextState;

    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (var key in listeners) {
      var listener = listeners[key];
      if (listener === undefined) {
        // eslint-disable-next-line no-continue
        continue;
      }

      listener(state);
    }
  }

  function subscribe(listener) {
    var currentId = id;
    listeners[currentId] = listener;
    id += 1;
    listener(state);
    return currentId;
  }

  function unsubscribe(unsubID) {
    listeners[unsubID] = undefined;
  }

  return { publish: publish, subscribe: subscribe, unsubscribe: unsubscribe };
};

//      
// Helper to call a given function, only once
var once = (function (cb) {
  var called = false;

  return function () {
    if (!called) {
      called = true;
      cb();
    }
  };
});

var _ThemeProvider$childC;
var _ThemeProvider$contex;

//      
/* globals React$Element */
// NOTE: DO NOT CHANGE, changing this is a semver major change!
var CHANNEL = '__styled-components__';
var CHANNEL_NEXT = CHANNEL + 'next__';

var CONTEXT_CHANNEL_SHAPE = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
  getTheme: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  subscribe: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  unsubscribe: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func
});

var warnChannelDeprecated = void 0;
if (false) {
  warnChannelDeprecated = once(function () {
    // eslint-disable-next-line no-console
    console.error('Warning: Usage of `context.' + CHANNEL + '` as a function is deprecated. It will be replaced with the object on `.context.' + CHANNEL_NEXT + '` in a future version.');
  });
}

var isFunction = function isFunction(test) {
  return typeof test === 'function';
};

/**
 * Provide a theme to an entire react component tree via context and event listeners (have to do
 * both context and event emitter as pure components block context updates)
 */

var ThemeProvider = function (_Component) {
  inherits(ThemeProvider, _Component);

  function ThemeProvider() {
    classCallCheck(this, ThemeProvider);

    var _this = possibleConstructorReturn(this, _Component.call(this));

    _this.unsubscribeToOuterId = -1;

    _this.getTheme = _this.getTheme.bind(_this);
    return _this;
  }

  ThemeProvider.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    // If there is a ThemeProvider wrapper anywhere around this theme provider, merge this theme
    // with the outer theme
    var outerContext = this.context[CHANNEL_NEXT];
    if (outerContext !== undefined) {
      this.unsubscribeToOuterId = outerContext.subscribe(function (theme) {
        _this2.outerTheme = theme;
      });
    }
    this.broadcast = createBroadcast(this.getTheme());
  };

  ThemeProvider.prototype.getChildContext = function getChildContext() {
    var _this3 = this,
        _babelHelpers$extends;

    return _extends({}, this.context, (_babelHelpers$extends = {}, _babelHelpers$extends[CHANNEL_NEXT] = {
      getTheme: this.getTheme,
      subscribe: this.broadcast.subscribe,
      unsubscribe: this.broadcast.unsubscribe
    }, _babelHelpers$extends[CHANNEL] = function (subscriber) {
      if (false) {
        warnChannelDeprecated();
      }

      // Patch the old `subscribe` provide via `CHANNEL` for older clients.
      var unsubscribeId = _this3.broadcast.subscribe(subscriber);
      return function () {
        return _this3.broadcast.unsubscribe(unsubscribeId);
      };
    }, _babelHelpers$extends));
  };

  ThemeProvider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.theme !== nextProps.theme) {
      this.broadcast.publish(this.getTheme(nextProps.theme));
    }
  };

  ThemeProvider.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.unsubscribeToOuterId !== -1) {
      this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeToOuterId);
    }
  };

  // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation


  ThemeProvider.prototype.getTheme = function getTheme(passedTheme) {
    var theme = passedTheme || this.props.theme;
    if (isFunction(theme)) {
      var mergedTheme = theme(this.outerTheme);
      if (false) {
        throw new Error('[ThemeProvider] Please return an object from your theme function, i.e. theme={() => ({})}!');
      }
      return mergedTheme;
    }
    if (!__WEBPACK_IMPORTED_MODULE_0_is_plain_object___default()(theme)) {
      throw new Error('[ThemeProvider] Please make your theme prop a plain object');
    }
    return _extends({}, this.outerTheme, theme);
  };

  ThemeProvider.prototype.render = function render() {
    if (!this.props.children) {
      return null;
    }
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(this.props.children);
  };

  return ThemeProvider;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

ThemeProvider.childContextTypes = (_ThemeProvider$childC = {}, _ThemeProvider$childC[CHANNEL] = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, _ThemeProvider$childC[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _ThemeProvider$childC);
ThemeProvider.contextTypes = (_ThemeProvider$contex = {}, _ThemeProvider$contex[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _ThemeProvider$contex);

//      

// HACK for generating all static styles without needing to allocate
// an empty execution context every single time...
var STATIC_EXECUTION_CONTEXT = {};

var _StyledComponent = (function (ComponentStyle, constructWithOptions) {
  var identifiers = {};

  /* We depend on components having unique IDs */
  var generateId = function generateId(_displayName, parentComponentId) {
    var displayName = typeof _displayName !== 'string' ? 'sc' : escape(_displayName);

    var componentId = void 0;

    /**
     * only fall back to hashing the component injection order if
     * a proper displayName isn't provided by the babel plugin
     */
    if (!_displayName) {
      var nr = (identifiers[displayName] || 0) + 1;
      identifiers[displayName] = nr;

      componentId = displayName + '-' + ComponentStyle.generateName(displayName + nr);
    } else {
      componentId = displayName + '-' + ComponentStyle.generateName(displayName);
    }

    return parentComponentId !== undefined ? parentComponentId + '-' + componentId : componentId;
  };

  var BaseStyledComponent = function (_Component) {
    inherits(BaseStyledComponent, _Component);

    function BaseStyledComponent() {
      var _temp, _this, _ret;

      classCallCheck(this, BaseStyledComponent);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.attrs = {}, _this.state = {
        theme: null,
        generatedClassName: ''
      }, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
    }

    BaseStyledComponent.prototype.unsubscribeFromContext = function unsubscribeFromContext() {
      if (this.unsubscribeId !== -1) {
        this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
      }
    };

    BaseStyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props) {
      var attrs = this.constructor.attrs;

      var context = _extends({}, props, { theme: theme });
      if (attrs === undefined) {
        return context;
      }

      this.attrs = Object.keys(attrs).reduce(function (acc, key) {
        var attr = attrs[key];
        // eslint-disable-next-line no-param-reassign
        acc[key] = typeof attr === 'function' ? attr(context) : attr;
        return acc;
      }, {});

      return _extends({}, context, this.attrs);
    };

    BaseStyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
      var _constructor = this.constructor,
          attrs = _constructor.attrs,
          componentStyle = _constructor.componentStyle,
          warnTooManyClasses = _constructor.warnTooManyClasses;

      var styleSheet = this.context[CONTEXT_KEY] || StyleSheet.instance;

      // staticaly styled-components don't need to build an execution context object,
      // and shouldn't be increasing the number of class names
      if (componentStyle.isStatic && attrs === undefined) {
        return componentStyle.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, styleSheet);
      } else {
        var executionContext = this.buildExecutionContext(theme, props);
        var className = componentStyle.generateAndInjectStyles(executionContext, styleSheet);

        if (false) {
          warnTooManyClasses(className);
        }

        return className;
      }
    };

    BaseStyledComponent.prototype.componentWillMount = function componentWillMount() {
      var _this2 = this;

      var componentStyle = this.constructor.componentStyle;

      var styledContext = this.context[CHANNEL_NEXT];

      // If this is a staticaly-styled component, we don't need to the theme
      // to generate or build styles.
      if (componentStyle.isStatic) {
        var generatedClassName = this.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, this.props);
        this.setState({ generatedClassName: generatedClassName });
        // If there is a theme in the context, subscribe to the event emitter. This
        // is necessary due to pure components blocking context updates, this circumvents
        // that by updating when an event is emitted
      } else if (styledContext !== undefined) {
        var subscribe = styledContext.subscribe;

        this.unsubscribeId = subscribe(function (nextTheme) {
          // This will be called once immediately
          var theme = determineTheme(_this2.props, nextTheme, _this2.constructor.defaultProps);
          var generatedClassName = _this2.generateAndInjectStyles(theme, _this2.props);

          _this2.setState({ theme: theme, generatedClassName: generatedClassName });
        });
      } else {
        // eslint-disable-next-line react/prop-types
        var theme = this.props.theme || {};
        var _generatedClassName = this.generateAndInjectStyles(theme, this.props);
        this.setState({ theme: theme, generatedClassName: _generatedClassName });
      }
    };

    BaseStyledComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      // If this is a staticaly-styled component, we don't need to listen to
      // props changes to update styles
      var componentStyle = this.constructor.componentStyle;

      if (componentStyle.isStatic) {
        return;
      }

      this.setState(function (oldState) {
        var theme = determineTheme(nextProps, oldState.theme, _this3.constructor.defaultProps);
        var generatedClassName = _this3.generateAndInjectStyles(theme, nextProps);

        return { theme: theme, generatedClassName: generatedClassName };
      });
    };

    BaseStyledComponent.prototype.componentWillUnmount = function componentWillUnmount() {
      this.unsubscribeFromContext();
    };

    BaseStyledComponent.prototype.render = function render() {
      var _this4 = this;

      // eslint-disable-next-line react/prop-types
      var innerRef = this.props.innerRef;
      var generatedClassName = this.state.generatedClassName;
      var _constructor2 = this.constructor,
          styledComponentId = _constructor2.styledComponentId,
          target = _constructor2.target;


      var isTargetTag = isTag(target);

      var className = [
      // eslint-disable-next-line react/prop-types
      this.props.className, styledComponentId, this.attrs.className, generatedClassName].filter(Boolean).join(' ');

      var baseProps = _extends({}, this.attrs, {
        className: className
      });

      if (isStyledComponent(target)) {
        baseProps.innerRef = innerRef;
      } else {
        baseProps.ref = innerRef;
      }

      var propsForElement = Object.keys(this.props).reduce(function (acc, propName) {
        // Don't pass through non HTML tags through to HTML elements
        // always omit innerRef
        if (propName !== 'innerRef' && propName !== 'className' && (!isTargetTag || validAttr(propName))) {
          // eslint-disable-next-line no-param-reassign
          acc[propName] = _this4.props[propName];
        }

        return acc;
      }, baseProps);

      return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(target, propsForElement);
    };

    return BaseStyledComponent;
  }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

  var createStyledComponent = function createStyledComponent(target, options, rules) {
    var _StyledComponent$cont;

    var _options$displayName = options.displayName,
        displayName = _options$displayName === undefined ? isTag(target) ? 'styled.' + target : 'Styled(' + getComponentName(target) + ')' : _options$displayName,
        _options$componentId = options.componentId,
        componentId = _options$componentId === undefined ? generateId(options.displayName, options.parentComponentId) : _options$componentId,
        _options$ParentCompon = options.ParentComponent,
        ParentComponent = _options$ParentCompon === undefined ? BaseStyledComponent : _options$ParentCompon,
        extendingRules = options.rules,
        attrs = options.attrs;


    var styledComponentId = options.displayName && options.componentId ? escape(options.displayName) + '-' + options.componentId : componentId;

    var componentStyle = new ComponentStyle(extendingRules === undefined ? rules : extendingRules.concat(rules), attrs, styledComponentId);

    var StyledComponent = function (_ParentComponent) {
      inherits(StyledComponent, _ParentComponent);

      function StyledComponent() {
        classCallCheck(this, StyledComponent);
        return possibleConstructorReturn(this, _ParentComponent.apply(this, arguments));
      }

      StyledComponent.withComponent = function withComponent(tag) {
        var previousComponentId = options.componentId,
            optionsToCopy = objectWithoutProperties(options, ['componentId']);


        var newComponentId = previousComponentId && previousComponentId + '-' + (isTag(tag) ? tag : escape(getComponentName(tag)));

        var newOptions = _extends({}, optionsToCopy, {
          componentId: newComponentId,
          ParentComponent: StyledComponent
        });

        return createStyledComponent(tag, newOptions, rules);
      };

      createClass(StyledComponent, null, [{
        key: 'extend',
        get: function get$$1() {
          var rulesFromOptions = options.rules,
              parentComponentId = options.componentId,
              optionsToCopy = objectWithoutProperties(options, ['rules', 'componentId']);


          var newRules = rulesFromOptions === undefined ? rules : rulesFromOptions.concat(rules);

          var newOptions = _extends({}, optionsToCopy, {
            rules: newRules,
            parentComponentId: parentComponentId,
            ParentComponent: StyledComponent
          });

          return constructWithOptions(createStyledComponent, target, newOptions);
        }
      }]);
      return StyledComponent;
    }(ParentComponent);

    StyledComponent.contextTypes = (_StyledComponent$cont = {}, _StyledComponent$cont[CHANNEL] = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, _StyledComponent$cont[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _StyledComponent$cont[CONTEXT_KEY] = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(StyleSheet), __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(ServerStyleSheet)]), _StyledComponent$cont);
    StyledComponent.displayName = displayName;
    StyledComponent.styledComponentId = styledComponentId;
    StyledComponent.attrs = attrs;
    StyledComponent.componentStyle = componentStyle;
    StyledComponent.target = target;


    if (false) {
      StyledComponent.warnTooManyClasses = createWarnTooManyClasses(displayName);
    }

    return StyledComponent;
  };

  return createStyledComponent;
});

// murmurhash2 via https://gist.github.com/raycmorgan/588423

function doHash(str, seed) {
  var m = 0x5bd1e995;
  var r = 24;
  var h = seed ^ str.length;
  var length = str.length;
  var currentIndex = 0;

  while (length >= 4) {
    var k = UInt32(str, currentIndex);

    k = Umul32(k, m);
    k ^= k >>> r;
    k = Umul32(k, m);

    h = Umul32(h, m);
    h ^= k;

    currentIndex += 4;
    length -= 4;
  }

  switch (length) {
    case 3:
      h ^= UInt16(str, currentIndex);
      h ^= str.charCodeAt(currentIndex + 2) << 16;
      h = Umul32(h, m);
      break;

    case 2:
      h ^= UInt16(str, currentIndex);
      h = Umul32(h, m);
      break;

    case 1:
      h ^= str.charCodeAt(currentIndex);
      h = Umul32(h, m);
      break;
  }

  h ^= h >>> 13;
  h = Umul32(h, m);
  h ^= h >>> 15;

  return h >>> 0;
}

function UInt32(str, pos) {
  return str.charCodeAt(pos++) + (str.charCodeAt(pos++) << 8) + (str.charCodeAt(pos++) << 16) + (str.charCodeAt(pos) << 24);
}

function UInt16(str, pos) {
  return str.charCodeAt(pos++) + (str.charCodeAt(pos++) << 8);
}

function Umul32(n, m) {
  n = n | 0;
  m = m | 0;
  var nlo = n & 0xffff;
  var nhi = n >>> 16;
  var res = nlo * m + ((nhi * m & 0xffff) << 16) | 0;
  return res;
}

//      
var isStaticRules = function isStaticRules(rules, attrs) {
  for (var i = 0; i < rules.length; i += 1) {
    var rule = rules[i];

    // recursive case
    if (Array.isArray(rule) && !isStaticRules(rule)) {
      return false;
    } else if (typeof rule === 'function' && !isStyledComponent(rule)) {
      // functions are allowed to be static if they're just being
      // used to get the classname of a nested styled copmonent
      return false;
    }
  }

  if (attrs !== undefined) {
    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (var key in attrs) {
      var value = attrs[key];
      if (typeof value === 'function') {
        return false;
      }
    }
  }

  return true;
};

var isHRMEnabled = typeof module !== 'undefined' && module.hot && "production" !== 'production';

/*
 ComponentStyle is all the CSS-specific stuff, not
 the React-specific stuff.
 */
var _ComponentStyle = (function (nameGenerator, flatten, stringifyRules) {
  var ComponentStyle = function () {
    function ComponentStyle(rules, attrs, componentId) {
      classCallCheck(this, ComponentStyle);

      this.rules = rules;
      this.isStatic = !isHRMEnabled && isStaticRules(rules, attrs);
      this.componentId = componentId;
      if (!StyleSheet.instance.hasInjectedComponent(this.componentId)) {
        var placeholder =  false ? '.' + componentId + ' {}' : '';
        StyleSheet.instance.deferredInject(componentId, true, placeholder);
      }
    }

    /*
     * Flattens a rule set into valid CSS
     * Hashes it, wraps the whole chunk in a .hash1234 {}
     * Returns the hash to be injected on render()
     * */


    ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
      var isStatic = this.isStatic,
          lastClassName = this.lastClassName;

      if (isStatic && lastClassName !== undefined) {
        return lastClassName;
      }

      var flatCSS = flatten(this.rules, executionContext);
      var hash = doHash(this.componentId + flatCSS.join(''));

      var existingName = styleSheet.getName(hash);
      if (existingName !== undefined) {
        if (styleSheet.stylesCacheable) {
          this.lastClassName = existingName;
        }
        return existingName;
      }

      var name = nameGenerator(hash);
      if (styleSheet.stylesCacheable) {
        this.lastClassName = existingName;
      }
      if (styleSheet.alreadyInjected(hash, name)) {
        return name;
      }

      var css = '\n' + stringifyRules(flatCSS, '.' + name);
      // NOTE: this can only be set when we inject the class-name.
      // For some reason, presumably due to how css is stringifyRules behaves in
      // differently between client and server, styles break.
      styleSheet.inject(this.componentId, true, css, hash, name);
      return name;
    };

    ComponentStyle.generateName = function generateName(str) {
      return nameGenerator(doHash(str));
    };

    return ComponentStyle;
  }();

  return ComponentStyle;
});

//      
// Thanks to ReactDOMFactories for this handy list!

var domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',

// SVG
'circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

//      

var _styled = (function (styledComponent, constructWithOptions) {
  var styled = function styled(tag) {
    return constructWithOptions(styledComponent, tag);
  };

  // Shorthands for all valid HTML Elements
  domElements.forEach(function (domElement) {
    styled[domElement] = styled(domElement);
  });

  return styled;
});

//      
var replaceWhitespace = function replaceWhitespace(str) {
  return str.replace(/\s|\\n/g, '');
};

var _keyframes = (function (nameGenerator, stringifyRules, css) {
  return function (strings) {
    for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }

    var rules = css.apply(undefined, [strings].concat(interpolations));
    var hash = doHash(replaceWhitespace(JSON.stringify(rules)));

    var existingName = StyleSheet.instance.getName(hash);
    if (existingName) return existingName;

    var name = nameGenerator(hash);
    if (StyleSheet.instance.alreadyInjected(hash, name)) return name;

    var generatedCSS = stringifyRules(rules, name, '@keyframes');
    StyleSheet.instance.inject('sc-keyframes-' + name, true, generatedCSS, hash, name);
    return name;
  };
});

//      
var _injectGlobal = (function (stringifyRules, css) {
  var injectGlobal = function injectGlobal(strings) {
    for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }

    var rules = css.apply(undefined, [strings].concat(interpolations));
    var hash = doHash(JSON.stringify(rules));

    var componentId = 'sc-global-' + hash;
    if (StyleSheet.instance.hasInjectedComponent(componentId)) return;

    StyleSheet.instance.inject(componentId, false, stringifyRules(rules));
  };

  return injectGlobal;
});

//      


var _constructWithOptions = (function (css) {
  var constructWithOptions = function constructWithOptions(componentConstructor, tag) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (false) {
      // $FlowInvalidInputTest
      throw new Error('Cannot create styled-component for component: ' + tag);
    }

    /* This is callable directly as a template function */
    var templateFunction = function templateFunction(strings) {
      for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        interpolations[_key - 1] = arguments[_key];
      }

      return componentConstructor(tag, options, css.apply(undefined, [strings].concat(interpolations)));
    };

    /* If config methods are called, wrap up a new template function and merge options */
    templateFunction.withConfig = function (config) {
      return constructWithOptions(componentConstructor, tag, _extends({}, options, config));
    };
    templateFunction.attrs = function (attrs) {
      return constructWithOptions(componentConstructor, tag, _extends({}, options, {
        attrs: _extends({}, options.attrs || {}, attrs)
      }));
    };

    return templateFunction;
  };

  return constructWithOptions;
});

//      
/* globals ReactClass */

var wrapWithTheme = function wrapWithTheme(Component$$1) {
  var _WithTheme$contextTyp;

  var componentName = Component$$1.displayName || Component$$1.name || 'Component';

  var shouldSetInnerRef = isStyledComponent(Component$$1) ||
  // NOTE: We can't pass a ref to a stateless functional component
  typeof Component$$1 === 'function' && !(Component$$1.prototype && 'isReactComponent' in Component$$1.prototype);

  var WithTheme = function (_React$Component) {
    inherits(WithTheme, _React$Component);

    function WithTheme() {
      var _temp, _this, _ret;

      classCallCheck(this, WithTheme);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {}, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
    }

    // NOTE: This is so that isStyledComponent passes for the innerRef unwrapping


    WithTheme.prototype.componentWillMount = function componentWillMount() {
      var _this2 = this;

      var defaultProps = this.constructor.defaultProps;

      var styledContext = this.context[CHANNEL_NEXT];
      var themeProp = determineTheme(this.props, undefined, defaultProps);
      if (styledContext === undefined && themeProp === undefined && "production" !== 'production') {
        // eslint-disable-next-line no-console
        console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps');
      } else if (styledContext === undefined && themeProp !== undefined) {
        this.setState({ theme: themeProp });
      } else {
        var subscribe = styledContext.subscribe;

        this.unsubscribeId = subscribe(function (nextTheme) {
          var theme = determineTheme(_this2.props, nextTheme, defaultProps);
          _this2.setState({ theme: theme });
        });
      }
    };

    WithTheme.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var defaultProps = this.constructor.defaultProps;

      this.setState(function (oldState) {
        var theme = determineTheme(nextProps, oldState.theme, defaultProps);

        return { theme: theme };
      });
    };

    WithTheme.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.unsubscribeId !== -1) {
        this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
      }
    };

    WithTheme.prototype.render = function render() {
      // eslint-disable-next-line react/prop-types
      var innerRef = this.props.innerRef;
      var theme = this.state.theme;


      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component$$1, _extends({
        theme: theme
      }, this.props, {
        innerRef: shouldSetInnerRef ? innerRef : undefined,
        ref: shouldSetInnerRef ? undefined : innerRef
      }));
    };

    return WithTheme;
  }(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

  WithTheme.displayName = 'WithTheme(' + componentName + ')';
  WithTheme.styledComponentId = 'withTheme';
  WithTheme.contextTypes = (_WithTheme$contextTyp = {}, _WithTheme$contextTyp[CHANNEL] = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, _WithTheme$contextTyp[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _WithTheme$contextTyp);


  return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(WithTheme, Component$$1);
};

//      

/* Import singletons */
/* Import singleton constructors */
/* Import components */
/* Import Higher Order Components */
/* Instantiate singletons */
var ComponentStyle = _ComponentStyle(generateAlphabeticName, flatten, stringifyRules);
var constructWithOptions = _constructWithOptions(css);
var StyledComponent = _StyledComponent(ComponentStyle, constructWithOptions);

/* Instantiate exported singletons */
var keyframes = _keyframes(generateAlphabeticName, stringifyRules, css);
var injectGlobal = _injectGlobal(stringifyRules, css);
var styled = _styled(StyledComponent, constructWithOptions);

/* harmony default export */ __webpack_exports__["default"] = (styled);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../node_modules/webpack/buildin/harmony-module.js")(module)))

/***/ }),

/***/ "../node_modules/decisiv-ui-utils/node_modules/stylis/stylis.js":
/***/ (function(module, exports, __webpack_require__) {

/*
 *          __        ___
 *    _____/ /___  __/ (_)____
 *   / ___/ __/ / / / / / ___/
 *  (__  ) /_/ /_/ / / (__  )
 * /____/\__/\__, /_/_/____/
 *          /____/
 *
 * light - weight css preprocessor @licence MIT
 */
(function (factory) {/* eslint-disable */
	 true ? (module['exports'] = factory(null)) :
		typeof define === 'function' && define['amd'] ? define(factory(null)) :
			(window['stylis'] = factory(null))
}(/** @param {*=} options */function factory (options) {/* eslint-disable */

	'use strict'

	/**
	 * Notes
	 *
	 * The ['<method name>'] pattern is used to support closure compiler
	 * the jsdoc signatures are also used to the same effect
	 *
	 * ----
	 *
	 * int + int + int === n4 [faster]
	 *
	 * vs
	 *
	 * int === n1 && int === n2 && int === n3
	 *
	 * ----
	 *
	 * switch (int) { case ints...} [faster]
	 *
	 * vs
	 *
	 * if (int == 1 && int === 2 ...)
	 *
	 * ----
	 *
	 * The (first*n1 + second*n2 + third*n3) format used in the property parser
	 * is a simple way to hash the sequence of characters
	 * taking into account the index they occur in
	 * since any number of 3 character sequences could produce duplicates.
	 *
	 * On the other hand sequences that are directly tied to the index of the character
	 * resolve a far more accurate measure, it's also faster
	 * to evaluate one condition in a switch statement
	 * than three in an if statement regardless of the added math.
	 *
	 * This allows the vendor prefixer to be both small and fast.
	 */

	var nullptn = /^\0+/g /* matches leading null characters */
	var formatptn = /[\0\r\f]/g /* matches new line, null and formfeed characters */
	var colonptn = /: */g /* splits animation rules */
	var cursorptn = /zoo|gra/ /* assert cursor varient */
	var transformptn = /([,: ])(transform)/g /* vendor prefix transform, older webkit */
	var animationptn = /,+\s*(?![^(]*[)])/g /* splits multiple shorthand notation animations */
	var propertiesptn = / +\s*(?![^(]*[)])/g /* animation properties */
	var elementptn = / *[\0] */g /* selector elements */
	var selectorptn = /,\r+?/g /* splits selectors */
	var andptn = /([\t\r\n ])*\f?&/g /* match & */
	var escapeptn = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g /* matches :global(.*) */
	var invalidptn = /\W+/g /* removes invalid characters from keyframes */
	var keyframeptn = /@(k\w+)\s*(\S*)\s*/ /* matches @keyframes $1 */
	var plcholdrptn = /::(place)/g /* match ::placeholder varient */
	var readonlyptn = /:(read-only)/g /* match :read-only varient */
	var beforeptn = /\s+(?=[{\];=:>])/g /* matches \s before ] ; = : */
	var afterptn = /([[}=:>])\s+/g /* matches \s after characters [ } = : */
	var tailptn = /(\{[^{]+?);(?=\})/g /* matches tail semi-colons ;} */
	var whiteptn = /\s{2,}/g /* matches repeating whitespace */
	var pseudoptn = /([^\(])(:+) */g /* pseudo element */
	var writingptn = /[svh]\w+-[tblr]{2}/ /* match writing mode property values */
	var gradientptn = /([\w-]+t\()/g /* match *gradient property */
	var supportsptn = /\(\s*(.*)\s*\)/g /* match supports (groups) */
	var propertyptn = /([\s\S]*?);/g /* match properties leading semicolon */
	var selfptn = /-self|flex-/g /* match flex- and -self in align-self: flex-*; */
	var pseudofmt = /[^]*?(:[rp][el]a[\w-]+)[^]*/ /* extrats :readonly or :placholder from selector */
	var trimptn = /[ \t]+$/ /* match tail whitspace */
	var dimensionptn = /stretch|:\s*\w+\-(?:conte|avail)/ /* match max/min/fit-content, fill-available

	/* vendors */
	var webkit = '-webkit-'
	var moz = '-moz-'
	var ms = '-ms-'

	/* character codes */
	var SEMICOLON = 59 /* ; */
	var CLOSEBRACES = 125 /* } */
	var OPENBRACES = 123 /* { */
	var OPENPARENTHESES = 40 /* ( */
	var CLOSEPARENTHESES = 41 /* ) */
	var OPENBRACKET = 91 /* [ */
	var CLOSEBRACKET = 93 /* ] */
	var NEWLINE = 10 /* \n */
	var CARRIAGE = 13 /* \r */
	var TAB = 9 /* \t */
	var AT = 64 /* @ */
	var SPACE = 32 /*   */
	var AND = 38 /* & */
	var DASH = 45 /* - */
	var UNDERSCORE = 95 /* _ */
	var STAR = 42 /* * */
	var COMMA = 44 /* , */
	var COLON = 58 /* : */
	var SINGLEQUOTE = 39 /* ' */
	var DOUBLEQUOTE = 34 /* " */
	var FOWARDSLASH = 47 /* / */
	var GREATERTHAN = 62 /* > */
	var PLUS = 43 /* + */
	var TILDE = 126 /* ~ */
	var NULL = 0 /* \0 */
	var FORMFEED = 12 /* \f */
	var VERTICALTAB = 11 /* \v */

	/* special identifiers */
	var KEYFRAME = 107 /* k */
	var MEDIA = 109 /* m */
	var SUPPORTS = 115 /* s */
	var PLACEHOLDER = 112 /* p */
	var READONLY = 111 /* o */
	var IMPORT = 169 /* <at>i */
	var CHARSET = 163 /* <at>c */
	var DOCUMENT = 100 /* <at>d */
	var PAGE = 112 /* <at>p */

	var column = 1 /* current column */
	var line = 1 /* current line numebr */
	var pattern = 0 /* :pattern */

	var cascade = 1 /* #id h1 h2 vs h1#id h2#id  */
	var prefix = 1 /* vendor prefix */
	var escape = 1 /* escape :global() pattern */
	var compress = 0 /* compress output */
	var semicolon = 0 /* no/semicolon option */
	var preserve = 0 /* preserve empty selectors */

	/* empty reference */
	var array = []

	/* plugins */
	var plugins = []
	var plugged = 0
	var should = null

	/* plugin context */
	var POSTS = -2
	var PREPS = -1
	var UNKWN = 0
	var PROPS = 1
	var BLCKS = 2
	var ATRUL = 3

	/* plugin newline context */
	var unkwn = 0

	/* keyframe animation */
	var keyed = 1
	var key = ''

	/* selector namespace */
	var nscopealt = ''
	var nscope = ''

	/**
	 * Compile
	 *
	 * @param {Array<string>} parent
	 * @param {Array<string>} current
	 * @param {string} body
	 * @param {number} id
	 * @param {number} depth
	 * @return {string}
	 */
	function compile (parent, current, body, id, depth) {
		var bracket = 0 /* brackets [] */
		var comment = 0 /* comments /* // or /* */
		var parentheses = 0 /* functions () */
		var quote = 0 /* quotes '', "" */

		var first = 0 /* first character code */
		var second = 0 /* second character code */
		var code = 0 /* current character code */
		var tail = 0 /* previous character code */
		var trail = 0 /* character before previous code */
		var peak = 0 /* previous non-whitespace code */

		var counter = 0 /* count sequence termination */
		var context = 0 /* track current context */
		var atrule = 0 /* track @at-rule context */
		var pseudo = 0 /* track pseudo token index */
		var caret = 0 /* current character index */
		var format = 0 /* control character formating context */
		var insert = 0 /* auto semicolon insertion */
		var invert = 0 /* inverted selector pattern */
		var length = 0 /* generic length address */
		var eof = body.length /* end of file(length) */
		var eol = eof - 1 /* end of file(characters) */

		var char = '' /* current character */
		var chars = '' /* current buffer of characters */
		var child = '' /* next buffer of characters */
		var out = '' /* compiled body */
		var children = '' /* compiled children */
		var flat = '' /* compiled leafs */
		var selector /* generic selector address */
		var result /* generic address */

		// ...build body
		while (caret < eof) {
			code = body.charCodeAt(caret)

			// eof varient
			if (caret === eol) {
				// last character + noop context, add synthetic padding for noop context to terminate
				if (comment + quote + parentheses + bracket !== 0) {
					if (comment !== 0) {
						code = comment === FOWARDSLASH ? NEWLINE : FOWARDSLASH
					}

					quote = parentheses = bracket = 0
					eof++
					eol++
				}
			}

			if (comment + quote + parentheses + bracket === 0) {
				// eof varient
				if (caret === eol) {
					if (format > 0) {
						chars = chars.replace(formatptn, '')
					}

					if (chars.trim().length > 0) {
						switch (code) {
							case SPACE:
							case TAB:
							case SEMICOLON:
							case CARRIAGE:
							case NEWLINE: {
								break
							}
							default: {
								chars += body.charAt(caret)
							}
						}

						code = SEMICOLON
					}
				}

				// auto semicolon insertion
				if (insert === 1) {
					switch (code) {
						// false flags
						case OPENBRACES:
						case CLOSEBRACES:
						case SEMICOLON:
						case DOUBLEQUOTE:
						case SINGLEQUOTE:
						case OPENPARENTHESES:
						case CLOSEPARENTHESES:
						case COMMA: {
							insert = 0
						}
						// ignore
						case TAB:
						case CARRIAGE:
						case NEWLINE:
						case SPACE: {
							break
						}
						// valid
						default: {
							insert = 0
							length = caret
							first = code
							caret--
							code = SEMICOLON

							while (length < eof) {
								switch (body.charCodeAt(length++)) {
									case NEWLINE:
									case CARRIAGE:
									case SEMICOLON: {
										++caret
										code = first
										length = eof
										break
									}
									case COLON: {
										if (format > 0) {
											++caret
											code = first
										}
									}
									case OPENBRACES: {
										length = eof
									}
								}
							}
						}
					}
				}

				// token varient
				switch (code) {
					case OPENBRACES: {
						chars = chars.trim()
						first = chars.charCodeAt(0)
						counter = 1
						length = ++caret

						while (caret < eof) {
							code = body.charCodeAt(caret)

							switch (code) {
								case OPENBRACES: {
									counter++
									break
								}
								case CLOSEBRACES: {
									counter--
									break
								}
							}

							if (counter === 0) {
								break
							}

							caret++
						}

						child = body.substring(length, caret)

						if (first === NULL) {
							first = (chars = chars.replace(nullptn, '').trim()).charCodeAt(0)
						}

						switch (first) {
							// @at-rule
							case AT: {
								if (format > 0) {
									chars = chars.replace(formatptn, '')
								}

								second = chars.charCodeAt(1)

								switch (second) {
									case DOCUMENT:
									case MEDIA:
									case SUPPORTS:
									case DASH: {
										selector = current
										break
									}
									default: {
										selector = array
									}
								}

								child = compile(current, selector, child, second, depth+1)
								length = child.length

								// preserve empty @at-rule
								if (preserve > 0 && length === 0) {
									length = chars.length
								}

								// execute plugins, @at-rule context
								if (plugged > 0) {
									selector = select(array, chars, invert)
									result = proxy(ATRUL, child, selector, current, line, column, length, second, depth, id)
									chars = selector.join('')

									if (result !== void 0) {
										if ((length = (child = result.trim()).length) === 0) {
											second = 0
											child = ''
										}
									}
								}

								if (length > 0) {
									switch (second) {
										case SUPPORTS: {
											chars = chars.replace(supportsptn, supports)
										}
										case DOCUMENT:
										case MEDIA:
										case DASH: {
											child = chars + '{' + child + '}'
											break
										}
										case KEYFRAME: {
											chars = chars.replace(keyframeptn, '$1 $2' + (keyed > 0 ? key : ''))
											child = chars + '{' + child + '}'

											if (prefix === 1 || (prefix === 2 && vendor('@'+child, 3))) {
												child = '@' + webkit + child + '@' + child
											} else {
												child = '@' + child
											}
											break
										}
										default: {
											child = chars + child

											if (id === PAGE) {
												child = (out += child, '')
											}
										}
									}
								} else {
									child = ''
								}

								break
							}
							// selector
							default: {
								child = compile(current, select(current, chars, invert), child, id, depth+1)
							}
						}

						children += child

						// reset
						context = 0
						insert = 0
						pseudo = 0
						format = 0
						invert = 0
						atrule = 0
						chars = ''
						child = ''
						code = body.charCodeAt(++caret)
						break
					}
					case CLOSEBRACES:
					case SEMICOLON: {
						chars = (format > 0 ? chars.replace(formatptn, '') : chars).trim()

						if ((length = chars.length) > 1) {
							// monkey-patch missing colon
							if (pseudo === 0) {
								first = chars.charCodeAt(0)

								// first character is a letter or dash, buffer has a space character
								if ((first === DASH || first > 96 && first < 123)) {
									length = (chars = chars.replace(' ', ':')).length
								}
							}

							// execute plugins, property context
							if (plugged > 0) {
								if ((result = proxy(PROPS, chars, current, parent, line, column, out.length, id, depth, id)) !== void 0) {
									if ((length = (chars = result.trim()).length) === 0) {
										chars = '\0\0'
									}
								}
							}

							first = chars.charCodeAt(0)
							second = chars.charCodeAt(1)

							switch (first + second) {
								case NULL: {
									break
								}
								case IMPORT:
								case CHARSET: {
									flat += chars + body.charAt(caret)
									break
								}
								default: {
									if (chars.charCodeAt(length-1) === COLON)
										break

									out += property(chars, first, second, chars.charCodeAt(2))
								}
							}
						}

						// reset
						context = 0
						insert = 0
						pseudo = 0
						format = 0
						invert = 0
						chars = ''
						code = body.charCodeAt(++caret)
						break
					}
				}
			}

			// parse characters
			switch (code) {
				case CARRIAGE:
				case NEWLINE: {
					// auto insert semicolon
					if (comment + quote + parentheses + bracket + semicolon === 0) {
						// valid non-whitespace characters that
						// may precede a newline
						switch (peak) {
							case CLOSEPARENTHESES:
							case SINGLEQUOTE:
							case DOUBLEQUOTE:
							case AT:
							case TILDE:
							case GREATERTHAN:
							case STAR:
							case PLUS:
							case FOWARDSLASH:
							case DASH:
							case COLON:
							case COMMA:
							case SEMICOLON:
							case OPENBRACES:
							case CLOSEBRACES: {
								break
							}
							default: {
								// current buffer has a colon
								if (pseudo > 0) {
									insert = 1
								}
							}
						}
					}

					// terminate line comment
					if (comment === FOWARDSLASH) {
						comment = 0
					} else if (cascade + context === 0) {
						format = 1
						chars += '\0'
					}

					// execute plugins, newline context
					if (plugged * unkwn > 0) {
						proxy(UNKWN, chars, current, parent, line, column, out.length, id, depth, id)
					}

					// next line, reset column position
					column = 1
					line++
					break
				}
				case SEMICOLON:
				case CLOSEBRACES: {
					if (comment + quote + parentheses + bracket === 0) {
						column++
						break
					}
				}
				default: {
					// increment column position
					column++

					// current character
					char = body.charAt(caret)

					// remove comments, escape functions, strings, attributes and prepare selectors
					switch (code) {
						case TAB:
						case SPACE: {
							if (quote + bracket + comment === 0) {
								switch (tail) {
									case COMMA:
									case COLON:
									case TAB:
									case SPACE: {
										char = ''
										break
									}
									default: {
										if (code !== SPACE) {
											char = ' '
										}
									}
								}
							}
							break
						}
						// escape breaking control characters
						case NULL: {
							char = '\\0'
							break
						}
						case FORMFEED: {
							char = '\\f'
							break
						}
						case VERTICALTAB: {
							char = '\\v'
							break
						}
						// &
						case AND: {
							// inverted selector pattern i.e html &
							if (quote + comment + bracket === 0 && cascade > 0) {
								invert = 1
								format = 1
								char = '\f' + char
							}
							break
						}
						// ::p<l>aceholder, l
						// :read-on<l>y, l
						case 108: {
							if (quote + comment + bracket + pattern === 0 && pseudo > 0) {
								switch (caret - pseudo) {
									// ::placeholder
									case 2: {
										if (tail === PLACEHOLDER && body.charCodeAt(caret-3) === COLON) {
											pattern = tail
										}
									}
									// :read-only
									case 8: {
										if (trail === READONLY) {
											pattern = trail
										}
									}
								}
							}
							break
						}
						// :<pattern>
						case COLON: {
							if (quote + comment + bracket === 0) {
								pseudo = caret
							}
							break
						}
						// selectors
						case COMMA: {
							if (comment + parentheses + quote + bracket === 0) {
								format = 1
								char += '\r'
							}
							break
						}
						// quotes
						case DOUBLEQUOTE: {
							if (comment === 0) {
								quote = quote === code ? 0 : (quote === 0 ? code : quote)
							}
							break
						}
						case SINGLEQUOTE: {
							if (comment === 0) {
								quote = quote === code ? 0 : (quote === 0 ? code : quote)
							}
							break
						}
						// attributes
						case OPENBRACKET: {
							if (quote + comment + parentheses === 0) {
								bracket++
							}
							break
						}
						case CLOSEBRACKET: {
							if (quote + comment + parentheses === 0) {
								bracket--
							}
							break
						}
						// functions
						case CLOSEPARENTHESES: {
							if (quote + comment + bracket === 0) {
								parentheses--
							}
							break
						}
						case OPENPARENTHESES: {
							if (quote + comment + bracket === 0) {
								if (context === 0) {
									switch (tail*2 + trail*3) {
										// :matches
										case 533: {
											break
										}
										// :global, :not, :nth-child etc...
										default: {
											counter = 0
											context = 1
										}
									}
								}

								parentheses++
							}
							break
						}
						case AT: {
							if (comment + parentheses + quote + bracket + pseudo + atrule === 0) {
								atrule = 1
							}
							break
						}
						// block/line comments
						case STAR:
						case FOWARDSLASH: {
							if (quote + bracket + parentheses > 0) {
								break
							}

							switch (comment) {
								// initialize line/block comment context
								case 0: {
									switch (code*2 + body.charCodeAt(caret+1)*3) {
										// //
										case 235: {
											comment = FOWARDSLASH
											break
										}
										// /*
										case 220: {
											length = caret
											comment = STAR
											break
										}
									}
									break
								}
								// end block comment context
								case STAR: {
									if (code === FOWARDSLASH && tail === STAR) {
										// /*<!> ... */, !
										if (body.charCodeAt(length+2) === 33) {
											out += body.substring(length, caret+1)
										}
										char = ''
										comment = 0
									}
								}
							}
						}
					}

					// ignore comment blocks
					if (comment === 0) {
						// aggressive isolation mode, divide each individual selector
						// including selectors in :not function but excluding selectors in :global function
						if (cascade + quote + bracket + atrule === 0 && id !== KEYFRAME && code !== SEMICOLON) {
							switch (code) {
								case COMMA:
								case TILDE:
								case GREATERTHAN:
								case PLUS:
								case CLOSEPARENTHESES:
								case OPENPARENTHESES: {
									if (context === 0) {
										// outside of an isolated context i.e nth-child(<...>)
										switch (tail) {
											case TAB:
											case SPACE:
											case NEWLINE:
											case CARRIAGE: {
												char = char + '\0'
												break
											}
											default: {
												char = '\0' + char + (code === COMMA ? '' : '\0')
											}
										}
										format = 1
									} else {
										// within an isolated context, sleep untill it's terminated
										switch (code) {
											case OPENPARENTHESES: {
												context = ++counter
												break
											}
											case CLOSEPARENTHESES: {
												if ((context = --counter) === 0) {
													format = 1
													char += '\0'
												}
												break
											}
										}
									}
									break
								}
								case TAB:
								case SPACE: {
									switch (tail) {
										case NULL:
										case OPENBRACES:
										case CLOSEBRACES:
										case SEMICOLON:
										case COMMA:
										case FORMFEED:
										case TAB:
										case SPACE:
										case NEWLINE:
										case CARRIAGE: {
											break
										}
										default: {
											// ignore in isolated contexts
											if (context === 0) {
												format = 1
												char += '\0'
											}
										}
									}
								}
							}
						}

						// concat buffer of characters
						chars += char

						// previous non-whitespace character code
						if (code !== SPACE && code !== TAB) {
							peak = code
						}
					}
				}
			}

			// tail character codes
			trail = tail
			tail = code

			// visit every character
			caret++
		}

		length = out.length

		// preserve empty selector
 		if (preserve > 0) {
 			if (length === 0 && children.length === 0 && (current[0].length === 0) === false) {
 				if (id !== MEDIA || (current.length === 1 && (cascade > 0 ? nscopealt : nscope) === current[0])) {
					length = current.join(',').length + 2
 				}
 			}
		}

		if (length > 0) {
			// cascade isolation mode?
			selector = cascade === 0 && id !== KEYFRAME ? isolate(current) : current

			// execute plugins, block context
			if (plugged > 0) {
				result = proxy(BLCKS, out, selector, parent, line, column, length, id, depth, id)

				if (result !== void 0 && (out = result).length === 0) {
					return flat + out + children
				}
			}

			out = selector.join(',') + '{' + out + '}'

			if (prefix*pattern !== 0) {
				if (prefix === 2 && !vendor(out, 2))
					pattern = 0

				switch (pattern) {
					// ::read-only
					case READONLY: {
						out = out.replace(readonlyptn, ':'+moz+'$1')+out
						break
					}
					// ::placeholder
					case PLACEHOLDER: {
						out = (
							out.replace(plcholdrptn, '::' + webkit + 'input-$1') +
							out.replace(plcholdrptn, '::' + moz + '$1') +
							out.replace(plcholdrptn, ':' + ms + 'input-$1') + out
						)
						break
					}
				}

				pattern = 0
			}
		}

		return flat + out + children
	}

	/**
	 * Select
	 *
	 * @param {Array<string>} parent
	 * @param {string} current
	 * @param {number} invert
	 * @return {Array<string>}
	 */
	function select (parent, current, invert) {
		var selectors = current.trim().split(selectorptn)
		var out = selectors

		var length = selectors.length
		var l = parent.length

		switch (l) {
			// 0-1 parent selectors
			case 0:
			case 1: {
				for (var i = 0, selector = l === 0 ? '' : parent[0] + ' '; i < length; ++i) {
					out[i] = scope(selector, out[i], invert, l).trim()
				}
				break
			}
			// >2 parent selectors, nested
			default: {
				for (var i = 0, j = 0, out = []; i < length; ++i) {
					for (var k = 0; k < l; ++k) {
						out[j++] = scope(parent[k] + ' ', selectors[i], invert, l).trim()
					}
				}
			}
		}

		return out
	}

	/**
	 * Scope
	 *
	 * @param {string} parent
	 * @param {string} current
	 * @param {number} invert
	 * @param {number} level
	 * @return {string}
	 */
	function scope (parent, current, invert, level) {
		var selector = current
		var code = selector.charCodeAt(0)

		// trim leading whitespace
		if (code < 33) {
			code = (selector = selector.trim()).charCodeAt(0)
		}

		switch (code) {
			// &
			case AND: {
				switch (cascade + level) {
					case 0:
					case 1: {
						if (parent.trim().length === 0) {
							break
						}
					}
					default: {
						return selector.replace(andptn, '$1'+parent.trim())
					}
				}
				break
			}
			// :
			case COLON: {
				switch (selector.charCodeAt(1)) {
					// g in :global
					case 103: {
						if (escape > 0 && cascade > 0) {
							return selector.replace(escapeptn, '$1').replace(andptn, '$1'+nscope)
						}
						break
					}
					default: {
						// :hover
						return parent.trim() + selector.replace(andptn, '$1'+parent.trim())
					}
				}
			}
			default: {
				// html &
				if (invert*cascade > 0 && selector.indexOf('\f') > 0) {
					return selector.replace(andptn, (parent.charCodeAt(0) === COLON ? '' : '$1')+parent.trim())
				}
			}
		}

		return parent + selector
	}

	/**
	 * Property
	 *
	 * @param {string} input
	 * @param {number} first
	 * @param {number} second
	 * @param {number} third
	 * @return {string}
	 */
	function property (input, first, second, third) {
		var index = 0
		var out = input + ';'
		var hash = (first*2) + (second*3) + (third*4)
		var cache

		// animation: a, n, i characters
		if (hash === 944) {
			return animation(out)
		} else if (prefix === 0 || (prefix === 2 && !vendor(out, 1))) {
			return out
		}

		// vendor prefix
		switch (hash) {
			// text-decoration/text-size-adjust/text-shadow/text-align/text-transform: t, e, x
			case 1015: {
				// text-shadow/text-align/text-transform, a
				return out.charCodeAt(10) === 97 ? webkit + out + out : out
			}
			// filter/fill f, i, l
			case 951: {
				// filter, t
				return out.charCodeAt(3) === 116 ? webkit + out + out : out
			}
			// color/column, c, o, l
			case 963: {
				// column, n
				return out.charCodeAt(5) === 110 ? webkit + out + out : out
			}
			// box-decoration-break, b, o, x
			case 1009: {
				if (out.charCodeAt(4) !== 100) {
					break
				}
			}
			// mask, m, a, s
			// clip-path, c, l, i
			case 969:
			case 942: {
				return webkit + out + out
			}
			// appearance: a, p, p
			case 978: {
				return webkit + out + moz + out + out
			}
			// hyphens: h, y, p
			// user-select: u, s, e
			case 1019:
			case 983: {
				return webkit + out + moz + out + ms + out + out
			}
			// background/backface-visibility, b, a, c
			case 883: {
				// backface-visibility, -
				return out.charCodeAt(8) === DASH ? webkit + out + out : out
			}
			// flex: f, l, e
			case 932: {
				if (out.charCodeAt(4) === DASH) {
					switch (out.charCodeAt(5)) {
						// flex-grow, g
						case 103: {
							return webkit + 'box-' + out.replace('-grow', '') + webkit + out + ms + out.replace('grow', 'positive') + out
						}
						// flex-shrink, s
						case 115: {
							return webkit + out + ms + out.replace('shrink', 'negative') + out
						}
						// flex-basis, b
						case 98: {
							return webkit + out + ms + out.replace('basis', 'preferred-size') + out
						}
					}
				}

				return webkit + out + ms + out + out
			}
			// order: o, r, d
			case 964: {
				return webkit + out + ms + 'flex' + '-' + out + out
			}
			// justify-items/justify-content, j, u, s
			case 1023: {
				// justify-content, c
				if (out.charCodeAt(8) !== 99) {
					break
				}

				cache = out.substring(out.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify')
				return webkit + 'box-pack' + cache + webkit + out + ms + 'flex-pack' + cache + out
			}
			// cursor, c, u, r
			case 1005: {
				return cursorptn.test(out) ? out.replace(colonptn, ':' + webkit) + out.replace(colonptn, ':' + moz) + out : out
			}
			// writing-mode, w, r, i
			case 1000: {
				cache = out.substring(13).trim()
				index = cache.indexOf('-') + 1

				switch (cache.charCodeAt(0)+cache.charCodeAt(index)) {
					// vertical-lr
					case 226: {
						cache = out.replace(writingptn, 'tb')
						break
					}
					// vertical-rl
					case 232: {
						cache = out.replace(writingptn, 'tb-rl')
						break
					}
					// horizontal-tb
					case 220: {
						cache = out.replace(writingptn, 'lr')
						break
					}
					default: {
						return out
					}
				}

				return webkit + out + ms + cache + out
			}
			// position: sticky
			case 1017: {
				if (out.indexOf('sticky', 9) === -1) {
					return out
				}
			}
			// display(flex/inline-flex/inline-box): d, i, s
			case 975: {
				index = (out = input).length - 10
				cache = (out.charCodeAt(index) === 33 ? out.substring(0, index) : out).substring(input.indexOf(':', 7) + 1).trim()

				switch (hash = cache.charCodeAt(0) + (cache.charCodeAt(7)|0)) {
					// inline-
					case 203: {
						// inline-box
						if (cache.charCodeAt(8) < 111) {
							break
						}
					}
					// inline-box/sticky
					case 115: {
						out = out.replace(cache, webkit+cache)+';'+out
						break
					}
					// inline-flex
					// flex
					case 207:
					case 102: {
						out = (
							out.replace(cache, webkit+(hash > 102 ? 'inline-' : '')+'box')+';'+
							out.replace(cache, webkit+cache)+';'+
							out.replace(cache, ms+cache+'box')+';'+
							out
						)
					}
				}

				return out + ';'
			}
			// align-items, align-center, align-self: a, l, i, -
			case 938: {
				if (out.charCodeAt(5) === DASH) {
					switch (out.charCodeAt(6)) {
						// align-items, i
						case 105: {
							cache = out.replace('-items', '')
							return webkit + out + webkit + 'box-' + cache + ms + 'flex-' + cache + out
						}
						// align-self, s
						case 115: {
							return webkit + out + ms + 'flex-item-' + out.replace(selfptn, '') + out
						}
						// align-content
						default: {
							return webkit + out + ms + 'flex-line-pack' + out.replace('align-content', '').replace(selfptn, '') + out
						}
					}
				}
				break
			}
			// min/max
			case 973:
			case 989: {
				// min-/max- height/width/block-size/inline-size
				if (out.charCodeAt(3) !== DASH || out.charCodeAt(4) === 122) {
					break
				}
			}
			// height/width: min-content / width: max-content
			case 931:
			case 953: {
				if (dimensionptn.test(input) === true) {
					// stretch
					if ((cache = input.substring(input.indexOf(':') + 1)).charCodeAt(0) === 115)
						return property(input.replace('stretch', 'fill-available'), first, second, third).replace(':fill-available', ':stretch')
					else
						return out.replace(cache, webkit + cache) + out.replace(cache, moz + cache.replace('fill-', '')) + out
				}
				break
			}
			// transform, transition: t, r, a
			case 962: {
				out = webkit + out + (out.charCodeAt(5) === 102 ? ms + out : '') + out

				// transitions
				if (second + third === 211 && out.charCodeAt(13) === 105 && out.indexOf('transform', 10) > 0) {
					return out.substring(0, out.indexOf(';', 27) + 1).replace(transformptn, '$1' + webkit + '$2') + out
				}

				break
			}
		}

		return out
	}

	/**
	 * Vendor
	 *
	 * @param {string} content
	 * @param {number} context
	 * @return {boolean}
	 */
	function vendor (content, context) {
		var index = content.indexOf(context === 1 ? ':' : '{')
		var key = content.substring(0, context !== 3 ? index : 10)
		var value = content.substring(index + 1, content.length - 1)

		return should(context !== 2 ? key : key.replace(pseudofmt, '$1'), value, context)
	}

	/**
	 * Supports
	 *
	 * @param {string} match
	 * @param {string} group
	 * @return {string}
	 */
	function supports (match, group) {
		var out = property(group, group.charCodeAt(0), group.charCodeAt(1), group.charCodeAt(2))

		return out !== group+';' ? out.replace(propertyptn, ' or ($1)').substring(4) : '('+group+')'
	}

	/**
	 * Animation
	 *
	 * @param {string} input
	 * @return {string}
	 */
	function animation (input) {
		var length = input.length
		var index = input.indexOf(':', 9) + 1
		var declare = input.substring(0, index).trim()
		var out = input.substring(index, length-1).trim()

		switch (input.charCodeAt(9)*keyed) {
			case 0: {
				break
			}
			// animation-*, -
			case DASH: {
				// animation-name, n
				if (input.charCodeAt(10) !== 110) {
					break
				}
			}
			// animation/animation-name
			default: {
				// split in case of multiple animations
				var list = out.split((out = '', animationptn))

				for (var i = 0, index = 0, length = list.length; i < length; index = 0, ++i) {
					var value = list[i]
					var items = value.split(propertiesptn)

					while (value = items[index]) {
						var peak = value.charCodeAt(0)

						if (keyed === 1 && (
							// letters
							(peak > AT && peak < 90) || (peak > 96 && peak < 123) || peak === UNDERSCORE ||
							// dash but not in sequence i.e --
							(peak === DASH && value.charCodeAt(1) !== DASH)
						)) {
							// not a number/function
							switch (isNaN(parseFloat(value)) + (value.indexOf('(') !== -1)) {
								case 1: {
									switch (value) {
										// not a valid reserved keyword
										case 'infinite': case 'alternate': case 'backwards': case 'running':
										case 'normal': case 'forwards': case 'both': case 'none': case 'linear':
										case 'ease': case 'ease-in': case 'ease-out': case 'ease-in-out':
										case 'paused': case 'reverse': case 'alternate-reverse': case 'inherit':
										case 'initial': case 'unset': case 'step-start': case 'step-end': {
											break
										}
										default: {
											value += key
										}
									}
								}
							}
						}

						items[index++] = value
					}

					out += (i === 0 ? '' : ',') + items.join(' ')
				}
			}
		}

		out = declare + out + ';'

		if (prefix === 1 || (prefix === 2 && vendor(out, 1)))
			return webkit + out + out

		return out
	}

	/**
	 * Isolate
	 *
	 * @param {Array<string>} current
	 */
	function isolate (current) {
		for (var i = 0, length = current.length, selector = Array(length), padding, element; i < length; ++i) {
			// split individual elements in a selector i.e h1 h2 === [h1, h2]
			var elements = current[i].split(elementptn)
			var out = ''

			for (var j = 0, size = 0, tail = 0, code = 0, l = elements.length; j < l; ++j) {
				// empty element
				if ((size = (element = elements[j]).length) === 0 && l > 1) {
					continue
				}

				tail = out.charCodeAt(out.length-1)
				code = element.charCodeAt(0)
				padding = ''

				if (j !== 0) {
					// determine if we need padding
					switch (tail) {
						case STAR:
						case TILDE:
						case GREATERTHAN:
						case PLUS:
						case SPACE:
						case OPENPARENTHESES:  {
							break
						}
						default: {
							padding = ' '
						}
					}
				}

				switch (code) {
					case AND: {
						element = padding + nscopealt
					}
					case TILDE:
					case GREATERTHAN:
					case PLUS:
					case SPACE:
					case CLOSEPARENTHESES:
					case OPENPARENTHESES: {
						break
					}
					case OPENBRACKET: {
						element = padding + element + nscopealt
						break
					}
					case COLON: {
						switch (element.charCodeAt(1)*2 + element.charCodeAt(2)*3) {
							// :global
							case 530: {
								if (escape > 0) {
									element = padding + element.substring(8, size - 1)
									break
								}
							}
							// :hover, :nth-child(), ...
							default: {
								if (j < 1 || elements[j-1].length < 1) {
									element = padding + nscopealt + element
								}
							}
						}
						break
					}
					case COMMA: {
						padding = ''
					}
					default: {
						if (size > 1 && element.indexOf(':') > 0) {
							element = padding + element.replace(pseudoptn, '$1' + nscopealt + '$2')
						} else {
							element = padding + element + nscopealt
						}
					}
				}

				out += element
			}

			selector[i] = out.replace(formatptn, '').trim()
		}

		return selector
	}

	/**
	 * Proxy
	 *
	 * @param {number} context
	 * @param {string} content
	 * @param {Array<string>} selectors
	 * @param {Array<string>} parents
	 * @param {number} line
	 * @param {number} column
	 * @param {number} length
	 * @param {number} id
	 * @param {number} depth
	 * @param {number} at
	 * @return {(string|void|*)}
	 */
	function proxy (context, content, selectors, parents, line, column, length, id, depth, at) {
		for (var i = 0, out = content, next; i < plugged; ++i) {
			switch (next = plugins[i].call(stylis, context, out, selectors, parents, line, column, length, id, depth, at)) {
				case void 0:
				case false:
				case true:
				case null: {
					break
				}
				default: {
					out = next
				}
			}
		}

		switch (out) {
			case void 0:
			case false:
			case true:
			case null:
			case content: {
				break
			}
			default: {
				return out
			}
		}
	}

	/**
	 * Minify
	 *
	 * @param {(string|*)} output
	 * @return {string}
	 */
	function minify (output) {
		return output
			.replace(formatptn, '')
			.replace(beforeptn, '')
			.replace(afterptn, '$1')
			.replace(tailptn, '$1')
			.replace(whiteptn, ' ')
	}

	/**
	 * Use
	 *
	 * @param {(Array<function(...?)>|function(...?)|number|void)?} plugin
	 */
	function use (plugin) {
		switch (plugin) {
			case void 0:
			case null: {
				plugged = plugins.length = 0
				break
			}
			default: {
				switch (plugin.constructor) {
					case Array: {
						for (var i = 0, length = plugin.length; i < length; ++i) {
							use(plugin[i])
						}
						break
					}
					case Function: {
						plugins[plugged++] = plugin
						break
					}
					case Boolean: {
						unkwn = !!plugin|0
					}
				}
			}
 		}

 		return use
	}

	/**
	 * Set
	 *
	 * @param {*} options
	 */
	function set (options) {
		for (var name in options) {
			var value = options[name]
			switch (name) {
				case 'keyframe': keyed = value|0; break
				case 'global': escape = value|0; break
				case 'cascade': cascade = value|0; break
				case 'compress': compress = value|0; break
				case 'semicolon': semicolon = value|0; break
				case 'preserve': preserve = value|0; break
				case 'prefix':
					should = null

					if (!value) {
						prefix = 0
					} else if (typeof value !== 'function') {
						prefix = 1
					} else {
						prefix = 2
						should = value
					}
			}
		}

		return set
	}

	/**
	 * Stylis
	 *
	 * @param {string} selector
	 * @param {string} input
	 * @return {*}
	 */
	function stylis (selector, input) {
		if (this !== void 0 && this.constructor === stylis) {
			return factory(selector)
		}

		// setup
		var ns = selector
		var code = ns.charCodeAt(0)

		// trim leading whitespace
		if (code < 33) {
			code = (ns = ns.trim()).charCodeAt(0)
		}

		// keyframe/animation namespace
		if (keyed > 0) {
			key = ns.replace(invalidptn, code === OPENBRACKET ? '' : '-')
		}

		// reset, used to assert if a plugin is moneky-patching the return value
		code = 1

		// cascade/isolate
		if (cascade === 1) {
			nscope = ns
		} else {
			nscopealt = ns
		}

		var selectors = [nscope]
		var result

		// execute plugins, pre-process context
		if (plugged > 0) {
			result = proxy(PREPS, input, selectors, selectors, line, column, 0, 0, 0, 0)

			if (result !== void 0 && typeof result === 'string') {
				input = result
			}
		}

		// build
		var output = compile(array, selectors, input, 0, 0)

		// execute plugins, post-process context
		if (plugged > 0) {
			result = proxy(POSTS, output, selectors, selectors, line, column, output.length, 0, 0, 0)

			// bypass minification
			if (result !== void 0 && typeof(output = result) !== 'string') {
				code = 0
			}
		}

		// reset
		key = ''
		nscope = ''
		nscopealt = ''
		pattern = 0
		line = 1
		column = 1

		return compress*code === 0 ? output : minify(output)
	}

	stylis['use'] = use
	stylis['set'] = set

	if (options !== void 0) {
		set(options)
	}

	return stylis
}));


/***/ }),

/***/ "../node_modules/deep-equal/index.js":
/***/ (function(module, exports, __webpack_require__) {

var pSlice = Array.prototype.slice;
var objectKeys = __webpack_require__("../node_modules/deep-equal/lib/keys.js");
var isArguments = __webpack_require__("../node_modules/deep-equal/lib/is_arguments.js");

var deepEqual = module.exports = function (actual, expected, opts) {
  if (!opts) opts = {};
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;

  } else if (actual instanceof Date && expected instanceof Date) {
    return actual.getTime() === expected.getTime();

  // 7.3. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
    return opts.strict ? actual === expected : actual == expected;

  // 7.4. For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else {
    return objEquiv(actual, expected, opts);
  }
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer (x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') return false;
  return true;
}

function objEquiv(a, b, opts) {
  var i, key;
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
    return false;
  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) return false;
  //~~~I've managed to break Object.keys through screwy arguments passing.
  //   Converting to array solves the problem.
  if (isArguments(a)) {
    if (!isArguments(b)) {
      return false;
    }
    a = pSlice.call(a);
    b = pSlice.call(b);
    return deepEqual(a, b, opts);
  }
  if (isBuffer(a)) {
    if (!isBuffer(b)) {
      return false;
    }
    if (a.length !== b.length) return false;
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }
  try {
    var ka = objectKeys(a),
        kb = objectKeys(b);
  } catch (e) {//happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length != kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) return false;
  }
  return typeof a === typeof b;
}


/***/ }),

/***/ "../node_modules/deep-equal/lib/is_arguments.js":
/***/ (function(module, exports) {

var supportsArgumentsClass = (function(){
  return Object.prototype.toString.call(arguments)
})() == '[object Arguments]';

exports = module.exports = supportsArgumentsClass ? supported : unsupported;

exports.supported = supported;
function supported(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
};

exports.unsupported = unsupported;
function unsupported(object){
  return object &&
    typeof object == 'object' &&
    typeof object.length == 'number' &&
    Object.prototype.hasOwnProperty.call(object, 'callee') &&
    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
    false;
};


/***/ }),

/***/ "../node_modules/deep-equal/lib/keys.js":
/***/ (function(module, exports) {

exports = module.exports = typeof Object.keys === 'function'
  ? Object.keys : shim;

exports.shim = shim;
function shim (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
}


/***/ }),

/***/ "../node_modules/dompurify/dist/purify.js":
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.DOMPurify = factory());
}(this, (function () { 'use strict';

var html = ['a', 'abbr', 'acronym', 'address', 'area', 'article', 'aside', 'audio', 'b', 'bdi', 'bdo', 'big', 'blink', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'center', 'cite', 'code', 'col', 'colgroup', 'content', 'data', 'datalist', 'dd', 'decorator', 'del', 'details', 'dfn', 'dir', 'div', 'dl', 'dt', 'element', 'em', 'fieldset', 'figcaption', 'figure', 'font', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'img', 'input', 'ins', 'kbd', 'label', 'legend', 'li', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meter', 'nav', 'nobr', 'ol', 'optgroup', 'option', 'output', 'p', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'section', 'select', 'shadow', 'small', 'source', 'spacer', 'span', 'strike', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'tt', 'u', 'ul', 'var', 'video', 'wbr'];

// SVG
var svg = ['svg', 'a', 'altglyph', 'altglyphdef', 'altglyphitem', 'animatecolor', 'animatemotion', 'animatetransform', 'audio', 'canvas', 'circle', 'clippath', 'defs', 'desc', 'ellipse', 'filter', 'font', 'g', 'glyph', 'glyphref', 'hkern', 'image', 'line', 'lineargradient', 'marker', 'mask', 'metadata', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialgradient', 'rect', 'stop', 'style', 'switch', 'symbol', 'text', 'textpath', 'title', 'tref', 'tspan', 'video', 'view', 'vkern'];

var svgFilters = ['feBlend', 'feColorMatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'feSpecularLighting', 'feTile', 'feTurbulence'];

var mathMl = ['math', 'menclose', 'merror', 'mfenced', 'mfrac', 'mglyph', 'mi', 'mlabeledtr', 'mmuliscripts', 'mn', 'mo', 'mover', 'mpadded', 'mphantom', 'mroot', 'mrow', 'ms', 'mpspace', 'msqrt', 'mystyle', 'msub', 'msup', 'msubsup', 'mtable', 'mtd', 'mtext', 'mtr', 'munder', 'munderover'];

var text = ['#text'];

var html$1 = ['accept', 'action', 'align', 'alt', 'autocomplete', 'background', 'bgcolor', 'border', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'clear', 'color', 'cols', 'colspan', 'coords', 'datetime', 'default', 'dir', 'disabled', 'download', 'enctype', 'face', 'for', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'id', 'ismap', 'label', 'lang', 'list', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'multiple', 'name', 'noshade', 'novalidate', 'nowrap', 'open', 'optimum', 'pattern', 'placeholder', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'rev', 'reversed', 'role', 'rows', 'rowspan', 'spellcheck', 'scope', 'selected', 'shape', 'size', 'span', 'srclang', 'start', 'src', 'step', 'style', 'summary', 'tabindex', 'title', 'type', 'usemap', 'valign', 'value', 'width', 'xmlns'];

var svg$1 = ['accent-height', 'accumulate', 'additivive', 'alignment-baseline', 'ascent', 'attributename', 'attributetype', 'azimuth', 'basefrequency', 'baseline-shift', 'begin', 'bias', 'by', 'class', 'clip', 'clip-path', 'clip-rule', 'color', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'cx', 'cy', 'd', 'dx', 'dy', 'diffuseconstant', 'direction', 'display', 'divisor', 'dur', 'edgemode', 'elevation', 'end', 'fill', 'fill-opacity', 'fill-rule', 'filter', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'fx', 'fy', 'g1', 'g2', 'glyph-name', 'glyphref', 'gradientunits', 'gradienttransform', 'height', 'href', 'id', 'image-rendering', 'in', 'in2', 'k', 'k1', 'k2', 'k3', 'k4', 'kerning', 'keypoints', 'keysplines', 'keytimes', 'lang', 'lengthadjust', 'letter-spacing', 'kernelmatrix', 'kernelunitlength', 'lighting-color', 'local', 'marker-end', 'marker-mid', 'marker-start', 'markerheight', 'markerunits', 'markerwidth', 'maskcontentunits', 'maskunits', 'max', 'mask', 'media', 'method', 'mode', 'min', 'name', 'numoctaves', 'offset', 'operator', 'opacity', 'order', 'orient', 'orientation', 'origin', 'overflow', 'paint-order', 'path', 'pathlength', 'patterncontentunits', 'patterntransform', 'patternunits', 'points', 'preservealpha', 'r', 'rx', 'ry', 'radius', 'refx', 'refy', 'repeatcount', 'repeatdur', 'restart', 'result', 'rotate', 'scale', 'seed', 'shape-rendering', 'specularconstant', 'specularexponent', 'spreadmethod', 'stddeviation', 'stitchtiles', 'stop-color', 'stop-opacity', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke', 'stroke-width', 'style', 'surfacescale', 'tabindex', 'targetx', 'targety', 'transform', 'text-anchor', 'text-decoration', 'text-rendering', 'textlength', 'type', 'u1', 'u2', 'unicode', 'values', 'viewbox', 'visibility', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'width', 'word-spacing', 'wrap', 'writing-mode', 'xchannelselector', 'ychannelselector', 'x', 'x1', 'x2', 'xmlns', 'y', 'y1', 'y2', 'z', 'zoomandpan'];

var mathMl$1 = ['accent', 'accentunder', 'align', 'bevelled', 'close', 'columnsalign', 'columnlines', 'columnspan', 'denomalign', 'depth', 'dir', 'display', 'displaystyle', 'fence', 'frame', 'height', 'href', 'id', 'largeop', 'length', 'linethickness', 'lspace', 'lquote', 'mathbackground', 'mathcolor', 'mathsize', 'mathvariant', 'maxsize', 'minsize', 'movablelimits', 'notation', 'numalign', 'open', 'rowalign', 'rowlines', 'rowspacing', 'rowspan', 'rspace', 'rquote', 'scriptlevel', 'scriptminsize', 'scriptsizemultiplier', 'selection', 'separator', 'separators', 'stretchy', 'subscriptshift', 'supscriptshift', 'symmetric', 'voffset', 'width', 'xmlns'];

var xml = ['xlink:href', 'xml:id', 'xlink:title', 'xml:space', 'xmlns:xlink'];

/* Add properties to a lookup table */
function addToSet(set, array) {
  var l = array.length;
  while (l--) {
    if (typeof array[l] === 'string') {
      array[l] = array[l].toLowerCase();
    }
    set[array[l]] = true;
  }
  return set;
}

/* Shallow clone an object */
function clone(object) {
  var newObject = {};
  var property = void 0;
  for (property in object) {
    if (Object.prototype.hasOwnProperty.call(object, property)) {
      newObject[property] = object[property];
    }
  }
  return newObject;
}

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var getGlobal = function getGlobal() {
  return typeof window === 'undefined' ? null : window;
};

function createDOMPurify() {
  var window = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();

  var DOMPurify = function DOMPurify(root) {
    return createDOMPurify(root);
  };

  /**
      * Version label, exposed for easier checks
      * if DOMPurify is up to date or not
      */
  DOMPurify.version = '1.0.2';

  /**
    * Array of elements that DOMPurify removed during sanitation.
    * Empty if nothing was removed.
    */
  DOMPurify.removed = [];

  if (!window || !window.document || window.document.nodeType !== 9) {
    // Not running in a browser, provide a factory function
    // so that you can pass your own Window
    DOMPurify.isSupported = false;

    return DOMPurify;
  }

  var originalDocument = window.document;
  var useDOMParser = false; // See comment below
  var useXHR = false;

  var document = window.document;
  var DocumentFragment = window.DocumentFragment,
      HTMLTemplateElement = window.HTMLTemplateElement,
      Node = window.Node,
      NodeFilter = window.NodeFilter,
      _window$NamedNodeMap = window.NamedNodeMap,
      NamedNodeMap = _window$NamedNodeMap === undefined ? window.NamedNodeMap || window.MozNamedAttrMap : _window$NamedNodeMap,
      Text = window.Text,
      Comment = window.Comment,
      DOMParser = window.DOMParser,
      _window$XMLHttpReques = window.XMLHttpRequest,
      XMLHttpRequest = _window$XMLHttpReques === undefined ? window.XMLHttpRequest : _window$XMLHttpReques,
      _window$encodeURI = window.encodeURI,
      encodeURI = _window$encodeURI === undefined ? window.encodeURI : _window$encodeURI;

  // As per issue #47, the web-components registry is inherited by a
  // new document created via createHTMLDocument. As per the spec
  // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
  // a new empty registry is used when creating a template contents owner
  // document, so we use that as our parent document to ensure nothing
  // is inherited.

  if (typeof HTMLTemplateElement === 'function') {
    var template = document.createElement('template');
    if (template.content && template.content.ownerDocument) {
      document = template.content.ownerDocument;
    }
  }

  var _document = document,
      implementation = _document.implementation,
      createNodeIterator = _document.createNodeIterator,
      getElementsByTagName = _document.getElementsByTagName,
      createDocumentFragment = _document.createDocumentFragment;

  var importNode = originalDocument.importNode;

  var hooks = {};

  /**
    * Expose whether this browser supports running the full DOMPurify.
    */
  DOMPurify.isSupported = implementation && typeof implementation.createHTMLDocument !== 'undefined' && document.documentMode !== 9;

  /**
    * We consider the elements and attributes below to be safe. Ideally
    * don't add any new ones but feel free to remove unwanted ones.
    */

  /* allowed element names */
  var ALLOWED_TAGS = null;
  var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(svgFilters), _toConsumableArray(mathMl), _toConsumableArray(text)));

  /* Allowed attribute names */
  var ALLOWED_ATTR = null;
  var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(mathMl$1), _toConsumableArray(xml)));

  /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */
  var FORBID_TAGS = null;

  /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */
  var FORBID_ATTR = null;

  /* Decide if ARIA attributes are okay */
  var ALLOW_ARIA_ATTR = true;

  /* Decide if custom data attributes are okay */
  var ALLOW_DATA_ATTR = true;

  /* Decide if unknown protocols are okay */
  var ALLOW_UNKNOWN_PROTOCOLS = false;

  /* Output should be safe for jQuery's $() factory? */
  var SAFE_FOR_JQUERY = false;

  /* Output should be safe for common template engines.
   * This means, DOMPurify removes data attributes, mustaches and ERB
   */
  var SAFE_FOR_TEMPLATES = false;

  /* Specify template detection regex for SAFE_FOR_TEMPLATES mode */
  var MUSTACHE_EXPR = /\{\{[\s\S]*|[\s\S]*\}\}/gm;
  var ERB_EXPR = /<%[\s\S]*|[\s\S]*%>/gm;

  /* Decide if document with <html>... should be returned */
  var WHOLE_DOCUMENT = false;

  /* Track whether config is already set on this instance of DOMPurify. */
  var SET_CONFIG = false;

  /* Decide if all elements (e.g. style, script) must be children of
   * document.body. By default, browsers might move them to document.head */
  var FORCE_BODY = false;

  /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html string.
   * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
   */
  var RETURN_DOM = false;

  /* Decide if a DOM `DocumentFragment` should be returned, instead of a html string */
  var RETURN_DOM_FRAGMENT = false;

  /* If `RETURN_DOM` or `RETURN_DOM_FRAGMENT` is enabled, decide if the returned DOM
   * `Node` is imported into the current `Document`. If this flag is not enabled the
   * `Node` will belong (its ownerDocument) to a fresh `HTMLDocument`, created by
   * DOMPurify. */
  var RETURN_DOM_IMPORT = false;

  /* Output should be free from DOM clobbering attacks? */
  var SANITIZE_DOM = true;

  /* Keep element content when removing element? */
  var KEEP_CONTENT = true;

  /* Allow usage of profiles like html, svg and mathMl */
  var USE_PROFILES = {};

  /* Tags to ignore content of when KEEP_CONTENT is true */
  var FORBID_CONTENTS = addToSet({}, ['audio', 'head', 'math', 'script', 'style', 'template', 'svg', 'video']);

  /* Tags that are safe for data: URIs */
  var DATA_URI_TAGS = addToSet({}, ['audio', 'video', 'img', 'source', 'image']);

  /* Attributes safe for values like "javascript:" */
  var URI_SAFE_ATTRIBUTES = addToSet({}, ['alt', 'class', 'for', 'id', 'label', 'name', 'pattern', 'placeholder', 'summary', 'title', 'value', 'style', 'xmlns']);

  /* Keep a reference to config to pass to hooks */
  var CONFIG = null;

  /* Ideally, do not touch anything below this line */
  /* ______________________________________________ */

  var formElement = document.createElement('form');

  /**
  * _parseConfig
  *
  * @param  optional config literal
  */
  // eslint-disable-next-line complexity
  var _parseConfig = function _parseConfig(cfg) {
    /* Shield configuration object from tampering */
    if ((typeof cfg === 'undefined' ? 'undefined' : _typeof(cfg)) !== 'object') {
      cfg = {};
    }

    /* Set configuration parameters */
    ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS) : DEFAULT_ALLOWED_TAGS;
    ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR) : DEFAULT_ALLOWED_ATTR;
    FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS) : {};
    FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR) : {};
    USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
    ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
    ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
    ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
    SAFE_FOR_JQUERY = cfg.SAFE_FOR_JQUERY || false; // Default false
    SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
    WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
    RETURN_DOM = cfg.RETURN_DOM || false; // Default false
    RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
    RETURN_DOM_IMPORT = cfg.RETURN_DOM_IMPORT || false; // Default false
    FORCE_BODY = cfg.FORCE_BODY || false; // Default false
    SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
    KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true

    if (SAFE_FOR_TEMPLATES) {
      ALLOW_DATA_ATTR = false;
    }

    if (RETURN_DOM_FRAGMENT) {
      RETURN_DOM = true;
    }

    /* Parse profile info */
    if (USE_PROFILES) {
      ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(text)));
      ALLOWED_ATTR = [];
      if (USE_PROFILES.html === true) {
        addToSet(ALLOWED_TAGS, html);
        addToSet(ALLOWED_ATTR, html$1);
      }
      if (USE_PROFILES.svg === true) {
        addToSet(ALLOWED_TAGS, svg);
        addToSet(ALLOWED_ATTR, svg$1);
        addToSet(ALLOWED_ATTR, xml);
      }
      if (USE_PROFILES.svgFilters === true) {
        addToSet(ALLOWED_TAGS, svgFilters);
        addToSet(ALLOWED_ATTR, svg$1);
        addToSet(ALLOWED_ATTR, xml);
      }
      if (USE_PROFILES.mathMl === true) {
        addToSet(ALLOWED_TAGS, mathMl);
        addToSet(ALLOWED_ATTR, mathMl$1);
        addToSet(ALLOWED_ATTR, xml);
      }
    }

    /* Merge configuration parameters */
    if (cfg.ADD_TAGS) {
      if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
        ALLOWED_TAGS = clone(ALLOWED_TAGS);
      }
      addToSet(ALLOWED_TAGS, cfg.ADD_TAGS);
    }
    if (cfg.ADD_ATTR) {
      if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
        ALLOWED_ATTR = clone(ALLOWED_ATTR);
      }
      addToSet(ALLOWED_ATTR, cfg.ADD_ATTR);
    }
    if (cfg.ADD_URI_SAFE_ATTR) {
      addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR);
    }

    /* Add #text in case KEEP_CONTENT is set to true */
    if (KEEP_CONTENT) {
      ALLOWED_TAGS['#text'] = true;
    }

    // Prevent further manipulation of configuration.
    // Not available in IE8, Safari 5, etc.
    if (Object && 'freeze' in Object) {
      Object.freeze(cfg);
    }

    CONFIG = cfg;
  };

  /**
  * _forceRemove
  *
  * @param  a DOM node
  */
  var _forceRemove = function _forceRemove(node) {
    DOMPurify.removed.push({ element: node });
    try {
      node.parentNode.removeChild(node);
    } catch (err) {
      node.outerHTML = '';
    }
  };

  /**
  * _removeAttribute
  *
  * @param  an Attribute name
  * @param  a DOM node
  */
  var _removeAttribute = function _removeAttribute(name, node) {
    DOMPurify.removed.push({
      attribute: node.getAttributeNode(name),
      from: node
    });
    node.removeAttribute(name);
  };

  /**
  * _initDocument
  *
  * @param  a string of dirty markup
  * @return a DOM, filled with the dirty markup
  */
  var _initDocument = function _initDocument(dirty) {
    /* Create a HTML document */
    var doc = void 0;
    var body = void 0;

    if (FORCE_BODY) {
      dirty = '<remove></remove>' + dirty;
    }

    /* Use XHR if necessary because Safari 10.1 and newer are buggy */
    if (useXHR) {
      try {
        dirty = encodeURI(dirty);
      } catch (err) {}
      var xhr = new XMLHttpRequest();
      xhr.responseType = 'document';
      xhr.open('GET', 'data:text/html;charset=utf-8,' + dirty, false);
      xhr.send(null);
      doc = xhr.response;
    }

    /* Use DOMParser to workaround Firefox bug (see comment below) */
    if (useDOMParser) {
      try {
        doc = new DOMParser().parseFromString(dirty, 'text/html');
      } catch (err) {}
    }

    /* Otherwise use createHTMLDocument, because DOMParser is unsafe in
    Safari (see comment below) */
    if (!doc || !doc.documentElement) {
      doc = implementation.createHTMLDocument('');
      body = doc.body;
      body.parentNode.removeChild(body.parentNode.firstElementChild);
      body.outerHTML = dirty;
    }

    /* Work on whole document or just its body */
    return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
  };

  // Safari 10.1+ (unfixed as of time of writing) has a catastrophic bug in
  // its implementation of DOMParser such that the following executes the
  // JavaScript:
  //
  // new DOMParser()
  //   .parseFromString('<svg onload=alert(document.domain)>', 'text/html');
  //
  // Later, it was also noticed that even more assumed benign and inert ways
  // of creating a document are now insecure thanks to Safari. So we work
  // around that with a feature test and use XHR to create the document in
  // case we really have to. That one seems safe for now.
  //
  // However, Firefox uses a different parser for innerHTML rather than
  // DOMParser (see https://bugzilla.mozilla.org/show_bug.cgi?id=1205631)
  // which means that you *must* use DOMParser, otherwise the output may
  // not be safe if used in a document.write context later.
  //
  // So we feature detect the Firefox bug and use the DOMParser if necessary.
  if (DOMPurify.isSupported) {
    (function () {
      var doc = _initDocument('<svg><g onload="this.parentNode.remove()"></g></svg>');
      if (!doc.querySelector('svg')) {
        useXHR = true;
      }
      try {
        doc = _initDocument('<svg><p><style><img src="</style><img src=x onerror=alert(1)//">');
        if (doc.querySelector('svg img')) {
          useDOMParser = true;
        }
      } catch (err) {}
    })();
  }

  /**
  * _createIterator
  *
  * @param  document/fragment to create iterator for
  * @return iterator instance
  */
  var _createIterator = function _createIterator(root) {
    return createNodeIterator.call(root.ownerDocument || root, root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT, function () {
      return NodeFilter.FILTER_ACCEPT;
    }, false);
  };

  /**
  * _isClobbered
  *
  * @param  element to check for clobbering attacks
  * @return true if clobbered, false if safe
  */
  var _isClobbered = function _isClobbered(elm) {
    if (elm instanceof Text || elm instanceof Comment) {
      return false;
    }
    if (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function') {
      return true;
    }
    return false;
  };

  /**
  * _isNode
  *
  * @param object to check whether it's a DOM node
  * @return true is object is a DOM node
  */
  var _isNode = function _isNode(obj) {
    return (typeof Node === 'undefined' ? 'undefined' : _typeof(Node)) === 'object' ? obj instanceof Node : obj && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && typeof obj.nodeType === 'number' && typeof obj.nodeName === 'string';
  };

  /**
  * _executeHook
  * Execute user configurable hooks
  *
  * @param  {String} entryPoint  Name of the hook's entry point
  * @param  {Node} currentNode
  */
  var _executeHook = function _executeHook(entryPoint, currentNode, data) {
    if (!hooks[entryPoint]) {
      return;
    }

    hooks[entryPoint].forEach(function (hook) {
      hook.call(DOMPurify, currentNode, data, CONFIG);
    });
  };

  /**
  * _sanitizeElements
  *
  * @protect nodeName
  * @protect textContent
  * @protect removeChild
  *
  * @param   node to check for permission to exist
  * @return  true if node was killed, false if left alive
  */
  var _sanitizeElements = function _sanitizeElements(currentNode) {
    var content = void 0;

    /* Execute a hook if present */
    _executeHook('beforeSanitizeElements', currentNode, null);

    /* Check if element is clobbered or can clobber */
    if (_isClobbered(currentNode)) {
      _forceRemove(currentNode);
      return true;
    }

    /* Now let's check the element's type and name */
    var tagName = currentNode.nodeName.toLowerCase();

    /* Execute a hook if present */
    _executeHook('uponSanitizeElement', currentNode, {
      tagName: tagName,
      allowedTags: ALLOWED_TAGS
    });

    /* Remove element if anything forbids its presence */
    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
      /* Keep content except for black-listed elements */
      if (KEEP_CONTENT && !FORBID_CONTENTS[tagName] && typeof currentNode.insertAdjacentHTML === 'function') {
        try {
          currentNode.insertAdjacentHTML('AfterEnd', currentNode.innerHTML);
        } catch (err) {}
      }
      _forceRemove(currentNode);
      return true;
    }

    /* Convert markup to cover jQuery behavior */
    if (SAFE_FOR_JQUERY && !currentNode.firstElementChild && (!currentNode.content || !currentNode.content.firstElementChild) && /</g.test(currentNode.textContent)) {
      DOMPurify.removed.push({ element: currentNode.cloneNode() });
      currentNode.innerHTML = currentNode.textContent.replace(/</g, '&lt;');
    }

    /* Sanitize element content to be template-safe */
    if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
      /* Get the element's text content */
      content = currentNode.textContent;
      content = content.replace(MUSTACHE_EXPR, ' ');
      content = content.replace(ERB_EXPR, ' ');
      if (currentNode.textContent !== content) {
        DOMPurify.removed.push({ element: currentNode.cloneNode() });
        currentNode.textContent = content;
      }
    }

    /* Execute a hook if present */
    _executeHook('afterSanitizeElements', currentNode, null);

    return false;
  };

  var DATA_ATTR = /^data-[\-\w.\u00B7-\uFFFF]/; // eslint-disable-line no-useless-escape
  var ARIA_ATTR = /^aria-[\-\w]+$/; // eslint-disable-line no-useless-escape
  var IS_ALLOWED_URI = /^(?:(?:(?:f|ht)tps?|mailto|tel):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i; // eslint-disable-line no-useless-escape
  var IS_SCRIPT_OR_DATA = /^(?:\w+script|data):/i;
  /* This needs to be extensive thanks to Webkit/Blink's behavior */
  var ATTR_WHITESPACE = /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205f\u3000]/g;

  /**
  * _sanitizeAttributes
  *
  * @protect attributes
  * @protect nodeName
  * @protect removeAttribute
  * @protect setAttribute
  *
  * @param   node to sanitize
  * @return  void
  */
  // eslint-disable-next-line complexity
  var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
    var attr = void 0;
    var name = void 0;
    var value = void 0;
    var lcName = void 0;
    var idAttr = void 0;
    var attributes = void 0;
    var l = void 0;
    /* Execute a hook if present */
    _executeHook('beforeSanitizeAttributes', currentNode, null);

    attributes = currentNode.attributes;

    /* Check if we have attributes; if not we might have a text node */
    if (!attributes) {
      return;
    }

    var hookEvent = {
      attrName: '',
      attrValue: '',
      keepAttr: true,
      allowedAttributes: ALLOWED_ATTR
    };
    l = attributes.length;

    /* Go backwards over all attributes; safely remove bad ones */
    while (l--) {
      attr = attributes[l];
      name = attr.name;
      value = attr.value.trim();
      lcName = name.toLowerCase();

      /* Execute a hook if present */
      hookEvent.attrName = lcName;
      hookEvent.attrValue = value;
      hookEvent.keepAttr = true;
      _executeHook('uponSanitizeAttribute', currentNode, hookEvent);
      value = hookEvent.attrValue;

      /* Remove attribute */
      // Safari (iOS + Mac), last tested v8.0.5, crashes if you try to
      // remove a "name" attribute from an <img> tag that has an "id"
      // attribute at the time.
      if (lcName === 'name' && currentNode.nodeName === 'IMG' && attributes.id) {
        idAttr = attributes.id;
        attributes = Array.prototype.slice.apply(attributes);
        _removeAttribute('id', currentNode);
        _removeAttribute(name, currentNode);
        if (attributes.indexOf(idAttr) > l) {
          currentNode.setAttribute('id', idAttr.value);
        }
      } else if (
      // This works around a bug in Safari, where input[type=file]
      // cannot be dynamically set after type has been removed
      currentNode.nodeName === 'INPUT' && lcName === 'type' && value === 'file' && (ALLOWED_ATTR[lcName] || !FORBID_ATTR[lcName])) {
        continue;
      } else {
        // This avoids a crash in Safari v9.0 with double-ids.
        // The trick is to first set the id to be empty and then to
        // remove the attribute
        if (name === 'id') {
          currentNode.setAttribute(name, '');
        }
        _removeAttribute(name, currentNode);
      }

      /* Did the hooks approve of the attribute? */
      if (!hookEvent.keepAttr) {
        continue;
      }

      /* Make sure attribute cannot clobber */
      if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in window || value in document || value in formElement)) {
        continue;
      }

      /* Sanitize attribute content to be template-safe */
      if (SAFE_FOR_TEMPLATES) {
        value = value.replace(MUSTACHE_EXPR, ' ');
        value = value.replace(ERB_EXPR, ' ');
      }

      /* Allow valid data-* attributes: At least one character after "-"
         (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
         XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
         We don't need to check the value; it's always URI safe. */
      if (ALLOW_DATA_ATTR && DATA_ATTR.test(lcName)) {
        // This attribute is safe
      } else if (ALLOW_ARIA_ATTR && ARIA_ATTR.test(lcName)) {
        // This attribute is safe
        /* Otherwise, check the name is permitted */
      } else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
        continue;

        /* Check value is safe. First, is attr inert? If so, is safe */
      } else if (URI_SAFE_ATTRIBUTES[lcName]) {
        // This attribute is safe
        /* Check no script, data or unknown possibly unsafe URI
         unless we know URI values are safe for that attribute */
      } else if (IS_ALLOWED_URI.test(value.replace(ATTR_WHITESPACE, ''))) {
        // This attribute is safe
        /* Keep image data URIs alive if src/xlink:href is allowed */
      } else if ((lcName === 'src' || lcName === 'xlink:href') && value.indexOf('data:') === 0 && DATA_URI_TAGS[currentNode.nodeName.toLowerCase()]) {
        // This attribute is safe
        /* Allow unknown protocols: This provides support for links that
         are handled by protocol handlers which may be unknown ahead of
         time, e.g. fb:, spotify: */
      } else if (ALLOW_UNKNOWN_PROTOCOLS && !IS_SCRIPT_OR_DATA.test(value.replace(ATTR_WHITESPACE, ''))) {
        // This attribute is safe
        /* Check for binary attributes */
        // eslint-disable-next-line no-negated-condition
      } else if (!value) {
        // Binary attributes are safe at this point
        /* Anything else, presume unsafe, do not add it back */
      } else {
        continue;
      }

      /* Handle invalid data-* attribute set by try-catching it */
      try {
        currentNode.setAttribute(name, value);
        DOMPurify.removed.pop();
      } catch (err) {}
    }

    /* Execute a hook if present */
    _executeHook('afterSanitizeAttributes', currentNode, null);
  };

  /**
  * _sanitizeShadowDOM
  *
  * @param  fragment to iterate over recursively
  * @return void
  */
  var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
    var shadowNode = void 0;
    var shadowIterator = _createIterator(fragment);

    /* Execute a hook if present */
    _executeHook('beforeSanitizeShadowDOM', fragment, null);

    while (shadowNode = shadowIterator.nextNode()) {
      /* Execute a hook if present */
      _executeHook('uponSanitizeShadowNode', shadowNode, null);

      /* Sanitize tags and elements */
      if (_sanitizeElements(shadowNode)) {
        continue;
      }

      /* Deep shadow DOM detected */
      if (shadowNode.content instanceof DocumentFragment) {
        _sanitizeShadowDOM(shadowNode.content);
      }

      /* Check attributes, sanitize if necessary */
      _sanitizeAttributes(shadowNode);
    }

    /* Execute a hook if present */
    _executeHook('afterSanitizeShadowDOM', fragment, null);
  };

  /**
  * Sanitize
  * Public method providing core sanitation functionality
  *
  * @param {String|Node} dirty string or DOM node
  * @param {Object} configuration object
  */
  // eslint-disable-next-line complexity
  DOMPurify.sanitize = function (dirty, cfg) {
    var body = void 0;
    var importedNode = void 0;
    var currentNode = void 0;
    var oldNode = void 0;
    var returnNode = void 0;
    /* Make sure we have a string to sanitize.
      DO NOT return early, as this will return the wrong type if
      the user has requested a DOM object rather than a string */
    if (!dirty) {
      dirty = '<!-->';
    }

    /* Stringify, in case dirty is an object */
    if (typeof dirty !== 'string' && !_isNode(dirty)) {
      // eslint-disable-next-line no-negated-condition
      if (typeof dirty.toString !== 'function') {
        throw new TypeError('toString is not a function');
      } else {
        dirty = dirty.toString();
      }
    }

    /* Check we can run. Otherwise fall back or ignore */
    if (!DOMPurify.isSupported) {
      if (_typeof(window.toStaticHTML) === 'object' || typeof window.toStaticHTML === 'function') {
        if (typeof dirty === 'string') {
          return window.toStaticHTML(dirty);
        } else if (_isNode(dirty)) {
          return window.toStaticHTML(dirty.outerHTML);
        }
      }
      return dirty;
    }

    /* Assign config vars */
    if (!SET_CONFIG) {
      _parseConfig(cfg);
    }

    /* Clean up removed elements */
    DOMPurify.removed = [];

    if (dirty instanceof Node) {
      /* If dirty is a DOM element, append to an empty document to avoid
         elements being stripped by the parser */
      body = _initDocument('<!-->');
      importedNode = body.ownerDocument.importNode(dirty, true);
      if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') {
        /* Node is already a body, use as is */
        body = importedNode;
      } else {
        body.appendChild(importedNode);
      }
    } else {
      /* Exit directly if we have nothing to do */
      if (!RETURN_DOM && !WHOLE_DOCUMENT && dirty.indexOf('<') === -1) {
        return dirty;
      }

      /* Initialize the document to work on */
      body = _initDocument(dirty);

      /* Check we have a DOM node from the data */
      if (!body) {
        return RETURN_DOM ? null : '';
      }
    }

    /* Remove first element node (ours) if FORCE_BODY is set */
    if (FORCE_BODY) {
      _forceRemove(body.firstChild);
    }

    /* Get node iterator */
    var nodeIterator = _createIterator(body);

    /* Now start iterating over the created document */
    while (currentNode = nodeIterator.nextNode()) {
      /* Fix IE's strange behavior with manipulated textNodes #89 */
      if (currentNode.nodeType === 3 && currentNode === oldNode) {
        continue;
      }

      /* Sanitize tags and elements */
      if (_sanitizeElements(currentNode)) {
        continue;
      }

      /* Shadow DOM detected, sanitize it */
      if (currentNode.content instanceof DocumentFragment) {
        _sanitizeShadowDOM(currentNode.content);
      }

      /* Check attributes, sanitize if necessary */
      _sanitizeAttributes(currentNode);

      oldNode = currentNode;
    }

    /* Return sanitized string or DOM */
    if (RETURN_DOM) {
      if (RETURN_DOM_FRAGMENT) {
        returnNode = createDocumentFragment.call(body.ownerDocument);

        while (body.firstChild) {
          returnNode.appendChild(body.firstChild);
        }
      } else {
        returnNode = body;
      }

      if (RETURN_DOM_IMPORT) {
        /* AdoptNode() is not used because internal state is not reset
               (e.g. the past names map of a HTMLFormElement), this is safe
               in theory but we would rather not risk another attack vector.
               The state that is cloned by importNode() is explicitly defined
               by the specs. */
        returnNode = importNode.call(originalDocument, returnNode, true);
      }

      return returnNode;
    }

    return WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
  };

  /**
  * Public method to set the configuration once
  * setConfig
  *
  * @param {Object} configuration object
  * @return void
  */
  DOMPurify.setConfig = function (cfg) {
    _parseConfig(cfg);
    SET_CONFIG = true;
  };

  /**
  * Public method to remove the configuration
  * clearConfig
  *
  * @return void
  */
  DOMPurify.clearConfig = function () {
    CONFIG = null;
    SET_CONFIG = false;
  };

  /**
  * AddHook
  * Public method to add DOMPurify hooks
  *
  * @param {String} entryPoint
  * @param {Function} hookFunction
  */
  DOMPurify.addHook = function (entryPoint, hookFunction) {
    if (typeof hookFunction !== 'function') {
      return;
    }
    hooks[entryPoint] = hooks[entryPoint] || [];
    hooks[entryPoint].push(hookFunction);
  };

  /**
  * RemoveHook
  * Public method to remove a DOMPurify hook at a given entryPoint
  * (pops it from the stack of hooks if more are present)
  *
  * @param {String} entryPoint
  * @return void
  */
  DOMPurify.removeHook = function (entryPoint) {
    if (hooks[entryPoint]) {
      hooks[entryPoint].pop();
    }
  };

  /**
  * RemoveHooks
  * Public method to remove all DOMPurify hooks at a given entryPoint
  *
  * @param  {String} entryPoint
  * @return void
  */
  DOMPurify.removeHooks = function (entryPoint) {
    if (hooks[entryPoint]) {
      hooks[entryPoint] = [];
    }
  };

  /**
  * RemoveAllHooks
  * Public method to remove all DOMPurify hooks
  *
  * @return void
  */
  DOMPurify.removeAllHooks = function () {
    hooks = {};
  };

  return DOMPurify;
}

var purify = createDOMPurify();

return purify;

})));
//# sourceMappingURL=purify.js.map


/***/ }),

/***/ "../node_modules/element-resize-detector/src/browser-detector.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var detector = module.exports = {};

detector.isIE = function(version) {
    function isAnyIeVersion() {
        var agent = navigator.userAgent.toLowerCase();
        return agent.indexOf("msie") !== -1 || agent.indexOf("trident") !== -1 || agent.indexOf(" edge/") !== -1;
    }

    if(!isAnyIeVersion()) {
        return false;
    }

    if(!version) {
        return true;
    }

    //Shamelessly stolen from https://gist.github.com/padolsey/527683
    var ieVersion = (function(){
        var undef,
            v = 3,
            div = document.createElement("div"),
            all = div.getElementsByTagName("i");

        do {
            div.innerHTML = "<!--[if gt IE " + (++v) + "]><i></i><![endif]-->";
        }
        while (all[0]);

        return v > 4 ? v : undef;
    }());

    return version === ieVersion;
};

detector.isLegacyOpera = function() {
    return !!window.opera;
};


/***/ }),

/***/ "../node_modules/element-resize-detector/src/collection-utils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = module.exports = {};

/**
 * Loops through the collection and calls the callback for each element. if the callback returns truthy, the loop is broken and returns the same value.
 * @public
 * @param {*} collection The collection to loop through. Needs to have a length property set and have indices set from 0 to length - 1.
 * @param {function} callback The callback to be called for each element. The element will be given as a parameter to the callback. If this callback returns truthy, the loop is broken and the same value is returned.
 * @returns {*} The value that a callback has returned (if truthy). Otherwise nothing.
 */
utils.forEach = function(collection, callback) {
    for(var i = 0; i < collection.length; i++) {
        var result = callback(collection[i]);
        if(result) {
            return result;
        }
    }
};


/***/ }),

/***/ "../node_modules/element-resize-detector/src/detection-strategy/object.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Resize detection strategy that injects objects to elements in order to detect resize events.
 * Heavily inspired by: http://www.backalleycoder.com/2013/03/18/cross-browser-event-based-element-resize-detection/
 */



var browserDetector = __webpack_require__("../node_modules/element-resize-detector/src/browser-detector.js");

module.exports = function(options) {
    options             = options || {};
    var reporter        = options.reporter;
    var batchProcessor  = options.batchProcessor;
    var getState        = options.stateHandler.getState;

    if(!reporter) {
        throw new Error("Missing required dependency: reporter.");
    }

    /**
     * Adds a resize event listener to the element.
     * @public
     * @param {element} element The element that should have the listener added.
     * @param {function} listener The listener callback to be called for each resize event of the element. The element will be given as a parameter to the listener callback.
     */
    function addListener(element, listener) {
        if(!getObject(element)) {
            throw new Error("Element is not detectable by this strategy.");
        }

        function listenerProxy() {
            listener(element);
        }

        if(browserDetector.isIE(8)) {
            //IE 8 does not support object, but supports the resize event directly on elements.
            getState(element).object = {
                proxy: listenerProxy
            };
            element.attachEvent("onresize", listenerProxy);
        } else {
            var object = getObject(element);
            object.contentDocument.defaultView.addEventListener("resize", listenerProxy);
        }
    }

    /**
     * Makes an element detectable and ready to be listened for resize events. Will call the callback when the element is ready to be listened for resize changes.
     * @private
     * @param {object} options Optional options object.
     * @param {element} element The element to make detectable
     * @param {function} callback The callback to be called when the element is ready to be listened for resize changes. Will be called with the element as first parameter.
     */
    function makeDetectable(options, element, callback) {
        if (!callback) {
            callback = element;
            element = options;
            options = null;
        }

        options = options || {};
        var debug = options.debug;

        function injectObject(element, callback) {
            var OBJECT_STYLE = "display: block; position: absolute; top: 0; left: 0; width: 100%; height: 100%; border: none; padding: 0; margin: 0; opacity: 0; z-index: -1000; pointer-events: none;";

            //The target element needs to be positioned (everything except static) so the absolute positioned object will be positioned relative to the target element.

            // Position altering may be performed directly or on object load, depending on if style resolution is possible directly or not.
            var positionCheckPerformed = false;

            // The element may not yet be attached to the DOM, and therefore the style object may be empty in some browsers.
            // Since the style object is a reference, it will be updated as soon as the element is attached to the DOM.
            var style = window.getComputedStyle(element);
            var width = element.offsetWidth;
            var height = element.offsetHeight;

            getState(element).startSize = {
                width: width,
                height: height
            };

            function mutateDom() {
                function alterPositionStyles() {
                    if(style.position === "static") {
                        element.style.position = "relative";

                        var removeRelativeStyles = function(reporter, element, style, property) {
                            function getNumericalValue(value) {
                                return value.replace(/[^-\d\.]/g, "");
                            }

                            var value = style[property];

                            if(value !== "auto" && getNumericalValue(value) !== "0") {
                                reporter.warn("An element that is positioned static has style." + property + "=" + value + " which is ignored due to the static positioning. The element will need to be positioned relative, so the style." + property + " will be set to 0. Element: ", element);
                                element.style[property] = 0;
                            }
                        };

                        //Check so that there are no accidental styles that will make the element styled differently now that is is relative.
                        //If there are any, set them to 0 (this should be okay with the user since the style properties did nothing before [since the element was positioned static] anyway).
                        removeRelativeStyles(reporter, element, style, "top");
                        removeRelativeStyles(reporter, element, style, "right");
                        removeRelativeStyles(reporter, element, style, "bottom");
                        removeRelativeStyles(reporter, element, style, "left");
                    }
                }

                function onObjectLoad() {
                    // The object has been loaded, which means that the element now is guaranteed to be attached to the DOM.
                    if (!positionCheckPerformed) {
                        alterPositionStyles();
                    }

                    /*jshint validthis: true */

                    function getDocument(element, callback) {
                        //Opera 12 seem to call the object.onload before the actual document has been created.
                        //So if it is not present, poll it with an timeout until it is present.
                        //TODO: Could maybe be handled better with object.onreadystatechange or similar.
                        if(!element.contentDocument) {
                            setTimeout(function checkForObjectDocument() {
                                getDocument(element, callback);
                            }, 100);

                            return;
                        }

                        callback(element.contentDocument);
                    }

                    //Mutating the object element here seems to fire another load event.
                    //Mutating the inner document of the object element is fine though.
                    var objectElement = this;

                    //Create the style element to be added to the object.
                    getDocument(objectElement, function onObjectDocumentReady(objectDocument) {
                        //Notify that the element is ready to be listened to.
                        callback(element);
                    });
                }

                // The element may be detached from the DOM, and some browsers does not support style resolving of detached elements.
                // The alterPositionStyles needs to be delayed until we know the element has been attached to the DOM (which we are sure of when the onObjectLoad has been fired), if style resolution is not possible.
                if (style.position !== "") {
                    alterPositionStyles(style);
                    positionCheckPerformed = true;
                }

                //Add an object element as a child to the target element that will be listened to for resize events.
                var object = document.createElement("object");
                object.style.cssText = OBJECT_STYLE;
                object.tabIndex = -1;
                object.type = "text/html";
                object.onload = onObjectLoad;

                //Safari: This must occur before adding the object to the DOM.
                //IE: Does not like that this happens before, even if it is also added after.
                if(!browserDetector.isIE()) {
                    object.data = "about:blank";
                }

                element.appendChild(object);
                getState(element).object = object;

                //IE: This must occur after adding the object to the DOM.
                if(browserDetector.isIE()) {
                    object.data = "about:blank";
                }
            }

            if(batchProcessor) {
                batchProcessor.add(mutateDom);
            } else {
                mutateDom();
            }
        }

        if(browserDetector.isIE(8)) {
            //IE 8 does not support objects properly. Luckily they do support the resize event.
            //So do not inject the object and notify that the element is already ready to be listened to.
            //The event handler for the resize event is attached in the utils.addListener instead.
            callback(element);
        } else {
            injectObject(element, callback);
        }
    }

    /**
     * Returns the child object of the target element.
     * @private
     * @param {element} element The target element.
     * @returns The object element of the target.
     */
    function getObject(element) {
        return getState(element).object;
    }

    function uninstall(element) {
        if(browserDetector.isIE(8)) {
            element.detachEvent("onresize", getState(element).object.proxy);
        } else {
            element.removeChild(getObject(element));
        }
        delete getState(element).object;
    }

    return {
        makeDetectable: makeDetectable,
        addListener: addListener,
        uninstall: uninstall
    };
};


/***/ }),

/***/ "../node_modules/element-resize-detector/src/detection-strategy/scroll.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Resize detection strategy that injects divs to elements in order to detect resize events on scroll events.
 * Heavily inspired by: https://github.com/marcj/css-element-queries/blob/master/src/ResizeSensor.js
 */



var forEach = __webpack_require__("../node_modules/element-resize-detector/src/collection-utils.js").forEach;

module.exports = function(options) {
    options             = options || {};
    var reporter        = options.reporter;
    var batchProcessor  = options.batchProcessor;
    var getState        = options.stateHandler.getState;
    var hasState        = options.stateHandler.hasState;
    var idHandler       = options.idHandler;

    if (!batchProcessor) {
        throw new Error("Missing required dependency: batchProcessor");
    }

    if (!reporter) {
        throw new Error("Missing required dependency: reporter.");
    }

    //TODO: Could this perhaps be done at installation time?
    var scrollbarSizes = getScrollbarSizes();

    // Inject the scrollbar styling that prevents them from appearing sometimes in Chrome.
    // The injected container needs to have a class, so that it may be styled with CSS (pseudo elements).
    var styleId = "erd_scroll_detection_scrollbar_style";
    var detectionContainerClass = "erd_scroll_detection_container";
    injectScrollStyle(styleId, detectionContainerClass);

    function getScrollbarSizes() {
        var width = 500;
        var height = 500;

        var child = document.createElement("div");
        child.style.cssText = "position: absolute; width: " + width*2 + "px; height: " + height*2 + "px; visibility: hidden; margin: 0; padding: 0;";

        var container = document.createElement("div");
        container.style.cssText = "position: absolute; width: " + width + "px; height: " + height + "px; overflow: scroll; visibility: none; top: " + -width*3 + "px; left: " + -height*3 + "px; visibility: hidden; margin: 0; padding: 0;";

        container.appendChild(child);

        document.body.insertBefore(container, document.body.firstChild);

        var widthSize = width - container.clientWidth;
        var heightSize = height - container.clientHeight;

        document.body.removeChild(container);

        return {
            width: widthSize,
            height: heightSize
        };
    }

    function injectScrollStyle(styleId, containerClass) {
        function injectStyle(style, method) {
            method = method || function (element) {
                document.head.appendChild(element);
            };

            var styleElement = document.createElement("style");
            styleElement.innerHTML = style;
            styleElement.id = styleId;
            method(styleElement);
            return styleElement;
        }

        if (!document.getElementById(styleId)) {
            var containerAnimationClass = containerClass + "_animation";
            var containerAnimationActiveClass = containerClass + "_animation_active";
            var style = "/* Created by the element-resize-detector library. */\n";
            style += "." + containerClass + " > div::-webkit-scrollbar { display: none; }\n\n";
            style += "." + containerAnimationActiveClass + " { -webkit-animation-duration: 0.1s; animation-duration: 0.1s; -webkit-animation-name: " + containerAnimationClass + "; animation-name: " + containerAnimationClass + "; }\n";
            style += "@-webkit-keyframes " + containerAnimationClass +  " { 0% { opacity: 1; } 50% { opacity: 0; } 100% { opacity: 1; } }\n";
            style += "@keyframes " + containerAnimationClass +          " { 0% { opacity: 1; } 50% { opacity: 0; } 100% { opacity: 1; } }";
            injectStyle(style);
        }
    }

    function addAnimationClass(element) {
        element.className += " " + detectionContainerClass + "_animation_active";
    }

    function addEvent(el, name, cb) {
        if (el.addEventListener) {
            el.addEventListener(name, cb);
        } else if(el.attachEvent) {
            el.attachEvent("on" + name, cb);
        } else {
            return reporter.error("[scroll] Don't know how to add event listeners.");
        }
    }

    function removeEvent(el, name, cb) {
        if (el.removeEventListener) {
            el.removeEventListener(name, cb);
        } else if(el.detachEvent) {
            el.detachEvent("on" + name, cb);
        } else {
            return reporter.error("[scroll] Don't know how to remove event listeners.");
        }
    }

    function getExpandElement(element) {
        return getState(element).container.childNodes[0].childNodes[0].childNodes[0];
    }

    function getShrinkElement(element) {
        return getState(element).container.childNodes[0].childNodes[0].childNodes[1];
    }

    /**
     * Adds a resize event listener to the element.
     * @public
     * @param {element} element The element that should have the listener added.
     * @param {function} listener The listener callback to be called for each resize event of the element. The element will be given as a parameter to the listener callback.
     */
    function addListener(element, listener) {
        var listeners = getState(element).listeners;

        if (!listeners.push) {
            throw new Error("Cannot add listener to an element that is not detectable.");
        }

        getState(element).listeners.push(listener);
    }

    /**
     * Makes an element detectable and ready to be listened for resize events. Will call the callback when the element is ready to be listened for resize changes.
     * @private
     * @param {object} options Optional options object.
     * @param {element} element The element to make detectable
     * @param {function} callback The callback to be called when the element is ready to be listened for resize changes. Will be called with the element as first parameter.
     */
    function makeDetectable(options, element, callback) {
        if (!callback) {
            callback = element;
            element = options;
            options = null;
        }

        options = options || {};

        function debug() {
            if (options.debug) {
                var args = Array.prototype.slice.call(arguments);
                args.unshift(idHandler.get(element), "Scroll: ");
                if (reporter.log.apply) {
                    reporter.log.apply(null, args);
                } else {
                    for (var i = 0; i < args.length; i++) {
                        reporter.log(args[i]);
                    }
                }
            }
        }

        function isDetached(element) {
            function isInDocument(element) {
                return element === element.ownerDocument.body || element.ownerDocument.body.contains(element);
            }

            if (!isInDocument(element)) {
                return true;
            }

            // FireFox returns null style in hidden iframes. See https://github.com/wnr/element-resize-detector/issues/68 and https://bugzilla.mozilla.org/show_bug.cgi?id=795520
            if (getComputedStyle(element) === null) {
                return true;
            }

            return false;
        }

        function isUnrendered(element) {
            // Check the absolute positioned container since the top level container is display: inline.
            var container = getState(element).container.childNodes[0];
            var style = getComputedStyle(container);
            return !style.width || style.width.indexOf("px") === -1; //Can only compute pixel value when rendered.
        }

        function getStyle() {
            // Some browsers only force layouts when actually reading the style properties of the style object, so make sure that they are all read here,
            // so that the user of the function can be sure that it will perform the layout here, instead of later (important for batching).
            var elementStyle            = getComputedStyle(element);
            var style                   = {};
            style.position              = elementStyle.position;
            style.width                 = element.offsetWidth;
            style.height                = element.offsetHeight;
            style.top                   = elementStyle.top;
            style.right                 = elementStyle.right;
            style.bottom                = elementStyle.bottom;
            style.left                  = elementStyle.left;
            style.widthCSS              = elementStyle.width;
            style.heightCSS             = elementStyle.height;
            return style;
        }

        function storeStartSize() {
            var style = getStyle();
            getState(element).startSize = {
                width: style.width,
                height: style.height
            };
            debug("Element start size", getState(element).startSize);
        }

        function initListeners() {
            getState(element).listeners = [];
        }

        function storeStyle() {
            debug("storeStyle invoked.");
            if (!getState(element)) {
                debug("Aborting because element has been uninstalled");
                return;
            }

            var style = getStyle();
            getState(element).style = style;
        }

        function storeCurrentSize(element, width, height) {
            getState(element).lastWidth = width;
            getState(element).lastHeight  = height;
        }

        function getExpandChildElement(element) {
            return getExpandElement(element).childNodes[0];
        }

        function getWidthOffset() {
            return 2 * scrollbarSizes.width + 1;
        }

        function getHeightOffset() {
            return 2 * scrollbarSizes.height + 1;
        }

        function getExpandWidth(width) {
            return width + 10 + getWidthOffset();
        }

        function getExpandHeight(height) {
            return height + 10 + getHeightOffset();
        }

        function getShrinkWidth(width) {
            return width * 2 + getWidthOffset();
        }

        function getShrinkHeight(height) {
            return height * 2 + getHeightOffset();
        }

        function positionScrollbars(element, width, height) {
            var expand          = getExpandElement(element);
            var shrink          = getShrinkElement(element);
            var expandWidth     = getExpandWidth(width);
            var expandHeight    = getExpandHeight(height);
            var shrinkWidth     = getShrinkWidth(width);
            var shrinkHeight    = getShrinkHeight(height);
            expand.scrollLeft   = expandWidth;
            expand.scrollTop    = expandHeight;
            shrink.scrollLeft   = shrinkWidth;
            shrink.scrollTop    = shrinkHeight;
        }

        function injectContainerElement() {
            var container = getState(element).container;

            if (!container) {
                container                   = document.createElement("div");
                container.className         = detectionContainerClass;
                container.style.cssText     = "visibility: hidden; display: inline; width: 0px; height: 0px; z-index: -1; overflow: hidden; margin: 0; padding: 0;";
                getState(element).container = container;
                addAnimationClass(container);
                element.appendChild(container);

                var onAnimationStart = function () {
                    getState(element).onRendered && getState(element).onRendered();
                };

                addEvent(container, "animationstart", onAnimationStart);

                // Store the event handler here so that they may be removed when uninstall is called.
                // See uninstall function for an explanation why it is needed.
                getState(element).onAnimationStart = onAnimationStart;
            }

            return container;
        }

        function injectScrollElements() {
            function alterPositionStyles() {
                var style = getState(element).style;

                if(style.position === "static") {
                    element.style.position = "relative";

                    var removeRelativeStyles = function(reporter, element, style, property) {
                        function getNumericalValue(value) {
                            return value.replace(/[^-\d\.]/g, "");
                        }

                        var value = style[property];

                        if(value !== "auto" && getNumericalValue(value) !== "0") {
                            reporter.warn("An element that is positioned static has style." + property + "=" + value + " which is ignored due to the static positioning. The element will need to be positioned relative, so the style." + property + " will be set to 0. Element: ", element);
                            element.style[property] = 0;
                        }
                    };

                    //Check so that there are no accidental styles that will make the element styled differently now that is is relative.
                    //If there are any, set them to 0 (this should be okay with the user since the style properties did nothing before [since the element was positioned static] anyway).
                    removeRelativeStyles(reporter, element, style, "top");
                    removeRelativeStyles(reporter, element, style, "right");
                    removeRelativeStyles(reporter, element, style, "bottom");
                    removeRelativeStyles(reporter, element, style, "left");
                }
            }

            function getLeftTopBottomRightCssText(left, top, bottom, right) {
                left = (!left ? "0" : (left + "px"));
                top = (!top ? "0" : (top + "px"));
                bottom = (!bottom ? "0" : (bottom + "px"));
                right = (!right ? "0" : (right + "px"));

                return "left: " + left + "; top: " + top + "; right: " + right + "; bottom: " + bottom + ";";
            }

            debug("Injecting elements");

            if (!getState(element)) {
                debug("Aborting because element has been uninstalled");
                return;
            }

            alterPositionStyles();

            var rootContainer = getState(element).container;

            if (!rootContainer) {
                rootContainer = injectContainerElement();
            }

            // Due to this WebKit bug https://bugs.webkit.org/show_bug.cgi?id=80808 (currently fixed in Blink, but still present in WebKit browsers such as Safari),
            // we need to inject two containers, one that is width/height 100% and another that is left/top -1px so that the final container always is 1x1 pixels bigger than
            // the targeted element.
            // When the bug is resolved, "containerContainer" may be removed.

            // The outer container can occasionally be less wide than the targeted when inside inline elements element in WebKit (see https://bugs.webkit.org/show_bug.cgi?id=152980).
            // This should be no problem since the inner container either way makes sure the injected scroll elements are at least 1x1 px.

            var scrollbarWidth          = scrollbarSizes.width;
            var scrollbarHeight         = scrollbarSizes.height;
            var containerContainerStyle = "position: absolute; flex: none; overflow: hidden; z-index: -1; visibility: hidden; width: 100%; height: 100%; left: 0px; top: 0px;";
            var containerStyle          = "position: absolute; flex: none; overflow: hidden; z-index: -1; visibility: hidden; " + getLeftTopBottomRightCssText(-(1 + scrollbarWidth), -(1 + scrollbarHeight), -scrollbarHeight, -scrollbarWidth);
            var expandStyle             = "position: absolute; flex: none; overflow: scroll; z-index: -1; visibility: hidden; width: 100%; height: 100%;";
            var shrinkStyle             = "position: absolute; flex: none; overflow: scroll; z-index: -1; visibility: hidden; width: 100%; height: 100%;";
            var expandChildStyle        = "position: absolute; left: 0; top: 0;";
            var shrinkChildStyle        = "position: absolute; width: 200%; height: 200%;";

            var containerContainer      = document.createElement("div");
            var container               = document.createElement("div");
            var expand                  = document.createElement("div");
            var expandChild             = document.createElement("div");
            var shrink                  = document.createElement("div");
            var shrinkChild             = document.createElement("div");

            // Some browsers choke on the resize system being rtl, so force it to ltr. https://github.com/wnr/element-resize-detector/issues/56
            // However, dir should not be set on the top level container as it alters the dimensions of the target element in some browsers.
            containerContainer.dir              = "ltr";

            containerContainer.style.cssText    = containerContainerStyle;
            containerContainer.className        = detectionContainerClass;
            container.className                 = detectionContainerClass;
            container.style.cssText             = containerStyle;
            expand.style.cssText                = expandStyle;
            expandChild.style.cssText           = expandChildStyle;
            shrink.style.cssText                = shrinkStyle;
            shrinkChild.style.cssText           = shrinkChildStyle;

            expand.appendChild(expandChild);
            shrink.appendChild(shrinkChild);
            container.appendChild(expand);
            container.appendChild(shrink);
            containerContainer.appendChild(container);
            rootContainer.appendChild(containerContainer);

            function onExpandScroll() {
                getState(element).onExpand && getState(element).onExpand();
            }

            function onShrinkScroll() {
                getState(element).onShrink && getState(element).onShrink();
            }

            addEvent(expand, "scroll", onExpandScroll);
            addEvent(shrink, "scroll", onShrinkScroll);

            // Store the event handlers here so that they may be removed when uninstall is called.
            // See uninstall function for an explanation why it is needed.
            getState(element).onExpandScroll = onExpandScroll;
            getState(element).onShrinkScroll = onShrinkScroll;
        }

        function registerListenersAndPositionElements() {
            function updateChildSizes(element, width, height) {
                var expandChild             = getExpandChildElement(element);
                var expandWidth             = getExpandWidth(width);
                var expandHeight            = getExpandHeight(height);
                expandChild.style.width     = expandWidth + "px";
                expandChild.style.height    = expandHeight + "px";
            }

            function updateDetectorElements(done) {
                var width           = element.offsetWidth;
                var height          = element.offsetHeight;

                debug("Storing current size", width, height);

                // Store the size of the element sync here, so that multiple scroll events may be ignored in the event listeners.
                // Otherwise the if-check in handleScroll is useless.
                storeCurrentSize(element, width, height);

                // Since we delay the processing of the batch, there is a risk that uninstall has been called before the batch gets to execute.
                // Since there is no way to cancel the fn executions, we need to add an uninstall guard to all fns of the batch.

                batchProcessor.add(0, function performUpdateChildSizes() {
                    if (!getState(element)) {
                        debug("Aborting because element has been uninstalled");
                        return;
                    }

                    if (!areElementsInjected()) {
                        debug("Aborting because element container has not been initialized");
                        return;
                    }

                    if (options.debug) {
                        var w = element.offsetWidth;
                        var h = element.offsetHeight;

                        if (w !== width || h !== height) {
                            reporter.warn(idHandler.get(element), "Scroll: Size changed before updating detector elements.");
                        }
                    }

                    updateChildSizes(element, width, height);
                });

                batchProcessor.add(1, function updateScrollbars() {
                    if (!getState(element)) {
                        debug("Aborting because element has been uninstalled");
                        return;
                    }

                    if (!areElementsInjected()) {
                        debug("Aborting because element container has not been initialized");
                        return;
                    }

                    positionScrollbars(element, width, height);
                });

                if (done) {
                    batchProcessor.add(2, function () {
                        if (!getState(element)) {
                            debug("Aborting because element has been uninstalled");
                            return;
                        }

                        if (!areElementsInjected()) {
                          debug("Aborting because element container has not been initialized");
                          return;
                        }

                        done();
                    });
                }
            }

            function areElementsInjected() {
                return !!getState(element).container;
            }

            function notifyListenersIfNeeded() {
                function isFirstNotify() {
                    return getState(element).lastNotifiedWidth === undefined;
                }

                debug("notifyListenersIfNeeded invoked");

                var state = getState(element);

                // Don't notify the if the current size is the start size, and this is the first notification.
                if (isFirstNotify() && state.lastWidth === state.startSize.width && state.lastHeight === state.startSize.height) {
                    return debug("Not notifying: Size is the same as the start size, and there has been no notification yet.");
                }

                // Don't notify if the size already has been notified.
                if (state.lastWidth === state.lastNotifiedWidth && state.lastHeight === state.lastNotifiedHeight) {
                    return debug("Not notifying: Size already notified");
                }


                debug("Current size not notified, notifying...");
                state.lastNotifiedWidth = state.lastWidth;
                state.lastNotifiedHeight = state.lastHeight;
                forEach(getState(element).listeners, function (listener) {
                    listener(element);
                });
            }

            function handleRender() {
                debug("startanimation triggered.");

                if (isUnrendered(element)) {
                    debug("Ignoring since element is still unrendered...");
                    return;
                }

                debug("Element rendered.");
                var expand = getExpandElement(element);
                var shrink = getShrinkElement(element);
                if (expand.scrollLeft === 0 || expand.scrollTop === 0 || shrink.scrollLeft === 0 || shrink.scrollTop === 0) {
                    debug("Scrollbars out of sync. Updating detector elements...");
                    updateDetectorElements(notifyListenersIfNeeded);
                }
            }

            function handleScroll() {
                debug("Scroll detected.");

                if (isUnrendered(element)) {
                    // Element is still unrendered. Skip this scroll event.
                    debug("Scroll event fired while unrendered. Ignoring...");
                    return;
                }

                var width = element.offsetWidth;
                var height = element.offsetHeight;

                if (width !== element.lastWidth || height !== element.lastHeight) {
                    debug("Element size changed.");
                    updateDetectorElements(notifyListenersIfNeeded);
                } else {
                    debug("Element size has not changed (" + width + "x" + height + ").");
                }
            }

            debug("registerListenersAndPositionElements invoked.");

            if (!getState(element)) {
                debug("Aborting because element has been uninstalled");
                return;
            }

            getState(element).onRendered = handleRender;
            getState(element).onExpand = handleScroll;
            getState(element).onShrink = handleScroll;

            var style = getState(element).style;
            updateChildSizes(element, style.width, style.height);
        }

        function finalizeDomMutation() {
            debug("finalizeDomMutation invoked.");

            if (!getState(element)) {
                debug("Aborting because element has been uninstalled");
                return;
            }

            var style = getState(element).style;
            storeCurrentSize(element, style.width, style.height);
            positionScrollbars(element, style.width, style.height);
        }

        function ready() {
            callback(element);
        }

        function install() {
            debug("Installing...");
            initListeners();
            storeStartSize();

            batchProcessor.add(0, storeStyle);
            batchProcessor.add(1, injectScrollElements);
            batchProcessor.add(2, registerListenersAndPositionElements);
            batchProcessor.add(3, finalizeDomMutation);
            batchProcessor.add(4, ready);
        }

        debug("Making detectable...");

        if (isDetached(element)) {
            debug("Element is detached");

            injectContainerElement();

            debug("Waiting until element is attached...");

            getState(element).onRendered = function () {
                debug("Element is now attached");
                install();
            };
        } else {
            install();
        }
    }

    function uninstall(element) {
        var state = getState(element);

        if (!state) {
            // Uninstall has been called on a non-erd element.
            return;
        }

        // Uninstall may have been called in the following scenarios:
        // (1) Right between the sync code and async batch (here state.busy = true, but nothing have been registered or injected).
        // (2) In the ready callback of the last level of the batch by another element (here, state.busy = true, but all the stuff has been injected).
        // (3) After the installation process (here, state.busy = false and all the stuff has been injected).
        // So to be on the safe side, let's check for each thing before removing.

        // We need to remove the event listeners, because otherwise the event might fire on an uninstall element which results in an error when trying to get the state of the element.
        state.onExpandScroll && removeEvent(getExpandElement(element), "scroll", state.onExpandScroll);
        state.onShrinkScroll && removeEvent(getShrinkElement(element), "scroll", state.onShrinkScroll);
        state.onAnimationStart && removeEvent(state.container, "animationstart", state.onAnimationStart);

        state.container && element.removeChild(state.container);
    }

    return {
        makeDetectable: makeDetectable,
        addListener: addListener,
        uninstall: uninstall
    };
};


/***/ }),

/***/ "../node_modules/element-resize-detector/src/element-resize-detector.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var forEach                 = __webpack_require__("../node_modules/element-resize-detector/src/collection-utils.js").forEach;
var elementUtilsMaker       = __webpack_require__("../node_modules/element-resize-detector/src/element-utils.js");
var listenerHandlerMaker    = __webpack_require__("../node_modules/element-resize-detector/src/listener-handler.js");
var idGeneratorMaker        = __webpack_require__("../node_modules/element-resize-detector/src/id-generator.js");
var idHandlerMaker          = __webpack_require__("../node_modules/element-resize-detector/src/id-handler.js");
var reporterMaker           = __webpack_require__("../node_modules/element-resize-detector/src/reporter.js");
var browserDetector         = __webpack_require__("../node_modules/element-resize-detector/src/browser-detector.js");
var batchProcessorMaker     = __webpack_require__("../node_modules/batch-processor/src/batch-processor.js");
var stateHandler            = __webpack_require__("../node_modules/element-resize-detector/src/state-handler.js");

//Detection strategies.
var objectStrategyMaker     = __webpack_require__("../node_modules/element-resize-detector/src/detection-strategy/object.js");
var scrollStrategyMaker     = __webpack_require__("../node_modules/element-resize-detector/src/detection-strategy/scroll.js");

function isCollection(obj) {
    return Array.isArray(obj) || obj.length !== undefined;
}

function toArray(collection) {
    if (!Array.isArray(collection)) {
        var array = [];
        forEach(collection, function (obj) {
            array.push(obj);
        });
        return array;
    } else {
        return collection;
    }
}

function isElement(obj) {
    return obj && obj.nodeType === 1;
}

/**
 * @typedef idHandler
 * @type {object}
 * @property {function} get Gets the resize detector id of the element.
 * @property {function} set Generate and sets the resize detector id of the element.
 */

/**
 * @typedef Options
 * @type {object}
 * @property {boolean} callOnAdd    Determines if listeners should be called when they are getting added.
                                    Default is true. If true, the listener is guaranteed to be called when it has been added.
                                    If false, the listener will not be guarenteed to be called when it has been added (does not prevent it from being called).
 * @property {idHandler} idHandler  A custom id handler that is responsible for generating, setting and retrieving id's for elements.
                                    If not provided, a default id handler will be used.
 * @property {reporter} reporter    A custom reporter that handles reporting logs, warnings and errors.
                                    If not provided, a default id handler will be used.
                                    If set to false, then nothing will be reported.
 * @property {boolean} debug        If set to true, the the system will report debug messages as default for the listenTo method.
 */

/**
 * Creates an element resize detector instance.
 * @public
 * @param {Options?} options Optional global options object that will decide how this instance will work.
 */
module.exports = function(options) {
    options = options || {};

    //idHandler is currently not an option to the listenTo function, so it should not be added to globalOptions.
    var idHandler;

    if (options.idHandler) {
        // To maintain compatability with idHandler.get(element, readonly), make sure to wrap the given idHandler
        // so that readonly flag always is true when it's used here. This may be removed next major version bump.
        idHandler = {
            get: function (element) { return options.idHandler.get(element, true); },
            set: options.idHandler.set
        };
    } else {
        var idGenerator = idGeneratorMaker();
        var defaultIdHandler = idHandlerMaker({
            idGenerator: idGenerator,
            stateHandler: stateHandler
        });
        idHandler = defaultIdHandler;
    }

    //reporter is currently not an option to the listenTo function, so it should not be added to globalOptions.
    var reporter = options.reporter;

    if(!reporter) {
        //If options.reporter is false, then the reporter should be quiet.
        var quiet = reporter === false;
        reporter = reporterMaker(quiet);
    }

    //batchProcessor is currently not an option to the listenTo function, so it should not be added to globalOptions.
    var batchProcessor = getOption(options, "batchProcessor", batchProcessorMaker({ reporter: reporter }));

    //Options to be used as default for the listenTo function.
    var globalOptions = {};
    globalOptions.callOnAdd     = !!getOption(options, "callOnAdd", true);
    globalOptions.debug         = !!getOption(options, "debug", false);

    var eventListenerHandler    = listenerHandlerMaker(idHandler);
    var elementUtils            = elementUtilsMaker({
        stateHandler: stateHandler
    });

    //The detection strategy to be used.
    var detectionStrategy;
    var desiredStrategy = getOption(options, "strategy", "object");
    var strategyOptions = {
        reporter: reporter,
        batchProcessor: batchProcessor,
        stateHandler: stateHandler,
        idHandler: idHandler
    };

    if(desiredStrategy === "scroll") {
        if (browserDetector.isLegacyOpera()) {
            reporter.warn("Scroll strategy is not supported on legacy Opera. Changing to object strategy.");
            desiredStrategy = "object";
        } else if (browserDetector.isIE(9)) {
            reporter.warn("Scroll strategy is not supported on IE9. Changing to object strategy.");
            desiredStrategy = "object";
        }
    }

    if(desiredStrategy === "scroll") {
        detectionStrategy = scrollStrategyMaker(strategyOptions);
    } else if(desiredStrategy === "object") {
        detectionStrategy = objectStrategyMaker(strategyOptions);
    } else {
        throw new Error("Invalid strategy name: " + desiredStrategy);
    }

    //Calls can be made to listenTo with elements that are still being installed.
    //Also, same elements can occur in the elements list in the listenTo function.
    //With this map, the ready callbacks can be synchronized between the calls
    //so that the ready callback can always be called when an element is ready - even if
    //it wasn't installed from the function itself.
    var onReadyCallbacks = {};

    /**
     * Makes the given elements resize-detectable and starts listening to resize events on the elements. Calls the event callback for each event for each element.
     * @public
     * @param {Options?} options Optional options object. These options will override the global options. Some options may not be overriden, such as idHandler.
     * @param {element[]|element} elements The given array of elements to detect resize events of. Single element is also valid.
     * @param {function} listener The callback to be executed for each resize event for each element.
     */
    function listenTo(options, elements, listener) {
        function onResizeCallback(element) {
            var listeners = eventListenerHandler.get(element);
            forEach(listeners, function callListenerProxy(listener) {
                listener(element);
            });
        }

        function addListener(callOnAdd, element, listener) {
            eventListenerHandler.add(element, listener);

            if(callOnAdd) {
                listener(element);
            }
        }

        //Options object may be omitted.
        if(!listener) {
            listener = elements;
            elements = options;
            options = {};
        }

        if(!elements) {
            throw new Error("At least one element required.");
        }

        if(!listener) {
            throw new Error("Listener required.");
        }

        if (isElement(elements)) {
            // A single element has been passed in.
            elements = [elements];
        } else if (isCollection(elements)) {
            // Convert collection to array for plugins.
            // TODO: May want to check so that all the elements in the collection are valid elements.
            elements = toArray(elements);
        } else {
            return reporter.error("Invalid arguments. Must be a DOM element or a collection of DOM elements.");
        }

        var elementsReady = 0;

        var callOnAdd = getOption(options, "callOnAdd", globalOptions.callOnAdd);
        var onReadyCallback = getOption(options, "onReady", function noop() {});
        var debug = getOption(options, "debug", globalOptions.debug);

        forEach(elements, function attachListenerToElement(element) {
            if (!stateHandler.getState(element)) {
                stateHandler.initState(element);
                idHandler.set(element);
            }

            var id = idHandler.get(element);

            debug && reporter.log("Attaching listener to element", id, element);

            if(!elementUtils.isDetectable(element)) {
                debug && reporter.log(id, "Not detectable.");
                if(elementUtils.isBusy(element)) {
                    debug && reporter.log(id, "System busy making it detectable");

                    //The element is being prepared to be detectable. Do not make it detectable.
                    //Just add the listener, because the element will soon be detectable.
                    addListener(callOnAdd, element, listener);
                    onReadyCallbacks[id] = onReadyCallbacks[id] || [];
                    onReadyCallbacks[id].push(function onReady() {
                        elementsReady++;

                        if(elementsReady === elements.length) {
                            onReadyCallback();
                        }
                    });
                    return;
                }

                debug && reporter.log(id, "Making detectable...");
                //The element is not prepared to be detectable, so do prepare it and add a listener to it.
                elementUtils.markBusy(element, true);
                return detectionStrategy.makeDetectable({ debug: debug }, element, function onElementDetectable(element) {
                    debug && reporter.log(id, "onElementDetectable");

                    if (stateHandler.getState(element)) {
                        elementUtils.markAsDetectable(element);
                        elementUtils.markBusy(element, false);
                        detectionStrategy.addListener(element, onResizeCallback);
                        addListener(callOnAdd, element, listener);

                        // Since the element size might have changed since the call to "listenTo", we need to check for this change,
                        // so that a resize event may be emitted.
                        // Having the startSize object is optional (since it does not make sense in some cases such as unrendered elements), so check for its existance before.
                        // Also, check the state existance before since the element may have been uninstalled in the installation process.
                        var state = stateHandler.getState(element);
                        if (state && state.startSize) {
                            var width = element.offsetWidth;
                            var height = element.offsetHeight;
                            if (state.startSize.width !== width || state.startSize.height !== height) {
                                onResizeCallback(element);
                            }
                        }

                        if(onReadyCallbacks[id]) {
                            forEach(onReadyCallbacks[id], function(callback) {
                                callback();
                            });
                        }
                    } else {
                        // The element has been unisntalled before being detectable.
                        debug && reporter.log(id, "Element uninstalled before being detectable.");
                    }

                    delete onReadyCallbacks[id];

                    elementsReady++;
                    if(elementsReady === elements.length) {
                        onReadyCallback();
                    }
                });
            }

            debug && reporter.log(id, "Already detecable, adding listener.");

            //The element has been prepared to be detectable and is ready to be listened to.
            addListener(callOnAdd, element, listener);
            elementsReady++;
        });

        if(elementsReady === elements.length) {
            onReadyCallback();
        }
    }

    function uninstall(elements) {
        if(!elements) {
            return reporter.error("At least one element is required.");
        }

        if (isElement(elements)) {
            // A single element has been passed in.
            elements = [elements];
        } else if (isCollection(elements)) {
            // Convert collection to array for plugins.
            // TODO: May want to check so that all the elements in the collection are valid elements.
            elements = toArray(elements);
        } else {
            return reporter.error("Invalid arguments. Must be a DOM element or a collection of DOM elements.");
        }

        forEach(elements, function (element) {
            eventListenerHandler.removeAllListeners(element);
            detectionStrategy.uninstall(element);
            stateHandler.cleanState(element);
        });
    }

    return {
        listenTo: listenTo,
        removeListener: eventListenerHandler.removeListener,
        removeAllListeners: eventListenerHandler.removeAllListeners,
        uninstall: uninstall
    };
};

function getOption(options, name, defaultValue) {
    var value = options[name];

    if((value === undefined || value === null) && defaultValue !== undefined) {
        return defaultValue;
    }

    return value;
}


/***/ }),

/***/ "../node_modules/element-resize-detector/src/element-utils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(options) {
    var getState = options.stateHandler.getState;

    /**
     * Tells if the element has been made detectable and ready to be listened for resize events.
     * @public
     * @param {element} The element to check.
     * @returns {boolean} True or false depending on if the element is detectable or not.
     */
    function isDetectable(element) {
        var state = getState(element);
        return state && !!state.isDetectable;
    }

    /**
     * Marks the element that it has been made detectable and ready to be listened for resize events.
     * @public
     * @param {element} The element to mark.
     */
    function markAsDetectable(element) {
        getState(element).isDetectable = true;
    }

    /**
     * Tells if the element is busy or not.
     * @public
     * @param {element} The element to check.
     * @returns {boolean} True or false depending on if the element is busy or not.
     */
    function isBusy(element) {
        return !!getState(element).busy;
    }

    /**
     * Marks the object is busy and should not be made detectable.
     * @public
     * @param {element} element The element to mark.
     * @param {boolean} busy If the element is busy or not.
     */
    function markBusy(element, busy) {
        getState(element).busy = !!busy;
    }

    return {
        isDetectable: isDetectable,
        markAsDetectable: markAsDetectable,
        isBusy: isBusy,
        markBusy: markBusy
    };
};


/***/ }),

/***/ "../node_modules/element-resize-detector/src/id-generator.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function() {
    var idCount = 1;

    /**
     * Generates a new unique id in the context.
     * @public
     * @returns {number} A unique id in the context.
     */
    function generate() {
        return idCount++;
    }

    return {
        generate: generate
    };
};


/***/ }),

/***/ "../node_modules/element-resize-detector/src/id-handler.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(options) {
    var idGenerator     = options.idGenerator;
    var getState        = options.stateHandler.getState;

    /**
     * Gets the resize detector id of the element.
     * @public
     * @param {element} element The target element to get the id of.
     * @returns {string|number|null} The id of the element. Null if it has no id.
     */
    function getId(element) {
        var state = getState(element);

        if (state && state.id !== undefined) {
            return state.id;
        }

        return null;
    }

    /**
     * Sets the resize detector id of the element. Requires the element to have a resize detector state initialized.
     * @public
     * @param {element} element The target element to set the id of.
     * @returns {string|number|null} The id of the element.
     */
    function setId(element) {
        var state = getState(element);

        if (!state) {
            throw new Error("setId required the element to have a resize detection state.");
        }

        var id = idGenerator.generate();

        state.id = id;

        return id;
    }

    return {
        get: getId,
        set: setId
    };
};


/***/ }),

/***/ "../node_modules/element-resize-detector/src/listener-handler.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(idHandler) {
    var eventListeners = {};

    /**
     * Gets all listeners for the given element.
     * @public
     * @param {element} element The element to get all listeners for.
     * @returns All listeners for the given element.
     */
    function getListeners(element) {
        var id = idHandler.get(element);

        if (id === undefined) {
            return [];
        }

        return eventListeners[id] || [];
    }

    /**
     * Stores the given listener for the given element. Will not actually add the listener to the element.
     * @public
     * @param {element} element The element that should have the listener added.
     * @param {function} listener The callback that the element has added.
     */
    function addListener(element, listener) {
        var id = idHandler.get(element);

        if(!eventListeners[id]) {
            eventListeners[id] = [];
        }

        eventListeners[id].push(listener);
    }

    function removeListener(element, listener) {
        var listeners = getListeners(element);
        for (var i = 0, len = listeners.length; i < len; ++i) {
            if (listeners[i] === listener) {
              listeners.splice(i, 1);
              break;
            }
        }
    }

    function removeAllListeners(element) {
      var listeners = getListeners(element);
      if (!listeners) { return; }
      listeners.length = 0;
    }

    return {
        get: getListeners,
        add: addListener,
        removeListener: removeListener,
        removeAllListeners: removeAllListeners
    };
};


/***/ }),

/***/ "../node_modules/element-resize-detector/src/reporter.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* global console: false */

/**
 * Reporter that handles the reporting of logs, warnings and errors.
 * @public
 * @param {boolean} quiet Tells if the reporter should be quiet or not.
 */
module.exports = function(quiet) {
    function noop() {
        //Does nothing.
    }

    var reporter = {
        log: noop,
        warn: noop,
        error: noop
    };

    if(!quiet && window.console) {
        var attachFunction = function(reporter, name) {
            //The proxy is needed to be able to call the method with the console context,
            //since we cannot use bind.
            reporter[name] = function reporterProxy() {
                var f = console[name];
                if (f.apply) { //IE9 does not support console.log.apply :)
                    f.apply(console, arguments);
                } else {
                    for (var i = 0; i < arguments.length; i++) {
                        f(arguments[i]);
                    }
                }
            };
        };

        attachFunction(reporter, "log");
        attachFunction(reporter, "warn");
        attachFunction(reporter, "error");
    }

    return reporter;
};

/***/ }),

/***/ "../node_modules/element-resize-detector/src/state-handler.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var prop = "_erd";

function initState(element) {
    element[prop] = {};
    return getState(element);
}

function getState(element) {
    return element[prop];
}

function cleanState(element) {
    delete element[prop];
}

module.exports = {
    initState: initState,
    getState: getState,
    cleanState: cleanState
};


/***/ }),

/***/ "../node_modules/events/events.js":
/***/ (function(module, exports) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function(n) {
  if (!isNumber(n) || n < 0 || isNaN(n))
    throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function(type) {
  var er, handler, len, args, i, listeners;

  if (!this._events)
    this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error ||
        (isObject(this._events.error) && !this._events.error.length)) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
    }
  }

  handler = this._events[type];

  if (isUndefined(handler))
    return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    args = Array.prototype.slice.call(arguments, 1);
    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++)
      listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function(type, listener) {
  var m;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events)
    this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener)
    this.emit('newListener', type,
              isFunction(listener.listener) ?
              listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);
  else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' +
                    'leak detected. %d listeners added. ' +
                    'Use emitter.setMaxListeners() to increase limit.',
                    this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function(type, listener) {
  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function(type, listener) {
  var list, position, length, i;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events || !this._events[type])
    return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener ||
      (isFunction(list.listener) && list.listener === listener)) {
    delete this._events[type];
    if (this._events.removeListener)
      this.emit('removeListener', type, listener);

  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener ||
          (list[i].listener && list[i].listener === listener)) {
        position = i;
        break;
      }
    }

    if (position < 0)
      return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener)
      this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function(type) {
  var key, listeners;

  if (!this._events)
    return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0)
      this._events = {};
    else if (this._events[type])
      delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    while (listeners.length)
      this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function(type) {
  var ret;
  if (!this._events || !this._events[type])
    ret = [];
  else if (isFunction(this._events[type]))
    ret = [this._events[type]];
  else
    ret = this._events[type].slice();
  return ret;
};

EventEmitter.prototype.listenerCount = function(type) {
  if (this._events) {
    var evlistener = this._events[type];

    if (isFunction(evlistener))
      return 1;
    else if (evlistener)
      return evlistener.length;
  }
  return 0;
};

EventEmitter.listenerCount = function(emitter, type) {
  return emitter.listenerCount(type);
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}


/***/ }),

/***/ "../node_modules/exenv/index.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return ExecutionEnvironment;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),

/***/ "../node_modules/fetch-intercept/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/*
	* Configuration for React-Native's package system
	* @providesModule whatwg-fetch
	*/
	
	// Uses Emscripten stategy for determining environment
	var ENVIRONMENT_IS_REACT_NATIVE = (typeof navigator === 'undefined' ? 'undefined' : _typeof(navigator)) === 'object' && navigator.product === 'ReactNative';
	var ENVIRONMENT_IS_NODE = (typeof process === 'undefined' ? 'undefined' : _typeof(process)) === 'object' && "function" === 'function';
	var ENVIRONMENT_IS_WEB = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object';
	var ENVIRONMENT_IS_WORKER = typeof importScripts === 'function';
	
	if (ENVIRONMENT_IS_REACT_NATIVE) {
	  attach(global);
	} else if (ENVIRONMENT_IS_WORKER) {
	  attach(self);
	} else if (ENVIRONMENT_IS_WEB) {
	  attach(window);
	} else if (ENVIRONMENT_IS_NODE) {
	  attach(global);
	} else {
	  throw new Error('Unsupported environment for fetch-intercept');
	}
	
	function attach(env) {
	  // Make sure fetch is avaibale in the given environment
	  if (!env.fetch) {
	    try {
	      __webpack_require__(2);
	    } catch (err) {
	      throw Error('No fetch avaibale. Unable to register fetch-intercept');
	    }
	  }
	  env.fetch = function (fetch) {
	    return function () {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return interceptor.apply(undefined, [fetch].concat(args));
	    };
	  }(env.fetch);
	}
	
	var interceptors = [];
	
	function interceptor(fetch) {
	  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    args[_key2 - 1] = arguments[_key2];
	  }
	
	  var reversedInterceptors = interceptors.reduce(function (array, interceptor) {
	    return [interceptor].concat(array);
	  }, []);
	  var promise = Promise.resolve(args);
	
	  // Register request interceptors
	  reversedInterceptors.forEach(function (_ref) {
	    var request = _ref.request;
	    var requestError = _ref.requestError;
	
	    if (request || requestError) {
	      promise = promise.then(function (args) {
	        return request.apply(undefined, _toConsumableArray(args));
	      }, requestError);
	    }
	  });
	
	  // Register fetch call
	  promise = promise.then(function (args) {
	    return fetch.apply(undefined, _toConsumableArray(args));
	  });
	
	  // Register response interceptors
	  reversedInterceptors.forEach(function (_ref2) {
	    var response = _ref2.response;
	    var responseError = _ref2.responseError;
	
	    if (response || responseError) {
	      promise = promise.then(response, responseError);
	    }
	  });
	
	  return promise;
	}
	
	module.exports = {
	  register: function register(interceptor) {
	    interceptors.push(interceptor);
	    return function () {
	      var index = interceptors.indexOf(interceptor);
	      if (index >= 0) {
	        interceptors.splice(index, 1);
	      }
	    };
	  },
	  clear: function clear() {
	    interceptors = [];
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), (function() { return this; }())))

/***/ },
/* 1 */
/***/ function(module, exports) {

	'use strict';
	
	// shim for using process in browser
	
	var process = module.exports = {};
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = setTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while (len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    clearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        setTimeout(drainQueue, 0);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () {
	    return '/';
	};
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function () {
	    return 0;
	};

/***/ },
/* 2 */
/***/ function(module, exports) {

	module.exports = __webpack_require__("../node_modules/whatwg-fetch/fetch.js");

/***/ }
/******/ ]);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../node_modules/fontfaceobserver/fontfaceobserver.standalone.js":
/***/ (function(module, exports, __webpack_require__) {

/* Font Face Observer v2.0.13 - © Bram Stein. License: BSD-3-Clause */(function(){function l(a,b){document.addEventListener?a.addEventListener("scroll",b,!1):a.attachEvent("scroll",b)}function m(a){document.body?a():document.addEventListener?document.addEventListener("DOMContentLoaded",function c(){document.removeEventListener("DOMContentLoaded",c);a()}):document.attachEvent("onreadystatechange",function k(){if("interactive"==document.readyState||"complete"==document.readyState)document.detachEvent("onreadystatechange",k),a()})};function r(a){this.a=document.createElement("div");this.a.setAttribute("aria-hidden","true");this.a.appendChild(document.createTextNode(a));this.b=document.createElement("span");this.c=document.createElement("span");this.h=document.createElement("span");this.f=document.createElement("span");this.g=-1;this.b.style.cssText="max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;";this.c.style.cssText="max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;";
this.f.style.cssText="max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;";this.h.style.cssText="display:inline-block;width:200%;height:200%;font-size:16px;max-width:none;";this.b.appendChild(this.h);this.c.appendChild(this.f);this.a.appendChild(this.b);this.a.appendChild(this.c)}
function t(a,b){a.a.style.cssText="max-width:none;min-width:20px;min-height:20px;display:inline-block;overflow:hidden;position:absolute;width:auto;margin:0;padding:0;top:-999px;white-space:nowrap;font-synthesis:none;font:"+b+";"}function y(a){var b=a.a.offsetWidth,c=b+100;a.f.style.width=c+"px";a.c.scrollLeft=c;a.b.scrollLeft=a.b.scrollWidth+100;return a.g!==b?(a.g=b,!0):!1}function z(a,b){function c(){var a=k;y(a)&&a.a.parentNode&&b(a.g)}var k=a;l(a.b,c);l(a.c,c);y(a)};function A(a,b){var c=b||{};this.family=a;this.style=c.style||"normal";this.weight=c.weight||"normal";this.stretch=c.stretch||"normal"}var B=null,C=null,E=null,F=null;function G(){if(null===C)if(J()&&/Apple/.test(window.navigator.vendor)){var a=/AppleWebKit\/([0-9]+)(?:\.([0-9]+))(?:\.([0-9]+))/.exec(window.navigator.userAgent);C=!!a&&603>parseInt(a[1],10)}else C=!1;return C}function J(){null===F&&(F=!!document.fonts);return F}
function K(){if(null===E){var a=document.createElement("div");try{a.style.font="condensed 100px sans-serif"}catch(b){}E=""!==a.style.font}return E}function L(a,b){return[a.style,a.weight,K()?a.stretch:"","100px",b].join(" ")}
A.prototype.load=function(a,b){var c=this,k=a||"BESbswy",q=0,D=b||3E3,H=(new Date).getTime();return new Promise(function(a,b){if(J()&&!G()){var M=new Promise(function(a,b){function e(){(new Date).getTime()-H>=D?b():document.fonts.load(L(c,'"'+c.family+'"'),k).then(function(c){1<=c.length?a():setTimeout(e,25)},function(){b()})}e()}),N=new Promise(function(a,c){q=setTimeout(c,D)});Promise.race([N,M]).then(function(){clearTimeout(q);a(c)},function(){b(c)})}else m(function(){function u(){var b;if(b=-1!=
f&&-1!=g||-1!=f&&-1!=h||-1!=g&&-1!=h)(b=f!=g&&f!=h&&g!=h)||(null===B&&(b=/AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent),B=!!b&&(536>parseInt(b[1],10)||536===parseInt(b[1],10)&&11>=parseInt(b[2],10))),b=B&&(f==v&&g==v&&h==v||f==w&&g==w&&h==w||f==x&&g==x&&h==x)),b=!b;b&&(d.parentNode&&d.parentNode.removeChild(d),clearTimeout(q),a(c))}function I(){if((new Date).getTime()-H>=D)d.parentNode&&d.parentNode.removeChild(d),b(c);else{var a=document.hidden;if(!0===a||void 0===a)f=e.a.offsetWidth,
g=n.a.offsetWidth,h=p.a.offsetWidth,u();q=setTimeout(I,50)}}var e=new r(k),n=new r(k),p=new r(k),f=-1,g=-1,h=-1,v=-1,w=-1,x=-1,d=document.createElement("div");d.dir="ltr";t(e,L(c,"sans-serif"));t(n,L(c,"serif"));t(p,L(c,"monospace"));d.appendChild(e.a);d.appendChild(n.a);d.appendChild(p.a);document.body.appendChild(d);v=e.a.offsetWidth;w=n.a.offsetWidth;x=p.a.offsetWidth;I();z(e,function(a){f=a;u()});t(e,L(c,'"'+c.family+'",sans-serif'));z(n,function(a){g=a;u()});t(n,L(c,'"'+c.family+'",serif'));
z(p,function(a){h=a;u()});t(p,L(c,'"'+c.family+'",monospace'))})})}; true?module.exports=A:(window.FontFaceObserver=A,window.FontFaceObserver.prototype.load=A.prototype.load);}());


/***/ }),

/***/ "../node_modules/fscreen/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var key = {
  fullscreenEnabled: 0,
  fullscreenElement: 1,
  requestFullscreen: 2,
  exitFullscreen: 3,
  fullscreenchange: 4,
  fullscreenerror: 5
};

var webkit = ['webkitFullscreenEnabled', 'webkitFullscreenElement', 'webkitRequestFullscreen', 'webkitExitFullscreen', 'webkitfullscreenchange', 'webkitfullscreenerror'];

var moz = ['mozFullScreenEnabled', 'mozFullScreenElement', 'mozRequestFullScreen', 'mozCancelFullScreen', 'mozfullscreenchange', 'mozfullscreenerror'];

var ms = ['msFullscreenEnabled', 'msFullscreenElement', 'msRequestFullscreen', 'msExitFullscreen', 'MSFullscreenChange', 'MSFullscreenError'];

// so it doesn't throw if no window or document
var document = typeof window !== 'undefined' && typeof window.document !== 'undefined' ? window.document : {};

var vendor = 'fullscreenEnabled' in document && Object.keys(key) || webkit[0] in document && webkit || moz[0] in document && moz || ms[0] in document && ms || [];

exports.default = {
  requestFullscreen: function requestFullscreen(element) {
    return element[vendor[key.requestFullscreen]]();
  },
  requestFullscreenFunction: function requestFullscreenFunction(element) {
    return element[vendor[key.requestFullscreen]];
  },
  get exitFullscreen() {
    return document[vendor[key.exitFullscreen]].bind(document);
  },
  addEventListener: function addEventListener(type, handler, options) {
    return document.addEventListener(vendor[key[type]], handler, options);
  },
  removeEventListener: function removeEventListener(type, handler, options) {
    return document.removeEventListener(vendor[key[type]], handler, options);
  },
  get fullscreenEnabled() {
    return Boolean(document[vendor[key.fullscreenEnabled]]);
  },
  set fullscreenEnabled(val) {},
  get fullscreenElement() {
    return document[vendor[key.fullscreenElement]];
  },
  set fullscreenElement(val) {},
  get onfullscreenchange() {
    return document[('on' + vendor[key.fullscreenchange]).toLowerCase()];
  },
  set onfullscreenchange(handler) {
    return document[('on' + vendor[key.fullscreenchange]).toLowerCase()] = handler;
  },
  get onfullscreenerror() {
    return document[('on' + vendor[key.fullscreenerror]).toLowerCase()];
  },
  set onfullscreenerror(handler) {
    return document[('on' + vendor[key.fullscreenerror]).toLowerCase()] = handler;
  }
};

/***/ }),

/***/ "../node_modules/hash-sum/hash-sum.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function pad (hash, len) {
  while (hash.length < len) {
    hash = '0' + hash;
  }
  return hash;
}

function fold (hash, text) {
  var i;
  var chr;
  var len;
  if (text.length === 0) {
    return hash;
  }
  for (i = 0, len = text.length; i < len; i++) {
    chr = text.charCodeAt(i);
    hash = ((hash << 5) - hash) + chr;
    hash |= 0;
  }
  return hash < 0 ? hash * -2 : hash;
}

function foldObject (hash, o, seen) {
  return Object.keys(o).sort().reduce(foldKey, hash);
  function foldKey (hash, key) {
    return foldValue(hash, o[key], key, seen);
  }
}

function foldValue (input, value, key, seen) {
  var hash = fold(fold(fold(input, key), toString(value)), typeof value);
  if (value === null) {
    return fold(hash, 'null');
  }
  if (value === undefined) {
    return fold(hash, 'undefined');
  }
  if (typeof value === 'object') {
    if (seen.indexOf(value) !== -1) {
      return fold(hash, '[Circular]' + key);
    }
    seen.push(value);
    return foldObject(hash, value, seen);
  }
  return fold(hash, value.toString());
}

function toString (o) {
  return Object.prototype.toString.call(o);
}

function sum (o) {
  return pad(foldValue(0, o, '', []).toString(16), 8);
}

module.exports = sum;


/***/ }),

/***/ "../node_modules/history/DOMUtils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),

/***/ "../node_modules/history/createBrowserHistory.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__("../node_modules/warning/browser.js");

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__("../node_modules/invariant/browser.js");

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__("../node_modules/history/LocationUtils.js");

var _PathUtils = __webpack_require__("../node_modules/history/PathUtils.js");

var _createTransitionManager = __webpack_require__("../node_modules/history/createTransitionManager.js");

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__("../node_modules/history/DOMUtils.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = (0, _DOMUtils.supportsHistory)();
  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + (0, _PathUtils.createPath)(location);
  };

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createBrowserHistory;

/***/ }),

/***/ "../node_modules/history/createHashHistory.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__("../node_modules/warning/browser.js");

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__("../node_modules/invariant/browser.js");

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__("../node_modules/history/LocationUtils.js");

var _PathUtils = __webpack_require__("../node_modules/history/PathUtils.js");

var _createTransitionManager = __webpack_require__("../node_modules/history/createTransitionManager.js");

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__("../node_modules/history/DOMUtils.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + (0, _PathUtils.stripLeadingSlash)(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: _PathUtils.stripLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  },
  slash: {
    encodePath: _PathUtils.addLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && (0, _LocationUtils.locationsAreEqual)(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === (0, _PathUtils.createPath)(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [(0, _PathUtils.createPath)(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + (0, _PathUtils.createPath)(location));
  };

  var push = function push(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        (0, _warning2.default)(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf((0, _PathUtils.createPath)(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    (0, _warning2.default)(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createHashHistory;

/***/ }),

/***/ "../node_modules/ieee754/index.js":
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ "../node_modules/inherits/inherits_browser.js":
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),

/***/ "../node_modules/is-buffer/index.js":
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),

/***/ "../node_modules/is-retina/index.js":
/***/ (function(module, exports) {

module.exports = function() {
  var mediaQuery;
  if (typeof window !== "undefined" && window !== null) {
    mediaQuery = "(-webkit-min-device-pixel-ratio: 1.25), (min--moz-device-pixel-ratio: 1.25), (-o-min-device-pixel-ratio: 5/4), (min-resolution: 1.25dppx)";
    if (window.devicePixelRatio > 1.25) {
      return true;
    }
    if (window.matchMedia && window.matchMedia(mediaQuery).matches) {
      return true;
    }
  }
  return false;
};


/***/ }),

/***/ "../node_modules/isarray/index.js":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),

/***/ "../node_modules/kefir-bus/index.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/kefir/dist/kefir.js")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    module.exports = factory(require('kefir'));
  } else {
    root.KefirBus = factory(root.Kefir);
  }
}(this, function (Kefir) {

  var dummyPool = {plug: function() {}, unplug: function() {}};

  return function kefirBus() {
    var ended = false;
    var pool = Kefir.pool();
    var emitter = null;

    var stream = Kefir.stream(function(_emitter) {
      function sub(event) {
        _emitter.emitEvent(event);
      }
      emitter = _emitter;

      if (ended) {
        _emitter.end();
      } else {
        pool.onAny(sub);
        return function() {
          emitter = null;
          pool.offAny(sub);
        };
      }
    });

    stream.value = stream.emit = function(x) {
      if (emitter) emitter.emit(x);
      return stream;
    };

    stream.error = function(err) {
      if (emitter) emitter.error(err);
      return stream;
    };

    stream.event = stream.emitEvent = function(event) {
      if (event.type === 'end') {
        stream.end();
      } else {
        if (emitter) emitter.emitEvent(event);
      }
      return stream;
    };

    stream.plug = function(s) {
      pool.plug(s);
      return stream;
    };

    stream.unplug = function(s) {
      pool.unplug(s);
      return stream;
    };

    stream.end = function() {
      if (!ended) {
        ended = true;
        if (emitter) emitter.end();
        pool = dummyPool;
      }
      return stream;
    };

    return stream.setName('bus');
  };
}));


/***/ }),

/***/ "../node_modules/keyboardevent-key-polyfill/index.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/* global define, KeyboardEvent, module */

(function () {

  var keyboardeventKeyPolyfill = {
    polyfill: polyfill,
    keys: {
      3: 'Cancel',
      6: 'Help',
      8: 'Backspace',
      9: 'Tab',
      12: 'Clear',
      13: 'Enter',
      16: 'Shift',
      17: 'Control',
      18: 'Alt',
      19: 'Pause',
      20: 'CapsLock',
      27: 'Escape',
      28: 'Convert',
      29: 'NonConvert',
      30: 'Accept',
      31: 'ModeChange',
      32: ' ',
      33: 'PageUp',
      34: 'PageDown',
      35: 'End',
      36: 'Home',
      37: 'ArrowLeft',
      38: 'ArrowUp',
      39: 'ArrowRight',
      40: 'ArrowDown',
      41: 'Select',
      42: 'Print',
      43: 'Execute',
      44: 'PrintScreen',
      45: 'Insert',
      46: 'Delete',
      48: ['0', ')'],
      49: ['1', '!'],
      50: ['2', '@'],
      51: ['3', '#'],
      52: ['4', '$'],
      53: ['5', '%'],
      54: ['6', '^'],
      55: ['7', '&'],
      56: ['8', '*'],
      57: ['9', '('],
      91: 'OS',
      93: 'ContextMenu',
      144: 'NumLock',
      145: 'ScrollLock',
      181: 'VolumeMute',
      182: 'VolumeDown',
      183: 'VolumeUp',
      186: [';', ':'],
      187: ['=', '+'],
      188: [',', '<'],
      189: ['-', '_'],
      190: ['.', '>'],
      191: ['/', '?'],
      192: ['`', '~'],
      219: ['[', '{'],
      220: ['\\', '|'],
      221: [']', '}'],
      222: ["'", '"'],
      224: 'Meta',
      225: 'AltGraph',
      246: 'Attn',
      247: 'CrSel',
      248: 'ExSel',
      249: 'EraseEof',
      250: 'Play',
      251: 'ZoomOut'
    }
  };

  // Function keys (F1-24).
  var i;
  for (i = 1; i < 25; i++) {
    keyboardeventKeyPolyfill.keys[111 + i] = 'F' + i;
  }

  // Printable ASCII characters.
  var letter = '';
  for (i = 65; i < 91; i++) {
    letter = String.fromCharCode(i);
    keyboardeventKeyPolyfill.keys[i] = [letter.toLowerCase(), letter.toUpperCase()];
  }

  function polyfill () {
    if (!('KeyboardEvent' in window) ||
        'key' in KeyboardEvent.prototype) {
      return false;
    }

    // Polyfill `key` on `KeyboardEvent`.
    var proto = {
      get: function (x) {
        var key = keyboardeventKeyPolyfill.keys[this.which || this.keyCode];

        if (Array.isArray(key)) {
          key = key[+this.shiftKey];
        }

        return key;
      }
    };
    Object.defineProperty(KeyboardEvent.prototype, 'key', proto);
    return proto;
  }

  if (true) {
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (keyboardeventKeyPolyfill),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== 'undefined' && typeof module !== 'undefined') {
    module.exports = keyboardeventKeyPolyfill;
  } else if (window) {
    window.keyboardeventKeyPolyfill = keyboardeventKeyPolyfill;
  }

})();


/***/ }),

/***/ "../node_modules/line-height/lib/line-height.js":
/***/ (function(module, exports, __webpack_require__) {

// Load in dependencies
var computedStyle = __webpack_require__("../node_modules/computed-style/dist/computedStyle.commonjs.js");

/**
 * Calculate the `line-height` of a given node
 * @param {HTMLElement} node Element to calculate line height of. Must be in the DOM.
 * @returns {Number} `line-height` of the element in pixels
 */
function lineHeight(node) {
  // Grab the line-height via style
  var lnHeightStr = computedStyle(node, 'line-height');
  var lnHeight = parseFloat(lnHeightStr, 10);

  // If the lineHeight did not contain a unit (i.e. it was numeric), convert it to ems (e.g. '2.3' === '2.3em')
  if (lnHeightStr === lnHeight + '') {
    // Save the old lineHeight style and update the em unit to the element
    var _lnHeightStyle = node.style.lineHeight;
    node.style.lineHeight = lnHeightStr + 'em';

    // Calculate the em based height
    lnHeightStr = computedStyle(node, 'line-height');
    lnHeight = parseFloat(lnHeightStr, 10);

    // Revert the lineHeight style
    if (_lnHeightStyle) {
      node.style.lineHeight = _lnHeightStyle;
    } else {
      delete node.style.lineHeight;
    }
  }

  // If the lineHeight is in `pt`, convert it to pixels (4px for 3pt)
  // DEV: `em` units are converted to `pt` in IE6
  // Conversion ratio from https://developer.mozilla.org/en-US/docs/Web/CSS/length
  if (lnHeightStr.indexOf('pt') !== -1) {
    lnHeight *= 4;
    lnHeight /= 3;
  // Otherwise, if the lineHeight is in `mm`, convert it to pixels (96px for 25.4mm)
  } else if (lnHeightStr.indexOf('mm') !== -1) {
    lnHeight *= 96;
    lnHeight /= 25.4;
  // Otherwise, if the lineHeight is in `cm`, convert it to pixels (96px for 2.54cm)
  } else if (lnHeightStr.indexOf('cm') !== -1) {
    lnHeight *= 96;
    lnHeight /= 2.54;
  // Otherwise, if the lineHeight is in `in`, convert it to pixels (96px for 1in)
  } else if (lnHeightStr.indexOf('in') !== -1) {
    lnHeight *= 96;
  // Otherwise, if the lineHeight is in `pc`, convert it to pixels (12pt for 1pc)
  } else if (lnHeightStr.indexOf('pc') !== -1) {
    lnHeight *= 16;
  }

  // Continue our computation
  lnHeight = Math.round(lnHeight);

  // If the line-height is "normal", calculate by font-size
  if (lnHeightStr === 'normal') {
    // Create a temporary node
    var nodeName = node.nodeName;
    var _node = document.createElement(nodeName);
    _node.innerHTML = '&nbsp;';

    // If we have a text area, reset it to only 1 row
    // https://github.com/twolfson/line-height/issues/4
    if (nodeName.toUpperCase() === 'TEXTAREA') {
      _node.setAttribute('rows', '1');
    }

    // Set the font-size of the element
    var fontSizeStr = computedStyle(node, 'font-size');
    _node.style.fontSize = fontSizeStr;

    // Remove default padding/border which can affect offset height
    // https://github.com/twolfson/line-height/issues/4
    // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetHeight
    _node.style.padding = '0px';
    _node.style.border = '0px';

    // Append it to the body
    var body = document.body;
    body.appendChild(_node);

    // Assume the line height of the element is the height
    var height = _node.offsetHeight;
    lnHeight = height;

    // Remove our child from the DOM
    body.removeChild(_node);
  }

  // Return the calculated height
  return lnHeight;
}

// Export lineHeight
module.exports = lineHeight;


/***/ }),

/***/ "../node_modules/lingui-formats/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

function date(language) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var formatter = new Intl.DateTimeFormat(language, format);
  return function (value) {
    return formatter.format(value);
  };
}

function number(language) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var formatter = new Intl.NumberFormat(language, format);
  return function (value) {
    return formatter.format(value);
  };
}

exports.date = date;
exports.number = number;


/***/ }),

/***/ "../node_modules/lingui-i18n/dev.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("../node_modules/lingui-i18n/dist/dev/index.js")


/***/ }),

/***/ "../node_modules/lingui-i18n/dist/dev/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _extends = _interopDefault(__webpack_require__("../node_modules/babel-runtime/helpers/extends.js"));
var messageformatParser = __webpack_require__("../node_modules/messageformat-parser/parser.js");
var _Object$getOwnPropertyNames = _interopDefault(__webpack_require__("../node_modules/babel-runtime/core-js/object/get-own-property-names.js"));
var _slicedToArray = _interopDefault(__webpack_require__("../node_modules/babel-runtime/helpers/slicedToArray.js"));
var plurals = _interopDefault(__webpack_require__("../node_modules/make-plural/umd/plurals.js"));

var isString = function isString(s) {
  return typeof s === 'string';
};

// [Tokens] -> (CTX -> String)
function processTokens(tokens) {
  var octothorpe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!tokens.filter(function (token) {
    return !isString(token);
  }).length) {
    return tokens.join('').trim();
  }

  return function (ctx) {
    return tokens.map(function (token) {
      if (isString(token)) {
        return token;

        // # in plural case
      } else if (token.type === 'octothorpe') {
        var name = octothorpe.name,
            _octothorpe$offset = octothorpe.offset,
            _offset = _octothorpe$offset === undefined ? 0 : _octothorpe$offset;

        return ctx(name) - _offset;

        // simple argument
      } else if (token.type === 'argument') {
        return ctx(token.arg);

        // argument with custom format (date, number)
      } else if (token.type === 'function') {
        return ctx(token.arg, token.key, token.params[0]);
      }

      var offset = token.offset ? parseInt(token.offset) : undefined;

      // complex argument with cases
      var formatProps = {};
      token.cases.forEach(function (item) {
        formatProps[item.key] = processTokens(item.tokens, {
          name: token.arg,
          offset: offset
        });
      });

      return ctx(token.arg, token.type, _extends({
        offset: offset
      }, formatProps));
    });
  };
}

// Message -> (Params -> String)
function compile(message) {
  return processTokens(messageformatParser.parse(message));
}

var loadLanguageData = (function (locale) {
  if (!locale) {
    return;
  }

  var _locale$split = locale.split('_'),
      _locale$split2 = _slicedToArray(_locale$split, 1),
      language = _locale$split2[0];

  return { plurals: plurals[language] };
});

var index = {
  compile: compile,
  loadLanguageData: loadLanguageData
};

module.exports = index;


/***/ }),

/***/ "../node_modules/lingui-i18n/dist/index.es.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return i18nMark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return i18n; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setupI18n; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return unpackCatalog; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("../node_modules/babel-runtime/helpers/extends.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("../node_modules/babel-runtime/core-js/object/keys.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__("../node_modules/babel-runtime/helpers/typeof.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__("../node_modules/babel-runtime/helpers/classCallCheck.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__("../node_modules/babel-runtime/helpers/createClass.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__("../node_modules/babel-runtime/helpers/objectWithoutProperties.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lingui_formats__ = __webpack_require__("../node_modules/lingui-formats/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lingui_formats___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lingui_formats__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_own_property_names__ = __webpack_require__("../node_modules/babel-runtime/core-js/object/get-own-property-names.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_own_property_names___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_own_property_names__);









var isString = function isString(s) {
  return typeof s === 'string';
};
var isFunction = function isFunction(f) {
  return typeof f === 'function';
};
function isEmpty(obj) {
  // null and undefined are "empty"
  if (obj === null || obj === undefined) return true;

  if (obj.length > 0) return false;
  if (obj.length === 0) return true;

  return !__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_get_own_property_names___default()(obj).length;
}

var defaultFormats = function defaultFormats(language) {
  var languageData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var plurals = languageData.plurals;

  var style = function style(format) {
    return isString(format) ? formats[format] || { style: format } : format;
  };

  var replaceOctothorpe = function replaceOctothorpe(value, message) {
    return function (ctx) {
      var msg = isFunction(message) ? message(ctx) : message;
      var norm = Array.isArray(msg) ? msg : [msg];
      return norm.map(function (m) {
        return isString(m) ? m.replace('#', value) : m;
      });
    };
  };

  return {
    plural: function plural(value, _ref) {
      var _ref$offset = _ref.offset,
          offset = _ref$offset === undefined ? 0 : _ref$offset,
          rules = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['offset']);

      var message = rules[value] || rules[plurals(value - offset)];
      return replaceOctothorpe(value - offset, message);
    },

    selectordinal: function selectordinal(value, _ref2) {
      var _ref2$offset = _ref2.offset,
          offset = _ref2$offset === undefined ? 0 : _ref2$offset,
          rules = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_objectWithoutProperties___default()(_ref2, ['offset']);

      var message = rules[value] || rules[plurals(value - offset, true)];
      return replaceOctothorpe(value - offset, message);
    },

    select: function select(value, rules) {
      return rules[value] || rules.other;
    },

    number: function number$$1(value, format) {
      return Object(__WEBPACK_IMPORTED_MODULE_6_lingui_formats__["number"])(language, style(format))(value);
    },

    date: function date$$1(value, format) {
      return Object(__WEBPACK_IMPORTED_MODULE_6_lingui_formats__["date"])(language, style(format))(value);
    },

    undefined: function undefined(value) {
      return value;
    }
  };
};

// Params -> CTX
/**
 * Creates a context object, which formats ICU MessageFormat arguments based on
 * argument type.
 *
 * @param language     - Language of message
 * @param values       - Parameters for variable interpolation
 * @param languageData - Language data (e.g: plurals)
 * @param formats - Custom format styles
 * @returns {function(string, string, any)}
 */
function context(_ref3) {
  var language = _ref3.language,
      values = _ref3.values,
      formats = _ref3.formats,
      languageData = _ref3.languageData;

  var formatters = defaultFormats(language, languageData, formats);

  var ctx = function ctx(name, type, format) {
    var value = values[name];
    var formatted = formatters[type](value, format);
    var message = isFunction(formatted) ? formatted(ctx) : formatted;
    return Array.isArray(message) ? message.join('') : message;
  };

  return ctx;
}

function interpolate(translation, language, languageData) {
  return function (values) {
    var formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var message = translation(context({
      language: language, languageData: languageData, formats: formats, values: values
    }));

    return Array.isArray(message) ? message.join('').trim() : message;
  };
}

var flatten = function flatten(arrays) {
  return [].concat.apply([], arrays);
};
var zip = function zip(a, b) {
  return a.map(function (item, index) {
    return [item, b[index]];
  });
};

var t = function t(strings) {
  for (var _len = arguments.length, values = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  return flatten(zip(strings, values)).join('');
};

var _plural = function _plural(type) {
  return function (i18n) {
    return function (_ref) {
      var value = _ref.value,
          _ref$offset = _ref.offset,
          offset = _ref$offset === undefined ? 0 : _ref$offset,
          other = _ref.other,
          pluralForms = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['value', 'offset', 'other']);

      var diff = value - offset;
      var translation = pluralForms[value.toString()] || // exact match
      pluralForms[i18n.pluralForm(diff, type)] || // plural form
      other;
      return translation.replace('#', diff.toString());
    };
  };
};

var plural = _plural('cardinal');
var selectOrdinal = _plural('ordinal');

function select(_ref2) {
  var value = _ref2.value,
      other = _ref2.other,
      selectForms = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_objectWithoutProperties___default()(_ref2, ['value', 'other']);

  return selectForms[value] || other;
}

function getLanguageData(catalog) {
  return (catalog || {}).languageData || {};
}

function getMessages(catalog) {
  return (catalog || {}).messages || {};
}

var I18n = function () {

  // Message catalogs
  function I18n() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, I18n);

    // Messages and languageData are merged on load,
    // so we must initialize it manually
    this._activeMessages = {};
    this._catalogs = {};

    if (false) {
      this.t = t;
      this.select = select;
      this.plural = plural(this);
      this.selectOrdinal = selectOrdinal(this);
    }
  }

  // Messages/langauge data in active language.
  // This is optimization, so we don't perform object lookup
  // _catalogs[language] for each translation.


  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(I18n, [{
    key: '_cacheActiveLanguage',
    value: function _cacheActiveLanguage() {
      var activeCatalog = this._catalogs[this.language];

      var languageData = getLanguageData(activeCatalog);
      if (false) {
        // Allow overriding data in development, useful for testing
        if (isEmpty(languageData) && this._dev && isFunction(this._dev.loadLanguageData)) {
          languageData = this._dev.loadLanguageData(this.language);
        }
      }

      this._activeMessages = getMessages(activeCatalog);
      this._activeLanguageData = languageData;
    }
  }, {
    key: 'load',
    value: function load(catalogs) {
      var _this = this;

      if ((typeof catalogs === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(catalogs)) !== 'object') return;

      // deeply merge Catalogs
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this._catalogs, catalogs)).forEach(function (language) {
        var compiledMessages = getMessages(catalogs[language]);

        if (false) {
          if (_this._dev && isFunction(_this._dev.compile)) {
            compiledMessages = _Object$keys(compiledMessages).reduce(function (dict, id) {
              var msg = compiledMessages[id];
              dict[id] = isString(msg) ? _this._dev.compile(msg) : msg;
              return dict;
            }, {});
          }
        }

        _this._catalogs[language] = {
          messages: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, getMessages(_this._catalogs[language]), compiledMessages),
          languageData: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, getLanguageData(_this._catalogs[language]), getLanguageData(catalogs[language]))
        };
      });

      this._cacheActiveLanguage();
    }
  }, {
    key: 'activate',
    value: function activate(language) {
      if (!language) return;

      if (false) {
        if (this.availableLanguages.indexOf(language) === -1) {
          console.warn('Message catalog for locale "' + language + '" not loaded.');
        }
      }

      this._language = language;
      this._cacheActiveLanguage();
    }
  }, {
    key: 'use',
    value: function use(language) {
      return setupI18n({
        language: language,
        catalogs: this._catalogs,
        development: this._dev
      });
    }

    // default translate method

  }, {
    key: '_',
    value: function _(id) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          defaults = _ref.defaults,
          _ref$values = _ref.values,
          values = _ref$values === undefined ? {} : _ref$values,
          _ref$formats = _ref.formats,
          formats = _ref$formats === undefined ? {} : _ref$formats;

      var translation = this.messages[id] || defaults || id;

      if (false) {
        if (isString(translation) && this._dev && isFunction(this._dev.compile)) {
          translation = this._dev.compile(translation);
        }
      }

      if (typeof translation !== 'function') return translation;
      return interpolate(translation, this.language, this.languageData)(values, formats);
    }
  }, {
    key: 'pluralForm',
    value: function pluralForm(n) {
      var pluralType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'cardinal';

      if (!this.languageData.plurals) return 'other';
      return this.languageData.plurals(n, pluralType === 'ordinal');
    }
  }, {
    key: 'development',
    value: function development(config) {
      this._dev = config;
    }
  }, {
    key: 'availableLanguages',
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this._catalogs);
    }
  }, {
    key: 'language',
    get: function get() {
      return this._language;
    }
  }, {
    key: 'messages',
    get: function get() {
      return this._activeMessages;
    }
  }, {
    key: 'languageData',
    get: function get() {
      return this._activeLanguageData;
    }
  }]);

  return I18n;
}();

function setupI18n() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var i18n = new I18n();

  if (false) {
    if (params.development) i18n.development(params.development);
  }

  if (params.catalogs) i18n.load(params.catalogs);
  if (params.language) i18n.activate(params.language);

  return i18n;
}

var i18n = setupI18n();

function unpackCatalog(compiled) {
  return {
    messages: compiled.m,
    languageData: {
      plurals: compiled.l && compiled.l.p
    }
  };
}

var i18nMark = function i18nMark(id) {
  return id;
};


/* unused harmony default export */ var _unused_webpack_default_export = (i18n);


/***/ }),

/***/ "../node_modules/lingui-i18n/index.es.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dist_index_es__ = __webpack_require__("../node_modules/lingui-i18n/dist/index.es.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "i18nMark", function() { return __WEBPACK_IMPORTED_MODULE_0__dist_index_es__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "i18n", function() { return __WEBPACK_IMPORTED_MODULE_0__dist_index_es__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "setupI18n", function() { return __WEBPACK_IMPORTED_MODULE_0__dist_index_es__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "unpackCatalog", function() { return __WEBPACK_IMPORTED_MODULE_0__dist_index_es__["d"]; });



/***/ }),

/***/ "../node_modules/lingui-react/dist/index.es.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return withI18n; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return WithI18n; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DateFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NumberFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return i18nMark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return I18nProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Trans$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Plural; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Select; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SelectOrdinal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lingui_formats__ = __webpack_require__("../node_modules/lingui-formats/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lingui_formats___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lingui_formats__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("../node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("../node_modules/babel-runtime/core-js/object/get-prototype-of.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__("../node_modules/babel-runtime/helpers/classCallCheck.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__("../node_modules/babel-runtime/helpers/createClass.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__("../node_modules/babel-runtime/helpers/inherits.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends__ = __webpack_require__("../node_modules/babel-runtime/helpers/extends.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_hash_sum__ = __webpack_require__("../node_modules/hash-sum/hash-sum.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_hash_sum___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_hash_sum__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lingui_i18n__ = __webpack_require__("../node_modules/lingui-i18n/index.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_get_iterator__ = __webpack_require__("../node_modules/babel-runtime/core-js/get-iterator.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_slicedToArray__ = __webpack_require__("../node_modules/babel-runtime/helpers/slicedToArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_keys__ = __webpack_require__("../node_modules/babel-runtime/core-js/object/keys.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__("../node_modules/babel-runtime/helpers/objectWithoutProperties.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_babel_runtime_helpers_objectWithoutProperties__);
















var Render = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Render, _React$Component);

  function Render() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Render);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Render.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Render)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Render, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          value = _props.value;

      var render = this.props.render !== undefined ? this.props.render : this.context.linguiDefaultRender;

      if (render === undefined) {
        render = 'span';
      }

      if (render === null) {
        return value;
      } else if (typeof render === 'string') {
        // Built-in element: h1, p
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(render, { className: className }, value);
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(render)
      // Custom element: <p className="lear' />
      ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(render, {}, value)
      // Custom component: ({ translation }) => <a title={translation}>x</a>
      : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(render, { translation: value });
    }
  }]);

  return Render;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

Render.contextTypes = {
  linguiDefaultRender: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any
};

function createFormat(formatFunction) {
  return function (_ref) {
    var value = _ref.value,
        format = _ref.format,
        i18n = _ref.i18n,
        className = _ref.className,
        render = _ref.render;

    var formatter = formatFunction(i18n.language, format);
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Render, {
      className: className,
      render: render,
      value: formatter(value)
    });
  };
}

var withI18n = function withI18n() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (WrappedComponent) {
    if (false) {
      if (typeof options === 'function' || React.isValidElement(options)) {
        console.warn('withI18n([options]) takes options as a first argument, ' + 'but received React component itself. Without options, the Component ' + 'should be wrapped as withI18n()(Component), not withI18n(Component).');
      }
    }

    var _options$update = options.update,
        update = _options$update === undefined ? true : _options$update,
        _options$withHash = options.withHash,
        withHash = _options$withHash === undefined ? true : _options$withHash,
        _options$withRef = options.withRef,
        withRef = _options$withRef === undefined ? false : _options$withRef;

    var withI18n = function (_React$Component) {
      __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(withI18n, _React$Component);

      function withI18n() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, withI18n);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = withI18n.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(withI18n)).call.apply(_ref, [this].concat(args))), _this), _this.wrappedInstance = null, _this.setWrappedInstance = function (ref) {
          if (withRef) _this.wrappedInstance = ref;
        }, _this.getWrappedInstance = function () {
          if (!withRef) {
            throw new Error('To access the wrapped instance, you need to specify { withRef: true }' + ' in the options argument of the withI18n() call.');
          }

          return _this.wrappedInstance;
        }, _this.checkUpdate = /* istanbul ignore next */function () {
          _this.forceUpdate();
        }, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
      }

      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(withI18n, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          var _getI18n = this.getI18n(),
              subscribe = _getI18n.subscribe;

          if (update && subscribe) subscribe(this.checkUpdate);
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          var _getI18n2 = this.getI18n(),
              unsubscribe = _getI18n2.unsubscribe;

          if (update && unsubscribe) unsubscribe(this.checkUpdate);
        }

        // Test checks that subscribe/unsubscribe is called with function.

      }, {
        key: 'getI18n',
        value: function getI18n() {
          return this.context.linguiPublisher || {};
        }
      }, {
        key: 'render',
        value: function render() {
          var _getI18n3 = this.getI18n(),
              i18n = _getI18n3.i18n,
              i18nHash = _getI18n3.i18nHash;

          var props = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, this.props, withRef ? { ref: this.setWrappedInstance } : {}, withHash ? { i18nHash: i18nHash } : {});
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, props, { i18n: i18n }));
        }
      }]);

      return withI18n;
    }(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

    // return needs to be here, otherwise flow complains about {...this.props}
    // in WrappedComponent


    withI18n.contextTypes = {
      linguiPublisher: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object
    };
    return withI18n;
  };
};

// Deprecated, remove in 2.x
var deprecationWithI18nOnce = false;

var WithI18n = function WithI18n() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (false) {
    if (!deprecationWithI18nOnce) {
      deprecationWithI18nOnce = true;
      console.warn('WithI18n is deprecated and will be removed in lingui-react@2.x, ' + 'use withI18n instead (lower-cased first letter).');
    }
  }

  return withI18n(options);
};

/*
 * I18nPublisher - Connects to lingui-i18n/I18n class
 * Allows listeners to subscribe for changes
 */
function LinguiPublisher(i18n) {
  var subscribers = [];

  return {
    i18n: i18n,
    i18nHash: null,

    getSubscribers: function getSubscribers() {
      return subscribers;
    },
    subscribe: function subscribe(callback) {
      subscribers.push(callback);
    },
    unsubscribe: function unsubscribe(callback) {
      subscribers = subscribers.filter(function (cb) {
        return cb !== callback;
      });
    },
    update: function update() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          catalogs = _ref.catalogs,
          language = _ref.language;

      if (!catalogs && !language) return;

      if (catalogs) i18n.load(catalogs);
      if (language) i18n.activate(language);

      this.i18nHash = __WEBPACK_IMPORTED_MODULE_9_hash_sum___default()([i18n.language, i18n.messages]);

      subscribers.forEach(function (f) {
        return f();
      });
    }
  };
}

var I18nProvider = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(I18nProvider, _React$Component);

  function I18nProvider(props) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, I18nProvider);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (I18nProvider.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(I18nProvider)).call(this, props));

    var _this$props = _this.props,
        language = _this$props.language,
        catalogs = _this$props.catalogs,
        development = _this$props.development;

    var i18n = _this.props.i18n || Object(__WEBPACK_IMPORTED_MODULE_10_lingui_i18n__["setupI18n"])({
      language: language,
      catalogs: catalogs,
      development: development
    });
    _this.linguiPublisher = new LinguiPublisher(i18n);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(I18nProvider, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _props = this.props,
          language = _props.language,
          catalogs = _props.catalogs;

      if (language !== prevProps.language || catalogs !== prevProps.catalogs) {
        this.linguiPublisher.update({ language: language, catalogs: catalogs });
      }
    }
  }, {
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        linguiPublisher: this.linguiPublisher,
        linguiDefaultRender: this.props.defaultRender
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;

      return children && __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.count(children) > 1 ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        children
      ) : children;
    }
  }]);

  return I18nProvider;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

I18nProvider.defaultProps = {
  defaultRender: 'span'
};
I18nProvider.childContextTypes = {
  linguiPublisher: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object.isRequired,
  linguiDefaultRender: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any
};

// match <0>paired</0> and <1/> unpaired tags
var tagRe = /<(\d+)>(.*)<\/\1>|<(\d+)\/>/;
var nlRe = /(?:\r\n|\r|\n)/g;

/**
 * `formatElements` - parse string and return tree of react elements
 *
 * `value` is string to be formatted with <0>Paired<0/> or <0/> (unpaired)
 * placeholders. `elements` is a array of react elements which indexes
 * correspond to element indexes in formatted string
 */
function formatElements(value) {
  var elements = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  // TODO: warn if there're any unprocessed elements
  // TODO: warn if element at `index` doesn't exist

  var parts = value.replace(nlRe, '').split(tagRe);

  // no inline elements, return
  if (parts.length === 1) return value;

  var tree = [];

  var before = parts.shift();
  if (before) tree.push(before);

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_get_iterator___default()(getElements(parts)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _ref = _step.value;

      var _ref2 = __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_slicedToArray___default()(_ref, 3);

      var index = _ref2[0];
      var children = _ref2[1];
      var after = _ref2[2];

      tree.push(Object(__WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"])(elements[index], { key: index },
      // unpaired tag shouldn't receive children (return null instead)
      children ? formatElements(children, elements) : null));

      if (after) tree.push(after);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return tree;
}

/*
 * `getElements` - return array of element indexes and element childrens
 *
 * `parts` is array of [pairedIndex, children, unpairedIndex, textAfter, ...]
 * where:
 * - `pairedIndex` is index of paired element (undef for unpaired)
 * - `children` are children of paired element (undef for unpaired)
 * - `unpairedIndex` is index of unpaired element (undef for paired)
 * - `textAfter` is string after all elements (empty string, if there's nothing)
 *
 * `parts` length is always multiply of 4
 *
 * Returns: Array<[elementIndex, children, after]>
 */
function getElements(parts) {
  if (!parts.length) return [];

  var _parts$slice = parts.slice(0, 4),
      _parts$slice2 = __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_slicedToArray___default()(_parts$slice, 4),
      paired = _parts$slice2[0],
      children = _parts$slice2[1],
      unpaired = _parts$slice2[2],
      after = _parts$slice2[3];

  return [[parseInt(paired || unpaired), children || '', after]].concat(getElements(parts.slice(4, parts.length)));
}

var Trans = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Trans, _React$Component);

  function Trans() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Trans);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Trans.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Trans)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Trans, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (false) {
        if (!this.getTranslation() && this.props.children) {
          console.warn('lingui-react preset is probably missing in babel config, ' + 'but you are using <Trans> component in a way which requires it. ' + 'Either don\' use children in <Trans> component or configure babel ' + 'to load lingui-react preset. See tutorial for more info: ' + 'https://l.lingui.io/tutorial-i18n-react');
        }
      }
    }
  }, {
    key: 'getTranslation',
    value: function getTranslation() {
      var _props = this.props,
          _props$id = _props.id,
          id = _props$id === undefined ? '' : _props$id,
          defaults = _props.defaults,
          i18n = _props.i18n,
          values = _props.values,
          formats = _props.formats;

      return i18n && typeof i18n._ === 'function' ? i18n._(id, { defaults: defaults, values: values, formats: formats })
      // i18n provider isn't loaded at all
      : id;
    }
  }, {
    key: 'render',
    value: function render() {
      var translation = formatElements(this.getTranslation(), this.props.components);
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Render, {
        render: this.props.render,
        className: this.props.className,
        value: translation
      });
    }
  }]);

  return Trans;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

var Trans$1 = withI18n()(Trans);

var Select = withI18n()(function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Select, _React$Component);

  function Select() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Select);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Select.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Select)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Select, [{
    key: 'render',
    value: function render() {
      // lingui-transform-js transforms also this file in react-native env.
      // i18n must be aliased to _i18n to hide i18n.select call from plugin,
      // otherwise it throws "undefined is not iterable" obscure error.
      var _props = this.props,
          className = _props.className,
          render = _props.render,
          _i18n = _props.i18n,
          selectProps = __WEBPACK_IMPORTED_MODULE_14_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className', 'render', 'i18n']);

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Render, {
        className: className,
        render: render,
        value: _i18n.select(selectProps)
      });
    }
  }]);

  return Select;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component));

var PluralFactory = function PluralFactory() {
  var _class2, _temp2;

  var ordinal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var displayName = !ordinal ? 'Plural' : 'SelectOrdinal';
  var pluralType = !ordinal ? 'plural' : 'selectOrdinal';

  return _temp2 = _class2 = function (_React$Component2) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(_class2, _React$Component2);

    function _class2() {
      var _ref;

      var _temp, _this2, _ret;

      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, _class2);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = _class2.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(_class2)).call.apply(_ref, [this].concat(args))), _this2), _this2.displayName = displayName, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this2, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(_class2, [{
      key: 'render',
      value: function render() {
        var _props2 = this.props,
            className = _props2.className,
            render = _props2.render,
            i18n = _props2.i18n,
            value = _props2.value,
            offset = _props2.offset,
            props = __WEBPACK_IMPORTED_MODULE_14_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['className', 'render', 'i18n', 'value', 'offset']);

        // i18n.selectOrdinal/plural uses numbers for exact matches (1, 2),
        // while SelectOrdinal/Plural has to use strings (_1, _2).


        var pluralProps = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_object_keys___default()(props).reduce(function (acc, prop) {
          var key = prop.replace('_', '');
          acc[key] = props[prop];
          return acc;
        }, {
          value: parseInt(value),
          offset: parseInt(offset)
        });

        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Render, {
          className: className,
          render: render,
          value: i18n[pluralType](pluralProps)
        });
      }
    }]);

    return _class2;
  }(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component), _class2.defaultProps = {
    offset: 0
  }, _temp2;
};

var Plural = withI18n()(PluralFactory(false));
var SelectOrdinal = withI18n()(PluralFactory(true));

var DateFormat = withI18n()(createFormat(__WEBPACK_IMPORTED_MODULE_0_lingui_formats__["date"]));
var NumberFormat = withI18n()(createFormat(__WEBPACK_IMPORTED_MODULE_0_lingui_formats__["number"]));

var i18nMark = function i18nMark(id) {
  return id;
};




/***/ }),

/***/ "../node_modules/lingui-react/index.es.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dist_index_es__ = __webpack_require__("../node_modules/lingui-react/dist/index.es.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "withI18n", function() { return __WEBPACK_IMPORTED_MODULE_0__dist_index_es__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "WithI18n", function() { return __WEBPACK_IMPORTED_MODULE_0__dist_index_es__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "DateFormat", function() { return __WEBPACK_IMPORTED_MODULE_0__dist_index_es__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "NumberFormat", function() { return __WEBPACK_IMPORTED_MODULE_0__dist_index_es__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "i18nMark", function() { return __WEBPACK_IMPORTED_MODULE_0__dist_index_es__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "I18nProvider", function() { return __WEBPACK_IMPORTED_MODULE_0__dist_index_es__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Trans", function() { return __WEBPACK_IMPORTED_MODULE_0__dist_index_es__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Plural", function() { return __WEBPACK_IMPORTED_MODULE_0__dist_index_es__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Select", function() { return __WEBPACK_IMPORTED_MODULE_0__dist_index_es__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "SelectOrdinal", function() { return __WEBPACK_IMPORTED_MODULE_0__dist_index_es__["f"]; });



/***/ }),

/***/ "../node_modules/lodash-es/_DataView.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__("../node_modules/lodash-es/_getNative.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__("../node_modules/lodash-es/_root.js");



/* Built-in method references that are verified to be native. */
var DataView = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'DataView');

/* harmony default export */ __webpack_exports__["a"] = (DataView);


/***/ }),

/***/ "../node_modules/lodash-es/_Map.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__("../node_modules/lodash-es/_getNative.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__("../node_modules/lodash-es/_root.js");



/* Built-in method references that are verified to be native. */
var Map = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Map');

/* harmony default export */ __webpack_exports__["a"] = (Map);


/***/ }),

/***/ "../node_modules/lodash-es/_Promise.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__("../node_modules/lodash-es/_getNative.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__("../node_modules/lodash-es/_root.js");



/* Built-in method references that are verified to be native. */
var Promise = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Promise');

/* harmony default export */ __webpack_exports__["a"] = (Promise);


/***/ }),

/***/ "../node_modules/lodash-es/_Set.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__("../node_modules/lodash-es/_getNative.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__("../node_modules/lodash-es/_root.js");



/* Built-in method references that are verified to be native. */
var Set = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Set');

/* harmony default export */ __webpack_exports__["a"] = (Set);


/***/ }),

/***/ "../node_modules/lodash-es/_WeakMap.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__("../node_modules/lodash-es/_getNative.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__("../node_modules/lodash-es/_root.js");



/* Built-in method references that are verified to be native. */
var WeakMap = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'WeakMap');

/* harmony default export */ __webpack_exports__["a"] = (WeakMap);


/***/ }),

/***/ "../node_modules/lodash-es/_arrayLikeKeys.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseTimes_js__ = __webpack_require__("../node_modules/lodash-es/_baseTimes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArguments_js__ = __webpack_require__("../node_modules/lodash-es/isArguments.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__("../node_modules/lodash-es/isArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isBuffer_js__ = __webpack_require__("../node_modules/lodash-es/isBuffer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isIndex_js__ = __webpack_require__("../node_modules/lodash-es/_isIndex.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isTypedArray_js__ = __webpack_require__("../node_modules/lodash-es/isTypedArray.js");







/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value),
      isArg = !isArr && Object(__WEBPACK_IMPORTED_MODULE_1__isArguments_js__["a" /* default */])(value),
      isBuff = !isArr && !isArg && Object(__WEBPACK_IMPORTED_MODULE_3__isBuffer_js__["a" /* default */])(value),
      isType = !isArr && !isArg && !isBuff && Object(__WEBPACK_IMPORTED_MODULE_5__isTypedArray_js__["a" /* default */])(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? Object(__WEBPACK_IMPORTED_MODULE_0__baseTimes_js__["a" /* default */])(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           Object(__WEBPACK_IMPORTED_MODULE_4__isIndex_js__["a" /* default */])(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayLikeKeys);


/***/ }),

/***/ "../node_modules/lodash-es/_arrayMap.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayMap);


/***/ }),

/***/ "../node_modules/lodash-es/_baseFindIndex.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

/* harmony default export */ __webpack_exports__["a"] = (baseFindIndex);


/***/ }),

/***/ "../node_modules/lodash-es/_baseIndexOf.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseFindIndex_js__ = __webpack_require__("../node_modules/lodash-es/_baseFindIndex.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseIsNaN_js__ = __webpack_require__("../node_modules/lodash-es/_baseIsNaN.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__strictIndexOf_js__ = __webpack_require__("../node_modules/lodash-es/_strictIndexOf.js");




/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? Object(__WEBPACK_IMPORTED_MODULE_2__strictIndexOf_js__["a" /* default */])(array, value, fromIndex)
    : Object(__WEBPACK_IMPORTED_MODULE_0__baseFindIndex_js__["a" /* default */])(array, __WEBPACK_IMPORTED_MODULE_1__baseIsNaN_js__["a" /* default */], fromIndex);
}

/* harmony default export */ __webpack_exports__["a"] = (baseIndexOf);


/***/ }),

/***/ "../node_modules/lodash-es/_baseIsArguments.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__("../node_modules/lodash-es/_baseGetTag.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__("../node_modules/lodash-es/isObjectLike.js");



/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == argsTag;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsArguments);


/***/ }),

/***/ "../node_modules/lodash-es/_baseIsNaN.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsNaN);


/***/ }),

/***/ "../node_modules/lodash-es/_baseIsNative.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction_js__ = __webpack_require__("../node_modules/lodash-es/isFunction.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isMasked_js__ = __webpack_require__("../node_modules/lodash-es/_isMasked.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObject_js__ = __webpack_require__("../node_modules/lodash-es/isObject.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toSource_js__ = __webpack_require__("../node_modules/lodash-es/_toSource.js");





/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObject_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_1__isMasked_js__["a" /* default */])(value)) {
    return false;
  }
  var pattern = Object(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(value) ? reIsNative : reIsHostCtor;
  return pattern.test(Object(__WEBPACK_IMPORTED_MODULE_3__toSource_js__["a" /* default */])(value));
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsNative);


/***/ }),

/***/ "../node_modules/lodash-es/_baseIsTypedArray.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__("../node_modules/lodash-es/_baseGetTag.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isLength_js__ = __webpack_require__("../node_modules/lodash-es/isLength.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__("../node_modules/lodash-es/isObjectLike.js");




/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) &&
    Object(__WEBPACK_IMPORTED_MODULE_1__isLength_js__["a" /* default */])(value.length) && !!typedArrayTags[Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value)];
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsTypedArray);


/***/ }),

/***/ "../node_modules/lodash-es/_baseKeys.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPrototype_js__ = __webpack_require__("../node_modules/lodash-es/_isPrototype.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nativeKeys_js__ = __webpack_require__("../node_modules/lodash-es/_nativeKeys.js");



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPrototype_js__["a" /* default */])(object)) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__nativeKeys_js__["a" /* default */])(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseKeys);


/***/ }),

/***/ "../node_modules/lodash-es/_baseTimes.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseTimes);


/***/ }),

/***/ "../node_modules/lodash-es/_baseToString.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__("../node_modules/lodash-es/_Symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arrayMap_js__ = __webpack_require__("../node_modules/lodash-es/_arrayMap.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__("../node_modules/lodash-es/isArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isSymbol_js__ = __webpack_require__("../node_modules/lodash-es/isSymbol.js");





/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return Object(__WEBPACK_IMPORTED_MODULE_1__arrayMap_js__["a" /* default */])(value, baseToString) + '';
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_3__isSymbol_js__["a" /* default */])(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseToString);


/***/ }),

/***/ "../node_modules/lodash-es/_baseUnary.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseUnary);


/***/ }),

/***/ "../node_modules/lodash-es/_baseValues.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayMap_js__ = __webpack_require__("../node_modules/lodash-es/_arrayMap.js");


/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayMap_js__["a" /* default */])(props, function(key) {
    return object[key];
  });
}

/* harmony default export */ __webpack_exports__["a"] = (baseValues);


/***/ }),

/***/ "../node_modules/lodash-es/_coreJsData.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__("../node_modules/lodash-es/_root.js");


/** Used to detect overreaching core-js shims. */
var coreJsData = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */]['__core-js_shared__'];

/* harmony default export */ __webpack_exports__["a"] = (coreJsData);


/***/ }),

/***/ "../node_modules/lodash-es/_getNative.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsNative_js__ = __webpack_require__("../node_modules/lodash-es/_baseIsNative.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getValue_js__ = __webpack_require__("../node_modules/lodash-es/_getValue.js");



/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = Object(__WEBPACK_IMPORTED_MODULE_1__getValue_js__["a" /* default */])(object, key);
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseIsNative_js__["a" /* default */])(value) ? value : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (getNative);


/***/ }),

/***/ "../node_modules/lodash-es/_getTag.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataView_js__ = __webpack_require__("../node_modules/lodash-es/_DataView.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Map_js__ = __webpack_require__("../node_modules/lodash-es/_Map.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Promise_js__ = __webpack_require__("../node_modules/lodash-es/_Promise.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Set_js__ = __webpack_require__("../node_modules/lodash-es/_Set.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WeakMap_js__ = __webpack_require__("../node_modules/lodash-es/_WeakMap.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__ = __webpack_require__("../node_modules/lodash-es/_baseGetTag.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toSource_js__ = __webpack_require__("../node_modules/lodash-es/_toSource.js");








/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */]),
    mapCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */]),
    promiseCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */]),
    setCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */]),
    weakMapCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */]);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = __WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__["a" /* default */];

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((__WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */](new ArrayBuffer(1))) != dataViewTag) ||
    (__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */]) != mapTag) ||
    (__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */] && getTag(__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */].resolve()) != promiseTag) ||
    (__WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */]) != setTag) ||
    (__WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */]) != weakMapTag)) {
  getTag = function(value) {
    var result = Object(__WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__["a" /* default */])(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (getTag);


/***/ }),

/***/ "../node_modules/lodash-es/_getValue.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/* harmony default export */ __webpack_exports__["a"] = (getValue);


/***/ }),

/***/ "../node_modules/lodash-es/_isIndex.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/* harmony default export */ __webpack_exports__["a"] = (isIndex);


/***/ }),

/***/ "../node_modules/lodash-es/_isMasked.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__ = __webpack_require__("../node_modules/lodash-es/_coreJsData.js");


/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(__WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */].keys && __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */].keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/* harmony default export */ __webpack_exports__["a"] = (isMasked);


/***/ }),

/***/ "../node_modules/lodash-es/_isPrototype.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/* harmony default export */ __webpack_exports__["a"] = (isPrototype);


/***/ }),

/***/ "../node_modules/lodash-es/_nativeKeys.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__("../node_modules/lodash-es/_overArg.js");


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.keys, Object);

/* harmony default export */ __webpack_exports__["a"] = (nativeKeys);


/***/ }),

/***/ "../node_modules/lodash-es/_nodeUtil.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__("../node_modules/lodash-es/_freeGlobal.js");


/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */].process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* harmony default export */ __webpack_exports__["a"] = (nodeUtil);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../node_modules/webpack/buildin/harmony-module.js")(module)))

/***/ }),

/***/ "../node_modules/lodash-es/_strictIndexOf.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

/* harmony default export */ __webpack_exports__["a"] = (strictIndexOf);


/***/ }),

/***/ "../node_modules/lodash-es/_toSource.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/* harmony default export */ __webpack_exports__["a"] = (toSource);


/***/ }),

/***/ "../node_modules/lodash-es/identity.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/* harmony default export */ __webpack_exports__["a"] = (identity);


/***/ }),

/***/ "../node_modules/lodash-es/includes.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIndexOf_js__ = __webpack_require__("../node_modules/lodash-es/_baseIndexOf.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__ = __webpack_require__("../node_modules/lodash-es/isArrayLike.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isString_js__ = __webpack_require__("../node_modules/lodash-es/isString.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toInteger_js__ = __webpack_require__("../node_modules/lodash-es/toInteger.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__values_js__ = __webpack_require__("../node_modules/lodash-es/values.js");






/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes(collection, value, fromIndex, guard) {
  collection = Object(__WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__["a" /* default */])(collection) ? collection : Object(__WEBPACK_IMPORTED_MODULE_4__values_js__["a" /* default */])(collection);
  fromIndex = (fromIndex && !guard) ? Object(__WEBPACK_IMPORTED_MODULE_3__toInteger_js__["a" /* default */])(fromIndex) : 0;

  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = nativeMax(length + fromIndex, 0);
  }
  return Object(__WEBPACK_IMPORTED_MODULE_2__isString_js__["a" /* default */])(collection)
    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
    : (!!length && Object(__WEBPACK_IMPORTED_MODULE_0__baseIndexOf_js__["a" /* default */])(collection, value, fromIndex) > -1);
}

/* harmony default export */ __webpack_exports__["a"] = (includes);


/***/ }),

/***/ "../node_modules/lodash-es/isArguments.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__ = __webpack_require__("../node_modules/lodash-es/_baseIsArguments.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__("../node_modules/lodash-es/isObjectLike.js");



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = Object(__WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__["a" /* default */])(function() { return arguments; }()) ? __WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__["a" /* default */] : function(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/* harmony default export */ __webpack_exports__["a"] = (isArguments);


/***/ }),

/***/ "../node_modules/lodash-es/isArray.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/* harmony default export */ __webpack_exports__["a"] = (isArray);


/***/ }),

/***/ "../node_modules/lodash-es/isArrayLike.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction_js__ = __webpack_require__("../node_modules/lodash-es/isFunction.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isLength_js__ = __webpack_require__("../node_modules/lodash-es/isLength.js");



/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && Object(__WEBPACK_IMPORTED_MODULE_1__isLength_js__["a" /* default */])(value.length) && !Object(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (isArrayLike);


/***/ }),

/***/ "../node_modules/lodash-es/isBuffer.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__("../node_modules/lodash-es/_root.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stubFalse_js__ = __webpack_require__("../node_modules/lodash-es/stubFalse.js");



/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || __WEBPACK_IMPORTED_MODULE_1__stubFalse_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isBuffer);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../node_modules/webpack/buildin/harmony-module.js")(module)))

/***/ }),

/***/ "../node_modules/lodash-es/isEmpty.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseKeys_js__ = __webpack_require__("../node_modules/lodash-es/_baseKeys.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getTag_js__ = __webpack_require__("../node_modules/lodash-es/_getTag.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArguments_js__ = __webpack_require__("../node_modules/lodash-es/isArguments.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArray_js__ = __webpack_require__("../node_modules/lodash-es/isArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isArrayLike_js__ = __webpack_require__("../node_modules/lodash-es/isArrayLike.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isBuffer_js__ = __webpack_require__("../node_modules/lodash-es/isBuffer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isPrototype_js__ = __webpack_require__("../node_modules/lodash-es/_isPrototype.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__ = __webpack_require__("../node_modules/lodash-es/isTypedArray.js");









/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_4__isArrayLike_js__["a" /* default */])(value) &&
      (Object(__WEBPACK_IMPORTED_MODULE_3__isArray_js__["a" /* default */])(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        Object(__WEBPACK_IMPORTED_MODULE_5__isBuffer_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_2__isArguments_js__["a" /* default */])(value))) {
    return !value.length;
  }
  var tag = Object(__WEBPACK_IMPORTED_MODULE_1__getTag_js__["a" /* default */])(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_6__isPrototype_js__["a" /* default */])(value)) {
    return !Object(__WEBPACK_IMPORTED_MODULE_0__baseKeys_js__["a" /* default */])(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

/* harmony default export */ __webpack_exports__["a"] = (isEmpty);


/***/ }),

/***/ "../node_modules/lodash-es/isFunction.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__("../node_modules/lodash-es/_baseGetTag.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObject_js__ = __webpack_require__("../node_modules/lodash-es/isObject.js");



/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_1__isObject_js__["a" /* default */])(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/* harmony default export */ __webpack_exports__["a"] = (isFunction);


/***/ }),

/***/ "../node_modules/lodash-es/isLength.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/* harmony default export */ __webpack_exports__["a"] = (isLength);


/***/ }),

/***/ "../node_modules/lodash-es/isNil.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

/* harmony default export */ __webpack_exports__["a"] = (isNil);


/***/ }),

/***/ "../node_modules/lodash-es/isNull.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is `null`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
 * @example
 *
 * _.isNull(null);
 * // => true
 *
 * _.isNull(void 0);
 * // => false
 */
function isNull(value) {
  return value === null;
}

/* harmony default export */ __webpack_exports__["a"] = (isNull);


/***/ }),

/***/ "../node_modules/lodash-es/isObject.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/* harmony default export */ __webpack_exports__["a"] = (isObject);


/***/ }),

/***/ "../node_modules/lodash-es/isString.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__("../node_modules/lodash-es/_baseGetTag.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArray_js__ = __webpack_require__("../node_modules/lodash-es/isArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__("../node_modules/lodash-es/isObjectLike.js");




/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!Object(__WEBPACK_IMPORTED_MODULE_1__isArray_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == stringTag);
}

/* harmony default export */ __webpack_exports__["a"] = (isString);


/***/ }),

/***/ "../node_modules/lodash-es/isSymbol.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__("../node_modules/lodash-es/_baseGetTag.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__("../node_modules/lodash-es/isObjectLike.js");



/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == symbolTag);
}

/* harmony default export */ __webpack_exports__["a"] = (isSymbol);


/***/ }),

/***/ "../node_modules/lodash-es/isTypedArray.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsTypedArray_js__ = __webpack_require__("../node_modules/lodash-es/_baseIsTypedArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseUnary_js__ = __webpack_require__("../node_modules/lodash-es/_baseUnary.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__ = __webpack_require__("../node_modules/lodash-es/_nodeUtil.js");




/* Node.js helper references. */
var nodeIsTypedArray = __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */].isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? Object(__WEBPACK_IMPORTED_MODULE_1__baseUnary_js__["a" /* default */])(nodeIsTypedArray) : __WEBPACK_IMPORTED_MODULE_0__baseIsTypedArray_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isTypedArray);


/***/ }),

/***/ "../node_modules/lodash-es/isUndefined.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */
function isUndefined(value) {
  return value === undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (isUndefined);


/***/ }),

/***/ "../node_modules/lodash-es/keys.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__ = __webpack_require__("../node_modules/lodash-es/_arrayLikeKeys.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseKeys_js__ = __webpack_require__("../node_modules/lodash-es/_baseKeys.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__ = __webpack_require__("../node_modules/lodash-es/isArrayLike.js");




/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__["a" /* default */])(object) ? Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__["a" /* default */])(object) : Object(__WEBPACK_IMPORTED_MODULE_1__baseKeys_js__["a" /* default */])(object);
}

/* harmony default export */ __webpack_exports__["a"] = (keys);


/***/ }),

/***/ "../node_modules/lodash-es/last.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (last);


/***/ }),

/***/ "../node_modules/lodash-es/stubFalse.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (stubFalse);


/***/ }),

/***/ "../node_modules/lodash-es/toFinite.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toNumber_js__ = __webpack_require__("../node_modules/lodash-es/toNumber.js");


/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = Object(__WEBPACK_IMPORTED_MODULE_0__toNumber_js__["a" /* default */])(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

/* harmony default export */ __webpack_exports__["a"] = (toFinite);


/***/ }),

/***/ "../node_modules/lodash-es/toInteger.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toFinite_js__ = __webpack_require__("../node_modules/lodash-es/toFinite.js");


/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_0__toFinite_js__["a" /* default */])(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

/* harmony default export */ __webpack_exports__["a"] = (toInteger);


/***/ }),

/***/ "../node_modules/lodash-es/toNumber.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__("../node_modules/lodash-es/isObject.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isSymbol_js__ = __webpack_require__("../node_modules/lodash-es/isSymbol.js");



/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_1__isSymbol_js__["a" /* default */])(value)) {
    return NAN;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

/* harmony default export */ __webpack_exports__["a"] = (toNumber);


/***/ }),

/***/ "../node_modules/lodash-es/toString.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseToString_js__ = __webpack_require__("../node_modules/lodash-es/_baseToString.js");


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : Object(__WEBPACK_IMPORTED_MODULE_0__baseToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (toString);


/***/ }),

/***/ "../node_modules/lodash-es/values.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseValues_js__ = __webpack_require__("../node_modules/lodash-es/_baseValues.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__("../node_modules/lodash-es/keys.js");



/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : Object(__WEBPACK_IMPORTED_MODULE_0__baseValues_js__["a" /* default */])(object, Object(__WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */])(object));
}

/* harmony default export */ __webpack_exports__["a"] = (values);


/***/ }),

/***/ "../node_modules/lodash.curry/index.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/** Used to compose bitmasks for function metadata. */
var BIND_FLAG = 1,
    BIND_KEY_FLAG = 2,
    CURRY_BOUND_FLAG = 4,
    CURRY_FLAG = 8,
    CURRY_RIGHT_FLAG = 16,
    PARTIAL_FLAG = 32,
    PARTIAL_RIGHT_FLAG = 64,
    ARY_FLAG = 128,
    REARG_FLAG = 256,
    FLIP_FLAG = 512;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991,
    MAX_INTEGER = 1.7976931348623157e+308,
    NAN = 0 / 0;

/** Used to associate wrap methods with their bit flags. */
var wrapFlags = [
  ['ary', ARY_FLAG],
  ['bind', BIND_FLAG],
  ['bindKey', BIND_KEY_FLAG],
  ['curry', CURRY_FLAG],
  ['curryRight', CURRY_RIGHT_FLAG],
  ['flip', FLIP_FLAG],
  ['partial', PARTIAL_FLAG],
  ['partialRight', PARTIAL_RIGHT_FLAG],
  ['rearg', REARG_FLAG]
];

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to match wrap detail comments. */
var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
    reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
    reSplitDetails = /,? & /;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array ? array.length : 0;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  if (value !== value) {
    return baseFindIndex(array, baseIsNaN, fromIndex);
  }
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */
function countHolders(array, placeholder) {
  var length = array.length,
      result = 0;

  while (length--) {
    if (array[length] === placeholder) {
      result++;
    }
  }
  return result;
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */
function replaceHolders(array, placeholder) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value === placeholder || value === PLACEHOLDER) {
      array[index] = PLACEHOLDER;
      result[resIndex++] = index;
    }
  }
  return result;
}

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var objectCreate = Object.create;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/* Used to set `toString` methods. */
var defineProperty = (function() {
  var func = getNative(Object, 'defineProperty'),
      name = getNative.name;

  return (name && name.length > 2) ? func : undefined;
}());

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */
function baseCreate(proto) {
  return isObject(proto) ? objectCreate(proto) : {};
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgs(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersLength = holders.length,
      leftIndex = -1,
      leftLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(leftLength + rangeLength),
      isUncurried = !isCurried;

  while (++leftIndex < leftLength) {
    result[leftIndex] = partials[leftIndex];
  }
  while (++argsIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[holders[argsIndex]] = args[argsIndex];
    }
  }
  while (rangeLength--) {
    result[leftIndex++] = args[argsIndex++];
  }
  return result;
}

/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgsRight(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersIndex = -1,
      holdersLength = holders.length,
      rightIndex = -1,
      rightLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(rangeLength + rightLength),
      isUncurried = !isCurried;

  while (++argsIndex < rangeLength) {
    result[argsIndex] = args[argsIndex];
  }
  var offset = argsIndex;
  while (++rightIndex < rightLength) {
    result[offset + rightIndex] = partials[rightIndex];
  }
  while (++holdersIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[offset + holders[holdersIndex]] = args[argsIndex++];
    }
  }
  return result;
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createBind(func, bitmask, thisArg) {
  var isBind = bitmask & BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return fn.apply(isBind ? thisArg : this, arguments);
  }
  return wrapper;
}

/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */
function createCtor(Ctor) {
  return function() {
    // Use a `switch` statement to work with class constructors. See
    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
    // for more details.
    var args = arguments;
    switch (args.length) {
      case 0: return new Ctor;
      case 1: return new Ctor(args[0]);
      case 2: return new Ctor(args[0], args[1]);
      case 3: return new Ctor(args[0], args[1], args[2]);
      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
    }
    var thisBinding = baseCreate(Ctor.prototype),
        result = Ctor.apply(thisBinding, args);

    // Mimic the constructor's `return` behavior.
    // See https://es5.github.io/#x13.2.2 for more details.
    return isObject(result) ? result : thisBinding;
  };
}

/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createCurry(func, bitmask, arity) {
  var Ctor = createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length,
        placeholder = getHolder(wrapper);

    while (index--) {
      args[index] = arguments[index];
    }
    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
      ? []
      : replaceHolders(args, placeholder);

    length -= holders.length;
    if (length < arity) {
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, undefined,
        args, holders, undefined, undefined, arity - length);
    }
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return apply(fn, this, args);
  }
  return wrapper;
}

/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
  var isAry = bitmask & ARY_FLAG,
      isBind = bitmask & BIND_FLAG,
      isBindKey = bitmask & BIND_KEY_FLAG,
      isCurried = bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG),
      isFlip = bitmask & FLIP_FLAG,
      Ctor = isBindKey ? undefined : createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length;

    while (index--) {
      args[index] = arguments[index];
    }
    if (isCurried) {
      var placeholder = getHolder(wrapper),
          holdersCount = countHolders(args, placeholder);
    }
    if (partials) {
      args = composeArgs(args, partials, holders, isCurried);
    }
    if (partialsRight) {
      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
    }
    length -= holdersCount;
    if (isCurried && length < arity) {
      var newHolders = replaceHolders(args, placeholder);
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
        args, newHolders, argPos, ary, arity - length
      );
    }
    var thisBinding = isBind ? thisArg : this,
        fn = isBindKey ? thisBinding[func] : func;

    length = args.length;
    if (argPos) {
      args = reorder(args, argPos);
    } else if (isFlip && length > 1) {
      args.reverse();
    }
    if (isAry && ary < length) {
      args.length = ary;
    }
    if (this && this !== root && this instanceof wrapper) {
      fn = Ctor || createCtor(fn);
    }
    return fn.apply(thisBinding, args);
  }
  return wrapper;
}

/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */
function createPartial(func, bitmask, thisArg, partials) {
  var isBind = bitmask & BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var argsIndex = -1,
        argsLength = arguments.length,
        leftIndex = -1,
        leftLength = partials.length,
        args = Array(leftLength + argsLength),
        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

    while (++leftIndex < leftLength) {
      args[leftIndex] = partials[leftIndex];
    }
    while (argsLength--) {
      args[leftIndex++] = arguments[++argsIndex];
    }
    return apply(fn, isBind ? thisArg : this, args);
  }
  return wrapper;
}

/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
  var isCurry = bitmask & CURRY_FLAG,
      newHolders = isCurry ? holders : undefined,
      newHoldersRight = isCurry ? undefined : holders,
      newPartials = isCurry ? partials : undefined,
      newPartialsRight = isCurry ? undefined : partials;

  bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
  bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);

  if (!(bitmask & CURRY_BOUND_FLAG)) {
    bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
  }

  var result = wrapFunc(func, bitmask, thisArg, newPartials, newHolders, newPartialsRight, newHoldersRight, argPos, ary, arity);
  result.placeholder = placeholder;
  return setWrapToString(result, func, bitmask);
}

/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *  The bitmask may be composed of the following flags:
 *     1 - `_.bind`
 *     2 - `_.bindKey`
 *     4 - `_.curry` or `_.curryRight` of a bound function
 *     8 - `_.curry`
 *    16 - `_.curryRight`
 *    32 - `_.partial`
 *    64 - `_.partialRight`
 *   128 - `_.rearg`
 *   256 - `_.ary`
 *   512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
  var isBindKey = bitmask & BIND_KEY_FLAG;
  if (!isBindKey && typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var length = partials ? partials.length : 0;
  if (!length) {
    bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
    partials = holders = undefined;
  }
  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
  arity = arity === undefined ? arity : toInteger(arity);
  length -= holders ? holders.length : 0;

  if (bitmask & PARTIAL_RIGHT_FLAG) {
    var partialsRight = partials,
        holdersRight = holders;

    partials = holders = undefined;
  }

  var newData = [
    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
    argPos, ary, arity
  ];

  func = newData[0];
  bitmask = newData[1];
  thisArg = newData[2];
  partials = newData[3];
  holders = newData[4];
  arity = newData[9] = newData[9] == null
    ? (isBindKey ? 0 : func.length)
    : nativeMax(newData[9] - length, 0);

  if (!arity && bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG)) {
    bitmask &= ~(CURRY_FLAG | CURRY_RIGHT_FLAG);
  }
  if (!bitmask || bitmask == BIND_FLAG) {
    var result = createBind(func, bitmask, thisArg);
  } else if (bitmask == CURRY_FLAG || bitmask == CURRY_RIGHT_FLAG) {
    result = createCurry(func, bitmask, arity);
  } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !holders.length) {
    result = createPartial(func, bitmask, thisArg, partials);
  } else {
    result = createHybrid.apply(undefined, newData);
  }
  return setWrapToString(result, func, bitmask);
}

/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */
function getHolder(func) {
  var object = func;
  return object.placeholder;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */
function getWrapDetails(source) {
  var match = source.match(reWrapDetails);
  return match ? match[1].split(reSplitDetails) : [];
}

/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */
function insertWrapDetails(source, details) {
  var length = details.length,
      lastIndex = length - 1;

  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
  details = details.join(length > 2 ? ', ' : ' ');
  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */
function reorder(array, indexes) {
  var arrLength = array.length,
      length = nativeMin(indexes.length, arrLength),
      oldArray = copyArray(array);

  while (length--) {
    var index = indexes[length];
    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
  }
  return array;
}

/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */
var setWrapToString = !defineProperty ? identity : function(wrapper, reference, bitmask) {
  var source = (reference + '');
  return defineProperty(wrapper, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)))
  });
};

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */
function updateWrapDetails(details, bitmask) {
  arrayEach(wrapFlags, function(pair) {
    var value = '_.' + pair[0];
    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
      details.push(value);
    }
  });
  return details.sort();
}

/**
 * Creates a function that accepts arguments of `func` and either invokes
 * `func` returning its result, if at least `arity` number of arguments have
 * been provided, or returns a function that accepts the remaining `func`
 * arguments, and so on. The arity of `func` may be specified if `func.length`
 * is not sufficient.
 *
 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curry(abc);
 *
 * curried(1)(2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(1)(_, 3)(2);
 * // => [1, 2, 3]
 */
function curry(func, arity, guard) {
  arity = guard ? undefined : arity;
  var result = createWrap(func, CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
  result.placeholder = curry.placeholder;
  return result;
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

// Assign default placeholders.
curry.placeholder = {};

module.exports = curry;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "../node_modules/lodash.difference/index.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array ? array.length : 0;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  if (value !== value) {
    return baseFindIndex(array, baseIsNaN, fromIndex);
  }
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Checks if a cache value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values ? values.length : 0;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap(values, baseUnary(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  }
  else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order of result values is determined by the
 * order they occur in the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */
var difference = baseRest(function(array, values) {
  return isArrayLikeObject(array)
    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
    : [];
});

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

module.exports = difference;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "../node_modules/lodash.flatten/index.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array ? array.length : 0;
  return length ? baseFlatten(array, 1) : [];
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

module.exports = flatten;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "../node_modules/lodash.forin/index.js":
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Iterates over own and inherited enumerable string keyed properties of an
 * object and invokes `iteratee` for each property. The iteratee is invoked
 * with three arguments: (value, key, object). Iteratee functions may exit
 * iteration early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forInRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forIn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
 */
function forIn(object, iteratee) {
  return object == null
    ? object
    : baseFor(object, typeof iteratee == 'function' ? iteratee : identity, keysIn);
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = forIn;


/***/ }),

/***/ "../node_modules/lodash.identity/index.js":
/***/ (function(module, exports) {

/**
 * lodash 3.0.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.7.0 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * This method returns the first argument provided to it.
 *
 * @static
 * @memberOf _
 * @category Utility
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'user': 'fred' };
 * _.identity(object) === object;
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ "../node_modules/lodash.iserror/index.js":
/***/ (function(module, exports) {

/**
 * lodash 3.1.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var errorTag = '[object Error]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
 * `SyntaxError`, `TypeError`, or `URIError` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
 * @example
 *
 * _.isError(new Error);
 * // => true
 *
 * _.isError(Error);
 * // => false
 */
function isError(value) {
  if (!isObjectLike(value)) {
    return false;
  }
  return (objectToString.call(value) == errorTag) ||
    (typeof value.message == 'string' && typeof value.name == 'string');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

module.exports = isError;


/***/ }),

/***/ "../node_modules/lodash.isfunction/index.js":
/***/ (function(module, exports) {

/**
 * lodash 3.0.8 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8 which returns 'object' for typed array constructors, and
  // PhantomJS 1.9 which returns 'function' for `NodeList` instances.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = isFunction;


/***/ }),

/***/ "../node_modules/lodash.isnull/index.js":
/***/ (function(module, exports) {

/**
 * lodash 3.0.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.7.0 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * Checks if `value` is `null`.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
 * @example
 *
 * _.isNull(null);
 * // => true
 *
 * _.isNull(void 0);
 * // => false
 */
function isNull(value) {
  return value === null;
}

module.exports = isNull;


/***/ }),

/***/ "../node_modules/lodash.isobject/index.js":
/***/ (function(module, exports) {

/**
 * lodash 3.0.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ "../node_modules/lodash.keys/index.js":
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ "../node_modules/lodash.throttle/index.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = throttle;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "../node_modules/lodash.uniq/index.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array ? array.length : 0;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  if (value !== value) {
    return baseFindIndex(array, baseIsNaN, fromIndex);
  }
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

/**
 * Checks if a cache value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    Set = getNative(root, 'Set'),
    nativeCreate = getNative(Object, 'create');

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values ? values.length : 0;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each
 * element is kept.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length)
    ? baseUniq(array)
    : [];
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = uniq;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "../node_modules/lodash/fp.js":
/***/ (function(module, exports, __webpack_require__) {

var _ = __webpack_require__("../node_modules/lodash/lodash.min.js").runInContext();
module.exports = __webpack_require__("../node_modules/lodash/fp/_baseConvert.js")(_, _);


/***/ }),

/***/ "../node_modules/lodash/fp/_baseConvert.js":
/***/ (function(module, exports, __webpack_require__) {

var mapping = __webpack_require__("../node_modules/lodash/fp/_mapping.js"),
    fallbackHolder = __webpack_require__("../node_modules/lodash/fp/placeholder.js");

/** Built-in value reference. */
var push = Array.prototype.push;

/**
 * Creates a function, with an arity of `n`, that invokes `func` with the
 * arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} n The arity of the new function.
 * @returns {Function} Returns the new function.
 */
function baseArity(func, n) {
  return n == 2
    ? function(a, b) { return func.apply(undefined, arguments); }
    : function(a) { return func.apply(undefined, arguments); };
}

/**
 * Creates a function that invokes `func`, with up to `n` arguments, ignoring
 * any additional arguments.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @param {number} n The arity cap.
 * @returns {Function} Returns the new function.
 */
function baseAry(func, n) {
  return n == 2
    ? function(a, b) { return func(a, b); }
    : function(a) { return func(a); };
}

/**
 * Creates a clone of `array`.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the cloned array.
 */
function cloneArray(array) {
  var length = array ? array.length : 0,
      result = Array(length);

  while (length--) {
    result[length] = array[length];
  }
  return result;
}

/**
 * Creates a function that clones a given object using the assignment `func`.
 *
 * @private
 * @param {Function} func The assignment function.
 * @returns {Function} Returns the new cloner function.
 */
function createCloner(func) {
  return function(object) {
    return func({}, object);
  };
}

/**
 * A specialized version of `_.spread` which flattens the spread array into
 * the arguments of the invoked `func`.
 *
 * @private
 * @param {Function} func The function to spread arguments over.
 * @param {number} start The start position of the spread.
 * @returns {Function} Returns the new function.
 */
function flatSpread(func, start) {
  return function() {
    var length = arguments.length,
        lastIndex = length - 1,
        args = Array(length);

    while (length--) {
      args[length] = arguments[length];
    }
    var array = args[start],
        otherArgs = args.slice(0, start);

    if (array) {
      push.apply(otherArgs, array);
    }
    if (start != lastIndex) {
      push.apply(otherArgs, args.slice(start + 1));
    }
    return func.apply(this, otherArgs);
  };
}

/**
 * Creates a function that wraps `func` and uses `cloner` to clone the first
 * argument it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} cloner The function to clone arguments.
 * @returns {Function} Returns the new immutable function.
 */
function wrapImmutable(func, cloner) {
  return function() {
    var length = arguments.length;
    if (!length) {
      return;
    }
    var args = Array(length);
    while (length--) {
      args[length] = arguments[length];
    }
    var result = args[0] = cloner.apply(undefined, args);
    func.apply(undefined, args);
    return result;
  };
}

/**
 * The base implementation of `convert` which accepts a `util` object of methods
 * required to perform conversions.
 *
 * @param {Object} util The util object.
 * @param {string} name The name of the function to convert.
 * @param {Function} func The function to convert.
 * @param {Object} [options] The options object.
 * @param {boolean} [options.cap=true] Specify capping iteratee arguments.
 * @param {boolean} [options.curry=true] Specify currying.
 * @param {boolean} [options.fixed=true] Specify fixed arity.
 * @param {boolean} [options.immutable=true] Specify immutable operations.
 * @param {boolean} [options.rearg=true] Specify rearranging arguments.
 * @returns {Function|Object} Returns the converted function or object.
 */
function baseConvert(util, name, func, options) {
  var setPlaceholder,
      isLib = typeof name == 'function',
      isObj = name === Object(name);

  if (isObj) {
    options = func;
    func = name;
    name = undefined;
  }
  if (func == null) {
    throw new TypeError;
  }
  options || (options = {});

  var config = {
    'cap': 'cap' in options ? options.cap : true,
    'curry': 'curry' in options ? options.curry : true,
    'fixed': 'fixed' in options ? options.fixed : true,
    'immutable': 'immutable' in options ? options.immutable : true,
    'rearg': 'rearg' in options ? options.rearg : true
  };

  var forceCurry = ('curry' in options) && options.curry,
      forceFixed = ('fixed' in options) && options.fixed,
      forceRearg = ('rearg' in options) && options.rearg,
      placeholder = isLib ? func : fallbackHolder,
      pristine = isLib ? func.runInContext() : undefined;

  var helpers = isLib ? func : {
    'ary': util.ary,
    'assign': util.assign,
    'clone': util.clone,
    'curry': util.curry,
    'forEach': util.forEach,
    'isArray': util.isArray,
    'isFunction': util.isFunction,
    'iteratee': util.iteratee,
    'keys': util.keys,
    'rearg': util.rearg,
    'toInteger': util.toInteger,
    'toPath': util.toPath
  };

  var ary = helpers.ary,
      assign = helpers.assign,
      clone = helpers.clone,
      curry = helpers.curry,
      each = helpers.forEach,
      isArray = helpers.isArray,
      isFunction = helpers.isFunction,
      keys = helpers.keys,
      rearg = helpers.rearg,
      toInteger = helpers.toInteger,
      toPath = helpers.toPath;

  var aryMethodKeys = keys(mapping.aryMethod);

  var wrappers = {
    'castArray': function(castArray) {
      return function() {
        var value = arguments[0];
        return isArray(value)
          ? castArray(cloneArray(value))
          : castArray.apply(undefined, arguments);
      };
    },
    'iteratee': function(iteratee) {
      return function() {
        var func = arguments[0],
            arity = arguments[1],
            result = iteratee(func, arity),
            length = result.length;

        if (config.cap && typeof arity == 'number') {
          arity = arity > 2 ? (arity - 2) : 1;
          return (length && length <= arity) ? result : baseAry(result, arity);
        }
        return result;
      };
    },
    'mixin': function(mixin) {
      return function(source) {
        var func = this;
        if (!isFunction(func)) {
          return mixin(func, Object(source));
        }
        var pairs = [];
        each(keys(source), function(key) {
          if (isFunction(source[key])) {
            pairs.push([key, func.prototype[key]]);
          }
        });

        mixin(func, Object(source));

        each(pairs, function(pair) {
          var value = pair[1];
          if (isFunction(value)) {
            func.prototype[pair[0]] = value;
          } else {
            delete func.prototype[pair[0]];
          }
        });
        return func;
      };
    },
    'nthArg': function(nthArg) {
      return function(n) {
        var arity = n < 0 ? 1 : (toInteger(n) + 1);
        return curry(nthArg(n), arity);
      };
    },
    'rearg': function(rearg) {
      return function(func, indexes) {
        var arity = indexes ? indexes.length : 0;
        return curry(rearg(func, indexes), arity);
      };
    },
    'runInContext': function(runInContext) {
      return function(context) {
        return baseConvert(util, runInContext(context), options);
      };
    }
  };

  /*--------------------------------------------------------------------------*/

  /**
   * Casts `func` to a function with an arity capped iteratee if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @returns {Function} Returns the cast function.
   */
  function castCap(name, func) {
    if (config.cap) {
      var indexes = mapping.iterateeRearg[name];
      if (indexes) {
        return iterateeRearg(func, indexes);
      }
      var n = !isLib && mapping.iterateeAry[name];
      if (n) {
        return iterateeAry(func, n);
      }
    }
    return func;
  }

  /**
   * Casts `func` to a curried function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */
  function castCurry(name, func, n) {
    return (forceCurry || (config.curry && n > 1))
      ? curry(func, n)
      : func;
  }

  /**
   * Casts `func` to a fixed arity function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the cast function.
   */
  function castFixed(name, func, n) {
    if (config.fixed && (forceFixed || !mapping.skipFixed[name])) {
      var data = mapping.methodSpread[name],
          start = data && data.start;

      return start  === undefined ? ary(func, n) : flatSpread(func, start);
    }
    return func;
  }

  /**
   * Casts `func` to an rearged function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */
  function castRearg(name, func, n) {
    return (config.rearg && n > 1 && (forceRearg || !mapping.skipRearg[name]))
      ? rearg(func, mapping.methodRearg[name] || mapping.aryRearg[n])
      : func;
  }

  /**
   * Creates a clone of `object` by `path`.
   *
   * @private
   * @param {Object} object The object to clone.
   * @param {Array|string} path The path to clone by.
   * @returns {Object} Returns the cloned object.
   */
  function cloneByPath(object, path) {
    path = toPath(path);

    var index = -1,
        length = path.length,
        lastIndex = length - 1,
        result = clone(Object(object)),
        nested = result;

    while (nested != null && ++index < length) {
      var key = path[index],
          value = nested[key];

      if (value != null) {
        nested[path[index]] = clone(index == lastIndex ? value : Object(value));
      }
      nested = nested[key];
    }
    return result;
  }

  /**
   * Converts `lodash` to an immutable auto-curried iteratee-first data-last
   * version with conversion `options` applied.
   *
   * @param {Object} [options] The options object. See `baseConvert` for more details.
   * @returns {Function} Returns the converted `lodash`.
   */
  function convertLib(options) {
    return _.runInContext.convert(options)(undefined);
  }

  /**
   * Create a converter function for `func` of `name`.
   *
   * @param {string} name The name of the function to convert.
   * @param {Function} func The function to convert.
   * @returns {Function} Returns the new converter function.
   */
  function createConverter(name, func) {
    var realName = mapping.aliasToReal[name] || name,
        methodName = mapping.remap[realName] || realName,
        oldOptions = options;

    return function(options) {
      var newUtil = isLib ? pristine : helpers,
          newFunc = isLib ? pristine[methodName] : func,
          newOptions = assign(assign({}, oldOptions), options);

      return baseConvert(newUtil, realName, newFunc, newOptions);
    };
  }

  /**
   * Creates a function that wraps `func` to invoke its iteratee, with up to `n`
   * arguments, ignoring any additional arguments.
   *
   * @private
   * @param {Function} func The function to cap iteratee arguments for.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the new function.
   */
  function iterateeAry(func, n) {
    return overArg(func, function(func) {
      return typeof func == 'function' ? baseAry(func, n) : func;
    });
  }

  /**
   * Creates a function that wraps `func` to invoke its iteratee with arguments
   * arranged according to the specified `indexes` where the argument value at
   * the first index is provided as the first argument, the argument value at
   * the second index is provided as the second argument, and so on.
   *
   * @private
   * @param {Function} func The function to rearrange iteratee arguments for.
   * @param {number[]} indexes The arranged argument indexes.
   * @returns {Function} Returns the new function.
   */
  function iterateeRearg(func, indexes) {
    return overArg(func, function(func) {
      var n = indexes.length;
      return baseArity(rearg(baseAry(func, n), indexes), n);
    });
  }

  /**
   * Creates a function that invokes `func` with its first argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function() {
      var length = arguments.length;
      if (!length) {
        return func();
      }
      var args = Array(length);
      while (length--) {
        args[length] = arguments[length];
      }
      var index = config.rearg ? 0 : (length - 1);
      args[index] = transform(args[index]);
      return func.apply(undefined, args);
    };
  }

  /**
   * Creates a function that wraps `func` and applys the conversions
   * rules by `name`.
   *
   * @private
   * @param {string} name The name of the function to wrap.
   * @param {Function} func The function to wrap.
   * @returns {Function} Returns the converted function.
   */
  function wrap(name, func) {
    var result,
        realName = mapping.aliasToReal[name] || name,
        wrapped = func,
        wrapper = wrappers[realName];

    if (wrapper) {
      wrapped = wrapper(func);
    }
    else if (config.immutable) {
      if (mapping.mutate.array[realName]) {
        wrapped = wrapImmutable(func, cloneArray);
      }
      else if (mapping.mutate.object[realName]) {
        wrapped = wrapImmutable(func, createCloner(func));
      }
      else if (mapping.mutate.set[realName]) {
        wrapped = wrapImmutable(func, cloneByPath);
      }
    }
    each(aryMethodKeys, function(aryKey) {
      each(mapping.aryMethod[aryKey], function(otherName) {
        if (realName == otherName) {
          var data = mapping.methodSpread[realName],
              afterRearg = data && data.afterRearg;

          result = afterRearg
            ? castFixed(realName, castRearg(realName, wrapped, aryKey), aryKey)
            : castRearg(realName, castFixed(realName, wrapped, aryKey), aryKey);

          result = castCap(realName, result);
          result = castCurry(realName, result, aryKey);
          return false;
        }
      });
      return !result;
    });

    result || (result = wrapped);
    if (result == func) {
      result = forceCurry ? curry(result, 1) : function() {
        return func.apply(this, arguments);
      };
    }
    result.convert = createConverter(realName, func);
    if (mapping.placeholder[realName]) {
      setPlaceholder = true;
      result.placeholder = func.placeholder = placeholder;
    }
    return result;
  }

  /*--------------------------------------------------------------------------*/

  if (!isObj) {
    return wrap(name, func);
  }
  var _ = func;

  // Convert methods by ary cap.
  var pairs = [];
  each(aryMethodKeys, function(aryKey) {
    each(mapping.aryMethod[aryKey], function(key) {
      var func = _[mapping.remap[key] || key];
      if (func) {
        pairs.push([key, wrap(key, func)]);
      }
    });
  });

  // Convert remaining methods.
  each(keys(_), function(key) {
    var func = _[key];
    if (typeof func == 'function') {
      var length = pairs.length;
      while (length--) {
        if (pairs[length][0] == key) {
          return;
        }
      }
      func.convert = createConverter(key, func);
      pairs.push([key, func]);
    }
  });

  // Assign to `_` leaving `_.prototype` unchanged to allow chaining.
  each(pairs, function(pair) {
    _[pair[0]] = pair[1];
  });

  _.convert = convertLib;
  if (setPlaceholder) {
    _.placeholder = placeholder;
  }
  // Assign aliases.
  each(keys(_), function(key) {
    each(mapping.realToAlias[key] || [], function(alias) {
      _[alias] = _[key];
    });
  });

  return _;
}

module.exports = baseConvert;


/***/ }),

/***/ "../node_modules/lodash/fp/_mapping.js":
/***/ (function(module, exports) {

/** Used to map aliases to their real names. */
exports.aliasToReal = {

  // Lodash aliases.
  'each': 'forEach',
  'eachRight': 'forEachRight',
  'entries': 'toPairs',
  'entriesIn': 'toPairsIn',
  'extend': 'assignIn',
  'extendAll': 'assignInAll',
  'extendAllWith': 'assignInAllWith',
  'extendWith': 'assignInWith',
  'first': 'head',

  // Methods that are curried variants of others.
  'conforms': 'conformsTo',
  'matches': 'isMatch',
  'property': 'get',

  // Ramda aliases.
  '__': 'placeholder',
  'F': 'stubFalse',
  'T': 'stubTrue',
  'all': 'every',
  'allPass': 'overEvery',
  'always': 'constant',
  'any': 'some',
  'anyPass': 'overSome',
  'apply': 'spread',
  'assoc': 'set',
  'assocPath': 'set',
  'complement': 'negate',
  'compose': 'flowRight',
  'contains': 'includes',
  'dissoc': 'unset',
  'dissocPath': 'unset',
  'dropLast': 'dropRight',
  'dropLastWhile': 'dropRightWhile',
  'equals': 'isEqual',
  'identical': 'eq',
  'indexBy': 'keyBy',
  'init': 'initial',
  'invertObj': 'invert',
  'juxt': 'over',
  'omitAll': 'omit',
  'nAry': 'ary',
  'path': 'get',
  'pathEq': 'matchesProperty',
  'pathOr': 'getOr',
  'paths': 'at',
  'pickAll': 'pick',
  'pipe': 'flow',
  'pluck': 'map',
  'prop': 'get',
  'propEq': 'matchesProperty',
  'propOr': 'getOr',
  'props': 'at',
  'symmetricDifference': 'xor',
  'symmetricDifferenceBy': 'xorBy',
  'symmetricDifferenceWith': 'xorWith',
  'takeLast': 'takeRight',
  'takeLastWhile': 'takeRightWhile',
  'unapply': 'rest',
  'unnest': 'flatten',
  'useWith': 'overArgs',
  'where': 'conformsTo',
  'whereEq': 'isMatch',
  'zipObj': 'zipObject'
};

/** Used to map ary to method names. */
exports.aryMethod = {
  '1': [
    'assignAll', 'assignInAll', 'attempt', 'castArray', 'ceil', 'create',
    'curry', 'curryRight', 'defaultsAll', 'defaultsDeepAll', 'floor', 'flow',
    'flowRight', 'fromPairs', 'invert', 'iteratee', 'memoize', 'method', 'mergeAll',
    'methodOf', 'mixin', 'nthArg', 'over', 'overEvery', 'overSome','rest', 'reverse',
    'round', 'runInContext', 'spread', 'template', 'trim', 'trimEnd', 'trimStart',
    'uniqueId', 'words', 'zipAll'
  ],
  '2': [
    'add', 'after', 'ary', 'assign', 'assignAllWith', 'assignIn', 'assignInAllWith',
    'at', 'before', 'bind', 'bindAll', 'bindKey', 'chunk', 'cloneDeepWith',
    'cloneWith', 'concat', 'conformsTo', 'countBy', 'curryN', 'curryRightN',
    'debounce', 'defaults', 'defaultsDeep', 'defaultTo', 'delay', 'difference',
    'divide', 'drop', 'dropRight', 'dropRightWhile', 'dropWhile', 'endsWith', 'eq',
    'every', 'filter', 'find', 'findIndex', 'findKey', 'findLast', 'findLastIndex',
    'findLastKey', 'flatMap', 'flatMapDeep', 'flattenDepth', 'forEach',
    'forEachRight', 'forIn', 'forInRight', 'forOwn', 'forOwnRight', 'get',
    'groupBy', 'gt', 'gte', 'has', 'hasIn', 'includes', 'indexOf', 'intersection',
    'invertBy', 'invoke', 'invokeMap', 'isEqual', 'isMatch', 'join', 'keyBy',
    'lastIndexOf', 'lt', 'lte', 'map', 'mapKeys', 'mapValues', 'matchesProperty',
    'maxBy', 'meanBy', 'merge', 'mergeAllWith', 'minBy', 'multiply', 'nth', 'omit',
    'omitBy', 'overArgs', 'pad', 'padEnd', 'padStart', 'parseInt', 'partial',
    'partialRight', 'partition', 'pick', 'pickBy', 'propertyOf', 'pull', 'pullAll',
    'pullAt', 'random', 'range', 'rangeRight', 'rearg', 'reject', 'remove',
    'repeat', 'restFrom', 'result', 'sampleSize', 'some', 'sortBy', 'sortedIndex',
    'sortedIndexOf', 'sortedLastIndex', 'sortedLastIndexOf', 'sortedUniqBy',
    'split', 'spreadFrom', 'startsWith', 'subtract', 'sumBy', 'take', 'takeRight',
    'takeRightWhile', 'takeWhile', 'tap', 'throttle', 'thru', 'times', 'trimChars',
    'trimCharsEnd', 'trimCharsStart', 'truncate', 'union', 'uniqBy', 'uniqWith',
    'unset', 'unzipWith', 'without', 'wrap', 'xor', 'zip', 'zipObject',
    'zipObjectDeep'
  ],
  '3': [
    'assignInWith', 'assignWith', 'clamp', 'differenceBy', 'differenceWith',
    'findFrom', 'findIndexFrom', 'findLastFrom', 'findLastIndexFrom', 'getOr',
    'includesFrom', 'indexOfFrom', 'inRange', 'intersectionBy', 'intersectionWith',
    'invokeArgs', 'invokeArgsMap', 'isEqualWith', 'isMatchWith', 'flatMapDepth',
    'lastIndexOfFrom', 'mergeWith', 'orderBy', 'padChars', 'padCharsEnd',
    'padCharsStart', 'pullAllBy', 'pullAllWith', 'rangeStep', 'rangeStepRight',
    'reduce', 'reduceRight', 'replace', 'set', 'slice', 'sortedIndexBy',
    'sortedLastIndexBy', 'transform', 'unionBy', 'unionWith', 'update', 'xorBy',
    'xorWith', 'zipWith'
  ],
  '4': [
    'fill', 'setWith', 'updateWith'
  ]
};

/** Used to map ary to rearg configs. */
exports.aryRearg = {
  '2': [1, 0],
  '3': [2, 0, 1],
  '4': [3, 2, 0, 1]
};

/** Used to map method names to their iteratee ary. */
exports.iterateeAry = {
  'dropRightWhile': 1,
  'dropWhile': 1,
  'every': 1,
  'filter': 1,
  'find': 1,
  'findFrom': 1,
  'findIndex': 1,
  'findIndexFrom': 1,
  'findKey': 1,
  'findLast': 1,
  'findLastFrom': 1,
  'findLastIndex': 1,
  'findLastIndexFrom': 1,
  'findLastKey': 1,
  'flatMap': 1,
  'flatMapDeep': 1,
  'flatMapDepth': 1,
  'forEach': 1,
  'forEachRight': 1,
  'forIn': 1,
  'forInRight': 1,
  'forOwn': 1,
  'forOwnRight': 1,
  'map': 1,
  'mapKeys': 1,
  'mapValues': 1,
  'partition': 1,
  'reduce': 2,
  'reduceRight': 2,
  'reject': 1,
  'remove': 1,
  'some': 1,
  'takeRightWhile': 1,
  'takeWhile': 1,
  'times': 1,
  'transform': 2
};

/** Used to map method names to iteratee rearg configs. */
exports.iterateeRearg = {
  'mapKeys': [1],
  'reduceRight': [1, 0]
};

/** Used to map method names to rearg configs. */
exports.methodRearg = {
  'assignInAllWith': [1, 0],
  'assignInWith': [1, 2, 0],
  'assignAllWith': [1, 0],
  'assignWith': [1, 2, 0],
  'differenceBy': [1, 2, 0],
  'differenceWith': [1, 2, 0],
  'getOr': [2, 1, 0],
  'intersectionBy': [1, 2, 0],
  'intersectionWith': [1, 2, 0],
  'isEqualWith': [1, 2, 0],
  'isMatchWith': [2, 1, 0],
  'mergeAllWith': [1, 0],
  'mergeWith': [1, 2, 0],
  'padChars': [2, 1, 0],
  'padCharsEnd': [2, 1, 0],
  'padCharsStart': [2, 1, 0],
  'pullAllBy': [2, 1, 0],
  'pullAllWith': [2, 1, 0],
  'rangeStep': [1, 2, 0],
  'rangeStepRight': [1, 2, 0],
  'setWith': [3, 1, 2, 0],
  'sortedIndexBy': [2, 1, 0],
  'sortedLastIndexBy': [2, 1, 0],
  'unionBy': [1, 2, 0],
  'unionWith': [1, 2, 0],
  'updateWith': [3, 1, 2, 0],
  'xorBy': [1, 2, 0],
  'xorWith': [1, 2, 0],
  'zipWith': [1, 2, 0]
};

/** Used to map method names to spread configs. */
exports.methodSpread = {
  'assignAll': { 'start': 0 },
  'assignAllWith': { 'start': 0 },
  'assignInAll': { 'start': 0 },
  'assignInAllWith': { 'start': 0 },
  'defaultsAll': { 'start': 0 },
  'defaultsDeepAll': { 'start': 0 },
  'invokeArgs': { 'start': 2 },
  'invokeArgsMap': { 'start': 2 },
  'mergeAll': { 'start': 0 },
  'mergeAllWith': { 'start': 0 },
  'partial': { 'start': 1 },
  'partialRight': { 'start': 1 },
  'without': { 'start': 1 },
  'zipAll': { 'start': 0 }
};

/** Used to identify methods which mutate arrays or objects. */
exports.mutate = {
  'array': {
    'fill': true,
    'pull': true,
    'pullAll': true,
    'pullAllBy': true,
    'pullAllWith': true,
    'pullAt': true,
    'remove': true,
    'reverse': true
  },
  'object': {
    'assign': true,
    'assignAll': true,
    'assignAllWith': true,
    'assignIn': true,
    'assignInAll': true,
    'assignInAllWith': true,
    'assignInWith': true,
    'assignWith': true,
    'defaults': true,
    'defaultsAll': true,
    'defaultsDeep': true,
    'defaultsDeepAll': true,
    'merge': true,
    'mergeAll': true,
    'mergeAllWith': true,
    'mergeWith': true,
  },
  'set': {
    'set': true,
    'setWith': true,
    'unset': true,
    'update': true,
    'updateWith': true
  }
};

/** Used to track methods with placeholder support */
exports.placeholder = {
  'bind': true,
  'bindKey': true,
  'curry': true,
  'curryRight': true,
  'partial': true,
  'partialRight': true
};

/** Used to map real names to their aliases. */
exports.realToAlias = (function() {
  var hasOwnProperty = Object.prototype.hasOwnProperty,
      object = exports.aliasToReal,
      result = {};

  for (var key in object) {
    var value = object[key];
    if (hasOwnProperty.call(result, value)) {
      result[value].push(key);
    } else {
      result[value] = [key];
    }
  }
  return result;
}());

/** Used to map method names to other names. */
exports.remap = {
  'assignAll': 'assign',
  'assignAllWith': 'assignWith',
  'assignInAll': 'assignIn',
  'assignInAllWith': 'assignInWith',
  'curryN': 'curry',
  'curryRightN': 'curryRight',
  'defaultsAll': 'defaults',
  'defaultsDeepAll': 'defaultsDeep',
  'findFrom': 'find',
  'findIndexFrom': 'findIndex',
  'findLastFrom': 'findLast',
  'findLastIndexFrom': 'findLastIndex',
  'getOr': 'get',
  'includesFrom': 'includes',
  'indexOfFrom': 'indexOf',
  'invokeArgs': 'invoke',
  'invokeArgsMap': 'invokeMap',
  'lastIndexOfFrom': 'lastIndexOf',
  'mergeAll': 'merge',
  'mergeAllWith': 'mergeWith',
  'padChars': 'pad',
  'padCharsEnd': 'padEnd',
  'padCharsStart': 'padStart',
  'propertyOf': 'get',
  'rangeStep': 'range',
  'rangeStepRight': 'rangeRight',
  'restFrom': 'rest',
  'spreadFrom': 'spread',
  'trimChars': 'trim',
  'trimCharsEnd': 'trimEnd',
  'trimCharsStart': 'trimStart',
  'zipAll': 'zip'
};

/** Used to track methods that skip fixing their arity. */
exports.skipFixed = {
  'castArray': true,
  'flow': true,
  'flowRight': true,
  'iteratee': true,
  'mixin': true,
  'rearg': true,
  'runInContext': true
};

/** Used to track methods that skip rearranging arguments. */
exports.skipRearg = {
  'add': true,
  'assign': true,
  'assignIn': true,
  'bind': true,
  'bindKey': true,
  'concat': true,
  'difference': true,
  'divide': true,
  'eq': true,
  'gt': true,
  'gte': true,
  'isEqual': true,
  'lt': true,
  'lte': true,
  'matchesProperty': true,
  'merge': true,
  'multiply': true,
  'overArgs': true,
  'partial': true,
  'partialRight': true,
  'propertyOf': true,
  'random': true,
  'range': true,
  'rangeRight': true,
  'subtract': true,
  'zip': true,
  'zipObject': true,
  'zipObjectDeep': true
};


/***/ }),

/***/ "../node_modules/lodash/fp/placeholder.js":
/***/ (function(module, exports) {

/**
 * The default argument placeholder value for methods.
 *
 * @type {Object}
 */
module.exports = {};


/***/ }),

/***/ "../node_modules/lodash/lodash.min.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash lodash.com/license | Underscore.js 1.8.3 underscorejs.org/LICENSE
 */
;(function(){function n(n,t){return n.set(t[0],t[1]),n}function t(n,t){return n.add(t),n}function r(n,t,r){switch(r.length){case 0:return n.call(t);case 1:return n.call(t,r[0]);case 2:return n.call(t,r[0],r[1]);case 3:return n.call(t,r[0],r[1],r[2])}return n.apply(t,r)}function e(n,t,r,e){for(var u=-1,i=null==n?0:n.length;++u<i;){var o=n[u];t(e,o,r(o),n)}return e}function u(n,t){for(var r=-1,e=null==n?0:n.length;++r<e&&false!==t(n[r],r,n););return n}function i(n,t){for(var r=null==n?0:n.length;r--&&false!==t(n[r],r,n););
return n}function o(n,t){for(var r=-1,e=null==n?0:n.length;++r<e;)if(!t(n[r],r,n))return false;return true}function f(n,t){for(var r=-1,e=null==n?0:n.length,u=0,i=[];++r<e;){var o=n[r];t(o,r,n)&&(i[u++]=o)}return i}function c(n,t){return!(null==n||!n.length)&&-1<d(n,t,0)}function a(n,t,r){for(var e=-1,u=null==n?0:n.length;++e<u;)if(r(t,n[e]))return true;return false}function l(n,t){for(var r=-1,e=null==n?0:n.length,u=Array(e);++r<e;)u[r]=t(n[r],r,n);return u}function s(n,t){for(var r=-1,e=t.length,u=n.length;++r<e;)n[u+r]=t[r];
return n}function h(n,t,r,e){var u=-1,i=null==n?0:n.length;for(e&&i&&(r=n[++u]);++u<i;)r=t(r,n[u],u,n);return r}function p(n,t,r,e){var u=null==n?0:n.length;for(e&&u&&(r=n[--u]);u--;)r=t(r,n[u],u,n);return r}function _(n,t){for(var r=-1,e=null==n?0:n.length;++r<e;)if(t(n[r],r,n))return true;return false}function v(n,t,r){var e;return r(n,function(n,r,u){if(t(n,r,u))return e=r,false}),e}function g(n,t,r,e){var u=n.length;for(r+=e?1:-1;e?r--:++r<u;)if(t(n[r],r,n))return r;return-1}function d(n,t,r){if(t===t)n:{
--r;for(var e=n.length;++r<e;)if(n[r]===t){n=r;break n}n=-1}else n=g(n,b,r);return n}function y(n,t,r,e){--r;for(var u=n.length;++r<u;)if(e(n[r],t))return r;return-1}function b(n){return n!==n}function x(n,t){var r=null==n?0:n.length;return r?k(n,t)/r:P}function j(n){return function(t){return null==t?F:t[n]}}function w(n){return function(t){return null==n?F:n[t]}}function m(n,t,r,e,u){return u(n,function(n,u,i){r=e?(e=false,n):t(r,n,u,i)}),r}function A(n,t){var r=n.length;for(n.sort(t);r--;)n[r]=n[r].c;
return n}function k(n,t){for(var r,e=-1,u=n.length;++e<u;){var i=t(n[e]);i!==F&&(r=r===F?i:r+i)}return r}function E(n,t){for(var r=-1,e=Array(n);++r<n;)e[r]=t(r);return e}function O(n,t){return l(t,function(t){return[t,n[t]]})}function S(n){return function(t){return n(t)}}function I(n,t){return l(t,function(t){return n[t]})}function R(n,t){return n.has(t)}function z(n,t){for(var r=-1,e=n.length;++r<e&&-1<d(t,n[r],0););return r}function W(n,t){for(var r=n.length;r--&&-1<d(t,n[r],0););return r}function B(n){
return"\\"+Tn[n]}function L(n){var t=-1,r=Array(n.size);return n.forEach(function(n,e){r[++t]=[e,n]}),r}function U(n,t){return function(r){return n(t(r))}}function C(n,t){for(var r=-1,e=n.length,u=0,i=[];++r<e;){var o=n[r];o!==t&&"__lodash_placeholder__"!==o||(n[r]="__lodash_placeholder__",i[u++]=r)}return i}function D(n){var t=-1,r=Array(n.size);return n.forEach(function(n){r[++t]=n}),r}function M(n){var t=-1,r=Array(n.size);return n.forEach(function(n){r[++t]=[n,n]}),r}function T(n){if(Bn.test(n)){
for(var t=zn.lastIndex=0;zn.test(n);)++t;n=t}else n=tt(n);return n}function $(n){return Bn.test(n)?n.match(zn)||[]:n.split("")}var F,N=1/0,P=NaN,Z=[["ary",128],["bind",1],["bindKey",2],["curry",8],["curryRight",16],["flip",512],["partial",32],["partialRight",64],["rearg",256]],q=/\b__p\+='';/g,V=/\b(__p\+=)''\+/g,K=/(__e\(.*?\)|\b__t\))\+'';/g,G=/&(?:amp|lt|gt|quot|#39);/g,H=/[&<>"']/g,J=RegExp(G.source),Y=RegExp(H.source),Q=/<%-([\s\S]+?)%>/g,X=/<%([\s\S]+?)%>/g,nn=/<%=([\s\S]+?)%>/g,tn=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,rn=/^\w*$/,en=/^\./,un=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,on=/[\\^$.*+?()[\]{}|]/g,fn=RegExp(on.source),cn=/^\s+|\s+$/g,an=/^\s+/,ln=/\s+$/,sn=/\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,hn=/\{\n\/\* \[wrapped with (.+)\] \*/,pn=/,? & /,_n=/[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,vn=/\\(\\)?/g,gn=/\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,dn=/\w*$/,yn=/^[-+]0x[0-9a-f]+$/i,bn=/^0b[01]+$/i,xn=/^\[object .+?Constructor\]$/,jn=/^0o[0-7]+$/i,wn=/^(?:0|[1-9]\d*)$/,mn=/[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,An=/($^)/,kn=/['\n\r\u2028\u2029\\]/g,En="[\\ufe0e\\ufe0f]?(?:[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|\\ud83c[\\udffb-\\udfff])?(?:\\u200d(?:[^\\ud800-\\udfff]|(?:\\ud83c[\\udde6-\\uddff]){2}|[\\ud800-\\udbff][\\udc00-\\udfff])[\\ufe0e\\ufe0f]?(?:[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|\\ud83c[\\udffb-\\udfff])?)*",On="(?:[\\u2700-\\u27bf]|(?:\\ud83c[\\udde6-\\uddff]){2}|[\\ud800-\\udbff][\\udc00-\\udfff])"+En,Sn="(?:[^\\ud800-\\udfff][\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]?|[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|(?:\\ud83c[\\udde6-\\uddff]){2}|[\\ud800-\\udbff][\\udc00-\\udfff]|[\\ud800-\\udfff])",In=RegExp("['\u2019]","g"),Rn=RegExp("[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]","g"),zn=RegExp("\\ud83c[\\udffb-\\udfff](?=\\ud83c[\\udffb-\\udfff])|"+Sn+En,"g"),Wn=RegExp(["[A-Z\\xc0-\\xd6\\xd8-\\xde]?[a-z\\xdf-\\xf6\\xf8-\\xff]+(?:['\u2019](?:d|ll|m|re|s|t|ve))?(?=[\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000]|[A-Z\\xc0-\\xd6\\xd8-\\xde]|$)|(?:[A-Z\\xc0-\\xd6\\xd8-\\xde]|[^\\ud800-\\udfff\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000\\d+\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde])+(?:['\u2019](?:D|LL|M|RE|S|T|VE))?(?=[\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000]|[A-Z\\xc0-\\xd6\\xd8-\\xde](?:[a-z\\xdf-\\xf6\\xf8-\\xff]|[^\\ud800-\\udfff\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000\\d+\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde])|$)|[A-Z\\xc0-\\xd6\\xd8-\\xde]?(?:[a-z\\xdf-\\xf6\\xf8-\\xff]|[^\\ud800-\\udfff\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000\\d+\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde])+(?:['\u2019](?:d|ll|m|re|s|t|ve))?|[A-Z\\xc0-\\xd6\\xd8-\\xde]+(?:['\u2019](?:D|LL|M|RE|S|T|VE))?|\\d*(?:(?:1ST|2ND|3RD|(?![123])\\dTH)\\b)|\\d*(?:(?:1st|2nd|3rd|(?![123])\\dth)\\b)|\\d+",On].join("|"),"g"),Bn=RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]"),Ln=/[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,Un="Array Buffer DataView Date Error Float32Array Float64Array Function Int8Array Int16Array Int32Array Map Math Object Promise RegExp Set String Symbol TypeError Uint8Array Uint8ClampedArray Uint16Array Uint32Array WeakMap _ clearTimeout isFinite parseInt setTimeout".split(" "),Cn={};
Cn["[object Float32Array]"]=Cn["[object Float64Array]"]=Cn["[object Int8Array]"]=Cn["[object Int16Array]"]=Cn["[object Int32Array]"]=Cn["[object Uint8Array]"]=Cn["[object Uint8ClampedArray]"]=Cn["[object Uint16Array]"]=Cn["[object Uint32Array]"]=true,Cn["[object Arguments]"]=Cn["[object Array]"]=Cn["[object ArrayBuffer]"]=Cn["[object Boolean]"]=Cn["[object DataView]"]=Cn["[object Date]"]=Cn["[object Error]"]=Cn["[object Function]"]=Cn["[object Map]"]=Cn["[object Number]"]=Cn["[object Object]"]=Cn["[object RegExp]"]=Cn["[object Set]"]=Cn["[object String]"]=Cn["[object WeakMap]"]=false;
var Dn={};Dn["[object Arguments]"]=Dn["[object Array]"]=Dn["[object ArrayBuffer]"]=Dn["[object DataView]"]=Dn["[object Boolean]"]=Dn["[object Date]"]=Dn["[object Float32Array]"]=Dn["[object Float64Array]"]=Dn["[object Int8Array]"]=Dn["[object Int16Array]"]=Dn["[object Int32Array]"]=Dn["[object Map]"]=Dn["[object Number]"]=Dn["[object Object]"]=Dn["[object RegExp]"]=Dn["[object Set]"]=Dn["[object String]"]=Dn["[object Symbol]"]=Dn["[object Uint8Array]"]=Dn["[object Uint8ClampedArray]"]=Dn["[object Uint16Array]"]=Dn["[object Uint32Array]"]=true,
Dn["[object Error]"]=Dn["[object Function]"]=Dn["[object WeakMap]"]=false;var Mn,Tn={"\\":"\\","'":"'","\n":"n","\r":"r","\u2028":"u2028","\u2029":"u2029"},$n=parseFloat,Fn=parseInt,Nn=typeof global=="object"&&global&&global.Object===Object&&global,Pn=typeof self=="object"&&self&&self.Object===Object&&self,Zn=Nn||Pn||Function("return this")(),qn=typeof exports=="object"&&exports&&!exports.nodeType&&exports,Vn=qn&&typeof module=="object"&&module&&!module.nodeType&&module,Kn=Vn&&Vn.exports===qn,Gn=Kn&&Nn.process;
n:{try{Mn=Gn&&Gn.binding&&Gn.binding("util");break n}catch(n){}Mn=void 0}var Hn=Mn&&Mn.isArrayBuffer,Jn=Mn&&Mn.isDate,Yn=Mn&&Mn.isMap,Qn=Mn&&Mn.isRegExp,Xn=Mn&&Mn.isSet,nt=Mn&&Mn.isTypedArray,tt=j("length"),rt=w({"\xc0":"A","\xc1":"A","\xc2":"A","\xc3":"A","\xc4":"A","\xc5":"A","\xe0":"a","\xe1":"a","\xe2":"a","\xe3":"a","\xe4":"a","\xe5":"a","\xc7":"C","\xe7":"c","\xd0":"D","\xf0":"d","\xc8":"E","\xc9":"E","\xca":"E","\xcb":"E","\xe8":"e","\xe9":"e","\xea":"e","\xeb":"e","\xcc":"I","\xcd":"I","\xce":"I",
"\xcf":"I","\xec":"i","\xed":"i","\xee":"i","\xef":"i","\xd1":"N","\xf1":"n","\xd2":"O","\xd3":"O","\xd4":"O","\xd5":"O","\xd6":"O","\xd8":"O","\xf2":"o","\xf3":"o","\xf4":"o","\xf5":"o","\xf6":"o","\xf8":"o","\xd9":"U","\xda":"U","\xdb":"U","\xdc":"U","\xf9":"u","\xfa":"u","\xfb":"u","\xfc":"u","\xdd":"Y","\xfd":"y","\xff":"y","\xc6":"Ae","\xe6":"ae","\xde":"Th","\xfe":"th","\xdf":"ss","\u0100":"A","\u0102":"A","\u0104":"A","\u0101":"a","\u0103":"a","\u0105":"a","\u0106":"C","\u0108":"C","\u010a":"C",
"\u010c":"C","\u0107":"c","\u0109":"c","\u010b":"c","\u010d":"c","\u010e":"D","\u0110":"D","\u010f":"d","\u0111":"d","\u0112":"E","\u0114":"E","\u0116":"E","\u0118":"E","\u011a":"E","\u0113":"e","\u0115":"e","\u0117":"e","\u0119":"e","\u011b":"e","\u011c":"G","\u011e":"G","\u0120":"G","\u0122":"G","\u011d":"g","\u011f":"g","\u0121":"g","\u0123":"g","\u0124":"H","\u0126":"H","\u0125":"h","\u0127":"h","\u0128":"I","\u012a":"I","\u012c":"I","\u012e":"I","\u0130":"I","\u0129":"i","\u012b":"i","\u012d":"i",
"\u012f":"i","\u0131":"i","\u0134":"J","\u0135":"j","\u0136":"K","\u0137":"k","\u0138":"k","\u0139":"L","\u013b":"L","\u013d":"L","\u013f":"L","\u0141":"L","\u013a":"l","\u013c":"l","\u013e":"l","\u0140":"l","\u0142":"l","\u0143":"N","\u0145":"N","\u0147":"N","\u014a":"N","\u0144":"n","\u0146":"n","\u0148":"n","\u014b":"n","\u014c":"O","\u014e":"O","\u0150":"O","\u014d":"o","\u014f":"o","\u0151":"o","\u0154":"R","\u0156":"R","\u0158":"R","\u0155":"r","\u0157":"r","\u0159":"r","\u015a":"S","\u015c":"S",
"\u015e":"S","\u0160":"S","\u015b":"s","\u015d":"s","\u015f":"s","\u0161":"s","\u0162":"T","\u0164":"T","\u0166":"T","\u0163":"t","\u0165":"t","\u0167":"t","\u0168":"U","\u016a":"U","\u016c":"U","\u016e":"U","\u0170":"U","\u0172":"U","\u0169":"u","\u016b":"u","\u016d":"u","\u016f":"u","\u0171":"u","\u0173":"u","\u0174":"W","\u0175":"w","\u0176":"Y","\u0177":"y","\u0178":"Y","\u0179":"Z","\u017b":"Z","\u017d":"Z","\u017a":"z","\u017c":"z","\u017e":"z","\u0132":"IJ","\u0133":"ij","\u0152":"Oe","\u0153":"oe",
"\u0149":"'n","\u017f":"s"}),et=w({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}),ut=w({"&amp;":"&","&lt;":"<","&gt;":">","&quot;":'"',"&#39;":"'"}),it=function w(En){function On(n){if(xu(n)&&!af(n)&&!(n instanceof Mn)){if(n instanceof zn)return n;if(ci.call(n,"__wrapped__"))return Pe(n)}return new zn(n)}function Sn(){}function zn(n,t){this.__wrapped__=n,this.__actions__=[],this.__chain__=!!t,this.__index__=0,this.__values__=F}function Mn(n){this.__wrapped__=n,this.__actions__=[],this.__dir__=1,
this.__filtered__=false,this.__iteratees__=[],this.__takeCount__=4294967295,this.__views__=[]}function Tn(n){var t=-1,r=null==n?0:n.length;for(this.clear();++t<r;){var e=n[t];this.set(e[0],e[1])}}function Nn(n){var t=-1,r=null==n?0:n.length;for(this.clear();++t<r;){var e=n[t];this.set(e[0],e[1])}}function Pn(n){var t=-1,r=null==n?0:n.length;for(this.clear();++t<r;){var e=n[t];this.set(e[0],e[1])}}function qn(n){var t=-1,r=null==n?0:n.length;for(this.__data__=new Pn;++t<r;)this.add(n[t])}function Vn(n){
this.size=(this.__data__=new Nn(n)).size}function Gn(n,t){var r,e=af(n),u=!e&&cf(n),i=!e&&!u&&sf(n),o=!e&&!u&&!i&&gf(n),u=(e=e||u||i||o)?E(n.length,ri):[],f=u.length;for(r in n)!t&&!ci.call(n,r)||e&&("length"==r||i&&("offset"==r||"parent"==r)||o&&("buffer"==r||"byteLength"==r||"byteOffset"==r)||Re(r,f))||u.push(r);return u}function tt(n){var t=n.length;return t?n[cr(0,t-1)]:F}function ot(n,t){return Te(Mr(n),gt(t,0,n.length))}function ft(n){return Te(Mr(n))}function ct(n,t,r){(r===F||hu(n[t],r))&&(r!==F||t in n)||_t(n,t,r);
}function at(n,t,r){var e=n[t];ci.call(n,t)&&hu(e,r)&&(r!==F||t in n)||_t(n,t,r)}function lt(n,t){for(var r=n.length;r--;)if(hu(n[r][0],t))return r;return-1}function st(n,t,r,e){return oo(n,function(n,u,i){t(e,n,r(n),i)}),e}function ht(n,t){return n&&Tr(t,Lu(t),n)}function pt(n,t){return n&&Tr(t,Uu(t),n)}function _t(n,t,r){"__proto__"==t&&Ei?Ei(n,t,{configurable:true,enumerable:true,value:r,writable:true}):n[t]=r}function vt(n,t){for(var r=-1,e=t.length,u=Hu(e),i=null==n;++r<e;)u[r]=i?F:Wu(n,t[r]);return u;
}function gt(n,t,r){return n===n&&(r!==F&&(n=n<=r?n:r),t!==F&&(n=n>=t?n:t)),n}function dt(n,t,r,e,i,o){var f,c=1&t,a=2&t,l=4&t;if(r&&(f=i?r(n,e,i,o):r(n)),f!==F)return f;if(!bu(n))return n;if(e=af(n)){if(f=Ee(n),!c)return Mr(n,f)}else{var s=yo(n),h="[object Function]"==s||"[object GeneratorFunction]"==s;if(sf(n))return Wr(n,c);if("[object Object]"==s||"[object Arguments]"==s||h&&!i){if(f=a||h?{}:Oe(n),!c)return a?Fr(n,pt(f,n)):$r(n,ht(f,n))}else{if(!Dn[s])return i?n:{};f=Se(n,s,dt,c)}}if(o||(o=new Vn),
i=o.get(n))return i;o.set(n,f);var a=l?a?ye:de:a?Uu:Lu,p=e?F:a(n);return u(p||n,function(e,u){p&&(u=e,e=n[u]),at(f,u,dt(e,t,r,u,n,o))}),f}function yt(n){var t=Lu(n);return function(r){return bt(r,n,t)}}function bt(n,t,r){var e=r.length;if(null==n)return!e;for(n=ni(n);e--;){var u=r[e],i=t[u],o=n[u];if(o===F&&!(u in n)||!i(o))return false}return true}function xt(n,t,r){if(typeof n!="function")throw new ei("Expected a function");return jo(function(){n.apply(F,r)},t)}function jt(n,t,r,e){var u=-1,i=c,o=true,f=n.length,s=[],h=t.length;
if(!f)return s;r&&(t=l(t,S(r))),e?(i=a,o=false):200<=t.length&&(i=R,o=false,t=new qn(t));n:for(;++u<f;){var p=n[u],_=null==r?p:r(p),p=e||0!==p?p:0;if(o&&_===_){for(var v=h;v--;)if(t[v]===_)continue n;s.push(p)}else i(t,_,e)||s.push(p)}return s}function wt(n,t){var r=true;return oo(n,function(n,e,u){return r=!!t(n,e,u)}),r}function mt(n,t,r){for(var e=-1,u=n.length;++e<u;){var i=n[e],o=t(i);if(null!=o&&(f===F?o===o&&!Au(o):r(o,f)))var f=o,c=i}return c}function At(n,t){var r=[];return oo(n,function(n,e,u){
t(n,e,u)&&r.push(n)}),r}function kt(n,t,r,e,u){var i=-1,o=n.length;for(r||(r=Ie),u||(u=[]);++i<o;){var f=n[i];0<t&&r(f)?1<t?kt(f,t-1,r,e,u):s(u,f):e||(u[u.length]=f)}return u}function Et(n,t){return n&&co(n,t,Lu)}function Ot(n,t){return n&&ao(n,t,Lu)}function St(n,t){return f(t,function(t){return gu(n[t])})}function It(n,t){t=Rr(t,n);for(var r=0,e=t.length;null!=n&&r<e;)n=n[$e(t[r++])];return r&&r==e?n:F}function Rt(n,t,r){return t=t(n),af(n)?t:s(t,r(n))}function zt(n){if(null==n)n=n===F?"[object Undefined]":"[object Null]";else if(ki&&ki in ni(n)){
var t=ci.call(n,ki),r=n[ki];try{n[ki]=F;var e=true}catch(n){}var u=si.call(n);e&&(t?n[ki]=r:delete n[ki]),n=u}else n=si.call(n);return n}function Wt(n,t){return n>t}function Bt(n,t){return null!=n&&ci.call(n,t)}function Lt(n,t){return null!=n&&t in ni(n)}function Ut(n,t,r){for(var e=r?a:c,u=n[0].length,i=n.length,o=i,f=Hu(i),s=1/0,h=[];o--;){var p=n[o];o&&t&&(p=l(p,S(t))),s=Mi(p.length,s),f[o]=!r&&(t||120<=u&&120<=p.length)?new qn(o&&p):F}var p=n[0],_=-1,v=f[0];n:for(;++_<u&&h.length<s;){var g=p[_],d=t?t(g):g,g=r||0!==g?g:0;
if(v?!R(v,d):!e(h,d,r)){for(o=i;--o;){var y=f[o];if(y?!R(y,d):!e(n[o],d,r))continue n}v&&v.push(d),h.push(g)}}return h}function Ct(n,t,r){var e={};return Et(n,function(n,u,i){t(e,r(n),u,i)}),e}function Dt(n,t,e){return t=Rr(t,n),n=2>t.length?n:It(n,vr(t,0,-1)),t=null==n?n:n[$e(Ge(t))],null==t?F:r(t,n,e)}function Mt(n){return xu(n)&&"[object Arguments]"==zt(n)}function Tt(n){return xu(n)&&"[object ArrayBuffer]"==zt(n)}function $t(n){return xu(n)&&"[object Date]"==zt(n)}function Ft(n,t,r,e,u){if(n===t)t=true;else if(null==n||null==t||!xu(n)&&!xu(t))t=n!==n&&t!==t;else n:{
var i=af(n),o=af(t),f=i?"[object Array]":yo(n),c=o?"[object Array]":yo(t),f="[object Arguments]"==f?"[object Object]":f,c="[object Arguments]"==c?"[object Object]":c,a="[object Object]"==f,o="[object Object]"==c;if((c=f==c)&&sf(n)){if(!sf(t)){t=false;break n}i=true,a=false}if(c&&!a)u||(u=new Vn),t=i||gf(n)?_e(n,t,r,e,Ft,u):ve(n,t,f,r,e,Ft,u);else{if(!(1&r)&&(i=a&&ci.call(n,"__wrapped__"),f=o&&ci.call(t,"__wrapped__"),i||f)){n=i?n.value():n,t=f?t.value():t,u||(u=new Vn),t=Ft(n,t,r,e,u);break n}if(c)t:if(u||(u=new Vn),
i=1&r,f=de(n),o=f.length,c=de(t).length,o==c||i){for(a=o;a--;){var l=f[a];if(!(i?l in t:ci.call(t,l))){t=false;break t}}if((c=u.get(n))&&u.get(t))t=c==t;else{c=true,u.set(n,t),u.set(t,n);for(var s=i;++a<o;){var l=f[a],h=n[l],p=t[l];if(e)var _=i?e(p,h,l,t,n,u):e(h,p,l,n,t,u);if(_===F?h!==p&&!Ft(h,p,r,e,u):!_){c=false;break}s||(s="constructor"==l)}c&&!s&&(r=n.constructor,e=t.constructor,r!=e&&"constructor"in n&&"constructor"in t&&!(typeof r=="function"&&r instanceof r&&typeof e=="function"&&e instanceof e)&&(c=false)),
u.delete(n),u.delete(t),t=c}}else t=false;else t=false}}return t}function Nt(n){return xu(n)&&"[object Map]"==yo(n)}function Pt(n,t,r,e){var u=r.length,i=u,o=!e;if(null==n)return!i;for(n=ni(n);u--;){var f=r[u];if(o&&f[2]?f[1]!==n[f[0]]:!(f[0]in n))return false}for(;++u<i;){var f=r[u],c=f[0],a=n[c],l=f[1];if(o&&f[2]){if(a===F&&!(c in n))return false}else{if(f=new Vn,e)var s=e(a,l,c,n,t,f);if(s===F?!Ft(l,a,3,e,f):!s)return false}}return true}function Zt(n){return!(!bu(n)||li&&li in n)&&(gu(n)?_i:xn).test(Fe(n))}function qt(n){
return xu(n)&&"[object RegExp]"==zt(n)}function Vt(n){return xu(n)&&"[object Set]"==yo(n)}function Kt(n){return xu(n)&&yu(n.length)&&!!Cn[zt(n)]}function Gt(n){return typeof n=="function"?n:null==n?Nu:typeof n=="object"?af(n)?Xt(n[0],n[1]):Qt(n):Vu(n)}function Ht(n){if(!Le(n))return Ci(n);var t,r=[];for(t in ni(n))ci.call(n,t)&&"constructor"!=t&&r.push(t);return r}function Jt(n,t){return n<t}function Yt(n,t){var r=-1,e=pu(n)?Hu(n.length):[];return oo(n,function(n,u,i){e[++r]=t(n,u,i)}),e}function Qt(n){
var t=me(n);return 1==t.length&&t[0][2]?Ue(t[0][0],t[0][1]):function(r){return r===n||Pt(r,n,t)}}function Xt(n,t){return We(n)&&t===t&&!bu(t)?Ue($e(n),t):function(r){var e=Wu(r,n);return e===F&&e===t?Bu(r,n):Ft(t,e,3)}}function nr(n,t,r,e,u){n!==t&&co(t,function(i,o){if(bu(i)){u||(u=new Vn);var f=u,c=n[o],a=t[o],l=f.get(a);if(l)ct(n,o,l);else{var l=e?e(c,a,o+"",n,t,f):F,s=l===F;if(s){var h=af(a),p=!h&&sf(a),_=!h&&!p&&gf(a),l=a;h||p||_?af(c)?l=c:_u(c)?l=Mr(c):p?(s=false,l=Wr(a,true)):_?(s=false,l=Lr(a,true)):l=[]:wu(a)||cf(a)?(l=c,
cf(c)?l=Ru(c):(!bu(c)||r&&gu(c))&&(l=Oe(a))):s=false}s&&(f.set(a,l),nr(l,a,r,e,f),f.delete(a)),ct(n,o,l)}}else f=e?e(n[o],i,o+"",n,t,u):F,f===F&&(f=i),ct(n,o,f)},Uu)}function tr(n,t){var r=n.length;if(r)return t+=0>t?r:0,Re(t,r)?n[t]:F}function rr(n,t,r){var e=-1;return t=l(t.length?t:[Nu],S(je())),n=Yt(n,function(n){return{a:l(t,function(t){return t(n)}),b:++e,c:n}}),A(n,function(n,t){var e;n:{e=-1;for(var u=n.a,i=t.a,o=u.length,f=r.length;++e<o;){var c=Ur(u[e],i[e]);if(c){e=e>=f?c:c*("desc"==r[e]?-1:1);
break n}}e=n.b-t.b}return e})}function er(n,t){return ur(n,t,function(t,r){return Bu(n,r)})}function ur(n,t,r){for(var e=-1,u=t.length,i={};++e<u;){var o=t[e],f=It(n,o);r(f,o)&&pr(i,Rr(o,n),f)}return i}function ir(n){return function(t){return It(t,n)}}function or(n,t,r,e){var u=e?y:d,i=-1,o=t.length,f=n;for(n===t&&(t=Mr(t)),r&&(f=l(n,S(r)));++i<o;)for(var c=0,a=t[i],a=r?r(a):a;-1<(c=u(f,a,c,e));)f!==n&&wi.call(f,c,1),wi.call(n,c,1);return n}function fr(n,t){for(var r=n?t.length:0,e=r-1;r--;){var u=t[r];
if(r==e||u!==i){var i=u;Re(u)?wi.call(n,u,1):mr(n,u)}}}function cr(n,t){return n+zi(Fi()*(t-n+1))}function ar(n,t){var r="";if(!n||1>t||9007199254740991<t)return r;do t%2&&(r+=n),(t=zi(t/2))&&(n+=n);while(t);return r}function lr(n,t){return wo(Ce(n,t,Nu),n+"")}function sr(n){return tt(Du(n))}function hr(n,t){var r=Du(n);return Te(r,gt(t,0,r.length))}function pr(n,t,r,e){if(!bu(n))return n;t=Rr(t,n);for(var u=-1,i=t.length,o=i-1,f=n;null!=f&&++u<i;){var c=$e(t[u]),a=r;if(u!=o){var l=f[c],a=e?e(l,c,f):F;
a===F&&(a=bu(l)?l:Re(t[u+1])?[]:{})}at(f,c,a),f=f[c]}return n}function _r(n){return Te(Du(n))}function vr(n,t,r){var e=-1,u=n.length;for(0>t&&(t=-t>u?0:u+t),r=r>u?u:r,0>r&&(r+=u),u=t>r?0:r-t>>>0,t>>>=0,r=Hu(u);++e<u;)r[e]=n[e+t];return r}function gr(n,t){var r;return oo(n,function(n,e,u){return r=t(n,e,u),!r}),!!r}function dr(n,t,r){var e=0,u=null==n?e:n.length;if(typeof t=="number"&&t===t&&2147483647>=u){for(;e<u;){var i=e+u>>>1,o=n[i];null!==o&&!Au(o)&&(r?o<=t:o<t)?e=i+1:u=i}return u}return yr(n,t,Nu,r);
}function yr(n,t,r,e){t=r(t);for(var u=0,i=null==n?0:n.length,o=t!==t,f=null===t,c=Au(t),a=t===F;u<i;){var l=zi((u+i)/2),s=r(n[l]),h=s!==F,p=null===s,_=s===s,v=Au(s);(o?e||_:a?_&&(e||h):f?_&&h&&(e||!p):c?_&&h&&!p&&(e||!v):p||v?0:e?s<=t:s<t)?u=l+1:i=l}return Mi(i,4294967294)}function br(n,t){for(var r=-1,e=n.length,u=0,i=[];++r<e;){var o=n[r],f=t?t(o):o;if(!r||!hu(f,c)){var c=f;i[u++]=0===o?0:o}}return i}function xr(n){return typeof n=="number"?n:Au(n)?P:+n}function jr(n){if(typeof n=="string")return n;
if(af(n))return l(n,jr)+"";if(Au(n))return uo?uo.call(n):"";var t=n+"";return"0"==t&&1/n==-N?"-0":t}function wr(n,t,r){var e=-1,u=c,i=n.length,o=true,f=[],l=f;if(r)o=false,u=a;else if(200<=i){if(u=t?null:po(n))return D(u);o=false,u=R,l=new qn}else l=t?[]:f;n:for(;++e<i;){var s=n[e],h=t?t(s):s,s=r||0!==s?s:0;if(o&&h===h){for(var p=l.length;p--;)if(l[p]===h)continue n;t&&l.push(h),f.push(s)}else u(l,h,r)||(l!==f&&l.push(h),f.push(s))}return f}function mr(n,t){return t=Rr(t,n),n=2>t.length?n:It(n,vr(t,0,-1)),
null==n||delete n[$e(Ge(t))]}function Ar(n,t,r,e){for(var u=n.length,i=e?u:-1;(e?i--:++i<u)&&t(n[i],i,n););return r?vr(n,e?0:i,e?i+1:u):vr(n,e?i+1:0,e?u:i)}function kr(n,t){var r=n;return r instanceof Mn&&(r=r.value()),h(t,function(n,t){return t.func.apply(t.thisArg,s([n],t.args))},r)}function Er(n,t,r){var e=n.length;if(2>e)return e?wr(n[0]):[];for(var u=-1,i=Hu(e);++u<e;)for(var o=n[u],f=-1;++f<e;)f!=u&&(i[u]=jt(i[u]||o,n[f],t,r));return wr(kt(i,1),t,r)}function Or(n,t,r){for(var e=-1,u=n.length,i=t.length,o={};++e<u;)r(o,n[e],e<i?t[e]:F);
return o}function Sr(n){return _u(n)?n:[]}function Ir(n){return typeof n=="function"?n:Nu}function Rr(n,t){return af(n)?n:We(n,t)?[n]:mo(zu(n))}function zr(n,t,r){var e=n.length;return r=r===F?e:r,!t&&r>=e?n:vr(n,t,r)}function Wr(n,t){if(t)return n.slice();var r=n.length,r=yi?yi(r):new n.constructor(r);return n.copy(r),r}function Br(n){var t=new n.constructor(n.byteLength);return new di(t).set(new di(n)),t}function Lr(n,t){return new n.constructor(t?Br(n.buffer):n.buffer,n.byteOffset,n.length)}function Ur(n,t){
if(n!==t){var r=n!==F,e=null===n,u=n===n,i=Au(n),o=t!==F,f=null===t,c=t===t,a=Au(t);if(!f&&!a&&!i&&n>t||i&&o&&c&&!f&&!a||e&&o&&c||!r&&c||!u)return 1;if(!e&&!i&&!a&&n<t||a&&r&&u&&!e&&!i||f&&r&&u||!o&&u||!c)return-1}return 0}function Cr(n,t,r,e){var u=-1,i=n.length,o=r.length,f=-1,c=t.length,a=Di(i-o,0),l=Hu(c+a);for(e=!e;++f<c;)l[f]=t[f];for(;++u<o;)(e||u<i)&&(l[r[u]]=n[u]);for(;a--;)l[f++]=n[u++];return l}function Dr(n,t,r,e){var u=-1,i=n.length,o=-1,f=r.length,c=-1,a=t.length,l=Di(i-f,0),s=Hu(l+a);
for(e=!e;++u<l;)s[u]=n[u];for(l=u;++c<a;)s[l+c]=t[c];for(;++o<f;)(e||u<i)&&(s[l+r[o]]=n[u++]);return s}function Mr(n,t){var r=-1,e=n.length;for(t||(t=Hu(e));++r<e;)t[r]=n[r];return t}function Tr(n,t,r,e){var u=!r;r||(r={});for(var i=-1,o=t.length;++i<o;){var f=t[i],c=e?e(r[f],n[f],f,r,n):F;c===F&&(c=n[f]),u?_t(r,f,c):at(r,f,c)}return r}function $r(n,t){return Tr(n,vo(n),t)}function Fr(n,t){return Tr(n,go(n),t)}function Nr(n,t){return function(r,u){var i=af(r)?e:st,o=t?t():{};return i(r,n,je(u,2),o);
}}function Pr(n){return lr(function(t,r){var e=-1,u=r.length,i=1<u?r[u-1]:F,o=2<u?r[2]:F,i=3<n.length&&typeof i=="function"?(u--,i):F;for(o&&ze(r[0],r[1],o)&&(i=3>u?F:i,u=1),t=ni(t);++e<u;)(o=r[e])&&n(t,o,e,i);return t})}function Zr(n,t){return function(r,e){if(null==r)return r;if(!pu(r))return n(r,e);for(var u=r.length,i=t?u:-1,o=ni(r);(t?i--:++i<u)&&false!==e(o[i],i,o););return r}}function qr(n){return function(t,r,e){var u=-1,i=ni(t);e=e(t);for(var o=e.length;o--;){var f=e[n?o:++u];if(false===r(i[f],f,i))break;
}return t}}function Vr(n,t,r){function e(){return(this&&this!==Zn&&this instanceof e?i:n).apply(u?r:this,arguments)}var u=1&t,i=Hr(n);return e}function Kr(n){return function(t){t=zu(t);var r=Bn.test(t)?$(t):F,e=r?r[0]:t.charAt(0);return t=r?zr(r,1).join(""):t.slice(1),e[n]()+t}}function Gr(n){return function(t){return h($u(Tu(t).replace(In,"")),n,"")}}function Hr(n){return function(){var t=arguments;switch(t.length){case 0:return new n;case 1:return new n(t[0]);case 2:return new n(t[0],t[1]);case 3:
return new n(t[0],t[1],t[2]);case 4:return new n(t[0],t[1],t[2],t[3]);case 5:return new n(t[0],t[1],t[2],t[3],t[4]);case 6:return new n(t[0],t[1],t[2],t[3],t[4],t[5]);case 7:return new n(t[0],t[1],t[2],t[3],t[4],t[5],t[6])}var r=io(n.prototype),t=n.apply(r,t);return bu(t)?t:r}}function Jr(n,t,e){function u(){for(var o=arguments.length,f=Hu(o),c=o,a=xe(u);c--;)f[c]=arguments[c];return c=3>o&&f[0]!==a&&f[o-1]!==a?[]:C(f,a),o-=c.length,o<e?fe(n,t,Xr,u.placeholder,F,f,c,F,F,e-o):r(this&&this!==Zn&&this instanceof u?i:n,this,f);
}var i=Hr(n);return u}function Yr(n){return function(t,r,e){var u=ni(t);if(!pu(t)){var i=je(r,3);t=Lu(t),r=function(n){return i(u[n],n,u)}}return r=n(t,r,e),-1<r?u[i?t[r]:r]:F}}function Qr(n){return ge(function(t){var r=t.length,e=r,u=zn.prototype.thru;for(n&&t.reverse();e--;){var i=t[e];if(typeof i!="function")throw new ei("Expected a function");if(u&&!o&&"wrapper"==be(i))var o=new zn([],true)}for(e=o?e:r;++e<r;)var i=t[e],u=be(i),f="wrapper"==u?_o(i):F,o=f&&Be(f[0])&&424==f[1]&&!f[4].length&&1==f[9]?o[be(f[0])].apply(o,f[3]):1==i.length&&Be(i)?o[u]():o.thru(i);
return function(){var n=arguments,e=n[0];if(o&&1==n.length&&af(e))return o.plant(e).value();for(var u=0,n=r?t[u].apply(this,n):e;++u<r;)n=t[u].call(this,n);return n}})}function Xr(n,t,r,e,u,i,o,f,c,a){function l(){for(var d=arguments.length,y=Hu(d),b=d;b--;)y[b]=arguments[b];if(_){var x,j=xe(l),b=y.length;for(x=0;b--;)y[b]===j&&++x}if(e&&(y=Cr(y,e,u,_)),i&&(y=Dr(y,i,o,_)),d-=x,_&&d<a)return j=C(y,j),fe(n,t,Xr,l.placeholder,r,y,j,f,c,a-d);if(j=h?r:this,b=p?j[n]:n,d=y.length,f){x=y.length;for(var w=Mi(f.length,x),m=Mr(y);w--;){
var A=f[w];y[w]=Re(A,x)?m[A]:F}}else v&&1<d&&y.reverse();return s&&c<d&&(y.length=c),this&&this!==Zn&&this instanceof l&&(b=g||Hr(b)),b.apply(j,y)}var s=128&t,h=1&t,p=2&t,_=24&t,v=512&t,g=p?F:Hr(n);return l}function ne(n,t){return function(r,e){return Ct(r,n,t(e))}}function te(n,t){return function(r,e){var u;if(r===F&&e===F)return t;if(r!==F&&(u=r),e!==F){if(u===F)return e;typeof r=="string"||typeof e=="string"?(r=jr(r),e=jr(e)):(r=xr(r),e=xr(e)),u=n(r,e)}return u}}function re(n){return ge(function(t){
return t=l(t,S(je())),lr(function(e){var u=this;return n(t,function(n){return r(n,u,e)})})})}function ee(n,t){t=t===F?" ":jr(t);var r=t.length;return 2>r?r?ar(t,n):t:(r=ar(t,Ri(n/T(t))),Bn.test(t)?zr($(r),0,n).join(""):r.slice(0,n))}function ue(n,t,e,u){function i(){for(var t=-1,c=arguments.length,a=-1,l=u.length,s=Hu(l+c),h=this&&this!==Zn&&this instanceof i?f:n;++a<l;)s[a]=u[a];for(;c--;)s[a++]=arguments[++t];return r(h,o?e:this,s)}var o=1&t,f=Hr(n);return i}function ie(n){return function(t,r,e){
e&&typeof e!="number"&&ze(t,r,e)&&(r=e=F),t=Eu(t),r===F?(r=t,t=0):r=Eu(r),e=e===F?t<r?1:-1:Eu(e);var u=-1;r=Di(Ri((r-t)/(e||1)),0);for(var i=Hu(r);r--;)i[n?r:++u]=t,t+=e;return i}}function oe(n){return function(t,r){return typeof t=="string"&&typeof r=="string"||(t=Iu(t),r=Iu(r)),n(t,r)}}function fe(n,t,r,e,u,i,o,f,c,a){var l=8&t,s=l?o:F;o=l?F:o;var h=l?i:F;return i=l?F:i,t=(t|(l?32:64))&~(l?64:32),4&t||(t&=-4),u=[n,t,u,h,s,i,o,f,c,a],r=r.apply(F,u),Be(n)&&xo(r,u),r.placeholder=e,De(r,n,t)}function ce(n){
var t=Xu[n];return function(n,r){if(n=Iu(n),r=null==r?0:Mi(Ou(r),292)){var e=(zu(n)+"e").split("e"),e=t(e[0]+"e"+(+e[1]+r)),e=(zu(e)+"e").split("e");return+(e[0]+"e"+(+e[1]-r))}return t(n)}}function ae(n){return function(t){var r=yo(t);return"[object Map]"==r?L(t):"[object Set]"==r?M(t):O(t,n(t))}}function le(n,t,r,e,u,i,o,f){var c=2&t;if(!c&&typeof n!="function")throw new ei("Expected a function");var a=e?e.length:0;if(a||(t&=-97,e=u=F),o=o===F?o:Di(Ou(o),0),f=f===F?f:Ou(f),a-=u?u.length:0,64&t){
var l=e,s=u;e=u=F}var h=c?F:_o(n);return i=[n,t,r,e,u,l,s,i,o,f],h&&(r=i[1],n=h[1],t=r|n,e=128==n&&8==r||128==n&&256==r&&i[7].length<=h[8]||384==n&&h[7].length<=h[8]&&8==r,131>t||e)&&(1&n&&(i[2]=h[2],t|=1&r?0:4),(r=h[3])&&(e=i[3],i[3]=e?Cr(e,r,h[4]):r,i[4]=e?C(i[3],"__lodash_placeholder__"):h[4]),(r=h[5])&&(e=i[5],i[5]=e?Dr(e,r,h[6]):r,i[6]=e?C(i[5],"__lodash_placeholder__"):h[6]),(r=h[7])&&(i[7]=r),128&n&&(i[8]=null==i[8]?h[8]:Mi(i[8],h[8])),null==i[9]&&(i[9]=h[9]),i[0]=h[0],i[1]=t),n=i[0],t=i[1],
r=i[2],e=i[3],u=i[4],f=i[9]=i[9]===F?c?0:n.length:Di(i[9]-a,0),!f&&24&t&&(t&=-25),De((h?lo:xo)(t&&1!=t?8==t||16==t?Jr(n,t,f):32!=t&&33!=t||u.length?Xr.apply(F,i):ue(n,t,r,e):Vr(n,t,r),i),n,t)}function se(n,t,r,e){return n===F||hu(n,ii[r])&&!ci.call(e,r)?t:n}function he(n,t,r,e,u,i){return bu(n)&&bu(t)&&(i.set(t,n),nr(n,t,F,he,i),i.delete(t)),n}function pe(n){return wu(n)?F:n}function _e(n,t,r,e,u,i){var o=1&r,f=n.length,c=t.length;if(f!=c&&!(o&&c>f))return false;if((c=i.get(n))&&i.get(t))return c==t;var c=-1,a=true,l=2&r?new qn:F;
for(i.set(n,t),i.set(t,n);++c<f;){var s=n[c],h=t[c];if(e)var p=o?e(h,s,c,t,n,i):e(s,h,c,n,t,i);if(p!==F){if(p)continue;a=false;break}if(l){if(!_(t,function(n,t){if(!R(l,t)&&(s===n||u(s,n,r,e,i)))return l.push(t)})){a=false;break}}else if(s!==h&&!u(s,h,r,e,i)){a=false;break}}return i.delete(n),i.delete(t),a}function ve(n,t,r,e,u,i,o){switch(r){case"[object DataView]":if(n.byteLength!=t.byteLength||n.byteOffset!=t.byteOffset)break;n=n.buffer,t=t.buffer;case"[object ArrayBuffer]":if(n.byteLength!=t.byteLength||!i(new di(n),new di(t)))break;
return true;case"[object Boolean]":case"[object Date]":case"[object Number]":return hu(+n,+t);case"[object Error]":return n.name==t.name&&n.message==t.message;case"[object RegExp]":case"[object String]":return n==t+"";case"[object Map]":var f=L;case"[object Set]":if(f||(f=D),n.size!=t.size&&!(1&e))break;return(r=o.get(n))?r==t:(e|=2,o.set(n,t),t=_e(f(n),f(t),e,u,i,o),o.delete(n),t);case"[object Symbol]":if(eo)return eo.call(n)==eo.call(t)}return false}function ge(n){return wo(Ce(n,F,Ve),n+"")}function de(n){
return Rt(n,Lu,vo)}function ye(n){return Rt(n,Uu,go)}function be(n){for(var t=n.name+"",r=Ji[t],e=ci.call(Ji,t)?r.length:0;e--;){var u=r[e],i=u.func;if(null==i||i==n)return u.name}return t}function xe(n){return(ci.call(On,"placeholder")?On:n).placeholder}function je(){var n=On.iteratee||Pu,n=n===Pu?Gt:n;return arguments.length?n(arguments[0],arguments[1]):n}function we(n,t){var r=n.__data__,e=typeof t;return("string"==e||"number"==e||"symbol"==e||"boolean"==e?"__proto__"!==t:null===t)?r[typeof t=="string"?"string":"hash"]:r.map;
}function me(n){for(var t=Lu(n),r=t.length;r--;){var e=t[r],u=n[e];t[r]=[e,u,u===u&&!bu(u)]}return t}function Ae(n,t){var r=null==n?F:n[t];return Zt(r)?r:F}function ke(n,t,r){t=Rr(t,n);for(var e=-1,u=t.length,i=false;++e<u;){var o=$e(t[e]);if(!(i=null!=n&&r(n,o)))break;n=n[o]}return i||++e!=u?i:(u=null==n?0:n.length,!!u&&yu(u)&&Re(o,u)&&(af(n)||cf(n)))}function Ee(n){var t=n.length,r=n.constructor(t);return t&&"string"==typeof n[0]&&ci.call(n,"index")&&(r.index=n.index,r.input=n.input),r}function Oe(n){
return typeof n.constructor!="function"||Le(n)?{}:io(bi(n))}function Se(r,e,u,i){var o=r.constructor;switch(e){case"[object ArrayBuffer]":return Br(r);case"[object Boolean]":case"[object Date]":return new o(+r);case"[object DataView]":return e=i?Br(r.buffer):r.buffer,new r.constructor(e,r.byteOffset,r.byteLength);case"[object Float32Array]":case"[object Float64Array]":case"[object Int8Array]":case"[object Int16Array]":case"[object Int32Array]":case"[object Uint8Array]":case"[object Uint8ClampedArray]":
case"[object Uint16Array]":case"[object Uint32Array]":return Lr(r,i);case"[object Map]":return e=i?u(L(r),1):L(r),h(e,n,new r.constructor);case"[object Number]":case"[object String]":return new o(r);case"[object RegExp]":return e=new r.constructor(r.source,dn.exec(r)),e.lastIndex=r.lastIndex,e;case"[object Set]":return e=i?u(D(r),1):D(r),h(e,t,new r.constructor);case"[object Symbol]":return eo?ni(eo.call(r)):{}}}function Ie(n){return af(n)||cf(n)||!!(mi&&n&&n[mi])}function Re(n,t){return t=null==t?9007199254740991:t,
!!t&&(typeof n=="number"||wn.test(n))&&-1<n&&0==n%1&&n<t}function ze(n,t,r){if(!bu(r))return false;var e=typeof t;return!!("number"==e?pu(r)&&Re(t,r.length):"string"==e&&t in r)&&hu(r[t],n)}function We(n,t){if(af(n))return false;var r=typeof n;return!("number"!=r&&"symbol"!=r&&"boolean"!=r&&null!=n&&!Au(n))||(rn.test(n)||!tn.test(n)||null!=t&&n in ni(t))}function Be(n){var t=be(n),r=On[t];return typeof r=="function"&&t in Mn.prototype&&(n===r||(t=_o(r),!!t&&n===t[0]))}function Le(n){var t=n&&n.constructor;
return n===(typeof t=="function"&&t.prototype||ii)}function Ue(n,t){return function(r){return null!=r&&(r[n]===t&&(t!==F||n in ni(r)))}}function Ce(n,t,e){return t=Di(t===F?n.length-1:t,0),function(){for(var u=arguments,i=-1,o=Di(u.length-t,0),f=Hu(o);++i<o;)f[i]=u[t+i];for(i=-1,o=Hu(t+1);++i<t;)o[i]=u[i];return o[t]=e(f),r(n,this,o)}}function De(n,t,r){var e=t+"";t=wo;var u,i=Ne;return u=(u=e.match(hn))?u[1].split(pn):[],r=i(u,r),(i=r.length)&&(u=i-1,r[u]=(1<i?"& ":"")+r[u],r=r.join(2<i?", ":" "),
e=e.replace(sn,"{\n/* [wrapped with "+r+"] */\n")),t(n,e)}function Me(n){var t=0,r=0;return function(){var e=Ti(),u=16-(e-r);if(r=e,0<u){if(800<=++t)return arguments[0]}else t=0;return n.apply(F,arguments)}}function Te(n,t){var r=-1,e=n.length,u=e-1;for(t=t===F?e:t;++r<t;){var e=cr(r,u),i=n[e];n[e]=n[r],n[r]=i}return n.length=t,n}function $e(n){if(typeof n=="string"||Au(n))return n;var t=n+"";return"0"==t&&1/n==-N?"-0":t}function Fe(n){if(null!=n){try{return fi.call(n)}catch(n){}return n+""}return"";
}function Ne(n,t){return u(Z,function(r){var e="_."+r[0];t&r[1]&&!c(n,e)&&n.push(e)}),n.sort()}function Pe(n){if(n instanceof Mn)return n.clone();var t=new zn(n.__wrapped__,n.__chain__);return t.__actions__=Mr(n.__actions__),t.__index__=n.__index__,t.__values__=n.__values__,t}function Ze(n,t,r){var e=null==n?0:n.length;return e?(r=null==r?0:Ou(r),0>r&&(r=Di(e+r,0)),g(n,je(t,3),r)):-1}function qe(n,t,r){var e=null==n?0:n.length;if(!e)return-1;var u=e-1;return r!==F&&(u=Ou(r),u=0>r?Di(e+u,0):Mi(u,e-1)),
g(n,je(t,3),u,true)}function Ve(n){return(null==n?0:n.length)?kt(n,1):[]}function Ke(n){return n&&n.length?n[0]:F}function Ge(n){var t=null==n?0:n.length;return t?n[t-1]:F}function He(n,t){return n&&n.length&&t&&t.length?or(n,t):n}function Je(n){return null==n?n:Ni.call(n)}function Ye(n){if(!n||!n.length)return[];var t=0;return n=f(n,function(n){if(_u(n))return t=Di(n.length,t),true}),E(t,function(t){return l(n,j(t))})}function Qe(n,t){if(!n||!n.length)return[];var e=Ye(n);return null==t?e:l(e,function(n){
return r(t,F,n)})}function Xe(n){return n=On(n),n.__chain__=true,n}function nu(n,t){return t(n)}function tu(){return this}function ru(n,t){return(af(n)?u:oo)(n,je(t,3))}function eu(n,t){return(af(n)?i:fo)(n,je(t,3))}function uu(n,t){return(af(n)?l:Yt)(n,je(t,3))}function iu(n,t,r){return t=r?F:t,t=n&&null==t?n.length:t,le(n,128,F,F,F,F,t)}function ou(n,t){var r;if(typeof t!="function")throw new ei("Expected a function");return n=Ou(n),function(){return 0<--n&&(r=t.apply(this,arguments)),1>=n&&(t=F),
r}}function fu(n,t,r){return t=r?F:t,n=le(n,8,F,F,F,F,F,t),n.placeholder=fu.placeholder,n}function cu(n,t,r){return t=r?F:t,n=le(n,16,F,F,F,F,F,t),n.placeholder=cu.placeholder,n}function au(n,t,r){function e(t){var r=c,e=a;return c=a=F,_=t,s=n.apply(e,r)}function u(n){var r=n-p;return n-=_,p===F||r>=t||0>r||g&&n>=l}function i(){var n=Jo();if(u(n))return o(n);var r,e=jo;r=n-_,n=t-(n-p),r=g?Mi(n,l-r):n,h=e(i,r)}function o(n){return h=F,d&&c?e(n):(c=a=F,s)}function f(){var n=Jo(),r=u(n);if(c=arguments,
a=this,p=n,r){if(h===F)return _=n=p,h=jo(i,t),v?e(n):s;if(g)return h=jo(i,t),e(p)}return h===F&&(h=jo(i,t)),s}var c,a,l,s,h,p,_=0,v=false,g=false,d=true;if(typeof n!="function")throw new ei("Expected a function");return t=Iu(t)||0,bu(r)&&(v=!!r.leading,l=(g="maxWait"in r)?Di(Iu(r.maxWait)||0,t):l,d="trailing"in r?!!r.trailing:d),f.cancel=function(){h!==F&&ho(h),_=0,c=p=a=h=F},f.flush=function(){return h===F?s:o(Jo())},f}function lu(n,t){function r(){var e=arguments,u=t?t.apply(this,e):e[0],i=r.cache;return i.has(u)?i.get(u):(e=n.apply(this,e),
r.cache=i.set(u,e)||i,e)}if(typeof n!="function"||null!=t&&typeof t!="function")throw new ei("Expected a function");return r.cache=new(lu.Cache||Pn),r}function su(n){if(typeof n!="function")throw new ei("Expected a function");return function(){var t=arguments;switch(t.length){case 0:return!n.call(this);case 1:return!n.call(this,t[0]);case 2:return!n.call(this,t[0],t[1]);case 3:return!n.call(this,t[0],t[1],t[2])}return!n.apply(this,t)}}function hu(n,t){return n===t||n!==n&&t!==t}function pu(n){return null!=n&&yu(n.length)&&!gu(n);
}function _u(n){return xu(n)&&pu(n)}function vu(n){if(!xu(n))return false;var t=zt(n);return"[object Error]"==t||"[object DOMException]"==t||typeof n.message=="string"&&typeof n.name=="string"&&!wu(n)}function gu(n){return!!bu(n)&&(n=zt(n),"[object Function]"==n||"[object GeneratorFunction]"==n||"[object AsyncFunction]"==n||"[object Proxy]"==n)}function du(n){return typeof n=="number"&&n==Ou(n)}function yu(n){return typeof n=="number"&&-1<n&&0==n%1&&9007199254740991>=n}function bu(n){var t=typeof n;return null!=n&&("object"==t||"function"==t);
}function xu(n){return null!=n&&typeof n=="object"}function ju(n){return typeof n=="number"||xu(n)&&"[object Number]"==zt(n)}function wu(n){return!(!xu(n)||"[object Object]"!=zt(n))&&(n=bi(n),null===n||(n=ci.call(n,"constructor")&&n.constructor,typeof n=="function"&&n instanceof n&&fi.call(n)==hi))}function mu(n){return typeof n=="string"||!af(n)&&xu(n)&&"[object String]"==zt(n)}function Au(n){return typeof n=="symbol"||xu(n)&&"[object Symbol]"==zt(n)}function ku(n){if(!n)return[];if(pu(n))return mu(n)?$(n):Mr(n);
if(Ai&&n[Ai]){n=n[Ai]();for(var t,r=[];!(t=n.next()).done;)r.push(t.value);return r}return t=yo(n),("[object Map]"==t?L:"[object Set]"==t?D:Du)(n)}function Eu(n){return n?(n=Iu(n),n===N||n===-N?1.7976931348623157e308*(0>n?-1:1):n===n?n:0):0===n?n:0}function Ou(n){n=Eu(n);var t=n%1;return n===n?t?n-t:n:0}function Su(n){return n?gt(Ou(n),0,4294967295):0}function Iu(n){if(typeof n=="number")return n;if(Au(n))return P;if(bu(n)&&(n=typeof n.valueOf=="function"?n.valueOf():n,n=bu(n)?n+"":n),typeof n!="string")return 0===n?n:+n;
n=n.replace(cn,"");var t=bn.test(n);return t||jn.test(n)?Fn(n.slice(2),t?2:8):yn.test(n)?P:+n}function Ru(n){return Tr(n,Uu(n))}function zu(n){return null==n?"":jr(n)}function Wu(n,t,r){return n=null==n?F:It(n,t),n===F?r:n}function Bu(n,t){return null!=n&&ke(n,t,Lt)}function Lu(n){return pu(n)?Gn(n):Ht(n)}function Uu(n){if(pu(n))n=Gn(n,true);else if(bu(n)){var t,r=Le(n),e=[];for(t in n)("constructor"!=t||!r&&ci.call(n,t))&&e.push(t);n=e}else{if(t=[],null!=n)for(r in ni(n))t.push(r);n=t}return n}function Cu(n,t){
if(null==n)return{};var r=l(ye(n),function(n){return[n]});return t=je(t),ur(n,r,function(n,r){return t(n,r[0])})}function Du(n){return null==n?[]:I(n,Lu(n))}function Mu(n){return Nf(zu(n).toLowerCase())}function Tu(n){return(n=zu(n))&&n.replace(mn,rt).replace(Rn,"")}function $u(n,t,r){return n=zu(n),t=r?F:t,t===F?Ln.test(n)?n.match(Wn)||[]:n.match(_n)||[]:n.match(t)||[]}function Fu(n){return function(){return n}}function Nu(n){return n}function Pu(n){return Gt(typeof n=="function"?n:dt(n,1))}function Zu(n,t,r){
var e=Lu(t),i=St(t,e);null!=r||bu(t)&&(i.length||!e.length)||(r=t,t=n,n=this,i=St(t,Lu(t)));var o=!(bu(r)&&"chain"in r&&!r.chain),f=gu(n);return u(i,function(r){var e=t[r];n[r]=e,f&&(n.prototype[r]=function(){var t=this.__chain__;if(o||t){var r=n(this.__wrapped__);return(r.__actions__=Mr(this.__actions__)).push({func:e,args:arguments,thisArg:n}),r.__chain__=t,r}return e.apply(n,s([this.value()],arguments))})}),n}function qu(){}function Vu(n){return We(n)?j($e(n)):ir(n)}function Ku(){return[]}function Gu(){
return false}En=null==En?Zn:it.defaults(Zn.Object(),En,it.pick(Zn,Un));var Hu=En.Array,Ju=En.Date,Yu=En.Error,Qu=En.Function,Xu=En.Math,ni=En.Object,ti=En.RegExp,ri=En.String,ei=En.TypeError,ui=Hu.prototype,ii=ni.prototype,oi=En["__core-js_shared__"],fi=Qu.prototype.toString,ci=ii.hasOwnProperty,ai=0,li=function(){var n=/[^.]+$/.exec(oi&&oi.keys&&oi.keys.IE_PROTO||"");return n?"Symbol(src)_1."+n:""}(),si=ii.toString,hi=fi.call(ni),pi=Zn._,_i=ti("^"+fi.call(ci).replace(on,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$"),vi=Kn?En.Buffer:F,gi=En.Symbol,di=En.Uint8Array,yi=vi?vi.f:F,bi=U(ni.getPrototypeOf,ni),xi=ni.create,ji=ii.propertyIsEnumerable,wi=ui.splice,mi=gi?gi.isConcatSpreadable:F,Ai=gi?gi.iterator:F,ki=gi?gi.toStringTag:F,Ei=function(){
try{var n=Ae(ni,"defineProperty");return n({},"",{}),n}catch(n){}}(),Oi=En.clearTimeout!==Zn.clearTimeout&&En.clearTimeout,Si=Ju&&Ju.now!==Zn.Date.now&&Ju.now,Ii=En.setTimeout!==Zn.setTimeout&&En.setTimeout,Ri=Xu.ceil,zi=Xu.floor,Wi=ni.getOwnPropertySymbols,Bi=vi?vi.isBuffer:F,Li=En.isFinite,Ui=ui.join,Ci=U(ni.keys,ni),Di=Xu.max,Mi=Xu.min,Ti=Ju.now,$i=En.parseInt,Fi=Xu.random,Ni=ui.reverse,Pi=Ae(En,"DataView"),Zi=Ae(En,"Map"),qi=Ae(En,"Promise"),Vi=Ae(En,"Set"),Ki=Ae(En,"WeakMap"),Gi=Ae(ni,"create"),Hi=Ki&&new Ki,Ji={},Yi=Fe(Pi),Qi=Fe(Zi),Xi=Fe(qi),no=Fe(Vi),to=Fe(Ki),ro=gi?gi.prototype:F,eo=ro?ro.valueOf:F,uo=ro?ro.toString:F,io=function(){
function n(){}return function(t){return bu(t)?xi?xi(t):(n.prototype=t,t=new n,n.prototype=F,t):{}}}();On.templateSettings={escape:Q,evaluate:X,interpolate:nn,variable:"",imports:{_:On}},On.prototype=Sn.prototype,On.prototype.constructor=On,zn.prototype=io(Sn.prototype),zn.prototype.constructor=zn,Mn.prototype=io(Sn.prototype),Mn.prototype.constructor=Mn,Tn.prototype.clear=function(){this.__data__=Gi?Gi(null):{},this.size=0},Tn.prototype.delete=function(n){return n=this.has(n)&&delete this.__data__[n],
this.size-=n?1:0,n},Tn.prototype.get=function(n){var t=this.__data__;return Gi?(n=t[n],"__lodash_hash_undefined__"===n?F:n):ci.call(t,n)?t[n]:F},Tn.prototype.has=function(n){var t=this.__data__;return Gi?t[n]!==F:ci.call(t,n)},Tn.prototype.set=function(n,t){var r=this.__data__;return this.size+=this.has(n)?0:1,r[n]=Gi&&t===F?"__lodash_hash_undefined__":t,this},Nn.prototype.clear=function(){this.__data__=[],this.size=0},Nn.prototype.delete=function(n){var t=this.__data__;return n=lt(t,n),!(0>n)&&(n==t.length-1?t.pop():wi.call(t,n,1),
--this.size,true)},Nn.prototype.get=function(n){var t=this.__data__;return n=lt(t,n),0>n?F:t[n][1]},Nn.prototype.has=function(n){return-1<lt(this.__data__,n)},Nn.prototype.set=function(n,t){var r=this.__data__,e=lt(r,n);return 0>e?(++this.size,r.push([n,t])):r[e][1]=t,this},Pn.prototype.clear=function(){this.size=0,this.__data__={hash:new Tn,map:new(Zi||Nn),string:new Tn}},Pn.prototype.delete=function(n){return n=we(this,n).delete(n),this.size-=n?1:0,n},Pn.prototype.get=function(n){return we(this,n).get(n);
},Pn.prototype.has=function(n){return we(this,n).has(n)},Pn.prototype.set=function(n,t){var r=we(this,n),e=r.size;return r.set(n,t),this.size+=r.size==e?0:1,this},qn.prototype.add=qn.prototype.push=function(n){return this.__data__.set(n,"__lodash_hash_undefined__"),this},qn.prototype.has=function(n){return this.__data__.has(n)},Vn.prototype.clear=function(){this.__data__=new Nn,this.size=0},Vn.prototype.delete=function(n){var t=this.__data__;return n=t.delete(n),this.size=t.size,n},Vn.prototype.get=function(n){
return this.__data__.get(n)},Vn.prototype.has=function(n){return this.__data__.has(n)},Vn.prototype.set=function(n,t){var r=this.__data__;if(r instanceof Nn){var e=r.__data__;if(!Zi||199>e.length)return e.push([n,t]),this.size=++r.size,this;r=this.__data__=new Pn(e)}return r.set(n,t),this.size=r.size,this};var oo=Zr(Et),fo=Zr(Ot,true),co=qr(),ao=qr(true),lo=Hi?function(n,t){return Hi.set(n,t),n}:Nu,so=Ei?function(n,t){return Ei(n,"toString",{configurable:true,enumerable:false,value:Fu(t),writable:true})}:Nu,ho=Oi||function(n){
return Zn.clearTimeout(n)},po=Vi&&1/D(new Vi([,-0]))[1]==N?function(n){return new Vi(n)}:qu,_o=Hi?function(n){return Hi.get(n)}:qu,vo=Wi?function(n){return null==n?[]:(n=ni(n),f(Wi(n),function(t){return ji.call(n,t)}))}:Ku,go=Wi?function(n){for(var t=[];n;)s(t,vo(n)),n=bi(n);return t}:Ku,yo=zt;(Pi&&"[object DataView]"!=yo(new Pi(new ArrayBuffer(1)))||Zi&&"[object Map]"!=yo(new Zi)||qi&&"[object Promise]"!=yo(qi.resolve())||Vi&&"[object Set]"!=yo(new Vi)||Ki&&"[object WeakMap]"!=yo(new Ki))&&(yo=function(n){
var t=zt(n);if(n=(n="[object Object]"==t?n.constructor:F)?Fe(n):"")switch(n){case Yi:return"[object DataView]";case Qi:return"[object Map]";case Xi:return"[object Promise]";case no:return"[object Set]";case to:return"[object WeakMap]"}return t});var bo=oi?gu:Gu,xo=Me(lo),jo=Ii||function(n,t){return Zn.setTimeout(n,t)},wo=Me(so),mo=function(n){n=lu(n,function(n){return 500===t.size&&t.clear(),n});var t=n.cache;return n}(function(n){var t=[];return en.test(n)&&t.push(""),n.replace(un,function(n,r,e,u){
t.push(e?u.replace(vn,"$1"):r||n)}),t}),Ao=lr(function(n,t){return _u(n)?jt(n,kt(t,1,_u,true)):[]}),ko=lr(function(n,t){var r=Ge(t);return _u(r)&&(r=F),_u(n)?jt(n,kt(t,1,_u,true),je(r,2)):[]}),Eo=lr(function(n,t){var r=Ge(t);return _u(r)&&(r=F),_u(n)?jt(n,kt(t,1,_u,true),F,r):[]}),Oo=lr(function(n){var t=l(n,Sr);return t.length&&t[0]===n[0]?Ut(t):[]}),So=lr(function(n){var t=Ge(n),r=l(n,Sr);return t===Ge(r)?t=F:r.pop(),r.length&&r[0]===n[0]?Ut(r,je(t,2)):[]}),Io=lr(function(n){var t=Ge(n),r=l(n,Sr);return(t=typeof t=="function"?t:F)&&r.pop(),
r.length&&r[0]===n[0]?Ut(r,F,t):[]}),Ro=lr(He),zo=ge(function(n,t){var r=null==n?0:n.length,e=vt(n,t);return fr(n,l(t,function(n){return Re(n,r)?+n:n}).sort(Ur)),e}),Wo=lr(function(n){return wr(kt(n,1,_u,true))}),Bo=lr(function(n){var t=Ge(n);return _u(t)&&(t=F),wr(kt(n,1,_u,true),je(t,2))}),Lo=lr(function(n){var t=Ge(n),t=typeof t=="function"?t:F;return wr(kt(n,1,_u,true),F,t)}),Uo=lr(function(n,t){return _u(n)?jt(n,t):[]}),Co=lr(function(n){return Er(f(n,_u))}),Do=lr(function(n){var t=Ge(n);return _u(t)&&(t=F),
Er(f(n,_u),je(t,2))}),Mo=lr(function(n){var t=Ge(n),t=typeof t=="function"?t:F;return Er(f(n,_u),F,t)}),To=lr(Ye),$o=lr(function(n){var t=n.length,t=1<t?n[t-1]:F,t=typeof t=="function"?(n.pop(),t):F;return Qe(n,t)}),Fo=ge(function(n){function t(t){return vt(t,n)}var r=n.length,e=r?n[0]:0,u=this.__wrapped__;return!(1<r||this.__actions__.length)&&u instanceof Mn&&Re(e)?(u=u.slice(e,+e+(r?1:0)),u.__actions__.push({func:nu,args:[t],thisArg:F}),new zn(u,this.__chain__).thru(function(n){return r&&!n.length&&n.push(F),
n})):this.thru(t)}),No=Nr(function(n,t,r){ci.call(n,r)?++n[r]:_t(n,r,1)}),Po=Yr(Ze),Zo=Yr(qe),qo=Nr(function(n,t,r){ci.call(n,r)?n[r].push(t):_t(n,r,[t])}),Vo=lr(function(n,t,e){var u=-1,i=typeof t=="function",o=pu(n)?Hu(n.length):[];return oo(n,function(n){o[++u]=i?r(t,n,e):Dt(n,t,e)}),o}),Ko=Nr(function(n,t,r){_t(n,r,t)}),Go=Nr(function(n,t,r){n[r?0:1].push(t)},function(){return[[],[]]}),Ho=lr(function(n,t){if(null==n)return[];var r=t.length;return 1<r&&ze(n,t[0],t[1])?t=[]:2<r&&ze(t[0],t[1],t[2])&&(t=[t[0]]),
rr(n,kt(t,1),[])}),Jo=Si||function(){return Zn.Date.now()},Yo=lr(function(n,t,r){var e=1;if(r.length)var u=C(r,xe(Yo)),e=32|e;return le(n,e,t,r,u)}),Qo=lr(function(n,t,r){var e=3;if(r.length)var u=C(r,xe(Qo)),e=32|e;return le(t,e,n,r,u)}),Xo=lr(function(n,t){return xt(n,1,t)}),nf=lr(function(n,t,r){return xt(n,Iu(t)||0,r)});lu.Cache=Pn;var tf=lr(function(n,t){t=1==t.length&&af(t[0])?l(t[0],S(je())):l(kt(t,1),S(je()));var e=t.length;return lr(function(u){for(var i=-1,o=Mi(u.length,e);++i<o;)u[i]=t[i].call(this,u[i]);
return r(n,this,u)})}),rf=lr(function(n,t){return le(n,32,F,t,C(t,xe(rf)))}),ef=lr(function(n,t){return le(n,64,F,t,C(t,xe(ef)))}),uf=ge(function(n,t){return le(n,256,F,F,F,t)}),of=oe(Wt),ff=oe(function(n,t){return n>=t}),cf=Mt(function(){return arguments}())?Mt:function(n){return xu(n)&&ci.call(n,"callee")&&!ji.call(n,"callee")},af=Hu.isArray,lf=Hn?S(Hn):Tt,sf=Bi||Gu,hf=Jn?S(Jn):$t,pf=Yn?S(Yn):Nt,_f=Qn?S(Qn):qt,vf=Xn?S(Xn):Vt,gf=nt?S(nt):Kt,df=oe(Jt),yf=oe(function(n,t){return n<=t}),bf=Pr(function(n,t){
if(Le(t)||pu(t))Tr(t,Lu(t),n);else for(var r in t)ci.call(t,r)&&at(n,r,t[r])}),xf=Pr(function(n,t){Tr(t,Uu(t),n)}),jf=Pr(function(n,t,r,e){Tr(t,Uu(t),n,e)}),wf=Pr(function(n,t,r,e){Tr(t,Lu(t),n,e)}),mf=ge(vt),Af=lr(function(n){return n.push(F,se),r(jf,F,n)}),kf=lr(function(n){return n.push(F,he),r(Rf,F,n)}),Ef=ne(function(n,t,r){n[t]=r},Fu(Nu)),Of=ne(function(n,t,r){ci.call(n,t)?n[t].push(r):n[t]=[r]},je),Sf=lr(Dt),If=Pr(function(n,t,r){nr(n,t,r)}),Rf=Pr(function(n,t,r,e){nr(n,t,r,e)}),zf=ge(function(n,t){
var r={};if(null==n)return r;var e=false;t=l(t,function(t){return t=Rr(t,n),e||(e=1<t.length),t}),Tr(n,ye(n),r),e&&(r=dt(r,7,pe));for(var u=t.length;u--;)mr(r,t[u]);return r}),Wf=ge(function(n,t){return null==n?{}:er(n,t)}),Bf=ae(Lu),Lf=ae(Uu),Uf=Gr(function(n,t,r){return t=t.toLowerCase(),n+(r?Mu(t):t)}),Cf=Gr(function(n,t,r){return n+(r?"-":"")+t.toLowerCase()}),Df=Gr(function(n,t,r){return n+(r?" ":"")+t.toLowerCase()}),Mf=Kr("toLowerCase"),Tf=Gr(function(n,t,r){return n+(r?"_":"")+t.toLowerCase();
}),$f=Gr(function(n,t,r){return n+(r?" ":"")+Nf(t)}),Ff=Gr(function(n,t,r){return n+(r?" ":"")+t.toUpperCase()}),Nf=Kr("toUpperCase"),Pf=lr(function(n,t){try{return r(n,F,t)}catch(n){return vu(n)?n:new Yu(n)}}),Zf=ge(function(n,t){return u(t,function(t){t=$e(t),_t(n,t,Yo(n[t],n))}),n}),qf=Qr(),Vf=Qr(true),Kf=lr(function(n,t){return function(r){return Dt(r,n,t)}}),Gf=lr(function(n,t){return function(r){return Dt(n,r,t)}}),Hf=re(l),Jf=re(o),Yf=re(_),Qf=ie(),Xf=ie(true),nc=te(function(n,t){return n+t},0),tc=ce("ceil"),rc=te(function(n,t){
return n/t},1),ec=ce("floor"),uc=te(function(n,t){return n*t},1),ic=ce("round"),oc=te(function(n,t){return n-t},0);return On.after=function(n,t){if(typeof t!="function")throw new ei("Expected a function");return n=Ou(n),function(){if(1>--n)return t.apply(this,arguments)}},On.ary=iu,On.assign=bf,On.assignIn=xf,On.assignInWith=jf,On.assignWith=wf,On.at=mf,On.before=ou,On.bind=Yo,On.bindAll=Zf,On.bindKey=Qo,On.castArray=function(){if(!arguments.length)return[];var n=arguments[0];return af(n)?n:[n]},
On.chain=Xe,On.chunk=function(n,t,r){if(t=(r?ze(n,t,r):t===F)?1:Di(Ou(t),0),r=null==n?0:n.length,!r||1>t)return[];for(var e=0,u=0,i=Hu(Ri(r/t));e<r;)i[u++]=vr(n,e,e+=t);return i},On.compact=function(n){for(var t=-1,r=null==n?0:n.length,e=0,u=[];++t<r;){var i=n[t];i&&(u[e++]=i)}return u},On.concat=function(){var n=arguments.length;if(!n)return[];for(var t=Hu(n-1),r=arguments[0];n--;)t[n-1]=arguments[n];return s(af(r)?Mr(r):[r],kt(t,1))},On.cond=function(n){var t=null==n?0:n.length,e=je();return n=t?l(n,function(n){
if("function"!=typeof n[1])throw new ei("Expected a function");return[e(n[0]),n[1]]}):[],lr(function(e){for(var u=-1;++u<t;){var i=n[u];if(r(i[0],this,e))return r(i[1],this,e)}})},On.conforms=function(n){return yt(dt(n,1))},On.constant=Fu,On.countBy=No,On.create=function(n,t){var r=io(n);return null==t?r:ht(r,t)},On.curry=fu,On.curryRight=cu,On.debounce=au,On.defaults=Af,On.defaultsDeep=kf,On.defer=Xo,On.delay=nf,On.difference=Ao,On.differenceBy=ko,On.differenceWith=Eo,On.drop=function(n,t,r){var e=null==n?0:n.length;
return e?(t=r||t===F?1:Ou(t),vr(n,0>t?0:t,e)):[]},On.dropRight=function(n,t,r){var e=null==n?0:n.length;return e?(t=r||t===F?1:Ou(t),t=e-t,vr(n,0,0>t?0:t)):[]},On.dropRightWhile=function(n,t){return n&&n.length?Ar(n,je(t,3),true,true):[]},On.dropWhile=function(n,t){return n&&n.length?Ar(n,je(t,3),true):[]},On.fill=function(n,t,r,e){var u=null==n?0:n.length;if(!u)return[];for(r&&typeof r!="number"&&ze(n,t,r)&&(r=0,e=u),u=n.length,r=Ou(r),0>r&&(r=-r>u?0:u+r),e=e===F||e>u?u:Ou(e),0>e&&(e+=u),e=r>e?0:Su(e);r<e;)n[r++]=t;
return n},On.filter=function(n,t){return(af(n)?f:At)(n,je(t,3))},On.flatMap=function(n,t){return kt(uu(n,t),1)},On.flatMapDeep=function(n,t){return kt(uu(n,t),N)},On.flatMapDepth=function(n,t,r){return r=r===F?1:Ou(r),kt(uu(n,t),r)},On.flatten=Ve,On.flattenDeep=function(n){return(null==n?0:n.length)?kt(n,N):[]},On.flattenDepth=function(n,t){return null!=n&&n.length?(t=t===F?1:Ou(t),kt(n,t)):[]},On.flip=function(n){return le(n,512)},On.flow=qf,On.flowRight=Vf,On.fromPairs=function(n){for(var t=-1,r=null==n?0:n.length,e={};++t<r;){
var u=n[t];e[u[0]]=u[1]}return e},On.functions=function(n){return null==n?[]:St(n,Lu(n))},On.functionsIn=function(n){return null==n?[]:St(n,Uu(n))},On.groupBy=qo,On.initial=function(n){return(null==n?0:n.length)?vr(n,0,-1):[]},On.intersection=Oo,On.intersectionBy=So,On.intersectionWith=Io,On.invert=Ef,On.invertBy=Of,On.invokeMap=Vo,On.iteratee=Pu,On.keyBy=Ko,On.keys=Lu,On.keysIn=Uu,On.map=uu,On.mapKeys=function(n,t){var r={};return t=je(t,3),Et(n,function(n,e,u){_t(r,t(n,e,u),n)}),r},On.mapValues=function(n,t){
var r={};return t=je(t,3),Et(n,function(n,e,u){_t(r,e,t(n,e,u))}),r},On.matches=function(n){return Qt(dt(n,1))},On.matchesProperty=function(n,t){return Xt(n,dt(t,1))},On.memoize=lu,On.merge=If,On.mergeWith=Rf,On.method=Kf,On.methodOf=Gf,On.mixin=Zu,On.negate=su,On.nthArg=function(n){return n=Ou(n),lr(function(t){return tr(t,n)})},On.omit=zf,On.omitBy=function(n,t){return Cu(n,su(je(t)))},On.once=function(n){return ou(2,n)},On.orderBy=function(n,t,r,e){return null==n?[]:(af(t)||(t=null==t?[]:[t]),
r=e?F:r,af(r)||(r=null==r?[]:[r]),rr(n,t,r))},On.over=Hf,On.overArgs=tf,On.overEvery=Jf,On.overSome=Yf,On.partial=rf,On.partialRight=ef,On.partition=Go,On.pick=Wf,On.pickBy=Cu,On.property=Vu,On.propertyOf=function(n){return function(t){return null==n?F:It(n,t)}},On.pull=Ro,On.pullAll=He,On.pullAllBy=function(n,t,r){return n&&n.length&&t&&t.length?or(n,t,je(r,2)):n},On.pullAllWith=function(n,t,r){return n&&n.length&&t&&t.length?or(n,t,F,r):n},On.pullAt=zo,On.range=Qf,On.rangeRight=Xf,On.rearg=uf,On.reject=function(n,t){
return(af(n)?f:At)(n,su(je(t,3)))},On.remove=function(n,t){var r=[];if(!n||!n.length)return r;var e=-1,u=[],i=n.length;for(t=je(t,3);++e<i;){var o=n[e];t(o,e,n)&&(r.push(o),u.push(e))}return fr(n,u),r},On.rest=function(n,t){if(typeof n!="function")throw new ei("Expected a function");return t=t===F?t:Ou(t),lr(n,t)},On.reverse=Je,On.sampleSize=function(n,t,r){return t=(r?ze(n,t,r):t===F)?1:Ou(t),(af(n)?ot:hr)(n,t)},On.set=function(n,t,r){return null==n?n:pr(n,t,r)},On.setWith=function(n,t,r,e){return e=typeof e=="function"?e:F,
null==n?n:pr(n,t,r,e)},On.shuffle=function(n){return(af(n)?ft:_r)(n)},On.slice=function(n,t,r){var e=null==n?0:n.length;return e?(r&&typeof r!="number"&&ze(n,t,r)?(t=0,r=e):(t=null==t?0:Ou(t),r=r===F?e:Ou(r)),vr(n,t,r)):[]},On.sortBy=Ho,On.sortedUniq=function(n){return n&&n.length?br(n):[]},On.sortedUniqBy=function(n,t){return n&&n.length?br(n,je(t,2)):[]},On.split=function(n,t,r){return r&&typeof r!="number"&&ze(n,t,r)&&(t=r=F),r=r===F?4294967295:r>>>0,r?(n=zu(n))&&(typeof t=="string"||null!=t&&!_f(t))&&(t=jr(t),
!t&&Bn.test(n))?zr($(n),0,r):n.split(t,r):[]},On.spread=function(n,t){if(typeof n!="function")throw new ei("Expected a function");return t=null==t?0:Di(Ou(t),0),lr(function(e){var u=e[t];return e=zr(e,0,t),u&&s(e,u),r(n,this,e)})},On.tail=function(n){var t=null==n?0:n.length;return t?vr(n,1,t):[]},On.take=function(n,t,r){return n&&n.length?(t=r||t===F?1:Ou(t),vr(n,0,0>t?0:t)):[]},On.takeRight=function(n,t,r){var e=null==n?0:n.length;return e?(t=r||t===F?1:Ou(t),t=e-t,vr(n,0>t?0:t,e)):[]},On.takeRightWhile=function(n,t){
return n&&n.length?Ar(n,je(t,3),false,true):[]},On.takeWhile=function(n,t){return n&&n.length?Ar(n,je(t,3)):[]},On.tap=function(n,t){return t(n),n},On.throttle=function(n,t,r){var e=true,u=true;if(typeof n!="function")throw new ei("Expected a function");return bu(r)&&(e="leading"in r?!!r.leading:e,u="trailing"in r?!!r.trailing:u),au(n,t,{leading:e,maxWait:t,trailing:u})},On.thru=nu,On.toArray=ku,On.toPairs=Bf,On.toPairsIn=Lf,On.toPath=function(n){return af(n)?l(n,$e):Au(n)?[n]:Mr(mo(zu(n)))},On.toPlainObject=Ru,
On.transform=function(n,t,r){var e=af(n),i=e||sf(n)||gf(n);if(t=je(t,4),null==r){var o=n&&n.constructor;r=i?e?new o:[]:bu(n)&&gu(o)?io(bi(n)):{}}return(i?u:Et)(n,function(n,e,u){return t(r,n,e,u)}),r},On.unary=function(n){return iu(n,1)},On.union=Wo,On.unionBy=Bo,On.unionWith=Lo,On.uniq=function(n){return n&&n.length?wr(n):[]},On.uniqBy=function(n,t){return n&&n.length?wr(n,je(t,2)):[]},On.uniqWith=function(n,t){return t=typeof t=="function"?t:F,n&&n.length?wr(n,F,t):[]},On.unset=function(n,t){return null==n||mr(n,t);
},On.unzip=Ye,On.unzipWith=Qe,On.update=function(n,t,r){return null==n?n:pr(n,t,Ir(r)(It(n,t)),void 0)},On.updateWith=function(n,t,r,e){return e=typeof e=="function"?e:F,null!=n&&(n=pr(n,t,Ir(r)(It(n,t)),e)),n},On.values=Du,On.valuesIn=function(n){return null==n?[]:I(n,Uu(n))},On.without=Uo,On.words=$u,On.wrap=function(n,t){return rf(Ir(t),n)},On.xor=Co,On.xorBy=Do,On.xorWith=Mo,On.zip=To,On.zipObject=function(n,t){return Or(n||[],t||[],at)},On.zipObjectDeep=function(n,t){return Or(n||[],t||[],pr);
},On.zipWith=$o,On.entries=Bf,On.entriesIn=Lf,On.extend=xf,On.extendWith=jf,Zu(On,On),On.add=nc,On.attempt=Pf,On.camelCase=Uf,On.capitalize=Mu,On.ceil=tc,On.clamp=function(n,t,r){return r===F&&(r=t,t=F),r!==F&&(r=Iu(r),r=r===r?r:0),t!==F&&(t=Iu(t),t=t===t?t:0),gt(Iu(n),t,r)},On.clone=function(n){return dt(n,4)},On.cloneDeep=function(n){return dt(n,5)},On.cloneDeepWith=function(n,t){return t=typeof t=="function"?t:F,dt(n,5,t)},On.cloneWith=function(n,t){return t=typeof t=="function"?t:F,dt(n,4,t)},
On.conformsTo=function(n,t){return null==t||bt(n,t,Lu(t))},On.deburr=Tu,On.defaultTo=function(n,t){return null==n||n!==n?t:n},On.divide=rc,On.endsWith=function(n,t,r){n=zu(n),t=jr(t);var e=n.length,e=r=r===F?e:gt(Ou(r),0,e);return r-=t.length,0<=r&&n.slice(r,e)==t},On.eq=hu,On.escape=function(n){return(n=zu(n))&&Y.test(n)?n.replace(H,et):n},On.escapeRegExp=function(n){return(n=zu(n))&&fn.test(n)?n.replace(on,"\\$&"):n},On.every=function(n,t,r){var e=af(n)?o:wt;return r&&ze(n,t,r)&&(t=F),e(n,je(t,3));
},On.find=Po,On.findIndex=Ze,On.findKey=function(n,t){return v(n,je(t,3),Et)},On.findLast=Zo,On.findLastIndex=qe,On.findLastKey=function(n,t){return v(n,je(t,3),Ot)},On.floor=ec,On.forEach=ru,On.forEachRight=eu,On.forIn=function(n,t){return null==n?n:co(n,je(t,3),Uu)},On.forInRight=function(n,t){return null==n?n:ao(n,je(t,3),Uu)},On.forOwn=function(n,t){return n&&Et(n,je(t,3))},On.forOwnRight=function(n,t){return n&&Ot(n,je(t,3))},On.get=Wu,On.gt=of,On.gte=ff,On.has=function(n,t){return null!=n&&ke(n,t,Bt);
},On.hasIn=Bu,On.head=Ke,On.identity=Nu,On.includes=function(n,t,r,e){return n=pu(n)?n:Du(n),r=r&&!e?Ou(r):0,e=n.length,0>r&&(r=Di(e+r,0)),mu(n)?r<=e&&-1<n.indexOf(t,r):!!e&&-1<d(n,t,r)},On.indexOf=function(n,t,r){var e=null==n?0:n.length;return e?(r=null==r?0:Ou(r),0>r&&(r=Di(e+r,0)),d(n,t,r)):-1},On.inRange=function(n,t,r){return t=Eu(t),r===F?(r=t,t=0):r=Eu(r),n=Iu(n),n>=Mi(t,r)&&n<Di(t,r)},On.invoke=Sf,On.isArguments=cf,On.isArray=af,On.isArrayBuffer=lf,On.isArrayLike=pu,On.isArrayLikeObject=_u,
On.isBoolean=function(n){return true===n||false===n||xu(n)&&"[object Boolean]"==zt(n)},On.isBuffer=sf,On.isDate=hf,On.isElement=function(n){return xu(n)&&1===n.nodeType&&!wu(n)},On.isEmpty=function(n){if(null==n)return true;if(pu(n)&&(af(n)||typeof n=="string"||typeof n.splice=="function"||sf(n)||gf(n)||cf(n)))return!n.length;var t=yo(n);if("[object Map]"==t||"[object Set]"==t)return!n.size;if(Le(n))return!Ht(n).length;for(var r in n)if(ci.call(n,r))return false;return true},On.isEqual=function(n,t){return Ft(n,t);
},On.isEqualWith=function(n,t,r){var e=(r=typeof r=="function"?r:F)?r(n,t):F;return e===F?Ft(n,t,F,r):!!e},On.isError=vu,On.isFinite=function(n){return typeof n=="number"&&Li(n)},On.isFunction=gu,On.isInteger=du,On.isLength=yu,On.isMap=pf,On.isMatch=function(n,t){return n===t||Pt(n,t,me(t))},On.isMatchWith=function(n,t,r){return r=typeof r=="function"?r:F,Pt(n,t,me(t),r)},On.isNaN=function(n){return ju(n)&&n!=+n},On.isNative=function(n){if(bo(n))throw new Yu("Unsupported core-js use. Try https://npms.io/search?q=ponyfill.");
return Zt(n)},On.isNil=function(n){return null==n},On.isNull=function(n){return null===n},On.isNumber=ju,On.isObject=bu,On.isObjectLike=xu,On.isPlainObject=wu,On.isRegExp=_f,On.isSafeInteger=function(n){return du(n)&&-9007199254740991<=n&&9007199254740991>=n},On.isSet=vf,On.isString=mu,On.isSymbol=Au,On.isTypedArray=gf,On.isUndefined=function(n){return n===F},On.isWeakMap=function(n){return xu(n)&&"[object WeakMap]"==yo(n)},On.isWeakSet=function(n){return xu(n)&&"[object WeakSet]"==zt(n)},On.join=function(n,t){
return null==n?"":Ui.call(n,t)},On.kebabCase=Cf,On.last=Ge,On.lastIndexOf=function(n,t,r){var e=null==n?0:n.length;if(!e)return-1;var u=e;if(r!==F&&(u=Ou(r),u=0>u?Di(e+u,0):Mi(u,e-1)),t===t){for(r=u+1;r--&&n[r]!==t;);n=r}else n=g(n,b,u,true);return n},On.lowerCase=Df,On.lowerFirst=Mf,On.lt=df,On.lte=yf,On.max=function(n){return n&&n.length?mt(n,Nu,Wt):F},On.maxBy=function(n,t){return n&&n.length?mt(n,je(t,2),Wt):F},On.mean=function(n){return x(n,Nu)},On.meanBy=function(n,t){return x(n,je(t,2))},On.min=function(n){
return n&&n.length?mt(n,Nu,Jt):F},On.minBy=function(n,t){return n&&n.length?mt(n,je(t,2),Jt):F},On.stubArray=Ku,On.stubFalse=Gu,On.stubObject=function(){return{}},On.stubString=function(){return""},On.stubTrue=function(){return true},On.multiply=uc,On.nth=function(n,t){return n&&n.length?tr(n,Ou(t)):F},On.noConflict=function(){return Zn._===this&&(Zn._=pi),this},On.noop=qu,On.now=Jo,On.pad=function(n,t,r){n=zu(n);var e=(t=Ou(t))?T(n):0;return!t||e>=t?n:(t=(t-e)/2,ee(zi(t),r)+n+ee(Ri(t),r))},On.padEnd=function(n,t,r){
n=zu(n);var e=(t=Ou(t))?T(n):0;return t&&e<t?n+ee(t-e,r):n},On.padStart=function(n,t,r){n=zu(n);var e=(t=Ou(t))?T(n):0;return t&&e<t?ee(t-e,r)+n:n},On.parseInt=function(n,t,r){return r||null==t?t=0:t&&(t=+t),$i(zu(n).replace(an,""),t||0)},On.random=function(n,t,r){if(r&&typeof r!="boolean"&&ze(n,t,r)&&(t=r=F),r===F&&(typeof t=="boolean"?(r=t,t=F):typeof n=="boolean"&&(r=n,n=F)),n===F&&t===F?(n=0,t=1):(n=Eu(n),t===F?(t=n,n=0):t=Eu(t)),n>t){var e=n;n=t,t=e}return r||n%1||t%1?(r=Fi(),Mi(n+r*(t-n+$n("1e-"+((r+"").length-1))),t)):cr(n,t);
},On.reduce=function(n,t,r){var e=af(n)?h:m,u=3>arguments.length;return e(n,je(t,4),r,u,oo)},On.reduceRight=function(n,t,r){var e=af(n)?p:m,u=3>arguments.length;return e(n,je(t,4),r,u,fo)},On.repeat=function(n,t,r){return t=(r?ze(n,t,r):t===F)?1:Ou(t),ar(zu(n),t)},On.replace=function(){var n=arguments,t=zu(n[0]);return 3>n.length?t:t.replace(n[1],n[2])},On.result=function(n,t,r){t=Rr(t,n);var e=-1,u=t.length;for(u||(u=1,n=F);++e<u;){var i=null==n?F:n[$e(t[e])];i===F&&(e=u,i=r),n=gu(i)?i.call(n):i;
}return n},On.round=ic,On.runInContext=w,On.sample=function(n){return(af(n)?tt:sr)(n)},On.size=function(n){if(null==n)return 0;if(pu(n))return mu(n)?T(n):n.length;var t=yo(n);return"[object Map]"==t||"[object Set]"==t?n.size:Ht(n).length},On.snakeCase=Tf,On.some=function(n,t,r){var e=af(n)?_:gr;return r&&ze(n,t,r)&&(t=F),e(n,je(t,3))},On.sortedIndex=function(n,t){return dr(n,t)},On.sortedIndexBy=function(n,t,r){return yr(n,t,je(r,2))},On.sortedIndexOf=function(n,t){var r=null==n?0:n.length;if(r){
var e=dr(n,t);if(e<r&&hu(n[e],t))return e}return-1},On.sortedLastIndex=function(n,t){return dr(n,t,true)},On.sortedLastIndexBy=function(n,t,r){return yr(n,t,je(r,2),true)},On.sortedLastIndexOf=function(n,t){if(null==n?0:n.length){var r=dr(n,t,true)-1;if(hu(n[r],t))return r}return-1},On.startCase=$f,On.startsWith=function(n,t,r){return n=zu(n),r=null==r?0:gt(Ou(r),0,n.length),t=jr(t),n.slice(r,r+t.length)==t},On.subtract=oc,On.sum=function(n){return n&&n.length?k(n,Nu):0},On.sumBy=function(n,t){return n&&n.length?k(n,je(t,2)):0;
},On.template=function(n,t,r){var e=On.templateSettings;r&&ze(n,t,r)&&(t=F),n=zu(n),t=jf({},t,e,se),r=jf({},t.imports,e.imports,se);var u,i,o=Lu(r),f=I(r,o),c=0;r=t.interpolate||An;var a="__p+='";r=ti((t.escape||An).source+"|"+r.source+"|"+(r===nn?gn:An).source+"|"+(t.evaluate||An).source+"|$","g");var l="sourceURL"in t?"//# sourceURL="+t.sourceURL+"\n":"";if(n.replace(r,function(t,r,e,o,f,l){return e||(e=o),a+=n.slice(c,l).replace(kn,B),r&&(u=true,a+="'+__e("+r+")+'"),f&&(i=true,a+="';"+f+";\n__p+='"),
e&&(a+="'+((__t=("+e+"))==null?'':__t)+'"),c=l+t.length,t}),a+="';",(t=t.variable)||(a="with(obj){"+a+"}"),a=(i?a.replace(q,""):a).replace(V,"$1").replace(K,"$1;"),a="function("+(t||"obj")+"){"+(t?"":"obj||(obj={});")+"var __t,__p=''"+(u?",__e=_.escape":"")+(i?",__j=Array.prototype.join;function print(){__p+=__j.call(arguments,'')}":";")+a+"return __p}",t=Pf(function(){return Qu(o,l+"return "+a).apply(F,f)}),t.source=a,vu(t))throw t;return t},On.times=function(n,t){if(n=Ou(n),1>n||9007199254740991<n)return[];
var r=4294967295,e=Mi(n,4294967295);for(t=je(t),n-=4294967295,e=E(e,t);++r<n;)t(r);return e},On.toFinite=Eu,On.toInteger=Ou,On.toLength=Su,On.toLower=function(n){return zu(n).toLowerCase()},On.toNumber=Iu,On.toSafeInteger=function(n){return n?gt(Ou(n),-9007199254740991,9007199254740991):0===n?n:0},On.toString=zu,On.toUpper=function(n){return zu(n).toUpperCase()},On.trim=function(n,t,r){return(n=zu(n))&&(r||t===F)?n.replace(cn,""):n&&(t=jr(t))?(n=$(n),r=$(t),t=z(n,r),r=W(n,r)+1,zr(n,t,r).join("")):n;
},On.trimEnd=function(n,t,r){return(n=zu(n))&&(r||t===F)?n.replace(ln,""):n&&(t=jr(t))?(n=$(n),t=W(n,$(t))+1,zr(n,0,t).join("")):n},On.trimStart=function(n,t,r){return(n=zu(n))&&(r||t===F)?n.replace(an,""):n&&(t=jr(t))?(n=$(n),t=z(n,$(t)),zr(n,t).join("")):n},On.truncate=function(n,t){var r=30,e="...";if(bu(t))var u="separator"in t?t.separator:u,r="length"in t?Ou(t.length):r,e="omission"in t?jr(t.omission):e;n=zu(n);var i=n.length;if(Bn.test(n))var o=$(n),i=o.length;if(r>=i)return n;if(i=r-T(e),1>i)return e;
if(r=o?zr(o,0,i).join(""):n.slice(0,i),u===F)return r+e;if(o&&(i+=r.length-i),_f(u)){if(n.slice(i).search(u)){var f=r;for(u.global||(u=ti(u.source,zu(dn.exec(u))+"g")),u.lastIndex=0;o=u.exec(f);)var c=o.index;r=r.slice(0,c===F?i:c)}}else n.indexOf(jr(u),i)!=i&&(u=r.lastIndexOf(u),-1<u&&(r=r.slice(0,u)));return r+e},On.unescape=function(n){return(n=zu(n))&&J.test(n)?n.replace(G,ut):n},On.uniqueId=function(n){var t=++ai;return zu(n)+t},On.upperCase=Ff,On.upperFirst=Nf,On.each=ru,On.eachRight=eu,On.first=Ke,
Zu(On,function(){var n={};return Et(On,function(t,r){ci.call(On.prototype,r)||(n[r]=t)}),n}(),{chain:false}),On.VERSION="4.17.4",u("bind bindKey curry curryRight partial partialRight".split(" "),function(n){On[n].placeholder=On}),u(["drop","take"],function(n,t){Mn.prototype[n]=function(r){r=r===F?1:Di(Ou(r),0);var e=this.__filtered__&&!t?new Mn(this):this.clone();return e.__filtered__?e.__takeCount__=Mi(r,e.__takeCount__):e.__views__.push({size:Mi(r,4294967295),type:n+(0>e.__dir__?"Right":"")}),e},Mn.prototype[n+"Right"]=function(t){
return this.reverse()[n](t).reverse()}}),u(["filter","map","takeWhile"],function(n,t){var r=t+1,e=1==r||3==r;Mn.prototype[n]=function(n){var t=this.clone();return t.__iteratees__.push({iteratee:je(n,3),type:r}),t.__filtered__=t.__filtered__||e,t}}),u(["head","last"],function(n,t){var r="take"+(t?"Right":"");Mn.prototype[n]=function(){return this[r](1).value()[0]}}),u(["initial","tail"],function(n,t){var r="drop"+(t?"":"Right");Mn.prototype[n]=function(){return this.__filtered__?new Mn(this):this[r](1);
}}),Mn.prototype.compact=function(){return this.filter(Nu)},Mn.prototype.find=function(n){return this.filter(n).head()},Mn.prototype.findLast=function(n){return this.reverse().find(n)},Mn.prototype.invokeMap=lr(function(n,t){return typeof n=="function"?new Mn(this):this.map(function(r){return Dt(r,n,t)})}),Mn.prototype.reject=function(n){return this.filter(su(je(n)))},Mn.prototype.slice=function(n,t){n=Ou(n);var r=this;return r.__filtered__&&(0<n||0>t)?new Mn(r):(0>n?r=r.takeRight(-n):n&&(r=r.drop(n)),
t!==F&&(t=Ou(t),r=0>t?r.dropRight(-t):r.take(t-n)),r)},Mn.prototype.takeRightWhile=function(n){return this.reverse().takeWhile(n).reverse()},Mn.prototype.toArray=function(){return this.take(4294967295)},Et(Mn.prototype,function(n,t){var r=/^(?:filter|find|map|reject)|While$/.test(t),e=/^(?:head|last)$/.test(t),u=On[e?"take"+("last"==t?"Right":""):t],i=e||/^find/.test(t);u&&(On.prototype[t]=function(){function t(n){return n=u.apply(On,s([n],f)),e&&h?n[0]:n}var o=this.__wrapped__,f=e?[1]:arguments,c=o instanceof Mn,a=f[0],l=c||af(o);
l&&r&&typeof a=="function"&&1!=a.length&&(c=l=false);var h=this.__chain__,p=!!this.__actions__.length,a=i&&!h,c=c&&!p;return!i&&l?(o=c?o:new Mn(this),o=n.apply(o,f),o.__actions__.push({func:nu,args:[t],thisArg:F}),new zn(o,h)):a&&c?n.apply(this,f):(o=this.thru(t),a?e?o.value()[0]:o.value():o)})}),u("pop push shift sort splice unshift".split(" "),function(n){var t=ui[n],r=/^(?:push|sort|unshift)$/.test(n)?"tap":"thru",e=/^(?:pop|shift)$/.test(n);On.prototype[n]=function(){var n=arguments;if(e&&!this.__chain__){
var u=this.value();return t.apply(af(u)?u:[],n)}return this[r](function(r){return t.apply(af(r)?r:[],n)})}}),Et(Mn.prototype,function(n,t){var r=On[t];if(r){var e=r.name+"";(Ji[e]||(Ji[e]=[])).push({name:t,func:r})}}),Ji[Xr(F,2).name]=[{name:"wrapper",func:F}],Mn.prototype.clone=function(){var n=new Mn(this.__wrapped__);return n.__actions__=Mr(this.__actions__),n.__dir__=this.__dir__,n.__filtered__=this.__filtered__,n.__iteratees__=Mr(this.__iteratees__),n.__takeCount__=this.__takeCount__,n.__views__=Mr(this.__views__),
n},Mn.prototype.reverse=function(){if(this.__filtered__){var n=new Mn(this);n.__dir__=-1,n.__filtered__=true}else n=this.clone(),n.__dir__*=-1;return n},Mn.prototype.value=function(){var n,t=this.__wrapped__.value(),r=this.__dir__,e=af(t),u=0>r,i=e?t.length:0;n=i;for(var o=this.__views__,f=0,c=-1,a=o.length;++c<a;){var l=o[c],s=l.size;switch(l.type){case"drop":f+=s;break;case"dropRight":n-=s;break;case"take":n=Mi(n,f+s);break;case"takeRight":f=Di(f,n-s)}}if(n={start:f,end:n},o=n.start,f=n.end,n=f-o,
o=u?f:o-1,f=this.__iteratees__,c=f.length,a=0,l=Mi(n,this.__takeCount__),!e||!u&&i==n&&l==n)return kr(t,this.__actions__);e=[];n:for(;n--&&a<l;){for(o+=r,u=-1,i=t[o];++u<c;){var h=f[u],s=h.type,h=(0,h.iteratee)(i);if(2==s)i=h;else if(!h){if(1==s)continue n;break n}}e[a++]=i}return e},On.prototype.at=Fo,On.prototype.chain=function(){return Xe(this)},On.prototype.commit=function(){return new zn(this.value(),this.__chain__)},On.prototype.next=function(){this.__values__===F&&(this.__values__=ku(this.value()));
var n=this.__index__>=this.__values__.length;return{done:n,value:n?F:this.__values__[this.__index__++]}},On.prototype.plant=function(n){for(var t,r=this;r instanceof Sn;){var e=Pe(r);e.__index__=0,e.__values__=F,t?u.__wrapped__=e:t=e;var u=e,r=r.__wrapped__}return u.__wrapped__=n,t},On.prototype.reverse=function(){var n=this.__wrapped__;return n instanceof Mn?(this.__actions__.length&&(n=new Mn(this)),n=n.reverse(),n.__actions__.push({func:nu,args:[Je],thisArg:F}),new zn(n,this.__chain__)):this.thru(Je);
},On.prototype.toJSON=On.prototype.valueOf=On.prototype.value=function(){return kr(this.__wrapped__,this.__actions__)},On.prototype.first=On.prototype.head,Ai&&(On.prototype[Ai]=tu),On}(); true?(Zn._=it, !(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return it}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))):Vn?((Vn.exports=it)._=it,qn._=it):Zn._=it}).call(this);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/global.js"), __webpack_require__("../node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "../node_modules/make-plural/umd/plurals.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;var _cp = [
function(n, ord) {
  if (ord) return 'other';
  return 'other';
},
function(n, ord) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},
function(n, ord) {
  if (ord) return 'other';
  return ((n == 0
          || n == 1)) ? 'one' : 'other';
},
function(n, ord) {
  var s = String(n).split('.'), v0 = !s[1];
  if (ord) return 'other';
  return (n == 1 && v0) ? 'one' : 'other';
}
];

(function (root, plurals) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (plurals),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    module.exports = plurals;
  } else {
    root.plurals = plurals;
  }
}(this, {
af: _cp[1],

ak: _cp[2],

am: function(n, ord) {
  if (ord) return 'other';
  return (n >= 0 && n <= 1) ? 'one' : 'other';
},

ar: function(n, ord) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n,
      n100 = t0 && s[0].slice(-2);
  if (ord) return 'other';
  return (n == 0) ? 'zero'
      : (n == 1) ? 'one'
      : (n == 2) ? 'two'
      : ((n100 >= 3 && n100 <= 10)) ? 'few'
      : ((n100 >= 11 && n100 <= 99)) ? 'many'
      : 'other';
},

ars: function(n, ord) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n,
      n100 = t0 && s[0].slice(-2);
  if (ord) return 'other';
  return (n == 0) ? 'zero'
      : (n == 1) ? 'one'
      : (n == 2) ? 'two'
      : ((n100 >= 3 && n100 <= 10)) ? 'few'
      : ((n100 >= 11 && n100 <= 99)) ? 'many'
      : 'other';
},

as: function(n, ord) {
  if (ord) return ((n == 1 || n == 5 || n == 7 || n == 8 || n == 9
          || n == 10)) ? 'one'
      : ((n == 2
          || n == 3)) ? 'two'
      : (n == 4) ? 'few'
      : (n == 6) ? 'many'
      : 'other';
  return (n >= 0 && n <= 1) ? 'one' : 'other';
},

asa: _cp[1],

ast: _cp[3],

az: function(n, ord) {
  var s = String(n).split('.'), i = s[0], i10 = i.slice(-1),
      i100 = i.slice(-2), i1000 = i.slice(-3);
  if (ord) return ((i10 == 1 || i10 == 2 || i10 == 5 || i10 == 7 || i10 == 8)
          || (i100 == 20 || i100 == 50 || i100 == 70
          || i100 == 80)) ? 'one'
      : ((i10 == 3 || i10 == 4) || (i1000 == 100 || i1000 == 200
          || i1000 == 300 || i1000 == 400 || i1000 == 500 || i1000 == 600 || i1000 == 700
          || i1000 == 800
          || i1000 == 900)) ? 'few'
      : (i == 0 || i10 == 6 || (i100 == 40 || i100 == 60
          || i100 == 90)) ? 'many'
      : 'other';
  return (n == 1) ? 'one' : 'other';
},

be: function(n, ord) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n,
      n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
  if (ord) return ((n10 == 2
          || n10 == 3) && n100 != 12 && n100 != 13) ? 'few' : 'other';
  return (n10 == 1 && n100 != 11) ? 'one'
      : ((n10 >= 2 && n10 <= 4) && (n100 < 12
          || n100 > 14)) ? 'few'
      : (t0 && n10 == 0 || (n10 >= 5 && n10 <= 9)
          || (n100 >= 11 && n100 <= 14)) ? 'many'
      : 'other';
},

bem: _cp[1],

bez: _cp[1],

bg: _cp[1],

bh: _cp[2],

bm: _cp[0],

bn: function(n, ord) {
  if (ord) return ((n == 1 || n == 5 || n == 7 || n == 8 || n == 9
          || n == 10)) ? 'one'
      : ((n == 2
          || n == 3)) ? 'two'
      : (n == 4) ? 'few'
      : (n == 6) ? 'many'
      : 'other';
  return (n >= 0 && n <= 1) ? 'one' : 'other';
},

bo: _cp[0],

br: function(n, ord) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n,
      n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2),
      n1000000 = t0 && s[0].slice(-6);
  if (ord) return 'other';
  return (n10 == 1 && n100 != 11 && n100 != 71 && n100 != 91) ? 'one'
      : (n10 == 2 && n100 != 12 && n100 != 72 && n100 != 92) ? 'two'
      : (((n10 == 3 || n10 == 4) || n10 == 9) && (n100 < 10
          || n100 > 19) && (n100 < 70 || n100 > 79) && (n100 < 90
          || n100 > 99)) ? 'few'
      : (n != 0 && t0 && n1000000 == 0) ? 'many'
      : 'other';
},

brx: _cp[1],

bs: function(n, ord) {
  var s = String(n).split('.'), i = s[0], f = s[1] || '', v0 = !s[1],
      i10 = i.slice(-1), i100 = i.slice(-2), f10 = f.slice(-1), f100 = f.slice(-2);
  if (ord) return 'other';
  return (v0 && i10 == 1 && i100 != 11
          || f10 == 1 && f100 != 11) ? 'one'
      : (v0 && (i10 >= 2 && i10 <= 4) && (i100 < 12 || i100 > 14)
          || (f10 >= 2 && f10 <= 4) && (f100 < 12
          || f100 > 14)) ? 'few'
      : 'other';
},

ca: function(n, ord) {
  var s = String(n).split('.'), v0 = !s[1];
  if (ord) return ((n == 1
          || n == 3)) ? 'one'
      : (n == 2) ? 'two'
      : (n == 4) ? 'few'
      : 'other';
  return (n == 1 && v0) ? 'one' : 'other';
},

ce: _cp[1],

cgg: _cp[1],

chr: _cp[1],

ckb: _cp[1],

cs: function(n, ord) {
  var s = String(n).split('.'), i = s[0], v0 = !s[1];
  if (ord) return 'other';
  return (n == 1 && v0) ? 'one'
      : ((i >= 2 && i <= 4) && v0) ? 'few'
      : (!v0) ? 'many'
      : 'other';
},

cy: function(n, ord) {
  if (ord) return ((n == 0 || n == 7 || n == 8
          || n == 9)) ? 'zero'
      : (n == 1) ? 'one'
      : (n == 2) ? 'two'
      : ((n == 3
          || n == 4)) ? 'few'
      : ((n == 5
          || n == 6)) ? 'many'
      : 'other';
  return (n == 0) ? 'zero'
      : (n == 1) ? 'one'
      : (n == 2) ? 'two'
      : (n == 3) ? 'few'
      : (n == 6) ? 'many'
      : 'other';
},

da: function(n, ord) {
  var s = String(n).split('.'), i = s[0], t0 = Number(s[0]) == n;
  if (ord) return 'other';
  return (n == 1 || !t0 && (i == 0
          || i == 1)) ? 'one' : 'other';
},

de: _cp[3],

dsb: function(n, ord) {
  var s = String(n).split('.'), i = s[0], f = s[1] || '', v0 = !s[1],
      i100 = i.slice(-2), f100 = f.slice(-2);
  if (ord) return 'other';
  return (v0 && i100 == 1
          || f100 == 1) ? 'one'
      : (v0 && i100 == 2
          || f100 == 2) ? 'two'
      : (v0 && (i100 == 3 || i100 == 4) || (f100 == 3
          || f100 == 4)) ? 'few'
      : 'other';
},

dv: _cp[1],

dz: _cp[0],

ee: _cp[1],

el: _cp[1],

en: function(n, ord) {
  var s = String(n).split('.'), v0 = !s[1], t0 = Number(s[0]) == n,
      n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
  if (ord) return (n10 == 1 && n100 != 11) ? 'one'
      : (n10 == 2 && n100 != 12) ? 'two'
      : (n10 == 3 && n100 != 13) ? 'few'
      : 'other';
  return (n == 1 && v0) ? 'one' : 'other';
},

eo: _cp[1],

es: _cp[1],

et: _cp[3],

eu: _cp[1],

fa: function(n, ord) {
  if (ord) return 'other';
  return (n >= 0 && n <= 1) ? 'one' : 'other';
},

ff: function(n, ord) {
  if (ord) return 'other';
  return (n >= 0 && n < 2) ? 'one' : 'other';
},

fi: _cp[3],

fil: function(n, ord) {
  var s = String(n).split('.'), i = s[0], f = s[1] || '', v0 = !s[1],
      i10 = i.slice(-1), f10 = f.slice(-1);
  if (ord) return (n == 1) ? 'one' : 'other';
  return (v0 && (i == 1 || i == 2 || i == 3)
          || v0 && i10 != 4 && i10 != 6 && i10 != 9
          || !v0 && f10 != 4 && f10 != 6 && f10 != 9) ? 'one' : 'other';
},

fo: _cp[1],

fr: function(n, ord) {
  if (ord) return (n == 1) ? 'one' : 'other';
  return (n >= 0 && n < 2) ? 'one' : 'other';
},

fur: _cp[1],

fy: _cp[3],

ga: function(n, ord) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n;
  if (ord) return (n == 1) ? 'one' : 'other';
  return (n == 1) ? 'one'
      : (n == 2) ? 'two'
      : ((t0 && n >= 3 && n <= 6)) ? 'few'
      : ((t0 && n >= 7 && n <= 10)) ? 'many'
      : 'other';
},

gd: function(n, ord) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n;
  if (ord) return 'other';
  return ((n == 1
          || n == 11)) ? 'one'
      : ((n == 2
          || n == 12)) ? 'two'
      : (((t0 && n >= 3 && n <= 10)
          || (t0 && n >= 13 && n <= 19))) ? 'few'
      : 'other';
},

gl: _cp[3],

gsw: _cp[1],

gu: function(n, ord) {
  if (ord) return (n == 1) ? 'one'
      : ((n == 2
          || n == 3)) ? 'two'
      : (n == 4) ? 'few'
      : (n == 6) ? 'many'
      : 'other';
  return (n >= 0 && n <= 1) ? 'one' : 'other';
},

guw: _cp[2],

gv: function(n, ord) {
  var s = String(n).split('.'), i = s[0], v0 = !s[1], i10 = i.slice(-1),
      i100 = i.slice(-2);
  if (ord) return 'other';
  return (v0 && i10 == 1) ? 'one'
      : (v0 && i10 == 2) ? 'two'
      : (v0 && (i100 == 0 || i100 == 20 || i100 == 40 || i100 == 60
          || i100 == 80)) ? 'few'
      : (!v0) ? 'many'
      : 'other';
},

ha: _cp[1],

haw: _cp[1],

he: function(n, ord) {
  var s = String(n).split('.'), i = s[0], v0 = !s[1], t0 = Number(s[0]) == n,
      n10 = t0 && s[0].slice(-1);
  if (ord) return 'other';
  return (n == 1 && v0) ? 'one'
      : (i == 2 && v0) ? 'two'
      : (v0 && (n < 0
          || n > 10) && t0 && n10 == 0) ? 'many'
      : 'other';
},

hi: function(n, ord) {
  if (ord) return (n == 1) ? 'one'
      : ((n == 2
          || n == 3)) ? 'two'
      : (n == 4) ? 'few'
      : (n == 6) ? 'many'
      : 'other';
  return (n >= 0 && n <= 1) ? 'one' : 'other';
},

hr: function(n, ord) {
  var s = String(n).split('.'), i = s[0], f = s[1] || '', v0 = !s[1],
      i10 = i.slice(-1), i100 = i.slice(-2), f10 = f.slice(-1), f100 = f.slice(-2);
  if (ord) return 'other';
  return (v0 && i10 == 1 && i100 != 11
          || f10 == 1 && f100 != 11) ? 'one'
      : (v0 && (i10 >= 2 && i10 <= 4) && (i100 < 12 || i100 > 14)
          || (f10 >= 2 && f10 <= 4) && (f100 < 12
          || f100 > 14)) ? 'few'
      : 'other';
},

hsb: function(n, ord) {
  var s = String(n).split('.'), i = s[0], f = s[1] || '', v0 = !s[1],
      i100 = i.slice(-2), f100 = f.slice(-2);
  if (ord) return 'other';
  return (v0 && i100 == 1
          || f100 == 1) ? 'one'
      : (v0 && i100 == 2
          || f100 == 2) ? 'two'
      : (v0 && (i100 == 3 || i100 == 4) || (f100 == 3
          || f100 == 4)) ? 'few'
      : 'other';
},

hu: function(n, ord) {
  if (ord) return ((n == 1
          || n == 5)) ? 'one' : 'other';
  return (n == 1) ? 'one' : 'other';
},

hy: function(n, ord) {
  if (ord) return (n == 1) ? 'one' : 'other';
  return (n >= 0 && n < 2) ? 'one' : 'other';
},

id: _cp[0],

ig: _cp[0],

ii: _cp[0],

"in": _cp[0],

io: _cp[3],

is: function(n, ord) {
  var s = String(n).split('.'), i = s[0], t0 = Number(s[0]) == n,
      i10 = i.slice(-1), i100 = i.slice(-2);
  if (ord) return 'other';
  return (t0 && i10 == 1 && i100 != 11
          || !t0) ? 'one' : 'other';
},

it: function(n, ord) {
  var s = String(n).split('.'), v0 = !s[1];
  if (ord) return ((n == 11 || n == 8 || n == 80
          || n == 800)) ? 'many' : 'other';
  return (n == 1 && v0) ? 'one' : 'other';
},

iu: function(n, ord) {
  if (ord) return 'other';
  return (n == 1) ? 'one'
      : (n == 2) ? 'two'
      : 'other';
},

iw: function(n, ord) {
  var s = String(n).split('.'), i = s[0], v0 = !s[1], t0 = Number(s[0]) == n,
      n10 = t0 && s[0].slice(-1);
  if (ord) return 'other';
  return (n == 1 && v0) ? 'one'
      : (i == 2 && v0) ? 'two'
      : (v0 && (n < 0
          || n > 10) && t0 && n10 == 0) ? 'many'
      : 'other';
},

ja: _cp[0],

jbo: _cp[0],

jgo: _cp[1],

ji: _cp[3],

jmc: _cp[1],

jv: _cp[0],

jw: _cp[0],

ka: function(n, ord) {
  var s = String(n).split('.'), i = s[0], i100 = i.slice(-2);
  if (ord) return (i == 1) ? 'one'
      : (i == 0 || ((i100 >= 2 && i100 <= 20) || i100 == 40 || i100 == 60
          || i100 == 80)) ? 'many'
      : 'other';
  return (n == 1) ? 'one' : 'other';
},

kab: function(n, ord) {
  if (ord) return 'other';
  return (n >= 0 && n < 2) ? 'one' : 'other';
},

kaj: _cp[1],

kcg: _cp[1],

kde: _cp[0],

kea: _cp[0],

kk: function(n, ord) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n,
      n10 = t0 && s[0].slice(-1);
  if (ord) return (n10 == 6 || n10 == 9
          || t0 && n10 == 0 && n != 0) ? 'many' : 'other';
  return (n == 1) ? 'one' : 'other';
},

kkj: _cp[1],

kl: _cp[1],

km: _cp[0],

kn: function(n, ord) {
  if (ord) return 'other';
  return (n >= 0 && n <= 1) ? 'one' : 'other';
},

ko: _cp[0],

ks: _cp[1],

ksb: _cp[1],

ksh: function(n, ord) {
  if (ord) return 'other';
  return (n == 0) ? 'zero'
      : (n == 1) ? 'one'
      : 'other';
},

ku: _cp[1],

kw: function(n, ord) {
  if (ord) return 'other';
  return (n == 1) ? 'one'
      : (n == 2) ? 'two'
      : 'other';
},

ky: _cp[1],

lag: function(n, ord) {
  var s = String(n).split('.'), i = s[0];
  if (ord) return 'other';
  return (n == 0) ? 'zero'
      : ((i == 0
          || i == 1) && n != 0) ? 'one'
      : 'other';
},

lb: _cp[1],

lg: _cp[1],

lkt: _cp[0],

ln: _cp[2],

lo: function(n, ord) {
  if (ord) return (n == 1) ? 'one' : 'other';
  return 'other';
},

lt: function(n, ord) {
  var s = String(n).split('.'), f = s[1] || '', t0 = Number(s[0]) == n,
      n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
  if (ord) return 'other';
  return (n10 == 1 && (n100 < 11
          || n100 > 19)) ? 'one'
      : ((n10 >= 2 && n10 <= 9) && (n100 < 11
          || n100 > 19)) ? 'few'
      : (f != 0) ? 'many'
      : 'other';
},

lv: function(n, ord) {
  var s = String(n).split('.'), f = s[1] || '', v = f.length,
      t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1),
      n100 = t0 && s[0].slice(-2), f100 = f.slice(-2), f10 = f.slice(-1);
  if (ord) return 'other';
  return (t0 && n10 == 0 || (n100 >= 11 && n100 <= 19)
          || v == 2 && (f100 >= 11 && f100 <= 19)) ? 'zero'
      : (n10 == 1 && n100 != 11 || v == 2 && f10 == 1 && f100 != 11
          || v != 2 && f10 == 1) ? 'one'
      : 'other';
},

mas: _cp[1],

mg: _cp[2],

mgo: _cp[1],

mk: function(n, ord) {
  var s = String(n).split('.'), i = s[0], f = s[1] || '', v0 = !s[1],
      i10 = i.slice(-1), i100 = i.slice(-2), f10 = f.slice(-1);
  if (ord) return (i10 == 1 && i100 != 11) ? 'one'
      : (i10 == 2 && i100 != 12) ? 'two'
      : ((i10 == 7
          || i10 == 8) && i100 != 17 && i100 != 18) ? 'many'
      : 'other';
  return (v0 && i10 == 1
          || f10 == 1) ? 'one' : 'other';
},

ml: _cp[1],

mn: _cp[1],

mo: function(n, ord) {
  var s = String(n).split('.'), v0 = !s[1], t0 = Number(s[0]) == n,
      n100 = t0 && s[0].slice(-2);
  if (ord) return (n == 1) ? 'one' : 'other';
  return (n == 1 && v0) ? 'one'
      : (!v0 || n == 0
          || n != 1 && (n100 >= 1 && n100 <= 19)) ? 'few'
      : 'other';
},

mr: function(n, ord) {
  if (ord) return (n == 1) ? 'one'
      : ((n == 2
          || n == 3)) ? 'two'
      : (n == 4) ? 'few'
      : 'other';
  return (n >= 0 && n <= 1) ? 'one' : 'other';
},

ms: function(n, ord) {
  if (ord) return (n == 1) ? 'one' : 'other';
  return 'other';
},

mt: function(n, ord) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n,
      n100 = t0 && s[0].slice(-2);
  if (ord) return 'other';
  return (n == 1) ? 'one'
      : (n == 0
          || (n100 >= 2 && n100 <= 10)) ? 'few'
      : ((n100 >= 11 && n100 <= 19)) ? 'many'
      : 'other';
},

my: _cp[0],

nah: _cp[1],

naq: function(n, ord) {
  if (ord) return 'other';
  return (n == 1) ? 'one'
      : (n == 2) ? 'two'
      : 'other';
},

nb: _cp[1],

nd: _cp[1],

ne: function(n, ord) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n;
  if (ord) return ((t0 && n >= 1 && n <= 4)) ? 'one' : 'other';
  return (n == 1) ? 'one' : 'other';
},

nl: _cp[3],

nn: _cp[1],

nnh: _cp[1],

no: _cp[1],

nqo: _cp[0],

nr: _cp[1],

nso: _cp[2],

ny: _cp[1],

nyn: _cp[1],

om: _cp[1],

or: function(n, ord) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n;
  if (ord) return ((n == 1 || n == 5
          || (t0 && n >= 7 && n <= 9))) ? 'one'
      : ((n == 2
          || n == 3)) ? 'two'
      : (n == 4) ? 'few'
      : (n == 6) ? 'many'
      : 'other';
  return (n == 1) ? 'one' : 'other';
},

os: _cp[1],

pa: _cp[2],

pap: _cp[1],

pl: function(n, ord) {
  var s = String(n).split('.'), i = s[0], v0 = !s[1], i10 = i.slice(-1),
      i100 = i.slice(-2);
  if (ord) return 'other';
  return (n == 1 && v0) ? 'one'
      : (v0 && (i10 >= 2 && i10 <= 4) && (i100 < 12
          || i100 > 14)) ? 'few'
      : (v0 && i != 1 && (i10 == 0 || i10 == 1)
          || v0 && (i10 >= 5 && i10 <= 9)
          || v0 && (i100 >= 12 && i100 <= 14)) ? 'many'
      : 'other';
},

prg: function(n, ord) {
  var s = String(n).split('.'), f = s[1] || '', v = f.length,
      t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1),
      n100 = t0 && s[0].slice(-2), f100 = f.slice(-2), f10 = f.slice(-1);
  if (ord) return 'other';
  return (t0 && n10 == 0 || (n100 >= 11 && n100 <= 19)
          || v == 2 && (f100 >= 11 && f100 <= 19)) ? 'zero'
      : (n10 == 1 && n100 != 11 || v == 2 && f10 == 1 && f100 != 11
          || v != 2 && f10 == 1) ? 'one'
      : 'other';
},

ps: _cp[1],

pt: function(n, ord) {
  var s = String(n).split('.'), i = s[0];
  if (ord) return 'other';
  return ((i == 0
          || i == 1)) ? 'one' : 'other';
},

"pt-PT": _cp[3],

rm: _cp[1],

ro: function(n, ord) {
  var s = String(n).split('.'), v0 = !s[1], t0 = Number(s[0]) == n,
      n100 = t0 && s[0].slice(-2);
  if (ord) return (n == 1) ? 'one' : 'other';
  return (n == 1 && v0) ? 'one'
      : (!v0 || n == 0
          || n != 1 && (n100 >= 1 && n100 <= 19)) ? 'few'
      : 'other';
},

rof: _cp[1],

root: _cp[0],

ru: function(n, ord) {
  var s = String(n).split('.'), i = s[0], v0 = !s[1], i10 = i.slice(-1),
      i100 = i.slice(-2);
  if (ord) return 'other';
  return (v0 && i10 == 1 && i100 != 11) ? 'one'
      : (v0 && (i10 >= 2 && i10 <= 4) && (i100 < 12
          || i100 > 14)) ? 'few'
      : (v0 && i10 == 0 || v0 && (i10 >= 5 && i10 <= 9)
          || v0 && (i100 >= 11 && i100 <= 14)) ? 'many'
      : 'other';
},

rwk: _cp[1],

sah: _cp[0],

saq: _cp[1],

sd: _cp[1],

sdh: _cp[1],

se: function(n, ord) {
  if (ord) return 'other';
  return (n == 1) ? 'one'
      : (n == 2) ? 'two'
      : 'other';
},

seh: _cp[1],

ses: _cp[0],

sg: _cp[0],

sh: function(n, ord) {
  var s = String(n).split('.'), i = s[0], f = s[1] || '', v0 = !s[1],
      i10 = i.slice(-1), i100 = i.slice(-2), f10 = f.slice(-1), f100 = f.slice(-2);
  if (ord) return 'other';
  return (v0 && i10 == 1 && i100 != 11
          || f10 == 1 && f100 != 11) ? 'one'
      : (v0 && (i10 >= 2 && i10 <= 4) && (i100 < 12 || i100 > 14)
          || (f10 >= 2 && f10 <= 4) && (f100 < 12
          || f100 > 14)) ? 'few'
      : 'other';
},

shi: function(n, ord) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n;
  if (ord) return 'other';
  return (n >= 0 && n <= 1) ? 'one'
      : ((t0 && n >= 2 && n <= 10)) ? 'few'
      : 'other';
},

si: function(n, ord) {
  var s = String(n).split('.'), i = s[0], f = s[1] || '';
  if (ord) return 'other';
  return ((n == 0 || n == 1)
          || i == 0 && f == 1) ? 'one' : 'other';
},

sk: function(n, ord) {
  var s = String(n).split('.'), i = s[0], v0 = !s[1];
  if (ord) return 'other';
  return (n == 1 && v0) ? 'one'
      : ((i >= 2 && i <= 4) && v0) ? 'few'
      : (!v0) ? 'many'
      : 'other';
},

sl: function(n, ord) {
  var s = String(n).split('.'), i = s[0], v0 = !s[1], i100 = i.slice(-2);
  if (ord) return 'other';
  return (v0 && i100 == 1) ? 'one'
      : (v0 && i100 == 2) ? 'two'
      : (v0 && (i100 == 3 || i100 == 4)
          || !v0) ? 'few'
      : 'other';
},

sma: function(n, ord) {
  if (ord) return 'other';
  return (n == 1) ? 'one'
      : (n == 2) ? 'two'
      : 'other';
},

smi: function(n, ord) {
  if (ord) return 'other';
  return (n == 1) ? 'one'
      : (n == 2) ? 'two'
      : 'other';
},

smj: function(n, ord) {
  if (ord) return 'other';
  return (n == 1) ? 'one'
      : (n == 2) ? 'two'
      : 'other';
},

smn: function(n, ord) {
  if (ord) return 'other';
  return (n == 1) ? 'one'
      : (n == 2) ? 'two'
      : 'other';
},

sms: function(n, ord) {
  if (ord) return 'other';
  return (n == 1) ? 'one'
      : (n == 2) ? 'two'
      : 'other';
},

sn: _cp[1],

so: _cp[1],

sq: function(n, ord) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n,
      n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
  if (ord) return (n == 1) ? 'one'
      : (n10 == 4 && n100 != 14) ? 'many'
      : 'other';
  return (n == 1) ? 'one' : 'other';
},

sr: function(n, ord) {
  var s = String(n).split('.'), i = s[0], f = s[1] || '', v0 = !s[1],
      i10 = i.slice(-1), i100 = i.slice(-2), f10 = f.slice(-1), f100 = f.slice(-2);
  if (ord) return 'other';
  return (v0 && i10 == 1 && i100 != 11
          || f10 == 1 && f100 != 11) ? 'one'
      : (v0 && (i10 >= 2 && i10 <= 4) && (i100 < 12 || i100 > 14)
          || (f10 >= 2 && f10 <= 4) && (f100 < 12
          || f100 > 14)) ? 'few'
      : 'other';
},

ss: _cp[1],

ssy: _cp[1],

st: _cp[1],

sv: function(n, ord) {
  var s = String(n).split('.'), v0 = !s[1], t0 = Number(s[0]) == n,
      n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
  if (ord) return ((n10 == 1
          || n10 == 2) && n100 != 11 && n100 != 12) ? 'one' : 'other';
  return (n == 1 && v0) ? 'one' : 'other';
},

sw: _cp[3],

syr: _cp[1],

ta: _cp[1],

te: _cp[1],

teo: _cp[1],

th: _cp[0],

ti: _cp[2],

tig: _cp[1],

tk: function(n, ord) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n,
      n10 = t0 && s[0].slice(-1);
  if (ord) return ((n10 == 6 || n10 == 9)
          || n == 10) ? 'few' : 'other';
  return (n == 1) ? 'one' : 'other';
},

tl: function(n, ord) {
  var s = String(n).split('.'), i = s[0], f = s[1] || '', v0 = !s[1],
      i10 = i.slice(-1), f10 = f.slice(-1);
  if (ord) return (n == 1) ? 'one' : 'other';
  return (v0 && (i == 1 || i == 2 || i == 3)
          || v0 && i10 != 4 && i10 != 6 && i10 != 9
          || !v0 && f10 != 4 && f10 != 6 && f10 != 9) ? 'one' : 'other';
},

tn: _cp[1],

to: _cp[0],

tr: _cp[1],

ts: _cp[1],

tzm: function(n, ord) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n;
  if (ord) return 'other';
  return ((n == 0 || n == 1)
          || (t0 && n >= 11 && n <= 99)) ? 'one' : 'other';
},

ug: _cp[1],

uk: function(n, ord) {
  var s = String(n).split('.'), i = s[0], v0 = !s[1], t0 = Number(s[0]) == n,
      n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2), i10 = i.slice(-1),
      i100 = i.slice(-2);
  if (ord) return (n10 == 3 && n100 != 13) ? 'few' : 'other';
  return (v0 && i10 == 1 && i100 != 11) ? 'one'
      : (v0 && (i10 >= 2 && i10 <= 4) && (i100 < 12
          || i100 > 14)) ? 'few'
      : (v0 && i10 == 0 || v0 && (i10 >= 5 && i10 <= 9)
          || v0 && (i100 >= 11 && i100 <= 14)) ? 'many'
      : 'other';
},

ur: _cp[3],

uz: _cp[1],

ve: _cp[1],

vi: function(n, ord) {
  if (ord) return (n == 1) ? 'one' : 'other';
  return 'other';
},

vo: _cp[1],

vun: _cp[1],

wa: _cp[2],

wae: _cp[1],

wo: _cp[0],

xh: _cp[1],

xog: _cp[1],

yi: _cp[3],

yo: _cp[0],

yue: _cp[0],

zh: _cp[0],

zu: function(n, ord) {
  if (ord) return 'other';
  return (n >= 0 && n <= 1) ? 'one' : 'other';
}
}));


/***/ }),

/***/ "../node_modules/md5/md5.js":
/***/ (function(module, exports, __webpack_require__) {

(function(){
  var crypt = __webpack_require__("../node_modules/crypt/crypt.js"),
      utf8 = __webpack_require__("../node_modules/charenc/charenc.js").utf8,
      isBuffer = __webpack_require__("../node_modules/is-buffer/index.js"),
      bin = __webpack_require__("../node_modules/charenc/charenc.js").bin,

  // The core
  md5 = function (message, options) {
    // Convert to byte array
    if (message.constructor == String)
      if (options && options.encoding === 'binary')
        message = bin.stringToBytes(message);
      else
        message = utf8.stringToBytes(message);
    else if (isBuffer(message))
      message = Array.prototype.slice.call(message, 0);
    else if (!Array.isArray(message))
      message = message.toString();
    // else, assume byte array already

    var m = crypt.bytesToWords(message),
        l = message.length * 8,
        a =  1732584193,
        b = -271733879,
        c = -1732584194,
        d =  271733878;

    // Swap endian
    for (var i = 0; i < m.length; i++) {
      m[i] = ((m[i] <<  8) | (m[i] >>> 24)) & 0x00FF00FF |
             ((m[i] << 24) | (m[i] >>>  8)) & 0xFF00FF00;
    }

    // Padding
    m[l >>> 5] |= 0x80 << (l % 32);
    m[(((l + 64) >>> 9) << 4) + 14] = l;

    // Method shortcuts
    var FF = md5._ff,
        GG = md5._gg,
        HH = md5._hh,
        II = md5._ii;

    for (var i = 0; i < m.length; i += 16) {

      var aa = a,
          bb = b,
          cc = c,
          dd = d;

      a = FF(a, b, c, d, m[i+ 0],  7, -680876936);
      d = FF(d, a, b, c, m[i+ 1], 12, -389564586);
      c = FF(c, d, a, b, m[i+ 2], 17,  606105819);
      b = FF(b, c, d, a, m[i+ 3], 22, -1044525330);
      a = FF(a, b, c, d, m[i+ 4],  7, -176418897);
      d = FF(d, a, b, c, m[i+ 5], 12,  1200080426);
      c = FF(c, d, a, b, m[i+ 6], 17, -1473231341);
      b = FF(b, c, d, a, m[i+ 7], 22, -45705983);
      a = FF(a, b, c, d, m[i+ 8],  7,  1770035416);
      d = FF(d, a, b, c, m[i+ 9], 12, -1958414417);
      c = FF(c, d, a, b, m[i+10], 17, -42063);
      b = FF(b, c, d, a, m[i+11], 22, -1990404162);
      a = FF(a, b, c, d, m[i+12],  7,  1804603682);
      d = FF(d, a, b, c, m[i+13], 12, -40341101);
      c = FF(c, d, a, b, m[i+14], 17, -1502002290);
      b = FF(b, c, d, a, m[i+15], 22,  1236535329);

      a = GG(a, b, c, d, m[i+ 1],  5, -165796510);
      d = GG(d, a, b, c, m[i+ 6],  9, -1069501632);
      c = GG(c, d, a, b, m[i+11], 14,  643717713);
      b = GG(b, c, d, a, m[i+ 0], 20, -373897302);
      a = GG(a, b, c, d, m[i+ 5],  5, -701558691);
      d = GG(d, a, b, c, m[i+10],  9,  38016083);
      c = GG(c, d, a, b, m[i+15], 14, -660478335);
      b = GG(b, c, d, a, m[i+ 4], 20, -405537848);
      a = GG(a, b, c, d, m[i+ 9],  5,  568446438);
      d = GG(d, a, b, c, m[i+14],  9, -1019803690);
      c = GG(c, d, a, b, m[i+ 3], 14, -187363961);
      b = GG(b, c, d, a, m[i+ 8], 20,  1163531501);
      a = GG(a, b, c, d, m[i+13],  5, -1444681467);
      d = GG(d, a, b, c, m[i+ 2],  9, -51403784);
      c = GG(c, d, a, b, m[i+ 7], 14,  1735328473);
      b = GG(b, c, d, a, m[i+12], 20, -1926607734);

      a = HH(a, b, c, d, m[i+ 5],  4, -378558);
      d = HH(d, a, b, c, m[i+ 8], 11, -2022574463);
      c = HH(c, d, a, b, m[i+11], 16,  1839030562);
      b = HH(b, c, d, a, m[i+14], 23, -35309556);
      a = HH(a, b, c, d, m[i+ 1],  4, -1530992060);
      d = HH(d, a, b, c, m[i+ 4], 11,  1272893353);
      c = HH(c, d, a, b, m[i+ 7], 16, -155497632);
      b = HH(b, c, d, a, m[i+10], 23, -1094730640);
      a = HH(a, b, c, d, m[i+13],  4,  681279174);
      d = HH(d, a, b, c, m[i+ 0], 11, -358537222);
      c = HH(c, d, a, b, m[i+ 3], 16, -722521979);
      b = HH(b, c, d, a, m[i+ 6], 23,  76029189);
      a = HH(a, b, c, d, m[i+ 9],  4, -640364487);
      d = HH(d, a, b, c, m[i+12], 11, -421815835);
      c = HH(c, d, a, b, m[i+15], 16,  530742520);
      b = HH(b, c, d, a, m[i+ 2], 23, -995338651);

      a = II(a, b, c, d, m[i+ 0],  6, -198630844);
      d = II(d, a, b, c, m[i+ 7], 10,  1126891415);
      c = II(c, d, a, b, m[i+14], 15, -1416354905);
      b = II(b, c, d, a, m[i+ 5], 21, -57434055);
      a = II(a, b, c, d, m[i+12],  6,  1700485571);
      d = II(d, a, b, c, m[i+ 3], 10, -1894986606);
      c = II(c, d, a, b, m[i+10], 15, -1051523);
      b = II(b, c, d, a, m[i+ 1], 21, -2054922799);
      a = II(a, b, c, d, m[i+ 8],  6,  1873313359);
      d = II(d, a, b, c, m[i+15], 10, -30611744);
      c = II(c, d, a, b, m[i+ 6], 15, -1560198380);
      b = II(b, c, d, a, m[i+13], 21,  1309151649);
      a = II(a, b, c, d, m[i+ 4],  6, -145523070);
      d = II(d, a, b, c, m[i+11], 10, -1120210379);
      c = II(c, d, a, b, m[i+ 2], 15,  718787259);
      b = II(b, c, d, a, m[i+ 9], 21, -343485551);

      a = (a + aa) >>> 0;
      b = (b + bb) >>> 0;
      c = (c + cc) >>> 0;
      d = (d + dd) >>> 0;
    }

    return crypt.endian([a, b, c, d]);
  };

  // Auxiliary functions
  md5._ff  = function (a, b, c, d, x, s, t) {
    var n = a + (b & c | ~b & d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5._gg  = function (a, b, c, d, x, s, t) {
    var n = a + (b & d | c & ~d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5._hh  = function (a, b, c, d, x, s, t) {
    var n = a + (b ^ c ^ d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5._ii  = function (a, b, c, d, x, s, t) {
    var n = a + (c ^ (b | ~d)) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };

  // Package private blocksize
  md5._blocksize = 16;
  md5._digestsize = 16;

  module.exports = function (message, options) {
    if (message === undefined || message === null)
      throw new Error('Illegal argument ' + message);

    var digestbytes = crypt.wordsToBytes(md5(message, options));
    return options && options.asBytes ? digestbytes :
        options && options.asString ? bin.bytesToString(digestbytes) :
        crypt.bytesToHex(digestbytes);
  };

})();


/***/ }),

/***/ "../node_modules/memorystorage/dist/memorystorage.umd.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (u, m, d) {
	if (true) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function(){return (d());}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));}
	else if (typeof exports === 'object') {module.exports = d();}
	else {u[m] = d();}
}(this, 'MemoryStorage', function() {'use strict';

/*! memorystorage.js - A memory-backed implementation of the Web Storage API.
 *
 * @copyright Copyright 2016 by Stijn de Witt and contributors. Some rights reserved.
 * @license Licensed under [Creative Commons Attribution 4.0 International (CC BY 4.0)](https://creativecommons.org/licenses/by/4.0/).
 */

/**
 * Creates a new MemoryStorage object implementing the <a href="http://www.w3.org/TR/webstorage/">Web Storage API</a> using memory.
 *
 * <p>If no arguments are given, the created memory storage object will read from and write to the
 * <code>global</code> memory storage. If a string argument is given, the new storage object
 * will read from and write to it's own segment of memory. Any data written to such a memory
 * storage object will only show up in other memory storage objects that have been created with
 * the same id. This data will not show up in the <code>global</code> memory space. As such it
 * is recommended to always construct a memory storage object with a unique string id as argument.</p>
 *
 * @param id Optional string argument used to isolate this memory storage object from others.
 */
function MemoryStorage(id) {
	// make sure id is assigned
	id = id || 'global'
	// try to get existing store
	var result = storage[id]
	// return it if found
	if (result) {return result}

	// make sure there is no harm in leaving out new in invocations to MemoryStorage
	if (! (this instanceof MemoryStorage)) {return new MemoryStorage(id);}

	// create a new store and save a ref to it so we can get it back later
	result = storage[id] = this;
	// create a space to store 'cloaked' key/values: items that have a key
	// that collides with Web Storage API method names.
	var cloak = {};

	// Allow client code to read the id
	Object.defineProperty(result, 'id', {enumerable:true, configurable:true, value:id})

	// Create the length property
	Object.defineProperty(result, 'length', {enumerable:true, configurable:true, get:function(){
		return enumerableKeys().length
	}})

	// Create API methods
	result.getItem = function MemoryStorage_getItem(key) {
		return (key in API ? cloak[key] : this[key]) || null
	}
	result.setItem = function MemoryStorage_setItem(key, val) {
		key in API ? cloak[key] = val : this[key] = val
	}
	result.removeItem = function MemoryStorage_removeItem(key) {
		key in API ? delete cloak[key] : delete this[key]
	}
	result.key = function MemoryStorage_key(idx) {
		var keys = enumerableKeys()
		return idx >= 0 && idx < keys.length ? keys[idx] : null
	}
	result.clear = function MemoryStorage_clear() {
		var keys = uncloakedKeys()
		for (var i=0,key; key=keys[i]; i++) {
			delete this[key]
		}
		keys = cloakedKeys()
		for (var i=0,key; key=keys[i]; i++) {
			delete cloak[key]
		}
	}

	// Wrap in ES6 Proxy if available to support Object.keys() on a MemoryStorage object
	return typeof Proxy === 'undefined' ? result : new Proxy(result, {ownKeys: function() {return enumerableKeys()}})

	// helper functions
	function uncloakedKeys() {return Object.keys(result).filter(function(x){return !(x in API)})}
	function cloakedKeys() {return Object.keys(cloak)}
	function enumerableKeys(){return uncloakedKeys().concat(cloakedKeys())}
}

// API methods and properties will be cloaked
var API = {clear:1, getItem:1, id:1, key:1, length:1, removeItem:1, setItem:1}

// Used to store all memorystorage objects
var storage = {};


return MemoryStorage;
}));


/***/ }),

/***/ "../node_modules/messageformat-parser/parser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Generated by PEG.js 0.10.0.
 *
 * http://pegjs.org/
 */



function peg$subclass(child, parent) {
  function ctor() { this.constructor = child; }
  ctor.prototype = parent.prototype;
  child.prototype = new ctor();
}

function peg$SyntaxError(message, expected, found, location) {
  this.message  = message;
  this.expected = expected;
  this.found    = found;
  this.location = location;
  this.name     = "SyntaxError";

  if (typeof Error.captureStackTrace === "function") {
    Error.captureStackTrace(this, peg$SyntaxError);
  }
}

peg$subclass(peg$SyntaxError, Error);

peg$SyntaxError.buildMessage = function(expected, found) {
  var DESCRIBE_EXPECTATION_FNS = {
        literal: function(expectation) {
          return "\"" + literalEscape(expectation.text) + "\"";
        },

        "class": function(expectation) {
          var escapedParts = "",
              i;

          for (i = 0; i < expectation.parts.length; i++) {
            escapedParts += expectation.parts[i] instanceof Array
              ? classEscape(expectation.parts[i][0]) + "-" + classEscape(expectation.parts[i][1])
              : classEscape(expectation.parts[i]);
          }

          return "[" + (expectation.inverted ? "^" : "") + escapedParts + "]";
        },

        any: function(expectation) {
          return "any character";
        },

        end: function(expectation) {
          return "end of input";
        },

        other: function(expectation) {
          return expectation.description;
        }
      };

  function hex(ch) {
    return ch.charCodeAt(0).toString(16).toUpperCase();
  }

  function literalEscape(s) {
    return s
      .replace(/\\/g, '\\\\')
      .replace(/"/g,  '\\"')
      .replace(/\0/g, '\\0')
      .replace(/\t/g, '\\t')
      .replace(/\n/g, '\\n')
      .replace(/\r/g, '\\r')
      .replace(/[\x00-\x0F]/g,          function(ch) { return '\\x0' + hex(ch); })
      .replace(/[\x10-\x1F\x7F-\x9F]/g, function(ch) { return '\\x'  + hex(ch); });
  }

  function classEscape(s) {
    return s
      .replace(/\\/g, '\\\\')
      .replace(/\]/g, '\\]')
      .replace(/\^/g, '\\^')
      .replace(/-/g,  '\\-')
      .replace(/\0/g, '\\0')
      .replace(/\t/g, '\\t')
      .replace(/\n/g, '\\n')
      .replace(/\r/g, '\\r')
      .replace(/[\x00-\x0F]/g,          function(ch) { return '\\x0' + hex(ch); })
      .replace(/[\x10-\x1F\x7F-\x9F]/g, function(ch) { return '\\x'  + hex(ch); });
  }

  function describeExpectation(expectation) {
    return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);
  }

  function describeExpected(expected) {
    var descriptions = new Array(expected.length),
        i, j;

    for (i = 0; i < expected.length; i++) {
      descriptions[i] = describeExpectation(expected[i]);
    }

    descriptions.sort();

    if (descriptions.length > 0) {
      for (i = 1, j = 1; i < descriptions.length; i++) {
        if (descriptions[i - 1] !== descriptions[i]) {
          descriptions[j] = descriptions[i];
          j++;
        }
      }
      descriptions.length = j;
    }

    switch (descriptions.length) {
      case 1:
        return descriptions[0];

      case 2:
        return descriptions[0] + " or " + descriptions[1];

      default:
        return descriptions.slice(0, -1).join(", ")
          + ", or "
          + descriptions[descriptions.length - 1];
    }
  }

  function describeFound(found) {
    return found ? "\"" + literalEscape(found) + "\"" : "end of input";
  }

  return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
};

function peg$parse(input, options) {
  options = options !== void 0 ? options : {};

  var peg$FAILED = {},

      peg$startRuleFunctions = { start: peg$parsestart },
      peg$startRuleFunction  = peg$parsestart,

      peg$c0 = "#",
      peg$c1 = peg$literalExpectation("#", false),
      peg$c2 = function() { return inPlural; },
      peg$c3 = function() { return { type: 'octothorpe' }; },
      peg$c4 = function(str) { return str.join(''); },
      peg$c5 = "{",
      peg$c6 = peg$literalExpectation("{", false),
      peg$c7 = "}",
      peg$c8 = peg$literalExpectation("}", false),
      peg$c9 = function(arg) {
          return {
            type: 'argument',
            arg: arg
          };
        },
      peg$c10 = ",",
      peg$c11 = peg$literalExpectation(",", false),
      peg$c12 = "select",
      peg$c13 = peg$literalExpectation("select", false),
      peg$c14 = function(arg, m) { if (options.strictNumberSign) { inPlural = false; } return m; },
      peg$c15 = function(arg, cases) {
          return {
            type: 'select',
            arg: arg,
            cases: cases
          };
        },
      peg$c16 = "plural",
      peg$c17 = peg$literalExpectation("plural", false),
      peg$c18 = "selectordinal",
      peg$c19 = peg$literalExpectation("selectordinal", false),
      peg$c20 = function(arg, m) { inPlural = true; return m; },
      peg$c21 = function(arg, type, offset, cases) {
          var ls = ((type === 'selectordinal') ? options.ordinal : options.cardinal)
                   || ['zero', 'one', 'two', 'few', 'many', 'other'];
          if (ls && ls.length) cases.forEach(function(c) {
            if (isNaN(c.key) && ls.indexOf(c.key) < 0) throw new Error(
              'Invalid key `' + c.key + '` for argument `' + arg + '`.' +
              ' Valid ' + type + ' keys for this locale are `' + ls.join('`, `') +
              '`, and explicit keys like `=0`.');
          });
          inPlural = false;
          return {
            type: type,
            arg: arg,
            offset: offset || 0,
            cases: cases
          };
        },
      peg$c22 = function(arg, key, params) {
          return {
            type: 'function',
            arg: arg,
            key: key,
            params: params
          };
        },
      peg$c23 = /^[^\t-\r \x85\u200E\u200F\u2028\u2029!-\/:-@[-\^`{-~\xA1-\xA7\xA9\xAB\xAC\xAE\xB0\xB1\xB6\xBB\xBF\xD7\xF7\u2010-\u2027\u2030-\u203E\u2041-\u2053\u2055-\u205E\u2190-\u245F\u2500-\u2775\u2794-\u2BFF\u2E00-\u2E7F\u3001-\u3003\u3008-\u3020\u3030\uFD3E\uFD3F\uFE45\uFE46]/,
      peg$c24 = peg$classExpectation([["\t", "\r"], " ", "\x85", "\u200E", "\u200F", "\u2028", "\u2029", ["!", "/"], [":", "@"], ["[", "^"], "`", ["{", "~"], ["\xA1", "\xA7"], "\xA9", "\xAB", "\xAC", "\xAE", "\xB0", "\xB1", "\xB6", "\xBB", "\xBF", "\xD7", "\xF7", ["\u2010", "\u2027"], ["\u2030", "\u203E"], ["\u2041", "\u2053"], ["\u2055", "\u205E"], ["\u2190", "\u245F"], ["\u2500", "\u2775"], ["\u2794", "\u2BFF"], ["\u2E00", "\u2E7F"], ["\u3001", "\u3003"], ["\u3008", "\u3020"], "\u3030", "\uFD3E", "\uFD3F", "\uFE45", "\uFE46"], true, false),
      peg$c25 = function(key, tokens) { return { key: key, tokens: tokens }; },
      peg$c26 = function(tokens) { return tokens; },
      peg$c27 = "offset",
      peg$c28 = peg$literalExpectation("offset", false),
      peg$c29 = ":",
      peg$c30 = peg$literalExpectation(":", false),
      peg$c31 = function(d) { return d; },
      peg$c32 = "=",
      peg$c33 = peg$literalExpectation("=", false),
      peg$c34 = function(p) { return options.strictFunctionParams; },
      peg$c35 = function(p) { return p; },
      peg$c36 = function(p) { return p.replace(whitespaceTrimRE, ''); },
      peg$c37 = "''",
      peg$c38 = peg$literalExpectation("''", false),
      peg$c39 = function() { return "'"; },
      peg$c40 = /^[^']/,
      peg$c41 = peg$classExpectation(["'"], true, false),
      peg$c42 = "'{",
      peg$c43 = peg$literalExpectation("'{", false),
      peg$c44 = "'",
      peg$c45 = peg$literalExpectation("'", false),
      peg$c46 = function(str) { return '\u007B'+str.join(''); },
      peg$c47 = "'}",
      peg$c48 = peg$literalExpectation("'}", false),
      peg$c49 = function(str) { return '\u007D'+str.join(''); },
      peg$c50 = "'#",
      peg$c51 = peg$literalExpectation("'#", false),
      peg$c52 = function(str) { return "#"+str.join(''); },
      peg$c53 = function(quotedOcto) { return quotedOcto[0]; },
      peg$c54 = function(octo) { return !inPlural; },
      peg$c55 = function(octo) { return octo; },
      peg$c56 = /^[^{}#\\\0-\x08\x0E-\x1F\x7F]/,
      peg$c57 = peg$classExpectation(["{", "}", "#", "\\", ["\0", "\b"], ["\x0E", "\x1F"], "\x7F"], true, false),
      peg$c58 = "\\\\",
      peg$c59 = peg$literalExpectation("\\\\", false),
      peg$c60 = function() { return '\\'; },
      peg$c61 = "\\#",
      peg$c62 = peg$literalExpectation("\\#", false),
      peg$c63 = function() { return '#'; },
      peg$c64 = "\\{",
      peg$c65 = peg$literalExpectation("\\{", false),
      peg$c66 = function() { return '\u007B'; },
      peg$c67 = "\\}",
      peg$c68 = peg$literalExpectation("\\}", false),
      peg$c69 = function() { return '\u007D'; },
      peg$c70 = "\\u",
      peg$c71 = peg$literalExpectation("\\u", false),
      peg$c72 = function(h1, h2, h3, h4) {
            return String.fromCharCode(parseInt('0x' + h1 + h2 + h3 + h4));
          },
      peg$c73 = /^[^',}]/,
      peg$c74 = peg$classExpectation(["'", ",", "}"], true, false),
      peg$c75 = /^[^'}]/,
      peg$c76 = peg$classExpectation(["'", "}"], true, false),
      peg$c77 = /^[0-9]/,
      peg$c78 = peg$classExpectation([["0", "9"]], false, false),
      peg$c79 = /^[0-9a-fA-F]/,
      peg$c80 = peg$classExpectation([["0", "9"], ["a", "f"], ["A", "F"]], false, false),
      peg$c81 = /^[\t-\r \x85\u200E\u200F\u2028\u2029]/,
      peg$c82 = peg$classExpectation([["\t", "\r"], " ", "\x85", "\u200E", "\u200F", "\u2028", "\u2029"], false, false),

      peg$currPos          = 0,
      peg$savedPos         = 0,
      peg$posDetailsCache  = [{ line: 1, column: 1 }],
      peg$maxFailPos       = 0,
      peg$maxFailExpected  = [],
      peg$silentFails      = 0,

      peg$result;

  if ("startRule" in options) {
    if (!(options.startRule in peg$startRuleFunctions)) {
      throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
    }

    peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
  }

  function text() {
    return input.substring(peg$savedPos, peg$currPos);
  }

  function location() {
    return peg$computeLocation(peg$savedPos, peg$currPos);
  }

  function expected(description, location) {
    location = location !== void 0 ? location : peg$computeLocation(peg$savedPos, peg$currPos)

    throw peg$buildStructuredError(
      [peg$otherExpectation(description)],
      input.substring(peg$savedPos, peg$currPos),
      location
    );
  }

  function error(message, location) {
    location = location !== void 0 ? location : peg$computeLocation(peg$savedPos, peg$currPos)

    throw peg$buildSimpleError(message, location);
  }

  function peg$literalExpectation(text, ignoreCase) {
    return { type: "literal", text: text, ignoreCase: ignoreCase };
  }

  function peg$classExpectation(parts, inverted, ignoreCase) {
    return { type: "class", parts: parts, inverted: inverted, ignoreCase: ignoreCase };
  }

  function peg$anyExpectation() {
    return { type: "any" };
  }

  function peg$endExpectation() {
    return { type: "end" };
  }

  function peg$otherExpectation(description) {
    return { type: "other", description: description };
  }

  function peg$computePosDetails(pos) {
    var details = peg$posDetailsCache[pos], p;

    if (details) {
      return details;
    } else {
      p = pos - 1;
      while (!peg$posDetailsCache[p]) {
        p--;
      }

      details = peg$posDetailsCache[p];
      details = {
        line:   details.line,
        column: details.column
      };

      while (p < pos) {
        if (input.charCodeAt(p) === 10) {
          details.line++;
          details.column = 1;
        } else {
          details.column++;
        }

        p++;
      }

      peg$posDetailsCache[pos] = details;
      return details;
    }
  }

  function peg$computeLocation(startPos, endPos) {
    var startPosDetails = peg$computePosDetails(startPos),
        endPosDetails   = peg$computePosDetails(endPos);

    return {
      start: {
        offset: startPos,
        line:   startPosDetails.line,
        column: startPosDetails.column
      },
      end: {
        offset: endPos,
        line:   endPosDetails.line,
        column: endPosDetails.column
      }
    };
  }

  function peg$fail(expected) {
    if (peg$currPos < peg$maxFailPos) { return; }

    if (peg$currPos > peg$maxFailPos) {
      peg$maxFailPos = peg$currPos;
      peg$maxFailExpected = [];
    }

    peg$maxFailExpected.push(expected);
  }

  function peg$buildSimpleError(message, location) {
    return new peg$SyntaxError(message, null, null, location);
  }

  function peg$buildStructuredError(expected, found, location) {
    return new peg$SyntaxError(
      peg$SyntaxError.buildMessage(expected, found),
      expected,
      found,
      location
    );
  }

  function peg$parsestart() {
    var s0, s1;

    s0 = [];
    s1 = peg$parsetoken();
    while (s1 !== peg$FAILED) {
      s0.push(s1);
      s1 = peg$parsetoken();
    }

    return s0;
  }

  function peg$parsetoken() {
    var s0, s1, s2;

    s0 = peg$parseargument();
    if (s0 === peg$FAILED) {
      s0 = peg$parseselect();
      if (s0 === peg$FAILED) {
        s0 = peg$parseplural();
        if (s0 === peg$FAILED) {
          s0 = peg$parsefunction();
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 35) {
              s1 = peg$c0;
              peg$currPos++;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c1); }
            }
            if (s1 !== peg$FAILED) {
              peg$savedPos = peg$currPos;
              s2 = peg$c2();
              if (s2) {
                s2 = void 0;
              } else {
                s2 = peg$FAILED;
              }
              if (s2 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c3();
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              s1 = [];
              s2 = peg$parsechar();
              if (s2 !== peg$FAILED) {
                while (s2 !== peg$FAILED) {
                  s1.push(s2);
                  s2 = peg$parsechar();
                }
              } else {
                s1 = peg$FAILED;
              }
              if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c4(s1);
              }
              s0 = s1;
            }
          }
        }
      }
    }

    return s0;
  }

  function peg$parseargument() {
    var s0, s1, s2, s3, s4, s5;

    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 123) {
      s1 = peg$c5;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c6); }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parse_();
      if (s2 !== peg$FAILED) {
        s3 = peg$parseid();
        if (s3 !== peg$FAILED) {
          s4 = peg$parse_();
          if (s4 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 125) {
              s5 = peg$c7;
              peg$currPos++;
            } else {
              s5 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c8); }
            }
            if (s5 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c9(s3);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseselect() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13;

    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 123) {
      s1 = peg$c5;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c6); }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parse_();
      if (s2 !== peg$FAILED) {
        s3 = peg$parseid();
        if (s3 !== peg$FAILED) {
          s4 = peg$parse_();
          if (s4 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 44) {
              s5 = peg$c10;
              peg$currPos++;
            } else {
              s5 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c11); }
            }
            if (s5 !== peg$FAILED) {
              s6 = peg$parse_();
              if (s6 !== peg$FAILED) {
                s7 = peg$currPos;
                if (input.substr(peg$currPos, 6) === peg$c12) {
                  s8 = peg$c12;
                  peg$currPos += 6;
                } else {
                  s8 = peg$FAILED;
                  if (peg$silentFails === 0) { peg$fail(peg$c13); }
                }
                if (s8 !== peg$FAILED) {
                  peg$savedPos = s7;
                  s8 = peg$c14(s3, s8);
                }
                s7 = s8;
                if (s7 !== peg$FAILED) {
                  s8 = peg$parse_();
                  if (s8 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 44) {
                      s9 = peg$c10;
                      peg$currPos++;
                    } else {
                      s9 = peg$FAILED;
                      if (peg$silentFails === 0) { peg$fail(peg$c11); }
                    }
                    if (s9 !== peg$FAILED) {
                      s10 = peg$parse_();
                      if (s10 !== peg$FAILED) {
                        s11 = [];
                        s12 = peg$parseselectCase();
                        if (s12 !== peg$FAILED) {
                          while (s12 !== peg$FAILED) {
                            s11.push(s12);
                            s12 = peg$parseselectCase();
                          }
                        } else {
                          s11 = peg$FAILED;
                        }
                        if (s11 !== peg$FAILED) {
                          s12 = peg$parse_();
                          if (s12 !== peg$FAILED) {
                            if (input.charCodeAt(peg$currPos) === 125) {
                              s13 = peg$c7;
                              peg$currPos++;
                            } else {
                              s13 = peg$FAILED;
                              if (peg$silentFails === 0) { peg$fail(peg$c8); }
                            }
                            if (s13 !== peg$FAILED) {
                              peg$savedPos = s0;
                              s1 = peg$c15(s3, s11);
                              s0 = s1;
                            } else {
                              peg$currPos = s0;
                              s0 = peg$FAILED;
                            }
                          } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                          }
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseplural() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13, s14;

    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 123) {
      s1 = peg$c5;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c6); }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parse_();
      if (s2 !== peg$FAILED) {
        s3 = peg$parseid();
        if (s3 !== peg$FAILED) {
          s4 = peg$parse_();
          if (s4 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 44) {
              s5 = peg$c10;
              peg$currPos++;
            } else {
              s5 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c11); }
            }
            if (s5 !== peg$FAILED) {
              s6 = peg$parse_();
              if (s6 !== peg$FAILED) {
                s7 = peg$currPos;
                if (input.substr(peg$currPos, 6) === peg$c16) {
                  s8 = peg$c16;
                  peg$currPos += 6;
                } else {
                  s8 = peg$FAILED;
                  if (peg$silentFails === 0) { peg$fail(peg$c17); }
                }
                if (s8 === peg$FAILED) {
                  if (input.substr(peg$currPos, 13) === peg$c18) {
                    s8 = peg$c18;
                    peg$currPos += 13;
                  } else {
                    s8 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$c19); }
                  }
                }
                if (s8 !== peg$FAILED) {
                  peg$savedPos = s7;
                  s8 = peg$c20(s3, s8);
                }
                s7 = s8;
                if (s7 !== peg$FAILED) {
                  s8 = peg$parse_();
                  if (s8 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 44) {
                      s9 = peg$c10;
                      peg$currPos++;
                    } else {
                      s9 = peg$FAILED;
                      if (peg$silentFails === 0) { peg$fail(peg$c11); }
                    }
                    if (s9 !== peg$FAILED) {
                      s10 = peg$parse_();
                      if (s10 !== peg$FAILED) {
                        s11 = peg$parseoffset();
                        if (s11 === peg$FAILED) {
                          s11 = null;
                        }
                        if (s11 !== peg$FAILED) {
                          s12 = [];
                          s13 = peg$parsepluralCase();
                          if (s13 !== peg$FAILED) {
                            while (s13 !== peg$FAILED) {
                              s12.push(s13);
                              s13 = peg$parsepluralCase();
                            }
                          } else {
                            s12 = peg$FAILED;
                          }
                          if (s12 !== peg$FAILED) {
                            s13 = peg$parse_();
                            if (s13 !== peg$FAILED) {
                              if (input.charCodeAt(peg$currPos) === 125) {
                                s14 = peg$c7;
                                peg$currPos++;
                              } else {
                                s14 = peg$FAILED;
                                if (peg$silentFails === 0) { peg$fail(peg$c8); }
                              }
                              if (s14 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c21(s3, s7, s11, s12);
                                s0 = s1;
                              } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                              }
                            } else {
                              peg$currPos = s0;
                              s0 = peg$FAILED;
                            }
                          } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                          }
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsefunction() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10;

    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 123) {
      s1 = peg$c5;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c6); }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parse_();
      if (s2 !== peg$FAILED) {
        s3 = peg$parseid();
        if (s3 !== peg$FAILED) {
          s4 = peg$parse_();
          if (s4 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 44) {
              s5 = peg$c10;
              peg$currPos++;
            } else {
              s5 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c11); }
            }
            if (s5 !== peg$FAILED) {
              s6 = peg$parse_();
              if (s6 !== peg$FAILED) {
                s7 = peg$currPos;
                s8 = peg$parseid();
                if (s8 !== peg$FAILED) {
                  peg$savedPos = s7;
                  s8 = peg$c14(s3, s8);
                }
                s7 = s8;
                if (s7 !== peg$FAILED) {
                  s8 = peg$parse_();
                  if (s8 !== peg$FAILED) {
                    s9 = peg$parsefunctionParams();
                    if (s9 !== peg$FAILED) {
                      if (input.charCodeAt(peg$currPos) === 125) {
                        s10 = peg$c7;
                        peg$currPos++;
                      } else {
                        s10 = peg$FAILED;
                        if (peg$silentFails === 0) { peg$fail(peg$c8); }
                      }
                      if (s10 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c22(s3, s7, s9);
                        s0 = s1;
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseid() {
    var s0, s1, s2;

    s0 = peg$currPos;
    s1 = [];
    if (peg$c23.test(input.charAt(peg$currPos))) {
      s2 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s2 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c24); }
    }
    if (s2 !== peg$FAILED) {
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        if (peg$c23.test(input.charAt(peg$currPos))) {
          s2 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c24); }
        }
      }
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      s0 = input.substring(s0, peg$currPos);
    } else {
      s0 = s1;
    }

    return s0;
  }

  function peg$parseparamDefault() {
    var s0, s1, s2;

    s0 = peg$currPos;
    s1 = [];
    s2 = peg$parseparamcharsDefault();
    if (s2 !== peg$FAILED) {
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parseparamcharsDefault();
      }
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$c4(s1);
    }
    s0 = s1;

    return s0;
  }

  function peg$parseparamStrict() {
    var s0, s1, s2;

    s0 = peg$currPos;
    s1 = [];
    s2 = peg$parseparamcharsStrict();
    if (s2 !== peg$FAILED) {
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parseparamcharsStrict();
      }
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$c4(s1);
    }
    s0 = s1;

    return s0;
  }

  function peg$parseselectCase() {
    var s0, s1, s2, s3, s4;

    s0 = peg$currPos;
    s1 = peg$parse_();
    if (s1 !== peg$FAILED) {
      s2 = peg$parseid();
      if (s2 !== peg$FAILED) {
        s3 = peg$parse_();
        if (s3 !== peg$FAILED) {
          s4 = peg$parsecaseTokens();
          if (s4 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c25(s2, s4);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsepluralCase() {
    var s0, s1, s2, s3, s4;

    s0 = peg$currPos;
    s1 = peg$parse_();
    if (s1 !== peg$FAILED) {
      s2 = peg$parsepluralKey();
      if (s2 !== peg$FAILED) {
        s3 = peg$parse_();
        if (s3 !== peg$FAILED) {
          s4 = peg$parsecaseTokens();
          if (s4 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c25(s2, s4);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsecaseTokens() {
    var s0, s1, s2, s3, s4, s5;

    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 123) {
      s1 = peg$c5;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c6); }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      s3 = peg$parse_();
      if (s3 !== peg$FAILED) {
        s4 = peg$currPos;
        peg$silentFails++;
        if (input.charCodeAt(peg$currPos) === 123) {
          s5 = peg$c5;
          peg$currPos++;
        } else {
          s5 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c6); }
        }
        peg$silentFails--;
        if (s5 !== peg$FAILED) {
          peg$currPos = s4;
          s4 = void 0;
        } else {
          s4 = peg$FAILED;
        }
        if (s4 !== peg$FAILED) {
          s3 = [s3, s4];
          s2 = s3;
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 === peg$FAILED) {
        s2 = null;
      }
      if (s2 !== peg$FAILED) {
        s3 = [];
        s4 = peg$parsetoken();
        while (s4 !== peg$FAILED) {
          s3.push(s4);
          s4 = peg$parsetoken();
        }
        if (s3 !== peg$FAILED) {
          s4 = peg$parse_();
          if (s4 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 125) {
              s5 = peg$c7;
              peg$currPos++;
            } else {
              s5 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c8); }
            }
            if (s5 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c26(s3);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseoffset() {
    var s0, s1, s2, s3, s4, s5, s6, s7;

    s0 = peg$currPos;
    s1 = peg$parse_();
    if (s1 !== peg$FAILED) {
      if (input.substr(peg$currPos, 6) === peg$c27) {
        s2 = peg$c27;
        peg$currPos += 6;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c28); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parse_();
        if (s3 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 58) {
            s4 = peg$c29;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c30); }
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parse_();
            if (s5 !== peg$FAILED) {
              s6 = peg$parsedigits();
              if (s6 !== peg$FAILED) {
                s7 = peg$parse_();
                if (s7 !== peg$FAILED) {
                  peg$savedPos = s0;
                  s1 = peg$c31(s6);
                  s0 = s1;
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsepluralKey() {
    var s0, s1, s2;

    s0 = peg$parseid();
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 61) {
        s1 = peg$c32;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c33); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parsedigits();
        if (s2 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c31(s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }

    return s0;
  }

  function peg$parsefunctionParams() {
    var s0, s1, s2;

    s0 = peg$currPos;
    s1 = [];
    s2 = peg$parsefunctionParamsDefault();
    while (s2 !== peg$FAILED) {
      s1.push(s2);
      s2 = peg$parsefunctionParamsDefault();
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = peg$currPos;
      s2 = peg$c34(s1);
      if (s2) {
        s2 = peg$FAILED;
      } else {
        s2 = void 0;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c35(s1);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsefunctionParamsStrict();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsefunctionParamsStrict();
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = peg$currPos;
        s2 = peg$c34(s1);
        if (s2) {
          s2 = void 0;
        } else {
          s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c35(s1);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }

    return s0;
  }

  function peg$parsefunctionParamsStrict() {
    var s0, s1, s2, s3;

    s0 = peg$currPos;
    s1 = peg$parse_();
    if (s1 !== peg$FAILED) {
      if (input.charCodeAt(peg$currPos) === 44) {
        s2 = peg$c10;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c11); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parseparamStrict();
        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c35(s3);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsefunctionParamsDefault() {
    var s0, s1, s2, s3, s4, s5;

    s0 = peg$currPos;
    s1 = peg$parse_();
    if (s1 !== peg$FAILED) {
      if (input.charCodeAt(peg$currPos) === 44) {
        s2 = peg$c10;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c11); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parse_();
        if (s3 !== peg$FAILED) {
          s4 = peg$parseparamDefault();
          if (s4 !== peg$FAILED) {
            s5 = peg$parse_();
            if (s5 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c36(s4);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsedoubleapos() {
    var s0, s1;

    s0 = peg$currPos;
    if (input.substr(peg$currPos, 2) === peg$c37) {
      s1 = peg$c37;
      peg$currPos += 2;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c38); }
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$c39();
    }
    s0 = s1;

    return s0;
  }

  function peg$parseinapos() {
    var s0, s1, s2;

    s0 = peg$parsedoubleapos();
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = [];
      if (peg$c40.test(input.charAt(peg$currPos))) {
        s2 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c41); }
      }
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          if (peg$c40.test(input.charAt(peg$currPos))) {
            s2 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c41); }
          }
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c4(s1);
      }
      s0 = s1;
    }

    return s0;
  }

  function peg$parsequotedCurly() {
    var s0, s1, s2, s3;

    s0 = peg$currPos;
    if (input.substr(peg$currPos, 2) === peg$c42) {
      s1 = peg$c42;
      peg$currPos += 2;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c43); }
    }
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$parseinapos();
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$parseinapos();
      }
      if (s2 !== peg$FAILED) {
        if (input.charCodeAt(peg$currPos) === 39) {
          s3 = peg$c44;
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c45); }
        }
        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c46(s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      if (input.substr(peg$currPos, 2) === peg$c47) {
        s1 = peg$c47;
        peg$currPos += 2;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c48); }
      }
      if (s1 !== peg$FAILED) {
        s2 = [];
        s3 = peg$parseinapos();
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$parseinapos();
        }
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 39) {
            s3 = peg$c44;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c45); }
          }
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c49(s2);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }

    return s0;
  }

  function peg$parsequoted() {
    var s0, s1, s2, s3, s4, s5;

    s0 = peg$parsequotedCurly();
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$currPos;
      s2 = peg$currPos;
      if (input.substr(peg$currPos, 2) === peg$c50) {
        s3 = peg$c50;
        peg$currPos += 2;
      } else {
        s3 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c51); }
      }
      if (s3 !== peg$FAILED) {
        s4 = [];
        s5 = peg$parseinapos();
        while (s5 !== peg$FAILED) {
          s4.push(s5);
          s5 = peg$parseinapos();
        }
        if (s4 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 39) {
            s5 = peg$c44;
            peg$currPos++;
          } else {
            s5 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c45); }
          }
          if (s5 !== peg$FAILED) {
            peg$savedPos = s2;
            s3 = peg$c52(s4);
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = peg$currPos;
        s3 = peg$c2();
        if (s3) {
          s3 = void 0;
        } else {
          s3 = peg$FAILED;
        }
        if (s3 !== peg$FAILED) {
          s2 = [s2, s3];
          s1 = s2;
        } else {
          peg$currPos = s1;
          s1 = peg$FAILED;
        }
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c53(s1);
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        if (input.charCodeAt(peg$currPos) === 39) {
          s0 = peg$c44;
          peg$currPos++;
        } else {
          s0 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c45); }
        }
      }
    }

    return s0;
  }

  function peg$parsequotedFunctionParams() {
    var s0;

    s0 = peg$parsequotedCurly();
    if (s0 === peg$FAILED) {
      if (input.charCodeAt(peg$currPos) === 39) {
        s0 = peg$c44;
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c45); }
      }
    }

    return s0;
  }

  function peg$parsechar() {
    var s0, s1, s2, s3, s4, s5;

    s0 = peg$parsedoubleapos();
    if (s0 === peg$FAILED) {
      s0 = peg$parsequoted();
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 35) {
          s1 = peg$c0;
          peg$currPos++;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c1); }
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = peg$currPos;
          s2 = peg$c54(s1);
          if (s2) {
            s2 = void 0;
          } else {
            s2 = peg$FAILED;
          }
          if (s2 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c55(s1);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
          if (peg$c56.test(input.charAt(peg$currPos))) {
            s0 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c57); }
          }
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 2) === peg$c58) {
              s1 = peg$c58;
              peg$currPos += 2;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c59); }
            }
            if (s1 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c60();
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              if (input.substr(peg$currPos, 2) === peg$c61) {
                s1 = peg$c61;
                peg$currPos += 2;
              } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c62); }
              }
              if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c63();
              }
              s0 = s1;
              if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                if (input.substr(peg$currPos, 2) === peg$c64) {
                  s1 = peg$c64;
                  peg$currPos += 2;
                } else {
                  s1 = peg$FAILED;
                  if (peg$silentFails === 0) { peg$fail(peg$c65); }
                }
                if (s1 !== peg$FAILED) {
                  peg$savedPos = s0;
                  s1 = peg$c66();
                }
                s0 = s1;
                if (s0 === peg$FAILED) {
                  s0 = peg$currPos;
                  if (input.substr(peg$currPos, 2) === peg$c67) {
                    s1 = peg$c67;
                    peg$currPos += 2;
                  } else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$c68); }
                  }
                  if (s1 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c69();
                  }
                  s0 = s1;
                  if (s0 === peg$FAILED) {
                    s0 = peg$currPos;
                    if (input.substr(peg$currPos, 2) === peg$c70) {
                      s1 = peg$c70;
                      peg$currPos += 2;
                    } else {
                      s1 = peg$FAILED;
                      if (peg$silentFails === 0) { peg$fail(peg$c71); }
                    }
                    if (s1 !== peg$FAILED) {
                      s2 = peg$parsehexDigit();
                      if (s2 !== peg$FAILED) {
                        s3 = peg$parsehexDigit();
                        if (s3 !== peg$FAILED) {
                          s4 = peg$parsehexDigit();
                          if (s4 !== peg$FAILED) {
                            s5 = peg$parsehexDigit();
                            if (s5 !== peg$FAILED) {
                              peg$savedPos = s0;
                              s1 = peg$c72(s2, s3, s4, s5);
                              s0 = s1;
                            } else {
                              peg$currPos = s0;
                              s0 = peg$FAILED;
                            }
                          } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                          }
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    return s0;
  }

  function peg$parseparamcharsCommon() {
    var s0;

    s0 = peg$parsedoubleapos();
    if (s0 === peg$FAILED) {
      s0 = peg$parsequotedFunctionParams();
    }

    return s0;
  }

  function peg$parseparamcharsDefault() {
    var s0, s1, s2;

    s0 = peg$parseparamcharsCommon();
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = [];
      if (peg$c73.test(input.charAt(peg$currPos))) {
        s2 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c74); }
      }
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          if (peg$c73.test(input.charAt(peg$currPos))) {
            s2 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c74); }
          }
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c4(s1);
      }
      s0 = s1;
    }

    return s0;
  }

  function peg$parseparamcharsStrict() {
    var s0, s1, s2;

    s0 = peg$parseparamcharsCommon();
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = [];
      if (peg$c75.test(input.charAt(peg$currPos))) {
        s2 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c76); }
      }
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          if (peg$c75.test(input.charAt(peg$currPos))) {
            s2 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c76); }
          }
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c4(s1);
      }
      s0 = s1;
    }

    return s0;
  }

  function peg$parsedigits() {
    var s0, s1, s2;

    s0 = peg$currPos;
    s1 = [];
    if (peg$c77.test(input.charAt(peg$currPos))) {
      s2 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s2 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c78); }
    }
    if (s2 !== peg$FAILED) {
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        if (peg$c77.test(input.charAt(peg$currPos))) {
          s2 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c78); }
        }
      }
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      s0 = input.substring(s0, peg$currPos);
    } else {
      s0 = s1;
    }

    return s0;
  }

  function peg$parsehexDigit() {
    var s0;

    if (peg$c79.test(input.charAt(peg$currPos))) {
      s0 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c80); }
    }

    return s0;
  }

  function peg$parse_() {
    var s0, s1, s2;

    s0 = peg$currPos;
    s1 = [];
    if (peg$c81.test(input.charAt(peg$currPos))) {
      s2 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s2 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c82); }
    }
    while (s2 !== peg$FAILED) {
      s1.push(s2);
      if (peg$c81.test(input.charAt(peg$currPos))) {
        s2 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c82); }
      }
    }
    if (s1 !== peg$FAILED) {
      s0 = input.substring(s0, peg$currPos);
    } else {
      s0 = s1;
    }

    return s0;
  }


    var inPlural = false;
    var whitespaceChars = "[\u0009-\u000d \u0085\u200e\u200f\u2028\u2029]*";
    var whitespaceTrimRE = new RegExp("^" + whitespaceChars + "|" + whitespaceChars + "$", "g");


  peg$result = peg$startRuleFunction();

  if (peg$result !== peg$FAILED && peg$currPos === input.length) {
    return peg$result;
  } else {
    if (peg$result !== peg$FAILED && peg$currPos < input.length) {
      peg$fail(peg$endExpectation());
    }

    throw peg$buildStructuredError(
      peg$maxFailExpected,
      peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null,
      peg$maxFailPos < input.length
        ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
        : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)
    );
  }
}

module.exports = {
  SyntaxError: peg$SyntaxError,
  parse:       peg$parse
};


/***/ }),

/***/ "../node_modules/normalizr/dist/src/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.denormalize = exports.normalize = exports.schema = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _Entity = __webpack_require__("../node_modules/normalizr/dist/src/schemas/Entity.js");

var _Entity2 = _interopRequireDefault(_Entity);

var _Union = __webpack_require__("../node_modules/normalizr/dist/src/schemas/Union.js");

var _Union2 = _interopRequireDefault(_Union);

var _Values = __webpack_require__("../node_modules/normalizr/dist/src/schemas/Values.js");

var _Values2 = _interopRequireDefault(_Values);

var _Array = __webpack_require__("../node_modules/normalizr/dist/src/schemas/Array.js");

var ArrayUtils = _interopRequireWildcard(_Array);

var _Object = __webpack_require__("../node_modules/normalizr/dist/src/schemas/Object.js");

var ObjectUtils = _interopRequireWildcard(_Object);

var _ImmutableUtils = __webpack_require__("../node_modules/normalizr/dist/src/schemas/ImmutableUtils.js");

var ImmutableUtils = _interopRequireWildcard(_ImmutableUtils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var visit = function visit(value, parent, key, schema, addEntity) {
  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object' || !value) {
    return value;
  }

  if ((typeof schema === 'undefined' ? 'undefined' : _typeof(schema)) === 'object' && (!schema.normalize || typeof schema.normalize !== 'function')) {
    var method = Array.isArray(schema) ? ArrayUtils.normalize : ObjectUtils.normalize;
    return method(schema, value, parent, key, visit, addEntity);
  }

  return schema.normalize(value, parent, key, visit, addEntity);
};

var addEntities = function addEntities(entities) {
  return function (schema, processedEntity, value, parent, key) {
    var schemaKey = schema.key;
    var id = schema.getId(value, parent, key);
    if (!(schemaKey in entities)) {
      entities[schemaKey] = {};
    }

    var existingEntity = entities[schemaKey][id];
    if (existingEntity) {
      entities[schemaKey][id] = schema.merge(existingEntity, processedEntity);
    } else {
      entities[schemaKey][id] = processedEntity;
    }
  };
};

var schema = exports.schema = {
  Array: ArrayUtils.default,
  Entity: _Entity2.default,
  Object: ObjectUtils.default,
  Union: _Union2.default,
  Values: _Values2.default
};

var normalize = exports.normalize = function normalize(input, schema) {
  if (!input || (typeof input === 'undefined' ? 'undefined' : _typeof(input)) !== 'object') {
    throw new Error('Unexpected input given to normalize. Expected type to be "object", found "' + (typeof input === 'undefined' ? 'undefined' : _typeof(input)) + '".');
  }

  var entities = {};
  var addEntity = addEntities(entities);

  var result = visit(input, input, null, schema, addEntity);
  return { entities: entities, result: result };
};

var unvisitEntity = function unvisitEntity(id, schema, unvisit, getEntity, cache) {
  var entity = getEntity(id, schema);
  if ((typeof entity === 'undefined' ? 'undefined' : _typeof(entity)) !== 'object' || entity === null) {
    return entity;
  }

  if (!cache[schema.key]) {
    cache[schema.key] = {};
  }

  if (!cache[schema.key][id]) {
    // Ensure we don't mutate it non-immutable objects
    var entityCopy = ImmutableUtils.isImmutable(entity) ? entity : _extends({}, entity);

    // Need to set this first so that if it is referenced further within the
    // denormalization the reference will already exist.
    cache[schema.key][id] = entityCopy;
    cache[schema.key][id] = schema.denormalize(entityCopy, unvisit);
  }

  return cache[schema.key][id];
};

var getUnvisit = function getUnvisit(entities) {
  var cache = {};
  var getEntity = getEntities(entities);

  return function unvisit(input, schema) {
    if ((typeof schema === 'undefined' ? 'undefined' : _typeof(schema)) === 'object' && (!schema.denormalize || typeof schema.denormalize !== 'function')) {
      var method = Array.isArray(schema) ? ArrayUtils.denormalize : ObjectUtils.denormalize;
      return method(schema, input, unvisit);
    }

    if (input === undefined || input === null) {
      return input;
    }

    if (schema instanceof _Entity2.default) {
      return unvisitEntity(input, schema, unvisit, getEntity, cache);
    }

    return schema.denormalize(input, unvisit);
  };
};

var getEntities = function getEntities(entities) {
  var isImmutable = ImmutableUtils.isImmutable(entities);

  return function (entityOrId, schema) {
    var schemaKey = schema.key;

    if ((typeof entityOrId === 'undefined' ? 'undefined' : _typeof(entityOrId)) === 'object') {
      return entityOrId;
    }

    return isImmutable ? entities.getIn([schemaKey, entityOrId.toString()]) : entities[schemaKey][entityOrId];
  };
};

var denormalize = exports.denormalize = function denormalize(input, schema, entities) {
  if (typeof input !== 'undefined') {
    return getUnvisit(entities)(input, schema);
  }
};

/***/ }),

/***/ "../node_modules/normalizr/dist/src/schemas/Array.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.denormalize = exports.normalize = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Polymorphic = __webpack_require__("../node_modules/normalizr/dist/src/schemas/Polymorphic.js");

var _Polymorphic2 = _interopRequireDefault(_Polymorphic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var validateSchema = function validateSchema(definition) {
  var isArray = Array.isArray(definition);
  if (isArray && definition.length > 1) {
    throw new Error('Expected schema definition to be a single schema, but found ' + definition.length + '.');
  }

  return definition[0];
};

var getValues = function getValues(input) {
  return Array.isArray(input) ? input : Object.keys(input).map(function (key) {
    return input[key];
  });
};

var normalize = exports.normalize = function normalize(schema, input, parent, key, visit, addEntity) {
  schema = validateSchema(schema);

  var values = getValues(input);

  // Special case: Arrays pass *their* parent on to their children, since there
  // is not any special information that can be gathered from themselves directly
  return values.map(function (value, index) {
    return visit(value, parent, key, schema, addEntity);
  });
};

var denormalize = exports.denormalize = function denormalize(schema, input, unvisit) {
  schema = validateSchema(schema);
  return input && input.map ? input.map(function (entityOrId) {
    return unvisit(entityOrId, schema);
  }) : input;
};

var ArraySchema = function (_PolymorphicSchema) {
  _inherits(ArraySchema, _PolymorphicSchema);

  function ArraySchema() {
    _classCallCheck(this, ArraySchema);

    return _possibleConstructorReturn(this, (ArraySchema.__proto__ || Object.getPrototypeOf(ArraySchema)).apply(this, arguments));
  }

  _createClass(ArraySchema, [{
    key: 'normalize',
    value: function normalize(input, parent, key, visit, addEntity) {
      var _this2 = this;

      var values = getValues(input);

      return values.map(function (value, index) {
        return _this2.normalizeValue(value, parent, key, visit, addEntity);
      }).filter(function (value) {
        return value !== undefined && value !== null;
      });
    }
  }, {
    key: 'denormalize',
    value: function denormalize(input, unvisit) {
      var _this3 = this;

      return input && input.map ? input.map(function (value) {
        return _this3.denormalizeValue(value, unvisit);
      }) : input;
    }
  }]);

  return ArraySchema;
}(_Polymorphic2.default);

exports.default = ArraySchema;

/***/ }),

/***/ "../node_modules/normalizr/dist/src/schemas/Entity.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ImmutableUtils = __webpack_require__("../node_modules/normalizr/dist/src/schemas/ImmutableUtils.js");

var ImmutableUtils = _interopRequireWildcard(_ImmutableUtils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var getDefaultGetId = function getDefaultGetId(idAttribute) {
  return function (input) {
    return ImmutableUtils.isImmutable(input) ? input.get(idAttribute) : input[idAttribute];
  };
};

var EntitySchema = function () {
  function EntitySchema(key) {
    var definition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, EntitySchema);

    if (!key || typeof key !== 'string') {
      throw new Error('Expected a string key for Entity, but found ' + key + '.');
    }

    var _options$idAttribute = options.idAttribute,
        idAttribute = _options$idAttribute === undefined ? 'id' : _options$idAttribute,
        _options$mergeStrateg = options.mergeStrategy,
        mergeStrategy = _options$mergeStrateg === undefined ? function (entityA, entityB) {
      return _extends({}, entityA, entityB);
    } : _options$mergeStrateg,
        _options$processStrat = options.processStrategy,
        processStrategy = _options$processStrat === undefined ? function (input) {
      return _extends({}, input);
    } : _options$processStrat;


    this._key = key;
    this._getId = typeof idAttribute === 'function' ? idAttribute : getDefaultGetId(idAttribute);
    this._idAttribute = idAttribute;
    this._mergeStrategy = mergeStrategy;
    this._processStrategy = processStrategy;
    this.define(definition);
  }

  _createClass(EntitySchema, [{
    key: 'define',
    value: function define(definition) {
      this.schema = Object.keys(definition).reduce(function (entitySchema, key) {
        var schema = definition[key];
        return _extends({}, entitySchema, _defineProperty({}, key, schema));
      }, this.schema || {});
    }
  }, {
    key: 'getId',
    value: function getId(input, parent, key) {
      return this._getId(input, parent, key);
    }
  }, {
    key: 'merge',
    value: function merge(entityA, entityB) {
      return this._mergeStrategy(entityA, entityB);
    }
  }, {
    key: 'normalize',
    value: function normalize(input, parent, key, visit, addEntity) {
      var _this = this;

      var processedEntity = this._processStrategy(input, parent, key);
      Object.keys(this.schema).forEach(function (key) {
        if (processedEntity.hasOwnProperty(key) && _typeof(processedEntity[key]) === 'object') {
          var schema = _this.schema[key];
          processedEntity[key] = visit(processedEntity[key], processedEntity, key, schema, addEntity);
        }
      });

      addEntity(this, processedEntity, input, parent, key);
      return this.getId(input, parent, key);
    }
  }, {
    key: 'denormalize',
    value: function denormalize(entity, unvisit) {
      var _this2 = this;

      if (ImmutableUtils.isImmutable(entity)) {
        return ImmutableUtils.denormalizeImmutable(this.schema, entity, unvisit);
      }

      Object.keys(this.schema).forEach(function (key) {
        if (entity.hasOwnProperty(key)) {
          var schema = _this2.schema[key];
          entity[key] = unvisit(entity[key], schema);
        }
      });
      return entity;
    }
  }, {
    key: 'key',
    get: function get() {
      return this._key;
    }
  }, {
    key: 'idAttribute',
    get: function get() {
      return this._idAttribute;
    }
  }]);

  return EntitySchema;
}();

exports.default = EntitySchema;

/***/ }),

/***/ "../node_modules/normalizr/dist/src/schemas/ImmutableUtils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isImmutable = isImmutable;
exports.denormalizeImmutable = denormalizeImmutable;
/**
 * Helpers to enable Immutable compatibility *without* bringing in
 * the 'immutable' package as a dependency.
 */

/**
 * Check if an object is immutable by checking if it has a key specific
 * to the immutable library.
 *
 * @param  {any} object
 * @return {bool}
 */
function isImmutable(object) {
  return !!(object && typeof object.hasOwnProperty === 'function' && (object.hasOwnProperty('__ownerID') || // Immutable.Map
  object._map && object._map.hasOwnProperty('__ownerID') // Immutable.Record
  ));
}

/**
 * Denormalize an immutable entity.
 *
 * @param  {Schema} schema
 * @param  {Immutable.Map|Immutable.Record} input
 * @param  {function} unvisit
 * @param  {function} getDenormalizedEntity
 * @return {Immutable.Map|Immutable.Record}
 */
function denormalizeImmutable(schema, input, unvisit) {
  return Object.keys(schema).reduce(function (object, key) {
    // Immutable maps cast keys to strings on write so we need to ensure
    // we're accessing them using string keys.
    var stringKey = '' + key;

    if (object.has(stringKey)) {
      return object.set(stringKey, unvisit(object.get(stringKey), schema[stringKey]));
    } else {
      return object;
    }
  }, input);
}

/***/ }),

/***/ "../node_modules/normalizr/dist/src/schemas/Object.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.denormalize = exports.normalize = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _ImmutableUtils = __webpack_require__("../node_modules/normalizr/dist/src/schemas/ImmutableUtils.js");

var ImmutableUtils = _interopRequireWildcard(_ImmutableUtils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _normalize = function _normalize(schema, input, parent, key, visit, addEntity) {
  var object = _extends({}, input);
  Object.keys(schema).forEach(function (key) {
    var localSchema = schema[key];
    var value = visit(input[key], input, key, localSchema, addEntity);
    if (value === undefined || value === null) {
      delete object[key];
    } else {
      object[key] = value;
    }
  });
  return object;
};

exports.normalize = _normalize;
var _denormalize = function _denormalize(schema, input, unvisit) {
  if (ImmutableUtils.isImmutable(input)) {
    return ImmutableUtils.denormalizeImmutable(schema, input, unvisit);
  }

  var object = _extends({}, input);
  Object.keys(schema).forEach(function (key) {
    if (object[key]) {
      object[key] = unvisit(object[key], schema[key]);
    }
  });
  return object;
};

exports.denormalize = _denormalize;

var ObjectSchema = function () {
  function ObjectSchema(definition) {
    _classCallCheck(this, ObjectSchema);

    this.define(definition);
  }

  _createClass(ObjectSchema, [{
    key: 'define',
    value: function define(definition) {
      this.schema = Object.keys(definition).reduce(function (entitySchema, key) {
        var schema = definition[key];
        return _extends({}, entitySchema, _defineProperty({}, key, schema));
      }, this.schema || {});
    }
  }, {
    key: 'normalize',
    value: function normalize() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _normalize.apply(undefined, [this.schema].concat(args));
    }
  }, {
    key: 'denormalize',
    value: function denormalize() {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _denormalize.apply(undefined, [this.schema].concat(args));
    }
  }]);

  return ObjectSchema;
}();

exports.default = ObjectSchema;

/***/ }),

/***/ "../node_modules/normalizr/dist/src/schemas/Polymorphic.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ImmutableUtils = __webpack_require__("../node_modules/normalizr/dist/src/schemas/ImmutableUtils.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PolymorphicSchema = function () {
  function PolymorphicSchema(definition, schemaAttribute) {
    _classCallCheck(this, PolymorphicSchema);

    if (schemaAttribute) {
      this._schemaAttribute = typeof schemaAttribute === 'string' ? function (input) {
        return input[schemaAttribute];
      } : schemaAttribute;
    }
    this.define(definition);
  }

  _createClass(PolymorphicSchema, [{
    key: 'define',
    value: function define(definition) {
      this.schema = definition;
    }
  }, {
    key: 'getSchemaAttribute',
    value: function getSchemaAttribute(input, parent, key) {
      return !this.isSingleSchema && this._schemaAttribute(input, parent, key);
    }
  }, {
    key: 'inferSchema',
    value: function inferSchema(input, parent, key) {
      if (this.isSingleSchema) {
        return this.schema;
      }

      var attr = this.getSchemaAttribute(input, parent, key);
      return this.schema[attr];
    }
  }, {
    key: 'normalizeValue',
    value: function normalizeValue(value, parent, key, visit, addEntity) {
      var schema = this.inferSchema(value, parent, key);
      if (!schema) {
        return value;
      }
      var normalizedValue = visit(value, parent, key, schema, addEntity);
      return this.isSingleSchema || normalizedValue === undefined || normalizedValue === null ? normalizedValue : { id: normalizedValue, schema: this.getSchemaAttribute(value, parent, key) };
    }
  }, {
    key: 'denormalizeValue',
    value: function denormalizeValue(value, unvisit) {
      var schemaKey = (0, _ImmutableUtils.isImmutable)(value) ? value.get('schema') : value.schema;
      if (!this.isSingleSchema && !schemaKey) {
        return value;
      }
      var id = (0, _ImmutableUtils.isImmutable)(value) ? value.get('id') : value.id;
      var schema = this.isSingleSchema ? this.schema : this.schema[schemaKey];
      return unvisit(id || value, schema);
    }
  }, {
    key: 'isSingleSchema',
    get: function get() {
      return !this._schemaAttribute;
    }
  }]);

  return PolymorphicSchema;
}();

exports.default = PolymorphicSchema;

/***/ }),

/***/ "../node_modules/normalizr/dist/src/schemas/Union.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Polymorphic = __webpack_require__("../node_modules/normalizr/dist/src/schemas/Polymorphic.js");

var _Polymorphic2 = _interopRequireDefault(_Polymorphic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UnionSchema = function (_PolymorphicSchema) {
  _inherits(UnionSchema, _PolymorphicSchema);

  function UnionSchema(definition, schemaAttribute) {
    _classCallCheck(this, UnionSchema);

    if (!schemaAttribute) {
      throw new Error('Expected option "schemaAttribute" not found on UnionSchema.');
    }
    return _possibleConstructorReturn(this, (UnionSchema.__proto__ || Object.getPrototypeOf(UnionSchema)).call(this, definition, schemaAttribute));
  }

  _createClass(UnionSchema, [{
    key: 'normalize',
    value: function normalize(input, parent, key, visit, addEntity) {
      return this.normalizeValue(input, parent, key, visit, addEntity);
    }
  }, {
    key: 'denormalize',
    value: function denormalize(input, unvisit) {
      return this.denormalizeValue(input, unvisit);
    }
  }]);

  return UnionSchema;
}(_Polymorphic2.default);

exports.default = UnionSchema;

/***/ }),

/***/ "../node_modules/normalizr/dist/src/schemas/Values.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Polymorphic = __webpack_require__("../node_modules/normalizr/dist/src/schemas/Polymorphic.js");

var _Polymorphic2 = _interopRequireDefault(_Polymorphic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ValuesSchema = function (_PolymorphicSchema) {
  _inherits(ValuesSchema, _PolymorphicSchema);

  function ValuesSchema() {
    _classCallCheck(this, ValuesSchema);

    return _possibleConstructorReturn(this, (ValuesSchema.__proto__ || Object.getPrototypeOf(ValuesSchema)).apply(this, arguments));
  }

  _createClass(ValuesSchema, [{
    key: 'normalize',
    value: function normalize(input, parent, key, visit, addEntity) {
      var _this2 = this;

      return Object.keys(input).reduce(function (output, key, index) {
        var value = input[key];
        return value !== undefined && value !== null ? _extends({}, output, _defineProperty({}, key, _this2.normalizeValue(value, input, key, visit, addEntity))) : output;
      }, {});
    }
  }, {
    key: 'denormalize',
    value: function denormalize(input, unvisit) {
      var _this3 = this;

      return Object.keys(input).reduce(function (output, key) {
        var entityOrId = input[key];
        return _extends({}, output, _defineProperty({}, key, _this3.denormalizeValue(entityOrId, unvisit)));
      }, {});
    }
  }]);

  return ValuesSchema;
}(_Polymorphic2.default);

exports.default = ValuesSchema;

/***/ }),

/***/ "../node_modules/numeral/numeral.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! @preserve
 * numeral.js
 * version : 2.0.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        module.exports = factory();
    } else {
        global.numeral = factory();
    }
}(this, function () {
    /************************************
        Variables
    ************************************/

    var numeral,
        _,
        VERSION = '2.0.6',
        formats = {},
        locales = {},
        defaults = {
            currentLocale: 'en',
            zeroFormat: null,
            nullFormat: null,
            defaultFormat: '0,0',
            scalePercentBy100: true
        },
        options = {
            currentLocale: defaults.currentLocale,
            zeroFormat: defaults.zeroFormat,
            nullFormat: defaults.nullFormat,
            defaultFormat: defaults.defaultFormat,
            scalePercentBy100: defaults.scalePercentBy100
        };


    /************************************
        Constructors
    ************************************/

    // Numeral prototype object
    function Numeral(input, number) {
        this._input = input;

        this._value = number;
    }

    numeral = function(input) {
        var value,
            kind,
            unformatFunction,
            regexp;

        if (numeral.isNumeral(input)) {
            value = input.value();
        } else if (input === 0 || typeof input === 'undefined') {
            value = 0;
        } else if (input === null || _.isNaN(input)) {
            value = null;
        } else if (typeof input === 'string') {
            if (options.zeroFormat && input === options.zeroFormat) {
                value = 0;
            } else if (options.nullFormat && input === options.nullFormat || !input.replace(/[^0-9]+/g, '').length) {
                value = null;
            } else {
                for (kind in formats) {
                    regexp = typeof formats[kind].regexps.unformat === 'function' ? formats[kind].regexps.unformat() : formats[kind].regexps.unformat;

                    if (regexp && input.match(regexp)) {
                        unformatFunction = formats[kind].unformat;

                        break;
                    }
                }

                unformatFunction = unformatFunction || numeral._.stringToNumber;

                value = unformatFunction(input);
            }
        } else {
            value = Number(input)|| null;
        }

        return new Numeral(input, value);
    };

    // version number
    numeral.version = VERSION;

    // compare numeral object
    numeral.isNumeral = function(obj) {
        return obj instanceof Numeral;
    };

    // helper functions
    numeral._ = _ = {
        // formats numbers separators, decimals places, signs, abbreviations
        numberToFormat: function(value, format, roundingFunction) {
            var locale = locales[numeral.options.currentLocale],
                negP = false,
                optDec = false,
                leadingCount = 0,
                abbr = '',
                trillion = 1000000000000,
                billion = 1000000000,
                million = 1000000,
                thousand = 1000,
                decimal = '',
                neg = false,
                abbrForce, // force abbreviation
                abs,
                min,
                max,
                power,
                int,
                precision,
                signed,
                thousands,
                output;

            // make sure we never format a null value
            value = value || 0;

            abs = Math.abs(value);

            // see if we should use parentheses for negative number or if we should prefix with a sign
            // if both are present we default to parentheses
            if (numeral._.includes(format, '(')) {
                negP = true;
                format = format.replace(/[\(|\)]/g, '');
            } else if (numeral._.includes(format, '+') || numeral._.includes(format, '-')) {
                signed = numeral._.includes(format, '+') ? format.indexOf('+') : value < 0 ? format.indexOf('-') : -1;
                format = format.replace(/[\+|\-]/g, '');
            }

            // see if abbreviation is wanted
            if (numeral._.includes(format, 'a')) {
                abbrForce = format.match(/a(k|m|b|t)?/);

                abbrForce = abbrForce ? abbrForce[1] : false;

                // check for space before abbreviation
                if (numeral._.includes(format, ' a')) {
                    abbr = ' ';
                }

                format = format.replace(new RegExp(abbr + 'a[kmbt]?'), '');

                if (abs >= trillion && !abbrForce || abbrForce === 't') {
                    // trillion
                    abbr += locale.abbreviations.trillion;
                    value = value / trillion;
                } else if (abs < trillion && abs >= billion && !abbrForce || abbrForce === 'b') {
                    // billion
                    abbr += locale.abbreviations.billion;
                    value = value / billion;
                } else if (abs < billion && abs >= million && !abbrForce || abbrForce === 'm') {
                    // million
                    abbr += locale.abbreviations.million;
                    value = value / million;
                } else if (abs < million && abs >= thousand && !abbrForce || abbrForce === 'k') {
                    // thousand
                    abbr += locale.abbreviations.thousand;
                    value = value / thousand;
                }
            }

            // check for optional decimals
            if (numeral._.includes(format, '[.]')) {
                optDec = true;
                format = format.replace('[.]', '.');
            }

            // break number and format
            int = value.toString().split('.')[0];
            precision = format.split('.')[1];
            thousands = format.indexOf(',');
            leadingCount = (format.split('.')[0].split(',')[0].match(/0/g) || []).length;

            if (precision) {
                if (numeral._.includes(precision, '[')) {
                    precision = precision.replace(']', '');
                    precision = precision.split('[');
                    decimal = numeral._.toFixed(value, (precision[0].length + precision[1].length), roundingFunction, precision[1].length);
                } else {
                    decimal = numeral._.toFixed(value, precision.length, roundingFunction);
                }

                int = decimal.split('.')[0];

                if (numeral._.includes(decimal, '.')) {
                    decimal = locale.delimiters.decimal + decimal.split('.')[1];
                } else {
                    decimal = '';
                }

                if (optDec && Number(decimal.slice(1)) === 0) {
                    decimal = '';
                }
            } else {
                int = numeral._.toFixed(value, 0, roundingFunction);
            }

            // check abbreviation again after rounding
            if (abbr && !abbrForce && Number(int) >= 1000 && abbr !== locale.abbreviations.trillion) {
                int = String(Number(int) / 1000);

                switch (abbr) {
                    case locale.abbreviations.thousand:
                        abbr = locale.abbreviations.million;
                        break;
                    case locale.abbreviations.million:
                        abbr = locale.abbreviations.billion;
                        break;
                    case locale.abbreviations.billion:
                        abbr = locale.abbreviations.trillion;
                        break;
                }
            }


            // format number
            if (numeral._.includes(int, '-')) {
                int = int.slice(1);
                neg = true;
            }

            if (int.length < leadingCount) {
                for (var i = leadingCount - int.length; i > 0; i--) {
                    int = '0' + int;
                }
            }

            if (thousands > -1) {
                int = int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + locale.delimiters.thousands);
            }

            if (format.indexOf('.') === 0) {
                int = '';
            }

            output = int + decimal + (abbr ? abbr : '');

            if (negP) {
                output = (negP && neg ? '(' : '') + output + (negP && neg ? ')' : '');
            } else {
                if (signed >= 0) {
                    output = signed === 0 ? (neg ? '-' : '+') + output : output + (neg ? '-' : '+');
                } else if (neg) {
                    output = '-' + output;
                }
            }

            return output;
        },
        // unformats numbers separators, decimals places, signs, abbreviations
        stringToNumber: function(string) {
            var locale = locales[options.currentLocale],
                stringOriginal = string,
                abbreviations = {
                    thousand: 3,
                    million: 6,
                    billion: 9,
                    trillion: 12
                },
                abbreviation,
                value,
                i,
                regexp;

            if (options.zeroFormat && string === options.zeroFormat) {
                value = 0;
            } else if (options.nullFormat && string === options.nullFormat || !string.replace(/[^0-9]+/g, '').length) {
                value = null;
            } else {
                value = 1;

                if (locale.delimiters.decimal !== '.') {
                    string = string.replace(/\./g, '').replace(locale.delimiters.decimal, '.');
                }

                for (abbreviation in abbreviations) {
                    regexp = new RegExp('[^a-zA-Z]' + locale.abbreviations[abbreviation] + '(?:\\)|(\\' + locale.currency.symbol + ')?(?:\\))?)?$');

                    if (stringOriginal.match(regexp)) {
                        value *= Math.pow(10, abbreviations[abbreviation]);
                        break;
                    }
                }

                // check for negative number
                value *= (string.split('-').length + Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2 ? 1 : -1;

                // remove non numbers
                string = string.replace(/[^0-9\.]+/g, '');

                value *= Number(string);
            }

            return value;
        },
        isNaN: function(value) {
            return typeof value === 'number' && isNaN(value);
        },
        includes: function(string, search) {
            return string.indexOf(search) !== -1;
        },
        insert: function(string, subString, start) {
            return string.slice(0, start) + subString + string.slice(start);
        },
        reduce: function(array, callback /*, initialValue*/) {
            if (this === null) {
                throw new TypeError('Array.prototype.reduce called on null or undefined');
            }

            if (typeof callback !== 'function') {
                throw new TypeError(callback + ' is not a function');
            }

            var t = Object(array),
                len = t.length >>> 0,
                k = 0,
                value;

            if (arguments.length === 3) {
                value = arguments[2];
            } else {
                while (k < len && !(k in t)) {
                    k++;
                }

                if (k >= len) {
                    throw new TypeError('Reduce of empty array with no initial value');
                }

                value = t[k++];
            }
            for (; k < len; k++) {
                if (k in t) {
                    value = callback(value, t[k], k, t);
                }
            }
            return value;
        },
        /**
         * Computes the multiplier necessary to make x >= 1,
         * effectively eliminating miscalculations caused by
         * finite precision.
         */
        multiplier: function (x) {
            var parts = x.toString().split('.');

            return parts.length < 2 ? 1 : Math.pow(10, parts[1].length);
        },
        /**
         * Given a variable number of arguments, returns the maximum
         * multiplier that must be used to normalize an operation involving
         * all of them.
         */
        correctionFactor: function () {
            var args = Array.prototype.slice.call(arguments);

            return args.reduce(function(accum, next) {
                var mn = _.multiplier(next);
                return accum > mn ? accum : mn;
            }, 1);
        },
        /**
         * Implementation of toFixed() that treats floats more like decimals
         *
         * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
         * problems for accounting- and finance-related software.
         */
        toFixed: function(value, maxDecimals, roundingFunction, optionals) {
            var splitValue = value.toString().split('.'),
                minDecimals = maxDecimals - (optionals || 0),
                boundedPrecision,
                optionalsRegExp,
                power,
                output;

            // Use the smallest precision value possible to avoid errors from floating point representation
            if (splitValue.length === 2) {
              boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
            } else {
              boundedPrecision = minDecimals;
            }

            power = Math.pow(10, boundedPrecision);

            // Multiply up by precision, round accurately, then divide and use native toFixed():
            output = (roundingFunction(value + 'e+' + boundedPrecision) / power).toFixed(boundedPrecision);

            if (optionals > maxDecimals - boundedPrecision) {
                optionalsRegExp = new RegExp('\\.?0{1,' + (optionals - (maxDecimals - boundedPrecision)) + '}$');
                output = output.replace(optionalsRegExp, '');
            }

            return output;
        }
    };

    // avaliable options
    numeral.options = options;

    // avaliable formats
    numeral.formats = formats;

    // avaliable formats
    numeral.locales = locales;

    // This function sets the current locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    numeral.locale = function(key) {
        if (key) {
            options.currentLocale = key.toLowerCase();
        }

        return options.currentLocale;
    };

    // This function provides access to the loaded locale data.  If
    // no arguments are passed in, it will simply return the current
    // global locale object.
    numeral.localeData = function(key) {
        if (!key) {
            return locales[options.currentLocale];
        }

        key = key.toLowerCase();

        if (!locales[key]) {
            throw new Error('Unknown locale : ' + key);
        }

        return locales[key];
    };

    numeral.reset = function() {
        for (var property in defaults) {
            options[property] = defaults[property];
        }
    };

    numeral.zeroFormat = function(format) {
        options.zeroFormat = typeof(format) === 'string' ? format : null;
    };

    numeral.nullFormat = function (format) {
        options.nullFormat = typeof(format) === 'string' ? format : null;
    };

    numeral.defaultFormat = function(format) {
        options.defaultFormat = typeof(format) === 'string' ? format : '0.0';
    };

    numeral.register = function(type, name, format) {
        name = name.toLowerCase();

        if (this[type + 's'][name]) {
            throw new TypeError(name + ' ' + type + ' already registered.');
        }

        this[type + 's'][name] = format;

        return format;
    };


    numeral.validate = function(val, culture) {
        var _decimalSep,
            _thousandSep,
            _currSymbol,
            _valArray,
            _abbrObj,
            _thousandRegEx,
            localeData,
            temp;

        //coerce val to string
        if (typeof val !== 'string') {
            val += '';

            if (console.warn) {
                console.warn('Numeral.js: Value is not string. It has been co-erced to: ', val);
            }
        }

        //trim whitespaces from either sides
        val = val.trim();

        //if val is just digits return true
        if (!!val.match(/^\d+$/)) {
            return true;
        }

        //if val is empty return false
        if (val === '') {
            return false;
        }

        //get the decimal and thousands separator from numeral.localeData
        try {
            //check if the culture is understood by numeral. if not, default it to current locale
            localeData = numeral.localeData(culture);
        } catch (e) {
            localeData = numeral.localeData(numeral.locale());
        }

        //setup the delimiters and currency symbol based on culture/locale
        _currSymbol = localeData.currency.symbol;
        _abbrObj = localeData.abbreviations;
        _decimalSep = localeData.delimiters.decimal;
        if (localeData.delimiters.thousands === '.') {
            _thousandSep = '\\.';
        } else {
            _thousandSep = localeData.delimiters.thousands;
        }

        // validating currency symbol
        temp = val.match(/^[^\d]+/);
        if (temp !== null) {
            val = val.substr(1);
            if (temp[0] !== _currSymbol) {
                return false;
            }
        }

        //validating abbreviation symbol
        temp = val.match(/[^\d]+$/);
        if (temp !== null) {
            val = val.slice(0, -1);
            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) {
                return false;
            }
        }

        _thousandRegEx = new RegExp(_thousandSep + '{2}');

        if (!val.match(/[^\d.,]/g)) {
            _valArray = val.split(_decimalSep);
            if (_valArray.length > 2) {
                return false;
            } else {
                if (_valArray.length < 2) {
                    return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx));
                } else {
                    if (_valArray[0].length === 1) {
                        return ( !! _valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
                    } else {
                        return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
                    }
                }
            }
        }

        return false;
    };


    /************************************
        Numeral Prototype
    ************************************/

    numeral.fn = Numeral.prototype = {
        clone: function() {
            return numeral(this);
        },
        format: function(inputString, roundingFunction) {
            var value = this._value,
                format = inputString || options.defaultFormat,
                kind,
                output,
                formatFunction;

            // make sure we have a roundingFunction
            roundingFunction = roundingFunction || Math.round;

            // format based on value
            if (value === 0 && options.zeroFormat !== null) {
                output = options.zeroFormat;
            } else if (value === null && options.nullFormat !== null) {
                output = options.nullFormat;
            } else {
                for (kind in formats) {
                    if (format.match(formats[kind].regexps.format)) {
                        formatFunction = formats[kind].format;

                        break;
                    }
                }

                formatFunction = formatFunction || numeral._.numberToFormat;

                output = formatFunction(value, format, roundingFunction);
            }

            return output;
        },
        value: function() {
            return this._value;
        },
        input: function() {
            return this._input;
        },
        set: function(value) {
            this._value = Number(value);

            return this;
        },
        add: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);

            function cback(accum, curr, currI, O) {
                return accum + Math.round(corrFactor * curr);
            }

            this._value = _.reduce([this._value, value], cback, 0) / corrFactor;

            return this;
        },
        subtract: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);

            function cback(accum, curr, currI, O) {
                return accum - Math.round(corrFactor * curr);
            }

            this._value = _.reduce([value], cback, Math.round(this._value * corrFactor)) / corrFactor;

            return this;
        },
        multiply: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) * Math.round(curr * corrFactor) / Math.round(corrFactor * corrFactor);
            }

            this._value = _.reduce([this._value, value], cback, 1);

            return this;
        },
        divide: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) / Math.round(curr * corrFactor);
            }

            this._value = _.reduce([this._value, value], cback);

            return this;
        },
        difference: function(value) {
            return Math.abs(numeral(this._value).subtract(value).value());
        }
    };

    /************************************
        Default Locale && Format
    ************************************/

    numeral.register('locale', 'en', {
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function(number) {
            var b = number % 10;
            return (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
        },
        currency: {
            symbol: '$'
        }
    });

    

(function() {
        numeral.register('format', 'bps', {
            regexps: {
                format: /(BPS)/,
                unformat: /(BPS)/
            },
            format: function(value, format, roundingFunction) {
                var space = numeral._.includes(format, ' BPS') ? ' ' : '',
                    output;

                value = value * 10000;

                // check for space before BPS
                format = format.replace(/\s?BPS/, '');

                output = numeral._.numberToFormat(value, format, roundingFunction);

                if (numeral._.includes(output, ')')) {
                    output = output.split('');

                    output.splice(-1, 0, space + 'BPS');

                    output = output.join('');
                } else {
                    output = output + space + 'BPS';
                }

                return output;
            },
            unformat: function(string) {
                return +(numeral._.stringToNumber(string) * 0.0001).toFixed(15);
            }
        });
})();


(function() {
        var decimal = {
            base: 1000,
            suffixes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        },
        binary = {
            base: 1024,
            suffixes: ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
        };

    var allSuffixes =  decimal.suffixes.concat(binary.suffixes.filter(function (item) {
            return decimal.suffixes.indexOf(item) < 0;
        }));
        var unformatRegex = allSuffixes.join('|');
        // Allow support for BPS (http://www.investopedia.com/terms/b/basispoint.asp)
        unformatRegex = '(' + unformatRegex.replace('B', 'B(?!PS)') + ')';

    numeral.register('format', 'bytes', {
        regexps: {
            format: /([0\s]i?b)/,
            unformat: new RegExp(unformatRegex)
        },
        format: function(value, format, roundingFunction) {
            var output,
                bytes = numeral._.includes(format, 'ib') ? binary : decimal,
                suffix = numeral._.includes(format, ' b') || numeral._.includes(format, ' ib') ? ' ' : '',
                power,
                min,
                max;

            // check for space before
            format = format.replace(/\s?i?b/, '');

            for (power = 0; power <= bytes.suffixes.length; power++) {
                min = Math.pow(bytes.base, power);
                max = Math.pow(bytes.base, power + 1);

                if (value === null || value === 0 || value >= min && value < max) {
                    suffix += bytes.suffixes[power];

                    if (min > 0) {
                        value = value / min;
                    }

                    break;
                }
            }

            output = numeral._.numberToFormat(value, format, roundingFunction);

            return output + suffix;
        },
        unformat: function(string) {
            var value = numeral._.stringToNumber(string),
                power,
                bytesMultiplier;

            if (value) {
                for (power = decimal.suffixes.length - 1; power >= 0; power--) {
                    if (numeral._.includes(string, decimal.suffixes[power])) {
                        bytesMultiplier = Math.pow(decimal.base, power);

                        break;
                    }

                    if (numeral._.includes(string, binary.suffixes[power])) {
                        bytesMultiplier = Math.pow(binary.base, power);

                        break;
                    }
                }

                value *= (bytesMultiplier || 1);
            }

            return value;
        }
    });
})();


(function() {
        numeral.register('format', 'currency', {
        regexps: {
            format: /(\$)/
        },
        format: function(value, format, roundingFunction) {
            var locale = numeral.locales[numeral.options.currentLocale],
                symbols = {
                    before: format.match(/^([\+|\-|\(|\s|\$]*)/)[0],
                    after: format.match(/([\+|\-|\)|\s|\$]*)$/)[0]
                },
                output,
                symbol,
                i;

            // strip format of spaces and $
            format = format.replace(/\s?\$\s?/, '');

            // format the number
            output = numeral._.numberToFormat(value, format, roundingFunction);

            // update the before and after based on value
            if (value >= 0) {
                symbols.before = symbols.before.replace(/[\-\(]/, '');
                symbols.after = symbols.after.replace(/[\-\)]/, '');
            } else if (value < 0 && (!numeral._.includes(symbols.before, '-') && !numeral._.includes(symbols.before, '('))) {
                symbols.before = '-' + symbols.before;
            }

            // loop through each before symbol
            for (i = 0; i < symbols.before.length; i++) {
                symbol = symbols.before[i];

                switch (symbol) {
                    case '$':
                        output = numeral._.insert(output, locale.currency.symbol, i);
                        break;
                    case ' ':
                        output = numeral._.insert(output, ' ', i + locale.currency.symbol.length - 1);
                        break;
                }
            }

            // loop through each after symbol
            for (i = symbols.after.length - 1; i >= 0; i--) {
                symbol = symbols.after[i];

                switch (symbol) {
                    case '$':
                        output = i === symbols.after.length - 1 ? output + locale.currency.symbol : numeral._.insert(output, locale.currency.symbol, -(symbols.after.length - (1 + i)));
                        break;
                    case ' ':
                        output = i === symbols.after.length - 1 ? output + ' ' : numeral._.insert(output, ' ', -(symbols.after.length - (1 + i) + locale.currency.symbol.length - 1));
                        break;
                }
            }


            return output;
        }
    });
})();


(function() {
        numeral.register('format', 'exponential', {
        regexps: {
            format: /(e\+|e-)/,
            unformat: /(e\+|e-)/
        },
        format: function(value, format, roundingFunction) {
            var output,
                exponential = typeof value === 'number' && !numeral._.isNaN(value) ? value.toExponential() : '0e+0',
                parts = exponential.split('e');

            format = format.replace(/e[\+|\-]{1}0/, '');

            output = numeral._.numberToFormat(Number(parts[0]), format, roundingFunction);

            return output + 'e' + parts[1];
        },
        unformat: function(string) {
            var parts = numeral._.includes(string, 'e+') ? string.split('e+') : string.split('e-'),
                value = Number(parts[0]),
                power = Number(parts[1]);

            power = numeral._.includes(string, 'e-') ? power *= -1 : power;

            function cback(accum, curr, currI, O) {
                var corrFactor = numeral._.correctionFactor(accum, curr),
                    num = (accum * corrFactor) * (curr * corrFactor) / (corrFactor * corrFactor);
                return num;
            }

            return numeral._.reduce([value, Math.pow(10, power)], cback, 1);
        }
    });
})();


(function() {
        numeral.register('format', 'ordinal', {
        regexps: {
            format: /(o)/
        },
        format: function(value, format, roundingFunction) {
            var locale = numeral.locales[numeral.options.currentLocale],
                output,
                ordinal = numeral._.includes(format, ' o') ? ' ' : '';

            // check for space before
            format = format.replace(/\s?o/, '');

            ordinal += locale.ordinal(value);

            output = numeral._.numberToFormat(value, format, roundingFunction);

            return output + ordinal;
        }
    });
})();


(function() {
        numeral.register('format', 'percentage', {
        regexps: {
            format: /(%)/,
            unformat: /(%)/
        },
        format: function(value, format, roundingFunction) {
            var space = numeral._.includes(format, ' %') ? ' ' : '',
                output;

            if (numeral.options.scalePercentBy100) {
                value = value * 100;
            }

            // check for space before %
            format = format.replace(/\s?\%/, '');

            output = numeral._.numberToFormat(value, format, roundingFunction);

            if (numeral._.includes(output, ')')) {
                output = output.split('');

                output.splice(-1, 0, space + '%');

                output = output.join('');
            } else {
                output = output + space + '%';
            }

            return output;
        },
        unformat: function(string) {
            var number = numeral._.stringToNumber(string);
            if (numeral.options.scalePercentBy100) {
                return number * 0.01;
            }
            return number;
        }
    });
})();


(function() {
        numeral.register('format', 'time', {
        regexps: {
            format: /(:)/,
            unformat: /(:)/
        },
        format: function(value, format, roundingFunction) {
            var hours = Math.floor(value / 60 / 60),
                minutes = Math.floor((value - (hours * 60 * 60)) / 60),
                seconds = Math.round(value - (hours * 60 * 60) - (minutes * 60));

            return hours + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
        },
        unformat: function(string) {
            var timeArray = string.split(':'),
                seconds = 0;

            // turn hours and minutes into seconds and add them all up
            if (timeArray.length === 3) {
                // hours
                seconds = seconds + (Number(timeArray[0]) * 60 * 60);
                // minutes
                seconds = seconds + (Number(timeArray[1]) * 60);
                // seconds
                seconds = seconds + Number(timeArray[2]);
            } else if (timeArray.length === 2) {
                // minutes
                seconds = seconds + (Number(timeArray[0]) * 60);
                // seconds
                seconds = seconds + Number(timeArray[1]);
            }
            return Number(seconds);
        }
    });
})();

return numeral;
}));


/***/ }),

/***/ "../node_modules/parse-domain/lib/parseDomain.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var urlParts = /^(https?:\/\/)?([^/]*@)?(.+?)(:\d{2,5})?([/?].*)?$/; // 1 = protocol, 2 = auth, 3 = domain, 4 = port, 5 = path
var knownTlds = __webpack_require__("../node_modules/parse-domain/lib/tld.js");
var dot = /\./g;

/**
 * Removes all unnecessary parts of the domain (e.g. protocol, auth, port, path, query)
 * and parses the remaining domain. The returned object contains the properties 'subdomain', 'domain' and 'tld'.
 *
 * Since the top-level domain is handled differently by every country, this function only
 * supports all tlds listed in lib/build/tld.txt.
 *
 * If the given url is not valid or isn't supported by the tld.txt, this function returns null.
 *
 * @param {string} url
 * @param {Object} [options]
 * @param {Array<string>|RegExp} [options.customTlds]
 * @param {boolean} [options.privateTlds]
 * @returns {Object|null}
 */
function parseDomain(url, options) {
    var urlSplit;
    var tld = null;
    var domain;
    var subdomain;

    if (!url || typeof url !== "string") {
        return null;
    }

    if (!options || typeof options !== "object") {
        options = Object.create(null);
    }
    if ("privateTlds" in options === false) {
        options.privateTlds = false;
    }

    // urlSplit can't be null because urlParts will always match at the third capture
    urlSplit = url.toLowerCase().match(urlParts);
    domain = urlSplit[3]; // domain will now be something like sub.domain.example.com

    // for potentially unrecognized tlds, try matching against custom tlds
    if (options.customTlds) {
        if (options.customTlds instanceof RegExp === false) {
            // build regexp from options.customTlds
            options.customTlds = new RegExp("\\.(" + options.customTlds.join("|") + ")$");
        }
        // try matching against a built regexp of custom tlds
        tld = domain.match(options.customTlds);
    }

    // If no custom tlds, check if tld is supported
    if (tld === null) {
        tld = domain.match(options.privateTlds ? knownTlds : knownTlds.icann);
    }

    if (tld === null) {
        return null;
    }

    tld = tld[0];

    // remove tld and split by dot
    urlSplit = domain.slice(0, -tld.length).split(dot);

    if (tld.charAt(0) === ".") {
        // removes the remaining dot, if present (added to handle localhost)
        tld = tld.slice(1);
    }
    domain = urlSplit.pop();
    subdomain = urlSplit.join(".");

    return {
        tld: tld,
        domain: domain,
        subdomain: subdomain
    };
}

module.exports = parseDomain;


/***/ }),

/***/ "../node_modules/parse-domain/lib/tld.js":
/***/ (function(module, exports) {

exports = module.exports = /\.(ac|com\.ac|edu\.ac|gov\.ac|net\.ac|mil\.ac|org\.ac|ad|nom\.ad|ae|co\.ae|net\.ae|org\.ae|sch\.ae|ac\.ae|gov\.ae|mil\.ae|aero|accident-investigation\.aero|accident-prevention\.aero|aerobatic\.aero|aeroclub\.aero|aerodrome\.aero|agents\.aero|aircraft\.aero|airline\.aero|airport\.aero|air-surveillance\.aero|airtraffic\.aero|air-traffic-control\.aero|ambulance\.aero|amusement\.aero|association\.aero|author\.aero|ballooning\.aero|broker\.aero|caa\.aero|cargo\.aero|catering\.aero|certification\.aero|championship\.aero|charter\.aero|civilaviation\.aero|club\.aero|conference\.aero|consultant\.aero|consulting\.aero|control\.aero|council\.aero|crew\.aero|design\.aero|dgca\.aero|educator\.aero|emergency\.aero|engine\.aero|engineer\.aero|entertainment\.aero|equipment\.aero|exchange\.aero|express\.aero|federation\.aero|flight\.aero|freight\.aero|fuel\.aero|gliding\.aero|government\.aero|groundhandling\.aero|group\.aero|hanggliding\.aero|homebuilt\.aero|insurance\.aero|journal\.aero|journalist\.aero|leasing\.aero|logistics\.aero|magazine\.aero|maintenance\.aero|media\.aero|microlight\.aero|modelling\.aero|navigation\.aero|parachuting\.aero|paragliding\.aero|passenger-association\.aero|pilot\.aero|press\.aero|production\.aero|recreation\.aero|repbody\.aero|res\.aero|research\.aero|rotorcraft\.aero|safety\.aero|scientist\.aero|services\.aero|show\.aero|skydiving\.aero|software\.aero|student\.aero|trader\.aero|trading\.aero|trainer\.aero|union\.aero|workinggroup\.aero|works\.aero|af|gov\.af|com\.af|org\.af|net\.af|edu\.af|ag|com\.ag|org\.ag|net\.ag|co\.ag|nom\.ag|ai|off\.ai|com\.ai|net\.ai|org\.ai|al|com\.al|edu\.al|gov\.al|mil\.al|net\.al|org\.al|am|ao|ed\.ao|gv\.ao|og\.ao|co\.ao|pb\.ao|it\.ao|aq|ar|com\.ar|edu\.ar|gob\.ar|gov\.ar|int\.ar|mil\.ar|net\.ar|org\.ar|tur\.ar|arpa|e164\.arpa|in-addr\.arpa|ip6\.arpa|iris\.arpa|uri\.arpa|urn\.arpa|as|gov\.as|asia|at|ac\.at|co\.at|gv\.at|or\.at|au|com\.au|net\.au|org\.au|edu\.au|gov\.au|asn\.au|id\.au|info\.au|conf\.au|oz\.au|act\.au|nsw\.au|nt\.au|qld\.au|sa\.au|tas\.au|vic\.au|wa\.au|act\.edu\.au|nsw\.edu\.au|nt\.edu\.au|qld\.edu\.au|sa\.edu\.au|tas\.edu\.au|vic\.edu\.au|wa\.edu\.au|qld\.gov\.au|sa\.gov\.au|tas\.gov\.au|vic\.gov\.au|wa\.gov\.au|aw|com\.aw|ax|az|com\.az|net\.az|int\.az|gov\.az|org\.az|edu\.az|info\.az|pp\.az|mil\.az|name\.az|pro\.az|biz\.az|ba|com\.ba|edu\.ba|gov\.ba|mil\.ba|net\.ba|org\.ba|bb|biz\.bb|co\.bb|com\.bb|edu\.bb|gov\.bb|info\.bb|net\.bb|org\.bb|store\.bb|tv\.bb|[^.]+\.bd|be|ac\.be|bf|gov\.bf|bg|a\.bg|b\.bg|c\.bg|d\.bg|e\.bg|f\.bg|g\.bg|h\.bg|i\.bg|j\.bg|k\.bg|l\.bg|m\.bg|n\.bg|o\.bg|p\.bg|q\.bg|r\.bg|s\.bg|t\.bg|u\.bg|v\.bg|w\.bg|x\.bg|y\.bg|z\.bg|0\.bg|1\.bg|2\.bg|3\.bg|4\.bg|5\.bg|6\.bg|7\.bg|8\.bg|9\.bg|bh|com\.bh|edu\.bh|net\.bh|org\.bh|gov\.bh|bi|co\.bi|com\.bi|edu\.bi|or\.bi|org\.bi|biz|bj|asso\.bj|barreau\.bj|gouv\.bj|bm|com\.bm|edu\.bm|gov\.bm|net\.bm|org\.bm|[^.]+\.bn|bo|com\.bo|edu\.bo|gov\.bo|gob\.bo|int\.bo|org\.bo|net\.bo|mil\.bo|tv\.bo|br|adm\.br|adv\.br|agr\.br|am\.br|arq\.br|art\.br|ato\.br|b\.br|bio\.br|blog\.br|bmd\.br|cim\.br|cng\.br|cnt\.br|com\.br|coop\.br|ecn\.br|eco\.br|edu\.br|emp\.br|eng\.br|esp\.br|etc\.br|eti\.br|far\.br|flog\.br|fm\.br|fnd\.br|fot\.br|fst\.br|g12\.br|ggf\.br|gov\.br|imb\.br|ind\.br|inf\.br|jor\.br|jus\.br|leg\.br|lel\.br|mat\.br|med\.br|mil\.br|mp\.br|mus\.br|net\.br|[^.]+\.nom\.br|not\.br|ntr\.br|odo\.br|org\.br|ppg\.br|pro\.br|psc\.br|psi\.br|qsl\.br|radio\.br|rec\.br|slg\.br|srv\.br|taxi\.br|teo\.br|tmp\.br|trd\.br|tur\.br|tv\.br|vet\.br|vlog\.br|wiki\.br|zlg\.br|bs|com\.bs|net\.bs|org\.bs|edu\.bs|gov\.bs|bt|com\.bt|edu\.bt|gov\.bt|net\.bt|org\.bt|bv|bw|co\.bw|org\.bw|by|gov\.by|mil\.by|com\.by|of\.by|bz|com\.bz|net\.bz|org\.bz|edu\.bz|gov\.bz|ca|ab\.ca|bc\.ca|mb\.ca|nb\.ca|nf\.ca|nl\.ca|ns\.ca|nt\.ca|nu\.ca|on\.ca|pe\.ca|qc\.ca|sk\.ca|yk\.ca|gc\.ca|cat|cc|cd|gov\.cd|cf|cg|ch|ci|org\.ci|or\.ci|com\.ci|co\.ci|edu\.ci|ed\.ci|ac\.ci|net\.ci|go\.ci|asso\.ci|aéroport\.ci|int\.ci|presse\.ci|md\.ci|gouv\.ci|[^.]+\.ck|!www\.ck|cl|gov\.cl|gob\.cl|co\.cl|mil\.cl|cm|co\.cm|com\.cm|gov\.cm|net\.cm|cn|ac\.cn|com\.cn|edu\.cn|gov\.cn|net\.cn|org\.cn|mil\.cn|公司\.cn|网络\.cn|網絡\.cn|ah\.cn|bj\.cn|cq\.cn|fj\.cn|gd\.cn|gs\.cn|gz\.cn|gx\.cn|ha\.cn|hb\.cn|he\.cn|hi\.cn|hl\.cn|hn\.cn|jl\.cn|js\.cn|jx\.cn|ln\.cn|nm\.cn|nx\.cn|qh\.cn|sc\.cn|sd\.cn|sh\.cn|sn\.cn|sx\.cn|tj\.cn|xj\.cn|xz\.cn|yn\.cn|zj\.cn|hk\.cn|mo\.cn|tw\.cn|co|arts\.co|com\.co|edu\.co|firm\.co|gov\.co|info\.co|int\.co|mil\.co|net\.co|nom\.co|org\.co|rec\.co|web\.co|com|coop|cr|ac\.cr|co\.cr|ed\.cr|fi\.cr|go\.cr|or\.cr|sa\.cr|cu|com\.cu|edu\.cu|org\.cu|net\.cu|gov\.cu|inf\.cu|cv|cw|com\.cw|edu\.cw|net\.cw|org\.cw|cx|gov\.cx|cy|ac\.cy|biz\.cy|com\.cy|ekloges\.cy|gov\.cy|ltd\.cy|name\.cy|net\.cy|org\.cy|parliament\.cy|press\.cy|pro\.cy|tm\.cy|cz|de|dj|dk|dm|com\.dm|net\.dm|org\.dm|edu\.dm|gov\.dm|do|art\.do|com\.do|edu\.do|gob\.do|gov\.do|mil\.do|net\.do|org\.do|sld\.do|web\.do|dz|com\.dz|org\.dz|net\.dz|gov\.dz|edu\.dz|asso\.dz|pol\.dz|art\.dz|ec|com\.ec|info\.ec|net\.ec|fin\.ec|k12\.ec|med\.ec|pro\.ec|org\.ec|edu\.ec|gov\.ec|gob\.ec|mil\.ec|edu|ee|edu\.ee|gov\.ee|riik\.ee|lib\.ee|med\.ee|com\.ee|pri\.ee|aip\.ee|org\.ee|fie\.ee|eg|com\.eg|edu\.eg|eun\.eg|gov\.eg|mil\.eg|name\.eg|net\.eg|org\.eg|sci\.eg|[^.]+\.er|es|com\.es|nom\.es|org\.es|gob\.es|edu\.es|et|com\.et|gov\.et|org\.et|edu\.et|biz\.et|name\.et|info\.et|net\.et|eu|fi|aland\.fi|[^.]+\.fj|[^.]+\.fk|fm|fo|fr|com\.fr|asso\.fr|nom\.fr|prd\.fr|presse\.fr|tm\.fr|aeroport\.fr|assedic\.fr|avocat\.fr|avoues\.fr|cci\.fr|chambagri\.fr|chirurgiens-dentistes\.fr|experts-comptables\.fr|geometre-expert\.fr|gouv\.fr|greta\.fr|huissier-justice\.fr|medecin\.fr|notaires\.fr|pharmacien\.fr|port\.fr|veterinaire\.fr|ga|gb|gd|ge|com\.ge|edu\.ge|gov\.ge|org\.ge|mil\.ge|net\.ge|pvt\.ge|gf|gg|co\.gg|net\.gg|org\.gg|gh|com\.gh|edu\.gh|gov\.gh|org\.gh|mil\.gh|gi|com\.gi|ltd\.gi|gov\.gi|mod\.gi|edu\.gi|org\.gi|gl|co\.gl|com\.gl|edu\.gl|net\.gl|org\.gl|gm|gn|ac\.gn|com\.gn|edu\.gn|gov\.gn|org\.gn|net\.gn|gov|gp|com\.gp|net\.gp|mobi\.gp|edu\.gp|org\.gp|asso\.gp|gq|gr|com\.gr|edu\.gr|net\.gr|org\.gr|gov\.gr|gs|gt|com\.gt|edu\.gt|gob\.gt|ind\.gt|mil\.gt|net\.gt|org\.gt|[^.]+\.gu|gw|gy|co\.gy|com\.gy|edu\.gy|gov\.gy|net\.gy|org\.gy|hk|com\.hk|edu\.hk|gov\.hk|idv\.hk|net\.hk|org\.hk|公司\.hk|教育\.hk|敎育\.hk|政府\.hk|個人\.hk|个人\.hk|箇人\.hk|網络\.hk|网络\.hk|组織\.hk|網絡\.hk|网絡\.hk|组织\.hk|組織\.hk|組织\.hk|hm|hn|com\.hn|edu\.hn|org\.hn|net\.hn|mil\.hn|gob\.hn|hr|iz\.hr|from\.hr|name\.hr|com\.hr|ht|com\.ht|shop\.ht|firm\.ht|info\.ht|adult\.ht|net\.ht|pro\.ht|org\.ht|med\.ht|art\.ht|coop\.ht|pol\.ht|asso\.ht|edu\.ht|rel\.ht|gouv\.ht|perso\.ht|hu|co\.hu|info\.hu|org\.hu|priv\.hu|sport\.hu|tm\.hu|2000\.hu|agrar\.hu|bolt\.hu|casino\.hu|city\.hu|erotica\.hu|erotika\.hu|film\.hu|forum\.hu|games\.hu|hotel\.hu|ingatlan\.hu|jogasz\.hu|konyvelo\.hu|lakas\.hu|media\.hu|news\.hu|reklam\.hu|sex\.hu|shop\.hu|suli\.hu|szex\.hu|tozsde\.hu|utazas\.hu|video\.hu|id|ac\.id|biz\.id|co\.id|desa\.id|go\.id|mil\.id|my\.id|net\.id|or\.id|sch\.id|web\.id|ie|gov\.ie|il|ac\.il|co\.il|gov\.il|idf\.il|k12\.il|muni\.il|net\.il|org\.il|im|ac\.im|co\.im|com\.im|ltd\.co\.im|net\.im|org\.im|plc\.co\.im|tt\.im|tv\.im|in|co\.in|firm\.in|net\.in|org\.in|gen\.in|ind\.in|nic\.in|ac\.in|edu\.in|res\.in|gov\.in|mil\.in|info|int|eu\.int|io|com\.io|iq|gov\.iq|edu\.iq|mil\.iq|com\.iq|org\.iq|net\.iq|ir|ac\.ir|co\.ir|gov\.ir|id\.ir|net\.ir|org\.ir|sch\.ir|ایران\.ir|ايران\.ir|is|net\.is|com\.is|edu\.is|gov\.is|org\.is|int\.is|it|gov\.it|edu\.it|abr\.it|abruzzo\.it|aosta-valley\.it|aostavalley\.it|bas\.it|basilicata\.it|cal\.it|calabria\.it|cam\.it|campania\.it|emilia-romagna\.it|emiliaromagna\.it|emr\.it|friuli-v-giulia\.it|friuli-ve-giulia\.it|friuli-vegiulia\.it|friuli-venezia-giulia\.it|friuli-veneziagiulia\.it|friuli-vgiulia\.it|friuliv-giulia\.it|friulive-giulia\.it|friulivegiulia\.it|friulivenezia-giulia\.it|friuliveneziagiulia\.it|friulivgiulia\.it|fvg\.it|laz\.it|lazio\.it|lig\.it|liguria\.it|lom\.it|lombardia\.it|lombardy\.it|lucania\.it|mar\.it|marche\.it|mol\.it|molise\.it|piedmont\.it|piemonte\.it|pmn\.it|pug\.it|puglia\.it|sar\.it|sardegna\.it|sardinia\.it|sic\.it|sicilia\.it|sicily\.it|taa\.it|tos\.it|toscana\.it|trentino-a-adige\.it|trentino-aadige\.it|trentino-alto-adige\.it|trentino-altoadige\.it|trentino-s-tirol\.it|trentino-stirol\.it|trentino-sud-tirol\.it|trentino-sudtirol\.it|trentino-sued-tirol\.it|trentino-suedtirol\.it|trentinoa-adige\.it|trentinoaadige\.it|trentinoalto-adige\.it|trentinoaltoadige\.it|trentinos-tirol\.it|trentinostirol\.it|trentinosud-tirol\.it|trentinosudtirol\.it|trentinosued-tirol\.it|trentinosuedtirol\.it|tuscany\.it|umb\.it|umbria\.it|val-d-aosta\.it|val-daosta\.it|vald-aosta\.it|valdaosta\.it|valle-aosta\.it|valle-d-aosta\.it|valle-daosta\.it|valleaosta\.it|valled-aosta\.it|valledaosta\.it|vallee-aoste\.it|valleeaoste\.it|vao\.it|vda\.it|ven\.it|veneto\.it|ag\.it|agrigento\.it|al\.it|alessandria\.it|alto-adige\.it|altoadige\.it|an\.it|ancona\.it|andria-barletta-trani\.it|andria-trani-barletta\.it|andriabarlettatrani\.it|andriatranibarletta\.it|ao\.it|aosta\.it|aoste\.it|ap\.it|aq\.it|aquila\.it|ar\.it|arezzo\.it|ascoli-piceno\.it|ascolipiceno\.it|asti\.it|at\.it|av\.it|avellino\.it|ba\.it|balsan\.it|bari\.it|barletta-trani-andria\.it|barlettatraniandria\.it|belluno\.it|benevento\.it|bergamo\.it|bg\.it|bi\.it|biella\.it|bl\.it|bn\.it|bo\.it|bologna\.it|bolzano\.it|bozen\.it|br\.it|brescia\.it|brindisi\.it|bs\.it|bt\.it|bz\.it|ca\.it|cagliari\.it|caltanissetta\.it|campidano-medio\.it|campidanomedio\.it|campobasso\.it|carbonia-iglesias\.it|carboniaiglesias\.it|carrara-massa\.it|carraramassa\.it|caserta\.it|catania\.it|catanzaro\.it|cb\.it|ce\.it|cesena-forli\.it|cesenaforli\.it|ch\.it|chieti\.it|ci\.it|cl\.it|cn\.it|co\.it|como\.it|cosenza\.it|cr\.it|cremona\.it|crotone\.it|cs\.it|ct\.it|cuneo\.it|cz\.it|dell-ogliastra\.it|dellogliastra\.it|en\.it|enna\.it|fc\.it|fe\.it|fermo\.it|ferrara\.it|fg\.it|fi\.it|firenze\.it|florence\.it|fm\.it|foggia\.it|forli-cesena\.it|forlicesena\.it|fr\.it|frosinone\.it|ge\.it|genoa\.it|genova\.it|go\.it|gorizia\.it|gr\.it|grosseto\.it|iglesias-carbonia\.it|iglesiascarbonia\.it|im\.it|imperia\.it|is\.it|isernia\.it|kr\.it|la-spezia\.it|laquila\.it|laspezia\.it|latina\.it|lc\.it|le\.it|lecce\.it|lecco\.it|li\.it|livorno\.it|lo\.it|lodi\.it|lt\.it|lu\.it|lucca\.it|macerata\.it|mantova\.it|massa-carrara\.it|massacarrara\.it|matera\.it|mb\.it|mc\.it|me\.it|medio-campidano\.it|mediocampidano\.it|messina\.it|mi\.it|milan\.it|milano\.it|mn\.it|mo\.it|modena\.it|monza-brianza\.it|monza-e-della-brianza\.it|monza\.it|monzabrianza\.it|monzaebrianza\.it|monzaedellabrianza\.it|ms\.it|mt\.it|na\.it|naples\.it|napoli\.it|no\.it|novara\.it|nu\.it|nuoro\.it|og\.it|ogliastra\.it|olbia-tempio\.it|olbiatempio\.it|or\.it|oristano\.it|ot\.it|pa\.it|padova\.it|padua\.it|palermo\.it|parma\.it|pavia\.it|pc\.it|pd\.it|pe\.it|perugia\.it|pesaro-urbino\.it|pesarourbino\.it|pescara\.it|pg\.it|pi\.it|piacenza\.it|pisa\.it|pistoia\.it|pn\.it|po\.it|pordenone\.it|potenza\.it|pr\.it|prato\.it|pt\.it|pu\.it|pv\.it|pz\.it|ra\.it|ragusa\.it|ravenna\.it|rc\.it|re\.it|reggio-calabria\.it|reggio-emilia\.it|reggiocalabria\.it|reggioemilia\.it|rg\.it|ri\.it|rieti\.it|rimini\.it|rm\.it|rn\.it|ro\.it|roma\.it|rome\.it|rovigo\.it|sa\.it|salerno\.it|sassari\.it|savona\.it|si\.it|siena\.it|siracusa\.it|so\.it|sondrio\.it|sp\.it|sr\.it|ss\.it|suedtirol\.it|sv\.it|ta\.it|taranto\.it|te\.it|tempio-olbia\.it|tempioolbia\.it|teramo\.it|terni\.it|tn\.it|to\.it|torino\.it|tp\.it|tr\.it|trani-andria-barletta\.it|trani-barletta-andria\.it|traniandriabarletta\.it|tranibarlettaandria\.it|trapani\.it|trentino\.it|trento\.it|treviso\.it|trieste\.it|ts\.it|turin\.it|tv\.it|ud\.it|udine\.it|urbino-pesaro\.it|urbinopesaro\.it|va\.it|varese\.it|vb\.it|vc\.it|ve\.it|venezia\.it|venice\.it|verbania\.it|vercelli\.it|verona\.it|vi\.it|vibo-valentia\.it|vibovalentia\.it|vicenza\.it|viterbo\.it|vr\.it|vs\.it|vt\.it|vv\.it|je|co\.je|net\.je|org\.je|[^.]+\.jm|jo|com\.jo|org\.jo|net\.jo|edu\.jo|sch\.jo|gov\.jo|mil\.jo|name\.jo|jobs|jp|ac\.jp|ad\.jp|co\.jp|ed\.jp|go\.jp|gr\.jp|lg\.jp|ne\.jp|or\.jp|aichi\.jp|akita\.jp|aomori\.jp|chiba\.jp|ehime\.jp|fukui\.jp|fukuoka\.jp|fukushima\.jp|gifu\.jp|gunma\.jp|hiroshima\.jp|hokkaido\.jp|hyogo\.jp|ibaraki\.jp|ishikawa\.jp|iwate\.jp|kagawa\.jp|kagoshima\.jp|kanagawa\.jp|kochi\.jp|kumamoto\.jp|kyoto\.jp|mie\.jp|miyagi\.jp|miyazaki\.jp|nagano\.jp|nagasaki\.jp|nara\.jp|niigata\.jp|oita\.jp|okayama\.jp|okinawa\.jp|osaka\.jp|saga\.jp|saitama\.jp|shiga\.jp|shimane\.jp|shizuoka\.jp|tochigi\.jp|tokushima\.jp|tokyo\.jp|tottori\.jp|toyama\.jp|wakayama\.jp|yamagata\.jp|yamaguchi\.jp|yamanashi\.jp|栃木\.jp|愛知\.jp|愛媛\.jp|兵庫\.jp|熊本\.jp|茨城\.jp|北海道\.jp|千葉\.jp|和歌山\.jp|長崎\.jp|長野\.jp|新潟\.jp|青森\.jp|静岡\.jp|東京\.jp|石川\.jp|埼玉\.jp|三重\.jp|京都\.jp|佐賀\.jp|大分\.jp|大阪\.jp|奈良\.jp|宮城\.jp|宮崎\.jp|富山\.jp|山口\.jp|山形\.jp|山梨\.jp|岩手\.jp|岐阜\.jp|岡山\.jp|島根\.jp|広島\.jp|徳島\.jp|沖縄\.jp|滋賀\.jp|神奈川\.jp|福井\.jp|福岡\.jp|福島\.jp|秋田\.jp|群馬\.jp|香川\.jp|高知\.jp|鳥取\.jp|鹿児島\.jp|[^.]+\.kawasaki\.jp|[^.]+\.kitakyushu\.jp|[^.]+\.kobe\.jp|[^.]+\.nagoya\.jp|[^.]+\.sapporo\.jp|[^.]+\.sendai\.jp|[^.]+\.yokohama\.jp|!city\.kawasaki\.jp|!city\.kitakyushu\.jp|!city\.kobe\.jp|!city\.nagoya\.jp|!city\.sapporo\.jp|!city\.sendai\.jp|!city\.yokohama\.jp|aisai\.aichi\.jp|ama\.aichi\.jp|anjo\.aichi\.jp|asuke\.aichi\.jp|chiryu\.aichi\.jp|chita\.aichi\.jp|fuso\.aichi\.jp|gamagori\.aichi\.jp|handa\.aichi\.jp|hazu\.aichi\.jp|hekinan\.aichi\.jp|higashiura\.aichi\.jp|ichinomiya\.aichi\.jp|inazawa\.aichi\.jp|inuyama\.aichi\.jp|isshiki\.aichi\.jp|iwakura\.aichi\.jp|kanie\.aichi\.jp|kariya\.aichi\.jp|kasugai\.aichi\.jp|kira\.aichi\.jp|kiyosu\.aichi\.jp|komaki\.aichi\.jp|konan\.aichi\.jp|kota\.aichi\.jp|mihama\.aichi\.jp|miyoshi\.aichi\.jp|nishio\.aichi\.jp|nisshin\.aichi\.jp|obu\.aichi\.jp|oguchi\.aichi\.jp|oharu\.aichi\.jp|okazaki\.aichi\.jp|owariasahi\.aichi\.jp|seto\.aichi\.jp|shikatsu\.aichi\.jp|shinshiro\.aichi\.jp|shitara\.aichi\.jp|tahara\.aichi\.jp|takahama\.aichi\.jp|tobishima\.aichi\.jp|toei\.aichi\.jp|togo\.aichi\.jp|tokai\.aichi\.jp|tokoname\.aichi\.jp|toyoake\.aichi\.jp|toyohashi\.aichi\.jp|toyokawa\.aichi\.jp|toyone\.aichi\.jp|toyota\.aichi\.jp|tsushima\.aichi\.jp|yatomi\.aichi\.jp|akita\.akita\.jp|daisen\.akita\.jp|fujisato\.akita\.jp|gojome\.akita\.jp|hachirogata\.akita\.jp|happou\.akita\.jp|higashinaruse\.akita\.jp|honjo\.akita\.jp|honjyo\.akita\.jp|ikawa\.akita\.jp|kamikoani\.akita\.jp|kamioka\.akita\.jp|katagami\.akita\.jp|kazuno\.akita\.jp|kitaakita\.akita\.jp|kosaka\.akita\.jp|kyowa\.akita\.jp|misato\.akita\.jp|mitane\.akita\.jp|moriyoshi\.akita\.jp|nikaho\.akita\.jp|noshiro\.akita\.jp|odate\.akita\.jp|oga\.akita\.jp|ogata\.akita\.jp|semboku\.akita\.jp|yokote\.akita\.jp|yurihonjo\.akita\.jp|aomori\.aomori\.jp|gonohe\.aomori\.jp|hachinohe\.aomori\.jp|hashikami\.aomori\.jp|hiranai\.aomori\.jp|hirosaki\.aomori\.jp|itayanagi\.aomori\.jp|kuroishi\.aomori\.jp|misawa\.aomori\.jp|mutsu\.aomori\.jp|nakadomari\.aomori\.jp|noheji\.aomori\.jp|oirase\.aomori\.jp|owani\.aomori\.jp|rokunohe\.aomori\.jp|sannohe\.aomori\.jp|shichinohe\.aomori\.jp|shingo\.aomori\.jp|takko\.aomori\.jp|towada\.aomori\.jp|tsugaru\.aomori\.jp|tsuruta\.aomori\.jp|abiko\.chiba\.jp|asahi\.chiba\.jp|chonan\.chiba\.jp|chosei\.chiba\.jp|choshi\.chiba\.jp|chuo\.chiba\.jp|funabashi\.chiba\.jp|futtsu\.chiba\.jp|hanamigawa\.chiba\.jp|ichihara\.chiba\.jp|ichikawa\.chiba\.jp|ichinomiya\.chiba\.jp|inzai\.chiba\.jp|isumi\.chiba\.jp|kamagaya\.chiba\.jp|kamogawa\.chiba\.jp|kashiwa\.chiba\.jp|katori\.chiba\.jp|katsuura\.chiba\.jp|kimitsu\.chiba\.jp|kisarazu\.chiba\.jp|kozaki\.chiba\.jp|kujukuri\.chiba\.jp|kyonan\.chiba\.jp|matsudo\.chiba\.jp|midori\.chiba\.jp|mihama\.chiba\.jp|minamiboso\.chiba\.jp|mobara\.chiba\.jp|mutsuzawa\.chiba\.jp|nagara\.chiba\.jp|nagareyama\.chiba\.jp|narashino\.chiba\.jp|narita\.chiba\.jp|noda\.chiba\.jp|oamishirasato\.chiba\.jp|omigawa\.chiba\.jp|onjuku\.chiba\.jp|otaki\.chiba\.jp|sakae\.chiba\.jp|sakura\.chiba\.jp|shimofusa\.chiba\.jp|shirako\.chiba\.jp|shiroi\.chiba\.jp|shisui\.chiba\.jp|sodegaura\.chiba\.jp|sosa\.chiba\.jp|tako\.chiba\.jp|tateyama\.chiba\.jp|togane\.chiba\.jp|tohnosho\.chiba\.jp|tomisato\.chiba\.jp|urayasu\.chiba\.jp|yachimata\.chiba\.jp|yachiyo\.chiba\.jp|yokaichiba\.chiba\.jp|yokoshibahikari\.chiba\.jp|yotsukaido\.chiba\.jp|ainan\.ehime\.jp|honai\.ehime\.jp|ikata\.ehime\.jp|imabari\.ehime\.jp|iyo\.ehime\.jp|kamijima\.ehime\.jp|kihoku\.ehime\.jp|kumakogen\.ehime\.jp|masaki\.ehime\.jp|matsuno\.ehime\.jp|matsuyama\.ehime\.jp|namikata\.ehime\.jp|niihama\.ehime\.jp|ozu\.ehime\.jp|saijo\.ehime\.jp|seiyo\.ehime\.jp|shikokuchuo\.ehime\.jp|tobe\.ehime\.jp|toon\.ehime\.jp|uchiko\.ehime\.jp|uwajima\.ehime\.jp|yawatahama\.ehime\.jp|echizen\.fukui\.jp|eiheiji\.fukui\.jp|fukui\.fukui\.jp|ikeda\.fukui\.jp|katsuyama\.fukui\.jp|mihama\.fukui\.jp|minamiechizen\.fukui\.jp|obama\.fukui\.jp|ohi\.fukui\.jp|ono\.fukui\.jp|sabae\.fukui\.jp|sakai\.fukui\.jp|takahama\.fukui\.jp|tsuruga\.fukui\.jp|wakasa\.fukui\.jp|ashiya\.fukuoka\.jp|buzen\.fukuoka\.jp|chikugo\.fukuoka\.jp|chikuho\.fukuoka\.jp|chikujo\.fukuoka\.jp|chikushino\.fukuoka\.jp|chikuzen\.fukuoka\.jp|chuo\.fukuoka\.jp|dazaifu\.fukuoka\.jp|fukuchi\.fukuoka\.jp|hakata\.fukuoka\.jp|higashi\.fukuoka\.jp|hirokawa\.fukuoka\.jp|hisayama\.fukuoka\.jp|iizuka\.fukuoka\.jp|inatsuki\.fukuoka\.jp|kaho\.fukuoka\.jp|kasuga\.fukuoka\.jp|kasuya\.fukuoka\.jp|kawara\.fukuoka\.jp|keisen\.fukuoka\.jp|koga\.fukuoka\.jp|kurate\.fukuoka\.jp|kurogi\.fukuoka\.jp|kurume\.fukuoka\.jp|minami\.fukuoka\.jp|miyako\.fukuoka\.jp|miyama\.fukuoka\.jp|miyawaka\.fukuoka\.jp|mizumaki\.fukuoka\.jp|munakata\.fukuoka\.jp|nakagawa\.fukuoka\.jp|nakama\.fukuoka\.jp|nishi\.fukuoka\.jp|nogata\.fukuoka\.jp|ogori\.fukuoka\.jp|okagaki\.fukuoka\.jp|okawa\.fukuoka\.jp|oki\.fukuoka\.jp|omuta\.fukuoka\.jp|onga\.fukuoka\.jp|onojo\.fukuoka\.jp|oto\.fukuoka\.jp|saigawa\.fukuoka\.jp|sasaguri\.fukuoka\.jp|shingu\.fukuoka\.jp|shinyoshitomi\.fukuoka\.jp|shonai\.fukuoka\.jp|soeda\.fukuoka\.jp|sue\.fukuoka\.jp|tachiarai\.fukuoka\.jp|tagawa\.fukuoka\.jp|takata\.fukuoka\.jp|toho\.fukuoka\.jp|toyotsu\.fukuoka\.jp|tsuiki\.fukuoka\.jp|ukiha\.fukuoka\.jp|umi\.fukuoka\.jp|usui\.fukuoka\.jp|yamada\.fukuoka\.jp|yame\.fukuoka\.jp|yanagawa\.fukuoka\.jp|yukuhashi\.fukuoka\.jp|aizubange\.fukushima\.jp|aizumisato\.fukushima\.jp|aizuwakamatsu\.fukushima\.jp|asakawa\.fukushima\.jp|bandai\.fukushima\.jp|date\.fukushima\.jp|fukushima\.fukushima\.jp|furudono\.fukushima\.jp|futaba\.fukushima\.jp|hanawa\.fukushima\.jp|higashi\.fukushima\.jp|hirata\.fukushima\.jp|hirono\.fukushima\.jp|iitate\.fukushima\.jp|inawashiro\.fukushima\.jp|ishikawa\.fukushima\.jp|iwaki\.fukushima\.jp|izumizaki\.fukushima\.jp|kagamiishi\.fukushima\.jp|kaneyama\.fukushima\.jp|kawamata\.fukushima\.jp|kitakata\.fukushima\.jp|kitashiobara\.fukushima\.jp|koori\.fukushima\.jp|koriyama\.fukushima\.jp|kunimi\.fukushima\.jp|miharu\.fukushima\.jp|mishima\.fukushima\.jp|namie\.fukushima\.jp|nango\.fukushima\.jp|nishiaizu\.fukushima\.jp|nishigo\.fukushima\.jp|okuma\.fukushima\.jp|omotego\.fukushima\.jp|ono\.fukushima\.jp|otama\.fukushima\.jp|samegawa\.fukushima\.jp|shimogo\.fukushima\.jp|shirakawa\.fukushima\.jp|showa\.fukushima\.jp|soma\.fukushima\.jp|sukagawa\.fukushima\.jp|taishin\.fukushima\.jp|tamakawa\.fukushima\.jp|tanagura\.fukushima\.jp|tenei\.fukushima\.jp|yabuki\.fukushima\.jp|yamato\.fukushima\.jp|yamatsuri\.fukushima\.jp|yanaizu\.fukushima\.jp|yugawa\.fukushima\.jp|anpachi\.gifu\.jp|ena\.gifu\.jp|gifu\.gifu\.jp|ginan\.gifu\.jp|godo\.gifu\.jp|gujo\.gifu\.jp|hashima\.gifu\.jp|hichiso\.gifu\.jp|hida\.gifu\.jp|higashishirakawa\.gifu\.jp|ibigawa\.gifu\.jp|ikeda\.gifu\.jp|kakamigahara\.gifu\.jp|kani\.gifu\.jp|kasahara\.gifu\.jp|kasamatsu\.gifu\.jp|kawaue\.gifu\.jp|kitagata\.gifu\.jp|mino\.gifu\.jp|minokamo\.gifu\.jp|mitake\.gifu\.jp|mizunami\.gifu\.jp|motosu\.gifu\.jp|nakatsugawa\.gifu\.jp|ogaki\.gifu\.jp|sakahogi\.gifu\.jp|seki\.gifu\.jp|sekigahara\.gifu\.jp|shirakawa\.gifu\.jp|tajimi\.gifu\.jp|takayama\.gifu\.jp|tarui\.gifu\.jp|toki\.gifu\.jp|tomika\.gifu\.jp|wanouchi\.gifu\.jp|yamagata\.gifu\.jp|yaotsu\.gifu\.jp|yoro\.gifu\.jp|annaka\.gunma\.jp|chiyoda\.gunma\.jp|fujioka\.gunma\.jp|higashiagatsuma\.gunma\.jp|isesaki\.gunma\.jp|itakura\.gunma\.jp|kanna\.gunma\.jp|kanra\.gunma\.jp|katashina\.gunma\.jp|kawaba\.gunma\.jp|kiryu\.gunma\.jp|kusatsu\.gunma\.jp|maebashi\.gunma\.jp|meiwa\.gunma\.jp|midori\.gunma\.jp|minakami\.gunma\.jp|naganohara\.gunma\.jp|nakanojo\.gunma\.jp|nanmoku\.gunma\.jp|numata\.gunma\.jp|oizumi\.gunma\.jp|ora\.gunma\.jp|ota\.gunma\.jp|shibukawa\.gunma\.jp|shimonita\.gunma\.jp|shinto\.gunma\.jp|showa\.gunma\.jp|takasaki\.gunma\.jp|takayama\.gunma\.jp|tamamura\.gunma\.jp|tatebayashi\.gunma\.jp|tomioka\.gunma\.jp|tsukiyono\.gunma\.jp|tsumagoi\.gunma\.jp|ueno\.gunma\.jp|yoshioka\.gunma\.jp|asaminami\.hiroshima\.jp|daiwa\.hiroshima\.jp|etajima\.hiroshima\.jp|fuchu\.hiroshima\.jp|fukuyama\.hiroshima\.jp|hatsukaichi\.hiroshima\.jp|higashihiroshima\.hiroshima\.jp|hongo\.hiroshima\.jp|jinsekikogen\.hiroshima\.jp|kaita\.hiroshima\.jp|kui\.hiroshima\.jp|kumano\.hiroshima\.jp|kure\.hiroshima\.jp|mihara\.hiroshima\.jp|miyoshi\.hiroshima\.jp|naka\.hiroshima\.jp|onomichi\.hiroshima\.jp|osakikamijima\.hiroshima\.jp|otake\.hiroshima\.jp|saka\.hiroshima\.jp|sera\.hiroshima\.jp|seranishi\.hiroshima\.jp|shinichi\.hiroshima\.jp|shobara\.hiroshima\.jp|takehara\.hiroshima\.jp|abashiri\.hokkaido\.jp|abira\.hokkaido\.jp|aibetsu\.hokkaido\.jp|akabira\.hokkaido\.jp|akkeshi\.hokkaido\.jp|asahikawa\.hokkaido\.jp|ashibetsu\.hokkaido\.jp|ashoro\.hokkaido\.jp|assabu\.hokkaido\.jp|atsuma\.hokkaido\.jp|bibai\.hokkaido\.jp|biei\.hokkaido\.jp|bifuka\.hokkaido\.jp|bihoro\.hokkaido\.jp|biratori\.hokkaido\.jp|chippubetsu\.hokkaido\.jp|chitose\.hokkaido\.jp|date\.hokkaido\.jp|ebetsu\.hokkaido\.jp|embetsu\.hokkaido\.jp|eniwa\.hokkaido\.jp|erimo\.hokkaido\.jp|esan\.hokkaido\.jp|esashi\.hokkaido\.jp|fukagawa\.hokkaido\.jp|fukushima\.hokkaido\.jp|furano\.hokkaido\.jp|furubira\.hokkaido\.jp|haboro\.hokkaido\.jp|hakodate\.hokkaido\.jp|hamatonbetsu\.hokkaido\.jp|hidaka\.hokkaido\.jp|higashikagura\.hokkaido\.jp|higashikawa\.hokkaido\.jp|hiroo\.hokkaido\.jp|hokuryu\.hokkaido\.jp|hokuto\.hokkaido\.jp|honbetsu\.hokkaido\.jp|horokanai\.hokkaido\.jp|horonobe\.hokkaido\.jp|ikeda\.hokkaido\.jp|imakane\.hokkaido\.jp|ishikari\.hokkaido\.jp|iwamizawa\.hokkaido\.jp|iwanai\.hokkaido\.jp|kamifurano\.hokkaido\.jp|kamikawa\.hokkaido\.jp|kamishihoro\.hokkaido\.jp|kamisunagawa\.hokkaido\.jp|kamoenai\.hokkaido\.jp|kayabe\.hokkaido\.jp|kembuchi\.hokkaido\.jp|kikonai\.hokkaido\.jp|kimobetsu\.hokkaido\.jp|kitahiroshima\.hokkaido\.jp|kitami\.hokkaido\.jp|kiyosato\.hokkaido\.jp|koshimizu\.hokkaido\.jp|kunneppu\.hokkaido\.jp|kuriyama\.hokkaido\.jp|kuromatsunai\.hokkaido\.jp|kushiro\.hokkaido\.jp|kutchan\.hokkaido\.jp|kyowa\.hokkaido\.jp|mashike\.hokkaido\.jp|matsumae\.hokkaido\.jp|mikasa\.hokkaido\.jp|minamifurano\.hokkaido\.jp|mombetsu\.hokkaido\.jp|moseushi\.hokkaido\.jp|mukawa\.hokkaido\.jp|muroran\.hokkaido\.jp|naie\.hokkaido\.jp|nakagawa\.hokkaido\.jp|nakasatsunai\.hokkaido\.jp|nakatombetsu\.hokkaido\.jp|nanae\.hokkaido\.jp|nanporo\.hokkaido\.jp|nayoro\.hokkaido\.jp|nemuro\.hokkaido\.jp|niikappu\.hokkaido\.jp|niki\.hokkaido\.jp|nishiokoppe\.hokkaido\.jp|noboribetsu\.hokkaido\.jp|numata\.hokkaido\.jp|obihiro\.hokkaido\.jp|obira\.hokkaido\.jp|oketo\.hokkaido\.jp|okoppe\.hokkaido\.jp|otaru\.hokkaido\.jp|otobe\.hokkaido\.jp|otofuke\.hokkaido\.jp|otoineppu\.hokkaido\.jp|oumu\.hokkaido\.jp|ozora\.hokkaido\.jp|pippu\.hokkaido\.jp|rankoshi\.hokkaido\.jp|rebun\.hokkaido\.jp|rikubetsu\.hokkaido\.jp|rishiri\.hokkaido\.jp|rishirifuji\.hokkaido\.jp|saroma\.hokkaido\.jp|sarufutsu\.hokkaido\.jp|shakotan\.hokkaido\.jp|shari\.hokkaido\.jp|shibecha\.hokkaido\.jp|shibetsu\.hokkaido\.jp|shikabe\.hokkaido\.jp|shikaoi\.hokkaido\.jp|shimamaki\.hokkaido\.jp|shimizu\.hokkaido\.jp|shimokawa\.hokkaido\.jp|shinshinotsu\.hokkaido\.jp|shintoku\.hokkaido\.jp|shiranuka\.hokkaido\.jp|shiraoi\.hokkaido\.jp|shiriuchi\.hokkaido\.jp|sobetsu\.hokkaido\.jp|sunagawa\.hokkaido\.jp|taiki\.hokkaido\.jp|takasu\.hokkaido\.jp|takikawa\.hokkaido\.jp|takinoue\.hokkaido\.jp|teshikaga\.hokkaido\.jp|tobetsu\.hokkaido\.jp|tohma\.hokkaido\.jp|tomakomai\.hokkaido\.jp|tomari\.hokkaido\.jp|toya\.hokkaido\.jp|toyako\.hokkaido\.jp|toyotomi\.hokkaido\.jp|toyoura\.hokkaido\.jp|tsubetsu\.hokkaido\.jp|tsukigata\.hokkaido\.jp|urakawa\.hokkaido\.jp|urausu\.hokkaido\.jp|uryu\.hokkaido\.jp|utashinai\.hokkaido\.jp|wakkanai\.hokkaido\.jp|wassamu\.hokkaido\.jp|yakumo\.hokkaido\.jp|yoichi\.hokkaido\.jp|aioi\.hyogo\.jp|akashi\.hyogo\.jp|ako\.hyogo\.jp|amagasaki\.hyogo\.jp|aogaki\.hyogo\.jp|asago\.hyogo\.jp|ashiya\.hyogo\.jp|awaji\.hyogo\.jp|fukusaki\.hyogo\.jp|goshiki\.hyogo\.jp|harima\.hyogo\.jp|himeji\.hyogo\.jp|ichikawa\.hyogo\.jp|inagawa\.hyogo\.jp|itami\.hyogo\.jp|kakogawa\.hyogo\.jp|kamigori\.hyogo\.jp|kamikawa\.hyogo\.jp|kasai\.hyogo\.jp|kasuga\.hyogo\.jp|kawanishi\.hyogo\.jp|miki\.hyogo\.jp|minamiawaji\.hyogo\.jp|nishinomiya\.hyogo\.jp|nishiwaki\.hyogo\.jp|ono\.hyogo\.jp|sanda\.hyogo\.jp|sannan\.hyogo\.jp|sasayama\.hyogo\.jp|sayo\.hyogo\.jp|shingu\.hyogo\.jp|shinonsen\.hyogo\.jp|shiso\.hyogo\.jp|sumoto\.hyogo\.jp|taishi\.hyogo\.jp|taka\.hyogo\.jp|takarazuka\.hyogo\.jp|takasago\.hyogo\.jp|takino\.hyogo\.jp|tamba\.hyogo\.jp|tatsuno\.hyogo\.jp|toyooka\.hyogo\.jp|yabu\.hyogo\.jp|yashiro\.hyogo\.jp|yoka\.hyogo\.jp|yokawa\.hyogo\.jp|ami\.ibaraki\.jp|asahi\.ibaraki\.jp|bando\.ibaraki\.jp|chikusei\.ibaraki\.jp|daigo\.ibaraki\.jp|fujishiro\.ibaraki\.jp|hitachi\.ibaraki\.jp|hitachinaka\.ibaraki\.jp|hitachiomiya\.ibaraki\.jp|hitachiota\.ibaraki\.jp|ibaraki\.ibaraki\.jp|ina\.ibaraki\.jp|inashiki\.ibaraki\.jp|itako\.ibaraki\.jp|iwama\.ibaraki\.jp|joso\.ibaraki\.jp|kamisu\.ibaraki\.jp|kasama\.ibaraki\.jp|kashima\.ibaraki\.jp|kasumigaura\.ibaraki\.jp|koga\.ibaraki\.jp|miho\.ibaraki\.jp|mito\.ibaraki\.jp|moriya\.ibaraki\.jp|naka\.ibaraki\.jp|namegata\.ibaraki\.jp|oarai\.ibaraki\.jp|ogawa\.ibaraki\.jp|omitama\.ibaraki\.jp|ryugasaki\.ibaraki\.jp|sakai\.ibaraki\.jp|sakuragawa\.ibaraki\.jp|shimodate\.ibaraki\.jp|shimotsuma\.ibaraki\.jp|shirosato\.ibaraki\.jp|sowa\.ibaraki\.jp|suifu\.ibaraki\.jp|takahagi\.ibaraki\.jp|tamatsukuri\.ibaraki\.jp|tokai\.ibaraki\.jp|tomobe\.ibaraki\.jp|tone\.ibaraki\.jp|toride\.ibaraki\.jp|tsuchiura\.ibaraki\.jp|tsukuba\.ibaraki\.jp|uchihara\.ibaraki\.jp|ushiku\.ibaraki\.jp|yachiyo\.ibaraki\.jp|yamagata\.ibaraki\.jp|yawara\.ibaraki\.jp|yuki\.ibaraki\.jp|anamizu\.ishikawa\.jp|hakui\.ishikawa\.jp|hakusan\.ishikawa\.jp|kaga\.ishikawa\.jp|kahoku\.ishikawa\.jp|kanazawa\.ishikawa\.jp|kawakita\.ishikawa\.jp|komatsu\.ishikawa\.jp|nakanoto\.ishikawa\.jp|nanao\.ishikawa\.jp|nomi\.ishikawa\.jp|nonoichi\.ishikawa\.jp|noto\.ishikawa\.jp|shika\.ishikawa\.jp|suzu\.ishikawa\.jp|tsubata\.ishikawa\.jp|tsurugi\.ishikawa\.jp|uchinada\.ishikawa\.jp|wajima\.ishikawa\.jp|fudai\.iwate\.jp|fujisawa\.iwate\.jp|hanamaki\.iwate\.jp|hiraizumi\.iwate\.jp|hirono\.iwate\.jp|ichinohe\.iwate\.jp|ichinoseki\.iwate\.jp|iwaizumi\.iwate\.jp|iwate\.iwate\.jp|joboji\.iwate\.jp|kamaishi\.iwate\.jp|kanegasaki\.iwate\.jp|karumai\.iwate\.jp|kawai\.iwate\.jp|kitakami\.iwate\.jp|kuji\.iwate\.jp|kunohe\.iwate\.jp|kuzumaki\.iwate\.jp|miyako\.iwate\.jp|mizusawa\.iwate\.jp|morioka\.iwate\.jp|ninohe\.iwate\.jp|noda\.iwate\.jp|ofunato\.iwate\.jp|oshu\.iwate\.jp|otsuchi\.iwate\.jp|rikuzentakata\.iwate\.jp|shiwa\.iwate\.jp|shizukuishi\.iwate\.jp|sumita\.iwate\.jp|tanohata\.iwate\.jp|tono\.iwate\.jp|yahaba\.iwate\.jp|yamada\.iwate\.jp|ayagawa\.kagawa\.jp|higashikagawa\.kagawa\.jp|kanonji\.kagawa\.jp|kotohira\.kagawa\.jp|manno\.kagawa\.jp|marugame\.kagawa\.jp|mitoyo\.kagawa\.jp|naoshima\.kagawa\.jp|sanuki\.kagawa\.jp|tadotsu\.kagawa\.jp|takamatsu\.kagawa\.jp|tonosho\.kagawa\.jp|uchinomi\.kagawa\.jp|utazu\.kagawa\.jp|zentsuji\.kagawa\.jp|akune\.kagoshima\.jp|amami\.kagoshima\.jp|hioki\.kagoshima\.jp|isa\.kagoshima\.jp|isen\.kagoshima\.jp|izumi\.kagoshima\.jp|kagoshima\.kagoshima\.jp|kanoya\.kagoshima\.jp|kawanabe\.kagoshima\.jp|kinko\.kagoshima\.jp|kouyama\.kagoshima\.jp|makurazaki\.kagoshima\.jp|matsumoto\.kagoshima\.jp|minamitane\.kagoshima\.jp|nakatane\.kagoshima\.jp|nishinoomote\.kagoshima\.jp|satsumasendai\.kagoshima\.jp|soo\.kagoshima\.jp|tarumizu\.kagoshima\.jp|yusui\.kagoshima\.jp|aikawa\.kanagawa\.jp|atsugi\.kanagawa\.jp|ayase\.kanagawa\.jp|chigasaki\.kanagawa\.jp|ebina\.kanagawa\.jp|fujisawa\.kanagawa\.jp|hadano\.kanagawa\.jp|hakone\.kanagawa\.jp|hiratsuka\.kanagawa\.jp|isehara\.kanagawa\.jp|kaisei\.kanagawa\.jp|kamakura\.kanagawa\.jp|kiyokawa\.kanagawa\.jp|matsuda\.kanagawa\.jp|minamiashigara\.kanagawa\.jp|miura\.kanagawa\.jp|nakai\.kanagawa\.jp|ninomiya\.kanagawa\.jp|odawara\.kanagawa\.jp|oi\.kanagawa\.jp|oiso\.kanagawa\.jp|sagamihara\.kanagawa\.jp|samukawa\.kanagawa\.jp|tsukui\.kanagawa\.jp|yamakita\.kanagawa\.jp|yamato\.kanagawa\.jp|yokosuka\.kanagawa\.jp|yugawara\.kanagawa\.jp|zama\.kanagawa\.jp|zushi\.kanagawa\.jp|aki\.kochi\.jp|geisei\.kochi\.jp|hidaka\.kochi\.jp|higashitsuno\.kochi\.jp|ino\.kochi\.jp|kagami\.kochi\.jp|kami\.kochi\.jp|kitagawa\.kochi\.jp|kochi\.kochi\.jp|mihara\.kochi\.jp|motoyama\.kochi\.jp|muroto\.kochi\.jp|nahari\.kochi\.jp|nakamura\.kochi\.jp|nankoku\.kochi\.jp|nishitosa\.kochi\.jp|niyodogawa\.kochi\.jp|ochi\.kochi\.jp|okawa\.kochi\.jp|otoyo\.kochi\.jp|otsuki\.kochi\.jp|sakawa\.kochi\.jp|sukumo\.kochi\.jp|susaki\.kochi\.jp|tosa\.kochi\.jp|tosashimizu\.kochi\.jp|toyo\.kochi\.jp|tsuno\.kochi\.jp|umaji\.kochi\.jp|yasuda\.kochi\.jp|yusuhara\.kochi\.jp|amakusa\.kumamoto\.jp|arao\.kumamoto\.jp|aso\.kumamoto\.jp|choyo\.kumamoto\.jp|gyokuto\.kumamoto\.jp|kamiamakusa\.kumamoto\.jp|kikuchi\.kumamoto\.jp|kumamoto\.kumamoto\.jp|mashiki\.kumamoto\.jp|mifune\.kumamoto\.jp|minamata\.kumamoto\.jp|minamioguni\.kumamoto\.jp|nagasu\.kumamoto\.jp|nishihara\.kumamoto\.jp|oguni\.kumamoto\.jp|ozu\.kumamoto\.jp|sumoto\.kumamoto\.jp|takamori\.kumamoto\.jp|uki\.kumamoto\.jp|uto\.kumamoto\.jp|yamaga\.kumamoto\.jp|yamato\.kumamoto\.jp|yatsushiro\.kumamoto\.jp|ayabe\.kyoto\.jp|fukuchiyama\.kyoto\.jp|higashiyama\.kyoto\.jp|ide\.kyoto\.jp|ine\.kyoto\.jp|joyo\.kyoto\.jp|kameoka\.kyoto\.jp|kamo\.kyoto\.jp|kita\.kyoto\.jp|kizu\.kyoto\.jp|kumiyama\.kyoto\.jp|kyotamba\.kyoto\.jp|kyotanabe\.kyoto\.jp|kyotango\.kyoto\.jp|maizuru\.kyoto\.jp|minami\.kyoto\.jp|minamiyamashiro\.kyoto\.jp|miyazu\.kyoto\.jp|muko\.kyoto\.jp|nagaokakyo\.kyoto\.jp|nakagyo\.kyoto\.jp|nantan\.kyoto\.jp|oyamazaki\.kyoto\.jp|sakyo\.kyoto\.jp|seika\.kyoto\.jp|tanabe\.kyoto\.jp|uji\.kyoto\.jp|ujitawara\.kyoto\.jp|wazuka\.kyoto\.jp|yamashina\.kyoto\.jp|yawata\.kyoto\.jp|asahi\.mie\.jp|inabe\.mie\.jp|ise\.mie\.jp|kameyama\.mie\.jp|kawagoe\.mie\.jp|kiho\.mie\.jp|kisosaki\.mie\.jp|kiwa\.mie\.jp|komono\.mie\.jp|kumano\.mie\.jp|kuwana\.mie\.jp|matsusaka\.mie\.jp|meiwa\.mie\.jp|mihama\.mie\.jp|minamiise\.mie\.jp|misugi\.mie\.jp|miyama\.mie\.jp|nabari\.mie\.jp|shima\.mie\.jp|suzuka\.mie\.jp|tado\.mie\.jp|taiki\.mie\.jp|taki\.mie\.jp|tamaki\.mie\.jp|toba\.mie\.jp|tsu\.mie\.jp|udono\.mie\.jp|ureshino\.mie\.jp|watarai\.mie\.jp|yokkaichi\.mie\.jp|furukawa\.miyagi\.jp|higashimatsushima\.miyagi\.jp|ishinomaki\.miyagi\.jp|iwanuma\.miyagi\.jp|kakuda\.miyagi\.jp|kami\.miyagi\.jp|kawasaki\.miyagi\.jp|marumori\.miyagi\.jp|matsushima\.miyagi\.jp|minamisanriku\.miyagi\.jp|misato\.miyagi\.jp|murata\.miyagi\.jp|natori\.miyagi\.jp|ogawara\.miyagi\.jp|ohira\.miyagi\.jp|onagawa\.miyagi\.jp|osaki\.miyagi\.jp|rifu\.miyagi\.jp|semine\.miyagi\.jp|shibata\.miyagi\.jp|shichikashuku\.miyagi\.jp|shikama\.miyagi\.jp|shiogama\.miyagi\.jp|shiroishi\.miyagi\.jp|tagajo\.miyagi\.jp|taiwa\.miyagi\.jp|tome\.miyagi\.jp|tomiya\.miyagi\.jp|wakuya\.miyagi\.jp|watari\.miyagi\.jp|yamamoto\.miyagi\.jp|zao\.miyagi\.jp|aya\.miyazaki\.jp|ebino\.miyazaki\.jp|gokase\.miyazaki\.jp|hyuga\.miyazaki\.jp|kadogawa\.miyazaki\.jp|kawaminami\.miyazaki\.jp|kijo\.miyazaki\.jp|kitagawa\.miyazaki\.jp|kitakata\.miyazaki\.jp|kitaura\.miyazaki\.jp|kobayashi\.miyazaki\.jp|kunitomi\.miyazaki\.jp|kushima\.miyazaki\.jp|mimata\.miyazaki\.jp|miyakonojo\.miyazaki\.jp|miyazaki\.miyazaki\.jp|morotsuka\.miyazaki\.jp|nichinan\.miyazaki\.jp|nishimera\.miyazaki\.jp|nobeoka\.miyazaki\.jp|saito\.miyazaki\.jp|shiiba\.miyazaki\.jp|shintomi\.miyazaki\.jp|takaharu\.miyazaki\.jp|takanabe\.miyazaki\.jp|takazaki\.miyazaki\.jp|tsuno\.miyazaki\.jp|achi\.nagano\.jp|agematsu\.nagano\.jp|anan\.nagano\.jp|aoki\.nagano\.jp|asahi\.nagano\.jp|azumino\.nagano\.jp|chikuhoku\.nagano\.jp|chikuma\.nagano\.jp|chino\.nagano\.jp|fujimi\.nagano\.jp|hakuba\.nagano\.jp|hara\.nagano\.jp|hiraya\.nagano\.jp|iida\.nagano\.jp|iijima\.nagano\.jp|iiyama\.nagano\.jp|iizuna\.nagano\.jp|ikeda\.nagano\.jp|ikusaka\.nagano\.jp|ina\.nagano\.jp|karuizawa\.nagano\.jp|kawakami\.nagano\.jp|kiso\.nagano\.jp|kisofukushima\.nagano\.jp|kitaaiki\.nagano\.jp|komagane\.nagano\.jp|komoro\.nagano\.jp|matsukawa\.nagano\.jp|matsumoto\.nagano\.jp|miasa\.nagano\.jp|minamiaiki\.nagano\.jp|minamimaki\.nagano\.jp|minamiminowa\.nagano\.jp|minowa\.nagano\.jp|miyada\.nagano\.jp|miyota\.nagano\.jp|mochizuki\.nagano\.jp|nagano\.nagano\.jp|nagawa\.nagano\.jp|nagiso\.nagano\.jp|nakagawa\.nagano\.jp|nakano\.nagano\.jp|nozawaonsen\.nagano\.jp|obuse\.nagano\.jp|ogawa\.nagano\.jp|okaya\.nagano\.jp|omachi\.nagano\.jp|omi\.nagano\.jp|ookuwa\.nagano\.jp|ooshika\.nagano\.jp|otaki\.nagano\.jp|otari\.nagano\.jp|sakae\.nagano\.jp|sakaki\.nagano\.jp|saku\.nagano\.jp|sakuho\.nagano\.jp|shimosuwa\.nagano\.jp|shinanomachi\.nagano\.jp|shiojiri\.nagano\.jp|suwa\.nagano\.jp|suzaka\.nagano\.jp|takagi\.nagano\.jp|takamori\.nagano\.jp|takayama\.nagano\.jp|tateshina\.nagano\.jp|tatsuno\.nagano\.jp|togakushi\.nagano\.jp|togura\.nagano\.jp|tomi\.nagano\.jp|ueda\.nagano\.jp|wada\.nagano\.jp|yamagata\.nagano\.jp|yamanouchi\.nagano\.jp|yasaka\.nagano\.jp|yasuoka\.nagano\.jp|chijiwa\.nagasaki\.jp|futsu\.nagasaki\.jp|goto\.nagasaki\.jp|hasami\.nagasaki\.jp|hirado\.nagasaki\.jp|iki\.nagasaki\.jp|isahaya\.nagasaki\.jp|kawatana\.nagasaki\.jp|kuchinotsu\.nagasaki\.jp|matsuura\.nagasaki\.jp|nagasaki\.nagasaki\.jp|obama\.nagasaki\.jp|omura\.nagasaki\.jp|oseto\.nagasaki\.jp|saikai\.nagasaki\.jp|sasebo\.nagasaki\.jp|seihi\.nagasaki\.jp|shimabara\.nagasaki\.jp|shinkamigoto\.nagasaki\.jp|togitsu\.nagasaki\.jp|tsushima\.nagasaki\.jp|unzen\.nagasaki\.jp|ando\.nara\.jp|gose\.nara\.jp|heguri\.nara\.jp|higashiyoshino\.nara\.jp|ikaruga\.nara\.jp|ikoma\.nara\.jp|kamikitayama\.nara\.jp|kanmaki\.nara\.jp|kashiba\.nara\.jp|kashihara\.nara\.jp|katsuragi\.nara\.jp|kawai\.nara\.jp|kawakami\.nara\.jp|kawanishi\.nara\.jp|koryo\.nara\.jp|kurotaki\.nara\.jp|mitsue\.nara\.jp|miyake\.nara\.jp|nara\.nara\.jp|nosegawa\.nara\.jp|oji\.nara\.jp|ouda\.nara\.jp|oyodo\.nara\.jp|sakurai\.nara\.jp|sango\.nara\.jp|shimoichi\.nara\.jp|shimokitayama\.nara\.jp|shinjo\.nara\.jp|soni\.nara\.jp|takatori\.nara\.jp|tawaramoto\.nara\.jp|tenkawa\.nara\.jp|tenri\.nara\.jp|uda\.nara\.jp|yamatokoriyama\.nara\.jp|yamatotakada\.nara\.jp|yamazoe\.nara\.jp|yoshino\.nara\.jp|aga\.niigata\.jp|agano\.niigata\.jp|gosen\.niigata\.jp|itoigawa\.niigata\.jp|izumozaki\.niigata\.jp|joetsu\.niigata\.jp|kamo\.niigata\.jp|kariwa\.niigata\.jp|kashiwazaki\.niigata\.jp|minamiuonuma\.niigata\.jp|mitsuke\.niigata\.jp|muika\.niigata\.jp|murakami\.niigata\.jp|myoko\.niigata\.jp|nagaoka\.niigata\.jp|niigata\.niigata\.jp|ojiya\.niigata\.jp|omi\.niigata\.jp|sado\.niigata\.jp|sanjo\.niigata\.jp|seiro\.niigata\.jp|seirou\.niigata\.jp|sekikawa\.niigata\.jp|shibata\.niigata\.jp|tagami\.niigata\.jp|tainai\.niigata\.jp|tochio\.niigata\.jp|tokamachi\.niigata\.jp|tsubame\.niigata\.jp|tsunan\.niigata\.jp|uonuma\.niigata\.jp|yahiko\.niigata\.jp|yoita\.niigata\.jp|yuzawa\.niigata\.jp|beppu\.oita\.jp|bungoono\.oita\.jp|bungotakada\.oita\.jp|hasama\.oita\.jp|hiji\.oita\.jp|himeshima\.oita\.jp|hita\.oita\.jp|kamitsue\.oita\.jp|kokonoe\.oita\.jp|kuju\.oita\.jp|kunisaki\.oita\.jp|kusu\.oita\.jp|oita\.oita\.jp|saiki\.oita\.jp|taketa\.oita\.jp|tsukumi\.oita\.jp|usa\.oita\.jp|usuki\.oita\.jp|yufu\.oita\.jp|akaiwa\.okayama\.jp|asakuchi\.okayama\.jp|bizen\.okayama\.jp|hayashima\.okayama\.jp|ibara\.okayama\.jp|kagamino\.okayama\.jp|kasaoka\.okayama\.jp|kibichuo\.okayama\.jp|kumenan\.okayama\.jp|kurashiki\.okayama\.jp|maniwa\.okayama\.jp|misaki\.okayama\.jp|nagi\.okayama\.jp|niimi\.okayama\.jp|nishiawakura\.okayama\.jp|okayama\.okayama\.jp|satosho\.okayama\.jp|setouchi\.okayama\.jp|shinjo\.okayama\.jp|shoo\.okayama\.jp|soja\.okayama\.jp|takahashi\.okayama\.jp|tamano\.okayama\.jp|tsuyama\.okayama\.jp|wake\.okayama\.jp|yakage\.okayama\.jp|aguni\.okinawa\.jp|ginowan\.okinawa\.jp|ginoza\.okinawa\.jp|gushikami\.okinawa\.jp|haebaru\.okinawa\.jp|higashi\.okinawa\.jp|hirara\.okinawa\.jp|iheya\.okinawa\.jp|ishigaki\.okinawa\.jp|ishikawa\.okinawa\.jp|itoman\.okinawa\.jp|izena\.okinawa\.jp|kadena\.okinawa\.jp|kin\.okinawa\.jp|kitadaito\.okinawa\.jp|kitanakagusuku\.okinawa\.jp|kumejima\.okinawa\.jp|kunigami\.okinawa\.jp|minamidaito\.okinawa\.jp|motobu\.okinawa\.jp|nago\.okinawa\.jp|naha\.okinawa\.jp|nakagusuku\.okinawa\.jp|nakijin\.okinawa\.jp|nanjo\.okinawa\.jp|nishihara\.okinawa\.jp|ogimi\.okinawa\.jp|okinawa\.okinawa\.jp|onna\.okinawa\.jp|shimoji\.okinawa\.jp|taketomi\.okinawa\.jp|tarama\.okinawa\.jp|tokashiki\.okinawa\.jp|tomigusuku\.okinawa\.jp|tonaki\.okinawa\.jp|urasoe\.okinawa\.jp|uruma\.okinawa\.jp|yaese\.okinawa\.jp|yomitan\.okinawa\.jp|yonabaru\.okinawa\.jp|yonaguni\.okinawa\.jp|zamami\.okinawa\.jp|abeno\.osaka\.jp|chihayaakasaka\.osaka\.jp|chuo\.osaka\.jp|daito\.osaka\.jp|fujiidera\.osaka\.jp|habikino\.osaka\.jp|hannan\.osaka\.jp|higashiosaka\.osaka\.jp|higashisumiyoshi\.osaka\.jp|higashiyodogawa\.osaka\.jp|hirakata\.osaka\.jp|ibaraki\.osaka\.jp|ikeda\.osaka\.jp|izumi\.osaka\.jp|izumiotsu\.osaka\.jp|izumisano\.osaka\.jp|kadoma\.osaka\.jp|kaizuka\.osaka\.jp|kanan\.osaka\.jp|kashiwara\.osaka\.jp|katano\.osaka\.jp|kawachinagano\.osaka\.jp|kishiwada\.osaka\.jp|kita\.osaka\.jp|kumatori\.osaka\.jp|matsubara\.osaka\.jp|minato\.osaka\.jp|minoh\.osaka\.jp|misaki\.osaka\.jp|moriguchi\.osaka\.jp|neyagawa\.osaka\.jp|nishi\.osaka\.jp|nose\.osaka\.jp|osakasayama\.osaka\.jp|sakai\.osaka\.jp|sayama\.osaka\.jp|sennan\.osaka\.jp|settsu\.osaka\.jp|shijonawate\.osaka\.jp|shimamoto\.osaka\.jp|suita\.osaka\.jp|tadaoka\.osaka\.jp|taishi\.osaka\.jp|tajiri\.osaka\.jp|takaishi\.osaka\.jp|takatsuki\.osaka\.jp|tondabayashi\.osaka\.jp|toyonaka\.osaka\.jp|toyono\.osaka\.jp|yao\.osaka\.jp|ariake\.saga\.jp|arita\.saga\.jp|fukudomi\.saga\.jp|genkai\.saga\.jp|hamatama\.saga\.jp|hizen\.saga\.jp|imari\.saga\.jp|kamimine\.saga\.jp|kanzaki\.saga\.jp|karatsu\.saga\.jp|kashima\.saga\.jp|kitagata\.saga\.jp|kitahata\.saga\.jp|kiyama\.saga\.jp|kouhoku\.saga\.jp|kyuragi\.saga\.jp|nishiarita\.saga\.jp|ogi\.saga\.jp|omachi\.saga\.jp|ouchi\.saga\.jp|saga\.saga\.jp|shiroishi\.saga\.jp|taku\.saga\.jp|tara\.saga\.jp|tosu\.saga\.jp|yoshinogari\.saga\.jp|arakawa\.saitama\.jp|asaka\.saitama\.jp|chichibu\.saitama\.jp|fujimi\.saitama\.jp|fujimino\.saitama\.jp|fukaya\.saitama\.jp|hanno\.saitama\.jp|hanyu\.saitama\.jp|hasuda\.saitama\.jp|hatogaya\.saitama\.jp|hatoyama\.saitama\.jp|hidaka\.saitama\.jp|higashichichibu\.saitama\.jp|higashimatsuyama\.saitama\.jp|honjo\.saitama\.jp|ina\.saitama\.jp|iruma\.saitama\.jp|iwatsuki\.saitama\.jp|kamiizumi\.saitama\.jp|kamikawa\.saitama\.jp|kamisato\.saitama\.jp|kasukabe\.saitama\.jp|kawagoe\.saitama\.jp|kawaguchi\.saitama\.jp|kawajima\.saitama\.jp|kazo\.saitama\.jp|kitamoto\.saitama\.jp|koshigaya\.saitama\.jp|kounosu\.saitama\.jp|kuki\.saitama\.jp|kumagaya\.saitama\.jp|matsubushi\.saitama\.jp|minano\.saitama\.jp|misato\.saitama\.jp|miyashiro\.saitama\.jp|miyoshi\.saitama\.jp|moroyama\.saitama\.jp|nagatoro\.saitama\.jp|namegawa\.saitama\.jp|niiza\.saitama\.jp|ogano\.saitama\.jp|ogawa\.saitama\.jp|ogose\.saitama\.jp|okegawa\.saitama\.jp|omiya\.saitama\.jp|otaki\.saitama\.jp|ranzan\.saitama\.jp|ryokami\.saitama\.jp|saitama\.saitama\.jp|sakado\.saitama\.jp|satte\.saitama\.jp|sayama\.saitama\.jp|shiki\.saitama\.jp|shiraoka\.saitama\.jp|soka\.saitama\.jp|sugito\.saitama\.jp|toda\.saitama\.jp|tokigawa\.saitama\.jp|tokorozawa\.saitama\.jp|tsurugashima\.saitama\.jp|urawa\.saitama\.jp|warabi\.saitama\.jp|yashio\.saitama\.jp|yokoze\.saitama\.jp|yono\.saitama\.jp|yorii\.saitama\.jp|yoshida\.saitama\.jp|yoshikawa\.saitama\.jp|yoshimi\.saitama\.jp|aisho\.shiga\.jp|gamo\.shiga\.jp|higashiomi\.shiga\.jp|hikone\.shiga\.jp|koka\.shiga\.jp|konan\.shiga\.jp|kosei\.shiga\.jp|koto\.shiga\.jp|kusatsu\.shiga\.jp|maibara\.shiga\.jp|moriyama\.shiga\.jp|nagahama\.shiga\.jp|nishiazai\.shiga\.jp|notogawa\.shiga\.jp|omihachiman\.shiga\.jp|otsu\.shiga\.jp|ritto\.shiga\.jp|ryuoh\.shiga\.jp|takashima\.shiga\.jp|takatsuki\.shiga\.jp|torahime\.shiga\.jp|toyosato\.shiga\.jp|yasu\.shiga\.jp|akagi\.shimane\.jp|ama\.shimane\.jp|gotsu\.shimane\.jp|hamada\.shimane\.jp|higashiizumo\.shimane\.jp|hikawa\.shimane\.jp|hikimi\.shimane\.jp|izumo\.shimane\.jp|kakinoki\.shimane\.jp|masuda\.shimane\.jp|matsue\.shimane\.jp|misato\.shimane\.jp|nishinoshima\.shimane\.jp|ohda\.shimane\.jp|okinoshima\.shimane\.jp|okuizumo\.shimane\.jp|shimane\.shimane\.jp|tamayu\.shimane\.jp|tsuwano\.shimane\.jp|unnan\.shimane\.jp|yakumo\.shimane\.jp|yasugi\.shimane\.jp|yatsuka\.shimane\.jp|arai\.shizuoka\.jp|atami\.shizuoka\.jp|fuji\.shizuoka\.jp|fujieda\.shizuoka\.jp|fujikawa\.shizuoka\.jp|fujinomiya\.shizuoka\.jp|fukuroi\.shizuoka\.jp|gotemba\.shizuoka\.jp|haibara\.shizuoka\.jp|hamamatsu\.shizuoka\.jp|higashiizu\.shizuoka\.jp|ito\.shizuoka\.jp|iwata\.shizuoka\.jp|izu\.shizuoka\.jp|izunokuni\.shizuoka\.jp|kakegawa\.shizuoka\.jp|kannami\.shizuoka\.jp|kawanehon\.shizuoka\.jp|kawazu\.shizuoka\.jp|kikugawa\.shizuoka\.jp|kosai\.shizuoka\.jp|makinohara\.shizuoka\.jp|matsuzaki\.shizuoka\.jp|minamiizu\.shizuoka\.jp|mishima\.shizuoka\.jp|morimachi\.shizuoka\.jp|nishiizu\.shizuoka\.jp|numazu\.shizuoka\.jp|omaezaki\.shizuoka\.jp|shimada\.shizuoka\.jp|shimizu\.shizuoka\.jp|shimoda\.shizuoka\.jp|shizuoka\.shizuoka\.jp|susono\.shizuoka\.jp|yaizu\.shizuoka\.jp|yoshida\.shizuoka\.jp|ashikaga\.tochigi\.jp|bato\.tochigi\.jp|haga\.tochigi\.jp|ichikai\.tochigi\.jp|iwafune\.tochigi\.jp|kaminokawa\.tochigi\.jp|kanuma\.tochigi\.jp|karasuyama\.tochigi\.jp|kuroiso\.tochigi\.jp|mashiko\.tochigi\.jp|mibu\.tochigi\.jp|moka\.tochigi\.jp|motegi\.tochigi\.jp|nasu\.tochigi\.jp|nasushiobara\.tochigi\.jp|nikko\.tochigi\.jp|nishikata\.tochigi\.jp|nogi\.tochigi\.jp|ohira\.tochigi\.jp|ohtawara\.tochigi\.jp|oyama\.tochigi\.jp|sakura\.tochigi\.jp|sano\.tochigi\.jp|shimotsuke\.tochigi\.jp|shioya\.tochigi\.jp|takanezawa\.tochigi\.jp|tochigi\.tochigi\.jp|tsuga\.tochigi\.jp|ujiie\.tochigi\.jp|utsunomiya\.tochigi\.jp|yaita\.tochigi\.jp|aizumi\.tokushima\.jp|anan\.tokushima\.jp|ichiba\.tokushima\.jp|itano\.tokushima\.jp|kainan\.tokushima\.jp|komatsushima\.tokushima\.jp|matsushige\.tokushima\.jp|mima\.tokushima\.jp|minami\.tokushima\.jp|miyoshi\.tokushima\.jp|mugi\.tokushima\.jp|nakagawa\.tokushima\.jp|naruto\.tokushima\.jp|sanagochi\.tokushima\.jp|shishikui\.tokushima\.jp|tokushima\.tokushima\.jp|wajiki\.tokushima\.jp|adachi\.tokyo\.jp|akiruno\.tokyo\.jp|akishima\.tokyo\.jp|aogashima\.tokyo\.jp|arakawa\.tokyo\.jp|bunkyo\.tokyo\.jp|chiyoda\.tokyo\.jp|chofu\.tokyo\.jp|chuo\.tokyo\.jp|edogawa\.tokyo\.jp|fuchu\.tokyo\.jp|fussa\.tokyo\.jp|hachijo\.tokyo\.jp|hachioji\.tokyo\.jp|hamura\.tokyo\.jp|higashikurume\.tokyo\.jp|higashimurayama\.tokyo\.jp|higashiyamato\.tokyo\.jp|hino\.tokyo\.jp|hinode\.tokyo\.jp|hinohara\.tokyo\.jp|inagi\.tokyo\.jp|itabashi\.tokyo\.jp|katsushika\.tokyo\.jp|kita\.tokyo\.jp|kiyose\.tokyo\.jp|kodaira\.tokyo\.jp|koganei\.tokyo\.jp|kokubunji\.tokyo\.jp|komae\.tokyo\.jp|koto\.tokyo\.jp|kouzushima\.tokyo\.jp|kunitachi\.tokyo\.jp|machida\.tokyo\.jp|meguro\.tokyo\.jp|minato\.tokyo\.jp|mitaka\.tokyo\.jp|mizuho\.tokyo\.jp|musashimurayama\.tokyo\.jp|musashino\.tokyo\.jp|nakano\.tokyo\.jp|nerima\.tokyo\.jp|ogasawara\.tokyo\.jp|okutama\.tokyo\.jp|ome\.tokyo\.jp|oshima\.tokyo\.jp|ota\.tokyo\.jp|setagaya\.tokyo\.jp|shibuya\.tokyo\.jp|shinagawa\.tokyo\.jp|shinjuku\.tokyo\.jp|suginami\.tokyo\.jp|sumida\.tokyo\.jp|tachikawa\.tokyo\.jp|taito\.tokyo\.jp|tama\.tokyo\.jp|toshima\.tokyo\.jp|chizu\.tottori\.jp|hino\.tottori\.jp|kawahara\.tottori\.jp|koge\.tottori\.jp|kotoura\.tottori\.jp|misasa\.tottori\.jp|nanbu\.tottori\.jp|nichinan\.tottori\.jp|sakaiminato\.tottori\.jp|tottori\.tottori\.jp|wakasa\.tottori\.jp|yazu\.tottori\.jp|yonago\.tottori\.jp|asahi\.toyama\.jp|fuchu\.toyama\.jp|fukumitsu\.toyama\.jp|funahashi\.toyama\.jp|himi\.toyama\.jp|imizu\.toyama\.jp|inami\.toyama\.jp|johana\.toyama\.jp|kamiichi\.toyama\.jp|kurobe\.toyama\.jp|nakaniikawa\.toyama\.jp|namerikawa\.toyama\.jp|nanto\.toyama\.jp|nyuzen\.toyama\.jp|oyabe\.toyama\.jp|taira\.toyama\.jp|takaoka\.toyama\.jp|tateyama\.toyama\.jp|toga\.toyama\.jp|tonami\.toyama\.jp|toyama\.toyama\.jp|unazuki\.toyama\.jp|uozu\.toyama\.jp|yamada\.toyama\.jp|arida\.wakayama\.jp|aridagawa\.wakayama\.jp|gobo\.wakayama\.jp|hashimoto\.wakayama\.jp|hidaka\.wakayama\.jp|hirogawa\.wakayama\.jp|inami\.wakayama\.jp|iwade\.wakayama\.jp|kainan\.wakayama\.jp|kamitonda\.wakayama\.jp|katsuragi\.wakayama\.jp|kimino\.wakayama\.jp|kinokawa\.wakayama\.jp|kitayama\.wakayama\.jp|koya\.wakayama\.jp|koza\.wakayama\.jp|kozagawa\.wakayama\.jp|kudoyama\.wakayama\.jp|kushimoto\.wakayama\.jp|mihama\.wakayama\.jp|misato\.wakayama\.jp|nachikatsuura\.wakayama\.jp|shingu\.wakayama\.jp|shirahama\.wakayama\.jp|taiji\.wakayama\.jp|tanabe\.wakayama\.jp|wakayama\.wakayama\.jp|yuasa\.wakayama\.jp|yura\.wakayama\.jp|asahi\.yamagata\.jp|funagata\.yamagata\.jp|higashine\.yamagata\.jp|iide\.yamagata\.jp|kahoku\.yamagata\.jp|kaminoyama\.yamagata\.jp|kaneyama\.yamagata\.jp|kawanishi\.yamagata\.jp|mamurogawa\.yamagata\.jp|mikawa\.yamagata\.jp|murayama\.yamagata\.jp|nagai\.yamagata\.jp|nakayama\.yamagata\.jp|nanyo\.yamagata\.jp|nishikawa\.yamagata\.jp|obanazawa\.yamagata\.jp|oe\.yamagata\.jp|oguni\.yamagata\.jp|ohkura\.yamagata\.jp|oishida\.yamagata\.jp|sagae\.yamagata\.jp|sakata\.yamagata\.jp|sakegawa\.yamagata\.jp|shinjo\.yamagata\.jp|shirataka\.yamagata\.jp|shonai\.yamagata\.jp|takahata\.yamagata\.jp|tendo\.yamagata\.jp|tozawa\.yamagata\.jp|tsuruoka\.yamagata\.jp|yamagata\.yamagata\.jp|yamanobe\.yamagata\.jp|yonezawa\.yamagata\.jp|yuza\.yamagata\.jp|abu\.yamaguchi\.jp|hagi\.yamaguchi\.jp|hikari\.yamaguchi\.jp|hofu\.yamaguchi\.jp|iwakuni\.yamaguchi\.jp|kudamatsu\.yamaguchi\.jp|mitou\.yamaguchi\.jp|nagato\.yamaguchi\.jp|oshima\.yamaguchi\.jp|shimonoseki\.yamaguchi\.jp|shunan\.yamaguchi\.jp|tabuse\.yamaguchi\.jp|tokuyama\.yamaguchi\.jp|toyota\.yamaguchi\.jp|ube\.yamaguchi\.jp|yuu\.yamaguchi\.jp|chuo\.yamanashi\.jp|doshi\.yamanashi\.jp|fuefuki\.yamanashi\.jp|fujikawa\.yamanashi\.jp|fujikawaguchiko\.yamanashi\.jp|fujiyoshida\.yamanashi\.jp|hayakawa\.yamanashi\.jp|hokuto\.yamanashi\.jp|ichikawamisato\.yamanashi\.jp|kai\.yamanashi\.jp|kofu\.yamanashi\.jp|koshu\.yamanashi\.jp|kosuge\.yamanashi\.jp|minami-alps\.yamanashi\.jp|minobu\.yamanashi\.jp|nakamichi\.yamanashi\.jp|nanbu\.yamanashi\.jp|narusawa\.yamanashi\.jp|nirasaki\.yamanashi\.jp|nishikatsura\.yamanashi\.jp|oshino\.yamanashi\.jp|otsuki\.yamanashi\.jp|showa\.yamanashi\.jp|tabayama\.yamanashi\.jp|tsuru\.yamanashi\.jp|uenohara\.yamanashi\.jp|yamanakako\.yamanashi\.jp|yamanashi\.yamanashi\.jp|[^.]+\.ke|kg|org\.kg|net\.kg|com\.kg|edu\.kg|gov\.kg|mil\.kg|[^.]+\.kh|ki|edu\.ki|biz\.ki|net\.ki|org\.ki|gov\.ki|info\.ki|com\.ki|km|org\.km|nom\.km|gov\.km|prd\.km|tm\.km|edu\.km|mil\.km|ass\.km|com\.km|coop\.km|asso\.km|presse\.km|medecin\.km|notaires\.km|pharmaciens\.km|veterinaire\.km|gouv\.km|kn|net\.kn|org\.kn|edu\.kn|gov\.kn|kp|com\.kp|edu\.kp|gov\.kp|org\.kp|rep\.kp|tra\.kp|kr|ac\.kr|co\.kr|es\.kr|go\.kr|hs\.kr|kg\.kr|mil\.kr|ms\.kr|ne\.kr|or\.kr|pe\.kr|re\.kr|sc\.kr|busan\.kr|chungbuk\.kr|chungnam\.kr|daegu\.kr|daejeon\.kr|gangwon\.kr|gwangju\.kr|gyeongbuk\.kr|gyeonggi\.kr|gyeongnam\.kr|incheon\.kr|jeju\.kr|jeonbuk\.kr|jeonnam\.kr|seoul\.kr|ulsan\.kr|[^.]+\.kw|ky|edu\.ky|gov\.ky|com\.ky|org\.ky|net\.ky|kz|org\.kz|edu\.kz|net\.kz|gov\.kz|mil\.kz|com\.kz|la|int\.la|net\.la|info\.la|edu\.la|gov\.la|per\.la|com\.la|org\.la|lb|com\.lb|edu\.lb|gov\.lb|net\.lb|org\.lb|lc|com\.lc|net\.lc|co\.lc|org\.lc|edu\.lc|gov\.lc|li|lk|gov\.lk|sch\.lk|net\.lk|int\.lk|com\.lk|org\.lk|edu\.lk|ngo\.lk|soc\.lk|web\.lk|ltd\.lk|assn\.lk|grp\.lk|hotel\.lk|ac\.lk|lr|com\.lr|edu\.lr|gov\.lr|org\.lr|net\.lr|ls|co\.ls|org\.ls|lt|gov\.lt|lu|lv|com\.lv|edu\.lv|gov\.lv|org\.lv|mil\.lv|id\.lv|net\.lv|asn\.lv|conf\.lv|ly|com\.ly|net\.ly|gov\.ly|plc\.ly|edu\.ly|sch\.ly|med\.ly|org\.ly|id\.ly|ma|co\.ma|net\.ma|gov\.ma|org\.ma|ac\.ma|press\.ma|mc|tm\.mc|asso\.mc|md|me|co\.me|net\.me|org\.me|edu\.me|ac\.me|gov\.me|its\.me|priv\.me|mg|org\.mg|nom\.mg|gov\.mg|prd\.mg|tm\.mg|edu\.mg|mil\.mg|com\.mg|co\.mg|mh|mil|mk|com\.mk|org\.mk|net\.mk|edu\.mk|gov\.mk|inf\.mk|name\.mk|ml|com\.ml|edu\.ml|gouv\.ml|gov\.ml|net\.ml|org\.ml|presse\.ml|[^.]+\.mm|mn|gov\.mn|edu\.mn|org\.mn|mo|com\.mo|net\.mo|org\.mo|edu\.mo|gov\.mo|mobi|mp|mq|mr|gov\.mr|ms|com\.ms|edu\.ms|gov\.ms|net\.ms|org\.ms|mt|com\.mt|edu\.mt|net\.mt|org\.mt|mu|com\.mu|net\.mu|org\.mu|gov\.mu|ac\.mu|co\.mu|or\.mu|museum|academy\.museum|agriculture\.museum|air\.museum|airguard\.museum|alabama\.museum|alaska\.museum|amber\.museum|ambulance\.museum|american\.museum|americana\.museum|americanantiques\.museum|americanart\.museum|amsterdam\.museum|and\.museum|annefrank\.museum|anthro\.museum|anthropology\.museum|antiques\.museum|aquarium\.museum|arboretum\.museum|archaeological\.museum|archaeology\.museum|architecture\.museum|art\.museum|artanddesign\.museum|artcenter\.museum|artdeco\.museum|arteducation\.museum|artgallery\.museum|arts\.museum|artsandcrafts\.museum|asmatart\.museum|assassination\.museum|assisi\.museum|association\.museum|astronomy\.museum|atlanta\.museum|austin\.museum|australia\.museum|automotive\.museum|aviation\.museum|axis\.museum|badajoz\.museum|baghdad\.museum|bahn\.museum|bale\.museum|baltimore\.museum|barcelona\.museum|baseball\.museum|basel\.museum|baths\.museum|bauern\.museum|beauxarts\.museum|beeldengeluid\.museum|bellevue\.museum|bergbau\.museum|berkeley\.museum|berlin\.museum|bern\.museum|bible\.museum|bilbao\.museum|bill\.museum|birdart\.museum|birthplace\.museum|bonn\.museum|boston\.museum|botanical\.museum|botanicalgarden\.museum|botanicgarden\.museum|botany\.museum|brandywinevalley\.museum|brasil\.museum|bristol\.museum|british\.museum|britishcolumbia\.museum|broadcast\.museum|brunel\.museum|brussel\.museum|brussels\.museum|bruxelles\.museum|building\.museum|burghof\.museum|bus\.museum|bushey\.museum|cadaques\.museum|california\.museum|cambridge\.museum|can\.museum|canada\.museum|capebreton\.museum|carrier\.museum|cartoonart\.museum|casadelamoneda\.museum|castle\.museum|castres\.museum|celtic\.museum|center\.museum|chattanooga\.museum|cheltenham\.museum|chesapeakebay\.museum|chicago\.museum|children\.museum|childrens\.museum|childrensgarden\.museum|chiropractic\.museum|chocolate\.museum|christiansburg\.museum|cincinnati\.museum|cinema\.museum|circus\.museum|civilisation\.museum|civilization\.museum|civilwar\.museum|clinton\.museum|clock\.museum|coal\.museum|coastaldefence\.museum|cody\.museum|coldwar\.museum|collection\.museum|colonialwilliamsburg\.museum|coloradoplateau\.museum|columbia\.museum|columbus\.museum|communication\.museum|communications\.museum|community\.museum|computer\.museum|computerhistory\.museum|comunicações\.museum|contemporary\.museum|contemporaryart\.museum|convent\.museum|copenhagen\.museum|corporation\.museum|correios-e-telecomunicações\.museum|corvette\.museum|costume\.museum|countryestate\.museum|county\.museum|crafts\.museum|cranbrook\.museum|creation\.museum|cultural\.museum|culturalcenter\.museum|culture\.museum|cyber\.museum|cymru\.museum|dali\.museum|dallas\.museum|database\.museum|ddr\.museum|decorativearts\.museum|delaware\.museum|delmenhorst\.museum|denmark\.museum|depot\.museum|design\.museum|detroit\.museum|dinosaur\.museum|discovery\.museum|dolls\.museum|donostia\.museum|durham\.museum|eastafrica\.museum|eastcoast\.museum|education\.museum|educational\.museum|egyptian\.museum|eisenbahn\.museum|elburg\.museum|elvendrell\.museum|embroidery\.museum|encyclopedic\.museum|england\.museum|entomology\.museum|environment\.museum|environmentalconservation\.museum|epilepsy\.museum|essex\.museum|estate\.museum|ethnology\.museum|exeter\.museum|exhibition\.museum|family\.museum|farm\.museum|farmequipment\.museum|farmers\.museum|farmstead\.museum|field\.museum|figueres\.museum|filatelia\.museum|film\.museum|fineart\.museum|finearts\.museum|finland\.museum|flanders\.museum|florida\.museum|force\.museum|fortmissoula\.museum|fortworth\.museum|foundation\.museum|francaise\.museum|frankfurt\.museum|franziskaner\.museum|freemasonry\.museum|freiburg\.museum|fribourg\.museum|frog\.museum|fundacio\.museum|furniture\.museum|gallery\.museum|garden\.museum|gateway\.museum|geelvinck\.museum|gemological\.museum|geology\.museum|georgia\.museum|giessen\.museum|glas\.museum|glass\.museum|gorge\.museum|grandrapids\.museum|graz\.museum|guernsey\.museum|halloffame\.museum|hamburg\.museum|handson\.museum|harvestcelebration\.museum|hawaii\.museum|health\.museum|heimatunduhren\.museum|hellas\.museum|helsinki\.museum|hembygdsforbund\.museum|heritage\.museum|histoire\.museum|historical\.museum|historicalsociety\.museum|historichouses\.museum|historisch\.museum|historisches\.museum|history\.museum|historyofscience\.museum|horology\.museum|house\.museum|humanities\.museum|illustration\.museum|imageandsound\.museum|indian\.museum|indiana\.museum|indianapolis\.museum|indianmarket\.museum|intelligence\.museum|interactive\.museum|iraq\.museum|iron\.museum|isleofman\.museum|jamison\.museum|jefferson\.museum|jerusalem\.museum|jewelry\.museum|jewish\.museum|jewishart\.museum|jfk\.museum|journalism\.museum|judaica\.museum|judygarland\.museum|juedisches\.museum|juif\.museum|karate\.museum|karikatur\.museum|kids\.museum|koebenhavn\.museum|koeln\.museum|kunst\.museum|kunstsammlung\.museum|kunstunddesign\.museum|labor\.museum|labour\.museum|lajolla\.museum|lancashire\.museum|landes\.museum|lans\.museum|läns\.museum|larsson\.museum|lewismiller\.museum|lincoln\.museum|linz\.museum|living\.museum|livinghistory\.museum|localhistory\.museum|london\.museum|losangeles\.museum|louvre\.museum|loyalist\.museum|lucerne\.museum|luxembourg\.museum|luzern\.museum|mad\.museum|madrid\.museum|mallorca\.museum|manchester\.museum|mansion\.museum|mansions\.museum|manx\.museum|marburg\.museum|maritime\.museum|maritimo\.museum|maryland\.museum|marylhurst\.museum|media\.museum|medical\.museum|medizinhistorisches\.museum|meeres\.museum|memorial\.museum|mesaverde\.museum|michigan\.museum|midatlantic\.museum|military\.museum|mill\.museum|miners\.museum|mining\.museum|minnesota\.museum|missile\.museum|missoula\.museum|modern\.museum|moma\.museum|money\.museum|monmouth\.museum|monticello\.museum|montreal\.museum|moscow\.museum|motorcycle\.museum|muenchen\.museum|muenster\.museum|mulhouse\.museum|muncie\.museum|museet\.museum|museumcenter\.museum|museumvereniging\.museum|music\.museum|national\.museum|nationalfirearms\.museum|nationalheritage\.museum|nativeamerican\.museum|naturalhistory\.museum|naturalhistorymuseum\.museum|naturalsciences\.museum|nature\.museum|naturhistorisches\.museum|natuurwetenschappen\.museum|naumburg\.museum|naval\.museum|nebraska\.museum|neues\.museum|newhampshire\.museum|newjersey\.museum|newmexico\.museum|newport\.museum|newspaper\.museum|newyork\.museum|niepce\.museum|norfolk\.museum|north\.museum|nrw\.museum|nuernberg\.museum|nuremberg\.museum|nyc\.museum|nyny\.museum|oceanographic\.museum|oceanographique\.museum|omaha\.museum|online\.museum|ontario\.museum|openair\.museum|oregon\.museum|oregontrail\.museum|otago\.museum|oxford\.museum|pacific\.museum|paderborn\.museum|palace\.museum|paleo\.museum|palmsprings\.museum|panama\.museum|paris\.museum|pasadena\.museum|pharmacy\.museum|philadelphia\.museum|philadelphiaarea\.museum|philately\.museum|phoenix\.museum|photography\.museum|pilots\.museum|pittsburgh\.museum|planetarium\.museum|plantation\.museum|plants\.museum|plaza\.museum|portal\.museum|portland\.museum|portlligat\.museum|posts-and-telecommunications\.museum|preservation\.museum|presidio\.museum|press\.museum|project\.museum|public\.museum|pubol\.museum|quebec\.museum|railroad\.museum|railway\.museum|research\.museum|resistance\.museum|riodejaneiro\.museum|rochester\.museum|rockart\.museum|roma\.museum|russia\.museum|saintlouis\.museum|salem\.museum|salvadordali\.museum|salzburg\.museum|sandiego\.museum|sanfrancisco\.museum|santabarbara\.museum|santacruz\.museum|santafe\.museum|saskatchewan\.museum|satx\.museum|savannahga\.museum|schlesisches\.museum|schoenbrunn\.museum|schokoladen\.museum|school\.museum|schweiz\.museum|science\.museum|scienceandhistory\.museum|scienceandindustry\.museum|sciencecenter\.museum|sciencecenters\.museum|science-fiction\.museum|sciencehistory\.museum|sciences\.museum|sciencesnaturelles\.museum|scotland\.museum|seaport\.museum|settlement\.museum|settlers\.museum|shell\.museum|sherbrooke\.museum|sibenik\.museum|silk\.museum|ski\.museum|skole\.museum|society\.museum|sologne\.museum|soundandvision\.museum|southcarolina\.museum|southwest\.museum|space\.museum|spy\.museum|square\.museum|stadt\.museum|stalbans\.museum|starnberg\.museum|state\.museum|stateofdelaware\.museum|station\.museum|steam\.museum|steiermark\.museum|stjohn\.museum|stockholm\.museum|stpetersburg\.museum|stuttgart\.museum|suisse\.museum|surgeonshall\.museum|surrey\.museum|svizzera\.museum|sweden\.museum|sydney\.museum|tank\.museum|tcm\.museum|technology\.museum|telekommunikation\.museum|television\.museum|texas\.museum|textile\.museum|theater\.museum|time\.museum|timekeeping\.museum|topology\.museum|torino\.museum|touch\.museum|town\.museum|transport\.museum|tree\.museum|trolley\.museum|trust\.museum|trustee\.museum|uhren\.museum|ulm\.museum|undersea\.museum|university\.museum|usa\.museum|usantiques\.museum|usarts\.museum|uscountryestate\.museum|usculture\.museum|usdecorativearts\.museum|usgarden\.museum|ushistory\.museum|ushuaia\.museum|uslivinghistory\.museum|utah\.museum|uvic\.museum|valley\.museum|vantaa\.museum|versailles\.museum|viking\.museum|village\.museum|virginia\.museum|virtual\.museum|virtuel\.museum|vlaanderen\.museum|volkenkunde\.museum|wales\.museum|wallonie\.museum|war\.museum|washingtondc\.museum|watchandclock\.museum|watch-and-clock\.museum|western\.museum|westfalen\.museum|whaling\.museum|wildlife\.museum|williamsburg\.museum|windmill\.museum|workshop\.museum|york\.museum|yorkshire\.museum|yosemite\.museum|youth\.museum|zoological\.museum|zoology\.museum|ירושלים\.museum|иком\.museum|mv|aero\.mv|biz\.mv|com\.mv|coop\.mv|edu\.mv|gov\.mv|info\.mv|int\.mv|mil\.mv|museum\.mv|name\.mv|net\.mv|org\.mv|pro\.mv|mw|ac\.mw|biz\.mw|co\.mw|com\.mw|coop\.mw|edu\.mw|gov\.mw|int\.mw|museum\.mw|net\.mw|org\.mw|mx|com\.mx|org\.mx|gob\.mx|edu\.mx|net\.mx|my|com\.my|net\.my|org\.my|gov\.my|edu\.my|mil\.my|name\.my|mz|ac\.mz|adv\.mz|co\.mz|edu\.mz|gov\.mz|mil\.mz|net\.mz|org\.mz|na|info\.na|pro\.na|name\.na|school\.na|or\.na|dr\.na|us\.na|mx\.na|ca\.na|in\.na|cc\.na|tv\.na|ws\.na|mobi\.na|co\.na|com\.na|org\.na|name|nc|asso\.nc|ne|net|nf|com\.nf|net\.nf|per\.nf|rec\.nf|web\.nf|arts\.nf|firm\.nf|info\.nf|other\.nf|store\.nf|ng|com\.ng|edu\.ng|gov\.ng|i\.ng|mil\.ng|mobi\.ng|name\.ng|net\.ng|org\.ng|sch\.ng|ni|ac\.ni|biz\.ni|co\.ni|com\.ni|edu\.ni|gob\.ni|in\.ni|info\.ni|int\.ni|mil\.ni|net\.ni|nom\.ni|org\.ni|web\.ni|nl|bv\.nl|no|fhs\.no|vgs\.no|fylkesbibl\.no|folkebibl\.no|museum\.no|idrett\.no|priv\.no|mil\.no|stat\.no|dep\.no|kommune\.no|herad\.no|aa\.no|ah\.no|bu\.no|fm\.no|hl\.no|hm\.no|jan-mayen\.no|mr\.no|nl\.no|nt\.no|of\.no|ol\.no|oslo\.no|rl\.no|sf\.no|st\.no|svalbard\.no|tm\.no|tr\.no|va\.no|vf\.no|gs\.aa\.no|gs\.ah\.no|gs\.bu\.no|gs\.fm\.no|gs\.hl\.no|gs\.hm\.no|gs\.jan-mayen\.no|gs\.mr\.no|gs\.nl\.no|gs\.nt\.no|gs\.of\.no|gs\.ol\.no|gs\.oslo\.no|gs\.rl\.no|gs\.sf\.no|gs\.st\.no|gs\.svalbard\.no|gs\.tm\.no|gs\.tr\.no|gs\.va\.no|gs\.vf\.no|akrehamn\.no|åkrehamn\.no|algard\.no|ålgård\.no|arna\.no|brumunddal\.no|bryne\.no|bronnoysund\.no|brønnøysund\.no|drobak\.no|drøbak\.no|egersund\.no|fetsund\.no|floro\.no|florø\.no|fredrikstad\.no|hokksund\.no|honefoss\.no|hønefoss\.no|jessheim\.no|jorpeland\.no|jørpeland\.no|kirkenes\.no|kopervik\.no|krokstadelva\.no|langevag\.no|langevåg\.no|leirvik\.no|mjondalen\.no|mjøndalen\.no|mo-i-rana\.no|mosjoen\.no|mosjøen\.no|nesoddtangen\.no|orkanger\.no|osoyro\.no|osøyro\.no|raholt\.no|råholt\.no|sandnessjoen\.no|sandnessjøen\.no|skedsmokorset\.no|slattum\.no|spjelkavik\.no|stathelle\.no|stavern\.no|stjordalshalsen\.no|stjørdalshalsen\.no|tananger\.no|tranby\.no|vossevangen\.no|afjord\.no|åfjord\.no|agdenes\.no|al\.no|ål\.no|alesund\.no|ålesund\.no|alstahaug\.no|alta\.no|áltá\.no|alaheadju\.no|álaheadju\.no|alvdal\.no|amli\.no|åmli\.no|amot\.no|åmot\.no|andebu\.no|andoy\.no|andøy\.no|andasuolo\.no|ardal\.no|årdal\.no|aremark\.no|arendal\.no|ås\.no|aseral\.no|åseral\.no|asker\.no|askim\.no|askvoll\.no|askoy\.no|askøy\.no|asnes\.no|åsnes\.no|audnedaln\.no|aukra\.no|aure\.no|aurland\.no|aurskog-holand\.no|aurskog-høland\.no|austevoll\.no|austrheim\.no|averoy\.no|averøy\.no|balestrand\.no|ballangen\.no|balat\.no|bálát\.no|balsfjord\.no|bahccavuotna\.no|báhccavuotna\.no|bamble\.no|bardu\.no|beardu\.no|beiarn\.no|bajddar\.no|bájddar\.no|baidar\.no|báidár\.no|berg\.no|bergen\.no|berlevag\.no|berlevåg\.no|bearalvahki\.no|bearalváhki\.no|bindal\.no|birkenes\.no|bjarkoy\.no|bjarkøy\.no|bjerkreim\.no|bjugn\.no|bodo\.no|bodø\.no|badaddja\.no|bådåddjå\.no|budejju\.no|bokn\.no|bremanger\.no|bronnoy\.no|brønnøy\.no|bygland\.no|bykle\.no|barum\.no|bærum\.no|bo\.telemark\.no|bø\.telemark\.no|bo\.nordland\.no|bø\.nordland\.no|bievat\.no|bievát\.no|bomlo\.no|bømlo\.no|batsfjord\.no|båtsfjord\.no|bahcavuotna\.no|báhcavuotna\.no|dovre\.no|drammen\.no|drangedal\.no|dyroy\.no|dyrøy\.no|donna\.no|dønna\.no|eid\.no|eidfjord\.no|eidsberg\.no|eidskog\.no|eidsvoll\.no|eigersund\.no|elverum\.no|enebakk\.no|engerdal\.no|etne\.no|etnedal\.no|evenes\.no|evenassi\.no|evenášši\.no|evje-og-hornnes\.no|farsund\.no|fauske\.no|fuossko\.no|fuoisku\.no|fedje\.no|fet\.no|finnoy\.no|finnøy\.no|fitjar\.no|fjaler\.no|fjell\.no|flakstad\.no|flatanger\.no|flekkefjord\.no|flesberg\.no|flora\.no|fla\.no|flå\.no|folldal\.no|forsand\.no|fosnes\.no|frei\.no|frogn\.no|froland\.no|frosta\.no|frana\.no|fræna\.no|froya\.no|frøya\.no|fusa\.no|fyresdal\.no|forde\.no|førde\.no|gamvik\.no|gangaviika\.no|gáŋgaviika\.no|gaular\.no|gausdal\.no|gildeskal\.no|gildeskål\.no|giske\.no|gjemnes\.no|gjerdrum\.no|gjerstad\.no|gjesdal\.no|gjovik\.no|gjøvik\.no|gloppen\.no|gol\.no|gran\.no|grane\.no|granvin\.no|gratangen\.no|grimstad\.no|grong\.no|kraanghke\.no|kråanghke\.no|grue\.no|gulen\.no|hadsel\.no|halden\.no|halsa\.no|hamar\.no|hamaroy\.no|habmer\.no|hábmer\.no|hapmir\.no|hápmir\.no|hammerfest\.no|hammarfeasta\.no|hámmárfeasta\.no|haram\.no|hareid\.no|harstad\.no|hasvik\.no|aknoluokta\.no|ákŋoluokta\.no|hattfjelldal\.no|aarborte\.no|haugesund\.no|hemne\.no|hemnes\.no|hemsedal\.no|heroy\.more-og-romsdal\.no|herøy\.møre-og-romsdal\.no|heroy\.nordland\.no|herøy\.nordland\.no|hitra\.no|hjartdal\.no|hjelmeland\.no|hobol\.no|hobøl\.no|hof\.no|hol\.no|hole\.no|holmestrand\.no|holtalen\.no|holtålen\.no|hornindal\.no|horten\.no|hurdal\.no|hurum\.no|hvaler\.no|hyllestad\.no|hagebostad\.no|hægebostad\.no|hoyanger\.no|høyanger\.no|hoylandet\.no|høylandet\.no|ha\.no|hå\.no|ibestad\.no|inderoy\.no|inderøy\.no|iveland\.no|jevnaker\.no|jondal\.no|jolster\.no|jølster\.no|karasjok\.no|karasjohka\.no|kárášjohka\.no|karlsoy\.no|galsa\.no|gálsá\.no|karmoy\.no|karmøy\.no|kautokeino\.no|guovdageaidnu\.no|klepp\.no|klabu\.no|klæbu\.no|kongsberg\.no|kongsvinger\.no|kragero\.no|kragerø\.no|kristiansand\.no|kristiansund\.no|krodsherad\.no|krødsherad\.no|kvalsund\.no|rahkkeravju\.no|ráhkkerávju\.no|kvam\.no|kvinesdal\.no|kvinnherad\.no|kviteseid\.no|kvitsoy\.no|kvitsøy\.no|kvafjord\.no|kvæfjord\.no|giehtavuoatna\.no|kvanangen\.no|kvænangen\.no|navuotna\.no|návuotna\.no|kafjord\.no|kåfjord\.no|gaivuotna\.no|gáivuotna\.no|larvik\.no|lavangen\.no|lavagis\.no|loabat\.no|loabát\.no|lebesby\.no|davvesiida\.no|leikanger\.no|leirfjord\.no|leka\.no|leksvik\.no|lenvik\.no|leangaviika\.no|leaŋgaviika\.no|lesja\.no|levanger\.no|lier\.no|lierne\.no|lillehammer\.no|lillesand\.no|lindesnes\.no|lindas\.no|lindås\.no|lom\.no|loppa\.no|lahppi\.no|láhppi\.no|lund\.no|lunner\.no|luroy\.no|lurøy\.no|luster\.no|lyngdal\.no|lyngen\.no|ivgu\.no|lardal\.no|lerdal\.no|lærdal\.no|lodingen\.no|lødingen\.no|lorenskog\.no|lørenskog\.no|loten\.no|løten\.no|malvik\.no|masoy\.no|måsøy\.no|muosat\.no|muosát\.no|mandal\.no|marker\.no|marnardal\.no|masfjorden\.no|meland\.no|meldal\.no|melhus\.no|meloy\.no|meløy\.no|meraker\.no|meråker\.no|moareke\.no|moåreke\.no|midsund\.no|midtre-gauldal\.no|modalen\.no|modum\.no|molde\.no|moskenes\.no|moss\.no|mosvik\.no|malselv\.no|målselv\.no|malatvuopmi\.no|málatvuopmi\.no|namdalseid\.no|aejrie\.no|namsos\.no|namsskogan\.no|naamesjevuemie\.no|nååmesjevuemie\.no|laakesvuemie\.no|nannestad\.no|narvik\.no|narviika\.no|naustdal\.no|nedre-eiker\.no|nes\.akershus\.no|nes\.buskerud\.no|nesna\.no|nesodden\.no|nesseby\.no|unjarga\.no|unjárga\.no|nesset\.no|nissedal\.no|nittedal\.no|nord-aurdal\.no|nord-fron\.no|nord-odal\.no|norddal\.no|nordkapp\.no|davvenjarga\.no|davvenjárga\.no|nordre-land\.no|nordreisa\.no|raisa\.no|ráisa\.no|nore-og-uvdal\.no|notodden\.no|naroy\.no|nærøy\.no|notteroy\.no|nøtterøy\.no|odda\.no|oksnes\.no|øksnes\.no|oppdal\.no|oppegard\.no|oppegård\.no|orkdal\.no|orland\.no|ørland\.no|orskog\.no|ørskog\.no|orsta\.no|ørsta\.no|os\.hedmark\.no|os\.hordaland\.no|osen\.no|osteroy\.no|osterøy\.no|ostre-toten\.no|østre-toten\.no|overhalla\.no|ovre-eiker\.no|øvre-eiker\.no|oyer\.no|øyer\.no|oygarden\.no|øygarden\.no|oystre-slidre\.no|øystre-slidre\.no|porsanger\.no|porsangu\.no|porsáŋgu\.no|porsgrunn\.no|radoy\.no|radøy\.no|rakkestad\.no|rana\.no|ruovat\.no|randaberg\.no|rauma\.no|rendalen\.no|rennebu\.no|rennesoy\.no|rennesøy\.no|rindal\.no|ringebu\.no|ringerike\.no|ringsaker\.no|rissa\.no|risor\.no|risør\.no|roan\.no|rollag\.no|rygge\.no|ralingen\.no|rælingen\.no|rodoy\.no|rødøy\.no|romskog\.no|rømskog\.no|roros\.no|røros\.no|rost\.no|røst\.no|royken\.no|røyken\.no|royrvik\.no|røyrvik\.no|rade\.no|råde\.no|salangen\.no|siellak\.no|saltdal\.no|salat\.no|sálát\.no|sálat\.no|samnanger\.no|sande\.more-og-romsdal\.no|sande\.møre-og-romsdal\.no|sande\.vestfold\.no|sandefjord\.no|sandnes\.no|sandoy\.no|sandøy\.no|sarpsborg\.no|sauda\.no|sauherad\.no|sel\.no|selbu\.no|selje\.no|seljord\.no|sigdal\.no|siljan\.no|sirdal\.no|skaun\.no|skedsmo\.no|ski\.no|skien\.no|skiptvet\.no|skjervoy\.no|skjervøy\.no|skierva\.no|skiervá\.no|skjak\.no|skjåk\.no|skodje\.no|skanland\.no|skånland\.no|skanit\.no|skánit\.no|smola\.no|smøla\.no|snillfjord\.no|snasa\.no|snåsa\.no|snoasa\.no|snaase\.no|snåase\.no|sogndal\.no|sokndal\.no|sola\.no|solund\.no|songdalen\.no|sortland\.no|spydeberg\.no|stange\.no|stavanger\.no|steigen\.no|steinkjer\.no|stjordal\.no|stjørdal\.no|stokke\.no|stor-elvdal\.no|stord\.no|stordal\.no|storfjord\.no|omasvuotna\.no|strand\.no|stranda\.no|stryn\.no|sula\.no|suldal\.no|sund\.no|sunndal\.no|surnadal\.no|sveio\.no|svelvik\.no|sykkylven\.no|sogne\.no|søgne\.no|somna\.no|sømna\.no|sondre-land\.no|søndre-land\.no|sor-aurdal\.no|sør-aurdal\.no|sor-fron\.no|sør-fron\.no|sor-odal\.no|sør-odal\.no|sor-varanger\.no|sør-varanger\.no|matta-varjjat\.no|mátta-várjjat\.no|sorfold\.no|sørfold\.no|sorreisa\.no|sørreisa\.no|sorum\.no|sørum\.no|tana\.no|deatnu\.no|time\.no|tingvoll\.no|tinn\.no|tjeldsund\.no|dielddanuorri\.no|tjome\.no|tjøme\.no|tokke\.no|tolga\.no|torsken\.no|tranoy\.no|tranøy\.no|tromso\.no|tromsø\.no|tromsa\.no|romsa\.no|trondheim\.no|troandin\.no|trysil\.no|trana\.no|træna\.no|trogstad\.no|trøgstad\.no|tvedestrand\.no|tydal\.no|tynset\.no|tysfjord\.no|divtasvuodna\.no|divttasvuotna\.no|tysnes\.no|tysvar\.no|tysvær\.no|tonsberg\.no|tønsberg\.no|ullensaker\.no|ullensvang\.no|ulvik\.no|utsira\.no|vadso\.no|vadsø\.no|cahcesuolo\.no|čáhcesuolo\.no|vaksdal\.no|valle\.no|vang\.no|vanylven\.no|vardo\.no|vardø\.no|varggat\.no|várggát\.no|vefsn\.no|vaapste\.no|vega\.no|vegarshei\.no|vegårshei\.no|vennesla\.no|verdal\.no|verran\.no|vestby\.no|vestnes\.no|vestre-slidre\.no|vestre-toten\.no|vestvagoy\.no|vestvågøy\.no|vevelstad\.no|vik\.no|vikna\.no|vindafjord\.no|volda\.no|voss\.no|varoy\.no|værøy\.no|vagan\.no|vågan\.no|voagat\.no|vagsoy\.no|vågsøy\.no|vaga\.no|vågå\.no|valer\.ostfold\.no|våler\.østfold\.no|valer\.hedmark\.no|våler\.hedmark\.no|[^.]+\.np|nr|biz\.nr|info\.nr|gov\.nr|edu\.nr|org\.nr|net\.nr|com\.nr|nu|nz|ac\.nz|co\.nz|cri\.nz|geek\.nz|gen\.nz|govt\.nz|health\.nz|iwi\.nz|kiwi\.nz|maori\.nz|mil\.nz|māori\.nz|net\.nz|org\.nz|parliament\.nz|school\.nz|om|co\.om|com\.om|edu\.om|gov\.om|med\.om|museum\.om|net\.om|org\.om|pro\.om|onion|org|pa|ac\.pa|gob\.pa|com\.pa|org\.pa|sld\.pa|edu\.pa|net\.pa|ing\.pa|abo\.pa|med\.pa|nom\.pa|pe|edu\.pe|gob\.pe|nom\.pe|mil\.pe|org\.pe|com\.pe|net\.pe|pf|com\.pf|org\.pf|edu\.pf|[^.]+\.pg|ph|com\.ph|net\.ph|org\.ph|gov\.ph|edu\.ph|ngo\.ph|mil\.ph|i\.ph|pk|com\.pk|net\.pk|edu\.pk|org\.pk|fam\.pk|biz\.pk|web\.pk|gov\.pk|gob\.pk|gok\.pk|gon\.pk|gop\.pk|gos\.pk|info\.pk|pl|com\.pl|net\.pl|org\.pl|aid\.pl|agro\.pl|atm\.pl|auto\.pl|biz\.pl|edu\.pl|gmina\.pl|gsm\.pl|info\.pl|mail\.pl|miasta\.pl|media\.pl|mil\.pl|nieruchomosci\.pl|nom\.pl|pc\.pl|powiat\.pl|priv\.pl|realestate\.pl|rel\.pl|sex\.pl|shop\.pl|sklep\.pl|sos\.pl|szkola\.pl|targi\.pl|tm\.pl|tourism\.pl|travel\.pl|turystyka\.pl|gov\.pl|ap\.gov\.pl|ic\.gov\.pl|is\.gov\.pl|us\.gov\.pl|kmpsp\.gov\.pl|kppsp\.gov\.pl|kwpsp\.gov\.pl|psp\.gov\.pl|wskr\.gov\.pl|kwp\.gov\.pl|mw\.gov\.pl|ug\.gov\.pl|um\.gov\.pl|umig\.gov\.pl|ugim\.gov\.pl|upow\.gov\.pl|uw\.gov\.pl|starostwo\.gov\.pl|pa\.gov\.pl|po\.gov\.pl|psse\.gov\.pl|pup\.gov\.pl|rzgw\.gov\.pl|sa\.gov\.pl|so\.gov\.pl|sr\.gov\.pl|wsa\.gov\.pl|sko\.gov\.pl|uzs\.gov\.pl|wiih\.gov\.pl|winb\.gov\.pl|pinb\.gov\.pl|wios\.gov\.pl|witd\.gov\.pl|wzmiuw\.gov\.pl|piw\.gov\.pl|wiw\.gov\.pl|griw\.gov\.pl|wif\.gov\.pl|oum\.gov\.pl|sdn\.gov\.pl|zp\.gov\.pl|uppo\.gov\.pl|mup\.gov\.pl|wuoz\.gov\.pl|konsulat\.gov\.pl|oirm\.gov\.pl|augustow\.pl|babia-gora\.pl|bedzin\.pl|beskidy\.pl|bialowieza\.pl|bialystok\.pl|bielawa\.pl|bieszczady\.pl|boleslawiec\.pl|bydgoszcz\.pl|bytom\.pl|cieszyn\.pl|czeladz\.pl|czest\.pl|dlugoleka\.pl|elblag\.pl|elk\.pl|glogow\.pl|gniezno\.pl|gorlice\.pl|grajewo\.pl|ilawa\.pl|jaworzno\.pl|jelenia-gora\.pl|jgora\.pl|kalisz\.pl|kazimierz-dolny\.pl|karpacz\.pl|kartuzy\.pl|kaszuby\.pl|katowice\.pl|kepno\.pl|ketrzyn\.pl|klodzko\.pl|kobierzyce\.pl|kolobrzeg\.pl|konin\.pl|konskowola\.pl|kutno\.pl|lapy\.pl|lebork\.pl|legnica\.pl|lezajsk\.pl|limanowa\.pl|lomza\.pl|lowicz\.pl|lubin\.pl|lukow\.pl|malbork\.pl|malopolska\.pl|mazowsze\.pl|mazury\.pl|mielec\.pl|mielno\.pl|mragowo\.pl|naklo\.pl|nowaruda\.pl|nysa\.pl|olawa\.pl|olecko\.pl|olkusz\.pl|olsztyn\.pl|opoczno\.pl|opole\.pl|ostroda\.pl|ostroleka\.pl|ostrowiec\.pl|ostrowwlkp\.pl|pila\.pl|pisz\.pl|podhale\.pl|podlasie\.pl|polkowice\.pl|pomorze\.pl|pomorskie\.pl|prochowice\.pl|pruszkow\.pl|przeworsk\.pl|pulawy\.pl|radom\.pl|rawa-maz\.pl|rybnik\.pl|rzeszow\.pl|sanok\.pl|sejny\.pl|slask\.pl|slupsk\.pl|sosnowiec\.pl|stalowa-wola\.pl|skoczow\.pl|starachowice\.pl|stargard\.pl|suwalki\.pl|swidnica\.pl|swiebodzin\.pl|swinoujscie\.pl|szczecin\.pl|szczytno\.pl|tarnobrzeg\.pl|tgory\.pl|turek\.pl|tychy\.pl|ustka\.pl|walbrzych\.pl|warmia\.pl|warszawa\.pl|waw\.pl|wegrow\.pl|wielun\.pl|wlocl\.pl|wloclawek\.pl|wodzislaw\.pl|wolomin\.pl|wroclaw\.pl|zachpomor\.pl|zagan\.pl|zarow\.pl|zgora\.pl|zgorzelec\.pl|pm|pn|gov\.pn|co\.pn|org\.pn|edu\.pn|net\.pn|post|pr|com\.pr|net\.pr|org\.pr|gov\.pr|edu\.pr|isla\.pr|pro\.pr|biz\.pr|info\.pr|name\.pr|est\.pr|prof\.pr|ac\.pr|pro|aaa\.pro|aca\.pro|acct\.pro|avocat\.pro|bar\.pro|cpa\.pro|eng\.pro|jur\.pro|law\.pro|med\.pro|recht\.pro|ps|edu\.ps|gov\.ps|sec\.ps|plo\.ps|com\.ps|org\.ps|net\.ps|pt|net\.pt|gov\.pt|org\.pt|edu\.pt|int\.pt|publ\.pt|com\.pt|nome\.pt|pw|co\.pw|ne\.pw|or\.pw|ed\.pw|go\.pw|belau\.pw|py|com\.py|coop\.py|edu\.py|gov\.py|mil\.py|net\.py|org\.py|qa|com\.qa|edu\.qa|gov\.qa|mil\.qa|name\.qa|net\.qa|org\.qa|sch\.qa|re|asso\.re|com\.re|nom\.re|ro|arts\.ro|com\.ro|firm\.ro|info\.ro|nom\.ro|nt\.ro|org\.ro|rec\.ro|store\.ro|tm\.ro|www\.ro|rs|ac\.rs|co\.rs|edu\.rs|gov\.rs|in\.rs|org\.rs|ru|ac\.ru|edu\.ru|gov\.ru|int\.ru|mil\.ru|test\.ru|rw|gov\.rw|net\.rw|edu\.rw|ac\.rw|com\.rw|co\.rw|int\.rw|mil\.rw|gouv\.rw|sa|com\.sa|net\.sa|org\.sa|gov\.sa|med\.sa|pub\.sa|edu\.sa|sch\.sa|sb|com\.sb|edu\.sb|gov\.sb|net\.sb|org\.sb|sc|com\.sc|gov\.sc|net\.sc|org\.sc|edu\.sc|sd|com\.sd|net\.sd|org\.sd|edu\.sd|med\.sd|tv\.sd|gov\.sd|info\.sd|se|a\.se|ac\.se|b\.se|bd\.se|brand\.se|c\.se|d\.se|e\.se|f\.se|fh\.se|fhsk\.se|fhv\.se|g\.se|h\.se|i\.se|k\.se|komforb\.se|kommunalforbund\.se|komvux\.se|l\.se|lanbib\.se|m\.se|n\.se|naturbruksgymn\.se|o\.se|org\.se|p\.se|parti\.se|pp\.se|press\.se|r\.se|s\.se|t\.se|tm\.se|u\.se|w\.se|x\.se|y\.se|z\.se|sg|com\.sg|net\.sg|org\.sg|gov\.sg|edu\.sg|per\.sg|sh|com\.sh|net\.sh|gov\.sh|org\.sh|mil\.sh|si|sj|sk|sl|com\.sl|net\.sl|edu\.sl|gov\.sl|org\.sl|sm|sn|art\.sn|com\.sn|edu\.sn|gouv\.sn|org\.sn|perso\.sn|univ\.sn|so|com\.so|net\.so|org\.so|sr|st|co\.st|com\.st|consulado\.st|edu\.st|embaixada\.st|gov\.st|mil\.st|net\.st|org\.st|principe\.st|saotome\.st|store\.st|su|sv|com\.sv|edu\.sv|gob\.sv|org\.sv|red\.sv|sx|gov\.sx|sy|edu\.sy|gov\.sy|net\.sy|mil\.sy|com\.sy|org\.sy|sz|co\.sz|ac\.sz|org\.sz|tc|td|tel|tf|tg|th|ac\.th|co\.th|go\.th|in\.th|mi\.th|net\.th|or\.th|tj|ac\.tj|biz\.tj|co\.tj|com\.tj|edu\.tj|go\.tj|gov\.tj|int\.tj|mil\.tj|name\.tj|net\.tj|nic\.tj|org\.tj|test\.tj|web\.tj|tk|tl|gov\.tl|tm|com\.tm|co\.tm|org\.tm|net\.tm|nom\.tm|gov\.tm|mil\.tm|edu\.tm|tn|com\.tn|ens\.tn|fin\.tn|gov\.tn|ind\.tn|intl\.tn|nat\.tn|net\.tn|org\.tn|info\.tn|perso\.tn|tourism\.tn|edunet\.tn|rnrt\.tn|rns\.tn|rnu\.tn|mincom\.tn|agrinet\.tn|defense\.tn|turen\.tn|to|com\.to|gov\.to|net\.to|org\.to|edu\.to|mil\.to|tr|com\.tr|info\.tr|biz\.tr|net\.tr|org\.tr|web\.tr|gen\.tr|tv\.tr|av\.tr|dr\.tr|bbs\.tr|name\.tr|tel\.tr|gov\.tr|bel\.tr|pol\.tr|mil\.tr|k12\.tr|edu\.tr|kep\.tr|nc\.tr|gov\.nc\.tr|travel|tt|co\.tt|com\.tt|org\.tt|net\.tt|biz\.tt|info\.tt|pro\.tt|int\.tt|coop\.tt|jobs\.tt|mobi\.tt|travel\.tt|museum\.tt|aero\.tt|name\.tt|gov\.tt|edu\.tt|tv|tw|edu\.tw|gov\.tw|mil\.tw|com\.tw|net\.tw|org\.tw|idv\.tw|game\.tw|ebiz\.tw|club\.tw|網路\.tw|組織\.tw|商業\.tw|tz|ac\.tz|co\.tz|go\.tz|hotel\.tz|info\.tz|me\.tz|mil\.tz|mobi\.tz|ne\.tz|or\.tz|sc\.tz|tv\.tz|ua|com\.ua|edu\.ua|gov\.ua|in\.ua|net\.ua|org\.ua|cherkassy\.ua|cherkasy\.ua|chernigov\.ua|chernihiv\.ua|chernivtsi\.ua|chernovtsy\.ua|ck\.ua|cn\.ua|cr\.ua|crimea\.ua|cv\.ua|dn\.ua|dnepropetrovsk\.ua|dnipropetrovsk\.ua|dominic\.ua|donetsk\.ua|dp\.ua|if\.ua|ivano-frankivsk\.ua|kh\.ua|kharkiv\.ua|kharkov\.ua|kherson\.ua|khmelnitskiy\.ua|khmelnytskyi\.ua|kiev\.ua|kirovograd\.ua|km\.ua|kr\.ua|krym\.ua|ks\.ua|kv\.ua|kyiv\.ua|lg\.ua|lt\.ua|lugansk\.ua|lutsk\.ua|lv\.ua|lviv\.ua|mk\.ua|mykolaiv\.ua|nikolaev\.ua|od\.ua|odesa\.ua|odessa\.ua|pl\.ua|poltava\.ua|rivne\.ua|rovno\.ua|rv\.ua|sb\.ua|sebastopol\.ua|sevastopol\.ua|sm\.ua|sumy\.ua|te\.ua|ternopil\.ua|uz\.ua|uzhgorod\.ua|vinnica\.ua|vinnytsia\.ua|vn\.ua|volyn\.ua|yalta\.ua|zaporizhzhe\.ua|zaporizhzhia\.ua|zhitomir\.ua|zhytomyr\.ua|zp\.ua|zt\.ua|ug|co\.ug|or\.ug|ac\.ug|sc\.ug|go\.ug|ne\.ug|com\.ug|org\.ug|uk|ac\.uk|co\.uk|gov\.uk|ltd\.uk|me\.uk|net\.uk|nhs\.uk|org\.uk|plc\.uk|police\.uk|[^.]+\.sch\.uk|us|dni\.us|fed\.us|isa\.us|kids\.us|nsn\.us|ak\.us|al\.us|ar\.us|as\.us|az\.us|ca\.us|co\.us|ct\.us|dc\.us|de\.us|fl\.us|ga\.us|gu\.us|hi\.us|ia\.us|id\.us|il\.us|in\.us|ks\.us|ky\.us|la\.us|ma\.us|md\.us|me\.us|mi\.us|mn\.us|mo\.us|ms\.us|mt\.us|nc\.us|nd\.us|ne\.us|nh\.us|nj\.us|nm\.us|nv\.us|ny\.us|oh\.us|ok\.us|or\.us|pa\.us|pr\.us|ri\.us|sc\.us|sd\.us|tn\.us|tx\.us|ut\.us|vi\.us|vt\.us|va\.us|wa\.us|wi\.us|wv\.us|wy\.us|k12\.ak\.us|k12\.al\.us|k12\.ar\.us|k12\.as\.us|k12\.az\.us|k12\.ca\.us|k12\.co\.us|k12\.ct\.us|k12\.dc\.us|k12\.de\.us|k12\.fl\.us|k12\.ga\.us|k12\.gu\.us|k12\.ia\.us|k12\.id\.us|k12\.il\.us|k12\.in\.us|k12\.ks\.us|k12\.ky\.us|k12\.la\.us|k12\.ma\.us|k12\.md\.us|k12\.me\.us|k12\.mi\.us|k12\.mn\.us|k12\.mo\.us|k12\.ms\.us|k12\.mt\.us|k12\.nc\.us|k12\.ne\.us|k12\.nh\.us|k12\.nj\.us|k12\.nm\.us|k12\.nv\.us|k12\.ny\.us|k12\.oh\.us|k12\.ok\.us|k12\.or\.us|k12\.pa\.us|k12\.pr\.us|k12\.ri\.us|k12\.sc\.us|k12\.tn\.us|k12\.tx\.us|k12\.ut\.us|k12\.vi\.us|k12\.vt\.us|k12\.va\.us|k12\.wa\.us|k12\.wi\.us|k12\.wy\.us|cc\.ak\.us|cc\.al\.us|cc\.ar\.us|cc\.as\.us|cc\.az\.us|cc\.ca\.us|cc\.co\.us|cc\.ct\.us|cc\.dc\.us|cc\.de\.us|cc\.fl\.us|cc\.ga\.us|cc\.gu\.us|cc\.hi\.us|cc\.ia\.us|cc\.id\.us|cc\.il\.us|cc\.in\.us|cc\.ks\.us|cc\.ky\.us|cc\.la\.us|cc\.ma\.us|cc\.md\.us|cc\.me\.us|cc\.mi\.us|cc\.mn\.us|cc\.mo\.us|cc\.ms\.us|cc\.mt\.us|cc\.nc\.us|cc\.nd\.us|cc\.ne\.us|cc\.nh\.us|cc\.nj\.us|cc\.nm\.us|cc\.nv\.us|cc\.ny\.us|cc\.oh\.us|cc\.ok\.us|cc\.or\.us|cc\.pa\.us|cc\.pr\.us|cc\.ri\.us|cc\.sc\.us|cc\.sd\.us|cc\.tn\.us|cc\.tx\.us|cc\.ut\.us|cc\.vi\.us|cc\.vt\.us|cc\.va\.us|cc\.wa\.us|cc\.wi\.us|cc\.wv\.us|cc\.wy\.us|lib\.ak\.us|lib\.al\.us|lib\.ar\.us|lib\.as\.us|lib\.az\.us|lib\.ca\.us|lib\.co\.us|lib\.ct\.us|lib\.dc\.us|lib\.fl\.us|lib\.ga\.us|lib\.gu\.us|lib\.hi\.us|lib\.ia\.us|lib\.id\.us|lib\.il\.us|lib\.in\.us|lib\.ks\.us|lib\.ky\.us|lib\.la\.us|lib\.ma\.us|lib\.md\.us|lib\.me\.us|lib\.mi\.us|lib\.mn\.us|lib\.mo\.us|lib\.ms\.us|lib\.mt\.us|lib\.nc\.us|lib\.nd\.us|lib\.ne\.us|lib\.nh\.us|lib\.nj\.us|lib\.nm\.us|lib\.nv\.us|lib\.ny\.us|lib\.oh\.us|lib\.ok\.us|lib\.or\.us|lib\.pa\.us|lib\.pr\.us|lib\.ri\.us|lib\.sc\.us|lib\.sd\.us|lib\.tn\.us|lib\.tx\.us|lib\.ut\.us|lib\.vi\.us|lib\.vt\.us|lib\.va\.us|lib\.wa\.us|lib\.wi\.us|lib\.wy\.us|pvt\.k12\.ma\.us|chtr\.k12\.ma\.us|paroch\.k12\.ma\.us|uy|com\.uy|edu\.uy|gub\.uy|mil\.uy|net\.uy|org\.uy|uz|co\.uz|com\.uz|net\.uz|org\.uz|va|vc|com\.vc|net\.vc|org\.vc|gov\.vc|mil\.vc|edu\.vc|ve|arts\.ve|co\.ve|com\.ve|e12\.ve|edu\.ve|firm\.ve|gob\.ve|gov\.ve|info\.ve|int\.ve|mil\.ve|net\.ve|org\.ve|rec\.ve|store\.ve|tec\.ve|web\.ve|vg|vi|co\.vi|com\.vi|k12\.vi|net\.vi|org\.vi|vn|com\.vn|net\.vn|org\.vn|edu\.vn|gov\.vn|int\.vn|ac\.vn|biz\.vn|info\.vn|name\.vn|pro\.vn|health\.vn|vu|com\.vu|edu\.vu|net\.vu|org\.vu|wf|ws|com\.ws|net\.ws|org\.ws|gov\.ws|edu\.ws|yt|امارات|հայ|বাংলা|бел|中国|中國|الجزائر|مصر|ею|გე|ελ|香港|भारत|بھارت|భారత్|ભારત|ਭਾਰਤ|ভারত|இந்தியா|ایران|ايران|عراق|الاردن|한국|қаз|ලංකා|இலங்கை|المغرب|мкд|мон|澳門|澳门|مليسيا|عمان|پاکستان|پاكستان|فلسطين|срб|пр\.срб|орг\.срб|обр\.срб|од\.срб|упр\.срб|ак\.срб|рф|قطر|السعودية|السعودیة|السعودیۃ|السعوديه|سودان|新加坡|சிங்கப்பூர்|سورية|سوريا|ไทย|تونس|台灣|台湾|臺灣|укр|اليمن|xxx|[^.]+\.ye|ac\.za|agric\.za|alt\.za|co\.za|edu\.za|gov\.za|grondar\.za|law\.za|mil\.za|net\.za|ngo\.za|nis\.za|nom\.za|org\.za|school\.za|tm\.za|web\.za|zm|ac\.zm|biz\.zm|co\.zm|com\.zm|edu\.zm|gov\.zm|info\.zm|mil\.zm|net\.zm|org\.zm|sch\.zm|[^.]+\.zw|aaa|aarp|abarth|abb|abbott|abbvie|abc|able|abogado|abudhabi|academy|accenture|accountant|accountants|aco|active|actor|adac|ads|adult|aeg|aetna|afamilycompany|afl|africa|agakhan|agency|aig|aigo|airbus|airforce|airtel|akdn|alfaromeo|alibaba|alipay|allfinanz|allstate|ally|alsace|alstom|americanexpress|americanfamily|amex|amfam|amica|amsterdam|analytics|android|anquan|anz|aol|apartments|app|apple|aquarelle|arab|aramco|archi|army|art|arte|asda|associates|athleta|attorney|auction|audi|audible|audio|auspost|author|auto|autos|avianca|aws|axa|azure|baby|baidu|banamex|bananarepublic|band|bank|bar|barcelona|barclaycard|barclays|barefoot|bargains|baseball|basketball|bauhaus|bayern|bbc|bbt|bbva|bcg|bcn|beats|beauty|beer|bentley|berlin|best|bestbuy|bet|bharti|bible|bid|bike|bing|bingo|bio|black|blackfriday|blanco|blockbuster|blog|bloomberg|blue|bms|bmw|bnl|bnpparibas|boats|boehringer|bofa|bom|bond|boo|book|booking|boots|bosch|bostik|boston|bot|boutique|box|bradesco|bridgestone|broadway|broker|brother|brussels|budapest|bugatti|build|builders|business|buy|buzz|bzh|cab|cafe|cal|call|calvinklein|cam|camera|camp|cancerresearch|canon|capetown|capital|capitalone|car|caravan|cards|care|career|careers|cars|cartier|casa|case|caseih|cash|casino|catering|catholic|cba|cbn|cbre|cbs|ceb|center|ceo|cern|cfa|cfd|chanel|channel|chase|chat|cheap|chintai|chloe|christmas|chrome|chrysler|church|cipriani|circle|cisco|citadel|citi|citic|city|cityeats|claims|cleaning|click|clinic|clinique|clothing|cloud|club|clubmed|coach|codes|coffee|college|cologne|comcast|commbank|community|company|compare|computer|comsec|condos|construction|consulting|contact|contractors|cooking|cookingchannel|cool|corsica|country|coupon|coupons|courses|credit|creditcard|creditunion|cricket|crown|crs|cruise|cruises|csc|cuisinella|cymru|cyou|dabur|dad|dance|data|date|dating|datsun|day|dclk|dds|deal|dealer|deals|degree|delivery|dell|deloitte|delta|democrat|dental|dentist|desi|design|dev|dhl|diamonds|diet|digital|direct|directory|discount|discover|dish|diy|dnp|docs|doctor|dodge|dog|doha|domains|dot|download|drive|dtv|dubai|duck|dunlop|duns|dupont|durban|dvag|dvr|dwg|earth|eat|eco|edeka|education|email|emerck|energy|engineer|engineering|enterprises|epost|epson|equipment|ericsson|erni|esq|estate|esurance|etisalat|eurovision|eus|events|everbank|exchange|expert|exposed|express|extraspace|fage|fail|fairwinds|faith|family|fan|fans|farm|farmers|fashion|fast|fedex|feedback|ferrari|ferrero|fiat|fidelity|fido|film|final|finance|financial|fire|firestone|firmdale|fish|fishing|fit|fitness|flickr|flights|flir|florist|flowers|fly|foo|food|foodnetwork|football|ford|forex|forsale|forum|foundation|fox|free|fresenius|frl|frogans|frontdoor|frontier|ftr|fujitsu|fujixerox|fun|fund|furniture|futbol|fyi|gal|gallery|gallo|gallup|game|games|gap|garden|gbiz|gdn|gea|gent|genting|george|ggee|gift|gifts|gives|giving|glade|glass|gle|global|globo|gmail|gmbh|gmo|gmx|godaddy|gold|goldpoint|golf|goo|goodhands|goodyear|goog|google|gop|got|grainger|graphics|gratis|green|gripe|grocery|group|guardian|gucci|guge|guide|guitars|guru|hair|hamburg|hangout|haus|hbo|hdfc|hdfcbank|health|healthcare|help|helsinki|here|hermes|hgtv|hiphop|hisamitsu|hitachi|hiv|hkt|hockey|holdings|holiday|homedepot|homegoods|homes|homesense|honda|honeywell|horse|hospital|host|hosting|hot|hoteles|hotels|hotmail|house|how|hsbc|htc|hughes|hyatt|hyundai|ibm|icbc|ice|icu|ieee|ifm|iinet|ikano|imamat|imdb|immo|immobilien|industries|infiniti|ing|ink|institute|insurance|insure|intel|international|intuit|investments|ipiranga|irish|iselect|ismaili|ist|istanbul|itau|itv|iveco|iwc|jaguar|java|jcb|jcp|jeep|jetzt|jewelry|jio|jlc|jll|jmp|jnj|joburg|jot|joy|jpmorgan|jprs|juegos|juniper|kaufen|kddi|kerryhotels|kerrylogistics|kerryproperties|kfh|kia|kim|kinder|kindle|kitchen|kiwi|koeln|komatsu|kosher|kpmg|kpn|krd|kred|kuokgroup|kyoto|lacaixa|ladbrokes|lamborghini|lamer|lancaster|lancia|lancome|land|landrover|lanxess|lasalle|lat|latino|latrobe|law|lawyer|lds|lease|leclerc|lefrak|legal|lego|lexus|lgbt|liaison|lidl|life|lifeinsurance|lifestyle|lighting|like|lilly|limited|limo|lincoln|linde|link|lipsy|live|living|lixil|loan|loans|locker|locus|loft|lol|london|lotte|lotto|love|lpl|lplfinancial|ltd|ltda|lundbeck|lupin|luxe|luxury|macys|madrid|maif|maison|makeup|man|management|mango|map|market|marketing|markets|marriott|marshalls|maserati|mattel|mba|mcd|mcdonalds|mckinsey|med|media|meet|melbourne|meme|memorial|men|menu|meo|merckmsd|metlife|miami|microsoft|mini|mint|mit|mitsubishi|mlb|mls|mma|mobile|mobily|moda|moe|moi|mom|monash|money|monster|montblanc|mopar|mormon|mortgage|moscow|moto|motorcycles|mov|movie|movistar|msd|mtn|mtpc|mtr|mutual|mutuelle|nab|nadex|nagoya|nationwide|natura|navy|nba|nec|netbank|netflix|network|neustar|new|newholland|news|next|nextdirect|nexus|nfl|ngo|nhk|nico|nike|nikon|ninja|nissan|nissay|nokia|northwesternmutual|norton|now|nowruz|nowtv|nra|nrw|ntt|nyc|obi|observer|off|office|okinawa|olayan|olayangroup|oldnavy|ollo|omega|one|ong|onl|online|onyourside|ooo|open|oracle|orange|organic|orientexpress|origins|osaka|otsuka|ott|ovh|page|pamperedchef|panasonic|panerai|paris|pars|partners|parts|party|passagens|pay|pccw|pet|pfizer|pharmacy|phd|philips|phone|photo|photography|photos|physio|piaget|pics|pictet|pictures|pid|pin|ping|pink|pioneer|pizza|place|play|playstation|plumbing|plus|pnc|pohl|poker|politie|porn|pramerica|praxi|press|prime|prod|productions|prof|progressive|promo|properties|property|protection|pru|prudential|pub|pwc|qpon|quebec|quest|qvc|racing|radio|raid|read|realestate|realtor|realty|recipes|red|redstone|redumbrella|rehab|reise|reisen|reit|reliance|ren|rent|rentals|repair|report|republican|rest|restaurant|review|reviews|rexroth|rich|richardli|ricoh|rightathome|ril|rio|rip|rmit|rocher|rocks|rodeo|rogers|room|rsvp|ruhr|run|rwe|ryukyu|saarland|safe|safety|sakura|sale|salon|samsclub|samsung|sandvik|sandvikcoromant|sanofi|sap|sapo|sarl|sas|save|saxo|sbi|sbs|sca|scb|schaeffler|schmidt|scholarships|school|schule|schwarz|science|scjohnson|scor|scot|search|seat|secure|security|seek|select|sener|services|ses|seven|sew|sex|sexy|sfr|shangrila|sharp|shaw|shell|shia|shiksha|shoes|shop|shopping|shouji|show|showtime|shriram|silk|sina|singles|site|ski|skin|sky|skype|sling|smart|smile|sncf|soccer|social|softbank|software|sohu|solar|solutions|song|sony|soy|space|spiegel|spot|spreadbetting|srl|srt|stada|staples|star|starhub|statebank|statefarm|statoil|stc|stcgroup|stockholm|storage|store|stream|studio|study|style|sucks|supplies|supply|support|surf|surgery|suzuki|swatch|swiftcover|swiss|sydney|symantec|systems|tab|taipei|talk|taobao|target|tatamotors|tatar|tattoo|tax|taxi|tci|tdk|team|tech|technology|telecity|telefonica|temasek|tennis|teva|thd|theater|theatre|theguardian|tiaa|tickets|tienda|tiffany|tips|tires|tirol|tjmaxx|tjx|tkmaxx|tmall|today|tokyo|tools|top|toray|toshiba|total|tours|town|toyota|toys|trade|trading|training|travelchannel|travelers|travelersinsurance|trust|trv|tube|tui|tunes|tushu|tvs|ubank|ubs|uconnect|unicom|university|uno|uol|ups|vacations|vana|vanguard|vegas|ventures|verisign|versicherung|vet|viajes|video|vig|viking|villas|vin|vip|virgin|visa|vision|vista|vistaprint|viva|vivo|vlaanderen|vodka|volkswagen|volvo|vote|voting|voto|voyage|vuelos|wales|walmart|walter|wang|wanggou|warman|watch|watches|weather|weatherchannel|webcam|weber|website|wed|wedding|weibo|weir|whoswho|wien|wiki|williamhill|win|windows|wine|winners|wme|wolterskluwer|woodside|work|works|world|wow|wtc|wtf|xbox|xerox|xfinity|xihuan|xin|कॉम|セール|佛山|慈善|集团|在线|大众汽车|点看|คอม|八卦|موقع|一号店|公益|公司|香格里拉|网站|移动|我爱你|москва|католик|онлайн|сайт|联通|קום|时尚|微博|淡马锡|ファッション|орг|नेट|ストア|삼성|商标|商店|商城|дети|ポイント|新闻|工行|家電|كوم|中文网|中信|娱乐|谷歌|電訊盈科|购物|クラウド|通販|网店|संगठन|餐厅|网络|ком|诺基亚|食品|飞利浦|手表|手机|ارامكو|العليان|اتصالات|بازار|موبايلي|ابوظبي|كاثوليك|همراه|닷컴|政府|شبكة|بيتك|عرب|机构|组织机构|健康|рус|珠宝|大拿|みんな|グーグル|世界|書籍|网址|닷넷|コム|天主教|游戏|vermögensberater|vermögensberatung|企业|信息|嘉里大酒店|嘉里|广东|政务|xperia|xyz|yachts|yahoo|yamaxun|yandex|yodobashi|yoga|yokohama|you|youtube|yun|zappos|zara|zero|zip|zippo|zone|zuerich|$beep\.pl|[^.]+\.compute\.estate|[^.]+\.alces\.network|[^.]+\.alwaysdata\.net|cloudfront\.net|[^.]+\.compute\.amazonaws\.com|[^.]+\.compute-1\.amazonaws\.com|[^.]+\.compute\.amazonaws\.com\.cn|us-east-1\.amazonaws\.com|elasticbeanstalk\.cn-north-1\.amazonaws\.com\.cn|[^.]+\.elasticbeanstalk\.com|[^.]+\.elb\.amazonaws\.com|[^.]+\.elb\.amazonaws\.com\.cn|s3\.amazonaws\.com|s3-ap-northeast-1\.amazonaws\.com|s3-ap-northeast-2\.amazonaws\.com|s3-ap-south-1\.amazonaws\.com|s3-ap-southeast-1\.amazonaws\.com|s3-ap-southeast-2\.amazonaws\.com|s3-ca-central-1\.amazonaws\.com|s3-eu-central-1\.amazonaws\.com|s3-eu-west-1\.amazonaws\.com|s3-eu-west-2\.amazonaws\.com|s3-external-1\.amazonaws\.com|s3-fips-us-gov-west-1\.amazonaws\.com|s3-sa-east-1\.amazonaws\.com|s3-us-gov-west-1\.amazonaws\.com|s3-us-east-2\.amazonaws\.com|s3-us-west-1\.amazonaws\.com|s3-us-west-2\.amazonaws\.com|s3\.ap-northeast-2\.amazonaws\.com|s3\.ap-south-1\.amazonaws\.com|s3\.cn-north-1\.amazonaws\.com\.cn|s3\.ca-central-1\.amazonaws\.com|s3\.eu-central-1\.amazonaws\.com|s3\.eu-west-2\.amazonaws\.com|s3\.us-east-2\.amazonaws\.com|s3\.dualstack\.ap-northeast-1\.amazonaws\.com|s3\.dualstack\.ap-northeast-2\.amazonaws\.com|s3\.dualstack\.ap-south-1\.amazonaws\.com|s3\.dualstack\.ap-southeast-1\.amazonaws\.com|s3\.dualstack\.ap-southeast-2\.amazonaws\.com|s3\.dualstack\.ca-central-1\.amazonaws\.com|s3\.dualstack\.eu-central-1\.amazonaws\.com|s3\.dualstack\.eu-west-1\.amazonaws\.com|s3\.dualstack\.eu-west-2\.amazonaws\.com|s3\.dualstack\.sa-east-1\.amazonaws\.com|s3\.dualstack\.us-east-1\.amazonaws\.com|s3\.dualstack\.us-east-2\.amazonaws\.com|s3-website-us-east-1\.amazonaws\.com|s3-website-us-west-1\.amazonaws\.com|s3-website-us-west-2\.amazonaws\.com|s3-website-ap-northeast-1\.amazonaws\.com|s3-website-ap-southeast-1\.amazonaws\.com|s3-website-ap-southeast-2\.amazonaws\.com|s3-website-eu-west-1\.amazonaws\.com|s3-website-sa-east-1\.amazonaws\.com|s3-website\.ap-northeast-2\.amazonaws\.com|s3-website\.ap-south-1\.amazonaws\.com|s3-website\.ca-central-1\.amazonaws\.com|s3-website\.eu-central-1\.amazonaws\.com|s3-website\.eu-west-2\.amazonaws\.com|s3-website\.us-east-2\.amazonaws\.com|t3l3p0rt\.net|tele\.amune\.org|on-aptible\.com|user\.party\.eus|pimienta\.org|poivron\.org|potager\.org|sweetpepper\.org|myasustor\.com|myfritz\.net|backplaneapp\.io|betainabox\.com|bnr\.la|boxfuse\.io|browsersafetymark\.io|mycd\.eu|ae\.org|ar\.com|br\.com|cn\.com|com\.de|com\.se|de\.com|eu\.com|gb\.com|gb\.net|hu\.com|hu\.net|jp\.net|jpn\.com|kr\.com|mex\.com|no\.com|qc\.com|ru\.com|sa\.com|se\.com|se\.net|uk\.com|uk\.net|us\.com|uy\.com|za\.bz|za\.com|africa\.com|gr\.com|in\.net|us\.org|co\.com|c\.la|certmgr\.org|xenapponazure\.com|virtueeldomein\.nl|cloudcontrolled\.com|cloudcontrolapp\.com|co\.ca|co\.cz|c\.cdn77\.org|cdn77-ssl\.net|r\.cdn77\.net|rsc\.cdn77\.org|ssl\.origin\.cdn77-secure\.org|cloudns\.asia|cloudns\.biz|cloudns\.club|cloudns\.cc|cloudns\.eu|cloudns\.in|cloudns\.info|cloudns\.org|cloudns\.pro|cloudns\.pw|cloudns\.us|co\.nl|co\.no|[^.]+\.platform\.sh|dyn\.cosidns\.de|dynamisches-dns\.de|dnsupdater\.de|internet-dns\.de|l-o-g-i-n\.de|dynamic-dns\.info|feste-ip\.net|knx-server\.net|static-access\.net|realm\.cz|[^.]+\.cryptonomic\.net|cupcake\.is|cyon\.link|cyon\.site|daplie\.me|biz\.dk|co\.dk|firm\.dk|reg\.dk|store\.dk|dedyn\.io|dnshome\.de|dreamhosters\.com|mydrobo\.com|drud\.io|drud\.us|duckdns\.org|dy\.fi|tunk\.org|dyndns-at-home\.com|dyndns-at-work\.com|dyndns-blog\.com|dyndns-free\.com|dyndns-home\.com|dyndns-ip\.com|dyndns-mail\.com|dyndns-office\.com|dyndns-pics\.com|dyndns-remote\.com|dyndns-server\.com|dyndns-web\.com|dyndns-wiki\.com|dyndns-work\.com|dyndns\.biz|dyndns\.info|dyndns\.org|dyndns\.tv|at-band-camp\.net|ath\.cx|barrel-of-knowledge\.info|barrell-of-knowledge\.info|better-than\.tv|blogdns\.com|blogdns\.net|blogdns\.org|blogsite\.org|boldlygoingnowhere\.org|broke-it\.net|buyshouses\.net|cechire\.com|dnsalias\.com|dnsalias\.net|dnsalias\.org|dnsdojo\.com|dnsdojo\.net|dnsdojo\.org|does-it\.net|doesntexist\.com|doesntexist\.org|dontexist\.com|dontexist\.net|dontexist\.org|doomdns\.com|doomdns\.org|dvrdns\.org|dyn-o-saur\.com|dynalias\.com|dynalias\.net|dynalias\.org|dynathome\.net|dyndns\.ws|endofinternet\.net|endofinternet\.org|endoftheinternet\.org|est-a-la-maison\.com|est-a-la-masion\.com|est-le-patron\.com|est-mon-blogueur\.com|for-better\.biz|for-more\.biz|for-our\.info|for-some\.biz|for-the\.biz|forgot\.her\.name|forgot\.his\.name|from-ak\.com|from-al\.com|from-ar\.com|from-az\.net|from-ca\.com|from-co\.net|from-ct\.com|from-dc\.com|from-de\.com|from-fl\.com|from-ga\.com|from-hi\.com|from-ia\.com|from-id\.com|from-il\.com|from-in\.com|from-ks\.com|from-ky\.com|from-la\.net|from-ma\.com|from-md\.com|from-me\.org|from-mi\.com|from-mn\.com|from-mo\.com|from-ms\.com|from-mt\.com|from-nc\.com|from-nd\.com|from-ne\.com|from-nh\.com|from-nj\.com|from-nm\.com|from-nv\.com|from-ny\.net|from-oh\.com|from-ok\.com|from-or\.com|from-pa\.com|from-pr\.com|from-ri\.com|from-sc\.com|from-sd\.com|from-tn\.com|from-tx\.com|from-ut\.com|from-va\.com|from-vt\.com|from-wa\.com|from-wi\.com|from-wv\.com|from-wy\.com|ftpaccess\.cc|fuettertdasnetz\.de|game-host\.org|game-server\.cc|getmyip\.com|gets-it\.net|go\.dyndns\.org|gotdns\.com|gotdns\.org|groks-the\.info|groks-this\.info|ham-radio-op\.net|here-for-more\.info|hobby-site\.com|hobby-site\.org|home\.dyndns\.org|homedns\.org|homeftp\.net|homeftp\.org|homeip\.net|homelinux\.com|homelinux\.net|homelinux\.org|homeunix\.com|homeunix\.net|homeunix\.org|iamallama\.com|in-the-band\.net|is-a-anarchist\.com|is-a-blogger\.com|is-a-bookkeeper\.com|is-a-bruinsfan\.org|is-a-bulls-fan\.com|is-a-candidate\.org|is-a-caterer\.com|is-a-celticsfan\.org|is-a-chef\.com|is-a-chef\.net|is-a-chef\.org|is-a-conservative\.com|is-a-cpa\.com|is-a-cubicle-slave\.com|is-a-democrat\.com|is-a-designer\.com|is-a-doctor\.com|is-a-financialadvisor\.com|is-a-geek\.com|is-a-geek\.net|is-a-geek\.org|is-a-green\.com|is-a-guru\.com|is-a-hard-worker\.com|is-a-hunter\.com|is-a-knight\.org|is-a-landscaper\.com|is-a-lawyer\.com|is-a-liberal\.com|is-a-libertarian\.com|is-a-linux-user\.org|is-a-llama\.com|is-a-musician\.com|is-a-nascarfan\.com|is-a-nurse\.com|is-a-painter\.com|is-a-patsfan\.org|is-a-personaltrainer\.com|is-a-photographer\.com|is-a-player\.com|is-a-republican\.com|is-a-rockstar\.com|is-a-socialist\.com|is-a-soxfan\.org|is-a-student\.com|is-a-teacher\.com|is-a-techie\.com|is-a-therapist\.com|is-an-accountant\.com|is-an-actor\.com|is-an-actress\.com|is-an-anarchist\.com|is-an-artist\.com|is-an-engineer\.com|is-an-entertainer\.com|is-by\.us|is-certified\.com|is-found\.org|is-gone\.com|is-into-anime\.com|is-into-cars\.com|is-into-cartoons\.com|is-into-games\.com|is-leet\.com|is-lost\.org|is-not-certified\.com|is-saved\.org|is-slick\.com|is-uberleet\.com|is-very-bad\.org|is-very-evil\.org|is-very-good\.org|is-very-nice\.org|is-very-sweet\.org|is-with-theband\.com|isa-geek\.com|isa-geek\.net|isa-geek\.org|isa-hockeynut\.com|issmarterthanyou\.com|isteingeek\.de|istmein\.de|kicks-ass\.net|kicks-ass\.org|knowsitall\.info|land-4-sale\.us|lebtimnetz\.de|leitungsen\.de|likes-pie\.com|likescandy\.com|merseine\.nu|mine\.nu|misconfused\.org|mypets\.ws|myphotos\.cc|neat-url\.com|office-on-the\.net|on-the-web\.tv|podzone\.net|podzone\.org|readmyblog\.org|saves-the-whales\.com|scrapper-site\.net|scrapping\.cc|selfip\.biz|selfip\.com|selfip\.info|selfip\.net|selfip\.org|sells-for-less\.com|sells-for-u\.com|sells-it\.net|sellsyourhome\.org|servebbs\.com|servebbs\.net|servebbs\.org|serveftp\.net|serveftp\.org|servegame\.org|shacknet\.nu|simple-url\.com|space-to-rent\.com|stuff-4-sale\.org|stuff-4-sale\.us|teaches-yoga\.com|thruhere\.net|traeumtgerade\.de|webhop\.biz|webhop\.info|webhop\.net|webhop\.org|worse-than\.tv|writesthisblog\.com|ddnss\.de|dyn\.ddnss\.de|dyndns\.ddnss\.de|dyndns1\.de|dyn-ip24\.de|home-webserver\.de|dyn\.home-webserver\.de|myhome-server\.de|ddnss\.org|dynv6\.net|e4\.cz|enonic\.io|customer\.enonic\.io|eu\.org|al\.eu\.org|asso\.eu\.org|at\.eu\.org|au\.eu\.org|be\.eu\.org|bg\.eu\.org|ca\.eu\.org|cd\.eu\.org|ch\.eu\.org|cn\.eu\.org|cy\.eu\.org|cz\.eu\.org|de\.eu\.org|dk\.eu\.org|edu\.eu\.org|ee\.eu\.org|es\.eu\.org|fi\.eu\.org|fr\.eu\.org|gr\.eu\.org|hr\.eu\.org|hu\.eu\.org|ie\.eu\.org|il\.eu\.org|in\.eu\.org|int\.eu\.org|is\.eu\.org|it\.eu\.org|jp\.eu\.org|kr\.eu\.org|lt\.eu\.org|lu\.eu\.org|lv\.eu\.org|mc\.eu\.org|me\.eu\.org|mk\.eu\.org|mt\.eu\.org|my\.eu\.org|net\.eu\.org|ng\.eu\.org|nl\.eu\.org|no\.eu\.org|nz\.eu\.org|paris\.eu\.org|pl\.eu\.org|pt\.eu\.org|q-a\.eu\.org|ro\.eu\.org|ru\.eu\.org|se\.eu\.org|si\.eu\.org|sk\.eu\.org|tr\.eu\.org|uk\.eu\.org|us\.eu\.org|eu-1\.evennode\.com|eu-2\.evennode\.com|us-1\.evennode\.com|us-2\.evennode\.com|apps\.fbsbx\.com|ru\.net|adygeya\.ru|bashkiria\.ru|bir\.ru|cbg\.ru|com\.ru|dagestan\.ru|grozny\.ru|kalmykia\.ru|kustanai\.ru|marine\.ru|mordovia\.ru|msk\.ru|mytis\.ru|nalchik\.ru|nov\.ru|pyatigorsk\.ru|spb\.ru|vladikavkaz\.ru|vladimir\.ru|abkhazia\.su|adygeya\.su|aktyubinsk\.su|arkhangelsk\.su|armenia\.su|ashgabad\.su|azerbaijan\.su|balashov\.su|bashkiria\.su|bryansk\.su|bukhara\.su|chimkent\.su|dagestan\.su|east-kazakhstan\.su|exnet\.su|georgia\.su|grozny\.su|ivanovo\.su|jambyl\.su|kalmykia\.su|kaluga\.su|karacol\.su|karaganda\.su|karelia\.su|khakassia\.su|krasnodar\.su|kurgan\.su|kustanai\.su|lenug\.su|mangyshlak\.su|mordovia\.su|msk\.su|murmansk\.su|nalchik\.su|navoi\.su|north-kazakhstan\.su|nov\.su|obninsk\.su|penza\.su|pokrovsk\.su|sochi\.su|spb\.su|tashkent\.su|termez\.su|togliatti\.su|troitsk\.su|tselinograd\.su|tula\.su|tuva\.su|vladikavkaz\.su|vladimir\.su|vologda\.su|map\.fastly\.net|a\.prod\.fastly\.net|global\.prod\.fastly\.net|a\.ssl\.fastly\.net|b\.ssl\.fastly\.net|global\.ssl\.fastly\.net|fastlylb\.net|map\.fastlylb\.net|fhapp\.xyz|firebaseapp\.com|flynnhub\.com|freebox-os\.com|freeboxos\.com|fbx-os\.fr|fbxos\.fr|freebox-os\.fr|freeboxos\.fr|myfusion\.cloud|futurehosting\.at|futuremailing\.at|[^.]+\.ex\.ortsinfo\.at|[^.]+\.kunden\.ortsinfo\.at|[^.]+\.statics\.cloud|service\.gov\.uk|github\.io|githubusercontent\.com|githubcloud\.com|[^.]+\.api\.githubcloud\.com|[^.]+\.ext\.githubcloud\.com|gist\.githubcloud\.com|[^.]+\.githubcloudusercontent\.com|gitlab\.io|homeoffice\.gov\.uk|ro\.im|shop\.ro|goip\.de|[^.]+\.0emm\.com|appspot\.com|blogspot\.ae|blogspot\.al|blogspot\.am|blogspot\.ba|blogspot\.be|blogspot\.bg|blogspot\.bj|blogspot\.ca|blogspot\.cf|blogspot\.ch|blogspot\.cl|blogspot\.co\.at|blogspot\.co\.id|blogspot\.co\.il|blogspot\.co\.ke|blogspot\.co\.nz|blogspot\.co\.uk|blogspot\.co\.za|blogspot\.com|blogspot\.com\.ar|blogspot\.com\.au|blogspot\.com\.br|blogspot\.com\.by|blogspot\.com\.co|blogspot\.com\.cy|blogspot\.com\.ee|blogspot\.com\.eg|blogspot\.com\.es|blogspot\.com\.mt|blogspot\.com\.ng|blogspot\.com\.tr|blogspot\.com\.uy|blogspot\.cv|blogspot\.cz|blogspot\.de|blogspot\.dk|blogspot\.fi|blogspot\.fr|blogspot\.gr|blogspot\.hk|blogspot\.hr|blogspot\.hu|blogspot\.ie|blogspot\.in|blogspot\.is|blogspot\.it|blogspot\.jp|blogspot\.kr|blogspot\.li|blogspot\.lt|blogspot\.lu|blogspot\.md|blogspot\.mk|blogspot\.mr|blogspot\.mx|blogspot\.my|blogspot\.nl|blogspot\.no|blogspot\.pe|blogspot\.pt|blogspot\.qa|blogspot\.re|blogspot\.ro|blogspot\.rs|blogspot\.ru|blogspot\.se|blogspot\.sg|blogspot\.si|blogspot\.sk|blogspot\.sn|blogspot\.td|blogspot\.tw|blogspot\.ug|blogspot\.vn|cloudfunctions\.net|codespot\.com|googleapis\.com|googlecode\.com|pagespeedmobilizer\.com|publishproxy\.com|withgoogle\.com|withyoutube\.com|hashbang\.sh|hasura-app\.io|hepforge\.org|herokuapp\.com|herokussl\.com|iki\.fi|biz\.at|info\.at|ac\.leg\.br|al\.leg\.br|am\.leg\.br|ap\.leg\.br|ba\.leg\.br|ce\.leg\.br|df\.leg\.br|es\.leg\.br|go\.leg\.br|ma\.leg\.br|mg\.leg\.br|ms\.leg\.br|mt\.leg\.br|pa\.leg\.br|pb\.leg\.br|pe\.leg\.br|pi\.leg\.br|pr\.leg\.br|rj\.leg\.br|rn\.leg\.br|ro\.leg\.br|rr\.leg\.br|rs\.leg\.br|sc\.leg\.br|se\.leg\.br|sp\.leg\.br|to\.leg\.br|[^.]+\.triton\.zone|[^.]+\.cns\.joyent\.com|js\.org|keymachine\.de|knightpoint\.systems|co\.krd|edu\.krd|[^.]+\.magentosite\.cloud|meteorapp\.com|eu\.meteorapp\.com|co\.pl|azurewebsites\.net|azure-mobile\.net|cloudapp\.net|bmoattachments\.org|4u\.com|ngrok\.io|nfshost\.com|nsupdate\.info|nerdpol\.ovh|blogsyte\.com|brasilia\.me|cable-modem\.org|ciscofreak\.com|collegefan\.org|couchpotatofries\.org|damnserver\.com|ddns\.me|ditchyourip\.com|dnsfor\.me|dnsiskinky\.com|dvrcam\.info|dynns\.com|eating-organic\.net|fantasyleague\.cc|geekgalaxy\.com|golffan\.us|health-carereform\.com|homesecuritymac\.com|homesecuritypc\.com|hopto\.me|ilovecollege\.info|loginto\.me|mlbfan\.org|mmafan\.biz|myactivedirectory\.com|mydissent\.net|myeffect\.net|mymediapc\.net|mypsx\.net|mysecuritycamera\.com|mysecuritycamera\.net|mysecuritycamera\.org|net-freaks\.com|nflfan\.org|nhlfan\.net|no-ip\.ca|no-ip\.co\.uk|no-ip\.net|noip\.us|onthewifi\.com|pgafan\.net|point2this\.com|pointto\.us|privatizehealthinsurance\.net|quicksytes\.com|read-books\.org|securitytactics\.com|serveexchange\.com|servehumour\.com|servep2p\.com|servesarcasm\.com|stufftoread\.com|ufcfan\.org|unusualperson\.com|workisboring\.com|3utilities\.com|bounceme\.net|ddns\.net|ddnsking\.com|gotdns\.ch|hopto\.org|myftp\.biz|myftp\.org|myvnc\.com|no-ip\.biz|no-ip\.info|no-ip\.org|noip\.me|redirectme\.net|servebeer\.com|serveblog\.net|servecounterstrike\.com|serveftp\.com|servegame\.com|servehalflife\.com|servehttp\.com|serveirc\.com|serveminecraft\.net|servemp3\.com|servepics\.com|servequake\.com|sytes\.net|webhop\.me|zapto\.org|nyc\.mn|nid\.io|opencraft\.hosting|operaunite\.com|outsystemscloud\.com|ownprovider\.com|oy\.lc|pgfog\.com|pagefrontapp\.com|art\.pl|gliwice\.pl|krakow\.pl|poznan\.pl|wroc\.pl|zakopane\.pl|pantheonsite\.io|gotpantheon\.com|mypep\.link|on-web\.fr|xen\.prgmr\.com|priv\.at|protonet\.io|chirurgiens-dentistes-en-france\.fr|qa2\.com|dev-myqnapcloud\.com|alpha-myqnapcloud\.com|myqnapcloud\.com|rackmaze\.com|rackmaze\.net|rhcloud\.com|hzc\.io|wellbeingzone\.eu|ptplus\.fit|wellbeingzone\.co\.uk|sandcats\.io|logoip\.de|logoip\.com|firewall-gateway\.com|firewall-gateway\.de|my-gateway\.de|my-router\.de|spdns\.de|spdns\.eu|firewall-gateway\.net|my-firewall\.org|myfirewall\.org|spdns\.org|biz\.ua|co\.ua|pp\.ua|shiftedit\.io|myshopblocks\.com|1kapp\.com|appchizi\.com|applinzi\.com|sinaapp\.com|vipsinaapp\.com|bounty-full\.com|alpha\.bounty-full\.com|beta\.bounty-full\.com|static\.land|dev\.static\.land|sites\.static\.land|apps\.lair\.io|[^.]+\.stolos\.io|spacekit\.io|stackspace\.space|diskstation\.me|dscloud\.biz|dscloud\.me|dscloud\.mobi|dsmynas\.com|dsmynas\.net|dsmynas\.org|familyds\.com|familyds\.net|familyds\.org|i234\.me|myds\.me|synology\.me|taifun-dns\.de|gda\.pl|gdansk\.pl|gdynia\.pl|med\.pl|sopot\.pl|bloxcms\.com|townnews-staging\.com|[^.]+\.transurl\.be|[^.]+\.transurl\.eu|[^.]+\.transurl\.nl|tuxfamily\.org|dd-dns\.de|diskstation\.eu|diskstation\.org|dray-dns\.de|draydns\.de|dyn-vpn\.de|dynvpn\.de|mein-vigor\.de|my-vigor\.de|my-wan\.de|syno-ds\.de|synology-diskstation\.de|synology-ds\.de|hk\.com|hk\.org|ltd\.hk|inc\.hk|lib\.de\.us|router\.management|remotewd\.com|wmflabs\.org|yolasite\.com|ybo\.faith|yombo\.me|homelink\.one|ybo\.party|ybo\.review|ybo\.science|ybo\.trade|za\.net|za\.org|now\.sh|cc\.ua|inf\.ua|ltd\.ua)$/;
exports.icann = /\.(ac|com\.ac|edu\.ac|gov\.ac|net\.ac|mil\.ac|org\.ac|ad|nom\.ad|ae|co\.ae|net\.ae|org\.ae|sch\.ae|ac\.ae|gov\.ae|mil\.ae|aero|accident-investigation\.aero|accident-prevention\.aero|aerobatic\.aero|aeroclub\.aero|aerodrome\.aero|agents\.aero|aircraft\.aero|airline\.aero|airport\.aero|air-surveillance\.aero|airtraffic\.aero|air-traffic-control\.aero|ambulance\.aero|amusement\.aero|association\.aero|author\.aero|ballooning\.aero|broker\.aero|caa\.aero|cargo\.aero|catering\.aero|certification\.aero|championship\.aero|charter\.aero|civilaviation\.aero|club\.aero|conference\.aero|consultant\.aero|consulting\.aero|control\.aero|council\.aero|crew\.aero|design\.aero|dgca\.aero|educator\.aero|emergency\.aero|engine\.aero|engineer\.aero|entertainment\.aero|equipment\.aero|exchange\.aero|express\.aero|federation\.aero|flight\.aero|freight\.aero|fuel\.aero|gliding\.aero|government\.aero|groundhandling\.aero|group\.aero|hanggliding\.aero|homebuilt\.aero|insurance\.aero|journal\.aero|journalist\.aero|leasing\.aero|logistics\.aero|magazine\.aero|maintenance\.aero|media\.aero|microlight\.aero|modelling\.aero|navigation\.aero|parachuting\.aero|paragliding\.aero|passenger-association\.aero|pilot\.aero|press\.aero|production\.aero|recreation\.aero|repbody\.aero|res\.aero|research\.aero|rotorcraft\.aero|safety\.aero|scientist\.aero|services\.aero|show\.aero|skydiving\.aero|software\.aero|student\.aero|trader\.aero|trading\.aero|trainer\.aero|union\.aero|workinggroup\.aero|works\.aero|af|gov\.af|com\.af|org\.af|net\.af|edu\.af|ag|com\.ag|org\.ag|net\.ag|co\.ag|nom\.ag|ai|off\.ai|com\.ai|net\.ai|org\.ai|al|com\.al|edu\.al|gov\.al|mil\.al|net\.al|org\.al|am|ao|ed\.ao|gv\.ao|og\.ao|co\.ao|pb\.ao|it\.ao|aq|ar|com\.ar|edu\.ar|gob\.ar|gov\.ar|int\.ar|mil\.ar|net\.ar|org\.ar|tur\.ar|arpa|e164\.arpa|in-addr\.arpa|ip6\.arpa|iris\.arpa|uri\.arpa|urn\.arpa|as|gov\.as|asia|at|ac\.at|co\.at|gv\.at|or\.at|au|com\.au|net\.au|org\.au|edu\.au|gov\.au|asn\.au|id\.au|info\.au|conf\.au|oz\.au|act\.au|nsw\.au|nt\.au|qld\.au|sa\.au|tas\.au|vic\.au|wa\.au|act\.edu\.au|nsw\.edu\.au|nt\.edu\.au|qld\.edu\.au|sa\.edu\.au|tas\.edu\.au|vic\.edu\.au|wa\.edu\.au|qld\.gov\.au|sa\.gov\.au|tas\.gov\.au|vic\.gov\.au|wa\.gov\.au|aw|com\.aw|ax|az|com\.az|net\.az|int\.az|gov\.az|org\.az|edu\.az|info\.az|pp\.az|mil\.az|name\.az|pro\.az|biz\.az|ba|com\.ba|edu\.ba|gov\.ba|mil\.ba|net\.ba|org\.ba|bb|biz\.bb|co\.bb|com\.bb|edu\.bb|gov\.bb|info\.bb|net\.bb|org\.bb|store\.bb|tv\.bb|[^.]+\.bd|be|ac\.be|bf|gov\.bf|bg|a\.bg|b\.bg|c\.bg|d\.bg|e\.bg|f\.bg|g\.bg|h\.bg|i\.bg|j\.bg|k\.bg|l\.bg|m\.bg|n\.bg|o\.bg|p\.bg|q\.bg|r\.bg|s\.bg|t\.bg|u\.bg|v\.bg|w\.bg|x\.bg|y\.bg|z\.bg|0\.bg|1\.bg|2\.bg|3\.bg|4\.bg|5\.bg|6\.bg|7\.bg|8\.bg|9\.bg|bh|com\.bh|edu\.bh|net\.bh|org\.bh|gov\.bh|bi|co\.bi|com\.bi|edu\.bi|or\.bi|org\.bi|biz|bj|asso\.bj|barreau\.bj|gouv\.bj|bm|com\.bm|edu\.bm|gov\.bm|net\.bm|org\.bm|[^.]+\.bn|bo|com\.bo|edu\.bo|gov\.bo|gob\.bo|int\.bo|org\.bo|net\.bo|mil\.bo|tv\.bo|br|adm\.br|adv\.br|agr\.br|am\.br|arq\.br|art\.br|ato\.br|b\.br|bio\.br|blog\.br|bmd\.br|cim\.br|cng\.br|cnt\.br|com\.br|coop\.br|ecn\.br|eco\.br|edu\.br|emp\.br|eng\.br|esp\.br|etc\.br|eti\.br|far\.br|flog\.br|fm\.br|fnd\.br|fot\.br|fst\.br|g12\.br|ggf\.br|gov\.br|imb\.br|ind\.br|inf\.br|jor\.br|jus\.br|leg\.br|lel\.br|mat\.br|med\.br|mil\.br|mp\.br|mus\.br|net\.br|[^.]+\.nom\.br|not\.br|ntr\.br|odo\.br|org\.br|ppg\.br|pro\.br|psc\.br|psi\.br|qsl\.br|radio\.br|rec\.br|slg\.br|srv\.br|taxi\.br|teo\.br|tmp\.br|trd\.br|tur\.br|tv\.br|vet\.br|vlog\.br|wiki\.br|zlg\.br|bs|com\.bs|net\.bs|org\.bs|edu\.bs|gov\.bs|bt|com\.bt|edu\.bt|gov\.bt|net\.bt|org\.bt|bv|bw|co\.bw|org\.bw|by|gov\.by|mil\.by|com\.by|of\.by|bz|com\.bz|net\.bz|org\.bz|edu\.bz|gov\.bz|ca|ab\.ca|bc\.ca|mb\.ca|nb\.ca|nf\.ca|nl\.ca|ns\.ca|nt\.ca|nu\.ca|on\.ca|pe\.ca|qc\.ca|sk\.ca|yk\.ca|gc\.ca|cat|cc|cd|gov\.cd|cf|cg|ch|ci|org\.ci|or\.ci|com\.ci|co\.ci|edu\.ci|ed\.ci|ac\.ci|net\.ci|go\.ci|asso\.ci|aéroport\.ci|int\.ci|presse\.ci|md\.ci|gouv\.ci|[^.]+\.ck|!www\.ck|cl|gov\.cl|gob\.cl|co\.cl|mil\.cl|cm|co\.cm|com\.cm|gov\.cm|net\.cm|cn|ac\.cn|com\.cn|edu\.cn|gov\.cn|net\.cn|org\.cn|mil\.cn|公司\.cn|网络\.cn|網絡\.cn|ah\.cn|bj\.cn|cq\.cn|fj\.cn|gd\.cn|gs\.cn|gz\.cn|gx\.cn|ha\.cn|hb\.cn|he\.cn|hi\.cn|hl\.cn|hn\.cn|jl\.cn|js\.cn|jx\.cn|ln\.cn|nm\.cn|nx\.cn|qh\.cn|sc\.cn|sd\.cn|sh\.cn|sn\.cn|sx\.cn|tj\.cn|xj\.cn|xz\.cn|yn\.cn|zj\.cn|hk\.cn|mo\.cn|tw\.cn|co|arts\.co|com\.co|edu\.co|firm\.co|gov\.co|info\.co|int\.co|mil\.co|net\.co|nom\.co|org\.co|rec\.co|web\.co|com|coop|cr|ac\.cr|co\.cr|ed\.cr|fi\.cr|go\.cr|or\.cr|sa\.cr|cu|com\.cu|edu\.cu|org\.cu|net\.cu|gov\.cu|inf\.cu|cv|cw|com\.cw|edu\.cw|net\.cw|org\.cw|cx|gov\.cx|cy|ac\.cy|biz\.cy|com\.cy|ekloges\.cy|gov\.cy|ltd\.cy|name\.cy|net\.cy|org\.cy|parliament\.cy|press\.cy|pro\.cy|tm\.cy|cz|de|dj|dk|dm|com\.dm|net\.dm|org\.dm|edu\.dm|gov\.dm|do|art\.do|com\.do|edu\.do|gob\.do|gov\.do|mil\.do|net\.do|org\.do|sld\.do|web\.do|dz|com\.dz|org\.dz|net\.dz|gov\.dz|edu\.dz|asso\.dz|pol\.dz|art\.dz|ec|com\.ec|info\.ec|net\.ec|fin\.ec|k12\.ec|med\.ec|pro\.ec|org\.ec|edu\.ec|gov\.ec|gob\.ec|mil\.ec|edu|ee|edu\.ee|gov\.ee|riik\.ee|lib\.ee|med\.ee|com\.ee|pri\.ee|aip\.ee|org\.ee|fie\.ee|eg|com\.eg|edu\.eg|eun\.eg|gov\.eg|mil\.eg|name\.eg|net\.eg|org\.eg|sci\.eg|[^.]+\.er|es|com\.es|nom\.es|org\.es|gob\.es|edu\.es|et|com\.et|gov\.et|org\.et|edu\.et|biz\.et|name\.et|info\.et|net\.et|eu|fi|aland\.fi|[^.]+\.fj|[^.]+\.fk|fm|fo|fr|com\.fr|asso\.fr|nom\.fr|prd\.fr|presse\.fr|tm\.fr|aeroport\.fr|assedic\.fr|avocat\.fr|avoues\.fr|cci\.fr|chambagri\.fr|chirurgiens-dentistes\.fr|experts-comptables\.fr|geometre-expert\.fr|gouv\.fr|greta\.fr|huissier-justice\.fr|medecin\.fr|notaires\.fr|pharmacien\.fr|port\.fr|veterinaire\.fr|ga|gb|gd|ge|com\.ge|edu\.ge|gov\.ge|org\.ge|mil\.ge|net\.ge|pvt\.ge|gf|gg|co\.gg|net\.gg|org\.gg|gh|com\.gh|edu\.gh|gov\.gh|org\.gh|mil\.gh|gi|com\.gi|ltd\.gi|gov\.gi|mod\.gi|edu\.gi|org\.gi|gl|co\.gl|com\.gl|edu\.gl|net\.gl|org\.gl|gm|gn|ac\.gn|com\.gn|edu\.gn|gov\.gn|org\.gn|net\.gn|gov|gp|com\.gp|net\.gp|mobi\.gp|edu\.gp|org\.gp|asso\.gp|gq|gr|com\.gr|edu\.gr|net\.gr|org\.gr|gov\.gr|gs|gt|com\.gt|edu\.gt|gob\.gt|ind\.gt|mil\.gt|net\.gt|org\.gt|[^.]+\.gu|gw|gy|co\.gy|com\.gy|edu\.gy|gov\.gy|net\.gy|org\.gy|hk|com\.hk|edu\.hk|gov\.hk|idv\.hk|net\.hk|org\.hk|公司\.hk|教育\.hk|敎育\.hk|政府\.hk|個人\.hk|个人\.hk|箇人\.hk|網络\.hk|网络\.hk|组織\.hk|網絡\.hk|网絡\.hk|组织\.hk|組織\.hk|組织\.hk|hm|hn|com\.hn|edu\.hn|org\.hn|net\.hn|mil\.hn|gob\.hn|hr|iz\.hr|from\.hr|name\.hr|com\.hr|ht|com\.ht|shop\.ht|firm\.ht|info\.ht|adult\.ht|net\.ht|pro\.ht|org\.ht|med\.ht|art\.ht|coop\.ht|pol\.ht|asso\.ht|edu\.ht|rel\.ht|gouv\.ht|perso\.ht|hu|co\.hu|info\.hu|org\.hu|priv\.hu|sport\.hu|tm\.hu|2000\.hu|agrar\.hu|bolt\.hu|casino\.hu|city\.hu|erotica\.hu|erotika\.hu|film\.hu|forum\.hu|games\.hu|hotel\.hu|ingatlan\.hu|jogasz\.hu|konyvelo\.hu|lakas\.hu|media\.hu|news\.hu|reklam\.hu|sex\.hu|shop\.hu|suli\.hu|szex\.hu|tozsde\.hu|utazas\.hu|video\.hu|id|ac\.id|biz\.id|co\.id|desa\.id|go\.id|mil\.id|my\.id|net\.id|or\.id|sch\.id|web\.id|ie|gov\.ie|il|ac\.il|co\.il|gov\.il|idf\.il|k12\.il|muni\.il|net\.il|org\.il|im|ac\.im|co\.im|com\.im|ltd\.co\.im|net\.im|org\.im|plc\.co\.im|tt\.im|tv\.im|in|co\.in|firm\.in|net\.in|org\.in|gen\.in|ind\.in|nic\.in|ac\.in|edu\.in|res\.in|gov\.in|mil\.in|info|int|eu\.int|io|com\.io|iq|gov\.iq|edu\.iq|mil\.iq|com\.iq|org\.iq|net\.iq|ir|ac\.ir|co\.ir|gov\.ir|id\.ir|net\.ir|org\.ir|sch\.ir|ایران\.ir|ايران\.ir|is|net\.is|com\.is|edu\.is|gov\.is|org\.is|int\.is|it|gov\.it|edu\.it|abr\.it|abruzzo\.it|aosta-valley\.it|aostavalley\.it|bas\.it|basilicata\.it|cal\.it|calabria\.it|cam\.it|campania\.it|emilia-romagna\.it|emiliaromagna\.it|emr\.it|friuli-v-giulia\.it|friuli-ve-giulia\.it|friuli-vegiulia\.it|friuli-venezia-giulia\.it|friuli-veneziagiulia\.it|friuli-vgiulia\.it|friuliv-giulia\.it|friulive-giulia\.it|friulivegiulia\.it|friulivenezia-giulia\.it|friuliveneziagiulia\.it|friulivgiulia\.it|fvg\.it|laz\.it|lazio\.it|lig\.it|liguria\.it|lom\.it|lombardia\.it|lombardy\.it|lucania\.it|mar\.it|marche\.it|mol\.it|molise\.it|piedmont\.it|piemonte\.it|pmn\.it|pug\.it|puglia\.it|sar\.it|sardegna\.it|sardinia\.it|sic\.it|sicilia\.it|sicily\.it|taa\.it|tos\.it|toscana\.it|trentino-a-adige\.it|trentino-aadige\.it|trentino-alto-adige\.it|trentino-altoadige\.it|trentino-s-tirol\.it|trentino-stirol\.it|trentino-sud-tirol\.it|trentino-sudtirol\.it|trentino-sued-tirol\.it|trentino-suedtirol\.it|trentinoa-adige\.it|trentinoaadige\.it|trentinoalto-adige\.it|trentinoaltoadige\.it|trentinos-tirol\.it|trentinostirol\.it|trentinosud-tirol\.it|trentinosudtirol\.it|trentinosued-tirol\.it|trentinosuedtirol\.it|tuscany\.it|umb\.it|umbria\.it|val-d-aosta\.it|val-daosta\.it|vald-aosta\.it|valdaosta\.it|valle-aosta\.it|valle-d-aosta\.it|valle-daosta\.it|valleaosta\.it|valled-aosta\.it|valledaosta\.it|vallee-aoste\.it|valleeaoste\.it|vao\.it|vda\.it|ven\.it|veneto\.it|ag\.it|agrigento\.it|al\.it|alessandria\.it|alto-adige\.it|altoadige\.it|an\.it|ancona\.it|andria-barletta-trani\.it|andria-trani-barletta\.it|andriabarlettatrani\.it|andriatranibarletta\.it|ao\.it|aosta\.it|aoste\.it|ap\.it|aq\.it|aquila\.it|ar\.it|arezzo\.it|ascoli-piceno\.it|ascolipiceno\.it|asti\.it|at\.it|av\.it|avellino\.it|ba\.it|balsan\.it|bari\.it|barletta-trani-andria\.it|barlettatraniandria\.it|belluno\.it|benevento\.it|bergamo\.it|bg\.it|bi\.it|biella\.it|bl\.it|bn\.it|bo\.it|bologna\.it|bolzano\.it|bozen\.it|br\.it|brescia\.it|brindisi\.it|bs\.it|bt\.it|bz\.it|ca\.it|cagliari\.it|caltanissetta\.it|campidano-medio\.it|campidanomedio\.it|campobasso\.it|carbonia-iglesias\.it|carboniaiglesias\.it|carrara-massa\.it|carraramassa\.it|caserta\.it|catania\.it|catanzaro\.it|cb\.it|ce\.it|cesena-forli\.it|cesenaforli\.it|ch\.it|chieti\.it|ci\.it|cl\.it|cn\.it|co\.it|como\.it|cosenza\.it|cr\.it|cremona\.it|crotone\.it|cs\.it|ct\.it|cuneo\.it|cz\.it|dell-ogliastra\.it|dellogliastra\.it|en\.it|enna\.it|fc\.it|fe\.it|fermo\.it|ferrara\.it|fg\.it|fi\.it|firenze\.it|florence\.it|fm\.it|foggia\.it|forli-cesena\.it|forlicesena\.it|fr\.it|frosinone\.it|ge\.it|genoa\.it|genova\.it|go\.it|gorizia\.it|gr\.it|grosseto\.it|iglesias-carbonia\.it|iglesiascarbonia\.it|im\.it|imperia\.it|is\.it|isernia\.it|kr\.it|la-spezia\.it|laquila\.it|laspezia\.it|latina\.it|lc\.it|le\.it|lecce\.it|lecco\.it|li\.it|livorno\.it|lo\.it|lodi\.it|lt\.it|lu\.it|lucca\.it|macerata\.it|mantova\.it|massa-carrara\.it|massacarrara\.it|matera\.it|mb\.it|mc\.it|me\.it|medio-campidano\.it|mediocampidano\.it|messina\.it|mi\.it|milan\.it|milano\.it|mn\.it|mo\.it|modena\.it|monza-brianza\.it|monza-e-della-brianza\.it|monza\.it|monzabrianza\.it|monzaebrianza\.it|monzaedellabrianza\.it|ms\.it|mt\.it|na\.it|naples\.it|napoli\.it|no\.it|novara\.it|nu\.it|nuoro\.it|og\.it|ogliastra\.it|olbia-tempio\.it|olbiatempio\.it|or\.it|oristano\.it|ot\.it|pa\.it|padova\.it|padua\.it|palermo\.it|parma\.it|pavia\.it|pc\.it|pd\.it|pe\.it|perugia\.it|pesaro-urbino\.it|pesarourbino\.it|pescara\.it|pg\.it|pi\.it|piacenza\.it|pisa\.it|pistoia\.it|pn\.it|po\.it|pordenone\.it|potenza\.it|pr\.it|prato\.it|pt\.it|pu\.it|pv\.it|pz\.it|ra\.it|ragusa\.it|ravenna\.it|rc\.it|re\.it|reggio-calabria\.it|reggio-emilia\.it|reggiocalabria\.it|reggioemilia\.it|rg\.it|ri\.it|rieti\.it|rimini\.it|rm\.it|rn\.it|ro\.it|roma\.it|rome\.it|rovigo\.it|sa\.it|salerno\.it|sassari\.it|savona\.it|si\.it|siena\.it|siracusa\.it|so\.it|sondrio\.it|sp\.it|sr\.it|ss\.it|suedtirol\.it|sv\.it|ta\.it|taranto\.it|te\.it|tempio-olbia\.it|tempioolbia\.it|teramo\.it|terni\.it|tn\.it|to\.it|torino\.it|tp\.it|tr\.it|trani-andria-barletta\.it|trani-barletta-andria\.it|traniandriabarletta\.it|tranibarlettaandria\.it|trapani\.it|trentino\.it|trento\.it|treviso\.it|trieste\.it|ts\.it|turin\.it|tv\.it|ud\.it|udine\.it|urbino-pesaro\.it|urbinopesaro\.it|va\.it|varese\.it|vb\.it|vc\.it|ve\.it|venezia\.it|venice\.it|verbania\.it|vercelli\.it|verona\.it|vi\.it|vibo-valentia\.it|vibovalentia\.it|vicenza\.it|viterbo\.it|vr\.it|vs\.it|vt\.it|vv\.it|je|co\.je|net\.je|org\.je|[^.]+\.jm|jo|com\.jo|org\.jo|net\.jo|edu\.jo|sch\.jo|gov\.jo|mil\.jo|name\.jo|jobs|jp|ac\.jp|ad\.jp|co\.jp|ed\.jp|go\.jp|gr\.jp|lg\.jp|ne\.jp|or\.jp|aichi\.jp|akita\.jp|aomori\.jp|chiba\.jp|ehime\.jp|fukui\.jp|fukuoka\.jp|fukushima\.jp|gifu\.jp|gunma\.jp|hiroshima\.jp|hokkaido\.jp|hyogo\.jp|ibaraki\.jp|ishikawa\.jp|iwate\.jp|kagawa\.jp|kagoshima\.jp|kanagawa\.jp|kochi\.jp|kumamoto\.jp|kyoto\.jp|mie\.jp|miyagi\.jp|miyazaki\.jp|nagano\.jp|nagasaki\.jp|nara\.jp|niigata\.jp|oita\.jp|okayama\.jp|okinawa\.jp|osaka\.jp|saga\.jp|saitama\.jp|shiga\.jp|shimane\.jp|shizuoka\.jp|tochigi\.jp|tokushima\.jp|tokyo\.jp|tottori\.jp|toyama\.jp|wakayama\.jp|yamagata\.jp|yamaguchi\.jp|yamanashi\.jp|栃木\.jp|愛知\.jp|愛媛\.jp|兵庫\.jp|熊本\.jp|茨城\.jp|北海道\.jp|千葉\.jp|和歌山\.jp|長崎\.jp|長野\.jp|新潟\.jp|青森\.jp|静岡\.jp|東京\.jp|石川\.jp|埼玉\.jp|三重\.jp|京都\.jp|佐賀\.jp|大分\.jp|大阪\.jp|奈良\.jp|宮城\.jp|宮崎\.jp|富山\.jp|山口\.jp|山形\.jp|山梨\.jp|岩手\.jp|岐阜\.jp|岡山\.jp|島根\.jp|広島\.jp|徳島\.jp|沖縄\.jp|滋賀\.jp|神奈川\.jp|福井\.jp|福岡\.jp|福島\.jp|秋田\.jp|群馬\.jp|香川\.jp|高知\.jp|鳥取\.jp|鹿児島\.jp|[^.]+\.kawasaki\.jp|[^.]+\.kitakyushu\.jp|[^.]+\.kobe\.jp|[^.]+\.nagoya\.jp|[^.]+\.sapporo\.jp|[^.]+\.sendai\.jp|[^.]+\.yokohama\.jp|!city\.kawasaki\.jp|!city\.kitakyushu\.jp|!city\.kobe\.jp|!city\.nagoya\.jp|!city\.sapporo\.jp|!city\.sendai\.jp|!city\.yokohama\.jp|aisai\.aichi\.jp|ama\.aichi\.jp|anjo\.aichi\.jp|asuke\.aichi\.jp|chiryu\.aichi\.jp|chita\.aichi\.jp|fuso\.aichi\.jp|gamagori\.aichi\.jp|handa\.aichi\.jp|hazu\.aichi\.jp|hekinan\.aichi\.jp|higashiura\.aichi\.jp|ichinomiya\.aichi\.jp|inazawa\.aichi\.jp|inuyama\.aichi\.jp|isshiki\.aichi\.jp|iwakura\.aichi\.jp|kanie\.aichi\.jp|kariya\.aichi\.jp|kasugai\.aichi\.jp|kira\.aichi\.jp|kiyosu\.aichi\.jp|komaki\.aichi\.jp|konan\.aichi\.jp|kota\.aichi\.jp|mihama\.aichi\.jp|miyoshi\.aichi\.jp|nishio\.aichi\.jp|nisshin\.aichi\.jp|obu\.aichi\.jp|oguchi\.aichi\.jp|oharu\.aichi\.jp|okazaki\.aichi\.jp|owariasahi\.aichi\.jp|seto\.aichi\.jp|shikatsu\.aichi\.jp|shinshiro\.aichi\.jp|shitara\.aichi\.jp|tahara\.aichi\.jp|takahama\.aichi\.jp|tobishima\.aichi\.jp|toei\.aichi\.jp|togo\.aichi\.jp|tokai\.aichi\.jp|tokoname\.aichi\.jp|toyoake\.aichi\.jp|toyohashi\.aichi\.jp|toyokawa\.aichi\.jp|toyone\.aichi\.jp|toyota\.aichi\.jp|tsushima\.aichi\.jp|yatomi\.aichi\.jp|akita\.akita\.jp|daisen\.akita\.jp|fujisato\.akita\.jp|gojome\.akita\.jp|hachirogata\.akita\.jp|happou\.akita\.jp|higashinaruse\.akita\.jp|honjo\.akita\.jp|honjyo\.akita\.jp|ikawa\.akita\.jp|kamikoani\.akita\.jp|kamioka\.akita\.jp|katagami\.akita\.jp|kazuno\.akita\.jp|kitaakita\.akita\.jp|kosaka\.akita\.jp|kyowa\.akita\.jp|misato\.akita\.jp|mitane\.akita\.jp|moriyoshi\.akita\.jp|nikaho\.akita\.jp|noshiro\.akita\.jp|odate\.akita\.jp|oga\.akita\.jp|ogata\.akita\.jp|semboku\.akita\.jp|yokote\.akita\.jp|yurihonjo\.akita\.jp|aomori\.aomori\.jp|gonohe\.aomori\.jp|hachinohe\.aomori\.jp|hashikami\.aomori\.jp|hiranai\.aomori\.jp|hirosaki\.aomori\.jp|itayanagi\.aomori\.jp|kuroishi\.aomori\.jp|misawa\.aomori\.jp|mutsu\.aomori\.jp|nakadomari\.aomori\.jp|noheji\.aomori\.jp|oirase\.aomori\.jp|owani\.aomori\.jp|rokunohe\.aomori\.jp|sannohe\.aomori\.jp|shichinohe\.aomori\.jp|shingo\.aomori\.jp|takko\.aomori\.jp|towada\.aomori\.jp|tsugaru\.aomori\.jp|tsuruta\.aomori\.jp|abiko\.chiba\.jp|asahi\.chiba\.jp|chonan\.chiba\.jp|chosei\.chiba\.jp|choshi\.chiba\.jp|chuo\.chiba\.jp|funabashi\.chiba\.jp|futtsu\.chiba\.jp|hanamigawa\.chiba\.jp|ichihara\.chiba\.jp|ichikawa\.chiba\.jp|ichinomiya\.chiba\.jp|inzai\.chiba\.jp|isumi\.chiba\.jp|kamagaya\.chiba\.jp|kamogawa\.chiba\.jp|kashiwa\.chiba\.jp|katori\.chiba\.jp|katsuura\.chiba\.jp|kimitsu\.chiba\.jp|kisarazu\.chiba\.jp|kozaki\.chiba\.jp|kujukuri\.chiba\.jp|kyonan\.chiba\.jp|matsudo\.chiba\.jp|midori\.chiba\.jp|mihama\.chiba\.jp|minamiboso\.chiba\.jp|mobara\.chiba\.jp|mutsuzawa\.chiba\.jp|nagara\.chiba\.jp|nagareyama\.chiba\.jp|narashino\.chiba\.jp|narita\.chiba\.jp|noda\.chiba\.jp|oamishirasato\.chiba\.jp|omigawa\.chiba\.jp|onjuku\.chiba\.jp|otaki\.chiba\.jp|sakae\.chiba\.jp|sakura\.chiba\.jp|shimofusa\.chiba\.jp|shirako\.chiba\.jp|shiroi\.chiba\.jp|shisui\.chiba\.jp|sodegaura\.chiba\.jp|sosa\.chiba\.jp|tako\.chiba\.jp|tateyama\.chiba\.jp|togane\.chiba\.jp|tohnosho\.chiba\.jp|tomisato\.chiba\.jp|urayasu\.chiba\.jp|yachimata\.chiba\.jp|yachiyo\.chiba\.jp|yokaichiba\.chiba\.jp|yokoshibahikari\.chiba\.jp|yotsukaido\.chiba\.jp|ainan\.ehime\.jp|honai\.ehime\.jp|ikata\.ehime\.jp|imabari\.ehime\.jp|iyo\.ehime\.jp|kamijima\.ehime\.jp|kihoku\.ehime\.jp|kumakogen\.ehime\.jp|masaki\.ehime\.jp|matsuno\.ehime\.jp|matsuyama\.ehime\.jp|namikata\.ehime\.jp|niihama\.ehime\.jp|ozu\.ehime\.jp|saijo\.ehime\.jp|seiyo\.ehime\.jp|shikokuchuo\.ehime\.jp|tobe\.ehime\.jp|toon\.ehime\.jp|uchiko\.ehime\.jp|uwajima\.ehime\.jp|yawatahama\.ehime\.jp|echizen\.fukui\.jp|eiheiji\.fukui\.jp|fukui\.fukui\.jp|ikeda\.fukui\.jp|katsuyama\.fukui\.jp|mihama\.fukui\.jp|minamiechizen\.fukui\.jp|obama\.fukui\.jp|ohi\.fukui\.jp|ono\.fukui\.jp|sabae\.fukui\.jp|sakai\.fukui\.jp|takahama\.fukui\.jp|tsuruga\.fukui\.jp|wakasa\.fukui\.jp|ashiya\.fukuoka\.jp|buzen\.fukuoka\.jp|chikugo\.fukuoka\.jp|chikuho\.fukuoka\.jp|chikujo\.fukuoka\.jp|chikushino\.fukuoka\.jp|chikuzen\.fukuoka\.jp|chuo\.fukuoka\.jp|dazaifu\.fukuoka\.jp|fukuchi\.fukuoka\.jp|hakata\.fukuoka\.jp|higashi\.fukuoka\.jp|hirokawa\.fukuoka\.jp|hisayama\.fukuoka\.jp|iizuka\.fukuoka\.jp|inatsuki\.fukuoka\.jp|kaho\.fukuoka\.jp|kasuga\.fukuoka\.jp|kasuya\.fukuoka\.jp|kawara\.fukuoka\.jp|keisen\.fukuoka\.jp|koga\.fukuoka\.jp|kurate\.fukuoka\.jp|kurogi\.fukuoka\.jp|kurume\.fukuoka\.jp|minami\.fukuoka\.jp|miyako\.fukuoka\.jp|miyama\.fukuoka\.jp|miyawaka\.fukuoka\.jp|mizumaki\.fukuoka\.jp|munakata\.fukuoka\.jp|nakagawa\.fukuoka\.jp|nakama\.fukuoka\.jp|nishi\.fukuoka\.jp|nogata\.fukuoka\.jp|ogori\.fukuoka\.jp|okagaki\.fukuoka\.jp|okawa\.fukuoka\.jp|oki\.fukuoka\.jp|omuta\.fukuoka\.jp|onga\.fukuoka\.jp|onojo\.fukuoka\.jp|oto\.fukuoka\.jp|saigawa\.fukuoka\.jp|sasaguri\.fukuoka\.jp|shingu\.fukuoka\.jp|shinyoshitomi\.fukuoka\.jp|shonai\.fukuoka\.jp|soeda\.fukuoka\.jp|sue\.fukuoka\.jp|tachiarai\.fukuoka\.jp|tagawa\.fukuoka\.jp|takata\.fukuoka\.jp|toho\.fukuoka\.jp|toyotsu\.fukuoka\.jp|tsuiki\.fukuoka\.jp|ukiha\.fukuoka\.jp|umi\.fukuoka\.jp|usui\.fukuoka\.jp|yamada\.fukuoka\.jp|yame\.fukuoka\.jp|yanagawa\.fukuoka\.jp|yukuhashi\.fukuoka\.jp|aizubange\.fukushima\.jp|aizumisato\.fukushima\.jp|aizuwakamatsu\.fukushima\.jp|asakawa\.fukushima\.jp|bandai\.fukushima\.jp|date\.fukushima\.jp|fukushima\.fukushima\.jp|furudono\.fukushima\.jp|futaba\.fukushima\.jp|hanawa\.fukushima\.jp|higashi\.fukushima\.jp|hirata\.fukushima\.jp|hirono\.fukushima\.jp|iitate\.fukushima\.jp|inawashiro\.fukushima\.jp|ishikawa\.fukushima\.jp|iwaki\.fukushima\.jp|izumizaki\.fukushima\.jp|kagamiishi\.fukushima\.jp|kaneyama\.fukushima\.jp|kawamata\.fukushima\.jp|kitakata\.fukushima\.jp|kitashiobara\.fukushima\.jp|koori\.fukushima\.jp|koriyama\.fukushima\.jp|kunimi\.fukushima\.jp|miharu\.fukushima\.jp|mishima\.fukushima\.jp|namie\.fukushima\.jp|nango\.fukushima\.jp|nishiaizu\.fukushima\.jp|nishigo\.fukushima\.jp|okuma\.fukushima\.jp|omotego\.fukushima\.jp|ono\.fukushima\.jp|otama\.fukushima\.jp|samegawa\.fukushima\.jp|shimogo\.fukushima\.jp|shirakawa\.fukushima\.jp|showa\.fukushima\.jp|soma\.fukushima\.jp|sukagawa\.fukushima\.jp|taishin\.fukushima\.jp|tamakawa\.fukushima\.jp|tanagura\.fukushima\.jp|tenei\.fukushima\.jp|yabuki\.fukushima\.jp|yamato\.fukushima\.jp|yamatsuri\.fukushima\.jp|yanaizu\.fukushima\.jp|yugawa\.fukushima\.jp|anpachi\.gifu\.jp|ena\.gifu\.jp|gifu\.gifu\.jp|ginan\.gifu\.jp|godo\.gifu\.jp|gujo\.gifu\.jp|hashima\.gifu\.jp|hichiso\.gifu\.jp|hida\.gifu\.jp|higashishirakawa\.gifu\.jp|ibigawa\.gifu\.jp|ikeda\.gifu\.jp|kakamigahara\.gifu\.jp|kani\.gifu\.jp|kasahara\.gifu\.jp|kasamatsu\.gifu\.jp|kawaue\.gifu\.jp|kitagata\.gifu\.jp|mino\.gifu\.jp|minokamo\.gifu\.jp|mitake\.gifu\.jp|mizunami\.gifu\.jp|motosu\.gifu\.jp|nakatsugawa\.gifu\.jp|ogaki\.gifu\.jp|sakahogi\.gifu\.jp|seki\.gifu\.jp|sekigahara\.gifu\.jp|shirakawa\.gifu\.jp|tajimi\.gifu\.jp|takayama\.gifu\.jp|tarui\.gifu\.jp|toki\.gifu\.jp|tomika\.gifu\.jp|wanouchi\.gifu\.jp|yamagata\.gifu\.jp|yaotsu\.gifu\.jp|yoro\.gifu\.jp|annaka\.gunma\.jp|chiyoda\.gunma\.jp|fujioka\.gunma\.jp|higashiagatsuma\.gunma\.jp|isesaki\.gunma\.jp|itakura\.gunma\.jp|kanna\.gunma\.jp|kanra\.gunma\.jp|katashina\.gunma\.jp|kawaba\.gunma\.jp|kiryu\.gunma\.jp|kusatsu\.gunma\.jp|maebashi\.gunma\.jp|meiwa\.gunma\.jp|midori\.gunma\.jp|minakami\.gunma\.jp|naganohara\.gunma\.jp|nakanojo\.gunma\.jp|nanmoku\.gunma\.jp|numata\.gunma\.jp|oizumi\.gunma\.jp|ora\.gunma\.jp|ota\.gunma\.jp|shibukawa\.gunma\.jp|shimonita\.gunma\.jp|shinto\.gunma\.jp|showa\.gunma\.jp|takasaki\.gunma\.jp|takayama\.gunma\.jp|tamamura\.gunma\.jp|tatebayashi\.gunma\.jp|tomioka\.gunma\.jp|tsukiyono\.gunma\.jp|tsumagoi\.gunma\.jp|ueno\.gunma\.jp|yoshioka\.gunma\.jp|asaminami\.hiroshima\.jp|daiwa\.hiroshima\.jp|etajima\.hiroshima\.jp|fuchu\.hiroshima\.jp|fukuyama\.hiroshima\.jp|hatsukaichi\.hiroshima\.jp|higashihiroshima\.hiroshima\.jp|hongo\.hiroshima\.jp|jinsekikogen\.hiroshima\.jp|kaita\.hiroshima\.jp|kui\.hiroshima\.jp|kumano\.hiroshima\.jp|kure\.hiroshima\.jp|mihara\.hiroshima\.jp|miyoshi\.hiroshima\.jp|naka\.hiroshima\.jp|onomichi\.hiroshima\.jp|osakikamijima\.hiroshima\.jp|otake\.hiroshima\.jp|saka\.hiroshima\.jp|sera\.hiroshima\.jp|seranishi\.hiroshima\.jp|shinichi\.hiroshima\.jp|shobara\.hiroshima\.jp|takehara\.hiroshima\.jp|abashiri\.hokkaido\.jp|abira\.hokkaido\.jp|aibetsu\.hokkaido\.jp|akabira\.hokkaido\.jp|akkeshi\.hokkaido\.jp|asahikawa\.hokkaido\.jp|ashibetsu\.hokkaido\.jp|ashoro\.hokkaido\.jp|assabu\.hokkaido\.jp|atsuma\.hokkaido\.jp|bibai\.hokkaido\.jp|biei\.hokkaido\.jp|bifuka\.hokkaido\.jp|bihoro\.hokkaido\.jp|biratori\.hokkaido\.jp|chippubetsu\.hokkaido\.jp|chitose\.hokkaido\.jp|date\.hokkaido\.jp|ebetsu\.hokkaido\.jp|embetsu\.hokkaido\.jp|eniwa\.hokkaido\.jp|erimo\.hokkaido\.jp|esan\.hokkaido\.jp|esashi\.hokkaido\.jp|fukagawa\.hokkaido\.jp|fukushima\.hokkaido\.jp|furano\.hokkaido\.jp|furubira\.hokkaido\.jp|haboro\.hokkaido\.jp|hakodate\.hokkaido\.jp|hamatonbetsu\.hokkaido\.jp|hidaka\.hokkaido\.jp|higashikagura\.hokkaido\.jp|higashikawa\.hokkaido\.jp|hiroo\.hokkaido\.jp|hokuryu\.hokkaido\.jp|hokuto\.hokkaido\.jp|honbetsu\.hokkaido\.jp|horokanai\.hokkaido\.jp|horonobe\.hokkaido\.jp|ikeda\.hokkaido\.jp|imakane\.hokkaido\.jp|ishikari\.hokkaido\.jp|iwamizawa\.hokkaido\.jp|iwanai\.hokkaido\.jp|kamifurano\.hokkaido\.jp|kamikawa\.hokkaido\.jp|kamishihoro\.hokkaido\.jp|kamisunagawa\.hokkaido\.jp|kamoenai\.hokkaido\.jp|kayabe\.hokkaido\.jp|kembuchi\.hokkaido\.jp|kikonai\.hokkaido\.jp|kimobetsu\.hokkaido\.jp|kitahiroshima\.hokkaido\.jp|kitami\.hokkaido\.jp|kiyosato\.hokkaido\.jp|koshimizu\.hokkaido\.jp|kunneppu\.hokkaido\.jp|kuriyama\.hokkaido\.jp|kuromatsunai\.hokkaido\.jp|kushiro\.hokkaido\.jp|kutchan\.hokkaido\.jp|kyowa\.hokkaido\.jp|mashike\.hokkaido\.jp|matsumae\.hokkaido\.jp|mikasa\.hokkaido\.jp|minamifurano\.hokkaido\.jp|mombetsu\.hokkaido\.jp|moseushi\.hokkaido\.jp|mukawa\.hokkaido\.jp|muroran\.hokkaido\.jp|naie\.hokkaido\.jp|nakagawa\.hokkaido\.jp|nakasatsunai\.hokkaido\.jp|nakatombetsu\.hokkaido\.jp|nanae\.hokkaido\.jp|nanporo\.hokkaido\.jp|nayoro\.hokkaido\.jp|nemuro\.hokkaido\.jp|niikappu\.hokkaido\.jp|niki\.hokkaido\.jp|nishiokoppe\.hokkaido\.jp|noboribetsu\.hokkaido\.jp|numata\.hokkaido\.jp|obihiro\.hokkaido\.jp|obira\.hokkaido\.jp|oketo\.hokkaido\.jp|okoppe\.hokkaido\.jp|otaru\.hokkaido\.jp|otobe\.hokkaido\.jp|otofuke\.hokkaido\.jp|otoineppu\.hokkaido\.jp|oumu\.hokkaido\.jp|ozora\.hokkaido\.jp|pippu\.hokkaido\.jp|rankoshi\.hokkaido\.jp|rebun\.hokkaido\.jp|rikubetsu\.hokkaido\.jp|rishiri\.hokkaido\.jp|rishirifuji\.hokkaido\.jp|saroma\.hokkaido\.jp|sarufutsu\.hokkaido\.jp|shakotan\.hokkaido\.jp|shari\.hokkaido\.jp|shibecha\.hokkaido\.jp|shibetsu\.hokkaido\.jp|shikabe\.hokkaido\.jp|shikaoi\.hokkaido\.jp|shimamaki\.hokkaido\.jp|shimizu\.hokkaido\.jp|shimokawa\.hokkaido\.jp|shinshinotsu\.hokkaido\.jp|shintoku\.hokkaido\.jp|shiranuka\.hokkaido\.jp|shiraoi\.hokkaido\.jp|shiriuchi\.hokkaido\.jp|sobetsu\.hokkaido\.jp|sunagawa\.hokkaido\.jp|taiki\.hokkaido\.jp|takasu\.hokkaido\.jp|takikawa\.hokkaido\.jp|takinoue\.hokkaido\.jp|teshikaga\.hokkaido\.jp|tobetsu\.hokkaido\.jp|tohma\.hokkaido\.jp|tomakomai\.hokkaido\.jp|tomari\.hokkaido\.jp|toya\.hokkaido\.jp|toyako\.hokkaido\.jp|toyotomi\.hokkaido\.jp|toyoura\.hokkaido\.jp|tsubetsu\.hokkaido\.jp|tsukigata\.hokkaido\.jp|urakawa\.hokkaido\.jp|urausu\.hokkaido\.jp|uryu\.hokkaido\.jp|utashinai\.hokkaido\.jp|wakkanai\.hokkaido\.jp|wassamu\.hokkaido\.jp|yakumo\.hokkaido\.jp|yoichi\.hokkaido\.jp|aioi\.hyogo\.jp|akashi\.hyogo\.jp|ako\.hyogo\.jp|amagasaki\.hyogo\.jp|aogaki\.hyogo\.jp|asago\.hyogo\.jp|ashiya\.hyogo\.jp|awaji\.hyogo\.jp|fukusaki\.hyogo\.jp|goshiki\.hyogo\.jp|harima\.hyogo\.jp|himeji\.hyogo\.jp|ichikawa\.hyogo\.jp|inagawa\.hyogo\.jp|itami\.hyogo\.jp|kakogawa\.hyogo\.jp|kamigori\.hyogo\.jp|kamikawa\.hyogo\.jp|kasai\.hyogo\.jp|kasuga\.hyogo\.jp|kawanishi\.hyogo\.jp|miki\.hyogo\.jp|minamiawaji\.hyogo\.jp|nishinomiya\.hyogo\.jp|nishiwaki\.hyogo\.jp|ono\.hyogo\.jp|sanda\.hyogo\.jp|sannan\.hyogo\.jp|sasayama\.hyogo\.jp|sayo\.hyogo\.jp|shingu\.hyogo\.jp|shinonsen\.hyogo\.jp|shiso\.hyogo\.jp|sumoto\.hyogo\.jp|taishi\.hyogo\.jp|taka\.hyogo\.jp|takarazuka\.hyogo\.jp|takasago\.hyogo\.jp|takino\.hyogo\.jp|tamba\.hyogo\.jp|tatsuno\.hyogo\.jp|toyooka\.hyogo\.jp|yabu\.hyogo\.jp|yashiro\.hyogo\.jp|yoka\.hyogo\.jp|yokawa\.hyogo\.jp|ami\.ibaraki\.jp|asahi\.ibaraki\.jp|bando\.ibaraki\.jp|chikusei\.ibaraki\.jp|daigo\.ibaraki\.jp|fujishiro\.ibaraki\.jp|hitachi\.ibaraki\.jp|hitachinaka\.ibaraki\.jp|hitachiomiya\.ibaraki\.jp|hitachiota\.ibaraki\.jp|ibaraki\.ibaraki\.jp|ina\.ibaraki\.jp|inashiki\.ibaraki\.jp|itako\.ibaraki\.jp|iwama\.ibaraki\.jp|joso\.ibaraki\.jp|kamisu\.ibaraki\.jp|kasama\.ibaraki\.jp|kashima\.ibaraki\.jp|kasumigaura\.ibaraki\.jp|koga\.ibaraki\.jp|miho\.ibaraki\.jp|mito\.ibaraki\.jp|moriya\.ibaraki\.jp|naka\.ibaraki\.jp|namegata\.ibaraki\.jp|oarai\.ibaraki\.jp|ogawa\.ibaraki\.jp|omitama\.ibaraki\.jp|ryugasaki\.ibaraki\.jp|sakai\.ibaraki\.jp|sakuragawa\.ibaraki\.jp|shimodate\.ibaraki\.jp|shimotsuma\.ibaraki\.jp|shirosato\.ibaraki\.jp|sowa\.ibaraki\.jp|suifu\.ibaraki\.jp|takahagi\.ibaraki\.jp|tamatsukuri\.ibaraki\.jp|tokai\.ibaraki\.jp|tomobe\.ibaraki\.jp|tone\.ibaraki\.jp|toride\.ibaraki\.jp|tsuchiura\.ibaraki\.jp|tsukuba\.ibaraki\.jp|uchihara\.ibaraki\.jp|ushiku\.ibaraki\.jp|yachiyo\.ibaraki\.jp|yamagata\.ibaraki\.jp|yawara\.ibaraki\.jp|yuki\.ibaraki\.jp|anamizu\.ishikawa\.jp|hakui\.ishikawa\.jp|hakusan\.ishikawa\.jp|kaga\.ishikawa\.jp|kahoku\.ishikawa\.jp|kanazawa\.ishikawa\.jp|kawakita\.ishikawa\.jp|komatsu\.ishikawa\.jp|nakanoto\.ishikawa\.jp|nanao\.ishikawa\.jp|nomi\.ishikawa\.jp|nonoichi\.ishikawa\.jp|noto\.ishikawa\.jp|shika\.ishikawa\.jp|suzu\.ishikawa\.jp|tsubata\.ishikawa\.jp|tsurugi\.ishikawa\.jp|uchinada\.ishikawa\.jp|wajima\.ishikawa\.jp|fudai\.iwate\.jp|fujisawa\.iwate\.jp|hanamaki\.iwate\.jp|hiraizumi\.iwate\.jp|hirono\.iwate\.jp|ichinohe\.iwate\.jp|ichinoseki\.iwate\.jp|iwaizumi\.iwate\.jp|iwate\.iwate\.jp|joboji\.iwate\.jp|kamaishi\.iwate\.jp|kanegasaki\.iwate\.jp|karumai\.iwate\.jp|kawai\.iwate\.jp|kitakami\.iwate\.jp|kuji\.iwate\.jp|kunohe\.iwate\.jp|kuzumaki\.iwate\.jp|miyako\.iwate\.jp|mizusawa\.iwate\.jp|morioka\.iwate\.jp|ninohe\.iwate\.jp|noda\.iwate\.jp|ofunato\.iwate\.jp|oshu\.iwate\.jp|otsuchi\.iwate\.jp|rikuzentakata\.iwate\.jp|shiwa\.iwate\.jp|shizukuishi\.iwate\.jp|sumita\.iwate\.jp|tanohata\.iwate\.jp|tono\.iwate\.jp|yahaba\.iwate\.jp|yamada\.iwate\.jp|ayagawa\.kagawa\.jp|higashikagawa\.kagawa\.jp|kanonji\.kagawa\.jp|kotohira\.kagawa\.jp|manno\.kagawa\.jp|marugame\.kagawa\.jp|mitoyo\.kagawa\.jp|naoshima\.kagawa\.jp|sanuki\.kagawa\.jp|tadotsu\.kagawa\.jp|takamatsu\.kagawa\.jp|tonosho\.kagawa\.jp|uchinomi\.kagawa\.jp|utazu\.kagawa\.jp|zentsuji\.kagawa\.jp|akune\.kagoshima\.jp|amami\.kagoshima\.jp|hioki\.kagoshima\.jp|isa\.kagoshima\.jp|isen\.kagoshima\.jp|izumi\.kagoshima\.jp|kagoshima\.kagoshima\.jp|kanoya\.kagoshima\.jp|kawanabe\.kagoshima\.jp|kinko\.kagoshima\.jp|kouyama\.kagoshima\.jp|makurazaki\.kagoshima\.jp|matsumoto\.kagoshima\.jp|minamitane\.kagoshima\.jp|nakatane\.kagoshima\.jp|nishinoomote\.kagoshima\.jp|satsumasendai\.kagoshima\.jp|soo\.kagoshima\.jp|tarumizu\.kagoshima\.jp|yusui\.kagoshima\.jp|aikawa\.kanagawa\.jp|atsugi\.kanagawa\.jp|ayase\.kanagawa\.jp|chigasaki\.kanagawa\.jp|ebina\.kanagawa\.jp|fujisawa\.kanagawa\.jp|hadano\.kanagawa\.jp|hakone\.kanagawa\.jp|hiratsuka\.kanagawa\.jp|isehara\.kanagawa\.jp|kaisei\.kanagawa\.jp|kamakura\.kanagawa\.jp|kiyokawa\.kanagawa\.jp|matsuda\.kanagawa\.jp|minamiashigara\.kanagawa\.jp|miura\.kanagawa\.jp|nakai\.kanagawa\.jp|ninomiya\.kanagawa\.jp|odawara\.kanagawa\.jp|oi\.kanagawa\.jp|oiso\.kanagawa\.jp|sagamihara\.kanagawa\.jp|samukawa\.kanagawa\.jp|tsukui\.kanagawa\.jp|yamakita\.kanagawa\.jp|yamato\.kanagawa\.jp|yokosuka\.kanagawa\.jp|yugawara\.kanagawa\.jp|zama\.kanagawa\.jp|zushi\.kanagawa\.jp|aki\.kochi\.jp|geisei\.kochi\.jp|hidaka\.kochi\.jp|higashitsuno\.kochi\.jp|ino\.kochi\.jp|kagami\.kochi\.jp|kami\.kochi\.jp|kitagawa\.kochi\.jp|kochi\.kochi\.jp|mihara\.kochi\.jp|motoyama\.kochi\.jp|muroto\.kochi\.jp|nahari\.kochi\.jp|nakamura\.kochi\.jp|nankoku\.kochi\.jp|nishitosa\.kochi\.jp|niyodogawa\.kochi\.jp|ochi\.kochi\.jp|okawa\.kochi\.jp|otoyo\.kochi\.jp|otsuki\.kochi\.jp|sakawa\.kochi\.jp|sukumo\.kochi\.jp|susaki\.kochi\.jp|tosa\.kochi\.jp|tosashimizu\.kochi\.jp|toyo\.kochi\.jp|tsuno\.kochi\.jp|umaji\.kochi\.jp|yasuda\.kochi\.jp|yusuhara\.kochi\.jp|amakusa\.kumamoto\.jp|arao\.kumamoto\.jp|aso\.kumamoto\.jp|choyo\.kumamoto\.jp|gyokuto\.kumamoto\.jp|kamiamakusa\.kumamoto\.jp|kikuchi\.kumamoto\.jp|kumamoto\.kumamoto\.jp|mashiki\.kumamoto\.jp|mifune\.kumamoto\.jp|minamata\.kumamoto\.jp|minamioguni\.kumamoto\.jp|nagasu\.kumamoto\.jp|nishihara\.kumamoto\.jp|oguni\.kumamoto\.jp|ozu\.kumamoto\.jp|sumoto\.kumamoto\.jp|takamori\.kumamoto\.jp|uki\.kumamoto\.jp|uto\.kumamoto\.jp|yamaga\.kumamoto\.jp|yamato\.kumamoto\.jp|yatsushiro\.kumamoto\.jp|ayabe\.kyoto\.jp|fukuchiyama\.kyoto\.jp|higashiyama\.kyoto\.jp|ide\.kyoto\.jp|ine\.kyoto\.jp|joyo\.kyoto\.jp|kameoka\.kyoto\.jp|kamo\.kyoto\.jp|kita\.kyoto\.jp|kizu\.kyoto\.jp|kumiyama\.kyoto\.jp|kyotamba\.kyoto\.jp|kyotanabe\.kyoto\.jp|kyotango\.kyoto\.jp|maizuru\.kyoto\.jp|minami\.kyoto\.jp|minamiyamashiro\.kyoto\.jp|miyazu\.kyoto\.jp|muko\.kyoto\.jp|nagaokakyo\.kyoto\.jp|nakagyo\.kyoto\.jp|nantan\.kyoto\.jp|oyamazaki\.kyoto\.jp|sakyo\.kyoto\.jp|seika\.kyoto\.jp|tanabe\.kyoto\.jp|uji\.kyoto\.jp|ujitawara\.kyoto\.jp|wazuka\.kyoto\.jp|yamashina\.kyoto\.jp|yawata\.kyoto\.jp|asahi\.mie\.jp|inabe\.mie\.jp|ise\.mie\.jp|kameyama\.mie\.jp|kawagoe\.mie\.jp|kiho\.mie\.jp|kisosaki\.mie\.jp|kiwa\.mie\.jp|komono\.mie\.jp|kumano\.mie\.jp|kuwana\.mie\.jp|matsusaka\.mie\.jp|meiwa\.mie\.jp|mihama\.mie\.jp|minamiise\.mie\.jp|misugi\.mie\.jp|miyama\.mie\.jp|nabari\.mie\.jp|shima\.mie\.jp|suzuka\.mie\.jp|tado\.mie\.jp|taiki\.mie\.jp|taki\.mie\.jp|tamaki\.mie\.jp|toba\.mie\.jp|tsu\.mie\.jp|udono\.mie\.jp|ureshino\.mie\.jp|watarai\.mie\.jp|yokkaichi\.mie\.jp|furukawa\.miyagi\.jp|higashimatsushima\.miyagi\.jp|ishinomaki\.miyagi\.jp|iwanuma\.miyagi\.jp|kakuda\.miyagi\.jp|kami\.miyagi\.jp|kawasaki\.miyagi\.jp|marumori\.miyagi\.jp|matsushima\.miyagi\.jp|minamisanriku\.miyagi\.jp|misato\.miyagi\.jp|murata\.miyagi\.jp|natori\.miyagi\.jp|ogawara\.miyagi\.jp|ohira\.miyagi\.jp|onagawa\.miyagi\.jp|osaki\.miyagi\.jp|rifu\.miyagi\.jp|semine\.miyagi\.jp|shibata\.miyagi\.jp|shichikashuku\.miyagi\.jp|shikama\.miyagi\.jp|shiogama\.miyagi\.jp|shiroishi\.miyagi\.jp|tagajo\.miyagi\.jp|taiwa\.miyagi\.jp|tome\.miyagi\.jp|tomiya\.miyagi\.jp|wakuya\.miyagi\.jp|watari\.miyagi\.jp|yamamoto\.miyagi\.jp|zao\.miyagi\.jp|aya\.miyazaki\.jp|ebino\.miyazaki\.jp|gokase\.miyazaki\.jp|hyuga\.miyazaki\.jp|kadogawa\.miyazaki\.jp|kawaminami\.miyazaki\.jp|kijo\.miyazaki\.jp|kitagawa\.miyazaki\.jp|kitakata\.miyazaki\.jp|kitaura\.miyazaki\.jp|kobayashi\.miyazaki\.jp|kunitomi\.miyazaki\.jp|kushima\.miyazaki\.jp|mimata\.miyazaki\.jp|miyakonojo\.miyazaki\.jp|miyazaki\.miyazaki\.jp|morotsuka\.miyazaki\.jp|nichinan\.miyazaki\.jp|nishimera\.miyazaki\.jp|nobeoka\.miyazaki\.jp|saito\.miyazaki\.jp|shiiba\.miyazaki\.jp|shintomi\.miyazaki\.jp|takaharu\.miyazaki\.jp|takanabe\.miyazaki\.jp|takazaki\.miyazaki\.jp|tsuno\.miyazaki\.jp|achi\.nagano\.jp|agematsu\.nagano\.jp|anan\.nagano\.jp|aoki\.nagano\.jp|asahi\.nagano\.jp|azumino\.nagano\.jp|chikuhoku\.nagano\.jp|chikuma\.nagano\.jp|chino\.nagano\.jp|fujimi\.nagano\.jp|hakuba\.nagano\.jp|hara\.nagano\.jp|hiraya\.nagano\.jp|iida\.nagano\.jp|iijima\.nagano\.jp|iiyama\.nagano\.jp|iizuna\.nagano\.jp|ikeda\.nagano\.jp|ikusaka\.nagano\.jp|ina\.nagano\.jp|karuizawa\.nagano\.jp|kawakami\.nagano\.jp|kiso\.nagano\.jp|kisofukushima\.nagano\.jp|kitaaiki\.nagano\.jp|komagane\.nagano\.jp|komoro\.nagano\.jp|matsukawa\.nagano\.jp|matsumoto\.nagano\.jp|miasa\.nagano\.jp|minamiaiki\.nagano\.jp|minamimaki\.nagano\.jp|minamiminowa\.nagano\.jp|minowa\.nagano\.jp|miyada\.nagano\.jp|miyota\.nagano\.jp|mochizuki\.nagano\.jp|nagano\.nagano\.jp|nagawa\.nagano\.jp|nagiso\.nagano\.jp|nakagawa\.nagano\.jp|nakano\.nagano\.jp|nozawaonsen\.nagano\.jp|obuse\.nagano\.jp|ogawa\.nagano\.jp|okaya\.nagano\.jp|omachi\.nagano\.jp|omi\.nagano\.jp|ookuwa\.nagano\.jp|ooshika\.nagano\.jp|otaki\.nagano\.jp|otari\.nagano\.jp|sakae\.nagano\.jp|sakaki\.nagano\.jp|saku\.nagano\.jp|sakuho\.nagano\.jp|shimosuwa\.nagano\.jp|shinanomachi\.nagano\.jp|shiojiri\.nagano\.jp|suwa\.nagano\.jp|suzaka\.nagano\.jp|takagi\.nagano\.jp|takamori\.nagano\.jp|takayama\.nagano\.jp|tateshina\.nagano\.jp|tatsuno\.nagano\.jp|togakushi\.nagano\.jp|togura\.nagano\.jp|tomi\.nagano\.jp|ueda\.nagano\.jp|wada\.nagano\.jp|yamagata\.nagano\.jp|yamanouchi\.nagano\.jp|yasaka\.nagano\.jp|yasuoka\.nagano\.jp|chijiwa\.nagasaki\.jp|futsu\.nagasaki\.jp|goto\.nagasaki\.jp|hasami\.nagasaki\.jp|hirado\.nagasaki\.jp|iki\.nagasaki\.jp|isahaya\.nagasaki\.jp|kawatana\.nagasaki\.jp|kuchinotsu\.nagasaki\.jp|matsuura\.nagasaki\.jp|nagasaki\.nagasaki\.jp|obama\.nagasaki\.jp|omura\.nagasaki\.jp|oseto\.nagasaki\.jp|saikai\.nagasaki\.jp|sasebo\.nagasaki\.jp|seihi\.nagasaki\.jp|shimabara\.nagasaki\.jp|shinkamigoto\.nagasaki\.jp|togitsu\.nagasaki\.jp|tsushima\.nagasaki\.jp|unzen\.nagasaki\.jp|ando\.nara\.jp|gose\.nara\.jp|heguri\.nara\.jp|higashiyoshino\.nara\.jp|ikaruga\.nara\.jp|ikoma\.nara\.jp|kamikitayama\.nara\.jp|kanmaki\.nara\.jp|kashiba\.nara\.jp|kashihara\.nara\.jp|katsuragi\.nara\.jp|kawai\.nara\.jp|kawakami\.nara\.jp|kawanishi\.nara\.jp|koryo\.nara\.jp|kurotaki\.nara\.jp|mitsue\.nara\.jp|miyake\.nara\.jp|nara\.nara\.jp|nosegawa\.nara\.jp|oji\.nara\.jp|ouda\.nara\.jp|oyodo\.nara\.jp|sakurai\.nara\.jp|sango\.nara\.jp|shimoichi\.nara\.jp|shimokitayama\.nara\.jp|shinjo\.nara\.jp|soni\.nara\.jp|takatori\.nara\.jp|tawaramoto\.nara\.jp|tenkawa\.nara\.jp|tenri\.nara\.jp|uda\.nara\.jp|yamatokoriyama\.nara\.jp|yamatotakada\.nara\.jp|yamazoe\.nara\.jp|yoshino\.nara\.jp|aga\.niigata\.jp|agano\.niigata\.jp|gosen\.niigata\.jp|itoigawa\.niigata\.jp|izumozaki\.niigata\.jp|joetsu\.niigata\.jp|kamo\.niigata\.jp|kariwa\.niigata\.jp|kashiwazaki\.niigata\.jp|minamiuonuma\.niigata\.jp|mitsuke\.niigata\.jp|muika\.niigata\.jp|murakami\.niigata\.jp|myoko\.niigata\.jp|nagaoka\.niigata\.jp|niigata\.niigata\.jp|ojiya\.niigata\.jp|omi\.niigata\.jp|sado\.niigata\.jp|sanjo\.niigata\.jp|seiro\.niigata\.jp|seirou\.niigata\.jp|sekikawa\.niigata\.jp|shibata\.niigata\.jp|tagami\.niigata\.jp|tainai\.niigata\.jp|tochio\.niigata\.jp|tokamachi\.niigata\.jp|tsubame\.niigata\.jp|tsunan\.niigata\.jp|uonuma\.niigata\.jp|yahiko\.niigata\.jp|yoita\.niigata\.jp|yuzawa\.niigata\.jp|beppu\.oita\.jp|bungoono\.oita\.jp|bungotakada\.oita\.jp|hasama\.oita\.jp|hiji\.oita\.jp|himeshima\.oita\.jp|hita\.oita\.jp|kamitsue\.oita\.jp|kokonoe\.oita\.jp|kuju\.oita\.jp|kunisaki\.oita\.jp|kusu\.oita\.jp|oita\.oita\.jp|saiki\.oita\.jp|taketa\.oita\.jp|tsukumi\.oita\.jp|usa\.oita\.jp|usuki\.oita\.jp|yufu\.oita\.jp|akaiwa\.okayama\.jp|asakuchi\.okayama\.jp|bizen\.okayama\.jp|hayashima\.okayama\.jp|ibara\.okayama\.jp|kagamino\.okayama\.jp|kasaoka\.okayama\.jp|kibichuo\.okayama\.jp|kumenan\.okayama\.jp|kurashiki\.okayama\.jp|maniwa\.okayama\.jp|misaki\.okayama\.jp|nagi\.okayama\.jp|niimi\.okayama\.jp|nishiawakura\.okayama\.jp|okayama\.okayama\.jp|satosho\.okayama\.jp|setouchi\.okayama\.jp|shinjo\.okayama\.jp|shoo\.okayama\.jp|soja\.okayama\.jp|takahashi\.okayama\.jp|tamano\.okayama\.jp|tsuyama\.okayama\.jp|wake\.okayama\.jp|yakage\.okayama\.jp|aguni\.okinawa\.jp|ginowan\.okinawa\.jp|ginoza\.okinawa\.jp|gushikami\.okinawa\.jp|haebaru\.okinawa\.jp|higashi\.okinawa\.jp|hirara\.okinawa\.jp|iheya\.okinawa\.jp|ishigaki\.okinawa\.jp|ishikawa\.okinawa\.jp|itoman\.okinawa\.jp|izena\.okinawa\.jp|kadena\.okinawa\.jp|kin\.okinawa\.jp|kitadaito\.okinawa\.jp|kitanakagusuku\.okinawa\.jp|kumejima\.okinawa\.jp|kunigami\.okinawa\.jp|minamidaito\.okinawa\.jp|motobu\.okinawa\.jp|nago\.okinawa\.jp|naha\.okinawa\.jp|nakagusuku\.okinawa\.jp|nakijin\.okinawa\.jp|nanjo\.okinawa\.jp|nishihara\.okinawa\.jp|ogimi\.okinawa\.jp|okinawa\.okinawa\.jp|onna\.okinawa\.jp|shimoji\.okinawa\.jp|taketomi\.okinawa\.jp|tarama\.okinawa\.jp|tokashiki\.okinawa\.jp|tomigusuku\.okinawa\.jp|tonaki\.okinawa\.jp|urasoe\.okinawa\.jp|uruma\.okinawa\.jp|yaese\.okinawa\.jp|yomitan\.okinawa\.jp|yonabaru\.okinawa\.jp|yonaguni\.okinawa\.jp|zamami\.okinawa\.jp|abeno\.osaka\.jp|chihayaakasaka\.osaka\.jp|chuo\.osaka\.jp|daito\.osaka\.jp|fujiidera\.osaka\.jp|habikino\.osaka\.jp|hannan\.osaka\.jp|higashiosaka\.osaka\.jp|higashisumiyoshi\.osaka\.jp|higashiyodogawa\.osaka\.jp|hirakata\.osaka\.jp|ibaraki\.osaka\.jp|ikeda\.osaka\.jp|izumi\.osaka\.jp|izumiotsu\.osaka\.jp|izumisano\.osaka\.jp|kadoma\.osaka\.jp|kaizuka\.osaka\.jp|kanan\.osaka\.jp|kashiwara\.osaka\.jp|katano\.osaka\.jp|kawachinagano\.osaka\.jp|kishiwada\.osaka\.jp|kita\.osaka\.jp|kumatori\.osaka\.jp|matsubara\.osaka\.jp|minato\.osaka\.jp|minoh\.osaka\.jp|misaki\.osaka\.jp|moriguchi\.osaka\.jp|neyagawa\.osaka\.jp|nishi\.osaka\.jp|nose\.osaka\.jp|osakasayama\.osaka\.jp|sakai\.osaka\.jp|sayama\.osaka\.jp|sennan\.osaka\.jp|settsu\.osaka\.jp|shijonawate\.osaka\.jp|shimamoto\.osaka\.jp|suita\.osaka\.jp|tadaoka\.osaka\.jp|taishi\.osaka\.jp|tajiri\.osaka\.jp|takaishi\.osaka\.jp|takatsuki\.osaka\.jp|tondabayashi\.osaka\.jp|toyonaka\.osaka\.jp|toyono\.osaka\.jp|yao\.osaka\.jp|ariake\.saga\.jp|arita\.saga\.jp|fukudomi\.saga\.jp|genkai\.saga\.jp|hamatama\.saga\.jp|hizen\.saga\.jp|imari\.saga\.jp|kamimine\.saga\.jp|kanzaki\.saga\.jp|karatsu\.saga\.jp|kashima\.saga\.jp|kitagata\.saga\.jp|kitahata\.saga\.jp|kiyama\.saga\.jp|kouhoku\.saga\.jp|kyuragi\.saga\.jp|nishiarita\.saga\.jp|ogi\.saga\.jp|omachi\.saga\.jp|ouchi\.saga\.jp|saga\.saga\.jp|shiroishi\.saga\.jp|taku\.saga\.jp|tara\.saga\.jp|tosu\.saga\.jp|yoshinogari\.saga\.jp|arakawa\.saitama\.jp|asaka\.saitama\.jp|chichibu\.saitama\.jp|fujimi\.saitama\.jp|fujimino\.saitama\.jp|fukaya\.saitama\.jp|hanno\.saitama\.jp|hanyu\.saitama\.jp|hasuda\.saitama\.jp|hatogaya\.saitama\.jp|hatoyama\.saitama\.jp|hidaka\.saitama\.jp|higashichichibu\.saitama\.jp|higashimatsuyama\.saitama\.jp|honjo\.saitama\.jp|ina\.saitama\.jp|iruma\.saitama\.jp|iwatsuki\.saitama\.jp|kamiizumi\.saitama\.jp|kamikawa\.saitama\.jp|kamisato\.saitama\.jp|kasukabe\.saitama\.jp|kawagoe\.saitama\.jp|kawaguchi\.saitama\.jp|kawajima\.saitama\.jp|kazo\.saitama\.jp|kitamoto\.saitama\.jp|koshigaya\.saitama\.jp|kounosu\.saitama\.jp|kuki\.saitama\.jp|kumagaya\.saitama\.jp|matsubushi\.saitama\.jp|minano\.saitama\.jp|misato\.saitama\.jp|miyashiro\.saitama\.jp|miyoshi\.saitama\.jp|moroyama\.saitama\.jp|nagatoro\.saitama\.jp|namegawa\.saitama\.jp|niiza\.saitama\.jp|ogano\.saitama\.jp|ogawa\.saitama\.jp|ogose\.saitama\.jp|okegawa\.saitama\.jp|omiya\.saitama\.jp|otaki\.saitama\.jp|ranzan\.saitama\.jp|ryokami\.saitama\.jp|saitama\.saitama\.jp|sakado\.saitama\.jp|satte\.saitama\.jp|sayama\.saitama\.jp|shiki\.saitama\.jp|shiraoka\.saitama\.jp|soka\.saitama\.jp|sugito\.saitama\.jp|toda\.saitama\.jp|tokigawa\.saitama\.jp|tokorozawa\.saitama\.jp|tsurugashima\.saitama\.jp|urawa\.saitama\.jp|warabi\.saitama\.jp|yashio\.saitama\.jp|yokoze\.saitama\.jp|yono\.saitama\.jp|yorii\.saitama\.jp|yoshida\.saitama\.jp|yoshikawa\.saitama\.jp|yoshimi\.saitama\.jp|aisho\.shiga\.jp|gamo\.shiga\.jp|higashiomi\.shiga\.jp|hikone\.shiga\.jp|koka\.shiga\.jp|konan\.shiga\.jp|kosei\.shiga\.jp|koto\.shiga\.jp|kusatsu\.shiga\.jp|maibara\.shiga\.jp|moriyama\.shiga\.jp|nagahama\.shiga\.jp|nishiazai\.shiga\.jp|notogawa\.shiga\.jp|omihachiman\.shiga\.jp|otsu\.shiga\.jp|ritto\.shiga\.jp|ryuoh\.shiga\.jp|takashima\.shiga\.jp|takatsuki\.shiga\.jp|torahime\.shiga\.jp|toyosato\.shiga\.jp|yasu\.shiga\.jp|akagi\.shimane\.jp|ama\.shimane\.jp|gotsu\.shimane\.jp|hamada\.shimane\.jp|higashiizumo\.shimane\.jp|hikawa\.shimane\.jp|hikimi\.shimane\.jp|izumo\.shimane\.jp|kakinoki\.shimane\.jp|masuda\.shimane\.jp|matsue\.shimane\.jp|misato\.shimane\.jp|nishinoshima\.shimane\.jp|ohda\.shimane\.jp|okinoshima\.shimane\.jp|okuizumo\.shimane\.jp|shimane\.shimane\.jp|tamayu\.shimane\.jp|tsuwano\.shimane\.jp|unnan\.shimane\.jp|yakumo\.shimane\.jp|yasugi\.shimane\.jp|yatsuka\.shimane\.jp|arai\.shizuoka\.jp|atami\.shizuoka\.jp|fuji\.shizuoka\.jp|fujieda\.shizuoka\.jp|fujikawa\.shizuoka\.jp|fujinomiya\.shizuoka\.jp|fukuroi\.shizuoka\.jp|gotemba\.shizuoka\.jp|haibara\.shizuoka\.jp|hamamatsu\.shizuoka\.jp|higashiizu\.shizuoka\.jp|ito\.shizuoka\.jp|iwata\.shizuoka\.jp|izu\.shizuoka\.jp|izunokuni\.shizuoka\.jp|kakegawa\.shizuoka\.jp|kannami\.shizuoka\.jp|kawanehon\.shizuoka\.jp|kawazu\.shizuoka\.jp|kikugawa\.shizuoka\.jp|kosai\.shizuoka\.jp|makinohara\.shizuoka\.jp|matsuzaki\.shizuoka\.jp|minamiizu\.shizuoka\.jp|mishima\.shizuoka\.jp|morimachi\.shizuoka\.jp|nishiizu\.shizuoka\.jp|numazu\.shizuoka\.jp|omaezaki\.shizuoka\.jp|shimada\.shizuoka\.jp|shimizu\.shizuoka\.jp|shimoda\.shizuoka\.jp|shizuoka\.shizuoka\.jp|susono\.shizuoka\.jp|yaizu\.shizuoka\.jp|yoshida\.shizuoka\.jp|ashikaga\.tochigi\.jp|bato\.tochigi\.jp|haga\.tochigi\.jp|ichikai\.tochigi\.jp|iwafune\.tochigi\.jp|kaminokawa\.tochigi\.jp|kanuma\.tochigi\.jp|karasuyama\.tochigi\.jp|kuroiso\.tochigi\.jp|mashiko\.tochigi\.jp|mibu\.tochigi\.jp|moka\.tochigi\.jp|motegi\.tochigi\.jp|nasu\.tochigi\.jp|nasushiobara\.tochigi\.jp|nikko\.tochigi\.jp|nishikata\.tochigi\.jp|nogi\.tochigi\.jp|ohira\.tochigi\.jp|ohtawara\.tochigi\.jp|oyama\.tochigi\.jp|sakura\.tochigi\.jp|sano\.tochigi\.jp|shimotsuke\.tochigi\.jp|shioya\.tochigi\.jp|takanezawa\.tochigi\.jp|tochigi\.tochigi\.jp|tsuga\.tochigi\.jp|ujiie\.tochigi\.jp|utsunomiya\.tochigi\.jp|yaita\.tochigi\.jp|aizumi\.tokushima\.jp|anan\.tokushima\.jp|ichiba\.tokushima\.jp|itano\.tokushima\.jp|kainan\.tokushima\.jp|komatsushima\.tokushima\.jp|matsushige\.tokushima\.jp|mima\.tokushima\.jp|minami\.tokushima\.jp|miyoshi\.tokushima\.jp|mugi\.tokushima\.jp|nakagawa\.tokushima\.jp|naruto\.tokushima\.jp|sanagochi\.tokushima\.jp|shishikui\.tokushima\.jp|tokushima\.tokushima\.jp|wajiki\.tokushima\.jp|adachi\.tokyo\.jp|akiruno\.tokyo\.jp|akishima\.tokyo\.jp|aogashima\.tokyo\.jp|arakawa\.tokyo\.jp|bunkyo\.tokyo\.jp|chiyoda\.tokyo\.jp|chofu\.tokyo\.jp|chuo\.tokyo\.jp|edogawa\.tokyo\.jp|fuchu\.tokyo\.jp|fussa\.tokyo\.jp|hachijo\.tokyo\.jp|hachioji\.tokyo\.jp|hamura\.tokyo\.jp|higashikurume\.tokyo\.jp|higashimurayama\.tokyo\.jp|higashiyamato\.tokyo\.jp|hino\.tokyo\.jp|hinode\.tokyo\.jp|hinohara\.tokyo\.jp|inagi\.tokyo\.jp|itabashi\.tokyo\.jp|katsushika\.tokyo\.jp|kita\.tokyo\.jp|kiyose\.tokyo\.jp|kodaira\.tokyo\.jp|koganei\.tokyo\.jp|kokubunji\.tokyo\.jp|komae\.tokyo\.jp|koto\.tokyo\.jp|kouzushima\.tokyo\.jp|kunitachi\.tokyo\.jp|machida\.tokyo\.jp|meguro\.tokyo\.jp|minato\.tokyo\.jp|mitaka\.tokyo\.jp|mizuho\.tokyo\.jp|musashimurayama\.tokyo\.jp|musashino\.tokyo\.jp|nakano\.tokyo\.jp|nerima\.tokyo\.jp|ogasawara\.tokyo\.jp|okutama\.tokyo\.jp|ome\.tokyo\.jp|oshima\.tokyo\.jp|ota\.tokyo\.jp|setagaya\.tokyo\.jp|shibuya\.tokyo\.jp|shinagawa\.tokyo\.jp|shinjuku\.tokyo\.jp|suginami\.tokyo\.jp|sumida\.tokyo\.jp|tachikawa\.tokyo\.jp|taito\.tokyo\.jp|tama\.tokyo\.jp|toshima\.tokyo\.jp|chizu\.tottori\.jp|hino\.tottori\.jp|kawahara\.tottori\.jp|koge\.tottori\.jp|kotoura\.tottori\.jp|misasa\.tottori\.jp|nanbu\.tottori\.jp|nichinan\.tottori\.jp|sakaiminato\.tottori\.jp|tottori\.tottori\.jp|wakasa\.tottori\.jp|yazu\.tottori\.jp|yonago\.tottori\.jp|asahi\.toyama\.jp|fuchu\.toyama\.jp|fukumitsu\.toyama\.jp|funahashi\.toyama\.jp|himi\.toyama\.jp|imizu\.toyama\.jp|inami\.toyama\.jp|johana\.toyama\.jp|kamiichi\.toyama\.jp|kurobe\.toyama\.jp|nakaniikawa\.toyama\.jp|namerikawa\.toyama\.jp|nanto\.toyama\.jp|nyuzen\.toyama\.jp|oyabe\.toyama\.jp|taira\.toyama\.jp|takaoka\.toyama\.jp|tateyama\.toyama\.jp|toga\.toyama\.jp|tonami\.toyama\.jp|toyama\.toyama\.jp|unazuki\.toyama\.jp|uozu\.toyama\.jp|yamada\.toyama\.jp|arida\.wakayama\.jp|aridagawa\.wakayama\.jp|gobo\.wakayama\.jp|hashimoto\.wakayama\.jp|hidaka\.wakayama\.jp|hirogawa\.wakayama\.jp|inami\.wakayama\.jp|iwade\.wakayama\.jp|kainan\.wakayama\.jp|kamitonda\.wakayama\.jp|katsuragi\.wakayama\.jp|kimino\.wakayama\.jp|kinokawa\.wakayama\.jp|kitayama\.wakayama\.jp|koya\.wakayama\.jp|koza\.wakayama\.jp|kozagawa\.wakayama\.jp|kudoyama\.wakayama\.jp|kushimoto\.wakayama\.jp|mihama\.wakayama\.jp|misato\.wakayama\.jp|nachikatsuura\.wakayama\.jp|shingu\.wakayama\.jp|shirahama\.wakayama\.jp|taiji\.wakayama\.jp|tanabe\.wakayama\.jp|wakayama\.wakayama\.jp|yuasa\.wakayama\.jp|yura\.wakayama\.jp|asahi\.yamagata\.jp|funagata\.yamagata\.jp|higashine\.yamagata\.jp|iide\.yamagata\.jp|kahoku\.yamagata\.jp|kaminoyama\.yamagata\.jp|kaneyama\.yamagata\.jp|kawanishi\.yamagata\.jp|mamurogawa\.yamagata\.jp|mikawa\.yamagata\.jp|murayama\.yamagata\.jp|nagai\.yamagata\.jp|nakayama\.yamagata\.jp|nanyo\.yamagata\.jp|nishikawa\.yamagata\.jp|obanazawa\.yamagata\.jp|oe\.yamagata\.jp|oguni\.yamagata\.jp|ohkura\.yamagata\.jp|oishida\.yamagata\.jp|sagae\.yamagata\.jp|sakata\.yamagata\.jp|sakegawa\.yamagata\.jp|shinjo\.yamagata\.jp|shirataka\.yamagata\.jp|shonai\.yamagata\.jp|takahata\.yamagata\.jp|tendo\.yamagata\.jp|tozawa\.yamagata\.jp|tsuruoka\.yamagata\.jp|yamagata\.yamagata\.jp|yamanobe\.yamagata\.jp|yonezawa\.yamagata\.jp|yuza\.yamagata\.jp|abu\.yamaguchi\.jp|hagi\.yamaguchi\.jp|hikari\.yamaguchi\.jp|hofu\.yamaguchi\.jp|iwakuni\.yamaguchi\.jp|kudamatsu\.yamaguchi\.jp|mitou\.yamaguchi\.jp|nagato\.yamaguchi\.jp|oshima\.yamaguchi\.jp|shimonoseki\.yamaguchi\.jp|shunan\.yamaguchi\.jp|tabuse\.yamaguchi\.jp|tokuyama\.yamaguchi\.jp|toyota\.yamaguchi\.jp|ube\.yamaguchi\.jp|yuu\.yamaguchi\.jp|chuo\.yamanashi\.jp|doshi\.yamanashi\.jp|fuefuki\.yamanashi\.jp|fujikawa\.yamanashi\.jp|fujikawaguchiko\.yamanashi\.jp|fujiyoshida\.yamanashi\.jp|hayakawa\.yamanashi\.jp|hokuto\.yamanashi\.jp|ichikawamisato\.yamanashi\.jp|kai\.yamanashi\.jp|kofu\.yamanashi\.jp|koshu\.yamanashi\.jp|kosuge\.yamanashi\.jp|minami-alps\.yamanashi\.jp|minobu\.yamanashi\.jp|nakamichi\.yamanashi\.jp|nanbu\.yamanashi\.jp|narusawa\.yamanashi\.jp|nirasaki\.yamanashi\.jp|nishikatsura\.yamanashi\.jp|oshino\.yamanashi\.jp|otsuki\.yamanashi\.jp|showa\.yamanashi\.jp|tabayama\.yamanashi\.jp|tsuru\.yamanashi\.jp|uenohara\.yamanashi\.jp|yamanakako\.yamanashi\.jp|yamanashi\.yamanashi\.jp|[^.]+\.ke|kg|org\.kg|net\.kg|com\.kg|edu\.kg|gov\.kg|mil\.kg|[^.]+\.kh|ki|edu\.ki|biz\.ki|net\.ki|org\.ki|gov\.ki|info\.ki|com\.ki|km|org\.km|nom\.km|gov\.km|prd\.km|tm\.km|edu\.km|mil\.km|ass\.km|com\.km|coop\.km|asso\.km|presse\.km|medecin\.km|notaires\.km|pharmaciens\.km|veterinaire\.km|gouv\.km|kn|net\.kn|org\.kn|edu\.kn|gov\.kn|kp|com\.kp|edu\.kp|gov\.kp|org\.kp|rep\.kp|tra\.kp|kr|ac\.kr|co\.kr|es\.kr|go\.kr|hs\.kr|kg\.kr|mil\.kr|ms\.kr|ne\.kr|or\.kr|pe\.kr|re\.kr|sc\.kr|busan\.kr|chungbuk\.kr|chungnam\.kr|daegu\.kr|daejeon\.kr|gangwon\.kr|gwangju\.kr|gyeongbuk\.kr|gyeonggi\.kr|gyeongnam\.kr|incheon\.kr|jeju\.kr|jeonbuk\.kr|jeonnam\.kr|seoul\.kr|ulsan\.kr|[^.]+\.kw|ky|edu\.ky|gov\.ky|com\.ky|org\.ky|net\.ky|kz|org\.kz|edu\.kz|net\.kz|gov\.kz|mil\.kz|com\.kz|la|int\.la|net\.la|info\.la|edu\.la|gov\.la|per\.la|com\.la|org\.la|lb|com\.lb|edu\.lb|gov\.lb|net\.lb|org\.lb|lc|com\.lc|net\.lc|co\.lc|org\.lc|edu\.lc|gov\.lc|li|lk|gov\.lk|sch\.lk|net\.lk|int\.lk|com\.lk|org\.lk|edu\.lk|ngo\.lk|soc\.lk|web\.lk|ltd\.lk|assn\.lk|grp\.lk|hotel\.lk|ac\.lk|lr|com\.lr|edu\.lr|gov\.lr|org\.lr|net\.lr|ls|co\.ls|org\.ls|lt|gov\.lt|lu|lv|com\.lv|edu\.lv|gov\.lv|org\.lv|mil\.lv|id\.lv|net\.lv|asn\.lv|conf\.lv|ly|com\.ly|net\.ly|gov\.ly|plc\.ly|edu\.ly|sch\.ly|med\.ly|org\.ly|id\.ly|ma|co\.ma|net\.ma|gov\.ma|org\.ma|ac\.ma|press\.ma|mc|tm\.mc|asso\.mc|md|me|co\.me|net\.me|org\.me|edu\.me|ac\.me|gov\.me|its\.me|priv\.me|mg|org\.mg|nom\.mg|gov\.mg|prd\.mg|tm\.mg|edu\.mg|mil\.mg|com\.mg|co\.mg|mh|mil|mk|com\.mk|org\.mk|net\.mk|edu\.mk|gov\.mk|inf\.mk|name\.mk|ml|com\.ml|edu\.ml|gouv\.ml|gov\.ml|net\.ml|org\.ml|presse\.ml|[^.]+\.mm|mn|gov\.mn|edu\.mn|org\.mn|mo|com\.mo|net\.mo|org\.mo|edu\.mo|gov\.mo|mobi|mp|mq|mr|gov\.mr|ms|com\.ms|edu\.ms|gov\.ms|net\.ms|org\.ms|mt|com\.mt|edu\.mt|net\.mt|org\.mt|mu|com\.mu|net\.mu|org\.mu|gov\.mu|ac\.mu|co\.mu|or\.mu|museum|academy\.museum|agriculture\.museum|air\.museum|airguard\.museum|alabama\.museum|alaska\.museum|amber\.museum|ambulance\.museum|american\.museum|americana\.museum|americanantiques\.museum|americanart\.museum|amsterdam\.museum|and\.museum|annefrank\.museum|anthro\.museum|anthropology\.museum|antiques\.museum|aquarium\.museum|arboretum\.museum|archaeological\.museum|archaeology\.museum|architecture\.museum|art\.museum|artanddesign\.museum|artcenter\.museum|artdeco\.museum|arteducation\.museum|artgallery\.museum|arts\.museum|artsandcrafts\.museum|asmatart\.museum|assassination\.museum|assisi\.museum|association\.museum|astronomy\.museum|atlanta\.museum|austin\.museum|australia\.museum|automotive\.museum|aviation\.museum|axis\.museum|badajoz\.museum|baghdad\.museum|bahn\.museum|bale\.museum|baltimore\.museum|barcelona\.museum|baseball\.museum|basel\.museum|baths\.museum|bauern\.museum|beauxarts\.museum|beeldengeluid\.museum|bellevue\.museum|bergbau\.museum|berkeley\.museum|berlin\.museum|bern\.museum|bible\.museum|bilbao\.museum|bill\.museum|birdart\.museum|birthplace\.museum|bonn\.museum|boston\.museum|botanical\.museum|botanicalgarden\.museum|botanicgarden\.museum|botany\.museum|brandywinevalley\.museum|brasil\.museum|bristol\.museum|british\.museum|britishcolumbia\.museum|broadcast\.museum|brunel\.museum|brussel\.museum|brussels\.museum|bruxelles\.museum|building\.museum|burghof\.museum|bus\.museum|bushey\.museum|cadaques\.museum|california\.museum|cambridge\.museum|can\.museum|canada\.museum|capebreton\.museum|carrier\.museum|cartoonart\.museum|casadelamoneda\.museum|castle\.museum|castres\.museum|celtic\.museum|center\.museum|chattanooga\.museum|cheltenham\.museum|chesapeakebay\.museum|chicago\.museum|children\.museum|childrens\.museum|childrensgarden\.museum|chiropractic\.museum|chocolate\.museum|christiansburg\.museum|cincinnati\.museum|cinema\.museum|circus\.museum|civilisation\.museum|civilization\.museum|civilwar\.museum|clinton\.museum|clock\.museum|coal\.museum|coastaldefence\.museum|cody\.museum|coldwar\.museum|collection\.museum|colonialwilliamsburg\.museum|coloradoplateau\.museum|columbia\.museum|columbus\.museum|communication\.museum|communications\.museum|community\.museum|computer\.museum|computerhistory\.museum|comunicações\.museum|contemporary\.museum|contemporaryart\.museum|convent\.museum|copenhagen\.museum|corporation\.museum|correios-e-telecomunicações\.museum|corvette\.museum|costume\.museum|countryestate\.museum|county\.museum|crafts\.museum|cranbrook\.museum|creation\.museum|cultural\.museum|culturalcenter\.museum|culture\.museum|cyber\.museum|cymru\.museum|dali\.museum|dallas\.museum|database\.museum|ddr\.museum|decorativearts\.museum|delaware\.museum|delmenhorst\.museum|denmark\.museum|depot\.museum|design\.museum|detroit\.museum|dinosaur\.museum|discovery\.museum|dolls\.museum|donostia\.museum|durham\.museum|eastafrica\.museum|eastcoast\.museum|education\.museum|educational\.museum|egyptian\.museum|eisenbahn\.museum|elburg\.museum|elvendrell\.museum|embroidery\.museum|encyclopedic\.museum|england\.museum|entomology\.museum|environment\.museum|environmentalconservation\.museum|epilepsy\.museum|essex\.museum|estate\.museum|ethnology\.museum|exeter\.museum|exhibition\.museum|family\.museum|farm\.museum|farmequipment\.museum|farmers\.museum|farmstead\.museum|field\.museum|figueres\.museum|filatelia\.museum|film\.museum|fineart\.museum|finearts\.museum|finland\.museum|flanders\.museum|florida\.museum|force\.museum|fortmissoula\.museum|fortworth\.museum|foundation\.museum|francaise\.museum|frankfurt\.museum|franziskaner\.museum|freemasonry\.museum|freiburg\.museum|fribourg\.museum|frog\.museum|fundacio\.museum|furniture\.museum|gallery\.museum|garden\.museum|gateway\.museum|geelvinck\.museum|gemological\.museum|geology\.museum|georgia\.museum|giessen\.museum|glas\.museum|glass\.museum|gorge\.museum|grandrapids\.museum|graz\.museum|guernsey\.museum|halloffame\.museum|hamburg\.museum|handson\.museum|harvestcelebration\.museum|hawaii\.museum|health\.museum|heimatunduhren\.museum|hellas\.museum|helsinki\.museum|hembygdsforbund\.museum|heritage\.museum|histoire\.museum|historical\.museum|historicalsociety\.museum|historichouses\.museum|historisch\.museum|historisches\.museum|history\.museum|historyofscience\.museum|horology\.museum|house\.museum|humanities\.museum|illustration\.museum|imageandsound\.museum|indian\.museum|indiana\.museum|indianapolis\.museum|indianmarket\.museum|intelligence\.museum|interactive\.museum|iraq\.museum|iron\.museum|isleofman\.museum|jamison\.museum|jefferson\.museum|jerusalem\.museum|jewelry\.museum|jewish\.museum|jewishart\.museum|jfk\.museum|journalism\.museum|judaica\.museum|judygarland\.museum|juedisches\.museum|juif\.museum|karate\.museum|karikatur\.museum|kids\.museum|koebenhavn\.museum|koeln\.museum|kunst\.museum|kunstsammlung\.museum|kunstunddesign\.museum|labor\.museum|labour\.museum|lajolla\.museum|lancashire\.museum|landes\.museum|lans\.museum|läns\.museum|larsson\.museum|lewismiller\.museum|lincoln\.museum|linz\.museum|living\.museum|livinghistory\.museum|localhistory\.museum|london\.museum|losangeles\.museum|louvre\.museum|loyalist\.museum|lucerne\.museum|luxembourg\.museum|luzern\.museum|mad\.museum|madrid\.museum|mallorca\.museum|manchester\.museum|mansion\.museum|mansions\.museum|manx\.museum|marburg\.museum|maritime\.museum|maritimo\.museum|maryland\.museum|marylhurst\.museum|media\.museum|medical\.museum|medizinhistorisches\.museum|meeres\.museum|memorial\.museum|mesaverde\.museum|michigan\.museum|midatlantic\.museum|military\.museum|mill\.museum|miners\.museum|mining\.museum|minnesota\.museum|missile\.museum|missoula\.museum|modern\.museum|moma\.museum|money\.museum|monmouth\.museum|monticello\.museum|montreal\.museum|moscow\.museum|motorcycle\.museum|muenchen\.museum|muenster\.museum|mulhouse\.museum|muncie\.museum|museet\.museum|museumcenter\.museum|museumvereniging\.museum|music\.museum|national\.museum|nationalfirearms\.museum|nationalheritage\.museum|nativeamerican\.museum|naturalhistory\.museum|naturalhistorymuseum\.museum|naturalsciences\.museum|nature\.museum|naturhistorisches\.museum|natuurwetenschappen\.museum|naumburg\.museum|naval\.museum|nebraska\.museum|neues\.museum|newhampshire\.museum|newjersey\.museum|newmexico\.museum|newport\.museum|newspaper\.museum|newyork\.museum|niepce\.museum|norfolk\.museum|north\.museum|nrw\.museum|nuernberg\.museum|nuremberg\.museum|nyc\.museum|nyny\.museum|oceanographic\.museum|oceanographique\.museum|omaha\.museum|online\.museum|ontario\.museum|openair\.museum|oregon\.museum|oregontrail\.museum|otago\.museum|oxford\.museum|pacific\.museum|paderborn\.museum|palace\.museum|paleo\.museum|palmsprings\.museum|panama\.museum|paris\.museum|pasadena\.museum|pharmacy\.museum|philadelphia\.museum|philadelphiaarea\.museum|philately\.museum|phoenix\.museum|photography\.museum|pilots\.museum|pittsburgh\.museum|planetarium\.museum|plantation\.museum|plants\.museum|plaza\.museum|portal\.museum|portland\.museum|portlligat\.museum|posts-and-telecommunications\.museum|preservation\.museum|presidio\.museum|press\.museum|project\.museum|public\.museum|pubol\.museum|quebec\.museum|railroad\.museum|railway\.museum|research\.museum|resistance\.museum|riodejaneiro\.museum|rochester\.museum|rockart\.museum|roma\.museum|russia\.museum|saintlouis\.museum|salem\.museum|salvadordali\.museum|salzburg\.museum|sandiego\.museum|sanfrancisco\.museum|santabarbara\.museum|santacruz\.museum|santafe\.museum|saskatchewan\.museum|satx\.museum|savannahga\.museum|schlesisches\.museum|schoenbrunn\.museum|schokoladen\.museum|school\.museum|schweiz\.museum|science\.museum|scienceandhistory\.museum|scienceandindustry\.museum|sciencecenter\.museum|sciencecenters\.museum|science-fiction\.museum|sciencehistory\.museum|sciences\.museum|sciencesnaturelles\.museum|scotland\.museum|seaport\.museum|settlement\.museum|settlers\.museum|shell\.museum|sherbrooke\.museum|sibenik\.museum|silk\.museum|ski\.museum|skole\.museum|society\.museum|sologne\.museum|soundandvision\.museum|southcarolina\.museum|southwest\.museum|space\.museum|spy\.museum|square\.museum|stadt\.museum|stalbans\.museum|starnberg\.museum|state\.museum|stateofdelaware\.museum|station\.museum|steam\.museum|steiermark\.museum|stjohn\.museum|stockholm\.museum|stpetersburg\.museum|stuttgart\.museum|suisse\.museum|surgeonshall\.museum|surrey\.museum|svizzera\.museum|sweden\.museum|sydney\.museum|tank\.museum|tcm\.museum|technology\.museum|telekommunikation\.museum|television\.museum|texas\.museum|textile\.museum|theater\.museum|time\.museum|timekeeping\.museum|topology\.museum|torino\.museum|touch\.museum|town\.museum|transport\.museum|tree\.museum|trolley\.museum|trust\.museum|trustee\.museum|uhren\.museum|ulm\.museum|undersea\.museum|university\.museum|usa\.museum|usantiques\.museum|usarts\.museum|uscountryestate\.museum|usculture\.museum|usdecorativearts\.museum|usgarden\.museum|ushistory\.museum|ushuaia\.museum|uslivinghistory\.museum|utah\.museum|uvic\.museum|valley\.museum|vantaa\.museum|versailles\.museum|viking\.museum|village\.museum|virginia\.museum|virtual\.museum|virtuel\.museum|vlaanderen\.museum|volkenkunde\.museum|wales\.museum|wallonie\.museum|war\.museum|washingtondc\.museum|watchandclock\.museum|watch-and-clock\.museum|western\.museum|westfalen\.museum|whaling\.museum|wildlife\.museum|williamsburg\.museum|windmill\.museum|workshop\.museum|york\.museum|yorkshire\.museum|yosemite\.museum|youth\.museum|zoological\.museum|zoology\.museum|ירושלים\.museum|иком\.museum|mv|aero\.mv|biz\.mv|com\.mv|coop\.mv|edu\.mv|gov\.mv|info\.mv|int\.mv|mil\.mv|museum\.mv|name\.mv|net\.mv|org\.mv|pro\.mv|mw|ac\.mw|biz\.mw|co\.mw|com\.mw|coop\.mw|edu\.mw|gov\.mw|int\.mw|museum\.mw|net\.mw|org\.mw|mx|com\.mx|org\.mx|gob\.mx|edu\.mx|net\.mx|my|com\.my|net\.my|org\.my|gov\.my|edu\.my|mil\.my|name\.my|mz|ac\.mz|adv\.mz|co\.mz|edu\.mz|gov\.mz|mil\.mz|net\.mz|org\.mz|na|info\.na|pro\.na|name\.na|school\.na|or\.na|dr\.na|us\.na|mx\.na|ca\.na|in\.na|cc\.na|tv\.na|ws\.na|mobi\.na|co\.na|com\.na|org\.na|name|nc|asso\.nc|ne|net|nf|com\.nf|net\.nf|per\.nf|rec\.nf|web\.nf|arts\.nf|firm\.nf|info\.nf|other\.nf|store\.nf|ng|com\.ng|edu\.ng|gov\.ng|i\.ng|mil\.ng|mobi\.ng|name\.ng|net\.ng|org\.ng|sch\.ng|ni|ac\.ni|biz\.ni|co\.ni|com\.ni|edu\.ni|gob\.ni|in\.ni|info\.ni|int\.ni|mil\.ni|net\.ni|nom\.ni|org\.ni|web\.ni|nl|bv\.nl|no|fhs\.no|vgs\.no|fylkesbibl\.no|folkebibl\.no|museum\.no|idrett\.no|priv\.no|mil\.no|stat\.no|dep\.no|kommune\.no|herad\.no|aa\.no|ah\.no|bu\.no|fm\.no|hl\.no|hm\.no|jan-mayen\.no|mr\.no|nl\.no|nt\.no|of\.no|ol\.no|oslo\.no|rl\.no|sf\.no|st\.no|svalbard\.no|tm\.no|tr\.no|va\.no|vf\.no|gs\.aa\.no|gs\.ah\.no|gs\.bu\.no|gs\.fm\.no|gs\.hl\.no|gs\.hm\.no|gs\.jan-mayen\.no|gs\.mr\.no|gs\.nl\.no|gs\.nt\.no|gs\.of\.no|gs\.ol\.no|gs\.oslo\.no|gs\.rl\.no|gs\.sf\.no|gs\.st\.no|gs\.svalbard\.no|gs\.tm\.no|gs\.tr\.no|gs\.va\.no|gs\.vf\.no|akrehamn\.no|åkrehamn\.no|algard\.no|ålgård\.no|arna\.no|brumunddal\.no|bryne\.no|bronnoysund\.no|brønnøysund\.no|drobak\.no|drøbak\.no|egersund\.no|fetsund\.no|floro\.no|florø\.no|fredrikstad\.no|hokksund\.no|honefoss\.no|hønefoss\.no|jessheim\.no|jorpeland\.no|jørpeland\.no|kirkenes\.no|kopervik\.no|krokstadelva\.no|langevag\.no|langevåg\.no|leirvik\.no|mjondalen\.no|mjøndalen\.no|mo-i-rana\.no|mosjoen\.no|mosjøen\.no|nesoddtangen\.no|orkanger\.no|osoyro\.no|osøyro\.no|raholt\.no|råholt\.no|sandnessjoen\.no|sandnessjøen\.no|skedsmokorset\.no|slattum\.no|spjelkavik\.no|stathelle\.no|stavern\.no|stjordalshalsen\.no|stjørdalshalsen\.no|tananger\.no|tranby\.no|vossevangen\.no|afjord\.no|åfjord\.no|agdenes\.no|al\.no|ål\.no|alesund\.no|ålesund\.no|alstahaug\.no|alta\.no|áltá\.no|alaheadju\.no|álaheadju\.no|alvdal\.no|amli\.no|åmli\.no|amot\.no|åmot\.no|andebu\.no|andoy\.no|andøy\.no|andasuolo\.no|ardal\.no|årdal\.no|aremark\.no|arendal\.no|ås\.no|aseral\.no|åseral\.no|asker\.no|askim\.no|askvoll\.no|askoy\.no|askøy\.no|asnes\.no|åsnes\.no|audnedaln\.no|aukra\.no|aure\.no|aurland\.no|aurskog-holand\.no|aurskog-høland\.no|austevoll\.no|austrheim\.no|averoy\.no|averøy\.no|balestrand\.no|ballangen\.no|balat\.no|bálát\.no|balsfjord\.no|bahccavuotna\.no|báhccavuotna\.no|bamble\.no|bardu\.no|beardu\.no|beiarn\.no|bajddar\.no|bájddar\.no|baidar\.no|báidár\.no|berg\.no|bergen\.no|berlevag\.no|berlevåg\.no|bearalvahki\.no|bearalváhki\.no|bindal\.no|birkenes\.no|bjarkoy\.no|bjarkøy\.no|bjerkreim\.no|bjugn\.no|bodo\.no|bodø\.no|badaddja\.no|bådåddjå\.no|budejju\.no|bokn\.no|bremanger\.no|bronnoy\.no|brønnøy\.no|bygland\.no|bykle\.no|barum\.no|bærum\.no|bo\.telemark\.no|bø\.telemark\.no|bo\.nordland\.no|bø\.nordland\.no|bievat\.no|bievát\.no|bomlo\.no|bømlo\.no|batsfjord\.no|båtsfjord\.no|bahcavuotna\.no|báhcavuotna\.no|dovre\.no|drammen\.no|drangedal\.no|dyroy\.no|dyrøy\.no|donna\.no|dønna\.no|eid\.no|eidfjord\.no|eidsberg\.no|eidskog\.no|eidsvoll\.no|eigersund\.no|elverum\.no|enebakk\.no|engerdal\.no|etne\.no|etnedal\.no|evenes\.no|evenassi\.no|evenášši\.no|evje-og-hornnes\.no|farsund\.no|fauske\.no|fuossko\.no|fuoisku\.no|fedje\.no|fet\.no|finnoy\.no|finnøy\.no|fitjar\.no|fjaler\.no|fjell\.no|flakstad\.no|flatanger\.no|flekkefjord\.no|flesberg\.no|flora\.no|fla\.no|flå\.no|folldal\.no|forsand\.no|fosnes\.no|frei\.no|frogn\.no|froland\.no|frosta\.no|frana\.no|fræna\.no|froya\.no|frøya\.no|fusa\.no|fyresdal\.no|forde\.no|førde\.no|gamvik\.no|gangaviika\.no|gáŋgaviika\.no|gaular\.no|gausdal\.no|gildeskal\.no|gildeskål\.no|giske\.no|gjemnes\.no|gjerdrum\.no|gjerstad\.no|gjesdal\.no|gjovik\.no|gjøvik\.no|gloppen\.no|gol\.no|gran\.no|grane\.no|granvin\.no|gratangen\.no|grimstad\.no|grong\.no|kraanghke\.no|kråanghke\.no|grue\.no|gulen\.no|hadsel\.no|halden\.no|halsa\.no|hamar\.no|hamaroy\.no|habmer\.no|hábmer\.no|hapmir\.no|hápmir\.no|hammerfest\.no|hammarfeasta\.no|hámmárfeasta\.no|haram\.no|hareid\.no|harstad\.no|hasvik\.no|aknoluokta\.no|ákŋoluokta\.no|hattfjelldal\.no|aarborte\.no|haugesund\.no|hemne\.no|hemnes\.no|hemsedal\.no|heroy\.more-og-romsdal\.no|herøy\.møre-og-romsdal\.no|heroy\.nordland\.no|herøy\.nordland\.no|hitra\.no|hjartdal\.no|hjelmeland\.no|hobol\.no|hobøl\.no|hof\.no|hol\.no|hole\.no|holmestrand\.no|holtalen\.no|holtålen\.no|hornindal\.no|horten\.no|hurdal\.no|hurum\.no|hvaler\.no|hyllestad\.no|hagebostad\.no|hægebostad\.no|hoyanger\.no|høyanger\.no|hoylandet\.no|høylandet\.no|ha\.no|hå\.no|ibestad\.no|inderoy\.no|inderøy\.no|iveland\.no|jevnaker\.no|jondal\.no|jolster\.no|jølster\.no|karasjok\.no|karasjohka\.no|kárášjohka\.no|karlsoy\.no|galsa\.no|gálsá\.no|karmoy\.no|karmøy\.no|kautokeino\.no|guovdageaidnu\.no|klepp\.no|klabu\.no|klæbu\.no|kongsberg\.no|kongsvinger\.no|kragero\.no|kragerø\.no|kristiansand\.no|kristiansund\.no|krodsherad\.no|krødsherad\.no|kvalsund\.no|rahkkeravju\.no|ráhkkerávju\.no|kvam\.no|kvinesdal\.no|kvinnherad\.no|kviteseid\.no|kvitsoy\.no|kvitsøy\.no|kvafjord\.no|kvæfjord\.no|giehtavuoatna\.no|kvanangen\.no|kvænangen\.no|navuotna\.no|návuotna\.no|kafjord\.no|kåfjord\.no|gaivuotna\.no|gáivuotna\.no|larvik\.no|lavangen\.no|lavagis\.no|loabat\.no|loabát\.no|lebesby\.no|davvesiida\.no|leikanger\.no|leirfjord\.no|leka\.no|leksvik\.no|lenvik\.no|leangaviika\.no|leaŋgaviika\.no|lesja\.no|levanger\.no|lier\.no|lierne\.no|lillehammer\.no|lillesand\.no|lindesnes\.no|lindas\.no|lindås\.no|lom\.no|loppa\.no|lahppi\.no|láhppi\.no|lund\.no|lunner\.no|luroy\.no|lurøy\.no|luster\.no|lyngdal\.no|lyngen\.no|ivgu\.no|lardal\.no|lerdal\.no|lærdal\.no|lodingen\.no|lødingen\.no|lorenskog\.no|lørenskog\.no|loten\.no|løten\.no|malvik\.no|masoy\.no|måsøy\.no|muosat\.no|muosát\.no|mandal\.no|marker\.no|marnardal\.no|masfjorden\.no|meland\.no|meldal\.no|melhus\.no|meloy\.no|meløy\.no|meraker\.no|meråker\.no|moareke\.no|moåreke\.no|midsund\.no|midtre-gauldal\.no|modalen\.no|modum\.no|molde\.no|moskenes\.no|moss\.no|mosvik\.no|malselv\.no|målselv\.no|malatvuopmi\.no|málatvuopmi\.no|namdalseid\.no|aejrie\.no|namsos\.no|namsskogan\.no|naamesjevuemie\.no|nååmesjevuemie\.no|laakesvuemie\.no|nannestad\.no|narvik\.no|narviika\.no|naustdal\.no|nedre-eiker\.no|nes\.akershus\.no|nes\.buskerud\.no|nesna\.no|nesodden\.no|nesseby\.no|unjarga\.no|unjárga\.no|nesset\.no|nissedal\.no|nittedal\.no|nord-aurdal\.no|nord-fron\.no|nord-odal\.no|norddal\.no|nordkapp\.no|davvenjarga\.no|davvenjárga\.no|nordre-land\.no|nordreisa\.no|raisa\.no|ráisa\.no|nore-og-uvdal\.no|notodden\.no|naroy\.no|nærøy\.no|notteroy\.no|nøtterøy\.no|odda\.no|oksnes\.no|øksnes\.no|oppdal\.no|oppegard\.no|oppegård\.no|orkdal\.no|orland\.no|ørland\.no|orskog\.no|ørskog\.no|orsta\.no|ørsta\.no|os\.hedmark\.no|os\.hordaland\.no|osen\.no|osteroy\.no|osterøy\.no|ostre-toten\.no|østre-toten\.no|overhalla\.no|ovre-eiker\.no|øvre-eiker\.no|oyer\.no|øyer\.no|oygarden\.no|øygarden\.no|oystre-slidre\.no|øystre-slidre\.no|porsanger\.no|porsangu\.no|porsáŋgu\.no|porsgrunn\.no|radoy\.no|radøy\.no|rakkestad\.no|rana\.no|ruovat\.no|randaberg\.no|rauma\.no|rendalen\.no|rennebu\.no|rennesoy\.no|rennesøy\.no|rindal\.no|ringebu\.no|ringerike\.no|ringsaker\.no|rissa\.no|risor\.no|risør\.no|roan\.no|rollag\.no|rygge\.no|ralingen\.no|rælingen\.no|rodoy\.no|rødøy\.no|romskog\.no|rømskog\.no|roros\.no|røros\.no|rost\.no|røst\.no|royken\.no|røyken\.no|royrvik\.no|røyrvik\.no|rade\.no|råde\.no|salangen\.no|siellak\.no|saltdal\.no|salat\.no|sálát\.no|sálat\.no|samnanger\.no|sande\.more-og-romsdal\.no|sande\.møre-og-romsdal\.no|sande\.vestfold\.no|sandefjord\.no|sandnes\.no|sandoy\.no|sandøy\.no|sarpsborg\.no|sauda\.no|sauherad\.no|sel\.no|selbu\.no|selje\.no|seljord\.no|sigdal\.no|siljan\.no|sirdal\.no|skaun\.no|skedsmo\.no|ski\.no|skien\.no|skiptvet\.no|skjervoy\.no|skjervøy\.no|skierva\.no|skiervá\.no|skjak\.no|skjåk\.no|skodje\.no|skanland\.no|skånland\.no|skanit\.no|skánit\.no|smola\.no|smøla\.no|snillfjord\.no|snasa\.no|snåsa\.no|snoasa\.no|snaase\.no|snåase\.no|sogndal\.no|sokndal\.no|sola\.no|solund\.no|songdalen\.no|sortland\.no|spydeberg\.no|stange\.no|stavanger\.no|steigen\.no|steinkjer\.no|stjordal\.no|stjørdal\.no|stokke\.no|stor-elvdal\.no|stord\.no|stordal\.no|storfjord\.no|omasvuotna\.no|strand\.no|stranda\.no|stryn\.no|sula\.no|suldal\.no|sund\.no|sunndal\.no|surnadal\.no|sveio\.no|svelvik\.no|sykkylven\.no|sogne\.no|søgne\.no|somna\.no|sømna\.no|sondre-land\.no|søndre-land\.no|sor-aurdal\.no|sør-aurdal\.no|sor-fron\.no|sør-fron\.no|sor-odal\.no|sør-odal\.no|sor-varanger\.no|sør-varanger\.no|matta-varjjat\.no|mátta-várjjat\.no|sorfold\.no|sørfold\.no|sorreisa\.no|sørreisa\.no|sorum\.no|sørum\.no|tana\.no|deatnu\.no|time\.no|tingvoll\.no|tinn\.no|tjeldsund\.no|dielddanuorri\.no|tjome\.no|tjøme\.no|tokke\.no|tolga\.no|torsken\.no|tranoy\.no|tranøy\.no|tromso\.no|tromsø\.no|tromsa\.no|romsa\.no|trondheim\.no|troandin\.no|trysil\.no|trana\.no|træna\.no|trogstad\.no|trøgstad\.no|tvedestrand\.no|tydal\.no|tynset\.no|tysfjord\.no|divtasvuodna\.no|divttasvuotna\.no|tysnes\.no|tysvar\.no|tysvær\.no|tonsberg\.no|tønsberg\.no|ullensaker\.no|ullensvang\.no|ulvik\.no|utsira\.no|vadso\.no|vadsø\.no|cahcesuolo\.no|čáhcesuolo\.no|vaksdal\.no|valle\.no|vang\.no|vanylven\.no|vardo\.no|vardø\.no|varggat\.no|várggát\.no|vefsn\.no|vaapste\.no|vega\.no|vegarshei\.no|vegårshei\.no|vennesla\.no|verdal\.no|verran\.no|vestby\.no|vestnes\.no|vestre-slidre\.no|vestre-toten\.no|vestvagoy\.no|vestvågøy\.no|vevelstad\.no|vik\.no|vikna\.no|vindafjord\.no|volda\.no|voss\.no|varoy\.no|værøy\.no|vagan\.no|vågan\.no|voagat\.no|vagsoy\.no|vågsøy\.no|vaga\.no|vågå\.no|valer\.ostfold\.no|våler\.østfold\.no|valer\.hedmark\.no|våler\.hedmark\.no|[^.]+\.np|nr|biz\.nr|info\.nr|gov\.nr|edu\.nr|org\.nr|net\.nr|com\.nr|nu|nz|ac\.nz|co\.nz|cri\.nz|geek\.nz|gen\.nz|govt\.nz|health\.nz|iwi\.nz|kiwi\.nz|maori\.nz|mil\.nz|māori\.nz|net\.nz|org\.nz|parliament\.nz|school\.nz|om|co\.om|com\.om|edu\.om|gov\.om|med\.om|museum\.om|net\.om|org\.om|pro\.om|onion|org|pa|ac\.pa|gob\.pa|com\.pa|org\.pa|sld\.pa|edu\.pa|net\.pa|ing\.pa|abo\.pa|med\.pa|nom\.pa|pe|edu\.pe|gob\.pe|nom\.pe|mil\.pe|org\.pe|com\.pe|net\.pe|pf|com\.pf|org\.pf|edu\.pf|[^.]+\.pg|ph|com\.ph|net\.ph|org\.ph|gov\.ph|edu\.ph|ngo\.ph|mil\.ph|i\.ph|pk|com\.pk|net\.pk|edu\.pk|org\.pk|fam\.pk|biz\.pk|web\.pk|gov\.pk|gob\.pk|gok\.pk|gon\.pk|gop\.pk|gos\.pk|info\.pk|pl|com\.pl|net\.pl|org\.pl|aid\.pl|agro\.pl|atm\.pl|auto\.pl|biz\.pl|edu\.pl|gmina\.pl|gsm\.pl|info\.pl|mail\.pl|miasta\.pl|media\.pl|mil\.pl|nieruchomosci\.pl|nom\.pl|pc\.pl|powiat\.pl|priv\.pl|realestate\.pl|rel\.pl|sex\.pl|shop\.pl|sklep\.pl|sos\.pl|szkola\.pl|targi\.pl|tm\.pl|tourism\.pl|travel\.pl|turystyka\.pl|gov\.pl|ap\.gov\.pl|ic\.gov\.pl|is\.gov\.pl|us\.gov\.pl|kmpsp\.gov\.pl|kppsp\.gov\.pl|kwpsp\.gov\.pl|psp\.gov\.pl|wskr\.gov\.pl|kwp\.gov\.pl|mw\.gov\.pl|ug\.gov\.pl|um\.gov\.pl|umig\.gov\.pl|ugim\.gov\.pl|upow\.gov\.pl|uw\.gov\.pl|starostwo\.gov\.pl|pa\.gov\.pl|po\.gov\.pl|psse\.gov\.pl|pup\.gov\.pl|rzgw\.gov\.pl|sa\.gov\.pl|so\.gov\.pl|sr\.gov\.pl|wsa\.gov\.pl|sko\.gov\.pl|uzs\.gov\.pl|wiih\.gov\.pl|winb\.gov\.pl|pinb\.gov\.pl|wios\.gov\.pl|witd\.gov\.pl|wzmiuw\.gov\.pl|piw\.gov\.pl|wiw\.gov\.pl|griw\.gov\.pl|wif\.gov\.pl|oum\.gov\.pl|sdn\.gov\.pl|zp\.gov\.pl|uppo\.gov\.pl|mup\.gov\.pl|wuoz\.gov\.pl|konsulat\.gov\.pl|oirm\.gov\.pl|augustow\.pl|babia-gora\.pl|bedzin\.pl|beskidy\.pl|bialowieza\.pl|bialystok\.pl|bielawa\.pl|bieszczady\.pl|boleslawiec\.pl|bydgoszcz\.pl|bytom\.pl|cieszyn\.pl|czeladz\.pl|czest\.pl|dlugoleka\.pl|elblag\.pl|elk\.pl|glogow\.pl|gniezno\.pl|gorlice\.pl|grajewo\.pl|ilawa\.pl|jaworzno\.pl|jelenia-gora\.pl|jgora\.pl|kalisz\.pl|kazimierz-dolny\.pl|karpacz\.pl|kartuzy\.pl|kaszuby\.pl|katowice\.pl|kepno\.pl|ketrzyn\.pl|klodzko\.pl|kobierzyce\.pl|kolobrzeg\.pl|konin\.pl|konskowola\.pl|kutno\.pl|lapy\.pl|lebork\.pl|legnica\.pl|lezajsk\.pl|limanowa\.pl|lomza\.pl|lowicz\.pl|lubin\.pl|lukow\.pl|malbork\.pl|malopolska\.pl|mazowsze\.pl|mazury\.pl|mielec\.pl|mielno\.pl|mragowo\.pl|naklo\.pl|nowaruda\.pl|nysa\.pl|olawa\.pl|olecko\.pl|olkusz\.pl|olsztyn\.pl|opoczno\.pl|opole\.pl|ostroda\.pl|ostroleka\.pl|ostrowiec\.pl|ostrowwlkp\.pl|pila\.pl|pisz\.pl|podhale\.pl|podlasie\.pl|polkowice\.pl|pomorze\.pl|pomorskie\.pl|prochowice\.pl|pruszkow\.pl|przeworsk\.pl|pulawy\.pl|radom\.pl|rawa-maz\.pl|rybnik\.pl|rzeszow\.pl|sanok\.pl|sejny\.pl|slask\.pl|slupsk\.pl|sosnowiec\.pl|stalowa-wola\.pl|skoczow\.pl|starachowice\.pl|stargard\.pl|suwalki\.pl|swidnica\.pl|swiebodzin\.pl|swinoujscie\.pl|szczecin\.pl|szczytno\.pl|tarnobrzeg\.pl|tgory\.pl|turek\.pl|tychy\.pl|ustka\.pl|walbrzych\.pl|warmia\.pl|warszawa\.pl|waw\.pl|wegrow\.pl|wielun\.pl|wlocl\.pl|wloclawek\.pl|wodzislaw\.pl|wolomin\.pl|wroclaw\.pl|zachpomor\.pl|zagan\.pl|zarow\.pl|zgora\.pl|zgorzelec\.pl|pm|pn|gov\.pn|co\.pn|org\.pn|edu\.pn|net\.pn|post|pr|com\.pr|net\.pr|org\.pr|gov\.pr|edu\.pr|isla\.pr|pro\.pr|biz\.pr|info\.pr|name\.pr|est\.pr|prof\.pr|ac\.pr|pro|aaa\.pro|aca\.pro|acct\.pro|avocat\.pro|bar\.pro|cpa\.pro|eng\.pro|jur\.pro|law\.pro|med\.pro|recht\.pro|ps|edu\.ps|gov\.ps|sec\.ps|plo\.ps|com\.ps|org\.ps|net\.ps|pt|net\.pt|gov\.pt|org\.pt|edu\.pt|int\.pt|publ\.pt|com\.pt|nome\.pt|pw|co\.pw|ne\.pw|or\.pw|ed\.pw|go\.pw|belau\.pw|py|com\.py|coop\.py|edu\.py|gov\.py|mil\.py|net\.py|org\.py|qa|com\.qa|edu\.qa|gov\.qa|mil\.qa|name\.qa|net\.qa|org\.qa|sch\.qa|re|asso\.re|com\.re|nom\.re|ro|arts\.ro|com\.ro|firm\.ro|info\.ro|nom\.ro|nt\.ro|org\.ro|rec\.ro|store\.ro|tm\.ro|www\.ro|rs|ac\.rs|co\.rs|edu\.rs|gov\.rs|in\.rs|org\.rs|ru|ac\.ru|edu\.ru|gov\.ru|int\.ru|mil\.ru|test\.ru|rw|gov\.rw|net\.rw|edu\.rw|ac\.rw|com\.rw|co\.rw|int\.rw|mil\.rw|gouv\.rw|sa|com\.sa|net\.sa|org\.sa|gov\.sa|med\.sa|pub\.sa|edu\.sa|sch\.sa|sb|com\.sb|edu\.sb|gov\.sb|net\.sb|org\.sb|sc|com\.sc|gov\.sc|net\.sc|org\.sc|edu\.sc|sd|com\.sd|net\.sd|org\.sd|edu\.sd|med\.sd|tv\.sd|gov\.sd|info\.sd|se|a\.se|ac\.se|b\.se|bd\.se|brand\.se|c\.se|d\.se|e\.se|f\.se|fh\.se|fhsk\.se|fhv\.se|g\.se|h\.se|i\.se|k\.se|komforb\.se|kommunalforbund\.se|komvux\.se|l\.se|lanbib\.se|m\.se|n\.se|naturbruksgymn\.se|o\.se|org\.se|p\.se|parti\.se|pp\.se|press\.se|r\.se|s\.se|t\.se|tm\.se|u\.se|w\.se|x\.se|y\.se|z\.se|sg|com\.sg|net\.sg|org\.sg|gov\.sg|edu\.sg|per\.sg|sh|com\.sh|net\.sh|gov\.sh|org\.sh|mil\.sh|si|sj|sk|sl|com\.sl|net\.sl|edu\.sl|gov\.sl|org\.sl|sm|sn|art\.sn|com\.sn|edu\.sn|gouv\.sn|org\.sn|perso\.sn|univ\.sn|so|com\.so|net\.so|org\.so|sr|st|co\.st|com\.st|consulado\.st|edu\.st|embaixada\.st|gov\.st|mil\.st|net\.st|org\.st|principe\.st|saotome\.st|store\.st|su|sv|com\.sv|edu\.sv|gob\.sv|org\.sv|red\.sv|sx|gov\.sx|sy|edu\.sy|gov\.sy|net\.sy|mil\.sy|com\.sy|org\.sy|sz|co\.sz|ac\.sz|org\.sz|tc|td|tel|tf|tg|th|ac\.th|co\.th|go\.th|in\.th|mi\.th|net\.th|or\.th|tj|ac\.tj|biz\.tj|co\.tj|com\.tj|edu\.tj|go\.tj|gov\.tj|int\.tj|mil\.tj|name\.tj|net\.tj|nic\.tj|org\.tj|test\.tj|web\.tj|tk|tl|gov\.tl|tm|com\.tm|co\.tm|org\.tm|net\.tm|nom\.tm|gov\.tm|mil\.tm|edu\.tm|tn|com\.tn|ens\.tn|fin\.tn|gov\.tn|ind\.tn|intl\.tn|nat\.tn|net\.tn|org\.tn|info\.tn|perso\.tn|tourism\.tn|edunet\.tn|rnrt\.tn|rns\.tn|rnu\.tn|mincom\.tn|agrinet\.tn|defense\.tn|turen\.tn|to|com\.to|gov\.to|net\.to|org\.to|edu\.to|mil\.to|tr|com\.tr|info\.tr|biz\.tr|net\.tr|org\.tr|web\.tr|gen\.tr|tv\.tr|av\.tr|dr\.tr|bbs\.tr|name\.tr|tel\.tr|gov\.tr|bel\.tr|pol\.tr|mil\.tr|k12\.tr|edu\.tr|kep\.tr|nc\.tr|gov\.nc\.tr|travel|tt|co\.tt|com\.tt|org\.tt|net\.tt|biz\.tt|info\.tt|pro\.tt|int\.tt|coop\.tt|jobs\.tt|mobi\.tt|travel\.tt|museum\.tt|aero\.tt|name\.tt|gov\.tt|edu\.tt|tv|tw|edu\.tw|gov\.tw|mil\.tw|com\.tw|net\.tw|org\.tw|idv\.tw|game\.tw|ebiz\.tw|club\.tw|網路\.tw|組織\.tw|商業\.tw|tz|ac\.tz|co\.tz|go\.tz|hotel\.tz|info\.tz|me\.tz|mil\.tz|mobi\.tz|ne\.tz|or\.tz|sc\.tz|tv\.tz|ua|com\.ua|edu\.ua|gov\.ua|in\.ua|net\.ua|org\.ua|cherkassy\.ua|cherkasy\.ua|chernigov\.ua|chernihiv\.ua|chernivtsi\.ua|chernovtsy\.ua|ck\.ua|cn\.ua|cr\.ua|crimea\.ua|cv\.ua|dn\.ua|dnepropetrovsk\.ua|dnipropetrovsk\.ua|dominic\.ua|donetsk\.ua|dp\.ua|if\.ua|ivano-frankivsk\.ua|kh\.ua|kharkiv\.ua|kharkov\.ua|kherson\.ua|khmelnitskiy\.ua|khmelnytskyi\.ua|kiev\.ua|kirovograd\.ua|km\.ua|kr\.ua|krym\.ua|ks\.ua|kv\.ua|kyiv\.ua|lg\.ua|lt\.ua|lugansk\.ua|lutsk\.ua|lv\.ua|lviv\.ua|mk\.ua|mykolaiv\.ua|nikolaev\.ua|od\.ua|odesa\.ua|odessa\.ua|pl\.ua|poltava\.ua|rivne\.ua|rovno\.ua|rv\.ua|sb\.ua|sebastopol\.ua|sevastopol\.ua|sm\.ua|sumy\.ua|te\.ua|ternopil\.ua|uz\.ua|uzhgorod\.ua|vinnica\.ua|vinnytsia\.ua|vn\.ua|volyn\.ua|yalta\.ua|zaporizhzhe\.ua|zaporizhzhia\.ua|zhitomir\.ua|zhytomyr\.ua|zp\.ua|zt\.ua|ug|co\.ug|or\.ug|ac\.ug|sc\.ug|go\.ug|ne\.ug|com\.ug|org\.ug|uk|ac\.uk|co\.uk|gov\.uk|ltd\.uk|me\.uk|net\.uk|nhs\.uk|org\.uk|plc\.uk|police\.uk|[^.]+\.sch\.uk|us|dni\.us|fed\.us|isa\.us|kids\.us|nsn\.us|ak\.us|al\.us|ar\.us|as\.us|az\.us|ca\.us|co\.us|ct\.us|dc\.us|de\.us|fl\.us|ga\.us|gu\.us|hi\.us|ia\.us|id\.us|il\.us|in\.us|ks\.us|ky\.us|la\.us|ma\.us|md\.us|me\.us|mi\.us|mn\.us|mo\.us|ms\.us|mt\.us|nc\.us|nd\.us|ne\.us|nh\.us|nj\.us|nm\.us|nv\.us|ny\.us|oh\.us|ok\.us|or\.us|pa\.us|pr\.us|ri\.us|sc\.us|sd\.us|tn\.us|tx\.us|ut\.us|vi\.us|vt\.us|va\.us|wa\.us|wi\.us|wv\.us|wy\.us|k12\.ak\.us|k12\.al\.us|k12\.ar\.us|k12\.as\.us|k12\.az\.us|k12\.ca\.us|k12\.co\.us|k12\.ct\.us|k12\.dc\.us|k12\.de\.us|k12\.fl\.us|k12\.ga\.us|k12\.gu\.us|k12\.ia\.us|k12\.id\.us|k12\.il\.us|k12\.in\.us|k12\.ks\.us|k12\.ky\.us|k12\.la\.us|k12\.ma\.us|k12\.md\.us|k12\.me\.us|k12\.mi\.us|k12\.mn\.us|k12\.mo\.us|k12\.ms\.us|k12\.mt\.us|k12\.nc\.us|k12\.ne\.us|k12\.nh\.us|k12\.nj\.us|k12\.nm\.us|k12\.nv\.us|k12\.ny\.us|k12\.oh\.us|k12\.ok\.us|k12\.or\.us|k12\.pa\.us|k12\.pr\.us|k12\.ri\.us|k12\.sc\.us|k12\.tn\.us|k12\.tx\.us|k12\.ut\.us|k12\.vi\.us|k12\.vt\.us|k12\.va\.us|k12\.wa\.us|k12\.wi\.us|k12\.wy\.us|cc\.ak\.us|cc\.al\.us|cc\.ar\.us|cc\.as\.us|cc\.az\.us|cc\.ca\.us|cc\.co\.us|cc\.ct\.us|cc\.dc\.us|cc\.de\.us|cc\.fl\.us|cc\.ga\.us|cc\.gu\.us|cc\.hi\.us|cc\.ia\.us|cc\.id\.us|cc\.il\.us|cc\.in\.us|cc\.ks\.us|cc\.ky\.us|cc\.la\.us|cc\.ma\.us|cc\.md\.us|cc\.me\.us|cc\.mi\.us|cc\.mn\.us|cc\.mo\.us|cc\.ms\.us|cc\.mt\.us|cc\.nc\.us|cc\.nd\.us|cc\.ne\.us|cc\.nh\.us|cc\.nj\.us|cc\.nm\.us|cc\.nv\.us|cc\.ny\.us|cc\.oh\.us|cc\.ok\.us|cc\.or\.us|cc\.pa\.us|cc\.pr\.us|cc\.ri\.us|cc\.sc\.us|cc\.sd\.us|cc\.tn\.us|cc\.tx\.us|cc\.ut\.us|cc\.vi\.us|cc\.vt\.us|cc\.va\.us|cc\.wa\.us|cc\.wi\.us|cc\.wv\.us|cc\.wy\.us|lib\.ak\.us|lib\.al\.us|lib\.ar\.us|lib\.as\.us|lib\.az\.us|lib\.ca\.us|lib\.co\.us|lib\.ct\.us|lib\.dc\.us|lib\.fl\.us|lib\.ga\.us|lib\.gu\.us|lib\.hi\.us|lib\.ia\.us|lib\.id\.us|lib\.il\.us|lib\.in\.us|lib\.ks\.us|lib\.ky\.us|lib\.la\.us|lib\.ma\.us|lib\.md\.us|lib\.me\.us|lib\.mi\.us|lib\.mn\.us|lib\.mo\.us|lib\.ms\.us|lib\.mt\.us|lib\.nc\.us|lib\.nd\.us|lib\.ne\.us|lib\.nh\.us|lib\.nj\.us|lib\.nm\.us|lib\.nv\.us|lib\.ny\.us|lib\.oh\.us|lib\.ok\.us|lib\.or\.us|lib\.pa\.us|lib\.pr\.us|lib\.ri\.us|lib\.sc\.us|lib\.sd\.us|lib\.tn\.us|lib\.tx\.us|lib\.ut\.us|lib\.vi\.us|lib\.vt\.us|lib\.va\.us|lib\.wa\.us|lib\.wi\.us|lib\.wy\.us|pvt\.k12\.ma\.us|chtr\.k12\.ma\.us|paroch\.k12\.ma\.us|uy|com\.uy|edu\.uy|gub\.uy|mil\.uy|net\.uy|org\.uy|uz|co\.uz|com\.uz|net\.uz|org\.uz|va|vc|com\.vc|net\.vc|org\.vc|gov\.vc|mil\.vc|edu\.vc|ve|arts\.ve|co\.ve|com\.ve|e12\.ve|edu\.ve|firm\.ve|gob\.ve|gov\.ve|info\.ve|int\.ve|mil\.ve|net\.ve|org\.ve|rec\.ve|store\.ve|tec\.ve|web\.ve|vg|vi|co\.vi|com\.vi|k12\.vi|net\.vi|org\.vi|vn|com\.vn|net\.vn|org\.vn|edu\.vn|gov\.vn|int\.vn|ac\.vn|biz\.vn|info\.vn|name\.vn|pro\.vn|health\.vn|vu|com\.vu|edu\.vu|net\.vu|org\.vu|wf|ws|com\.ws|net\.ws|org\.ws|gov\.ws|edu\.ws|yt|امارات|հայ|বাংলা|бел|中国|中國|الجزائر|مصر|ею|გე|ελ|香港|भारत|بھارت|భారత్|ભારત|ਭਾਰਤ|ভারত|இந்தியா|ایران|ايران|عراق|الاردن|한국|қаз|ලංකා|இலங்கை|المغرب|мкд|мон|澳門|澳门|مليسيا|عمان|پاکستان|پاكستان|فلسطين|срб|пр\.срб|орг\.срб|обр\.срб|од\.срб|упр\.срб|ак\.срб|рф|قطر|السعودية|السعودیة|السعودیۃ|السعوديه|سودان|新加坡|சிங்கப்பூர்|سورية|سوريا|ไทย|تونس|台灣|台湾|臺灣|укр|اليمن|xxx|[^.]+\.ye|ac\.za|agric\.za|alt\.za|co\.za|edu\.za|gov\.za|grondar\.za|law\.za|mil\.za|net\.za|ngo\.za|nis\.za|nom\.za|org\.za|school\.za|tm\.za|web\.za|zm|ac\.zm|biz\.zm|co\.zm|com\.zm|edu\.zm|gov\.zm|info\.zm|mil\.zm|net\.zm|org\.zm|sch\.zm|[^.]+\.zw|aaa|aarp|abarth|abb|abbott|abbvie|abc|able|abogado|abudhabi|academy|accenture|accountant|accountants|aco|active|actor|adac|ads|adult|aeg|aetna|afamilycompany|afl|africa|agakhan|agency|aig|aigo|airbus|airforce|airtel|akdn|alfaromeo|alibaba|alipay|allfinanz|allstate|ally|alsace|alstom|americanexpress|americanfamily|amex|amfam|amica|amsterdam|analytics|android|anquan|anz|aol|apartments|app|apple|aquarelle|arab|aramco|archi|army|art|arte|asda|associates|athleta|attorney|auction|audi|audible|audio|auspost|author|auto|autos|avianca|aws|axa|azure|baby|baidu|banamex|bananarepublic|band|bank|bar|barcelona|barclaycard|barclays|barefoot|bargains|baseball|basketball|bauhaus|bayern|bbc|bbt|bbva|bcg|bcn|beats|beauty|beer|bentley|berlin|best|bestbuy|bet|bharti|bible|bid|bike|bing|bingo|bio|black|blackfriday|blanco|blockbuster|blog|bloomberg|blue|bms|bmw|bnl|bnpparibas|boats|boehringer|bofa|bom|bond|boo|book|booking|boots|bosch|bostik|boston|bot|boutique|box|bradesco|bridgestone|broadway|broker|brother|brussels|budapest|bugatti|build|builders|business|buy|buzz|bzh|cab|cafe|cal|call|calvinklein|cam|camera|camp|cancerresearch|canon|capetown|capital|capitalone|car|caravan|cards|care|career|careers|cars|cartier|casa|case|caseih|cash|casino|catering|catholic|cba|cbn|cbre|cbs|ceb|center|ceo|cern|cfa|cfd|chanel|channel|chase|chat|cheap|chintai|chloe|christmas|chrome|chrysler|church|cipriani|circle|cisco|citadel|citi|citic|city|cityeats|claims|cleaning|click|clinic|clinique|clothing|cloud|club|clubmed|coach|codes|coffee|college|cologne|comcast|commbank|community|company|compare|computer|comsec|condos|construction|consulting|contact|contractors|cooking|cookingchannel|cool|corsica|country|coupon|coupons|courses|credit|creditcard|creditunion|cricket|crown|crs|cruise|cruises|csc|cuisinella|cymru|cyou|dabur|dad|dance|data|date|dating|datsun|day|dclk|dds|deal|dealer|deals|degree|delivery|dell|deloitte|delta|democrat|dental|dentist|desi|design|dev|dhl|diamonds|diet|digital|direct|directory|discount|discover|dish|diy|dnp|docs|doctor|dodge|dog|doha|domains|dot|download|drive|dtv|dubai|duck|dunlop|duns|dupont|durban|dvag|dvr|dwg|earth|eat|eco|edeka|education|email|emerck|energy|engineer|engineering|enterprises|epost|epson|equipment|ericsson|erni|esq|estate|esurance|etisalat|eurovision|eus|events|everbank|exchange|expert|exposed|express|extraspace|fage|fail|fairwinds|faith|family|fan|fans|farm|farmers|fashion|fast|fedex|feedback|ferrari|ferrero|fiat|fidelity|fido|film|final|finance|financial|fire|firestone|firmdale|fish|fishing|fit|fitness|flickr|flights|flir|florist|flowers|fly|foo|food|foodnetwork|football|ford|forex|forsale|forum|foundation|fox|free|fresenius|frl|frogans|frontdoor|frontier|ftr|fujitsu|fujixerox|fun|fund|furniture|futbol|fyi|gal|gallery|gallo|gallup|game|games|gap|garden|gbiz|gdn|gea|gent|genting|george|ggee|gift|gifts|gives|giving|glade|glass|gle|global|globo|gmail|gmbh|gmo|gmx|godaddy|gold|goldpoint|golf|goo|goodhands|goodyear|goog|google|gop|got|grainger|graphics|gratis|green|gripe|grocery|group|guardian|gucci|guge|guide|guitars|guru|hair|hamburg|hangout|haus|hbo|hdfc|hdfcbank|health|healthcare|help|helsinki|here|hermes|hgtv|hiphop|hisamitsu|hitachi|hiv|hkt|hockey|holdings|holiday|homedepot|homegoods|homes|homesense|honda|honeywell|horse|hospital|host|hosting|hot|hoteles|hotels|hotmail|house|how|hsbc|htc|hughes|hyatt|hyundai|ibm|icbc|ice|icu|ieee|ifm|iinet|ikano|imamat|imdb|immo|immobilien|industries|infiniti|ing|ink|institute|insurance|insure|intel|international|intuit|investments|ipiranga|irish|iselect|ismaili|ist|istanbul|itau|itv|iveco|iwc|jaguar|java|jcb|jcp|jeep|jetzt|jewelry|jio|jlc|jll|jmp|jnj|joburg|jot|joy|jpmorgan|jprs|juegos|juniper|kaufen|kddi|kerryhotels|kerrylogistics|kerryproperties|kfh|kia|kim|kinder|kindle|kitchen|kiwi|koeln|komatsu|kosher|kpmg|kpn|krd|kred|kuokgroup|kyoto|lacaixa|ladbrokes|lamborghini|lamer|lancaster|lancia|lancome|land|landrover|lanxess|lasalle|lat|latino|latrobe|law|lawyer|lds|lease|leclerc|lefrak|legal|lego|lexus|lgbt|liaison|lidl|life|lifeinsurance|lifestyle|lighting|like|lilly|limited|limo|lincoln|linde|link|lipsy|live|living|lixil|loan|loans|locker|locus|loft|lol|london|lotte|lotto|love|lpl|lplfinancial|ltd|ltda|lundbeck|lupin|luxe|luxury|macys|madrid|maif|maison|makeup|man|management|mango|map|market|marketing|markets|marriott|marshalls|maserati|mattel|mba|mcd|mcdonalds|mckinsey|med|media|meet|melbourne|meme|memorial|men|menu|meo|merckmsd|metlife|miami|microsoft|mini|mint|mit|mitsubishi|mlb|mls|mma|mobile|mobily|moda|moe|moi|mom|monash|money|monster|montblanc|mopar|mormon|mortgage|moscow|moto|motorcycles|mov|movie|movistar|msd|mtn|mtpc|mtr|mutual|mutuelle|nab|nadex|nagoya|nationwide|natura|navy|nba|nec|netbank|netflix|network|neustar|new|newholland|news|next|nextdirect|nexus|nfl|ngo|nhk|nico|nike|nikon|ninja|nissan|nissay|nokia|northwesternmutual|norton|now|nowruz|nowtv|nra|nrw|ntt|nyc|obi|observer|off|office|okinawa|olayan|olayangroup|oldnavy|ollo|omega|one|ong|onl|online|onyourside|ooo|open|oracle|orange|organic|orientexpress|origins|osaka|otsuka|ott|ovh|page|pamperedchef|panasonic|panerai|paris|pars|partners|parts|party|passagens|pay|pccw|pet|pfizer|pharmacy|phd|philips|phone|photo|photography|photos|physio|piaget|pics|pictet|pictures|pid|pin|ping|pink|pioneer|pizza|place|play|playstation|plumbing|plus|pnc|pohl|poker|politie|porn|pramerica|praxi|press|prime|prod|productions|prof|progressive|promo|properties|property|protection|pru|prudential|pub|pwc|qpon|quebec|quest|qvc|racing|radio|raid|read|realestate|realtor|realty|recipes|red|redstone|redumbrella|rehab|reise|reisen|reit|reliance|ren|rent|rentals|repair|report|republican|rest|restaurant|review|reviews|rexroth|rich|richardli|ricoh|rightathome|ril|rio|rip|rmit|rocher|rocks|rodeo|rogers|room|rsvp|ruhr|run|rwe|ryukyu|saarland|safe|safety|sakura|sale|salon|samsclub|samsung|sandvik|sandvikcoromant|sanofi|sap|sapo|sarl|sas|save|saxo|sbi|sbs|sca|scb|schaeffler|schmidt|scholarships|school|schule|schwarz|science|scjohnson|scor|scot|search|seat|secure|security|seek|select|sener|services|ses|seven|sew|sex|sexy|sfr|shangrila|sharp|shaw|shell|shia|shiksha|shoes|shop|shopping|shouji|show|showtime|shriram|silk|sina|singles|site|ski|skin|sky|skype|sling|smart|smile|sncf|soccer|social|softbank|software|sohu|solar|solutions|song|sony|soy|space|spiegel|spot|spreadbetting|srl|srt|stada|staples|star|starhub|statebank|statefarm|statoil|stc|stcgroup|stockholm|storage|store|stream|studio|study|style|sucks|supplies|supply|support|surf|surgery|suzuki|swatch|swiftcover|swiss|sydney|symantec|systems|tab|taipei|talk|taobao|target|tatamotors|tatar|tattoo|tax|taxi|tci|tdk|team|tech|technology|telecity|telefonica|temasek|tennis|teva|thd|theater|theatre|theguardian|tiaa|tickets|tienda|tiffany|tips|tires|tirol|tjmaxx|tjx|tkmaxx|tmall|today|tokyo|tools|top|toray|toshiba|total|tours|town|toyota|toys|trade|trading|training|travelchannel|travelers|travelersinsurance|trust|trv|tube|tui|tunes|tushu|tvs|ubank|ubs|uconnect|unicom|university|uno|uol|ups|vacations|vana|vanguard|vegas|ventures|verisign|versicherung|vet|viajes|video|vig|viking|villas|vin|vip|virgin|visa|vision|vista|vistaprint|viva|vivo|vlaanderen|vodka|volkswagen|volvo|vote|voting|voto|voyage|vuelos|wales|walmart|walter|wang|wanggou|warman|watch|watches|weather|weatherchannel|webcam|weber|website|wed|wedding|weibo|weir|whoswho|wien|wiki|williamhill|win|windows|wine|winners|wme|wolterskluwer|woodside|work|works|world|wow|wtc|wtf|xbox|xerox|xfinity|xihuan|xin|कॉम|セール|佛山|慈善|集团|在线|大众汽车|点看|คอม|八卦|موقع|一号店|公益|公司|香格里拉|网站|移动|我爱你|москва|католик|онлайн|сайт|联通|קום|时尚|微博|淡马锡|ファッション|орг|नेट|ストア|삼성|商标|商店|商城|дети|ポイント|新闻|工行|家電|كوم|中文网|中信|娱乐|谷歌|電訊盈科|购物|クラウド|通販|网店|संगठन|餐厅|网络|ком|诺基亚|食品|飞利浦|手表|手机|ارامكو|العليان|اتصالات|بازار|موبايلي|ابوظبي|كاثوليك|همراه|닷컴|政府|شبكة|بيتك|عرب|机构|组织机构|健康|рус|珠宝|大拿|みんな|グーグル|世界|書籍|网址|닷넷|コム|天主教|游戏|vermögensberater|vermögensberatung|企业|信息|嘉里大酒店|嘉里|广东|政务|xperia|xyz|yachts|yahoo|yamaxun|yandex|yodobashi|yoga|yokohama|you|youtube|yun|zappos|zara|zero|zip|zippo|zone|zuerich)$/;
exports.private = /\.(beep\.pl|[^.]+\.compute\.estate|[^.]+\.alces\.network|[^.]+\.alwaysdata\.net|cloudfront\.net|[^.]+\.compute\.amazonaws\.com|[^.]+\.compute-1\.amazonaws\.com|[^.]+\.compute\.amazonaws\.com\.cn|us-east-1\.amazonaws\.com|elasticbeanstalk\.cn-north-1\.amazonaws\.com\.cn|[^.]+\.elasticbeanstalk\.com|[^.]+\.elb\.amazonaws\.com|[^.]+\.elb\.amazonaws\.com\.cn|s3\.amazonaws\.com|s3-ap-northeast-1\.amazonaws\.com|s3-ap-northeast-2\.amazonaws\.com|s3-ap-south-1\.amazonaws\.com|s3-ap-southeast-1\.amazonaws\.com|s3-ap-southeast-2\.amazonaws\.com|s3-ca-central-1\.amazonaws\.com|s3-eu-central-1\.amazonaws\.com|s3-eu-west-1\.amazonaws\.com|s3-eu-west-2\.amazonaws\.com|s3-external-1\.amazonaws\.com|s3-fips-us-gov-west-1\.amazonaws\.com|s3-sa-east-1\.amazonaws\.com|s3-us-gov-west-1\.amazonaws\.com|s3-us-east-2\.amazonaws\.com|s3-us-west-1\.amazonaws\.com|s3-us-west-2\.amazonaws\.com|s3\.ap-northeast-2\.amazonaws\.com|s3\.ap-south-1\.amazonaws\.com|s3\.cn-north-1\.amazonaws\.com\.cn|s3\.ca-central-1\.amazonaws\.com|s3\.eu-central-1\.amazonaws\.com|s3\.eu-west-2\.amazonaws\.com|s3\.us-east-2\.amazonaws\.com|s3\.dualstack\.ap-northeast-1\.amazonaws\.com|s3\.dualstack\.ap-northeast-2\.amazonaws\.com|s3\.dualstack\.ap-south-1\.amazonaws\.com|s3\.dualstack\.ap-southeast-1\.amazonaws\.com|s3\.dualstack\.ap-southeast-2\.amazonaws\.com|s3\.dualstack\.ca-central-1\.amazonaws\.com|s3\.dualstack\.eu-central-1\.amazonaws\.com|s3\.dualstack\.eu-west-1\.amazonaws\.com|s3\.dualstack\.eu-west-2\.amazonaws\.com|s3\.dualstack\.sa-east-1\.amazonaws\.com|s3\.dualstack\.us-east-1\.amazonaws\.com|s3\.dualstack\.us-east-2\.amazonaws\.com|s3-website-us-east-1\.amazonaws\.com|s3-website-us-west-1\.amazonaws\.com|s3-website-us-west-2\.amazonaws\.com|s3-website-ap-northeast-1\.amazonaws\.com|s3-website-ap-southeast-1\.amazonaws\.com|s3-website-ap-southeast-2\.amazonaws\.com|s3-website-eu-west-1\.amazonaws\.com|s3-website-sa-east-1\.amazonaws\.com|s3-website\.ap-northeast-2\.amazonaws\.com|s3-website\.ap-south-1\.amazonaws\.com|s3-website\.ca-central-1\.amazonaws\.com|s3-website\.eu-central-1\.amazonaws\.com|s3-website\.eu-west-2\.amazonaws\.com|s3-website\.us-east-2\.amazonaws\.com|t3l3p0rt\.net|tele\.amune\.org|on-aptible\.com|user\.party\.eus|pimienta\.org|poivron\.org|potager\.org|sweetpepper\.org|myasustor\.com|myfritz\.net|backplaneapp\.io|betainabox\.com|bnr\.la|boxfuse\.io|browsersafetymark\.io|mycd\.eu|ae\.org|ar\.com|br\.com|cn\.com|com\.de|com\.se|de\.com|eu\.com|gb\.com|gb\.net|hu\.com|hu\.net|jp\.net|jpn\.com|kr\.com|mex\.com|no\.com|qc\.com|ru\.com|sa\.com|se\.com|se\.net|uk\.com|uk\.net|us\.com|uy\.com|za\.bz|za\.com|africa\.com|gr\.com|in\.net|us\.org|co\.com|c\.la|certmgr\.org|xenapponazure\.com|virtueeldomein\.nl|cloudcontrolled\.com|cloudcontrolapp\.com|co\.ca|co\.cz|c\.cdn77\.org|cdn77-ssl\.net|r\.cdn77\.net|rsc\.cdn77\.org|ssl\.origin\.cdn77-secure\.org|cloudns\.asia|cloudns\.biz|cloudns\.club|cloudns\.cc|cloudns\.eu|cloudns\.in|cloudns\.info|cloudns\.org|cloudns\.pro|cloudns\.pw|cloudns\.us|co\.nl|co\.no|[^.]+\.platform\.sh|dyn\.cosidns\.de|dynamisches-dns\.de|dnsupdater\.de|internet-dns\.de|l-o-g-i-n\.de|dynamic-dns\.info|feste-ip\.net|knx-server\.net|static-access\.net|realm\.cz|[^.]+\.cryptonomic\.net|cupcake\.is|cyon\.link|cyon\.site|daplie\.me|biz\.dk|co\.dk|firm\.dk|reg\.dk|store\.dk|dedyn\.io|dnshome\.de|dreamhosters\.com|mydrobo\.com|drud\.io|drud\.us|duckdns\.org|dy\.fi|tunk\.org|dyndns-at-home\.com|dyndns-at-work\.com|dyndns-blog\.com|dyndns-free\.com|dyndns-home\.com|dyndns-ip\.com|dyndns-mail\.com|dyndns-office\.com|dyndns-pics\.com|dyndns-remote\.com|dyndns-server\.com|dyndns-web\.com|dyndns-wiki\.com|dyndns-work\.com|dyndns\.biz|dyndns\.info|dyndns\.org|dyndns\.tv|at-band-camp\.net|ath\.cx|barrel-of-knowledge\.info|barrell-of-knowledge\.info|better-than\.tv|blogdns\.com|blogdns\.net|blogdns\.org|blogsite\.org|boldlygoingnowhere\.org|broke-it\.net|buyshouses\.net|cechire\.com|dnsalias\.com|dnsalias\.net|dnsalias\.org|dnsdojo\.com|dnsdojo\.net|dnsdojo\.org|does-it\.net|doesntexist\.com|doesntexist\.org|dontexist\.com|dontexist\.net|dontexist\.org|doomdns\.com|doomdns\.org|dvrdns\.org|dyn-o-saur\.com|dynalias\.com|dynalias\.net|dynalias\.org|dynathome\.net|dyndns\.ws|endofinternet\.net|endofinternet\.org|endoftheinternet\.org|est-a-la-maison\.com|est-a-la-masion\.com|est-le-patron\.com|est-mon-blogueur\.com|for-better\.biz|for-more\.biz|for-our\.info|for-some\.biz|for-the\.biz|forgot\.her\.name|forgot\.his\.name|from-ak\.com|from-al\.com|from-ar\.com|from-az\.net|from-ca\.com|from-co\.net|from-ct\.com|from-dc\.com|from-de\.com|from-fl\.com|from-ga\.com|from-hi\.com|from-ia\.com|from-id\.com|from-il\.com|from-in\.com|from-ks\.com|from-ky\.com|from-la\.net|from-ma\.com|from-md\.com|from-me\.org|from-mi\.com|from-mn\.com|from-mo\.com|from-ms\.com|from-mt\.com|from-nc\.com|from-nd\.com|from-ne\.com|from-nh\.com|from-nj\.com|from-nm\.com|from-nv\.com|from-ny\.net|from-oh\.com|from-ok\.com|from-or\.com|from-pa\.com|from-pr\.com|from-ri\.com|from-sc\.com|from-sd\.com|from-tn\.com|from-tx\.com|from-ut\.com|from-va\.com|from-vt\.com|from-wa\.com|from-wi\.com|from-wv\.com|from-wy\.com|ftpaccess\.cc|fuettertdasnetz\.de|game-host\.org|game-server\.cc|getmyip\.com|gets-it\.net|go\.dyndns\.org|gotdns\.com|gotdns\.org|groks-the\.info|groks-this\.info|ham-radio-op\.net|here-for-more\.info|hobby-site\.com|hobby-site\.org|home\.dyndns\.org|homedns\.org|homeftp\.net|homeftp\.org|homeip\.net|homelinux\.com|homelinux\.net|homelinux\.org|homeunix\.com|homeunix\.net|homeunix\.org|iamallama\.com|in-the-band\.net|is-a-anarchist\.com|is-a-blogger\.com|is-a-bookkeeper\.com|is-a-bruinsfan\.org|is-a-bulls-fan\.com|is-a-candidate\.org|is-a-caterer\.com|is-a-celticsfan\.org|is-a-chef\.com|is-a-chef\.net|is-a-chef\.org|is-a-conservative\.com|is-a-cpa\.com|is-a-cubicle-slave\.com|is-a-democrat\.com|is-a-designer\.com|is-a-doctor\.com|is-a-financialadvisor\.com|is-a-geek\.com|is-a-geek\.net|is-a-geek\.org|is-a-green\.com|is-a-guru\.com|is-a-hard-worker\.com|is-a-hunter\.com|is-a-knight\.org|is-a-landscaper\.com|is-a-lawyer\.com|is-a-liberal\.com|is-a-libertarian\.com|is-a-linux-user\.org|is-a-llama\.com|is-a-musician\.com|is-a-nascarfan\.com|is-a-nurse\.com|is-a-painter\.com|is-a-patsfan\.org|is-a-personaltrainer\.com|is-a-photographer\.com|is-a-player\.com|is-a-republican\.com|is-a-rockstar\.com|is-a-socialist\.com|is-a-soxfan\.org|is-a-student\.com|is-a-teacher\.com|is-a-techie\.com|is-a-therapist\.com|is-an-accountant\.com|is-an-actor\.com|is-an-actress\.com|is-an-anarchist\.com|is-an-artist\.com|is-an-engineer\.com|is-an-entertainer\.com|is-by\.us|is-certified\.com|is-found\.org|is-gone\.com|is-into-anime\.com|is-into-cars\.com|is-into-cartoons\.com|is-into-games\.com|is-leet\.com|is-lost\.org|is-not-certified\.com|is-saved\.org|is-slick\.com|is-uberleet\.com|is-very-bad\.org|is-very-evil\.org|is-very-good\.org|is-very-nice\.org|is-very-sweet\.org|is-with-theband\.com|isa-geek\.com|isa-geek\.net|isa-geek\.org|isa-hockeynut\.com|issmarterthanyou\.com|isteingeek\.de|istmein\.de|kicks-ass\.net|kicks-ass\.org|knowsitall\.info|land-4-sale\.us|lebtimnetz\.de|leitungsen\.de|likes-pie\.com|likescandy\.com|merseine\.nu|mine\.nu|misconfused\.org|mypets\.ws|myphotos\.cc|neat-url\.com|office-on-the\.net|on-the-web\.tv|podzone\.net|podzone\.org|readmyblog\.org|saves-the-whales\.com|scrapper-site\.net|scrapping\.cc|selfip\.biz|selfip\.com|selfip\.info|selfip\.net|selfip\.org|sells-for-less\.com|sells-for-u\.com|sells-it\.net|sellsyourhome\.org|servebbs\.com|servebbs\.net|servebbs\.org|serveftp\.net|serveftp\.org|servegame\.org|shacknet\.nu|simple-url\.com|space-to-rent\.com|stuff-4-sale\.org|stuff-4-sale\.us|teaches-yoga\.com|thruhere\.net|traeumtgerade\.de|webhop\.biz|webhop\.info|webhop\.net|webhop\.org|worse-than\.tv|writesthisblog\.com|ddnss\.de|dyn\.ddnss\.de|dyndns\.ddnss\.de|dyndns1\.de|dyn-ip24\.de|home-webserver\.de|dyn\.home-webserver\.de|myhome-server\.de|ddnss\.org|dynv6\.net|e4\.cz|enonic\.io|customer\.enonic\.io|eu\.org|al\.eu\.org|asso\.eu\.org|at\.eu\.org|au\.eu\.org|be\.eu\.org|bg\.eu\.org|ca\.eu\.org|cd\.eu\.org|ch\.eu\.org|cn\.eu\.org|cy\.eu\.org|cz\.eu\.org|de\.eu\.org|dk\.eu\.org|edu\.eu\.org|ee\.eu\.org|es\.eu\.org|fi\.eu\.org|fr\.eu\.org|gr\.eu\.org|hr\.eu\.org|hu\.eu\.org|ie\.eu\.org|il\.eu\.org|in\.eu\.org|int\.eu\.org|is\.eu\.org|it\.eu\.org|jp\.eu\.org|kr\.eu\.org|lt\.eu\.org|lu\.eu\.org|lv\.eu\.org|mc\.eu\.org|me\.eu\.org|mk\.eu\.org|mt\.eu\.org|my\.eu\.org|net\.eu\.org|ng\.eu\.org|nl\.eu\.org|no\.eu\.org|nz\.eu\.org|paris\.eu\.org|pl\.eu\.org|pt\.eu\.org|q-a\.eu\.org|ro\.eu\.org|ru\.eu\.org|se\.eu\.org|si\.eu\.org|sk\.eu\.org|tr\.eu\.org|uk\.eu\.org|us\.eu\.org|eu-1\.evennode\.com|eu-2\.evennode\.com|us-1\.evennode\.com|us-2\.evennode\.com|apps\.fbsbx\.com|ru\.net|adygeya\.ru|bashkiria\.ru|bir\.ru|cbg\.ru|com\.ru|dagestan\.ru|grozny\.ru|kalmykia\.ru|kustanai\.ru|marine\.ru|mordovia\.ru|msk\.ru|mytis\.ru|nalchik\.ru|nov\.ru|pyatigorsk\.ru|spb\.ru|vladikavkaz\.ru|vladimir\.ru|abkhazia\.su|adygeya\.su|aktyubinsk\.su|arkhangelsk\.su|armenia\.su|ashgabad\.su|azerbaijan\.su|balashov\.su|bashkiria\.su|bryansk\.su|bukhara\.su|chimkent\.su|dagestan\.su|east-kazakhstan\.su|exnet\.su|georgia\.su|grozny\.su|ivanovo\.su|jambyl\.su|kalmykia\.su|kaluga\.su|karacol\.su|karaganda\.su|karelia\.su|khakassia\.su|krasnodar\.su|kurgan\.su|kustanai\.su|lenug\.su|mangyshlak\.su|mordovia\.su|msk\.su|murmansk\.su|nalchik\.su|navoi\.su|north-kazakhstan\.su|nov\.su|obninsk\.su|penza\.su|pokrovsk\.su|sochi\.su|spb\.su|tashkent\.su|termez\.su|togliatti\.su|troitsk\.su|tselinograd\.su|tula\.su|tuva\.su|vladikavkaz\.su|vladimir\.su|vologda\.su|map\.fastly\.net|a\.prod\.fastly\.net|global\.prod\.fastly\.net|a\.ssl\.fastly\.net|b\.ssl\.fastly\.net|global\.ssl\.fastly\.net|fastlylb\.net|map\.fastlylb\.net|fhapp\.xyz|firebaseapp\.com|flynnhub\.com|freebox-os\.com|freeboxos\.com|fbx-os\.fr|fbxos\.fr|freebox-os\.fr|freeboxos\.fr|myfusion\.cloud|futurehosting\.at|futuremailing\.at|[^.]+\.ex\.ortsinfo\.at|[^.]+\.kunden\.ortsinfo\.at|[^.]+\.statics\.cloud|service\.gov\.uk|github\.io|githubusercontent\.com|githubcloud\.com|[^.]+\.api\.githubcloud\.com|[^.]+\.ext\.githubcloud\.com|gist\.githubcloud\.com|[^.]+\.githubcloudusercontent\.com|gitlab\.io|homeoffice\.gov\.uk|ro\.im|shop\.ro|goip\.de|[^.]+\.0emm\.com|appspot\.com|blogspot\.ae|blogspot\.al|blogspot\.am|blogspot\.ba|blogspot\.be|blogspot\.bg|blogspot\.bj|blogspot\.ca|blogspot\.cf|blogspot\.ch|blogspot\.cl|blogspot\.co\.at|blogspot\.co\.id|blogspot\.co\.il|blogspot\.co\.ke|blogspot\.co\.nz|blogspot\.co\.uk|blogspot\.co\.za|blogspot\.com|blogspot\.com\.ar|blogspot\.com\.au|blogspot\.com\.br|blogspot\.com\.by|blogspot\.com\.co|blogspot\.com\.cy|blogspot\.com\.ee|blogspot\.com\.eg|blogspot\.com\.es|blogspot\.com\.mt|blogspot\.com\.ng|blogspot\.com\.tr|blogspot\.com\.uy|blogspot\.cv|blogspot\.cz|blogspot\.de|blogspot\.dk|blogspot\.fi|blogspot\.fr|blogspot\.gr|blogspot\.hk|blogspot\.hr|blogspot\.hu|blogspot\.ie|blogspot\.in|blogspot\.is|blogspot\.it|blogspot\.jp|blogspot\.kr|blogspot\.li|blogspot\.lt|blogspot\.lu|blogspot\.md|blogspot\.mk|blogspot\.mr|blogspot\.mx|blogspot\.my|blogspot\.nl|blogspot\.no|blogspot\.pe|blogspot\.pt|blogspot\.qa|blogspot\.re|blogspot\.ro|blogspot\.rs|blogspot\.ru|blogspot\.se|blogspot\.sg|blogspot\.si|blogspot\.sk|blogspot\.sn|blogspot\.td|blogspot\.tw|blogspot\.ug|blogspot\.vn|cloudfunctions\.net|codespot\.com|googleapis\.com|googlecode\.com|pagespeedmobilizer\.com|publishproxy\.com|withgoogle\.com|withyoutube\.com|hashbang\.sh|hasura-app\.io|hepforge\.org|herokuapp\.com|herokussl\.com|iki\.fi|biz\.at|info\.at|ac\.leg\.br|al\.leg\.br|am\.leg\.br|ap\.leg\.br|ba\.leg\.br|ce\.leg\.br|df\.leg\.br|es\.leg\.br|go\.leg\.br|ma\.leg\.br|mg\.leg\.br|ms\.leg\.br|mt\.leg\.br|pa\.leg\.br|pb\.leg\.br|pe\.leg\.br|pi\.leg\.br|pr\.leg\.br|rj\.leg\.br|rn\.leg\.br|ro\.leg\.br|rr\.leg\.br|rs\.leg\.br|sc\.leg\.br|se\.leg\.br|sp\.leg\.br|to\.leg\.br|[^.]+\.triton\.zone|[^.]+\.cns\.joyent\.com|js\.org|keymachine\.de|knightpoint\.systems|co\.krd|edu\.krd|[^.]+\.magentosite\.cloud|meteorapp\.com|eu\.meteorapp\.com|co\.pl|azurewebsites\.net|azure-mobile\.net|cloudapp\.net|bmoattachments\.org|4u\.com|ngrok\.io|nfshost\.com|nsupdate\.info|nerdpol\.ovh|blogsyte\.com|brasilia\.me|cable-modem\.org|ciscofreak\.com|collegefan\.org|couchpotatofries\.org|damnserver\.com|ddns\.me|ditchyourip\.com|dnsfor\.me|dnsiskinky\.com|dvrcam\.info|dynns\.com|eating-organic\.net|fantasyleague\.cc|geekgalaxy\.com|golffan\.us|health-carereform\.com|homesecuritymac\.com|homesecuritypc\.com|hopto\.me|ilovecollege\.info|loginto\.me|mlbfan\.org|mmafan\.biz|myactivedirectory\.com|mydissent\.net|myeffect\.net|mymediapc\.net|mypsx\.net|mysecuritycamera\.com|mysecuritycamera\.net|mysecuritycamera\.org|net-freaks\.com|nflfan\.org|nhlfan\.net|no-ip\.ca|no-ip\.co\.uk|no-ip\.net|noip\.us|onthewifi\.com|pgafan\.net|point2this\.com|pointto\.us|privatizehealthinsurance\.net|quicksytes\.com|read-books\.org|securitytactics\.com|serveexchange\.com|servehumour\.com|servep2p\.com|servesarcasm\.com|stufftoread\.com|ufcfan\.org|unusualperson\.com|workisboring\.com|3utilities\.com|bounceme\.net|ddns\.net|ddnsking\.com|gotdns\.ch|hopto\.org|myftp\.biz|myftp\.org|myvnc\.com|no-ip\.biz|no-ip\.info|no-ip\.org|noip\.me|redirectme\.net|servebeer\.com|serveblog\.net|servecounterstrike\.com|serveftp\.com|servegame\.com|servehalflife\.com|servehttp\.com|serveirc\.com|serveminecraft\.net|servemp3\.com|servepics\.com|servequake\.com|sytes\.net|webhop\.me|zapto\.org|nyc\.mn|nid\.io|opencraft\.hosting|operaunite\.com|outsystemscloud\.com|ownprovider\.com|oy\.lc|pgfog\.com|pagefrontapp\.com|art\.pl|gliwice\.pl|krakow\.pl|poznan\.pl|wroc\.pl|zakopane\.pl|pantheonsite\.io|gotpantheon\.com|mypep\.link|on-web\.fr|xen\.prgmr\.com|priv\.at|protonet\.io|chirurgiens-dentistes-en-france\.fr|qa2\.com|dev-myqnapcloud\.com|alpha-myqnapcloud\.com|myqnapcloud\.com|rackmaze\.com|rackmaze\.net|rhcloud\.com|hzc\.io|wellbeingzone\.eu|ptplus\.fit|wellbeingzone\.co\.uk|sandcats\.io|logoip\.de|logoip\.com|firewall-gateway\.com|firewall-gateway\.de|my-gateway\.de|my-router\.de|spdns\.de|spdns\.eu|firewall-gateway\.net|my-firewall\.org|myfirewall\.org|spdns\.org|biz\.ua|co\.ua|pp\.ua|shiftedit\.io|myshopblocks\.com|1kapp\.com|appchizi\.com|applinzi\.com|sinaapp\.com|vipsinaapp\.com|bounty-full\.com|alpha\.bounty-full\.com|beta\.bounty-full\.com|static\.land|dev\.static\.land|sites\.static\.land|apps\.lair\.io|[^.]+\.stolos\.io|spacekit\.io|stackspace\.space|diskstation\.me|dscloud\.biz|dscloud\.me|dscloud\.mobi|dsmynas\.com|dsmynas\.net|dsmynas\.org|familyds\.com|familyds\.net|familyds\.org|i234\.me|myds\.me|synology\.me|taifun-dns\.de|gda\.pl|gdansk\.pl|gdynia\.pl|med\.pl|sopot\.pl|bloxcms\.com|townnews-staging\.com|[^.]+\.transurl\.be|[^.]+\.transurl\.eu|[^.]+\.transurl\.nl|tuxfamily\.org|dd-dns\.de|diskstation\.eu|diskstation\.org|dray-dns\.de|draydns\.de|dyn-vpn\.de|dynvpn\.de|mein-vigor\.de|my-vigor\.de|my-wan\.de|syno-ds\.de|synology-diskstation\.de|synology-ds\.de|hk\.com|hk\.org|ltd\.hk|inc\.hk|lib\.de\.us|router\.management|remotewd\.com|wmflabs\.org|yolasite\.com|ybo\.faith|yombo\.me|homelink\.one|ybo\.party|ybo\.review|ybo\.science|ybo\.trade|za\.net|za\.org|now\.sh|cc\.ua|inf\.ua|ltd\.ua)$/;

/***/ }),

/***/ "../node_modules/process-nextick-args/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

if (!process.version ||
    process.version.indexOf('v0.') === 0 ||
    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  module.exports = nextTick;
} else {
  module.exports = process.nextTick;
}

function nextTick(fn, arg1, arg2, arg3) {
  if (typeof fn !== 'function') {
    throw new TypeError('"callback" argument must be a function');
  }
  var len = arguments.length;
  var args, i;
  switch (len) {
  case 0:
  case 1:
    return process.nextTick(fn);
  case 2:
    return process.nextTick(function afterTickOne() {
      fn.call(null, arg1);
    });
  case 3:
    return process.nextTick(function afterTickTwo() {
      fn.call(null, arg1, arg2);
    });
  case 4:
    return process.nextTick(function afterTickThree() {
      fn.call(null, arg1, arg2, arg3);
    });
  default:
    args = new Array(len - 1);
    i = 0;
    while (i < args.length) {
      args[i++] = arguments[i];
    }
    return process.nextTick(function afterTick() {
      fn.apply(null, args);
    });
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/process/browser.js")))

/***/ }),

/***/ "../node_modules/qs/lib/formats.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

module.exports = {
    'default': 'RFC3986',
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return value;
        }
    },
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};


/***/ }),

/***/ "../node_modules/qs/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var stringify = __webpack_require__("../node_modules/qs/lib/stringify.js");
var parse = __webpack_require__("../node_modules/qs/lib/parse.js");
var formats = __webpack_require__("../node_modules/qs/lib/formats.js");

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),

/***/ "../node_modules/qs/lib/parse.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("../node_modules/qs/lib/utils.js");

var has = Object.prototype.hasOwnProperty;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    arrayLimit: 20,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    parameterLimit: 1000,
    plainObjects: false,
    strictNullHandling: false
};

var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);

    for (var i = 0; i < parts.length; ++i) {
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder);
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder);
            val = options.decoder(part.slice(pos + 1), defaults.decoder);
        }
        if (has.call(obj, key)) {
            obj[key] = [].concat(obj[key]).concat(val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options) {
    var leaf = val;

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]') {
            obj = [];
            obj = obj.concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys
        // that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while ((segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options);
};

module.exports = function (str, opts) {
    var options = opts ? utils.assign({}, opts) : {};

    if (options.decoder !== null && options.decoder !== undefined && typeof options.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    options.ignoreQueryPrefix = options.ignoreQueryPrefix === true;
    options.delimiter = typeof options.delimiter === 'string' || utils.isRegExp(options.delimiter) ? options.delimiter : defaults.delimiter;
    options.depth = typeof options.depth === 'number' ? options.depth : defaults.depth;
    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : defaults.arrayLimit;
    options.parseArrays = options.parseArrays !== false;
    options.decoder = typeof options.decoder === 'function' ? options.decoder : defaults.decoder;
    options.allowDots = typeof options.allowDots === 'boolean' ? options.allowDots : defaults.allowDots;
    options.plainObjects = typeof options.plainObjects === 'boolean' ? options.plainObjects : defaults.plainObjects;
    options.allowPrototypes = typeof options.allowPrototypes === 'boolean' ? options.allowPrototypes : defaults.allowPrototypes;
    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : defaults.parameterLimit;
    options.strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options);
        obj = utils.merge(obj, newObj, options);
    }

    return utils.compact(obj);
};


/***/ }),

/***/ "../node_modules/qs/lib/stringify.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("../node_modules/qs/lib/utils.js");
var formats = __webpack_require__("../node_modules/qs/lib/formats.js");

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) { // eslint-disable-line func-name-matching
        return prefix + '[]';
    },
    indices: function indices(prefix, key) { // eslint-disable-line func-name-matching
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) { // eslint-disable-line func-name-matching
        return prefix;
    }
};

var toISO = Date.prototype.toISOString;

var defaults = {
    delimiter: '&',
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    serializeDate: function serializeDate(date) { // eslint-disable-line func-name-matching
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var stringify = function stringify( // eslint-disable-line func-name-matching
    object,
    prefix,
    generateArrayPrefix,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    formatter,
    encodeValuesOnly
) {
    var obj = object;
    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder) : prefix;
        }

        obj = '';
    }

    if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean' || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (Array.isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (skipNulls && obj[key] === null) {
            continue;
        }

        if (Array.isArray(obj)) {
            values = values.concat(stringify(
                obj[key],
                generateArrayPrefix(prefix, key),
                generateArrayPrefix,
                strictNullHandling,
                skipNulls,
                encoder,
                filter,
                sort,
                allowDots,
                serializeDate,
                formatter,
                encodeValuesOnly
            ));
        } else {
            values = values.concat(stringify(
                obj[key],
                prefix + (allowDots ? '.' + key : '[' + key + ']'),
                generateArrayPrefix,
                strictNullHandling,
                skipNulls,
                encoder,
                filter,
                sort,
                allowDots,
                serializeDate,
                formatter,
                encodeValuesOnly
            ));
        }
    }

    return values;
};

module.exports = function (object, opts) {
    var obj = object;
    var options = opts ? utils.assign({}, opts) : {};

    if (options.encoder !== null && options.encoder !== undefined && typeof options.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var delimiter = typeof options.delimiter === 'undefined' ? defaults.delimiter : options.delimiter;
    var strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;
    var skipNulls = typeof options.skipNulls === 'boolean' ? options.skipNulls : defaults.skipNulls;
    var encode = typeof options.encode === 'boolean' ? options.encode : defaults.encode;
    var encoder = typeof options.encoder === 'function' ? options.encoder : defaults.encoder;
    var sort = typeof options.sort === 'function' ? options.sort : null;
    var allowDots = typeof options.allowDots === 'undefined' ? false : options.allowDots;
    var serializeDate = typeof options.serializeDate === 'function' ? options.serializeDate : defaults.serializeDate;
    var encodeValuesOnly = typeof options.encodeValuesOnly === 'boolean' ? options.encodeValuesOnly : defaults.encodeValuesOnly;
    if (typeof options.format === 'undefined') {
        options.format = formats['default'];
    } else if (!Object.prototype.hasOwnProperty.call(formats.formatters, options.format)) {
        throw new TypeError('Unknown format option provided.');
    }
    var formatter = formats.formatters[options.format];
    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (Array.isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (options.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = options.arrayFormat;
    } else if ('indices' in options) {
        arrayFormat = options.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (sort) {
        objKeys.sort(sort);
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (skipNulls && obj[key] === null) {
            continue;
        }

        keys = keys.concat(stringify(
            obj[key],
            key,
            generateArrayPrefix,
            strictNullHandling,
            skipNulls,
            encode ? encoder : null,
            filter,
            sort,
            allowDots,
            serializeDate,
            formatter,
            encodeValuesOnly
        ));
    }

    var joined = keys.join(delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),

/***/ "../node_modules/qs/lib/utils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    var obj;

    while (queue.length) {
        var item = queue.pop();
        obj = item.obj[item.prop];

        if (Array.isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }

    return obj;
};

exports.arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

exports.merge = function merge(target, source, options) {
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (Array.isArray(target)) {
            target.push(source);
        } else if (typeof target === 'object') {
            if (options.plainObjects || options.allowPrototypes || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (Array.isArray(target) && !Array.isArray(source)) {
        mergeTarget = exports.arrayToObject(target, options);
    }

    if (Array.isArray(target) && Array.isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                if (target[i] && typeof target[i] === 'object') {
                    target[i] = exports.merge(target[i], item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = exports.merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

exports.assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

exports.decode = function (str) {
    try {
        return decodeURIComponent(str.replace(/\+/g, ' '));
    } catch (e) {
        return str;
    }
};

exports.encode = function encode(str) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = typeof str === 'string' ? str : String(str);

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

exports.compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    return compactQueue(queue);
};

exports.isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

exports.isBuffer = function isBuffer(obj) {
    if (obj === null || typeof obj === 'undefined') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};


/***/ }),

/***/ "../node_modules/query-string/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__("../node_modules/strict-uri-encode/index.js");
var objectAssign = __webpack_require__("../node_modules/object-assign/index.js");

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),

/***/ "../node_modules/querystringify/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty;

/**
 * Decode a URI encoded string.
 *
 * @param {String} input The URI encoded string.
 * @returns {String} The decoded string.
 * @api private
 */
function decode(input) {
  return decodeURIComponent(input.replace(/\+/g, ' '));
}

/**
 * Simple query string parser.
 *
 * @param {String} query The query string that needs to be parsed.
 * @returns {Object}
 * @api public
 */
function querystring(query) {
  var parser = /([^=?&]+)=?([^&]*)/g
    , result = {}
    , part;

  //
  // Little nifty parsing hack, leverage the fact that RegExp.exec increments
  // the lastIndex property so we can continue executing this loop until we've
  // parsed all results.
  //
  for (;
    part = parser.exec(query);
    result[decode(part[1])] = decode(part[2])
  );

  return result;
}

/**
 * Transform a query string to an object.
 *
 * @param {Object} obj Object that should be transformed.
 * @param {String} prefix Optional prefix.
 * @returns {String}
 * @api public
 */
function querystringify(obj, prefix) {
  prefix = prefix || '';

  var pairs = [];

  //
  // Optionally prefix with a '?' if needed
  //
  if ('string' !== typeof prefix) prefix = '?';

  for (var key in obj) {
    if (has.call(obj, key)) {
      pairs.push(encodeURIComponent(key) +'='+ encodeURIComponent(obj[key]));
    }
  }

  return pairs.length ? prefix + pairs.join('&') : '';
}

//
// Expose the module.
//
exports.stringify = querystringify;
exports.parse = querystring;


/***/ }),

/***/ "../node_modules/react-autosize-textarea/lib/TextareaAutosize.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _autosize = __webpack_require__("../node_modules/autosize/dist/autosize.js");

var _autosize2 = _interopRequireDefault(_autosize);

var _lineHeight = __webpack_require__("../node_modules/line-height/lib/line-height.js");

var _lineHeight2 = _interopRequireDefault(_lineHeight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UPDATE = 'autosize:update',
    DESTROY = 'autosize:destroy',
    RESIZED = 'autosize:resized';

/** A light replacement for built-in textarea component
 * which automaticaly adjusts its height to match the content
 * @param onResize - called whenever the textarea resizes
 * @param rows - minimum number of visible rows
 * @param maxRows - maximum number of visible rows
 * @param innerRef - called with the ref to the DOM node
 */
var TextareaAutosize = (_temp2 = _class = function (_React$Component) {
  _inherits(TextareaAutosize, _React$Component);

  function TextareaAutosize() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TextareaAutosize);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TextareaAutosize.__proto__ || Object.getPrototypeOf(TextareaAutosize)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      lineHeight: null
    }, _this.dispatchEvent = function (EVENT_TYPE) {
      var event = document.createEvent('Event');
      event.initEvent(EVENT_TYPE, true, false);

      _this.textarea.dispatchEvent(event);
    }, _this.getValue = function (_ref2) {
      var valueLink = _ref2.valueLink,
          value = _ref2.value;
      return valueLink ? valueLink.value : value;
    }, _this.updateLineHeight = function () {
      _this.setState({
        lineHeight: (0, _lineHeight2.default)(_this.textarea)
      });
    }, _this.onChange = function (e) {
      _this.currentValue = e.target.value;
      _this.props.onChange && _this.props.onChange(e);
    }, _this.saveDOMNodeRef = function (ref) {
      var innerRef = _this.props.innerRef;


      if (innerRef) {
        innerRef(ref);
      }

      _this.textarea = ref;
    }, _this.getLocals = function () {
      var _this2 = _this,
          _this2$props = _this2.props,
          onResize = _this2$props.onResize,
          maxRows = _this2$props.maxRows,
          onChange = _this2$props.onChange,
          style = _this2$props.style,
          innerRef = _this2$props.innerRef,
          props = _objectWithoutProperties(_this2$props, ['onResize', 'maxRows', 'onChange', 'style', 'innerRef']),
          lineHeight = _this2.state.lineHeight,
          saveDOMNodeRef = _this2.saveDOMNodeRef;

      var maxHeight = maxRows && lineHeight ? lineHeight * maxRows : null;

      return _extends({}, props, {
        saveDOMNodeRef: saveDOMNodeRef,
        style: maxHeight ? _extends({}, style, { maxHeight: maxHeight }) : style,
        onChange: _this.onChange
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TextareaAutosize, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this3 = this;

      var _props = this.props,
          onResize = _props.onResize,
          maxRows = _props.maxRows;


      if (typeof maxRows === 'number') {
        this.updateLineHeight();

        // this trick is needed to force "autosize" to activate the scrollbar
        setTimeout(function () {
          return (0, _autosize2.default)(_this3.textarea);
        });
      } else {
        (0, _autosize2.default)(this.textarea);
      }

      if (onResize) {
        this.textarea.addEventListener(RESIZED, this.props.onResize);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.onResize) {
        this.textarea.removeEventListener(RESIZED, this.props.onResize);
      }
      this.dispatchEvent(DESTROY);
    }
  }, {
    key: 'render',
    value: function render() {
      var _getLocals = this.getLocals(),
          children = _getLocals.children,
          saveDOMNodeRef = _getLocals.saveDOMNodeRef,
          locals = _objectWithoutProperties(_getLocals, ['children', 'saveDOMNodeRef']);

      return _react2.default.createElement(
        'textarea',
        _extends({}, locals, { ref: saveDOMNodeRef }),
        children
      );
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.getValue(this.props) !== this.currentValue) {
        this.dispatchEvent(UPDATE);
      }
    }
  }]);

  return TextareaAutosize;
}(_react2.default.Component), _class.defaultProps = {
  rows: 1
}, _temp2);
exports.default = TextareaAutosize;


TextareaAutosize.propTypes = {
  rows: _propTypes2.default.number,
  maxRows: _propTypes2.default.number,
  onResize: _propTypes2.default.func,
  innerRef: _propTypes2.default.func
};

/***/ }),

/***/ "../node_modules/react-autosize-textarea/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _TextareaAutosize = __webpack_require__("../node_modules/react-autosize-textarea/lib/TextareaAutosize.js");

var _TextareaAutosize2 = _interopRequireDefault(_TextareaAutosize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _TextareaAutosize2.default;

/***/ }),

/***/ "../node_modules/react-autosuggest/dist/Autosuggest.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _arrays = __webpack_require__("../node_modules/shallow-equal/arrays/index.js");

var _arrays2 = _interopRequireDefault(_arrays);

var _reactAutowhatever = __webpack_require__("../node_modules/react-autowhatever/dist/index.js");

var _reactAutowhatever2 = _interopRequireDefault(_reactAutowhatever);

var _theme = __webpack_require__("../node_modules/react-autosuggest/dist/theme.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var alwaysTrue = function alwaysTrue() {
  return true;
};
var defaultShouldRenderSuggestions = function defaultShouldRenderSuggestions(value) {
  return value.trim().length > 0;
};
var defaultRenderSuggestionsContainer = function defaultRenderSuggestionsContainer(_ref) {
  var containerProps = _ref.containerProps,
      children = _ref.children;
  return _react2.default.createElement(
    'div',
    containerProps,
    children
  );
};

var Autosuggest = function (_Component) {
  _inherits(Autosuggest, _Component);

  function Autosuggest(_ref2) {
    var alwaysRenderSuggestions = _ref2.alwaysRenderSuggestions;

    _classCallCheck(this, Autosuggest);

    var _this = _possibleConstructorReturn(this, (Autosuggest.__proto__ || Object.getPrototypeOf(Autosuggest)).call(this));

    _initialiseProps.call(_this);

    _this.state = {
      isFocused: false,
      isCollapsed: !alwaysRenderSuggestions,
      highlightedSectionIndex: null,
      highlightedSuggestionIndex: null,
      valueBeforeUpDown: null
    };

    _this.justPressedUpDown = false;
    return _this;
  }

  _createClass(Autosuggest, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.onDocumentMouseDown);

      this.input = this.autowhatever.input;
      this.suggestionsContainer = this.autowhatever.itemsContainer;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if ((0, _arrays2.default)(nextProps.suggestions, this.props.suggestions)) {
        if (nextProps.highlightFirstSuggestion && nextProps.suggestions.length > 0 && this.justPressedUpDown === false) {
          this.highlightFirstSuggestion();
        }
      } else {
        if (this.willRenderSuggestions(nextProps)) {
          if (nextProps.highlightFirstSuggestion) {
            this.highlightFirstSuggestion();
          }

          if (this.state.isCollapsed && !this.justSelectedSuggestion) {
            this.revealSuggestions();
          }
        } else {
          this.resetHighlightedSuggestion();
        }
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var onSuggestionHighlighted = this.props.onSuggestionHighlighted;


      if (!onSuggestionHighlighted) {
        return;
      }

      var _state = this.state,
          highlightedSectionIndex = _state.highlightedSectionIndex,
          highlightedSuggestionIndex = _state.highlightedSuggestionIndex;


      if (highlightedSectionIndex !== prevState.highlightedSectionIndex || highlightedSuggestionIndex !== prevState.highlightedSuggestionIndex) {
        var suggestion = this.getHighlightedSuggestion();

        onSuggestionHighlighted({ suggestion: suggestion });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.onDocumentMouseDown);
    }
  }, {
    key: 'updateHighlightedSuggestion',
    value: function updateHighlightedSuggestion(sectionIndex, suggestionIndex, prevValue) {
      this.setState(function (state) {
        var valueBeforeUpDown = state.valueBeforeUpDown;


        if (suggestionIndex === null) {
          valueBeforeUpDown = null;
        } else if (valueBeforeUpDown === null && typeof prevValue !== 'undefined') {
          valueBeforeUpDown = prevValue;
        }

        return {
          highlightedSectionIndex: sectionIndex,
          highlightedSuggestionIndex: suggestionIndex,
          valueBeforeUpDown: valueBeforeUpDown
        };
      });
    }
  }, {
    key: 'resetHighlightedSuggestion',
    value: function resetHighlightedSuggestion() {
      var shouldResetValueBeforeUpDown = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.setState(function (state) {
        var valueBeforeUpDown = state.valueBeforeUpDown;


        return {
          highlightedSectionIndex: null,
          highlightedSuggestionIndex: null,
          valueBeforeUpDown: shouldResetValueBeforeUpDown ? null : valueBeforeUpDown
        };
      });
    }
  }, {
    key: 'revealSuggestions',
    value: function revealSuggestions() {
      this.setState({
        isCollapsed: false
      });
    }
  }, {
    key: 'closeSuggestions',
    value: function closeSuggestions() {
      this.setState({
        highlightedSectionIndex: null,
        highlightedSuggestionIndex: null,
        valueBeforeUpDown: null,
        isCollapsed: true
      });
    }
  }, {
    key: 'getSuggestion',
    value: function getSuggestion(sectionIndex, suggestionIndex) {
      var _props = this.props,
          suggestions = _props.suggestions,
          multiSection = _props.multiSection,
          getSectionSuggestions = _props.getSectionSuggestions;


      if (multiSection) {
        return getSectionSuggestions(suggestions[sectionIndex])[suggestionIndex];
      }

      return suggestions[suggestionIndex];
    }
  }, {
    key: 'getHighlightedSuggestion',
    value: function getHighlightedSuggestion() {
      var _state2 = this.state,
          highlightedSectionIndex = _state2.highlightedSectionIndex,
          highlightedSuggestionIndex = _state2.highlightedSuggestionIndex;


      if (highlightedSuggestionIndex === null) {
        return null;
      }

      return this.getSuggestion(highlightedSectionIndex, highlightedSuggestionIndex);
    }
  }, {
    key: 'getSuggestionValueByIndex',
    value: function getSuggestionValueByIndex(sectionIndex, suggestionIndex) {
      var getSuggestionValue = this.props.getSuggestionValue;


      return getSuggestionValue(this.getSuggestion(sectionIndex, suggestionIndex));
    }
  }, {
    key: 'getSuggestionIndices',
    value: function getSuggestionIndices(suggestionElement) {
      var sectionIndex = suggestionElement.getAttribute('data-section-index');
      var suggestionIndex = suggestionElement.getAttribute('data-suggestion-index');

      return {
        sectionIndex: typeof sectionIndex === 'string' ? parseInt(sectionIndex, 10) : null,
        suggestionIndex: parseInt(suggestionIndex, 10)
      };
    }
  }, {
    key: 'findSuggestionElement',
    value: function findSuggestionElement(startNode) {
      var node = startNode;

      do {
        if (node.getAttribute('data-suggestion-index') !== null) {
          return node;
        }

        node = node.parentNode;
      } while (node !== null);

      console.error('Clicked element:', startNode); // eslint-disable-line no-console
      throw new Error("Couldn't find suggestion element");
    }
  }, {
    key: 'maybeCallOnChange',
    value: function maybeCallOnChange(event, newValue, method) {
      var _props$inputProps = this.props.inputProps,
          value = _props$inputProps.value,
          onChange = _props$inputProps.onChange;


      if (newValue !== value) {
        onChange(event, { newValue: newValue, method: method });
      }
    }
  }, {
    key: 'willRenderSuggestions',
    value: function willRenderSuggestions(props) {
      var suggestions = props.suggestions,
          inputProps = props.inputProps,
          shouldRenderSuggestions = props.shouldRenderSuggestions;
      var value = inputProps.value;


      return suggestions.length > 0 && shouldRenderSuggestions(value);
    }
  }, {
    key: 'getQuery',
    value: function getQuery() {
      var inputProps = this.props.inputProps;
      var value = inputProps.value;
      var valueBeforeUpDown = this.state.valueBeforeUpDown;


      return (valueBeforeUpDown || value).trim();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          suggestions = _props2.suggestions,
          renderInputComponent = _props2.renderInputComponent,
          onSuggestionsFetchRequested = _props2.onSuggestionsFetchRequested,
          renderSuggestion = _props2.renderSuggestion,
          inputProps = _props2.inputProps,
          multiSection = _props2.multiSection,
          renderSectionTitle = _props2.renderSectionTitle,
          id = _props2.id,
          getSectionSuggestions = _props2.getSectionSuggestions,
          theme = _props2.theme,
          getSuggestionValue = _props2.getSuggestionValue,
          alwaysRenderSuggestions = _props2.alwaysRenderSuggestions;
      var _state3 = this.state,
          isFocused = _state3.isFocused,
          isCollapsed = _state3.isCollapsed,
          highlightedSectionIndex = _state3.highlightedSectionIndex,
          highlightedSuggestionIndex = _state3.highlightedSuggestionIndex,
          valueBeforeUpDown = _state3.valueBeforeUpDown;

      var shouldRenderSuggestions = alwaysRenderSuggestions ? alwaysTrue : this.props.shouldRenderSuggestions;
      var value = inputProps.value,
          _onFocus = inputProps.onFocus,
          _onKeyDown = inputProps.onKeyDown;

      var willRenderSuggestions = this.willRenderSuggestions(this.props);
      var isOpen = alwaysRenderSuggestions || isFocused && !isCollapsed && willRenderSuggestions;
      var items = isOpen ? suggestions : [];
      var autowhateverInputProps = _extends({}, inputProps, {
        onFocus: function onFocus(event) {
          if (!_this2.justSelectedSuggestion && !_this2.justClickedOnSuggestionsContainer) {
            var shouldRender = shouldRenderSuggestions(value);

            _this2.setState({
              isFocused: true,
              isCollapsed: !shouldRender
            });

            _onFocus && _onFocus(event);

            if (shouldRender) {
              onSuggestionsFetchRequested({ value: value, reason: 'input-focused' });
            }
          }
        },
        onBlur: function onBlur(event) {
          if (_this2.justClickedOnSuggestionsContainer) {
            _this2.input.focus();
            return;
          }

          _this2.blurEvent = event;

          if (!_this2.justSelectedSuggestion) {
            _this2.onBlur();
            _this2.onSuggestionsClearRequested();
          }
        },
        onChange: function onChange(event) {
          var value = event.target.value;

          var shouldRender = shouldRenderSuggestions(value);

          _this2.maybeCallOnChange(event, value, 'type');

          _this2.setState({
            highlightedSectionIndex: null,
            highlightedSuggestionIndex: null,
            valueBeforeUpDown: null,
            isCollapsed: !shouldRender
          });

          if (shouldRender) {
            onSuggestionsFetchRequested({ value: value, reason: 'input-changed' });
          } else {
            _this2.onSuggestionsClearRequested();
          }
        },
        onKeyDown: function onKeyDown(event, data) {
          var keyCode = event.keyCode;


          switch (keyCode) {
            case 40: // ArrowDown
            case 38:
              // ArrowUp
              if (isCollapsed) {
                if (shouldRenderSuggestions(value)) {
                  onSuggestionsFetchRequested({
                    value: value,
                    reason: 'suggestions-revealed'
                  });
                  _this2.revealSuggestions();
                }
              } else if (suggestions.length > 0) {
                var newHighlightedSectionIndex = data.newHighlightedSectionIndex,
                    newHighlightedItemIndex = data.newHighlightedItemIndex;


                var newValue = void 0;

                if (newHighlightedItemIndex === null) {
                  // valueBeforeUpDown can be null if, for example, user
                  // hovers on the first suggestion and then pressed Up.
                  // If that happens, use the original input value.
                  newValue = valueBeforeUpDown === null ? value : valueBeforeUpDown;
                } else {
                  newValue = _this2.getSuggestionValueByIndex(newHighlightedSectionIndex, newHighlightedItemIndex);
                }

                _this2.updateHighlightedSuggestion(newHighlightedSectionIndex, newHighlightedItemIndex, value);
                _this2.maybeCallOnChange(event, newValue, keyCode === 40 ? 'down' : 'up');
              }

              event.preventDefault(); // Prevents the cursor from moving

              _this2.justPressedUpDown = true;

              setTimeout(function () {
                _this2.justPressedUpDown = false;
              });

              break;

            // Enter
            case 13:
              {
                // See #388
                if (event.keyCode === 229) {
                  break;
                }

                var highlightedSuggestion = _this2.getHighlightedSuggestion();

                if (isOpen && !alwaysRenderSuggestions) {
                  _this2.closeSuggestions();
                }

                if (highlightedSuggestion !== null) {
                  var _newValue = getSuggestionValue(highlightedSuggestion);

                  _this2.maybeCallOnChange(event, _newValue, 'enter');

                  _this2.onSuggestionSelected(event, {
                    suggestion: highlightedSuggestion,
                    suggestionValue: _newValue,
                    suggestionIndex: highlightedSuggestionIndex,
                    sectionIndex: highlightedSectionIndex,
                    method: 'enter'
                  });

                  _this2.justSelectedSuggestion = true;

                  setTimeout(function () {
                    _this2.justSelectedSuggestion = false;
                  });
                }

                break;
              }

            // Escape
            case 27:
              {
                if (isOpen) {
                  // If input.type === 'search', the browser clears the input
                  // when Escape is pressed. We want to disable this default
                  // behaviour so that, when suggestions are shown, we just hide
                  // them, without clearing the input.
                  event.preventDefault();
                }

                var willCloseSuggestions = isOpen && !alwaysRenderSuggestions;

                if (valueBeforeUpDown === null) {
                  // Didn't interact with Up/Down
                  if (!willCloseSuggestions) {
                    var _newValue2 = '';

                    _this2.maybeCallOnChange(event, _newValue2, 'escape');

                    if (shouldRenderSuggestions(_newValue2)) {
                      onSuggestionsFetchRequested({
                        value: _newValue2,
                        reason: 'escape-pressed'
                      });
                    } else {
                      _this2.onSuggestionsClearRequested();
                    }
                  }
                } else {
                  // Interacted with Up/Down
                  _this2.maybeCallOnChange(event, valueBeforeUpDown, 'escape');
                }

                if (willCloseSuggestions) {
                  _this2.onSuggestionsClearRequested();
                  _this2.closeSuggestions();
                } else {
                  _this2.resetHighlightedSuggestion();
                }

                break;
              }
          }

          _onKeyDown && _onKeyDown(event);
        }
      });
      var renderSuggestionData = {
        query: this.getQuery()
      };

      return _react2.default.createElement(_reactAutowhatever2.default, {
        multiSection: multiSection,
        items: items,
        renderInputComponent: renderInputComponent,
        renderItemsContainer: this.renderSuggestionsContainer,
        renderItem: renderSuggestion,
        renderItemData: renderSuggestionData,
        renderSectionTitle: renderSectionTitle,
        getSectionItems: getSectionSuggestions,
        highlightedSectionIndex: highlightedSectionIndex,
        highlightedItemIndex: highlightedSuggestionIndex,
        inputProps: autowhateverInputProps,
        itemProps: this.itemProps,
        theme: (0, _theme.mapToAutowhateverTheme)(theme),
        id: id,
        ref: this.storeAutowhateverRef
      });
    }
  }]);

  return Autosuggest;
}(_react.Component);

Autosuggest.propTypes = {
  suggestions: _propTypes2.default.array.isRequired,
  onSuggestionsFetchRequested: function onSuggestionsFetchRequested(props, propName) {
    var onSuggestionsFetchRequested = props[propName];

    if (typeof onSuggestionsFetchRequested !== 'function') {
      throw new Error("'onSuggestionsFetchRequested' must be implemented. See: https://github.com/moroshko/react-autosuggest#onSuggestionsFetchRequestedProp");
    }
  },
  onSuggestionsClearRequested: function onSuggestionsClearRequested(props, propName) {
    var onSuggestionsClearRequested = props[propName];

    if (props.alwaysRenderSuggestions === false && typeof onSuggestionsClearRequested !== 'function') {
      throw new Error("'onSuggestionsClearRequested' must be implemented. See: https://github.com/moroshko/react-autosuggest#onSuggestionsClearRequestedProp");
    }
  },
  onSuggestionSelected: _propTypes2.default.func,
  onSuggestionHighlighted: _propTypes2.default.func,
  renderInputComponent: _propTypes2.default.func,
  renderSuggestionsContainer: _propTypes2.default.func,
  getSuggestionValue: _propTypes2.default.func.isRequired,
  renderSuggestion: _propTypes2.default.func.isRequired,
  inputProps: function inputProps(props, propName) {
    var inputProps = props[propName];

    if (!inputProps.hasOwnProperty('value')) {
      throw new Error("'inputProps' must have 'value'.");
    }

    if (!inputProps.hasOwnProperty('onChange')) {
      throw new Error("'inputProps' must have 'onChange'.");
    }
  },
  shouldRenderSuggestions: _propTypes2.default.func,
  alwaysRenderSuggestions: _propTypes2.default.bool,
  multiSection: _propTypes2.default.bool,
  renderSectionTitle: function renderSectionTitle(props, propName) {
    var renderSectionTitle = props[propName];

    if (props.multiSection === true && typeof renderSectionTitle !== 'function') {
      throw new Error("'renderSectionTitle' must be implemented. See: https://github.com/moroshko/react-autosuggest#renderSectionTitleProp");
    }
  },
  getSectionSuggestions: function getSectionSuggestions(props, propName) {
    var getSectionSuggestions = props[propName];

    if (props.multiSection === true && typeof getSectionSuggestions !== 'function') {
      throw new Error("'getSectionSuggestions' must be implemented. See: https://github.com/moroshko/react-autosuggest#getSectionSuggestionsProp");
    }
  },
  focusInputOnSuggestionClick: _propTypes2.default.bool,
  highlightFirstSuggestion: _propTypes2.default.bool,
  theme: _propTypes2.default.object,
  id: _propTypes2.default.string
};
Autosuggest.defaultProps = {
  renderSuggestionsContainer: defaultRenderSuggestionsContainer,
  shouldRenderSuggestions: defaultShouldRenderSuggestions,
  alwaysRenderSuggestions: false,
  multiSection: false,
  focusInputOnSuggestionClick: true,
  highlightFirstSuggestion: false,
  theme: _theme.defaultTheme,
  id: '1'
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onDocumentMouseDown = function (event) {
    _this3.justClickedOnSuggestionsContainer = false;

    var node = event.detail && event.detail.target || // This is for testing only. Please show me a better way to emulate this.
    event.target;

    while (node !== null && node !== document) {
      if (node.getAttribute('data-suggestion-index') !== null) {
        // Suggestion was clicked
        return;
      }

      if (node === _this3.suggestionsContainer) {
        // Something else inside suggestions container was clicked
        _this3.justClickedOnSuggestionsContainer = true;
        return;
      }

      node = node.parentNode;
    }
  };

  this.storeAutowhateverRef = function (autowhatever) {
    if (autowhatever !== null) {
      _this3.autowhatever = autowhatever;
    }
  };

  this.onSuggestionMouseEnter = function (event, _ref3) {
    var sectionIndex = _ref3.sectionIndex,
        itemIndex = _ref3.itemIndex;

    _this3.updateHighlightedSuggestion(sectionIndex, itemIndex);
  };

  this.highlightFirstSuggestion = function () {
    _this3.updateHighlightedSuggestion(_this3.props.multiSection ? 0 : null, 0);
  };

  this.onSuggestionMouseDown = function () {
    _this3.justSelectedSuggestion = true;
  };

  this.onSuggestionsClearRequested = function () {
    var onSuggestionsClearRequested = _this3.props.onSuggestionsClearRequested;


    onSuggestionsClearRequested && onSuggestionsClearRequested();
  };

  this.onSuggestionSelected = function (event, data) {
    var _props3 = _this3.props,
        alwaysRenderSuggestions = _props3.alwaysRenderSuggestions,
        onSuggestionSelected = _props3.onSuggestionSelected,
        onSuggestionsFetchRequested = _props3.onSuggestionsFetchRequested;


    onSuggestionSelected && onSuggestionSelected(event, data);

    if (alwaysRenderSuggestions) {
      onSuggestionsFetchRequested({
        value: data.suggestionValue,
        reason: 'suggestion-selected'
      });
    } else {
      _this3.onSuggestionsClearRequested();
    }

    _this3.resetHighlightedSuggestion();
  };

  this.onSuggestionClick = function (event) {
    var _props4 = _this3.props,
        alwaysRenderSuggestions = _props4.alwaysRenderSuggestions,
        focusInputOnSuggestionClick = _props4.focusInputOnSuggestionClick;

    var _getSuggestionIndices = _this3.getSuggestionIndices(_this3.findSuggestionElement(event.target)),
        sectionIndex = _getSuggestionIndices.sectionIndex,
        suggestionIndex = _getSuggestionIndices.suggestionIndex;

    var clickedSuggestion = _this3.getSuggestion(sectionIndex, suggestionIndex);
    var clickedSuggestionValue = _this3.props.getSuggestionValue(clickedSuggestion);

    _this3.maybeCallOnChange(event, clickedSuggestionValue, 'click');
    _this3.onSuggestionSelected(event, {
      suggestion: clickedSuggestion,
      suggestionValue: clickedSuggestionValue,
      suggestionIndex: suggestionIndex,
      sectionIndex: sectionIndex,
      method: 'click'
    });

    if (!alwaysRenderSuggestions) {
      _this3.closeSuggestions();
    }

    if (focusInputOnSuggestionClick === true) {
      _this3.input.focus();
    } else {
      _this3.onBlur();
    }

    setTimeout(function () {
      _this3.justSelectedSuggestion = false;
    });
  };

  this.onBlur = function () {
    var _props5 = _this3.props,
        inputProps = _props5.inputProps,
        shouldRenderSuggestions = _props5.shouldRenderSuggestions;
    var value = inputProps.value,
        onBlur = inputProps.onBlur;

    var highlightedSuggestion = _this3.getHighlightedSuggestion();
    var shouldRender = shouldRenderSuggestions(value);

    _this3.setState({
      isFocused: false,
      highlightedSectionIndex: null,
      highlightedSuggestionIndex: null,
      valueBeforeUpDown: null,
      isCollapsed: !shouldRender
    });

    onBlur && onBlur(_this3.blurEvent, { highlightedSuggestion: highlightedSuggestion });
  };

  this.resetHighlightedSuggestionOnMouseLeave = function () {
    _this3.resetHighlightedSuggestion(false); // shouldResetValueBeforeUpDown
  };

  this.itemProps = function (_ref4) {
    var sectionIndex = _ref4.sectionIndex,
        itemIndex = _ref4.itemIndex;

    return {
      'data-section-index': sectionIndex,
      'data-suggestion-index': itemIndex,
      onMouseEnter: _this3.onSuggestionMouseEnter,
      onMouseLeave: _this3.resetHighlightedSuggestionOnMouseLeave,
      onMouseDown: _this3.onSuggestionMouseDown,
      onTouchStart: _this3.onSuggestionMouseDown, // Because on iOS `onMouseDown` is not triggered
      onClick: _this3.onSuggestionClick
    };
  };

  this.renderSuggestionsContainer = function (_ref5) {
    var containerProps = _ref5.containerProps,
        children = _ref5.children;
    var renderSuggestionsContainer = _this3.props.renderSuggestionsContainer;


    return renderSuggestionsContainer({
      containerProps: containerProps,
      children: children,
      query: _this3.getQuery()
    });
  };
};

exports.default = Autosuggest;

/***/ }),

/***/ "../node_modules/react-autosuggest/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__("../node_modules/react-autosuggest/dist/Autosuggest.js").default;

/***/ }),

/***/ "../node_modules/react-autosuggest/dist/theme.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var defaultTheme = exports.defaultTheme = {
  container: 'react-autosuggest__container',
  containerOpen: 'react-autosuggest__container--open',
  input: 'react-autosuggest__input',
  inputOpen: 'react-autosuggest__input--open',
  inputFocused: 'react-autosuggest__input--focused',
  suggestionsContainer: 'react-autosuggest__suggestions-container',
  suggestionsContainerOpen: 'react-autosuggest__suggestions-container--open',
  suggestionsList: 'react-autosuggest__suggestions-list',
  suggestion: 'react-autosuggest__suggestion',
  suggestionFirst: 'react-autosuggest__suggestion--first',
  suggestionHighlighted: 'react-autosuggest__suggestion--highlighted',
  sectionContainer: 'react-autosuggest__section-container',
  sectionContainerFirst: 'react-autosuggest__section-container--first',
  sectionTitle: 'react-autosuggest__section-title'
};

var mapToAutowhateverTheme = exports.mapToAutowhateverTheme = function mapToAutowhateverTheme(theme) {
  var result = {};

  for (var key in theme) {
    switch (key) {
      case 'suggestionsContainer':
        result['itemsContainer'] = theme[key];
        break;

      case 'suggestionsContainerOpen':
        result['itemsContainerOpen'] = theme[key];
        break;

      case 'suggestion':
        result['item'] = theme[key];
        break;

      case 'suggestionFirst':
        result['itemFirst'] = theme[key];
        break;

      case 'suggestionHighlighted':
        result['itemHighlighted'] = theme[key];
        break;

      case 'suggestionsList':
        result['itemsList'] = theme[key];
        break;

      default:
        result[key] = theme[key];
    }
  }

  return result;
};

/***/ }),

/***/ "../node_modules/react-autowhatever/dist/Autowhatever.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _sectionIterator = __webpack_require__("../node_modules/section-iterator/dist/index.js");

var _sectionIterator2 = _interopRequireDefault(_sectionIterator);

var _reactThemeable = __webpack_require__("../node_modules/react-themeable/dist/index.js");

var _reactThemeable2 = _interopRequireDefault(_reactThemeable);

var _SectionTitle = __webpack_require__("../node_modules/react-autowhatever/dist/SectionTitle.js");

var _SectionTitle2 = _interopRequireDefault(_SectionTitle);

var _ItemsList = __webpack_require__("../node_modules/react-autowhatever/dist/ItemsList.js");

var _ItemsList2 = _interopRequireDefault(_ItemsList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var emptyObject = {};
var defaultRenderInputComponent = function defaultRenderInputComponent(props) {
  return _react2.default.createElement('input', props);
};
var defaultRenderItemsContainer = function defaultRenderItemsContainer(_ref) {
  var containerProps = _ref.containerProps,
      children = _ref.children;
  return _react2.default.createElement(
    'div',
    containerProps,
    children
  );
};
var defaultTheme = {
  container: 'react-autowhatever__container',
  containerOpen: 'react-autowhatever__container--open',
  input: 'react-autowhatever__input',
  inputOpen: 'react-autowhatever__input--open',
  inputFocused: 'react-autowhatever__input--focused',
  itemsContainer: 'react-autowhatever__items-container',
  itemsContainerOpen: 'react-autowhatever__items-container--open',
  itemsList: 'react-autowhatever__items-list',
  item: 'react-autowhatever__item',
  itemFirst: 'react-autowhatever__item--first',
  itemHighlighted: 'react-autowhatever__item--highlighted',
  sectionContainer: 'react-autowhatever__section-container',
  sectionContainerFirst: 'react-autowhatever__section-container--first',
  sectionTitle: 'react-autowhatever__section-title'
};

var Autowhatever = function (_Component) {
  _inherits(Autowhatever, _Component);

  function Autowhatever(props) {
    _classCallCheck(this, Autowhatever);

    var _this = _possibleConstructorReturn(this, (Autowhatever.__proto__ || Object.getPrototypeOf(Autowhatever)).call(this, props));

    _this.storeInputReference = function (input) {
      if (input !== null) {
        _this.input = input;
      }
    };

    _this.storeItemsContainerReference = function (itemsContainer) {
      if (itemsContainer !== null) {
        _this.itemsContainer = itemsContainer;
      }
    };

    _this.onHighlightedItemChange = function (highlightedItem) {
      _this.highlightedItem = highlightedItem;
    };

    _this.getItemId = function (sectionIndex, itemIndex) {
      if (itemIndex === null) {
        return null;
      }

      var id = _this.props.id;

      var section = sectionIndex === null ? '' : 'section-' + sectionIndex;

      return 'react-autowhatever-' + id + '-' + section + '-item-' + itemIndex;
    };

    _this.onFocus = function (event) {
      var inputProps = _this.props.inputProps;


      _this.setState({
        isInputFocused: true
      });

      inputProps.onFocus && inputProps.onFocus(event);
    };

    _this.onBlur = function (event) {
      var inputProps = _this.props.inputProps;


      _this.setState({
        isInputFocused: false
      });

      inputProps.onBlur && inputProps.onBlur(event);
    };

    _this.onKeyDown = function (event) {
      var _this$props = _this.props,
          inputProps = _this$props.inputProps,
          highlightedSectionIndex = _this$props.highlightedSectionIndex,
          highlightedItemIndex = _this$props.highlightedItemIndex;


      switch (event.key) {
        case 'ArrowDown':
        case 'ArrowUp':
          {
            var nextPrev = event.key === 'ArrowDown' ? 'next' : 'prev';

            var _this$sectionIterator = _this.sectionIterator[nextPrev]([highlightedSectionIndex, highlightedItemIndex]),
                _this$sectionIterator2 = _slicedToArray(_this$sectionIterator, 2),
                newHighlightedSectionIndex = _this$sectionIterator2[0],
                newHighlightedItemIndex = _this$sectionIterator2[1];

            inputProps.onKeyDown(event, { newHighlightedSectionIndex: newHighlightedSectionIndex, newHighlightedItemIndex: newHighlightedItemIndex });
            break;
          }

        default:
          inputProps.onKeyDown(event, { highlightedSectionIndex: highlightedSectionIndex, highlightedItemIndex: highlightedItemIndex });
      }
    };

    _this.highlightedItem = null;

    _this.state = {
      isInputFocused: false
    };

    _this.setSectionsItems(props);
    _this.setSectionIterator(props);
    _this.setTheme(props);
    return _this;
  }

  _createClass(Autowhatever, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.ensureHighlightedItemIsVisible();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.items !== this.props.items) {
        this.setSectionsItems(nextProps);
      }

      if (nextProps.items !== this.props.items || nextProps.multiSection !== this.props.multiSection) {
        this.setSectionIterator(nextProps);
      }

      if (nextProps.theme !== this.props.theme) {
        this.setTheme(nextProps);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.ensureHighlightedItemIsVisible();
    }
  }, {
    key: 'setSectionsItems',
    value: function setSectionsItems(props) {
      if (props.multiSection) {
        this.sectionsItems = props.items.map(function (section) {
          return props.getSectionItems(section);
        });
        this.sectionsLengths = this.sectionsItems.map(function (items) {
          return items.length;
        });
        this.allSectionsAreEmpty = this.sectionsLengths.every(function (itemsCount) {
          return itemsCount === 0;
        });
      }
    }
  }, {
    key: 'setSectionIterator',
    value: function setSectionIterator(props) {
      this.sectionIterator = (0, _sectionIterator2.default)({
        multiSection: props.multiSection,
        data: props.multiSection ? this.sectionsLengths : props.items.length
      });
    }
  }, {
    key: 'setTheme',
    value: function setTheme(props) {
      this.theme = (0, _reactThemeable2.default)(props.theme);
    }
  }, {
    key: 'renderSections',
    value: function renderSections() {
      var _this2 = this;

      if (this.allSectionsAreEmpty) {
        return null;
      }

      var theme = this.theme;
      var _props = this.props,
          id = _props.id,
          items = _props.items,
          renderItem = _props.renderItem,
          renderItemData = _props.renderItemData,
          renderSectionTitle = _props.renderSectionTitle,
          highlightedSectionIndex = _props.highlightedSectionIndex,
          highlightedItemIndex = _props.highlightedItemIndex,
          itemProps = _props.itemProps;


      return items.map(function (section, sectionIndex) {
        var keyPrefix = 'react-autowhatever-' + id + '-';
        var sectionKeyPrefix = keyPrefix + 'section-' + sectionIndex + '-';
        var isFirstSection = sectionIndex === 0;

        // `key` is provided by theme()
        /* eslint-disable react/jsx-key */
        return _react2.default.createElement(
          'div',
          theme(sectionKeyPrefix + 'container', 'sectionContainer', isFirstSection && 'sectionContainerFirst'),
          _react2.default.createElement(_SectionTitle2.default, {
            section: section,
            renderSectionTitle: renderSectionTitle,
            theme: theme,
            sectionKeyPrefix: sectionKeyPrefix
          }),
          _react2.default.createElement(_ItemsList2.default, {
            items: _this2.sectionsItems[sectionIndex],
            itemProps: itemProps,
            renderItem: renderItem,
            renderItemData: renderItemData,
            sectionIndex: sectionIndex,
            highlightedItemIndex: highlightedSectionIndex === sectionIndex ? highlightedItemIndex : null,
            onHighlightedItemChange: _this2.onHighlightedItemChange,
            getItemId: _this2.getItemId,
            theme: theme,
            keyPrefix: keyPrefix,
            ref: _this2.storeItemsListReference
          })
        );
        /* eslint-enable react/jsx-key */
      });
    }
  }, {
    key: 'renderItems',
    value: function renderItems() {
      var items = this.props.items;


      if (items.length === 0) {
        return null;
      }

      var theme = this.theme;
      var _props2 = this.props,
          id = _props2.id,
          renderItem = _props2.renderItem,
          renderItemData = _props2.renderItemData,
          highlightedSectionIndex = _props2.highlightedSectionIndex,
          highlightedItemIndex = _props2.highlightedItemIndex,
          itemProps = _props2.itemProps;


      return _react2.default.createElement(_ItemsList2.default, {
        items: items,
        itemProps: itemProps,
        renderItem: renderItem,
        renderItemData: renderItemData,
        highlightedItemIndex: highlightedSectionIndex === null ? highlightedItemIndex : null,
        onHighlightedItemChange: this.onHighlightedItemChange,
        getItemId: this.getItemId,
        theme: theme,
        keyPrefix: 'react-autowhatever-' + id + '-'
      });
    }
  }, {
    key: 'ensureHighlightedItemIsVisible',
    value: function ensureHighlightedItemIsVisible() {
      var highlightedItem = this.highlightedItem;


      if (!highlightedItem) {
        return;
      }

      var itemsContainer = this.itemsContainer;

      var itemOffsetRelativeToContainer = highlightedItem.offsetParent === itemsContainer ? highlightedItem.offsetTop : highlightedItem.offsetTop - itemsContainer.offsetTop;

      var scrollTop = itemsContainer.scrollTop; // Top of the visible area

      if (itemOffsetRelativeToContainer < scrollTop) {
        // Item is off the top of the visible area
        scrollTop = itemOffsetRelativeToContainer;
      } else if (itemOffsetRelativeToContainer + highlightedItem.offsetHeight > scrollTop + itemsContainer.offsetHeight) {
        // Item is off the bottom of the visible area
        scrollTop = itemOffsetRelativeToContainer + highlightedItem.offsetHeight - itemsContainer.offsetHeight;
      }

      if (scrollTop !== itemsContainer.scrollTop) {
        itemsContainer.scrollTop = scrollTop;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var theme = this.theme;
      var _props3 = this.props,
          id = _props3.id,
          multiSection = _props3.multiSection,
          renderInputComponent = _props3.renderInputComponent,
          renderItemsContainer = _props3.renderItemsContainer,
          highlightedSectionIndex = _props3.highlightedSectionIndex,
          highlightedItemIndex = _props3.highlightedItemIndex;
      var isInputFocused = this.state.isInputFocused;

      var renderedItems = multiSection ? this.renderSections() : this.renderItems();
      var isOpen = renderedItems !== null;
      var ariaActivedescendant = this.getItemId(highlightedSectionIndex, highlightedItemIndex);
      var containerProps = theme('react-autowhatever-' + id + '-container', 'container', isOpen && 'containerOpen');
      var itemsContainerId = 'react-autowhatever-' + id;
      var inputComponent = renderInputComponent(_extends({
        type: 'text',
        value: '',
        autoComplete: 'off',
        role: 'combobox',
        'aria-autocomplete': 'list',
        'aria-owns': itemsContainerId,
        'aria-expanded': isOpen,
        'aria-haspopup': isOpen,
        'aria-activedescendant': ariaActivedescendant
      }, theme('react-autowhatever-' + id + '-input', 'input', isOpen && 'inputOpen', isInputFocused && 'inputFocused'), this.props.inputProps, {
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        onKeyDown: this.props.inputProps.onKeyDown && this.onKeyDown,
        ref: this.storeInputReference
      }));
      var itemsContainer = renderItemsContainer({
        containerProps: _extends({
          id: itemsContainerId
        }, theme('react-autowhatever-' + id + '-items-container', 'itemsContainer', isOpen && 'itemsContainerOpen'), {
          ref: this.storeItemsContainerReference
        }),
        children: renderedItems
      });

      return _react2.default.createElement(
        'div',
        containerProps,
        inputComponent,
        itemsContainer
      );
    }
  }]);

  return Autowhatever;
}(_react.Component);

Autowhatever.propTypes = {
  id: _propTypes2.default.string, // Used in aria-* attributes. If multiple Autowhatever's are rendered on a page, they must have unique ids.
  multiSection: _propTypes2.default.bool, // Indicates whether a multi section layout should be rendered.
  renderInputComponent: _propTypes2.default.func, // When specified, it is used to render the input element.
  renderItemsContainer: _propTypes2.default.func, // Renders the items container.
  items: _propTypes2.default.array.isRequired, // Array of items or sections to render.
  renderItem: _propTypes2.default.func, // This function renders a single item.
  renderItemData: _propTypes2.default.object, // Arbitrary data that will be passed to renderItem()
  renderSectionTitle: _propTypes2.default.func, // This function gets a section and renders its title.
  getSectionItems: _propTypes2.default.func, // This function gets a section and returns its items, which will be passed into `renderItem` for rendering.
  inputProps: _propTypes2.default.object, // Arbitrary input props
  itemProps: _propTypes2.default.oneOfType([// Arbitrary item props
  _propTypes2.default.object, _propTypes2.default.func]),
  highlightedSectionIndex: _propTypes2.default.number, // Section index of the highlighted item
  highlightedItemIndex: _propTypes2.default.number, // Highlighted item index (within a section)
  theme: _propTypes2.default.oneOfType([// Styles. See: https://github.com/markdalgleish/react-themeable
  _propTypes2.default.object, _propTypes2.default.array])
};
Autowhatever.defaultProps = {
  id: '1',
  multiSection: false,
  renderInputComponent: defaultRenderInputComponent,
  renderItemsContainer: defaultRenderItemsContainer,
  renderItem: function renderItem() {
    throw new Error('`renderItem` must be provided');
  },
  renderItemData: emptyObject,
  renderSectionTitle: function renderSectionTitle() {
    throw new Error('`renderSectionTitle` must be provided');
  },
  getSectionItems: function getSectionItems() {
    throw new Error('`getSectionItems` must be provided');
  },
  inputProps: emptyObject,
  itemProps: emptyObject,
  highlightedSectionIndex: null,
  highlightedItemIndex: null,
  theme: defaultTheme
};
exports.default = Autowhatever;

/***/ }),

/***/ "../node_modules/react-autowhatever/dist/Item.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _compareObjects = __webpack_require__("../node_modules/react-autowhatever/dist/compareObjects.js");

var _compareObjects2 = _interopRequireDefault(_compareObjects);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Item = function (_Component) {
  _inherits(Item, _Component);

  function Item() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Item);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Item.__proto__ || Object.getPrototypeOf(Item)).call.apply(_ref, [this].concat(args))), _this), _this.storeItemReference = function (item) {
      if (item !== null) {
        _this.item = item;
      }
    }, _this.onMouseEnter = function (event) {
      var _this$props = _this.props,
          sectionIndex = _this$props.sectionIndex,
          itemIndex = _this$props.itemIndex;


      _this.props.onMouseEnter(event, { sectionIndex: sectionIndex, itemIndex: itemIndex });
    }, _this.onMouseLeave = function (event) {
      var _this$props2 = _this.props,
          sectionIndex = _this$props2.sectionIndex,
          itemIndex = _this$props2.itemIndex;


      _this.props.onMouseLeave(event, { sectionIndex: sectionIndex, itemIndex: itemIndex });
    }, _this.onMouseDown = function (event) {
      var _this$props3 = _this.props,
          sectionIndex = _this$props3.sectionIndex,
          itemIndex = _this$props3.itemIndex;


      _this.props.onMouseDown(event, { sectionIndex: sectionIndex, itemIndex: itemIndex });
    }, _this.onClick = function (event) {
      var _this$props4 = _this.props,
          sectionIndex = _this$props4.sectionIndex,
          itemIndex = _this$props4.itemIndex;


      _this.props.onClick(event, { sectionIndex: sectionIndex, itemIndex: itemIndex });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Item, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return (0, _compareObjects2.default)(nextProps, this.props, ['renderItemData']);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          isHighlighted = _props.isHighlighted,
          item = _props.item,
          renderItem = _props.renderItem,
          renderItemData = _props.renderItemData,
          restProps = _objectWithoutProperties(_props, ['isHighlighted', 'item', 'renderItem', 'renderItemData']);

      delete restProps.sectionIndex;
      delete restProps.itemIndex;

      if (typeof restProps.onMouseEnter === 'function') {
        restProps.onMouseEnter = this.onMouseEnter;
      }

      if (typeof restProps.onMouseLeave === 'function') {
        restProps.onMouseLeave = this.onMouseLeave;
      }

      if (typeof restProps.onMouseDown === 'function') {
        restProps.onMouseDown = this.onMouseDown;
      }

      if (typeof restProps.onClick === 'function') {
        restProps.onClick = this.onClick;
      }

      return _react2.default.createElement(
        'li',
        _extends({ role: 'option' }, restProps, { ref: this.storeItemReference }),
        renderItem(item, _extends({ isHighlighted: isHighlighted }, renderItemData))
      );
    }
  }]);

  return Item;
}(_react.Component);

Item.propTypes = {
  sectionIndex: _propTypes2.default.number,
  isHighlighted: _propTypes2.default.bool.isRequired,
  itemIndex: _propTypes2.default.number.isRequired,
  item: _propTypes2.default.any.isRequired,
  renderItem: _propTypes2.default.func.isRequired,
  renderItemData: _propTypes2.default.object.isRequired,
  onMouseEnter: _propTypes2.default.func,
  onMouseLeave: _propTypes2.default.func,
  onMouseDown: _propTypes2.default.func,
  onClick: _propTypes2.default.func
};
exports.default = Item;

/***/ }),

/***/ "../node_modules/react-autowhatever/dist/ItemsList.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Item = __webpack_require__("../node_modules/react-autowhatever/dist/Item.js");

var _Item2 = _interopRequireDefault(_Item);

var _compareObjects = __webpack_require__("../node_modules/react-autowhatever/dist/compareObjects.js");

var _compareObjects2 = _interopRequireDefault(_compareObjects);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ItemsList = function (_Component) {
  _inherits(ItemsList, _Component);

  function ItemsList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ItemsList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ItemsList.__proto__ || Object.getPrototypeOf(ItemsList)).call.apply(_ref, [this].concat(args))), _this), _this.storeHighlightedItemReference = function (highlightedItem) {
      _this.props.onHighlightedItemChange(highlightedItem === null ? null : highlightedItem.item);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ItemsList, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return (0, _compareObjects2.default)(nextProps, this.props, ['itemProps']);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          items = _props.items,
          itemProps = _props.itemProps,
          renderItem = _props.renderItem,
          renderItemData = _props.renderItemData,
          sectionIndex = _props.sectionIndex,
          highlightedItemIndex = _props.highlightedItemIndex,
          getItemId = _props.getItemId,
          theme = _props.theme,
          keyPrefix = _props.keyPrefix;

      var sectionPrefix = sectionIndex === null ? keyPrefix : keyPrefix + 'section-' + sectionIndex + '-';
      var isItemPropsFunction = typeof itemProps === 'function';

      return _react2.default.createElement(
        'ul',
        _extends({ role: 'listbox' }, theme(sectionPrefix + 'items-list', 'itemsList')),
        items.map(function (item, itemIndex) {
          var isFirst = itemIndex === 0;
          var isHighlighted = itemIndex === highlightedItemIndex;
          var itemKey = sectionPrefix + 'item-' + itemIndex;
          var itemPropsObj = isItemPropsFunction ? itemProps({ sectionIndex: sectionIndex, itemIndex: itemIndex }) : itemProps;
          var allItemProps = _extends({
            id: getItemId(sectionIndex, itemIndex)
          }, theme(itemKey, 'item', isFirst && 'itemFirst', isHighlighted && 'itemHighlighted'), itemPropsObj);

          if (isHighlighted) {
            allItemProps.ref = _this2.storeHighlightedItemReference;
          }

          // `key` is provided by theme()
          /* eslint-disable react/jsx-key */
          return _react2.default.createElement(_Item2.default, _extends({}, allItemProps, {
            sectionIndex: sectionIndex,
            isHighlighted: isHighlighted,
            itemIndex: itemIndex,
            item: item,
            renderItem: renderItem,
            renderItemData: renderItemData
          }));
          /* eslint-enable react/jsx-key */
        })
      );
    }
  }]);

  return ItemsList;
}(_react.Component);

ItemsList.propTypes = {
  items: _propTypes2.default.array.isRequired,
  itemProps: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
  renderItem: _propTypes2.default.func.isRequired,
  renderItemData: _propTypes2.default.object.isRequired,
  sectionIndex: _propTypes2.default.number,
  highlightedItemIndex: _propTypes2.default.number,
  onHighlightedItemChange: _propTypes2.default.func.isRequired,
  getItemId: _propTypes2.default.func.isRequired,
  theme: _propTypes2.default.func.isRequired,
  keyPrefix: _propTypes2.default.string.isRequired
};
ItemsList.defaultProps = {
  sectionIndex: null
};
exports.default = ItemsList;

/***/ }),

/***/ "../node_modules/react-autowhatever/dist/SectionTitle.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _compareObjects = __webpack_require__("../node_modules/react-autowhatever/dist/compareObjects.js");

var _compareObjects2 = _interopRequireDefault(_compareObjects);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SectionTitle = function (_Component) {
  _inherits(SectionTitle, _Component);

  function SectionTitle() {
    _classCallCheck(this, SectionTitle);

    return _possibleConstructorReturn(this, (SectionTitle.__proto__ || Object.getPrototypeOf(SectionTitle)).apply(this, arguments));
  }

  _createClass(SectionTitle, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return (0, _compareObjects2.default)(nextProps, this.props);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          section = _props.section,
          renderSectionTitle = _props.renderSectionTitle,
          theme = _props.theme,
          sectionKeyPrefix = _props.sectionKeyPrefix;

      var sectionTitle = renderSectionTitle(section);

      if (!sectionTitle) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        theme(sectionKeyPrefix + 'title', 'sectionTitle'),
        sectionTitle
      );
    }
  }]);

  return SectionTitle;
}(_react.Component);

SectionTitle.propTypes = {
  section: _propTypes2.default.any.isRequired,
  renderSectionTitle: _propTypes2.default.func.isRequired,
  theme: _propTypes2.default.func.isRequired,
  sectionKeyPrefix: _propTypes2.default.string.isRequired
};
exports.default = SectionTitle;

/***/ }),

/***/ "../node_modules/react-autowhatever/dist/compareObjects.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = compareObjects;
function compareObjects(objA, objB) {
  var keys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  if (objA === objB) {
    return false;
  }

  var aKeys = Object.keys(objA);
  var bKeys = Object.keys(objB);

  if (aKeys.length !== bKeys.length) {
    return true;
  }

  var keysMap = {};
  var i = void 0,
      len = void 0;

  for (i = 0, len = keys.length; i < len; i++) {
    keysMap[keys[i]] = true;
  }

  for (i = 0, len = aKeys.length; i < len; i++) {
    var key = aKeys[i];
    var aValue = objA[key];
    var bValue = objB[key];

    if (aValue === bValue) {
      continue;
    }

    if (!keysMap[key] || aValue === null || bValue === null || (typeof aValue === 'undefined' ? 'undefined' : _typeof(aValue)) !== 'object' || (typeof bValue === 'undefined' ? 'undefined' : _typeof(bValue)) !== 'object') {
      return true;
    }

    var aValueKeys = Object.keys(aValue);
    var bValueKeys = Object.keys(bValue);

    if (aValueKeys.length !== bValueKeys.length) {
      return true;
    }

    for (var n = 0, length = aValueKeys.length; n < length; n++) {
      var aValueKey = aValueKeys[n];

      if (aValue[aValueKey] !== bValue[aValueKey]) {
        return true;
      }
    }
  }

  return false;
}

/***/ }),

/***/ "../node_modules/react-autowhatever/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__("../node_modules/react-autowhatever/dist/Autowhatever.js").default;

/***/ }),

/***/ "../node_modules/react-click-outside/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var hoistNonReactStatic = __webpack_require__("../node_modules/hoist-non-react-statics/index.js");
var React = __webpack_require__("../node_modules/react/react.js");
var ReactDOM = __webpack_require__("../node_modules/react-dom/index.js");

module.exports = function enhanceWithClickOutside(WrappedComponent) {
  var componentName = WrappedComponent.displayName || WrappedComponent.name;

  var EnhancedComponent = function (_React$Component) {
    _inherits(EnhancedComponent, _React$Component);

    function EnhancedComponent(props) {
      _classCallCheck(this, EnhancedComponent);

      var _this = _possibleConstructorReturn(this, (EnhancedComponent.__proto__ || Object.getPrototypeOf(EnhancedComponent)).call(this, props));

      _this.handleClickOutside = _this.handleClickOutside.bind(_this);
      return _this;
    }

    _createClass(EnhancedComponent, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        document.addEventListener('click', this.handleClickOutside, true);
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside, true);
      }
    }, {
      key: 'handleClickOutside',
      value: function handleClickOutside(e) {
        var domNode = this.__domNode;
        if ((!domNode || !domNode.contains(e.target)) && typeof this.__wrappedComponent.handleClickOutside === 'function') {
          this.__wrappedComponent.handleClickOutside(e);
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var _props = this.props,
            wrappedRef = _props.wrappedRef,
            rest = _objectWithoutProperties(_props, ['wrappedRef']);

        return React.createElement(WrappedComponent, _extends({}, rest, {
          ref: function ref(c) {
            _this2.__wrappedComponent = c;
            _this2.__domNode = ReactDOM.findDOMNode(c);
            wrappedRef && wrappedRef(c);
          }
        }));
      }
    }]);

    return EnhancedComponent;
  }(React.Component);

  EnhancedComponent.displayName = 'clickOutside(' + componentName + ')';

  return hoistNonReactStatic(EnhancedComponent, WrappedComponent);
};

/***/ }),

/***/ "../node_modules/react-dropdown/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("../node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = __webpack_require__("../node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DEFAULT_PLACEHOLDER_STRING = 'Select...';

var Dropdown = function (_Component) {
  _inherits(Dropdown, _Component);

  function Dropdown(props) {
    _classCallCheck(this, Dropdown);

    var _this = _possibleConstructorReturn(this, (Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call(this, props));

    _this.state = {
      selected: props.value || {
        label: props.placeholder || DEFAULT_PLACEHOLDER_STRING,
        value: ''
      },
      isOpen: false
    };
    _this.mounted = true;
    _this.handleDocumentClick = _this.handleDocumentClick.bind(_this);
    _this.fireChangeEvent = _this.fireChangeEvent.bind(_this);
    return _this;
  }

  _createClass(Dropdown, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (newProps.value && newProps.value !== this.state.selected) {
        this.setState({ selected: newProps.value });
      } else if (!newProps.value) {
        this.setState({ selected: {
            label: newProps.placeholder || DEFAULT_PLACEHOLDER_STRING,
            value: ''
          } });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('click', this.handleDocumentClick, false);
      document.addEventListener('touchend', this.handleDocumentClick, false);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.mounted = false;
      document.removeEventListener('click', this.handleDocumentClick, false);
      document.removeEventListener('touchend', this.handleDocumentClick, false);
    }
  }, {
    key: 'handleMouseDown',
    value: function handleMouseDown(event) {
      if (this.props.onFocus && typeof this.props.onFocus === 'function') {
        this.props.onFocus(this.state.isOpen);
      }
      if (event.type === 'mousedown' && event.button !== 0) return;
      event.stopPropagation();
      event.preventDefault();

      if (!this.props.disabled) {
        this.setState({
          isOpen: !this.state.isOpen
        });
      }
    }
  }, {
    key: 'setValue',
    value: function setValue(value, label) {
      var newState = {
        selected: {
          value: value,
          label: label
        },
        isOpen: false
      };
      this.fireChangeEvent(newState);
      this.setState(newState);
    }
  }, {
    key: 'fireChangeEvent',
    value: function fireChangeEvent(newState) {
      if (newState.selected !== this.state.selected && this.props.onChange) {
        this.props.onChange(newState.selected);
      }
    }
  }, {
    key: 'renderOption',
    value: function renderOption(option) {
      var _classNames;

      var optionClass = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, this.props.baseClassName + '-option', true), _defineProperty(_classNames, 'is-selected', option === this.state.selected), _classNames));

      var value = option.value || option.label || option;
      var label = option.label || option.value || option;

      return _react2.default.createElement(
        'div',
        {
          key: value,
          className: optionClass,
          onMouseDown: this.setValue.bind(this, value, label),
          onClick: this.setValue.bind(this, value, label) },
        label
      );
    }
  }, {
    key: 'buildMenu',
    value: function buildMenu() {
      var _this2 = this;

      var _props = this.props,
          options = _props.options,
          baseClassName = _props.baseClassName;

      var ops = options.map(function (option) {
        if (option.type === 'group') {
          var groupTitle = _react2.default.createElement(
            'div',
            { className: baseClassName + '-title' },
            option.name
          );
          var _options = option.items.map(function (item) {
            return _this2.renderOption(item);
          });

          return _react2.default.createElement(
            'div',
            { className: baseClassName + '-group', key: option.name },
            groupTitle,
            _options
          );
        } else {
          return _this2.renderOption(option);
        }
      });

      return ops.length ? ops : _react2.default.createElement(
        'div',
        { className: baseClassName + '-noresults' },
        'No options found'
      );
    }
  }, {
    key: 'handleDocumentClick',
    value: function handleDocumentClick(event) {
      if (this.mounted) {
        if (!_reactDom2.default.findDOMNode(this).contains(event.target)) {
          if (this.state.isOpen) {
            this.setState({ isOpen: false });
          }
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames2;

      var _props2 = this.props,
          baseClassName = _props2.baseClassName,
          className = _props2.className;


      var disabledClass = this.props.disabled ? 'Dropdown-disabled' : '';
      var placeHolderValue = typeof this.state.selected === 'string' ? this.state.selected : this.state.selected.label;
      var value = _react2.default.createElement(
        'div',
        { className: baseClassName + '-placeholder' },
        placeHolderValue
      );
      var menu = this.state.isOpen ? _react2.default.createElement(
        'div',
        { className: baseClassName + '-menu' },
        this.buildMenu()
      ) : null;

      var dropdownClass = (0, _classnames2.default)((_classNames2 = {}, _defineProperty(_classNames2, className, true), _defineProperty(_classNames2, baseClassName + '-root', true), _defineProperty(_classNames2, 'is-open', this.state.isOpen), _classNames2));

      return _react2.default.createElement(
        'div',
        { className: dropdownClass },
        _react2.default.createElement(
          'div',
          { className: baseClassName + '-control ' + disabledClass, onMouseDown: this.handleMouseDown.bind(this), onTouchEnd: this.handleMouseDown.bind(this) },
          value,
          _react2.default.createElement('span', { className: baseClassName + '-arrow' })
        ),
        menu
      );
    }
  }]);

  return Dropdown;
}(_react.Component);

Dropdown.defaultProps = { baseClassName: 'Dropdown' };
exports.default = Dropdown;


/***/ }),

/***/ "../node_modules/react-fontawesome/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _screenReaderStyles = __webpack_require__("../node_modules/react-fontawesome/lib/screen-reader-styles.js");

var _screenReaderStyles2 = _interopRequireDefault(_screenReaderStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * A React component for the font-awesome icon library.
 *
 * @param {String} [ariaLabel] An extra accessibility label to put on the icon
 * @param {Boolean} [border=false] Whether or not to show a border radius
 * @param {String} [className] An extra set of CSS classes to add to the component
 * @param {Object} [cssModule] Option to pass FontAwesome CSS as a module
 * @param {Boolean} [fixedWidth=false] Make buttons fixed width
 * @param {String} [flip=false] Flip the icon's orientation.
 * @param {Boolean} [inverse=false]Inverse the icon's color
 * @param {String} name Name of the icon to use
 * @param {Boolean} [pulse=false] Rotate icon with 8 steps, rather than smoothly
 * @param {Number} [rotate] The degress to rotate the icon by
 * @param {String} [size] The icon scaling size
 * @param {Boolean} [spin=false] Spin the icon
 * @param {String} [stack] Stack an icon on top of another
 * @param {String} [tag=span] The HTML tag to use as a string, eg 'i' or 'em'
 * @module FontAwesome
 * @type {ReactClass}
 */
var FontAwesome = function (_React$Component) {
  _inherits(FontAwesome, _React$Component);

  function FontAwesome() {
    _classCallCheck(this, FontAwesome);

    var _this = _possibleConstructorReturn(this, (FontAwesome.__proto__ || Object.getPrototypeOf(FontAwesome)).call(this));

    _this.displayName = 'FontAwesome';
    return _this;
  }

  _createClass(FontAwesome, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          border = _props.border,
          cssModule = _props.cssModule,
          className = _props.className,
          fixedWidth = _props.fixedWidth,
          flip = _props.flip,
          inverse = _props.inverse,
          name = _props.name,
          pulse = _props.pulse,
          rotate = _props.rotate,
          size = _props.size,
          spin = _props.spin,
          stack = _props.stack,
          _props$tag = _props.tag,
          tag = _props$tag === undefined ? 'span' : _props$tag,
          ariaLabel = _props.ariaLabel,
          props = _objectWithoutProperties(_props, ['border', 'cssModule', 'className', 'fixedWidth', 'flip', 'inverse', 'name', 'pulse', 'rotate', 'size', 'spin', 'stack', 'tag', 'ariaLabel']);

      var classNames = [];

      if (cssModule) {
        classNames.push(cssModule['fa']);
        classNames.push(cssModule['fa-' + name]);
        size && classNames.push(cssModule['fa-' + size]);
        spin && classNames.push(cssModule['fa-spin']);
        pulse && classNames.push(cssModule['fa-pulse']);
        border && classNames.push(cssModule['fa-border']);
        fixedWidth && classNames.push(cssModule['fa-fw']);
        inverse && classNames.push(cssModule['fa-inverse']);
        flip && classNames.push(cssModule['fa-flip-' + flip]);
        rotate && classNames.push(cssModule['fa-rotate-' + rotate]);
        stack && classNames.push(cssModule['fa-stack-' + stack]);
      } else {
        classNames.push('fa');
        classNames.push('fa-' + name);
        size && classNames.push('fa-' + size);
        spin && classNames.push('fa-spin');
        pulse && classNames.push('fa-pulse');
        border && classNames.push('fa-border');
        fixedWidth && classNames.push('fa-fw');
        inverse && classNames.push('fa-inverse');
        flip && classNames.push('fa-flip-' + flip);
        rotate && classNames.push('fa-rotate-' + rotate);
        stack && classNames.push('fa-stack-' + stack);
      }

      // Add any custom class names at the end.
      className && classNames.push(className);
      return _react2.default.createElement(tag, _extends({}, props, { 'aria-hidden': true, className: classNames.join(' ') }), ariaLabel ? _react2.default.createElement('span', { style: _screenReaderStyles2.default }, ariaLabel) : null);
    }
  }]);

  return FontAwesome;
}(_react2.default.Component);

FontAwesome.propTypes = {
  ariaLabel: _propTypes2.default.string,
  border: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  cssModule: _propTypes2.default.object,
  fixedWidth: _propTypes2.default.bool,
  flip: _propTypes2.default.oneOf(['horizontal', 'vertical']),
  inverse: _propTypes2.default.bool,
  name: _propTypes2.default.string.isRequired,
  pulse: _propTypes2.default.bool,
  rotate: _propTypes2.default.oneOf([90, 180, 270]),
  size: _propTypes2.default.oneOf(['lg', '2x', '3x', '4x', '5x']),
  spin: _propTypes2.default.bool,
  stack: _propTypes2.default.oneOf(['1x', '2x']),
  tag: _propTypes2.default.string
};

exports.default = FontAwesome;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/react-fontawesome/lib/screen-reader-styles.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  padding: '0px',
  margin: '-1px',
  overflow: 'hidden',
  clip: 'rect(0px, 0px, 0px, 0px)',
  border: '0px'
};
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/react-gravatar/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _md = __webpack_require__("../node_modules/md5/md5.js");

var _md2 = _interopRequireDefault(_md);

var _queryString = __webpack_require__("../node_modules/query-string/index.js");

var _queryString2 = _interopRequireDefault(_queryString);

var _isRetina = __webpack_require__("../node_modules/is-retina/index.js");

var _isRetina2 = _interopRequireDefault(_isRetina);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Gravatar = function (_React$Component) {
  _inherits(Gravatar, _React$Component);

  function Gravatar() {
    _classCallCheck(this, Gravatar);

    return _possibleConstructorReturn(this, (Gravatar.__proto__ || Object.getPrototypeOf(Gravatar)).apply(this, arguments));
  }

  _createClass(Gravatar, [{
    key: 'render',
    value: function render() {
      var base = this.props.protocol + 'www.gravatar.com/avatar/';

      var query = _queryString2.default.stringify({
        s: this.props.size,
        r: this.props.rating,
        d: this.props.default
      });

      var retinaQuery = _queryString2.default.stringify({
        s: this.props.size * 2,
        r: this.props.rating,
        d: this.props.default
      });

      // Gravatar service currently trims and lowercases all registered emails
      var formattedEmail = ('' + this.props.email).trim().toLowerCase();

      var hash = void 0;
      if (this.props.md5) {
        hash = this.props.md5;
      } else if (typeof this.props.email === 'string') {
        hash = (0, _md2.default)(formattedEmail, { encoding: "binary" });
      } else {
        console.warn('Gravatar image can not be fetched. Either the "email" or "md5" prop must be specified.');
        return _react2.default.createElement('script', null);
      }

      var src = '' + base + hash + '?' + query;
      var retinaSrc = '' + base + hash + '?' + retinaQuery;

      var modernBrowser = true; // server-side, we render for modern browsers

      if (typeof window !== 'undefined') {
        // this is not NodeJS
        modernBrowser = 'srcset' in document.createElement('img');
      }

      var className = 'react-gravatar';
      if (this.props.className) {
        className = className + ' ' + this.props.className;
      }

      // Clone this.props and then delete Component specific props so we can
      // spread the rest into the img.

      var rest = _objectWithoutProperties(this.props, []);

      delete rest.md5;
      delete rest.email;
      delete rest.protocol;
      delete rest.rating;
      delete rest.size;
      delete rest.style;
      delete rest.className;
      delete rest.default;
      if (!modernBrowser && (0, _isRetina2.default)()) {
        return _react2.default.createElement('img', _extends({
          alt: 'Gravatar for ' + formattedEmail,
          style: this.props.style,
          src: retinaSrc,
          height: this.props.size,
          width: this.props.size
        }, rest, {
          className: className
        }));
      }
      return _react2.default.createElement('img', _extends({
        alt: 'Gravatar for ' + formattedEmail,
        style: this.props.style,
        src: src,
        srcSet: retinaSrc + ' 2x',
        height: this.props.size,
        width: this.props.size
      }, rest, {
        className: className
      }));
    }
  }]);

  return Gravatar;
}(_react2.default.Component);

Gravatar.displayName = 'Gravatar';
Gravatar.propTypes = {
  email: _propTypes2.default.string,
  md5: _propTypes2.default.string,
  size: _propTypes2.default.number,
  rating: _propTypes2.default.string,
  default: _propTypes2.default.string,
  className: _propTypes2.default.string,
  protocol: _propTypes2.default.string,
  style: _propTypes2.default.object
};
Gravatar.defaultProps = {
  size: 50,
  rating: 'g',
  default: 'retro',
  protocol: '//'
};


module.exports = Gravatar;

/***/ }),

/***/ "../node_modules/react-helmet/lib/Helmet.js":
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.Helmet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSideEffect = __webpack_require__("../node_modules/react-side-effect/lib/index.js");

var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);

var _deepEqual = __webpack_require__("../node_modules/deep-equal/index.js");

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _HelmetUtils = __webpack_require__("../node_modules/react-helmet/lib/HelmetUtils.js");

var _HelmetConstants = __webpack_require__("../node_modules/react-helmet/lib/HelmetConstants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Helmet = function Helmet(Component) {
    var _class, _temp;

    return _temp = _class = function (_React$Component) {
        _inherits(HelmetWrapper, _React$Component);

        function HelmetWrapper() {
            _classCallCheck(this, HelmetWrapper);

            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }

        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, _deepEqual2.default)(this.props, nextProps);
        };

        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) {
                return null;
            }

            switch (child.type) {
                case _HelmetConstants.TAG_NAMES.SCRIPT:
                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };

                case _HelmetConstants.TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }

            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };

        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _extends2;

            var child = _ref.child,
                arrayTypeChildren = _ref.arrayTypeChildren,
                newChildProps = _ref.newChildProps,
                nestedChildren = _ref.nestedChildren;

            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
        };

        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _extends3, _extends4;

            var child = _ref2.child,
                newProps = _ref2.newProps,
                newChildProps = _ref2.newChildProps,
                nestedChildren = _ref2.nestedChildren;

            switch (child.type) {
                case _HelmetConstants.TAG_NAMES.TITLE:
                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));

                case _HelmetConstants.TAG_NAMES.BODY:
                    return _extends({}, newProps, {
                        bodyAttributes: _extends({}, newChildProps)
                    });

                case _HelmetConstants.TAG_NAMES.HTML:
                    return _extends({}, newProps, {
                        htmlAttributes: _extends({}, newChildProps)
                    });
            }

            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
        };

        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = _extends({}, newProps);

            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
                var _extends5;

                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
            });

            return newFlattenedProps;
        };

        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            if (false) {
                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
                    return child.type === name;
                })) {
                    if (typeof child.type === "function") {
                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
                    }

                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
                }

                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
                    return typeof nestedChild !== "string";
                }))) {
                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
                }
            }

            return true;
        };

        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;

            var arrayTypeChildren = {};

            _react2.default.Children.forEach(children, function (child) {
                if (!child || !child.props) {
                    return;
                }

                var _child$props = child.props,
                    nestedChildren = _child$props.children,
                    childProps = _objectWithoutProperties(_child$props, ["children"]);

                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);

                _this2.warnOnInvalidChildren(child, nestedChildren);

                switch (child.type) {
                    case _HelmetConstants.TAG_NAMES.LINK:
                    case _HelmetConstants.TAG_NAMES.META:
                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
                    case _HelmetConstants.TAG_NAMES.SCRIPT:
                    case _HelmetConstants.TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;

                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });

            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };

        HelmetWrapper.prototype.render = function render() {
            var _props = this.props,
                children = _props.children,
                props = _objectWithoutProperties(_props, ["children"]);

            var newProps = _extends({}, props);

            if (children) {
                newProps = this.mapChildrenToProps(children, newProps);
            }

            return _react2.default.createElement(Component, newProps);
        };

        _createClass(HelmetWrapper, null, [{
            key: "canUseDOM",


            // Component.peek comes from react-side-effect:
            // For testing, you may use a static peek() method available on the returned component.
            // It lets you get the current state without resetting the mounted instance stack.
            // Don’t use it for anything other than testing.

            /**
            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
            * @param {Object} bodyAttributes: {"className": "root"}
            * @param {String} defaultTitle: "Default Title"
            * @param {Boolean} defer: true
            * @param {Boolean} encodeSpecialCharacters: true
            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
            * @param {String} title: "Title"
            * @param {Object} titleAttributes: {"itemprop": "name"}
            * @param {String} titleTemplate: "MySite.com - %s"
            */
            set: function set(canUseDOM) {
                Component.canUseDOM = canUseDOM;
            }
        }]);

        return HelmetWrapper;
    }(_react2.default.Component), _class.propTypes = {
        base: _propTypes2.default.object,
        bodyAttributes: _propTypes2.default.object,
        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
        defaultTitle: _propTypes2.default.string,
        defer: _propTypes2.default.bool,
        encodeSpecialCharacters: _propTypes2.default.bool,
        htmlAttributes: _propTypes2.default.object,
        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
        onChangeClientState: _propTypes2.default.func,
        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
        title: _propTypes2.default.string,
        titleAttributes: _propTypes2.default.object,
        titleTemplate: _propTypes2.default.string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function () {
        var mappedState = Component.rewind();
        if (!mappedState) {
            // provide fallback if mappedState is undefined
            mappedState = (0, _HelmetUtils.mapStateOnServer)({
                baseTag: [],
                bodyAttributes: {},
                encodeSpecialCharacters: true,
                htmlAttributes: {},
                linkTags: [],
                metaTags: [],
                noscriptTags: [],
                scriptTags: [],
                styleTags: [],
                title: "",
                titleAttributes: {}
            });
        }

        return mappedState;
    }, _temp;
};

var NullComponent = function NullComponent() {
    return null;
};

var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);

var HelmetExport = Helmet(HelmetSideEffects);
HelmetExport.renderStatic = HelmetExport.rewind;

exports.Helmet = HelmetExport;
exports.default = HelmetExport;

/***/ }),

/***/ "../node_modules/react-helmet/lib/HelmetConstants.js":
/***/ (function(module, exports) {

exports.__esModule = true;
var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};

var TAG_NAMES = exports.TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};

var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
    return TAG_NAMES[name];
});

var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src"
};

var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};

var HELMET_PROPS = exports.HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};

var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
    obj[REACT_TAG_MAP[key]] = key;
    return obj;
}, {});

var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];

var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ "../node_modules/react-helmet/lib/HelmetUtils.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__("../node_modules/object-assign/index.js");

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _HelmetConstants = __webpack_require__("../node_modules/react-helmet/lib/HelmetConstants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (encode === false) {
        return String(str);
    }

    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};

var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);

    if (innermostTemplate && innermostTitle) {
        // use function arg to avoid need to escape $ characters
        return innermostTemplate.replace(/%s/g, function () {
            return innermostTitle;
        });
    }

    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);

    return innermostTitle || innermostDefaultTitle || undefined;
};

var getOnChangeClientState = function getOnChangeClientState(propsList) {
    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
};

var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function (props) {
        return typeof props[tagType] !== "undefined";
    }).map(function (props) {
        return props[tagType];
    }).reduce(function (tagAttrs, current) {
        return _extends({}, tagAttrs, current);
    }, {});
};

var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function (props) {
        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
    }).map(function (props) {
        return props[_HelmetConstants.TAG_NAMES.BASE];
    }).reverse().reduce(function (innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);

            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
                    return innermostBaseTag.concat(tag);
                }
            }
        }

        return innermostBaseTag;
    }, []);
};

var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};

    return propsList.filter(function (props) {
        if (Array.isArray(props[tagName])) {
            return true;
        }
        if (typeof props[tagName] !== "undefined") {
            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
        }
        return false;
    }).map(function (props) {
        return props[tagName];
    }).reverse().reduce(function (approvedTags, instanceTags) {
        var instanceSeenTags = {};

        instanceTags.filter(function (tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
                    primaryAttributeKey = lowerCaseAttributeKey;
                }
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
                    primaryAttributeKey = attributeKey;
                }
            }

            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
                return false;
            }

            var value = tag[primaryAttributeKey].toLowerCase();

            if (!approvedSeenTags[primaryAttributeKey]) {
                approvedSeenTags[primaryAttributeKey] = {};
            }

            if (!instanceSeenTags[primaryAttributeKey]) {
                instanceSeenTags[primaryAttributeKey] = {};
            }

            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }

            return false;
        }).reverse().forEach(function (tag) {
            return approvedTags.push(tag);
        });

        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for (var i = 0; i < keys.length; i++) {
            var attributeKey = keys[i];
            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);

            approvedSeenTags[attributeKey] = tagUnion;
        }

        return approvedTags;
    }, []).reverse();
};

var getInnermostProperty = function getInnermostProperty(propsList, property) {
    for (var i = propsList.length - 1; i >= 0; i--) {
        var props = propsList[i];

        if (props.hasOwnProperty(property)) {
            return props[property];
        }
    }

    return null;
};

var reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        onChangeClientState: getOnChangeClientState(propsList),
        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
        title: getTitleFromPropsList(propsList),
        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
    };
};

var rafPolyfill = function () {
    var clock = Date.now();

    return function (callback) {
        var currentTime = Date.now();

        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else {
            setTimeout(function () {
                rafPolyfill(callback);
            }, 0);
        }
    };
}();

var cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};

var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;

var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;

var warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};

var _helmetCallback = null;

var handleClientStateChange = function handleClientStateChange(newState) {
    if (_helmetCallback) {
        cancelAnimationFrame(_helmetCallback);
    }

    if (newState.defer) {
        _helmetCallback = requestAnimationFrame(function () {
            commitTagChanges(newState, function () {
                _helmetCallback = null;
            });
        });
    } else {
        commitTagChanges(newState);
        _helmetCallback = null;
    }
};

var commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag,
        bodyAttributes = newState.bodyAttributes,
        htmlAttributes = newState.htmlAttributes,
        linkTags = newState.linkTags,
        metaTags = newState.metaTags,
        noscriptTags = newState.noscriptTags,
        onChangeClientState = newState.onChangeClientState,
        scriptTags = newState.scriptTags,
        styleTags = newState.styleTags,
        title = newState.title,
        titleAttributes = newState.titleAttributes;

    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);

    updateTitle(title, titleAttributes);

    var tagUpdates = {
        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
    };

    var addedTags = {};
    var removedTags = {};

    Object.keys(tagUpdates).forEach(function (tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType],
            newTags = _tagUpdates$tagType.newTags,
            oldTags = _tagUpdates$tagType.oldTags;


        if (newTags.length) {
            addedTags[tagType] = newTags;
        }
        if (oldTags.length) {
            removedTags[tagType] = tagUpdates[tagType].oldTags;
        }
    });

    cb && cb();

    onChangeClientState(newState, addedTags, removedTags);
};

var flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};

var updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) {
        document.title = flattenArray(title);
    }

    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
};

var updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];

    if (!elementTag) {
        return;
    }

    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);

    for (var i = 0; i < attributeKeys.length; i++) {
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";

        if (elementTag.getAttribute(attribute) !== value) {
            elementTag.setAttribute(attribute, value);
        }

        if (helmetAttributes.indexOf(attribute) === -1) {
            helmetAttributes.push(attribute);
        }

        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) {
            attributesToRemove.splice(indexToSave, 1);
        }
    }

    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
        elementTag.removeAttribute(attributesToRemove[_i]);
    }

    if (helmetAttributes.length === attributesToRemove.length) {
        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
    }
};

var updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;

    if (tags && tags.length) {
        tags.forEach(function (tag) {
            var newElement = document.createElement(type);

            for (var attribute in tag) {
                if (tag.hasOwnProperty(attribute)) {
                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
                        newElement.innerHTML = tag.innerHTML;
                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
                        if (newElement.styleSheet) {
                            newElement.styleSheet.cssText = tag.cssText;
                        } else {
                            newElement.appendChild(document.createTextNode(tag.cssText));
                        }
                    } else {
                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                        newElement.setAttribute(attribute, value);
                    }
                }
            }

            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");

            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
            if (oldTags.some(function (existingTag, index) {
                indexToDelete = index;
                return newElement.isEqualNode(existingTag);
            })) {
                oldTags.splice(indexToDelete, 1);
            } else {
                newTags.push(newElement);
            }
        });
    }

    oldTags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function (tag) {
        return headElement.appendChild(tag);
    });

    return {
        oldTags: oldTags,
        newTags: newTags
    };
};

var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function (str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};

var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = generateElementAttributesAsString(attributes);
    var flattenedTitle = flattenArray(title);
    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};

var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function (str, tag) {
        var attributeHtml = Object.keys(tag).filter(function (attribute) {
            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function (string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
            return string ? string + " " + attr : attr;
        }, "");

        var tagContent = tag.innerHTML || tag.cssText || "";

        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;

        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};

var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(attributes).reduce(function (obj, key) {
        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};

var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(props).reduce(function (obj, key) {
        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};

var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;

    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
    var props = convertElementAttributestoReactProps(attributes, initProps);

    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
};

var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function (tag, i) {
        var _mappedTag;

        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);

        Object.keys(tag).forEach(function (attribute) {
            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;

            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = { __html: content };
            } else {
                mappedTag[mappedAttribute] = tag[attribute];
            }
        });

        return _react2.default.createElement(type, mappedTag);
    });
};

var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch (type) {
        case _HelmetConstants.TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return generateTagsAsString(type, tags, encode);
                }
            };
    }
};

var mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag,
        bodyAttributes = _ref.bodyAttributes,
        encode = _ref.encode,
        htmlAttributes = _ref.htmlAttributes,
        linkTags = _ref.linkTags,
        metaTags = _ref.metaTags,
        noscriptTags = _ref.noscriptTags,
        scriptTags = _ref.scriptTags,
        styleTags = _ref.styleTags,
        _ref$title = _ref.title,
        title = _ref$title === undefined ? "" : _ref$title,
        titleAttributes = _ref.titleAttributes;
    return {
        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
    };
};

exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
exports.handleClientStateChange = handleClientStateChange;
exports.mapStateOnServer = mapStateOnServer;
exports.reducePropsToState = reducePropsToState;
exports.requestAnimationFrame = requestAnimationFrame;
exports.warn = warn;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "../node_modules/react-hot-loader/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("../node_modules/react-hot-loader/lib/index.js")


/***/ }),

/***/ "../node_modules/react-hot-loader/lib/AppContainer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable global-require */

if (true) {
  module.exports = __webpack_require__("../node_modules/react-hot-loader/lib/AppContainer.prod.js");
} else {
  module.exports = require('./AppContainer.dev');
}

/***/ }),

/***/ "../node_modules/react-hot-loader/lib/AppContainer.prod.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/prop-types */

var React = __webpack_require__("../node_modules/react/react.js");

var Component = React.Component;

var AppContainer = function (_Component) {
  _inherits(AppContainer, _Component);

  function AppContainer() {
    _classCallCheck(this, AppContainer);

    return _possibleConstructorReturn(this, (AppContainer.__proto__ || Object.getPrototypeOf(AppContainer)).apply(this, arguments));
  }

  _createClass(AppContainer, [{
    key: 'render',
    value: function render() {
      if (this.props.component) {
        return React.createElement(this.props.component, this.props.props);
      }

      return React.Children.only(this.props.children);
    }
  }]);

  return AppContainer;
}(Component);

module.exports = AppContainer;

/***/ }),

/***/ "../node_modules/react-hot-loader/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable global-require */

if (true) {
  module.exports = __webpack_require__("../node_modules/react-hot-loader/lib/index.prod.js");
} else {
  module.exports = require('./index.dev');
}

/***/ }),

/***/ "../node_modules/react-hot-loader/lib/index.prod.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports.AppContainer = __webpack_require__("../node_modules/react-hot-loader/lib/AppContainer.js");

/***/ }),

/***/ "../node_modules/react-immutable-proptypes/dist/ImmutablePropTypes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This is a straight rip-off of the React.js ReactPropTypes.js proptype validators,
 * modified to make it possible to validate Immutable.js data.
 *     ImmutableTypes.listOf is patterned after React.PropTypes.arrayOf, but for Immutable.List
 *     ImmutableTypes.shape  is based on React.PropTypes.shape, but for any Immutable.Iterable
 */


var Immutable = __webpack_require__("../node_modules/immutable/dist/immutable.js");

var ANONYMOUS = "<<anonymous>>";

var ImmutablePropTypes = {
  listOf: createListOfTypeChecker,
  mapOf: createMapOfTypeChecker,
  orderedMapOf: createOrderedMapOfTypeChecker,
  setOf: createSetOfTypeChecker,
  orderedSetOf: createOrderedSetOfTypeChecker,
  stackOf: createStackOfTypeChecker,
  iterableOf: createIterableOfTypeChecker,
  recordOf: createRecordOfTypeChecker,
  shape: createShapeChecker,
  contains: createShapeChecker,
  mapContains: createMapContainsChecker,
  // Primitive Types
  list: createImmutableTypeChecker("List", Immutable.List.isList),
  map: createImmutableTypeChecker("Map", Immutable.Map.isMap),
  orderedMap: createImmutableTypeChecker("OrderedMap", Immutable.OrderedMap.isOrderedMap),
  set: createImmutableTypeChecker("Set", Immutable.Set.isSet),
  orderedSet: createImmutableTypeChecker("OrderedSet", Immutable.OrderedSet.isOrderedSet),
  stack: createImmutableTypeChecker("Stack", Immutable.Stack.isStack),
  seq: createImmutableTypeChecker("Seq", Immutable.Seq.isSeq),
  record: createImmutableTypeChecker("Record", function (isRecord) {
    return isRecord instanceof Immutable.Record;
  }),
  iterable: createImmutableTypeChecker("Iterable", Immutable.Iterable.isIterable)
};

function getPropType(propValue) {
  var propType = typeof propValue;
  if (Array.isArray(propValue)) {
    return "array";
  }
  if (propValue instanceof RegExp) {
    // Old webkits (at least until Android 4.0) return 'function' rather than
    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
    // passes PropTypes.object.
    return "object";
  }
  if (propValue instanceof Immutable.Iterable) {
    return "Immutable." + propValue.toSource().split(" ")[0];
  }
  return propType;
}

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    for (var _len = arguments.length, rest = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      rest[_key - 6] = arguments[_key];
    }

    propFullName = propFullName || propName;
    componentName = componentName || ANONYMOUS;
    if (props[propName] == null) {
      var locationName = location;
      if (isRequired) {
        return new Error("Required " + locationName + " `" + propFullName + "` was not specified in " + ("`" + componentName + "`."));
      }
    } else {
      return validate.apply(undefined, [props, propName, componentName, location, propFullName].concat(rest));
    }
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}

function createImmutableTypeChecker(immutableClassName, immutableClassTypeValidator) {
  function validate(props, propName, componentName, location, propFullName) {
    var propValue = props[propName];
    if (!immutableClassTypeValidator(propValue)) {
      var propType = getPropType(propValue);
      return new Error("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `" + immutableClassName + "`."));
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function createIterableTypeChecker(typeChecker, immutableClassName, immutableClassTypeValidator) {

  function validate(props, propName, componentName, location, propFullName) {
    for (var _len = arguments.length, rest = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      rest[_key - 5] = arguments[_key];
    }

    var propValue = props[propName];
    if (!immutableClassTypeValidator(propValue)) {
      var locationName = location;
      var propType = getPropType(propValue);
      return new Error("Invalid " + locationName + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an Immutable.js " + immutableClassName + "."));
    }

    if (typeof typeChecker !== "function") {
      return new Error("Invalid typeChecker supplied to `" + componentName + "` " + ("for propType `" + propFullName + "`, expected a function."));
    }

    var propValues = propValue.toArray();
    for (var i = 0, len = propValues.length; i < len; i++) {
      var error = typeChecker.apply(undefined, [propValues, i, componentName, location, "" + propFullName + "[" + i + "]"].concat(rest));
      if (error instanceof Error) {
        return error;
      }
    }
  }
  return createChainableTypeChecker(validate);
}

function createKeysTypeChecker(typeChecker) {

  function validate(props, propName, componentName, location, propFullName) {
    for (var _len = arguments.length, rest = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      rest[_key - 5] = arguments[_key];
    }

    var propValue = props[propName];
    if (typeof typeChecker !== "function") {
      return new Error("Invalid keysTypeChecker (optional second argument) supplied to `" + componentName + "` " + ("for propType `" + propFullName + "`, expected a function."));
    }

    var keys = propValue.keySeq().toArray();
    for (var i = 0, len = keys.length; i < len; i++) {
      var error = typeChecker.apply(undefined, [keys, i, componentName, location, "" + propFullName + " -> key(" + keys[i] + ")"].concat(rest));
      if (error instanceof Error) {
        return error;
      }
    }
  }
  return createChainableTypeChecker(validate);
}

function createListOfTypeChecker(typeChecker) {
  return createIterableTypeChecker(typeChecker, "List", Immutable.List.isList);
}

function createMapOfTypeCheckerFactory(valuesTypeChecker, keysTypeChecker, immutableClassName, immutableClassTypeValidator) {
  function validate() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return createIterableTypeChecker(valuesTypeChecker, immutableClassName, immutableClassTypeValidator).apply(undefined, args) || keysTypeChecker && createKeysTypeChecker(keysTypeChecker).apply(undefined, args);
  }

  return createChainableTypeChecker(validate);
}

function createMapOfTypeChecker(valuesTypeChecker, keysTypeChecker) {
  return createMapOfTypeCheckerFactory(valuesTypeChecker, keysTypeChecker, "Map", Immutable.Map.isMap);
}

function createOrderedMapOfTypeChecker(valuesTypeChecker, keysTypeChecker) {
  return createMapOfTypeCheckerFactory(valuesTypeChecker, keysTypeChecker, "OrderedMap", Immutable.OrderedMap.isOrderedMap);
}

function createSetOfTypeChecker(typeChecker) {
  return createIterableTypeChecker(typeChecker, "Set", Immutable.Set.isSet);
}

function createOrderedSetOfTypeChecker(typeChecker) {
  return createIterableTypeChecker(typeChecker, "OrderedSet", Immutable.OrderedSet.isOrderedSet);
}

function createStackOfTypeChecker(typeChecker) {
  return createIterableTypeChecker(typeChecker, "Stack", Immutable.Stack.isStack);
}

function createIterableOfTypeChecker(typeChecker) {
  return createIterableTypeChecker(typeChecker, "Iterable", Immutable.Iterable.isIterable);
}

function createRecordOfTypeChecker(recordKeys) {
  function validate(props, propName, componentName, location, propFullName) {
    for (var _len = arguments.length, rest = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      rest[_key - 5] = arguments[_key];
    }

    var propValue = props[propName];
    if (!(propValue instanceof Immutable.Record)) {
      var propType = getPropType(propValue);
      var locationName = location;
      return new Error("Invalid " + locationName + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected an Immutable.js Record."));
    }
    for (var key in recordKeys) {
      var checker = recordKeys[key];
      if (!checker) {
        continue;
      }
      var mutablePropValue = propValue.toObject();
      var error = checker.apply(undefined, [mutablePropValue, key, componentName, location, "" + propFullName + "." + key].concat(rest));
      if (error) {
        return error;
      }
    }
  }
  return createChainableTypeChecker(validate);
}

// there is some irony in the fact that shapeTypes is a standard hash and not an immutable collection
function createShapeTypeChecker(shapeTypes) {
  var immutableClassName = arguments[1] === undefined ? "Iterable" : arguments[1];
  var immutableClassTypeValidator = arguments[2] === undefined ? Immutable.Iterable.isIterable : arguments[2];

  function validate(props, propName, componentName, location, propFullName) {
    for (var _len = arguments.length, rest = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      rest[_key - 5] = arguments[_key];
    }

    var propValue = props[propName];
    if (!immutableClassTypeValidator(propValue)) {
      var propType = getPropType(propValue);
      var locationName = location;
      return new Error("Invalid " + locationName + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected an Immutable.js " + immutableClassName + "."));
    }
    var mutablePropValue = propValue.toObject();
    for (var key in shapeTypes) {
      var checker = shapeTypes[key];
      if (!checker) {
        continue;
      }
      var error = checker.apply(undefined, [mutablePropValue, key, componentName, location, "" + propFullName + "." + key].concat(rest));
      if (error) {
        return error;
      }
    }
  }
  return createChainableTypeChecker(validate);
}

function createShapeChecker(shapeTypes) {
  return createShapeTypeChecker(shapeTypes);
}

function createMapContainsChecker(shapeTypes) {
  return createShapeTypeChecker(shapeTypes, "Map", Immutable.Map.isMap);
}

module.exports = ImmutablePropTypes;

/***/ }),

/***/ "../node_modules/react-load-script/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Script = function (_React$Component) {
  _inherits(Script, _React$Component);

  // A dictionary mapping script URL to a boolean value indicating if the script
  // has failed to load.


  // A dictionary mapping script URLs to a dictionary mapping
  // component key to component for all components that are waiting
  // for the script to load.
  function Script(props) {
    _classCallCheck(this, Script);

    var _this = _possibleConstructorReturn(this, (Script.__proto__ || Object.getPrototypeOf(Script)).call(this, props));

    _this.scriptLoaderId = 'id' + _this.constructor.idCount++; // eslint-disable-line space-unary-ops, no-plusplus
    return _this;
  }

  // A counter used to generate a unique id for each component that uses
  // ScriptLoaderMixin.


  // A dictionary mapping script URL to a boolean value indicating if the script
  // has already been loaded.


  _createClass(Script, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          onError = _props.onError,
          onLoad = _props.onLoad,
          url = _props.url;


      if (this.constructor.loadedScripts[url]) {
        onLoad();
        return;
      }

      if (this.constructor.erroredScripts[url]) {
        onError();
        return;
      }

      // If the script is loading, add the component to the script's observers
      // and return. Otherwise, initialize the script's observers with the component
      // and start loading the script.
      if (this.constructor.scriptObservers[url]) {
        this.constructor.scriptObservers[url][this.scriptLoaderId] = this.props;
        return;
      }

      this.constructor.scriptObservers[url] = _defineProperty({}, this.scriptLoaderId, this.props);

      this.createScript();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var url = this.props.url;

      var observers = this.constructor.scriptObservers[url];

      // If the component is waiting for the script to load, remove the
      // component from the script's observers before unmounting the component.
      if (observers) {
        delete observers[this.scriptLoaderId];
      }
    }
  }, {
    key: 'createScript',
    value: function createScript() {
      var _this2 = this;

      var _props2 = this.props,
          onCreate = _props2.onCreate,
          url = _props2.url,
          attributes = _props2.attributes;

      var script = document.createElement('script');

      onCreate();

      // add 'data-' or non standard attributes to the script tag
      if (attributes) {
        Object.keys(attributes).forEach(function (prop) {
          return script.setAttribute(prop, attributes[prop]);
        });
      }

      script.src = url;

      // default async to true if not set with custom attributes
      if (!script.hasAttribute('async')) {
        script.async = 1;
      }

      var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(shouldRemoveObserver) {
        var observers = _this2.constructor.scriptObservers[url];
        Object.keys(observers).forEach(function (key) {
          if (shouldRemoveObserver(observers[key])) {
            delete _this2.constructor.scriptObservers[url][_this2.scriptLoaderId];
          }
        });
      };
      script.onload = function () {
        _this2.constructor.loadedScripts[url] = true;
        callObserverFuncAndRemoveObserver(function (observer) {
          observer.onLoad();
          return true;
        });
      };

      script.onerror = function () {
        _this2.constructor.erroredScripts[url] = true;
        callObserverFuncAndRemoveObserver(function (observer) {
          observer.onError();
          return true;
        });
      };

      document.body.appendChild(script);
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return Script;
}(_react2.default.Component);

Script.propTypes = {
  attributes: _propTypes.PropTypes.object, // eslint-disable-line react/forbid-prop-types
  onCreate: _propTypes.PropTypes.func,
  onError: _propTypes.PropTypes.func.isRequired,
  onLoad: _propTypes.PropTypes.func.isRequired,
  url: _propTypes.PropTypes.string.isRequired
};
Script.defaultProps = {
  attributes: {},
  onCreate: function onCreate() {},
  onError: function onError() {},
  onLoad: function onLoad() {} };
Script.scriptObservers = {};
Script.loadedScripts = {};
Script.erroredScripts = {};
Script.idCount = 0;
exports.default = Script;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/react-proptype-conditional-require/dist/isRequiredIf.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var VALIDATOR_ARG_ERROR_MESSAGE='The typeValidator argument must be a function with the signature function(props, propName, componentName).',MESSAGE_ARG_ERROR_MESSAGE='The error message is optional, but must be a string if provided.',propIsRequired=function propIsRequired(a,b,c,d){if('boolean'==typeof a)return a;return'function'==typeof a?a(b,c,d):!(!0!==!!a)&&!!a},propExists=function propExists(a,b){return Object.hasOwnProperty.call(a,b)},missingPropError=function missingPropError(a,b,c,d){return d?new Error(d):new Error('Required '+a[b]+' `'+b+'`'+(' was not specified in `'+c+'`.'))},guardAgainstInvalidArgTypes=function guardAgainstInvalidArgTypes(a,b){if('function'!=typeof a)throw new TypeError(VALIDATOR_ARG_ERROR_MESSAGE);if(!!b&&'string'!=typeof b)throw new TypeError(MESSAGE_ARG_ERROR_MESSAGE)},isRequiredIf=function isRequiredIf(a,b,c){return guardAgainstInvalidArgTypes(a,c),function(d,e,f){for(var _len=arguments.length,g=Array(3<_len?_len-3:0),_key=3;_key<_len;_key++)g[_key-3]=arguments[_key];return propIsRequired(b,d,e,f)?propExists(d,e)?a.apply(void 0,[d,e,f].concat(g)):missingPropError(d,e,f,c):a.apply(void 0,[d,e,f].concat(g));// Is not required, so just run typeValidator.
}};exports.default=isRequiredIf;

//# sourceMappingURL=isRequiredIf.js.map

/***/ }),

/***/ "../node_modules/react-router-dom/es/BrowserRouter.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__("../node_modules/warning/browser.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("../node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__ = __webpack_require__("../node_modules/history/createBrowserHistory.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__("../node_modules/react-router-dom/es/Router.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<BrowserRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { BrowserRouter as Router }`.');
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),

/***/ "../node_modules/react-router-dom/es/HashRouter.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__("../node_modules/warning/browser.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("../node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory__ = __webpack_require__("../node_modules/history/createHashHistory.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__("../node_modules/react-router-dom/es/Router.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<HashRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { HashRouter as Router }`.');
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['hashbang', 'noslash', 'slash']),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (HashRouter);

/***/ }),

/***/ "../node_modules/react-router-dom/es/Link.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__("../node_modules/invariant/browser.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore right clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ['replace', 'to', 'innerRef']); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, 'You should not use <Link> outside a <Router>');

    var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),

/***/ "../node_modules/react-router-dom/es/MemoryRouter.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__("../node_modules/react-router/es/MemoryRouter.js");
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),

/***/ "../node_modules/react-router-dom/es/NavLink.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__("../node_modules/react-router-dom/es/Route.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__("../node_modules/react-router-dom/es/Link.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref.ariaCurrent,
      rest = _objectWithoutProperties(_ref, ['to', 'exact', 'strict', 'location', 'activeClassName', 'className', 'activeStyle', 'style', 'isActive', 'ariaCurrent']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' ? to.pathname : to,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(' ') : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        'aria-current': isActive && ariaCurrent
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  ariaCurrent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['page', 'step', 'location', 'true'])
};

NavLink.defaultProps = {
  activeClassName: 'active',
  ariaCurrent: 'true'
};

/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),

/***/ "../node_modules/react-router-dom/es/Prompt.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__("../node_modules/react-router/es/Prompt.js");
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),

/***/ "../node_modules/react-router-dom/es/Redirect.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__("../node_modules/react-router/es/Redirect.js");
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),

/***/ "../node_modules/react-router-dom/es/Route.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__("../node_modules/react-router/es/Route.js");
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),

/***/ "../node_modules/react-router-dom/es/Router.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__("../node_modules/react-router/es/Router.js");
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),

/***/ "../node_modules/react-router-dom/es/StaticRouter.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__("../node_modules/react-router/es/StaticRouter.js");
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),

/***/ "../node_modules/react-router-dom/es/Switch.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__("../node_modules/react-router/es/Switch.js");
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),

/***/ "../node_modules/react-router-dom/es/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__("../node_modules/react-router-dom/es/BrowserRouter.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BrowserRouter", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__("../node_modules/react-router-dom/es/HashRouter.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "HashRouter", function() { return __WEBPACK_IMPORTED_MODULE_1__HashRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__("../node_modules/react-router-dom/es/Link.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__("../node_modules/react-router-dom/es/MemoryRouter.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MemoryRouter", function() { return __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__("../node_modules/react-router-dom/es/NavLink.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NavLink", function() { return __WEBPACK_IMPORTED_MODULE_4__NavLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__("../node_modules/react-router-dom/es/Prompt.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Prompt", function() { return __WEBPACK_IMPORTED_MODULE_5__Prompt__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__("../node_modules/react-router-dom/es/Redirect.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Redirect", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__("../node_modules/react-router-dom/es/Route.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__("../node_modules/react-router-dom/es/Router.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return __WEBPACK_IMPORTED_MODULE_8__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__("../node_modules/react-router-dom/es/StaticRouter.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StaticRouter", function() { return __WEBPACK_IMPORTED_MODULE_9__StaticRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__("../node_modules/react-router-dom/es/Switch.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Switch", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__matchPath__ = __webpack_require__("../node_modules/react-router-dom/es/matchPath.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "matchPath", function() { return __WEBPACK_IMPORTED_MODULE_11__matchPath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__withRouter__ = __webpack_require__("../node_modules/react-router-dom/es/withRouter.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withRouter", function() { return __WEBPACK_IMPORTED_MODULE_12__withRouter__["a"]; });



























/***/ }),

/***/ "../node_modules/react-router-dom/es/matchPath.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__("../node_modules/react-router/es/matchPath.js");
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),

/***/ "../node_modules/react-router-dom/es/withRouter.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__("../node_modules/react-router/es/withRouter.js");
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),

/***/ "../node_modules/react-scroll/modules/components/Button.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__("../node_modules/react/react.js");
var Helpers = __webpack_require__("../node_modules/react-scroll/modules/mixins/Helpers.js");

var Button = function (_React$Component) {
  _inherits(Button, _React$Component);

  function Button() {
    _classCallCheck(this, Button);

    return _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).apply(this, arguments));
  }

  _createClass(Button, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'input',
        this.props,
        this.props.children
      );
    }
  }]);

  return Button;
}(React.Component);

;

module.exports = Helpers.Scroll(Button);

/***/ }),

/***/ "../node_modules/react-scroll/modules/components/Element.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__("../node_modules/react/react.js");
var Helpers = __webpack_require__("../node_modules/react-scroll/modules/mixins/Helpers.js");

var Element = function (_React$Component) {
  _inherits(Element, _React$Component);

  function Element() {
    _classCallCheck(this, Element);

    return _possibleConstructorReturn(this, (Element.__proto__ || Object.getPrototypeOf(Element)).apply(this, arguments));
  }

  _createClass(Element, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      // Remove `parentBindings` from props
      var newProps = _extends({}, this.props);
      if (newProps.parentBindings) {
        delete newProps.parentBindings;
      }

      return React.createElement(
        'div',
        _extends({}, newProps, { ref: function ref(el) {
            _this2.props.parentBindings.domNode = el;
          } }),
        this.props.children
      );
    }
  }]);

  return Element;
}(React.Component);

;

module.exports = Helpers.Element(Element);

/***/ }),

/***/ "../node_modules/react-scroll/modules/components/Link.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__("../node_modules/react/react.js");
var Helpers = __webpack_require__("../node_modules/react-scroll/modules/mixins/Helpers.js");

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    _classCallCheck(this, Link);

    return _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).apply(this, arguments));
  }

  _createClass(Link, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'a',
        this.props,
        this.props.children
      );
    }
  }]);

  return Link;
}(React.Component);

;

module.exports = Helpers.Scroll(Link);

/***/ }),

/***/ "../node_modules/react-scroll/modules/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.Link = __webpack_require__("../node_modules/react-scroll/modules/components/Link.js");
exports.Button = __webpack_require__("../node_modules/react-scroll/modules/components/Button.js");
exports.Element = __webpack_require__("../node_modules/react-scroll/modules/components/Element.js");
exports.Helpers = __webpack_require__("../node_modules/react-scroll/modules/mixins/Helpers.js");
exports.scroller = __webpack_require__("../node_modules/react-scroll/modules/mixins/scroller.js");
exports.Events = __webpack_require__("../node_modules/react-scroll/modules/mixins/scroll-events.js");
exports.scrollSpy = __webpack_require__("../node_modules/react-scroll/modules/mixins/scroll-spy.js");
exports.animateScroll = __webpack_require__("../node_modules/react-scroll/modules/mixins/animate-scroll.js");

/***/ }),

/***/ "../node_modules/react-scroll/modules/mixins/Helpers.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__("../node_modules/react/react.js");
var ReactDOM = __webpack_require__("../node_modules/react-dom/index.js");

var utils = __webpack_require__("../node_modules/react-scroll/modules/mixins/utils.js");
var scrollSpy = __webpack_require__("../node_modules/react-scroll/modules/mixins/scroll-spy.js");
var defaultScroller = __webpack_require__("../node_modules/react-scroll/modules/mixins/scroller.js");
var assign = __webpack_require__("../node_modules/object-assign/index.js");
var PropTypes = __webpack_require__("../node_modules/prop-types/index.js");

var scrollHash = __webpack_require__("../node_modules/react-scroll/modules/mixins/scroll-hash.js");

var protoTypes = {
  to: PropTypes.string.isRequired,
  containerId: PropTypes.string,
  container: PropTypes.object,
  activeClass: PropTypes.string,
  spy: PropTypes.bool,
  smooth: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  offset: PropTypes.number,
  delay: PropTypes.number,
  isDynamic: PropTypes.bool,
  onClick: PropTypes.func,
  duration: PropTypes.oneOfType([PropTypes.number, PropTypes.func]),
  absolute: PropTypes.bool,
  onSetActive: PropTypes.func,
  onSetInactive: PropTypes.func,
  ignoreCancelEvents: PropTypes.bool,
  hashSpy: PropTypes.bool
};

var Helpers = {
  Scroll: function Scroll(Component, customScroller) {

    var scroller = customScroller || defaultScroller;

    var _ = function (_React$Component) {
      _inherits(_, _React$Component);

      function _(props) {
        _classCallCheck(this, _);

        var _this = _possibleConstructorReturn(this, (_.__proto__ || Object.getPrototypeOf(_)).call(this, props));

        _this.scrollTo = _this.scrollTo.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        _this.stateHandler = _this.stateHandler.bind(_this);
        _this.spyHandler = _this.spyHandler.bind(_this);

        _this.state = {
          active: false
        };
        return _this;
      }

      _createClass(_, [{
        key: 'scrollTo',
        value: function scrollTo(to, props) {
          scroller.scrollTo(to, _extends({}, this.state, props));
        }
      }, {
        key: 'handleClick',
        value: function handleClick(event) {

          /*
           * give the posibility to override onClick
           */

          if (this.props.onClick) {
            this.props.onClick(event);
          }

          /*
           * dont bubble the navigation
           */

          if (event.stopPropagation) event.stopPropagation();
          if (event.preventDefault) event.preventDefault();

          /*
           * do the magic!
           */
          this.scrollTo(this.props.to, this.props);
        }
      }, {
        key: 'stateHandler',
        value: function stateHandler() {
          var to = this.props.to;

          if (scroller.getActiveLink() !== to) {
            if (this.state !== null && this.state.active && this.props.onSetInactive) {
              this.props.onSetInactive();
            }
            this.setState({ active: false });
          }
        }
      }, {
        key: 'spyHandler',
        value: function spyHandler(y) {
          var scrollSpyContainer = this.getScrollSpyContainer();

          if (scrollHash.isMounted() && !scrollHash.isInitialized()) {
            return;
          }

          var to = this.props.to;

          var element = null;
          var elemTopBound = 0;
          var elemBottomBound = 0;

          var containerTop = 0;
          if (scrollSpyContainer.getBoundingClientRect) {
            var containerCords = scrollSpyContainer.getBoundingClientRect();
            containerTop = containerCords.top;
          }

          if (!element || this.props.isDynamic) {
            element = scroller.get(to);
            if (!element) {
              return;
            }

            var cords = element.getBoundingClientRect();
            elemTopBound = cords.top - containerTop + y;
            elemBottomBound = elemTopBound + cords.height;
          }

          var offsetY = y - this.props.offset;
          // var isInside = (offsetY >= Math.floor(elemTopBound) && offsetY <= Math.floor(elemBottomBound));
          // var isOutside = (offsetY < Math.floor(elemTopBound) || offsetY > Math.floor(elemBottomBound));
          var isInside = offsetY >= Math.floor(elemTopBound) && offsetY < Math.floor(elemBottomBound);
          var isOutside = offsetY < Math.floor(elemTopBound) || offsetY >= Math.floor(elemBottomBound);
          var activeLink = scroller.getActiveLink();

          if (isOutside) {
            if (to === activeLink) {
              scroller.setActiveLink(void 0);
            }

            if (this.props.hashSpy && scrollHash.getHash() === to) {
              scrollHash.changeHash();
            }

            if (this.props.spy && this.state.active) {
              this.setState({ active: false });

              if (this.props.onSetInactive) {
                this.props.onSetInactive();
              }
            }
          } else if (isInside && activeLink !== to) {
            scroller.setActiveLink(to);

            if (this.props.hashSpy) {
              scrollHash.changeHash(to);
            }

            if (this.props.spy) {
              this.setState({ active: true });
              if (this.props.onSetActive) {
                this.props.onSetActive(to);
              }
            }

            scrollSpy.updateStates();
          }
        }
      }, {
        key: 'getScrollSpyContainer',
        value: function getScrollSpyContainer() {
          var containerId = this.props.containerId;
          var container = this.props.container;

          var scrollSpyContainer;

          if (containerId) {
            scrollSpyContainer = document.getElementById(containerId);
          } else if (container && container.nodeType) {
            scrollSpyContainer = container;
          } else {
            scrollSpyContainer = utils.getScrollParent(ReactDOM.findDOMNode(this));
          }

          return scrollSpyContainer;
        }
      }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (this.props.spy || this.props.hashSpy) {
            var scrollSpyContainer = this.getScrollSpyContainer();

            if (!scrollSpy.isMounted(scrollSpyContainer)) {
              scrollSpy.mount(scrollSpyContainer);
            }

            if (this.props.hashSpy) {
              if (!scrollHash.isMounted()) {
                scrollHash.mount(scroller);
              }
            }

            if (this.props.spy) {
              scrollSpy.addStateHandler(this.stateHandler);
            }

            scrollSpy.addSpyHandler(this.spyHandler, scrollSpyContainer);

            this.setState({
              container: scrollSpyContainer
            });
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          scrollSpy.unmount(this.stateHandler, this.spyHandler);
        }
      }, {
        key: 'render',
        value: function render() {
          var className = "";

          if (this.state && this.state.active) {
            className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
          } else {
            className = this.props.className;
          }

          var props = assign({}, this.props);

          for (var prop in protoTypes) {
            if (props.hasOwnProperty(prop)) {
              delete props[prop];
            }
          }

          props.className = className;
          props.onClick = this.handleClick;

          return React.createElement(Component, props);
        }
      }]);

      return _;
    }(React.Component);

    ;
    _.propTypes = protoTypes;
    _.defaultProps = { offset: 0 };
    return _;
  },

  Element: function Element(Component) {
    var _ = function (_React$Component2) {
      _inherits(_, _React$Component2);

      function _(props) {
        _classCallCheck(this, _);

        var _this2 = _possibleConstructorReturn(this, (_.__proto__ || Object.getPrototypeOf(_)).call(this, props));

        _this2.registerElems = _this2.registerElems.bind(_this2);
        _this2.childBindings = {
          domNode: null
        };
        return _this2;
      }

      _createClass(_, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          this.registerElems(this.props.name);
        }
      }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
          if (this.props.name !== nextProps.name) {
            this.registerElems(nextProps.name);
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          defaultScroller.unregister(this.props.name);
        }
      }, {
        key: 'registerElems',
        value: function registerElems(name) {
          defaultScroller.register(name, this.childBindings.domNode);
        }
      }, {
        key: 'render',
        value: function render() {
          return React.createElement(Component, _extends({}, this.props, { parentBindings: this.childBindings }));
        }
      }]);

      return _;
    }(React.Component);

    ;
    _.propTypes = {
      name: PropTypes.string,
      id: PropTypes.string
    };
    return _;
  }
};

module.exports = Helpers;

/***/ }),

/***/ "../node_modules/react-scroll/modules/mixins/animate-scroll.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assign = __webpack_require__("../node_modules/object-assign/index.js");

var utils = __webpack_require__("../node_modules/react-scroll/modules/mixins/utils.js");
var smooth = __webpack_require__("../node_modules/react-scroll/modules/mixins/smooth.js");

var cancelEvents = __webpack_require__("../node_modules/react-scroll/modules/mixins/cancel-events.js");

var events = __webpack_require__("../node_modules/react-scroll/modules/mixins/scroll-events.js");

/*
 * Gets the easing type from the smooth prop within options.
 */
var getAnimationType = function getAnimationType(options) {
  return smooth[options.smooth] || smooth.defaultEasing;
};

/*
 * Function helper
 */
var functionWrapper = function functionWrapper(value) {
  return typeof value === 'function' ? value : function () {
    return value;
  };
};

/*
 * Wraps window properties to allow server side rendering
 */
var currentWindowProperties = function currentWindowProperties() {
  if (typeof window !== 'undefined') {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame;
  }
};

/*
 * Helper function to never extend 60fps on the webpage.
 */
var requestAnimationFrameHelper = function () {
  return currentWindowProperties() || function (callback, element, delay) {
    window.setTimeout(callback, delay || 1000 / 60, new Date().getTime());
  };
}();

var __currentPositionY = 0;
var __startPositionY = 0;
var __targetPositionY = 0;
var __progress = 0;
var __duration = 0;
var __cancel = false;

var __target;
var __containerElement;
var __to;
var __start;
var __deltaTop;
var __percent;
var __delayTimeout;

var currentPositionY = function currentPositionY() {
  if (__containerElement && __containerElement !== document && __containerElement !== document.body) {
    return __containerElement.scrollTop;
  } else {
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
    return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
  }
};

var scrollContainerHeight = function scrollContainerHeight() {
  if (__containerElement && __containerElement !== document && __containerElement !== document.body) {
    return Math.max(__containerElement.scrollHeight, __containerElement.offsetHeight, __containerElement.clientHeight);
  } else {
    var body = document.body;
    var html = document.documentElement;

    return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
  }
};

var animateTopScroll = function animateTopScroll(easing, timestamp) {

  // Cancel on specific events
  if (__cancel) {
    if (events.registered['end']) {
      events.registered['end'](__to, __target, __currentPositionY);
    }
    return;
  };

  __deltaTop = Math.round(__targetPositionY - __startPositionY);

  if (__start === null) {
    __start = timestamp;
  }

  __progress = timestamp - __start;

  __percent = __progress >= __duration ? 1 : easing(__progress / __duration);

  __currentPositionY = __startPositionY + Math.ceil(__deltaTop * __percent);

  if (__containerElement && __containerElement !== document && __containerElement !== document.body) {
    __containerElement.scrollTop = __currentPositionY;
  } else {
    window.scrollTo(0, __currentPositionY);
  }

  if (__percent < 1) {
    var easedAnimate = animateTopScroll.bind(null, easing);
    requestAnimationFrameHelper.call(window, easedAnimate);
    return;
  }

  if (events.registered['end']) {
    events.registered['end'](__to, __target, __currentPositionY);
  }
};

var setContainer = function setContainer(options) {
  __containerElement = !options ? null : options.containerId ? document.getElementById(options.containerId) : options.container && options.container.nodeType ? options.container : options.element && options.element.nodeType ? utils.getScrollParent(options.element) : document;
};

var startAnimateTopScroll = function startAnimateTopScroll(y, options, to, target) {

  window.clearTimeout(__delayTimeout);

  if (!options.ignoreCancelEvents) {
    /*
     * Sets the cancel trigger
     */

    cancelEvents.register(function () {
      __cancel = true;
    });
  }

  setContainer(options);

  __start = null;
  __cancel = false;
  __startPositionY = currentPositionY();
  __targetPositionY = options.absolute ? y : y + __startPositionY;
  __deltaTop = Math.round(__targetPositionY - __startPositionY);

  __duration = functionWrapper(options.duration)(__deltaTop);
  __duration = isNaN(parseFloat(__duration)) ? 1000 : parseFloat(__duration);
  __to = to;
  __target = target;

  var easing = getAnimationType(options);
  var easedAnimate = animateTopScroll.bind(null, easing);

  if (options && options.delay > 0) {
    __delayTimeout = window.setTimeout(function animate() {
      requestAnimationFrameHelper.call(window, easedAnimate);
    }, options.delay);
    return;
  }

  requestAnimationFrameHelper.call(window, easedAnimate);
};

function proceedOptions(options) {
  if (options && options.nodeType) {
    options = { element: options };
  } else {
    options = assign({}, options);
  }
  options.absolute = true;

  return options;
}

var scrollToTop = function scrollToTop(options) {
  startAnimateTopScroll(0, proceedOptions(options));
};

var scrollTo = function scrollTo(toY, options) {
  startAnimateTopScroll(toY, proceedOptions(options));
};

var scrollToBottom = function scrollToBottom(options) {
  options = proceedOptions(options);
  setContainer(options);
  startAnimateTopScroll(scrollContainerHeight(), options);
};

var scrollMore = function scrollMore(toY, options) {
  options = proceedOptions(options);
  setContainer(options);
  startAnimateTopScroll(currentPositionY() + toY, options);
};

module.exports = {
  animateTopScroll: startAnimateTopScroll,
  getAnimationType: getAnimationType,
  scrollToTop: scrollToTop,
  scrollToBottom: scrollToBottom,
  scrollTo: scrollTo,
  scrollMore: scrollMore
};

/***/ }),

/***/ "../node_modules/react-scroll/modules/mixins/cancel-events.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var addPassiveEventListener = __webpack_require__("../node_modules/react-scroll/modules/mixins/passive-event-listeners.js");

var events = ['mousedown', 'mousewheel', 'touchmove', 'keydown'];

module.exports = {
	register: function register(cancelEvent) {
		if (typeof document === 'undefined') {
			return;
		}

		for (var i = 0; i < events.length; i = i + 1) {
			addPassiveEventListener(document, events[i], cancelEvent);
		}
	}
};

/***/ }),

/***/ "../node_modules/react-scroll/modules/mixins/passive-event-listeners.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
 * Tell the browser that the event listener won't prevent a scroll.
 * Allowing the browser to continue scrolling without having to
 * to wait for the listener to return.
 */
var addPassiveEventListener = function addPassiveEventListener(target, eventName, listener) {
    var supportsPassiveOption = function () {
        var supportsPassiveOption = false;
        try {
            var opts = Object.defineProperty({}, 'passive', {
                get: function get() {
                    supportsPassiveOption = true;
                }
            });
            window.addEventListener('test', null, opts);
        } catch (e) {}
        return supportsPassiveOption;
    }();

    target.addEventListener(eventName, listener, supportsPassiveOption ? { passive: true } : false);
};

module.exports = addPassiveEventListener;

/***/ }),

/***/ "../node_modules/react-scroll/modules/mixins/scroll-events.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Events = {
	registered: {},
	scrollEvent: {
		register: function register(evtName, callback) {
			Events.registered[evtName] = callback;
		},
		remove: function remove(evtName) {
			Events.registered[evtName] = null;
		}
	}
};

module.exports = Events;

/***/ }),

/***/ "../node_modules/react-scroll/modules/mixins/scroll-hash.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var addPassiveEventListener = __webpack_require__("../node_modules/react-scroll/modules/mixins/passive-event-listeners.js");
var utils = __webpack_require__("../node_modules/react-scroll/modules/mixins/utils.js");

var scrollHash = {
  mountFlag: false,
  initialized: false,
  scroller: null,

  mount: function mount(scroller) {
    this.scroller = scroller;

    this.handleHashChange = this.handleHashChange.bind(this);
    window.addEventListener('hashchange', this.handleHashChange);

    this.initStateFromHash();
    this.mountFlag = true;
  },
  isMounted: function isMounted() {
    return this.mountFlag;
  },
  isInitialized: function isInitialized() {
    return this.initialized;
  },
  initStateFromHash: function initStateFromHash() {
    var hash = this.getHash();
    if (hash) {
      // time to all component Elements can registered in componentDidMount phase
      window.setTimeout(function () {
        this.scrollTo(hash, true);
        this.initialized = true;
      }.bind(this), 10);
    } else {
      this.initialized = true;
    }
  },
  scrollTo: function scrollTo(to, isInit) {
    var scroller = this.scroller;
    var element = scroller.get(to);
    if (element && (isInit || to !== scroller.getActiveLink())) {
      var container = utils.getScrollParent(element);
      // scroller.setActiveLink(to);
      scroller.scrollTo(to, { container: container });
    }
  },
  getHash: function getHash() {
    return utils.getHash();
  },
  changeHash: function changeHash(to) {
    if (this.isInitialized()) {
      utils.pushHash(to);
    }
  },
  handleHashChange: function handleHashChange() {
    this.scrollTo(this.getHash());
  },


  // todo - think about when unmount? (it can work without Links, while any element with id exists)
  unmount: function unmount() {
    this.scroller = null;
    window.removeEventListener('hashchange', this.handleHashChange);
  }
};

module.exports = scrollHash;

/***/ }),

/***/ "../node_modules/react-scroll/modules/mixins/scroll-spy.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var addPassiveEventListener = __webpack_require__("../node_modules/react-scroll/modules/mixins/passive-event-listeners.js");

var eventThrottler = function eventThrottler(eventHandler) {
  var eventHandlerTimeout;
  return function (event) {
    // ignore events as long as an eventHandler execution is in the queue
    if (!eventHandlerTimeout) {
      eventHandlerTimeout = setTimeout(function () {
        eventHandlerTimeout = null;
        eventHandler(event);
        // The eventHandler will execute at a rate of 15fps
      }, 66);
    }
  };
};

var scrollSpy = {

  spyCallbacks: [],
  spySetState: [],
  scrollSpyContainers: [],

  mount: function mount(scrollSpyContainer) {
    var t = this;
    if (scrollSpyContainer) {
      var eventHandler = eventThrottler(function (event) {
        t.scrollHandler(scrollSpyContainer);
      });
      this.scrollSpyContainers.push(scrollSpyContainer);
      addPassiveEventListener(scrollSpyContainer, 'scroll', eventHandler);
    }
  },

  isMounted: function isMounted(scrollSpyContainer) {
    return this.scrollSpyContainers.indexOf(scrollSpyContainer) !== -1;
  },

  currentPositionY: function currentPositionY(scrollSpyContainer) {
    if (scrollSpyContainer === document) {
      var supportPageOffset = window.pageXOffset !== undefined;
      var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
      return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
    } else {
      return scrollSpyContainer.scrollTop;
    }
  },

  scrollHandler: function scrollHandler(scrollSpyContainer) {
    var callbacks = this.scrollSpyContainers[this.scrollSpyContainers.indexOf(scrollSpyContainer)].spyCallbacks;
    if (callbacks) {
      for (var i = 0; i < callbacks.length; i++) {
        var position = this.currentPositionY(scrollSpyContainer);
        callbacks[i](position);
      }
    }
  },

  addStateHandler: function addStateHandler(handler) {
    this.spySetState.push(handler);
  },

  addSpyHandler: function addSpyHandler(handler, scrollSpyContainer) {
    var container = this.scrollSpyContainers[this.scrollSpyContainers.indexOf(scrollSpyContainer)];
    if (!container.spyCallbacks) {
      container.spyCallbacks = [];
    }
    container.spyCallbacks.push(handler);
  },

  updateStates: function updateStates() {
    var length = this.spySetState.length;

    for (var i = 0; i < length; i++) {
      this.spySetState[i]();
    }
  },

  unmount: function unmount(stateHandler, spyHandler) {
    for (var i = 0; i < this.scrollSpyContainers.length; i++) {
      var callbacks = this.scrollSpyContainers[i].spyCallbacks;
      if (callbacks && callbacks.length) {
        callbacks.splice(callbacks.indexOf(spyHandler), 1);
      }
    }

    if (this.spySetState && this.spySetState.length) {
      this.spySetState.splice(this.spySetState.indexOf(stateHandler), 1);
    }

    document.removeEventListener('scroll', this.scrollHandler);
  },

  update: function update() {
    for (var i = 0; i < this.scrollSpyContainers.length; i++) {
      this.scrollHandler(this.scrollSpyContainers[i]);
    }
  }
};

module.exports = scrollSpy;

/***/ }),

/***/ "../node_modules/react-scroll/modules/mixins/scroller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assign = __webpack_require__("../node_modules/object-assign/index.js");

var utils = __webpack_require__("../node_modules/react-scroll/modules/mixins/utils.js");
var animateScroll = __webpack_require__("../node_modules/react-scroll/modules/mixins/animate-scroll.js");
var events = __webpack_require__("../node_modules/react-scroll/modules/mixins/scroll-events.js");

var __mapped = {};
var __activeLink;

module.exports = {

  unmount: function unmount() {
    __mapped = {};
  },

  register: function register(name, element) {
    __mapped[name] = element;
  },

  unregister: function unregister(name) {
    delete __mapped[name];
  },

  get: function get(name) {
    return __mapped[name] || document.getElementById(name);
  },

  setActiveLink: function setActiveLink(link) {
    __activeLink = link;
  },

  getActiveLink: function getActiveLink() {
    return __activeLink;
  },

  scrollTo: function scrollTo(to, props) {

    /*
    * get the mapped DOM element
    */

    var target = this.get(to);

    if (!target) {
      console.warn("target Element not found");
      return;
    }

    props = assign({}, props, { absolute: false });

    if (events.registered['begin']) {
      events.registered['begin'](to, target);
    }

    var containerId = props.containerId;
    var container = props.container;

    var containerElement;
    if (containerId) {
      containerElement = document.getElementById(containerId);
    } else if (container && container.nodeType) {
      containerElement = container;
    } else {
      containerElement = utils.getScrollParent(target);
    }

    props.absolute = true;
    var scrollOffset;
    if (containerElement === document) {
      scrollOffset = target.offsetTop;
    } else {
      var coordinates = target.getBoundingClientRect();
      scrollOffset = containerElement.scrollTop + coordinates.top - containerElement.offsetTop;
    }

    scrollOffset += props.offset || 0;

    /*
     * if animate is not provided just scroll into the view
     */
    if (!props.smooth) {
      if (containerElement === document) {
        // window.scrollTo accepts only absolute values so body rectangle needs to be subtracted
        window.scrollTo(0, scrollOffset);
      } else {
        containerElement.scrollTop = scrollOffset;
      }

      if (events.registered['end']) {
        events.registered['end'](to, target);
      }

      return;
    }

    /*
     * Animate scrolling
     */

    animateScroll.animateTopScroll(scrollOffset, props, to, target);
  }
};

/***/ }),

/***/ "../node_modules/react-scroll/modules/mixins/smooth.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  /*
   * https://github.com/oblador/angular-scroll (duScrollDefaultEasing)
   */
  defaultEasing: function defaultEasing(x) {
    if (x < 0.5) {
      return Math.pow(x * 2, 2) / 2;
    }
    return 1 - Math.pow((1 - x) * 2, 2) / 2;
  },
  /*
   * https://gist.github.com/gre/1650294
   */
  // no easing, no acceleration
  linear: function linear(x) {
    return x;
  },
  // accelerating from zero velocity
  easeInQuad: function easeInQuad(x) {
    return x * x;
  },
  // decelerating to zero velocity
  easeOutQuad: function easeOutQuad(x) {
    return x * (2 - x);
  },
  // acceleration until halfway, then deceleration
  easeInOutQuad: function easeInOutQuad(x) {
    return x < .5 ? 2 * x * x : -1 + (4 - 2 * x) * x;
  },
  // accelerating from zero velocity 
  easeInCubic: function easeInCubic(x) {
    return x * x * x;
  },
  // decelerating to zero velocity π
  easeOutCubic: function easeOutCubic(x) {
    return --x * x * x + 1;
  },
  // acceleration until halfway, then deceleration 
  easeInOutCubic: function easeInOutCubic(x) {
    return x < .5 ? 4 * x * x * x : (x - 1) * (2 * x - 2) * (2 * x - 2) + 1;
  },
  // accelerating from zero velocity 
  easeInQuart: function easeInQuart(x) {
    return x * x * x * x;
  },
  // decelerating to zero velocity 
  easeOutQuart: function easeOutQuart(x) {
    return 1 - --x * x * x * x;
  },
  // acceleration until halfway, then deceleration
  easeInOutQuart: function easeInOutQuart(x) {
    return x < .5 ? 8 * x * x * x * x : 1 - 8 * --x * x * x * x;
  },
  // accelerating from zero velocity
  easeInQuint: function easeInQuint(x) {
    return x * x * x * x * x;
  },
  // decelerating to zero velocity
  easeOutQuint: function easeOutQuint(x) {
    return 1 + --x * x * x * x * x;
  },
  // acceleration until halfway, then deceleration 
  easeInOutQuint: function easeInOutQuint(x) {
    return x < .5 ? 16 * x * x * x * x * x : 1 + 16 * --x * x * x * x * x;
  }
};

/***/ }),

/***/ "../node_modules/react-scroll/modules/mixins/utils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function getScrollParent(element, includeHidden) {
  var style = getComputedStyle(element);
  var excludeStaticParent = style.position === "absolute";
  var overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/;

  if (style.position === "fixed") {
    return document;
  }
  for (var parent = element; parent = parent.parentElement;) {
    style = getComputedStyle(parent);
    if (excludeStaticParent && style.position === "static") {
      continue;
    }
    if (overflowRegex.test(style.overflow + style.overflowY + style.overflowX)) {
      return parent;
    }
  }

  return document;
}

function pushHash(hash) {
  hash = hash ? hash.indexOf('#') === 0 ? hash : '#' + hash : '';

  if (history.pushState) {
    var loc = window.location;
    history.pushState(null, null, hash ? hash
    // remove hash
    : loc.pathname + loc.search);
  } else {
    location.hash = hash;
  }
}

function getHash() {
  return window.location.hash.replace(/^#/, '');
}

module.exports = {
  getScrollParent: getScrollParent,
  pushHash: pushHash,
  getHash: getHash
};

/***/ }),

/***/ "../node_modules/react-side-effect/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _exenv = __webpack_require__("../node_modules/exenv/index.js");

var _exenv2 = _interopRequireDefault(_exenv);

var _shallowequal = __webpack_require__("../node_modules/shallowequal/index.js");

var _shallowequal2 = _interopRequireDefault(_shallowequal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }
  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }
  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state = void 0;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect = function (_Component) {
      _inherits(SideEffect, _Component);

      function SideEffect() {
        _classCallCheck(this, SideEffect);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      // Try to use displayName of wrapped component
      SideEffect.peek = function peek() {
        return state;
      };

      // Expose canUseDOM so tests can monkeypatch it


      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return !(0, _shallowequal2.default)(nextProps, this.props);
      };

      SideEffect.prototype.componentWillMount = function componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      SideEffect.prototype.render = function render() {
        return _react2.default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(_react.Component);

    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
    SideEffect.canUseDOM = _exenv2.default.canUseDOM;


    return SideEffect;
  };
};

/***/ }),

/***/ "../node_modules/react-smooth-collapse/js/getTransitionTimeMs.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getTransitionTimeMs;
function getTransitionTimeMs(heightTransition) {
  var m = /(\d+(?:\.\d+)?|\.\d+)(m?s)\b/i.exec(heightTransition);
  if (!m) throw new Error('Could not parse time from transition value');
  return Number(m[1]) * (m[2].length === 1 ? 1000 : 1);
}
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9nZXRUcmFuc2l0aW9uVGltZU1zLmpzIl0sIm5hbWVzIjpbImdldFRyYW5zaXRpb25UaW1lTXMiLCJoZWlnaHRUcmFuc2l0aW9uIiwibSIsImV4ZWMiLCJFcnJvciIsIk51bWJlciIsImxlbmd0aCJdLCJtYXBwaW5ncyI6Ijs7Ozs7a0JBRXdCQSxtQjtBQUFULFNBQVNBLG1CQUFULENBQTZCQyxnQkFBN0IsRUFBK0Q7QUFDNUUsTUFBTUMsSUFBSSxnQ0FBZ0NDLElBQWhDLENBQXFDRixnQkFBckMsQ0FBVjtBQUNBLE1BQUksQ0FBQ0MsQ0FBTCxFQUFRLE1BQU0sSUFBSUUsS0FBSixDQUFVLDRDQUFWLENBQU47QUFDUixTQUFPQyxPQUFPSCxFQUFFLENBQUYsQ0FBUCxLQUFnQkEsRUFBRSxDQUFGLEVBQUtJLE1BQUwsS0FBZ0IsQ0FBaEIsR0FBb0IsSUFBcEIsR0FBMkIsQ0FBM0MsQ0FBUDtBQUNEIiwiZmlsZSI6ImdldFRyYW5zaXRpb25UaW1lTXMuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvKiBAZmxvdyAqL1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBnZXRUcmFuc2l0aW9uVGltZU1zKGhlaWdodFRyYW5zaXRpb246IHN0cmluZyk6IG51bWJlciB7XG4gIGNvbnN0IG0gPSAvKFxcZCsoPzpcXC5cXGQrKT98XFwuXFxkKykobT9zKVxcYi9pLmV4ZWMoaGVpZ2h0VHJhbnNpdGlvbik7XG4gIGlmICghbSkgdGhyb3cgbmV3IEVycm9yKCdDb3VsZCBub3QgcGFyc2UgdGltZSBmcm9tIHRyYW5zaXRpb24gdmFsdWUnKTtcbiAgcmV0dXJuIE51bWJlcihtWzFdKSAqIChtWzJdLmxlbmd0aCA9PT0gMSA/IDEwMDAgOiAxKTtcbn1cbiJdfQ==

/***/ }),

/***/ "../node_modules/react-smooth-collapse/js/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__("../node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("../node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("../node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("../node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _kefir = __webpack_require__("../node_modules/kefir/dist/kefir.js");

var _kefir2 = _interopRequireDefault(_kefir);

var _kefirBus = __webpack_require__("../node_modules/kefir-bus/index.js");

var _kefirBus2 = _interopRequireDefault(_kefirBus);

var _getTransitionTimeMs = __webpack_require__("../node_modules/react-smooth-collapse/js/getTransitionTimeMs.js");

var _getTransitionTimeMs2 = _interopRequireDefault(_getTransitionTimeMs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SmoothCollapse = function (_React$Component) {
  (0, _inherits3.default)(SmoothCollapse, _React$Component);

  function SmoothCollapse(props) {
    (0, _classCallCheck3.default)(this, SmoothCollapse);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SmoothCollapse.__proto__ || (0, _getPrototypeOf2.default)(SmoothCollapse)).call(this, props));

    _this._resetter = (0, _kefirBus2.default)();
    _this._mainEl = null;
    _this._innerEl = null;

    _this._mainElSetter = function (el) {
      _this._mainEl = el;
    };

    _this._innerElSetter = function (el) {
      _this._innerEl = el;
    };

    _this.state = {
      hasBeenVisibleBefore: props.expanded || _this._visibleWhenClosed(),
      fullyClosed: !props.expanded,
      height: props.expanded ? 'auto' : props.collapsedHeight
    };
    return _this;
  }

  (0, _createClass3.default)(SmoothCollapse, [{
    key: '_visibleWhenClosed',
    value: function _visibleWhenClosed(props) {
      if (!props) props = this.props;
      return parseFloat(props.collapsedHeight) !== 0;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._resetter.emit(null);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (!this.props.expanded && nextProps.expanded) {
        this._resetter.emit(null);

        // In order to expand, we need to know the height of the children, so we
        // need to setState first so they get rendered before we continue.

        this.setState({
          fullyClosed: false,
          hasBeenVisibleBefore: true
        }, function () {
          var mainEl = _this2._mainEl;
          var innerEl = _this2._innerEl;
          if (!mainEl || !innerEl) throw new Error('Should not happen');

          // Set the collapser to the target height instead of auto so that it
          // animates correctly. Then switch it to 'auto' after the animation so
          // that it flows correctly if the page is resized.
          var targetHeight = innerEl.clientHeight + 'px';
          _this2.setState({
            height: targetHeight
          });

          // Wait until the transitionend event, or until a timer goes off in
          // case the event doesn't fire because the browser doesn't support it
          // or the element is hidden before it happens. The timer is a little
          // longer than the transition is supposed to take to make sure we don't
          // cut the animation early while it's still going if the browser is
          // running it just a little slow.
          _kefir2.default.fromEvents(mainEl, 'transitionend').merge(_kefir2.default.later((0, _getTransitionTimeMs2.default)(nextProps.heightTransition) * 1.1 + 500)).takeUntilBy(_this2._resetter).take(1).onValue(function () {
            _this2.setState({
              height: 'auto'
            }, function () {
              if (_this2.props.onChangeEnd) {
                _this2.props.onChangeEnd();
              }
            });
          });
        });
      } else if (this.props.expanded && !nextProps.expanded) {
        this._resetter.emit(null);

        if (!this._innerEl) throw new Error('Should not happen');
        this.setState({
          height: this._innerEl.clientHeight + 'px'
        }, function () {
          var mainEl = _this2._mainEl;
          if (!mainEl) throw new Error('Should not happen');

          mainEl.clientHeight; // force the page layout
          _this2.setState({
            height: nextProps.collapsedHeight
          });

          // See comment above about previous use of transitionend event.
          _kefir2.default.fromEvents(mainEl, 'transitionend').merge(_kefir2.default.later((0, _getTransitionTimeMs2.default)(nextProps.heightTransition) * 1.1 + 500)).takeUntilBy(_this2._resetter).take(1).onValue(function () {
            _this2.setState({
              fullyClosed: true
            });
            if (_this2.props.onChangeEnd) {
              _this2.props.onChangeEnd();
            }
          });
        });
      } else if (!nextProps.expanded && this.props.collapsedHeight !== nextProps.collapsedHeight) {
        this.setState({
          hasBeenVisibleBefore: this.state.hasBeenVisibleBefore || this._visibleWhenClosed(nextProps),
          height: nextProps.collapsedHeight
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var visibleWhenClosed = this._visibleWhenClosed();
      var _state = this.state,
          height = _state.height,
          fullyClosed = _state.fullyClosed,
          hasBeenVisibleBefore = _state.hasBeenVisibleBefore;

      var innerEl = hasBeenVisibleBefore ? _react2.default.createElement(
        'div',
        { ref: this._innerElSetter, style: { overflow: 'hidden' } },
        this.props.children
      ) : null;

      return _react2.default.createElement(
        'div',
        {
          ref: this._mainElSetter,
          style: {
            height: height, overflow: 'hidden',
            display: fullyClosed && !visibleWhenClosed ? 'none' : null,
            transition: 'height ' + this.props.heightTransition
          }
        },
        innerEl
      );
    }
  }]);
  return SmoothCollapse;
}(_react2.default.Component);

SmoothCollapse.propTypes = {
  expanded: _propTypes2.default.bool.isRequired,
  onChangeEnd: _propTypes2.default.func,
  collapsedHeight: _propTypes2.default.string,
  heightTransition: _propTypes2.default.string
};
SmoothCollapse.defaultProps = {
  collapsedHeight: '0',
  heightTransition: '.25s ease'
};
exports.default = SmoothCollapse;
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ "../node_modules/react-sticky-fill/lib/components/ReactStickyfill.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; desc = parent = getter = undefined; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _stickyfill = __webpack_require__("../node_modules/stickyfill/index.js");

var _stickyfill2 = _interopRequireDefault(_stickyfill);

var _cssSupports = __webpack_require__("../node_modules/css-supports/index.js");

var _cssSupports2 = _interopRequireDefault(_cssSupports);

_cssSupports2['default'].shim();

var stickyfill = (0, _stickyfill2['default'])();

var ReactStickyfill = (function (_React$PureComponent) {
  _inherits(ReactStickyfill, _React$PureComponent);

  function ReactStickyfill() {
    _classCallCheck(this, ReactStickyfill);

    _get(Object.getPrototypeOf(ReactStickyfill.prototype), 'constructor', this).apply(this, arguments);
  }

  _createClass(ReactStickyfill, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      stickyfill.add(this.stickyElement);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      stickyfill.remove(this.stickyElement);
    }
  }, {
    key: '_getPositionStyleValue',
    value: function _getPositionStyleValue() {
      var isStickySupported = CSS.supports('position', 'sticky');

      return isStickySupported ? 'sticky' : '-webkit-sticky';
    }
  }, {
    key: 'render',
    value: function render() {
      var _this = this;

      return _react2['default'].createElement('div', _extends({}, this.props, {
        ref: function (el) {
          _this.stickyElement = el;
        },
        style: _extends({
          top: 0,
          zIndex: 1,
          position: this._getPositionStyleValue()
        }, this.props.style)
      }));
    }
  }]);

  return ReactStickyfill;
})(_react2['default'].PureComponent);

ReactStickyfill.displayName = 'ReactStickyfill';

ReactStickyfill.propTypes = {
  children: _propTypes2['default'].element,
  className: _propTypes2['default'].string
};

exports['default'] = ReactStickyfill;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/react-sticky-fill/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _componentsReactStickyfill = __webpack_require__("../node_modules/react-sticky-fill/lib/components/ReactStickyfill.js");

var _componentsReactStickyfill2 = _interopRequireDefault(_componentsReactStickyfill);

exports['default'] = _componentsReactStickyfill2['default'];
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/react-themeable/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }

var _objectAssign = __webpack_require__("../node_modules/react-themeable/node_modules/object-assign/index.js");

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var truthy = function truthy(x) {
  return x;
};

exports['default'] = function (input) {
  var _ref = Array.isArray(input) && input.length === 2 ? input : [input, null];

  var _ref2 = _slicedToArray(_ref, 2);

  var theme = _ref2[0];
  var classNameDecorator = _ref2[1];

  return function (key) {
    for (var _len = arguments.length, names = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      names[_key - 1] = arguments[_key];
    }

    var styles = names.map(function (name) {
      return theme[name];
    }).filter(truthy);

    return typeof styles[0] === 'string' || typeof classNameDecorator === 'function' ? { key: key, className: classNameDecorator ? classNameDecorator.apply(undefined, _toConsumableArray(styles)) : styles.join(' ') } : { key: key, style: _objectAssign2['default'].apply(undefined, [{}].concat(_toConsumableArray(styles))) };
  };
};

module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/react-themeable/node_modules/object-assign/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function ToObject(val) {
	if (val == null) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function ownEnumerableKeys(obj) {
	var keys = Object.getOwnPropertyNames(obj);

	if (Object.getOwnPropertySymbols) {
		keys = keys.concat(Object.getOwnPropertySymbols(obj));
	}

	return keys.filter(function (key) {
		return propIsEnumerable.call(obj, key);
	});
}

module.exports = Object.assign || function (target, source) {
	var from;
	var keys;
	var to = ToObject(target);

	for (var s = 1; s < arguments.length; s++) {
		from = arguments[s];
		keys = ownEnumerableKeys(Object(from));

		for (var i = 0; i < keys.length; i++) {
			to[keys[i]] = from[keys[i]];
		}
	}

	return to;
};


/***/ }),

/***/ "../node_modules/reactive-container/dist/SizeStore.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SizeStore = function () {
  function SizeStore(size) {
    _classCallCheck(this, SizeStore);

    this.size = size;
    this.subscriptions = [];
  }

  _createClass(SizeStore, [{
    key: 'setSize',
    value: function setSize(size) {
      this.size = size;
      this.subscriptions.forEach(function (subscription) {
        return subscription();
      });
    }
  }, {
    key: 'subscribe',
    value: function subscribe(subscription) {
      this.subscriptions.push(subscription);
    }
  }, {
    key: 'unsubscribe',
    value: function unsubscribe(subscription) {
      (0, _lodash.remove)(this.subscriptions, function (sub) {
        return sub === subscription;
      });
    }
  }]);

  return SizeStore;
}();

exports.default = SizeStore;

/***/ }),

/***/ "../node_modules/reactive-container/dist/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var sizes = exports.sizes = {
  XS: 'XS',
  SM: 'SM',
  MD: 'MD',
  LG: 'LG',
  XL: 'XL'
};

var DEFAULT_MIN_ADJUSTMENT = exports.DEFAULT_MIN_ADJUSTMENT = 10;
var DEFAULT_SIZE = exports.DEFAULT_SIZE = sizes.XS;
var DEFAULT_THROTTLE_MS = exports.DEFAULT_THROTTLE_MS = 250;

/***/ }),

/***/ "../node_modules/reactive-container/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withSize = exports.makeReactiveContainer = exports.sizes = undefined;

var _constants = __webpack_require__("../node_modules/reactive-container/dist/constants.js");

var _makeReactiveContainer = __webpack_require__("../node_modules/reactive-container/dist/makeReactiveContainer.js");

var _makeReactiveContainer2 = _interopRequireDefault(_makeReactiveContainer);

var _withSize = __webpack_require__("../node_modules/reactive-container/dist/withSize.js");

var _withSize2 = _interopRequireDefault(_withSize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.sizes = _constants.sizes;
exports.makeReactiveContainer = _makeReactiveContainer2.default;
exports.withSize = _withSize2.default;

/***/ }),

/***/ "../node_modules/reactive-container/dist/makeReactiveContainer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _elementResizeDetector = __webpack_require__("../node_modules/element-resize-detector/src/element-resize-detector.js");

var _elementResizeDetector2 = _interopRequireDefault(_elementResizeDetector);

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _constants = __webpack_require__("../node_modules/reactive-container/dist/constants.js");

var _SizeStore = __webpack_require__("../node_modules/reactive-container/dist/SizeStore.js");

var _SizeStore2 = _interopRequireDefault(_SizeStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var makeReactiveContainer = function makeReactiveContainer() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      defaultSize = _ref.defaultSize,
      minAdjustment = _ref.minAdjustment,
      throttleMS = _ref.throttleMS;

  return function (Container) {
    var _class, _temp2;

    return _temp2 = _class = function (_Component) {
      _inherits(Reactive, _Component);

      function Reactive() {
        var _ref2;

        var _temp, _this, _ret;

        _classCallCheck(this, Reactive);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Reactive.__proto__ || Object.getPrototypeOf(Reactive)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {}, _this.getSize = function (width, breakpoints) {
          var sortedBreakpoints = (0, _lodash.sortBy)(breakpoints, function (bp) {
            return bp.minWidth;
          });
          if (width < (0, _lodash.first)(sortedBreakpoints).minWidth) {
            return _this.props.defaultSize;
          }
          var largestBreakpoint = (0, _lodash.last)(sortedBreakpoints);
          if (width >= largestBreakpoint.minWidth) {
            return largestBreakpoint.name;
          }
          var idx = (0, _lodash.findLastIndex)(sortedBreakpoints, function (bp) {
            return width >= bp.minWidth;
          });
          var breakpoint = sortedBreakpoints[idx];
          return breakpoint.name;
        }, _this.setRef = function (element) {
          _this.element = element;
        }, _this.setWidth = function () {
          var _this$element$getBoun = _this.element.getBoundingClientRect(),
              width = _this$element$getBoun.width;

          var savedWidth = _this.state.width;
          if (width <= savedWidth - _this.props.minAdjustment || width >= savedWidth + _this.props.minAdjustment || !savedWidth) {
            _this.setState({ width: width });
            var size = _this.getSize(width, _this.props.breakpoints);
            _this.sizeStore.setSize(size);
          }
        }, _this.resizeEventHandler = function () {
          _this.setWidth();
        }, _temp), _possibleConstructorReturn(_this, _ret);
      }

      _createClass(Reactive, [{
        key: 'getChildContext',
        value: function getChildContext() {
          return {
            sizeStore: this.sizeStore
          };
        }
      }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
          this.sizeStore = new _SizeStore2.default(this.props.defaultSize);
          this.elementResizeDetector = (0, _elementResizeDetector2.default)();
        }
      }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
          this.setWidth();
          this.elementResizeDetector.listenTo(this.element, (0, _lodash.throttle)(this.resizeEventHandler, this.props.throttleMS));
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          this.elementResizeDetector.removeAllListeners(this.element);
        }
      }, {
        key: 'render',
        value: function render() {
          var componentProps = (0, _lodash.omit)(this.props, ['breakpoints', 'defaultSize', 'minAdjustment', 'throttleMS']);

          return _react2.default.createElement(Container, _extends({
            innerRef: this.setRef,
            size: this.sizeStore.size
          }, componentProps));
        }
      }]);

      return Reactive;
    }(_react.Component), _class.childContextTypes = {
      sizeStore: _propTypes2.default.object.isRequired
    }, _class.displayName = 'Reactive(' + (Container.displayName || Container.name) + ')', _class.propTypes = {
      breakpoints: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        name: _propTypes2.default.string.isRequired,
        minWidth: _propTypes2.default.number.isRequired
      })).isRequired,
      defaultSize: _propTypes2.default.string.isRequired,
      minAdjustment: _propTypes2.default.number,
      throttleMS: _propTypes2.default.number
    }, _class.defaultProps = {
      defaultSize: defaultSize || _constants.DEFAULT_SIZE,
      minAdjustment: minAdjustment || _constants.DEFAULT_MIN_ADJUSTMENT,
      throttleMS: throttleMS || _constants.DEFAULT_THROTTLE_MS
    }, _temp2;
  };
};

exports.default = makeReactiveContainer;

/***/ }),

/***/ "../node_modules/reactive-container/dist/withSize.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var withSize = function withSize(ComponentWithSize) {
  var _class, _temp2;

  return _temp2 = _class = function (_Component) {
    _inherits(AddContextSizeToProps, _Component);

    function AddContextSizeToProps() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, AddContextSizeToProps);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AddContextSizeToProps.__proto__ || Object.getPrototypeOf(AddContextSizeToProps)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.handleSubscriptionEvents = function () {
        var size = _this.sizeStore().size;
        if (size !== _this.state.size) {
          _this.setState({ size: size });
        }
      }, _this.sizeStore = function () {
        return _this.context.sizeStore ? _this.context.sizeStore : {
          size: '',
          subscribe: _lodash.noop,
          unsubscribe: _lodash.noop
        };
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(AddContextSizeToProps, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        this.setState({ size: this.sizeStore().size });
        this.sizeStore().subscribe(this.handleSubscriptionEvents);
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.sizeStore().unsubscribe(this.handleSubscriptionEvents);
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(ComponentWithSize, _extends({ size: this.state.size }, this.props));
      }
    }]);

    return AddContextSizeToProps;
  }(_react.Component), _class.contextTypes = {
    sizeStore: _propTypes2.default.object
  }, _class.displayName = 'withSize(' + (ComponentWithSize.displayName || ComponentWithSize.name) + ')', _temp2;
};

exports.default = withSize;

/***/ }),

/***/ "../node_modules/readable-stream/duplex-browser.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("../node_modules/readable-stream/lib/_stream_duplex.js");


/***/ }),

/***/ "../node_modules/readable-stream/lib/_stream_duplex.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/

var processNextTick = __webpack_require__("../node_modules/process-nextick-args/index.js");
/*</replacement>*/

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var util = __webpack_require__("../node_modules/core-util-is/lib/util.js");
util.inherits = __webpack_require__("../node_modules/inherits/inherits_browser.js");
/*</replacement>*/

var Readable = __webpack_require__("../node_modules/readable-stream/lib/_stream_readable.js");
var Writable = __webpack_require__("../node_modules/readable-stream/lib/_stream_writable.js");

util.inherits(Duplex, Readable);

var keys = objectKeys(Writable.prototype);
for (var v = 0; v < keys.length; v++) {
  var method = keys[v];
  if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  processNextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

Object.defineProperty(Duplex.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

Duplex.prototype._destroy = function (err, cb) {
  this.push(null);
  this.end();

  processNextTick(cb, err);
};

function forEach(xs, f) {
  for (var i = 0, l = xs.length; i < l; i++) {
    f(xs[i], i);
  }
}

/***/ }),

/***/ "../node_modules/readable-stream/lib/_stream_passthrough.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;

var Transform = __webpack_require__("../node_modules/readable-stream/lib/_stream_transform.js");

/*<replacement>*/
var util = __webpack_require__("../node_modules/core-util-is/lib/util.js");
util.inherits = __webpack_require__("../node_modules/inherits/inherits_browser.js");
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),

/***/ "../node_modules/readable-stream/lib/_stream_readable.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var processNextTick = __webpack_require__("../node_modules/process-nextick-args/index.js");
/*</replacement>*/

module.exports = Readable;

/*<replacement>*/
var isArray = __webpack_require__("../node_modules/isarray/index.js");
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = __webpack_require__("../node_modules/events/events.js").EventEmitter;

var EElistenerCount = function (emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__("../node_modules/readable-stream/lib/internal/streams/stream-browser.js");
/*</replacement>*/

// TODO(bmeurer): Change this back to const once hole checks are
// properly optimized away early in Ignition+TurboFan.
/*<replacement>*/
var Buffer = __webpack_require__("../node_modules/safe-buffer/index.js").Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
/*</replacement>*/

/*<replacement>*/
var util = __webpack_require__("../node_modules/core-util-is/lib/util.js");
util.inherits = __webpack_require__("../node_modules/inherits/inherits_browser.js");
/*</replacement>*/

/*<replacement>*/
var debugUtil = __webpack_require__(1);
var debug = void 0;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

var BufferList = __webpack_require__("../node_modules/readable-stream/lib/internal/streams/BufferList.js");
var destroyImpl = __webpack_require__("../node_modules/readable-stream/lib/internal/streams/destroy.js");
var StringDecoder;

util.inherits(Readable, Stream);

var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') {
    return emitter.prependListener(event, fn);
  } else {
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
  }
}

function ReadableState(options, stream) {
  Duplex = Duplex || __webpack_require__("../node_modules/readable-stream/lib/_stream_duplex.js");

  options = options || {};

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
  this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = __webpack_require__("../node_modules/string_decoder/index.js").StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || __webpack_require__("../node_modules/readable-stream/lib/_stream_duplex.js");

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options) {
    if (typeof options.read === 'function') this._read = options.read;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }

  Stream.call(this);
}

Object.defineProperty(Readable.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});

Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  this.push(null);
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;

  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }

  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};

function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      stream.emit('error', er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }

      if (addToFront) {
        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        stream.emit('error', new Error('stream.push() after EOF'));
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
    }
  }

  return needMoreData(state);
}

function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    stream.emit('data', chunk);
    stream.read(0);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}

function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = __webpack_require__("../node_modules/string_decoder/index.js").StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;

  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  } else {
    state.length -= n;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) processNextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    processNextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('_read() is not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) processNextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  // If the user pushes more data while we're writing to dest then we'll end up
  // in ondata again. However, we only want to increase awaitDrain once because
  // dest will only emit one 'drain' event for the multiple writes.
  // => Introduce a guard on increasing awaitDrain.
  var increasedAwaitDrain = false;
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    increasedAwaitDrain = false;
    var ret = dest.write(chunk);
    if (false === ret && !increasedAwaitDrain) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', src._readableState.awaitDrain);
        src._readableState.awaitDrain++;
        increasedAwaitDrain = true;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = { hasUnpiped: false };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, unpipeInfo);
    }return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;

  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this, unpipeInfo);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  if (ev === 'data') {
    // Start flowing on next tick if stream isn't explicitly paused
    if (this._readableState.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    var state = this._readableState;
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.emittedReadable = false;
      if (!state.reading) {
        processNextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    processNextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  state.awaitDrain = 0;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null) {}
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var state = this._readableState;
  var paused = false;

  var self = this;
  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) self.push(chunk);
    }

    self.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = self.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], self.emit.bind(self, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  self._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return self;
};

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;

  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
  }

  return ret;
}

// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
  var ret;
  if (n < list.head.data.length) {
    // slice is the same for buffers and strings
    ret = list.head.data.slice(0, n);
    list.head.data = list.head.data.slice(n);
  } else if (n === list.head.data.length) {
    // first chunk is a perfect match
    ret = list.shift();
  } else {
    // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
  }
  return ret;
}

// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
  var p = list.head;
  var c = 1;
  var ret = p.data;
  n -= ret.length;
  while (p = p.next) {
    var str = p.data;
    var nb = n > str.length ? str.length : n;
    if (nb === str.length) ret += str;else ret += str.slice(0, n);
    n -= nb;
    if (n === 0) {
      if (nb === str.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = str.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
  var ret = Buffer.allocUnsafe(n);
  var p = list.head;
  var c = 1;
  p.data.copy(ret);
  n -= p.data.length;
  while (p = p.next) {
    var buf = p.data;
    var nb = n > buf.length ? buf.length : n;
    buf.copy(ret, ret.length - n, 0, nb);
    n -= nb;
    if (n === 0) {
      if (nb === buf.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = buf.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    processNextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function forEach(xs, f) {
  for (var i = 0, l = xs.length; i < l; i++) {
    f(xs[i], i);
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/global.js"), __webpack_require__("../node_modules/process/browser.js")))

/***/ }),

/***/ "../node_modules/readable-stream/lib/_stream_transform.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;

var Duplex = __webpack_require__("../node_modules/readable-stream/lib/_stream_duplex.js");

/*<replacement>*/
var util = __webpack_require__("../node_modules/core-util-is/lib/util.js");
util.inherits = __webpack_require__("../node_modules/inherits/inherits_browser.js");
/*</replacement>*/

util.inherits(Transform, Duplex);

function TransformState(stream) {
  this.afterTransform = function (er, data) {
    return afterTransform(stream, er, data);
  };

  this.needTransform = false;
  this.transforming = false;
  this.writecb = null;
  this.writechunk = null;
  this.writeencoding = null;
}

function afterTransform(stream, er, data) {
  var ts = stream._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) {
    return stream.emit('error', new Error('write callback called multiple times'));
  }

  ts.writechunk = null;
  ts.writecb = null;

  if (data !== null && data !== undefined) stream.push(data);

  cb(er);

  var rs = stream._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    stream._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  Duplex.call(this, options);

  this._transformState = new TransformState(this);

  var stream = this;

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.once('prefinish', function () {
    if (typeof this._flush === 'function') this._flush(function (er, data) {
      done(stream, er, data);
    });else done(stream);
  });
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('_transform() is not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

Transform.prototype._destroy = function (err, cb) {
  var _this = this;

  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
    _this.emit('close');
  });
};

function done(stream, er, data) {
  if (er) return stream.emit('error', er);

  if (data !== null && data !== undefined) stream.push(data);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  var ws = stream._writableState;
  var ts = stream._transformState;

  if (ws.length) throw new Error('Calling transform done when ws.length != 0');

  if (ts.transforming) throw new Error('Calling transform done when still transforming');

  return stream.push(null);
}

/***/ }),

/***/ "../node_modules/readable-stream/lib/_stream_writable.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



/*<replacement>*/

var processNextTick = __webpack_require__("../node_modules/process-nextick-args/index.js");
/*</replacement>*/

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : processNextTick;
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = __webpack_require__("../node_modules/core-util-is/lib/util.js");
util.inherits = __webpack_require__("../node_modules/inherits/inherits_browser.js");
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__("../node_modules/util-deprecate/browser.js")
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__("../node_modules/readable-stream/lib/internal/streams/stream-browser.js");
/*</replacement>*/

/*<replacement>*/
var Buffer = __webpack_require__("../node_modules/safe-buffer/index.js").Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
/*</replacement>*/

var destroyImpl = __webpack_require__("../node_modules/readable-stream/lib/internal/streams/destroy.js");

util.inherits(Writable, Stream);

function nop() {}

function WritableState(options, stream) {
  Duplex = Duplex || __webpack_require__("../node_modules/readable-stream/lib/_stream_duplex.js");

  options = options || {};

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
  this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function (object) {
      if (realHasInstance.call(this, object)) return true;

      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function (object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || __webpack_require__("../node_modules/readable-stream/lib/_stream_duplex.js");

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
    return new Writable(options);
  }

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;

    if (typeof options.final === 'function') this._final = options.final;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe, not readable'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  processNextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  var er = false;

  if (chunk === null) {
    er = new TypeError('May not write null values to stream');
  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  if (er) {
    stream.emit('error', er);
    processNextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = _isUint8Array(chunk) && !state.objectMode;

  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;

  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    processNextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    processNextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequestCount = 0;
  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('_write() is not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending && !state.finished) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      stream.emit('error', err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function') {
      state.pendingcb++;
      state.finalCalled = true;
      processNextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) processNextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }
  if (state.corkedRequestsFree) {
    state.corkedRequestsFree.next = corkReq;
  } else {
    state.corkedRequestsFree = corkReq;
  }
}

Object.defineProperty(Writable.prototype, 'destroyed', {
  get: function () {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});

Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  this.end();
  cb(err);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/process/browser.js"), __webpack_require__("../node_modules/webpack/node_modules/timers-browserify/main.js").setImmediate, __webpack_require__("../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "../node_modules/readable-stream/lib/internal/streams/BufferList.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*<replacement>*/

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Buffer = __webpack_require__("../node_modules/safe-buffer/index.js").Buffer;
/*</replacement>*/

function copyBuffer(src, target, offset) {
  src.copy(target, offset);
}

module.exports = function () {
  function BufferList() {
    _classCallCheck(this, BufferList);

    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  BufferList.prototype.push = function push(v) {
    var entry = { data: v, next: null };
    if (this.length > 0) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
    ++this.length;
  };

  BufferList.prototype.unshift = function unshift(v) {
    var entry = { data: v, next: this.head };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
  };

  BufferList.prototype.shift = function shift() {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
    --this.length;
    return ret;
  };

  BufferList.prototype.clear = function clear() {
    this.head = this.tail = null;
    this.length = 0;
  };

  BufferList.prototype.join = function join(s) {
    if (this.length === 0) return '';
    var p = this.head;
    var ret = '' + p.data;
    while (p = p.next) {
      ret += s + p.data;
    }return ret;
  };

  BufferList.prototype.concat = function concat(n) {
    if (this.length === 0) return Buffer.alloc(0);
    if (this.length === 1) return this.head.data;
    var ret = Buffer.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while (p) {
      copyBuffer(p.data, ret, i);
      i += p.data.length;
      p = p.next;
    }
    return ret;
  };

  return BufferList;
}();

/***/ }),

/***/ "../node_modules/readable-stream/lib/internal/streams/destroy.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*<replacement>*/

var processNextTick = __webpack_require__("../node_modules/process-nextick-args/index.js");
/*</replacement>*/

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;

  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;

  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
      processNextTick(emitErrorNT, this, err);
    }
    return;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }

  this._destroy(err || null, function (err) {
    if (!cb && err) {
      processNextTick(emitErrorNT, _this, err);
      if (_this._writableState) {
        _this._writableState.errorEmitted = true;
      }
    } else if (cb) {
      cb(err);
    }
  });
}

function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }

  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}

function emitErrorNT(self, err) {
  self.emit('error', err);
}

module.exports = {
  destroy: destroy,
  undestroy: undestroy
};

/***/ }),

/***/ "../node_modules/readable-stream/lib/internal/streams/stream-browser.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("../node_modules/events/events.js").EventEmitter;


/***/ }),

/***/ "../node_modules/readable-stream/passthrough.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("../node_modules/readable-stream/readable-browser.js").PassThrough


/***/ }),

/***/ "../node_modules/readable-stream/readable-browser.js":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("../node_modules/readable-stream/lib/_stream_readable.js");
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = __webpack_require__("../node_modules/readable-stream/lib/_stream_writable.js");
exports.Duplex = __webpack_require__("../node_modules/readable-stream/lib/_stream_duplex.js");
exports.Transform = __webpack_require__("../node_modules/readable-stream/lib/_stream_transform.js");
exports.PassThrough = __webpack_require__("../node_modules/readable-stream/lib/_stream_passthrough.js");


/***/ }),

/***/ "../node_modules/readable-stream/transform.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("../node_modules/readable-stream/readable-browser.js").Transform


/***/ }),

/***/ "../node_modules/readable-stream/writable-browser.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("../node_modules/readable-stream/lib/_stream_writable.js");


/***/ }),

/***/ "../node_modules/recompose/es/Recompose.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapProps", function() { return mapProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withProps", function() { return withProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withPropsOnChange", function() { return withPropsOnChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withHandlers", function() { return withHandlers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultProps", function() { return defaultProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renameProp", function() { return renameProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renameProps", function() { return renameProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "flattenProp", function() { return flattenProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withState", function() { return withState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withStateHandlers", function() { return withStateHandlers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withReducer", function() { return withReducer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "branch", function() { return branch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renderComponent", function() { return renderComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renderNothing", function() { return renderNothing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shouldUpdate", function() { return shouldUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pure", function() { return pure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onlyUpdateForKeys", function() { return onlyUpdateForKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onlyUpdateForPropTypes", function() { return onlyUpdateForPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withContext", function() { return withContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getContext", function() { return getContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lifecycle", function() { return lifecycle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toClass", function() { return toClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setStatic", function() { return setStatic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setPropTypes", function() { return setPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDisplayName", function() { return setDisplayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return compose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDisplayName", function() { return getDisplayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wrapDisplayName", function() { return wrapDisplayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isClassComponent", function() { return isClassComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createSink", function() { return createSink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentFromProp", function() { return componentFromProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nest", function() { return nest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hoistStatics", function() { return hoistStatics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentFromStream", function() { return componentFromStream; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentFromStreamWithConfig", function() { return componentFromStreamWithConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapPropsStream", function() { return mapPropsStream; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapPropsStreamWithConfig", function() { return mapPropsStreamWithConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createEventHandler", function() { return createEventHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createEventHandlerWithConfig", function() { return createEventHandlerWithConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setObservableConfig", function() { return configureObservable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual__ = __webpack_require__("../node_modules/fbjs/lib/shallowEqual.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__("../node_modules/hoist-non-react-statics/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_change_emitter__ = __webpack_require__("../node_modules/change-emitter/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_change_emitter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_change_emitter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_symbol_observable__ = __webpack_require__("../node_modules/symbol-observable/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_symbol_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_symbol_observable__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "shallowEqual", function() { return __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default.a; });






var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    /* eslint-disable no-param-reassign */
    BaseComponent[key] = value;
    /* eslint-enable no-param-reassign */
    return BaseComponent;
  };
};

var setDisplayName = function setDisplayName(displayName) {
  return setStatic('displayName', displayName);
};

var getDisplayName = function getDisplayName(Component$$1) {
  if (typeof Component$$1 === 'string') {
    return Component$$1;
  }

  if (!Component$$1) {
    return undefined;
  }

  return Component$$1.displayName || Component$$1.name || 'Component';
};

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + '(' + getDisplayName(BaseComponent) + ')';
};

var mapProps = function mapProps(propsMapper) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var MapProps = function MapProps(props) {
      return factory(propsMapper(props));
    };
    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'mapProps'))(MapProps);
    }
    return MapProps;
  };
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};









var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var withProps = function withProps(input) {
  var hoc = mapProps(function (props) {
    return _extends({}, props, typeof input === 'function' ? input(props) : input);
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withProps'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var pick = function pick(obj, keys) {
  var result = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (obj.hasOwnProperty(key)) {
      result[key] = obj[key];
    }
  }
  return result;
};

var withPropsOnChange = function withPropsOnChange(shouldMapOrKeys, propsMapper) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var shouldMap = typeof shouldMapOrKeys === 'function' ? shouldMapOrKeys : function (props, nextProps) {
      return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(pick(props, shouldMapOrKeys), pick(nextProps, shouldMapOrKeys));
    };

    var WithPropsOnChange = function (_Component) {
      inherits(WithPropsOnChange, _Component);

      function WithPropsOnChange() {
        var _temp, _this, _ret;

        classCallCheck(this, WithPropsOnChange);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.computedProps = propsMapper(_this.props), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithPropsOnChange.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (shouldMap(this.props, nextProps)) {
          this.computedProps = propsMapper(nextProps);
        }
      };

      WithPropsOnChange.prototype.render = function render() {
        return factory(_extends({}, this.props, this.computedProps));
      };

      return WithPropsOnChange;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withPropsOnChange'))(WithPropsOnChange);
    }
    return WithPropsOnChange;
  };
};

var mapValues = function mapValues(obj, func) {
  var result = {};
  /* eslint-disable no-restricted-syntax */
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      result[key] = func(obj[key], key);
    }
  }
  /* eslint-enable no-restricted-syntax */
  return result;
};

/* eslint-disable no-console */
var withHandlers = function withHandlers(handlers) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithHandlers = function (_Component) {
      inherits(WithHandlers, _Component);

      function WithHandlers() {
        var _temp, _this, _ret;

        classCallCheck(this, WithHandlers);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithHandlers.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
        this.cachedHandlers = {};
      };

      WithHandlers.prototype.render = function render() {
        return factory(_extends({}, this.props, this.handlers));
      };

      return WithHandlers;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.cachedHandlers = {};
      this.handlers = mapValues(typeof handlers === 'function' ? handlers(this.props) : handlers, function (createHandler, handlerName) {
        return function () {
          var cachedHandler = _this2.cachedHandlers[handlerName];
          if (cachedHandler) {
            return cachedHandler.apply(undefined, arguments);
          }

          var handler = createHandler(_this2.props);
          _this2.cachedHandlers[handlerName] = handler;

          if (false) {
            console.error(
            // eslint-disable-line no-console
            'withHandlers(): Expected a map of higher-order functions. ' + 'Refer to the docs for more info.');
          }

          return handler.apply(undefined, arguments);
        };
      });
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withHandlers'))(WithHandlers);
    }
    return WithHandlers;
  };
};

var defaultProps = function defaultProps(props) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var DefaultProps = function DefaultProps(ownerProps) {
      return factory(ownerProps);
    };
    DefaultProps.defaultProps = props;
    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'defaultProps'))(DefaultProps);
    }
    return DefaultProps;
  };
};

var omit = function omit(obj, keys) {
  var rest = objectWithoutProperties(obj, []);

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (rest.hasOwnProperty(key)) {
      delete rest[key];
    }
  }
  return rest;
};

var renameProp = function renameProp(oldName, newName) {
  var hoc = mapProps(function (props) {
    var _babelHelpers$extends;

    return _extends({}, omit(props, [oldName]), (_babelHelpers$extends = {}, _babelHelpers$extends[newName] = props[oldName], _babelHelpers$extends));
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProp'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var keys = Object.keys;


var mapKeys = function mapKeys(obj, func) {
  return keys(obj).reduce(function (result, key) {
    var val = obj[key];
    /* eslint-disable no-param-reassign */
    result[func(val, key)] = val;
    /* eslint-enable no-param-reassign */
    return result;
  }, {});
};

var renameProps = function renameProps(nameMap) {
  var hoc = mapProps(function (props) {
    return _extends({}, omit(props, keys(nameMap)), mapKeys(pick(props, keys(nameMap)), function (_, oldName) {
      return nameMap[oldName];
    }));
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProps'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var flattenProp = function flattenProp(propName) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var FlattenProp = function FlattenProp(props) {
      return factory(_extends({}, props, props[propName]));
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'flattenProp'))(FlattenProp);
    }
    return FlattenProp;
  };
};

var withState = function withState(stateName, stateUpdaterName, initialState) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithState = function (_Component) {
      inherits(WithState, _Component);

      function WithState() {
        var _temp, _this, _ret;

        classCallCheck(this, WithState);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
          stateValue: typeof initialState === 'function' ? initialState(_this.props) : initialState
        }, _this.updateStateValue = function (updateFn, callback) {
          return _this.setState(function (_ref) {
            var stateValue = _ref.stateValue;
            return {
              stateValue: typeof updateFn === 'function' ? updateFn(stateValue) : updateFn
            };
          }, callback);
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithState.prototype.render = function render() {
        var _babelHelpers$extends;

        return factory(_extends({}, this.props, (_babelHelpers$extends = {}, _babelHelpers$extends[stateName] = this.state.stateValue, _babelHelpers$extends[stateUpdaterName] = this.updateStateValue, _babelHelpers$extends)));
      };

      return WithState;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withState'))(WithState);
    }
    return WithState;
  };
};

var withStateHandlers = function withStateHandlers(initialState, stateUpdaters) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithStateHandlers = function (_Component) {
      inherits(WithStateHandlers, _Component);

      function WithStateHandlers() {
        var _temp, _this, _ret;

        classCallCheck(this, WithStateHandlers);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithStateHandlers.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        var propsChanged = nextProps !== this.props;
        // the idea is to skip render if stateUpdater handler return undefined
        // this allows to create no state update handlers with access to state and props
        var stateChanged = !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(nextState, this.state);
        return propsChanged || stateChanged;
      };

      WithStateHandlers.prototype.render = function render() {
        return factory(_extends({}, this.props, this.state, this.stateUpdaters));
      };

      return WithStateHandlers;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.state = typeof initialState === 'function' ? initialState(this.props) : initialState;
      this.stateUpdaters = mapValues(stateUpdaters, function (handler) {
        return function (mayBeEvent) {
          for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          // Having that functional form of setState can be called async
          // we need to persist SyntheticEvent
          if (mayBeEvent && typeof mayBeEvent.persist === 'function') {
            mayBeEvent.persist();
          }

          _this2.setState(function (state, props) {
            return handler(state, props).apply(undefined, [mayBeEvent].concat(args));
          });
        };
      });
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withStateHandlers'))(WithStateHandlers);
    }
    return WithStateHandlers;
  };
};

var withReducer = function withReducer(stateName, dispatchName, reducer, initialState) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithReducer = function (_Component) {
      inherits(WithReducer, _Component);

      function WithReducer() {
        var _temp, _this, _ret;

        classCallCheck(this, WithReducer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
          stateValue: _this.initializeStateValue()
        }, _this.dispatch = function (action) {
          return _this.setState(function (_ref) {
            var stateValue = _ref.stateValue;
            return {
              stateValue: reducer(stateValue, action)
            };
          });
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithReducer.prototype.initializeStateValue = function initializeStateValue() {
        if (initialState !== undefined) {
          return typeof initialState === 'function' ? initialState(this.props) : initialState;
        }
        return reducer(undefined, { type: '@@recompose/INIT' });
      };

      WithReducer.prototype.render = function render() {
        var _babelHelpers$extends;

        return factory(_extends({}, this.props, (_babelHelpers$extends = {}, _babelHelpers$extends[stateName] = this.state.stateValue, _babelHelpers$extends[dispatchName] = this.dispatch, _babelHelpers$extends)));
      };

      return WithReducer;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withReducer'))(WithReducer);
    }
    return WithReducer;
  };
};

var identity = function identity(Component$$1) {
  return Component$$1;
};

var branch = function branch(test, left) {
  var right = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : identity;
  return function (BaseComponent) {
    var leftFactory = void 0;
    var rightFactory = void 0;
    var Branch = function Branch(props) {
      if (test(props)) {
        leftFactory = leftFactory || Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(left(BaseComponent));
        return leftFactory(props);
      }
      rightFactory = rightFactory || Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(right(BaseComponent));
      return rightFactory(props);
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'branch'))(Branch);
    }
    return Branch;
  };
};

var renderComponent = function renderComponent(Component$$1) {
  return function (_) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(Component$$1);
    var RenderComponent = function RenderComponent(props) {
      return factory(props);
    };
    if (false) {
      RenderComponent.displayName = wrapDisplayName(Component$$1, 'renderComponent');
    }
    return RenderComponent;
  };
};

var Nothing = function (_Component) {
  inherits(Nothing, _Component);

  function Nothing() {
    classCallCheck(this, Nothing);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Nothing.prototype.render = function render() {
    return null;
  };

  return Nothing;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var renderNothing = function renderNothing(_) {
  return Nothing;
};

var shouldUpdate = function shouldUpdate(test) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var ShouldUpdate = function (_Component) {
      inherits(ShouldUpdate, _Component);

      function ShouldUpdate() {
        classCallCheck(this, ShouldUpdate);
        return possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      ShouldUpdate.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return test(this.props, nextProps);
      };

      ShouldUpdate.prototype.render = function render() {
        return factory(this.props);
      };

      return ShouldUpdate;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
    }
    return ShouldUpdate;
  };
};

var pure = function pure(BaseComponent) {
  var hoc = shouldUpdate(function (props, nextProps) {
    return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(props, nextProps);
  });

  if (false) {
    return setDisplayName(wrapDisplayName(BaseComponent, 'pure'))(hoc(BaseComponent));
  }

  return hoc(BaseComponent);
};

var onlyUpdateForKeys = function onlyUpdateForKeys(propKeys) {
  var hoc = shouldUpdate(function (props, nextProps) {
    return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(pick(nextProps, propKeys), pick(props, propKeys));
  });

  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForKeys'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var onlyUpdateForPropTypes = function onlyUpdateForPropTypes(BaseComponent) {
  var propTypes = BaseComponent.propTypes;

  if (false) {
    if (!propTypes) {
      /* eslint-disable */
      console.error('A component without any `propTypes` was passed to ' + '`onlyUpdateForPropTypes()`. Check the implementation of the ' + ('component with display name "' + getDisplayName(BaseComponent) + '".'));
      /* eslint-enable */
    }
  }

  var propKeys = Object.keys(propTypes || {});
  var OnlyUpdateForPropTypes = onlyUpdateForKeys(propKeys)(BaseComponent);

  if (false) {
    return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForPropTypes'))(OnlyUpdateForPropTypes);
  }
  return OnlyUpdateForPropTypes;
};

var withContext = function withContext(childContextTypes, getChildContext) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithContext = function (_Component) {
      inherits(WithContext, _Component);

      function WithContext() {
        var _temp, _this, _ret;

        classCallCheck(this, WithContext);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getChildContext = function () {
          return getChildContext(_this.props);
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithContext.prototype.render = function render() {
        return factory(this.props);
      };

      return WithContext;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    WithContext.childContextTypes = childContextTypes;

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withContext'))(WithContext);
    }
    return WithContext;
  };
};

var getContext = function getContext(contextTypes) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var GetContext = function GetContext(ownerProps, context) {
      return factory(_extends({}, ownerProps, context));
    };

    GetContext.contextTypes = contextTypes;

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'getContext'))(GetContext);
    }
    return GetContext;
  };
};

/* eslint-disable no-console */
var lifecycle = function lifecycle(spec) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    if (false) {
      console.error('lifecycle() does not support the render method; its behavior is to ' + 'pass all props and state to the base component.');
    }

    var Lifecycle = function (_Component) {
      inherits(Lifecycle, _Component);

      function Lifecycle() {
        classCallCheck(this, Lifecycle);
        return possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      Lifecycle.prototype.render = function render() {
        return factory(_extends({}, this.props, this.state));
      };

      return Lifecycle;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    Object.keys(spec).forEach(function (hook) {
      return Lifecycle.prototype[hook] = spec[hook];
    });

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'lifecycle'))(Lifecycle);
    }
    return Lifecycle;
  };
};

var isClassComponent = function isClassComponent(Component$$1) {
  return Boolean(Component$$1 && Component$$1.prototype && typeof Component$$1.prototype.render === 'function');
};

var toClass = function toClass(baseComponent) {
  if (isClassComponent(baseComponent)) {
    return baseComponent;
  }

  var ToClass = function (_Component) {
    inherits(ToClass, _Component);

    function ToClass() {
      classCallCheck(this, ToClass);
      return possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    ToClass.prototype.render = function render() {
      if (typeof baseComponent === 'string') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(baseComponent, this.props);
      }
      return baseComponent(this.props, this.context);
    };

    return ToClass;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  ToClass.displayName = getDisplayName(baseComponent);
  ToClass.propTypes = baseComponent.propTypes;
  ToClass.contextTypes = baseComponent.contextTypes;
  ToClass.defaultProps = baseComponent.defaultProps;

  return ToClass;
};

var setPropTypes = function setPropTypes(propTypes) {
  return setStatic('propTypes', propTypes);
};

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

var createSink = function createSink(callback) {
  return function (_Component) {
    inherits(Sink, _Component);

    function Sink() {
      classCallCheck(this, Sink);
      return possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Sink.prototype.componentWillMount = function componentWillMount() {
      callback(this.props);
    };

    Sink.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      callback(nextProps);
    };

    Sink.prototype.render = function render() {
      return null;
    };

    return Sink;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
};

var componentFromProp = function componentFromProp(propName) {
  var Component$$1 = function Component$$1(props) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(props[propName], omit(props, [propName]));
  };
  Component$$1.displayName = 'componentFromProp(' + propName + ')';
  return Component$$1;
};

var nest = function nest() {
  for (var _len = arguments.length, Components = Array(_len), _key = 0; _key < _len; _key++) {
    Components[_key] = arguments[_key];
  }

  var factories = Components.map(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"]);
  var Nest = function Nest(_ref) {
    var props = objectWithoutProperties(_ref, []),
        children = _ref.children;
    return factories.reduceRight(function (child, factory) {
      return factory(props, child);
    }, children);
  };

  if (false) {
    var displayNames = Components.map(getDisplayName);
    Nest.displayName = 'nest(' + displayNames.join(', ') + ')';
  }

  return Nest;
};

var hoistStatics = function hoistStatics(higherOrderComponent) {
  return function (BaseComponent) {
    var NewComponent = higherOrderComponent(BaseComponent);
    __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(NewComponent, BaseComponent);
    return NewComponent;
  };
};

var _config = {
  fromESObservable: null,
  toESObservable: null
};

var configureObservable = function configureObservable(c) {
  _config = c;
};

var config = {
  fromESObservable: function fromESObservable(observable) {
    return typeof _config.fromESObservable === 'function' ? _config.fromESObservable(observable) : observable;
  },
  toESObservable: function toESObservable(stream) {
    return typeof _config.toESObservable === 'function' ? _config.toESObservable(stream) : stream;
  }
};

var componentFromStreamWithConfig = function componentFromStreamWithConfig(config$$1) {
  return function (propsToVdom) {
    return function (_Component) {
      inherits(ComponentFromStream, _Component);

      function ComponentFromStream() {
        var _config$fromESObserva;

        var _temp, _this, _ret;

        classCallCheck(this, ComponentFromStream);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { vdom: null }, _this.propsEmitter = Object(__WEBPACK_IMPORTED_MODULE_3_change_emitter__["createChangeEmitter"])(), _this.props$ = config$$1.fromESObservable((_config$fromESObserva = {
          subscribe: function subscribe(observer) {
            var unsubscribe = _this.propsEmitter.listen(function (props) {
              if (props) {
                observer.next(props);
              } else {
                observer.complete();
              }
            });
            return { unsubscribe: unsubscribe };
          }
        }, _config$fromESObserva[__WEBPACK_IMPORTED_MODULE_4_symbol_observable___default.a] = function () {
          return this;
        }, _config$fromESObserva)), _this.vdom$ = config$$1.toESObservable(propsToVdom(_this.props$)), _temp), possibleConstructorReturn(_this, _ret);
      }

      // Stream of props


      // Stream of vdom


      ComponentFromStream.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;

        // Subscribe to child prop changes so we know when to re-render
        this.subscription = this.vdom$.subscribe({
          next: function next(vdom) {
            _this2.setState({ vdom: vdom });
          }
        });
        this.propsEmitter.emit(this.props);
      };

      ComponentFromStream.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        // Receive new props from the owner
        this.propsEmitter.emit(nextProps);
      };

      ComponentFromStream.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        return nextState.vdom !== this.state.vdom;
      };

      ComponentFromStream.prototype.componentWillUnmount = function componentWillUnmount() {
        // Call without arguments to complete stream
        this.propsEmitter.emit();

        // Clean-up subscription before un-mounting
        this.subscription.unsubscribe();
      };

      ComponentFromStream.prototype.render = function render() {
        return this.state.vdom;
      };

      return ComponentFromStream;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
  };
};

var componentFromStream = function componentFromStream(propsToVdom) {
  return componentFromStreamWithConfig(config)(propsToVdom);
};

var identity$1 = function identity(t) {
  return t;
};

var mapPropsStreamWithConfig = function mapPropsStreamWithConfig(config$$1) {
  var componentFromStream = componentFromStreamWithConfig({
    fromESObservable: identity$1,
    toESObservable: identity$1
  });
  return function (transform) {
    return function (BaseComponent) {
      var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
      var fromESObservable = config$$1.fromESObservable,
          toESObservable = config$$1.toESObservable;

      return componentFromStream(function (props$) {
        var _ref;

        return _ref = {
          subscribe: function subscribe(observer) {
            var subscription = toESObservable(transform(fromESObservable(props$))).subscribe({
              next: function next(childProps) {
                return observer.next(factory(childProps));
              }
            });
            return {
              unsubscribe: function unsubscribe() {
                return subscription.unsubscribe();
              }
            };
          }
        }, _ref[__WEBPACK_IMPORTED_MODULE_4_symbol_observable___default.a] = function () {
          return this;
        }, _ref;
      });
    };
  };
};

var mapPropsStream = function mapPropsStream(transform) {
  var hoc = mapPropsStreamWithConfig(config)(transform);

  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'mapPropsStream'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var createEventHandlerWithConfig = function createEventHandlerWithConfig(config$$1) {
  return function () {
    var _config$fromESObserva;

    var emitter = Object(__WEBPACK_IMPORTED_MODULE_3_change_emitter__["createChangeEmitter"])();
    var stream = config$$1.fromESObservable((_config$fromESObserva = {
      subscribe: function subscribe(observer) {
        var unsubscribe = emitter.listen(function (value) {
          return observer.next(value);
        });
        return { unsubscribe: unsubscribe };
      }
    }, _config$fromESObserva[__WEBPACK_IMPORTED_MODULE_4_symbol_observable___default.a] = function () {
      return this;
    }, _config$fromESObserva));
    return {
      handler: emitter.emit,
      stream: stream
    };
  };
};

var createEventHandler = createEventHandlerWithConfig(config);

// Higher-order component helpers




/***/ }),

/***/ "../node_modules/reduce-reducers/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = reduceReducers;

function reduceReducers() {
  for (var _len = arguments.length, reducers = Array(_len), _key = 0; _key < _len; _key++) {
    reducers[_key] = arguments[_key];
  }

  return function (previous, current) {
    return reducers.reduce(function (p, r) {
      return r(p, current);
    }, previous);
  };
}

module.exports = exports["default"];

/***/ }),

/***/ "../node_modules/redux-actions/es/arrayToObject.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (array, callback) {
  return array.reduce(function (partialObject, element) {
    return callback(partialObject, element);
  }, {});
});

/***/ }),

/***/ "../node_modules/redux-actions/es/camelCase.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// based on https://github.com/lodash/lodash/blob/4.17.2/lodash.js#L14100
// eslint-disable-next-line max-len
var wordPattern = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:(?:1ST|2ND|3RD|(?![123])\dTH)\b)|\d*(?:(?:1st|2nd|3rd|(?![123])\dth)\b)|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g;
var namespacer = '/';

function camelCase(string) {
  return string.match(wordPattern).reduce(function (camelCased, word, index) {
    return camelCased + (index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.substring(1).toLowerCase());
  }, '');
}

/* harmony default export */ __webpack_exports__["a"] = (function (type) {
  return type.split(namespacer).map(camelCase).join(namespacer);
});

/***/ }),

/***/ "../node_modules/redux-actions/es/combineActions.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTION_TYPE_DELIMITER; });
/* harmony export (immutable) */ __webpack_exports__["b"] = combineActions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isString__ = __webpack_require__("../node_modules/lodash-es/isString.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isFunction__ = __webpack_require__("../node_modules/lodash-es/isFunction.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_isEmpty__ = __webpack_require__("../node_modules/lodash-es/isEmpty.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_toString__ = __webpack_require__("../node_modules/lodash-es/toString.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_es_isSymbol__ = __webpack_require__("../node_modules/lodash-es/isSymbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__("../node_modules/invariant/browser.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);







var ACTION_TYPE_DELIMITER = '||';

function isValidActionType(type) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isString__["a" /* default */])(type) || Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isFunction__["a" /* default */])(type) || Object(__WEBPACK_IMPORTED_MODULE_4_lodash_es_isSymbol__["a" /* default */])(type);
}

function isValidActionTypes(types) {
  if (Object(__WEBPACK_IMPORTED_MODULE_2_lodash_es_isEmpty__["a" /* default */])(types)) {
    return false;
  }
  return types.every(isValidActionType);
}

function combineActions() {
  for (var _len = arguments.length, actionsTypes = Array(_len), _key = 0; _key < _len; _key++) {
    actionsTypes[_key] = arguments[_key];
  }

  __WEBPACK_IMPORTED_MODULE_5_invariant___default()(isValidActionTypes(actionsTypes), 'Expected action types to be strings, symbols, or action creators');
  var combinedActionType = actionsTypes.map(__WEBPACK_IMPORTED_MODULE_3_lodash_es_toString__["a" /* default */]).join(ACTION_TYPE_DELIMITER);
  return { toString: function toString() {
      return combinedActionType;
    } };
}

/***/ }),

/***/ "../node_modules/redux-actions/es/createAction.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createAction;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_identity__ = __webpack_require__("../node_modules/lodash-es/identity.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isFunction__ = __webpack_require__("../node_modules/lodash-es/isFunction.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_isNull__ = __webpack_require__("../node_modules/lodash-es/isNull.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__("../node_modules/invariant/browser.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);





function createAction(type) {
  var payloadCreator = arguments.length <= 1 || arguments[1] === undefined ? __WEBPACK_IMPORTED_MODULE_0_lodash_es_identity__["a" /* default */] : arguments[1];
  var metaCreator = arguments[2];

  __WEBPACK_IMPORTED_MODULE_3_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isFunction__["a" /* default */])(payloadCreator) || Object(__WEBPACK_IMPORTED_MODULE_2_lodash_es_isNull__["a" /* default */])(payloadCreator), 'Expected payloadCreator to be a function, undefined or null');

  var finalPayloadCreator = Object(__WEBPACK_IMPORTED_MODULE_2_lodash_es_isNull__["a" /* default */])(payloadCreator) || payloadCreator === __WEBPACK_IMPORTED_MODULE_0_lodash_es_identity__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0_lodash_es_identity__["a" /* default */] : function (head) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return head instanceof Error ? head : payloadCreator.apply(undefined, [head].concat(args));
  };

  var hasMeta = Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isFunction__["a" /* default */])(metaCreator);
  var typeString = type.toString();

  var actionCreator = function actionCreator() {
    var payload = finalPayloadCreator.apply(undefined, arguments);
    var action = { type: type };

    if (payload instanceof Error) {
      action.error = true;
    }

    if (payload !== undefined) {
      action.payload = payload;
    }

    if (hasMeta) {
      action.meta = metaCreator.apply(undefined, arguments);
    }

    return action;
  };

  actionCreator.toString = function () {
    return typeString;
  };

  return actionCreator;
}

/***/ }),

/***/ "../node_modules/redux-actions/es/createActions.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createActions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__camelCase__ = __webpack_require__("../node_modules/redux-actions/es/camelCase.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_identity__ = __webpack_require__("../node_modules/lodash-es/identity.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_isPlainObject__ = __webpack_require__("../node_modules/lodash-es/isPlainObject.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_isArray__ = __webpack_require__("../node_modules/lodash-es/isArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_es_last__ = __webpack_require__("../node_modules/lodash-es/last.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_es_isString__ = __webpack_require__("../node_modules/lodash-es/isString.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_es_isFunction__ = __webpack_require__("../node_modules/lodash-es/isFunction.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_es_isNil__ = __webpack_require__("../node_modules/lodash-es/isNil.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__createAction__ = __webpack_require__("../node_modules/redux-actions/es/createAction.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_invariant__ = __webpack_require__("../node_modules/invariant/browser.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__arrayToObject__ = __webpack_require__("../node_modules/redux-actions/es/arrayToObject.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__flattenUtils__ = __webpack_require__("../node_modules/redux-actions/es/flattenUtils.js");
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }














function createActions(actionMap) {
  for (var _len = arguments.length, identityActions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    identityActions[_key - 1] = arguments[_key];
  }

  var _ref = Object(__WEBPACK_IMPORTED_MODULE_2_lodash_es_isPlainObject__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4_lodash_es_last__["a" /* default */])(identityActions)) ? identityActions.pop() : {};

  var namespace = _ref.namespace;

  __WEBPACK_IMPORTED_MODULE_9_invariant___default()(identityActions.every(__WEBPACK_IMPORTED_MODULE_5_lodash_es_isString__["a" /* default */]) && (Object(__WEBPACK_IMPORTED_MODULE_5_lodash_es_isString__["a" /* default */])(actionMap) || Object(__WEBPACK_IMPORTED_MODULE_2_lodash_es_isPlainObject__["a" /* default */])(actionMap)), 'Expected optional object followed by string action types');
  if (Object(__WEBPACK_IMPORTED_MODULE_5_lodash_es_isString__["a" /* default */])(actionMap)) {
    return actionCreatorsFromIdentityActions([actionMap].concat(identityActions));
  }
  return _extends({}, actionCreatorsFromActionMap(actionMap, namespace), actionCreatorsFromIdentityActions(identityActions));
}

function actionCreatorsFromActionMap(actionMap, namespace) {
  var flatActionMap = Object(__WEBPACK_IMPORTED_MODULE_11__flattenUtils__["a" /* flattenActionMap */])(actionMap, namespace);
  var flatActionCreators = actionMapToActionCreators(flatActionMap);
  return Object(__WEBPACK_IMPORTED_MODULE_11__flattenUtils__["c" /* unflattenActionCreators */])(flatActionCreators, namespace);
}

function actionMapToActionCreators(actionMap) {
  function isValidActionMapValue(actionMapValue) {
    if (Object(__WEBPACK_IMPORTED_MODULE_6_lodash_es_isFunction__["a" /* default */])(actionMapValue) || Object(__WEBPACK_IMPORTED_MODULE_7_lodash_es_isNil__["a" /* default */])(actionMapValue)) {
      return true;
    } else if (Object(__WEBPACK_IMPORTED_MODULE_3_lodash_es_isArray__["a" /* default */])(actionMapValue)) {
      var _actionMapValue = _slicedToArray(actionMapValue, 2);

      var _actionMapValue$ = _actionMapValue[0];
      var payload = _actionMapValue$ === undefined ? __WEBPACK_IMPORTED_MODULE_1_lodash_es_identity__["a" /* default */] : _actionMapValue$;
      var meta = _actionMapValue[1];

      return Object(__WEBPACK_IMPORTED_MODULE_6_lodash_es_isFunction__["a" /* default */])(payload) && Object(__WEBPACK_IMPORTED_MODULE_6_lodash_es_isFunction__["a" /* default */])(meta);
    }
    return false;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_10__arrayToObject__["a" /* default */])(Object.keys(actionMap), function (partialActionCreators, type) {
    var actionMapValue = actionMap[type];
    __WEBPACK_IMPORTED_MODULE_9_invariant___default()(isValidActionMapValue(actionMapValue), 'Expected function, undefined, null, or array with payload and meta ' + ('functions for ' + type));
    var actionCreator = Object(__WEBPACK_IMPORTED_MODULE_3_lodash_es_isArray__["a" /* default */])(actionMapValue) ? __WEBPACK_IMPORTED_MODULE_8__createAction__["a" /* default */].apply(undefined, [type].concat(_toConsumableArray(actionMapValue))) : Object(__WEBPACK_IMPORTED_MODULE_8__createAction__["a" /* default */])(type, actionMapValue);
    return _extends({}, partialActionCreators, _defineProperty({}, type, actionCreator));
  });
}

function actionCreatorsFromIdentityActions(identityActions) {
  var actionMap = Object(__WEBPACK_IMPORTED_MODULE_10__arrayToObject__["a" /* default */])(identityActions, function (partialActionMap, type) {
    return _extends({}, partialActionMap, _defineProperty({}, type, __WEBPACK_IMPORTED_MODULE_1_lodash_es_identity__["a" /* default */]));
  });
  var actionCreators = actionMapToActionCreators(actionMap);
  return Object(__WEBPACK_IMPORTED_MODULE_10__arrayToObject__["a" /* default */])(Object.keys(actionCreators), function (partialActionCreators, type) {
    return _extends({}, partialActionCreators, _defineProperty({}, Object(__WEBPACK_IMPORTED_MODULE_0__camelCase__["a" /* default */])(type), actionCreators[type]));
  });
}

/***/ }),

/***/ "../node_modules/redux-actions/es/flattenUtils.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return flattenActionMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return flattenReducerMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return unflattenActionCreators; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__camelCase__ = __webpack_require__("../node_modules/redux-actions/es/camelCase.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ownKeys__ = __webpack_require__("../node_modules/redux-actions/es/ownKeys.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hasGeneratorInterface__ = __webpack_require__("../node_modules/redux-actions/es/hasGeneratorInterface.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_isPlainObject__ = __webpack_require__("../node_modules/lodash-es/isPlainObject.js");





var defaultNamespace = '/';

var flattenWhenNode = function flattenWhenNode(predicate) {
  return function flatten(map) {
    var namespace = arguments.length <= 1 || arguments[1] === undefined ? defaultNamespace : arguments[1];
    var partialFlatMap = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
    var partialFlatActionType = arguments.length <= 3 || arguments[3] === undefined ? '' : arguments[3];

    function connectNamespace(type) {
      return partialFlatActionType ? '' + partialFlatActionType + namespace + type : type;
    }

    Object(__WEBPACK_IMPORTED_MODULE_1__ownKeys__["a" /* default */])(map).forEach(function (type) {
      var nextNamespace = connectNamespace(type);
      var mapValue = map[type];

      if (!predicate(mapValue)) {
        partialFlatMap[nextNamespace] = map[type];
      } else {
        flatten(map[type], namespace, partialFlatMap, nextNamespace);
      }
    });

    return partialFlatMap;
  };
};

var flattenActionMap = flattenWhenNode(__WEBPACK_IMPORTED_MODULE_3_lodash_es_isPlainObject__["a" /* default */]);
var flattenReducerMap = flattenWhenNode(function (node) {
  return Object(__WEBPACK_IMPORTED_MODULE_3_lodash_es_isPlainObject__["a" /* default */])(node) && !Object(__WEBPACK_IMPORTED_MODULE_2__hasGeneratorInterface__["a" /* default */])(node);
});

function unflattenActionCreators(flatActionCreators) {
  var namespace = arguments.length <= 1 || arguments[1] === undefined ? defaultNamespace : arguments[1];

  function unflatten(flatActionType) {
    var partialNestedActionCreators = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
    var partialFlatActionTypePath = arguments.length <= 2 || arguments[2] === undefined ? [] : arguments[2];

    var nextNamespace = Object(__WEBPACK_IMPORTED_MODULE_0__camelCase__["a" /* default */])(partialFlatActionTypePath.shift());
    if (partialFlatActionTypePath.length) {
      if (!partialNestedActionCreators[nextNamespace]) {
        partialNestedActionCreators[nextNamespace] = {};
      }
      unflatten(flatActionType, partialNestedActionCreators[nextNamespace], partialFlatActionTypePath);
    } else {
      partialNestedActionCreators[nextNamespace] = flatActionCreators[flatActionType];
    }
  }

  var nestedActionCreators = {};
  Object.getOwnPropertyNames(flatActionCreators).forEach(function (type) {
    return unflatten(type, nestedActionCreators, type.split(namespace));
  });
  return nestedActionCreators;
}



/***/ }),

/***/ "../node_modules/redux-actions/es/handleAction.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = handleAction;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isFunction__ = __webpack_require__("../node_modules/lodash-es/isFunction.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__("../node_modules/lodash-es/isPlainObject.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_identity__ = __webpack_require__("../node_modules/lodash-es/identity.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_isNil__ = __webpack_require__("../node_modules/lodash-es/isNil.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_es_isUndefined__ = __webpack_require__("../node_modules/lodash-es/isUndefined.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_es_includes__ = __webpack_require__("../node_modules/lodash-es/includes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_invariant__ = __webpack_require__("../node_modules/invariant/browser.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__combineActions__ = __webpack_require__("../node_modules/redux-actions/es/combineActions.js");
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();










function handleAction(type) {
  var reducer = arguments.length <= 1 || arguments[1] === undefined ? __WEBPACK_IMPORTED_MODULE_2_lodash_es_identity__["a" /* default */] : arguments[1];
  var defaultState = arguments[2];

  var types = type.toString().split(__WEBPACK_IMPORTED_MODULE_7__combineActions__["a" /* ACTION_TYPE_DELIMITER */]);
  __WEBPACK_IMPORTED_MODULE_6_invariant___default()(!Object(__WEBPACK_IMPORTED_MODULE_4_lodash_es_isUndefined__["a" /* default */])(defaultState), 'defaultState for reducer handling ' + types.join(', ') + ' should be defined');
  __WEBPACK_IMPORTED_MODULE_6_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isFunction__["a" /* default */])(reducer) || Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(reducer), 'Expected reducer to be a function or object with next and throw reducers');

  var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isFunction__["a" /* default */])(reducer) ? [reducer, reducer] : [reducer.next, reducer.throw].map(function (aReducer) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_lodash_es_isNil__["a" /* default */])(aReducer) ? __WEBPACK_IMPORTED_MODULE_2_lodash_es_identity__["a" /* default */] : aReducer;
  });

  var _ref2 = _slicedToArray(_ref, 2);

  var nextReducer = _ref2[0];
  var throwReducer = _ref2[1];


  return function () {
    var state = arguments.length <= 0 || arguments[0] === undefined ? defaultState : arguments[0];
    var action = arguments[1];
    var actionType = action.type;

    if (!actionType || !Object(__WEBPACK_IMPORTED_MODULE_5_lodash_es_includes__["a" /* default */])(types, actionType.toString())) {
      return state;
    }

    return (action.error === true ? throwReducer : nextReducer)(state, action);
  };
}

/***/ }),

/***/ "../node_modules/redux-actions/es/handleActions.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = handleActions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__("../node_modules/lodash-es/isPlainObject.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reduce_reducers__ = __webpack_require__("../node_modules/reduce-reducers/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reduce_reducers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reduce_reducers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__("../node_modules/invariant/browser.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__handleAction__ = __webpack_require__("../node_modules/redux-actions/es/handleAction.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ownKeys__ = __webpack_require__("../node_modules/redux-actions/es/ownKeys.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flattenUtils__ = __webpack_require__("../node_modules/redux-actions/es/flattenUtils.js");
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }








function handleActions(handlers, defaultState) {
  var _ref = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];

  var namespace = _ref.namespace;

  __WEBPACK_IMPORTED_MODULE_2_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(handlers), 'Expected handlers to be an plain object.');
  var flattenedReducerMap = Object(__WEBPACK_IMPORTED_MODULE_5__flattenUtils__["b" /* flattenReducerMap */])(handlers, namespace);
  var reducers = Object(__WEBPACK_IMPORTED_MODULE_4__ownKeys__["a" /* default */])(flattenedReducerMap).map(function (type) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__handleAction__["a" /* default */])(type, flattenedReducerMap[type], defaultState);
  });
  var reducer = __WEBPACK_IMPORTED_MODULE_1_reduce_reducers___default.a.apply(undefined, _toConsumableArray(reducers));
  return function () {
    var state = arguments.length <= 0 || arguments[0] === undefined ? defaultState : arguments[0];
    var action = arguments[1];
    return reducer(state, action);
  };
}

/***/ }),

/***/ "../node_modules/redux-actions/es/hasGeneratorInterface.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hasGeneratorInterface;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ownKeys__ = __webpack_require__("../node_modules/redux-actions/es/ownKeys.js");


function hasGeneratorInterface(handler) {
  var keys = Object(__WEBPACK_IMPORTED_MODULE_0__ownKeys__["a" /* default */])(handler);
  var hasOnlyInterfaceNames = keys.every(function (ownKey) {
    return ownKey === 'next' || ownKey === 'throw';
  });
  return keys.length && keys.length <= 2 && hasOnlyInterfaceNames;
}

/***/ }),

/***/ "../node_modules/redux-actions/es/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createAction__ = __webpack_require__("../node_modules/redux-actions/es/createAction.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__handleAction__ = __webpack_require__("../node_modules/redux-actions/es/handleAction.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__handleActions__ = __webpack_require__("../node_modules/redux-actions/es/handleActions.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__combineActions__ = __webpack_require__("../node_modules/redux-actions/es/combineActions.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createActions__ = __webpack_require__("../node_modules/redux-actions/es/createActions.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createAction", function() { return __WEBPACK_IMPORTED_MODULE_0__createAction__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createActions", function() { return __WEBPACK_IMPORTED_MODULE_4__createActions__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "handleAction", function() { return __WEBPACK_IMPORTED_MODULE_1__handleAction__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "handleActions", function() { return __WEBPACK_IMPORTED_MODULE_2__handleActions__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "combineActions", function() { return __WEBPACK_IMPORTED_MODULE_3__combineActions__["b"]; });








/***/ }),

/***/ "../node_modules/redux-actions/es/ownKeys.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ownKeys;
function ownKeys(object) {
  if (typeof Reflect !== 'undefined' && typeof Reflect.ownKeys === 'function') {
    return Reflect.ownKeys(object);
  }

  var keys = Object.getOwnPropertyNames(object);

  if (typeof Object.getOwnPropertySymbols === 'function') {
    keys = keys.concat(Object.getOwnPropertySymbols(object));
  }

  return keys;
}

/***/ }),

/***/ "../node_modules/redux-flight-control/build/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// Request Management
var ADD_FAILED_REQUEST = exports.ADD_FAILED_REQUEST = 'redux-flight-control/ADD_FAILED_REQUEST';
var ADD_PENDING_REQUEST = exports.ADD_PENDING_REQUEST = 'redux-flight-control/ADD_PENDING_REQUEST';
var CLEAR_FAILED_REQUEST = exports.CLEAR_FAILED_REQUEST = 'redux-flight-control/CLEAR_FAILED_REQUEST';
var CLEAR_QUEUED_REQUEST = exports.CLEAR_QUEUED_REQUEST = 'redux-flight-control/CLEAR_QUEUED_REQUEST';
var FINALIZE_REQUEST = exports.FINALIZE_REQUEST = 'redux-flight-control/FINALIZE_REQUEST';
var QUEUE_REQUEST = exports.QUEUE_REQUEST = 'redux-flight-control/QUEUE_REQUEST';

/***/ }),

/***/ "../node_modules/redux-flight-control/build/createRequestAction.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createRequestAction;

var _invariant = __webpack_require__("../node_modules/invariant/browser.js");

var _invariant2 = _interopRequireDefault(_invariant);

var _lodash = __webpack_require__("../node_modules/lodash.identity/index.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = __webpack_require__("../node_modules/lodash.isfunction/index.js");

var _lodash4 = _interopRequireDefault(_lodash3);

var _lodash5 = __webpack_require__("../node_modules/lodash.isnull/index.js");

var _lodash6 = _interopRequireDefault(_lodash5);

var _constants = __webpack_require__("../node_modules/redux-flight-control/build/constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createRequestAction(type, request) {
  var payloadCreator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _lodash2.default;

  (0, _invariant2.default)((0, _lodash4.default)(request), 'Expected request to be a function');

  (0, _invariant2.default)((0, _lodash4.default)(payloadCreator) || (0, _lodash6.default)(payloadCreator), 'Expected payloadCreator to be a function, undefined or null');

  var finalPayloadCreator = (0, _lodash6.default)(payloadCreator) || payloadCreator === _lodash2.default ? _lodash2.default : function (head) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return head instanceof Error ? head : payloadCreator.apply(undefined, [head].concat(args));
  };

  var actionCreator = function actionCreator() {
    var payload = finalPayloadCreator.apply(undefined, arguments);
    var action = { type: _constants.QUEUE_REQUEST, meta: { request: request, requestType: type } };

    if (payload instanceof Error) {
      action.error = true;
    }

    if (payload !== undefined) {
      action.payload = payload;
    }

    return action;
  };

  return actionCreator;
}

/***/ }),

/***/ "../node_modules/redux-flight-control/build/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requestsReducer = exports.hasActiveRequestsSelector = exports.createRequestAction = exports.createHasActiveRequestSelectorFor = exports.createFailedRequestSelectorFor = exports.addRequestsSubscriber = exports.QUEUE_REQUEST = exports.FINALIZE_REQUEST = undefined;

var _constants = __webpack_require__("../node_modules/redux-flight-control/build/constants.js");

var _createRequestAction = __webpack_require__("../node_modules/redux-flight-control/build/createRequestAction.js");

var _createRequestAction2 = _interopRequireDefault(_createRequestAction);

var _reducer = __webpack_require__("../node_modules/redux-flight-control/build/reducer.js");

var _reducer2 = _interopRequireDefault(_reducer);

var _selectors = __webpack_require__("../node_modules/redux-flight-control/build/selectors.js");

var _subscriber = __webpack_require__("../node_modules/redux-flight-control/build/subscriber.js");

var _subscriber2 = _interopRequireDefault(_subscriber);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.FINALIZE_REQUEST = _constants.FINALIZE_REQUEST;
exports.QUEUE_REQUEST = _constants.QUEUE_REQUEST;
exports.addRequestsSubscriber = _subscriber2.default;
exports.createFailedRequestSelectorFor = _selectors.createFailedRequestSelectorFor;
exports.createHasActiveRequestSelectorFor = _selectors.createHasActiveRequestSelectorFor;
exports.createRequestAction = _createRequestAction2.default;
exports.hasActiveRequestsSelector = _selectors.hasActiveRequestsSelector;
exports.requestsReducer = _reducer2.default;

/***/ }),

/***/ "../node_modules/redux-flight-control/build/reducer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = undefined;

var _handleActions;

var _immutable = __webpack_require__("../node_modules/immutable/dist/immutable.js");

var _reduxActions = __webpack_require__("../node_modules/redux-actions/es/index.js");

var _constants = __webpack_require__("../node_modules/redux-flight-control/build/constants.js");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = exports.initialState = (0, _immutable.fromJS)({
  queue: [],
  pending: [],
  failed: {}
});

/**
 * removeActionFromList is called in several of the action handlers. It creates a new Immutable
 * List with all elements except for the matching request(s). In the case of multiple duplicates,
 * it removes only the first instance.
 */
function removeActionFromList(state, key, action) {
  var list = state.get(key);
  var index = list.findIndex(function (request) {
    return request.meta.requestType === action.meta.requestType && request.payload === action.payload;
  });
  // If no matching request is found the index will be -1.
  if (index < 0) {
    return list;
  }
  return list.delete(index);
}

/**
 * queueRequestHandler is the actual action dispatched wherever an api request is triggered. Its
 * purpose is to add the request to a queue, which is then efficiently batch processed later.
 */
function queueRequestHandler(state, action) {
  return state.set('queue', state.get('queue').concat(action));
}

/**
 * addPendingRequestHandler is called after some deduping logic is performed. This action removes
 * a request from the queue, adds it to pending, and (if the request has previously failed)
 * removes the failure from the store.
 */
function addPendingRequestHandler(state, action) {
  return state.set('queue', removeActionFromList(state, 'queue', action)).set('pending', state.get('pending').concat(action)).set('failed', state.get('failed').delete(action.meta.requestType));
}

/**
 * addFailedRequestHandler is called in the event of a request failing. It saves the action under
 * the key of the requestType.
 */
function addFailedRequestHandler(state, action) {
  return state.set('failed', state.get('failed').set(action.meta.requestType, action));
}

/**
 * finalizeRequestHandler is called when a request has completed, regardless of success or failure.
 * It removes the request action from pending.
 */
function finalizeRequestHandler(state, action) {
  return state.set('pending', removeActionFromList(state, 'pending', action));
}

/**
 * clearFailedRequestHandler removes a failed request object from the store. It is not a part of
 * the normal request processing lifecycle, but a separate action that can be called.
 */
function clearFailedRequestHandler(state, action) {
  return state.set('failed', state.get('failed').delete(action.payload.requestType));
}

/**
 * clearQueuedRequestHandler is called in the event a duplicated request is found, before the
 * request is added to pending. This effectively cancels the request before it is submitted.
 */
function clearQueuedRequestHandler(state, action) {
  return state.set('queue', removeActionFromList(state, 'queue', action));
}

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _constants.QUEUE_REQUEST, queueRequestHandler), _defineProperty(_handleActions, _constants.ADD_PENDING_REQUEST, addPendingRequestHandler), _defineProperty(_handleActions, _constants.ADD_FAILED_REQUEST, addFailedRequestHandler), _defineProperty(_handleActions, _constants.FINALIZE_REQUEST, finalizeRequestHandler), _defineProperty(_handleActions, _constants.CLEAR_FAILED_REQUEST, clearFailedRequestHandler), _defineProperty(_handleActions, _constants.CLEAR_QUEUED_REQUEST, clearQueuedRequestHandler), _handleActions), initialState);

/***/ }),

/***/ "../node_modules/redux-flight-control/build/selectors.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createFailedRequestSelectorFor = exports.createHasActiveRequestSelectorFor = exports.hasActiveRequestsSelector = exports.pendingRequestsSelector = exports.queuedRequestsSelector = undefined;

var _lodash = __webpack_require__("../node_modules/lodash.curry/index.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _reselect = __webpack_require__("../node_modules/reselect/lib/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var requestsStoreSelector = function requestsStoreSelector(state) {
  return state.get('requests');
};

var queuedRequestsSelector = exports.queuedRequestsSelector = (0, _reselect.createSelector)(requestsStoreSelector, function (requestsStore) {
  return requestsStore.get('queue');
});

var pendingRequestsSelector = exports.pendingRequestsSelector = (0, _reselect.createSelector)(requestsStoreSelector, function (requestsStore) {
  return requestsStore.get('pending');
});

var hasActiveRequestsSelector = exports.hasActiveRequestsSelector = (0, _reselect.createSelector)(queuedRequestsSelector, pendingRequestsSelector, function (queuedRequests, pendingRequests) {
  return !!(queuedRequests.size > 0 || pendingRequests.size > 0);
});

/**
 * A factory function that creates a selector for the pending request of a given type
 */
var createHasActiveRequestSelectorFor = exports.createHasActiveRequestSelectorFor = (0, _lodash2.default)(function (queuedRequestsSel, pendingRequestsSel, REQUEST_TYPE) {
  return (0, _reselect.createSelector)(queuedRequestsSel, pendingRequestsSel, function (queuedRequests, pendingRequests) {
    return !!(queuedRequests.some(function (queuedRequest) {
      return queuedRequest.meta.requestType === REQUEST_TYPE;
    }) || pendingRequests.some(function (pendingRequest) {
      return pendingRequest.meta.requestType === REQUEST_TYPE;
    }));
  });
})(queuedRequestsSelector, pendingRequestsSelector);

var failedRequestsSelector = (0, _reselect.createSelector)(requestsStoreSelector, function (requestsStore) {
  return requestsStore.get('failed');
});

/**
 * A factory function that creates a selector for the failed request of a given type
 */
var createFailedRequestSelectorFor = exports.createFailedRequestSelectorFor = (0, _lodash2.default)(function (failedRequestsSel, REQUEST_TYPE) {
  return (0, _reselect.createSelector)(failedRequestsSel, function (failedRequests) {
    return failedRequests.get(REQUEST_TYPE);
  });
})(failedRequestsSelector);

/***/ }),

/***/ "../node_modules/redux-flight-control/build/subscriber.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.buildClearQueuedRequestAction = buildClearQueuedRequestAction;
exports.buildPendingRequestAction = buildPendingRequestAction;
exports.requestsMatch = requestsMatch;
exports.isRequestUnique = isRequestUnique;
exports.handleRequestsQueueChange = handleRequestsQueueChange;

var _lodash = __webpack_require__("../node_modules/lodash.curry/index.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = __webpack_require__("../node_modules/lodash.throttle/index.js");

var _lodash4 = _interopRequireDefault(_lodash3);

var _constants = __webpack_require__("../node_modules/redux-flight-control/build/constants.js");

var _selectors = __webpack_require__("../node_modules/redux-flight-control/build/selectors.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function buildClearQueuedRequestAction(queuedRequest) {
  return _extends({}, queuedRequest, {
    type: _constants.CLEAR_QUEUED_REQUEST
  });
}

function buildPendingRequestAction(store, _ref) {
  var _ref$meta = _ref.meta,
      requestType = _ref$meta.requestType,
      request = _ref$meta.request,
      payload = _ref.payload;

  return {
    type: _constants.ADD_PENDING_REQUEST,
    meta: {
      requestType: requestType,
      request: request(payload).then(function (_ref2) {
        var response = _ref2.response,
            error = _ref2.error;

        if (error) {
          store.dispatch({
            type: _constants.ADD_FAILED_REQUEST,
            error: true,
            payload: error,
            meta: {
              requestType: requestType,
              requestPayload: payload
            }
          });
        } else {
          store.dispatch({
            type: requestType,
            payload: response,
            meta: {
              requestPayload: payload
            }
          });
        }
      }).then(function () {
        store.dispatch({
          type: _constants.FINALIZE_REQUEST,
          meta: {
            requestType: requestType
          },
          payload: payload
        });
      })
    },
    payload: payload
  };
}

function requestsMatch(requestOne, requestTwo) {
  return requestOne === requestTwo || requestOne.meta.requestType === requestTwo.meta.requestType && requestOne.payload === requestTwo.payload;
}

function isRequestUnique(request, queuedRequests, pendingRequests) {
  var matcher = (0, _lodash2.default)(requestsMatch)(request);

  // see if this request exists more than once in the request queue....
  var matchingQueuedRequests = queuedRequests.filter(matcher);
  if (matchingQueuedRequests.count() > 1) {
    return false;
  }

  // not double-queued, see if this request is already pending...
  return !pendingRequests.find(matcher);
}

function handleRequestsQueueChange(store) {
  var currentState = store.getState();
  var queuedRequests = (0, _selectors.queuedRequestsSelector)(currentState);
  if (queuedRequests.size > 0) {
    var pendingRequests = (0, _selectors.pendingRequestsSelector)(currentState);
    queuedRequests.forEach(function (queuedRequest) {
      if (isRequestUnique(queuedRequest, queuedRequests, pendingRequests)) {
        var pendingRequestAction = buildPendingRequestAction(store, queuedRequest);
        store.dispatch(pendingRequestAction);
      } else {
        var clearQueuedRequestAction = buildClearQueuedRequestAction(queuedRequest);
        store.dispatch(clearQueuedRequestAction);
      }
      return true;
    });
  }
}

function addRequestsSubscriber(store) {
  var throttleFunc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _lodash4.default;

  var onStateChange = throttleFunc(function () {
    handleRequestsQueueChange(store);
  }, 16);
  return store.subscribe(onStateChange);
}

exports.default = addRequestsSubscriber;

/***/ }),

/***/ "../node_modules/redux-immutable/dist/combineReducers.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__("../node_modules/immutable/dist/immutable.js");

var _immutable2 = _interopRequireDefault(_immutable);

var _utilities = __webpack_require__("../node_modules/redux-immutable/dist/utilities/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (reducers) {
  var getDefaultState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _immutable2.default.Map;

  var reducerKeys = Object.keys(reducers);

  // eslint-disable-next-line space-infix-ops
  return function () {
    var inputState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getDefaultState();
    var action = arguments[1];

    // eslint-disable-next-line no-process-env
    if (false) {
      var warningMessage = (0, _utilities.getUnexpectedInvocationParameterMessage)(inputState, reducers, action);

      if (warningMessage) {
        // eslint-disable-next-line no-console
        console.error(warningMessage);
      }
    }

    return inputState.withMutations(function (temporaryState) {
      reducerKeys.forEach(function (reducerName) {
        var reducer = reducers[reducerName];
        var currentDomainState = temporaryState.get(reducerName);
        var nextDomainState = reducer(currentDomainState, action);

        (0, _utilities.validateNextState)(nextDomainState, reducerName, action);

        temporaryState.set(reducerName, nextDomainState);
      });
    });
  };
};

module.exports = exports['default'];
//# sourceMappingURL=combineReducers.js.map

/***/ }),

/***/ "../node_modules/redux-immutable/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.combineReducers = undefined;

var _combineReducers2 = __webpack_require__("../node_modules/redux-immutable/dist/combineReducers.js");

var _combineReducers3 = _interopRequireDefault(_combineReducers2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.combineReducers = _combineReducers3.default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../node_modules/redux-immutable/dist/utilities/getStateName.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (action) {
  return action && action.type === '@@redux/INIT' ? 'initialState argument passed to createStore' : 'previous state received by the reducer';
};

module.exports = exports['default'];
//# sourceMappingURL=getStateName.js.map

/***/ }),

/***/ "../node_modules/redux-immutable/dist/utilities/getUnexpectedInvocationParameterMessage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__("../node_modules/immutable/dist/immutable.js");

var _immutable2 = _interopRequireDefault(_immutable);

var _getStateName = __webpack_require__("../node_modules/redux-immutable/dist/utilities/getStateName.js");

var _getStateName2 = _interopRequireDefault(_getStateName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (state, reducers, action) {
  var reducerNames = Object.keys(reducers);

  if (!reducerNames.length) {
    return 'Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.';
  }

  var stateName = (0, _getStateName2.default)(action);

  if (_immutable2.default.isImmutable ? !_immutable2.default.isImmutable(state) : !_immutable2.default.Iterable.isIterable(state)) {
    return 'The ' + stateName + ' is of unexpected type. Expected argument to be an instance of Immutable.Collection or Immutable.Record with the following properties: "' + reducerNames.join('", "') + '".';
  }

  var unexpectedStatePropertyNames = state.toSeq().keySeq().toArray().filter(function (name) {
    return !reducers.hasOwnProperty(name);
  });

  if (unexpectedStatePropertyNames.length > 0) {
    return 'Unexpected ' + (unexpectedStatePropertyNames.length === 1 ? 'property' : 'properties') + ' "' + unexpectedStatePropertyNames.join('", "') + '" found in ' + stateName + '. Expected to find one of the known reducer property names instead: "' + reducerNames.join('", "') + '". Unexpected properties will be ignored.';
  }

  return null;
};

module.exports = exports['default'];
//# sourceMappingURL=getUnexpectedInvocationParameterMessage.js.map

/***/ }),

/***/ "../node_modules/redux-immutable/dist/utilities/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateNextState = exports.getUnexpectedInvocationParameterMessage = exports.getStateName = undefined;

var _getStateName2 = __webpack_require__("../node_modules/redux-immutable/dist/utilities/getStateName.js");

var _getStateName3 = _interopRequireDefault(_getStateName2);

var _getUnexpectedInvocationParameterMessage2 = __webpack_require__("../node_modules/redux-immutable/dist/utilities/getUnexpectedInvocationParameterMessage.js");

var _getUnexpectedInvocationParameterMessage3 = _interopRequireDefault(_getUnexpectedInvocationParameterMessage2);

var _validateNextState2 = __webpack_require__("../node_modules/redux-immutable/dist/utilities/validateNextState.js");

var _validateNextState3 = _interopRequireDefault(_validateNextState2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.getStateName = _getStateName3.default;
exports.getUnexpectedInvocationParameterMessage = _getUnexpectedInvocationParameterMessage3.default;
exports.validateNextState = _validateNextState3.default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../node_modules/redux-immutable/dist/utilities/validateNextState.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (nextState, reducerName, action) {
  // eslint-disable-next-line no-undefined
  if (nextState === undefined) {
    throw new Error('Reducer "' + reducerName + '" returned undefined when handling "' + action.type + '" action. To ignore an action, you must explicitly return the previous state.');
  }
};

module.exports = exports['default'];
//# sourceMappingURL=validateNextState.js.map

/***/ }),

/***/ "../node_modules/requires-port/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Check if we're required to add a port number.
 *
 * @see https://url.spec.whatwg.org/#default-port
 * @param {Number|String} port Port number we need to check
 * @param {String} protocol Protocol we need to check against.
 * @returns {Boolean} Is it a default port for the given protocol
 * @api private
 */
module.exports = function required(port, protocol) {
  protocol = protocol.split(':')[0];
  port = +port;

  if (!port) return false;

  switch (protocol) {
    case 'http':
    case 'ws':
    return port !== 80;

    case 'https':
    case 'wss':
    return port !== 443;

    case 'ftp':
    return port !== 21;

    case 'gopher':
    return port !== 70;

    case 'file':
    return false;
  }

  return port !== 0;
};


/***/ }),

/***/ "../node_modules/reselect/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.defaultMemoize = defaultMemoize;
exports.createSelectorCreator = createSelectorCreator;
exports.createStructuredSelector = createStructuredSelector;
function defaultEqualityCheck(a, b) {
  return a === b;
}

function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
  if (prev === null || next === null || prev.length !== next.length) {
    return false;
  }

  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
  var length = prev.length;
  for (var i = 0; i < length; i++) {
    if (!equalityCheck(prev[i], next[i])) {
      return false;
    }
  }

  return true;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;

  var lastArgs = null;
  var lastResult = null;
  // we reference arguments instead of spreading them for performance reasons
  return function () {
    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
      // apply arguments instead of spreading for performance.
      lastResult = func.apply(null, arguments);
    }

    lastArgs = arguments;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptions[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      // apply arguments instead of spreading for performance.
      return resultFunc.apply(null, arguments);
    }].concat(memoizeOptions));

    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
    var selector = defaultMemoize(function () {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        params.push(dependencies[i].apply(null, arguments));
      }

      // apply arguments instead of spreading for performance.
      return memoizedResultFunc.apply(null, params);
    });

    selector.resultFunc = resultFunc;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}

/***/ }),

/***/ "../node_modules/safe-buffer/index.js":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__("../node_modules/buffer/index.js")
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),

/***/ "../node_modules/sax/lib/sax.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {;(function (sax) { // wrapper for non-node envs
  sax.parser = function (strict, opt) { return new SAXParser(strict, opt) }
  sax.SAXParser = SAXParser
  sax.SAXStream = SAXStream
  sax.createStream = createStream

  // When we pass the MAX_BUFFER_LENGTH position, start checking for buffer overruns.
  // When we check, schedule the next check for MAX_BUFFER_LENGTH - (max(buffer lengths)),
  // since that's the earliest that a buffer overrun could occur.  This way, checks are
  // as rare as required, but as often as necessary to ensure never crossing this bound.
  // Furthermore, buffers are only tested at most once per write(), so passing a very
  // large string into write() might have undesirable effects, but this is manageable by
  // the caller, so it is assumed to be safe.  Thus, a call to write() may, in the extreme
  // edge case, result in creating at most one complete copy of the string passed in.
  // Set to Infinity to have unlimited buffers.
  sax.MAX_BUFFER_LENGTH = 64 * 1024

  var buffers = [
    'comment', 'sgmlDecl', 'textNode', 'tagName', 'doctype',
    'procInstName', 'procInstBody', 'entity', 'attribName',
    'attribValue', 'cdata', 'script'
  ]

  sax.EVENTS = [
    'text',
    'processinginstruction',
    'sgmldeclaration',
    'doctype',
    'comment',
    'opentagstart',
    'attribute',
    'opentag',
    'closetag',
    'opencdata',
    'cdata',
    'closecdata',
    'error',
    'end',
    'ready',
    'script',
    'opennamespace',
    'closenamespace'
  ]

  function SAXParser (strict, opt) {
    if (!(this instanceof SAXParser)) {
      return new SAXParser(strict, opt)
    }

    var parser = this
    clearBuffers(parser)
    parser.q = parser.c = ''
    parser.bufferCheckPosition = sax.MAX_BUFFER_LENGTH
    parser.opt = opt || {}
    parser.opt.lowercase = parser.opt.lowercase || parser.opt.lowercasetags
    parser.looseCase = parser.opt.lowercase ? 'toLowerCase' : 'toUpperCase'
    parser.tags = []
    parser.closed = parser.closedRoot = parser.sawRoot = false
    parser.tag = parser.error = null
    parser.strict = !!strict
    parser.noscript = !!(strict || parser.opt.noscript)
    parser.state = S.BEGIN
    parser.strictEntities = parser.opt.strictEntities
    parser.ENTITIES = parser.strictEntities ? Object.create(sax.XML_ENTITIES) : Object.create(sax.ENTITIES)
    parser.attribList = []

    // namespaces form a prototype chain.
    // it always points at the current tag,
    // which protos to its parent tag.
    if (parser.opt.xmlns) {
      parser.ns = Object.create(rootNS)
    }

    // mostly just for error reporting
    parser.trackPosition = parser.opt.position !== false
    if (parser.trackPosition) {
      parser.position = parser.line = parser.column = 0
    }
    emit(parser, 'onready')
  }

  if (!Object.create) {
    Object.create = function (o) {
      function F () {}
      F.prototype = o
      var newf = new F()
      return newf
    }
  }

  if (!Object.keys) {
    Object.keys = function (o) {
      var a = []
      for (var i in o) if (o.hasOwnProperty(i)) a.push(i)
      return a
    }
  }

  function checkBufferLength (parser) {
    var maxAllowed = Math.max(sax.MAX_BUFFER_LENGTH, 10)
    var maxActual = 0
    for (var i = 0, l = buffers.length; i < l; i++) {
      var len = parser[buffers[i]].length
      if (len > maxAllowed) {
        // Text/cdata nodes can get big, and since they're buffered,
        // we can get here under normal conditions.
        // Avoid issues by emitting the text node now,
        // so at least it won't get any bigger.
        switch (buffers[i]) {
          case 'textNode':
            closeText(parser)
            break

          case 'cdata':
            emitNode(parser, 'oncdata', parser.cdata)
            parser.cdata = ''
            break

          case 'script':
            emitNode(parser, 'onscript', parser.script)
            parser.script = ''
            break

          default:
            error(parser, 'Max buffer length exceeded: ' + buffers[i])
        }
      }
      maxActual = Math.max(maxActual, len)
    }
    // schedule the next check for the earliest possible buffer overrun.
    var m = sax.MAX_BUFFER_LENGTH - maxActual
    parser.bufferCheckPosition = m + parser.position
  }

  function clearBuffers (parser) {
    for (var i = 0, l = buffers.length; i < l; i++) {
      parser[buffers[i]] = ''
    }
  }

  function flushBuffers (parser) {
    closeText(parser)
    if (parser.cdata !== '') {
      emitNode(parser, 'oncdata', parser.cdata)
      parser.cdata = ''
    }
    if (parser.script !== '') {
      emitNode(parser, 'onscript', parser.script)
      parser.script = ''
    }
  }

  SAXParser.prototype = {
    end: function () { end(this) },
    write: write,
    resume: function () { this.error = null; return this },
    close: function () { return this.write(null) },
    flush: function () { flushBuffers(this) }
  }

  var Stream
  try {
    Stream = __webpack_require__("../node_modules/stream-browserify/index.js").Stream
  } catch (ex) {
    Stream = function () {}
  }

  var streamWraps = sax.EVENTS.filter(function (ev) {
    return ev !== 'error' && ev !== 'end'
  })

  function createStream (strict, opt) {
    return new SAXStream(strict, opt)
  }

  function SAXStream (strict, opt) {
    if (!(this instanceof SAXStream)) {
      return new SAXStream(strict, opt)
    }

    Stream.apply(this)

    this._parser = new SAXParser(strict, opt)
    this.writable = true
    this.readable = true

    var me = this

    this._parser.onend = function () {
      me.emit('end')
    }

    this._parser.onerror = function (er) {
      me.emit('error', er)

      // if didn't throw, then means error was handled.
      // go ahead and clear error, so we can write again.
      me._parser.error = null
    }

    this._decoder = null

    streamWraps.forEach(function (ev) {
      Object.defineProperty(me, 'on' + ev, {
        get: function () {
          return me._parser['on' + ev]
        },
        set: function (h) {
          if (!h) {
            me.removeAllListeners(ev)
            me._parser['on' + ev] = h
            return h
          }
          me.on(ev, h)
        },
        enumerable: true,
        configurable: false
      })
    })
  }

  SAXStream.prototype = Object.create(Stream.prototype, {
    constructor: {
      value: SAXStream
    }
  })

  SAXStream.prototype.write = function (data) {
    if (typeof Buffer === 'function' &&
      typeof Buffer.isBuffer === 'function' &&
      Buffer.isBuffer(data)) {
      if (!this._decoder) {
        var SD = __webpack_require__("../node_modules/string_decoder/index.js").StringDecoder
        this._decoder = new SD('utf8')
      }
      data = this._decoder.write(data)
    }

    this._parser.write(data.toString())
    this.emit('data', data)
    return true
  }

  SAXStream.prototype.end = function (chunk) {
    if (chunk && chunk.length) {
      this.write(chunk)
    }
    this._parser.end()
    return true
  }

  SAXStream.prototype.on = function (ev, handler) {
    var me = this
    if (!me._parser['on' + ev] && streamWraps.indexOf(ev) !== -1) {
      me._parser['on' + ev] = function () {
        var args = arguments.length === 1 ? [arguments[0]] : Array.apply(null, arguments)
        args.splice(0, 0, ev)
        me.emit.apply(me, args)
      }
    }

    return Stream.prototype.on.call(me, ev, handler)
  }

  // this really needs to be replaced with character classes.
  // XML allows all manner of ridiculous numbers and digits.
  var CDATA = '[CDATA['
  var DOCTYPE = 'DOCTYPE'
  var XML_NAMESPACE = 'http://www.w3.org/XML/1998/namespace'
  var XMLNS_NAMESPACE = 'http://www.w3.org/2000/xmlns/'
  var rootNS = { xml: XML_NAMESPACE, xmlns: XMLNS_NAMESPACE }

  // http://www.w3.org/TR/REC-xml/#NT-NameStartChar
  // This implementation works on strings, a single character at a time
  // as such, it cannot ever support astral-plane characters (10000-EFFFF)
  // without a significant breaking change to either this  parser, or the
  // JavaScript language.  Implementation of an emoji-capable xml parser
  // is left as an exercise for the reader.
  var nameStart = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/

  var nameBody = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/

  var entityStart = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/
  var entityBody = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040.\d-]/

  function isWhitespace (c) {
    return c === ' ' || c === '\n' || c === '\r' || c === '\t'
  }

  function isQuote (c) {
    return c === '"' || c === '\''
  }

  function isAttribEnd (c) {
    return c === '>' || isWhitespace(c)
  }

  function isMatch (regex, c) {
    return regex.test(c)
  }

  function notMatch (regex, c) {
    return !isMatch(regex, c)
  }

  var S = 0
  sax.STATE = {
    BEGIN: S++, // leading byte order mark or whitespace
    BEGIN_WHITESPACE: S++, // leading whitespace
    TEXT: S++, // general stuff
    TEXT_ENTITY: S++, // &amp and such.
    OPEN_WAKA: S++, // <
    SGML_DECL: S++, // <!BLARG
    SGML_DECL_QUOTED: S++, // <!BLARG foo "bar
    DOCTYPE: S++, // <!DOCTYPE
    DOCTYPE_QUOTED: S++, // <!DOCTYPE "//blah
    DOCTYPE_DTD: S++, // <!DOCTYPE "//blah" [ ...
    DOCTYPE_DTD_QUOTED: S++, // <!DOCTYPE "//blah" [ "foo
    COMMENT_STARTING: S++, // <!-
    COMMENT: S++, // <!--
    COMMENT_ENDING: S++, // <!-- blah -
    COMMENT_ENDED: S++, // <!-- blah --
    CDATA: S++, // <![CDATA[ something
    CDATA_ENDING: S++, // ]
    CDATA_ENDING_2: S++, // ]]
    PROC_INST: S++, // <?hi
    PROC_INST_BODY: S++, // <?hi there
    PROC_INST_ENDING: S++, // <?hi "there" ?
    OPEN_TAG: S++, // <strong
    OPEN_TAG_SLASH: S++, // <strong /
    ATTRIB: S++, // <a
    ATTRIB_NAME: S++, // <a foo
    ATTRIB_NAME_SAW_WHITE: S++, // <a foo _
    ATTRIB_VALUE: S++, // <a foo=
    ATTRIB_VALUE_QUOTED: S++, // <a foo="bar
    ATTRIB_VALUE_CLOSED: S++, // <a foo="bar"
    ATTRIB_VALUE_UNQUOTED: S++, // <a foo=bar
    ATTRIB_VALUE_ENTITY_Q: S++, // <foo bar="&quot;"
    ATTRIB_VALUE_ENTITY_U: S++, // <foo bar=&quot
    CLOSE_TAG: S++, // </a
    CLOSE_TAG_SAW_WHITE: S++, // </a   >
    SCRIPT: S++, // <script> ...
    SCRIPT_ENDING: S++ // <script> ... <
  }

  sax.XML_ENTITIES = {
    'amp': '&',
    'gt': '>',
    'lt': '<',
    'quot': '"',
    'apos': "'"
  }

  sax.ENTITIES = {
    'amp': '&',
    'gt': '>',
    'lt': '<',
    'quot': '"',
    'apos': "'",
    'AElig': 198,
    'Aacute': 193,
    'Acirc': 194,
    'Agrave': 192,
    'Aring': 197,
    'Atilde': 195,
    'Auml': 196,
    'Ccedil': 199,
    'ETH': 208,
    'Eacute': 201,
    'Ecirc': 202,
    'Egrave': 200,
    'Euml': 203,
    'Iacute': 205,
    'Icirc': 206,
    'Igrave': 204,
    'Iuml': 207,
    'Ntilde': 209,
    'Oacute': 211,
    'Ocirc': 212,
    'Ograve': 210,
    'Oslash': 216,
    'Otilde': 213,
    'Ouml': 214,
    'THORN': 222,
    'Uacute': 218,
    'Ucirc': 219,
    'Ugrave': 217,
    'Uuml': 220,
    'Yacute': 221,
    'aacute': 225,
    'acirc': 226,
    'aelig': 230,
    'agrave': 224,
    'aring': 229,
    'atilde': 227,
    'auml': 228,
    'ccedil': 231,
    'eacute': 233,
    'ecirc': 234,
    'egrave': 232,
    'eth': 240,
    'euml': 235,
    'iacute': 237,
    'icirc': 238,
    'igrave': 236,
    'iuml': 239,
    'ntilde': 241,
    'oacute': 243,
    'ocirc': 244,
    'ograve': 242,
    'oslash': 248,
    'otilde': 245,
    'ouml': 246,
    'szlig': 223,
    'thorn': 254,
    'uacute': 250,
    'ucirc': 251,
    'ugrave': 249,
    'uuml': 252,
    'yacute': 253,
    'yuml': 255,
    'copy': 169,
    'reg': 174,
    'nbsp': 160,
    'iexcl': 161,
    'cent': 162,
    'pound': 163,
    'curren': 164,
    'yen': 165,
    'brvbar': 166,
    'sect': 167,
    'uml': 168,
    'ordf': 170,
    'laquo': 171,
    'not': 172,
    'shy': 173,
    'macr': 175,
    'deg': 176,
    'plusmn': 177,
    'sup1': 185,
    'sup2': 178,
    'sup3': 179,
    'acute': 180,
    'micro': 181,
    'para': 182,
    'middot': 183,
    'cedil': 184,
    'ordm': 186,
    'raquo': 187,
    'frac14': 188,
    'frac12': 189,
    'frac34': 190,
    'iquest': 191,
    'times': 215,
    'divide': 247,
    'OElig': 338,
    'oelig': 339,
    'Scaron': 352,
    'scaron': 353,
    'Yuml': 376,
    'fnof': 402,
    'circ': 710,
    'tilde': 732,
    'Alpha': 913,
    'Beta': 914,
    'Gamma': 915,
    'Delta': 916,
    'Epsilon': 917,
    'Zeta': 918,
    'Eta': 919,
    'Theta': 920,
    'Iota': 921,
    'Kappa': 922,
    'Lambda': 923,
    'Mu': 924,
    'Nu': 925,
    'Xi': 926,
    'Omicron': 927,
    'Pi': 928,
    'Rho': 929,
    'Sigma': 931,
    'Tau': 932,
    'Upsilon': 933,
    'Phi': 934,
    'Chi': 935,
    'Psi': 936,
    'Omega': 937,
    'alpha': 945,
    'beta': 946,
    'gamma': 947,
    'delta': 948,
    'epsilon': 949,
    'zeta': 950,
    'eta': 951,
    'theta': 952,
    'iota': 953,
    'kappa': 954,
    'lambda': 955,
    'mu': 956,
    'nu': 957,
    'xi': 958,
    'omicron': 959,
    'pi': 960,
    'rho': 961,
    'sigmaf': 962,
    'sigma': 963,
    'tau': 964,
    'upsilon': 965,
    'phi': 966,
    'chi': 967,
    'psi': 968,
    'omega': 969,
    'thetasym': 977,
    'upsih': 978,
    'piv': 982,
    'ensp': 8194,
    'emsp': 8195,
    'thinsp': 8201,
    'zwnj': 8204,
    'zwj': 8205,
    'lrm': 8206,
    'rlm': 8207,
    'ndash': 8211,
    'mdash': 8212,
    'lsquo': 8216,
    'rsquo': 8217,
    'sbquo': 8218,
    'ldquo': 8220,
    'rdquo': 8221,
    'bdquo': 8222,
    'dagger': 8224,
    'Dagger': 8225,
    'bull': 8226,
    'hellip': 8230,
    'permil': 8240,
    'prime': 8242,
    'Prime': 8243,
    'lsaquo': 8249,
    'rsaquo': 8250,
    'oline': 8254,
    'frasl': 8260,
    'euro': 8364,
    'image': 8465,
    'weierp': 8472,
    'real': 8476,
    'trade': 8482,
    'alefsym': 8501,
    'larr': 8592,
    'uarr': 8593,
    'rarr': 8594,
    'darr': 8595,
    'harr': 8596,
    'crarr': 8629,
    'lArr': 8656,
    'uArr': 8657,
    'rArr': 8658,
    'dArr': 8659,
    'hArr': 8660,
    'forall': 8704,
    'part': 8706,
    'exist': 8707,
    'empty': 8709,
    'nabla': 8711,
    'isin': 8712,
    'notin': 8713,
    'ni': 8715,
    'prod': 8719,
    'sum': 8721,
    'minus': 8722,
    'lowast': 8727,
    'radic': 8730,
    'prop': 8733,
    'infin': 8734,
    'ang': 8736,
    'and': 8743,
    'or': 8744,
    'cap': 8745,
    'cup': 8746,
    'int': 8747,
    'there4': 8756,
    'sim': 8764,
    'cong': 8773,
    'asymp': 8776,
    'ne': 8800,
    'equiv': 8801,
    'le': 8804,
    'ge': 8805,
    'sub': 8834,
    'sup': 8835,
    'nsub': 8836,
    'sube': 8838,
    'supe': 8839,
    'oplus': 8853,
    'otimes': 8855,
    'perp': 8869,
    'sdot': 8901,
    'lceil': 8968,
    'rceil': 8969,
    'lfloor': 8970,
    'rfloor': 8971,
    'lang': 9001,
    'rang': 9002,
    'loz': 9674,
    'spades': 9824,
    'clubs': 9827,
    'hearts': 9829,
    'diams': 9830
  }

  Object.keys(sax.ENTITIES).forEach(function (key) {
    var e = sax.ENTITIES[key]
    var s = typeof e === 'number' ? String.fromCharCode(e) : e
    sax.ENTITIES[key] = s
  })

  for (var s in sax.STATE) {
    sax.STATE[sax.STATE[s]] = s
  }

  // shorthand
  S = sax.STATE

  function emit (parser, event, data) {
    parser[event] && parser[event](data)
  }

  function emitNode (parser, nodeType, data) {
    if (parser.textNode) closeText(parser)
    emit(parser, nodeType, data)
  }

  function closeText (parser) {
    parser.textNode = textopts(parser.opt, parser.textNode)
    if (parser.textNode) emit(parser, 'ontext', parser.textNode)
    parser.textNode = ''
  }

  function textopts (opt, text) {
    if (opt.trim) text = text.trim()
    if (opt.normalize) text = text.replace(/\s+/g, ' ')
    return text
  }

  function error (parser, er) {
    closeText(parser)
    if (parser.trackPosition) {
      er += '\nLine: ' + parser.line +
        '\nColumn: ' + parser.column +
        '\nChar: ' + parser.c
    }
    er = new Error(er)
    parser.error = er
    emit(parser, 'onerror', er)
    return parser
  }

  function end (parser) {
    if (parser.sawRoot && !parser.closedRoot) strictFail(parser, 'Unclosed root tag')
    if ((parser.state !== S.BEGIN) &&
      (parser.state !== S.BEGIN_WHITESPACE) &&
      (parser.state !== S.TEXT)) {
      error(parser, 'Unexpected end')
    }
    closeText(parser)
    parser.c = ''
    parser.closed = true
    emit(parser, 'onend')
    SAXParser.call(parser, parser.strict, parser.opt)
    return parser
  }

  function strictFail (parser, message) {
    if (typeof parser !== 'object' || !(parser instanceof SAXParser)) {
      throw new Error('bad call to strictFail')
    }
    if (parser.strict) {
      error(parser, message)
    }
  }

  function newTag (parser) {
    if (!parser.strict) parser.tagName = parser.tagName[parser.looseCase]()
    var parent = parser.tags[parser.tags.length - 1] || parser
    var tag = parser.tag = { name: parser.tagName, attributes: {} }

    // will be overridden if tag contails an xmlns="foo" or xmlns:foo="bar"
    if (parser.opt.xmlns) {
      tag.ns = parent.ns
    }
    parser.attribList.length = 0
    emitNode(parser, 'onopentagstart', tag)
  }

  function qname (name, attribute) {
    var i = name.indexOf(':')
    var qualName = i < 0 ? [ '', name ] : name.split(':')
    var prefix = qualName[0]
    var local = qualName[1]

    // <x "xmlns"="http://foo">
    if (attribute && name === 'xmlns') {
      prefix = 'xmlns'
      local = ''
    }

    return { prefix: prefix, local: local }
  }

  function attrib (parser) {
    if (!parser.strict) {
      parser.attribName = parser.attribName[parser.looseCase]()
    }

    if (parser.attribList.indexOf(parser.attribName) !== -1 ||
      parser.tag.attributes.hasOwnProperty(parser.attribName)) {
      parser.attribName = parser.attribValue = ''
      return
    }

    if (parser.opt.xmlns) {
      var qn = qname(parser.attribName, true)
      var prefix = qn.prefix
      var local = qn.local

      if (prefix === 'xmlns') {
        // namespace binding attribute. push the binding into scope
        if (local === 'xml' && parser.attribValue !== XML_NAMESPACE) {
          strictFail(parser,
            'xml: prefix must be bound to ' + XML_NAMESPACE + '\n' +
            'Actual: ' + parser.attribValue)
        } else if (local === 'xmlns' && parser.attribValue !== XMLNS_NAMESPACE) {
          strictFail(parser,
            'xmlns: prefix must be bound to ' + XMLNS_NAMESPACE + '\n' +
            'Actual: ' + parser.attribValue)
        } else {
          var tag = parser.tag
          var parent = parser.tags[parser.tags.length - 1] || parser
          if (tag.ns === parent.ns) {
            tag.ns = Object.create(parent.ns)
          }
          tag.ns[local] = parser.attribValue
        }
      }

      // defer onattribute events until all attributes have been seen
      // so any new bindings can take effect. preserve attribute order
      // so deferred events can be emitted in document order
      parser.attribList.push([parser.attribName, parser.attribValue])
    } else {
      // in non-xmlns mode, we can emit the event right away
      parser.tag.attributes[parser.attribName] = parser.attribValue
      emitNode(parser, 'onattribute', {
        name: parser.attribName,
        value: parser.attribValue
      })
    }

    parser.attribName = parser.attribValue = ''
  }

  function openTag (parser, selfClosing) {
    if (parser.opt.xmlns) {
      // emit namespace binding events
      var tag = parser.tag

      // add namespace info to tag
      var qn = qname(parser.tagName)
      tag.prefix = qn.prefix
      tag.local = qn.local
      tag.uri = tag.ns[qn.prefix] || ''

      if (tag.prefix && !tag.uri) {
        strictFail(parser, 'Unbound namespace prefix: ' +
          JSON.stringify(parser.tagName))
        tag.uri = qn.prefix
      }

      var parent = parser.tags[parser.tags.length - 1] || parser
      if (tag.ns && parent.ns !== tag.ns) {
        Object.keys(tag.ns).forEach(function (p) {
          emitNode(parser, 'onopennamespace', {
            prefix: p,
            uri: tag.ns[p]
          })
        })
      }

      // handle deferred onattribute events
      // Note: do not apply default ns to attributes:
      //   http://www.w3.org/TR/REC-xml-names/#defaulting
      for (var i = 0, l = parser.attribList.length; i < l; i++) {
        var nv = parser.attribList[i]
        var name = nv[0]
        var value = nv[1]
        var qualName = qname(name, true)
        var prefix = qualName.prefix
        var local = qualName.local
        var uri = prefix === '' ? '' : (tag.ns[prefix] || '')
        var a = {
          name: name,
          value: value,
          prefix: prefix,
          local: local,
          uri: uri
        }

        // if there's any attributes with an undefined namespace,
        // then fail on them now.
        if (prefix && prefix !== 'xmlns' && !uri) {
          strictFail(parser, 'Unbound namespace prefix: ' +
            JSON.stringify(prefix))
          a.uri = prefix
        }
        parser.tag.attributes[name] = a
        emitNode(parser, 'onattribute', a)
      }
      parser.attribList.length = 0
    }

    parser.tag.isSelfClosing = !!selfClosing

    // process the tag
    parser.sawRoot = true
    parser.tags.push(parser.tag)
    emitNode(parser, 'onopentag', parser.tag)
    if (!selfClosing) {
      // special case for <script> in non-strict mode.
      if (!parser.noscript && parser.tagName.toLowerCase() === 'script') {
        parser.state = S.SCRIPT
      } else {
        parser.state = S.TEXT
      }
      parser.tag = null
      parser.tagName = ''
    }
    parser.attribName = parser.attribValue = ''
    parser.attribList.length = 0
  }

  function closeTag (parser) {
    if (!parser.tagName) {
      strictFail(parser, 'Weird empty close tag.')
      parser.textNode += '</>'
      parser.state = S.TEXT
      return
    }

    if (parser.script) {
      if (parser.tagName !== 'script') {
        parser.script += '</' + parser.tagName + '>'
        parser.tagName = ''
        parser.state = S.SCRIPT
        return
      }
      emitNode(parser, 'onscript', parser.script)
      parser.script = ''
    }

    // first make sure that the closing tag actually exists.
    // <a><b></c></b></a> will close everything, otherwise.
    var t = parser.tags.length
    var tagName = parser.tagName
    if (!parser.strict) {
      tagName = tagName[parser.looseCase]()
    }
    var closeTo = tagName
    while (t--) {
      var close = parser.tags[t]
      if (close.name !== closeTo) {
        // fail the first time in strict mode
        strictFail(parser, 'Unexpected close tag')
      } else {
        break
      }
    }

    // didn't find it.  we already failed for strict, so just abort.
    if (t < 0) {
      strictFail(parser, 'Unmatched closing tag: ' + parser.tagName)
      parser.textNode += '</' + parser.tagName + '>'
      parser.state = S.TEXT
      return
    }
    parser.tagName = tagName
    var s = parser.tags.length
    while (s-- > t) {
      var tag = parser.tag = parser.tags.pop()
      parser.tagName = parser.tag.name
      emitNode(parser, 'onclosetag', parser.tagName)

      var x = {}
      for (var i in tag.ns) {
        x[i] = tag.ns[i]
      }

      var parent = parser.tags[parser.tags.length - 1] || parser
      if (parser.opt.xmlns && tag.ns !== parent.ns) {
        // remove namespace bindings introduced by tag
        Object.keys(tag.ns).forEach(function (p) {
          var n = tag.ns[p]
          emitNode(parser, 'onclosenamespace', { prefix: p, uri: n })
        })
      }
    }
    if (t === 0) parser.closedRoot = true
    parser.tagName = parser.attribValue = parser.attribName = ''
    parser.attribList.length = 0
    parser.state = S.TEXT
  }

  function parseEntity (parser) {
    var entity = parser.entity
    var entityLC = entity.toLowerCase()
    var num
    var numStr = ''

    if (parser.ENTITIES[entity]) {
      return parser.ENTITIES[entity]
    }
    if (parser.ENTITIES[entityLC]) {
      return parser.ENTITIES[entityLC]
    }
    entity = entityLC
    if (entity.charAt(0) === '#') {
      if (entity.charAt(1) === 'x') {
        entity = entity.slice(2)
        num = parseInt(entity, 16)
        numStr = num.toString(16)
      } else {
        entity = entity.slice(1)
        num = parseInt(entity, 10)
        numStr = num.toString(10)
      }
    }
    entity = entity.replace(/^0+/, '')
    if (isNaN(num) || numStr.toLowerCase() !== entity) {
      strictFail(parser, 'Invalid character entity')
      return '&' + parser.entity + ';'
    }

    return String.fromCodePoint(num)
  }

  function beginWhiteSpace (parser, c) {
    if (c === '<') {
      parser.state = S.OPEN_WAKA
      parser.startTagPosition = parser.position
    } else if (!isWhitespace(c)) {
      // have to process this as a text node.
      // weird, but happens.
      strictFail(parser, 'Non-whitespace before first tag.')
      parser.textNode = c
      parser.state = S.TEXT
    }
  }

  function charAt (chunk, i) {
    var result = ''
    if (i < chunk.length) {
      result = chunk.charAt(i)
    }
    return result
  }

  function write (chunk) {
    var parser = this
    if (this.error) {
      throw this.error
    }
    if (parser.closed) {
      return error(parser,
        'Cannot write after close. Assign an onready handler.')
    }
    if (chunk === null) {
      return end(parser)
    }
    if (typeof chunk === 'object') {
      chunk = chunk.toString()
    }
    var i = 0
    var c = ''
    while (true) {
      c = charAt(chunk, i++)
      parser.c = c

      if (!c) {
        break
      }

      if (parser.trackPosition) {
        parser.position++
        if (c === '\n') {
          parser.line++
          parser.column = 0
        } else {
          parser.column++
        }
      }

      switch (parser.state) {
        case S.BEGIN:
          parser.state = S.BEGIN_WHITESPACE
          if (c === '\uFEFF') {
            continue
          }
          beginWhiteSpace(parser, c)
          continue

        case S.BEGIN_WHITESPACE:
          beginWhiteSpace(parser, c)
          continue

        case S.TEXT:
          if (parser.sawRoot && !parser.closedRoot) {
            var starti = i - 1
            while (c && c !== '<' && c !== '&') {
              c = charAt(chunk, i++)
              if (c && parser.trackPosition) {
                parser.position++
                if (c === '\n') {
                  parser.line++
                  parser.column = 0
                } else {
                  parser.column++
                }
              }
            }
            parser.textNode += chunk.substring(starti, i - 1)
          }
          if (c === '<' && !(parser.sawRoot && parser.closedRoot && !parser.strict)) {
            parser.state = S.OPEN_WAKA
            parser.startTagPosition = parser.position
          } else {
            if (!isWhitespace(c) && (!parser.sawRoot || parser.closedRoot)) {
              strictFail(parser, 'Text data outside of root node.')
            }
            if (c === '&') {
              parser.state = S.TEXT_ENTITY
            } else {
              parser.textNode += c
            }
          }
          continue

        case S.SCRIPT:
          // only non-strict
          if (c === '<') {
            parser.state = S.SCRIPT_ENDING
          } else {
            parser.script += c
          }
          continue

        case S.SCRIPT_ENDING:
          if (c === '/') {
            parser.state = S.CLOSE_TAG
          } else {
            parser.script += '<' + c
            parser.state = S.SCRIPT
          }
          continue

        case S.OPEN_WAKA:
          // either a /, ?, !, or text is coming next.
          if (c === '!') {
            parser.state = S.SGML_DECL
            parser.sgmlDecl = ''
          } else if (isWhitespace(c)) {
            // wait for it...
          } else if (isMatch(nameStart, c)) {
            parser.state = S.OPEN_TAG
            parser.tagName = c
          } else if (c === '/') {
            parser.state = S.CLOSE_TAG
            parser.tagName = ''
          } else if (c === '?') {
            parser.state = S.PROC_INST
            parser.procInstName = parser.procInstBody = ''
          } else {
            strictFail(parser, 'Unencoded <')
            // if there was some whitespace, then add that in.
            if (parser.startTagPosition + 1 < parser.position) {
              var pad = parser.position - parser.startTagPosition
              c = new Array(pad).join(' ') + c
            }
            parser.textNode += '<' + c
            parser.state = S.TEXT
          }
          continue

        case S.SGML_DECL:
          if ((parser.sgmlDecl + c).toUpperCase() === CDATA) {
            emitNode(parser, 'onopencdata')
            parser.state = S.CDATA
            parser.sgmlDecl = ''
            parser.cdata = ''
          } else if (parser.sgmlDecl + c === '--') {
            parser.state = S.COMMENT
            parser.comment = ''
            parser.sgmlDecl = ''
          } else if ((parser.sgmlDecl + c).toUpperCase() === DOCTYPE) {
            parser.state = S.DOCTYPE
            if (parser.doctype || parser.sawRoot) {
              strictFail(parser,
                'Inappropriately located doctype declaration')
            }
            parser.doctype = ''
            parser.sgmlDecl = ''
          } else if (c === '>') {
            emitNode(parser, 'onsgmldeclaration', parser.sgmlDecl)
            parser.sgmlDecl = ''
            parser.state = S.TEXT
          } else if (isQuote(c)) {
            parser.state = S.SGML_DECL_QUOTED
            parser.sgmlDecl += c
          } else {
            parser.sgmlDecl += c
          }
          continue

        case S.SGML_DECL_QUOTED:
          if (c === parser.q) {
            parser.state = S.SGML_DECL
            parser.q = ''
          }
          parser.sgmlDecl += c
          continue

        case S.DOCTYPE:
          if (c === '>') {
            parser.state = S.TEXT
            emitNode(parser, 'ondoctype', parser.doctype)
            parser.doctype = true // just remember that we saw it.
          } else {
            parser.doctype += c
            if (c === '[') {
              parser.state = S.DOCTYPE_DTD
            } else if (isQuote(c)) {
              parser.state = S.DOCTYPE_QUOTED
              parser.q = c
            }
          }
          continue

        case S.DOCTYPE_QUOTED:
          parser.doctype += c
          if (c === parser.q) {
            parser.q = ''
            parser.state = S.DOCTYPE
          }
          continue

        case S.DOCTYPE_DTD:
          parser.doctype += c
          if (c === ']') {
            parser.state = S.DOCTYPE
          } else if (isQuote(c)) {
            parser.state = S.DOCTYPE_DTD_QUOTED
            parser.q = c
          }
          continue

        case S.DOCTYPE_DTD_QUOTED:
          parser.doctype += c
          if (c === parser.q) {
            parser.state = S.DOCTYPE_DTD
            parser.q = ''
          }
          continue

        case S.COMMENT:
          if (c === '-') {
            parser.state = S.COMMENT_ENDING
          } else {
            parser.comment += c
          }
          continue

        case S.COMMENT_ENDING:
          if (c === '-') {
            parser.state = S.COMMENT_ENDED
            parser.comment = textopts(parser.opt, parser.comment)
            if (parser.comment) {
              emitNode(parser, 'oncomment', parser.comment)
            }
            parser.comment = ''
          } else {
            parser.comment += '-' + c
            parser.state = S.COMMENT
          }
          continue

        case S.COMMENT_ENDED:
          if (c !== '>') {
            strictFail(parser, 'Malformed comment')
            // allow <!-- blah -- bloo --> in non-strict mode,
            // which is a comment of " blah -- bloo "
            parser.comment += '--' + c
            parser.state = S.COMMENT
          } else {
            parser.state = S.TEXT
          }
          continue

        case S.CDATA:
          if (c === ']') {
            parser.state = S.CDATA_ENDING
          } else {
            parser.cdata += c
          }
          continue

        case S.CDATA_ENDING:
          if (c === ']') {
            parser.state = S.CDATA_ENDING_2
          } else {
            parser.cdata += ']' + c
            parser.state = S.CDATA
          }
          continue

        case S.CDATA_ENDING_2:
          if (c === '>') {
            if (parser.cdata) {
              emitNode(parser, 'oncdata', parser.cdata)
            }
            emitNode(parser, 'onclosecdata')
            parser.cdata = ''
            parser.state = S.TEXT
          } else if (c === ']') {
            parser.cdata += ']'
          } else {
            parser.cdata += ']]' + c
            parser.state = S.CDATA
          }
          continue

        case S.PROC_INST:
          if (c === '?') {
            parser.state = S.PROC_INST_ENDING
          } else if (isWhitespace(c)) {
            parser.state = S.PROC_INST_BODY
          } else {
            parser.procInstName += c
          }
          continue

        case S.PROC_INST_BODY:
          if (!parser.procInstBody && isWhitespace(c)) {
            continue
          } else if (c === '?') {
            parser.state = S.PROC_INST_ENDING
          } else {
            parser.procInstBody += c
          }
          continue

        case S.PROC_INST_ENDING:
          if (c === '>') {
            emitNode(parser, 'onprocessinginstruction', {
              name: parser.procInstName,
              body: parser.procInstBody
            })
            parser.procInstName = parser.procInstBody = ''
            parser.state = S.TEXT
          } else {
            parser.procInstBody += '?' + c
            parser.state = S.PROC_INST_BODY
          }
          continue

        case S.OPEN_TAG:
          if (isMatch(nameBody, c)) {
            parser.tagName += c
          } else {
            newTag(parser)
            if (c === '>') {
              openTag(parser)
            } else if (c === '/') {
              parser.state = S.OPEN_TAG_SLASH
            } else {
              if (!isWhitespace(c)) {
                strictFail(parser, 'Invalid character in tag name')
              }
              parser.state = S.ATTRIB
            }
          }
          continue

        case S.OPEN_TAG_SLASH:
          if (c === '>') {
            openTag(parser, true)
            closeTag(parser)
          } else {
            strictFail(parser, 'Forward-slash in opening tag not followed by >')
            parser.state = S.ATTRIB
          }
          continue

        case S.ATTRIB:
          // haven't read the attribute name yet.
          if (isWhitespace(c)) {
            continue
          } else if (c === '>') {
            openTag(parser)
          } else if (c === '/') {
            parser.state = S.OPEN_TAG_SLASH
          } else if (isMatch(nameStart, c)) {
            parser.attribName = c
            parser.attribValue = ''
            parser.state = S.ATTRIB_NAME
          } else {
            strictFail(parser, 'Invalid attribute name')
          }
          continue

        case S.ATTRIB_NAME:
          if (c === '=') {
            parser.state = S.ATTRIB_VALUE
          } else if (c === '>') {
            strictFail(parser, 'Attribute without value')
            parser.attribValue = parser.attribName
            attrib(parser)
            openTag(parser)
          } else if (isWhitespace(c)) {
            parser.state = S.ATTRIB_NAME_SAW_WHITE
          } else if (isMatch(nameBody, c)) {
            parser.attribName += c
          } else {
            strictFail(parser, 'Invalid attribute name')
          }
          continue

        case S.ATTRIB_NAME_SAW_WHITE:
          if (c === '=') {
            parser.state = S.ATTRIB_VALUE
          } else if (isWhitespace(c)) {
            continue
          } else {
            strictFail(parser, 'Attribute without value')
            parser.tag.attributes[parser.attribName] = ''
            parser.attribValue = ''
            emitNode(parser, 'onattribute', {
              name: parser.attribName,
              value: ''
            })
            parser.attribName = ''
            if (c === '>') {
              openTag(parser)
            } else if (isMatch(nameStart, c)) {
              parser.attribName = c
              parser.state = S.ATTRIB_NAME
            } else {
              strictFail(parser, 'Invalid attribute name')
              parser.state = S.ATTRIB
            }
          }
          continue

        case S.ATTRIB_VALUE:
          if (isWhitespace(c)) {
            continue
          } else if (isQuote(c)) {
            parser.q = c
            parser.state = S.ATTRIB_VALUE_QUOTED
          } else {
            strictFail(parser, 'Unquoted attribute value')
            parser.state = S.ATTRIB_VALUE_UNQUOTED
            parser.attribValue = c
          }
          continue

        case S.ATTRIB_VALUE_QUOTED:
          if (c !== parser.q) {
            if (c === '&') {
              parser.state = S.ATTRIB_VALUE_ENTITY_Q
            } else {
              parser.attribValue += c
            }
            continue
          }
          attrib(parser)
          parser.q = ''
          parser.state = S.ATTRIB_VALUE_CLOSED
          continue

        case S.ATTRIB_VALUE_CLOSED:
          if (isWhitespace(c)) {
            parser.state = S.ATTRIB
          } else if (c === '>') {
            openTag(parser)
          } else if (c === '/') {
            parser.state = S.OPEN_TAG_SLASH
          } else if (isMatch(nameStart, c)) {
            strictFail(parser, 'No whitespace between attributes')
            parser.attribName = c
            parser.attribValue = ''
            parser.state = S.ATTRIB_NAME
          } else {
            strictFail(parser, 'Invalid attribute name')
          }
          continue

        case S.ATTRIB_VALUE_UNQUOTED:
          if (!isAttribEnd(c)) {
            if (c === '&') {
              parser.state = S.ATTRIB_VALUE_ENTITY_U
            } else {
              parser.attribValue += c
            }
            continue
          }
          attrib(parser)
          if (c === '>') {
            openTag(parser)
          } else {
            parser.state = S.ATTRIB
          }
          continue

        case S.CLOSE_TAG:
          if (!parser.tagName) {
            if (isWhitespace(c)) {
              continue
            } else if (notMatch(nameStart, c)) {
              if (parser.script) {
                parser.script += '</' + c
                parser.state = S.SCRIPT
              } else {
                strictFail(parser, 'Invalid tagname in closing tag.')
              }
            } else {
              parser.tagName = c
            }
          } else if (c === '>') {
            closeTag(parser)
          } else if (isMatch(nameBody, c)) {
            parser.tagName += c
          } else if (parser.script) {
            parser.script += '</' + parser.tagName
            parser.tagName = ''
            parser.state = S.SCRIPT
          } else {
            if (!isWhitespace(c)) {
              strictFail(parser, 'Invalid tagname in closing tag')
            }
            parser.state = S.CLOSE_TAG_SAW_WHITE
          }
          continue

        case S.CLOSE_TAG_SAW_WHITE:
          if (isWhitespace(c)) {
            continue
          }
          if (c === '>') {
            closeTag(parser)
          } else {
            strictFail(parser, 'Invalid characters in closing tag')
          }
          continue

        case S.TEXT_ENTITY:
        case S.ATTRIB_VALUE_ENTITY_Q:
        case S.ATTRIB_VALUE_ENTITY_U:
          var returnState
          var buffer
          switch (parser.state) {
            case S.TEXT_ENTITY:
              returnState = S.TEXT
              buffer = 'textNode'
              break

            case S.ATTRIB_VALUE_ENTITY_Q:
              returnState = S.ATTRIB_VALUE_QUOTED
              buffer = 'attribValue'
              break

            case S.ATTRIB_VALUE_ENTITY_U:
              returnState = S.ATTRIB_VALUE_UNQUOTED
              buffer = 'attribValue'
              break
          }

          if (c === ';') {
            parser[buffer] += parseEntity(parser)
            parser.entity = ''
            parser.state = returnState
          } else if (isMatch(parser.entity.length ? entityBody : entityStart, c)) {
            parser.entity += c
          } else {
            strictFail(parser, 'Invalid character in entity name')
            parser[buffer] += '&' + parser.entity + c
            parser.entity = ''
            parser.state = returnState
          }

          continue

        default:
          throw new Error(parser, 'Unknown state: ' + parser.state)
      }
    } // while

    if (parser.position >= parser.bufferCheckPosition) {
      checkBufferLength(parser)
    }
    return parser
  }

  /*! http://mths.be/fromcodepoint v0.1.0 by @mathias */
  /* istanbul ignore next */
  if (!String.fromCodePoint) {
    (function () {
      var stringFromCharCode = String.fromCharCode
      var floor = Math.floor
      var fromCodePoint = function () {
        var MAX_SIZE = 0x4000
        var codeUnits = []
        var highSurrogate
        var lowSurrogate
        var index = -1
        var length = arguments.length
        if (!length) {
          return ''
        }
        var result = ''
        while (++index < length) {
          var codePoint = Number(arguments[index])
          if (
            !isFinite(codePoint) || // `NaN`, `+Infinity`, or `-Infinity`
            codePoint < 0 || // not a valid Unicode code point
            codePoint > 0x10FFFF || // not a valid Unicode code point
            floor(codePoint) !== codePoint // not an integer
          ) {
            throw RangeError('Invalid code point: ' + codePoint)
          }
          if (codePoint <= 0xFFFF) { // BMP code point
            codeUnits.push(codePoint)
          } else { // Astral code point; split in surrogate halves
            // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
            codePoint -= 0x10000
            highSurrogate = (codePoint >> 10) + 0xD800
            lowSurrogate = (codePoint % 0x400) + 0xDC00
            codeUnits.push(highSurrogate, lowSurrogate)
          }
          if (index + 1 === length || codeUnits.length > MAX_SIZE) {
            result += stringFromCharCode.apply(null, codeUnits)
            codeUnits.length = 0
          }
        }
        return result
      }
      /* istanbul ignore next */
      if (Object.defineProperty) {
        Object.defineProperty(String, 'fromCodePoint', {
          value: fromCodePoint,
          configurable: true,
          writable: true
        })
      } else {
        String.fromCodePoint = fromCodePoint
      }
    }())
  }
})( false ? this.sax = {} : exports)

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/buffer/index.js").Buffer))

/***/ }),

/***/ "../node_modules/section-iterator/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

module.exports = function (_ref) {
  var data = _ref.data;
  var multiSection = _ref.multiSection;

  function nextNonEmptySectionIndex(sectionIndex) {
    if (sectionIndex === null) {
      sectionIndex = 0;
    } else {
      sectionIndex++;
    }

    while (sectionIndex < data.length && data[sectionIndex] === 0) {
      sectionIndex++;
    }

    return sectionIndex === data.length ? null : sectionIndex;
  }

  function prevNonEmptySectionIndex(sectionIndex) {
    if (sectionIndex === null) {
      sectionIndex = data.length - 1;
    } else {
      sectionIndex--;
    }

    while (sectionIndex >= 0 && data[sectionIndex] === 0) {
      sectionIndex--;
    }

    return sectionIndex === -1 ? null : sectionIndex;
  }

  function next(position) {
    var _position = _slicedToArray(position, 2);

    var sectionIndex = _position[0];
    var itemIndex = _position[1];


    if (multiSection) {
      if (itemIndex === null || itemIndex === data[sectionIndex] - 1) {
        sectionIndex = nextNonEmptySectionIndex(sectionIndex);

        if (sectionIndex === null) {
          return [null, null];
        }

        return [sectionIndex, 0];
      }

      return [sectionIndex, itemIndex + 1];
    }

    if (data === 0 || itemIndex === data - 1) {
      return [null, null];
    }

    if (itemIndex === null) {
      return [null, 0];
    }

    return [null, itemIndex + 1];
  }

  function prev(position) {
    var _position2 = _slicedToArray(position, 2);

    var sectionIndex = _position2[0];
    var itemIndex = _position2[1];


    if (multiSection) {
      if (itemIndex === null || itemIndex === 0) {
        sectionIndex = prevNonEmptySectionIndex(sectionIndex);

        if (sectionIndex === null) {
          return [null, null];
        }

        return [sectionIndex, data[sectionIndex] - 1];
      }

      return [sectionIndex, itemIndex - 1];
    }

    if (data === 0 || itemIndex === 0) {
      return [null, null];
    }

    if (itemIndex === null) {
      return [null, data - 1];
    }

    return [null, itemIndex - 1];
  }

  function isLast(position) {
    return next(position)[1] === null;
  }

  return {
    next: next,
    prev: prev,
    isLast: isLast
  };
};


/***/ }),

/***/ "../node_modules/setimmediate/setImmediate.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/global.js"), __webpack_require__("../node_modules/process/browser.js")))

/***/ }),

/***/ "../node_modules/shallow-equal/arrays/index.js":
/***/ (function(module, exports) {

module.exports = function shallowEqualArrays(arrA, arrB) {
  if (arrA === arrB) {
    return true;
  }

  var len = arrA.length;

  if (arrB.length !== len) {
    return false;
  }

  for (var i = 0; i < len; i++) {
    if (arrA[i] !== arrB[i]) {
      return false;
    }
  }

  return true;
};


/***/ }),

/***/ "../node_modules/shallowequal/index.js":
/***/ (function(module, exports) {

module.exports = function shallowEqual(objA, objB, compare, compareContext) {

    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

    if(ret !== void 0) {
        return !!ret;
    }

    if(objA === objB) {
        return true;
    }

    if(typeof objA !== 'object' || !objA ||
       typeof objB !== 'object' || !objB) {
        return false;
    }

    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);

    if(keysA.length !== keysB.length) {
        return false;
    }

    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++) {

        var key = keysA[idx];

        if(!bHasOwnProperty(key)) {
            return false;
        }

        var valueA = objA[key];
        var valueB = objB[key];

        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

        if(ret === false ||
           ret === void 0 && valueA !== valueB) {
            return false;
        }

    }

    return true;

};


/***/ }),

/***/ "../node_modules/speakingurl/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("../node_modules/speakingurl/lib/speakingurl.js");


/***/ }),

/***/ "../node_modules/speakingurl/lib/speakingurl.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root) {
    'use strict';

    /**
     * charMap
     * @type {Object}
     */
    var charMap = {

        // latin
        'À': 'A',
        'Á': 'A',
        'Â': 'A',
        'Ã': 'A',
        'Ä': 'Ae',
        'Å': 'A',
        'Æ': 'AE',
        'Ç': 'C',
        'È': 'E',
        'É': 'E',
        'Ê': 'E',
        'Ë': 'E',
        'Ì': 'I',
        'Í': 'I',
        'Î': 'I',
        'Ï': 'I',
        'Ð': 'D',
        'Ñ': 'N',
        'Ò': 'O',
        'Ó': 'O',
        'Ô': 'O',
        'Õ': 'O',
        'Ö': 'Oe',
        'Ő': 'O',
        'Ø': 'O',
        'Ù': 'U',
        'Ú': 'U',
        'Û': 'U',
        'Ü': 'Ue',
        'Ű': 'U',
        'Ý': 'Y',
        'Þ': 'TH',
        'ß': 'ss',
        'à': 'a',
        'á': 'a',
        'â': 'a',
        'ã': 'a',
        'ä': 'ae',
        'å': 'a',
        'æ': 'ae',
        'ç': 'c',
        'è': 'e',
        'é': 'e',
        'ê': 'e',
        'ë': 'e',
        'ì': 'i',
        'í': 'i',
        'î': 'i',
        'ï': 'i',
        'ð': 'd',
        'ñ': 'n',
        'ò': 'o',
        'ó': 'o',
        'ô': 'o',
        'õ': 'o',
        'ö': 'oe',
        'ő': 'o',
        'ø': 'o',
        'ù': 'u',
        'ú': 'u',
        'û': 'u',
        'ü': 'ue',
        'ű': 'u',
        'ý': 'y',
        'þ': 'th',
        'ÿ': 'y',
        'ẞ': 'SS',

        // language specific

        // Arabic
        'ا': 'a',
        'أ': 'a',
        'إ': 'i',
        'آ': 'aa',
        'ؤ': 'u',
        'ئ': 'e',
        'ء': 'a',
        'ب': 'b',
        'ت': 't',
        'ث': 'th',
        'ج': 'j',
        'ح': 'h',
        'خ': 'kh',
        'د': 'd',
        'ذ': 'th',
        'ر': 'r',
        'ز': 'z',
        'س': 's',
        'ش': 'sh',
        'ص': 's',
        'ض': 'dh',
        'ط': 't',
        'ظ': 'z',
        'ع': 'a',
        'غ': 'gh',
        'ف': 'f',
        'ق': 'q',
        'ك': 'k',
        'ل': 'l',
        'م': 'm',
        'ن': 'n',
        'ه': 'h',
        'و': 'w',
        'ي': 'y',
        'ى': 'a',
        'ة': 'h',
        'ﻻ': 'la',
        'ﻷ': 'laa',
        'ﻹ': 'lai',
        'ﻵ': 'laa',

        // Persian additional characters than Arabic
        'گ': 'g',
        'چ': 'ch',
        'پ': 'p',
        'ژ': 'zh',
        'ک': 'k',
        'ی': 'y',

        // Arabic diactrics
        'َ': 'a',
        'ً': 'an',
        'ِ': 'e',
        'ٍ': 'en',
        'ُ': 'u',
        'ٌ': 'on',
        'ْ': '',

        // Arabic numbers
        '٠': '0',
        '١': '1',
        '٢': '2',
        '٣': '3',
        '٤': '4',
        '٥': '5',
        '٦': '6',
        '٧': '7',
        '٨': '8',
        '٩': '9',

        // Persian numbers
        '۰': '0',
        '۱': '1',
        '۲': '2',
        '۳': '3',
        '۴': '4',
        '۵': '5',
        '۶': '6',
        '۷': '7',
        '۸': '8',
        '۹': '9',

        // Burmese consonants
        'က': 'k',
        'ခ': 'kh',
        'ဂ': 'g',
        'ဃ': 'ga',
        'င': 'ng',
        'စ': 's',
        'ဆ': 'sa',
        'ဇ': 'z',
        'စျ': 'za',
        'ည': 'ny',
        'ဋ': 't',
        'ဌ': 'ta',
        'ဍ': 'd',
        'ဎ': 'da',
        'ဏ': 'na',
        'တ': 't',
        'ထ': 'ta',
        'ဒ': 'd',
        'ဓ': 'da',
        'န': 'n',
        'ပ': 'p',
        'ဖ': 'pa',
        'ဗ': 'b',
        'ဘ': 'ba',
        'မ': 'm',
        'ယ': 'y',
        'ရ': 'ya',
        'လ': 'l',
        'ဝ': 'w',
        'သ': 'th',
        'ဟ': 'h',
        'ဠ': 'la',
        'အ': 'a',
        // consonant character combos
        'ြ': 'y',
        'ျ': 'ya',
        'ွ': 'w',
        'ြွ': 'yw',
        'ျွ': 'ywa',
        'ှ': 'h',
        // independent vowels
        'ဧ': 'e',
        '၏': '-e',
        'ဣ': 'i',
        'ဤ': '-i',
        'ဉ': 'u',
        'ဦ': '-u',
        'ဩ': 'aw',
        'သြော': 'aw',
        'ဪ': 'aw',
        // numbers
        '၀': '0',
        '၁': '1',
        '၂': '2',
        '၃': '3',
        '၄': '4',
        '၅': '5',
        '၆': '6',
        '၇': '7',
        '၈': '8',
        '၉': '9',
        // virama and tone marks which are silent in transliteration
        '္': '',
        '့': '',
        'း': '',

        // Czech
        'č': 'c',
        'ď': 'd',
        'ě': 'e',
        'ň': 'n',
        'ř': 'r',
        'š': 's',
        'ť': 't',
        'ů': 'u',
        'ž': 'z',
        'Č': 'C',
        'Ď': 'D',
        'Ě': 'E',
        'Ň': 'N',
        'Ř': 'R',
        'Š': 'S',
        'Ť': 'T',
        'Ů': 'U',
        'Ž': 'Z',

        // Dhivehi
        'ހ': 'h',
        'ށ': 'sh',
        'ނ': 'n',
        'ރ': 'r',
        'ބ': 'b',
        'ޅ': 'lh',
        'ކ': 'k',
        'އ': 'a',
        'ވ': 'v',
        'މ': 'm',
        'ފ': 'f',
        'ދ': 'dh',
        'ތ': 'th',
        'ލ': 'l',
        'ގ': 'g',
        'ޏ': 'gn',
        'ސ': 's',
        'ޑ': 'd',
        'ޒ': 'z',
        'ޓ': 't',
        'ޔ': 'y',
        'ޕ': 'p',
        'ޖ': 'j',
        'ޗ': 'ch',
        'ޘ': 'tt',
        'ޙ': 'hh',
        'ޚ': 'kh',
        'ޛ': 'th',
        'ޜ': 'z',
        'ޝ': 'sh',
        'ޞ': 's',
        'ޟ': 'd',
        'ޠ': 't',
        'ޡ': 'z',
        'ޢ': 'a',
        'ޣ': 'gh',
        'ޤ': 'q',
        'ޥ': 'w',
        'ަ': 'a',
        'ާ': 'aa',
        'ި': 'i',
        'ީ': 'ee',
        'ު': 'u',
        'ޫ': 'oo',
        'ެ': 'e',
        'ޭ': 'ey',
        'ޮ': 'o',
        'ޯ': 'oa',
        'ް': '',

        // Georgian https://en.wikipedia.org/wiki/Romanization_of_Georgian
        // National system (2002)
        'ა': 'a',
        'ბ': 'b',
        'გ': 'g',
        'დ': 'd',
        'ე': 'e',
        'ვ': 'v',
        'ზ': 'z',
        'თ': 't',
        'ი': 'i',
        'კ': 'k',
        'ლ': 'l',
        'მ': 'm',
        'ნ': 'n',
        'ო': 'o',
        'პ': 'p',
        'ჟ': 'zh',
        'რ': 'r',
        'ს': 's',
        'ტ': 't',
        'უ': 'u',
        'ფ': 'p',
        'ქ': 'k',
        'ღ': 'gh',
        'ყ': 'q',
        'შ': 'sh',
        'ჩ': 'ch',
        'ც': 'ts',
        'ძ': 'dz',
        'წ': 'ts',
        'ჭ': 'ch',
        'ხ': 'kh',
        'ჯ': 'j',
        'ჰ': 'h',

        // Greek
        'α': 'a',
        'β': 'v',
        'γ': 'g',
        'δ': 'd',
        'ε': 'e',
        'ζ': 'z',
        'η': 'i',
        'θ': 'th',
        'ι': 'i',
        'κ': 'k',
        'λ': 'l',
        'μ': 'm',
        'ν': 'n',
        'ξ': 'ks',
        'ο': 'o',
        'π': 'p',
        'ρ': 'r',
        'σ': 's',
        'τ': 't',
        'υ': 'y',
        'φ': 'f',
        'χ': 'x',
        'ψ': 'ps',
        'ω': 'o',
        'ά': 'a',
        'έ': 'e',
        'ί': 'i',
        'ό': 'o',
        'ύ': 'y',
        'ή': 'i',
        'ώ': 'o',
        'ς': 's',
        'ϊ': 'i',
        'ΰ': 'y',
        'ϋ': 'y',
        'ΐ': 'i',
        'Α': 'A',
        'Β': 'B',
        'Γ': 'G',
        'Δ': 'D',
        'Ε': 'E',
        'Ζ': 'Z',
        'Η': 'I',
        'Θ': 'TH',
        'Ι': 'I',
        'Κ': 'K',
        'Λ': 'L',
        'Μ': 'M',
        'Ν': 'N',
        'Ξ': 'KS',
        'Ο': 'O',
        'Π': 'P',
        'Ρ': 'R',
        'Σ': 'S',
        'Τ': 'T',
        'Υ': 'Y',
        'Φ': 'F',
        'Χ': 'X',
        'Ψ': 'PS',
        'Ω': 'O',
        'Ά': 'A',
        'Έ': 'E',
        'Ί': 'I',
        'Ό': 'O',
        'Ύ': 'Y',
        'Ή': 'I',
        'Ώ': 'O',
        'Ϊ': 'I',
        'Ϋ': 'Y',

        // Latvian
        'ā': 'a',
        // 'č': 'c', // duplicate
        'ē': 'e',
        'ģ': 'g',
        'ī': 'i',
        'ķ': 'k',
        'ļ': 'l',
        'ņ': 'n',
        // 'š': 's', // duplicate
        'ū': 'u',
        // 'ž': 'z', // duplicate
        'Ā': 'A',
        // 'Č': 'C', // duplicate
        'Ē': 'E',
        'Ģ': 'G',
        'Ī': 'I',
        'Ķ': 'k',
        'Ļ': 'L',
        'Ņ': 'N',
        // 'Š': 'S', // duplicate
        'Ū': 'U',
        // 'Ž': 'Z', // duplicate

        // Macedonian
        'Ќ': 'Kj',
        'ќ': 'kj',
        'Љ': 'Lj',
        'љ': 'lj',
        'Њ': 'Nj',
        'њ': 'nj',
        'Тс': 'Ts',
        'тс': 'ts',

        // Polish
        'ą': 'a',
        'ć': 'c',
        'ę': 'e',
        'ł': 'l',
        'ń': 'n',
        // 'ó': 'o', // duplicate
        'ś': 's',
        'ź': 'z',
        'ż': 'z',
        'Ą': 'A',
        'Ć': 'C',
        'Ę': 'E',
        'Ł': 'L',
        'Ń': 'N',
        'Ś': 'S',
        'Ź': 'Z',
        'Ż': 'Z',

        // Ukranian
        'Є': 'Ye',
        'І': 'I',
        'Ї': 'Yi',
        'Ґ': 'G',
        'є': 'ye',
        'і': 'i',
        'ї': 'yi',
        'ґ': 'g',

        // Romanian
        'ă': 'a',
        'Ă': 'A',
        'ș': 's',
        'Ș': 'S',
        // 'ş': 's', // duplicate
        // 'Ş': 'S', // duplicate
        'ț': 't',
        'Ț': 'T',
        'ţ': 't',
        'Ţ': 'T',

        // Russian https://en.wikipedia.org/wiki/Romanization_of_Russian
        // ICAO

        'а': 'a',
        'б': 'b',
        'в': 'v',
        'г': 'g',
        'д': 'd',
        'е': 'e',
        'ё': 'yo',
        'ж': 'zh',
        'з': 'z',
        'и': 'i',
        'й': 'i',
        'к': 'k',
        'л': 'l',
        'м': 'm',
        'н': 'n',
        'о': 'o',
        'п': 'p',
        'р': 'r',
        'с': 's',
        'т': 't',
        'у': 'u',
        'ф': 'f',
        'х': 'kh',
        'ц': 'c',
        'ч': 'ch',
        'ш': 'sh',
        'щ': 'sh',
        'ъ': '',
        'ы': 'y',
        'ь': '',
        'э': 'e',
        'ю': 'yu',
        'я': 'ya',
        'А': 'A',
        'Б': 'B',
        'В': 'V',
        'Г': 'G',
        'Д': 'D',
        'Е': 'E',
        'Ё': 'Yo',
        'Ж': 'Zh',
        'З': 'Z',
        'И': 'I',
        'Й': 'I',
        'К': 'K',
        'Л': 'L',
        'М': 'M',
        'Н': 'N',
        'О': 'O',
        'П': 'P',
        'Р': 'R',
        'С': 'S',
        'Т': 'T',
        'У': 'U',
        'Ф': 'F',
        'Х': 'Kh',
        'Ц': 'C',
        'Ч': 'Ch',
        'Ш': 'Sh',
        'Щ': 'Sh',
        'Ъ': '',
        'Ы': 'Y',
        'Ь': '',
        'Э': 'E',
        'Ю': 'Yu',
        'Я': 'Ya',

        // Serbian
        'ђ': 'dj',
        'ј': 'j',
        // 'љ': 'lj',  // duplicate
        // 'њ': 'nj', // duplicate
        'ћ': 'c',
        'џ': 'dz',
        'Ђ': 'Dj',
        'Ј': 'j',
        // 'Љ': 'Lj', // duplicate
        // 'Њ': 'Nj', // duplicate
        'Ћ': 'C',
        'Џ': 'Dz',

        // Slovak
        'ľ': 'l',
        'ĺ': 'l',
        'ŕ': 'r',
        'Ľ': 'L',
        'Ĺ': 'L',
        'Ŕ': 'R',

        // Turkish
        'ş': 's',
        'Ş': 'S',
        'ı': 'i',
        'İ': 'I',
        // 'ç': 'c', // duplicate
        // 'Ç': 'C', // duplicate
        // 'ü': 'u', // duplicate, see langCharMap
        // 'Ü': 'U', // duplicate, see langCharMap
        // 'ö': 'o', // duplicate, see langCharMap
        // 'Ö': 'O', // duplicate, see langCharMap
        'ğ': 'g',
        'Ğ': 'G',

        // Vietnamese
        'ả': 'a',
        'Ả': 'A',
        'ẳ': 'a',
        'Ẳ': 'A',
        'ẩ': 'a',
        'Ẩ': 'A',
        'đ': 'd',
        'Đ': 'D',
        'ẹ': 'e',
        'Ẹ': 'E',
        'ẽ': 'e',
        'Ẽ': 'E',
        'ẻ': 'e',
        'Ẻ': 'E',
        'ế': 'e',
        'Ế': 'E',
        'ề': 'e',
        'Ề': 'E',
        'ệ': 'e',
        'Ệ': 'E',
        'ễ': 'e',
        'Ễ': 'E',
        'ể': 'e',
        'Ể': 'E',
        'ỏ': 'o',
        'ọ': 'o',
        'Ọ': 'o',
        'ố': 'o',
        'Ố': 'O',
        'ồ': 'o',
        'Ồ': 'O',
        'ổ': 'o',
        'Ổ': 'O',
        'ộ': 'o',
        'Ộ': 'O',
        'ỗ': 'o',
        'Ỗ': 'O',
        'ơ': 'o',
        'Ơ': 'O',
        'ớ': 'o',
        'Ớ': 'O',
        'ờ': 'o',
        'Ờ': 'O',
        'ợ': 'o',
        'Ợ': 'O',
        'ỡ': 'o',
        'Ỡ': 'O',
        'Ở': 'o',
        'ở': 'o',
        'ị': 'i',
        'Ị': 'I',
        'ĩ': 'i',
        'Ĩ': 'I',
        'ỉ': 'i',
        'Ỉ': 'i',
        'ủ': 'u',
        'Ủ': 'U',
        'ụ': 'u',
        'Ụ': 'U',
        'ũ': 'u',
        'Ũ': 'U',
        'ư': 'u',
        'Ư': 'U',
        'ứ': 'u',
        'Ứ': 'U',
        'ừ': 'u',
        'Ừ': 'U',
        'ự': 'u',
        'Ự': 'U',
        'ữ': 'u',
        'Ữ': 'U',
        'ử': 'u',
        'Ử': 'ư',
        'ỷ': 'y',
        'Ỷ': 'y',
        'ỳ': 'y',
        'Ỳ': 'Y',
        'ỵ': 'y',
        'Ỵ': 'Y',
        'ỹ': 'y',
        'Ỹ': 'Y',
        'ạ': 'a',
        'Ạ': 'A',
        'ấ': 'a',
        'Ấ': 'A',
        'ầ': 'a',
        'Ầ': 'A',
        'ậ': 'a',
        'Ậ': 'A',
        'ẫ': 'a',
        'Ẫ': 'A',
        // 'ă': 'a', // duplicate
        // 'Ă': 'A', // duplicate
        'ắ': 'a',
        'Ắ': 'A',
        'ằ': 'a',
        'Ằ': 'A',
        'ặ': 'a',
        'Ặ': 'A',
        'ẵ': 'a',
        'Ẵ': 'A',
        "⓪": "0",
        "①": "1",
        "②": "2",
        "③": "3",
        "④": "4",
        "⑤": "5",
        "⑥": "6",
        "⑦": "7",
        "⑧": "8",
        "⑨": "9",
        "⑩": "10",
        "⑪": "11",
        "⑫": "12",
        "⑬": "13",
        "⑭": "14",
        "⑮": "15",
        "⑯": "16",
        "⑰": "17",
        "⑱": "18",
        "⑲": "18",
        "⑳": "18",

        "⓵": "1",
        "⓶": "2",
        "⓷": "3",
        "⓸": "4",
        "⓹": "5",
        "⓺": "6",
        "⓻": "7",
        "⓼": "8",
        "⓽": "9",
        "⓾": "10",

        "⓿": "0",
        "⓫": "11",
        "⓬": "12",
        "⓭": "13",
        "⓮": "14",
        "⓯": "15",
        "⓰": "16",
        "⓱": "17",
        "⓲": "18",
        "⓳": "19",
        "⓴": "20",

        "Ⓐ": "A",
        "Ⓑ": "B",
        "Ⓒ": "C",
        "Ⓓ": "D",
        "Ⓔ": "E",
        "Ⓕ": "F",
        "Ⓖ": "G",
        "Ⓗ": "H",
        "Ⓘ": "I",
        "Ⓙ": "J",
        "Ⓚ": "K",
        "Ⓛ": "L",
        "Ⓜ": "M",
        "Ⓝ": "N",
        "Ⓞ": "O",
        "Ⓟ": "P",
        "Ⓠ": "Q",
        "Ⓡ": "R",
        "Ⓢ": "S",
        "Ⓣ": "T",
        "Ⓤ": "U",
        "Ⓥ": "V",
        "Ⓦ": "W",
        "Ⓧ": "X",
        "Ⓨ": "Y",
        "Ⓩ": "Z",

        "ⓐ": "a",
        "ⓑ": "b",
        "ⓒ": "c",
        "ⓓ": "d",
        "ⓔ": "e",
        "ⓕ": "f",
        "ⓖ": "g",
        "ⓗ": "h",
        "ⓘ": "i",
        "ⓙ": "j",
        "ⓚ": "k",
        "ⓛ": "l",
        "ⓜ": "m",
        "ⓝ": "n",
        "ⓞ": "o",
        "ⓟ": "p",
        "ⓠ": "q",
        "ⓡ": "r",
        "ⓢ": "s",
        "ⓣ": "t",
        "ⓤ": "u",
        "ⓦ": "v",
        "ⓥ": "w",
        "ⓧ": "x",
        "ⓨ": "y",
        "ⓩ": "z",

        // symbols
        '“': '"',
        '”': '"',
        '‘': "'",
        '’': "'",
        '∂': 'd',
        'ƒ': 'f',
        '™': '(TM)',
        '©': '(C)',
        'œ': 'oe',
        'Œ': 'OE',
        '®': '(R)',
        '†': '+',
        '℠': '(SM)',
        '…': '...',
        '˚': 'o',
        'º': 'o',
        'ª': 'a',
        '•': '*',
        '၊': ',',
        '။': '.',

        // currency
        '$': 'USD',
        '€': 'EUR',
        '₢': 'BRN',
        '₣': 'FRF',
        '£': 'GBP',
        '₤': 'ITL',
        '₦': 'NGN',
        '₧': 'ESP',
        '₩': 'KRW',
        '₪': 'ILS',
        '₫': 'VND',
        '₭': 'LAK',
        '₮': 'MNT',
        '₯': 'GRD',
        '₱': 'ARS',
        '₲': 'PYG',
        '₳': 'ARA',
        '₴': 'UAH',
        '₵': 'GHS',
        '¢': 'cent',
        '¥': 'CNY',
        '元': 'CNY',
        '円': 'YEN',
        '﷼': 'IRR',
        '₠': 'EWE',
        '฿': 'THB',
        '₨': 'INR',
        '₹': 'INR',
        '₰': 'PF',
        '₺': 'TRY',
        '؋': 'AFN',
        '₼': 'AZN',
        'лв': 'BGN',
        '៛': 'KHR',
        '₡': 'CRC',
        '₸': 'KZT',
        'ден': 'MKD',
        'zł': 'PLN',
        '₽': 'RUB',
        '₾': 'GEL'

    };

    /**
     * special look ahead character array
     * These characters form with consonants to become 'single'/consonant combo
     * @type [Array]
     */
    var lookAheadCharArray = [
        // burmese
        '်',

        // Dhivehi
        'ް'
    ];

    /**
     * diatricMap for languages where transliteration changes entirely as more diatrics are added
     * @type {Object}
     */
    var diatricMap = {
        // Burmese
        // dependent vowels
        'ာ': 'a',
        'ါ': 'a',
        'ေ': 'e',
        'ဲ': 'e',
        'ိ': 'i',
        'ီ': 'i',
        'ို': 'o',
        'ု': 'u',
        'ူ': 'u',
        'ေါင်': 'aung',
        'ော': 'aw',
        'ော်': 'aw',
        'ေါ': 'aw',
        'ေါ်': 'aw',
        '်': '်', // this is special case but the character will be converted to latin in the code
        'က်': 'et',
        'ိုက်': 'aik',
        'ောက်': 'auk',
        'င်': 'in',
        'ိုင်': 'aing',
        'ောင်': 'aung',
        'စ်': 'it',
        'ည်': 'i',
        'တ်': 'at',
        'ိတ်': 'eik',
        'ုတ်': 'ok',
        'ွတ်': 'ut',
        'ေတ်': 'it',
        'ဒ်': 'd',
        'ိုဒ်': 'ok',
        'ုဒ်': 'ait',
        'န်': 'an',
        'ာန်': 'an',
        'ိန်': 'ein',
        'ုန်': 'on',
        'ွန်': 'un',
        'ပ်': 'at',
        'ိပ်': 'eik',
        'ုပ်': 'ok',
        'ွပ်': 'ut',
        'န်ုပ်': 'nub',
        'မ်': 'an',
        'ိမ်': 'ein',
        'ုမ်': 'on',
        'ွမ်': 'un',
        'ယ်': 'e',
        'ိုလ်': 'ol',
        'ဉ်': 'in',
        'ံ': 'an',
        'ိံ': 'ein',
        'ုံ': 'on',

        // Dhivehi
        'ައް': 'ah',
        'ަށް': 'ah'
    };

    /**
     * langCharMap language specific characters translations
     * @type   {Object}
     */
    var langCharMap = {
        'en': {}, // default language

        'az': { // Azerbaijani
            'ç': 'c',
            'ə': 'e',
            'ğ': 'g',
            'ı': 'i',
            'ö': 'o',
            'ş': 's',
            'ü': 'u',
            'Ç': 'C',
            'Ə': 'E',
            'Ğ': 'G',
            'İ': 'I',
            'Ö': 'O',
            'Ş': 'S',
            'Ü': 'U'
        },

        'cs': { // Czech
            'č': 'c',
            'ď': 'd',
            'ě': 'e',
            'ň': 'n',
            'ř': 'r',
            'š': 's',
            'ť': 't',
            'ů': 'u',
            'ž': 'z',
            'Č': 'C',
            'Ď': 'D',
            'Ě': 'E',
            'Ň': 'N',
            'Ř': 'R',
            'Š': 'S',
            'Ť': 'T',
            'Ů': 'U',
            'Ž': 'Z'
        },

        'fi': { // Finnish
            // 'å': 'a', duplicate see charMap/latin
            // 'Å': 'A', duplicate see charMap/latin
            'ä': 'a', // ok
            'Ä': 'A', // ok
            'ö': 'o', // ok
            'Ö': 'O' // ok
        },

        'hu': { // Hungarian
            'ä': 'a', // ok
            'Ä': 'A', // ok
            // 'á': 'a', duplicate see charMap/latin
            // 'Á': 'A', duplicate see charMap/latin
            'ö': 'o', // ok
            'Ö': 'O', // ok
            // 'ő': 'o', duplicate see charMap/latin
            // 'Ő': 'O', duplicate see charMap/latin
            'ü': 'u',
            'Ü': 'U',
            'ű': 'u',
            'Ű': 'U'
        },

        'lt': { // Lithuanian
            'ą': 'a',
            'č': 'c',
            'ę': 'e',
            'ė': 'e',
            'į': 'i',
            'š': 's',
            'ų': 'u',
            'ū': 'u',
            'ž': 'z',
            'Ą': 'A',
            'Č': 'C',
            'Ę': 'E',
            'Ė': 'E',
            'Į': 'I',
            'Š': 'S',
            'Ų': 'U',
            'Ū': 'U'
        },

        'lv': { // Latvian
            'ā': 'a',
            'č': 'c',
            'ē': 'e',
            'ģ': 'g',
            'ī': 'i',
            'ķ': 'k',
            'ļ': 'l',
            'ņ': 'n',
            'š': 's',
            'ū': 'u',
            'ž': 'z',
            'Ā': 'A',
            'Č': 'C',
            'Ē': 'E',
            'Ģ': 'G',
            'Ī': 'i',
            'Ķ': 'k',
            'Ļ': 'L',
            'Ņ': 'N',
            'Š': 'S',
            'Ū': 'u',
            'Ž': 'Z'
        },

        'pl': { // Polish
            'ą': 'a',
            'ć': 'c',
            'ę': 'e',
            'ł': 'l',
            'ń': 'n',
            'ó': 'o',
            'ś': 's',
            'ź': 'z',
            'ż': 'z',
            'Ą': 'A',
            'Ć': 'C',
            'Ę': 'e',
            'Ł': 'L',
            'Ń': 'N',
            'Ó': 'O',
            'Ś': 'S',
            'Ź': 'Z',
            'Ż': 'Z'
        },

        'sv': { // Swedish
            // 'å': 'a', duplicate see charMap/latin
            // 'Å': 'A', duplicate see charMap/latin
            'ä': 'a', // ok
            'Ä': 'A', // ok
            'ö': 'o', // ok
            'Ö': 'O' // ok
        },

        'sk': { // Slovak
            'ä': 'a',
            'Ä': 'A'
        },

        'sr': { // Serbian
            'љ': 'lj',
            'њ': 'nj',
            'Љ': 'Lj',
            'Њ': 'Nj',
            'đ': 'dj',
            'Đ': 'Dj'
        },

        'tr': { // Turkish
            'Ü': 'U',
            'Ö': 'O',
            'ü': 'u',
            'ö': 'o'
        }
    };

    /**
     * symbolMap language specific symbol translations
     * translations must be transliterated already
     * @type   {Object}
     */
    var symbolMap = {
        'ar': {
            '∆': 'delta',
            '∞': 'la-nihaya',
            '♥': 'hob',
            '&': 'wa',
            '|': 'aw',
            '<': 'aqal-men',
            '>': 'akbar-men',
            '∑': 'majmou',
            '¤': 'omla'
        },

        'az': {},

        'ca': {
            '∆': 'delta',
            '∞': 'infinit',
            '♥': 'amor',
            '&': 'i',
            '|': 'o',
            '<': 'menys que',
            '>': 'mes que',
            '∑': 'suma dels',
            '¤': 'moneda'
        },

        'cs': {
            '∆': 'delta',
            '∞': 'nekonecno',
            '♥': 'laska',
            '&': 'a',
            '|': 'nebo',
            '<': 'mensi nez',
            '>': 'vetsi nez',
            '∑': 'soucet',
            '¤': 'mena'
        },

        'de': {
            '∆': 'delta',
            '∞': 'unendlich',
            '♥': 'Liebe',
            '&': 'und',
            '|': 'oder',
            '<': 'kleiner als',
            '>': 'groesser als',
            '∑': 'Summe von',
            '¤': 'Waehrung'
        },

        'dv': {
            '∆': 'delta',
            '∞': 'kolunulaa',
            '♥': 'loabi',
            '&': 'aai',
            '|': 'noonee',
            '<': 'ah vure kuda',
            '>': 'ah vure bodu',
            '∑': 'jumula',
            '¤': 'faisaa'
        },

        'en': {
            '∆': 'delta',
            '∞': 'infinity',
            '♥': 'love',
            '&': 'and',
            '|': 'or',
            '<': 'less than',
            '>': 'greater than',
            '∑': 'sum',
            '¤': 'currency'
        },

        'es': {
            '∆': 'delta',
            '∞': 'infinito',
            '♥': 'amor',
            '&': 'y',
            '|': 'u',
            '<': 'menos que',
            '>': 'mas que',
            '∑': 'suma de los',
            '¤': 'moneda'
        },

        'fa': {
            '∆': 'delta',
            '∞': 'bi-nahayat',
            '♥': 'eshgh',
            '&': 'va',
            '|': 'ya',
            '<': 'kamtar-az',
            '>': 'bishtar-az',
            '∑': 'majmooe',
            '¤': 'vahed'
        },

        'fi': {
            '∆': 'delta',
            '∞': 'aarettomyys',
            '♥': 'rakkaus',
            '&': 'ja',
            '|': 'tai',
            '<': 'pienempi kuin',
            '>': 'suurempi kuin',
            '∑': 'summa',
            '¤': 'valuutta'
        },

        'fr': {
            '∆': 'delta',
            '∞': 'infiniment',
            '♥': 'Amour',
            '&': 'et',
            '|': 'ou',
            '<': 'moins que',
            '>': 'superieure a',
            '∑': 'somme des',
            '¤': 'monnaie'
        },

        'ge': {
            '∆': 'delta',
            '∞': 'usasruloba',
            '♥': 'siqvaruli',
            '&': 'da',
            '|': 'an',
            '<': 'naklebi',
            '>': 'meti',
            '∑': 'jami',
            '¤': 'valuta'
        },

        'gr': {},

        'hu': {
            '∆': 'delta',
            '∞': 'vegtelen',
            '♥': 'szerelem',
            '&': 'es',
            '|': 'vagy',
            '<': 'kisebb mint',
            '>': 'nagyobb mint',
            '∑': 'szumma',
            '¤': 'penznem'
        },

        'it': {
            '∆': 'delta',
            '∞': 'infinito',
            '♥': 'amore',
            '&': 'e',
            '|': 'o',
            '<': 'minore di',
            '>': 'maggiore di',
            '∑': 'somma',
            '¤': 'moneta'
        },

        'lt': {
            '∆': 'delta',
            '∞': 'begalybe',
            '♥': 'meile',
            '&': 'ir',
            '|': 'ar',
            '<': 'maziau nei',
            '>': 'daugiau nei',
            '∑': 'suma',
            '¤': 'valiuta'
        },

        'lv': {
            '∆': 'delta',
            '∞': 'bezgaliba',
            '♥': 'milestiba',
            '&': 'un',
            '|': 'vai',
            '<': 'mazak neka',
            '>': 'lielaks neka',
            '∑': 'summa',
            '¤': 'valuta'
        },

        'my': {
            '∆': 'kwahkhyaet',
            '∞': 'asaonasme',
            '♥': 'akhyait',
            '&': 'nhin',
            '|': 'tho',
            '<': 'ngethaw',
            '>': 'kyithaw',
            '∑': 'paungld',
            '¤': 'ngwekye'
        },

        'mk': {},

        'nl': {
            '∆': 'delta',
            '∞': 'oneindig',
            '♥': 'liefde',
            '&': 'en',
            '|': 'of',
            '<': 'kleiner dan',
            '>': 'groter dan',
            '∑': 'som',
            '¤': 'valuta'
        },

        'pl': {
            '∆': 'delta',
            '∞': 'nieskonczonosc',
            '♥': 'milosc',
            '&': 'i',
            '|': 'lub',
            '<': 'mniejsze niz',
            '>': 'wieksze niz',
            '∑': 'suma',
            '¤': 'waluta'
        },

        'pt': {
            '∆': 'delta',
            '∞': 'infinito',
            '♥': 'amor',
            '&': 'e',
            '|': 'ou',
            '<': 'menor que',
            '>': 'maior que',
            '∑': 'soma',
            '¤': 'moeda'
        },

        'ro': {
            '∆': 'delta',
            '∞': 'infinit',
            '♥': 'dragoste',
            '&': 'si',
            '|': 'sau',
            '<': 'mai mic ca',
            '>': 'mai mare ca',
            '∑': 'suma',
            '¤': 'valuta'
        },

        'ru': {
            '∆': 'delta',
            '∞': 'beskonechno',
            '♥': 'lubov',
            '&': 'i',
            '|': 'ili',
            '<': 'menshe',
            '>': 'bolshe',
            '∑': 'summa',
            '¤': 'valjuta'
        },

        'sk': {
            '∆': 'delta',
            '∞': 'nekonecno',
            '♥': 'laska',
            '&': 'a',
            '|': 'alebo',
            '<': 'menej ako',
            '>': 'viac ako',
            '∑': 'sucet',
            '¤': 'mena'
        },

        'sr': {},

        'tr': {
            '∆': 'delta',
            '∞': 'sonsuzluk',
            '♥': 'ask',
            '&': 've',
            '|': 'veya',
            '<': 'kucuktur',
            '>': 'buyuktur',
            '∑': 'toplam',
            '¤': 'para birimi'
        },

        'uk': {
            '∆': 'delta',
            '∞': 'bezkinechnist',
            '♥': 'lubov',
            '&': 'i',
            '|': 'abo',
            '<': 'menshe',
            '>': 'bilshe',
            '∑': 'suma',
            '¤': 'valjuta'
        },

        'vn': {
            '∆': 'delta',
            '∞': 'vo cuc',
            '♥': 'yeu',
            '&': 'va',
            '|': 'hoac',
            '<': 'nho hon',
            '>': 'lon hon',
            '∑': 'tong',
            '¤': 'tien te'
        }
    };

    var uricChars = [';', '?', ':', '@', '&', '=', '+', '$', ',', '/'].join('');

    var uricNoSlashChars = [';', '?', ':', '@', '&', '=', '+', '$', ','].join('');

    var markChars = ['.', '!', '~', '*', "'", '(', ')'].join('');

    /**
     * getSlug
     * @param  {string} input input string
     * @param  {object|string} opts config object or separator string/char
     * @api    public
     * @return {string}  sluggified string
     */
    var getSlug = function getSlug(input, opts) {
        var separator = '-';
        var result = '';
        var diatricString = '';
        var convertSymbols = true;
        var customReplacements = {};
        var maintainCase;
        var titleCase;
        var truncate;
        var uricFlag;
        var uricNoSlashFlag;
        var markFlag;
        var symbol;
        var langChar;
        var lucky;
        var i;
        var ch;
        var l;
        var lastCharWasSymbol;
        var lastCharWasDiatric;
        var allowedChars = '';

        if (typeof input !== 'string') {
            return '';
        }

        if (typeof opts === 'string') {
            separator = opts;
        }

        symbol = symbolMap.en;
        langChar = langCharMap.en;

        if (typeof opts === 'object') {
            maintainCase = opts.maintainCase || false;
            customReplacements = (opts.custom && typeof opts.custom === 'object') ? opts.custom : customReplacements;
            truncate = (+opts.truncate > 1 && opts.truncate) || false;
            uricFlag = opts.uric || false;
            uricNoSlashFlag = opts.uricNoSlash || false;
            markFlag = opts.mark || false;
            convertSymbols = (opts.symbols === false || opts.lang === false) ? false : true;
            separator = opts.separator || separator;

            if (uricFlag) {
                allowedChars += uricChars;
            }

            if (uricNoSlashFlag) {
                allowedChars += uricNoSlashChars;
            }

            if (markFlag) {
                allowedChars += markChars;
            }

            symbol = (opts.lang && symbolMap[opts.lang] && convertSymbols) ?
                symbolMap[opts.lang] : (convertSymbols ? symbolMap.en : {});

            langChar = (opts.lang && langCharMap[opts.lang]) ?
                langCharMap[opts.lang] :
                opts.lang === false || opts.lang === true ? {} : langCharMap.en;

            // if titleCase config is an Array, rewrite to object format
            if (opts.titleCase && typeof opts.titleCase.length === 'number' && Array.prototype.toString.call(opts.titleCase)) {
                opts.titleCase.forEach(function (v) {
                    customReplacements[v + ''] = v + '';
                });

                titleCase = true;
            } else {
                titleCase = !!opts.titleCase;
            }

            // if custom config is an Array, rewrite to object format
            if (opts.custom && typeof opts.custom.length === 'number' && Array.prototype.toString.call(opts.custom)) {
                opts.custom.forEach(function (v) {
                    customReplacements[v + ''] = v + '';
                });
            }

            // custom replacements
            Object.keys(customReplacements).forEach(function (v) {
                var r;

                if (v.length > 1) {
                    r = new RegExp('\\b' + escapeChars(v) + '\\b', 'gi');
                } else {
                    r = new RegExp(escapeChars(v), 'gi');
                }

                input = input.replace(r, customReplacements[v]);
            });

            // add all custom replacement to allowed charlist
            for (ch in customReplacements) {
                allowedChars += ch;
            }
        }

        allowedChars += separator;

        // escape all necessary chars
        allowedChars = escapeChars(allowedChars);

        // trim whitespaces
        input = input.replace(/(^\s+|\s+$)/g, '');

        lastCharWasSymbol = false;
        lastCharWasDiatric = false;

        for (i = 0, l = input.length; i < l; i++) {
            ch = input[i];

            if (isReplacedCustomChar(ch, customReplacements)) {
                // don't convert a already converted char
                lastCharWasSymbol = false;
            } else if (langChar[ch]) {
                // process language specific diactrics chars conversion
                ch = lastCharWasSymbol && langChar[ch].match(/[A-Za-z0-9]/) ? ' ' + langChar[ch] : langChar[ch];

                lastCharWasSymbol = false;
            } else if (ch in charMap) {
                // the transliteration changes entirely when some special characters are added
                if (i + 1 < l && lookAheadCharArray.indexOf(input[i + 1]) >= 0) {
                    diatricString += ch;
                    ch = '';
                } else if (lastCharWasDiatric === true) {
                    ch = diatricMap[diatricString] + charMap[ch];
                    diatricString = '';
                } else {
                    // process diactrics chars
                    ch = lastCharWasSymbol && charMap[ch].match(/[A-Za-z0-9]/) ? ' ' + charMap[ch] : charMap[ch];
                }

                lastCharWasSymbol = false;
                lastCharWasDiatric = false;
            } else if (ch in diatricMap) {
                diatricString += ch;
                ch = '';
                // end of string, put the whole meaningful word
                if (i === l - 1) {
                    ch = diatricMap[diatricString];
                }
                lastCharWasDiatric = true;
            } else if (
                // process symbol chars
                symbol[ch] && !(uricFlag && uricChars
                    .indexOf(ch) !== -1) && !(uricNoSlashFlag && uricNoSlashChars
                    // .indexOf(ch) !== -1) && !(markFlag && markChars
                    .indexOf(ch) !== -1)) {
                ch = lastCharWasSymbol || result.substr(-1).match(/[A-Za-z0-9]/) ? separator + symbol[ch] : symbol[ch];
                ch += input[i + 1] !== void 0 && input[i + 1].match(/[A-Za-z0-9]/) ? separator : '';

                lastCharWasSymbol = true;
            } else {
                if (lastCharWasDiatric === true) {
                    ch = diatricMap[diatricString] + ch;
                    diatricString = '';
                    lastCharWasDiatric = false;
                } else if (lastCharWasSymbol && (/[A-Za-z0-9]/.test(ch) || result.substr(-1).match(/A-Za-z0-9]/))) {
                    // process latin chars
                    ch = ' ' + ch;
                }
                lastCharWasSymbol = false;
            }

            // add allowed chars
            result += ch.replace(new RegExp('[^\\w\\s' + allowedChars + '_-]', 'g'), separator);
        }

        if (titleCase) {
            result = result.replace(/(\w)(\S*)/g, function (_, i, r) {
                var j = i.toUpperCase() + (r !== null ? r : '');
                return (Object.keys(customReplacements).indexOf(j.toLowerCase()) < 0) ? j : j.toLowerCase();
            });
        }

        // eliminate duplicate separators
        // add separator
        // trim separators from start and end
        result = result.replace(/\s+/g, separator)
            .replace(new RegExp('\\' + separator + '+', 'g'), separator)
            .replace(new RegExp('(^\\' + separator + '+|\\' + separator + '+$)', 'g'), '');

        if (truncate && result.length > truncate) {
            lucky = result.charAt(truncate) === separator;
            result = result.slice(0, truncate);

            if (!lucky) {
                result = result.slice(0, result.lastIndexOf(separator));
            }
        }

        if (!maintainCase && !titleCase) {
            result = result.toLowerCase();
        }

        return result;
    };

    /**
     * createSlug curried(opts)(input)
     * @param   {object|string} opts config object or input string
     * @return  {Function} function getSlugWithConfig()
     **/
    var createSlug = function createSlug(opts) {

        /**
         * getSlugWithConfig
         * @param   {string} input string
         * @return  {string} slug string
         */
        return function getSlugWithConfig(input) {
            return getSlug(input, opts);
        };
    };

    /**
     * escape Chars
     * @param   {string} input string
     */
    var escapeChars = function escapeChars(input) {
        return input.replace(/[-\\^$*+?.()|[\]{}\/]/g, '\\$&');
    };

    /**
     * check if the char is an already converted char from custom list
     * @param   {char} ch character to check
     * @param   {object} customReplacements custom translation map
     */
    var isReplacedCustomChar = function (ch, customReplacements) {
        for (var c in customReplacements) {
            if (customReplacements[c] === ch) {
                return true;
            }
        }
    };

    if (typeof module !== 'undefined' && module.exports) {

        // export functions for use in Node
        module.exports = getSlug;
        module.exports.createSlug = createSlug;
    } else if (true) {

        // export function for use in AMD
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
            return getSlug;
        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {

        // don't overwrite global if exists
        try {
            if (root.getSlug || root.createSlug) {
                throw 'speakingurl: globals exists /(getSlug|createSlug)/';
            } else {
                root.getSlug = getSlug;
                root.createSlug = createSlug;
            }
        } catch (e) {}
    }
})(this);

/***/ }),

/***/ "../node_modules/stickyfill/index.js":
/***/ (function(module, exports) {

/*!
 * Stickyfill -- `position: sticky` polyfill
 * v. 1.1.1 | https://github.com/wilddeer/stickyfill
 * Copyright Oleg Korsunsky | http://wd.dizaina.net/
 *
 * MIT License
 */

module.exports = (function(doc, win) {
    if (!doc) {
        doc = document;
    }

    if (!win) {
        win = window;
    }
    
    var watchArray = [],
        scroll,
        initialized = false,
        html = doc.documentElement,
        noop = function() {},
        checkTimer,

        //visibility API strings
        hiddenPropertyName = 'hidden',
        visibilityChangeEventName = 'visibilitychange';

    //fallback to prefixed names in old webkit browsers
    if (doc.webkitHidden !== undefined) {
        hiddenPropertyName = 'webkitHidden';
        visibilityChangeEventName = 'webkitvisibilitychange';
    }

    //test getComputedStyle
    if (!win.getComputedStyle) {
        seppuku();
    }

    //test for native support
    var prefixes = ['', '-webkit-', '-moz-', '-ms-'],
        block = document.createElement('div');

    for (var i = prefixes.length - 1; i >= 0; i--) {
        try {
            block.style.position = prefixes[i] + 'sticky';
        }
        catch(e) {}
        if (block.style.position != '') {
            seppuku();
        }
    }

    updateScrollPos();

    //commit seppuku!
    function seppuku() {
        init = add = rebuild = pause = stop = kill = noop;
    }

    function mergeObjects(targetObj, sourceObject) {
        for (key in sourceObject) {
            if (sourceObject.hasOwnProperty(key)) {
                targetObj[key] = sourceObject[key];
            }
        }
    }

    function parseNumeric(val) {
        return parseFloat(val) || 0;
    }

    function updateScrollPos() {
        scroll = {
            top: win.pageYOffset,
            left: win.pageXOffset
        };
    }

    function onScroll() {
        if (win.pageXOffset != scroll.left) {
            updateScrollPos();
            rebuild();
            return;
        }
        
        if (win.pageYOffset != scroll.top) {
            updateScrollPos();
            recalcAllPos();
        }
    }

    //fixes flickering
    function onWheel(event) {
        setTimeout(function() {
            if (win.pageYOffset != scroll.top) {
                scroll.top = win.pageYOffset;
                recalcAllPos();
            }
        }, 0);
    }

    function recalcAllPos() {
        for (var i = watchArray.length - 1; i >= 0; i--) {
            recalcElementPos(watchArray[i]);
        }
    }

    function recalcElementPos(el) {
        if (!el.inited) return;

        var currentMode = (scroll.top <= el.limit.start? 0: scroll.top >= el.limit.end? 2: 1);

        if (el.mode != currentMode) {
            switchElementMode(el, currentMode);
        }
    }

    //checks whether stickies start or stop positions have changed
    function fastCheck() {
        for (var i = watchArray.length - 1; i >= 0; i--) {
            if (!watchArray[i].inited) continue;

            var deltaTop = Math.abs(getDocOffsetTop(watchArray[i].clone) - watchArray[i].docOffsetTop),
                deltaHeight = Math.abs(watchArray[i].parent.node.offsetHeight - watchArray[i].parent.height);

            if (deltaTop >= 2 || deltaHeight >= 2) return false;
        }
        return true;
    }

    function initElement(el) {
        if (isNaN(parseFloat(el.computed.top)) || el.isCell) return;

        el.inited = true;

        if (!el.clone) clone(el);
        if (el.parent.computed.position != 'absolute' &&
            el.parent.computed.position != 'relative') el.parent.node.style.position = 'relative';

        recalcElementPos(el);

        el.parent.height = el.parent.node.offsetHeight;
        el.docOffsetTop = getDocOffsetTop(el.clone);
    }

    function deinitElement(el) {
        var deinitParent = true;

        el.clone && killClone(el);
        mergeObjects(el.node.style, el.css);

        //check whether element's parent is used by other stickies
        for (var i = watchArray.length - 1; i >= 0; i--) {
            if (watchArray[i].node !== el.node && watchArray[i].parent.node === el.parent.node) {
                deinitParent = false;
                break;
            }
        };

        if (deinitParent) el.parent.node.style.position = el.parent.css.position;
        el.mode = -1;
    }

    function initAll() {
        for (var i = watchArray.length - 1; i >= 0; i--) {
            initElement(watchArray[i]);
        }
    }

    function deinitAll() {
        for (var i = watchArray.length - 1; i >= 0; i--) {
            deinitElement(watchArray[i]);
        }
    }

    function switchElementMode(el, mode) {
        var nodeStyle = el.node.style;

        switch (mode) {
            case 0:
                nodeStyle.position = 'absolute';
                nodeStyle.left = el.offset.left + 'px';
                nodeStyle.right = el.offset.right + 'px';
                nodeStyle.top = el.offset.top + 'px';
                nodeStyle.bottom = 'auto';
                nodeStyle.width = 'auto';
                nodeStyle.marginLeft = 0;
                nodeStyle.marginRight = 0;
                nodeStyle.marginTop = 0;
                break;

            case 1:
                nodeStyle.position = 'fixed';
                nodeStyle.left = el.box.left + 'px';
                nodeStyle.right = el.box.right + 'px';
                nodeStyle.top = el.css.top;
                nodeStyle.bottom = 'auto';
                nodeStyle.width = 'auto';
                nodeStyle.marginLeft = 0;
                nodeStyle.marginRight = 0;
                nodeStyle.marginTop = 0;
                break;

            case 2:
                nodeStyle.position = 'absolute';
                nodeStyle.left = el.offset.left + 'px';
                nodeStyle.right = el.offset.right + 'px';
                nodeStyle.top = 'auto';
                nodeStyle.bottom = 0;
                nodeStyle.width = 'auto';
                nodeStyle.marginLeft = 0;
                nodeStyle.marginRight = 0;
                break;
        }

        el.mode = mode;
    }

    function clone(el) {
        el.clone = document.createElement('div');

        var refElement = el.node.nextSibling || el.node,
            cloneStyle = el.clone.style;

        cloneStyle.height = el.height + 'px';
        cloneStyle.width = el.width + 'px';
        cloneStyle.marginTop = el.computed.marginTop;
        cloneStyle.marginBottom = el.computed.marginBottom;
        cloneStyle.marginLeft = el.computed.marginLeft;
        cloneStyle.marginRight = el.computed.marginRight;
        cloneStyle.padding = cloneStyle.border = cloneStyle.borderSpacing = 0;
        cloneStyle.fontSize = '1em';
        cloneStyle.position = 'static';
        cloneStyle.cssFloat = el.computed.cssFloat;

        el.node.parentNode.insertBefore(el.clone, refElement);
    }

    function killClone(el) {
        el.clone.parentNode.removeChild(el.clone);
        el.clone = undefined;
    }

    function getElementParams(node) {
        var computedStyle = getComputedStyle(node),
            parentNode = node.parentNode,
            parentComputedStyle = getComputedStyle(parentNode),
            cachedPosition = node.style.position;

        node.style.position = 'relative';

        var computed = {
                top: computedStyle.top,
                marginTop: computedStyle.marginTop,
                marginBottom: computedStyle.marginBottom,
                marginLeft: computedStyle.marginLeft,
                marginRight: computedStyle.marginRight,
                cssFloat: computedStyle.cssFloat
            },
            numeric = {
                top: parseNumeric(computedStyle.top),
                marginBottom: parseNumeric(computedStyle.marginBottom),
                paddingLeft: parseNumeric(computedStyle.paddingLeft),
                paddingRight: parseNumeric(computedStyle.paddingRight),
                borderLeftWidth: parseNumeric(computedStyle.borderLeftWidth),
                borderRightWidth: parseNumeric(computedStyle.borderRightWidth)
            };

        node.style.position = cachedPosition;

        var css = {
                position: node.style.position,
                top: node.style.top,
                bottom: node.style.bottom,
                left: node.style.left,
                right: node.style.right,
                width: node.style.width,
                marginTop: node.style.marginTop,
                marginLeft: node.style.marginLeft,
                marginRight: node.style.marginRight
            },
            nodeOffset = getElementOffset(node),
            parentOffset = getElementOffset(parentNode),
            
            parent = {
                node: parentNode,
                css: {
                    position: parentNode.style.position
                },
                computed: {
                    position: parentComputedStyle.position
                },
                numeric: {
                    borderLeftWidth: parseNumeric(parentComputedStyle.borderLeftWidth),
                    borderRightWidth: parseNumeric(parentComputedStyle.borderRightWidth),
                    borderTopWidth: parseNumeric(parentComputedStyle.borderTopWidth),
                    borderBottomWidth: parseNumeric(parentComputedStyle.borderBottomWidth)
                }
            },

            el = {
                node: node,
                box: {
                    left: nodeOffset.win.left,
                    right: html.clientWidth - nodeOffset.win.right
                },
                offset: {
                    top: nodeOffset.win.top - parentOffset.win.top - parent.numeric.borderTopWidth,
                    left: nodeOffset.win.left - parentOffset.win.left - parent.numeric.borderLeftWidth,
                    right: -nodeOffset.win.right + parentOffset.win.right - parent.numeric.borderRightWidth
                },
                css: css,
                isCell: computedStyle.display == 'table-cell',
                computed: computed,
                numeric: numeric,
                width: nodeOffset.win.right - nodeOffset.win.left,
                height: nodeOffset.win.bottom - nodeOffset.win.top,
                mode: -1,
                inited: false,
                parent: parent,
                limit: {
                    start: nodeOffset.doc.top - numeric.top,
                    end: parentOffset.doc.top + parentNode.offsetHeight - parent.numeric.borderBottomWidth -
                        node.offsetHeight - numeric.top - numeric.marginBottom
                }
            };

        return el;
    }

    function getDocOffsetTop(node) {
        var docOffsetTop = 0;

        while (node) {
            docOffsetTop += node.offsetTop;
            node = node.offsetParent;
        }

        return docOffsetTop;
    }

    function getElementOffset(node) {
        var box = node.getBoundingClientRect();

            return {
                doc: {
                    top: box.top + win.pageYOffset,
                    left: box.left + win.pageXOffset
                },
                win: box
            };
    }

    function startFastCheckTimer() {
        checkTimer = setInterval(function() {
            !fastCheck() && rebuild();
        }, 500);
    }

    function stopFastCheckTimer() {
        clearInterval(checkTimer);
    }

    function handlePageVisibilityChange() {
        if (!initialized) return;

        if (document[hiddenPropertyName]) {
            stopFastCheckTimer();
        }
        else {
            startFastCheckTimer();
        }
    }

    function init() {
        if (initialized) return;

        updateScrollPos();
        initAll();

        win.addEventListener('scroll', onScroll);
        win.addEventListener('wheel', onWheel);

        //watch for width changes
        win.addEventListener('resize', rebuild);
        win.addEventListener('orientationchange', rebuild);

        //watch for page visibility
        doc.addEventListener(visibilityChangeEventName, handlePageVisibilityChange);

        startFastCheckTimer();

        initialized = true;
    }

    function rebuild() {
        if (!initialized) return;

        deinitAll();
        
        for (var i = watchArray.length - 1; i >= 0; i--) {
            watchArray[i] = getElementParams(watchArray[i].node);
        }
        
        initAll();
    }

    function pause() {
        win.removeEventListener('scroll', onScroll);
        win.removeEventListener('wheel', onWheel);
        win.removeEventListener('resize', rebuild);
        win.removeEventListener('orientationchange', rebuild);
        doc.removeEventListener(visibilityChangeEventName, handlePageVisibilityChange);

        stopFastCheckTimer();

        initialized = false;
    }

    function stop() {
        pause();
        deinitAll(); 
    }

    function kill() {
        stop();

        //empty the array without loosing the references,
        //the most performant method according to http://jsperf.com/empty-javascript-array
        while (watchArray.length) {
            watchArray.pop();
        }
    }

    function add(node) {
        //check if Stickyfill is already applied to the node
        for (var i = watchArray.length - 1; i >= 0; i--) {
            if (watchArray[i].node === node) return;
        };

        var el = getElementParams(node);

        watchArray.push(el);

        if (!initialized) {
            init();
        }
        else {
            initElement(el);
        }
    }

    function remove(node) {
        for (var i = watchArray.length - 1; i >= 0; i--) {
            if (watchArray[i].node === node) {
                deinitElement(watchArray[i]);
                watchArray.splice(i, 1);
            }
        };
    }

    //expose Stickyfill
    return {
        stickies: watchArray,
        add: add,
        remove: remove,
        init: init,
        rebuild: rebuild,
        pause: pause,
        stop: stop,
        kill: kill
    };
})

/***/ }),

/***/ "../node_modules/stream-browserify/index.js":
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Stream;

var EE = __webpack_require__("../node_modules/events/events.js").EventEmitter;
var inherits = __webpack_require__("../node_modules/inherits/inherits_browser.js");

inherits(Stream, EE);
Stream.Readable = __webpack_require__("../node_modules/readable-stream/readable-browser.js");
Stream.Writable = __webpack_require__("../node_modules/readable-stream/writable-browser.js");
Stream.Duplex = __webpack_require__("../node_modules/readable-stream/duplex-browser.js");
Stream.Transform = __webpack_require__("../node_modules/readable-stream/transform.js");
Stream.PassThrough = __webpack_require__("../node_modules/readable-stream/passthrough.js");

// Backwards-compat with node 0.4.x
Stream.Stream = Stream;



// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.

function Stream() {
  EE.call(this);
}

Stream.prototype.pipe = function(dest, options) {
  var source = this;

  function ondata(chunk) {
    if (dest.writable) {
      if (false === dest.write(chunk) && source.pause) {
        source.pause();
      }
    }
  }

  source.on('data', ondata);

  function ondrain() {
    if (source.readable && source.resume) {
      source.resume();
    }
  }

  dest.on('drain', ondrain);

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend);
    source.on('close', onclose);
  }

  var didOnEnd = false;
  function onend() {
    if (didOnEnd) return;
    didOnEnd = true;

    dest.end();
  }


  function onclose() {
    if (didOnEnd) return;
    didOnEnd = true;

    if (typeof dest.destroy === 'function') dest.destroy();
  }

  // don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup();
    if (EE.listenerCount(this, 'error') === 0) {
      throw er; // Unhandled stream error in pipe.
    }
  }

  source.on('error', onerror);
  dest.on('error', onerror);

  // remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata);
    dest.removeListener('drain', ondrain);

    source.removeListener('end', onend);
    source.removeListener('close', onclose);

    source.removeListener('error', onerror);
    dest.removeListener('error', onerror);

    source.removeListener('end', cleanup);
    source.removeListener('close', cleanup);

    dest.removeListener('close', cleanup);
  }

  source.on('end', cleanup);
  source.on('close', cleanup);

  dest.on('close', cleanup);

  dest.emit('pipe', source);

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest;
};


/***/ }),

/***/ "../node_modules/strict-uri-encode/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),

/***/ "../node_modules/string_decoder/index.js":
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var Buffer = __webpack_require__("../node_modules/buffer/index.js").Buffer;

var isBufferEncoding = Buffer.isEncoding
  || function(encoding) {
       switch (encoding && encoding.toLowerCase()) {
         case 'hex': case 'utf8': case 'utf-8': case 'ascii': case 'binary': case 'base64': case 'ucs2': case 'ucs-2': case 'utf16le': case 'utf-16le': case 'raw': return true;
         default: return false;
       }
     }


function assertEncoding(encoding) {
  if (encoding && !isBufferEncoding(encoding)) {
    throw new Error('Unknown encoding: ' + encoding);
  }
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters. CESU-8 is handled as part of the UTF-8 encoding.
//
// @TODO Handling all encodings inside a single object makes it very difficult
// to reason about this code, so it should be split up in the future.
// @TODO There should be a utf8-strict encoding that rejects invalid UTF-8 code
// points as used by CESU-8.
var StringDecoder = exports.StringDecoder = function(encoding) {
  this.encoding = (encoding || 'utf8').toLowerCase().replace(/[-_]/, '');
  assertEncoding(encoding);
  switch (this.encoding) {
    case 'utf8':
      // CESU-8 represents each of Surrogate Pair by 3-bytes
      this.surrogateSize = 3;
      break;
    case 'ucs2':
    case 'utf16le':
      // UTF-16 represents each of Surrogate Pair by 2-bytes
      this.surrogateSize = 2;
      this.detectIncompleteChar = utf16DetectIncompleteChar;
      break;
    case 'base64':
      // Base-64 stores 3 bytes in 4 chars, and pads the remainder.
      this.surrogateSize = 3;
      this.detectIncompleteChar = base64DetectIncompleteChar;
      break;
    default:
      this.write = passThroughWrite;
      return;
  }

  // Enough space to store all bytes of a single character. UTF-8 needs 4
  // bytes, but CESU-8 may require up to 6 (3 bytes per surrogate).
  this.charBuffer = new Buffer(6);
  // Number of bytes received for the current incomplete multi-byte character.
  this.charReceived = 0;
  // Number of bytes expected for the current incomplete multi-byte character.
  this.charLength = 0;
};


// write decodes the given buffer and returns it as JS string that is
// guaranteed to not contain any partial multi-byte characters. Any partial
// character found at the end of the buffer is buffered up, and will be
// returned when calling write again with the remaining bytes.
//
// Note: Converting a Buffer containing an orphan surrogate to a String
// currently works, but converting a String to a Buffer (via `new Buffer`, or
// Buffer#write) will replace incomplete surrogates with the unicode
// replacement character. See https://codereview.chromium.org/121173009/ .
StringDecoder.prototype.write = function(buffer) {
  var charStr = '';
  // if our last write ended with an incomplete multibyte character
  while (this.charLength) {
    // determine how many remaining bytes this buffer has to offer for this char
    var available = (buffer.length >= this.charLength - this.charReceived) ?
        this.charLength - this.charReceived :
        buffer.length;

    // add the new bytes to the char buffer
    buffer.copy(this.charBuffer, this.charReceived, 0, available);
    this.charReceived += available;

    if (this.charReceived < this.charLength) {
      // still not enough chars in this buffer? wait for more ...
      return '';
    }

    // remove bytes belonging to the current character from the buffer
    buffer = buffer.slice(available, buffer.length);

    // get the character that was split
    charStr = this.charBuffer.slice(0, this.charLength).toString(this.encoding);

    // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
    var charCode = charStr.charCodeAt(charStr.length - 1);
    if (charCode >= 0xD800 && charCode <= 0xDBFF) {
      this.charLength += this.surrogateSize;
      charStr = '';
      continue;
    }
    this.charReceived = this.charLength = 0;

    // if there are no more bytes in this buffer, just emit our char
    if (buffer.length === 0) {
      return charStr;
    }
    break;
  }

  // determine and set charLength / charReceived
  this.detectIncompleteChar(buffer);

  var end = buffer.length;
  if (this.charLength) {
    // buffer the incomplete character bytes we got
    buffer.copy(this.charBuffer, 0, buffer.length - this.charReceived, end);
    end -= this.charReceived;
  }

  charStr += buffer.toString(this.encoding, 0, end);

  var end = charStr.length - 1;
  var charCode = charStr.charCodeAt(end);
  // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
  if (charCode >= 0xD800 && charCode <= 0xDBFF) {
    var size = this.surrogateSize;
    this.charLength += size;
    this.charReceived += size;
    this.charBuffer.copy(this.charBuffer, size, 0, size);
    buffer.copy(this.charBuffer, 0, 0, size);
    return charStr.substring(0, end);
  }

  // or just emit the charStr
  return charStr;
};

// detectIncompleteChar determines if there is an incomplete UTF-8 character at
// the end of the given buffer. If so, it sets this.charLength to the byte
// length that character, and sets this.charReceived to the number of bytes
// that are available for this character.
StringDecoder.prototype.detectIncompleteChar = function(buffer) {
  // determine how many bytes we have to check at the end of this buffer
  var i = (buffer.length >= 3) ? 3 : buffer.length;

  // Figure out if one of the last i bytes of our buffer announces an
  // incomplete char.
  for (; i > 0; i--) {
    var c = buffer[buffer.length - i];

    // See http://en.wikipedia.org/wiki/UTF-8#Description

    // 110XXXXX
    if (i == 1 && c >> 5 == 0x06) {
      this.charLength = 2;
      break;
    }

    // 1110XXXX
    if (i <= 2 && c >> 4 == 0x0E) {
      this.charLength = 3;
      break;
    }

    // 11110XXX
    if (i <= 3 && c >> 3 == 0x1E) {
      this.charLength = 4;
      break;
    }
  }
  this.charReceived = i;
};

StringDecoder.prototype.end = function(buffer) {
  var res = '';
  if (buffer && buffer.length)
    res = this.write(buffer);

  if (this.charReceived) {
    var cr = this.charReceived;
    var buf = this.charBuffer;
    var enc = this.encoding;
    res += buf.slice(0, cr).toString(enc);
  }

  return res;
};

function passThroughWrite(buffer) {
  return buffer.toString(this.encoding);
}

function utf16DetectIncompleteChar(buffer) {
  this.charReceived = buffer.length % 2;
  this.charLength = this.charReceived ? 2 : 0;
}

function base64DetectIncompleteChar(buffer) {
  this.charReceived = buffer.length % 3;
  this.charLength = this.charReceived ? 3 : 0;
}


/***/ }),

/***/ "../node_modules/styled-components-modifiers/dist/applyResponsiveStyleModifiers.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = applyResponsiveStyleModifiers;

var _modifiedStyles = __webpack_require__("../node_modules/styled-components-modifiers/dist/utils/modifiedStyles.js");

var _modifiedStyles2 = _interopRequireDefault(_modifiedStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Returns a function that evaluates a modifierConfig object against a component's props,
 * including a size prop. This function will return a string of CSS styles based on those inputs.
 * @param {Object} modifierConfig A modifierConfig object that defines the styles
 * @param {string} [modifierPropName=responsiveModifiers] The name of the prop that contains
 *                                                        the modifiers array
 */
function applyResponsiveStyleModifiers(modifierConfig) {
  var modifierPropName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'responsiveModifiers';

  return function (props) {
    var responsiveModifiers = props[modifierPropName],
        otherProps = _objectWithoutProperties(props, [modifierPropName]);

    var activeModifiers = responsiveModifiers && responsiveModifiers[props.size];
    return (0, _modifiedStyles2.default)(activeModifiers, modifierConfig, otherProps);
  };
}

/***/ }),

/***/ "../node_modules/styled-components-modifiers/dist/applyStyleModifiers.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = applyStyleModifiers;

var _modifiedStyles = __webpack_require__("../node_modules/styled-components-modifiers/dist/utils/modifiedStyles.js");

var _modifiedStyles2 = _interopRequireDefault(_modifiedStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Returns a function that evaluates a modifierConfig object against a component's props.
 * This function will return a string of CSS styles based on those inputs.
 * @param {Object} modifierConfig A modifierConfig object that defines the styles
 * @param {string} [modifierPropName=modifiers] The name of the prop that contains
 *                                              the modifiers array
 */
function applyStyleModifiers(modifierConfig) {
  var modifierPropName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'modifiers';

  return function (props) {
    var modifiers = props[modifierPropName],
        otherProps = _objectWithoutProperties(props, [modifierPropName]);

    return (0, _modifiedStyles2.default)(modifiers, modifierConfig, otherProps);
  };
}

/***/ }),

/***/ "../node_modules/styled-components-modifiers/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.responsiveStyleModifierPropTypes = exports.styleModifierPropTypes = exports.applyStyleModifiers = exports.applyResponsiveStyleModifiers = undefined;

var _applyResponsiveStyleModifiers = __webpack_require__("../node_modules/styled-components-modifiers/dist/applyResponsiveStyleModifiers.js");

var _applyResponsiveStyleModifiers2 = _interopRequireDefault(_applyResponsiveStyleModifiers);

var _applyStyleModifiers = __webpack_require__("../node_modules/styled-components-modifiers/dist/applyStyleModifiers.js");

var _applyStyleModifiers2 = _interopRequireDefault(_applyStyleModifiers);

var _styleModifierPropTypes = __webpack_require__("../node_modules/styled-components-modifiers/dist/styleModifierPropTypes.js");

var _styleModifierPropTypes2 = _interopRequireDefault(_styleModifierPropTypes);

var _responsiveStyleModifierPropTypes = __webpack_require__("../node_modules/styled-components-modifiers/dist/responsiveStyleModifierPropTypes.js");

var _responsiveStyleModifierPropTypes2 = _interopRequireDefault(_responsiveStyleModifierPropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.applyResponsiveStyleModifiers = _applyResponsiveStyleModifiers2.default;
exports.applyStyleModifiers = _applyStyleModifiers2.default;
exports.styleModifierPropTypes = _styleModifierPropTypes2.default;
exports.responsiveStyleModifierPropTypes = _responsiveStyleModifierPropTypes2.default;

/***/ }),

/***/ "../node_modules/styled-components-modifiers/dist/responsiveStyleModifierPropTypes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = responsiveStyleModifierPropTypes;

var _lodash = __webpack_require__("../node_modules/lodash.difference/index.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = __webpack_require__("../node_modules/lodash.flatten/index.js");

var _lodash4 = _interopRequireDefault(_lodash3);

var _lodash5 = __webpack_require__("../node_modules/lodash.forin/index.js");

var _lodash6 = _interopRequireDefault(_lodash5);

var _lodash7 = __webpack_require__("../node_modules/lodash.iserror/index.js");

var _lodash8 = _interopRequireDefault(_lodash7);

var _lodash9 = __webpack_require__("../node_modules/lodash.keys/index.js");

var _lodash10 = _interopRequireDefault(_lodash9);

var _lodash11 = __webpack_require__("../node_modules/lodash.uniq/index.js");

var _lodash12 = _interopRequireDefault(_lodash11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function validateModifiers(propName, componentName, responsiveModifiers, modifierConfig) {
  var rawMissingModifiers = [];
  var rawSizesWithErrors = [];

  var modifierNames = (0, _lodash10.default)(modifierConfig);
  (0, _lodash6.default)(responsiveModifiers, function (v, k) {
    var noMatches = (0, _lodash2.default)(v, modifierNames);
    if (noMatches.length > 0) {
      rawMissingModifiers.push(noMatches);
      rawSizesWithErrors.push(k);
    }
  });

  var missingModifiers = (0, _lodash12.default)((0, _lodash4.default)(rawMissingModifiers));
  var sizesWithErrors = (0, _lodash12.default)(rawSizesWithErrors);

  if (missingModifiers.length > 0) {
    var m = missingModifiers.length > 1 ? 'modifiers' : 'modifier';
    var modifierList = missingModifiers.join(', ');
    var k = sizesWithErrors.length > 1 ? 'keys' : 'key';
    var sizes = sizesWithErrors.join(', ');
    return new Error('Invalid ' + m + ' ' + modifierList + ' used in prop \'' + propName + '\' (size ' + k + ' ' + sizes + ') and supplied to ' + componentName + '. Validation failed.');
  }

  return null;
}

/**
 * Evaluates the responsive modifiers prop against the size keys found in the reactive-container
 * package and the modifier config. Throws invalid proptype error if an incorrect size key is used
 * or a modifier is supplied in prop and not found in modifier config object.
 * @param  {Object} modifierConfig a modifier config object
 * @return {null:Error}           Returns null or an error
 */
function responsiveStyleModifierPropTypes(modifierConfig) {
  return function (props, propName, componentName) {
    var responsiveModifiers = props[propName];

    var validModifiers = validateModifiers(propName, componentName, responsiveModifiers, modifierConfig);

    if ((0, _lodash8.default)(validModifiers)) {
      return validModifiers;
    }

    return null;
  };
}

/***/ }),

/***/ "../node_modules/styled-components-modifiers/dist/styleModifierPropTypes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = styleModifierPropTypes;

var _lodash = __webpack_require__("../node_modules/lodash.curry/index.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = __webpack_require__("../node_modules/lodash.keys/index.js");

var _lodash4 = _interopRequireDefault(_lodash3);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validateModifiers = (0, _lodash2.default)(function (modifierConfig, propValue, idx, componentName, location, propFullName) {
  var modifierName = propValue[idx];
  var modifierNames = (0, _lodash4.default)(modifierConfig);
  var match = modifierNames.includes(modifierName);
  if (!match) {
    return new Error('Invalid modifier ' + modifierName + ' used in prop ' + propFullName + ' and supplied to ' + componentName + '. Validation failed.');
  }
  return true;
});

/**
 * Evaluates the modifiers prop against the modifier config. Throw invalid proptype if a
 * modifier is supplied in prop and not found in modifier config.
 * @param  {Object} modifierConfig a modifier config object
 * @return {Boolean:Error}               Returns true or an error
 */
function styleModifierPropTypes(modifierConfig) {
  return _propTypes2.default.arrayOf(validateModifiers(modifierConfig));
}

/***/ }),

/***/ "../node_modules/styled-components-modifiers/dist/utils/modifiedStyles.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = modifiedStyles;

var _lodash = __webpack_require__("../node_modules/lodash.isfunction/index.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = __webpack_require__("../node_modules/lodash.isobject/index.js");

var _lodash4 = _interopRequireDefault(_lodash3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Extracts and builds the required style string based on the provided values.
 * @param {Array} modifierProps An array of strings that must match up with keys in modifierConfig
 * @param {Object} modifierConfig A modifierConfig object that defines the styles
 * @param {Object} componentProps The calling component's props, used when calling the
 *                                config definitions.
 */
function modifiedStyles() {
  var modifierProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var modifierConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var componentProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var stylesArr = modifierProps.reduce(function (acc, modifierName) {
    var modifierFunc = modifierConfig[modifierName];
    if ((0, _lodash2.default)(modifierFunc)) {
      var config = modifierFunc(componentProps);
      var styles = (0, _lodash4.default)(config) ? config.styles : config;
      return acc.concat(styles);
    }
    return acc;
  }, []);

  return stylesArr.join(' ');
}

/***/ }),

/***/ "../node_modules/styled-components-reactive-grid/dist/Column.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n      justify-content: center;\n      text-align: center;\n    '], ['\n      justify-content: center;\n      text-align: center;\n    ']),
    _templateObject2 = _taggedTemplateLiteral(['\n      flex-basis: 0;\n      flex-grow: 1;\n      max-width: 100%;\n      -ms-flex-positive: 1;\n    '], ['\n      flex-basis: 0;\n      flex-grow: 1;\n      max-width: 100%;\n      -ms-flex-positive: 1;\n    ']),
    _templateObject3 = _taggedTemplateLiteral(['\n      flex-basis: 8.33333333%;\n      max-width: 8.33333333%;\n      -ms-flex-preferred-size: 8.33333333%;\n    '], ['\n      flex-basis: 8.33333333%;\n      max-width: 8.33333333%;\n      -ms-flex-preferred-size: 8.33333333%;\n    ']),
    _templateObject4 = _taggedTemplateLiteral(['\n      flex-basis: 16.66666667%;\n      max-width: 16.66666667%;\n      -ms-flex-preferred-size: 16.66666667%;\n    '], ['\n      flex-basis: 16.66666667%;\n      max-width: 16.66666667%;\n      -ms-flex-preferred-size: 16.66666667%;\n    ']),
    _templateObject5 = _taggedTemplateLiteral(['\n      flex-basis: 25%;\n      max-width: 25%;\n      -ms-flex-preferred-size: 25%;\n    '], ['\n      flex-basis: 25%;\n      max-width: 25%;\n      -ms-flex-preferred-size: 25%;\n    ']),
    _templateObject6 = _taggedTemplateLiteral(['\n      flex-basis: 33.33333333%;\n      max-width: 33.33333333%;\n      -ms-flex-preferred-size: 33.33333333%;\n    '], ['\n      flex-basis: 33.33333333%;\n      max-width: 33.33333333%;\n      -ms-flex-preferred-size: 33.33333333%;\n    ']),
    _templateObject7 = _taggedTemplateLiteral(['\n      flex-basis: 41.66666667%;\n      max-width: 41.66666667%;\n      -ms-flex-preferred-size: 41.66666667%;\n    '], ['\n      flex-basis: 41.66666667%;\n      max-width: 41.66666667%;\n      -ms-flex-preferred-size: 41.66666667%;\n    ']),
    _templateObject8 = _taggedTemplateLiteral(['\n      flex-basis: 50%;\n      max-width: 50%;\n      -ms-flex-preferred-size: 50%;\n    '], ['\n      flex-basis: 50%;\n      max-width: 50%;\n      -ms-flex-preferred-size: 50%;\n    ']),
    _templateObject9 = _taggedTemplateLiteral(['\n      flex-basis: 58.33333333%;\n      max-width: 58.33333333%;\n      -ms-flex-preferred-size: 58.33333333%;\n    '], ['\n      flex-basis: 58.33333333%;\n      max-width: 58.33333333%;\n      -ms-flex-preferred-size: 58.33333333%;\n    ']),
    _templateObject10 = _taggedTemplateLiteral(['\n      flex-basis: 66.66666667%;\n      max-width: 66.66666667%;\n      -ms-flex-preferred-size: 66.66666667%;\n    '], ['\n      flex-basis: 66.66666667%;\n      max-width: 66.66666667%;\n      -ms-flex-preferred-size: 66.66666667%;\n    ']),
    _templateObject11 = _taggedTemplateLiteral(['\n      flex-basis: 75%;\n      max-width: 75%;\n      -ms-flex-preferred-size: 75%;\n    '], ['\n      flex-basis: 75%;\n      max-width: 75%;\n      -ms-flex-preferred-size: 75%;\n    ']),
    _templateObject12 = _taggedTemplateLiteral(['\n      flex-basis: 83.33333333%;\n      max-width: 83.33333333%;\n      -ms-flex-preferred-size: 83.33333333%;\n    '], ['\n      flex-basis: 83.33333333%;\n      max-width: 83.33333333%;\n      -ms-flex-preferred-size: 83.33333333%;\n    ']),
    _templateObject13 = _taggedTemplateLiteral(['\n      flex-basis: 91.66666667%;\n      max-width: 91.66666667%;\n      -ms-flex-preferred-size: 91.66666667%;\n    '], ['\n      flex-basis: 91.66666667%;\n      max-width: 91.66666667%;\n      -ms-flex-preferred-size: 91.66666667%;\n    ']),
    _templateObject14 = _taggedTemplateLiteral(['\n      flex-basis: 100%;\n      max-width: 100%;\n      -ms-flex-preferred-size: 100%;\n    '], ['\n      flex-basis: 100%;\n      max-width: 100%;\n      -ms-flex-preferred-size: 100%;\n    ']),
    _templateObject15 = _taggedTemplateLiteral(['\n      margin-left: 8.33333333%;\n    '], ['\n      margin-left: 8.33333333%;\n    ']),
    _templateObject16 = _taggedTemplateLiteral(['\n      margin-left: 16.66666667%;\n    '], ['\n      margin-left: 16.66666667%;\n    ']),
    _templateObject17 = _taggedTemplateLiteral(['\n      margin-left: 25%;\n    '], ['\n      margin-left: 25%;\n    ']),
    _templateObject18 = _taggedTemplateLiteral(['\n      margin-left: 33.33333333%;\n    '], ['\n      margin-left: 33.33333333%;\n    ']),
    _templateObject19 = _taggedTemplateLiteral(['\n      margin-left: 41.66666667%;\n    '], ['\n      margin-left: 41.66666667%;\n    ']),
    _templateObject20 = _taggedTemplateLiteral(['\n      margin-left: 50%;\n    '], ['\n      margin-left: 50%;\n    ']),
    _templateObject21 = _taggedTemplateLiteral(['\n      margin-left: 58.33333333%;\n    '], ['\n      margin-left: 58.33333333%;\n    ']),
    _templateObject22 = _taggedTemplateLiteral(['\n      margin-left: 66.66666667%;\n    '], ['\n      margin-left: 66.66666667%;\n    ']),
    _templateObject23 = _taggedTemplateLiteral(['\n      margin-left: 75%;\n    '], ['\n      margin-left: 75%;\n    ']),
    _templateObject24 = _taggedTemplateLiteral(['\n      margin-left: 83.33333333%;\n    '], ['\n      margin-left: 83.33333333%;\n    ']),
    _templateObject25 = _taggedTemplateLiteral(['\n      margin-left: 91.66666667%;\n    '], ['\n      margin-left: 91.66666667%;\n    ']),
    _templateObject26 = _taggedTemplateLiteral(['\n      justify-content: flex-end;\n      text-align: end;\n    '], ['\n      justify-content: flex-end;\n      text-align: end;\n    ']),
    _templateObject27 = _taggedTemplateLiteral(['\n      padding-left: 0;\n      padding-right: 0;\n    '], ['\n      padding-left: 0;\n      padding-right: 0;\n    ']),
    _templateObject28 = _taggedTemplateLiteral(['\n      flex-direction: column-reverse;\n    '], ['\n      flex-direction: column-reverse;\n    ']),
    _templateObject29 = _taggedTemplateLiteral(['\n      justify-content: flex-start;\n      text-align: start;\n    '], ['\n      justify-content: flex-start;\n      text-align: start;\n    ']),
    _templateObject30 = _taggedTemplateLiteral(['\n  ', '\n  box-sizing: border-box;\n  flex: 0 0 auto;\n  padding: ', ';\n  position: relative;\n  ', '\n  ', '\n'], ['\n  ', '\n  box-sizing: border-box;\n  flex: 0 0 auto;\n  padding: ', ';\n  position: relative;\n  ', '\n  ', '\n']);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactiveContainer = __webpack_require__("../node_modules/reactive-container/dist/index.js");

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledComponentsModifiers = __webpack_require__("../node_modules/styled-components-modifiers/dist/index.js");

var _styledComponentsThemeValidator = __webpack_require__("../node_modules/styled-components-theme-validator/dist/index.js");

var _modifiers = __webpack_require__("../node_modules/styled-components-reactive-grid/dist/utils/modifiers.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var COMPONENT_NAME = 'Column';

var MODIFIER_CONFIG = _extends({}, _modifiers.dimensionModifiers, _modifiers.displayModifiers, _modifiers.padScaleModifiers, {
  center: function center() {
    return {
      styles: (0, _styledComponents.css)(_templateObject)
    };
  },
  col: function col() {
    return {
      styles: (0, _styledComponents.css)(_templateObject2)
    };
  },
  col_1: function col_1() {
    return {
      styles: (0, _styledComponents.css)(_templateObject3)
    };
  },
  col_2: function col_2() {
    return {
      styles: (0, _styledComponents.css)(_templateObject4)
    };
  },
  col_3: function col_3() {
    return {
      styles: (0, _styledComponents.css)(_templateObject5)
    };
  },
  col_4: function col_4() {
    return {
      styles: (0, _styledComponents.css)(_templateObject6)
    };
  },
  col_5: function col_5() {
    return {
      styles: (0, _styledComponents.css)(_templateObject7)
    };
  },
  col_6: function col_6() {
    return {
      styles: (0, _styledComponents.css)(_templateObject8)
    };
  },
  col_7: function col_7() {
    return {
      styles: (0, _styledComponents.css)(_templateObject9)
    };
  },

  col_8: function col_8() {
    return {
      styles: (0, _styledComponents.css)(_templateObject10)
    };
  },

  col_9: function col_9() {
    return {
      styles: (0, _styledComponents.css)(_templateObject11)
    };
  },
  col_10: function col_10() {
    return {
      styles: (0, _styledComponents.css)(_templateObject12)
    };
  },
  col_11: function col_11() {
    return {
      styles: (0, _styledComponents.css)(_templateObject13)
    };
  },
  col_12: function col_12() {
    return {
      styles: (0, _styledComponents.css)(_templateObject14)
    };
  },
  col_offset_1: function col_offset_1() {
    return {
      styles: (0, _styledComponents.css)(_templateObject15)
    };
  },
  col_offset_2: function col_offset_2() {
    return {
      styles: (0, _styledComponents.css)(_templateObject16)
    };
  },
  col_offset_3: function col_offset_3() {
    return {
      styles: (0, _styledComponents.css)(_templateObject17)
    };
  },
  col_offset_4: function col_offset_4() {
    return {
      styles: (0, _styledComponents.css)(_templateObject18)
    };
  },
  col_offset_5: function col_offset_5() {
    return {
      styles: (0, _styledComponents.css)(_templateObject19)
    };
  },
  col_offset_6: function col_offset_6() {
    return {
      styles: (0, _styledComponents.css)(_templateObject20)
    };
  },
  col_offset_7: function col_offset_7() {
    return {
      styles: (0, _styledComponents.css)(_templateObject21)
    };
  },
  col_offset_8: function col_offset_8() {
    return {
      styles: (0, _styledComponents.css)(_templateObject22)
    };
  },
  col_offset_9: function col_offset_9() {
    return {
      styles: (0, _styledComponents.css)(_templateObject23)
    };
  },
  col_offset_10: function col_offset_10() {
    return {
      styles: (0, _styledComponents.css)(_templateObject24)
    };
  },
  col_offset_11: function col_offset_11() {
    return {
      styles: (0, _styledComponents.css)(_templateObject25)
    };
  },
  end: function end() {
    return {
      styles: (0, _styledComponents.css)(_templateObject26)
    };
  },
  fluid: function fluid() {
    return {
      styles: (0, _styledComponents.css)(_templateObject27)
    };
  },
  reverse: function reverse() {
    return {
      styles: (0, _styledComponents.css)(_templateObject28)
    };
  },
  start: function start() {
    return {
      styles: (0, _styledComponents.css)(_templateObject29)
    };
  }
});

var THEME_PROPTYPES = (0, _styledComponentsThemeValidator.buildThemePropTypes)({
  dimensions: _propTypes2.default.shape({
    gridPad: _propTypes2.default.string.isRequired
  }).isRequired
});

var Column = _styledComponents2.default.div(_templateObject30, (0, _styledComponentsThemeValidator.validateTheme)(COMPONENT_NAME, THEME_PROPTYPES), function (props) {
  return props.theme.dimensions.gridPad;
}, (0, _styledComponentsModifiers.applyStyleModifiers)(MODIFIER_CONFIG), (0, _styledComponentsModifiers.applyResponsiveStyleModifiers)(MODIFIER_CONFIG));

Column.propTypes = {
  className: _propTypes2.default.string,
  modifiers: (0, _styledComponentsModifiers.styleModifierPropTypes)(MODIFIER_CONFIG),
  responsiveModifiers: (0, _styledComponentsModifiers.responsiveStyleModifierPropTypes)(MODIFIER_CONFIG),
  size: _propTypes2.default.string.isRequired
};

Column.defaultProps = {
  className: COMPONENT_NAME
};

var ColumnWithSize = (0, _reactiveContainer.withSize)(Column);

ColumnWithSize.displayName = COMPONENT_NAME;
ColumnWithSize.modifiers = MODIFIER_CONFIG;

exports.default = ColumnWithSize;

/***/ }),

/***/ "../node_modules/styled-components-reactive-grid/dist/Container.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MODIFIER_CONFIG = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n      display: flex;\n      flex-direction: column;\n    '], ['\n      display: flex;\n      flex-direction: column;\n    ']),
    _templateObject2 = _taggedTemplateLiteral(['\n      padding: 0;\n    '], ['\n      padding: 0;\n    ']),
    _templateObject3 = _taggedTemplateLiteral(['\n  ', '\n  box-sizing: border-box;\n  flex: 1;\n  padding: ', ';\n  position: relative;\n  width: 100%;\n  ', ';\n'], ['\n  ', '\n  box-sizing: border-box;\n  flex: 1;\n  padding: ', ';\n  position: relative;\n  width: 100%;\n  ', ';\n']);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledComponentsModifiers = __webpack_require__("../node_modules/styled-components-modifiers/dist/index.js");

var _styledComponentsThemeValidator = __webpack_require__("../node_modules/styled-components-theme-validator/dist/index.js");

var _modifiers = __webpack_require__("../node_modules/styled-components-reactive-grid/dist/utils/modifiers.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var COMPONENT_NAME = 'Container';

var MODIFIER_CONFIG = exports.MODIFIER_CONFIG = _extends({}, _modifiers.dimensionModifiers, _modifiers.displayModifiers, _modifiers.padScaleModifiers, {
  flex_column: function flex_column() {
    return {
      styles: (0, _styledComponents.css)(_templateObject)
    };
  },
  fluid: function fluid() {
    return {
      styles: (0, _styledComponents.css)(_templateObject2)
    };
  }
});

var THEME_PROPTYPES = (0, _styledComponentsThemeValidator.buildThemePropTypes)({
  dimensions: _propTypes2.default.shape({
    gridPad: _propTypes2.default.string.isRequired
  }).isRequired
});

var Container = _styledComponents2.default.div(_templateObject3, (0, _styledComponentsThemeValidator.validateTheme)(COMPONENT_NAME, THEME_PROPTYPES), function (props) {
  return props.theme.dimensions.gridPad;
}, (0, _styledComponentsModifiers.applyStyleModifiers)(MODIFIER_CONFIG));

Container.propTypes = {
  className: _propTypes2.default.string,
  modifiers: (0, _styledComponentsModifiers.styleModifierPropTypes)(MODIFIER_CONFIG)
};

Container.defaultProps = {
  className: COMPONENT_NAME
};

Container.displayName = COMPONENT_NAME;
Container.modifiers = MODIFIER_CONFIG;

exports.default = Container;

/***/ }),

/***/ "../node_modules/styled-components-reactive-grid/dist/ReactiveContainer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactiveContainer = __webpack_require__("../node_modules/reactive-container/dist/index.js");

var _Container = __webpack_require__("../node_modules/styled-components-reactive-grid/dist/Container.js");

var _Container2 = _interopRequireDefault(_Container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReactiveContainer = (0, _reactiveContainer.makeReactiveContainer)()(_Container2.default);

ReactiveContainer.displayName = 'ReactiveContainer';
ReactiveContainer.modifiers = _Container.MODIFIER_CONFIG;

exports.default = ReactiveContainer;

/***/ }),

/***/ "../node_modules/styled-components-reactive-grid/dist/Row.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n      align-items: flex-end;\n    '], ['\n      align-items: flex-end;\n    ']),
    _templateObject2 = _taggedTemplateLiteral(['\n      justify-content: center;\n      text-align: center;\n    '], ['\n      justify-content: center;\n      text-align: center;\n    ']),
    _templateObject3 = _taggedTemplateLiteral(['\n      justify-content: flex-end;\n      text-align: end;\n    '], ['\n      justify-content: flex-end;\n      text-align: end;\n    ']),
    _templateObject4 = _taggedTemplateLiteral(['\n      margin-left: calc(-', ' * 2);\n      margin-right: calc(-', ' * 2);\n    '], ['\n      margin-left: calc(-', ' * 2);\n      margin-right: calc(-', ' * 2);\n    ']),
    _templateObject5 = _taggedTemplateLiteral(['\n      align-items: center;\n    '], ['\n      align-items: center;\n    ']),
    _templateObject6 = _taggedTemplateLiteral(['\n      -webkit-box-direction: reverse;\n      -webkit-box-orient: horizontal;\n      flex-direction: row-reverse;\n    '], ['\n      -webkit-box-direction: reverse;\n      -webkit-box-orient: horizontal;\n      flex-direction: row-reverse;\n    ']),
    _templateObject7 = _taggedTemplateLiteral(['\n      justify-content: flex-start;\n      text-align: start;\n    '], ['\n      justify-content: flex-start;\n      text-align: start;\n    ']),
    _templateObject8 = _taggedTemplateLiteral(['\n      align-items: flex-start;\n    '], ['\n      align-items: flex-start;\n    ']),
    _templateObject9 = _taggedTemplateLiteral(['\n  ', '\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  flex: 0 1 auto;\n  position: relative;\n  ', '\n  ', '\n'], ['\n  ', '\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  flex: 0 1 auto;\n  position: relative;\n  ', '\n  ', '\n']);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactiveContainer = __webpack_require__("../node_modules/reactive-container/dist/index.js");

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledComponentsModifiers = __webpack_require__("../node_modules/styled-components-modifiers/dist/index.js");

var _styledComponentsThemeValidator = __webpack_require__("../node_modules/styled-components-theme-validator/dist/index.js");

var _modifiers = __webpack_require__("../node_modules/styled-components-reactive-grid/dist/utils/modifiers.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var COMPONENT_NAME = 'Row';

var MODIFIER_CONFIG = _extends({}, _modifiers.dimensionModifiers, _modifiers.displayModifiers, _modifiers.padScaleModifiers, {
  bottom: function bottom() {
    return {
      styles: (0, _styledComponents.css)(_templateObject)
    };
  },
  center: function center() {
    return {
      styles: (0, _styledComponents.css)(_templateObject2)
    };
  },
  end: function end() {
    return {
      styles: (0, _styledComponents.css)(_templateObject3)
    };
  },
  fluid: function fluid(_ref) {
    var theme = _ref.theme;
    return {
      styles: (0, _styledComponents.css)(_templateObject4, theme.dimensions.gridPad, theme.dimensions.gridPad)
    };
  },
  middle: function middle() {
    return {
      styles: (0, _styledComponents.css)(_templateObject5)
    };
  },
  reverse: function reverse() {
    return {
      styles: (0, _styledComponents.css)(_templateObject6)
    };
  },
  start: function start() {
    return {
      styles: (0, _styledComponents.css)(_templateObject7)
    };
  },
  top: function top() {
    return {
      styles: (0, _styledComponents.css)(_templateObject8)
    };
  }
});

var THEME_PROPTYPES = (0, _styledComponentsThemeValidator.buildThemePropTypes)({
  dimensions: _propTypes2.default.shape({
    gridPad: _propTypes2.default.string.isRequired
  }).isRequired
});

var Row = _styledComponents2.default.div(_templateObject9, (0, _styledComponentsThemeValidator.validateTheme)(COMPONENT_NAME, THEME_PROPTYPES), (0, _styledComponentsModifiers.applyStyleModifiers)(MODIFIER_CONFIG), (0, _styledComponentsModifiers.applyResponsiveStyleModifiers)(MODIFIER_CONFIG));

Row.propTypes = {
  className: _propTypes2.default.string,
  modifiers: (0, _styledComponentsModifiers.styleModifierPropTypes)(MODIFIER_CONFIG),
  responsiveModifiers: (0, _styledComponentsModifiers.responsiveStyleModifierPropTypes)(MODIFIER_CONFIG),
  size: _propTypes2.default.string.isRequired
};

Row.defaultProps = {
  className: COMPONENT_NAME
};

var RowWithSize = (0, _reactiveContainer.withSize)(Row);

RowWithSize.displayName = COMPONENT_NAME;
RowWithSize.modifiers = MODIFIER_CONFIG;

exports.default = RowWithSize;

/***/ }),

/***/ "../node_modules/styled-components-reactive-grid/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Row = exports.ReactiveContainer = exports.Container = exports.Column = undefined;

var _Column = __webpack_require__("../node_modules/styled-components-reactive-grid/dist/Column.js");

var _Column2 = _interopRequireDefault(_Column);

var _Container = __webpack_require__("../node_modules/styled-components-reactive-grid/dist/Container.js");

var _Container2 = _interopRequireDefault(_Container);

var _ReactiveContainer = __webpack_require__("../node_modules/styled-components-reactive-grid/dist/ReactiveContainer.js");

var _ReactiveContainer2 = _interopRequireDefault(_ReactiveContainer);

var _Row = __webpack_require__("../node_modules/styled-components-reactive-grid/dist/Row.js");

var _Row2 = _interopRequireDefault(_Row);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Column = _Column2.default;
exports.Container = _Container2.default;
exports.ReactiveContainer = _ReactiveContainer2.default;
exports.Row = _Row2.default;

/***/ }),

/***/ "../node_modules/styled-components-reactive-grid/dist/utils/modifiers.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.padScaleModifiers = exports.displayModifiers = exports.dimensionModifiers = undefined;

var _templateObject = _taggedTemplateLiteral(['\n      height: 100%;\n    '], ['\n      height: 100%;\n    ']),
    _templateObject2 = _taggedTemplateLiteral(['\n      flex: 1;\n    '], ['\n      flex: 1;\n    ']),
    _templateObject3 = _taggedTemplateLiteral(['\n      display: none;\n    '], ['\n      display: none;\n    ']),
    _templateObject4 = _taggedTemplateLiteral(['\n      padding: 0;\n    '], ['\n      padding: 0;\n    ']),
    _templateObject5 = _taggedTemplateLiteral(['\n      padding: calc(', ' * 2);\n    '], ['\n      padding: calc(', ' * 2);\n    ']),
    _templateObject6 = _taggedTemplateLiteral(['\n      padding: calc(', ' * 3);\n    '], ['\n      padding: calc(', ' * 3);\n    ']),
    _templateObject7 = _taggedTemplateLiteral(['\n      padding: calc(', ' * 4);\n    '], ['\n      padding: calc(', ' * 4);\n    ']),
    _templateObject8 = _taggedTemplateLiteral(['\n      padding: calc(', ' * 5);\n    '], ['\n      padding: calc(', ' * 5);\n    ']),
    _templateObject9 = _taggedTemplateLiteral(['\n      padding-left: 0;\n      padding-right: 0;\n    '], ['\n      padding-left: 0;\n      padding-right: 0;\n    ']),
    _templateObject10 = _taggedTemplateLiteral(['\n      padding-left: calc(', ' * 2);\n      padding-right: calc(', ' * 2);\n    '], ['\n      padding-left: calc(', ' * 2);\n      padding-right: calc(', ' * 2);\n    ']),
    _templateObject11 = _taggedTemplateLiteral(['\n      padding-left: calc(', ' * 3);\n      padding-right: calc(', ' * 3);\n    '], ['\n      padding-left: calc(', ' * 3);\n      padding-right: calc(', ' * 3);\n    ']),
    _templateObject12 = _taggedTemplateLiteral(['\n      padding-left: calc(', ' * 4);\n      padding-right: calc(', ' * 4);\n    '], ['\n      padding-left: calc(', ' * 4);\n      padding-right: calc(', ' * 4);\n    ']),
    _templateObject13 = _taggedTemplateLiteral(['\n      padding-left: calc(', ' * 5);\n      padding-right: calc(', ' * 5);\n    '], ['\n      padding-left: calc(', ' * 5);\n      padding-right: calc(', ' * 5);\n    ']),
    _templateObject14 = _taggedTemplateLiteral(['\n      padding-top: 0;\n      padding-bottom: 0;\n    '], ['\n      padding-top: 0;\n      padding-bottom: 0;\n    ']),
    _templateObject15 = _taggedTemplateLiteral(['\n      padding-top: calc(', ' * 2);\n      padding-bottom: calc(', ' * 2);\n    '], ['\n      padding-top: calc(', ' * 2);\n      padding-bottom: calc(', ' * 2);\n    ']),
    _templateObject16 = _taggedTemplateLiteral(['\n      padding-top: calc(', ' * 3);\n      padding-bottom: calc(', ' * 3);\n    '], ['\n      padding-top: calc(', ' * 3);\n      padding-bottom: calc(', ' * 3);\n    ']),
    _templateObject17 = _taggedTemplateLiteral(['\n      padding-top: calc(', ' * 4);\n      padding-bottom: calc(', ' * 4);\n    '], ['\n      padding-top: calc(', ' * 4);\n      padding-bottom: calc(', ' * 4);\n    ']),
    _templateObject18 = _taggedTemplateLiteral(['\n      padding-top: calc(', ' * 5);\n      padding-bottom: calc(', ' * 5);\n    '], ['\n      padding-top: calc(', ' * 5);\n      padding-bottom: calc(', ' * 5);\n    ']);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var dimensionModifiers = {
  height_100: function height_100() {
    return {
      styles: (0, _styledComponents.css)(_templateObject)
    };
  },
  flex_1: function flex_1() {
    return {
      styles: (0, _styledComponents.css)(_templateObject2)
    };
  }
};

var displayModifiers = {
  noDisplay: function noDisplay() {
    return {
      styles: (0, _styledComponents.css)(_templateObject3)
    };
  }
};

var padScaleModifiers = {
  padScale_0: function padScale_0() {
    return {
      styles: (0, _styledComponents.css)(_templateObject4)
    };
  },
  padScale_2: function padScale_2(_ref) {
    var theme = _ref.theme;
    return {
      styles: (0, _styledComponents.css)(_templateObject5, theme.dimensions.gridPad)
    };
  },
  padScale_3: function padScale_3(_ref2) {
    var theme = _ref2.theme;
    return {
      styles: (0, _styledComponents.css)(_templateObject6, theme.dimensions.gridPad)
    };
  },
  padScale_4: function padScale_4(_ref3) {
    var theme = _ref3.theme;
    return {
      styles: (0, _styledComponents.css)(_templateObject7, theme.dimensions.gridPad)
    };
  },
  padScale_5: function padScale_5(_ref4) {
    var theme = _ref4.theme;
    return {
      styles: (0, _styledComponents.css)(_templateObject8, theme.dimensions.gridPad)
    };
  },
  padScaleX_0: function padScaleX_0() {
    return {
      styles: (0, _styledComponents.css)(_templateObject9)
    };
  },
  padScaleX_2: function padScaleX_2(_ref5) {
    var theme = _ref5.theme;
    return {
      styles: (0, _styledComponents.css)(_templateObject10, theme.dimensions.gridPad, theme.dimensions.gridPad)
    };
  },
  padScaleX_3: function padScaleX_3(_ref6) {
    var theme = _ref6.theme;
    return {
      styles: (0, _styledComponents.css)(_templateObject11, theme.dimensions.gridPad, theme.dimensions.gridPad)
    };
  },
  padScaleX_4: function padScaleX_4(_ref7) {
    var theme = _ref7.theme;
    return {
      styles: (0, _styledComponents.css)(_templateObject12, theme.dimensions.gridPad, theme.dimensions.gridPad)
    };
  },
  padScaleX_5: function padScaleX_5(_ref8) {
    var theme = _ref8.theme;
    return {
      styles: (0, _styledComponents.css)(_templateObject13, theme.dimensions.gridPad, theme.dimensions.gridPad)
    };
  },
  padScaleY_0: function padScaleY_0() {
    return {
      styles: (0, _styledComponents.css)(_templateObject14)
    };
  },
  padScaleY_2: function padScaleY_2(_ref9) {
    var theme = _ref9.theme;
    return {
      styles: (0, _styledComponents.css)(_templateObject15, theme.dimensions.gridPad, theme.dimensions.gridPad)
    };
  },
  padScaleY_3: function padScaleY_3(_ref10) {
    var theme = _ref10.theme;
    return {
      styles: (0, _styledComponents.css)(_templateObject16, theme.dimensions.gridPad, theme.dimensions.gridPad)
    };
  },
  padScaleY_4: function padScaleY_4(_ref11) {
    var theme = _ref11.theme;
    return {
      styles: (0, _styledComponents.css)(_templateObject17, theme.dimensions.gridPad, theme.dimensions.gridPad)
    };
  },
  padScaleY_5: function padScaleY_5(_ref12) {
    var theme = _ref12.theme;
    return {
      styles: (0, _styledComponents.css)(_templateObject18, theme.dimensions.gridPad, theme.dimensions.gridPad)
    };
  }
};

exports.dimensionModifiers = dimensionModifiers;
exports.displayModifiers = displayModifiers;
exports.padScaleModifiers = padScaleModifiers;

/***/ }),

/***/ "../node_modules/styled-components-theme-validator/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateTheme = exports.buildThemePropTypes = undefined;

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _fp = __webpack_require__("../node_modules/lodash/fp.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

function removeFromProd(nonProdArg, prodArg) {
  if (false) {
    return nonProdArg;
  }
  return prodArg;
}

/**
 * Creates the theme proptypes object in a non-prod build, returns undefined in prod.
 * @param {Object} propTypes An object definining the expected propTypes within the theme.
 */
var buildThemePropTypes = exports.buildThemePropTypes = (0, _fp.compose)(removeFromProd);

/**
 * Performs propTypes validations on the theme actually being used by a styled component
 * @param {String} componentName  The component's displayName. Must be passed in as `this` will be
 *                                `undefined`.
 * @param {Object} themePropTypes Defines the expected propTypes to be found in the theme.
 * @param {Object} props          The component's props.
 */
var validateTheme = exports.validateTheme = removeFromProd((0, _lodash.curry)(function (componentName, themePropTypes, props) {
  (0, _propTypes.checkPropTypes)({ theme: (0, _propTypes.shape)(themePropTypes).isRequired }, props, 'theme', componentName);
}), _lodash.noop);

/***/ }),

/***/ "../node_modules/url-parse/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var required = __webpack_require__("../node_modules/requires-port/index.js")
  , qs = __webpack_require__("../node_modules/querystringify/index.js")
  , protocolre = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\S\s]*)/i
  , slashes = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//;

/**
 * These are the parse rules for the URL parser, it informs the parser
 * about:
 *
 * 0. The char it Needs to parse, if it's a string it should be done using
 *    indexOf, RegExp using exec and NaN means set as current value.
 * 1. The property we should set when parsing this value.
 * 2. Indication if it's backwards or forward parsing, when set as number it's
 *    the value of extra chars that should be split off.
 * 3. Inherit from location if non existing in the parser.
 * 4. `toLowerCase` the resulting value.
 */
var rules = [
  ['#', 'hash'],                        // Extract from the back.
  ['?', 'query'],                       // Extract from the back.
  ['/', 'pathname'],                    // Extract from the back.
  ['@', 'auth', 1],                     // Extract from the front.
  [NaN, 'host', undefined, 1, 1],       // Set left over value.
  [/:(\d+)$/, 'port', undefined, 1],    // RegExp the back.
  [NaN, 'hostname', undefined, 1, 1]    // Set left over.
];

/**
 * These properties should not be copied or inherited from. This is only needed
 * for all non blob URL's as a blob URL does not include a hash, only the
 * origin.
 *
 * @type {Object}
 * @private
 */
var ignore = { hash: 1, query: 1 };

/**
 * The location object differs when your code is loaded through a normal page,
 * Worker or through a worker using a blob. And with the blobble begins the
 * trouble as the location object will contain the URL of the blob, not the
 * location of the page where our code is loaded in. The actual origin is
 * encoded in the `pathname` so we can thankfully generate a good "default"
 * location from it so we can generate proper relative URL's again.
 *
 * @param {Object|String} loc Optional default location object.
 * @returns {Object} lolcation object.
 * @api public
 */
function lolcation(loc) {
  loc = loc || global.location || {};

  var finaldestination = {}
    , type = typeof loc
    , key;

  if ('blob:' === loc.protocol) {
    finaldestination = new URL(unescape(loc.pathname), {});
  } else if ('string' === type) {
    finaldestination = new URL(loc, {});
    for (key in ignore) delete finaldestination[key];
  } else if ('object' === type) {
    for (key in loc) {
      if (key in ignore) continue;
      finaldestination[key] = loc[key];
    }

    if (finaldestination.slashes === undefined) {
      finaldestination.slashes = slashes.test(loc.href);
    }
  }

  return finaldestination;
}

/**
 * @typedef ProtocolExtract
 * @type Object
 * @property {String} protocol Protocol matched in the URL, in lowercase.
 * @property {Boolean} slashes `true` if protocol is followed by "//", else `false`.
 * @property {String} rest Rest of the URL that is not part of the protocol.
 */

/**
 * Extract protocol information from a URL with/without double slash ("//").
 *
 * @param {String} address URL we want to extract from.
 * @return {ProtocolExtract} Extracted information.
 * @api private
 */
function extractProtocol(address) {
  var match = protocolre.exec(address);

  return {
    protocol: match[1] ? match[1].toLowerCase() : '',
    slashes: !!match[2],
    rest: match[3]
  };
}

/**
 * Resolve a relative URL pathname against a base URL pathname.
 *
 * @param {String} relative Pathname of the relative URL.
 * @param {String} base Pathname of the base URL.
 * @return {String} Resolved pathname.
 * @api private
 */
function resolve(relative, base) {
  var path = (base || '/').split('/').slice(0, -1).concat(relative.split('/'))
    , i = path.length
    , last = path[i - 1]
    , unshift = false
    , up = 0;

  while (i--) {
    if (path[i] === '.') {
      path.splice(i, 1);
    } else if (path[i] === '..') {
      path.splice(i, 1);
      up++;
    } else if (up) {
      if (i === 0) unshift = true;
      path.splice(i, 1);
      up--;
    }
  }

  if (unshift) path.unshift('');
  if (last === '.' || last === '..') path.push('');

  return path.join('/');
}

/**
 * The actual URL instance. Instead of returning an object we've opted-in to
 * create an actual constructor as it's much more memory efficient and
 * faster and it pleases my OCD.
 *
 * @constructor
 * @param {String} address URL we want to parse.
 * @param {Object|String} location Location defaults for relative paths.
 * @param {Boolean|Function} parser Parser for the query string.
 * @api public
 */
function URL(address, location, parser) {
  if (!(this instanceof URL)) {
    return new URL(address, location, parser);
  }

  var relative, extracted, parse, instruction, index, key
    , instructions = rules.slice()
    , type = typeof location
    , url = this
    , i = 0;

  //
  // The following if statements allows this module two have compatibility with
  // 2 different API:
  //
  // 1. Node.js's `url.parse` api which accepts a URL, boolean as arguments
  //    where the boolean indicates that the query string should also be parsed.
  //
  // 2. The `URL` interface of the browser which accepts a URL, object as
  //    arguments. The supplied object will be used as default values / fall-back
  //    for relative paths.
  //
  if ('object' !== type && 'string' !== type) {
    parser = location;
    location = null;
  }

  if (parser && 'function' !== typeof parser) parser = qs.parse;

  location = lolcation(location);

  //
  // Extract protocol information before running the instructions.
  //
  extracted = extractProtocol(address || '');
  relative = !extracted.protocol && !extracted.slashes;
  url.slashes = extracted.slashes || relative && location.slashes;
  url.protocol = extracted.protocol || location.protocol || '';
  address = extracted.rest;

  //
  // When the authority component is absent the URL starts with a path
  // component.
  //
  if (!extracted.slashes) instructions[2] = [/(.*)/, 'pathname'];

  for (; i < instructions.length; i++) {
    instruction = instructions[i];
    parse = instruction[0];
    key = instruction[1];

    if (parse !== parse) {
      url[key] = address;
    } else if ('string' === typeof parse) {
      if (~(index = address.indexOf(parse))) {
        if ('number' === typeof instruction[2]) {
          url[key] = address.slice(0, index);
          address = address.slice(index + instruction[2]);
        } else {
          url[key] = address.slice(index);
          address = address.slice(0, index);
        }
      }
    } else if ((index = parse.exec(address))) {
      url[key] = index[1];
      address = address.slice(0, index.index);
    }

    url[key] = url[key] || (
      relative && instruction[3] ? location[key] || '' : ''
    );

    //
    // Hostname, host and protocol should be lowercased so they can be used to
    // create a proper `origin`.
    //
    if (instruction[4]) url[key] = url[key].toLowerCase();
  }

  //
  // Also parse the supplied query string in to an object. If we're supplied
  // with a custom parser as function use that instead of the default build-in
  // parser.
  //
  if (parser) url.query = parser(url.query);

  //
  // If the URL is relative, resolve the pathname against the base URL.
  //
  if (
      relative
    && location.slashes
    && url.pathname.charAt(0) !== '/'
    && (url.pathname !== '' || location.pathname !== '')
  ) {
    url.pathname = resolve(url.pathname, location.pathname);
  }

  //
  // We should not add port numbers if they are already the default port number
  // for a given protocol. As the host also contains the port number we're going
  // override it with the hostname which contains no port number.
  //
  if (!required(url.port, url.protocol)) {
    url.host = url.hostname;
    url.port = '';
  }

  //
  // Parse down the `auth` for the username and password.
  //
  url.username = url.password = '';
  if (url.auth) {
    instruction = url.auth.split(':');
    url.username = instruction[0] || '';
    url.password = instruction[1] || '';
  }

  url.origin = url.protocol && url.host && url.protocol !== 'file:'
    ? url.protocol +'//'+ url.host
    : 'null';

  //
  // The href is just the compiled result.
  //
  url.href = url.toString();
}

/**
 * This is convenience method for changing properties in the URL instance to
 * insure that they all propagate correctly.
 *
 * @param {String} part          Property we need to adjust.
 * @param {Mixed} value          The newly assigned value.
 * @param {Boolean|Function} fn  When setting the query, it will be the function
 *                               used to parse the query.
 *                               When setting the protocol, double slash will be
 *                               removed from the final url if it is true.
 * @returns {URL}
 * @api public
 */
function set(part, value, fn) {
  var url = this;

  switch (part) {
    case 'query':
      if ('string' === typeof value && value.length) {
        value = (fn || qs.parse)(value);
      }

      url[part] = value;
      break;

    case 'port':
      url[part] = value;

      if (!required(value, url.protocol)) {
        url.host = url.hostname;
        url[part] = '';
      } else if (value) {
        url.host = url.hostname +':'+ value;
      }

      break;

    case 'hostname':
      url[part] = value;

      if (url.port) value += ':'+ url.port;
      url.host = value;
      break;

    case 'host':
      url[part] = value;

      if (/:\d+$/.test(value)) {
        value = value.split(':');
        url.port = value.pop();
        url.hostname = value.join(':');
      } else {
        url.hostname = value;
        url.port = '';
      }

      break;

    case 'protocol':
      url.protocol = value.toLowerCase();
      url.slashes = !fn;
      break;

    case 'pathname':
      url.pathname = value.length && value.charAt(0) !== '/' ? '/' + value : value;

      break;

    default:
      url[part] = value;
  }

  for (var i = 0; i < rules.length; i++) {
    var ins = rules[i];

    if (ins[4]) url[ins[1]] = url[ins[1]].toLowerCase();
  }

  url.origin = url.protocol && url.host && url.protocol !== 'file:'
    ? url.protocol +'//'+ url.host
    : 'null';

  url.href = url.toString();

  return url;
}

/**
 * Transform the properties back in to a valid and full URL string.
 *
 * @param {Function} stringify Optional query stringify function.
 * @returns {String}
 * @api public
 */
function toString(stringify) {
  if (!stringify || 'function' !== typeof stringify) stringify = qs.stringify;

  var query
    , url = this
    , protocol = url.protocol;

  if (protocol && protocol.charAt(protocol.length - 1) !== ':') protocol += ':';

  var result = protocol + (url.slashes ? '//' : '');

  if (url.username) {
    result += url.username;
    if (url.password) result += ':'+ url.password;
    result += '@';
  }

  result += url.host + url.pathname;

  query = 'object' === typeof url.query ? stringify(url.query) : url.query;
  if (query) result += '?' !== query.charAt(0) ? '?'+ query : query;

  if (url.hash) result += url.hash;

  return result;
}

URL.prototype = { set: set, toString: toString };

//
// Expose the URL parser and some additional properties that might be useful for
// others or testing.
//
URL.extractProtocol = extractProtocol;
URL.location = lolcation;
URL.qs = qs;

module.exports = URL;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "../node_modules/util-deprecate/browser.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "../node_modules/webpack/buildin/harmony-module.js":
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ "../node_modules/webpack/node_modules/timers-browserify/main.js":
/***/ (function(module, exports, __webpack_require__) {

var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__("../node_modules/setimmediate/setImmediate.js");
exports.setImmediate = setImmediate;
exports.clearImmediate = clearImmediate;


/***/ }),

/***/ "../node_modules/xml2js/lib/bom.js":
/***/ (function(module, exports) {

// Generated by CoffeeScript 1.12.7
(function() {
  "use strict";
  exports.stripBOM = function(str) {
    if (str[0] === '\uFEFF') {
      return str.substring(1);
    } else {
      return str;
    }
  };

}).call(this);


/***/ }),

/***/ "../node_modules/xml2js/lib/builder.js":
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.12.7
(function() {
  "use strict";
  var builder, defaults, escapeCDATA, requiresCDATA, wrapCDATA,
    hasProp = {}.hasOwnProperty;

  builder = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/index.js");

  defaults = __webpack_require__("../node_modules/xml2js/lib/defaults.js").defaults;

  requiresCDATA = function(entry) {
    return typeof entry === "string" && (entry.indexOf('&') >= 0 || entry.indexOf('>') >= 0 || entry.indexOf('<') >= 0);
  };

  wrapCDATA = function(entry) {
    return "<![CDATA[" + (escapeCDATA(entry)) + "]]>";
  };

  escapeCDATA = function(entry) {
    return entry.replace(']]>', ']]]]><![CDATA[>');
  };

  exports.Builder = (function() {
    function Builder(opts) {
      var key, ref, value;
      this.options = {};
      ref = defaults["0.2"];
      for (key in ref) {
        if (!hasProp.call(ref, key)) continue;
        value = ref[key];
        this.options[key] = value;
      }
      for (key in opts) {
        if (!hasProp.call(opts, key)) continue;
        value = opts[key];
        this.options[key] = value;
      }
    }

    Builder.prototype.buildObject = function(rootObj) {
      var attrkey, charkey, render, rootElement, rootName;
      attrkey = this.options.attrkey;
      charkey = this.options.charkey;
      if ((Object.keys(rootObj).length === 1) && (this.options.rootName === defaults['0.2'].rootName)) {
        rootName = Object.keys(rootObj)[0];
        rootObj = rootObj[rootName];
      } else {
        rootName = this.options.rootName;
      }
      render = (function(_this) {
        return function(element, obj) {
          var attr, child, entry, index, key, value;
          if (typeof obj !== 'object') {
            if (_this.options.cdata && requiresCDATA(obj)) {
              element.raw(wrapCDATA(obj));
            } else {
              element.txt(obj);
            }
          } else if (Array.isArray(obj)) {
            for (index in obj) {
              if (!hasProp.call(obj, index)) continue;
              child = obj[index];
              for (key in child) {
                entry = child[key];
                element = render(element.ele(key), entry).up();
              }
            }
          } else {
            for (key in obj) {
              if (!hasProp.call(obj, key)) continue;
              child = obj[key];
              if (key === attrkey) {
                if (typeof child === "object") {
                  for (attr in child) {
                    value = child[attr];
                    element = element.att(attr, value);
                  }
                }
              } else if (key === charkey) {
                if (_this.options.cdata && requiresCDATA(child)) {
                  element = element.raw(wrapCDATA(child));
                } else {
                  element = element.txt(child);
                }
              } else if (Array.isArray(child)) {
                for (index in child) {
                  if (!hasProp.call(child, index)) continue;
                  entry = child[index];
                  if (typeof entry === 'string') {
                    if (_this.options.cdata && requiresCDATA(entry)) {
                      element = element.ele(key).raw(wrapCDATA(entry)).up();
                    } else {
                      element = element.ele(key, entry).up();
                    }
                  } else {
                    element = render(element.ele(key), entry).up();
                  }
                }
              } else if (typeof child === "object") {
                element = render(element.ele(key), child).up();
              } else {
                if (typeof child === 'string' && _this.options.cdata && requiresCDATA(child)) {
                  element = element.ele(key).raw(wrapCDATA(child)).up();
                } else {
                  if (child == null) {
                    child = '';
                  }
                  element = element.ele(key, child.toString()).up();
                }
              }
            }
          }
          return element;
        };
      })(this);
      rootElement = builder.create(rootName, this.options.xmldec, this.options.doctype, {
        headless: this.options.headless,
        allowSurrogateChars: this.options.allowSurrogateChars
      });
      return render(rootElement, rootObj).end(this.options.renderOpts);
    };

    return Builder;

  })();

}).call(this);


/***/ }),

/***/ "../node_modules/xml2js/lib/defaults.js":
/***/ (function(module, exports) {

// Generated by CoffeeScript 1.12.7
(function() {
  exports.defaults = {
    "0.1": {
      explicitCharkey: false,
      trim: true,
      normalize: true,
      normalizeTags: false,
      attrkey: "@",
      charkey: "#",
      explicitArray: false,
      ignoreAttrs: false,
      mergeAttrs: false,
      explicitRoot: false,
      validator: null,
      xmlns: false,
      explicitChildren: false,
      childkey: '@@',
      charsAsChildren: false,
      includeWhiteChars: false,
      async: false,
      strict: true,
      attrNameProcessors: null,
      attrValueProcessors: null,
      tagNameProcessors: null,
      valueProcessors: null,
      emptyTag: ''
    },
    "0.2": {
      explicitCharkey: false,
      trim: false,
      normalize: false,
      normalizeTags: false,
      attrkey: "$",
      charkey: "_",
      explicitArray: true,
      ignoreAttrs: false,
      mergeAttrs: false,
      explicitRoot: true,
      validator: null,
      xmlns: false,
      explicitChildren: false,
      preserveChildrenOrder: false,
      childkey: '$$',
      charsAsChildren: false,
      includeWhiteChars: false,
      async: false,
      strict: true,
      attrNameProcessors: null,
      attrValueProcessors: null,
      tagNameProcessors: null,
      valueProcessors: null,
      rootName: 'root',
      xmldec: {
        'version': '1.0',
        'encoding': 'UTF-8',
        'standalone': true
      },
      doctype: null,
      renderOpts: {
        'pretty': true,
        'indent': '  ',
        'newline': '\n'
      },
      headless: false,
      chunkSize: 10000,
      emptyTag: '',
      cdata: false
    }
  };

}).call(this);


/***/ }),

/***/ "../node_modules/xml2js/lib/parser.js":
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.12.7
(function() {
  "use strict";
  var bom, defaults, events, isEmpty, processItem, processors, sax, setImmediate,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  sax = __webpack_require__("../node_modules/sax/lib/sax.js");

  events = __webpack_require__("../node_modules/events/events.js");

  bom = __webpack_require__("../node_modules/xml2js/lib/bom.js");

  processors = __webpack_require__("../node_modules/xml2js/lib/processors.js");

  setImmediate = __webpack_require__("../node_modules/webpack/node_modules/timers-browserify/main.js").setImmediate;

  defaults = __webpack_require__("../node_modules/xml2js/lib/defaults.js").defaults;

  isEmpty = function(thing) {
    return typeof thing === "object" && (thing != null) && Object.keys(thing).length === 0;
  };

  processItem = function(processors, item, key) {
    var i, len, process;
    for (i = 0, len = processors.length; i < len; i++) {
      process = processors[i];
      item = process(item, key);
    }
    return item;
  };

  exports.Parser = (function(superClass) {
    extend(Parser, superClass);

    function Parser(opts) {
      this.parseString = bind(this.parseString, this);
      this.reset = bind(this.reset, this);
      this.assignOrPush = bind(this.assignOrPush, this);
      this.processAsync = bind(this.processAsync, this);
      var key, ref, value;
      if (!(this instanceof exports.Parser)) {
        return new exports.Parser(opts);
      }
      this.options = {};
      ref = defaults["0.2"];
      for (key in ref) {
        if (!hasProp.call(ref, key)) continue;
        value = ref[key];
        this.options[key] = value;
      }
      for (key in opts) {
        if (!hasProp.call(opts, key)) continue;
        value = opts[key];
        this.options[key] = value;
      }
      if (this.options.xmlns) {
        this.options.xmlnskey = this.options.attrkey + "ns";
      }
      if (this.options.normalizeTags) {
        if (!this.options.tagNameProcessors) {
          this.options.tagNameProcessors = [];
        }
        this.options.tagNameProcessors.unshift(processors.normalize);
      }
      this.reset();
    }

    Parser.prototype.processAsync = function() {
      var chunk, err;
      try {
        if (this.remaining.length <= this.options.chunkSize) {
          chunk = this.remaining;
          this.remaining = '';
          this.saxParser = this.saxParser.write(chunk);
          return this.saxParser.close();
        } else {
          chunk = this.remaining.substr(0, this.options.chunkSize);
          this.remaining = this.remaining.substr(this.options.chunkSize, this.remaining.length);
          this.saxParser = this.saxParser.write(chunk);
          return setImmediate(this.processAsync);
        }
      } catch (error1) {
        err = error1;
        if (!this.saxParser.errThrown) {
          this.saxParser.errThrown = true;
          return this.emit(err);
        }
      }
    };

    Parser.prototype.assignOrPush = function(obj, key, newValue) {
      if (!(key in obj)) {
        if (!this.options.explicitArray) {
          return obj[key] = newValue;
        } else {
          return obj[key] = [newValue];
        }
      } else {
        if (!(obj[key] instanceof Array)) {
          obj[key] = [obj[key]];
        }
        return obj[key].push(newValue);
      }
    };

    Parser.prototype.reset = function() {
      var attrkey, charkey, ontext, stack;
      this.removeAllListeners();
      this.saxParser = sax.parser(this.options.strict, {
        trim: false,
        normalize: false,
        xmlns: this.options.xmlns
      });
      this.saxParser.errThrown = false;
      this.saxParser.onerror = (function(_this) {
        return function(error) {
          _this.saxParser.resume();
          if (!_this.saxParser.errThrown) {
            _this.saxParser.errThrown = true;
            return _this.emit("error", error);
          }
        };
      })(this);
      this.saxParser.onend = (function(_this) {
        return function() {
          if (!_this.saxParser.ended) {
            _this.saxParser.ended = true;
            return _this.emit("end", _this.resultObject);
          }
        };
      })(this);
      this.saxParser.ended = false;
      this.EXPLICIT_CHARKEY = this.options.explicitCharkey;
      this.resultObject = null;
      stack = [];
      attrkey = this.options.attrkey;
      charkey = this.options.charkey;
      this.saxParser.onopentag = (function(_this) {
        return function(node) {
          var key, newValue, obj, processedKey, ref;
          obj = {};
          obj[charkey] = "";
          if (!_this.options.ignoreAttrs) {
            ref = node.attributes;
            for (key in ref) {
              if (!hasProp.call(ref, key)) continue;
              if (!(attrkey in obj) && !_this.options.mergeAttrs) {
                obj[attrkey] = {};
              }
              newValue = _this.options.attrValueProcessors ? processItem(_this.options.attrValueProcessors, node.attributes[key], key) : node.attributes[key];
              processedKey = _this.options.attrNameProcessors ? processItem(_this.options.attrNameProcessors, key) : key;
              if (_this.options.mergeAttrs) {
                _this.assignOrPush(obj, processedKey, newValue);
              } else {
                obj[attrkey][processedKey] = newValue;
              }
            }
          }
          obj["#name"] = _this.options.tagNameProcessors ? processItem(_this.options.tagNameProcessors, node.name) : node.name;
          if (_this.options.xmlns) {
            obj[_this.options.xmlnskey] = {
              uri: node.uri,
              local: node.local
            };
          }
          return stack.push(obj);
        };
      })(this);
      this.saxParser.onclosetag = (function(_this) {
        return function() {
          var cdata, emptyStr, key, node, nodeName, obj, objClone, old, s, xpath;
          obj = stack.pop();
          nodeName = obj["#name"];
          if (!_this.options.explicitChildren || !_this.options.preserveChildrenOrder) {
            delete obj["#name"];
          }
          if (obj.cdata === true) {
            cdata = obj.cdata;
            delete obj.cdata;
          }
          s = stack[stack.length - 1];
          if (obj[charkey].match(/^\s*$/) && !cdata) {
            emptyStr = obj[charkey];
            delete obj[charkey];
          } else {
            if (_this.options.trim) {
              obj[charkey] = obj[charkey].trim();
            }
            if (_this.options.normalize) {
              obj[charkey] = obj[charkey].replace(/\s{2,}/g, " ").trim();
            }
            obj[charkey] = _this.options.valueProcessors ? processItem(_this.options.valueProcessors, obj[charkey], nodeName) : obj[charkey];
            if (Object.keys(obj).length === 1 && charkey in obj && !_this.EXPLICIT_CHARKEY) {
              obj = obj[charkey];
            }
          }
          if (isEmpty(obj)) {
            obj = _this.options.emptyTag !== '' ? _this.options.emptyTag : emptyStr;
          }
          if (_this.options.validator != null) {
            xpath = "/" + ((function() {
              var i, len, results;
              results = [];
              for (i = 0, len = stack.length; i < len; i++) {
                node = stack[i];
                results.push(node["#name"]);
              }
              return results;
            })()).concat(nodeName).join("/");
            (function() {
              var err;
              try {
                return obj = _this.options.validator(xpath, s && s[nodeName], obj);
              } catch (error1) {
                err = error1;
                return _this.emit("error", err);
              }
            })();
          }
          if (_this.options.explicitChildren && !_this.options.mergeAttrs && typeof obj === 'object') {
            if (!_this.options.preserveChildrenOrder) {
              node = {};
              if (_this.options.attrkey in obj) {
                node[_this.options.attrkey] = obj[_this.options.attrkey];
                delete obj[_this.options.attrkey];
              }
              if (!_this.options.charsAsChildren && _this.options.charkey in obj) {
                node[_this.options.charkey] = obj[_this.options.charkey];
                delete obj[_this.options.charkey];
              }
              if (Object.getOwnPropertyNames(obj).length > 0) {
                node[_this.options.childkey] = obj;
              }
              obj = node;
            } else if (s) {
              s[_this.options.childkey] = s[_this.options.childkey] || [];
              objClone = {};
              for (key in obj) {
                if (!hasProp.call(obj, key)) continue;
                objClone[key] = obj[key];
              }
              s[_this.options.childkey].push(objClone);
              delete obj["#name"];
              if (Object.keys(obj).length === 1 && charkey in obj && !_this.EXPLICIT_CHARKEY) {
                obj = obj[charkey];
              }
            }
          }
          if (stack.length > 0) {
            return _this.assignOrPush(s, nodeName, obj);
          } else {
            if (_this.options.explicitRoot) {
              old = obj;
              obj = {};
              obj[nodeName] = old;
            }
            _this.resultObject = obj;
            _this.saxParser.ended = true;
            return _this.emit("end", _this.resultObject);
          }
        };
      })(this);
      ontext = (function(_this) {
        return function(text) {
          var charChild, s;
          s = stack[stack.length - 1];
          if (s) {
            s[charkey] += text;
            if (_this.options.explicitChildren && _this.options.preserveChildrenOrder && _this.options.charsAsChildren && (_this.options.includeWhiteChars || text.replace(/\\n/g, '').trim() !== '')) {
              s[_this.options.childkey] = s[_this.options.childkey] || [];
              charChild = {
                '#name': '__text__'
              };
              charChild[charkey] = text;
              if (_this.options.normalize) {
                charChild[charkey] = charChild[charkey].replace(/\s{2,}/g, " ").trim();
              }
              s[_this.options.childkey].push(charChild);
            }
            return s;
          }
        };
      })(this);
      this.saxParser.ontext = ontext;
      return this.saxParser.oncdata = (function(_this) {
        return function(text) {
          var s;
          s = ontext(text);
          if (s) {
            return s.cdata = true;
          }
        };
      })(this);
    };

    Parser.prototype.parseString = function(str, cb) {
      var err;
      if ((cb != null) && typeof cb === "function") {
        this.on("end", function(result) {
          this.reset();
          return cb(null, result);
        });
        this.on("error", function(err) {
          this.reset();
          return cb(err);
        });
      }
      try {
        str = str.toString();
        if (str.trim() === '') {
          this.emit("end", null);
          return true;
        }
        str = bom.stripBOM(str);
        if (this.options.async) {
          this.remaining = str;
          setImmediate(this.processAsync);
          return this.saxParser;
        }
        return this.saxParser.write(str).close();
      } catch (error1) {
        err = error1;
        if (!(this.saxParser.errThrown || this.saxParser.ended)) {
          this.emit('error', err);
          return this.saxParser.errThrown = true;
        } else if (this.saxParser.ended) {
          throw err;
        }
      }
    };

    return Parser;

  })(events.EventEmitter);

  exports.parseString = function(str, a, b) {
    var cb, options, parser;
    if (b != null) {
      if (typeof b === 'function') {
        cb = b;
      }
      if (typeof a === 'object') {
        options = a;
      }
    } else {
      if (typeof a === 'function') {
        cb = a;
      }
      options = {};
    }
    parser = new exports.Parser(options);
    return parser.parseString(str, cb);
  };

}).call(this);


/***/ }),

/***/ "../node_modules/xml2js/lib/processors.js":
/***/ (function(module, exports) {

// Generated by CoffeeScript 1.12.7
(function() {
  "use strict";
  var prefixMatch;

  prefixMatch = new RegExp(/(?!xmlns)^.*:/);

  exports.normalize = function(str) {
    return str.toLowerCase();
  };

  exports.firstCharLowerCase = function(str) {
    return str.charAt(0).toLowerCase() + str.slice(1);
  };

  exports.stripPrefix = function(str) {
    return str.replace(prefixMatch, '');
  };

  exports.parseNumbers = function(str) {
    if (!isNaN(str)) {
      str = str % 1 === 0 ? parseInt(str, 10) : parseFloat(str);
    }
    return str;
  };

  exports.parseBooleans = function(str) {
    if (/^(?:true|false)$/i.test(str)) {
      str = str.toLowerCase() === 'true';
    }
    return str;
  };

}).call(this);


/***/ }),

/***/ "../node_modules/xml2js/lib/xml2js.js":
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.12.7
(function() {
  "use strict";
  var builder, defaults, parser, processors,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  defaults = __webpack_require__("../node_modules/xml2js/lib/defaults.js");

  builder = __webpack_require__("../node_modules/xml2js/lib/builder.js");

  parser = __webpack_require__("../node_modules/xml2js/lib/parser.js");

  processors = __webpack_require__("../node_modules/xml2js/lib/processors.js");

  exports.defaults = defaults.defaults;

  exports.processors = processors;

  exports.ValidationError = (function(superClass) {
    extend(ValidationError, superClass);

    function ValidationError(message) {
      this.message = message;
    }

    return ValidationError;

  })(Error);

  exports.Builder = builder.Builder;

  exports.Parser = parser.Parser;

  exports.parseString = parser.parseString;

}).call(this);


/***/ }),

/***/ "../node_modules/xml2js/node_modules/xmlbuilder/lib/Utility.js":
/***/ (function(module, exports) {

// Generated by CoffeeScript 1.12.6
(function() {
  var assign, isArray, isEmpty, isFunction, isObject, isPlainObject,
    slice = [].slice,
    hasProp = {}.hasOwnProperty;

  assign = function() {
    var i, key, len, source, sources, target;
    target = arguments[0], sources = 2 <= arguments.length ? slice.call(arguments, 1) : [];
    if (isFunction(Object.assign)) {
      Object.assign.apply(null, arguments);
    } else {
      for (i = 0, len = sources.length; i < len; i++) {
        source = sources[i];
        if (source != null) {
          for (key in source) {
            if (!hasProp.call(source, key)) continue;
            target[key] = source[key];
          }
        }
      }
    }
    return target;
  };

  isFunction = function(val) {
    return !!val && Object.prototype.toString.call(val) === '[object Function]';
  };

  isObject = function(val) {
    var ref;
    return !!val && ((ref = typeof val) === 'function' || ref === 'object');
  };

  isArray = function(val) {
    if (isFunction(Array.isArray)) {
      return Array.isArray(val);
    } else {
      return Object.prototype.toString.call(val) === '[object Array]';
    }
  };

  isEmpty = function(val) {
    var key;
    if (isArray(val)) {
      return !val.length;
    } else {
      for (key in val) {
        if (!hasProp.call(val, key)) continue;
        return false;
      }
      return true;
    }
  };

  isPlainObject = function(val) {
    var ctor, proto;
    return isObject(val) && (proto = Object.getPrototypeOf(val)) && (ctor = proto.constructor) && (typeof ctor === 'function') && (ctor instanceof ctor) && (Function.prototype.toString.call(ctor) === Function.prototype.toString.call(Object));
  };

  module.exports.assign = assign;

  module.exports.isFunction = isFunction;

  module.exports.isObject = isObject;

  module.exports.isArray = isArray;

  module.exports.isEmpty = isEmpty;

  module.exports.isPlainObject = isPlainObject;

}).call(this);


/***/ }),

/***/ "../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLAttribute.js":
/***/ (function(module, exports) {

// Generated by CoffeeScript 1.12.6
(function() {
  var XMLAttribute;

  module.exports = XMLAttribute = (function() {
    function XMLAttribute(parent, name, value) {
      this.options = parent.options;
      this.stringify = parent.stringify;
      if (name == null) {
        throw new Error("Missing attribute name of element " + parent.name);
      }
      if (value == null) {
        throw new Error("Missing attribute value for attribute " + name + " of element " + parent.name);
      }
      this.name = this.stringify.attName(name);
      this.value = this.stringify.attValue(value);
    }

    XMLAttribute.prototype.clone = function() {
      return Object.create(this);
    };

    XMLAttribute.prototype.toString = function(options) {
      return this.options.writer.set(options).attribute(this);
    };

    return XMLAttribute;

  })();

}).call(this);


/***/ }),

/***/ "../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLCData.js":
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.12.6
(function() {
  var XMLCData, XMLNode,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  XMLNode = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLNode.js");

  module.exports = XMLCData = (function(superClass) {
    extend(XMLCData, superClass);

    function XMLCData(parent, text) {
      XMLCData.__super__.constructor.call(this, parent);
      if (text == null) {
        throw new Error("Missing CDATA text");
      }
      this.text = this.stringify.cdata(text);
    }

    XMLCData.prototype.clone = function() {
      return Object.create(this);
    };

    XMLCData.prototype.toString = function(options) {
      return this.options.writer.set(options).cdata(this);
    };

    return XMLCData;

  })(XMLNode);

}).call(this);


/***/ }),

/***/ "../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLComment.js":
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.12.6
(function() {
  var XMLComment, XMLNode,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  XMLNode = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLNode.js");

  module.exports = XMLComment = (function(superClass) {
    extend(XMLComment, superClass);

    function XMLComment(parent, text) {
      XMLComment.__super__.constructor.call(this, parent);
      if (text == null) {
        throw new Error("Missing comment text");
      }
      this.text = this.stringify.comment(text);
    }

    XMLComment.prototype.clone = function() {
      return Object.create(this);
    };

    XMLComment.prototype.toString = function(options) {
      return this.options.writer.set(options).comment(this);
    };

    return XMLComment;

  })(XMLNode);

}).call(this);


/***/ }),

/***/ "../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLDTDAttList.js":
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.12.6
(function() {
  var XMLDTDAttList, XMLNode,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  XMLNode = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLNode.js");

  module.exports = XMLDTDAttList = (function(superClass) {
    extend(XMLDTDAttList, superClass);

    function XMLDTDAttList(parent, elementName, attributeName, attributeType, defaultValueType, defaultValue) {
      XMLDTDAttList.__super__.constructor.call(this, parent);
      if (elementName == null) {
        throw new Error("Missing DTD element name");
      }
      if (attributeName == null) {
        throw new Error("Missing DTD attribute name");
      }
      if (!attributeType) {
        throw new Error("Missing DTD attribute type");
      }
      if (!defaultValueType) {
        throw new Error("Missing DTD attribute default");
      }
      if (defaultValueType.indexOf('#') !== 0) {
        defaultValueType = '#' + defaultValueType;
      }
      if (!defaultValueType.match(/^(#REQUIRED|#IMPLIED|#FIXED|#DEFAULT)$/)) {
        throw new Error("Invalid default value type; expected: #REQUIRED, #IMPLIED, #FIXED or #DEFAULT");
      }
      if (defaultValue && !defaultValueType.match(/^(#FIXED|#DEFAULT)$/)) {
        throw new Error("Default value only applies to #FIXED or #DEFAULT");
      }
      this.elementName = this.stringify.eleName(elementName);
      this.attributeName = this.stringify.attName(attributeName);
      this.attributeType = this.stringify.dtdAttType(attributeType);
      this.defaultValue = this.stringify.dtdAttDefault(defaultValue);
      this.defaultValueType = defaultValueType;
    }

    XMLDTDAttList.prototype.toString = function(options) {
      return this.options.writer.set(options).dtdAttList(this);
    };

    return XMLDTDAttList;

  })(XMLNode);

}).call(this);


/***/ }),

/***/ "../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLDTDElement.js":
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.12.6
(function() {
  var XMLDTDElement, XMLNode,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  XMLNode = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLNode.js");

  module.exports = XMLDTDElement = (function(superClass) {
    extend(XMLDTDElement, superClass);

    function XMLDTDElement(parent, name, value) {
      XMLDTDElement.__super__.constructor.call(this, parent);
      if (name == null) {
        throw new Error("Missing DTD element name");
      }
      if (!value) {
        value = '(#PCDATA)';
      }
      if (Array.isArray(value)) {
        value = '(' + value.join(',') + ')';
      }
      this.name = this.stringify.eleName(name);
      this.value = this.stringify.dtdElementValue(value);
    }

    XMLDTDElement.prototype.toString = function(options) {
      return this.options.writer.set(options).dtdElement(this);
    };

    return XMLDTDElement;

  })(XMLNode);

}).call(this);


/***/ }),

/***/ "../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLDTDEntity.js":
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.12.6
(function() {
  var XMLDTDEntity, XMLNode, isObject,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  isObject = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/Utility.js").isObject;

  XMLNode = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLNode.js");

  module.exports = XMLDTDEntity = (function(superClass) {
    extend(XMLDTDEntity, superClass);

    function XMLDTDEntity(parent, pe, name, value) {
      XMLDTDEntity.__super__.constructor.call(this, parent);
      if (name == null) {
        throw new Error("Missing entity name");
      }
      if (value == null) {
        throw new Error("Missing entity value");
      }
      this.pe = !!pe;
      this.name = this.stringify.eleName(name);
      if (!isObject(value)) {
        this.value = this.stringify.dtdEntityValue(value);
      } else {
        if (!value.pubID && !value.sysID) {
          throw new Error("Public and/or system identifiers are required for an external entity");
        }
        if (value.pubID && !value.sysID) {
          throw new Error("System identifier is required for a public external entity");
        }
        if (value.pubID != null) {
          this.pubID = this.stringify.dtdPubID(value.pubID);
        }
        if (value.sysID != null) {
          this.sysID = this.stringify.dtdSysID(value.sysID);
        }
        if (value.nData != null) {
          this.nData = this.stringify.dtdNData(value.nData);
        }
        if (this.pe && this.nData) {
          throw new Error("Notation declaration is not allowed in a parameter entity");
        }
      }
    }

    XMLDTDEntity.prototype.toString = function(options) {
      return this.options.writer.set(options).dtdEntity(this);
    };

    return XMLDTDEntity;

  })(XMLNode);

}).call(this);


/***/ }),

/***/ "../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLDTDNotation.js":
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.12.6
(function() {
  var XMLDTDNotation, XMLNode,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  XMLNode = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLNode.js");

  module.exports = XMLDTDNotation = (function(superClass) {
    extend(XMLDTDNotation, superClass);

    function XMLDTDNotation(parent, name, value) {
      XMLDTDNotation.__super__.constructor.call(this, parent);
      if (name == null) {
        throw new Error("Missing notation name");
      }
      if (!value.pubID && !value.sysID) {
        throw new Error("Public or system identifiers are required for an external entity");
      }
      this.name = this.stringify.eleName(name);
      if (value.pubID != null) {
        this.pubID = this.stringify.dtdPubID(value.pubID);
      }
      if (value.sysID != null) {
        this.sysID = this.stringify.dtdSysID(value.sysID);
      }
    }

    XMLDTDNotation.prototype.toString = function(options) {
      return this.options.writer.set(options).dtdNotation(this);
    };

    return XMLDTDNotation;

  })(XMLNode);

}).call(this);


/***/ }),

/***/ "../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLDeclaration.js":
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.12.6
(function() {
  var XMLDeclaration, XMLNode, isObject,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  isObject = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/Utility.js").isObject;

  XMLNode = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLNode.js");

  module.exports = XMLDeclaration = (function(superClass) {
    extend(XMLDeclaration, superClass);

    function XMLDeclaration(parent, version, encoding, standalone) {
      var ref;
      XMLDeclaration.__super__.constructor.call(this, parent);
      if (isObject(version)) {
        ref = version, version = ref.version, encoding = ref.encoding, standalone = ref.standalone;
      }
      if (!version) {
        version = '1.0';
      }
      this.version = this.stringify.xmlVersion(version);
      if (encoding != null) {
        this.encoding = this.stringify.xmlEncoding(encoding);
      }
      if (standalone != null) {
        this.standalone = this.stringify.xmlStandalone(standalone);
      }
    }

    XMLDeclaration.prototype.toString = function(options) {
      return this.options.writer.set(options).declaration(this);
    };

    return XMLDeclaration;

  })(XMLNode);

}).call(this);


/***/ }),

/***/ "../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLDocType.js":
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.12.6
(function() {
  var XMLDTDAttList, XMLDTDElement, XMLDTDEntity, XMLDTDNotation, XMLDocType, XMLNode, isObject,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  isObject = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/Utility.js").isObject;

  XMLNode = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLNode.js");

  XMLDTDAttList = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLDTDAttList.js");

  XMLDTDEntity = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLDTDEntity.js");

  XMLDTDElement = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLDTDElement.js");

  XMLDTDNotation = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLDTDNotation.js");

  module.exports = XMLDocType = (function(superClass) {
    extend(XMLDocType, superClass);

    function XMLDocType(parent, pubID, sysID) {
      var ref, ref1;
      XMLDocType.__super__.constructor.call(this, parent);
      this.documentObject = parent;
      if (isObject(pubID)) {
        ref = pubID, pubID = ref.pubID, sysID = ref.sysID;
      }
      if (sysID == null) {
        ref1 = [pubID, sysID], sysID = ref1[0], pubID = ref1[1];
      }
      if (pubID != null) {
        this.pubID = this.stringify.dtdPubID(pubID);
      }
      if (sysID != null) {
        this.sysID = this.stringify.dtdSysID(sysID);
      }
    }

    XMLDocType.prototype.element = function(name, value) {
      var child;
      child = new XMLDTDElement(this, name, value);
      this.children.push(child);
      return this;
    };

    XMLDocType.prototype.attList = function(elementName, attributeName, attributeType, defaultValueType, defaultValue) {
      var child;
      child = new XMLDTDAttList(this, elementName, attributeName, attributeType, defaultValueType, defaultValue);
      this.children.push(child);
      return this;
    };

    XMLDocType.prototype.entity = function(name, value) {
      var child;
      child = new XMLDTDEntity(this, false, name, value);
      this.children.push(child);
      return this;
    };

    XMLDocType.prototype.pEntity = function(name, value) {
      var child;
      child = new XMLDTDEntity(this, true, name, value);
      this.children.push(child);
      return this;
    };

    XMLDocType.prototype.notation = function(name, value) {
      var child;
      child = new XMLDTDNotation(this, name, value);
      this.children.push(child);
      return this;
    };

    XMLDocType.prototype.toString = function(options) {
      return this.options.writer.set(options).docType(this);
    };

    XMLDocType.prototype.ele = function(name, value) {
      return this.element(name, value);
    };

    XMLDocType.prototype.att = function(elementName, attributeName, attributeType, defaultValueType, defaultValue) {
      return this.attList(elementName, attributeName, attributeType, defaultValueType, defaultValue);
    };

    XMLDocType.prototype.ent = function(name, value) {
      return this.entity(name, value);
    };

    XMLDocType.prototype.pent = function(name, value) {
      return this.pEntity(name, value);
    };

    XMLDocType.prototype.not = function(name, value) {
      return this.notation(name, value);
    };

    XMLDocType.prototype.up = function() {
      return this.root() || this.documentObject;
    };

    return XMLDocType;

  })(XMLNode);

}).call(this);


/***/ }),

/***/ "../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLDocument.js":
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.12.6
(function() {
  var XMLDocument, XMLNode, XMLStringWriter, XMLStringifier, isPlainObject,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  isPlainObject = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/Utility.js").isPlainObject;

  XMLNode = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLNode.js");

  XMLStringifier = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLStringifier.js");

  XMLStringWriter = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLStringWriter.js");

  module.exports = XMLDocument = (function(superClass) {
    extend(XMLDocument, superClass);

    function XMLDocument(options) {
      XMLDocument.__super__.constructor.call(this, null);
      options || (options = {});
      if (!options.writer) {
        options.writer = new XMLStringWriter();
      }
      this.options = options;
      this.stringify = new XMLStringifier(options);
      this.isDocument = true;
    }

    XMLDocument.prototype.end = function(writer) {
      var writerOptions;
      if (!writer) {
        writer = this.options.writer;
      } else if (isPlainObject(writer)) {
        writerOptions = writer;
        writer = this.options.writer.set(writerOptions);
      }
      return writer.document(this);
    };

    XMLDocument.prototype.toString = function(options) {
      return this.options.writer.set(options).document(this);
    };

    return XMLDocument;

  })(XMLNode);

}).call(this);


/***/ }),

/***/ "../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLDocumentCB.js":
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.12.6
(function() {
  var XMLAttribute, XMLCData, XMLComment, XMLDTDAttList, XMLDTDElement, XMLDTDEntity, XMLDTDNotation, XMLDeclaration, XMLDocType, XMLDocumentCB, XMLElement, XMLProcessingInstruction, XMLRaw, XMLStringWriter, XMLStringifier, XMLText, isFunction, isObject, isPlainObject, ref,
    hasProp = {}.hasOwnProperty;

  ref = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/Utility.js"), isObject = ref.isObject, isFunction = ref.isFunction, isPlainObject = ref.isPlainObject;

  XMLElement = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLElement.js");

  XMLCData = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLCData.js");

  XMLComment = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLComment.js");

  XMLRaw = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLRaw.js");

  XMLText = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLText.js");

  XMLProcessingInstruction = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLProcessingInstruction.js");

  XMLDeclaration = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLDeclaration.js");

  XMLDocType = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLDocType.js");

  XMLDTDAttList = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLDTDAttList.js");

  XMLDTDEntity = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLDTDEntity.js");

  XMLDTDElement = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLDTDElement.js");

  XMLDTDNotation = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLDTDNotation.js");

  XMLAttribute = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLAttribute.js");

  XMLStringifier = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLStringifier.js");

  XMLStringWriter = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLStringWriter.js");

  module.exports = XMLDocumentCB = (function() {
    function XMLDocumentCB(options, onData, onEnd) {
      var writerOptions;
      options || (options = {});
      if (!options.writer) {
        options.writer = new XMLStringWriter(options);
      } else if (isPlainObject(options.writer)) {
        writerOptions = options.writer;
        options.writer = new XMLStringWriter(writerOptions);
      }
      this.options = options;
      this.writer = options.writer;
      this.stringify = new XMLStringifier(options);
      this.onDataCallback = onData || function() {};
      this.onEndCallback = onEnd || function() {};
      this.currentNode = null;
      this.currentLevel = -1;
      this.openTags = {};
      this.documentStarted = false;
      this.documentCompleted = false;
      this.root = null;
    }

    XMLDocumentCB.prototype.node = function(name, attributes, text) {
      var ref1;
      if (name == null) {
        throw new Error("Missing node name");
      }
      if (this.root && this.currentLevel === -1) {
        throw new Error("Document can only have one root node");
      }
      this.openCurrent();
      name = name.valueOf();
      if (attributes == null) {
        attributes = {};
      }
      attributes = attributes.valueOf();
      if (!isObject(attributes)) {
        ref1 = [attributes, text], text = ref1[0], attributes = ref1[1];
      }
      this.currentNode = new XMLElement(this, name, attributes);
      this.currentNode.children = false;
      this.currentLevel++;
      this.openTags[this.currentLevel] = this.currentNode;
      if (text != null) {
        this.text(text);
      }
      return this;
    };

    XMLDocumentCB.prototype.element = function(name, attributes, text) {
      if (this.currentNode && this.currentNode instanceof XMLDocType) {
        return this.dtdElement.apply(this, arguments);
      } else {
        return this.node(name, attributes, text);
      }
    };

    XMLDocumentCB.prototype.attribute = function(name, value) {
      var attName, attValue;
      if (!this.currentNode || this.currentNode.children) {
        throw new Error("att() can only be used immediately after an ele() call in callback mode");
      }
      if (name != null) {
        name = name.valueOf();
      }
      if (isObject(name)) {
        for (attName in name) {
          if (!hasProp.call(name, attName)) continue;
          attValue = name[attName];
          this.attribute(attName, attValue);
        }
      } else {
        if (isFunction(value)) {
          value = value.apply();
        }
        if (!this.options.skipNullAttributes || (value != null)) {
          this.currentNode.attributes[name] = new XMLAttribute(this, name, value);
        }
      }
      return this;
    };

    XMLDocumentCB.prototype.text = function(value) {
      var node;
      this.openCurrent();
      node = new XMLText(this, value);
      this.onData(this.writer.text(node, this.currentLevel + 1));
      return this;
    };

    XMLDocumentCB.prototype.cdata = function(value) {
      var node;
      this.openCurrent();
      node = new XMLCData(this, value);
      this.onData(this.writer.cdata(node, this.currentLevel + 1));
      return this;
    };

    XMLDocumentCB.prototype.comment = function(value) {
      var node;
      this.openCurrent();
      node = new XMLComment(this, value);
      this.onData(this.writer.comment(node, this.currentLevel + 1));
      return this;
    };

    XMLDocumentCB.prototype.raw = function(value) {
      var node;
      this.openCurrent();
      node = new XMLRaw(this, value);
      this.onData(this.writer.raw(node, this.currentLevel + 1));
      return this;
    };

    XMLDocumentCB.prototype.instruction = function(target, value) {
      var i, insTarget, insValue, len, node;
      this.openCurrent();
      if (target != null) {
        target = target.valueOf();
      }
      if (value != null) {
        value = value.valueOf();
      }
      if (Array.isArray(target)) {
        for (i = 0, len = target.length; i < len; i++) {
          insTarget = target[i];
          this.instruction(insTarget);
        }
      } else if (isObject(target)) {
        for (insTarget in target) {
          if (!hasProp.call(target, insTarget)) continue;
          insValue = target[insTarget];
          this.instruction(insTarget, insValue);
        }
      } else {
        if (isFunction(value)) {
          value = value.apply();
        }
        node = new XMLProcessingInstruction(this, target, value);
        this.onData(this.writer.processingInstruction(node, this.currentLevel + 1));
      }
      return this;
    };

    XMLDocumentCB.prototype.declaration = function(version, encoding, standalone) {
      var node;
      this.openCurrent();
      if (this.documentStarted) {
        throw new Error("declaration() must be the first node");
      }
      node = new XMLDeclaration(this, version, encoding, standalone);
      this.onData(this.writer.declaration(node, this.currentLevel + 1));
      return this;
    };

    XMLDocumentCB.prototype.doctype = function(root, pubID, sysID) {
      this.openCurrent();
      if (root == null) {
        throw new Error("Missing root node name");
      }
      if (this.root) {
        throw new Error("dtd() must come before the root node");
      }
      this.currentNode = new XMLDocType(this, pubID, sysID);
      this.currentNode.rootNodeName = root;
      this.currentNode.children = false;
      this.currentLevel++;
      this.openTags[this.currentLevel] = this.currentNode;
      return this;
    };

    XMLDocumentCB.prototype.dtdElement = function(name, value) {
      var node;
      this.openCurrent();
      node = new XMLDTDElement(this, name, value);
      this.onData(this.writer.dtdElement(node, this.currentLevel + 1));
      return this;
    };

    XMLDocumentCB.prototype.attList = function(elementName, attributeName, attributeType, defaultValueType, defaultValue) {
      var node;
      this.openCurrent();
      node = new XMLDTDAttList(this, elementName, attributeName, attributeType, defaultValueType, defaultValue);
      this.onData(this.writer.dtdAttList(node, this.currentLevel + 1));
      return this;
    };

    XMLDocumentCB.prototype.entity = function(name, value) {
      var node;
      this.openCurrent();
      node = new XMLDTDEntity(this, false, name, value);
      this.onData(this.writer.dtdEntity(node, this.currentLevel + 1));
      return this;
    };

    XMLDocumentCB.prototype.pEntity = function(name, value) {
      var node;
      this.openCurrent();
      node = new XMLDTDEntity(this, true, name, value);
      this.onData(this.writer.dtdEntity(node, this.currentLevel + 1));
      return this;
    };

    XMLDocumentCB.prototype.notation = function(name, value) {
      var node;
      this.openCurrent();
      node = new XMLDTDNotation(this, name, value);
      this.onData(this.writer.dtdNotation(node, this.currentLevel + 1));
      return this;
    };

    XMLDocumentCB.prototype.up = function() {
      if (this.currentLevel < 0) {
        throw new Error("The document node has no parent");
      }
      if (this.currentNode) {
        if (this.currentNode.children) {
          this.closeNode(this.currentNode);
        } else {
          this.openNode(this.currentNode);
        }
        this.currentNode = null;
      } else {
        this.closeNode(this.openTags[this.currentLevel]);
      }
      delete this.openTags[this.currentLevel];
      this.currentLevel--;
      return this;
    };

    XMLDocumentCB.prototype.end = function() {
      while (this.currentLevel >= 0) {
        this.up();
      }
      return this.onEnd();
    };

    XMLDocumentCB.prototype.openCurrent = function() {
      if (this.currentNode) {
        this.currentNode.children = true;
        return this.openNode(this.currentNode);
      }
    };

    XMLDocumentCB.prototype.openNode = function(node) {
      if (!node.isOpen) {
        if (!this.root && this.currentLevel === 0 && node instanceof XMLElement) {
          this.root = node;
        }
        this.onData(this.writer.openNode(node, this.currentLevel));
        return node.isOpen = true;
      }
    };

    XMLDocumentCB.prototype.closeNode = function(node) {
      if (!node.isClosed) {
        this.onData(this.writer.closeNode(node, this.currentLevel));
        return node.isClosed = true;
      }
    };

    XMLDocumentCB.prototype.onData = function(chunk) {
      this.documentStarted = true;
      return this.onDataCallback(chunk);
    };

    XMLDocumentCB.prototype.onEnd = function() {
      this.documentCompleted = true;
      return this.onEndCallback();
    };

    XMLDocumentCB.prototype.ele = function() {
      return this.element.apply(this, arguments);
    };

    XMLDocumentCB.prototype.nod = function(name, attributes, text) {
      return this.node(name, attributes, text);
    };

    XMLDocumentCB.prototype.txt = function(value) {
      return this.text(value);
    };

    XMLDocumentCB.prototype.dat = function(value) {
      return this.cdata(value);
    };

    XMLDocumentCB.prototype.com = function(value) {
      return this.comment(value);
    };

    XMLDocumentCB.prototype.ins = function(target, value) {
      return this.instruction(target, value);
    };

    XMLDocumentCB.prototype.dec = function(version, encoding, standalone) {
      return this.declaration(version, encoding, standalone);
    };

    XMLDocumentCB.prototype.dtd = function(root, pubID, sysID) {
      return this.doctype(root, pubID, sysID);
    };

    XMLDocumentCB.prototype.e = function(name, attributes, text) {
      return this.element(name, attributes, text);
    };

    XMLDocumentCB.prototype.n = function(name, attributes, text) {
      return this.node(name, attributes, text);
    };

    XMLDocumentCB.prototype.t = function(value) {
      return this.text(value);
    };

    XMLDocumentCB.prototype.d = function(value) {
      return this.cdata(value);
    };

    XMLDocumentCB.prototype.c = function(value) {
      return this.comment(value);
    };

    XMLDocumentCB.prototype.r = function(value) {
      return this.raw(value);
    };

    XMLDocumentCB.prototype.i = function(target, value) {
      return this.instruction(target, value);
    };

    XMLDocumentCB.prototype.att = function() {
      if (this.currentNode && this.currentNode instanceof XMLDocType) {
        return this.attList.apply(this, arguments);
      } else {
        return this.attribute.apply(this, arguments);
      }
    };

    XMLDocumentCB.prototype.a = function() {
      if (this.currentNode && this.currentNode instanceof XMLDocType) {
        return this.attList.apply(this, arguments);
      } else {
        return this.attribute.apply(this, arguments);
      }
    };

    XMLDocumentCB.prototype.ent = function(name, value) {
      return this.entity(name, value);
    };

    XMLDocumentCB.prototype.pent = function(name, value) {
      return this.pEntity(name, value);
    };

    XMLDocumentCB.prototype.not = function(name, value) {
      return this.notation(name, value);
    };

    return XMLDocumentCB;

  })();

}).call(this);


/***/ }),

/***/ "../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLElement.js":
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.12.6
(function() {
  var XMLAttribute, XMLElement, XMLNode, isFunction, isObject, ref,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  ref = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/Utility.js"), isObject = ref.isObject, isFunction = ref.isFunction;

  XMLNode = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLNode.js");

  XMLAttribute = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLAttribute.js");

  module.exports = XMLElement = (function(superClass) {
    extend(XMLElement, superClass);

    function XMLElement(parent, name, attributes) {
      XMLElement.__super__.constructor.call(this, parent);
      if (name == null) {
        throw new Error("Missing element name");
      }
      this.name = this.stringify.eleName(name);
      this.attributes = {};
      if (attributes != null) {
        this.attribute(attributes);
      }
      if (parent.isDocument) {
        this.isRoot = true;
        this.documentObject = parent;
        parent.rootObject = this;
      }
    }

    XMLElement.prototype.clone = function() {
      var att, attName, clonedSelf, ref1;
      clonedSelf = Object.create(this);
      if (clonedSelf.isRoot) {
        clonedSelf.documentObject = null;
      }
      clonedSelf.attributes = {};
      ref1 = this.attributes;
      for (attName in ref1) {
        if (!hasProp.call(ref1, attName)) continue;
        att = ref1[attName];
        clonedSelf.attributes[attName] = att.clone();
      }
      clonedSelf.children = [];
      this.children.forEach(function(child) {
        var clonedChild;
        clonedChild = child.clone();
        clonedChild.parent = clonedSelf;
        return clonedSelf.children.push(clonedChild);
      });
      return clonedSelf;
    };

    XMLElement.prototype.attribute = function(name, value) {
      var attName, attValue;
      if (name != null) {
        name = name.valueOf();
      }
      if (isObject(name)) {
        for (attName in name) {
          if (!hasProp.call(name, attName)) continue;
          attValue = name[attName];
          this.attribute(attName, attValue);
        }
      } else {
        if (isFunction(value)) {
          value = value.apply();
        }
        if (!this.options.skipNullAttributes || (value != null)) {
          this.attributes[name] = new XMLAttribute(this, name, value);
        }
      }
      return this;
    };

    XMLElement.prototype.removeAttribute = function(name) {
      var attName, i, len;
      if (name == null) {
        throw new Error("Missing attribute name");
      }
      name = name.valueOf();
      if (Array.isArray(name)) {
        for (i = 0, len = name.length; i < len; i++) {
          attName = name[i];
          delete this.attributes[attName];
        }
      } else {
        delete this.attributes[name];
      }
      return this;
    };

    XMLElement.prototype.toString = function(options) {
      return this.options.writer.set(options).element(this);
    };

    XMLElement.prototype.att = function(name, value) {
      return this.attribute(name, value);
    };

    XMLElement.prototype.a = function(name, value) {
      return this.attribute(name, value);
    };

    return XMLElement;

  })(XMLNode);

}).call(this);


/***/ }),

/***/ "../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLNode.js":
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.12.6
(function() {
  var XMLCData, XMLComment, XMLDeclaration, XMLDocType, XMLElement, XMLNode, XMLProcessingInstruction, XMLRaw, XMLText, isEmpty, isFunction, isObject, ref,
    hasProp = {}.hasOwnProperty;

  ref = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/Utility.js"), isObject = ref.isObject, isFunction = ref.isFunction, isEmpty = ref.isEmpty;

  XMLElement = null;

  XMLCData = null;

  XMLComment = null;

  XMLDeclaration = null;

  XMLDocType = null;

  XMLRaw = null;

  XMLText = null;

  XMLProcessingInstruction = null;

  module.exports = XMLNode = (function() {
    function XMLNode(parent) {
      this.parent = parent;
      if (this.parent) {
        this.options = this.parent.options;
        this.stringify = this.parent.stringify;
      }
      this.children = [];
      if (!XMLElement) {
        XMLElement = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLElement.js");
        XMLCData = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLCData.js");
        XMLComment = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLComment.js");
        XMLDeclaration = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLDeclaration.js");
        XMLDocType = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLDocType.js");
        XMLRaw = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLRaw.js");
        XMLText = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLText.js");
        XMLProcessingInstruction = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLProcessingInstruction.js");
      }
    }

    XMLNode.prototype.element = function(name, attributes, text) {
      var childNode, item, j, k, key, lastChild, len, len1, ref1, val;
      lastChild = null;
      if (attributes == null) {
        attributes = {};
      }
      attributes = attributes.valueOf();
      if (!isObject(attributes)) {
        ref1 = [attributes, text], text = ref1[0], attributes = ref1[1];
      }
      if (name != null) {
        name = name.valueOf();
      }
      if (Array.isArray(name)) {
        for (j = 0, len = name.length; j < len; j++) {
          item = name[j];
          lastChild = this.element(item);
        }
      } else if (isFunction(name)) {
        lastChild = this.element(name.apply());
      } else if (isObject(name)) {
        for (key in name) {
          if (!hasProp.call(name, key)) continue;
          val = name[key];
          if (isFunction(val)) {
            val = val.apply();
          }
          if ((isObject(val)) && (isEmpty(val))) {
            val = null;
          }
          if (!this.options.ignoreDecorators && this.stringify.convertAttKey && key.indexOf(this.stringify.convertAttKey) === 0) {
            lastChild = this.attribute(key.substr(this.stringify.convertAttKey.length), val);
          } else if (!this.options.separateArrayItems && Array.isArray(val)) {
            for (k = 0, len1 = val.length; k < len1; k++) {
              item = val[k];
              childNode = {};
              childNode[key] = item;
              lastChild = this.element(childNode);
            }
          } else if (isObject(val)) {
            lastChild = this.element(key);
            lastChild.element(val);
          } else {
            lastChild = this.element(key, val);
          }
        }
      } else {
        if (!this.options.ignoreDecorators && this.stringify.convertTextKey && name.indexOf(this.stringify.convertTextKey) === 0) {
          lastChild = this.text(text);
        } else if (!this.options.ignoreDecorators && this.stringify.convertCDataKey && name.indexOf(this.stringify.convertCDataKey) === 0) {
          lastChild = this.cdata(text);
        } else if (!this.options.ignoreDecorators && this.stringify.convertCommentKey && name.indexOf(this.stringify.convertCommentKey) === 0) {
          lastChild = this.comment(text);
        } else if (!this.options.ignoreDecorators && this.stringify.convertRawKey && name.indexOf(this.stringify.convertRawKey) === 0) {
          lastChild = this.raw(text);
        } else if (!this.options.ignoreDecorators && this.stringify.convertPIKey && name.indexOf(this.stringify.convertPIKey) === 0) {
          lastChild = this.instruction(name.substr(this.stringify.convertPIKey.length), text);
        } else {
          lastChild = this.node(name, attributes, text);
        }
      }
      if (lastChild == null) {
        throw new Error("Could not create any elements with: " + name);
      }
      return lastChild;
    };

    XMLNode.prototype.insertBefore = function(name, attributes, text) {
      var child, i, removed;
      if (this.isRoot) {
        throw new Error("Cannot insert elements at root level");
      }
      i = this.parent.children.indexOf(this);
      removed = this.parent.children.splice(i);
      child = this.parent.element(name, attributes, text);
      Array.prototype.push.apply(this.parent.children, removed);
      return child;
    };

    XMLNode.prototype.insertAfter = function(name, attributes, text) {
      var child, i, removed;
      if (this.isRoot) {
        throw new Error("Cannot insert elements at root level");
      }
      i = this.parent.children.indexOf(this);
      removed = this.parent.children.splice(i + 1);
      child = this.parent.element(name, attributes, text);
      Array.prototype.push.apply(this.parent.children, removed);
      return child;
    };

    XMLNode.prototype.remove = function() {
      var i, ref1;
      if (this.isRoot) {
        throw new Error("Cannot remove the root element");
      }
      i = this.parent.children.indexOf(this);
      [].splice.apply(this.parent.children, [i, i - i + 1].concat(ref1 = [])), ref1;
      return this.parent;
    };

    XMLNode.prototype.node = function(name, attributes, text) {
      var child, ref1;
      if (name != null) {
        name = name.valueOf();
      }
      attributes || (attributes = {});
      attributes = attributes.valueOf();
      if (!isObject(attributes)) {
        ref1 = [attributes, text], text = ref1[0], attributes = ref1[1];
      }
      child = new XMLElement(this, name, attributes);
      if (text != null) {
        child.text(text);
      }
      this.children.push(child);
      return child;
    };

    XMLNode.prototype.text = function(value) {
      var child;
      child = new XMLText(this, value);
      this.children.push(child);
      return this;
    };

    XMLNode.prototype.cdata = function(value) {
      var child;
      child = new XMLCData(this, value);
      this.children.push(child);
      return this;
    };

    XMLNode.prototype.comment = function(value) {
      var child;
      child = new XMLComment(this, value);
      this.children.push(child);
      return this;
    };

    XMLNode.prototype.commentBefore = function(value) {
      var child, i, removed;
      i = this.parent.children.indexOf(this);
      removed = this.parent.children.splice(i);
      child = this.parent.comment(value);
      Array.prototype.push.apply(this.parent.children, removed);
      return this;
    };

    XMLNode.prototype.commentAfter = function(value) {
      var child, i, removed;
      i = this.parent.children.indexOf(this);
      removed = this.parent.children.splice(i + 1);
      child = this.parent.comment(value);
      Array.prototype.push.apply(this.parent.children, removed);
      return this;
    };

    XMLNode.prototype.raw = function(value) {
      var child;
      child = new XMLRaw(this, value);
      this.children.push(child);
      return this;
    };

    XMLNode.prototype.instruction = function(target, value) {
      var insTarget, insValue, instruction, j, len;
      if (target != null) {
        target = target.valueOf();
      }
      if (value != null) {
        value = value.valueOf();
      }
      if (Array.isArray(target)) {
        for (j = 0, len = target.length; j < len; j++) {
          insTarget = target[j];
          this.instruction(insTarget);
        }
      } else if (isObject(target)) {
        for (insTarget in target) {
          if (!hasProp.call(target, insTarget)) continue;
          insValue = target[insTarget];
          this.instruction(insTarget, insValue);
        }
      } else {
        if (isFunction(value)) {
          value = value.apply();
        }
        instruction = new XMLProcessingInstruction(this, target, value);
        this.children.push(instruction);
      }
      return this;
    };

    XMLNode.prototype.instructionBefore = function(target, value) {
      var child, i, removed;
      i = this.parent.children.indexOf(this);
      removed = this.parent.children.splice(i);
      child = this.parent.instruction(target, value);
      Array.prototype.push.apply(this.parent.children, removed);
      return this;
    };

    XMLNode.prototype.instructionAfter = function(target, value) {
      var child, i, removed;
      i = this.parent.children.indexOf(this);
      removed = this.parent.children.splice(i + 1);
      child = this.parent.instruction(target, value);
      Array.prototype.push.apply(this.parent.children, removed);
      return this;
    };

    XMLNode.prototype.declaration = function(version, encoding, standalone) {
      var doc, xmldec;
      doc = this.document();
      xmldec = new XMLDeclaration(doc, version, encoding, standalone);
      if (doc.children[0] instanceof XMLDeclaration) {
        doc.children[0] = xmldec;
      } else {
        doc.children.unshift(xmldec);
      }
      return doc.root() || doc;
    };

    XMLNode.prototype.doctype = function(pubID, sysID) {
      var child, doc, doctype, i, j, k, len, len1, ref1, ref2;
      doc = this.document();
      doctype = new XMLDocType(doc, pubID, sysID);
      ref1 = doc.children;
      for (i = j = 0, len = ref1.length; j < len; i = ++j) {
        child = ref1[i];
        if (child instanceof XMLDocType) {
          doc.children[i] = doctype;
          return doctype;
        }
      }
      ref2 = doc.children;
      for (i = k = 0, len1 = ref2.length; k < len1; i = ++k) {
        child = ref2[i];
        if (child.isRoot) {
          doc.children.splice(i, 0, doctype);
          return doctype;
        }
      }
      doc.children.push(doctype);
      return doctype;
    };

    XMLNode.prototype.up = function() {
      if (this.isRoot) {
        throw new Error("The root node has no parent. Use doc() if you need to get the document object.");
      }
      return this.parent;
    };

    XMLNode.prototype.root = function() {
      var node;
      node = this;
      while (node) {
        if (node.isDocument) {
          return node.rootObject;
        } else if (node.isRoot) {
          return node;
        } else {
          node = node.parent;
        }
      }
    };

    XMLNode.prototype.document = function() {
      var node;
      node = this;
      while (node) {
        if (node.isDocument) {
          return node;
        } else {
          node = node.parent;
        }
      }
    };

    XMLNode.prototype.end = function(options) {
      return this.document().end(options);
    };

    XMLNode.prototype.prev = function() {
      var i;
      i = this.parent.children.indexOf(this);
      if (i < 1) {
        throw new Error("Already at the first node");
      }
      return this.parent.children[i - 1];
    };

    XMLNode.prototype.next = function() {
      var i;
      i = this.parent.children.indexOf(this);
      if (i === -1 || i === this.parent.children.length - 1) {
        throw new Error("Already at the last node");
      }
      return this.parent.children[i + 1];
    };

    XMLNode.prototype.importDocument = function(doc) {
      var clonedRoot;
      clonedRoot = doc.root().clone();
      clonedRoot.parent = this;
      clonedRoot.isRoot = false;
      this.children.push(clonedRoot);
      return this;
    };

    XMLNode.prototype.ele = function(name, attributes, text) {
      return this.element(name, attributes, text);
    };

    XMLNode.prototype.nod = function(name, attributes, text) {
      return this.node(name, attributes, text);
    };

    XMLNode.prototype.txt = function(value) {
      return this.text(value);
    };

    XMLNode.prototype.dat = function(value) {
      return this.cdata(value);
    };

    XMLNode.prototype.com = function(value) {
      return this.comment(value);
    };

    XMLNode.prototype.ins = function(target, value) {
      return this.instruction(target, value);
    };

    XMLNode.prototype.doc = function() {
      return this.document();
    };

    XMLNode.prototype.dec = function(version, encoding, standalone) {
      return this.declaration(version, encoding, standalone);
    };

    XMLNode.prototype.dtd = function(pubID, sysID) {
      return this.doctype(pubID, sysID);
    };

    XMLNode.prototype.e = function(name, attributes, text) {
      return this.element(name, attributes, text);
    };

    XMLNode.prototype.n = function(name, attributes, text) {
      return this.node(name, attributes, text);
    };

    XMLNode.prototype.t = function(value) {
      return this.text(value);
    };

    XMLNode.prototype.d = function(value) {
      return this.cdata(value);
    };

    XMLNode.prototype.c = function(value) {
      return this.comment(value);
    };

    XMLNode.prototype.r = function(value) {
      return this.raw(value);
    };

    XMLNode.prototype.i = function(target, value) {
      return this.instruction(target, value);
    };

    XMLNode.prototype.u = function() {
      return this.up();
    };

    XMLNode.prototype.importXMLBuilder = function(doc) {
      return this.importDocument(doc);
    };

    return XMLNode;

  })();

}).call(this);


/***/ }),

/***/ "../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLProcessingInstruction.js":
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.12.6
(function() {
  var XMLNode, XMLProcessingInstruction,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  XMLNode = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLNode.js");

  module.exports = XMLProcessingInstruction = (function(superClass) {
    extend(XMLProcessingInstruction, superClass);

    function XMLProcessingInstruction(parent, target, value) {
      XMLProcessingInstruction.__super__.constructor.call(this, parent);
      if (target == null) {
        throw new Error("Missing instruction target");
      }
      this.target = this.stringify.insTarget(target);
      if (value) {
        this.value = this.stringify.insValue(value);
      }
    }

    XMLProcessingInstruction.prototype.clone = function() {
      return Object.create(this);
    };

    XMLProcessingInstruction.prototype.toString = function(options) {
      return this.options.writer.set(options).processingInstruction(this);
    };

    return XMLProcessingInstruction;

  })(XMLNode);

}).call(this);


/***/ }),

/***/ "../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLRaw.js":
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.12.6
(function() {
  var XMLNode, XMLRaw,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  XMLNode = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLNode.js");

  module.exports = XMLRaw = (function(superClass) {
    extend(XMLRaw, superClass);

    function XMLRaw(parent, text) {
      XMLRaw.__super__.constructor.call(this, parent);
      if (text == null) {
        throw new Error("Missing raw text");
      }
      this.value = this.stringify.raw(text);
    }

    XMLRaw.prototype.clone = function() {
      return Object.create(this);
    };

    XMLRaw.prototype.toString = function(options) {
      return this.options.writer.set(options).raw(this);
    };

    return XMLRaw;

  })(XMLNode);

}).call(this);


/***/ }),

/***/ "../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLStreamWriter.js":
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.12.6
(function() {
  var XMLCData, XMLComment, XMLDTDAttList, XMLDTDElement, XMLDTDEntity, XMLDTDNotation, XMLDeclaration, XMLDocType, XMLElement, XMLProcessingInstruction, XMLRaw, XMLStreamWriter, XMLText, XMLWriterBase,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  XMLDeclaration = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLDeclaration.js");

  XMLDocType = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLDocType.js");

  XMLCData = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLCData.js");

  XMLComment = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLComment.js");

  XMLElement = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLElement.js");

  XMLRaw = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLRaw.js");

  XMLText = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLText.js");

  XMLProcessingInstruction = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLProcessingInstruction.js");

  XMLDTDAttList = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLDTDAttList.js");

  XMLDTDElement = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLDTDElement.js");

  XMLDTDEntity = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLDTDEntity.js");

  XMLDTDNotation = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLDTDNotation.js");

  XMLWriterBase = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLWriterBase.js");

  module.exports = XMLStreamWriter = (function(superClass) {
    extend(XMLStreamWriter, superClass);

    function XMLStreamWriter(stream, options) {
      this.stream = stream;
      XMLStreamWriter.__super__.constructor.call(this, options);
    }

    XMLStreamWriter.prototype.document = function(doc) {
      var child, i, j, len, len1, ref, ref1, results;
      ref = doc.children;
      for (i = 0, len = ref.length; i < len; i++) {
        child = ref[i];
        child.isLastRootNode = false;
      }
      doc.children[doc.children.length - 1].isLastRootNode = true;
      ref1 = doc.children;
      results = [];
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        child = ref1[j];
        switch (false) {
          case !(child instanceof XMLDeclaration):
            results.push(this.declaration(child));
            break;
          case !(child instanceof XMLDocType):
            results.push(this.docType(child));
            break;
          case !(child instanceof XMLComment):
            results.push(this.comment(child));
            break;
          case !(child instanceof XMLProcessingInstruction):
            results.push(this.processingInstruction(child));
            break;
          default:
            results.push(this.element(child));
        }
      }
      return results;
    };

    XMLStreamWriter.prototype.attribute = function(att) {
      return this.stream.write(' ' + att.name + '="' + att.value + '"');
    };

    XMLStreamWriter.prototype.cdata = function(node, level) {
      return this.stream.write(this.space(level) + '<![CDATA[' + node.text + ']]>' + this.endline(node));
    };

    XMLStreamWriter.prototype.comment = function(node, level) {
      return this.stream.write(this.space(level) + '<!-- ' + node.text + ' -->' + this.endline(node));
    };

    XMLStreamWriter.prototype.declaration = function(node, level) {
      this.stream.write(this.space(level));
      this.stream.write('<?xml version="' + node.version + '"');
      if (node.encoding != null) {
        this.stream.write(' encoding="' + node.encoding + '"');
      }
      if (node.standalone != null) {
        this.stream.write(' standalone="' + node.standalone + '"');
      }
      this.stream.write(this.spacebeforeslash + '?>');
      return this.stream.write(this.endline(node));
    };

    XMLStreamWriter.prototype.docType = function(node, level) {
      var child, i, len, ref;
      level || (level = 0);
      this.stream.write(this.space(level));
      this.stream.write('<!DOCTYPE ' + node.root().name);
      if (node.pubID && node.sysID) {
        this.stream.write(' PUBLIC "' + node.pubID + '" "' + node.sysID + '"');
      } else if (node.sysID) {
        this.stream.write(' SYSTEM "' + node.sysID + '"');
      }
      if (node.children.length > 0) {
        this.stream.write(' [');
        this.stream.write(this.endline(node));
        ref = node.children;
        for (i = 0, len = ref.length; i < len; i++) {
          child = ref[i];
          switch (false) {
            case !(child instanceof XMLDTDAttList):
              this.dtdAttList(child, level + 1);
              break;
            case !(child instanceof XMLDTDElement):
              this.dtdElement(child, level + 1);
              break;
            case !(child instanceof XMLDTDEntity):
              this.dtdEntity(child, level + 1);
              break;
            case !(child instanceof XMLDTDNotation):
              this.dtdNotation(child, level + 1);
              break;
            case !(child instanceof XMLCData):
              this.cdata(child, level + 1);
              break;
            case !(child instanceof XMLComment):
              this.comment(child, level + 1);
              break;
            case !(child instanceof XMLProcessingInstruction):
              this.processingInstruction(child, level + 1);
              break;
            default:
              throw new Error("Unknown DTD node type: " + child.constructor.name);
          }
        }
        this.stream.write(']');
      }
      this.stream.write(this.spacebeforeslash + '>');
      return this.stream.write(this.endline(node));
    };

    XMLStreamWriter.prototype.element = function(node, level) {
      var att, child, i, len, name, ref, ref1, space;
      level || (level = 0);
      space = this.space(level);
      this.stream.write(space + '<' + node.name);
      ref = node.attributes;
      for (name in ref) {
        if (!hasProp.call(ref, name)) continue;
        att = ref[name];
        this.attribute(att);
      }
      if (node.children.length === 0 || node.children.every(function(e) {
        return e.value === '';
      })) {
        if (this.allowEmpty) {
          this.stream.write('></' + node.name + '>');
        } else {
          this.stream.write(this.spacebeforeslash + '/>');
        }
      } else if (this.pretty && node.children.length === 1 && (node.children[0].value != null)) {
        this.stream.write('>');
        this.stream.write(node.children[0].value);
        this.stream.write('</' + node.name + '>');
      } else {
        this.stream.write('>' + this.newline);
        ref1 = node.children;
        for (i = 0, len = ref1.length; i < len; i++) {
          child = ref1[i];
          switch (false) {
            case !(child instanceof XMLCData):
              this.cdata(child, level + 1);
              break;
            case !(child instanceof XMLComment):
              this.comment(child, level + 1);
              break;
            case !(child instanceof XMLElement):
              this.element(child, level + 1);
              break;
            case !(child instanceof XMLRaw):
              this.raw(child, level + 1);
              break;
            case !(child instanceof XMLText):
              this.text(child, level + 1);
              break;
            case !(child instanceof XMLProcessingInstruction):
              this.processingInstruction(child, level + 1);
              break;
            default:
              throw new Error("Unknown XML node type: " + child.constructor.name);
          }
        }
        this.stream.write(space + '</' + node.name + '>');
      }
      return this.stream.write(this.endline(node));
    };

    XMLStreamWriter.prototype.processingInstruction = function(node, level) {
      this.stream.write(this.space(level) + '<?' + node.target);
      if (node.value) {
        this.stream.write(' ' + node.value);
      }
      return this.stream.write(this.spacebeforeslash + '?>' + this.endline(node));
    };

    XMLStreamWriter.prototype.raw = function(node, level) {
      return this.stream.write(this.space(level) + node.value + this.endline(node));
    };

    XMLStreamWriter.prototype.text = function(node, level) {
      return this.stream.write(this.space(level) + node.value + this.endline(node));
    };

    XMLStreamWriter.prototype.dtdAttList = function(node, level) {
      this.stream.write(this.space(level) + '<!ATTLIST ' + node.elementName + ' ' + node.attributeName + ' ' + node.attributeType);
      if (node.defaultValueType !== '#DEFAULT') {
        this.stream.write(' ' + node.defaultValueType);
      }
      if (node.defaultValue) {
        this.stream.write(' "' + node.defaultValue + '"');
      }
      return this.stream.write(this.spacebeforeslash + '>' + this.endline(node));
    };

    XMLStreamWriter.prototype.dtdElement = function(node, level) {
      this.stream.write(this.space(level) + '<!ELEMENT ' + node.name + ' ' + node.value);
      return this.stream.write(this.spacebeforeslash + '>' + this.endline(node));
    };

    XMLStreamWriter.prototype.dtdEntity = function(node, level) {
      this.stream.write(this.space(level) + '<!ENTITY');
      if (node.pe) {
        this.stream.write(' %');
      }
      this.stream.write(' ' + node.name);
      if (node.value) {
        this.stream.write(' "' + node.value + '"');
      } else {
        if (node.pubID && node.sysID) {
          this.stream.write(' PUBLIC "' + node.pubID + '" "' + node.sysID + '"');
        } else if (node.sysID) {
          this.stream.write(' SYSTEM "' + node.sysID + '"');
        }
        if (node.nData) {
          this.stream.write(' NDATA ' + node.nData);
        }
      }
      return this.stream.write(this.spacebeforeslash + '>' + this.endline(node));
    };

    XMLStreamWriter.prototype.dtdNotation = function(node, level) {
      this.stream.write(this.space(level) + '<!NOTATION ' + node.name);
      if (node.pubID && node.sysID) {
        this.stream.write(' PUBLIC "' + node.pubID + '" "' + node.sysID + '"');
      } else if (node.pubID) {
        this.stream.write(' PUBLIC "' + node.pubID + '"');
      } else if (node.sysID) {
        this.stream.write(' SYSTEM "' + node.sysID + '"');
      }
      return this.stream.write(this.spacebeforeslash + '>' + this.endline(node));
    };

    XMLStreamWriter.prototype.endline = function(node) {
      if (!node.isLastRootNode) {
        return this.newline;
      } else {
        return '';
      }
    };

    return XMLStreamWriter;

  })(XMLWriterBase);

}).call(this);


/***/ }),

/***/ "../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLStringWriter.js":
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.12.6
(function() {
  var XMLCData, XMLComment, XMLDTDAttList, XMLDTDElement, XMLDTDEntity, XMLDTDNotation, XMLDeclaration, XMLDocType, XMLElement, XMLProcessingInstruction, XMLRaw, XMLStringWriter, XMLText, XMLWriterBase,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  XMLDeclaration = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLDeclaration.js");

  XMLDocType = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLDocType.js");

  XMLCData = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLCData.js");

  XMLComment = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLComment.js");

  XMLElement = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLElement.js");

  XMLRaw = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLRaw.js");

  XMLText = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLText.js");

  XMLProcessingInstruction = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLProcessingInstruction.js");

  XMLDTDAttList = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLDTDAttList.js");

  XMLDTDElement = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLDTDElement.js");

  XMLDTDEntity = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLDTDEntity.js");

  XMLDTDNotation = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLDTDNotation.js");

  XMLWriterBase = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLWriterBase.js");

  module.exports = XMLStringWriter = (function(superClass) {
    extend(XMLStringWriter, superClass);

    function XMLStringWriter(options) {
      XMLStringWriter.__super__.constructor.call(this, options);
    }

    XMLStringWriter.prototype.document = function(doc) {
      var child, i, len, r, ref;
      this.textispresent = false;
      r = '';
      ref = doc.children;
      for (i = 0, len = ref.length; i < len; i++) {
        child = ref[i];
        r += (function() {
          switch (false) {
            case !(child instanceof XMLDeclaration):
              return this.declaration(child);
            case !(child instanceof XMLDocType):
              return this.docType(child);
            case !(child instanceof XMLComment):
              return this.comment(child);
            case !(child instanceof XMLProcessingInstruction):
              return this.processingInstruction(child);
            default:
              return this.element(child, 0);
          }
        }).call(this);
      }
      if (this.pretty && r.slice(-this.newline.length) === this.newline) {
        r = r.slice(0, -this.newline.length);
      }
      return r;
    };

    XMLStringWriter.prototype.attribute = function(att) {
      return ' ' + att.name + '="' + att.value + '"';
    };

    XMLStringWriter.prototype.cdata = function(node, level) {
      return this.space(level) + '<![CDATA[' + node.text + ']]>' + this.newline;
    };

    XMLStringWriter.prototype.comment = function(node, level) {
      return this.space(level) + '<!-- ' + node.text + ' -->' + this.newline;
    };

    XMLStringWriter.prototype.declaration = function(node, level) {
      var r;
      r = this.space(level);
      r += '<?xml version="' + node.version + '"';
      if (node.encoding != null) {
        r += ' encoding="' + node.encoding + '"';
      }
      if (node.standalone != null) {
        r += ' standalone="' + node.standalone + '"';
      }
      r += this.spacebeforeslash + '?>';
      r += this.newline;
      return r;
    };

    XMLStringWriter.prototype.docType = function(node, level) {
      var child, i, len, r, ref;
      level || (level = 0);
      r = this.space(level);
      r += '<!DOCTYPE ' + node.root().name;
      if (node.pubID && node.sysID) {
        r += ' PUBLIC "' + node.pubID + '" "' + node.sysID + '"';
      } else if (node.sysID) {
        r += ' SYSTEM "' + node.sysID + '"';
      }
      if (node.children.length > 0) {
        r += ' [';
        r += this.newline;
        ref = node.children;
        for (i = 0, len = ref.length; i < len; i++) {
          child = ref[i];
          r += (function() {
            switch (false) {
              case !(child instanceof XMLDTDAttList):
                return this.dtdAttList(child, level + 1);
              case !(child instanceof XMLDTDElement):
                return this.dtdElement(child, level + 1);
              case !(child instanceof XMLDTDEntity):
                return this.dtdEntity(child, level + 1);
              case !(child instanceof XMLDTDNotation):
                return this.dtdNotation(child, level + 1);
              case !(child instanceof XMLCData):
                return this.cdata(child, level + 1);
              case !(child instanceof XMLComment):
                return this.comment(child, level + 1);
              case !(child instanceof XMLProcessingInstruction):
                return this.processingInstruction(child, level + 1);
              default:
                throw new Error("Unknown DTD node type: " + child.constructor.name);
            }
          }).call(this);
        }
        r += ']';
      }
      r += this.spacebeforeslash + '>';
      r += this.newline;
      return r;
    };

    XMLStringWriter.prototype.element = function(node, level) {
      var att, child, i, j, len, len1, name, r, ref, ref1, ref2, space, textispresentwasset;
      level || (level = 0);
      textispresentwasset = false;
      if (this.textispresent) {
        this.newline = '';
        this.pretty = false;
      } else {
        this.newline = this.newlinedefault;
        this.pretty = this.prettydefault;
      }
      space = this.space(level);
      r = '';
      r += space + '<' + node.name;
      ref = node.attributes;
      for (name in ref) {
        if (!hasProp.call(ref, name)) continue;
        att = ref[name];
        r += this.attribute(att);
      }
      if (node.children.length === 0 || node.children.every(function(e) {
        return e.value === '';
      })) {
        if (this.allowEmpty) {
          r += '></' + node.name + '>' + this.newline;
        } else {
          r += this.spacebeforeslash + '/>' + this.newline;
        }
      } else if (this.pretty && node.children.length === 1 && (node.children[0].value != null)) {
        r += '>';
        r += node.children[0].value;
        r += '</' + node.name + '>' + this.newline;
      } else {
        if (this.dontprettytextnodes) {
          ref1 = node.children;
          for (i = 0, len = ref1.length; i < len; i++) {
            child = ref1[i];
            if (child.value != null) {
              this.textispresent++;
              textispresentwasset = true;
              break;
            }
          }
        }
        if (this.textispresent) {
          this.newline = '';
          this.pretty = false;
          space = this.space(level);
        }
        r += '>' + this.newline;
        ref2 = node.children;
        for (j = 0, len1 = ref2.length; j < len1; j++) {
          child = ref2[j];
          r += (function() {
            switch (false) {
              case !(child instanceof XMLCData):
                return this.cdata(child, level + 1);
              case !(child instanceof XMLComment):
                return this.comment(child, level + 1);
              case !(child instanceof XMLElement):
                return this.element(child, level + 1);
              case !(child instanceof XMLRaw):
                return this.raw(child, level + 1);
              case !(child instanceof XMLText):
                return this.text(child, level + 1);
              case !(child instanceof XMLProcessingInstruction):
                return this.processingInstruction(child, level + 1);
              default:
                throw new Error("Unknown XML node type: " + child.constructor.name);
            }
          }).call(this);
        }
        if (textispresentwasset) {
          this.textispresent--;
        }
        if (!this.textispresent) {
          this.newline = this.newlinedefault;
          this.pretty = this.prettydefault;
        }
        r += space + '</' + node.name + '>' + this.newline;
      }
      return r;
    };

    XMLStringWriter.prototype.processingInstruction = function(node, level) {
      var r;
      r = this.space(level) + '<?' + node.target;
      if (node.value) {
        r += ' ' + node.value;
      }
      r += this.spacebeforeslash + '?>' + this.newline;
      return r;
    };

    XMLStringWriter.prototype.raw = function(node, level) {
      return this.space(level) + node.value + this.newline;
    };

    XMLStringWriter.prototype.text = function(node, level) {
      return this.space(level) + node.value + this.newline;
    };

    XMLStringWriter.prototype.dtdAttList = function(node, level) {
      var r;
      r = this.space(level) + '<!ATTLIST ' + node.elementName + ' ' + node.attributeName + ' ' + node.attributeType;
      if (node.defaultValueType !== '#DEFAULT') {
        r += ' ' + node.defaultValueType;
      }
      if (node.defaultValue) {
        r += ' "' + node.defaultValue + '"';
      }
      r += this.spacebeforeslash + '>' + this.newline;
      return r;
    };

    XMLStringWriter.prototype.dtdElement = function(node, level) {
      return this.space(level) + '<!ELEMENT ' + node.name + ' ' + node.value + this.spacebeforeslash + '>' + this.newline;
    };

    XMLStringWriter.prototype.dtdEntity = function(node, level) {
      var r;
      r = this.space(level) + '<!ENTITY';
      if (node.pe) {
        r += ' %';
      }
      r += ' ' + node.name;
      if (node.value) {
        r += ' "' + node.value + '"';
      } else {
        if (node.pubID && node.sysID) {
          r += ' PUBLIC "' + node.pubID + '" "' + node.sysID + '"';
        } else if (node.sysID) {
          r += ' SYSTEM "' + node.sysID + '"';
        }
        if (node.nData) {
          r += ' NDATA ' + node.nData;
        }
      }
      r += this.spacebeforeslash + '>' + this.newline;
      return r;
    };

    XMLStringWriter.prototype.dtdNotation = function(node, level) {
      var r;
      r = this.space(level) + '<!NOTATION ' + node.name;
      if (node.pubID && node.sysID) {
        r += ' PUBLIC "' + node.pubID + '" "' + node.sysID + '"';
      } else if (node.pubID) {
        r += ' PUBLIC "' + node.pubID + '"';
      } else if (node.sysID) {
        r += ' SYSTEM "' + node.sysID + '"';
      }
      r += this.spacebeforeslash + '>' + this.newline;
      return r;
    };

    XMLStringWriter.prototype.openNode = function(node, level) {
      var att, name, r, ref;
      level || (level = 0);
      if (node instanceof XMLElement) {
        r = this.space(level) + '<' + node.name;
        ref = node.attributes;
        for (name in ref) {
          if (!hasProp.call(ref, name)) continue;
          att = ref[name];
          r += this.attribute(att);
        }
        r += (node.children ? '>' : '/>') + this.newline;
        return r;
      } else {
        r = this.space(level) + '<!DOCTYPE ' + node.rootNodeName;
        if (node.pubID && node.sysID) {
          r += ' PUBLIC "' + node.pubID + '" "' + node.sysID + '"';
        } else if (node.sysID) {
          r += ' SYSTEM "' + node.sysID + '"';
        }
        r += (node.children ? ' [' : '>') + this.newline;
        return r;
      }
    };

    XMLStringWriter.prototype.closeNode = function(node, level) {
      level || (level = 0);
      switch (false) {
        case !(node instanceof XMLElement):
          return this.space(level) + '</' + node.name + '>' + this.newline;
        case !(node instanceof XMLDocType):
          return this.space(level) + ']>' + this.newline;
      }
    };

    return XMLStringWriter;

  })(XMLWriterBase);

}).call(this);


/***/ }),

/***/ "../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLStringifier.js":
/***/ (function(module, exports) {

// Generated by CoffeeScript 1.12.6
(function() {
  var XMLStringifier,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    hasProp = {}.hasOwnProperty;

  module.exports = XMLStringifier = (function() {
    function XMLStringifier(options) {
      this.assertLegalChar = bind(this.assertLegalChar, this);
      var key, ref, value;
      options || (options = {});
      this.noDoubleEncoding = options.noDoubleEncoding;
      ref = options.stringify || {};
      for (key in ref) {
        if (!hasProp.call(ref, key)) continue;
        value = ref[key];
        this[key] = value;
      }
    }

    XMLStringifier.prototype.eleName = function(val) {
      val = '' + val || '';
      return this.assertLegalChar(val);
    };

    XMLStringifier.prototype.eleText = function(val) {
      val = '' + val || '';
      return this.assertLegalChar(this.elEscape(val));
    };

    XMLStringifier.prototype.cdata = function(val) {
      val = '' + val || '';
      val = val.replace(']]>', ']]]]><![CDATA[>');
      return this.assertLegalChar(val);
    };

    XMLStringifier.prototype.comment = function(val) {
      val = '' + val || '';
      if (val.match(/--/)) {
        throw new Error("Comment text cannot contain double-hypen: " + val);
      }
      return this.assertLegalChar(val);
    };

    XMLStringifier.prototype.raw = function(val) {
      return '' + val || '';
    };

    XMLStringifier.prototype.attName = function(val) {
      return val = '' + val || '';
    };

    XMLStringifier.prototype.attValue = function(val) {
      val = '' + val || '';
      return this.attEscape(val);
    };

    XMLStringifier.prototype.insTarget = function(val) {
      return '' + val || '';
    };

    XMLStringifier.prototype.insValue = function(val) {
      val = '' + val || '';
      if (val.match(/\?>/)) {
        throw new Error("Invalid processing instruction value: " + val);
      }
      return val;
    };

    XMLStringifier.prototype.xmlVersion = function(val) {
      val = '' + val || '';
      if (!val.match(/1\.[0-9]+/)) {
        throw new Error("Invalid version number: " + val);
      }
      return val;
    };

    XMLStringifier.prototype.xmlEncoding = function(val) {
      val = '' + val || '';
      if (!val.match(/^[A-Za-z](?:[A-Za-z0-9._-]|-)*$/)) {
        throw new Error("Invalid encoding: " + val);
      }
      return val;
    };

    XMLStringifier.prototype.xmlStandalone = function(val) {
      if (val) {
        return "yes";
      } else {
        return "no";
      }
    };

    XMLStringifier.prototype.dtdPubID = function(val) {
      return '' + val || '';
    };

    XMLStringifier.prototype.dtdSysID = function(val) {
      return '' + val || '';
    };

    XMLStringifier.prototype.dtdElementValue = function(val) {
      return '' + val || '';
    };

    XMLStringifier.prototype.dtdAttType = function(val) {
      return '' + val || '';
    };

    XMLStringifier.prototype.dtdAttDefault = function(val) {
      if (val != null) {
        return '' + val || '';
      } else {
        return val;
      }
    };

    XMLStringifier.prototype.dtdEntityValue = function(val) {
      return '' + val || '';
    };

    XMLStringifier.prototype.dtdNData = function(val) {
      return '' + val || '';
    };

    XMLStringifier.prototype.convertAttKey = '@';

    XMLStringifier.prototype.convertPIKey = '?';

    XMLStringifier.prototype.convertTextKey = '#text';

    XMLStringifier.prototype.convertCDataKey = '#cdata';

    XMLStringifier.prototype.convertCommentKey = '#comment';

    XMLStringifier.prototype.convertRawKey = '#raw';

    XMLStringifier.prototype.assertLegalChar = function(str) {
      var res;
      res = str.match(/[\0\uFFFE\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/);
      if (res) {
        throw new Error("Invalid character in string: " + str + " at index " + res.index);
      }
      return str;
    };

    XMLStringifier.prototype.elEscape = function(str) {
      var ampregex;
      ampregex = this.noDoubleEncoding ? /(?!&\S+;)&/g : /&/g;
      return str.replace(ampregex, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\r/g, '&#xD;');
    };

    XMLStringifier.prototype.attEscape = function(str) {
      var ampregex;
      ampregex = this.noDoubleEncoding ? /(?!&\S+;)&/g : /&/g;
      return str.replace(ampregex, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;').replace(/\t/g, '&#x9;').replace(/\n/g, '&#xA;').replace(/\r/g, '&#xD;');
    };

    return XMLStringifier;

  })();

}).call(this);


/***/ }),

/***/ "../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLText.js":
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.12.6
(function() {
  var XMLNode, XMLText,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  XMLNode = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLNode.js");

  module.exports = XMLText = (function(superClass) {
    extend(XMLText, superClass);

    function XMLText(parent, text) {
      XMLText.__super__.constructor.call(this, parent);
      if (text == null) {
        throw new Error("Missing element text");
      }
      this.value = this.stringify.eleText(text);
    }

    XMLText.prototype.clone = function() {
      return Object.create(this);
    };

    XMLText.prototype.toString = function(options) {
      return this.options.writer.set(options).text(this);
    };

    return XMLText;

  })(XMLNode);

}).call(this);


/***/ }),

/***/ "../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLWriterBase.js":
/***/ (function(module, exports) {

// Generated by CoffeeScript 1.12.6
(function() {
  var XMLWriterBase,
    hasProp = {}.hasOwnProperty;

  module.exports = XMLWriterBase = (function() {
    function XMLWriterBase(options) {
      var key, ref, ref1, ref2, ref3, ref4, ref5, ref6, value;
      options || (options = {});
      this.pretty = options.pretty || false;
      this.allowEmpty = (ref = options.allowEmpty) != null ? ref : false;
      if (this.pretty) {
        this.indent = (ref1 = options.indent) != null ? ref1 : '  ';
        this.newline = (ref2 = options.newline) != null ? ref2 : '\n';
        this.offset = (ref3 = options.offset) != null ? ref3 : 0;
        this.dontprettytextnodes = (ref4 = options.dontprettytextnodes) != null ? ref4 : 0;
      } else {
        this.indent = '';
        this.newline = '';
        this.offset = 0;
        this.dontprettytextnodes = 0;
      }
      this.spacebeforeslash = (ref5 = options.spacebeforeslash) != null ? ref5 : '';
      if (this.spacebeforeslash === true) {
        this.spacebeforeslash = ' ';
      }
      this.newlinedefault = this.newline;
      this.prettydefault = this.pretty;
      ref6 = options.writer || {};
      for (key in ref6) {
        if (!hasProp.call(ref6, key)) continue;
        value = ref6[key];
        this[key] = value;
      }
    }

    XMLWriterBase.prototype.set = function(options) {
      var key, ref, value;
      options || (options = {});
      if ("pretty" in options) {
        this.pretty = options.pretty;
      }
      if ("allowEmpty" in options) {
        this.allowEmpty = options.allowEmpty;
      }
      if (this.pretty) {
        this.indent = "indent" in options ? options.indent : '  ';
        this.newline = "newline" in options ? options.newline : '\n';
        this.offset = "offset" in options ? options.offset : 0;
        this.dontprettytextnodes = "dontprettytextnodes" in options ? options.dontprettytextnodes : 0;
      } else {
        this.indent = '';
        this.newline = '';
        this.offset = 0;
        this.dontprettytextnodes = 0;
      }
      this.spacebeforeslash = "spacebeforeslash" in options ? options.spacebeforeslash : '';
      if (this.spacebeforeslash === true) {
        this.spacebeforeslash = ' ';
      }
      this.newlinedefault = this.newline;
      this.prettydefault = this.pretty;
      ref = options.writer || {};
      for (key in ref) {
        if (!hasProp.call(ref, key)) continue;
        value = ref[key];
        this[key] = value;
      }
      return this;
    };

    XMLWriterBase.prototype.space = function(level) {
      var indent;
      if (this.pretty) {
        indent = (level || 0) + this.offset + 1;
        if (indent > 0) {
          return new Array(indent).join(this.indent);
        } else {
          return '';
        }
      } else {
        return '';
      }
    };

    return XMLWriterBase;

  })();

}).call(this);


/***/ }),

/***/ "../node_modules/xml2js/node_modules/xmlbuilder/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.12.6
(function() {
  var XMLDocument, XMLDocumentCB, XMLStreamWriter, XMLStringWriter, assign, isFunction, ref;

  ref = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/Utility.js"), assign = ref.assign, isFunction = ref.isFunction;

  XMLDocument = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLDocument.js");

  XMLDocumentCB = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLDocumentCB.js");

  XMLStringWriter = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLStringWriter.js");

  XMLStreamWriter = __webpack_require__("../node_modules/xml2js/node_modules/xmlbuilder/lib/XMLStreamWriter.js");

  module.exports.create = function(name, xmldec, doctype, options) {
    var doc, root;
    if (name == null) {
      throw new Error("Root element needs a name");
    }
    options = assign({}, xmldec, doctype, options);
    doc = new XMLDocument(options);
    root = doc.element(name);
    if (!options.headless) {
      doc.declaration(options);
      if ((options.pubID != null) || (options.sysID != null)) {
        doc.doctype(options);
      }
    }
    return root;
  };

  module.exports.begin = function(options, onData, onEnd) {
    var ref1;
    if (isFunction(options)) {
      ref1 = [options, onData], onData = ref1[0], onEnd = ref1[1];
      options = {};
    }
    if (onData) {
      return new XMLDocumentCB(options, onData, onEnd);
    } else {
      return new XMLDocument(options);
    }
  };

  module.exports.stringWriter = function(options) {
    return new XMLStringWriter(options);
  };

  module.exports.streamWriter = function(stream, options) {
    return new XMLStreamWriter(stream, options);
  };

}).call(this);


/***/ }),

/***/ "./apiEndpoints.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var apiBaseRoute = exports.apiBaseRoute = "https://fleet-mobile-api.preview.decisivapps.com/api";

exports.default = {
  //---------------------------------------------------------------------------

  // /api/assets GET
  assets: function assets() {
    return apiBaseRoute + "/assets";
  },

  // /api/assets/{assetId} GET PATCH
  asset: function asset(_ref) {
    var assetId = _ref.assetId;
    return apiBaseRoute + "/assets/" + assetId;
  },

  // /api/assets/{assetId}/scheduled_maintenances GET PATCH
  assetScheduledMaintenances: function assetScheduledMaintenances(_ref2) {
    var assetId = _ref2.assetId;
    return apiBaseRoute + "/assets/" + assetId + "/scheduled_maintenances";
  },

  // /api/assets/{assetId}/cases GET
  assetCases: function assetCases(_ref3) {
    var assetId = _ref3.assetId;
    return apiBaseRoute + "/assets/" + assetId + "/cases";
  },

  // /api/assets/{assetId}/warranty GET
  assetWarranty: function assetWarranty(_ref4) {
    var assetId = _ref4.assetId;
    return apiBaseRoute + "/assets/" + assetId + "/warranty";
  },

  // /api/assets/{assetId}/faults GET
  assetFaults: function assetFaults(_ref5) {
    var assetId = _ref5.assetId;
    return apiBaseRoute + "/assets/" + assetId + "/faults";
  },

  //---------------------------------------------------------------------------

  // /api/cases GET POST
  cases: function cases() {
    return apiBaseRoute + "/cases";
  },

  // /api/cases/{caseId} GET
  case: function _case(_ref6) {
    var caseId = _ref6.caseId;
    return apiBaseRoute + "/cases/" + caseId;
  },

  // /api/cases/{caseId}/versions/{versionId} PATCH
  caseVersion: function caseVersion(_ref7) {
    var caseId = _ref7.caseId,
        versionId = _ref7.versionId;
    return apiBaseRoute + "/cases/" + caseId + "/versions/" + versionId;
  },

  // /api/cases/{caseId}/recipients GET
  caseRecipients: function caseRecipients(_ref8) {
    var caseId = _ref8.caseId;
    return apiBaseRoute + "/cases/" + caseId + "/recipients";
  },

  // /api/cases/{caseId}/notes GET POST
  caseNotes: function caseNotes(_ref9) {
    var caseId = _ref9.caseId;
    return apiBaseRoute + "/cases/" + caseId + "/notes";
  },

  // /api/cases/{caseId}/notes/{noteId} GET PATCH
  caseNote: function caseNote(_ref10) {
    var caseId = _ref10.caseId,
        noteId = _ref10.noteId;
    return apiBaseRoute + "/cases/" + caseId + "/notes/" + noteId;
  },

  // /api/cases/{caseId}/faults GET POST
  caseFaults: function caseFaults(_ref11) {
    var caseId = _ref11.caseId;
    return apiBaseRoute + "/cases/" + caseId + "/faults";
  },

  //---------------------------------------------------------------------------

  // /api/messages/status GET
  messagesStatus: function messagesStatus() {
    return apiBaseRoute + "/messages/status";
  },

  // /api/profile GET POST
  profile: function profile() {
    return apiBaseRoute + "/profile";
  },

  // /api/password POST
  password: function password() {
    return apiBaseRoute + "/password";
  },

  // /api/password/reset POST
  passwordReset: function passwordReset() {
    return apiBaseRoute + "/password/reset";
  },

  // /api/dashboard GET
  dashboard: function dashboard() {
    return apiBaseRoute + "/dashboard";
  },

  //---------------------------------------------------------------------------

  // /api/service_providers GET
  serviceProviders: function serviceProviders() {
    return apiBaseRoute + "/service_providers";
  },

  // /api/service_providers/{serviceProviderId} GET
  serviceProvider: function serviceProvider(_ref12) {
    var serviceProviderId = _ref12.serviceProviderId;
    return apiBaseRoute + "/service_providers/" + serviceProviderId;
  },

  //---------------------------------------------------------------------------

  // /api/service_requests GET
  serviceRequests: function serviceRequests() {
    return apiBaseRoute + "/service_requests";
  },

  // /api/service_requests/{serviceRequestId} GET PATCH
  serviceRequest: function serviceRequest(_ref13) {
    var serviceRequestId = _ref13.serviceRequestId;
    return apiBaseRoute + "/service_requests/" + serviceRequestId;
  },

  //---------------------------------------------------------------------------

  // /api/data_lists GET
  dataLists: function dataLists() {
    return apiBaseRoute + "/data_lists";
  }

};

/***/ }),

/***/ "./brands/logos/decisiv.png":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAqkAAACQCAYAAAArzPKLAAAAAXNSR0IArs4c6QAAAAlwSFlzAAAuIwAALiMBeKU/dgAAAVlpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IlhNUCBDb3JlIDUuNC4wIj4KICAgPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICAgICAgPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIKICAgICAgICAgICAgeG1sbnM6dGlmZj0iaHR0cDovL25zLmFkb2JlLmNvbS90aWZmLzEuMC8iPgogICAgICAgICA8dGlmZjpPcmllbnRhdGlvbj4xPC90aWZmOk9yaWVudGF0aW9uPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgPC9yZGY6UkRGPgo8L3g6eG1wbWV0YT4KTMInWQAAMcVJREFUeAHtXVt247i1BSn9p+4I7J7ALWcEVkZg5zfLTisjKOe/W6128t/uEbQ65XV/4xpB5BHENYLII7ju37ss8p4NWLYk60FS4AFIbqxySSTxONiAwH0ODoDE/Gl8YlLzwcQc+mZmJuNZzCJSNiJABIgAESACRIAIEAF/CCTmcjSV7E79Zama01cp7em1xNw8COF213n+ZPLeg31GkvsKEb8QASJABIgAESACRKAJCPSbIOQOGT+uPEuEbOeLO4kxSeYu5vJxOTLy7DeTCJEFscVnns+EyM7M7XjqIvJ/IkAEiAARIAJEgAgQgRgQaLol1SeGj5LZTMjr1GTZg+n3p+Ji8Gal9VkS8yICRIAIEAEiQASIABHYiQBJ6k54zKNYX6cmyaem1wNpne2OzqdEgAgQASJABIgAESACPhAgSS2HIkjrncnSifmfsfN3LZeesYkAESACRIAIEAEiQAQKIECSWgCkLVEcYe2nN7SwbkGIt4kAESACRIAIEAEiUBGBtGI6JjPmSPxXP5l59h+7Q8Ll90OCQgSIABEgAkSACBABIuAHAZJUPzjKFl7JL0JWZ4Zk1Q+izIUIEAEiQASIABHoNAIkqX6b/4hk1S+gzI0IEAEiQASIABHoJgIkqfW0+xtZvRgP6imCuRIBIkAEiAARIAJEoL0IkKTW27bit5r9S9wA7sxw/KHeopg7ESACRIAIEAEiQATagwBJqk5bnpnnbGYuvjvXKY6lEAEiQASIABEgAkSg2QiQpGq1X2J+Z5L0n7SqagHOcogAESACRIAIEIEmI0CSqt96Z7Jt1YP50/hEv2iWSASIABEgAkSACBCBZiBAkhqmnY5ML/s3t6sKAz5LJQJEgAgQASJABOJHgCQ1aBvJ3qoXo0lQEVg4ESACRIAIEAEiQAQiRIAkNXSjJOZbe2IVV/+HbgmWTwSIABEgAkSACESEAElqHI1xKn6qU25TFUdjUAoiQASIABEgAkQgPAIkqeHbYCHBRxLVBRT8JAJEgAgQASJABLqOAElqXD2ARDWu9qA0RIAIEAEiQASIQCAESFIDAb+jWBLVHeDwEREgAkSACBABItANBEhS42xnENVJnKJRKiJABIgAESACRIAI1I8ASWr9GFct4YzbU1WFjumIABEgAkSACBCBpiPQD1CBr2aeDs3/jB92lo0TmVLzYXOc5w8mTd9ObMrN4CXesXwevXxv/ofdnur7qfn8t0nzK8MaEAEiQASIABEgAkSgOAKJ3aPTmNPiSQ6OeW8+Xw8OzmVXBsPxsXk2xybNBiaTz8SA0H7clSTqZ/P093tJfdQVoHBEgAgQASJABIgAESiHQAhLajkJq8SejGeSDH9T+XMBm+U/C1kFcc3NudxsDmlN7R6qx2YyflpUh59EgAgQASJABIgAEWgzAu0kqZtazBG8qTzC39hunD+fC1lNQFjP5C/ekJjfyUKqOxFwEK+QlIwIEAEiQASIABEgAv4QaOd0f1l8YGV1hPVKkkZsYc3/Kv6pN2Wr15r4Cz/lZC4uHMmxrZdz53Df7Y0d/+ViXU+thd2YPH8yee/Bxr4dT3ek4qPQCCzcd8xWX/T9EubmQdr+yUbM85m0/UxcgZ5a40Zz+f1QFG75Uwrz9Kqx2F2MBxYlzKohZLL2wbmE2csC/z1JfDd2NL0vXY6mBerrL8rn68HezP48Gsts5/54ezMqGAHvhdvrYcHYzYp28d25SeS3qhUwzt5eey2vO5bUXY3krKwTiTIxdgDLhjIIfbsrSZBneQIL8J1M+8+ClK9V6KprxokUiz9ZEJe9SJAIyXz7+vJt/0civteLdNLAJnnJ73KE/H6zLx78yBJLYuTHRvK6H1SPMaCE9OYnVgFxL6kPkju2Y5O2QjnpW7uXLXZT2/ckE7S9MY/yN5MypqK8zMxclJd9CzuRKqaQJMfSh0/VRNq6qFVNgv0FWeXmWVy8ZJEt+lMu4whmpRbjyGIssH1rf3YrMfLF7JskxjiyqS9l2YPp9x8iH6/1+swKgDsugFuS/rAjht9HGBuG43Hk7VStzkl6IwmPqiWukCrJJzYVlGaMSeshTSev64X+cT1ef2yvrcIt314WjJOkrqPkiMnUdlq3V2k8P2I37T8RkQfrYjf+2ikH5/ISGQgp+WhJSa5YK/vyksEKAxYKx4vHEZh7ebk9CEG6I2n13B6OlA4EbBCIgWAuBEKw12x3V6Uj+TiScl3b96TtL0ZOaQFxfZa2bxpp9dxUjcjOKrfPA/mtLsaRIyE7b/1JupZCeOtLKBsK1uXoUfrWVJTfqen1pq0kQz6Bvf37ncVMk1w9Z2OpwtBnNYLnBSuqJoZQ9hc7EeXJiZSNv+MXGe7l05j/M3emb9cF/WAuv5+9xrcP5T8olvPsF/mG+BP5MySpQGFTcNbKgbWsJnZjfQw+MYRTadzhu8aNQbKyMtgfkbxQjCxkswSlbAYq8V+Ia/bphbhM5a13Jy8bWLSfVCRoUyHv2jxxtXv5iKaqC6UFxLWX/cC2j6Zl3gvipjSH8nI7s6T0fYzQd4QsY2Yu+XaJtN6ZTKxKVH62tE0+FrxAVnQC2mc4vmrVmK45zW9bCW32EhZT/s5144eVHZ3+PMI7X0JyJf9N8O01QFlYexeQpL6is+ULLKtDmYZ04H3aEkv3dp7ciEzNJEl2Ci5D5xxKZxTLWYOCk/dMflxnVtu7GP0qU4diYRXNn2E7AivEtGFtvqjVettfjr5QWVmAE+AT40gmblmZuWrcOALrVmI+ifLz6cXKSsK63oVgkbscjeW2nnEos+8llNn84GYmTxUr8mZFLV7oR2sEXLjV2bVBmShzq4EkdRWPzVfOYnZlLr6bylTSJPigiBemm54A2WtGwI8mES1pnsEy2Y5grSPpt25qKr8R6+qkVZr4Ia3UZGWkWL2dsvKc3YiVFSTjhlaxYsAdFMv1K4wj7mXW/LFkmbB+FcUH40gzDRAHNeymxMrWVCg82PmnFUEUONWwZEUtXu695QQL90UoCYu1IUt5iNMMQ2EEYDHL0oHEfyycpq6I0MQxYMce4JpwOZpJZ/yXiKqp2WkicyTW1Z9EcZgZTG9AI+xqgNUUK4bn2X+stahp1vKy7Yb6QVnpZf+29bYWjLKZMP5eBDDWXYwmL/3KEdS9iRoX4aOMI7/YceRihNmy48bVwKfAzr9R712L3/Ji0Y7PemjnhX5jDShqBVexooo+lo5FwlODtQl4Z0JJSM3NutQkqeuI7LuGD1EvPZFoovUGDs6aGliILcXjZQ1y6vyKhMR1IGCQy80PnSSrr8pI+k9p6bYqI/s6scwSiDIGkk6yug+r4s+h+D1jxXeEO64Ur0XxmE7x+WQJOYh5p8lqJQtdcazfxUzG72417YY2L0jW/EqL4uWm+R/lgKUr2QJ0aJOlMiO1FkhS1wApdInp/146kLhhiSoG7dgGMMiDl7SznHaDnK53mmWyevn91frjVl0vyGmXlJH9DUiyuh+j/TEWii4UP/ymuhgwxmNWoqszNNrWVPjAWh/6hnY2N4t3riY9puc3EMvi5YsSYpXPl0VUGxYjk6QWR3M1ZixEVVtrWkVh9Wph8eiuJW0VD/tiFTeAy9FD6yxrjkA8dMpSvtq6Ra4cWXXWsA9FEjDOCwKY7u6yorveERYzNE0mUOt1Knpd1VJXNP/1eOqr4tcFOOAafp2aCh2m5zcQy8I1eFNCjkz/vRUV+ZCkFkZzQ0Q0zjwdWmffDY+Vbp1bfw6lwjYW46ynD3aqW/MHslGYKG/Kvq8yDYwXb9ODa+u7FwIhPnQMexGApQD+yl0kGHvBWYsASxCUOvjcM6wigLE1EXcazFTFNoO2KqnfK1jqYLHTC85PUq88fyW5xV/+8tuVUxErapbKrKr5cSWb9Xu5cCiT/0XI7szFyydyLX8ukKQukKj6CR9VbB4dKmDgWvhzhJAB073wF4v6ONkQwGwoEy9evIDhKN7EANcF19ZnTRQ/qMxvBOMuuFIZFIgdheN3ATLPsWQHSPbRqf0dtmGRz76a4jmMQRsW1BRJWjkO/CSbFtAfNI1ERayo8DtdP1lq/R6unUXVIY7vS9ckqT46IkBe1xZ85Fs4D+vPUTi2l4iweGAaE76Imj8ML8IHzeSjOIrLwhp7GkhQQQoX7qxbd9LWP7GtC6O2LeKZJWJcWLWKDwgqfhccS1Zx2XZlcZKxtyuuJNrW1BjXe2zrC6/3FRd9FbGivsp12BeS1MPwe0vttIVQC6mOVK1zIC1z+0Jp61Ywb+1axze8YDBt14Tp/zfrFq2nvvqCbX9x/4APN4OxYxcJarWe4BZWTVXH/2qSHpYqhDX1uUHWVKf0ai5UVtsTnCT1sJ/Oamr4p4YKqdLmvW+khf6Ih7Y1pv9jtoRg+gj7f9K6dWhLb06PxTAxt/9mqf3epQXVB55udgZYtjloW1NxKiIMMk0IOChHM2xZ5FSHCCSpPlGFf2qoaf/EnPusysa8+ELZCMtBNxeWkNgGQ2vlVTw7+yAQG5w41vbXgBR9vpdNqAR5ABuKJBTKJrkRla22tjUVmIZc71EUH6ec6O1NnZtf3xY5FRWyejyS1OrYbU6pr+0t5Kh3yp9WtQXOdXx+tO4TsRBVWPe4urqOdt6WZ1ztv01K3/fd9nmckfGFKwwkOBWxzSGVY8lVQ4D1HmXrp73Iq5+Oy4p4SHyS1EPQ25RWW9tblqGf1WNNtdo5rWrLUNfwPQ6i4ggqfY1raOA9WaL9m7vzw57KvXsMHzoqQu9gqXjjUY6Y/MO7VdQVM4s6GbYpgiVPLxxFfVQqtiLDbIxWULaiolokqXU0bihral7DlL+dStDWXutolEbkCaIyCSYpCWow6F8KPpIp225sUaXtQxe6ZesqH6QBx3Rjh5muBGVLnjHJMFpotRd3qWNPklpP34M11ZgQ0y4fvTp60we1nv6xO9czu5hmdxz/T0lQ/WNaLcejqFw/qtVhdyq3ElnPh263NM18ii2A8uyP5vZ6eNCJP02svb419TTKEwOde9hQrQkDWFFRN1pS62rhbPMRX3UV95rvszl5/X7IF7eoQU4WEufxeMOjiHYv0z8/i5w/2lMrMO217Q9x3MK2L5Iu1HZh+9HE9I3mRt0kqPvbRDdGHK4ftdVZaSeS2uQPnvEXOULyuPX+p7tg1rboJRFuR6V9BKoJM6Pa39UP+OwABLDS/3IEEnV0QC7lk6bZQBJNyydcS+GmnXVlXxNhw6X4XqFuMiXa7z9UWGEoadcCrMW9+UCmdOTPRLQXqPgA/0n6EPpRncGR4W/rLIJ5V0Lgg/k/cywp623/SqIdnOj84BzqzeB+S/Yf5H64hV6wnib5WE7judkiX3duw5p6MfpVjA5aY9eZPYr29ejOCKDOZYssvXAfyqWEJLXORs5lyl97cUBuBgdXCcdfxkLYMDDLwXgmEy2uDsLm8nyQMm6sq8R8fi6EFfUP9zKSwm1w/okntU3n2WnX7JdFcZF/QuGbye9pavJcFk/0ZiYzT4X7hJtilrkjUeIy80HyOZH8TiOssxAkObd66VjACGWsLpJdMJXFNDsDxfdOFN+pKL7TQr81p9iemNwqtufSlzTqcy/WU0ztz6qD37KUsKbOMy2SauSkuLEgOIwCRWdcOFKTJResAwWS1DqBB7HqZZ/qLOJd3vmB0/12oVT207t89W8IKRGrwe3fJmpFO19ilDexPkhucUdIIgP/RMgjxNlzwKrQZ7FIxxqcciJKXj41vR7Iw+wgUd8WlkxX8gFpAnF1iw4/rjzTvRC3FXkRvMmpW7pWaQ5rrdK2l+OskleVlIE3xXZiC3C++1fyvR7CChel9fPPt9esO08wJlyO4Lp1plTpc2vIcO8JpSK3FZOMtz2p4X4wKyrqQpJaQ4u+ZonB7GIkUzQqmrYrFmWBgFR9qWNz7bDBkdPQliRHFgYRkFVZSPXduXf/s7kQVM1+WbxPfZEFIRPv9d1WvmvnqTwe29+NWy07VMMGixFgEar6e91Wr1jvZ+ZYsA0dvgrmA8H8yYsgjrQObV7WwpXguw/l9qvBKYYuf5s9/1tDIE9vTJLpkFSMl/ADxVgRMrgZsE5YUQFzGhLrTpSdBPApe5YXQZXgpvnDWZNgMcB2KqEJ6jJ2IDGfrwdi1f2rWNvgeqAfEhmIfW70786MD9fOmxB0W+l8I1j7J+Sbytt0D0Tx9vpK/j5Ie/9FojxuinbwPfQjLPbrpd+8rM6eHZxnUzJIKo5NvuoH7HupP4K6LhfGLowXWLyJRZ1VA/rH5+sTEtQ9ADolszrOe7J/91jXD/Rd8faG7vZtQa2oqC9J6uZu4O8ufOi0g1s8Va5UkKBcdQphWb5HsRj83k5p+bJuLOfu4zsWK/SFQB/y4qkux9GLBl89h0VKWNlxZnwsYUFOb6+HUVkTHdk49qqc2ClmUcTsymwhw12xnsbS15wcd94sqLvqtVBuy5NV8ZEVggtliaEYArr+kmE397fueF6s9AWxzW6KRawvFklqfdi6nLN0WncR7/LHwpCy4Vk6Y5jp33trPW3ClBZIhbWSiJVDO2Tmyk5HH1puyMMCVmX/+vIyjoucrspo7EpqkEpj4PtWNTxayywstPAtjFURq1q7JqVLzUxV3FWyKv1gR3AKW7c25t8BR+FH2tZUE8yYg4WfmsrLo5rb1Y7GJkndAY6XR33lQRFCu5XLxcWHdU1vK483uTAog/Q17aVtrRx2OvitLnV/gwLhVpdWL8keb6uohW+TFG4dmMp0L5dtseK5j/4JNwTnAlBGrnub5vP1cVQuLGVq4DtuiJml5Tr42P1kOb+i3x1ZxTj74zu3Iev+0dGN+Yvity+etjV1sVvIPrl8Pld/T8vC5QgCSWrdjdCEKb1DyU81DL9Yf7xqacOnsn6z6kT124N8U+HbGjLYl3Ha3DPG0eZwS0E9dges1P+DVcBsP9kdmU9VETiVgzI0rVGrlYMlfdVtCFtLHcdgsVoVtGFX2tZUXb9Q1xi6R6A+xqJYk6Tq/Ba/6hTzWkrxlaXq2pmV8VGm+Iev0jb1CwgILCOawa0uLV+i9r567yXEiurmWE/fy+/uwC0lSwcbierCvxazA02xEm+rZ133Q7g/vatL8pNxiwffPVG58eo29KLING0mSQWkCoXkqv6Tp17cr4pWU/sIVGz/GEkgSdVpiCedYiqUkgU4ojAXgtqWgdntXyjTukqh8urSJJz1CEfQuhXVMyWU6i1mmaha63BHV+pXQbkfYLeTTXJi8eDlaKpKNNbloCKzjshh17d/v5MMHg/LpERqzRlI3SNQo7GiojVIUkv0yVZGrUx6KqMRfEuLypJvSzhPNQngkd03dZssm+47/6lQW04tCGq8itomzPbdA1GFZZgr9fchtfrcKafaM0urMrxdncphGf+RvawnQcnqmzz8djACihZArOPwuTXgrrqrvqcVMdxV55dnJKkFQGptFLeQRm9TYAukHPnYtuB2Jjhk9XdJRNLzcgkCWMshIKyMzoLaLoK6AB/Ttm2ZEVjUSeUzv1EppmghIBsLsuq2+CmakvFiQ8D5gOtZU6u6X5XBTdNVC2N2ZH70JKllOkuT4sLXdG8oS3b2Zrg/QmQ/gP0CF4yBU5L0QnGS6jT94vF91gG+myRxPhFtR17aRKIoaiCrvezf4gbwIIurhmpWsqLyMV5BBBQtgW5rwA8FBasYTdFVKzVxKZCCGElqxW4TfbJip05pkxc9303tBur3p2pFYjsqZwXfX+R8Xs954vtKxoIyZ2HeF5PPO4mAIpEoj6+4xiS/iHX1f4Ww3pGwlgcwaApNJQhjMcbYuoKmqxasqGngHWA24EiSugGUTtzCtJb25v15JIsm6mhgWAzxI1cL6aBYUUl9A+h2AR7tpvXbn/NJ1xFwRKIJSuvZEmF9sLsChNgjs+v9pXT9NZWgGjf319zqClbUCGe++qXbngmagUBmnnYK2psPZPDdGcX7w8Sci2XixHu+sWSYKwqSmEGh0rB5uXIzyx6hw0KyMVK3EcA2dM/Zg7qyXB31j6KIfjRJ9oMstvpN5J6K4/Wd6fV0jlqtLnf3UkIJuhyNpeIaay7cYla3u4A/rOGyN89O/WW4Iye3fuBmR4xgj0hSg0Ffc8F7p1qTQc0SbMoeA4bGoLGp7Prv6ZLBj9ZnbpfmC4tPkv2u/oqvlCBH6Y2nK3d4QQQ2IYCFZxffDcXr7J+bHkd9z81Cwcp6JkTiFyFEsnCShDWqNkvMRJSKH1RkSuwOL3dey8IWV1rvlEitqMCT0/1ee1WDMgt1PGCDIIpe1OfnwU4Z02z3852Jqz7UnGarKiPTRYOAtT4pn9xWT+WX3QKcH2s95TDXogjAv1LPBevU+NwZAlZUraPKI/VFXTQzSeoCiS59uh+AtoWtSwjr1DWVfTp3hRCKCKY+GYhAGQSsf2oriOqi1o6wXoye7B6s9GFd4KL7iVkmzdXqaXblrYK6h+xE7a5CkuqtVzUoo2Ir/xtUoY6KmpvdJNWYU2VkvsToeK+MAYurggCIqvYRw1XkLJMGLgGwhiXZv8QdYGYXXcFAwKCHgKY1FW3to32xbSC2ttIK/XSsVVSVckhSq6BWNs1+MlE2x93x901xBJkG3i0yn1ZC4HhrKh+D5dbMtz0QnzwGIlAVAXvEcKssqstIHFn/SBwagG2tim4ht5wDv5dHQNua+uzBmjqfD0W50ZnpzM2vYliYlQdWLwVJqgbWWh1uUZekxVs9LerITyDwcSsMIazlvd50qzx8QASKIACLap79UdGXsIhUvuOcmUQWi8G6evn9FQ8N8A3vWn6a1lRjPBwCobh5f+RWVLQkSepaf/Z+GaM/UghfRe/AMkOLwLazo7Wt5bDeR66Rs8c0BAEspupbf+uvDZG4qpiy00nyk2zDJbscjG68TBVXlaTN6TStqTBIwRJaNegegRq9FRUwkqRW7UxF0yXz46JRvcVr86b53kBqSUbPe/1SdSpK670Ozl0pBQrP52scOPJj66vsfFc/yVZW/7ELrYK46rQc5TSd6NXwEEvoIWlL1rABVlTUiCS1ZLuWjp4n+xa3lM5yb4J0z0b+ezNghMYjkJkPqnWgYqQKd2cKg5/qPP291Pe+E3XG4huSVf9NDaUH/pc64cgepVu2LDfrut2Fq2x+u+I3wBd1IT5J6gKJuj6TAJauLJ3uqc7xnud83BgEnjeTUe1+R8WoMT2mcYLiYJLP1wPZLP8vIvtj4+SvIvCCrP5ZTk3a5tJTJd8up1G1HCbD0lBrHoFqNC3LpZFYSUCSugJHLRfa2wAZ2b7iaU9NxBeKoRUI7NsrtRWVZCWIgCCARVU98VWFC8C+HUzaAhhOTLI+q9+dt6VKweqha009NWXWozgXDy2ucN+kUwFJUuv8xZTppD7lgOWBgQgQASLQNgSwCAYuAP0UJ/J0g6xan1W7G8AdraoHdmhNa2pSYjsqHIGqFfJUrywPdSJJ9QDi9iyyENpvN3y3toPOJ0SACLQdgS6SVWPOrFXV5/Gbbe8n6/XTtaaeFdqxAVZUuHfohEZZUQEJSWqdHSMx+iS12AKWtm/tUmerMm8iQARiQaBrZBVW1V7270oLc2Jps9ByaFpTi1hINY9AbZgVFV2FJLWuH4yb6tf3/UzyIlP9T3VVm/lGgkAxZSUSYSkGETgQgQVZvb3+8LLAquWKePKLPQjgQNg6mRzWVGO+KNX9fKeLhu4RqI2zoqKNSFJr66nZsLasd2XMU392odOdZ9qr7XlARHf6Vuw1xQIr7LHaS7952We1pTsCyEEAWP3PUB6BPL0pn6hCCli+sx2+qfP5ufRRnSNQTT6pUIPgSUhS62gCXR+T5Ro8Fjz1h5bUZdTa+D3Ptdv4uI0wsk4NRgAWMyyy+nx9bPdaxd6QbdsVAKv/3SlFDW6oAKLfjqdSqs76jcxcba9hMt7+zOuTR7s7htcsdTLr6xTTsVLgh5IEqHNu7gqVitOBcnHC1wi5+Vns9dqESaNmcZSxbU/cvPdgkkxTxiO7SMBNpWmWy7KIwH4E3I4nQxvxAts5pbBgaS1W2S/fQTFk6v9CCLkjXgfl1KnE8M9Msn/VXmdYSqFIwMK/HDSPQDX5eLnoJn0nSfXdWrCizrNAg182LVQda2XTYtHpnfmH1VoLicZInhDom5mZe8qraDbz+UCiTopGZzwiEASB279Dmcd2TldyzroQ1kT+lJT22iqcoT7HMpP2VFsRbcsYpP5ydC/VOq2/atZiOlktJxmuXtd21VgrKhDhdL/vfjHPJr6zLJQfprHc4Ls/OqxsaiHINlxqtYu2IFg01ac27cs+WkgoGBFYQQCEzvmvnov/6n/Jgqu/yvNmLriCtS7Uu2cF1IZd6K12P1rZ3N8trFYgx2iP5lpRIT1JKlDwFew0koZWtlHgu413N93sy3S/VkjMQKsolrOGANw6dAP2BfygWyRLIwIeEHCE9eZ1wVUzCevZChHyAEvrs9D0TV0+9rTMRv+HNUKjraioOknqYR3gLbV9OaeTtxva30qU7aaEtCwGHw03n9buDK68xEzVC57Ph+plskAi4BMBzEJ8/psjrPP09zIj8bNk/+iziNrySgLN5NVWIY2M1Va9n1qXDLhlqLmXNNuKitYnSQUKPsJcfILUtpJ4J/Bjaad5zX0000Dbcb2DqWM3ti2qqhWG5KrW7Jk5EdBEAAuubq+v7A4BefoHIay/ahZfoazVaeUKGXQuiVvQpKOEYFF1kQ3+fTQC3L16vTsfWYXMgyTVB/purzol/5JNAlfQlpJ8uimnmu4NOQ1cE7K7ssVUlrpfqjniJuO7GoXPGosAfk+310Prv5qYHwP8topBpzeVXEyeRsSq8A6tUi/sKKG1q0RqbtqwkI4ktUpHW06DbSSwV12oUFVb0tSwYGHetaFxKOy6Ua6+Jp3LSlb6pnajd3WxlnCXwv6r/RRnrsdIVukbXrZfalpTy8pWJT54QZreVEkaWxqS1ENaxO5zJnvUhQxVtSVdv1RjsKGx88UJiVYHyxY3FO3AlcbaiLO8EAi8kdUTKf5LCBG2lvn8PNj6jA+2IKBkTd1SutfbVXmBVyH8ZEaSWhXHGAjqwdqSmsO4bEVot0hphWZXtcsESee2JdPxt1qt4Bmn/VcB4VVLEbALra7PTZ79MRoXgDQFcWYog0BbrKkH84IyoNUflyS1CsYxEFTIfai21OtNqlT/gDQkLgeAVzlpEmqDfTlb3O0HWFn06BNiLKBrQ/TNpCIgFMIsHURBVHMzUKlz6wppgTX1UF4QWZuSpJZtkIuRWAMDT/FDZh/akpvy152mgr8it6Qq2+sOiw/fJPSXIEHcDdra3hejiR0L5tkDz09X6FxYoHo5mkXdn7AbQCxEVaFJWlcErKnBxkpPaLbEF3WBBknqAol9n/CnvBzJeejm076oKs+T/MrLyr1c2bka0/6pHN/aVuKi0vglC3HKyF3JVH6iL9q7TRZVWE5BUN9W6R5Zsno5mrbecuynV5TLBXgDW7dA9cj0sn8bt6NKuXy0YoOowprF0EwEmtx22CLNjffNxH6D1CSpG0B5dwsD4rNYS4z5+O5ZmBtf7XF+Psp2J27o+iyCuPRezpr2UYeQeYBsX4yerIUH/STWxWH99CqYhQDtnWT/aoW1Ee07FyXrjaAu975TW08Q2Fj7wbK0TfgO5eY5m4moq1v8gbDCaBCrspuWOFylCe3QJRmDzjwdCHQ/HR+YQ3TJSVJ3NQkGSEwvYUDEizaWME+HfkUJ4odzZF/2sb5kigB8+f2Vteq4vnFk+8k8+4/0mTvjjsgtkotOHGjXwS0E4ibjCNwHnUp7LgXtXURZBYFFvJitfZ6hqSU74AflZvvY+/HVqhqbXzAWUzE0E4EoxsoK0Dkr6qxCyqiTkKSuN4+dWpLFECCnGCCNbE4eU8ARfZhO8hncqsZ7n1kWzOvITv03bSrYuX5MZYr3py31PDNJ+k/bh2KyrjpfJV2r+TpAIHDw4WxSmy+393bCtFpTxHPWvll0CsuqpPFdrU7v75cPOMPaahe07o+uEoOWdBWYayukidbUFlpR0b4kqUDBvoTESgIL2Dz7XyEfv8jduMgp5MT50XV1xDzQNAFe5lAGHJmL38IGOZ017dQ1yc7/47KuwkKQZ1c7JdZ5eGTbHH6GMb/MIRssv7COr083F8dJ6moVFvphF8Fs2/T+vrRWeZBxG8aFGMhqFvgo6NzM9kHG5zsQaJo1taVWVLRQf0cztfMRtPRnc2KS+YmQ0YFU8kReQkJIk/jrO0/PzWchGnUE+KZejH4WGD7Vkf3ePGENmcvAfvHdlXF7e+5NohrBbTs2FuuYkI5KJcO6KltwjR4ljztRNnBk3axSTockAraXI+zocHZINp7SnloCeDH61SpfIfDYVBG4oKRC5ufZtxXbelOup3Zq2tXVz6LHTaU0+R4UwDz74cAqYCwHWR0bI25MOFkPhEMzoP8cXo/DJE5JUg8DUFLDmvos44BVgA7Ord4M6jJe1St1odzbR1KXpxGT+bFJkmM57eiDdDQZOORvnonlDthUYxqFUK0jEo7f8z3Nvy4nOvo8O5fbMtAHCQur0728YCbeFocdUpUFOfWHCUjuJ8H5k7xIw9Szlw7t9Ggsg69zAfg2GB7oH1Be53Pp+8mVHI/28ZAuszOt81c9l5mDG3u05s7IHXlosZeFlPna4qjDqu/I6nN2I8o39i+9qX38hLzwW86z8WGie0idpVMPuXQ7Cyg3mEkxgQw3xdH/EsTgUVy+g2Im8mKYSg6nB+VSJjH2IEvMQ5kkG+OCcMbykt0ooNeb9+bz9cBrjtsyA8l3vrjbYmjef5Q2nohGO1H9ETpL2lAqOlTpY25fvomqdTWudl7tU26MmIqicieWsGltbW8xsDMqUMz0xsC32opVXRQGt8PG290q36wVUmYjtEKe/sGL3NaoIARVZyx3sxiZjCe+FX73exoL/CH60ftW76X/VciCfDnK3yeu8c7n66TG3P1nDZcf5+7jP29fOfr6LfqSx3M++iTVcwU6kN2j6ckRd5pTVjiwINS0//YG/Soy3Znn9M77C8a6gDwPZH5HCLoBYTmSv1DhXs2KrE1sqiP6KEkfpG1ko3RsBdd/Ekelh8K/CUuEJIc0G8isyrHkcyxXcZAJEUTCvfzGhweRce229PFi1JbZYe3+f1OEpibvPVQi3I5gn0cwZizXDN+/iFED49j+QJK6HyNYUzEDEmfQM2AFqj9JaiDgCxWLgRSnl/jW+osUjj0I49kXdpPE9zI9KMQln9mXDGLsIy7WQgrXjxc3EFjj4ZMclpRC8vdBy7qKxYJx+Ke+x6DoHUc40F8X4Vi+hFQ0FnKU+8TOHXC5qaKQahO+Q0jqYno/LkUBbfVV/p7suJLK56bgxowP8igmJWdN0vwvhV2lSFLXsNtwGbM19ZDf4YaqxnirfT6pMaJcRaaQBBXy9tJzu4pdZxquCkKnot3KiyKRf5lLP5ePy9GOvF7iIU2+I1oMjxzu8F0diDgntYkECx42p49bIdldfYdVxKRht/ivTzF78SyLBy+/HwvJuHm936YvsD4+q03vl0XO+SJjXIl9fNhWM7w3bv822faY9ysggAWdWPAYnzX1vtIMQAUIQibhFlQh0d9VNo49DWFBXciEHyasuAwhEYCrx6BWAWC1QxnOcltrUcy8AAIg3HkyjnprrgLV2BjFuhHt3Jx/YzLeLIFA8AM7SsjapKgxrp4PtW2kcruRpCoDXqy4EtM1xTKsFsuSZJGFQR8BkEZsOVZl6restCgDCgmJalnk/MdHG6AtYtmOy0cNMV0K96H4/Nx91C6ePNB30rSdFvjQKOP3iL1I4wlfu2BFBdwkqfF0OkxB/ybbl/yxsD+Rhuz2NCoSVQ2oX8tYEBVNSzrKIlF9bYIgX0K0e90VxfHARY6SrVuOTuQvriIaSm0nsNxQyaisqXlnlBGS1A19McitxQsqxo3sSVT1usSiH2gS1EXtSFQXSIT4/GqVhBDtXldtsccwTtuK16+9rpqHyPdLlIeghECirjLd7MZ9XdmXyPcxKkNWCcGrRCVJrYKa/zTxv6AWRBUkiqEuBB6DE5UFUXUrneuqJ/NdReCr9QtuE0FF/XDaE/vRakvXcwXf9WE9WTPXFQSi8AOVk9Q6FEhSwzf2l8a8oEBUOSVcV48BUTkJulhuUTOQJbdgC1vyMNSJAPzcgHUbp2lRp8/XOOkvJl++OltTP28YDbR81/VrF1+J7uCNkNbUTllR0QFIUkP+DHDUKTZdbtILCgSmL2SKFhJ/PSdGooI+6Vb9k2D4a+m1nPK/mtvr9vsRoo5G6srgF4GQrkF+a9Ks3IJaU7tlRUXHIEkN8/PAcYh/aOzZ3fDNIYHx1HMiJiogqiQYntp5JRv3+2/rXqgrVX25QF3n6e/l6nHTY94rjUD8LmKlq9SQBOGsqZ2zoqJHkKRq/y5wqgymdX2c160t+3J5CwKD3Qjop7qMTNHvzSEqbwSD0/9FW3d7PLj3NP/3v71+2584NxJM//+8PRKfFEAAx+iGOYmwgHCdiBLEmtqdFf3LfYgkdRmNer87UnJ7fdWo6f19mGA3gn56LNG+7IvK5y8INFFRAcGAfyFcVBjKIwBFzm4v1zD3nvI13Z3CKbdXdiaJVtXdWG16irHj83U7fZg31TfWe9rWVIwfvd4kVjjqlIsktU50kTc6l/M9PW689XQbVnjxwLcWL2G+eLahhPvNV1T+cT0WK843Upf7XRXlsyUEQCygyMW4vdySmKpf8ZL/fH1sx0bOxBSB/m3sKBKbcRQQyCcKhbgicJIY3rMdDCSpdTY6FsRgkRFe7F0IeAljKhOknC+etxZfKCptmeaFTzKsOfCrplLy1s7vv2Fa9hvx623X7Mn7ela/g7ERBJ47AGzHEONpW8aO7bVs3hO7LaOCjzXeH2namc371ztCf/0Grz0g4MjpWDSfmYfcmpWF0/Zw9vhETpoZC2H9tlkV8Cxtm/uCm/KSIy9l03aTjAW5I8/oNTW7eyHw49bOnPhuFTdmDGXMGHPMWAK3zWPHUjWb/RWr7ZNfaq1Dh62owJWWVF+9C9oOBhVnOcG2MjNfWTcyH9T/9npo8QAuXQtd6guwKGDq1rl7dNkN4Iu1LsPK3PSFkSF+r6tjxs+dnY3p0tgRop/5LLNua2rHrahoKlpSD++wj+J4emP6vUlXfUZ2QujIurOSZHK2dGauxLr6u51pmvvwUeo2sVMzXfQfcj6Xd+ZP4xOTZlfSjOctbutFLxVfQYPFg/AZmy1u8vMABByOV9ayOp+fi6UKfenjATnGnxRkxMjYwX4Uf1u9k7BGa2rHraiAmiT1XYcrdMO9mLJ0EsUJQYVEDhzJvXjGIsXYXHwn5CUdyvcz+Wt2cC+XO5mUmNB69tKU2AnAGCgmH4wjGUI0WtDWi5762ubZHRdDLUCp4dMpehPJefKi+AxF6UFfapNbieyKkouS07ujkaOGPqSRJaypl6NxLf0ylfdKxwNJarEOAFI6NUk+lW0gprSYFANta6yFxQ0k5vl5IAQPL54mWd2ckmKyKUnK1lYWamFXo04kxuSVsObJQK6b1NYirg1fhSDdmef0jorpAhLFT6f4XEmJV5aw9jPZTcQS1iZaWB0x7ZGYKvagmouqwZoKtw/OztCSuqHnwqfuSV5ID3JO/VQQeqCGuwElH7ccibmTrPBn7MunNx/I9J78mRP5i8Vi8lVeiA9UUqRFqoZlwoo84BKAts6TE/mtoa1jIxv3ItfUZNmD6fehmD5VrTrTeUbAEdYHyXVslR8ouqnsKpIb6U/Sl2JyJ4LVHe8S25fkfUJfZc+dIZLsYE29GN147Xv9dBxJ7YKK0SVL6ldB2r1ocjOTJWMzizxeQqb/RDIatB+6wt9ePjf2hrW0yksnzQbiy/pBBoATuX8sf3WRV9dH8ELJ8yeT9x74UrEt4f+/t7Z+y/tiPDDJ/NgkybElG0ba3JjTtwi1fFtSSmUsyPqzRlpK83wmyh3qohOyl7FUp7Ttpawruog5HB+bZ3P8Mm5If5Lv9Y4bKPVR/mbSb927xSk3MHDM8DDicB+xbM0SDf6jufnBi9C0or7CmNjtY5Lk+PVOk74siMQmmamxbkKlPfcWBHZRo2QuFpQEpGZ/WO837Cv7MQsdY0E8IMeCyJaVCTMjCCBYjiTbS/7XIQTWxw0owGXDoh8hHWfayqLX3vi2b2UzUYp+d3AlsUtQ/ArOwdUskkFSJBLjEAEiQASIABEgAkSACOxA4M+ygOpQayqsqLfXwx2ldOoR90ntVHOzskSACBABIkAEiEAtCKQppvx/Oyhv+qKuwEeSugIHL4gAESACRIAIEAEiUAEB+EjDN7V6uOc0/yp4JKmrePCKCBABIkAEiAARIALVEDjEmorjlBlWECBJXYGDF0SACBABIkAEiAARqIjA23Z7ZTO4524y7yEjSX2PCe8QASJABIgAESACRKAaAjjetmygFXUjYiSpG2HhTSJABIgAESACRIAIVEAA20dhlX7xQCvqFqxIUrcAw9tEgAgQASJABIgAEaiEQJlV+rSiboWYJHUrNHxABIgAESACRIAIEIEKCBS3pj7SF3U7viSp27HhEyJABIgAESACRIAIVEOgkDU1H1fLvBupet2oJmtJBIgAESACRIAIEAFFBB6mT+a/T7+Ro1JPtpT6aD7/bbjlGW8LArSkshsQASJABIgAESACRKAOBHZaU2lF3Qd5si8CnxMBIkAEiAARIAJEgAhUROByNJWUp2upxYp6fbx2j5drCNCSugYIL4kAESACRIAIEAEi4A2Bjav3aUUtgi8tqUVQYhwiQASIABEgAkSACFRFYNWaSitqQRxpSS0IFKMRASJABIgAESACRKASAsvW1MRMKuXRwUQkqR1sdFaZCBABIkAEiAARUETgdjyV0u7lJKrfTFrh2FRFUWMqqh+TMJSFCBABIkAEiAARIAKtRADW1DQbmMn4qZX1q6FS/w8fPyk41f6mNgAAAABJRU5ErkJggg=="

/***/ }),

/***/ "./brands/logos/michelin.png":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0abea9f6ef42fde5b3c0320acf4b09d0.png";

/***/ }),

/***/ "./components/AbsoluteSmoothCollapse/Wrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO: Refactor to use modifiers instead of passing props directly through component to styles.
/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  color: ' + (props.color || props.theme.colors.base.textLight) + ';\n  position: absolute;\n  left: ' + props.left + ';\n  right: ' + props.right + ';\n  top: ' + props.top + ';\n  bottom: ' + props.bottom + ';\n  z-index: ' + props.zIndex + ';\n  padding-top: ' + props.paddingTop + ';\n  line-height: ' + props.lineHeight + ';\n  text-align: left;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      textLight: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

var propTypes = {
  left: _propTypes2.default.string,
  right: _propTypes2.default.string,
  top: _propTypes2.default.string,
  bottom: _propTypes2.default.string,
  paddingTop: _propTypes2.default.string,
  zIndex: _propTypes2.default.number,
  color: _propTypes2.default.string,
  lineHeight: _propTypes2.default.string
};

var defaultProps = {
  left: 'auto',
  right: 'auto',
  top: 'auto',
  bottom: 'auto',
  paddingTop: '0',
  zIndex: 1,
  color: undefined,
  lineHeight: '14px'
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Wrapper', _styledComponents2.default.div, styles, { defaultProps: defaultProps, propTypes: propTypes, themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/AbsoluteSmoothCollapse/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSmoothCollapse = __webpack_require__("../node_modules/react-smooth-collapse/js/index.js");

var _reactSmoothCollapse2 = _interopRequireDefault(_reactSmoothCollapse);

var _Wrapper = __webpack_require__("./components/AbsoluteSmoothCollapse/Wrapper.js");

var _Wrapper2 = _interopRequireDefault(_Wrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO: Refactor AbsoluteSmoothCollapse to use modifiers
function AbsoluteSmoothCollapse(props) {
  return _react2.default.createElement(
    _Wrapper2.default,
    props,
    _react2.default.createElement(
      _reactSmoothCollapse2.default,
      props,
      props.children
    )
  );
}

AbsoluteSmoothCollapse.propTypes = {
  children: _propTypes2.default.node.isRequired
};

exports.default = AbsoluteSmoothCollapse;

/***/ }),

/***/ "./components/AppBody/AppWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function expandedStyle(_ref) {
  var expanded = _ref.expanded,
      theme = _ref.theme;

  if (expanded) {
    return theme.dimensions.leftNavWidth;
  }
  return theme.dimensions.leftNavWidthCollapsed;
}

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  height: 100%;\n  position: absolute;\n  left: ' + expandedStyle(props) + ';\n  right: 0;\n  transition: left ' + props.theme.dimensions.leftNavExpandTime + ';\n';
};

var themePropTypes = {
  dimensions: _propTypes2.default.shape({
    leftNavExpandTime: _propTypes2.default.string.isRequired,
    leftNavWidth: _propTypes2.default.string.isRequired,
    leftNavWidthCollapsed: _propTypes2.default.string.isRequired
  }).isRequired
};

var propTypes = {
  expanded: _propTypes2.default.bool
};

var defaultProps = {
  expanded: false
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('AppWrapper', _styledComponents2.default.section, styles, { defaultProps: defaultProps, propTypes: propTypes, themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/AppBody/ContentWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  min-height: 100%;\n'], ['\n  display: flex;\n  flex-direction: column;\n  min-height: 100%;\n']);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ContentWrapper = function () {
  var c = _styledComponents2.default.div(_templateObject);

  c.displayName = 'ContentWrapper';
  return c;
}();

exports.default = ContentWrapper;

/***/ }),

/***/ "./components/AppBody/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactFontawesome = __webpack_require__("../node_modules/react-fontawesome/lib/index.js");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _reactScroll = __webpack_require__("../node_modules/react-scroll/modules/index.js");

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _document = __webpack_require__("./utils/document.js");

var _FloatingActionWrapper = __webpack_require__("./elements/FloatingActionWrapper/index.js");

var _FloatingActionWrapper2 = _interopRequireDefault(_FloatingActionWrapper);

var _RectangleButton = __webpack_require__("./elements/RectangleButton/index.js");

var _RectangleButton2 = _interopRequireDefault(_RectangleButton);

var _GlobalFooter = __webpack_require__("./components/GlobalFooter/index.js");

var _GlobalFooter2 = _interopRequireDefault(_GlobalFooter);

var _AppWrapper = __webpack_require__("./components/AppBody/AppWrapper.js");

var _AppWrapper2 = _interopRequireDefault(_AppWrapper);

var _ContentWrapper = __webpack_require__("./components/AppBody/ContentWrapper.js");

var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);

var _messages = __webpack_require__("./components/AppBody/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AppBody = function (_React$Component) {
  _inherits(AppBody, _React$Component);

  function AppBody() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AppBody);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AppBody.__proto__ || Object.getPrototypeOf(AppBody)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      scrollHeight: 0
    }, _this.scrollListener = function () {
      _this.setState({ scrollHeight: (0, _document.getScrollTop)(document) });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AppBody, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('scroll', this.scrollListener);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.scrollListener);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          expanded = _props.expanded,
          children = _props.children;
      var scrollHeight = this.state.scrollHeight;

      var hide = scrollHeight < 1000 && 'hide';
      var bounceIn = scrollHeight < 1000 && 'bounceIn';

      return _react2.default.createElement(
        _AppWrapper2.default,
        {
          expanded: expanded,
          id: 'app-wrapper'
        },
        _react2.default.createElement(
          _ContentWrapper2.default,
          null,
          children,
          _react2.default.createElement(_GlobalFooter2.default, { isBranded: true })
        ),
        _react2.default.createElement(
          _FloatingActionWrapper2.default,
          {
            modifiers: (0, _lodash.compact)(['bottomRight', bounceIn, 'boxShadow', hide])
          },
          _react2.default.createElement(
            _RectangleButton2.default,
            {
              className: 'back-to-top-button',
              modifiers: ['hoverBrandBright', 'hoverUnderline', 'offWhite', 'small'],
              onClick: function onClick() {
                return _reactScroll.animateScroll.scrollToTop();
              }
            },
            _react2.default.createElement(
              _RectangleButton.RectangleButtonText,
              { modifiers: ['small'] },
              _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.backToTopButton })
            ),
            _react2.default.createElement(
              _RectangleButton.RectangleButtonIcon,
              { modifiers: ['padLeft'] },
              _react2.default.createElement(_reactFontawesome2.default, { name: 'long-arrow-up' })
            )
          )
        )
      );
    }
  }]);

  return AppBody;
}(_react2.default.Component);

AppBody.propTypes = {
  children: _propTypes2.default.node.isRequired,
  expanded: _propTypes2.default.bool
};

AppBody.defaultProps = {
  children: null,
  expanded: true
};

exports.default = AppBody;

/***/ }),

/***/ "./components/AppBody/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var formattedMessages = {
  backToTopButton: (0, _linguiReact.i18nMark)('Back to Top')
};

exports.default = formattedMessages;

/***/ }),

/***/ "./components/AssetDisplayElement/AssetCard.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactImmutableProptypes = __webpack_require__("../node_modules/react-immutable-proptypes/dist/ImmutablePropTypes.js");

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _Card = __webpack_require__("./elements/Card/index.js");

var _Card2 = _interopRequireDefault(_Card);

var _Divider = __webpack_require__("./elements/Divider/index.js");

var _Divider2 = _interopRequireDefault(_Divider);

var _AssetDetails = __webpack_require__("./components/AssetDisplayElement/AssetDetails.js");

var _AssetDetails2 = _interopRequireDefault(_AssetDetails);

var _AssetIds = __webpack_require__("./components/AssetDisplayElement/AssetIds.js");

var _AssetIds2 = _interopRequireDefault(_AssetIds);

var _AssetStatus = __webpack_require__("./components/AssetDisplayElement/AssetStatus.js");

var _AssetStatus2 = _interopRequireDefault(_AssetStatus);

var _AssetTitle = __webpack_require__("./components/AssetDisplayElement/AssetTitle.js");

var _AssetTitle2 = _interopRequireDefault(_AssetTitle);

var _AssetOpenCases = __webpack_require__("./components/AssetDisplayElement/AssetOpenCases.js");

var _AssetOpenCases2 = _interopRequireDefault(_AssetOpenCases);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AssetCard(_ref) {
  var assetInfo = _ref.assetInfo;

  return _react2.default.createElement(
    _Card2.default,
    { modifiers: ['noCursor'] },
    _react2.default.createElement(_AssetTitle2.default, { assetInfo: assetInfo }),
    _react2.default.createElement(_Divider2.default, { modifiers: ['gutter', 'light'] }),
    _react2.default.createElement(_AssetIds2.default, { assetInfo: assetInfo }),
    _react2.default.createElement(_Divider2.default, { modifiers: ['gutter', 'light', 'narrow'] }),
    _react2.default.createElement(_AssetDetails2.default, { assetInfo: assetInfo }),
    _react2.default.createElement(_Divider2.default, { modifiers: ['gutter', 'light', 'narrow'] }),
    _react2.default.createElement(_AssetStatus2.default, { assetInfo: assetInfo }),
    _react2.default.createElement(_Divider2.default, { modifiers: ['gutter', 'light'] }),
    _react2.default.createElement(_AssetOpenCases2.default, { assetInfo: assetInfo })
  );
}

AssetCard.propTypes = {
  assetInfo: _reactImmutableProptypes2.default.contains({
    id: _propTypes2.default.string
  }).isRequired
};

exports.default = AssetCard;

/***/ }),

/***/ "./components/AssetDisplayElement/AssetDetails.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactImmutableProptypes = __webpack_require__("../node_modules/react-immutable-proptypes/dist/ImmutablePropTypes.js");

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _asset = __webpack_require__("./utils/asset.js");

var _widget = __webpack_require__("./utils/widget.js");

var _Card = __webpack_require__("./elements/Card/index.js");

var _messages = __webpack_require__("./components/AssetDisplayElement/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AssetDetails(_ref) {
  var assetInfo = _ref.assetInfo;

  var make = (0, _widget.getOutputText)(assetInfo.get('make'));
  var model = (0, _widget.getOutputText)(assetInfo.get('model'));
  var year = (0, _widget.getOutputText)(assetInfo.get('year'));
  var engine = (0, _widget.getOutputText)(assetInfo.get('engine'));
  var odometerReading = assetInfo.getIn(['odometer', 'reading']);
  var odometerUnit = assetInfo.getIn(['odometer', 'unit']);
  var odometerText = (0, _asset.getOdometerText)(odometerReading, odometerUnit);
  var odometer = (0, _widget.getOutputText)(odometerText);

  return _react2.default.createElement(
    _Card.CardElement,
    null,
    _react2.default.createElement(
      _Card.CardTable,
      {
        modifiers: ['capitalize'],
        tdModifiers: ['leftAlign', 'midGreyText'],
        thModifiers: ['extraWide']
      },
      _react2.default.createElement(
        'tbody',
        null,
        _react2.default.createElement(
          _Card.CardTableRow,
          null,
          _react2.default.createElement(
            'th',
            null,
            _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.make })
          ),
          _react2.default.createElement(
            'td',
            null,
            make
          )
        ),
        _react2.default.createElement(
          _Card.CardTableRow,
          { type: 'topGap' },
          _react2.default.createElement(
            'th',
            null,
            _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.model })
          ),
          _react2.default.createElement(
            'td',
            null,
            model
          )
        ),
        _react2.default.createElement(
          _Card.CardTableRow,
          { type: 'topGap' },
          _react2.default.createElement(
            'th',
            null,
            _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.year })
          ),
          _react2.default.createElement(
            'td',
            null,
            year
          )
        ),
        _react2.default.createElement(
          _Card.CardTableRow,
          { type: 'topGap' },
          _react2.default.createElement(
            'th',
            null,
            _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.engine })
          ),
          _react2.default.createElement(
            'td',
            null,
            engine
          )
        ),
        _react2.default.createElement(
          _Card.CardTableRow,
          { type: 'topGap' },
          _react2.default.createElement(
            'th',
            null,
            _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.odometer })
          ),
          _react2.default.createElement(
            'td',
            null,
            odometer
          )
        )
      )
    )
  );
}

AssetDetails.propTypes = {
  assetInfo: _reactImmutableProptypes2.default.contains({
    equipmentStatus: _propTypes2.default.string,
    make: _propTypes2.default.string,
    model: _propTypes2.default.string,
    year: _propTypes2.default.string,
    engine: _propTypes2.default.string,
    odometer: _propTypes2.default.shape({
      reading: _propTypes2.default.string,
      unit: _propTypes2.default.string
    })
  }).isRequired
};

exports.default = AssetDetails;

/***/ }),

/***/ "./components/AssetDisplayElement/AssetIds.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactImmutableProptypes = __webpack_require__("../node_modules/react-immutable-proptypes/dist/ImmutablePropTypes.js");

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _asset = __webpack_require__("./utils/asset.js");

var _widget = __webpack_require__("./utils/widget.js");

var _Card = __webpack_require__("./elements/Card/index.js");

var _messages = __webpack_require__("./components/AssetDisplayElement/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AssetIds(_ref) {
  var assetInfo = _ref.assetInfo;

  var rawVin = assetInfo.get('vinNumber');
  var vinNumber = (0, _widget.getOutputText)(rawVin);
  var serialNumber = (0, _asset.getSerialNumber)(rawVin);

  return _react2.default.createElement(
    _Card.CardElement,
    null,
    _react2.default.createElement(
      _Card.CardTable,
      {
        modifiers: ['uppercase'],
        tdModifiers: ['active', 'leftAlign'],
        thModifiers: ['extraWide']
      },
      _react2.default.createElement(
        'tbody',
        null,
        _react2.default.createElement(
          _Card.CardTableRow,
          null,
          _react2.default.createElement(
            'th',
            null,
            _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.serial })
          ),
          _react2.default.createElement(
            'td',
            null,
            serialNumber
          )
        ),
        _react2.default.createElement(
          _Card.CardTableRow,
          { type: 'topGap' },
          _react2.default.createElement(
            'th',
            null,
            _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.vin })
          ),
          _react2.default.createElement(
            'td',
            null,
            vinNumber
          )
        )
      )
    )
  );
}

AssetIds.propTypes = {
  assetInfo: _reactImmutableProptypes2.default.contains({
    vinNumber: _propTypes2.default.string
  }).isRequired
};

exports.default = AssetIds;

/***/ }),

/***/ "./components/AssetDisplayElement/AssetListRow.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactImmutableProptypes = __webpack_require__("../node_modules/react-immutable-proptypes/dist/ImmutablePropTypes.js");

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _SeverityLabel = __webpack_require__("./components/SeverityLabel/index.js");

var _SeverityLabel2 = _interopRequireDefault(_SeverityLabel);

var _Link = __webpack_require__("./elements/Link/index.js");

var _Link2 = _interopRequireDefault(_Link);

var _baseComponents = __webpack_require__("../node_modules/base-components/build/index.js");

var _StatusSpan = __webpack_require__("./elements/StatusSpan/index.js");

var _StatusSpan2 = _interopRequireDefault(_StatusSpan);

var _TextDiv = __webpack_require__("./elements/TextDiv/index.js");

var _TextDiv2 = _interopRequireDefault(_TextDiv);

var _asset = __webpack_require__("./utils/asset.js");

var _widget = __webpack_require__("./utils/widget.js");

var _messages = __webpack_require__("./components/AssetDisplayElement/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AssetListRow(_ref) {
  var assetInfo = _ref.assetInfo;

  // asset ids
  var assetId = assetInfo.get('id');
  var unitNumber = (0, _widget.getOutputText)(assetInfo.get('unitNumber'));
  var rawVin = assetInfo.get('vinNumber');
  var vinNumber = (0, _widget.getOutputText)(rawVin);
  var serialNumber = (0, _asset.getSerialNumber)(rawVin);
  // asset details
  var make = (0, _widget.getOutputText)(assetInfo.get('make'));
  var model = (0, _widget.getOutputText)(assetInfo.get('model'));
  var year = (0, _widget.getOutputText)(assetInfo.get('year'));
  var engine = (0, _widget.getOutputText)(assetInfo.get('engine'));
  var odometerReading = assetInfo.getIn(['odometer', 'reading']);
  var odometerUnit = assetInfo.getIn(['odometer', 'unit']);
  var odometerText = (0, _asset.getOdometerText)(odometerReading, odometerUnit);
  var odometer = (0, _widget.getOutputText)(odometerText);
  // asset status
  var pmStatus = assetInfo.get('pmStatus');
  // asset severity info
  var severityColor = assetInfo.get('severityColor');
  var severityCount = Number(assetInfo.get('severityCount'));

  return _react2.default.createElement(
    _baseComponents.ListTable.Row,
    { modifiers: ['lined'] },
    _react2.default.createElement(
      _baseComponents.ListTable.Data,
      null,
      _react2.default.createElement(
        _Link2.default,
        { to: '/assets/' + assetId, modifiers: ['heavy', 'uppercase'] },
        unitNumber
      )
    ),
    _react2.default.createElement(
      _baseComponents.ListTable.Data,
      null,
      _react2.default.createElement(
        _TextDiv2.default,
        { modifiers: ['bright'] },
        serialNumber
      )
    ),
    _react2.default.createElement(
      _baseComponents.ListTable.Data,
      { flex: 1.5, minWidth: 150 },
      _react2.default.createElement(
        _TextDiv2.default,
        { modifiers: ['bright'] },
        vinNumber
      )
    ),
    _react2.default.createElement(
      _baseComponents.ListTable.Data,
      null,
      _react2.default.createElement(
        _TextDiv2.default,
        null,
        make
      )
    ),
    _react2.default.createElement(
      _baseComponents.ListTable.Data,
      null,
      _react2.default.createElement(
        _TextDiv2.default,
        null,
        model
      )
    ),
    _react2.default.createElement(
      _baseComponents.ListTable.Data,
      null,
      _react2.default.createElement(
        _TextDiv2.default,
        null,
        year
      )
    ),
    _react2.default.createElement(
      _baseComponents.ListTable.Data,
      null,
      _react2.default.createElement(
        _TextDiv2.default,
        null,
        engine
      )
    ),
    _react2.default.createElement(
      _baseComponents.ListTable.Data,
      null,
      _react2.default.createElement(
        _TextDiv2.default,
        null,
        odometer
      )
    ),
    _react2.default.createElement(
      _baseComponents.ListTable.Data,
      null,
      _react2.default.createElement(
        _TextDiv2.default,
        null,
        _react2.default.createElement(
          _StatusSpan2.default,
          { modifiers: (0, _lodash.compact)(['bold', pmStatus, 'capitalize']) },
          (0, _asset.getAssetStatusText)('pmStatus', pmStatus, _messages2.default.pmStatus)
        )
      )
    ),
    _react2.default.createElement(
      _baseComponents.ListTable.Data,
      null,
      _react2.default.createElement(_SeverityLabel2.default, { color: severityColor, value: severityCount, small: true })
    )
  );
}

AssetListRow.propTypes = {
  assetInfo: _reactImmutableProptypes2.default.contains({
    id: _propTypes2.default.string,
    unitNumber: _propTypes2.default.string,
    vinNumber: _propTypes2.default.string,
    make: _propTypes2.default.string,
    model: _propTypes2.default.string,
    year: _propTypes2.default.string,
    engine: _propTypes2.default.string,
    pmStatus: _propTypes2.default.string,
    odometer: _propTypes2.default.shape({
      reading: _propTypes2.default.string,
      unit: _propTypes2.default.string
    })
  }).isRequired
};

exports.default = AssetListRow;

/***/ }),

/***/ "./components/AssetDisplayElement/AssetOpenCases.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactImmutableProptypes = __webpack_require__("../node_modules/react-immutable-proptypes/dist/ImmutablePropTypes.js");

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _Card = __webpack_require__("./elements/Card/index.js");

var _TextDiv = __webpack_require__("./elements/TextDiv/index.js");

var _TextDiv2 = _interopRequireDefault(_TextDiv);

var _BriefcaseIcon = __webpack_require__("./components/BriefcaseIcon/index.js");

var _BriefcaseIcon2 = _interopRequireDefault(_BriefcaseIcon);

var _messages = __webpack_require__("./components/AssetDisplayElement/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AssetOpenCases(_ref) {
  var assetInfo = _ref.assetInfo;

  var hasOpenCases = assetInfo.get('hasActiveCases');
  var count = assetInfo.get('countActiveCases');

  if (hasOpenCases) {
    return _react2.default.createElement(
      _Card.CardElement,
      { modifiers: ['flex'] },
      _react2.default.createElement(_BriefcaseIcon2.default, { name: 'briefcase' }),
      _react2.default.createElement(
        _TextDiv2.default,
        { modifiers: ['darkGreyText', 'smallText'] },
        _react2.default.createElement(_linguiReact.Trans, {
          id: '{count, plural, one {# Open Case} other {# Open Cases}}',
          values: {
            count: count
          }
        })
      )
    );
  }
  return _react2.default.createElement(
    _Card.CardElement,
    null,
    _react2.default.createElement(
      _TextDiv2.default,
      { modifiers: ['smallText', 'lightText', 'italic', 'statusDefault'] },
      _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.noOpenCases })
    )
  );
}

AssetOpenCases.propTypes = {
  assetInfo: _reactImmutableProptypes2.default.contains({
    countActiveCases: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
    hasActiveCases: _propTypes2.default.bool.isRequired
  }).isRequired
};

exports.default = AssetOpenCases;

/***/ }),

/***/ "./components/AssetDisplayElement/AssetStatus.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactImmutableProptypes = __webpack_require__("../node_modules/react-immutable-proptypes/dist/ImmutablePropTypes.js");

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _StatusSpan = __webpack_require__("./elements/StatusSpan/index.js");

var _StatusSpan2 = _interopRequireDefault(_StatusSpan);

var _asset = __webpack_require__("./utils/asset.js");

var _Card = __webpack_require__("./elements/Card/index.js");

var _messages = __webpack_require__("./components/AssetDisplayElement/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AssetStatus(_ref) {
  var assetInfo = _ref.assetInfo;

  var pmStatus = assetInfo.get('pmStatus');

  return _react2.default.createElement(
    _Card.CardElement,
    null,
    _react2.default.createElement(
      _Card.CardTable,
      {
        modifiers: ['capitalize'],
        tdModifiers: ['leftAlign'],
        thModifiers: ['extraWide']
      },
      _react2.default.createElement(
        'tbody',
        null,
        _react2.default.createElement(
          _Card.CardTableRow,
          null,
          _react2.default.createElement(
            'th',
            null,
            _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.pmStatus })
          ),
          _react2.default.createElement(
            'td',
            null,
            _react2.default.createElement(
              _StatusSpan2.default,
              { modifiers: (0, _lodash.compact)(['bold', pmStatus, 'capitalize']) },
              (0, _asset.getAssetStatusText)('pmStatus', pmStatus, _messages2.default.pmStatus)
            )
          )
        )
      )
    )
  );
}

AssetStatus.propTypes = {
  assetInfo: _reactImmutableProptypes2.default.contains({
    pmStatus: _propTypes2.default.string
  }).isRequired
};

exports.default = AssetStatus;

/***/ }),

/***/ "./components/AssetDisplayElement/AssetTitle.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactImmutableProptypes = __webpack_require__("../node_modules/react-immutable-proptypes/dist/ImmutablePropTypes.js");

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _SeverityLabel = __webpack_require__("./components/SeverityLabel/index.js");

var _SeverityLabel2 = _interopRequireDefault(_SeverityLabel);

var _Card = __webpack_require__("./elements/Card/index.js");

var _Link = __webpack_require__("./elements/Link/index.js");

var _Link2 = _interopRequireDefault(_Link);

var _SplitBlock = __webpack_require__("./elements/SplitBlock/index.js");

var _messages = __webpack_require__("./components/AssetDisplayElement/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AssetTitle(_ref) {
  var assetInfo = _ref.assetInfo;

  var assetId = assetInfo.get('id');
  var unitNumber = assetInfo.get('unitNumber');

  return _react2.default.createElement(
    _Card.CardElement,
    null,
    _react2.default.createElement(
      _SplitBlock.SplitBlock,
      null,
      _react2.default.createElement(
        _SplitBlock.SplitBlockPart,
        { modifiers: ['left', 'wide'] },
        _react2.default.createElement(
          _SplitBlock.SplitBlockElement,
          { modifiers: ['padRight'] },
          _react2.default.createElement(
            _Link2.default,
            { to: '/assets/' + assetId, modifiers: ['heavy', 'uppercase'] },
            _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.title, values: { unitNumber: unitNumber } })
          )
        ),
        _react2.default.createElement(
          _SplitBlock.SplitBlockElement,
          { modifiers: ['padLeft'] },
          _react2.default.createElement(_SeverityLabel2.default, {
            color: assetInfo.get('severityColor'),
            value: Number(assetInfo.get('severityCount')),
            small: true
          })
        )
      )
    )
  );
}

AssetTitle.propTypes = {
  assetInfo: _reactImmutableProptypes2.default.contains({
    id: _propTypes2.default.string,
    severityColor: _propTypes2.default.string,
    severityCount: _propTypes2.default.string
  }).isRequired
};

exports.default = AssetTitle;

/***/ }),

/***/ "./components/AssetDisplayElement/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AssetListRow = exports.AssetCard = undefined;

var _AssetCard2 = __webpack_require__("./components/AssetDisplayElement/AssetCard.js");

var _AssetCard3 = _interopRequireDefault(_AssetCard2);

var _AssetListRow2 = __webpack_require__("./components/AssetDisplayElement/AssetListRow.js");

var _AssetListRow3 = _interopRequireDefault(_AssetListRow2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = './AssetCard';
exports.AssetCard = _AssetCard3.default;
exports.AssetListRow = _AssetListRow3.default;

/***/ }),

/***/ "./components/AssetDisplayElement/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var formattedMessages = {
  engine: (0, _linguiReact.i18nMark)('Engine'),
  make: (0, _linguiReact.i18nMark)('Make'),
  model: (0, _linguiReact.i18nMark)('Model'),
  noOpenCases: (0, _linguiReact.i18nMark)('No Open Cases'),
  odometer: (0, _linguiReact.i18nMark)('Odometer'),
  pmStatus: (0, _linguiReact.i18nMark)('Maintenance'),
  serial: (0, _linguiReact.i18nMark)('Serial'),
  title: (0, _linguiReact.i18nMark)('Unit {unitNumber}'),
  unitNumber: (0, _linguiReact.i18nMark)('Unit'),
  vin: (0, _linguiReact.i18nMark)('VIN'),
  year: (0, _linguiReact.i18nMark)('Year')
};

exports.default = formattedMessages;

/***/ }),

/***/ "./components/AssetsPanel/AssetsListView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__("../node_modules/immutable/dist/immutable.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactImmutableProptypes = __webpack_require__("../node_modules/react-immutable-proptypes/dist/ImmutablePropTypes.js");

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _reactStickyFill = __webpack_require__("../node_modules/react-sticky-fill/lib/index.js");

var _reactStickyFill2 = _interopRequireDefault(_reactStickyFill);

var _AssetDisplayContainer = __webpack_require__("./containers/AssetDisplayContainer/index.js");

var _AssetDisplayContainer2 = _interopRequireDefault(_AssetDisplayContainer);

var _baseComponents = __webpack_require__("../node_modules/base-components/build/index.js");

var _favorites = __webpack_require__("./utils/favorites.js");

var _ListRowLoading = __webpack_require__("./components/_common/ListRowLoading/index.js");

var _ListRowLoading2 = _interopRequireDefault(_ListRowLoading);

var _messages = __webpack_require__("./components/AssetsPanel/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MAX_LOADING_ROWS = 10;

function renderAssetList(assets) {
  return assets.map(function (assetInfo) {
    var assetId = assetInfo.get('id');
    return _react2.default.createElement(_AssetDisplayContainer2.default, { datum: assetInfo, key: assetId, type: 'list' });
  });
}

function renderGhostRows(assets, favoritePagination, requesting) {
  if (!(0, _favorites.shouldBuildLoadingGhosts)({
    currentCount: assets.size,
    favoritePagination: favoritePagination,
    requesting: requesting
  })) {
    return null;
  }
  var totalCount = favoritePagination.get('totalCount');
  var count = totalCount ? Math.min(MAX_LOADING_ROWS, totalCount - assets.size) : MAX_LOADING_ROWS;
  return Array.from({ length: count }, function (_, i) {
    return _react2.default.createElement(_ListRowLoading2.default, { key: i, columnSpans: [1, 3, 2, 4, 2] });
  });
}

function AssetsListView(_ref) {
  var assets = _ref.assets,
      favoritePagination = _ref.favoritePagination,
      requesting = _ref.requesting;

  return _react2.default.createElement(
    _baseComponents.ListTable,
    null,
    _react2.default.createElement(
      _reactStickyFill2.default,
      { style: { top: '80px' } },
      _react2.default.createElement(
        _baseComponents.ListTable.Head,
        null,
        _react2.default.createElement(
          _baseComponents.ListTable.Header,
          null,
          _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.unitNumber })
        ),
        _react2.default.createElement(
          _baseComponents.ListTable.Header,
          null,
          _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.serial })
        ),
        _react2.default.createElement(
          _baseComponents.ListTable.Header,
          { flex: 1.5, minWidth: 150 },
          _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.vin })
        ),
        _react2.default.createElement(
          _baseComponents.ListTable.Header,
          null,
          _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.make })
        ),
        _react2.default.createElement(
          _baseComponents.ListTable.Header,
          null,
          _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.model })
        ),
        _react2.default.createElement(
          _baseComponents.ListTable.Header,
          null,
          _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.year })
        ),
        _react2.default.createElement(
          _baseComponents.ListTable.Header,
          null,
          _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.engine })
        ),
        _react2.default.createElement(
          _baseComponents.ListTable.Header,
          null,
          _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.odometer })
        ),
        _react2.default.createElement(
          _baseComponents.ListTable.Header,
          null,
          _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.pmStatus })
        ),
        _react2.default.createElement(
          _baseComponents.ListTable.Header,
          null,
          _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.other })
        )
      )
    ),
    _react2.default.createElement(
      _baseComponents.ListTable.Body,
      null,
      renderAssetList(assets),
      renderGhostRows(assets, favoritePagination, requesting)
    )
  );
}

AssetsListView.propTypes = {
  assets: _reactImmutableProptypes2.default.listOf(_reactImmutableProptypes2.default.mapContains({
    id: _propTypes2.default.string
  })).isRequired,
  favoritePagination: _reactImmutableProptypes2.default.map.isRequired,
  requesting: _propTypes2.default.bool.isRequired
};

AssetsListView.defaultProps = {
  favoritePagination: (0, _immutable.Map)(),
  requesting: false
};

exports.default = AssetsListView;

/***/ }),

/***/ "./components/AssetsPanel/AssetsMapView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactImmutableProptypes = __webpack_require__("../node_modules/react-immutable-proptypes/dist/ImmutablePropTypes.js");

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _reactRouterDom = __webpack_require__("../node_modules/react-router-dom/es/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function buildAssetList(assets) {
  return assets.map(function (c) {
    var assetId = c.get('id');
    return _react2.default.createElement(
      'li',
      { key: assetId },
      _react2.default.createElement(
        _reactRouterDom.Link,
        { to: '/assets/' + assetId },
        'Asset ID: ' + assetId
      )
    );
  });
}

function AssetsMapView(_ref) {
  var assets = _ref.assets;

  return _react2.default.createElement(
    'div',
    { style: { padding: '0.5rem' } },
    _react2.default.createElement(
      'h2',
      null,
      'TODO: Build MAP view'
    ),
    _react2.default.createElement(
      'ul',
      null,
      buildAssetList(assets)
    )
  );
}

AssetsMapView.propTypes = {
  assets: _reactImmutableProptypes2.default.listOf(_reactImmutableProptypes2.default.mapContains({
    id: _propTypes2.default.string
  })).isRequired
};

exports.default = AssetsMapView;

/***/ }),

/***/ "./components/AssetsPanel/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AssetsListView = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactImmutableProptypes = __webpack_require__("../node_modules/react-immutable-proptypes/dist/ImmutablePropTypes.js");

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _AssetDisplayContainer = __webpack_require__("./containers/AssetDisplayContainer/index.js");

var _AssetDisplayContainer2 = _interopRequireDefault(_AssetDisplayContainer);

var _CategoryHeader = __webpack_require__("./components/CategoryHeader/index.js");

var _CategoryHeader2 = _interopRequireDefault(_CategoryHeader);

var _paginateFavorites = __webpack_require__("./components/_common/paginateFavorites/index.js");

var _paginateFavorites2 = _interopRequireDefault(_paginateFavorites);

var _CardView = __webpack_require__("./components/_common/CardView/index.js");

var _CardView2 = _interopRequireDefault(_CardView);

var _PageContentPanel = __webpack_require__("./elements/PageContentPanel/index.js");

var _PageContentPanel2 = _interopRequireDefault(_PageContentPanel);

var _AssetsListView2 = __webpack_require__("./components/AssetsPanel/AssetsListView.js");

var _AssetsListView3 = _interopRequireDefault(_AssetsListView2);

var _AssetsMapView = __webpack_require__("./components/AssetsPanel/AssetsMapView.js");

var _AssetsMapView2 = _interopRequireDefault(_AssetsMapView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getAssetsView(assetsView) {
  switch (assetsView) {
    case 'list':
      return _AssetsListView3.default;
    case 'map':
      return _AssetsMapView2.default;
    case 'card':
    default:
      return _CardView2.default;
  }
}

var AssetsPanel = function (_Component) {
  _inherits(AssetsPanel, _Component);

  function AssetsPanel() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AssetsPanel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AssetsPanel.__proto__ || Object.getPrototypeOf(AssetsPanel)).call.apply(_ref, [this].concat(args))), _this), _this.buildPaginatedAssetsView = function (viewType) {
      // define the component that will be displayed with the super pagination powers.
      var AssetsView = getAssetsView(viewType);

      // add methods concerning pagination
      var paginationMethods = {
        requestNext: _this.props.requestNext
      };

      return (0, _paginateFavorites2.default)(paginationMethods)(AssetsView);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AssetsPanel, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.PaginatedAssetsView = this.buildPaginatedAssetsView(this.props.assetsView);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // If the users has changed view types, a new HOC wrapped component must be made.
      if (this.props.assetsView !== nextProps.assetsView) {
        this.PaginatedAssetsView = this.buildPaginatedAssetsView(nextProps.assetsView);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          assets = _props.assets,
          assetsRequesting = _props.assetsRequesting,
          refreshAssets = _props.refreshAssets,
          favoritePagination = _props.favoritePagination,
          latestFavorite = _props.latestFavorite;
      var PaginatedAssetsView = this.PaginatedAssetsView;


      var componentProps = {
        assets: assets,
        dataList: assets,
        requesting: assetsRequesting,
        favoritePagination: favoritePagination,
        CardComp: _AssetDisplayContainer2.default
      };

      return _react2.default.createElement(
        _PageContentPanel2.default,
        { id: 'assets-panel' },
        _react2.default.createElement(_CategoryHeader2.default, {
          favoritePagination: favoritePagination,
          refresh: refreshAssets,
          requesting: assetsRequesting,
          type: 'asset'
        }),
        _react2.default.createElement(PaginatedAssetsView, {
          componentProps: componentProps,
          favoritePagination: favoritePagination,
          noFavoritesMessage: latestFavorite.message,
          requestInProgress: assetsRequesting
        })
      );
    }
  }]);

  return AssetsPanel;
}(_react.Component);

AssetsPanel.propTypes = {
  assets: _reactImmutableProptypes2.default.list.isRequired,
  assetsRequesting: _propTypes2.default.bool,
  assetsView: _propTypes2.default.string.isRequired,
  favoritePagination: _reactImmutableProptypes2.default.map.isRequired,
  latestFavorite: _propTypes2.default.shape({
    message: _propTypes2.default.string
  }),
  refreshAssets: _propTypes2.default.func.isRequired,
  requestNext: _propTypes2.default.func.isRequired
};
AssetsPanel.defaultProps = {
  assetsRequesting: false,
  latestFavorite: {}
};
exports.default = AssetsPanel;
exports.AssetsListView = _AssetsListView3.default;

/***/ }),

/***/ "./components/AssetsPanel/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var formattedMessages = {
  engine: (0, _linguiReact.i18nMark)('Engine'),
  make: (0, _linguiReact.i18nMark)('Make'),
  model: (0, _linguiReact.i18nMark)('Model'),
  odometer: (0, _linguiReact.i18nMark)('Odometer'),
  other: (0, _linguiReact.i18nMark)('Other'),
  pmStatus: (0, _linguiReact.i18nMark)('Maintenance'),
  serial: (0, _linguiReact.i18nMark)('Serial No.'),
  unitNumber: (0, _linguiReact.i18nMark)('Unit'),
  vin: (0, _linguiReact.i18nMark)('VIN'),
  year: (0, _linguiReact.i18nMark)('Year')
};

exports.default = formattedMessages;

/***/ }),

/***/ "./components/BriefcaseIcon/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnstyledFontAwesome = UnstyledFontAwesome;

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactFontawesome = __webpack_require__("../node_modules/react-fontawesome/lib/index.js");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function UnstyledFontAwesome(props) {
  var componentProps = (0, _lodash.omit)(props, ['theme', 'modifiers']);
  return _react2.default.createElement(_reactFontawesome2.default, componentProps);
}

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  color: ' + props.theme.colors.brand.primary + ';\n  font-size: ' + (0, _decisivUiUtils.px2rem)(14) + ';\n  padding-right: ' + (0, _decisivUiUtils.px2rem)(6) + ';\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    brand: _propTypes2.default.shape({
      primary: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('BriefcaseIcon', (0, _styledComponents2.default)(UnstyledFontAwesome), styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/CaseDisplayElement/AdditionalInfo.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactImmutableProptypes = __webpack_require__("../node_modules/react-immutable-proptypes/dist/ImmutablePropTypes.js");

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _FollowUpLabel = __webpack_require__("./components/_common/FollowUpLabel/index.js");

var _FollowUpLabel2 = _interopRequireDefault(_FollowUpLabel);

var _UnreadNoteLabelContainer = __webpack_require__("./containers/UnreadNoteLabelContainer/index.js");

var _UnreadNoteLabelContainer2 = _interopRequireDefault(_UnreadNoteLabelContainer);

var _Card = __webpack_require__("./elements/Card/index.js");

var _SplitBlock = __webpack_require__("./elements/SplitBlock/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AdditionalInfo(_ref) {
  var caseInfo = _ref.caseInfo;

  var followUpColor = caseInfo.get('followUpColor');
  var followUpTime = caseInfo.get('followUpTime');

  return _react2.default.createElement(
    _Card.CardElement,
    null,
    _react2.default.createElement(
      _SplitBlock.SplitBlock,
      null,
      _react2.default.createElement(
        _SplitBlock.SplitBlockPart,
        { modifiers: ['left', 'wide'] },
        _react2.default.createElement(
          _SplitBlock.SplitBlockElement,
          { modifiers: ['padRight'] },
          _react2.default.createElement(_UnreadNoteLabelContainer2.default, { hasModal: true, caseInfo: caseInfo })
        ),
        _react2.default.createElement(
          _SplitBlock.SplitBlockElement,
          { modifiers: ['padLeft'] },
          _react2.default.createElement(_FollowUpLabel2.default, {
            followUpColor: followUpColor,
            followUpTime: followUpTime
          })
        )
      )
    )
  );
}

AdditionalInfo.propTypes = {
  caseInfo: _reactImmutableProptypes2.default.map.isRequired
};

exports.default = AdditionalInfo;

/***/ }),

/***/ "./components/CaseDisplayElement/AssetInfo.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactImmutableProptypes = __webpack_require__("../node_modules/react-immutable-proptypes/dist/ImmutablePropTypes.js");

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _widget = __webpack_require__("./utils/widget.js");

var _Card = __webpack_require__("./elements/Card/index.js");

var _Link = __webpack_require__("./elements/Link/index.js");

var _Link2 = _interopRequireDefault(_Link);

var _messages = __webpack_require__("./components/CaseDisplayElement/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AssetInfo(_ref) {
  var assetInfo = _ref.assetInfo;

  return _react2.default.createElement(
    _Card.CardElement,
    null,
    _react2.default.createElement(
      _Card.CardTable,
      { modifiers: ['uppercase'], tdModifiers: ['active', 'leftAlign'] },
      _react2.default.createElement(
        'tbody',
        null,
        _react2.default.createElement(
          _Card.CardTableRow,
          null,
          _react2.default.createElement(
            'th',
            null,
            _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.unit })
          ),
          _react2.default.createElement(
            'td',
            null,
            _react2.default.createElement(
              _Link2.default,
              { to: '/assets/' + assetInfo.get('id'), modifiers: ['hoverCaret'] },
              (0, _widget.getOutputText)(assetInfo.get('unitNumber'))
            )
          )
        ),
        _react2.default.createElement(
          _Card.CardTableRow,
          { type: 'topGap' },
          _react2.default.createElement(
            'th',
            null,
            _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.vin })
          ),
          _react2.default.createElement(
            'td',
            null,
            (0, _widget.getOutputText)(assetInfo.get('vinNumber'))
          )
        )
      )
    )
  );
}

AssetInfo.propTypes = {
  assetInfo: _reactImmutableProptypes2.default.contains({
    unitNumber: _propTypes2.default.string,
    vinNumber: _propTypes2.default.string
  }).isRequired
};

exports.default = AssetInfo;

/***/ }),

/***/ "./components/CaseDisplayElement/CaseCard.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactImmutableProptypes = __webpack_require__("../node_modules/react-immutable-proptypes/dist/ImmutablePropTypes.js");

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _Card = __webpack_require__("./elements/Card/index.js");

var _Card2 = _interopRequireDefault(_Card);

var _Divider = __webpack_require__("./elements/Divider/index.js");

var _Divider2 = _interopRequireDefault(_Divider);

var _AdditionalInfo = __webpack_require__("./components/CaseDisplayElement/AdditionalInfo.js");

var _AdditionalInfo2 = _interopRequireDefault(_AdditionalInfo);

var _AssetInfo = __webpack_require__("./components/CaseDisplayElement/AssetInfo.js");

var _AssetInfo2 = _interopRequireDefault(_AssetInfo);

var _CaseInfo = __webpack_require__("./components/CaseDisplayElement/CaseInfo.js");

var _CaseInfo2 = _interopRequireDefault(_CaseInfo);

var _CaseTitle = __webpack_require__("./components/CaseDisplayElement/CaseTitle.js");

var _CaseTitle2 = _interopRequireDefault(_CaseTitle);

var _Complaint = __webpack_require__("./components/CaseDisplayElement/Complaint.js");

var _Complaint2 = _interopRequireDefault(_Complaint);

var _ServiceProvider = __webpack_require__("./components/CaseDisplayElement/ServiceProvider.js");

var _ServiceProvider2 = _interopRequireDefault(_ServiceProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getCardModifier(_ref) {
  var selectionDisabled = _ref.selectionDisabled,
      isSelected = _ref.isSelected;

  if (selectionDisabled) {
    return 'noCursor';
  }
  if (isSelected) {
    return 'selected';
  }
  return 'selectable';
}

function CaseCard(_ref2) {
  var assetInfo = _ref2.assetInfo,
      caseInfo = _ref2.caseInfo,
      serviceProviderInfo = _ref2.serviceProviderInfo,
      onSelect = _ref2.onSelect,
      isSelected = _ref2.isSelected,
      selectionDisabled = _ref2.selectionDisabled;

  var cardModifier = getCardModifier({ selectionDisabled: selectionDisabled, isSelected: isSelected });

  return _react2.default.createElement(
    _Card2.default,
    { modifiers: [cardModifier], onClick: onSelect },
    _react2.default.createElement(_CaseTitle2.default, { caseInfo: caseInfo }),
    _react2.default.createElement(_Divider2.default, { modifiers: ['gutter', 'heavy'] }),
    _react2.default.createElement(_AssetInfo2.default, { assetInfo: assetInfo }),
    _react2.default.createElement(_Divider2.default, { modifiers: ['gutter', 'light', 'narrow'] }),
    _react2.default.createElement(_ServiceProvider2.default, { serviceProviderInfo: serviceProviderInfo }),
    _react2.default.createElement(_Divider2.default, { modifiers: ['gutter', 'light', 'narrow'] }),
    _react2.default.createElement(_Complaint2.default, { caseInfo: caseInfo }),
    _react2.default.createElement(_Divider2.default, { modifiers: ['gutter', 'light', 'narrow'] }),
    _react2.default.createElement(_CaseInfo2.default, { caseInfo: caseInfo }),
    _react2.default.createElement(_Divider2.default, { modifiers: ['gutter', 'heavy'] }),
    _react2.default.createElement(_AdditionalInfo2.default, { caseInfo: caseInfo })
  );
}

CaseCard.propTypes = {
  assetInfo: _reactImmutableProptypes2.default.contains({
    id: _propTypes2.default.string
  }).isRequired,
  caseInfo: _reactImmutableProptypes2.default.contains({
    id: _propTypes2.default.string
  }).isRequired,
  serviceProviderInfo: _reactImmutableProptypes2.default.contains({
    id: _propTypes2.default.string
  }).isRequired,
  onSelect: _propTypes2.default.func.isRequired,
  isSelected: _propTypes2.default.bool.isRequired,
  selectionDisabled: _propTypes2.default.bool.isRequired
};

exports.default = CaseCard;

/***/ }),

/***/ "./components/CaseDisplayElement/CaseInfo.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactImmutableProptypes = __webpack_require__("../node_modules/react-immutable-proptypes/dist/ImmutablePropTypes.js");

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _ETR = __webpack_require__("./components/_common/ETR/index.js");

var _ETR2 = _interopRequireDefault(_ETR);

var _Card = __webpack_require__("./elements/Card/index.js");

var _StatusSpan = __webpack_require__("./elements/StatusSpan/index.js");

var _StatusSpan2 = _interopRequireDefault(_StatusSpan);

var _Span = __webpack_require__("./elements/Span/index.js");

var _Span2 = _interopRequireDefault(_Span);

var _TextDiv = __webpack_require__("./elements/TextDiv/index.js");

var _TextDiv2 = _interopRequireDefault(_TextDiv);

var _widget = __webpack_require__("./utils/widget.js");

var _messages = __webpack_require__("./components/CaseDisplayElement/messages.js");

var _messages2 = _interopRequireDefault(_messages);

var _helpers = __webpack_require__("./components/CaseDisplayElement/helpers.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CaseInfo(_ref) {
  var caseInfo = _ref.caseInfo;

  var approvalStatus = caseInfo.get('approvalStatus');
  var approvalStatusModifier = approvalStatus && (0, _lodash.camelCase)(approvalStatus);
  var statusSpanModifiers = [approvalStatusModifier, 'bold', 'uppercase'];

  return _react2.default.createElement(
    _Card.CardElement,
    null,
    _react2.default.createElement(
      _Card.CardTable,
      { thModifiers: ['wide'], tdModifiers: ['leftAlign', 'midGreyText'] },
      _react2.default.createElement(
        'tbody',
        null,
        _react2.default.createElement(
          _Card.CardTableRow,
          null,
          _react2.default.createElement(
            'th',
            null,
            _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.status })
          ),
          _react2.default.createElement(
            'td',
            null,
            (0, _widget.getOutputText)(caseInfo.get('repairStatus'))
          )
        ),
        _react2.default.createElement(
          _Card.CardTableRow,
          { type: 'topGap' },
          _react2.default.createElement(
            'th',
            null,
            _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.etr })
          ),
          _react2.default.createElement(
            'td',
            null,
            _react2.default.createElement(_ETR2.default, { caseInfo: caseInfo })
          )
        ),
        _react2.default.createElement(
          _Card.CardTableRow,
          { type: 'topGap' },
          _react2.default.createElement(
            'th',
            null,
            _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.created })
          ),
          _react2.default.createElement(
            'td',
            null,
            _react2.default.createElement(
              _Span2.default,
              { modifiers: ['capitalize'] },
              (0, _widget.getOutputText)((0, _helpers.getCaseCreated)(caseInfo))
            )
          )
        ),
        _react2.default.createElement(
          _Card.CardTableRow,
          { type: 'topGap' },
          _react2.default.createElement(
            'th',
            null,
            _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.estimate })
          ),
          _react2.default.createElement(
            'td',
            null,
            _react2.default.createElement(
              _TextDiv2.default,
              { modifiers: ['bottomGap'] },
              (0, _widget.getOutputText)(caseInfo.get('estimateTotal'))
            ),
            _react2.default.createElement(
              _StatusSpan2.default,
              { modifiers: (0, _lodash.compact)(statusSpanModifiers) },
              approvalStatus
            )
          )
        )
      )
    )
  );
}

CaseInfo.propTypes = {
  caseInfo: _reactImmutableProptypes2.default.contains({
    estimateTotal: _propTypes2.default.string,
    approvalStatus: _propTypes2.default.string,
    repairStatus: _propTypes2.default.string,
    etr: _propTypes2.default.string,
    downtime: _propTypes2.default.string
  }).isRequired
};

exports.default = CaseInfo;

/***/ }),

/***/ "./components/CaseDisplayElement/CaseListRow.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactImmutableProptypes = __webpack_require__("../node_modules/react-immutable-proptypes/dist/ImmutablePropTypes.js");

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _UnreadNoteLabelContainer = __webpack_require__("./containers/UnreadNoteLabelContainer/index.js");

var _UnreadNoteLabelContainer2 = _interopRequireDefault(_UnreadNoteLabelContainer);

var _ETR = __webpack_require__("./components/_common/ETR/index.js");

var _ETR2 = _interopRequireDefault(_ETR);

var _FollowUpLabel = __webpack_require__("./components/_common/FollowUpLabel/index.js");

var _FollowUpLabel2 = _interopRequireDefault(_FollowUpLabel);

var _SeverityLabel = __webpack_require__("./components/SeverityLabel/index.js");

var _SeverityLabel2 = _interopRequireDefault(_SeverityLabel);

var _BorderedStatus = __webpack_require__("./elements/BorderedStatus/index.js");

var _BorderedStatus2 = _interopRequireDefault(_BorderedStatus);

var _Link = __webpack_require__("./elements/Link/index.js");

var _Link2 = _interopRequireDefault(_Link);

var _baseComponents = __webpack_require__("../node_modules/base-components/build/index.js");

var _Popover = __webpack_require__("./elements/Popover/index.js");

var _Popover2 = _interopRequireDefault(_Popover);

var _StatusSpan = __webpack_require__("./elements/StatusSpan/index.js");

var _StatusSpan2 = _interopRequireDefault(_StatusSpan);

var _Span = __webpack_require__("./elements/Span/index.js");

var _Span2 = _interopRequireDefault(_Span);

var _TextDiv = __webpack_require__("./elements/TextDiv/index.js");

var _TextDiv2 = _interopRequireDefault(_TextDiv);

var _widget = __webpack_require__("./utils/widget.js");

var _complaint = __webpack_require__("./utils/complaint.js");

var _complaint2 = _interopRequireDefault(_complaint);

var _StatusPopoverContent = __webpack_require__("./components/CaseDisplayElement/StatusPopoverContent.js");

var _StatusPopoverContent2 = _interopRequireDefault(_StatusPopoverContent);

var _StatusPopoverTable = __webpack_require__("./components/CaseDisplayElement/StatusPopoverTable.js");

var _StatusPopoverTable2 = _interopRequireDefault(_StatusPopoverTable);

var _messages = __webpack_require__("./components/CaseDisplayElement/messages.js");

var _messages2 = _interopRequireDefault(_messages);

var _helpers = __webpack_require__("./components/CaseDisplayElement/helpers.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getRowModifier(_ref) {
  var selectionDisabled = _ref.selectionDisabled,
      isSelected = _ref.isSelected;

  if (selectionDisabled) {
    return undefined;
  }
  if (isSelected) {
    return 'selected';
  }
  return 'selectableHover';
}

function CaseListRow(_ref2) {
  var caseInfo = _ref2.caseInfo,
      assetInfo = _ref2.assetInfo,
      onSelect = _ref2.onSelect,
      isSelected = _ref2.isSelected,
      selectionDisabled = _ref2.selectionDisabled;

  var caseId = caseInfo.get('id');
  var assetUnitNumber = assetInfo.get('unitNumber');
  var assetVINNumber = assetInfo.get('vinNumber');
  var providerName = caseInfo.getIn(['defaultRecipient', 'group', 'companyName']);

  var _getComplaintText = (0, _complaint2.default)(caseInfo.toJS(), { titleInLink: false }),
      complaintTitle = _getComplaintText.title,
      complaintContent = _getComplaintText.content;

  var closedAt = caseInfo.get('closedAt');
  var openOrClosed = closedAt ? 'closed' : 'open';
  var repairStatus = caseInfo.get('repairStatus');
  var estimateTotal = caseInfo.get('estimateTotal');
  var approvalStatus = caseInfo.get('approvalStatus');
  var approvalStatusModifier = approvalStatus && (0, _lodash.camelCase)(approvalStatus);
  var caseCreated = (0, _helpers.getCaseCreated)(caseInfo);
  var severityColor = caseInfo.get('severityColor');
  var severityCount = Number(caseInfo.get('severityCount'));
  var followUpColor = caseInfo.get('followUpColor');
  var followUpTime = caseInfo.get('followUpTime');
  var rowModifier = getRowModifier({ selectionDisabled: selectionDisabled, isSelected: isSelected });
  return _react2.default.createElement(
    _baseComponents.ListTable.Row,
    {
      modifiers: (0, _lodash.compact)(['lined', rowModifier]),
      onClick: onSelect
    },
    _react2.default.createElement(
      _baseComponents.ListTable.Data,
      null,
      _react2.default.createElement(
        _Link2.default,
        {
          to: '/cases/' + caseId,
          modifiers: ['heavy', 'uppercase']
        },
        _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.title, values: { caseId: caseId } })
      )
    ),
    _react2.default.createElement(
      _baseComponents.ListTable.Data,
      null,
      _react2.default.createElement(
        _Popover2.default,
        {
          showOnHover: true,
          position: 'right',
          positionOffset: 35
        },
        _react2.default.createElement(
          _Popover.PopoverTarget,
          null,
          _react2.default.createElement(
            _BorderedStatus2.default,
            { modifiers: [openOrClosed] },
            openOrClosed
          )
        ),
        _react2.default.createElement(
          _Popover.PopoverContent,
          null,
          _react2.default.createElement(
            _StatusPopoverContent2.default,
            null,
            _react2.default.createElement(
              _TextDiv2.default,
              { modifiers: ['uppercase', 'xSmallText'] },
              _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.statusPopoverTitle })
            ),
            _react2.default.createElement(
              _StatusPopoverTable2.default,
              { modifiers: ['smallText'] },
              _react2.default.createElement(
                'tbody',
                null,
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'th',
                    null,
                    _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.statusPopoverCaseStatus })
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(
                      _BorderedStatus2.default,
                      { modifiers: [openOrClosed] },
                      openOrClosed
                    )
                  )
                ),
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'th',
                    null,
                    _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.statusPopoverRepairStatus })
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    (0, _widget.getOutputText)(repairStatus, _messages2.default.status)
                  )
                )
              )
            )
          )
        )
      )
    ),
    _react2.default.createElement(
      _baseComponents.ListTable.Data,
      null,
      _react2.default.createElement(
        _Link2.default,
        { to: '/assets/' + assetInfo.get('id') },
        (0, _widget.getOutputText)(assetUnitNumber, _messages2.default.unit)
      )
    ),
    _react2.default.createElement(
      _baseComponents.ListTable.Data,
      { flex: 1.5, minWidth: 150 },
      (0, _widget.getOutputText)(assetVINNumber)
    ),
    _react2.default.createElement(
      _baseComponents.ListTable.Data,
      { flex: 1.5, minWidth: 150 },
      _react2.default.createElement(
        _TextDiv2.default,
        { modifiers: ['ellipsis', 'short', 'smallWidth'] },
        (0, _widget.getOutputText)(providerName)
      )
    ),
    _react2.default.createElement(
      _baseComponents.ListTable.Data,
      { flex: 2, minWidth: 200 },
      _react2.default.createElement(
        _Popover2.default,
        { showOnHover: true },
        _react2.default.createElement(
          _Popover.PopoverTarget,
          null,
          _react2.default.createElement(
            _TextDiv2.default,
            {
              modifiers: ['bottomGap', 'heavyText', 'ellipsis', 'oneLine', 'smallText', 'smallWidth']
            },
            complaintTitle
          ),
          _react2.default.createElement(
            _TextDiv2.default,
            { modifiers: ['ellipsis', 'short', 'smallWidth'] },
            complaintContent
          )
        ),
        _react2.default.createElement(
          _Popover.PopoverContent,
          null,
          _react2.default.createElement(
            _Popover.ScrollingPopoverContentWrapper,
            { modifiers: ['smallText'] },
            _react2.default.createElement(
              _TextDiv2.default,
              { modifiers: ['bold', 'bright', 'bottomGap'] },
              complaintTitle
            ),
            _react2.default.createElement(
              _TextDiv2.default,
              { modifiers: ['bottomGap'] },
              complaintContent
            )
          )
        )
      )
    ),
    _react2.default.createElement(
      _baseComponents.ListTable.Data,
      null,
      _react2.default.createElement(
        _TextDiv2.default,
        null,
        (0, _widget.getOutputText)(estimateTotal, _messages2.default.estimate)
      ),
      _react2.default.createElement(
        _StatusSpan2.default,
        { modifiers: (0, _lodash.compact)([approvalStatusModifier, 'bold', 'tall', 'uppercase']) },
        approvalStatus
      )
    ),
    _react2.default.createElement(
      _baseComponents.ListTable.Data,
      { className: 'etr' },
      _react2.default.createElement(_ETR2.default, { caseInfo: caseInfo, maxWidth: '6rem' })
    ),
    _react2.default.createElement(
      _baseComponents.ListTable.Data,
      null,
      _react2.default.createElement(
        _Span2.default,
        { modifiers: ['capitalize'] },
        (0, _widget.getOutputText)(caseCreated, _messages2.default.created)
      )
    ),
    _react2.default.createElement(
      _baseComponents.ListTable.Data,
      null,
      _react2.default.createElement(_SeverityLabel2.default, {
        color: severityColor,
        value: severityCount,
        small: true
      })
    ),
    _react2.default.createElement(
      _baseComponents.ListTable.Data,
      { flex: 1.5, minWidth: 150 },
      _react2.default.createElement(_UnreadNoteLabelContainer2.default, { hasModal: true, caseInfo: caseInfo })
    ),
    _react2.default.createElement(
      _baseComponents.ListTable.Data,
      null,
      _react2.default.createElement(_FollowUpLabel2.default, {
        followUpColor: followUpColor,
        followUpTime: followUpTime
      })
    )
  );
}

CaseListRow.propTypes = {
  assetInfo: _reactImmutableProptypes2.default.contains({
    id: _propTypes2.default.string
  }).isRequired,
  caseInfo: _reactImmutableProptypes2.default.contains({
    id: _propTypes2.default.string
  }).isRequired,
  onSelect: _propTypes2.default.func.isRequired,
  isSelected: _propTypes2.default.bool.isRequired,
  selectionDisabled: _propTypes2.default.bool.isRequired
};

exports.default = CaseListRow;

/***/ }),

/***/ "./components/CaseDisplayElement/CaseTitle.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactImmutableProptypes = __webpack_require__("../node_modules/react-immutable-proptypes/dist/ImmutablePropTypes.js");

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _SeverityLabel = __webpack_require__("./components/SeverityLabel/index.js");

var _SeverityLabel2 = _interopRequireDefault(_SeverityLabel);

var _Card = __webpack_require__("./elements/Card/index.js");

var _Link = __webpack_require__("./elements/Link/index.js");

var _Link2 = _interopRequireDefault(_Link);

var _SplitBlock = __webpack_require__("./elements/SplitBlock/index.js");

var _messages = __webpack_require__("./components/CaseDisplayElement/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CaseTitle(_ref) {
  var caseInfo = _ref.caseInfo;

  var caseId = caseInfo.get('id');

  return _react2.default.createElement(
    _Card.CardElement,
    null,
    _react2.default.createElement(
      _SplitBlock.SplitBlock,
      null,
      _react2.default.createElement(
        _SplitBlock.SplitBlockPart,
        { modifiers: ['left', 'wide'] },
        _react2.default.createElement(
          _SplitBlock.SplitBlockElement,
          { modifiers: ['padRight'] },
          _react2.default.createElement(
            _Link2.default,
            {
              to: '/cases/' + caseId,
              modifiers: ['heavy', 'uppercase']
            },
            _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.title, values: { caseId: caseId } })
          )
        ),
        _react2.default.createElement(
          _SplitBlock.SplitBlockElement,
          { modifiers: ['padLeft'] },
          _react2.default.createElement(_SeverityLabel2.default, {
            color: caseInfo.get('severityColor'),
            value: Number(caseInfo.get('severityCount')),
            small: true
          })
        )
      )
    )
  );
}

CaseTitle.propTypes = {
  caseInfo: _reactImmutableProptypes2.default.contains({
    id: _propTypes2.default.string,
    severityColor: _propTypes2.default.string,
    severityCount: _propTypes2.default.string
  }).isRequired
};

exports.default = CaseTitle;

/***/ }),

/***/ "./components/CaseDisplayElement/Complaint.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactImmutableProptypes = __webpack_require__("../node_modules/react-immutable-proptypes/dist/ImmutablePropTypes.js");

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _complaint = __webpack_require__("./utils/complaint.js");

var _complaint2 = _interopRequireDefault(_complaint);

var _Card = __webpack_require__("./elements/Card/index.js");

var _Popover = __webpack_require__("./elements/Popover/index.js");

var _Popover2 = _interopRequireDefault(_Popover);

var _TextDiv = __webpack_require__("./elements/TextDiv/index.js");

var _TextDiv2 = _interopRequireDefault(_TextDiv);

var _messages = __webpack_require__("./components/CaseDisplayElement/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Complaint(_ref) {
  var caseInfo = _ref.caseInfo;

  var _getComplaintText = (0, _complaint2.default)(caseInfo.toJS(), { titleInLink: false }),
      title = _getComplaintText.title,
      content = _getComplaintText.content;

  return _react2.default.createElement(
    _Card.CardElement,
    null,
    _react2.default.createElement(
      _Popover2.default,
      { showOnHover: true },
      _react2.default.createElement(
        _Popover.PopoverTarget,
        null,
        _react2.default.createElement(
          _TextDiv2.default,
          { modifiers: ['bold', 'bottomGap', 'smallText'] },
          _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.complaintTitle })
        ),
        _react2.default.createElement(
          _TextDiv2.default,
          { modifiers: ['bottomGap', 'heavyText', 'ellipsis', 'oneLine', 'smallText'] },
          title
        ),
        _react2.default.createElement(
          _TextDiv2.default,
          { modifiers: ['ellipsis', 'midGreyText', 'short', 'smallText'] },
          content
        )
      ),
      _react2.default.createElement(
        _Popover.PopoverContent,
        null,
        _react2.default.createElement(
          _Popover.ScrollingPopoverContentWrapper,
          { modifiers: ['smallText'] },
          _react2.default.createElement(
            _TextDiv2.default,
            { modifiers: ['bold', 'bright', 'bottomGap'] },
            title
          ),
          _react2.default.createElement(
            _TextDiv2.default,
            { modifiers: ['bottomGap'] },
            content
          )
        )
      )
    )
  );
}

Complaint.propTypes = {
  caseInfo: _reactImmutableProptypes2.default.contains({
    complaint: _propTypes2.default.shape({
      code: _propTypes2.default.string,
      description: _propTypes2.default.string
    }),
    description: _propTypes2.default.string
  }).isRequired
};

exports.default = Complaint;

/***/ }),

/***/ "./components/CaseDisplayElement/ServiceProvider.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactImmutableProptypes = __webpack_require__("../node_modules/react-immutable-proptypes/dist/ImmutablePropTypes.js");

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _Card = __webpack_require__("./elements/Card/index.js");

var _TextDiv = __webpack_require__("./elements/TextDiv/index.js");

var _TextDiv2 = _interopRequireDefault(_TextDiv);

var _widget = __webpack_require__("./utils/widget.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ServiceProvider(_ref) {
  var serviceProviderInfo = _ref.serviceProviderInfo;

  var companyName = serviceProviderInfo.get('companyName');
  return _react2.default.createElement(
    _Card.CardElement,
    null,
    _react2.default.createElement(
      _TextDiv2.default,
      { modifiers: ['active', 'bold', 'ellipsis', 'oneLine', 'smallText'] },
      (0, _widget.getOutputText)(companyName)
    )
  );
}

ServiceProvider.propTypes = {
  serviceProviderInfo: _reactImmutableProptypes2.default.contains({
    companyName: _propTypes2.default.string
  }).isRequired
};

exports.default = ServiceProvider;

/***/ }),

/***/ "./components/CaseDisplayElement/StatusPopoverContent.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  color: ' + props.theme.colors.base.text + ';\n  padding: ' + (0, _decisivUiUtils.px2rem)(13) + ' ' + (0, _decisivUiUtils.px2rem)(18) + ' ' + (0, _decisivUiUtils.px2rem)(13) + ' ' + (0, _decisivUiUtils.px2rem)(12) + ';\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('StatusPopoverContent', _styledComponents2.default.div, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/CaseDisplayElement/StatusPopoverTable.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _Table = __webpack_require__("./elements/Table/index.js");

var _Table2 = _interopRequireDefault(_Table);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  margin-top: ' + (0, _decisivUiUtils.px2rem)(6) + ';\n  th {\n    color: ' + props.theme.colors.base.text + ';\n    font-weight: bold !important;\n    min-width: ' + (0, _decisivUiUtils.px2rem)(130) + ';\n    padding: 0 0 ' + (0, _decisivUiUtils.px2rem)(4) + ';\n  }\n  td {\n    color: ' + props.theme.colors.base.text + ';\n    font-size: ' + (0, _decisivUiUtils.px2rem)(10) + ';\n    font-weight: normal !important;\n    min-width: 0;\n    padding: 0;\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('StatusPopoverTable', (0, _styledComponents2.default)(_Table2.default), styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/CaseDisplayElement/helpers.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCaseCreated = getCaseCreated;

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _decisivDomainUtils = __webpack_require__("../node_modules/decisiv-domain-utils/build/index.js");

var _momentTimezone = __webpack_require__("../node_modules/moment-timezone/index.js");

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _timeUtils = __webpack_require__("./utils/timeUtils.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Get and format the relative case creation date/time from the given
 * case information
 *
 * @param caseInfo - an immutable map of case information
 */
/* eslint-disable import/prefer-default-export */
function getCaseCreated(caseInfo) {
  var requestedAt = caseInfo.get('requestedAt');
  return requestedAt && _react2.default.createElement(_decisivDomainUtils.FormattedRelative, {
    render: function render(relativeTime) {
      return _react2.default.createElement(
        'span',
        null,
        relativeTime
      );
    },
    value: _momentTimezone2.default.tz(requestedAt, (0, _timeUtils.userTimeZone)())
  });
}

/***/ }),

/***/ "./components/CaseDisplayElement/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CaseListRow = exports.CaseCard = undefined;

var _CaseCard2 = __webpack_require__("./components/CaseDisplayElement/CaseCard.js");

var _CaseCard3 = _interopRequireDefault(_CaseCard2);

var _CaseListRow2 = __webpack_require__("./components/CaseDisplayElement/CaseListRow.js");

var _CaseListRow3 = _interopRequireDefault(_CaseListRow2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = './CaseCard';
exports.CaseCard = _CaseCard3.default;
exports.CaseListRow = _CaseListRow3.default;

/***/ }),

/***/ "./components/CaseDisplayElement/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var formattedMessages = {
  title: (0, _linguiReact.i18nMark)('#{caseId}'),
  complaintTitle: (0, _linguiReact.i18nMark)('Complaint'),
  created: (0, _linguiReact.i18nMark)('Created'),
  estimate: (0, _linguiReact.i18nMark)('Estimate'),
  etr: (0, _linguiReact.i18nMark)('ETR'),
  status: (0, _linguiReact.i18nMark)('Status'),
  statusPopoverCaseStatus: (0, _linguiReact.i18nMark)('Case Status'),
  statusPopoverRepairStatus: (0, _linguiReact.i18nMark)('Repair Status'),
  statusPopoverTitle: (0, _linguiReact.i18nMark)('Status'),
  undefinedServiceProvider: (0, _linguiReact.i18nMark)('Service Provider'),
  unit: (0, _linguiReact.i18nMark)('Unit'),
  vin: (0, _linguiReact.i18nMark)('VIN')
};

exports.default = formattedMessages;

/***/ }),

/***/ "./components/CasesPanel/CasesListView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__("../node_modules/immutable/dist/immutable.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactImmutableProptypes = __webpack_require__("../node_modules/react-immutable-proptypes/dist/ImmutablePropTypes.js");

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _reactStickyFill = __webpack_require__("../node_modules/react-sticky-fill/lib/index.js");

var _reactStickyFill2 = _interopRequireDefault(_reactStickyFill);

var _baseComponents = __webpack_require__("../node_modules/base-components/build/index.js");

var _CaseDisplayContainer = __webpack_require__("./containers/CaseDisplayContainer/index.js");

var _CaseDisplayContainer2 = _interopRequireDefault(_CaseDisplayContainer);

var _favorites = __webpack_require__("./utils/favorites.js");

var _ListRowLoading = __webpack_require__("./components/_common/ListRowLoading/index.js");

var _ListRowLoading2 = _interopRequireDefault(_ListRowLoading);

var _messages = __webpack_require__("./components/CasesPanel/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MAX_LOADING_ROWS = 10;

function renderCaseList(cases, isResultsPage) {
  return cases.map(function (caseInfo) {
    var caseId = caseInfo.get('id');
    return _react2.default.createElement(_CaseDisplayContainer2.default, {
      datum: caseInfo,
      selectionDisabled: isResultsPage,
      key: caseId,
      type: 'list'
    });
  });
}

function renderGhostRows(cases, favoritePagination, requesting) {
  if (!(0, _favorites.shouldBuildLoadingGhosts)({ currentCount: cases.size, favoritePagination: favoritePagination, requesting: requesting })) {
    return null;
  }
  var totalCount = favoritePagination.get('totalCount');
  var count = totalCount ? Math.min(MAX_LOADING_ROWS, totalCount - cases.size) : MAX_LOADING_ROWS;
  return Array.from({ length: count }, function (_, i) {
    return _react2.default.createElement(_ListRowLoading2.default, {
      key: i,
      columnSpans: [1, 3, 2, 4, 2]
    });
  });
}

function CasesListView(_ref) {
  var cases = _ref.cases,
      favoritePagination = _ref.favoritePagination,
      isResultsPage = _ref.isResultsPage,
      requesting = _ref.requesting;

  return _react2.default.createElement(
    _baseComponents.ListTable,
    null,
    _react2.default.createElement(
      _reactStickyFill2.default,
      { style: { top: '80px' } },
      _react2.default.createElement(
        _baseComponents.ListTable.Head,
        null,
        _react2.default.createElement(
          _baseComponents.ListTable.Header,
          null,
          _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.caseNumber })
        ),
        _react2.default.createElement(
          _baseComponents.ListTable.Header,
          null,
          _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.status })
        ),
        _react2.default.createElement(
          _baseComponents.ListTable.Header,
          null,
          _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.unitNumber })
        ),
        _react2.default.createElement(
          _baseComponents.ListTable.Header,
          { flex: 1.5, minWidth: 150 },
          _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.vinNumber })
        ),
        _react2.default.createElement(
          _baseComponents.ListTable.Header,
          { flex: 1.5, minWidth: 150 },
          _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.serviceProvider })
        ),
        _react2.default.createElement(
          _baseComponents.ListTable.Header,
          { flex: 2, minWidth: 200 },
          _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.complaint })
        ),
        _react2.default.createElement(
          _baseComponents.ListTable.Header,
          null,
          _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.estimate })
        ),
        _react2.default.createElement(
          _baseComponents.ListTable.Header,
          null,
          _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.etr })
        ),
        _react2.default.createElement(
          _baseComponents.ListTable.Header,
          null,
          _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.created })
        ),
        _react2.default.createElement(
          _baseComponents.ListTable.Header,
          null,
          _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.severity })
        ),
        _react2.default.createElement(
          _baseComponents.ListTable.Header,
          { flex: 1.5, minWidth: 150 },
          _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.notes })
        ),
        _react2.default.createElement(
          _baseComponents.ListTable.Header,
          null,
          _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.followup })
        )
      )
    ),
    _react2.default.createElement(
      _baseComponents.ListTable.Body,
      null,
      renderCaseList(cases, isResultsPage),
      renderGhostRows(cases, favoritePagination, requesting)
    )
  );
}

CasesListView.propTypes = {
  cases: _reactImmutableProptypes2.default.listOf(_reactImmutableProptypes2.default.mapContains({
    id: _propTypes2.default.string
  })).isRequired,
  favoritePagination: _reactImmutableProptypes2.default.map.isRequired,
  isResultsPage: _propTypes2.default.bool,
  requesting: _propTypes2.default.bool.isRequired
};

CasesListView.defaultProps = {
  favoritePagination: (0, _immutable.Map)(),
  isResultsPage: false,
  requesting: false
};

exports.default = CasesListView;

/***/ }),

/***/ "./components/CasesPanel/CasesMapView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactImmutableProptypes = __webpack_require__("../node_modules/react-immutable-proptypes/dist/ImmutablePropTypes.js");

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _reactRouterDom = __webpack_require__("../node_modules/react-router-dom/es/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function buildCaseList(cases) {
  return cases.map(function (c) {
    var caseId = c.get('id');
    return _react2.default.createElement(
      'li',
      { key: caseId },
      _react2.default.createElement(
        _reactRouterDom.Link,
        { to: '/cases/' + caseId },
        'Case ID: ' + caseId
      )
    );
  });
}

function CasesMapView(_ref) {
  var cases = _ref.cases;

  return _react2.default.createElement(
    'div',
    { style: { padding: '0.5rem' } },
    _react2.default.createElement(
      'h2',
      null,
      'TODO: Build MAP view'
    ),
    _react2.default.createElement(
      'ul',
      null,
      buildCaseList(cases)
    )
  );
}

CasesMapView.propTypes = {
  cases: _reactImmutableProptypes2.default.listOf(_reactImmutableProptypes2.default.mapContains({
    id: _propTypes2.default.string
  })).isRequired
};

exports.default = CasesMapView;

/***/ }),

/***/ "./components/CasesPanel/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CasesListView = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactImmutableProptypes = __webpack_require__("../node_modules/react-immutable-proptypes/dist/ImmutablePropTypes.js");

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _CaseDisplayContainer = __webpack_require__("./containers/CaseDisplayContainer/index.js");

var _CaseDisplayContainer2 = _interopRequireDefault(_CaseDisplayContainer);

var _CategoryHeader = __webpack_require__("./components/CategoryHeader/index.js");

var _CategoryHeader2 = _interopRequireDefault(_CategoryHeader);

var _paginateFavorites = __webpack_require__("./components/_common/paginateFavorites/index.js");

var _paginateFavorites2 = _interopRequireDefault(_paginateFavorites);

var _CardView = __webpack_require__("./components/_common/CardView/index.js");

var _CardView2 = _interopRequireDefault(_CardView);

var _PageContentPanel = __webpack_require__("./elements/PageContentPanel/index.js");

var _PageContentPanel2 = _interopRequireDefault(_PageContentPanel);

var _CasesListView2 = __webpack_require__("./components/CasesPanel/CasesListView.js");

var _CasesListView3 = _interopRequireDefault(_CasesListView2);

var _CasesMapView = __webpack_require__("./components/CasesPanel/CasesMapView.js");

var _CasesMapView2 = _interopRequireDefault(_CasesMapView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getCasesView(casesView) {
  switch (casesView) {
    case 'list':
      return _CasesListView3.default;
    case 'map':
      return _CasesMapView2.default;
    case 'card':
    default:
      return _CardView2.default;
  }
}

var CasesPanel = function (_Component) {
  _inherits(CasesPanel, _Component);

  function CasesPanel() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CasesPanel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CasesPanel.__proto__ || Object.getPrototypeOf(CasesPanel)).call.apply(_ref, [this].concat(args))), _this), _this.buildPaginatedCasesView = function (viewType) {
      // define the component that will be displayed with the super pagination powers.
      var CasesView = getCasesView(viewType);

      // add methods concerning pagination
      var paginationMethods = {
        requestNext: _this.props.requestNext
      };

      return (0, _paginateFavorites2.default)(paginationMethods)(CasesView);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CasesPanel, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.PaginatedCasesView = this.buildPaginatedCasesView(this.props.casesView);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // If the users has changed view types, a new HOC wrapped component must be made.
      if (this.props.casesView !== nextProps.casesView) {
        this.PaginatedCasesView = this.buildPaginatedCasesView(nextProps.casesView);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          cases = _props.cases,
          casesRequesting = _props.casesRequesting,
          refreshCases = _props.refreshCases,
          favoritePagination = _props.favoritePagination,
          latestFavorite = _props.latestFavorite;
      var PaginatedCasesView = this.PaginatedCasesView;


      var componentProps = {
        cases: cases,
        dataList: cases,
        requesting: casesRequesting,
        favoritePagination: favoritePagination,
        CardComp: _CaseDisplayContainer2.default
      };

      return _react2.default.createElement(
        _PageContentPanel2.default,
        { id: 'cases-panel' },
        _react2.default.createElement(_CategoryHeader2.default, {
          refresh: refreshCases,
          requesting: casesRequesting,
          favoritePagination: favoritePagination,
          type: 'case'
        }),
        _react2.default.createElement(PaginatedCasesView, {
          componentProps: componentProps,
          favoritePagination: favoritePagination,
          noFavoritesMessage: latestFavorite.message,
          requestInProgress: casesRequesting
        })
      );
    }
  }]);

  return CasesPanel;
}(_react.Component);

CasesPanel.propTypes = {
  cases: _reactImmutableProptypes2.default.list.isRequired,
  casesRequesting: _propTypes2.default.bool,
  casesView: _propTypes2.default.string.isRequired,
  favoritePagination: _reactImmutableProptypes2.default.map.isRequired,
  latestFavorite: _propTypes2.default.shape({
    message: _propTypes2.default.string
  }),
  refreshCases: _propTypes2.default.func.isRequired,
  requestNext: _propTypes2.default.func.isRequired
};
CasesPanel.defaultProps = {
  casesRequesting: false,
  latestFavorite: {}
};
exports.default = CasesPanel;
exports.CasesListView = _CasesListView3.default;

/***/ }),

/***/ "./components/CasesPanel/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var formattedMessages = {
  caseNumber: (0, _linguiReact.i18nMark)('Case'),
  complaint: (0, _linguiReact.i18nMark)('Complaint'),
  created: (0, _linguiReact.i18nMark)('Created'),
  estimate: (0, _linguiReact.i18nMark)('Estimate'),
  etr: (0, _linguiReact.i18nMark)('ETR'),
  followup: (0, _linguiReact.i18nMark)('Follow-Up'),
  notes: (0, _linguiReact.i18nMark)('Notes'),
  serviceProvider: (0, _linguiReact.i18nMark)('Service Provider'),
  severity: (0, _linguiReact.i18nMark)('Severity'),
  status: (0, _linguiReact.i18nMark)('Status'),
  unitNumber: (0, _linguiReact.i18nMark)('Unit'),
  vinNumber: (0, _linguiReact.i18nMark)('VIN')
};

exports.default = formattedMessages;

/***/ }),

/***/ "./components/CategoryHeader/Wrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  background-color: ' + props.theme.colors.base.chrome100 + ';\n  border: 1px solid ' + props.theme.colors.base.chrome200 + ';\n  margin: 0 ' + (0, _decisivUiUtils.px2rem)(8) + ';\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome100: _propTypes2.default.string.isRequired,
      chrome200: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Wrapper', _styledComponents2.default.div, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/CategoryHeader/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactImmutableProptypes = __webpack_require__("../node_modules/react-immutable-proptypes/dist/ImmutablePropTypes.js");

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _RefreshBlock = __webpack_require__("./components/RefreshBlock/index.js");

var _RefreshBlock2 = _interopRequireDefault(_RefreshBlock);

var _SplitBlock = __webpack_require__("./elements/SplitBlock/index.js");

var _Wrapper = __webpack_require__("./components/CategoryHeader/Wrapper.js");

var _Wrapper2 = _interopRequireDefault(_Wrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CategoryHeader(_ref) {
  var favoritePagination = _ref.favoritePagination,
      requesting = _ref.requesting,
      refresh = _ref.refresh,
      type = _ref.type;

  return _react2.default.createElement(
    _Wrapper2.default,
    { id: 'category-header' },
    _react2.default.createElement(
      _SplitBlock.SplitBlock,
      { modifiers: ['pad'] },
      _react2.default.createElement(
        _SplitBlock.SplitBlockPart,
        { modifiers: ['right'] },
        _react2.default.createElement(
          _SplitBlock.SplitBlockElement,
          { modifiers: ['padLeft'] },
          _react2.default.createElement(_RefreshBlock2.default, {
            type: type,
            count: favoritePagination.get('totalCount'),
            requesting: requesting,
            refresh: refresh
          })
        )
      )
    )
  );
}

CategoryHeader.propTypes = {
  requesting: _propTypes2.default.bool,
  refresh: _propTypes2.default.func.isRequired,
  favoritePagination: _reactImmutableProptypes2.default.map.isRequired,
  type: _propTypes2.default.string.isRequired
};

CategoryHeader.defaultProps = {
  requesting: false
};

exports.default = CategoryHeader;

/***/ }),

/***/ "./components/DangerousHtmlMessage/TextWithLinks.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  a {\n    color: ' + props.theme.colors.base.link + ';\n    text-decoration: none;\n    &:hover {\n      color: ' + props.theme.colors.base.linkHover + ';\n      text-decoration: underline;\n    }\n    cursor: pointer;\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      link: _propTypes2.default.string.isRequired,
      linkHover: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('TextWithLinks', _styledComponents2.default.p, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/DangerousHtmlMessage/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dompurify = __webpack_require__("../node_modules/dompurify/dist/purify.js");

var _dompurify2 = _interopRequireDefault(_dompurify);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _TextWithLinks = __webpack_require__("./components/DangerousHtmlMessage/TextWithLinks.js");

var _TextWithLinks2 = _interopRequireDefault(_TextWithLinks);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SANITIZE_OPTS = {
  ALLOWED_TAGS: ['a', 'br', 'span']
};

function sanitizedHtml(message) {
  return { __html: _dompurify2.default.sanitize(message, SANITIZE_OPTS) };
}

function DangerousHtmlMessage(_ref) {
  var message = _ref.message;

  return _react2.default.createElement(_TextWithLinks2.default, { dangerouslySetInnerHTML: sanitizedHtml(message) });
}

DangerousHtmlMessage.propTypes = {
  message: _propTypes2.default.string
};

DangerousHtmlMessage.defaultProps = {
  message: ''
};

exports.default = DangerousHtmlMessage;

/***/ }),

/***/ "./components/GlobalFooter/InfoWrapper/TextWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  color: ' + props.theme.colors.base.text + ';\n  font-family: ' + props.theme.fonts.primary + ';\n  font-size: ' + (0, _decisivUiUtils.px2rem)(14) + ';\n  font-weight: 300;\n  line-height: 30px;\n  margin: 0;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired,
  fonts: _propTypes2.default.shape({
    primary: _propTypes2.default.string.isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('TextWrapper', _styledComponents2.default.p, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/GlobalFooter/InfoWrapper/Wrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  display: inline;\n  margin: auto 0;\n  padding: ', ' 0 0 ', ';\n'], ['\n  display: inline;\n  margin: auto 0;\n  padding: ', ' 0 0 ', ';\n']);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = function () {
  var c = _styledComponents2.default.div(_templateObject, (0, _decisivUiUtils.px2rem)(24), (0, _decisivUiUtils.px2rem)(14));

  c.displayName = 'Wrapper';
  return c;
}();

exports.default = Wrapper;

/***/ }),

/***/ "./components/GlobalFooter/InfoWrapper/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var BLOG_URL = exports.BLOG_URL = 'https://blog.decisiv.com';
var TERMS_OF_USE_URL = exports.TERMS_OF_USE_URL = 'https://www.decisiv.com/resources/product-agreements';
var PRIVACY_POLICY_URL = exports.PRIVACY_POLICY_URL = '/';

/***/ }),

/***/ "./components/GlobalFooter/InfoWrapper/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _decisivDomainUtils = __webpack_require__("../node_modules/decisiv-domain-utils/build/index.js");

var _Link = __webpack_require__("./elements/Link/index.js");

var _Link2 = _interopRequireDefault(_Link);

var _runtimeConfig = __webpack_require__("./runtimeConfig.json");

var _runtimeConfig2 = _interopRequireDefault(_runtimeConfig);

var _Wrapper = __webpack_require__("./components/GlobalFooter/InfoWrapper/Wrapper.js");

var _Wrapper2 = _interopRequireDefault(_Wrapper);

var _TextWrapper = __webpack_require__("./components/GlobalFooter/InfoWrapper/TextWrapper.js");

var _TextWrapper2 = _interopRequireDefault(_TextWrapper);

var _constants = __webpack_require__("./components/GlobalFooter/InfoWrapper/constants.js");

var _messages = __webpack_require__("./components/GlobalFooter/InfoWrapper/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function renderVersion() {
  var version = "1.3.4";
  var gitVersion = "e2696e6";
  var msgValues = {
    app: _runtimeConfig2.default.title,
    version: version,
    gitVersion: gitVersion
  };

  var showGitRevision = gitVersion && (0, _decisivDomainUtils.configEnabled)('SHOW_GIT_REVISION');
  var msg = showGitRevision ? _messages2.default.versionWithGit : _messages2.default.version;
  return _react2.default.createElement(_linguiReact.Trans, { id: msg, values: msgValues });
}

// eslint-disable-next-line import/no-unresolved


function InfoWrapper() {
  function getCurrentYear() {
    return new Date().getFullYear();
  }

  return _react2.default.createElement(
    _Wrapper2.default,
    null,
    _react2.default.createElement(
      _TextWrapper2.default,
      null,
      _react2.default.createElement(_linguiReact.Trans, {
        id: _messages2.default.copyrightText,
        values: { year: getCurrentYear() }
      }),
      ' ',
      '|',
      _react2.default.createElement(
        _Link2.default,
        {
          modifiers: ['padded', 'textColor'],
          target: 'fleet_footer_link',
          to: _constants.TERMS_OF_USE_URL
        },
        _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.termsOfUse })
      ),
      '|',
      _react2.default.createElement(
        _Link2.default,
        {
          modifiers: ['padded', 'textColor'],
          target: 'fleet_footer_link',
          to: _constants.PRIVACY_POLICY_URL
        },
        _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.privacyPolicy })
      )
    ),
    _react2.default.createElement(
      _TextWrapper2.default,
      null,
      renderVersion()
    )
  );
}

exports.default = InfoWrapper;

/***/ }),

/***/ "./components/GlobalFooter/InfoWrapper/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  copyrightText: (0, _linguiReact.i18nMark)('Copyright © {year} Decisiv, Inc.'),
  termsOfUse: (0, _linguiReact.i18nMark)('Terms of Use'),
  privacyPolicy: (0, _linguiReact.i18nMark)('Privacy Policy'),
  version: (0, _linguiReact.i18nMark)('{app} version {version}'),
  versionWithGit: (0, _linguiReact.i18nMark)('{app} version {version} (GIT SHA {gitVersion})')
};

exports.default = messages;

/***/ }),

/***/ "./components/GlobalFooter/Logo.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: auto;\n  height: 120px;\n\n  /* FIXME: Remove below when the app is branded for a customer */\n  display: none;\n'], ['\n  width: auto;\n  height: 120px;\n\n  /* FIXME: Remove below when the app is branded for a customer */\n  display: none;\n']);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Img = __webpack_require__("./elements/Img/index.js");

var _Img2 = _interopRequireDefault(_Img);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Logo = function () {
  var c = (0, _styledComponents2.default)(_Img2.default)(_templateObject);
  c.displayName = 'Logo';
  return c;
}();

exports.default = Logo;

/***/ }),

/***/ "./components/GlobalFooter/Wrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  border-top: ' + (0, _decisivUiUtils.px2rem)(2) + ' solid ' + props.theme.colors.base.chrome300 + ';\n  display: flex;\n  margin: ' + (0, _decisivUiUtils.px2rem)(30) + ' ' + (0, _decisivUiUtils.px2rem)(16) + ';\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome300: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Wrapper', _styledComponents2.default.div, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/GlobalFooter/footer_logo.png":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "eb1650ec57dee65d310f55d86e4f0a68.png";

/***/ }),

/***/ "./components/GlobalFooter/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Wrapper = __webpack_require__("./components/GlobalFooter/Wrapper.js");

var _Wrapper2 = _interopRequireDefault(_Wrapper);

var _Logo = __webpack_require__("./components/GlobalFooter/Logo.js");

var _Logo2 = _interopRequireDefault(_Logo);

var _InfoWrapper = __webpack_require__("./components/GlobalFooter/InfoWrapper/index.js");

var _InfoWrapper2 = _interopRequireDefault(_InfoWrapper);

var _footer_logo = __webpack_require__("./components/GlobalFooter/footer_logo.png");

var _footer_logo2 = _interopRequireDefault(_footer_logo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function GlobalFooter(_ref) {
  var isBranded = _ref.isBranded;

  return _react2.default.createElement(
    _Wrapper2.default,
    null,
    isBranded && _react2.default.createElement(_Logo2.default, { alt: 'Decisiv Logo', src: _footer_logo2.default }),
    _react2.default.createElement(_InfoWrapper2.default, null)
  );
}

GlobalFooter.propTypes = {
  isBranded: _propTypes2.default.bool
};

GlobalFooter.defaultProps = {
  isBranded: false
};

exports.default = GlobalFooter;

/***/ }),

/***/ "./components/LabelValue/Wrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  display: flex;\n  align-items: center;\n  vertical-align: middle;\n  font-size: ' + props.theme.dimensions.fontSizeNormal + ';\n  margin-right: ' + (0, _decisivUiUtils.px2rem)(props.marginRight) + ';\n\n  .label {\n    font-weight: 700;\n    margin-right: 30px;\n  }\n';
};

var themePropTypes = {
  dimensions: _propTypes2.default.shape({
    fontSizeNormal: _propTypes2.default.string.isRequired
  }).isRequired
};

var propTypes = {
  marginRight: _propTypes2.default.number
};

var defaultProps = {
  marginRight: 0
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Wrapper', _styledComponents2.default.div, styles, { defaultProps: defaultProps, propTypes: propTypes, themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/LabelValue/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Wrapper = __webpack_require__("./components/LabelValue/Wrapper.js");

var _Wrapper2 = _interopRequireDefault(_Wrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LabelValue(_ref) {
  var label = _ref.label,
      value = _ref.value,
      marginRight = _ref.marginRight;

  return _react2.default.createElement(
    _Wrapper2.default,
    { marginRight: marginRight },
    _react2.default.createElement(
      'span',
      { className: 'label' },
      label
    ),
    _react2.default.createElement(
      'span',
      null,
      value
    )
  );
}

LabelValue.propTypes = {
  label: _propTypes2.default.node,
  value: _propTypes2.default.node,
  marginRight: _propTypes2.default.number
};

LabelValue.defaultProps = {
  label: '',
  value: '',
  marginRight: 0
};

exports.default = LabelValue;

/***/ }),

/***/ "./components/Layout/LayoutWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  font-family: ' + props.theme.fonts.primary + ';\n';
};

var themePropTypes = {
  fonts: _propTypes2.default.shape({
    primary: _propTypes2.default.string.isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('LayoutWrapper', _styledComponents2.default.section, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/Layout/PageWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  flex: 1;\n  order: 2;\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  height: 100%;\n  top: ', ';\n'], ['\n  flex: 1;\n  order: 2;\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  height: 100%;\n  top: ', ';\n']);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

exports.default = _styledComponents2.default.section(_templateObject, (0, _decisivUiUtils.px2rem)(72));

/***/ }),

/***/ "./components/Layout/TopNavWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  flex: 1;\n  order: 1;\n  width: 100%;\n  max-height: 5rem;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 2;\n'], ['\n  flex: 1;\n  order: 1;\n  width: 100%;\n  max-height: 5rem;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 2;\n']);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

exports.default = _styledComponents2.default.section(_templateObject);

/***/ }),

/***/ "./components/Layout/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Layout = Layout;

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactHelmet = __webpack_require__("../node_modules/react-helmet/lib/Helmet.js");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _recompose = __webpack_require__("../node_modules/recompose/es/Recompose.js");

var _TopNav = __webpack_require__("./components/TopNav/index.js");

var _TopNav2 = _interopRequireDefault(_TopNav);

var _LeftNav = __webpack_require__("./compositions/LeftNav/index.js");

var _LeftNav2 = _interopRequireDefault(_LeftNav);

var _AppContainer = __webpack_require__("./containers/AppContainer/index.js");

var _AppContainer2 = _interopRequireDefault(_AppContainer);

var _withFullScreenMode = __webpack_require__("./containers/withFullScreenMode/index.js");

var _withFullScreenMode2 = _interopRequireDefault(_withFullScreenMode);

var _withPrint = __webpack_require__("./containers/withPrint/index.js");

var _withPrint2 = _interopRequireDefault(_withPrint);

var _helmet = __webpack_require__("./setup/helmet.js");

var _helmet2 = _interopRequireDefault(_helmet);

var _LayoutWrapper = __webpack_require__("./components/Layout/LayoutWrapper.js");

var _LayoutWrapper2 = _interopRequireDefault(_LayoutWrapper);

var _TopNavWrapper = __webpack_require__("./components/Layout/TopNavWrapper.js");

var _TopNavWrapper2 = _interopRequireDefault(_TopNavWrapper);

var _PageWrapper = __webpack_require__("./components/Layout/PageWrapper.js");

var _PageWrapper2 = _interopRequireDefault(_PageWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Layout(_ref) {
  var children = _ref.children;

  return _react2.default.createElement(
    _LayoutWrapper2.default,
    { id: 'layout-wrapper' },
    _react2.default.createElement(_reactHelmet2.default, _helmet2.default),
    _react2.default.createElement(
      _TopNavWrapper2.default,
      null,
      _react2.default.createElement(_TopNav2.default, null)
    ),
    _react2.default.createElement(
      _PageWrapper2.default,
      { id: 'page-wrapper' },
      _react2.default.createElement(_LeftNav2.default, null),
      _react2.default.createElement(
        _AppContainer2.default,
        null,
        children
      )
    )
  );
}

Layout.propTypes = {
  children: _propTypes2.default.node
};

Layout.defaultProps = {
  children: null
};

exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('Layout'), _withFullScreenMode2.default, _withPrint2.default)(Layout);

/***/ }),

/***/ "./components/MapWithDirections/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactGoogleMaps = __webpack_require__("../node_modules/react-google-maps/lib/index.js");

var _propTypes = __webpack_require__("./utils/prop-types.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _WithDirections = __webpack_require__("./utils/mapping/WithDirections.js");

var _WithDirections2 = _interopRequireDefault(_WithDirections);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Map is the (private) component that is rendered by the WithDirections component
 * in MapWithDirections.
 */
function Map(_ref) {
  var directions = _ref.directions,
      markers = _ref.markers,
      onMarkerClick = _ref.onMarkerClick,
      onMarkerClose = _ref.onMarkerClose;

  // default to the first marker as the map center-point
  var firstMarker = markers && markers[0];
  var center = firstMarker && firstMarker.position;

  return _react2.default.createElement(
    _reactGoogleMaps.GoogleMap,
    {
      defaultZoom: 12,
      defaultCenter: center
    },

    // render the directions, but don't include markers/info windows
    // since we'll render our custom info windows below
    directions && _react2.default.createElement(_reactGoogleMaps.DirectionsRenderer, {
      directions: directions,
      options: { suppressInfoWindows: true, suppressMarkers: true }
    }),

    // render custom markers & info windows for each received marker
    // TODO:  We might eventually want to pass in the component to
    //        be used for rendering the info window contents, to allow
    //        for customization.
    markers && markers.map(function (m) {
      return _react2.default.createElement(
        _reactGoogleMaps.Marker,
        {
          key: m.label,
          position: m.position,
          onClick: function onClick() {
            return onMarkerClick(m);
          }
        },
        m.showInfo && _react2.default.createElement(
          _reactGoogleMaps.InfoWindow,
          {
            onCloseClick: function onCloseClick() {
              return onMarkerClose(m);
            }
          },
          _react2.default.createElement(
            'div',
            null,
            m.label
          )
        )
      );
    })
  );
}

/**
 * MapWithDirections wraps a Map (see above) with the WithDirections component, which
 * provides the calculated directions to the Map.
 */
function MapWithDirections(_ref2) {
  var markers = _ref2.markers,
      onDirectionsUpdate = _ref2.onDirectionsUpdate,
      onMarkerClick = _ref2.onMarkerClick,
      onMarkerClose = _ref2.onMarkerClose;

  return _react2.default.createElement(_WithDirections2.default, {
    markers: markers,
    onDirectionsUpdate: onDirectionsUpdate,
    render: function render(_ref3) {
      var directions = _ref3.directions;
      return _react2.default.createElement(Map, {
        directions: directions,
        markers: markers,
        onMarkerClick: onMarkerClick,
        onMarkerClose: onMarkerClose
      });
    }
  });
}

// ------------ prop types for both components above ------------

var markerPropType = _propTypes2.default.shape({
  label: _propTypes2.default.string.isRequired,
  position: _propTypes2.default.latLng.isRequired,
  showInfo: _propTypes2.default.bool.isRequired
});

var sharedPropTypes = {
  markers: _propTypes2.default.arrayOf(markerPropType),
  onMarkerClick: _propTypes2.default.func.isRequired,
  onMarkerClose: _propTypes2.default.func.isRequired
};

Map.propTypes = _extends({}, sharedPropTypes, {
  directions: _propTypes2.default.googleDirections
});

Map.defaultProps = {
  markers: undefined,
  directions: undefined
};

MapWithDirections.propTypes = _extends({}, sharedPropTypes, {
  onDirectionsUpdate: _propTypes2.default.func.isRequired
});

MapWithDirections.defaultProps = {
  markers: undefined,
  onDirectionsUpdate: undefined
};

exports.default = MapWithDirections;

/***/ }),

/***/ "./components/ModalWindow/BodyWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  max-height: calc(100vh - 100px);\n  overflow: auto;\n  padding: ', ';\n  position: relative;\n'], ['\n  max-height: calc(100vh - 100px);\n  overflow: auto;\n  padding: ', ';\n  position: relative;\n']);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var BodyWrapper = function () {
  var c = _styledComponents2.default.div(_templateObject, (0, _decisivUiUtils.px2rem)(8));

  c.displayName = 'BodyWrapper';
  return c;
}();

exports.default = BodyWrapper;

/***/ }),

/***/ "./components/ModalWindow/CloseButtonWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  color: ' + props.theme.colors.base.chrome500 + ';\n  cursor: pointer;\n  float: right;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome500: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('CloseButtonWrapper', _styledComponents2.default.div, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/ModalWindow/FooterWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  font-size: ', ';\n  text-align: right;\n  padding: ', ';\n'], ['\n  font-size: ', ';\n  text-align: right;\n  padding: ', ';\n']);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var FooterWrapper = function () {
  var c = _styledComponents2.default.section(_templateObject, (0, _decisivUiUtils.px2rem)(16), (0, _decisivUiUtils.px2rem)(20));

  c.displayName = 'FooterWrapper';
  return c;
}();

exports.default = FooterWrapper;

/***/ }),

/***/ "./components/ModalWindow/HeaderWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  box-sizing: border-box;\n  color: ' + props.theme.colors.base.textLight + ';\n  font-size: ' + (0, _decisivUiUtils.px2rem)(18) + ';\n  font-weight: 500;\n  line-height: ' + (0, _decisivUiUtils.px2rem)(22) + ';\n  padding: ' + (0, _decisivUiUtils.px2rem)(16) + ';\n  text-transform: uppercase;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      textLight: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('HeaderWrapper', _styledComponents2.default.section, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/ModalWindow/PopupWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  background-color: ' + props.theme.colors.base.background + ';\n  border-radius: 2px;\n  left: ' + (0, _decisivUiUtils.px2rem)(26) + ';\n  position: fixed;\n  right: ' + (0, _decisivUiUtils.px2rem)(26) + ';\n  top: 50%;\n  transform: translate(0, -50%);\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      background: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('PopupWrapper', _styledComponents2.default.section, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/ModalWindow/Wrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  position: fixed;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1000;\n'], ['\n  position: fixed;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1000;\n']);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = function () {
  var c = _styledComponents2.default.section(_templateObject);

  c.displayName = 'Wrapper';
  return c;
}();

exports.default = Wrapper;

/***/ }),

/***/ "./components/ModalWindow/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactFontawesome = __webpack_require__("../node_modules/react-fontawesome/lib/index.js");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _Overlay = __webpack_require__("./components/_common/Overlay/index.js");

var _Overlay2 = _interopRequireDefault(_Overlay);

var _Divider = __webpack_require__("./elements/Divider/index.js");

var _Divider2 = _interopRequireDefault(_Divider);

var _Wrapper = __webpack_require__("./components/ModalWindow/Wrapper.js");

var _Wrapper2 = _interopRequireDefault(_Wrapper);

var _PopupWrapper = __webpack_require__("./components/ModalWindow/PopupWrapper.js");

var _PopupWrapper2 = _interopRequireDefault(_PopupWrapper);

var _HeaderWrapper = __webpack_require__("./components/ModalWindow/HeaderWrapper.js");

var _HeaderWrapper2 = _interopRequireDefault(_HeaderWrapper);

var _BodyWrapper = __webpack_require__("./components/ModalWindow/BodyWrapper.js");

var _BodyWrapper2 = _interopRequireDefault(_BodyWrapper);

var _FooterWrapper = __webpack_require__("./components/ModalWindow/FooterWrapper.js");

var _FooterWrapper2 = _interopRequireDefault(_FooterWrapper);

var _CloseButtonWrapper = __webpack_require__("./components/ModalWindow/CloseButtonWrapper.js");

var _CloseButtonWrapper2 = _interopRequireDefault(_CloseButtonWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ModalWindow(_ref) {
  var children = _ref.children,
      divider = _ref.divider,
      headerInfo = _ref.headerInfo,
      hideByClickingBackground = _ref.hideByClickingBackground,
      hideModal = _ref.hideModal,
      footerButtons = _ref.footerButtons;

  var handleBackgroundClick = function handleBackgroundClick(e) {
    if (hideByClickingBackground && e.target === e.currentTarget) hideModal();
  };

  var showFooter = footerButtons && footerButtons.length > 0;

  return _react2.default.createElement(
    _Wrapper2.default,
    null,
    _react2.default.createElement(_Overlay2.default, { onClick: handleBackgroundClick }),
    _react2.default.createElement(
      _PopupWrapper2.default,
      null,
      headerInfo && _react2.default.createElement(
        _HeaderWrapper2.default,
        null,
        headerInfo.title,
        _react2.default.createElement(
          _CloseButtonWrapper2.default,
          { onClick: hideModal },
          _react2.default.createElement(_reactFontawesome2.default, { name: 'close' })
        )
      ),
      divider && _react2.default.createElement(_Divider2.default, { modifiers: ['heavyMidGray'] }),
      _react2.default.createElement(
        _BodyWrapper2.default,
        { id: 'modal-body' },
        children
      ),
      showFooter && _react2.default.createElement(_Divider2.default, null),
      showFooter && _react2.default.createElement(
        _FooterWrapper2.default,
        null,
        footerButtons
      )
    )
  );
}

ModalWindow.propTypes = {
  children: _propTypes2.default.node,
  divider: _propTypes2.default.bool,
  headerInfo: _propTypes2.default.shape(),
  hideByClickingBackground: _propTypes2.default.bool,
  hideModal: _propTypes2.default.func.isRequired,
  footerButtons: _propTypes2.default.arrayOf(_propTypes2.default.node)
};

ModalWindow.defaultProps = {
  children: null,
  divider: false,
  headerInfo: null,
  footerButtons: [],
  hideByClickingBackground: false
};

exports.default = ModalWindow;

/***/ }),

/***/ "./components/NoFavoritesPanel/Instruction.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  width: 90%;\n  max-width: ' + (0, _decisivUiUtils.px2rem)(542) + ';\n  color: ' + props.theme.colors.base.text + ';\n  font-size: ' + (0, _decisivUiUtils.px2rem)(20) + ';\n  line-height: ' + (0, _decisivUiUtils.px2rem)(25) + ';\n  text-align: center;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Instruction', _styledComponents2.default.span, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/NoFavoritesPanel/Title.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  margin: ' + (0, _decisivUiUtils.px2rem)(30) + ' 0 ' + (0, _decisivUiUtils.px2rem)(16) + ';\n  color: ' + props.theme.colors.base.text + ';\n  font-size: ' + (0, _decisivUiUtils.px2rem)(25) + ';\n  line-height: ' + (0, _decisivUiUtils.px2rem)(25) + ';\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Title', _styledComponents2.default.span, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/NoFavoritesPanel/Wrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  padding: ' + (0, _decisivUiUtils.px2rem)(70) + ' 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  font-size: ' + (0, _decisivUiUtils.px2rem)(68) + ';\n  font-weight: 300;\n  color: ' + props.theme.colors.base.chrome300 + ';\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome300: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Wrapper', _styledComponents2.default.div, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/NoFavoritesPanel/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactFontawesome = __webpack_require__("../node_modules/react-fontawesome/lib/index.js");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _TextDiv = __webpack_require__("./elements/TextDiv/index.js");

var _TextDiv2 = _interopRequireDefault(_TextDiv);

var _messages = __webpack_require__("./components/NoFavoritesPanel/messages.js");

var _messages2 = _interopRequireDefault(_messages);

var _Wrapper = __webpack_require__("./components/NoFavoritesPanel/Wrapper.js");

var _Wrapper2 = _interopRequireDefault(_Wrapper);

var _Title = __webpack_require__("./components/NoFavoritesPanel/Title.js");

var _Title2 = _interopRequireDefault(_Title);

var _Instruction = __webpack_require__("./components/NoFavoritesPanel/Instruction.js");

var _Instruction2 = _interopRequireDefault(_Instruction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function NoFavoritesPanel(_ref) {
  var filter = _ref.filter;

  return _react2.default.createElement(
    _Wrapper2.default,
    null,
    _react2.default.createElement(_reactFontawesome2.default, { name: 'star-o' }),
    _react2.default.createElement(
      _Title2.default,
      null,
      _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.title }),
      '\xA0',
      _react2.default.createElement(
        _TextDiv2.default,
        { modifiers: ['heavyText', 'inline'] },
        _react2.default.createElement(_linguiReact.Trans, { id: filter })
      )
    ),
    _react2.default.createElement(
      _Instruction2.default,
      null,
      _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.instruction })
    )
  );
}

NoFavoritesPanel.propTypes = {
  filter: _propTypes2.default.string.isRequired
};

exports.default = NoFavoritesPanel;

/***/ }),

/***/ "./components/NoFavoritesPanel/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  title: (0, _linguiReact.i18nMark)('No matches for'),
  instruction: (0, _linguiReact.i18nMark)('Try removing or editing some of your criteria to expand the search or review another favorite.')
};

exports.default = messages;

/***/ }),

/***/ "./components/NotFoundPage/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/styled-components-reactive-grid/dist/index.js");

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _Img = __webpack_require__("./elements/Img/index.js");

var _Img2 = _interopRequireDefault(_Img);

var _TextDiv = __webpack_require__("./elements/TextDiv/index.js");

var _TextDiv2 = _interopRequireDefault(_TextDiv);

var _messages = __webpack_require__("./components/NotFoundPage/messages.js");

var _messages2 = _interopRequireDefault(_messages);

var _mapIcon = __webpack_require__("./components/NotFoundPage/map-icon.svg");

var _mapIcon2 = _interopRequireDefault(_mapIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function NotFoundPage() {
  return _react2.default.createElement(
    _styledComponentsReactiveGrid.Container,
    { style: { padding: (0, _decisivUiUtils.px2rem)(160) + ' 0' } },
    _react2.default.createElement(
      _styledComponentsReactiveGrid.Row,
      null,
      _react2.default.createElement(
        _styledComponentsReactiveGrid.Column,
        { modifiers: ['col', 'center'] },
        _react2.default.createElement(_Img2.default, { alt: 'map', src: _mapIcon2.default })
      )
    ),
    _react2.default.createElement(
      _styledComponentsReactiveGrid.Row,
      null,
      _react2.default.createElement(
        _styledComponentsReactiveGrid.Column,
        {
          modifiers: ['col', 'center']
        },
        _react2.default.createElement(
          _TextDiv2.default,
          { modifiers: ['bold', 'largeText'] },
          _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.title })
        )
      )
    ),
    _react2.default.createElement(
      _styledComponentsReactiveGrid.Row,
      null,
      _react2.default.createElement(
        _styledComponentsReactiveGrid.Column,
        { modifiers: ['col', 'center'] },
        _react2.default.createElement(
          _TextDiv2.default,
          { modifiers: ['mediumLargeText'] },
          _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.line1 })
        )
      )
    ),
    _react2.default.createElement(
      _styledComponentsReactiveGrid.Row,
      null,
      _react2.default.createElement(
        _styledComponentsReactiveGrid.Column,
        { modifiers: ['col', 'center'] },
        _react2.default.createElement(
          _TextDiv2.default,
          { modifiers: ['mediumLargeText'] },
          _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.line2 })
        )
      )
    )
  );
}

exports.default = NotFoundPage;

/***/ }),

/***/ "./components/NotFoundPage/map-icon.svg":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "./components/NotFoundPage/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  title: (0, _linguiReact.i18nMark)('It looks like you’re lost…'),
  line1: (0, _linguiReact.i18nMark)('This page either does not exist or you need permission to view it.'),
  line2: (0, _linguiReact.i18nMark)('Try using the search bar or contacting the person who gave you the link.')
};

exports.default = messages;

/***/ }),

/***/ "./components/PdfLink/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PdfLink = PdfLink;

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactFontawesome = __webpack_require__("../node_modules/react-fontawesome/lib/index.js");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _recompose = __webpack_require__("../node_modules/recompose/es/Recompose.js");

var _urlParse = __webpack_require__("../node_modules/url-parse/index.js");

var _urlParse2 = _interopRequireDefault(_urlParse);

var _baseComponents = __webpack_require__("../node_modules/base-components/build/index.js");

var _IconWrapper = __webpack_require__("./elements/IconWrapper.js");

var _IconWrapper2 = _interopRequireDefault(_IconWrapper);

var _fetch = __webpack_require__("./utils/fetch.js");

var _messages = __webpack_require__("./components/PdfLink/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The URLs for PDFs (for estimates, etc) provided by the API are potentially URLs that
 * will require an `access_token` to authorize access.  This component encapsulates the
 * logic for authorizing these URLs and also standardizes the formatting of a PDF link to
 * include the appropriate icon and formatting.
 *
 * @param url The URL for the PDF.  If not provided, an empty span will be returned.
 * @param children The text of the PDF link should be provided as children of the component.
 */
function PdfLink(_ref) {
  var i18n = _ref.i18n,
      url = _ref.url,
      children = _ref.children;

  if (!url) {
    return _react2.default.createElement('span', null);
  }

  var parsedUrl = new _urlParse2.default(url, true);
  var authorizedUrl = (0, _fetch.makeApiUrl)('' + parsedUrl.origin + parsedUrl.pathname, parsedUrl.query);

  return _react2.default.createElement(
    _baseComponents.A,
    {
      'aria-label': i18n._(_messages2.default.pdfLink),
      target: '_blank',
      href: authorizedUrl,
      modifiers: ['colorText']
    },
    _react2.default.createElement(
      _IconWrapper2.default,
      null,
      _react2.default.createElement(_reactFontawesome2.default, { name: 'file-pdf-o' })
    ),
    children
  );
}

PdfLink.propTypes = {
  i18n: _propTypes2.default.shape({
    _: _propTypes2.default.func.isRequired
  }).isRequired,
  url: _propTypes2.default.string,
  children: _propTypes2.default.node
};

PdfLink.defaultProps = {
  url: null,
  children: null
};

exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('PdfLink'), (0, _linguiReact.withI18n)())(PdfLink);

/***/ }),

/***/ "./components/PdfLink/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  pdfLink: (0, _linguiReact.i18nMark)('PDF Link')
};

exports.default = messages;

/***/ }),

/***/ "./components/PopupMenu/MenuItem.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function MenuItem(_ref) {
  var children = _ref.children;

  return _react2.default.createElement(
    'div',
    { className: 'menu-item' },
    children
  );
}

MenuItem.propTypes = {
  children: _propTypes2.default.node
};

MenuItem.defaultProps = {
  children: null
};

exports.default = MenuItem;

/***/ }),

/***/ "./components/PopupMenu/MenuItemDivider.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  background: ' + props.theme.colors.base.chrome200 + ';\n  height: ' + (0, _decisivUiUtils.px2rem)(1) + ';\n  width: 100%;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome200: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('MenuItemDivider', _styledComponents2.default.div, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/PopupMenu/Wrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = '\n  width: 100%;\n';

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Wrapper', _styledComponents2.default.div, styles);

/***/ }),

/***/ "./components/PopupMenu/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopupMenu = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactClickOutside = __webpack_require__("../node_modules/react-click-outside/dist/index.js");

var _reactClickOutside2 = _interopRequireDefault(_reactClickOutside);

var _Wrapper = __webpack_require__("./components/PopupMenu/Wrapper.js");

var _Wrapper2 = _interopRequireDefault(_Wrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PopupMenu = exports.PopupMenu = function (_Component) {
  _inherits(PopupMenu, _Component);

  function PopupMenu() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PopupMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PopupMenu.__proto__ || Object.getPrototypeOf(PopupMenu)).call.apply(_ref, [this].concat(args))), _this), _this.handleClickOutside = function (e) {
      _this.props.onOutsideClick(e);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PopupMenu, [{
    key: 'render',
    value: function render() {
      var children = this.props.children;

      return _react2.default.createElement(
        _Wrapper2.default,
        null,
        children
      );
    }
  }]);

  return PopupMenu;
}(_react.Component);

PopupMenu.propTypes = {
  children: _propTypes2.default.node,
  onOutsideClick: _propTypes2.default.func.isRequired
};

PopupMenu.defaultProps = {
  children: null
};

exports.default = (0, _reactClickOutside2.default)(PopupMenu);

/***/ }),

/***/ "./components/ProgressBar/Bar.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(_ref) {
  var theme = _ref.theme,
      fill = _ref.fill;
  return '\n  background-color: ' + theme.colors.status.success + ';\n  height: 100%;\n  width: ' + fill + ';\n  transition: width .2s ease-out;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    status: _propTypes2.default.shape({
      success: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

var propTypes = {
  fill: _propTypes2.default.string
};

var defaultProps = {
  fill: '0%'
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Bar', _styledComponents2.default.div, styles, { propTypes: propTypes, themePropTypes: themePropTypes, defaultProps: defaultProps });

/***/ }),

/***/ "./components/ProgressBar/ProgressBarWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(_ref) {
  var theme = _ref.theme;
  return '\n  background: ' + theme.colors.base.chrome200 + ';\n  bottom: ' + (0, _decisivUiUtils.px2rem)(-4) + ';\n  height: ' + (0, _decisivUiUtils.px2rem)(4) + ';\n  left: ' + (0, _decisivUiUtils.px2rem)(8) + ';\n  position: absolute;\n  right:' + (0, _decisivUiUtils.px2rem)(8) + ';\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome200: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('ProgressBarWrapper', _styledComponents2.default.div, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/ProgressBar/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ProgressBarWrapper = __webpack_require__("./components/ProgressBar/ProgressBarWrapper.js");

var _ProgressBarWrapper2 = _interopRequireDefault(_ProgressBarWrapper);

var _Bar = __webpack_require__("./components/ProgressBar/Bar.js");

var _Bar2 = _interopRequireDefault(_Bar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProgressBar = function ProgressBar(_ref) {
  var step = _ref.step,
      total = _ref.total;
  return _react2.default.createElement(
    _ProgressBarWrapper2.default,
    null,
    _react2.default.createElement(_Bar2.default, { fill: step * 100 / total + '%' })
  );
};

ProgressBar.propTypes = {
  step: _propTypes2.default.number,
  total: _propTypes2.default.number
};

ProgressBar.defaultProps = {
  step: 0,
  total: 1
};

exports.default = ProgressBar;

/***/ }),

/***/ "./components/QuickActionBar/ItemGroup.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n'], ['\n  display: flex;\n']);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ItemGroup = function () {
  var c = _styledComponents2.default.div(_templateObject);

  c.displayName = 'ItemGroup';
  return c;
}();

exports.default = ItemGroup;

/***/ }),

/***/ "./components/QuickActionBar/QuickActionBarWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  background-color: ' + props.theme.colors.base.background + ';\n  display: flex;\n  justify-content: space-between;\n  padding: ' + (0, _decisivUiUtils.px2rem)(8) + ' ' + (0, _decisivUiUtils.px2rem)(17) + ';\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      background: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('QuickActionBarWrapper', _styledComponents2.default.div, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/QuickActionBar/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _baseComponents = __webpack_require__("../node_modules/base-components/build/index.js");

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _QuickActionSelector = __webpack_require__("./components/QuickActionSelector/index.js");

var _QuickActionSelector2 = _interopRequireDefault(_QuickActionSelector);

var _QuickActionBarWrapper = __webpack_require__("./components/QuickActionBar/QuickActionBarWrapper.js");

var _QuickActionBarWrapper2 = _interopRequireDefault(_QuickActionBarWrapper);

var _ItemGroup = __webpack_require__("./components/QuickActionBar/ItemGroup.js");

var _ItemGroup2 = _interopRequireDefault(_ItemGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO: Remove this component and all associate files after all detail pages are being rendered
// from the config/DetailPage composition.
function QuickActionBar(_ref) {
  var items = _ref.items,
      onItemClicked = _ref.onItemClicked,
      disabled = _ref.disabled;

  return _react2.default.createElement(
    _QuickActionBarWrapper2.default,
    null,
    _react2.default.createElement(
      _ItemGroup2.default,
      null,
      items.LEFT_ITEMS.map(function (item) {
        return _react2.default.createElement(
          _baseComponents.QuickActionButton,
          {
            key: item.id,
            modifiers: (0, _lodash.compact)([!!disabled[item.id] && 'disabled']),
            onClick: function onClick() {
              return onItemClicked({ buttonId: item.id });
            }
          },
          item.icon && _react2.default.createElement(_baseComponents.QuickActionButton.Icon, {
            modifiers: ['left'],
            name: item.icon
          }),
          _react2.default.createElement(
            _baseComponents.QuickActionButton.Text,
            null,
            _react2.default.createElement(_linguiReact.Trans, { id: item.label })
          )
        );
      })
    ),
    _react2.default.createElement(
      _ItemGroup2.default,
      null,
      items.RIGHT_ITEMS.map(function (item) {
        return _react2.default.createElement(_QuickActionSelector2.default, {
          key: item.id,
          item: item,
          onClick: onItemClicked,
          disabled: !!disabled[item.id]
        });
      })
    )
  );
}

QuickActionBar.propTypes = {
  items: _propTypes2.default.shape({
    LEFT_ITEMS: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      id: _propTypes2.default.string.isRequired,
      icon: _propTypes2.default.string.isRequired,
      label: _propTypes2.default.string.isRequired
    })).isRequired,
    RIGHT_ITEMS: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      id: _propTypes2.default.string.isRequired,
      icon: _propTypes2.default.string.isRequired,
      label: _propTypes2.default.string.isRequired,
      options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        id: _propTypes2.default.string.isRequired,
        label: _propTypes2.default.string.isRequired
      }))
    })).isRequired
  }).isRequired,
  onItemClicked: _propTypes2.default.func.isRequired,
  disabled: _propTypes2.default.shape()
};

QuickActionBar.defaultProps = {
  disabled: {}
};

exports.default = QuickActionBar;

/***/ }),

/***/ "./components/QuickActionSelector/QuickActionSelectorWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n  display: inline-block;\n'], ['\n  position: relative;\n  display: inline-block;\n']);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var QuickActionSelectorWrapper = function () {
  var c = _styledComponents2.default.div(_templateObject);

  c.displayName = 'QuickActionSelectorWrapper';
  return c;
}();

exports.default = QuickActionSelectorWrapper;

/***/ }),

/***/ "./components/QuickActionSelector/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuickActionSelector = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _baseComponents = __webpack_require__("../node_modules/base-components/build/index.js");

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _recompose = __webpack_require__("../node_modules/recompose/es/Recompose.js");

var _AbsoluteSmoothCollapse = __webpack_require__("./components/AbsoluteSmoothCollapse/index.js");

var _AbsoluteSmoothCollapse2 = _interopRequireDefault(_AbsoluteSmoothCollapse);

var _PopupMenu = __webpack_require__("./components/PopupMenu/index.js");

var _PopupMenu2 = _interopRequireDefault(_PopupMenu);

var _SelectorButton = __webpack_require__("./elements/SelectorButton/index.js");

var _QuickActionSelectorWrapper = __webpack_require__("./components/QuickActionSelector/QuickActionSelectorWrapper.js");

var _QuickActionSelectorWrapper2 = _interopRequireDefault(_QuickActionSelectorWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function renderOptionsList(options, _onClick) {
  return options.map(function (option) {
    return _react2.default.createElement(
      _SelectorButton.SelectorOptionListElement,
      {
        key: option.id,
        id: 'action-option-' + option.id,
        onClick: function onClick() {
          return _onClick(option.id);
        },
        modifiers: ['small']
      },
      _react2.default.createElement(_linguiReact.Trans, { id: option.label })
    );
  });
}

var QuickActionSelector = exports.QuickActionSelector = function (_Component) {
  _inherits(QuickActionSelector, _Component);

  function QuickActionSelector() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, QuickActionSelector);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = QuickActionSelector.__proto__ || Object.getPrototypeOf(QuickActionSelector)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      expanded: false
    }, _this.toggleOptions = function () {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      _this.setState({
        expanded: value
      });
    }, _this.handleClickButton = function () {
      var _this$props = _this.props,
          id = _this$props.item.id,
          onClick = _this$props.onClick;


      _this.toggleOptions(true);
      onClick({ buttonId: id });
    }, _this.handleClickItem = function (dropdownItemId) {
      var _this$props2 = _this.props,
          id = _this$props2.item.id,
          onClick = _this$props2.onClick;


      _this.toggleOptions();
      onClick({ buttonId: id, dropdownItemId: dropdownItemId });
    }, _this.handleOutsideClick = function () {
      if (_this.state.expanded) {
        _this.toggleOptions();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(QuickActionSelector, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          item = _props.item,
          disabled = _props.disabled,
          theme = _props.theme;
      var expanded = this.state.expanded;
      var label = item.label,
          icon = item.icon,
          _item$iconPressed = item.iconPressed,
          iconPressed = _item$iconPressed === undefined ? icon : _item$iconPressed,
          options = item.options;


      var wrapperClass = 'action-selector-' + item.id;
      var buttonClass = 'action-button-' + item.id;

      return _react2.default.createElement(
        _QuickActionSelectorWrapper2.default,
        { className: wrapperClass },
        _react2.default.createElement(
          _baseComponents.QuickActionButton,
          {
            className: buttonClass,
            modifiers: (0, _lodash.compact)([disabled && 'disabled', expanded && 'active']),
            onClick: this.handleClickButton
          },
          _react2.default.createElement(
            _baseComponents.QuickActionButton.Text,
            null,
            _react2.default.createElement(_linguiReact.Trans, { id: label })
          ),
          _react2.default.createElement(_baseComponents.QuickActionButton.Icon, {
            modifiers: ['right'],
            name: expanded ? iconPressed : icon
          })
        ),
        _react2.default.createElement(
          _AbsoluteSmoothCollapse2.default,
          {
            expanded: expanded,
            heightTransition: theme.transitions.heightExpand,
            top: (0, _decisivUiUtils.px2rem)(25),
            left: (0, _decisivUiUtils.px2rem)(-50),
            right: (0, _decisivUiUtils.px2rem)(-3),
            zIndex: 1
          },
          _react2.default.createElement(
            _PopupMenu2.default,
            { onOutsideClick: this.handleOutsideClick },
            _react2.default.createElement(
              _SelectorButton.SelectorOptionsPopup,
              { modifiers: ['noPad'], minWidth: '0' },
              _react2.default.createElement(
                _SelectorButton.SelectorOptionsList,
                null,
                renderOptionsList(options, this.handleClickItem)
              )
            )
          )
        )
      );
    }
  }]);

  return QuickActionSelector;
}(_react.Component);

QuickActionSelector.propTypes = {
  item: _propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired,
    icon: _propTypes2.default.string.isRequired,
    iconPressed: _propTypes2.default.string,
    label: _propTypes2.default.string.isRequired
  }).isRequired,
  theme: _propTypes2.default.shape({
    transitions: _propTypes2.default.shape({
      heightExpand: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired,
  onClick: _propTypes2.default.func.isRequired,
  disabled: _propTypes2.default.bool
};

QuickActionSelector.defaultProps = {
  onClick: _lodash.noop,
  disabled: false
};

exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('QuickActionSelector'), _styledComponents.withTheme)(QuickActionSelector);

/***/ }),

/***/ "./components/RefreshBlock/Count.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  color: ' + props.theme.colors.base.textLight + ';\n  font-size: ' + (0, _decisivUiUtils.px2rem)(12) + ';\n  padding: 0 ' + (0, _decisivUiUtils.px2rem)(8) + ';\n  text-transform: uppercase;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      textLight: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Count', _styledComponents2.default.span, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/RefreshBlock/RefreshBlockWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n'], ['\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n']);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var RefreshBlockWrapper = function () {
  var c = _styledComponents2.default.div(_templateObject);

  c.displayName = 'RefreshBlockWrapper';
  return c;
}();

exports.default = RefreshBlockWrapper;

/***/ }),

/***/ "./components/RefreshBlock/RefreshIcon.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setAnimation = setAnimation;
exports.setColor = setColor;

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function setAnimation(_ref) {
  var requesting = _ref.requesting,
      theme = _ref.theme;

  return requesting ? theme.animations.spin + ' 0.8s linear infinite' : 'none';
}

function setColor(_ref2) {
  var requesting = _ref2.requesting,
      theme = _ref2.theme;

  return requesting ? theme.colors.base.linkHover : theme.colors.base.chrome500;
}

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  align-items: center;\n  color: ' + setColor(props) + ';\n  display: flex;\n  font-size: 14px;\n  text-align: center;\n\n  &:hover {\n    color: ' + props.theme.colors.base.linkHover + ';\n    cursor: pointer;\n  }\n\n  .fa {\n    animation: ' + setAnimation(props) + ';\n  }\n';
};

var themePropTypes = {
  animations: _propTypes2.default.shape({
    spin: _propTypes2.default.string.isRequired
  }).isRequired,
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome500: _propTypes2.default.string.isRequired,
      linkHover: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

var propTypes = {
  requesting: _propTypes2.default.bool
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('RefreshIcon', _styledComponents2.default.div, styles, { propTypes: propTypes, themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/RefreshBlock/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactFontawesome = __webpack_require__("../node_modules/react-fontawesome/lib/index.js");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _Count = __webpack_require__("./components/RefreshBlock/Count.js");

var _Count2 = _interopRequireDefault(_Count);

var _RefreshBlockWrapper = __webpack_require__("./components/RefreshBlock/RefreshBlockWrapper.js");

var _RefreshBlockWrapper2 = _interopRequireDefault(_RefreshBlockWrapper);

var _RefreshIcon = __webpack_require__("./components/RefreshBlock/RefreshIcon.js");

var _RefreshIcon2 = _interopRequireDefault(_RefreshIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getMessage(type, count) {
  switch (type) {
    case 'asset':
      return _react2.default.createElement(_linguiReact.Trans, {
        id: 'Assets: {count}',
        values: {
          count: count
        }
      });
    case 'case':
      return _react2.default.createElement(_linguiReact.Trans, {
        id: 'Cases: {count}',
        values: {
          count: count
        }
      });
    case 'search':
      return _react2.default.createElement(_linguiReact.Trans, {
        id: 'Matches: {count}',
        values: {
          count: count
        }
      });
    case 'serviceRequest':
      return _react2.default.createElement(_linguiReact.Trans, {
        id: 'Service Requests: {count}',
        values: {
          count: count
        }
      });
    default:
      return '';
  }
}

function RefreshBlock(_ref) {
  var count = _ref.count,
      refresh = _ref.refresh,
      requesting = _ref.requesting,
      type = _ref.type;

  var message = getMessage(type, count);

  function renderCount() {
    if (requesting) {
      return null;
    }
    return _react2.default.createElement(
      _Count2.default,
      null,
      message
    );
  }

  function handleRefreshClick(event) {
    event.preventDefault();
    if (requesting) {
      return null;
    }
    return refresh();
  }

  return _react2.default.createElement(
    _RefreshBlockWrapper2.default,
    { id: 'refresh-block' },
    renderCount(),
    _react2.default.createElement(
      _RefreshIcon2.default,
      {
        requesting: requesting,
        onClick: handleRefreshClick
      },
      _react2.default.createElement(_reactFontawesome2.default, { name: 'refresh' })
    )
  );
}

RefreshBlock.propTypes = {
  count: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  refresh: _propTypes2.default.func.isRequired,
  requesting: _propTypes2.default.bool.isRequired,
  type: _propTypes2.default.string
};

RefreshBlock.defaultProps = {
  count: '-',
  type: undefined
};

exports.default = RefreshBlock;

/***/ }),

/***/ "./components/Search/SearchBar/SearchOption/OptionButton.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  span:not(:first-of-type) {\n    margin-left: ', ';\n  }\n'], ['\n  span:not(:first-of-type) {\n    margin-left: ', ';\n  }\n']);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var OptionButton = function () {
  var c = _styledComponents2.default.a(_templateObject, (0, _decisivUiUtils.px2rem)(10));

  c.displayName = 'OptionButton';
  return c;
}();

exports.default = OptionButton;

/***/ }),

/***/ "./components/Search/SearchBar/SearchOption/Wrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  collapsed: function collapsed() {
    return {
      styles: 'width: ' + (0, _decisivUiUtils.px2rem)(17) + ';'
    };
  },
  expanded: function expanded() {
    return {
      styles: 'width: ' + (0, _decisivUiUtils.px2rem)(145) + ';'
    };
  },
  isDisplayed: function isDisplayed(_ref) {
    var theme = _ref.theme;
    return {
      styles: '\n      background: ' + theme.colors.brand.primary + ';\n      color: ' + theme.colors.base.chrome000 + ';\n    '
    };
  },
  isHidden: function isHidden(_ref2) {
    var theme = _ref2.theme;
    return {
      styles: '\n      background: ' + theme.colors.base.chrome100 + ';\n      color: ' + theme.colors.base.textLight + ';\n    '
    };
  }
};

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  border-bottom-left-radius: ' + (0, _decisivUiUtils.px2rem)(17) + ';\n  border-top-left-radius: ' + (0, _decisivUiUtils.px2rem)(17) + ';\n  color: ' + props.theme.colors.base.textLight + ';\n  cursor: pointer;\n  font-size: ' + (0, _decisivUiUtils.px2rem)(12) + ';\n  line-height: ' + (0, _decisivUiUtils.px2rem)(35) + ';\n  overflow: hidden;\n  text-align: center;\n  transition: width 0.2s;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome000: _propTypes2.default.string.isRequired,
      chrome100: _propTypes2.default.string.isRequired,
      textLight: _propTypes2.default.string.isRequired
    }).isRequired,
    brand: _propTypes2.default.shape({
      primary: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('SearchOptionWrapper', _styledComponents2.default.div, styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/Search/SearchBar/SearchOption/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _reactFontawesome = __webpack_require__("../node_modules/react-fontawesome/lib/index.js");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _AbsoluteSmoothCollapse = __webpack_require__("./components/AbsoluteSmoothCollapse/index.js");

var _AbsoluteSmoothCollapse2 = _interopRequireDefault(_AbsoluteSmoothCollapse);

var _PopupMenu = __webpack_require__("./components/PopupMenu/index.js");

var _PopupMenu2 = _interopRequireDefault(_PopupMenu);

var _SelectorButton = __webpack_require__("./elements/SelectorButton/index.js");

var _Wrapper = __webpack_require__("./components/Search/SearchBar/SearchOption/Wrapper.js");

var _Wrapper2 = _interopRequireDefault(_Wrapper);

var _OptionButton = __webpack_require__("./components/Search/SearchBar/SearchOption/OptionButton.js");

var _OptionButton2 = _interopRequireDefault(_OptionButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Displays the selectedSearchOption. Clicking the link will open a dropdown selected and allow you
// to choose a different option.
function SearchOption(_ref) {
  var displaySearchOptions = _ref.displaySearchOptions,
      expanded = _ref.expanded,
      handleSearchOptionSelect = _ref.handleSearchOptionSelect,
      searchOptions = _ref.searchOptions,
      selectedSearchOption = _ref.selectedSearchOption,
      toggleDisplaySearchOptions = _ref.toggleDisplaySearchOptions;

  var stateModifier = displaySearchOptions ? 'isDisplayed' : 'isHidden';
  var expandedModifier = expanded ? 'expanded' : 'collapsed';

  /* istanbul ignore next */
  function onClickOutsidePopupMenu(e) {
    if (displaySearchOptions) {
      e.stopPropagation();
      toggleDisplaySearchOptions();
    }
  }

  return _react2.default.createElement(
    _Wrapper2.default,
    { modifiers: [stateModifier, expandedModifier] },
    _react2.default.createElement(
      _OptionButton2.default,
      { onClick: toggleDisplaySearchOptions },
      _react2.default.createElement(_linguiReact.Trans, { id: selectedSearchOption.label }),
      _react2.default.createElement(_reactFontawesome2.default, { name: 'caret-down' })
    ),
    _react2.default.createElement(
      _AbsoluteSmoothCollapse2.default,
      {
        expanded: displaySearchOptions,
        heightTransition: '.15s cubic-bezier(0, 1, 0.5, 1)',
        top: (0, _decisivUiUtils.px2rem)(32),
        left: (0, _decisivUiUtils.px2rem)(-3),
        zIndex: 1,
        width: (0, _decisivUiUtils.px2rem)(150)
      },
      _react2.default.createElement(
        _PopupMenu2.default,
        { onOutsideClick: onClickOutsidePopupMenu },
        _react2.default.createElement(
          _SelectorButton.SelectorOptionsPopup,
          { minWidth: '0' },
          _react2.default.createElement(
            _SelectorButton.SelectorOptionsList,
            null,
            searchOptions.map(function (option) {
              var selected = selectedSearchOption.id === option.id && 'selected';
              return _react2.default.createElement(
                _SelectorButton.SelectorOptionListElement,
                {
                  key: option.id,
                  id: 'search-option-' + option.id,
                  onClick: function onClick(event) {
                    handleSearchOptionSelect(event, option);
                  },
                  modifiers: (0, _lodash.compact)([selected])
                },
                _react2.default.createElement(_linguiReact.Trans, { id: option.label })
              );
            })
          )
        )
      )
    )
  );
}

SearchOption.propTypes = {
  displaySearchOptions: _propTypes2.default.bool.isRequired,
  expanded: _propTypes2.default.bool.isRequired,
  handleSearchOptionSelect: _propTypes2.default.func.isRequired,
  searchOptions: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
  selectedSearchOption: _propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.string.isRequired
  }).isRequired,
  toggleDisplaySearchOptions: _propTypes2.default.func.isRequired
};

exports.default = SearchOption;

/***/ }),

/***/ "./components/Search/SearchBar/Typeahead/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _Autosuggest = __webpack_require__("./elements/Autosuggest/index.js");

var _Autosuggest2 = _interopRequireDefault(_Autosuggest);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Autosuggest is an external dependency that is styled with classnames. elements/Autosuggest is
// the export from react-autosuggest that has been wrapped in a style wrapper.


var Typeahead = function (_Component) {
  _inherits(Typeahead, _Component);

  function Typeahead() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Typeahead);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Typeahead.__proto__ || Object.getPrototypeOf(Typeahead)).call.apply(_ref, [this].concat(args))), _this), _this.onKeyDown = function (event) {
      if (event.key === 'Enter') {
        _this.props.performSearch();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  // Autosuggest is a controlled component.
  // This means that you need to provide an input value
  // and an onChange handler that updates this value (see below).
  // Suggestions also need to be provided to the Autosuggest,
  // and they are initially empty because the Autosuggest is closed.


  _createClass(Typeahead, [{
    key: 'componentDidUpdate',


    // This logic also helps maintain focus on the user input.
    value: function componentDidUpdate(prevProps) {
      var wasFocused = prevProps.focused,
          wasSearchOptionDisplayed = prevProps.displaySearchOptions;
      var _props = this.props,
          focused = _props.focused,
          searchOptionDisplayed = _props.displaySearchOptions;

      if (focused !== wasFocused && focused || searchOptionDisplayed !== wasSearchOptionDisplayed && !searchOptionDisplayed) {
        this.self.input.focus();
      }
    }

    // If the user presses the enter key, we should clear the search input and perform the search.
    // This will fire if the user has keyed to their desired suggestion or if the user is simply
    // typing and hits enter.

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          getSearchSuggestions = _props2.getSearchSuggestions,
          clearSearchSuggestions = _props2.clearSearchSuggestions,
          searchSuggestions = _props2.searchSuggestions,
          focused = _props2.focused;
      var _props3 = this.props,
          handleSearchValueChange = _props3.handleSearchValueChange,
          searchValue = _props3.searchValue;

      // Autosuggest will pass through all these props to the input element.

      var inputProps = {
        placeholder: 'Search',
        onChange: handleSearchValueChange,
        onKeyDown: this.onKeyDown,
        value: searchValue
      };

      return _react2.default.createElement(_Autosuggest2.default, {
        autosuggestRef: function autosuggestRef(self) {
          _this2.self = self;
        },
        getSuggestionValue: function getSuggestionValue(suggestion) {
          return suggestion.id;
        },
        inputProps: inputProps,
        onSuggestionsClearRequested: clearSearchSuggestions,
        onSuggestionsFetchRequested: getSearchSuggestions,
        renderSuggestion: function renderSuggestion(suggestion) {
          return _react2.default.createElement(_Autosuggest.Suggestion, { suggestion: suggestion });
        },
        suggestions: searchSuggestions,
        modifiers: (0, _lodash.compact)([focused && 'focused'])
      });
    }
  }]);

  return Typeahead;
}(_react.Component);

Typeahead.propTypes = {
  clearSearchSuggestions: _propTypes2.default.func.isRequired,
  displaySearchOptions: _propTypes2.default.bool.isRequired,
  focused: _propTypes2.default.bool.isRequired,
  getSearchSuggestions: _propTypes2.default.func.isRequired,
  handleSearchValueChange: _propTypes2.default.func.isRequired,
  performSearch: _propTypes2.default.func.isRequired,
  searchSuggestions: _propTypes2.default.arrayOf(_propTypes2.default.object),
  searchValue: _propTypes2.default.string
};
Typeahead.defaultProps = {
  searchSuggestions: [],
  searchValue: ''
};
exports.default = Typeahead;

/***/ }),

/***/ "./components/Search/SearchBar/Wrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  expanded: function expanded() {
    return {
      styles: 'width: ' + (0, _decisivUiUtils.px2rem)(300) + ';'
    };
  }
};

/* istanbul ignore next */
var styles = function styles() {
  return '\n  display: inline-flex;\n  height: 100%;\n  transition-duration: 0.2s;\n  transition-timing-function: cubic-bezier(0, 0, 1, 1);\n  vertical-align: top;\n  width: 0;\n';
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('SearchBarWrapper', _styledComponents2.default.div, styles, { modifierConfig: modifierConfig });

/***/ }),

/***/ "./components/Search/SearchBar/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _VerticalDivider = __webpack_require__("./elements/VerticalDivider/index.js");

var _VerticalDivider2 = _interopRequireDefault(_VerticalDivider);

var _Wrapper = __webpack_require__("./components/Search/SearchBar/Wrapper.js");

var _Wrapper2 = _interopRequireDefault(_Wrapper);

var _SearchOption = __webpack_require__("./components/Search/SearchBar/SearchOption/index.js");

var _SearchOption2 = _interopRequireDefault(_SearchOption);

var _Typeahead = __webpack_require__("./components/Search/SearchBar/Typeahead/index.js");

var _Typeahead2 = _interopRequireDefault(_Typeahead);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SearchBar(_ref) {
  var displaySearchOptions = _ref.displaySearchOptions,
      expanded = _ref.expanded,
      getSearchSuggestions = _ref.getSearchSuggestions,
      clearSearchSuggestions = _ref.clearSearchSuggestions,
      handleSearchOptionSelect = _ref.handleSearchOptionSelect,
      handleSearchValueChange = _ref.handleSearchValueChange,
      performSearch = _ref.performSearch,
      searchOptions = _ref.searchOptions,
      searchSuggestions = _ref.searchSuggestions,
      searchValue = _ref.searchValue,
      selectedSearchOption = _ref.selectedSearchOption,
      toggleDisplaySearchOptions = _ref.toggleDisplaySearchOptions;

  var showExpanded = expanded && 'expanded';
  return _react2.default.createElement(
    _Wrapper2.default,
    { modifiers: (0, _lodash.compact)([showExpanded]) },
    _react2.default.createElement(_SearchOption2.default, {
      displaySearchOptions: displaySearchOptions,
      expanded: expanded,
      handleSearchOptionSelect: handleSearchOptionSelect,
      searchOptions: searchOptions,
      selectedSearchOption: selectedSearchOption,
      toggleDisplaySearchOptions: toggleDisplaySearchOptions
    }),
    _react2.default.createElement(_VerticalDivider2.default, { modifiers: ['dark'] }),
    _react2.default.createElement(_Typeahead2.default, {
      clearSearchSuggestions: clearSearchSuggestions,
      displaySearchOptions: displaySearchOptions,
      focused: expanded && !!selectedSearchOption.id,
      getSearchSuggestions: getSearchSuggestions,
      handleSearchValueChange: handleSearchValueChange,
      performSearch: performSearch,
      searchSuggestions: searchSuggestions,
      searchValue: searchValue
    })
  );
}

SearchBar.propTypes = {
  displaySearchOptions: _propTypes2.default.bool.isRequired,
  expanded: _propTypes2.default.bool.isRequired,
  getSearchSuggestions: _propTypes2.default.func.isRequired,
  clearSearchSuggestions: _propTypes2.default.func.isRequired,
  handleSearchOptionSelect: _propTypes2.default.func.isRequired,
  handleSearchValueChange: _propTypes2.default.func.isRequired,
  performSearch: _propTypes2.default.func.isRequired,
  searchOptions: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
  searchSuggestions: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
  searchValue: _propTypes2.default.string,
  selectedSearchOption: _propTypes2.default.shape().isRequired,
  toggleDisplaySearchOptions: _propTypes2.default.func.isRequired
};

SearchBar.defaultProps = {
  searchValue: ''
};

exports.default = SearchBar;

/***/ }),

/***/ "./components/Search/SearchButton/SearchIcon.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactFontawesome = __webpack_require__("../node_modules/react-fontawesome/lib/index.js");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function UnstyledIcon(props) {
  var iconProps = (0, _lodash.omit)(props, ['theme', 'modifiers']);
  return _react2.default.createElement(_reactFontawesome2.default, iconProps);
}

var modifierConfig = {
  disabled: function disabled() {
    return '\n    opacity: 0.5;\n  ';
  }
};

var styles = '';

exports.default = (0, _decisivUiUtils.buildStyledComponent)('SearchIcon', (0, _styledComponents2.default)(UnstyledIcon), styles, { modifierConfig: modifierConfig });

/***/ }),

/***/ "./components/Search/SearchButton/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _constants = __webpack_require__("./redux/constants.js");

var _CircleButton = __webpack_require__("./elements/CircleButton/index.js");

var _CircleButton2 = _interopRequireDefault(_CircleButton);

var _SearchIcon = __webpack_require__("./components/Search/SearchButton/SearchIcon.js");

var _SearchIcon2 = _interopRequireDefault(_SearchIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// A simple magnifying glass in a circle. Clicking it expands the search bar.
function SearchButton(_ref) {
  var expanded = _ref.expanded,
      _onClick = _ref.onClick,
      performSearch = _ref.performSearch,
      searchValue = _ref.searchValue;

  var closedAndActive = !expanded;
  var openAndDisabled = searchValue.length <= _constants.MIN_CHAR_SEARCH && expanded;
  var openAndActive = searchValue.length > _constants.MIN_CHAR_SEARCH && expanded;

  return _react2.default.createElement(
    _CircleButton2.default,
    {
      disabled: openAndDisabled,
      id: 'search-button',
      modifiers: (0, _lodash.compact)([openAndDisabled && 'disabled']),
      onClick: function onClick() {
        if (closedAndActive) {
          return _onClick();
        } else if (openAndActive) {
          return performSearch();
        }
        return null;
      }
    },
    _react2.default.createElement(_SearchIcon2.default, { name: 'search', modifiers: (0, _lodash.compact)([openAndDisabled && 'disabled']) })
  );
}

SearchButton.propTypes = {
  expanded: _propTypes2.default.bool.isRequired,
  onClick: _propTypes2.default.func.isRequired,
  performSearch: _propTypes2.default.func.isRequired,
  searchValue: _propTypes2.default.string.isRequired
};

exports.default = SearchButton;

/***/ }),

/***/ "./components/Search/Wrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = '\n  height: ' + (0, _decisivUiUtils.px2rem)(35) + ';\n  display: inline-block;\n  overflow: visible;\n  position: relative;\n  text-align: right;\n';

exports.default = (0, _decisivUiUtils.buildStyledComponent)('SearchWrapper', _styledComponents2.default.div, styles);

/***/ }),

/***/ "./components/Search/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Search = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactClickOutside = __webpack_require__("../node_modules/react-click-outside/dist/index.js");

var _reactClickOutside2 = _interopRequireDefault(_reactClickOutside);

var _Wrapper = __webpack_require__("./components/Search/Wrapper.js");

var _Wrapper2 = _interopRequireDefault(_Wrapper);

var _SearchBar = __webpack_require__("./components/Search/SearchBar/index.js");

var _SearchBar2 = _interopRequireDefault(_SearchBar);

var _SearchButton = __webpack_require__("./components/Search/SearchButton/index.js");

var _SearchButton2 = _interopRequireDefault(_SearchButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// The "...rest" of the props is lengthy, and there is no need to individually specify them here.
var Search = exports.Search = function (_Component) {
  _inherits(Search, _Component);

  function Search() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Search);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Search.__proto__ || Object.getPrototypeOf(Search)).call.apply(_ref, [this].concat(args))), _this), _this.handleClickOutside = function (e) {
      _this.props.onOutsideClick(e);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Search, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          expanded = _props.expanded,
          performSearch = _props.performSearch,
          toggleSearchExpanded = _props.toggleSearchExpanded,
          searchValue = _props.searchValue,
          rest = _objectWithoutProperties(_props, ['expanded', 'performSearch', 'toggleSearchExpanded', 'searchValue']);

      return _react2.default.createElement(
        _Wrapper2.default,
        null,
        _react2.default.createElement(_SearchBar2.default, _extends({
          expanded: expanded,
          performSearch: performSearch,
          searchValue: searchValue
        }, rest)),
        _react2.default.createElement(_SearchButton2.default, {
          expanded: expanded,
          onClick: toggleSearchExpanded,
          performSearch: performSearch,
          searchValue: searchValue
        })
      );
    }
  }]);

  return Search;
}(_react.Component);

Search.propTypes = {
  expanded: _propTypes2.default.bool.isRequired,
  performSearch: _propTypes2.default.func.isRequired,
  searchValue: _propTypes2.default.string.isRequired,
  toggleSearchExpanded: _propTypes2.default.func.isRequired,
  onOutsideClick: _propTypes2.default.func.isRequired
};

exports.default = (0, _reactClickOutside2.default)(Search);

/***/ }),

/***/ "./components/SearchResultsPanel/NoSearchResults.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactFontawesome = __webpack_require__("../node_modules/react-fontawesome/lib/index.js");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _messages = __webpack_require__("./components/SearchResultsPanel/messages.js");

var _messages2 = _interopRequireDefault(_messages);

var _NoSearchResultsWrapper = __webpack_require__("./components/SearchResultsPanel/NoSearchResultsWrapper.js");

var _NoSearchResultsWrapper2 = _interopRequireDefault(_NoSearchResultsWrapper);

var _NoSearchResultsTitle = __webpack_require__("./components/SearchResultsPanel/NoSearchResultsTitle.js");

var _NoSearchResultsTitle2 = _interopRequireDefault(_NoSearchResultsTitle);

var _NoSearchResultsTitleValue = __webpack_require__("./components/SearchResultsPanel/NoSearchResultsTitleValue.js");

var _NoSearchResultsTitleValue2 = _interopRequireDefault(_NoSearchResultsTitleValue);

var _NoSearchResultsSubtitle = __webpack_require__("./components/SearchResultsPanel/NoSearchResultsSubtitle.js");

var _NoSearchResultsSubtitle2 = _interopRequireDefault(_NoSearchResultsSubtitle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function NoSearchResults(_ref) {
  var searchValue = _ref.searchValue;

  return _react2.default.createElement(
    _NoSearchResultsWrapper2.default,
    null,
    _react2.default.createElement(_reactFontawesome2.default, { name: 'search' }),
    _react2.default.createElement(
      _NoSearchResultsTitle2.default,
      null,
      _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.noResultsTitle }),
      _react2.default.createElement(
        _NoSearchResultsTitleValue2.default,
        null,
        ' ' + searchValue
      )
    ),
    _react2.default.createElement(
      _NoSearchResultsSubtitle2.default,
      null,
      searchValue && searchValue.length > 2 ? _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.noResultsNoMatch }) : _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.noResultsWrongQuery })
    )
  );
}

NoSearchResults.propTypes = {
  searchValue: _propTypes2.default.string.isRequired
};

exports.default = NoSearchResults;

/***/ }),

/***/ "./components/SearchResultsPanel/NoSearchResultsSubtitle.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  color: ' + props.theme.colors.base.text + ';\n  font-size: ' + (0, _decisivUiUtils.px2rem)(20) + ';\n  font-weight: normal;\n  line-height: ' + (0, _decisivUiUtils.px2rem)(25) + ';\n  margin: 0;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('NoSearchResultsSubtitle', _styledComponents2.default.h2, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/SearchResultsPanel/NoSearchResultsTitle.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  color: ' + props.theme.colors.base.text + ';\n  font-size: ' + (0, _decisivUiUtils.px2rem)(25) + ';\n  font-weight: normal;\n  line-height: ' + (0, _decisivUiUtils.px2rem)(25) + ';\n  margin-bottom: ' + (0, _decisivUiUtils.px2rem)(16) + ';\n  margin-top: ' + (0, _decisivUiUtils.px2rem)(30) + ';\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('NoSearchResultsTitle', _styledComponents2.default.h2, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/SearchResultsPanel/NoSearchResultsTitleValue.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  font-weight: bold;\n'], ['\n  font-weight: bold;\n']);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var NoSearchResultsTitleValue = function () {
  var c = _styledComponents2.default.span(_templateObject);

  c.displayName = 'NoSearchResultsTitleValue';
  return c;
}();

exports.default = NoSearchResultsTitleValue;

/***/ }),

/***/ "./components/SearchResultsPanel/NoSearchResultsWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  color: ' + props.theme.colors.base.chrome300 + ';\n  font-size: ' + (0, _decisivUiUtils.px2rem)(72) + ';\n  margin-top: ' + (0, _decisivUiUtils.px2rem)(90) + ';\n  line-height: ' + (0, _decisivUiUtils.px2rem)(72) + ';\n  text-align: center;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome300: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('NoSearchResultsWrapper', _styledComponents2.default.div, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/SearchResultsPanel/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactImmutableProptypes = __webpack_require__("../node_modules/react-immutable-proptypes/dist/ImmutablePropTypes.js");

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _CaseDisplayContainer = __webpack_require__("./containers/CaseDisplayContainer/index.js");

var _CaseDisplayContainer2 = _interopRequireDefault(_CaseDisplayContainer);

var _AssetDisplayElement = __webpack_require__("./components/AssetDisplayElement/index.js");

var _AssetDisplayElement2 = _interopRequireDefault(_AssetDisplayElement);

var _paginateFavorites = __webpack_require__("./components/_common/paginateFavorites/index.js");

var _paginateFavorites2 = _interopRequireDefault(_paginateFavorites);

var _AssetsPanel = __webpack_require__("./components/AssetsPanel/index.js");

var _CasesPanel = __webpack_require__("./components/CasesPanel/index.js");

var _RefreshBlock = __webpack_require__("./components/RefreshBlock/index.js");

var _RefreshBlock2 = _interopRequireDefault(_RefreshBlock);

var _TabBar = __webpack_require__("./components/TabBar/index.js");

var _TabBar2 = _interopRequireDefault(_TabBar);

var _PageContentPanel = __webpack_require__("./elements/PageContentPanel/index.js");

var _PageContentPanel2 = _interopRequireDefault(_PageContentPanel);

var _NoSearchResults = __webpack_require__("./components/SearchResultsPanel/NoSearchResults.js");

var _NoSearchResults2 = _interopRequireDefault(_NoSearchResults);

var _messages = __webpack_require__("./components/SearchResultsPanel/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchResultsPanel = function (_Component) {
  _inherits(SearchResultsPanel, _Component);

  function SearchResultsPanel() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SearchResultsPanel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SearchResultsPanel.__proto__ || Object.getPrototypeOf(SearchResultsPanel)).call.apply(_ref, [this].concat(args))), _this), _this.buildCasesList = function () {
      var _this$props = _this.props,
          currentTab = _this$props.currentTab,
          cases = _this$props.cases,
          requesting = _this$props.requesting,
          searchPagination = _this$props.searchPagination;


      if (currentTab !== 'cases') {
        return null;
      }

      var favoritePagination = searchPagination.get('cases');
      var componentProps = {
        cases: cases,
        dataList: cases,
        isResultsPage: true,
        requesting: requesting,
        favoritePagination: favoritePagination,
        CardComp: _CaseDisplayContainer2.default
      };
      var _this2 = _this,
          PaginatedCasesView = _this2.PaginatedCasesView;


      return _react2.default.createElement(PaginatedCasesView, {
        componentProps: componentProps,
        favoritePagination: favoritePagination,
        noFavoritesMessage: _messages2.default.noResultsNoMatch,
        requestInProgress: requesting
      });
    }, _this.buildAssetsList = function () {
      var _this$props2 = _this.props,
          currentTab = _this$props2.currentTab,
          assets = _this$props2.assets,
          requesting = _this$props2.requesting,
          searchPagination = _this$props2.searchPagination;


      if (currentTab !== 'assets') {
        return null;
      }

      var favoritePagination = searchPagination.get('assets');
      var componentProps = {
        assets: assets,
        dataList: assets,
        requesting: requesting,
        favoritePagination: favoritePagination,
        CardComp: _AssetDisplayElement2.default
      };
      var _this3 = _this,
          PaginatedAssetsView = _this3.PaginatedAssetsView;


      return _react2.default.createElement(PaginatedAssetsView, {
        componentProps: componentProps,
        favoritePagination: favoritePagination,
        noFavoritesMessage: _messages2.default.noResultsNoMatch,
        requestInProgress: requesting
      });
    }, _this.sumSearchPagination = function (searchPagination) {
      var tabCounts = searchPagination.map(function (tabData) {
        return Number(tabData.get('totalCount') || 0);
      });
      return tabCounts.reduce(function (a, b) {
        return a + b;
      }, 0);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SearchResultsPanel, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var casesPaginationMethods = {
        requestNext: this.props.requestNextCases
      };
      var assetsPaginationMethods = {
        requestNext: this.props.requestNextAssets
      };
      this.PaginatedCasesView = (0, _paginateFavorites2.default)(casesPaginationMethods)(_CasesPanel.CasesListView);
      this.PaginatedAssetsView = (0, _paginateFavorites2.default)(assetsPaginationMethods)(_AssetsPanel.AssetsListView);
    }

    /**
     * sumSearchPaginaton returns sum of totalCount values from each group
     * ("tab" in the UI) of the searchResults
     */

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          currentTab = _props.currentTab,
          handleTabChange = _props.handleTabChange,
          refresh = _props.refresh,
          requesting = _props.requesting,
          searchValue = _props.searchValue,
          tabs = _props.tabs,
          searchPagination = _props.searchPagination;


      var matchesCount = this.sumSearchPagination(searchPagination);
      var noSearchResult = !requesting && matchesCount === 0 && searchValue;

      return _react2.default.createElement(
        _PageContentPanel2.default,
        { id: 'search-results-panel' },
        _react2.default.createElement(
          _TabBar2.default,
          {
            currentTab: currentTab,
            onChangeTab: handleTabChange,
            tabs: tabs
          },
          _react2.default.createElement(
            _TabBar.TabBarOptionsWrapper,
            null,
            _react2.default.createElement(_RefreshBlock2.default, {
              count: matchesCount,
              refresh: refresh,
              requesting: requesting,
              type: 'search'
            })
          )
        ),
        this.buildCasesList(),
        this.buildAssetsList(),
        noSearchResult && _react2.default.createElement(_NoSearchResults2.default, { searchValue: searchValue })
      );
    }
  }]);

  return SearchResultsPanel;
}(_react.Component);

SearchResultsPanel.propTypes = {
  assets: _reactImmutableProptypes2.default.listOf(_reactImmutableProptypes2.default.mapContains({
    id: _propTypes2.default.string
  })).isRequired,
  cases: _reactImmutableProptypes2.default.listOf(_reactImmutableProptypes2.default.mapContains({
    id: _propTypes2.default.string
  })).isRequired,
  currentTab: _propTypes2.default.string.isRequired,
  handleTabChange: _propTypes2.default.func.isRequired,
  refresh: _propTypes2.default.func.isRequired,
  requesting: _propTypes2.default.bool.isRequired,
  searchValue: _propTypes2.default.string.isRequired,
  tabs: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    name: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.object.isRequired
  }).isRequired).isRequired,
  searchPagination: _reactImmutableProptypes2.default.map.isRequired,
  requestNextCases: _propTypes2.default.func.isRequired,
  requestNextAssets: _propTypes2.default.func.isRequired
};

exports.default = SearchResultsPanel;

/***/ }),

/***/ "./components/SearchResultsPanel/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  noResultsTitle: (0, _linguiReact.i18nMark)('No matches for'),
  noResultsNoMatch: (0, _linguiReact.i18nMark)('Try broadening your search criteria.'),
  noResultsWrongQuery: (0, _linguiReact.i18nMark)('Enter at least 3 characters for your search.')
};

exports.default = messages;

/***/ }),

/***/ "./components/SelectorBar/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SERVICE_REQUESTS_VIEW_OPTIONS = exports.ASSETS_VIEW_OPTIONS = exports.CASES_VIEW_OPTIONS = undefined;

var _messages = __webpack_require__("./components/SelectorBar/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO: Re-introduce map views by un-commenting commented options

var CASES_VIEW_OPTIONS = exports.CASES_VIEW_OPTIONS = [{
  id: 'cards',
  label: _messages2.default.cards
}, {
  id: 'list',
  label: _messages2.default.list
}];

var ASSETS_VIEW_OPTIONS = exports.ASSETS_VIEW_OPTIONS = [{
  id: 'cards',
  label: _messages2.default.cards
}, {
  id: 'list',
  label: _messages2.default.list
}];

var SERVICE_REQUESTS_VIEW_OPTIONS = exports.SERVICE_REQUESTS_VIEW_OPTIONS = [{
  id: 'cards',
  label: _messages2.default.cards
}, {
  id: 'list',
  label: _messages2.default.list
}];

/***/ }),

/***/ "./components/SelectorBar/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _ViewSelector = __webpack_require__("./components/ViewSelector/index.js");

var _ViewSelector2 = _interopRequireDefault(_ViewSelector);

var _SplitBlock = __webpack_require__("./elements/SplitBlock/index.js");

var _constants = __webpack_require__("./components/SelectorBar/constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getOptions(type) {
  switch (type) {
    case 'asset':
      return _constants.ASSETS_VIEW_OPTIONS;
    case 'serviceRequests':
      return _constants.SERVICE_REQUESTS_VIEW_OPTIONS;
    case 'case':
    default:
      return _constants.CASES_VIEW_OPTIONS;
  }
}

function SelectorBar(_ref) {
  var view = _ref.view,
      setView = _ref.setView,
      type = _ref.type;

  var options = getOptions(type);
  return _react2.default.createElement(
    _SplitBlock.SplitBlock,
    { modifiers: ['pad'] },
    _react2.default.createElement(
      _SplitBlock.SplitBlockPart,
      { modifiers: ['left', 'wide'] },
      _react2.default.createElement(
        _SplitBlock.SplitBlockElement,
        { modifiers: ['padRight'] },
        _react2.default.createElement(_ViewSelector2.default, {
          id: 'cases-view-selector',
          changeView: setView,
          options: options,
          selected: view
        })
      )
    )
  );
}

SelectorBar.propTypes = {
  view: _propTypes2.default.string.isRequired,
  setView: _propTypes2.default.func.isRequired,
  type: _propTypes2.default.string.isRequired
};

exports.default = SelectorBar;

/***/ }),

/***/ "./components/SelectorBar/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  cards: (0, _linguiReact.i18nMark)('Cards'),
  list: (0, _linguiReact.i18nMark)('List'),
  map: (0, _linguiReact.i18nMark)('Map')
};

exports.default = messages;

/***/ }),

/***/ "./components/ServiceProvidersList/SelectedLabel/Wrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(_ref) {
  var theme = _ref.theme;
  return '\n  align-items: center;\n  display: inline-flex;\n  .fa {\n    color: ' + theme.colors.status.success + ';\n    margin-right: ' + (0, _decisivUiUtils.px2rem)(5) + ';\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    status: _propTypes2.default.shape({
      success: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Wrapper', _styledComponents2.default.div, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/ServiceProvidersList/SelectedLabel/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactFontawesome = __webpack_require__("../node_modules/react-fontawesome/lib/index.js");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _baseComponents = __webpack_require__("../node_modules/base-components/build/index.js");

var _Wrapper = __webpack_require__("./components/ServiceProvidersList/SelectedLabel/Wrapper.js");

var _Wrapper2 = _interopRequireDefault(_Wrapper);

var _messages = __webpack_require__("./components/ServiceProvidersList/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SelectedLabel() {
  return _react2.default.createElement(
    _Wrapper2.default,
    null,
    _react2.default.createElement(_reactFontawesome2.default, { name: 'check-circle' }),
    _react2.default.createElement(
      _baseComponents.P,
      { modifiers: ['fontWeightLight', 'textLight', 'uppercase'] },
      _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.selected })
    )
  );
}

exports.default = SelectedLabel;

/***/ }),

/***/ "./components/ServiceProvidersList/ServiceProvider.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _baseComponents = __webpack_require__("../node_modules/base-components/build/index.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/styled-components-reactive-grid/dist/index.js");

var _SelectedLabel = __webpack_require__("./components/ServiceProvidersList/SelectedLabel/index.js");

var _SelectedLabel2 = _interopRequireDefault(_SelectedLabel);

var _messages = __webpack_require__("./components/ServiceProvidersList/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ServiceProvider(_ref) {
  var isSelected = _ref.isSelected,
      onSelect = _ref.onSelect,
      serviceProvider = _ref.serviceProvider;
  var _serviceProvider$addr = serviceProvider.address,
      city = _serviceProvider$addr.city,
      postalCode = _serviceProvider$addr.postalCode,
      region = _serviceProvider$addr.region,
      street = _serviceProvider$addr.street,
      street2 = _serviceProvider$addr.street2,
      companyName = serviceProvider.companyName;


  return _react2.default.createElement(
    _styledComponentsReactiveGrid.Container,
    { className: 'ServiceProvider', modifiers: ['padScaleY_4'] },
    _react2.default.createElement(
      _styledComponentsReactiveGrid.Row,
      { modifiers: ['middle'] },
      _react2.default.createElement(
        _styledComponentsReactiveGrid.Column,
        { modifiers: ['col'] },
        _react2.default.createElement(
          _baseComponents.H4,
          null,
          companyName
        )
      ),
      _react2.default.createElement(
        _styledComponentsReactiveGrid.Column,
        { modifiers: ['col', 'end'] },
        isSelected ? _react2.default.createElement(_SelectedLabel2.default, null) : _react2.default.createElement(
          _baseComponents.QuickActionButton,
          {
            modifiers: ['hoverSuccess'],
            onClick: function onClick() {
              return onSelect(serviceProvider);
            }
          },
          _react2.default.createElement(
            _baseComponents.QuickActionButton.Text,
            null,
            _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.select })
          )
        )
      )
    ),
    _react2.default.createElement(
      _styledComponentsReactiveGrid.Row,
      null,
      _react2.default.createElement(
        _styledComponentsReactiveGrid.Column,
        { modifiers: ['col_12', 'padScaleY_0'] },
        _react2.default.createElement(
          _baseComponents.P,
          null,
          street + ' ' + street2
        )
      ),
      _react2.default.createElement(
        _styledComponentsReactiveGrid.Column,
        { modifiers: ['col_12', 'padScaleY_0'] },
        _react2.default.createElement(
          _baseComponents.P,
          null,
          city + ', ' + region + ' ' + postalCode
        )
      )
    )
  );
}

ServiceProvider.propTypes = {
  isSelected: _propTypes2.default.bool.isRequired,
  onSelect: _propTypes2.default.func.isRequired,
  serviceProvider: _propTypes2.default.shape({
    address: _propTypes2.default.shape({
      city: _propTypes2.default.string,
      postalCode: _propTypes2.default.string,
      region: _propTypes2.default.string,
      street: _propTypes2.default.string,
      street2: _propTypes2.default.string
    }).isRequired,
    companyName: _propTypes2.default.string
  }).isRequired
};

exports.default = ServiceProvider;

/***/ }),

/***/ "./components/ServiceProvidersList/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _ScrollableContainer = __webpack_require__("./elements/ScrollableContainer/index.js");

var _ScrollableContainer2 = _interopRequireDefault(_ScrollableContainer);

var _ServiceProvider = __webpack_require__("./components/ServiceProvidersList/ServiceProvider.js");

var _ServiceProvider2 = _interopRequireDefault(_ServiceProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ServiceProvidersList(_ref) {
  var onSelect = _ref.onSelect,
      selectedServiceProvider = _ref.selectedServiceProvider,
      serviceProviders = _ref.serviceProviders;

  return _react2.default.createElement(
    _ScrollableContainer2.default,
    { modifiers: ['fluid'], style: { height: (0, _decisivUiUtils.px2rem)(330) } },
    _react2.default.createElement(
      _ScrollableContainer2.default.List,
      null,
      serviceProviders.map(function (serviceProvider) {
        var isSelected = serviceProvider.id === selectedServiceProvider.id;
        return _react2.default.createElement(
          _ScrollableContainer2.default.ListElement,
          {
            key: serviceProvider.id,
            modifiers: (0, _lodash.compact)([isSelected && 'selected'])
          },
          _react2.default.createElement(_ServiceProvider2.default, {
            serviceProvider: serviceProvider,
            onSelect: onSelect,
            isSelected: isSelected
          })
        );
      })
    )
  );
}

ServiceProvidersList.propTypes = {
  onSelect: _propTypes2.default.func.isRequired,
  selectedServiceProvider: _propTypes2.default.shape({
    id: _propTypes2.default.string
  }),
  serviceProviders: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    id: _propTypes2.default.string
  })).isRequired
};

ServiceProvidersList.defaultProps = {
  selectedServiceProvider: {}
};

exports.default = ServiceProvidersList;

/***/ }),

/***/ "./components/ServiceProvidersList/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  select: (0, _linguiReact.i18nMark)('Select'),
  selected: (0, _linguiReact.i18nMark)('Selected')
};

exports.default = messages;

/***/ }),

/***/ "./components/ServiceRequestDisplayElement/AdditionalInfo.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactImmutableProptypes = __webpack_require__("../node_modules/react-immutable-proptypes/dist/ImmutablePropTypes.js");

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _FollowUpLabel = __webpack_require__("./components/_common/FollowUpLabel/index.js");

var _FollowUpLabel2 = _interopRequireDefault(_FollowUpLabel);

var _Card = __webpack_require__("./elements/Card/index.js");

var _SplitBlock = __webpack_require__("./elements/SplitBlock/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AdditionalInfo(_ref) {
  var serviceRequestInfo = _ref.serviceRequestInfo;

  var followUpColor = serviceRequestInfo.get('followUpColor');
  var followUpTime = serviceRequestInfo.get('followUpTime');

  return _react2.default.createElement(
    _Card.CardElement,
    null,
    _react2.default.createElement(
      _SplitBlock.SplitBlock,
      { pad: 'none' },
      _react2.default.createElement(
        _SplitBlock.SplitBlockPart,
        { modifiers: ['left', 'wide'] },
        _react2.default.createElement(
          _SplitBlock.SplitBlockElement,
          null,
          _react2.default.createElement(_FollowUpLabel2.default, {
            followUpColor: followUpColor,
            followUpTime: followUpTime
          })
        )
      )
    )
  );
}

AdditionalInfo.propTypes = {
  serviceRequestInfo: _reactImmutableProptypes2.default.map.isRequired
};

exports.default = AdditionalInfo;

/***/ }),

/***/ "./components/ServiceRequestDisplayElement/Complaint.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactImmutableProptypes = __webpack_require__("../node_modules/react-immutable-proptypes/dist/ImmutablePropTypes.js");

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _complaint = __webpack_require__("./utils/complaint.js");

var _complaint2 = _interopRequireDefault(_complaint);

var _Card = __webpack_require__("./elements/Card/index.js");

var _Popover = __webpack_require__("./elements/Popover/index.js");

var _Popover2 = _interopRequireDefault(_Popover);

var _TextDiv = __webpack_require__("./elements/TextDiv/index.js");

var _TextDiv2 = _interopRequireDefault(_TextDiv);

var _messages = __webpack_require__("./components/ServiceRequestDisplayElement/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Complaint(_ref) {
  var serviceRequestInfo = _ref.serviceRequestInfo;

  var _getComplaintText = (0, _complaint2.default)(serviceRequestInfo.toJS(), { titleInLink: false }),
      title = _getComplaintText.title,
      content = _getComplaintText.content;

  return _react2.default.createElement(
    _Card.CardElement,
    null,
    _react2.default.createElement(
      _Popover2.default,
      { showOnHover: true },
      _react2.default.createElement(
        _Popover.PopoverTarget,
        null,
        _react2.default.createElement(
          _TextDiv2.default,
          { modifiers: ['bold', 'bottomGap', 'smallText'] },
          _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.complaint })
        ),
        _react2.default.createElement(
          _TextDiv2.default,
          { modifiers: ['bottomGap', 'heavyText', 'ellipsis', 'oneLine', 'smallText'] },
          title
        ),
        _react2.default.createElement(
          _TextDiv2.default,
          { modifiers: ['ellipsis', 'midGreyText', 'short', 'smallText'] },
          content
        )
      ),
      _react2.default.createElement(
        _Popover.PopoverContent,
        null,
        _react2.default.createElement(
          _Popover.ScrollingPopoverContentWrapper,
          { modifiers: ['smallText'] },
          _react2.default.createElement(
            _TextDiv2.default,
            { modifiers: ['bold', 'bright', 'bottomGap'] },
            title
          ),
          _react2.default.createElement(
            _TextDiv2.default,
            { modifiers: ['bottomGap'] },
            content
          )
        )
      )
    )
  );
}

Complaint.propTypes = {
  serviceRequestInfo: _reactImmutableProptypes2.default.contains({
    complaint: _propTypes2.default.shape({
      code: _propTypes2.default.string,
      description: _propTypes2.default.string
    }),
    description: _propTypes2.default.string
  }).isRequired
};

exports.default = Complaint;

/***/ }),

/***/ "./components/ServiceRequestDisplayElement/ReasonForRepair.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactImmutableProptypes = __webpack_require__("../node_modules/react-immutable-proptypes/dist/ImmutablePropTypes.js");

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _widget = __webpack_require__("./utils/widget.js");

var _Card = __webpack_require__("./elements/Card/index.js");

var _TextDiv = __webpack_require__("./elements/TextDiv/index.js");

var _TextDiv2 = _interopRequireDefault(_TextDiv);

var _messages = __webpack_require__("./components/ServiceRequestDisplayElement/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ReasonForRepair(_ref) {
  var serviceRequestInfo = _ref.serviceRequestInfo;

  var code = serviceRequestInfo.getIn(['reasonForRepair', 'code']);
  var description = serviceRequestInfo.getIn(['reasonForRepair', 'description']);
  var codeDescription = code && description ? code + ' - ' + description : '';

  return _react2.default.createElement(
    _Card.CardElement,
    null,
    _react2.default.createElement(
      _TextDiv2.default,
      { modifiers: ['bold', 'bottomGap', 'smallText'] },
      _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.reasonForRepair })
    ),
    _react2.default.createElement(
      _TextDiv2.default,
      { modifiers: ['bottomGap', 'ellipsis', 'oneLine', 'smallText'] },
      (0, _widget.getOutputText)(codeDescription)
    )
  );
}

ReasonForRepair.propTypes = {
  serviceRequestInfo: _reactImmutableProptypes2.default.contains({
    reasonForRepair: _reactImmutableProptypes2.default.contains({
      code: _propTypes2.default.string,
      description: _propTypes2.default.string
    })
  }).isRequired
};

exports.default = ReasonForRepair;

/***/ }),

/***/ "./components/ServiceRequestDisplayElement/ServiceProvider.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactImmutableProptypes = __webpack_require__("../node_modules/react-immutable-proptypes/dist/ImmutablePropTypes.js");

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _timeUtils = __webpack_require__("./utils/timeUtils.js");

var _widget = __webpack_require__("./utils/widget.js");

var _Card = __webpack_require__("./elements/Card/index.js");

var _TextDiv = __webpack_require__("./elements/TextDiv/index.js");

var _TextDiv2 = _interopRequireDefault(_TextDiv);

var _StatusSpan = __webpack_require__("./elements/StatusSpan/index.js");

var _StatusSpan2 = _interopRequireDefault(_StatusSpan);

var _messages = __webpack_require__("./components/ServiceRequestDisplayElement/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ServiceProvider(_ref) {
  var serviceRequestInfo = _ref.serviceRequestInfo;

  var companyName = serviceRequestInfo.getIn(['serviceProvider', 'companyName']);
  var requestedAt = (0, _timeUtils.formatDate)(serviceRequestInfo.get('requestedAt'));
  var requestStatus = serviceRequestInfo.get('requestStatus');
  var requestStatusModifier = requestStatus && (0, _lodash.camelCase)(requestStatus);
  var statusSpanModifiers = [requestStatusModifier, 'bold', 'uppercase'];

  return _react2.default.createElement(
    _Card.CardElement,
    null,
    _react2.default.createElement(
      _TextDiv2.default,
      { modifiers: ['active', 'bold', 'bottomGap', 'ellipsis', 'oneLine', 'smallText'] },
      (0, _widget.getOutputText)(companyName)
    ),
    _react2.default.createElement(
      _Card.CardTable,
      { thModifiers: ['wide'], tdModifiers: ['leftAlign', 'midGreyText'] },
      _react2.default.createElement(
        'tbody',
        null,
        _react2.default.createElement(
          _Card.CardTableRow,
          null,
          _react2.default.createElement(
            'th',
            null,
            _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.status })
          ),
          _react2.default.createElement(
            'td',
            { colSpan: '2' },
            _react2.default.createElement(
              _StatusSpan2.default,
              { modifiers: (0, _lodash.compact)(statusSpanModifiers) },
              (0, _widget.getOutputText)(requestStatus)
            )
          )
        ),
        _react2.default.createElement(
          _Card.CardTableRow,
          { type: 'topGap' },
          _react2.default.createElement(
            'th',
            null,
            _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.requested })
          ),
          _react2.default.createElement(
            'td',
            { colSpan: '2' },
            (0, _widget.getOutputText)(requestedAt)
          )
        )
      )
    )
  );
}

ServiceProvider.propTypes = {
  serviceRequestInfo: _reactImmutableProptypes2.default.contains({
    requestStatus: _propTypes2.default.string,
    requestedAt: _propTypes2.default.string,
    serviceProvider: _reactImmutableProptypes2.default.contains({
      companyName: _propTypes2.default.string
    })
  }).isRequired
};

exports.default = ServiceProvider;

/***/ }),

/***/ "./components/ServiceRequestDisplayElement/ServiceRequestCard.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactImmutableProptypes = __webpack_require__("../node_modules/react-immutable-proptypes/dist/ImmutablePropTypes.js");

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _Card = __webpack_require__("./elements/Card/index.js");

var _Card2 = _interopRequireDefault(_Card);

var _Divider = __webpack_require__("./elements/Divider/index.js");

var _Divider2 = _interopRequireDefault(_Divider);

var _AdditionalInfo = __webpack_require__("./components/ServiceRequestDisplayElement/AdditionalInfo.js");

var _AdditionalInfo2 = _interopRequireDefault(_AdditionalInfo);

var _Complaint = __webpack_require__("./components/ServiceRequestDisplayElement/Complaint.js");

var _Complaint2 = _interopRequireDefault(_Complaint);

var _ReasonForRepair = __webpack_require__("./components/ServiceRequestDisplayElement/ReasonForRepair.js");

var _ReasonForRepair2 = _interopRequireDefault(_ReasonForRepair);

var _ServiceProvider = __webpack_require__("./components/ServiceRequestDisplayElement/ServiceProvider.js");

var _ServiceProvider2 = _interopRequireDefault(_ServiceProvider);

var _ServiceRequestTitle = __webpack_require__("./components/ServiceRequestDisplayElement/ServiceRequestTitle.js");

var _ServiceRequestTitle2 = _interopRequireDefault(_ServiceRequestTitle);

var _ServiceRequestVin = __webpack_require__("./components/ServiceRequestDisplayElement/ServiceRequestVin.js");

var _ServiceRequestVin2 = _interopRequireDefault(_ServiceRequestVin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ServiceRequestCard(_ref) {
  var serviceRequestInfo = _ref.serviceRequestInfo;

  return _react2.default.createElement(
    _Card2.default,
    { modifiers: ['noCursor'] },
    _react2.default.createElement(_ServiceRequestTitle2.default, { serviceRequestInfo: serviceRequestInfo }),
    _react2.default.createElement(_Divider2.default, { modifiers: ['gutter', 'heavy'] }),
    _react2.default.createElement(_ServiceRequestVin2.default, { serviceRequestInfo: serviceRequestInfo }),
    _react2.default.createElement(_Divider2.default, { modifiers: ['gutter', 'light', 'narrow'] }),
    _react2.default.createElement(_ReasonForRepair2.default, { serviceRequestInfo: serviceRequestInfo }),
    _react2.default.createElement(_Divider2.default, { modifiers: ['gutter', 'light', 'narrow'] }),
    _react2.default.createElement(_ServiceProvider2.default, { serviceRequestInfo: serviceRequestInfo }),
    _react2.default.createElement(_Divider2.default, { modifiers: ['gutter', 'light', 'narrow'] }),
    _react2.default.createElement(_Complaint2.default, { serviceRequestInfo: serviceRequestInfo }),
    _react2.default.createElement(_Divider2.default, { modifiers: ['gutter', 'light', 'narrow'] }),
    _react2.default.createElement(_AdditionalInfo2.default, { serviceRequestInfo: serviceRequestInfo })
  );
}

ServiceRequestCard.propTypes = {
  serviceRequestInfo: _reactImmutableProptypes2.default.map.isRequired
};

exports.default = ServiceRequestCard;

/***/ }),

/***/ "./components/ServiceRequestDisplayElement/ServiceRequestTitle.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactImmutableProptypes = __webpack_require__("../node_modules/react-immutable-proptypes/dist/ImmutablePropTypes.js");

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _Card = __webpack_require__("./elements/Card/index.js");

var _Link = __webpack_require__("./elements/Link/index.js");

var _Link2 = _interopRequireDefault(_Link);

var _SplitBlock = __webpack_require__("./elements/SplitBlock/index.js");

var _messages = __webpack_require__("./components/ServiceRequestDisplayElement/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ServiceRequestTitle(_ref) {
  var serviceRequestInfo = _ref.serviceRequestInfo;

  var serviceRequestId = serviceRequestInfo.get('id');

  return _react2.default.createElement(
    _Card.CardElement,
    null,
    _react2.default.createElement(
      _SplitBlock.SplitBlock,
      { pad: 'none' },
      _react2.default.createElement(
        _SplitBlock.SplitBlockPart,
        { modifiers: ['left', 'wide'] },
        _react2.default.createElement(
          _SplitBlock.SplitBlockElement,
          { modifiers: ['padRight'] },
          _react2.default.createElement(
            _Link2.default,
            { to: '/service-requests/' + serviceRequestId, modifiers: ['heavy', 'uppercase'] },
            _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.title, values: { serviceRequestId: serviceRequestId } })
          )
        )
      )
    )
  );
}

ServiceRequestTitle.propTypes = {
  serviceRequestInfo: _reactImmutableProptypes2.default.contains({
    serviceRequestId: _propTypes2.default.string,
    severityColor: _propTypes2.default.string,
    severityCount: _propTypes2.default.string
  }).isRequired
};

exports.default = ServiceRequestTitle;

/***/ }),

/***/ "./components/ServiceRequestDisplayElement/ServiceRequestVin.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactImmutableProptypes = __webpack_require__("../node_modules/react-immutable-proptypes/dist/ImmutablePropTypes.js");

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _widget = __webpack_require__("./utils/widget.js");

var _Card = __webpack_require__("./elements/Card/index.js");

var _messages = __webpack_require__("./components/ServiceRequestDisplayElement/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ServiceRequestVin(_ref) {
  var serviceRequestInfo = _ref.serviceRequestInfo;

  return _react2.default.createElement(
    _Card.CardElement,
    null,
    _react2.default.createElement(
      _Card.CardTable,
      { modifiers: ['uppercase'], tdModifiers: ['active', 'leftAlign'] },
      _react2.default.createElement(
        'tbody',
        null,
        _react2.default.createElement(
          _Card.CardTableRow,
          { type: 'topGap' },
          _react2.default.createElement(
            'th',
            null,
            _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.vin })
          ),
          _react2.default.createElement(
            'td',
            null,
            (0, _widget.getOutputText)(serviceRequestInfo.get('vinNumber'))
          )
        )
      )
    )
  );
}

ServiceRequestVin.propTypes = {
  serviceRequestInfo: _reactImmutableProptypes2.default.contains({
    vinNumber: _propTypes2.default.string
  }).isRequired
};

exports.default = ServiceRequestVin;

/***/ }),

/***/ "./components/ServiceRequestDisplayElement/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ServiceRequestCard = undefined;

var _ServiceRequestCard2 = __webpack_require__("./components/ServiceRequestDisplayElement/ServiceRequestCard.js");

var _ServiceRequestCard3 = _interopRequireDefault(_ServiceRequestCard2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = './ServiceRequestCard';
exports.ServiceRequestCard = _ServiceRequestCard3.default;

/***/ }),

/***/ "./components/ServiceRequestDisplayElement/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  title: (0, _linguiReact.i18nMark)('{serviceRequestId}'),
  codeDescription: (0, _linguiReact.i18nMark)('Code - Description'),
  reasonForRepair: (0, _linguiReact.i18nMark)('Reason for Repair'),
  requested: (0, _linguiReact.i18nMark)('Requested'),
  serviceProvider: (0, _linguiReact.i18nMark)('Service Provider'),
  status: (0, _linguiReact.i18nMark)('Status'),
  complaint: (0, _linguiReact.i18nMark)('Complaint'),
  vin: (0, _linguiReact.i18nMark)('VIN')
};

exports.default = messages;

/***/ }),

/***/ "./components/ServiceRequestMap/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ServiceRequestMap = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = __webpack_require__("../node_modules/recompose/es/Recompose.js");

var _reactGoogleMaps = __webpack_require__("../node_modules/react-google-maps/lib/index.js");

var _withGoogleMapJS = __webpack_require__("./utils/mapping/withGoogleMapJS.js");

var _withGoogleMapJS2 = _interopRequireDefault(_withGoogleMapJS);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LatLonPropType = _propTypes2.default.shape({
  lat: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  lon: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
});

function latLonToLatLng(_ref) {
  var lat = _ref.lat,
      lng = _ref.lon;

  return {
    lat: parseFloat(lat),
    lng: parseFloat(lng)
  };
}

var ServiceRequestMap = exports.ServiceRequestMap = function (_Component) {
  _inherits(ServiceRequestMap, _Component);

  function ServiceRequestMap() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, ServiceRequestMap);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = ServiceRequestMap.__proto__ || Object.getPrototypeOf(ServiceRequestMap)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      center: null,
      markers: []
    }, _this.setMapRef = function (map) {
      _this.map = map;
    }, _this.providerToLatLng = function (_ref3) {
      var _ref3$address$locatio = _ref3.address.location,
          lat = _ref3$address$locatio.lat,
          lon = _ref3$address$locatio.lon,
          id = _ref3.id;
      return {
        lat: parseFloat(lat), lng: parseFloat(lon), id: id
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ServiceRequestMap, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref4) {
      var serviceProviders = _ref4.serviceProviders,
          currentLocation = _ref4.currentLocation,
          googleMaps = _ref4.googleMaps;

      var center = latLonToLatLng(currentLocation);

      if (isNaN(center.lat) || isNaN(center.lng) || !serviceProviders.length) {
        this.setState({ center: null, markers: [] });
        return;
      }

      var centerMarker = _extends({}, center, { id: 0 });
      var markers = [].concat(_toConsumableArray(serviceProviders.map(this.providerToLatLng)), [centerMarker]);
      this.setState({ markers: markers, center: center });
      var newBounds = new googleMaps.LatLngBounds();

      if (markers.length) {
        markers.forEach(function (_ref5) {
          var lat = _ref5.lat,
              lng = _ref5.lng;

          newBounds.extend(new googleMaps.LatLng(lat, lng));
        });
      }

      if (this.map) {
        this.map.fitBounds(newBounds);
      }
    }

    /**
     * Extracts the geolocation and ID from a ServiceProvider.
     */

  }, {
    key: 'render',
    value: function render() {
      var googleMaps = this.props.googleMaps;
      var _state = this.state,
          center = _state.center,
          markers = _state.markers;
      // if no location is detected show US map

      return _react2.default.createElement(
        _reactGoogleMaps.GoogleMap,
        {
          zoom: center ? 12 : 4,
          center: center || { lat: 39.5, lng: -98.35 },
          ref: this.setMapRef
        },
        markers.map(function (_ref6, index) {
          var lat = _ref6.lat,
              lng = _ref6.lng,
              id = _ref6.id;
          return _react2.default.createElement(_reactGoogleMaps.Marker, {
            key: id,
            position: { lat: lat, lng: lng },
            label: id ? '' + (index + 1) : '',
            labelAnchor: new googleMaps.Point(lat, lng),
            icon: id ? {
              path: googleMaps.SymbolPath.CIRCLE,
              strokeColor: 'white',
              scale: 15,
              fillColor: 'red',
              fillOpacity: 0.7,
              strokeWeight: 0.5
            } : null
          });
        })
      );
    }
  }]);

  return ServiceRequestMap;
}(_react.Component);

ServiceRequestMap.propTypes = {
  serviceProviders: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    address: _propTypes2.default.shape({
      location: LatLonPropType
    })
  })).isRequired,
  currentLocation: LatLonPropType.isRequired,
  googleMaps: _propTypes2.default.shape().isRequired
};
exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('ServiceRequestMap'), (0, _recompose.withProps)({
  // props for withGoogleMap:
  containerElement: _react2.default.createElement('div', { style: { height: '100%' } }),
  mapElement: _react2.default.createElement('div', { style: { height: '100%' } })
}), _withGoogleMapJS2.default, _reactGoogleMaps.withGoogleMap)(ServiceRequestMap);

/***/ }),

/***/ "./components/ServiceRequestsPanel/ServiceRequestsListView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactImmutableProptypes = __webpack_require__("../node_modules/react-immutable-proptypes/dist/ImmutablePropTypes.js");

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _reactRouterDom = __webpack_require__("../node_modules/react-router-dom/es/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function buildServiceRequestList(serviceRequests) {
  return serviceRequests.map(function (s) {
    var serviceRequestId = s.get('id');
    return _react2.default.createElement(
      'li',
      { key: serviceRequestId },
      _react2.default.createElement(
        _reactRouterDom.Link,
        { to: '/serviceRequests/' + serviceRequestId },
        'Service Request ID: ' + serviceRequestId
      )
    );
  });
}

function ServiceRequestsListView(_ref) {
  var serviceRequests = _ref.serviceRequests;

  return _react2.default.createElement(
    'div',
    { style: { padding: '0.5rem' } },
    _react2.default.createElement(
      'h2',
      null,
      'TODO: Build List view'
    ),
    _react2.default.createElement(
      'ul',
      null,
      buildServiceRequestList(serviceRequests)
    )
  );
}

ServiceRequestsListView.propTypes = {
  serviceRequests: _reactImmutableProptypes2.default.listOf(_reactImmutableProptypes2.default.mapContains({
    id: _propTypes2.default.string
  })).isRequired
};

exports.default = ServiceRequestsListView;

/***/ }),

/***/ "./components/ServiceRequestsPanel/ServiceRequestsMapView.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactImmutableProptypes = __webpack_require__("../node_modules/react-immutable-proptypes/dist/ImmutablePropTypes.js");

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _reactRouterDom = __webpack_require__("../node_modules/react-router-dom/es/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function buildServiceRequestList(serviceRequests) {
  return serviceRequests.map(function (s) {
    var serviceRequestId = s.get('id');
    return _react2.default.createElement(
      'li',
      { key: serviceRequestId },
      _react2.default.createElement(
        _reactRouterDom.Link,
        { to: '/serviceRequests/' + serviceRequestId },
        'Service Request ID: ' + serviceRequestId
      )
    );
  });
}

function ServiceRequestsMapView(_ref) {
  var serviceRequests = _ref.serviceRequests;

  return _react2.default.createElement(
    'div',
    { style: { padding: '0.5rem' } },
    _react2.default.createElement(
      'h2',
      null,
      'TODO: Build MAP view'
    ),
    _react2.default.createElement(
      'ul',
      null,
      buildServiceRequestList(serviceRequests)
    )
  );
}

ServiceRequestsMapView.propTypes = {
  serviceRequests: _reactImmutableProptypes2.default.listOf(_reactImmutableProptypes2.default.mapContains({
    id: _propTypes2.default.string
  })).isRequired
};

exports.default = ServiceRequestsMapView;

/***/ }),

/***/ "./components/ServiceRequestsPanel/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactImmutableProptypes = __webpack_require__("../node_modules/react-immutable-proptypes/dist/ImmutablePropTypes.js");

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _ServiceRequestDisplayContainer = __webpack_require__("./containers/ServiceRequestDisplayContainer/index.js");

var _ServiceRequestDisplayContainer2 = _interopRequireDefault(_ServiceRequestDisplayContainer);

var _CategoryHeader = __webpack_require__("./components/CategoryHeader/index.js");

var _CategoryHeader2 = _interopRequireDefault(_CategoryHeader);

var _paginateFavorites = __webpack_require__("./components/_common/paginateFavorites/index.js");

var _paginateFavorites2 = _interopRequireDefault(_paginateFavorites);

var _CardView = __webpack_require__("./components/_common/CardView/index.js");

var _CardView2 = _interopRequireDefault(_CardView);

var _PageContentPanel = __webpack_require__("./elements/PageContentPanel/index.js");

var _PageContentPanel2 = _interopRequireDefault(_PageContentPanel);

var _ServiceRequestsListView = __webpack_require__("./components/ServiceRequestsPanel/ServiceRequestsListView.js");

var _ServiceRequestsListView2 = _interopRequireDefault(_ServiceRequestsListView);

var _ServiceRequestsMapView = __webpack_require__("./components/ServiceRequestsPanel/ServiceRequestsMapView.js");

var _ServiceRequestsMapView2 = _interopRequireDefault(_ServiceRequestsMapView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getServiceRequestsView(serviceRequestsView) {
  switch (serviceRequestsView) {
    case 'list':
      return _ServiceRequestsListView2.default;
    case 'map':
      return _ServiceRequestsMapView2.default;
    case 'card':
    default:
      return _CardView2.default;
  }
}

var ServiceRequestsPanel = function (_Component) {
  _inherits(ServiceRequestsPanel, _Component);

  function ServiceRequestsPanel() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ServiceRequestsPanel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ServiceRequestsPanel.__proto__ || Object.getPrototypeOf(ServiceRequestsPanel)).call.apply(_ref, [this].concat(args))), _this), _this.buildPaginatedServiceRequestsView = function (viewType) {
      // define the component that will be displayed with the super pagination powers.
      var ServiceRequestsView = getServiceRequestsView(viewType);

      // add methods concerning pagination
      var paginationMethods = {
        requestNext: _this.props.requestNext
      };

      return (0, _paginateFavorites2.default)(paginationMethods)(ServiceRequestsView);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ServiceRequestsPanel, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.PaginatedServiceRequestsView = this.buildPaginatedServiceRequestsView(this.props.serviceRequestsView);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // If the users has changed view types, a new HOC wrapped component must be made.
      if (this.props.serviceRequestsView !== nextProps.serviceRequestsView) {
        this.PaginatedServiceRequestsView = this.buildPaginatedServiceRequestsView(nextProps.serviceRequestsView);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          serviceRequests = _props.serviceRequests,
          serviceRequestsRequesting = _props.serviceRequestsRequesting,
          refreshServiceRequests = _props.refreshServiceRequests,
          favoritePagination = _props.favoritePagination,
          latestFavorite = _props.latestFavorite;
      var PaginatedServiceRequestsView = this.PaginatedServiceRequestsView;


      var componentProps = {
        serviceRequests: serviceRequests,
        dataList: serviceRequests,
        requesting: serviceRequestsRequesting,
        favoritePagination: favoritePagination,
        CardComp: _ServiceRequestDisplayContainer2.default
      };

      return _react2.default.createElement(
        _PageContentPanel2.default,
        { id: 'service-requests-panel' },
        _react2.default.createElement(_CategoryHeader2.default, {
          refresh: refreshServiceRequests,
          requesting: serviceRequestsRequesting,
          favoritePagination: favoritePagination,
          type: 'serviceRequest'
        }),
        _react2.default.createElement(PaginatedServiceRequestsView, {
          componentProps: componentProps,
          favoritePagination: favoritePagination,
          noFavoritesMessage: latestFavorite.message,
          requestInProgress: serviceRequestsRequesting
        })
      );
    }
  }]);

  return ServiceRequestsPanel;
}(_react.Component);

ServiceRequestsPanel.propTypes = {
  serviceRequests: _reactImmutableProptypes2.default.list.isRequired,
  serviceRequestsRequesting: _propTypes2.default.bool,
  serviceRequestsView: _propTypes2.default.string.isRequired,
  favoritePagination: _reactImmutableProptypes2.default.map.isRequired,
  latestFavorite: _propTypes2.default.shape({
    message: _propTypes2.default.string
  }),
  refreshServiceRequests: _propTypes2.default.func.isRequired,
  requestNext: _propTypes2.default.func.isRequired
};
ServiceRequestsPanel.defaultProps = {
  serviceRequestsRequesting: false,
  latestFavorite: {}
};
exports.default = ServiceRequestsPanel;

/***/ }),

/***/ "./components/SeverityLabel/SeverityIcon/SeverityIconValue.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.valueTextColor = valueTextColor;

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _constants = __webpack_require__("./components/SeverityLabel/constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function valueTextColor(_ref) {
  var theme = _ref.theme,
      backgroundColor = _ref.color;

  switch (backgroundColor) {
    case 'deepskyblue':
    case 'orange':
    case 'red':
    case 'grey':
    case 'green':
      return theme.colors.base.background;
    default:
      return theme.colors.base.text;
  }
}

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  color: ' + valueTextColor(props) + ';\n  font-size: ' + (props.small ? (0, _decisivUiUtils.px2rem)(10) : (0, _decisivUiUtils.px2rem)(12)) + ';\n  left: 50%;\n  position: absolute;\n  top: 50%;\n  transform: translate(-50%, -50%);\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      background: _propTypes2.default.string.isRequired,
      text: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

var propTypes = {
  color: _propTypes2.default.oneOf(_constants.SEVERITY_COLORS).isRequired,
  small: _propTypes2.default.bool
};

var defaultProps = {
  small: false
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('SeverityIconValue', _styledComponents2.default.div, styles, { defaultProps: defaultProps, propTypes: propTypes, themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/SeverityLabel/SeverityIcon/Wrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n'], ['\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n']);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SeverityIconWrapper = function () {
  var c = _styledComponents2.default.div(_templateObject);

  c.displayName = 'SeverityIconWrapper';
  return c;
}();

exports.default = SeverityIconWrapper;

/***/ }),

/***/ "./components/SeverityLabel/SeverityIcon/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStatusColor = getStatusColor;
exports.SeverityIcon = SeverityIcon;

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _IconWarning = __webpack_require__("./elements/IconWarning/index.js");

var _IconWarning2 = _interopRequireDefault(_IconWarning);

var _constants = __webpack_require__("./components/SeverityLabel/constants.js");

var _Wrapper = __webpack_require__("./components/SeverityLabel/SeverityIcon/Wrapper.js");

var _Wrapper2 = _interopRequireDefault(_Wrapper);

var _SeverityIconValue = __webpack_require__("./components/SeverityLabel/SeverityIcon/SeverityIconValue.js");

var _SeverityIconValue2 = _interopRequireDefault(_SeverityIconValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStatusColor(_ref) {
  var color = _ref.color,
      theme = _ref.theme;

  switch (color) {
    case 'deepskyblue':
      return theme.colors.status.info;
    case 'red':
      return theme.colors.status.danger;
    case 'orange':
    case 'yellow':
      return theme.colors.status.warning;
    case 'green':
      return theme.colors.status.success;
    case 'grey':
    default:
      return theme.colors.status.default;
  }
}

function SeverityIcon(_ref2) {
  var color = _ref2.color,
      value = _ref2.value,
      theme = _ref2.theme,
      small = _ref2.small;

  return _react2.default.createElement(
    _Wrapper2.default,
    null,
    _react2.default.createElement(_IconWarning2.default, { color: getStatusColor({ color: color, theme: theme }) }),
    _react2.default.createElement(
      _SeverityIconValue2.default,
      { color: color, small: small },
      (0, _lodash.isNaN)(value) ? 0 : value
    )
  );
}

SeverityIcon.propTypes = {
  color: _propTypes2.default.oneOf(_constants.SEVERITY_COLORS).isRequired,
  value: _propTypes2.default.number,
  theme: _propTypes2.default.shape({
    colors: _propTypes2.default.shape({
      status: _propTypes2.default.shape({
        danger: _propTypes2.default.string.isRequired,
        default: _propTypes2.default.string.isRequired,
        info: _propTypes2.default.string.isRequired,
        success: _propTypes2.default.string.isRequired,
        warning: _propTypes2.default.string.isRequired
      }).isRequired
    }).isRequired
  }).isRequired,
  small: _propTypes2.default.bool
};

SeverityIcon.defaultProps = {
  color: 'grey',
  small: false,
  value: null
};

exports.default = (0, _styledComponents.withTheme)(SeverityIcon);

/***/ }),

/***/ "./components/SeverityLabel/Wrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n  text-transform: uppercase;\n  display: inline-block;\n  align-items: center;\n  font-size: ', ';\n  height: ', ';\n  span {\n    padding-left: 0.5rem;\n  }\n'], ['\n  position: relative;\n  text-transform: uppercase;\n  display: inline-block;\n  align-items: center;\n  font-size: ', ';\n  height: ', ';\n  span {\n    padding-left: 0.5rem;\n  }\n']);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = function () {
  var c = _styledComponents2.default.div(_templateObject, function (props) {
    return props.small ? (0, _decisivUiUtils.px2rem)(13) : (0, _decisivUiUtils.px2rem)(props.fontSize);
  }, function (props) {
    return props.small ? (0, _decisivUiUtils.px2rem)(19) : 'auto';
  });

  c.displayName = 'Wrapper';
  return c;
}();

Wrapper.propTypes = {
  fontSize: _propTypes2.default.number,
  small: _propTypes2.default.bool
};

Wrapper.defaultProps = {
  fontSize: 14,
  small: false
};

exports.default = Wrapper;

/***/ }),

/***/ "./components/SeverityLabel/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable import/prefer-default-export */
var SEVERITY_COLORS = exports.SEVERITY_COLORS = ['grey', 'yellow', 'red', 'green', 'orange', 'deepskyblue', // TODO: determine if this color name should be shown in the UI?
'unknown'];

/***/ }),

/***/ "./components/SeverityLabel/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _constants = __webpack_require__("./components/SeverityLabel/constants.js");

var _Wrapper = __webpack_require__("./components/SeverityLabel/Wrapper.js");

var _Wrapper2 = _interopRequireDefault(_Wrapper);

var _SeverityIcon = __webpack_require__("./components/SeverityLabel/SeverityIcon/index.js");

var _SeverityIcon2 = _interopRequireDefault(_SeverityIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Presents a severity indicator based on a numeric severity
 * level (typically 0-3) and a color (red, orange, yellow, etc)
 */
function SeverityLabel(_ref) {
  var color = _ref.color,
      value = _ref.value,
      fontSize = _ref.fontSize,
      name = _ref.name,
      small = _ref.small;

  // per UI-215, a green/zero severity is "no" severity.
  if (color === 'green' && !value) {
    return _react2.default.createElement('div', null);
  }

  return _react2.default.createElement(
    _Wrapper2.default,
    { fontSize: fontSize, small: small },
    _react2.default.createElement(_SeverityIcon2.default, {
      color: color,
      value: value,
      small: small
    }),
    name && _react2.default.createElement(
      'span',
      null,
      name
    )
  );
}

SeverityLabel.propTypes = {
  color: _propTypes2.default.oneOf(_constants.SEVERITY_COLORS).isRequired,
  value: _propTypes2.default.number,
  fontSize: _propTypes2.default.number,
  name: _propTypes2.default.string,
  small: _propTypes2.default.bool
};

SeverityLabel.defaultProps = {
  color: 'grey',
  fontSize: 14,
  name: '',
  small: false,
  value: null
};

exports.default = SeverityLabel;

/***/ }),

/***/ "./components/StatusLabel/StatusCircle.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.backgroundColor = backgroundColor;

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function backgroundColor(_ref) {
  var color = _ref.color,
      theme = _ref.theme;

  switch (color) {
    case 'red':
      return theme.colors.status.danger;
    case 'yellow':
      return theme.colors.status.warning;
    case 'green':
    default:
      return theme.colors.status.success;
  }
}

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  background: ' + backgroundColor(props) + ';\n  border-radius: ' + (0, _decisivUiUtils.px2rem)(props.theme.dimensions.statusCircleRadius) + ';\n  display: inline-block;\n  height: ' + (0, _decisivUiUtils.px2rem)(props.theme.dimensions.statusCircleRadius * 2) + ';\n  vertical-align: middle;\n  width: ' + (0, _decisivUiUtils.px2rem)(props.theme.dimensions.statusCircleRadius * 2) + ';\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    status: _propTypes2.default.shape({
      danger: _propTypes2.default.string.isRequired,
      success: _propTypes2.default.string.isRequired,
      warning: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired,
  dimensions: _propTypes2.default.shape({
    statusCircleRadius: _propTypes2.default.number.isRequired
  }).isRequired
};

var propTypes = {
  color: _propTypes2.default.oneOf(['red', 'yellow', 'green', 'grey']).isRequired
};

var defaultProps = {
  color: 'green'
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('StatusCircle', _styledComponents2.default.div, styles, { defaultProps: defaultProps, propTypes: propTypes, themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/StatusLabel/StatusIcon.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iconName = iconName;

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactFontawesome = __webpack_require__("../node_modules/react-fontawesome/lib/index.js");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _StatusIconWrapper = __webpack_require__("./components/StatusLabel/StatusIconWrapper.js");

var _StatusIconWrapper2 = _interopRequireDefault(_StatusIconWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function iconName(color) {
  switch (color) {
    case 'red':
      return 'times';
    case 'yellow':
      return 'exclamation-circle';
    case 'grey':
      return 'minus';
    case 'green':
    default:
      return 'check';
  }
}

function StatusIcon(_ref) {
  var color = _ref.color;

  return _react2.default.createElement(
    _StatusIconWrapper2.default,
    { color: color },
    _react2.default.createElement(_reactFontawesome2.default, { name: iconName(color) })
  );
}

StatusIcon.propTypes = {
  color: _propTypes2.default.oneOf(['red', 'yellow', 'green', 'grey']).isRequired
};

StatusIcon.defaultProps = {
  color: 'green'
};

exports.default = StatusIcon;

/***/ }),

/***/ "./components/StatusLabel/StatusIconWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.statusColor = statusColor;

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function statusColor(_ref) {
  var color = _ref.color,
      theme = _ref.theme;

  switch (color) {
    case 'red':
      return theme.colors.status.danger;
    case 'yellow':
      return theme.colors.status.warning;
    case 'grey':
      return theme.colors.status.default;
    case 'green':
    default:
      return theme.colors.status.success;
  }
}

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  color: ' + statusColor(props) + ';\n  display: inline-block;\n  height: ' + (0, _decisivUiUtils.px2rem)(props.theme.dimensions.statusCircleRadius * 2) + ';\n  vertical-align: middle;\n  width: ' + (0, _decisivUiUtils.px2rem)(props.theme.dimensions.statusCircleRadius * 2) + ';\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    status: _propTypes2.default.shape({
      danger: _propTypes2.default.string.isRequired,
      default: _propTypes2.default.string.isRequired,
      success: _propTypes2.default.string.isRequired,
      warning: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired,
  dimensions: _propTypes2.default.shape({
    statusCircleRadius: _propTypes2.default.number.isRequired
  }).isRequired
};

var propTypes = {
  color: _propTypes2.default.oneOf(['red', 'yellow', 'green', 'grey']).isRequired
};

var defaultProps = {
  color: 'green'
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('StatusIconWrapper', _styledComponents2.default.div, styles, { defaultProps: defaultProps, propTypes: propTypes, themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/StatusLabel/StatusValue.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = function styles(props) {
  return '\n  vertical-align: middle;\n  text-transform: uppercase;\n  margin-left: ' + (0, _decisivUiUtils.px2rem)(11) + ';\n  font-size: ' + props.theme.dimensions.fontSizeNormal + ';\n';
};

var themePropTypes = {
  dimensions: _propTypes2.default.shape({
    fontSizeNormal: _propTypes2.default.string.isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('StatusValue', _styledComponents2.default.span, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/StatusLabel/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StatusLabel = StatusLabel;

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _Tooltip = __webpack_require__("./elements/Tooltip/index.js");

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _StatusCircle = __webpack_require__("./components/StatusLabel/StatusCircle.js");

var _StatusCircle2 = _interopRequireDefault(_StatusCircle);

var _StatusIcon = __webpack_require__("./components/StatusLabel/StatusIcon.js");

var _StatusIcon2 = _interopRequireDefault(_StatusIcon);

var _StatusValue = __webpack_require__("./components/StatusLabel/StatusValue.js");

var _StatusValue2 = _interopRequireDefault(_StatusValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_COLOR = 'green';

function StatusLabel(_ref) {
  var rawColor = _ref.color,
      label = _ref.label,
      showIcon = _ref.showIcon,
      tooltip = _ref.tooltip;

  var color = rawColor || DEFAULT_COLOR;
  var target = _react2.default.createElement(
    'div',
    null,
    showIcon ? _react2.default.createElement(_StatusIcon2.default, { color: color }) : _react2.default.createElement(_StatusCircle2.default, { color: color }),
    label && _react2.default.createElement(
      _StatusValue2.default,
      null,
      _react2.default.createElement(_linguiReact.Trans, { id: label })
    )
  );
  if (!tooltip) return target;
  return _react2.default.createElement(
    _Tooltip2.default,
    {
      position: 'top',
      message: function message() {
        return _react2.default.createElement(_linguiReact.Trans, { id: tooltip });
      }
    },
    target
  );
}

StatusLabel.propTypes = {
  color: _propTypes2.default.string,
  label: _propTypes2.default.string,
  showIcon: _propTypes2.default.bool,
  tooltip: _propTypes2.default.string
};

StatusLabel.defaultProps = {
  color: DEFAULT_COLOR,
  showIcon: false,
  tooltip: null,
  label: null
};

exports.default = StatusLabel;

/***/ }),

/***/ "./components/TabBar/NoTabsWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  border: 1px solid ' + props.theme.colors.base.chrome200 + ';\n  border-right: none;\n  font-style: italic;\n  line-height: ' + (0, _decisivUiUtils.px2rem)(34) + ';\n  padding-left: ' + (0, _decisivUiUtils.px2rem)(10) + ';\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome200: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('NoTabsWrapper', _styledComponents2.default.div, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/TabBar/OtherWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.borderLeft = borderLeft;

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function borderLeft(_ref) {
  var hasTab = _ref.hasTab;

  if (hasTab) {
    return '';
  }
  return '\n    border-left: none;\n  ';
}

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  align-items: center;\n  border: 1px solid ' + props.theme.colors.base.chrome200 + ';\n  ' + borderLeft(props) + '\n  display: flex;\n  flex: 1;\n  padding-left: ' + (0, _decisivUiUtils.px2rem)(7) + ';\n  padding-right: ' + (0, _decisivUiUtils.px2rem)(7) + ';\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome200: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

var propTypes = {
  hasTab: _propTypes2.default.bool
};

var defaultProps = {
  hasTab: true
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('OtherWrapper', _styledComponents2.default.div, styles, { defaultProps: defaultProps, propTypes: propTypes, themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/TabBar/TabBarOptionsWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  flex: 1;\n  justify-content: flex-end;\n'], ['\n  flex: 1;\n  justify-content: flex-end;\n']);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var TabBarOptionsWrapper = function () {
  var c = _styledComponents2.default.div(_templateObject);

  c.displayName = 'TabBarOptionsWrapper';
  return c;
}();

exports.default = TabBarOptionsWrapper;

/***/ }),

/***/ "./components/TabBar/TabWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.activeStyle = activeStyle;

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function activeStyle(_ref) {
  var active = _ref.active,
      theme = _ref.theme;

  if (active) {
    return '\n      background-color: ' + theme.colors.base.background + ';\n      font-weight: bold;\n    ';
  }
  return '\n    background-color: transparent;\n    border-bottom: 1px solid ' + theme.colors.base.chrome200 + ';\n  ';
}

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  ' + activeStyle(props) + '\n  align-items: center;\n  border-left: 1px solid ' + props.theme.colors.base.chrome200 + ';\n  border-top: 1px solid ' + props.theme.colors.base.chrome200 + ';\n  cursor: pointer;\n  display: flex;\n  flex: 1;\n  justify-content: center;\n  max-width: ' + props.theme.dimensions.tabWidth + ';\n\n  &:hover {\n    text-decoration: underline;\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      background: _propTypes2.default.string.isRequired,
      chrome200: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired,
  dimensions: _propTypes2.default.shape({
    tabWidth: _propTypes2.default.string.isRequired
  }).isRequired
};

var propTypes = {
  active: _propTypes2.default.bool
};

var defaultProps = {
  active: false
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('TabWrapper', _styledComponents2.default.div, styles, { defaultProps: defaultProps, propTypes: propTypes, themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/TabBar/Wrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  background-color: ' + props.theme.colors.base.chrome100 + ';\n  color: ' + props.theme.colors.base.textLight + ';\n  display: flex;\n  flex-grow: 1;\n  font-size: ' + (0, _decisivUiUtils.px2rem)(12) + ';\n  height: ' + (0, _decisivUiUtils.px2rem)(34) + ';\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome100: _propTypes2.default.string.isRequired,
      textLight: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Wrapper', _styledComponents2.default.section, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/TabBar/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabBarOptionsWrapper = undefined;

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Wrapper = __webpack_require__("./components/TabBar/Wrapper.js");

var _Wrapper2 = _interopRequireDefault(_Wrapper);

var _TabWrapper = __webpack_require__("./components/TabBar/TabWrapper.js");

var _TabWrapper2 = _interopRequireDefault(_TabWrapper);

var _OtherWrapper = __webpack_require__("./components/TabBar/OtherWrapper.js");

var _OtherWrapper2 = _interopRequireDefault(_OtherWrapper);

var _NoTabsWrapper = __webpack_require__("./components/TabBar/NoTabsWrapper.js");

var _NoTabsWrapper2 = _interopRequireDefault(_NoTabsWrapper);

var _TabBarOptionsWrapper2 = __webpack_require__("./components/TabBar/TabBarOptionsWrapper.js");

var _TabBarOptionsWrapper3 = _interopRequireDefault(_TabBarOptionsWrapper2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function buildTabs(params) {
  var tabs = params.tabs,
      emptyMessage = params.emptyMessage,
      currentTab = params.currentTab,
      onChangeTab = params.onChangeTab;

  if (tabs.length) {
    return tabs.map(function (tab, index) {
      return _react2.default.createElement(
        _TabWrapper2.default,
        {
          key: tab.name,
          active: currentTab === tab.name || index === 0 && !currentTab,
          onClick: function onClick() {
            return onChangeTab(tab.name);
          }
        },
        tab.label
      );
    });
  }
  return _react2.default.createElement(
    _NoTabsWrapper2.default,
    null,
    emptyMessage
  );
}

function TabBar(_ref) {
  var tabs = _ref.tabs,
      emptyMessage = _ref.emptyMessage,
      currentTab = _ref.currentTab,
      onChangeTab = _ref.onChangeTab,
      children = _ref.children;

  return _react2.default.createElement(
    _Wrapper2.default,
    null,
    buildTabs({ tabs: tabs, emptyMessage: emptyMessage, currentTab: currentTab, onChangeTab: onChangeTab }),
    _react2.default.createElement(
      _OtherWrapper2.default,
      { hasTab: tabs.length > 0 },
      children
    )
  );
}

TabBar.propTypes = {
  tabs: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    name: _propTypes2.default.string,
    label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])
  })),
  currentTab: _propTypes2.default.string,
  onChangeTab: _propTypes2.default.func.isRequired,
  children: _propTypes2.default.node,
  emptyMessage: _propTypes2.default.node
};

TabBar.defaultProps = {
  tabs: [],
  currentTab: '',
  children: null,
  emptyMessage: null
};

exports.default = TabBar;
exports.TabBarOptionsWrapper = _TabBarOptionsWrapper3.default;

/***/ }),

/***/ "./components/TopNav/AddNew/AddNewMenuItem.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  font-size: ', ';\n  list-style-type: none;\n  padding: ', ';\n'], ['\n  font-size: ', ';\n  list-style-type: none;\n  padding: ', ';\n']);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var AddNewMenuItem = function () {
  var c = _styledComponents2.default.li(_templateObject, (0, _decisivUiUtils.px2rem)(12), (0, _decisivUiUtils.px2rem)(8));

  c.displayName = 'AddNewMenuItem';
  return c;
}();

exports.default = AddNewMenuItem;

/***/ }),

/***/ "./components/TopNav/AddNew/AddNewMenuList.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddNewMenuList = AddNewMenuList;

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = __webpack_require__("../node_modules/react-router-dom/es/index.js");

var _Link = __webpack_require__("./elements/Link/index.js");

var _Link2 = _interopRequireDefault(_Link);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _AddNewMenuListWrapper = __webpack_require__("./components/TopNav/AddNew/AddNewMenuListWrapper.js");

var _AddNewMenuListWrapper2 = _interopRequireDefault(_AddNewMenuListWrapper);

var _AddNewMenuItem = __webpack_require__("./components/TopNav/AddNew/AddNewMenuItem.js");

var _AddNewMenuItem2 = _interopRequireDefault(_AddNewMenuItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AddNewMenuList(_ref) {
  var location = _ref.location,
      menuItems = _ref.menuItems,
      hidePopover = _ref.hidePopover;

  return _react2.default.createElement(
    _AddNewMenuListWrapper2.default,
    null,
    menuItems.map(function (menuItem) {
      return _react2.default.createElement(
        _AddNewMenuItem2.default,
        {
          key: menuItem.id,
          onClick: hidePopover
        },
        _react2.default.createElement(
          _Link2.default,
          {
            to: {
              pathname: menuItem.href,
              state: { previousPage: location.pathname }
            },
            modifiers: ['textColor']
          },
          _react2.default.createElement(_linguiReact.Trans, { id: menuItem.label })
        )
      );
    })
  );
}

AddNewMenuList.propTypes = {
  // This prop is added by Popover component's getContent() method
  hidePopover: _propTypes2.default.func,

  menuItems: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired,
    href: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.string.isRequired
  })).isRequired,

  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string.isRequired
  }).isRequired
};

AddNewMenuList.defaultProps = {
  hidePopover: _lodash.noop
};

exports.default = (0, _reactRouterDom.withRouter)(AddNewMenuList);

/***/ }),

/***/ "./components/TopNav/AddNew/AddNewMenuListWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  margin: 0;\n  min-width: ', ';\n  padding: 0;\n'], ['\n  margin: 0;\n  min-width: ', ';\n  padding: 0;\n']);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var AddNewMenuList = function () {
  var c = _styledComponents2.default.ul(_templateObject, (0, _decisivUiUtils.px2rem)(198));

  c.displayName = 'AddNewMenuList';
  return c;
}();

exports.default = AddNewMenuList;

/***/ }),

/***/ "./components/TopNav/AddNew/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ADD_NEW_MENU_ITEMS = undefined;

var _messages = __webpack_require__("./components/TopNav/AddNew/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line import/prefer-default-export
var ADD_NEW_MENU_ITEMS = exports.ADD_NEW_MENU_ITEMS = [{
  id: 'createNewServiceRequest',
  label: _messages2.default.createNewServiceRequest,
  href: '/service-requests/new'
}];

/***/ }),

/***/ "./components/TopNav/AddNew/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactFontawesome = __webpack_require__("../node_modules/react-fontawesome/lib/index.js");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _baseComponents = __webpack_require__("../node_modules/base-components/build/index.js");

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _Popover = __webpack_require__("./elements/Popover/index.js");

var _Popover2 = _interopRequireDefault(_Popover);

var _AddNewMenuList = __webpack_require__("./components/TopNav/AddNew/AddNewMenuList.js");

var _AddNewMenuList2 = _interopRequireDefault(_AddNewMenuList);

var _constants = __webpack_require__("./components/TopNav/AddNew/constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddNew = function (_Component) {
  _inherits(AddNew, _Component);

  function AddNew() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AddNew);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AddNew.__proto__ || Object.getPrototypeOf(AddNew)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      popoverVisible: false
    }, _this.handlePopoverHide = function () {
      _this.setState({ popoverVisible: false });
    }, _this.togglePopoverVisibility = function () {
      _this.setState(function (prevState) {
        return { popoverVisible: !prevState.popoverVisible };
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AddNew, [{
    key: 'render',
    value: function render() {
      var buttonActive = this.state.popoverVisible && 'active';

      return _react2.default.createElement(
        _Popover2.default,
        {
          position: 'bottom',
          onHide: this.handlePopoverHide
        },
        _react2.default.createElement(
          _Popover.PopoverTarget,
          null,
          _react2.default.createElement(
            _baseComponents.ButtonIconCircle,
            {
              modifiers: (0, _lodash.compact)([buttonActive]),
              onClick: this.togglePopoverVisibility
            },
            _react2.default.createElement(_reactFontawesome2.default, { name: 'plus', style: { lineHeight: (0, _decisivUiUtils.px2rem)(31) } })
          )
        ),
        _react2.default.createElement(
          _Popover.PopoverContent,
          null,
          _react2.default.createElement(_AddNewMenuList2.default, { menuItems: _constants.ADD_NEW_MENU_ITEMS })
        )
      );
    }
  }]);

  return AddNew;
}(_react.Component);

exports.default = AddNew;

/***/ }),

/***/ "./components/TopNav/AddNew/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  createNewServiceRequest: (0, _linguiReact.i18nMark)('Create New Service Request')
};

exports.default = messages;

/***/ }),

/***/ "./components/TopNav/Controls/Wrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Controls section (right side)
/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  display: block;\n  height: 100%;\n  margin-left: auto;\n  > div {\n    display: inline-block;\n    vertical-align: middle;\n    margin-left: ' + props.theme.dimensions.spacingNormal + ';\n  }\n  > button {\n    margin-left: ' + props.theme.dimensions.spacingNormal + ';\n  }\n';
};

var themePropTypes = {
  dimensions: _propTypes2.default.shape({
    spacingNormal: _propTypes2.default.string.isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('ControlsWrapper', _styledComponents2.default.div, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/TopNav/Controls/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _SearchContainer = __webpack_require__("./containers/SearchContainer/index.js");

var _SearchContainer2 = _interopRequireDefault(_SearchContainer);

var _VerticalDivider = __webpack_require__("./elements/VerticalDivider/index.js");

var _VerticalDivider2 = _interopRequireDefault(_VerticalDivider);

var _Wrapper = __webpack_require__("./components/TopNav/Controls/Wrapper.js");

var _Wrapper2 = _interopRequireDefault(_Wrapper);

var _AddNew = __webpack_require__("./components/TopNav/AddNew/index.js");

var _AddNew2 = _interopRequireDefault(_AddNew);

var _UserProfile = __webpack_require__("./components/TopNav/UserProfile/index.js");

var _UserProfile2 = _interopRequireDefault(_UserProfile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Controls() {
  return _react2.default.createElement(
    _Wrapper2.default,
    null,
    _react2.default.createElement(_SearchContainer2.default, null),
    _react2.default.createElement(_AddNew2.default, null),
    _react2.default.createElement(_VerticalDivider2.default, null),
    _react2.default.createElement(_UserProfile2.default, null)
  );
}

exports.default = Controls;

/***/ }),

/***/ "./components/TopNav/UserProfile/UserInfo/GhostUserAvatar.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _GhostIndicator = __webpack_require__("./components/_common/GhostIndicator/index.js");

var _GhostIndicator2 = _interopRequireDefault(_GhostIndicator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AVATAR_SIZE_PX = 34;

var styles = function styles(props) {
  return '\n  border-radius: ' + (0, _decisivUiUtils.px2rem)(AVATAR_SIZE_PX / 2) + ';\n  width: ' + (0, _decisivUiUtils.px2rem)(AVATAR_SIZE_PX) + ';\n  height: ' + (0, _decisivUiUtils.px2rem)(AVATAR_SIZE_PX) + ';\n  margin: 0 ' + props.theme.dimensions.spacingNormal + ' 0 0;\n  vertical-align: middle;\n';
};

var themePropTypes = {
  dimensions: _propTypes2.default.shape({
    spacingNormal: _propTypes2.default.string.isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('GhostUserAvatar', (0, _styledComponents2.default)(_GhostIndicator2.default), styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/TopNav/UserProfile/UserInfo/GhostUserInfo.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: ', ';\n  height: ', ';\n'], ['\n  width: ', ';\n  height: ', ';\n']);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _GhostIndicator = __webpack_require__("./components/_common/GhostIndicator/index.js");

var _GhostIndicator2 = _interopRequireDefault(_GhostIndicator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var GhostUserInfo = function () {
  var c = (0, _styledComponents2.default)(_GhostIndicator2.default)(_templateObject, (0, _decisivUiUtils.px2rem)(75), (0, _decisivUiUtils.px2rem)(17));
  c.displayName = 'GhostUserInfo';
  return c;
}();

exports.default = GhostUserInfo;

/***/ }),

/***/ "./components/TopNav/UserProfile/UserInfo/UserAvatar.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _Gravatar = __webpack_require__("./elements/Gravatar/index.js");

var _Gravatar2 = _interopRequireDefault(_Gravatar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AVATAR_SIZE_PX = 34;

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  img {\n    border-radius: ' + (0, _decisivUiUtils.px2rem)(AVATAR_SIZE_PX / 2) + ';\n    width: ' + (0, _decisivUiUtils.px2rem)(AVATAR_SIZE_PX) + ';\n    height: ' + (0, _decisivUiUtils.px2rem)(AVATAR_SIZE_PX) + ';\n    margin-right: ' + props.theme.dimensions.spacingNormal + ';\n    vertical-align: middle;\n  }\n';
};

var themePropTypes = {
  dimensions: _propTypes2.default.shape({
    spacingNormal: _propTypes2.default.string.isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('UserAvatar', (0, _styledComponents2.default)(_Gravatar2.default), styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/TopNav/UserProfile/UserInfo/UserInfoLabel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  display: block;\n  font-size: ' + props.theme.dimensions.fontSizeNormal + ';\n  font-weight: ' + (props.bold ? '500' : '300') + ';\n  line-height: ' + (0, _decisivUiUtils.px2rem)(17) + ';\n';
};

var themePropTypes = {
  dimensions: _propTypes2.default.shape({
    fontSizeNormal: _propTypes2.default.string.isRequired
  }).isRequired
};

var propTypes = {
  bold: _propTypes2.default.bool
};

var defaultProps = {
  bold: false
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('UserInfoLabel', _styledComponents2.default.span, styles, { defaultProps: defaultProps, propTypes: propTypes, themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/TopNav/UserProfile/UserInfo/UserInfoLabelWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  margin-right: 8px;\n'], ['\n  margin-right: 8px;\n']);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var UserInfoLabelWrapper = function () {
  var c = _styledComponents2.default.div(_templateObject);

  c.displayName = 'UserInfoLabelWrapper';
  return c;
}();

exports.default = UserInfoLabelWrapper;

/***/ }),

/***/ "./components/TopNav/UserProfile/UserInfo/Wrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrapperColor = wrapperColor;

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function wrapperColor(_ref) {
  var theme = _ref.theme,
      expanded = _ref.expanded;

  if (expanded) {
    return theme.colors.base.linkHover;
  }

  return theme.colors.base.chrome500;
}

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  color: ' + wrapperColor(props) + ';\n\n  .fa-caret-down {\n    font-size: ' + props.theme.dimensions.fontSizeMedium + ';\n  }\n\n  &:hover {\n    color: ' + props.theme.colors.base.linkHover + ';\n\n    span:not(.fa) {\n      text-decoration: underline;\n    }\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome500: _propTypes2.default.string.isRequired,
      linkHover: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired,
  dimensions: _propTypes2.default.shape({
    fontSizeMedium: _propTypes2.default.string.isRequired
  }).isRequired
};

var propTypes = {
  expanded: _propTypes2.default.bool
};

var defaultProps = {
  expanded: false
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('UserInfoWrapper', _styledComponents2.default.div, styles, { defaultProps: defaultProps, propTypes: propTypes, themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/TopNav/UserProfile/UserInfo/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactImmutableProptypes = __webpack_require__("../node_modules/react-immutable-proptypes/dist/ImmutablePropTypes.js");

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _immutable = __webpack_require__("../node_modules/immutable/dist/immutable.js");

var _reactFontawesome = __webpack_require__("../node_modules/react-fontawesome/lib/index.js");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _Wrapper = __webpack_require__("./components/TopNav/UserProfile/UserInfo/Wrapper.js");

var _Wrapper2 = _interopRequireDefault(_Wrapper);

var _UserAvatar = __webpack_require__("./components/TopNav/UserProfile/UserInfo/UserAvatar.js");

var _UserAvatar2 = _interopRequireDefault(_UserAvatar);

var _UserInfoLabelWrapper = __webpack_require__("./components/TopNav/UserProfile/UserInfo/UserInfoLabelWrapper.js");

var _UserInfoLabelWrapper2 = _interopRequireDefault(_UserInfoLabelWrapper);

var _UserInfoLabel = __webpack_require__("./components/TopNav/UserProfile/UserInfo/UserInfoLabel.js");

var _UserInfoLabel2 = _interopRequireDefault(_UserInfoLabel);

var _GhostUserAvatar = __webpack_require__("./components/TopNav/UserProfile/UserInfo/GhostUserAvatar.js");

var _GhostUserAvatar2 = _interopRequireDefault(_GhostUserAvatar);

var _GhostUserInfo = __webpack_require__("./components/TopNav/UserProfile/UserInfo/GhostUserInfo.js");

var _GhostUserInfo2 = _interopRequireDefault(_GhostUserInfo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function UserInfo(_ref) {
  var userProfile = _ref.userProfile,
      expanded = _ref.expanded;

  var fullName = (0, _lodash.filter)([userProfile.get('firstName'), userProfile.get('lastName')]).join(' ');
  var title = userProfile.get('jobTitle') || userProfile.get('companyName');
  var email = userProfile.get('email');

  return _react2.default.createElement(
    _Wrapper2.default,
    { expanded: expanded },
    email ? _react2.default.createElement(_UserAvatar2.default, { email: email }) : _react2.default.createElement(_GhostUserAvatar2.default, null),
    fullName || title ? _react2.default.createElement(
      _UserInfoLabelWrapper2.default,
      null,
      _react2.default.createElement(
        _UserInfoLabel2.default,
        { className: 'user-full-name' },
        fullName
      ),
      _react2.default.createElement(
        _UserInfoLabel2.default,
        { bold: true, className: 'user-title' },
        title
      )
    ) : _react2.default.createElement(
      _UserInfoLabelWrapper2.default,
      null,
      _react2.default.createElement(_GhostUserInfo2.default, null)
    ),
    _react2.default.createElement(_reactFontawesome2.default, { name: 'caret-down' })
  );
}

UserInfo.propTypes = {
  expanded: _propTypes2.default.bool.isRequired,
  userProfile: _reactImmutableProptypes2.default.contains({
    firstName: _propTypes2.default.string,
    lastName: _propTypes2.default.string,
    jobTitle: _propTypes2.default.string,
    companyName: _propTypes2.default.string,
    email: _propTypes2.default.string
  }).isRequired
};

UserInfo.defaultProps = {
  expanded: false,
  userProfile: (0, _immutable.Map)()
};

exports.default = UserInfo;

/***/ }),

/***/ "./components/TopNav/UserProfile/UserPopupWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  background: #fff;\n  box-shadow: 0 ' + (0, _decisivUiUtils.px2rem)(3) + ' ' + (0, _decisivUiUtils.px2rem)(7) + ' 0 ' + props.theme.colors.base.shadow + ';\n  box-sizing: border-box;\n  cursor: auto;\n  height: auto;\n  margin: ' + (0, _decisivUiUtils.px2rem)(10) + ';\n  overflow: hidden;\n  padding: ' + (0, _decisivUiUtils.px2rem)(10) + ';\n  text-align: right;\n  width: ' + (0, _decisivUiUtils.px2rem)(215) + ';\n\n  .menu-item {\n    a {\n      text-decoration: none;\n      &:hover {\n        text-decoration: underline;\n      }\n    }\n    span {\n      color: ' + props.theme.colors.base.textLight + ';\n      font-size: ' + props.theme.dimensions.fontSizeNormal + ';\n    }\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      shadow: _propTypes2.default.string.isRequired,
      textLight: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired,
  dimensions: _propTypes2.default.shape({
    fontSizeNormal: _propTypes2.default.string.isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('UserPopupWrapper', _styledComponents2.default.div, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/TopNav/UserProfile/Wrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = '\n  cursor: pointer;\n  div {\n    display: inline-block;\n    vertical-align: middle;\n  }\n';

exports.default = (0, _decisivUiUtils.buildStyledComponent)('UserProfileWrapper', _styledComponents2.default.div, styles);

/***/ }),

/***/ "./components/TopNav/UserProfile/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__("../node_modules/react-router-dom/es/index.js");

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _UserInfoContainer = __webpack_require__("./containers/UserInfoContainer/index.js");

var _UserInfoContainer2 = _interopRequireDefault(_UserInfoContainer);

var _PopupMenu = __webpack_require__("./components/PopupMenu/index.js");

var _PopupMenu2 = _interopRequireDefault(_PopupMenu);

var _MenuItem = __webpack_require__("./components/PopupMenu/MenuItem.js");

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _MenuItemDivider = __webpack_require__("./components/PopupMenu/MenuItemDivider.js");

var _MenuItemDivider2 = _interopRequireDefault(_MenuItemDivider);

var _AbsoluteSmoothCollapse = __webpack_require__("./components/AbsoluteSmoothCollapse/index.js");

var _AbsoluteSmoothCollapse2 = _interopRequireDefault(_AbsoluteSmoothCollapse);

var _Wrapper = __webpack_require__("./components/TopNav/UserProfile/Wrapper.js");

var _Wrapper2 = _interopRequireDefault(_Wrapper);

var _UserInfo = __webpack_require__("./components/TopNav/UserProfile/UserInfo/index.js");

var _UserInfo2 = _interopRequireDefault(_UserInfo);

var _UserPopupWrapper = __webpack_require__("./components/TopNav/UserProfile/UserPopupWrapper.js");

var _UserPopupWrapper2 = _interopRequireDefault(_UserPopupWrapper);

var _messages = __webpack_require__("./components/TopNav/UserProfile/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserProfile = function (_React$Component) {
  _inherits(UserProfile, _React$Component);

  function UserProfile() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, UserProfile);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UserProfile.__proto__ || Object.getPrototypeOf(UserProfile)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      expanded: false
    }, _this.handleClick = function () {
      _this.setState(function (prevState) {
        return { expanded: !prevState.expanded };
      });
    }, _this.hidePopupMenu = function () {
      if (_this.state.expanded) {
        _this.setState({ expanded: false });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(UserProfile, [{
    key: 'render',
    value: function render() {
      var expanded = this.state.expanded;

      return _react2.default.createElement(
        _Wrapper2.default,
        { id: 'topnav-user-profile', onClick: this.handleClick },
        _react2.default.createElement(_UserInfoContainer2.default, { around: _UserInfo2.default, expanded: expanded }),
        _react2.default.createElement(
          _AbsoluteSmoothCollapse2.default,
          {
            expanded: expanded,
            heightTransition: '.15s cubic-bezier(0, 1, 0.5, 1)',
            top: (0, _decisivUiUtils.px2rem)(70),
            right: '0'
          },
          _react2.default.createElement(
            _PopupMenu2.default,
            { onOutsideClick: this.hidePopupMenu },
            _react2.default.createElement(
              _UserPopupWrapper2.default,
              null,
              _react2.default.createElement(_MenuItemDivider2.default, null),
              _react2.default.createElement(
                _MenuItem2.default,
                null,
                _react2.default.createElement(
                  _reactRouterDom.Link,
                  { to: '/logout', id: 'topnav-user-profile-logout' },
                  _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.logout })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return UserProfile;
}(_react2.default.Component);

exports.default = UserProfile;

/***/ }),

/***/ "./components/TopNav/UserProfile/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  logout: (0, _linguiReact.i18nMark)('Log Out')
};

exports.default = messages;

/***/ }),

/***/ "./components/TopNav/Wrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  align-items: center;\n  background-color: ' + props.theme.colors.base.background + ';\n  box-sizing: border-box;\n  display: flex;\n  height: ' + props.theme.dimensions.topNavHeight + ';\n  justify-content: space-between;\n  overflow: visible;\n  padding: ' + (0, _decisivUiUtils.px2rem)(22) + ' ' + (0, _decisivUiUtils.px2rem)(20) + ';\n  position: relative;\n  z-index: 10;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      background: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired,
  dimensions: _propTypes2.default.shape({
    topNavHeight: _propTypes2.default.string.isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('TopNavWrapper', _styledComponents2.default.div, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/TopNav/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _LoadingBar = __webpack_require__("./compositions/LoadingBar/index.js");

var _LoadingBar2 = _interopRequireDefault(_LoadingBar);

var _Logo = __webpack_require__("./compositions/Logo/index.js");

var _Logo2 = _interopRequireDefault(_Logo);

var _Controls = __webpack_require__("./components/TopNav/Controls/index.js");

var _Controls2 = _interopRequireDefault(_Controls);

var _Wrapper = __webpack_require__("./components/TopNav/Wrapper.js");

var _Wrapper2 = _interopRequireDefault(_Wrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TopNav() {
  return _react2.default.createElement(
    _Wrapper2.default,
    { id: 'top-nav' },
    _react2.default.createElement(_Logo2.default, null),
    _react2.default.createElement(_Controls2.default, null),
    _react2.default.createElement(_LoadingBar2.default, null)
  );
}

exports.default = TopNav;

/***/ }),

/***/ "./components/TypeSelect/Circle.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var modifierConfig = {
  hovered: function hovered(_ref) {
    var theme = _ref.theme;
    return {
      styles: '\n      border-color: ' + theme.colors.base.chrome600 + ';\n    '
    };
  }
};

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  align-items: center;\n  background-color: ' + props.theme.colors.base.background + ';\n  border: 1px solid ' + props.theme.colors.base.chrome400 + ';\n  border-radius: ' + (0, _decisivUiUtils.px2rem)(25) + ';\n  display: flex;\n  height: ' + (0, _decisivUiUtils.px2rem)(25) + ';\n  margin: ' + (0, _decisivUiUtils.px2rem)(0) + ' ' + (0, _decisivUiUtils.px2rem)(10) + ';\n  width: ' + (0, _decisivUiUtils.px2rem)(25) + ';\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      background: _propTypes2.default.string.isRequired,
      chrome400: _propTypes2.default.string.isRequired,
      chrome600: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Circle', _styledComponents2.default.div, styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/TypeSelect/InputIcon.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  align-items: center;\n  display: flex;\n  position: absolute;\n  top: ' + (0, _decisivUiUtils.px2rem)(4) + ';\n  right: ' + (0, _decisivUiUtils.px2rem)(4) + ';\n\n  span {\n    font-size: ' + (0, _decisivUiUtils.px2rem)(10) + ';\n    color: ' + props.theme.colors.base.textLight + ';\n  }\n\n  .fa-keyboard-o {\n    color: ' + props.theme.colors.base.chrome500 + ';\n    font-size: ' + (0, _decisivUiUtils.px2rem)(12) + ';\n    margin-right: ' + (0, _decisivUiUtils.px2rem)(4) + ';\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome500: _propTypes2.default.string.isRequired,
      textLight: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('InputIcon', _styledComponents2.default.div, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/TypeSelect/SmallCircle.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  background-color: ' + props.theme.colors.status.info + ';\n  border-radius: ' + (0, _decisivUiUtils.px2rem)(11) + ';\n  height: ' + (0, _decisivUiUtils.px2rem)(11) + ';\n  margin: auto;\n  width: ' + (0, _decisivUiUtils.px2rem)(11) + ';\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    status: _propTypes2.default.shape({
      info: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('SmallCircle', _styledComponents2.default.div, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/TypeSelect/TypeName.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  color: ' + props.theme.colors.base.textLight + ';\n  font-size: ' + (0, _decisivUiUtils.px2rem)(12) + ';\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      textLight: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('TypeName', _styledComponents2.default.div, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/TypeSelect/Wrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var modifierConfig = {
  selected: function selected(_ref) {
    var theme = _ref.theme;
    return {
      styles: '\n      border-color: ' + theme.colors.base.chrome600 + ';\n    '
    };
  }
};

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  align-items: center;\n  background-color: ' + props.theme.colors.base.background + ';\n  border: 1px solid ' + props.theme.colors.base.chrome400 + ';\n  cursor: pointer;\n  display: flex;\n  height: ' + (0, _decisivUiUtils.px2rem)(45) + ';\n  margin-right: ' + (0, _decisivUiUtils.px2rem)(10) + ';\n  position: relative;\n  width: ' + (0, _decisivUiUtils.px2rem)(230) + ';\n  &: hover {\n    border-color: ' + props.theme.colors.base.chrome600 + ';\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      background: _propTypes2.default.string.isRequired,
      chrome400: _propTypes2.default.string.isRequired,
      chrome600: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Wrapper', _styledComponents2.default.div, styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/TypeSelect/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactFontawesome = __webpack_require__("../node_modules/react-fontawesome/lib/index.js");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _Circle = __webpack_require__("./components/TypeSelect/Circle.js");

var _Circle2 = _interopRequireDefault(_Circle);

var _InputIcon = __webpack_require__("./components/TypeSelect/InputIcon.js");

var _InputIcon2 = _interopRequireDefault(_InputIcon);

var _SmallCircle = __webpack_require__("./components/TypeSelect/SmallCircle.js");

var _SmallCircle2 = _interopRequireDefault(_SmallCircle);

var _TypeName = __webpack_require__("./components/TypeSelect/TypeName.js");

var _TypeName2 = _interopRequireDefault(_TypeName);

var _Wrapper = __webpack_require__("./components/TypeSelect/Wrapper.js");

var _Wrapper2 = _interopRequireDefault(_Wrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TypeSelect = function (_Component) {
  _inherits(TypeSelect, _Component);

  function TypeSelect() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TypeSelect);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TypeSelect.__proto__ || Object.getPrototypeOf(TypeSelect)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isHovered: false
    }, _this.onMouseEnter = function () {
      _this.setState({ isHovered: true });
    }, _this.onMouseLeave = function () {
      _this.setState({ isHovered: false });
    }, _this.keydownEventHandler = function (_ref2) {
      var key = _ref2.key;
      var _this$props = _this.props,
          selectKey = _this$props.selectKey,
          onSelect = _this$props.onSelect;


      if (key === selectKey) {
        onSelect();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TypeSelect, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('keydown', this.keydownEventHandler);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('keydown', this.keydownEventHandler);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          onSelect = _props.onSelect,
          isSelected = _props.isSelected,
          selectKey = _props.selectKey,
          typeName = _props.typeName;
      var isHovered = this.state.isHovered;


      return _react2.default.createElement(
        _Wrapper2.default,
        {
          modifiers: (0, _lodash.compact)([isSelected && 'selected']),
          onClick: onSelect,
          onMouseEnter: this.onMouseEnter,
          onMouseLeave: this.onMouseLeave
        },
        _react2.default.createElement(
          _Circle2.default,
          { modifiers: (0, _lodash.compact)([!isSelected && isHovered && 'hovered']) },
          isSelected && _react2.default.createElement(_SmallCircle2.default, null)
        ),
        _react2.default.createElement(
          _TypeName2.default,
          null,
          typeName
        ),
        _react2.default.createElement(
          _InputIcon2.default,
          null,
          _react2.default.createElement(_reactFontawesome2.default, { name: 'keyboard-o' }),
          _react2.default.createElement(
            'span',
            null,
            selectKey
          )
        )
      );
    }
  }]);

  return TypeSelect;
}(_react.Component);

TypeSelect.propTypes = {
  selectKey: _propTypes2.default.string.isRequired,
  isSelected: _propTypes2.default.bool,
  onSelect: _propTypes2.default.func.isRequired,
  typeName: _propTypes2.default.node.isRequired
};

TypeSelect.defaultProps = {
  isSelected: false
};

exports.default = TypeSelect;

/***/ }),

/***/ "./components/UnreadNoteLabel/UnreadNotesIcon.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnstyledFontAwesome = UnstyledFontAwesome;

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactFontawesome = __webpack_require__("../node_modules/react-fontawesome/lib/index.js");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function UnstyledFontAwesome(props) {
  var componentProps = (0, _lodash.omit)(props, ['theme', 'modifiers']);
  return _react2.default.createElement(_reactFontawesome2.default, componentProps);
}

/* istanbul ignore next */
var modifierConfig = {
  loud: function loud(_ref) {
    var theme = _ref.theme;
    return {
      styles: '\n      color: ' + theme.colors.status.info + ' !important;\n    '
    };
  }
};

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  color: ' + props.theme.colors.base.textLight + ';\n  font-size: ' + (0, _decisivUiUtils.px2rem)(16) + ';\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      textLight: _propTypes2.default.string.isRequired
    }).isRequired,
    status: _propTypes2.default.shape({
      info: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('UnreadNotesIcon', (0, _styledComponents2.default)(UnstyledFontAwesome), styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/UnreadNoteLabel/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnreadNotesLabel = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/styled-components-reactive-grid/dist/index.js");

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _ModalWindow = __webpack_require__("./components/ModalWindow/index.js");

var _ModalWindow2 = _interopRequireDefault(_ModalWindow);

var _NotesWidget = __webpack_require__("./compositions/NotesWidget/index.js");

var _baseComponents = __webpack_require__("../node_modules/base-components/build/index.js");

var _TextDiv = __webpack_require__("./elements/TextDiv/index.js");

var _TextDiv2 = _interopRequireDefault(_TextDiv);

var _messages = __webpack_require__("./components/UnreadNoteLabel/messages.js");

var _messages2 = _interopRequireDefault(_messages);

var _UnreadNotesIcon = __webpack_require__("./components/UnreadNoteLabel/UnreadNotesIcon.js");

var _UnreadNotesIcon2 = _interopRequireDefault(_UnreadNotesIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getIcon(count) {
  return count ? 'envelope' : 'envelope-o';
}

var UnreadNotesLabel = exports.UnreadNotesLabel = function (_Component) {
  _inherits(UnreadNotesLabel, _Component);

  function UnreadNotesLabel() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, UnreadNotesLabel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UnreadNotesLabel.__proto__ || Object.getPrototypeOf(UnreadNotesLabel)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      showCaseNotesModal: false
    }, _this.handleClickLabel = function (event) {
      event.preventDefault();
      event.stopPropagation();

      var _this$props = _this.props,
          hasModal = _this$props.hasModal,
          onClickAction = _this$props.onClickAction;


      return hasModal ? _this.handleToggleNotesModal() : onClickAction();
    }, _this.handleToggleNotesModal = function () {
      _this.setState({
        showCaseNotesModal: !_this.state.showCaseNotesModal
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(UnreadNotesLabel, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          caseInfo = _props.caseInfo,
          hideIcon = _props.hideIcon,
          i18n = _props.i18n;
      var showCaseNotesModal = this.state.showCaseNotesModal;
      var unreadNotesCount = caseInfo.unreadNotesCount;

      var iconModifier = unreadNotesCount > 0 && 'loud';

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _baseComponents.A,
          {
            'aria-label': i18n._(_messages2.default.unreadNotes),
            href: '',
            onClick: this.handleClickLabel
          },
          _react2.default.createElement(
            _styledComponentsReactiveGrid.Row,
            { modifiers: ['middle'] },
            !hideIcon && _react2.default.createElement(
              _styledComponentsReactiveGrid.Column,
              null,
              _react2.default.createElement(_UnreadNotesIcon2.default, {
                modifiers: (0, _lodash.compact)([iconModifier]),
                name: getIcon(unreadNotesCount)
              })
            ),
            _react2.default.createElement(
              _styledComponentsReactiveGrid.Column,
              { modifiers: (0, _lodash.compact)([hideIcon && 'fluid']) },
              _react2.default.createElement(
                _TextDiv2.default,
                { modifiers: ['smallText', 'statusInfo'] },
                _react2.default.createElement(_linguiReact.Trans, {
                  id: _messages2.default.unreadCount,
                  values: { count: String(unreadNotesCount) }
                })
              )
            )
          )
        ),
        showCaseNotesModal && _react2.default.createElement(
          _ModalWindow2.default,
          {
            headerInfo: { title: _react2.default.createElement(_NotesWidget.NotesWidgetHeader, { info: caseInfo }) },
            hideModal: this.handleToggleNotesModal,
            hideByClickingBackground: true
          },
          _react2.default.createElement(_NotesWidget.CaseNotesWidget, { caseInfo: caseInfo, type: 'modal' })
        )
      );
    }
  }]);

  return UnreadNotesLabel;
}(_react.Component);

UnreadNotesLabel.propTypes = {
  caseInfo: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    unreadNotesCount: _propTypes2.default.number.isRequired
  }).isRequired,
  hasModal: _propTypes2.default.bool,
  hideIcon: _propTypes2.default.bool,
  i18n: _propTypes2.default.shape({
    _: _propTypes2.default.func.isRequired
  }).isRequired,
  onClickAction: _propTypes2.default.func.isRequired
};

UnreadNotesLabel.defaultProps = {
  hasModal: false,
  hideIcon: false
};

exports.default = (0, _linguiReact.withI18n)()(UnreadNotesLabel);

/***/ }),

/***/ "./components/UnreadNoteLabel/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  unreadCount: (0, _linguiReact.i18nMark)('{count} Unread {count, plural, one {Note} other {Notes}}'),
  unreadNotes: (0, _linguiReact.i18nMark)('Unread Notes')
};

exports.default = messages;

/***/ }),

/***/ "./components/ViewSelector/ButtonWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = '\n  display: flex;\n  justify-content: space-between;\n  flex: 1;\n';

exports.default = (0, _decisivUiUtils.buildStyledComponent)('ButtonWrapper', _styledComponents2.default.div, styles);

/***/ }),

/***/ "./components/ViewSelector/IconWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  color: ' + props.theme.colors.base.chrome500 + ';\n  padding-right: ' + (0, _decisivUiUtils.px2rem)(7) + ';\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome500: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('IconWrapper', _styledComponents2.default.div, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/ViewSelector/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _reactFontawesome = __webpack_require__("../node_modules/react-fontawesome/lib/index.js");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _AbsoluteSmoothCollapse = __webpack_require__("./components/AbsoluteSmoothCollapse/index.js");

var _AbsoluteSmoothCollapse2 = _interopRequireDefault(_AbsoluteSmoothCollapse);

var _PopupMenu = __webpack_require__("./components/PopupMenu/index.js");

var _PopupMenu2 = _interopRequireDefault(_PopupMenu);

var _SelectorButton = __webpack_require__("./elements/SelectorButton/index.js");

var _ButtonWrapper = __webpack_require__("./components/ViewSelector/ButtonWrapper.js");

var _ButtonWrapper2 = _interopRequireDefault(_ButtonWrapper);

var _IconWrapper = __webpack_require__("./components/ViewSelector/IconWrapper.js");

var _IconWrapper2 = _interopRequireDefault(_IconWrapper);

var _messages = __webpack_require__("./components/ViewSelector/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ViewSelector = function (_Component) {
  _inherits(ViewSelector, _Component);

  function ViewSelector() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ViewSelector);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ViewSelector.__proto__ || Object.getPrototypeOf(ViewSelector)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      expanded: false
    }, _this.collapse = function () {
      _this.setState({ expanded: false });
    }, _this.handleSelect = function (event, optionId) {
      event.preventDefault();
      _this.props.changeView(optionId);
      _this.collapse();
    }, _this.toggle = function () {
      _this.setState({ expanded: !_this.state.expanded });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ViewSelector, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          options = _props.options,
          selected = _props.selected;
      var expanded = this.state.expanded;


      var selectedOption = options.find(function (option) {
        return option.id === selected;
      }) || {};
      var availableOptions = options.filter(function (option) {
        return option.id !== selected;
      });

      return _react2.default.createElement(
        _SelectorButton.SelectorButton,
        null,
        _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.viewAs }),
        ':',
        _react2.default.createElement(
          _SelectorButton.SelectorButtonAction,
          {
            expanded: expanded,
            onClick: this.toggle
          },
          _react2.default.createElement(
            _PopupMenu2.default,
            { onOutsideClick: this.collapse },
            !!selectedOption.id && _react2.default.createElement(
              _ButtonWrapper2.default,
              null,
              _react2.default.createElement(_linguiReact.Trans, { id: selectedOption.label }),
              _react2.default.createElement(
                _IconWrapper2.default,
                null,
                _react2.default.createElement(_reactFontawesome2.default, { name: expanded ? 'caret-up' : 'caret-down' })
              )
            ),
            _react2.default.createElement(
              _AbsoluteSmoothCollapse2.default,
              {
                expanded: expanded,
                heightTransition: '.15s cubic-bezier(0, 1, 0.5, 1)',
                top: (0, _decisivUiUtils.px2rem)(24),
                left: (0, _decisivUiUtils.px2rem)(-4),
                right: (0, _decisivUiUtils.px2rem)(-4)
              },
              _react2.default.createElement(
                _SelectorButton.SelectorOptionsPopup,
                null,
                _react2.default.createElement(
                  _SelectorButton.SelectorOptionsList,
                  null,
                  availableOptions.map(function (option) {
                    return _react2.default.createElement(
                      _SelectorButton.SelectorOptionListElement,
                      {
                        key: option.id,
                        id: 'case-view-option-' + option.id,
                        onClick: function onClick(event) {
                          _this2.handleSelect(event, option.id);
                        }
                      },
                      _react2.default.createElement(_linguiReact.Trans, { id: option.label })
                    );
                  })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return ViewSelector;
}(_react.Component);

ViewSelector.propTypes = {
  changeView: _propTypes2.default.func.isRequired,
  options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.string.isRequired
  })).isRequired,
  selected: _propTypes2.default.string.isRequired
};
exports.default = ViewSelector;

/***/ }),

/***/ "./components/ViewSelector/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  viewAs: (0, _linguiReact.i18nMark)('View As')
};

exports.default = messages;

/***/ }),

/***/ "./components/WarningLabel/WarningIcon.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.UnstyledFontAwesome = UnstyledFontAwesome;

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactFontawesome = __webpack_require__("../node_modules/react-fontawesome/lib/index.js");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function UnstyledFontAwesome(props) {
  var componentProps = (0, _lodash.omit)(props, ['theme', 'modifiers']);
  return _react2.default.createElement(_reactFontawesome2.default, _extends({}, componentProps, { name: 'exclamation-circle' }));
}

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  color: ' + props.theme.colors.status.warning + ';\n  font-size: ' + (0, _decisivUiUtils.px2rem)(14) + ';\n  padding-right: ' + (0, _decisivUiUtils.px2rem)(6) + ';\n  vertical-align: middle;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    status: _propTypes2.default.shape({
      warning: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('WarningIcon', (0, _styledComponents2.default)(UnstyledFontAwesome), styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/WarningLabel/WarningText.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(_ref) {
  var theme = _ref.theme;
  return '\n  color: ' + theme.colors.base.textLight + ';\n  font-size: ' + (0, _decisivUiUtils.px2rem)(12) + ';\n  font-weight: 300;\n  line-height: ' + (0, _decisivUiUtils.px2rem)(21) + ';\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      textLight: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('WarningText', _styledComponents2.default.span, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/WarningLabel/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _WarningIcon = __webpack_require__("./components/WarningLabel/WarningIcon.js");

var _WarningIcon2 = _interopRequireDefault(_WarningIcon);

var _WarningText = __webpack_require__("./components/WarningLabel/WarningText.js");

var _WarningText2 = _interopRequireDefault(_WarningText);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function WarningLabel(_ref) {
  var label = _ref.label;

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_WarningIcon2.default, null),
    _react2.default.createElement(
      _WarningText2.default,
      null,
      _react2.default.createElement(_linguiReact.Trans, { id: label })
    )
  );
}

WarningLabel.propTypes = {
  label: _propTypes2.default.string.isRequired
};

exports.default = WarningLabel;

/***/ }),

/***/ "./components/WindowQuery/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/react.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WindowQuery = function (_Component) {
  _inherits(WindowQuery, _Component);

  function WindowQuery() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, WindowQuery);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WindowQuery.__proto__ || Object.getPrototypeOf(WindowQuery)).call.apply(_ref, [this].concat(args))), _this), _this.resizeEventHandler = function () {
      _this.props.onResize({ windowWidth: window.innerWidth });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(WindowQuery, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.resizeEventListener = (0, _lodash.throttle)(this.resizeEventHandler, this.props.DEBOUNCE_TIME_MS);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.resizeEventListener);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.resizeEventListener);
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return WindowQuery;
}(_react.Component);

WindowQuery.propTypes = {
  DEBOUNCE_TIME_MS: _propTypes2.default.number.isRequired,
  children: _propTypes2.default.node.isRequired,
  onResize: _propTypes2.default.func
};
WindowQuery.defaultProps = {
  DEBOUNCE_TIME_MS: 250,
  onResize: _lodash.noop
};
exports.default = WindowQuery;

/***/ }),

/***/ "./components/WizardControllerHeader/ProgressPane.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = '\n  font-size: ' + (0, _decisivUiUtils.px2rem)(10) + ';\n  line-height: ' + (0, _decisivUiUtils.px2rem)(16) + ';\n  text-transform: uppercase;\n  width: 100%;\n';

exports.default = (0, _decisivUiUtils.buildStyledComponent)('ProgressPane', _styledComponents2.default.div, styles);

/***/ }),

/***/ "./components/WizardControllerHeader/StatusPane.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/styled-components-reactive-grid/dist/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(_ref) {
  var theme = _ref.theme;
  return '\n  background-color: ' + theme.colors.base.chrome100 + ';\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome100: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('StatusPane', (0, _styledComponents2.default)(_styledComponentsReactiveGrid.Container), styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/WizardControllerHeader/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _reactFontawesome = __webpack_require__("../node_modules/react-fontawesome/lib/index.js");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _baseComponents = __webpack_require__("../node_modules/base-components/build/index.js");

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/styled-components-reactive-grid/dist/index.js");

var _ProgressBar = __webpack_require__("./components/ProgressBar/index.js");

var _ProgressBar2 = _interopRequireDefault(_ProgressBar);

var _TextDiv = __webpack_require__("./elements/TextDiv/index.js");

var _TextDiv2 = _interopRequireDefault(_TextDiv);

var _StatusPane = __webpack_require__("./components/WizardControllerHeader/StatusPane.js");

var _StatusPane2 = _interopRequireDefault(_StatusPane);

var _ProgressPane = __webpack_require__("./components/WizardControllerHeader/ProgressPane.js");

var _ProgressPane2 = _interopRequireDefault(_ProgressPane);

var _messages = __webpack_require__("./components/WizardControllerHeader/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WizardControllerHeader = function WizardControllerHeader(_ref) {
  var configKey = _ref.configKey,
      handleWizardCancel = _ref.handleWizardCancel,
      nextStep = _ref.nextStep,
      nextStepDisabled = _ref.nextStepDisabled,
      previousStep = _ref.previousStep,
      previousStepDisabled = _ref.previousStepDisabled,
      stepCount = _ref.stepCount,
      stepIndex = _ref.stepIndex;
  return _react2.default.createElement(
    _StatusPane2.default,
    null,
    _react2.default.createElement(
      _styledComponentsReactiveGrid.Row,
      { modifiers: ['height_100', 'middle'] },
      _react2.default.createElement(
        _styledComponentsReactiveGrid.Column,
        { modifiers: ['col_3', 'padScale_5'] },
        _react2.default.createElement(
          _TextDiv2.default,
          { modifiers: ['heavyText', 'mediumText', 'midGreyText', 'uppercase'] },
          _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default[configKey] })
        )
      ),
      _react2.default.createElement(
        _styledComponentsReactiveGrid.Column,
        { modifiers: ['col_6'] },
        _react2.default.createElement(
          _styledComponentsReactiveGrid.Row,
          { modifiers: ['middle'] },
          _react2.default.createElement(
            _styledComponentsReactiveGrid.Column,
            { modifiers: ['col'] },
            _react2.default.createElement(
              _ProgressPane2.default,
              null,
              stepIndex < stepCount ? _react2.default.createElement(_linguiReact.Trans, {
                id: _messages2.default.wizardProgress,
                values: { step: stepIndex, total: stepCount - 1 }
              }) : _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.wizardReview })
            )
          ),
          _react2.default.createElement(
            _styledComponentsReactiveGrid.Column,
            null,
            _react2.default.createElement(
              _baseComponents.QuickActionButton,
              {
                modifiers: (0, _lodash.compact)(['iconOnly', previousStepDisabled && 'disabled']),
                onClick: previousStep
              },
              _react2.default.createElement(_reactFontawesome2.default, { name: 'chevron-up' })
            )
          ),
          _react2.default.createElement(
            _styledComponentsReactiveGrid.Column,
            null,
            _react2.default.createElement(
              _baseComponents.QuickActionButton,
              {
                modifiers: (0, _lodash.compact)(['iconOnly', nextStepDisabled && 'disabled']),
                onClick: nextStep
              },
              _react2.default.createElement(_reactFontawesome2.default, { name: 'chevron-down' })
            )
          )
        )
      ),
      _react2.default.createElement(
        _styledComponentsReactiveGrid.Column,
        {
          modifiers: ['col_3', 'end', 'padScale_5'],
          style: { display: 'flex' }
        },
        _react2.default.createElement(
          _baseComponents.QuickActionButton,
          {
            modifiers: ['iconOnly'],
            onClick: handleWizardCancel
          },
          _react2.default.createElement(_reactFontawesome2.default, { name: 'close' })
        )
      )
    ),
    _react2.default.createElement(
      _styledComponentsReactiveGrid.Row,
      null,
      _react2.default.createElement(
        _styledComponentsReactiveGrid.Column,
        { modifiers: ['col_6', 'col_offset_3', 'padScale_0'] },
        _react2.default.createElement(_ProgressBar2.default, { step: stepIndex, total: stepCount })
      )
    )
  );
};

WizardControllerHeader.propTypes = {
  configKey: _propTypes2.default.string.isRequired,
  handleWizardCancel: _propTypes2.default.func.isRequired,
  nextStep: _propTypes2.default.func.isRequired,
  nextStepDisabled: _propTypes2.default.bool,
  previousStep: _propTypes2.default.func.isRequired,
  previousStepDisabled: _propTypes2.default.bool,
  stepCount: _propTypes2.default.number.isRequired,
  stepIndex: _propTypes2.default.number.isRequired
};

WizardControllerHeader.defaultProps = {
  nextStepDisabled: false,
  previousStepDisabled: false
};

exports.default = WizardControllerHeader;

/***/ }),

/***/ "./components/WizardControllerHeader/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  SERVICE_REQUEST_WIZARD: (0, _linguiReact.i18nMark)('Create Service Request'),
  wizardProgress: (0, _linguiReact.i18nMark)('Step {step} of {total}'),
  wizardReview: (0, _linguiReact.i18nMark)('Review')
};

exports.default = messages;

/***/ }),

/***/ "./components/WizardInput/LeftLabel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles() {
  return '\n  left: ' + (0, _decisivUiUtils.px2rem)(10) + ';\n  position: absolute;\n  top: ' + (0, _decisivUiUtils.px2rem)(10) + ';\n';
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('LeftLabel', _styledComponents2.default.span, styles);

/***/ }),

/***/ "./components/WizardInput/RightLabel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var modifierConfig = {
  rightLabelVisible: function rightLabelVisible() {
    return {
      styles: '\n      visibility: visible;\n    '
    };
  }
};

/* istanbul ignore next */
var styles = function styles() {
  return '\n  right: ' + (0, _decisivUiUtils.px2rem)(10) + ';\n  position: absolute;\n  top: ' + (0, _decisivUiUtils.px2rem)(10) + ';\n  visibility: hidden;\n';
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('RightLabel', _styledComponents2.default.span, styles, { modifierConfig: modifierConfig });

/***/ }),

/***/ "./components/WizardInput/WizardInputWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultHeight = (0, _decisivUiUtils.px2rem)(25);

/* istanbul ignore next */
var modifierConfig = {
  flexibleHeight: function flexibleHeight() {
    return {
      styles: '\n      box-sizing: border-box;\n      font-size: 0;\n      height: auto;\n      min-height: ' + defaultHeight + ';\n    '
    };
  },
  topOverlap: function topOverlap() {
    return {
      styles: '\n      margin-top: -1px;\n    '
    };
  },
  warning: function warning(_ref) {
    var theme = _ref.theme;
    return {
      styles: '\n      border-color: ' + theme.colors.status.warning + ' !important;\n    '
    };
  }
};

/* istanbul ignore next */
var styles = function styles(_ref2) {
  var theme = _ref2.theme;
  return '\n  border: 1px solid ' + theme.colors.base.chrome400 + ';\n  height: ' + defaultHeight + ';\n  padding-left: ' + (0, _decisivUiUtils.px2rem)(10) + ';\n  padding-top: ' + (0, _decisivUiUtils.px2rem)(20) + ';\n  position: relative;\n\n  &:focus-within {\n    border-color: ' + theme.colors.base.chrome600 + ';\n    z-index: 1;\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome400: _propTypes2.default.string.isRequired,
      chrome600: _propTypes2.default.string.isRequired
    }).isRequired,
    status: _propTypes2.default.shape({
      warning: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('WizardInputWrapper', _styledComponents2.default.div, styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/WizardInput/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _TextDiv = __webpack_require__("./elements/TextDiv/index.js");

var _TextDiv2 = _interopRequireDefault(_TextDiv);

var _WizardInputWrapper = __webpack_require__("./components/WizardInput/WizardInputWrapper.js");

var _WizardInputWrapper2 = _interopRequireDefault(_WizardInputWrapper);

var _LeftLabel = __webpack_require__("./components/WizardInput/LeftLabel.js");

var _LeftLabel2 = _interopRequireDefault(_LeftLabel);

var _RightLabel = __webpack_require__("./components/WizardInput/RightLabel.js");

var _RightLabel2 = _interopRequireDefault(_RightLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A UI wrapper for input fields in Wizard steps (e.g. Complaint Select, Asset Select, etc)
 * Basically, it contains the border, a label and an icon (TBD).
 * @param {array} modifiers includes component-level modifiers and rightLabel modifiers
 * that start with `rightLabel-` prefix. (e.g. rightLabelVisible)
 */
function WizardInput(_ref) {
  var children = _ref.children,
      label = _ref.label,
      rightLabel = _ref.rightLabel,
      rightLabelValue = _ref.rightLabelValue,
      modifiers = _ref.modifiers;

  var rightLabelModifiers = modifiers.filter(function (modifier) {
    return modifier.startsWith('rightLabel');
  });
  var componentModifiers = (0, _lodash.difference)(modifiers, rightLabelModifiers);
  return _react2.default.createElement(
    _WizardInputWrapper2.default,
    { modifiers: componentModifiers },
    children,
    _react2.default.createElement(
      _LeftLabel2.default,
      null,
      _react2.default.createElement(
        _TextDiv2.default,
        { modifiers: ['midGreyText', 'xSmallText'] },
        _react2.default.createElement(_linguiReact.Trans, { id: label })
      )
    ),
    rightLabel && _react2.default.createElement(
      _RightLabel2.default,
      { modifiers: rightLabelModifiers },
      _react2.default.createElement(
        _TextDiv2.default,
        { modifiers: ['midGreyText', 'xSmallText'] },
        _react2.default.createElement(_linguiReact.Trans, { id: rightLabel, values: { value: rightLabelValue } })
      )
    )
  );
}

WizardInput.propTypes = {
  children: _propTypes2.default.node.isRequired,
  label: _propTypes2.default.string.isRequired,
  rightLabel: _propTypes2.default.string,
  rightLabelValue: _propTypes2.default.number,
  modifiers: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

WizardInput.defaultProps = {
  modifiers: [],
  rightLabel: undefined,
  rightLabelValue: 0
};

exports.default = WizardInput;

/***/ }),

/***/ "./components/WizardSearchError/Wrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  color: ' + props.theme.colors.base.chrome300 + ';\n  font-size: ' + (0, _decisivUiUtils.px2rem)(50) + ';\n  margin: auto;\n  max-width: ' + (0, _decisivUiUtils.px2rem)(350) + ';\n  line-height: ' + (0, _decisivUiUtils.px2rem)(50) + ';\n  text-align: center;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome300: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Wrapper', _styledComponents2.default.div, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/WizardSearchError/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactFontawesome = __webpack_require__("../node_modules/react-fontawesome/lib/index.js");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _baseComponents = __webpack_require__("../node_modules/base-components/build/index.js");

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _TextDiv = __webpack_require__("./elements/TextDiv/index.js");

var _TextDiv2 = _interopRequireDefault(_TextDiv);

var _Wrapper = __webpack_require__("./components/WizardSearchError/Wrapper.js");

var _Wrapper2 = _interopRequireDefault(_Wrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function WizardSearchError(_ref) {
  var searchValue = _ref.searchValue,
      titlePrefix = _ref.titlePrefix,
      titleSuffix = _ref.titleSuffix,
      subtitle = _ref.subtitle;

  var isNoSearch = searchValue === '';
  var marginValue = isNoSearch ? (0, _decisivUiUtils.px2rem)(20) : (0, _decisivUiUtils.px2rem)(6);

  return _react2.default.createElement(
    _Wrapper2.default,
    null,
    _react2.default.createElement(_reactFontawesome2.default, { name: 'search' }),
    !isNoSearch && _react2.default.createElement(
      _baseComponents.H4,
      { modifiers: ['fontWeightRegular'], style: { marginTop: (0, _decisivUiUtils.px2rem)(20) } },
      _react2.default.createElement(_linguiReact.Trans, { id: titlePrefix }),
      _react2.default.createElement(
        _TextDiv2.default,
        { modifiers: ['bold', 'inline'] },
        '' + searchValue
      ),
      _react2.default.createElement(_linguiReact.Trans, { id: titleSuffix })
    ),
    _react2.default.createElement(
      _baseComponents.P,
      {
        modifiers: ['textLight'],
        style: { marginTop: marginValue }
      },
      _react2.default.createElement(_linguiReact.Trans, { id: subtitle })
    )
  );
}

WizardSearchError.propTypes = {
  searchValue: _propTypes2.default.string.isRequired,
  titlePrefix: _propTypes2.default.string.isRequired,
  titleSuffix: _propTypes2.default.string.isRequired,
  subtitle: _propTypes2.default.string.isRequired
};

exports.default = WizardSearchError;

/***/ }),

/***/ "./components/WizardSteps/AssetAvailability/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO: Make this a real step.
/* istanbul ignore next */
function Step(props) {
  console.log('WizardSteps - AssetAvailability - props:', props);

  var submitInputData = function submitInputData(value) {
    props.completeStep({ assetAvailability: value });
  };

  return _react2.default.createElement(
    'div',
    { style: { backgroundColor: 'papayawhip', padding: '1rem' } },
    _react2.default.createElement(
      'h3',
      null,
      'AssetAvailability'
    ),
    _react2.default.createElement(
      'button',
      { onClick: function onClick() {
          submitInputData('Today');
        } },
      'Today'
    ),
    _react2.default.createElement(
      'button',
      { onClick: function onClick() {
          submitInputData('Next Week');
        } },
      'Next Week'
    ),
    _react2.default.createElement(
      'h4',
      null,
      'Input Data'
    ),
    _react2.default.createElement(
      'pre',
      null,
      JSON.stringify(props.inputData, null, 2)
    )
  );
}

Step.propTypes = {
  completeStep: _propTypes2.default.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  inputData: _propTypes2.default.object.isRequired
};

exports.default = Step;

/***/ }),

/***/ "./components/WizardSteps/AssetSelection/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/styled-components-reactive-grid/dist/index.js");

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _baseComponents = __webpack_require__("../node_modules/base-components/build/index.js");

var _AssetSelectionStep = __webpack_require__("./compositions/AssetSelectionStep/index.js");

var _AssetSelectionStep2 = _interopRequireDefault(_AssetSelectionStep);

var _messages = __webpack_require__("./components/WizardSteps/AssetSelection/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AssetSelection = function (_Component) {
  _inherits(AssetSelection, _Component);

  function AssetSelection() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AssetSelection);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AssetSelection.__proto__ || Object.getPrototypeOf(AssetSelection)).call.apply(_ref, [this].concat(args))), _this), _this.submitInputData = function (value) {
      _this.props.completeStep({ asset: value });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AssetSelection, [{
    key: 'render',


    // TODO: make AssetSelector a composition, not the entire AssetSelectionStep,
    // so that AssetSelector can more easily be re-used elsewhere.
    value: function render() {
      var _props = this.props,
          review = _props.review,
          asset = _props.inputData.asset;


      return review ? _react2.default.createElement(
        _styledComponentsReactiveGrid.Container,
        null,
        _react2.default.createElement(
          _styledComponentsReactiveGrid.Row,
          null,
          _react2.default.createElement(
            _styledComponentsReactiveGrid.Column,
            { modifiers: ['col_3'] },
            _react2.default.createElement(
              _baseComponents.P,
              { modifiers: ['fontWeightMedium'] },
              _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.asset })
            )
          ),
          _react2.default.createElement(
            _styledComponentsReactiveGrid.Column,
            { modifiers: ['col_9'] },
            _react2.default.createElement(
              _baseComponents.P,
              { modifiers: ['fontWeightRegular'] },
              asset.unitNumber + ' ' + asset.make + ' ' + asset.model + ' ' + asset.engine + ' - ' + asset.year
            )
          )
        )
      ) : _react2.default.createElement(_AssetSelectionStep2.default, {
        submitInputData: this.submitInputData,
        initialAsset: asset
      });
    }
  }]);

  return AssetSelection;
}(_react.Component);

AssetSelection.propTypes = {
  inputData: _propTypes2.default.shape({
    asset: _propTypes2.default.shape({
      unitNumber: _propTypes2.default.string,
      make: _propTypes2.default.string,
      model: _propTypes2.default.string,
      engine: _propTypes2.default.string,
      year: _propTypes2.default.string
    })
  }),
  review: _propTypes2.default.bool,
  completeStep: _propTypes2.default.func.isRequired
};
AssetSelection.defaultProps = {
  inputData: {},
  review: false
};
exports.default = AssetSelection;

/***/ }),

/***/ "./components/WizardSteps/AssetSelection/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var formattedMessages = {
  asset: (0, _linguiReact.i18nMark)('Asset')
};

exports.default = formattedMessages;

/***/ }),

/***/ "./components/WizardSteps/ContactPerson/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO: Make this a real step.
/* istanbul ignore next */
function Step(props) {
  console.log('WizardSteps - ContactPerson - props:', props);

  var submitInputData = function submitInputData(value) {
    props.completeStep({ contact: value });
  };

  return _react2.default.createElement(
    'div',
    { style: { backgroundColor: 'papayawhip', padding: '1rem' } },
    _react2.default.createElement(
      'h3',
      null,
      'ContactPerson'
    ),
    _react2.default.createElement(
      'button',
      { onClick: function onClick() {
          submitInputData('David');
        } },
      'David'
    ),
    _react2.default.createElement(
      'button',
      { onClick: function onClick() {
          submitInputData('Kim');
        } },
      'Kim'
    ),
    _react2.default.createElement(
      'h4',
      null,
      'Input Data'
    ),
    _react2.default.createElement(
      'pre',
      null,
      JSON.stringify(props.inputData, null, 2)
    )
  );
}

Step.propTypes = {
  completeStep: _propTypes2.default.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  inputData: _propTypes2.default.object.isRequired
};

exports.default = Step;

/***/ }),

/***/ "./components/WizardSteps/ReasonForRepair/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/styled-components-reactive-grid/dist/index.js");

var _baseComponents = __webpack_require__("../node_modules/base-components/build/index.js");

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _ReasonForRepairStep = __webpack_require__("./compositions/ReasonForRepairStep/index.js");

var _ReasonForRepairStep2 = _interopRequireDefault(_ReasonForRepairStep);

var _messages = __webpack_require__("./components/WizardSteps/ReasonForRepair/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReasonForRepair = function (_Component) {
  _inherits(ReasonForRepair, _Component);

  function ReasonForRepair() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ReasonForRepair);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReasonForRepair.__proto__ || Object.getPrototypeOf(ReasonForRepair)).call.apply(_ref, [this].concat(args))), _this), _this.submitInputData = function (value) {
      _this.props.completeStep({ reasonForRepair: value });
    }, _this.syncInputData = function (value) {
      _this.props.syncStep({ reasonForRepair: value });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ReasonForRepair, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          review = _props.review,
          _props$inputData$reas = _props.inputData.reasonForRepair;
      _props$inputData$reas = _props$inputData$reas === undefined ? {} : _props$inputData$reas;
      var complaintCode = _props$inputData$reas.complaintCode,
          complaintDescription = _props$inputData$reas.complaintDescription,
          description = _props$inputData$reas.description;


      return review ? _react2.default.createElement(
        _styledComponentsReactiveGrid.Container,
        null,
        _react2.default.createElement(
          _styledComponentsReactiveGrid.Row,
          null,
          _react2.default.createElement(
            _styledComponentsReactiveGrid.Column,
            { modifiers: ['col_3'] },
            _react2.default.createElement(
              _baseComponents.P,
              { modifiers: ['fontWeightMedium'] },
              _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.complaint })
            )
          ),
          _react2.default.createElement(
            _styledComponentsReactiveGrid.Column,
            { modifiers: ['col_9'] },
            _react2.default.createElement(
              _baseComponents.P,
              { modifiers: ['fontWeightMedium'] },
              complaintCode + ' - ' + complaintDescription
            ),
            _react2.default.createElement(
              _baseComponents.P,
              { modifiers: ['fontWeightRegular'] },
              description
            )
          )
        )
      ) : _react2.default.createElement(_ReasonForRepairStep2.default, {
        initialReasonForRepair: this.props.inputData.reasonForRepair,
        submitInputData: this.submitInputData,
        syncInputData: this.syncInputData
      });
    }
  }]);

  return ReasonForRepair;
}(_react.Component);

ReasonForRepair.propTypes = {
  inputData: _propTypes2.default.shape({
    reasonForRepair: _propTypes2.default.shape({
      complaintCode: _propTypes2.default.string,
      complaintDescription: _propTypes2.default.string,
      description: _propTypes2.default.string
    })
  }),
  review: _propTypes2.default.bool,
  completeStep: _propTypes2.default.func.isRequired,
  syncStep: _propTypes2.default.func.isRequired
};
ReasonForRepair.defaultProps = {
  inputData: {},
  review: false
};
exports.default = ReasonForRepair;

/***/ }),

/***/ "./components/WizardSteps/ReasonForRepair/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  complaint: (0, _linguiReact.i18nMark)('Complaint')
};

exports.default = messages;

/***/ }),

/***/ "./components/WizardSteps/Review/GridRow.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/styled-components-reactive-grid/dist/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(_ref) {
  var theme = _ref.theme;
  return '\n  &:hover {\n    background-color: ' + theme.colors.base.chrome100 + ';\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome100: _propTypes2.default.string.isRequired
    })
  })
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('GridRow', (0, _styledComponents2.default)(_styledComponentsReactiveGrid.Row), styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/WizardSteps/Review/ReviewStepRow.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _baseComponents = __webpack_require__("../node_modules/base-components/build/index.js");

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/styled-components-reactive-grid/dist/index.js");

var _GridRow = __webpack_require__("./components/WizardSteps/Review/GridRow.js");

var _GridRow2 = _interopRequireDefault(_GridRow);

var _messages = __webpack_require__("./components/WizardSteps/Review/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReviewStepRow = function (_Component) {
  _inherits(ReviewStepRow, _Component);

  function ReviewStepRow() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ReviewStepRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReviewStepRow.__proto__ || Object.getPrototypeOf(ReviewStepRow)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hovering: false
    }, _this.setHoveringTrue = function () {
      _this.setState({ hovering: true });
    }, _this.setHoveringFalse = function () {
      _this.setState({ hovering: false });
    }, _this.handleClick = function () {
      var _this$props = _this.props,
          jumpToStep = _this$props.jumpToStep,
          name = _this$props.name;

      jumpToStep(name);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ReviewStepRow, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          inputData = _props.inputData,
          ReviewComponent = _props.ReviewComponent;


      return _react2.default.createElement(
        _GridRow2.default,
        {
          modifiers: ['fluid'],
          onMouseEnter: this.setHoveringTrue,
          onMouseLeave: this.setHoveringFalse
        },
        _react2.default.createElement(
          _styledComponentsReactiveGrid.Column,
          { modifiers: ['col_9'] },
          _react2.default.createElement(ReviewComponent, { completeStep: _lodash.noop, inputData: inputData, review: true })
        ),
        _react2.default.createElement(
          _styledComponentsReactiveGrid.Column,
          { modifiers: ['col_3'] },
          this.state.hovering && _react2.default.createElement(
            _baseComponents.QuickActionButton,
            { onClick: this.handleClick },
            _react2.default.createElement(_baseComponents.QuickActionButton.Icon, { modifiers: ['left'], name: 'pencil' }),
            _react2.default.createElement(
              _baseComponents.QuickActionButton.Text,
              null,
              _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.editButton })
            )
          )
        )
      );
    }
  }]);

  return ReviewStepRow;
}(_react.Component);

ReviewStepRow.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  inputData: _propTypes2.default.object.isRequired,
  jumpToStep: _propTypes2.default.func.isRequired,
  name: _propTypes2.default.string.isRequired,
  ReviewComponent: _propTypes2.default.func.isRequired
};
exports.default = ReviewStepRow;

/***/ }),

/***/ "./components/WizardSteps/Review/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _baseComponents = __webpack_require__("../node_modules/base-components/build/index.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactFontawesome = __webpack_require__("../node_modules/react-fontawesome/lib/index.js");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/styled-components-reactive-grid/dist/index.js");

var _TextDiv = __webpack_require__("./elements/TextDiv/index.js");

var _TextDiv2 = _interopRequireDefault(_TextDiv);

var _ReviewStepRow = __webpack_require__("./components/WizardSteps/Review/ReviewStepRow.js");

var _ReviewStepRow2 = _interopRequireDefault(_ReviewStepRow);

var _messages = __webpack_require__("./components/WizardSteps/Review/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReviewStep = function (_Component) {
  _inherits(ReviewStep, _Component);

  function ReviewStep() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ReviewStep);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReviewStep.__proto__ || Object.getPrototypeOf(ReviewStep)).call.apply(_ref, [this].concat(args))), _this), _this.keydownEventHandler = function (_ref2) {
      var key = _ref2.key;

      // handle the Enter key being pressed
      if (key === 'Enter') {
        _this.props.handleWizardSubmit(_this.props.inputData);
      }

      // handle the ESC key being pressed - `Esc` for IE11
      if (key === 'Escape' || key === 'Esc') {
        _this.props.handleWizardCancel();
      }
    }, _this.handleClick = function () {
      var _this$props = _this.props,
          handleWizardSubmit = _this$props.handleWizardSubmit,
          inputData = _this$props.inputData;

      handleWizardSubmit(inputData);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ReviewStep, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('keydown', this.keydownEventHandler);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('keydown', this.keydownEventHandler);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          handleWizardCancel = _props.handleWizardCancel,
          inputData = _props.inputData,
          jumpToStep = _props.jumpToStep,
          stepsArray = _props.stepsArray;

      // The last step in the stepsArray is the ReviewStep (this step).
      // It is not included in the review steps display.

      var stepsToDisplay = stepsArray.slice(0, stepsArray.length - 1);

      return _react2.default.createElement(
        _styledComponentsReactiveGrid.Container,
        null,
        stepsToDisplay.map(function (_ref3) {
          var name = _ref3.name,
              ReviewComponent = _ref3.component;
          return _react2.default.createElement(_ReviewStepRow2.default, {
            key: name,
            inputData: inputData,
            jumpToStep: jumpToStep,
            name: name,
            ReviewComponent: ReviewComponent
          });
        }),
        _react2.default.createElement(
          _styledComponentsReactiveGrid.Row,
          null,
          _react2.default.createElement(
            _styledComponentsReactiveGrid.Column,
            { modifiers: ['col_12'] },
            _react2.default.createElement(
              _styledComponentsReactiveGrid.Container,
              null,
              _react2.default.createElement(
                _styledComponentsReactiveGrid.Row,
                { modifiers: ['end', 'middle'] },
                _react2.default.createElement(
                  _styledComponentsReactiveGrid.Column,
                  null,
                  _react2.default.createElement(
                    _TextDiv2.default,
                    { modifiers: ['midGreyText'] },
                    _react2.default.createElement(_reactFontawesome2.default, { name: 'keyboard-o' })
                  )
                ),
                _react2.default.createElement(
                  _styledComponentsReactiveGrid.Column,
                  null,
                  _react2.default.createElement(
                    _TextDiv2.default,
                    { modifiers: ['midGreyText', 'xSmallText'] },
                    _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.keypressGuide })
                  )
                ),
                _react2.default.createElement(
                  _styledComponentsReactiveGrid.Column,
                  null,
                  _react2.default.createElement(
                    _baseComponents.QuickActionButton,
                    {
                      modifiers: ['hoverDanger'],
                      onClick: handleWizardCancel
                    },
                    _react2.default.createElement(
                      _baseComponents.QuickActionButton.Text,
                      null,
                      _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.cancelButton })
                    )
                  )
                ),
                _react2.default.createElement(
                  _styledComponentsReactiveGrid.Column,
                  null,
                  _react2.default.createElement(
                    _baseComponents.QuickActionButton,
                    {
                      modifiers: ['hoverSuccess', 'secondary'],
                      onClick: this.handleClick
                    },
                    _react2.default.createElement(
                      _baseComponents.QuickActionButton.Text,
                      null,
                      _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.submitButton })
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return ReviewStep;
}(_react.Component);

ReviewStep.propTypes = {
  handleWizardCancel: _propTypes2.default.func.isRequired,
  handleWizardSubmit: _propTypes2.default.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  inputData: _propTypes2.default.object.isRequired,
  jumpToStep: _propTypes2.default.func.isRequired,
  stepsArray: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    component: _propTypes2.default.func.isRequired,
    name: _propTypes2.default.string.isRequired
  }).isRequired).isRequired
};
exports.default = ReviewStep;

/***/ }),

/***/ "./components/WizardSteps/Review/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  cancelButton: (0, _linguiReact.i18nMark)('Cancel'),
  editButton: (0, _linguiReact.i18nMark)('Edit'),
  keypressGuide: (0, _linguiReact.i18nMark)('Press ESC to cancel or ENTER to submit'),
  submitButton: (0, _linguiReact.i18nMark)('Submit Request')
};

exports.default = messages;

/***/ }),

/***/ "./components/WizardSteps/ServiceProviderSelection/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _baseComponents = __webpack_require__("../node_modules/base-components/build/index.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/styled-components-reactive-grid/dist/index.js");

var _ServiceProviderSelectionStep = __webpack_require__("./compositions/ServiceProviderSelectionStep/index.js");

var _ServiceProviderSelectionStep2 = _interopRequireDefault(_ServiceProviderSelectionStep);

var _messages = __webpack_require__("./components/WizardSteps/ServiceProviderSelection/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ServiceProviderSelection(_ref) {
  var completeStep = _ref.completeStep,
      _ref$inputData = _ref.inputData,
      _ref$inputData$servic = _ref$inputData.serviceProvider,
      serviceProvider = _ref$inputData$servic === undefined ? { address: {} } : _ref$inputData$servic,
      assetLocationSearchValue = _ref$inputData.assetLocationSearchValue,
      inputData = _ref.inputData,
      review = _ref.review;

  if (review) {
    var _serviceProvider$addr = serviceProvider.address,
        city = _serviceProvider$addr.city,
        postalCode = _serviceProvider$addr.postalCode,
        region = _serviceProvider$addr.region,
        street = _serviceProvider$addr.street,
        street2 = _serviceProvider$addr.street2,
        companyName = serviceProvider.companyName;

    return _react2.default.createElement(
      _styledComponentsReactiveGrid.Container,
      { className: 'service-provider-selection-review' },
      _react2.default.createElement(
        _styledComponentsReactiveGrid.Row,
        null,
        _react2.default.createElement(
          _styledComponentsReactiveGrid.Column,
          { modifiers: ['col_3'] },
          _react2.default.createElement(
            _baseComponents.P,
            { modifiers: ['fontWeightMedium'] },
            _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.serviceProvider })
          )
        ),
        _react2.default.createElement(
          _styledComponentsReactiveGrid.Column,
          { modifiers: ['col_9'] },
          _react2.default.createElement(
            _baseComponents.P,
            { modifiers: ['fontWeightRegular'] },
            assetLocationSearchValue
          ),
          _react2.default.createElement(
            _baseComponents.P,
            { modifiers: ['fontWeightRegular'] },
            companyName
          ),
          _react2.default.createElement(
            _baseComponents.P,
            { modifiers: ['fontWeightRegular'] },
            street + ' ' + street2
          ),
          _react2.default.createElement(
            _baseComponents.P,
            { modifiers: ['fontWeightRegular'] },
            city + ', ' + region + ' ' + postalCode
          )
        )
      )
    );
  }

  return _react2.default.createElement(_ServiceProviderSelectionStep2.default, {
    inputData: inputData,
    completeStep: completeStep
  });
}

ServiceProviderSelection.propTypes = {
  completeStep: _propTypes2.default.func.isRequired,
  inputData: _propTypes2.default.shape({
    serviceProvider: _propTypes2.default.shape({
      companyName: _propTypes2.default.string.isRequired
    }),
    assetLocationSearchValue: _propTypes2.default.string
  }),
  review: _propTypes2.default.bool
};

ServiceProviderSelection.defaultProps = {
  inputData: {},
  review: false
};

exports.default = ServiceProviderSelection;

/***/ }),

/***/ "./components/WizardSteps/ServiceProviderSelection/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  serviceProvider: (0, _linguiReact.i18nMark)('Service Provider')
};

exports.default = messages;

/***/ }),

/***/ "./components/WizardSteps/ServiceRequestType/InputWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = '\n  display: flex;\n  margin-top: ' + (0, _decisivUiUtils.px2rem)(30) + ';\n';

exports.default = (0, _decisivUiUtils.buildStyledComponent)('InputWrapper', _styledComponents2.default.div, styles);

/***/ }),

/***/ "./components/WizardSteps/ServiceRequestType/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable import/prefer-default-export */
var SERVICE_TYPES = exports.SERVICE_TYPES = ['maintenance', 'breakdown'];

/***/ }),

/***/ "./components/WizardSteps/ServiceRequestType/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _baseComponents = __webpack_require__("../node_modules/base-components/build/index.js");

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/styled-components-reactive-grid/dist/index.js");

var _TypeSelect = __webpack_require__("./components/TypeSelect/index.js");

var _TypeSelect2 = _interopRequireDefault(_TypeSelect);

var _InputWrapper = __webpack_require__("./components/WizardSteps/ServiceRequestType/InputWrapper.js");

var _InputWrapper2 = _interopRequireDefault(_InputWrapper);

var _constants = __webpack_require__("./components/WizardSteps/ServiceRequestType/constants.js");

var _messages = __webpack_require__("./components/WizardSteps/ServiceRequestType/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ServiceRequestType = function (_Component) {
  _inherits(ServiceRequestType, _Component);

  function ServiceRequestType() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ServiceRequestType);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ServiceRequestType.__proto__ || Object.getPrototypeOf(ServiceRequestType)).call.apply(_ref, [this].concat(args))), _this), _this.submitInputData = function (value) {
      _this.props.completeStep({ typeOfService: value });
    }, _this.renderInput = function (inputData) {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _baseComponents.H3,
          { modifiers: ['fontWeightRegular'] },
          _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.title })
        ),
        _react2.default.createElement(
          _InputWrapper2.default,
          null,
          _constants.SERVICE_TYPES.map(function (serviceType, index) {
            return _react2.default.createElement(_TypeSelect2.default, {
              key: serviceType,
              onSelect: function onSelect() {
                _this.submitInputData(serviceType);
              },
              isSelected: inputData.typeOfService === serviceType,
              typeName: _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default[serviceType] }),
              selectKey: '' + (index + 1)
            });
          })
        )
      );
    }, _this.renderReview = function (inputData) {
      return _react2.default.createElement(
        _styledComponentsReactiveGrid.Container,
        null,
        _react2.default.createElement(
          _styledComponentsReactiveGrid.Row,
          null,
          _react2.default.createElement(
            _styledComponentsReactiveGrid.Column,
            { modifiers: ['col_3'] },
            _react2.default.createElement(
              _baseComponents.P,
              { modifiers: ['fontWeightMedium'] },
              _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.requestType })
            )
          ),
          _react2.default.createElement(
            _styledComponentsReactiveGrid.Column,
            { modifiers: ['col_9'] },
            _react2.default.createElement(
              _baseComponents.P,
              null,
              _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default[inputData.typeOfService] })
            )
          )
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ServiceRequestType, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          inputData = _props.inputData,
          review = _props.review;

      return !review ? this.renderInput(inputData) : this.renderReview(inputData);
    }
  }]);

  return ServiceRequestType;
}(_react.Component);

ServiceRequestType.propTypes = {
  completeStep: _propTypes2.default.func.isRequired,
  inputData: _propTypes2.default.shape({
    typeOfService: _propTypes2.default.string
  }),
  review: _propTypes2.default.bool
};

ServiceRequestType.defaultProps = {
  inputData: {},
  review: false
};

exports.default = ServiceRequestType;

/***/ }),

/***/ "./components/WizardSteps/ServiceRequestType/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  breakdown: (0, _linguiReact.i18nMark)('Breakdown'),
  maintenance: (0, _linguiReact.i18nMark)('Maintenance'),
  title: (0, _linguiReact.i18nMark)('What type of Service?'),
  requestType: (0, _linguiReact.i18nMark)('Request Type')
};

exports.default = messages;

/***/ }),

/***/ "./components/_common/CardLoading/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactiveContainer = __webpack_require__("../node_modules/reactive-container/dist/index.js");

var _Card = __webpack_require__("./elements/Card/index.js");

var _Card2 = _interopRequireDefault(_Card);

var _GhostIndicator = __webpack_require__("./components/_common/GhostIndicator/index.js");

var _GhostIndicator2 = _interopRequireDefault(_GhostIndicator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function CardLoading() {
  var _ref;

  return _react2.default.createElement(
    _Card.CardWrapper,
    {
      responsiveModifiers: (_ref = {}, _defineProperty(_ref, _reactiveContainer.sizes.XS, ['1_per_row']), _defineProperty(_ref, _reactiveContainer.sizes.SM, ['2_per_row']), _defineProperty(_ref, _reactiveContainer.sizes.MD, ['3_per_row']), _defineProperty(_ref, _reactiveContainer.sizes.LG, ['4_per_row']), _defineProperty(_ref, _reactiveContainer.sizes.XL, ['5_per_row']), _ref)
    },
    _react2.default.createElement(
      _Card2.default,
      { modifiers: ['loading'] },
      _react2.default.createElement(_GhostIndicator2.default, { modifiers: ['bottomGap'] }),
      _react2.default.createElement(_GhostIndicator2.default, null),
      _react2.default.createElement(_GhostIndicator2.default, null),
      _react2.default.createElement(_GhostIndicator2.default, null)
    )
  );
}

exports.default = CardLoading;

/***/ }),

/***/ "./components/_common/CardView/CardsWithSize.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MAX_LOADING_CARDS_PE;

exports.CardsWithSize = CardsWithSize;

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactImmutableProptypes = __webpack_require__("../node_modules/react-immutable-proptypes/dist/ImmutablePropTypes.js");

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _reactiveContainer = __webpack_require__("../node_modules/reactive-container/dist/index.js");

var _CardLoading = __webpack_require__("./components/_common/CardLoading/index.js");

var _CardLoading2 = _interopRequireDefault(_CardLoading);

var _favorites = __webpack_require__("./utils/favorites.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MAX_LOADING_CARDS_PER_SIZE = (_MAX_LOADING_CARDS_PE = {}, _defineProperty(_MAX_LOADING_CARDS_PE, _reactiveContainer.sizes.SM, 4), _defineProperty(_MAX_LOADING_CARDS_PE, _reactiveContainer.sizes.MD, 6), _defineProperty(_MAX_LOADING_CARDS_PE, _reactiveContainer.sizes.LG, 8), _defineProperty(_MAX_LOADING_CARDS_PE, _reactiveContainer.sizes.XL, 10), _MAX_LOADING_CARDS_PE);

function renderDataCards(dataList, CardComp) {
  return dataList.map(function (datum) {
    return _react2.default.createElement(CardComp, {
      key: datum.get('id'),
      datum: datum,
      type: 'card'
    });
  });
}

function renderGhostCards(dataList, favoritePagination, requesting, size) {
  if (!(0, _favorites.shouldBuildLoadingGhosts)({ currentCount: dataList.size, favoritePagination: favoritePagination, requesting: requesting })) {
    return null;
  }

  var MAX_LOADING_CARDS = MAX_LOADING_CARDS_PER_SIZE[size] || 2;
  var totalCount = favoritePagination.get('totalCount');
  var count = totalCount ? Math.min(MAX_LOADING_CARDS, totalCount - dataList.size) : MAX_LOADING_CARDS;
  return Array.from({ length: count }, function (_, i) {
    return _react2.default.createElement(_CardLoading2.default, { key: i });
  });
}

function CardsWithSize(_ref) {
  var dataList = _ref.dataList,
      favoritePagination = _ref.favoritePagination,
      requesting = _ref.requesting,
      CardComp = _ref.CardComp,
      size = _ref.size;

  return _react2.default.createElement(
    'div',
    null,
    renderDataCards(dataList, CardComp),
    renderGhostCards(dataList, favoritePagination, requesting, size)
  );
}

CardsWithSize.propTypes = {
  dataList: _reactImmutableProptypes2.default.listOf(_reactImmutableProptypes2.default.mapContains({
    id: _propTypes2.default.string
  })).isRequired,
  favoritePagination: _reactImmutableProptypes2.default.map.isRequired,
  requesting: _propTypes2.default.bool.isRequired,
  size: _propTypes2.default.string.isRequired,
  CardComp: _propTypes2.default.func.isRequired
};

exports.default = (0, _reactiveContainer.withSize)(CardsWithSize);

/***/ }),

/***/ "./components/_common/CardView/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactImmutableProptypes = __webpack_require__("../node_modules/react-immutable-proptypes/dist/ImmutablePropTypes.js");

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _ResponsiveCardGrid = __webpack_require__("./elements/Card/ResponsiveCardGrid.js");

var _ResponsiveCardGrid2 = _interopRequireDefault(_ResponsiveCardGrid);

var _CardsWithSize = __webpack_require__("./components/_common/CardView/CardsWithSize.js");

var _CardsWithSize2 = _interopRequireDefault(_CardsWithSize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CardView(_ref) {
  var dataList = _ref.dataList,
      favoritePagination = _ref.favoritePagination,
      requesting = _ref.requesting,
      CardComp = _ref.CardComp;

  return _react2.default.createElement(
    _ResponsiveCardGrid2.default,
    { breakpoints: _ResponsiveCardGrid.CARD_GRID_BREAKPOINTS },
    _react2.default.createElement(_CardsWithSize2.default, {
      dataList: dataList,
      favoritePagination: favoritePagination,
      requesting: requesting,
      CardComp: CardComp
    })
  );
}

CardView.propTypes = {
  dataList: _reactImmutableProptypes2.default.listOf(_reactImmutableProptypes2.default.mapContains({
    id: _propTypes2.default.string
  })).isRequired,
  favoritePagination: _reactImmutableProptypes2.default.map.isRequired,
  requesting: _propTypes2.default.bool.isRequired,
  CardComp: _propTypes2.default.func.isRequired
};

exports.default = CardView;

/***/ }),

/***/ "./components/_common/DropDownSelector/DropDownSelectorWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  text-align: left;\n\n  label {\n    margin-right: ', ';\n    display: ', ';\n  }\n'], ['\n  display: flex;\n  align-items: center;\n  text-align: left;\n\n  label {\n    margin-right: ', ';\n    display: ', ';\n  }\n']);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var DropDownSelectorWrapper = function () {
  var c = _styledComponents2.default.div(_templateObject, (0, _decisivUiUtils.px2rem)(8), function (props) {
    return props.hideLabel ? 'none' : 'inherit';
  });

  c.displayName = 'DropDownSelectorWrapper';
  return c;
}();

exports.default = DropDownSelectorWrapper;

/***/ }),

/***/ "./components/_common/DropDownSelector/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _DropDown = __webpack_require__("./elements/DropDown/index.js");

var _DropDown2 = _interopRequireDefault(_DropDown);

var _DropDownSelectorWrapper = __webpack_require__("./components/_common/DropDownSelector/DropDownSelectorWrapper.js");

var _DropDownSelectorWrapper2 = _interopRequireDefault(_DropDownSelectorWrapper);

var _messages = __webpack_require__("./components/_common/DropDownSelector/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DropDownSelector(_ref) {
  var label = _ref.label,
      onChange = _ref.onChange,
      options = _ref.options,
      placeholder = _ref.placeholder,
      selected = _ref.selected;

  return _react2.default.createElement(
    _DropDownSelectorWrapper2.default,
    null,
    _react2.default.createElement(
      'label',
      { htmlFor: 'options-selector' },
      _react2.default.createElement(_linguiReact.Trans, { id: label })
    ),
    _react2.default.createElement(_DropDown2.default, {
      name: 'options-selector',
      onChange: onChange,
      options: options,
      placeholder: placeholder,
      value: selected
    })
  );
}

DropDownSelector.propTypes = {
  label: _propTypes2.default.string,
  options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    value: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.string.isRequired
  })).isRequired,
  placeholder: _propTypes2.default.string.isRequired,
  selected: _propTypes2.default.shape({
    value: _propTypes2.default.string,
    label: _propTypes2.default.string
  }),
  onChange: _propTypes2.default.func.isRequired
};

DropDownSelector.defaultProps = {
  label: _messages2.default.label,
  placeholder: 'Select...',
  selected: undefined
};

exports.default = DropDownSelector;

/***/ }),

/***/ "./components/_common/DropDownSelector/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  label: (0, _linguiReact.i18nMark)('OPTIONS:')
};

exports.default = messages;

/***/ }),

/***/ "./components/_common/ETR/Wrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getColor = getColor;

var _moment = __webpack_require__("../node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getColor(_ref) {
  var etr = _ref.etr,
      theme = _ref.theme;

  if (!etr) return '';

  var etrTime = (0, _moment2.default)(etr);
  var nowTime = (0, _moment2.default)(new Date());
  var secondsInDay = 86400;
  var diffSeconds = etrTime.diff(nowTime, 'seconds');

  switch (true) {
    case diffSeconds <= 0:
      return 'color: ' + theme.colors.status.danger + ';';
    case diffSeconds > 0 && diffSeconds <= secondsInDay:
      return 'color: ' + theme.colors.status.warning + ';';
    case diffSeconds > secondsInDay:
    default:
      return 'color: ' + theme.colors.status.success + ';';
  }
}

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  ' + getColor(props) + '\n  display: inline-block;\n  font-weight: 500;\n  max-width: ' + props.maxWidth + ';\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    status: _propTypes2.default.shape({
      danger: _propTypes2.default.string.isRequired,
      success: _propTypes2.default.string.isRequired,
      warning: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

var propTypes = {
  etr: _propTypes2.default.string,
  maxWidth: _propTypes2.default.string
};

var defaultProps = {
  etr: '',
  maxWidth: '0'
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Wrapper', _styledComponents2.default.span, styles, { defaultProps: defaultProps, propTypes: propTypes, themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/_common/ETR/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactImmutableProptypes = __webpack_require__("../node_modules/react-immutable-proptypes/dist/ImmutablePropTypes.js");

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _timeUtils = __webpack_require__("./utils/timeUtils.js");

var _widget = __webpack_require__("./utils/widget.js");

var _Wrapper = __webpack_require__("./components/_common/ETR/Wrapper.js");

var _Wrapper2 = _interopRequireDefault(_Wrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ETR(_ref) {
  var caseInfo = _ref.caseInfo,
      maxWidth = _ref.maxWidth;

  var etr = caseInfo.get('etr');
  var formattedTime = etr ? (0, _timeUtils.formatDate)(etr) : '';

  return _react2.default.createElement(
    _Wrapper2.default,
    { etr: etr, maxWidth: maxWidth },
    (0, _widget.getOutputText)(formattedTime)
  );
}

ETR.defaultProps = {
  maxWidth: 'none'
};

ETR.propTypes = {
  caseInfo: _reactImmutableProptypes2.default.contains({
    etr: _propTypes2.default.string
  }).isRequired,
  maxWidth: _propTypes2.default.string
};

exports.default = ETR;

/***/ }),

/***/ "./components/_common/FollowUpLabel/FollowUpValue.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  color: ' + props.theme.colors.base.text + ';\n  font-size: ' + (0, _decisivUiUtils.px2rem)(10) + ';\n  margin-left: ' + (0, _decisivUiUtils.px2rem)(6) + ';\n  text-transform: capitalize;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('FollowUpValue', _styledComponents2.default.span, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/_common/FollowUpLabel/Wrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getColor = getColor;

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getColor(_ref) {
  var color = _ref.color,
      theme = _ref.theme;

  switch (color) {
    case 'yellow':
      return theme.colors.status.warning;
    case 'red':
      return theme.colors.status.danger;
    case 'green':
    default:
      return theme.colors.status.success;
  }
}

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  align-items: center;\n  color: ' + getColor(props) + ';\n  display: flex;\n  font-size: ' + (0, _decisivUiUtils.px2rem)(16) + ';\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    status: _propTypes2.default.shape({
      danger: _propTypes2.default.string.isRequired,
      success: _propTypes2.default.string.isRequired,
      warning: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

var propTypes = {
  color: _propTypes2.default.string
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Wrapper', _styledComponents2.default.div, styles, { propTypes: propTypes, themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/_common/FollowUpLabel/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactFontawesome = __webpack_require__("../node_modules/react-fontawesome/lib/index.js");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _momentTimezone = __webpack_require__("../node_modules/moment-timezone/index.js");

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _decisivDomainUtils = __webpack_require__("../node_modules/decisiv-domain-utils/build/index.js");

var _timeUtils = __webpack_require__("./utils/timeUtils.js");

var _widget = __webpack_require__("./utils/widget.js");

var _Wrapper = __webpack_require__("./components/_common/FollowUpLabel/Wrapper.js");

var _Wrapper2 = _interopRequireDefault(_Wrapper);

var _FollowUpValue = __webpack_require__("./components/_common/FollowUpLabel/FollowUpValue.js");

var _FollowUpValue2 = _interopRequireDefault(_FollowUpValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FollowUpLabel(_ref) {
  var followUpColor = _ref.followUpColor,
      followUpTime = _ref.followUpTime;

  var timeLabel = followUpTime && _react2.default.createElement(_decisivDomainUtils.FormattedRelative, {
    render: function render(relativeTime) {
      return _react2.default.createElement(
        'span',
        null,
        relativeTime
      );
    },
    value: _momentTimezone2.default.tz(followUpTime, (0, _timeUtils.userTimeZone)())
  });

  return _react2.default.createElement(
    _Wrapper2.default,
    { color: followUpColor },
    _react2.default.createElement(_reactFontawesome2.default, { name: 'flag' }),
    _react2.default.createElement(
      _FollowUpValue2.default,
      null,
      (0, _widget.getOutputText)(timeLabel)
    )
  );
}

FollowUpLabel.propTypes = {
  followUpColor: _propTypes2.default.string,
  followUpTime: _propTypes2.default.string
};

FollowUpLabel.defaultProps = {
  followUpColor: '',
  followUpTime: ''
};

exports.default = FollowUpLabel;

/***/ }),

/***/ "./components/_common/GhostIndicator/GhostAnimation.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  0% {\n    background-position: 0% 50%;\n  }\n  50% {\n    background-position: 100% 51%;\n  }\n  100% {\n    background-position: 0% 50%;\n  }\n'], ['\n  0% {\n    background-position: 0% 50%;\n  }\n  50% {\n    background-position: 100% 51%;\n  }\n  100% {\n    background-position: 0% 50%;\n  }\n']);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var GhostAnimation = (0, _styledComponents.keyframes)(_templateObject);

exports.default = GhostAnimation;

/***/ }),

/***/ "./components/_common/GhostIndicator/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _GhostAnimation = __webpack_require__("./components/_common/GhostIndicator/GhostAnimation.js");

var _GhostAnimation2 = _interopRequireDefault(_GhostAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  bottomGap: function bottomGap() {
    return {
      styles: 'margin-bottom: ' + (0, _decisivUiUtils.px2rem)(30) + ';'
    };
  },

  dark: function dark(_ref) {
    var theme = _ref.theme;
    return {
      styles: '\n      background: linear-gradient(90deg, ' + theme.colors.base.chrome200 + ' 0%, ' + theme.colors.base.chrome300 + ' 16.42%, ' + theme.colors.base.chrome200 + ' 100%);\n    '
    };
  },

  expanded: function expanded() {
    return {
      styles: '\n      height: ' + (0, _decisivUiUtils.px2rem)(23) + ';\n      margin: ' + (0, _decisivUiUtils.px2rem)(12) + ' ' + (0, _decisivUiUtils.px2rem)(5) + ';\n    '
    };
  },

  rightGap: function rightGap() {
    return {
      styles: 'margin-right: ' + (0, _decisivUiUtils.px2rem)(13) + ';'
    };
  },

  smallWidth: function smallWidth() {
    return {
      styles: '\n      flex: none;\n      width: ' + (0, _decisivUiUtils.px2rem)(20) + ';\n    '
    };
  },
  wide: function wide() {
    return {
      styles: '\n      width: 80%;\n    '
    };
  }
};

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  animation: ' + _GhostAnimation2.default + ' 2s ease infinite;\n  background-size: 600% 600% !important;\n  background: linear-gradient(90deg, ' + props.theme.colors.base.chrome100 + ' 0%, ' + props.theme.colors.base.chrome200 + ' 24.85%, ' + props.theme.colors.base.chrome100 + ' 100%);\n  border-radius: ' + (0, _decisivUiUtils.px2rem)(2) + ';\n  height: ' + (0, _decisivUiUtils.px2rem)(20) + ';\n  margin: ' + (0, _decisivUiUtils.px2rem)(7) + ' ' + (0, _decisivUiUtils.px2rem)(2) + ';\n  max-width: 100%;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome100: _propTypes2.default.string.isRequired,
      chrome200: _propTypes2.default.string.isRequired,
      chrome300: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('GhostIndicator', _styledComponents2.default.div, styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/_common/InlineEditableField/Button/Wrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var modifierConfig = {
  cancel: function cancel(_ref) {
    var theme = _ref.theme;
    return {
      styles: '\n      &:hover {\n        background-color: ' + theme.colors.status.danger + ';\n        border: 1px solid ' + theme.colors.status.danger + ';\n        span {\n          color: ' + theme.colors.base.chrome100 + ';\n        }\n      }\n    '
    };
  },
  edit: function edit(_ref2) {
    var theme = _ref2.theme;
    return {
      styles: '\n      background-color: ' + theme.colors.base.chrome100 + ';\n      color: ' + theme.colors.brand.secondary + ';\n      span {\n        color: ' + theme.colors.base.chrome500 + ';\n      }\n    '
    };
  },
  loading: function loading(_ref3) {
    var theme = _ref3.theme;
    return {
      styles: '\n      .fa {\n        animation: ' + theme.animations.spin + ' 0.8s linear infinite;\n      }\n    '
    };
  },
  submit: function submit(_ref4) {
    var theme = _ref4.theme;
    return {
      styles: '\n      &:hover {\n        background-color: ' + theme.colors.status.success + ';\n        border: 1px solid ' + theme.colors.status.success + ';\n        span {\n          color: ' + theme.colors.base.chrome100 + ';\n        }\n      }\n    '
    };
  }
};

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  align-items: center;\n  background-color: ' + props.theme.colors.base.chrome100 + ';\n  border-radius: 2px;\n  border: 1px solid ' + props.theme.colors.base.chrome300 + ';\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  margin: 0;\n  width: ' + (0, _decisivUiUtils.px2rem)(31) + ';\n\n  span {\n    color: ' + props.theme.colors.base.chrome500 + ';\n    font-size: ' + (0, _decisivUiUtils.px2rem)(17) + ';\n    margin: auto;\n  }\n';
};

var themePropTypes = {
  animations: _propTypes2.default.shape({
    spin: _propTypes2.default.string.isRequired
  }).isRequired,
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome100: _propTypes2.default.string.isRequired,
      chrome300: _propTypes2.default.string.isRequired,
      chrome500: _propTypes2.default.string.isRequired
    }).isRequired,
    brand: _propTypes2.default.shape({
      secondary: _propTypes2.default.string.isRequired
    }).isRequired,
    status: _propTypes2.default.shape({
      danger: _propTypes2.default.string.isRequired,
      success: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Wrapper', _styledComponents2.default.button, styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/_common/InlineEditableField/Button/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ICON_MAP = undefined;

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactFontawesome = __webpack_require__("../node_modules/react-fontawesome/lib/index.js");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _Wrapper = __webpack_require__("./components/_common/InlineEditableField/Button/Wrapper.js");

var _Wrapper2 = _interopRequireDefault(_Wrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ICON_MAP = exports.ICON_MAP = {
  edit: 'pencil',
  submit: 'check',
  cancel: 'close',
  loading: 'refresh'
};

function Button(_ref) {
  var type = _ref.type,
      onClick = _ref.onClick;

  return _react2.default.createElement(
    _Wrapper2.default,
    { modifiers: [type], onClick: onClick },
    _react2.default.createElement(_reactFontawesome2.default, { name: ICON_MAP[type] })
  );
}

Button.propTypes = {
  type: _propTypes2.default.string.isRequired,
  onClick: _propTypes2.default.func.isRequired
};

exports.default = Button;

/***/ }),

/***/ "./components/_common/InlineEditableField/ButtonWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n'], ['\n  display: flex;\n']);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ButtonWrapper = function () {
  var c = _styledComponents2.default.div(_templateObject);

  c.displayName = 'ButtonWrapper';
  return c;
}();

exports.default = ButtonWrapper;

/***/ }),

/***/ "./components/_common/InlineEditableField/Input.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var modifierConfig = {
  isHovered: function isHovered(_ref) {
    var theme = _ref.theme;
    return {
      styles: '\n      border: 1px solid;\n      border-color: ' + theme.colors.base.chrome300 + ';\n      padding-left: ' + (0, _decisivUiUtils.px2rem)(5) + ';\n    '
    };
  },
  isFocused: function isFocused(_ref2) {
    var theme = _ref2.theme;
    return {
      styles: '\n      border: 1px solid;\n      border-color: ' + theme.colors.base.chrome300 + ';\n      padding-left: ' + (0, _decisivUiUtils.px2rem)(5) + ';\n    '
    };
  }
};

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  border: 0px;\n  border-radius: 2px;\n  height: ' + (0, _decisivUiUtils.px2rem)(26) + ';\n  padding-right: ' + (0, _decisivUiUtils.px2rem)(5) + ';\n  padding-left: ' + (0, _decisivUiUtils.px2rem)(0) + ';\n  width: ' + (0, _decisivUiUtils.px2rem)(150) + ';\n  &:hover {\n    cursor: text;\n  }\n  &:focus {\n    border-color: ' + props.theme.colors.base.chrome300 + ';\n  }\n  &::placeholder {\n    font-weight: 200;\n    font-style: italic;\n    font-color: ' + props.theme.colors.base.chrome500 + ';\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome300: _propTypes2.default.string.isRequired,
      chrome500: _propTypes2.default.string.isRequired
    }).isRequired,
    brand: _propTypes2.default.shape({
      secondary: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Input', _styledComponents2.default.input, styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/_common/InlineEditableField/Wrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  display: inline-flex;\n'], ['\n  display: inline-flex;\n']);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = function () {
  var c = _styledComponents2.default.div(_templateObject);

  c.displayName = 'Wrapper';
  return c;
}();

exports.default = Wrapper;

/***/ }),

/***/ "./components/_common/InlineEditableField/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InlineEditableField = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactClickOutside = __webpack_require__("../node_modules/react-click-outside/dist/index.js");

var _reactClickOutside2 = _interopRequireDefault(_reactClickOutside);

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _Wrapper = __webpack_require__("./components/_common/InlineEditableField/Wrapper.js");

var _Wrapper2 = _interopRequireDefault(_Wrapper);

var _Input = __webpack_require__("./components/_common/InlineEditableField/Input.js");

var _Input2 = _interopRequireDefault(_Input);

var _Button = __webpack_require__("./components/_common/InlineEditableField/Button/index.js");

var _Button2 = _interopRequireDefault(_Button);

var _ButtonWrapper = __webpack_require__("./components/_common/InlineEditableField/ButtonWrapper.js");

var _ButtonWrapper2 = _interopRequireDefault(_ButtonWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InlineEditableField = exports.InlineEditableField = function (_Component) {
  _inherits(InlineEditableField, _Component);

  function InlineEditableField() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, InlineEditableField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InlineEditableField.__proto__ || Object.getPrototypeOf(InlineEditableField)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isHovered: false,
      isFocused: false,
      isSubmitting: false
    }, _this.onEnter = function () {
      _this.setState({ isHovered: true });
    }, _this.onEdit = function () {
      _this.textInput.focus();
    }, _this.onLeave = function () {
      _this.setState({ isHovered: false });
    }, _this.onFocus = function () {
      _this.setState({ isFocused: true });
      _this.props.getInitialValue(_this.props.value);
    }, _this.onKeyPress = function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        e.target.blur();

        _this.submitValue();
      }
    }, _this.onCancel = function () {
      _this.setState({
        isFocused: false,
        isHovered: false
      });

      _this.props.onUpdate(false);
    }, _this.onSubmit = function () {
      _this.submitValue();
    }, _this.handleClickOutside = function () {
      if (_this.state.isFocused) {
        _this.setState({ isFocused: false });
        _this.submitValue();
      }
    }, _this.submitValue = function () {
      _this.setState({
        isFocused: false,
        isHovered: false
      });

      _this.props.onUpdate(true);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(InlineEditableField, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        this.setState({
          isSubmitting: false
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          isHovered = _state.isHovered,
          isFocused = _state.isFocused,
          isSubmitting = _state.isSubmitting;


      return _react2.default.createElement(
        _Wrapper2.default,
        {
          onMouseEnter: this.onEnter,
          onMouseLeave: this.onLeave
        },
        _react2.default.createElement(_Input2.default, _extends({}, this.props, {
          modifiers: (0, _lodash.compact)([isHovered && 'isHovered', isFocused && 'isFocused']),
          placeholder: 'Edit',
          value: this.props.value,
          innerRef: function innerRef(input) {
            _this2.textInput = input;
          },
          disabled: isSubmitting,
          onFocus: this.onFocus,
          onKeyPress: this.onKeyPress
        })),
        isSubmitting && _react2.default.createElement(_Button2.default, { type: 'loading', onClick: this.onCancel }),
        !isSubmitting && isHovered && !isFocused && _react2.default.createElement(_Button2.default, { type: 'edit', onClick: this.onEdit }),
        !isSubmitting && isFocused && _react2.default.createElement(
          _ButtonWrapper2.default,
          null,
          _react2.default.createElement(_Button2.default, { type: 'cancel', onClick: this.onCancel }),
          _react2.default.createElement(_Button2.default, { type: 'submit', onClick: this.onSubmit })
        )
      );
    }
  }]);

  return InlineEditableField;
}(_react.Component);

InlineEditableField.propTypes = {
  value: _propTypes2.default.string.isRequired,
  onUpdate: _propTypes2.default.func.isRequired,
  getInitialValue: _propTypes2.default.func.isRequired
};
exports.default = (0, _reactClickOutside2.default)(InlineEditableField);

/***/ }),

/***/ "./components/_common/ListRowLoading/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _baseComponents = __webpack_require__("../node_modules/base-components/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ghostColumns(_ref) {
  var columnSpans = _ref.columnSpans;

  return columnSpans.map(function (columnSpan, index) {
    return (
      // eslint-disable-next-line react/no-array-index-key
      _react2.default.createElement(
        _baseComponents.ListTable.Data,
        { flex: columnSpan, key: index, modifiers: ['flexRow'] },
        _react2.default.createElement(_baseComponents.GhostIndicator, null)
      )
    );
  });
}

function ListRowLoading(_ref2) {
  var columnSpans = _ref2.columnSpans;

  return _react2.default.createElement(
    _baseComponents.ListTable.Row,
    null,
    ghostColumns({ columnSpans: columnSpans })
  );
}

ListRowLoading.propTypes = {
  columnSpans: _propTypes2.default.arrayOf(_propTypes2.default.number).isRequired
};

exports.default = ListRowLoading;

/***/ }),

/***/ "./components/_common/Overlay/Background.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  background-color: ' + props.theme.colors.base.overlay + ';\n  height: 100%;\n  position: absolute;\n  width: 100%;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      overlay: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Background', _styledComponents2.default.section, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./components/_common/Overlay/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _Background = __webpack_require__("./components/_common/Overlay/Background.js");

var _Background2 = _interopRequireDefault(_Background);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Overlay = function (_Component) {
  _inherits(Overlay, _Component);

  function Overlay() {
    _classCallCheck(this, Overlay);

    return _possibleConstructorReturn(this, (Overlay.__proto__ || Object.getPrototypeOf(Overlay)).apply(this, arguments));
  }

  _createClass(Overlay, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.body.style.overflow = 'hidden';
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.body.style.overflow = 'auto';
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_Background2.default, this.props);
    }
  }]);

  return Overlay;
}(_react.Component);

exports.default = Overlay;

/***/ }),

/***/ "./components/_common/paginateFavorites/ButtonContainer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  padding: 0.5rem;\n'], ['\n  padding: 0.5rem;\n']);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/* istanbul ignore next */
var ButtonContainer = function () {
  var c = _styledComponents2.default.div(_templateObject);

  c.displayName = 'ButtonContainer';
  return c;
}();

exports.default = ButtonContainer;

/***/ }),

/***/ "./components/_common/paginateFavorites/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.showLoadMoreButton = showLoadMoreButton;
exports.shouldRequestNext = shouldRequestNext;

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactImmutableProptypes = __webpack_require__("../node_modules/react-immutable-proptypes/dist/ImmutablePropTypes.js");

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _NoFavoritesPanel = __webpack_require__("./components/NoFavoritesPanel/index.js");

var _NoFavoritesPanel2 = _interopRequireDefault(_NoFavoritesPanel);

var _RectangleButton = __webpack_require__("./elements/RectangleButton/index.js");

var _RectangleButton2 = _interopRequireDefault(_RectangleButton);

var _document = __webpack_require__("./utils/document.js");

var _ButtonContainer = __webpack_require__("./components/_common/paginateFavorites/ButtonContainer.js");

var _ButtonContainer2 = _interopRequireDefault(_ButtonContainer);

var _messages = __webpack_require__("./components/_common/paginateFavorites/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Evaluates pagination data to determine if the "Load More" button should be displayed.
 * @param  {Map} favoritePagination An Immutable Map with pagination data.
 * @return {Boolean}
 */
function showLoadMoreButton(favoritePagination) {
  var latestPage = parseInt(favoritePagination.get('latestPage'), 10);
  var totalPages = parseInt(favoritePagination.get('totalPages'), 10);
  return latestPage >= 3 && totalPages > latestPage;
}

/**
 * Evaluates pagination and scroll information from the document body to determine if
 * a scroll event should make the next request for the favorites
 * @param  {Object} componentProps The props of the calling component. Required keys:
 * favoritePagination, requestInProgress
 * @param  {Object} document The data held at document.body.
 * @return {Boolean}
 */
function shouldRequestNext(_ref, document) {
  var favoritePagination = _ref.favoritePagination,
      requestInProgress = _ref.requestInProgress;

  var latestPage = parseInt(favoritePagination.get('latestPage'), 10);
  var totalPages = parseInt(favoritePagination.get('totalPages'), 10);
  var viewingSecondHalf = (0, _document.getScrollTop)(document) > document.body.scrollHeight / 2;

  return !requestInProgress && totalPages > latestPage && (latestPage === 1 || latestPage === 2 && viewingSecondHalf);
}

/**
 * An HOC that wraps a favorite view component and provides pagination per the specs outlined here:
 * https://decisiv.atlassian.net/browse/UI-192
 * @param  {Object} paginationParams Contains pagination methods. Required keys:
 * requestNext,
 * @param  {Component} FavoritesView A react component that renders the favorites.
 * @return {Component} The favorites view with pagination helpers.
 */
var paginateFavorites = function paginateFavorites(_ref2) {
  var requestNext = _ref2.requestNext;
  return function (FavoritesView) {
    var _class, _temp2;

    return _temp2 = _class = function (_Component) {
      _inherits(FavoritesPaginator, _Component);

      function FavoritesPaginator() {
        var _ref3;

        var _temp, _this, _ret;

        _classCallCheck(this, FavoritesPaginator);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref3 = FavoritesPaginator.__proto__ || Object.getPrototypeOf(FavoritesPaginator)).call.apply(_ref3, [this].concat(args))), _this), _this.scrollEventHandler = function () {
          if (shouldRequestNext(_this.props, document)) {
            _this.props.requestNext(_this.props.favoritePagination);
          }
        }, _temp), _possibleConstructorReturn(_this, _ret);
      }

      _createClass(FavoritesPaginator, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
          this.scrollEventListener = (0, _lodash.throttle)(this.scrollEventHandler, this.props.DEBOUNCE_TIME_MS);
        }
      }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
          window.addEventListener('scroll', this.scrollEventListener);
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          window.removeEventListener('scroll', this.scrollEventListener);
        }
      }, {
        key: 'render',
        value: function render() {
          var _this2 = this;

          var _props = this.props,
              noFavoritesMessage = _props.noFavoritesMessage,
              requestInProgress = _props.requestInProgress;

          var disabled = requestInProgress && 'disabled';
          var totalCount = this.props.favoritePagination.get('totalCount');
          var isEmpty = !requestInProgress && totalCount === '0';

          if (isEmpty) {
            return _react2.default.createElement(_NoFavoritesPanel2.default, { filter: noFavoritesMessage });
          }

          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(FavoritesView, this.props.componentProps),
            showLoadMoreButton(this.props.favoritePagination) && _react2.default.createElement(
              _ButtonContainer2.default,
              null,
              _react2.default.createElement(
                _RectangleButton2.default,
                {
                  disabled: disabled,
                  modifiers: (0, _lodash.compact)([disabled, 'fullWidth', 'hoverBrandBright', 'hoverUnderline', 'offWhite', 'small']),
                  onClick: function onClick() {
                    _this2.props.requestNext(_this2.props.favoritePagination);
                  }
                },
                _react2.default.createElement(
                  _RectangleButton.RectangleButtonText,
                  { modifiers: ['uppercase'] },
                  _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.loadMore })
                )
              )
            )
          );
        }
      }]);

      return FavoritesPaginator;
    }(_react.Component), _class.propTypes = {
      // This component doesn't care what is in componentProps, only that it is an object.
      // eslint-disable-next-line react/forbid-prop-types
      componentProps: _propTypes2.default.object.isRequired,

      DEBOUNCE_TIME_MS: _propTypes2.default.number.isRequired,

      favoritePagination: _reactImmutableProptypes2.default.map.isRequired,
      noFavoritesMessage: _propTypes2.default.string.isRequired,

      // requesting is passed through to shouldRequestNext and should not set a lint error
      requestInProgress: _propTypes2.default.bool.isRequired,

      requestNext: _propTypes2.default.func.isRequired
    }, _class.defaultProps = {
      DEBOUNCE_TIME_MS: 250,
      requestNext: requestNext,
      latestFavorite: {},
      noFavoritesMessage: ''
    }, _temp2;
  };
};

exports.default = paginateFavorites;

/***/ }),

/***/ "./components/_common/paginateFavorites/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  loadMore: (0, _linguiReact.i18nMark)('Load More')
};

exports.default = messages;

/***/ }),

/***/ "./components/_common/withCollapsedState/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _WindowQuery = __webpack_require__("./components/WindowQuery/index.js");

var _WindowQuery2 = _interopRequireDefault(_WindowQuery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var withCollapsedState = function withCollapsedState(WrappedComponent) {
  var AddCollapsedStateToProps = function (_Component) {
    _inherits(AddCollapsedStateToProps, _Component);

    function AddCollapsedStateToProps() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, AddCollapsedStateToProps);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AddCollapsedStateToProps.__proto__ || Object.getPrototypeOf(AddCollapsedStateToProps)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        collapsed: true
      }, _this.onResizeWindow = function (_ref2) {
        var windowWidth = _ref2.windowWidth;

        _this.updateCollapsedState(windowWidth);
      }, _this.updateCollapsedState = function (windowWidth) {
        var autoCollapseLeftNavPx = _this.props.theme.dimensions.autoCollapseLeftNavPx;


        _this.setState({ collapsed: windowWidth < autoCollapseLeftNavPx });
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(AddCollapsedStateToProps, [{
      key: 'componentDidMount',


      /**
       * On initial mount, update collapsed state based on window size.
       * @return {undefined} This method is expected to trigger a state mutation, not return a value.
       */
      value: function componentDidMount() {
        this.updateCollapsedState(window.innerWidth);
      }

      /**
       * event handler for resizing the window
       * @param  {number} windowWidth  The width of the window after resizing.
       * @return {undefined} This method is expected to mutate state, not return a value.
       */


      /**
       * Sets a new value for this.state.collapsed based on the current window width
       * @param  {number} windowWidth  The width of the window to be used in determining the collapsed
       * state
       * @return {undefined} This method is expected to mutate state, not return a value.
       */

    }, {
      key: 'render',
      value: function render() {
        var componentProps = (0, _lodash.omit)(this.props, 'theme');

        return _react2.default.createElement(
          _WindowQuery2.default,
          { onResize: this.onResizeWindow },
          _react2.default.createElement(WrappedComponent, _extends({ collapsed: this.state.collapsed }, componentProps))
        );
      }
    }]);

    return AddCollapsedStateToProps;
  }(_react.Component);

  AddCollapsedStateToProps.propTypes = {
    theme: _propTypes2.default.shape({
      dimensions: _propTypes2.default.shape({
        autoCollapseLeftNavPx: _propTypes2.default.number.isRequired
      }).isRequired
    }).isRequired
  };


  return (0, _styledComponents.withTheme)(AddCollapsedStateToProps);
};

exports.default = withCollapsedState;

/***/ }),

/***/ "./compositions/AddNoteButton/Container.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _actions = __webpack_require__("./redux/ui/actions.js");

var _immutableToJS = __webpack_require__("./utils/immutableToJS.js");

var _immutableToJS2 = _interopRequireDefault(_immutableToJS);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var withConnectedData = function withConnectedData(WrappedComponent) {
  function WithConnectedData(props) {
    return _react2.default.createElement(WrappedComponent, props);
  }

  WithConnectedData.propTypes = {
    handleActionBarItemClick: _propTypes2.default.func.isRequired
  };

  function mapStateToProps() {
    return {};
  }

  function mapDispatchToProps(dispatch) {
    return {
      handleActionBarItemClick: function handleActionBarItemClick(payload) {
        return dispatch((0, _actions.handleActionBarItemClick)(payload));
      }
    };
  }

  return (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _immutableToJS2.default)(WithConnectedData));
};

exports.default = withConnectedData;

/***/ }),

/***/ "./compositions/AddNoteButton/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddNoteButton = AddNoteButton;

var _baseComponents = __webpack_require__("../node_modules/base-components/build/index.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _messages = __webpack_require__("./compositions/AddNoteButton/messages.js");

var _messages2 = _interopRequireDefault(_messages);

var _Container = __webpack_require__("./compositions/AddNoteButton/Container.js");

var _Container2 = _interopRequireDefault(_Container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BUTTON_ID = 'ADD_NOTE';

function AddNoteButton(_ref) {
  var handleActionBarItemClick = _ref.handleActionBarItemClick;

  return _react2.default.createElement(
    _baseComponents.QuickActionButton,
    { onClick: function onClick() {
        return handleActionBarItemClick({ buttonId: BUTTON_ID });
      } },
    _react2.default.createElement(_baseComponents.QuickActionButton.Icon, { modifiers: ['left'], name: 'envelope-o' }),
    _react2.default.createElement(
      _baseComponents.QuickActionButton.Text,
      null,
      _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.title })
    )
  );
}

AddNoteButton.propTypes = {
  handleActionBarItemClick: _propTypes2.default.func.isRequired
};

exports.default = (0, _Container2.default)(AddNoteButton);

/***/ }),

/***/ "./compositions/AddNoteButton/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  title: (0, _linguiReact.i18nMark)('Add Note')
};

exports.default = messages;

/***/ }),

/***/ "./compositions/AssetOverview/Container.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _reactRouterDom = __webpack_require__("../node_modules/react-router-dom/es/index.js");

var _actions = __webpack_require__("./redux/app/actions.js");

var _selectors = __webpack_require__("./redux/assets/selectors.js");

var _immutableToJS = __webpack_require__("./utils/immutableToJS.js");

var _immutableToJS2 = _interopRequireDefault(_immutableToJS);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var withConnectedData = function withConnectedData(WrappedComponent) {
  function Container(props) {
    return _react2.default.createElement(WrappedComponent, props);
  }

  Container.propTypes = {
    assetInfo: _propTypes2.default.shape({
      make: _propTypes2.default.string,
      model: _propTypes2.default.string,
      severityColor: _propTypes2.default.string,
      severityCount: _propTypes2.default.string,
      vinNumber: _propTypes2.default.string,
      year: _propTypes2.default.string
    }).isRequired,
    location: _propTypes2.default.shape({
      pathname: _propTypes2.default.string.isRequired
    }).isRequired,
    addPageToBreadcrumbs: _propTypes2.default.func.isRequired
  };

  Container.defaultProps = {
    assetInfo: {}
  };

  function mapStateToProps(state) {
    return {
      assetInfo: (0, _selectors.currentAssetSelector)(state)
    };
  }

  function mapDispatchToProps(dispatch) {
    return {
      addPageToBreadcrumbs: function addPageToBreadcrumbs(breadcrumbs) {
        return dispatch((0, _actions.addPageToBreadcrumbs)(breadcrumbs));
      }
    };
  }

  return (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactRouterDom.withRouter)((0, _immutableToJS2.default)(Container)));
};

exports.default = withConnectedData;

/***/ }),

/***/ "./compositions/AssetOverview/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AssetOverview = AssetOverview;

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/styled-components-reactive-grid/dist/index.js");

var _recompose = __webpack_require__("../node_modules/recompose/es/Recompose.js");

var _SeverityLabel = __webpack_require__("./components/SeverityLabel/index.js");

var _SeverityLabel2 = _interopRequireDefault(_SeverityLabel);

var _BreadCrumbLink = __webpack_require__("./compositions/BreadCrumbLink/index.js");

var _BreadCrumbLink2 = _interopRequireDefault(_BreadCrumbLink);

var _PageHeadingPanel = __webpack_require__("./elements/PageHeadingPanel/index.js");

var _PageHeadingPanel2 = _interopRequireDefault(_PageHeadingPanel);

var _Table = __webpack_require__("./elements/Table/index.js");

var _Table2 = _interopRequireDefault(_Table);

var _asset = __webpack_require__("./utils/asset.js");

var _widget = __webpack_require__("./utils/widget.js");

var _Container = __webpack_require__("./compositions/AssetOverview/Container.js");

var _Container2 = _interopRequireDefault(_Container);

var _messages = __webpack_require__("./compositions/AssetOverview/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AssetOverview(_ref) {
  var _ref$assetInfo = _ref.assetInfo,
      make = _ref$assetInfo.make,
      model = _ref$assetInfo.model,
      severityColor = _ref$assetInfo.severityColor,
      severityCount = _ref$assetInfo.severityCount,
      vinNumber = _ref$assetInfo.vinNumber,
      year = _ref$assetInfo.year;

  // NOTE: The extra padding on top is required to correct other display issues on this page.
  // This must be removed when this component is exported to a composition, and brought in via
  // the config file.
  return _react2.default.createElement(
    _PageHeadingPanel2.default,
    null,
    _react2.default.createElement(
      _styledComponentsReactiveGrid.Container,
      { id: 'asset-overview', style: { paddingTop: '16px' } },
      _react2.default.createElement(_BreadCrumbLink2.default, null),
      _react2.default.createElement(
        _styledComponentsReactiveGrid.Row,
        { modifiers: ['middle'] },
        _react2.default.createElement(
          _styledComponentsReactiveGrid.Column,
          { modifiers: ['col'] },
          _react2.default.createElement(
            _Table2.default,
            { modifiers: ['mediumGrey', 'xLargeText'] },
            _react2.default.createElement(
              'tbody',
              null,
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'th',
                  null,
                  _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.serial })
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  (0, _asset.getSerialNumber)(vinNumber, _messages2.default.serial)
                ),
                _react2.default.createElement(
                  'th',
                  null,
                  _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.make })
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  (0, _widget.getOutputText)(make)
                ),
                _react2.default.createElement(
                  'th',
                  null,
                  _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.model })
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  (0, _widget.getOutputText)(model)
                ),
                _react2.default.createElement(
                  'th',
                  null,
                  _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.year })
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  (0, _widget.getOutputText)(year)
                )
              )
            )
          )
        )
      ),
      _react2.default.createElement(
        _styledComponentsReactiveGrid.Row,
        { modifiers: ['end'] },
        _react2.default.createElement(
          _styledComponentsReactiveGrid.Column,
          null,
          _react2.default.createElement(_SeverityLabel2.default, {
            color: severityColor,
            value: Number(severityCount)
          })
        )
      )
    )
  );
}

AssetOverview.propTypes = {
  assetInfo: _propTypes2.default.shape({
    make: _propTypes2.default.string,
    model: _propTypes2.default.string,
    severityColor: _propTypes2.default.string,
    severityCount: _propTypes2.default.string,
    vinNumber: _propTypes2.default.string,
    year: _propTypes2.default.string
  }).isRequired
};

AssetOverview.defaultProps = {
  assetInfo: {
    severityColor: 'grey',
    severityCount: '0'
  }
};

exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('AssetOverview'), _Container2.default)(AssetOverview);

/***/ }),

/***/ "./compositions/AssetOverview/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  make: (0, _linguiReact.i18nMark)('Make'),
  model: (0, _linguiReact.i18nMark)('Model'),
  serial: (0, _linguiReact.i18nMark)('Serial'),
  year: (0, _linguiReact.i18nMark)('Year')
};

exports.default = messages;

/***/ }),

/***/ "./compositions/AssetSelectionStep/Container.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _recompose = __webpack_require__("../node_modules/recompose/es/Recompose.js");

var _actions = __webpack_require__("./redux/assets/actions.js");

var _selectors = __webpack_require__("./redux/assets/selectors.js");

var _immutableToJS = __webpack_require__("./utils/immutableToJS.js");

var _immutableToJS2 = _interopRequireDefault(_immutableToJS);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var withConnectedData = function withConnectedData(WrappedComponent) {
  function Container(props) {
    return _react2.default.createElement(WrappedComponent, props);
  }

  Container.propTypes = {
    assets: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      id: _propTypes2.default.string
    })).isRequired,
    currentAsset: _propTypes2.default.shape({
      id: _propTypes2.default.string
    }).isRequired,
    clearAssets: _propTypes2.default.func.isRequired,
    loadAssets: _propTypes2.default.func.isRequired,
    loadAsset: _propTypes2.default.func.isRequired,
    setCurrentAsset: _propTypes2.default.func.isRequired
  };

  function mapStateToProps(state) {
    return {
      assets: (0, _selectors.assetsSelector)(state),
      currentAsset: (0, _selectors.currentAssetSelector)(state)
    };
  }

  function mapDispatchToProps(dispatch) {
    return {
      clearAssets: function clearAssets() {
        return dispatch((0, _actions.clearAssets)());
      },
      loadAssets: function loadAssets(filter) {
        return dispatch((0, _actions.loadAssets)(filter));
      },
      loadAsset: function loadAsset(assetId) {
        return dispatch((0, _actions.loadAsset)({ assetId: assetId }));
      },
      setCurrentAsset: function setCurrentAsset(assetId) {
        return dispatch((0, _actions.setCurrentAsset)(assetId));
      }
    };
  }

  return (0, _recompose.compose)((0, _recompose.setDisplayName)('AssetSelectionStepContainer'), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _immutableToJS2.default)(Container);
};

exports.default = withConnectedData;

/***/ }),

/***/ "./compositions/AssetSelectionStep/DropdownWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var height = (0, _decisivUiUtils.px2rem)(25);

/* istanbul ignore next */
var styles = function styles(_ref) {
  var colors = _ref.theme.colors;
  return '\n  position: relative;\n  padding-left: 0;\n\n  .Select--multi {\n    &:focus {\n      outline: none;\n    }\n    .Select-control {\n      font-size: ' + (0, _decisivUiUtils.px2rem)(14) + ';\n      height: ' + height + ';\n      border: none;\n    }\n    .Select-multi-value-wrapper {\n    }\n    .Select-placeholder {\n      font-size: ' + (0, _decisivUiUtils.px2rem)(12) + ';\n      font-weight: 300;\n      line-height: ' + (0, _decisivUiUtils.px2rem)(23) + ';\n      padding-left: 0;\n      top: initial;\n      color: ' + colors.base.chrome300 + ';\n    }\n    .Select-input {\n      height: ' + height + ';\n      margin-left: 0;\n      input {\n        padding: ' + (0, _decisivUiUtils.px2rem)(5) + ' 0;\n      }\n    }\n    .Select-value {\n      border: 1px solid ' + colors.base.chrome300 + ';\n      background-color: ' + colors.base.chrome100 + ';\n      color: ' + colors.base.text + ';\n      height: ' + (0, _decisivUiUtils.px2rem)(18) + ';\n      margin-left: 0;\n      margin-top: ' + (0, _decisivUiUtils.px2rem)(4) + ';\n      pointer-events: none;\n\n      .Select-value-label {\n        font-size: ' + (0, _decisivUiUtils.px2rem)(10) + ';\n        padding-right: ' + (0, _decisivUiUtils.px2rem)(2) + ';\n        vertical-align: top;\n      }\n      .Select-value-icon {\n        border: none;\n        float: right;\n        font-size: ' + (0, _decisivUiUtils.px2rem)(20) + ';\n        height: ' + (0, _decisivUiUtils.px2rem)(15) + ';\n        line-height: ' + (0, _decisivUiUtils.px2rem)(15) + ';\n        color: ' + colors.base.chrome500 + ';\n        pointer-events: auto;\n      }\n\n      &:hover {\n        background-color: ' + colors.status.danger + ';\n        color: ' + colors.base.chrome000 + ';\n        cursor: pointer;\n        .Select-value-label {\n          text-decoration: underline;\n          cursor: inherit;\n        }\n        .Select-value-icon {\n          background-color: inherit;\n          color: ' + colors.base.chrome000 + ';\n        }\n      }\n    }\n    \n    .Select-option {\n      padding: ' + (0, _decisivUiUtils.px2rem)(4) + ';\n      font-size: ' + (0, _decisivUiUtils.px2rem)(12) + ';\n      color: ' + colors.base.text + ';\n\n      &:hover {\n        background-color: inherit;\n      }\n    }\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome000: _propTypes2.default.string.isRequired,
      chrome100: _propTypes2.default.string.isRequired,
      chrome300: _propTypes2.default.string.isRequired,
      chrome500: _propTypes2.default.string.isRequired,
      text: _propTypes2.default.string.isRequired
    }).isRequired,
    status: _propTypes2.default.shape({
      danger: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('DropdownWrapper', _styledComponents2.default.div, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./compositions/AssetSelectionStep/Option.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/styled-components-reactive-grid/dist/index.js");

var _SeverityLabel = __webpack_require__("./components/SeverityLabel/index.js");

var _SeverityLabel2 = _interopRequireDefault(_SeverityLabel);

var _StatusLabel = __webpack_require__("./components/StatusLabel/index.js");

var _StatusLabel2 = _interopRequireDefault(_StatusLabel);

var _TextDiv = __webpack_require__("./elements/TextDiv/index.js");

var _TextDiv2 = _interopRequireDefault(_TextDiv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
function Option(option) {
  var assetInfo = option.value;

  return _react2.default.createElement(
    _styledComponentsReactiveGrid.Container,
    null,
    _react2.default.createElement(
      _styledComponentsReactiveGrid.Row,
      { modifiers: ['middle'] },
      _react2.default.createElement(
        _styledComponentsReactiveGrid.Column,
        { modifiers: ['col'] },
        _react2.default.createElement(
          _TextDiv2.default,
          { modifiers: ['bold', 'darkGreyText', 'smallText'] },
          option.label
        )
      ),
      _react2.default.createElement(
        _styledComponentsReactiveGrid.Column,
        null,
        _react2.default.createElement(_SeverityLabel2.default, {
          color: assetInfo.severityColor,
          value: Number(assetInfo.severityCount)
        })
      ),
      _react2.default.createElement(
        _styledComponentsReactiveGrid.Column,
        null,
        _react2.default.createElement(_StatusLabel2.default, {
          color: assetInfo.pmStatus,
          showIcon: true
        })
      ),
      _react2.default.createElement(
        _styledComponentsReactiveGrid.Column,
        null,
        _react2.default.createElement(_StatusLabel2.default, {
          color: assetInfo.warrantyStatus,
          showIcon: true
        })
      ),
      _react2.default.createElement(
        _styledComponentsReactiveGrid.Column,
        null,
        _react2.default.createElement(_StatusLabel2.default, {
          color: assetInfo.campaignsStatus,
          showIcon: true
        })
      )
    )
  );
}

exports.default = Option;

/***/ }),

/***/ "./compositions/AssetSelectionStep/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AssetSelectionStep = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.makeOptions = makeOptions;

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = __webpack_require__("../node_modules/react-router-dom/es/index.js");

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/styled-components-reactive-grid/dist/index.js");

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _baseComponents = __webpack_require__("../node_modules/base-components/build/index.js");

var _recompose = __webpack_require__("../node_modules/recompose/es/Recompose.js");

var _Select = __webpack_require__("./elements/Select/index.js");

var _Select2 = _interopRequireDefault(_Select);

var _WizardInput = __webpack_require__("./components/WizardInput/index.js");

var _WizardInput2 = _interopRequireDefault(_WizardInput);

var _url = __webpack_require__("./utils/url.js");

var _Option = __webpack_require__("./compositions/AssetSelectionStep/Option.js");

var _Option2 = _interopRequireDefault(_Option);

var _DropdownWrapper = __webpack_require__("./compositions/AssetSelectionStep/DropdownWrapper.js");

var _DropdownWrapper2 = _interopRequireDefault(_DropdownWrapper);

var _Container = __webpack_require__("./compositions/AssetSelectionStep/Container.js");

var _Container2 = _interopRequireDefault(_Container);

var _messages = __webpack_require__("./compositions/AssetSelectionStep/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Component has props and state which need clarification to avoid a confusion
 *
 * 1. this.props.currentAsset: It is the current asset stored in redux.
 *  When you were on asset detail page before you click `Request Service` it has asset detail
 *  in currentAsset under asset reducer
 *
 * 2. this.props.initialAsset: It is the asset selected already. Suppose you selected an asset
 *  and clicked next. Now you clicked prev button to be back to AssetSelectionStep page.
 *  initialAsset is given and it allows this step show asset selected which you selected before.
 *
 * 3. this.state.selectedAsset: This is simply an asset selected on this step.
 *  The difference comparing to this.props.initialAsset, it changes whenever you select an asset
 *  on this step. initialAsset is changed when you go to next step.
 *  Also state selectedAsset keeps the initialAsseet as a default one to actually show
 *  it is selected.
 */

function makeOptions(assets) {
  return assets.map(function (asset) {
    return {
      label: asset.unitNumber + ' ' + asset.make + ' - ' + asset.model + ' - ' + asset.engine + ' - ' + asset.year,
      value: asset
    };
  });
}

var AssetSelectionStep = exports.AssetSelectionStep = function (_Component) {
  _inherits(AssetSelectionStep, _Component);

  function AssetSelectionStep() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AssetSelectionStep);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AssetSelectionStep.__proto__ || Object.getPrototypeOf(AssetSelectionStep)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      selectedAsset: _this.props.initialAsset && makeOptions([_this.props.initialAsset]),
      options: makeOptions(_this.props.assets)
    }, _this.getAssetId = function () {
      var queries = (0, _url.parseQueryParams)(_this.props.location.search);
      var assetId = queries.assetId;

      return assetId;
    }, _this.loadItems = function (value) {
      if (_this.shouldNotReload) {
        _this.shouldNotReload = false; // just to be safe
        return;
      }

      _this.props.clearAssets();
      var params = { per_page: 150 };
      if (value && value.length >= 3) {
        params.unit_no = value;
      }
      _this.props.loadAssets(params);
    }, _this.handleInputChange = (0, _lodash.debounce)(_this.loadItems, 1000), _this.handleAssetChange = function (options) {
      var submitInputData = _this.props.submitInputData;

      var option = options[options.length - 1];
      _this.setState({ selectedAsset: options });
      // If asset is changed we clear the query param and replace it with new query
      _this.props.setCurrentAsset();
      if (option) {
        // Once an asset is selected, it moves to the next step. At this point,
        // `handleInputChange` is triggered because the input value is removed.
        // In this scenario, since we're moving to the next step, `handleInputChange`
        // should not trigger reloading the assets, as it's a redundant API call.
        _this.shouldNotReload = true;

        submitInputData(option.value);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AssetSelectionStep, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          initialAsset = _props.initialAsset,
          loadAsset = _props.loadAsset;

      var assetId = this.getAssetId();
      // loadItems was firing when a asset was already set and causing the wizard to move forward
      // to next step automatically when moving back to asset selection step.
      if (!this.props.location.search) {
        this.loadItems();
      }
      if (initialAsset) {
        return;
      }
      if (assetId) {
        loadAsset(assetId);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.assets !== nextProps.assets) {
        var options = makeOptions(nextProps.assets);

        this.setState({ options: options });
      }
      if (this.props.currentAsset !== nextProps.currentAsset) {
        var assetId = this.getAssetId();
        var currentAsset = nextProps.currentAsset,
            submitInputData = nextProps.submitInputData;

        if (currentAsset.id === assetId && assetId) {
          // Clears the url of search query
          this.props.history.push('/service-requests/new');
          submitInputData(currentAsset);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          selectedAsset = _state.selectedAsset,
          options = _state.options;
      var i18n = this.props.i18n;


      return _react2.default.createElement(
        _styledComponentsReactiveGrid.Container,
        { style: { padding: (0, _decisivUiUtils.px2rem)(30) + ' 0' } },
        _react2.default.createElement(
          _styledComponentsReactiveGrid.Row,
          null,
          _react2.default.createElement(
            _styledComponentsReactiveGrid.Column,
            { modifiers: ['col_offset_3', 'col_6'] },
            _react2.default.createElement(
              _styledComponentsReactiveGrid.Row,
              null,
              _react2.default.createElement(
                _styledComponentsReactiveGrid.Column,
                { modifiers: ['col'] },
                _react2.default.createElement(
                  _baseComponents.H3,
                  { modifiers: ['fontWeightRegular'] },
                  _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.whichAsset })
                )
              )
            ),
            _react2.default.createElement(
              _styledComponentsReactiveGrid.Row,
              { style: { marginTop: (0, _decisivUiUtils.px2rem)(20) } },
              _react2.default.createElement(
                _styledComponentsReactiveGrid.Column,
                { modifiers: ['col'] },
                _react2.default.createElement(
                  _WizardInput2.default,
                  { label: _messages2.default.unit },
                  _react2.default.createElement(
                    _DropdownWrapper2.default,
                    null,
                    _react2.default.createElement(_Select2.default, {
                      autoBlur: true,
                      multi: true,
                      onChange: this.handleAssetChange,
                      onInputChange: this.handleInputChange,
                      optionRenderer: _Option2.default,
                      options: options,
                      placeholder: i18n._(_messages2.default.selectItem),
                      value: selectedAsset
                    })
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return AssetSelectionStep;
}(_react.Component);

AssetSelectionStep.propTypes = {
  assets: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    id: _propTypes2.default.string
  })).isRequired,
  currentAsset: _propTypes2.default.shape({
    id: _propTypes2.default.string
  }).isRequired,
  initialAsset: _propTypes2.default.shape({
    unitNumber: _propTypes2.default.string,
    make: _propTypes2.default.string,
    model: _propTypes2.default.string,
    engine: _propTypes2.default.string,
    year: _propTypes2.default.string
  }),
  i18n: _propTypes2.default.shape({
    _: _propTypes2.default.func.isRequired
  }).isRequired,
  clearAssets: _propTypes2.default.func.isRequired,
  loadAssets: _propTypes2.default.func.isRequired,
  loadAsset: _propTypes2.default.func.isRequired,
  setCurrentAsset: _propTypes2.default.func.isRequired,
  submitInputData: _propTypes2.default.func.isRequired,
  location: _propTypes2.default.shape({
    search: _propTypes2.default.string
  }).isRequired,
  history: _propTypes2.default.shape({
    push: _propTypes2.default.func.isRequired
  }).isRequired
};
AssetSelectionStep.defaultProps = {
  initialAsset: null
};
exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('AssetSelectionStep'), _Container2.default, (0, _linguiReact.withI18n)(), _reactRouterDom.withRouter)(AssetSelectionStep);

/***/ }),

/***/ "./compositions/AssetSelectionStep/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var formattedMessages = {
  selectItem: (0, _linguiReact.i18nMark)('Select Item...'),
  unit: (0, _linguiReact.i18nMark)('Unit'),
  whichAsset: (0, _linguiReact.i18nMark)('Which asset?')
};

exports.default = formattedMessages;

/***/ }),

/***/ "./compositions/AssetSummaryWidget/Container.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _selectors = __webpack_require__("./redux/assets/selectors.js");

var _immutableToJS = __webpack_require__("./utils/immutableToJS.js");

var _immutableToJS2 = _interopRequireDefault(_immutableToJS);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var withConnectedData = function withConnectedData(WrappedComponent) {
  function Container(props) {
    return _react2.default.createElement(WrappedComponent, props);
  }

  Container.propTypes = {
    assetInfo: _propTypes2.default.shape({
      id: _propTypes2.default.string
    }).isRequired
  };

  Container.defaultProps = {
    assetInfo: {}
  };

  function mapStateToProps(state) {
    return {
      assetInfo: (0, _selectors.currentAssetSelector)(state)
    };
  }

  return (0, _reactRedux.connect)(mapStateToProps)((0, _immutableToJS2.default)(Container));
};

exports.default = withConnectedData;

/***/ }),

/***/ "./compositions/AssetSummaryWidget/InfoBox/Label.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  font-size: ', ';\n  font-weight: 700;\n  margin: ', ' 0;\n  text-align: center;\n  white-space: pre-line;\n'], ['\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  font-size: ', ';\n  font-weight: 700;\n  margin: ', ' 0;\n  text-align: center;\n  white-space: pre-line;\n']);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Label = function () {
  var c = _styledComponents2.default.div(_templateObject, (0, _decisivUiUtils.px2rem)(12), (0, _decisivUiUtils.px2rem)(5));

  c.displayName = 'Label';
  return c;
}();

exports.default = Label;

/***/ }),

/***/ "./compositions/AssetSummaryWidget/InfoBox/Title.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  align-items: center;\n  color: ' + props.theme.colors.base.text + ';\n  display: flex;\n  flex-direction: column;\n  font-size: ' + (0, _decisivUiUtils.px2rem)(10) + ';\n  margin: ' + (0, _decisivUiUtils.px2rem)(5) + ' 0;\n  text-transform: uppercase;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Title', _styledComponents2.default.div, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./compositions/AssetSummaryWidget/InfoBox/Wrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  border: 1px solid ' + props.theme.colors.base.chrome500 + ';\n  display: flex;\n  flex-direction: column;\n  margin: ' + (0, _decisivUiUtils.px2rem)(2.5) + ' ' + (0, _decisivUiUtils.px2rem)(5) + ' ' + (0, _decisivUiUtils.px2rem)(2.5) + ' 0;\n  min-height: ' + (0, _decisivUiUtils.px2rem)(60) + ';\n  padding: ' + (0, _decisivUiUtils.px2rem)(10) + ';\n  width: ' + (0, _decisivUiUtils.px2rem)(120) + ';\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome500: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Wrapper', _styledComponents2.default.div, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./compositions/AssetSummaryWidget/InfoBox/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _Wrapper = __webpack_require__("./compositions/AssetSummaryWidget/InfoBox/Wrapper.js");

var _Wrapper2 = _interopRequireDefault(_Wrapper);

var _Title = __webpack_require__("./compositions/AssetSummaryWidget/InfoBox/Title.js");

var _Title2 = _interopRequireDefault(_Title);

var _Label = __webpack_require__("./compositions/AssetSummaryWidget/InfoBox/Label.js");

var _Label2 = _interopRequireDefault(_Label);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function InfoBox(_ref) {
  var title = _ref.title,
      children = _ref.children;

  return _react2.default.createElement(
    _Wrapper2.default,
    null,
    _react2.default.createElement(
      _Title2.default,
      null,
      _react2.default.createElement(_linguiReact.Trans, { id: title })
    ),
    _react2.default.createElement(
      _Label2.default,
      null,
      children
    )
  );
}

InfoBox.propTypes = {
  title: _propTypes2.default.string.isRequired,
  children: _propTypes2.default.node
};

InfoBox.defaultProps = {
  children: null
};

exports.default = InfoBox;

/***/ }),

/***/ "./compositions/AssetSummaryWidget/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AssetSummaryWidget = AssetSummaryWidget;

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _recompose = __webpack_require__("../node_modules/recompose/es/Recompose.js");

var _SplitBlock = __webpack_require__("./elements/SplitBlock/index.js");

var _StatusSpan = __webpack_require__("./elements/StatusSpan/index.js");

var _StatusSpan2 = _interopRequireDefault(_StatusSpan);

var _Table = __webpack_require__("./elements/Table/index.js");

var _Table2 = _interopRequireDefault(_Table);

var _TextDiv = __webpack_require__("./elements/TextDiv/index.js");

var _TextDiv2 = _interopRequireDefault(_TextDiv);

var _Widget = __webpack_require__("./elements/Widget/index.js");

var _Widget2 = _interopRequireDefault(_Widget);

var _asset = __webpack_require__("./utils/asset.js");

var _widget = __webpack_require__("./utils/widget.js");

var _InfoBox = __webpack_require__("./compositions/AssetSummaryWidget/InfoBox/index.js");

var _InfoBox2 = _interopRequireDefault(_InfoBox);

var _messages = __webpack_require__("./compositions/AssetSummaryWidget/messages.js");

var _messages2 = _interopRequireDefault(_messages);

var _Container = __webpack_require__("./compositions/AssetSummaryWidget/Container.js");

var _Container2 = _interopRequireDefault(_Container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AssetSummaryWidget(_ref) {
  var _ref$assetInfo = _ref.assetInfo,
      odometer = _ref$assetInfo.odometer,
      campaignsStatus = _ref$assetInfo.campaignsStatus,
      engine = _ref$assetInfo.engine,
      make = _ref$assetInfo.make,
      model = _ref$assetInfo.model,
      pmStatus = _ref$assetInfo.pmStatus,
      unitNumber = _ref$assetInfo.unitNumber,
      vinNumber = _ref$assetInfo.vinNumber,
      warrantyStatus = _ref$assetInfo.warrantyStatus,
      year = _ref$assetInfo.year;

  var odometerUnit = odometer ? odometer.unit : '';
  var odometerReading = odometer ? odometer.reading : '';
  var odometerReadAt = odometer ? odometer.readAt : '';

  return _react2.default.createElement(
    _Widget2.default,
    { expandKey: 'asset-summary' },
    _react2.default.createElement(
      _Widget2.default.Header,
      null,
      _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.title })
    ),
    _react2.default.createElement(
      _Widget2.default.Item,
      null,
      _react2.default.createElement(
        _SplitBlock.SplitBlock,
        { modifiers: ['flexRow'] },
        _react2.default.createElement(
          _Table2.default,
          { modifiers: ['smallText'], trModifiers: ['flex'] },
          _react2.default.createElement(
            'tbody',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                null,
                _react2.default.createElement(
                  _TextDiv2.default,
                  { modifiers: ['bold', 'capitalize', 'inline', 'padRight'] },
                  _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.unit })
                ),
                (0, _widget.getOutputText)(unitNumber)
              ),
              _react2.default.createElement(
                'td',
                null,
                _react2.default.createElement(
                  _TextDiv2.default,
                  { modifiers: ['bold', 'inline', 'padRight'] },
                  _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.vin })
                ),
                (0, _widget.getOutputText)(vinNumber)
              ),
              _react2.default.createElement(
                'td',
                null,
                _react2.default.createElement(
                  _TextDiv2.default,
                  { modifiers: ['bold', 'capitalize', 'inline', 'padRight'] },
                  _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.make })
                ),
                (0, _widget.getOutputText)(make)
              ),
              _react2.default.createElement(
                'td',
                null,
                _react2.default.createElement(
                  _TextDiv2.default,
                  { modifiers: ['bold', 'capitalize', 'inline', 'padRight'] },
                  _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.model })
                ),
                (0, _widget.getOutputText)(model)
              ),
              _react2.default.createElement(
                'td',
                null,
                _react2.default.createElement(
                  _TextDiv2.default,
                  { modifiers: ['bold', 'capitalize', 'inline', 'padRight'] },
                  _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.year })
                ),
                (0, _widget.getOutputText)(year)
              ),
              _react2.default.createElement(
                'td',
                null,
                _react2.default.createElement(
                  _TextDiv2.default,
                  { modifiers: ['bold', 'capitalize', 'inline', 'padRight'] },
                  _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.engine })
                ),
                (0, _widget.getOutputText)(engine)
              )
            )
          )
        )
      ),
      _react2.default.createElement(
        _SplitBlock.SplitBlock,
        { modifiers: ['flexRow'] },
        _react2.default.createElement(
          _InfoBox2.default,
          { title: _messages2.default.odometer },
          (0, _asset.getOdometerText)(odometerReading, odometerUnit + '\n', odometerReadAt)
        ),
        _react2.default.createElement(
          _InfoBox2.default,
          { title: _messages2.default.maintenance },
          _react2.default.createElement(
            _StatusSpan2.default,
            { modifiers: (0, _lodash.compact)(['bold', 'capitalize', pmStatus]) },
            (0, _asset.getAssetStatusText)('pmStatus', pmStatus)
          )
        ),
        _react2.default.createElement(
          _InfoBox2.default,
          { title: _messages2.default.warranty },
          _react2.default.createElement(
            _StatusSpan2.default,
            { modifiers: (0, _lodash.compact)(['bold', 'capitalize', warrantyStatus]) },
            (0, _asset.getAssetStatusText)('warrantyStatus', warrantyStatus)
          )
        ),
        _react2.default.createElement(
          _InfoBox2.default,
          { title: _messages2.default.campaigns },
          _react2.default.createElement(
            _StatusSpan2.default,
            { modifiers: (0, _lodash.compact)(['bold', 'capitalize', campaignsStatus]) },
            (0, _asset.getAssetStatusText)('campaignsStatus', campaignsStatus)
          )
        )
      )
    )
  );
}

AssetSummaryWidget.propTypes = {
  assetInfo: _propTypes2.default.shape({
    campaignsStatus: _propTypes2.default.string,
    engine: _propTypes2.default.string,
    make: _propTypes2.default.string,
    model: _propTypes2.default.string,
    odometer: _propTypes2.default.shape({
      readAt: _propTypes2.default.string,
      reading: _propTypes2.default.string,
      unit: _propTypes2.default.string
    }),
    pmStatus: _propTypes2.default.string,
    readAt: _propTypes2.default.string,
    reading: _propTypes2.default.string,
    unit: _propTypes2.default.string,
    unitNumber: _propTypes2.default.string,
    vinNumber: _propTypes2.default.string,
    warrantyStatus: _propTypes2.default.string,
    year: _propTypes2.default.string
  }).isRequired
};

exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('AssetSummaryWidget'), _Container2.default)(AssetSummaryWidget);

/***/ }),

/***/ "./compositions/AssetSummaryWidget/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  title: (0, _linguiReact.i18nMark)('Asset Summary'),
  maintenance: (0, _linguiReact.i18nMark)('Maintenance'),
  campaigns: (0, _linguiReact.i18nMark)('Campaigns'),
  warranty: (0, _linguiReact.i18nMark)('Warranty'),
  unit: (0, _linguiReact.i18nMark)('UNIT'),
  vin: (0, _linguiReact.i18nMark)('VIN'),
  make: (0, _linguiReact.i18nMark)('Make'),
  model: (0, _linguiReact.i18nMark)('Model'),
  year: (0, _linguiReact.i18nMark)('Year'),
  engine: (0, _linguiReact.i18nMark)('Engine'),
  odometer: (0, _linguiReact.i18nMark)('Odometer'),
  current: (0, _linguiReact.i18nMark)('Current'),
  due: (0, _linguiReact.i18nMark)('Due'),
  overdue: (0, _linguiReact.i18nMark)('Overdue'),
  allCurrent: (0, _linguiReact.i18nMark)('All Current'),
  someCurrent: (0, _linguiReact.i18nMark)('Some Current'),
  noCoverage: (0, _linguiReact.i18nMark)('No Coverage'),
  campaignDue: (0, _linguiReact.i18nMark)('Campaign Due')
};

exports.default = messages;

/***/ }),

/***/ "./compositions/AssetsWidget/CaseAssetsContainer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fp = __webpack_require__("../node_modules/lodash/fp.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _immutableToJS = __webpack_require__("./utils/immutableToJS.js");

var _immutableToJS2 = _interopRequireDefault(_immutableToJS);

var _selectors = __webpack_require__("./redux/cases/selectors.js");

var _withAssetDetailRequestOnlyFields = __webpack_require__("./compositions/AssetsWidget/withAssetDetailRequestOnlyFields.js");

var _withAssetDetailRequestOnlyFields2 = _interopRequireDefault(_withAssetDetailRequestOnlyFields);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var withConnectedData = function withConnectedData(WrappedComponent) {
  function Container(props) {
    return _react2.default.createElement(WrappedComponent, props);
  }

  Container.propTypes = {
    assetInfo: _propTypes2.default.shape()
  };

  Container.defaultProps = {
    assetInfo: {}
  };

  function mapStateToProps(state) {
    return {
      assetInfo: (0, _selectors.currentCaseAssetSelector)(state)
    };
  }

  return (0, _fp.compose)((0, _reactRedux.connect)(mapStateToProps), _immutableToJS2.default, _withAssetDetailRequestOnlyFields2.default)(Container);
};

exports.default = withConnectedData;

/***/ }),

/***/ "./compositions/AssetsWidget/ServiceRequestAssetsContainer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fp = __webpack_require__("../node_modules/lodash/fp.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _immutableToJS = __webpack_require__("./utils/immutableToJS.js");

var _immutableToJS2 = _interopRequireDefault(_immutableToJS);

var _selectors = __webpack_require__("./redux/serviceRequests/selectors.js");

var _withAssetDetailRequestOnlyFields = __webpack_require__("./compositions/AssetsWidget/withAssetDetailRequestOnlyFields.js");

var _withAssetDetailRequestOnlyFields2 = _interopRequireDefault(_withAssetDetailRequestOnlyFields);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var withConnectedData = function withConnectedData(WrappedComponent) {
  function Container(props) {
    return _react2.default.createElement(WrappedComponent, props);
  }

  Container.propTypes = {
    assetInfo: _propTypes2.default.shape()
  };

  Container.defaultProps = {
    assetInfo: {}
  };

  function mapStateToProps(state) {
    return {
      assetInfo: (0, _selectors.currentServiceRequestAssetSelector)(state)
    };
  }

  return (0, _fp.compose)((0, _reactRedux.connect)(mapStateToProps), _immutableToJS2.default, _withAssetDetailRequestOnlyFields2.default)(Container);
};

exports.default = withConnectedData;

/***/ }),

/***/ "./compositions/AssetsWidget/Status/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _StatusLabel = __webpack_require__("./components/StatusLabel/index.js");

var _StatusLabel2 = _interopRequireDefault(_StatusLabel);

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/styled-components-reactive-grid/dist/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Status(_ref) {
  var statuses = _ref.statuses;

  return _react2.default.createElement(
    _styledComponentsReactiveGrid.Container,
    null,
    statuses.map(function (status) {
      return _react2.default.createElement(
        _styledComponentsReactiveGrid.Row,
        { key: status.label },
        _react2.default.createElement(_StatusLabel2.default, {
          color: status.value,
          label: status.label,
          tooltip: status.tooltip,
          showIcon: true
        })
      );
    })
  );
}

Status.propTypes = {
  statuses: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.string,
    value: _propTypes2.default.string,
    tooltip: _propTypes2.default.string
  })).isRequired
};

exports.default = Status;

/***/ }),

/***/ "./compositions/AssetsWidget/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ServiceRequestAssetsWidget = exports.CaseAssetsWidget = exports.getStatuses = exports.getTooltip = undefined;
exports.AssetsWidget = AssetsWidget;

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/styled-components-reactive-grid/dist/index.js");

var _asset = __webpack_require__("./utils/asset.js");

var _widget = __webpack_require__("./utils/widget.js");

var _Widget = __webpack_require__("./elements/Widget/index.js");

var _Widget2 = _interopRequireDefault(_Widget);

var _Link = __webpack_require__("./elements/Link/index.js");

var _Link2 = _interopRequireDefault(_Link);

var _CaseAssetsContainer = __webpack_require__("./compositions/AssetsWidget/CaseAssetsContainer.js");

var _CaseAssetsContainer2 = _interopRequireDefault(_CaseAssetsContainer);

var _ServiceRequestAssetsContainer = __webpack_require__("./compositions/AssetsWidget/ServiceRequestAssetsContainer.js");

var _ServiceRequestAssetsContainer2 = _interopRequireDefault(_ServiceRequestAssetsContainer);

var _messages = __webpack_require__("./compositions/AssetsWidget/messages.js");

var _messages2 = _interopRequireDefault(_messages);

var _Status = __webpack_require__("./compositions/AssetsWidget/Status/index.js");

var _Status2 = _interopRequireDefault(_Status);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getTooltip = exports.getTooltip = function getTooltip(tooltips, key) {
  return tooltips[key] || tooltips.green;
};

var getStatuses = exports.getStatuses = function getStatuses(assetInfo) {
  return [{
    label: _messages2.default.pmStatus,
    value: assetInfo.pmStatus,
    tooltip: getTooltip({
      green: _messages2.default.pmStatusTooltipGreen,
      yellow: _messages2.default.pmStatusTooltipYellow,
      red: _messages2.default.pmStatusTooltipRed
    }, assetInfo.pmStatus)
  }, {
    label: _messages2.default.warranty,
    value: assetInfo.warrantyStatus,
    tooltip: getTooltip({
      green: _messages2.default.warrantyTooltipGreen,
      yellow: _messages2.default.warrantyTooltipYellow,
      red: _messages2.default.warrantyTooltipRed,
      grey: _messages2.default.warrantyTooltipGrey
    }, assetInfo.warrantyStatus)
  }, {
    label: _messages2.default.campaigns,
    value: assetInfo.campaignsStatus,
    tooltip: getTooltip({
      green: _messages2.default.campaignsTooltipGreen,
      red: _messages2.default.campaignsTooltipRed
    }, assetInfo.campaignsStatus)
  }];
};

function AssetsWidget(_ref) {
  var assetInfo = _ref.assetInfo;
  var id = assetInfo.id,
      unitNumber = assetInfo.unitNumber,
      vinNumber = assetInfo.vinNumber,
      year = assetInfo.year,
      make = assetInfo.make,
      model = assetInfo.model,
      engine = assetInfo.engine,
      _assetInfo$odometer = assetInfo.odometer;
  _assetInfo$odometer = _assetInfo$odometer === undefined ? {} : _assetInfo$odometer;
  var odometerUnit = _assetInfo$odometer.unit,
      odometerReading = _assetInfo$odometer.reading,
      odometerReadAt = _assetInfo$odometer.readAt;


  return _react2.default.createElement(
    _Widget2.default,
    { className: 'AssetsWidget', expandKey: 'assets' },
    _react2.default.createElement(
      _Widget2.default.Header,
      null,
      _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.title })
    ),
    _react2.default.createElement(
      _styledComponentsReactiveGrid.Container,
      null,
      _react2.default.createElement(
        _styledComponentsReactiveGrid.Row,
        null,
        _react2.default.createElement(
          _styledComponentsReactiveGrid.Column,
          null,
          _react2.default.createElement(
            _styledComponentsReactiveGrid.Container,
            null,
            _react2.default.createElement(
              _Widget2.default.SubHeader,
              null,
              _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.unit }),
              '\xA0\xA0',
              _react2.default.createElement(
                _Link2.default,
                { to: '/assets/' + id, modifiers: ['hoverCaret'] },
                _react2.default.createElement(
                  'span',
                  { className: 'value' },
                  (0, _widget.getOutputText)(unitNumber)
                )
              )
            )
          ),
          _react2.default.createElement(
            _styledComponentsReactiveGrid.Container,
            null,
            _react2.default.createElement(
              _Widget2.default.Table,
              null,
              _react2.default.createElement(
                'tbody',
                null,
                _react2.default.createElement(
                  _Widget2.default.TableRow,
                  null,
                  _react2.default.createElement(
                    'th',
                    null,
                    _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.vin })
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    (0, _widget.getOutputText)(vinNumber)
                  )
                ),
                _react2.default.createElement(
                  _Widget2.default.TableRow,
                  { modifiers: ['topGap'] },
                  _react2.default.createElement(
                    'th',
                    null,
                    _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.year })
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    (0, _widget.getOutputText)(year)
                  )
                ),
                _react2.default.createElement(
                  _Widget2.default.TableRow,
                  { modifiers: ['topGap'] },
                  _react2.default.createElement(
                    'th',
                    null,
                    _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.make })
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    (0, _widget.getOutputText)(make)
                  )
                ),
                _react2.default.createElement(
                  _Widget2.default.TableRow,
                  { modifiers: ['topGap'] },
                  _react2.default.createElement(
                    'th',
                    null,
                    _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.model })
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    (0, _widget.getOutputText)(model)
                  )
                ),
                _react2.default.createElement(
                  _Widget2.default.TableRow,
                  { modifiers: ['topGap'] },
                  _react2.default.createElement(
                    'th',
                    null,
                    _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.engine })
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    (0, _widget.getOutputText)(engine)
                  )
                ),
                _react2.default.createElement(
                  _Widget2.default.TableRow,
                  { modifiers: ['topGap'] },
                  _react2.default.createElement(
                    'th',
                    null,
                    _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.odometer })
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    (0, _widget.getOutputText)((0, _asset.getOdometerText)(odometerReading, odometerUnit, odometerReadAt))
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _styledComponentsReactiveGrid.Column,
          null,
          _react2.default.createElement(_Status2.default, { statuses: getStatuses(assetInfo) })
        )
      )
    )
  );
}

AssetsWidget.propTypes = {
  assetInfo: _propTypes2.default.shape({
    id: _propTypes2.default.string
  }).isRequired
};

var CaseAssetsWidget = exports.CaseAssetsWidget = (0, _CaseAssetsContainer2.default)(AssetsWidget);
var ServiceRequestAssetsWidget = exports.ServiceRequestAssetsWidget = (0, _ServiceRequestAssetsContainer2.default)(AssetsWidget);

/***/ }),

/***/ "./compositions/AssetsWidget/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  campaigns: (0, _linguiReact.i18nMark)('Campaigns'),
  engine: (0, _linguiReact.i18nMark)('Engine'),
  make: (0, _linguiReact.i18nMark)('Make'),
  model: (0, _linguiReact.i18nMark)('Model'),
  odometer: (0, _linguiReact.i18nMark)('Odometer'),
  pmStatus: (0, _linguiReact.i18nMark)('Maintenance'),
  serial: (0, _linguiReact.i18nMark)('Serial'),
  title: (0, _linguiReact.i18nMark)('Asset'),
  unit: (0, _linguiReact.i18nMark)('Unit'),
  warranty: (0, _linguiReact.i18nMark)('Warranty'),
  vin: (0, _linguiReact.i18nMark)('VIN'),
  year: (0, _linguiReact.i18nMark)('Year'),
  pmStatusTooltipGreen: (0, _linguiReact.i18nMark)('Current'),
  pmStatusTooltipYellow: (0, _linguiReact.i18nMark)('Due'),
  pmStatusTooltipRed: (0, _linguiReact.i18nMark)('Overdue'),
  warrantyTooltipGreen: (0, _linguiReact.i18nMark)('Fully Covered'),
  warrantyTooltipYellow: (0, _linguiReact.i18nMark)('Partially Covered'),
  warrantyTooltipRed: (0, _linguiReact.i18nMark)('Expired'),
  warrantyTooltipGrey: (0, _linguiReact.i18nMark)('No Coverage'),
  campaignsTooltipGreen: (0, _linguiReact.i18nMark)('Current'),
  campaignsTooltipRed: (0, _linguiReact.i18nMark)('Campaign Due')
};

exports.default = messages;

/***/ }),

/***/ "./compositions/AssetsWidget/withAssetDetailRequestOnlyFields.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WithAssetDetailRequestOnlyFields = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _actions = __webpack_require__("./redux/app/actions.js");

var _actions2 = __webpack_require__("./redux/assets/actions.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Depending on a user's path, they may have incomplete data for an asset.
 * Specifically, information concerning campaigns and warranties is to heavy
 * on the server to load for more than one case, asset, or service request.
 * The AssetsWidget requires this data to display correctly. This component
 * validates that the assetInfo contains the required data, and dispatches a
 * request for the complete information if it does not.
 *
 * @class WithAssetDetailRequestOnlyFields
 * @extends {Component}
 */
var WithAssetDetailRequestOnlyFields = exports.WithAssetDetailRequestOnlyFields = function (_Component) {
  _inherits(WithAssetDetailRequestOnlyFields, _Component);

  function WithAssetDetailRequestOnlyFields() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, WithAssetDetailRequestOnlyFields);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WithAssetDetailRequestOnlyFields.__proto__ || Object.getPrototypeOf(WithAssetDetailRequestOnlyFields)).call.apply(_ref, [this].concat(args))), _this), _this.shouldLoadAssetInfo = function (assetInfo) {
      return (0, _lodash.isEmpty)((0, _lodash.pick)(assetInfo, ['campaigns', 'campaignsStatus', 'countWarranties', 'warrantyStatus']));
    }, _this.validateOrLoadAssetInfo = function (assetInfo) {
      if (assetInfo.id && _this.shouldLoadAssetInfo(assetInfo)) {
        _this.props.loadAssetInfo(assetInfo.id);
        _this.props.setLoadingStarted();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(WithAssetDetailRequestOnlyFields, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var assetInfo = this.props.assetInfo;

      this.validateOrLoadAssetInfo(assetInfo);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var assetInfo = nextProps.assetInfo;

      this.validateOrLoadAssetInfo(assetInfo);
    }

    /**
     * Checks for missing fields in the current asset info object.
     * Returns true if the asset info is missing required data.
     *
     * @property {object} assetInfo The current or next assetInfo object
     * @returns Boolean indicating if the assetInfo should be reloaded.
     * @memberof Container
     */


    /**
     * Depending on the user's path some information may not be present
     * in the Asset Info. Validates the asset info. Loads/ reloads if necessary.
     *
     * @param {object} assetInfo The current or next assetInfo object
     * @memberof Container
     */

  }, {
    key: 'render',
    value: function render() {
      // The children don't need to know about loading related props.
      var componentProps = (0, _lodash.omit)(this.props, ['children', 'loadAssetInfo', 'setLoadingStarted']);
      return this.props.children(componentProps);
    }
  }]);

  return WithAssetDetailRequestOnlyFields;
}(_react.Component);

/* istanbul ignore next */


WithAssetDetailRequestOnlyFields.propTypes = {
  assetInfo: _propTypes2.default.shape({
    id: _propTypes2.default.string
  }).isRequired,
  children: _propTypes2.default.func.isRequired,
  loadAssetInfo: _propTypes2.default.func.isRequired,
  setLoadingStarted: _propTypes2.default.func.isRequired
};
var withAssetDetailRequestOnlyFields = function withAssetDetailRequestOnlyFields(WrappedComponent) {
  // Using an external component/ function as a child pattern here to enhance testability.
  var InternalComponent = function InternalComponent(props) {
    return _react2.default.createElement(
      WithAssetDetailRequestOnlyFields,
      props,
      function (componentProps) {
        return _react2.default.createElement(
          WrappedComponent,
          componentProps,
          props.children
        );
      }
    );
  };

  InternalComponent.propTypes = {
    children: _propTypes2.default.node
  };

  InternalComponent.defaultProps = {
    children: null
  };

  function mapStateToProps() {
    return {};
  }

  function mapDispatchToProps(dispatch) {
    return {
      loadAssetInfo: function loadAssetInfo(assetId) {
        return dispatch((0, _actions2.loadAsset)({ assetId: assetId }));
      },
      setLoadingStarted: function setLoadingStarted() {
        return dispatch((0, _actions.setLoadingStarted)(true));
      }
    };
  }

  return (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(InternalComponent);
};

exports.default = withAssetDetailRequestOnlyFields;

/***/ }),

/***/ "./compositions/BreadCrumbLink/BreadCrumbLinkWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modifierConfig = exports.LinkWithoutStyleProps = undefined;

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__("../node_modules/react-router-dom/es/index.js");

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * LinkWithoutStyle removes the theme props from react-router-dom's `Link` component,
 * allowing us to use styled-components without prop errors in the console.
 */
var LinkWithoutStyleProps = exports.LinkWithoutStyleProps = function LinkWithoutStyleProps(props) {
  return _react2.default.createElement(_reactRouterDom.Link, (0, _lodash.omit)(props, ['theme', 'modifiers']));
};

/* istanbul ignore next */
var modifierConfig = exports.modifierConfig = {
  icon: function icon(_ref) {
    var theme = _ref.theme;
    return {
      styles: '\n      color: ' + theme.colors.base.link + ';\n      font-size: ' + (0, _decisivUiUtils.px2rem)(15) + ';\n      &:hover {\n        text-decoration: none;\n      }\n      .fa {\n        font-size: ' + (0, _decisivUiUtils.px2rem)(15) + ';\n      }\n    '
    };
  }
};

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  color: ' + props.theme.colors.base.link + ';\n  font-size: ' + (0, _decisivUiUtils.px2rem)(15) + ';\n  font-weight: 400;\n  text-decoration: none;\n  text-transform: uppercase;\n  &:hover {\n    color: ' + props.theme.colors.base.linkHover + ';\n    text-decoration: underline;\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      link: _propTypes2.default.string.isRequired,
      linkHover: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('BreadCrumbLinkWrapper', (0, _styledComponents2.default)(LinkWithoutStyleProps), styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

/***/ }),

/***/ "./compositions/BreadCrumbLink/Container.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _withCollapsedState = __webpack_require__("./components/_common/withCollapsedState/index.js");

var _withCollapsedState2 = _interopRequireDefault(_withCollapsedState);

var _selectors = __webpack_require__("./redux/app/selectors.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var BreadcrumbLinkContainer = function BreadcrumbLinkContainer(WrappedComponent) {
  function Container(props) {
    return _react2.default.createElement(WrappedComponent, props);
  }

  Container.propTypes = {
    breadcrumbs: _propTypes2.default.shape({
      current: _propTypes2.default.shape({
        path: _propTypes2.default.string,
        message: _propTypes2.default.string
      }).isRequired,
      previous: _propTypes2.default.shape({
        path: _propTypes2.default.string,
        message: _propTypes2.default.string
      }).isRequired
    }).isRequired,
    collapsed: _propTypes2.default.bool.isRequired
  };

  function mapStateToProps(state) {
    return {
      breadcrumbs: (0, _selectors.breadcrumbsSelector)(state)
    };
  }

  return (0, _reactRedux.connect)(mapStateToProps)((0, _withCollapsedState2.default)(Container));
};

exports.default = BreadcrumbLinkContainer;

/***/ }),

/***/ "./compositions/BreadCrumbLink/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BreadCrumbLink = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _reactFontawesome = __webpack_require__("../node_modules/react-fontawesome/lib/index.js");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/styled-components-reactive-grid/dist/index.js");

var _PageHeadingTitle = __webpack_require__("./elements/PageHeadingTitle/index.js");

var _PageHeadingTitle2 = _interopRequireDefault(_PageHeadingTitle);

var _TextDiv = __webpack_require__("./elements/TextDiv/index.js");

var _TextDiv2 = _interopRequireDefault(_TextDiv);

var _BreadCrumbLinkWrapper = __webpack_require__("./compositions/BreadCrumbLink/BreadCrumbLinkWrapper.js");

var _BreadCrumbLinkWrapper2 = _interopRequireDefault(_BreadCrumbLinkWrapper);

var _Container = __webpack_require__("./compositions/BreadCrumbLink/Container.js");

var _Container2 = _interopRequireDefault(_Container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function buildPreviousBreadcrumb(breadcrumbs, collapsed) {
  if ((0, _lodash.isEmpty)(breadcrumbs.previous)) {
    return null;
  }

  if (collapsed) {
    return _react2.default.createElement(
      _styledComponentsReactiveGrid.Column,
      null,
      _react2.default.createElement(
        _BreadCrumbLinkWrapper2.default,
        {
          modifiers: ['icon'],
          to: breadcrumbs.previous.path
        },
        _react2.default.createElement(_reactFontawesome2.default, { name: 'angle-left' })
      )
    );
  }

  return _react2.default.createElement(
    _styledComponentsReactiveGrid.Row,
    { modifiers: ['middle'], style: { padding: '0' } },
    _react2.default.createElement(
      _styledComponentsReactiveGrid.Column,
      null,
      _react2.default.createElement(
        _BreadCrumbLinkWrapper2.default,
        { to: breadcrumbs.previous.path },
        _react2.default.createElement(_linguiReact.Trans, {
          id: breadcrumbs.previous.message,
          values: { number: breadcrumbs.previous.number }
        })
      )
    ),
    _react2.default.createElement(
      _styledComponentsReactiveGrid.Column,
      null,
      _react2.default.createElement(
        _TextDiv2.default,
        { modifiers: ['bold', 'inline', 'largeText', 'lightGreyText'] },
        _react2.default.createElement(_reactFontawesome2.default, { name: 'angle-right' })
      )
    )
  );
}

var BreadCrumbLink = exports.BreadCrumbLink = function (_Component) {
  _inherits(BreadCrumbLink, _Component);

  function BreadCrumbLink() {
    _classCallCheck(this, BreadCrumbLink);

    return _possibleConstructorReturn(this, (BreadCrumbLink.__proto__ || Object.getPrototypeOf(BreadCrumbLink)).apply(this, arguments));
  }

  _createClass(BreadCrumbLink, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          breadcrumbs = _props.breadcrumbs,
          collapsed = _props.collapsed;


      if (!breadcrumbs.current.message) {
        return null;
      }

      var previousBreadcrumb = buildPreviousBreadcrumb(breadcrumbs, collapsed);

      return _react2.default.createElement(
        _styledComponentsReactiveGrid.Row,
        { modifiers: ['middle'] },
        !(0, _lodash.isEmpty)(previousBreadcrumb) && _react2.default.createElement(
          _styledComponentsReactiveGrid.Column,
          { style: { padding: '0' } },
          previousBreadcrumb
        ),
        _react2.default.createElement(
          _styledComponentsReactiveGrid.Column,
          null,
          _react2.default.createElement(
            _PageHeadingTitle2.default,
            null,
            _react2.default.createElement(_linguiReact.Trans, {
              id: breadcrumbs.current.message,
              values: { number: breadcrumbs.current.number }
            })
          )
        )
      );
    }
  }]);

  return BreadCrumbLink;
}(_react.Component);

BreadCrumbLink.propTypes = {
  collapsed: _propTypes2.default.bool,
  breadcrumbs: _propTypes2.default.shape({
    current: _propTypes2.default.shape({
      message: _propTypes2.default.string,
      number: _propTypes2.default.string,
      path: _propTypes2.default.string
    }).isRequired,
    previous: _propTypes2.default.shape({
      message: _propTypes2.default.string,
      number: _propTypes2.default.string,
      path: _propTypes2.default.string
    }).isRequired
  }).isRequired
};
BreadCrumbLink.defaultProps = {
  collapsed: false
};


var wrappedComponent = (0, _Container2.default)(BreadCrumbLink);
wrappedComponent.displayName = 'BreadCrumbLink';
exports.default = wrappedComponent;

/***/ }),

/***/ "./compositions/CancelServiceRequestButton/Container.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _immutableToJS = __webpack_require__("./utils/immutableToJS.js");

var _immutableToJS2 = _interopRequireDefault(_immutableToJS);

var _actions = __webpack_require__("./redux/serviceRequests/actions.js");

var _selectors = __webpack_require__("./redux/serviceRequests/selectors.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var withConnectedData = function withConnectedData(WrappedComponent) {
  function Container(props) {
    return _react2.default.createElement(WrappedComponent, props);
  }

  Container.propTypes = {
    cancelServiceRequest: _propTypes2.default.func.isRequired,
    cancelServiceRequestError: _propTypes2.default.shape({
      error: _propTypes2.default.bool.isRequired
    }),
    cancelServiceRequestPending: _propTypes2.default.bool.isRequired,
    serviceRequestInfo: _propTypes2.default.shape({
      id: _propTypes2.default.string
    }).isRequired
  };

  Container.defaultProps = {
    cancelServiceRequestError: undefined
  };

  function mapStateToProps(state) {
    return {
      cancelServiceRequestError: (0, _selectors.cancelServiceRequestErrorSelector)(state),
      cancelServiceRequestPending: (0, _selectors.cancelServiceRequestPendingSelector)(state),
      serviceRequestInfo: (0, _selectors.currentServiceRequestSelector)(state)
    };
  }

  function mapDispatchToProps(dispatch) {
    return {
      cancelServiceRequest: function cancelServiceRequest(serviceRequestId) {
        return dispatch((0, _actions.cancelServiceRequest)({ serviceRequestId: serviceRequestId }));
      }
    };
  }

  return (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _immutableToJS2.default)(Container));
};

exports.default = withConnectedData;

/***/ }),

/***/ "./compositions/CancelServiceRequestButton/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CancelServiceRequestButton = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _baseComponents = __webpack_require__("../node_modules/base-components/build/index.js");

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__("../node_modules/react-router-dom/es/index.js");

var _Container = __webpack_require__("./compositions/CancelServiceRequestButton/Container.js");

var _Container2 = _interopRequireDefault(_Container);

var _messages = __webpack_require__("./compositions/CancelServiceRequestButton/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CancelServiceRequestButton = exports.CancelServiceRequestButton = function (_Component) {
  _inherits(CancelServiceRequestButton, _Component);

  function CancelServiceRequestButton() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CancelServiceRequestButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CancelServiceRequestButton.__proto__ || Object.getPrototypeOf(CancelServiceRequestButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      serviceRequestCancelled: false
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CancelServiceRequestButton, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var cancelServiceRequestError = nextProps.cancelServiceRequestError,
          cancelServiceRequestPending = nextProps.cancelServiceRequestPending;

      if (!cancelServiceRequestPending && this.props.cancelServiceRequestPending) {
        if (cancelServiceRequestError) {
          console.log('TODO: Cancel Service Request failed. Implement correct error handling.', cancelServiceRequestError);
        }

        // Sets the success flag as a local state
        this.setState({ serviceRequestCancelled: !cancelServiceRequestError });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          cancelServiceRequest = _props.cancelServiceRequest,
          serviceRequestInfo = _props.serviceRequestInfo;

      if (this.state.serviceRequestCancelled) {
        // FIXME: This is a temporary fix - handle the success case better
        return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/service-requests/filter/open-service-request' });
      }
      return _react2.default.createElement(
        _baseComponents.QuickActionButton,
        { onClick: function onClick() {
            return cancelServiceRequest(serviceRequestInfo.id);
          } },
        _react2.default.createElement(
          _baseComponents.QuickActionButton.Text,
          null,
          _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.title })
        )
      );
    }
  }]);

  return CancelServiceRequestButton;
}(_react.Component);

CancelServiceRequestButton.propTypes = {
  cancelServiceRequest: _propTypes2.default.func.isRequired,
  cancelServiceRequestError: _propTypes2.default.shape({
    error: _propTypes2.default.bool.isRequired
  }),
  cancelServiceRequestPending: _propTypes2.default.bool.isRequired,
  serviceRequestInfo: _propTypes2.default.shape({
    id: _propTypes2.default.string
  }).isRequired
};

CancelServiceRequestButton.defaultProps = {
  cancelServiceRequestError: undefined
};

exports.default = (0, _Container2.default)(CancelServiceRequestButton);

/***/ }),

/***/ "./compositions/CancelServiceRequestButton/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  title: (0, _linguiReact.i18nMark)('Cancel Request')
};

exports.default = messages;

/***/ }),

/***/ "./compositions/CaseClassicAssetDetailButton/Container.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _recompose = __webpack_require__("../node_modules/recompose/es/Recompose.js");

var _authentication = __webpack_require__("./features/authentication/index.js");

var _selectors = __webpack_require__("./redux/assets/selectors.js");

var _selectors2 = __webpack_require__("./redux/user/selectors.js");

var _immutableToJS = __webpack_require__("./utils/immutableToJS.js");

var _immutableToJS2 = _interopRequireDefault(_immutableToJS);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var withConnectedData = function withConnectedData(WrappedComponent) {
  function WithConnectedData(props) {
    return _react2.default.createElement(WrappedComponent, props);
  }

  WithConnectedData.propTypes = {
    assetInfo: _propTypes2.default.shape({
      id: _propTypes2.default.string
    }).isRequired,
    tenant: _propTypes2.default.string.isRequired,
    userProfile: _propTypes2.default.shape({
      companyId: _propTypes2.default.string
    }).isRequired
  };

  function mapStateToProps(state) {
    return {
      assetInfo: (0, _selectors.currentAssetSelector)(state),
      tenant: (0, _authentication.currentTenantSelector)(state),
      userProfile: (0, _selectors2.userProfileSelector)(state)
    };
  }

  return (0, _recompose.compose)((0, _recompose.setDisplayName)('CaseClassicAssetDetailButton'), (0, _reactRedux.connect)(mapStateToProps), _immutableToJS2.default)(WithConnectedData);
};

exports.default = withConnectedData;

/***/ }),

/***/ "./compositions/CaseClassicAssetDetailButton/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CaseClassicAssetDetailButton = CaseClassicAssetDetailButton;

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _baseComponents = __webpack_require__("../node_modules/base-components/build/index.js");

var _hybridLinks = __webpack_require__("./utils/hybridLinks.js");

var _Container = __webpack_require__("./compositions/CaseClassicAssetDetailButton/Container.js");

var _Container2 = _interopRequireDefault(_Container);

var _messages = __webpack_require__("./compositions/CaseClassicAssetDetailButton/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CaseClassicAssetDetailButton(_ref) {
  var assetInfo = _ref.assetInfo,
      tenant = _ref.tenant,
      companyId = _ref.userProfile.companyId;

  var assetDetailLink = (0, _hybridLinks.buildAssetDetailLink)(assetInfo.id, { companyId: companyId, tenant: tenant });
  return _react2.default.createElement(
    'a',
    { href: assetDetailLink },
    _react2.default.createElement(
      _baseComponents.QuickActionButton,
      null,
      _react2.default.createElement(_baseComponents.QuickActionButton.Icon, { name: 'long-arrow-left', modifiers: ['left'] }),
      _react2.default.createElement(
        _baseComponents.QuickActionButton.Text,
        null,
        _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.title })
      )
    )
  );
}

CaseClassicAssetDetailButton.propTypes = {
  assetInfo: _propTypes2.default.shape({
    id: _propTypes2.default.string
  }).isRequired,
  tenant: _propTypes2.default.string.isRequired,
  userProfile: _propTypes2.default.shape({
    companyId: _propTypes2.default.string
  }).isRequired
};

exports.default = (0, _Container2.default)(CaseClassicAssetDetailButton);

/***/ }),

/***/ "./compositions/CaseClassicAssetDetailButton/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  title: (0, _linguiReact.i18nMark)('Return to the classic look')
};

exports.default = messages;

/***/ }),

/***/ "./compositions/CaseOverview/Container.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _selectors = __webpack_require__("./redux/cases/selectors.js");

var _immutableToJS = __webpack_require__("./utils/immutableToJS.js");

var _immutableToJS2 = _interopRequireDefault(_immutableToJS);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var withConnectedData = function withConnectedData(WrappedComponent) {
  function Container(props) {
    return _react2.default.createElement(WrappedComponent, props);
  }

  function mapStateToProps(state) {
    return {
      assetInfo: (0, _selectors.currentCaseAssetSelector)(state),
      caseInfo: (0, _selectors.currentCaseSelector)(state)
    };
  }

  return (0, _reactRedux.connect)(mapStateToProps)((0, _immutableToJS2.default)(Container));
};

exports.default = withConnectedData;

/***/ }),

/***/ "./compositions/CaseOverview/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CaseOverview = CaseOverview;

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _recompose = __webpack_require__("../node_modules/recompose/es/Recompose.js");

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/styled-components-reactive-grid/dist/index.js");

var _SeverityLabel = __webpack_require__("./components/SeverityLabel/index.js");

var _SeverityLabel2 = _interopRequireDefault(_SeverityLabel);

var _UnreadNoteLabelContainer = __webpack_require__("./containers/UnreadNoteLabelContainer/index.js");

var _UnreadNoteLabelContainer2 = _interopRequireDefault(_UnreadNoteLabelContainer);

var _BreadCrumbLink = __webpack_require__("./compositions/BreadCrumbLink/index.js");

var _BreadCrumbLink2 = _interopRequireDefault(_BreadCrumbLink);

var _Table = __webpack_require__("./elements/Table/index.js");

var _Table2 = _interopRequireDefault(_Table);

var _widget = __webpack_require__("./utils/widget.js");

var _Container = __webpack_require__("./compositions/CaseOverview/Container.js");

var _Container2 = _interopRequireDefault(_Container);

var _messages = __webpack_require__("./compositions/CaseOverview/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CaseOverview(_ref) {
  var assetInfo = _ref.assetInfo,
      caseInfo = _ref.caseInfo;

  var unreadNoteCount = Number(caseInfo.unreadNotesCount) || 0;
  var severityColor = caseInfo.severityColor;
  var severityCount = Number(caseInfo.severityCount);
  var unitNumber = assetInfo.unitNumber,
      year = assetInfo.year,
      make = assetInfo.make,
      model = assetInfo.model;
  // NOTE: The extra padding on top is required to correct other display issues on this page.
  // This must be removed when this component is exported to a composition, and brought in via
  // the config file.

  return _react2.default.createElement(
    _styledComponentsReactiveGrid.Container,
    { id: 'case-overview', style: { paddingTop: '16px' } },
    _react2.default.createElement(_BreadCrumbLink2.default, null),
    _react2.default.createElement(
      _styledComponentsReactiveGrid.Row,
      { modifiers: ['middle'] },
      _react2.default.createElement(
        _styledComponentsReactiveGrid.Column,
        { modifiers: ['col'] },
        _react2.default.createElement(
          _Table2.default,
          { modifiers: ['mediumGrey', 'xLargeText'] },
          _react2.default.createElement(
            'tbody',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'th',
                null,
                _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.unit })
              ),
              _react2.default.createElement(
                'td',
                null,
                (0, _widget.getOutputText)(unitNumber)
              ),
              _react2.default.createElement(
                'th',
                null,
                _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.year })
              ),
              _react2.default.createElement(
                'td',
                null,
                (0, _widget.getOutputText)(year)
              ),
              _react2.default.createElement(
                'th',
                null,
                _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.make })
              ),
              _react2.default.createElement(
                'td',
                null,
                (0, _widget.getOutputText)(make)
              ),
              _react2.default.createElement(
                'th',
                null,
                _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.model })
              ),
              _react2.default.createElement(
                'td',
                null,
                (0, _widget.getOutputText)(model)
              )
            )
          )
        )
      )
    ),
    _react2.default.createElement(
      _styledComponentsReactiveGrid.Row,
      { modifiers: ['end'] },
      _react2.default.createElement(
        _styledComponentsReactiveGrid.Column,
        null,
        _react2.default.createElement(_SeverityLabel2.default, {
          color: severityColor,
          value: severityCount
        })
      ),
      unreadNoteCount > 0 && _react2.default.createElement(
        _styledComponentsReactiveGrid.Column,
        null,
        _react2.default.createElement(_UnreadNoteLabelContainer2.default, { caseInfo: caseInfo })
      )
    )
  );
}

CaseOverview.propTypes = {
  assetInfo: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    unitNumber: _propTypes2.default.string,
    year: _propTypes2.default.string,
    make: _propTypes2.default.string,
    model: _propTypes2.default.string
  }).isRequired,
  caseInfo: _propTypes2.default.shape({
    severityColor: _propTypes2.default.string,
    severityCount: _propTypes2.default.string
  }).isRequired
};

CaseOverview.defaultProps = {
  assetInfo: {},
  caseInfo: {
    severityColor: 'grey',
    severityCount: '0'
  }
};

exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('CaseOverview'), _Container2.default)(CaseOverview);

/***/ }),

/***/ "./compositions/CaseOverview/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var formattedMessages = {
  make: (0, _linguiReact.i18nMark)('Make'),
  model: (0, _linguiReact.i18nMark)('Model'),
  unit: (0, _linguiReact.i18nMark)('Unit'),
  year: (0, _linguiReact.i18nMark)('Year')
};

exports.default = formattedMessages;

/***/ }),

/***/ "./compositions/CaseStatusWidget/Container.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _selectors = __webpack_require__("./redux/cases/selectors.js");

var _immutableToJS = __webpack_require__("./utils/immutableToJS.js");

var _immutableToJS2 = _interopRequireDefault(_immutableToJS);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var withConnectedData = function withConnectedData(WrappedComponent) {
  function WithConnectedData(props) {
    return _react2.default.createElement(WrappedComponent, props);
  }

  WithConnectedData.propTypes = {
    caseInfo: _propTypes2.default.shape({
      id: _propTypes2.default.string
    }).isRequired
  };

  function mapStateToProps(state) {
    return {
      caseInfo: (0, _selectors.currentCaseSelector)(state)
    };
  }

  return (0, _reactRedux.connect)(mapStateToProps)((0, _immutableToJS2.default)(WithConnectedData));
};

exports.default = withConnectedData;

/***/ }),

/***/ "./compositions/CaseStatusWidget/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CaseStatusWidget = CaseStatusWidget;

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _momentTimezone = __webpack_require__("../node_modules/moment-timezone/index.js");

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _decisivDomainUtils = __webpack_require__("../node_modules/decisiv-domain-utils/build/index.js");

var _Widget = __webpack_require__("./elements/Widget/index.js");

var _Widget2 = _interopRequireDefault(_Widget);

var _Table = __webpack_require__("./elements/Table/index.js");

var _Table2 = _interopRequireDefault(_Table);

var _Span = __webpack_require__("./elements/Span/index.js");

var _Span2 = _interopRequireDefault(_Span);

var _BorderedStatus = __webpack_require__("./elements/BorderedStatus/index.js");

var _BorderedStatus2 = _interopRequireDefault(_BorderedStatus);

var _timeUtils = __webpack_require__("./utils/timeUtils.js");

var _widget = __webpack_require__("./utils/widget.js");

var _messages = __webpack_require__("./compositions/CaseStatusWidget/messages.js");

var _messages2 = _interopRequireDefault(_messages);

var _Container = __webpack_require__("./compositions/CaseStatusWidget/Container.js");

var _Container2 = _interopRequireDefault(_Container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CaseStatusWidget(_ref) {
  var caseInfo = _ref.caseInfo;
  var closedAt = caseInfo.closedAt,
      etr = caseInfo.etr,
      repairStatus = caseInfo.repairStatus,
      requestedAt = caseInfo.requestedAt;


  var openOrClosed = closedAt ? 'closed' : 'open';
  var formattedEtr = etr ? (0, _timeUtils.formatDate)(etr) : (0, _widget.getOutputText)(null);

  var createdAt = requestedAt && _react2.default.createElement(_decisivDomainUtils.FormattedRelative, {
    render: function render(relativeTime) {
      return _react2.default.createElement(
        _Span2.default,
        { modifiers: ['capitalize'] },
        relativeTime
      );
    },
    value: _momentTimezone2.default.tz(requestedAt, (0, _timeUtils.userTimeZone)())
  });

  return _react2.default.createElement(
    _Widget2.default,
    { expandKey: 'case-status' },
    _react2.default.createElement(
      _Widget2.default.Header,
      null,
      _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.title })
    ),
    _react2.default.createElement(
      _Widget2.default.Item,
      null,
      _react2.default.createElement(
        _Widget2.default.SubHeader,
        null,
        _react2.default.createElement(
          _BorderedStatus2.default,
          { modifiers: [openOrClosed] },
          openOrClosed
        )
      )
    ),
    _react2.default.createElement(
      _Widget2.default.Item,
      null,
      _react2.default.createElement(
        _Table2.default,
        { modifiers: ['smallText'], trModifiers: ['flex', 'wide'] },
        _react2.default.createElement(
          'tbody',
          null,
          _react2.default.createElement(
            'tr',
            null,
            _react2.default.createElement(
              'th',
              null,
              _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.repairStatus })
            ),
            _react2.default.createElement(
              'td',
              null,
              (0, _widget.getOutputText)(repairStatus)
            ),
            _react2.default.createElement(
              'th',
              null,
              _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.etr })
            ),
            _react2.default.createElement(
              'td',
              null,
              formattedEtr
            ),
            _react2.default.createElement(
              'th',
              null,
              _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.created })
            ),
            _react2.default.createElement(
              'td',
              null,
              (0, _widget.getOutputText)(createdAt)
            )
          )
        )
      )
    )
  );
}

CaseStatusWidget.propTypes = {
  caseInfo: _propTypes2.default.shape({
    closedAt: _propTypes2.default.string,
    repairStatus: _propTypes2.default.string,
    etr: _propTypes2.default.string,
    downtime: _propTypes2.default.string
  }).isRequired
};

exports.default = (0, _Container2.default)(CaseStatusWidget);

/***/ }),

/***/ "./compositions/CaseStatusWidget/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  created: (0, _linguiReact.i18nMark)('Created'),
  etr: (0, _linguiReact.i18nMark)('ETR'),
  repairStatus: (0, _linguiReact.i18nMark)('Repair Status'),
  title: (0, _linguiReact.i18nMark)('Case Status')
};

exports.default = messages;

/***/ }),

/***/ "./compositions/ComplaintWidget/CaseComplaintContainer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _immutableToJS = __webpack_require__("./utils/immutableToJS.js");

var _immutableToJS2 = _interopRequireDefault(_immutableToJS);

var _selectors = __webpack_require__("./redux/cases/selectors.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var withConnectedData = function withConnectedData(WrappedComponent) {
  function Container(props) {
    return _react2.default.createElement(WrappedComponent, props);
  }

  Container.propTypes = {
    info: _propTypes2.default.shape({
      complaint: _propTypes2.default.shape({
        code: _propTypes2.default.string,
        description: _propTypes2.default.string
      }),
      description: _propTypes2.default.string
    }).isRequired
  };

  Container.defaultProps = {
    caseInfo: {}
  };

  function mapStateToProps(state) {
    return {
      info: (0, _selectors.currentCaseSelector)(state)
    };
  }

  return (0, _reactRedux.connect)(mapStateToProps)((0, _immutableToJS2.default)(Container));
};

exports.default = withConnectedData;

/***/ }),

/***/ "./compositions/ComplaintWidget/Content.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  color: ' + props.theme.colors.base.text + ';\n  font-size: ' + (0, _decisivUiUtils.px2rem)(12) + ';\n  font-weight: normal;\n  line-height: ' + (0, _decisivUiUtils.px2rem)(19) + ';\n  margin: 0;\n  padding-left: ' + (0, _decisivUiUtils.px2rem)(20) + ';\n  padding-top: ' + (0, _decisivUiUtils.px2rem)(8) + ';\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Content', _styledComponents2.default.p, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./compositions/ComplaintWidget/ServiceRequestComplaintContainer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _recompose = __webpack_require__("../node_modules/recompose/es/Recompose.js");

var _selectors = __webpack_require__("./redux/serviceRequests/selectors.js");

var _immutableToJS = __webpack_require__("./utils/immutableToJS.js");

var _immutableToJS2 = _interopRequireDefault(_immutableToJS);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var withConnectedData = function withConnectedData(WrappedComponent) {
  function Container(props) {
    return _react2.default.createElement(WrappedComponent, props);
  }

  Container.propTypes = {
    info: _propTypes2.default.shape({
      complaint: _propTypes2.default.shape({
        code: _propTypes2.default.string,
        description: _propTypes2.default.string
      }),
      description: _propTypes2.default.string
    }).isRequired
  };

  function mapStateToProps(state) {
    return {
      info: (0, _selectors.currentServiceRequestSelector)(state)
    };
  }

  return (0, _recompose.compose)((0, _recompose.setDisplayName)('ServiceRequestComplaintContainer'), (0, _reactRedux.connect)(mapStateToProps), _immutableToJS2.default)(Container);
};

exports.default = withConnectedData;

/***/ }),

/***/ "./compositions/ComplaintWidget/Title.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  color: ' + props.theme.colors.base.text + ';\n  font-size: ' + (0, _decisivUiUtils.px2rem)(14) + ';\n  font-weight: 600;\n  height: ' + (0, _decisivUiUtils.px2rem)(19) + ';\n  line-height: ' + (0, _decisivUiUtils.px2rem)(19) + ';\n  margin: 0;\n  padding-left: ' + (0, _decisivUiUtils.px2rem)(20) + ';\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Title', _styledComponents2.default.p, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./compositions/ComplaintWidget/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ServiceRequestComplaintWidget = exports.CaseComplaintWidget = undefined;
exports.ComplaintWidget = ComplaintWidget;

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _complaint = __webpack_require__("./utils/complaint.js");

var _complaint2 = _interopRequireDefault(_complaint);

var _Widget = __webpack_require__("./elements/Widget/index.js");

var _Widget2 = _interopRequireDefault(_Widget);

var _CaseComplaintContainer = __webpack_require__("./compositions/ComplaintWidget/CaseComplaintContainer.js");

var _CaseComplaintContainer2 = _interopRequireDefault(_CaseComplaintContainer);

var _ServiceRequestComplaintContainer = __webpack_require__("./compositions/ComplaintWidget/ServiceRequestComplaintContainer.js");

var _ServiceRequestComplaintContainer2 = _interopRequireDefault(_ServiceRequestComplaintContainer);

var _Title = __webpack_require__("./compositions/ComplaintWidget/Title.js");

var _Title2 = _interopRequireDefault(_Title);

var _Content = __webpack_require__("./compositions/ComplaintWidget/Content.js");

var _Content2 = _interopRequireDefault(_Content);

var _messages = __webpack_require__("./compositions/ComplaintWidget/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ComplaintWidget(_ref) {
  var info = _ref.info;

  var _getComplaintText = (0, _complaint2.default)(info, {
    titleInLink: false
  }),
      title = _getComplaintText.title,
      content = _getComplaintText.content;

  return _react2.default.createElement(
    _Widget2.default,
    { id: 'complaints', expandKey: 'complaints' },
    _react2.default.createElement(
      _Widget2.default.Header,
      null,
      _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.title })
    ),
    _react2.default.createElement(
      _Widget2.default.Item,
      null,
      _react2.default.createElement(
        _Title2.default,
        null,
        title
      ),
      _react2.default.createElement(
        _Content2.default,
        null,
        content
      )
    )
  );
}

ComplaintWidget.propTypes = {
  info: _propTypes2.default.shape({
    complaint: _propTypes2.default.shape({
      code: _propTypes2.default.string,
      description: _propTypes2.default.string
    }),
    description: _propTypes2.default.string
  }).isRequired
};

var WidgetWithCommonHOCS = ComplaintWidget;

var CaseComplaintWidget = exports.CaseComplaintWidget = (0, _CaseComplaintContainer2.default)(WidgetWithCommonHOCS);
var ServiceRequestComplaintWidget = exports.ServiceRequestComplaintWidget = (0, _ServiceRequestComplaintContainer2.default)(WidgetWithCommonHOCS);

/***/ }),

/***/ "./compositions/ComplaintWidget/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var formattedMessages = {
  title: (0, _linguiReact.i18nMark)('Complaint')
};

exports.default = formattedMessages;

/***/ }),

/***/ "./compositions/DetailsPage/Container/Component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./utils/prop-types.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Container = function (_Component) {
  _inherits(Container, _Component);

  function Container() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Container);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Container.__proto__ || Object.getPrototypeOf(Container)).call.apply(_ref, [this].concat(args))), _this), _this.buildDetailsPageWithData = function (_ref2) {
      var ChildComponent = _ref2.ChildComponent,
          mappedPageConfig = _ref2.mappedPageConfig;
      var data = mappedPageConfig.data;

      return data.hoc(ChildComponent);
    }, _this.initialize = function (props) {
      var configKey = props.configKey,
          setCurrentPageConfigKey = props.setCurrentPageConfigKey;

      _this.DetailsPageWithData = _this.buildDetailsPageWithData(props);
      setCurrentPageConfigKey(configKey);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Container, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.initialize(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // Switching between different types of detail page should build a new Page component
      if (nextProps.configKey !== this.props.configKey) {
        this.initialize(nextProps);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var DetailsPageWithData = this.DetailsPageWithData;

      var _props = this.props,
          ChildComponent = _props.ChildComponent,
          setCurrentPageConfigKey = _props.setCurrentPageConfigKey,
          rest = _objectWithoutProperties(_props, ['ChildComponent', 'setCurrentPageConfigKey']);

      if (DetailsPageWithData) {
        return _react2.default.createElement(DetailsPageWithData, {
          componentProps: _extends({}, rest)
        });
      }

      return null;
    }
  }]);

  return Container;
}(_react.Component);

Container.propTypes = {
  ChildComponent: _propTypes2.default.func.isRequired,
  configKey: _propTypes2.default.string.isRequired,
  mappedPageConfig: _propTypes2.default.shape({
    fixed: _propTypes2.default.registeredCompositions,
    top: _propTypes2.default.registeredCompositions,
    quick_action_items: _propTypes2.default.shape({
      left: _propTypes2.default.registeredCompositions,
      right: _propTypes2.default.registeredCompositions
    }).isRequired,
    left: _propTypes2.default.registeredCompositions,
    right: _propTypes2.default.registeredCompositions
  }).isRequired,
  pageConfig: _propTypes2.default.shape({
    data: _propTypes2.default.string,
    fixed: _propTypes2.default.compositionConfig,
    top: _propTypes2.default.compositionConfig,
    quick_action_items: _propTypes2.default.shape({
      left: _propTypes2.default.compositionConfig,
      right: _propTypes2.default.compositionConfig
    }).isRequired,
    left: _propTypes2.default.compositionConfig,
    right: _propTypes2.default.compositionConfig
  }).isRequired,
  setCurrentPageConfigKey: _propTypes2.default.func.isRequired
};
exports.default = Container;

/***/ }),

/***/ "./compositions/DetailsPage/Container/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__("./utils/prop-types.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _actions = __webpack_require__("./redux/pageConfigs/actions.js");

var _selectors = __webpack_require__("./redux/pageConfigs/selectors.js");

var _actions2 = __webpack_require__("./redux/ui/actions.js");

var _selectors2 = __webpack_require__("./redux/ui/selectors.js");

var _immutableToJS = __webpack_require__("./utils/immutableToJS.js");

var _immutableToJS2 = _interopRequireDefault(_immutableToJS);

var _mapPageConfigToRegistry = __webpack_require__("./utils/mapPageConfigToRegistry.js");

var _mapPageConfigToRegistry2 = _interopRequireDefault(_mapPageConfigToRegistry);

var _Component = __webpack_require__("./compositions/DetailsPage/Container/Component.js");

var _Component2 = _interopRequireDefault(_Component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var withConnectedData = function withConnectedData(DetailsPage) {
  function WithConnectedData(props) {
    var configKey = props.configKey,
        pageConfig = props.pageConfig;

    var mappedPageConfig = (0, _mapPageConfigToRegistry2.default)(pageConfig, configKey);
    return _react2.default.createElement(_Component2.default, _extends({}, props, {
      mappedPageConfig: mappedPageConfig,
      ChildComponent: DetailsPage
    }));
  }

  WithConnectedData.propTypes = {
    configKey: _propTypes2.default.string.isRequired,
    pageConfig: _propTypes2.default.shape({
      data: _propTypes2.default.string,
      fixed: _propTypes2.default.compositionConfig,
      top: _propTypes2.default.compositionConfig,
      quick_action_items: _propTypes2.default.shape({
        left: _propTypes2.default.compositionConfig,
        right: _propTypes2.default.compositionConfig
      }).isRequired,
      left: _propTypes2.default.compositionConfig,
      right: _propTypes2.default.compositionConfig
    }).isRequired,
    resetHiddenWidgets: _propTypes2.default.func.isRequired
  };

  function mapStateToProps() {
    var getPageConfigByKey = (0, _selectors.makeGetPageConfigByKey)();

    return function (state, props) {
      return {
        hiddenWidgets: (0, _selectors2.hiddenWidgetsSelector)(state),
        leftNavExpanded: (0, _selectors2.leftNavExpandedSelector)(state),
        pageConfig: getPageConfigByKey(state, props.configKey)
      };
    };
  }

  function mapDispatchToProps(dispatch) {
    return {
      resetHiddenWidgets: function resetHiddenWidgets() {
        return dispatch((0, _actions2.resetHiddenWidgets)());
      },
      setCurrentPageConfigKey: function setCurrentPageConfigKey(configKey) {
        return dispatch((0, _actions.setCurrentPageConfigKey)(configKey));
      }
    };
  }

  return (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _immutableToJS2.default)(WithConnectedData));
};

exports.default = withConnectedData;

/***/ }),

/***/ "./compositions/DetailsPage/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DetailsPage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./utils/prop-types.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactScroll = __webpack_require__("../node_modules/react-scroll/modules/index.js");

var _speakingurl = __webpack_require__("../node_modules/speakingurl/index.js");

var _speakingurl2 = _interopRequireDefault(_speakingurl);

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/styled-components-reactive-grid/dist/index.js");

var _document = __webpack_require__("./utils/document.js");

var _Page = __webpack_require__("./elements/Page/index.js");

var _Page2 = _interopRequireDefault(_Page);

var _FloatingHeader = __webpack_require__("./elements/FloatingHeader/index.js");

var _FloatingHeader2 = _interopRequireDefault(_FloatingHeader);

var _Container = __webpack_require__("./compositions/DetailsPage/Container/index.js");

var _Container2 = _interopRequireDefault(_Container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// minimum length to scroll before the floating header is shown/hidden
var FLOATING_HEADER_SCROLL_DOWN_LENGTH = 100;
var FLOATING_HEADER_SCROLL_UP_LENGTH = 500;
var SCROLL_DEBOUNCE_TIME_MS = 250;

var DetailsPage = exports.DetailsPage = function (_Component) {
  _inherits(DetailsPage, _Component);

  function DetailsPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DetailsPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DetailsPage.__proto__ || Object.getPrototypeOf(DetailsPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      floatingHeaderVisible: false,
      currentScrollPosition: 0,
      scrollingDown: true, // if this state is false, it means scrolling up
      startScrollPosition: 0
    }, _this.buildComponents = function (config) {
      return config.map(function (_ref2) {
        var name = _ref2.name,
            Composition = _ref2.composition;

        if (_this.props.hiddenWidgets.includes(name)) {
          return null;
        }

        return _react2.default.createElement(
          _reactScroll.Element,
          { className: 'react-scroll-' + name, key: name, name: name },
          _react2.default.createElement(
            _styledComponentsReactiveGrid.Row,
            null,
            _react2.default.createElement(
              _styledComponentsReactiveGrid.Column,
              { modifiers: ['col'] },
              _react2.default.createElement(Composition, { configName: name })
            )
          )
        );
      });
    }, _this.buildQuickActionItems = function (config) {
      return _react2.default.createElement(
        _styledComponentsReactiveGrid.Row,
        null,
        _react2.default.createElement(
          _styledComponentsReactiveGrid.Column,
          { modifiers: ['col'] },
          _react2.default.createElement(
            _styledComponentsReactiveGrid.Container,
            null,
            _react2.default.createElement(
              _styledComponentsReactiveGrid.Row,
              { modifiers: ['start'] },
              config.left.map(function (_ref3) {
                var name = _ref3.name,
                    Composition = _ref3.composition;
                return _react2.default.createElement(
                  _styledComponentsReactiveGrid.Column,
                  { key: name },
                  _react2.default.createElement(Composition, null)
                );
              })
            )
          )
        ),
        _react2.default.createElement(
          _styledComponentsReactiveGrid.Column,
          { modifiers: ['col'] },
          _react2.default.createElement(
            _styledComponentsReactiveGrid.Container,
            null,
            _react2.default.createElement(
              _styledComponentsReactiveGrid.Row,
              { modifiers: ['end'] },
              config.right.map(function (_ref4) {
                var name = _ref4.name,
                    Composition = _ref4.composition;
                return _react2.default.createElement(
                  _styledComponentsReactiveGrid.Column,
                  { key: name },
                  _react2.default.createElement(Composition, null)
                );
              })
            )
          )
        )
      );
    }, _this.buildHeaderContent = function (mappedPageConfig) {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _styledComponentsReactiveGrid.Container,
          { className: 'fixed' },
          _this.buildComponents(mappedPageConfig.fixed)
        ),
        _react2.default.createElement(
          _styledComponentsReactiveGrid.Container,
          { className: 'quick-action-items' },
          _this.buildQuickActionItems(mappedPageConfig.quick_action_items)
        )
      );
    }, _this.scrollHandler = function () {
      var scrollTop = (0, _document.getScrollTop)(document);

      // update the scroll states
      var scrollingDown = scrollTop > _this.state.currentScrollPosition;
      var startScrollPosition = _this.state.startScrollPosition;
      if (scrollingDown !== _this.state.scrollingDown) {
        startScrollPosition = scrollTop;
      }
      _this.setState({
        currentScrollPosition: scrollTop,
        scrollingDown: scrollingDown,
        startScrollPosition: startScrollPosition
      });

      // set the header visibility states
      var floatingHeaderVisible = _this.state.floatingHeaderVisible;
      if (scrollTop === 0) {
        floatingHeaderVisible = false;
      } else if (scrollingDown && scrollTop - startScrollPosition > FLOATING_HEADER_SCROLL_DOWN_LENGTH) {
        floatingHeaderVisible = false;
      } else if (!scrollingDown && startScrollPosition - scrollTop > FLOATING_HEADER_SCROLL_UP_LENGTH) {
        floatingHeaderVisible = true;
      }
      _this.setState({
        floatingHeaderVisible: floatingHeaderVisible
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DetailsPage, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.scrollListener = (0, _lodash.throttle)(this.scrollHandler, SCROLL_DEBOUNCE_TIME_MS);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('scroll', this.scrollListener);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.scrollListener);
      this.props.resetHiddenWidgets();
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          floatingHeaderVisible = _state.floatingHeaderVisible,
          currentScrollPosition = _state.currentScrollPosition;
      var _props = this.props,
          configKey = _props.configKey,
          leftNavExpanded = _props.leftNavExpanded,
          mappedPageConfig = _props.mappedPageConfig;


      var pageKey = (0, _speakingurl2.default)(configKey);
      var headerFloatingModifier = floatingHeaderVisible && 'visible';
      var leftNavExpandedModifier = leftNavExpanded && 'leftNavExpanded';
      var noTransitionModifier = currentScrollPosition === 0 && 'noTransition';
      var headerContent = this.buildHeaderContent(mappedPageConfig);

      return _react2.default.createElement(
        _Page2.default,
        { id: pageKey },
        _react2.default.createElement(
          _FloatingHeader2.default,
          {
            modifiers: (0, _lodash.compact)([headerFloatingModifier, leftNavExpandedModifier, noTransitionModifier])
          },
          headerContent
        ),
        headerContent,
        _react2.default.createElement(
          _styledComponentsReactiveGrid.Container,
          { className: 'top' },
          this.buildComponents(mappedPageConfig.top)
        ),
        _react2.default.createElement(
          _styledComponentsReactiveGrid.Container,
          { modifiers: ['fluid'] },
          _react2.default.createElement(
            _styledComponentsReactiveGrid.Row,
            null,
            _react2.default.createElement(
              _styledComponentsReactiveGrid.Column,
              { modifiers: ['col_8'] },
              _react2.default.createElement(
                _styledComponentsReactiveGrid.Container,
                { className: 'left', modifiers: ['fluid'] },
                this.buildComponents(mappedPageConfig.left)
              )
            ),
            _react2.default.createElement(
              _styledComponentsReactiveGrid.Column,
              { modifiers: ['col_4'] },
              _react2.default.createElement(
                _styledComponentsReactiveGrid.Container,
                { className: 'right', modifiers: ['fluid'] },
                this.buildComponents(mappedPageConfig.right)
              )
            )
          )
        )
      );
    }
  }]);

  return DetailsPage;
}(_react.Component);

DetailsPage.propTypes = {
  configKey: _propTypes2.default.string.isRequired,
  hiddenWidgets: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  leftNavExpanded: _propTypes2.default.bool.isRequired,
  mappedPageConfig: _propTypes2.default.shape({
    fixed: _propTypes2.default.registeredCompositions,
    top: _propTypes2.default.registeredCompositions,
    quick_action_items: _propTypes2.default.shape({
      left: _propTypes2.default.registeredCompositions,
      right: _propTypes2.default.registeredCompositions
    }).isRequired,
    left: _propTypes2.default.registeredCompositions,
    right: _propTypes2.default.registeredCompositions
  }).isRequired,
  resetHiddenWidgets: _propTypes2.default.func.isRequired
};
exports.default = (0, _Container2.default)(DetailsPage);

/***/ }),

/***/ "./compositions/DiagnosticsWidget/AssetFaultContainer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _immutableToJS = __webpack_require__("./utils/immutableToJS.js");

var _immutableToJS2 = _interopRequireDefault(_immutableToJS);

var _actions = __webpack_require__("./redux/assets/actions.js");

var _selectors = __webpack_require__("./redux/assets/selectors.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var withConnectedData = function withConnectedData(WrappedComponent) {
  function Container(props) {
    return _react2.default.createElement(WrappedComponent, props);
  }

  function mapStateToProps(state) {
    return {
      assetInfo: (0, _selectors.currentAssetSelector)(state),
      faults: (0, _selectors.currentAssetFaultsSelector)(state),
      currentId: (0, _selectors.currentAssetIdSelector)(state)
    };
  }

  function mapDispatchToProps(dispatch) {
    return {
      loadFaults: function loadFaults(assetId) {
        return dispatch((0, _actions.loadAssetFaults)({ assetId: assetId }));
      },
      clearFaults: function clearFaults(caseFaults) {
        return dispatch((0, _actions.setCurrentAssetFaults)(caseFaults));
      }
    };
  }

  return (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _immutableToJS2.default)(Container));
};

exports.default = withConnectedData;

/***/ }),

/***/ "./compositions/DiagnosticsWidget/CaseFaultContainer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _immutableToJS = __webpack_require__("./utils/immutableToJS.js");

var _immutableToJS2 = _interopRequireDefault(_immutableToJS);

var _actions = __webpack_require__("./redux/cases/actions.js");

var _selectors = __webpack_require__("./redux/cases/selectors.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var withConnectedData = function withConnectedData(WrappedComponent) {
  function Container(props) {
    return _react2.default.createElement(WrappedComponent, props);
  }

  function mapStateToProps(state) {
    return {
      assetInfo: (0, _selectors.currentCaseAssetSelector)(state),
      faults: (0, _selectors.currentCaseFaultsSelector)(state),
      currentId: (0, _selectors.currentCaseIdSelector)(state)
    };
  }

  function mapDispatchToProps(dispatch) {
    return {
      loadFaults: function loadFaults(caseId) {
        return dispatch((0, _actions.loadCaseFaults)({ caseId: caseId }));
      },
      clearFaults: function clearFaults(caseFaults) {
        return dispatch((0, _actions.setCurrentCaseFaults)(caseFaults));
      }
    };
  }

  return (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _immutableToJS2.default)(Container));
};

exports.default = withConnectedData;

/***/ }),

/***/ "./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/ContentWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var modifierConfig = {
  smallPadLeft: function smallPadLeft() {
    return {
      styles: 'padding-left: ' + (0, _decisivUiUtils.px2rem)(6) + ';'
    };
  }
};

/* istanbul ignore next */
var styles = function styles() {
  return '\n  padding-left: ' + (0, _decisivUiUtils.px2rem)(12) + ';\n  width: auto;\n';
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('ContentWrapper', _styledComponents2.default.div, styles, { modifierConfig: modifierConfig });

/***/ }),

/***/ "./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/FaultDetails/FaultDetailsWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  background-color: ' + props.theme.colors.base.chrome200 + ';\n  padding: ' + (0, _decisivUiUtils.px2rem)(24) + ';\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome200: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('FaultDetailsWrapper', _styledComponents2.default.div, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/FaultDetails/RelatedFault.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _Container = __webpack_require__("./elements/Container/index.js");

var _Container2 = _interopRequireDefault(_Container);

var _Divider = __webpack_require__("./elements/Divider/index.js");

var _Divider2 = _interopRequireDefault(_Divider);

var _SeverityLabel = __webpack_require__("./components/SeverityLabel/index.js");

var _SeverityLabel2 = _interopRequireDefault(_SeverityLabel);

var _SplitBlock = __webpack_require__("./elements/SplitBlock/index.js");

var _TextDiv = __webpack_require__("./elements/TextDiv/index.js");

var _TextDiv2 = _interopRequireDefault(_TextDiv);

var _Widget = __webpack_require__("./elements/Widget/index.js");

var _Widget2 = _interopRequireDefault(_Widget);

var _timeUtils = __webpack_require__("./utils/timeUtils.js");

var _widget = __webpack_require__("./utils/widget.js");

var _ContentWrapper = __webpack_require__("./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/ContentWrapper.js");

var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);

var _messages = __webpack_require__("./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/messages.js");

var _messages2 = _interopRequireDefault(_messages);

var _RightPanelWrapper = __webpack_require__("./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/RightPanelWrapper.js");

var _RightPanelWrapper2 = _interopRequireDefault(_RightPanelWrapper);

var _StatusItemWrapper = __webpack_require__("./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/StatusItemWrapper.js");

var _StatusItemWrapper2 = _interopRequireDefault(_StatusItemWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RelatedFault(_ref) {
  var fault = _ref.fault;
  var componentId = fault.componentId,
      count = fault.count,
      ecu = fault.ecuId,
      fmi = fault.failureMode,
      rawReportedAt = fault.reportedAt,
      severity = fault.severity,
      status = fault.status;

  var reportedAt = rawReportedAt ? (0, _timeUtils.formatDate)(rawReportedAt) : null;

  return _react2.default.createElement(
    _Container2.default,
    { modifiers: ['fullWidth', 'noPad'] },
    _react2.default.createElement(_Divider2.default, { modifiers: ['extraLightGray', 'gutter'] }),
    _react2.default.createElement(
      _SplitBlock.SplitBlock,
      null,
      _react2.default.createElement(
        _SplitBlock.SplitBlockPart,
        { modifiers: ['column', 'left', 'wide'] },
        _react2.default.createElement(
          _Container2.default,
          null,
          _react2.default.createElement(
            _TextDiv2.default,
            { modifiers: ['bold'] },
            (0, _widget.getOutputText)(componentId)
          )
        ),
        _react2.default.createElement(
          _ContentWrapper2.default,
          { modifiers: ['smallPadLeft'] },
          _react2.default.createElement(
            _SplitBlock.SplitBlock,
            { pad: 'none' },
            _react2.default.createElement(
              _SplitBlock.SplitBlockPart,
              { modifiers: ['left'] },
              _react2.default.createElement(
                _Widget2.default.Table,
                null,
                _react2.default.createElement(
                  'tbody',
                  null,
                  _react2.default.createElement(
                    _Widget2.default.TableRow,
                    null,
                    _react2.default.createElement(
                      'th',
                      null,
                      _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.status })
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      (0, _widget.getOutputText)(status)
                    )
                  ),
                  _react2.default.createElement(
                    _Widget2.default.TableRow,
                    { modifiers: ['topGap'] },
                    _react2.default.createElement(
                      'th',
                      null,
                      _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.datetime })
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      (0, _widget.getOutputText)(reportedAt)
                    )
                  ),
                  _react2.default.createElement(
                    _Widget2.default.TableRow,
                    { modifiers: ['topGap'] },
                    _react2.default.createElement(
                      'th',
                      null,
                      _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.ecu })
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      (0, _widget.getOutputText)(ecu)
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              _SplitBlock.SplitBlockPart,
              { modifiers: ['left'] },
              _react2.default.createElement(
                _Widget2.default.Table,
                null,
                _react2.default.createElement(
                  'tbody',
                  null,
                  _react2.default.createElement(
                    _Widget2.default.TableRow,
                    { modifiers: ['topGap'] },
                    _react2.default.createElement(
                      'th',
                      null,
                      _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.fmi })
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      (0, _widget.getOutputText)(fmi)
                    )
                  ),
                  _react2.default.createElement(
                    _Widget2.default.TableRow,
                    { modifiers: ['topGap'] },
                    _react2.default.createElement(
                      'th',
                      null,
                      _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.count })
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      (0, _widget.getOutputText)(count)
                    )
                  )
                )
              )
            )
          )
        )
      ),
      _react2.default.createElement(
        _SplitBlock.SplitBlockPart,
        { modifiers: ['right'] },
        _react2.default.createElement(
          _Container2.default,
          null,
          _react2.default.createElement(
            _RightPanelWrapper2.default,
            null,
            severity && _react2.default.createElement(
              _StatusItemWrapper2.default,
              null,
              _react2.default.createElement(_SeverityLabel2.default, {
                color: severity.color,
                value: severity.level,
                name: severity.name,
                fontSize: 12
              })
            )
          )
        )
      )
    )
  );
}

RelatedFault.propTypes = {
  fault: _propTypes2.default.shape({
    componentId: _propTypes2.default.string.isRequired
  }).isRequired
};

exports.default = RelatedFault;

/***/ }),

/***/ "./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/FaultDetails/RelatedFaults.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _Container = __webpack_require__("./elements/Container/index.js");

var _Container2 = _interopRequireDefault(_Container);

var _Divider = __webpack_require__("./elements/Divider/index.js");

var _Divider2 = _interopRequireDefault(_Divider);

var _TextDiv = __webpack_require__("./elements/TextDiv/index.js");

var _TextDiv2 = _interopRequireDefault(_TextDiv);

var _messages = __webpack_require__("./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/FaultDetails/messages.js");

var _messages2 = _interopRequireDefault(_messages);

var _RelatedFault = __webpack_require__("./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/FaultDetails/RelatedFault.js");

var _RelatedFault2 = _interopRequireDefault(_RelatedFault);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RelatedFaults(_ref) {
  var data = _ref.data;

  if (data.length <= 0) {
    return null;
  }

  return _react2.default.createElement(
    _Container2.default,
    { modifiers: ['fullWidth', 'noPad'] },
    _react2.default.createElement(_Divider2.default, { modifiers: ['extraWide', 'light'] }),
    _react2.default.createElement(
      _Container2.default,
      null,
      _react2.default.createElement(
        _TextDiv2.default,
        { modifiers: ['bold', 'brand', 'mediumText'] },
        _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.relatedFaults, values: { count: data.length } })
      )
    ),

    // eslint-disable-next-line react/no-array-index-key
    data.map(function (fault, index) {
      return _react2.default.createElement(_RelatedFault2.default, { key: index, fault: fault });
    })
  );
}

RelatedFaults.propTypes = {
  data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    componentId: _propTypes2.default.string.isRequired
  })).isRequired
};

exports.default = RelatedFaults;

/***/ }),

/***/ "./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/FaultDetails/SnapShot.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _Container = __webpack_require__("./elements/Container/index.js");

var _Container2 = _interopRequireDefault(_Container);

var _Divider = __webpack_require__("./elements/Divider/index.js");

var _Divider2 = _interopRequireDefault(_Divider);

var _TextDiv = __webpack_require__("./elements/TextDiv/index.js");

var _TextDiv2 = _interopRequireDefault(_TextDiv);

var _messages = __webpack_require__("./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/FaultDetails/messages.js");

var _messages2 = _interopRequireDefault(_messages);

var _SnapShotTable = __webpack_require__("./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/FaultDetails/SnapShotTable.js");

var _SnapShotTable2 = _interopRequireDefault(_SnapShotTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SnapShot(_ref) {
  var data = _ref.data;

  var title = data.category.toLowerCase() === 'unknown' ? _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.other }) : data.category;

  return _react2.default.createElement(
    _Container2.default,
    {
      modifiers: ['fullWidth', 'noPad']
    },
    _react2.default.createElement(
      _Container2.default,
      null,
      _react2.default.createElement(
        _TextDiv2.default,
        { modifiers: ['bold', 'darkGreyText', 'mediumText'] },
        title
      )
    ),
    _react2.default.createElement(_Divider2.default, { modifiers: ['extraLightGray', 'gutter'] }),
    _react2.default.createElement(
      _Container2.default,
      { modifiers: ['fullWidth'] },
      _react2.default.createElement(
        _SnapShotTable2.default,
        null,
        _react2.default.createElement(
          'thead',
          null,
          _react2.default.createElement(
            'tr',
            null,
            _react2.default.createElement(
              'th',
              null,
              _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.item })
            ),
            _react2.default.createElement(
              'th',
              null,
              _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.value })
            ),
            _react2.default.createElement(
              'th',
              null,
              _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.measure })
            )
          )
        ),
        _react2.default.createElement(
          'tbody',
          null,
          data.items.map(function (item) {
            return _react2.default.createElement(
              'tr',
              { key: item.description },
              _react2.default.createElement(
                'th',
                null,
                item.description
              ),
              _react2.default.createElement(
                'td',
                null,
                item.value
              ),
              _react2.default.createElement(
                'td',
                null,
                item.unit
              )
            );
          })
        )
      )
    )
  );
}

SnapShot.propTypes = {
  data: _propTypes2.default.shape({
    category: _propTypes2.default.string.isRequired,
    items: _propTypes2.default.array.isRequired
  }).isRequired
};

exports.default = SnapShot;

/***/ }),

/***/ "./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/FaultDetails/SnapShotTable.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  border-collapse: collapse;\n  border: 2px solid ' + props.theme.colors.base.chrome200 + ';\n  padding-left: ' + (0, _decisivUiUtils.px2rem)(32) + ';\n  text-align: left;\n  width: 100%;\n  thead {\n    th {\n      font-size: ' + (0, _decisivUiUtils.px2rem)(14) + ';\n      padding: ' + (0, _decisivUiUtils.px2rem)(16) + ';\n      text-transform: uppercase;\n    }\n  }\n  tbody {\n    color: ' + props.theme.colors.base.textLight + ';\n    font-size: ' + (0, _decisivUiUtils.px2rem)(12) + ';\n    tr:nth-child(odd) {\n      background-color: ' + props.theme.colors.base.chrome100 + ';\n    }\n    th,\n    td {\n      padding: ' + (0, _decisivUiUtils.px2rem)(8) + ' ' + (0, _decisivUiUtils.px2rem)(16) + ';\n    }\n    td {\n      font-weight: 200;\n    }\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome100: _propTypes2.default.string.isRequired,
      chrome200: _propTypes2.default.string.isRequired,
      textLight: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('SnapShotTable', _styledComponents2.default.table, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/FaultDetails/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactiveContainer = __webpack_require__("../node_modules/reactive-container/dist/index.js");

var _Card = __webpack_require__("./elements/Card/index.js");

var _Card2 = _interopRequireDefault(_Card);

var _Container = __webpack_require__("./elements/Container/index.js");

var _FaultDetailsWrapper = __webpack_require__("./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/FaultDetails/FaultDetailsWrapper.js");

var _FaultDetailsWrapper2 = _interopRequireDefault(_FaultDetailsWrapper);

var _RelatedFaults = __webpack_require__("./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/FaultDetails/RelatedFaults.js");

var _RelatedFaults2 = _interopRequireDefault(_RelatedFaults);

var _SnapShot = __webpack_require__("./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/FaultDetails/SnapShot.js");

var _SnapShot2 = _interopRequireDefault(_SnapShot);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FaultDetails(_ref) {
  var fault = _ref.fault;
  var snapshots = fault.snapshots,
      relatedFaults = fault.relatedFaults;


  return _react2.default.createElement(
    _FaultDetailsWrapper2.default,
    null,
    _react2.default.createElement(
      _Card2.default,
      null,
      _react2.default.createElement(
        _Container.ReactiveContainer,
        {
          breakpoints: [{ name: _reactiveContainer.sizes.LG, minWidth: 800 }],
          modifiers: ['fullWidth', 'noPad']
        },
        snapshots.map(function (snapshot) {
          return _react2.default.createElement(_SnapShot2.default, { key: snapshot.category, data: snapshot });
        }),
        _react2.default.createElement(_RelatedFaults2.default, { data: relatedFaults })
      )
    )
  );
}

FaultDetails.propTypes = {
  fault: _propTypes2.default.shape({
    relatedFaults: _propTypes2.default.array.isRequired,
    snapshots: _propTypes2.default.array.isRequired
  }).isRequired
};

exports.default = FaultDetails;

/***/ }),

/***/ "./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/FaultDetails/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  item: (0, _linguiReact.i18nMark)('Item'),
  value: (0, _linguiReact.i18nMark)('Value'),
  measure: (0, _linguiReact.i18nMark)('Measure'),
  other: (0, _linguiReact.i18nMark)('Other'),
  relatedFaults: (0, _linguiReact.i18nMark)('Related Faults ({count})')
};

exports.default = messages;

/***/ }),

/***/ "./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/HeadingWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  color: ' + props.theme.colors.base.linkHover + ';\n  font-size: ' + (0, _decisivUiUtils.px2rem)(12) + ';\n  font-weight: 600;\n  padding: ' + (0, _decisivUiUtils.px2rem)(3) + ';\n  position: relative;\n  text-transform: uppercase;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      linkHover: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('HeadingWrapper', _styledComponents2.default.div, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/ModalCaseFault.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _reactSmoothCollapse = __webpack_require__("../node_modules/react-smooth-collapse/js/index.js");

var _reactSmoothCollapse2 = _interopRequireDefault(_reactSmoothCollapse);

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _SeverityLabel = __webpack_require__("./components/SeverityLabel/index.js");

var _SeverityLabel2 = _interopRequireDefault(_SeverityLabel);

var _Container = __webpack_require__("./elements/Container/index.js");

var _Container2 = _interopRequireDefault(_Container);

var _SplitBlock = __webpack_require__("./elements/SplitBlock/index.js");

var _Widget = __webpack_require__("./elements/Widget/index.js");

var _Widget2 = _interopRequireDefault(_Widget);

var _timeUtils = __webpack_require__("./utils/timeUtils.js");

var _widget = __webpack_require__("./utils/widget.js");

var _messages = __webpack_require__("./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/messages.js");

var _messages2 = _interopRequireDefault(_messages);

var _Wrapper = __webpack_require__("./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/Wrapper.js");

var _Wrapper2 = _interopRequireDefault(_Wrapper);

var _HeadingWrapper = __webpack_require__("./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/HeadingWrapper.js");

var _HeadingWrapper2 = _interopRequireDefault(_HeadingWrapper);

var _RepairInstructionsLink = __webpack_require__("./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/RepairInstructionsLink.js");

var _RepairInstructionsLink2 = _interopRequireDefault(_RepairInstructionsLink);

var _RightPanelWrapper = __webpack_require__("./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/RightPanelWrapper.js");

var _RightPanelWrapper2 = _interopRequireDefault(_RightPanelWrapper);

var _StatusItemWrapper = __webpack_require__("./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/StatusItemWrapper.js");

var _StatusItemWrapper2 = _interopRequireDefault(_StatusItemWrapper);

var _TitleWrapper = __webpack_require__("./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/TitleWrapper.js");

var _TitleWrapper2 = _interopRequireDefault(_TitleWrapper);

var _ContentWrapper = __webpack_require__("./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/ContentWrapper.js");

var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);

var _ShowDetailsIcon = __webpack_require__("./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/ShowDetailsIcon.js");

var _ShowDetailsIcon2 = _interopRequireDefault(_ShowDetailsIcon);

var _FaultDetails = __webpack_require__("./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/FaultDetails/index.js");

var _FaultDetails2 = _interopRequireDefault(_FaultDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ModalCaseFault = function (_Component) {
  _inherits(ModalCaseFault, _Component);

  function ModalCaseFault() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ModalCaseFault);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ModalCaseFault.__proto__ || Object.getPrototypeOf(ModalCaseFault)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      displayDetailsChevron: false
    }, _this.setDisplayDetailsChevron = function (_ref2) {
      var displayDetailsChevron = _ref2.displayDetailsChevron;

      _this.setState({ displayDetailsChevron: displayDetailsChevron });
    }, _this.toggleDetailView = function (e) {
      e.preventDefault();
      var _this$props$displayFa = _this.props.displayFault,
          fault = _this$props$displayFa.fault,
          showDetails = _this$props$displayFa.showDetails;

      _this.props.handleTitleClick(fault.id, !showDetails);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ModalCaseFault, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props$displayFault = this.props.displayFault,
          fault = _props$displayFault.fault,
          showDetails = _props$displayFault.showDetails;
      var componentId = fault.componentId,
          count = fault.count,
          ecu = fault.ecuId,
          fmi = fault.failureMode,
          repairInstructionsUrl = fault.repairInstructionsUrl,
          rawReportedAt = fault.reportedAt,
          _fault$severity = fault.severity;
      _fault$severity = _fault$severity === undefined ? {} : _fault$severity;
      var severityColor = _fault$severity.color,
          severityLevel = _fault$severity.level,
          severityName = _fault$severity.name,
          status = fault.status;

      var componentIdComponent = _react2.default.createElement(
        'span',
        null,
        componentId
      );
      var reportedAt = rawReportedAt ? (0, _timeUtils.formatDate)(rawReportedAt) : null;

      var isBottom = this.props.bottom && 'bottom';

      return _react2.default.createElement(
        _Wrapper2.default,
        { modifiers: (0, _lodash.compact)([isBottom]) },
        _react2.default.createElement(
          _SplitBlock.SplitBlock,
          { modifiers: ['pad'] },
          _react2.default.createElement(
            _HeadingWrapper2.default,
            {
              onClick: this.toggleDetailView,
              onMouseEnter: function onMouseEnter() {
                return _this2.setDisplayDetailsChevron({ displayDetailsChevron: true });
              },
              onMouseLeave: function onMouseLeave() {
                return _this2.setDisplayDetailsChevron({ displayDetailsChevron: false });
              }
            },
            _react2.default.createElement(_ShowDetailsIcon2.default, {
              modifiers: (0, _lodash.compact)([!this.state.displayDetailsChevron && 'hidden']),
              showDetails: showDetails
            }),
            _react2.default.createElement(
              _TitleWrapper2.default,
              { modifiers: ['padLeft'] },
              (0, _widget.getOutputText)(componentIdComponent)
            )
          )
        ),
        _react2.default.createElement(
          _ContentWrapper2.default,
          null,
          _react2.default.createElement(
            _SplitBlock.SplitBlock,
            { modifiers: ['pad'] },
            _react2.default.createElement(
              _SplitBlock.SplitBlockPart,
              { modifiers: ['left'] },
              _react2.default.createElement(
                _Widget2.default.Table,
                null,
                _react2.default.createElement(
                  'tbody',
                  null,
                  _react2.default.createElement(
                    _Widget2.default.TableRow,
                    null,
                    _react2.default.createElement(
                      'th',
                      null,
                      _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.status })
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      (0, _widget.getOutputText)(status)
                    )
                  ),
                  _react2.default.createElement(
                    _Widget2.default.TableRow,
                    { modifiers: ['topGap'] },
                    _react2.default.createElement(
                      'th',
                      null,
                      _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.datetime })
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      (0, _widget.getOutputText)(reportedAt)
                    )
                  ),
                  _react2.default.createElement(
                    _Widget2.default.TableRow,
                    { modifiers: ['topGap'] },
                    _react2.default.createElement(
                      'th',
                      null,
                      _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.ecu })
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      (0, _widget.getOutputText)(ecu)
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              _SplitBlock.SplitBlockPart,
              { modifiers: ['left'] },
              _react2.default.createElement(
                _Widget2.default.Table,
                null,
                _react2.default.createElement(
                  'tbody',
                  null,
                  _react2.default.createElement(
                    _Widget2.default.TableRow,
                    { modifiers: ['topGap'] },
                    _react2.default.createElement(
                      'th',
                      null,
                      _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.fmi })
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      (0, _widget.getOutputText)(fmi)
                    )
                  ),
                  _react2.default.createElement(
                    _Widget2.default.TableRow,
                    { modifiers: ['topGap'] },
                    _react2.default.createElement(
                      'th',
                      null,
                      _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.count })
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      (0, _widget.getOutputText)(count)
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              _SplitBlock.SplitBlockPart,
              { modifiers: ['right'] },
              _react2.default.createElement(
                _Container2.default,
                null,
                _react2.default.createElement(
                  _RightPanelWrapper2.default,
                  null,
                  _react2.default.createElement(
                    _StatusItemWrapper2.default,
                    null,
                    _react2.default.createElement(_SeverityLabel2.default, {
                      color: severityColor,
                      value: severityLevel,
                      name: severityName,
                      fontSize: 12
                    })
                  ),
                  repairInstructionsUrl && _react2.default.createElement(
                    _StatusItemWrapper2.default,
                    null,
                    _react2.default.createElement(_RepairInstructionsLink2.default, { href: repairInstructionsUrl })
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _reactSmoothCollapse2.default,
          { expanded: showDetails },
          _react2.default.createElement(_FaultDetails2.default, { fault: fault })
        )
      );
    }
  }]);

  return ModalCaseFault;
}(_react.Component);

ModalCaseFault.propTypes = {
  bottom: _propTypes2.default.bool,
  displayFault: _propTypes2.default.shape({
    fault: _propTypes2.default.object.isRequired,
    isExpanded: _propTypes2.default.bool,
    showDetails: _propTypes2.default.bool
  }).isRequired,
  handleTitleClick: _propTypes2.default.func.isRequired
};
ModalCaseFault.defaultProps = {
  bottom: false
};
exports.default = ModalCaseFault;

/***/ }),

/***/ "./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/RepairInstructionsIconWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  color: ' + props.theme.colors.base.text + ';\n  margin-right: ' + (0, _decisivUiUtils.px2rem)(5) + ';\n  .fa {\n    font-size: ' + (0, _decisivUiUtils.px2rem)(15) + ';\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('RepairInstructionsIconWrapper', _styledComponents2.default.span, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/RepairInstructionsLink.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactFontawesome = __webpack_require__("../node_modules/react-fontawesome/lib/index.js");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _baseComponents = __webpack_require__("../node_modules/base-components/build/index.js");

var _RepairInstructionsIconWrapper = __webpack_require__("./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/RepairInstructionsIconWrapper.js");

var _RepairInstructionsIconWrapper2 = _interopRequireDefault(_RepairInstructionsIconWrapper);

var _messages = __webpack_require__("./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RepairInstructionsLink(_ref) {
  var href = _ref.href;

  return _react2.default.createElement(
    _baseComponents.A,
    { href: href },
    _react2.default.createElement(
      _RepairInstructionsIconWrapper2.default,
      null,
      _react2.default.createElement(_reactFontawesome2.default, { name: 'file-pdf-o' })
    ),
    _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.viewRepairInstructions })
  );
}

RepairInstructionsLink.propTypes = {
  href: _propTypes2.default.string.isRequired
};

exports.default = RepairInstructionsLink;

/***/ }),

/***/ "./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/RightPanelWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles() {
  return '\n  padding-right: ' + (0, _decisivUiUtils.px2rem)(8) + ';\n  text-align: right;\n';
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('RightPanelWrapper', _styledComponents2.default.div, styles);

/***/ }),

/***/ "./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/ShowDetailsIcon.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactFontawesome = __webpack_require__("../node_modules/react-fontawesome/lib/index.js");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _ShowDetailsIconWrapper = __webpack_require__("./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/ShowDetailsIconWrapper.js");

var _ShowDetailsIconWrapper2 = _interopRequireDefault(_ShowDetailsIconWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ShowDetailsIcon(_ref) {
  var modifiers = _ref.modifiers,
      showDetails = _ref.showDetails;

  return _react2.default.createElement(
    _ShowDetailsIconWrapper2.default,
    { modifiers: modifiers },
    _react2.default.createElement(_reactFontawesome2.default, { name: showDetails ? 'chevron-up' : 'chevron-down' })
  );
}

ShowDetailsIcon.propTypes = {
  modifiers: _propTypes2.default.arrayOf(_propTypes2.default.string),
  showDetails: _propTypes2.default.bool.isRequired
};

ShowDetailsIcon.defaultProps = {
  modifiers: []
};

exports.default = ShowDetailsIcon;

/***/ }),

/***/ "./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/ShowDetailsIconWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var modifierConfig = {
  hidden: function hidden() {
    return {
      styles: '\n      visibility: hidden;\n    '
    };
  }
};

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  color: ' + props.theme.colors.base.chrome300 + ';\n  left: -' + (0, _decisivUiUtils.px2rem)(4) + ';\n  position: absolute;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome300: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('ShowDetailsIconWrapper', _styledComponents2.default.div, styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

/***/ }),

/***/ "./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/StatusItemWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles() {
  return '\n  height: ' + (0, _decisivUiUtils.px2rem)(30) + ';\n';
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('StatusItemWrapper', _styledComponents2.default.div, styles);

/***/ }),

/***/ "./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/TitleWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var modifierConfig = {
  padLeft: function padLeft() {
    return {
      styles: '\n      padding-left: ' + (0, _decisivUiUtils.px2rem)(12) + ';\n    '
    };
  }
};

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  color: ' + props.theme.colors.base.text + ';\n  cursor: pointer;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('TitleWrapper', _styledComponents2.default.div, styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

/***/ }),

/***/ "./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/Wrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var modifierConfig = {
  bottom: function bottom(_ref) {
    var theme = _ref.theme;
    return {
      styles: '\n      border-bottom: 1px solid ' + theme.colors.base.chrome200 + ';\n    '
    };
  }
};

/* istanbul ignore next */
var styles = function styles() {
  return '\n  font-size: ' + (0, _decisivUiUtils.px2rem)(12) + ';\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome200: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Wrapper', _styledComponents2.default.section, styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

/***/ }),

/***/ "./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalCaseFault = undefined;

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _Expandable = __webpack_require__("./containers/Expandable/index.js");

var _Expandable2 = _interopRequireDefault(_Expandable);

var _SeverityLabel = __webpack_require__("./components/SeverityLabel/index.js");

var _SeverityLabel2 = _interopRequireDefault(_SeverityLabel);

var _Link = __webpack_require__("./elements/Link/index.js");

var _Link2 = _interopRequireDefault(_Link);

var _SplitBlock = __webpack_require__("./elements/SplitBlock/index.js");

var _Widget = __webpack_require__("./elements/Widget/index.js");

var _Widget2 = _interopRequireDefault(_Widget);

var _timeUtils = __webpack_require__("./utils/timeUtils.js");

var _widget = __webpack_require__("./utils/widget.js");

var _messages = __webpack_require__("./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/messages.js");

var _messages2 = _interopRequireDefault(_messages);

var _Wrapper = __webpack_require__("./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/Wrapper.js");

var _Wrapper2 = _interopRequireDefault(_Wrapper);

var _HeadingWrapper = __webpack_require__("./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/HeadingWrapper.js");

var _HeadingWrapper2 = _interopRequireDefault(_HeadingWrapper);

var _RepairInstructionsLink = __webpack_require__("./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/RepairInstructionsLink.js");

var _RepairInstructionsLink2 = _interopRequireDefault(_RepairInstructionsLink);

var _RightPanelWrapper = __webpack_require__("./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/RightPanelWrapper.js");

var _RightPanelWrapper2 = _interopRequireDefault(_RightPanelWrapper);

var _StatusItemWrapper = __webpack_require__("./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/StatusItemWrapper.js");

var _StatusItemWrapper2 = _interopRequireDefault(_StatusItemWrapper);

var _TitleWrapper = __webpack_require__("./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/TitleWrapper.js");

var _TitleWrapper2 = _interopRequireDefault(_TitleWrapper);

var _ContentWrapper = __webpack_require__("./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/ContentWrapper.js");

var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);

var _ModalCaseFault2 = __webpack_require__("./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/ModalCaseFault.js");

var _ModalCaseFault3 = _interopRequireDefault(_ModalCaseFault2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CaseFault(_ref) {
  var bottom = _ref.bottom,
      displayFault = _ref.displayFault,
      onExpand = _ref.onExpand,
      handleTitleClick = _ref.handleTitleClick;
  var fault = displayFault.fault,
      isExpanded = displayFault.isExpanded;

  var componentId = fault.componentId;
  var componentIdComponent = _react2.default.createElement(
    _Link2.default,
    {
      to: '#',
      onClick: function onClick(e) {
        return e.preventDefault();
      },
      modifiers: ['hoverCaret']
    },
    componentId
  );

  var status = fault.status;
  var rawReportedAt = fault.reportedAt;
  var reportedAt = rawReportedAt ? (0, _timeUtils.formatDate)(rawReportedAt) : null;
  var repairInstructionsUrl = fault.repairInstructionsUrl;
  var ecu = fault.ecuId;
  var fmi = fault.failureMode;
  var count = fault.count;
  var severity = fault.severity;
  var severityColor = severity.color;
  var severityLevel = severity.level;
  var severityName = severity.name;

  var onTitleClick = function onTitleClick(e) {
    e.preventDefault();
    handleTitleClick(fault.id, !isExpanded);
  };

  var isBottom = bottom && 'bottom';

  return _react2.default.createElement(
    _Wrapper2.default,
    { modifiers: (0, _lodash.compact)([isBottom]) },
    _react2.default.createElement(
      _Expandable2.default,
      { isExpanded: isExpanded, onExpand: onExpand },
      _react2.default.createElement(
        _Expandable.ExpandableHeader,
        null,
        _react2.default.createElement(
          _SplitBlock.SplitBlock,
          { modifiers: ['pad'] },
          _react2.default.createElement(
            _HeadingWrapper2.default,
            { onClick: onTitleClick },
            _react2.default.createElement(
              _TitleWrapper2.default,
              null,
              (0, _widget.getOutputText)(componentIdComponent)
            )
          )
        )
      ),
      _react2.default.createElement(
        _Expandable.ExpandableContent,
        null,
        _react2.default.createElement(
          _ContentWrapper2.default,
          null,
          _react2.default.createElement(
            _SplitBlock.SplitBlock,
            { modifiers: ['pad'] },
            _react2.default.createElement(
              _SplitBlock.SplitBlockPart,
              { modifiers: ['left'] },
              _react2.default.createElement(
                _Widget2.default.Table,
                null,
                _react2.default.createElement(
                  'tbody',
                  null,
                  _react2.default.createElement(
                    _Widget2.default.TableRow,
                    null,
                    _react2.default.createElement(
                      'th',
                      null,
                      _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.status })
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      (0, _widget.getOutputText)(status)
                    )
                  ),
                  _react2.default.createElement(
                    _Widget2.default.TableRow,
                    { modifiers: ['topGap'] },
                    _react2.default.createElement(
                      'th',
                      null,
                      _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.datetime })
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      (0, _widget.getOutputText)(reportedAt)
                    )
                  ),
                  _react2.default.createElement(
                    _Widget2.default.TableRow,
                    { modifiers: ['topGap'] },
                    _react2.default.createElement(
                      'th',
                      null,
                      _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.ecu })
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      (0, _widget.getOutputText)(ecu)
                    )
                  ),
                  _react2.default.createElement(
                    _Widget2.default.TableRow,
                    { modifiers: ['topGap'] },
                    _react2.default.createElement(
                      'th',
                      null,
                      _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.fmi })
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      (0, _widget.getOutputText)(fmi)
                    )
                  ),
                  _react2.default.createElement(
                    _Widget2.default.TableRow,
                    { modifiers: ['topGap'] },
                    _react2.default.createElement(
                      'th',
                      null,
                      _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.count })
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      (0, _widget.getOutputText)(count)
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              _SplitBlock.SplitBlockPart,
              { modifiers: ['right'] },
              _react2.default.createElement(
                _RightPanelWrapper2.default,
                null,
                _react2.default.createElement(
                  _StatusItemWrapper2.default,
                  null,
                  _react2.default.createElement(_SeverityLabel2.default, {
                    color: severityColor,
                    value: severityLevel,
                    name: severityName,
                    fontSize: 12
                  })
                ),
                repairInstructionsUrl && _react2.default.createElement(
                  _StatusItemWrapper2.default,
                  null,
                  _react2.default.createElement(_RepairInstructionsLink2.default, { href: repairInstructionsUrl })
                )
              )
            )
          )
        )
      )
    )
  );
}

CaseFault.propTypes = {
  bottom: _propTypes2.default.bool,
  displayFault: _propTypes2.default.shape({
    fault: _propTypes2.default.object.isRequired,
    isExpanded: _propTypes2.default.bool
  }).isRequired,
  onExpand: _propTypes2.default.func,
  handleTitleClick: _propTypes2.default.func.isRequired
};

CaseFault.defaultProps = {
  bottom: false,
  onExpand: _lodash.noop
};

exports.default = CaseFault;
exports.ModalCaseFault = _ModalCaseFault3.default;

/***/ }),

/***/ "./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  additionalWarnings: (0, _linguiReact.i18nMark)('Additional Warnings'),
  componentId: (0, _linguiReact.i18nMark)('Component Id'),
  count: (0, _linguiReact.i18nMark)('Count'),
  datetime: (0, _linguiReact.i18nMark)('Date/Time'),
  ecu: (0, _linguiReact.i18nMark)('ECU'),
  fmi: (0, _linguiReact.i18nMark)('FMI'),
  status: (0, _linguiReact.i18nMark)('Status'),
  viewRepairInstructions: (0, _linguiReact.i18nMark)('View Repair Instructions')
};

exports.default = messages;

/***/ }),

/***/ "./compositions/DiagnosticsWidget/DiagnosticsComponent/DiagnosticsOptionsBar/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DropDownSelector = __webpack_require__("./components/_common/DropDownSelector/index.js");

var _DropDownSelector2 = _interopRequireDefault(_DropDownSelector);

var _SplitBlock = __webpack_require__("./elements/SplitBlock/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DiagnosticsOptionsBar(_ref) {
  var options = _ref.options,
      onChangeOption = _ref.onChangeOption;

  return _react2.default.createElement(
    _SplitBlock.SplitBlock,
    { modifiers: ['pad'] },
    _react2.default.createElement(
      _SplitBlock.SplitBlockPart,
      { modifiers: ['right'] },
      _react2.default.createElement(_DropDownSelector2.default, {
        onChange: onChangeOption,
        options: options
      })
    )
  );
}

DiagnosticsOptionsBar.propTypes = {
  options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    value: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.string.isRequired
  })).isRequired,
  onChangeOption: _propTypes2.default.func.isRequired
};

DiagnosticsOptionsBar.defaultProps = {
  selectedDiagnosticsOption: undefined
};

exports.default = DiagnosticsOptionsBar;

/***/ }),

/***/ "./compositions/DiagnosticsWidget/DiagnosticsComponent/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _ModalWindow = __webpack_require__("./components/ModalWindow/index.js");

var _ModalWindow2 = _interopRequireDefault(_ModalWindow);

var _TabBar = __webpack_require__("./components/TabBar/index.js");

var _TabBar2 = _interopRequireDefault(_TabBar);

var _Widget = __webpack_require__("./elements/Widget/index.js");

var _Widget2 = _interopRequireDefault(_Widget);

var _CaseFault = __webpack_require__("./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/index.js");

var _CaseFault2 = _interopRequireDefault(_CaseFault);

var _DiagnosticsOptionsBar = __webpack_require__("./compositions/DiagnosticsWidget/DiagnosticsComponent/DiagnosticsOptionsBar/index.js");

var _DiagnosticsOptionsBar2 = _interopRequireDefault(_DiagnosticsOptionsBar);

var _messages = __webpack_require__("./compositions/DiagnosticsWidget/DiagnosticsComponent/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DiagnosticsComponent(_ref) {
  var currentFaultType = _ref.currentFaultType,
      displayFaults = _ref.displayFaults,
      options = _ref.options,
      faultTypes = _ref.faultTypes,
      handleChangeDiagnosticsOption = _ref.handleChangeDiagnosticsOption,
      handleChangeDiagnosticsModalOption = _ref.handleChangeDiagnosticsModalOption,
      handleExpandFault = _ref.handleExpandFault,
      handleFaultTypeChange = _ref.handleFaultTypeChange,
      handleHideDetailsModal = _ref.handleHideDetailsModal,
      handleShowDetailsModal = _ref.handleShowDetailsModal,
      handleShowFaultDetails = _ref.handleShowFaultDetails,
      showDetailsModal = _ref.showDetailsModal;

  function renderListOfFaults(_ref2) {
    var Component = _ref2.Component,
        handleTitleClick = _ref2.handleTitleClick,
        _ref2$buildExtraProps = _ref2.buildExtraProps,
        buildExtraProps = _ref2$buildExtraProps === undefined ? _lodash.noop : _ref2$buildExtraProps;

    return displayFaults.map(function (displayFault, index) {
      var caseFaultId = displayFault.fault.id;
      return _react2.default.createElement(Component, _extends({
        key: caseFaultId,
        bottom: index === displayFaults.size - 1,
        displayFault: displayFault,
        handleTitleClick: handleTitleClick
      }, buildExtraProps(displayFault)));
    });
  }

  function caseFaults() {
    var buildExtraProps = function buildExtraProps(displayFault) {
      return {
        onExpand: function onExpand(expanded) {
          return handleExpandFault(displayFault.fault.id, expanded);
        }
      };
    };

    return renderListOfFaults({
      Component: _CaseFault2.default,
      handleTitleClick: handleShowDetailsModal,
      buildExtraProps: buildExtraProps
    });
  }

  function modalCaseFaults() {
    return renderListOfFaults({
      Component: _CaseFault.ModalCaseFault,
      handleTitleClick: handleShowFaultDetails
    });
  }

  return _react2.default.createElement(
    _Widget2.default,
    { id: 'diagnostics', width: 'full', expandKey: 'diagnostics' },
    _react2.default.createElement(
      _Widget2.default.Header,
      null,
      _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.title })
    ),
    _react2.default.createElement(
      _Widget2.default.Item,
      null,
      _react2.default.createElement(
        _TabBar2.default,
        {
          currentTab: currentFaultType,
          emptyMessage: _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.noFaults }),
          onChangeTab: handleFaultTypeChange,
          tabs: faultTypes
        },
        _react2.default.createElement(
          _TabBar.TabBarOptionsWrapper,
          null,
          _react2.default.createElement(_DiagnosticsOptionsBar2.default, {
            options: options,
            onChangeOption: handleChangeDiagnosticsOption
          })
        )
      ),
      caseFaults()
    ),
    showDetailsModal && _react2.default.createElement(
      _ModalWindow2.default,
      {
        headerInfo: { title: _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.modalTitle }) },
        hideModal: handleHideDetailsModal,
        hideByClickingBackground: true
      },
      _react2.default.createElement(
        _TabBar2.default,
        {
          currentTab: currentFaultType,
          emptyMessage: _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.noFaults }),
          onChangeTab: handleFaultTypeChange,
          tabs: faultTypes
        },
        _react2.default.createElement(
          _TabBar.TabBarOptionsWrapper,
          null,
          _react2.default.createElement(_DiagnosticsOptionsBar2.default, {
            options: options,
            onChangeOption: handleChangeDiagnosticsModalOption
          })
        )
      ),
      modalCaseFaults()
    )
  );
}

DiagnosticsComponent.propTypes = {
  currentFaultType: _propTypes2.default.string,
  options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    value: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.string.isRequired
  })).isRequired,
  displayFaults: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    isExpanded: _propTypes2.default.bool.isRequired,
    faultTypeMap: _propTypes2.default.object.isRequired,
    fault: _propTypes2.default.shape({
      id: _propTypes2.default.string.isRequired
    }).isRequired
  })).isRequired,
  faultTypes: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    type: _propTypes2.default.string.isRequired,
    name: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.string.isRequired
  })).isRequired,
  handleChangeDiagnosticsOption: _propTypes2.default.func.isRequired,
  handleChangeDiagnosticsModalOption: _propTypes2.default.func.isRequired,
  handleExpandFault: _propTypes2.default.func.isRequired,
  handleFaultTypeChange: _propTypes2.default.func.isRequired,
  handleHideDetailsModal: _propTypes2.default.func.isRequired,
  handleShowDetailsModal: _propTypes2.default.func.isRequired,
  handleShowFaultDetails: _propTypes2.default.func.isRequired,
  showDetailsModal: _propTypes2.default.bool.isRequired
};

DiagnosticsComponent.defaultProps = {
  currentFaultType: ''
};

exports.default = DiagnosticsComponent;

/***/ }),

/***/ "./compositions/DiagnosticsWidget/DiagnosticsComponent/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  modalTitle: (0, _linguiReact.i18nMark)('Diagnostics Details'),
  noFaults: (0, _linguiReact.i18nMark)('Not available. Please check again later.'),
  title: (0, _linguiReact.i18nMark)('Diagnostics')
};

exports.default = messages;

/***/ }),

/***/ "./compositions/DiagnosticsWidget/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FAULT_TYPE_MAPS = exports.DISPLAY_OPTIONS = undefined;

var _messages = __webpack_require__("./compositions/DiagnosticsWidget/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DISPLAY_OPTIONS = exports.DISPLAY_OPTIONS = [{
  value: 'expand',
  label: _messages2.default.expandAll
}, {
  value: 'collapse',
  label: _messages2.default.collapseAll
}];

var FAULT_TYPE_MAPS = exports.FAULT_TYPE_MAPS = [{
  type: 'VehicleNotification::CumminsFault',
  name: 'cummins',
  label: 'Cummins'
}, {
  type: 'VehicleNotification::OsVolvoLinkFault-Mack',
  name: 'guard-dog',
  label: 'GuardDog'
}, {
  type: 'VehicleNotification::OsVolvoLinkFault-Volvo',
  name: 'volvo-rd',
  label: 'Volvo RD'
}, {
  type: 'VehicleNotification::NoregonFault',
  name: 'tds',
  label: 'Noregon'
}];

/***/ }),

/***/ "./compositions/DiagnosticsWidget/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CaseFaultDiagnosticsWidget = exports.AssetFaultDiagnosticsWidget = exports.DiagnosticsWidget = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.getFormattedFaultType = getFormattedFaultType;

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _AssetFaultContainer = __webpack_require__("./compositions/DiagnosticsWidget/AssetFaultContainer.js");

var _AssetFaultContainer2 = _interopRequireDefault(_AssetFaultContainer);

var _CaseFaultContainer = __webpack_require__("./compositions/DiagnosticsWidget/CaseFaultContainer.js");

var _CaseFaultContainer2 = _interopRequireDefault(_CaseFaultContainer);

var _constants = __webpack_require__("./compositions/DiagnosticsWidget/constants.js");

var _DiagnosticsComponent = __webpack_require__("./compositions/DiagnosticsWidget/DiagnosticsComponent/index.js");

var _DiagnosticsComponent2 = _interopRequireDefault(_DiagnosticsComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Filters allDisplayFaults and returns only those matching the currentFaultType
 * @param  {Array} allDisplayFaults   An Array of all the display fault objects
 * @param  {String} currentFaultType The name of the currently viewed fault type
 * @return {Array}                    An Array of display fault objects matching the
 *                                   currentFaultType
 */
function filterDisplayFaults(allDisplayFaults, currentFaultType) {
  return allDisplayFaults.filter(function (displayFault) {
    return displayFault.faultTypeMap.name === currentFaultType;
  });
}

/**
 * Collects and returns unique fault type maps from allDisplayFaults
 * @param  {Array} allDisplayFaults   An Array of all the display fault objects
 * @return {Array}                   An array of unique fault type maps that represent the types
 *                                   found in allDisplayFaults
 */
function getFaultTypeMaps(allDisplayFaults) {
  var allFaultTypes = allDisplayFaults.map(function (f) {
    return f.faultTypeMap;
  });
  return (0, _lodash.uniqBy)(allFaultTypes, function (value) {
    return value.type;
  });
}

/**
 * Formats the fault types based on asset make and model. Specifically, converts Volvo faults to
 * Mack branding on Mack assets.
 * @param  {String} faultType The core application's fault type
 * @param  {Object} assetInfo    The current asset data as held in state
 * @return {String}           The updated fault type (may be the original fault type);
 */
function getFormattedFaultType(faultType, assetInfo) {
  if (faultType !== 'VehicleNotification::OsVolvoLinkFault') {
    return faultType;
  }

  var vinNumber = assetInfo.vinNumber;
  if (vinNumber) {
    var assetMake = assetInfo.make;
    if (vinNumber.startsWith('1M1') || assetMake === 'Mack') {
      return 'VehicleNotification::OsVolvoLinkFault-Mack';
    }
    if (vinNumber.startsWith('4V4') || assetMake === 'Volvo') {
      return 'VehicleNotification::OsVolvoLinkFault-Volvo';
    }
  }
  return 'VehicleNotification::OsVolvoLinkFault-Volvo';
}

var DiagnosticsWidget = exports.DiagnosticsWidget = function (_Component) {
  _inherits(DiagnosticsWidget, _Component);

  function DiagnosticsWidget() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DiagnosticsWidget);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DiagnosticsWidget.__proto__ || Object.getPrototypeOf(DiagnosticsWidget)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      allDisplayFaults: [],
      currentFaultType: '',
      displayFaults: [],
      faultTypeMaps: [],
      showDetailsModal: false
    }, _this.buildAllDisplayFaults = function (faults, assetInfo) {
      return faults.map(function (fault) {
        var oldFault = _this.state.allDisplayFaults.find(function (f) {
          return f.fault.id === fault.id;
        }) || {};
        var faultTypeMap = oldFault.faultTypeMap;
        if (!faultTypeMap) {
          var formattedFaultType = getFormattedFaultType(fault.faultType, assetInfo);
          faultTypeMap = (0, _lodash.find)(_constants.FAULT_TYPE_MAPS, function (map) {
            return map.type === formattedFaultType;
          });
        }

        // TODO: Ignoring the faults that do not have the faultTypeMap defined (e.g. HinoFault)
        // Will need to revisit this to cover these ignored fault types.
        return faultTypeMap && {
          fault: fault,
          faultTypeMap: faultTypeMap,
          isExpanded: (0, _lodash.has)(oldFault, 'isExpanded') ? !!oldFault.expanded : true,
          showDetails: (0, _lodash.has)(oldFault, 'showDetails') ? !!oldFault.showDetails : false
        };
      }).filter(Boolean);
    }, _this.options = function () {
      var _this$props = _this.props,
          options = _this$props.options,
          i18n = _this$props.i18n;

      return options.map(function (opt) {
        return _extends({}, opt, {
          label: i18n._(opt.label)
        });
      });
    }, _this.handleChangeDiagnosticsOption = function (_ref2) {
      var value = _ref2.value;

      if (value === 'collapse') {
        _this.updateDisplayFaults({ isExpanded: false });
      }
      if (value === 'expand') {
        _this.updateDisplayFaults({ isExpanded: true });
      }
    }, _this.handleChangeDiagnosticsModalOption = function (_ref3) {
      var value = _ref3.value;

      if (value === 'collapse') {
        _this.updateDisplayFaults({ showDetails: false });
      }
      if (value === 'expand') {
        _this.updateDisplayFaults({ showDetails: true });
      }
    }, _this.handleExpandFault = function (faultId, isExpanded) {
      _this.updateDisplayFault(faultId, { isExpanded: isExpanded });
    }, _this.handleFaultTypeChange = function (type) {
      _this.setState({ currentFaultType: type });
    }, _this.handleHideDetailsModal = function () {
      _this.updateDisplayFaults({ showDetails: false });
      _this.setState({ showDetailsModal: false });
    }, _this.handleShowDetailsModal = function (faultId) {
      _this.updateDisplayFault(faultId, { showDetails: true });
      _this.setState({ showDetailsModal: true });
    }, _this.handleShowFaultDetails = function (faultId, showDetails) {
      _this.updateDisplayFault(faultId, { showDetails: showDetails });
    }, _this.updateDisplayFault = function (faultId, options) {
      var displayFaults = _this.state.displayFaults.map(function (f) {
        if (f.fault.id === faultId) {
          return _extends({}, f, options);
        }
        return f;
      });
      _this.setState({ displayFaults: displayFaults });
    }, _this.updateDisplayFaults = function (options) {
      var displayFaults = _this.state.displayFaults.map(function (f) {
        return _extends({}, f, options);
      });
      _this.setState({ displayFaults: displayFaults });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DiagnosticsWidget, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.loadFaults(this.props.currentId);
    }

    /**
     * Parses case faults with asset info to determine the fault types and the current type.
     * @param {Object} nextProps
     */

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var faults = nextProps.faults,
          assetInfo = nextProps.assetInfo;

      if (assetInfo.id && faults.length > 0 && this.state.allDisplayFaults.length === 0) {
        var allDisplayFaults = this.buildAllDisplayFaults(faults, assetInfo);
        var faultTypeMaps = getFaultTypeMaps(allDisplayFaults);
        var currentFaultType = faultTypeMaps[0] && faultTypeMaps[0].name;
        var displayFaults = filterDisplayFaults(allDisplayFaults, currentFaultType);

        this.setState({ allDisplayFaults: allDisplayFaults, currentFaultType: currentFaultType, displayFaults: displayFaults, faultTypeMaps: faultTypeMaps });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.clearFaults();
    }

    /**
     * Builds a collection of objects defining some properties concerning the display of case faults
     * @param  {Array} faults The case faults as they exist in redux state
     * @param  {Object} assetInfo The asset info for the current case, also held in redux state.
     * @return {Array}  An Array with the following fields:
     *                  fault {Object} The original fault as held in redux state.
     *                  faultTypeMap {Object} Contains data concerning the remapping of the fault type
     *                  isExpanded {Boolean} The expanded state of the case fault.
     *                  showDetails {Boolean} The state of details display within the modal view.
     */


    /**
     * Builds a list of options with translated labels
     * @return {Array} Option objects for the options DropDownSelector
     */


    /**
     * Calls the appropriate method based on the newly selected diagnostics option,
     * then clears that option.
     * @param {Object} options An object with data concerning which option has been selected.
     * @param {String} options.value 'expand' or 'collpase'. Indicates which action to perform.
     */


    /**
     * Calls the appropriate method based on the newly selected diagnostics option,
     * then clears that option.
     * @param {Object} options An object with data concerning which option has been selected.
     * @param {String} options.value 'expand' or 'collpase'. Indicates which action to perform.
     */


    /**
     * Updates the expanded state of a fault in this.state.displayFaults
     * @param  {String}  faultId    The id of the fault that requires updating
     * @param  {Boolean} isExpanded The expanded state of that fault.
     */


    /**
     * Updates the type of fault currently being displayed in local state.
     * @param  {String} type The name of the fault type that was selected.
     */


    /**
     * Closes the fault details modal and sets all faults to hide the full details.
     */


    /**
     * Opens the fault details modal with the selected fault expanded to show all details.
     * @param  {string} faultId The id of the fault that should be fully expanded.
     */


    /**
     * Opens the fault details within the modal.
     * @param  {String} faultId      The id of the fault that should have the details displayed
     * @param  {Boolean} showDetails The state of the details view
     */


    /**
     * Updates a single display fault within the List of displayFaults
     * @param  {String} faultId The id of the fault that should have the details updated
     * @param  {Object} options An object with the options to update on the display fault
     */


    /**
     * Updates properties on all display faults within the List of displayFaults.
     * @param  {Object} options An object with options to update on all display faults
     */

  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          currentFaultType = _state.currentFaultType,
          displayFaults = _state.displayFaults,
          faultTypeMaps = _state.faultTypeMaps,
          showDetailsModal = _state.showDetailsModal;


      return _react2.default.createElement(_DiagnosticsComponent2.default, {
        currentFaultType: currentFaultType,
        displayFaults: displayFaults,
        faultTypes: faultTypeMaps,
        options: this.options(),
        handleChangeDiagnosticsOption: this.handleChangeDiagnosticsOption,
        handleChangeDiagnosticsModalOption: this.handleChangeDiagnosticsModalOption,
        handleExpandFault: this.handleExpandFault,
        handleFaultTypeChange: this.handleFaultTypeChange,
        handleHideDetailsModal: this.handleHideDetailsModal,
        handleShowDetailsModal: this.handleShowDetailsModal,
        handleShowFaultDetails: this.handleShowFaultDetails,
        showDetailsModal: showDetailsModal
      });
    }
  }]);

  return DiagnosticsWidget;
}(_react.Component);

DiagnosticsWidget.propTypes = {
  assetInfo: _propTypes2.default.shape({
    vinNumber: _propTypes2.default.string,
    make: _propTypes2.default.string
  }).isRequired,
  currentId: _propTypes2.default.string.isRequired,
  faults: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
  options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    value: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.string.isRequired
  })).isRequired,
  i18n: _propTypes2.default.shape({
    _: _propTypes2.default.func.isRequired
  }).isRequired,
  clearFaults: _propTypes2.default.func.isRequired,
  loadFaults: _propTypes2.default.func.isRequired
};
DiagnosticsWidget.defaultProps = {
  options: _constants.DISPLAY_OPTIONS,
  assetInfo: {}
};


var DiagnosticsWidgetWithCommonHOCS = (0, _linguiReact.withI18n)()(DiagnosticsWidget);

var AssetFaultDiagnosticsWidget = exports.AssetFaultDiagnosticsWidget = (0, _AssetFaultContainer2.default)(DiagnosticsWidgetWithCommonHOCS);
var CaseFaultDiagnosticsWidget = exports.CaseFaultDiagnosticsWidget = (0, _CaseFaultContainer2.default)(DiagnosticsWidgetWithCommonHOCS);

/***/ }),

/***/ "./compositions/DiagnosticsWidget/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  collapseAll: (0, _linguiReact.i18nMark)('Collapse All'),
  expandAll: (0, _linguiReact.i18nMark)('Expand All')
};

exports.default = messages;

/***/ }),

/***/ "./compositions/EstimateInvoiceDecidedWidget/Container.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _immutableToJS = __webpack_require__("./utils/immutableToJS.js");

var _immutableToJS2 = _interopRequireDefault(_immutableToJS);

var _selectors = __webpack_require__("./redux/cases/selectors.js");

var _actions = __webpack_require__("./redux/ui/actions.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var withConnectedData = function withConnectedData(WrappedComponent) {
  function Container(props) {
    return _react2.default.createElement(WrappedComponent, props);
  }

  Container.propTypes = {
    caseInfo: _propTypes2.default.shape({
      approvalStatus: _propTypes2.default.string
    }).isRequired
  };

  Container.defaultProps = {
    caseInfo: {
      approvalStatus: ''
    }
  };

  function mapStateToProps(state) {
    return {
      caseInfo: (0, _selectors.currentCaseSelector)(state)
    };
  }

  function mapDispatchToProps(dispatch) {
    return {
      addHiddenWidget: function addHiddenWidget(payload) {
        return dispatch((0, _actions.addHiddenWidget)(payload));
      }
    };
  }

  return (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _immutableToJS2.default)(Container));
};

exports.default = withConnectedData;

/***/ }),

/***/ "./compositions/EstimateInvoiceDecidedWidget/InvoiceInfo.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculatePercentage = calculatePercentage;
exports.colorForPercentage = colorForPercentage;
exports.formatPercentage = formatPercentage;

var _numeral = __webpack_require__("../node_modules/numeral/numeral.js");

var _numeral2 = _interopRequireDefault(_numeral);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _recompose = __webpack_require__("../node_modules/recompose/es/Recompose.js");

var _widget = __webpack_require__("./utils/widget.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function calculatePercentage(estimateTotalString, invoiceTotalString) {
  var invoiceTotal = (0, _numeral2.default)(invoiceTotalString).value();
  var estimateTotal = (0, _numeral2.default)(estimateTotalString).value();
  var percentageFloat = (invoiceTotal - estimateTotal) / estimateTotal * 100;
  return parseInt(percentageFloat, 10);
}

function colorForPercentage(percentage, theme) {
  switch (true) {
    case percentage > 0:
      return theme.colors.status.danger;
    case percentage < 0:
      return theme.colors.status.success;
    default:
      return 'inherit';
  }
}

function formatPercentage(percentage) {
  switch (true) {
    case percentage > 0:
      return ' (+' + percentage + '%)';
    case percentage < 0:
      return ' (' + percentage + '%)';
    default:
      return null;
  }
}

function InvoiceInfo(_ref) {
  var estimateTotal = _ref.estimateTotal,
      invoiceTotal = _ref.invoiceTotal,
      theme = _ref.theme;

  var percentage = estimateTotal && invoiceTotal ? calculatePercentage(estimateTotal, invoiceTotal) : 0;

  var color = colorForPercentage(percentage, theme);
  var formattedPercentage = formatPercentage(percentage);

  return _react2.default.createElement(
    'div',
    { style: { color: color } },
    (0, _widget.getOutputText)(invoiceTotal),
    formattedPercentage
  );
}

InvoiceInfo.propTypes = {
  estimateTotal: _propTypes2.default.string,
  invoiceTotal: _propTypes2.default.string,
  theme: _propTypes2.default.shape({
    colors: _propTypes2.default.shape({
      status: _propTypes2.default.shape({
        danger: _propTypes2.default.string.isRequired,
        success: _propTypes2.default.string.isRequired
      }).isRequired
    }).isRequired
  }).isRequired
};

InvoiceInfo.defaultProps = {
  estimateTotal: null,
  invoiceTotal: null
};

exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('InvoiceInfo'), _styledComponents.withTheme)(InvoiceInfo);

/***/ }),

/***/ "./compositions/EstimateInvoiceDecidedWidget/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EstimateInvoiceDecidedWidget = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = __webpack_require__("../node_modules/recompose/es/Recompose.js");

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _InlineEditableField = __webpack_require__("./components/_common/InlineEditableField/index.js");

var _InlineEditableField2 = _interopRequireDefault(_InlineEditableField);

var _Widget = __webpack_require__("./elements/Widget/index.js");

var _Widget2 = _interopRequireDefault(_Widget);

var _PdfLink = __webpack_require__("./components/PdfLink/index.js");

var _PdfLink2 = _interopRequireDefault(_PdfLink);

var _timeUtils = __webpack_require__("./utils/timeUtils.js");

var _widget = __webpack_require__("./utils/widget.js");

var _cardType = __webpack_require__("./utils/cardType.js");

var _cardType2 = _interopRequireDefault(_cardType);

var _messages = __webpack_require__("./compositions/EstimateInvoiceDecidedWidget/messages.js");

var _messages2 = _interopRequireDefault(_messages);

var _InvoiceInfo = __webpack_require__("./compositions/EstimateInvoiceDecidedWidget/InvoiceInfo.js");

var _InvoiceInfo2 = _interopRequireDefault(_InvoiceInfo);

var _Container = __webpack_require__("./compositions/EstimateInvoiceDecidedWidget/Container.js");

var _Container2 = _interopRequireDefault(_Container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EstimateInvoiceDecidedWidget = exports.EstimateInvoiceDecidedWidget = function (_Component) {
  _inherits(EstimateInvoiceDecidedWidget, _Component);

  function EstimateInvoiceDecidedWidget() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, EstimateInvoiceDecidedWidget);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EstimateInvoiceDecidedWidget.__proto__ || Object.getPrototypeOf(EstimateInvoiceDecidedWidget)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      poNumber: '',
      initialPoNumber: ''
    }, _this.onChangePONumber = function (e) {
      _this.setState({
        poNumber: e.target.value
      });
    }, _this.onUpdatePONumber = function (isSubmitting) {
      if (!isSubmitting) {
        _this.setState({
          poNumber: _this.state.initialPoNumber
        });
      }
    }, _this.setInitialPONumber = function (value) {
      _this.setState({
        initialPoNumber: value
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(EstimateInvoiceDecidedWidget, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (!this.widgetShouldRender()) {
        var _props = this.props,
            configName = _props.configName,
            addHiddenWidget = _props.addHiddenWidget;

        addHiddenWidget(configName);
      }
    }
  }, {
    key: 'widgetShouldRender',
    value: function widgetShouldRender() {
      var approvalStatus = this.props.caseInfo.approvalStatus;

      return approvalStatus !== 'Pending';
    }
  }, {
    key: 'render',
    value: function render() {
      var caseInfo = this.props.caseInfo;
      var approvalStatus = caseInfo.approvalStatus,
          etr = caseInfo.etr,
          roUrl = caseInfo.roUrl,
          roNumber = caseInfo.roNumber,
          invoiceId = caseInfo.invoiceId,
          invoiceTotal = caseInfo.invoiceTotal,
          estimateTotal = caseInfo.estimateTotal,
          approvalComment = caseInfo.approvalComment,
          invoiceDate = caseInfo.invoiceDate;


      var formattedEtr = etr ? (0, _timeUtils.formatDate)(etr) : (0, _widget.getOutputText)(etr);
      var poNumber = this.state.poNumber || caseInfo.poNumber || '';
      var invoiceDateStr = invoiceDate ? (0, _timeUtils.formatDate)(invoiceDate) : (0, _widget.getOutputText)(invoiceDate);
      var isApprovedOrDeclined = approvalStatus === 'approved' || approvalStatus === 'declined';
      var approvalCommentModifier = roUrl && 'topGap';
      var statusCardType = (0, _cardType2.default)(approvalStatus);

      if (!this.widgetShouldRender()) {
        return null;
      }

      return _react2.default.createElement(
        _Widget2.default,
        {
          id: 'estimate-invoice',
          className: 'estimate-invoice-decided',
          expandKey: 'estimate-invoice'
        },
        _react2.default.createElement(
          _Widget2.default.Header,
          null,
          _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.title })
        ),
        _react2.default.createElement(
          _Widget2.default.Item,
          null,
          _react2.default.createElement(
            _Widget2.default.SubHeader,
            { modifiers: (0, _lodash.compact)([statusCardType]) },
            approvalStatus
          )
        ),
        _react2.default.createElement(
          _Widget2.default.Item,
          { horizontal: true },
          _react2.default.createElement(
            _Widget2.default.Table,
            null,
            _react2.default.createElement(
              'tbody',
              null,
              _react2.default.createElement(
                _Widget2.default.TableRow,
                null,
                _react2.default.createElement(
                  'th',
                  null,
                  _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.amount })
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  estimateTotal
                )
              ),
              _react2.default.createElement(
                _Widget2.default.TableRow,
                { modifiers: ['topGap'] },
                _react2.default.createElement(
                  'th',
                  null,
                  _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.etr })
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  formattedEtr
                )
              ),
              _react2.default.createElement(
                _Widget2.default.TableRow,
                { modifiers: ['topGap'] },
                _react2.default.createElement(
                  'th',
                  null,
                  _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.repairOrder })
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  roNumber && '#',
                  (0, _widget.getOutputText)(roNumber)
                )
              ),
              _react2.default.createElement(
                _Widget2.default.TableRow,
                { modifiers: ['topGap'] },
                _react2.default.createElement(
                  'th',
                  null,
                  _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.po })
                ),
                isApprovedOrDeclined ? _react2.default.createElement(
                  'td',
                  null,
                  _react2.default.createElement(_InlineEditableField2.default, {
                    value: poNumber,
                    onUpdate: this.onUpdatePONumber,
                    onChange: this.onChangePONumber,
                    getInitialValue: this.setInitialPONumber
                  })
                ) : _react2.default.createElement(
                  'td',
                  null,
                  poNumber && '#',
                  (0, _widget.getOutputText)(poNumber)
                )
              ),
              _react2.default.createElement(
                _Widget2.default.TableRow,
                { modifiers: ['topGap'] },
                _react2.default.createElement(
                  'th',
                  null,
                  _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.invoice })
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  invoiceId && '#',
                  (0, _widget.getOutputText)(invoiceId)
                )
              ),
              _react2.default.createElement(
                _Widget2.default.TableRow,
                null,
                _react2.default.createElement('td', null),
                _react2.default.createElement(
                  'td',
                  null,
                  _react2.default.createElement(_InvoiceInfo2.default, { estimateTotal: estimateTotal, invoiceTotal: invoiceTotal })
                )
              ),
              _react2.default.createElement(
                _Widget2.default.TableRow,
                null,
                _react2.default.createElement('th', null),
                _react2.default.createElement(
                  'td',
                  null,
                  invoiceDateStr
                )
              )
            )
          ),
          _react2.default.createElement(
            _Widget2.default.Table,
            null,
            _react2.default.createElement(
              'tbody',
              null,
              _react2.default.createElement(
                _Widget2.default.TableRow,
                null,
                _react2.default.createElement(
                  'th',
                  null,
                  roUrl && _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.estimates })
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  _react2.default.createElement(
                    _PdfLink2.default,
                    { url: roUrl },
                    _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.viewLatestEstimate })
                  )
                )
              ),
              _react2.default.createElement(
                _Widget2.default.TableRow,
                { modifiers: (0, _lodash.compact)([approvalCommentModifier]) },
                _react2.default.createElement(
                  'th',
                  null,
                  approvalComment && _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.comments })
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  approvalComment
                )
              )
            )
          )
        ),
        _react2.default.createElement(_Widget2.default.Item, null)
      );
    }
  }]);

  return EstimateInvoiceDecidedWidget;
}(_react.Component);

EstimateInvoiceDecidedWidget.propTypes = {
  caseInfo: _propTypes2.default.shape({
    approvalStatus: _propTypes2.default.string,
    estimateTotal: _propTypes2.default.string,
    invoiceId: _propTypes2.default.string,
    invoiceTotal: _propTypes2.default.string,
    roNumber: _propTypes2.default.string,
    poNumber: _propTypes2.default.string
  }).isRequired,
  configName: _propTypes2.default.string.isRequired,
  addHiddenWidget: _propTypes2.default.func.isRequired
};

exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('EstimateInvoiceDecidedWidget'), _Container2.default)(EstimateInvoiceDecidedWidget);

/***/ }),

/***/ "./compositions/EstimateInvoiceDecidedWidget/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var formattedMessages = {
  accept: (0, _linguiReact.i18nMark)('Accept'),
  amount: (0, _linguiReact.i18nMark)('Amount'),
  approve: (0, _linguiReact.i18nMark)('Approve'),
  comments: (0, _linguiReact.i18nMark)('Comments'),
  decline: (0, _linguiReact.i18nMark)('Decline'),
  error: (0, _linguiReact.i18nMark)('Error'),
  estimates: (0, _linguiReact.i18nMark)('Estimates'),
  estimateTotal: (0, _linguiReact.i18nMark)('Estimate Total'),
  etr: (0, _linguiReact.i18nMark)('ETR'),
  invoice: (0, _linguiReact.i18nMark)('Invoice'),
  invoiceDate: (0, _linguiReact.i18nMark)('Invoice Date'),
  invoiceId: (0, _linguiReact.i18nMark)('Invoice Id'),
  optional: (0, _linguiReact.i18nMark)('Optional'),
  po: (0, _linguiReact.i18nMark)('Purchase Order'),
  provideANote: (0, _linguiReact.i18nMark)('Provide a Note about your decision'),
  repairOrder: (0, _linguiReact.i18nMark)('Repair Order'),
  submissionFailed: (0, _linguiReact.i18nMark)('Your submission has failed.'),
  submit: (0, _linguiReact.i18nMark)('SUBMIT'),
  title: (0, _linguiReact.i18nMark)('Estimate/Invoice'),
  viewEstimate: (0, _linguiReact.i18nMark)('View Estimate'),
  viewLatestEstimate: (0, _linguiReact.i18nMark)('View Latest Estimate')
};

exports.default = formattedMessages;

/***/ }),

/***/ "./compositions/EstimateInvoicePendingWidget/Container.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _immutableToJS = __webpack_require__("./utils/immutableToJS.js");

var _immutableToJS2 = _interopRequireDefault(_immutableToJS);

var _selectors = __webpack_require__("./redux/cases/selectors.js");

var _actions = __webpack_require__("./redux/cases/actions.js");

var _actions2 = __webpack_require__("./redux/ui/actions.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var withConnectedData = function withConnectedData(WrappedComponent) {
  function Container(props) {
    return _react2.default.createElement(WrappedComponent, props);
  }

  Container.propTypes = {
    caseInfo: _propTypes2.default.shape({
      approvalStatus: _propTypes2.default.string
    }).isRequired
  };

  Container.defaultProps = {
    caseInfo: {
      approvalStatus: ''
    }
  };

  function mapStateToProps(state) {
    return {
      caseInfo: (0, _selectors.currentCaseSelector)(state),
      casesError: (0, _selectors.casesErrorSelector)(state),
      casesRequesting: (0, _selectors.casesRequestingSelector)(state)
    };
  }

  function mapDispatchToProps(dispatch) {
    return {
      updateCase: function updateCase(payload) {
        return dispatch((0, _actions.updateCaseRequest)(payload));
      },
      addHiddenWidget: function addHiddenWidget(payload) {
        return dispatch((0, _actions2.addHiddenWidget)(payload));
      }
    };
  }

  return (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _immutableToJS2.default)(Container));
};

exports.default = withConnectedData;

/***/ }),

/***/ "./compositions/EstimateInvoicePendingWidget/DropdownWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = function styles(_ref) {
  var theme = _ref.theme;
  return '\n  position: relative;\n  display: flex;\n  align-items: center;\n\n  .Dropdown-control .ButtonLink {\n    color: ' + theme.colors.base.chrome000 + ';\n  }\n\n  .Dropdown-option .ButtonLink {\n    color: ' + theme.colors.base.link + ';\n  }\n\n  .Dropdown-option.is-selected .ButtonLink {\n    color: ' + theme.colors.base.chrome000 + ';\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome000: _propTypes2.default.string.isRequired,
      link: _propTypes2.default.string.isRequired
    })
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('DropdownWrapper', _styledComponents2.default.div, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./compositions/EstimateInvoicePendingWidget/NoteDialog/DialogHelp.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  color: ' + props.theme.colors.base.chrome500 + ';\n  font-style: italic;\n  font-weight: 300;\n  line-height: ' + (0, _decisivUiUtils.px2rem)(15) + ';\n  margin-top: ' + (0, _decisivUiUtils.px2rem)(2) + ';\n  strong {\n    font-weight: 600;\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome500: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('DialogHelp', _styledComponents2.default.div, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./compositions/EstimateInvoicePendingWidget/NoteDialog/DialogTitle.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  color: ' + props.theme.colors.base.text + ';\n  font-weight: bold;\n  line-height: ' + (0, _decisivUiUtils.px2rem)(19) + ';\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('DialogTitle', _styledComponents2.default.div, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./compositions/EstimateInvoicePendingWidget/NoteDialog/NoteInput.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  border-radius: 2px;\n  border: none;\n  box-shadow: 0 0 2px 0 ' + props.theme.colors.base.shadow + ';\n  box-sizing: border-box;\n  color: ' + props.theme.colors.base.text + ';\n  font-weight: 500;\n  height: ' + (0, _decisivUiUtils.px2rem)(92) + ';\n  line-height: ' + (0, _decisivUiUtils.px2rem)(19) + ';\n  margin-top: ' + (0, _decisivUiUtils.px2rem)(6) + ';\n  outline: none;\n  overflow-y: auto;\n  padding: ' + (0, _decisivUiUtils.px2rem)(7.8) + ' ' + (0, _decisivUiUtils.px2rem)(14) + ' ' + (0, _decisivUiUtils.px2rem)(9.8) + ' ' + (0, _decisivUiUtils.px2rem)(11) + ';\n  resize: none;\n  width: 100%;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      shadow: _propTypes2.default.string.isRequired,
      text: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('NoteInput', _styledComponents2.default.textarea, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./compositions/EstimateInvoicePendingWidget/NoteDialog/NoteSubmitLinks.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  margin-top: ', ';\n  display: flex;\n  justify-content: space-between;\n'], ['\n  margin-top: ', ';\n  display: flex;\n  justify-content: space-between;\n']);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var NoteSubmitLinks = function () {
  var c = _styledComponents2.default.div(_templateObject, (0, _decisivUiUtils.px2rem)(12));

  c.displayName = 'NoteSubmitLinks';
  return c;
}();

exports.default = NoteSubmitLinks;

/***/ }),

/***/ "./compositions/EstimateInvoicePendingWidget/NoteDialog/Wrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  background-color: ' + props.theme.colors.base.background + ';\n  font-size: ' + props.theme.dimensions.fontSizeNormal + ';\n  padding: ' + (0, _decisivUiUtils.px2rem)(10) + ';\n  width: ' + (0, _decisivUiUtils.px2rem)(365) + ';\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      background: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired,
  dimensions: _propTypes2.default.shape({
    fontSizeNormal: _propTypes2.default.string.isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Wrapper', _styledComponents2.default.div, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./compositions/EstimateInvoicePendingWidget/NoteDialog/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _baseComponents = __webpack_require__("../node_modules/base-components/build/index.js");

var _Wrapper = __webpack_require__("./compositions/EstimateInvoicePendingWidget/NoteDialog/Wrapper.js");

var _Wrapper2 = _interopRequireDefault(_Wrapper);

var _DialogTitle = __webpack_require__("./compositions/EstimateInvoicePendingWidget/NoteDialog/DialogTitle.js");

var _DialogTitle2 = _interopRequireDefault(_DialogTitle);

var _DialogHelp = __webpack_require__("./compositions/EstimateInvoicePendingWidget/NoteDialog/DialogHelp.js");

var _DialogHelp2 = _interopRequireDefault(_DialogHelp);

var _NoteInput = __webpack_require__("./compositions/EstimateInvoicePendingWidget/NoteDialog/NoteInput.js");

var _NoteInput2 = _interopRequireDefault(_NoteInput);

var _NoteSubmitLinks = __webpack_require__("./compositions/EstimateInvoicePendingWidget/NoteDialog/NoteSubmitLinks.js");

var _NoteSubmitLinks2 = _interopRequireDefault(_NoteSubmitLinks);

var _messages = __webpack_require__("./compositions/EstimateInvoicePendingWidget/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NoteDialog = function (_Component) {
  _inherits(NoteDialog, _Component);

  function NoteDialog() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NoteDialog);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NoteDialog.__proto__ || Object.getPrototypeOf(NoteDialog)).call.apply(_ref, [this].concat(args))), _this), _this.setFocus = function () {
      _this.noteTextArea.focus();
    }, _this.handleNoteChange = function (ev) {
      _this.setState({
        note: ev.target.value
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NoteDialog, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setState({
        note: this.props.note
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      setTimeout(this.setFocus, 100);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          title = _props.title,
          okLabel = _props.okLabel,
          cancelLabel = _props.cancelLabel,
          onOk = _props.onOk,
          onCancel = _props.onCancel;
      var note = this.state.note;

      return _react2.default.createElement(
        _Wrapper2.default,
        null,
        _react2.default.createElement(
          _DialogTitle2.default,
          null,
          title
        ),
        _react2.default.createElement(
          _DialogHelp2.default,
          null,
          _react2.default.createElement(
            'strong',
            null,
            _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.optional }),
            ':\xA0'
          ),
          _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.provideANote }),
            ':'
          )
        ),
        _react2.default.createElement(_NoteInput2.default, {
          value: note,
          onChange: this.handleNoteChange,
          innerRef: function innerRef(input) {
            _this2.noteTextArea = input;
          }
        }),
        _react2.default.createElement(
          _NoteSubmitLinks2.default,
          null,
          _react2.default.createElement(
            _baseComponents.ButtonLink,
            { onClick: onCancel },
            cancelLabel
          ),
          _react2.default.createElement(
            _baseComponents.ButtonLink,
            { onClick: function onClick() {
                return onOk(note);
              } },
            okLabel
          )
        )
      );
    }
  }]);

  return NoteDialog;
}(_react.Component);

NoteDialog.propTypes = {
  title: _propTypes2.default.string,
  note: _propTypes2.default.string,
  okLabel: _propTypes2.default.string,
  cancelLabel: _propTypes2.default.string,
  onOk: _propTypes2.default.func,
  onCancel: _propTypes2.default.func
};
NoteDialog.defaultProps = {
  title: 'Approve',
  note: '',
  okLabel: 'OK',
  cancelLabel: 'Cancel',
  onOk: _lodash.noop,
  onCancel: _lodash.noop
};
exports.default = NoteDialog;

/***/ }),

/***/ "./compositions/EstimateInvoicePendingWidget/Wrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  font-size: ' + props.theme.dimensions.fontSizeNormal + ';\n\n  .estimate-label {\n    background-color: ' + props.theme.colors.base.chrome100 + ';\n    flex: 1;\n    font-weight: 700;\n    padding: ' + props.theme.dimensions.fontSizeNormal + ' ' + (0, _decisivUiUtils.px2rem)(10) + ';\n  }\n\n  .estimate-value {\n    background-color: ' + props.theme.colors.base.chrome200 + ';\n    margin: 0 ' + (0, _decisivUiUtils.px2rem)(15) + ' 0 ' + (0, _decisivUiUtils.px2rem)(2) + ';\n    padding: ' + props.theme.dimensions.fontSizeNormal + ' 0;\n    text-align: center;\n    width: ' + (0, _decisivUiUtils.px2rem)(135) + ';\n  }\n\n  .Dropdown-control {\n    height: 37px;\n  }\n\n  .error {\n    color: ' + props.theme.colors.status.danger + ';\n    margin-right: 15px;\n  }\n  .bold {\n    font-weight: bold;\n  }\n  .fa-ban {\n    margin-right: 10px;\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome100: _propTypes2.default.string.isRequired,
      chrome200: _propTypes2.default.string.isRequired
    }).isRequired,
    status: _propTypes2.default.shape({
      danger: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired,
  dimensions: _propTypes2.default.shape({
    fontSizeNormal: _propTypes2.default.string.isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('PendingEstimateInvoiceWrapper', _styledComponents2.default.div, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./compositions/EstimateInvoicePendingWidget/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EstimateInvoicePendingWidget = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.getApprovalStatus = getApprovalStatus;
exports.getOkLabel = getOkLabel;

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = __webpack_require__("../node_modules/recompose/es/Recompose.js");

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _reactFontawesome = __webpack_require__("../node_modules/react-fontawesome/lib/index.js");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _baseComponents = __webpack_require__("../node_modules/base-components/build/index.js");

var _cardType = __webpack_require__("./utils/cardType.js");

var _cardType2 = _interopRequireDefault(_cardType);

var _PdfLink = __webpack_require__("./components/PdfLink/index.js");

var _PdfLink2 = _interopRequireDefault(_PdfLink);

var _Dialog = __webpack_require__("./elements/Dialog/index.js");

var _Dialog2 = _interopRequireDefault(_Dialog);

var _Divider = __webpack_require__("./elements/Divider/index.js");

var _Divider2 = _interopRequireDefault(_Divider);

var _DropDown = __webpack_require__("./elements/DropDown/index.js");

var _DropDown2 = _interopRequireDefault(_DropDown);

var _SplitBlock = __webpack_require__("./elements/SplitBlock/index.js");

var _Widget = __webpack_require__("./elements/Widget/index.js");

var _Widget2 = _interopRequireDefault(_Widget);

var _timeUtils = __webpack_require__("./utils/timeUtils.js");

var _widget = __webpack_require__("./utils/widget.js");

var _LabelValue = __webpack_require__("./components/LabelValue/index.js");

var _LabelValue2 = _interopRequireDefault(_LabelValue);

var _DropdownWrapper = __webpack_require__("./compositions/EstimateInvoicePendingWidget/DropdownWrapper.js");

var _DropdownWrapper2 = _interopRequireDefault(_DropdownWrapper);

var _Wrapper = __webpack_require__("./compositions/EstimateInvoicePendingWidget/Wrapper.js");

var _Wrapper2 = _interopRequireDefault(_Wrapper);

var _NoteDialog = __webpack_require__("./compositions/EstimateInvoicePendingWidget/NoteDialog/index.js");

var _NoteDialog2 = _interopRequireDefault(_NoteDialog);

var _messages = __webpack_require__("./compositions/EstimateInvoicePendingWidget/messages.js");

var _messages2 = _interopRequireDefault(_messages);

var _Container = __webpack_require__("./compositions/EstimateInvoicePendingWidget/Container.js");

var _Container2 = _interopRequireDefault(_Container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getApprovalStatus(approveValue) {
  switch (approveValue) {
    case 'Approve':
      return 'approved';
    case 'Decline':
      return 'declined';
    default:
      return '';
  }
}

function getOkLabel(title, i18n) {
  switch (title) {
    case 'Approve':
      return i18n._(_messages2.default.accept);
    case 'Decline':
      return i18n._(_messages2.default.decline);
    default:
      return title;
  }
}

var EstimateInvoicePendingWidget = exports.EstimateInvoicePendingWidget = function (_Component) {
  _inherits(EstimateInvoicePendingWidget, _Component);

  function EstimateInvoicePendingWidget() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, EstimateInvoicePendingWidget);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EstimateInvoicePendingWidget.__proto__ || Object.getPrototypeOf(EstimateInvoicePendingWidget)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      selectedApproveValue: undefined,
      dialogVisible: false,
      note: '',
      poNumber: null
    }, _this.onChangeApproveOption = function (_ref2) {
      var value = _ref2.value;

      _this.deferredApproveValue = value;
      _this.setState({
        dialogVisible: true
      });
    }, _this.onChangePONumber = function (ev) {
      _this.setState({
        poNumber: ev.target.value
      });
    }, _this.getApproveOptions = function () {
      var i18n = _this.props.i18n;

      return [{
        value: 'Approve',
        label: _react2.default.createElement(
          _baseComponents.ButtonLink,
          null,
          i18n._(_messages2.default.approve)
        )
      }, {
        value: 'Decline',
        label: _react2.default.createElement(
          _baseComponents.ButtonLink,
          null,
          i18n._(_messages2.default.decline)
        )
      }];
    }, _this.getDropdownColors = function (selectedApproveValue) {
      var theme = _this.props.theme;

      if (selectedApproveValue === 'Approve') {
        return {
          fgColor: theme.colors.base.chrome100,
          bgColor: theme.colors.brand.primary
        };
      } else if (selectedApproveValue === 'Decline') {
        return {
          fgColor: theme.colors.base.chrome100,
          bgColor: theme.colors.base.chrome600
        };
      }

      return {
        fgColor: undefined,
        bgColor: undefined
      };
    }, _this.handleOk = function (note) {
      _this.setState({
        selectedApproveValue: _this.deferredApproveValue,
        dialogVisible: false,
        note: note
      });
    }, _this.handleCancel = function () {
      _this.setState({
        dialogVisible: false
      });
    }, _this.handleSubmit = function () {
      var _this$props = _this.props,
          caseInfo = _this$props.caseInfo,
          updateCase = _this$props.updateCase;
      var _this$state = _this.state,
          poNumber = _this$state.poNumber,
          note = _this$state.note,
          selectedApproveValue = _this$state.selectedApproveValue;


      if (!selectedApproveValue) {
        return;
      }
      var approvalStatus = getApprovalStatus(_this.deferredApproveValue);

      updateCase({
        caseId: caseInfo.id,
        versionId: caseInfo.version,
        approvalStatus: approvalStatus,
        comments: note,
        poNumber: poNumber === null ? caseInfo.poNumber : poNumber
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(EstimateInvoicePendingWidget, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (!this.widgetShouldRender()) {
        var _props = this.props,
            configName = _props.configName,
            addHiddenWidget = _props.addHiddenWidget;

        addHiddenWidget(configName);
      }
    }
  }, {
    key: 'widgetShouldRender',
    value: function widgetShouldRender() {
      var approvalStatus = this.props.caseInfo.approvalStatus;

      return approvalStatus === 'Pending';
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          casesError = _props2.casesError,
          caseInfo = _props2.caseInfo,
          i18n = _props2.i18n,
          theme = _props2.theme;
      var _state = this.state,
          selectedApproveValue = _state.selectedApproveValue,
          dialogVisible = _state.dialogVisible,
          note = _state.note;
      var approvalStatus = caseInfo.approvalStatus,
          etr = caseInfo.etr,
          roUrl = caseInfo.roUrl,
          roNumber = caseInfo.roNumber,
          estimateTotal = caseInfo.estimateTotal,
          poNumber = caseInfo.poNumber;


      var formattedEtr = etr ? (0, _timeUtils.formatDate)(etr) : (0, _widget.getOutputText)(etr);
      var approveOptions = this.getApproveOptions();
      var selectedApproveOption = (0, _lodash.find)(approveOptions, { value: selectedApproveValue });
      var dropdownColors = this.getDropdownColors(selectedApproveValue);
      var submitDisabled = !selectedApproveValue && 'disabled';
      var statusCardType = (0, _cardType2.default)(approvalStatus);

      if (!this.widgetShouldRender()) {
        return null;
      }

      return _react2.default.createElement(
        _Wrapper2.default,
        null,
        _react2.default.createElement(
          _Widget2.default,
          {
            id: 'estimate-invoice',
            className: 'estimate-invoice-pending',
            expandKey: 'estimate-invoice'
          },
          _react2.default.createElement(
            _Widget2.default.Header,
            null,
            _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.title })
          ),
          _react2.default.createElement(
            _SplitBlock.SplitBlock,
            { modifiers: ['pad'] },
            _react2.default.createElement(
              _SplitBlock.SplitBlock,
              { modifiers: ['pad'] },
              _react2.default.createElement(
                _Widget2.default.SubHeader,
                { modifiers: (0, _lodash.compact)([statusCardType]) },
                approvalStatus
              )
            ),
            _react2.default.createElement(
              _SplitBlock.SplitBlockPart,
              { modifiers: ['right'] },
              _react2.default.createElement(_LabelValue2.default, {
                label: _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.etr }),
                value: formattedEtr,
                marginRight: 80
              }),
              _react2.default.createElement(_LabelValue2.default, {
                label: _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.repairOrder }),
                value: _react2.default.createElement(
                  'span',
                  null,
                  roNumber && '#',
                  (0, _widget.getOutputText)(roNumber)
                )
              })
            )
          ),
          _react2.default.createElement(_Divider2.default, { color: theme.colors.base.chrome200, marginBottom: 15 }),
          _react2.default.createElement(
            _SplitBlock.SplitBlock,
            { modifiers: ['pad'] },
            _react2.default.createElement(
              _SplitBlock.SplitBlock,
              { modifiers: ['pad'] },
              _react2.default.createElement(
                'div',
                { className: 'estimate-label' },
                _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.estimateTotal })
              ),
              _react2.default.createElement(
                'div',
                { className: 'estimate-value' },
                estimateTotal
              )
            ),
            _react2.default.createElement(
              _DropdownWrapper2.default,
              { className: 'pending-estimate-options' },
              _react2.default.createElement(_DropDown2.default, {
                onChange: this.onChangeApproveOption,
                options: approveOptions,
                value: selectedApproveOption,
                widgetBGColor: dropdownColors.bgColor,
                widgetFGColor: dropdownColors.fgColor,
                showIcon: !!note
              }),
              dialogVisible && _react2.default.createElement(
                _Dialog2.default,
                null,
                _react2.default.createElement(_NoteDialog2.default, {
                  title: this.deferredApproveValue,
                  note: note,
                  theme: theme,
                  okLabel: getOkLabel(this.deferredApproveValue, i18n),
                  onOk: this.handleOk,
                  onCancel: this.handleCancel
                })
              )
            )
          ),
          _react2.default.createElement(
            _Widget2.default.Item,
            null,
            _react2.default.createElement(
              _SplitBlock.SplitBlock,
              { modifiers: ['pad'] },
              _react2.default.createElement(_LabelValue2.default, {
                label: _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.po }),
                value: _react2.default.createElement('input', {
                  placeholder: 'Optional: PO Number',
                  style: { width: '150px', height: '25px', paddingLeft: '10px' },
                  defaultValue: poNumber,
                  onChange: this.onChangePONumber
                })
              })
            )
          ),
          _react2.default.createElement(_Divider2.default, { color: theme.colors.base.chrome200, marginTop: 15 }),
          _react2.default.createElement(
            _Widget2.default.Item,
            null,
            _react2.default.createElement(
              _SplitBlock.SplitBlock,
              { modifiers: ['pad'] },
              _react2.default.createElement(
                _SplitBlock.SplitBlockPart,
                { modifiers: ['left'] },
                _react2.default.createElement(
                  _PdfLink2.default,
                  { url: roUrl },
                  _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.viewEstimate })
                )
              ),
              _react2.default.createElement(
                _SplitBlock.SplitBlockPart,
                { modifiers: ['right'] },
                _react2.default.createElement(
                  _SplitBlock.SplitBlockElement,
                  { modifiers: ['padLeft'] },
                  !(0, _lodash.isEmpty)(casesError) && _react2.default.createElement(
                    'span',
                    { className: 'error' },
                    _react2.default.createElement(
                      'span',
                      { className: 'bold' },
                      _react2.default.createElement(_reactFontawesome2.default, { name: 'ban' }),
                      _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.error }),
                      ':\xA0'
                    )
                  )
                ),
                _react2.default.createElement(
                  _baseComponents.QuickActionButton,
                  {
                    modifiers: (0, _lodash.compact)([submitDisabled, 'secondary', 'hoverSuccess']),
                    onClick: this.handleSubmit
                  },
                  _react2.default.createElement(
                    _baseComponents.QuickActionButton.Text,
                    null,
                    _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.submit })
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return EstimateInvoicePendingWidget;
}(_react.Component);

EstimateInvoicePendingWidget.propTypes = {
  caseInfo: _propTypes2.default.shape({
    approvalStatus: _propTypes2.default.string,
    estimateTotal: _propTypes2.default.string,
    invoiceId: _propTypes2.default.string,
    invoiceTotal: _propTypes2.default.string,
    roNumber: _propTypes2.default.string,
    poNumber: _propTypes2.default.string
  }).isRequired,
  casesError: _propTypes2.default.shape(),
  configName: _propTypes2.default.string.isRequired,
  i18n: _propTypes2.default.shape({
    _: _propTypes2.default.func
  }).isRequired,
  theme: _propTypes2.default.shape({
    colors: _propTypes2.default.shape({
      base: _propTypes2.default.shape({
        chrome100: _propTypes2.default.string.isRequired,
        chrome200: _propTypes2.default.string.isRequired,
        chrome600: _propTypes2.default.string.isRequired
      }).isRequired,
      brand: _propTypes2.default.shape({
        primary: _propTypes2.default.string.isRequired
      }).isRequired
    }).isRequired
  }).isRequired,
  updateCase: _propTypes2.default.func.isRequired,
  addHiddenWidget: _propTypes2.default.func.isRequired
};
EstimateInvoicePendingWidget.defaultProps = {
  cardType: '',
  caseInfo: {},
  casesError: {},
  casesRequesting: false,
  theme: _decisivUiUtils.theme
};
exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('EstimateInvoicePendingWidget'), _Container2.default, _styledComponents.withTheme, (0, _linguiReact.withI18n)())(EstimateInvoicePendingWidget);

/***/ }),

/***/ "./compositions/EstimateInvoicePendingWidget/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var formattedMessages = {
  accept: (0, _linguiReact.i18nMark)('Accept'),
  amount: (0, _linguiReact.i18nMark)('Amount'),
  approve: (0, _linguiReact.i18nMark)('Approve'),
  comments: (0, _linguiReact.i18nMark)('Comments'),
  decline: (0, _linguiReact.i18nMark)('Decline'),
  error: (0, _linguiReact.i18nMark)('Error'),
  estimates: (0, _linguiReact.i18nMark)('Estimates'),
  estimateTotal: (0, _linguiReact.i18nMark)('Estimate Total'),
  etr: (0, _linguiReact.i18nMark)('ETR'),
  invoice: (0, _linguiReact.i18nMark)('Invoice'),
  invoiceDate: (0, _linguiReact.i18nMark)('Invoice Date'),
  invoiceId: (0, _linguiReact.i18nMark)('Invoice Id'),
  optional: (0, _linguiReact.i18nMark)('Optional'),
  po: (0, _linguiReact.i18nMark)('Purchase Order'),
  provideANote: (0, _linguiReact.i18nMark)('Provide a Note about your decision'),
  repairOrder: (0, _linguiReact.i18nMark)('Repair Order'),
  submissionFailed: (0, _linguiReact.i18nMark)('Your submission has failed.'),
  submit: (0, _linguiReact.i18nMark)('SUBMIT'),
  title: (0, _linguiReact.i18nMark)('Estimate/Invoice'),
  viewEstimate: (0, _linguiReact.i18nMark)('View Estimate'),
  viewLatestEstimate: (0, _linguiReact.i18nMark)('View Latest Estimate')
};

exports.default = formattedMessages;

/***/ }),

/***/ "./compositions/JumpToButton/Container.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _recompose = __webpack_require__("../node_modules/recompose/es/Recompose.js");

var _immutableToJS = __webpack_require__("./utils/immutableToJS.js");

var _immutableToJS2 = _interopRequireDefault(_immutableToJS);

var _propTypes = __webpack_require__("./utils/prop-types.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _selectors = __webpack_require__("./redux/pageConfigs/selectors.js");

var _actions = __webpack_require__("./redux/ui/actions.js");

var _selectors2 = __webpack_require__("./redux/ui/selectors.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var withConnectedData = function withConnectedData(WrappedComponent) {
  function WithConnectedData(props) {
    return _react2.default.createElement(WrappedComponent, props);
  }

  WithConnectedData.propTypes = {
    actionBarItemClicked: _propTypes2.default.shape({
      buttonId: _propTypes2.default.string,
      dropdownItemId: _propTypes2.default.string
    }).isRequired,
    handleActionBarItemClick: _propTypes2.default.func.isRequired,
    hiddenWidgets: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
    pageConfig: _propTypes2.default.shape({
      top: _propTypes2.default.compositionConfig,
      left: _propTypes2.default.compositionConfig,
      right: _propTypes2.default.compositionConfig
    }).isRequired
  };

  function mapStateToProps(state) {
    return {
      actionBarItemClicked: (0, _selectors2.actionBarItemClickedSelector)(state),
      hiddenWidgets: (0, _selectors2.hiddenWidgetsSelector)(state),
      pageConfig: (0, _selectors.currentPageConfigSelector)(state)
    };
  }

  function mapDispatchToProps(dispatch) {
    return {
      handleActionBarItemClick: function handleActionBarItemClick(payload) {
        return dispatch((0, _actions.handleActionBarItemClick)(payload));
      }
    };
  }

  return (0, _recompose.compose)((0, _recompose.setDisplayName)('JumpToButtonContainer'), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _immutableToJS2.default)(WithConnectedData);
};

exports.default = withConnectedData;

/***/ }),

/***/ "./compositions/JumpToButton/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JumpToButton = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.buildJumpToOptions = buildJumpToOptions;

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _recompose = __webpack_require__("../node_modules/recompose/es/Recompose.js");

var _reactScroll = __webpack_require__("../node_modules/react-scroll/modules/index.js");

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _QuickActionSelector = __webpack_require__("./components/QuickActionSelector/index.js");

var _QuickActionSelector2 = _interopRequireDefault(_QuickActionSelector);

var _Container = __webpack_require__("./compositions/JumpToButton/Container.js");

var _Container2 = _interopRequireDefault(_Container);

var _messages = __webpack_require__("./compositions/JumpToButton/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function buildJumpToOptions(pageConfig, hiddenWidgets) {
  var top = pageConfig.top || [];
  var left = pageConfig.left || [];
  var right = pageConfig.right || [];

  var zippedLROptions = (0, _lodash.zip)(left, right);
  var allOptions = top.concat(zippedLROptions);
  var combinedOptions = (0, _lodash.compact)((0, _lodash.flattenDeep)(allOptions));

  var renderedOptions = (0, _lodash.compact)(combinedOptions.map(function (opt) {
    return !hiddenWidgets.includes(opt) && opt;
  }));

  return renderedOptions.reduce(function (acc, opt) {
    return acc.concat({
      id: opt,
      label: _messages2.default[opt]
    });
  }, []);
}

var JUMP_TO_BUTTON = 'JUMP_TO_BUTTON';

var JumpToButton = exports.JumpToButton = function (_Component) {
  _inherits(JumpToButton, _Component);

  function JumpToButton() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, JumpToButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = JumpToButton.__proto__ || Object.getPrototypeOf(JumpToButton)).call.apply(_ref, [this].concat(args))), _this), _this.scrollToWidget = function (dropdownItemId) {
      var topNavHeightInPixel = _this.props.theme.dimensions.topNavHeightInPixel;

      _reactScroll.scroller.scrollTo(dropdownItemId, {
        duration: 500,
        smooth: true,
        offset: -topNavHeightInPixel
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(JumpToButton, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref2) {
      var actionBarItemClicked = _ref2.actionBarItemClicked;
      var buttonId = actionBarItemClicked.buttonId,
          dropdownItemId = actionBarItemClicked.dropdownItemId;

      if (buttonId === JUMP_TO_BUTTON) {
        var currentDropdownItemId = this.props.actionBarItemClicked.dropdownItemId;

        if (dropdownItemId && dropdownItemId !== currentDropdownItemId) {
          this.scrollToWidget(dropdownItemId);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_QuickActionSelector2.default, {
        item: {
          id: JUMP_TO_BUTTON,
          icon: 'caret-down',
          iconPressed: 'caret-up',
          label: _messages2.default.jumpTo,
          options: buildJumpToOptions(this.props.pageConfig, this.props.hiddenWidgets)
        },
        onClick: this.props.handleActionBarItemClick
      });
    }
  }]);

  return JumpToButton;
}(_react.Component);

JumpToButton.propTypes = {
  actionBarItemClicked: _propTypes2.default.shape({
    buttonId: _propTypes2.default.string,
    dropdownItemId: _propTypes2.default.string
  }).isRequired,
  handleActionBarItemClick: _propTypes2.default.func.isRequired,
  hiddenWidgets: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  pageConfig: _propTypes2.default.shape({
    top: _propTypes2.default.compositionConfig,
    left: _propTypes2.default.compositionConfig,
    right: _propTypes2.default.compositionConfig
  }).isRequired,
  theme: _propTypes2.default.shape({
    dimensions: _propTypes2.default.shape({
      topNavHeightInPixel: _propTypes2.default.number.isRequired
    }).isRequired
  }).isRequired
};
exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('JumpToButton'), _Container2.default, _styledComponents.withTheme)(JumpToButton);

/***/ }),

/***/ "./compositions/JumpToButton/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  jumpTo: (0, _linguiReact.i18nMark)('Jump To...'),
  ASSET_FAULT_DIAGNOSTIC_WIDGET: (0, _linguiReact.i18nMark)('Diagnostics'),
  ASSET_LOCATION_WIDGET: (0, _linguiReact.i18nMark)('Location'),
  ASSET_SUMMARY_WIDGET: (0, _linguiReact.i18nMark)('Asset Summary'),
  CASE_ASSETS_WIDGET: (0, _linguiReact.i18nMark)('Asset'),
  CASE_COMPLAINT_WIDGET: (0, _linguiReact.i18nMark)('Complaint'),
  CASE_FAULT_DIAGNOSTIC_WIDGET: (0, _linguiReact.i18nMark)('Diagnostics'),
  CASE_LOCATION_WIDGET: (0, _linguiReact.i18nMark)('Location'),
  CASE_NOTES_WIDGET: (0, _linguiReact.i18nMark)('Notes'),
  CASE_SERVICE_PROVIDER_WIDGET: (0, _linguiReact.i18nMark)('Service Provider'),
  CASE_SERVICE_REQUEST_INFO_WIDGET: (0, _linguiReact.i18nMark)('Service Request'),
  CASE_STATUS_WIDGET: (0, _linguiReact.i18nMark)('Case Status'),
  ESTIMATE_INVOICE_DECIDED_WIDGET: (0, _linguiReact.i18nMark)('Estimate Invoice'),
  ESTIMATE_INVOICE_PENDING_WIDGET: (0, _linguiReact.i18nMark)('Estimate Invoice'),
  QR_CODE_WIDGET: (0, _linguiReact.i18nMark)('QR Code'),
  OPEN_EVENTS_WIDGET: (0, _linguiReact.i18nMark)('Open Events'),
  SERVICE_REQUEST_ASSETS_WIDGET: (0, _linguiReact.i18nMark)('Asset'),
  SERVICE_REQUEST_COMPLAINT_WIDGET: (0, _linguiReact.i18nMark)('Complaint'),
  SERVICE_REQUEST_LOCATION_WIDGET: (0, _linguiReact.i18nMark)('Location'),
  SERVICE_REQUEST_NOTES_WIDGET: (0, _linguiReact.i18nMark)('Notes'),
  SERVICE_REQUEST_SERVICE_PROVIDER_WIDGET: (0, _linguiReact.i18nMark)('Service Provider'),
  SERVICE_REQUEST_SERV_REQ_INFO_WIDGET: (0, _linguiReact.i18nMark)('Service Request')
};

exports.default = messages;

/***/ }),

/***/ "./compositions/LeftNav/Container.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LeftNavContainer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.composeMenus = composeMenus;

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _reactRouterDom = __webpack_require__("../node_modules/react-router-dom/es/index.js");

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _WindowQuery = __webpack_require__("./components/WindowQuery/index.js");

var _WindowQuery2 = _interopRequireDefault(_WindowQuery);

var _authentication = __webpack_require__("./features/authentication/index.js");

var _actions = __webpack_require__("./redux/app/actions.js");

var _selectors = __webpack_require__("./redux/app/selectors.js");

var _actions2 = __webpack_require__("./redux/ui/actions.js");

var _selectors2 = __webpack_require__("./redux/ui/selectors.js");

var _selectors3 = __webpack_require__("./redux/user/selectors.js");

var _immutableToJS = __webpack_require__("./utils/immutableToJS.js");

var _immutableToJS2 = _interopRequireDefault(_immutableToJS);

var _LeftNavComponent = __webpack_require__("./compositions/LeftNav/LeftNavComponent/index.js");

var _LeftNavComponent2 = _interopRequireDefault(_LeftNavComponent);

var _menuDefault = __webpack_require__("./compositions/LeftNav/menuDefault.js");

var _menuDefault2 = _interopRequireDefault(_menuDefault);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Processes the user's favorites from the dashboard api response into menu groups for display.
 * @param  {Array} menuGroups The default menu groups arrays
 * @param  {Object} favorites The user's favorites, keyed under menu group labels
 * @return {Array}            The processed array, with the user's favorites in the correct groups.
 */
function composeMenus(menuGroups, favorites) {
  if ((0, _lodash.isEmpty)(favorites)) {
    return [];
  }
  return menuGroups.map(function (menuGroup) {
    return menuGroup.map(function (menu) {
      var menuFavorites = favorites[menu.label];
      if (menuFavorites) {
        return _extends({}, menu, { favorites: menuFavorites });
      }
      return menu;
    });
  });
}

/**
 * LeftNavContainer wraps the entire left-hand navigation panel for the application.
 * It is rendered by the Layout.
 */

var LeftNavContainer = exports.LeftNavContainer = function (_Component) {
  _inherits(LeftNavContainer, _Component);

  function LeftNavContainer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LeftNavContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LeftNavContainer.__proto__ || Object.getPrototypeOf(LeftNavContainer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      // `requestedNavExpanded` tracks whether the user has *manually* expanded a collapsed left-nav
      // (contrasted with an auto-expand due to a window resize)
      requestedNavExpanded: true
    }, _this.onResizeWindow = function (_ref2) {
      var windowWidth = _ref2.windowWidth;
      var _this$props = _this.props,
          navExpanded = _this$props.navExpanded,
          setLeftNavExpanded = _this$props.setLeftNavExpanded,
          theme = _this$props.theme;

      var collapseAt = theme.dimensions.autoCollapseLeftNavPx;
      if (navExpanded && windowWidth < collapseAt) {
        // collapse the left nav when shrinking the window below the configured width
        setLeftNavExpanded(false);
      } else if (_this.state.requestedNavExpanded && !navExpanded && windowWidth > collapseAt) {
        // only auto-expand the left nav is resizing to make the window larger *and*
        // the left nav had previously been manually navExpanded
        setLeftNavExpanded(true);
      }
    }, _this.handleExpandLeftNavClick = function (navExpanded) {
      _this.props.setLeftNavExpanded(navExpanded);
      _this.setState({ requestedNavExpanded: navExpanded });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(LeftNavContainer, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if ((0, _lodash.isEmpty)(this.props.favorites) && !this.props.dashboardRequesting) {
        this.props.loadDashboard();
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (window.innerWidth < this.props.theme.dimensions.autoCollapseLeftNavPx) {
        this.props.setLeftNavExpanded(false);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          navExpanded = _props.navExpanded,
          tenant = _props.tenant,
          userProfile = _props.userProfile;


      return _react2.default.createElement(
        _WindowQuery2.default,
        { onResize: this.onResizeWindow },
        _react2.default.createElement(_LeftNavComponent2.default, {
          companyId: userProfile.companyId,
          menus: composeMenus(_menuDefault2.default, this.props.favorites),
          navExpanded: navExpanded,
          onExpandLeftNav: this.handleExpandLeftNavClick,
          tenant: tenant
        })
      );
    }
  }]);

  return LeftNavContainer;
}(_react.Component);

LeftNavContainer.propTypes = {
  // `dashboardRequesting` is true if a request is currently ongoing.
  dashboardRequesting: _propTypes2.default.bool.isRequired,

  // `favorites` is the collection of favorites for all the menu items
  favorites: _propTypes2.default.objectOf(_propTypes2.default.arrayOf(_propTypes2.default.shape({
    path: _propTypes2.default.string.isRequired,
    slug: _propTypes2.default.string.isRequired,
    title: _propTypes2.default.string.isRequired
  }))).isRequired,

  // `loadDashboard` triggers loading the user's favorites from the api
  loadDashboard: _propTypes2.default.func.isRequired,

  // `navExpanded` is true if the left nav is currently navExpanded, false otherwise
  navExpanded: _propTypes2.default.bool,

  // `setLeftNavExpanded` allows saving the user's left nav navExpanded preference
  setLeftNavExpanded: _propTypes2.default.func.isRequired,

  // Tenant for the current login - needed for the hybrid admin link
  tenant: _propTypes2.default.string.isRequired,

  theme: _propTypes2.default.shape({
    dimensions: _propTypes2.default.shape({
      autoCollapseLeftNavPx: _propTypes2.default.number.isRequired
    }).isRequired
  }).isRequired,

  // companyId is used by the admin link for redirecting to Case Classic
  userProfile: _propTypes2.default.shape({
    companyId: _propTypes2.default.string
  })
};
LeftNavContainer.defaultProps = {
  dashboardRequesting: false,
  navExpanded: true,
  userProfile: {
    companyId: ''
  }
};


function mapStateToProps(state) {
  return {
    dashboardRequesting: (0, _selectors.dashboardRequestingSelector)(state),
    favorites: (0, _selectors.favoritesSelector)(state),
    navExpanded: (0, _selectors2.leftNavExpandedSelector)(state),
    tenant: (0, _authentication.currentTenantSelector)(state),
    userProfile: (0, _selectors3.userProfileSelector)(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loadDashboard: function loadDashboard() {
      return dispatch((0, _actions.loadDashboard)());
    },
    setLeftNavExpanded: function setLeftNavExpanded(navExpanded) {
      return dispatch((0, _actions2.setLeftNavExpanded)(navExpanded));
    }
  };
}

exports.default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _styledComponents.withTheme)((0, _immutableToJS2.default)(LeftNavContainer))));

/***/ }),

/***/ "./compositions/LeftNav/LeftNavComponent/FavoritesPopover/Body.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/styled-components-reactive-grid/dist/index.js");

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _decisivUiUtils.buildStyledComponent)('FavoritesPopoverBody', (0, _styledComponents2.default)(_styledComponentsReactiveGrid.Container));

/***/ }),

/***/ "./compositions/LeftNav/LeftNavComponent/FavoritesPopover/Header.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  active: function active(_ref) {
    var theme = _ref.theme;
    return {
      styles: '\n      background-color: ' + theme.colors.brand.primary + ';\n      color: ' + theme.colors.base.chrome100 + ';\n    '
    };
  }
};

var styles = function styles(_ref2) {
  var theme = _ref2.theme;
  return '\n  background-color: ' + theme.colors.base.chrome200 + ';\n  padding: ' + (0, _decisivUiUtils.px2rem)(12) + ';\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome100: _propTypes2.default.string.isRequired,
      chrome200: _propTypes2.default.string.isRequired
    }).isRequired,
    brand: _propTypes2.default.shape({
      primary: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('FavoritesPopoverHeader', _styledComponents2.default.div, styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

/***/ }),

/***/ "./compositions/LeftNav/LeftNavComponent/FavoritesPopover/Wrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = '\n  line-height: ' + (0, _decisivUiUtils.px2rem)(22) + ';\n';

exports.default = (0, _decisivUiUtils.buildStyledComponent)('FavoritesPopoverWrapper', _styledComponents2.default.div, styles);

/***/ }),

/***/ "./compositions/LeftNav/LeftNavComponent/FavoritesPopover/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FavoritesPopover = FavoritesPopover;

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _reactRouterDom = __webpack_require__("../node_modules/react-router-dom/es/index.js");

var _TextDiv = __webpack_require__("./elements/TextDiv/index.js");

var _TextDiv2 = _interopRequireDefault(_TextDiv);

var _Wrapper = __webpack_require__("./compositions/LeftNav/LeftNavComponent/FavoritesPopover/Wrapper.js");

var _Wrapper2 = _interopRequireDefault(_Wrapper);

var _Header = __webpack_require__("./compositions/LeftNav/LeftNavComponent/FavoritesPopover/Header.js");

var _Header2 = _interopRequireDefault(_Header);

var _Body = __webpack_require__("./compositions/LeftNav/LeftNavComponent/FavoritesPopover/Body.js");

var _Body2 = _interopRequireDefault(_Body);

var _MenuItem = __webpack_require__("./compositions/LeftNav/LeftNavComponent/MenuItem.js");

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _messages = __webpack_require__("./compositions/LeftNav/LeftNavComponent/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function favoriteLinks(favorites, hidePopover) {
  return favorites.map(function (_ref) {
    var message = _ref.message,
        path = _ref.path,
        slug = _ref.slug;
    return _react2.default.createElement(
      _MenuItem2.default,
      { key: slug, modifiers: ['popover'], to: path, onClick: hidePopover },
      _react2.default.createElement(_linguiReact.Trans, { id: message })
    );
  });
}

function FavoritesPopover(_ref2) {
  var favorites = _ref2.favorites,
      hidePopover = _ref2.hidePopover,
      label = _ref2.label,
      location = _ref2.location,
      match = _ref2.match,
      isActiveFunc = _ref2.isActiveFunc;

  var isActive = isActiveFunc(match, location);
  var headerModifiers = (0, _lodash.compact)([isActive && 'active']);
  var textModifiers = (0, _lodash.compact)([!isActive && 'bold', 'uppercase']);

  return _react2.default.createElement(
    _Wrapper2.default,
    null,
    _react2.default.createElement(
      _Header2.default,
      { modifiers: headerModifiers },
      _react2.default.createElement(
        _TextDiv2.default,
        { modifiers: textModifiers },
        _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default[label] })
      )
    ),
    _react2.default.createElement(
      _Body2.default,
      null,
      favoriteLinks(favorites, hidePopover)
    )
  );
}

FavoritesPopover.propTypes = {
  // `favorites` is an array of the submenu item definitions
  favorites: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    message: _propTypes2.default.string.isRequired,
    path: _propTypes2.default.string.isRequired,
    slug: _propTypes2.default.string.isRequired,
    title: _propTypes2.default.string.isRequired
  })),

  // `hidePopover` is a function called when a submenu item clicked
  hidePopover: _propTypes2.default.func,

  // `label` is a property name in the message definitions (messages.js) for the label text
  label: _propTypes2.default.string.isRequired,

  // `isActiveFunc` is a function passed down to determine if the
  // FavoritesPopoverHeader should reflect an actively selected status
  isActiveFunc: _propTypes2.default.func.isRequired,

  match: _propTypes2.default.shape({
    params: _propTypes2.default.shape({
      eventId: _propTypes2.default.number
    }).isRequired
  }).isRequired,

  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string.isRequired
  }).isRequired
};

FavoritesPopover.defaultProps = {
  favorites: [],
  hidePopover: _lodash.noop
};

exports.default = (0, _reactRouterDom.withRouter)(FavoritesPopover);

/***/ }),

/***/ "./compositions/LeftNav/LeftNavComponent/GhostLeftNav/GhostIndicatorLeftNav.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _GhostIndicator = __webpack_require__("./components/_common/GhostIndicator/index.js");

var _GhostIndicator2 = _interopRequireDefault(_GhostIndicator);

var _GhostIndicatorLeftNavWrapper = __webpack_require__("./compositions/LeftNav/LeftNavComponent/GhostLeftNav/GhostIndicatorLeftNavWrapper.js");

var _GhostIndicatorLeftNavWrapper2 = _interopRequireDefault(_GhostIndicatorLeftNavWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function GhostIndicatorLeftNav(_ref) {
  var navExpanded = _ref.navExpanded;

  return navExpanded ? _react2.default.createElement(
    _GhostIndicatorLeftNavWrapper2.default,
    null,
    _react2.default.createElement(_GhostIndicator2.default, { modifiers: ['dark', 'expanded', 'smallWidth'] }),
    _react2.default.createElement(_GhostIndicator2.default, { modifiers: ['dark', 'expanded', 'wide'] })
  ) : _react2.default.createElement(
    _GhostIndicatorLeftNavWrapper2.default,
    null,
    _react2.default.createElement(_GhostIndicator2.default, { modifiers: ['dark', 'wide'] })
  );
}

GhostIndicatorLeftNav.propTypes = {
  navExpanded: _propTypes2.default.bool.isRequired
};

exports.default = GhostIndicatorLeftNav;

/***/ }),

/***/ "./compositions/LeftNav/LeftNavComponent/GhostLeftNav/GhostIndicatorLeftNavWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  justify-content: center;\n'], ['\n  display: flex;\n  justify-content: center;\n']);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var GhostIndicatorLeftNavWrapper = function () {
  var c = _styledComponents2.default.div(_templateObject);

  c.displayName = 'GhostIndicatorLeftNavWrapper';
  return c;
}();

exports.default = GhostIndicatorLeftNavWrapper;

/***/ }),

/***/ "./compositions/LeftNav/LeftNavComponent/GhostLeftNav/GhostLeftNavWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  margin: 0 ', ';\n'], ['\n  margin: 0 ', ';\n']);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var GhostLeftNavWrapper = function () {
  var c = _styledComponents2.default.div(_templateObject, function (props) {
    return props.navExpanded ? (0, _decisivUiUtils.px2rem)(10) : (0, _decisivUiUtils.px2rem)(4);
  });

  c.displayName = 'GhostLeftNavWrapper';
  return c;
}();

GhostLeftNavWrapper.propTypes = {
  navExpanded: _propTypes2.default.bool.isRequired
};

exports.default = GhostLeftNavWrapper;

/***/ }),

/***/ "./compositions/LeftNav/LeftNavComponent/GhostLeftNav/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Divider = __webpack_require__("./elements/Divider/index.js");

var _Divider2 = _interopRequireDefault(_Divider);

var _GhostLeftNavWrapper = __webpack_require__("./compositions/LeftNav/LeftNavComponent/GhostLeftNav/GhostLeftNavWrapper.js");

var _GhostLeftNavWrapper2 = _interopRequireDefault(_GhostLeftNavWrapper);

var _GhostIndicatorLeftNav = __webpack_require__("./compositions/LeftNav/LeftNavComponent/GhostLeftNav/GhostIndicatorLeftNav.js");

var _GhostIndicatorLeftNav2 = _interopRequireDefault(_GhostIndicatorLeftNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function buildGhostIndicators(num, navExpanded) {
  return Array.from(new Array(num), function (x, i) {
    return _react2.default.createElement(_GhostIndicatorLeftNav2.default, { key: i, navExpanded: navExpanded });
  });
}

function GhostLeftNav(_ref) {
  var navExpanded = _ref.navExpanded;

  return _react2.default.createElement(
    _GhostLeftNavWrapper2.default,
    { navExpanded: navExpanded },
    buildGhostIndicators(1, navExpanded),
    _react2.default.createElement(_Divider2.default, { modifiers: ['extraLightGray'] }),
    buildGhostIndicators(6, navExpanded),
    _react2.default.createElement(_Divider2.default, { modifiers: ['extraLightGray'] }),
    buildGhostIndicators(1, navExpanded),
    _react2.default.createElement(_Divider2.default, { modifiers: ['extraLightGray'] })
  );
}

GhostLeftNav.propTypes = {
  navExpanded: _propTypes2.default.bool.isRequired
};

exports.default = GhostLeftNav;

/***/ }),

/***/ "./compositions/LeftNav/LeftNavComponent/LeftNavExpander/ExpanderMenuWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// `ExpanderMenuWrapper` sticks the expander menu item to the bottom of the left nav and
// adds a border to the top of it.
/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  background: ' + props.theme.colors.base.chrome100 + ';\n  border-top: 1px solid ' + props.theme.colors.base.chrome300 + ';\n  bottom: 84px;\n  left: 0;\n  list-style: none;\n  position: absolute;\n  right: 0;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome100: _propTypes2.default.string.isRequired,
      chrome300: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('ExpanderMenuWrapper', _styledComponents2.default.div, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./compositions/LeftNav/LeftNavComponent/LeftNavExpander/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LeftNavExpander = LeftNavExpander;

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactFontawesome = __webpack_require__("../node_modules/react-fontawesome/lib/index.js");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _recompose = __webpack_require__("../node_modules/recompose/es/Recompose.js");

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/styled-components-reactive-grid/dist/index.js");

var _baseComponents = __webpack_require__("../node_modules/base-components/build/index.js");

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _Tooltip = __webpack_require__("./elements/Tooltip/index.js");

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _TextDiv = __webpack_require__("./elements/TextDiv/index.js");

var _TextDiv2 = _interopRequireDefault(_TextDiv);

var _hybridLinks = __webpack_require__("./utils/hybridLinks.js");

var _messages = __webpack_require__("./compositions/LeftNav/LeftNavComponent/messages.js");

var _messages2 = _interopRequireDefault(_messages);

var _ExpanderMenuWrapper = __webpack_require__("./compositions/LeftNav/LeftNavComponent/LeftNavExpander/ExpanderMenuWrapper.js");

var _ExpanderMenuWrapper2 = _interopRequireDefault(_ExpanderMenuWrapper);

var _MenuItem = __webpack_require__("./compositions/LeftNav/LeftNavComponent/MenuItem.js");

var _MenuItem2 = _interopRequireDefault(_MenuItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LeftNavExpander(_ref) {
  var companyId = _ref.companyId,
      i18n = _ref.i18n,
      navExpanded = _ref.navExpanded,
      onExpandLeftNav = _ref.onExpandLeftNav,
      tenant = _ref.tenant,
      theme = _ref.theme;

  var icon = navExpanded ? 'angle-double-left' : 'angle-double-right';
  var base = theme.colors.base;


  var onExpand = function onExpand(e) {
    e.preventDefault();
    onExpandLeftNav(!navExpanded);
  };

  var styleIconBorder = function styleIconBorder() {
    if (navExpanded) {
      return { borderLeft: (0, _decisivUiUtils.px2rem)(1) + ' ' + base.chrome300 + ' solid' };
    }
    return { borderTop: (0, _decisivUiUtils.px2rem)(1) + ' ' + base.chrome300 + ' solid' };
  };

  var adminUrl = (0, _hybridLinks.buildFleetAdminLink)({ companyId: companyId, tenant: tenant });

  return _react2.default.createElement(
    _ExpanderMenuWrapper2.default,
    { id: 'expander-menu-wrapper' },
    _react2.default.createElement(
      _styledComponentsReactiveGrid.Container,
      { modifiers: ['fluid'] },
      _react2.default.createElement(
        _styledComponentsReactiveGrid.Row,
        { modifiers: (0, _lodash.compact)([!navExpanded && 'center']) },
        _react2.default.createElement(
          _styledComponentsReactiveGrid.Column,
          { modifiers: [navExpanded ? 'col_2' : 'col_12'] },
          _react2.default.createElement(
            _Tooltip2.default,
            {
              message: function message() {
                return _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.administration });
              },
              position: 'right'
            },
            _react2.default.createElement(
              _baseComponents.A,
              { 'aria-label': i18n._(_messages2.default.administration), href: adminUrl, modifiers: ['colorText'] },
              _react2.default.createElement(
                _baseComponents.ButtonIconRectangle,
                { style: { background: 'transparent' } },
                _react2.default.createElement(_reactFontawesome2.default, { name: 'cog' })
              )
            )
          )
        ),
        _react2.default.createElement(_styledComponentsReactiveGrid.Column, { modifiers: [navExpanded ? 'col' : 'noDisplay', 'fluid'] }),
        _react2.default.createElement(
          _styledComponentsReactiveGrid.Column,
          {
            modifiers: [navExpanded ? 'col_2' : 'col_12', 'fluid'],
            style: styleIconBorder()
          },
          _react2.default.createElement(
            _Tooltip2.default,
            {
              message: function message() {
                return _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default['' + (navExpanded ? 'collapsed' : 'expanded')] });
              },
              position: 'right'
            },
            _react2.default.createElement(
              _MenuItem2.default,
              { to: '#', onClick: onExpand },
              _react2.default.createElement(
                _TextDiv2.default,
                { modifiers: ['textAlignCenter'] },
                _react2.default.createElement(_reactFontawesome2.default, { name: icon })
              )
            )
          )
        )
      )
    )
  );
}

LeftNavExpander.propTypes = {
  companyId: _propTypes2.default.string,
  i18n: _propTypes2.default.shape({
    _: _propTypes2.default.func.isRequired
  }).isRequired,
  // `navExpanded` is true if left nav is navExpanded, false if it is collapsed
  navExpanded: _propTypes2.default.bool.isRequired,

  // `onExpandLeftNav` is called when the expander is clicked
  onExpandLeftNav: _propTypes2.default.func.isRequired,

  tenant: _propTypes2.default.string.isRequired,

  theme: _propTypes2.default.shape({
    colors: _propTypes2.default.shape({
      base: _propTypes2.default.shape({
        chrome000: _propTypes2.default.string,
        chrome200: _propTypes2.default.string,
        chrome300: _propTypes2.default.string,
        chrome700: _propTypes2.default.string
      })
    }).isRequired
  }).isRequired
};

LeftNavExpander.defaultProps = {
  navExpanded: true,
  onExpandLeftNav: _lodash.noop,
  theme: _decisivUiUtils.theme,
  companyId: ''
};

exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('LeftNavExpander'), _styledComponents.withTheme, (0, _linguiReact.withI18n)())(LeftNavExpander);

/***/ }),

/***/ "./compositions/LeftNav/LeftNavComponent/LeftNavList.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  font-size: ' + (0, _decisivUiUtils.px2rem)(12) + ';\n  font-weight: 400;\n  list-style: none;\n  margin-bottom: ' + props.theme.dimensions.leftNavItemHeight + ';\n  margin: 0;\n  padding: 0;\n';
};

var themePropTypes = {
  dimensions: _propTypes2.default.shape({
    leftNavItemHeight: _propTypes2.default.string.isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('LeftNavList', _styledComponents2.default.ul, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./compositions/LeftNav/LeftNavComponent/LeftNavWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var modifierConfig = {
  navExpanded: function navExpanded(_ref) {
    var theme = _ref.theme;
    return {
      styles: '\n      overflow: visible;\n      width: ' + theme.dimensions.leftNavWidth + ';\n    '
    };
  }
};

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  background-color: ' + props.theme.colors.base.chrome100 + ';\n  border-right: 1px solid ' + props.theme.colors.base.chrome300 + ';\n  height: 100%;\n  left: 0;\n  width: ' + props.theme.dimensions.leftNavWidthCollapsed + ';\n  padding-top: ' + props.theme.dimensions.gridPad + ';\n  position: fixed;\n  top: 80px;\n  transition: width ' + props.theme.dimensions.leftNavExpandTime + ';\n  z-index: 2;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome100: _propTypes2.default.string.isRequired,
      chrome300: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired,
  dimensions: _propTypes2.default.shape({
    gridPad: _propTypes2.default.string.isRequired,
    leftNavWidth: _propTypes2.default.string.isRequired,
    leftNavWidthCollapsed: _propTypes2.default.string.isRequired,
    leftNavExpandTime: _propTypes2.default.string.isRequired
  }).isRequired
};

var propTypes = {
  navExpanded: _propTypes2.default.bool.isRequired
};

var defaultProps = {
  navExpanded: true
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('LeftNavWrapper', _styledComponents2.default.section, styles, { defaultProps: defaultProps, modifierConfig: modifierConfig, propTypes: propTypes, themePropTypes: themePropTypes });

/***/ }),

/***/ "./compositions/LeftNav/LeftNavComponent/MenuItem.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__("../node_modules/react-router-dom/es/index.js");

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * LinkWithoutStyle removes the modifier and theme props from react-router-dom's `Link` component,
 * allowing us to use styled-components without prop errors in the console.
 */
/* istanbul ignore text */
function NavLinkWithoutStyleProps(props) {
  return _react2.default.createElement(_reactRouterDom.NavLink, (0, _lodash.omit)(props, ['modifiers', 'theme']));
}

var modifierConfig = {
  popover: function popover(_ref) {
    var theme = _ref.theme;
    return {
      styles: '\n      line-height: ' + theme.dimensions.leftNavChildItemHeight + ';\n      padding: 0 ' + (0, _decisivUiUtils.px2rem)(10) + ';\n      border-radius: 2px;\n\n      &:hover:not(.active) {\n        text-decoration: underline;\n        color: ' + theme.colors.base.linkHover + ';\n        background-color: ' + theme.colors.base.chrome100 + ';\n      }\n    '
    };
  },
  singleLine: function singleLine() {
    return {
      styles: '\n      max-height: ' + (0, _decisivUiUtils.px2rem)(42) + ';\n    '
    };
  },
  center: function center() {
    return {
      styles: '\n      text-align: center;\n    '
    };
  },
  chrome200: function chrome200() {
    return {
      styles: '\n      background-color: #e6e7e8;\n    '
    };
  }
};

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  color: ' + props.theme.colors.base.text + ';\n  display: block;\n  line-height: ' + props.theme.dimensions.leftNavItemHeight + ';\n  overflow: hidden;\n  text-decoration: none;\n  white-space: nowrap;\n\n  &.active {\n    color: ' + props.theme.colors.base.chrome100 + ';\n    background-color: ' + props.theme.colors.brand.primary + ';\n\n    .menuIcon {\n      color: ' + props.theme.colors.base.chrome100 + ';\n    }\n  }\n\n  .menuIcon {\n    font-size: ' + (0, _decisivUiUtils.px2rem)(18) + ';\n    text-align: center;\n    width: ' + (0, _decisivUiUtils.px2rem)(33) + ';\n    color: ' + props.theme.colors.base.chrome500 + ';\n  }\n\n  .chevron {\n    font-size: ' + (0, _decisivUiUtils.px2rem)(10) + ';\n    margin-right: ' + (0, _decisivUiUtils.px2rem)(8) + '\n  }\n\n  &:hover:not(.active) {\n    background-color: ' + props.theme.colors.base.chrome200 + ';\n    .menuIcon {\n      color: ' + props.theme.colors.base.text + ';\n    }\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome100: _propTypes2.default.string.isRequired,
      chrome200: _propTypes2.default.string.isRequired,
      chrome500: _propTypes2.default.string.isRequired,
      chrome600: _propTypes2.default.string.isRequired,
      linkHover: _propTypes2.default.string.isRequired,
      text: _propTypes2.default.string.isRequired
    }).isRequired,
    brand: _propTypes2.default.shape({
      primary: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired,
  dimensions: _propTypes2.default.shape({
    leftNavChildItemHeight: _propTypes2.default.string.isRequired,
    leftNavItemHeight: _propTypes2.default.string.isRequired
  }).isRequired
};

var propTypes = {
  to: _propTypes2.default.string.isRequired
};

var defaultProps = {
  to: '#'
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('MenuItem', (0, _styledComponents2.default)(NavLinkWithoutStyleProps), styles, { defaultProps: defaultProps, modifierConfig: modifierConfig, propTypes: propTypes, themePropTypes: themePropTypes });

/***/ }),

/***/ "./compositions/LeftNav/LeftNavComponent/MenuItemWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var modifierConfig = {
  /**
   * This emits CSS for a partial-width bottom border.  It
   * is actually a "fake" border using :after and absolute positioning.
   */
  border: function border(_ref) {
    var theme = _ref.theme;
    return {
      styles: '\n      &:after {\n        background: ' + theme.colors.base.chrome200 + ';\n        bottom: 0;\n        content: "";\n        height: 0.8px;\n        left: ' + (0, _decisivUiUtils.px2rem)(16) + ';\n        right: ' + (0, _decisivUiUtils.px2rem)(16) + ';\n        position: absolute;\n      }\n    '
    };
  }
};

/* istanbul ignore next */
/**
 * MenuItemWrapper is the list item for an individual LeftNav menu item.  It is
 * used for both top level (parent or non-parent) menu items and also for sub-menu
 * items (favorites). It removes the default list item padding and margins and
 * applies a bottom border if the modifier `border` is applied.
 */

var styles = function styles() {
  return '\n  margin: 0;\n  padding: 0;\n  position: relative;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome200: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('MenuItemWrapper', _styledComponents2.default.li, styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

/***/ }),

/***/ "./compositions/LeftNav/LeftNavComponent/NonParentMenu.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactFontawesome = __webpack_require__("../node_modules/react-fontawesome/lib/index.js");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/styled-components-reactive-grid/dist/index.js");

var _TextDiv = __webpack_require__("./elements/TextDiv/index.js");

var _TextDiv2 = _interopRequireDefault(_TextDiv);

var _messages = __webpack_require__("./compositions/LeftNav/LeftNavComponent/messages.js");

var _messages2 = _interopRequireDefault(_messages);

var _MenuItemWrapper = __webpack_require__("./compositions/LeftNav/LeftNavComponent/MenuItemWrapper.js");

var _MenuItemWrapper2 = _interopRequireDefault(_MenuItemWrapper);

var _MenuItem = __webpack_require__("./compositions/LeftNav/LeftNavComponent/MenuItem.js");

var _MenuItem2 = _interopRequireDefault(_MenuItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A NonParentMenu is a top level menu item that does not have favorites (so, it does
 * not have a submenu).
 */
function NonParentMenu(_ref) {
  var border = _ref.border,
      icon = _ref.icon,
      label = _ref.label,
      navExpanded = _ref.navExpanded,
      path = _ref.path;

  return _react2.default.createElement(
    _MenuItemWrapper2.default,
    { modifiers: (0, _lodash.compact)([border && 'border']) },
    _react2.default.createElement(
      _MenuItem2.default,
      {
        to: path,
        modifiers: ['singleLine']
      },
      _react2.default.createElement(
        _styledComponentsReactiveGrid.Container,
        null,
        _react2.default.createElement(
          _styledComponentsReactiveGrid.Row,
          { modifiers: ['middle'] },
          _react2.default.createElement(
            _styledComponentsReactiveGrid.Column,
            { modifiers: [navExpanded ? 'col_2' : 'col', 'start'] },
            icon && _react2.default.createElement(_reactFontawesome2.default, { name: icon, className: 'menuIcon' })
          ),
          navExpanded && _react2.default.createElement(
            _styledComponentsReactiveGrid.Column,
            { modifiers: ['col'] },
            _react2.default.createElement(
              _TextDiv2.default,
              { modifiers: ['smallText', 'uppercase'] },
              _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default[label] })
            )
          )
        )
      )
    )
  );
}

NonParentMenu.propTypes = {
  // `border` is true if this menu item should include a bottom border
  border: _propTypes2.default.bool.isRequired,

  // `icon` is the name of the FontAwesome icon to render for the menu item
  icon: _propTypes2.default.string.isRequired,

  // `label` is a property name in the message definitions (messages.js) for the label text
  label: _propTypes2.default.string.isRequired,

  // `navExpanded` is true if the left nav is expanded, false if not
  navExpanded: _propTypes2.default.bool.isRequired,

  // `path` is the route path for this menu item's link
  path: _propTypes2.default.string.isRequired

};

exports.default = NonParentMenu;

/***/ }),

/***/ "./compositions/LeftNav/LeftNavComponent/ParentMenu.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactFontawesome = __webpack_require__("../node_modules/react-fontawesome/lib/index.js");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _reactSmoothCollapse = __webpack_require__("../node_modules/react-smooth-collapse/js/index.js");

var _reactSmoothCollapse2 = _interopRequireDefault(_reactSmoothCollapse);

var _speakingurl = __webpack_require__("../node_modules/speakingurl/index.js");

var _speakingurl2 = _interopRequireDefault(_speakingurl);

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/styled-components-reactive-grid/dist/index.js");

var _TextDiv = __webpack_require__("./elements/TextDiv/index.js");

var _TextDiv2 = _interopRequireDefault(_TextDiv);

var _messages = __webpack_require__("./compositions/LeftNav/LeftNavComponent/messages.js");

var _messages2 = _interopRequireDefault(_messages);

var _MenuItem = __webpack_require__("./compositions/LeftNav/LeftNavComponent/MenuItem.js");

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _MenuItemWrapper = __webpack_require__("./compositions/LeftNav/LeftNavComponent/MenuItemWrapper.js");

var _MenuItemWrapper2 = _interopRequireDefault(_MenuItemWrapper);

var _SubMenu = __webpack_require__("./compositions/LeftNav/LeftNavComponent/SubMenu.js");

var _SubMenu2 = _interopRequireDefault(_SubMenu);

var _SubMenuItem = __webpack_require__("./compositions/LeftNav/LeftNavComponent/SubMenuItem.js");

var _SubMenuItem2 = _interopRequireDefault(_SubMenuItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Builds the sub menu items for the favorites supplied.
 * @param  {Collection} favorites An array of favorites objects
 * @return {Iterable}   An array of sub menu item components
 */
function subMenuItems(favorites) {
  return favorites.map(function (_ref) {
    var message = _ref.message,
        path = _ref.path,
        slug = _ref.slug;
    return _react2.default.createElement(
      _MenuItemWrapper2.default,
      { key: slug },
      _react2.default.createElement(
        _SubMenuItem2.default,
        { id: 'menu-item-' + (0, _speakingurl2.default)(message), to: path },
        _react2.default.createElement(_linguiReact.Trans, { id: message })
      )
    );
  });
}

/**
 * A ParentMenu is a top level menu item that has a submenu (for the list of favorites).
 */
function ParentMenu(_ref2) {
  var border = _ref2.border,
      expanded = _ref2.expanded,
      favorites = _ref2.favorites,
      icon = _ref2.icon,
      label = _ref2.label,
      navExpanded = _ref2.navExpanded,
      navKey = _ref2.navKey,
      onExpandParent = _ref2.onExpandParent,
      isActiveFunc = _ref2.isActiveFunc;

  // Handles click events on parent menu items.
  function parentMenuItemClickHandler() {
    // toggle the expanded state of this menu item & its children
    return onExpandParent({ key: navKey, expanded: !expanded });
  }

  return _react2.default.createElement(
    _MenuItemWrapper2.default,
    { modifiers: (0, _lodash.compact)([border && 'border']) },
    _react2.default.createElement(
      _MenuItem2.default,
      {
        isActive: isActiveFunc,
        onClick: parentMenuItemClickHandler,
        modifiers: ['singleLine']
      },
      _react2.default.createElement(
        _styledComponentsReactiveGrid.Container,
        null,
        _react2.default.createElement(
          _styledComponentsReactiveGrid.Row,
          { modifiers: ['middle'] },
          _react2.default.createElement(
            _styledComponentsReactiveGrid.Column,
            { modifiers: [navExpanded ? 'col_2' : 'col', 'start'] },
            icon && _react2.default.createElement(_reactFontawesome2.default, { name: icon, className: 'menuIcon' })
          ),
          navExpanded && _react2.default.createElement(
            _styledComponentsReactiveGrid.Column,
            { modifiers: ['col'] },
            _react2.default.createElement(
              _TextDiv2.default,
              { modifiers: ['smallText', 'uppercase'] },
              _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default[label] })
            )
          ),
          navExpanded && _react2.default.createElement(
            _styledComponentsReactiveGrid.Column,
            { modifiers: ['end', 'col'] },
            _react2.default.createElement(
              _TextDiv2.default,
              { modifiers: ['textAlignRight'] },
              _react2.default.createElement(_reactFontawesome2.default, { name: expanded ? 'chevron-up' : 'chevron-down', className: 'chevron' })
            )
          )
        )
      )
    ),
    _react2.default.createElement(
      _reactSmoothCollapse2.default,
      { expanded: expanded },
      _react2.default.createElement(
        _SubMenu2.default,
        { navExpanded: navExpanded },
        subMenuItems(favorites)
      )
    )
  );
}

ParentMenu.propTypes = {
  // `border` is true if this menu item should include a bottom border
  border: _propTypes2.default.bool.isRequired,

  // `expanded` is a boolean indicating if the submenu should be displayed.
  expanded: _propTypes2.default.bool,

  // `favorites` is an array of the submenu item definitions
  favorites: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    message: _propTypes2.default.string.isRequired,
    path: _propTypes2.default.string.isRequired,
    slug: _propTypes2.default.string.isRequired,
    title: _propTypes2.default.string.isRequired
  })).isRequired,

  // `icon` is the name of the FontAwesome icon to render for the menu item
  icon: _propTypes2.default.string.isRequired,

  // `label` is a property name in the message definitions (messages.js) for the label text
  label: _propTypes2.default.string.isRequired,

  // `navExpanded` is true if the left nav is expanded, false if not
  navExpanded: _propTypes2.default.bool.isRequired,

  // `navKey` is the in-app ID for the parent menu
  navKey: _propTypes2.default.string.isRequired,

  // `onExpandParent` is called when the parent menu item is clicked
  onExpandParent: _propTypes2.default.func.isRequired,

  // `isActiveFunc` is now being passed down, for shareability
  isActiveFunc: _propTypes2.default.func.isRequired

};

ParentMenu.defaultProps = {
  expanded: false,
  favorites: []
};

exports.default = ParentMenu;

/***/ }),

/***/ "./compositions/LeftNav/LeftNavComponent/SubMenu.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A SubMenu is the unordered list of favorites links under a parent menu item.
 */
/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  background: ' + props.theme.colors.base.chrome100 + ';\n  border-bottom: 0.8px solid ' + props.theme.colors.base.chrome200 + ';\n  font-size: ' + (0, _decisivUiUtils.px2rem)(11) + ';\n  list-style: none;\n  margin: 0;\n  padding: 0;\n\n  /* add a little extra padding above & below the submenu items: */\n  li:first-child a {\n    margin-top: ' + (0, _decisivUiUtils.px2rem)(6) + ';\n  }\n  li:last-child a {\n    margin-bottom: ' + (0, _decisivUiUtils.px2rem)(6) + ';\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome100: _propTypes2.default.string.isRequired,
      chrome200: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('SubMenu', _styledComponents2.default.ul, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./compositions/LeftNav/LeftNavComponent/SubMenuItem.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _MenuItem = __webpack_require__("./compositions/LeftNav/LeftNavComponent/MenuItem.js");

var _MenuItem2 = _interopRequireDefault(_MenuItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * SubMenuItem applies padding and line height to the submenu items (favorites).
 */
/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  line-height: ' + props.theme.dimensions.leftNavChildItemHeight + ';\n  padding-left: ' + (0, _decisivUiUtils.px2rem)(42) + ';\n\n  &:hover:not(.active) {\n    text-decoration: underline;\n    color: ' + props.theme.colors.base.linkHover + ';\n    background: ' + props.theme.colors.base.chrome100 + ';\n  }\n\n  &.active {\n    margin-left: ' + (0, _decisivUiUtils.px2rem)(6) + ';\n    padding-left: ' + (0, _decisivUiUtils.px2rem)(36) + ';\n    border-radius: 2px;\n    width: 77%;\n  }\n';
};

var themePropTypes = {
  dimensions: _propTypes2.default.shape({
    leftNavChildItemHeight: _propTypes2.default.string.isRequired
  }),
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome100: _propTypes2.default.string.isRequired,
      linkHover: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('SubMenuItem', (0, _styledComponents2.default)(_MenuItem2.default), styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./compositions/LeftNav/LeftNavComponent/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LeftNav = LeftNav;

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _Popover = __webpack_require__("./elements/Popover/index.js");

var _Popover2 = _interopRequireDefault(_Popover);

var _messages = __webpack_require__("./compositions/LeftNav/LeftNavComponent/messages.js");

var _messages2 = _interopRequireDefault(_messages);

var _FavoritesPopover = __webpack_require__("./compositions/LeftNav/LeftNavComponent/FavoritesPopover/index.js");

var _FavoritesPopover2 = _interopRequireDefault(_FavoritesPopover);

var _GhostLeftNav = __webpack_require__("./compositions/LeftNav/LeftNavComponent/GhostLeftNav/index.js");

var _GhostLeftNav2 = _interopRequireDefault(_GhostLeftNav);

var _LeftNavExpander = __webpack_require__("./compositions/LeftNav/LeftNavComponent/LeftNavExpander/index.js");

var _LeftNavExpander2 = _interopRequireDefault(_LeftNavExpander);

var _LeftNavList = __webpack_require__("./compositions/LeftNav/LeftNavComponent/LeftNavList.js");

var _LeftNavList2 = _interopRequireDefault(_LeftNavList);

var _LeftNavWrapper = __webpack_require__("./compositions/LeftNav/LeftNavComponent/LeftNavWrapper.js");

var _LeftNavWrapper2 = _interopRequireDefault(_LeftNavWrapper);

var _NonParentMenu = __webpack_require__("./compositions/LeftNav/LeftNavComponent/NonParentMenu.js");

var _NonParentMenu2 = _interopRequireDefault(_NonParentMenu);

var _ParentMenuContainer = __webpack_require__("./compositions/LeftNav/ParentMenuContainer.js");

var _ParentMenuContainer2 = _interopRequireDefault(_ParentMenuContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function parentMenuGroup(menuGroup, isFinalGroup, leftNavIsExpanded, theme) {
  return menuGroup.map(function (_ref, index) {
    var label = _ref.label,
        icon = _ref.icon,
        path = _ref.path,
        favorites = _ref.favorites;

    // Overrides the default logic used by React Router's `NavLink` to determine if a
    // parent menu item is active.
    var parentMenuIsActive = (0, _lodash.curry)(function (currentPath, match, _ref2) {
      var pathname = _ref2.pathname;
      return pathname.startsWith(currentPath);
    });

    // include a border for last menu item in each group, except
    // for the final group in the menu
    var hasBorder = index + 1 === menuGroup.length && !isFinalGroup;

    var hasFavorites = favorites && favorites.length;

    var target = hasFavorites ? _react2.default.createElement(_ParentMenuContainer2.default, {
      key: path,
      label: label,
      icon: icon,
      path: path,
      favorites: favorites,
      border: hasBorder,
      isActiveFunc: parentMenuIsActive(path)
    }) : _react2.default.createElement(_NonParentMenu2.default, {
      key: path,
      navExpanded: leftNavIsExpanded,
      label: label,
      icon: icon,
      path: path,
      border: hasBorder
    });

    if (leftNavIsExpanded) {
      return target;
    }

    var content = hasFavorites ? _react2.default.createElement(_FavoritesPopover2.default, {
      favorites: favorites,
      label: label,
      path: path,
      isActiveFunc: parentMenuIsActive(path)
    }) : _react2.default.createElement(
      _Popover.MessagePopover,
      null,
      _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default[label] })
    );

    return _react2.default.createElement(
      _Popover2.default,
      {
        key: path,
        showOnHover: true,
        position: 'right',
        noOffset: true,
        arrowVisible: false,
        bgColor: theme.colors.base.chrome100
      },
      _react2.default.createElement(
        _Popover.PopoverTarget,
        null,
        target
      ),
      _react2.default.createElement(
        _Popover.PopoverContent,
        null,
        content
      )
    );
  });
}

function parentMenus(menus, leftNavIsExpanded, theme) {
  if (!menus.length) {
    return _react2.default.createElement(_GhostLeftNav2.default, { navExpanded: leftNavIsExpanded });
  }
  return menus.map(function (menuGroup, groupIndex) {
    var isFinalGroup = groupIndex + 1 === menus.length;
    return parentMenuGroup(menuGroup, isFinalGroup, leftNavIsExpanded, theme);
  });
}

/**
 * The top-level component wrapper for the application left navigation menu.
 * `LeftNav` renders the top-level menu items and submenus for any favorites
 * specified in `menus`.
 */
function LeftNav(_ref3) {
  var companyId = _ref3.companyId,
      menus = _ref3.menus,
      navExpanded = _ref3.navExpanded,
      onExpandLeftNav = _ref3.onExpandLeftNav,
      tenant = _ref3.tenant,
      theme = _ref3.theme;

  return _react2.default.createElement(
    _LeftNavWrapper2.default,
    { id: 'left-nav', modifiers: (0, _lodash.compact)([navExpanded && 'navExpanded']) },
    _react2.default.createElement(
      _LeftNavList2.default,
      null,
      parentMenus(menus, navExpanded, theme)
    ),
    _react2.default.createElement(_LeftNavExpander2.default, {
      companyId: companyId,
      navExpanded: navExpanded,
      onExpandLeftNav: onExpandLeftNav,
      tenant: tenant
    })
  );
}

LeftNav.propTypes = {
  // companyId is used by the admin link for redirecting to Case Classic
  companyId: _propTypes2.default.string,
  // `menus` defines the menu structure - see `LeftNavContainer/menuDefault.js` for details
  menus: _propTypes2.default.arrayOf(_propTypes2.default.arrayOf(_propTypes2.default.shape())),

  // `navExpanded` is true if the left nav is navExpanded, false if it is collapsed
  navExpanded: _propTypes2.default.bool,

  // `onExpandLeftNav` is called by the expander when expanding or collapsing the left nav
  onExpandLeftNav: _propTypes2.default.func,

  tenant: _propTypes2.default.string.isRequired,

  theme: _propTypes2.default.shape({
    colors: _propTypes2.default.shape({
      base: _propTypes2.default.shape({
        chrome100: _propTypes2.default.string.isRequired
      }).isRequired
    }).isRequired
  }).isRequired
};

LeftNav.defaultProps = {
  menus: [],
  navExpanded: true,
  onExpandLeftNav: _lodash.noop,
  companyId: ''
};

exports.default = (0, _styledComponents.withTheme)(LeftNav);

/***/ }),

/***/ "./compositions/LeftNav/LeftNavComponent/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  administration: (0, _linguiReact.i18nMark)('Administration'),
  approvals: (0, _linguiReact.i18nMark)('Approvals'),
  assets: (0, _linguiReact.i18nMark)('Assets'),
  cases: (0, _linguiReact.i18nMark)('Cases'),
  collapsed: (0, _linguiReact.i18nMark)('Collapse Sidebar'),
  expanded: (0, _linguiReact.i18nMark)('Expand Sidebar'),
  reports: (0, _linguiReact.i18nMark)('Reports'),
  serviceRequests: (0, _linguiReact.i18nMark)('Service Requests')
};

exports.default = messages;

/***/ }),

/***/ "./compositions/LeftNav/ParentMenuContainer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.ParentMenuContainer = ParentMenuContainer;

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _reactRouterDom = __webpack_require__("../node_modules/react-router-dom/es/index.js");

var _actions = __webpack_require__("./redux/ui/actions.js");

var _selectors = __webpack_require__("./redux/ui/selectors.js");

var _immutableToJS = __webpack_require__("./utils/immutableToJS.js");

var _immutableToJS2 = _interopRequireDefault(_immutableToJS);

var _ParentMenu = __webpack_require__("./compositions/LeftNav/LeftNavComponent/ParentMenu.js");

var _ParentMenu2 = _interopRequireDefault(_ParentMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function parentMenuKey(_ref) {
  var label = _ref.label,
      icon = _ref.icon;

  return label + '-' + icon;
}

/**
 * This component hooks up a top-level left nav menu item (containing a favorites
 * submenu) with the Redux store so that the expanded/collapsed state of the menu
 * item can be persisted to the store.
 */
function ParentMenuContainer(_ref2) {
  var expandedParents = _ref2.expandedParents,
      expandParent = _ref2.expandParent,
      icon = _ref2.icon,
      label = _ref2.label,
      navExpanded = _ref2.navExpanded,
      isActiveFunc = _ref2.isActiveFunc,
      rest = _objectWithoutProperties(_ref2, ['expandedParents', 'expandParent', 'icon', 'label', 'navExpanded', 'isActiveFunc']);

  var onExpandParent = function onExpandParent(payload) {
    // only expand/contract submenus when the left nav is expanded
    if (navExpanded) {
      return expandParent(payload);
    }

    return false;
  };

  var navKey = parentMenuKey({ label: label, icon: icon });
  var isExpanded = !!(navExpanded && Array.isArray(expandedParents) && expandedParents.includes(navKey));

  return _react2.default.createElement(_ParentMenu2.default, _extends({
    onExpandParent: onExpandParent,
    navExpanded: navExpanded,
    expanded: isExpanded,
    label: label,
    icon: icon,
    navKey: navKey,
    isActiveFunc: isActiveFunc
  }, rest));
}

ParentMenuContainer.propTypes = {
  // `expandedParents` is the array of navKeys of the currently-expanded menu items
  expandedParents: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,

  // `expandParent` should be called when this menu item is expanded or collapsed
  expandParent: _propTypes2.default.func.isRequired,

  // `icon` is the name of the FontAwesome icon to render for the menu item
  icon: _propTypes2.default.string.isRequired,

  // `label` is a property name in the message definitions (messages.js) for the label text
  label: _propTypes2.default.string.isRequired,

  // `navExpanded` is true of the overall left nav menu is expanded
  navExpanded: _propTypes2.default.bool,

  // `isActiveFunc` is a passthrough function
  isActiveFunc: _propTypes2.default.func.isRequired
};

ParentMenuContainer.defaultProps = {
  navExpanded: true,
  expandedParents: []
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    navExpanded: (0, _selectors.leftNavExpandedSelector)(state),
    expandedParents: (0, _selectors.leftNavExpandedParentsSelector)(state)
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    expandParent: function expandParent(expanded) {
      return dispatch((0, _actions.expandLeftNavParent)(expanded));
    }
  };
}

exports.default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _immutableToJS2.default)(ParentMenuContainer)));

/***/ }),

/***/ "./compositions/LeftNav/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Container = __webpack_require__("./compositions/LeftNav/Container.js");

var _Container2 = _interopRequireDefault(_Container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Container2.default;

/***/ }),

/***/ "./compositions/LeftNav/menuDefault.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * The menu info passed into LeftNav is an array of arrays; each top-level array is a "group",
 * and within each group is a top-level menu item definition.
 *
 * The top-level menu item definitions each have the following properties:
 *  * label: the message key for the displayed text of the menu item
 *  * icon: the FontAwesome icon for the menu item
 *  * and either...
 *    * path: if the menu item has no "favorites", clicking it will go to this path
 *    ...or...
 *    * path: prefix of pathname for all favorites under this parent menu item
 *    * favorites: an array of sub-menu items, each having:
 *      * label: the message key for the displayed text of the menu item
 *      * filterId: the ID of the individual favorite
 *
 * If a top-level menu item has favorites, then clicking the menu item will simply expand or
 * contract the list of favorites; clicking the menu item will not change the current route.
 */
var menuDefault = [[{
  icon: 'briefcase',
  label: 'cases',
  path: '/cases'
}, {
  icon: 'check',
  label: 'approvals',
  path: '/approvals'
}, {
  icon: 'wrench',
  label: 'serviceRequests',
  path: '/service-requests'
},
// TODO: parts requests
{
  icon: 'truck',
  label: 'assets',
  path: '/assets'
}]];

exports.default = menuDefault;

/***/ }),

/***/ "./compositions/LoadingBar/Component/LoadingBarContent.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWidth = getWidth;
exports.getTransitionDuration = getTransitionDuration;

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getWidth(_ref) {
  var started = _ref.started,
      finished = _ref.finished;

  if (started) {
    return 90;
  } else if (finished) {
    return 100;
  }
  return 0;
}

function getTransitionDuration(_ref2) {
  var started = _ref2.started,
      finished = _ref2.finished;

  if (started) {
    return 3;
  } else if (finished) {
    return 0.5;
  }
  return 0;
}

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  background: ' + props.theme.colors.brand.primary + ';\n  height: 100%;\n  transition: width ' + getTransitionDuration(props) + 's linear;\n  width: ' + getWidth(props) + '%;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    brand: _propTypes2.default.shape({
      primary: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

var propTypes = {
  started: _propTypes2.default.bool.isRequired,
  finished: _propTypes2.default.bool.isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('LoadingBarContent', _styledComponents2.default.div, styles, { propTypes: propTypes, themePropTypes: themePropTypes });

/***/ }),

/***/ "./compositions/LoadingBar/Component/LoadingBarWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  background: ' + props.theme.colors.base.chrome200 + ';\n  bottom: 0;\n  height: 6px;\n  left: 0;\n  position: absolute;\n  width: 100%;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome200: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('LoadingBarWrapper', _styledComponents2.default.div, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./compositions/LoadingBar/Component/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _LoadingBarContent = __webpack_require__("./compositions/LoadingBar/Component/LoadingBarContent.js");

var _LoadingBarContent2 = _interopRequireDefault(_LoadingBarContent);

var _LoadingBarWrapper = __webpack_require__("./compositions/LoadingBar/Component/LoadingBarWrapper.js");

var _LoadingBarWrapper2 = _interopRequireDefault(_LoadingBarWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LoadingBarComponent(_ref) {
  var started = _ref.started,
      finished = _ref.finished;

  return _react2.default.createElement(
    _LoadingBarWrapper2.default,
    null,
    _react2.default.createElement(_LoadingBarContent2.default, {
      started: started,
      finished: finished
    })
  );
}

LoadingBarComponent.propTypes = {
  started: _propTypes2.default.bool.isRequired,
  finished: _propTypes2.default.bool.isRequired
};

exports.default = LoadingBarComponent;

/***/ }),

/***/ "./compositions/LoadingBar/Container.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadingBarContainer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _actions = __webpack_require__("./redux/app/actions.js");

var _selectors = __webpack_require__("./redux/app/selectors.js");

var _combinedSelectors = __webpack_require__("./redux/combinedSelectors.js");

var _Component2 = __webpack_require__("./compositions/LoadingBar/Component/index.js");

var _Component3 = _interopRequireDefault(_Component2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoadingBarContainer = exports.LoadingBarContainer = function (_Component) {
  _inherits(LoadingBarContainer, _Component);

  function LoadingBarContainer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LoadingBarContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LoadingBarContainer.__proto__ || Object.getPrototypeOf(LoadingBarContainer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      started: false,
      finished: false
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(LoadingBarContainer, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var loading = nextProps.loading,
          loadingStarted = nextProps.loadingStarted;


      if (loadingStarted) {
        // we need to reset `started` and `finished` first in order to start CSS transition
        this.setState({
          started: false,
          finished: false
        });

        (0, _lodash.delay)(function () {
          _this2.setState({
            started: true
          });
        }, 50);

        this.props.resetLoadingStarted();
      }

      // if the previous loading has stopped and current loading has started, `started` should be
      // settled by the previous loadingStarted.
      if (!this.props.loading && loading) {
        this.setState({
          started: !this.props.loadingStarted,
          finished: false
        });
      }

      // if the previous loading has started, `finished` should be settled by current loading.
      if (this.props.loading) {
        this.setState({
          started: false,
          finished: !loading
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          started = _state.started,
          finished = _state.finished;

      return _react2.default.createElement(_Component3.default, {
        started: started,
        finished: finished
      });
    }
  }]);

  return LoadingBarContainer;
}(_react.Component);

LoadingBarContainer.propTypes = {
  loading: _propTypes2.default.bool.isRequired,
  loadingStarted: _propTypes2.default.bool.isRequired,
  resetLoadingStarted: _propTypes2.default.func.isRequired
};
LoadingBarContainer.defaultProps = {
  loadingStarted: false // required for testing
};


function mapStateToProps(state) {
  return {
    loading: (0, _combinedSelectors.loadingSelector)(state),
    loadingStarted: (0, _selectors.loadingStartedSelector)(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    resetLoadingStarted: function resetLoadingStarted() {
      return dispatch((0, _actions.setLoadingStarted)(false));
    }
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(LoadingBarContainer);

/***/ }),

/***/ "./compositions/LoadingBar/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Container = __webpack_require__("./compositions/LoadingBar/Container.js");

var _Container2 = _interopRequireDefault(_Container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Container2.default;

/***/ }),

/***/ "./compositions/LocationWidget/AssetLocation.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RenderAddress = RenderAddress;

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _WithReverseGeocoding = __webpack_require__("./utils/mapping/WithReverseGeocoding.js");

var _WithReverseGeocoding2 = _interopRequireDefault(_WithReverseGeocoding);

var _widget = __webpack_require__("./utils/widget.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RenderAddress(_ref) {
  var address = _ref.address;

  return _react2.default.createElement(
    'span',
    null,
    (0, _widget.getOutputText)(address)
  );
}

RenderAddress.propTypes = {
  address: _propTypes2.default.string
};

RenderAddress.defaultProps = {
  address: null
};

function AssetLocation(_ref2) {
  var location = _ref2.location;

  return _react2.default.createElement(_WithReverseGeocoding2.default, {
    location: location,
    render: RenderAddress
  });
}

AssetLocation.propTypes = {
  location: _propTypes2.default.shape({
    lat: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    lon: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
  })
};

AssetLocation.defaultProps = {
  location: {}
};

exports.default = AssetLocation;

/***/ }),

/***/ "./compositions/LocationWidget/AssetLocationContainer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _immutableToJS = __webpack_require__("./utils/immutableToJS.js");

var _immutableToJS2 = _interopRequireDefault(_immutableToJS);

var _selectors = __webpack_require__("./redux/assets/selectors.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var withConnectedData = function withConnectedData(WrappedComponent) {
  function Container(props) {
    return _react2.default.createElement(WrappedComponent, props);
  }

  Container.propTypes = {
    assetInfo: _propTypes2.default.shape({
      location: _propTypes2.default.shape({
        lat: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
        lng: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
      })
    })
  };

  Container.defaultProps = {
    assetInfo: {}
  };

  function mapStateToProps(state) {
    return {
      assetInfo: (0, _selectors.currentAssetSelector)(state)
    };
  }

  return (0, _reactRedux.connect)(mapStateToProps)((0, _immutableToJS2.default)(Container));
};

exports.default = withConnectedData;

/***/ }),

/***/ "./compositions/LocationWidget/Cartographer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Cartographer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MapWithDirections = __webpack_require__("./components/MapWithDirections/index.js");

var _MapWithDirections2 = _interopRequireDefault(_MapWithDirections);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The Cartographer draws the map.
 *
 * The markers will be used for plotting driving directions (from the first marker to the last).
 * The directions will be rendered without markers of their own; instead, the custom markers
 * will be rendered. The `onDirectionsUpdate` function will be called with the DirectionService
 * response when it is received.
 */
var Cartographer = exports.Cartographer = function (_Component) {
  _inherits(Cartographer, _Component);

  function Cartographer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Cartographer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Cartographer.__proto__ || Object.getPrototypeOf(Cartographer)).call.apply(_ref, [this].concat(args))), _this), _this.toLatLng = function (latLon) {
      return latLon && { lat: latLon.lat, lng: latLon.lon };
    }, _this.makeMarkers = function (markerData) {
      return markerData.map(function (m) {
        return _extends({}, m, {
          showInfo: false, // indicates whether the marker info window is currently open
          position: _this.toLatLng(m.position) // make the position google-friendly
        });
      });
    }, _this.handleMarkerClick = function (targetMarker) {
      return _this.toggleMarker(targetMarker, true);
    }, _this.handleMarkerClose = function (targetMarker) {
      return _this.toggleMarker(targetMarker, false);
    }, _this.toggleMarker = function (targetMarker, showInfo) {
      return _this.setState({
        markers: _this.state.markers.map(function (marker) {
          if (marker === targetMarker) {
            return _extends({}, marker, { showInfo: showInfo });
          }
          return marker;
        })
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Cartographer, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var markers = this.props.markers;


      this.setState({
        directions: null,
        markers: this.makeMarkers(markers)
      });
    }

    /**
     * Converts an object with { lat, lon } into a GoogleMap-friendly { lat, lng }.
     * Returns `null` if `latLon` is not given.
     */


    /**
     * Creates marker objects in the appropriate format for the `Map` based on the
     * marker data provided as props to this component.
     */


    /**
     * Sets `showInfo` to true for the given marker, causing a re-render and
     * display of the info window.
     */


    /**
     * Sets `showInfo` to false for the given marker.
     */

  }, {
    key: 'render',
    value: function render() {
      var onDirectionsUpdate = this.props.onDirectionsUpdate;

      return _react2.default.createElement(_MapWithDirections2.default, {
        markers: this.state.markers,
        onMarkerClick: this.handleMarkerClick,
        onMarkerClose: this.handleMarkerClose,
        onDirectionsUpdate: onDirectionsUpdate
      });
    }
  }]);

  return Cartographer;
}(_react.Component);

Cartographer.propTypes = {
  markers: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    position: _propTypes2.default.shape({
      lat: _propTypes2.default.number.isRequired,
      lon: _propTypes2.default.number.isRequired
    }).isRequired,
    label: _propTypes2.default.string.isRequired
  })),
  onDirectionsUpdate: _propTypes2.default.func
};
Cartographer.defaultProps = {
  markers: [],
  onDirectionsUpdate: null
};
exports.default = Cartographer;

/***/ }),

/***/ "./compositions/LocationWidget/CaseLocationContainer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _immutableToJS = __webpack_require__("./utils/immutableToJS.js");

var _immutableToJS2 = _interopRequireDefault(_immutableToJS);

var _selectors = __webpack_require__("./redux/cases/selectors.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var withConnectedData = function withConnectedData(WrappedComponent) {
  function Container(props) {
    return _react2.default.createElement(WrappedComponent, props);
  }

  Container.propTypes = {
    assetInfo: _propTypes2.default.shape({
      location: _propTypes2.default.shape({
        lat: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
        lng: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
      })
    }),
    serviceProviderInfo: _propTypes2.default.shape({
      address: _propTypes2.default.shape({
        location: _propTypes2.default.shape({
          lat: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
          lng: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
        })
      })
    })
  };

  Container.defaultProps = {
    assetInfo: {},
    serviceProviderInfo: {}
  };

  function mapStateToProps(state) {
    return {
      assetInfo: (0, _selectors.currentCaseAssetSelector)(state),
      serviceProviderInfo: (0, _selectors.currentCaseServiceProviderSelector)(state)
    };
  }

  return (0, _reactRedux.connect)(mapStateToProps)((0, _immutableToJS2.default)(Container));
};

exports.default = withConnectedData;

/***/ }),

/***/ "./compositions/LocationWidget/LocationMap.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocationMap = LocationMap;

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _recompose = __webpack_require__("../node_modules/recompose/es/Recompose.js");

var _MapWrapper = __webpack_require__("./compositions/LocationWidget/MapWrapper.js");

var _MapWrapper2 = _interopRequireDefault(_MapWrapper);

var _Cartographer = __webpack_require__("./compositions/LocationWidget/Cartographer.js");

var _Cartographer2 = _interopRequireDefault(_Cartographer);

var _messages = __webpack_require__("./compositions/LocationWidget/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Get the lat/lon location values from the given entity.  The entity is expected to have
 * an object at the given path (e.g. 'address', 'location' mapping to entity.address.location)
 * which contains string-valued latitude and longitude values.
 */
function entityLocationInfo(entity, locationPath) {
  /* istanbul ignore else  */
  if (entity) {
    var location = (0, _lodash.get)(entity, locationPath);
    if (location) {
      // parse the string value lat/lon to floats
      return (0, _lodash.mapValues)(location, function (val) {
        return parseFloat(val);
      });
    }
  }
  return null;
}

/**
 * The LocationMap shows the map part of the Location widget for the given asset and
 * service provider.  An `onDirectionsUpdate` callback can be provided as a prop, which
 * will be called when the driving directions have been calculated between the asset
 * and the service provider.  The directions returned from the Google Maps API will
 * be passed to `onDirectionsUpdate`.
 */
function LocationMap(_ref) {
  var assetInfo = _ref.assetInfo,
      serviceProviderInfo = _ref.serviceProviderInfo,
      onDirectionsUpdate = _ref.onDirectionsUpdate,
      i18n = _ref.i18n;

  var markers = [];
  var assetLocation = entityLocationInfo(assetInfo, ['location']);
  var providerLocation = entityLocationInfo(serviceProviderInfo, ['address', 'location']);

  if (assetLocation) {
    markers.push({
      label: i18n._(_messages2.default.unit, { values: { unitNumber: assetInfo.unitNumber } }),
      position: assetLocation
    });
  }

  if (providerLocation) {
    markers.push({
      label: serviceProviderInfo.companyName,
      position: providerLocation
    });
  }

  return (assetLocation || providerLocation) && _react2.default.createElement(
    _MapWrapper2.default,
    null,
    _react2.default.createElement(_Cartographer2.default, {
      markers: markers,
      onDirectionsUpdate: onDirectionsUpdate
    })
  );
}

LocationMap.propTypes = {
  assetInfo: _propTypes2.default.shape({
    location: _propTypes2.default.shape({
      lat: _propTypes2.default.string,
      lon: _propTypes2.default.string
    })
  }).isRequired,
  serviceProviderInfo: _propTypes2.default.shape({
    location: _propTypes2.default.shape({
      lat: _propTypes2.default.string,
      lon: _propTypes2.default.string
    })
  }).isRequired,
  onDirectionsUpdate: _propTypes2.default.func,
  i18n: _propTypes2.default.shape({
    _: _propTypes2.default.func.isRequired
  }).isRequired
};

LocationMap.defaultProps = {
  onDirectionsUpdate: null
};

exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('LocationMap'), (0, _linguiReact.withI18n)())(LocationMap);

/***/ }),

/***/ "./compositions/LocationWidget/MapWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  height: ', ';\n'], ['\n  width: 100%;\n  height: ', ';\n']);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var MapWrapper = function () {
  var c = _styledComponents2.default.div(_templateObject, (0, _decisivUiUtils.px2rem)(265));

  c.displayName = 'MapWrapper';
  return c;
}();

exports.default = MapWrapper;

/***/ }),

/***/ "./compositions/LocationWidget/ServiceRequestLocationContainer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _immutableToJS = __webpack_require__("./utils/immutableToJS.js");

var _immutableToJS2 = _interopRequireDefault(_immutableToJS);

var _selectors = __webpack_require__("./redux/serviceRequests/selectors.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var withConnectedData = function withConnectedData(WrappedComponent) {
  function Container(props) {
    return _react2.default.createElement(WrappedComponent, props);
  }

  Container.propTypes = {
    assetInfo: _propTypes2.default.shape({
      location: _propTypes2.default.shape({
        lat: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
        lng: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
      })
    }),
    serviceProviderInfo: _propTypes2.default.shape({
      address: _propTypes2.default.shape({
        location: _propTypes2.default.shape({
          lat: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
          lng: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
        })
      })
    })
  };

  Container.defaultProps = {
    assetInfo: {},
    serviceProviderInfo: {}
  };

  function mapStateToProps(state) {
    return {
      assetInfo: (0, _selectors.currentServiceRequestAssetSelector)(state),
      serviceProviderInfo: (0, _selectors.currentServReqServProvSelector)(state)
    };
  }

  return (0, _reactRedux.connect)(mapStateToProps)((0, _immutableToJS2.default)(Container));
};

exports.default = withConnectedData;

/***/ }),

/***/ "./compositions/LocationWidget/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ServiceRequestLocationWidget = exports.CaseLocationWidget = exports.AssetLocationWidget = exports.LocationWidget = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _Widget = __webpack_require__("./elements/Widget/index.js");

var _Widget2 = _interopRequireDefault(_Widget);

var _widget = __webpack_require__("./utils/widget.js");

var _messages = __webpack_require__("./compositions/LocationWidget/messages.js");

var _messages2 = _interopRequireDefault(_messages);

var _LocationMap = __webpack_require__("./compositions/LocationWidget/LocationMap.js");

var _LocationMap2 = _interopRequireDefault(_LocationMap);

var _AssetLocation = __webpack_require__("./compositions/LocationWidget/AssetLocation.js");

var _AssetLocation2 = _interopRequireDefault(_AssetLocation);

var _AssetLocationContainer = __webpack_require__("./compositions/LocationWidget/AssetLocationContainer.js");

var _AssetLocationContainer2 = _interopRequireDefault(_AssetLocationContainer);

var _CaseLocationContainer = __webpack_require__("./compositions/LocationWidget/CaseLocationContainer.js");

var _CaseLocationContainer2 = _interopRequireDefault(_CaseLocationContainer);

var _ServiceRequestLocationContainer = __webpack_require__("./compositions/LocationWidget/ServiceRequestLocationContainer.js");

var _ServiceRequestLocationContainer2 = _interopRequireDefault(_ServiceRequestLocationContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LocationWidget = exports.LocationWidget = function (_Component) {
  _inherits(LocationWidget, _Component);

  function LocationWidget() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LocationWidget);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LocationWidget.__proto__ || Object.getPrototypeOf(LocationWidget)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      directions: null
    }, _this.onDirectionsUpdate = function (directions) {
      _this.setState({ directions: directions });
    }, _this.renderDistance = function () {
      if (_this.state.directions) {
        var routeLeg = _this.state.directions.routes[0].legs[0];
        return _react2.default.createElement(
          'span',
          null,
          routeLeg.distance.text,
          _react2.default.createElement('br', null),
          routeLeg.duration.text
        );
      }
      return (0, _widget.getOutputText)(null, _messages2.default.notAvailable);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(LocationWidget, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          assetInfo = _props.assetInfo,
          serviceProviderInfo = _props.serviceProviderInfo;


      var assetLocation = assetInfo.location;

      return _react2.default.createElement(
        _Widget2.default,
        { expandKey: 'case-location' },
        _react2.default.createElement(
          _Widget2.default.Header,
          null,
          _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.title })
        ),
        _react2.default.createElement(
          _Widget2.default.Item,
          null,
          _react2.default.createElement(_LocationMap2.default, {
            assetInfo: assetInfo,
            serviceProviderInfo: serviceProviderInfo,
            onDirectionsUpdate: this.onDirectionsUpdate
          })
        ),
        _react2.default.createElement(
          _Widget2.default.Item,
          null,
          _react2.default.createElement(
            _Widget2.default.Table,
            null,
            _react2.default.createElement(
              'tbody',
              null,
              _react2.default.createElement(
                _Widget2.default.TableRow,
                null,
                _react2.default.createElement(
                  'th',
                  null,
                  _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.assetLocation })
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  _react2.default.createElement(_AssetLocation2.default, { location: assetLocation || {} })
                )
              ),
              !(0, _lodash.isEmpty)(serviceProviderInfo) && _react2.default.createElement(
                _Widget2.default.TableRow,
                { modifiers: ['topGap'] },
                _react2.default.createElement(
                  'th',
                  null,
                  _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.distanceToServiceLocation })
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  this.renderDistance()
                )
              )
            )
          )
        )
      );
    }
  }]);

  return LocationWidget;
}(_react.Component);

LocationWidget.propTypes = {
  assetInfo: _propTypes2.default.shape({
    location: _propTypes2.default.shape({
      lat: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
      lng: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
    })
  }),
  serviceProviderInfo: _propTypes2.default.shape({
    address: _propTypes2.default.shape({
      location: _propTypes2.default.shape({
        lat: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
        lng: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
      })
    })
  })
};
LocationWidget.defaultProps = {
  assetInfo: {},
  serviceProviderInfo: {}
};
var AssetLocationWidget = exports.AssetLocationWidget = (0, _AssetLocationContainer2.default)(LocationWidget);
var CaseLocationWidget = exports.CaseLocationWidget = (0, _CaseLocationContainer2.default)(LocationWidget);
var ServiceRequestLocationWidget = exports.ServiceRequestLocationWidget = (0, _ServiceRequestLocationContainer2.default)(LocationWidget);

/***/ }),

/***/ "./compositions/LocationWidget/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  assetLocation: (0, _linguiReact.i18nMark)('Asset Location'),
  distanceToServiceLocation: (0, _linguiReact.i18nMark)('Distance to Service Location'),
  notAvailable: (0, _linguiReact.i18nMark)('Not Provided'),
  title: (0, _linguiReact.i18nMark)('Location'),
  unit: (0, _linguiReact.i18nMark)('Unit #{unitNumber}')
};

exports.default = messages;

/***/ }),

/***/ "./compositions/Logo/Container.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _selectors = __webpack_require__("./redux/ui/selectors.js");

var _immutableToJS = __webpack_require__("./utils/immutableToJS.js");

var _immutableToJS2 = _interopRequireDefault(_immutableToJS);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var withConnectedData = function withConnectedData(WrappedComponent) {
  function WithConnectedData(props) {
    return _react2.default.createElement(WrappedComponent, props);
  }

  function mapStateToProps(state) {
    return {
      brand: (0, _selectors.brandSelector)(state),
      logoImageUrl: (0, _selectors.brandLogoSelector)(state)
    };
  }

  return (0, _reactRedux.connect)(mapStateToProps)((0, _immutableToJS2.default)(WithConnectedData));
};

exports.default = withConnectedData;

/***/ }),

/***/ "./compositions/Logo/LogoImg.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Img = __webpack_require__("./elements/Img/index.js");

var _Img2 = _interopRequireDefault(_Img);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = '\n  width: auto;\n  height: ' + (0, _decisivUiUtils.px2rem)(50) + ';\n';

exports.default = (0, _decisivUiUtils.buildStyledComponent)('LogoImg', (0, _styledComponents2.default)(_Img2.default), styles);

/***/ }),

/***/ "./compositions/Logo/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Logo = Logo;

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__("../node_modules/react-router-dom/es/index.js");

var _recompose = __webpack_require__("../node_modules/recompose/es/Recompose.js");

var _Container = __webpack_require__("./compositions/Logo/Container.js");

var _Container2 = _interopRequireDefault(_Container);

var _LogoImg = __webpack_require__("./compositions/Logo/LogoImg.js");

var _LogoImg2 = _interopRequireDefault(_LogoImg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Logo(_ref) {
  var brand = _ref.brand,
      logoImageUrl = _ref.logoImageUrl;

  if (!logoImageUrl) {
    return _react2.default.createElement('span', null);
  }

  return _react2.default.createElement(
    _reactRouterDom.Link,
    { to: '/' },
    _react2.default.createElement(_LogoImg2.default, { src: logoImageUrl, alt: brand + ' logo' })
  );
}

Logo.propTypes = {
  brand: _propTypes2.default.string.isRequired,
  logoImageUrl: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])
};

Logo.defaultProps = {
  logoImageUrl: undefined
};

exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('Logo'), _Container2.default)(Logo);

/***/ }),

/***/ "./compositions/NotesWidget/CaseNotesContainer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _recompose = __webpack_require__("../node_modules/recompose/es/Recompose.js");

var _immutableToJS = __webpack_require__("./utils/immutableToJS.js");

var _immutableToJS2 = _interopRequireDefault(_immutableToJS);

var _selectors = __webpack_require__("./features/authentication/redux/selectors.js");

var _actions = __webpack_require__("./redux/cases/actions.js");

var _actions2 = __webpack_require__("./redux/ui/actions.js");

var _selectors2 = __webpack_require__("./redux/cases/selectors.js");

var _selectors3 = __webpack_require__("./redux/ui/selectors.js");

var _PropTypes = __webpack_require__("./compositions/NotesWidget/PropTypes.js");

var _PropTypes2 = _interopRequireDefault(_PropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var withConnectedData = function withConnectedData(WrappedComponent) {
  function Container(props) {
    return _react2.default.createElement(WrappedComponent, props);
  }

  Container.propTypes = _PropTypes2.default;

  Container.defaultProps = {
    actionBarItemClicked: {},
    info: {},
    notes: {
      requesting: false,
      error: null,
      data: []
    },
    availableRecipients: {
      requesting: false,
      error: null,
      data: []
    },
    scrollToUnreadNote: false
  };

  function mapStateToProps(state, ownProps) {
    return {
      actionBarItemClicked: (0, _selectors3.actionBarItemClickedSelector)(state),
      currentUser: (0, _selectors.userSelector)(state),
      info: ownProps.caseInfo || (0, _selectors2.currentCaseSelector)(state),
      notes: (0, _selectors2.caseNotesSelector)(state),
      availableRecipients: (0, _selectors2.caseRecipientsSelector)(state),
      componentsExpanded: (0, _selectors3.componentsExpandedSelector)(state),
      scrollToUnreadNote: (0, _selectors3.scrollToUnreadNoteSelector)(state)
    };
  }

  function mapDispatchToProps(dispatch) {
    return {
      clearAvailableRecipients: function clearAvailableRecipients() {
        return dispatch((0, _actions.clearCaseRecipients)());
      },
      loadNotes: function loadNotes(caseId) {
        return dispatch((0, _actions.loadCaseNotes)({ caseId: caseId }));
      },
      loadAvailableRecipients: function loadAvailableRecipients(caseId) {
        return dispatch((0, _actions.loadCaseRecipients)({ caseId: caseId }));
      },
      postNote: function postNote(payload) {
        return dispatch((0, _actions.postCaseNote)(payload));
      },
      setNotes: function setNotes(caseNotes) {
        return dispatch((0, _actions.setCaseNotes)(caseNotes));
      },
      updateNote: function updateNote(params) {
        return dispatch((0, _actions.updateCaseNote)(params));
      },
      setComponentExpanded: function setComponentExpanded(expandKey, expanded) {
        return dispatch((0, _actions2.setComponentExpanded)({ expandKey: expandKey, expanded: expanded }));
      },
      updateScrollToUnreadNote: function updateScrollToUnreadNote(bool) {
        return dispatch((0, _actions2.updateScrollToUnreadNote)(bool));
      }
    };
  }

  return (0, _recompose.compose)((0, _recompose.setDisplayName)('CaseNotesContainer'), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _immutableToJS2.default)(Container);
};

exports.default = withConnectedData;

/***/ }),

/***/ "./compositions/NotesWidget/GhostNote/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _baseComponents = __webpack_require__("../node_modules/base-components/build/index.js");

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/styled-components-reactive-grid/dist/index.js");

var _Gravatar = __webpack_require__("./elements/Gravatar/index.js");

var _Gravatar2 = _interopRequireDefault(_Gravatar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function GhostNote() {
  return _react2.default.createElement(
    _styledComponentsReactiveGrid.Container,
    null,
    _react2.default.createElement(
      _styledComponentsReactiveGrid.Row,
      null,
      _react2.default.createElement(
        _styledComponentsReactiveGrid.Column,
        { modifiers: ['center'], style: { maxWidth: '44px' } },
        _react2.default.createElement(_Gravatar2.default, { ghost: true })
      ),
      _react2.default.createElement(
        _styledComponentsReactiveGrid.Column,
        { modifiers: ['col'] },
        _react2.default.createElement(
          _styledComponentsReactiveGrid.Row,
          null,
          _react2.default.createElement(
            _styledComponentsReactiveGrid.Column,
            { modifiers: ['col_5'] },
            _react2.default.createElement(_baseComponents.GhostIndicator, null)
          )
        ),
        _react2.default.createElement(
          _styledComponentsReactiveGrid.Row,
          null,
          _react2.default.createElement(
            _styledComponentsReactiveGrid.Column,
            { modifiers: ['col_12'] },
            _react2.default.createElement(_baseComponents.GhostIndicator, null),
            _react2.default.createElement(_baseComponents.GhostIndicator, null)
          )
        )
      )
    )
  );
}

exports.default = GhostNote;

/***/ }),

/***/ "./compositions/NotesWidget/NoNotes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/styled-components-reactive-grid/dist/index.js");

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _TextDiv = __webpack_require__("./elements/TextDiv/index.js");

var _TextDiv2 = _interopRequireDefault(_TextDiv);

var _messages = __webpack_require__("./compositions/NotesWidget/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function NoNotes(_ref) {
  var requesting = _ref.requesting;

  var message = requesting ? 'loadingNotes' : 'noNotesYet';

  return _react2.default.createElement(
    _styledComponentsReactiveGrid.Container,
    null,
    _react2.default.createElement(
      _styledComponentsReactiveGrid.Row,
      { modifiers: ['middle'], style: { height: (0, _decisivUiUtils.px2rem)(100) } },
      _react2.default.createElement(
        _styledComponentsReactiveGrid.Column,
        { modifiers: ['col', 'center'] },
        _react2.default.createElement(
          _TextDiv2.default,
          { modifiers: ['midGreyText', 'smallText'] },
          _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default[message] })
        )
      )
    )
  );
}

NoNotes.propTypes = {
  requesting: _propTypes2.default.bool.isRequired
};

exports.default = NoNotes;

/***/ }),

/***/ "./compositions/NotesWidget/Note/NoteBlock.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var modifierConfig = {
  unread: function unread(_ref) {
    var theme = _ref.theme;
    return { styles: '\n    background-color: ' + theme.colors.base.selectableActive + ';\n    border-left: ' + (0, _decisivUiUtils.px2rem)(4) + ' solid ' + theme.colors.base.linkHover + ';\n  ' };
  },
  borderBottom: function borderBottom(_ref2) {
    var theme = _ref2.theme;
    return { styles: '\n    border-bottom: 2px solid ' + theme.colors.base.chrome200 + ';\n  ' };
  }
};

var styles = '\n  font-size: ' + (0, _decisivUiUtils.px2rem)(12) + ';\n  margin-bottom: ' + (0, _decisivUiUtils.px2rem)(5) + ';\n';

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome200: _propTypes2.default.string.isRequired,
      selectableActive: _propTypes2.default.string.isRequired,
      linkHover: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired,
  isRead: _propTypes2.default.bool
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('NoteBlock', _styledComponents2.default.div, styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

/***/ }),

/***/ "./compositions/NotesWidget/Note/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.buildRecipientFullName = buildRecipientFullName;
exports.buildRecipientCompanyName = buildRecipientCompanyName;
exports.buildUserLabel = buildUserLabel;
exports.buildFullRecipientText = buildFullRecipientText;
exports.buildFirstTwoRecipientText = buildFirstTwoRecipientText;
exports.buildSentAt = buildSentAt;

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _momentTimezone = __webpack_require__("../node_modules/moment-timezone/index.js");

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/styled-components-reactive-grid/dist/index.js");

var _baseComponents = __webpack_require__("../node_modules/base-components/build/index.js");

var _Expandable = __webpack_require__("./containers/Expandable/index.js");

var _Expandable2 = _interopRequireDefault(_Expandable);

var _DangerousHtmlMessage = __webpack_require__("./components/DangerousHtmlMessage/index.js");

var _DangerousHtmlMessage2 = _interopRequireDefault(_DangerousHtmlMessage);

var _Gravatar = __webpack_require__("./elements/Gravatar/index.js");

var _Gravatar2 = _interopRequireDefault(_Gravatar);

var _TextDiv = __webpack_require__("./elements/TextDiv/index.js");

var _TextDiv2 = _interopRequireDefault(_TextDiv);

var _Popover = __webpack_require__("./elements/Popover/index.js");

var _Popover2 = _interopRequireDefault(_Popover);

var _Span = __webpack_require__("./elements/Span/index.js");

var _Span2 = _interopRequireDefault(_Span);

var _Tooltip = __webpack_require__("./elements/Tooltip/index.js");

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _decisivDomainUtils = __webpack_require__("../node_modules/decisiv-domain-utils/build/index.js");

var _timeUtils = __webpack_require__("./utils/timeUtils.js");

var _NoteBlock = __webpack_require__("./compositions/NotesWidget/Note/NoteBlock.js");

var _NoteBlock2 = _interopRequireDefault(_NoteBlock);

var _messages = __webpack_require__("./compositions/NotesWidget/Note/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function buildRecipientFullName(user) {
  return user && (user.firstName || '') + ' ' + (user.lastName || '') + ' ';
}

function buildRecipientCompanyName(group) {
  return group.companyName;
}

function buildUserLabel(user, group) {
  var fullName = buildRecipientFullName(user);
  var companyName = buildRecipientCompanyName(group);
  return '' + (fullName || '') + (companyName ? '(' + companyName + ')' : '');
}

function buildFullRecipientText(_ref) {
  var recipients = _ref.recipients;

  return recipients.reduce(function (acc, recipient) {
    return acc + ' ' + buildUserLabel(recipient.user, recipient.group) + '\n';
  }, '');
}

function buildFirstTwoRecipientText(_ref2) {
  var recipients = _ref2.recipients;

  return buildFullRecipientText({ recipients: recipients.slice(0, 2) });
}

function buildSentAt(note) {
  return _momentTimezone2.default.tz(note.sentAt, (0, _timeUtils.userTimeZone)());
}

var Note = function (_Component) {
  _inherits(Note, _Component);

  function Note() {
    var _ref3;

    var _temp, _this, _ret;

    _classCallCheck(this, Note);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref3 = Note.__proto__ || Object.getPrototypeOf(Note)).call.apply(_ref3, [this].concat(args))), _this), _this.handleMouseEnter = function () {
      var note = _this.props.note;

      if (note.status === 'read') return;
      // It's better to save the timeout handler as a variable on this than
      // storing it in state because. In the latter case the component will
      // unnecessarily re-render whenever this happens.
      // Refer to: http://stackoverflow.com/a/25208809/3930247
      _this.hoverTimeout = setTimeout(function () {
        _this.props.updateNoteStatus(note.id, 'read');
      }, 3000);
    }, _this.handleMouseLeave = function () {
      if (_this.hoverTimeout) {
        clearTimeout(_this.hoverTimeout);
        _this.hoverTimeout = null;
      }
    }, _this.handleReplyClick = function (event) {
      event.preventDefault();
      _this.props.handleReply(_this.props.note);
    }, _this.handleExpandNote = function (expanded) {
      _this.props.onExpand(_this.props.note.id, expanded);
    }, _this.handleStatusLinkClick = function (event) {
      event.preventDefault();
      _this.props.handleStatusToggle(_this.props.note);
    }, _this.renderRecipientItem = function (_ref4) {
      var user = _ref4.user,
          group = _ref4.group;
      return _react2.default.createElement(
        _styledComponentsReactiveGrid.Row,
        { key: user.id + ':' + group.id },
        _react2.default.createElement(
          _styledComponentsReactiveGrid.Column,
          null,
          _react2.default.createElement(
            _TextDiv2.default,
            { modifiers: ['bold', 'midGreyText', 'padRight'] },
            buildRecipientFullName(user)
          )
        ),
        _react2.default.createElement(
          _styledComponentsReactiveGrid.Column,
          null,
          _react2.default.createElement(
            _TextDiv2.default,
            { modifiers: ['darkGreyText', 'lightText'] },
            buildRecipientCompanyName(group)
          )
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Note, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          expandKey = _props.expandKey,
          isExpanded = _props.isExpanded,
          _props$note$sender = _props.note.sender,
          sender = _props$note$sender === undefined ? {} : _props$note$sender,
          note = _props.note,
          borderBottom = _props.borderBottom;

      var senderGroup = sender.group || {};
      var senderUser = sender.user || {};

      var noteReadUnreadMessage = note.status === 'read' ? _messages2.default.markAsUnread : _messages2.default.markAsRead;

      var readStatus = note.status === 'unread' ? 'unread' : null;
      var borderBottomStatus = borderBottom && 'borderBottom';
      var hasMoreRecipients = note.recipients.length > 2;

      return _react2.default.createElement(
        _NoteBlock2.default,
        {
          onMouseEnter: this.handleMouseEnter,
          onMouseLeave: this.handleMouseLeave,
          modifiers: (0, _lodash.compact)([readStatus, borderBottomStatus]),
          id: this.props.note.id
        },
        _react2.default.createElement(
          _Expandable2.default,
          {
            expandKey: expandKey,
            hasPopover: true,
            isExpanded: isExpanded,
            onExpand: this.handleExpandNote,
            popoverMessages: _messages2.default
          },
          _react2.default.createElement(
            _Expandable.ExpandableHeader,
            null,
            _react2.default.createElement(
              _styledComponentsReactiveGrid.Container,
              null,
              _react2.default.createElement(
                _styledComponentsReactiveGrid.Row,
                { modifiers: ['middle'] },
                _react2.default.createElement(
                  _styledComponentsReactiveGrid.Column,
                  null,
                  _react2.default.createElement(_Gravatar2.default, { email: senderUser.email, round: true })
                ),
                _react2.default.createElement(
                  _styledComponentsReactiveGrid.Column,
                  null,
                  _react2.default.createElement(
                    _TextDiv2.default,
                    { modifiers: ['bold', 'mediumText'] },
                    buildUserLabel(senderUser, senderGroup)
                  )
                ),
                _react2.default.createElement(_styledComponentsReactiveGrid.Column, { modifiers: ['col'] }),
                _react2.default.createElement(
                  _styledComponentsReactiveGrid.Column,
                  { modifiers: ['end'] },
                  _react2.default.createElement(
                    _Tooltip2.default,
                    {
                      position: 'top',
                      message: function message() {
                        return _react2.default.createElement(_linguiReact.Trans, {
                          id: _messages2.default.readAt,
                          values: { date: (0, _timeUtils.formatDate)(buildSentAt(note)) }
                        });
                      }
                    },
                    _react2.default.createElement(
                      _TextDiv2.default,
                      { modifiers: ['capitalize', 'midGreyText', 'textAlignRight'] },
                      _react2.default.createElement(_decisivDomainUtils.FormattedRelative, {
                        value: buildSentAt(note),
                        render: function render(relativeTime) {
                          return _react2.default.createElement(
                            'span',
                            null,
                            relativeTime
                          );
                        }
                      })
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            _Expandable.ExpandableContent,
            null,
            _react2.default.createElement(
              _styledComponentsReactiveGrid.Container,
              null,
              _react2.default.createElement(
                _styledComponentsReactiveGrid.Row,
                null,
                _react2.default.createElement(_styledComponentsReactiveGrid.Column, { style: { width: '44px' } }),
                _react2.default.createElement(
                  _styledComponentsReactiveGrid.Column,
                  { modifiers: ['col'] },
                  _react2.default.createElement(
                    _TextDiv2.default,
                    { modifiers: ['heavyText', 'inline'] },
                    hasMoreRecipients ? buildFirstTwoRecipientText(note) : buildFullRecipientText(note),
                    hasMoreRecipients && _react2.default.createElement(
                      _Popover2.default,
                      {
                        showOnHover: true,
                        position: 'right',
                        positionOffset: 50,
                        delay: 500,
                        inlineBlock: true
                      },
                      _react2.default.createElement(
                        _Popover.PopoverTarget,
                        null,
                        _react2.default.createElement(
                          _Span2.default,
                          { modifiers: ['textLight', 'weightNormal'] },
                          _react2.default.createElement(_linguiReact.Trans, {
                            id: _messages2.default.more,
                            values: { count: note.recipients.length - 2 }
                          })
                        )
                      ),
                      _react2.default.createElement(
                        _Popover.PopoverContent,
                        null,
                        _react2.default.createElement(
                          _Popover.ScrollingPopoverContentWrapper,
                          { modifiers: ['smallText'] },
                          _react2.default.createElement(
                            _styledComponentsReactiveGrid.Container,
                            null,
                            note.recipients.map(function (recipient) {
                              return _this2.renderRecipientItem(recipient);
                            })
                          )
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(_DangerousHtmlMessage2.default, { message: note.message }),
                  _react2.default.createElement(
                    _styledComponentsReactiveGrid.Row,
                    null,
                    _react2.default.createElement(
                      _styledComponentsReactiveGrid.Column,
                      { modifiers: ['col', 'fluid'] },
                      _react2.default.createElement(
                        _baseComponents.ButtonLink,
                        { onClick: this.handleReplyClick },
                        _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.reply })
                      )
                    ),
                    note.status !== 'read_only' && _react2.default.createElement(
                      _styledComponentsReactiveGrid.Column,
                      { modifiers: ['col', 'end', 'fluid'] },
                      _react2.default.createElement(
                        _baseComponents.ButtonLink,
                        { onClick: this.handleStatusLinkClick },
                        _react2.default.createElement(_linguiReact.Trans, { id: noteReadUnreadMessage })
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Note;
}(_react.Component);

Note.propTypes = {
  expandKey: _propTypes2.default.string.isRequired,
  handleStatusToggle: _propTypes2.default.func.isRequired,
  handleReply: _propTypes2.default.func.isRequired,
  isExpanded: _propTypes2.default.bool,
  note: _propTypes2.default.shape({
    id: _propTypes2.default.number.isRequired
  }).isRequired,
  onExpand: _propTypes2.default.func,
  updateNoteStatus: _propTypes2.default.func.isRequired,
  borderBottom: _propTypes2.default.bool
};
Note.defaultProps = {
  isExpanded: undefined,
  onExpand: _lodash.noop,
  borderBottom: false
};
exports.default = Note;

/***/ }),

/***/ "./compositions/NotesWidget/Note/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  collapse: (0, _linguiReact.i18nMark)('Collapse Note'),
  expand: (0, _linguiReact.i18nMark)('Expand Note'),
  markAsRead: (0, _linguiReact.i18nMark)('Mark as Read'),
  markAsUnread: (0, _linguiReact.i18nMark)('Mark as Unread'),
  readAt: (0, _linguiReact.i18nMark)('{date}'),
  reply: (0, _linguiReact.i18nMark)('Reply'),
  more: (0, _linguiReact.i18nMark)('... {count} more')
};

exports.default = messages;

/***/ }),

/***/ "./compositions/NotesWidget/NoteCreator/NoteComposer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _baseComponents = __webpack_require__("../node_modules/base-components/build/index.js");

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/styled-components-reactive-grid/dist/index.js");

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _Select = __webpack_require__("./elements/Select/index.js");

var _Select2 = _interopRequireDefault(_Select);

var _Textarea = __webpack_require__("./elements/Textarea/index.js");

var _Textarea2 = _interopRequireDefault(_Textarea);

var _TextDiv = __webpack_require__("./elements/TextDiv/index.js");

var _TextDiv2 = _interopRequireDefault(_TextDiv);

var _WarningLabel = __webpack_require__("./components/WarningLabel/index.js");

var _WarningLabel2 = _interopRequireDefault(_WarningLabel);

var _messages = __webpack_require__("./compositions/NotesWidget/NoteCreator/messages.js");

var _messages2 = _interopRequireDefault(_messages);

var _RecipientCount = __webpack_require__("./compositions/NotesWidget/NoteCreator/RecipientCount/index.js");

var _RecipientCount2 = _interopRequireDefault(_RecipientCount);

var _constants = __webpack_require__("./compositions/NotesWidget/constants.js");

var _utils = __webpack_require__("./compositions/NotesWidget/utils.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NoteComposer = function (_Component) {
  _inherits(NoteComposer, _Component);

  function NoteComposer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NoteComposer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NoteComposer.__proto__ || Object.getPrototypeOf(NoteComposer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      message: ''
    }, _this.handleMessageChange = function (_ref2) {
      var target = _ref2.target;

      _this.setState({ message: target.value });
    }, _this.handleCreateClick = function () {
      var message = _this.state.message;

      _this.props.handleNoteCreate(message);
      _this.setState({ message: '' });
    }, _this.valueRenderer = function (option) {
      return option.label + ' (' + option.companyName + ')';
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NoteComposer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          availableRecipients = _props.availableRecipients,
          focusTextArea = _props.focusTextArea,
          handleRecipientChange = _props.handleRecipientChange,
          handleNewNoteCancel = _props.handleNewNoteCancel,
          selectedRecipients = _props.selectedRecipients;
      var message = this.state.message;

      var maxRecipientsReached = selectedRecipients.length > _constants.MAX_RECIPIENTS;
      var postButtonDisabled = !message || selectedRecipients.length === 0 || maxRecipientsReached;
      var recipientOptions = (0, _utils.buildRecipientOptions)(availableRecipients.data);

      return _react2.default.createElement(
        _styledComponentsReactiveGrid.Container,
        null,
        _react2.default.createElement(
          _styledComponentsReactiveGrid.Row,
          { modifiers: ['fluid'] },
          _react2.default.createElement(
            _styledComponentsReactiveGrid.Column,
            null,
            _react2.default.createElement(
              _TextDiv2.default,
              { modifiers: ['midGreyText', 'smallText', 'uppercase'] },
              _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.title })
            )
          )
        ),
        _react2.default.createElement(
          _styledComponentsReactiveGrid.Row,
          { modifiers: ['fluid', 'middle'] },
          _react2.default.createElement(
            _styledComponentsReactiveGrid.Column,
            { style: { width: (0, _decisivUiUtils.px2rem)(32) } },
            _react2.default.createElement(
              _TextDiv2.default,
              { modifiers: ['midGreyText', 'smallText', 'uppercase'] },
              _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.to })
            )
          ),
          _react2.default.createElement(
            _styledComponentsReactiveGrid.Column,
            { modifiers: ['col', 'fluid'] },
            _react2.default.createElement(_Select2.default, {
              autofocus: true,
              multi: true,
              onChange: handleRecipientChange,
              openOnFocus: true,
              options: recipientOptions,
              value: selectedRecipients,
              valueRenderer: this.valueRenderer
            }),
            selectedRecipients.length > _constants.MAX_RECIPIENTS / 2 && _react2.default.createElement(_RecipientCount2.default, { count: selectedRecipients.length, maxCount: _constants.MAX_RECIPIENTS }),
            maxRecipientsReached && _react2.default.createElement(
              _styledComponentsReactiveGrid.Row,
              null,
              _react2.default.createElement(
                _styledComponentsReactiveGrid.Column,
                null,
                _react2.default.createElement(_WarningLabel2.default, { label: _messages2.default.maxRecipientsError })
              )
            )
          )
        ),
        _react2.default.createElement(
          _styledComponentsReactiveGrid.Row,
          { modifiers: ['fluid'] },
          _react2.default.createElement(_styledComponentsReactiveGrid.Column, { style: { width: (0, _decisivUiUtils.px2rem)(32) } }),
          _react2.default.createElement(
            _styledComponentsReactiveGrid.Column,
            { modifiers: ['col'] },
            _react2.default.createElement(
              _styledComponentsReactiveGrid.Row,
              { modifiers: ['fluid'] },
              _react2.default.createElement(
                _styledComponentsReactiveGrid.Column,
                { modifiers: ['col'], style: { display: 'flex' } },
                _react2.default.createElement(_Textarea2.default, {
                  innerRef: function innerRef(textarea) {
                    focusTextArea(textarea);
                  },
                  onChange: this.handleMessageChange,
                  value: message
                })
              )
            ),
            _react2.default.createElement(
              _styledComponentsReactiveGrid.Row,
              { modifiers: ['end', 'fluid'] },
              _react2.default.createElement(
                _styledComponentsReactiveGrid.Column,
                { modifiers: ['end'] },
                _react2.default.createElement(
                  _baseComponents.QuickActionButton,
                  { onClick: handleNewNoteCancel },
                  _react2.default.createElement(
                    _baseComponents.QuickActionButton.Text,
                    null,
                    _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.cancelButton })
                  )
                )
              ),
              _react2.default.createElement(
                _styledComponentsReactiveGrid.Column,
                { modifiers: ['end'] },
                _react2.default.createElement(
                  _baseComponents.QuickActionButton,
                  {
                    modifiers: (0, _lodash.compact)([postButtonDisabled && 'disabled', 'secondary', 'hoverSuccess']),
                    onClick: this.handleCreateClick
                  },
                  _react2.default.createElement(
                    _baseComponents.QuickActionButton.Text,
                    null,
                    _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.postButton })
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return NoteComposer;
}(_react.Component);

NoteComposer.propTypes = {
  availableRecipients: _propTypes2.default.shape({
    requesting: _propTypes2.default.bool.isRequired,
    error: _propTypes2.default.object,
    data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      group: _propTypes2.default.shape({
        id: _propTypes2.default.string.isRequired
      }),
      user: _propTypes2.default.shape({
        id: _propTypes2.default.string.isRequired
      })
    })).isRequired
  }).isRequired,
  handleRecipientChange: _propTypes2.default.func.isRequired,
  handleNewNoteCancel: _propTypes2.default.func.isRequired,
  handleNoteCreate: _propTypes2.default.func.isRequired,
  focusTextArea: _propTypes2.default.func,
  selectedRecipients: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.string.isRequired,
    companyName: _propTypes2.default.string.isRequired,
    userId: _propTypes2.default.string.isRequired,
    groupId: _propTypes2.default.string.isRequired,
    value: _propTypes2.default.string.isRequired
  })).isRequired
};
NoteComposer.defaultProps = {
  focusTextArea: _lodash.noop
};
exports.default = NoteComposer;

/***/ }),

/***/ "./compositions/NotesWidget/NoteCreator/NoteCreatorError.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  color: ' + props.theme.colors.status.danger + ';\n  font-size: ' + (0, _decisivUiUtils.px2rem)(12) + ';\n  font-weight: bold;\n  line-height: ' + (0, _decisivUiUtils.px2rem)(18) + ';\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    status: _propTypes2.default.shape({
      danger: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('NoteCreatorError', _styledComponents2.default.span, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./compositions/NotesWidget/NoteCreator/RecipientCount/RecipientIcon.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnstyledFontAwesome = UnstyledFontAwesome;

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactFontawesome = __webpack_require__("../node_modules/react-fontawesome/lib/index.js");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function UnstyledFontAwesome(props) {
  var componentProps = (0, _lodash.omit)(props, ['theme', 'modifiers']);
  return _react2.default.createElement(_reactFontawesome2.default, componentProps);
}

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  color: ' + props.theme.colors.base.chrome500 + ';\n  padding-left: ' + (0, _decisivUiUtils.px2rem)(6) + ';\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome500: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('RecipientIcon', (0, _styledComponents2.default)(UnstyledFontAwesome), styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./compositions/NotesWidget/NoteCreator/RecipientCount/RecipientLabel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var modifierConfig = {
  warning: function warning(_ref) {
    var theme = _ref.theme;
    return {
      styles: '\n      color: ' + theme.colors.status.warning + ';\n    '
    };
  }
};

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  color: ' + props.theme.colors.base.chrome600 + ';\n  font-size: ' + (0, _decisivUiUtils.px2rem)(10) + ';\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome600: _propTypes2.default.string.isRequired
    }).isRequired,
    status: _propTypes2.default.shape({
      warning: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('RecipientLabel', _styledComponents2.default.span, styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

/***/ }),

/***/ "./compositions/NotesWidget/NoteCreator/RecipientCount/Wrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = '\n  font-size: ' + (0, _decisivUiUtils.px2rem)(12) + ';\n  position: absolute;\n  right: ' + (0, _decisivUiUtils.px2rem)(10) + ';\n  top: ' + (0, _decisivUiUtils.px2rem)(10) + ';\n';

exports.default = (0, _decisivUiUtils.buildStyledComponent)('RecipientCountWrapper', _styledComponents2.default.div, styles);

/***/ }),

/***/ "./compositions/NotesWidget/NoteCreator/RecipientCount/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _RecipientIcon = __webpack_require__("./compositions/NotesWidget/NoteCreator/RecipientCount/RecipientIcon.js");

var _RecipientIcon2 = _interopRequireDefault(_RecipientIcon);

var _RecipientLabel = __webpack_require__("./compositions/NotesWidget/NoteCreator/RecipientCount/RecipientLabel.js");

var _RecipientLabel2 = _interopRequireDefault(_RecipientLabel);

var _Wrapper = __webpack_require__("./compositions/NotesWidget/NoteCreator/RecipientCount/Wrapper.js");

var _Wrapper2 = _interopRequireDefault(_Wrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RecipientCount(_ref) {
  var count = _ref.count,
      maxCount = _ref.maxCount;

  var warningModifier = count > maxCount && 'warning';
  return _react2.default.createElement(
    _Wrapper2.default,
    null,
    _react2.default.createElement(
      _RecipientLabel2.default,
      { modifiers: (0, _lodash.compact)([warningModifier]) },
      count,
      '/',
      maxCount
    ),
    _react2.default.createElement(_RecipientIcon2.default, { name: 'users' })
  );
}

RecipientCount.propTypes = {
  count: _propTypes2.default.number,
  maxCount: _propTypes2.default.number.isRequired
};

RecipientCount.defaultProps = {
  count: 0
};

exports.default = RecipientCount;

/***/ }),

/***/ "./compositions/NotesWidget/NoteCreator/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _baseComponents = __webpack_require__("../node_modules/base-components/build/index.js");

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/styled-components-reactive-grid/dist/index.js");

var _NoteComposer = __webpack_require__("./compositions/NotesWidget/NoteCreator/NoteComposer.js");

var _NoteComposer2 = _interopRequireDefault(_NoteComposer);

var _NoteCreatorError = __webpack_require__("./compositions/NotesWidget/NoteCreator/NoteCreatorError.js");

var _NoteCreatorError2 = _interopRequireDefault(_NoteCreatorError);

var _messages = __webpack_require__("./compositions/NotesWidget/NoteCreator/messages.js");

var _messages2 = _interopRequireDefault(_messages);

var _constants = __webpack_require__("./compositions/NotesWidget/constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function NoteCreator(_ref) {
  var composerStatus = _ref.composerStatus,
      handleNewNoteClick = _ref.handleNewNoteClick,
      rest = _objectWithoutProperties(_ref, ['composerStatus', 'handleNewNoteClick']);

  return _react2.default.createElement(
    _styledComponentsReactiveGrid.Container,
    null,
    composerStatus === _constants.COMPOSER_VISIBLE ? _react2.default.createElement(_NoteComposer2.default, rest) : _react2.default.createElement(
      _styledComponentsReactiveGrid.Row,
      { modifiers: ['fluid'] },
      _react2.default.createElement(
        _styledComponentsReactiveGrid.Column,
        null,
        _react2.default.createElement(
          _baseComponents.QuickActionButton,
          { onClick: handleNewNoteClick },
          _react2.default.createElement(_baseComponents.QuickActionButton.Icon, { modifiers: ['left'], name: 'plus' }),
          _react2.default.createElement(
            _baseComponents.QuickActionButton.Text,
            null,
            _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.newNote })
          )
        )
      ),
      _react2.default.createElement(
        _styledComponentsReactiveGrid.Column,
        null,
        composerStatus === _constants.COMPOSER_ERROR && _react2.default.createElement(
          _NoteCreatorError2.default,
          null,
          _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.loadingRecipientsError })
        ),
        composerStatus === _constants.COMPOSER_NO_RECIPIENTS && _react2.default.createElement(
          _NoteCreatorError2.default,
          null,
          _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.noRecipientsError })
        )
      )
    )
  );
}

NoteCreator.propTypes = {
  composerStatus: _propTypes2.default.oneOf([_constants.COMPOSER_ERROR, _constants.COMPOSER_HIDDEN, _constants.COMPOSER_INVISIBLE, _constants.COMPOSER_LOADING, _constants.COMPOSER_NO_RECIPIENTS, _constants.COMPOSER_VISIBLE]).isRequired,
  handleNewNoteClick: _propTypes2.default.func.isRequired
};

exports.default = NoteCreator;

/***/ }),

/***/ "./compositions/NotesWidget/NoteCreator/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  cancelButton: (0, _linguiReact.i18nMark)('Cancel'),
  loadingRecipientsError: (0, _linguiReact.i18nMark)('Sorry, we had a connection issue while loading recipients. Please try again.'),
  maxRecipientsError: (0, _linguiReact.i18nMark)('You reached the max of 15 recipients. Remove some recipients to enable the Post button.'),
  newNote: (0, _linguiReact.i18nMark)('New Note'),
  noRecipientsError: (0, _linguiReact.i18nMark)('We didn\'t find any possible recipients. Please contact our support services team.'),
  postButton: (0, _linguiReact.i18nMark)('Post'),
  title: (0, _linguiReact.i18nMark)('New Note'),
  to: (0, _linguiReact.i18nMark)('To:')
};

exports.default = messages;

/***/ }),

/***/ "./compositions/NotesWidget/NotesOptionsBar.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _baseComponents = __webpack_require__("../node_modules/base-components/build/index.js");

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/styled-components-reactive-grid/dist/index.js");

var _DropDownSelector = __webpack_require__("./components/_common/DropDownSelector/index.js");

var _DropDownSelector2 = _interopRequireDefault(_DropDownSelector);

var _Widget = __webpack_require__("./elements/Widget/index.js");

var _Widget2 = _interopRequireDefault(_Widget);

var _messages = __webpack_require__("./compositions/NotesWidget/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function NotesOptionsBar(_ref) {
  var handleNewNoteClick = _ref.handleNewNoteClick,
      handleNoteOptionChange = _ref.handleNoteOptionChange,
      handleNoteSortOptionChange = _ref.handleNoteSortOptionChange,
      notesOptions = _ref.notesOptions,
      notesSortOptions = _ref.notesSortOptions,
      selectedNoteOption = _ref.selectedNoteOption,
      selectedNoteSortOption = _ref.selectedNoteSortOption;

  return _react2.default.createElement(
    _Widget2.default.OptionsBar,
    null,
    _react2.default.createElement(
      _styledComponentsReactiveGrid.Row,
      { modifiers: ['middle'] },
      _react2.default.createElement(
        _styledComponentsReactiveGrid.Column,
        null,
        _react2.default.createElement(_DropDownSelector2.default, {
          onChange: handleNoteOptionChange,
          options: notesOptions,
          selected: selectedNoteOption
        })
      ),
      _react2.default.createElement(_styledComponentsReactiveGrid.Column, null),
      _react2.default.createElement(
        _styledComponentsReactiveGrid.Column,
        null,
        _react2.default.createElement(_DropDownSelector2.default, {
          label: _messages2.default.sortLabel,
          onChange: handleNoteSortOptionChange,
          options: notesSortOptions,
          selected: selectedNoteSortOption
        })
      ),
      _react2.default.createElement(
        _styledComponentsReactiveGrid.Column,
        { modifiers: ['col', 'end'] },
        _react2.default.createElement(
          _baseComponents.QuickActionButton,
          { onClick: handleNewNoteClick },
          _react2.default.createElement(_baseComponents.QuickActionButton.Icon, { name: 'plus' })
        )
      )
    )
  );
}

NotesOptionsBar.propTypes = {
  handleNewNoteClick: _propTypes2.default.func.isRequired,
  handleNoteOptionChange: _propTypes2.default.func.isRequired,
  handleNoteSortOptionChange: _propTypes2.default.func.isRequired,
  notesOptions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    value: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.string.isRequired
  })).isRequired,
  notesSortOptions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    value: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.string.isRequired
  })).isRequired,
  selectedNoteOption: _propTypes2.default.shape({
    value: _propTypes2.default.string,
    label: _propTypes2.default.string
  }),
  selectedNoteSortOption: _propTypes2.default.shape({
    value: _propTypes2.default.string,
    label: _propTypes2.default.string
  })
};

NotesOptionsBar.defaultProps = {
  selectedNoteOption: undefined,
  selectedNoteSortOption: undefined
};

exports.default = NotesOptionsBar;

/***/ }),

/***/ "./compositions/NotesWidget/NotesWidgetHeader.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _messages = __webpack_require__("./compositions/NotesWidget/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function generateWidgetHeaderNote(_ref) {
  var unreadNotesCount = _ref.unreadNotesCount;

  return unreadNotesCount ? ' (' + unreadNotesCount + ' unread)' : '';
}

function NotesWidgetHeader(_ref2) {
  var info = _ref2.info;

  return _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.title, values: { count: generateWidgetHeaderNote(info) } });
}

NotesWidgetHeader.propTypes = {
  info: _propTypes2.default.shape({
    unreadNotesCount: _propTypes2.default.number
  }).isRequired
};

exports.default = NotesWidgetHeader;

/***/ }),

/***/ "./compositions/NotesWidget/PropTypes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotesPropTypes = {
  actionBarItemClicked: _propTypes2.default.shape({
    buttonId: _propTypes2.default.string,
    dropdownItemId: _propTypes2.default.string
  }),
  info: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    unreadNotesCount: _propTypes2.default.number
  }).isRequired,
  notes: _propTypes2.default.shape({
    requesting: _propTypes2.default.bool.isRequired,
    error: _propTypes2.default.object,
    data: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired
  }).isRequired,
  availableRecipients: _propTypes2.default.shape({
    requesting: _propTypes2.default.bool.isRequired,
    error: _propTypes2.default.object,
    data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      group: _propTypes2.default.shape({
        id: _propTypes2.default.string.isRequired
      }),
      user: _propTypes2.default.shape({
        id: _propTypes2.default.string.isRequired
      })
    })).isRequired
  }).isRequired,
  clearAvailableRecipients: _propTypes2.default.func.isRequired,
  loadNotes: _propTypes2.default.func.isRequired,
  loadAvailableRecipients: _propTypes2.default.func.isRequired,
  postNote: _propTypes2.default.func.isRequired,
  setNotes: _propTypes2.default.func.isRequired,
  updateNote: _propTypes2.default.func.isRequired,
  scrollToUnreadNote: _propTypes2.default.bool,
  updateScrollToUnreadNote: _propTypes2.default.func.isRequired
};

exports.default = NotesPropTypes;

/***/ }),

/***/ "./compositions/NotesWidget/ServiceRequestNotesContainer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _recompose = __webpack_require__("../node_modules/recompose/es/Recompose.js");

var _immutableToJS = __webpack_require__("./utils/immutableToJS.js");

var _immutableToJS2 = _interopRequireDefault(_immutableToJS);

var _selectors = __webpack_require__("./features/authentication/redux/selectors.js");

var _actions = __webpack_require__("./redux/ui/actions.js");

var _selectors2 = __webpack_require__("./redux/serviceRequests/selectors.js");

var _selectors3 = __webpack_require__("./redux/ui/selectors.js");

var _PropTypes = __webpack_require__("./compositions/NotesWidget/PropTypes.js");

var _PropTypes2 = _interopRequireDefault(_PropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var withConnectedData = function withConnectedData(WrappedComponent) {
  function Container(props) {
    return _react2.default.createElement(WrappedComponent, props);
  }

  Container.propTypes = _PropTypes2.default;

  Container.defaultProps = {
    actionBarItemClicked: {},
    info: {},
    notes: {
      requesting: false,
      error: null,
      data: []
    },
    availableRecipients: {
      requesting: false,
      error: null,
      data: []
    },
    scrollToUnreadNote: false
  };

  function mapStateToProps(state) {
    return {
      actionBarItemClicked: (0, _selectors3.actionBarItemClickedSelector)(state),
      currentUser: (0, _selectors.userSelector)(state),
      info: (0, _selectors2.currentServiceRequestSelector)(state),
      // TODO: Future implementation just add the contextual data refer to CaseNotesContainer
      // notes: currentServiceRequestNotes(state),
      // availableRecipients: currentRecipientsSelector(state),
      componentsExpanded: (0, _selectors3.componentsExpandedSelector)(state),
      scrollToUnreadNote: (0, _selectors3.scrollToUnreadNoteSelector)(state)
    };
  }

  function mapDispatchToProps(dispatch) {
    return {
      // TODO: Future Implementation just add the contextual actions
      clearAvailableRecipients: function clearAvailableRecipients() {
        return console.log('TODO: message');
      },
      loadNotes: function loadNotes() {
        return console.log('TODO: message');
      },
      loadAvailableRecipients: function loadAvailableRecipients() {
        return console.log('TODO: message');
      },
      postNote: function postNote() {
        return console.log('TODO: message');
      },
      setNotes: function setNotes() {
        return console.log('TODO: message');
      },
      updateNote: function updateNote() {
        return console.log('TODO: message');
      },
      setComponentExpanded: function setComponentExpanded(expandKey, expanded) {
        return dispatch((0, _actions.setComponentExpanded)({ expandKey: expandKey, expanded: expanded }));
      },
      updateScrollToUnreadNote: function updateScrollToUnreadNote(bool) {
        return dispatch((0, _actions.updateScrollToUnreadNote)(bool));
      }
    };
  }

  return (0, _recompose.compose)((0, _recompose.setDisplayName)('ServiceRequestNotesContainer'), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _immutableToJS2.default)(Container);
};

exports.default = withConnectedData;

/***/ }),

/***/ "./compositions/NotesWidget/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// Four states of the Note composer
var COMPOSER_ERROR = exports.COMPOSER_ERROR = 'COMPOSER_ERROR';
var COMPOSER_HIDDEN = exports.COMPOSER_HIDDEN = 'COMPOSER_HIDDEN';
var COMPOSER_INVISIBLE = exports.COMPOSER_INVISIBLE = 'COMPOSER_INVISIBLE';
var COMPOSER_LOADING = exports.COMPOSER_LOADING = 'COMPOSER_LOADING';
var COMPOSER_NO_RECIPIENTS = exports.COMPOSER_NO_RECIPIENTS = 'COMPOSER_NO_RECIPIENTS';
var COMPOSER_VISIBLE = exports.COMPOSER_VISIBLE = 'COMPOSER_VISIBLE';

// Maximum number of recipients that you can simultaneously send notes to
var MAX_RECIPIENTS = exports.MAX_RECIPIENTS = 15;

// react-scroll identifier for the Note creator block
var SCROLLABLE_COMPOSER_NAME = exports.SCROLLABLE_COMPOSER_NAME = 'note-composer';

/***/ }),

/***/ "./compositions/NotesWidget/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ServiceRequestNotesWidget = exports.CaseNotesWidget = exports.NotesWidgetHeader = exports.NotesWidget = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// TODO: Find a way to handle this that removes cross component dependency!
// Perhaps a app wide component registry, as has been suggested for
// generalized favorites & overview pages.


var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _reactScroll = __webpack_require__("../node_modules/react-scroll/modules/index.js");

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/styled-components-reactive-grid/dist/index.js");

var _baseComponents = __webpack_require__("../node_modules/base-components/build/index.js");

var _constants = __webpack_require__("./containers/QuickActionBarContainer/constants.js");

var _Expandable = __webpack_require__("./containers/Expandable/index.js");

var _Expandable2 = _interopRequireDefault(_Expandable);

var _Divider = __webpack_require__("./elements/Divider/index.js");

var _Divider2 = _interopRequireDefault(_Divider);

var _Widget = __webpack_require__("./elements/Widget/index.js");

var _Widget2 = _interopRequireDefault(_Widget);

var _CaseNotesContainer = __webpack_require__("./compositions/NotesWidget/CaseNotesContainer.js");

var _CaseNotesContainer2 = _interopRequireDefault(_CaseNotesContainer);

var _ServiceRequestNotesContainer = __webpack_require__("./compositions/NotesWidget/ServiceRequestNotesContainer.js");

var _ServiceRequestNotesContainer2 = _interopRequireDefault(_ServiceRequestNotesContainer);

var _constants2 = __webpack_require__("./compositions/NotesWidget/constants.js");

var _NotesWidgetHeader2 = __webpack_require__("./compositions/NotesWidget/NotesWidgetHeader.js");

var _NotesWidgetHeader3 = _interopRequireDefault(_NotesWidgetHeader2);

var _Note = __webpack_require__("./compositions/NotesWidget/Note/index.js");

var _Note2 = _interopRequireDefault(_Note);

var _NoteCreator = __webpack_require__("./compositions/NotesWidget/NoteCreator/index.js");

var _NoteCreator2 = _interopRequireDefault(_NoteCreator);

var _NotesOptionsBar = __webpack_require__("./compositions/NotesWidget/NotesOptionsBar.js");

var _NotesOptionsBar2 = _interopRequireDefault(_NotesOptionsBar);

var _NoNotes = __webpack_require__("./compositions/NotesWidget/NoNotes.js");

var _NoNotes2 = _interopRequireDefault(_NoNotes);

var _GhostNote = __webpack_require__("./compositions/NotesWidget/GhostNote/index.js");

var _GhostNote2 = _interopRequireDefault(_GhostNote);

var _messages = __webpack_require__("./compositions/NotesWidget/messages.js");

var _messages2 = _interopRequireDefault(_messages);

var _utils = __webpack_require__("./compositions/NotesWidget/utils.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function buildSelectedRecipients(selectedRecipients, noteRecipients) {
  var selectedRecipientsFromNote = noteRecipients.reduce(function (acc, group) {
    return acc.concat(group.options.map(function (recipient) {
      return _extends({}, recipient, { isInTree: true });
    }));
  }, []);
  var allSelectedRecipients = selectedRecipients.concat(selectedRecipientsFromNote);
  return (0, _lodash.uniqBy)(allSelectedRecipients, 'userId').slice(0, _constants2.MAX_RECIPIENTS);
}

function generateNoteExpandKey(noteId) {
  return 'noteExpanded-' + noteId;
}

function getCurrentOption(options, value) {
  return (0, _lodash.find)(options, function (opt) {
    return opt.value === value;
  });
}

function sortNotes(notes, sortValue) {
  var ascendingCaseNotes = (0, _lodash.sortBy)(notes, function (note) {
    return note.sentAt;
  });
  if (sortValue === 'desc') {
    return ascendingCaseNotes.reverse();
  }
  return ascendingCaseNotes;
}

function filterUnreadNotes(notes) {
  return notes.filter(function (note) {
    return note.status === 'unread';
  });
}

var NotesWidget = exports.NotesWidget = function (_Component) {
  _inherits(NotesWidget, _Component);

  function NotesWidget() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NotesWidget);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NotesWidget.__proto__ || Object.getPrototypeOf(NotesWidget)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      composerStatus: _constants2.COMPOSER_INVISIBLE,
      notesExpanded: {},
      selectedRecipients: [],
      shouldFocusTextArea: false,
      selectedNoteValue: '',
      selectedNoteSortValue: 'asc',
      oldNotesCollapsed: false
    }, _this.focusTextArea = function (textarea) {
      if (textarea && _this.state.shouldFocusTextArea) {
        textarea.focus();
        _this.setState({ shouldFocusTextArea: false });
      }
    }, _this.handleExpandNote = function (id, expanded) {
      var noteExpandKey = generateNoteExpandKey(id);
      _this.setState({
        notesExpanded: _extends({}, _this.state.notesExpanded, _defineProperty({}, noteExpandKey, expanded))
      });
    }, _this.handleExpandOldNotes = function () {
      _this.setState({ oldNotesCollapsed: false });
    }, _this.handleNewNoteCancel = function (event) {
      event.preventDefault();
      _this.setState({
        composerStatus: _constants2.COMPOSER_HIDDEN,
        selectedRecipients: [],
        shouldFocusTextArea: false
      });
    }, _this.handleNewNoteClick = function () {
      var _this$props = _this.props,
          info = _this$props.info,
          loadAvailableRecipients = _this$props.loadAvailableRecipients;
      var _this$state = _this.state,
          composerStatus = _this$state.composerStatus,
          selectedRecipients = _this$state.selectedRecipients;


      _this.scrollToNoteCreator();

      if (composerStatus === _constants2.COMPOSER_INVISIBLE || composerStatus === _constants2.COMPOSER_ERROR) {
        loadAvailableRecipients(info.id);
        _this.setState({ hasRequestedRecipients: true });
      }

      _this.setState({ composerStatus: _constants2.COMPOSER_VISIBLE }); // Batch state update makes this fine

      if (selectedRecipients.length) {
        _this.setState({
          shouldFocusTextArea: true
        });
      }
    }, _this.handleNoteCreate = function (message) {
      var _this$props2 = _this.props,
          info = _this$props2.info,
          postNote = _this$props2.postNote;
      var selectedRecipients = _this.state.selectedRecipients;

      var recipients = (0, _utils.selectedRecipientsforApi)(selectedRecipients);
      var payload = {
        caseId: info.id,
        params: {
          recipients: recipients,
          message: message
        }
      };
      _this.setState({
        composerStatus: _constants2.COMPOSER_HIDDEN,
        selectedRecipients: [],
        shouldFocusTextArea: false
      });
      postNote(payload);
    }, _this.handleNoteOptionChange = function (_ref2) {
      var value = _ref2.value;
      var notes = _this.props.notes.data;

      var notesExpanded = notes.reduce(function (acc, note) {
        var noteExpandKey = generateNoteExpandKey(note.id);
        (0, _lodash.set)(acc, noteExpandKey, value === 'expand');
        return acc;
      }, {});
      _this.setState({
        notesExpanded: notesExpanded,
        selectedNoteValue: null
      });
    }, _this.handleNoteSortOptionChange = function (_ref3) {
      var value = _ref3.value;

      _this.setState({ selectedNoteSortValue: value });
    }, _this.handleRecipientChange = function (value) {
      _this.setState({
        selectedRecipients: value
      });
    }, _this.handleReply = function (note) {
      var oldSelectedRecipients = _this.state.selectedRecipients;
      var currentUser = _this.props.currentUser;


      var newRecipients = [note.sender].concat(_toConsumableArray(note.recipients)).filter(function (recipient) {
        return recipient.user.email !== currentUser.email;
      });
      var noteRecipients = (0, _utils.buildRecipientOptions)(newRecipients);
      var selectedRecipients = buildSelectedRecipients(oldSelectedRecipients, noteRecipients);
      _this.setState({
        selectedRecipients: selectedRecipients,
        shouldFocusTextArea: true
      });
      _this.handleNewNoteClick();
    }, _this.handleStatusToggle = function (_ref4) {
      var noteId = _ref4.id,
          oldStatus = _ref4.status;

      var status = oldStatus === 'read' ? 'unread' : 'read';
      _this.handleUpdateNoteStatus(noteId, status);
    }, _this.handleUpdateNoteStatus = function (noteId, status) {
      _this.props.updateNote({
        caseId: _this.props.info.id,
        noteId: noteId,
        status: status
      });
    }, _this.notesOptions = function () {
      var i18n = _this.props.i18n;

      return [{
        value: 'expand',
        label: i18n._(_messages2.default.expandAll)
      }, {
        value: 'collapse',
        label: i18n._(_messages2.default.collapseAll)
      }];
    }, _this.notesSortOptions = function () {
      var i18n = _this.props.i18n;

      return [{
        value: 'asc',
        label: i18n._(_messages2.default.oldToNew)
      }, {
        value: 'desc',
        label: i18n._(_messages2.default.newToOld)
      }];
    }, _this.scrollToNoteCreator = function () {
      var options = {
        duration: 1000,
        smooth: true,
        offset: -_this.props.theme.dimensions.topNavHeightInPixel - 10 // adding some more space
      };

      if (_this.props.type === 'modal') {
        options.containerId = 'modal-body';
      }

      _reactScroll.scroller.scrollTo(_constants2.SCROLLABLE_COMPOSER_NAME, options);
    }, _this.scrollToUnreadNote = function () {
      if (_this.props.scrollToUnreadNote && _this.props.notes.data.length) {
        var sortedNotes = sortNotes(_this.props.notes.data, _this.state.selectedNoteSortValue);
        var firstUnreadNote = filterUnreadNotes(sortedNotes)[0];

        if (firstUnreadNote) {
          var options = {
            duration: 1500,
            smooth: true,
            delay: 200
          };

          if (_this.props.type === 'modal') {
            options.containerId = 'modal-body';
          } else {
            options.offset = -_this.props.theme.dimensions.topNavHeightInPixel;
          }

          _reactScroll.scroller.scrollTo(firstUnreadNote.id, options);
        }
        _this.props.updateScrollToUnreadNote(false);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NotesWidget, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          _props$info = _props.info,
          id = _props$info.id,
          notesCount = _props$info.notesCount,
          type = _props.type,
          action = _props.action,
          updateScrollToUnreadNote = _props.updateScrollToUnreadNote,
          loadNotes = _props.loadNotes;


      if (type === 'modal') {
        if (action === 'add_note') {
          this.setState({ composerStatus: _constants2.COMPOSER_VISIBLE });
        } else {
          updateScrollToUnreadNote(true);
        }
      }

      if (id && notesCount) {
        loadNotes(id);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref5) {
      var actionBarItemClicked = _ref5.actionBarItemClicked,
          _ref5$info = _ref5.info,
          id = _ref5$info.id,
          notesCount = _ref5$info.notesCount,
          notes = _ref5.notes,
          availableRecipients = _ref5.availableRecipients,
          setComponentExpanded = _ref5.setComponentExpanded,
          componentsExpanded = _ref5.componentsExpanded;

      if (!this.props.info.id && id && notesCount) {
        this.props.loadNotes(id);
      }

      if (!this.props.notes.data.length && notes.data.length > 8) {
        this.setState({ oldNotesCollapsed: true });
      }

      var recipientsChanging = availableRecipients !== this.props.availableRecipients;
      var requestInProgress = availableRecipients.requesting;
      if (this.state.hasRequestedRecipients && recipientsChanging && !requestInProgress) {
        var error = availableRecipients.error;
        var recipientData = availableRecipients.data;
        if (error || !recipientData) {
          this.setState({ composerStatus: _constants2.COMPOSER_ERROR });
        } else if ((0, _lodash.isEmpty)(recipientData)) {
          this.setState({ composerStatus: _constants2.COMPOSER_NO_RECIPIENTS });
        } else {
          this.setState({ composerStatus: _constants2.COMPOSER_VISIBLE });
        }
      }

      /* The logic here is complicated but required
        We should expand the component only when
        notesWidget was not expanded and button 'ADD NOTE' is just clicked.
        If notesWidget is expanded just before and 'ADD NOTE' is clicked,
        we call handleNoteClick which scrolls you to new note area which is ready to be written.
      */
      var buttonId = actionBarItemClicked && actionBarItemClicked.buttonId;
      var actionTime = actionBarItemClicked && actionBarItemClicked.time;
      var addingNote = buttonId === _constants.ADD_NOTE;
      var buttonWasJustClicked = buttonId !== this.props.actionBarItemClicked.buttonId || actionTime !== this.props.actionBarItemClicked.time;
      var notesWidgetExpanded = componentsExpanded && componentsExpanded['widget-notes'];
      var notesWidgetWasJustExpanded = notesWidgetExpanded && notesWidgetExpanded !== this.props.componentsExpanded['widget-notes'];
      var shouldExpandNotesWidget = !notesWidgetExpanded && buttonWasJustClicked;
      var shouldHandleNewNoteClick = notesWidgetExpanded && (buttonWasJustClicked || notesWidgetWasJustExpanded);
      if (addingNote) {
        if (shouldExpandNotesWidget) {
          setComponentExpanded('widget-notes', true);
        } else if (shouldHandleNewNoteClick) {
          this.handleNewNoteClick();
        }
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _props2 = this.props,
          type = _props2.type,
          action = _props2.action,
          _props2$notes = _props2.notes,
          requesting = _props2$notes.requesting,
          data = _props2$notes.data;
      /* When it's a modal to add a note from cases page */

      if (!requesting && prevProps.notes.requesting && data.length) {
        if (type === 'modal' && action === 'add_note') {
          /* right after the notes are loaded there are not yet rendered so we need wait a bit
            to scroll to note creator.
          */
          this.handleNewNoteClick();
          return;
        }
      }
      this.scrollToUnreadNote();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.clearAvailableRecipients();
      this.props.setNotes();
      this.props.updateScrollToUnreadNote(false);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props3 = this.props,
          info = _props3.info,
          notes = _props3.notes,
          availableRecipients = _props3.availableRecipients;
      var _state = this.state,
          composerStatus = _state.composerStatus,
          notesExpanded = _state.notesExpanded,
          selectedNoteSortValue = _state.selectedNoteSortValue,
          selectedNoteValue = _state.selectedNoteValue,
          selectedRecipients = _state.selectedRecipients,
          oldNotesCollapsed = _state.oldNotesCollapsed;


      var notesOptions = this.notesOptions();
      var notesSortOptions = this.notesSortOptions();

      var selectedNoteOption = getCurrentOption(notesOptions, selectedNoteValue);
      var selectedNoteSortOption = getCurrentOption(notesSortOptions, selectedNoteSortValue);

      var sortedCaseNotes = sortNotes(notes.data, selectedNoteSortValue);
      var shouldCollapseNotes = sortedCaseNotes.length > 8;
      var ascendingOrder = selectedNoteSortValue === 'asc';
      var shownNotes = void 0;
      var collapsedNotes = void 0;
      if (shouldCollapseNotes) {
        if (ascendingOrder) {
          shownNotes = sortedCaseNotes.slice(-5);
          collapsedNotes = sortedCaseNotes.slice(0, -5);
        } else {
          shownNotes = sortedCaseNotes.slice(0, 5);
          collapsedNotes = sortedCaseNotes.slice(5);
        }
      } else {
        shownNotes = sortedCaseNotes;
        collapsedNotes = [];
      }
      var collapsedTitle = _react2.default.createElement(
        _styledComponentsReactiveGrid.Container,
        null,
        _react2.default.createElement(
          _styledComponentsReactiveGrid.Row,
          { modifiers: ['center'] },
          _react2.default.createElement(
            _styledComponentsReactiveGrid.Column,
            { modifiers: ['col'] },
            _react2.default.createElement(
              _baseComponents.QuickActionButton,
              {
                onClick: this.handleExpandOldNotes
              },
              _react2.default.createElement(_linguiReact.Trans, {
                id: _messages2.default.oldNotesCollapsedHeader,
                values: { count: collapsedNotes.length }
              })
            )
          )
        )
      );
      var collapsedNotesContent = _react2.default.createElement(
        _Expandable2.default,
        {
          isExpanded: !oldNotesCollapsed,
          showHeaderWhenExpanded: false,
          hasExpandIcon: false
        },
        _react2.default.createElement(
          _Expandable.ExpandableHeader,
          null,
          collapsedTitle
        ),
        _react2.default.createElement(
          _Expandable.ExpandableContent,
          null,
          collapsedNotes.map(function (note, index) {
            var noteExpandKey = generateNoteExpandKey(note.id);
            var nextNoteIndex = index + 1 + (ascendingOrder ? 0 : shownNotes.length);
            var nextNote = sortedCaseNotes[nextNoteIndex];
            var borderBottom = false;
            if (nextNote && note.status === nextNote.status && note.status !== 'unread') {
              borderBottom = true;
            }
            return _react2.default.createElement(_Note2.default, {
              key: note.id,
              expandKey: noteExpandKey,
              handleReply: _this2.handleReply,
              handleStatusToggle: _this2.handleStatusToggle,
              isExpanded: notesExpanded[noteExpandKey],
              note: note,
              onExpand: _this2.handleExpandNote,
              updateNoteStatus: _this2.handleUpdateNoteStatus,
              borderBottom: borderBottom
            });
          })
        )
      );

      // If notesCount is less than 9, show number of GhostNotes equal to notesCount
      // Otherwise, show 5
      var ghostNotesCount = info.notesCount < 9 ? info.notesCount : 5;
      var noNotesContent = info.notesCount > 0 ? _react2.default.createElement(
        'div',
        null,
        Array.from(new Array(ghostNotesCount), function (x, i) {
          return _react2.default.createElement(_GhostNote2.default, { key: i });
        })
      ) : _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_NoNotes2.default, { requesting: notes.requesting }),
        _react2.default.createElement(_Divider2.default, { modifiers: ['light'] })
      );
      var shownNotesContent = notes.data.length > 0 ? shownNotes.map(function (note, index) {
        var noteExpandKey = generateNoteExpandKey(note.id);
        var nextNoteIndex = index + 1 + (ascendingOrder ? collapsedNotes.length : 0);
        var nextNote = sortedCaseNotes[nextNoteIndex];
        var borderBottom = false;
        if (nextNote && note.status === nextNote.status && note.status !== 'unread') {
          borderBottom = true;
        }
        return _react2.default.createElement(_Note2.default, {
          key: note.id,
          expandKey: noteExpandKey,
          handleReply: _this2.handleReply,
          handleStatusToggle: _this2.handleStatusToggle,
          isExpanded: notesExpanded[noteExpandKey],
          note: note,
          onExpand: _this2.handleExpandNote,
          updateNoteStatus: _this2.handleUpdateNoteStatus,
          borderBottom: borderBottom
        });
      }) : noNotesContent;

      var NotesWidgetBody = _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_NotesOptionsBar2.default, {
          handleNewNoteClick: this.handleNewNoteClick,
          handleNoteOptionChange: this.handleNoteOptionChange,
          handleNoteSortOptionChange: this.handleNoteSortOptionChange,
          notesOptions: notesOptions,
          notesSortOptions: notesSortOptions,
          selectedNoteOption: selectedNoteOption,
          selectedNoteSortOption: selectedNoteSortOption
        }),
        !ascendingOrder && shownNotesContent,
        collapsedNotesContent,
        ascendingOrder && shownNotesContent,
        _react2.default.createElement(_styledComponentsReactiveGrid.Container, null),
        _react2.default.createElement(
          _reactScroll.Element,
          { className: 'react-scroll-element NoteCreator', name: _constants2.SCROLLABLE_COMPOSER_NAME },
          _react2.default.createElement(_NoteCreator2.default, {
            availableRecipients: availableRecipients,
            composerStatus: composerStatus,
            focusTextArea: this.focusTextArea,
            handleNewNoteCancel: this.handleNewNoteCancel,
            handleNewNoteClick: this.handleNewNoteClick,
            handleNoteCreate: this.handleNoteCreate,
            handleRecipientChange: this.handleRecipientChange,
            selectedRecipients: selectedRecipients
          })
        )
      );

      if (this.props.type === 'modal') {
        return NotesWidgetBody;
      }

      return _react2.default.createElement(
        _Widget2.default,
        { className: 'NotesWidget', id: 'notes', expandKey: 'notes' },
        _react2.default.createElement(
          _Widget2.default.Header,
          null,
          _react2.default.createElement(_NotesWidgetHeader3.default, { info: info })
        ),
        _react2.default.createElement(
          _Widget2.default.Item,
          null,
          NotesWidgetBody
        )
      );
    }
  }]);

  return NotesWidget;
}(_react.Component);

NotesWidget.propTypes = {
  actionBarItemClicked: _propTypes2.default.shape({
    buttonId: _propTypes2.default.string,
    dropdownItemId: _propTypes2.default.string,
    time: _propTypes2.default.number
  }),
  componentsExpanded: _propTypes2.default.shape().isRequired,
  info: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    unreadNotesCount: _propTypes2.default.number
  }).isRequired,
  notes: _propTypes2.default.shape({
    requesting: _propTypes2.default.bool.isRequired,
    error: _propTypes2.default.object,
    data: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired
  }).isRequired,
  availableRecipients: _propTypes2.default.shape({
    requesting: _propTypes2.default.bool.isRequired,
    error: _propTypes2.default.object,
    data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      group: _propTypes2.default.shape({
        id: _propTypes2.default.string.isRequired
      }),
      user: _propTypes2.default.shape({
        id: _propTypes2.default.string.isRequired
      })
    })).isRequired
  }).isRequired,
  clearAvailableRecipients: _propTypes2.default.func.isRequired,
  i18n: _propTypes2.default.shape({
    _: _propTypes2.default.func.isRequired
  }).isRequired,
  loadNotes: _propTypes2.default.func.isRequired,
  loadAvailableRecipients: _propTypes2.default.func.isRequired,
  postNote: _propTypes2.default.func.isRequired,
  setNotes: _propTypes2.default.func.isRequired,
  updateNote: _propTypes2.default.func.isRequired,
  setComponentExpanded: _propTypes2.default.func.isRequired,
  theme: _propTypes2.default.shape({
    dimensions: _propTypes2.default.shape({
      topNavHeightInPixel: _propTypes2.default.number.isRequired
    }).isRequired
  }).isRequired,
  type: _propTypes2.default.oneOf([undefined, 'modal']),
  action: _propTypes2.default.oneOf([undefined, 'add_note']),
  scrollToUnreadNote: _propTypes2.default.bool,
  updateScrollToUnreadNote: _propTypes2.default.func.isRequired,
  currentUser: _propTypes2.default.shape({
    email: _propTypes2.default.string.isRequired
  })
};
NotesWidget.defaultProps = {
  actionBarItemClicked: {},
  type: undefined,
  scrollToUnreadNote: false,
  action: undefined,
  currentUser: {
    email: ''
  }
};


var NotesWidgetWithCommonHOCS = (0, _styledComponents.withTheme)((0, _linguiReact.withI18n)()(NotesWidget));

exports.NotesWidgetHeader = _NotesWidgetHeader3.default;
var CaseNotesWidget = exports.CaseNotesWidget = (0, _CaseNotesContainer2.default)(NotesWidgetWithCommonHOCS);
var ServiceRequestNotesWidget = exports.ServiceRequestNotesWidget = (0, _ServiceRequestNotesContainer2.default)(NotesWidgetWithCommonHOCS);

/***/ }),

/***/ "./compositions/NotesWidget/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  collapseAll: (0, _linguiReact.i18nMark)('Collapse All'),
  expandAll: (0, _linguiReact.i18nMark)('Expand All'),
  loadingNotes: (0, _linguiReact.i18nMark)('...Loading'),
  newToOld: (0, _linguiReact.i18nMark)('Newest to Oldest'),
  noNotesYet: (0, _linguiReact.i18nMark)('No notes yet.'),
  oldToNew: (0, _linguiReact.i18nMark)('Oldest to Newest'),
  oldNotesCollapsedHeader: (0, _linguiReact.i18nMark)('({count}) Older {count, plural, one {Comment} other {Comments}}'),
  sortLabel: (0, _linguiReact.i18nMark)('SORT:'),
  title: (0, _linguiReact.i18nMark)('Notes {count}')
};

exports.default = messages;

/***/ }),

/***/ "./compositions/NotesWidget/utils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.recipientToOption = recipientToOption;
exports.buildRecipientOptions = buildRecipientOptions;
exports.selectedRecipientsforApi = selectedRecipientsforApi;

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

/**
 * Turn the given recipient (as received from the Redux store) into an option value for use by the
 * recipients multiselect component. In addition to the required `label` and
 * `value` fields, extra fields will be included to help with rendering and processing of
 * the selected items.
 * @param {Object} recipient
 * @returns {{label: string, companyName: string, userId: string, groupId: string, value: string}}
 */
function recipientToOption(_ref) {
  var user = _ref.user,
      group = _ref.group;

  return {
    label: user.firstName + ' ' + user.lastName,
    companyName: group.companyName,
    userId: user.id,
    groupId: group.id,
    value: user.id
  };
}

/**
 * Builds an array of recipient options that are used in the `react-select-plus` component.
 * The given `recipients` are collected together based on shared `group` values so that they
 * appear as `optgroups` in the rendered select.
 *
 * @param {Array} recipients: an array of `group` and `user` pairs received from the API.
 *  Example:
 *    recipients = [
 *      {
 *        group: {
 *          companyName: ‘Volvo’,
 *          id: ’12’,
 *        },
 *        user: {
 *          email: ‘abc@abc.com’,
 *          id: ’333’,
 *          firstName: ‘Bill’,
 *          lastName: ‘Lentz’,
 *        },
 *      },
 *      {
 *        group: {...},
 *        user: {...},
 *      },
 *    ];
 * @return {Array} grouped options based on the user's groups
 *  Example:
 *    returnArray = [
 *      {
 *        label: <group_company_name>,
 *        options: [ ...results from `recipientToOption` for each recipient ]
 *      },
 *      {
 *        label: <group_company_name>,
 *        options: [ ...results from `recipientToOption` for each recipient ]
 *      }
 *    ];
 */
function buildRecipientOptions(recipients) {
  return recipients.reduce(function (acc, recipient) {
    var companyName = recipient.group.companyName;

    var newOption = recipientToOption(recipient);
    var existingGroup = (0, _lodash.find)(acc, function (g) {
      return g.label === companyName;
    });
    if (existingGroup) {
      existingGroup.options = existingGroup.options.concat(newOption);
      return acc;
    }
    return acc.concat({
      label: companyName,
      options: [newOption]
    });
  }, []);
}

/**
 * Given an array of selected note recipients from the multiselect, return an
 * array of objects representing these users for use by the API.  Each item
 * in the array will be an object with the `userId` and `groupId` of the
 * recipient.
 * @param {{userId: string, groupId: string}[]} selections
 * @returns {{userId: string, groupId: string}[]}
 */
function selectedRecipientsforApi(selections) {
  return selections.map(function (selection) {
    return {
      userId: selection.userId,
      groupId: selection.groupId
    };
  });
}

/***/ }),

/***/ "./compositions/OpenEventsWidget/AssetCaseTable.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _reactFontawesome = __webpack_require__("../node_modules/react-fontawesome/lib/index.js");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _momentTimezone = __webpack_require__("../node_modules/moment-timezone/index.js");

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _immutable = __webpack_require__("../node_modules/immutable/dist/immutable.js");

var _decisivDomainUtils = __webpack_require__("../node_modules/decisiv-domain-utils/build/index.js");

var _timeUtils = __webpack_require__("./utils/timeUtils.js");

var _widget = __webpack_require__("./utils/widget.js");

var _Widget = __webpack_require__("./elements/Widget/index.js");

var _Widget2 = _interopRequireDefault(_Widget);

var _TextDiv = __webpack_require__("./elements/TextDiv/index.js");

var _TextDiv2 = _interopRequireDefault(_TextDiv);

var _Popover = __webpack_require__("./elements/Popover/index.js");

var _Popover2 = _interopRequireDefault(_Popover);

var _Span = __webpack_require__("./elements/Span/index.js");

var _Span2 = _interopRequireDefault(_Span);

var _ETR = __webpack_require__("./components/_common/ETR/index.js");

var _ETR2 = _interopRequireDefault(_ETR);

var _UnreadNoteLabelContainer = __webpack_require__("./containers/UnreadNoteLabelContainer/index.js");

var _UnreadNoteLabelContainer2 = _interopRequireDefault(_UnreadNoteLabelContainer);

var _AssetCaseTableWrapper = __webpack_require__("./compositions/OpenEventsWidget/AssetCaseTableWrapper.js");

var _AssetCaseTableWrapper2 = _interopRequireDefault(_AssetCaseTableWrapper);

var _UnreadNotesIcon = __webpack_require__("./compositions/OpenEventsWidget/UnreadNotesIcon.js");

var _UnreadNotesIcon2 = _interopRequireDefault(_UnreadNotesIcon);

var _FollowUpIcon = __webpack_require__("./compositions/OpenEventsWidget/FollowUpIcon.js");

var _FollowUpIcon2 = _interopRequireDefault(_FollowUpIcon);

var _StatusSpanLeftPadded = __webpack_require__("./compositions/OpenEventsWidget/StatusSpanLeftPadded.js");

var _StatusSpanLeftPadded2 = _interopRequireDefault(_StatusSpanLeftPadded);

var _messages = __webpack_require__("./compositions/OpenEventsWidget/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AssetCaseTable(_ref) {
  var assetCase = _ref.assetCase,
      serviceProvider = _ref.serviceProvider;
  var approvalStatus = assetCase.approvalStatus,
      complaint = assetCase.complaint,
      caseDescription = assetCase.description,
      followUpColor = assetCase.followUpColor,
      followUpTime = assetCase.followUpTime,
      requestedAt = assetCase.requestedAt,
      unreadNotesCount = assetCase.unreadNotesCount;

  var _ref2 = complaint || {},
      complaintCode = _ref2.code,
      complaintDescription = _ref2.description;

  var complaintTitle = complaintCode && complaintDescription && complaintCode + ' - ' + complaintDescription;

  var approvalStatusModifier = approvalStatus && (0, _lodash.camelCase)(approvalStatus);

  var unreadNotesIcon = unreadNotesCount ? 'envelope' : 'envelope-o';
  var unreadNotesCountModifier = unreadNotesCount ? 'hasUnreadNotes' : '';

  var createdAt = requestedAt && _react2.default.createElement(_decisivDomainUtils.FormattedRelative, {
    render: function render(relativeTime) {
      return _react2.default.createElement(
        _Span2.default,
        { modifiers: ['capitalize'] },
        relativeTime
      );
    },
    value: _momentTimezone2.default.tz(requestedAt, (0, _timeUtils.userTimeZone)())
  });

  var followUpLabel = followUpTime && _react2.default.createElement(_decisivDomainUtils.FormattedRelative, {
    render: function render(relativeTime) {
      return _react2.default.createElement(
        'span',
        null,
        relativeTime
      );
    },
    value: _momentTimezone2.default.tz(followUpTime, (0, _timeUtils.userTimeZone)())
  });

  if ((0, _lodash.isEmpty)(assetCase)) {
    return null;
  }

  return _react2.default.createElement(
    _AssetCaseTableWrapper2.default,
    null,
    _react2.default.createElement(
      _Widget2.default.Table,
      { modifiers: ['noFlex', 'padRight'] },
      _react2.default.createElement(
        'tbody',
        null,
        _react2.default.createElement(
          _Widget2.default.TableRow,
          null,
          _react2.default.createElement(
            'th',
            null,
            _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.serviceProvider })
          ),
          _react2.default.createElement(
            'td',
            null,
            serviceProvider.companyName
          )
        ),
        _react2.default.createElement(
          _Widget2.default.TableRow,
          { modifiers: ['topGap'] },
          _react2.default.createElement(
            'th',
            null,
            _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.complaint })
          ),
          _react2.default.createElement(
            'td',
            null,
            _react2.default.createElement(
              _Popover2.default,
              { showOnHover: true },
              _react2.default.createElement(
                _Popover.PopoverTarget,
                null,
                _react2.default.createElement(
                  _TextDiv2.default,
                  {
                    modifiers: ['bottomGap', 'heavyText', 'ellipsis', 'oneLine', 'smallText', 'smallWidth']
                  },
                  (0, _widget.getOutputText)(complaintTitle, _messages2.default.undefinedComplaint)
                ),
                _react2.default.createElement(
                  _TextDiv2.default,
                  { modifiers: ['ellipsis', 'short', 'smallWidth'] },
                  complaintCode && (0, _widget.getOutputText)(caseDescription)
                )
              ),
              _react2.default.createElement(
                _Popover.PopoverContent,
                null,
                _react2.default.createElement(
                  _Popover.ScrollingPopoverContentWrapper,
                  { modifiers: ['smallText'] },
                  _react2.default.createElement(
                    _TextDiv2.default,
                    { modifiers: ['bold', 'bright', 'bottomGap'] },
                    (0, _widget.getOutputText)(complaintTitle, _messages2.default.undefinedComplaint)
                  ),
                  _react2.default.createElement(
                    _TextDiv2.default,
                    { modifiers: ['bottomGap'] },
                    complaintCode && (0, _widget.getOutputText)(caseDescription)
                  )
                )
              )
            )
          )
        )
      )
    ),
    _react2.default.createElement(
      _Widget2.default.Table,
      { modifiers: ['noFlex', 'padRight'] },
      _react2.default.createElement(
        'tbody',
        null,
        _react2.default.createElement(
          _Widget2.default.TableRow,
          null,
          _react2.default.createElement(
            'th',
            null,
            _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.status })
          ),
          _react2.default.createElement(
            'td',
            null,
            (0, _widget.getOutputText)(assetCase.repairStatus)
          )
        ),
        _react2.default.createElement(
          _Widget2.default.TableRow,
          { modifiers: ['topGapSmall'] },
          _react2.default.createElement(
            'th',
            null,
            _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.estimate })
          ),
          _react2.default.createElement(
            'td',
            null,
            _react2.default.createElement(
              'span',
              null,
              (0, _widget.getOutputText)(assetCase.estimateTotal)
            ),
            _react2.default.createElement(
              _StatusSpanLeftPadded2.default,
              {
                modifiers: (0, _lodash.compact)([approvalStatusModifier, 'bold', 'uppercase'])
              },
              approvalStatus
            )
          )
        ),
        _react2.default.createElement(
          _Widget2.default.TableRow,
          { modifiers: ['topGapSmall'] },
          _react2.default.createElement(
            'th',
            null,
            _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.etr })
          ),
          _react2.default.createElement(
            'td',
            null,
            _react2.default.createElement(_ETR2.default, { caseInfo: (0, _immutable.fromJS)(assetCase) })
          )
        ),
        _react2.default.createElement(
          _Widget2.default.TableRow,
          { modifiers: ['topGapSmall'] },
          _react2.default.createElement(
            'th',
            null,
            _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.created })
          ),
          _react2.default.createElement(
            'td',
            null,
            (0, _widget.getOutputText)(createdAt)
          )
        )
      )
    ),
    _react2.default.createElement(
      _Widget2.default.Table,
      { modifiers: ['noFlex'] },
      _react2.default.createElement(
        'tbody',
        null,
        _react2.default.createElement(
          _Widget2.default.TableRow,
          null,
          _react2.default.createElement(
            'th',
            null,
            _react2.default.createElement(
              _UnreadNotesIcon2.default,
              { modifiers: (0, _lodash.compact)([unreadNotesCountModifier]) },
              _react2.default.createElement(_reactFontawesome2.default, { name: unreadNotesIcon })
            ),
            _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.notes })
          ),
          _react2.default.createElement(
            'td',
            null,
            _react2.default.createElement(_UnreadNoteLabelContainer2.default, { hasModal: true, hideIcon: true, caseInfo: (0, _immutable.fromJS)(assetCase) })
          )
        ),
        _react2.default.createElement(
          _Widget2.default.TableRow,
          { modifiers: ['topGapSmall'] },
          _react2.default.createElement(
            'th',
            null,
            _react2.default.createElement(
              _FollowUpIcon2.default,
              { modifiers: (0, _lodash.compact)([followUpColor]) },
              _react2.default.createElement(_reactFontawesome2.default, { name: 'flag' })
            ),
            _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.followUp })
          ),
          _react2.default.createElement(
            'td',
            null,
            (0, _widget.getOutputText)(followUpLabel)
          )
        )
      )
    )
  );
}

AssetCaseTable.propTypes = {
  assetCase: _propTypes2.default.shape({
    approvalStatus: _propTypes2.default.string,
    complaint: _propTypes2.default.shape({
      code: _propTypes2.default.string,
      description: _propTypes2.default.string
    }),
    description: _propTypes2.default.string,
    downtime: _propTypes2.default.string,
    estimateTotal: _propTypes2.default.string,
    followUpColor: _propTypes2.default.string,
    followUpTime: _propTypes2.default.string,
    repairStatus: _propTypes2.default.string,
    unreadNotesCount: _propTypes2.default.number
  }).isRequired,
  serviceProvider: _propTypes2.default.shape({
    companyName: _propTypes2.default.string
  }).isRequired
};

exports.default = AssetCaseTable;

/***/ }),

/***/ "./compositions/OpenEventsWidget/AssetCaseTableWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  margin-left: ', ';\n  margin-top: ', ';\n'], ['\n  display: flex;\n  margin-left: ', ';\n  margin-top: ', ';\n']);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var AssetCaseTableWrapper = function () {
  var c = _styledComponents2.default.div(_templateObject, (0, _decisivUiUtils.px2rem)(-2), (0, _decisivUiUtils.px2rem)(12));

  c.displayName = 'AssetCaseTableWrapper';
  return c;
}();

exports.default = AssetCaseTableWrapper;

/***/ }),

/***/ "./compositions/OpenEventsWidget/Container.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _immutableToJS = __webpack_require__("./utils/immutableToJS.js");

var _immutableToJS2 = _interopRequireDefault(_immutableToJS);

var _actions = __webpack_require__("./redux/assets/actions.js");

var _selectors = __webpack_require__("./redux/assets/selectors.js");

var _selectors2 = __webpack_require__("./redux/cases/selectors.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var withConnectedData = function withConnectedData(WrappedComponent) {
  function Container(props) {
    return _react2.default.createElement(WrappedComponent, props);
  }

  Container.propTypes = {
    assetCases: _propTypes2.default.arrayOf(_propTypes2.default.string.isRequired),
    currentAssetCase: _propTypes2.default.shape({
      approvalStatus: _propTypes2.default.string,
      complaint: _propTypes2.default.shape({
        code: _propTypes2.default.string,
        description: _propTypes2.default.string
      }),
      description: _propTypes2.default.string,
      downtime: _propTypes2.default.string,
      estimateTotal: _propTypes2.default.string,
      followUpColor: _propTypes2.default.string,
      followUpTime: _propTypes2.default.string,
      repairStatus: _propTypes2.default.string,
      unreadNotesCount: _propTypes2.default.number
    }),
    currentAssetCaseServiceProvider: _propTypes2.default.shape({
      companyName: _propTypes2.default.string
    }),
    loadAssetCases: _propTypes2.default.func.isRequired
  };

  Container.defaultProps = {
    assetCases: [],
    currentAssetCase: {
      approvalStatus: '',
      repairStatus: '',
      unreadNotesCount: 0
    },
    currentAssetCaseServiceProvider: {}
  };

  function mapStateToProps(state) {
    return {
      currentAssetCase: (0, _selectors2.currentAssetCaseSelector)(state),
      currentAssetCaseServiceProvider: (0, _selectors2.currentAssetCaseServiceProviderSelector)(state),
      assetCases: (0, _selectors.currentAssetCasesSelector)(state)
    };
  }

  function mapDispatchToProps(dispatch) {
    return {
      loadAssetCases: function loadAssetCases(assetId) {
        return dispatch((0, _actions.loadAssetCases)({ assetId: assetId }));
      },
      setCurrentAssetCaseId: function setCurrentAssetCaseId(caseId) {
        return dispatch((0, _actions.setCurrentAssetCaseId)(caseId));
      }
    };
  }

  return (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _immutableToJS2.default)(Container));
};

exports.default = withConnectedData;

/***/ }),

/***/ "./compositions/OpenEventsWidget/FollowUpIcon.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  green: function green(_ref) {
    var theme = _ref.theme;
    return { styles: 'color: ' + theme.colors.status.success + ';' };
  },
  red: function red(_ref2) {
    var theme = _ref2.theme;
    return { styles: 'color: ' + theme.colors.status.danger + ';' };
  },
  yellow: function yellow(_ref3) {
    var theme = _ref3.theme;
    return { styles: 'color: ' + theme.colors.status.warning + ';' };
  }
};

/* istanbul ignore next */
var styles = '\n  font-size: ' + (0, _decisivUiUtils.px2rem)(16) + ';\n  margin-right: ' + (0, _decisivUiUtils.px2rem)(8) + ';\n';

var themePropTypes = {
  colors: _propTypes2.default.shape({
    status: _propTypes2.default.shape({
      danger: _propTypes2.default.string.isRequired,
      success: _propTypes2.default.string.isRequired,
      warning: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('FollowUpIcon', _styledComponents2.default.span, styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

/***/ }),

/***/ "./compositions/OpenEventsWidget/StatusSpanLeftPadded.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _StatusSpan = __webpack_require__("./elements/StatusSpan/index.js");

var _StatusSpan2 = _interopRequireDefault(_StatusSpan);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = '\n  margin-left: ' + (0, _decisivUiUtils.px2rem)(12) + ';\n';

exports.default = (0, _decisivUiUtils.buildStyledComponent)('StatusSpanLeftPadded', (0, _styledComponents2.default)(_StatusSpan2.default), styles);

/***/ }),

/***/ "./compositions/OpenEventsWidget/TabContentWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles() {
  return '\n  padding: ' + (0, _decisivUiUtils.px2rem)(18) + ' ' + (0, _decisivUiUtils.px2rem)(15) + ';\n';
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('TabContentWrapper', _styledComponents2.default.div, styles);

/***/ }),

/***/ "./compositions/OpenEventsWidget/UnreadNotesIcon.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  hasUnreadNotes: function hasUnreadNotes(_ref) {
    var theme = _ref.theme;
    return {
      styles: 'color: ' + theme.colors.status.info + ';'
    };
  }
};

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  color: ' + props.theme.colors.base.textLight + ';\n  font-size: ' + (0, _decisivUiUtils.px2rem)(16) + ';\n  margin-right: ' + (0, _decisivUiUtils.px2rem)(8) + ';\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      textLight: _propTypes2.default.string.isRequired
    }).isRequired,
    status: _propTypes2.default.shape({
      info: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('UnreadNotesIcon', _styledComponents2.default.span, styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

/***/ }),

/***/ "./compositions/OpenEventsWidget/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OpenEventsWidget = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _reactRouterDom = __webpack_require__("../node_modules/react-router-dom/es/index.js");

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _Widget = __webpack_require__("./elements/Widget/index.js");

var _Widget2 = _interopRequireDefault(_Widget);

var _Link = __webpack_require__("./elements/Link/index.js");

var _Link2 = _interopRequireDefault(_Link);

var _TabBar = __webpack_require__("./components/TabBar/index.js");

var _TabBar2 = _interopRequireDefault(_TabBar);

var _AssetCaseTable = __webpack_require__("./compositions/OpenEventsWidget/AssetCaseTable.js");

var _AssetCaseTable2 = _interopRequireDefault(_AssetCaseTable);

var _TabContentWrapper = __webpack_require__("./compositions/OpenEventsWidget/TabContentWrapper.js");

var _TabContentWrapper2 = _interopRequireDefault(_TabContentWrapper);

var _Container = __webpack_require__("./compositions/OpenEventsWidget/Container.js");

var _Container2 = _interopRequireDefault(_Container);

var _messages = __webpack_require__("./compositions/OpenEventsWidget/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OpenEventsWidget = exports.OpenEventsWidget = function (_Component) {
  _inherits(OpenEventsWidget, _Component);

  function OpenEventsWidget() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, OpenEventsWidget);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OpenEventsWidget.__proto__ || Object.getPrototypeOf(OpenEventsWidget)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      currentTab: '0',
      tabs: []
    }, _this.buildTabs = function (_ref2) {
      var assetCases = _ref2.assetCases;

      var tabs = assetCases.map(function (assetCase, index) {
        return {
          name: index.toString(),
          label: _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.caseTitle, values: { caseId: assetCase } })
        };
      });

      _this.setState({ tabs: tabs });
      _this.handleTabChange('0', { assetCases: assetCases }); // activates the first tab by default
    }, _this.handleTabChange = function (tabName) {
      var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.props,
          assetCases = _ref3.assetCases;

      var setCurrentAssetCaseId = _this.props.setCurrentAssetCaseId;

      _this.setState({
        currentTab: tabName
      });
      setCurrentAssetCaseId(assetCases[tabName]);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(OpenEventsWidget, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var assetId = this.props.match.params.assetId;

      this.props.loadAssetCases(assetId);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!(0, _lodash.isEqual)(nextProps.assetCases, this.props.assetCases)) {
        this.buildTabs(nextProps);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          currentAssetCase = _props.currentAssetCase,
          currentAssetCaseServiceProvider = _props.currentAssetCaseServiceProvider;
      var _state = this.state,
          currentTab = _state.currentTab,
          tabs = _state.tabs;

      var caseId = currentAssetCase.id;

      return !!tabs.length && _react2.default.createElement(
        _Widget2.default,
        { expandKey: 'open-events' },
        _react2.default.createElement(
          _Widget2.default.Header,
          null,
          _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.title }),
          _react2.default.createElement(
            'span',
            null,
            ' (',
            tabs.length,
            ')'
          )
        ),
        _react2.default.createElement(
          _Widget2.default.Item,
          null,
          _react2.default.createElement(_TabBar2.default, {
            currentTab: currentTab,
            onChangeTab: this.handleTabChange,
            tabs: tabs
          }),
          _react2.default.createElement(
            _TabContentWrapper2.default,
            null,
            _react2.default.createElement(
              _Link2.default,
              { to: '/cases/' + caseId, modifiers: ['bold', 'small', 'uppercase'] },
              _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.caseTitle, values: { caseId: caseId } })
            ),
            _react2.default.createElement(_AssetCaseTable2.default, {
              assetCase: currentAssetCase,
              serviceProvider: currentAssetCaseServiceProvider
            })
          )
        )
      );
    }
  }]);

  return OpenEventsWidget;
}(_react.Component);

OpenEventsWidget.propTypes = {
  assetCases: _propTypes2.default.arrayOf(_propTypes2.default.string.isRequired).isRequired,
  currentAssetCase: _propTypes2.default.shape({
    approvalStatus: _propTypes2.default.string,
    complaint: _propTypes2.default.shape({
      code: _propTypes2.default.string,
      description: _propTypes2.default.string
    }),
    description: _propTypes2.default.string,
    downtime: _propTypes2.default.string,
    estimateTotal: _propTypes2.default.string,
    followUpColor: _propTypes2.default.string,
    followUpTime: _propTypes2.default.string,
    repairStatus: _propTypes2.default.string,
    unreadNotesCount: _propTypes2.default.number
  }).isRequired,
  currentAssetCaseServiceProvider: _propTypes2.default.shape({
    companyName: _propTypes2.default.string
  }).isRequired,
  loadAssetCases: _propTypes2.default.func.isRequired,
  match: _propTypes2.default.shape({
    params: _propTypes2.default.shape({
      assetId: _propTypes2.default.string.isRequired
    })
  }).isRequired,
  setCurrentAssetCaseId: _propTypes2.default.func.isRequired
};
exports.default = (0, _Container2.default)((0, _reactRouterDom.withRouter)(OpenEventsWidget));

/***/ }),

/***/ "./compositions/OpenEventsWidget/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  caseTitle: (0, _linguiReact.i18nMark)('Case {caseId}'),
  complaint: (0, _linguiReact.i18nMark)('Complaint'),
  created: (0, _linguiReact.i18nMark)('Created'),
  estimate: (0, _linguiReact.i18nMark)('Estimate'),
  etr: (0, _linguiReact.i18nMark)('ETR'),
  followUp: (0, _linguiReact.i18nMark)('Follow-Up'),
  notes: (0, _linguiReact.i18nMark)('Notes'),
  serviceProvider: (0, _linguiReact.i18nMark)('Service Provider'),
  status: (0, _linguiReact.i18nMark)('Status'),
  title: (0, _linguiReact.i18nMark)('Open Events'),
  undefinedComplaint: (0, _linguiReact.i18nMark)('No complaints yet'),
  unreadNotesCount: (0, _linguiReact.i18nMark)('{count} Unread')
};

exports.default = messages;

/***/ }),

/***/ "./compositions/OptionsButton/Container.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("./utils/prop-types.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _recompose = __webpack_require__("../node_modules/recompose/es/Recompose.js");

var _immutableToJS = __webpack_require__("./utils/immutableToJS.js");

var _immutableToJS2 = _interopRequireDefault(_immutableToJS);

var _actions = __webpack_require__("./redux/ui/actions.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var withConnectedData = function withConnectedData(WrappedComponent) {
  function WithConnectedData(props) {
    return _react2.default.createElement(WrappedComponent, props);
  }

  WithConnectedData.propTypes = {
    handleActionBarItemClick: _propTypes2.default.func.isRequired
  };

  function mapDispatchToProps(dispatch) {
    return {
      handleActionBarItemClick: function handleActionBarItemClick(payload) {
        return dispatch((0, _actions.handleActionBarItemClick)(payload));
      }
    };
  }

  return (0, _recompose.compose)((0, _recompose.setDisplayName)('OptionsButtonContainer'), (0, _reactRedux.connect)(undefined, mapDispatchToProps), _immutableToJS2.default)(WithConnectedData);
};

exports.default = withConnectedData;

/***/ }),

/***/ "./compositions/OptionsButton/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.options = undefined;

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _oldIEVersion = __webpack_require__("./utils/oldIEVersion.js");

var _oldIEVersion2 = _interopRequireDefault(_oldIEVersion);

var _messages = __webpack_require__("./compositions/OptionsButton/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line import/prefer-default-export
var options = exports.options = (0, _lodash.compact)([{
  id: 'printPage',
  label: _messages2.default.printPage
}, !(0, _oldIEVersion2.default)() && {
  id: 'viewInFullScreenMode',
  label: _messages2.default.viewInFullScreenMode
}]);

/***/ }),

/***/ "./compositions/OptionsButton/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OptionsButton = OptionsButton;

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _recompose = __webpack_require__("../node_modules/recompose/es/Recompose.js");

var _QuickActionSelector = __webpack_require__("./components/QuickActionSelector/index.js");

var _QuickActionSelector2 = _interopRequireDefault(_QuickActionSelector);

var _Container = __webpack_require__("./compositions/OptionsButton/Container.js");

var _Container2 = _interopRequireDefault(_Container);

var _constants = __webpack_require__("./compositions/OptionsButton/constants.js");

var _messages = __webpack_require__("./compositions/OptionsButton/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function OptionsButton(_ref) {
  var handleActionBarItemClick = _ref.handleActionBarItemClick;

  return _react2.default.createElement(_QuickActionSelector2.default, {
    item: {
      id: 'OPTIONS_BUTTON',
      icon: 'caret-down',
      iconPressed: 'caret-up',
      label: _messages2.default.title,
      options: _constants.options
    },
    onClick: handleActionBarItemClick
  });
}

OptionsButton.propTypes = {
  handleActionBarItemClick: _propTypes2.default.func.isRequired
};

exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('OptionsButton'), _Container2.default)(OptionsButton);

/***/ }),

/***/ "./compositions/OptionsButton/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  title: (0, _linguiReact.i18nMark)('Options'),
  printPage: (0, _linguiReact.i18nMark)('Print Page'),
  viewInFullScreenMode: (0, _linguiReact.i18nMark)('View In Full-Screen Mode')
};

exports.default = messages;

/***/ }),

/***/ "./compositions/QRCodeWidget/Container.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _immutableToJS = __webpack_require__("./utils/immutableToJS.js");

var _immutableToJS2 = _interopRequireDefault(_immutableToJS);

var _selectors = __webpack_require__("./redux/assets/selectors.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var withConnectedData = function withConnectedData(WrappedComponent) {
  function Container(props) {
    return _react2.default.createElement(WrappedComponent, props);
  }

  Container.propTypes = {
    assetInfo: _propTypes2.default.shape()
  };

  Container.defaultProps = {
    assetInfo: {}
  };

  function mapStateToProps(state) {
    return {
      assetInfo: (0, _selectors.currentAssetSelector)(state)
    };
  }

  return (0, _reactRedux.connect)(mapStateToProps)((0, _immutableToJS2.default)(Container));
};

exports.default = withConnectedData;

/***/ }),

/***/ "./compositions/QRCodeWidget/QRCodeWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  padding: ', ' 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n'], ['\n  padding: ', ' 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n']);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var QRCodeWrapper = function () {
  var c = _styledComponents2.default.div(_templateObject, (0, _decisivUiUtils.px2rem)(20));

  c.displayName = 'QRCodeWrapper';
  return c;
}();

exports.default = QRCodeWrapper;

/***/ }),

/***/ "./compositions/QRCodeWidget/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QRCodeWidget = QRCodeWidget;

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _Widget = __webpack_require__("./elements/Widget/index.js");

var _Widget2 = _interopRequireDefault(_Widget);

var _Img = __webpack_require__("./elements/Img/index.js");

var _Img2 = _interopRequireDefault(_Img);

var _Container = __webpack_require__("./compositions/QRCodeWidget/Container.js");

var _Container2 = _interopRequireDefault(_Container);

var _QRCodeWrapper = __webpack_require__("./compositions/QRCodeWidget/QRCodeWrapper.js");

var _QRCodeWrapper2 = _interopRequireDefault(_QRCodeWrapper);

var _messages = __webpack_require__("./compositions/QRCodeWidget/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function QRCodeWidget(_ref) {
  var assetInfo = _ref.assetInfo;
  var qrCodeUrl = assetInfo.qrCodeUrl;


  return _react2.default.createElement(
    _Widget2.default,
    { expandKey: 'qr-code' },
    _react2.default.createElement(
      _Widget2.default.Header,
      null,
      _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.title })
    ),
    _react2.default.createElement(
      _Widget2.default.Item,
      null,
      _react2.default.createElement(
        _QRCodeWrapper2.default,
        null,
        qrCodeUrl && _react2.default.createElement(_Img2.default, { src: qrCodeUrl, alt: 'QRCode' })
      )
    )
  );
}

QRCodeWidget.propTypes = {
  assetInfo: _propTypes2.default.shape({
    qrCodeUrl: _propTypes2.default.string
  }).isRequired
};

exports.default = (0, _Container2.default)(QRCodeWidget);

/***/ }),

/***/ "./compositions/QRCodeWidget/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  title: (0, _linguiReact.i18nMark)('QR Code')
};

exports.default = messages;

/***/ }),

/***/ "./compositions/ReasonForRepairStep/ComplaintSelect.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var height = (0, _decisivUiUtils.px2rem)(25);

/* istanbul ignore next */
var styles = function styles(_ref) {
  var colors = _ref.theme.colors;
  return '\n  position: relative;\n  padding-left: 0;\n\n  .Select--multi {\n    &:focus {\n      outline: none;\n    }\n    .Select-control {\n      font-size: ' + (0, _decisivUiUtils.px2rem)(14) + ';\n      height: ' + height + ';\n      border: none;\n    }\n    .Select-multi-value-wrapper {\n    }\n    .Select-placeholder {\n      font-size: ' + (0, _decisivUiUtils.px2rem)(12) + ';\n      font-weight: 300;\n      line-height: ' + (0, _decisivUiUtils.px2rem)(23) + ';\n      padding-left: 0;\n      top: initial;\n      color: ' + colors.base.chrome300 + ';\n    }\n    .Select-input {\n      height: ' + height + ';\n      margin-left: 0;\n      input {\n        padding: ' + (0, _decisivUiUtils.px2rem)(5) + ' 0;\n      }\n    }\n    .Select-value {\n      border: 1px solid ' + colors.base.chrome300 + ';\n      background-color: ' + colors.base.chrome100 + ';\n      color: ' + colors.base.text + ';\n      height: ' + (0, _decisivUiUtils.px2rem)(18) + ';\n      margin-left: 0;\n      margin-top: ' + (0, _decisivUiUtils.px2rem)(4) + ';\n      pointer-events: none;\n\n      .Select-value-label {\n        font-size: ' + (0, _decisivUiUtils.px2rem)(10) + ';\n        padding-right: ' + (0, _decisivUiUtils.px2rem)(2) + ';\n        vertical-align: top;\n      }\n      .Select-value-icon {\n        border: none;\n        float: right;\n        font-size: ' + (0, _decisivUiUtils.px2rem)(20) + ';\n        height: ' + (0, _decisivUiUtils.px2rem)(15) + ';\n        line-height: ' + (0, _decisivUiUtils.px2rem)(15) + ';\n        color: ' + colors.base.chrome500 + ';\n        pointer-events: auto;\n      }\n\n      &:hover {\n        background-color: ' + colors.status.danger + ';\n        color: ' + colors.base.chrome000 + ';\n        cursor: pointer;\n        .Select-value-label {\n          text-decoration: underline;\n          cursor: inherit;\n        }\n        .Select-value-icon {\n          background-color: inherit;\n          color: ' + colors.base.chrome000 + ';\n        }\n      }\n    }\n    \n    .Select-option {\n      padding: ' + (0, _decisivUiUtils.px2rem)(4) + ';\n      font-size: ' + (0, _decisivUiUtils.px2rem)(12) + ';\n      color: ' + colors.base.text + ';\n\n      &:hover {\n        background-color: inherit;\n      }\n    }\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome000: _propTypes2.default.string.isRequired,
      chrome100: _propTypes2.default.string.isRequired,
      chrome300: _propTypes2.default.string.isRequired,
      chrome400: _propTypes2.default.string.isRequired,
      chrome500: _propTypes2.default.string.isRequired,
      text: _propTypes2.default.string.isRequired
    }).isRequired,
    status: _propTypes2.default.shape({
      danger: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('ComplaintSelect', _styledComponents2.default.div, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./compositions/ReasonForRepairStep/ComplaintSelectOption.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(_ref) {
  var colors = _ref.theme.colors;
  return '\n  border-radius: ' + (0, _decisivUiUtils.px2rem)(2) + ';\n  padding: ' + (0, _decisivUiUtils.px2rem)(2) + ' 0 ' + (0, _decisivUiUtils.px2rem)(1) + ' ' + (0, _decisivUiUtils.px2rem)(10) + ';\n  color: ' + colors.base.text + ';\n  font-size: ' + (0, _decisivUiUtils.px2rem)(12) + ';\n\n  &:hover {\n    background-color: ' + colors.status.info + ';\n    color: ' + colors.base.chrome000 + ';\n    text-decoration: underline;\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome000: _propTypes2.default.string.isRequired,
      text: _propTypes2.default.string.isRequired
    }).isRequired,
    status: _propTypes2.default.shape({
      info: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('ComplaintSelectOption', _styledComponents2.default.div, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./compositions/ReasonForRepairStep/Container.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _recompose = __webpack_require__("../node_modules/recompose/es/Recompose.js");

var _actions = __webpack_require__("./redux/dataLists/actions.js");

var _selectors = __webpack_require__("./redux/dataLists/selectors.js");

var _immutableToJS = __webpack_require__("./utils/immutableToJS.js");

var _immutableToJS2 = _interopRequireDefault(_immutableToJS);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var withConnectedData = function withConnectedData(WrappedComponent) {
  function Container(props) {
    return _react2.default.createElement(WrappedComponent, props);
  }

  Container.propTypes = {
    complaints: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      code: _propTypes2.default.string.isRequired,
      description: _propTypes2.default.string.isRequired
    })),
    loadDataLists: _propTypes2.default.func.isRequired
  };

  Container.defaultProps = {
    complaints: []
  };

  function mapStateToProps(state) {
    return {
      complaints: (0, _selectors.complaintsSelector)(state)
    };
  }

  function mapDispatchToProps(dispatch) {
    return {
      loadDataLists: function loadDataLists() {
        return dispatch((0, _actions.loadDataLists)());
      }
    };
  }

  return (0, _recompose.compose)((0, _recompose.setDisplayName)('ReasonForRepairStepContainer'), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _immutableToJS2.default)(Container);
};

exports.default = withConnectedData;

/***/ }),

/***/ "./compositions/ReasonForRepairStep/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReasonForRepairStep = exports.MAX_DESCRIPTION_LENGTH = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.makeSelectOptions = makeSelectOptions;
exports.setDefaultSelectValue = setDefaultSelectValue;

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/styled-components-reactive-grid/dist/index.js");

var _baseComponents = __webpack_require__("../node_modules/base-components/build/index.js");

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _WizardInput = __webpack_require__("./components/WizardInput/index.js");

var _WizardInput2 = _interopRequireDefault(_WizardInput);

var _WarningLabel = __webpack_require__("./components/WarningLabel/index.js");

var _WarningLabel2 = _interopRequireDefault(_WarningLabel);

var _Select = __webpack_require__("./elements/Select/index.js");

var _Select2 = _interopRequireDefault(_Select);

var _TextareaAutosize = __webpack_require__("./elements/TextareaAutosize/index.js");

var _TextareaAutosize2 = _interopRequireDefault(_TextareaAutosize);

var _ComplaintSelect = __webpack_require__("./compositions/ReasonForRepairStep/ComplaintSelect.js");

var _ComplaintSelect2 = _interopRequireDefault(_ComplaintSelect);

var _ComplaintSelectOption = __webpack_require__("./compositions/ReasonForRepairStep/ComplaintSelectOption.js");

var _ComplaintSelectOption2 = _interopRequireDefault(_ComplaintSelectOption);

var _Container = __webpack_require__("./compositions/ReasonForRepairStep/Container.js");

var _Container2 = _interopRequireDefault(_Container);

var _messages = __webpack_require__("./compositions/ReasonForRepairStep/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_DESCRIPTION_LENGTH = exports.MAX_DESCRIPTION_LENGTH = 6000;

function makeSelectOptions(complaints) {
  return complaints && complaints.map(function (complaint) {
    return {
      code: complaint.code,
      description: complaint.description,
      label: complaint.code + ' - ' + complaint.description
    };
  });
}

function setDefaultSelectValue(complaints, initialCode) {
  if ((0, _lodash.isEmpty)(initialCode)) {
    return null;
  }

  var foundComplaint = complaints.find(function (complaint) {
    return complaint.code === initialCode;
  });
  return {
    code: foundComplaint.code,
    description: foundComplaint.description,
    label: foundComplaint.code + ' - ' + foundComplaint.description
  };
}

var ReasonForRepairStep = exports.ReasonForRepairStep = function (_Component) {
  _inherits(ReasonForRepairStep, _Component);

  function ReasonForRepairStep() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ReasonForRepairStep);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReasonForRepairStep.__proto__ || Object.getPrototypeOf(ReasonForRepairStep)).call.apply(_ref, [this].concat(args))), _this), _this.state = function () {
      var _this$props = _this.props,
          complaints = _this$props.complaints,
          _this$props$initialRe = _this$props.initialReasonForRepair,
          complaintCode = _this$props$initialRe.complaintCode,
          description = _this$props$initialRe.description;


      return {
        charactersLeft: MAX_DESCRIPTION_LENGTH,
        charactersLeftVisible: false,
        description: description,
        selectedOption: setDefaultSelectValue(complaints, complaintCode),
        selectOptions: makeSelectOptions(_this.props.complaints)
      };
    }(), _this.getInputData = function () {
      var selectedOption = _this.state.selectedOption || {};
      var description = _this.state.description;
      if (selectedOption.code || description) {
        return {
          description: description,
          complaintCode: selectedOption.code || '',
          complaintDescription: selectedOption.description || ''
        };
      }

      return undefined;
    }, _this.syncInputData = function () {
      var reasonForRepair = _this.getInputData();
      if (reasonForRepair) {
        _this.props.syncInputData(reasonForRepair);
      }
    }, _this.submitInputData = function () {
      var reasonForRepair = _this.getInputData();
      if (reasonForRepair) {
        _this.props.submitInputData(reasonForRepair);
      }
    }, _this.handleSelectChange = function (options) {
      var selectedOption = options[options.length - 1];
      _this.setState({ selectedOption: selectedOption }, _this.syncInputData);
    }, _this.handleTextChange = function (event) {
      var value = event.target.value;


      var charactersLeft = MAX_DESCRIPTION_LENGTH - value.length;
      if (charactersLeft >= 0) {
        _this.setState({
          charactersLeft: charactersLeft,
          description: value
        }, _this.syncInputData);
      }

      clearTimeout(_this.charactersLeftTimer);
      _this.setState({ charactersLeftVisible: true });
      _this.charactersLeftTimer = (0, _lodash.delay)(function () {
        return _this.setState({ charactersLeftVisible: false });
      }, 1000);
    }, _this.renderSelectOption = function (option) {
      return _react2.default.createElement(
        _ComplaintSelectOption2.default,
        null,
        option.label
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ReasonForRepairStep, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.loadDataLists();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // it is fine to do it just the first time, because the list of complaints won't change often
      if (this.props.complaints.length === 0 && nextProps.complaints.length > 0) {
        this.setState({ selectOptions: makeSelectOptions(nextProps.complaints) });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          selectedOption = _state.selectedOption,
          selectOptions = _state.selectOptions,
          description = _state.description,
          charactersLeft = _state.charactersLeft,
          charactersLeftVisible = _state.charactersLeftVisible;


      var continueButtonDisabled = !selectedOption && !description;
      var noCharactersLeft = charactersLeft <= 0;

      return _react2.default.createElement(
        _styledComponentsReactiveGrid.Container,
        { style: { padding: (0, _decisivUiUtils.px2rem)(30) + ' 0' } },
        _react2.default.createElement(
          _styledComponentsReactiveGrid.Row,
          null,
          _react2.default.createElement(
            _styledComponentsReactiveGrid.Column,
            { modifiers: ['col_offset_3', 'col_6'] },
            _react2.default.createElement(
              _styledComponentsReactiveGrid.Row,
              null,
              _react2.default.createElement(
                _styledComponentsReactiveGrid.Column,
                { modifiers: ['col'] },
                _react2.default.createElement(
                  _baseComponents.H3,
                  { modifiers: ['fontWeightRegular'] },
                  _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.title })
                )
              )
            ),
            _react2.default.createElement(
              _styledComponentsReactiveGrid.Row,
              null,
              _react2.default.createElement(
                _styledComponentsReactiveGrid.Column,
                { modifiers: ['col'] },
                _react2.default.createElement(
                  _baseComponents.P,
                  null,
                  _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.subtitle })
                )
              )
            ),
            _react2.default.createElement(
              _styledComponentsReactiveGrid.Row,
              { style: { marginTop: '' + (0, _decisivUiUtils.px2rem)(30) } },
              _react2.default.createElement(
                _styledComponentsReactiveGrid.Column,
                { modifiers: ['col'] },
                _react2.default.createElement(
                  _WizardInput2.default,
                  { label: _messages2.default.complaintCode },
                  _react2.default.createElement(
                    _ComplaintSelect2.default,
                    null,
                    _react2.default.createElement(_Select2.default, {
                      autoBlur: true,
                      multi: true,
                      onChange: this.handleSelectChange,
                      optionRenderer: this.renderSelectOption,
                      options: selectOptions,
                      placeholder: 'Select Item...',
                      value: selectedOption
                    })
                  )
                ),
                _react2.default.createElement(
                  _WizardInput2.default,
                  {
                    label: _messages2.default.description,
                    rightLabel: _messages2.default.charactersLeft,
                    rightLabelValue: charactersLeft,
                    modifiers: (0, _lodash.compact)([noCharactersLeft && 'warning', charactersLeftVisible && 'rightLabelVisible', 'flexibleHeight', 'topOverlap'])
                  },
                  _react2.default.createElement(_TextareaAutosize2.default, {
                    placeholder: 'Enter Description...',
                    onChange: this.handleTextChange,
                    value: description
                  })
                )
              )
            ),
            noCharactersLeft && _react2.default.createElement(
              _styledComponentsReactiveGrid.Row,
              null,
              _react2.default.createElement(
                _styledComponentsReactiveGrid.Column,
                null,
                _react2.default.createElement(_WarningLabel2.default, { label: _messages2.default.characterCountWarning })
              )
            ),
            _react2.default.createElement(
              _styledComponentsReactiveGrid.Row,
              { style: { marginTop: '' + (0, _decisivUiUtils.px2rem)(30) } },
              _react2.default.createElement(
                _styledComponentsReactiveGrid.Column,
                null,
                _react2.default.createElement(
                  _baseComponents.QuickActionButton,
                  {
                    modifiers: (0, _lodash.compact)([continueButtonDisabled && 'disabled', 'secondary']),
                    onClick: this.submitInputData
                  },
                  _react2.default.createElement(
                    _baseComponents.QuickActionButton.Text,
                    null,
                    _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.continueButton })
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return ReasonForRepairStep;
}(_react.Component);

ReasonForRepairStep.propTypes = {
  complaints: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    code: _propTypes2.default.string.isRequired,
    description: _propTypes2.default.string.isRequired
  })).isRequired,
  loadDataLists: _propTypes2.default.func.isRequired,
  initialReasonForRepair: _propTypes2.default.shape({
    complaintCode: _propTypes2.default.string,
    complaintDescription: _propTypes2.default.string,
    description: _propTypes2.default.string
  }),
  submitInputData: _propTypes2.default.func.isRequired,
  syncInputData: _propTypes2.default.func.isRequired
};
ReasonForRepairStep.defaultProps = {
  initialReasonForRepair: {}
};
exports.default = (0, _Container2.default)(ReasonForRepairStep);

/***/ }),

/***/ "./compositions/ReasonForRepairStep/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var formattedMessages = {
  title: (0, _linguiReact.i18nMark)('What\'s the complaint?'),
  subtitle: (0, _linguiReact.i18nMark)('You can select a complaint code or enter a description. When possible, fill in both. That helps the service provider expedite your case.'),
  complaintCode: (0, _linguiReact.i18nMark)('Complaint Code'),
  description: (0, _linguiReact.i18nMark)('Description'),
  continueButton: (0, _linguiReact.i18nMark)('Continue'),
  charactersLeft: (0, _linguiReact.i18nMark)('{value} {value, plural, one {Character} other {Characters}} left'),
  characterCountWarning: (0, _linguiReact.i18nMark)('You reached the max character count.')
};

exports.default = formattedMessages;

/***/ }),

/***/ "./compositions/RequestServiceButton/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RequestServiceButton = RequestServiceButton;

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _qs = __webpack_require__("../node_modules/qs/lib/index.js");

var _qs2 = _interopRequireDefault(_qs);

var _baseComponents = __webpack_require__("../node_modules/base-components/build/index.js");

var _reactRouterDom = __webpack_require__("../node_modules/react-router-dom/es/index.js");

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _messages = __webpack_require__("./compositions/RequestServiceButton/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RequestServiceButton(_ref) {
  var assetId = _ref.match.params.assetId;

  var query = _qs2.default.stringify({ assetId: assetId }, { addQueryPrefix: true, skipNulls: true });
  return _react2.default.createElement(
    _reactRouterDom.Link,
    { to: '/service-requests/new' + query },
    _react2.default.createElement(
      _baseComponents.QuickActionButton,
      null,
      _react2.default.createElement(_baseComponents.QuickActionButton.Icon, { modifiers: ['left'], name: 'wrench' }),
      _react2.default.createElement(
        _baseComponents.QuickActionButton.Text,
        null,
        _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.title })
      )
    )
  );
}

RequestServiceButton.propTypes = {
  match: _propTypes2.default.shape({
    params: _propTypes2.default.shape({
      assetId: _propTypes2.default.string
    })
  }).isRequired
};

exports.default = (0, _reactRouterDom.withRouter)(RequestServiceButton);

/***/ }),

/***/ "./compositions/RequestServiceButton/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  title: (0, _linguiReact.i18nMark)('Request Service')
};

exports.default = messages;

/***/ }),

/***/ "./compositions/ServiceProviderSelectionStep/Container.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _recompose = __webpack_require__("../node_modules/recompose/es/Recompose.js");

var _actions = __webpack_require__("./redux/serviceProviders/actions.js");

var _selectors = __webpack_require__("./redux/serviceProviders/selectors.js");

var _immutableToJS = __webpack_require__("./utils/immutableToJS.js");

var _immutableToJS2 = _interopRequireDefault(_immutableToJS);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var withConnectedData = function withConnectedData(WrappedComponent) {
  function Container(props) {
    return _react2.default.createElement(WrappedComponent, props);
  }

  Container.propTypes = {
    serviceProviders: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      id: _propTypes2.default.string
    })).isRequired,
    loadServiceProviders: _propTypes2.default.func.isRequired
  };

  function mapStateToProps(state) {
    return {
      serviceProviders: (0, _selectors.serviceProvidersSelector)(state),
      serviceProvidersPending: (0, _selectors.loadServiceProvidersPendingSelector)(state)
    };
  }

  function mapDispatchToProps(dispatch) {
    return {
      loadServiceProviders: function loadServiceProviders(query) {
        return dispatch((0, _actions.loadServiceProviders)(query));
      },
      clearServiceProviders: function clearServiceProviders() {
        return dispatch((0, _actions.clearServiceProviders)());
      }
    };
  }

  return (0, _recompose.compose)((0, _recompose.setDisplayName)('ServiceProviderSelectionStepContainer'), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _immutableToJS2.default)(Container);
};

exports.default = withConnectedData;

/***/ }),

/***/ "./compositions/ServiceProviderSelectionStep/InputWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = '\n  display: flex;\n  flex-direction: column;\n';

exports.default = (0, _decisivUiUtils.buildStyledComponent)('InputWrapper', _styledComponents2.default.div, styles);

/***/ }),

/***/ "./compositions/ServiceProviderSelectionStep/ResultWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = '\n  display: flex;\n  flex: 1;\n  margin-top: ' + (0, _decisivUiUtils.px2rem)(20) + ';\n';

exports.default = (0, _decisivUiUtils.buildStyledComponent)('ResultWrapper', _styledComponents2.default.div, styles);

/***/ }),

/***/ "./compositions/ServiceProviderSelectionStep/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ServiceProviderSelectionStep = exports.handleGeocode = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

// Note we had to send `this` as a parameter due to when...
//   - Calling any method from a constructor,
//   - And you have an unrelated async fat arrow function in the class (that is not the method
//     being called in the constructor)
// ...the async fat arrow function looses `this`.
//
// This appears to be an issue with Babel that has been squashed a few times but
// continues to resurface.

var handleGeocode = exports.handleGeocode = function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(self) {
    var address, props, _ref3, location, count;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            address = self.state.searchValue;


            self.setState({ currentLocation: {} });
            _context.prev = 2;
            props = self.props;
            _context.next = 6;
            return props.geocode(address);

          case 6:
            _ref3 = _context.sent;
            location = _ref3.location;
            count = _ref3.count;


            if (!count) {
              self.setGeocodeError();
            } else if (count === 1) {
              findServiceProviders(props, location);
              self.setState({ currentLocation: location });
            } else {
              self.setGeocodeError();
            }
            _context.next = 15;
            break;

          case 12:
            _context.prev = 12;
            _context.t0 = _context['catch'](2);

            self.setGeocodeError();

          case 15:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[2, 12]]);
  }));

  return function handleGeocode(_x) {
    return _ref2.apply(this, arguments);
  };
}();

/**
 * Given input data from a previous pass through this step, extract the `currentLocation`
 * object containing the lat/lon values.
 * @param inputData
 * @returns {*}
 */


exports.getCurrentLocation = getCurrentLocation;
exports.getSearchValue = getSearchValue;

var _baseComponents = __webpack_require__("../node_modules/base-components/build/index.js");

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _recompose = __webpack_require__("../node_modules/recompose/es/Recompose.js");

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/styled-components-reactive-grid/dist/index.js");

var _withGeocoder = __webpack_require__("./utils/mapping/withGeocoder.js");

var _withGeocoder2 = _interopRequireDefault(_withGeocoder);

var _ServiceProvidersList = __webpack_require__("./components/ServiceProvidersList/index.js");

var _ServiceProvidersList2 = _interopRequireDefault(_ServiceProvidersList);

var _ServiceRequestMap = __webpack_require__("./components/ServiceRequestMap/index.js");

var _ServiceRequestMap2 = _interopRequireDefault(_ServiceRequestMap);

var _WizardSearchError = __webpack_require__("./components/WizardSearchError/index.js");

var _WizardSearchError2 = _interopRequireDefault(_WizardSearchError);

var _InputWrapper = __webpack_require__("./compositions/ServiceProviderSelectionStep/InputWrapper.js");

var _InputWrapper2 = _interopRequireDefault(_InputWrapper);

var _ResultWrapper = __webpack_require__("./compositions/ServiceProviderSelectionStep/ResultWrapper.js");

var _ResultWrapper2 = _interopRequireDefault(_ResultWrapper);

var _Container = __webpack_require__("./compositions/ServiceProviderSelectionStep/Container.js");

var _Container2 = _interopRequireDefault(_Container);

var _messages = __webpack_require__("./compositions/ServiceProviderSelectionStep/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function locationToString(_ref) {
  var lat = _ref.lat,
      lon = _ref.lon;

  return lat && lon ? lat + ', ' + lon : '';
}

var DEFAULT_SEARCH_RADIUS = 50;

function findServiceProviders(props, location) {
  var origin = locationToString(location);
  if (origin) {
    props.clearServiceProviders();
    props.loadServiceProviders({
      origin: origin,
      radius: DEFAULT_SEARCH_RADIUS
    });
  }
}function getCurrentLocation(_ref4) {
  var _ref4$inputData = _ref4.inputData;
  _ref4$inputData = _ref4$inputData === undefined ? {} : _ref4$inputData;
  var prevLocation = _ref4$inputData.assetCurrentLocation,
      asset = _ref4$inputData.asset;

  if (prevLocation) {
    return prevLocation;
  }

  var assetEmbeddedLocation = asset && asset.location;

  return assetEmbeddedLocation || {};
}

function getSearchValue(_ref5) {
  var inputData = _ref5.inputData;

  if (inputData && inputData.assetLocationSearchValue) {
    return inputData.assetLocationSearchValue;
  }
  return locationToString(getCurrentLocation({ inputData: inputData }));
}

/**
 * The ServiceProviderSelectionStep has an input for specifying the location of the
 * asset (or some other location to use as the center for the provider search). This
 * input is stored in state as `searchValue`.
 *
 * In response to a change to this input value, a geocode is performed, and the resulting
 * location (an object with lat/lon) is stored in state as `currentLocation`.  Also, the
 * resulting location from the geocode is turned into a query for the `loadServiceProviders`
 * API call, which is received as a prop.
 *
 * The resulting provider list from `loadServiceProviders` is received as a `serviceProviders`
 * prop, and passed down to the `ServiceProvidersList` component.
 */

var ServiceProviderSelectionStep = exports.ServiceProviderSelectionStep = function (_Component) {
  _inherits(ServiceProviderSelectionStep, _Component);

  function ServiceProviderSelectionStep() {
    var _ref6;

    var _temp, _this, _ret;

    _classCallCheck(this, ServiceProviderSelectionStep);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref6 = ServiceProviderSelectionStep.__proto__ || Object.getPrototypeOf(ServiceProviderSelectionStep)).call.apply(_ref6, [this].concat(args))), _this), _this.state = {
      currentLocation: getCurrentLocation(_this.props),
      searchValue: getSearchValue(_this.props),
      searchErrorSubTitle: _messages2.default.suggestion,
      isSearching: false
    }, _this.setGeocodeError = function () {
      _this.props.clearServiceProviders();
      var searchErrorSubTitle = _this.state.searchValue === '' ? _messages2.default.suggestion : _messages2.default.noAssetLocationSubtitle;
      _this.setState({
        searchErrorSubTitle: searchErrorSubTitle,
        currentLocation: {},
        isSearching: false
      });
    }, _this.handleAssetLocationInputChange = function (e) {
      _this.setState({ searchValue: e.target.value });
      if (!_this.state.isSearching) {
        _this.setState({ isSearching: true });
      }
      _this.debounceGeoCode();
    }, _this.debounceGeoCode = (0, _lodash.debounce)(function () {
      return handleGeocode(_this);
    }, 1000), _this.submitInputData = function (selectedServiceProvider) {
      var stepData = {
        assetCurrentLocation: _this.state.currentLocation,
        assetLocationSearchValue: _this.state.searchValue,
        serviceProvider: selectedServiceProvider
      };
      _this.props.completeStep(stepData);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ServiceProviderSelectionStep, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var currentLocation = this.state.currentLocation;

      if (currentLocation) {
        findServiceProviders(this.props, currentLocation);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _state = this.state,
          currentLocation = _state.currentLocation,
          searchValue = _state.searchValue;
      var serviceProviders = nextProps.serviceProviders,
          serviceProvidersPending = nextProps.serviceProvidersPending;

      if (currentLocation && (0, _lodash.isEmpty)(serviceProviders) && !serviceProvidersPending) {
        var searchErrorSubTitle = searchValue === '' ? _messages2.default.suggestion : _messages2.default.noAssetLocationSubtitle;
        this.setState({
          searchErrorSubTitle: searchErrorSubTitle,
          isSearching: false
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _state2 = this.state,
          searchErrorSubTitle = _state2.searchErrorSubTitle,
          searchValue = _state2.searchValue,
          isSearching = _state2.isSearching,
          currentLocation = _state2.currentLocation;
      var _props = this.props,
          serviceProviders = _props.serviceProviders,
          serviceProvider = _props.inputData.serviceProvider,
          i18n = _props.i18n;

      return _react2.default.createElement(
        _styledComponentsReactiveGrid.Container,
        { style: { padding: (0, _decisivUiUtils.px2rem)(30) + ' 0' } },
        _react2.default.createElement(
          _styledComponentsReactiveGrid.Row,
          null,
          _react2.default.createElement(
            _styledComponentsReactiveGrid.Column,
            { modifiers: ['col_offset_3', 'col_6'] },
            _react2.default.createElement(
              _baseComponents.H3,
              { modifiers: ['fontWeightRegular'] },
              _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.title })
            )
          )
        ),
        _react2.default.createElement(
          _styledComponentsReactiveGrid.Row,
          { style: { marginTop: '' + (0, _decisivUiUtils.px2rem)(30) } },
          _react2.default.createElement(
            _styledComponentsReactiveGrid.Column,
            { modifiers: ['col_offset_1', 'col_10'] },
            _react2.default.createElement(
              _styledComponentsReactiveGrid.Row,
              null,
              _react2.default.createElement(
                _styledComponentsReactiveGrid.Column,
                { modifiers: ['col'] },
                _react2.default.createElement(_ServiceRequestMap2.default, {
                  serviceProviders: serviceProviders,
                  currentLocation: currentLocation
                })
              ),
              _react2.default.createElement(
                _styledComponentsReactiveGrid.Column,
                {
                  modifiers: ['col'],
                  style: { height: '' + (0, _decisivUiUtils.px2rem)(400), marginLeft: '' + (0, _decisivUiUtils.px2rem)(20) }
                },
                _react2.default.createElement(
                  _InputWrapper2.default,
                  null,
                  _react2.default.createElement(
                    _baseComponents.InputField,
                    {
                      name: 'search',
                      onChange: this.handleAssetLocationInputChange,
                      onBlur: this.handleAssetLocationInputChange,
                      placeholder: i18n._(_messages2.default.placeholder),
                      value: searchValue
                    },
                    _react2.default.createElement(
                      _styledComponentsReactiveGrid.Column,
                      { modifiers: ['col', 'padScaleY_0'] },
                      _react2.default.createElement(
                        _styledComponentsReactiveGrid.Row,
                        null,
                        _react2.default.createElement(
                          _baseComponents.InputField.Label,
                          null,
                          _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.assetLocation })
                        )
                      ),
                      _react2.default.createElement(
                        _styledComponentsReactiveGrid.Row,
                        null,
                        _react2.default.createElement(_baseComponents.InputField.TextField, null)
                      )
                    )
                  ),
                  _react2.default.createElement(
                    _ResultWrapper2.default,
                    null,
                    serviceProviders.length > 0 && _react2.default.createElement(_ServiceProvidersList2.default, {
                      onSelect: this.submitInputData,
                      selectedServiceProvider: serviceProvider,
                      serviceProviders: serviceProviders
                    }),
                    !isSearching && serviceProviders.length === 0 && _react2.default.createElement(_WizardSearchError2.default, {
                      searchValue: searchValue,
                      titlePrefix: _messages2.default.noAssetLocationTitlePrefix,
                      titleSuffix: _messages2.default.titleSuffix,
                      subtitle: searchErrorSubTitle
                    })
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return ServiceProviderSelectionStep;
}(_react.Component);

ServiceProviderSelectionStep.propTypes = {
  // provided by the wizard controller to pass up this step's data:
  completeStep: _propTypes2.default.func.isRequired,

  // previously-collected input data from the wizard controller:
  inputData: _propTypes2.default.shape({
    asset: _propTypes2.default.shape({
      location: _propTypes2.default.shape({
        lat: _propTypes2.default.string,
        lon: _propTypes2.default.string
      })
    }),
    serviceProvider: _propTypes2.default.shape({
      id: _propTypes2.default.string
    })
  }),

  // API action to look up service providers:
  // eslint-disable-next-line react/no-unused-prop-types
  loadServiceProviders: _propTypes2.default.func.isRequired,

  // service providers from the API lookup:
  serviceProviders: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    id: _propTypes2.default.string
  })).isRequired,

  // true when the service provider API lookup is in flight:
  serviceProvidersPending: _propTypes2.default.bool.isRequired,

  // clear any service providers from a previous API lookup:
  clearServiceProviders: _propTypes2.default.func.isRequired,

  // async geocoding function provided by withGeocoder:
  // eslint-disable-next-line react/no-unused-prop-types
  geocode: _propTypes2.default.func.isRequired,

  i18n: _propTypes2.default.shape({
    _: _propTypes2.default.func.isRequired
  }).isRequired
};
ServiceProviderSelectionStep.defaultProps = {
  inputData: {}
};
exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('ServiceProviderSelectionStep'), _withGeocoder2.default, _Container2.default, (0, _linguiReact.withI18n)())(ServiceProviderSelectionStep);

/***/ }),

/***/ "./compositions/ServiceProviderSelectionStep/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  assetLocation: (0, _linguiReact.i18nMark)('Asset Location'),
  noAssetLocationSubtitle: (0, _linguiReact.i18nMark)('Try removing or editing some of your criteria to expand the search or search by city and state or zip code.'),
  noAssetLocationTitlePrefix: (0, _linguiReact.i18nMark)('No matches for "'),
  noServiceProviderSubtitle: (0, _linguiReact.i18nMark)('Try removing or editing some of the filters to expand your search, or search by a different location.'),
  noServiceProviderTitlePrefix: (0, _linguiReact.i18nMark)('No results for "'),
  placeholder: (0, _linguiReact.i18nMark)('Enter a city and state or zip code...'),
  suggestion: (0, _linguiReact.i18nMark)('Search by asset location to see nearby providers or service provider for nearby locations.'),
  title: (0, _linguiReact.i18nMark)('Which service provider do you want?'),
  titleSuffix: (0, _linguiReact.i18nMark)('".')
};

exports.default = messages;

/***/ }),

/***/ "./compositions/ServiceProviderWidget/CaseServiceProviderContainer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _selectors = __webpack_require__("./redux/cases/selectors.js");

var _immutableToJS = __webpack_require__("./utils/immutableToJS.js");

var _immutableToJS2 = _interopRequireDefault(_immutableToJS);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var withConnectedData = function withConnectedData(WrappedComponent) {
  function Container(props) {
    return _react2.default.createElement(WrappedComponent, props);
  }

  Container.propTypes = {
    serviceProviderInfo: _propTypes2.default.shape({
      id: _propTypes2.default.string
    })
  };

  Container.defaultProps = {
    serviceProviderInfo: {}
  };

  function mapStateToProps(state) {
    return {
      serviceProviderInfo: (0, _selectors.currentCaseServiceProviderSelector)(state)
    };
  }

  return (0, _reactRedux.connect)(mapStateToProps)((0, _immutableToJS2.default)(Container));
};

exports.default = withConnectedData;

/***/ }),

/***/ "./compositions/ServiceProviderWidget/OperatingHoursTable.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizeTimeString = normalizeTimeString;
exports.renderDayRange = renderDayRange;
exports.renderTimes = renderTimes;
exports.OperatingHoursTable = OperatingHoursTable;

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _momentTimezone = __webpack_require__("../node_modules/moment-timezone/index.js");

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _recompose = __webpack_require__("../node_modules/recompose/es/Recompose.js");

var _Widget = __webpack_require__("./elements/Widget/index.js");

var _Widget2 = _interopRequireDefault(_Widget);

var _Popover = __webpack_require__("./elements/Popover/index.js");

var _Popover2 = _interopRequireDefault(_Popover);

var _timeUtils = __webpack_require__("./utils/timeUtils.js");

var _PopoverContentWrapper = __webpack_require__("./compositions/ServiceProviderWidget/PopoverContentWrapper.js");

var _PopoverContentWrapper2 = _interopRequireDefault(_PopoverContentWrapper);

var _TimezoneWrapper = __webpack_require__("./compositions/ServiceProviderWidget/TimezoneWrapper.js");

var _TimezoneWrapper2 = _interopRequireDefault(_TimezoneWrapper);

var _messages = __webpack_require__("./compositions/ServiceProviderWidget/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Clean up any random extra whitespace in the given time string (expected to
 * be roughly in a format like " 5:00AM") for the service provider operating
 * hours.
 */
function normalizeTimeString(str) {
  return str.replace(/\s/g, '') // remove all whitespace
  .replace('AM', ' AM').replace('PM', ' PM');
}

/**
 * Determine if the service provider (which is located in the given `timeZone`) is
 * currently open, based on the open/close hours of a given day of the week.
 */
function evalOpenStatus(targetDay, openingTime, closingTime, timeZone) {
  var timeNowAtProvider = (0, _timeUtils.getCurrentTime)(timeZone);
  var targetDayAtProvider = (0, _momentTimezone2.default)(timeNowAtProvider).day(targetDay);

  var dayNameAtProvider = targetDayAtProvider.format('dddd');

  // fail fast if `targetDay` is not the current day of the week at the provider
  if (dayNameAtProvider !== targetDay) return false;

  // create time objects for opening/closing times of the target day in the provider's time-zone:
  var ymd = targetDayAtProvider.format('YYYY-MM-DD');
  var parseFormat = 'YYYY-MM-DD h:mm A';
  var targetDayOpenAt = _momentTimezone2.default.tz(ymd + ' ' + openingTime, parseFormat, timeZone);
  var targetDayCloseAt = _momentTimezone2.default.tz(ymd + ' ' + closingTime, parseFormat, timeZone);

  // If targetDayOpenAt and targetDayCloseAt are same,
  // it is supposed that targetDayCloseAt is one day more.
  if (targetDayOpenAt.isSame(targetDayCloseAt)) targetDayCloseAt.add(1, 'day');
  // determine if the service provider is open right now, due to the current time
  // in the provider's time-zone falling between the open and close times for
  // the day of the week we're currently processing:
  return timeNowAtProvider.isBetween(targetDayOpenAt, targetDayCloseAt);
}

/**
 * This function serves two purposes:
 *   1. Process the incoming array of service provider operating hours to collapse multiple
 *      days having the same open/close hours into single entries.
 *   2. Determine if the service provider is currently open, based on the specified days
 *      and opening/closing hours.
 * It returns an object with two properties:
 *    * `hours`: the list of processed day-ranges with open/close hours
 *    * `isOpen`: a boolean indicating whether the provider is *currently* open
 */
function processOperatingHours(operatingHours, timeZone) {
  // incoming operatingHours will look something like this:
  // [  {:day=>"Monday", :open=>" 5:00AM", :close=>" 5:00PM"},
  //    {:day=>"Tuesday", :open=>" 5:00AM", :close=>" 5:00PM"},
  //    {:day=>"Wednesday", :open=>" 5:00AM", :close=>" 5:00PM"},
  //    {:day=>"Thursday", :open=>" 5:00AM", :close=>" 5:00PM"},
  //    {:day=>"Friday", :open=>" 5:00AM", :close=>" 5:00PM"},
  //    {:day=>"Saturday", :open=>" 5:00AM", :close=>" 3:00PM"},
  //    {:day=>"Sunday", :open=>" 5:00AM", :close=>" 3:00PM"} ]
  //
  // output should be...
  // [  { start: 'Monday', end: 'Friday', open: '5 AM', close: '5 PM' },
  //    { start: 'Saturday', end: 'Sunday', open: '5 AM', close: '3 PM' } ]

  var isOpen = false;

  var processedHours = operatingHours.reduce(function (processed, dayInfo) {
    // get the last processed day, and all the other processed days before that one:
    var lastDay = processed.length ? (0, _lodash.last)(processed) : { start: '', end: '', open: '', close: '' };
    var otherDays = (0, _lodash.initial)(processed);

    // this will be the full English name of the day of the week we're processing now:
    var targetDay = dayInfo.day;

    // clean up the open/close times:
    var open = normalizeTimeString(dayInfo.open);
    var close = normalizeTimeString(dayInfo.close);

    // if we haven't already found that the provider is open on a previous
    // day, check whether they're open on this day:
    isOpen = isOpen || evalOpenStatus(targetDay, open, close, timeZone);

    // compare this day's open/close with the last day's open/close:
    if (open === lastDay.open && close === lastDay.close) {
      // same open/close hours so merge this day into the last day
      return [].concat(_toConsumableArray(otherDays), [{
        start: lastDay.start || targetDay,
        end: targetDay,
        open: open,
        close: close
      }]);
    }
    // create a new day since this one has different hours from the last one
    return [].concat(_toConsumableArray(processed), [{
      start: targetDay,
      end: targetDay,
      open: open,
      close: close
    }]);
  }, []);

  return { hours: processedHours, isOpen: isOpen };
}

/**
 * Takes an English-language day of the week (e.g. "Monday") and
 * translates it into the current language's abbreviated representation
 * of that day of the week (e.g. "Mon" for English, "Lu" or "Lun" for
 * Spanish).
 */
function translateDay(englishDayName, i18n) {
  return i18n._(_messages2.default[englishDayName.toLowerCase()]);
}

/**
 * Render a day or a range of days in the current locale.
 */
function renderDayRange(_ref, i18n) {
  var start = _ref.start,
      end = _ref.end;

  return start === end ? translateDay(start, i18n) : translateDay(start, i18n) + ' - ' + translateDay(end, i18n);
}

/**
 * Remove :00 from the hours (but leave meaningful minutes) and render the
 * `open` and `close` values with a dash between.
 */
function renderTimes(_ref2) {
  var open = _ref2.open,
      close = _ref2.close;

  var openString = open.replace(':00', '');
  var closeString = close.replace(':00', '');
  return openString + ' - ' + closeString;
}

/**
 * Iterate through the given daily hours specification and render one row for
 * each day or range of days.
 */
function renderDailyOpeningHours(hours, i18n, shortTimezone) {
  return _react2.default.createElement(
    _PopoverContentWrapper2.default,
    null,
    _react2.default.createElement(
      'table',
      null,
      _react2.default.createElement(
        'tbody',
        null,
        _react2.default.createElement(
          'tr',
          null,
          _react2.default.createElement(
            'td',
            null,
            _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.hours })
          ),
          _react2.default.createElement(
            'td',
            null,
            _react2.default.createElement(
              _TimezoneWrapper2.default,
              null,
              '(',
              shortTimezone,
              ')'
            )
          )
        ),
        hours.map(function (day, index) {
          return _react2.default.createElement(
            _Widget2.default.TableRow,
            { key: day.start, modifiers: (0, _lodash.compact)([index && 'topGap']) },
            _react2.default.createElement(
              'th',
              null,
              renderDayRange(day, i18n)
            ),
            _react2.default.createElement(
              'td',
              null,
              renderTimes(day)
            )
          );
        })
      )
    )
  );
}

function OperatingHoursTable(_ref3) {
  var operatingHours = _ref3.operatingHours,
      timeZone = _ref3.timeZone,
      i18n = _ref3.i18n;

  var _processOperatingHour = processOperatingHours(operatingHours, timeZone),
      hours = _processOperatingHour.hours,
      isOpen = _processOperatingHour.isOpen;

  var colorModifier = isOpen ? 'statusSuccess' : 'statusDanger';
  var target = _react2.default.createElement(
    _Widget2.default.SubHeader,
    { modifiers: ['small', colorModifier] },
    _react2.default.createElement(_linguiReact.Trans, { id: isOpen ? _messages2.default.open : _messages2.default.closed })
  );
  var shortTimezone = (0, _momentTimezone2.default)().tz(timeZone).format('z');
  var popOverContent = renderDailyOpeningHours(hours, i18n, shortTimezone);
  return _react2.default.createElement(
    'table',
    null,
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            _Popover2.default,
            {
              showOnHover: true
            },
            _react2.default.createElement(
              _Popover.PopoverTarget,
              null,
              target
            ),
            _react2.default.createElement(
              _Popover.PopoverContent,
              null,
              popOverContent
            )
          )
        )
      )
    )
  );
}

OperatingHoursTable.propTypes = {
  operatingHours: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    day: _propTypes2.default.string,
    open: _propTypes2.default.string,
    close: _propTypes2.default.string
  })),
  timeZone: _propTypes2.default.string,
  i18n: _propTypes2.default.shape({
    _: _propTypes2.default.func.isRequired
  }).isRequired
};

OperatingHoursTable.defaultProps = {
  operatingHours: [],
  timeZone: ''
};

exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('OperatingHoursTable'), (0, _linguiReact.withI18n)())(OperatingHoursTable);

/***/ }),

/***/ "./compositions/ServiceProviderWidget/PopoverContentWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n  white-space: nowrap;\n  padding: ', ';\n'], ['\n  position: relative;\n  white-space: nowrap;\n  padding: ', ';\n']);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var PopoverContentWrapper = function () {
  var c = _styledComponents2.default.div(_templateObject, (0, _decisivUiUtils.px2rem)(10));

  c.displayName = 'PopoverContentWrapper';
  return c;
}();

exports.default = PopoverContentWrapper;

/***/ }),

/***/ "./compositions/ServiceProviderWidget/ServiceRequestContainer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _selectors = __webpack_require__("./redux/serviceRequests/selectors.js");

var _immutableToJS = __webpack_require__("./utils/immutableToJS.js");

var _immutableToJS2 = _interopRequireDefault(_immutableToJS);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var withConnectedData = function withConnectedData(WrappedComponent) {
  function Container(props) {
    return _react2.default.createElement(WrappedComponent, props);
  }

  Container.propTypes = {
    serviceProviderInfo: _propTypes2.default.shape({
      id: _propTypes2.default.string
    })
  };

  Container.defaultProps = {
    serviceProviderInfo: {}
  };

  function mapStateToProps(state) {
    return {
      serviceProviderInfo: (0, _selectors.currentServReqServProvSelector)(state)
    };
  }

  return (0, _reactRedux.connect)(mapStateToProps)((0, _immutableToJS2.default)(Container));
};

exports.default = withConnectedData;

/***/ }),

/***/ "./compositions/ServiceProviderWidget/TimezoneWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  color: ' + props.theme.colors.brand.tertiary + ';\n  font-size: ' + (0, _decisivUiUtils.px2rem)(10) + ';\n  line-height: ' + (0, _decisivUiUtils.px2rem)(15) + ';\n  text-align: right;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    brand: _propTypes2.default.shape({
      tertiary: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('TimezoneWrapper', _styledComponents2.default.div, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./compositions/ServiceProviderWidget/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ServiceRequestServiceProviderWidget = exports.CaseServiceProviderWidget = undefined;
exports.getAddressHtml = getAddressHtml;
exports.ServiceProviderWidget = ServiceProviderWidget;

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _timeUtils = __webpack_require__("./utils/timeUtils.js");

var _Widget = __webpack_require__("./elements/Widget/index.js");

var _Widget2 = _interopRequireDefault(_Widget);

var _EmptyValue = __webpack_require__("./elements/EmptyValue/index.js");

var _EmptyValue2 = _interopRequireDefault(_EmptyValue);

var _postalAddressFormatter = __webpack_require__("./utils/postalAddressFormatter.js");

var _postalAddressFormatter2 = _interopRequireDefault(_postalAddressFormatter);

var _CaseServiceProviderContainer = __webpack_require__("./compositions/ServiceProviderWidget/CaseServiceProviderContainer.js");

var _CaseServiceProviderContainer2 = _interopRequireDefault(_CaseServiceProviderContainer);

var _ServiceRequestContainer = __webpack_require__("./compositions/ServiceProviderWidget/ServiceRequestContainer.js");

var _ServiceRequestContainer2 = _interopRequireDefault(_ServiceRequestContainer);

var _OperatingHoursTable = __webpack_require__("./compositions/ServiceProviderWidget/OperatingHoursTable.js");

var _OperatingHoursTable2 = _interopRequireDefault(_OperatingHoursTable);

var _messages = __webpack_require__("./compositions/ServiceProviderWidget/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getAddressHtml(addressMap) {
  var addressLines = addressMap ? (0, _postalAddressFormatter2.default)(addressMap) : [];
  return addressLines.map(function (line) {
    return _react2.default.createElement(
      'div',
      { key: line },
      line
    );
  });
}

function ServiceProviderWidget(_ref) {
  var serviceProviderInfo = _ref.serviceProviderInfo;

  var serviceProviderTimeZone = (0, _timeUtils.convertRailsTz)(serviceProviderInfo.timezone);
  var operatingHours = serviceProviderInfo.operatingHours;
  var operatingHoursProvided = operatingHours && operatingHours.length;

  var addressHtml = getAddressHtml(serviceProviderInfo.address);
  return _react2.default.createElement(
    _Widget2.default,
    { expandKey: 'service-provider' },
    _react2.default.createElement(
      _Widget2.default.Header,
      null,
      _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.title })
    ),
    _react2.default.createElement(
      _Widget2.default.Item,
      null,
      _react2.default.createElement(
        _Widget2.default.SubHeader,
        null,
        serviceProviderInfo.companyName
      )
    ),
    _react2.default.createElement(
      _Widget2.default.Item,
      null,
      _react2.default.createElement(
        _Widget2.default.Table,
        null,
        _react2.default.createElement(
          'tbody',
          null,
          _react2.default.createElement(
            _Widget2.default.TableRow,
            null,
            _react2.default.createElement(
              'th',
              null,
              _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.address })
            ),
            _react2.default.createElement(
              'td',
              null,
              addressHtml
            )
          ),
          _react2.default.createElement(
            _Widget2.default.TableRow,
            { modifiers: ['topGap'] },
            _react2.default.createElement(
              'th',
              null,
              _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.phone })
            ),
            _react2.default.createElement(
              'td',
              null,
              serviceProviderInfo.phone,
              _react2.default.createElement('br', null),
              serviceProviderInfo.fax
            )
          ),
          _react2.default.createElement(
            _Widget2.default.TableRow,
            { modifiers: ['topGap'] },
            _react2.default.createElement(
              'th',
              null,
              _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.hours })
            ),
            _react2.default.createElement(
              'td',
              null,
              operatingHoursProvided ? _react2.default.createElement(_OperatingHoursTable2.default, {
                operatingHours: operatingHours,
                timeZone: serviceProviderTimeZone
              }) : _react2.default.createElement(
                _EmptyValue2.default,
                null,
                _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.noHoursAvailable })
              )
            )
          )
        )
      )
    )
  );
}

ServiceProviderWidget.propTypes = {
  serviceProviderInfo: _propTypes2.default.shape({
    address: _propTypes2.default.shape({
      street: _propTypes2.default.string,
      street2: _propTypes2.default.string,
      city: _propTypes2.default.string,
      region: _propTypes2.default.string,
      postalCode: _propTypes2.default.string
    }),
    phone: _propTypes2.default.string,
    fax: _propTypes2.default.string,
    operatingHours: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      day: _propTypes2.default.string,
      open: _propTypes2.default.string,
      close: _propTypes2.default.string
    }))
  })
};

ServiceProviderWidget.defaultProps = {
  serviceProviderInfo: {
    address: {
      street: '',
      street2: '',
      city: '',
      region: '',
      postalCode: ''
    },
    phone: '',
    fax: '',
    operatingHours: []
  }
};

var CaseServiceProviderWidget = exports.CaseServiceProviderWidget = (0, _CaseServiceProviderContainer2.default)(ServiceProviderWidget);
var ServiceRequestServiceProviderWidget = exports.ServiceRequestServiceProviderWidget = (0, _ServiceRequestContainer2.default)(ServiceProviderWidget);

/***/ }),

/***/ "./compositions/ServiceProviderWidget/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  address: (0, _linguiReact.i18nMark)('Address'),
  closed: (0, _linguiReact.i18nMark)('Closed'),
  friday: (0, _linguiReact.i18nMark)('Fri'),
  hours: (0, _linguiReact.i18nMark)('Hours'),
  monday: (0, _linguiReact.i18nMark)('Mon'),
  noHoursAvailable: (0, _linguiReact.i18nMark)('Not Provided'),
  open: (0, _linguiReact.i18nMark)('Open'),
  phone: (0, _linguiReact.i18nMark)('Phone'),
  saturday: (0, _linguiReact.i18nMark)('Sat'),
  sunday: (0, _linguiReact.i18nMark)('Sun'),
  thursday: (0, _linguiReact.i18nMark)('Thu'),
  title: (0, _linguiReact.i18nMark)('Service Provider'),
  tuesday: (0, _linguiReact.i18nMark)('Tue'),
  wednesday: (0, _linguiReact.i18nMark)('Wed')
};

exports.default = messages;

/***/ }),

/***/ "./compositions/ServiceRequestOverview/Container.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _selectors = __webpack_require__("./redux/serviceRequests/selectors.js");

var _immutableToJS = __webpack_require__("./utils/immutableToJS.js");

var _immutableToJS2 = _interopRequireDefault(_immutableToJS);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var withConnectedData = function withConnectedData(WrappedComponent) {
  function Container(props) {
    return _react2.default.createElement(WrappedComponent, props);
  }

  Container.propTypes = {
    assetInfo: _propTypes2.default.shape({
      id: _propTypes2.default.string
    }).isRequired
  };

  function mapStateToProps(state) {
    return {
      assetInfo: (0, _selectors.currentServiceRequestAssetSelector)(state)
    };
  }

  return (0, _reactRedux.connect)(mapStateToProps)((0, _immutableToJS2.default)(Container));
};

exports.default = withConnectedData;

/***/ }),

/***/ "./compositions/ServiceRequestOverview/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ServiceRequestOverview = ServiceRequestOverview;

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/styled-components-reactive-grid/dist/index.js");

var _BreadCrumbLink = __webpack_require__("./compositions/BreadCrumbLink/index.js");

var _BreadCrumbLink2 = _interopRequireDefault(_BreadCrumbLink);

var _Table = __webpack_require__("./elements/Table/index.js");

var _Table2 = _interopRequireDefault(_Table);

var _widget = __webpack_require__("./utils/widget.js");

var _Container = __webpack_require__("./compositions/ServiceRequestOverview/Container.js");

var _Container2 = _interopRequireDefault(_Container);

var _messages = __webpack_require__("./compositions/ServiceRequestOverview/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ServiceRequestOverview(_ref) {
  var assetInfo = _ref.assetInfo;
  var unitNumber = assetInfo.unitNumber,
      year = assetInfo.year,
      make = assetInfo.make,
      model = assetInfo.model;


  return _react2.default.createElement(
    _styledComponentsReactiveGrid.Container,
    { id: 'service-request-overview' },
    _react2.default.createElement(_BreadCrumbLink2.default, null),
    _react2.default.createElement(
      _styledComponentsReactiveGrid.Row,
      { modifiers: ['middle'] },
      _react2.default.createElement(
        _styledComponentsReactiveGrid.Column,
        { modifiers: ['col'] },
        _react2.default.createElement(
          _Table2.default,
          { modifiers: ['mediumGrey', 'xLargeText'] },
          _react2.default.createElement(
            'tbody',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'th',
                null,
                _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.unit })
              ),
              _react2.default.createElement(
                'td',
                null,
                (0, _widget.getOutputText)(unitNumber)
              ),
              _react2.default.createElement(
                'th',
                null,
                _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.year })
              ),
              _react2.default.createElement(
                'td',
                null,
                (0, _widget.getOutputText)(year)
              ),
              _react2.default.createElement(
                'th',
                null,
                _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.make })
              ),
              _react2.default.createElement(
                'td',
                null,
                (0, _widget.getOutputText)(make)
              ),
              _react2.default.createElement(
                'th',
                null,
                _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.model })
              ),
              _react2.default.createElement(
                'td',
                null,
                (0, _widget.getOutputText)(model)
              )
            )
          )
        )
      )
    )
  );
}

ServiceRequestOverview.propTypes = {
  assetInfo: _propTypes2.default.shape({
    id: _propTypes2.default.string
  }).isRequired
};

exports.default = (0, _Container2.default)(ServiceRequestOverview);

/***/ }),

/***/ "./compositions/ServiceRequestOverview/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  make: (0, _linguiReact.i18nMark)('Make'),
  model: (0, _linguiReact.i18nMark)('Model'),
  unit: (0, _linguiReact.i18nMark)('Unit'),
  year: (0, _linguiReact.i18nMark)('Year')
};

exports.default = messages;

/***/ }),

/***/ "./compositions/ServiceRequestWidget/CaseServiceRequestInfoConainer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _immutableToJS = __webpack_require__("./utils/immutableToJS.js");

var _immutableToJS2 = _interopRequireDefault(_immutableToJS);

var _selectors = __webpack_require__("./redux/cases/selectors.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var withConnectedData = function withConnectedData(WrappedComponent) {
  function Container(props) {
    return _react2.default.createElement(WrappedComponent, props);
  }

  Container.propTypes = {
    serviceRequestInfo: _propTypes2.default.shape({
      reasonForRepair: _propTypes2.default.shape({
        code: _propTypes2.default.string,
        description: _propTypes2.default.string
      })
    })
  };

  Container.defaultProps = {
    serviceRequestInfo: {}
  };

  function mapStateToProps(state) {
    return {
      serviceRequestInfo: (0, _selectors.currentCaseSelector)(state)
    };
  }

  return (0, _reactRedux.connect)(mapStateToProps)((0, _immutableToJS2.default)(Container));
};

exports.default = withConnectedData;

/***/ }),

/***/ "./compositions/ServiceRequestWidget/ServReqServReqInfoContainer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _immutableToJS = __webpack_require__("./utils/immutableToJS.js");

var _immutableToJS2 = _interopRequireDefault(_immutableToJS);

var _selectors = __webpack_require__("./redux/serviceRequests/selectors.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var withConnectedData = function withConnectedData(WrappedComponent) {
  function Container(props) {
    return _react2.default.createElement(WrappedComponent, props);
  }

  Container.propTypes = {
    serviceRequestInfo: _propTypes2.default.shape({
      reasonForRepair: _propTypes2.default.shape({
        code: _propTypes2.default.string,
        description: _propTypes2.default.string
      })
    })
  };

  Container.defaultProps = {
    serviceRequestInfo: {}
  };

  function mapStateToProps(state) {
    return {
      serviceRequestInfo: (0, _selectors.currentServiceRequestSelector)(state)
    };
  }

  return (0, _reactRedux.connect)(mapStateToProps)((0, _immutableToJS2.default)(Container));
};

exports.default = withConnectedData;

/***/ }),

/***/ "./compositions/ServiceRequestWidget/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ServiceRequestServReqInfoWidget = exports.CaseServiceRequestInfoWidget = undefined;
exports.ServiceRequestInfoWidget = ServiceRequestInfoWidget;

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _Widget = __webpack_require__("./elements/Widget/index.js");

var _Widget2 = _interopRequireDefault(_Widget);

var _widget = __webpack_require__("./utils/widget.js");

var _CaseServiceRequestInfoConainer = __webpack_require__("./compositions/ServiceRequestWidget/CaseServiceRequestInfoConainer.js");

var _CaseServiceRequestInfoConainer2 = _interopRequireDefault(_CaseServiceRequestInfoConainer);

var _ServReqServReqInfoContainer = __webpack_require__("./compositions/ServiceRequestWidget/ServReqServReqInfoContainer.js");

var _ServReqServReqInfoContainer2 = _interopRequireDefault(_ServReqServReqInfoContainer);

var _messages = __webpack_require__("./compositions/ServiceRequestWidget/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ServiceRequestInfoWidget(_ref) {
  var reasonForRepair = _ref.serviceRequestInfo.reasonForRepair;

  var _ref2 = reasonForRepair || {},
      code = _ref2.code,
      description = _ref2.description;

  var content = code && description && code + ' - ' + description;

  return _react2.default.createElement(
    _Widget2.default,
    { id: 'service-request', expandKey: 'service-request' },
    _react2.default.createElement(
      _Widget2.default.Header,
      null,
      _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.title })
    ),
    _react2.default.createElement(
      _Widget2.default.Item,
      null,
      _react2.default.createElement(
        _Widget2.default.Table,
        null,
        _react2.default.createElement(
          'tbody',
          null,
          _react2.default.createElement(
            _Widget2.default.TableRow,
            { modifiers: ['topGap'] },
            _react2.default.createElement(
              'th',
              null,
              _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.reasonForRepair })
            ),
            _react2.default.createElement(
              'td',
              null,
              (0, _widget.getOutputText)(content)
            )
          )
        )
      )
    )
  );
}

ServiceRequestInfoWidget.propTypes = {
  serviceRequestInfo: _propTypes2.default.shape({
    reasonForRepair: _propTypes2.default.shape({
      code: _propTypes2.default.string,
      description: _propTypes2.default.string
    })
  }).isRequired
};

var CaseServiceRequestInfoWidget = exports.CaseServiceRequestInfoWidget = (0, _CaseServiceRequestInfoConainer2.default)(ServiceRequestInfoWidget);
var ServiceRequestServReqInfoWidget = exports.ServiceRequestServReqInfoWidget = (0, _ServReqServReqInfoContainer2.default)(ServiceRequestInfoWidget);

/***/ }),

/***/ "./compositions/ServiceRequestWidget/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var formattedMessages = {
  title: (0, _linguiReact.i18nMark)('Service Request'),
  reasonForRepair: (0, _linguiReact.i18nMark)('Reason For Repair')
};

exports.default = formattedMessages;

/***/ }),

/***/ "./containers/AppContainer/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppContainer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _reactRouterDom = __webpack_require__("../node_modules/react-router-dom/es/index.js");

var _selectors = __webpack_require__("./redux/ui/selectors.js");

var _AppBody = __webpack_require__("./components/AppBody/index.js");

var _AppBody2 = _interopRequireDefault(_AppBody);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    expanded: (0, _selectors.leftNavExpandedSelector)(state)
  };
}

/**
 * AppContainer wraps the main body of the application (excluding the top and left nav)
 * and passes down the left-nav expanded state to the AppBody.
 */

var AppContainer = exports.AppContainer = function (_Component) {
  _inherits(AppContainer, _Component);

  function AppContainer() {
    _classCallCheck(this, AppContainer);

    return _possibleConstructorReturn(this, (AppContainer.__proto__ || Object.getPrototypeOf(AppContainer)).apply(this, arguments));
  }

  _createClass(AppContainer, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.location !== prevProps.location) {
        // prevents Detail pages from NOT resetting the scroll state
        window.scrollTo(0, 0);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          expanded = _props.expanded,
          children = _props.children;

      return _react2.default.createElement(
        _AppBody2.default,
        { expanded: expanded },
        children
      );
    }
  }]);

  return AppContainer;
}(_react.Component);

AppContainer.propTypes = {
  children: _propTypes2.default.node.isRequired,
  expanded: _propTypes2.default.bool,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string
  }).isRequired
};
AppContainer.defaultProps = {
  expanded: true
};
exports.default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps)(AppContainer));

/***/ }),

/***/ "./containers/AssetDetailData/Component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = __webpack_require__("../node_modules/react-helmet/lib/Helmet.js");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _NotFoundPage = __webpack_require__("./components/NotFoundPage/index.js");

var _NotFoundPage2 = _interopRequireDefault(_NotFoundPage);

var _messages = __webpack_require__("./containers/AssetDetailData/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AssetDetailData = function (_Component) {
  _inherits(AssetDetailData, _Component);

  function AssetDetailData() {
    _classCallCheck(this, AssetDetailData);

    return _possibleConstructorReturn(this, (AssetDetailData.__proto__ || Object.getPrototypeOf(AssetDetailData)).apply(this, arguments));
  }

  _createClass(AssetDetailData, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var assetId = this.props.match.params.assetId;

      this.props.setCurrentAsset(assetId);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          assetInfo = _props.assetInfo,
          pathname = _props.location.pathname,
          assetId = _props.match.params.assetId;


      if (assetInfo.id) {
        this.props.addPageToBreadcrumbs({
          path: pathname,
          message: _messages2.default.breadcrumbs,
          number: assetInfo.unitNumber
        });
      }

      this.props.loadAsset(assetId);
      this.props.setLoadingStarted();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!this.props.assetInfo.id && nextProps.assetInfo.id) {
        this.props.addPageToBreadcrumbs({
          path: this.props.location.pathname,
          message: _messages2.default.breadcrumbs,
          number: nextProps.assetInfo.unitNumber
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.setCurrentAsset();
      this.props.setCurrentAssetCases({});
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          assetError = _props2.assetError,
          ChildComponent = _props2.ChildComponent,
          i18n = _props2.i18n;


      if (assetError) {
        return _react2.default.createElement(_NotFoundPage2.default, null);
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_reactHelmet2.default, {
          title: i18n._(_messages2.default.title),
          meta: [{ name: 'description', content: i18n._(_messages2.default.description) }]
        }),
        _react2.default.createElement(ChildComponent, this.props.componentProps)
      );
    }
  }]);

  return AssetDetailData;
}(_react.Component);

AssetDetailData.propTypes = {
  addPageToBreadcrumbs: _propTypes2.default.func.isRequired,
  assetError: _propTypes2.default.shape({
    error: _propTypes2.default.oneOf([true]).isRequired
  }),
  assetInfo: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    unitNumber: _propTypes2.default.string
  }).isRequired,
  ChildComponent: _propTypes2.default.func.isRequired,
  // This component doesn't care what is in componentProps, only that it is an object.
  // eslint-disable-next-line react/forbid-prop-types
  componentProps: _propTypes2.default.object.isRequired,
  i18n: _propTypes2.default.shape({
    _: _propTypes2.default.func.isRequired
  }).isRequired,
  loadAsset: _propTypes2.default.func.isRequired,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string.isRequired
  }).isRequired,
  match: _propTypes2.default.shape({
    params: _propTypes2.default.shape({
      assetId: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired,
  setCurrentAsset: _propTypes2.default.func.isRequired,
  setCurrentAssetCases: _propTypes2.default.func.isRequired,
  setLoadingStarted: _propTypes2.default.func.isRequired
};
AssetDetailData.defaultProps = {
  assetError: undefined
};
exports.default = AssetDetailData;

/***/ }),

/***/ "./containers/AssetDetailData/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _reactRouterDom = __webpack_require__("../node_modules/react-router-dom/es/index.js");

var _recompose = __webpack_require__("../node_modules/recompose/es/Recompose.js");

var _actions = __webpack_require__("./redux/app/actions.js");

var _actions2 = __webpack_require__("./redux/assets/actions.js");

var _selectors = __webpack_require__("./redux/assets/selectors.js");

var _immutableToJS = __webpack_require__("./utils/immutableToJS.js");

var _immutableToJS2 = _interopRequireDefault(_immutableToJS);

var _Component = __webpack_require__("./containers/AssetDetailData/Component.js");

var _Component2 = _interopRequireDefault(_Component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var withAssetDetailData = function withAssetDetailData(DetailsPage) {
  function WithAssetDetailData(props) {
    return _react2.default.createElement(_Component2.default, _extends({}, props, { ChildComponent: DetailsPage }));
  }

  WithAssetDetailData.propTypes = {
    addPageToBreadcrumbs: _propTypes2.default.func.isRequired,
    assetError: _propTypes2.default.shape({
      error: _propTypes2.default.oneOf([true]).isRequired
    }),
    assetInfo: _propTypes2.default.shape({
      id: _propTypes2.default.string
    }).isRequired,
    // This component doesn't care what is in componentProps, only that it is an object.
    // eslint-disable-next-line react/forbid-prop-types
    componentProps: _propTypes2.default.object.isRequired,
    i18n: _propTypes2.default.shape({
      _: _propTypes2.default.func.isRequired
    }).isRequired,
    loadAsset: _propTypes2.default.func.isRequired,
    location: _propTypes2.default.shape({
      pathname: _propTypes2.default.string.isRequired
    }).isRequired,
    match: _propTypes2.default.shape({
      params: _propTypes2.default.shape({
        assetId: _propTypes2.default.string.isRequired
      }).isRequired
    }).isRequired,
    setCurrentAsset: _propTypes2.default.func.isRequired,
    setCurrentAssetCases: _propTypes2.default.func.isRequired,
    setLoadingStarted: _propTypes2.default.func.isRequired
  };

  WithAssetDetailData.defaultProps = {
    assetError: undefined
  };

  function mapStateToProps(state) {
    return {
      assetError: (0, _selectors.loadAssetErrorSelector)(state),
      assetInfo: (0, _selectors.currentAssetSelector)(state)
    };
  }

  function mapDispatchToProps(dispatch) {
    return {
      addPageToBreadcrumbs: function addPageToBreadcrumbs(breadcrumbs) {
        return dispatch((0, _actions.addPageToBreadcrumbs)(breadcrumbs));
      },
      loadAsset: function loadAsset(assetId) {
        return dispatch((0, _actions2.loadAsset)({ assetId: assetId }));
      },
      setCurrentAsset: function setCurrentAsset(assetId) {
        return dispatch((0, _actions2.setCurrentAsset)(assetId));
      },
      setCurrentAssetCases: function setCurrentAssetCases(assetCases) {
        return dispatch((0, _actions2.setCurrentAssetCases)(assetCases));
      },
      setLoadingStarted: function setLoadingStarted() {
        return dispatch((0, _actions.setLoadingStarted)(true));
      }
    };
  }

  return (0, _recompose.compose)(_reactRouterDom.withRouter, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _linguiReact.withI18n)(), _immutableToJS2.default)(WithAssetDetailData);
};

exports.default = withAssetDetailData;

/***/ }),

/***/ "./containers/AssetDetailData/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  breadcrumbs: (0, _linguiReact.i18nMark)('Unit {number}'),
  description: (0, _linguiReact.i18nMark)('The Asset Detail page of the application'),
  title: (0, _linguiReact.i18nMark)('The Asset Detail Page')
};

exports.default = messages;

/***/ }),

/***/ "./containers/AssetDisplayContainer/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AssetDisplayContainer = AssetDisplayContainer;

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactiveContainer = __webpack_require__("../node_modules/reactive-container/dist/index.js");

var _reactImmutableProptypes = __webpack_require__("../node_modules/react-immutable-proptypes/dist/ImmutablePropTypes.js");

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _AssetDisplayElement = __webpack_require__("./components/AssetDisplayElement/index.js");

var _Card = __webpack_require__("./elements/Card/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function AssetDisplayContainer(_ref) {
  var _ref2;

  var datum = _ref.datum,
      type = _ref.type;

  switch (type) {
    case 'list':
      return _react2.default.createElement(_AssetDisplayElement.AssetListRow, {
        assetInfo: datum
      });
    case 'card':
    default:
      return _react2.default.createElement(
        _Card.CardWrapper,
        {
          responsiveModifiers: (_ref2 = {}, _defineProperty(_ref2, _reactiveContainer.sizes.XS, ['1_per_row']), _defineProperty(_ref2, _reactiveContainer.sizes.SM, ['2_per_row']), _defineProperty(_ref2, _reactiveContainer.sizes.MD, ['3_per_row']), _defineProperty(_ref2, _reactiveContainer.sizes.LG, ['4_per_row']), _defineProperty(_ref2, _reactiveContainer.sizes.XL, ['5_per_row']), _ref2)
        },
        _react2.default.createElement(_AssetDisplayElement.AssetCard, {
          assetInfo: datum
        })
      );
  }
}

AssetDisplayContainer.propTypes = {
  datum: _reactImmutableProptypes2.default.contains({
    id: _propTypes2.default.string
  }).isRequired,
  type: _propTypes2.default.oneOf(['card', 'list', 'map']).isRequired
};

exports.default = AssetDisplayContainer;

/***/ }),

/***/ "./containers/AssetsPage/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AssetsPage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactImmutableProptypes = __webpack_require__("../node_modules/react-immutable-proptypes/dist/ImmutablePropTypes.js");

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _reactHelmet = __webpack_require__("../node_modules/react-helmet/lib/Helmet.js");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _AssetsPanel = __webpack_require__("./components/AssetsPanel/index.js");

var _AssetsPanel2 = _interopRequireDefault(_AssetsPanel);

var _SelectorBar = __webpack_require__("./components/SelectorBar/index.js");

var _SelectorBar2 = _interopRequireDefault(_SelectorBar);

var _NotFoundPage = __webpack_require__("./components/NotFoundPage/index.js");

var _NotFoundPage2 = _interopRequireDefault(_NotFoundPage);

var _Divider = __webpack_require__("./elements/Divider/index.js");

var _Divider2 = _interopRequireDefault(_Divider);

var _Page = __webpack_require__("./elements/Page/index.js");

var _Page2 = _interopRequireDefault(_Page);

var _PageHeadingPanel = __webpack_require__("./elements/PageHeadingPanel/index.js");

var _PageHeadingPanel2 = _interopRequireDefault(_PageHeadingPanel);

var _PageHeadingTitle = __webpack_require__("./elements/PageHeadingTitle/index.js");

var _PageHeadingTitle2 = _interopRequireDefault(_PageHeadingTitle);

var _actions = __webpack_require__("./redux/app/actions.js");

var _selectors = __webpack_require__("./redux/app/selectors.js");

var _actions2 = __webpack_require__("./redux/assets/actions.js");

var _selectors2 = __webpack_require__("./redux/assets/selectors.js");

var _actions3 = __webpack_require__("./redux/ui/actions.js");

var _selectors3 = __webpack_require__("./redux/ui/selectors.js");

var _favorites = __webpack_require__("./utils/favorites.js");

var _messages = __webpack_require__("./containers/AssetsPage/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AssetsPage = exports.AssetsPage = function (_Component) {
  _inherits(AssetsPage, _Component);

  function AssetsPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AssetsPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AssetsPage.__proto__ || Object.getPrototypeOf(AssetsPage)).call.apply(_ref, [this].concat(args))), _this), _this.loadAssetFavorite = function (_ref2) {
      var priorFavorite = _ref2.priorFavorite,
          latestFavorite = _ref2.latestFavorite,
          _ref2$forceClear = _ref2.forceClear,
          forceClear = _ref2$forceClear === undefined ? false : _ref2$forceClear;

      var opts = {
        priorFavorite: priorFavorite,
        latestFavorite: latestFavorite,
        forceClear: forceClear,
        clearAction: _this.props.clearAssets,
        loadAction: _this.props.loadAssets
      };
      (0, _favorites.clearAndLoadFavorites)(opts);
    }, _this.refreshAssets = function () {
      _this.loadAssetFavorite({
        priorFavorite: _this.props.priorFavorite,
        latestFavorite: _this.props.latestFavorite,
        forceClear: true
      });
    }, _this.requestNext = function (favoritePagination) {
      var latestPage = parseInt(favoritePagination.get('latestPage'), 10);
      var nextPage = latestPage + 1;
      (0, _favorites.loadFavorite)({
        page: nextPage,
        favorite: _this.props.latestFavorite,
        loadAction: _this.props.loadAssets
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AssetsPage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // if the slug is invalid, we don't need to dispatch the following redux actions
      // to fetch the assets data from the server
      if (!this.props.isValidSlug) {
        return;
      }

      this.loadingOnMount = true;
      this.props.startLoading();

      this.loadAssetFavorite({
        priorFavorite: this.props.priorFavorite,
        latestFavorite: this.props.latestFavorite
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // if the slug is invalid, we don't need to dispatch the following redux actions
      // to fetch the assets data from the server
      if (!nextProps.isValidSlug) {
        return;
      }
      // if loading has finished, set loadingOnMount to false
      if (!nextProps.assetsRequesting && this.props.assetsRequesting) {
        this.loadingOnMount = false;
      }
      if ((0, _favorites.shouldClearAndLoadFavorites)(this.props, nextProps)) {
        // if loading from componentDidMount is in progress, don't start loading again
        if (!this.loadingOnMount) this.props.startLoading();
        this.loadAssetFavorite({
          priorFavorite: nextProps.priorFavorite,
          latestFavorite: nextProps.latestFavorite
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          assets = _props.assets,
          assetsView = _props.assetsView,
          assetsRequesting = _props.assetsRequesting,
          favoritePagination = _props.favoritePagination,
          i18n = _props.i18n,
          latestFavorite = _props.latestFavorite,
          isValidSlug = _props.isValidSlug;


      if (!isValidSlug) {
        return _react2.default.createElement(_NotFoundPage2.default, null);
      }

      var headingTitle = latestFavorite.title ? latestFavorite.message : _messages2.default.defaultHeader;

      return _react2.default.createElement(
        _Page2.default,
        { id: 'assets-page' },
        _react2.default.createElement(_reactHelmet2.default, {
          title: i18n._(headingTitle),
          meta: [{ name: 'description', content: i18n._(_messages2.default.description) }]
        }),
        _react2.default.createElement(
          _PageHeadingPanel2.default,
          null,
          _react2.default.createElement(
            _PageHeadingTitle2.default,
            { modifiers: ['large', 'padLeft'] },
            _react2.default.createElement(_linguiReact.Trans, { id: headingTitle })
          ),
          _react2.default.createElement(_SelectorBar2.default, {
            view: assetsView,
            setView: this.props.setAssetsView,
            type: 'asset'
          }),
          _react2.default.createElement(_Divider2.default, null)
        ),
        _react2.default.createElement(_AssetsPanel2.default, {
          assets: assets,
          assetsView: assetsView,
          refreshAssets: this.refreshAssets,
          requestNext: this.requestNext,
          assetsRequesting: assetsRequesting,
          favoritePagination: favoritePagination,
          latestFavorite: latestFavorite
        })
      );
    }
  }]);

  return AssetsPage;
}(_react.Component);

/* istanbul ignore next */


AssetsPage.propTypes = {
  // All application data kept in state is immutable. To properly validate these,
  // use ImmutablePropTypes.
  assets: _reactImmutableProptypes2.default.listOf(_reactImmutableProptypes2.default.mapContains({
    id: _propTypes2.default.string
  })).isRequired,
  assetsRequesting: _propTypes2.default.bool,
  assetsView: _propTypes2.default.string,
  clearAssets: _propTypes2.default.func.isRequired,
  favoritePagination: _reactImmutableProptypes2.default.map.isRequired,
  i18n: _propTypes2.default.shape({
    _: _propTypes2.default.func.isRequired
  }).isRequired,
  latestFavorite: _propTypes2.default.shape({
    message: _propTypes2.default.string,
    path: _propTypes2.default.string,
    slug: _propTypes2.default.string,
    title: _propTypes2.default.string
  }),
  loadAssets: _propTypes2.default.func.isRequired,
  priorFavorite: _propTypes2.default.shape({
    message: _propTypes2.default.string,
    path: _propTypes2.default.string,
    slug: _propTypes2.default.string,
    title: _propTypes2.default.string
  }),
  setAssetsView: _propTypes2.default.func.isRequired,
  startLoading: _propTypes2.default.func.isRequired,
  isValidSlug: _propTypes2.default.bool
};
AssetsPage.defaultProps = {
  assetsRequesting: false,
  assetsView: '',
  latestFavorite: {},
  priorFavorite: {},
  isValidSlug: true
};
function mapStateToProps(state) {
  return {
    favoritePagination: (0, _selectors.favoritePaginationSelector)(state),
    assets: (0, _selectors2.assetsSelector)(state),
    assetsRequesting: (0, _selectors2.assetsRequestingSelector)(state),
    assetsView: (0, _selectors3.assetsViewSelector)(state),
    latestFavorite: (0, _selectors.latestFavoriteSelector)(state),
    priorFavorite: (0, _selectors.priorFavoriteSelector)(state)
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    loadAssets: function loadAssets(filter) {
      return dispatch((0, _actions2.loadAssets)(filter));
    },
    clearAssets: function clearAssets() {
      return dispatch((0, _actions2.clearAssets)());
    },
    setAssetsView: function setAssetsView(id) {
      return dispatch((0, _actions3.setAssetsView)(id));
    },
    startLoading: function startLoading() {
      return dispatch((0, _actions.setLoadingStarted)(true));
    }
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _linguiReact.withI18n)()(AssetsPage));

/***/ }),

/***/ "./containers/AssetsPage/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  defaultHeader: (0, _linguiReact.i18nMark)('Assets'),
  description: (0, _linguiReact.i18nMark)('The assets page of the application'),
  title: (0, _linguiReact.i18nMark)('The Assets Page')
};

exports.default = messages;

/***/ }),

/***/ "./containers/CaseDetailData/Component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = __webpack_require__("../node_modules/react-helmet/lib/Helmet.js");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _NotFoundPage = __webpack_require__("./components/NotFoundPage/index.js");

var _NotFoundPage2 = _interopRequireDefault(_NotFoundPage);

var _messages = __webpack_require__("./containers/CaseDetailData/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CaseDetailData = function (_Component) {
  _inherits(CaseDetailData, _Component);

  function CaseDetailData() {
    _classCallCheck(this, CaseDetailData);

    return _possibleConstructorReturn(this, (CaseDetailData.__proto__ || Object.getPrototypeOf(CaseDetailData)).apply(this, arguments));
  }

  _createClass(CaseDetailData, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var caseId = this.props.match.params.caseId;

      this.props.setCurrentCase(caseId);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var caseId = this.props.match.params.caseId;

      this.props.loadCase(caseId);
      this.props.setLoadingStarted();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!this.props.caseInfo.id && nextProps.caseInfo.id) {
        this.props.addPageToBreadcrumbs({
          path: this.props.location.pathname,
          message: _messages2.default.breadcrumbs,
          number: nextProps.caseInfo.id
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.setCurrentCase();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          caseError = _props.caseError,
          ChildComponent = _props.ChildComponent,
          i18n = _props.i18n;


      if (caseError) {
        return _react2.default.createElement(_NotFoundPage2.default, null);
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_reactHelmet2.default, {
          title: i18n._(_messages2.default.title),
          meta: [{ name: 'description', content: i18n._(_messages2.default.description) }]
        }),
        _react2.default.createElement(ChildComponent, this.props.componentProps)
      );
    }
  }]);

  return CaseDetailData;
}(_react.Component);

CaseDetailData.propTypes = {
  addPageToBreadcrumbs: _propTypes2.default.func.isRequired,
  caseError: _propTypes2.default.shape({
    error: _propTypes2.default.oneOf([true]).isRequired
  }),
  caseInfo: _propTypes2.default.shape({
    id: _propTypes2.default.string
  }).isRequired,
  ChildComponent: _propTypes2.default.func.isRequired,
  // This component doesn't care what is in componentProps, only that it is an object.
  // eslint-disable-next-line react/forbid-prop-types
  componentProps: _propTypes2.default.object.isRequired,
  i18n: _propTypes2.default.shape({
    _: _propTypes2.default.func.isRequired
  }).isRequired,
  loadCase: _propTypes2.default.func.isRequired,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string.isRequired
  }).isRequired,
  match: _propTypes2.default.shape({
    params: _propTypes2.default.shape({
      caseId: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired,
  setCurrentCase: _propTypes2.default.func.isRequired,
  setLoadingStarted: _propTypes2.default.func.isRequired
};
CaseDetailData.defaultProps = {
  caseError: undefined
};
exports.default = CaseDetailData;

/***/ }),

/***/ "./containers/CaseDetailData/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _reactRouterDom = __webpack_require__("../node_modules/react-router-dom/es/index.js");

var _recompose = __webpack_require__("../node_modules/recompose/es/Recompose.js");

var _actions = __webpack_require__("./redux/app/actions.js");

var _actions2 = __webpack_require__("./redux/cases/actions.js");

var _selectors = __webpack_require__("./redux/cases/selectors.js");

var _immutableToJS = __webpack_require__("./utils/immutableToJS.js");

var _immutableToJS2 = _interopRequireDefault(_immutableToJS);

var _Component = __webpack_require__("./containers/CaseDetailData/Component.js");

var _Component2 = _interopRequireDefault(_Component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var withCaseDetailData = function withCaseDetailData(DetailsPage) {
  function WithCaseDetailData(props) {
    return _react2.default.createElement(_Component2.default, _extends({}, props, { ChildComponent: DetailsPage }));
  }

  WithCaseDetailData.propTypes = {
    addPageToBreadcrumbs: _propTypes2.default.func.isRequired,
    caseError: _propTypes2.default.shape({
      error: _propTypes2.default.oneOf([true]).isRequired
    }),
    caseInfo: _propTypes2.default.shape({
      id: _propTypes2.default.string
    }).isRequired,
    // This component doesn't care what is in componentProps, only that it is an object.
    // eslint-disable-next-line react/forbid-prop-types
    componentProps: _propTypes2.default.object.isRequired,
    i18n: _propTypes2.default.shape({
      _: _propTypes2.default.func.isRequired
    }).isRequired,
    loadCase: _propTypes2.default.func.isRequired,
    location: _propTypes2.default.shape({
      pathname: _propTypes2.default.string.isRequired
    }).isRequired,
    match: _propTypes2.default.shape({
      params: _propTypes2.default.shape({
        caseId: _propTypes2.default.string.isRequired
      }).isRequired
    }).isRequired,
    setCurrentCase: _propTypes2.default.func.isRequired,
    setLoadingStarted: _propTypes2.default.func.isRequired
  };

  WithCaseDetailData.defaultProps = {
    caseError: undefined
  };

  function mapStateToProps(state) {
    return {
      caseError: (0, _selectors.loadCaseErrorSelector)(state),
      caseInfo: (0, _selectors.currentCaseSelector)(state)
    };
  }

  function mapDispatchToProps(dispatch) {
    return {
      addPageToBreadcrumbs: function addPageToBreadcrumbs(breadcrumbs) {
        return dispatch((0, _actions.addPageToBreadcrumbs)(breadcrumbs));
      },
      loadCase: function loadCase(caseId) {
        return dispatch((0, _actions2.loadCase)({ caseId: caseId }));
      },
      setCurrentCase: function setCurrentCase(caseId) {
        return dispatch((0, _actions2.setCurrentCase)(caseId));
      },
      setLoadingStarted: function setLoadingStarted() {
        return dispatch((0, _actions.setLoadingStarted)(true));
      }
    };
  }

  return (0, _recompose.compose)(_reactRouterDom.withRouter, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _linguiReact.withI18n)(), _immutableToJS2.default)(WithCaseDetailData);
};

exports.default = withCaseDetailData;

/***/ }),

/***/ "./containers/CaseDetailData/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  breadcrumbs: (0, _linguiReact.i18nMark)('Case {number}'),
  description: (0, _linguiReact.i18nMark)('The case page of the application'),
  title: (0, _linguiReact.i18nMark)('The Case Page')
};

exports.default = messages;

/***/ }),

/***/ "./containers/CaseDisplayContainer/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CaseDisplayContainer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactiveContainer = __webpack_require__("../node_modules/reactive-container/dist/index.js");

var _reactImmutableProptypes = __webpack_require__("../node_modules/react-immutable-proptypes/dist/ImmutablePropTypes.js");

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _actions = __webpack_require__("./redux/cases/actions.js");

var _selectors = __webpack_require__("./redux/cases/selectors.js");

var _selectors2 = __webpack_require__("./redux/assets/selectors.js");

var _selectors3 = __webpack_require__("./redux/serviceProviders/selectors.js");

var _CaseDisplayElement = __webpack_require__("./components/CaseDisplayElement/index.js");

var _Card = __webpack_require__("./elements/Card/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CaseDisplayContainer = exports.CaseDisplayContainer = function (_Component) {
  _inherits(CaseDisplayContainer, _Component);

  function CaseDisplayContainer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CaseDisplayContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CaseDisplayContainer.__proto__ || Object.getPrototypeOf(CaseDisplayContainer)).call.apply(_ref, [this].concat(args))), _this), _this.onSelect = function () {
      if (!_this.props.selectionDisabled) {
        _this.props.select(_this.props.datum.get('id'));
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CaseDisplayContainer, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.select('');
    }
  }, {
    key: 'render',
    value: function render() {
      var _ref2;

      var _props = this.props,
          assetInfo = _props.assetInfo,
          datum = _props.datum,
          serviceProviderInfo = _props.serviceProviderInfo,
          selectedCaseId = _props.selectedCaseId,
          selectionDisabled = _props.selectionDisabled,
          type = _props.type;

      var isSelected = !selectionDisabled && datum.get('id') === selectedCaseId;

      switch (type) {
        case 'list':
          return _react2.default.createElement(_CaseDisplayElement.CaseListRow, {
            assetInfo: assetInfo,
            caseInfo: datum,
            onSelect: this.onSelect,
            isSelected: isSelected,
            selectionDisabled: selectionDisabled
          });
        case 'card':
        default:
          return _react2.default.createElement(
            _Card.CardWrapper,
            {
              responsiveModifiers: (_ref2 = {}, _defineProperty(_ref2, _reactiveContainer.sizes.XS, ['1_per_row']), _defineProperty(_ref2, _reactiveContainer.sizes.SM, ['2_per_row']), _defineProperty(_ref2, _reactiveContainer.sizes.MD, ['3_per_row']), _defineProperty(_ref2, _reactiveContainer.sizes.LG, ['4_per_row']), _defineProperty(_ref2, _reactiveContainer.sizes.XL, ['5_per_row']), _ref2)
            },
            _react2.default.createElement(_CaseDisplayElement.CaseCard, {
              caseInfo: datum,
              assetInfo: assetInfo,
              serviceProviderInfo: serviceProviderInfo,
              onSelect: this.onSelect,
              isSelected: isSelected,
              selectionDisabled: selectionDisabled
            })
          );
      }
    }
  }]);

  return CaseDisplayContainer;
}(_react.Component);

CaseDisplayContainer.propTypes = {
  assetInfo: _reactImmutableProptypes2.default.contains({
    id: _propTypes2.default.string
  }).isRequired,
  datum: _reactImmutableProptypes2.default.contains({
    id: _propTypes2.default.string
  }).isRequired,
  serviceProviderInfo: _reactImmutableProptypes2.default.contains({
    id: _propTypes2.default.string
  }).isRequired,
  select: _propTypes2.default.func.isRequired,
  selectedCaseId: _propTypes2.default.string.isRequired,
  selectionDisabled: _propTypes2.default.bool,
  type: _propTypes2.default.oneOf(['card', 'list', 'map']).isRequired
};

CaseDisplayContainer.defaultProps = {
  selectedCaseId: '',
  selectionDisabled: false
};

/* istanbul ignore next */
function mapStateToProps() {
  var getAsset = (0, _selectors2.makeGetAssetById)();
  var getServiceProvider = (0, _selectors3.makeGetServiceProviderById)();

  return function (state, props) {
    return {
      assetInfo: getAsset(state, props.datum.get('asset')),
      serviceProviderInfo: getServiceProvider(state, props.datum.get('serviceProvider')),
      selectedCaseId: (0, _selectors.selectedCaseSelector)(state)
    };
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    select: function select(id) {
      return dispatch((0, _actions.selectCase)(id));
    }
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CaseDisplayContainer);

/***/ }),

/***/ "./containers/CasesPage/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CasesPage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactImmutableProptypes = __webpack_require__("../node_modules/react-immutable-proptypes/dist/ImmutablePropTypes.js");

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _immutable = __webpack_require__("../node_modules/immutable/dist/immutable.js");

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _reactHelmet = __webpack_require__("../node_modules/react-helmet/lib/Helmet.js");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _QuickActionBarContainer = __webpack_require__("./containers/QuickActionBarContainer/index.js");

var _QuickActionBarContainer2 = _interopRequireDefault(_QuickActionBarContainer);

var _NotesWidget = __webpack_require__("./compositions/NotesWidget/index.js");

var _CasesPanel = __webpack_require__("./components/CasesPanel/index.js");

var _CasesPanel2 = _interopRequireDefault(_CasesPanel);

var _SelectorBar = __webpack_require__("./components/SelectorBar/index.js");

var _SelectorBar2 = _interopRequireDefault(_SelectorBar);

var _NotFoundPage = __webpack_require__("./components/NotFoundPage/index.js");

var _NotFoundPage2 = _interopRequireDefault(_NotFoundPage);

var _ModalWindow = __webpack_require__("./components/ModalWindow/index.js");

var _ModalWindow2 = _interopRequireDefault(_ModalWindow);

var _Divider = __webpack_require__("./elements/Divider/index.js");

var _Divider2 = _interopRequireDefault(_Divider);

var _Page = __webpack_require__("./elements/Page/index.js");

var _Page2 = _interopRequireDefault(_Page);

var _PageHeadingPanel = __webpack_require__("./elements/PageHeadingPanel/index.js");

var _PageHeadingPanel2 = _interopRequireDefault(_PageHeadingPanel);

var _PageHeadingTitle = __webpack_require__("./elements/PageHeadingTitle/index.js");

var _PageHeadingTitle2 = _interopRequireDefault(_PageHeadingTitle);

var _actions = __webpack_require__("./redux/app/actions.js");

var _selectors = __webpack_require__("./redux/app/selectors.js");

var _actions2 = __webpack_require__("./redux/cases/actions.js");

var _selectors2 = __webpack_require__("./redux/cases/selectors.js");

var _selectors3 = __webpack_require__("./redux/ui/selectors.js");

var _constants = __webpack_require__("./containers/QuickActionBarContainer/constants.js");

var _actions3 = __webpack_require__("./redux/ui/actions.js");

var _favorites = __webpack_require__("./utils/favorites.js");

var _messages = __webpack_require__("./containers/CasesPage/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CasesPage = exports.CasesPage = function (_Component) {
  _inherits(CasesPage, _Component);

  function CasesPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CasesPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CasesPage.__proto__ || Object.getPrototypeOf(CasesPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = { showCaseNotesModal: false, lastSelectedCaseId: '' }, _this.handleHideDetailsModal = function () {
      _this.setState({ showCaseNotesModal: false });
    }, _this.loadCaseFavorite = function (_ref2) {
      var priorFavorite = _ref2.priorFavorite,
          latestFavorite = _ref2.latestFavorite,
          _ref2$forceClear = _ref2.forceClear,
          forceClear = _ref2$forceClear === undefined ? false : _ref2$forceClear;

      var opts = {
        priorFavorite: priorFavorite,
        latestFavorite: latestFavorite,
        forceClear: forceClear,
        clearAction: _this.props.clearCases,
        loadAction: _this.props.loadCases
      };
      (0, _favorites.clearAndLoadFavorites)(opts);
    }, _this.refreshCases = function () {
      _this.loadCaseFavorite({
        priorFavorite: _this.props.priorFavorite,
        latestFavorite: _this.props.latestFavorite,
        forceClear: true
      });
    }, _this.requestNext = function (favoritePagination) {
      var latestPage = parseInt(favoritePagination.get('latestPage'), 10);
      var nextPage = latestPage + 1;
      (0, _favorites.loadFavorite)({
        page: nextPage,
        favorite: _this.props.latestFavorite,
        loadAction: _this.props.loadCases
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CasesPage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // if the slug is invalid, we don't need to dispatch the following redux actions
      // to fetch the data from the server

      if (!this.props.isValidSlug) {
        return;
      }

      this.loadingOnMount = true;
      this.props.startLoading();

      this.loadCaseFavorite({
        priorFavorite: this.props.priorFavorite,
        latestFavorite: this.props.latestFavorite
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var actionBarItemClicked = nextProps.actionBarItemClicked,
          selectedCaseId = nextProps.selectedCaseId;

      var buttonId = actionBarItemClicked.get('buttonId');
      var actionTime = actionBarItemClicked.get('time');
      var addingNote = buttonId === _constants.ADD_NOTE;
      var buttonWasJustClicked = buttonId !== this.props.actionBarItemClicked.get('buttonId') || actionTime !== this.props.actionBarItemClicked.get('time');
      if (addingNote && buttonWasJustClicked) {
        this.setState({ showCaseNotesModal: true });
      }

      if (selectedCaseId !== this.props.selectedCaseId && selectedCaseId) {
        this.setState({ lastSelectedCaseId: selectedCaseId });
      }

      // if the slug is invalid, we don't need to dispatch the following redux actions
      // to fetch the cases data from the server

      if (!nextProps.isValidSlug) {
        return;
      }

      // if loading has finished, set loadingOnMount to false

      if (!nextProps.casesRequesting && this.props.casesRequesting) {
        this.loadingOnMount = false;
      }

      if ((0, _favorites.shouldClearAndLoadFavorites)(this.props, nextProps)) {
        // if loading from componentDidMount is in progress, don't start loading again
        if (!this.loadingOnMount) this.props.startLoading();
        this.loadCaseFavorite({
          priorFavorite: nextProps.priorFavorite,
          latestFavorite: nextProps.latestFavorite
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          cases = _props.cases,
          casesRequesting = _props.casesRequesting,
          casesView = _props.casesView,
          favoritePagination = _props.favoritePagination,
          i18n = _props.i18n,
          latestFavorite = _props.latestFavorite,
          isValidSlug = _props.isValidSlug,
          selectedCaseId = _props.selectedCaseId;
      var _state = this.state,
          showCaseNotesModal = _state.showCaseNotesModal,
          lastSelectedCaseId = _state.lastSelectedCaseId;


      if (!isValidSlug) {
        return _react2.default.createElement(_NotFoundPage2.default, null);
      }

      var headingTitle = latestFavorite.title ? latestFavorite.message : _messages2.default.defaultHeader;
      var selectedCase = cases.find(function (item) {
        return item.get('id') === lastSelectedCaseId;
      });
      var caseInfo = (selectedCase || (0, _immutable.Map)()).toJS();
      return _react2.default.createElement(
        _Page2.default,
        { id: 'cases-page' },
        _react2.default.createElement(_reactHelmet2.default, {
          title: i18n._(headingTitle),
          meta: [{ name: 'description', content: i18n._(_messages2.default.description) }]
        }),
        _react2.default.createElement(
          _PageHeadingPanel2.default,
          null,
          _react2.default.createElement(
            _PageHeadingTitle2.default,
            { modifiers: ['large', 'padLeft'] },
            _react2.default.createElement(_linguiReact.Trans, { id: headingTitle })
          ),
          _react2.default.createElement(_SelectorBar2.default, {
            view: casesView,
            setView: this.props.setCasesView,
            type: 'case'
          }),
          _react2.default.createElement(_Divider2.default, null)
        ),
        _react2.default.createElement(_QuickActionBarContainer2.default, {
          pageTitle: 'CASES_PAGE',
          disabled: { ADD_NOTE: !selectedCaseId }
        }),
        _react2.default.createElement(_CasesPanel2.default, {
          cases: cases,
          casesView: casesView,
          refreshCases: this.refreshCases,
          requestNext: this.requestNext,
          casesRequesting: casesRequesting,
          favoritePagination: favoritePagination,
          latestFavorite: latestFavorite
        }),
        showCaseNotesModal && _react2.default.createElement(
          _ModalWindow2.default,
          {
            headerInfo: { title: _react2.default.createElement(_NotesWidget.NotesWidgetHeader, { info: caseInfo }) },
            hideModal: this.handleHideDetailsModal,
            hideByClickingBackground: true
          },
          _react2.default.createElement(_NotesWidget.CaseNotesWidget, { caseInfo: caseInfo, type: 'modal', action: 'add_note' })
        )
      );
    }
  }]);

  return CasesPage;
}(_react.Component);

/* istanbul ignore next */


CasesPage.propTypes = {
  // All application data kept in state is immutable. To properly validate these,
  // use ImmutablePropTypes.
  cases: _reactImmutableProptypes2.default.listOf(_reactImmutableProptypes2.default.mapContains({
    id: _propTypes2.default.string
  })).isRequired,
  casesRequesting: _propTypes2.default.bool,
  casesView: _propTypes2.default.string,
  clearCases: _propTypes2.default.func.isRequired,
  favoritePagination: _reactImmutableProptypes2.default.map.isRequired,
  i18n: _propTypes2.default.shape({
    _: _propTypes2.default.func.isRequired
  }).isRequired,
  latestFavorite: _propTypes2.default.shape({
    message: _propTypes2.default.string,
    path: _propTypes2.default.string,
    slug: _propTypes2.default.string,
    title: _propTypes2.default.string
  }),
  loadCases: _propTypes2.default.func.isRequired,
  priorFavorite: _propTypes2.default.shape({
    message: _propTypes2.default.string,
    path: _propTypes2.default.string,
    slug: _propTypes2.default.string,
    title: _propTypes2.default.string
  }),
  setCasesView: _propTypes2.default.func.isRequired,
  startLoading: _propTypes2.default.func.isRequired,
  isValidSlug: _propTypes2.default.bool,
  selectedCaseId: _propTypes2.default.string.isRequired,
  actionBarItemClicked: _reactImmutableProptypes2.default.contains({
    buttonId: _propTypes2.default.string,
    dropdownItemId: _propTypes2.default.string
  })
};
CasesPage.defaultProps = {
  casesRequesting: false,
  casesView: '',
  latestFavorite: {},
  priorFavorite: {},
  totalCount: '',
  isValidSlug: true,
  actionBarItemClicked: (0, _immutable.Map)({
    buttonId: '',
    dropdownItemId: ''
  })
};
function mapStateToProps(state) {
  return {
    cases: (0, _selectors2.casesSelector)(state),
    casesRequesting: (0, _selectors2.casesRequestingSelector)(state),
    casesView: (0, _selectors3.casesViewSelector)(state),
    favoritePagination: (0, _selectors.favoritePaginationSelector)(state),
    latestFavorite: (0, _selectors.latestFavoriteSelector)(state),
    priorFavorite: (0, _selectors.priorFavoriteSelector)(state),
    selectedCaseId: (0, _selectors2.selectedCaseSelector)(state),
    actionBarItemClicked: (0, _selectors3.actionBarItemClickedSelector)(state)
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    clearCases: function clearCases() {
      return dispatch((0, _actions2.clearCases)());
    },
    loadCases: function loadCases(filter) {
      return dispatch((0, _actions2.loadCases)(filter));
    },
    setCasesView: function setCasesView(id) {
      return dispatch((0, _actions3.setCasesView)(id));
    },
    startLoading: function startLoading() {
      return dispatch((0, _actions.setLoadingStarted)(true));
    }
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _linguiReact.withI18n)()(CasesPage));

/***/ }),

/***/ "./containers/CasesPage/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  description: (0, _linguiReact.i18nMark)('The cases page of the application'),
  title: (0, _linguiReact.i18nMark)('The Cases Page'),
  defaultHeader: (0, _linguiReact.i18nMark)('Cases'),
  allRepairCases: (0, _linguiReact.i18nMark)('All Repair Cases'),
  downtime2Days: (0, _linguiReact.i18nMark)('Downtime > 2 Days'),
  pastDueFollowUp: (0, _linguiReact.i18nMark)('Past Due Follow Up'),
  pastDueEtr: (0, _linguiReact.i18nMark)('Past Due ETR'),
  current: (0, _linguiReact.i18nMark)('Current'),
  uptimeCases: (0, _linguiReact.i18nMark)('Uptime Cases')
};

exports.default = messages;

/***/ }),

/***/ "./containers/Expandable/ExpandIconWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  color: ' + props.theme.colors.base.chrome400 + ';\n  cursor: pointer;\n  font-size: ' + (0, _decisivUiUtils.px2rem)(12) + ';\n  margin-right: ' + (0, _decisivUiUtils.px2rem)(5) + ';\n  text-align: center;\n  width: ' + (0, _decisivUiUtils.px2rem)(12) + ';\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome400: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('ExpandIconWrapper', _styledComponents2.default.div, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./containers/Expandable/Expandable.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Expandable = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSmoothCollapse = __webpack_require__("../node_modules/react-smooth-collapse/js/index.js");

var _reactSmoothCollapse2 = _interopRequireDefault(_reactSmoothCollapse);

var _reactFontawesome = __webpack_require__("../node_modules/react-fontawesome/lib/index.js");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _reactImmutableProptypes = __webpack_require__("../node_modules/react-immutable-proptypes/dist/ImmutablePropTypes.js");

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _immutable = __webpack_require__("../node_modules/immutable/dist/immutable.js");

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _selectors = __webpack_require__("./redux/ui/selectors.js");

var _actions = __webpack_require__("./redux/ui/actions.js");

var _Popover = __webpack_require__("./elements/Popover/index.js");

var _Popover2 = _interopRequireDefault(_Popover);

var _Wrapper = __webpack_require__("./containers/Expandable/Wrapper.js");

var _Wrapper2 = _interopRequireDefault(_Wrapper);

var _HeaderWrapper = __webpack_require__("./containers/Expandable/HeaderWrapper.js");

var _HeaderWrapper2 = _interopRequireDefault(_HeaderWrapper);

var _OverflowWrapper = __webpack_require__("./containers/Expandable/OverflowWrapper.js");

var _OverflowWrapper2 = _interopRequireDefault(_OverflowWrapper);

var _ExpandIconWrapper = __webpack_require__("./containers/Expandable/ExpandIconWrapper.js");

var _ExpandIconWrapper2 = _interopRequireDefault(_ExpandIconWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    componentsExpanded: (0, _selectors.componentsExpandedSelector)(state)
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    setComponentExpanded: function setComponentExpanded(expandKey, expanded) {
      return dispatch((0, _actions.setComponentExpanded)({ expandKey: expandKey, expanded: expanded }));
    }
  };
}

/*
  This is a general expand/collapse component to be applied to both
  entire widget and individual collapsible component like note (from Notes widget)
  and fault (from Diagnostics widget)
  Props:
    expandKey: If it is set, the status of component (expanded/collapsed)
      is stored in local storage and loaded when the page is refreshed.
      It is important not to use same name (you can pass this prop like sending id)
      because this name is directly used as a name to be stored in local storage
      If it is not set, expand/collapse status is managed locally in the component
      and page refresh doesn't keep the previous status (expanded originally).
    expandOnHeaderClick: If it is set to true, header is clickable and do expand/collapse
    onExpand: called when component is expanded or collapsed.
      It is used only when the component's status is controlled by outside.
*/

var Expandable = exports.Expandable = function (_Component) {
  _inherits(Expandable, _Component);

  function Expandable() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Expandable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Expandable.__proto__ || Object.getPrototypeOf(Expandable)).call.apply(_ref, [this].concat(args))), _this), _this.state = { isExpanded: true, contentExpanded: true }, _this.componentDidMount = function () {
      _this.collapseStatusChanged();
    }, _this.componentWillReceiveProps = function (nextProps) {
      if (nextProps.isExpanded !== _this.props.isExpanded) {
        _this.expandFromProps(nextProps.isExpanded);
      }
    }, _this.getHeader = function () {
      var children = _this.props.children;

      var targetComponent = _react2.default.Children.toArray(children).filter(function (c) {
        return c.type.displayName === 'ExpandableHeader';
      })[0];
      return targetComponent && targetComponent.props.children;
    }, _this.getContent = function () {
      var children = _this.props.children;

      var contentComponent = _react2.default.Children.toArray(children).filter(function (c) {
        return c.type.displayName === 'ExpandableContent';
      })[0];
      return contentComponent && contentComponent.props.children;
    }, _this.getExpanded = function () {
      var isExpanded = _this.state.isExpanded;
      var _this$props = _this.props,
          expandKey = _this$props.expandKey,
          componentsExpanded = _this$props.componentsExpanded;

      if (expandKey) {
        if (componentsExpanded.get(expandKey) !== undefined) {
          isExpanded = componentsExpanded.get(expandKey);
        }
      }
      return isExpanded;
    }, _this.expand = function () {
      var isExpanded = _this.state.isExpanded;
      var _this$props2 = _this.props,
          expandKey = _this$props2.expandKey,
          componentsExpanded = _this$props2.componentsExpanded,
          setComponentExpanded = _this$props2.setComponentExpanded,
          onExpand = _this$props2.onExpand;

      if (expandKey) {
        if (componentsExpanded.get(expandKey) === undefined) {
          onExpand(false);
          return setComponentExpanded(expandKey, false);
        }
        onExpand(!componentsExpanded.get(expandKey));
        return setComponentExpanded(expandKey, !componentsExpanded.get(expandKey));
      }
      onExpand(!isExpanded);
      return _this.setState({ isExpanded: !isExpanded });
    }, _this.expandFromProps = function (isExpanded) {
      var _this$props3 = _this.props,
          expandKey = _this$props3.expandKey,
          setComponentExpanded = _this$props3.setComponentExpanded;

      if (expandKey) {
        return setComponentExpanded(expandKey, isExpanded);
      }
      return _this.setState({ isExpanded: isExpanded });
    }, _this.collapseStatusChanged = function () {
      _this.setState({ contentExpanded: _this.getExpanded() });
    }, _this.buildExpandIcon = function () {
      var _this$props4 = _this.props,
          expandOnHeaderClick = _this$props4.expandOnHeaderClick,
          hasPopover = _this$props4.hasPopover,
          popoverMessages = _this$props4.popoverMessages;

      var isExpanded = _this.getExpanded();
      var target = _react2.default.createElement(
        _ExpandIconWrapper2.default,
        {
          className: (isExpanded ? 'expanded' : '') + ' expand-icon',
          onClick: expandOnHeaderClick ? _lodash.noop : _this.expand
        },
        _react2.default.createElement(_reactFontawesome2.default, { name: 'chevron-right' })
      );
      if (hasPopover) {
        var content = _react2.default.createElement(
          _Popover.MessagePopover,
          null,
          _react2.default.createElement(_linguiReact.Trans, { id: popoverMessages[isExpanded ? 'collapse' : 'expand'] })
        );
        return _react2.default.createElement(
          _Popover2.default,
          {
            showOnHover: true,
            position: 'right',
            noOffset: true
          },
          _react2.default.createElement(
            _Popover.PopoverTarget,
            null,
            target
          ),
          _react2.default.createElement(
            _Popover.PopoverContent,
            null,
            content
          )
        );
      }
      return target;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Expandable, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          expandOnHeaderClick = _props.expandOnHeaderClick,
          showHeaderWhenExpanded = _props.showHeaderWhenExpanded,
          hasExpandIcon = _props.hasExpandIcon;
      var contentExpanded = this.state.contentExpanded;

      var isExpanded = this.getExpanded();
      var clickable = expandOnHeaderClick && 'clickable';
      return _react2.default.createElement(
        _Wrapper2.default,
        null,
        (!isExpanded || showHeaderWhenExpanded) && _react2.default.createElement(
          _HeaderWrapper2.default,
          {
            modifiers: (0, _lodash.compact)([clickable]),
            onClick: expandOnHeaderClick ? this.expand : _lodash.noop
          },
          hasExpandIcon && this.buildExpandIcon(),
          this.getHeader()
        ),
        _react2.default.createElement(
          _OverflowWrapper2.default,
          { isExpanded: isExpanded ? contentExpanded : false },
          _react2.default.createElement(
            _reactSmoothCollapse2.default,
            { expanded: isExpanded, onChangeEnd: this.collapseStatusChanged },
            this.getContent()
          )
        )
      );
    }
  }]);

  return Expandable;
}(_react.Component);

Expandable.propTypes = {
  isExpanded: _propTypes2.default.bool,
  expandKey: _propTypes2.default.string,
  children: _propTypes2.default.node,
  setComponentExpanded: _propTypes2.default.func.isRequired,
  componentsExpanded: _reactImmutableProptypes2.default.map.isRequired,
  expandOnHeaderClick: _propTypes2.default.bool,
  onExpand: _propTypes2.default.func,
  hasPopover: _propTypes2.default.bool,
  popoverMessages: _propTypes2.default.objectOf(_propTypes2.default.string),
  showHeaderWhenExpanded: _propTypes2.default.bool,
  hasExpandIcon: _propTypes2.default.bool
};
Expandable.defaultProps = {
  isExpanded: undefined,
  expandKey: '',
  children: null,
  expandOnHeaderClick: false,
  setComponentExpanded: _lodash.noop,
  componentsExpanded: (0, _immutable.Map)(),
  onExpand: _lodash.noop,
  hasPopover: false,
  popoverMessages: {
    expand: '',
    collapse: ''
  },
  showHeaderWhenExpanded: true,
  hasExpandIcon: true
};
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Expandable);

/***/ }),

/***/ "./containers/Expandable/ExpandableContent.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function ExpandableContent() {
  return null;
}

ExpandableContent.displayName = 'ExpandableContent';

exports.default = ExpandableContent;

/***/ }),

/***/ "./containers/Expandable/ExpandableHeader.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function ExpandableHeader() {
  return null;
}

ExpandableHeader.displayName = 'ExpandableHeader';

exports.default = ExpandableHeader;

/***/ }),

/***/ "./containers/Expandable/HeaderWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  clickable: function clickable() {
    return { styles: 'cursor: pointer;' };
  }
};

/* istanbul ignore next */
var styles = function styles() {
  return '\n  align-items: center;\n  display: flex;\n  .expand-icon {\n    transition: transform 0.3s;\n    &.expanded {\n      transform: rotate(90deg);\n      visibility: hidden;\n    }\n  }\n  &:hover {\n    .expanded {\n      visibility: visible;\n    }\n  }\n';
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('HeaderWrapper', _styledComponents2.default.div, styles, { modifierConfig: modifierConfig });

/***/ }),

/***/ "./containers/Expandable/OverflowWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.expandedStyle = expandedStyle;

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function expandedStyle(_ref) {
  var isExpanded = _ref.isExpanded;

  if (isExpanded) {
    return 'overflow: visible !important;';
  }
  return '';
}

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  padding-left: ' + (0, _decisivUiUtils.px2rem)(4) + ';\n  & > div,\n  & > div > div {\n    ' + expandedStyle(props) + '\n    display: block;\n  }\n';
};

var propTypes = {
  isExpanded: _propTypes2.default.bool
};

var defaultProps = {
  isExpanded: true
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('OverflowWrapper', _styledComponents2.default.div, styles, { defaultProps: defaultProps, propTypes: propTypes });

/***/ }),

/***/ "./containers/Expandable/Wrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles() {
  return '\n  display: block;\n  position: relative;\n';
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Wrapper', _styledComponents2.default.div, styles);

/***/ }),

/***/ "./containers/Expandable/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExpandableContent = exports.ExpandableHeader = exports.default = undefined;

var _Expandable = __webpack_require__("./containers/Expandable/Expandable.js");

var _Expandable2 = _interopRequireDefault(_Expandable);

var _ExpandableHeader2 = __webpack_require__("./containers/Expandable/ExpandableHeader.js");

var _ExpandableHeader3 = _interopRequireDefault(_ExpandableHeader2);

var _ExpandableContent2 = __webpack_require__("./containers/Expandable/ExpandableContent.js");

var _ExpandableContent3 = _interopRequireDefault(_ExpandableContent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Expandable2.default;
exports.ExpandableHeader = _ExpandableHeader3.default;
exports.ExpandableContent = _ExpandableContent3.default;

/***/ }),

/***/ "./containers/QuickActionBarContainer/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SERVICE_REQUEST = exports.SERVICE_PROVIDER = exports.NOTES = exports.LOCATION = exports.ESTIMATE_INVOICE_PENDING = exports.ESTIMATE_INVOICE_DECIDED = exports.DIAGNOSTICS = exports.COMPLAINT = exports.CASE_STATUS = exports.ASSET = exports.OPTIONS = exports.JUMP_TO = exports.ADD_NOTE = undefined;

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _oldIEVersion = __webpack_require__("./utils/oldIEVersion.js");

var _oldIEVersion2 = _interopRequireDefault(_oldIEVersion);

var _messages = __webpack_require__("./containers/QuickActionBarContainer/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// actionbar item ids
var ADD_NOTE = exports.ADD_NOTE = 'ADD_NOTE';
var JUMP_TO = exports.JUMP_TO = 'JUMP_TO';
var OPTIONS = exports.OPTIONS = 'OPTIONS_BUTTON';

// react-scroll anchor names
var ASSET = exports.ASSET = 'ASSET';
var CASE_STATUS = exports.CASE_STATUS = 'CASE_STATUS';
var COMPLAINT = exports.COMPLAINT = 'COMPLAINT';
var DIAGNOSTICS = exports.DIAGNOSTICS = 'DIAGNOSTICS';
var ESTIMATE_INVOICE_DECIDED = exports.ESTIMATE_INVOICE_DECIDED = 'ESTIMATE_INVOICE_DECIDED';
var ESTIMATE_INVOICE_PENDING = exports.ESTIMATE_INVOICE_PENDING = 'ESTIMATE_INVOICE_PENDING';
var LOCATION = exports.LOCATION = 'LOCATION';
var NOTES = exports.NOTES = 'NOTES';
var SERVICE_PROVIDER = exports.SERVICE_PROVIDER = 'SERVICE_PROVIDER';
var SERVICE_REQUEST = exports.SERVICE_REQUEST = 'SERVICE_REQUEST';

var QUICK_ACTION_ITEMS = {
  ASSET_PAGE: {
    LEFT_ITEMS: [
    // In alpha version we don't have addContact.
    // {
    //   id: 'addContact',
    //   icon: 'user-plus',
    //   label: messages.addContact,
    // },
    {
      id: 'requestService',
      icon: 'wrench',
      label: _messages2.default.requestService
    }],
    RIGHT_ITEMS: [{
      id: OPTIONS,
      icon: 'caret-down',
      label: _messages2.default.options,
      options: (0, _lodash.compact)([{
        id: 'printPage',
        label: _messages2.default.printPage
      }, !(0, _oldIEVersion2.default)() && {
        id: 'viewInFullScreenMode',
        label: _messages2.default.viewInFullScreenMode
      }])
    }]
  },

  CASE_PAGE: {
    LEFT_ITEMS: [{
      id: ADD_NOTE,
      icon: 'envelope-o',
      label: _messages2.default.addNote
    }],
    RIGHT_ITEMS: [{
      id: JUMP_TO,
      icon: 'caret-down',
      iconPressed: 'caret-up',
      label: _messages2.default.jumpTo,
      options: [{
        id: CASE_STATUS,
        label: _messages2.default.caseStatus
      }, {
        id: ASSET,
        label: _messages2.default.asset
      }, {
        id: NOTES,
        label: _messages2.default.notes
      }, {
        id: SERVICE_PROVIDER,
        label: _messages2.default.serviceProvider
      }, {
        id: COMPLAINT,
        label: _messages2.default.complaint
      }, {
        id: SERVICE_REQUEST,
        label: _messages2.default.serviceRequest
      }, {
        id: DIAGNOSTICS,
        label: _messages2.default.diagnostics
      }, {
        id: LOCATION,
        label: _messages2.default.location
      }, {
        id: ESTIMATE_INVOICE_DECIDED,
        label: _messages2.default.estimateInvoiceDecided
      }, {
        id: ESTIMATE_INVOICE_PENDING,
        label: _messages2.default.estimateInvoicePending
      }]
    }, {
      id: OPTIONS,
      icon: 'caret-down',
      iconPressed: 'caret-up',
      label: _messages2.default.options,
      options: (0, _lodash.compact)([{
        id: 'printPage',
        label: _messages2.default.printPage
      }, !(0, _oldIEVersion2.default)() && {
        id: 'viewInFullScreenMode',
        label: _messages2.default.viewInFullScreenMode
      }])
    }]
  },

  CASES_PAGE: {
    LEFT_ITEMS: [{
      id: ADD_NOTE,
      icon: 'envelope-o',
      label: _messages2.default.addNote
    }],
    RIGHT_ITEMS: []
  }
};

exports.default = QUICK_ACTION_ITEMS;

/***/ }),

/***/ "./containers/QuickActionBarContainer/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuickActionBarContainer = QuickActionBarContainer;

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _actions = __webpack_require__("./redux/ui/actions.js");

var _QuickActionBar = __webpack_require__("./components/QuickActionBar/index.js");

var _QuickActionBar2 = _interopRequireDefault(_QuickActionBar);

var _constants = __webpack_require__("./containers/QuickActionBarContainer/constants.js");

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function QuickActionBarContainer(_ref) {
  var pageTitle = _ref.pageTitle,
      handleActionBarItem = _ref.handleActionBarItem,
      disabled = _ref.disabled;

  return _react2.default.createElement(_QuickActionBar2.default, {
    items: _constants2.default[pageTitle],
    onItemClicked: handleActionBarItem,
    disabled: disabled
  });
}

QuickActionBarContainer.propTypes = {
  pageTitle: _propTypes2.default.string.isRequired,
  handleActionBarItem: _propTypes2.default.func.isRequired,
  disabled: _propTypes2.default.shape()
};

QuickActionBarContainer.defaultProps = {
  disabled: {}
};

function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    handleActionBarItem: function handleActionBarItem(payload) {
      return dispatch((0, _actions.handleActionBarItemClick)(payload));
    }
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(QuickActionBarContainer);

/***/ }),

/***/ "./containers/QuickActionBarContainer/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  addNote: (0, _linguiReact.i18nMark)('Add Note'),
  asset: (0, _linguiReact.i18nMark)('Asset'),
  caseStatus: (0, _linguiReact.i18nMark)('Case Status'),
  complaint: (0, _linguiReact.i18nMark)('Complaint'),
  diagnostics: (0, _linguiReact.i18nMark)('Diagnostics'),
  estimateInvoiceDecided: (0, _linguiReact.i18nMark)('Estimate/Invoice'),
  estimateInvoicePending: (0, _linguiReact.i18nMark)('Estimate/Invoice'),
  jumpTo: (0, _linguiReact.i18nMark)('Jump To...'),
  location: (0, _linguiReact.i18nMark)('Location'),
  notes: (0, _linguiReact.i18nMark)('Notes'),
  options: (0, _linguiReact.i18nMark)('Options'),
  printPage: (0, _linguiReact.i18nMark)('Print Page'),
  requestService: (0, _linguiReact.i18nMark)('Request Service'),
  serviceProvider: (0, _linguiReact.i18nMark)('Service Provider'),
  serviceRequest: (0, _linguiReact.i18nMark)('Service Request'),
  viewInFullScreenMode: (0, _linguiReact.i18nMark)('View In Full-Screen Mode')
  // In alpha version we don't have assignCase, addAttachment, and setFollowup.
  // addAttachment: i18nMark('Add Attachment'),
  // assignCase: i18nMark('Assign Case'),
  // setFollowUp: i18nMark('Set Follow Up'),
};

exports.default = messages;

/***/ }),

/***/ "./containers/SearchContainer/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SEARCH_OPTIONS = undefined;

var _messages = __webpack_require__("./containers/SearchContainer/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line import/prefer-default-export
var SEARCH_OPTIONS = exports.SEARCH_OPTIONS = [{
  default: true,
  id: 'unitNumber',
  label: _messages2.default.unitNumber,
  params: {
    searchParam: 'unit_no'
  }
}, {
  id: 'vin',
  label: _messages2.default.vin,
  params: {
    searchParam: 'vin'
  }
}];

/***/ }),

/***/ "./containers/SearchContainer/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchContainer = exports.SEARCH_RESULT_COUNT_PER_PAGE = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _reactRouter = __webpack_require__("../node_modules/react-router/es/index.js");

var _actions = __webpack_require__("./redux/app/actions.js");

var _actions2 = __webpack_require__("./redux/cases/actions.js");

var _constants = __webpack_require__("./redux/constants.js");

var _combinedSelectors = __webpack_require__("./redux/combinedSelectors.js");

var _url = __webpack_require__("./utils/url.js");

var _Search = __webpack_require__("./components/Search/index.js");

var _Search2 = _interopRequireDefault(_Search);

var _constants2 = __webpack_require__("./containers/SearchContainer/constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SEARCH_RESULT_COUNT_PER_PAGE = exports.SEARCH_RESULT_COUNT_PER_PAGE = 20;

/**
 * The SearchContainer is a smart component that controls the global search bar within the TopNav.
 * Responsibilities include:
 *   - Holding and manipulating search based state in a single location.
 *   - Displaying, hiding, and selecting a search options (unit number, vin, etc...)
 *   - Determining which search option to apply to the search (unit number, vin, etc...)
 *   - Parsing through search suggestion results to find matches.
 *   - Dispatching actions that trigger the actual the searches.
 */

var SearchContainer = exports.SearchContainer = function (_Component) {
  _inherits(SearchContainer, _Component);

  function SearchContainer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SearchContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SearchContainer.__proto__ || Object.getPrototypeOf(SearchContainer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      // Controls whether the "search options" dropdown menu is displayed.
      displaySearchOptions: false,

      // Controls whether the search input is displayed
      expanded: false,

      // The filtered list of suggestions. This is what will be displayed as suggestion options.
      searchSuggestions: [],

      // The selected search option, or the default search option.
      selectedSearchOption: _this.props.searchOptions.find(function (option) {
        return option.default;
      }),

      searchValue: ''
    }, _this.onOutsideClick = function () {
      _this.setState({ expanded: false });
    }, _this.getSearchSuggestions = function () /* { value } */{}
    // TODO: Implement type ahead search suggestions.
    // Call the api. Get the search suggestions based on the input value.
    // Process the results from the api into the results that will be suggested to the user.
    // Save the search suggestions to `this.state.searchSuggestions`


    /**
     * Handles resetting the type ahead suggestions to an empty array.
     */
    , _this.clearSearchSuggestions = function () {}
    // this.setState({ searchSuggestions: [] });


    /**
     * Event handler for selecting a new search option.
     * @param  {Event} event         A DOM event, typically a click.
     * @param  {Object} searchOption The selected search option.
     */
    , _this.handleSearchOptionSelect = function (event, searchOption) {
      event.preventDefault();
      _this.setState({
        displaySearchOptions: false,
        selectedSearchOption: searchOption
      });
    }, _this.handleSearchValueChange = function (event, _ref2) {
      var newValue = _ref2.newValue;

      _this.setState({ searchValue: newValue });
    }, _this.performSearch = function () {
      var _this$state = _this.state,
          searchValue = _this$state.searchValue,
          selectedSearchOption = _this$state.selectedSearchOption;
      var searchParam = selectedSearchOption.params.searchParam;

      if (searchValue && searchValue.length > _constants.MIN_CHAR_SEARCH) {
        _this.toggleSearchExpanded({ expanded: false });
        _this.props.clearCases();
        _this.props.performSearch({
          searchOption: selectedSearchOption.params,
          searchValue: searchValue,
          per_page: SEARCH_RESULT_COUNT_PER_PAGE
        });

        // Active tab defaults to Cases
        _this.props.history.push('/search?by=' + searchParam + '&value=' + searchValue + '&active=cases');
      }
    }, _this.performSearchFromQueryParams = function (params) {
      var searchValue = params.value;
      if (searchValue && searchValue.length > 0) {
        _this.props.performSearch({
          searchOption: {
            searchParam: params.by
          },
          searchValue: params.value,
          per_page: SEARCH_RESULT_COUNT_PER_PAGE
        });
      }
    }, _this.toggleDisplaySearchOptions = function () {
      _this.setState({
        displaySearchOptions: !_this.state.displaySearchOptions
      });
    }, _this.toggleSearchExpanded = function () {
      _this.setState({
        expanded: !_this.state.expanded
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SearchContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var location = this.props.location;

      var params = (0, _url.parseQueryParams)(location.search);
      this.performSearchFromQueryParams(params);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var location = nextProps.location,
          noAssetsCases = nextProps.noAssetsCases,
          requesting = nextProps.requesting;


      if (location.pathname !== '/search') {
        this.setState({ searchValue: '' }); // Remove search value on route redirection
      } else if (!requesting) {
        if (noAssetsCases) {
          this.setState({ expanded: true });
        } else {
          this.setState({
            expanded: false,
            searchValue: ''
          });
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.clearCases();
    }

    /**
     * Handles click events outside of the search component.
     */


    /**
     * Handles calling the api, processing results, and saving the type ahead search suggestions.
     */


    /**
     * Handles performing the full search from the user's input.
     */


    /**
     * Handles performing the search from query params
     */


    /**
     * Handles toggling the display of the search options dropdown.
     */


    /**
     * Handles toggling of the search bar's expanded state.
    */

  }, {
    key: 'render',
    value: function render() {
      var searchOptions = this.props.searchOptions;
      var _state = this.state,
          displaySearchOptions = _state.displaySearchOptions,
          expanded = _state.expanded,
          searchSuggestions = _state.searchSuggestions,
          selectedSearchOption = _state.selectedSearchOption,
          searchValue = _state.searchValue;


      return _react2.default.createElement(_Search2.default, {
        displaySearchOptions: displaySearchOptions,
        expanded: expanded,
        getSearchSuggestions: this.getSearchSuggestions,
        clearSearchSuggestions: this.clearSearchSuggestions,
        handleSearchOptionSelect: this.handleSearchOptionSelect,
        handleSearchValueChange: this.handleSearchValueChange,
        performSearch: this.performSearch,
        searchOptions: searchOptions,
        searchSuggestions: searchSuggestions,
        searchValue: searchValue,
        selectedSearchOption: selectedSearchOption,
        toggleDisplaySearchOptions: this.toggleDisplaySearchOptions,
        toggleSearchExpanded: this.toggleSearchExpanded,
        onOutsideClick: this.onOutsideClick
      });
    }
  }]);

  return SearchContainer;
}(_react.Component);

SearchContainer.propTypes = {
  // clearCases is used to remove all cases, assets, and other data
  // (including favorites pagination data) currently held in state.
  clearCases: _propTypes2.default.func.isRequired,

  // history is provided by the HOC withRouter, and allows us to change routes
  // without rendering a redirect component.
  history: _propTypes2.default.shape({
    push: _propTypes2.default.func.isRequired
  }).isRequired,

  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string.isRequired
  }).isRequired,
  noAssetsCases: _propTypes2.default.bool,

  // dispatches an action triggering the search requests to be made.
  performSearch: _propTypes2.default.func.isRequired,

  requesting: _propTypes2.default.bool,

  // These are the filters that narrow the scope of where we are searching,
  // unit number, vin, etc...
  searchOptions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired,
    params: _propTypes2.default.shape({
      searchParam: _propTypes2.default.string.isRequired
    }).isRequired,
    label: _propTypes2.default.string.isRequired
  }))

  // // TODO: This is an example of how to setup typeahead search suggestions.
  // // These are the results from the api request to get the type ahead search suggestions.
  // suggestionResults: PropTypes.arrayOf(
  //   PropTypes.shape({
  //     id: PropTypes.string.isRequired,
  //     type: PropTypes.string.isRequired,
  //   }),
  // ),
};
SearchContainer.defaultProps = {
  noAssetsCases: false,
  requesting: false,

  // Supply the "search options" via props. This increases our ability to expand on this later.
  searchOptions: _constants2.SEARCH_OPTIONS
};


function mapStateToProps(state) {
  return {
    requesting: (0, _combinedSelectors.requestingSelector)(state),
    noAssetsCases: (0, _combinedSelectors.noAssetsCasesSelector)(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    clearCases: function clearCases() {
      return dispatch((0, _actions2.clearCases)());
    },
    performSearch: function performSearch(params) {
      return dispatch((0, _actions.performSearch)(params));
    }
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactRouter.withRouter)(SearchContainer));

/***/ }),

/***/ "./containers/SearchContainer/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var formattedMessages = {
  unitNumber: (0, _linguiReact.i18nMark)('Unit Number'),
  vin: (0, _linguiReact.i18nMark)('VIN')
};

exports.default = formattedMessages;

/***/ }),

/***/ "./containers/SearchResultsPage/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TAB_LABELS = undefined;

var _messages = __webpack_require__("./containers/SearchResultsPage/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line import/prefer-default-export
var TAB_LABELS = exports.TAB_LABELS = [{ name: 'cases', message: _messages2.default.tabTitleCases }, { name: 'assets', message: _messages2.default.tabTitleAssets }];

/***/ }),

/***/ "./containers/SearchResultsPage/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchResultsPage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = __webpack_require__("../node_modules/react-helmet/lib/Helmet.js");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactImmutableProptypes = __webpack_require__("../node_modules/react-immutable-proptypes/dist/ImmutablePropTypes.js");

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _url = __webpack_require__("./utils/url.js");

var _SearchResultsPanel = __webpack_require__("./components/SearchResultsPanel/index.js");

var _SearchResultsPanel2 = _interopRequireDefault(_SearchResultsPanel);

var _Divider = __webpack_require__("./elements/Divider/index.js");

var _Divider2 = _interopRequireDefault(_Divider);

var _Page = __webpack_require__("./elements/Page/index.js");

var _Page2 = _interopRequireDefault(_Page);

var _PageHeadingPanel = __webpack_require__("./elements/PageHeadingPanel/index.js");

var _PageHeadingPanel2 = _interopRequireDefault(_PageHeadingPanel);

var _PageHeadingTitle = __webpack_require__("./elements/PageHeadingTitle/index.js");

var _PageHeadingTitle2 = _interopRequireDefault(_PageHeadingTitle);

var _actions = __webpack_require__("./redux/app/actions.js");

var _selectors = __webpack_require__("./redux/app/selectors.js");

var _actions2 = __webpack_require__("./redux/assets/actions.js");

var _selectors2 = __webpack_require__("./redux/assets/selectors.js");

var _actions3 = __webpack_require__("./redux/cases/actions.js");

var _selectors3 = __webpack_require__("./redux/cases/selectors.js");

var _combinedSelectors = __webpack_require__("./redux/combinedSelectors.js");

var _favorites = __webpack_require__("./utils/favorites.js");

var _constants = __webpack_require__("./containers/SearchResultsPage/constants.js");

var _messages = __webpack_require__("./containers/SearchResultsPage/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchResultsPage = exports.SearchResultsPage = function (_Component) {
  _inherits(SearchResultsPage, _Component);

  function SearchResultsPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SearchResultsPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SearchResultsPage.__proto__ || Object.getPrototypeOf(SearchResultsPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      currentTab: '',
      tabs: []
    }, _this.buildContent = function (props) {
      var tabs = _this.buildTabs(props);
      var currentTab = _this.selectCurrentTab(tabs, props);
      _this.setState({ currentTab: currentTab, tabs: tabs });
    }, _this.buildTabs = function (nextProps) {
      var tabLabels = nextProps.tabLabels,
          searchPagination = nextProps.searchPagination;


      var filtered = searchPagination.filter(function (tabData) {
        return Number(tabData.get('totalCount')) > 0;
      });

      var processed = filtered.map(function (tabData, tabName) {
        var label = (0, _lodash.find)(tabLabels, function (l) {
          return l.name === tabName;
        });
        return {
          name: tabName,
          label: _react2.default.createElement(_linguiReact.Trans, { id: label.message, values: { count: tabData.get('totalCount') } })
        };
      });

      return processed.toList().toJS();
    }, _this.handleTabChange = function (tabName) {
      var _this$props = _this.props,
          search = _this$props.location.search,
          history = _this$props.history;

      var params = (0, _url.parseQueryParams)(search);
      history.replace('/search?by=' + params.by + '&value=' + params.value + '&active=' + tabName);
    }, _this.loadSearchParams = function () {
      var searchParams = _this.props.searchParams;
      if ((0, _lodash.isEmpty)(searchParams)) {
        // should build it from URL
        var queryParams = _this.props.location.search;

        var params = (0, _url.parseQueryParams)(queryParams);
        searchParams = {
          searchOption: {
            searchParam: params.by
          },
          searchValue: params.value,
          per_page: 20
        };
      }
      return searchParams;
    }, _this.selectCurrentTab = function (tabs, props) {
      var location = props.location;

      var params = location.search && (0, _url.parseQueryParams)(location.search);
      if (tabs && tabs.length) {
        if (params && params.active) {
          if (tabs.some(function (tab) {
            return tab.name === params.active;
          })) {
            return params.active;
          }
        }
        return tabs[0].name; // Tab does not include a tab named as "active" query param
      }
      return ''; // No tabs are avaialble
    }, _this.refresh = function () {
      if (_this.props.searchParams.searchValue) {
        _this.setState({ currentTab: '' });
        _this.props.clearCases();
        _this.props.performSearch(_this.props.searchParams);
      }
    }, _this.requestNextData = function (favoritePagination, loadAction) {
      var _this$props$searchPar = _this.props.searchParams,
          searchOption = _this$props$searchPar.searchOption,
          searchValue = _this$props$searchPar.searchValue;

      var latestPage = parseInt(favoritePagination.get('latestPage'), 10);
      var nextPage = latestPage + 1;

      (0, _favorites.loadFavorite)({
        page: nextPage,
        favorite: {
          params: _defineProperty({}, searchOption.searchParam, searchValue)
        },
        loadAction: loadAction
      });
    }, _this.requestNextCases = function (favoritePagination) {
      _this.requestNextData(favoritePagination, _this.props.loadCases);
    }, _this.requestNextAssets = function (favoritePagination) {
      _this.requestNextData(favoritePagination, _this.props.loadAssets);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SearchResultsPage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.cases.size || this.props.assets.size) {
        // The cases/assets are already loaded, so just show them
        this.buildContent(this.props);
      } else {
        var searchParams = this.loadSearchParams();
        this.props.performSearch(searchParams);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.assets !== this.props.assets || nextProps.cases !== this.props.cases) {
        this.buildContent(nextProps);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          assets = _props.assets,
          cases = _props.cases,
          i18n = _props.i18n,
          noSearchResult = _props.noSearchResult,
          requesting = _props.requesting,
          searchPagination = _props.searchPagination;

      var _loadSearchParams = this.loadSearchParams(),
          searchValue = _loadSearchParams.searchValue;

      return _react2.default.createElement(
        _Page2.default,
        { name: 'search-results-page' },
        _react2.default.createElement(_reactHelmet2.default, {
          title: i18n._(_messages2.default.title),
          meta: [{ name: 'description', content: i18n._(_messages2.default.description) }]
        }),
        _react2.default.createElement(
          _PageHeadingPanel2.default,
          null,
          _react2.default.createElement(
            _PageHeadingTitle2.default,
            null,
            noSearchResult ? _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.pageTitleNoResult }) : _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.pageTitle, values: { searchValue: searchValue } })
          ),
          _react2.default.createElement(_Divider2.default, null)
        ),
        _react2.default.createElement(_SearchResultsPanel2.default, {
          assets: assets,
          cases: cases,
          currentTab: this.state.currentTab,
          handleTabChange: this.handleTabChange,
          refresh: this.refresh,
          requesting: requesting,
          searchValue: searchValue,
          tabs: this.state.tabs,
          requestNextCases: this.requestNextCases,
          requestNextAssets: this.requestNextAssets,
          searchPagination: searchPagination
        })
      );
    }
  }]);

  return SearchResultsPage;
}(_react.Component);

/* istanbul ignore next */


SearchResultsPage.propTypes = {
  assets: _reactImmutableProptypes2.default.listOf(_reactImmutableProptypes2.default.mapContains({
    id: _propTypes2.default.string
  })).isRequired,
  cases: _reactImmutableProptypes2.default.listOf(_reactImmutableProptypes2.default.mapContains({
    id: _propTypes2.default.string
  })).isRequired,

  // clearCases is used to remove all cases, assets, and other data
  // (including favorites pagination data) currently held in state.
  clearCases: _propTypes2.default.func.isRequired,

  history: _propTypes2.default.shape({
    replace: _propTypes2.default.func.isRequired
  }).isRequired,
  i18n: _propTypes2.default.shape({
    _: _propTypes2.default.func.isRequired
  }).isRequired,
  location: _propTypes2.default.shape({
    search: _propTypes2.default.string.isRequired
  }).isRequired,
  noSearchResult: _propTypes2.default.bool,
  performSearch: _propTypes2.default.func.isRequired,
  requesting: _propTypes2.default.bool,
  searchParams: _propTypes2.default.shape({
    searchOption: _propTypes2.default.shape({
      searchParam: _propTypes2.default.string
    }),
    searchValue: _propTypes2.default.string
  }).isRequired,
  tabLabels: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    name: _propTypes2.default.string.isRequired,
    message: _propTypes2.default.string.isRequired
  }).isRequired).isRequired,
  searchPagination: _reactImmutableProptypes2.default.mapContains({
    cases: _reactImmutableProptypes2.default.map.isRequired,
    assets: _reactImmutableProptypes2.default.map.isRequired
  }).isRequired,
  loadCases: _propTypes2.default.func.isRequired,
  loadAssets: _propTypes2.default.func.isRequired
};
SearchResultsPage.defaultProps = {
  noSearchResult: false,
  requesting: false,
  tabLabels: _constants.TAB_LABELS
};
function mapStateToProps(state) {
  return {
    assets: (0, _selectors2.assetsSelector)(state),
    cases: (0, _selectors3.casesSelector)(state),
    requesting: (0, _combinedSelectors.requestingSelector)(state),
    noSearchResult: (0, _combinedSelectors.noAssetsCasesFoundSelector)(state),
    searchParams: (0, _selectors.searchParamsSelector)(state),
    searchPagination: (0, _selectors.searchPaginationSelector)(state)
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    performSearch: function performSearch(params) {
      return dispatch((0, _actions.performSearch)(params));
    },
    loadCases: function loadCases(filter) {
      return dispatch((0, _actions3.loadCases)(filter));
    },
    clearCases: function clearCases() {
      return dispatch((0, _actions3.clearCases)());
    },
    loadAssets: function loadAssets(filter) {
      return dispatch((0, _actions2.loadAssets)(filter));
    }
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _linguiReact.withI18n)()(SearchResultsPage));

/***/ }),

/***/ "./containers/SearchResultsPage/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  description: (0, _linguiReact.i18nMark)('The search results page of the application'),
  title: (0, _linguiReact.i18nMark)('The Search Results Page'),
  pageTitle: (0, _linguiReact.i18nMark)('Search Results: {searchValue}'),
  pageTitleNoResult: (0, _linguiReact.i18nMark)('Search Results'),
  tabTitleAssets: (0, _linguiReact.i18nMark)('Assets ({count})'),
  tabTitleCases: (0, _linguiReact.i18nMark)('Cases ({count})')
};

exports.default = messages;

/***/ }),

/***/ "./containers/ServiceRequestCreatePage/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ServiceRequestCreatePage = ServiceRequestCreatePage;

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactHelmet = __webpack_require__("../node_modules/react-helmet/lib/Helmet.js");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _Page = __webpack_require__("./elements/Page/index.js");

var _Page2 = _interopRequireDefault(_Page);

var _WizardController = __webpack_require__("./containers/WizardController/index.js");

var _WizardController2 = _interopRequireDefault(_WizardController);

var _messages = __webpack_require__("./containers/ServiceRequestCreatePage/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ServiceRequestCreatePage(_ref) {
  var i18n = _ref.i18n;

  return _react2.default.createElement(
    _Page2.default,
    { name: 'service-request-wizard-page' },
    _react2.default.createElement(_reactHelmet2.default, {
      title: i18n._(_messages2.default.title),
      meta: [{ name: 'description', content: i18n._(_messages2.default.description) }]
    }),
    _react2.default.createElement(_WizardController2.default, { configKey: 'SERVICE_REQUEST_WIZARD' })
  );
}

ServiceRequestCreatePage.propTypes = {
  i18n: _propTypes2.default.shape({
    _: _propTypes2.default.func.isRequired
  }).isRequired
};

exports.default = (0, _linguiReact.withI18n)()(ServiceRequestCreatePage);

/***/ }),

/***/ "./containers/ServiceRequestCreatePage/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  description: (0, _linguiReact.i18nMark)('Service Request Wizard'),
  title: (0, _linguiReact.i18nMark)('Service Request Wizard')
};

exports.default = messages;

/***/ }),

/***/ "./containers/ServiceRequestDetailData/Component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = __webpack_require__("../node_modules/react-helmet/lib/Helmet.js");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _NotFoundPage = __webpack_require__("./components/NotFoundPage/index.js");

var _NotFoundPage2 = _interopRequireDefault(_NotFoundPage);

var _messages = __webpack_require__("./containers/ServiceRequestDetailData/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ServiceRequestDetailData = function (_Component) {
  _inherits(ServiceRequestDetailData, _Component);

  function ServiceRequestDetailData() {
    _classCallCheck(this, ServiceRequestDetailData);

    return _possibleConstructorReturn(this, (ServiceRequestDetailData.__proto__ || Object.getPrototypeOf(ServiceRequestDetailData)).apply(this, arguments));
  }

  _createClass(ServiceRequestDetailData, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var serviceRequestId = this.props.match.params.serviceRequestId;

      this.props.setCurrentServiceRequest(serviceRequestId);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          addPageToBreadcrumbs = _props.addPageToBreadcrumbs,
          loadServiceRequest = _props.loadServiceRequest,
          location = _props.location,
          serviceRequestId = _props.match.params.serviceRequestId,
          setLoadingStarted = _props.setLoadingStarted;


      addPageToBreadcrumbs({
        path: location.pathname,
        message: _messages2.default.breadcrumbs,
        number: serviceRequestId
      });
      loadServiceRequest(serviceRequestId);
      setLoadingStarted();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props2 = this.props,
          addPageToBreadcrumbs = _props2.addPageToBreadcrumbs,
          loadServiceRequest = _props2.loadServiceRequest,
          location = _props2.location,
          serviceRequestId = _props2.match.params.serviceRequestId,
          setLoadingStarted = _props2.setLoadingStarted;

      var nextServiceRequestId = nextProps.match.params.serviceRequestId;

      if (serviceRequestId !== nextServiceRequestId) {
        addPageToBreadcrumbs({
          path: location.pathname,
          message: _messages2.default.breadcrumbs,
          number: nextServiceRequestId
        });
        loadServiceRequest(nextServiceRequestId);
        setLoadingStarted();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.setCurrentServiceRequest();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          ChildComponent = _props3.ChildComponent,
          i18n = _props3.i18n,
          serviceRequestError = _props3.serviceRequestError;


      if (serviceRequestError) {
        return _react2.default.createElement(_NotFoundPage2.default, null);
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_reactHelmet2.default, {
          title: i18n._(_messages2.default.title),
          meta: [{ name: 'description', content: i18n._(_messages2.default.description) }]
        }),
        _react2.default.createElement(ChildComponent, this.props.componentProps)
      );
    }
  }]);

  return ServiceRequestDetailData;
}(_react.Component);

ServiceRequestDetailData.propTypes = {
  addPageToBreadcrumbs: _propTypes2.default.func.isRequired,
  ChildComponent: _propTypes2.default.func.isRequired,
  // This component doesn't care what is in componentProps, only that it is an object.
  // eslint-disable-next-line react/forbid-prop-types
  componentProps: _propTypes2.default.object.isRequired,
  i18n: _propTypes2.default.shape({
    _: _propTypes2.default.func.isRequired
  }).isRequired,
  loadServiceRequest: _propTypes2.default.func.isRequired,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string.isRequired
  }).isRequired,
  match: _propTypes2.default.shape({
    params: _propTypes2.default.shape({
      serviceRequestId: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired,
  serviceRequestError: _propTypes2.default.shape({
    error: _propTypes2.default.oneOf([true]).isRequired
  }),
  serviceRequestInfo: _propTypes2.default.shape({
    id: _propTypes2.default.string
  }).isRequired,
  setCurrentServiceRequest: _propTypes2.default.func.isRequired,
  setLoadingStarted: _propTypes2.default.func.isRequired
};
ServiceRequestDetailData.defaultProps = {
  serviceRequestError: undefined
};
exports.default = ServiceRequestDetailData;

/***/ }),

/***/ "./containers/ServiceRequestDetailData/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _reactRouterDom = __webpack_require__("../node_modules/react-router-dom/es/index.js");

var _actions = __webpack_require__("./redux/app/actions.js");

var _actions2 = __webpack_require__("./redux/serviceRequests/actions.js");

var _selectors = __webpack_require__("./redux/serviceRequests/selectors.js");

var _immutableToJS = __webpack_require__("./utils/immutableToJS.js");

var _immutableToJS2 = _interopRequireDefault(_immutableToJS);

var _Component = __webpack_require__("./containers/ServiceRequestDetailData/Component.js");

var _Component2 = _interopRequireDefault(_Component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * `withServiceRequestDetailData` is an HOC used to map data from state down to the Component that
 * handles logic for setting page level details for service requests. The typical pattern for HOC's
 * is to include the logic component within the HOC and return it directly. Although there is
 * nothing wrong with this pattern, it makes testing the logic nearly impossible. Extracting the
 * logic from the data mapping allows simple testing of the logic.
 * @param  {Component} DetailsPage the details page component being rendered
 */
/* istanbul ignore next */
var withServiceRequestDetailData = function withServiceRequestDetailData(DetailsPage) {
  function WithServiceRequestDetailData(props) {
    return _react2.default.createElement(_Component2.default, _extends({}, props, { ChildComponent: DetailsPage }));
  }

  WithServiceRequestDetailData.propTypes = {
    addPageToBreadcrumbs: _propTypes2.default.func.isRequired,
    // This component doesn't care what is in componentProps, only that it is an object.
    // eslint-disable-next-line react/forbid-prop-types
    componentProps: _propTypes2.default.object.isRequired,
    i18n: _propTypes2.default.shape({
      _: _propTypes2.default.func.isRequired
    }).isRequired,
    loadServiceRequest: _propTypes2.default.func.isRequired,
    location: _propTypes2.default.shape({
      pathname: _propTypes2.default.string.isRequired
    }).isRequired,
    match: _propTypes2.default.shape({
      params: _propTypes2.default.shape({
        serviceRequestId: _propTypes2.default.string.isRequired
      }).isRequired
    }).isRequired,
    serviceRequestError: _propTypes2.default.shape({
      error: _propTypes2.default.oneOf([true]).isRequired
    }),
    serviceRequestInfo: _propTypes2.default.shape({
      id: _propTypes2.default.string
    }).isRequired,
    setCurrentServiceRequest: _propTypes2.default.func.isRequired,
    setLoadingStarted: _propTypes2.default.func.isRequired
  };

  WithServiceRequestDetailData.defaultProps = {
    serviceRequestError: undefined
  };

  function mapStateToProps(state) {
    return {
      serviceRequestError: (0, _selectors.loadServiceRequestErrorSelector)(state),
      serviceRequestInfo: (0, _selectors.currentServiceRequestSelector)(state)
    };
  }

  function mapDispatchToProps(dispatch) {
    return {
      addPageToBreadcrumbs: function addPageToBreadcrumbs(breadcrumbs) {
        return dispatch((0, _actions.addPageToBreadcrumbs)(breadcrumbs));
      },
      loadServiceRequest: function loadServiceRequest(serviceRequestId) {
        return dispatch((0, _actions2.loadServiceRequest)({ serviceRequestId: serviceRequestId }));
      },
      setCurrentServiceRequest: function setCurrentServiceRequest(serviceRequestId) {
        return dispatch((0, _actions2.setCurrentServiceRequest)(serviceRequestId));
      },
      setLoadingStarted: function setLoadingStarted() {
        return dispatch((0, _actions.setLoadingStarted)(true));
      }
    };
  }

  return (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _linguiReact.withI18n)()((0, _immutableToJS2.default)(WithServiceRequestDetailData))));
};

exports.default = withServiceRequestDetailData;

/***/ }),

/***/ "./containers/ServiceRequestDetailData/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  breadcrumbs: (0, _linguiReact.i18nMark)('Request {number}'),
  description: (0, _linguiReact.i18nMark)('The Service Request Detail page of the application'),
  title: (0, _linguiReact.i18nMark)('The Service Request Detail Page')
};

exports.default = messages;

/***/ }),

/***/ "./containers/ServiceRequestDisplayContainer/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ServiceRequestDisplayContainer = ServiceRequestDisplayContainer;

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactiveContainer = __webpack_require__("../node_modules/reactive-container/dist/index.js");

var _reactImmutableProptypes = __webpack_require__("../node_modules/react-immutable-proptypes/dist/ImmutablePropTypes.js");

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _ServiceRequestDisplayElement = __webpack_require__("./components/ServiceRequestDisplayElement/index.js");

var _Card = __webpack_require__("./elements/Card/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function ServiceRequestDisplayContainer(_ref) {
  var _ref2;

  var datum = _ref.datum,
      type = _ref.type;

  switch (type) {
    case 'list':
      return null;
    case 'card':
    default:
      return _react2.default.createElement(
        _Card.CardWrapper,
        {
          responsiveModifiers: (_ref2 = {}, _defineProperty(_ref2, _reactiveContainer.sizes.XS, ['1_per_row']), _defineProperty(_ref2, _reactiveContainer.sizes.SM, ['2_per_row']), _defineProperty(_ref2, _reactiveContainer.sizes.MD, ['3_per_row']), _defineProperty(_ref2, _reactiveContainer.sizes.LG, ['4_per_row']), _defineProperty(_ref2, _reactiveContainer.sizes.XL, ['5_per_row']), _ref2)
        },
        _react2.default.createElement(_ServiceRequestDisplayElement.ServiceRequestCard, {
          serviceRequestInfo: datum
        })
      );
  }
}

ServiceRequestDisplayContainer.propTypes = {
  datum: _reactImmutableProptypes2.default.contains({
    id: _propTypes2.default.string
  }).isRequired,
  type: _propTypes2.default.oneOf(['card', 'list', 'map']).isRequired
};

ServiceRequestDisplayContainer.defaultProps = {
  selectedServiceRequestId: ''
};

exports.default = ServiceRequestDisplayContainer;

/***/ }),

/***/ "./containers/ServiceRequestWizardController/Container.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _recompose = __webpack_require__("../node_modules/recompose/es/Recompose.js");

var _actions = __webpack_require__("./redux/serviceRequests/actions.js");

var _selectors = __webpack_require__("./redux/serviceRequests/selectors.js");

var _immutableToJS = __webpack_require__("./utils/immutableToJS.js");

var _immutableToJS2 = _interopRequireDefault(_immutableToJS);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var withConnectedData = function withConnectedData(SpecificWizardController) {
  function WithConnectedData(props) {
    return _react2.default.createElement(SpecificWizardController, props);
  }

  WithConnectedData.propTypes = {
    createServiceRequest: _propTypes2.default.func.isRequired,
    createServiceRequestPending: _propTypes2.default.bool.isRequired,
    currentServiceRequest: _propTypes2.default.shape({
      id: _propTypes2.default.string
    }).isRequired
  };

  function mapStateToProps(state) {
    return {
      createServiceRequestPending: !!(0, _selectors.createServiceRequestPendingSelector)(state),
      currentServiceRequest: (0, _selectors.currentServiceRequestSelector)(state)
    };
  }

  function mapDispatchToProps(dispatch) {
    return {
      createServiceRequest: function createServiceRequest(data) {
        return dispatch((0, _actions.createServiceRequest)(data));
      }
    };
  }

  return (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _immutableToJS2.default)(WithConnectedData);
};

exports.default = withConnectedData;

/***/ }),

/***/ "./containers/ServiceRequestWizardController/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ServiceRequestWizardController = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__("../node_modules/react-router/es/index.js");

var _recompose = __webpack_require__("../node_modules/recompose/es/Recompose.js");

var _Container = __webpack_require__("./containers/ServiceRequestWizardController/Container.js");

var _Container2 = _interopRequireDefault(_Container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ServiceRequestWizardController = exports.ServiceRequestWizardController = function (_Component) {
  _inherits(ServiceRequestWizardController, _Component);

  function ServiceRequestWizardController() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ServiceRequestWizardController);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ServiceRequestWizardController.__proto__ || Object.getPrototypeOf(ServiceRequestWizardController)).call.apply(_ref, [this].concat(args))), _this), _this.handleWizardCancel = function () {
      // User is viewing the modal view. Close the modal.
      if (_this.props.modal) {
        // handle closing modal action.
        _this.props.closeModal();
        return;
      }
      // User is viewing the page view. Return to the previous page
      _this.props.history.go(-2);
    }, _this.handleWizardSubmit = function (inputData) {
      var processedData = _this.processInputData(inputData);
      if (!_this.props.createServiceRequestPending) {
        _this.props.createServiceRequest(processedData);
      }
    }, _this.processInputData = function (inputData) {
      var assetId = inputData.asset.id,
          _inputData$reasonForR = inputData.reasonForRepair,
          complaint = _inputData$reasonForR.complaintCode,
          description = _inputData$reasonForR.description,
          serviceProviderId = inputData.serviceProvider.id;

      return {
        serviceProviderId: serviceProviderId,
        assetId: assetId,
        reasonForRepair: '10',
        complaint: complaint,
        complaintDescription: description
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  /**
   * This controller does not implement any type of specialized branching logic. If it did,
   * that logic would be implemented here and passed down to the rendered child.
   */
  // buildStepsArray = (wizardControllerState, mappedWizardConfig) => {}

  /**
   * handleWizardCancel handles cancelling the wizard and redirecting the
   * user to the appropriate location when cancelling a request.
   */


  /**
   * handleWizardSubmit orchestrates manipulating the raw input data into a proper request body
   * and dispatching a request action
   * @param  {Object} inputData the raw input data accumulated in the WizardController
   */


  /**
   * processInputData converts the raw input data into a useful request body for posting to the api.
   * @param  {Object} inputData the raw input data accumulated in the WizardController.
   * @return {Object} a properly formatted object ready to be sent over the api.
   */


  _createClass(ServiceRequestWizardController, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          currentServiceRequest = _props.currentServiceRequest,
          render = _props.render,
          rest = _objectWithoutProperties(_props, ['currentServiceRequest', 'render']);

      if (currentServiceRequest.id) {
        // if the user is viewing the modal view, close it before redirecting.
        this.props.closeModal();
        return _react2.default.createElement(_reactRouter.Redirect, { to: '/service-requests/' + currentServiceRequest.id });
      }

      return this.props.render(_extends({}, rest, {
        handleWizardCancel: this.handleWizardCancel,
        handleWizardSubmit: this.handleWizardSubmit
      }));
    }
  }]);

  return ServiceRequestWizardController;
}(_react.Component);

ServiceRequestWizardController.propTypes = {
  closeModal: _propTypes2.default.func,
  createServiceRequest: _propTypes2.default.func.isRequired,
  createServiceRequestPending: _propTypes2.default.bool.isRequired,
  currentServiceRequest: _propTypes2.default.shape({
    id: _propTypes2.default.string
  }).isRequired,
  history: _propTypes2.default.shape({
    go: _propTypes2.default.func.isRequired
  }).isRequired,
  render: _propTypes2.default.func.isRequired,
  modal: _propTypes2.default.bool.isRequired
};
ServiceRequestWizardController.defaultProps = {
  closeModal: _lodash.noop
};
exports.default = (0, _recompose.compose)(_Container2.default, _reactRouter.withRouter)(ServiceRequestWizardController);

/***/ }),

/***/ "./containers/ServiceRequestsPage/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ServiceRequestsPage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactImmutableProptypes = __webpack_require__("../node_modules/react-immutable-proptypes/dist/ImmutablePropTypes.js");

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _reactHelmet = __webpack_require__("../node_modules/react-helmet/lib/Helmet.js");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _ServiceRequestsPanel = __webpack_require__("./components/ServiceRequestsPanel/index.js");

var _ServiceRequestsPanel2 = _interopRequireDefault(_ServiceRequestsPanel);

var _NotFoundPage = __webpack_require__("./components/NotFoundPage/index.js");

var _NotFoundPage2 = _interopRequireDefault(_NotFoundPage);

var _Divider = __webpack_require__("./elements/Divider/index.js");

var _Divider2 = _interopRequireDefault(_Divider);

var _Page = __webpack_require__("./elements/Page/index.js");

var _Page2 = _interopRequireDefault(_Page);

var _PageHeadingPanel = __webpack_require__("./elements/PageHeadingPanel/index.js");

var _PageHeadingPanel2 = _interopRequireDefault(_PageHeadingPanel);

var _PageHeadingTitle = __webpack_require__("./elements/PageHeadingTitle/index.js");

var _PageHeadingTitle2 = _interopRequireDefault(_PageHeadingTitle);

var _actions = __webpack_require__("./redux/app/actions.js");

var _selectors = __webpack_require__("./redux/app/selectors.js");

var _actions2 = __webpack_require__("./redux/serviceRequests/actions.js");

var _selectors2 = __webpack_require__("./redux/serviceRequests/selectors.js");

var _selectors3 = __webpack_require__("./redux/ui/selectors.js");

var _favorites = __webpack_require__("./utils/favorites.js");

var _messages = __webpack_require__("./containers/ServiceRequestsPage/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// import SelectorBar from 'components/SelectorBar';


// NOTE: Suppress QuickActionBar in Alpha
// import QuickActionBar from 'elements/QuickActionBar';

// import { setServiceRequestsView } from 'redux/ui/actions';


// NOTE: Suppress QuickActionBar in Alpha
// import quickActionItems from './constants';

var ServiceRequestsPage = exports.ServiceRequestsPage = function (_Component) {
  _inherits(ServiceRequestsPage, _Component);

  function ServiceRequestsPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ServiceRequestsPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ServiceRequestsPage.__proto__ || Object.getPrototypeOf(ServiceRequestsPage)).call.apply(_ref, [this].concat(args))), _this), _this.loadServiceRequestFavorite = function (_ref2) {
      var priorFavorite = _ref2.priorFavorite,
          latestFavorite = _ref2.latestFavorite,
          _ref2$forceClear = _ref2.forceClear,
          forceClear = _ref2$forceClear === undefined ? false : _ref2$forceClear;

      var opts = {
        priorFavorite: priorFavorite,
        latestFavorite: latestFavorite,
        forceClear: forceClear,
        clearAction: _this.props.clearServiceRequests,
        loadAction: _this.props.loadServiceRequests
      };
      (0, _favorites.clearAndLoadFavorites)(opts);
    }, _this.refreshServiceRequests = function () {
      _this.loadServiceRequestFavorite({
        priorFavorite: _this.props.priorFavorite,
        latestFavorite: _this.props.latestFavorite,
        forceClear: true
      });
    }, _this.requestNext = function (favoritePagination) {
      var latestPage = parseInt(favoritePagination.get('latestPage'), 10);
      var nextPage = latestPage + 1;
      (0, _favorites.loadFavorite)({
        page: nextPage,
        favorite: _this.props.latestFavorite,
        loadAction: _this.props.loadServiceRequests
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ServiceRequestsPage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // if the slug is invalid, we don't need to dispatch the following redux actions
      // to fetch the service requests data from the server
      if (!this.props.isValidSlug) {
        return;
      }

      this.loadingOnMount = true;
      this.props.startLoading();

      this.loadServiceRequestFavorite({
        priorFavorite: this.props.priorFavorite,
        latestFavorite: this.props.latestFavorite
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // if the slug is invalid, we don't need to dispatch the following redux actions
      // to fetch the service requests data from the server
      if (!nextProps.isValidSlug) {
        return;
      }

      // if loading has finished, set loadingOnMount to false
      if (!nextProps.serviceRequestsRequesting && this.props.serviceRequestsRequesting) {
        this.loadingOnMount = false;
      }

      if ((0, _favorites.shouldClearAndLoadFavorites)(this.props, nextProps)) {
        // if loading from componentDidMount is in progress, don't start loading again
        if (!this.loadingOnMount) this.props.startLoading();
        this.loadServiceRequestFavorite({
          priorFavorite: nextProps.priorFavorite,
          latestFavorite: nextProps.latestFavorite
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          serviceRequests = _props.serviceRequests,
          serviceRequestsRequesting = _props.serviceRequestsRequesting,
          serviceRequestsView = _props.serviceRequestsView,
          favoritePagination = _props.favoritePagination,
          i18n = _props.i18n,
          latestFavorite = _props.latestFavorite,
          isValidSlug = _props.isValidSlug;


      if (!isValidSlug) {
        return _react2.default.createElement(_NotFoundPage2.default, null);
      }

      var headingTitle = latestFavorite.title ? _react2.default.createElement(_linguiReact.Trans, { id: latestFavorite.message }) : _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.defaultHeader });

      return _react2.default.createElement(
        _Page2.default,
        { id: 'service-requests-page' },
        _react2.default.createElement(_reactHelmet2.default, {
          title: i18n._(_messages2.default.title),
          meta: [{ name: 'description', content: i18n._(_messages2.default.description) }]
        }),
        _react2.default.createElement(
          _PageHeadingPanel2.default,
          null,
          _react2.default.createElement(
            _PageHeadingTitle2.default,
            { modifiers: ['large', 'padLeft'] },
            headingTitle
          ),
          _react2.default.createElement(_Divider2.default, null)
        ),
        _react2.default.createElement(_ServiceRequestsPanel2.default, {
          serviceRequests: serviceRequests,
          serviceRequestsView: serviceRequestsView,
          refreshServiceRequests: this.refreshServiceRequests,
          requestNext: this.requestNext,
          serviceRequestsRequesting: serviceRequestsRequesting,
          favoritePagination: favoritePagination,
          latestFavorite: latestFavorite
        })
      );
    }
  }]);

  return ServiceRequestsPage;
}(_react.Component);

/* istanbul ignore next */


ServiceRequestsPage.propTypes = {
  // All application data kept in state is immutable. To properly validate these,
  // use ImmutablePropTypes.
  serviceRequests: _reactImmutableProptypes2.default.listOf(_reactImmutableProptypes2.default.mapContains({
    id: _propTypes2.default.string
  })).isRequired,
  serviceRequestsRequesting: _propTypes2.default.bool,
  serviceRequestsView: _propTypes2.default.string,
  clearServiceRequests: _propTypes2.default.func.isRequired,
  favoritePagination: _reactImmutableProptypes2.default.map.isRequired,
  i18n: _propTypes2.default.shape({
    _: _propTypes2.default.func.isRequired
  }).isRequired,
  latestFavorite: _propTypes2.default.shape({
    message: _propTypes2.default.string,
    path: _propTypes2.default.string,
    slug: _propTypes2.default.string,
    title: _propTypes2.default.string
  }),
  loadServiceRequests: _propTypes2.default.func.isRequired,
  priorFavorite: _propTypes2.default.shape({
    message: _propTypes2.default.string,
    path: _propTypes2.default.string,
    slug: _propTypes2.default.string,
    title: _propTypes2.default.string
  }),
  // setServiceRequestsView: PropTypes.func.isRequired,
  startLoading: _propTypes2.default.func.isRequired,
  isValidSlug: _propTypes2.default.bool
};
ServiceRequestsPage.defaultProps = {
  serviceRequestsRequesting: false,
  serviceRequestsView: '',
  latestFavorite: {},
  priorFavorite: {},
  totalCount: '',
  isValidSlug: true
};
function mapStateToProps(state) {
  return {
    serviceRequests: (0, _selectors2.serviceRequestsSelector)(state),
    serviceRequestsRequesting: (0, _selectors2.serviceRequestsRequestingSelector)(state),
    serviceRequestsView: (0, _selectors3.serviceRequestsViewSelector)(state),
    favoritePagination: (0, _selectors.favoritePaginationSelector)(state),
    latestFavorite: (0, _selectors.latestFavoriteSelector)(state),
    priorFavorite: (0, _selectors.priorFavoriteSelector)(state)
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    clearServiceRequests: function clearServiceRequests() {
      return dispatch((0, _actions2.clearServiceRequests)());
    },
    loadServiceRequests: function loadServiceRequests(filter) {
      return dispatch((0, _actions2.loadServiceRequests)(filter));
    },
    // setServiceRequestsView: id => dispatch(setServiceRequestsView(id)),
    startLoading: function startLoading() {
      return dispatch((0, _actions.setLoadingStarted)(true));
    }
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _linguiReact.withI18n)()(ServiceRequestsPage));

/***/ }),

/***/ "./containers/ServiceRequestsPage/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  description: (0, _linguiReact.i18nMark)('Service Requests'),
  title: (0, _linguiReact.i18nMark)('Service Requests'),
  addNote: (0, _linguiReact.i18nMark)('Add Note'),
  defaultHeader: (0, _linguiReact.i18nMark)('Service Requests')
};

exports.default = messages;

/***/ }),

/***/ "./containers/UnreadNoteLabelContainer/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _recompose = __webpack_require__("../node_modules/recompose/es/Recompose.js");

var _actions = __webpack_require__("./redux/ui/actions.js");

var _immutableToJS = __webpack_require__("./utils/immutableToJS.js");

var _immutableToJS2 = _interopRequireDefault(_immutableToJS);

var _UnreadNoteLabel = __webpack_require__("./components/UnreadNoteLabel/index.js");

var _UnreadNoteLabel2 = _interopRequireDefault(_UnreadNoteLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    onClickAction: function onClickAction() {
      return dispatch((0, _actions.updateScrollToUnreadNote)(true));
    }
  };
}

exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('UnreadNoteLabelContainer'), (0, _reactRedux.connect)(null, mapDispatchToProps), _immutableToJS2.default)(_UnreadNoteLabel2.default);

/***/ }),

/***/ "./containers/UserInfoContainer/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserInfoContainer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _immutable = __webpack_require__("../node_modules/immutable/dist/immutable.js");

var _reactImmutableProptypes = __webpack_require__("../node_modules/react-immutable-proptypes/dist/ImmutablePropTypes.js");

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _actions = __webpack_require__("./redux/user/actions.js");

var _selectors = __webpack_require__("./redux/user/selectors.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserInfoContainer = exports.UserInfoContainer = function (_Component) {
  _inherits(UserInfoContainer, _Component);

  function UserInfoContainer() {
    _classCallCheck(this, UserInfoContainer);

    return _possibleConstructorReturn(this, (UserInfoContainer.__proto__ || Object.getPrototypeOf(UserInfoContainer)).apply(this, arguments));
  }

  _createClass(UserInfoContainer, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.props.userProfile.size === 0) {
        this.props.loadUserProfile();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          userProfile = _props.userProfile,
          loadUserProfile = _props.loadUserProfile,
          Child = _props.around,
          rest = _objectWithoutProperties(_props, ['userProfile', 'loadUserProfile', 'around']);

      return _react2.default.createElement(Child, _extends({ userProfile: userProfile }, rest));
    }
  }]);

  return UserInfoContainer;
}(_react.Component);

UserInfoContainer.propTypes = {
  userProfile: _reactImmutableProptypes2.default.map,
  loadUserProfile: _propTypes2.default.func.isRequired,
  around: _propTypes2.default.func.isRequired
};
UserInfoContainer.defaultProps = {
  userProfile: (0, _immutable.Map)()
};


function mapStateToProps(state) {
  return {
    userProfile: (0, _selectors.userProfileSelector)(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loadUserProfile: function loadUserProfile() {
      return dispatch((0, _actions.loadUserProfile)());
    }
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(UserInfoContainer);

/***/ }),

/***/ "./containers/WizardController/Container.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _actions = __webpack_require__("./redux/app/actions.js");

var _selectors = __webpack_require__("./redux/app/selectors.js");

var _selectors2 = __webpack_require__("./redux/wizardConfigs/selectors.js");

var _WizardRegistry = __webpack_require__("./setup/WizardRegistry/index.js");

var _immutableToJS = __webpack_require__("./utils/immutableToJS.js");

var _immutableToJS2 = _interopRequireDefault(_immutableToJS);

var _mapWizardConfigToRegistry = __webpack_require__("./utils/mapWizardConfigToRegistry.js");

var _mapWizardConfigToRegistry2 = _interopRequireDefault(_mapWizardConfigToRegistry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var withConnectedData = function withConnectedData(GenericWizardController) {
  function WithConnectedData(props) {
    var configKey = props.configKey,
        wizardConfig = props.wizardConfig;

    var mappedWizardConfig = (0, _mapWizardConfigToRegistry2.default)(wizardConfig, configKey);
    var SpecificWizardController = mappedWizardConfig.SpecificWizardController;


    return _react2.default.createElement(SpecificWizardController, _extends({}, props, {
      render: function render(genericControllerProps) {
        return _react2.default.createElement(GenericWizardController, _extends({}, genericControllerProps, {
          mappedWizardConfig: mappedWizardConfig
        }));
      }
    }));
  }

  WithConnectedData.propTypes = {
    addPageToBreadcrumbs: _propTypes2.default.func.isRequired,
    breadcrumbs: _propTypes2.default.shape({
      current: _propTypes2.default.shape({
        path: _propTypes2.default.string,
        message: _propTypes2.default.string
      }).isRequired,
      previous: _propTypes2.default.shape({
        path: _propTypes2.default.string,
        message: _propTypes2.default.string
      }).isRequired
    }).isRequired,
    configKey: _propTypes2.default.oneOf(_WizardRegistry.wizardConfigKeys).isRequired,
    modal: _propTypes2.default.bool,
    wizardConfig: _propTypes2.default.shape({
      steps: _propTypes2.default.objectOf(_propTypes2.default.arrayOf(_propTypes2.default.string)).isRequired,
      start: _propTypes2.default.string.isRequired
    }).isRequired
  };

  WithConnectedData.defaultProps = {
    modal: false
  };

  function mapStateToProps() {
    var getWizardConfigByKey = (0, _selectors2.makeGetWizardConfigByKey)();

    return function (state, props) {
      return {
        breadcrumbs: (0, _selectors.breadcrumbsSelector)(state),
        wizardConfig: getWizardConfigByKey(state, props.configKey)
      };
    };
  }

  function mapDispatchToProps(dispatch) {
    return {
      addPageToBreadcrumbs: function addPageToBreadcrumbs(pageDetails) {
        return dispatch((0, _actions.addPageToBreadcrumbs)(pageDetails));
      }
    };
  }
  return (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _immutableToJS2.default)(WithConnectedData));
};

exports.default = withConnectedData;

/***/ }),

/***/ "./containers/WizardController/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WizardController = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/styled-components-reactive-grid/dist/index.js");

var _WizardRegistry = __webpack_require__("./setup/WizardRegistry/index.js");

var _WizardControllerHeader = __webpack_require__("./components/WizardControllerHeader/index.js");

var _WizardControllerHeader2 = _interopRequireDefault(_WizardControllerHeader);

var _Container = __webpack_require__("./containers/WizardController/Container.js");

var _Container2 = _interopRequireDefault(_Container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WizardController = exports.WizardController = function (_Component) {
  _inherits(WizardController, _Component);

  function WizardController() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, WizardController);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WizardController.__proto__ || Object.getPrototypeOf(WizardController)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      currentStepIndex: 0,
      highestViewedStep: 0,
      inputData: {},
      stepsArray: []
    }, _this.buildStepsArray = function (currentState, mappedWizardConfig) {
      // if a `buildStepsArray` prop is available, prefer it.
      if (_this.props.buildStepsArray) {
        return _this.props.buildStepsArray(currentState, mappedWizardConfig);
      }

      // This recursively called function builds the stepsArray by evaluating the last step in the
      // array for a "nextSteps" property, then appending the first next step onto the stepsArray.
      // When no "nextSteps" property is found, the function returns the current array of steps and
      // the process terminates.
      var process = function process(allSteps, previousStepsArray) {
        var lastStep = previousStepsArray[previousStepsArray.length - 1];
        if (lastStep.nextSteps) {
          var nextStepName = lastStep.nextSteps[0];
          var nextStep = allSteps[nextStepName];
          var withNextStep = previousStepsArray.concat(nextStep);
          return process(allSteps, withNextStep);
        }
        return previousStepsArray;
      };

      var currentStepIndex = currentState.currentStepIndex,
          stepsArray = currentState.stepsArray;
      var steps = mappedWizardConfig.steps,
          start = mappedWizardConfig.start;

      // The current step index defaults to 0, which is falsey. When our currentStepIndex is 0, we
      // should build the steps array starting with the start step.

      if (!currentStepIndex) {
        // This calls the recursive builder function with all of the available steps and an array
        // containing the "start" step.
        return process(steps, [steps[start]]);
      }

      // If our currentStepIndex is higher then 0, build the remainder of the array without altering
      // the order of the steps already completed by providing the recursive builder function a
      // starting array containing the completed steps.
      return process(steps, stepsArray.slice(0, currentStepIndex));
    }, _this.completeStep = function (newInputData) {
      // If a `buildStepsArray` prop has been passed in, this component expects
      // the user's flow through the steps to be non-linear and based on user inputs.
      // This block updates the stepsArray.
      if (_this.props.buildStepsArray) {
        var stepsArray = _this.props.buildStepsArray(_this.state, _this.props.mappedWizardConfig);
        _this.setState({ stepsArray: stepsArray });
      }

      var inputData = (0, _lodash.merge)(_this.state.inputData, newInputData);
      var currentStepIndex = _this.state.currentStepIndex + 1;
      var highestViewedStep = _this.state.highestViewedStep <= _this.state.currentStepIndex ? currentStepIndex : _this.state.highestViewedStep;

      _this.setState({
        currentStepIndex: currentStepIndex,
        highestViewedStep: highestViewedStep,
        inputData: inputData
      });
    }, _this.jumpToStep = function (name) {
      var currentStepIndex = (0, _lodash.findIndex)(_this.state.stepsArray, function (s) {
        return s.name === name;
      });
      _this.setState({
        currentStepIndex: currentStepIndex,
        // `jumpToStep` is only called from the final (review) step.
        // Thus, it should be the highestViewedStep.
        highestViewedStep: _this.state.stepsArray.length - 1
      });
    }, _this.nextStep = function () {
      if (_this.state.highestViewedStep >= _this.state.currentStepIndex) {
        _this.setState({
          currentStepIndex: _this.state.currentStepIndex + 1
        });
      }
      if (_this.state.currentStepIndex >= _this.state.highestViewedStep) {
        _this.setState({
          highestViewedStep: undefined
        });
      }
    }, _this.nextStepDisabled = function () {
      var _this$state = _this.state,
          currentStepIndex = _this$state.currentStepIndex,
          highestViewedStep = _this$state.highestViewedStep,
          stepsArray = _this$state.stepsArray;

      return (
        // A highestViewedStep is present, indicating user has gone to a previous step.
        // The user is currently not on the highestViewedStep
        !(highestViewedStep && highestViewedStep > currentStepIndex) ||
        // The user is not currently on the last (review) step
        currentStepIndex === stepsArray.length - 1
      );
    }, _this.previousStep = function () {
      if (_this.state.currentStepIndex === 0) {
        return;
      }
      var highestViewedStep = _this.state.highestViewedStep || _this.state.currentStepIndex;
      _this.setState({
        currentStepIndex: _this.state.currentStepIndex - 1,
        highestViewedStep: highestViewedStep
      });
    }, _this.previousStepDisabled = function () {
      var currentStepIndex = _this.state.currentStepIndex;

      return currentStepIndex === 0;
    }, _this.syncStep = function (newInputData) {
      var inputData = (0, _lodash.merge)(_this.state.inputData, newInputData);
      _this.setState({ inputData: inputData });
    }, _this.handleWizardCancel = function () {
      var _this$props = _this.props,
          addPageToBreadcrumbs = _this$props.addPageToBreadcrumbs,
          previous = _this$props.breadcrumbs.previous,
          handleWizardCancel = _this$props.handleWizardCancel;
      // pushing the previous breadcrumb back onto the breadcrumbs before navigating back
      // effectively restores the user's origin path in our breadcrumbs history. It is
      // required to prevent the breadcrumbs from displaying the same previous and current
      // link.

      addPageToBreadcrumbs(previous);
      handleWizardCancel();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(WizardController, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // At a later point, we may need to "hydrate" this data from saved in localstorage.
      var currentStepIndex = 0;
      var stepsArray = this.buildStepsArray(this.state, this.props.mappedWizardConfig);
      this.setState({
        currentStepIndex: currentStepIndex,
        stepsArray: stepsArray
      });
    }

    /**
     * buildStepsArray builds a full list of steps for the wizard based on the data currently
     * held in state. The implementation held within the Wizard Controller handles a linear
     * progression of steps. More complicated progressions like branching must be handled with
     * a buildStepsArray prop.
     * @param  {Object} currentState the current state of the WizardController. Passed in for purity.
     * @property {Number} currentState.currentStepIndex the index of the current step
     * @property {Array} currentState.stepsArray the current steps array.
     * @param {Object} mappedWizardConfig wizard config from the runtime file, mapped to components
     * @property {String} mappedWizardConfig.start the starting step name
     * @property {Object} mappedWizardConfig.steps an object containing the available steps
     * @return {Array} a complete array of steps for the wizard, in the order they should be
     * presented.
     */


    /**
     * completeStep is passed to and called by the step currently being displayed.
     * This method orchestrates several actions:
     *   - merges in any new inputData
     *   - if a buildStepsArray prop has been provided, updates the stepsArray
     *   - advances the display to the next step
     * @param {Object} newInputData the data provided by the step being completed.
     */


    /**
     * jumpToStep locates a step by its name, then updates state so the user is viewing that step.
     * @param  {String} name the name property of the step the user should be viewing
     */


    /**
     * nextStep is passed to and called by the wizard navigation bar.
     * When a user has navigated to already completed steps, calling this will
     * navigate the user to the next step, in the order that they were completed.
     */


    /**
     * Evaluate current state to determine if the "nextStep" button should be disabled.
     * @return {Boolean} true if the next step button should be disabled.
     */


    /**
     * previousStep is passed to and called by the wizard navigation bar.
     * When a user has completed steps, calling this will navigate the user
     * to the previous step, in the order that they were completed.
     */


    /**
     * Evaluate current state to determine if the "previousStep" button should be disabled.
     * @return {Boolean} true if the previous step button should be disabled.
     */


    /**
     * Saves the current step's data without moving forward to the next step
     */


    /**
     * Handles generic wizard cancelling logic.
     */

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          configKey = _props.configKey,
          handleWizardSubmit = _props.handleWizardSubmit;
      var _state = this.state,
          currentStepIndex = _state.currentStepIndex,
          stepsArray = _state.stepsArray,
          inputData = _state.inputData;

      var _ref2 = stepsArray[currentStepIndex] || {},
          CurrentStepComponent = _ref2.component;

      return _react2.default.createElement(
        _styledComponentsReactiveGrid.Container,
        null,
        _react2.default.createElement(_WizardControllerHeader2.default, {
          configKey: configKey,
          handleWizardCancel: this.handleWizardCancel,
          nextStep: this.nextStep,
          nextStepDisabled: this.nextStepDisabled(),
          previousStep: this.previousStep,
          previousStepDisabled: this.previousStepDisabled(),
          stepCount: stepsArray.length,
          stepIndex: currentStepIndex + 1
        }),
        _react2.default.createElement(
          _styledComponentsReactiveGrid.Row,
          null,
          _react2.default.createElement(
            _styledComponentsReactiveGrid.Column,
            { modifiers: ['col'] },
            CurrentStepComponent && _react2.default.createElement(CurrentStepComponent, {
              completeStep: this.completeStep,
              configKey: configKey,
              handleWizardCancel: this.handleWizardCancel,
              handleWizardSubmit: handleWizardSubmit,
              inputData: inputData,
              jumpToStep: this.jumpToStep,
              stepsArray: stepsArray,
              syncStep: this.syncStep
            })
          )
        )
      );
    }
  }]);

  return WizardController;
}(_react.Component);

WizardController.propTypes = {
  addPageToBreadcrumbs: _propTypes2.default.func.isRequired,
  breadcrumbs: _propTypes2.default.shape({
    current: _propTypes2.default.shape({
      path: _propTypes2.default.string,
      message: _propTypes2.default.string
    }).isRequired,
    previous: _propTypes2.default.shape({
      path: _propTypes2.default.string,
      message: _propTypes2.default.string
    }).isRequired
  }).isRequired,
  buildStepsArray: _propTypes2.default.func,
  configKey: _propTypes2.default.oneOf(_WizardRegistry.wizardConfigKeys).isRequired,
  handleWizardCancel: _propTypes2.default.func.isRequired,
  handleWizardSubmit: _propTypes2.default.func.isRequired,
  mappedWizardConfig: _propTypes2.default.shape({
    start: _propTypes2.default.string.isRequired,
    steps: _propTypes2.default.objectOf(_propTypes2.default.shape({
      component: _propTypes2.default.func.isRequired,
      name: _propTypes2.default.string.isRequired,
      nextSteps: _propTypes2.default.arrayOf(_propTypes2.default.string.isRequired)
    }).isRequired).isRequired
  }).isRequired
};
WizardController.defaultProps = {
  buildStepsArray: undefined
};
exports.default = (0, _Container2.default)(WizardController);

/***/ }),

/***/ "./containers/withFullScreenMode/HandleFullScreenMode.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _fscreen = __webpack_require__("../node_modules/fscreen/lib/index.js");

var _fscreen2 = _interopRequireDefault(_fscreen);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HandleFullScreenMode = function (_Component) {
  _inherits(HandleFullScreenMode, _Component);

  function HandleFullScreenMode() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, HandleFullScreenMode);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = HandleFullScreenMode.__proto__ || Object.getPrototypeOf(HandleFullScreenMode)).call.apply(_ref, [this].concat(args))), _this), _this.startFullScreenMode = function () {
      // You can supply any html element here, but do not supply `document.body`.
      // Numerous browsers translate that incorrectly, and will make elements render
      // in the smallest possible box. For any element with `position: absolute`,
      // that box is 0px X 0px, meaning it disappears.
      _fscreen2.default.requestFullscreen(document.documentElement);
    }, _this.endFullScreenMode = function () {
      _fscreen2.default.removeEventListener('fullscreenchange', _this.handleFullScreenChangeEvent);
    }, _this.handleFullScreenChangeEvent = function () {
      if (_fscreen2.default.fullscreenEnabled && _this.props.fullScreenModeRequested) {
        _this.props.requestFullScreenMode(false);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(HandleFullScreenMode, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      _fscreen2.default.addEventListener('fullscreenchange', this.handleFullScreenChangeEvent);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.fullScreenModeRequested && !this.props.fullScreenModeRequested) {
        this.startFullScreenMode();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.endFullScreenMode();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.Children.only(this.props.children);
    }
  }]);

  return HandleFullScreenMode;
}(_react.Component);

HandleFullScreenMode.propTypes = {
  children: _propTypes2.default.element.isRequired,
  fullScreenModeRequested: _propTypes2.default.bool.isRequired,
  requestFullScreenMode: _propTypes2.default.func.isRequired
};
exports.default = HandleFullScreenMode;

/***/ }),

/***/ "./containers/withFullScreenMode/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _actions = __webpack_require__("./redux/ui/actions.js");

var _selectors = __webpack_require__("./redux/ui/selectors.js");

var _HandleFullScreenMode = __webpack_require__("./containers/withFullScreenMode/HandleFullScreenMode.js");

var _HandleFullScreenMode2 = _interopRequireDefault(_HandleFullScreenMode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var withFullScreenMode = function withFullScreenMode(WrappedComponent) {
  function WithFullScreenMode(props) {
    var fullScreenModeRequested = props.fullScreenModeRequested,
        requestFullScreenMode = props.requestFullScreenMode,
        childProps = _objectWithoutProperties(props, ['fullScreenModeRequested', 'requestFullScreenMode']);

    return _react2.default.createElement(
      _HandleFullScreenMode2.default,
      {
        fullScreenModeRequested: fullScreenModeRequested,
        requestFullScreenMode: requestFullScreenMode
      },
      _react2.default.createElement(WrappedComponent, childProps)
    );
  }

  WithFullScreenMode.propTypes = {
    fullScreenModeRequested: _propTypes2.default.bool,
    requestFullScreenMode: _propTypes2.default.func.isRequired
  };

  WithFullScreenMode.defaultProps = {
    fullScreenModeRequested: false
  };

  function mapStateToProps(state) {
    return {
      fullScreenModeRequested: (0, _selectors.requestFullScreenModeSelector)(state)
    };
  }

  function mapDispatchToProps(dispatch) {
    return {
      requestFullScreenMode: function requestFullScreenMode() {
        return dispatch((0, _actions.requestFullScreenMode)());
      }
    };
  }

  return (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(WithFullScreenMode);
};

exports.default = withFullScreenMode;

/***/ }),

/***/ "./containers/withPrint/HandlePrint.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HandlePrint = function (_Component) {
  _inherits(HandlePrint, _Component);

  function HandlePrint() {
    _classCallCheck(this, HandlePrint);

    return _possibleConstructorReturn(this, (HandlePrint.__proto__ || Object.getPrototypeOf(HandlePrint)).apply(this, arguments));
  }

  _createClass(HandlePrint, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!this.props.printPageRequested && nextProps.printPageRequested) {
        setTimeout(function () {
          window.print();
        }, 300);
        this.props.requestPrintPage(false);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.Children.only(this.props.children);
    }
  }]);

  return HandlePrint;
}(_react.Component);

HandlePrint.propTypes = {
  children: _propTypes2.default.element.isRequired,
  printPageRequested: _propTypes2.default.bool.isRequired,
  requestPrintPage: _propTypes2.default.func.isRequired
};
exports.default = HandlePrint;

/***/ }),

/***/ "./containers/withPrint/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _actions = __webpack_require__("./redux/ui/actions.js");

var _selectors = __webpack_require__("./redux/ui/selectors.js");

var _HandlePrint = __webpack_require__("./containers/withPrint/HandlePrint.js");

var _HandlePrint2 = _interopRequireDefault(_HandlePrint);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var withPrint = function withPrint(WrappedComponent) {
  function WithPrint(props) {
    var printPageRequested = props.printPageRequested,
        requestPrintPage = props.requestPrintPage,
        childProps = _objectWithoutProperties(props, ['printPageRequested', 'requestPrintPage']);

    return _react2.default.createElement(
      _HandlePrint2.default,
      {
        printPageRequested: printPageRequested,
        requestPrintPage: requestPrintPage
      },
      _react2.default.createElement(WrappedComponent, childProps)
    );
  }

  WithPrint.propTypes = {
    printPageRequested: _propTypes2.default.bool,
    requestPrintPage: _propTypes2.default.func.isRequired
  };

  WithPrint.defaultProps = {
    printPageRequested: false
  };

  /* istanbul ignore next */
  function mapStateToProps(state) {
    return {
      printPageRequested: (0, _selectors.requestPrintPageSelector)(state)
    };
  }

  /* istanbul ignore next */
  function mapDispatchToProps(dispatch) {
    return {
      requestPrintPage: function requestPrintPage(requested) {
        return dispatch((0, _actions.requestPrintPage)(requested));
      }
    };
  }

  return (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(WithPrint);
};

exports.default = withPrint;

/***/ }),

/***/ "./elements/Autosuggest/AutosuggestWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  focused: function focused() {
    return {
      styles: '\n      height: 100%;\n      transition-delay: 0s;\n    '
    };
  }
};

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  flex: 1;\n  background: ' + props.theme.colors.base.chrome100 + ';\n  line-height: ' + (0, _decisivUiUtils.px2rem)(35) + ';\n  margin-right: ' + (0, _decisivUiUtils.px2rem)(-17) + ';\n  overflow: visible;\n  width: 0;\n  height: 0;\n  transition: height 0s;\n  transition-delay: 0.2s;\n\n  .react-autosuggest__container {\n    font-size: ' + props.theme.dimensions.fontSizeMedium + ';\n    line-height: ' + (0, _decisivUiUtils.px2rem)(18) + ';\n    font-weight: 500;\n    color: ' + props.theme.colors.base.text + ';\n    height: 100%;\n    padding-left: ' + (0, _decisivUiUtils.px2rem)(8) + ';\n    padding-right: ' + (0, _decisivUiUtils.px2rem)(17) + ';\n  }\n\n  .react-autosuggest__input {\n    font-size: ' + props.theme.dimensions.fontSizeMedium + ';\n    line-height: ' + (0, _decisivUiUtils.px2rem)(18) + ';\n    font-weight: 500;\n    outline: none;\n    border: none;\n    width: 100%;\n    height: 100%;\n    padding: 0;\n    background-color: ' + props.theme.colors.base.chrome100 + ';\n\n    &::-webkit-input-placeholder {\n      font-style: italic;\n      font-weight: 300;\n      color: ' + props.theme.colors.base.chrome500 + ';\n    }\n    &:-moz-placeholder {\n      font-style: italic;\n      font-weight: 300;\n      color: ' + props.theme.colors.base.chrome500 + ';\n    }\n    &::-moz-placeholder {\n      font-style: italic;\n      font-weight: 300;\n      color: ' + props.theme.colors.base.chrome500 + ';\n    }\n    &:-ms-input-placeholder {\n      font-style: italic;\n      font-weight: 300;\n      color: ' + props.theme.colors.base.chrome500 + ';\n    }\n  }\n\n  .react-autosuggest__suggestions-list {\n    list-style: none;\n    background: ' + props.theme.colors.base.chrome100 + ';\n    box-shadow: 0 3px 7px 0 ' + props.theme.colors.base.shadow + ';\n    margin-left: ' + (0, _decisivUiUtils.px2rem)(-8) + ';\n    margin-right: ' + (0, _decisivUiUtils.px2rem)(-34) + ';\n    z-index: -1;\n  }\n\n  .react-autosuggest__suggestion {\n    margin-left: ' + (0, _decisivUiUtils.px2rem)(-40) + ';\n    padding: ' + (0, _decisivUiUtils.px2rem)(8) + ';\n\n    .typeahead-in {\n      margin: 0 ' + (0, _decisivUiUtils.px2rem)(4) + ';\n      font-weight: 400;\n    }\n    .typeahead-type {\n      color: ' + props.theme.colors.status.warning + ';\n    }\n  }\n\n  .react-autosuggest__suggestion--highlighted {\n    background-color: ' + props.theme.colors.base.linkHover + ';\n    color: ' + props.theme.colors.base.chrome100 + ';\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome100: _propTypes2.default.string.isRequired,
      chrome500: _propTypes2.default.string.isRequired,
      linkHover: _propTypes2.default.string.isRequired,
      shadow: _propTypes2.default.string.isRequired,
      text: _propTypes2.default.string.isRequired
    }).isRequired,
    status: _propTypes2.default.shape({
      warning: _propTypes2.default.string.isRequired
    }).isRequired
  }),
  dimensions: _propTypes2.default.shape({
    fontSizeMedium: _propTypes2.default.string.isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('AutosuggestWrapper', _styledComponents2.default.div, styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

/***/ }),

/***/ "./elements/Autosuggest/Suggestion.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _messages = __webpack_require__("./elements/Autosuggest/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Suggestion(_ref) {
  var suggestion = _ref.suggestion;

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'span',
      { className: 'typeahead-value' },
      suggestion.id
    ),
    _react2.default.createElement(
      'span',
      { className: 'typeahead-in' },
      _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.in })
    ),
    _react2.default.createElement(
      'span',
      { className: 'typeahead-type' },
      suggestion.type === 'case' ? _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.cases }) : _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.assets })
    )
  );
}

Suggestion.propTypes = {
  suggestion: _propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired,
    type: _propTypes2.default.string.isRequired
  }).isRequired
};
exports.default = Suggestion;

/***/ }),

/***/ "./elements/Autosuggest/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Suggestion = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactAutosuggest = __webpack_require__("../node_modules/react-autosuggest/dist/index.js");

var _reactAutosuggest2 = _interopRequireDefault(_reactAutosuggest);

var _AutosuggestWrapper = __webpack_require__("./elements/Autosuggest/AutosuggestWrapper.js");

var _AutosuggestWrapper2 = _interopRequireDefault(_AutosuggestWrapper);

var _Suggestion2 = __webpack_require__("./elements/Autosuggest/Suggestion.js");

var _Suggestion3 = _interopRequireDefault(_Suggestion2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Autosuggest(_ref) {
  var autosuggestRef = _ref.autosuggestRef,
      props = _objectWithoutProperties(_ref, ['autosuggestRef']);

  return _react2.default.createElement(
    _AutosuggestWrapper2.default,
    props,
    _react2.default.createElement(_reactAutosuggest2.default, _extends({}, props, { ref: autosuggestRef }))
  );
}

Autosuggest.propTypes = {
  autosuggestRef: _propTypes2.default.func.isRequired
};

exports.default = Autosuggest;
exports.Suggestion = _Suggestion3.default;

/***/ }),

/***/ "./elements/Autosuggest/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  assets: (0, _linguiReact.i18nMark)('Assets'),
  cases: (0, _linguiReact.i18nMark)('Cases'),
  in: (0, _linguiReact.i18nMark)('in')
};

exports.default = messages;

/***/ }),

/***/ "./elements/BorderedStatus/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  closed: function closed(_ref) {
    var theme = _ref.theme;
    return {
      styles: '\n      color: ' + theme.colors.status.success + ';\n    '
    };
  },
  open: function open(_ref2) {
    var theme = _ref2.theme;
    return {
      styles: '\n      color: ' + theme.colors.base.text + ';\n    '
    };
  }
};

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  background-color: ' + props.theme.colors.base.background + ';\n  border: 1px solid ' + props.theme.colors.base.chrome200 + ';\n  border-radius: 2px;\n  font-size: ' + (0, _decisivUiUtils.px2rem)(10) + ';\n  font-weight: 500;\n  padding: 0 ' + (0, _decisivUiUtils.px2rem)(5) + ';\n  text-transform: capitalize;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      background: _propTypes2.default.string.isRequired,
      chrome200: _propTypes2.default.string.isRequired,
      text: _propTypes2.default.string.isRequired
    }).isRequired,
    status: _propTypes2.default.shape({
      success: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('BorderedStatus', _styledComponents2.default.span, styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

/***/ }),

/***/ "./elements/Card/Card.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var modifierConfig = {
  loading: function loading(_ref) {
    var theme = _ref.theme;
    return {
      styles: '\n      box-shadow: 0 2px 3px 2px ' + theme.colors.base.shadowLight + ';\n      cursor: default;\n      height: ' + (0, _decisivUiUtils.px2rem)(300) + ';\n    '
    };
  },
  noCursor: function noCursor() {
    return {
      styles: '\n      cursor: default;\n    '
    };
  },
  noPad: function noPad() {
    return {
      styles: 'padding: 0;'
    };
  },
  selected: function selected(_ref2) {
    var theme = _ref2.theme;
    return {
      styles: '\n      background-color: ' + theme.colors.base.selectableActive + ';\n      box-shadow: 0 2px 3px 2px ' + theme.colors.base.shadow + ';\n      &:hover {\n        background-color: ' + theme.colors.base.selectableActive + ';\n      }\n    '
    };
  },
  selectable: function selectable(_ref3) {
    var theme = _ref3.theme;
    return {
      styles: '\n      box-shadow: 0 2px 3px 2px ' + theme.colors.base.shadowLight + ';\n      &:hover {\n        background-color: ' + theme.colors.base.selectableHover + ';\n      }\n    '
    };
  }
};

/* istanbul ignore next */
var styles = function styles(_ref4) {
  var theme = _ref4.theme;
  return '\n  background-color: ' + theme.colors.base.background + ';\n  border-radius: 2px;\n  box-shadow: 0 2px 3px 2px ' + theme.colors.base.shadowLight + ';\n  cursor: pointer;\n  margin: ' + (0, _decisivUiUtils.px2rem)(4) + ';\n  min-height: 50px;\n  padding: ' + (0, _decisivUiUtils.px2rem)(8) + ';\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      background: _propTypes2.default.string.isRequired,
      shadow: _propTypes2.default.string.isRequired,
      shadowLight: _propTypes2.default.string.isRequired,
      selectableActive: _propTypes2.default.string.isRequired,
      selectableHover: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Card', _styledComponents2.default.div, styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

/***/ }),

/***/ "./elements/Card/CardElement.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  flex: function flex() {
    return {
      styles: '\n      align-items: center;\n      display: flex;\n    '
    };
  }
};

/* istanbul ignore next */
var styles = '\n  padding: ' + (0, _decisivUiUtils.px2rem)(8) + ';\n';

exports.default = (0, _decisivUiUtils.buildStyledComponent)('CardElement', _styledComponents2.default.div, styles, { modifierConfig: modifierConfig });

/***/ }),

/***/ "./elements/Card/CardTable.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  ', '\n\n  border-spacing: 0;\n  font-size: ', ';\n  width: 100%;\n  ', '\n\n  th {\n    text-align: left;\n    vertical-align: text-top;\n    ', '\n  }\n\n  td {\n    padding-left: ', ';\n    text-align: right;\n    vertical-align: text-top;\n    ', '\n  }\n'], ['\n  ', '\n\n  border-spacing: 0;\n  font-size: ', ';\n  width: 100%;\n  ', '\n\n  th {\n    text-align: left;\n    vertical-align: text-top;\n    ', '\n  }\n\n  td {\n    padding-left: ', ';\n    text-align: right;\n    vertical-align: text-top;\n    ', '\n  }\n']);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledComponentsModifiers = __webpack_require__("../node_modules/styled-components-modifiers/dist/index.js");

var _styledComponentsThemeValidator = __webpack_require__("../node_modules/styled-components-theme-validator/dist/index.js");

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _styles = __webpack_require__("./utils/styles.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var COMPONENT_NAME = 'CardTable';

var TABLE_MODIFIER_CONFIG = {
  capitalize: function capitalize() {
    return { styles: 'text-transform: capitalize;' };
  },
  uppercase: function uppercase() {
    return { styles: 'text-transform: uppercase;' };
  }
};

var TH_MODIFIER_CONFIG = {
  extraWide: function extraWide() {
    return { styles: 'width: 7rem;' };
  },
  wide: function wide() {
    return { styles: 'width: ' + (0, _decisivUiUtils.px2rem)(75) + ';' };
  }
};

var TD_MODIFIER_CONFIG = {
  active: function active(_ref) {
    var theme = _ref.theme;
    return { styles: 'color: ' + theme.colors.base.link + ';' };
  },
  leftAlign: function leftAlign() {
    return {
      styles: 'text-align: left;'
    };
  },
  midGreyText: function midGreyText(_ref2) {
    var theme = _ref2.theme;
    return { styles: 'color: ' + theme.colors.base.textLight + ';' };
  }
};

var THEME_PROPTYPES = (0, _styledComponentsThemeValidator.buildThemePropTypes)({
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      link: _propTypes2.default.string.isRequired,
      textLight: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
});

var CardTable = function () {
  var c = _styledComponents2.default.table(_templateObject, (0, _styledComponentsThemeValidator.validateTheme)(COMPONENT_NAME, THEME_PROPTYPES), (0, _decisivUiUtils.px2rem)(12), (0, _styledComponentsModifiers.applyStyleModifiers)(TABLE_MODIFIER_CONFIG), (0, _styledComponentsModifiers.applyStyleModifiers)(TH_MODIFIER_CONFIG, 'thModifiers'), (0, _decisivUiUtils.px2rem)(16), (0, _styledComponentsModifiers.applyStyleModifiers)(TD_MODIFIER_CONFIG, 'tdModifiers'));

  c.displayName = 'CardTable';
  return c;
}();

CardTable.propTypes = {
  modifiers: (0, _styledComponentsModifiers.styleModifierPropTypes)(TABLE_MODIFIER_CONFIG),
  tdModifiers: (0, _styledComponentsModifiers.styleModifierPropTypes)(TD_MODIFIER_CONFIG),
  thModifiers: (0, _styledComponentsModifiers.styleModifierPropTypes)(TH_MODIFIER_CONFIG)
};

CardTable.displayName = COMPONENT_NAME;

exports.default = (0, _styles.withTestTheme)(CardTable);

/***/ }),

/***/ "./elements/Card/CardTableRow.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  & > th,\n  & > td {\n    padding-top: ', ';\n  }\n'], ['\n  & > th,\n  & > td {\n    padding-top: ', ';\n  }\n']);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var CardTableRow = function () {
  var c = _styledComponents2.default.tr(_templateObject, function (_ref) {
    var type = _ref.type;
    return type === 'topGap' ? '0.6em' : '0';
  });

  c.displayName = 'CardTableRow';
  return c;
}();

CardTableRow.propTypes = {
  type: _propTypes2.default.oneOf(['topGap', ''])
};

CardTableRow.defaultProps = {
  type: ''
};
exports.default = CardTableRow;

/***/ }),

/***/ "./elements/Card/CardWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var modifierConfig = {
  '1_per_row': function _per_row() {
    return {
      styles: '\n      width: 100%;\n    '
    };
  },
  '2_per_row': function _per_row() {
    return {
      styles: '\n      width: 50%;\n    '
    };
  },
  '3_per_row': function _per_row() {
    return {
      styles: '\n      width: 33.33%;\n    '
    };
  },
  '4_per_row': function _per_row() {
    return {
      styles: '\n      width: 25%;\n    '
    };
  },
  '5_per_row': function _per_row() {
    return {
      styles: '\n      width: 20%;\n    '
    };
  }
};

/* istanbul ignore next */
var styles = function styles() {
  return '\n  box-sizing: border-box;\n  display: inline-block;\n  vertical-align: top;\n';
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('CardWrapper', _styledComponents2.default.div, styles, { modifierConfig: modifierConfig, responsive: true });

/***/ }),

/***/ "./elements/Card/ResponsiveCardGrid.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CARD_GRID_BREAKPOINTS = undefined;

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactiveContainer = __webpack_require__("../node_modules/reactive-container/dist/index.js");

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getMinWidth(numberOfCards) {
  // The cardGridPadding was updated in the theme and is now a string like '0.25rem'.
  // `parseFloat()` has a quirky ability that parses floats up to the end of the numeric sequence, 
  // thus allowing it to convert '0.25rem' into 0.25 without issue ...because JavaScript.
  var gridPad = parseFloat(_decisivUiUtils.theme.dimensions.cardGridPadding);
  return _decisivUiUtils.theme.dimensions.cardMinWidth * numberOfCards + gridPad * 2;
}

var CARD_GRID_BREAKPOINTS = exports.CARD_GRID_BREAKPOINTS = [{ name: _reactiveContainer.sizes.SM, minWidth: getMinWidth(2) }, { name: _reactiveContainer.sizes.MD, minWidth: getMinWidth(3) }, { name: _reactiveContainer.sizes.LG, minWidth: getMinWidth(4) }, { name: _reactiveContainer.sizes.XL, minWidth: getMinWidth(5) }];

var styles = function styles(props) {
  return '\n  padding: ' + props.theme.dimensions.cardGridPadding + ';\n  box-sizing: border-box;\n';
};

var themePropTypes = {
  dimensions: _propTypes2.default.shape({
    cardGridPadding: _propTypes2.default.string.isRequired
  }).isRequired
};

var CardGrid = (0, _decisivUiUtils.buildStyledComponent)('CardGrid', _styledComponents2.default.div, styles, { themePropTypes: themePropTypes });

exports.default = (0, _reactiveContainer.makeReactiveContainer)()(CardGrid);

/***/ }),

/***/ "./elements/Card/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardWrapper = exports.CardTableRow = exports.CardTable = exports.CardElement = exports.Card = exports.default = undefined;

var _Card2 = __webpack_require__("./elements/Card/Card.js");

var _Card3 = _interopRequireDefault(_Card2);

var _CardElement2 = __webpack_require__("./elements/Card/CardElement.js");

var _CardElement3 = _interopRequireDefault(_CardElement2);

var _CardTable2 = __webpack_require__("./elements/Card/CardTable.js");

var _CardTable3 = _interopRequireDefault(_CardTable2);

var _CardTableRow2 = __webpack_require__("./elements/Card/CardTableRow.js");

var _CardTableRow3 = _interopRequireDefault(_CardTableRow2);

var _CardWrapper2 = __webpack_require__("./elements/Card/CardWrapper.js");

var _CardWrapper3 = _interopRequireDefault(_CardWrapper2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Card3.default;
exports.Card = _Card3.default;
exports.CardElement = _CardElement3.default;
exports.CardTable = _CardTable3.default;
exports.CardTableRow = _CardTableRow3.default;
exports.CardWrapper = _CardWrapper3.default;

/***/ }),

/***/ "./elements/CircleButton/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var modifierConfig = {
  brandPrimary: function brandPrimary(_ref) {
    var theme = _ref.theme;
    return '\n    background-color: ' + theme.colors.brand.primary + ';\n    color: ' + theme.colors.base.chrome000 + ';\n  ';
  },

  brandSecondary: function brandSecondary(_ref2) {
    var theme = _ref2.theme;
    return '\n    background-color: ' + theme.colors.brand.secondary + ';\n    color: ' + theme.colors.base.chrome000 + ';\n  ';
  },

  disabled: function disabled() {
    return '\n    cursor: default;\n    pointer-events: none;\n  ';
  },

  hoverBrand: function hoverBrand(_ref3) {
    var theme = _ref3.theme;
    return '\n    &:hover {\n      background-color: ' + theme.colors.brand.hover + ';\n      color: ' + theme.colors.base.chrome000 + ';\n    }\n  ';
  },

  hoverShadow: function hoverShadow(_ref4) {
    var theme = _ref4.theme;
    return '\n    &:hover {\n      box-shadow: 0 2px 4px ' + theme.colors.base.shadow + ';\n    }\n  ';
  }
};

/* istanbul ignore next */
/**
 * Component: CircleButton
 *
 * Produces a button tag styled to be circular.
 *
 * modifiers:
 *   darkColor: The color and hover color for background and font.
                If darkColor is not specified, normal bright color will be rendered as default.
 *   normalFont: The font size of the CircleButton text/icon
 */

var styles = function styles(_ref5) {
  var theme = _ref5.theme;
  return '\n  background-color: ' + theme.colors.base.chrome100 + ';\n  border-radius: ' + (0, _decisivUiUtils.px2rem)(35 / 2) + ';\n  border: none;\n  color: ' + theme.colors.base.chrome500 + ';\n  cursor: pointer;\n  font-size: inherit;\n  height: ' + (0, _decisivUiUtils.px2rem)(35) + ';\n  line-height: normal;\n  outline: none;\n  width: ' + (0, _decisivUiUtils.px2rem)(35) + ';\n  &:hover {\n    background-color: ' + theme.colors.base.chrome100 + ';\n    color: ' + theme.colors.brand.hover + ';\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome000: _propTypes2.default.string.isRequired,
      chrome100: _propTypes2.default.string.isRequired,
      chrome500: _propTypes2.default.string.isRequired,
      shadow: _propTypes2.default.string.isRequired
    }).isRequired,
    brand: _propTypes2.default.shape({
      hover: _propTypes2.default.string.isRequired,
      secondary: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired,
  dimensions: _propTypes2.default.shape({
    fontSizeNormal: _propTypes2.default.string.isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('CircleButton', _styledComponents2.default.button, styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

/***/ }),

/***/ "./elements/Container/Container.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var modifierConfig = {
  fullWidth: function fullWidth() {
    return {
      styles: '\n      width: 100%;\n    '
    };
  },
  halfWidth: function halfWidth() {
    return {
      styles: '\n      width: 50%;\n    '
    };
  },
  noPad: function noPad() {
    return {
      styles: '\n      padding: 0;\n    '
    };
  }
};

/* istanbul ignore next */
var styles = function styles() {
  return '\n  box-sizing: border-box;\n  display: inline-block;\n  padding: ' + (0, _decisivUiUtils.px2rem)(8) + ';\n  position: relative;\n';
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Container', _styledComponents2.default.div, styles, { modifierConfig: modifierConfig, responsive: true });

/***/ }),

/***/ "./elements/Container/ReactiveContainer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactiveContainer = __webpack_require__("../node_modules/reactive-container/dist/index.js");

var _Container = __webpack_require__("./elements/Container/Container.js");

var _Container2 = _interopRequireDefault(_Container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reactiveContainer.makeReactiveContainer)()(_Container2.default);

/***/ }),

/***/ "./elements/Container/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReactiveContainer = exports.default = undefined;

var _Container = __webpack_require__("./elements/Container/Container.js");

var _Container2 = _interopRequireDefault(_Container);

var _ReactiveContainer2 = __webpack_require__("./elements/Container/ReactiveContainer.js");

var _ReactiveContainer3 = _interopRequireDefault(_ReactiveContainer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Container2.default;
exports.ReactiveContainer = _ReactiveContainer3.default;

/***/ }),

/***/ "./elements/Dialog/Wrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  position: absolute;\n  top: ' + (0, _decisivUiUtils.px2rem)(props.top) + ';\n  right: ' + (0, _decisivUiUtils.px2rem)(props.right) + ';\n  filter: drop-shadow(0 3px 7px rgba(0, 0, 0, 0.4));\n  z-index: 10;\n';
};

var propTypes = {
  top: _propTypes2.default.number.isRequired,
  right: _propTypes2.default.number.isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('DialogWrapper', _styledComponents2.default.div, styles, { propTypes: propTypes });

/***/ }),

/***/ "./elements/Dialog/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Wrapper = __webpack_require__("./elements/Dialog/Wrapper.js");

var _Wrapper2 = _interopRequireDefault(_Wrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Dialog(_ref) {
  var top = _ref.top,
      right = _ref.right,
      children = _ref.children;

  return _react2.default.createElement(
    _Wrapper2.default,
    { top: top, right: right },
    children
  );
}

Dialog.propTypes = {
  top: _propTypes2.default.number,
  right: _propTypes2.default.number,
  children: _propTypes2.default.node.isRequired
};

Dialog.defaultProps = {
  top: 0,
  right: 0
};

exports.default = Dialog;

/***/ }),

/***/ "./elements/Divider/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  extraLightGray: function extraLightGray(_ref) {
    var theme = _ref.theme;
    return {
      styles: '\n      border-bottom: 2px solid ' + theme.colors.base.chrome200 + ';\n    '
    };
  },
  extraWide: function extraWide() {
    return {
      styles: '\n      margin-left: -' + (0, _decisivUiUtils.px2rem)(8) + ';\n      margin-right: -' + (0, _decisivUiUtils.px2rem)(8) + ';\n    '
    };
  },
  gutter: function gutter() {
    return {
      styles: '\n      margin-top: ' + (0, _decisivUiUtils.px2rem)(4) + ';\n      margin-bottom: ' + (0, _decisivUiUtils.px2rem)(4) + ';\n    '
    };
  },
  heavy: function heavy(_ref2) {
    var theme = _ref2.theme;
    return {
      styles: '\n      border-bottom: 2px solid ' + theme.colors.base.chrome300 + ';\n    '
    };
  },
  heavyMidGray: function heavyMidGray(_ref3) {
    var theme = _ref3.theme;
    return {
      styles: '\n      border-bottom: 2px solid ' + theme.colors.base.chrome500 + ';\n\n    '
    };
  },
  light: function light(_ref4) {
    var theme = _ref4.theme;
    return {
      styles: '\n      border-bottom: 2px solid ' + theme.colors.base.chrome200 + ';\n    '
    };
  },
  narrow: function narrow() {
    return {
      styles: 'margin: 0 ' + (0, _decisivUiUtils.px2rem)(4) + ';'
    };
  }
};

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  border-bottom: 1px solid ' + (props.color || props.theme.colors.base.chrome300) + ';\n  margin-bottom: ' + (0, _decisivUiUtils.px2rem)(props.marginBottom) + ';\n  margin-top: ' + (0, _decisivUiUtils.px2rem)(props.marginTop) + ';\n  position: relative;\n  width: auto;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome200: _propTypes2.default.string.isRequired,
      chrome300: _propTypes2.default.string.isRequired,
      chrome500: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

var propTypes = {
  color: _propTypes2.default.string
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Divider', _styledComponents2.default.div, styles, { modifierConfig: modifierConfig, propTypes: propTypes, themePropTypes: themePropTypes });

/***/ }),

/***/ "./elements/DropDown/DropDownWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSelectedStyles = getSelectedStyles;

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getSelectedStyles(_ref) {
  var theme = _ref.theme,
      value = _ref.value;

  if (!value) {
    return '\n      font-style: italic;\n      color: ' + theme.colors.base.chrome500 + ';\n    ';
  }
  return undefined;
}

/* istanbul ignore next */
/*
 * This wrapper is built to surround the Dropdown component provided by `react-dropdown`.
 * The classnames used in the styling here are built into this library and are out of our
 * control, thus they must be used to style the component.
 *
 * Much of the styling here originates from the default styling of the component:
 * https://github.com/fraserxu/react-dropdown/blob/master/style.css
 */

var styles = function styles(props) {
  return '\n  display: inline-block;\n\n  .Dropdown-root {\n    position: relative;\n  }\n\n  .Dropdown-control {\n    align-items: center;\n    background-color: ' + props.widgetBGColor + ';\n    border-radius: 2px;\n    border: 1px solid ' + props.theme.colors.base.chrome200 + ';\n    box-sizing: border-box;\n    color: ' + props.widgetFGColor + ';\n    cursor: pointer;\n    display: flex;\n    min-width: ' + (0, _decisivUiUtils.px2rem)(150) + ';\n    outline: none;\n    overflow: hidden;\n    padding: ' + (0, _decisivUiUtils.px2rem)(4) + ' ' + (0, _decisivUiUtils.px2rem)(4) + ' ' + (0, _decisivUiUtils.px2rem)(4) + ' ' + (0, _decisivUiUtils.px2rem)(9) + ';\n    position: relative;\n    transition: all 200ms ease;\n\n    .fa {\n      display: ' + (props.showIcon ? 'inherit' : 'none') + ';\n    }\n  }\n\n  .Dropdown-control:hover {\n    box-shadow: 0 1px 0 ' + props.theme.colors.base.shadow + ');\n    .Dropdown-arrow {\n      border-color: ' + props.widgetFGColor + ' transparent transparent;\n    }\n  }\n\n  .Dropdown-placeholder {\n    ' + getSelectedStyles(props) + '\n    position: relative;\n  }\n\n  .Dropdown-arrow {\n    border-color: ' + props.widgetFGColor + ' transparent transparent;\n    border-style: solid;\n    border-width: 5px 5px 0;\n    display: block;\n    height: 0;\n    margin-left: auto;\n    margin-right: ' + (0, _decisivUiUtils.px2rem)(4) + ';\n    width: 0;\n  }\n\n  .is-open .Dropdown-control:hover {\n    .Dropdown-arrow {\n      border-color: transparent transparent ' + props.widgetFGColor + ';\n    }\n  }\n\n  .is-open .Dropdown-arrow {\n    border-color: transparent transparent ' + props.widgetFGColor + ';\n    border-width: 0 5px 5px;\n  }\n\n  .Dropdown-menu {\n    -webkit-overflow-scrolling: touch;\n    background-color: ' + props.theme.colors.base.chrome100 + ';\n    border-top: none;\n    border: 1px solid ' + props.theme.colors.base.chrome200 + ';\n    box-sizing: border-box;\n    margin-top: -1px;\n    overflow-y: auto;\n    position: absolute;\n    top: 100%;\n    width: 100%;\n    z-index: 1000;\n  }\n\n  .Dropdown-menu .Dropdown-group > .Dropdown-title {\n    font-weight: bold;\n    padding: 8px 10px;\n    text-transform: capitalize;\n  }\n\n  .Dropdown-option {\n    box-sizing: border-box;\n    cursor: pointer;\n    display: block;\n    padding: ' + (0, _decisivUiUtils.px2rem)(9) + ';\n  }\n\n  .Dropdown-option:last-child {\n    border-bottom-left-radius: 2px;\n    border-bottom-right-radius: 2px;\n  }\n\n  .Dropdown-option:hover {\n    background-color: ' + props.theme.colors.base.chrome100 + ';\n    color: ' + props.theme.colors.base.linkHover + ';\n    text-decoration: underline;\n  }\n\n  .Dropdown-option.is-selected {\n    background-color: ' + props.theme.colors.base.linkHover + ';\n    color: ' + props.theme.colors.base.chrome100 + ';\n    text-decoration: none;\n  }\n\n  .Dropdown-noresults {\n    box-sizing: border-box;\n    cursor: default;\n    display: block;\n    padding: ' + (0, _decisivUiUtils.px2rem)(4) + ';\n  }\n\n  .fa {\n    margin-left: ' + (0, _decisivUiUtils.px2rem)(5) + ';\n  }\n\n  .Dropdown-menu .fa {\n    display: none;\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome100: _propTypes2.default.string.isRequired,
      chrome200: _propTypes2.default.string.isRequired,
      chrome500: _propTypes2.default.string.isRequired,
      linkHover: _propTypes2.default.string.isRequired,
      shadow: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

var propTypes = {
  value: _propTypes2.default.shape({
    value: _propTypes2.default.string,
    label: _propTypes2.default.node
  }),
  widgetBGColor: _propTypes2.default.string.isRequired,
  widgetFGColor: _propTypes2.default.string.isRequired,
  showIcon: _propTypes2.default.bool.isRequired
};

var defaultProps = {
  value: undefined
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('DropDownWrapper', _styledComponents2.default.div, styles, { defaultProps: defaultProps, propTypes: propTypes, themePropTypes: themePropTypes });

/***/ }),

/***/ "./elements/DropDown/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDropdown = __webpack_require__("../node_modules/react-dropdown/dist/index.js");

var _reactDropdown2 = _interopRequireDefault(_reactDropdown);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _DropDownWrapper = __webpack_require__("./elements/DropDown/DropDownWrapper.js");

var _DropDownWrapper2 = _interopRequireDefault(_DropDownWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// TODO: Refactor this to use modifiers and stop passing color values down directly.
function DropDown(_ref) {
  var widgetBGColor = _ref.widgetBGColor,
      widgetFGColor = _ref.widgetFGColor,
      showIcon = _ref.showIcon,
      props = _objectWithoutProperties(_ref, ['widgetBGColor', 'widgetFGColor', 'showIcon']);

  return _react2.default.createElement(
    _DropDownWrapper2.default,
    {
      value: props.value,
      widgetBGColor: widgetBGColor,
      widgetFGColor: widgetFGColor,
      showIcon: showIcon
    },
    _react2.default.createElement(_reactDropdown2.default, props)
  );
}

DropDown.propTypes = {
  value: _propTypes2.default.shape({
    value: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.node.isRequired
  }),
  widgetBGColor: _propTypes2.default.string,
  widgetFGColor: _propTypes2.default.string,
  showIcon: _propTypes2.default.bool
};

DropDown.defaultProps = {
  value: undefined,
  widgetBGColor: _decisivUiUtils.theme.colors.base.background,
  widgetFGColor: _decisivUiUtils.theme.colors.base.chrome600,
  showIcon: false
};

exports.default = DropDown;

/***/ }),

/***/ "./elements/EmptyValue/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  color: ' + props.theme.colors.base.chrome500 + ';\n  font-style: italic;\n  font-weight: 200;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome500: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('EmptyValue', _styledComponents2.default.span, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./elements/FloatingActionWrapper/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var modifierConfig = {
  bottomRight: function bottomRight() {
    return {
      styles: '\n      > * {\n        bottom: 20vh;\n        right: 1rem;\n      }\n    '
    };
  },

  bounceIn: function bounceIn(_ref) {
    var theme = _ref.theme;
    return {
      styles: '\n      > * {\n        animation: ' + theme.animations.bounceOut + ' 200ms ease;\n      }\n    '
    };
  },

  boxShadow: function boxShadow(_ref2) {
    var theme = _ref2.theme;
    return {
      styles: '\n      > * {\n        box-shadow: 0 1px 2px 0 ' + theme.colors.base.shadow + ';\n      }\n    '
    };
  },

  hide: function hide() {
    return {
      styles: '\n      > * {\n        opacity: 0;\n      }\n    '
    };
  }
};

/* istanbul ignore next */
var styles = function styles(_ref3) {
  var theme = _ref3.theme;
  return '\n  > * {\n    animation: ' + theme.animations.bounceIn + ' 200ms ease;\n    opacity: 1;\n    position: fixed;\n  }\n';
};

var themePropTypes = {
  animations: _propTypes2.default.shape({
    bounceIn: _propTypes2.default.string.isRequired,
    bounceOut: _propTypes2.default.string.isRequired
  }).isRequired,
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      shadow: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('FloatingActionWrapper', _styledComponents2.default.span, styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

/***/ }),

/***/ "./elements/FloatingHeader/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var leftPadding = (0, _decisivUiUtils.px2rem)(8);
var floatingHeaderHeight = (0, _decisivUiUtils.px2rem)(189);

/* istanbul ignore next */
var modifierConfig = {
  leftNavExpanded: function leftNavExpanded(_ref) {
    var theme = _ref.theme;
    return {
      styles: '\n      left: calc(' + theme.dimensions.leftNavWidth + ' + ' + leftPadding + ') !important;\n    '
    };
  },
  noTransition: function noTransition() {
    return { styles: 'transition: inherit;' };
  },
  visible: function visible() {
    return {
      styles: '\n      height: ' + floatingHeaderHeight + ';\n      overflow: visible;\n    '
    };
  }
};

/* istanbul ignore next */
var styles = function styles(_ref2) {
  var theme = _ref2.theme;
  return '\n  background: ' + theme.colors.base.background + ';\n  box-shadow: 0 2px 3px 0 ' + theme.colors.base.shadow + ';\n  height: 0;\n  left: calc(' + theme.dimensions.leftNavWidthCollapsed + ' + ' + leftPadding + ');\n  margin: 0 ' + (0, _decisivUiUtils.px2rem)(-8) + ';\n  overflow: hidden;\n  padding: 0 ' + (0, _decisivUiUtils.px2rem)(8) + ';\n  position: fixed;\n  right: ' + (0, _decisivUiUtils.px2rem)(8) + ';\n  transition: ' + theme.transitions.heightExpand + ';\n  top: ' + theme.dimensions.topNavHeight + ';\n  z-index: 1;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      background: _propTypes2.default.string.isRequired,
      shadow: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired,
  dimensions: _propTypes2.default.shape({
    leftNavWidth: _propTypes2.default.string.isRequired,
    leftNavWidthCollapsed: _propTypes2.default.string.isRequired,
    topNavHeight: _propTypes2.default.string.isRequired
  }).isRequired,
  transitions: _propTypes2.default.shape({
    heightExpand: _propTypes2.default.string.isRequired
  })
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('FloatingHeader', _styledComponents2.default.div, styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

/***/ }),

/***/ "./elements/Gravatar/Ghost.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _baseComponents = __webpack_require__("../node_modules/base-components/build/index.js");

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = '\n  border-radius: ' + (0, _decisivUiUtils.px2rem)(12) + ';\n  height: ' + (0, _decisivUiUtils.px2rem)(24) + ';\n  width: ' + (0, _decisivUiUtils.px2rem)(24) + ';\n';

exports.default = (0, _decisivUiUtils.buildStyledComponent)('GravatarGhost', (0, _styledComponents2.default)(_baseComponents.GhostIndicator), styles);

/***/ }),

/***/ "./elements/Gravatar/GravatarWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  img {\n    ', '\n    ', '\n    position: relative;\n  }\n'], ['\n  img {\n    ', '\n    ', '\n    position: relative;\n  }\n']);

exports.defineBorderRadius = defineBorderRadius;
exports.defineDimensions = defineDimensions;

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function defineBorderRadius(_ref) {
  var round = _ref.round;

  if (round) {
    return 'border-radius: ' + (0, _decisivUiUtils.px2rem)(12) + ';';
  }
  return '';
}

function defineDimensions(_ref2) {
  var round = _ref2.round;

  if (round) {
    return '\n      height: ' + (0, _decisivUiUtils.px2rem)(24) + ';\n      width: ' + (0, _decisivUiUtils.px2rem)(24) + ';\n    ';
  }
  return '';
}

var GravatarWrapper = function () {
  var c = _styledComponents2.default.div(_templateObject, defineBorderRadius, defineDimensions);

  c.displayName = 'GravatarWrapper';
  return c;
}();

exports.default = GravatarWrapper;

/***/ }),

/***/ "./elements/Gravatar/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactGravatar = __webpack_require__("../node_modules/react-gravatar/dist/index.js");

var _reactGravatar2 = _interopRequireDefault(_reactGravatar);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _Ghost = __webpack_require__("./elements/Gravatar/Ghost.js");

var _Ghost2 = _interopRequireDefault(_Ghost);

var _GravatarWrapper = __webpack_require__("./elements/Gravatar/GravatarWrapper.js");

var _GravatarWrapper2 = _interopRequireDefault(_GravatarWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Gravatar(props) {
  var gravatarProps = _extends({}, (0, _lodash.omit)(props, ['ghost', 'round']), {
    default: props.email ? 'identicon' : 'mm',
    email: props.email || 'invalid'
  });

  return _react2.default.createElement(
    _GravatarWrapper2.default,
    props,
    props.ghost ? _react2.default.createElement(_Ghost2.default, null) : _react2.default.createElement(_reactGravatar2.default, gravatarProps)
  );
}

Gravatar.propTypes = {
  email: _propTypes2.default.string,
  ghost: _propTypes2.default.bool
};

Gravatar.defaultProps = {
  email: '',
  ghost: false
};

exports.default = Gravatar;

/***/ }),

/***/ "./elements/IconWarning/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Renders a triangle icon (SVG) with rounded corners.
 */
function IconWarning(_ref) {
  var size = _ref.size,
      color = _ref.color;

  var styles = {
    fill: color,
    width: size, // CSS instead of the width attr to support non-pixel units
    height: size // Prevents scaling issue in IE
  };

  var svgPath = 'M22.1 2.8C24.3-1 27.7-1 29.9 2.8L51.2 41C53.3 44.9 51.5 48 47 48L5 48C0.5 48-1.3 44.9 0.8 41L22.1 2.8Z';

  return _react2.default.createElement(
    'svg',
    { viewBox: '-1 -1 53 49', preserveAspectRatio: 'xMidYMid meet', style: styles },
    _react2.default.createElement('path', { d: svgPath })
  );
}

IconWarning.propTypes = {
  size: _propTypes2.default.number,
  color: _propTypes2.default.string
};

IconWarning.defaultProps = {
  size: 18,
  color: 'grey'
};

exports.default = IconWarning;

/***/ }),

/***/ "./elements/IconWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  color: ' + props.theme.colors.base.textLight + ';\n  margin-right: ' + (0, _decisivUiUtils.px2rem)(5) + ';\n\n  .fa {\n    font-size: ' + (0, _decisivUiUtils.px2rem)(18) + ';\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      textLight: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

var propTypes = {
  type: _propTypes2.default.string
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('IconWrapper', _styledComponents2.default.span, styles, { propTypes: propTypes, themePropTypes: themePropTypes });

/***/ }),

/***/ "./elements/Img/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A simple wrapper around the DOM `img` tag that requires the inclusion
 * of an `alt` property.
 */
function Img(props) {
  return _react2.default.createElement('img', { className: props.className, src: props.src, alt: props.alt });
}

Img.propTypes = {
  src: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired,
  alt: _propTypes2.default.string.isRequired,
  className: _propTypes2.default.string
};

Img.defaultProps = {
  className: ''
};

exports.default = Img;

/***/ }),

/***/ "./elements/Link/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__("../node_modules/react-router-dom/es/index.js");

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * LinkWithoutStyle removes the modifier and theme props from react-router-dom's `Link` component,
 * allowing us to use styled-components without prop errors in the console.
 */
function LinkWithoutStyleProps(props) {
  return _react2.default.createElement(_reactRouterDom.Link, (0, _lodash.omit)(props, ['theme', 'modifiers']));
}

/* istanbul ignore next */
var modifierConfig = {
  bold: function bold() {
    return { styles: 'font-weight: bold;' };
  },
  heavy: function heavy() {
    return { styles: 'font-weight: 500;' };
  },
  hoverCaret: function hoverCaret() {
    return {
      styles: '\n      &:hover::after {\n        content: "\\f0da";\n        font-family: FontAwesome;\n        display: inline-block;\n        text-decoration: none;\n        vertical-align: middle;\n        line-height: 0;\n        margin-left: 0.5rem;\n        position: relative;\n        bottom: 0.05rem;\n      }\n    '
    };
  },
  padded: function padded() {
    return { styles: 'padding: ' + (0, _decisivUiUtils.px2rem)(6) + ';' };
  },
  small: function small() {
    return { styles: 'font-size: ' + (0, _decisivUiUtils.px2rem)(14) + ';' };
  },
  textColor: function textColor(_ref) {
    var theme = _ref.theme;
    return {
      styles: '\n      color: ' + theme.colors.base.text + ';\n      &:hover {\n        color: ' + theme.colors.base.linkHover + ' !important;\n        text-decoration: underline;\n      }\n      &:visited {\n        color: ' + theme.colors.base.text + ';\n      }\n    '
    };
  },
  uppercase: function uppercase() {
    return { styles: 'text-transform: uppercase;' };
  }
};

/* istanbul ignore next */
var styles = function styles(_ref2) {
  var theme = _ref2.theme;
  return '\n  color: ' + theme.colors.base.link + ';\n  text-decoration: none;\n  &:hover {\n    color: ' + theme.colors.base.linkHover + ';\n    text-decoration: underline;\n  }\n  &:visited {\n    color: ' + theme.colors.base.linkVisited + ';\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      link: _propTypes2.default.string.isRequired,
      linkHover: _propTypes2.default.string.isRequired,
      linkVisited: _propTypes2.default.string.isRequired,
      text: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Link', (0, _styledComponents2.default)(LinkWithoutStyleProps), styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

/***/ }),

/***/ "./elements/Page/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = '\n  flex-grow: 1;\n';

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Page', _styledComponents2.default.section, styles);

/***/ }),

/***/ "./elements/PageContentPanel/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = '\n  flex-grow: 1;\n  padding: ' + (0, _decisivUiUtils.px2rem)(8) + ';\n';

exports.default = (0, _decisivUiUtils.buildStyledComponent)('PageContentPanel', _styledComponents2.default.section, styles);

/***/ }),

/***/ "./elements/PageHeadingPanel/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = '\n  padding: 0 0.5rem;\n';

exports.default = (0, _decisivUiUtils.buildStyledComponent)('PageHeadingPanel', _styledComponents2.default.section, styles);

/***/ }),

/***/ "./elements/PageHeadingTitle/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  large: function large() {
    return {
      styles: '\n      font-size: ' + (0, _decisivUiUtils.px2rem)(25) + ';\n      padding-top: ' + (0, _decisivUiUtils.px2rem)(16) + ';\n    '
    };
  },
  padLeft: function padLeft() {
    return {
      styles: 'padding-left: ' + (0, _decisivUiUtils.px2rem)(8) + ';'
    };
  }
};

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  color: ' + props.theme.colors.base.text + ';\n  font-size: ' + (0, _decisivUiUtils.px2rem)(15) + ';\n  font-weight: 600;\n  margin: 0;\n  text-transform: uppercase;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('PageHeadingTitle', _styledComponents2.default.h1, styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

/***/ }),

/***/ "./elements/Popover/Arrow.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stylePosition = stylePosition;
exports.borderStyle = borderStyle;

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _oldIEVersion = __webpack_require__("./utils/oldIEVersion.js");

var _oldIEVersion2 = _interopRequireDefault(_oldIEVersion);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function styleValues(_ref) {
  var position = _ref.position,
      arrowEnd = _ref.arrowEnd;

  if (position === 'left' || position === 'right') {
    return {
      posAttrName: arrowEnd ? 'bottom' : 'top',
      posOtherAttrName: position === 'right' ? 'left' : 'right',
      offsetX: position === 'right' ? '50%' : '-50%',
      offsetY: arrowEnd ? '50%' : '-50%',
      rotation: position === 'right' ? -135 : 45
    };
  }
  return {
    posAttrName: arrowEnd ? 'right' : 'left',
    posOtherAttrName: position === 'bottom' ? 'top' : 'bottom',
    offsetX: arrowEnd ? '50%' : '-50%',
    offsetY: position === 'bottom' ? '50%' : '-50%',
    rotation: position === 'bottom' ? -45 : 135
  };
}

function arrowPosition(_ref2) {
  var noOffset = _ref2.noOffset,
      arrowSize = _ref2.arrowSize,
      arrowCenter = _ref2.arrowCenter,
      theme = _ref2.theme;

  switch (true) {
    case noOffset:
      return (0, _decisivUiUtils.px2rem)(arrowSize);
    case arrowCenter:
      return '50%';
    default:
      return theme.dimensions.popOverArrowOffset;
  }
}

function stylePosition(props) {
  var _styleValues = styleValues(props),
      posAttrName = _styleValues.posAttrName,
      posOtherAttrName = _styleValues.posOtherAttrName,
      offsetX = _styleValues.offsetX,
      offsetY = _styleValues.offsetY,
      rotation = _styleValues.rotation;

  var arrowPos = arrowPosition(props);

  return '\n    ' + posAttrName + ': ' + arrowPos + ';\n    ' + posOtherAttrName + ': 0;\n    margin-' + posOtherAttrName + ': 0;\n    transform: translateX(' + offsetX + ') translateY(' + offsetY + ') rotate(' + rotation + 'deg) scale(1.3);\n  ';
}

function borderStyle(_ref3) {
  var border = _ref3.border,
      theme = _ref3.theme;

  if (border) {
    return '\n      border-width: 2px 2px 0 0;\n      border-color: ' + theme.colors.base.chrome300 + ';\n      border-style: solid;\n    ';
  }
  return '';
}

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  ' + borderStyle(props) + '\n  ' + stylePosition(props) + '\n  background-color: ' + (props.bgColor || props.theme.colors.base.background) + ';\n  content: "";\n  height: ' + (props.arrowSize ? (0, _decisivUiUtils.px2rem)(props.arrowSize) : props.theme.dimensions.popOverArrowSize) + ';\n  position: absolute;\n  transition: all 0.3s ease 0ms;\n  width: ' + (props.arrowSize ? (0, _decisivUiUtils.px2rem)(props.arrowSize) : props.theme.dimensions.popOverArrowSize) + ';\n  display: ' + (!(0, _oldIEVersion2.default)() && props.arrowVisible ? 'initial' : 'none') + '\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      background: _propTypes2.default.string.isRequired,
      chrome300: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired,
  dimensions: _propTypes2.default.shape({
    popOverArrowOffset: _propTypes2.default.string.isRequired,
    popOverArrowSize: _propTypes2.default.string.isRequired
  }).isRequired
};

var propTypes = {
  position: _propTypes2.default.string,
  arrowEnd: _propTypes2.default.bool,
  arrowCenter: _propTypes2.default.bool,
  noOffset: _propTypes2.default.bool,
  bgColor: _propTypes2.default.string,
  border: _propTypes2.default.bool,
  arrowSize: _propTypes2.default.number,
  arrowVisible: _propTypes2.default.bool
};

var defaultProps = {
  position: 'top',
  arrowEnd: false,
  arrowCenter: false,
  noOffset: false,
  bgColor: '',
  border: false,
  arrowSize: 18,
  arrowVisible: true
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Arrow', _styledComponents2.default.div, styles, { defaultProps: defaultProps, propTypes: propTypes, themePropTypes: themePropTypes });

/***/ }),

/***/ "./elements/Popover/ContentWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.stylePosition = stylePosition;
exports.styleActive = styleActive;
exports.styleShadow = styleShadow;
exports.borderStyle = borderStyle;

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getSizeOffset(_ref) {
  var arrowSize = _ref.arrowSize,
      noOffset = _ref.noOffset,
      dimensions = _ref.theme.dimensions;

  return {
    arrowOffset: noOffset ? dimensions.popOverArrowSize : dimensions.popOverArrowOffset,
    arrowSizeDefault: arrowSize ? (0, _decisivUiUtils.px2rem)(arrowSize) : dimensions.popOverArrowSize
  };
}

function styleValues(_ref2) {
  var position = _ref2.position,
      arrowEnd = _ref2.arrowEnd,
      arrowCenter = _ref2.arrowCenter,
      arrowOffset = _ref2.arrowOffset;

  if (position === 'left' || position === 'right') {
    return {
      offsetX: 0,
      offsetY: arrowCenter ? '50%' : '' + (arrowEnd ? '' : '-') + arrowOffset,
      paddingAttrName: 'padding-' + (position === 'right' ? 'left' : 'right'),
      posAttrName: position === 'right' ? 'left' : 'right',
      posOtherAttrName: arrowEnd ? 'bottom' : 'top'
    };
  }
  return {
    offsetX: arrowCenter ? '50%' : '' + (arrowEnd ? '' : '-') + arrowOffset,
    offsetY: 0,
    paddingAttrName: 'padding-' + (position === 'bottom' ? 'top' : 'bottom'),
    posAttrName: position === 'bottom' ? 'top' : 'bottom',
    posOtherAttrName: arrowEnd ? 'right' : 'left'
  };
}

function stylePosition(props) {
  var _getSizeOffset = getSizeOffset(props),
      arrowOffset = _getSizeOffset.arrowOffset,
      arrowSizeDefault = _getSizeOffset.arrowSizeDefault;

  var _styleValues = styleValues(_extends({}, props, {
    arrowOffset: arrowOffset,
    arrowSizeDefault: arrowSizeDefault
  })),
      offsetX = _styleValues.offsetX,
      offsetY = _styleValues.offsetY,
      paddingAttrName = _styleValues.paddingAttrName,
      posAttrName = _styleValues.posAttrName,
      posOtherAttrName = _styleValues.posOtherAttrName;

  var positionOffset = props.positionOffset;


  return '\n    ' + paddingAttrName + ': ' + arrowSizeDefault + ';\n    ' + posAttrName + ': ' + (positionOffset ? (0, _decisivUiUtils.px2rem)(positionOffset) : '80%') + ';\n    ' + posOtherAttrName + ': 50%;\n    transform: translateX(' + offsetX + ') translateY(' + offsetY + ');\n  ';
}

function styleActive(_ref3) {
  var active = _ref3.active,
      delay = _ref3.delay;

  if (active) {
    return '\n      transition: opacity 0.5s;\n      opacity: 1;\n      transition-delay: ' + delay + 'ms;\n    ';
  }
  return '\n    opacity: 0;\n    pointer-events: none;\n  ';
}

function styleShadow(_ref4) {
  var noShadow = _ref4.noShadow,
      theme = _ref4.theme;

  if (noShadow) {
    return '';
  }
  return '\n    filter: drop-shadow(0 3px 7px ' + theme.colors.base.shadow + ');\n  ';
}

function borderStyle(_ref5) {
  var border = _ref5.border,
      theme = _ref5.theme;

  if (border) {
    return '\n      border: 3px solid ' + theme.colors.base.chrome300 + ';\n    ';
  }
  return '';
}

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  ' + borderStyle(props) + '\n  ' + styleActive(props) + '\n  ' + stylePosition(props) + '\n  ' + styleShadow(props) + '\n  flex-flow: column nowrap;\n  position: absolute;\n  z-index: 10;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome300: _propTypes2.default.string.isRequired,
      shadow: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

var propTypes = {
  arrowCenter: _propTypes2.default.bool,
  arrowEnd: _propTypes2.default.bool,
  arrowSize: _propTypes2.default.number,
  border: _propTypes2.default.bool,
  delay: _propTypes2.default.number.isRequired,
  noOffset: _propTypes2.default.bool,
  noShadow: _propTypes2.default.bool,
  position: _propTypes2.default.string,
  positionOffset: _propTypes2.default.number
};

var defaultProps = {
  arrowCenter: false,
  arrowEnd: false,
  arrowSize: 18,
  border: false,
  noOffset: false,
  noShadow: false,
  position: 'top',
  positionOffset: 0
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('ContentWrapper', _styledComponents2.default.div, styles, { defaultProps: defaultProps, propTypes: propTypes, themePropTypes: themePropTypes });

/***/ }),

/***/ "./elements/Popover/InsideContentWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.backgroundColor = backgroundColor;

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _oldIEVersion = __webpack_require__("./utils/oldIEVersion.js");

var _oldIEVersion2 = _interopRequireDefault(_oldIEVersion);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function backgroundColor(_ref) {
  var bgColor = _ref.bgColor,
      theme = _ref.theme;

  return 'background-color: ' + (bgColor || theme.colors.base.background) + ';';
}

function borderStyles(_ref2) {
  var theme = _ref2.theme;

  if ((0, _oldIEVersion2.default)()) {
    return 'border: solid 1px ' + theme.colors.base.chrome300 + ';';
  }
  return 'border: none;';
}

var modifierConfig = {
  minSize: function minSize(_ref3) {
    var theme = _ref3.theme;
    return {
      styles: '\n      min-height: ' + theme.dimensions.popOverMinHeight + ';\n      min-width: ' + theme.dimensions.popOverMinWidth + ';\n    '
    };
  }
};

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  ' + borderStyles(props) + '\n  ' + backgroundColor(props) + '\n  font-size: ' + (props.fontSize ? (0, _decisivUiUtils.px2rem)(props.fontSize) : 'inherit') + ';\n  color: ' + (props.fontColor || 'inherit') + ';\n  padding: ' + (0, _decisivUiUtils.px2rem)(5) + ';\n  position: relative;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      background: _propTypes2.default.string.isRequired,
      chrome300: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired,
  dimensions: _propTypes2.default.shape({
    popOverMinHeight: _propTypes2.default.string.isRequired,
    popOverMinWidth: _propTypes2.default.string.isRequired
  }).isRequired
};

var propTypes = {
  bgColor: _propTypes2.default.string,
  fontSize: _propTypes2.default.string,
  fontColor: _propTypes2.default.string
};

var defaultProps = {
  bgColor: '',
  fontSize: '',
  fontColor: ''
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('InsideContentWrapper', _styledComponents2.default.div, styles, { defaultProps: defaultProps, modifierConfig: modifierConfig, propTypes: propTypes, themePropTypes: themePropTypes });

/***/ }),

/***/ "./elements/Popover/MessagePopover.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  line-height: ' + props.theme.dimensions.popOverMinHeight + ';\n  text-transform: uppercase;\n';
};

var themePropTypes = {
  dimensions: _propTypes2.default.shape({
    popOverMinHeight: _propTypes2.default.string.isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('MessagePopover', _styledComponents2.default.div, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./elements/Popover/Popover.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Popover = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactClickOutside = __webpack_require__("../node_modules/react-click-outside/dist/index.js");

var _reactClickOutside2 = _interopRequireDefault(_reactClickOutside);

var _recompose = __webpack_require__("../node_modules/recompose/es/Recompose.js");

var _Wrapper = __webpack_require__("./elements/Popover/Wrapper.js");

var _Wrapper2 = _interopRequireDefault(_Wrapper);

var _ContentWrapper = __webpack_require__("./elements/Popover/ContentWrapper.js");

var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);

var _TargetWrapper = __webpack_require__("./elements/Popover/TargetWrapper.js");

var _TargetWrapper2 = _interopRequireDefault(_TargetWrapper);

var _InsideContentWrapper = __webpack_require__("./elements/Popover/InsideContentWrapper.js");

var _InsideContentWrapper2 = _interopRequireDefault(_InsideContentWrapper);

var _Arrow = __webpack_require__("./elements/Popover/Arrow.js");

var _Arrow2 = _interopRequireDefault(_Arrow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
  Overview: This is a popover component
  Basic Use:
    import Popover, { PopoverContent, PopoverTarget } from 'elements/Popover';
    <Popover>
      <PopoverTarget>
        target where your mouse is clicked on or hovered on.
      </PopoverTarget>
      <PopoverContent>
        content to be shown on Popover
      </PopoverContent>
    </Popover>
  Props:
    showOnHover: show Popover on mouse hover (not click) if set to true.
    onShow: callback function called when the popover is shown.
    onHide: callback function called when the popover is hidden.
    noOffset: Arrow of popover goes to start or end of the border if set to true.
    position: can be one of ['left', 'top', 'right', 'bottom'].
              the relative position of popover to target
    positionOffset: if provided, defines the offset of the popover position (in px) from its
                    target element. if not provided, it defaults to 80%.
    arrowCenter: place the Arrow at the center of the border.
                 noOffset value is ignored if arrowCenter is set to true.
    bgColor: background Color of Popover
    border: if border is set to true it shows the border around Popover (solid 3px gray)
    arrowSize: size of the arrow of Popover. default is 18
    showAlways: show Popover always no matter you hover/click on it or not if set to true.
    noShadow: remove shadow if set to true.
    minSize: make minWidth and minHeight enabled. default: true
    delay: number of ms to delay showing of the popover
    fontSize: change font size in the popover
    fontColor: change the color of the font
*/

var Popover = exports.Popover = function (_Component) {
  _inherits(Popover, _Component);

  function Popover() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Popover);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Popover.__proto__ || Object.getPrototypeOf(Popover)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isPopoverShown: false,
      bound: {},
      position: 'bottom',
      arrowEnd: true
    }, _this.getTarget = function () {
      var children = _this.props.children;

      var targetComponent = _react2.default.Children.toArray(children).filter(function (c) {
        return c.type.displayName === 'PopoverTarget';
      })[0];
      return targetComponent && targetComponent.props.children;
    }, _this.getContent = function () {
      var children = _this.props.children;

      var contentComponent = _react2.default.Children.toArray(children).filter(function (c) {
        return c.type.displayName === 'PopoverContent';
      })[0];
      var childComponent = contentComponent && contentComponent.props.children;
      return childComponent && _react2.default.cloneElement(childComponent, { hidePopover: _this.hide });
    }, _this.handleClickOutside = function () {
      _this.hide();
      _this.props.clickOutside();
    }, _this.handleClickTarget = function (e) {
      if (_this.state.isPopoverShown) {
        _this.hide(e);
      } else {
        _this.show(e);
      }
    }, _this.hide = function (e) {
      if (!_this.state.isPopoverShown) return;
      _this.setState({ isPopoverShown: false });
      _this.props.onHide(e);
    }, _this.show = function (e) {
      if (_this.state.isPopoverShown) return;
      var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
      var h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
      var bound = e.currentTarget.getBoundingClientRect();
      var xLeft = bound.left + bound.right < w; // true if the object is on left side of viewport
      var yTop = bound.top + bound.bottom < h; // true if the object is on top side of viewport
      _this.setState({
        isPopoverShown: true,
        position: yTop ? 'bottom' : 'top',
        arrowEnd: !xLeft
      });
      _this.props.onShow(e);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Popover, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          arrowCenter = _props.arrowCenter,
          arrowSize = _props.arrowSize,
          arrowVisible = _props.arrowVisible,
          bgColor = _props.bgColor,
          border = _props.border,
          delay = _props.delay,
          minSize = _props.minSize,
          noOffset = _props.noOffset,
          noShadow = _props.noShadow,
          positionOffset = _props.positionOffset,
          showAlways = _props.showAlways,
          showOnHover = _props.showOnHover,
          fontSize = _props.fontSize,
          fontColor = _props.fontColor,
          inlineBlock = _props.inlineBlock;
      var _state = this.state,
          isPopoverShown = _state.isPopoverShown,
          bound = _state.bound,
          position = _state.position,
          arrowEnd = _state.arrowEnd;

      return _react2.default.createElement(
        _Wrapper2.default,
        {
          onMouseLeave: showOnHover ? this.hide : _lodash.noop,
          onMouseEnter: showOnHover ? this.show : _lodash.noop,
          modifiers: (0, _lodash.compact)([inlineBlock && 'inlineBlock'])
        },
        _react2.default.createElement(
          _TargetWrapper2.default,
          { onClick: this.handleClickTarget },
          this.getTarget()
        ),
        _react2.default.createElement(
          _ContentWrapper2.default,
          {
            active: !!((showAlways || isPopoverShown) && children),
            arrowCenter: arrowCenter,
            arrowEnd: arrowEnd,
            arrowSize: arrowSize,
            border: border,
            bound: bound,
            delay: delay,
            noOffset: noOffset,
            noShadow: noShadow,
            position: this.props.position || position,
            positionOffset: positionOffset
          },
          _react2.default.createElement(_Arrow2.default, {
            position: this.props.position || position,
            arrowCenter: arrowCenter,
            arrowEnd: arrowEnd,
            noOffset: noOffset,
            bgColor: bgColor,
            border: border,
            arrowSize: arrowSize,
            arrowVisible: arrowVisible
          }),
          _react2.default.createElement(
            _InsideContentWrapper2.default,
            {
              bgColor: bgColor,
              fontSize: fontSize,
              fontColor: fontColor,
              modifiers: (0, _lodash.compact)([minSize && 'minSize'])
            },
            this.getContent()
          )
        )
      );
    }
  }]);

  return Popover;
}(_react.Component);

// Popover.displayName = 'Popover';

Popover.propTypes = {
  children: _propTypes2.default.node,
  arrowCenter: _propTypes2.default.bool,
  arrowSize: _propTypes2.default.number,
  arrowVisible: _propTypes2.default.bool,
  bgColor: _propTypes2.default.string,
  border: _propTypes2.default.bool,
  clickOutside: _propTypes2.default.func,
  delay: _propTypes2.default.number,
  minSize: _propTypes2.default.bool,
  noOffset: _propTypes2.default.bool,
  noShadow: _propTypes2.default.bool,
  onHide: _propTypes2.default.func,
  onShow: _propTypes2.default.func,
  position: _propTypes2.default.oneOf(['top', 'bottom', 'left', 'right']),
  positionOffset: _propTypes2.default.number,
  showAlways: _propTypes2.default.bool,
  showOnHover: _propTypes2.default.bool,
  fontSize: _propTypes2.default.string,
  fontColor: _propTypes2.default.string,
  inlineBlock: _propTypes2.default.bool
};
Popover.defaultProps = {
  children: null,
  arrowCenter: false,
  arrowSize: 18,
  arrowVisible: true,
  bgColor: '',
  border: false,
  clickOutside: _lodash.noop,
  delay: 100,
  minSize: true,
  noOffset: false,
  noShadow: false,
  onHide: _lodash.noop,
  onShow: _lodash.noop,
  position: 'bottom',
  positionOffset: 0,
  showAlways: false,
  showOnHover: false,
  target: null,
  fontSize: '',
  fontColor: '',
  inlineBlock: false
};
exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('Popover'), _reactClickOutside2.default)(Popover);

/***/ }),

/***/ "./elements/Popover/PopoverContent.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function PopoverContent() {
  return null;
}

PopoverContent.displayName = 'PopoverContent';

exports.default = PopoverContent;

/***/ }),

/***/ "./elements/Popover/PopoverTarget.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function PopoverTarget() {
  return null;
}

PopoverTarget.displayName = 'PopoverTarget';

exports.default = PopoverTarget;

/***/ }),

/***/ "./elements/Popover/ScrollingPopoverContentWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  smallText: function smallText() {
    return {
      styles: '\n      font-size: ' + (0, _decisivUiUtils.px2rem)(12) + ';\n      line-height: ' + (0, _decisivUiUtils.px2rem)(18) + ';\n    '
    };
  }
};

/* istanbul ignore next */
var styles = function styles() {
  return '\n  max-height: ' + (0, _decisivUiUtils.px2rem)(300) + ';\n  overflow: auto;\n  padding: ' + (0, _decisivUiUtils.px2rem)(8) + ';\n  width: ' + (0, _decisivUiUtils.px2rem)(475) + ';\n';
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('ScrollingPopoverContentWrapper', _styledComponents2.default.div, styles, { modifierConfig: modifierConfig });

/***/ }),

/***/ "./elements/Popover/TargetWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  flex: 1;\n  cursor: pointer;\n'], ['\n  flex: 1;\n  cursor: pointer;\n']);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var TargetWrapper = function () {
  var c = _styledComponents2.default.div(_templateObject);

  c.displayName = 'TargetWrapper';
  return c;
}();

exports.default = TargetWrapper;

/***/ }),

/***/ "./elements/Popover/Wrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  inlineBlock: function inlineBlock() {
    return { styles: 'display: inline-block;' };
  }
};

var styles = '\n  position: relative;\n  box-sizing: border-box;\n';

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Wrapper', _styledComponents2.default.div, styles, { modifierConfig: modifierConfig });

/***/ }),

/***/ "./elements/Popover/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ScrollingPopoverContentWrapper = exports.MessagePopover = exports.PopoverContent = exports.PopoverTarget = exports.Popover = undefined;

var _Popover2 = __webpack_require__("./elements/Popover/Popover.js");

var _Popover3 = _interopRequireDefault(_Popover2);

var _PopoverTarget2 = __webpack_require__("./elements/Popover/PopoverTarget.js");

var _PopoverTarget3 = _interopRequireDefault(_PopoverTarget2);

var _PopoverContent2 = __webpack_require__("./elements/Popover/PopoverContent.js");

var _PopoverContent3 = _interopRequireDefault(_PopoverContent2);

var _MessagePopover2 = __webpack_require__("./elements/Popover/MessagePopover.js");

var _MessagePopover3 = _interopRequireDefault(_MessagePopover2);

var _ScrollingPopoverContentWrapper2 = __webpack_require__("./elements/Popover/ScrollingPopoverContentWrapper.js");

var _ScrollingPopoverContentWrapper3 = _interopRequireDefault(_ScrollingPopoverContentWrapper2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Popover = _Popover3.default;
exports.PopoverTarget = _PopoverTarget3.default;
exports.PopoverContent = _PopoverContent3.default;
exports.MessagePopover = _MessagePopover3.default;
exports.ScrollingPopoverContentWrapper = _ScrollingPopoverContentWrapper3.default;
exports.default = _Popover3.default;

/***/ }),

/***/ "./elements/RectangleButton/RectangleButtonIcon.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var modifierConfig = {
  padLeft: function padLeft() {
    return { styles: 'padding-left: ' + (0, _decisivUiUtils.px2rem)(8) + ';' };
  },
  padRight: function padRight() {
    return { styles: 'padding-right: ' + (0, _decisivUiUtils.px2rem)(8) + ';' };
  }
};

/* istanbul ignore next */
var styles = function styles() {
  return '\n  display: inline-block;\n  .fa {\n    line-height: 0;\n  }\n';
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('RectangleButtonIcon', _styledComponents2.default.div, styles, { modifierConfig: modifierConfig });

/***/ }),

/***/ "./elements/RectangleButton/RectangleButtonText.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var modifierConfig = {
  small: function small() {
    return {
      styles: '\n      font-weight: 300;\n      font-size: ' + (0, _decisivUiUtils.px2rem)(12) + ';\n    '
    };
  },
  padLeft: function padLeft() {
    return { styles: 'padding-left: ' + (0, _decisivUiUtils.px2rem)(8) + ';' };
  },
  padRight: function padRight() {
    return { styles: 'padding-right: ' + (0, _decisivUiUtils.px2rem)(8) + ';' };
  },
  uppercase: function uppercase() {
    return { styles: 'text-transform: uppercase;' };
  }
};

/* istanbul ignore next */
var styles = function styles() {
  return '\n  font-size: ' + (0, _decisivUiUtils.px2rem)(14) + ';\n  line-height: initial;\n';
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('RectangleButtonText', _styledComponents2.default.span, styles, { modifierConfig: modifierConfig });

/***/ }),

/***/ "./elements/RectangleButton/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RectangleButtonText = exports.RectangleButtonIcon = undefined;

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _RectangleButtonIcon2 = __webpack_require__("./elements/RectangleButton/RectangleButtonIcon.js");

var _RectangleButtonIcon3 = _interopRequireDefault(_RectangleButtonIcon2);

var _RectangleButtonText2 = __webpack_require__("./elements/RectangleButton/RectangleButtonText.js");

var _RectangleButtonText3 = _interopRequireDefault(_RectangleButtonText2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var modifierConfig = {
  blue: function blue(_ref) {
    var theme = _ref.theme;
    return {
      styles: '\n      background-color: ' + theme.colors.brand.primary + ';\n      border: none;\n      color: ' + theme.colors.base.chrome100 + ';\n    '
    };
  },

  disabled: function disabled() {
    return {
      styles: '\n      cursor: default;\n      opacity: 0.5;\n      pointer-events: none;\n      &:hover {\n        box-shadow: inherit !important;\n        text-decoration: inherit !important;\n      }\n    '
    };
  },

  fullWidth: function fullWidth() {
    return {
      styles: '\n      width: 100%;\n    '
    };
  },

  green: function green(_ref2) {
    var theme = _ref2.theme;
    return {
      styles: '\n      background-color: ' + theme.colors.status.success + ';\n      border: 1px solid ' + theme.colors.status.success + ';\n      color: ' + theme.colors.base.chrome100 + ';\n    '
    };
  },

  hoverBrandBright: function hoverBrandBright(_ref3) {
    var theme = _ref3.theme;
    return {
      styles: '\n      &:hover {\n        background-color: ' + theme.colors.brand.primary + ';\n        border-color: transparent;\n        color: ' + theme.colors.base.chrome000 + ';\n      }\n    '
    };
  },

  hoverSuccess: function hoverSuccess(_ref4) {
    var theme = _ref4.theme;
    return {
      styles: '\n      &:hover {\n        background-color: ' + theme.colors.status.success + ';\n        border-color: transparent;\n        color: ' + theme.colors.base.chrome000 + ';\n      }\n    '
    };
  },

  hoverShadow: function hoverShadow(_ref5) {
    var theme = _ref5.theme;
    return {
      styles: '\n      &:hover {\n        box-shadow: 0 1px 2px 0 ' + theme.colors.base.shadow + ';\n      }\n    '
    };
  },

  hoverUnderline: function hoverUnderline() {
    return {
      styles: '\n      &:hover {\n        text-decoration: underline;\n      }\n    '
    };
  },

  large: function large() {
    return {
      styles: '\n      line-height: ' + (0, _decisivUiUtils.px2rem)(60) + ';\n      padding: 0 ' + (0, _decisivUiUtils.px2rem)(24) + ';\n    '
    };
  },

  medium: function medium() {
    return {
      styles: '\n      line-height: ' + (0, _decisivUiUtils.px2rem)(48) + ';\n      padding: 0 ' + (0, _decisivUiUtils.px2rem)(18) + ';\n    '
    };
  },

  normalWidth: function normalWidth() {
    return {
      styles: '\n      width: ' + (0, _decisivUiUtils.px2rem)(127) + ';\n    '
    };
  },

  offWhite: function offWhite(_ref6) {
    var theme = _ref6.theme;
    return {
      styles: '\n      background-color: ' + theme.colors.base.chrome100 + ';\n      border: 1px solid ' + theme.colors.base.chrome200 + ';\n      color: ' + theme.colors.base.textLight + ';\n      &:disabled {\n        background-color: ' + theme.colors.base.chrome100 + ' !important;\n        border: 1px solid ' + theme.colors.base.chrome200 + ' !important;\n        color: ' + theme.colors.base.textLight + ' !important;\n      }\n    '
    };
  },

  padLeft: function padLeft() {
    return {
      styles: '\n      margin-left: ' + (0, _decisivUiUtils.px2rem)(10) + ';\n    '
    };
  },

  pressed: function pressed(_ref7) {
    var theme = _ref7.theme;
    return {
      styles: '\n      background-color: ' + theme.colors.brand.primary + ';\n      border-color: transparent;\n      border: 1px solid ' + theme.colors.base.chrome200 + ';\n      box-shadow: 0 1px 2px 0 ' + theme.colors.base.shadow + ';\n      color: ' + theme.colors.base.chrome000 + ';\n      text-decoration: underline;\n    '
    };
  },

  pureWhite: function pureWhite(_ref8) {
    var theme = _ref8.theme;
    return {
      styles: '\n      background-color: ' + theme.colors.base.chrome100 + ';\n      border: 1px solid ' + theme.colors.base.chrome200 + ';\n      color: ' + theme.colors.base.textLight + ';\n    '
    };
  },

  small: function small() {
    return {
      styles: '\n      line-height: ' + (0, _decisivUiUtils.px2rem)(38) + ';\n      padding: 0 ' + (0, _decisivUiUtils.px2rem)(12) + ';\n    '
    };
  },

  white: function white(_ref9) {
    var theme = _ref9.theme;
    return {
      styles: '\n      background-color: ' + theme.colors.base.chrome200 + ';\n      border: none;\n      color: ' + theme.colors.base.textLight + ';\n    '
    };
  },

  wide: function wide() {
    return {
      styles: '\n      padding-left: ' + (0, _decisivUiUtils.px2rem)(24) + ';\n      padding-right: ' + (0, _decisivUiUtils.px2rem)(24) + ';\n    '
    };
  },

  xtraWide: function xtraWide() {
    return {
      styles: '\n      padding-left: ' + (0, _decisivUiUtils.px2rem)(48) + ';\n      padding-right: ' + (0, _decisivUiUtils.px2rem)(48) + ';\n    '
    };
  }

};

/* istanbul ignore next */
var styles = function styles(_ref10) {
  var theme = _ref10.theme;
  return '\n  background-color: ' + theme.colors.base.chrome200 + ';\n  border-radius: 2px;\n  border: none;\n  color: ' + theme.colors.base.textLight + ';\n  cursor: pointer;\n  outline: none;\n  transition: background-color 0.2s,\n              border-color 0.2s,\n              box-shadow 0.2s,\n              color 0.2s,\n              opacity 0.2s;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome000: _propTypes2.default.string.isRequired,
      chrome100: _propTypes2.default.string.isRequired,
      chrome200: _propTypes2.default.string.isRequired,
      shadow: _propTypes2.default.string.isRequired,
      textLight: _propTypes2.default.string.isRequired
    }).isRequired,
    brand: _propTypes2.default.shape({
      primary: _propTypes2.default.string.isRequired
    }).isRequired,
    status: _propTypes2.default.shape({
      success: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

var propTypes = {
  onClick: _propTypes2.default.func.isRequired
};

var defaultProps = {
  onClick: _lodash.noop
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('RectangleButton', _styledComponents2.default.button, styles, { defaultProps: defaultProps, modifierConfig: modifierConfig, propTypes: propTypes, themePropTypes: themePropTypes });
exports.RectangleButtonIcon = _RectangleButtonIcon3.default;
exports.RectangleButtonText = _RectangleButtonText3.default;

/***/ }),

/***/ "./elements/ScrollableContainer/List.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = '\n  padding: 0;\n  margin: 0;\n  list-decoration: none;\n';

exports.default = (0, _decisivUiUtils.buildStyledComponent)('ScrollableContainer.List', _styledComponents2.default.ul, styles);

/***/ }),

/***/ "./elements/ScrollableContainer/ListElement.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var modifierConfig = {
  selected: function selected(_ref) {
    var theme = _ref.theme;
    return { styles: 'background: ' + theme.colors.status.successBackground + ';' };
  }
};

/* istanbul ignore next */
var styles = function styles(_ref2) {
  var theme = _ref2.theme;
  return '\n  border-top: 1px solid ' + theme.colors.base.chrome200 + ';\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome200: _propTypes2.default.string.isRequired
    }).isRequired,
    status: _propTypes2.default.shape({
      successBackground: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('ScrollableContainer.ListElement', _styledComponents2.default.li, styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

/***/ }),

/***/ "./elements/ScrollableContainer/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/styled-components-reactive-grid/dist/index.js");

var _List = __webpack_require__("./elements/ScrollableContainer/List.js");

var _List2 = _interopRequireDefault(_List);

var _ListElement = __webpack_require__("./elements/ScrollableContainer/ListElement.js");

var _ListElement2 = _interopRequireDefault(_ListElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(_ref) {
  var theme = _ref.theme;
  return '\n  width: 100%;\n  overflow-y: scroll;\n  border-bottom: 1px solid ' + theme.colors.base.chrome200 + ';\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome200: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

var ScrollableContainer = (0, _decisivUiUtils.buildStyledComponent)('ScrollableContainer', (0, _styledComponents2.default)(_styledComponentsReactiveGrid.Container), styles, { themePropTypes: themePropTypes });

ScrollableContainer.List = _List2.default;
ScrollableContainer.ListElement = _ListElement2.default;

exports.default = ScrollableContainer;

/***/ }),

/***/ "./elements/Select/SelectWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  font-size: ', ';\n\n  /**\n   * React Select Plus\n   * =================\n   * MIT License: https://github.com/HubSpot/react-select-plus\n  */\n  .Select {\n    position: relative;\n  }\n\n  .Select,\n  .Select div,\n  .Select input,\n  .Select span {\n    -webkit-box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    box-sizing: border-box;\n  }\n\n  .Select.is-disabled > .Select-control {\n    background-color: #f9f9f9;\n  }\n\n  .Select.is-disabled > .Select-control:hover {\n    box-shadow: none;\n  }\n\n  .Select.is-disabled .Select-arrow-zone {\n    cursor: default;\n    pointer-events: none;\n    opacity: 0.35;\n  }\n\n  .Select-control {\n    background-color: #fff;\n    border-color: #d9d9d9 #ccc #b3b3b3;\n    border-radius: 4px;\n    border: 1px solid #ccc;\n    color: #333;\n    cursor: default;\n    display: table;\n    border-spacing: 0;\n    border-collapse: separate;\n    height: 36px;\n    outline: none;\n    overflow: hidden;\n    position: relative;\n    width: 100%;\n  }\n\n  .Select-control:hover {\n    box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);\n  }\n\n  .Select-control .Select-input:focus {\n    outline: none;\n  }\n\n  .is-searchable.is-open > .Select-control {\n    cursor: text;\n  }\n\n  .is-open > .Select-control {\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0;\n    background: #fff;\n    border-color: #b3b3b3 #ccc #d9d9d9;\n  }\n\n  .is-open > .Select-control .Select-arrow {\n    top: -2px;\n    border-color: transparent transparent #999;\n    border-width: 0 5px 5px;\n  }\n\n  .is-searchable.is-focused:not(.is-open) > .Select-control {\n    cursor: text;\n  }\n\n  .is-focused:not(.is-open) > .Select-control {\n    border-color: #007eff;\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 3px rgba(0, 126, 255, 0.1);\n  }\n\n  .Select-placeholder,\n  .Select--single > .Select-control .Select-value {\n    bottom: 0;\n    color: #aaa;\n    left: 0;\n    line-height: 34px;\n    padding-left: 10px;\n    padding-right: 10px;\n    position: absolute;\n    right: 0;\n    top: 0;\n    max-width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .has-value.Select--single > .Select-control .Select-value .Select-value-label,\n  .has-value.is-pseudo-focused.Select--single > .Select-control .Select-value .Select-value-label {\n    color: #333;\n  }\n\n  .has-value.Select--single > .Select-control .Select-value a.Select-value-label,\n  .has-value.is-pseudo-focused.Select--single > .Select-control .Select-value a.Select-value-label {\n    cursor: pointer;\n    text-decoration: none;\n  }\n\n  .has-value.Select--single > .Select-control .Select-value a.Select-value-label:hover,\n  .has-value.is-pseudo-focused.Select--single > .Select-control .Select-value a.Select-value-label:hover,\n  .has-value.Select--single > .Select-control .Select-value a.Select-value-label:focus,\n  .has-value.is-pseudo-focused.Select--single > .Select-control .Select-value a.Select-value-label:focus {\n    color: #007eff;\n    outline: none;\n    text-decoration: underline;\n  }\n\n  .Select-input {\n    height: 34px;\n    padding-left: 10px;\n    padding-right: 10px;\n    vertical-align: middle;\n  }\n\n  .Select-input > input {\n    width: 100%;\n    background: none transparent;\n    border: 0 none;\n    box-shadow: none;\n    cursor: default;\n    display: inline-block;\n    font-family: inherit;\n    font-size: inherit;\n    margin: 0;\n    outline: none;\n    line-height: 14px;\n\n    /* For IE 8 compatibility */\n    padding: 8px 0 12px;\n\n    /* For IE 8 compatibility */\n    -webkit-appearance: none;\n  }\n\n  .is-focused .Select-input > input {\n    cursor: text;\n  }\n\n  .has-value.is-pseudo-focused .Select-input {\n    opacity: 0;\n  }\n\n  .Select-control:not(.is-searchable) > .Select-input {\n    outline: none;\n  }\n\n  .Select-loading-zone {\n    cursor: pointer;\n    display: table-cell;\n    position: relative;\n    text-align: center;\n    vertical-align: middle;\n    width: 16px;\n  }\n\n  .Select-loading {\n    -webkit-animation: Select-animation-spin 400ms infinite linear;\n    -o-animation: Select-animation-spin 400ms infinite linear;\n    animation: Select-animation-spin 400ms infinite linear;\n    width: 16px;\n    height: 16px;\n    box-sizing: border-box;\n    border-radius: 50%;\n    border: 2px solid #ccc;\n    border-right-color: #333;\n    display: inline-block;\n    position: relative;\n    vertical-align: middle;\n  }\n\n  .Select-clear-zone {\n    -webkit-animation: Select-animation-fadeIn 200ms;\n    -o-animation: Select-animation-fadeIn 200ms;\n    animation: Select-animation-fadeIn 200ms;\n    color: #999;\n    cursor: pointer;\n    display: table-cell;\n    position: relative;\n    text-align: center;\n    vertical-align: middle;\n    width: 17px;\n  }\n\n  .Select-clear-zone:hover {\n    color: #d0021b;\n  }\n\n  .Select-clear {\n    display: inline-block;\n    font-size: 18px;\n    line-height: 1;\n  }\n\n  .Select--multi .Select-clear-zone {\n    width: 17px;\n  }\n\n  .Select-arrow-zone {\n    cursor: pointer;\n    display: table-cell;\n    position: relative;\n    text-align: center;\n    vertical-align: middle;\n    width: 25px;\n    padding-right: 5px;\n  }\n\n  .Select-arrow {\n    border-color: #999 transparent transparent;\n    border-style: solid;\n    border-width: 5px 5px 2.5px;\n    display: inline-block;\n    height: 0;\n    width: 0;\n    position: relative;\n  }\n\n  .is-open .Select-arrow,\n  .Select-arrow-zone:hover > .Select-arrow {\n    border-top-color: #666;\n  }\n\n  .Select--multi .Select-multi-value-wrapper {\n    display: inline-block;\n  }\n\n  .Select .Select-aria-only {\n    display: inline-block;\n    height: 1px;\n    width: 1px;\n    margin: -1px;\n    clip: rect(0, 0, 0, 0);\n    overflow: hidden;\n    float: left;\n  }\n\n  @-webkit-keyframes Select-animation-fadeIn {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n\n  @keyframes Select-animation-fadeIn {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n\n  .Select-menu-outer {\n    border-bottom-right-radius: 4px;\n    border-bottom-left-radius: 4px;\n    background-color: #fff;\n    border: 1px solid #ccc;\n    border-top-color: #e6e6e6;\n    box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);\n    box-sizing: border-box;\n    margin-top: -1px;\n    max-height: 200px;\n    position: absolute;\n    top: 100%;\n    width: 100%;\n    z-index: 1;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .Select-menu {\n    max-height: 198px;\n    overflow-y: auto;\n  }\n\n  .Select-option-group-label {\n    box-sizing: border-box;\n    background-color: #fff;\n    color: #666;\n    font-weight: bold;\n    cursor: default;\n    display: block;\n    padding: 8px 10px;\n  }\n\n  .Select-option-group-label ~ .Select-option,\n  .Select-option-group-label ~ .Select-option-group {\n    padding-left: 20px;\n  }\n\n  .Select-option {\n    box-sizing: border-box;\n    background-color: #fff;\n    color: #666;\n    cursor: pointer;\n    display: block;\n    padding: 8px 10px;\n  }\n\n  .Select-option:last-child {\n    border-bottom-right-radius: 4px;\n    border-bottom-left-radius: 4px;\n  }\n\n  .Select-option.is-selected {\n    background-color: #f5faff;\n\n    /* Fallback color for IE 8 */\n    background-color: rgba(0, 126, 255, 0.04);\n    color: #333;\n  }\n\n  .Select-option.is-focused {\n    background-color: #ebf5ff;\n\n    /* Fallback color for IE 8 */\n    background-color: rgba(0, 126, 255, 0.08);\n    color: #333;\n  }\n\n  .Select-option.is-disabled {\n    color: #ccc;\n    cursor: default;\n  }\n\n  .Select-noresults {\n    box-sizing: border-box;\n    color: #999;\n    cursor: default;\n    display: block;\n    padding: 8px 10px;\n  }\n\n  .Select--multi .Select-input {\n    vertical-align: middle;\n    margin-left: 10px;\n    padding: 0;\n  }\n\n  .Select--multi.has-value .Select-input {\n    margin-left: 5px;\n  }\n\n  .Select--multi .Select-value {\n    background-color: #ebf5ff;\n\n    /* Fallback color for IE 8 */\n    background-color: rgba(0, 126, 255, 0.08);\n    border-radius: 2px;\n    border: 1px solid #c2e0ff;\n\n    /* Fallback color for IE 8 */\n    border: 1px solid rgba(0, 126, 255, 0.24);\n    color: #007eff;\n    display: inline-block;\n    font-size: 0.9em;\n    line-height: 1.4;\n    margin-left: 5px;\n    margin-top: 5px;\n    vertical-align: top;\n  }\n\n  .Select--multi .Select-value-icon,\n  .Select--multi .Select-value-label {\n    display: inline-block;\n    vertical-align: middle;\n  }\n\n  .Select--multi .Select-value-label {\n    border-bottom-right-radius: 2px;\n    border-top-right-radius: 2px;\n    cursor: default;\n    padding: 2px 5px;\n  }\n\n  .Select--multi a.Select-value-label {\n    color: #007eff;\n    cursor: pointer;\n    text-decoration: none;\n  }\n\n  .Select--multi a.Select-value-label:hover {\n    text-decoration: underline;\n  }\n\n  .Select--multi .Select-value-icon {\n    cursor: pointer;\n    border-bottom-left-radius: 2px;\n    border-top-left-radius: 2px;\n    border-right: 1px solid #c2e0ff;\n\n    /* Fallback color for IE 8 */\n    border-right: 1px solid rgba(0, 126, 255, 0.24);\n    padding: 1px 5px 3px;\n  }\n\n  .Select--multi .Select-value-icon:hover,\n  .Select--multi .Select-value-icon:focus {\n    background-color: #d8eafd;\n\n    /* Fallback color for IE 8 */\n    background-color: rgba(0, 113, 230, 0.08);\n    color: #0071e6;\n  }\n\n  .Select--multi .Select-value-icon:active {\n    background-color: #c2e0ff;\n\n    /* Fallback color for IE 8 */\n    background-color: rgba(0, 126, 255, 0.24);\n  }\n\n  .Select--multi.is-disabled .Select-value {\n    background-color: #fcfcfc;\n    border: 1px solid #e3e3e3;\n    color: #333;\n  }\n\n  .Select--multi.is-disabled .Select-value-icon {\n    cursor: not-allowed;\n    border-right: 1px solid #e3e3e3;\n  }\n\n  .Select--multi.is-disabled .Select-value-icon:hover,\n  .Select--multi.is-disabled .Select-value-icon:focus,\n  .Select--multi.is-disabled .Select-value-icon:active {\n    background-color: #fcfcfc;\n  }\n\n  @keyframes Select-animation-spin {\n    to {\n      transform: rotate(1turn);\n    }\n  }\n\n  @-webkit-keyframes Select-animation-spin {\n    to {\n      -webkit-transform: rotate(1turn);\n    }\n  }\n'], ['\n  font-size: ', ';\n\n  /**\n   * React Select Plus\n   * =================\n   * MIT License: https://github.com/HubSpot/react-select-plus\n  */\n  .Select {\n    position: relative;\n  }\n\n  .Select,\n  .Select div,\n  .Select input,\n  .Select span {\n    -webkit-box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    box-sizing: border-box;\n  }\n\n  .Select.is-disabled > .Select-control {\n    background-color: #f9f9f9;\n  }\n\n  .Select.is-disabled > .Select-control:hover {\n    box-shadow: none;\n  }\n\n  .Select.is-disabled .Select-arrow-zone {\n    cursor: default;\n    pointer-events: none;\n    opacity: 0.35;\n  }\n\n  .Select-control {\n    background-color: #fff;\n    border-color: #d9d9d9 #ccc #b3b3b3;\n    border-radius: 4px;\n    border: 1px solid #ccc;\n    color: #333;\n    cursor: default;\n    display: table;\n    border-spacing: 0;\n    border-collapse: separate;\n    height: 36px;\n    outline: none;\n    overflow: hidden;\n    position: relative;\n    width: 100%;\n  }\n\n  .Select-control:hover {\n    box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);\n  }\n\n  .Select-control .Select-input:focus {\n    outline: none;\n  }\n\n  .is-searchable.is-open > .Select-control {\n    cursor: text;\n  }\n\n  .is-open > .Select-control {\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0;\n    background: #fff;\n    border-color: #b3b3b3 #ccc #d9d9d9;\n  }\n\n  .is-open > .Select-control .Select-arrow {\n    top: -2px;\n    border-color: transparent transparent #999;\n    border-width: 0 5px 5px;\n  }\n\n  .is-searchable.is-focused:not(.is-open) > .Select-control {\n    cursor: text;\n  }\n\n  .is-focused:not(.is-open) > .Select-control {\n    border-color: #007eff;\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 3px rgba(0, 126, 255, 0.1);\n  }\n\n  .Select-placeholder,\n  .Select--single > .Select-control .Select-value {\n    bottom: 0;\n    color: #aaa;\n    left: 0;\n    line-height: 34px;\n    padding-left: 10px;\n    padding-right: 10px;\n    position: absolute;\n    right: 0;\n    top: 0;\n    max-width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .has-value.Select--single > .Select-control .Select-value .Select-value-label,\n  .has-value.is-pseudo-focused.Select--single > .Select-control .Select-value .Select-value-label {\n    color: #333;\n  }\n\n  .has-value.Select--single > .Select-control .Select-value a.Select-value-label,\n  .has-value.is-pseudo-focused.Select--single > .Select-control .Select-value a.Select-value-label {\n    cursor: pointer;\n    text-decoration: none;\n  }\n\n  .has-value.Select--single > .Select-control .Select-value a.Select-value-label:hover,\n  .has-value.is-pseudo-focused.Select--single > .Select-control .Select-value a.Select-value-label:hover,\n  .has-value.Select--single > .Select-control .Select-value a.Select-value-label:focus,\n  .has-value.is-pseudo-focused.Select--single > .Select-control .Select-value a.Select-value-label:focus {\n    color: #007eff;\n    outline: none;\n    text-decoration: underline;\n  }\n\n  .Select-input {\n    height: 34px;\n    padding-left: 10px;\n    padding-right: 10px;\n    vertical-align: middle;\n  }\n\n  .Select-input > input {\n    width: 100%;\n    background: none transparent;\n    border: 0 none;\n    box-shadow: none;\n    cursor: default;\n    display: inline-block;\n    font-family: inherit;\n    font-size: inherit;\n    margin: 0;\n    outline: none;\n    line-height: 14px;\n\n    /* For IE 8 compatibility */\n    padding: 8px 0 12px;\n\n    /* For IE 8 compatibility */\n    -webkit-appearance: none;\n  }\n\n  .is-focused .Select-input > input {\n    cursor: text;\n  }\n\n  .has-value.is-pseudo-focused .Select-input {\n    opacity: 0;\n  }\n\n  .Select-control:not(.is-searchable) > .Select-input {\n    outline: none;\n  }\n\n  .Select-loading-zone {\n    cursor: pointer;\n    display: table-cell;\n    position: relative;\n    text-align: center;\n    vertical-align: middle;\n    width: 16px;\n  }\n\n  .Select-loading {\n    -webkit-animation: Select-animation-spin 400ms infinite linear;\n    -o-animation: Select-animation-spin 400ms infinite linear;\n    animation: Select-animation-spin 400ms infinite linear;\n    width: 16px;\n    height: 16px;\n    box-sizing: border-box;\n    border-radius: 50%;\n    border: 2px solid #ccc;\n    border-right-color: #333;\n    display: inline-block;\n    position: relative;\n    vertical-align: middle;\n  }\n\n  .Select-clear-zone {\n    -webkit-animation: Select-animation-fadeIn 200ms;\n    -o-animation: Select-animation-fadeIn 200ms;\n    animation: Select-animation-fadeIn 200ms;\n    color: #999;\n    cursor: pointer;\n    display: table-cell;\n    position: relative;\n    text-align: center;\n    vertical-align: middle;\n    width: 17px;\n  }\n\n  .Select-clear-zone:hover {\n    color: #d0021b;\n  }\n\n  .Select-clear {\n    display: inline-block;\n    font-size: 18px;\n    line-height: 1;\n  }\n\n  .Select--multi .Select-clear-zone {\n    width: 17px;\n  }\n\n  .Select-arrow-zone {\n    cursor: pointer;\n    display: table-cell;\n    position: relative;\n    text-align: center;\n    vertical-align: middle;\n    width: 25px;\n    padding-right: 5px;\n  }\n\n  .Select-arrow {\n    border-color: #999 transparent transparent;\n    border-style: solid;\n    border-width: 5px 5px 2.5px;\n    display: inline-block;\n    height: 0;\n    width: 0;\n    position: relative;\n  }\n\n  .is-open .Select-arrow,\n  .Select-arrow-zone:hover > .Select-arrow {\n    border-top-color: #666;\n  }\n\n  .Select--multi .Select-multi-value-wrapper {\n    display: inline-block;\n  }\n\n  .Select .Select-aria-only {\n    display: inline-block;\n    height: 1px;\n    width: 1px;\n    margin: -1px;\n    clip: rect(0, 0, 0, 0);\n    overflow: hidden;\n    float: left;\n  }\n\n  @-webkit-keyframes Select-animation-fadeIn {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n\n  @keyframes Select-animation-fadeIn {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n\n  .Select-menu-outer {\n    border-bottom-right-radius: 4px;\n    border-bottom-left-radius: 4px;\n    background-color: #fff;\n    border: 1px solid #ccc;\n    border-top-color: #e6e6e6;\n    box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);\n    box-sizing: border-box;\n    margin-top: -1px;\n    max-height: 200px;\n    position: absolute;\n    top: 100%;\n    width: 100%;\n    z-index: 1;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .Select-menu {\n    max-height: 198px;\n    overflow-y: auto;\n  }\n\n  .Select-option-group-label {\n    box-sizing: border-box;\n    background-color: #fff;\n    color: #666;\n    font-weight: bold;\n    cursor: default;\n    display: block;\n    padding: 8px 10px;\n  }\n\n  .Select-option-group-label ~ .Select-option,\n  .Select-option-group-label ~ .Select-option-group {\n    padding-left: 20px;\n  }\n\n  .Select-option {\n    box-sizing: border-box;\n    background-color: #fff;\n    color: #666;\n    cursor: pointer;\n    display: block;\n    padding: 8px 10px;\n  }\n\n  .Select-option:last-child {\n    border-bottom-right-radius: 4px;\n    border-bottom-left-radius: 4px;\n  }\n\n  .Select-option.is-selected {\n    background-color: #f5faff;\n\n    /* Fallback color for IE 8 */\n    background-color: rgba(0, 126, 255, 0.04);\n    color: #333;\n  }\n\n  .Select-option.is-focused {\n    background-color: #ebf5ff;\n\n    /* Fallback color for IE 8 */\n    background-color: rgba(0, 126, 255, 0.08);\n    color: #333;\n  }\n\n  .Select-option.is-disabled {\n    color: #ccc;\n    cursor: default;\n  }\n\n  .Select-noresults {\n    box-sizing: border-box;\n    color: #999;\n    cursor: default;\n    display: block;\n    padding: 8px 10px;\n  }\n\n  .Select--multi .Select-input {\n    vertical-align: middle;\n    margin-left: 10px;\n    padding: 0;\n  }\n\n  .Select--multi.has-value .Select-input {\n    margin-left: 5px;\n  }\n\n  .Select--multi .Select-value {\n    background-color: #ebf5ff;\n\n    /* Fallback color for IE 8 */\n    background-color: rgba(0, 126, 255, 0.08);\n    border-radius: 2px;\n    border: 1px solid #c2e0ff;\n\n    /* Fallback color for IE 8 */\n    border: 1px solid rgba(0, 126, 255, 0.24);\n    color: #007eff;\n    display: inline-block;\n    font-size: 0.9em;\n    line-height: 1.4;\n    margin-left: 5px;\n    margin-top: 5px;\n    vertical-align: top;\n  }\n\n  .Select--multi .Select-value-icon,\n  .Select--multi .Select-value-label {\n    display: inline-block;\n    vertical-align: middle;\n  }\n\n  .Select--multi .Select-value-label {\n    border-bottom-right-radius: 2px;\n    border-top-right-radius: 2px;\n    cursor: default;\n    padding: 2px 5px;\n  }\n\n  .Select--multi a.Select-value-label {\n    color: #007eff;\n    cursor: pointer;\n    text-decoration: none;\n  }\n\n  .Select--multi a.Select-value-label:hover {\n    text-decoration: underline;\n  }\n\n  .Select--multi .Select-value-icon {\n    cursor: pointer;\n    border-bottom-left-radius: 2px;\n    border-top-left-radius: 2px;\n    border-right: 1px solid #c2e0ff;\n\n    /* Fallback color for IE 8 */\n    border-right: 1px solid rgba(0, 126, 255, 0.24);\n    padding: 1px 5px 3px;\n  }\n\n  .Select--multi .Select-value-icon:hover,\n  .Select--multi .Select-value-icon:focus {\n    background-color: #d8eafd;\n\n    /* Fallback color for IE 8 */\n    background-color: rgba(0, 113, 230, 0.08);\n    color: #0071e6;\n  }\n\n  .Select--multi .Select-value-icon:active {\n    background-color: #c2e0ff;\n\n    /* Fallback color for IE 8 */\n    background-color: rgba(0, 126, 255, 0.24);\n  }\n\n  .Select--multi.is-disabled .Select-value {\n    background-color: #fcfcfc;\n    border: 1px solid #e3e3e3;\n    color: #333;\n  }\n\n  .Select--multi.is-disabled .Select-value-icon {\n    cursor: not-allowed;\n    border-right: 1px solid #e3e3e3;\n  }\n\n  .Select--multi.is-disabled .Select-value-icon:hover,\n  .Select--multi.is-disabled .Select-value-icon:focus,\n  .Select--multi.is-disabled .Select-value-icon:active {\n    background-color: #fcfcfc;\n  }\n\n  @keyframes Select-animation-spin {\n    to {\n      transform: rotate(1turn);\n    }\n  }\n\n  @-webkit-keyframes Select-animation-spin {\n    to {\n      -webkit-transform: rotate(1turn);\n    }\n  }\n']);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/**
 * Styling for the react-select-plus component.  Copied (with minimal formatting updates) from
 * https://github.com/HubSpot/react-select-plus/blob/master/dist/react-select-plus.css
 *
 * TODO: update to accept some modifiers to the styling and/or to pull colors from the theme.
 */
var SelectWrapper = function () {
  var c = _styledComponents2.default.div(_templateObject, (0, _decisivUiUtils.px2rem)(14));

  c.displayName = 'SelectWrapper';
  return c;
}();

exports.default = SelectWrapper;

/***/ }),

/***/ "./elements/Select/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactSelectPlus = __webpack_require__("../node_modules/react-select-plus/lib/index.js");

var _reactSelectPlus2 = _interopRequireDefault(_reactSelectPlus);

var _SelectWrapper = __webpack_require__("./elements/Select/SelectWrapper.js");

var _SelectWrapper2 = _interopRequireDefault(_SelectWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Select(props) {
  return _react2.default.createElement(
    _SelectWrapper2.default,
    null,
    _react2.default.createElement(_reactSelectPlus2.default, props)
  );
}

exports.default = Select;

/***/ }),

/***/ "./elements/SelectorButton/SelectorButton.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  align-items: center;\n  background-color: ' + props.theme.colors.base.chrome100 + ';\n  border-radius: 2px;\n  border: 1px solid ' + props.theme.colors.base.chrome200 + ';\n  color: ' + props.theme.colors.base.textLight + ';\n  display: flex;\n  font-size: ' + (0, _decisivUiUtils.px2rem)(12) + ';\n  height: ' + (0, _decisivUiUtils.px2rem)(25) + ';\n  min-width: ' + (0, _decisivUiUtils.px2rem)(130) + ';\n  padding-left: ' + (0, _decisivUiUtils.px2rem)(8) + ';\n  position: relative;\n  text-align: left;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome100: _propTypes2.default.string.isRequired,
      chrome200: _propTypes2.default.string.isRequired,
      textLight: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('SelectorButton', _styledComponents2.default.div, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./elements/SelectorButton/SelectorButtonAction.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getExpandedStyles = getExpandedStyles;

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getExpandedStyles(_ref) {
  var expanded = _ref.expanded,
      theme = _ref.theme;

  if (expanded) {
    return '\n      color: ' + theme.colors.base.linkHover + ';\n      text-decoration: underline;\n    ';
  }
  return '';
}

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  ' + getExpandedStyles(props) + '\n  cursor: pointer;\n  font-weight: 500;\n  padding-left: ' + (0, _decisivUiUtils.px2rem)(8) + ';\n  text-transform: capitalize;\n  display: flex;\n  flex: 1;\n  align-items: center;\n\n  &:hover {\n    color: ' + props.theme.colors.base.linkHover + ';\n    text-decoration: underline;\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      linkHover: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('SelectorButtonAction', _styledComponents2.default.div, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./elements/SelectorButton/SelectorOptionListElement.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var modifierConfig = {
  selected: function selected(_ref) {
    var theme = _ref.theme;
    return {
      styles: '\n      font-weight: bold;\n      color: ' + theme.colors.base.linkHover + ';\n    '
    };
  },
  small: function small() {
    return {
      styles: '\n      font-size: ' + (0, _decisivUiUtils.px2rem)(12) + ';\n    '
    };
  }
};

/* istanbul ignore next */
var styles = function styles(_ref2) {
  var theme = _ref2.theme;
  return '\n  color: ' + theme.colors.base.textLight + ';\n  cursor: pointer;\n  font-weight: normal;\n  list-style-type: none;\n  padding: ' + (0, _decisivUiUtils.px2rem)(8) + ';\n  text-transform: capitalize;\n  &:hover {\n    color: ' + theme.colors.base.linkHover + ';\n    text-decoration: underline;\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      linkHover: _propTypes2.default.string.isRequired,
      textLight: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('SelectorOptionListElement', _styledComponents2.default.li, styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

/***/ }),

/***/ "./elements/SelectorButton/SelectorOptionsList.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  margin: 0;\n  padding: 0;\n'], ['\n  margin: 0;\n  padding: 0;\n']);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SelectorOptionsList = function () {
  var c = _styledComponents2.default.ul(_templateObject);

  c.displayName = 'SelectorOptionsList';
  return c;
}();

exports.default = SelectorOptionsList;

/***/ }),

/***/ "./elements/SelectorButton/SelectorOptionsPopup.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _Card = __webpack_require__("./elements/Card/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var modifierConfig = {
  noPad: function noPad() {
    return {
      styles: '\n      padding: 0;\n    '
    };
  }
};

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  background-color: ' + props.theme.colors.base.background + ';\n  min-height: 0;\n  min-width: ' + (0, _decisivUiUtils.px2rem)(props.minWidth) + ';\n  padding: 0 ' + (0, _decisivUiUtils.px2rem)(8) + ';\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      background: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

var propTypes = {
  minWidth: _propTypes2.default.string
};

var defaultProps = {
  minWidth: (0, _decisivUiUtils.px2rem)(180)
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('SelectorOptionsPopup', (0, _styledComponents2.default)(_Card.Card), styles, { defaultProps: defaultProps, modifierConfig: modifierConfig, propTypes: propTypes, themePropTypes: themePropTypes });

/***/ }),

/***/ "./elements/SelectorButton/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectorOptionListElement = exports.SelectorOptionsList = exports.SelectorOptionsPopup = exports.SelectorButtonAction = exports.SelectorButton = undefined;

var _SelectorButton2 = __webpack_require__("./elements/SelectorButton/SelectorButton.js");

var _SelectorButton3 = _interopRequireDefault(_SelectorButton2);

var _SelectorButtonAction2 = __webpack_require__("./elements/SelectorButton/SelectorButtonAction.js");

var _SelectorButtonAction3 = _interopRequireDefault(_SelectorButtonAction2);

var _SelectorOptionsPopup2 = __webpack_require__("./elements/SelectorButton/SelectorOptionsPopup.js");

var _SelectorOptionsPopup3 = _interopRequireDefault(_SelectorOptionsPopup2);

var _SelectorOptionsList2 = __webpack_require__("./elements/SelectorButton/SelectorOptionsList.js");

var _SelectorOptionsList3 = _interopRequireDefault(_SelectorOptionsList2);

var _SelectorOptionListElement2 = __webpack_require__("./elements/SelectorButton/SelectorOptionListElement.js");

var _SelectorOptionListElement3 = _interopRequireDefault(_SelectorOptionListElement2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.SelectorButton = _SelectorButton3.default;
exports.SelectorButtonAction = _SelectorButtonAction3.default;
exports.SelectorOptionsPopup = _SelectorOptionsPopup3.default;
exports.SelectorOptionsList = _SelectorOptionsList3.default;
exports.SelectorOptionListElement = _SelectorOptionListElement3.default;

/***/ }),

/***/ "./elements/Span/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var modifierConfig = {
  capitalize: function capitalize() {
    return { styles: 'text-transform: capitalize;' };
  },
  textLight: function textLight(_ref) {
    var theme = _ref.theme;
    return { styles: 'color: ' + theme.colors.base.textLight + ';' };
  },
  weightNormal: function weightNormal() {
    return { styles: 'font-weight: normal;' };
  }
};

/* istanbul ignore next */
var styles = '';

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      textLight: _propTypes2.default.string.isRequired
    })
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Span', _styledComponents2.default.span, styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

/***/ }),

/***/ "./elements/SplitBlock/SplitBlock.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var modifierConfig = {
  flexColumn: function flexColumn() {
    return { styles: 'flex-flow: column wrap;' };
  },
  flexRow: function flexRow() {
    return { styles: 'flex-flow: row wrap;' };
  },
  pad: function pad() {
    return { styles: 'padding: ' + (0, _decisivUiUtils.px2rem)(8) + ';' };
  },
  padBottom: function padBottom() {
    return { styles: 'padding-bottom: ' + (0, _decisivUiUtils.px2rem)(8) + ';' };
  },
  padLeft: function padLeft() {
    return { styles: 'padding-left: ' + (0, _decisivUiUtils.px2rem)(8) + ';' };
  },
  padRight: function padRight() {
    return { styles: 'padding-right: ' + (0, _decisivUiUtils.px2rem)(8) + ';' };
  },
  padTop: function padTop() {
    return { styles: 'padding-top: ' + (0, _decisivUiUtils.px2rem)(8) + ';' };
  }
};

/* istanbul ignore next */
var styles = function styles() {
  return '\n  display: flex;\n  flex: 1;\n';
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('SplitBlock', _styledComponents2.default.div, styles, { modifierConfig: modifierConfig });

/***/ }),

/***/ "./elements/SplitBlock/SplitBlockElement.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var modifierConfig = {
  pad: function pad() {
    return { styles: 'padding: 0 ' + (0, _decisivUiUtils.px2rem)(8) + ';' };
  },
  padLeft: function padLeft() {
    return { styles: 'padding-left: ' + (0, _decisivUiUtils.px2rem)(8) + ';' };
  },
  padRight: function padRight() {
    return { styles: 'padding-right: ' + (0, _decisivUiUtils.px2rem)(8) + ';' };
  }
};

/* istanbul ignore next */
var styles = function styles() {
  return '\n  align-items: center;\n  display: flex;\n  h2 {\n    margin: 0;\n    padding-right: 0.5rem;\n  }\n  h3 {\n    margin: 0;\n    padding: 0.5rem;\n  }\n';
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('SplitBlockElement', _styledComponents2.default.div, styles, { modifierConfig: modifierConfig });

/***/ }),

/***/ "./elements/SplitBlock/SplitBlockPart.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var modifierConfig = {
  column: function column() {
    return { styles: 'flex-direction: column;' };
  },
  left: function left() {
    return { styles: 'justify-content: flex-start;' };
  },
  narrow: function narrow() {
    return { styles: 'flex: 0.5;' };
  },
  right: function right() {
    return { styles: 'justify-content: flex-end;' };
  },
  wide: function wide() {
    return { styles: 'flex: 2;' };
  },
  xNarrow: function xNarrow() {
    return { styles: 'flex: 0.25;' };
  }
};

/* istanbul ignore next */
var styles = function styles() {
  return '\n  display: flex;\n  flex: 1;\n';
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('SplitBlockPart', _styledComponents2.default.div, styles, { modifierConfig: modifierConfig });

/***/ }),

/***/ "./elements/SplitBlock/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SplitBlockElement = exports.SplitBlockPart = exports.SplitBlock = undefined;

var _SplitBlock2 = __webpack_require__("./elements/SplitBlock/SplitBlock.js");

var _SplitBlock3 = _interopRequireDefault(_SplitBlock2);

var _SplitBlockPart2 = __webpack_require__("./elements/SplitBlock/SplitBlockPart.js");

var _SplitBlockPart3 = _interopRequireDefault(_SplitBlockPart2);

var _SplitBlockElement2 = __webpack_require__("./elements/SplitBlock/SplitBlockElement.js");

var _SplitBlockElement3 = _interopRequireDefault(_SplitBlockElement2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.SplitBlock = _SplitBlock3.default; /**
                                            * The SplitBlock elements provide a reusable set of components that allow us to split a full
                                            * width <div> into left aligned and right aligned sections.
                                            *
                                            * Expected use is as follows:
                                            *
                                            * <SplitBlock modifiers={['pad']}>
                                            *   <SplitBlockPart modifiers={['left']} > // indicates that this part of the SplitBlock should
                                            *                                          // align left
                                            *     <SplitBlockElement modifiers={['padRight']}> // indicates that padding should be
                                            *                                          // applied to the right side of this element.
                                            *       {content}
                                            *     </SplitBlockElement>
                                            *   </SplitBlockPart>
                                            *   <SplitBlockPart modifiers={['right']} > // indicates that this part of the SplitBlock should
                                            *                                           // align right
                                            *     <SplitBlockElement modifiers={['padLeft']}>
                                            *       {content}
                                            *     </SplitBlockElement>
                                            *   </SplitBlockPart>
                                            * </SplitBlock>
                                            */

exports.SplitBlockPart = _SplitBlockPart3.default;
exports.SplitBlockElement = _SplitBlockElement3.default;

/***/ }),

/***/ "./elements/StatusSpan/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var modifierConfig = {
  approved: function approved(_ref) {
    var theme = _ref.theme;
    return { styles: 'color: ' + theme.colors.status.success + ';' };
  },
  bold: function bold() {
    return { styles: 'font-weight: 500;' };
  },
  capitalize: function capitalize() {
    return { styles: 'text-transform: capitalize;' };
  },
  declined: function declined(_ref2) {
    var theme = _ref2.theme;
    return { styles: 'color: ' + theme.colors.status.danger + ';' };
  },
  green: function green(_ref3) {
    var theme = _ref3.theme;
    return { styles: 'color: ' + theme.colors.status.success + ';' };
  },
  grey: function grey(_ref4) {
    var theme = _ref4.theme;
    return { styles: 'color: ' + theme.colors.status.default + ';' };
  },
  partiallyApproved: function partiallyApproved(_ref5) {
    var theme = _ref5.theme;
    return { styles: 'color: ' + theme.colors.status.warning + ';' };
  },
  pending: function pending(_ref6) {
    var theme = _ref6.theme;
    return { styles: 'color: ' + theme.colors.status.warning + ';' };
  },
  red: function red(_ref7) {
    var theme = _ref7.theme;
    return { styles: 'color: ' + theme.colors.status.danger + ';' };
  },
  requested: function requested(_ref8) {
    var theme = _ref8.theme;
    return { styles: 'color: ' + theme.colors.status.warning + ';' };
  },
  tall: function tall() {
    return { styles: 'display: block; height: ' + (0, _decisivUiUtils.px2rem)(24) + ';' };
  },
  uppercase: function uppercase() {
    return { styles: 'text-transform: uppercase;' };
  },
  yellow: function yellow(_ref9) {
    var theme = _ref9.theme;
    return { styles: 'color: ' + theme.colors.status.warning + ';' };
  }
};

/* istanbul ignore next */
var styles = '\n  display: inline-block;\n';

var themePropTypes = {
  colors: _propTypes2.default.shape({
    status: _propTypes2.default.shape({
      danger: _propTypes2.default.string.isRequired,
      default: _propTypes2.default.string.isRequired,
      success: _propTypes2.default.string.isRequired,
      warning: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('StatusSpan', _styledComponents2.default.span, styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

/***/ }),

/***/ "./elements/Table/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  ', '\n\n  border-spacing: 0;\n  ', '\n\n  tbody {\n    color: ', ';\n\n    tr {\n      text-align: left;\n\n      th {\n        font-weight: 500;\n        text-align: left;\n      }\n\n      td {\n        font-weight: 300;\n        vertical-align: text-top;\n      }\n\n      ', '\n    }\n  }\n'], ['\n  ', '\n\n  border-spacing: 0;\n  ', '\n\n  tbody {\n    color: ', ';\n\n    tr {\n      text-align: left;\n\n      th {\n        font-weight: 500;\n        text-align: left;\n      }\n\n      td {\n        font-weight: 300;\n        vertical-align: text-top;\n      }\n\n      ', '\n    }\n  }\n']);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledComponentsModifiers = __webpack_require__("../node_modules/styled-components-modifiers/dist/index.js");

var _styledComponentsThemeValidator = __webpack_require__("../node_modules/styled-components-theme-validator/dist/index.js");

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _styles = __webpack_require__("./utils/styles.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var COMPONENT_NAME = 'Table';

var TABLE_MODIFIER_CONFIG = {
  brand: function brand(_ref) {
    var theme = _ref.theme;
    return {
      styles: '\n      color: ' + theme.colors.brand.secondary + ',\n      font-size: ' + (0, _decisivUiUtils.px2rem)(20) + ',\n    '
    };
  },
  mediumGrey: function mediumGrey(_ref2) {
    var theme = _ref2.theme;
    return {
      styles: 'color: ' + theme.colors.base.chrome500 + ';'
    };
  },
  smallText: function smallText() {
    return {
      styles: '\n      font-size: ' + (0, _decisivUiUtils.px2rem)(12) + ';\n      th {\n        padding-left: ' + (0, _decisivUiUtils.px2rem)(8) + ' ' + (0, _decisivUiUtils.px2rem)(8) + ' 0;\n      }\n      td {\n        padding: ' + (0, _decisivUiUtils.px2rem)(8) + ' ' + (0, _decisivUiUtils.px2rem)(16) + ' ' + (0, _decisivUiUtils.px2rem)(8) + ' 0;\n      }\n    '
    };
  },
  xLargeText: function xLargeText() {
    return {
      styles: '\n      font-size: ' + (0, _decisivUiUtils.px2rem)(24) + ';\n      th {\n        padding-right: ' + (0, _decisivUiUtils.px2rem)(12) + ';\n      }\n      td {\n        padding-right: ' + (0, _decisivUiUtils.px2rem)(24) + ';\n      }\n    '
    };
  }
};

var TR_MODIFIER_CONFIG = {
  flex: function flex() {
    return {
      styles: '\n      display: flex;\n      flex-flow: row wrap;\n    '
    };
  },
  wide: function wide() {
    return {
      styles: '\n      th {\n        padding: 0;\n      }\n      td {\n        padding: 0 ' + (0, _decisivUiUtils.px2rem)(50) + ' 0 ' + (0, _decisivUiUtils.px2rem)(20) + ';\n      }\n    '
    };
  }
};

var THEME_PROPTYPES = (0, _styledComponentsThemeValidator.buildThemePropTypes)({
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome500: _propTypes2.default.string.isRequired,
      chrome700: _propTypes2.default.string.isRequired
    }).isRequired,
    brand: _propTypes2.default.shape({
      secondary: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
});

var Table = function () {
  var c = _styledComponents2.default.table(_templateObject, (0, _styledComponentsThemeValidator.validateTheme)(COMPONENT_NAME, THEME_PROPTYPES), (0, _styledComponentsModifiers.applyStyleModifiers)(TABLE_MODIFIER_CONFIG), function (_ref3) {
    var theme = _ref3.theme;
    return theme.colors.base.chrome700;
  }, (0, _styledComponentsModifiers.applyStyleModifiers)(TR_MODIFIER_CONFIG, 'trModifiers'));

  c.displayName = 'Table';
  return c;
}();

Table.propTypes = {
  modifiers: (0, _styledComponentsModifiers.styleModifierPropTypes)(TABLE_MODIFIER_CONFIG),
  trModifiers: (0, _styledComponentsModifiers.styleModifierPropTypes)(TR_MODIFIER_CONFIG)
};

Table.displayName = COMPONENT_NAME;

exports.default = (0, _styles.withTestTheme)(Table);

/***/ }),

/***/ "./elements/TextDiv/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var modifierConfig = {
  active: function active(_ref) {
    var theme = _ref.theme;
    return { styles: 'color: ' + theme.colors.base.link + ';' };
  },
  bold: function bold() {
    return { styles: 'font-weight: bold;' };
  },
  brand: function brand(_ref2) {
    var theme = _ref2.theme;
    return { styles: 'color: ' + theme.colors.brand.secondary + ';' };
  },
  bright: function bright(_ref3) {
    var theme = _ref3.theme;
    return { styles: 'color: ' + theme.colors.brand.primary + ';' };
  },
  bottomGap: function bottomGap() {
    return { styles: 'margin-bottom: ' + (0, _decisivUiUtils.px2rem)(4) + ';' };
  },
  capitalize: function capitalize() {
    return { styles: 'text-transform: capitalize;' };
  },
  darkGreyText: function darkGreyText(_ref4) {
    var theme = _ref4.theme;
    return { styles: 'color: ' + theme.colors.base.text + ';' };
  },
  ellipsis: function ellipsis() {
    return {
      styles: '\n      overflow: hidden;\n      text-overflow: ellipsis;\n    '
    };
  },
  heavyText: function heavyText() {
    return { styles: 'font-weight: 500;' };
  },
  inline: function inline() {
    return { styles: 'display: inline;' };
  },
  inlineBlock: function inlineBlock() {
    return { styles: 'display: inline-block;' };
  },
  italic: function italic() {
    return { styles: 'font-style: italic;' };
  },
  largeText: function largeText() {
    return { styles: 'font-size: ' + (0, _decisivUiUtils.px2rem)(24) + ';' };
  },
  lightGreyText: function lightGreyText(_ref5) {
    var theme = _ref5.theme;
    return { styles: 'color: ' + theme.colors.base.chrome300 + ';' };
  },
  lightText: function lightText() {
    return { styles: 'font-weight: 300;' };
  },
  mediumText: function mediumText() {
    return {
      styles: '\n      font-size: ' + (0, _decisivUiUtils.px2rem)(14) + ';\n      line-height: ' + (0, _decisivUiUtils.px2rem)(18) + ';\n    '
    };
  },
  mediumLargeText: function mediumLargeText() {
    return { styles: 'font-size: ' + (0, _decisivUiUtils.px2rem)(20) + ';' };
  },
  midGreyText: function midGreyText(_ref6) {
    var theme = _ref6.theme;
    return { styles: 'color: ' + theme.colors.base.textLight + ';' };
  },
  multiLine: function multiLine() {
    return { styles: 'white-space: pre-line;' };
  },
  oneLine: function oneLine() {
    return { styles: 'white-space: nowrap;' };
  },
  padRight: function padRight() {
    return { styles: 'padding-right: ' + (0, _decisivUiUtils.px2rem)(8) + ';' };
  },
  short: function short() {
    return {
      styles: '\n      -webkit-box-orient: vertical;\n      -webkit-line-clamp: 3;\n      display: -webkit-box;\n      height: ' + (0, _decisivUiUtils.px2rem)(45) + ';\n      line-height: ' + (0, _decisivUiUtils.px2rem)(15) + ';\n    '
    };
  },
  smallText: function smallText() {
    return {
      styles: '\n      font-size: ' + (0, _decisivUiUtils.px2rem)(12) + ';\n      line-height: ' + (0, _decisivUiUtils.px2rem)(18) + ';\n    '
    };
  },
  smallWidth: function smallWidth() {
    return {
      styles: '\n      max-width: 12rem;\n      width: 100%;\n    '
    };
  },
  statusDefault: function statusDefault(_ref7) {
    var theme = _ref7.theme;
    return { styles: 'color: ' + theme.colors.status.default + ';' };
  },
  statusInfo: function statusInfo(_ref8) {
    var theme = _ref8.theme;
    return { styles: 'color: ' + theme.colors.status.info + ';' };
  },
  uppercase: function uppercase() {
    return { styles: 'text-transform: uppercase;' };
  },
  xLargeText: function xLargeText() {
    return {
      styles: '\n      font-size: ' + (0, _decisivUiUtils.px2rem)(30) + ';\n      line-height: ' + (0, _decisivUiUtils.px2rem)(26) + ';\n      .fa {\n        font-size: ' + (0, _decisivUiUtils.px2rem)(30) + ';\n        line-height: ' + (0, _decisivUiUtils.px2rem)(26) + ';\n      }\n    '
    };
  },
  xSmallText: function xSmallText() {
    return {
      styles: '\n      font-size: ' + (0, _decisivUiUtils.px2rem)(10) + ';\n    '
    };
  },
  textAlignRight: function textAlignRight() {
    return {
      styles: '\n      text-align: right;\n    '
    };
  },
  textAlignCenter: function textAlignCenter() {
    return {
      styles: '\n      text-align: center;\n    '
    };
  }
};

/* istanbul ignore next */
var styles = '\n  position: relative;\n';

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome300: _propTypes2.default.string.isRequired,
      link: _propTypes2.default.string.isRequired,
      text: _propTypes2.default.string.isRequired,
      textLight: _propTypes2.default.string.isRequired
    }),
    brand: _propTypes2.default.shape({
      primary: _propTypes2.default.string.isRequired,
      secondary: _propTypes2.default.string.isRequired
    }).isRequired,
    status: _propTypes2.default.shape({
      default: _propTypes2.default.string.isRequired,
      info: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('TextDiv', _styledComponents2.default.div, styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

/***/ }),

/***/ "./elements/Textarea/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  border-radius: 2px;\n  border: 1px solid ' + props.theme.colors.base.chrome300 + ';\n  color: ' + props.theme.colors.base.text + ';\n  flex: 1;\n  font-size: ' + (0, _decisivUiUtils.px2rem)(12) + ';\n  height: ' + (0, _decisivUiUtils.px2rem)(90) + ';\n  line-height: ' + (0, _decisivUiUtils.px2rem)(18) + ';\n  padding: ' + (0, _decisivUiUtils.px2rem)(6) + ' ' + (0, _decisivUiUtils.px2rem)(9) + ';\n  resize: none;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome300: _propTypes2.default.string.isRequired,
      text: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Textarea', _styledComponents2.default.textarea, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./elements/TextareaAutosize/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactAutosizeTextarea = __webpack_require__("../node_modules/react-autosize-textarea/lib/index.js");

var _reactAutosizeTextarea2 = _interopRequireDefault(_reactAutosizeTextarea);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {};

/* istanbul ignore next */
var styles = function styles(_ref) {
  var theme = _ref.theme;
  return '\n  border: none;\n  box-sizing: border-box;\n  color: ' + theme.colors.base.text + ';\n  font-size: ' + (0, _decisivUiUtils.px2rem)(12) + ';\n  line-height: ' + (0, _decisivUiUtils.px2rem)(19) + ';\n  padding-left: 0;\n  resize: none;\n  width: 100%;\n  &::placeholder {\n    color: ' + theme.colors.base.chrome300 + ';\n    font-weight: 300;\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome300: _propTypes2.default.string.isRequired,
      text: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('TextareaAutosize', (0, _styledComponents2.default)(_reactAutosizeTextarea2.default), styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

/***/ }),

/***/ "./elements/Tooltip/Arrow.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var modifierConfig = {
  bottom: function bottom() {
    return {
      styles: '\n      transform: translateX(50%) translateY(50%) rotate(-45deg) scale(1.3);\n      right: 50%;\n      top: 0;\n      margin-top: 0;\n    '
    };
  },
  left: function left() {
    return {
      styles: '\n      transform: translateX(-50%) translateY(50%) rotate(45deg) scale(1.3);\n      bottom: 50%;\n      right: 0;\n      margin-right: 0;\n    '
    };
  },
  right: function right() {
    return {
      styles: '\n      transform: translateX(50%) translateY(50%) rotate(-135deg) scale(1.3);\n      bottom: 50%;\n      left: 0;\n      margin-left: 0;\n    '
    };
  },
  top: function top() {
    return {
      styles: '\n      transform: translateX(50%) translateY(-50%) rotate(135deg) scale(1.3);\n      right: 50%;\n      bottom: 0;\n      margin-bottom: 0;\n    '
    };
  }
};

/* istanbul ignore next */
var styles = function styles(_ref) {
  var _ref$theme = _ref.theme,
      colors = _ref$theme.colors,
      dimensions = _ref$theme.dimensions;
  return '\n  background-color: ' + colors.base.chrome700 + ';\n  height: ' + dimensions.tooltipArrowSize + ';\n  position: absolute;\n  transition: all 0.3s ease 0ms;\n  width: ' + dimensions.tooltipArrowSize + ';\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome700: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired,
  dimensions: _propTypes2.default.shape({
    tooltipArrowSize: _propTypes2.default.string.isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Arrow', _styledComponents2.default.div, styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

/***/ }),

/***/ "./elements/Tooltip/ContentWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var modifierConfig = {
  active: function active() {
    return {
      styles: '\n      transition: opacity 0.5s;\n      opacity: 1;\n    '
    };
  },
  bottom: function bottom(_ref) {
    var theme = _ref.theme;
    return {
      styles: '\n      transform: translateX(50%) translateY(0);\n      padding-top: ' + theme.dimensions.tooltipArrowSize + ';\n      top: 80%;\n      right: 50%;\n    '
    };
  },
  left: function left(_ref2) {
    var theme = _ref2.theme;
    return {
      styles: '\n      transform: translateX(0) translateY(50%);\n      padding-right: ' + theme.dimensions.tooltipArrowSize + ';\n      right: 80%;\n      bottom: 50%;\n    '
    };
  },
  right: function right(_ref3) {
    var theme = _ref3.theme;
    return {
      styles: '\n      transform: translateX(0) translateY(50%);\n      padding-left: ' + theme.dimensions.tooltipArrowSize + ';\n      left: 80%;\n      bottom: 50%;\n    '
    };
  },
  top: function top(_ref4) {
    var theme = _ref4.theme;
    return {
      styles: '\n      transform: translateX(50%) translateY(0);\n      padding-bottom: ' + theme.dimensions.tooltipArrowSize + ';\n      bottom: 80%;\n      right: 50%;\n    '
    };
  }
};

/* istanbul ignore next */
var styles = function styles(_ref5) {
  var colors = _ref5.theme.colors;
  return '\n  filter: drop-shadow(0 3px 7px ' + colors.base.shadow + ');\n  flex-flow: column nowrap;\n  position: absolute;\n  z-index: 10;\n  opacity: 0;\n  pointer-events: none;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      shadow: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired,
  dimensions: _propTypes2.default.shape({
    tooltipArrowSize: _propTypes2.default.string.isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('ContentWrapper', _styledComponents2.default.div, styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

/***/ }),

/***/ "./elements/Tooltip/InsideContentWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(_ref) {
  var _ref$theme = _ref.theme,
      colors = _ref$theme.colors,
      fonts = _ref$theme.fonts;
  return '\n  background-color: ' + colors.base.chrome700 + ';\n  border-radius: ' + (0, _decisivUiUtils.px2rem)(2) + ';\n  color: ' + colors.base.chrome000 + ';\n  font-size: ' + (0, _decisivUiUtils.px2rem)(12) + ';\n  line-height: ' + (0, _decisivUiUtils.px2rem)(22) + ';\n  padding: ' + (0, _decisivUiUtils.px2rem)(2) + ' ' + (0, _decisivUiUtils.px2rem)(20) + ';\n  position: relative;\n  white-space: nowrap;\n  font-family: ' + fonts.primary + '\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome000: _propTypes2.default.string.isRequired,
      chrome700: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired,
  fonts: _propTypes2.default.shape({
    primary: _propTypes2.default.string.isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('InsideContentWrapper', _styledComponents2.default.div, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./elements/Tooltip/TargetWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = function styles() {
  return '\n  flex: 1;\n  cursor: pointer;\n';
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('TargetWrapper', _styledComponents2.default.div, styles);

/***/ }),

/***/ "./elements/Tooltip/Wrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = '\n  position: relative;\n  box-sizing: border-box;\n';

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Tooltip.Wrapper', _styledComponents2.default.div, styles);

/***/ }),

/***/ "./elements/Tooltip/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tooltip = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _Wrapper = __webpack_require__("./elements/Tooltip/Wrapper.js");

var _Wrapper2 = _interopRequireDefault(_Wrapper);

var _ContentWrapper = __webpack_require__("./elements/Tooltip/ContentWrapper.js");

var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);

var _TargetWrapper = __webpack_require__("./elements/Tooltip/TargetWrapper.js");

var _TargetWrapper2 = _interopRequireDefault(_TargetWrapper);

var _InsideContentWrapper = __webpack_require__("./elements/Tooltip/InsideContentWrapper.js");

var _InsideContentWrapper2 = _interopRequireDefault(_InsideContentWrapper);

var _Arrow = __webpack_require__("./elements/Tooltip/Arrow.js");

var _Arrow2 = _interopRequireDefault(_Arrow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
  * Creates a tooltip component, ie '<Tooltip>{children}</Tooltip>'
  * @prop {position} Position of tooltip to target; must be one of ['left','top','right','bottom']
  * @prop {message} Either a string message, or a function returning a message, for display
  *                 in the Tooltip
  * @prop {children} The target of where the hover will be shown
  * @return {String} The tooltip component
*/
var Tooltip = exports.Tooltip = function (_Component) {
  _inherits(Tooltip, _Component);

  function Tooltip() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Tooltip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call.apply(_ref, [this].concat(args))), _this), _this.state = { isTooltipShown: false }, _this.hide = function () {
      if (!_this.state.isTooltipShown) return;
      _this.setState({ isTooltipShown: false });
    }, _this.show = function () {
      if (_this.state.isTooltipShown) return;
      _this.setState({ isTooltipShown: true });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Tooltip, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          message = _props.message,
          position = _props.position;
      var isTooltipShown = this.state.isTooltipShown;


      return _react2.default.createElement(
        _Wrapper2.default,
        {
          onMouseLeave: this.hide,
          onMouseEnter: this.show
        },
        _react2.default.createElement(
          _TargetWrapper2.default,
          null,
          children
        ),
        _react2.default.createElement(
          _ContentWrapper2.default,
          {
            modifiers: (0, _lodash.compact)([!!isTooltipShown && 'active', position])
          },
          _react2.default.createElement(_Arrow2.default, { modifiers: [position] }),
          _react2.default.createElement(
            _InsideContentWrapper2.default,
            null,
            (0, _lodash.isFunction)(message) ? message() : message
          )
        )
      );
    }
  }]);

  return Tooltip;
}(_react.Component);

Tooltip.propTypes = {
  children: _propTypes2.default.node.isRequired,
  position: _propTypes2.default.oneOf(['bottom', 'left', 'right', 'top']),
  message: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired
};
Tooltip.defaultProps = { position: 'bottom' };


Tooltip.displayName = 'Tooltip';

exports.default = Tooltip;

/***/ }),

/***/ "./elements/VerticalDivider/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  dark: function dark(_ref) {
    var theme = _ref.theme;
    return {
      styles: 'background-color: ' + theme.colors.base.chrome300 + ';'
    };
  }
};

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  background-color: ' + props.theme.colors.base.chrome200 + ';\n  height: 100%;\n  width: 1px;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome200: _propTypes2.default.string.isRequired,
      chrome300: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('VerticalDivider', _styledComponents2.default.div, styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

/***/ }),

/***/ "./elements/Widget/Header/HeaderLine.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  border-bottom: 1px solid ' + props.theme.colors.base.chrome400 + ';\n  flex: 1;\n  margin-bottom: ' + (0, _decisivUiUtils.px2rem)(10) + ';\n  margin-left: ' + (0, _decisivUiUtils.px2rem)(10) + ';\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome400: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('HeaderLine', _styledComponents2.default.div, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./elements/Widget/Header/HeaderNote.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  color: ' + props.theme.colors.base.textLight + ';\n  font-size: ' + (0, _decisivUiUtils.px2rem)(18) + ';\n  height: ' + (0, _decisivUiUtils.px2rem)(22) + ';\n  line-height: ' + (0, _decisivUiUtils.px2rem)(22) + ';\n  margin-left: ' + (0, _decisivUiUtils.px2rem)(8) + ';\n  padding: 0;\n  text-transform: uppercase;\n';
}; /**
    * The HeaderNote provides a styled <h2> element that is used at the top of the widget only.
    */

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      textLight: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('HeaderNote', _styledComponents2.default.span, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./elements/Widget/Header/HeaderTitle.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  color: ' + props.theme.colors.base.textLight + ';\n  font-size: ' + (0, _decisivUiUtils.px2rem)(18) + ';\n  font-weight: 500;\n  height: ' + (0, _decisivUiUtils.px2rem)(22) + ';\n  line-height: ' + (0, _decisivUiUtils.px2rem)(22) + ';\n  margin: 0;\n  padding: 0;\n  text-transform: uppercase;\n';
}; /**
    * The HeaderTitle provides a styled <h2> element that is used at the top of the widget only.
    */

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      textLight: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('HeaderTitle', _styledComponents2.default.h2, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./elements/Widget/Header/Wrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  width: 100%;\n'], ['\n  display: flex;\n  width: 100%;\n']);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = function () {
  var c = _styledComponents2.default.div(_templateObject);

  c.displayName = 'Wrapper';
  return c;
}();

exports.default = Wrapper;

/***/ }),

/***/ "./elements/Widget/Header/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Wrapper = __webpack_require__("./elements/Widget/Header/Wrapper.js");

var _Wrapper2 = _interopRequireDefault(_Wrapper);

var _HeaderTitle = __webpack_require__("./elements/Widget/Header/HeaderTitle.js");

var _HeaderTitle2 = _interopRequireDefault(_HeaderTitle);

var _HeaderNote = __webpack_require__("./elements/Widget/Header/HeaderNote.js");

var _HeaderNote2 = _interopRequireDefault(_HeaderNote);

var _HeaderLine = __webpack_require__("./elements/Widget/Header/HeaderLine.js");

var _HeaderLine2 = _interopRequireDefault(_HeaderLine);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Header(_ref) {
  var children = _ref.children,
      note = _ref.note;

  return _react2.default.createElement(
    _Wrapper2.default,
    null,
    _react2.default.createElement(
      _HeaderTitle2.default,
      null,
      children
    ),
    note && _react2.default.createElement(
      _HeaderNote2.default,
      null,
      note
    ),
    _react2.default.createElement(_HeaderLine2.default, null)
  );
}

Header.propTypes = {
  children: _propTypes2.default.node,
  note: _propTypes2.default.string
};

Header.defaultProps = {
  children: null,
  note: ''
};

Header.displayName = 'Header';

exports.default = Header;

/***/ }),

/***/ "./elements/Widget/Item.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/styled-components-reactive-grid/dist/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
/**
 * The WidgetItem component provides a padded block within the body of the card. It encapsulates
 * sections to provide the expected gaps on all sides.
 */

var styles = function styles() {
  return '\n  padding: ' + (0, _decisivUiUtils.px2rem)(11) + ' ' + (0, _decisivUiUtils.px2rem)(14) + ';\n  display: ' + function (_ref) {
    var horizontal = _ref.horizontal;
    return horizontal === true ? 'flex' : 'block';
  } + ';\n';
};

var propTypes = {
  horizontal: _propTypes2.default.bool
};

var defaultProps = {
  horizontal: false
};

var Item = (0, _decisivUiUtils.buildStyledComponent)('Item', (0, _styledComponents2.default)(_styledComponentsReactiveGrid.Container), styles, { defaultProps: defaultProps, propTypes: propTypes });

exports.default = Item;

/***/ }),

/***/ "./elements/Widget/OptionsBar.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledComponentsReactiveGrid = __webpack_require__("../node_modules/styled-components-reactive-grid/dist/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  background-color: ' + props.theme.colors.base.chrome100 + ';\n  border: 1px solid ' + props.theme.colors.base.chrome200 + ';\n  color: ' + props.theme.colors.base.textLight + ';\n  font-size: ' + (0, _decisivUiUtils.px2rem)(12) + ';\n  line-height: ' + (0, _decisivUiUtils.px2rem)(15) + ';\n  margin-top: ' + (0, _decisivUiUtils.px2rem)(8) + ';\n  padding-bottom: 0;\n  padding-top: 0;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome100: _propTypes2.default.string.isRequired,
      chrome200: _propTypes2.default.string.isRequired,
      textLight: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('OptionsBar', (0, _styledComponents2.default)(_styledComponentsReactiveGrid.Container), styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./elements/Widget/Pagination/PageItem.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
var modifierConfig = {
  selected: function selected(_ref) {
    var theme = _ref.theme;
    return {
      styles: 'color: ' + theme.colors.base.text + ';'
    };
  }
};

/* istanbul ignore next */
var styles = function styles(_ref2) {
  var theme = _ref2.theme;
  return '\n  color: ' + theme.colors.base.chrome500 + ';\n  font-size: ' + (0, _decisivUiUtils.px2rem)(15) + ';\n  font-weight: normal;\n  padding-right: ' + (0, _decisivUiUtils.px2rem)(16) + ';\n  text-decoration: none;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome500: _propTypes2.default.string.isRequired,
      text: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

var propTypes = {
  selected: _propTypes2.default.bool
};

var defaultProps = {
  selected: false
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('PageItem', _styledComponents2.default.a, styles, { defaultProps: defaultProps, modifierConfig: modifierConfig, propTypes: propTypes, themePropTypes: themePropTypes });

/***/ }),

/***/ "./elements/Widget/Pagination/Paginator/PaginatorWrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n'], ['\n  display: flex;\n']);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var PaginatorWrapper = function () {
  var c = _styledComponents2.default.div(_templateObject);

  c.displayName = 'PaginatorWrapper';
  return c;
}();

exports.default = PaginatorWrapper;

/***/ }),

/***/ "./elements/Widget/Pagination/Paginator/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactFontawesome = __webpack_require__("../node_modules/react-fontawesome/lib/index.js");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _PaginatorWrapper = __webpack_require__("./elements/Widget/Pagination/Paginator/PaginatorWrapper.js");

var _PaginatorWrapper2 = _interopRequireDefault(_PaginatorWrapper);

var _PageItem = __webpack_require__("./elements/Widget/Pagination/PageItem.js");

var _PageItem2 = _interopRequireDefault(_PageItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function buildPageLinks(totalPages, currentPage, onPageClicked) {
  var rawArray = [].concat(_toConsumableArray(Array(totalPages).keys()));
  var pageLinkArray = rawArray.map(function (v) {
    return v + 1;
  });
  return pageLinkArray.map(function (pageNum) {
    return _react2.default.createElement(
      _PageItem2.default,
      {
        key: pageNum,
        href: '#',
        selected: pageNum === currentPage,
        onClick: function onClick(e) {
          e.preventDefault();
          onPageClicked(pageNum);
        }
      },
      pageNum
    );
  });
}

function Paginator(_ref) {
  var totalPages = _ref.totalPages,
      currentPage = _ref.currentPage,
      onPrevClicked = _ref.onPrevClicked,
      onNextClicked = _ref.onNextClicked,
      onPageClicked = _ref.onPageClicked;

  return _react2.default.createElement(
    _PaginatorWrapper2.default,
    null,
    _react2.default.createElement(
      _PageItem2.default,
      {
        href: '#',
        onClick: onPrevClicked
      },
      _react2.default.createElement(_reactFontawesome2.default, { name: 'chevron-left' })
    ),
    buildPageLinks(totalPages, currentPage, onPageClicked),
    _react2.default.createElement(
      _PageItem2.default,
      {
        href: '#',
        onClick: onNextClicked
      },
      _react2.default.createElement(_reactFontawesome2.default, { name: 'chevron-right' })
    )
  );
}

Paginator.propTypes = {
  totalPages: _propTypes2.default.number.isRequired,
  currentPage: _propTypes2.default.number.isRequired,
  onPrevClicked: _propTypes2.default.func.isRequired,
  onNextClicked: _propTypes2.default.func.isRequired,
  onPageClicked: _propTypes2.default.func.isRequired
};

exports.default = Paginator;

/***/ }),

/***/ "./elements/Widget/Pagination/Wrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  justify-content: space-between;\n'], ['\n  display: flex;\n  justify-content: space-between;\n']);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = function () {
  var c = _styledComponents2.default.div(_templateObject);

  c.displayName = 'Wrapper';
  return c;
}();

exports.default = Wrapper;

/***/ }),

/***/ "./elements/Widget/Pagination/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactFontawesome = __webpack_require__("../node_modules/react-fontawesome/lib/index.js");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _Wrapper = __webpack_require__("./elements/Widget/Pagination/Wrapper.js");

var _Wrapper2 = _interopRequireDefault(_Wrapper);

var _Paginator = __webpack_require__("./elements/Widget/Pagination/Paginator/index.js");

var _Paginator2 = _interopRequireDefault(_Paginator);

var _PageItem = __webpack_require__("./elements/Widget/Pagination/PageItem.js");

var _PageItem2 = _interopRequireDefault(_PageItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Pagination(_ref) {
  var totalPages = _ref.totalPages,
      currentPage = _ref.currentPage,
      onPrevClicked = _ref.onPrevClicked,
      onNextClicked = _ref.onNextClicked,
      onPageClicked = _ref.onPageClicked,
      onAddClicked = _ref.onAddClicked;

  return _react2.default.createElement(
    _Wrapper2.default,
    null,
    _react2.default.createElement(_Paginator2.default, {
      totalPages: totalPages,
      currentPage: currentPage,
      onPrevClicked: onPrevClicked,
      onNextClicked: onNextClicked,
      onPageClicked: onPageClicked
    }),
    _react2.default.createElement(
      _PageItem2.default,
      { href: '#', onClick: function onClick() {
          return onAddClicked();
        } },
      _react2.default.createElement(_reactFontawesome2.default, { name: 'plus' })
    )
  );
}

Pagination.propTypes = {
  totalPages: _propTypes2.default.number.isRequired,
  currentPage: _propTypes2.default.number.isRequired,
  onPrevClicked: _propTypes2.default.func.isRequired,
  onNextClicked: _propTypes2.default.func.isRequired,
  onPageClicked: _propTypes2.default.func.isRequired,
  onAddClicked: _propTypes2.default.func.isRequired
};

exports.default = Pagination;

/***/ }),

/***/ "./elements/Widget/SubHeader.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  small: function small() {
    return { styles: 'font-size: ' + (0, _decisivUiUtils.px2rem)(12) + ';' };
  },
  statusDanger: function statusDanger(_ref) {
    var theme = _ref.theme;
    return { styles: 'color: ' + theme.colors.status.danger + ';' };
  },
  statusInfo: function statusInfo(_ref2) {
    var theme = _ref2.theme;
    return { styles: 'color: ' + theme.colors.status.info + ';' };
  },
  statusSuccess: function statusSuccess(_ref3) {
    var theme = _ref3.theme;
    return { styles: 'color: ' + theme.colors.status.success + ';' };
  },
  statusWarning: function statusWarning(_ref4) {
    var theme = _ref4.theme;
    return { styles: 'color: ' + theme.colors.status.warning + ';' };
  }
};

/* istanbul ignore next */
/**
 * The WidgetSubHeader provides a styled <h3> element typically used to declare a status or name a
 * specific value within the Widget. It is typically encapsulated in its own WidgetItem component.
 */

var styles = function styles(props) {
  return '\n  color: ' + props.theme.colors.base.text + ';\n  font-size: ' + (0, _decisivUiUtils.px2rem)(16) + ';\n  font-weight: 600;\n  margin: 0;\n  padding: 0;\n  text-transform: uppercase;\n\n  .value {\n    font-weight: 300;\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired,
    status: _propTypes2.default.shape({
      danger: _propTypes2.default.string.isRequired,
      info: _propTypes2.default.string.isRequired,
      success: _propTypes2.default.string.isRequired,
      warning: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('SubHeader', _styledComponents2.default.h3, styles, { modifierConfig: modifierConfig, themePropTypes: themePropTypes });

/***/ }),

/***/ "./elements/Widget/Table.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The WidgetTable component creates some specific styling around the table structure unique to
 * widgets. Specifically, there is a gap between the header cells and the display cells, which
 * are aligned vertically. Use the WidgetTable to build any table within a widget.
 */

var modifierConfig = {
  noFlex: function noFlex() {
    return {
      styles: '\n      flex: none;\n      margin-right: ' + (0, _decisivUiUtils.px2rem)(40) + ';\n    '
    };
  },
  padRight: function padRight() {
    return {
      styles: '\n      th {\n        padding-right: ' + (0, _decisivUiUtils.px2rem)(26) + '\n      }\n    '
    };
  }
};

var styles = function styles() {
  return '\n  font-size: ' + (0, _decisivUiUtils.px2rem)(12) + ';\n  flex: 1;\n  display: block;\n\n  th {\n    padding-right: 1em;\n    text-align: left;\n    vertical-align: top;\n  }\n\n  td {\n    vertical-align: top;\n  }\n';
};

var Table = (0, _decisivUiUtils.buildStyledComponent)('Table', _styledComponents2.default.table, styles, { modifierConfig: modifierConfig });

exports.default = Table;

/***/ }),

/***/ "./elements/Widget/TableRow.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The TableRow component is used to apply a gap above table rows as is shown in the designs.
 * As this gap is not always present, it must be passed in as a prop. For consistency within the
 * component, all rows should use the WidgetTableRow component.
 */

var modifierConfig = {
  topGap: function topGap() {
    return {
      styles: '\n      & > th,\n      & > td {\n        padding-top: ' + (0, _decisivUiUtils.px2rem)(14) + ';\n      }\n    '
    };
  },
  topGapSmall: function topGapSmall() {
    return {
      styles: '\n      & > th,\n      & > td {\n        padding-top: ' + (0, _decisivUiUtils.px2rem)(4) + ';\n      }\n    '
    };
  }
};

var styles = function styles() {
  return '\n  & > th,\n  & > td {\n    padding-top: 0;\n  }\n';
};

var TableRow = (0, _decisivUiUtils.buildStyledComponent)('TableRow', _styledComponents2.default.tr, styles, { modifierConfig: modifierConfig });

exports.default = TableRow;

/***/ }),

/***/ "./elements/Widget/Wrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Wrapper component for Grid
 */
/* istanbul ignore next */
var styles = function styles(props) {
  return '\n  padding: ' + props.theme.dimensions.gridGutterSizeHalf + ';\n  box-sizing: border-box;\n';
};

var themePropTypes = {
  dimensions: _propTypes2.default.shape({
    gridGutterSizeHalf: _propTypes2.default.string.isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('WidgetWrapper', _styledComponents2.default.div, styles, { themePropTypes: themePropTypes });

/***/ }),

/***/ "./elements/Widget/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Expandable = __webpack_require__("./containers/Expandable/index.js");

var _Expandable2 = _interopRequireDefault(_Expandable);

var _baseComponents = __webpack_require__("../node_modules/base-components/build/index.js");

var _Header = __webpack_require__("./elements/Widget/Header/index.js");

var _Header2 = _interopRequireDefault(_Header);

var _Item = __webpack_require__("./elements/Widget/Item.js");

var _Item2 = _interopRequireDefault(_Item);

var _OptionsBar = __webpack_require__("./elements/Widget/OptionsBar.js");

var _OptionsBar2 = _interopRequireDefault(_OptionsBar);

var _Pagination = __webpack_require__("./elements/Widget/Pagination/index.js");

var _Pagination2 = _interopRequireDefault(_Pagination);

var _SubHeader = __webpack_require__("./elements/Widget/SubHeader.js");

var _SubHeader2 = _interopRequireDefault(_SubHeader);

var _Table = __webpack_require__("./elements/Widget/Table.js");

var _Table2 = _interopRequireDefault(_Table);

var _TableRow = __webpack_require__("./elements/Widget/TableRow.js");

var _TableRow2 = _interopRequireDefault(_TableRow);

var _Wrapper = __webpack_require__("./elements/Widget/Wrapper.js");

var _Wrapper2 = _interopRequireDefault(_Wrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
  Props:
    expandKey: It is a unique key per widget so that it's expand/collapse status
      is stored in local storage.
      Prefix is there "widget-" so if expandKey is "test" actual key stored in local storage
      will be "widget-test"
      It is important not to use same name (you can pass this prop like sending id)
      between different widgets.
*/

var Widget = function (_Component) {
  _inherits(Widget, _Component);

  function Widget() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Widget);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Widget.__proto__ || Object.getPrototypeOf(Widget)).call.apply(_ref, [this].concat(args))), _this), _this.getHeader = function () {
      var children = _this.props.children;

      var targetComponent = _react2.default.Children.toArray(children).filter(function (c) {
        return c.type.displayName === 'Header';
      })[0];
      return targetComponent;
    }, _this.getContent = function () {
      var children = _this.props.children;

      var contentComponents = _react2.default.Children.toArray(children).filter(function (c) {
        return c.type.displayName !== 'Header';
      });
      return contentComponents;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Widget, [{
    key: 'render',
    value: function render() {
      var expandKey = this.props.expandKey;

      return _react2.default.createElement(
        _Wrapper2.default,
        null,
        _react2.default.createElement(
          _Expandable2.default,
          { expandKey: 'widget-' + expandKey, expandOnHeaderClick: true },
          _react2.default.createElement(
            _Expandable.ExpandableHeader,
            null,
            this.getHeader()
          ),
          _react2.default.createElement(
            _Expandable.ExpandableContent,
            null,
            this.getContent()
          )
        )
      );
    }
  }]);

  return Widget;
}(_react.Component);

Widget.propTypes = {
  children: _propTypes2.default.node,
  expandKey: _propTypes2.default.string.isRequired
};
Widget.defaultProps = {
  children: null,
  expandKey: ''
};


Widget.Divider = _baseComponents.Divider;
Widget.Header = _Header2.default;
Widget.Item = _Item2.default;
Widget.OptionsBar = _OptionsBar2.default;
Widget.Pagination = _Pagination2.default;
Widget.SubHeader = _SubHeader2.default;
Widget.Table = _Table2.default;
Widget.TableRow = _TableRow2.default;

exports.default = Widget;

/***/ }),

/***/ "./features/authentication/AuthorizedRoute/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AuthorizedRoute = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = __webpack_require__("../node_modules/react-router-dom/es/index.js");

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _reactProptypeConditionalRequire = __webpack_require__("../node_modules/react-proptype-conditional-require/dist/isRequiredIf.js");

var _reactProptypeConditionalRequire2 = _interopRequireDefault(_reactProptypeConditionalRequire);

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _selectors = __webpack_require__("./features/authentication/redux/selectors.js");

var _redirects = __webpack_require__("./features/authentication/utils/redirects.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /**
                                                                                                                                                                                                                              * Provides an enhanced "Route" component that first verifies if the user is authorized to use the
                                                                                                                                                                                                                              * application. If not, it saves the user's desired location and redirects the user to login page.
                                                                                                                                                                                                                              */

function AuthorizedRoute(_ref) {
  var component = _ref.component,
      isAuthorized = _ref.isAuthorized,
      isTokenExpired = _ref.isTokenExpired,
      _render = _ref.render,
      rest = _objectWithoutProperties(_ref, ['component', 'isAuthorized', 'isTokenExpired', 'render']);

  return _react2.default.createElement(_reactRouterDom.Route, _extends({}, rest, {
    render: function render(componentProps) {
      // Portunus authorization lasts 24hrs, but tokens expire in 1hr.
      // In the event of an expired token (which will happen if the user
      // is idle for > 1hr), redirect the user to the login page to refresh.
      if (isTokenExpired) {
        (0, _redirects.saveLoginRedirectFrom)(componentProps.location);
        return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/logout' });
      }
      if (isAuthorized) {
        if (component) {
          return _react2.default.createElement(component, _extends({}, rest, componentProps));
        }
        if (_render) {
          return _render(_extends({}, rest, componentProps));
        }
        return _react2.default.createElement(_reactRouterDom.Redirect, {
          to: {
            pathname: '/404-not-found',
            state: { from: componentProps.location }
          }
        });
      }

      // The current path must be saved in localstorage to persist across
      // the redirects to the SSO provider. History state is saved in memory
      // only and will be cleared.
      (0, _redirects.saveLoginRedirectFrom)(componentProps.location);
      return _react2.default.createElement(_reactRouterDom.Redirect, {
        to: {
          pathname: '/login'
        }
      });
    }
  }));
}

exports.AuthorizedRoute = AuthorizedRoute;
AuthorizedRoute.propTypes = {
  // A `component` prop or a `render` prop is required. Both should not be supplied.
  // If both are supplied, the `component` prop will take priority.
  // https://reacttraining.com/react-router/web/api/Route/render-func
  component: (0, _reactProptypeConditionalRequire2.default)(_propTypes2.default.func, function (props) {
    return !(0, _lodash.has)(props, 'render');
  }),
  isAuthorized: _propTypes2.default.bool.isRequired,
  isTokenExpired: _propTypes2.default.bool.isRequired,
  render: (0, _reactProptypeConditionalRequire2.default)(_propTypes2.default.func, function (props) {
    return !(0, _lodash.has)(props, 'component');
  })
};

AuthorizedRoute.defaultProps = {
  component: undefined,
  render: undefined
};

function mapStateToProps(state) {
  return {
    isAuthorized: (0, _selectors.isAuthorizedSelector)(state),
    isTokenExpired: (0, _selectors.isTokenExpiredSelector)(state)
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(AuthorizedRoute);

/***/ }),

/***/ "./features/authentication/LoginPage/Wrapper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = '\n  align-items: center;\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  left: 0;\n  position: fixed;\n  top: 0;\n  width: 100%;\n';

exports.default = (0, _decisivUiUtils.buildStyledComponent)('LoginPageWrapper', _styledComponents2.default.section, styles, {
  className: 'LoginPage'
});

/***/ }),

/***/ "./features/authentication/LoginPage/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoginPage = LoginPage;

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__("../node_modules/react-router-dom/es/index.js");

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _selectors = __webpack_require__("./features/authentication/redux/selectors.js");

var _redirects = __webpack_require__("./features/authentication/utils/redirects.js");

var _Wrapper = __webpack_require__("./features/authentication/LoginPage/Wrapper.js");

var _Wrapper2 = _interopRequireDefault(_Wrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A simple SFC container is responsible for rendering the page containing the login form and
 * redirecting to the correct route when a user is authorized.
 * @param {Object} props The props passed to this component.
 * @param {Boolean} props.isAuthorized A boolean value indicating whether the use is authorized.
 */
function LoginPage(_ref) {
  var isAuthorized = _ref.isAuthorized,
      children = _ref.children;

  if (isAuthorized) {
    // This block runs after a succesful SSO ticket decoding. The redirectPath
    // will be saved in localstorage, so we should consume it.
    var redirectPath = (0, _redirects.consumeLoginRedirectFrom)();

    return _react2.default.createElement(_reactRouterDom.Redirect, { to: redirectPath });
  }

  return _react2.default.createElement(
    _Wrapper2.default,
    null,
    children
  );
}

LoginPage.propTypes = {
  isAuthorized: _propTypes2.default.bool.isRequired,
  children: _propTypes2.default.node.isRequired
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    isAuthorized: (0, _selectors.isAuthorizedSelector)(state)
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(LoginPage);

/***/ }),

/***/ "./features/authentication/LoginValidation/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoginValidation = LoginValidation;

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _reactRouterDom = __webpack_require__("../node_modules/react-router-dom/es/index.js");

var _propTypes = __webpack_require__("./utils/prop-types.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _url = __webpack_require__("./utils/url.js");

var _LoginPage = __webpack_require__("./features/authentication/LoginPage/index.js");

var _LoginPage2 = _interopRequireDefault(_LoginPage);

var _actions = __webpack_require__("./features/authentication/redux/actions.js");

var _messages = __webpack_require__("./features/authentication/LoginValidation/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LoginValidation(_ref) {
  var location = _ref.location,
      validateTicket = _ref.validateTicket;

  var params = (0, _url.parseQueryParams)(location.search);

  var ticket = params.ticket;

  if (ticket) {
    // This will kick off the API call to validate our ticket-granting ticket:
    validateTicket(ticket);
    // Once the API call completes successfully, we will be authorized, and that
    // will kick off a router re-render directing the user to the application
    // page that was originally requested.

    return _react2.default.createElement(
      _LoginPage2.default,
      null,
      _react2.default.createElement(
        'p',
        null,
        _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.validating })
      )
    );
  }

  // No ticket, so either we're coming back from a logout or something went wrong.
  // In either case, bounce back to the login page.
  return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/login' });
}

LoginValidation.propTypes = {
  location: _propTypes2.default.shape({
    search: _propTypes2.default.string
  }).isRequired,
  validateTicket: _propTypes2.default.func.isRequired
};

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    validateTicket: function validateTicket(ticket) {
      return dispatch((0, _actions.validateSsoTicket)(ticket));
    }
  };
}

exports.default = (0, _reactRedux.connect)(undefined, mapDispatchToProps)(LoginValidation);

/***/ }),

/***/ "./features/authentication/LoginValidation/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  validating: (0, _linguiReact.i18nMark)('Validating...')
};

exports.default = messages;

/***/ }),

/***/ "./features/authentication/LogoutPage/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LogoutPage = LogoutPage;

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _reactRouterDom = __webpack_require__("../node_modules/react-router-dom/es/index.js");

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _LoginPage = __webpack_require__("./features/authentication/LoginPage/index.js");

var _LoginPage2 = _interopRequireDefault(_LoginPage);

var _api = __webpack_require__("./features/authentication/api.js");

var _selectors = __webpack_require__("./features/authentication/redux/selectors.js");

var _messages = __webpack_require__("./features/authentication/LogoutPage/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LogoutPage(_ref) {
  var isAuthorized = _ref.isAuthorized;

  if (isAuthorized) {
    // 1. dispatch the logout action
    // logout();
    // NOTE: It seems that a logout action is in fact not even necessary.
    // This is because the redirect to Portunus below will empty out our Redux store anyway.

    // 2. redirect to Portunus for the login page
    // The action of hitting that logout page will cause Portunus to log us out,
    // issuing a single-sign-out to other services.  It will then redirect to our
    // application, but since we're now logged out, this will trigger a redirect
    // to the Portunus login page will then
    (0, _api.redirectToLogout)();

    return _react2.default.createElement(
      _LoginPage2.default,
      null,
      _react2.default.createElement(
        'p',
        null,
        _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.loggingOut })
      )
    );
  }

  return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/login' });
}

LogoutPage.propTypes = {
  isAuthorized: _propTypes2.default.bool.isRequired
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    isAuthorized: (0, _selectors.isAuthorizedSelector)(state)
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(LogoutPage);

/***/ }),

/***/ "./features/authentication/LogoutPage/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  loggingOut: (0, _linguiReact.i18nMark)('Logging out...')
};

exports.default = messages;

/***/ }),

/***/ "./features/authentication/PortunusLogin/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PortunusLogin = PortunusLogin;

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _propTypes = __webpack_require__("./utils/prop-types.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _LoginPage = __webpack_require__("./features/authentication/LoginPage/index.js");

var _LoginPage2 = _interopRequireDefault(_LoginPage);

var _api = __webpack_require__("./features/authentication/api.js");

var _selectors = __webpack_require__("./features/authentication/redux/selectors.js");

var _messages = __webpack_require__("./features/authentication/PortunusLogin/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function PortunusLogin(_ref) {
  var tenant = _ref.tenant;

  // redirect to Portunus for the login page
  (0, _api.redirectToLogin)(tenant);

  return _react2.default.createElement(
    _LoginPage2.default,
    null,
    _react2.default.createElement(
      'p',
      null,
      _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.redirect })
    )
  );
}

PortunusLogin.propTypes = {
  tenant: _propTypes2.default.string.isRequired
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    tenant: (0, _selectors.currentTenantSelector)(state)
  };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(PortunusLogin);

/***/ }),

/***/ "./features/authentication/PortunusLogin/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  redirect: (0, _linguiReact.i18nMark)('Redirecting...')
};

exports.default = messages;

/***/ }),

/***/ "./features/authentication/api.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.validateSSOTicket = validateSSOTicket;
exports.decodeAuthToken = decodeAuthToken;
exports.refreshAuthToken = refreshAuthToken;
exports.authenticatedFetch = authenticatedFetch;
exports.portunusRedirect = portunusRedirect;
exports.redirectToLogin = redirectToLogin;
exports.redirectToLogout = redirectToLogout;

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _fetch = __webpack_require__("./utils/fetch.js");

var _global = __webpack_require__("./utils/global.js");

var _url = __webpack_require__("./utils/url.js");

var _constants = __webpack_require__("./features/authentication/constants.js");

var _redirects = __webpack_require__("./features/authentication/utils/redirects.js");

/**
 * Base URL for the Portunus SSO server.  Should be available via an environment variable.
 * See `config/build-targets/[TARGET]/env.*`
 */
var PORTUNUS_URL = "https://portunus.preview.decisivapps.com";

/**
 * Get the `service` parameter for Portunus, which tells Portunus where to
 * redirect back to in our application.
 * @returns {string}
 */
function currentService() {
  var baseUrl = (0, _url.locationOrigin)();
  return '' + baseUrl + _constants.SSO_VALIDATE_PATH;
}

/**
 * Make a URL to a particular endpoint in the Portunus SSO service, configured with
 * the `service` param for our application.
 * @param {string} path
 * @param {object} params
 * @returns {string}
 */
function makePortunusUrl(path, params) {
  return (0, _url.makeUrl)(PORTUNUS_URL, path, _extends({
    service: currentService()
  }, params));
}

/**
 * Return a URL to the given endpoint within the Portunus API resource
 * space.
 * @param {string} endpoint An endpoint under the API path, e.g. `sessions` or `sessions/decode`
 * @returns {string} The URL with the params, e.g. <BASEURL>/api/v1/endpoint?params...
 */
function makePortunusApiUrl(endpoint) {
  return (0, _url.makeUrl)(PORTUNUS_URL, 'api/v1/' + (0, _lodash.trimStart)(endpoint, '/'));
}

/**
 * API fetch call to validate the given Portunus ticket-granting-ticket.
 * @param {string} ticket
 */
function validateSSOTicket(ticket) {
  var endpoint = makePortunusUrl('serviceValidate', { ticket: ticket });
  return (0, _fetch.get)(endpoint, { auth: false, headers: { Accept: 'text/xml' } });
}

/**
 * API fetch call to the current auth token (JWT) via the Portunus sessions/decode API endpoint.
 */
function decodeAuthToken() {
  var endpoint = makePortunusApiUrl('sessions/decode');
  return (0, _fetch.get)(endpoint, {
    headers: {
      Accept: 'application/vnd.api+json',
      'Content-type': 'application/vnd.api+json'
    }
  });
}

/**
 * API fetch call to refresh the current auth token (JWT).
 */
function refreshAuthToken() {
  var endpoint = makePortunusApiUrl('sessions/renew');
  return (0, _fetch.put)(endpoint, {
    headers: {
      Accept: 'application/vnd.api+json',
      'Content-type': 'application/vnd.api+json'
    }
  });
}

/**
 * Wrapper for built-in `fetch` which adds the expected Authorization header to the
 * request.  If no access token is available, a rejected Promise will be returned.
 *
 * @param {string} url - The URL to fetch from
 * @param {object} options - Standard options for fetch
 * @returns {Promise}
 */
function authenticatedFetch(url, options) {
  var accessToken = (0, _global.getGlobal)(_constants.GLOBAL_ACCESS_TOKEN_KEY);

  if (!accessToken) {
    return Promise.resolve({
      error: new Error('Attempting to access an API that requires authentication, but no auth token is available. URL=' + url)
    });
  }

  var authedOpts = _extends({}, options, {
    headers: _extends({
      Authorization: 'Bearer ' + accessToken
    }, options.headers)
  });

  return fetch(url, authedOpts);
}

/* istanbul ignore next */
function hardRedirect(location) {
  window.location = location;
}

/**
 * Redirect (via window.location) to the given path on the Portunus server.
 * @private
 * @param {string} path - The Portunus endpoint to redirect to
 * @param {object} params - Any (optional) params to add to the query string
 * @param {function} doRedirect - A function which will do the redirect (injected for testing)
 */
function portunusRedirect(path) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var doRedirect = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : hardRedirect;

  doRedirect(makePortunusUrl(path, params));
}

/**
 * Redirect to the Portunus login page. A 'tenant' will be added to the
 * query string using the specified tenant.
 * @param {string} tenant
 * @param {function(string, object)} doRedirect - To do the redirect (injected for testing)
 */
function redirectToLogin(tenant) {
  var doRedirect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : portunusRedirect;

  console.log('redirecting to login with tenant=' + tenant);
  doRedirect('/login', { tenant: tenant });
}

/**
 * Redirect to the Portunus logout page. This will trigger a single-sign-out, then a redirection
 * back to our application. Upon landing back in our application, since at that time there will
 * be no auth info, the login page will in turn redirect back to Portunus to re-login.
 * @param {function(string, object)} doRedirect - To do the redirect (injected for testing)
 */
function redirectToLogout() {
  var doRedirect = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : portunusRedirect;

  (0, _redirects.saveLoginRedirectFrom)(window.location);
  doRedirect('/logout');
}

/***/ }),

/***/ "./features/authentication/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * The key in the application global where we store the current auth token.
 * @type {string}
 */
var GLOBAL_ACCESS_TOKEN_KEY = exports.GLOBAL_ACCESS_TOKEN_KEY = 'fenix/authentication/accessToken';

var SSO_VALIDATE_PATH = exports.SSO_VALIDATE_PATH = '/login/sso';

// Redux actions
var DECODE_AUTH_TOKEN = exports.DECODE_AUTH_TOKEN = 'fenix/authentication/DECODE_AUTH_TOKEN';
var REFRESH_AUTH_TOKEN = exports.REFRESH_AUTH_TOKEN = 'fenix/authentication/REFRESH_AUTH_TOKEN';
var LOGIN_SUCCESS = exports.LOGIN_SUCCESS = 'fenix/authentication/LOGIN_SUCCESS';
var LOGOUT = exports.LOGOUT = 'fenix/authentication/LOGOUT';
var SET_DEFAULT_OEM = exports.SET_DEFAULT_OEM = 'fenix/authentication/SET_DEFAULT_OEM';
var TICKET_VALIDATION_FAILURE = exports.TICKET_VALIDATION_FAILURE = 'fenix/authentication/TICKET_VALIDATION_FAILURE';
var VALIDATE_SSO_TICKET = exports.VALIDATE_SSO_TICKET = 'fenix/authentication/VALIDATE_SSO_TICKET';

/***/ }),

/***/ "./features/authentication/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOGOUT = exports.authenticatedFetch = exports.currentTenantSelector = exports.sagas = exports.reducer = exports.LogoutPage = exports.LoginValidation = exports.LoginPage = exports.AuthorizedRoute = undefined;

var _selectors = __webpack_require__("./features/authentication/redux/selectors.js");

Object.defineProperty(exports, 'currentTenantSelector', {
  enumerable: true,
  get: function get() {
    return _selectors.currentTenantSelector;
  }
});

var _api = __webpack_require__("./features/authentication/api.js");

Object.defineProperty(exports, 'authenticatedFetch', {
  enumerable: true,
  get: function get() {
    return _api.authenticatedFetch;
  }
});

var _constants = __webpack_require__("./features/authentication/constants.js");

Object.defineProperty(exports, 'LOGOUT', {
  enumerable: true,
  get: function get() {
    return _constants.LOGOUT;
  }
});

var _AuthorizedRoute2 = __webpack_require__("./features/authentication/AuthorizedRoute/index.js");

var _AuthorizedRoute3 = _interopRequireDefault(_AuthorizedRoute2);

var _PortunusLogin = __webpack_require__("./features/authentication/PortunusLogin/index.js");

var _PortunusLogin2 = _interopRequireDefault(_PortunusLogin);

var _LoginValidation2 = __webpack_require__("./features/authentication/LoginValidation/index.js");

var _LoginValidation3 = _interopRequireDefault(_LoginValidation2);

var _LogoutPage2 = __webpack_require__("./features/authentication/LogoutPage/index.js");

var _LogoutPage3 = _interopRequireDefault(_LogoutPage2);

var _reducer2 = __webpack_require__("./features/authentication/redux/reducer.js");

var _reducer3 = _interopRequireDefault(_reducer2);

var _sagas2 = __webpack_require__("./features/authentication/redux/sagas.js");

var _sagas3 = _interopRequireDefault(_sagas2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.AuthorizedRoute = _AuthorizedRoute3.default;
exports.LoginPage = _PortunusLogin2.default;
exports.LoginValidation = _LoginValidation3.default;
exports.LogoutPage = _LogoutPage3.default;
exports.reducer = _reducer3.default;
exports.sagas = _sagas3.default;

/***/ }),

/***/ "./features/authentication/redux/actions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateSsoTicket = exports.ticketValidationFailure = exports.logout = exports.loginSuccess = exports.refreshAuthToken = exports.decodeAuthToken = undefined;

var _reduxActions = __webpack_require__("../node_modules/redux-actions/es/index.js");

var _reduxFlightControl = __webpack_require__("../node_modules/redux-flight-control/build/index.js");

var _constants = __webpack_require__("./features/authentication/constants.js");

var _api = __webpack_require__("./features/authentication/api.js");

var decodeAuthToken = exports.decodeAuthToken = (0, _reduxFlightControl.createRequestAction)(_constants.DECODE_AUTH_TOKEN, _api.decodeAuthToken);
var refreshAuthToken = exports.refreshAuthToken = (0, _reduxFlightControl.createRequestAction)(_constants.REFRESH_AUTH_TOKEN, _api.refreshAuthToken);
var loginSuccess = exports.loginSuccess = (0, _reduxActions.createAction)(_constants.LOGIN_SUCCESS);
var logout = exports.logout = (0, _reduxActions.createAction)(_constants.LOGOUT);
var ticketValidationFailure = exports.ticketValidationFailure = (0, _reduxActions.createAction)(_constants.TICKET_VALIDATION_FAILURE);
var validateSsoTicket = exports.validateSsoTicket = (0, _reduxFlightControl.createRequestAction)(_constants.VALIDATE_SSO_TICKET, _api.validateSSOTicket);

/***/ }),

/***/ "./features/authentication/redux/reducer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _handleActions;

exports.getInitialState = getInitialState;

var _immutable = __webpack_require__("../node_modules/immutable/dist/immutable.js");

var _reduxActions = __webpack_require__("../node_modules/redux-actions/es/index.js");

var _url = __webpack_require__("./utils/url.js");

var _constants = __webpack_require__("./features/authentication/constants.js");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Build the initial authentication state, including a default OEM.
 * @private
 * @returns {object}
 */
function getInitialState() {
  return (0, _immutable.fromJS)({
    isAuthorized: false,
    tenant: (0, _url.getTenantFromUrl)(),
    user: {},
    error: {},
    token: {}
  });
}

function storeAuthData(state, action) {
  var _action$payload = action.payload,
      user = _action$payload.user,
      authToken = _action$payload.authToken,
      authedAt = _action$payload.authedAt,
      email = _action$payload.email,
      uuid = _action$payload.uuid;


  var userInfo = (0, _immutable.fromJS)({
    accessToken: authToken,
    issuedAt: Date.parse(authedAt), // authedAt is in the form '2017-11-21T03:57:46Z'
    email: email,
    userID: user,
    uuid: uuid
  });

  console.log('User authorized: ' + user);

  return state.set('isAuthorized', true).set('user', userInfo).set('error', undefined);
}

function storeTokenData(state, action) {
  // action.payload will look something like this:
  // body: {
  //   data: {
  //     attributes: {
  //       email: 'ddaniell@decisiv.net',
  //       exp: 1511363184,
  //       external_id: 'a7b08468-6ea4-11e7-a7eb-0a501d49e77a',
  //       iat: 1511359584,
  //       iss: 'decisiv.com',
  //       name: 'Fleet Web1',
  //       uri: 'decisiv:users:a7b08468-6ea4-11e7-a7eb-0a501d49e77a',
  //       username: 'fleet_web_demo_1',
  //       legacy_tenant: 'vlv',
  //     },
  //     id: 'the JWT token',
  //     type: 'sessions',
  //   },
  // }

  var jwtAttributes = action.payload.body.data.attributes;
  console.log('User token validated:', 'username=' + jwtAttributes.username, 'email=' + jwtAttributes.email, 'legacy_tenant=' + jwtAttributes.legacy_tenant, 'tenant from URL=' + (0, _url.getTenantFromUrl)());
  return state.set('token', (0, _immutable.fromJS)(jwtAttributes));
}

function clearAuthData() /* state, action */{
  return getInitialState();
}

/**
 * Store error information in state regarding a failure to validate a
 * Portunus login ticket.
 */
function handleValidationFailure(state, action) {
  // action.payload will be an object with a `message` and a `code`
  return clearAuthData(state).set('error', (0, _immutable.fromJS)(action.payload));
}

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _constants.DECODE_AUTH_TOKEN, storeTokenData), _defineProperty(_handleActions, _constants.LOGIN_SUCCESS, storeAuthData), _defineProperty(_handleActions, _constants.LOGOUT, clearAuthData), _defineProperty(_handleActions, _constants.TICKET_VALIDATION_FAILURE, handleValidationFailure), _handleActions), getInitialState());

/***/ }),

/***/ "./features/authentication/redux/sagas.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateSSOWatcher = validateSSOWatcher;
exports.ticketValidationFailureWatcher = ticketValidationFailureWatcher;
exports.requestQueueWatcher = requestQueueWatcher;
exports.requestFinalizeWatcher = requestFinalizeWatcher;
exports.refreshAuthTokenWatcher = refreshAuthTokenWatcher;

var _effects = __webpack_require__("../node_modules/redux-saga/es/effects.js");

var _reduxFlightControl = __webpack_require__("../node_modules/redux-flight-control/build/index.js");

var _global = __webpack_require__("./utils/global.js");

var _xml = __webpack_require__("./utils/xml.js");

var _api = __webpack_require__("./features/authentication/api.js");

var _constants = __webpack_require__("./features/authentication/constants.js");

var _actions = __webpack_require__("./features/authentication/redux/actions.js");

var _selectors = __webpack_require__("./features/authentication/redux/selectors.js");

var _marked = /*#__PURE__*/regeneratorRuntime.mark(processNewAuthToken),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(validateSSOWorker),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(ticketValidationFailureWorker),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(requestQueueWorker),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(requestFinalizeWorker),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(refreshAuthTokenWorker),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(validateSSOWatcher),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(ticketValidationFailureWatcher),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(requestQueueWatcher),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(requestFinalizeWatcher),
    _marked11 = /*#__PURE__*/regeneratorRuntime.mark(refreshAuthTokenWatcher);

/**
 * Handles saving and decoding of a new auth token.
 * @param {string} authToken A valid JWT
 */
function processNewAuthToken(authToken) {
  return regeneratorRuntime.wrap(function processNewAuthToken$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.call)(_global.setGlobal, _constants.GLOBAL_ACCESS_TOKEN_KEY, authToken);

        case 2:
          _context.next = 4;
          return (0, _effects.put)((0, _actions.decodeAuthToken)());

        case 4:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

/* ------------------------------- worker sagas ------------------------------- */

/**
 * This worker function handles the results of the Portunus API call which
 * validates the ticket-granting ticket.
 *
 * If the ticket is valid, the payload will contain an XML document with
 * `authenticationSuccess`, including details on the user, auth token, etc.
 * This data will be stored in the redux store.
 *
 * If the ticket is NOT valid, the payload will contain an `authenticationFailure`
 * with a code and text indicating the reason for failure.
 *
 * @param payload The ticket-validation API response payload.
 */
function validateSSOWorker(_ref) {
  var payload = _ref.payload;
  var xml, serviceResponse, authSuccess, user, attributes, authToken, authedAt, email, isFromNewLogin, userID, uuid, authFailure, authFailureAttrs, failureCode, failureText;
  return regeneratorRuntime.wrap(function validateSSOWorker$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.call)(_xml.xmlToJs, payload.body);

        case 2:
          xml = _context2.sent;
          serviceResponse = xml.serviceResponse;
          authSuccess = serviceResponse.authenticationSuccess;

          if (!authSuccess) {
            _context2.next = 20;
            break;
          }

          // 👍
          user = authSuccess.user;
          attributes = authSuccess.attributes;
          authToken = attributes.auth_token;
          authedAt = attributes.authenticationDate;
          email = attributes.email;
          isFromNewLogin = attributes.isFromNewLogin;
          userID = attributes.user_id;
          uuid = attributes.uuid;
          _context2.next = 16;
          return (0, _effects.call)(processNewAuthToken, authToken);

        case 16:
          _context2.next = 18;
          return (0, _effects.put)((0, _actions.loginSuccess)({
            user: user,
            authToken: authToken,
            authedAt: authedAt,
            email: email,
            isFromNewLogin: isFromNewLogin,
            userID: userID,
            uuid: uuid
          }));

        case 18:
          _context2.next = 30;
          break;

        case 20:
          _context2.next = 22;
          return (0, _effects.call)(_global.clearGlobal, _constants.GLOBAL_ACCESS_TOKEN_KEY);

        case 22:
          authFailure = serviceResponse.authenticationFailure;

          if (!authFailure) {
            _context2.next = 30;
            break;
          }

          authFailureAttrs = authFailure.$;
          failureCode = authFailureAttrs.code;
          failureText = authFailure._;

          console.error('FAILED SSO VALIDATION: failureCode=', failureCode, 'error text=', failureText);
          _context2.next = 30;
          return (0, _effects.put)((0, _actions.ticketValidationFailure)({
            message: failureText,
            code: failureCode
          }));

        case 30:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

/**
 * This worker takes care of the response to a failed Portunus ticket validation.
 */
function ticketValidationFailureWorker() {
  var tenant;
  return regeneratorRuntime.wrap(function ticketValidationFailureWorker$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.select)(_selectors.currentTenantSelector);

        case 2:
          tenant = _context3.sent;
          _context3.next = 5;
          return (0, _effects.call)(_api.redirectToLogin, tenant);

        case 5:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

/**
 * This worker logs the user out if the token is within one minute of expiry.
 * A one minute buffer was selected to create enough buffer to process active
 * requests and refresh the token.
 */
function requestQueueWorker() {
  var isTokenExpired;
  return regeneratorRuntime.wrap(function requestQueueWorker$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.select)(_selectors.isTokenExpiredSelector);

        case 2:
          isTokenExpired = _context4.sent;

          if (!isTokenExpired) {
            _context4.next = 6;
            break;
          }

          _context4.next = 6;
          return (0, _effects.call)(_api.redirectToLogout);

        case 6:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

/**
 * This worker monitors the requests queue, and under certain conditions logs the user out or
 * dispatches an action that refreshes the auth token.
 * @param {object} action A finalize request action, dispatched by redux request action system
 */
function requestFinalizeWorker(_ref2) {
  var requestType = _ref2.meta.requestType;
  var decodeAuthTokenError, isTokenAlmostExpired, hasActiveRequests;
  return regeneratorRuntime.wrap(function requestFinalizeWorker$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.select)(_selectors.decodeAuthTokenErrorSelector);

        case 2:
          decodeAuthTokenError = _context5.sent;

          if (!decodeAuthTokenError) {
            _context5.next = 6;
            break;
          }

          _context5.next = 6;
          return (0, _effects.call)(_api.redirectToLogout);

        case 6:
          _context5.next = 8;
          return (0, _effects.select)(_selectors.isTokenAlmostExpiredSelector);

        case 8:
          isTokenAlmostExpired = _context5.sent;
          _context5.next = 11;
          return (0, _effects.select)(_reduxFlightControl.hasActiveRequestsSelector);

        case 11:
          hasActiveRequests = _context5.sent;

          if (!(!hasActiveRequests && isTokenAlmostExpired && requestType !== _constants.REFRESH_AUTH_TOKEN)) {
            _context5.next = 15;
            break;
          }

          _context5.next = 15;
          return (0, _effects.put)((0, _actions.refreshAuthToken)());

        case 15:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

/**
 * This worker watches for a refresh auth token action, dispatched only on success.
 * It extracts and begins processing the new authToken.
 * @param {object} action A successful refresh token action
 */
function refreshAuthTokenWorker(_ref3) {
  var authToken = _ref3.payload.body.data.attributes.access_token;
  return regeneratorRuntime.wrap(function refreshAuthTokenWorker$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.call)(processNewAuthToken, authToken);

        case 2:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

/* ------------------------------- watcher sagas ------------------------------- */

function validateSSOWatcher() {
  return regeneratorRuntime.wrap(function validateSSOWatcher$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.takeLatest)(_constants.VALIDATE_SSO_TICKET, validateSSOWorker);

        case 2:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this);
}

function ticketValidationFailureWatcher() {
  return regeneratorRuntime.wrap(function ticketValidationFailureWatcher$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.takeLatest)(_constants.TICKET_VALIDATION_FAILURE, ticketValidationFailureWorker);

        case 2:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked8, this);
}

function requestQueueWatcher() {
  return regeneratorRuntime.wrap(function requestQueueWatcher$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.takeEvery)(_reduxFlightControl.QUEUE_REQUEST, requestQueueWorker);

        case 2:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked9, this);
}

function requestFinalizeWatcher() {
  return regeneratorRuntime.wrap(function requestFinalizeWatcher$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _effects.takeLatest)(_reduxFlightControl.FINALIZE_REQUEST, requestFinalizeWorker);

        case 2:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked10, this);
}

function refreshAuthTokenWatcher() {
  return regeneratorRuntime.wrap(function refreshAuthTokenWatcher$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return (0, _effects.takeLatest)(_constants.REFRESH_AUTH_TOKEN, refreshAuthTokenWorker);

        case 2:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked11, this);
}

// export all of the watcher sagas.
exports.default = [refreshAuthTokenWatcher(), requestFinalizeWatcher(), requestQueueWatcher(), ticketValidationFailureWatcher(), validateSSOWatcher()];

/***/ }),

/***/ "./features/authentication/redux/selectors.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.currentTenantSelector = exports.accessTokenSelector = exports.isTokenAlmostExpiredSelector = exports.isTokenExpiredSelector = exports.userSelector = exports.isAuthorizedSelector = exports.decodeAuthTokenErrorSelector = undefined;

var _reselect = __webpack_require__("../node_modules/reselect/lib/index.js");

var _immutable = __webpack_require__("../node_modules/immutable/dist/immutable.js");

var _reduxFlightControl = __webpack_require__("../node_modules/redux-flight-control/build/index.js");

var _constants = __webpack_require__("./features/authentication/constants.js");

var _evaluateTokenExpiry3 = __webpack_require__("./features/authentication/utils/evaluateTokenExpiry.js");

var _evaluateTokenExpiry4 = _interopRequireDefault(_evaluateTokenExpiry3);

var _getCurrentTimeInSeconds = __webpack_require__("./features/authentication/utils/getCurrentTimeInSeconds.js");

var _getCurrentTimeInSeconds2 = _interopRequireDefault(_getCurrentTimeInSeconds);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* --------------------------- REQUEST SELECTORS --------------------------- */

/* --------------------------- DECODE_AUTH_TOKEN --------------------------- */

/**
 * Shape of the authentication slice of the store:
 *
 * - isAuthorized: boolean
 *
 * - tenant: string - the current tenant, determined from the URL
 *
 * - user:
 *     - accessToken: string
 *     - issuedAt: date/time
 *     - email: string
 *     - userID: string
 *     - uuid: string
 *
 * - error:
 *     - code: string
 *     - message: string
 *
 * - token:
 *     - email
 *     - exp - the expiration time, in Unix seconds
 *     - external_id
 *     - iat - the issued-at time, in Unix seconds
 *     - iss - the issuer of the JWT
 *     - name - the full name of the user associated with the JWT
 *     - uri
 *     - username - the login username associated with the JWT
 *     - legacy_tenant - the tenant e.g. vlv, mich, etc
 */

var decodeAuthTokenErrorSelector = exports.decodeAuthTokenErrorSelector = (0, _reduxFlightControl.createFailedRequestSelectorFor)(_constants.DECODE_AUTH_TOKEN);

/* --------------------------- AUTH STORE SELECTORS --------------------------- */

var authStoreSelector = function authStoreSelector(state) {
  return state.get('authentication');
};

var isAuthorizedSelector = exports.isAuthorizedSelector = (0, _reselect.createSelector)(authStoreSelector, function (authStore) {
  return authStore.get('isAuthorized', false);
});

var userSelector = exports.userSelector = (0, _reselect.createSelector)(authStoreSelector, function (authStore) {
  return authStore.get('user', (0, _immutable.Map)());
});

var tokenSelector = (0, _reselect.createSelector)(authStoreSelector, function (authStore) {
  return authStore.get('token', (0, _immutable.Map)());
});

var tokenExpirySelector = (0, _reselect.createSelector)(tokenSelector, function (token) {
  return token.get('exp');
});

/**
 * Returns true if token is within 1 minute of expiry. This selector is impure.
 * `createSelector` can not be used as it will return invalid cached results.
 */
var isTokenExpiredSelector = exports.isTokenExpiredSelector = function isTokenExpiredSelector(state) {
  var currentTimeInSeconds = (0, _getCurrentTimeInSeconds2.default)();
  var tokenExpiryInSeconds = tokenExpirySelector(state);

  var _evaluateTokenExpiry = (0, _evaluateTokenExpiry4.default)(currentTimeInSeconds, tokenExpiryInSeconds),
      expired = _evaluateTokenExpiry.expired;

  return expired;
};

/**
 * Returns true only if token is within 15 minutes of expiry. This selector is impure.
 * `createSelector` can not be used as it will return invalid cached results.
 */
var isTokenAlmostExpiredSelector = exports.isTokenAlmostExpiredSelector = function isTokenAlmostExpiredSelector(state) {
  var currentTimeInSeconds = (0, _getCurrentTimeInSeconds2.default)();
  var tokenExpiryInSeconds = tokenExpirySelector(state);

  var _evaluateTokenExpiry2 = (0, _evaluateTokenExpiry4.default)(currentTimeInSeconds, tokenExpiryInSeconds),
      almostExpired = _evaluateTokenExpiry2.almostExpired;

  return almostExpired;
};

var accessTokenSelector = exports.accessTokenSelector = (0, _reselect.createSelector)(userSelector, function (authUserStore) {
  return authUserStore.get('accessToken');
});

var currentTenantSelector = exports.currentTenantSelector = (0, _reselect.createSelector)(authStoreSelector, function (authStore) {
  return authStore.get('tenant', null);
});

/***/ }),

/***/ "./features/authentication/utils/evaluateTokenExpiry.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function convertMinutesToSeconds(minutes) {
  return minutes * 60;
}

var ONE_MINUTE_IN_SECONDS = convertMinutesToSeconds(1);
var FIFTEEN_MINUTES_IN_SECONDS = convertMinutesToSeconds(15);

/**
 * Extracts the logic concerning token expiry to optimized function. Standard memoization is not a
 * good fit for optimizing this logic (and would be a memory leak) as the inputs will almost
 * always be different. This optimized memoization only caches a single result.
 */
var evaluateTokenExpiry = function () {
  // Setup the cache. This will hold previously run evaluations.
  var cache = {};

  var evaluate = function evaluate(currentTimeInSeconds, tokenExpiryInSeconds) {
    var key = currentTimeInSeconds + ":" + tokenExpiryInSeconds;
    // This currentTime has already been processed. Return previous results.
    if (cache[key]) {
      return cache[key];
    }

    // Time will not go backwards. After this second passes there is no reason to maintain old
    // results. If the currentTimeInSeconds is not in the cache, nothing should be.
    Object.keys(cache).forEach(function (k) {
      delete cache[k];
    });

    // Evaluates to true if the token is present and current time is within 1 minute of,
    // or after expiry.
    var expired = !!(tokenExpiryInSeconds && currentTimeInSeconds + ONE_MINUTE_IN_SECONDS > tokenExpiryInSeconds);

    // Evaluates to true only if expired is false and the token is within 15 minutes of expiry.
    var almostExpired = !expired && !!(tokenExpiryInSeconds && currentTimeInSeconds + FIFTEEN_MINUTES_IN_SECONDS > tokenExpiryInSeconds && currentTimeInSeconds < tokenExpiryInSeconds);

    var result = { almostExpired: almostExpired, expired: expired };

    // Save this result so we can return without re-evaluating these inputs in the future.
    cache[key] = result;

    return result;
  };

  // Return the evaluation function.
  return evaluate;
}();

exports.default = evaluateTokenExpiry;

/***/ }),

/***/ "./features/authentication/utils/getCurrentTimeInSeconds.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * `getCurrentTimeInSeconds` resolves a Unix timestamp in MS to the
 * most recently completed second
 * @returns {number}
 */
function getCurrentTimeInSeconds() {
  return Math.floor(Date.now() / 1000);
}

exports.default = getCurrentTimeInSeconds;

/***/ }),

/***/ "./features/authentication/utils/redirects.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveLoginRedirectFrom = saveLoginRedirectFrom;
exports.consumeLoginRedirectFrom = consumeLoginRedirectFrom;

var _constants = __webpack_require__("./features/authentication/constants.js");

function saveLoginRedirectFrom(_ref) {
  var pathname = _ref.pathname,
      _ref$search = _ref.search,
      search = _ref$search === undefined ? '' : _ref$search;

  if (pathname !== _constants.SSO_VALIDATE_PATH) {
    memoryDB.DECISIV__redirectedToLoginFrom = '' + pathname + search;
  }
}

function consumeLoginRedirectFrom() {
  var redirectPath = memoryDB.DECISIV__redirectedToLoginFrom || '/';
  memoryDB.removeItem('DECISIV__redirectedToLoginFrom');
  return redirectPath;
}

/***/ }),

/***/ "./index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Bugsnag = __webpack_require__("./setup/Bugsnag/index.js");

var _Bugsnag2 = _interopRequireDefault(_Bugsnag);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("../node_modules/react-dom/index.js");

var _reactHotLoader = __webpack_require__("../node_modules/react-hot-loader/index.js");

var _immutable = __webpack_require__("../node_modules/immutable/dist/immutable.js");

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _keyboardeventKeyPolyfill = __webpack_require__("../node_modules/keyboardevent-key-polyfill/index.js");

var _keyboardeventKeyPolyfill2 = _interopRequireDefault(_keyboardeventKeyPolyfill);

var _I18n = __webpack_require__("./setup/I18n/index.js");

var _I18n2 = _interopRequireDefault(_I18n);

var _AppThemeProvider = __webpack_require__("./setup/AppThemeProvider/index.js");

var _AppThemeProvider2 = _interopRequireDefault(_AppThemeProvider);

var _Router = __webpack_require__("./setup/Router/index.js");

var _Router2 = _interopRequireDefault(_Router);

var _store = __webpack_require__("./setup/store.js");

var _store2 = _interopRequireDefault(_store);

var _localStorage = __webpack_require__("./setup/localStorage.js");

var _localStorage2 = _interopRequireDefault(_localStorage);

var _Hotjar = __webpack_require__("./setup/Hotjar.js");

var _Pendo = __webpack_require__("./setup/Pendo.js");

var _ZendeskLoader = __webpack_require__("./setup/ZendeskLoader.js");

var _ZendeskLoader2 = _interopRequireDefault(_ZendeskLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// make sure Bugsnag is loaded first
(0, _localStorage2.default)();
(0, _Hotjar.installHotjar)();
(0, _Pendo.installPendo)();

// This enables us to use `key` property of keyboardEvent object in all browsers.
_keyboardeventKeyPolyfill2.default.polyfill();

// ----- Setup the store -----

var initialState = (0, _immutable.fromJS)({});
var store = (0, _store2.default)(initialState);
_Bugsnag2.default.setStore(store);

// ----- Render the application root -----

// NOTE:  Any changes to the top-level application rendering -- i.e. the
// component structure built by `renderApp` -- need to be reflected in
// `MountableTestComponent` under src/__tests__/helpers.

function renderApp(Component) {
  (0, _reactDom.render)(_react2.default.createElement(
    _reactHotLoader.AppContainer,
    null,
    _react2.default.createElement(
      _reactRedux.Provider,
      { store: store },
      _react2.default.createElement(
        _I18n2.default,
        null,
        _react2.default.createElement(_ZendeskLoader2.default, null),
        _react2.default.createElement(
          _AppThemeProvider2.default,
          null,
          _react2.default.createElement(Component, null)
        )
      )
    )
  ), document.getElementById('root'));
}

renderApp(_Router2.default);

// ----- Setup hot module reloading -----

if (false) {
  module.hot.accept('./setup/Router/index.js', function () {
    /* eslint-disable global-require */
    var NewApp = require('./setup/Router/index.js').default;
    renderApp(NewApp);
  });
}

/***/ }),

/***/ "./locale/de/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = { l: { "p": function p(n, ord) {
      var s = String(n).split("."),
          v0 = !s[1];if (ord) return "other";return n == 1 && v0 ? "one" : "other";
    } }, m: { "\".": "\".", "#{caseId}": function caseId(a) {
      return ["#", a("caseId")];
    }, "({count}) Older {count, plural, one {Comment} other {Comments}}": function countOlderCountPluralOneCommentOtherComments(a) {
      return ["(", a("count"), ") \xC4lter ", a("count", "plural", { one: "Kommentar", other: "Kommentare" })];
    }, "... {count} more": function countMore(a) {
      return ["... ", a("count"), " mehr"];
    }, "...Loading": "...Wird geladen", "1 Hour": "1 Stunde", "A Minute Ago": "Vor einer Minute", "A Month Ago": "Vor einem Monat", "A Week Ago": "Vor einer Woche", "A Year Ago": "Vor einem Jahr", "Accept": "Akzeptieren", "Add Note": "Notiz hinzuf\xFCgen", "Additional Warnings": "Zus\xE4tzliche Warnhinweise", "Address": "Adresse", "Administration": "Administration", "All Assets": "Alle Verm\xF6genswerte", "All Current": "Alles aktuell", "All Repair Cases": "Alle Reparaturf\xE4lle", "Amount": "Betrag", "An Hour Ago": "Vor einer Stunde", "Approvals": "Genehmigungen", "Approve": "Genehmigen", "Asset": "Verm\xF6genswert", "Asset Location": "Asset-Standort", "Asset Summary": "Asset-Zusammenfassung", "Assets": "Verm\xF6genswerte", "Assets ({count})": function AssetsCount(a) {
      return ["Assets (", a("count"), ")"];
    }, "Assets: {count}": function AssetsCount(a) {
      return ["Verm\xF6genswerte: ", a("count")];
    }, "Back to Top": "Zur\xFCck nach oben", "Breakdown": "Aufgliederung", "By signing in you agree to all applicable ": "Mit der Anmeldung stimmen Sie allen geltenden Nutzungsbedingungen zu", "Campaign Due": "Kampagne f\xE4llig", "Campaigns": "Kampagnen", "Cancel": "Stornieren", "Cancel Request": "Anfrage abbrechen", "Caps Lock is Enabled": "Feststelltaste ist aktiviert", "Cards": "Karten", "Case": "Fall", "Case Status": "Fallstatus", "Case {caseId}": function CaseCaseId(a) {
      return ["Fall ", a("caseId")];
    }, "Case {number}": function CaseNumber(a) {
      return ["Fall ", a("number")];
    }, "Cases": "F\xE4lle", "Cases ({count})": function CasesCount(a) {
      return ["F\xE4lle (", a("count"), ")"];
    }, "Cases: {count}": function CasesCount(a) {
      return ["F\xE4lle: ", a("count")];
    }, "Closed": "Geschlossen", "Code - Description": "Code - Beschreibung", "Code Not Provided": "Code nicht zur Verf\xFCgung gestellt", "Collapse All": "Alles ausblenden", "Collapse Note": "Ausblend Notiz", "Collapse Sidebar": "Seitenleiste Ausblenden", "Comments": "Bemerkungen", "Complaint": "Beschwerde", "Complaint Code": "Beschwerdecode", "Component Id": "Komponenten-ID", "Continue": "Fortsetzen", "Copyright \xA9 {year} Decisiv, Inc.": function CopyrightYearDecisivInc(a) {
      return ["Copyright \xA9 ", a("year"), " Decisiv, Inc."];
    }, "Count": "Anzahl", "Create New Service Request": "Erstellen Sie eine neue Service-Anfrage", "Create Service Request": "Erstellen Sie eine Service-Anfrage", "Created": "Erstellt", "Current": "Aktuell", "Date/Time": "Datum / Uhrzeit", "Decisiv": "Decisiv", "Decline": "Ablehnen", "Description": "Beschreibung", "Description Not Provided": "Beschreibung nicht zur Verf\xFCgung gestellt", "Diagnostics": "Diagnose", "Diagnostics Details": "Diagnosedetails", "Distance to Service Location": "Entfernung zum Service-Standort", "Downtime": "Ausfallzeit", "Downtime > 2 Days": "Ausfallzeit > 2 Tage", "Due": "F\xE4llig", "ECU": "ECU", "ETR": "ETR", "Edit": "Bearbeiten", "Email Address or Username": "E-Mail-Adresse oder Benutzername", "Engine": "Motor", "Enter a city and state or zip code...": "Geben Sie eine Stadt und eine Postleitzahl ein ...", "Enter a passphrase at least four characters long.": "Geben Sie eine Passphrase mit mindestens vier Zeichen ein.", "Enter a username at least four characters long.": "Geben Sie einen Benutzernamen mit mindestens vier Zeichen ein.", "Enter at least 3 characters for your search.": "Geben Sie mindestens 3 Zeichen f\xFCr Ihre Suche ein.", "Error": "Error", "Estimate": "Sch\xE4tzung", "Estimate Invoice": "Rechnungssch\xE4tzung", "Estimate Total": "Gesch\xE4tzte Summe", "Estimate/Invoice": "Sch\xE4tzung/Rechnung", "Estimates": "Sch\xE4tzungen", "Expand All": "Alle erweitern", "Expand Note": "Notiz Erweitern", "Expand Sidebar": "Erweitern Sie die Seitenleiste", "Expired": "Abgelaufen", "FMI": "FMI", "Follow Up Time": "Follow-up-Zeit", "Follow-Up": "Follow-Up", "Fri": "Fr", "Fully Covered": "Volle Deckung", "High Severity": "Hoher Schweregrad", "Hours": "Std", "Invoice": "Rechnung", "Invoice Date": "Rechnungsdatum", "Invoice Id": "Rechnungs-ID", "It looks like you\u2019re lost\u2026": "Es sieht so aus als ob du verloren bist ...", "Item": "Artikel", "Jump To...": "Springen zu...", "Less than a Minute": "Weniger als einer Minute", "Less than an Hour": "Weniger als eine Stunde", "List": "Liste", "Load More": "Mehr laden", "Loading...": "Wird geladen...", "Location": "Standort", "Log Out": "Ausloggen", "Log in": "Einloggen", "Logging out...": "Ausloggen...", "Mack": "Mack", "Maintenance": "Wartung", "Maintenance Current": "Aktuelle Wartung", "Maintenance Due": "F\xE4lligen Wartungstermin", "Maintenance Overdue": "\xDCberf\xE4lliges Wartungsdatum", "Make": "Marke", "Map": "Karte", "Mark as Read": "Als gelesen markieren", "Mark as Unread": "Als ungelesen markieren", "Matches: {count}": function MatchesCount(a) {
      return ["\xDCbereinstimmungen: ", a("count")];
    }, "Measure": "Messen", "Medium Severity": "Mittlere Schweregrade", "Model": "Modell", "Mon": "Mo", "More than a Day": "Mehr als ein Tag", "More than a Month": "Mehr als ein Monat", "More than a Week": "Mehr als eine Woche", "More than a Year": "Mehr als ein Jahr", "More than an Hour": "Mehr als eine Stunde", "New Note": "Neue Notiz", "Newest to Oldest": "Neuester zu \xC4ltester", "No Coverage": "Keine Deckung", "No Open Cases": "Keine offenen F\xE4lle", "No complaints yet": "Noch keine Beschwerden", "No matches for": "Keine \xDCbereinstimmungen f\xFCr", "No matches for \"": "Keine \xDCbereinstimmungen f\xFCr \"", "No notes yet.": "Noch keine Notizen.", "No results for \"": "Keine Ergebnisse f\xFCr \"", "Not Provided": "Nicht vorgesehen", "Not available. Please check again later.": "Nicht verf\xFCgbar. Bitte \xFCberpr\xFCfen Sie es sp\xE4ter noch einmal.", "Notes": "Notizen", "Notes {count}": function NotesCount(a) {
      return ["Notizen ", a("count")];
    }, "OPTIONS:": "OPTIONEN:", "Odometer": "Kilometerz\xE4hler", "Oldest to Newest": "\xC4lteste bis neueste", "Open": "\xD6ffnen", "Open Events": "Offene Veranstaltungen", "Open Service Requests": "\xD6ffnen Sie Serviceanfragen", "Optional": "Optional", "Options": "Optionen", "Other": "Andere", "Over a Month": "\xDCber einen Monat", "Over a Week": "\xDCber eine Woche", "Over a Year": "\xDCber ein Jahr", "Over {years} Years": function OverYearsYears(a) {
      return ["\xDCber ", a("years"), " Jahre"];
    }, "Overdue": "\xDCberf\xE4llig", "PDF Link": "PDF Link", "Partially Covered": "Teilweise bedeckt", "Passphrase": "Passphrase", "Past Due ETR": "\xDCberf\xE4llige ETR", "Past Due Follow Up": "\xDCberf\xE4llige Follow-up", "Phone": "Telefon", "Please try again.": "Bitte versuche es erneut.", "Post": "Post", "Press ESC to cancel or ENTER to submit": "Dr\xFCcken Sie ESC zum Abbrechen oder ENTER zum Senden", "Print Page": "Seite drucken", "Privacy Policy": "Datenschutz-Bestimmungen", "Provide a Note about your decision": "Geben Sie eine Anmerkung \xFCber Ihre Entscheidung", "Purchase Order": "Bestellung", "QR Code": "QR-Code", "Reason For Repair": "Grund f\xFCr die Reparatur", "Reason for Repair": "Grund f\xFCr die Reparatur", "Redirecting...": "Umleitung ...", "Related Faults ({count})": function RelatedFaultsCount(a) {
      return ["Zugeh\xF6rige Fehler (", a("count"), ")"];
    }, "Repair Order": "Reparaturauftrag", "Repair Status": "Reparaturstatus", "Reply": "Antworten", "Reports": "Berichte", "Request Service": "Service anfordern", "Request Type": "Anfragetyp", "Request {number}": function RequestNumber(a) {
      return ["Auftrage ", a("number")];
    }, "Requested": "Angefordert", "Return to the classic look": "Kehre zum klassischen Look zur\xFCck", "Review": "Rezension", "SORT:": "SORTIEREN:", "SUBMIT": "EINREICHEN", "Sat": "Sa", "Search Results": "Suchergebnis", "Search Results: {searchValue}": function SearchResultsSearchValue(a) {
      return ["Suchergebnisse: ", a("searchValue")];
    }, "Search by asset location to see nearby providers or service provider for nearby locations.": "Suchen Sie nach dem Standort des Ger\xE4ts, um Anbieter oder Dienstanbieter in der N\xE4he f\xFCr Standorte in der N\xE4he zu sehen.", "Select": "W\xE4hlen", "Select Item...": "Artikel w\xE4hlen...", "Selected": "Ausgew\xE4hlt", "Serial": "Seriell", "Serial No.": "Seriennummer.", "Service Provider": "Dienstleister", "Service Request": "Service-Anfrage", "Service Request Wizard": "Serviceanfrage-Assistent", "Service Requests": "Serviceanfragen", "Service Requests: {count}": function ServiceRequestsCount(a) {
      return ["Serviceanfragen: ", a("count")];
    }, "Severity": "Schweregrad", "Some Current": "Enige Aktuelle", "Something's not right.": "Etwas stimmt nicht.", "Sorry, we don't recognize that passphrase.": "Entschuldigung, wir erkennen diese Passphrase nicht.", "Sorry, we had a connection issue while loading recipients. Please try again.": "Entschuldigung, beim Laden der Empf\xE4nger ist ein Verbindungsproblem aufgetreten. Bitte versuche es erneut.", "Status": "Status", "Step {step} of {total}": function StepStepOfTotal(a) {
      return ["Stufe ", a("step"), " von ", a("total")];
    }, "Submit Request": "Anfrage einreichen", "Sun": "So", "Terms and Conditions": "Gesch\xE4ftsbedingungen", "Terms of Use": "Nutzungsbedingungen", "The Asset Detail Page": "Die Assetdetailseite", "The Asset Detail page of the application": "Die Seite Asset-Details der Anwendung", "The Assets Page": "Die Assets Seite", "The Case Page": "Die Fallseite", "The Cases Page": "Die F\xE4lle", "The Search Results Page": "Die Suchergebnisseite", "The Service Request Detail Page": "Die Detailseite der Service-Anfrage", "The Service Request Detail page of the application": "Die Detailseite f\xFCr die Service-Anfrage der Anwendung", "The assets page of the application": "Die Assets-Seite der Anwendung", "The case page of the application": "Die Fallseite der Anwendung", "The cases page of the application": "Die Fallseite der Anwendung", "The search results page of the application": "Die Suchergebnisseite der Anwendung", "There is an error in your input. Please try again.": "In Ihrer Eingabe ist ein Fehler aufgetreten. Bitte versuche es erneut.", "This page either does not exist or you need permission to view it.": "Diese Seite existiert entweder nicht oder Sie ben\xF6tigen die Erlaubnis, sie anzusehen.", "Thu": "Do", "To:": "Zu:", "Try broadening your search criteria.": "Versuchen Sie, Ihre Suchkriterien zu erweitern.", "Try removing or editing some of the filters to expand your search, or search by a different location.": "Versuchen Sie, einige der Filter zu entfernen oder zu bearbeiten, um Ihre Suche zu erweitern oder suchen Sie nach einem anderen.", "Try removing or editing some of your criteria to expand the search or review another favorite.": "Versuchen Sie, einige Ihrer Kriterien zu entfernen oder zu bearbeiten, um die Suche zu erweitern oder einen anderen Favoriten anzuzeigen.", "Try removing or editing some of your criteria to expand the search or search by city and state or zip code.": "Versuchen Sie, einige Ihrer Kriterien zu entfernen oder zu bearbeiten, um die Suche zu erweitern oder nach Stadt, Bundesstaat oder Postleitzahl zu suchen.", "Try using the search bar or contacting the person who gave you the link.": "Verwenden Sie die Suchleiste oder wenden Sie sich an die Person, die den Link angegeben hat.", "Tue": "Di", "UNIT": "EINHEIT", "Unit": "Ger\xE4te", "Unit #{unitNumber}": function UnitUnitNumber(a) {
      return ["Ger\xE4te #", a("unitNumber")];
    }, "Unit Number": "Ger\xE4tenummer", "Unit {number}": function UnitNumber(a) {
      return ["Ger\xE4te ", a("number")];
    }, "Unit {unitNumber}": function UnitUnitNumber(a) {
      return ["Ger\xE4te ", a("unitNumber")];
    }, "Unread Notes": "Ungelesene Notizen", "Uptime Cases": "Aktuelle-F\xE4lle", "VIN": "Fahrgestellnummer", "Validating...": "Validierung ...", "Value": "Wert", "View As": "Ansicht als", "View Estimate": "Sch\xE4tzung anzeigen", "View In Full-Screen Mode": "Im Vollbildmodus anzeigen", "View Latest Estimate": "Letzte Sch\xE4tzung anzeigen", "View Repair Instructions": "Siehe Reparaturanweisungen", "Volvo": "Volvo", "Waiting Approval": "Warten auf Genehmigung", "Warranty": "Garantie", "We didn't find any possible recipients. Please contact our support services team.": "Wir haben keine m\xF6glichen Empf\xE4nger gefunden. Bitte kontaktieren Sie unser Support-Team.", "Wed": "Mi", "What type of Service?": "Welche Art von Service?", "What's the complaint?": "Was ist die Reklamation?", "Which asset?": "Welches Verm\xF6gen?", "Which service provider do you want?": "Welchen Dienstleister m\xF6chten Sie?", "Year": "Jahr", "Yesterday": "Gestern", "You can select a complaint code or enter a description. When possible, fill in both. That helps the service provider expedite your case.": "Sie k\xF6nnen einen Beschwerdecode ausw\xE4hlen oder eine Beschreibung eingeben. Wenn m\xF6glich, f\xFCllen Sie beide aus. Das hilft dem Dienstleister, Ihren Fall zu beschleunigen.", "You may want to disable it before entering your password.": "M\xF6glicherweise m\xF6chten Sie es deaktivieren, bevor Sie Ihr Passwort eingeben.", "You reached the max character count.": "Du hast die maximale Anzahl an Charakteren erreicht.", "You reached the max of 15 recipients. Remove some recipients to enable the Post button.": "Sie haben die maximale Anzahl von 15 Empf\xE4ngern erreicht. Entfernen Sie einige Empf\xE4nger, um die Schaltfl\xE4che \"Senden\" zu aktivieren.", "Your passphrase is too short.": "Ihre Passphrase ist zu kurz.", "Your submission has failed.": "Ihre Einreichung ist fehlgeschlagen.", "Your username is too short.": "Dein Benutzername ist zu kurz.", "campaign due": "Kampagne f\xE4llig", "current": "aktuelle", "due": "f\xE4llig", "expired": "abgelaufen", "fully covered": "volle deckung", "in": "im", "no coverage": "keine Deckung", "overdue": "\xFCberf\xE4llig", "partially covered": "teilweise bedeckt", "{app} version {version}": function appVersionVersion(a) {
      return [a("app"), " Version ", a("version")];
    }, "{app} version {version} (GIT SHA {gitVersion})": function appVersionVersionGITSHAGitVersion(a) {
      return [a("app"), " Version ", a("version"), " (GIT SHA ", a("gitVersion"), ")"];
    }, "{count, plural, one {# Open Case} other {# Open Cases}}": function countPluralOneOpenCaseOtherOpenCases(a) {
      return [a("count", "plural", { one: ["#", " Fall \xF6ffnen"], other: ["#", " F\xE4lle \xF6ffnen"] })];
    }, "{count} Unread": function countUnread(a) {
      return [a("count"), " Ungelesen"];
    }, "{count} Unread {count, plural, one {Note} other {Notes}}": function countUnreadCountPluralOneNoteOtherNotes(a) {
      return [a("count"), " Ungelesen ", a("count", "plural", { one: "Note", other: "Notizen" })];
    }, "{date}": function date(a) {
      return [a("date")];
    }, "{days} Days": function daysDays(a) {
      return [a("days"), " Tage"];
    }, "{days} Days Ago": function daysDaysAgo(a) {
      return [a("days"), " vor Tagen"];
    }, "{hours} Hours": function hoursHours(a) {
      return [a("hours"), " Stunden"];
    }, "{hours} Hours Ago": function hoursHoursAgo(a) {
      return ["vor ", a("hours"), " Stunden"];
    }, "{minutes} Minutes Ago": function minutesMinutesAgo(a) {
      return ["vor ", a("minutes"), " Minuten"];
    }, "{months} Months": function monthsMonths(a) {
      return [a("months"), " Monate"];
    }, "{months} Months Ago": function monthsMonthsAgo(a) {
      return ["vor ", a("months"), " Monate"];
    }, "{serviceRequestId}": function serviceRequestId(a) {
      return [a("serviceRequestId")];
    }, "{value} {value, plural, one {Character} other {Characters}} left": function valueValuePluralOneCharacterOtherCharactersLeft(a) {
      return [a("value"), " ", a("value", "plural", { one: "Zeichen", other: "Zeichen" }), " \xFCbrig"];
    }, "{weeks} Weeks": function weeksWeeks(a) {
      return [a("weeks"), " Wochen"];
    }, "{weeks} Weeks Ago": function weeksWeeksAgo(a) {
      return ["vor ", a("weeks"), " Wochen"];
    }, "{years} Years": function yearsYears(a) {
      return [a("years"), " Jahre"];
    }, "{years} Years Ago": function yearsYearsAgo(a) {
      return ["vor ", a("years"), " Jahren"];
    } } };

/***/ }),

/***/ "./locale/en/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = { l: { "p": function p(n, ord) {
      var s = String(n).split("."),
          v0 = !s[1],
          t0 = Number(s[0]) == n,
          n10 = t0 && s[0].slice(-1),
          n100 = t0 && s[0].slice(-2);if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";return n == 1 && v0 ? "one" : "other";
    } }, m: { "\".": "\".", "#{caseId}": function caseId(a) {
      return ["#", a("caseId")];
    }, "({count}) Older {count, plural, one {Comment} other {Comments}}": function countOlderCountPluralOneCommentOtherComments(a) {
      return ["(", a("count"), ") Older ", a("count", "plural", { one: "Comment", other: "Comments" })];
    }, "... {count} more": function countMore(a) {
      return ["... ", a("count"), " more"];
    }, "...Loading": "...Loading", "1 Hour": "1 Hour", "A Minute Ago": "A Minute Ago", "A Month Ago": "A Month Ago", "A Week Ago": "A Week Ago", "A Year Ago": "A Year Ago", "Accept": "Accept", "Add Note": "Add Note", "Additional Warnings": "Additional Warnings", "Address": "Address", "Administration": "Administration", "All Assets": "All Assets", "All Current": "All Current", "All Repair Cases": "All Repair Cases", "Amount": "Amount", "An Hour Ago": "An Hour Ago", "Approvals": "Approvals", "Approve": "Approve", "Asset": "Asset", "Asset Location": "Asset Location", "Asset Summary": "Asset Summary", "Assets": "Assets", "Assets ({count})": function AssetsCount(a) {
      return ["Assets (", a("count"), ")"];
    }, "Assets: {count}": function AssetsCount(a) {
      return ["Assets: ", a("count")];
    }, "Back to Top": "Back to Top", "Breakdown": "Breakdown", "By signing in you agree to all applicable ": "By signing in you agree to all applicable ", "Campaign Due": "Campaign Due", "Campaigns": "Campaigns", "Cancel": "Cancel", "Cancel Request": "Cancel Request", "Caps Lock is Enabled": "Caps Lock is Enabled", "Cards": "Cards", "Case": "Case", "Case Status": "Case Status", "Case {caseId}": function CaseCaseId(a) {
      return ["Case ", a("caseId")];
    }, "Case {number}": function CaseNumber(a) {
      return ["Case ", a("number")];
    }, "Cases": "Cases", "Cases ({count})": function CasesCount(a) {
      return ["Cases (", a("count"), ")"];
    }, "Cases: {count}": function CasesCount(a) {
      return ["Cases: ", a("count")];
    }, "Closed": "Closed", "Code - Description": "Code - Description", "Code Not Provided": "Code Not Provided", "Collapse All": "Collapse All", "Collapse Note": "Collapse Note", "Collapse Sidebar": "Collapse Sidebar", "Comments": "Comments", "Complaint": "Complaint", "Complaint Code": "Complaint Code", "Component Id": "Component Id", "Continue": "Continue", "Copyright \xA9 {year} Decisiv, Inc.": function CopyrightYearDecisivInc(a) {
      return ["Copyright \xA9 ", a("year"), " Decisiv, Inc."];
    }, "Count": "Count", "Create New Service Request": "Create New Service Request", "Create Service Request": "Create Service Request", "Created": "Created", "Current": "Current", "Date/Time": "Date/Time", "Decisiv": "Decisiv", "Decline": "Decline", "Description": "Description", "Description Not Provided": "Description Not Provided", "Diagnostics": "Diagnostics", "Diagnostics Details": "Diagnostics Details", "Distance to Service Location": "Distance to Service Location", "Downtime": "Downtime", "Downtime > 2 Days": "Downtime > 2 Days", "Due": "Due", "ECU": "ECU", "ETR": "ETR", "Edit": "Edit", "Email Address or Username": "Email Address or Username", "Engine": "Engine", "Enter a city and state or zip code...": "Enter a city and state or zip code...", "Enter a passphrase at least four characters long.": "Enter a passphrase at least four characters long.", "Enter a username at least four characters long.": "Enter a username at least four characters long.", "Enter at least 3 characters for your search.": "Enter at least 3 characters for your search.", "Error": "Error", "Estimate": "Estimate", "Estimate Invoice": "Estimate Invoice", "Estimate Total": "Estimate Total", "Estimate/Invoice": "Estimate/Invoice", "Estimates": "Estimates", "Expand All": "Expand All", "Expand Note": "Expand Note", "Expand Sidebar": "Expand Sidebar", "Expired": "Expired", "FMI": "FMI", "Follow Up Time": "Follow Up Time", "Follow-Up": "Follow-Up", "Fri": "Fri", "Fully Covered": "Fully Covered", "High Severity": "High Severity", "Hours": "Hours", "Invoice": "Invoice", "Invoice Date": "Invoice Date", "Invoice Id": "Invoice Id", "It looks like you\u2019re lost\u2026": "It looks like you\u2019re lost\u2026", "Item": "Item", "Jump To...": "Jump To...", "Less than a Minute": "Less than a Minute", "Less than an Hour": "Less than an Hour", "List": "List", "Load More": "Load More", "Loading...": "Loading...", "Location": "Location", "Log Out": "Log Out", "Log in": "Log in", "Logging out...": "Logging out...", "Mack": "Mack", "Maintenance": "Maintenance", "Maintenance Current": "Maintenance Current", "Maintenance Due": "Maintenance Due", "Maintenance Overdue": "Maintenance Overdue", "Make": "Make", "Map": "Map", "Mark as Read": "Mark as Read", "Mark as Unread": "Mark as Unread", "Matches: {count}": function MatchesCount(a) {
      return ["Matches: ", a("count")];
    }, "Measure": "Measure", "Medium Severity": "Medium Severity", "Model": "Model", "Mon": "Mon", "More than a Day": "More than a Day", "More than a Month": "More than a Month", "More than a Week": "More than a Week", "More than a Year": "More than a Year", "More than an Hour": "More than an Hour", "New Note": "New Note", "Newest to Oldest": "Newest to Oldest", "No Coverage": "No Coverage", "No Open Cases": "No Open Cases", "No complaints yet": "No complaints yet", "No matches for": "No matches for", "No matches for \"": "No matches for \"", "No notes yet.": "No notes yet.", "No results for \"": "No results for \"", "Not Provided": "Not Provided", "Not available. Please check again later.": "Not available. Please check again later.", "Notes": "Notes", "Notes {count}": function NotesCount(a) {
      return ["Notes ", a("count")];
    }, "OPTIONS:": "OPTIONS:", "Odometer": "Odometer", "Oldest to Newest": "Oldest to Newest", "Open": "Open", "Open Events": "Open Events", "Open Service Requests": "Open Service Requests", "Optional": "Optional", "Options": "Options", "Other": "Other", "Over a Month": "Over a Month", "Over a Week": "Over a Week", "Over a Year": "Over a Year", "Over {years} Years": function OverYearsYears(a) {
      return ["Over ", a("years"), " Years"];
    }, "Overdue": "Overdue", "PDF Link": "PDF Link", "Partially Covered": "Partially Covered", "Passphrase": "Passphrase", "Past Due ETR": "Past Due ETR", "Past Due Follow Up": "Past Due Follow Up", "Phone": "Phone", "Please try again.": "Please try again.", "Post": "Post", "Press ESC to cancel or ENTER to submit": "Press ESC to cancel or ENTER to submit", "Print Page": "Print Page", "Privacy Policy": "Privacy Policy", "Provide a Note about your decision": "Provide a Note about your decision", "Purchase Order": "Purchase Order", "QR Code": "QR Code", "Reason For Repair": "Reason For Repair", "Reason for Repair": "Reason for Repair", "Redirecting...": "Redirecting...", "Related Faults ({count})": function RelatedFaultsCount(a) {
      return ["Related Faults (", a("count"), ")"];
    }, "Repair Order": "Repair Order", "Repair Status": "Repair Status", "Reply": "Reply", "Reports": "Reports", "Request Service": "Request Service", "Request Type": "Request Type", "Request {number}": function RequestNumber(a) {
      return ["Request ", a("number")];
    }, "Requested": "Requested", "Return to the classic look": "Return to the classic look", "Review": "Review", "SORT:": "SORT:", "SUBMIT": "SUBMIT", "Sat": "Sat", "Search Results": "Search Results", "Search Results: {searchValue}": function SearchResultsSearchValue(a) {
      return ["Search Results: ", a("searchValue")];
    }, "Search by asset location to see nearby providers or service provider for nearby locations.": "Search by asset location to see nearby providers or service provider for nearby locations.", "Select": "Select", "Select Item...": "Select Item...", "Selected": "Selected", "Serial": "Serial", "Serial No.": "Serial No.", "Service Provider": "Service Provider", "Service Request": "Service Request", "Service Request Wizard": "Service Request Wizard", "Service Requests": "Service Requests", "Service Requests: {count}": function ServiceRequestsCount(a) {
      return ["Service Requests: ", a("count")];
    }, "Severity": "Severity", "Some Current": "Some Current", "Something's not right.": "Something's not right.", "Sorry, we don't recognize that passphrase.": "Sorry, we don't recognize that passphrase.", "Sorry, we had a connection issue while loading recipients. Please try again.": "Sorry, we had a connection issue while loading recipients. Please try again.", "Status": "Status", "Step {step} of {total}": function StepStepOfTotal(a) {
      return ["Step ", a("step"), " of ", a("total")];
    }, "Submit Request": "Submit Request", "Sun": "Sun", "Terms and Conditions": "Terms and Conditions", "Terms of Use": "Terms of Use", "The Asset Detail Page": "The Asset Detail Page", "The Asset Detail page of the application": "The Asset Detail page of the application", "The Assets Page": "The Assets Page", "The Case Page": "The Case Page", "The Cases Page": "The Cases Page", "The Search Results Page": "The Search Results Page", "The Service Request Detail Page": "The Service Request Detail Page", "The Service Request Detail page of the application": "The Service Request Detail page of the application", "The assets page of the application": "The assets page of the application", "The case page of the application": "The case page of the application", "The cases page of the application": "The cases page of the application", "The search results page of the application": "The search results page of the application", "There is an error in your input. Please try again.": "There is an error in your input. Please try again.", "This page either does not exist or you need permission to view it.": "This page either does not exist or you need permission to view it.", "Thu": "Thu", "To:": "To:", "Try broadening your search criteria.": "Try broadening your search criteria.", "Try removing or editing some of the filters to expand your search, or search by a different location.": "Try removing or editing some of the filters to expand your search, or search by a different location.", "Try removing or editing some of your criteria to expand the search or review another favorite.": "Try removing or editing some of your criteria to expand the search or review another favorite.", "Try removing or editing some of your criteria to expand the search or search by city and state or zip code.": "Try removing or editing some of your criteria to expand the search or search by city and state or zip code.", "Try using the search bar or contacting the person who gave you the link.": "Try using the search bar or contacting the person who gave you the link.", "Tue": "Tue", "UNIT": "UNIT", "Unit": "Unit", "Unit #{unitNumber}": function UnitUnitNumber(a) {
      return ["Unit #", a("unitNumber")];
    }, "Unit Number": "Unit Number", "Unit {number}": function UnitNumber(a) {
      return ["Unit ", a("number")];
    }, "Unit {unitNumber}": function UnitUnitNumber(a) {
      return ["Unit ", a("unitNumber")];
    }, "Unread Notes": "Unread Notes", "Uptime Cases": "Uptime Cases", "VIN": "VIN", "Validating...": "Validating...", "Value": "Value", "View As": "View As", "View Estimate": "View Estimate", "View In Full-Screen Mode": "View In Full-Screen Mode", "View Latest Estimate": "View Latest Estimate", "View Repair Instructions": "View Repair Instructions", "Volvo": "Volvo", "Waiting Approval": "Waiting Approval", "Warranty": "Warranty", "We didn't find any possible recipients. Please contact our support services team.": "We didn't find any possible recipients. Please contact our support services team.", "Wed": "Wed", "What type of Service?": "What type of Service?", "What's the complaint?": "What's the complaint?", "Which asset?": "Which asset?", "Which service provider do you want?": "Which service provider do you want?", "Year": "Year", "Yesterday": "Yesterday", "You can select a complaint code or enter a description. When possible, fill in both. That helps the service provider expedite your case.": "You can select a complaint code or enter a description. When possible, fill in both. That helps the service provider expedite your case.", "You may want to disable it before entering your password.": "You may want to disable it before entering your password.", "You reached the max character count.": "You reached the max character count.", "You reached the max of 15 recipients. Remove some recipients to enable the Post button.": "You reached the max of 15 recipients. Remove some recipients to enable the Post button.", "Your passphrase is too short.": "Your passphrase is too short.", "Your submission has failed.": "Your submission has failed.", "Your username is too short.": "Your username is too short.", "campaign due": "campaign due", "current": "current", "due": "due", "expired": "expired", "fully covered": "fully covered", "in": "in", "no coverage": "no coverage", "overdue": "overdue", "partially covered": "partially covered", "{app} version {version}": function appVersionVersion(a) {
      return [a("app"), " version ", a("version")];
    }, "{app} version {version} (GIT SHA {gitVersion})": function appVersionVersionGITSHAGitVersion(a) {
      return [a("app"), " version ", a("version"), " (GIT SHA ", a("gitVersion"), ")"];
    }, "{count, plural, one {# Open Case} other {# Open Cases}}": function countPluralOneOpenCaseOtherOpenCases(a) {
      return [a("count", "plural", { one: ["#", " Open Case"], other: ["#", " Open Cases"] })];
    }, "{count} Unread": function countUnread(a) {
      return [a("count"), " Unread"];
    }, "{count} Unread {count, plural, one {Note} other {Notes}}": function countUnreadCountPluralOneNoteOtherNotes(a) {
      return [a("count"), " Unread ", a("count", "plural", { one: "Note", other: "Notes" })];
    }, "{date}": function date(a) {
      return [a("date")];
    }, "{days} Days": function daysDays(a) {
      return [a("days"), " Days"];
    }, "{days} Days Ago": function daysDaysAgo(a) {
      return [a("days"), " Days Ago"];
    }, "{hours} Hours": function hoursHours(a) {
      return [a("hours"), " Hours"];
    }, "{hours} Hours Ago": function hoursHoursAgo(a) {
      return [a("hours"), " Hours Ago"];
    }, "{minutes} Minutes Ago": function minutesMinutesAgo(a) {
      return [a("minutes"), " Minutes Ago"];
    }, "{months} Months": function monthsMonths(a) {
      return [a("months"), " Months"];
    }, "{months} Months Ago": function monthsMonthsAgo(a) {
      return [a("months"), " Months Ago"];
    }, "{serviceRequestId}": function serviceRequestId(a) {
      return [a("serviceRequestId")];
    }, "{value} {value, plural, one {Character} other {Characters}} left": function valueValuePluralOneCharacterOtherCharactersLeft(a) {
      return [a("value"), " ", a("value", "plural", { one: "Character", other: "Characters" }), " left"];
    }, "{weeks} Weeks": function weeksWeeks(a) {
      return [a("weeks"), " Weeks"];
    }, "{weeks} Weeks Ago": function weeksWeeksAgo(a) {
      return [a("weeks"), " Weeks Ago"];
    }, "{years} Years": function yearsYears(a) {
      return [a("years"), " Years"];
    }, "{years} Years Ago": function yearsYearsAgo(a) {
      return [a("years"), " Years Ago"];
    } } };

/***/ }),

/***/ "./locale/es/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = { l: { "p": function p(n, ord) {
      if (ord) return "other";return n == 1 ? "one" : "other";
    } }, m: { "\".": "\".", "#{caseId}": function caseId(a) {
      return ["#", a("caseId")];
    }, "({count}) Older {count, plural, one {Comment} other {Comments}}": function countOlderCountPluralOneCommentOtherComments(a) {
      return ["(", a("count"), ") Mayores ", a("count", "plural", { one: "Comentario", other: "Comentarios" })];
    }, "... {count} more": function countMore(a) {
      return ["... ", a("count"), " m\xE1s"];
    }, "...Loading": "...Cargando", "1 Hour": "1 Hour", "A Minute Ago": "A Minute Ago", "A Month Ago": "A Month Ago", "A Week Ago": "A Week Ago", "A Year Ago": "A Year Ago", "Accept": "Aceptar", "Add Note": "A\xF1adir la nota", "Additional Warnings": "Advertencias adicionales", "Address": "Direcci\xF3n", "Administration": "Administraci\xF3n", "All Assets": "Todos los activos", "All Current": "Todos los actuales", "All Repair Cases": "Todos los casos de reparaci\xF3n", "Amount": "Cantidad", "An Hour Ago": "An Hour Ago", "Approvals": "Aprobaciones", "Approve": "Aprobar", "Asset": "Activo", "Asset Location": "Ubicaci\xF3n del activo", "Asset Summary": "Resumen de activos", "Assets": "Bienes", "Assets ({count})": function AssetsCount(a) {
      return ["Activos (", a("count"), ")"];
    }, "Assets: {count}": function AssetsCount(a) {
      return ["Activos: ", a("count")];
    }, "Back to Top": "Volver arriba", "Breakdown": "Descompostura", "By signing in you agree to all applicable ": "Al iniciar sesi\xF3n, acepta todos los requisitos aplicables.", "Campaign Due": "Campa\xF1a debida", "Campaigns": "Campa\xF1as", "Cancel": "Cancelar", "Cancel Request": "Cancelar petici\xF3n", "Caps Lock is Enabled": "Bloq May\xFAs est\xE1 habilitado", "Cards": "Tarjetas", "Case": "Caso", "Case Status": "Estado del caso", "Case {caseId}": function CaseCaseId(a) {
      return ["Caso ", a("caseId")];
    }, "Case {number}": function CaseNumber(a) {
      return ["Caso ", a("number")];
    }, "Cases": "Casos", "Cases ({count})": function CasesCount(a) {
      return ["Casos (", a("count"), ")"];
    }, "Cases: {count}": function CasesCount(a) {
      return ["Casos: ", a("count")];
    }, "Closed": "Cerrado", "Code - Description": "C\xF3digo - Descripci\xF3n", "Code Not Provided": "C\xF3digo no provisto", "Collapse All": "Desplegar todo", "Collapse Note": "Contraer nota", "Collapse Sidebar": "Contraer la barra lateral", "Comments": "Comentarios", "Complaint": "Queja", "Complaint Code": "C\xF3digo de Queja", "Component Id": "ID de componente", "Continue": "Continuar", "Copyright \xA9 {year} Decisiv, Inc.": function CopyrightYearDecisivInc(a) {
      return ["Copyright \xA9 ", a("a\xF1o"), " Decisiv, Inc."];
    }, "Count": "Contar", "Create New Service Request": "Crear nueva solicitud de servicio", "Create Service Request": "Crear solicitud de servicio", "Created": "Created", "Current": "Corriente", "Date/Time": "Fecha y hora", "Decisiv": "Decisiv", "Decline": "Disminuci\xF3n", "Description": "Descripci\xF3n", "Description Not Provided": "Descripci\xF3n no proporcionada", "Diagnostics": "Diagnostico", "Diagnostics Details": "Detalles de diagn\xF3stico", "Distance to Service Location": "Distancia a la ubicaci\xF3n del servicio", "Downtime": "Falta del tiempo", "Downtime > 2 Days": "Tiempo de inactividad> 2 d\xEDas", "Due": "Debido", "ECU": "ECU", "ETR": "ETR", "Edit": "Editar", "Email Address or Username": "Direcci\xF3n de correo electr\xF3nico o nombre de usuario", "Engine": "Motor", "Enter a city and state or zip code...": "Ingrese una ciudad y estado o c\xF3digo postal ...", "Enter a passphrase at least four characters long.": "Ingrese una frase de contrase\xF1a de al menos cuatro caracteres.", "Enter a username at least four characters long.": "Ingrese un nombre de usuario de al menos cuatro caracteres de longitud.", "Enter at least 3 characters for your search.": "Ingrese al menos 3 caracteres para su b\xFAsqueda.", "Error": "Error", "Estimate": "Estimar", "Estimate Invoice": "Estimar factura", "Estimate Total": "Estimar total", "Estimate/Invoice": "Estimado / Factura", "Estimates": "Estimados", "Expand All": "Expandir todo", "Expand Note": "Expandir Nota", "Expand Sidebar": "Expandir barra lateral", "Expired": "Muerto", "FMI": "FMI", "Follow Up Time": "Tiempo de seguimiento", "Follow-Up": "Seguir", "Fri": "Vie", "Fully Covered": "Totalmente cubierto", "High Severity": "Alta severidad", "Hours": "Horas", "Invoice": "Factura", "Invoice Date": "Fecha de la factura", "Invoice Id": "Id de la factura", "It looks like you\u2019re lost\u2026": "Parece que est\xE1s perdido ...", "Item": "\xEDt.", "Jump To...": "Salta a...", "Less than a Minute": "Less than a Minute", "Less than an Hour": "Less than an Hour", "List": "Lista", "Load More": "Carga m\xE1s", "Loading...": "Cargando...", "Location": "Ubicaci\xF3n", "Log Out": "Cerrar sesi\xF3n", "Log in": "Iniciar sesi\xF3n", "Logging out...": "Saliendo de tu cuenta...", "Mack": "Mack", "Maintenance": "Mantenimiento", "Maintenance Current": "Mantenimiento actual", "Maintenance Due": "Mantenimiento debido", "Maintenance Overdue": "Mantenimiento vencido", "Make": "Hacer", "Map": "Mapa", "Mark as Read": "Marcar como le\xEDdo", "Mark as Unread": "Marcar como no le\xEDdo", "Matches: {count}": function MatchesCount(a) {
      return ["Partidos: ", a("count")];
    }, "Measure": "Medida", "Medium Severity": "Gravedad media", "Model": "Modelo", "Mon": "Lun", "More than a Day": "More than a Day", "More than a Month": "More than a Month", "More than a Week": "More than a Week", "More than a Year": "More than a Year", "More than an Hour": "More than an Hour", "New Note": "Nueva nota", "Newest to Oldest": "Del m\xE1s nuevo al m\xE1s antiguo", "No Coverage": "Sin cobertura", "No Open Cases": "Sin casos abiertos", "No complaints yet": "No tengo quejas todav\xEDa", "No matches for": "No hay coincidencias para", "No matches for \"": "No hay coincidencias para \"", "No notes yet.": "No hay notas todav\xEDa", "No results for \"": "No hay resultados para \"", "Not Provided": "No provisto", "Not available. Please check again later.": "No disponible. Por favor verifique m\xE1s tarde.", "Notes": "Notas", "Notes {count}": function NotesCount(a) {
      return ["Notas ", a("count")];
    }, "OPTIONS:": "OPCIONES:", "Odometer": "Cuentakil\xF3metros", "Oldest to Newest": "De m\xE1s viejo a m\xE1s nuevo", "Open": "Abierto", "Open Events": "Eventos abiertos", "Open Service Requests": "Solicitudes de servicio abierto", "Optional": "Opcional", "Options": "Opciones", "Other": "Otro", "Over a Month": "Over a Month", "Over a Week": "Over a Week", "Over a Year": "Over a Year", "Over {years} Years": function OverYearsYears(a) {
      return ["Over ", a("years"), " Years"];
    }, "Overdue": "Atrasado", "PDF Link": "PDF Link", "Partially Covered": "Parcialmente cubierto", "Passphrase": "Frase de contrase\xF1a", "Past Due ETR": "ETR vencido", "Past Due Follow Up": "Seguimiento vencido", "Phone": "Tel\xE9fono", "Please try again.": "Int\xE9ntalo de nuevo.", "Post": "Enviar", "Press ESC to cancel or ENTER to submit": "Presione ESC para cancelar o ENTER para enviar", "Print Page": "Imprimir p\xE1gina", "Privacy Policy": "Pol\xEDtica de privacidad", "Provide a Note about your decision": "Proporcione una nota sobre su decisi\xF3n", "Purchase Order": "Orden de compra", "QR Code": "C\xF3digo QR", "Reason For Repair": "Motivo de la reparaci\xF3n", "Reason for Repair": "Motivo de la reparaci\xF3n", "Redirecting...": "Redireccionando ...", "Related Faults ({count})": function RelatedFaultsCount(a) {
      return ["Fallas relacionadas (", a("count"), ")"];
    }, "Repair Order": "Orden de reparaci\xF3n", "Repair Status": "Estado de reparaci\xF3n", "Reply": "Respuesta", "Reports": "Informes", "Request Service": "Solicitar servicio", "Request Type": "tipo de solicitud", "Request {number}": function RequestNumber(a) {
      return ["Solicitud ", a("number")];
    }, "Requested": "Pedido", "Return to the classic look": "Volver a la apariencia cl\xE1sica", "Review": "revisi\xF3n", "SORT:": "ORDENAR:", "SUBMIT": "ENVIAR", "Sat": "Sab", "Search Results": "Resultados de la b\xFAsqueda", "Search Results: {searchValue}": function SearchResultsSearchValue(a) {
      return ["Resultados de b\xFAsqueda: ", a("searchValue")];
    }, "Search by asset location to see nearby providers or service provider for nearby locations.": "Busque por ubicaci\xF3n de activo para ver proveedores o proveedores de servicios cercanos para ubicaciones cercanas.", "Select": "Seleccionar", "Select Item...": "Seleccione un art\xEDculo...", "Selected": "Seleccionado", "Serial": "De serie", "Serial No.": "N\xFAmero de serie.", "Service Provider": "Proveedor de servicio", "Service Request": "Petici\xF3n de servicio", "Service Request Wizard": "Asistente de solicitud de servicio", "Service Requests": "Solicitudes de servicio", "Service Requests: {count}": function ServiceRequestsCount(a) {
      return ["Solicitudes de servicio: ", a("count")];
    }, "Severity": "Gravedad", "Some Current": "Algunos actuales", "Something's not right.": "Algo no esta bien.", "Sorry, we don't recognize that passphrase.": "Lo sentimos, no reconocemos esa frase de contrase\xF1a.", "Sorry, we had a connection issue while loading recipients. Please try again.": "Lo sentimos, tuvimos un problema de conexi\xF3n al cargar destinatarios. Int\xE9ntalo de nuevo.", "Status": "Estado", "Step {step} of {total}": function StepStepOfTotal(a) {
      return ["Paso ", a("step"), " de ", a("total")];
    }, "Submit Request": "Enviar peticion", "Sun": "Sol", "Terms and Conditions": "T\xE9rminos y Condiciones", "Terms of Use": "T\xE9rminos de Uso", "The Asset Detail Page": "La p\xE1gina de detalles del activo", "The Asset Detail page of the application": "La p\xE1gina Detalle de activos de la aplicaci\xF3n", "The Assets Page": "La p\xE1gina de activos", "The Case Page": "La p\xE1gina de casos", "The Cases Page": "La p\xE1gina de casos", "The Search Results Page": "La p\xE1gina de resultados de b\xFAsqueda", "The Service Request Detail Page": "La p\xE1gina de detalles de solicitud de servicio", "The Service Request Detail page of the application": "La p\xE1gina Detalle de solicitud de servicio de la aplicaci\xF3n", "The assets page of the application": "La p\xE1gina de activos de la aplicaci\xF3n", "The case page of the application": "La p\xE1gina del caso de la aplicaci\xF3n", "The cases page of the application": "La p\xE1gina de casos de la aplicaci\xF3n", "The search results page of the application": "La p\xE1gina de resultados de b\xFAsqueda de la aplicaci\xF3n", "There is an error in your input. Please try again.": "Hay un error en su entrada. Int\xE9ntalo de nuevo.", "This page either does not exist or you need permission to view it.": "Esta p\xE1gina no existe o necesita permiso para verla.", "Thu": "Jue", "To:": "A:", "Try broadening your search criteria.": "Intenta alargar los criterios de b\xFAsqueda.", "Try removing or editing some of the filters to expand your search, or search by a different location.": "Intente eliminar o editar algunos de los filtros para expandir su b\xFAsqueda, o busque por una ubicaci\xF3n diferente.", "Try removing or editing some of your criteria to expand the search or review another favorite.": "Intente eliminar o editar algunos de sus criterios para expandir la b\xFAsqueda o revisar otros favoritos.", "Try removing or editing some of your criteria to expand the search or search by city and state or zip code.": "Intente eliminar o editar algunos de sus criterios para expandir la b\xFAsqueda o buscar por ciudad y estado o c\xF3digo postal.", "Try using the search bar or contacting the person who gave you the link.": "Intenta usar la barra de b\xFAsqueda o contacta a la persona que te dio el enlace.", "Tue": "Mar", "UNIT": "UNIDAD", "Unit": "Unidad", "Unit #{unitNumber}": function UnitUnitNumber(a) {
      return ["Unit # ", a("unitNumber")];
    }, "Unit Number": "Unidad num\xE9rica", "Unit {number}": function UnitNumber(a) {
      return ["Unidad ", a("number")];
    }, "Unit {unitNumber}": function UnitUnitNumber(a) {
      return ["Unidad ", a("unitNumber")];
    }, "Unread Notes": "Unread Notes", "Uptime Cases": "Casos de tiempo de actividad", "VIN": "VIN", "Validating...": "Validando ...", "Value": "Valor", "View As": "Visto como", "View Estimate": "Ver estimaci\xF3n", "View In Full-Screen Mode": "Ver en modo de pantalla completa", "View Latest Estimate": "Ver la \xFAltima estimaci\xF3n", "View Repair Instructions": "Ver instrucciones de reparaci\xF3n", "Volvo": "Volvo", "Waiting Approval": "esperando aprovaci\xF3n", "Warranty": "Garant\xEDa", "We didn't find any possible recipients. Please contact our support services team.": "No encontramos posibles destinatarios. Por favor, p\xF3ngase en contacto con nuestro equipo de servicios de soporte.", "Wed": "Mie", "What type of Service?": "\xBFQu\xE9 tipo de servicio?", "What's the complaint?": "\xBFCu\xE1l es la queja?", "Which asset?": "\xBFQu\xE9 activo?", "Which service provider do you want?": "\xBFQu\xE9 proveedor de servicios quieres?", "Year": "A\xF1o", "Yesterday": "Yesterday", "You can select a complaint code or enter a description. When possible, fill in both. That helps the service provider expedite your case.": "Puede seleccionar un c\xF3digo de queja o ingresar una descripci\xF3n. Cuando sea posible, complete ambos. Eso ayuda al proveedor de servicios a agilizar su caso.", "You may want to disable it before entering your password.": "Es posible que desee deshabilitarlo antes de ingresar su contrase\xF1a.", "You reached the max character count.": "Alcanzaste el recuento m\xE1ximo de caracteres.", "You reached the max of 15 recipients. Remove some recipients to enable the Post button.": "You reached the max of 15 recipients. Remove some recipients to enable the Post button.", "Your passphrase is too short.": "Su frase de contrase\xF1a es demasiado corta.", "Your submission has failed.": "Su presentaci\xF3n ha fallado", "Your username is too short.": "Tu nombre de usuario es muy corto.", "campaign due": "campa\xF1a debido", "current": "corriente", "due": "debido", "expired": "muerto", "fully covered": "totalmente cubierto", "in": "en", "no coverage": "sin cobertura", "overdue": "atrasado", "partially covered": "parcialmente cubierto", "{app} version {version}": function appVersionVersion(a) {
      return [a("app"), " versi\xF3n ", a("version")];
    }, "{app} version {version} (GIT SHA {gitVersion})": function appVersionVersionGITSHAGitVersion(a) {
      return [a("app"), " versi\xF3n ", a("version"), " (GIT SHA ", a("gitVersion"), ")"];
    }, "{count, plural, one {# Open Case} other {# Open Cases}}": function countPluralOneOpenCaseOtherOpenCases(a) {
      return [a("count", "plural", { one: ["#", " Caso Abierto"], other: ["#", " Casos Abiertos"] })];
    }, "{count} Unread": function countUnread(a) {
      return [a("count"), " no le\xEDdo"];
    }, "{count} Unread {count, plural, one {Note} other {Notes}}": function countUnreadCountPluralOneNoteOtherNotes(a) {
      return [a("count"), " No le\xEDdo ", a("count", "plural", { one: "Nota", other: "Notas" })];
    }, "{date}": function date(a) {
      return [a("date")];
    }, "{days} Days": function daysDays(a) {
      return [a("days"), " Days"];
    }, "{days} Days Ago": function daysDaysAgo(a) {
      return [a("days"), " Days Ago"];
    }, "{hours} Hours": function hoursHours(a) {
      return [a("hours"), " Hours"];
    }, "{hours} Hours Ago": function hoursHoursAgo(a) {
      return [a("hours"), " Hours Ago"];
    }, "{minutes} Minutes Ago": function minutesMinutesAgo(a) {
      return [a("minutes"), " Minutes Ago"];
    }, "{months} Months": function monthsMonths(a) {
      return [a("months"), " Months"];
    }, "{months} Months Ago": function monthsMonthsAgo(a) {
      return [a("months"), " Months Ago"];
    }, "{serviceRequestId}": function serviceRequestId(a) {
      return [a("serviceRequestId")];
    }, "{value} {value, plural, one {Character} other {Characters}} left": function valueValuePluralOneCharacterOtherCharactersLeft(a) {
      return [a("value"), " ", a("value", "plural", { one: "Character", other: "Characters" }), " left"];
    }, "{weeks} Weeks": function weeksWeeks(a) {
      return [a("weeks"), " Weeks"];
    }, "{weeks} Weeks Ago": function weeksWeeksAgo(a) {
      return [a("weeks"), " Weeks Ago"];
    }, "{years} Years": function yearsYears(a) {
      return [a("years"), " Years"];
    }, "{years} Years Ago": function yearsYearsAgo(a) {
      return [a("years"), " Years Ago"];
    } } };

/***/ }),

/***/ "./locale/ja/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = { l: { "p": function p(n, ord) {
      if (ord) return "other";return "other";
    } }, m: { "\".": "\"", "#{caseId}": function caseId(a) {
      return ["\uFF03", a("\u30B1\u30FC\u30B9ID")];
    }, "({count}) Older {count, plural, one {Comment} other {Comments}}": function countOlderCountPluralOneCommentOtherComments(a) {
      return ["\uFF08", a("count"), "\uFF09\u53E4\u3044", a("count", "plural", { one: "Comment", other: "Comments" })];
    }, "... {count} more": function countMore(a) {
      return ["... ", a("count"), "\u500B\u4EE5\u4E0A"];
    }, "...Loading": "...\u8AAD\u307F\u8FBC\u307F\u4E2D", "1 Hour": "1 Hour", "A Minute Ago": "A Minute Ago", "A Month Ago": "A Month Ago", "A Week Ago": "A Week Ago", "A Year Ago": "A Year Ago", "Accept": "\u540C\u610F\u3059\u308B", "Add Note": "\u30E1\u30E2\u3092\u8FFD\u52A0", "Additional Warnings": "\u305D\u306E\u4ED6\u306E\u8B66\u544A", "Address": "\u4F4F\u6240", "Administration": "\u7BA1\u7406", "All Assets": "\u3059\u3079\u3066\u306E\u30A2\u30BB\u30C3\u30C8", "All Current": "\u3059\u3079\u3066\u306E\u73FE\u5728", "All Repair Cases": "\u3059\u3079\u3066\u306E\u4FEE\u7406\u30B1\u30FC\u30B9", "Amount": "\u91CF", "An Hour Ago": "An Hour Ago", "Approvals": "\u627F\u8A8D", "Approve": "\u627F\u8A8D\u3059\u308B", "Asset": "\u8CC7\u7523", "Asset Location": "\u8CC7\u7523\u306E\u5834\u6240", "Asset Summary": "\u8CC7\u7523\u306E\u6982\u8981", "Assets": "\u8CC7\u7523", "Assets ({count})": function AssetsCount(a) {
      return ["\u8CC7\u7523\uFF08", a("count"), "\uFF09"];
    }, "Assets: {count}": function AssetsCount(a) {
      return ["\u8CC7\u7523\uFF1A", a("count")];
    }, "Back to Top": "\u30C8\u30C3\u30D7\u306B\u623B\u308B", "Breakdown": "\u58CA\u3059", "By signing in you agree to all applicable ": "\u30B5\u30A4\u30F3\u30A4\u30F3\u3059\u308B\u3053\u3068\u306B\u3088\u308A, \u3042\u306A\u305F\u306F\u3059\u3079\u3066\u306E\u8A72\u5F53\u3059\u308B", "Campaign Due": "\u30AD\u30E3\u30F3\u30DA\u30FC\u30F3\u671F\u9650", "Campaigns": "\u30AD\u30E3\u30F3\u30DA\u30FC\u30F3", "Cancel": "\u30AD\u30E3\u30F3\u30BB\u30EB", "Cancel Request": "\u30AD\u30E3\u30F3\u30BB\u30EB\u30EA\u30AF\u30A8\u30B9\u30C8", "Caps Lock is Enabled": "Caps Lock\u304C\u6709\u52B9\u3067\u3059", "Cards": "\u30AB\u30FC\u30C9", "Case": "\u5834\u5408", "Case Status": "\u30B1\u30FC\u30B9\u30B9\u30C6\u30FC\u30BF\u30B9", "Case {caseId}": function CaseCaseId(a) {
      return ["\u30B1\u30FC\u30B9", a("caseId")];
    }, "Case {number}": function CaseNumber(a) {
      return ["\u30B1\u30FC\u30B9", a("number")];
    }, "Cases": "\u30B1\u30FC\u30B9", "Cases ({count})": function CasesCount(a) {
      return ["\u30B1\u30FC\u30B9\uFF08", a("count"), "\uFF09"];
    }, "Cases: {count}": function CasesCount(a) {
      return ["\u30B1\u30FC\u30B9\uFF1A", a("count")];
    }, "Closed": "\u9589\u307E\u3063\u3066\u3044\u308B", "Code - Description": "\u30B3\u30FC\u30C9 - \u8AAC\u660E", "Code Not Provided": "\u63D0\u4F9B\u3055\u308C\u3066\u3044\u306A\u3044\u30B3\u30FC\u30C9", "Collapse All": "\u3059\u3079\u3066\u3092\u6298\u308A\u305F\u305F\u3080", "Collapse Note": "\u6298\u308A\u305F\u305F\u307F\u30E1\u30E2", "Collapse Sidebar": "\u6298\u308A\u305F\u305F\u307F\u30B5\u30A4\u30C9\u30D0\u30FC", "Comments": "\u30B3\u30E1\u30F3\u30C8", "Complaint": "\u82E6\u60C5", "Complaint Code": "\u30AF\u30EC\u30FC\u30E0\u30B3\u30FC\u30C9", "Component Id": "\u30B3\u30F3\u30DD\u30FC\u30CD\u30F3\u30C8ID", "Continue": "\u6301\u7D9A\u3059\u308B", "Copyright \xA9 {year} Decisiv, Inc.": function CopyrightYearDecisivInc(a) {
      return ["\u8457\u4F5C\u6A29\xA9", a("year"), " Decisiv, Inc."];
    }, "Count": "\u30AB\u30A6\u30F3\u30C8", "Create New Service Request": "\u65B0\u3057\u3044\u30B5\u30FC\u30D3\u30B9\u30EA\u30AF\u30A8\u30B9\u30C8\u3092\u4F5C\u6210\u3059\u308B", "Create Service Request": "\u30B5\u30FC\u30D3\u30B9\u30EA\u30AF\u30A8\u30B9\u30C8\u306E\u4F5C\u6210", "Created": "Created", "Current": "\u73FE\u5728", "Date/Time": "\u65E5\u4ED8\u6642\u523B", "Decisiv": "\u6C7A\u5B9A\u7684\u306A", "Decline": "\u4F4E\u4E0B", "Description": "\u8AAC\u660E", "Description Not Provided": "\u8AAC\u660E\u304C\u63D0\u4F9B\u3055\u308C\u3066\u3044\u306A\u3044", "Diagnostics": "\u8A3A\u65AD", "Diagnostics Details": "\u8A3A\u65AD\u306E\u8A73\u7D30", "Distance to Service Location": "\u30B5\u30FC\u30D3\u30B9\u306E\u5834\u6240\u307E\u3067\u306E\u8DDD\u96E2", "Downtime": "\u30C0\u30A6\u30F3\u30BF\u30A4\u30E0", "Downtime > 2 Days": "\u30C0\u30A6\u30F3\u30BF\u30A4\u30E0> 2\u65E5", "Due": "\u652F\u6255\u671F\u65E5", "ECU": "ECU", "ETR": "ETR", "Edit": "\u7DE8\u96C6", "Email Address or Username": "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u307E\u305F\u306F\u30E6\u30FC\u30B6\u30FC\u30CD\u30FC\u30E0", "Engine": "\u30A8\u30F3\u30B8\u30F3", "Enter a city and state or zip code...": "\u90FD\u5E02\u3068\u5DDE\u307E\u305F\u306F\u90F5\u4FBF\u756A\u53F7\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044...", "Enter a passphrase at least four characters long.": "\u5C11\u306A\u304F\u3068\u30824\u6587\u5B57\u4EE5\u4E0A\u306E\u30D1\u30B9\u30D5\u30EC\u30FC\u30BA\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002", "Enter a username at least four characters long.": "\u5C11\u306A\u304F\u3068\u30824\u6587\u5B57\u4EE5\u4E0A\u306E\u30E6\u30FC\u30B6\u30FC\u540D\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002", "Enter at least 3 characters for your search.": "\u691C\u7D22\u306B\u306F3\u6587\u5B57\u4EE5\u4E0A\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002", "Error": "\u30A8\u30E9\u30FC", "Estimate": "\u898B\u7A4D\u3082\u308A", "Estimate Invoice": "\u8ACB\u6C42\u66F8\u898B\u7A4D\u3082\u308A", "Estimate Total": "\u5408\u8A08\u898B\u7A4D\u3082\u308A", "Estimate/Invoice": "\u898B\u7A4D\u3082\u308A/\u8ACB\u6C42\u66F8", "Estimates": "\u898B\u7A4D\u308A", "Expand All": "\u3059\u3079\u3066\u5C55\u958B", "Expand Note": "Expand\u30CE\u30FC\u30C8", "Expand Sidebar": "\u30B5\u30A4\u30C9\u30D0\u30FC\u3092\u958B\u304F", "Expired": "\u671F\u9650\u5207\u308C", "FMI": "FMI", "Follow Up Time": "\u30D5\u30A9\u30ED\u30FC\u30A2\u30C3\u30D7\u30BF\u30A4\u30E0", "Follow-Up": "\u30D5\u30A1\u30ED\u30FC\u30A2\u30C3\u30D7", "Fri": "\u91D1", "Fully Covered": "\u5B8C\u5168\u306B\u30AB\u30D0\u30FC\u3055\u308C\u305F", "High Severity": "\u91CD\u5927\u5EA6\u304C\u9AD8\u3044", "Hours": "\u6642\u9593", "Invoice": "\u8ACB\u6C42\u66F8", "Invoice Date": "\u8ACB\u6C42\u66F8\u306E\u65E5\u4ED8", "Invoice Id": "\u8ACB\u6C42\u66F8ID", "It looks like you\u2019re lost\u2026": "\u3042\u306A\u305F\u304C\u5931\u308F\u308C\u305F\u3088\u3046\u306B\u898B\u3048\u308B...", "Item": "\u9805\u76EE", "Jump To...": "\u30B8\u30E3\u30F3\u30D7\u5148...", "Less than a Minute": "Less than a Minute", "Less than an Hour": "Less than an Hour", "List": "\u30EA\u30B9\u30C8", "Load More": "\u3082\u3063\u3068\u8AAD\u307F\u8FBC\u3080", "Loading...": "\u8AAD\u307F\u8FBC\u3093\u3067\u3044\u307E\u3059...", "Location": "\u30ED\u30B1\u30FC\u30B7\u30E7\u30F3", "Log Out": "\u30ED\u30B0\u30A2\u30A6\u30C8", "Log in": "\u30ED\u30B0\u30A4\u30F3", "Logging out...": "\u30ED\u30B0\u30A2\u30A6\u30C8...", "Mack": "\u30DE\u30C3\u30AF", "Maintenance": "\u30E1\u30F3\u30C6\u30CA\u30F3\u30B9", "Maintenance Current": "\u30E1\u30F3\u30C6\u30CA\u30F3\u30B9\u96FB\u6D41", "Maintenance Due": "\u30E1\u30F3\u30C6\u30CA\u30F3\u30B9\u671F\u9650", "Maintenance Overdue": "\u30E1\u30F3\u30C6\u30CA\u30F3\u30B9\u30AA\u30FC\u30D0\u30FC\u30D8\u30C3\u30C9", "Make": "\u30E1\u30A4\u30AF", "Map": "\u5730\u56F3", "Mark as Read": "\u65E2\u8AAD\u306B\u3059\u308B", "Mark as Unread": "\u672A\u8AAD\u3068\u3057\u3066\u30DE\u30FC\u30AF", "Matches: {count}": function MatchesCount(a) {
      return ["\u4E00\u81F4\uFF1A", a("count")];
    }, "Measure": "\u6E2C\u5B9A", "Medium Severity": "\u4E2D\u6DF1\u523B\u5EA6", "Model": "\u30E2\u30C7\u30EB", "Mon": "\u6708", "More than a Day": "More than a Day", "More than a Month": "More than a Month", "More than a Week": "More than a Week", "More than a Year": "More than a Year", "More than an Hour": "More than an Hour", "New Note": "\u65B0\u3057\u3044\u30CE\u30FC\u30C8", "Newest to Oldest": "\u6700\u65B0\u304B\u3089\u6700\u53E4", "No Coverage": "\u30AB\u30D0\u30EC\u30C3\u30B8\u306A\u3057", "No Open Cases": "\u30AA\u30FC\u30D7\u30F3\u30B1\u30FC\u30B9\u306A\u3057", "No complaints yet": "\u307E\u3060\u82E6\u60C5\u306F\u3042\u308A\u307E\u305B\u3093", "No matches for": "\u4E00\u81F4\u3059\u308B\u3082\u306E\u306F\u3042\u308A\u307E\u305B\u3093", "No matches for \"": "\"", "No notes yet.": "\u30E1\u30E2\u306F\u307E\u3060\u3042\u308A\u307E\u305B\u3093\u3002", "No results for \"": "\"", "Not Provided": "\u63D0\u4F9B\u3055\u308C\u3066\u3044\u306A\u3044", "Not available. Please check again later.": "\u5229\u7528\u4E0D\u53EF\u3002\u5F8C\u3067\u3082\u3046\u4E00\u5EA6\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002", "Notes": "\u30CE\u30FC\u30C8", "Notes {count}": function NotesCount(a) {
      return ["\u6CE8", a("count")];
    }, "OPTIONS:": "\u30AA\u30D7\u30B7\u30E7\u30F3\uFF1A", "Odometer": "\u30AA\u30C9\u30E1\u30FC\u30BF\u30FC", "Oldest to Newest": "\u6700\u53E4\u306E\u3082\u306E\u304B\u3089\u6700\u65B0\u306E\u3082\u306E", "Open": "\u958B\u3044\u305F", "Open Events": "\u30AA\u30FC\u30D7\u30F3\u30A4\u30D9\u30F3\u30C8", "Open Service Requests": "\u30AA\u30FC\u30D7\u30F3\u306A\u30B5\u30FC\u30D3\u30B9\u30EA\u30AF\u30A8\u30B9\u30C8", "Optional": "\u30AA\u30D7\u30B7\u30E7\u30F3", "Options": "\u30AA\u30D7\u30B7\u30E7\u30F3", "Other": "\u305D\u306E\u4ED6", "Over a Month": "Over a Month", "Over a Week": "Over a Week", "Over a Year": "Over a Year", "Over {years} Years": function OverYearsYears(a) {
      return ["Over ", a("years"), " Years"];
    }, "Overdue": "\u5EF6\u6EDE", "PDF Link": "PDF Link", "Partially Covered": "\u90E8\u5206\u7684\u306B\u8986\u308F\u308C\u305F", "Passphrase": "\u30D1\u30B9\u30D5\u30EC\u30FC\u30BA", "Past Due ETR": "\u904E\u53BB\u306EETR", "Past Due Follow Up": "\u904E\u53BB\u306E\u30D5\u30A9\u30ED\u30FC\u30A2\u30C3\u30D7", "Phone": "\u96FB\u8A71", "Please try again.": "\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002", "Post": "\u5F79\u8077", "Press ESC to cancel or ENTER to submit": "\u30AD\u30E3\u30F3\u30BB\u30EB\u3059\u308B\u306B\u306FESC\u3092\u62BC\u3057, \u9001\u4FE1\u3059\u308B\u306B\u306FENTER\u3092\u62BC\u3057\u3066\u304F\u3060\u3055\u3044\u3002", "Print Page": "\u30DA\u30FC\u30B8\u3092\u5370\u5237\u3059\u308B", "Privacy Policy": "\u500B\u4EBA\u60C5\u5831\u4FDD\u8B77\u65B9\u91DD", "Provide a Note about your decision": "\u3042\u306A\u305F\u306E\u6C7A\u5B9A\u306B\u3064\u3044\u3066\u306E\u6CE8\u610F\u3092\u63D0\u4F9B\u3059\u308B", "Purchase Order": "\u6CE8\u6587\u66F8", "QR Code": "QR\u30B3\u30FC\u30C9", "Reason For Repair": "\u4FEE\u7406\u306E\u7406\u7531", "Reason for Repair": "\u4FEE\u7406\u306E\u7406\u7531", "Redirecting...": "\u30EA\u30C0\u30A4\u30EC\u30AF\u30C8\u4E2D...", "Related Faults ({count})": function RelatedFaultsCount(a) {
      return ["\u95A2\u9023\u3059\u308B\u30D5\u30A9\u30EB\u30C8\uFF08", a("count"), "\uFF09"];
    }, "Repair Order": "\u4FEE\u7406\u547D\u4EE4", "Repair Status": "\u4FEE\u7406\u72B6\u6CC1", "Reply": "\u5FDC\u7B54", "Reports": "\u30EC\u30DD\u30FC\u30C8", "Request Service": "\u30EA\u30AF\u30A8\u30B9\u30C8\u30B5\u30FC\u30D3\u30B9", "Request Type": "\u30EA\u30AF\u30A8\u30B9\u30C8\u306E\u7A2E\u985E", "Request {number}": function RequestNumber(a) {
      return ["\u8981\u6C42", a("number")];
    }, "Requested": "\u8981\u6C42\u3055\u308C\u305F", "Return to the classic look": "\u53E4\u5178\u7684\u306A\u5916\u89B3\u306B\u623B\u308B", "Review": "\u30EC\u30D3\u30E5\u30FC", "SORT:": "\u30BD\u30FC\u30C8\uFF1A", "SUBMIT": "\u63D0\u51FA", "Sat": "\u571F", "Search Results": "\u306E\u691C\u7D22\u7D50\u679C", "Search Results: {searchValue}": function SearchResultsSearchValue(a) {
      return ["\u691C\u7D22\u7D50\u679C\uFF1A", a("searchValue")];
    }, "Search by asset location to see nearby providers or service provider for nearby locations.": "\u30A2\u30BB\u30C3\u30C8\u306E\u5834\u6240\u3067\u691C\u7D22\u3057, \u8FD1\u96A3\u306E\u5834\u6240\u306E\u8FD1\u304F\u306E\u30D7\u30ED\u30D0\u30A4\u30C0\u307E\u305F\u306F\u30B5\u30FC\u30D3\u30B9\u30D7\u30ED\u30D0\u30A4\u30C0\u3092\u8868\u793A\u3057\u307E\u3059\u3002", "Select": "\u9078\u629E", "Select Item...": "\u30A2\u30A4\u30C6\u30E0\u3092\u9078\u629E...", "Selected": "\u9078\u629E\u3055\u308C\u305F", "Serial": "\u30B7\u30EA\u30A2\u30EB", "Serial No.": "\u30B7\u30EA\u30A2\u30EB\u756A\u53F7\u3002", "Service Provider": "\u30B5\u30FC\u30D3\u30B9\u30D7\u30ED\u30D0\u30A4\u30C0", "Service Request": "\u30B5\u30FC\u30D3\u30B9\u8981\u6C42", "Service Request Wizard": "\u30B5\u30FC\u30D3\u30B9\u30EA\u30AF\u30A8\u30B9\u30C8\u30A6\u30A3\u30B6\u30FC\u30C9", "Service Requests": "\u30B5\u30FC\u30D3\u30B9\u30EA\u30AF\u30A8\u30B9\u30C8", "Service Requests: {count}": function ServiceRequestsCount(a) {
      return ["\u30B5\u30FC\u30D3\u30B9\u30EA\u30AF\u30A8\u30B9\u30C8\uFF1A", a("count")];
    }, "Severity": "\u91CD\u5927\u5EA6", "Some Current": "\u3044\u304F\u3064\u304B\u306E\u96FB\u6D41", "Something's not right.": "\u4F55\u304B\u304C\u304A\u304B\u3057\u3044\u3002", "Sorry, we don't recognize that passphrase.": "\u7533\u3057\u8A33\u3042\u308A\u307E\u305B\u3093\u304C, \u30D1\u30B9\u30D5\u30EC\u30FC\u30BA\u3092\u8A8D\u8B58\u3067\u304D\u307E\u305B\u3093\u3002", "Sorry, we had a connection issue while loading recipients. Please try again.": "\u7533\u3057\u8A33\u3042\u308A\u307E\u305B\u3093\u304C, \u53D7\u4FE1\u8005\u306E\u8AAD\u307F\u8FBC\u307F\u4E2D\u306B\u63A5\u7D9A\u306E\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002", "Status": "\u72B6\u614B", "Step {step} of {total}": function StepStepOfTotal(a) {
      return [a("\u5408\u8A08"), "\u306E\u30B9\u30C6\u30C3\u30D7", a("\u30B9\u30C6\u30C3\u30D7")];
    }, "Submit Request": "\u30EA\u30AF\u30A8\u30B9\u30C8\u3092\u9001\u4FE1\u3059\u308B", "Sun": "\u592A\u967D", "Terms and Conditions": "\u898F\u7D04\u3068\u6761\u4EF6", "Terms of Use": "\u5229\u7528\u898F\u7D04", "The Asset Detail Page": "\u30A2\u30BB\u30C3\u30C8\u8A73\u7D30\u30DA\u30FC\u30B8", "The Asset Detail page of the application": "\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u306E\u8CC7\u7523\u8A73\u7D30\u30DA\u30FC\u30B8", "The Assets Page": "\u30A2\u30BB\u30C3\u30C8\u30DA\u30FC\u30B8", "The Case Page": "\u30B1\u30FC\u30B9\u30DA\u30FC\u30B8", "The Cases Page": "\u30B1\u30FC\u30B9\u30DA\u30FC\u30B8", "The Search Results Page": "\u691C\u7D22\u7D50\u679C\u30DA\u30FC\u30B8", "The Service Request Detail Page": "\u30B5\u30FC\u30D3\u30B9\u30EA\u30AF\u30A8\u30B9\u30C8\u306E\u8A73\u7D30\u30DA\u30FC\u30B8", "The Service Request Detail page of the application": "\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u306E[Service Request Detail]\u30DA\u30FC\u30B8", "The assets page of the application": "\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u306E\u30A2\u30BB\u30C3\u30C8\u30DA\u30FC\u30B8", "The case page of the application": "\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u306E\u30B1\u30FC\u30B9\u30DA\u30FC\u30B8", "The cases page of the application": "\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u306E\u30B1\u30FC\u30B9\u30DA\u30FC\u30B8", "The search results page of the application": "\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u306E\u691C\u7D22\u7D50\u679C\u30DA\u30FC\u30B8", "There is an error in your input. Please try again.": "\u3042\u306A\u305F\u306E\u5165\u529B\u306B\u8AA4\u308A\u304C\u3042\u308A\u307E\u3059\u3002\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002", "This page either does not exist or you need permission to view it.": "\u3053\u306E\u30DA\u30FC\u30B8\u306F\u5B58\u5728\u3057\u306A\u3044\u304B, \u8868\u793A\u3059\u308B\u6A29\u9650\u304C\u5FC5\u8981\u3067\u3059\u3002", "Thu": "\u6728", "To:": "\u306B\uFF1A", "Try broadening your search criteria.": "\u691C\u7D22\u6761\u4EF6\u3092\u5E83\u3052\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002", "Try removing or editing some of the filters to expand your search, or search by a different location.": "\u30D5\u30A3\u30EB\u30BF\u3092\u524A\u9664\u307E\u305F\u306F\u7DE8\u96C6\u3057\u3066\u691C\u7D22\u3092\u62E1\u5927\u3059\u308B\u304B, \u5225\u306E\u5834\u6240\u3067\u691C\u7D22\u3057\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002", "Try removing or editing some of your criteria to expand the search or review another favorite.": "\u6761\u4EF6\u3092\u524A\u9664\u307E\u305F\u306F\u7DE8\u96C6\u3057\u3066\u691C\u7D22\u6761\u4EF6\u3092\u62E1\u5927\u3057\u305F\u308A, \u5225\u306E\u304A\u6C17\u306B\u5165\u308A\u3092\u78BA\u8A8D\u3057\u305F\u308A\u3057\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002", "Try removing or editing some of your criteria to expand the search or search by city and state or zip code.": "\u90FD\u5E02\u3084\u5DDE\u3084\u90F5\u4FBF\u756A\u53F7\u3067\u691C\u7D22\u3084\u691C\u7D22\u3092\u62E1\u5927\u3059\u308B\u305F\u3081\u306B, \u6761\u4EF6\u306E\u4E00\u90E8\u3092\u524A\u9664\u307E\u305F\u306F\u7DE8\u96C6\u3057\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002", "Try using the search bar or contacting the person who gave you the link.": "\u691C\u7D22\u30D0\u30FC\u3092\u4F7F\u7528\u3059\u308B\u304B, \u30EA\u30F3\u30AF\u3092\u4E0E\u3048\u305F\u4EBA\u306B\u9023\u7D61\u3057\u3066\u304F\u3060\u3055\u3044\u3002", "Tue": "\u706B", "UNIT": "\u5358\u4F4D", "Unit": "\u5358\u4F4D", "Unit #{unitNumber}": function UnitUnitNumber(a) {
      return ["\u30E6\u30CB\u30C3\u30C8\u756A\u53F7", a("unitNumber")];
    }, "Unit Number": "\u30E6\u30CB\u30C3\u30C8\u756A\u53F7", "Unit {number}": function UnitNumber(a) {
      return ["\u5358\u4F4D", a("number")];
    }, "Unit {unitNumber}": function UnitUnitNumber(a) {
      return ["\u5358\u4F4D", a("unitNumber")];
    }, "Unread Notes": "Unread Notes", "Uptime Cases": "\u7A3C\u50CD\u6642\u9593\u306E\u30B1\u30FC\u30B9", "VIN": "VIN", "Validating...": "\u691C\u8A3C\u4E2D...", "Value": "\u5024", "View As": "\u5225\u540D\u3067\u8868\u793A", "View Estimate": "\u898B\u7A4D\u3082\u308A\u3092\u898B\u308B", "View In Full-Screen Mode": "\u30D5\u30EB\u30B9\u30AF\u30EA\u30FC\u30F3\u30E2\u30FC\u30C9\u3067\u8868\u793A", "View Latest Estimate": "\u6700\u65B0\u306E\u898B\u7A4D\u3082\u308A\u3092\u8868\u793A", "View Repair Instructions": "\u4FEE\u7406\u624B\u9806\u306E\u8868\u793A", "Volvo": "\u30DC\u30EB\u30DC", "Waiting Approval": "\u627F\u8A8D\u5F85\u3061", "Warranty": "\u4FDD\u8A3C", "We didn't find any possible recipients. Please contact our support services team.": "\u53EF\u80FD\u306A\u53D7\u4FE1\u8005\u306F\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u30B5\u30DD\u30FC\u30C8\u30B5\u30FC\u30D3\u30B9\u30C1\u30FC\u30E0\u306B\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002", "Wed": "\u7D50\u5A5A\u3057\u305F", "What type of Service?": "\u3069\u306E\u3088\u3046\u306A\u7A2E\u985E\u306E\u30B5\u30FC\u30D3\u30B9\u3067\u3059\u304B\uFF1F", "What's the complaint?": "\u82E6\u60C5\u306F\u4F55\u3067\u3059\u304B\uFF1F", "Which asset?": "\u3069\u3061\u3089\u306E\u8CC7\u7523\u3067\u3059\u304B\uFF1F", "Which service provider do you want?": "\u3069\u306E\u30B5\u30FC\u30D3\u30B9\u30D7\u30ED\u30D0\u30A4\u30C0\u304C\u5FC5\u8981\u3067\u3059\u304B\uFF1F", "Year": "\u5E74", "Yesterday": "Yesterday", "You can select a complaint code or enter a description. When possible, fill in both. That helps the service provider expedite your case.": "\u82E6\u60C5\u30B3\u30FC\u30C9\u3092\u9078\u629E\u3059\u308B\u304B, \u8AAC\u660E\u3092\u5165\u529B\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002\u53EF\u80FD\u3067\u3042\u308C\u3070, \u4E21\u65B9\u3092\u8A18\u5165\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u3053\u308C\u306F, \u30B5\u30FC\u30D3\u30B9\u30D7\u30ED\u30D0\u30A4\u30C0\u304C\u3042\u306A\u305F\u306E\u30B1\u30FC\u30B9\u3092\u8FC5\u901F\u5316\u3059\u308B\u306E\u306B\u5F79\u7ACB\u3061\u307E\u3059\u3002", "You may want to disable it before entering your password.": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B\u3059\u308B\u524D\u306B\u7121\u52B9\u306B\u3057\u305F\u3044\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002", "You reached the max character count.": "\u6700\u5927\u6587\u5B57\u6570\u306B\u9054\u3057\u307E\u3057\u305F\u3002", "You reached the max of 15 recipients. Remove some recipients to enable the Post button.": "You reached the max of 15 recipients. Remove some recipients to enable the Post button.", "Your passphrase is too short.": "\u30D1\u30B9\u30D5\u30EC\u30FC\u30BA\u304C\u77ED\u3059\u304E\u307E\u3059\u3002", "Your submission has failed.": "\u3042\u306A\u305F\u306E\u6295\u7A3F\u306F\u5931\u6557\u3057\u307E\u3057\u305F\u3002", "Your username is too short.": "\u30E6\u30FC\u30B6\u30FC\u540D\u304C\u77ED\u3059\u304E\u307E\u3059\u3002", "campaign due": "\u30AD\u30E3\u30F3\u30DA\u30FC\u30F3\u671F\u9650", "current": "\u73FE\u5728", "due": "\u652F\u6255\u3046", "expired": "\u5931\u52B9\u3057\u305F", "fully covered": "\u5B8C\u5168\u306B\u8986\u308F\u308C\u305F", "in": "\u306B", "no coverage": "\u30AB\u30D0\u30EC\u30C3\u30B8\u306A\u3057", "overdue": "\u5EF6\u6EDE", "partially covered": "\u4E00\u90E8\u8986\u308F\u308C\u305F", "{app} version {version}": function appVersionVersion(a) {
      return [a("\u30A2\u30D7\u30EA"), "\u30D0\u30FC\u30B8\u30E7\u30F3", a("\u30D0\u30FC\u30B8\u30E7\u30F3")];
    }, "{app} version {version} (GIT SHA {gitVersion})": function appVersionVersionGITSHAGitVersion(a) {
      return [a("app"), "\u30D0\u30FC\u30B8\u30E7\u30F3", a("version"), "\uFF08GIT SHA ", a("gitVersion"), "\uFF09"];
    }, "{count, plural, one {# Open Case} other {# Open Cases}}": function countPluralOneOpenCaseOtherOpenCases(a) {
      return [a("count", "plural", "one {\u30AA\u30FC\u30D7\u30F3\u30B1\u30FC\u30B9"), " other ", a("\u30AA\u30FC\u30D7\u30F3\u30B1\u30FC\u30B9")];
    }, "{count} Unread": function countUnread(a) {
      return [a("count"), "\u672A\u8AAD"];
    }, "{count} Unread {count, plural, one {Note} other {Notes}}": function countUnreadCountPluralOneNoteOtherNotes(a) {
      return [a("count"), "\u672A\u8AAD", a("count", "plural", { one: "\u6CE8\u610F", other: "\u30CE\u30FC\u30C8" })];
    }, "{date}": function date(a) {
      return [a("\u65E5\u4ED8")];
    }, "{days} Days": function daysDays(a) {
      return [a("days"), " Days"];
    }, "{days} Days Ago": function daysDaysAgo(a) {
      return [a("days"), " Days Ago"];
    }, "{hours} Hours": function hoursHours(a) {
      return [a("hours"), " Hours"];
    }, "{hours} Hours Ago": function hoursHoursAgo(a) {
      return [a("hours"), " Hours Ago"];
    }, "{minutes} Minutes Ago": function minutesMinutesAgo(a) {
      return [a("minutes"), " Minutes Ago"];
    }, "{months} Months": function monthsMonths(a) {
      return [a("months"), " Months"];
    }, "{months} Months Ago": function monthsMonthsAgo(a) {
      return [a("months"), " Months Ago"];
    }, "{serviceRequestId}": function serviceRequestId(a) {
      return [a("serviceRequestId")];
    }, "{value} {value, plural, one {Character} other {Characters}} left": function valueValuePluralOneCharacterOtherCharactersLeft(a) {
      return [a("value"), " ", a("value", "plural", { one: "\u30AD\u30E3\u30E9\u30AF\u30BF\u30FC", other: "\u30AD\u30E3\u30E9\u30AF\u30BF\u30FC" })];
    }, "{weeks} Weeks": function weeksWeeks(a) {
      return [a("weeks"), " Weeks"];
    }, "{weeks} Weeks Ago": function weeksWeeksAgo(a) {
      return [a("weeks"), " Weeks Ago"];
    }, "{years} Years": function yearsYears(a) {
      return [a("years"), " Years"];
    }, "{years} Years Ago": function yearsYearsAgo(a) {
      return [a("years"), " Years Ago"];
    } } };

/***/ }),

/***/ "./locale/nl/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = { l: { "p": function p(n, ord) {
      var s = String(n).split("."),
          v0 = !s[1];if (ord) return "other";return n == 1 && v0 ? "one" : "other";
    } }, m: { "\".": "\".", "#{caseId}": function caseId(a) {
      return ["#", a("caseId")];
    }, "({count}) Older {count, plural, one {Comment} other {Comments}}": function countOlderCountPluralOneCommentOtherComments(a) {
      return ["(", a("count"), ") Ouder ", a("count", "plural", { one: "Opmerking", other: "Opmerkingen" })];
    }, "... {count} more": function countMore(a) {
      return ["... ", a("count"), " meer"];
    }, "...Loading": "...Bezig met laden", "1 Hour": "1 uur", "A Minute Ago": "Een minuut geleden", "A Month Ago": "Een maand geleden", "A Week Ago": "Een week geleden", "A Year Ago": "Een jaar geleden", "Accept": "Aanvaarden", "Add Note": "Voeg opmerking toe", "Additional Warnings": "Aanvullende waarschuwingen", "Address": "Adres", "Administration": "Administratie", "All Assets": "Alle activa", "All Current": "Alle huidige", "All Repair Cases": "Alle reparaties", "Amount": "Bedrag", "An Hour Ago": "Een uur geleden", "Approvals": "Goedkeuringen", "Approve": "Goedkeuren", "Asset": "Activa", "Asset Location": "Activa locatie", "Asset Summary": "Activa overzicht", "Assets": "Activa", "Assets ({count})": function AssetsCount(a) {
      return ["Activa (", a("count"), ")"];
    }, "Assets: {count}": function AssetsCount(a) {
      return ["Activa: ", a("count")];
    }, "Back to Top": "Terug naar boven", "Breakdown": "Onderverdeling", "By signing in you agree to all applicable ": "Door in te loggen gaat u accord met alles wat van toepassing", "Campaign Due": "Campagne vervaldatum", "Campaigns": "campagnes", "Cancel": "Annuleer", "Cancel Request": "Annuleer verzoek", "Caps Lock is Enabled": "Caps Lock is ingeschakeld", "Cards": "Kaarten", "Case": "Zaak", "Case Status": "Zaak status", "Case {caseId}": function CaseCaseId(a) {
      return ["Zaak ", a("caseId")];
    }, "Case {number}": function CaseNumber(a) {
      return ["Zaak ", a("number")];
    }, "Cases": "Zaken", "Cases ({count})": function CasesCount(a) {
      return ["Zaken (", a("count"), ")"];
    }, "Cases: {count}": function CasesCount(a) {
      return ["Zaken: ", a("count")];
    }, "Closed": "Gesloten", "Code - Description": "Code - Beschrijving", "Code Not Provided": "Code niet aangegeven", "Collapse All": "Alles inklappen", "Collapse Note": "Inklap opmerking", "Collapse Sidebar": "Inklap zijbalk", "Comments": "Opmerkingen", "Complaint": "Klacht", "Complaint Code": "Klachtencode", "Component Id": "Component-ID", "Continue": "Doorgaan", "Copyright \xA9 {year} Decisiv, Inc.": function CopyrightYearDecisivInc(a) {
      return ["Copyright \xA9 ", a("year"), " Decisiv, Inc."];
    }, "Count": "Aantal", "Create New Service Request": "Maak een nieuw serviceverzoek aan", "Create Service Request": "Servic verzoek aanmaken", "Created": "Gemaakt", "Current": "Huidig", "Date/Time": "Datum/Tijd", "Decisiv": "Decisiv", "Decline": "Weigeren", "Description": "Beschrijving", "Description Not Provided": "Beschrijving niet gegeven", "Diagnostics": "Diagnostics", "Diagnostics Details": "Diagnostische gegevens", "Distance to Service Location": "Afstand tot servicelocatie", "Downtime": "uitvaltijd", "Downtime > 2 Days": "Uitvaltijd> 2 dagen", "Due": "Vervaldatum", "ECU": "ECU", "ETR": "ETR", "Edit": "Bewerken", "Email Address or Username": "E-mailadres of gebruikersnaam", "Engine": "Motor", "Enter a city and state or zip code...": "Voer een stad en staat of postcode in ...", "Enter a passphrase at least four characters long.": "Voer een wachtwoordzin in van ten minste vier tekens lang.", "Enter a username at least four characters long.": "Voer een gebruikersnaam in van minimaal vier tekens lang.", "Enter at least 3 characters for your search.": "Voer minimaal 3 tekens in voor je zoekopdracht.", "Error": "Fout", "Estimate": "Offerte", "Estimate Invoice": "Offerte rekening", "Estimate Total": "Totale Offerte", "Estimate/Invoice": "Offerte/Rekening", "Estimates": "schattingen", "Expand All": "Alles uitklappen", "Expand Note": "Uitklap notitie", "Expand Sidebar": "klap zijbalk uit", "Expired": "Verlopen", "FMI": "FMI", "Follow Up Time": "Follow-up tijd", "Follow-Up": "Follow-up", "Fri": "vr", "Fully Covered": "Volledig gedekt", "High Severity": "Hoge eisen", "Hours": "uren", "Invoice": "Factuur", "Invoice Date": "Factuur datum", "Invoice Id": "Factuur-ID", "It looks like you\u2019re lost\u2026": "Het lijkt erop dat je verdwaald bent ...", "Item": "Item", "Jump To...": "Ga naar...", "Less than a Minute": "Minder dan een minuut", "Less than an Hour": "Minder dan een uur", "List": "Lijst", "Load More": "Meer laden", "Loading...": "Bezig met laden...", "Location": "Plaats", "Log Out": "Uitloggen", "Log in": "Inloggen", "Logging out...": "Uitloggen...", "Mack": "Mack", "Maintenance": "Onderhoud", "Maintenance Current": "Onderhoudsstroom", "Maintenance Due": "Onderhouds datum", "Maintenance Overdue": "Achterstallig onderhoud", "Make": "Maken", "Map": "Kaart", "Mark as Read": "Markeer als gelezen", "Mark as Unread": "Markeren als ongelezen", "Matches: {count}": function MatchesCount(a) {
      return ["Overeenkomsten: ", a("count")];
    }, "Measure": "Maten", "Medium Severity": "Matige eisen", "Model": "Model", "Mon": "ma", "More than a Day": "Meer dan een dag", "More than a Month": "Meer dan een maand", "More than a Week": "Meer dan een week", "More than a Year": "Meer dan een jaar", "More than an Hour": "Meer dan een uur", "New Note": "Nieuwe notitie", "Newest to Oldest": "Nieuwste tot oudste", "No Coverage": "Geen dekking", "No Open Cases": "Geen open zaken", "No complaints yet": "Nog geen klachten", "No matches for": "Geen overeenkomsten met", "No matches for \"": "Geen overeenkomsten met \"", "No notes yet.": "Nog geen notities.", "No results for \"": "Geen resultaten voor", "Not Provided": "Niet verstrekt", "Not available. Please check again later.": "Niet beschikbaar. Controleer later opnieuw.", "Notes": "Notities", "Notes {count}": function NotesCount(a) {
      return ["Notities ", a("count")];
    }, "OPTIONS:": "OPTIES:", "Odometer": "Kilometerteller", "Oldest to Newest": "Oudste tot nieuwste", "Open": "Open", "Open Events": "Open evenementen", "Open Service Requests": "Open serviceaanvragen", "Optional": "Optioneel", "Options": "opties", "Other": "anders", "Over a Month": "Meer dan een maand", "Over a Week": "Meer dan een week", "Over a Year": "Meer dan een jaar", "Over {years} Years": function OverYearsYears(a) {
      return ["Meer dan ", a("years"), " jaar"];
    }, "Overdue": "Achterstallig", "PDF Link": "PDF-link", "Partially Covered": "Gedeeltelijk gedekt", "Passphrase": "Wachtwoordzin", "Past Due ETR": "Achterstallige ETR", "Past Due Follow Up": "Achterstallige Follow-Up", "Phone": "Telefoon", "Please try again.": "Probeer het opnieuw.", "Post": "Post", "Press ESC to cancel or ENTER to submit": "Druk op ESC om te annuleren of op ENTER om te verzenden", "Print Page": "Print pagina", "Privacy Policy": "Privacybeleid", "Provide a Note about your decision": "Geef een opmerking over uw beslissing", "Purchase Order": "Bestelling", "QR Code": "QR code", "Reason For Repair": "Reden voor reparatie", "Reason for Repair": "Reden voor reparatie", "Redirecting...": "Wordt omgeleid ...", "Related Faults ({count})": function RelatedFaultsCount(a) {
      return ["Gerelateerde fouten (", a("count"), ")"];
    }, "Repair Order": "Reparatiebestelling", "Repair Status": "Reparatiestatus", "Reply": "Antwoord", "Reports": "rapporten", "Request Service": "Verzoek om service", "Request Type": "Verzoek type", "Request {number}": function RequestNumber(a) {
      return ["Verzoek ", a("number")];
    }, "Requested": "Aangevraagd", "Return to the classic look": "Keer terug naar de klassieke look", "Review": "Beoordeling", "SORT:": "SOORT:", "SUBMIT": "Verzenden", "Sat": "za", "Search Results": "Zoekresultaten", "Search Results: {searchValue}": function SearchResultsSearchValue(a) {
      return ["Zoekresultaten: ", a("searchValue")];
    }, "Search by asset location to see nearby providers or service provider for nearby locations.": "Zoeken op activapositie om nabijgelegen providers of serviceproviders voor locaties in de buurt te zien.", "Select": "Selecteren", "Select Item...": "Selecteer item...", "Selected": "Geselecteerd", "Serial": "serie", "Serial No.": "Serienummer", "Service Provider": "Dienstverlener", "Service Request": "Service verzoek", "Service Request Wizard": "Serviceaanvraag Wizard", "Service Requests": "Serviceaanvragen", "Service Requests: {count}": function ServiceRequestsCount(a) {
      return ["Serviceaanvragen: ", a("count")];
    }, "Severity": "Strengheid", "Some Current": "Gedeeltelijk bijgewerkt", "Something's not right.": "Iets klopt er niet.", "Sorry, we don't recognize that passphrase.": "Sorry, we herkennen dat wachtwoord niet.", "Sorry, we had a connection issue while loading recipients. Please try again.": "Sorry, we hadden een probleem met de verbinding tijdens het laden van ontvangers. Probeer het opnieuw.", "Status": "Status", "Step {step} of {total}": function StepStepOfTotal(a) {
      return ["Stap ", a("step"), " van ", a("total")];
    }, "Submit Request": "Aanvraag indienen", "Sun": "zo", "Terms and Conditions": "Voorwaarden", "Terms of Use": "Gebruiksvoorwaarden", "The Asset Detail Page": "De pagina met activadetails", "The Asset Detail page of the application": "De Asset Detail-pagina van de aanvraag", "The Assets Page": "De vermogenspagina", "The Case Page": "De Zaak Pagina", "The Cases Page": "De Zaak Pagina", "The Search Results Page": "De pagina met zoekresultaten", "The Service Request Detail Page": "De Serviceaanvraag Detailpagina", "The Service Request Detail page of the application": "De Service Request Detail-pagina van de aangraag", "The assets page of the application": "De activa-pagina van de aanvraag", "The case page of the application": "De hoofdpagina van de aanvraag", "The cases page of the application": "De zaak-pagina van de aanvraag", "The search results page of the application": "De pagina met zoekresultaten van de aanvraag", "There is an error in your input. Please try again.": "Er is een fout opgetreden bij je invoer. Probeer het opnieuw.", "This page either does not exist or you need permission to view it.": "Deze pagina bestaat niet of je hebt toestemming nodig om deze te bekijken.", "Thu": "do", "To:": "Aan:", "Try broadening your search criteria.": "Probeer uw zoekcriteria te verbreden.", "Try removing or editing some of the filters to expand your search, or search by a different location.": "Probeer enkele filters te verwijderen of te bewerken om uw zoekopdracht uit te breiden of zoek op een andere locatie.", "Try removing or editing some of your criteria to expand the search or review another favorite.": "Probeer enkele van uw criteria te verwijderen of te bewerken om de zoekopdracht uit te breiden of een andere favoriet te beoordelen.", "Try removing or editing some of your criteria to expand the search or search by city and state or zip code.": "Probeer een aantal van uw criteria te verwijderen of te bewerken om de zoekopdracht uit te breiden of zoek op stad en staat of postcode.", "Try using the search bar or contacting the person who gave you the link.": "Probeer de zoekbalk te gebruiken of neem contact op met de persoon die u de link heeft gegeven.", "Tue": "di", "UNIT": "EENHEID", "Unit": "Eenheid", "Unit #{unitNumber}": function UnitUnitNumber(a) {
      return ["Eenheid #", a("unitNumber")];
    }, "Unit Number": "Eenheid nummer", "Unit {number}": function UnitNumber(a) {
      return ["Eenheid ", a("number")];
    }, "Unit {unitNumber}": function UnitUnitNumber(a) {
      return ["Eenheid ", a("unitNumber")];
    }, "Unread Notes": "Ongelezen opmerkingen", "Uptime Cases": "Uptime-cases", "VIN": "VIN", "Validating...": "Valideren ...", "Value": "Waarde", "View As": "Zien als", "View Estimate": "Bekijk offerte", "View In Full-Screen Mode": "Bekijken in de modus Volledig scherm", "View Latest Estimate": "bekijk laatste offerte", "View Repair Instructions": "Bekijk reparatie-instructies", "Volvo": "Volvo", "Waiting Approval": "Wachten op goedkeuring", "Warranty": "Garantie", "We didn't find any possible recipients. Please contact our support services team.": "We hebben geen mogelijke ontvangers gevonden. Neem contact op met ons ondersteuningsteam.", "Wed": "wo", "What type of Service?": "Welk type service?", "What's the complaint?": "Wat is de klacht?", "Which asset?": "Welke activa?", "Which service provider do you want?": "Welke serviceprovider wilt u?", "Year": "Jaar", "Yesterday": "Gisteren", "You can select a complaint code or enter a description. When possible, fill in both. That helps the service provider expedite your case.": "U kunt een klachtencode selecteren of een beschrijving invoeren. Vul indien mogelijk beide in. Dat helpt de serviceprovider uw zaak te versnellen.", "You may want to disable it before entering your password.": "Mogelijk wilt u dit uitschakelen voordat u uw wachtwoord invoert.", "You reached the max character count.": "Je hebt het maximale aantal tekens bereikt.", "You reached the max of 15 recipients. Remove some recipients to enable the Post button.": "U bereikte het maximum van 15 ontvangers. Verwijder enkele ontvangers om de knop Posten in te schakelen.", "Your passphrase is too short.": "Je wachtwoordzin is te kort.", "Your submission has failed.": "Uw verzending is mislukt.", "Your username is too short.": "Uw gebruikersnaam is te kort.", "campaign due": "campagne verval datum", "current": "actueel", "due": "ten gevolge", "expired": "niet meer geldig", "fully covered": "volledige dekking", "in": "in", "no coverage": "geen dekking", "overdue": "achterstallig", "partially covered": "gedeeltelijk gedekt", "{app} version {version}": function appVersionVersion(a) {
      return [a("app"), " versie ", a("version")];
    }, "{app} version {version} (GIT SHA {gitVersion})": function appVersionVersionGITSHAGitVersion(a) {
      return [a("app"), " versie ", a("version"), " (GIT SHA ", a("gitVersion"), ")"];
    }, "{count, plural, one {# Open Case} other {# Open Cases}}": function countPluralOneOpenCaseOtherOpenCases(a) {
      return [a("count", "plural", { one: ["#", " Open Zaak"], other: ["#", " Open Zaaken"] })];
    }, "{count} Unread": function countUnread(a) {
      return [a("count"), " Ongelezen"];
    }, "{count} Unread {count, plural, one {Note} other {Notes}}": function countUnreadCountPluralOneNoteOtherNotes(a) {
      return [a("count"), " Ongelezen ", a("count", "plural", { one: "Notitie", other: "Opmerkingen" })];
    }, "{date}": function date(a) {
      return [a("date")];
    }, "{days} Days": function daysDays(a) {
      return [a("days"), " Dagen"];
    }, "{days} Days Ago": function daysDaysAgo(a) {
      return [a("days"), " Dagen geleden"];
    }, "{hours} Hours": function hoursHours(a) {
      return [a("hours"), " uren"];
    }, "{hours} Hours Ago": function hoursHoursAgo(a) {
      return [a("hours"), " uren geleden Ago"];
    }, "{minutes} Minutes Ago": function minutesMinutesAgo(a) {
      return [a("minutes"), " minuten geleden"];
    }, "{months} Months": function monthsMonths(a) {
      return [a("months"), " Maanden"];
    }, "{months} Months Ago": function monthsMonthsAgo(a) {
      return [a("months"), " Maanden geleden"];
    }, "{serviceRequestId}": function serviceRequestId(a) {
      return [a("serviceRequestId")];
    }, "{value} {value, plural, one {Character} other {Characters}} left": function valueValuePluralOneCharacterOtherCharactersLeft(a) {
      return [a("value"), " ", a("value", "plural", { one: "Teken", other: "Tekens" }), " over"];
    }, "{weeks} Weeks": function weeksWeeks(a) {
      return [a("weeks"), " Weken"];
    }, "{weeks} Weeks Ago": function weeksWeeksAgo(a) {
      return [a("weeks"), " Weken geleden"];
    }, "{years} Years": function yearsYears(a) {
      return [a("years"), " jaren"];
    }, "{years} Years Ago": function yearsYearsAgo(a) {
      return [a("years"), " jaren geleden"];
    } } };

/***/ }),

/***/ "./redux/app/actions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setSearchParams = exports.setSearchPagination = exports.setLoadingStarted = exports.setLatestFavorite = exports.setFavoritePagination = exports.setDashboardFavorites = exports.performSearch = exports.loadDashboard = exports.addPageToBreadcrumbs = undefined;

var _reduxActions = __webpack_require__("../node_modules/redux-actions/es/index.js");

var _reduxApiActions = __webpack_require__("./utils/redux-api-actions.js");

var _api = __webpack_require__("./redux/app/api.js");

var _constants = __webpack_require__("./redux/constants.js");

var addPageToBreadcrumbs = exports.addPageToBreadcrumbs = (0, _reduxActions.createAction)(_constants.ADD_PAGE_TO_BREADCRUMBS);

var loadDashboard = exports.loadDashboard = (0, _reduxApiActions.createApiAction)([_constants.LOAD_DASHBOARD_REQUEST, _constants.LOAD_DASHBOARD_SUCCESS, _constants.LOAD_DASHBOARD_FAILURE], _api.getDashboard);

var performSearch = exports.performSearch = (0, _reduxActions.createAction)(_constants.PERFORM_SEARCH);

var setDashboardFavorites = exports.setDashboardFavorites = (0, _reduxActions.createAction)(_constants.SET_DASHBOARD_FAVORITES);

var setFavoritePagination = exports.setFavoritePagination = (0, _reduxActions.createAction)(_constants.SET_FAVORITE_PAGINATION);

var setLatestFavorite = exports.setLatestFavorite = (0, _reduxActions.createAction)(_constants.SET_LATEST_FAVORITE);

var setLoadingStarted = exports.setLoadingStarted = (0, _reduxActions.createAction)(_constants.SET_LOADING_STARTED);

var setSearchPagination = exports.setSearchPagination = (0, _reduxActions.createAction)(_constants.SET_SEARCH_PAGINATION);

var setSearchParams = exports.setSearchParams = (0, _reduxActions.createAction)(_constants.SET_SEARCH_PARAMS);

/***/ }),

/***/ "./redux/app/alphaFavorites.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__("../node_modules/immutable/dist/immutable.js");

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _qs = __webpack_require__("../node_modules/qs/lib/index.js");

var _speakingurl = __webpack_require__("../node_modules/speakingurl/index.js");

var _speakingurl2 = _interopRequireDefault(_speakingurl);

var _messages = __webpack_require__("./redux/app/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scopeFromUrl(url) {
  var scope = '';
  if (url) {
    var paramString = url.split('?').pop();
    var params = (0, _qs.parse)(paramString);
    scope = params.scope;
  }
  return scope;
}

var mapDashboardFilterToFavorite = (0, _lodash.curry)(function (pathName, _ref) {
  var name = _ref.name,
      url = _ref.url,
      total = _ref.total;

  var title = (0, _lodash.camelCase)(name);
  var slug = (0, _speakingurl2.default)(name);
  var scope = scopeFromUrl(url);
  var params = scope ? { scope: scope } : null;
  return {
    title: title,
    params: params,
    slug: slug,
    count: total,
    // To prevent the app from failing catastrophically in the event of an untranslated favorite,
    // define a default message based on the the params received.
    message: _messages2.default[title] || '' + (0, _lodash.startCase)((0, _lodash.toLower)(name)),
    path: '/' + pathName + '/filter/' + slug
  };
});

/**
 * The Dashboard API response includes all case-related favorites in a single collection.
 * In this application we want to separate approvals and service requests into their own
 * categories.  This function is used to extract those filters.  It returns "approvals",
 * "serviceRequests", or "cases" for any given filter name based on which category the
 * filter should appear under.  `null` is returned for favorites which should be ignored
 * and not rendered into any category.
 */
function caseFavoriteSection(_ref2) {
  var name = _ref2.name;

  // exclude 'Waiting Approval' and 'Open Service Requests' from the Cases
  // favorite section since they are shown under their own left-nav headings
  switch (name) {
    case 'WAITING APPROVAL':
      return 'approvals';
    case 'OPEN SERVICE REQUEST':
      return 'serviceRequests';
    case 'CURRENT':
      return null;
    default:
      return 'cases';
  }
}

function buildCaseFavorites() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref3$total = _ref3.total,
      total = _ref3$total === undefined ? 0 : _ref3$total,
      filters = _ref3.filters;

  var allCasesFilter = { name: 'All Repair Cases', total: total, url: '' };
  var caseFilters = filters ? filters.filter(function (entry) {
    return caseFavoriteSection(entry) === 'cases';
  }) : [];
  var allFilters = (0, _lodash.concat)([allCasesFilter], caseFilters);
  return allFilters.map(mapDashboardFilterToFavorite('cases'));
}

function buildApprovalsFavorites() {
  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      filters = _ref4.filters;

  var approvalFilters = filters ? filters.filter(function (entry) {
    return caseFavoriteSection(entry) === 'approvals';
  }) : [];
  return approvalFilters.map(mapDashboardFilterToFavorite('approvals'));
}

function buildServiceRequestFavorites() {
  var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      filters = _ref5.filters;

  var serviceRequestFilters = filters ? filters.filter(function (entry) {
    return caseFavoriteSection(entry) === 'serviceRequests';
  }) : [];
  return serviceRequestFilters.map(mapDashboardFilterToFavorite('service-requests'));
}

function buildAssetFavorites() {
  var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref6$total = _ref6.total,
      total = _ref6$total === undefined ? 0 : _ref6$total,
      _ref6$filters = _ref6.filters,
      filters = _ref6$filters === undefined ? [] : _ref6$filters;

  var allAssetsFilter = { name: 'All Assets', total: total, url: '' };
  var allFilters = (0, _lodash.concat)([allAssetsFilter], filters);
  return allFilters.map(mapDashboardFilterToFavorite('assets'));
}

function processDashboard(dashboardResponse) {
  var body = dashboardResponse.body;
  var caseDashboardInfo = body.find(function (entry) {
    return entry.category === 'cases';
  });
  var assetDashboardInfo = body.find(function (entry) {
    return entry.category === 'assets';
  });

  return (0, _immutable.fromJS)({
    cases: buildCaseFavorites(caseDashboardInfo),
    approvals: buildApprovalsFavorites(caseDashboardInfo),
    serviceRequests: buildServiceRequestFavorites(caseDashboardInfo),
    assets: buildAssetFavorites(assetDashboardInfo)
    // reports: buildReportFavorites(),
  });
}

exports.default = processDashboard;

/***/ }),

/***/ "./redux/app/api.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDashboard = getDashboard;

var _apiEndpoints = __webpack_require__("./apiEndpoints.js");

var _apiEndpoints2 = _interopRequireDefault(_apiEndpoints);

var _fetch = __webpack_require__("./utils/fetch.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line import/prefer-default-export
function getDashboard() {
  return (0, _fetch.get)(_apiEndpoints2.default.dashboard());
}

/***/ }),

/***/ "./redux/app/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var messages = {
  allRepairCases: (0, _linguiReact.i18nMark)('All Repair Cases'),
  downtime2Days: (0, _linguiReact.i18nMark)('Downtime > 2 Days'),
  pastDueFollowUp: (0, _linguiReact.i18nMark)('Past Due Follow Up'),
  pastDueEtr: (0, _linguiReact.i18nMark)('Past Due ETR'),
  current: (0, _linguiReact.i18nMark)('Current'),
  uptimeCases: (0, _linguiReact.i18nMark)('Uptime Cases'),
  waitingApproval: (0, _linguiReact.i18nMark)('Waiting Approval'),
  openServiceRequest: (0, _linguiReact.i18nMark)('Open Service Requests'),
  allAssets: (0, _linguiReact.i18nMark)('All Assets'),
  highSeverity: (0, _linguiReact.i18nMark)('High Severity'),
  mediumSeverity: (0, _linguiReact.i18nMark)('Medium Severity'),
  maintenanceOverdue: (0, _linguiReact.i18nMark)('Maintenance Overdue'),
  maintenanceDue: (0, _linguiReact.i18nMark)('Maintenance Due'),
  maintenanceCurrent: (0, _linguiReact.i18nMark)('Maintenance Current')
};

exports.default = messages;

/***/ }),

/***/ "./redux/app/reducer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = undefined;

var _handleActions;

var _immutable = __webpack_require__("../node_modules/immutable/dist/immutable.js");

var _reduxActions = __webpack_require__("../node_modules/redux-actions/es/index.js");

var _constants = __webpack_require__("./redux/constants.js");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = exports.initialState = (0, _immutable.fromJS)({
  dashboard: (0, _immutable.Map)({
    error: null,
    favorites: (0, _immutable.Map)(),
    requesting: false
  }),
  favoritePagination: {},
  priorFavorite: {},
  latestFavorite: {},
  loadingStarted: false,
  searchParams: {},
  searchPagination: {
    cases: {},
    assets: {}
  },
  breadcrumbs: {
    current: {},
    previous: {}
  }
});

function loadDashboardRequestHandler(state) {
  return state.setIn(['dashboard', 'error'], null).setIn(['dashboard', 'requesting'], true);
}

function loadDashboardSuccessHandler(state) {
  return state.setIn(['dashboard', 'error'], null).setIn(['dashboard', 'requesting'], false);
}

function loadDashboardFailureHandler(state, action) {
  return state.setIn(['dashboard', 'error'], action.payload.response).setIn(['dashboard', 'requesting'], false);
}

function setDashboardFavoritesHandler(state, action) {
  return state.setIn(['dashboard', 'favorites'], action.payload);
}

function setFavoritePagination(state, _ref) {
  var payload = _ref.payload;

  return state.set('favoritePagination', (0, _immutable.fromJS)(payload));
}

function setLatestFavorite(state, _ref2) {
  var payload = _ref2.payload;

  return state.set('priorFavorite', state.get('latestFavorite')).set('latestFavorite', (0, _immutable.fromJS)(payload)).setIn(['favoritePagination', 'totalCount'], payload.get('count')).setIn(['breadcrumbs', 'previous'], (0, _immutable.fromJS)({})).setIn(['breadcrumbs', 'current'], (0, _immutable.fromJS)(payload));
}

function setLoadingStarted(state, _ref3) {
  var payload = _ref3.payload;

  return state.set('loadingStarted', payload);
}

function setSearchParams(state, _ref4) {
  var _ref4$payload = _ref4.payload,
      payload = _ref4$payload === undefined ? {} : _ref4$payload;

  return state.set('searchParams', (0, _immutable.fromJS)(payload));
}

function setSearchPagination(state, _ref5) {
  var payload = _ref5.payload;

  return state.setIn(['searchPagination', payload.type], (0, _immutable.fromJS)(payload.pagination));
}

function addPageToBreadcrumbs(state, _ref6) {
  var payload = _ref6.payload;

  var storedCrumbs = state.get('breadcrumbs').toJS();
  if (storedCrumbs.previous.path === payload.path) {
    return state.setIn(['breadcrumbs', 'previous'], (0, _immutable.fromJS)({})).setIn(['breadcrumbs', 'current'], (0, _immutable.fromJS)(payload));
  }
  return state.setIn(['breadcrumbs', 'previous'], state.getIn(['breadcrumbs', 'current'])).setIn(['breadcrumbs', 'current'], (0, _immutable.fromJS)(payload));
}

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _constants.LOAD_DASHBOARD_REQUEST, loadDashboardRequestHandler), _defineProperty(_handleActions, _constants.LOAD_DASHBOARD_SUCCESS, loadDashboardSuccessHandler), _defineProperty(_handleActions, _constants.LOAD_DASHBOARD_FAILURE, loadDashboardFailureHandler), _defineProperty(_handleActions, _constants.SET_DASHBOARD_FAVORITES, setDashboardFavoritesHandler), _defineProperty(_handleActions, _constants.SET_FAVORITE_PAGINATION, setFavoritePagination), _defineProperty(_handleActions, _constants.SET_LATEST_FAVORITE, setLatestFavorite), _defineProperty(_handleActions, _constants.SET_LOADING_STARTED, setLoadingStarted), _defineProperty(_handleActions, _constants.SET_SEARCH_PARAMS, setSearchParams), _defineProperty(_handleActions, _constants.SET_SEARCH_PAGINATION, setSearchPagination), _defineProperty(_handleActions, _constants.ADD_PAGE_TO_BREADCRUMBS, addPageToBreadcrumbs), _handleActions), initialState);

/***/ }),

/***/ "./redux/app/sagas.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _effects = __webpack_require__("../node_modules/redux-saga/es/effects.js");

var _actions = __webpack_require__("./redux/assets/actions.js");

var _actions2 = __webpack_require__("./redux/cases/actions.js");

var _constants = __webpack_require__("./redux/constants.js");

var _actions3 = __webpack_require__("./redux/app/actions.js");

var _alphaFavorites = __webpack_require__("./redux/app/alphaFavorites.js");

var _alphaFavorites2 = _interopRequireDefault(_alphaFavorites);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(loadDashboardSuccessWorker),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(performSearchWorker),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(loadDashboardSuccessWatcher),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(performSearchWatcher);

//---------------------------------------------------------------------------------------
// Workers:

/**
 * Load the left-nav favorites from the dashboard API endpoint.
 */
function loadDashboardSuccessWorker(_ref) {
  var response = _ref.payload;
  var favorites;
  return regeneratorRuntime.wrap(function loadDashboardSuccessWorker$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.call)(_alphaFavorites2.default, response);

        case 2:
          favorites = _context.sent;
          _context.next = 5;
          return (0, _effects.put)((0, _actions3.setDashboardFavorites)(favorites));

        case 5:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function performSearchWorker(_ref2) {
  var rawParams = _ref2.payload,
      _ref2$payload = _ref2.payload,
      searchOption = _ref2$payload.searchOption,
      searchValue = _ref2$payload.searchValue,
      rest = _objectWithoutProperties(_ref2$payload, ['searchOption', 'searchValue']);

  var params;
  return regeneratorRuntime.wrap(function performSearchWorker$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.put)((0, _actions3.setSearchParams)(rawParams));

        case 2:
          _context2.next = 4;
          return (0, _effects.put)((0, _actions3.setSearchPagination)({ type: 'assets', pagination: {} }));

        case 4:
          _context2.next = 6;
          return (0, _effects.put)((0, _actions3.setSearchPagination)({ type: 'cases', pagination: {} }));

        case 6:
          if (!(!searchValue || searchValue.length < _constants.MIN_CHAR_SEARCH)) {
            _context2.next = 9;
            break;
          }

          _context2.next = 9;
          return (0, _effects.cancel)();

        case 9:
          _context2.next = 11;
          return (0, _effects.put)((0, _actions3.setLoadingStarted)(true));

        case 11:
          params = _extends({}, rest);
          // TODO: The `all` function in redux-saga is so new at the time this was created
          // that the tools to test it do not yet exist. Revisit this generator function
          // after updating redux-saga-tester and add test coverage.
          /* istanbul ignore next */

          if (searchOption && searchValue) {
            params[searchOption.searchParam] = searchValue;
          }

          _context2.next = 15;
          return (0, _effects.all)([(0, _effects.put)((0, _actions.loadAssets)(params)), (0, _effects.put)((0, _actions2.loadCases)(params))]);

        case 15:
          _context2.next = 17;
          return (0, _effects.cancel)();

        case 17:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

//---------------------------------------------------------------------------------------
// Watchers:

function loadDashboardSuccessWatcher() {
  return regeneratorRuntime.wrap(function loadDashboardSuccessWatcher$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.takeLatest)(_constants.LOAD_DASHBOARD_SUCCESS, loadDashboardSuccessWorker);

        case 2:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function performSearchWatcher() {
  return regeneratorRuntime.wrap(function performSearchWatcher$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.takeLatest)(_constants.PERFORM_SEARCH, performSearchWorker);

        case 2:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

//---------------------------------------------------------------------------------------
// Exported list of all sagas:

exports.default = [loadDashboardSuccessWatcher(), performSearchWatcher()];

/***/ }),

/***/ "./redux/app/selectors.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.breadcrumbsSelector = exports.searchPaginationSelector = exports.searchParamsSelector = exports.priorFavoriteSelector = exports.loadingStartedSelector = exports.latestFavoriteSelector = exports.favoritesSelector = exports.favoritePaginationSelector = exports.dashboardRequestingSelector = exports.appStoreSelector = undefined;

var _reselect = __webpack_require__("../node_modules/reselect/lib/index.js");

// For convenience, extract the app section of the store.
var appStoreSelector = function appStoreSelector(state) {
  return state.get('app');
};

var dashboardRequestingSelector = (0, _reselect.createSelector)(appStoreSelector, function (appStore) {
  return appStore.getIn(['dashboard', 'requesting']);
});

// get the pagination data for the latest favorite.
var favoritePaginationSelector = (0, _reselect.createSelector)(appStoreSelector, function (appStore) {
  return appStore.get('favoritePagination');
});

// get the left nav favorites.
var favoritesSelector = (0, _reselect.createSelector)(appStoreSelector, function (appStore) {
  return appStore.getIn(['dashboard', 'favorites']);
});

// get the latest favorite
var latestFavoriteSelector = (0, _reselect.createSelector)(appStoreSelector, function (appStore) {
  return appStore.get('latestFavorite').toJS();
});

// get the flag that indicates loading has started
var loadingStartedSelector = (0, _reselect.createSelector)(appStoreSelector, function (appStore) {
  return appStore.get('loadingStarted');
});

// get the prior favorite
var priorFavoriteSelector = (0, _reselect.createSelector)(appStoreSelector, function (appStore) {
  return appStore.get('priorFavorite').toJS();
});

// get the search params
var searchParamsSelector = (0, _reselect.createSelector)(appStoreSelector, function (appStore) {
  return appStore.get('searchParams').toJS();
});

var searchPaginationSelector = (0, _reselect.createSelector)(appStoreSelector, function (appStore) {
  return appStore.get('searchPagination');
});

var breadcrumbsSelector = (0, _reselect.createSelector)(appStoreSelector, function (appStore) {
  return appStore.get('breadcrumbs').toJS();
});

exports.appStoreSelector = appStoreSelector;
exports.dashboardRequestingSelector = dashboardRequestingSelector;
exports.favoritePaginationSelector = favoritePaginationSelector;
exports.favoritesSelector = favoritesSelector;
exports.latestFavoriteSelector = latestFavoriteSelector;
exports.loadingStartedSelector = loadingStartedSelector;
exports.priorFavoriteSelector = priorFavoriteSelector;
exports.searchParamsSelector = searchParamsSelector;
exports.searchPaginationSelector = searchPaginationSelector;
exports.breadcrumbsSelector = breadcrumbsSelector;

/***/ }),

/***/ "./redux/assets/actions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setCurrentAssetCaseId = exports.setCurrentAssetCases = exports.setCurrentAsset = exports.setCurrentAssetFaults = exports.loadAssetFaults = exports.loadAssets = exports.loadAssetCases = exports.loadAsset = exports.clearAssets = exports.addOrUpdateCurrentAsset = exports.addOrUpdateAssets = undefined;

var _reduxActions = __webpack_require__("../node_modules/redux-actions/es/index.js");

var _reduxFlightControl = __webpack_require__("../node_modules/redux-flight-control/build/index.js");

var _reduxApiActions = __webpack_require__("./utils/redux-api-actions.js");

var _api = __webpack_require__("./redux/assets/api.js");

var _constants = __webpack_require__("./redux/constants.js");

var addOrUpdateAssets = exports.addOrUpdateAssets = (0, _reduxActions.createAction)(_constants.ADD_OR_UPDATE_ASSETS);

var addOrUpdateCurrentAsset = exports.addOrUpdateCurrentAsset = (0, _reduxActions.createAction)(_constants.ADD_OR_UPDATE_CURRENT_ASSET);

var clearAssets = exports.clearAssets = (0, _reduxActions.createAction)(_constants.RESET_FAVORITES);

var loadAsset = exports.loadAsset = (0, _reduxFlightControl.createRequestAction)(_constants.LOAD_ASSET, _api.getAsset);

var loadAssetCases = exports.loadAssetCases = (0, _reduxApiActions.createApiAction)([_constants.LOAD_ASSET_CASES_REQUEST, _constants.LOAD_ASSET_CASES_SUCCESS, _constants.LOAD_ASSET_CASES_FAILURE], _api.getAssetCases);

var loadAssets = exports.loadAssets = (0, _reduxApiActions.createApiAction)([_constants.LOAD_ASSETS_REQUEST, _constants.LOAD_ASSETS_SUCCESS, _constants.LOAD_ASSETS_FAILURE], _api.getAssets);

var loadAssetFaults = exports.loadAssetFaults = (0, _reduxFlightControl.createRequestAction)(_constants.LOAD_ASSET_FAULTS, _api.getAssetFaults);

var setCurrentAssetFaults = exports.setCurrentAssetFaults = (0, _reduxActions.createAction)(_constants.SET_CURRENT_ASSET_FAULTS, function (currentAssetFaults) {
  return { currentAssetFaults: currentAssetFaults };
});

var setCurrentAsset = exports.setCurrentAsset = (0, _reduxActions.createAction)(_constants.SET_CURRENT_ASSET);

var setCurrentAssetCases = exports.setCurrentAssetCases = (0, _reduxActions.createAction)(_constants.SET_CURRENT_ASSET_CASES);

var setCurrentAssetCaseId = exports.setCurrentAssetCaseId = (0, _reduxActions.createAction)(_constants.SET_CURRENT_ASSET_CASE_ID);

/***/ }),

/***/ "./redux/assets/api.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAsset = getAsset;
exports.getAssets = getAssets;
exports.getAssetCases = getAssetCases;
exports.getAssetFaults = getAssetFaults;

var _apiEndpoints = __webpack_require__("./apiEndpoints.js");

var _apiEndpoints2 = _interopRequireDefault(_apiEndpoints);

var _fetch = __webpack_require__("./utils/fetch.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getAsset(_ref) {
  var assetId = _ref.assetId;

  return (0, _fetch.get)(_apiEndpoints2.default.asset({ assetId: assetId }));
}

function getAssets(query) {
  return (0, _fetch.get)(_apiEndpoints2.default.assets(), { query: query });
}

function getAssetCases(_ref2) {
  var assetId = _ref2.assetId;

  return (0, _fetch.get)(_apiEndpoints2.default.assetCases({ assetId: assetId }));
}

function getAssetFaults(_ref3) {
  var assetId = _ref3.assetId;

  return (0, _fetch.get)(_apiEndpoints2.default.assetFaults({ assetId: assetId }));
}

/***/ }),

/***/ "./redux/assets/reducer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = undefined;

var _handleActions;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _immutable = __webpack_require__("../node_modules/immutable/dist/immutable.js");

var _reduxActions = __webpack_require__("../node_modules/redux-actions/es/index.js");

var _authentication = __webpack_require__("./features/authentication/index.js");

var _constants = __webpack_require__("./redux/constants.js");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = exports.initialState = (0, _immutable.fromJS)({
  responseIds: (0, _immutable.OrderedSet)(),
  byId: {},
  currentAssetId: '',
  currentAssetCases: [],
  currentAssetCase: '',
  currentAssetFaults: [],
  requesting: false,
  error: (0, _immutable.Map)()
});

function updateFromOtherHandler(state, action) {
  var _action$payload$entit = action.payload.entities;
  _action$payload$entit = _action$payload$entit === undefined ? {} : _action$payload$entit;
  var _action$payload$entit2 = _action$payload$entit.asset,
      newAssets = _action$payload$entit2 === undefined ? {} : _action$payload$entit2;


  var currentById = state.get('byId');
  var newById = currentById.merge(currentById, _extends({}, newAssets));

  return state.set('byId', newById);
}

function addOrUpdateAssetsHandler(state, action) {
  var _action$payload = action.payload,
      _action$payload$entit3 = _action$payload.entities;
  _action$payload$entit3 = _action$payload$entit3 === undefined ? {} : _action$payload$entit3;
  var _action$payload$entit4 = _action$payload$entit3.asset,
      newAssets = _action$payload$entit4 === undefined ? {} : _action$payload$entit4,
      _action$payload$resul = _action$payload.result,
      result = _action$payload$resul === undefined ? [] : _action$payload$resul;

  var currentAllIds = state.get('responseIds');
  var newAllIds = currentAllIds.concat(result);

  var currentById = state.get('byId');
  var newById = currentById.merge(currentById, _extends({}, newAssets));

  return state.set('responseIds', newAllIds).set('byId', newById);
}

function addOrUpdateCurrentAssetHandler(state, action) {
  var _action$payload$entit5 = action.payload.entities;
  _action$payload$entit5 = _action$payload$entit5 === undefined ? {} : _action$payload$entit5;
  var _action$payload$entit6 = _action$payload$entit5.asset,
      newAssets = _action$payload$entit6 === undefined ? {} : _action$payload$entit6;

  var assetId = Object.keys(newAssets)[0];

  var currentAssetInfo = state.getIn(['byId', assetId]) || (0, _immutable.Map)();
  var newAssetInfo = currentAssetInfo.merge(currentAssetInfo, newAssets[assetId]);

  return state.update('responseIds', function (orderedSet) {
    return orderedSet.add(assetId);
  }).updateIn(['byId', assetId], function () {
    return newAssetInfo;
  }).set('currentAssetId', assetId);
}

// Asset cases

function loadAssetCasesRequestHandler(state) {
  return state.set('assetCasesRequesting', true).set('error', (0, _immutable.Map)());
}

function loadAssetCasesSuccessHandler(state) {
  return state.set('assetCasesRequesting', false).set('error', (0, _immutable.Map)());
}

function loadAssetCasesFailureHandler(state, action) {
  return state.set('assetCasesRequesting', false).set('error', action.payload.response);
}

function setCurrentAssetFaultsHandler(state, action) {
  return state.set('currentAssetFaults', (0, _immutable.fromJS)(action.payload.currentAssetFaults));
}

// Assets

function loadAssetsRequestHandler(state) {
  return state.set('requesting', true).set('error', (0, _immutable.Map)());
}

function loadAssetsSuccessHandler(state) {
  return state.set('requesting', false).set('error', (0, _immutable.Map)());
}

function loadAssetsFailureHandler(state, action) {
  return state.set('requesting', false).set('error', action.payload.response);
}

function resetState(state) {
  return state.set('responseIds', (0, _immutable.OrderedSet)()).set('byId', (0, _immutable.Map)()).set('requesting', false);
}

function setCurrentAssetHandler(state, action) {
  return state.set('currentAssetId', action.payload);
}

function setCurrentAssetCaseIdHandler(state, action) {
  return state.set('currentAssetCaseId', action.payload);
}

function setCurrentAssetCasesHandler(state, action) {
  var _action$payload$resul2 = action.payload.result,
      result = _action$payload$resul2 === undefined ? [] : _action$payload$resul2;

  return state.set('currentAssetCases', (0, _immutable.fromJS)(result));
}

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _constants.ADD_OR_UPDATE_ASSETS, addOrUpdateAssetsHandler), _defineProperty(_handleActions, _constants.ADD_OR_UPDATE_CURRENT_ASSET, addOrUpdateCurrentAssetHandler), _defineProperty(_handleActions, (0, _reduxActions.combineActions)(_constants.ADD_OR_UPDATE_CASES, _constants.ADD_OR_UPDATE_CURRENT_CASE, _constants.ADD_OR_UPDATE_CURRENT_SERVICE_REQUEST, _constants.ADD_OR_UPDATE_SERVICE_REQUESTS), updateFromOtherHandler), _defineProperty(_handleActions, (0, _reduxActions.combineActions)(_constants.RESET_FAVORITES, _authentication.LOGOUT), resetState), _defineProperty(_handleActions, _constants.LOAD_ASSET_CASES_REQUEST, loadAssetCasesRequestHandler), _defineProperty(_handleActions, _constants.LOAD_ASSET_CASES_SUCCESS, loadAssetCasesSuccessHandler), _defineProperty(_handleActions, _constants.LOAD_ASSET_CASES_FAILURE, loadAssetCasesFailureHandler), _defineProperty(_handleActions, _constants.LOAD_ASSETS_REQUEST, loadAssetsRequestHandler), _defineProperty(_handleActions, _constants.LOAD_ASSETS_SUCCESS, loadAssetsSuccessHandler), _defineProperty(_handleActions, _constants.LOAD_ASSETS_FAILURE, loadAssetsFailureHandler), _defineProperty(_handleActions, _constants.SET_CURRENT_ASSET_FAULTS, setCurrentAssetFaultsHandler), _defineProperty(_handleActions, _constants.SET_CURRENT_ASSET, setCurrentAssetHandler), _defineProperty(_handleActions, _constants.SET_CURRENT_ASSET_CASES, setCurrentAssetCasesHandler), _defineProperty(_handleActions, _constants.SET_CURRENT_ASSET_CASE_ID, setCurrentAssetCaseIdHandler), _handleActions), initialState);

/***/ }),

/***/ "./redux/assets/sagas.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadAssetFaultsSuccessWorker = loadAssetFaultsSuccessWorker;
exports.loadAssetWatcher = loadAssetWatcher;
exports.loadAssetCasesSuccessWatcher = loadAssetCasesSuccessWatcher;
exports.loadAssetsSuccessWatcher = loadAssetsSuccessWatcher;
exports.loadAssetFaultsSuccessWatcher = loadAssetFaultsSuccessWatcher;

var _normalizr = __webpack_require__("../node_modules/normalizr/dist/src/index.js");

var _effects = __webpack_require__("../node_modules/redux-saga/es/effects.js");

var _actions = __webpack_require__("./redux/app/actions.js");

var _actions2 = __webpack_require__("./redux/cases/actions.js");

var _schemas = __webpack_require__("./redux/schemas.js");

var _constants = __webpack_require__("./redux/constants.js");

var _actions3 = __webpack_require__("./redux/assets/actions.js");

var _marked = /*#__PURE__*/regeneratorRuntime.mark(loadAssetWorker),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(loadAssetCasesSuccessWorker),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(loadAssetsSuccessWorker),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(loadAssetFaultsSuccessWorker),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(loadAssetWatcher),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(loadAssetCasesSuccessWatcher),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(loadAssetsSuccessWatcher),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(loadAssetFaultsSuccessWatcher);

// worker sagas
function loadAssetWorker(_ref) {
  var response = _ref.payload;
  var normalizedData;
  return regeneratorRuntime.wrap(function loadAssetWorker$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.call)(_normalizr.normalize, response.body, _schemas.assetSchema);

        case 2:
          normalizedData = _context.sent;

          if (!normalizedData.result) {
            _context.next = 6;
            break;
          }

          _context.next = 6;
          return (0, _effects.put)((0, _actions3.addOrUpdateCurrentAsset)(normalizedData));

        case 6:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function loadAssetCasesSuccessWorker(_ref2) {
  var response = _ref2.payload;
  var normalizedData;
  return regeneratorRuntime.wrap(function loadAssetCasesSuccessWorker$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.call)(_normalizr.normalize, response.body, _schemas.casesSchema);

        case 2:
          normalizedData = _context2.sent;
          _context2.next = 5;
          return (0, _effects.put)((0, _actions2.addOrUpdateCases)(normalizedData));

        case 5:
          _context2.next = 7;
          return (0, _effects.put)((0, _actions3.setCurrentAssetCases)(normalizedData));

        case 7:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function loadAssetsSuccessWorker(_ref3) {
  var response = _ref3.payload;
  var normalizedData, pagination;
  return regeneratorRuntime.wrap(function loadAssetsSuccessWorker$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.call)(_normalizr.normalize, response.body, _schemas.assetsSchema);

        case 2:
          normalizedData = _context3.sent;
          pagination = {
            latestPage: response.headers.get('x-page'),
            perPage: response.headers.get('x-per-page'),
            totalCount: response.headers.get('x-total-count'),
            totalPages: response.headers.get('x-total-pages')
          };
          _context3.next = 6;
          return (0, _effects.put)((0, _actions3.addOrUpdateAssets)(normalizedData));

        case 6:
          _context3.next = 8;
          return (0, _effects.put)((0, _actions.setFavoritePagination)(pagination));

        case 8:
          _context3.next = 10;
          return (0, _effects.put)((0, _actions.setSearchPagination)({
            type: 'assets',
            pagination: pagination
          }));

        case 10:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function loadAssetFaultsSuccessWorker(_ref4) {
  var response = _ref4.payload;
  var sortedData;
  return regeneratorRuntime.wrap(function loadAssetFaultsSuccessWorker$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          sortedData = response.body.sort(function (a, b) {
            return a.reportedAt > b.reportedAt ? 1 : -1;
          });
          _context4.next = 3;
          return (0, _effects.put)((0, _actions3.setCurrentAssetFaults)(sortedData));

        case 3:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

// watcher sagas
function loadAssetWatcher() {
  return regeneratorRuntime.wrap(function loadAssetWatcher$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.takeLatest)(_constants.LOAD_ASSET, loadAssetWorker);

        case 2:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function loadAssetCasesSuccessWatcher() {
  return regeneratorRuntime.wrap(function loadAssetCasesSuccessWatcher$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.takeLatest)(_constants.LOAD_ASSET_CASES_SUCCESS, loadAssetCasesSuccessWorker);

        case 2:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

function loadAssetsSuccessWatcher() {
  return regeneratorRuntime.wrap(function loadAssetsSuccessWatcher$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.takeLatest)(_constants.LOAD_ASSETS_SUCCESS, loadAssetsSuccessWorker);

        case 2:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this);
}

function loadAssetFaultsSuccessWatcher() {
  return regeneratorRuntime.wrap(function loadAssetFaultsSuccessWatcher$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.takeLatest)(_constants.LOAD_ASSET_FAULTS, loadAssetFaultsSuccessWorker);

        case 2:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked8, this);
}

// export all of the sagas.
exports.default = [loadAssetWatcher(), loadAssetCasesSuccessWatcher(), loadAssetsSuccessWatcher(), loadAssetFaultsSuccessWatcher()];

/***/ }),

/***/ "./redux/assets/selectors.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeGetAssetById = exports.getAssetById = exports.currentAssetCaseIdSelector = exports.currentAssetCasesSelector = exports.currentAssetSelector = exports.currentAssetIdSelector = exports.currentAssetFaultsSelector = exports.assetsSelector = exports.assetsErrorSelector = exports.assetsRequestingSelector = exports.assetCasesRequestingSelector = exports.assetsStoreSelector = exports.loadAssetErrorSelector = exports.loadAssetPendingSelector = undefined;

var _immutable = __webpack_require__("../node_modules/immutable/dist/immutable.js");

var _reselect = __webpack_require__("../node_modules/reselect/lib/index.js");

var _reduxFlightControl = __webpack_require__("../node_modules/redux-flight-control/build/index.js");

var _constants = __webpack_require__("./redux/constants.js");

/* --------------------------- REQUEST SELECTORS --------------------------- */

/* --------------------------- LOAD_ASSET --------------------------- */

var loadAssetPendingSelector = exports.loadAssetPendingSelector = (0, _reduxFlightControl.createHasActiveRequestSelectorFor)(_constants.LOAD_ASSET);

var loadAssetErrorSelector = exports.loadAssetErrorSelector = (0, _reduxFlightControl.createFailedRequestSelectorFor)(_constants.LOAD_ASSET);

/* --------------------------- ASSET STORE SELECTORS --------------------------- */

var assetsStoreSelector = exports.assetsStoreSelector = function assetsStoreSelector(state) {
  return state.get('assets');
};

var assetCasesRequestingSelector = exports.assetCasesRequestingSelector = (0, _reselect.createSelector)(assetsStoreSelector, function (assetsStore) {
  return assetsStore.get('assetCasesRequesting');
});

var assetsRequestingSelector = exports.assetsRequestingSelector = (0, _reselect.createSelector)(assetsStoreSelector, function (assetsStore) {
  return assetsStore.get('requesting');
});

var assetsErrorSelector = exports.assetsErrorSelector = (0, _reselect.createSelector)(assetsStoreSelector, function (assetsStore) {
  return assetsStore.get('error');
});

// When all of the assets are required we convert assets.byId into an immutable list.
var assetsSelector = exports.assetsSelector = (0, _reselect.createSelector)(assetsStoreSelector, function (assetsStore) {
  return assetsStore.get('responseIds').map(function (id) {
    return assetsStore.getIn(['byId', id]);
  }).toList();
});

var currentAssetFaultsSelector = exports.currentAssetFaultsSelector = (0, _reselect.createSelector)(assetsStoreSelector, function (assetsStore) {
  return assetsStore.get('currentAssetFaults') || (0, _immutable.List)();
});

var currentAssetIdSelector = exports.currentAssetIdSelector = (0, _reselect.createSelector)(assetsStoreSelector, function (assetsStore) {
  return assetsStore.get('currentAssetId');
});
// When just the current asset is required, we retrieve the asset data matching
// the current asset id.
var currentAssetSelector = exports.currentAssetSelector = (0, _reselect.createSelector)(assetsStoreSelector, function (assetsStore) {
  return assetsStore.getIn(['byId', assetsStore.get('currentAssetId')]) || (0, _immutable.Map)();
});

var currentAssetCasesSelector = exports.currentAssetCasesSelector = (0, _reselect.createSelector)(assetsStoreSelector, function (assetsStore) {
  return assetsStore.get('currentAssetCases');
});

var currentAssetCaseIdSelector = exports.currentAssetCaseIdSelector = (0, _reselect.createSelector)(assetsStoreSelector, function (assetsStore) {
  return assetsStore.get('currentAssetCaseId');
});

var getAssetById = exports.getAssetById = function getAssetById(state, assetId) {
  return assetsStoreSelector(state).getIn(['byId', assetId]) || (0, _immutable.Map)();
};

var makeGetAssetById = exports.makeGetAssetById = function makeGetAssetById() {
  return (0, _reselect.createSelector)(getAssetById, function (asset) {
    return asset;
  });
};

/***/ }),

/***/ "./redux/cases/actions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setCaseNotes = exports.setCurrentCaseFaults = exports.updateCaseFailure = exports.updateCaseSuccess = exports.updateCaseRequest = exports.updateCaseNote = exports.setCurrentCase = exports.selectCase = exports.postCaseNote = exports.loadCases = exports.loadCaseRecipients = exports.loadCaseNotes = exports.loadCaseFaults = exports.loadCase = exports.clearCases = exports.clearCaseRecipients = exports.addOrUpdateCurrentCase = exports.addOrUpdateCases = undefined;

var _reduxActions = __webpack_require__("../node_modules/redux-actions/es/index.js");

var _reduxApiActions = __webpack_require__("./utils/redux-api-actions.js");

var _reduxFlightControl = __webpack_require__("../node_modules/redux-flight-control/build/index.js");

var _api = __webpack_require__("./redux/cases/api.js");

var _constants = __webpack_require__("./redux/constants.js");

// redux-actions allows us to create very versatile action creators in a single line.
var addOrUpdateCases = exports.addOrUpdateCases = (0, _reduxActions.createAction)(_constants.ADD_OR_UPDATE_CASES);

var addOrUpdateCurrentCase = exports.addOrUpdateCurrentCase = (0, _reduxActions.createAction)(_constants.ADD_OR_UPDATE_CURRENT_CASE);

var clearCaseRecipients = exports.clearCaseRecipients = (0, _reduxActions.createAction)(_constants.CLEAR_CASE_RECIPIENTS);

var clearCases = exports.clearCases = (0, _reduxActions.createAction)(_constants.RESET_FAVORITES);

var loadCase = exports.loadCase = (0, _reduxFlightControl.createRequestAction)(_constants.LOAD_CASE, _api.getCase);

var loadCaseFaults = exports.loadCaseFaults = (0, _reduxApiActions.createApiAction)([_constants.LOAD_CASE_FAULTS_REQUEST, _constants.LOAD_CASE_FAULTS_SUCCESS, _constants.LOAD_CASE_FAULTS_FAILURE], _api.getCaseFaults);

var loadCaseNotes = exports.loadCaseNotes = (0, _reduxApiActions.createApiAction)([_constants.LOAD_CASE_NOTES_REQUEST, _constants.LOAD_CASE_NOTES_SUCCESS, _constants.LOAD_CASE_NOTES_FAILURE], _api.getCaseNotes);

var loadCaseRecipients = exports.loadCaseRecipients = (0, _reduxApiActions.createApiAction)([_constants.LOAD_CASE_RECIPIENTS_REQUEST, _constants.LOAD_CASE_RECIPIENTS_SUCCESS, _constants.LOAD_CASE_RECIPIENTS_FAILURE], _api.getCaseRecipients);

var loadCases = exports.loadCases = (0, _reduxApiActions.createApiAction)([_constants.LOAD_CASES_REQUEST, _constants.LOAD_CASES_SUCCESS, _constants.LOAD_CASES_FAILURE], _api.getCases);

// TODO: Success/Error handling should be added later
var postCaseNote = exports.postCaseNote = (0, _reduxActions.createAction)(_constants.POST_CASE_NOTE);

var selectCase = exports.selectCase = (0, _reduxActions.createAction)(_constants.SELECT_CASE);

var setCurrentCase = exports.setCurrentCase = (0, _reduxActions.createAction)(_constants.SET_CURRENT_CASE);

var updateCaseNote = exports.updateCaseNote = (0, _reduxActions.createAction)(_constants.UPDATE_CASE_NOTE);

var updateCaseRequest = exports.updateCaseRequest = (0, _reduxActions.createAction)(_constants.UPDATE_CASE_REQUEST);

var updateCaseSuccess = exports.updateCaseSuccess = (0, _reduxActions.createAction)(_constants.UPDATE_CASE_SUCCESS);

var updateCaseFailure = exports.updateCaseFailure = (0, _reduxActions.createAction)(_constants.UPDATE_CASE_FAILURE);

var setCurrentCaseFaults = exports.setCurrentCaseFaults = (0, _reduxActions.createAction)(_constants.SET_CURRENT_CASE_FAULTS, function (currentCaseFaults) {
  return { currentCaseFaults: currentCaseFaults };
});

var setCaseNotes = exports.setCaseNotes = (0, _reduxActions.createAction)(_constants.SET_CASE_NOTES, function (caseNotes) {
  return { caseNotes: caseNotes };
});

/***/ }),

/***/ "./redux/cases/api.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCase = getCase;
exports.getCases = getCases;
exports.getCaseFaults = getCaseFaults;
exports.getCaseNotes = getCaseNotes;
exports.getCaseRecipients = getCaseRecipients;
exports.postCaseNote = postCaseNote;
exports.updateCase = updateCase;
exports.updateCaseNote = updateCaseNote;

var _apiEndpoints = __webpack_require__("./apiEndpoints.js");

var _apiEndpoints2 = _interopRequireDefault(_apiEndpoints);

var _fetch = __webpack_require__("./utils/fetch.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getCase(_ref) {
  var caseId = _ref.caseId;

  return (0, _fetch.get)(_apiEndpoints2.default.case({ caseId: caseId }));
}

function getCases(query) {
  return (0, _fetch.get)(_apiEndpoints2.default.cases(), { query: query });
}

function getCaseFaults(_ref2) {
  var caseId = _ref2.caseId;

  return (0, _fetch.get)(_apiEndpoints2.default.caseFaults({ caseId: caseId }));
}

function getCaseNotes(_ref3) {
  var caseId = _ref3.caseId;

  return (0, _fetch.get)(_apiEndpoints2.default.caseNotes({ caseId: caseId }));
}

function getCaseRecipients(_ref4) {
  var caseId = _ref4.caseId;

  return (0, _fetch.get)(_apiEndpoints2.default.caseRecipients({ caseId: caseId }));
}

function postCaseNote(_ref5) {
  var caseId = _ref5.caseId,
      params = _ref5.params;

  return (0, _fetch.post)(_apiEndpoints2.default.caseNotes({ caseId: caseId }), { requestBody: params });
}

function updateCase(_ref6) {
  var caseId = _ref6.caseId,
      versionId = _ref6.versionId,
      approvalStatus = _ref6.approvalStatus,
      comments = _ref6.comments,
      poNumber = _ref6.poNumber;

  return (0, _fetch.patch)(_apiEndpoints2.default.caseVersion({ caseId: caseId, versionId: versionId }), { requestBody: { approvalStatus: approvalStatus, comments: comments, poNumber: poNumber } });
}

function updateCaseNote(_ref7) {
  var caseId = _ref7.caseId,
      noteId = _ref7.noteId,
      status = _ref7.status;

  return (0, _fetch.patch)(_apiEndpoints2.default.caseNote({ caseId: caseId, noteId: noteId }), { requestBody: { status: status } });
}

/***/ }),

/***/ "./redux/cases/reducer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = undefined;

var _handleActions;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _immutable = __webpack_require__("../node_modules/immutable/dist/immutable.js");

var _reduxActions = __webpack_require__("../node_modules/redux-actions/es/index.js");

var _authentication = __webpack_require__("./features/authentication/index.js");

var _constants = __webpack_require__("./redux/constants.js");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = exports.initialState = (0, _immutable.fromJS)({
  responseIds: (0, _immutable.OrderedSet)(),
  byId: {},
  caseNotes: {
    requesting: false,
    error: null,
    data: []
  },
  caseRecipients: {
    requesting: false,
    error: null,
    data: []
  },
  currentCaseId: '',
  selectedCaseId: '',
  requesting: false,
  error: (0, _immutable.Map)()
});

function addOrUpdateCasesHandler(state, action) {
  var _action$payload = action.payload,
      _action$payload$entit = _action$payload.entities;
  _action$payload$entit = _action$payload$entit === undefined ? {} : _action$payload$entit;
  var _action$payload$entit2 = _action$payload$entit.case,
      newCases = _action$payload$entit2 === undefined ? {} : _action$payload$entit2,
      _action$payload$resul = _action$payload.result,
      result = _action$payload$resul === undefined ? [] : _action$payload$resul;


  var currentAllIds = state.get('responseIds');
  var newAllIds = currentAllIds.concat(result);

  var currentById = state.get('byId');
  var newById = currentById.merge(currentById, _extends({}, newCases));

  return state.set('responseIds', newAllIds).set('byId', newById);
}

function addOrUpdateCurrentCaseHandler(state, action) {
  var _action$payload$entit3 = action.payload.entities;
  _action$payload$entit3 = _action$payload$entit3 === undefined ? {} : _action$payload$entit3;
  var _action$payload$entit4 = _action$payload$entit3.case,
      newCases = _action$payload$entit4 === undefined ? {} : _action$payload$entit4;

  var caseId = Object.keys(newCases)[0];

  var currentCaseInfo = state.getIn(['byId', caseId]) || (0, _immutable.Map)();
  var newCaseInfo = currentCaseInfo.merge(currentCaseInfo, newCases[caseId]);

  return state.update('responseIds', function (orderedSet) {
    return orderedSet.add(caseId).filter(function (id) {
      return !!id;
    });
  }).update('byId', function (map) {
    return map.set(caseId, newCaseInfo).filter(function (val, key) {
      return !!key;
    });
  }).set('currentCaseId', caseId).set('requesting', false);
}

function clearCaseRecipientsHandler(state) {
  return state.set('caseRecipients', state.get('caseRecipients').merge({
    requesting: false,
    error: null,
    data: []
  }));
}

function loadCaseFaultsRequestHandler(state) {
  return state.set('caseFaultsRequesting', true).set('error', (0, _immutable.Map)());
}

function loadCaseFaultsSuccessHandler(state) {
  return state.set('caseFaultsRequesting', false).set('error', (0, _immutable.Map)());
}

function loadCaseFaultsFailureHandler(state, action) {
  return state.set('caseFaultsRequesting', false).set('error', action.payload.response);
}

function loadCaseNotesRequestHandler(state) {
  return state.set('caseNotes', state.get('caseNotes').merge({
    requesting: true,
    error: null
  }));
}

function loadCaseNotesFailureHandler(state, action) {
  return state.set('caseNotes', state.get('caseNotes').merge({
    requesting: false,
    error: action.payload
  }));
}

function loadCaseRecipientsRequestHandler(state) {
  return state.set('caseRecipients', state.get('caseRecipients').merge({
    requesting: true,
    error: null
  }));
}

function loadCaseRecipientsSuccessHandler(state, action) {
  return state.set('caseRecipients', state.get('caseRecipients').merge({
    requesting: false,
    error: null,
    data: action.payload.body
  }));
}

function loadCaseRecipientsFailureHandler(state, action) {
  return state.set('caseRecipients', state.get('caseRecipients').merge({
    requesting: false,
    error: action.payload,
    data: []
  }));
}

function loadCasesRequestHandler(state) {
  return state.set('requesting', true).set('error', (0, _immutable.Map)());
}

function loadCasesSuccessHandler(state) {
  return state.set('requesting', false).set('error', (0, _immutable.Map)());
}

function loadCasesFailureHandler(state, action) {
  return state.set('requesting', false).set('error', action.payload.response);
}

function resetState() {
  return initialState;
}

function selectCase(state, action) {
  var selectedCaseId = state.get('selectedCaseId');
  var id = selectedCaseId === action.payload ? '' : action.payload;
  return state.set('selectedCaseId', id);
}

function setCurrentCaseHandler(state, action) {
  return state.set('currentCaseId', action.payload).set('error', (0, _immutable.Map)());
}

function setCurrentCaseFaultsHandler(state, action) {
  return state.set('currentCaseFaults', (0, _immutable.fromJS)(action.payload.currentCaseFaults));
}

function setCaseNotesHandler(state, action) {
  return state.set('caseNotes', (0, _immutable.fromJS)({
    requesting: false,
    error: null,
    data: action.payload.caseNotes || []
  }));
}

function updateCaseRequestHandler(state) {
  return state.set('requesting', true);
}

function updateCaseSuccessHandler(state, action) {
  return addOrUpdateCurrentCaseHandler(state, action);
}

function updateCaseFailureHandler(state, action) {
  return state.set('requesting', false).set('error', (0, _immutable.fromJS)(action));
}

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _constants.ADD_OR_UPDATE_CASES, addOrUpdateCasesHandler), _defineProperty(_handleActions, _constants.ADD_OR_UPDATE_CURRENT_CASE, addOrUpdateCurrentCaseHandler), _defineProperty(_handleActions, _constants.CLEAR_CASE_RECIPIENTS, clearCaseRecipientsHandler), _defineProperty(_handleActions, (0, _reduxActions.combineActions)(_constants.RESET_FAVORITES, _authentication.LOGOUT), resetState), _defineProperty(_handleActions, _constants.LOAD_CASE_FAULTS_REQUEST, loadCaseFaultsRequestHandler), _defineProperty(_handleActions, _constants.LOAD_CASE_FAULTS_SUCCESS, loadCaseFaultsSuccessHandler), _defineProperty(_handleActions, _constants.LOAD_CASE_FAULTS_FAILURE, loadCaseFaultsFailureHandler), _defineProperty(_handleActions, _constants.LOAD_CASE_NOTES_REQUEST, loadCaseNotesRequestHandler), _defineProperty(_handleActions, _constants.LOAD_CASE_NOTES_FAILURE, loadCaseNotesFailureHandler), _defineProperty(_handleActions, _constants.LOAD_CASE_RECIPIENTS_REQUEST, loadCaseRecipientsRequestHandler), _defineProperty(_handleActions, _constants.LOAD_CASE_RECIPIENTS_SUCCESS, loadCaseRecipientsSuccessHandler), _defineProperty(_handleActions, _constants.LOAD_CASE_RECIPIENTS_FAILURE, loadCaseRecipientsFailureHandler), _defineProperty(_handleActions, _constants.LOAD_CASES_REQUEST, loadCasesRequestHandler), _defineProperty(_handleActions, _constants.LOAD_CASES_SUCCESS, loadCasesSuccessHandler), _defineProperty(_handleActions, _constants.LOAD_CASES_FAILURE, loadCasesFailureHandler), _defineProperty(_handleActions, _constants.SELECT_CASE, selectCase), _defineProperty(_handleActions, _constants.SET_CURRENT_CASE, setCurrentCaseHandler), _defineProperty(_handleActions, _constants.SET_CURRENT_CASE_FAULTS, setCurrentCaseFaultsHandler), _defineProperty(_handleActions, _constants.SET_CASE_NOTES, setCaseNotesHandler), _defineProperty(_handleActions, _constants.UPDATE_CASE_REQUEST, updateCaseRequestHandler), _defineProperty(_handleActions, _constants.UPDATE_CASE_SUCCESS, updateCaseSuccessHandler), _defineProperty(_handleActions, _constants.UPDATE_CASE_FAILURE, updateCaseFailureHandler), _handleActions), initialState);

/***/ }),

/***/ "./redux/cases/sagas.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadCaseWatcher = loadCaseWatcher;
exports.loadCaseFaultsSuccessWatcher = loadCaseFaultsSuccessWatcher;
exports.loadCaseNotesSuccessWatcher = loadCaseNotesSuccessWatcher;
exports.loadCasesSuccessWatcher = loadCasesSuccessWatcher;
exports.postCaseNoteWatcher = postCaseNoteWatcher;
exports.updateCaseNoteWatcher = updateCaseNoteWatcher;
exports.updateCaseWatcher = updateCaseWatcher;

var _normalizr = __webpack_require__("../node_modules/normalizr/dist/src/index.js");

var _effects = __webpack_require__("../node_modules/redux-saga/es/effects.js");

var _actions = __webpack_require__("./redux/app/actions.js");

var _schemas = __webpack_require__("./redux/schemas.js");

var _constants = __webpack_require__("./redux/constants.js");

var _actions2 = __webpack_require__("./redux/cases/actions.js");

var _api = __webpack_require__("./redux/cases/api.js");

var _marked = /*#__PURE__*/regeneratorRuntime.mark(processCase),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(loadCaseWorker),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(loadCaseFaultsSuccessWorker),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(loadCaseNotesSuccessWorker),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(loadCasesSuccessWorker),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(postCaseNoteWorker),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(updateCaseNoteWorker),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(updateCaseWorker),
    _marked9 = /*#__PURE__*/regeneratorRuntime.mark(loadCaseWatcher),
    _marked10 = /*#__PURE__*/regeneratorRuntime.mark(loadCaseFaultsSuccessWatcher),
    _marked11 = /*#__PURE__*/regeneratorRuntime.mark(loadCaseNotesSuccessWatcher),
    _marked12 = /*#__PURE__*/regeneratorRuntime.mark(loadCasesSuccessWatcher),
    _marked13 = /*#__PURE__*/regeneratorRuntime.mark(postCaseNoteWatcher),
    _marked14 = /*#__PURE__*/regeneratorRuntime.mark(updateCaseNoteWatcher),
    _marked15 = /*#__PURE__*/regeneratorRuntime.mark(updateCaseWatcher);

/**
 * Given a single-case JSON response body (from a case fetch or case update), normalize
 * the data and update the matching entities in the Redux store with the new data.
 */
function processCase(response) {
  var normalizedData;
  return regeneratorRuntime.wrap(function processCase$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.call)(_normalizr.normalize, response.body, _schemas.caseSchema);

        case 2:
          normalizedData = _context.sent;
          _context.next = 5;
          return (0, _effects.put)((0, _actions2.addOrUpdateCurrentCase)(normalizedData));

        case 5:
          return _context.abrupt('return', normalizedData);

        case 6:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

// worker sagas
function loadCaseWorker(_ref) {
  var response = _ref.payload;
  return regeneratorRuntime.wrap(function loadCaseWorker$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.call)(processCase, response);

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function loadCaseFaultsSuccessWorker(_ref2) {
  var response = _ref2.payload;
  var sortedData;
  return regeneratorRuntime.wrap(function loadCaseFaultsSuccessWorker$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          sortedData = response.body.sort(function (a, b) {
            return a.reportedAt > b.reportedAt ? 1 : -1;
          });
          _context3.next = 3;
          return (0, _effects.put)((0, _actions2.setCurrentCaseFaults)(sortedData));

        case 3:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function loadCaseNotesSuccessWorker(_ref3) {
  var response = _ref3.payload;
  var sortedData;
  return regeneratorRuntime.wrap(function loadCaseNotesSuccessWorker$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          sortedData = response.body.sort(function (a, b) {
            return a.sentAt > b.sentAt ? 1 : -1;
          });
          _context4.next = 3;
          return (0, _effects.put)((0, _actions2.setCaseNotes)(sortedData));

        case 3:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function loadCasesSuccessWorker(_ref4) {
  var response = _ref4.payload;
  var normalizedData, pagination;
  return regeneratorRuntime.wrap(function loadCasesSuccessWorker$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.call)(_normalizr.normalize, response.body, _schemas.casesSchema);

        case 2:
          normalizedData = _context5.sent;
          pagination = {
            latestPage: response.headers.get('x-page'),
            perPage: response.headers.get('x-per-page'),
            totalCount: response.headers.get('x-total-count'),
            totalPages: response.headers.get('x-total-pages')
          };
          _context5.next = 6;
          return (0, _effects.put)((0, _actions2.addOrUpdateCases)(normalizedData));

        case 6:
          _context5.next = 8;
          return (0, _effects.put)((0, _actions.setFavoritePagination)(pagination));

        case 8:
          _context5.next = 10;
          return (0, _effects.put)((0, _actions.setSearchPagination)({
            type: 'cases',
            pagination: pagination
          }));

        case 10:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function postCaseNoteWorker(_ref5) {
  var payload = _ref5.payload;

  var _ref6, error;

  return regeneratorRuntime.wrap(function postCaseNoteWorker$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.call)(_api.postCaseNote, payload);

        case 2:
          _ref6 = _context6.sent;
          error = _ref6.error;

          if (!error) {
            _context6.next = 7;
            break;
          }

          _context6.next = 7;
          return (0, _effects.cancel)();

        case 7:
          _context6.next = 9;
          return (0, _effects.put)((0, _actions2.loadCase)(payload));

        case 9:
          _context6.next = 11;
          return (0, _effects.put)((0, _actions2.loadCaseNotes)(payload));

        case 11:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

function updateCaseNoteWorker(_ref7) {
  var payload = _ref7.payload;

  var _ref8, error;

  return regeneratorRuntime.wrap(function updateCaseNoteWorker$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.call)(_api.updateCaseNote, payload);

        case 2:
          _ref8 = _context7.sent;
          error = _ref8.error;

          if (!error) {
            _context7.next = 7;
            break;
          }

          _context7.next = 7;
          return (0, _effects.cancel)();

        case 7:
          _context7.next = 9;
          return (0, _effects.put)((0, _actions2.loadCase)(payload));

        case 9:
          _context7.next = 11;
          return (0, _effects.put)((0, _actions2.loadCaseNotes)(payload));

        case 11:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this);
}

function updateCaseWorker(_ref9) {
  var payload = _ref9.payload;

  var _ref10, response, error, normalizedData;

  return regeneratorRuntime.wrap(function updateCaseWorker$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.call)(_api.updateCase, payload);

        case 2:
          _ref10 = _context8.sent;
          response = _ref10.response;
          error = _ref10.error;

          if (!error) {
            _context8.next = 9;
            break;
          }

          (0, _effects.put)((0, _actions2.updateCaseFailure)(error));
          _context8.next = 9;
          return (0, _effects.cancel)();

        case 9:
          _context8.next = 11;
          return (0, _effects.call)(processCase, response);

        case 11:
          normalizedData = _context8.sent;
          _context8.next = 14;
          return (0, _effects.put)((0, _actions2.updateCaseSuccess)(normalizedData));

        case 14:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked8, this);
}

// watcher sagas
function loadCaseWatcher() {
  return regeneratorRuntime.wrap(function loadCaseWatcher$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.takeLatest)(_constants.LOAD_CASE, loadCaseWorker);

        case 2:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked9, this);
}

function loadCaseFaultsSuccessWatcher() {
  return regeneratorRuntime.wrap(function loadCaseFaultsSuccessWatcher$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _effects.takeLatest)(_constants.LOAD_CASE_FAULTS_SUCCESS, loadCaseFaultsSuccessWorker);

        case 2:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked10, this);
}

function loadCaseNotesSuccessWatcher() {
  return regeneratorRuntime.wrap(function loadCaseNotesSuccessWatcher$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return (0, _effects.takeLatest)(_constants.LOAD_CASE_NOTES_SUCCESS, loadCaseNotesSuccessWorker);

        case 2:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked11, this);
}

function loadCasesSuccessWatcher() {
  return regeneratorRuntime.wrap(function loadCasesSuccessWatcher$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return (0, _effects.takeLatest)(_constants.LOAD_CASES_SUCCESS, loadCasesSuccessWorker);

        case 2:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked12, this);
}

function postCaseNoteWatcher() {
  return regeneratorRuntime.wrap(function postCaseNoteWatcher$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return (0, _effects.takeLatest)(_constants.POST_CASE_NOTE, postCaseNoteWorker);

        case 2:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked13, this);
}

function updateCaseNoteWatcher() {
  return regeneratorRuntime.wrap(function updateCaseNoteWatcher$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return (0, _effects.takeLatest)(_constants.UPDATE_CASE_NOTE, updateCaseNoteWorker);

        case 2:
        case 'end':
          return _context14.stop();
      }
    }
  }, _marked14, this);
}

function updateCaseWatcher() {
  return regeneratorRuntime.wrap(function updateCaseWatcher$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 2;
          return (0, _effects.takeLatest)(_constants.UPDATE_CASE_REQUEST, updateCaseWorker);

        case 2:
        case 'end':
          return _context15.stop();
      }
    }
  }, _marked15, this);
}

// export all of the sagas.
exports.default = [loadCaseWatcher(), loadCaseFaultsSuccessWatcher(), loadCaseNotesSuccessWatcher(), loadCasesSuccessWatcher(), postCaseNoteWatcher(), updateCaseNoteWatcher(), updateCaseWatcher()];

/***/ }),

/***/ "./redux/cases/selectors.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.currentCaseServiceProviderSelector = exports.selectedCaseSelector = exports.caseRecipientsSelector = exports.caseNotesSelector = exports.currentCaseFaultsSelector = exports.currentCaseAssetSelector = exports.currentCaseSelector = exports.currentCaseIdSelector = exports.currentAssetCaseServiceProviderSelector = exports.currentAssetCaseSelector = exports.casesSelector = exports.casesErrorSelector = exports.casesRequestingSelector = exports.caseNotesRequestingSelector = exports.caseFaultsRequestingSelector = exports.loadCaseErrorSelector = exports.loadCasePendingSelector = undefined;

var _immutable = __webpack_require__("../node_modules/immutable/dist/immutable.js");

var _reselect = __webpack_require__("../node_modules/reselect/lib/index.js");

var _reduxFlightControl = __webpack_require__("../node_modules/redux-flight-control/build/index.js");

var _selectors = __webpack_require__("./redux/assets/selectors.js");

var _selectors2 = __webpack_require__("./redux/serviceProviders/selectors.js");

var _constants = __webpack_require__("./redux/constants.js");

/* --------------------------- REQUEST SELECTORS --------------------------- */

/* --------------------------- LOAD_CASE --------------------------- */

var loadCasePendingSelector = exports.loadCasePendingSelector = (0, _reduxFlightControl.createHasActiveRequestSelectorFor)(_constants.LOAD_CASE);

var loadCaseErrorSelector = exports.loadCaseErrorSelector = (0, _reduxFlightControl.createFailedRequestSelectorFor)(_constants.LOAD_CASE);

/* --------------------------- CASE STORE SELECTORS --------------------------- */

// For convenience, extract the cases section of the store.
var casesStoreSelector = function casesStoreSelector(state) {
  return state.get('cases');
};

// export const caseRequestingSelector = createSelector(
//   casesStoreSelector,
//   casesStore => casesStore.get('caseRequesting'),
// );

var caseFaultsRequestingSelector = exports.caseFaultsRequestingSelector = (0, _reselect.createSelector)(casesStoreSelector, function (casesStore) {
  return casesStore.get('caseFaultsRequesting');
});

var caseNotesRequestingSelector = exports.caseNotesRequestingSelector = (0, _reselect.createSelector)(casesStoreSelector, function (casesStore) {
  return casesStore.getIn(['caseNotes', 'requesting']);
});

var casesRequestingSelector = exports.casesRequestingSelector = (0, _reselect.createSelector)(casesStoreSelector, function (casesStore) {
  return casesStore.get('requesting');
});

var casesErrorSelector = exports.casesErrorSelector = (0, _reselect.createSelector)(casesStoreSelector, function (casesStore) {
  return casesStore.get('error');
});

// When all of the cases are required we convert cases.byId into an immutable list.
var casesSelector = exports.casesSelector = (0, _reselect.createSelector)(casesStoreSelector, function (casesStore) {
  return casesStore.get('responseIds').map(function (id) {
    return casesStore.getIn(['byId', id]);
  }).toList();
});

// This returns the cases from the currentAssetCases state of assets store
var currentAssetCaseSelector = exports.currentAssetCaseSelector = (0, _reselect.createSelector)(casesStoreSelector, _selectors.currentAssetCaseIdSelector, function (casesStore, currentAssetCaseId) {
  return currentAssetCaseId && casesStore.getIn(['byId', currentAssetCaseId]) || (0, _immutable.Map)();
});

var currentAssetCaseServiceProviderSelector = exports.currentAssetCaseServiceProviderSelector = (0, _reselect.createSelector)(currentAssetCaseSelector, _selectors2.serviceProviderStoreSelector, function (currentAssetCase, serviceProviderStore) {
  return currentAssetCase && serviceProviderStore.getIn(['byId', currentAssetCase.get('serviceProvider')]) || (0, _immutable.Map)();
});

var currentCaseIdSelector = exports.currentCaseIdSelector = (0, _reselect.createSelector)(casesStoreSelector, function (casesStore) {
  return casesStore.get('currentCaseId');
});

// When just the current case is required, we retrieve the case data matching the current case id.
var currentCaseSelector = exports.currentCaseSelector = (0, _reselect.createSelector)(casesStoreSelector, currentCaseIdSelector, function (casesStore, currentCaseId) {
  return currentCaseId && casesStore.getIn(['byId', currentCaseId]) || (0, _immutable.Map)();
});

var currentCaseAssetSelector = exports.currentCaseAssetSelector = (0, _reselect.createSelector)(currentCaseSelector, _selectors.assetsStoreSelector, function (currentCase, assetsStore) {
  return currentCase && assetsStore.getIn(['byId', currentCase.get('asset')]) || (0, _immutable.Map)();
});

var currentCaseFaultsSelector = exports.currentCaseFaultsSelector = (0, _reselect.createSelector)([casesStoreSelector], function (cases) {
  return cases.get('currentCaseFaults') || (0, _immutable.List)();
});

var caseNotesSelector = exports.caseNotesSelector = (0, _reselect.createSelector)([casesStoreSelector], function (cases) {
  return cases.get('caseNotes');
});

var caseRecipientsSelector = exports.caseRecipientsSelector = (0, _reselect.createSelector)([casesStoreSelector], function (cases) {
  return cases.get('caseRecipients');
});

var selectedCaseSelector = exports.selectedCaseSelector = (0, _reselect.createSelector)([casesStoreSelector], function (cases) {
  return cases.get('selectedCaseId');
});

var currentCaseServiceProviderSelector = exports.currentCaseServiceProviderSelector = (0, _reselect.createSelector)(currentCaseSelector, _selectors2.serviceProviderStoreSelector, function (currentCase, serviceProviderStore) {
  return currentCase && serviceProviderStore.getIn(['byId', currentCase.get('serviceProvider')]) || (0, _immutable.Map)();
});

/***/ }),

/***/ "./redux/combinedSelectors.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadingSelector = exports.noAssetsCasesFoundSelector = exports.noAssetsCasesSelector = exports.requestingSelector = undefined;

var _reselect = __webpack_require__("../node_modules/reselect/lib/index.js");

var _selectors = __webpack_require__("./redux/app/selectors.js");

var _selectors2 = __webpack_require__("./redux/assets/selectors.js");

var _selectors3 = __webpack_require__("./redux/cases/selectors.js");

var _selectors4 = __webpack_require__("./redux/serviceRequests/selectors.js");

var requestingSelector = (0, _reselect.createSelector)(_selectors2.assetsRequestingSelector, _selectors3.casesRequestingSelector, _selectors.dashboardRequestingSelector, _selectors4.serviceRequestsRequestingSelector, function (assetsRequesting, casesRequesting, dashboardRequesting, serviceRequestsRequesting) {
  return assetsRequesting || casesRequesting || dashboardRequesting || serviceRequestsRequesting;
});

var noAssetsCasesSelector = (0, _reselect.createSelector)(_selectors2.assetsSelector, _selectors3.casesSelector, function (assets, cases) {
  return assets.size + cases.size === 0;
});

var noAssetsCasesFoundSelector = (0, _reselect.createSelector)(noAssetsCasesSelector, requestingSelector, function (noAssetsCases, requesting) {
  return !requesting && noAssetsCases;
});

var loadingSelector = (0, _reselect.createSelector)(_selectors2.assetCasesRequestingSelector, _selectors2.assetsRequestingSelector, _selectors3.caseFaultsRequestingSelector, _selectors3.caseNotesRequestingSelector, _selectors3.casesRequestingSelector, _selectors.dashboardRequestingSelector, _selectors2.loadAssetPendingSelector, _selectors3.loadCasePendingSelector, _selectors4.loadServiceRequestPendingSelector, _selectors4.serviceRequestsRequestingSelector, function (assetCasesRequesting, assetsRequesting, caseFaultsRequesting, caseNotesRequesting, casesRequesting, dashboardRequesting, loadAssetPending, loadCasePending, loadServiceRequestPending, serviceRequestsRequesting) {
  return assetCasesRequesting || assetsRequesting || caseFaultsRequesting || caseNotesRequesting || casesRequesting || dashboardRequesting || loadAssetPending || loadCasePending || loadServiceRequestPending || serviceRequestsRequesting;
});

exports.requestingSelector = requestingSelector;
exports.noAssetsCasesSelector = noAssetsCasesSelector;
exports.noAssetsCasesFoundSelector = noAssetsCasesFoundSelector;
exports.loadingSelector = loadingSelector;

/***/ }),

/***/ "./redux/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * These are the constants used throughout the Redux store. They should be kept at this level
 * because constants may be called anywhere within the store, regardless of namespacing.
 */

var ADD_HIDDEN_WIDGET = exports.ADD_HIDDEN_WIDGET = 'fleet_web/ui/ADD_HIDDEN_WIDGET';
var EXPAND_LEFTNAV_PARENT = exports.EXPAND_LEFTNAV_PARENT = 'fleet_web/ui/EXPAND_LEFTNAV_PARENT';
var HANDLE_ACTION_BAR_ITEM_CLICK = exports.HANDLE_ACTION_BAR_ITEM_CLICK = 'fleet_web/ui/HANDLE_ACTION_BAR_ITEM_CLICK';
var REQUEST_FULL_SCREEN_MODE = exports.REQUEST_FULL_SCREEN_MODE = 'fleet_web/ui/REQUEST_FULL_SCREEN_MODE';
var REQUEST_PRINT_PAGE = exports.REQUEST_PRINT_PAGE = 'fleet_web/ui/REQUEST_PRINT_PAGE';
var RESET_HIDDEN_WIDGETS = exports.RESET_HIDDEN_WIDGETS = 'fleet_web/ui/RESET_HIDDEN_WIDGETS';
var SET_ASSETS_VIEW = exports.SET_ASSETS_VIEW = 'fleet_web/ui/SET_ASSETS_VIEW';
var SET_BRAND_VALUES = exports.SET_BRAND_VALUES = 'fleet_web/ui/SET_BRAND_VALUES';
var SET_CASES_VIEW = exports.SET_CASES_VIEW = 'fleet_web/ui/SET_CASES_VIEW';
var SET_COMPONENT_EXPANDED = exports.SET_COMPONENT_EXPANDED = 'fleet_web/ui/SET_COMPONENT_EXPANDED';
var SET_LEFTNAV_EXPANDED = exports.SET_LEFTNAV_EXPANDED = 'fleet_web/ui/SET_LEFTNAV_EXPANDED';
var SET_LOADING_STARTED = exports.SET_LOADING_STARTED = 'fleet_web/ui/SET_LOADING_STARTED';
var SET_SERVICE_REQUESTS_VIEW = exports.SET_SERVICE_REQUESTS_VIEW = 'fleet_web/ui/SET_SERVICE_REQUESTS_VIEW';
var UPDATE_SCROLL_TO_UNREAD_NOTE = exports.UPDATE_SCROLL_TO_UNREAD_NOTE = 'fleet_web/ui/UPDATE_SCROLL_TO_UNREAD_NOTE';

// key for the persisted app UI state in memoryDB:
var LOCALSTORAGE_APP_STATE_KEY = exports.LOCALSTORAGE_APP_STATE_KEY = 'DECISIV/fleet_web/ui-state';

// PageConfig constants
var SET_CURRENT_PAGE_CONFIG_KEY = exports.SET_CURRENT_PAGE_CONFIG_KEY = 'fleet_web/pageConfig/SET_CURRENT_PAGE_CONFIG_KEY';

var LOAD_DASHBOARD_REQUEST = exports.LOAD_DASHBOARD_REQUEST = 'fleet_web/app/LOAD_DASHBOARD_REQUEST';
var LOAD_DASHBOARD_SUCCESS = exports.LOAD_DASHBOARD_SUCCESS = 'fleet_web/app/LOAD_DASHBOARD_SUCCESS';
var LOAD_DASHBOARD_FAILURE = exports.LOAD_DASHBOARD_FAILURE = 'fleet_web/app/LOAD_DASHBOARD_FAILURE';
var PERFORM_SEARCH = exports.PERFORM_SEARCH = 'fleet_web/app/PERFORM_SEARCH';
var SET_DASHBOARD_FAVORITES = exports.SET_DASHBOARD_FAVORITES = 'fleet_web/app/SET_DASHBOARD_FAVORITES';
var SET_FAVORITE_PAGINATION = exports.SET_FAVORITE_PAGINATION = 'fleet_web/app/SET_FAVORITE_PAGINATION';
var SET_LATEST_FAVORITE = exports.SET_LATEST_FAVORITE = 'fleet_web/app/SET_LATEST_FAVORITE';
var SET_SEARCH_PARAMS = exports.SET_SEARCH_PARAMS = 'fleet_web/app/SET_SEARCH_PARAMS';
var SET_SEARCH_PAGINATION = exports.SET_SEARCH_PAGINATION = 'fleet_web/app/SET_SEARCH_PAGINATION';
var ADD_PAGE_TO_BREADCRUMBS = exports.ADD_PAGE_TO_BREADCRUMBS = 'fleet_web/app/ADD_PAGE_TO_BREADCRUMBS';

// FAVORITES constants
var RESET_FAVORITES = exports.RESET_FAVORITES = 'fleet_web/favorites/RESET_FAVORITES';

// Cases constants
var ADD_OR_UPDATE_CASES = exports.ADD_OR_UPDATE_CASES = 'fleet_web/cases/ADD_OR_UPDATE_CASES';
var ADD_OR_UPDATE_CURRENT_CASE = exports.ADD_OR_UPDATE_CURRENT_CASE = 'fleet_web/cases/ADD_OR_UPDATE_CURRENT_CASE';
var CLEAR_CASE_RECIPIENTS = exports.CLEAR_CASE_RECIPIENTS = 'fleet_web/cases/CLEAR_CASE_RECIPIENTS';
var LOAD_CASE = exports.LOAD_CASE = 'fleet_web/cases/LOAD_CASE';
var LOAD_CASE_FAULTS_REQUEST = exports.LOAD_CASE_FAULTS_REQUEST = 'fleet_web/cases/LOAD_CASE_FAULTS_REQUEST';
var LOAD_CASE_FAULTS_SUCCESS = exports.LOAD_CASE_FAULTS_SUCCESS = 'fleet_web/cases/LOAD_CASE_FAULTS_SUCCESS';
var LOAD_CASE_FAULTS_FAILURE = exports.LOAD_CASE_FAULTS_FAILURE = 'fleet_web/cases/LOAD_CASE_FAULTS_FAILURE';
var LOAD_CASE_NOTES_REQUEST = exports.LOAD_CASE_NOTES_REQUEST = 'fleet_web/cases/LOAD_CASE_NOTES_REQUEST';
var LOAD_CASE_NOTES_SUCCESS = exports.LOAD_CASE_NOTES_SUCCESS = 'fleet_web/cases/LOAD_CASE_NOTES_SUCCESS';
var LOAD_CASE_NOTES_FAILURE = exports.LOAD_CASE_NOTES_FAILURE = 'fleet_web/cases/LOAD_CASE_NOTES_FAILURE';
var LOAD_CASE_RECIPIENTS_REQUEST = exports.LOAD_CASE_RECIPIENTS_REQUEST = 'fleet_web/cases/LOAD_CASE_RECIPIENTS_REQUEST';
var LOAD_CASE_RECIPIENTS_SUCCESS = exports.LOAD_CASE_RECIPIENTS_SUCCESS = 'fleet_web/cases/LOAD_CASE_RECIPIENTS_SUCCESS';
var LOAD_CASE_RECIPIENTS_FAILURE = exports.LOAD_CASE_RECIPIENTS_FAILURE = 'fleet_web/cases/LOAD_CASE_RECIPIENTS_FAILURE';
var LOAD_CASES_REQUEST = exports.LOAD_CASES_REQUEST = 'fleet_web/cases/LOAD_CASES_REQUEST';
var LOAD_CASES_SUCCESS = exports.LOAD_CASES_SUCCESS = 'fleet_web/cases/LOAD_CASES_SUCCESS';
var LOAD_CASES_FAILURE = exports.LOAD_CASES_FAILURE = 'fleet_web/cases/LOAD_CASES_FAILURE';
var POST_CASE_NOTE = exports.POST_CASE_NOTE = 'fleet_web/cases/POST_CASE_NOTE';
var SELECT_CASE = exports.SELECT_CASE = 'fleet_web/cases/SELECT_CASE';
var SET_CURRENT_CASE = exports.SET_CURRENT_CASE = 'fleet_web/cases/SET_CURRENT_CASE';
var SET_CURRENT_CASE_FAULTS = exports.SET_CURRENT_CASE_FAULTS = 'fleet_web/cases/SET_CURRENT_CASE_FAULTS';
var SET_CASE_NOTES = exports.SET_CASE_NOTES = 'fleet_web/cases/SET_CASE_NOTES';
var UPDATE_CASE_NOTE = exports.UPDATE_CASE_NOTE = 'fleet_web/cases/UPDATE_CASE_NOTE';
var UPDATE_CASE_REQUEST = exports.UPDATE_CASE_REQUEST = 'fleet_web/cases/UPDATE_CASE_REQUEST';
var UPDATE_CASE_SUCCESS = exports.UPDATE_CASE_SUCCESS = 'fleet_web/cases/UPDATE_CASE_SUCCESS';
var UPDATE_CASE_FAILURE = exports.UPDATE_CASE_FAILURE = 'fleet_web/cases/UPDATE_CASE_FAILURE';

// Assets constants
var ADD_OR_UPDATE_ASSETS = exports.ADD_OR_UPDATE_ASSETS = 'fleet_web/assets/ADD_OR_UPDATE_ASSETS';
var ADD_OR_UPDATE_CURRENT_ASSET = exports.ADD_OR_UPDATE_CURRENT_ASSET = 'fleet_web/assets/ADD_OR_UPDATE_CURRENT_ASSET';
var LOAD_ASSET = exports.LOAD_ASSET = 'fleet_web/assets/LOAD_ASSET';
var LOAD_ASSET_CASES_REQUEST = exports.LOAD_ASSET_CASES_REQUEST = 'fleet_web/assets/LOAD_ASSET_CASES_REQUEST';
var LOAD_ASSET_CASES_SUCCESS = exports.LOAD_ASSET_CASES_SUCCESS = 'fleet_web/assets/LOAD_ASSET_CASES_SUCCESS';
var LOAD_ASSET_CASES_FAILURE = exports.LOAD_ASSET_CASES_FAILURE = 'fleet_web/assets/LOAD_ASSET_CASES_FAILURE';
var LOAD_ASSETS_REQUEST = exports.LOAD_ASSETS_REQUEST = 'fleet_web/assets/LOAD_ASSETS_REQUEST';
var LOAD_ASSETS_SUCCESS = exports.LOAD_ASSETS_SUCCESS = 'fleet_web/assets/LOAD_ASSETS_SUCCESS';
var LOAD_ASSETS_FAILURE = exports.LOAD_ASSETS_FAILURE = 'fleet_web/assets/LOAD_ASSETS_FAILURE';
var LOAD_ASSET_FAULTS = exports.LOAD_ASSET_FAULTS = 'fleet_web/assets/LOAD_ASSET_FAULTS';
var SET_CURRENT_ASSET_FAULTS = exports.SET_CURRENT_ASSET_FAULTS = 'fleet_web/assets/SET_CURRENT_ASSET_FAULTS';
var SET_CURRENT_ASSET = exports.SET_CURRENT_ASSET = 'fleet_web/cases/SET_CURRENT_ASSET';
var SET_CURRENT_ASSET_CASE_ID = exports.SET_CURRENT_ASSET_CASE_ID = 'fleet_web/cases/SET_CURRENT_ASSET_CASE_ID';
var SET_CURRENT_ASSET_CASES = exports.SET_CURRENT_ASSET_CASES = 'fleet_web/cases/SET_CURRENT_ASSET_CASES';

// User store constants
var LOAD_USER_PROFILE = exports.LOAD_USER_PROFILE = 'fleet_web/user/LOAD_USER_PROFILE';

// Service Providers constants
var ADD_OR_UPDATE_SERVICE_PROVIDERS = exports.ADD_OR_UPDATE_SERVICE_PROVIDERS = 'fleet_web/serviceProviders/ADD_OR_UPDATE_SERVICE_PROVIDERS';
var LOAD_SERVICE_PROVIDERS = exports.LOAD_SERVICE_PROVIDERS = 'fleet_web/serviceProviders/LOAD_SERVICE_PROVIDERS';
var CLEAR_SERVICE_PROVIDERS = exports.CLEAR_SERVICE_PROVIDERS = 'CLEAR_SERVICE_PROVIDERS';

// Service Requests constants
var ADD_OR_UPDATE_CURRENT_SERVICE_REQUEST = exports.ADD_OR_UPDATE_CURRENT_SERVICE_REQUEST = 'fleet_web/serviceRequests/ADD_OR_UPDATE_CURRENT_SERVICE_REQUEST';
var ADD_OR_UPDATE_SERVICE_REQUESTS = exports.ADD_OR_UPDATE_SERVICE_REQUESTS = 'fleet_web/serviceRequests/ADD_OR_UPDATE_SERVICE_REQUESTS';
var CANCEL_SERVICE_REQUEST = exports.CANCEL_SERVICE_REQUEST = 'fleet_web/serviceRequests/CANCEL_SERVICE_REQUEST';
var CREATE_SERVICE_REQUEST = exports.CREATE_SERVICE_REQUEST = 'fleet_web/serviceRequests/CREATE_SERVICE_REQUEST';
var LOAD_SERVICE_REQUEST = exports.LOAD_SERVICE_REQUEST = 'fleet_web/serviceRequests/LOAD_SERVICE_REQUEST';
var LOAD_SERVICE_REQUESTS_REQUEST = exports.LOAD_SERVICE_REQUESTS_REQUEST = 'fleet_web/serviceRequests/LOAD_SERVICE_REQUESTS_REQUEST';
var LOAD_SERVICE_REQUESTS_SUCCESS = exports.LOAD_SERVICE_REQUESTS_SUCCESS = 'fleet_web/serviceRequests/LOAD_SERVICE_REQUESTS_SUCCESS';
var LOAD_SERVICE_REQUESTS_FAILURE = exports.LOAD_SERVICE_REQUESTS_FAILURE = 'fleet_web/serviceRequests/LOAD_SERVICE_REQUESTS_FAILURE';
var RESET_SERVICE_REQUESTS_FAVORITES = exports.RESET_SERVICE_REQUESTS_FAVORITES = 'fleet_web/serviceRequests/RESET_SERVICE_REQUESTS_FAVORITES';
var SET_CURRENT_SERVICE_REQUEST = exports.SET_CURRENT_SERVICE_REQUEST = 'fleet_web/cases/SET_CURRENT_SERVICE_REQUEST';

// Data Lists constants (reasons for repair, search filters, etc)
var LOAD_DATA_LISTS = exports.LOAD_DATA_LISTS = 'fleet_web/dataLists/LOAD_DATA_LISTS';

// Minimum characters to perform search
var MIN_CHAR_SEARCH = exports.MIN_CHAR_SEARCH = 3;

/***/ }),

/***/ "./redux/dataLists/actions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadDataLists = undefined;

var _reduxFlightControl = __webpack_require__("../node_modules/redux-flight-control/build/index.js");

var _api = __webpack_require__("./redux/dataLists/api.js");

var _constants = __webpack_require__("./redux/constants.js");

// eslint-disable-next-line
var loadDataLists = exports.loadDataLists = (0, _reduxFlightControl.createRequestAction)(_constants.LOAD_DATA_LISTS, _api.getDataLists);

/***/ }),

/***/ "./redux/dataLists/api.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDataLists = getDataLists;

var _apiEndpoints = __webpack_require__("./apiEndpoints.js");

var _apiEndpoints2 = _interopRequireDefault(_apiEndpoints);

var _fetch = __webpack_require__("./utils/fetch.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line import/prefer-default-export
function getDataLists() {
  return (0, _fetch.get)(_apiEndpoints2.default.dataLists());
}

/***/ }),

/***/ "./redux/dataLists/reducer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = undefined;

var _immutable = __webpack_require__("../node_modules/immutable/dist/immutable.js");

var _reduxActions = __webpack_require__("../node_modules/redux-actions/es/index.js");

var _constants = __webpack_require__("./redux/constants.js");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = exports.initialState = (0, _immutable.Map)();

function loadDataListsSuccessHandler(state, action) {
  return (0, _immutable.fromJS)(action.payload.body);
}

exports.default = (0, _reduxActions.handleActions)(_defineProperty({}, _constants.LOAD_DATA_LISTS, loadDataListsSuccessHandler), initialState);

/***/ }),

/***/ "./redux/dataLists/selectors.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.complaintsSelector = exports.reasonsForRepairSelector = undefined;

var _reselect = __webpack_require__("../node_modules/reselect/lib/index.js");

var dataListsStoreSelector = function dataListsStoreSelector(state) {
  return state.get('dataLists');
};

var reasonsForRepairSelector = exports.reasonsForRepairSelector = (0, _reselect.createSelector)(dataListsStoreSelector, function (dataListsStore) {
  return dataListsStore.get('reasonsForRepair');
});

var complaintsSelector = exports.complaintsSelector = (0, _reselect.createSelector)(dataListsStoreSelector, function (dataListsStore) {
  return dataListsStore.get('complaints');
});

/***/ }),

/***/ "./redux/middleware/requestStatusMiddleware.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = requestStatusMiddleware;

var _invariant = __webpack_require__("../node_modules/invariant/browser.js");

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * requestStatusMiddleware takes an API Request action and handles updating the state
 * when requesting as well as dispatching actions for success and failure cases.
 */
function requestStatusMiddleware(_ref) {
  var dispatch = _ref.dispatch;

  return function (next) {
    return function (action) {
      var types = action.types,
          apiCall = action.apiCall,
          _action$payload = action.payload,
          payload = _action$payload === undefined ? {} : _action$payload;

      // requestStatusMiddleware requires 3 action types, *_REQUEST, *_SUCCESS, *_FAILURE.
      // If the `types` key is absent, pass this action along to the next middleware.

      if (!types) {
        return next(action);
      }

      // The `types` key must be an array of 3 strings. If not, throw an error.
      (0, _invariant2.default)(Array.isArray(types) && types.length === 3 && types.every(function (type) {
        return typeof type === 'string';
      }), 'requestStatusMiddleware expected `types` to be an array of 3 strings');

      // The `apiCall` key must be a function.
      (0, _invariant2.default)(typeof apiCall === 'function', 'requestStatusMiddleware expected `apiCall` to be a function');

      var _types = _slicedToArray(types, 3),
          requestType = _types[0],
          successType = _types[1],
          failureType = _types[2];

      dispatch({ type: requestType, payload: payload });

      return apiCall(payload).then(function (_ref2) {
        var response = _ref2.response,
            error = _ref2.error;

        if (error) {
          dispatch({ type: failureType, error: true, payload: error });
        } else {
          dispatch({ type: successType, payload: response });
        }
      });
    };
  };
}

/***/ }),

/***/ "./redux/pageConfigs/actions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setCurrentPageConfigKey = undefined;

var _reduxActions = __webpack_require__("../node_modules/redux-actions/es/index.js");

var _constants = __webpack_require__("./redux/constants.js");

// eslint-disable-next-line import/prefer-default-export
var setCurrentPageConfigKey = exports.setCurrentPageConfigKey = (0, _reduxActions.createAction)(_constants.SET_CURRENT_PAGE_CONFIG_KEY);

/***/ }),

/***/ "./redux/pageConfigs/reducer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _handleActions;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// eslint-disable-next-line import/no-unresolved


exports.loadInitialState = loadInitialState;
exports.setCurrentPageConfigKeyHandler = setCurrentPageConfigKeyHandler;

var _immutable = __webpack_require__("../node_modules/immutable/dist/immutable.js");

var _reduxActions = __webpack_require__("../node_modules/redux-actions/es/index.js");

var _runtimeConfig = __webpack_require__("./runtimeConfig.json");

var _runtimeConfig2 = _interopRequireDefault(_runtimeConfig);

var _authentication = __webpack_require__("./features/authentication/index.js");

var _constants = __webpack_require__("./redux/constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function loadInitialState() {
  var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _runtimeConfig2.default;

  var baseState = {
    currentPageConfigKey: null
  };
  if (!source.page_configs) {
    console.error('CONFIG ERROR: no `page_configs` key found in runtime configuration');
    return (0, _immutable.fromJS)(baseState);
  }
  return (0, _immutable.fromJS)(_extends({}, baseState, source.page_configs));
}

function resetPageConfig() {
  return loadInitialState();
}

function setCurrentPageConfigKeyHandler(state, _ref) {
  var payload = _ref.payload;

  return state.set('currentPageConfigKey', payload || null);
}

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _authentication.LOGOUT, resetPageConfig), _defineProperty(_handleActions, _constants.SET_CURRENT_PAGE_CONFIG_KEY, setCurrentPageConfigKeyHandler), _handleActions), loadInitialState());

/***/ }),

/***/ "./redux/pageConfigs/selectors.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeGetPageConfigByKey = exports.getPageConfigByKey = exports.currentPageConfigSelector = exports.currentPageConfigKeySelector = exports.pageConfigStoreSelector = undefined;

var _immutable = __webpack_require__("../node_modules/immutable/dist/immutable.js");

var _reselect = __webpack_require__("../node_modules/reselect/lib/index.js");

var pageConfigStoreSelector = exports.pageConfigStoreSelector = function pageConfigStoreSelector(state) {
  return state.get('pageConfigs');
};

var currentPageConfigKeySelector = exports.currentPageConfigKeySelector = (0, _reselect.createSelector)(pageConfigStoreSelector, function (pageConfigStore) {
  return pageConfigStore.get('currentPageConfigKey');
});

var currentPageConfigSelector = exports.currentPageConfigSelector = (0, _reselect.createSelector)(pageConfigStoreSelector, currentPageConfigKeySelector, function (pageConfigStore, currentPageConfigKey) {
  return currentPageConfigKey && pageConfigStore.get(currentPageConfigKey) || (0, _immutable.Map)();
});

var getPageConfigByKey = exports.getPageConfigByKey = function getPageConfigByKey(state, configKey) {
  return pageConfigStoreSelector(state).get(configKey) || (0, _immutable.Map)();
};

var makeGetPageConfigByKey = exports.makeGetPageConfigByKey = function makeGetPageConfigByKey() {
  return (0, _reselect.createSelector)(getPageConfigByKey, function (pageConfig) {
    return pageConfig;
  });
};

/***/ }),

/***/ "./redux/schemas.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.serviceRequestsSchema = exports.serviceRequestSchema = exports.casesSchema = exports.caseSchema = exports.serviceProvidersSchema = exports.serviceProviderSchema = exports.assetsSchema = exports.assetSchema = undefined;

var _normalizr = __webpack_require__("../node_modules/normalizr/dist/src/index.js");

/* ---------------------- Asset ------------------------ */
var assetSchema = exports.assetSchema = new _normalizr.schema.Entity('asset');
var assetsSchema = exports.assetsSchema = [assetSchema];

/* ---------------------- Service Provider ------------------------ */
var serviceProviderSchema = exports.serviceProviderSchema = new _normalizr.schema.Entity('serviceProvider');
var serviceProvidersSchema = exports.serviceProvidersSchema = [serviceProviderSchema];

/* ---------------------- Case ------------------------ */
var caseSchema = exports.caseSchema = new _normalizr.schema.Entity('case', {
  serviceProvider: serviceProviderSchema,
  asset: assetSchema
});
var casesSchema = exports.casesSchema = [caseSchema];

/* ---------------------- Service Request ------------------------ */
var serviceRequestSchema = exports.serviceRequestSchema = new _normalizr.schema.Entity('serviceRequest', {
  asset: assetSchema
});
var serviceRequestsSchema = exports.serviceRequestsSchema = [serviceRequestSchema];

/***/ }),

/***/ "./redux/serviceProviders/actions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearServiceProviders = exports.loadServiceProviders = exports.addOrUpdateServiceProviders = undefined;

var _reduxActions = __webpack_require__("../node_modules/redux-actions/es/index.js");

var _reduxFlightControl = __webpack_require__("../node_modules/redux-flight-control/build/index.js");

var _api = __webpack_require__("./redux/serviceProviders/api.js");

var _constants = __webpack_require__("./redux/constants.js");

// redux-actions allows us to create very versatile action creators in a single line.
var addOrUpdateServiceProviders = exports.addOrUpdateServiceProviders = (0, _reduxActions.createAction)(_constants.ADD_OR_UPDATE_SERVICE_PROVIDERS);

var loadServiceProviders = exports.loadServiceProviders = (0, _reduxFlightControl.createRequestAction)(_constants.LOAD_SERVICE_PROVIDERS, _api.getServiceProviders);

var clearServiceProviders = exports.clearServiceProviders = (0, _reduxActions.createAction)(_constants.CLEAR_SERVICE_PROVIDERS);

/***/ }),

/***/ "./redux/serviceProviders/api.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getServiceProviders = getServiceProviders;

var _apiEndpoints = __webpack_require__("./apiEndpoints.js");

var _apiEndpoints2 = _interopRequireDefault(_apiEndpoints);

var _fetch = __webpack_require__("./utils/fetch.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable import/prefer-default-export */
function getServiceProviders(query) {
  return (0, _fetch.get)(_apiEndpoints2.default.serviceProviders(), { query: query });
}

/***/ }),

/***/ "./redux/serviceProviders/reducer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = undefined;

var _handleActions;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _immutable = __webpack_require__("../node_modules/immutable/dist/immutable.js");

var _reduxActions = __webpack_require__("../node_modules/redux-actions/es/index.js");

var _authentication = __webpack_require__("./features/authentication/index.js");

var _constants = __webpack_require__("./redux/constants.js");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = exports.initialState = (0, _immutable.fromJS)({
  responseIds: (0, _immutable.OrderedSet)(),
  byId: {}
});

function updateFromCasesHandler(state, action) {
  var _action$payload$entit = action.payload.entities;
  _action$payload$entit = _action$payload$entit === undefined ? {} : _action$payload$entit;
  var _action$payload$entit2 = _action$payload$entit.serviceProvider,
      newServiceProviders = _action$payload$entit2 === undefined ? {} : _action$payload$entit2;


  var currentById = state.get('byId');
  var newById = currentById.merge(currentById, _extends({}, newServiceProviders));
  return state.set('byId', newById);
}

function resetState(state) {
  return state.set('responseIds', (0, _immutable.OrderedSet)()).set('byId', (0, _immutable.Map)());
}

function addOrUpdateServiceProvidersHandler(state, action) {
  var _action$payload = action.payload,
      _action$payload$entit3 = _action$payload.entities;
  _action$payload$entit3 = _action$payload$entit3 === undefined ? {} : _action$payload$entit3;
  var _action$payload$entit4 = _action$payload$entit3.serviceProvider,
      newServiceProviders = _action$payload$entit4 === undefined ? {} : _action$payload$entit4,
      _action$payload$resul = _action$payload.result,
      result = _action$payload$resul === undefined ? [] : _action$payload$resul;

  var currentAllIds = state.get('responseIds');
  var newAllIds = currentAllIds.concat(result);

  var currentById = state.get('byId');
  var newById = currentById.merge(currentById, _extends({}, newServiceProviders));

  return state.set('responseIds', newAllIds).set('byId', newById);
}

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _constants.ADD_OR_UPDATE_SERVICE_PROVIDERS, addOrUpdateServiceProvidersHandler), _defineProperty(_handleActions, (0, _reduxActions.combineActions)(_constants.ADD_OR_UPDATE_CASES, _constants.ADD_OR_UPDATE_CURRENT_CASE), updateFromCasesHandler), _defineProperty(_handleActions, (0, _reduxActions.combineActions)(_constants.CLEAR_SERVICE_PROVIDERS, _constants.RESET_FAVORITES, _authentication.LOGOUT), resetState), _handleActions), initialState);

/***/ }),

/***/ "./redux/serviceProviders/sagas.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadServiceProvidersWatcher = loadServiceProvidersWatcher;

var _normalizr = __webpack_require__("../node_modules/normalizr/dist/src/index.js");

var _effects = __webpack_require__("../node_modules/redux-saga/es/effects.js");

var _schemas = __webpack_require__("./redux/schemas.js");

var _constants = __webpack_require__("./redux/constants.js");

var _actions = __webpack_require__("./redux/serviceProviders/actions.js");

var _marked = /*#__PURE__*/regeneratorRuntime.mark(loadServiceProvidersWorker),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(loadServiceProvidersWatcher);

function loadServiceProvidersWorker(_ref) {
  var response = _ref.payload;
  var normalizedData;
  return regeneratorRuntime.wrap(function loadServiceProvidersWorker$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.call)(_normalizr.normalize, response.body, _schemas.serviceProvidersSchema);

        case 2:
          normalizedData = _context.sent;
          _context.next = 5;
          return (0, _effects.put)((0, _actions.addOrUpdateServiceProviders)(normalizedData));

        case 5:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

// watcher sagas

function loadServiceProvidersWatcher() {
  return regeneratorRuntime.wrap(function loadServiceProvidersWatcher$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeLatest)(_constants.LOAD_SERVICE_PROVIDERS, loadServiceProvidersWorker);

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

// export all of the sagas.
exports.default = [loadServiceProvidersWatcher()];

/***/ }),

/***/ "./redux/serviceProviders/selectors.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.serviceProvidersSelector = exports.makeGetServiceProviderById = exports.getServiceProviderById = exports.serviceProviderStoreSelector = exports.loadServiceProvidersPendingSelector = exports.loadServiceProvidersErrorSelector = undefined;

var _immutable = __webpack_require__("../node_modules/immutable/dist/immutable.js");

var _reselect = __webpack_require__("../node_modules/reselect/lib/index.js");

var _reduxFlightControl = __webpack_require__("../node_modules/redux-flight-control/build/index.js");

var _constants = __webpack_require__("./redux/constants.js");

/* --------------------------- REQUEST SELECTORS --------------------------- */

/* --------------------------- LOAD_SERVICE_PROVIDERS --------------------------- */

var loadServiceProvidersErrorSelector = exports.loadServiceProvidersErrorSelector = (0, _reduxFlightControl.createFailedRequestSelectorFor)(_constants.LOAD_SERVICE_PROVIDERS);

var loadServiceProvidersPendingSelector = exports.loadServiceProvidersPendingSelector = (0, _reduxFlightControl.createHasActiveRequestSelectorFor)(_constants.LOAD_SERVICE_PROVIDERS);

/* --------------------------- SERVICE PROVIDER STORE SELECTORS --------------------------- */

var serviceProviderStoreSelector = exports.serviceProviderStoreSelector = function serviceProviderStoreSelector(state) {
  return state.get('serviceProviders');
};

var getServiceProviderById = exports.getServiceProviderById = function getServiceProviderById(state, serviceProviderId) {
  return serviceProviderStoreSelector(state).getIn(['byId', serviceProviderId]) || (0, _immutable.Map)();
};

var makeGetServiceProviderById = exports.makeGetServiceProviderById = function makeGetServiceProviderById() {
  return (0, _reselect.createSelector)(getServiceProviderById, function (serviceProvider) {
    return serviceProvider;
  });
};

var serviceProvidersSelector = exports.serviceProvidersSelector = (0, _reselect.createSelector)(serviceProviderStoreSelector, function (serviceProvidersStore) {
  return serviceProvidersStore.get('responseIds').map(function (id) {
    return serviceProvidersStore.getIn(['byId', id]);
  }).toList();
});

/***/ }),

/***/ "./redux/serviceRequests/actions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setCurrentServiceRequest = exports.loadServiceRequests = exports.loadServiceRequest = exports.clearServiceRequests = exports.createServiceRequest = exports.cancelServiceRequest = exports.addOrUpdateServiceRequests = exports.addOrUpdateCurrentServiceRequest = undefined;

var _reduxApiActions = __webpack_require__("./utils/redux-api-actions.js");

var _reduxActions = __webpack_require__("../node_modules/redux-actions/es/index.js");

var _reduxFlightControl = __webpack_require__("../node_modules/redux-flight-control/build/index.js");

var _api = __webpack_require__("./redux/serviceRequests/api.js");

var _constants = __webpack_require__("./redux/constants.js");

// redux-actions allows us to create very versatile action creators in a single line.
var addOrUpdateCurrentServiceRequest = exports.addOrUpdateCurrentServiceRequest = (0, _reduxActions.createAction)(_constants.ADD_OR_UPDATE_CURRENT_SERVICE_REQUEST);

var addOrUpdateServiceRequests = exports.addOrUpdateServiceRequests = (0, _reduxActions.createAction)(_constants.ADD_OR_UPDATE_SERVICE_REQUESTS);

var cancelServiceRequest = exports.cancelServiceRequest = (0, _reduxFlightControl.createRequestAction)(_constants.CANCEL_SERVICE_REQUEST, _api.patchServiceRequest);

var createServiceRequest = exports.createServiceRequest = (0, _reduxFlightControl.createRequestAction)(_constants.CREATE_SERVICE_REQUEST, _api.postServiceRequest);

var clearServiceRequests = exports.clearServiceRequests = (0, _reduxActions.createAction)(_constants.RESET_SERVICE_REQUESTS_FAVORITES);

var loadServiceRequest = exports.loadServiceRequest = (0, _reduxFlightControl.createRequestAction)(_constants.LOAD_SERVICE_REQUEST, _api.getServiceRequest);

var loadServiceRequests = exports.loadServiceRequests = (0, _reduxApiActions.createApiAction)([_constants.LOAD_SERVICE_REQUESTS_REQUEST, _constants.LOAD_SERVICE_REQUESTS_SUCCESS, _constants.LOAD_SERVICE_REQUESTS_FAILURE], _api.getServiceRequests);

var setCurrentServiceRequest = exports.setCurrentServiceRequest = (0, _reduxActions.createAction)(_constants.SET_CURRENT_SERVICE_REQUEST);

/***/ }),

/***/ "./redux/serviceRequests/api.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getServiceRequest = getServiceRequest;
exports.getServiceRequests = getServiceRequests;
exports.patchServiceRequest = patchServiceRequest;
exports.postServiceRequest = postServiceRequest;

var _apiEndpoints = __webpack_require__("./apiEndpoints.js");

var _apiEndpoints2 = _interopRequireDefault(_apiEndpoints);

var _fetch = __webpack_require__("./utils/fetch.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getServiceRequest(_ref) {
  var serviceRequestId = _ref.serviceRequestId;

  return (0, _fetch.get)(_apiEndpoints2.default.serviceRequest({ serviceRequestId: serviceRequestId }));
}

function getServiceRequests(query) {
  return (0, _fetch.get)(_apiEndpoints2.default.serviceRequests(), { query: query });
}

function patchServiceRequest(_ref2) {
  var serviceRequestId = _ref2.serviceRequestId;

  return (0, _fetch.patch)(_apiEndpoints2.default.serviceRequest({ serviceRequestId: serviceRequestId }));
}

function postServiceRequest(requestBody) {
  return (0, _fetch.post)(_apiEndpoints2.default.serviceRequests(), { requestBody: requestBody });
}

/***/ }),

/***/ "./redux/serviceRequests/reducer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = undefined;

var _handleActions;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _immutable = __webpack_require__("../node_modules/immutable/dist/immutable.js");

var _reduxActions = __webpack_require__("../node_modules/redux-actions/es/index.js");

var _authentication = __webpack_require__("./features/authentication/index.js");

var _constants = __webpack_require__("./redux/constants.js");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = exports.initialState = (0, _immutable.fromJS)({
  responseIds: (0, _immutable.OrderedSet)(),
  byId: {},
  currentServiceRequestId: '',
  requesting: false,
  error: {}
});

function addOrUpdateServiceRequestsHandler(state, action) {
  var _action$payload = action.payload,
      _action$payload$entit = _action$payload.entities;
  _action$payload$entit = _action$payload$entit === undefined ? {} : _action$payload$entit;
  var _action$payload$entit2 = _action$payload$entit.serviceRequest,
      newServiceRequests = _action$payload$entit2 === undefined ? {} : _action$payload$entit2,
      _action$payload$resul = _action$payload.result,
      result = _action$payload$resul === undefined ? [] : _action$payload$resul;


  var currentAllIds = state.get('responseIds');
  var newAllIds = currentAllIds.concat(result);

  var currentById = state.get('byId');
  var newById = currentById.merge(currentById, _extends({}, newServiceRequests));

  return state.set('responseIds', newAllIds).set('byId', newById);
}

function addOrUpdateCurrentServiceRequestHandler(state, action) {
  var _action$payload$entit3 = action.payload.entities;
  _action$payload$entit3 = _action$payload$entit3 === undefined ? {} : _action$payload$entit3;
  var _action$payload$entit4 = _action$payload$entit3.serviceRequest,
      newServiceRequests = _action$payload$entit4 === undefined ? {} : _action$payload$entit4;

  var serviceRequestId = Object.keys(newServiceRequests)[0];

  var currentServiceRequestInfo = state.getIn(['byId', serviceRequestId]) || (0, _immutable.Map)();
  var newServiceRequestInfo = currentServiceRequestInfo.merge(currentServiceRequestInfo, newServiceRequests[serviceRequestId]);

  return state.update('responseIds', function (orderedSet) {
    return orderedSet.add(serviceRequestId).filter(function (id) {
      return !!id;
    });
  }).update('byId', function (map) {
    return map.set(serviceRequestId, newServiceRequestInfo).filter(function (val, key) {
      return !!key;
    });
  }).set('currentServiceRequestId', serviceRequestId).set('requesting', false);
}

function loadServiceRequestsRequestHandler(state) {
  return state.set('requesting', true).set('error', (0, _immutable.Map)());
}

function loadServiceRequestsSuccessHandler(state) {
  return state.set('requesting', false).set('error', (0, _immutable.Map)());
}

function loadServiceRequestsFailureHandler(state, action) {
  return state.set('requesting', false).set('error', action.payload.response);
}

function resetState(state) {
  return state.set('responseIds', (0, _immutable.OrderedSet)()).set('byId', (0, _immutable.Map)()).set('requesting', false);
}

function setCurrentServiceRequestHandler(state, action) {
  return state.set('currentServiceRequestId', action.payload).set('error', (0, _immutable.Map)());
}

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _constants.ADD_OR_UPDATE_CURRENT_SERVICE_REQUEST, addOrUpdateCurrentServiceRequestHandler), _defineProperty(_handleActions, _constants.ADD_OR_UPDATE_SERVICE_REQUESTS, addOrUpdateServiceRequestsHandler), _defineProperty(_handleActions, (0, _reduxActions.combineActions)(_constants.RESET_SERVICE_REQUESTS_FAVORITES, _authentication.LOGOUT), resetState), _defineProperty(_handleActions, _constants.LOAD_SERVICE_REQUESTS_REQUEST, loadServiceRequestsRequestHandler), _defineProperty(_handleActions, _constants.LOAD_SERVICE_REQUESTS_SUCCESS, loadServiceRequestsSuccessHandler), _defineProperty(_handleActions, _constants.LOAD_SERVICE_REQUESTS_FAILURE, loadServiceRequestsFailureHandler), _defineProperty(_handleActions, _constants.SET_CURRENT_SERVICE_REQUEST, setCurrentServiceRequestHandler), _handleActions), initialState);

/***/ }),

/***/ "./redux/serviceRequests/sagas.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createServiceRequestWatcher = createServiceRequestWatcher;
exports.loadServiceRequestWatcher = loadServiceRequestWatcher;
exports.loadServiceRequestsSuccessWatcher = loadServiceRequestsSuccessWatcher;

var _normalizr = __webpack_require__("../node_modules/normalizr/dist/src/index.js");

var _effects = __webpack_require__("../node_modules/redux-saga/es/effects.js");

var _actions = __webpack_require__("./redux/app/actions.js");

var _schemas = __webpack_require__("./redux/schemas.js");

var _constants = __webpack_require__("./redux/constants.js");

var _actions2 = __webpack_require__("./redux/serviceRequests/actions.js");

var _marked = /*#__PURE__*/regeneratorRuntime.mark(createServiceRequestWorker),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(loadServiceRequestWorker),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(loadServiceRequestsSuccessWorker),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(createServiceRequestWatcher),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(loadServiceRequestWatcher),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(loadServiceRequestsSuccessWatcher);

// worker sagas
function createServiceRequestWorker(_ref) {
  var response = _ref.payload;
  return regeneratorRuntime.wrap(function createServiceRequestWorker$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)((0, _actions2.loadServiceRequest)({ serviceRequestId: response.body.id }));

        case 2:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function loadServiceRequestWorker(_ref2) {
  var response = _ref2.payload;
  var normalizedData;
  return regeneratorRuntime.wrap(function loadServiceRequestWorker$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.call)(_normalizr.normalize, response.body, _schemas.serviceRequestSchema);

        case 2:
          normalizedData = _context2.sent;
          _context2.next = 5;
          return (0, _effects.put)((0, _actions2.addOrUpdateCurrentServiceRequest)(normalizedData));

        case 5:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function loadServiceRequestsSuccessWorker(_ref3) {
  var response = _ref3.payload;
  var normalizedData, pagination;
  return regeneratorRuntime.wrap(function loadServiceRequestsSuccessWorker$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.call)(_normalizr.normalize, response.body, _schemas.serviceRequestsSchema);

        case 2:
          normalizedData = _context3.sent;
          pagination = {
            latestPage: response.headers.get('x-page'),
            perPage: response.headers.get('x-per-page'),
            totalCount: response.headers.get('x-total-count'),
            totalPages: response.headers.get('x-total-pages')
          };
          _context3.next = 6;
          return (0, _effects.put)((0, _actions2.addOrUpdateServiceRequests)(normalizedData));

        case 6:
          _context3.next = 8;
          return (0, _effects.put)((0, _actions.setFavoritePagination)(pagination));

        case 8:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

// watcher sagas
function createServiceRequestWatcher() {
  return regeneratorRuntime.wrap(function createServiceRequestWatcher$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.takeLatest)(_constants.CREATE_SERVICE_REQUEST, createServiceRequestWorker);

        case 2:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function loadServiceRequestWatcher() {
  return regeneratorRuntime.wrap(function loadServiceRequestWatcher$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.takeLatest)(_constants.LOAD_SERVICE_REQUEST, loadServiceRequestWorker);

        case 2:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function loadServiceRequestsSuccessWatcher() {
  return regeneratorRuntime.wrap(function loadServiceRequestsSuccessWatcher$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.takeLatest)(_constants.LOAD_SERVICE_REQUESTS_SUCCESS, loadServiceRequestsSuccessWorker);

        case 2:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

// export all of the sagas.
exports.default = [createServiceRequestWatcher(), loadServiceRequestWatcher(), loadServiceRequestsSuccessWatcher()];

/***/ }),

/***/ "./redux/serviceRequests/selectors.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.serviceRequestsSelector = exports.serviceRequestsRequestingSelector = exports.currentServReqServProvSelector = exports.currentServiceRequestAssetSelector = exports.currentServiceRequestSelector = exports.loadServiceRequestErrorSelector = exports.loadServiceRequestPendingSelector = exports.createServiceRequestErrorSelector = exports.createServiceRequestPendingSelector = exports.cancelServiceRequestErrorSelector = exports.cancelServiceRequestPendingSelector = undefined;

var _immutable = __webpack_require__("../node_modules/immutable/dist/immutable.js");

var _reselect = __webpack_require__("../node_modules/reselect/lib/index.js");

var _reduxFlightControl = __webpack_require__("../node_modules/redux-flight-control/build/index.js");

var _selectors = __webpack_require__("./redux/assets/selectors.js");

var _constants = __webpack_require__("./redux/constants.js");

/* --------------------------- REQUEST SELECTORS --------------------------- */

/* --------------------------- CANCEL_SERVICE_REQUEST --------------------------- */

var cancelServiceRequestPendingSelector = exports.cancelServiceRequestPendingSelector = (0, _reduxFlightControl.createHasActiveRequestSelectorFor)(_constants.CANCEL_SERVICE_REQUEST);

var cancelServiceRequestErrorSelector = exports.cancelServiceRequestErrorSelector = (0, _reduxFlightControl.createFailedRequestSelectorFor)(_constants.CANCEL_SERVICE_REQUEST);

/* --------------------------- CREATE_SERVICE_REQUEST --------------------------- */

var createServiceRequestPendingSelector = exports.createServiceRequestPendingSelector = (0, _reduxFlightControl.createHasActiveRequestSelectorFor)(_constants.CREATE_SERVICE_REQUEST);

var createServiceRequestErrorSelector = exports.createServiceRequestErrorSelector = (0, _reduxFlightControl.createFailedRequestSelectorFor)(_constants.CREATE_SERVICE_REQUEST);

/* --------------------------- LOAD_SERVICE_REQUEST --------------------------- */

var loadServiceRequestPendingSelector = exports.loadServiceRequestPendingSelector = (0, _reduxFlightControl.createHasActiveRequestSelectorFor)(_constants.LOAD_SERVICE_REQUEST);

var loadServiceRequestErrorSelector = exports.loadServiceRequestErrorSelector = (0, _reduxFlightControl.createFailedRequestSelectorFor)(_constants.LOAD_SERVICE_REQUEST);

/* --------------------------- SERVICE REQUEST STORE SELECTORS --------------------------- */

// For convenience, extract the serviceRequests section of the store.
var serviceRequestsStoreSelector = function serviceRequestsStoreSelector(state) {
  return state.get('serviceRequests');
};

var currentServiceRequestIdSelector = (0, _reselect.createSelector)(serviceRequestsStoreSelector, function (serviceRequestStore) {
  return serviceRequestStore.get('currentServiceRequestId');
});

var currentServiceRequestSelector = exports.currentServiceRequestSelector = (0, _reselect.createSelector)(serviceRequestsStoreSelector, currentServiceRequestIdSelector, function (serviceRequestsStore, currentServiceRequestId) {
  return currentServiceRequestId && serviceRequestsStore.getIn(['byId', currentServiceRequestId]) || (0, _immutable.Map)();
});

var currentServiceRequestAssetSelector = exports.currentServiceRequestAssetSelector = (0, _reselect.createSelector)(currentServiceRequestSelector, _selectors.assetsStoreSelector, function (currentServiceRequest, assetsStore) {
  return currentServiceRequest && assetsStore.getIn(['byId', currentServiceRequest.get('asset')]) || (0, _immutable.Map)();
});

var currentServReqServProvSelector = exports.currentServReqServProvSelector = (0, _reselect.createSelector)(currentServiceRequestSelector, function (currentServiceRequest) {
  return currentServiceRequest && currentServiceRequest.get('serviceProvider') || (0, _immutable.Map)();
});

var serviceRequestsRequestingSelector = exports.serviceRequestsRequestingSelector = (0, _reselect.createSelector)(serviceRequestsStoreSelector, function (serviceRequestsStore) {
  return serviceRequestsStore.get('requesting');
});

// When all of the cases are required we convert serviceRequests.byId into an immutable list.
var serviceRequestsSelector = exports.serviceRequestsSelector = (0, _reselect.createSelector)(serviceRequestsStoreSelector, function (serviceRequestsStore) {
  return serviceRequestsStore.get('responseIds').map(function (id) {
    return serviceRequestsStore.getIn(['byId', id]);
  }).toList();
});

/***/ }),

/***/ "./redux/ui/actions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetHiddenWidgets = exports.addHiddenWidget = exports.updateScrollToUnreadNote = exports.setServiceRequestsView = exports.setLeftNavExpanded = exports.setComponentExpanded = exports.setCasesView = exports.loadBrandValues = exports.setAssetsView = exports.requestFullScreenMode = exports.requestPrintPage = exports.handleActionBarItemClick = exports.expandLeftNavParent = undefined;

var _reduxActions = __webpack_require__("../node_modules/redux-actions/es/index.js");

var _reduxFlightControl = __webpack_require__("../node_modules/redux-flight-control/build/index.js");

var _api = __webpack_require__("./redux/ui/api.js");

var _constants = __webpack_require__("./redux/constants.js");

var expandLeftNavParent = exports.expandLeftNavParent = (0, _reduxActions.createAction)(_constants.EXPAND_LEFTNAV_PARENT);

var handleActionBarItemClick = exports.handleActionBarItemClick = (0, _reduxActions.createAction)(_constants.HANDLE_ACTION_BAR_ITEM_CLICK);

var requestPrintPage = exports.requestPrintPage = (0, _reduxActions.createAction)(_constants.REQUEST_PRINT_PAGE);

var requestFullScreenMode = exports.requestFullScreenMode = (0, _reduxActions.createAction)(_constants.REQUEST_FULL_SCREEN_MODE);

var setAssetsView = exports.setAssetsView = (0, _reduxActions.createAction)(_constants.SET_ASSETS_VIEW);

var loadBrandValues = exports.loadBrandValues = (0, _reduxFlightControl.createRequestAction)(_constants.SET_BRAND_VALUES, _api.getBrandValues);

var setCasesView = exports.setCasesView = (0, _reduxActions.createAction)(_constants.SET_CASES_VIEW);

var setComponentExpanded = exports.setComponentExpanded = (0, _reduxActions.createAction)(_constants.SET_COMPONENT_EXPANDED);

var setLeftNavExpanded = exports.setLeftNavExpanded = (0, _reduxActions.createAction)(_constants.SET_LEFTNAV_EXPANDED);

var setServiceRequestsView = exports.setServiceRequestsView = (0, _reduxActions.createAction)(_constants.SET_SERVICE_REQUESTS_VIEW);

var updateScrollToUnreadNote = exports.updateScrollToUnreadNote = (0, _reduxActions.createAction)(_constants.UPDATE_SCROLL_TO_UNREAD_NOTE);

var addHiddenWidget = exports.addHiddenWidget = (0, _reduxActions.createAction)(_constants.ADD_HIDDEN_WIDGET);

var resetHiddenWidgets = exports.resetHiddenWidgets = (0, _reduxActions.createAction)(_constants.RESET_HIDDEN_WIDGETS);

/***/ }),

/***/ "./redux/ui/api.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.getBrandValues = getBrandValues;

var _michelin = __webpack_require__("./brands/logos/michelin.png");

var _michelin2 = _interopRequireDefault(_michelin);

var _decisiv = __webpack_require__("./brands/logos/decisiv.png");

var _decisiv2 = _interopRequireDefault(_decisiv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TEMP_BRAND_VALUES_MAP = {
  michelin: {
    colors: {
      brand: {
        hover: '#1095F9',
        primary: '#27509B',
        secondary: '#FCE500',
        tertiary: '#00205B'
      }
    },
    logo: _michelin2.default
  },
  decisiv: {
    logo: _decisiv2.default
  }
};

// eslint-disable-next-line import/prefer-default-export
function getBrandValues(_ref) {
  var brand = _ref.brand;

  return new Promise(function (resolve) {
    var brandValues = TEMP_BRAND_VALUES_MAP[brand] || {};
    setTimeout(function () {
      return resolve({
        response: {
          body: _extends({}, brandValues)
        }
      });
    }, 16);
  });
}

/***/ }),

/***/ "./redux/ui/reducer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateScrollToUnreadNote = exports.resetHiddenWidgets = exports.addHiddenWidget = exports.setServiceRequestsView = exports.setLeftNavExpanded = exports.setComponentExpanded = exports.setCasesView = exports.setBrandValues = exports.setAssetsView = exports.handleRequestPrintPage = exports.handleRequestFullScreenMode = exports.handleActionBarItemClicked = exports.expandLeftNavParent = undefined;

var _handleActions;

exports.loadInitialState = loadInitialState;

var _immutable = __webpack_require__("../node_modules/immutable/dist/immutable.js");

var _reduxActions = __webpack_require__("../node_modules/redux-actions/es/index.js");

var _url = __webpack_require__("./utils/url.js");

var _constants = __webpack_require__("./redux/constants.js");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultAppState = {
  // `actionBarItemClicked` has button id and dropdown item id for clicked button/dropdown
  actionBarItemClicked: {},

  // it indicates the users preference for rendering the assets on the favorites page
  assetsView: 'cards',

  // it indicates the users preference for rendering the cases on the favorites page
  casesView: 'cards',

  // `componentsExpanded` has all the statuses of registered components if they are expanded or not
  componentsExpanded: {},

  // `leftNavExpanded` is true if the overall left nav is expanded, false if collapsed
  leftNavExpanded: true,

  // `leftNavExpandedParents` is a Set of menu keys indicating which parent menus are
  // currently expanded
  leftNavExpandedParents: [],
  // list of widgets currently hidden on the details page
  hiddenWidgets: [],

  // `requestPrintPage` is true when the user requests print page open.
  requestPrintPage: false,

  // `requestFullScreenMode` is true when the user has opted to view the body in full screen.
  requestFullScreenMode: false,

  // it indicates the users preference for rendering the assets on the favorites page
  serviceRequestsView: 'cards',

  // 'scrollToUnreadNote' indicates if scrolling to unread note is needed
  scrollToUnreadNote: false
};

/**
 * Attempt to load the initial app UI state from the localStorage.  Note that this is
 * purposefully using localStorage and not the memoryDB proxy because...
 *  * memoryDB is not available at app bootstrap
 *  * the only reason for this loadInitialState to exist is to re-hydrate the persisted
 *    app UI state; memoryDB is not persisted
 *  * if localStorage is not available (e.g. Safari Private Browsing) then getItem just
 *    returns null, so the defaults above will be used instead, and that's fine.
 */
function loadInitialState() {
  var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : localStorage;

  var appState = source && source.getItem && source.getItem(_constants.LOCALSTORAGE_APP_STATE_KEY);
  if (appState) {
    try {
      appState = JSON.parse(appState);

      // iterate over the default appstate, and add the default key/value if not currently present.
      Object.keys(defaultAppState).forEach(function (k) {
        if (appState[k] === undefined) {
          appState[k] = defaultAppState[k];
        }
      });
    } catch (e) {
      console.error('error parsing ' + _constants.LOCALSTORAGE_APP_STATE_KEY + ' value from localStorage:', e);
      appState = null;
    }
  }

  if (!appState) {
    appState = defaultAppState;
  }

  var brand = (0, _url.getBrandFromUrl)();
  var brandValues = brand === appState.brand ? appState.brandValues : null;

  return (0, _immutable.Map)({
    actionBarItemClicked: (0, _immutable.Map)({
      buttonId: '',
      dropdownItemId: '',
      time: null
    }),
    assetsView: appState.assetsView,
    brand: brand,
    brandValues: brandValues,
    casesView: appState.casesView,
    componentsExpanded: (0, _immutable.Map)(appState.componentsExpanded),
    requestPrintPage: appState.requestPrintPage,
    requestFullScreenMode: appState.requestFullScreenMode,
    leftNavExpanded: appState.leftNavExpanded,
    leftNavExpandedParents: (0, _immutable.Set)(appState.leftNavExpandedParents),
    hiddenWidgets: (0, _immutable.Set)(appState.hiddenWidgets),
    serviceRequestsView: appState.serviceRequestsView
  });
}

var expandLeftNavParent = exports.expandLeftNavParent = function expandLeftNavParent(state, _ref) {
  var _ref$payload = _ref.payload,
      key = _ref$payload.key,
      expanded = _ref$payload.expanded;

  var wasExpanded = state.get('leftNavExpandedParents');
  var isExpanded = expanded ? wasExpanded.add(key) : wasExpanded.delete(key);
  return state.set('leftNavExpandedParents', isExpanded);
};

var handleActionBarItemClicked = exports.handleActionBarItemClicked = function handleActionBarItemClicked(state, _ref2) {
  var _ref2$payload = _ref2.payload,
      buttonId = _ref2$payload.buttonId,
      dropdownItemId = _ref2$payload.dropdownItemId;
  return state.set('actionBarItemClicked', new _immutable.Map({ buttonId: buttonId, dropdownItemId: dropdownItemId, time: Date.now() }));
};

var handleRequestFullScreenMode = exports.handleRequestFullScreenMode = function handleRequestFullScreenMode(state, _ref3) {
  var payload = _ref3.payload;
  return state.set('requestFullScreenMode', payload || false);
};

var handleRequestPrintPage = exports.handleRequestPrintPage = function handleRequestPrintPage(state, _ref4) {
  var payload = _ref4.payload;
  return state.set('requestPrintPage', payload || false);
};

var setAssetsView = exports.setAssetsView = function setAssetsView(state, _ref5) {
  var _ref5$payload = _ref5.payload,
      assetsView = _ref5$payload === undefined ? defaultAppState.assetsView : _ref5$payload;
  return state.set('assetsView', assetsView);
};

var setBrandValues = exports.setBrandValues = function setBrandValues(state, _ref6) {
  var payload = _ref6.payload;
  return state.set('brandValues', payload.body);
};

var setCasesView = exports.setCasesView = function setCasesView(state, _ref7) {
  var _ref7$payload = _ref7.payload,
      casesView = _ref7$payload === undefined ? defaultAppState.casesView : _ref7$payload;
  return state.set('casesView', casesView);
};

var setComponentExpanded = exports.setComponentExpanded = function setComponentExpanded(state, _ref8) {
  var _ref8$payload = _ref8.payload,
      expandKey = _ref8$payload.expandKey,
      expanded = _ref8$payload.expanded;
  return state.updateIn(['componentsExpanded'], function (componentsExpanded) {
    return componentsExpanded.set(expandKey, expanded);
  });
};

var setLeftNavExpanded = exports.setLeftNavExpanded = function setLeftNavExpanded(state, _ref9) {
  var expanded = _ref9.payload;
  return state.set('leftNavExpanded', expanded);
};

var setServiceRequestsView = exports.setServiceRequestsView = function setServiceRequestsView(state, _ref10) {
  var _ref10$payload = _ref10.payload,
      serviceRequestsView = _ref10$payload === undefined ? defaultAppState.serviceRequestsView : _ref10$payload;
  return state.set('serviceRequestsView', serviceRequestsView);
};

var addHiddenWidget = exports.addHiddenWidget = function addHiddenWidget(state, _ref11) {
  var widget = _ref11.payload;

  var hiddenWidgets = state.get('hiddenWidgets');
  var newHiddenWidgets = hiddenWidgets.add(widget);
  return state.set('hiddenWidgets', newHiddenWidgets);
};

var resetHiddenWidgets = exports.resetHiddenWidgets = function resetHiddenWidgets(state) {
  return state.set('hiddenWidgets', (0, _immutable.Set)());
};

var updateScrollToUnreadNote = exports.updateScrollToUnreadNote = function updateScrollToUnreadNote(state, _ref12) {
  var bool = _ref12.payload;
  return state.set('scrollToUnreadNote', bool);
};

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _constants.EXPAND_LEFTNAV_PARENT, expandLeftNavParent), _defineProperty(_handleActions, _constants.HANDLE_ACTION_BAR_ITEM_CLICK, handleActionBarItemClicked), _defineProperty(_handleActions, _constants.REQUEST_PRINT_PAGE, handleRequestPrintPage), _defineProperty(_handleActions, _constants.REQUEST_FULL_SCREEN_MODE, handleRequestFullScreenMode), _defineProperty(_handleActions, _constants.SET_ASSETS_VIEW, setAssetsView), _defineProperty(_handleActions, _constants.SET_BRAND_VALUES, setBrandValues), _defineProperty(_handleActions, _constants.SET_CASES_VIEW, setCasesView), _defineProperty(_handleActions, _constants.SET_COMPONENT_EXPANDED, setComponentExpanded), _defineProperty(_handleActions, _constants.SET_LEFTNAV_EXPANDED, setLeftNavExpanded), _defineProperty(_handleActions, _constants.SET_SERVICE_REQUESTS_VIEW, setServiceRequestsView), _defineProperty(_handleActions, _constants.UPDATE_SCROLL_TO_UNREAD_NOTE, updateScrollToUnreadNote), _defineProperty(_handleActions, _constants.ADD_HIDDEN_WIDGET, addHiddenWidget), _defineProperty(_handleActions, _constants.RESET_HIDDEN_WIDGETS, resetHiddenWidgets), _handleActions), loadInitialState());

/***/ }),

/***/ "./redux/ui/sagas.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleActionBarItemClickWatcher = handleActionBarItemClickWatcher;

var _effects = __webpack_require__("../node_modules/redux-saga/es/effects.js");

var _actions = __webpack_require__("./redux/ui/actions.js");

var _constants = __webpack_require__("./redux/constants.js");

var _marked = /*#__PURE__*/regeneratorRuntime.mark(handleActionBarItemClickWorker),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(handleActionBarItemClickWatcher);

function handleActionBarItemClickWorker(_ref) {
  var payload = _ref.payload;
  return regeneratorRuntime.wrap(function handleActionBarItemClickWorker$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!(payload.buttonId === 'OPTIONS_BUTTON')) {
            _context.next = 10;
            break;
          }

          _context.t0 = payload.dropdownItemId;
          _context.next = _context.t0 === 'viewInFullScreenMode' ? 4 : _context.t0 === 'printPage' ? 7 : 10;
          break;

        case 4:
          _context.next = 6;
          return (0, _effects.put)((0, _actions.requestFullScreenMode)(true));

        case 6:
          return _context.abrupt('break', 10);

        case 7:
          _context.next = 9;
          return (0, _effects.put)((0, _actions.requestPrintPage)(true));

        case 9:
          return _context.abrupt('break', 10);

        case 10:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function handleActionBarItemClickWatcher() {
  return regeneratorRuntime.wrap(function handleActionBarItemClickWatcher$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeLatest)(_constants.HANDLE_ACTION_BAR_ITEM_CLICK, handleActionBarItemClickWorker);

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

exports.default = [handleActionBarItemClickWatcher()];

/***/ }),

/***/ "./redux/ui/selectors.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uiStoreSelector = exports.serviceRequestsViewSelector = exports.scrollToUnreadNoteSelector = exports.requestFullScreenModeSelector = exports.requestPrintPageSelector = exports.leftNavExpandedSelector = exports.leftNavExpandedParentsSelector = exports.hiddenWidgetsSelector = exports.componentsExpandedSelector = exports.casesViewSelector = exports.brandValuesSelector = exports.brandLogoSelector = exports.brandSelector = exports.assetsViewSelector = exports.actionBarItemClickedSelector = undefined;

var _immutable = __webpack_require__("../node_modules/immutable/dist/immutable.js");

var _reselect = __webpack_require__("../node_modules/reselect/lib/index.js");

// For convenience, extract the ui section of the store.
var uiStoreSelector = function uiStoreSelector(state) {
  return state.get('ui');
};

var actionBarItemClickedSelector = (0, _reselect.createSelector)(uiStoreSelector, function (uiStore) {
  return uiStore.get('actionBarItemClicked');
});

// determine the type of assets favorites view the user has set
var assetsViewSelector = (0, _reselect.createSelector)(uiStoreSelector, function (uiStore) {
  return uiStore.get('assetsView');
});

// get the brand of the current application
var brandSelector = (0, _reselect.createSelector)(uiStoreSelector, function (uiStore) {
  return uiStore.get('brand');
});

// get the brand specific values, like the top nav image and the brand colors
var brandValuesSelector = (0, _reselect.createSelector)(uiStoreSelector, function (uiStore) {
  return uiStore.get('brandValues') || (0, _immutable.Map)();
});

// get the brand logo of the current application
var brandLogoSelector = (0, _reselect.createSelector)(brandValuesSelector, function (brandValues) {
  return brandValues.logo;
});

// determine the type of cases favorites view the user has set
var casesViewSelector = (0, _reselect.createSelector)(uiStoreSelector, function (uiStore) {
  return uiStore.get('casesView');
});

// get all the statuses of components if they are expanded
var componentsExpandedSelector = (0, _reselect.createSelector)(uiStoreSelector, function (uiStore) {
  return uiStore.get('componentsExpanded');
});

var hiddenWidgetsSelector = (0, _reselect.createSelector)(uiStoreSelector, function (uiStore) {
  return uiStore.get('hiddenWidgets');
});

// determine if the application should be rendered in full screen mode
var requestFullScreenModeSelector = (0, _reselect.createSelector)(uiStoreSelector, function (uiStore) {
  return uiStore.get('requestFullScreenMode');
});

// determine if print page is requested
var requestPrintPageSelector = (0, _reselect.createSelector)(uiStoreSelector, function (uiStore) {
  return uiStore.get('requestPrintPage');
});

// determine which (if any) left nav parents are currently expanded
var leftNavExpandedParentsSelector = (0, _reselect.createSelector)(uiStoreSelector, function (uiStore) {
  return uiStore.get('leftNavExpandedParents');
});

// get the status of left nav panel if it is expanded.
var leftNavExpandedSelector = (0, _reselect.createSelector)(uiStoreSelector, function (uiStore) {
  return uiStore.get('leftNavExpanded');
});

// determine if scrolling to unread note is necessary
var scrollToUnreadNoteSelector = (0, _reselect.createSelector)(uiStoreSelector, function (uiStore) {
  return uiStore.get('scrollToUnreadNote');
});

// determine the type of serviceRequests favorites view the user has set
var serviceRequestsViewSelector = (0, _reselect.createSelector)(uiStoreSelector, function (uiStore) {
  return uiStore.get('serviceRequestsView');
});

exports.actionBarItemClickedSelector = actionBarItemClickedSelector;
exports.assetsViewSelector = assetsViewSelector;
exports.brandSelector = brandSelector;
exports.brandLogoSelector = brandLogoSelector;
exports.brandValuesSelector = brandValuesSelector;
exports.casesViewSelector = casesViewSelector;
exports.componentsExpandedSelector = componentsExpandedSelector;
exports.hiddenWidgetsSelector = hiddenWidgetsSelector;
exports.leftNavExpandedParentsSelector = leftNavExpandedParentsSelector;
exports.leftNavExpandedSelector = leftNavExpandedSelector;
exports.requestPrintPageSelector = requestPrintPageSelector;
exports.requestFullScreenModeSelector = requestFullScreenModeSelector;
exports.scrollToUnreadNoteSelector = scrollToUnreadNoteSelector;
exports.serviceRequestsViewSelector = serviceRequestsViewSelector;
exports.uiStoreSelector = uiStoreSelector;

/***/ }),

/***/ "./redux/ui/subscriber.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _constants = __webpack_require__("./redux/constants.js");

var _selectors = __webpack_require__("./redux/ui/selectors.js");

function addSubscriber(store) {
  function onStateChange() {
    if (memoryDB && memoryDB.setItem) {
      var appState = (0, _selectors.uiStoreSelector)(store.getState());
      var appStateAsString = JSON.stringify(appState);
      memoryDB.setItem(_constants.LOCALSTORAGE_APP_STATE_KEY, appStateAsString);
    }
  }

  return store.subscribe(onStateChange);
}

exports.default = addSubscriber;

/***/ }),

/***/ "./redux/user/actions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadUserProfile = undefined;

var _reduxFlightControl = __webpack_require__("../node_modules/redux-flight-control/build/index.js");

var _api = __webpack_require__("./redux/user/api.js");

var _constants = __webpack_require__("./redux/constants.js");

// eslint-disable-next-line import/prefer-default-export
var loadUserProfile = exports.loadUserProfile = (0, _reduxFlightControl.createRequestAction)(_constants.LOAD_USER_PROFILE, _api.getUserProfile);

/***/ }),

/***/ "./redux/user/api.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUserProfile = getUserProfile;

var _apiEndpoints = __webpack_require__("./apiEndpoints.js");

var _apiEndpoints2 = _interopRequireDefault(_apiEndpoints);

var _fetch = __webpack_require__("./utils/fetch.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line import/prefer-default-export
function getUserProfile() {
  return (0, _fetch.get)(_apiEndpoints2.default.profile());
}

/***/ }),

/***/ "./redux/user/reducer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = undefined;

var _immutable = __webpack_require__("../node_modules/immutable/dist/immutable.js");

var _reduxActions = __webpack_require__("../node_modules/redux-actions/es/index.js");

var _constants = __webpack_require__("./redux/constants.js");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = exports.initialState = (0, _immutable.fromJS)({
  isAuthorized: false,
  loginRequestError: false,
  profile: {}
});

function loadUserProfileHandler(state, action) {
  return state.set('profile', (0, _immutable.fromJS)(action.payload.body));
}

exports.default = (0, _reduxActions.handleActions)(_defineProperty({}, _constants.LOAD_USER_PROFILE, loadUserProfileHandler), initialState);

/***/ }),

/***/ "./redux/user/sagas.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadUserProfileWatcher = loadUserProfileWatcher;

var _effects = __webpack_require__("../node_modules/redux-saga/es/effects.js");

var _Pendo = __webpack_require__("./setup/Pendo.js");

var _authentication = __webpack_require__("./features/authentication/index.js");

var _constants = __webpack_require__("./redux/constants.js");

var _marked = /*#__PURE__*/regeneratorRuntime.mark(loadUserProfileWorker),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(loadUserProfileWatcher);

/* ------------------------------- worker sagas ------------------------------- */

function loadUserProfileWorker(_ref) {
  var payload = _ref.payload;
  var tenant;
  return regeneratorRuntime.wrap(function loadUserProfileWorker$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.select)(_authentication.currentTenantSelector);

        case 2:
          tenant = _context.sent;
          _context.next = 5;
          return (0, _effects.call)(_Pendo.initializePendo, payload.body, tenant);

        case 5:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

/* ------------------------------- watcher sagas ------------------------------- */

function loadUserProfileWatcher() {
  return regeneratorRuntime.wrap(function loadUserProfileWatcher$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeLatest)(_constants.LOAD_USER_PROFILE, loadUserProfileWorker);

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

// export all of the watcher sagas.
exports.default = [loadUserProfileWatcher()];

/***/ }),

/***/ "./redux/user/selectors.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usernameSelector = exports.userProfileSelector = exports.loadUserProfileErrorSelector = undefined;

var _reselect = __webpack_require__("../node_modules/reselect/lib/index.js");

var _reduxFlightControl = __webpack_require__("../node_modules/redux-flight-control/build/index.js");

var _constants = __webpack_require__("./redux/constants.js");

/* --------------------------- REQUEST SELECTORS --------------------------- */

/* --------------------------- LOAD_USER_PROFILE --------------------------- */

var loadUserProfileErrorSelector = exports.loadUserProfileErrorSelector = (0, _reduxFlightControl.createFailedRequestSelectorFor)(_constants.LOAD_USER_PROFILE);

/* --------------------------- USER STORE SELECTORS --------------------------- */

var userStoreSelector = function userStoreSelector(state) {
  return state.get('user');
};

var userProfileSelector = exports.userProfileSelector = (0, _reselect.createSelector)(userStoreSelector, function (userStore) {
  return userStore.get('profile');
});

var usernameSelector = exports.usernameSelector = (0, _reselect.createSelector)(userStoreSelector, function (userStore) {
  return userStore.get('username');
});

/***/ }),

/***/ "./redux/wizardConfigs/reducer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadInitialState = loadInitialState;

var _immutable = __webpack_require__("../node_modules/immutable/dist/immutable.js");

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _reduxActions = __webpack_require__("../node_modules/redux-actions/es/index.js");

var _runtimeConfig = __webpack_require__("./runtimeConfig.json");

var _runtimeConfig2 = _interopRequireDefault(_runtimeConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function loadInitialState() {
  var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _runtimeConfig2.default;

  if (!(0, _lodash.has)(source, 'wizard_configs')) {
    console.warn('Warning: no `wizard_configs` key found in runtime configuration');
    return (0, _immutable.fromJS)({});
  }
  return (0, _immutable.fromJS)(source.wizard_configs);
}

// eslint-disable-next-line import/no-unresolved
exports.default = (0, _reduxActions.handleActions)({}, loadInitialState());

/***/ }),

/***/ "./redux/wizardConfigs/selectors.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeGetWizardConfigByKey = exports.getWizardConfigByKey = exports.wizardConfigStoreSelector = undefined;

var _immutable = __webpack_require__("../node_modules/immutable/dist/immutable.js");

var _reselect = __webpack_require__("../node_modules/reselect/lib/index.js");

var wizardConfigStoreSelector = exports.wizardConfigStoreSelector = function wizardConfigStoreSelector(state) {
  return state.get('wizardConfigs');
};

var getWizardConfigByKey = exports.getWizardConfigByKey = function getWizardConfigByKey(state, configKey) {
  return wizardConfigStoreSelector(state).get(configKey) || (0, _immutable.Map)();
};

var makeGetWizardConfigByKey = exports.makeGetWizardConfigByKey = function makeGetWizardConfigByKey() {
  return (0, _reselect.createSelector)(getWizardConfigByKey, function (wizardConfig) {
    return wizardConfig;
  });
};

/***/ }),

/***/ "./runtimeConfig.json":
/***/ (function(module, exports) {

module.exports = {"target":"fleet-web","configDir":"/home/jenkins/workspace/FleetWeb_fleet-web_master-2CTDD7ARFZUK4YL3RXIGRZCRHDJE5YDU4TW6NX3JYRSQK57UQEHQ/config/build-targets/fleet-web","name":"Fleet Web","title":"Decisiv Fleet","hybrid_link":{"return_app":"fleet_web"},"page_configs":{"ASSET_DETAIL":{"fixed":["ASSET_OVERVIEW"],"quick_action_items":{"left":["REQUEST_SERVICE_BUTTON","CASE_CLASSIC_ASSET_DETAIL_BUTTON"],"right":["JUMP_TO_BUTTON","OPTIONS_BUTTON"]},"top":["OPEN_EVENTS_WIDGET"],"left":["ASSET_SUMMARY_WIDGET","ASSET_FAULT_DIAGNOSTIC_WIDGET"],"right":["ASSET_LOCATION_WIDGET","QR_CODE_WIDGET"]},"CASE_DETAIL":{"fixed":["CASE_OVERVIEW"],"quick_action_items":{"left":["ADD_NOTE_BUTTON"],"right":["JUMP_TO_BUTTON","OPTIONS_BUTTON"]},"top":null,"left":["ESTIMATE_INVOICE_PENDING_WIDGET","CASE_STATUS_WIDGET","CASE_COMPLAINT_WIDGET","CASE_NOTES_WIDGET","CASE_FAULT_DIAGNOSTIC_WIDGET","ESTIMATE_INVOICE_DECIDED_WIDGET"],"right":["CASE_ASSETS_WIDGET","CASE_SERVICE_PROVIDER_WIDGET","CASE_SERVICE_REQUEST_INFO_WIDGET","CASE_LOCATION_WIDGET"]},"SERVICE_REQUEST_DETAIL":{"fixed":["SERVICE_REQUEST_OVERVIEW"],"quick_action_items":{"left":null,"right":["JUMP_TO_BUTTON","OPTIONS_BUTTON","CANCEL_SERVICE_REQUEST_BUTTON"]},"top":null,"left":["SERVICE_REQUEST_SERVICE_PROVIDER_WIDGET","SERVICE_REQUEST_SERV_REQ_INFO_WIDGET","SERVICE_REQUEST_COMPLAINT_WIDGET"],"right":["SERVICE_REQUEST_ASSETS_WIDGET","SERVICE_REQUEST_LOCATION_WIDGET"]}},"wizard_configs":{"SERVICE_REQUEST_WIZARD":{"steps":{"ASSET_SELECTION":["REASON_FOR_REPAIR"],"REASON_FOR_REPAIR":["SERVICE_PROVIDER_SELECTION"],"SERVICE_PROVIDER_SELECTION":["REVIEW"]},"start":"ASSET_SELECTION"}}}

/***/ }),

/***/ "./setup/AppThemeProvider/configureFonts.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fontfaceobserver = __webpack_require__("../node_modules/fontfaceobserver/fontfaceobserver.standalone.js");

var _fontfaceobserver2 = _interopRequireDefault(_fontfaceobserver);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
function configureFonts(appTheme) {
  if (false) {
    return null;
  }

  var primaryFonts = appTheme.fonts.primary.split(',');
  var fontObservers = primaryFonts.map(function (f) {
    return new _fontfaceobserver2.default(f, {});
  });

  function fontLoadSuccess() {
    console.log('All fonts have loaded'); // TODO: better logging
    document.body.classList.add('fontsLoaded');
  }

  function fontLoadFailure() {
    console.error('Fonts have failed to load'); // TODO: better logging
    document.body.classList.remove('fontsLoaded');
  }

  Promise.all(fontObservers.map(function (o) {
    return o.load();
  })).then(fontLoadSuccess, fontLoadFailure);

  return true;
}

exports.default = configureFonts;

/***/ }),

/***/ "./setup/AppThemeProvider/configureGlobalStyles.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function configureGlobalStyles(_ref) {
  var buildGlobalStyleString = _ref.globalStyles.buildGlobalStyleString,
      rest = _objectWithoutProperties(_ref, ['globalStyles']);

  var globalStyles = buildGlobalStyleString(rest);

  (0, _styledComponents.injectGlobal)([globalStyles]);

  return true;
}

exports.default = configureGlobalStyles;

/***/ }),

/***/ "./setup/AppThemeProvider/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppThemeProvider = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _recompose = __webpack_require__("../node_modules/recompose/es/Recompose.js");

var _styledComponents = __webpack_require__("../node_modules/styled-components/dist/styled-components.es.js");

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

var _actions = __webpack_require__("./redux/ui/actions.js");

var _selectors = __webpack_require__("./redux/ui/selectors.js");

var _immutableToJS = __webpack_require__("./utils/immutableToJS.js");

var _immutableToJS2 = _interopRequireDefault(_immutableToJS);

var _configureFonts = __webpack_require__("./setup/AppThemeProvider/configureFonts.js");

var _configureFonts2 = _interopRequireDefault(_configureFonts);

var _configureGlobalStyles = __webpack_require__("./setup/AppThemeProvider/configureGlobalStyles.js");

var _configureGlobalStyles2 = _interopRequireDefault(_configureGlobalStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AppThemeProvider = exports.AppThemeProvider = function (_Component) {
  _inherits(AppThemeProvider, _Component);

  function AppThemeProvider() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AppThemeProvider);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AppThemeProvider.__proto__ || Object.getPrototypeOf(AppThemeProvider)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      RenderComponent: null
    }, _this.buildAppTheme = function (baseTheme, customTheme) {
      return (0, _lodash.merge)(baseTheme, customTheme);
    }, _this.shouldRenderNullComponent = function (brand, brandValues) {
      return brand !== 'decisiv' && (0, _lodash.isEmpty)(brandValues);
    }, _this.buildComponent = function (props) {
      var baseTheme = props.baseTheme,
          brand = props.brand,
          brandValues = props.brandValues,
          children = props.children;


      if (_this.shouldRenderNullComponent(brand, brandValues)) {
        _this.setState({ RenderComponent: function RenderComponent() {
            return null;
          } });
      } else {
        var appTheme = _this.buildAppTheme(baseTheme, {
          colors: brandValues.colors
        });

        (0, _configureFonts2.default)(appTheme);

        (0, _configureGlobalStyles2.default)(appTheme);

        _this.setState({
          RenderComponent: function RenderComponent() {
            return _react2.default.createElement(
              _styledComponents.ThemeProvider,
              { theme: appTheme },
              children
            );
          }
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AppThemeProvider, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.buildComponent(this.props);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.loadBrandValues({ brand: this.props.brand });
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps) {
      if (this.props.brand !== 'decisiv' && (0, _lodash.isEmpty)(this.props.brandValues) && !(0, _lodash.isEmpty)(nextProps.brandValues) && this.props.brandValues !== nextProps.brandValues) {
        this.buildComponent(nextProps);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var RenderComponent = this.state.RenderComponent;

      return _react2.default.createElement(RenderComponent, null);
    }
  }]);

  return AppThemeProvider;
}(_react.Component);

AppThemeProvider.propTypes = {
  baseTheme: _propTypes2.default.shape({
    animations: _propTypes2.default.object.isRequired,
    colors: _propTypes2.default.shape({
      base: _propTypes2.default.object.isRequired,
      brand: _propTypes2.default.object.isRequired,
      status: _propTypes2.default.object.isRequired
    }).isRequired,
    dimensions: _propTypes2.default.object.isRequired,
    globalStyles: _propTypes2.default.shape({
      buildGlobalStyleString: _propTypes2.default.func.isRequired
    }).isRequired,
    transitions: _propTypes2.default.object.isRequired
  }).isRequired,
  brand: _propTypes2.default.oneOf(['decisiv', 'michelin']).isRequired,
  brandValues: _propTypes2.default.shape({
    colors: _propTypes2.default.object
  }).isRequired,
  children: _propTypes2.default.node.isRequired,
  loadBrandValues: _propTypes2.default.func.isRequired
};
AppThemeProvider.defaultProps = {
  baseTheme: _decisivUiUtils.theme
};


function mapStateToProps(state) {
  return {
    brand: (0, _selectors.brandSelector)(state),
    brandValues: (0, _selectors.brandValuesSelector)(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loadBrandValues: function loadBrandValues(brand) {
      return dispatch((0, _actions.loadBrandValues)(brand));
    }
  };
}

exports.default = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _immutableToJS2.default)(AppThemeProvider);

/***/ }),

/***/ "./setup/Bugsnag/addBeforeNotify.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setReduxStore = setReduxStore;
exports.clearBeforeNotifyCallbacks = clearBeforeNotifyCallbacks;
exports.default = addBeforeNotify;

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var callbacks = [];

var reduxStore = void 0;

function getStore() {
  return reduxStore;
}

function setReduxStore(store) {
  reduxStore = store;
}

function clearBeforeNotifyCallbacks() {
  // this function really only exists for test purposes,
  // to clear the beforeNotify callbacks between tests.
  callbacks.length = 0;
}

/**
 * Allows us to add Bugsnag `beforeNotify` steps without interfering with existing
 * `beforeNotify` callbacks.
 *
 * @example
 *  addBeforeNotify(Bugsnag, (payload, getStore, metadata) =>
 *    payload.user = selectUser(getStore().getState());
 *
 * If any beforeNotify returns false, no notification will happen.
 */
function addBeforeNotify(Bugsnag, callback) {
  // don't lose a beforeNotify callback that was created by other means
  if (Bugsnag.beforeNotify && callbacks.length === 0) {
    callbacks.push(Bugsnag.beforeNotify);
  }

  callbacks.push(callback);

  // eslint-disable-next-line no-param-reassign
  Bugsnag.beforeNotify = function (payload, metaData) {
    // call all the callbacks and get their return values
    var results = callbacks.map(function (cb) {
      return cb(payload, getStore, metaData);
    });

    // if any callback is false, return false so the notification doesn't happen
    if ((0, _lodash.includes)(results, false)) {
      return false;
    }

    return payload;
  };
}

/***/ }),

/***/ "./setup/Bugsnag/fetchBreadcrumbs.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _fetchIntercept = __webpack_require__("../node_modules/fetch-intercept/lib/index.js");

var _fetchIntercept2 = _interopRequireDefault(_fetchIntercept);

var _urlParse = __webpack_require__("../node_modules/url-parse/index.js");

var _urlParse2 = _interopRequireDefault(_urlParse);

var _url = __webpack_require__("./utils/url.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function makeBreadcrumb(fetchUrl) {
  var parsedUrl = new _urlParse2.default(fetchUrl);
  var query = (0, _url.parseQueryParams)(parsedUrl.query);
  return {
    type: 'request',
    name: 'fetch',
    metaData: _extends({
      host: parsedUrl.host,
      pathname: parsedUrl.pathname,
      query: parsedUrl.query
    }, query)
  };
}

/**
 * Sets up logging of any `fetch` requests to the back-end API as part of the breadcrumbs
 * that come over with an error report to Bugsnag.
 */
function setup(Bugsnag) {
  _fetchIntercept2.default.register({
    request: function request(url, config) {
      Bugsnag.leaveBreadcrumb(makeBreadcrumb(url));
      return [url, config];
    }
  });
}

exports.default = { setup: setup };

/***/ }),

/***/ "./setup/Bugsnag/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bugsnagJs = __webpack_require__("../node_modules/bugsnag-js/src/bugsnag.js");

var _bugsnagJs2 = _interopRequireDefault(_bugsnagJs);

var _addBeforeNotify = __webpack_require__("./setup/Bugsnag/addBeforeNotify.js");

var _addBeforeNotify2 = _interopRequireDefault(_addBeforeNotify);

var _user = __webpack_require__("./setup/Bugsnag/user.js");

var _user2 = _interopRequireDefault(_user);

var _fetchBreadcrumbs = __webpack_require__("./setup/Bugsnag/fetchBreadcrumbs.js");

var _fetchBreadcrumbs2 = _interopRequireDefault(_fetchBreadcrumbs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_bugsnagJs2.default.apiKey = "f4c8e3bfb8dfbd3a460e53b1e5e6d244";
_bugsnagJs2.default.releaseStage = "preview";
_bugsnagJs2.default.notifyReleaseStages = ['preview', 'production'];

_bugsnagJs2.default.appVersion = "1.3.4";

/**
 * Helper to set the current Redux store so that Bugsnag can have
 * access to it.
 *
 * @param store
 */
function setStore(store) {
  (0, _addBeforeNotify.setReduxStore)(store);
}

_user2.default.setup(_bugsnagJs2.default);
_fetchBreadcrumbs2.default.setup(_bugsnagJs2.default);

_bugsnagJs2.default.metaData = {
  request: {
    referrer: document.referrer, // TODO: get last route from redux-router
    errorCount: 0
  }
};

(0, _addBeforeNotify2.default)(_bugsnagJs2.default, function (payload) {
  if (payload.severity === 'error') {
    _bugsnagJs2.default.metaData.request.errorCount += 1;
  }
});

// TODO: add other monitoring (e.g. performance), enhanced breadcrumb tracking, etc

exports.default = {
  setStore: setStore
};

/***/ }),

/***/ "./setup/Bugsnag/reduxMiddleware.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bugsnagJs = __webpack_require__("../node_modules/bugsnag-js/src/bugsnag.js");

var _bugsnagJs2 = _interopRequireDefault(_bugsnagJs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Redux middleware that catches exceptions during the dispatching of actions and reports
 * them to Bugsnag.
 * @param store
 */
var bugsnagReporter = function bugsnagReporter(store) {
  return function (next) {
    return function (action) {
      try {
        return next(action);
      } catch (err) {
        var metadata = {
          action: action,
          token: store.getState().getIn(['authentication', 'token']).toJS()
        };

        _bugsnagJs2.default.notifyException(err, 'Exception in Redux store', metadata);
        throw err;
      }
    };
  };
};

exports.default = bugsnagReporter;

/***/ }),

/***/ "./setup/Bugsnag/user.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _selectors = __webpack_require__("./redux/user/selectors.js");

var _selectors2 = __webpack_require__("./redux/ui/selectors.js");

var _authentication = __webpack_require__("./features/authentication/index.js");

var _addBeforeNotify = __webpack_require__("./setup/Bugsnag/addBeforeNotify.js");

var _addBeforeNotify2 = _interopRequireDefault(_addBeforeNotify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function beforeNotify(payload, getStore) {
  // Report current user to Bugsnag, if available
  var store = getStore();
  var currentState = store && store.getState();

  if (currentState) {
    var userForBugsnag = {
      username: (0, _selectors.usernameSelector)(currentState),
      tenant: (0, _authentication.currentTenantSelector)(currentState),
      brand: (0, _selectors2.brandSelector)(currentState)
    };

    var userProfile = (0, _selectors.userProfileSelector)(currentState);
    if (userProfile) {
      userForBugsnag = _extends({}, userForBugsnag, userProfile.toJS());
    }

    // eslint-disable-next-line no-param-reassign
    payload.user = userForBugsnag;
  } else {
    console.log('Bugsnag user beforeNotify - no Redux store available yet');
  }
}

function setup(Bugsnag) {
  (0, _addBeforeNotify2.default)(Bugsnag, beforeNotify);
}

exports.default = { setup: setup };

/***/ }),

/***/ "./setup/ComponentRegistry/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ADD_NOTE_BUTTON = exports.ADD_NOTE_BUTTON = 'ADD_NOTE_BUTTON';
var ASSET_DETAIL_DATA = exports.ASSET_DETAIL_DATA = 'ASSET_DETAIL_DATA';
var ASSET_FAULT_DIAGNOSTIC_WIDGET = exports.ASSET_FAULT_DIAGNOSTIC_WIDGET = 'ASSET_FAULT_DIAGNOSTIC_WIDGET';
var ASSET_LOCATION_WIDGET = exports.ASSET_LOCATION_WIDGET = 'ASSET_LOCATION_WIDGET';
var ASSET_OVERVIEW = exports.ASSET_OVERVIEW = 'ASSET_OVERVIEW';
var ASSET_SUMMARY_WIDGET = exports.ASSET_SUMMARY_WIDGET = 'ASSET_SUMMARY_WIDGET';
var CANCEL_SERVICE_REQUEST_BUTTON = exports.CANCEL_SERVICE_REQUEST_BUTTON = 'CANCEL_SERVICE_REQUEST_BUTTON';
var CASE_ASSETS_WIDGET = exports.CASE_ASSETS_WIDGET = 'CASE_ASSETS_WIDGET';
var CASE_CLASSIC_ASSET_DETAIL_BUTTON = exports.CASE_CLASSIC_ASSET_DETAIL_BUTTON = 'CASE_CLASSIC_ASSET_DETAIL_BUTTON';
var CASE_COMPLAINT_WIDGET = exports.CASE_COMPLAINT_WIDGET = 'CASE_COMPLAINT_WIDGET';
var CASE_DETAIL_DATA = exports.CASE_DETAIL_DATA = 'CASE_DETAIL_DATA';
var CASE_FAULT_DIAGNOSTIC_WIDGET = exports.CASE_FAULT_DIAGNOSTIC_WIDGET = 'CASE_FAULT_DIAGNOSTIC_WIDGET';
var CASE_LOCATION_WIDGET = exports.CASE_LOCATION_WIDGET = 'CASE_LOCATION_WIDGET';
var CASE_NOTES_WIDGET = exports.CASE_NOTES_WIDGET = 'CASE_NOTES_WIDGET';
var CASE_OVERVIEW = exports.CASE_OVERVIEW = 'CASE_OVERVIEW';
var CASE_SERVICE_PROVIDER_WIDGET = exports.CASE_SERVICE_PROVIDER_WIDGET = 'CASE_SERVICE_PROVIDER_WIDGET';
var CASE_SERVICE_REQUEST_INFO_WIDGET = exports.CASE_SERVICE_REQUEST_INFO_WIDGET = 'CASE_SERVICE_REQUEST_INFO_WIDGET';
var CASE_STATUS_WIDGET = exports.CASE_STATUS_WIDGET = 'CASE_STATUS_WIDGET';
var ESTIMATE_INVOICE_DECIDED_WIDGET = exports.ESTIMATE_INVOICE_DECIDED_WIDGET = 'ESTIMATE_INVOICE_DECIDED_WIDGET';
var ESTIMATE_INVOICE_PENDING_WIDGET = exports.ESTIMATE_INVOICE_PENDING_WIDGET = 'ESTIMATE_INVOICE_PENDING_WIDGET';
var JUMP_TO_BUTTON = exports.JUMP_TO_BUTTON = 'JUMP_TO_BUTTON';
var OPEN_EVENTS_WIDGET = exports.OPEN_EVENTS_WIDGET = 'OPEN_EVENTS_WIDGET';
var OPTIONS_BUTTON = exports.OPTIONS_BUTTON = 'OPTIONS_BUTTON';
var QR_CODE_WIDGET = exports.QR_CODE_WIDGET = 'QR_CODE_WIDGET';
var REQUEST_SERVICE_BUTTON = exports.REQUEST_SERVICE_BUTTON = 'REQUEST_SERVICE_BUTTON';
var SERVICE_REQUEST_ASSETS_WIDGET = exports.SERVICE_REQUEST_ASSETS_WIDGET = 'SERVICE_REQUEST_ASSETS_WIDGET';
var SERVICE_REQUEST_COMPLAINT_WIDGET = exports.SERVICE_REQUEST_COMPLAINT_WIDGET = 'SERVICE_REQUEST_COMPLAINT_WIDGET';
var SERVICE_REQUEST_DETAIL_DATA = exports.SERVICE_REQUEST_DETAIL_DATA = 'SERVICE_REQUEST_DETAIL_DATA';
var SERVICE_REQUEST_LOCATION_WIDGET = exports.SERVICE_REQUEST_LOCATION_WIDGET = 'SERVICE_REQUEST_LOCATION_WIDGET';
var SERVICE_REQUEST_NOTES_WIDGET = exports.SERVICE_REQUEST_NOTES_WIDGET = 'SERVICE_REQUEST_NOTES_WIDGET';
var SERVICE_REQUEST_OVERVIEW = exports.SERVICE_REQUEST_OVERVIEW = 'SERVICE_REQUEST_OVERVIEW';
var SERVICE_REQUEST_SERVICE_PROVIDER_WIDGET = exports.SERVICE_REQUEST_SERVICE_PROVIDER_WIDGET = 'SERVICE_REQUEST_SERVICE_PROVIDER_WIDGET';
var SERVICE_REQUEST_SERV_REQ_INFO_WIDGET = exports.SERVICE_REQUEST_SERV_REQ_INFO_WIDGET = 'SERVICE_REQUEST_SERV_REQ_INFO_WIDGET';

exports.default = [ADD_NOTE_BUTTON, ASSET_DETAIL_DATA, ASSET_FAULT_DIAGNOSTIC_WIDGET, ASSET_LOCATION_WIDGET, ASSET_OVERVIEW, ASSET_SUMMARY_WIDGET, CANCEL_SERVICE_REQUEST_BUTTON, CASE_ASSETS_WIDGET, CASE_CLASSIC_ASSET_DETAIL_BUTTON, CASE_COMPLAINT_WIDGET, CASE_DETAIL_DATA, CASE_FAULT_DIAGNOSTIC_WIDGET, CASE_LOCATION_WIDGET, CASE_NOTES_WIDGET, CASE_OVERVIEW, CASE_SERVICE_PROVIDER_WIDGET, CASE_SERVICE_REQUEST_INFO_WIDGET, CASE_STATUS_WIDGET, ESTIMATE_INVOICE_DECIDED_WIDGET, ESTIMATE_INVOICE_PENDING_WIDGET, JUMP_TO_BUTTON, OPEN_EVENTS_WIDGET, OPTIONS_BUTTON, QR_CODE_WIDGET, REQUEST_SERVICE_BUTTON, SERVICE_REQUEST_ASSETS_WIDGET, SERVICE_REQUEST_COMPLAINT_WIDGET, SERVICE_REQUEST_DETAIL_DATA, SERVICE_REQUEST_LOCATION_WIDGET, SERVICE_REQUEST_NOTES_WIDGET, SERVICE_REQUEST_OVERVIEW, SERVICE_REQUEST_SERVICE_PROVIDER_WIDGET, SERVICE_REQUEST_SERV_REQ_INFO_WIDGET];

/***/ }),

/***/ "./setup/ComponentRegistry/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ADD_NOTE_BUTTON$ASSE;

var _AddNoteButton = __webpack_require__("./compositions/AddNoteButton/index.js");

var _AddNoteButton2 = _interopRequireDefault(_AddNoteButton);

var _AssetOverview = __webpack_require__("./compositions/AssetOverview/index.js");

var _AssetOverview2 = _interopRequireDefault(_AssetOverview);

var _AssetSummaryWidget = __webpack_require__("./compositions/AssetSummaryWidget/index.js");

var _AssetSummaryWidget2 = _interopRequireDefault(_AssetSummaryWidget);

var _AssetsWidget = __webpack_require__("./compositions/AssetsWidget/index.js");

var _CancelServiceRequestButton = __webpack_require__("./compositions/CancelServiceRequestButton/index.js");

var _CancelServiceRequestButton2 = _interopRequireDefault(_CancelServiceRequestButton);

var _CaseClassicAssetDetailButton = __webpack_require__("./compositions/CaseClassicAssetDetailButton/index.js");

var _CaseClassicAssetDetailButton2 = _interopRequireDefault(_CaseClassicAssetDetailButton);

var _CaseOverview = __webpack_require__("./compositions/CaseOverview/index.js");

var _CaseOverview2 = _interopRequireDefault(_CaseOverview);

var _CaseStatusWidget = __webpack_require__("./compositions/CaseStatusWidget/index.js");

var _CaseStatusWidget2 = _interopRequireDefault(_CaseStatusWidget);

var _ComplaintWidget = __webpack_require__("./compositions/ComplaintWidget/index.js");

var _DiagnosticsWidget = __webpack_require__("./compositions/DiagnosticsWidget/index.js");

var _EstimateInvoiceDecidedWidget = __webpack_require__("./compositions/EstimateInvoiceDecidedWidget/index.js");

var _EstimateInvoiceDecidedWidget2 = _interopRequireDefault(_EstimateInvoiceDecidedWidget);

var _EstimateInvoicePendingWidget = __webpack_require__("./compositions/EstimateInvoicePendingWidget/index.js");

var _EstimateInvoicePendingWidget2 = _interopRequireDefault(_EstimateInvoicePendingWidget);

var _JumpToButton = __webpack_require__("./compositions/JumpToButton/index.js");

var _JumpToButton2 = _interopRequireDefault(_JumpToButton);

var _NotesWidget = __webpack_require__("./compositions/NotesWidget/index.js");

var _LocationWidget = __webpack_require__("./compositions/LocationWidget/index.js");

var _OpenEventsWidget = __webpack_require__("./compositions/OpenEventsWidget/index.js");

var _OpenEventsWidget2 = _interopRequireDefault(_OpenEventsWidget);

var _OptionsButton = __webpack_require__("./compositions/OptionsButton/index.js");

var _OptionsButton2 = _interopRequireDefault(_OptionsButton);

var _QRCodeWidget = __webpack_require__("./compositions/QRCodeWidget/index.js");

var _QRCodeWidget2 = _interopRequireDefault(_QRCodeWidget);

var _RequestServiceButton = __webpack_require__("./compositions/RequestServiceButton/index.js");

var _RequestServiceButton2 = _interopRequireDefault(_RequestServiceButton);

var _ServiceProviderWidget = __webpack_require__("./compositions/ServiceProviderWidget/index.js");

var _ServiceRequestOverview = __webpack_require__("./compositions/ServiceRequestOverview/index.js");

var _ServiceRequestOverview2 = _interopRequireDefault(_ServiceRequestOverview);

var _ServiceRequestWidget = __webpack_require__("./compositions/ServiceRequestWidget/index.js");

var _AssetDetailData = __webpack_require__("./containers/AssetDetailData/index.js");

var _AssetDetailData2 = _interopRequireDefault(_AssetDetailData);

var _CaseDetailData = __webpack_require__("./containers/CaseDetailData/index.js");

var _CaseDetailData2 = _interopRequireDefault(_CaseDetailData);

var _ServiceRequestDetailData = __webpack_require__("./containers/ServiceRequestDetailData/index.js");

var _ServiceRequestDetailData2 = _interopRequireDefault(_ServiceRequestDetailData);

var _constants = __webpack_require__("./setup/ComponentRegistry/constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = (_ADD_NOTE_BUTTON$ASSE = {}, _defineProperty(_ADD_NOTE_BUTTON$ASSE, _constants.ADD_NOTE_BUTTON, _AddNoteButton2.default), _defineProperty(_ADD_NOTE_BUTTON$ASSE, _constants.ASSET_DETAIL_DATA, _AssetDetailData2.default), _defineProperty(_ADD_NOTE_BUTTON$ASSE, _constants.ASSET_FAULT_DIAGNOSTIC_WIDGET, _DiagnosticsWidget.AssetFaultDiagnosticsWidget), _defineProperty(_ADD_NOTE_BUTTON$ASSE, _constants.ASSET_LOCATION_WIDGET, _LocationWidget.AssetLocationWidget), _defineProperty(_ADD_NOTE_BUTTON$ASSE, _constants.ASSET_OVERVIEW, _AssetOverview2.default), _defineProperty(_ADD_NOTE_BUTTON$ASSE, _constants.ASSET_SUMMARY_WIDGET, _AssetSummaryWidget2.default), _defineProperty(_ADD_NOTE_BUTTON$ASSE, _constants.CANCEL_SERVICE_REQUEST_BUTTON, _CancelServiceRequestButton2.default), _defineProperty(_ADD_NOTE_BUTTON$ASSE, _constants.CASE_ASSETS_WIDGET, _AssetsWidget.CaseAssetsWidget), _defineProperty(_ADD_NOTE_BUTTON$ASSE, _constants.CASE_CLASSIC_ASSET_DETAIL_BUTTON, _CaseClassicAssetDetailButton2.default), _defineProperty(_ADD_NOTE_BUTTON$ASSE, _constants.CASE_COMPLAINT_WIDGET, _ComplaintWidget.CaseComplaintWidget), _defineProperty(_ADD_NOTE_BUTTON$ASSE, _constants.CASE_DETAIL_DATA, _CaseDetailData2.default), _defineProperty(_ADD_NOTE_BUTTON$ASSE, _constants.CASE_FAULT_DIAGNOSTIC_WIDGET, _DiagnosticsWidget.CaseFaultDiagnosticsWidget), _defineProperty(_ADD_NOTE_BUTTON$ASSE, _constants.CASE_LOCATION_WIDGET, _LocationWidget.CaseLocationWidget), _defineProperty(_ADD_NOTE_BUTTON$ASSE, _constants.CASE_NOTES_WIDGET, _NotesWidget.CaseNotesWidget), _defineProperty(_ADD_NOTE_BUTTON$ASSE, _constants.CASE_OVERVIEW, _CaseOverview2.default), _defineProperty(_ADD_NOTE_BUTTON$ASSE, _constants.CASE_SERVICE_PROVIDER_WIDGET, _ServiceProviderWidget.CaseServiceProviderWidget), _defineProperty(_ADD_NOTE_BUTTON$ASSE, _constants.CASE_SERVICE_REQUEST_INFO_WIDGET, _ServiceRequestWidget.CaseServiceRequestInfoWidget), _defineProperty(_ADD_NOTE_BUTTON$ASSE, _constants.CASE_STATUS_WIDGET, _CaseStatusWidget2.default), _defineProperty(_ADD_NOTE_BUTTON$ASSE, _constants.ESTIMATE_INVOICE_DECIDED_WIDGET, _EstimateInvoiceDecidedWidget2.default), _defineProperty(_ADD_NOTE_BUTTON$ASSE, _constants.ESTIMATE_INVOICE_PENDING_WIDGET, _EstimateInvoicePendingWidget2.default), _defineProperty(_ADD_NOTE_BUTTON$ASSE, _constants.JUMP_TO_BUTTON, _JumpToButton2.default), _defineProperty(_ADD_NOTE_BUTTON$ASSE, _constants.OPEN_EVENTS_WIDGET, _OpenEventsWidget2.default), _defineProperty(_ADD_NOTE_BUTTON$ASSE, _constants.OPTIONS_BUTTON, _OptionsButton2.default), _defineProperty(_ADD_NOTE_BUTTON$ASSE, _constants.QR_CODE_WIDGET, _QRCodeWidget2.default), _defineProperty(_ADD_NOTE_BUTTON$ASSE, _constants.REQUEST_SERVICE_BUTTON, _RequestServiceButton2.default), _defineProperty(_ADD_NOTE_BUTTON$ASSE, _constants.SERVICE_REQUEST_ASSETS_WIDGET, _AssetsWidget.ServiceRequestAssetsWidget), _defineProperty(_ADD_NOTE_BUTTON$ASSE, _constants.SERVICE_REQUEST_COMPLAINT_WIDGET, _ComplaintWidget.ServiceRequestComplaintWidget), _defineProperty(_ADD_NOTE_BUTTON$ASSE, _constants.SERVICE_REQUEST_DETAIL_DATA, _ServiceRequestDetailData2.default), _defineProperty(_ADD_NOTE_BUTTON$ASSE, _constants.SERVICE_REQUEST_LOCATION_WIDGET, _LocationWidget.ServiceRequestLocationWidget), _defineProperty(_ADD_NOTE_BUTTON$ASSE, _constants.SERVICE_REQUEST_NOTES_WIDGET, _NotesWidget.ServiceRequestNotesWidget), _defineProperty(_ADD_NOTE_BUTTON$ASSE, _constants.SERVICE_REQUEST_OVERVIEW, _ServiceRequestOverview2.default), _defineProperty(_ADD_NOTE_BUTTON$ASSE, _constants.SERVICE_REQUEST_SERVICE_PROVIDER_WIDGET, _ServiceProviderWidget.ServiceRequestServiceProviderWidget), _defineProperty(_ADD_NOTE_BUTTON$ASSE, _constants.SERVICE_REQUEST_SERV_REQ_INFO_WIDGET, _ServiceRequestWidget.ServiceRequestServReqInfoWidget), _ADD_NOTE_BUTTON$ASSE);

/***/ }),

/***/ "./setup/ComponentRegistry/propTypes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _constants = __webpack_require__("./setup/ComponentRegistry/constants.js");

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var compositionConfig = _propTypes2.default.arrayOf(_propTypes2.default.oneOf(_constants2.default));

var registeredCompositions = _propTypes2.default.arrayOf(_propTypes2.default.shape({
  name: _propTypes2.default.string.isRequired,
  composition: _propTypes2.default.func.isRequired
})).isRequired;

exports.default = {
  compositionConfig: compositionConfig,
  registeredCompositions: registeredCompositions
};

/***/ }),

/***/ "./setup/Hotjar.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.installHotjar = installHotjar;

var _decisivDomainUtils = __webpack_require__("../node_modules/decisiv-domain-utils/build/index.js");

/* istanbul ignore next */
function enableHotjar() {
  return (0, _decisivDomainUtils.configEnabled)('HOTJAR_ENABLED');
}

/* istanbul ignore next */
// eslint-disable-next-line import/prefer-default-export
function installHotjar() {
  if (enableHotjar()) {
    // This snippet is the install script provided by Hotjar for SPA's
    /* eslint-disable */
    (function (h, o, t, j, a, r) {
      h.hj = h.hj || function () {
        (h.hj.q = h.hj.q || []).push(arguments);
      };h._hjSettings = { hjid: 713818, hjsv: 6 };a = o.getElementsByTagName('head')[0];r = o.createElement('script');r.async = 1;r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;a.appendChild(r);
    })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
    /* eslint-enable */
  }
}

/***/ }),

/***/ "./setup/I18n/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _linguiI18n = __webpack_require__("../node_modules/lingui-i18n/index.es.js");

var _browserLocale = __webpack_require__("./utils/browserLocale.js");

var _browserLocale2 = _interopRequireDefault(_browserLocale);

var _messages = __webpack_require__("./locale/de/messages.js");

var _messages2 = _interopRequireDefault(_messages);

var _messages3 = __webpack_require__("./locale/en/messages.js");

var _messages4 = _interopRequireDefault(_messages3);

var _messages5 = __webpack_require__("./locale/es/messages.js");

var _messages6 = _interopRequireDefault(_messages5);

var _messages7 = __webpack_require__("./locale/ja/messages.js");

var _messages8 = _interopRequireDefault(_messages7);

var _messages9 = __webpack_require__("./locale/nl/messages.js");

var _messages10 = _interopRequireDefault(_messages9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------

// Define user's language. Different browsers have the user locale defined
// on different fields on the `navigator` object, so we make sure to account
// for these different by checking all of them
/* istanbul ignore next */
var userLocale = (0, _browserLocale2.default)();

// Split locales with a region code
var languageWithoutRegionCode = userLocale.toLowerCase().split(/[_-]+/)[0];

// ----------------------------------------------------------------------
// new js-lingui translation setup:

var linguiCatalogs = {
  de: (0, _linguiI18n.unpackCatalog)(_messages2.default),
  en: (0, _linguiI18n.unpackCatalog)(_messages4.default),
  es: (0, _linguiI18n.unpackCatalog)(_messages6.default),
  ja: (0, _linguiI18n.unpackCatalog)(_messages8.default),
  nl: (0, _linguiI18n.unpackCatalog)(_messages10.default)
};

// required for JS-Lingui in development only (huge dependency)
// eslint-disable-next-line global-require
var jsLinguiDev = "production" !== 'production' && __webpack_require__("../node_modules/lingui-i18n/dev.js");

function I18n(_ref) {
  var language = _ref.language,
      children = _ref.children;

  return _react2.default.createElement(
    _linguiReact.I18nProvider,
    {
      language: language,
      development: jsLinguiDev,
      catalogs: linguiCatalogs
    },
    children
  );
}

I18n.propTypes = {
  language: _propTypes2.default.string,
  children: _propTypes2.default.node.isRequired
};

I18n.defaultProps = {
  locale: userLocale,
  language: languageWithoutRegionCode
};

exports.default = I18n;

/***/ }),

/***/ "./setup/Pendo.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.installPendo = installPendo;
exports.initializePendo = initializePendo;

var _decisivDomainUtils = __webpack_require__("../node_modules/decisiv-domain-utils/build/index.js");

/* istanbul ignore next */
function enablePendo() {
  return (0, _decisivDomainUtils.configEnabled)('PENDO_ENABLED');
}

/* istanbul ignore next */
function installPendo() {
  if (enablePendo()) {
    // This snippet is the install script provided by Pendo for SPA's
    /* eslint-disable */
    (function (apiKey) {
      (function (p, e, n, d, o) {
        var v, w, x, y, z;o = p[d] = p[d] || {};o._q = [];
        v = ['initialize', 'identify', 'updateOptions', 'pageLoad'];for (w = 0, x = v.length; w < x; ++w) {
          (function (m) {
            o[m] = o[m] || function () {
              o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0)));
            };
          })(v[w]);
        }y = e.createElement(n);y.async = !0;y.src = 'https://cdn.pendo.io/agent/static/' + apiKey + '/pendo.js';
        z = e.getElementsByTagName(n)[0];z.parentNode.insertBefore(y, z);
      })(window, document, 'script', 'pendo');
    })("981f8608-6052-42f5-432b-6bd80a96933d");
    /* eslint-enable */
  }
}

/* istanbul ignore next */
function initializePendo(user, oem) {
  if (enablePendo()) {
    pendo.initialize({
      visitor: _extends({
        id: user.email,
        oem: oem
      }, user),
      account: {
        id: oem
      }
    });
  }
}

/***/ }),

/***/ "./setup/Router/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__("../node_modules/react-router-dom/es/index.js");

var _routes = __webpack_require__("./setup/routes.js");

var _routes2 = _interopRequireDefault(_routes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Router() {
  return _react2.default.createElement(
    _reactRouterDom.BrowserRouter,
    null,
    _react2.default.createElement(_routes2.default, null)
  );
}

exports.default = Router;

/***/ }),

/***/ "./setup/WizardRegistry/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ASSET_AVAILABILITY = exports.ASSET_AVAILABILITY = 'ASSET_AVAILABILITY';
var ASSET_SELECTION = exports.ASSET_SELECTION = 'ASSET_SELECTION';
var CONTACT_PERSON = exports.CONTACT_PERSON = 'CONTACT_PERSON';
var REASON_FOR_REPAIR = exports.REASON_FOR_REPAIR = 'REASON_FOR_REPAIR';
var REVIEW = exports.REVIEW = 'REVIEW';
var SERVICE_PROVIDER_SELECTION = exports.SERVICE_PROVIDER_SELECTION = 'SERVICE_PROVIDER_SELECTION';
var SERVICE_REQUEST_TYPE = exports.SERVICE_REQUEST_TYPE = 'SERVICE_REQUEST_TYPE';
var SERVICE_REQUEST_WIZARD = exports.SERVICE_REQUEST_WIZARD = 'SERVICE_REQUEST_WIZARD';

exports.default = [ASSET_AVAILABILITY, ASSET_SELECTION, CONTACT_PERSON, REASON_FOR_REPAIR, REVIEW, SERVICE_PROVIDER_SELECTION, SERVICE_REQUEST_TYPE, SERVICE_REQUEST_WIZARD];

/***/ }),

/***/ "./setup/WizardRegistry/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wizardConfigKeys = undefined;

var _extends2;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _AssetAvailability = __webpack_require__("./components/WizardSteps/AssetAvailability/index.js");

var _AssetAvailability2 = _interopRequireDefault(_AssetAvailability);

var _AssetSelection = __webpack_require__("./components/WizardSteps/AssetSelection/index.js");

var _AssetSelection2 = _interopRequireDefault(_AssetSelection);

var _ContactPerson = __webpack_require__("./components/WizardSteps/ContactPerson/index.js");

var _ContactPerson2 = _interopRequireDefault(_ContactPerson);

var _ReasonForRepair = __webpack_require__("./components/WizardSteps/ReasonForRepair/index.js");

var _ReasonForRepair2 = _interopRequireDefault(_ReasonForRepair);

var _Review = __webpack_require__("./components/WizardSteps/Review/index.js");

var _Review2 = _interopRequireDefault(_Review);

var _ServiceProviderSelection = __webpack_require__("./components/WizardSteps/ServiceProviderSelection/index.js");

var _ServiceProviderSelection2 = _interopRequireDefault(_ServiceProviderSelection);

var _ServiceRequestType = __webpack_require__("./components/WizardSteps/ServiceRequestType/index.js");

var _ServiceRequestType2 = _interopRequireDefault(_ServiceRequestType);

var _ServiceRequestWizardController = __webpack_require__("./containers/ServiceRequestWizardController/index.js");

var _ServiceRequestWizardController2 = _interopRequireDefault(_ServiceRequestWizardController);

var _constants = __webpack_require__("./setup/WizardRegistry/constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// The wizard configs are used to add the specfic wizard controllers to the mappedWizardConfigs,
// but they get lost when simply added to the default export.
var specificWizardControllers = _defineProperty({}, _constants.SERVICE_REQUEST_WIZARD, _ServiceRequestWizardController2.default);

// Export the wizardConfigKeys for use in propTypes validations.
var wizardConfigKeys = exports.wizardConfigKeys = Object.keys(specificWizardControllers);

exports.default = _extends((_extends2 = {}, _defineProperty(_extends2, _constants.ASSET_AVAILABILITY, _AssetAvailability2.default), _defineProperty(_extends2, _constants.ASSET_SELECTION, _AssetSelection2.default), _defineProperty(_extends2, _constants.CONTACT_PERSON, _ContactPerson2.default), _defineProperty(_extends2, _constants.REASON_FOR_REPAIR, _ReasonForRepair2.default), _defineProperty(_extends2, _constants.REVIEW, _Review2.default), _defineProperty(_extends2, _constants.SERVICE_PROVIDER_SELECTION, _ServiceProviderSelection2.default), _defineProperty(_extends2, _constants.SERVICE_REQUEST_TYPE, _ServiceRequestType2.default), _extends2), specificWizardControllers);

/***/ }),

/***/ "./setup/ZendeskLoader.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactLoadScript = __webpack_require__("../node_modules/react-load-script/lib/index.js");

var _reactLoadScript2 = _interopRequireDefault(_reactLoadScript);

var _bugsnagJs = __webpack_require__("../node_modules/bugsnag-js/src/bugsnag.js");

var _bugsnagJs2 = _interopRequireDefault(_bugsnagJs);

var _decisivDomainUtils = __webpack_require__("../node_modules/decisiv-domain-utils/build/index.js");

var _url = __webpack_require__("./utils/url.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function enableZenDesk() {
  return (0, _decisivDomainUtils.configEnabled)('ZENDESK_ENABLED');
}

function scriptUrl() {
  var brand = (0, _url.getBrandFromUrl)();
  var envVar = 'ZENDESK_' + brand.toUpperCase() + '_KEY';
  var zendeskKey = Object({"API_BASE_URL":"https://fleet-mobile-api.preview.decisivapps.com/api","BRAND":"default","TENANT":"default","BUGSNAG_API_KEY":"f4c8e3bfb8dfbd3a460e53b1e5e6d244","GOOGLE_MAPS_API_KEY":"AIzaSyCHbt8PyscdyDliLBNekCqKUXWNUeMv2IA","HOTJAR_ENABLED":"true","PENDO_ENABLED":"true","PENDO_API_KEY":"981f8608-6052-42f5-432b-6bd80a96933d","RELEASE_STAGE":"preview","ZENDESK_ENABLED":"true","ZENDESK_DECISIV_KEY":"cbc4e684-7026-4b63-a690-b7470c5d3637","ZENDESK_MICHELIN_KEY":"71b8e91c-cb29-4fd1-a05e-758c67aa58b6","SHOW_GIT_REVISION":"true","APP_VERSION":"1.3.4","GIT_COMMIT":"e2696e6","VLV_PRICING_URL":"https://volvopg.preview.decisivapps.com","DCV_PRICING_URL":"https://dsmppg.preview.decisivapps.com","MICH_PRICING_URL":"https://michelinpg.preview.decisivapps.com","PORTUNUS_URL":"https://portunus.preview.decisivapps.com"})[envVar];
  if (!zendeskKey) {
    var errorMsg = '\n      Cannot find Zendesk API key for brand \'' + brand + '\' - missing environment variable \'' + envVar + '\'\n    ';
    // eslint-disable-next-line no-console
    console.error(errorMsg);
    _bugsnagJs2.default.notify('Zendesk config error', errorMsg, { brand: brand, envVar: envVar }, 'error');
  }

  return 'https://static.zdassets.com/ekr/snippet.js?key=' + zendeskKey;
}

function configureZendesk() {
  window.zESettings = {
    webWidget: {
      helpCenter: {
        filter: { label_names: 'fleet' }
      }
    }
  };

  window.zE(function () {
    window.zE.setHelpCenterSuggestions({ url: true });
  });
}

function ZendeskLoader() {
  if (enableZenDesk()) {
    return _react2.default.createElement(_reactLoadScript2.default, {
      url: scriptUrl(),
      attributes: { id: 'ze-snippet' },
      onLoad: configureZendesk
    });
  }

  return null;
}

exports.default = ZendeskLoader;

/***/ }),

/***/ "./setup/helmet.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _runtimeConfig = __webpack_require__("./runtimeConfig.json");

var _runtimeConfig2 = _interopRequireDefault(_runtimeConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var helmetAppConfig = {
  htmlAttributes: { lang: 'en' },
  defaultTitle: _runtimeConfig2.default.title,
  titleTemplate: '%s - ' + _runtimeConfig2.default.title,
  meta: [{
    name: 'viewport',
    content: 'width=device-width, initial-scale=1'
  }]
  // Uncomment this if you want to watch Helmet's updates in the JS console:
  // onChangeClientState: newState => console.log('helmet update: ', newState),
}; // eslint-disable-next-line import/no-unresolved
exports.default = helmetAppConfig;

/***/ }),

/***/ "./setup/localStorage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initLocalStorage;

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _memorystorage = __webpack_require__("../node_modules/memorystorage/dist/memorystorage.umd.js");

var _memorystorage2 = _interopRequireDefault(_memorystorage);

var _runtimeConfig = __webpack_require__("./runtimeConfig.json");

var _runtimeConfig2 = _interopRequireDefault(_runtimeConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * This function sets up a browser-local memory DB, accessible via `window.memoryDB`.  It
 * first determines if `localStorage` is available and properly functional, and if so, sets
 * the `memoryDB` to be a reference to `localStorage`.  If `localStorage` is broken (for
 * example, in Safari Private Browsing mode), then it sets `memoryDB` to refer to an instance
 * if `MemoryStorage`, which supports the same API as `localStorage`, but does not persist
 * its keys/values across full page refresh.
 */
function initLocalStorage() {
  var actualStorage = localStorage;
  try {
    var x = 'test-localstorage-' + Date.now();
    actualStorage.setItem(x, x);
    var y = actualStorage.getItem(x);
    actualStorage.removeItem(x);
    if (y !== x) {
      throw new Error();
    }
  } catch (e) {
    // fall back to a memory-based implementation
    // (for a config.name 'Fleet Web', the memory storage will be DECISIV-FLEET-WEB)
    var memoryStorageName = 'DECISIV-' + (0, _lodash.toUpper)((0, _lodash.kebabCase)(_runtimeConfig2.default.name));
    actualStorage = new _memorystorage2.default(memoryStorageName);
  }

  window.memoryDB = actualStorage;
  return actualStorage;
}

// eslint-disable-next-line import/no-unresolved

/***/ }),

/***/ "./setup/reducer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createReducer;

var _reduxImmutable = __webpack_require__("../node_modules/redux-immutable/dist/index.js");

var _reduxFlightControl = __webpack_require__("../node_modules/redux-flight-control/build/index.js");

var _constants = __webpack_require__("./redux/constants.js");

var _reducer = __webpack_require__("./redux/ui/reducer.js");

var _reducer2 = _interopRequireDefault(_reducer);

var _reducer3 = __webpack_require__("./redux/app/reducer.js");

var _reducer4 = _interopRequireDefault(_reducer3);

var _reducer5 = __webpack_require__("./redux/assets/reducer.js");

var _reducer6 = _interopRequireDefault(_reducer5);

var _authentication = __webpack_require__("./features/authentication/index.js");

var _reducer7 = __webpack_require__("./redux/cases/reducer.js");

var _reducer8 = _interopRequireDefault(_reducer7);

var _reducer9 = __webpack_require__("./redux/dataLists/reducer.js");

var _reducer10 = _interopRequireDefault(_reducer9);

var _reducer11 = __webpack_require__("./redux/pageConfigs/reducer.js");

var _reducer12 = _interopRequireDefault(_reducer11);

var _reducer13 = __webpack_require__("./redux/serviceProviders/reducer.js");

var _reducer14 = _interopRequireDefault(_reducer13);

var _reducer15 = __webpack_require__("./redux/serviceRequests/reducer.js");

var _reducer16 = _interopRequireDefault(_reducer15);

var _reducer17 = __webpack_require__("./redux/user/reducer.js");

var _reducer18 = _interopRequireDefault(_reducer17);

var _reducer19 = __webpack_require__("./redux/wizardConfigs/reducer.js");

var _reducer20 = _interopRequireDefault(_reducer19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rootReducer = (0, _reduxImmutable.combineReducers)({
  ui: _reducer2.default,
  app: _reducer4.default,
  assets: _reducer6.default,
  authentication: _authentication.reducer,
  cases: _reducer8.default,
  dataLists: _reducer10.default,
  pageConfigs: _reducer12.default,
  requests: _reduxFlightControl.requestsReducer,
  serviceProviders: _reducer14.default,
  serviceRequests: _reducer16.default,
  user: _reducer18.default,
  wizardConfigs: _reducer20.default
});

function createReducer() {
  return function applicationReducer(state, action) {
    var newState = action.type === _constants.LOGOUT ? undefined : state;

    return rootReducer(newState, action);
  };
}

/***/ }),

/***/ "./setup/routes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactImmutableProptypes = __webpack_require__("../node_modules/react-immutable-proptypes/dist/ImmutablePropTypes.js");

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _reactRouterDom = __webpack_require__("../node_modules/react-router-dom/es/index.js");

var _reactRedux = __webpack_require__("../node_modules/react-redux/es/index.js");

var _authentication = __webpack_require__("./features/authentication/index.js");

var _Layout = __webpack_require__("./components/Layout/index.js");

var _Layout2 = _interopRequireDefault(_Layout);

var _AssetsPage = __webpack_require__("./containers/AssetsPage/index.js");

var _AssetsPage2 = _interopRequireDefault(_AssetsPage);

var _CasesPage = __webpack_require__("./containers/CasesPage/index.js");

var _CasesPage2 = _interopRequireDefault(_CasesPage);

var _SearchResultsPage = __webpack_require__("./containers/SearchResultsPage/index.js");

var _SearchResultsPage2 = _interopRequireDefault(_SearchResultsPage);

var _ServiceRequestCreatePage = __webpack_require__("./containers/ServiceRequestCreatePage/index.js");

var _ServiceRequestCreatePage2 = _interopRequireDefault(_ServiceRequestCreatePage);

var _NotFoundPage = __webpack_require__("./components/NotFoundPage/index.js");

var _NotFoundPage2 = _interopRequireDefault(_NotFoundPage);

var _ServiceRequestsPage = __webpack_require__("./containers/ServiceRequestsPage/index.js");

var _ServiceRequestsPage2 = _interopRequireDefault(_ServiceRequestsPage);

var _DetailsPage = __webpack_require__("./compositions/DetailsPage/index.js");

var _DetailsPage2 = _interopRequireDefault(_DetailsPage);

var _actions = __webpack_require__("./redux/app/actions.js");

var _selectors = __webpack_require__("./redux/app/selectors.js");

var _routes = __webpack_require__("./utils/routes.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import ServiceRequestSubmittedPage from 'containers/ServiceRequestSubmittedPage';

// 404 not found


// Page Containers


// User Authorization containers
function mapStateToProps(state) {
  return {
    favorites: (0, _selectors.favoritesSelector)(state)
  };
}

// Case Containers


function mapDispatchToProps(dispatch) {
  return {
    setLatestFavorite: function setLatestFavorite(favoriteWithLabel) {
      return dispatch((0, _actions.setLatestFavorite)(favoriteWithLabel));
    }
  };
}

function AuthorizedRoutes(_ref) {
  var favorites = _ref.favorites,
      setLatestFavorite = _ref.setLatestFavorite;

  // Preload setFavoriteAndRender with the favorites and setLatestFavorite.
  // This allows us to simply pass the curried function to the render prop.
  var renderFavoriteComponent = (0, _routes.setFavoriteAndRender)(favorites, setLatestFavorite);
  var renderSearchFavoriteComponent = (0, _routes.setSearchFavoriteAndRender)(setLatestFavorite);

  // Preload `renderPageFromConfig` with the DetailsPage.
  // Set the configKey when rendering in the route.
  var renderDetailsPage = (0, _routes.renderPageFromConfig)(_DetailsPage2.default);

  // TODO: This route has been disabled due to a change in scope for MVP release.
  // Re-enable when adding the submitted page.
  //   <AuthorizedRoute
  //   exact
  //   path="/service-requests/:serviceRequestId/submitted"
  //   component={ServiceRequestSubmittedPage}
  // />

  return _react2.default.createElement(
    _Layout2.default,
    null,
    _react2.default.createElement(
      _reactRouterDom.Switch,
      null,
      _react2.default.createElement(_authentication.AuthorizedRoute, {
        exact: true,
        path: '/approvals/filter/:slug',
        render: renderFavoriteComponent(_CasesPage2.default),
        submenu: 'approvals'
      }),
      _react2.default.createElement(_authentication.AuthorizedRoute, { exact: true, path: '/appointments' }),
      _react2.default.createElement(_authentication.AuthorizedRoute, {
        exact: true,
        path: '/assets/filter/:slug',
        render: renderFavoriteComponent(_AssetsPage2.default),
        submenu: 'assets'
      }),
      _react2.default.createElement(_authentication.AuthorizedRoute, {
        exact: true,
        path: '/assets/:assetId',
        render: renderDetailsPage('ASSET_DETAIL')
      }),
      _react2.default.createElement(_authentication.AuthorizedRoute, {
        exact: true,
        path: '/cases/filter/:slug',
        render: renderFavoriteComponent(_CasesPage2.default),
        submenu: 'cases'
      }),
      _react2.default.createElement(_authentication.AuthorizedRoute, {
        exact: true,
        path: '/cases/:caseId',
        render: renderDetailsPage('CASE_DETAIL')
      }),
      _react2.default.createElement(_authentication.AuthorizedRoute, {
        path: '/search',
        component: renderSearchFavoriteComponent(_SearchResultsPage2.default)
      }),
      _react2.default.createElement(_authentication.AuthorizedRoute, {
        exact: true,
        path: '/service-requests/filter/:slug',
        render: renderFavoriteComponent(_ServiceRequestsPage2.default),
        submenu: 'serviceRequests'
      }),
      _react2.default.createElement(_authentication.AuthorizedRoute, {
        exact: true,
        path: '/service-requests/new',
        component: _ServiceRequestCreatePage2.default
      }),
      _react2.default.createElement(_authentication.AuthorizedRoute, {
        exact: true,
        path: '/service-requests/:serviceRequestId',
        render: renderDetailsPage('SERVICE_REQUEST_DETAIL')
      }),
      _react2.default.createElement(_authentication.AuthorizedRoute, { exact: true, path: '/reports' }),
      _react2.default.createElement(_authentication.AuthorizedRoute, { exact: true, path: '/administration' }),
      _react2.default.createElement(_authentication.AuthorizedRoute, { path: '/404-not-found', component: _NotFoundPage2.default }),
      _react2.default.createElement(_reactRouterDom.Redirect, { exact: true, from: '/', to: '/cases/filter/all-repair-cases' }),
      _react2.default.createElement(_reactRouterDom.Redirect, { exact: true, from: '/assets', to: '/assets/filter/all-assets' }),
      _react2.default.createElement(_reactRouterDom.Redirect, { exact: true, from: '/cases', to: '/cases/filter/all-repair-cases' }),
      _react2.default.createElement(_NotFoundPage2.default, null)
    )
  );
}

AuthorizedRoutes.propTypes = {
  // `favorites` is an immutable map of the submenu item definitions
  favorites: _reactImmutableProptypes2.default.map.isRequired,

  // `setLatestFavorite` dispatches an action the updates the app state with the most recent
  // favorite
  setLatestFavorite: _propTypes2.default.func.isRequired
};

var ConnectedAuthorizedRoutes = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AuthorizedRoutes);

function Routes() {
  return _react2.default.createElement(
    _reactRouterDom.Switch,
    null,
    _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/login/sso', component: _authentication.LoginValidation }),
    _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/login', component: _authentication.LoginPage }),
    _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/logout', component: _authentication.LogoutPage }),
    _react2.default.createElement(_reactRouterDom.Route, { path: '/', component: ConnectedAuthorizedRoutes })
  );
}

exports.default = Routes;

/***/ }),

/***/ "./setup/sagas.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = rootSaga;

var _sagas = __webpack_require__("./redux/app/sagas.js");

var _sagas2 = _interopRequireDefault(_sagas);

var _authentication = __webpack_require__("./features/authentication/index.js");

var _sagas3 = __webpack_require__("./redux/ui/sagas.js");

var _sagas4 = _interopRequireDefault(_sagas3);

var _sagas5 = __webpack_require__("./redux/user/sagas.js");

var _sagas6 = _interopRequireDefault(_sagas5);

var _sagas7 = __webpack_require__("./redux/cases/sagas.js");

var _sagas8 = _interopRequireDefault(_sagas7);

var _sagas9 = __webpack_require__("./redux/assets/sagas.js");

var _sagas10 = _interopRequireDefault(_sagas9);

var _sagas11 = __webpack_require__("./redux/serviceProviders/sagas.js");

var _sagas12 = _interopRequireDefault(_sagas11);

var _sagas13 = __webpack_require__("./redux/serviceRequests/sagas.js");

var _sagas14 = _interopRequireDefault(_sagas13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(rootSaga);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function rootSaga() {
  return regeneratorRuntime.wrap(function rootSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return [].concat(_toConsumableArray(_sagas2.default), _toConsumableArray(_authentication.sagas), _toConsumableArray(_sagas4.default), _toConsumableArray(_sagas6.default), _toConsumableArray(_sagas8.default), _toConsumableArray(_sagas10.default), _toConsumableArray(_sagas12.default), _toConsumableArray(_sagas14.default));

        case 2:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

/***/ }),

/***/ "./setup/store.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = configureStore;

var _redux = __webpack_require__("../node_modules/redux/es/index.js");

var _reduxSaga = __webpack_require__("../node_modules/redux-saga/es/index.js");

var _reduxSaga2 = _interopRequireDefault(_reduxSaga);

var _requestStatusMiddleware = __webpack_require__("./redux/middleware/requestStatusMiddleware.js");

var _requestStatusMiddleware2 = _interopRequireDefault(_requestStatusMiddleware);

var _reducer = __webpack_require__("./setup/reducer.js");

var _reducer2 = _interopRequireDefault(_reducer);

var _sagas = __webpack_require__("./setup/sagas.js");

var _sagas2 = _interopRequireDefault(_sagas);

var _subscribers = __webpack_require__("./setup/subscribers.js");

var _subscribers2 = _interopRequireDefault(_subscribers);

var _reduxMiddleware = __webpack_require__("./setup/Bugsnag/reduxMiddleware.js");

var _reduxMiddleware2 = _interopRequireDefault(_reduxMiddleware);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sagaMiddleware = (0, _reduxSaga2.default)();

// eslint-disable-next-line no-unused-vars
function configureStore() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var history = arguments[1];

  // Create the store with middlewares
  // * sagaMiddleware: Makes redux-sagas work
  // * requestStatusMiddleware: Handles dispatching request status actions
  // * TODO: routerMiddleware: Syncs the location/URL path to the state
  // * bugsnagReporter: middleware that reports (to Bugsnag) exceptions during dispatching
  var middlewares = [sagaMiddleware, _requestStatusMiddleware2.default,
  // routerMiddleware(history),
  _reduxMiddleware2.default];

  var enhancers = [_redux.applyMiddleware.apply(undefined, middlewares)];

  // If Redux DevTools Extension is installed use it, otherwise use Redux compose
  /* eslint-disable no-underscore-dangle */
  var composeEnhancers =  false ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : _redux.compose;
  /* eslint-enable */

  var store = (0, _redux.createStore)((0, _reducer2.default)(), // reducer
  initialState, // preloadedState
  composeEnhancers.apply(undefined, enhancers) // enhancers
  );

  (0, _subscribers2.default)(store);

  sagaMiddleware.run(_sagas2.default);

  return store;
}

/***/ }),

/***/ "./setup/subscribers.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = setupSubscriptions;

var _reduxFlightControl = __webpack_require__("../node_modules/redux-flight-control/build/index.js");

var _subscriber = __webpack_require__("./redux/ui/subscriber.js");

var _subscriber2 = _interopRequireDefault(_subscriber);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * List of all the various Redux store subscribers to be registered.
 */
var storeSubscribers = [_reduxFlightControl.addRequestsSubscriber, _subscriber2.default];

/**
 * Register all the Redux store subscribers.
 * @param store The Redux store
 */
function setupSubscriptions(store) {
  storeSubscribers.forEach(function (subscribe) {
    return subscribe(store);
  });
}

/***/ }),

/***/ "./utils/asset.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSerialNumber = getSerialNumber;
exports.getAssetStatusText = getAssetStatusText;
exports.getOdometerText = getOdometerText;

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__("../node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _messages = __webpack_require__("./utils/messages.js");

var _messages2 = _interopRequireDefault(_messages);

var _widget = __webpack_require__("./utils/widget.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ASSET_STATUSES = {
  campaignsStatus: {
    green: _messages2.default.campaignStatusGreen,
    red: _messages2.default.campaignStatusRed
  },
  pmStatus: {
    green: _messages2.default.pmStatusGreen,
    yellow: _messages2.default.pmStatusYellow,
    red: _messages2.default.pmStatusRed
  },
  warrantyStatus: {
    green: _messages2.default.warrantyStatusGreen,
    yellow: _messages2.default.warrantyStatusYellow,
    red: _messages2.default.warrantyStatusRed,
    grey: _messages2.default.warrantyStatusGrey
  }
};

function sanitizeNumber(number) {
  // toLocaleString was breaking on ie10
  try {
    return number && Number(number).toLocaleString();
  } catch (e) {
    return number && Number(number);
  }
}

function getSerialNumber(vinNumber) {
  var placeholder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _messages2.default.noValue;

  if (!vinNumber) {
    return (0, _widget.renderEmptyValue)(placeholder);
  }
  return vinNumber.substr(-8);
}

function getAssetStatusText(type, color) {
  var placeholder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _messages2.default.noValue;

  if (!ASSET_STATUSES[type] || !ASSET_STATUSES[type][color]) {
    return (0, _widget.renderEmptyValue)(placeholder);
  }
  var message = ASSET_STATUSES[type][color];
  return _react2.default.createElement(_linguiReact.Trans, { id: message });
}

function getOdometerText(reading, unit, readAt) {
  var cleanReading = sanitizeNumber(reading);
  var cleanReadAt = readAt && '(' + (0, _moment2.default)(readAt).format('D MMM YYYY') + ')';
  var parts = [].concat(cleanReading, unit, cleanReadAt);
  return (0, _lodash.join)((0, _lodash.compact)(parts), ' ');
}

/***/ }),

/***/ "./utils/browserLocale.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getBrowserLocale;
function getBrowserLocale() {
  var navigatorObject = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : navigator;

  var lang = void 0;

  if (navigatorObject.languages && navigatorObject.languages.length) {
    // latest versions of Chrome and Firefox set this correctly
    lang = navigatorObject.languages[0];
  } else if (navigatorObject.userLanguage) {
    // IE only
    lang = navigatorObject.userLanguage;
  } else {
    // latest versions of Chrome, Firefox, and Safari set this correctly
    lang = navigatorObject.language;
  }

  return lang;
}

/***/ }),

/***/ "./utils/cardType.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = cardType;
function cardType(approvalStatus) {
  switch (approvalStatus && approvalStatus.toLowerCase()) {
    case 'approved':
      return 'statusSuccess';
    case 'declined':
      return 'statusDanger';
    case 'pending':
      return 'statusWarning';
    case 'requested':
      return 'statusWarning';
    default:
      return '';
  }
}

/***/ }),

/***/ "./utils/complaint.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getComplaintText;

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _Link = __webpack_require__("./elements/Link/index.js");

var _Link2 = _interopRequireDefault(_Link);

var _widget = __webpack_require__("./utils/widget.js");

var _messages = __webpack_require__("./utils/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getComplaintText(info) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$titleInLink = _ref.titleInLink,
      titleInLink = _ref$titleInLink === undefined ? true : _ref$titleInLink;

  var complaint = info.complaint,
      description = info.description;

  var complaintCode = complaint && complaint.code;
  var complaintDescription = complaint && complaint.description;
  var title = complaintCode && complaintDescription && (titleInLink ? _react2.default.createElement(
    _Link2.default,
    { to: '#', modifiers: ['hoverCaret'] },
    complaintCode,
    ' - ',
    complaintDescription
  ) : complaintCode + ' - ' + complaintDescription);

  return {
    title: (0, _widget.getOutputText)(title, description ? _messages2.default.undefinedComplaintCode : _messages2.default.undefinedComplaint),
    content: (title || description) && (0, _widget.getOutputText)(description, _messages2.default.undefinedComplaintDescription)
  };
}

/***/ }),

/***/ "./utils/document.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getScrollTop = getScrollTop;
/**
 * getScrollTop returns a scroll-top value across all browsers (ie, in Firefox
 * scrollTop is on documentElement but in Chrome, scrollTop is on the body)
 */
// eslint-disable-next-line import/prefer-default-export
function getScrollTop(_ref) {
  var documentElement = _ref.documentElement,
      body = _ref.body;

  return Math.max(documentElement.scrollTop, body.scrollTop);
}

/***/ }),

/***/ "./utils/favorites.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.shouldClearAndLoadFavorites = shouldClearAndLoadFavorites;
exports.loadFavorite = loadFavorite;
exports.clearAndLoadFavorites = clearAndLoadFavorites;
exports.shouldBuildLoadingGhosts = shouldBuildLoadingGhosts;
/**
 * How many favorites to load per page.
 */
var RESULTS_PER_PAGE = 20;

/**
 * Determine if a favorite is currently present and has changed. This is a helper method that
 * assists with favorite data caching.
 * @param  {Object}  oldFavorite A favorite, converted from a Map into a JS object.
 * @param  {Object}  newFavorite A favorite, converted from a Map into a JS object.
 * @return {Boolean} Indicates whether the latest favorite is present and new.
 */
function isFavoriteChanging(oldFavorite, newFavorite) {
  return newFavorite.title && oldFavorite.title !== newFavorite.title;
}

/**
 * Called from componentWillReceiveProps with the current and next props values to evaluate
 * whether the favorites should be cleared and/or loaded.
 * @param  {Object} currentProps The current props of the calling component, must have
 * latestFavorite
 * @param  {Object} nextProps    The new props of the calling component, must have latestFavorite
 * @return {Boolean} Indicates whether the favorites should be cleared and/or loaded.
 */
function shouldClearAndLoadFavorites(currentProps, nextProps) {
  var newFavorite = nextProps.latestFavorite;
  var oldFavorite = currentProps.latestFavorite;
  return isFavoriteChanging(oldFavorite, newFavorite);
}

/**
 * Load a page of the results for a given favorite from the API.
 * @param favorite A "favorite" containing params for loading the favorite
 * @param loadAction A function that triggers loading the favorite when called
 * @param page Which page of favorite results to retrieve (defaults to the first page).
 */
function loadFavorite(_ref) {
  var favorite = _ref.favorite,
      loadAction = _ref.loadAction,
      _ref$page = _ref.page,
      page = _ref$page === undefined ? 1 : _ref$page;

  loadAction(_extends({}, favorite.params || {}, { page: page, per_page: RESULTS_PER_PAGE }));
}

/**
 * Performs logic to determine is passed in clearAction and/or loadAction should be called, and
 * calls them accordingly.
 * @param {Object} args An object containing the following keys:
 *   clearAction: A function that clears the favorites when called.
 *   loadAction: A function that triggers loading the favorites when called.
 *   priorFavorite: The priorFavorite.
 *   latestFavorite: The latestFavorite.
 *   favorites: The List of favorites, used to determine presence.
 *   forceClear: A boolean that will force the clear action to fire if true.
 */
function clearAndLoadFavorites(_ref2) {
  var clearAction = _ref2.clearAction,
      loadAction = _ref2.loadAction,
      priorFavorite = _ref2.priorFavorite,
      latestFavorite = _ref2.latestFavorite,
      forceClear = _ref2.forceClear;

  if (forceClear || isFavoriteChanging(priorFavorite, latestFavorite)) {
    clearAction();
  }

  // The title must exist, and the favorite's pathname must match the actual url before the API
  // is called. This prevents calling an incorrect API endpoint on componentDidMount.
  if (latestFavorite.title && latestFavorite.path === window.location.pathname) {
    loadFavorite({ favorite: latestFavorite, loadAction: loadAction });
  }
}

/**
 * Determine if the ghost style loading indicators should be added to the favorites display
 * @param  {Object} args An object containing the required arguments for evaluation. Required keys:
 * currentCount {Number} The current number of favorites stored in state.
 * favoritePagination {ImmutableMap} A Map containing data concerning pagination of the favorite.
 * requesting {Boolean} Indicates if a request is currently active.
 * @return {Boolean}
 */
function shouldBuildLoadingGhosts(_ref3) {
  var currentCount = _ref3.currentCount,
      favoritePagination = _ref3.favoritePagination,
      requesting = _ref3.requesting;

  var totalCount = favoritePagination && favoritePagination.get('totalCount');
  if (requesting || currentCount === 0 && !totalCount) {
    return true;
  }
  return false;
}

/***/ }),

/***/ "./utils/fetch.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.put = exports.patch = exports.post = exports.get = exports.makeApiUrl = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _qs = __webpack_require__("../node_modules/qs/lib/index.js");

var _bugsnagJs = __webpack_require__("../node_modules/bugsnag-js/src/bugsnag.js");

var _bugsnagJs2 = _interopRequireDefault(_bugsnagJs);

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _authentication = __webpack_require__("./features/authentication/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var API_VERSION = 1;
var ACCEPT_HEADER = { Accept: 'application/json; version=' + API_VERSION };
var CONTENT_TYPE_HEADER = { 'Content-type': 'application/json' };

function makeApiUrl(endpoint, query) {
  var queryString = (0, _qs.stringify)(query);
  return '' + endpoint + (queryString ? '?' : '') + queryString;
}

/**
 * Check the status of an API response. If `response` is simply an object with an `error`
 * property (of type `Error`), this indicates something failed _before_ the fetch call
 * (for example, an attempt to call an authenticated endpoint without authentication).
 * Otherwise, inspect the response status to determine if the API request returned an error status.
 * @param {{error}|Response} response
 * @return {Response} if no errors are detected
 * @throws Will throw an error on any failure
 */
function checkStatus(response) {
  if (response.error && response.error instanceof Error) {
    // indicates a failure before even hitting the API - rethrow
    throw response.error;
  }

  if (response.status < 400) {
    // no errors, no worries
    return response;
  }

  // the response had a status code, so wrap it up in an Error that Bugsnag will handle...
  var error = new Error(response.statusText);
  error.response = response;
  throw error;
}

function processError(_ref) {
  var endpoint = _ref.endpoint,
      query = _ref.query,
      auth = _ref.auth,
      url = _ref.url,
      method = _ref.method;

  var metadata = {
    endpoint: endpoint,
    query: query,
    auth: auth,
    url: url,
    method: method
  };

  // const name = `API Error: ${method} ${endpoint}`;
  var severity = 'error';

  return function (error) {
    // console.error(`[FETCH] ${name}`, error);
    var message = error.message || error.response.status + ' error calling ' + endpoint;
    _bugsnagJs2.default.notifyException(error, message, metadata, severity);
    return { error: error };
  };
}

/**
 * Given a response, return a function that will accept the body
 * of that response and wrap it up with the headers and response
 * status into a JS object.
 * @param response
 * @returns {function}
 */
var makeResponseBuilder = function makeResponseBuilder(response) {
  return function (body) {
    return {
      response: {
        headers: response.headers,
        body: body,
        status: response.status
      }
    };
  };
};

function processResponse(response) {
  var contentType = response.headers.get('content-type');
  var responseBuilder = makeResponseBuilder(response);
  if (contentType && contentType.includes('json')) {
    return response.json().then(responseBuilder);
  }

  return response.text().then(responseBuilder);
}

function buildFetchArgs(_ref2) {
  var method = _ref2.method,
      _ref2$headers = _ref2.headers,
      headers = _ref2$headers === undefined ? {} : _ref2$headers,
      _ref2$requestBody = _ref2.requestBody,
      requestBody = _ref2$requestBody === undefined ? {} : _ref2$requestBody;

  var fetchOpts = {
    method: method,
    headers: _extends({}, ACCEPT_HEADER, CONTENT_TYPE_HEADER, headers)
  };
  return (0, _lodash.isEmpty)(requestBody) ? fetchOpts : _extends({}, fetchOpts, { body: JSON.stringify(requestBody) });
}

function execute(method, endpoint) {
  var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      query = _ref3.query,
      _ref3$auth = _ref3.auth,
      auth = _ref3$auth === undefined ? true : _ref3$auth,
      _ref3$headers = _ref3.headers,
      headers = _ref3$headers === undefined ? {} : _ref3$headers,
      _ref3$requestBody = _ref3.requestBody,
      requestBody = _ref3$requestBody === undefined ? {} : _ref3$requestBody;

  var url = makeApiUrl(endpoint, query);
  var options = buildFetchArgs({ method: method, headers: headers, requestBody: requestBody });
  var fetchFn = auth ? _authentication.authenticatedFetch : fetch;
  return fetchFn(url, options).then(checkStatus).then(processResponse).catch(processError({ endpoint: endpoint, query: query, auth: auth, url: url, method: method }));
}

// These are the functions that are exported for use:
exports.makeApiUrl = makeApiUrl;
var get = exports.get = (0, _lodash.curry)(execute)('GET');
var post = exports.post = (0, _lodash.curry)(execute)('POST');
var patch = exports.patch = (0, _lodash.curry)(execute)('PATCH');
var put = exports.put = (0, _lodash.curry)(execute)('PUT');
// Any other functions exported above are only exported for test purposes.

/***/ }),

/***/ "./utils/global.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.setGlobal = setGlobal;
exports.getGlobal = getGlobal;
exports.clearGlobal = clearGlobal;

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var root = (typeof self === 'undefined' ? 'undefined' : _typeof(self)) === 'object' && self.self === self && self || (typeof global === 'undefined' ? 'undefined' : _typeof(global)) === 'object' && global.global === global && global || undefined;

function setGlobal(key, value) {
  root[key] = value;
  return value;
}

function getGlobal(key) {
  var notSetValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

  if ((0, _lodash.has)(root, key)) {
    return root[key];
  }

  return notSetValue;
}

function clearGlobal(key) {
  return (0, _lodash.unset)(root, key);
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./utils/hybridLinks.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildAssetDetailLink = buildAssetDetailLink;
exports.buildFleetAdminLink = buildFleetAdminLink;

var _qs = __webpack_require__("../node_modules/qs/lib/index.js");

var _bugsnagJs = __webpack_require__("../node_modules/bugsnag-js/src/bugsnag.js");

var _bugsnagJs2 = _interopRequireDefault(_bugsnagJs);

var _runtimeConfig = __webpack_require__("./runtimeConfig.json");

var _runtimeConfig2 = _interopRequireDefault(_runtimeConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Build a URL to Case Classic for the given path and company ID ("Dealer ID").
 * @param {string} path The Case Classic endpoint to target (without a leading `/`)
 * @param {string} companyId The current dealer ID from the user profile
 * @param {string} tenant The current tenant/OEM
 * @returns {string} The full URL to Case Classic, with params
 */

function buildHybridLink(path, companyId, tenant) {
  if (!tenant) {
    var errorMsg = 'No tenant available for hybrid link';
    console.error(errorMsg);
    _bugsnagJs2.default.notify('hybrid link error', errorMsg, null, 'error');
    return '/';
  }

  var envVar = tenant.toUpperCase() + '_PRICING_URL';
  var baseUrl = Object({"API_BASE_URL":"https://fleet-mobile-api.preview.decisivapps.com/api","BRAND":"default","TENANT":"default","BUGSNAG_API_KEY":"f4c8e3bfb8dfbd3a460e53b1e5e6d244","GOOGLE_MAPS_API_KEY":"AIzaSyCHbt8PyscdyDliLBNekCqKUXWNUeMv2IA","HOTJAR_ENABLED":"true","PENDO_ENABLED":"true","PENDO_API_KEY":"981f8608-6052-42f5-432b-6bd80a96933d","RELEASE_STAGE":"preview","ZENDESK_ENABLED":"true","ZENDESK_DECISIV_KEY":"cbc4e684-7026-4b63-a690-b7470c5d3637","ZENDESK_MICHELIN_KEY":"71b8e91c-cb29-4fd1-a05e-758c67aa58b6","SHOW_GIT_REVISION":"true","APP_VERSION":"1.3.4","GIT_COMMIT":"e2696e6","VLV_PRICING_URL":"https://volvopg.preview.decisivapps.com","DCV_PRICING_URL":"https://dsmppg.preview.decisivapps.com","MICH_PRICING_URL":"https://michelinpg.preview.decisivapps.com","PORTUNUS_URL":"https://portunus.preview.decisivapps.com"})[envVar];
  if (!baseUrl) {
    var _errorMsg = '\n      Cannot find pricing URL for tenant \'' + tenant + '\' - missing environment variable \'' + envVar + '\'\n    ';
    console.error(_errorMsg);
    _bugsnagJs2.default.notify('hybrid link error', _errorMsg, { tenant: tenant }, 'error');
    return '/';
  }

  var params = {
    dealer_id: companyId,
    return_path: window.location.pathname,
    return_app: _runtimeConfig2.default.hybrid_link.return_app
  };

  var queryString = (0, _qs.stringify)(params);
  return baseUrl + '/' + path + '?' + queryString;
}

/**
 * Build a URL to the asset detail page on Case Classic.
 * @param {string} assetId the id of the asset being linked to
 * @param {object} options an object containing required values for building the URL
 * @property {string} options.companyId the user's companyId
 * @property {string} options.tenant the tenant connected to this user
 * @returns {string} The full URL to the asset detail page, with params
 */


// eslint-disable-next-line import/no-unresolved
function buildAssetDetailLink(assetId, _ref) {
  var companyId = _ref.companyId,
      tenant = _ref.tenant;

  return buildHybridLink('fleet/vehicles/' + assetId, companyId, tenant);
}

/**
 * Build a URL to the Fleet Admin page on Case Classic.
 * @param {object} options an object containing required values for building the URL
 * @param {string} options.companyId The current dealer ID from the user profile
 * @property {string} options.tenant the tenant connected to this user
 * @returns {string} The full URL to the fleet admin page, with params
 */
// Eventually there will be other hybrid links, but until then...
function buildFleetAdminLink(_ref2) {
  var companyId = _ref2.companyId,
      tenant = _ref2.tenant;

  return buildHybridLink('fleet/admin', companyId, tenant);
}

/***/ }),

/***/ "./utils/immutableToJS.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__("../node_modules/immutable/dist/immutable.js");

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * This HOC is used to convert the immutable objects held in the redux store into plain JS for
 * our React Components. For more information about this, please see this page in the redux docs:
 * http://redux.js.org/docs/recipes/UsingImmutableJS.html
 *
 * This HOC was directly extracted from these docs.
 */

var immutableToJS = function immutableToJS(WrappedComponent) {
  return function (wrappedComponentProps) {
    var KEY = 0;
    var VALUE = 1;

    var propsJS = Object.entries(wrappedComponentProps).reduce(function (newProps, wrappedComponentProp) {
      // eslint-disable-next-line no-param-reassign
      newProps[wrappedComponentProp[KEY]] = _immutable.Iterable.isIterable(wrappedComponentProp[VALUE]) ? wrappedComponentProp[VALUE].toJS() : wrappedComponentProp[VALUE];
      return newProps;
    }, {});

    return _react2.default.createElement(WrappedComponent, propsJS);
  };
};

exports.default = immutableToJS;

/***/ }),

/***/ "./utils/mapPageConfigToRegistry.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _ComponentRegistry = __webpack_require__("./setup/ComponentRegistry/index.js");

var _ComponentRegistry2 = _interopRequireDefault(_ComponentRegistry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * `mapPageConfigToRegistry` is a memoized closure that efficiently handles converting the
 * composition names stored in the runtime config to a map of registered composition objects.
 * An input config will probably look like:
 * {
 *   data: 'wrapper_hoc_data',
 *   fixed: ['feature1']
 *   quick_action_items: {
 *     left: ['button1'],
 *     right: ['button2', 'button3'],
 *   },
 *   top: null,
 *   // etc...
 * }
 *
 * You should expect to get back from this config:
 * {
 *   data: {name: wrapper_hoc_data, hoc: REACT COMPONENT},
 *   fixed: [{name: 'feature1', composition: REACT COMPONENT}],
 *   quick_action_items: {
 *     left: [{name: 'button1', composition: REACT COMPONENT}],
 *     right: [
 *       {name: 'button2', composition: REACT COMPONENT},
 *       {name: 'button3', composition: REACT COMPONENT},
 *     ],
 *   },
 *   top: [],
 *   // etc...
 * }
 *
 * When calling this function, you must also provide the configKey that was used.
 * This enables the caching.
 */
var mapPageConfigToRegistry = function () {
  // Setup the cache. This will hold previously run configuration maps.
  var cache = {};

  var process = function process(config, key) {
    var registry = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _ComponentRegistry2.default;

    if (key && cache[key]) {
      // This key has already been processed. Return previous results.
      return cache[key];
    }

    // The config currently being processed is `null` if no definition was provided.
    if ((0, _lodash.isNull)(config)) {
      return [];
    }

    // The config currently being processed is a string in cases where a
    // data wrapping HOC is defined.
    if ((0, _lodash.isString)(config)) {
      return { name: config, hoc: registry[config] };
    }

    // If the config currently being processed is an array, return a collection
    // with each object containing the following values:
    // the constant it was found under (key: name)
    // the composition from the registry (key: composition)
    if ((0, _lodash.isArray)(config)) {
      return (0, _lodash.compact)(config.map(function (name) {
        var composition = registry[name];
        return composition && { name: name, composition: composition };
      }));
    }

    // The config currently being processed is an object, handle processing it recursively.
    // Note that no `key` is being used, so this call will not check or save to the cache.
    var obj = (0, _lodash.mapValues)(config, function (value) {
      return process(value, undefined, registry);
    });

    // Only the initial call contains a `key`. This saves the result of the initial call
    // to the cache under the key.
    if (key) {
      // If no `data` key was provided in the config, fallback to retrieving the data hoc under
      // `${PAGE_NAME}_DATA`.
      if (!obj.data && registry[key + '_DATA']) {
        obj.data = { name: key + '_DATA', hoc: registry[key + '_DATA'] };
      }

      cache[key] = obj;
    }

    return obj;
  };

  return process;
}();

exports.default = mapPageConfigToRegistry;

/***/ }),

/***/ "./utils/mapWizardConfigToRegistry.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _WizardRegistry = __webpack_require__("./setup/WizardRegistry/index.js");

var _WizardRegistry2 = _interopRequireDefault(_WizardRegistry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * `mapWizardConfigToRegistry` is a memoized closure that efficiently handles converting the
 * component step names stored in the runtime config to a map of registered steps.
 * An input config will probably look like:
 * {
 *   start: 'STEP_NAME_1'
 *   steps: {
 *     STEP_NAME_1: ['STEP_NAME_2'],
 *     STEP_NAME_2: ['REVIEW'],
 *   },
 * }
 *
 * You should expect to get back from this config:
 * {
 *   SpecificWizardController: REACT COMPONENT,
 *   start: 'STEP_NAME_1',
 *   steps: {
 *     STEP_NAME_1: {
 *       component: REACT COMPONENT,
 *       name: 'STEP_NAME_1'
 *       nextSteps: ['STEP_NAME_2'],
 *     },
 *     STEP_NAME_2: {
 *      component: REACT COMPONENT,
 *      name: 'STEP_NAME_2',
 *      nextSteps: ['REVIEW'],
 *     },
 *     REVIEW: {
 *       component: REACT COMPONENT,
 *       name: 'REVIEW',
 *     },
 *   },
 * }
 *
 * When calling this function, you must provide the config and the configKey that was used.
 */
var mapWizardConfigToRegistry = function () {
  // Setup the cache. This will hold previously run configuration maps.
  var cache = {};

  // These keys trigger specific requirements in the processing of a wizard
  // config. They are required in all wizard configs.
  var reviewStepKey = 'REVIEW';
  var stepsKey = 'steps';

  var process = function process(config, configKey) {
    var registry = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _WizardRegistry2.default;
    var stepKey = arguments[3];

    if (configKey && cache[configKey]) {
      // This wizard config has already been processed. Return previous results.
      return cache[configKey];
    }

    // Strings and null values in a wizard config should simply be returned.
    if ((0, _lodash.isNull)(config) || (0, _lodash.isString)(config)) {
      return config;
    }

    // If the config currently being processed is an array, return an object with
    // the component, component name, and nextSteps for this config.
    if ((0, _lodash.isArray)(config)) {
      if (stepKey) {
        return {
          component: registry[stepKey],
          name: stepKey,
          nextSteps: config
        };
      }
      return config;
    }

    // The config currently being processed is an object, handle processing it recursively.
    // Note that no `configKey` is being used, so this call will not check or save to the cache.
    var obj = (0, _lodash.mapValues)(config, function (value, key) {
      return process(value, undefined, registry, key);
    });

    // Every wizard will require the REVIEW step, so it should be added by default.
    if (stepKey === stepsKey && !obj[reviewStepKey]) {
      obj[reviewStepKey] = {
        component: registry[reviewStepKey],
        name: reviewStepKey
      };
    }

    // Only the initial call contains a `configKey`. This block handles top level work, like
    // saving the result of the initial call to the cache under the `configKey`.
    if (configKey) {
      // Every wizard will require a specific wizard controller to handle things like submission.
      obj.SpecificWizardController = registry[configKey];

      cache[configKey] = obj;
    }

    return obj;
  };

  return process;
}();

exports.default = mapWizardConfigToRegistry;

/***/ }),

/***/ "./utils/mapping/WithDirections.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WithDirections = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactGoogleMaps = __webpack_require__("../node_modules/react-google-maps/lib/index.js");

var _recompose = __webpack_require__("../node_modules/recompose/es/Recompose.js");

var _propTypes = __webpack_require__("./utils/prop-types.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withGoogleMapJS = __webpack_require__("./utils/mapping/withGoogleMapJS.js");

var _withGoogleMapJS2 = _interopRequireDefault(_withGoogleMapJS);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * `withDirections` is a render-prop component that can be applied to
 * a mapping component to provide directions between two markers. On
 * mount, the HOC starts a DirectionsService route process, and upon
 * successful completion does two things:
 * 1. provides a `directions` prop value to the wrapped component, set
 *    to the result from the DirectionsService
 * 2. if an `onDirectionsUpdate` function prop is provided, calls this
 *    function with those results as well
 */
var WithDirections = exports.WithDirections = function (_React$Component) {
  _inherits(WithDirections, _React$Component);

  function WithDirections() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, WithDirections);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WithDirections.__proto__ || Object.getPrototypeOf(WithDirections)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      directions: null
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(WithDirections, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var _props = this.props,
          _props$markers = _slicedToArray(_props.markers, 2),
          markerOne = _props$markers[0],
          markerTwo = _props$markers[1],
          onDirectionsUpdate = _props.onDirectionsUpdate,
          googleMaps = _props.googleMaps;

      if (googleMaps && markerOne && markerTwo) {
        var DirectionsService = new googleMaps.DirectionsService();

        var start = markerOne.position;
        var end = markerTwo.position;

        var origin = new googleMaps.LatLng(start.lat, start.lng);
        var destination = new googleMaps.LatLng(end.lat, end.lng);
        // kick off the routing (which is asynchronous):
        DirectionsService.route({
          origin: origin,
          destination: destination,
          travelMode: googleMaps.TravelMode.DRIVING
        }, function (result, status) {
          if (status === googleMaps.DirectionsStatus.OK) {
            // set the directions in state so they're passed down to the child component
            _this2.setState({ directions: result });
            // call the callback so directions are passed up to any interested parent components
            onDirectionsUpdate(result);
          } else {
            console.error('error fetching directions ' + result);
          }
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.render(this.state);
    }
  }]);

  return WithDirections;
}(_react2.default.Component);

WithDirections.propTypes = {
  markers: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    position: _propTypes2.default.latLng.isRequired
  })).isRequired,
  onDirectionsUpdate: _propTypes2.default.func,
  render: _propTypes2.default.func.isRequired,
  googleMaps: _propTypes2.default.googleMapsApi
};
WithDirections.defaultProps = {
  onDirectionsUpdate: _lodash.noop,
  googleMaps: null
};
exports.default = (0, _recompose.compose)((0, _recompose.withProps)({
  // props for withGoogleMap:
  containerElement: _react2.default.createElement('div', { style: { height: '100%' } }),
  mapElement: _react2.default.createElement('div', { style: { height: '100%' } })
}), _withGoogleMapJS2.default, _reactGoogleMaps.withGoogleMap)(WithDirections);

/***/ }),

/***/ "./utils/mapping/WithReverseGeocoding.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WithReverseGeocoding = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _recompose = __webpack_require__("../node_modules/recompose/es/Recompose.js");

var _withGeocoder = __webpack_require__("./utils/mapping/withGeocoder.js");

var _withGeocoder2 = _interopRequireDefault(_withGeocoder);

var _messages = __webpack_require__("./utils/mapping/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * `WithReverseGeocoding` is a render-prop component that has a location prop
 * containing lat/lon values, and will provide reverse-geocoding of the
 * address of this lat/lon. On each prop update, if the lat/lon has changed
 * (or no geocoding has yet happened), the HOC starts a geocode process,
 * and upon successful completion does two things:
 * 1. provides an `address` prop value to the wrapped component, set
 *    to the first formatted address provided by the geocoder
 * 2. if an `onAddressUpdate` function prop is provided, calls this
 *    function with that formatted address as well
 */
var WithReverseGeocoding = exports.WithReverseGeocoding = function (_React$Component) {
  _inherits(WithReverseGeocoding, _React$Component);

  function WithReverseGeocoding() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, WithReverseGeocoding);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WithReverseGeocoding.__proto__ || Object.getPrototypeOf(WithReverseGeocoding)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      address: undefined
    }, _this.setAddress = function (address) {
      _this.setState({ address: address });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(WithReverseGeocoding, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var _props$location = this.props.location;
      _props$location = _props$location === undefined ? {} : _props$location;
      var oldLat = _props$location.lat,
          oldLon = _props$location.lon;
      var _nextProps$location = nextProps.location;
      _nextProps$location = _nextProps$location === undefined ? {} : _nextProps$location;
      var lat = _nextProps$location.lat,
          lon = _nextProps$location.lon,
          reverseGeocode = nextProps.reverseGeocode,
          onAddressUpdate = nextProps.onAddressUpdate,
          i18n = nextProps.i18n;

      // unless we're currently geocoding, then if we have a location and it is different
      // from the previous location (or the current address has not been set yet), then
      // let's geocode now...

      var currentAddress = this.state && this.state.address;
      if (!this.geocoding && lat && lon && (!currentAddress || oldLat !== lat || oldLon !== lon)) {
        this.geocoding = true;
        this.setAddress(i18n._(_messages2.default.loading));

        var location = { lat: parseFloat(lat), lng: parseFloat(lon) };

        // kick off the (asynchronous) geocode process:
        reverseGeocode(location).then(function (_ref2) {
          var address = _ref2.address;

          _this2.setAddress(address);
          // call the callback so the address is passed up to any interested parent components
          onAddressUpdate(address);
          _this2.geocoding = false;
        }).catch(function (status) {
          console.error('Geocoder failed for [' + lat + ', ' + lon + ']: ', status);
          _this2.geocoding = false;
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.render(this.state);
    }
  }]);

  return WithReverseGeocoding;
}(_react2.default.Component);

WithReverseGeocoding.propTypes = {
  location: _propTypes2.default.shape({
    lat: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    lon: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
  }),
  onAddressUpdate: _propTypes2.default.func,
  render: _propTypes2.default.func.isRequired,
  i18n: _propTypes2.default.shape({
    _: _propTypes2.default.func.isRequired
  }).isRequired,
  reverseGeocode: _propTypes2.default.func.isRequired
};
WithReverseGeocoding.defaultProps = {
  location: {},
  onAddressUpdate: _lodash.noop
};
exports.default = (0, _recompose.compose)(_withGeocoder2.default, (0, _linguiReact.withI18n)())(WithReverseGeocoding);

/***/ }),

/***/ "./utils/mapping/geocoders/googleMapsGeocoder.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.geocode = geocode;
exports.reverseGeocode = reverseGeocode;
function geocode(googleMaps, address) {
  var geocoder = new googleMaps.Geocoder();

  return new Promise(function (resolve, reject) {
    geocoder.geocode({
      address: address
    }, function (result, status) {
      if (status === googleMaps.GeocoderStatus.OK) {
        var rawlocation = result[0].geometry.location;
        var location = { lat: rawlocation.lat(), lon: rawlocation.lng() };
        resolve({ location: location, count: result.length });
      } else {
        reject(status);
      }
    });
  });
}

function reverseGeocode(googleMaps, location) {
  var geocoder = new googleMaps.Geocoder();

  return new Promise(function (resolve, reject) {
    geocoder.geocode({
      location: location
    }, function (result, status) {
      if (status === googleMaps.GeocoderStatus.OK) {
        var address = result[0].formatted_address;
        resolve({ address: address, count: result.length });
      } else {
        reject(status);
      }
    });
  });
}

/***/ }),

/***/ "./utils/mapping/googleMapsApi.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _qs = __webpack_require__("../node_modules/qs/lib/index.js");

var URL = 'https://maps.googleapis.com/maps/api/js';

/**
 * Build the URL to retrieve the Google Maps API JavaScript, based
 * on the specified options.
 * @param {String} apiKey
 * @param {Array<String>} libraries
 * @param {String} clientID
 * @param {String} version
 * @param {String} callback
 * @param {String} channel
 * @param {String} language
 * @param {String} region
 * @returns {string}
 */
function googleMapsApi() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$apiKey = _ref.apiKey,
      apiKey = _ref$apiKey === undefined ? "AIzaSyCHbt8PyscdyDliLBNekCqKUXWNUeMv2IA" : _ref$apiKey,
      _ref$libraries = _ref.libraries,
      libraries = _ref$libraries === undefined ? ['geometry', 'drawing', 'places'] : _ref$libraries,
      clientID = _ref.clientID,
      _ref$version = _ref.version,
      version = _ref$version === undefined ? '3.exp' : _ref$version,
      callback = _ref.callback,
      channel = _ref.channel,
      language = _ref.language,
      region = _ref.region;

  if (!(apiKey || clientID)) {
    throw new Error('googleMapsApi() requires a either an apiKey or a clientID');
  }

  // client ID and API key are mutually-exclusive - see
  // https://developers.google.com/maps/documentation/javascript/get-api-key#clientID-features
  if (apiKey && clientID) {
    throw new Error('googleMapsApi() cannot accept BOTH an apiKey and a clientID');
  }

  var params = {
    key: apiKey,
    callback: callback,
    libraries: libraries.join(','),
    client: clientID,
    v: version,
    channel: channel,
    language: language,
    region: region
  };

  var paramStr = (0, _qs.stringify)(params, { skipNulls: true });

  return URL + '?' + paramStr;
}

exports.default = googleMapsApi;

/***/ }),

/***/ "./utils/mapping/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var formattedMessages = {
  loading: (0, _linguiReact.i18nMark)('Loading...')
};

exports.default = formattedMessages;

/***/ }),

/***/ "./utils/mapping/propTypes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// --------------- PropType extensions specific to the Google Maps API ---------------

// A Google Map latitude & longitude pair (with `lat` and `lng` numeric values).
var latLng = _propTypes2.default.shape({
  lat: _propTypes2.default.number.isRequired,
  lng: _propTypes2.default.number.isRequired
});

// `PropTypes.googleMapsApi` defines the shape of the Google Maps API, or at least
// the parts of the API that we use within this application.
var googleMapsApi = _propTypes2.default.shape({
  DirectionsService: _propTypes2.default.func.isRequired,
  DirectionsStatus: _propTypes2.default.shape({
    OK: _propTypes2.default.string.isRequired
  }).isRequired,
  Geocoder: _propTypes2.default.func.isRequired,
  GeocoderStatus: _propTypes2.default.shape({
    OK: _propTypes2.default.string.isRequired
  }).isRequired,
  LatLng: _propTypes2.default.func.isRequired,
  TravelMode: _propTypes2.default.shape({
    DRIVING: _propTypes2.default.string.isRequired
  }).isRequired
});

var textAndValue = _propTypes2.default.shape({
  text: _propTypes2.default.string.isRequired,
  value: _propTypes2.default.number.isRequired
});

var googleDirections = _propTypes2.default.shape({
  routes: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    legs: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      distance: textAndValue,
      duration: textAndValue
    }))
  })),
  status: _propTypes2.default.string.isRequired
});

exports.default = {
  googleMapsApi: googleMapsApi,
  googleDirections: googleDirections,
  latLng: latLng
};

/***/ }),

/***/ "./utils/mapping/withGeocoder.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _recompose = __webpack_require__("../node_modules/recompose/es/Recompose.js");

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _propTypes = __webpack_require__("./utils/prop-types.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _googleMapsGeocoder = __webpack_require__("./utils/mapping/geocoders/googleMapsGeocoder.js");

var _withGoogleMapJS = __webpack_require__("./utils/mapping/withGoogleMapJS.js");

var _withGoogleMapJS2 = _interopRequireDefault(_withGoogleMapJS);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
function _geocode(_ref, address) {
  var googleMaps = _ref.googleMaps;

  if (!googleMaps) return _lodash.noop;
  return (0, _googleMapsGeocoder.geocode)(googleMaps, address);
}

/* istanbul ignore next */
function _reverseGeocode(_ref2, location) {
  var googleMaps = _ref2.googleMaps;

  if (!googleMaps) return _lodash.noop;
  return (0, _googleMapsGeocoder.reverseGeocode)(googleMaps, location);
}

/* istanbul ignore next */
var withGeocoder = (0, _recompose.compose)(_withGoogleMapJS2.default, (0, _recompose.withProps)(function (ownerProps) {
  return {
    geocode: function geocode(address) {
      return _geocode(ownerProps, address);
    },
    reverseGeocode: function reverseGeocode(location) {
      return _reverseGeocode(ownerProps, location);
    }
  };
}));

withGeocoder.propTypes = {
  googleMaps: _propTypes2.default.googleMapsApi
};

withGeocoder.defaultProps = {
  googleMaps: null
};

exports.default = withGeocoder;

/***/ }),

/***/ "./utils/mapping/withGoogleMapJS.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactGoogleMaps = __webpack_require__("../node_modules/react-google-maps/lib/index.js");

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _recompose = __webpack_require__("../node_modules/recompose/es/Recompose.js");

var _googleMapsApi = __webpack_require__("./utils/mapping/googleMapsApi.js");

var _googleMapsApi2 = _interopRequireDefault(_googleMapsApi);

var _messages = __webpack_require__("./utils/mapping/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ------------------------ withGoogleMapJS ------------------------

/**
 * `withGoogleMapJS` is a simple extension to react-google-maps' `withScriptjs` which
 * ensures that a wrapped component has access to the Google Maps API. The wrapped
 * component will not be rendered until the API's JavaScript has been loaded and the
 * global `google.maps` API is available.
 */
/* istanbul ignore next */
var withGoogleMapJS = (0, _recompose.compose)((0, _recompose.withProps)(function () {
  return {
    // props for withScriptJs:
    googleMapURL: (0, _googleMapsApi2.default)(),
    loadingElement: _react2.default.createElement(
      'div',
      { style: { height: '100%' } },
      _react2.default.createElement(_linguiReact.Trans, { id: _messages2.default.loading })
    )
  };
}), _reactGoogleMaps.withScriptjs,
/* istanbul ignore next */
(0, _recompose.mapProps)(function (ownerProps) {
  return _extends({
    // provide the Google Maps API as a prop to avoid using the global and
    // to allow test injection:
    googleMaps: window && window.google && window.google.maps,
    // provide a useful default for `location`:
    location: { lat: null, lon: null }
  }, ownerProps);
}));

exports.default = withGoogleMapJS;

/***/ }),

/***/ "./utils/messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var formattedMessages = {
  campaignStatusGreen: (0, _linguiReact.i18nMark)('current'),
  campaignStatusRed: (0, _linguiReact.i18nMark)('campaign due'),
  noValue: (0, _linguiReact.i18nMark)('Not Provided'),
  pmStatusGreen: (0, _linguiReact.i18nMark)('current'),
  pmStatusYellow: (0, _linguiReact.i18nMark)('due'),
  pmStatusRed: (0, _linguiReact.i18nMark)('overdue'),
  undefinedComplaint: (0, _linguiReact.i18nMark)('No complaints yet'),
  undefinedComplaintCode: (0, _linguiReact.i18nMark)('Code Not Provided'),
  undefinedComplaintDescription: (0, _linguiReact.i18nMark)('Description Not Provided'),
  warrantyStatusGreen: (0, _linguiReact.i18nMark)('fully covered'),
  warrantyStatusYellow: (0, _linguiReact.i18nMark)('partially covered'),
  warrantyStatusRed: (0, _linguiReact.i18nMark)('expired'),
  warrantyStatusGrey: (0, _linguiReact.i18nMark)('no coverage'),
  searchResults: (0, _linguiReact.i18nMark)('Search Results')
};

exports.default = formattedMessages;

/***/ }),

/***/ "./utils/oldIEVersion.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = oldIEVersion;
// returns true if the browser is IE 11 or older (pre-Edge)
// otherwise, it returns false

function oldIEVersion() {
  var ua = navigator.userAgent;
  var ie11 = ua.indexOf('Trident/7.0') !== -1;
  var ie10 = ua.indexOf('Trident/6.0') !== -1;
  var reallyOldIE = ua.indexOf('Trident/5.0') !== -1;
  return ie11 || ie10 || reallyOldIE;
}

/***/ }),

/***/ "./utils/postalAddressFormatter.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Takes an object containing address data fields and returns
 * an array of the formatted lines for displaying the address.
 *
 * Valid properties of the addressData:
 *  * street
 *  * street2
 *  * city
 *  * region (i.e. the state or province)
 *  * postalCode (i.e. ZIP code)
 *
 *  TODO: extend this to accept a country or country code
 *  TODO: support non-US address style formatting
 */

function postalAddressFormatter(addressData) {
  var output = [];
  if (addressData.street) {
    output.push(addressData.street);
  }
  if (addressData.street2) {
    output.push(addressData.street2);
  }
  if (addressData.city || addressData.region || addressData.postalCode) {
    var cityLine = [];
    if (addressData.city) {
      cityLine.push(addressData.city);
    }
    if (addressData.region) {
      cityLine.push(addressData.region);
    }
    if (cityLine.length > 0) {
      cityLine = [cityLine.join(', ')];
    }
    if (addressData.postalCode) {
      cityLine.push(addressData.postalCode);
    }
    output.push(cityLine.join(' '));
  }
  return output;
}

exports.default = postalAddressFormatter;

/***/ }),

/***/ "./utils/prop-types.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _propTypes3 = __webpack_require__("./setup/ComponentRegistry/propTypes.js");

var _propTypes4 = _interopRequireDefault(_propTypes3);

var _propTypes5 = __webpack_require__("./utils/mapping/propTypes.js");

var _propTypes6 = _interopRequireDefault(_propTypes5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _extends({}, _propTypes2.default, _propTypes6.default, _propTypes4.default);

/***/ }),

/***/ "./utils/redux-api-actions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createApiAction = createApiAction;

var _invariant = __webpack_require__("../node_modules/invariant/browser.js");

var _invariant2 = _interopRequireDefault(_invariant);

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Create an action creator that creates actions with types and apiCall keys. Heavily inspired
 * by the createAction function found in redux-actions
 * @param  {Array} types             An array of types that will be called based on api
 *                                   request. Must be in the following order:
 *                                   REQUEST, SUCCESS, FAILURE
 * @param  {Function} apiCall        A function that returns a promise.
 * @param  {Function} payloadCreator A function that defines how the payload is created.
 * @param  {Function} metaCreator    A function that defines how any meta data is created.
 * @return {Function} A function that creates actions.
 */
// eslint-disable-next-line import/prefer-default-export
function createApiAction(types, apiCall) {
  var payloadCreator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _lodash.identity;
  var metaCreator = arguments[3];

  (0, _invariant2.default)((0, _lodash.isFunction)(apiCall), 'Expected apiCall to be a function');

  (0, _invariant2.default)((0, _lodash.isFunction)(payloadCreator) || (0, _lodash.isNull)(payloadCreator), 'Expected payloadCreator to be a function, undefined or null');

  var finalPayloadCreator = (0, _lodash.isNull)(payloadCreator) || payloadCreator === _lodash.identity ? _lodash.identity : function (head) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return head instanceof Error ? head : payloadCreator.apply(undefined, [head].concat(args));
  };

  var hasMeta = (0, _lodash.isFunction)(metaCreator);

  var actionCreator = function actionCreator() {
    var payload = finalPayloadCreator.apply(undefined, arguments);
    var action = { types: types, apiCall: apiCall };

    if (payload instanceof Error) {
      action.error = true;
    }

    if (payload !== undefined) {
      action.payload = payload;
    }

    if (hasMeta) {
      action.meta = metaCreator.apply(undefined, arguments);
    }

    return action;
  };

  return actionCreator;
}

/***/ }),

/***/ "./utils/routes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setSearchFavoriteAndRender = exports.setFavoriteAndRender = exports.renderPageFromConfig = exports.SetsLatestFavorite = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.getFavorite = getFavorite;

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactImmutableProptypes = __webpack_require__("../node_modules/react-immutable-proptypes/dist/ImmutablePropTypes.js");

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _immutable = __webpack_require__("../node_modules/immutable/dist/immutable.js");

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _messages = __webpack_require__("./utils/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * SetsLatestFavorite is an HOC React component whose sole purpose is to dispatch a redux
 * action on certain lifecycle events.
 * @type {Component}
 */
var SetsLatestFavorite = exports.SetsLatestFavorite = function (_React$Component) {
  _inherits(SetsLatestFavorite, _React$Component);

  function SetsLatestFavorite() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SetsLatestFavorite);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SetsLatestFavorite.__proto__ || Object.getPrototypeOf(SetsLatestFavorite)).call.apply(_ref, [this].concat(args))), _this), _this.setNewFavorite = function () {
      var _this$props = _this.props,
          favorite = _this$props.favorite,
          setLatestFavorite = _this$props.setLatestFavorite;

      setLatestFavorite(favorite);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SetsLatestFavorite, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setNewFavorite();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.setNewFavorite();
    }

    // setLatestFavorite is a redux action. Calling it outside of a react component throws errors
    // in the console.

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          Component = _props.Component,
          componentProps = _props.componentProps;

      return _react2.default.createElement(Component, componentProps);
    }
  }]);

  return SetsLatestFavorite;
}(_react2.default.Component);

/**
 * Looks up the filter currently being viewed based on a url match with the slugs in the favorites.
 * @param  {Map} favorites   The Dashboard API response after processing and being stored in state.
 * @param  {string} submenu  The name of the submenu
 * @param  {string} slug     The slug as extracted from the current URL
 * @return {Map}             The matching favorite, or an empty Map.
 */


SetsLatestFavorite.propTypes = {
  Component: _propTypes2.default.func.isRequired,
  componentProps: _propTypes2.default.shape().isRequired,
  favorite: _reactImmutableProptypes2.default.map.isRequired,
  setLatestFavorite: _propTypes2.default.func.isRequired
};
function getFavorite(favorites, submenu, slug) {
  var subFavorites = favorites.get(submenu) || (0, _immutable.List)();
  var index = subFavorites.findIndex(function (f) {
    return f.get('slug') === slug;
  });

  if (index < 0) {
    return (0, _immutable.Map)();
  }

  return subFavorites.get(index);
}

var renderPageFromConfig = exports.renderPageFromConfig = (0, _lodash.curry)(function (PageComponent, configKey, otherProps) {
  return _react2.default.createElement(PageComponent, _extends({
    configKey: configKey
  }, otherProps));
});

/**
 * Curried function that locates active favorite and returns an HOC for managing it in state.
 */
var setFavoriteAndRender = exports.setFavoriteAndRender = (0, _lodash.curry)(function (favorites, setLatestFavorite, Component, componentProps) {
  var submenu = componentProps.submenu,
      slug = componentProps.match.params.slug;

  var favorite = getFavorite(favorites, submenu, slug);

  var isValidSlug = true;

  if (favorites.size !== 0 && favorite.size === 0) {
    isValidSlug = false;
  }

  return _react2.default.createElement(SetsLatestFavorite, {
    favorite: favorite,
    setLatestFavorite: setLatestFavorite,
    Component: Component,
    componentProps: _extends({}, componentProps, { isValidSlug: isValidSlug })
  });
});

var setSearchFavoriteAndRender = exports.setSearchFavoriteAndRender = (0, _lodash.curry)(function (setLatestFavorite, Component, componentProps) {
  var _componentProps$locat = componentProps.location,
      pathname = _componentProps$locat.pathname,
      search = _componentProps$locat.search;


  var favorite = (0, _immutable.Map)({
    path: '' + pathname + search,
    title: 'search-results',
    message: _messages2.default.searchResults
  });

  return _react2.default.createElement(SetsLatestFavorite, {
    favorite: favorite,
    setLatestFavorite: setLatestFavorite,
    Component: Component,
    componentProps: componentProps
  });
});

/***/ }),

/***/ "./utils/styles.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withTestTheme = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _decisivUiUtils = __webpack_require__("../node_modules/decisiv-ui-utils/build/index.js");

/**
 * Applies the theme to styled component as a defaultProp in test env only.
 * @param  {Component} StyledComponent A styled component
 * @return {Component}                 The styled component with the expected defaultProps
 */
/* eslint-disable import/prefer-default-export */
var withTestTheme = exports.withTestTheme = function withTestTheme(StyledComponent) {
  if (false) {
    // eslint-disable-next-line no-param-reassign
    StyledComponent.defaultProps = _extends({}, StyledComponent.defaultProps, {
      theme: _decisivUiUtils.theme
    });
  }

  return StyledComponent;
};

/***/ }),

/***/ "./utils/timeUtils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userTimeZone = userTimeZone;
exports.formatDate = formatDate;
exports.getCurrentTime = getCurrentTime;
exports.convertRailsTz = convertRailsTz;

var _momentTimezone = __webpack_require__("../node_modules/moment-timezone/index.js");

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_TIME_FORMAT = 'D MMM YYYY, h:mm A z';
var DEFAULT_TIME_ZONE = 'America/New_York';

/**
 * Attempt to guess the user's timezone.  Falls back to US Eastern Time when
 * a timezone cannot be detected by the browser.
 */
function userTimeZone() {
  return _momentTimezone2.default.tz.guess() || DEFAULT_TIME_ZONE;
}

/**
 * Parse a given date string and then reformat based on the given format string, in
 * the given time zone (or, by default, in the user's time zone).
 */
function formatDate(date) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$format = _ref.format,
      format = _ref$format === undefined ? DEFAULT_TIME_FORMAT : _ref$format,
      _ref$tz = _ref.tz,
      tz = _ref$tz === undefined ? userTimeZone() : _ref$tz;

  return _momentTimezone2.default.tz(date, tz).format(format);
}

/**
 * Wrapper around `moment().tz(timeZone)` which allows for spying/mocking during
 * tests.  Should be used everywhere in the code, instead of `moment().tz`.
 */
function getCurrentTime() {
  var timeZone = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_TIME_ZONE;

  return (0, _momentTimezone2.default)().tz(timeZone);
}

/**
 * Mapping of Rails time-zones to time-zones that JS/moment.js can understand. The
 * keys are Rails TimeZone names; the values are from the tz database.
 *
 * This is copied from Rails ActiveSupport::TimeZone::MAPPING
 * https://github.com/rails/rails/blob/master/activesupport/lib/active_support/values/time_zone.rb
 */
var RAILS_TZ_MAPPINGS = {
  'International Date Line West': 'Pacific/Midway',
  'Midway Island': 'Pacific/Midway',
  'American Samoa': 'Pacific/Pago_Pago',
  Hawaii: 'Pacific/Honolulu',
  Alaska: 'America/Juneau',
  'Pacific Time (US & Canada)': 'America/Los_Angeles',
  Tijuana: 'America/Tijuana',
  'Mountain Time (US & Canada)': 'America/Denver',
  Arizona: 'America/Phoenix',
  Chihuahua: 'America/Chihuahua',
  Mazatlan: 'America/Mazatlan',
  'Central Time (US & Canada)': 'America/Chicago',
  Saskatchewan: 'America/Regina',
  Guadalajara: 'America/Mexico_City',
  'Mexico City': 'America/Mexico_City',
  Monterrey: 'America/Monterrey',
  'Central America': 'America/Guatemala',
  'Eastern Time (US & Canada)': 'America/New_York',
  'Indiana (East)': 'America/Indiana/Indianapolis',
  Bogota: 'America/Bogota',
  Lima: 'America/Lima',
  Quito: 'America/Lima',
  'Atlantic Time (Canada)': 'America/Halifax',
  Caracas: 'America/Caracas',
  'La Paz': 'America/La_Paz',
  Santiago: 'America/Santiago',
  Newfoundland: 'America/St_Johns',
  Brasilia: 'America/Sao_Paulo',
  'Buenos Aires': 'America/Argentina/Buenos_Aires',
  Montevideo: 'America/Montevideo',
  Georgetown: 'America/Guyana',
  'Puerto Rico': 'America/Puerto_Rico',
  Greenland: 'America/Godthab',
  'Mid-Atlantic': 'Atlantic/South_Georgia',
  Azores: 'Atlantic/Azores',
  'Cape Verde Is.': 'Atlantic/Cape_Verde',
  Dublin: 'Europe/Dublin',
  Edinburgh: 'Europe/London',
  Lisbon: 'Europe/Lisbon',
  London: 'Europe/London',
  Casablanca: 'Africa/Casablanca',
  Monrovia: 'Africa/Monrovia',
  UTC: 'Etc/UTC',
  Belgrade: 'Europe/Belgrade',
  Bratislava: 'Europe/Bratislava',
  Budapest: 'Europe/Budapest',
  Ljubljana: 'Europe/Ljubljana',
  Prague: 'Europe/Prague',
  Sarajevo: 'Europe/Sarajevo',
  Skopje: 'Europe/Skopje',
  Warsaw: 'Europe/Warsaw',
  Zagreb: 'Europe/Zagreb',
  Brussels: 'Europe/Brussels',
  Copenhagen: 'Europe/Copenhagen',
  Madrid: 'Europe/Madrid',
  Paris: 'Europe/Paris',
  Amsterdam: 'Europe/Amsterdam',
  Berlin: 'Europe/Berlin',
  Bern: 'Europe/Zurich',
  Zurich: 'Europe/Zurich',
  Rome: 'Europe/Rome',
  Stockholm: 'Europe/Stockholm',
  Vienna: 'Europe/Vienna',
  'West Central Africa': 'Africa/Algiers',
  Bucharest: 'Europe/Bucharest',
  Cairo: 'Africa/Cairo',
  Helsinki: 'Europe/Helsinki',
  Kyiv: 'Europe/Kiev',
  Riga: 'Europe/Riga',
  Sofia: 'Europe/Sofia',
  Tallinn: 'Europe/Tallinn',
  Vilnius: 'Europe/Vilnius',
  Athens: 'Europe/Athens',
  Istanbul: 'Europe/Istanbul',
  Minsk: 'Europe/Minsk',
  Jerusalem: 'Asia/Jerusalem',
  Harare: 'Africa/Harare',
  Pretoria: 'Africa/Johannesburg',
  Kaliningrad: 'Europe/Kaliningrad',
  Moscow: 'Europe/Moscow',
  'St. Petersburg': 'Europe/Moscow',
  Volgograd: 'Europe/Volgograd',
  Samara: 'Europe/Samara',
  Kuwait: 'Asia/Kuwait',
  Riyadh: 'Asia/Riyadh',
  Nairobi: 'Africa/Nairobi',
  Baghdad: 'Asia/Baghdad',
  Tehran: 'Asia/Tehran',
  'Abu Dhabi': 'Asia/Muscat',
  Muscat: 'Asia/Muscat',
  Baku: 'Asia/Baku',
  Tbilisi: 'Asia/Tbilisi',
  Yerevan: 'Asia/Yerevan',
  Kabul: 'Asia/Kabul',
  Ekaterinburg: 'Asia/Yekaterinburg',
  Islamabad: 'Asia/Karachi',
  Karachi: 'Asia/Karachi',
  Tashkent: 'Asia/Tashkent',
  Chennai: 'Asia/Kolkata',
  Kolkata: 'Asia/Kolkata',
  Mumbai: 'Asia/Kolkata',
  'New Delhi': 'Asia/Kolkata',
  Kathmandu: 'Asia/Kathmandu',
  Astana: 'Asia/Dhaka',
  Dhaka: 'Asia/Dhaka',
  'Sri Jayawardenepura': 'Asia/Colombo',
  Almaty: 'Asia/Almaty',
  Novosibirsk: 'Asia/Novosibirsk',
  Rangoon: 'Asia/Rangoon',
  Bangkok: 'Asia/Bangkok',
  Hanoi: 'Asia/Bangkok',
  Jakarta: 'Asia/Jakarta',
  Krasnoyarsk: 'Asia/Krasnoyarsk',
  Beijing: 'Asia/Shanghai',
  Chongqing: 'Asia/Chongqing',
  'Hong Kong': 'Asia/Hong_Kong',
  Urumqi: 'Asia/Urumqi',
  'Kuala Lumpur': 'Asia/Kuala_Lumpur',
  Singapore: 'Asia/Singapore',
  Taipei: 'Asia/Taipei',
  Perth: 'Australia/Perth',
  Irkutsk: 'Asia/Irkutsk',
  Ulaanbaatar: 'Asia/Ulaanbaatar',
  Seoul: 'Asia/Seoul',
  Osaka: 'Asia/Tokyo',
  Sapporo: 'Asia/Tokyo',
  Tokyo: 'Asia/Tokyo',
  Yakutsk: 'Asia/Yakutsk',
  Darwin: 'Australia/Darwin',
  Adelaide: 'Australia/Adelaide',
  Canberra: 'Australia/Melbourne',
  Melbourne: 'Australia/Melbourne',
  Sydney: 'Australia/Sydney',
  Brisbane: 'Australia/Brisbane',
  Hobart: 'Australia/Hobart',
  Vladivostok: 'Asia/Vladivostok',
  Guam: 'Pacific/Guam',
  'Port Moresby': 'Pacific/Port_Moresby',
  Magadan: 'Asia/Magadan',
  Srednekolymsk: 'Asia/Srednekolymsk',
  'Solomon Is.': 'Pacific/Guadalcanal',
  'New Caledonia': 'Pacific/Noumea',
  Fiji: 'Pacific/Fiji',
  Kamchatka: 'Asia/Kamchatka',
  'Marshall Is.': 'Pacific/Majuro',
  Auckland: 'Pacific/Auckland',
  Wellington: 'Pacific/Auckland',
  "Nuku'alofa": 'Pacific/Tongatapu',
  'Tokelau Is.': 'Pacific/Fakaofo',
  'Chatham Is.': 'Pacific/Chatham',
  Samoa: 'Pacific/Apia'
};

/**
 * Given a Rails-style time zone (e.g. 'Pacific Time (US & Canada)'), get the equivalent
 * time-zone name that moment.tz can understand (e.g. 'America/Los_Angeles').
 */
function convertRailsTz(railsTz) {
  return RAILS_TZ_MAPPINGS[railsTz] || railsTz;
}

/***/ }),

/***/ "./utils/url.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseQueryParams = parseQueryParams;
exports.getBrandFromUrl = getBrandFromUrl;
exports.getTenantFromUrl = getTenantFromUrl;
exports.makeUrl = makeUrl;
exports.locationOrigin = locationOrigin;

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _parseDomain = __webpack_require__("../node_modules/parse-domain/lib/parseDomain.js");

var _parseDomain2 = _interopRequireDefault(_parseDomain);

var _qs = __webpack_require__("../node_modules/qs/lib/index.js");

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returns an object after parsing a query string of a url
 * @param {string} queryString
 * @returns {object} parsed object
 * @example parseQueryParams('?id=1234&param=hello') will return { id: '1234', param: 'hello' }
 */
function parseQueryParams(queryString) {
  var paramString = queryString.split('?').pop();
  return _qs2.default.parse(paramString);
}

function isUrlMatching(url, pattern) {
  var _ref = (0, _parseDomain2.default)(url) || {},
      subdomain = _ref.subdomain;

  if (subdomain) {
    if (subdomain.match(pattern)) {
      return true;
    }
  }

  return false;
}

/**
 * Determine if any brand is known to be associated with a given URL.  If so, return
 * the name of that brand; if not, return 'decisiv'.  If the given environment (which
 * defaults to `process.env` provides a `BRAND`, use that instead of even looking at
 * the URL.
 *
 * @param {string} url The URL to examine for brand-ness
 * @param {object} env The environment, which may provide a `BRAND` override.
 * @returns {string}
 */
function getBrandFromUrl() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.href;
  var env = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object({"API_BASE_URL":"https://fleet-mobile-api.preview.decisivapps.com/api","BRAND":"default","TENANT":"default","BUGSNAG_API_KEY":"f4c8e3bfb8dfbd3a460e53b1e5e6d244","GOOGLE_MAPS_API_KEY":"AIzaSyCHbt8PyscdyDliLBNekCqKUXWNUeMv2IA","HOTJAR_ENABLED":"true","PENDO_ENABLED":"true","PENDO_API_KEY":"981f8608-6052-42f5-432b-6bd80a96933d","RELEASE_STAGE":"preview","ZENDESK_ENABLED":"true","ZENDESK_DECISIV_KEY":"cbc4e684-7026-4b63-a690-b7470c5d3637","ZENDESK_MICHELIN_KEY":"71b8e91c-cb29-4fd1-a05e-758c67aa58b6","SHOW_GIT_REVISION":"true","APP_VERSION":"1.3.4","GIT_COMMIT":"e2696e6","VLV_PRICING_URL":"https://volvopg.preview.decisivapps.com","DCV_PRICING_URL":"https://dsmppg.preview.decisivapps.com","MICH_PRICING_URL":"https://michelinpg.preview.decisivapps.com","PORTUNUS_URL":"https://portunus.preview.decisivapps.com"});

  // To enable a better developer experience, prefer the BRAND set at boot up.
  if (env.BRAND && env.BRAND !== 'default') {
    return env.BRAND;
  }

  switch (true) {
    case isUrlMatching(url, /michelin/):
      return 'michelin';
    default:
      return 'decisiv';
  }
}

/**
 * Determine if any tenant is known to be associated with a given URL.  If so, return
 * the name of that tenant; if not, return 'vlv'.  If the given environment (which
 * defaults to `process.env` provides a `TENANT`, use that instead of even looking at
 * the URL.
 *
 * TODO: change the default from `vlv` to `dcv` once we have a Volvo-brand URL that maps to `vlv`
 *
 * @param {string} url The URL to examine for a tenant association
 * @param {object} env The environment, which may provide a `TENANT` override.
 * @returns {string}
 */
function getTenantFromUrl() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.href;
  var env = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object({"API_BASE_URL":"https://fleet-mobile-api.preview.decisivapps.com/api","BRAND":"default","TENANT":"default","BUGSNAG_API_KEY":"f4c8e3bfb8dfbd3a460e53b1e5e6d244","GOOGLE_MAPS_API_KEY":"AIzaSyCHbt8PyscdyDliLBNekCqKUXWNUeMv2IA","HOTJAR_ENABLED":"true","PENDO_ENABLED":"true","PENDO_API_KEY":"981f8608-6052-42f5-432b-6bd80a96933d","RELEASE_STAGE":"preview","ZENDESK_ENABLED":"true","ZENDESK_DECISIV_KEY":"cbc4e684-7026-4b63-a690-b7470c5d3637","ZENDESK_MICHELIN_KEY":"71b8e91c-cb29-4fd1-a05e-758c67aa58b6","SHOW_GIT_REVISION":"true","APP_VERSION":"1.3.4","GIT_COMMIT":"e2696e6","VLV_PRICING_URL":"https://volvopg.preview.decisivapps.com","DCV_PRICING_URL":"https://dsmppg.preview.decisivapps.com","MICH_PRICING_URL":"https://michelinpg.preview.decisivapps.com","PORTUNUS_URL":"https://portunus.preview.decisivapps.com"});

  // To enable a better developer experience, prefer the TENANT set at boot up.
  if (env.TENANT && env.TENANT !== 'default') {
    return env.TENANT;
  }

  switch (true) {
    case isUrlMatching(url, /michelin/):
      return 'mich';
    default:
      return 'vlv'; // TODO: change this to 'dcv' once we have a Volvo-brand URL
  }
}

/**
 * Given a base URL, a path, and optionally some params, assemble it all into a
 * final properly-encoded URL string.
 * @param {string} base - The URL base, e.g. 'https://www.google.com'
 * @param {string} path - A path at the destination server, e.g. '/search'
 * @param {object} params - Optional params, e.g. { q: 'lmgtfy' }
 * @returns {string} The final URL, e.g. 'https://www.google.com/search?q=lmgtfy'
 */
function makeUrl(base, path) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var endpoint = base + '/' + (0, _lodash.trimStart)(path, '/');
  var queryString = _qs2.default.stringify(params);
  return '' + endpoint + (queryString && '?' + queryString);
}

/**
 * Some older versions of various browsers do not support window.location.origin.
 * This is a re-implementation that should work cross-browser to return the same
 * result.
 * @returns {string}
 */
/* istanbul ignore next */
function locationOrigin() {
  if (window.location.origin) {
    return window.location.origin;
  }
  var port = window.location.port && ':' + window.location.port;
  return window.location.protocol + '//' + window.location.hostname + port;
}

/***/ }),

/***/ "./utils/widget.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderEmptyValue = renderEmptyValue;
exports.getOutputText = getOutputText;
exports.getOutputLink = getOutputLink;

var _react = __webpack_require__("../node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _linguiReact = __webpack_require__("../node_modules/lingui-react/index.es.js");

var _baseComponents = __webpack_require__("../node_modules/base-components/build/index.js");

var _EmptyValue = __webpack_require__("./elements/EmptyValue/index.js");

var _EmptyValue2 = _interopRequireDefault(_EmptyValue);

var _messages = __webpack_require__("./utils/messages.js");

var _messages2 = _interopRequireDefault(_messages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * This is a utility function for returning the value when it is valid
 * and EmptyValue placeholder when its value is invalid (null or empty).
 *
 * params:
 *   value (string): Value to be assessed
 *   placeholder (object): `messageDescriptorPropTypes` shaped object
 *     to be used in the Trans element as the placeholder
 *     in place of the null value
 *
 * return value:
 *   - If the value is valid, it simply returns the value
 *   - If it is null or empty, it returns a Trans that has
 *     the placeholder as its content. EmptyValue is simply a styled-component
 *     wrapper for styling the placeholder as an italic, light, gray text.
 *
 * Example:
 *   // messages.js
 *   const messages = {
 *     unitNumber: i18nMark('Unit'),
 *   };
 *
 *   // widget.js
 *   getOutputText('12345', messages.unitNumber); // Displays '12345'
 *   getOutputText('', messages.unitNumber); // Displays 'Unit' in italic gray font
 */

function renderEmptyValue(placeholder) {
  return _react2.default.createElement(
    _EmptyValue2.default,
    null,
    _react2.default.createElement(_linguiReact.Trans, { id: placeholder })
  );
}

function getOutputText(value) {
  var placeholder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _messages2.default.noValue;

  if (!value) {
    return renderEmptyValue(placeholder);
  }
  return value;
}

function getOutputLink(value, placeholder) {
  var link = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  if (!value) {
    return renderEmptyValue(placeholder);
  }
  return _react2.default.createElement(
    _baseComponents.A,
    { href: link },
    value
  );
}

/***/ }),

/***/ "./utils/xml.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.xmlToJs = xmlToJs;

var _xml2js = __webpack_require__("../node_modules/xml2js/lib/xml2js.js");

// Processors to modify the tag and attribute names of the XML
var nameProcessors = [_xml2js.processors.stripPrefix, _xml2js.processors.firstCharLowerCase];

// Processors to modify the body and attribute values of the XML
var valueProcessors = [_xml2js.processors.parseNumbers, _xml2js.processors.parseBooleans];

// Options for xml2js parseString
var parserOpts = {
  explicitArray: false,
  tagNameProcessors: nameProcessors,
  attrNameProcessors: nameProcessors,
  valueProcessors: valueProcessors,
  attrValueProcessors: valueProcessors
};

/**
 * Parse a string of XML into a Javascript object.
 * @param {string} xmlText The XML string
 * @returns {Promise<any>} Resolves with the resulting JS object
 */
// eslint-disable-next-line import/prefer-default-export
function xmlToJs(xmlText) {
  return new Promise(function (resolve, reject) {
    return (0, _xml2js.parseString)(xmlText, parserOpts, function (err, result) {
      return err ? reject(err) : resolve(result);
    });
  });
}

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./index.js");


/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

},[0]);


// WEBPACK FOOTER //
// app-9952a46c03cced524e7f.js